import _classCallCheck2 from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _objectSpread from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray3 from "C:\\projects\\mvision-html-admin-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import Axios from 'axios';
import React__default, { createElement, createContext, useState, useContext, useEffect, useCallback, useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
import ReactDOM from 'react-dom';
import { act as act$1 } from 'react-dom/test-utils';
import { Provider, useDispatch, connect, useSelector, batch } from 'react-redux';
import { action } from 'typesafe-actions';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { createStyles, makeStyles, StylesProvider, useTheme, withStyles as withStyles$1 } from '@material-ui/styles';
import { withStyles, makeStyles as makeStyles$1, createStyles as createStyles$2, fade, MuiThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import { createMuiTheme, createStyles as createStyles$1, IconButton, Tooltip, Menu, MenuItem, ListItemIcon, createGenerateClassName, Dialog, DialogTitle, Button, Table, TableHead, TableCell, TableBody, TableRow, Link, Icon, DialogContent as DialogContent$1, DialogContentText, List, ListItem, ListItemText, DialogActions as DialogActions$1, FormControl, InputLabel, Select, InputBase, TextField, Typography as Typography$1, Card, makeStyles as makeStyles$2, Divider, FilledInput, InputAdornment, FormControlLabel, Checkbox, FormLabel, FormHelperText, CircularProgress, Switch, CardHeader, CardContent, ListItemSecondaryAction } from '@material-ui/core';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { useTranslation } from 'react-i18next';
import IconButton$1 from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Help from '@material-ui/icons/Help';
import WarningRounded from '@material-ui/icons/WarningRounded';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import ReactMarkdown from 'react-markdown';
import Autorenew from '@material-ui/icons/Autorenew';
import CheckCircle from '@material-ui/icons/CheckCircle';
import produce from 'immer';
import AddIcon from '@material-ui/icons/Add';
import Create from '@material-ui/icons/Create';
import Delete from '@material-ui/icons/Delete';
import CloudUpload from '@material-ui/icons/CloudUpload';
import server from 'react-dom/server';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import FilterList from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import Check from '@material-ui/icons/CheckCircleRounded';
import Button$1 from '@material-ui/core/Button';
import CircularProgress$1 from '@material-ui/core/CircularProgress';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { withSnackbar } from 'notistack';
import Measure from 'react-measure';
import { FixedSizeList } from 'react-window';
import CheckboxComponent from '@material-ui/core/Checkbox';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';
import IndeterminateCheckBoxOutlined from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { useField, FieldArray, useFormikContext, Formik, Form } from 'formik';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Backspace from '@material-ui/icons/Backspace';
import Lock from '@material-ui/icons/Lock';
import Redo from '@material-ui/icons/Redo';
import TreeView from '@material-ui/lab/TreeView';
import AddCircle from '@material-ui/icons/AddCircle';
import Copy from '@material-ui/icons/FileCopy';
import { TreeItem, Alert } from '@material-ui/lab';
import HelpRounded from '@material-ui/icons/HelpRounded';
import Edit from '@material-ui/icons/Edit';
import { diff } from 'deep-diff';
import i18next from 'i18next';
import deepEqual from 'deep-equal';
import 'date-fns';
import Done from '@material-ui/icons/Done';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import Report from '@material-ui/icons/Report';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { createSelector } from 'reselect';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign2 = function __assign() {
  _assign2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign2.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
}
var ConcurrencyError = /** @class */function () {
  function ConcurrencyError(message, status) {
    this.message = message;
    this.status = status;
  }
  return ConcurrencyError;
}();
var BadRequestError = /** @class */function () {
  function BadRequestError(message, status) {
    this.message = message;
    this.status = status;
  }
  return BadRequestError;
}();
var InternalServerError = /** @class */function () {
  function InternalServerError(message, status) {
    this.message = message;
    this.status = status;
  }
  return InternalServerError;
}();
var HttpService = /** @class */function () {
  function HttpService() {
    Axios.interceptors.request.use(function (config) {
      config.headers['Content-Type'] = 'application/json';
      if (CURRENT_WORKGROUP_HEADER_NAME !== 'host') {
        config.headers[CURRENT_WORKGROUP_HEADER_NAME] = getCookieValue(currentWorkgroupKey);
      }
      return config;
    });
    Axios.interceptors.response.use(function (response) {
      return response;
    }, function (_a) {
      var response = _a.response;
      if (!response) {
        return Promise.reject({
          message: "Oops, something went wrong",
          status: 0
        });
      }
      if (response.status === 409) {
        return Promise.reject(new ConcurrencyError(response.data, response.status));
      }
      if (response.status === 400) {
        return Promise.reject(new BadRequestError(response.data, response.status));
      }
      if (response.status === 500) {
        return Promise.reject(new InternalServerError(response.data, response.status));
      }
    });
  }
  HttpService.prototype.get = function (url, headers) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.get("" + process.env.REACT_APP_ROOT_DOMAIN + url, {
              headers: headers
            })];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response.data];
        }
      });
    });
  };
  HttpService.prototype.getWithVersion = function (url, headers) {
    return __awaiter(this, void 0, void 0, function () {
      var response, version;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.get("" + process.env.REACT_APP_ROOT_DOMAIN + url, {
              headers: headers
            })];
          case 1:
            response = _a.sent();
            version = response.headers.etag;
            return [2 /*return*/, {
              data: response.data,
              version: version
            }];
        }
      });
    });
  };
  HttpService.prototype.post = function (url, body, headers) {
    if (body === void 0) {
      body = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.post("" + process.env.REACT_APP_ROOT_DOMAIN + url, body, {
              headers: headers
            })];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response.data];
        }
      });
    });
  };
  HttpService.prototype.postWithReturnedVersion = function (url, body, headers) {
    if (body === void 0) {
      body = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var response, responseEtag, matches, version;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.post("" + process.env.REACT_APP_ROOT_DOMAIN + url, body, {
              headers: headers
            })];
          case 1:
            response = _a.sent();
            responseEtag = response.headers.etag || '""';
            matches = responseEtag.match(/^"(.*)"$/);
            version = matches ? matches[1] : responseEtag;
            return [2 /*return*/, {
              data: response.data,
              version: typeof response.headers.etag == 'string' ? version : response.headers.etag
            }];
        }
      });
    });
  };
  HttpService.prototype.put = function (url, body, headers) {
    if (body === void 0) {
      body = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.put("" + process.env.REACT_APP_ROOT_DOMAIN + url, body, {
              headers: headers
            })];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response.data];
        }
      });
    });
  };
  HttpService.prototype.putWithVersion = function (url, body, version, headers) {
    if (body === void 0) {
      body = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var computedHeaders, response, responseEtag, matches;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            computedHeaders = _assign2(_assign2({}, headers), {
              ETag: version
            });
            // HS-3048
            // when adding the ETag header as the model version, test if the version is enclosed in double quotes and enclose it if not
            if (typeof version == 'string') {
              computedHeaders = _assign2(_assign2({}, headers), {
                ETag: /^".*"$/.test(version) ? version : "\"" + version + "\""
              });
            }
            return [4 /*yield*/, Axios.put("" + process.env.REACT_APP_ROOT_DOMAIN + url, body, {
              headers: computedHeaders
            })];
          case 1:
            response = _a.sent();
            responseEtag = response.headers.etag || '""';
            matches = responseEtag.match(/^"(.*)"$/);
            version = matches ? matches[1] : responseEtag;
            return [2 /*return*/, {
              data: response.data,
              version: typeof response.headers.etag == 'string' ? version : response.headers.etag
            }];
        }
      });
    });
  };
  HttpService.prototype.delete = function (url, body, headers) {
    if (body === void 0) {
      body = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, Axios.delete("" + process.env.REACT_APP_ROOT_DOMAIN + url, {
              headers: {},
              data: _assign2({}, body)
            })];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response.data];
        }
      });
    });
  };
  return HttpService;
}();
var HttpService$1 = new HttpService();
var getCookieValue = function getCookieValue(key) {
  var b = document.cookie.match("(^|;)*" + key + "*=*([^;]+)");
  if (b === null) {
    return '';
  }
  var value = b.pop();
  return value ? value : '';
};
var currentWorkgroupKey = 'currentWorkgroup';
var CURRENT_WORKGROUP_HEADER_NAME = process.env.REACT_APP_HEADER_01;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

/* MIT license */
/* eslint-disable no-mixed-operators */

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var _i3 = 0, _Object$keys2 = Object.keys(colorName); _i3 < _Object$keys2.length; _i3++) {
  var key = _Object$keys2[_i3];
  reverseKeywords[colorName[key]] = key;
}
var convert = {
  rgb: {
    channels: 3,
    labels: 'rgb'
  },
  hsl: {
    channels: 3,
    labels: 'hsl'
  },
  hsv: {
    channels: 3,
    labels: 'hsv'
  },
  hwb: {
    channels: 3,
    labels: 'hwb'
  },
  cmyk: {
    channels: 4,
    labels: 'cmyk'
  },
  xyz: {
    channels: 3,
    labels: 'xyz'
  },
  lab: {
    channels: 3,
    labels: 'lab'
  },
  lch: {
    channels: 3,
    labels: 'lch'
  },
  hex: {
    channels: 1,
    labels: ['hex']
  },
  keyword: {
    channels: 1,
    labels: ['keyword']
  },
  ansi16: {
    channels: 1,
    labels: ['ansi16']
  },
  ansi256: {
    channels: 1,
    labels: ['ansi256']
  },
  hcg: {
    channels: 3,
    labels: ['h', 'c', 'g']
  },
  apple: {
    channels: 3,
    labels: ['r16', 'g16', 'b16']
  },
  gray: {
    channels: 1,
    labels: ['gray']
  }
};
var conversions = convert;

// Hide .channels and .labels properties
for (var _i4 = 0, _Object$keys3 = Object.keys(convert); _i4 < _Object$keys3.length; _i4++) {
  var model = _Object$keys3[_i4];
  if (!('channels' in convert[model])) {
    throw new Error('missing channels property: ' + model);
  }
  if (!('labels' in convert[model])) {
    throw new Error('missing channel labels property: ' + model);
  }
  if (convert[model].labels.length !== convert[model].channels) {
    throw new Error('channel and label counts mismatch: ' + model);
  }
  var _convert$model = convert[model],
    channels = _convert$model.channels,
    labels = _convert$model.labels;
  delete convert[model].channels;
  delete convert[model].labels;
  Object.defineProperty(convert[model], 'channels', {
    value: channels
  });
  Object.defineProperty(convert[model], 'labels', {
    value: labels
  });
}
convert.rgb.hsl = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var min = Math.min(r, g, b);
  var max = Math.max(r, g, b);
  var delta = max - min;
  var h;
  var s;
  if (max === min) {
    h = 0;
  } else if (r === max) {
    h = (g - b) / delta;
  } else if (g === max) {
    h = 2 + (b - r) / delta;
  } else if (b === max) {
    h = 4 + (r - g) / delta;
  }
  h = Math.min(h * 60, 360);
  if (h < 0) {
    h += 360;
  }
  var l = (min + max) / 2;
  if (max === min) {
    s = 0;
  } else if (l <= 0.5) {
    s = delta / (max + min);
  } else {
    s = delta / (2 - max - min);
  }
  return [h, s * 100, l * 100];
};
convert.rgb.hsv = function (rgb) {
  var rdif;
  var gdif;
  var bdif;
  var h;
  var s;
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var v = Math.max(r, g, b);
  var diff = v - Math.min(r, g, b);
  var diffc = function diffc(c) {
    return (v - c) / 6 / diff + 1 / 2;
  };
  if (diff === 0) {
    h = 0;
    s = 0;
  } else {
    s = diff / v;
    rdif = diffc(r);
    gdif = diffc(g);
    bdif = diffc(b);
    if (r === v) {
      h = bdif - gdif;
    } else if (g === v) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v) {
      h = 2 / 3 + gdif - rdif;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return [h * 360, s * 100, v * 100];
};
convert.rgb.hwb = function (rgb) {
  var r = rgb[0];
  var g = rgb[1];
  var b = rgb[2];
  var h = convert.rgb.hsl(rgb)[0];
  var w = 1 / 255 * Math.min(r, Math.min(g, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
};
convert.rgb.cmyk = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var k = Math.min(1 - r, 1 - g, 1 - b);
  var c = (1 - r - k) / (1 - k) || 0;
  var m = (1 - g - k) / (1 - k) || 0;
  var y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
};
function comparativeDistance(x, y) {
  /*
  	See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
  */
  return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert.rgb.keyword = function (rgb) {
  var reversed = reverseKeywords[rgb];
  if (reversed) {
    return reversed;
  }
  var currentClosestDistance = Infinity;
  var currentClosestKeyword;
  for (var _i5 = 0, _Object$keys4 = Object.keys(colorName); _i5 < _Object$keys4.length; _i5++) {
    var keyword = _Object$keys4[_i5];
    var value = colorName[keyword];

    // Compute comparative distance
    var distance = comparativeDistance(rgb, value);

    // Check if its less, if so set as closest
    if (distance < currentClosestDistance) {
      currentClosestDistance = distance;
      currentClosestKeyword = keyword;
    }
  }
  return currentClosestKeyword;
};
convert.keyword.rgb = function (keyword) {
  return colorName[keyword];
};
convert.rgb.xyz = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;

  // Assume sRGB
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
  var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x * 100, y * 100, z * 100];
};
convert.rgb.lab = function (rgb) {
  var xyz = convert.rgb.xyz(rgb);
  var x = xyz[0];
  var y = xyz[1];
  var z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  var l = 116 * y - 16;
  var a = 500 * (x - y);
  var b = 200 * (y - z);
  return [l, a, b];
};
convert.hsl.rgb = function (hsl) {
  var h = hsl[0] / 360;
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var t2;
  var t3;
  var val;
  if (s === 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) {
    t2 = l * (1 + s);
  } else {
    t2 = l + s - l * s;
  }
  var t1 = 2 * l - t2;
  var rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    if (t3 < 0) {
      t3++;
    }
    if (t3 > 1) {
      t3--;
    }
    if (6 * t3 < 1) {
      val = t1 + (t2 - t1) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t2;
    } else if (3 * t3 < 2) {
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    } else {
      val = t1;
    }
    rgb[i] = val * 255;
  }
  return rgb;
};
convert.hsl.hsv = function (hsl) {
  var h = hsl[0];
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var smin = s;
  var lmin = Math.max(l, 0.01);
  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  var v = (l + s) / 2;
  var sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
  return [h, sv * 100, v * 100];
};
convert.hsv.rgb = function (hsv) {
  var h = hsv[0] / 60;
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var hi = Math.floor(h) % 6;
  var f = h - Math.floor(h);
  var p = 255 * v * (1 - s);
  var q = 255 * v * (1 - s * f);
  var t = 255 * v * (1 - s * (1 - f));
  v *= 255;
  switch (hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
};
convert.hsv.hsl = function (hsv) {
  var h = hsv[0];
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var vmin = Math.max(v, 0.01);
  var sl;
  var l;
  l = (2 - s) * v;
  var lmin = (2 - s) * vmin;
  sl = s * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
  var h = hwb[0] / 360;
  var wh = hwb[1] / 100;
  var bl = hwb[2] / 100;
  var ratio = wh + bl;
  var f;

  // Wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  var i = Math.floor(6 * h);
  var v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) !== 0) {
    f = 1 - f;
  }
  var n = wh + f * (v - wh); // Linear interpolation

  var r;
  var g;
  var b;
  /* eslint-disable max-statements-per-line,no-multi-spaces */
  switch (i) {
    default:
    case 6:
    case 0:
      r = v;
      g = n;
      b = wh;
      break;
    case 1:
      r = n;
      g = v;
      b = wh;
      break;
    case 2:
      r = wh;
      g = v;
      b = n;
      break;
    case 3:
      r = wh;
      g = n;
      b = v;
      break;
    case 4:
      r = n;
      g = wh;
      b = v;
      break;
    case 5:
      r = v;
      g = wh;
      b = n;
      break;
  }
  /* eslint-enable max-statements-per-line,no-multi-spaces */

  return [r * 255, g * 255, b * 255];
};
convert.cmyk.rgb = function (cmyk) {
  var c = cmyk[0] / 100;
  var m = cmyk[1] / 100;
  var y = cmyk[2] / 100;
  var k = cmyk[3] / 100;
  var r = 1 - Math.min(1, c * (1 - k) + k);
  var g = 1 - Math.min(1, m * (1 - k) + k);
  var b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
};
convert.xyz.rgb = function (xyz) {
  var x = xyz[0] / 100;
  var y = xyz[1] / 100;
  var z = xyz[2] / 100;
  var r;
  var g;
  var b;
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.2040 + z * 1.0570;

  // Assume sRGB
  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
  b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
};
convert.xyz.lab = function (xyz) {
  var x = xyz[0];
  var y = xyz[1];
  var z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  var l = 116 * y - 16;
  var a = 500 * (x - y);
  var b = 200 * (y - z);
  return [l, a, b];
};
convert.lab.xyz = function (lab) {
  var l = lab[0];
  var a = lab[1];
  var b = lab[2];
  var x;
  var y;
  var z;
  y = (l + 16) / 116;
  x = a / 500 + y;
  z = y - b / 200;
  var y2 = Math.pow(y, 3);
  var x2 = Math.pow(x, 3);
  var z2 = Math.pow(z, 3);
  y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
  x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
  z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
  x *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x, y, z];
};
convert.lab.lch = function (lab) {
  var l = lab[0];
  var a = lab[1];
  var b = lab[2];
  var h;
  var hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  var c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};
convert.lch.lab = function (lch) {
  var l = lch[0];
  var c = lch[1];
  var h = lch[2];
  var hr = h / 360 * 2 * Math.PI;
  var a = c * Math.cos(hr);
  var b = c * Math.sin(hr);
  return [l, a, b];
};
convert.rgb.ansi16 = function (args) {
  var saturation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _args = _slicedToArray3(args, 3),
    r = _args[0],
    g = _args[1],
    b = _args[2];
  var value = saturation === null ? convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization

  value = Math.round(value / 50);
  if (value === 0) {
    return 30;
  }
  var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
  if (value === 2) {
    ansi += 60;
  }
  return ansi;
};
convert.hsv.ansi16 = function (args) {
  // Optimization here; we already know the value and don't need to get
  // it converted for us.
  return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};
convert.rgb.ansi256 = function (args) {
  var r = args[0];
  var g = args[1];
  var b = args[2];

  // We use the extended greyscale palette here, with the exception of
  // black and white. normal palette only has 4 greyscale shades.
  if (r === g && g === b) {
    if (r < 8) {
      return 16;
    }
    if (r > 248) {
      return 231;
    }
    return Math.round((r - 8) / 247 * 24) + 232;
  }
  var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};
convert.ansi16.rgb = function (args) {
  var color = args % 10;

  // Handle greyscale
  if (color === 0 || color === 7) {
    if (args > 50) {
      color += 3.5;
    }
    color = color / 10.5 * 255;
    return [color, color, color];
  }
  var mult = (~~(args > 50) + 1) * 0.5;
  var r = (color & 1) * mult * 255;
  var g = (color >> 1 & 1) * mult * 255;
  var b = (color >> 2 & 1) * mult * 255;
  return [r, g, b];
};
convert.ansi256.rgb = function (args) {
  // Handle greyscale
  if (args >= 232) {
    var _c2 = (args - 232) * 10 + 8;
    return [_c2, _c2, _c2];
  }
  args -= 16;
  var rem;
  var r = Math.floor(args / 36) / 5 * 255;
  var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
  var b = rem % 6 / 5 * 255;
  return [r, g, b];
};
convert.rgb.hex = function (args) {
  var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
  var string = integer.toString(16).toUpperCase();
  return '000000'.substring(string.length) + string;
};
convert.hex.rgb = function (args) {
  var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match) {
    return [0, 0, 0];
  }
  var colorString = match[0];
  if (match[0].length === 3) {
    colorString = colorString.split('').map(function (char) {
      return char + char;
    }).join('');
  }
  var integer = parseInt(colorString, 16);
  var r = integer >> 16 & 0xFF;
  var g = integer >> 8 & 0xFF;
  var b = integer & 0xFF;
  return [r, g, b];
};
convert.rgb.hcg = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var max = Math.max(Math.max(r, g), b);
  var min = Math.min(Math.min(r, g), b);
  var chroma = max - min;
  var grayscale;
  var hue;
  if (chroma < 1) {
    grayscale = min / (1 - chroma);
  } else {
    grayscale = 0;
  }
  if (chroma <= 0) {
    hue = 0;
  } else if (max === r) {
    hue = (g - b) / chroma % 6;
  } else if (max === g) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g) / chroma;
  }
  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};
convert.hsl.hcg = function (hsl) {
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
  var f = 0;
  if (c < 1.0) {
    f = (l - 0.5 * c) / (1.0 - c);
  }
  return [hsl[0], c * 100, f * 100];
};
convert.hsv.hcg = function (hsv) {
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var c = s * v;
  var f = 0;
  if (c < 1.0) {
    f = (v - c) / (1 - c);
  }
  return [hsv[0], c * 100, f * 100];
};
convert.hcg.rgb = function (hcg) {
  var h = hcg[0] / 360;
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  if (c === 0.0) {
    return [g * 255, g * 255, g * 255];
  }
  var pure = [0, 0, 0];
  var hi = h % 1 * 6;
  var v = hi % 1;
  var w = 1 - v;
  var mg = 0;

  /* eslint-disable max-statements-per-line */
  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v;
      pure[2] = 0;
      break;
    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;
    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v;
      break;
    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;
    case 4:
      pure[0] = v;
      pure[1] = 0;
      pure[2] = 1;
      break;
    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }
  /* eslint-enable max-statements-per-line */

  mg = (1.0 - c) * g;
  return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
};
convert.hcg.hsv = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var v = c + g * (1.0 - c);
  var f = 0;
  if (v > 0.0) {
    f = c / v;
  }
  return [hcg[0], f * 100, v * 100];
};
convert.hcg.hsl = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var l = g * (1.0 - c) + 0.5 * c;
  var s = 0;
  if (l > 0.0 && l < 0.5) {
    s = c / (2 * l);
  } else if (l >= 0.5 && l < 1.0) {
    s = c / (2 * (1 - l));
  }
  return [hcg[0], s * 100, l * 100];
};
convert.hcg.hwb = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var v = c + g * (1.0 - c);
  return [hcg[0], (v - c) * 100, (1 - v) * 100];
};
convert.hwb.hcg = function (hwb) {
  var w = hwb[1] / 100;
  var b = hwb[2] / 100;
  var v = 1 - b;
  var c = v - w;
  var g = 0;
  if (c < 1) {
    g = (v - c) / (1 - c);
  }
  return [hwb[0], c * 100, g * 100];
};
convert.apple.rgb = function (apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};
convert.rgb.apple = function (rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};
convert.gray.rgb = function (args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};
convert.gray.hsl = function (args) {
  return [0, 0, args[0]];
};
convert.gray.hsv = convert.gray.hsl;
convert.gray.hwb = function (gray) {
  return [0, 100, gray[0]];
};
convert.gray.cmyk = function (gray) {
  return [0, 0, 0, gray[0]];
};
convert.gray.lab = function (gray) {
  return [gray[0], 0, 0];
};
convert.gray.hex = function (gray) {
  var val = Math.round(gray[0] / 100 * 255) & 0xFF;
  var integer = (val << 16) + (val << 8) + val;
  var string = integer.toString(16).toUpperCase();
  return '000000'.substring(string.length) + string;
};
convert.rgb.gray = function (rgb) {
  var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
  var graph = {};
  // https://jsperf.com/object-keys-vs-for-in-with-closure/3
  var models = Object.keys(conversions);
  for (var len = models.length, i = 0; i < len; i++) {
    graph[models[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }
  return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
  var graph = buildGraph();
  var queue = [fromModel]; // Unshift -> queue -> pop

  graph[fromModel].distance = 0;
  while (queue.length) {
    var current = queue.pop();
    var adjacents = Object.keys(conversions[current]);
    for (var len = adjacents.length, i = 0; i < len; i++) {
      var adjacent = adjacents[i];
      var node = graph[adjacent];
      if (node.distance === -1) {
        node.distance = graph[current].distance + 1;
        node.parent = current;
        queue.unshift(adjacent);
      }
    }
  }
  return graph;
}
function link(from, to) {
  return function (args) {
    return to(from(args));
  };
}
function wrapConversion(toModel, graph) {
  var path = [graph[toModel].parent, toModel];
  var fn = conversions[graph[toModel].parent][toModel];
  var cur = graph[toModel].parent;
  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }
  fn.conversion = path;
  return fn;
}
var route = function route(fromModel) {
  var graph = deriveBFS(fromModel);
  var conversion = {};
  var models = Object.keys(graph);
  for (var len = models.length, i = 0; i < len; i++) {
    var toModel = models[i];
    var node = graph[toModel];
    if (node.parent === null) {
      // No possible conversion, or this node is the source model.
      continue;
    }
    conversion[toModel] = wrapConversion(toModel, graph);
  }
  return conversion;
};
var convert$1 = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
  var wrappedFn = function wrappedFn() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    var arg0 = args[0];
    if (arg0 === undefined || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    return fn(args);
  };

  // Preserve .conversion property if there is one
  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
function wrapRounded(fn) {
  var wrappedFn = function wrappedFn() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    var arg0 = args[0];
    if (arg0 === undefined || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    var result = fn(args);

    // We're assuming the result is an array here.
    // see notice in conversions.js; don't use box types
    // in conversion functions.
    if (typeof result === 'object') {
      for (var len = result.length, i = 0; i < len; i++) {
        result[i] = Math.round(result[i]);
      }
    }
    return result;
  };

  // Preserve .conversion property if there is one
  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
models.forEach(function (fromModel) {
  convert$1[fromModel] = {};
  Object.defineProperty(convert$1[fromModel], 'channels', {
    value: conversions[fromModel].channels
  });
  Object.defineProperty(convert$1[fromModel], 'labels', {
    value: conversions[fromModel].labels
  });
  var routes = route(fromModel);
  var routeModels = Object.keys(routes);
  routeModels.forEach(function (toModel) {
    var fn = routes[toModel];
    convert$1[fromModel][toModel] = wrapRounded(fn);
    convert$1[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert$1;
var ansiStyles = createCommonjsModule(function (module) {
  var wrapAnsi16 = function wrapAnsi16(fn, offset) {
    return function () {
      var code = fn.apply(void 0, arguments);
      return "\x1B[".concat(code + offset, "m");
    };
  };
  var wrapAnsi256 = function wrapAnsi256(fn, offset) {
    return function () {
      var code = fn.apply(void 0, arguments);
      return "\x1B[".concat(38 + offset, ";5;").concat(code, "m");
    };
  };
  var wrapAnsi16m = function wrapAnsi16m(fn, offset) {
    return function () {
      var rgb = fn.apply(void 0, arguments);
      return "\x1B[".concat(38 + offset, ";2;").concat(rgb[0], ";").concat(rgb[1], ";").concat(rgb[2], "m");
    };
  };
  var ansi2ansi = function ansi2ansi(n) {
    return n;
  };
  var rgb2rgb = function rgb2rgb(r, g, b) {
    return [r, g, b];
  };
  var setLazyProperty = function setLazyProperty(object, property, _get) {
    Object.defineProperty(object, property, {
      get: function get() {
        var value = _get();
        Object.defineProperty(object, property, {
          value: value,
          enumerable: true,
          configurable: true
        });
        return value;
      },
      enumerable: true,
      configurable: true
    });
  };

  /** @type {typeof import('color-convert')} */
  var colorConvert$1;
  var makeDynamicStyles = function makeDynamicStyles(wrap, targetSpace, identity, isBackground) {
    if (colorConvert$1 === undefined) {
      colorConvert$1 = colorConvert;
    }
    var offset = isBackground ? 10 : 0;
    var styles = {};
    for (var _i6 = 0, _Object$entries = Object.entries(colorConvert$1); _i6 < _Object$entries.length; _i6++) {
      var _Object$entries$_i = _slicedToArray3(_Object$entries[_i6], 2),
        sourceSpace = _Object$entries$_i[0],
        suite = _Object$entries$_i[1];
      var name = sourceSpace === 'ansi16' ? 'ansi' : sourceSpace;
      if (sourceSpace === targetSpace) {
        styles[name] = wrap(identity, offset);
      } else if (typeof suite === 'object') {
        styles[name] = wrap(suite[targetSpace], offset);
      }
    }
    return styles;
  };
  function assembleStyles() {
    var codes = new Map();
    var styles = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };

    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (var _i7 = 0, _Object$entries2 = Object.entries(styles); _i7 < _Object$entries2.length; _i7++) {
      var _Object$entries2$_i = _slicedToArray3(_Object$entries2[_i7], 2),
        groupName = _Object$entries2$_i[0],
        group = _Object$entries2$_i[1];
      for (var _i8 = 0, _Object$entries3 = Object.entries(group); _i8 < _Object$entries3.length; _i8++) {
        var _Object$entries3$_i = _slicedToArray3(_Object$entries3[_i8], 2),
          styleName = _Object$entries3$_i[0],
          _style = _Object$entries3$_i[1];
        styles[styleName] = {
          open: "\x1B[".concat(_style[0], "m"),
          close: "\x1B[".concat(_style[1], "m")
        };
        group[styleName] = styles[styleName];
        codes.set(_style[0], _style[1]);
      }
      Object.defineProperty(styles, groupName, {
        value: group,
        enumerable: false
      });
    }
    Object.defineProperty(styles, 'codes', {
      value: codes,
      enumerable: false
    });
    styles.color.close = "\x1B[39m";
    styles.bgColor.close = "\x1B[49m";
    setLazyProperty(styles.color, 'ansi', function () {
      return makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, false);
    });
    setLazyProperty(styles.color, 'ansi256', function () {
      return makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, false);
    });
    setLazyProperty(styles.color, 'ansi16m', function () {
      return makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, false);
    });
    setLazyProperty(styles.bgColor, 'ansi', function () {
      return makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, true);
    });
    setLazyProperty(styles.bgColor, 'ansi256', function () {
      return makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, true);
    });
    setLazyProperty(styles.bgColor, 'ansi16m', function () {
      return makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, true);
    });
    return styles;
  }

  // Make the export immutable
  Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
  });
});
var collections = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.printIteratorEntries = printIteratorEntries;
  exports.printIteratorValues = printIteratorValues;
  exports.printListItems = printListItems;
  exports.printObjectProperties = printObjectProperties;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */
  var getKeysOfEnumerableProperties = function getKeysOfEnumerableProperties(object) {
    var keys = Object.keys(object).sort();
    if (Object.getOwnPropertySymbols) {
      Object.getOwnPropertySymbols(object).forEach(function (symbol) {
        if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
          keys.push(symbol);
        }
      });
    }
    return keys;
  };
  /**
   * Return entries (for example, of a map)
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, braces)
   */

  function printIteratorEntries(iterator, config, indentation, depth, refs, printer) {
    var separator = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ': ';
    var result = '';
    var current = iterator.next();
    if (!current.done) {
      result += config.spacingOuter;
      var indentationNext = indentation + config.indent;
      while (!current.done) {
        var name = printer(current.value[0], config, indentationNext, depth, refs);
        var value = printer(current.value[1], config, indentationNext, depth, refs);
        result += indentationNext + name + separator + value;
        current = iterator.next();
        if (!current.done) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return values (for example, of a set)
   * with spacing, indentation, and comma
   * without surrounding punctuation (braces or brackets)
   */

  function printIteratorValues(iterator, config, indentation, depth, refs, printer) {
    var result = '';
    var current = iterator.next();
    if (!current.done) {
      result += config.spacingOuter;
      var indentationNext = indentation + config.indent;
      while (!current.done) {
        result += indentationNext + printer(current.value, config, indentationNext, depth, refs);
        current = iterator.next();
        if (!current.done) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return items (for example, of an array)
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, brackets)
   **/

  function printListItems(list, config, indentation, depth, refs, printer) {
    var result = '';
    if (list.length) {
      result += config.spacingOuter;
      var indentationNext = indentation + config.indent;
      for (var i = 0; i < list.length; i++) {
        result += indentationNext + printer(list[i], config, indentationNext, depth, refs);
        if (i < list.length - 1) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
  /**
   * Return properties of an object
   * with spacing, indentation, and comma
   * without surrounding punctuation (for example, braces)
   */

  function printObjectProperties(val, config, indentation, depth, refs, printer) {
    var result = '';
    var keys = getKeysOfEnumerableProperties(val);
    if (keys.length) {
      result += config.spacingOuter;
      var indentationNext = indentation + config.indent;
      for (var i = 0; i < keys.length; i++) {
        var _key8 = keys[i];
        var name = printer(_key8, config, indentationNext, depth, refs);
        var value = printer(val[_key8], config, indentationNext, depth, refs);
        result += indentationNext + name + ': ' + value;
        if (i < keys.length - 1) {
          result += ',' + config.spacingInner;
        } else if (!config.min) {
          result += ',';
        }
      }
      result += config.spacingOuter + indentation;
    }
    return result;
  }
});
unwrapExports(collections);
var collections_1 = collections.printIteratorEntries;
var collections_2 = collections.printIteratorValues;
var collections_3 = collections.printListItems;
var collections_4 = collections.printObjectProperties;
var AsymmetricMatcher = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.test = exports.serialize = void 0;
  var Symbol = commonjsGlobal['jest-symbol-do-not-touch'] || commonjsGlobal.Symbol;
  var asymmetricMatcher = typeof Symbol === 'function' && Symbol.for ? Symbol.for('jest.asymmetricMatcher') : 0x1357a5;
  var SPACE = ' ';
  var serialize = function serialize(val, config, indentation, depth, refs, printer) {
    var stringedValue = val.toString();
    if (stringedValue === 'ArrayContaining' || stringedValue === 'ArrayNotContaining') {
      if (++depth > config.maxDepth) {
        return '[' + stringedValue + ']';
      }
      return stringedValue + SPACE + '[' + (0, collections.printListItems)(val.sample, config, indentation, depth, refs, printer) + ']';
    }
    if (stringedValue === 'ObjectContaining' || stringedValue === 'ObjectNotContaining') {
      if (++depth > config.maxDepth) {
        return '[' + stringedValue + ']';
      }
      return stringedValue + SPACE + '{' + (0, collections.printObjectProperties)(val.sample, config, indentation, depth, refs, printer) + '}';
    }
    if (stringedValue === 'StringMatching' || stringedValue === 'StringNotMatching') {
      return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    }
    if (stringedValue === 'StringContaining' || stringedValue === 'StringNotContaining') {
      return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
    }
    return val.toAsymmetricMatcher();
  };
  exports.serialize = serialize;
  var test = function test(val) {
    return val && val.$$typeof === asymmetricMatcher;
  };
  exports.test = test;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(AsymmetricMatcher);
var AsymmetricMatcher_1 = AsymmetricMatcher.test;
var AsymmetricMatcher_2 = AsymmetricMatcher.serialize;
var ansiRegex = function ansiRegex() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$onlyFirst = _ref10.onlyFirst,
    onlyFirst = _ref10$onlyFirst === void 0 ? false : _ref10$onlyFirst;
  var pattern = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", '(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))'].join('|');
  return new RegExp(pattern, onlyFirst ? undefined : 'g');
};
var ConvertAnsi = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.serialize = exports.test = void 0;
  var _ansiRegex = _interopRequireDefault(ansiRegex);
  var _ansiStyles = _interopRequireDefault(ansiStyles);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var toHumanReadableAnsi = function toHumanReadableAnsi(text) {
    return text.replace((0, _ansiRegex.default)(), function (match) {
      switch (match) {
        case _ansiStyles.default.red.close:
        case _ansiStyles.default.green.close:
        case _ansiStyles.default.cyan.close:
        case _ansiStyles.default.gray.close:
        case _ansiStyles.default.white.close:
        case _ansiStyles.default.yellow.close:
        case _ansiStyles.default.bgRed.close:
        case _ansiStyles.default.bgGreen.close:
        case _ansiStyles.default.bgYellow.close:
        case _ansiStyles.default.inverse.close:
        case _ansiStyles.default.dim.close:
        case _ansiStyles.default.bold.close:
        case _ansiStyles.default.reset.open:
        case _ansiStyles.default.reset.close:
          return '</>';
        case _ansiStyles.default.red.open:
          return '<red>';
        case _ansiStyles.default.green.open:
          return '<green>';
        case _ansiStyles.default.cyan.open:
          return '<cyan>';
        case _ansiStyles.default.gray.open:
          return '<gray>';
        case _ansiStyles.default.white.open:
          return '<white>';
        case _ansiStyles.default.yellow.open:
          return '<yellow>';
        case _ansiStyles.default.bgRed.open:
          return '<bgRed>';
        case _ansiStyles.default.bgGreen.open:
          return '<bgGreen>';
        case _ansiStyles.default.bgYellow.open:
          return '<bgYellow>';
        case _ansiStyles.default.inverse.open:
          return '<inverse>';
        case _ansiStyles.default.dim.open:
          return '<dim>';
        case _ansiStyles.default.bold.open:
          return '<bold>';
        default:
          return '';
      }
    });
  };
  var test = function test(val) {
    return typeof val === 'string' && !!val.match((0, _ansiRegex.default)());
  };
  exports.test = test;
  var serialize = function serialize(val, config, indentation, depth, refs, printer) {
    return printer(toHumanReadableAnsi(val), config, indentation, depth, refs);
  };
  exports.serialize = serialize;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(ConvertAnsi);
var ConvertAnsi_1 = ConvertAnsi.serialize;
var ConvertAnsi_2 = ConvertAnsi.test;
var DOMCollection = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.serialize = exports.test = void 0;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /* eslint-disable local/ban-types-eventually */
  var SPACE = ' ';
  var OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
  var ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
  var testName = function testName(name) {
    return OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);
  };
  var test = function test(val) {
    return val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
  };
  exports.test = test;
  var isNamedNodeMap = function isNamedNodeMap(collection) {
    return collection.constructor.name === 'NamedNodeMap';
  };
  var serialize = function serialize(collection, config, indentation, depth, refs, printer) {
    var name = collection.constructor.name;
    if (++depth > config.maxDepth) {
      return '[' + name + ']';
    }
    return (config.min ? '' : name + SPACE) + (OBJECT_NAMES.indexOf(name) !== -1 ? '{' + (0, collections.printObjectProperties)(isNamedNodeMap(collection) ? Array.from(collection).reduce(function (props, attribute) {
      props[attribute.name] = attribute.value;
      return props;
    }, {}) : _objectSpread({}, collection), config, indentation, depth, refs, printer) + '}' : '[' + (0, collections.printListItems)(Array.from(collection), config, indentation, depth, refs, printer) + ']');
  };
  exports.serialize = serialize;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(DOMCollection);
var DOMCollection_1 = DOMCollection.serialize;
var DOMCollection_2 = DOMCollection.test;
var escapeHTML_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = escapeHTML;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function escapeHTML(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
});
unwrapExports(escapeHTML_1);
var markup = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.printElementAsLeaf = exports.printElement = exports.printComment = exports.printText = exports.printChildren = exports.printProps = void 0;
  var _escapeHTML = _interopRequireDefault(escapeHTML_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // Return empty string if keys is empty.
  var printProps = function printProps(keys, props, config, indentation, depth, refs, printer) {
    var indentationNext = indentation + config.indent;
    var colors = config.colors;
    return keys.map(function (key) {
      var value = props[key];
      var printed = printer(value, config, indentationNext, depth, refs);
      if (typeof value !== 'string') {
        if (printed.indexOf('\n') !== -1) {
          printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
        }
        printed = '{' + printed + '}';
      }
      return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
    }).join('');
  }; // Return empty string if children is empty.

  exports.printProps = printProps;
  var printChildren = function printChildren(children, config, indentation, depth, refs, printer) {
    return children.map(function (child) {
      return config.spacingOuter + indentation + (typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs));
    }).join('');
  };
  exports.printChildren = printChildren;
  var printText = function printText(text, config) {
    var contentColor = config.colors.content;
    return contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close;
  };
  exports.printText = printText;
  var printComment = function printComment(comment, config) {
    var commentColor = config.colors.comment;
    return commentColor.open + '<!--' + (0, _escapeHTML.default)(comment) + '-->' + commentColor.close;
  }; // Separate the functions to format props, children, and element,
  // so a plugin could override a particular function, if needed.
  // Too bad, so sad: the traditional (but unnecessary) space
  // in a self-closing tagColor requires a second test of printedProps.

  exports.printComment = printComment;
  var printElement = function printElement(type, printedProps, printedChildren, config, indentation) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
  };
  exports.printElement = printElement;
  var printElementAsLeaf = function printElementAsLeaf(type, config) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
  };
  exports.printElementAsLeaf = printElementAsLeaf;
});
unwrapExports(markup);
var markup_1 = markup.printElementAsLeaf;
var markup_2 = markup.printElement;
var markup_3 = markup.printComment;
var markup_4 = markup.printText;
var markup_5 = markup.printChildren;
var markup_6 = markup.printProps;
var DOMElement = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.serialize = exports.test = void 0;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var ELEMENT_NODE = 1;
  var TEXT_NODE = 3;
  var COMMENT_NODE = 8;
  var FRAGMENT_NODE = 11;
  var ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
  var testNode = function testNode(val) {
    var _val$hasAttribute;
    var constructorName = val.constructor.name;
    var nodeType = val.nodeType,
      tagName = val.tagName;
    var isCustomElement = typeof tagName === 'string' && tagName.includes('-') || ((_val$hasAttribute = val.hasAttribute) === null || _val$hasAttribute === void 0 ? void 0 : _val$hasAttribute.call(val, 'is'));
    return nodeType === ELEMENT_NODE && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE && constructorName === 'Text' || nodeType === COMMENT_NODE && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
  };
  var test = function test(val) {
    var _val$constructor;
    return (val === null || val === void 0 ? void 0 : (_val$constructor = val.constructor) === null || _val$constructor === void 0 ? void 0 : _val$constructor.name) && testNode(val);
  };
  exports.test = test;
  function nodeIsText(node) {
    return node.nodeType === TEXT_NODE;
  }
  function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE;
  }
  function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
  }
  var serialize = function serialize(node, config, indentation, depth, refs, printer) {
    if (nodeIsText(node)) {
      return (0, markup.printText)(node.data, config);
    }
    if (nodeIsComment(node)) {
      return (0, markup.printComment)(node.data, config);
    }
    var type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
    if (++depth > config.maxDepth) {
      return (0, markup.printElementAsLeaf)(type, config);
    }
    return (0, markup.printElement)(type, (0, markup.printProps)(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(function (attr) {
      return attr.name;
    }).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce(function (props, attribute) {
      props[attribute.name] = attribute.value;
      return props;
    }, {}), config, indentation + config.indent, depth, refs, printer), (0, markup.printChildren)(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
  };
  exports.serialize = serialize;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(DOMElement);
var DOMElement_1 = DOMElement.serialize;
var DOMElement_2 = DOMElement.test;
var Immutable = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.test = exports.serialize = void 0;

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // SENTINEL constants are from https://github.com/facebook/immutable-js
  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
  var IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
  var getImmutableName = function getImmutableName(name) {
    return 'Immutable.' + name;
  };
  var printAsLeaf = function printAsLeaf(name) {
    return '[' + name + ']';
  };
  var SPACE = ' ';
  var LAZY = '…'; // Seq is lazy if it calls a method like filter

  var printImmutableEntries = function printImmutableEntries(val, config, indentation, depth, refs, printer, type) {
    return ++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + '{' + (0, collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) + '}';
  }; // Record has an entries method because it is a collection in immutable v3.
  // Return an iterator for Immutable Record from version v3 or v4.

  function getRecordEntries(val) {
    var i = 0;
    return {
      next: function next() {
        if (i < val._keys.length) {
          var _key9 = val._keys[i++];
          return {
            done: false,
            value: [_key9, val.get(_key9)]
          };
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
  var printImmutableRecord = function printImmutableRecord(val, config, indentation, depth, refs, printer) {
    // _name property is defined only for an Immutable Record instance
    // which was constructed with a second optional descriptive name arg
    var name = getImmutableName(val._name || 'Record');
    return ++depth > config.maxDepth ? printAsLeaf(name) : name + SPACE + '{' + (0, collections.printIteratorEntries)(getRecordEntries(val), config, indentation, depth, refs, printer) + '}';
  };
  var printImmutableSeq = function printImmutableSeq(val, config, indentation, depth, refs, printer) {
    var name = getImmutableName('Seq');
    if (++depth > config.maxDepth) {
      return printAsLeaf(name);
    }
    if (val[IS_KEYED_SENTINEL]) {
      return name + SPACE + '{' + (
      // from Immutable collection of entries or from ECMAScript object
      val._iter || val._object ? (0, collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) : LAZY) + '}';
    }
    return name + SPACE + '[' + (val._iter ||
    // from Immutable collection of values
    val._array ||
    // from ECMAScript array
    val._collection ||
    // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
    ? (0, collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) : LAZY) + ']';
  };
  var printImmutableValues = function printImmutableValues(val, config, indentation, depth, refs, printer, type) {
    return ++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : getImmutableName(type) + SPACE + '[' + (0, collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + ']';
  };
  var serialize = function serialize(val, config, indentation, depth, refs, printer) {
    if (val[IS_MAP_SENTINEL]) {
      return printImmutableEntries(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map');
    }
    if (val[IS_LIST_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, 'List');
    }
    if (val[IS_SET_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set');
    }
    if (val[IS_STACK_SENTINEL]) {
      return printImmutableValues(val, config, indentation, depth, refs, printer, 'Stack');
    }
    if (val[IS_SEQ_SENTINEL]) {
      return printImmutableSeq(val, config, indentation, depth, refs, printer);
    } // For compatibility with immutable v3 and v4, let record be the default.

    return printImmutableRecord(val, config, indentation, depth, refs, printer);
  }; // Explicitly comparing sentinel properties to true avoids false positive
  // when mock identity-obj-proxy returns the key as the value for any key.

  exports.serialize = serialize;
  var test = function test(val) {
    return val && (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);
  };
  exports.test = test;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(Immutable);
var Immutable_1 = Immutable.test;
var Immutable_2 = Immutable.serialize;

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = 60103,
  c = 60106,
  d = 60107,
  e = 60108,
  f = 60114,
  g = 60109,
  h = 60110,
  k = 60112,
  l = 60113,
  m = 60120,
  n = 60115,
  p = 60116,
  q = 60121,
  r = 60122,
  u = 60117,
  v = 60129,
  w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
  var x = Symbol.for;
  b = x("react.element");
  c = x("react.portal");
  d = x("react.fragment");
  e = x("react.strict_mode");
  f = x("react.profiler");
  g = x("react.provider");
  h = x("react.context");
  k = x("react.forward_ref");
  l = x("react.suspense");
  m = x("react.suspense_list");
  n = x("react.memo");
  p = x("react.lazy");
  q = x("react.block");
  r = x("react.server.block");
  u = x("react.fundamental");
  v = x("react.debug_trace_mode");
  w = x("react.legacy_hidden");
}
function y(a) {
  if ("object" === typeof a && null !== a) {
    var t = a.$$typeof;
    switch (t) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case l:
          case m:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case h:
              case k:
              case p:
              case n:
              case g:
                return a;
              default:
                return t;
            }
        }
      case c:
        return t;
    }
  }
}
var z = g,
  A = b,
  B = k,
  C = d,
  D = p,
  E = n,
  F = c,
  G = f,
  H = e,
  I = l;
var ContextConsumer = h;
var ContextProvider = z;
var Element$1 = A;
var ForwardRef = B;
var Fragment = C;
var Lazy = D;
var Memo = E;
var Portal = F;
var Profiler = G;
var StrictMode = H;
var Suspense = I;
var isAsyncMode = function isAsyncMode() {
  return !1;
};
var isConcurrentMode = function isConcurrentMode() {
  return !1;
};
var isContextConsumer = function isContextConsumer(a) {
  return y(a) === h;
};
var isContextProvider = function isContextProvider(a) {
  return y(a) === g;
};
var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === b;
};
var isForwardRef = function isForwardRef(a) {
  return y(a) === k;
};
var isFragment = function isFragment(a) {
  return y(a) === d;
};
var isLazy = function isLazy(a) {
  return y(a) === p;
};
var isMemo = function isMemo(a) {
  return y(a) === n;
};
var isPortal = function isPortal(a) {
  return y(a) === c;
};
var isProfiler = function isProfiler(a) {
  return y(a) === f;
};
var isStrictMode = function isStrictMode(a) {
  return y(a) === e;
};
var isSuspense = function isSuspense(a) {
  return y(a) === l;
};
var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
var typeOf = y;
var reactIs_production_min = {
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_SCOPE_TYPE = 0xead7;
      var REACT_OPAQUE_ID_TYPE = 0xeae0;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_OFFSCREEN_TYPE = 0xeae2;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.ContextConsumer;
var reactIs_development_2 = reactIs_development.ContextProvider;
var reactIs_development_3 = reactIs_development.Element;
var reactIs_development_4 = reactIs_development.ForwardRef;
var reactIs_development_5 = reactIs_development.Fragment;
var reactIs_development_6 = reactIs_development.Lazy;
var reactIs_development_7 = reactIs_development.Memo;
var reactIs_development_8 = reactIs_development.Portal;
var reactIs_development_9 = reactIs_development.Profiler;
var reactIs_development_10 = reactIs_development.StrictMode;
var reactIs_development_11 = reactIs_development.Suspense;
var reactIs_development_12 = reactIs_development.isAsyncMode;
var reactIs_development_13 = reactIs_development.isConcurrentMode;
var reactIs_development_14 = reactIs_development.isContextConsumer;
var reactIs_development_15 = reactIs_development.isContextProvider;
var reactIs_development_16 = reactIs_development.isElement;
var reactIs_development_17 = reactIs_development.isForwardRef;
var reactIs_development_18 = reactIs_development.isFragment;
var reactIs_development_19 = reactIs_development.isLazy;
var reactIs_development_20 = reactIs_development.isMemo;
var reactIs_development_21 = reactIs_development.isPortal;
var reactIs_development_22 = reactIs_development.isProfiler;
var reactIs_development_23 = reactIs_development.isStrictMode;
var reactIs_development_24 = reactIs_development.isSuspense;
var reactIs_development_25 = reactIs_development.isValidElementType;
var reactIs_development_26 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var ReactElement = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.test = exports.serialize = void 0;
  var ReactIs = _interopRequireWildcard(reactIs);
  function _getRequireWildcardCache() {
    if (typeof WeakMap !== 'function') return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };
    return cache;
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== 'object' && typeof obj !== 'function') {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // Given element.props.children, or subtree during recursive traversal,
  // return flattened array of children.
  var getChildren = function getChildren(arg) {
    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (Array.isArray(arg)) {
      arg.forEach(function (item) {
        getChildren(item, children);
      });
    } else if (arg != null && arg !== false) {
      children.push(arg);
    }
    return children;
  };
  var getType = function getType(element) {
    var type = element.type;
    if (typeof type === 'string') {
      return type;
    }
    if (typeof type === 'function') {
      return type.displayName || type.name || 'Unknown';
    }
    if (ReactIs.isFragment(element)) {
      return 'React.Fragment';
    }
    if (ReactIs.isSuspense(element)) {
      return 'React.Suspense';
    }
    if (typeof type === 'object' && type !== null) {
      if (ReactIs.isContextProvider(element)) {
        return 'Context.Provider';
      }
      if (ReactIs.isContextConsumer(element)) {
        return 'Context.Consumer';
      }
      if (ReactIs.isForwardRef(element)) {
        if (type.displayName) {
          return type.displayName;
        }
        var functionName = type.render.displayName || type.render.name || '';
        return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
      }
      if (ReactIs.isMemo(element)) {
        var _functionName = type.displayName || type.type.displayName || type.type.name || '';
        return _functionName !== '' ? 'Memo(' + _functionName + ')' : 'Memo';
      }
    }
    return 'UNDEFINED';
  };
  var getPropKeys = function getPropKeys(element) {
    var props = element.props;
    return Object.keys(props).filter(function (key) {
      return key !== 'children' && props[key] !== undefined;
    }).sort();
  };
  var serialize = function serialize(element, config, indentation, depth, refs, printer) {
    return ++depth > config.maxDepth ? (0, markup.printElementAsLeaf)(getType(element), config) : (0, markup.printElement)(getType(element), (0, markup.printProps)(getPropKeys(element), element.props, config, indentation + config.indent, depth, refs, printer), (0, markup.printChildren)(getChildren(element.props.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
  };
  exports.serialize = serialize;
  var test = function test(val) {
    return val && ReactIs.isElement(val);
  };
  exports.test = test;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(ReactElement);
var ReactElement_1 = ReactElement.test;
var ReactElement_2 = ReactElement.serialize;
var ReactTestComponent = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = exports.test = exports.serialize = void 0;
  var Symbol = commonjsGlobal['jest-symbol-do-not-touch'] || commonjsGlobal.Symbol;
  var testSymbol = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.test.json') : 0xea71357;
  var getPropKeys = function getPropKeys(object) {
    var props = object.props;
    return props ? Object.keys(props).filter(function (key) {
      return props[key] !== undefined;
    }).sort() : [];
  };
  var serialize = function serialize(object, config, indentation, depth, refs, printer) {
    return ++depth > config.maxDepth ? (0, markup.printElementAsLeaf)(object.type, config) : (0, markup.printElement)(object.type, object.props ? (0, markup.printProps)(getPropKeys(object), object.props, config, indentation + config.indent, depth, refs, printer) : '', object.children ? (0, markup.printChildren)(object.children, config, indentation + config.indent, depth, refs, printer) : '', config, indentation);
  };
  exports.serialize = serialize;
  var test = function test(val) {
    return val && val.$$typeof === testSymbol;
  };
  exports.test = test;
  var plugin = {
    serialize: serialize,
    test: test
  };
  var _default = plugin;
  exports.default = _default;
});
unwrapExports(ReactTestComponent);
var ReactTestComponent_1 = ReactTestComponent.test;
var ReactTestComponent_2 = ReactTestComponent.serialize;
var build = createCommonjsModule(function (module) {
  var _ansiStyles = _interopRequireDefault(ansiStyles);
  var _AsymmetricMatcher = _interopRequireDefault(AsymmetricMatcher);
  var _ConvertAnsi = _interopRequireDefault(ConvertAnsi);
  var _DOMCollection = _interopRequireDefault(DOMCollection);
  var _DOMElement = _interopRequireDefault(DOMElement);
  var _Immutable = _interopRequireDefault(Immutable);
  var _ReactElement = _interopRequireDefault(ReactElement);
  var _ReactTestComponent = _interopRequireDefault(ReactTestComponent);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /* eslint-disable local/ban-types-eventually */
  var toString = Object.prototype.toString;
  var toISOString = Date.prototype.toISOString;
  var errorToString = Error.prototype.toString;
  var regExpToString = RegExp.prototype.toString;
  /**
   * Explicitly comparing typeof constructor to function avoids undefined as name
   * when mock identity-obj-proxy returns the key as the value for any key.
   */

  var getConstructorName = function getConstructorName(val) {
    return typeof val.constructor === 'function' && val.constructor.name || 'Object';
  };
  /* global window */

  /** Is val is equal to global window object? Works even if it does not exist :) */

  var isWindow = function isWindow(val) {
    return typeof window !== 'undefined' && val === window;
  };
  var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
  var NEWLINE_REGEXP = /\n/gi;
  var PrettyFormatPluginError = /*#__PURE__*/function (_Error) {
    _inherits(PrettyFormatPluginError, _Error);
    function PrettyFormatPluginError(message, stack) {
      var _this2;
      _classCallCheck2(this, PrettyFormatPluginError);
      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PrettyFormatPluginError).call(this, message));
      _this2.stack = stack;
      _this2.name = _this2.constructor.name;
      return _this2;
    }
    return PrettyFormatPluginError;
  }(_wrapNativeSuper(Error));
  function isToStringedArrayType(toStringed) {
    return toStringed === '[object Array]' || toStringed === '[object ArrayBuffer]' || toStringed === '[object DataView]' || toStringed === '[object Float32Array]' || toStringed === '[object Float64Array]' || toStringed === '[object Int8Array]' || toStringed === '[object Int16Array]' || toStringed === '[object Int32Array]' || toStringed === '[object Uint8Array]' || toStringed === '[object Uint8ClampedArray]' || toStringed === '[object Uint16Array]' || toStringed === '[object Uint32Array]';
  }
  function printNumber(val) {
    return Object.is(val, -0) ? '-0' : String(val);
  }
  function printBigInt(val) {
    return String("".concat(val, "n"));
  }
  function printFunction(val, printFunctionName) {
    if (!printFunctionName) {
      return '[Function]';
    }
    return '[Function ' + (val.name || 'anonymous') + ']';
  }
  function printSymbol(val) {
    return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  }
  function printError(val) {
    return '[' + errorToString.call(val) + ']';
  }
  /**
   * The first port of call for printing an object, handles most of the
   * data-types in JS.
   */

  function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
    if (val === true || val === false) {
      return '' + val;
    }
    if (val === undefined) {
      return 'undefined';
    }
    if (val === null) {
      return 'null';
    }
    var typeOf = typeof val;
    if (typeOf === 'number') {
      return printNumber(val);
    }
    if (typeOf === 'bigint') {
      return printBigInt(val);
    }
    if (typeOf === 'string') {
      if (escapeString) {
        return '"' + val.replace(/"|\\/g, '\\$&') + '"';
      }
      return '"' + val + '"';
    }
    if (typeOf === 'function') {
      return printFunction(val, printFunctionName);
    }
    if (typeOf === 'symbol') {
      return printSymbol(val);
    }
    var toStringed = toString.call(val);
    if (toStringed === '[object WeakMap]') {
      return 'WeakMap {}';
    }
    if (toStringed === '[object WeakSet]') {
      return 'WeakSet {}';
    }
    if (toStringed === '[object Function]' || toStringed === '[object GeneratorFunction]') {
      return printFunction(val, printFunctionName);
    }
    if (toStringed === '[object Symbol]') {
      return printSymbol(val);
    }
    if (toStringed === '[object Date]') {
      return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
    }
    if (toStringed === '[object Error]') {
      return printError(val);
    }
    if (toStringed === '[object RegExp]') {
      if (escapeRegex) {
        // https://github.com/benjamingr/RegExp.escape/blob/master/polyfill.js
        return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
      }
      return regExpToString.call(val);
    }
    if (val instanceof Error) {
      return printError(val);
    }
    return null;
  }
  /**
   * Handles more complex objects ( such as objects with circular references.
   * maps and sets etc )
   */

  function printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
    if (refs.indexOf(val) !== -1) {
      return '[Circular]';
    }
    refs = refs.slice();
    refs.push(val);
    var hitMaxDepth = ++depth > config.maxDepth;
    var min = config.min;
    if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === 'function' && !hasCalledToJSON) {
      return printer(val.toJSON(), config, indentation, depth, refs, true);
    }
    var toStringed = toString.call(val);
    if (toStringed === '[object Arguments]') {
      return hitMaxDepth ? '[Arguments]' : (min ? '' : 'Arguments ') + '[' + (0, collections.printListItems)(val, config, indentation, depth, refs, printer) + ']';
    }
    if (isToStringedArrayType(toStringed)) {
      return hitMaxDepth ? '[' + val.constructor.name + ']' : (min ? '' : val.constructor.name + ' ') + '[' + (0, collections.printListItems)(val, config, indentation, depth, refs, printer) + ']';
    }
    if (toStringed === '[object Map]') {
      return hitMaxDepth ? '[Map]' : 'Map {' + (0, collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer, ' => ') + '}';
    }
    if (toStringed === '[object Set]') {
      return hitMaxDepth ? '[Set]' : 'Set {' + (0, collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + '}';
    } // Avoid failure to serialize global window object in jsdom test environment.
    // For example, not even relevant if window is prop of React element.

    return hitMaxDepth || isWindow(val) ? '[' + getConstructorName(val) + ']' : (min ? '' : getConstructorName(val) + ' ') + '{' + (0, collections.printObjectProperties)(val, config, indentation, depth, refs, printer) + '}';
  }
  function isNewPlugin(plugin) {
    return plugin.serialize != null;
  }
  function printPlugin(plugin, val, config, indentation, depth, refs) {
    var printed;
    try {
      printed = isNewPlugin(plugin) ? plugin.serialize(val, config, indentation, depth, refs, printer) : plugin.print(val, function (valChild) {
        return printer(valChild, config, indentation, depth, refs);
      }, function (str) {
        var indentationNext = indentation + config.indent;
        return indentationNext + str.replace(NEWLINE_REGEXP, '\n' + indentationNext);
      }, {
        edgeSpacing: config.spacingOuter,
        min: config.min,
        spacing: config.spacingInner
      }, config.colors);
    } catch (error) {
      throw new PrettyFormatPluginError(error.message, error.stack);
    }
    if (typeof printed !== 'string') {
      throw new Error("pretty-format: Plugin must return type \"string\" but instead returned \"".concat(typeof printed, "\"."));
    }
    return printed;
  }
  function findPlugin(plugins, val) {
    for (var _p2 = 0; _p2 < plugins.length; _p2++) {
      try {
        if (plugins[_p2].test(val)) {
          return plugins[_p2];
        }
      } catch (error) {
        throw new PrettyFormatPluginError(error.message, error.stack);
      }
    }
    return null;
  }
  function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
    var plugin = findPlugin(config.plugins, val);
    if (plugin !== null) {
      return printPlugin(plugin, val, config, indentation, depth, refs);
    }
    var basicResult = printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
    if (basicResult !== null) {
      return basicResult;
    }
    return printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
  }
  var DEFAULT_THEME = {
    comment: 'gray',
    content: 'reset',
    prop: 'yellow',
    tag: 'cyan',
    value: 'green'
  };
  var DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
  var DEFAULT_OPTIONS = {
    callToJSON: true,
    escapeRegex: false,
    escapeString: true,
    highlight: false,
    indent: 2,
    maxDepth: Infinity,
    min: false,
    plugins: [],
    printFunctionName: true,
    theme: DEFAULT_THEME
  };
  function validateOptions(options) {
    Object.keys(options).forEach(function (key) {
      if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
        throw new Error("pretty-format: Unknown option \"".concat(key, "\"."));
      }
    });
    if (options.min && options.indent !== undefined && options.indent !== 0) {
      throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
    }
    if (options.theme !== undefined) {
      if (options.theme === null) {
        throw new Error("pretty-format: Option \"theme\" must not be null.");
      }
      if (typeof options.theme !== 'object') {
        throw new Error("pretty-format: Option \"theme\" must be of type \"object\" but instead received \"".concat(typeof options.theme, "\"."));
      }
    }
  }
  var getColorsHighlight = function getColorsHighlight(options) {
    return DEFAULT_THEME_KEYS.reduce(function (colors, key) {
      var value = options.theme && options.theme[key] !== undefined ? options.theme[key] : DEFAULT_THEME[key];
      var color = value && _ansiStyles.default[value];
      if (color && typeof color.close === 'string' && typeof color.open === 'string') {
        colors[key] = color;
      } else {
        throw new Error("pretty-format: Option \"theme\" has a key \"".concat(key, "\" whose value \"").concat(value, "\" is undefined in ansi-styles."));
      }
      return colors;
    }, Object.create(null));
  };
  var getColorsEmpty = function getColorsEmpty() {
    return DEFAULT_THEME_KEYS.reduce(function (colors, key) {
      colors[key] = {
        close: '',
        open: ''
      };
      return colors;
    }, Object.create(null));
  };
  var getPrintFunctionName = function getPrintFunctionName(options) {
    return options && options.printFunctionName !== undefined ? options.printFunctionName : DEFAULT_OPTIONS.printFunctionName;
  };
  var getEscapeRegex = function getEscapeRegex(options) {
    return options && options.escapeRegex !== undefined ? options.escapeRegex : DEFAULT_OPTIONS.escapeRegex;
  };
  var getEscapeString = function getEscapeString(options) {
    return options && options.escapeString !== undefined ? options.escapeString : DEFAULT_OPTIONS.escapeString;
  };
  var getConfig = function getConfig(options) {
    return {
      callToJSON: options && options.callToJSON !== undefined ? options.callToJSON : DEFAULT_OPTIONS.callToJSON,
      colors: options && options.highlight ? getColorsHighlight(options) : getColorsEmpty(),
      escapeRegex: getEscapeRegex(options),
      escapeString: getEscapeString(options),
      indent: options && options.min ? '' : createIndent(options && options.indent !== undefined ? options.indent : DEFAULT_OPTIONS.indent),
      maxDepth: options && options.maxDepth !== undefined ? options.maxDepth : DEFAULT_OPTIONS.maxDepth,
      min: options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
      plugins: options && options.plugins !== undefined ? options.plugins : DEFAULT_OPTIONS.plugins,
      printFunctionName: getPrintFunctionName(options),
      spacingInner: options && options.min ? ' ' : '\n',
      spacingOuter: options && options.min ? '' : '\n'
    };
  };
  function createIndent(indent) {
    return new Array(indent + 1).join(' ');
  }
  /**
   * Returns a presentation string of your `val` object
   * @param val any potential JavaScript object
   * @param options Custom settings
   */

  function prettyFormat(val, options) {
    if (options) {
      validateOptions(options);
      if (options.plugins) {
        var plugin = findPlugin(options.plugins, val);
        if (plugin !== null) {
          return printPlugin(plugin, val, getConfig(options), '', 0, []);
        }
      }
    }
    var basicResult = printBasicValue(val, getPrintFunctionName(options), getEscapeRegex(options), getEscapeString(options));
    if (basicResult !== null) {
      return basicResult;
    }
    return printComplexValue(val, getConfig(options), '', 0, []);
  }
  prettyFormat.plugins = {
    AsymmetricMatcher: _AsymmetricMatcher.default,
    ConvertAnsi: _ConvertAnsi.default,
    DOMCollection: _DOMCollection.default,
    DOMElement: _DOMElement.default,
    Immutable: _Immutable.default,
    ReactElement: _ReactElement.default,
    ReactTestComponent: _ReactTestComponent.default
  };
  module.exports = prettyFormat;
});
var prettyFormat = unwrapExports(build);

/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */
var toStr = Object.prototype.toString;
function isCallable(fn) {
  return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}
function toInteger(value) {
  var number = Number(value);
  if (isNaN(number)) {
    return 0;
  }
  if (number === 0 || !isFinite(number)) {
    return number;
  }
  return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
  var len = toInteger(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 */

/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 * @param mapfn A mapping function to call on every element of the array.
 * @param thisArg Value of 'this' used to invoke the mapfn.
 */
function arrayFrom(arrayLike, mapFn) {
  // 1. Let C be the this value.
  // edit(@eps1lon): we're not calling it as Array.from
  var C = Array; // 2. Let items be ToObject(arrayLike).

  var items = Object(arrayLike); // 3. ReturnIfAbrupt(items).

  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  } // 4. If mapfn is undefined, then let mapping be false.
  // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;

  if (typeof mapFn !== "undefined") {
    // 5. else
    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
    if (!isCallable(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
  } // 10. Let lenValue be Get(items, "length").
  // 11. Let len be ToLength(lenValue).

  var len = toLength(items.length); // 13. If IsConstructor(C) is true, then
  // 13. a. Let A be the result of calling the [[Construct]] internal method
  // of C with an argument list containing the single item len.
  // 14. a. Else, Let A be ArrayCreate(len).

  var A = isCallable(C) ? Object(new C(len)) : new Array(len); // 16. Let k be 0.

  var k = 0; // 17. Repeat, while k < len… (also steps a - h)

  var kValue;
  while (k < len) {
    kValue = items[k];
    if (mapFn) {
      A[k] = mapFn(kValue, k);
    } else {
      A[k] = kValue;
    }
    k += 1;
  } // 18. Let putStatus be Put(A, "length", len, true).

  A.length = len; // 20. Return A.

  return A;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/function () {
  function SetLike() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, SetLike);
    _defineProperty(this, "items", void 0);
    this.items = items;
  }
  _createClass(SetLike, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function (item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this = this;
      this.items.forEach(function (item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }]);
  return SetLike;
}();
var SetLike$1 = typeof Set === "undefined" ? Set : SetLike;
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  body: "document",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: new Set(["aria-label", "aria-labelledby"]),
  code: new Set(["aria-label", "aria-labelledby"]),
  deletion: new Set(["aria-label", "aria-labelledby"]),
  emphasis: new Set(["aria-label", "aria-labelledby"]),
  generic: new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: new Set(["aria-label", "aria-labelledby"]),
  paragraph: new Set(["aria-label", "aria-labelledby"]),
  presentation: new Set(["aria-label", "aria-labelledby"]),
  strong: new Set(["aria-label", "aria-labelledby"]),
  subscript: new Set(["aria-label", "aria-labelledby"]),
  superscript: new Set(["aria-label", "aria-labelledby"])
};
/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */

function hasGlobalAriaAttributes(element, role) {
  // https://rawgit.com/w3c/aria/stable/#global_states
  // commented attributes are deprecated
  return ["aria-atomic", "aria-busy", "aria-controls", "aria-current", "aria-describedby", "aria-details",
  // "disabled",
  "aria-dropeffect",
  // "errormessage",
  "aria-flowto", "aria-grabbed",
  // "haspopup",
  "aria-hidden",
  // "invalid",
  "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription"].some(function (attributeName) {
    var _prohibitedAttributes;
    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) === null || _prohibitedAttributes === void 0 ? void 0 : _prohibitedAttributes.has(attributeName));
  });
}
function ignorePresentationalRole(element, implicitRole) {
  // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
  return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
  var explicitRole = getExplicitRole(element);
  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);
    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }
  return explicitRole;
}
function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];
  if (mappedByTag !== undefined) {
    return mappedByTag;
  }
  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }
      break;
    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }
      return "img";
    case "input":
      {
        var _ref = element,
          type = _ref.type;
        switch (type) {
          case "button":
          case "image":
          case "reset":
          case "submit":
            return "button";
          case "checkbox":
          case "radio":
            return type;
          case "range":
            return "slider";
          case "email":
          case "tel":
          case "text":
          case "url":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "textbox";
          case "search":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "searchbox";
          default:
            return null;
        }
      }
    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }
      return "combobox";
  }
  return null;
}
function getExplicitRole(element) {
  if (element.hasAttribute("role")) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var _trim$split = element.getAttribute("role").trim().split(" "),
      _trim$split2 = _slicedToArray(_trim$split, 1),
      explicitRole = _trim$split2[0];
    if (explicitRole !== undefined && explicitRole.length > 0) {
      return explicitRole;
    }
  }
  return null;
}

/**
 * Safe Element.localName for all supported environments
 * @param element
 */

function getLocalName(element) {
  var _element$localName;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName :
    // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase()
  );
}
function isElement$1(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
  return isElement$1(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
  return isElement$1(node) && getLocalName(node) === "input";
}
function isHTMLSelectElement(node) {
  return isElement$1(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
  return isElement$1(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
  return isElement$1(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
    defaultView = _ref.defaultView;
  if (defaultView === null) {
    throw new TypeError("no window available");
  }
  return defaultView;
}
function isHTMLFieldSetElement(node) {
  return isElement$1(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
  return isElement$1(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
  return isElement$1(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
  return isElement$1(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
  return isElement$1(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
  return isSVGElement(node) && getLocalName(node) === "title";
}
/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */

function queryIdRefs(node, attributeName) {
  if (isElement$1(node) && node.hasAttribute(attributeName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var ids = node.getAttribute(attributeName).split(" ");
    return ids.map(function (id) {
      return node.ownerDocument.getElementById(id);
    }).filter(function (element) {
      return element !== null;
    } // TODO: why does this not narrow?
    );
  }

  return [];
}
function hasAnyConcreteRoles(node, roles) {
  if (isElement$1(node)) {
    return roles.indexOf(getRole(node)) !== -1;
  }
  return false;
}

/**
 * implements https://w3c.github.io/accname/
 */
/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */

/**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */
function asFlatString(s) {
  return s.trim().replace(/\s\s+/g, " ");
}
/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */

function isHidden(node, getComputedStyleImplementation) {
  if (!isElement$1(node)) {
    return false;
  }
  if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") {
    return true;
  }
  var style = getComputedStyleImplementation(node);
  return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}
/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */

function isControl(node) {
  return hasAnyConcreteRoles(node, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node, "range");
}
function hasAbstractRole(node, role) {
  if (!isElement$1(node)) {
    return false;
  }
  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}
/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */

function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function (root) {
    // babel transpiles this assuming an iterator
    elements.push.apply(elements, arrayFrom(root.querySelectorAll(selectors)));
  });
  return elements;
}
function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }
  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node) {
  return hasAnyConcreteRoles(node, ["none", "presentation"]);
}
/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */

function isNativeHostLanguageTextAlternativeElement(node) {
  return isHTMLTableCaptionElement(node);
}
/**
 * https://w3c.github.io/aria/#namefromcontent
 */

function allowsNameFromContent(node) {
  return hasAnyConcreteRoles(node, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */

function isDescendantOfNativeHostLanguageTextAlternativeElement(
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
  return false;
}
function getValueOfTextbox(element) {
  if (isHTMLInputElement(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  } // https://github.com/eps1lon/dom-accessibility-api/issues/4

  return element.textContent || "";
}
function getTextualContent(declaration) {
  var content = declaration.getPropertyValue("content");
  if (/^["'].*["']$/.test(content)) {
    return content.slice(1, -1);
  }
  return "";
}
/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */

function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}
/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */

function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }
  var labelableElement = null;
  element.childNodes.forEach(function (childNode) {
    if (labelableElement === null && isElement$1(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);
      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}
/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */

function getControlOfLabel(label) {
  if (label.control !== undefined) {
    return label.control;
  }
  var htmlFor = label.getAttribute("for");
  if (htmlFor !== null) {
    return label.ownerDocument.getElementById(htmlFor);
  }
  return findLabelableElement(label);
}
/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */

function getLabels(element) {
  var labelsProperty = element.labels;
  if (labelsProperty === null) {
    return labelsProperty;
  }
  if (labelsProperty !== undefined) {
    return arrayFrom(labelsProperty);
  }
  if (!isLabelableElement(element)) {
    return null;
  }
  var document = element.ownerDocument;
  return arrayFrom(document.querySelectorAll("label")).filter(function (label) {
    return getControlOfLabel(label) === element;
  });
}
/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */

function getSlotContents(slot) {
  // Computing the accessible name for elements containing slots is not
  // currently defined in the spec. This implementation reflects the
  // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
  var assignedNodes = slot.assignedNodes();
  if (assignedNodes.length === 0) {
    // if no nodes are assigned to the slot, it displays the default content
    return arrayFrom(slot.childNodes);
  }
  return assignedNodes;
}
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param [options]
 * @param [options.getComputedStyle] - mock window.getComputedStyle. Needs `content`, `display` and `visibility`
 */

function computeTextAlternative(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var consultedNodes = new SetLike$1();
  var window = safeWindow(root);
  var _options$compute = options.compute,
    compute = _options$compute === void 0 ? "name" : _options$compute,
    _options$computedStyl = options.computedStyleSupportsPseudoElements,
    computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl,
    _options$getComputedS = options.getComputedStyle,
    getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS; // 2F.i

  function computeMiscTextAlternative(node, context) {
    var accumulatedText = "";
    if (isElement$1(node) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle(node, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    } // FIXME: Including aria-owns is not defined in the spec
    // But it is required in the web-platform-test

    var childNodes = isHTMLSlotElement(node) ? getSlotContents(node) : arrayFrom(node.childNodes).concat(queryIdRefs(node, "aria-owns"));
    childNodes.forEach(function (child) {
      var result = computeTextAlternative(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      }); // TODO: Unclear why display affects delimiter
      // see https://github.com/w3c/accname/issues/3

      var display = isElement$1(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : ""; // trailing separator for wpt tests

      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });
    if (isElement$1(node) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle(node, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }
    return accumulatedText;
  }
  function computeElementTextAlternative(node) {
    if (!isElement$1(node)) {
      return null;
    }
    /**
     *
     * @param element
     * @param attributeName
     * @returns A string non-empty string or `null`
     */

    function useAttribute(element, attributeName) {
      var attribute = element.getAttributeNode(attributeName);
      if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
        consultedNodes.add(attribute);
        return attribute.value;
      }
      return null;
    } // https://w3c.github.io/html-aam/#fieldset-and-legend-elements

    if (isHTMLFieldSetElement(node)) {
      consultedNodes.add(node);
      var children = arrayFrom(node.childNodes);
      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        if (isHTMLLegendElement(child)) {
          return computeTextAlternative(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node)) {
      // https://w3c.github.io/html-aam/#table-element
      consultedNodes.add(node);
      var _children = arrayFrom(node.childNodes);
      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];
        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node)) {
      // https://www.w3.org/TR/svg-aam-1.0/
      consultedNodes.add(node);
      var _children2 = arrayFrom(node.childNodes);
      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];
        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }
      return null;
    } else if (getLocalName(node) === "img" || getLocalName(node) === "area") {
      // https://w3c.github.io/html-aam/#area-element
      // https://w3c.github.io/html-aam/#img-element
      var nameFromAlt = useAttribute(node, "alt");
      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    }
    if (isHTMLInputElement(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
      // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
      var nameFromValue = useAttribute(node, "value");
      if (nameFromValue !== null) {
        return nameFromValue;
      } // TODO: l10n

      if (node.type === "submit") {
        return "Submit";
      } // TODO: l10n

      if (node.type === "reset") {
        return "Reset";
      }
    }
    if (isHTMLInputElement(node) || isHTMLSelectElement(node) || isHTMLTextAreaElement(node)) {
      var input = node;
      var labels = getLabels(input);
      if (labels !== null && labels.length !== 0) {
        consultedNodes.add(input);
        return arrayFrom(labels).map(function (element) {
          return computeTextAlternative(element, {
            isEmbeddedInLabel: true,
            isReferenced: false,
            recursion: true
          });
        }).filter(function (label) {
          return label.length > 0;
        }).join(" ");
      }
    } // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
    // TODO: wpt test consider label elements but html-aam does not mention them
    // We follow existing implementations over spec

    if (isHTMLInputElement(node) && node.type === "image") {
      var _nameFromAlt = useAttribute(node, "alt");
      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }
      var nameFromTitle = useAttribute(node, "title");
      if (nameFromTitle !== null) {
        return nameFromTitle;
      } // TODO: l10n

      return "Submit Query";
    }
    return useAttribute(node, "title");
  }
  function computeTextAlternative(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    } // special casing, cheating to make tests pass
    // https://github.com/w3c/accname/issues/67

    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    } // 2A

    if (isHidden(current, getComputedStyle) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    } // 2B

    var labelElements = queryIdRefs(current, "aria-labelledby");
    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      return labelElements.map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // thais isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    } // 2C
    // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
    // spec says we should only consider skipping if we have a non-empty label

    var skipToStep2E = context.recursion && isControl(current) && compute === "name";
    if (!skipToStep2E) {
      var ariaLabel = (isElement$1(current) && current.getAttribute("aria-label") || "").trim();
      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      } // 2D

      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);
        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    } // 2E

    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);
        if (selectedOptions.length === 0) {
          // defined per test `name_heading_combobox`
          return isHTMLInputElement(current) ? current.value : "";
        }
        return arrayFrom(selectedOptions).map(function (selectedOption) {
          return computeTextAlternative(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }
      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);
        if (current.hasAttribute("aria-valuetext")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuetext");
        }
        if (current.hasAttribute("aria-valuenow")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuenow");
        } // Otherwise, use the value as specified by a host language attribute.

        return current.getAttribute("value") || "";
      }
      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    } // 2F: https://w3c.github.io/accname/#step2F

    if (allowsNameFromContent(current) || isElement$1(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement()) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }
    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }
    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }
    consultedNodes.add(current);
    return "";
  }
  return asFlatString(computeTextAlternative(root, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}

/**
 * https://w3c.github.io/aria/#namefromprohibited
 */

function prohibitsNaming(node) {
  return hasAnyConcreteRoles(node, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param [options]
 * @parma [options.getComputedStyle] - mock window.getComputedStyle. Needs `content`, `display` and `visibility`
 */

function computeAccessibleName(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (prohibitsNaming(root)) {
    return "";
  }
  return computeTextAlternative(root, options);
}
var interopRequireDefault = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(interopRequireDefault);
var check = function check(it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();
var fails = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
  1: 2
}, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f$1
};
var createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};
var toString = {}.toString;
var classofRaw = function classofRaw(it) {
  return toString.call(it).slice(8, -1);
};
var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function requireObjectCoercible(it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings

var toIndexedObject = function toIndexedObject(it) {
  return indexedObject(requireObjectCoercible(it));
};
var isObject = function isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function toPrimitive(input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function toObject(argument) {
  return Object(requireObjectCoercible(argument));
};
var hasOwnProperty = {}.hasOwnProperty;
var has = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};
var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);
var documentCreateElement = function documentCreateElement(it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) {/* empty */}
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$2
};
var replacement = /#|\.prototype\./;
var isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;
var path = {};
var aFunction = function aFunction(it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  }
  return it;
};

// optional / simple context binding
var functionBindContext = function functionBindContext(fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0:
      return function () {
        return fn.call(that);
      };
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};
var anObject = function anObject(it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  }
  return it;
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$3 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$3
};
var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var wrapConstructor = function wrapConstructor(NativeConstructor) {
  var Wrapper = function Wrapper(a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0:
          return new NativeConstructor();
        case 1:
          return new NativeConstructor(a);
        case 2:
          return new NativeConstructor(a, b);
      }
      return new NativeConstructor(a, b, c);
    }
    return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;
  var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;
  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;
  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
  for (key in source) {
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);
    targetProperty = target[key];
    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global_1);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }
    target[key] = resultProperty;
    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
_export({
  target: 'Object',
  stat: true,
  forced: !descriptors,
  sham: !descriptors
}, {
  defineProperty: objectDefineProperty.f
});
var defineProperty_1 = createCommonjsModule(function (module) {
  var Object = path.Object;
  var defineProperty = module.exports = function defineProperty(it, key, desc) {
    return Object.defineProperty(it, key, desc);
  };
  if (Object.defineProperty.sham) defineProperty.sham = true;
});
var defineProperty = defineProperty_1;
var defineProperty$1 = defineProperty;
var hiddenKeys = {};
var id = 0;
var postfix = Math.random();
var uid = function uid(key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};
var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});
var internalMetadata = createCommonjsModule(function (module) {
  var defineProperty = objectDefineProperty.f;
  var METADATA = uid('meta');
  var id = 0;

  // eslint-disable-next-line es/no-object-isextensible -- safe
  var isExtensible = Object.isExtensible || function () {
    return true;
  };
  var setMetadata = function setMetadata(it) {
    defineProperty(it, METADATA, {
      value: {
        objectID: 'O' + ++id,
        // object ID
        weakData: {} // weak collections IDs
      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!has(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F';
      // not necessary to add metadata
      if (!create) return 'E';
      // add missing metadata
      setMetadata(it);
      // return object ID
    }
    return it[METADATA].objectID;
  };
  var getWeakData = function getWeakData(it, create) {
    if (!has(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true;
      // not necessary to add metadata
      if (!create) return false;
      // add missing metadata
      setMetadata(it);
      // return the store of weak collections IDs
    }
    return it[METADATA].weakData;
  };

  // add metadata on freeze-family methods calling
  var onFreeze = function onFreeze(it) {
    if (freezing && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
    return it;
  };
  var meta = module.exports = {
    REQUIRED: false,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
  };
  hiddenKeys[METADATA] = true;
});
var internalMetadata_1 = internalMetadata.REQUIRED;
var internalMetadata_2 = internalMetadata.fastKey;
var internalMetadata_3 = internalMetadata.getWeakData;
var internalMetadata_4 = internalMetadata.onFreeze;
var setGlobal = function setGlobal(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }
  return value;
};
var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;
var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.13.0',
    mode: 'pure',
    copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
  });
});
var aFunction$1 = function aFunction$1(variable) {
  return typeof variable == 'function' ? variable : undefined;
};
var getBuiltIn = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction$1(path[namespace]) || aFunction$1(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};
var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';
var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}
var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  return !String(Symbol()) ||
  // Chrome 38 Symbol has incorrect toString conversion
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = nativeSymbol && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
var wellKnownSymbol = function wellKnownSymbol(name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  }
  return WellKnownSymbolsStore[name];
};
var iterators = {};
var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function isArrayIteratorMethod(it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};
var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$1 = function toInteger$1(argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};
var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function toLength$1(argument) {
  return argument > 0 ? min(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
var toStringTagSupport = String(test) === '[object z]';
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O)
  // ES3 arguments fallback
  : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};
var ITERATOR$1 = wellKnownSymbol('iterator');
var getIteratorMethod = function getIteratorMethod(it) {
  if (it != undefined) return it[ITERATOR$1] || it['@@iterator'] || iterators[classof(it)];
};
var iteratorClose = function iteratorClose(iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};
var Result = function Result(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var iterate = function iterate(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;
  var stop = function stop(condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };
  var callFn = function callFn(value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength$1(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      }
      return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }
  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  }
  return new Result(false);
};
var anInstance = function anInstance(it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  }
  return it;
};

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};
var defineProperty$2 = objectDefineProperty.f;
var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var setToStringTag = function setToStringTag(it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG$2)) {
      defineProperty$2(target, TO_STRING_TAG$2, {
        configurable: true,
        value: TAG
      });
    }
    if (SET_METHOD && !toStringTagSupport) {
      createNonEnumerableProperty(target, 'toString', objectToString);
    }
  }
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};
var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function arraySpeciesCreate(originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};
var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function createMethod(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (; length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3:
            return true;
          // some
          case 5:
            return value;
          // find
          case 6:
            return index;
          // findIndex
          case 2:
            push.call(target, value);
          // filter
        } else switch (TYPE) {
          case 4:
            return false;
          // every
          case 7:
            push.call(target, value);
          // filterOut
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};
var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}
var inspectSource = sharedStore.inspectSource;
var WeakMap$1 = global_1.WeakMap;
var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));
var keys = shared('keys');
var sharedKey = function sharedKey(key) {
  return keys[key] || (keys[key] = uid(key));
};
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$2 = global_1.WeakMap;
var set, get, has$1;
var enforce = function enforce(it) {
  return has$1(it) ? get(it) : set(it, {});
};
var getterFor = function getterFor(TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};
if (nativeWeakMap || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function set(it, metadata) {
    if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function get(it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function has$1(it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function set(it, metadata) {
    if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function get(it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function has$1(it) {
    return has(it, STATE);
  };
}
var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};
var defineProperty$3 = objectDefineProperty.f;
var forEach = arrayIteration.forEach;
var setInternalState = internalState.set;
var internalStateGetterFor = internalState.getterFor;
var collection = function collection(CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global_1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;
  if (!descriptors || typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  }))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate(iterable, target[ADDER], {
        that: target,
        AS_ENTRIES: IS_MAP
      });
    });
    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });
    IS_WEAK || defineProperty$3(Constructor.prototype, 'size', {
      configurable: true,
      get: function get() {
        return getInternalState(this).collection.size;
      }
    });
  }
  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
  exported[CONSTRUCTOR_NAME] = Constructor;
  _export({
    global: true,
    forced: true
  }, exported);
  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
  return Constructor;
};
var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function toAbsoluteIndex(index, length) {
  var integer = toInteger$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function createMethod$1(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength$1(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};
var indexOf = arrayIncludes.indexOf;
var objectKeysInternal = function objectKeysInternal(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};
var html = getBuiltIn('document', 'documentElement');
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function EmptyConstructor() {/* empty */};
var scriptTag = function scriptTag(content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var _NullProtoObject = function NullProtoObject() {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return _NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};
var redefine = function redefine(target, key, value, options) {
  if (options && options.enumerable) target[key] = value;else createNonEnumerableProperty(target, key, value);
};
var redefineAll = function redefineAll(target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];else redefine(target, key, src[key], options);
  }
  return target;
};
var correctPrototypeGetter = !fails(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }
  return O instanceof Object ? ObjectPrototype : null;
};
var ITERATOR$2 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;
var returnThis = function returnThis() {
  return this;
};

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR$2].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (NEW_ITERATOR_PROTOTYPE && !has(IteratorPrototype, ITERATOR$2)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR$2, returnThis);
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var returnThis$1 = function returnThis$1() {
  return this;
};
var createIteratorConstructor = function createIteratorConstructor(IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
    next: createPropertyDescriptor(1, next)
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};
var aPossiblePrototype = function aPossiblePrototype(it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  }
  return it;
};

/* eslint-disable no-proto -- safe */

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis$2 = function returnThis$2() {
  return this;
};
var defineIterator = function defineIterator(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);
  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function () {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      iterators[TO_STRING_TAG] = returnThis$2;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() {
      return nativeIterator.call(this);
    };
  }

  // define iterator
  if (FORCED && IterablePrototype[ITERATOR$3] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$3, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
    }, methods);
  }
  return methods;
};
var SPECIES$1 = wellKnownSymbol('species');
var setSpecies = function setSpecies(CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;
  if (descriptors && Constructor && !Constructor[SPECIES$1]) {
    defineProperty(Constructor, SPECIES$1, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  }
};
var defineProperty$4 = objectDefineProperty.f;
var fastKey = internalMetadata.fastKey;
var setInternalState$1 = internalState.set;
var internalStateGetterFor$1 = internalState.getterFor;
var collectionStrong = {
  getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState$1(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], {
        that: that,
        AS_ENTRIES: IS_MAP
      });
    });
    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var define = function define(that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
        // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      }
      return that;
    };
    var getEntry = function getEntry(that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (descriptors) state.size = 0;else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (descriptors) state.size--;else that.size--;
        }
        return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });
    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineProperty$4(C.prototype, 'size', {
      get: function get() {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function setStrong(C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$1(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return {
          value: undefined,
          done: true
        };
      }
      // return step by kind
      if (kind == 'keys') return {
        value: entry.key,
        done: false
      };
      if (kind == 'values') return {
        value: entry.value,
        done: false
      };
      return {
        value: [entry.key, entry.value],
        done: false
      };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
var es_map = collection('Map', function (init) {
  return function Map() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$2 = function createMethod$2(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};
var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};
var charAt = stringMultibyte.charAt;
var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = internalState.set;
var getInternalState = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
  // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return {
    value: undefined,
    done: true
  };
  point = charAt(string, index);
  state.index += point.length;
  return {
    value: point,
    done: false
  };
});
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$3 = internalState.set;
var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$3(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind
  });
  // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return {
      value: undefined,
      done: true
    };
  }
  if (kind == 'keys') return {
    value: index,
    done: false
  };
  if (kind == 'values') return {
    value: target[index],
    done: false
  };
  return {
    value: [index, target[index]],
    done: false
  };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
  }
  iterators[COLLECTION_NAME] = iterators.Array;
}
var map = path.Map;
var map$1 = map;
var map$2 = map$1;
var ariaPropsMap_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _map = interopRequireDefault(map$2);
  var ariaPropsMap = new _map.default([['aria-activedescendant', {
    'type': 'id'
  }], ['aria-atomic', {
    'type': 'boolean'
  }], ['aria-autocomplete', {
    'type': 'token',
    'values': ['inline', 'list', 'both', 'none']
  }], ['aria-busy', {
    'type': 'boolean'
  }], ['aria-checked', {
    'type': 'tristate'
  }], ['aria-colcount', {
    type: 'integer'
  }], ['aria-colindex', {
    type: 'integer'
  }], ['aria-colspan', {
    type: 'integer'
  }], ['aria-controls', {
    'type': 'idlist'
  }], ['aria-current', {
    type: 'token',
    values: ['page', 'step', 'location', 'date', 'time', true, false]
  }], ['aria-describedby', {
    'type': 'idlist'
  }], ['aria-details', {
    'type': 'id'
  }], ['aria-disabled', {
    'type': 'boolean'
  }], ['aria-dropeffect', {
    'type': 'tokenlist',
    'values': ['copy', 'execute', 'link', 'move', 'none', 'popup']
  }], ['aria-errormessage', {
    'type': 'id'
  }], ['aria-expanded', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-flowto', {
    'type': 'idlist'
  }], ['aria-grabbed', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-haspopup', {
    'type': 'token',
    'values': [false, true, 'menu', 'listbox', 'tree', 'grid', 'dialog']
  }], ['aria-hidden', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-invalid', {
    'type': 'token',
    'values': ['grammar', false, 'spelling', true]
  }], ['aria-keyshortcuts', {
    type: 'string'
  }], ['aria-label', {
    'type': 'string'
  }], ['aria-labelledby', {
    'type': 'idlist'
  }], ['aria-level', {
    'type': 'integer'
  }], ['aria-live', {
    'type': 'token',
    'values': ['assertive', 'off', 'polite']
  }], ['aria-modal', {
    type: 'boolean'
  }], ['aria-multiline', {
    'type': 'boolean'
  }], ['aria-multiselectable', {
    'type': 'boolean'
  }], ['aria-orientation', {
    'type': 'token',
    'values': ['vertical', 'undefined', 'horizontal']
  }], ['aria-owns', {
    'type': 'idlist'
  }], ['aria-placeholder', {
    type: 'string'
  }], ['aria-posinset', {
    'type': 'integer'
  }], ['aria-pressed', {
    'type': 'tristate'
  }], ['aria-readonly', {
    'type': 'boolean'
  }], ['aria-relevant', {
    'type': 'tokenlist',
    'values': ['additions', 'all', 'removals', 'text']
  }], ['aria-required', {
    'type': 'boolean'
  }], ['aria-roledescription', {
    type: 'string'
  }], ['aria-rowcount', {
    type: 'integer'
  }], ['aria-rowindex', {
    type: 'integer'
  }], ['aria-rowspan', {
    type: 'integer'
  }], ['aria-selected', {
    'type': 'boolean',
    'allowundefined': true
  }], ['aria-setsize', {
    'type': 'integer'
  }], ['aria-sort', {
    'type': 'token',
    'values': ['ascending', 'descending', 'none', 'other']
  }], ['aria-valuemax', {
    'type': 'number'
  }], ['aria-valuemin', {
    'type': 'number'
  }], ['aria-valuenow', {
    'type': 'number'
  }], ['aria-valuetext', {
    'type': 'string'
  }]]);
  var _default = ariaPropsMap;
  exports.default = _default;
});
unwrapExports(ariaPropsMap_1);
var domMap_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _map = interopRequireDefault(map$2);
  var domMap = new _map.default([['a', {
    reserved: false
  }], ['abbr', {
    reserved: false
  }], ['acronym', {
    reserved: false
  }], ['address', {
    reserved: false
  }], ['applet', {
    reserved: false
  }], ['area', {
    reserved: false
  }], ['article', {
    reserved: false
  }], ['aside', {
    reserved: false
  }], ['audio', {
    reserved: false
  }], ['b', {
    reserved: false
  }], ['base', {
    reserved: true
  }], ['bdi', {
    reserved: false
  }], ['bdo', {
    reserved: false
  }], ['big', {
    reserved: false
  }], ['blink', {
    reserved: false
  }], ['blockquote', {
    reserved: false
  }], ['body', {
    reserved: false
  }], ['br', {
    reserved: false
  }], ['button', {
    reserved: false
  }], ['canvas', {
    reserved: false
  }], ['caption', {
    reserved: false
  }], ['center', {
    reserved: false
  }], ['cite', {
    reserved: false
  }], ['code', {
    reserved: false
  }], ['col', {
    reserved: true
  }], ['colgroup', {
    reserved: true
  }], ['content', {
    reserved: false
  }], ['data', {
    reserved: false
  }], ['datalist', {
    reserved: false
  }], ['dd', {
    reserved: false
  }], ['del', {
    reserved: false
  }], ['details', {
    reserved: false
  }], ['dfn', {
    reserved: false
  }], ['dialog', {
    reserved: false
  }], ['dir', {
    reserved: false
  }], ['div', {
    reserved: false
  }], ['dl', {
    reserved: false
  }], ['dt', {
    reserved: false
  }], ['em', {
    reserved: false
  }], ['embed', {
    reserved: false
  }], ['fieldset', {
    reserved: false
  }], ['figcaption', {
    reserved: false
  }], ['figure', {
    reserved: false
  }], ['font', {
    reserved: false
  }], ['footer', {
    reserved: false
  }], ['form', {
    reserved: false
  }], ['frame', {
    reserved: false
  }], ['frameset', {
    reserved: false
  }], ['h1', {
    reserved: false
  }], ['h2', {
    reserved: false
  }], ['h3', {
    reserved: false
  }], ['h4', {
    reserved: false
  }], ['h5', {
    reserved: false
  }], ['h6', {
    reserved: false
  }], ['head', {
    reserved: true
  }], ['header', {
    reserved: false
  }], ['hgroup', {
    reserved: false
  }], ['hr', {
    reserved: false
  }], ['html', {
    reserved: true
  }], ['i', {
    reserved: false
  }], ['iframe', {
    reserved: false
  }], ['img', {
    reserved: false
  }], ['input', {
    reserved: false
  }], ['ins', {
    reserved: false
  }], ['kbd', {
    reserved: false
  }], ['keygen', {
    reserved: false
  }], ['label', {
    reserved: false
  }], ['legend', {
    reserved: false
  }], ['li', {
    reserved: false
  }], ['link', {
    reserved: true
  }], ['main', {
    reserved: false
  }], ['map', {
    reserved: false
  }], ['mark', {
    reserved: false
  }], ['marquee', {
    reserved: false
  }], ['menu', {
    reserved: false
  }], ['menuitem', {
    reserved: false
  }], ['meta', {
    reserved: true
  }], ['meter', {
    reserved: false
  }], ['nav', {
    reserved: false
  }], ['noembed', {
    reserved: true
  }], ['noscript', {
    reserved: true
  }], ['object', {
    reserved: false
  }], ['ol', {
    reserved: false
  }], ['optgroup', {
    reserved: false
  }], ['option', {
    reserved: false
  }], ['output', {
    reserved: false
  }], ['p', {
    reserved: false
  }], ['param', {
    reserved: true
  }], ['picture', {
    reserved: true
  }], ['pre', {
    reserved: false
  }], ['progress', {
    reserved: false
  }], ['q', {
    reserved: false
  }], ['rp', {
    reserved: false
  }], ['rt', {
    reserved: false
  }], ['rtc', {
    reserved: false
  }], ['ruby', {
    reserved: false
  }], ['s', {
    reserved: false
  }], ['samp', {
    reserved: false
  }], ['script', {
    reserved: true
  }], ['section', {
    reserved: false
  }], ['select', {
    reserved: false
  }], ['small', {
    reserved: false
  }], ['source', {
    reserved: true
  }], ['spacer', {
    reserved: false
  }], ['span', {
    reserved: false
  }], ['strike', {
    reserved: false
  }], ['strong', {
    reserved: false
  }], ['style', {
    reserved: true
  }], ['sub', {
    reserved: false
  }], ['summary', {
    reserved: false
  }], ['sup', {
    reserved: false
  }], ['table', {
    reserved: false
  }], ['tbody', {
    reserved: false
  }], ['td', {
    reserved: false
  }], ['textarea', {
    reserved: false
  }], ['tfoot', {
    reserved: false
  }], ['th', {
    reserved: false
  }], ['thead', {
    reserved: false
  }], ['time', {
    reserved: false
  }], ['title', {
    reserved: true
  }], ['tr', {
    reserved: false
  }], ['track', {
    reserved: true
  }], ['tt', {
    reserved: false
  }], ['u', {
    reserved: false
  }], ['ul', {
    reserved: false
  }], ['var', {
    reserved: false
  }], ['video', {
    reserved: false
  }], ['wbr', {
    reserved: false
  }], ['xmp', {
    reserved: false
  }]]);
  var _default = domMap;
  exports.default = _default;
});
unwrapExports(domMap_1);
var getIterator = function getIterator(it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  }
  return anObject(iteratorMethod.call(it));
};
var getIterator_1 = getIterator;
var getIterator$1 = getIterator_1;

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
_export({
  target: 'Array',
  stat: true
}, {
  isArray: isArray
});
var isArray$1 = path.Array.isArray;
var isArray$2 = isArray$1;
var isArray$3 = isArray$2;
var getIteratorMethod_1 = getIteratorMethod;
var getIteratorMethod$1 = getIteratorMethod_1;
var createProperty = function createProperty(object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};
var SPECIES$2 = wellKnownSymbol('species');
var arrayMethodHasSpeciesSupport = function arrayMethodHasSpeciesSupport(METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$2] = function () {
      return {
        foo: 1
      };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};
var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');
var isConcatSpreadable = function isConcatSpreadable(O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};
var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({
  target: 'Array',
  proto: true,
  forced: FORCED
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength$1(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});
var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};
var objectGetOwnPropertyNames = {
  f: f$4
};

/* eslint-disable es/no-object-getownpropertynames -- safe */

var $getOwnPropertyNames = objectGetOwnPropertyNames.f;
var toString$1 = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function getWindowNames(it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
};
var objectGetOwnPropertyNamesExternal = {
  f: f$5
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$6 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$6
};
var f$7 = wellKnownSymbol;
var wellKnownSymbolWrapped = {
  f: f$7
};
var defineProperty$5 = objectDefineProperty.f;
var defineWellKnownSymbol = function defineWellKnownSymbol(NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty$5(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};
var $forEach = arrayIteration.forEach;
var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState$4 = internalState.set;
var getInternalState$2 = internalState.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');
var QObject = global_1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty({}, 'a', {
    get: function get() {
      return nativeDefineProperty(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;
var wrap = function wrap(tag, description) {
  var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
  setInternalState$4(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};
var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};
var $defineProperty$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, {
        enumerable: createPropertyDescriptor(0, false)
      });
    }
    return setSymbolDescriptor(O, key, Attributes);
  }
  return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!descriptors || $propertyIsEnumerable$1.call(properties, key)) $defineProperty$1(O, key, properties[key]);
  });
  return O;
};
var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};
var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype$1 && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype$1 && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};
var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype$1, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function setter(value) {
      if (this === ObjectPrototype$1) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, {
      configurable: true,
      set: setter
    });
    return wrap(tag, description);
  };
  redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
    return getInternalState$2(this).tag;
  });
  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });
  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty$1;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;
  wellKnownSymbolWrapped.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };
  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE$1], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });
  }
}
_export({
  global: true,
  wrap: true,
  forced: !nativeSymbol,
  sham: !nativeSymbol
}, {
  Symbol: $Symbol
});
$forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol(name);
});
_export({
  target: SYMBOL,
  stat: true,
  forced: !nativeSymbol
}, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function _for(key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function useSetter() {
    USE_SETTER = true;
  },
  useSimple: function useSimple() {
    USE_SETTER = false;
  }
});
_export({
  target: 'Object',
  stat: true,
  forced: !nativeSymbol,
  sham: !descriptors
}, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
});
_export({
  target: 'Object',
  stat: true,
  forced: !nativeSymbol
}, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({
  target: 'Object',
  stat: true,
  forced: fails(function () {
    objectGetOwnPropertySymbols.f(1);
  })
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({
      a: symbol
    }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
  });
  _export({
    target: 'JSON',
    stat: true,
    forced: FORCED_JSON_STRINGIFY
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function replacer(key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global_1.JSON, 'JSON', true);
var symbol = path.Symbol;
var symbol$1 = symbol;
var symbol$2 = symbol$1;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function callWithSafeIterationClosing(iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (; !(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength$1(O.length);
    result = new C(length);
    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};
var ITERATOR$4 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function next() {
      return {
        done: !!called++
      };
    },
    'return': function _return() {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {/* empty */}
var checkCorrectnessOfIteration = function checkCorrectnessOfIteration(exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function () {
      return {
        next: function next() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };
    exec(object);
  } catch (error) {/* empty */}
  return ITERATION_SUPPORT;
};
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({
  target: 'Array',
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  from: arrayFrom$1
});
var from_1 = path.Array.from;
var from_1$1 = from_1;
var from_1$2 = from_1$1;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var SPECIES$3 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$1 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength$1(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$3];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});
var entryVirtual = function entryVirtual(CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};
var slice = entryVirtual('Array').slice;
var ArrayPrototype$1 = Array.prototype;
var slice_1 = function slice_1(it) {
  var own = it.slice;
  return it === ArrayPrototype$1 || it instanceof Array && own === ArrayPrototype$1.slice ? slice : own;
};
var slice$1 = slice_1;
var slice$2 = slice$1;
var defineProperty$6 = defineProperty_1;
var defineProperty$7 = defineProperty$6;
var defineProperty$8 = createCommonjsModule(function (module) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      defineProperty$7(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(defineProperty$8);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$9 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({
    b: 1
  }, $assign(defineProperty$9({}, 'a', {
    enumerable: true,
    get: function get() {
      defineProperty$9(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({
  target: 'Object',
  stat: true,
  forced: Object.assign !== objectAssign
}, {
  assign: objectAssign
});
var assign = path.Object.assign;
var assign$1 = assign;
var assign$2 = assign$1;
var FAILS_ON_PRIMITIVES = fails(function () {
  objectKeys(1);
});

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES
}, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});
var keys$1 = path.Object.keys;
var keys$2 = keys$1;
var keys$3 = keys$2;
var arrayMethodIsStrict = function arrayMethodIsStrict(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () {
      throw 1;
    }, 1);
  });
};
var $forEach$1 = arrayIteration.forEach;
var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({
  target: 'Array',
  proto: true,
  forced: [].forEach != arrayForEach
}, {
  forEach: arrayForEach
});
var forEach$1 = entryVirtual('Array').forEach;
var forEach$2 = forEach$1;
var ArrayPrototype$2 = Array.prototype;
var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};
var forEach_1 = function forEach_1(it) {
  var own = it.forEach;
  return it === ArrayPrototype$2 || it instanceof Array && own === ArrayPrototype$2.forEach
  // eslint-disable-next-line no-prototype-builtins -- safe
  || DOMIterables.hasOwnProperty(classof(it)) ? forEach$2 : own;
};
var forEach$3 = forEach_1;
var commandRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var commandRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = commandRole;
  exports.default = _default;
});
unwrapExports(commandRole_1);
var compositeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var compositeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = compositeRole;
  exports.default = _default;
});
unwrapExports(compositeRole_1);
var inputRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var inputRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null
    },
    relatedConcepts: [{
      concept: {
        name: 'input'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget']]
  };
  var _default = inputRole;
  exports.default = _default;
});
unwrapExports(inputRole_1);
var landmarkRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var landmarkRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = landmarkRole;
  exports.default = _default;
});
unwrapExports(landmarkRole_1);
var rangeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var rangeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-valuemax': null,
      'aria-valuemin': null,
      'aria-valuenow': null,
      'aria-valuetext': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = rangeRole;
  exports.default = _default;
});
unwrapExports(rangeRole_1);
var roletypeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var roletypeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {
      'aria-atomic': null,
      'aria-busy': null,
      'aria-controls': null,
      'aria-current': null,
      'aria-describedby': null,
      'aria-details': null,
      'aria-dropeffect': null,
      'aria-flowto': null,
      'aria-grabbed': null,
      'aria-hidden': null,
      'aria-keyshortcuts': null,
      'aria-label': null,
      'aria-labelledby': null,
      'aria-live': null,
      'aria-owns': null,
      'aria-relevant': null,
      'aria-roledescription': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rel'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'role'
      },
      module: 'XHTML'
    }, {
      concept: {
        name: 'type'
      },
      module: 'Dublin Core'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  };
  var _default = roletypeRole;
  exports.default = _default;
});
unwrapExports(roletypeRole_1);
var sectionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var sectionRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'frontmatter'
      },
      module: 'DTB'
    }, {
      concept: {
        name: 'level'
      },
      module: 'DTB'
    }, {
      concept: {
        name: 'level'
      },
      module: 'SMIL'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = sectionRole;
  exports.default = _default;
});
unwrapExports(sectionRole_1);
var sectionheadRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var sectionheadRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = sectionheadRole;
  exports.default = _default;
});
unwrapExports(sectionheadRole_1);
var selectRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var selectRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'group']]
  };
  var _default = selectRole;
  exports.default = _default;
});
unwrapExports(selectRole_1);
var structureRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var structureRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = structureRole;
  exports.default = _default;
});
unwrapExports(structureRole_1);
var widgetRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var widgetRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = widgetRole;
  exports.default = _default;
});
unwrapExports(widgetRole_1);
var windowRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var windowRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-modal': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype']]
  };
  var _default = windowRole;
  exports.default = _default;
});
unwrapExports(windowRole_1);
var ariaAbstractRoles_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _map = interopRequireDefault(map$2);
  var _commandRole = interopRequireDefault(commandRole_1);
  var _compositeRole = interopRequireDefault(compositeRole_1);
  var _inputRole = interopRequireDefault(inputRole_1);
  var _landmarkRole = interopRequireDefault(landmarkRole_1);
  var _rangeRole = interopRequireDefault(rangeRole_1);
  var _roletypeRole = interopRequireDefault(roletypeRole_1);
  var _sectionRole = interopRequireDefault(sectionRole_1);
  var _sectionheadRole = interopRequireDefault(sectionheadRole_1);
  var _selectRole = interopRequireDefault(selectRole_1);
  var _structureRole = interopRequireDefault(structureRole_1);
  var _widgetRole = interopRequireDefault(widgetRole_1);
  var _windowRole = interopRequireDefault(windowRole_1);
  var ariaAbstractRoles = new _map.default([['command', _commandRole.default], ['composite', _compositeRole.default], ['input', _inputRole.default], ['landmark', _landmarkRole.default], ['range', _rangeRole.default], ['roletype', _roletypeRole.default], ['section', _sectionRole.default], ['sectionhead', _sectionheadRole.default], ['select', _selectRole.default], ['structure', _structureRole.default], ['widget', _widgetRole.default], ['window', _windowRole.default]]);
  var _default = ariaAbstractRoles;
  exports.default = _default;
});
unwrapExports(ariaAbstractRoles_1);
var alertRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var alertRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-atomic': 'true',
      'aria-live': 'assertive'
    },
    relatedConcepts: [{
      concept: {
        name: 'alert'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = alertRole;
  exports.default = _default;
});
unwrapExports(alertRole_1);
var alertdialogRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var alertdialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'alert'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'alert'], ['roletype', 'window', 'dialog']]
  };
  var _default = alertdialogRole;
  exports.default = _default;
});
unwrapExports(alertdialogRole_1);
var applicationRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var applicationRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'Device Independence Delivery Unit'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = applicationRole;
  exports.default = _default;
});
unwrapExports(applicationRole_1);
var articleRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var articleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'article'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'document']]
  };
  var _default = articleRole;
  exports.default = _default;
});
unwrapExports(articleRole_1);
var bannerRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var bannerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of document'],
        name: 'header'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = bannerRole;
  exports.default = _default;
});
unwrapExports(bannerRole_1);
var blockquoteRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var blockquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = blockquoteRole;
  exports.default = _default;
});
unwrapExports(blockquoteRole_1);
var buttonRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var buttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-pressed': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-pressed'
        }, {
          name: 'type',
          value: 'checkbox'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'aria-expanded',
          value: 'false'
        }],
        name: 'summary'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'aria-expanded',
          value: 'true'
        }],
        constraints: ['direct descendant of details element with the open attribute defined'],
        name: 'summary'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'button'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'image'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'reset'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'type',
          value: 'submit'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'button'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'trigger'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = buttonRole;
  exports.default = _default;
});
unwrapExports(buttonRole_1);
var captionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var captionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: ['figure', 'grid', 'table'],
    requiredContextRole: ['figure', 'grid', 'table'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = captionRole;
  exports.default = _default;
});
unwrapExports(captionRole_1);
var cellRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var cellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-colindex': null,
      'aria-colspan': null,
      'aria-rowindex': null,
      'aria-rowspan': null
    },
    relatedConcepts: [{
      concept: {
        constraints: ['descendant of table'],
        name: 'td'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = cellRole;
  exports.default = _default;
});
unwrapExports(cellRole_1);
var checkboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var checkboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'checkbox'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'option'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = checkboxRole;
  exports.default = _default;
});
unwrapExports(checkboxRole_1);
var codeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var codeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = codeRole;
  exports.default = _default;
});
unwrapExports(codeRole_1);
var columnheaderRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var columnheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-sort': null
    },
    relatedConcepts: [{
      attributes: [{
        name: 'scope',
        value: 'col'
      }],
      concept: {
        name: 'th'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
  };
  var _default = columnheaderRole;
  exports.default = _default;
});
unwrapExports(columnheaderRole_1);
var comboboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var comboboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-autocomplete': null,
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-expanded': 'false',
      'aria-haspopup': 'listbox'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'email'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'search'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'tel'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'text'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'multiple'
        }, {
          constraints: ['undefined'],
          name: 'size'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'multiple'
        }, {
          name: 'size',
          value: 1
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-controls': null,
      'aria-expanded': 'false'
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = comboboxRole;
  exports.default = _default;
});
unwrapExports(comboboxRole_1);
var complementaryRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var complementaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'aside'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = complementaryRole;
  exports.default = _default;
});
unwrapExports(complementaryRole_1);
var contentinfoRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var contentinfoRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of document'],
        name: 'footer'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = contentinfoRole;
  exports.default = _default;
});
unwrapExports(contentinfoRole_1);
var definitionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var definitionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dd'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = definitionRole;
  exports.default = _default;
});
unwrapExports(definitionRole_1);
var deletionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var deletionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = deletionRole;
  exports.default = _default;
});
unwrapExports(deletionRole_1);
var dialogRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var dialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dialog'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'window']]
  };
  var _default = dialogRole;
  exports.default = _default;
});
unwrapExports(dialogRole_1);
var directoryRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var directoryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      module: 'DAISY Guide'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'list']]
  };
  var _default = directoryRole;
  exports.default = _default;
});
unwrapExports(directoryRole_1);
var documentRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var documentRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'Device Independence Delivery Unit'
      }
    }, {
      concept: {
        name: 'body'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = documentRole;
  exports.default = _default;
});
unwrapExports(documentRole_1);
var emphasisRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var emphasisRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = emphasisRole;
  exports.default = _default;
});
unwrapExports(emphasisRole_1);
var feedRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var feedRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['article']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'list']]
  };
  var _default = feedRole;
  exports.default = _default;
});
unwrapExports(feedRole_1);
var figureRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var figureRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'figure'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = figureRole;
  exports.default = _default;
});
unwrapExports(figureRole_1);
var formRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var formRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-label'
        }],
        name: 'form'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-labelledby'
        }],
        name: 'form'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'name'
        }],
        name: 'form'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = formRole;
  exports.default = _default;
});
unwrapExports(formRole_1);
var genericRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var genericRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'span'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'div'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = genericRole;
  exports.default = _default;
});
unwrapExports(genericRole_1);
var gridRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var gridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-multiselectable': null,
      'aria-readonly': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'role',
          value: 'grid'
        }],
        name: 'table'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'table']]
  };
  var _default = gridRole;
  exports.default = _default;
});
unwrapExports(gridRole_1);
var gridcellRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var gridcellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-selected': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'role',
          value: 'gridcell'
        }],
        name: 'td'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'widget']]
  };
  var _default = gridcellRole;
  exports.default = _default;
});
unwrapExports(gridcellRole_1);
var groupRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var groupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-disabled': null
    },
    relatedConcepts: [{
      concept: {
        name: 'details'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'fieldset'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'optgroup'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = groupRole;
  exports.default = _default;
});
unwrapExports(groupRole_1);
var headingRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var headingRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-level': null
    },
    relatedConcepts: [{
      concept: {
        name: 'h1'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h2'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h3'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h4'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h5'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'h6'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-level': 2
    },
    superClass: [['roletype', 'structure', 'sectionhead']]
  };
  var _default = headingRole;
  exports.default = _default;
});
unwrapExports(headingRole_1);
var imgRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var imgRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'alt'
        }],
        name: 'img'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'alt'
        }],
        name: 'img'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'imggroup'
      },
      module: 'DTB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = imgRole;
  exports.default = _default;
});
unwrapExports(imgRole_1);
var insertionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var insertionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = insertionRole;
  exports.default = _default;
});
unwrapExports(insertionRole_1);
var linkRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var linkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'a'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'area'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'href'
        }],
        name: 'link'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = linkRole;
  exports.default = _default;
});
unwrapExports(linkRole_1);
var listRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var listRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menu'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'ol'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'ul'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['listitem']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = listRole;
  exports.default = _default;
});
unwrapExports(listRole_1);
var listboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var listboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-invalid': null,
      'aria-multiselectable': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['>1'],
          name: 'size'
        }, {
          name: 'multiple'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['>1'],
          name: 'size'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          name: 'multiple'
        }],
        name: 'select'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'datalist'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['option', 'group'], ['option']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = listboxRole;
  exports.default = _default;
});
unwrapExports(listboxRole_1);
var listitemRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var listitemRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-level': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        constraints: ['direct descendant of ol, ul or menu'],
        name: 'li'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'item'
      },
      module: 'XForms'
    }],
    requireContextRole: ['directory', 'list'],
    requiredContextRole: ['directory', 'list'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = listitemRole;
  exports.default = _default;
});
unwrapExports(listitemRole_1);
var logRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var logRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-live': 'polite'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = logRole;
  exports.default = _default;
});
unwrapExports(logRole_1);
var mainRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var mainRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'main'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = mainRole;
  exports.default = _default;
});
unwrapExports(mainRole_1);
var marqueeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var marqueeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = marqueeRole;
  exports.default = _default;
});
unwrapExports(marqueeRole_1);
var mathRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var mathRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'math'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = mathRole;
  exports.default = _default;
});
unwrapExports(mathRole_1);
var menuRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var menuRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [{
      concept: {
        name: 'MENU'
      },
      module: 'JAPI'
    }, {
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'select'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'sidebar'
      },
      module: 'DTB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = menuRole;
  exports.default = _default;
});
unwrapExports(menuRole_1);
var menubarRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var menubarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      concept: {
        name: 'toolbar'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select', 'menu'], ['roletype', 'structure', 'section', 'group', 'select', 'menu']]
  };
  var _default = menubarRole;
  exports.default = _default;
});
unwrapExports(menubarRole_1);
var menuitemRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var menuitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'MENU_ITEM'
      },
      module: 'JAPI'
    }, {
      concept: {
        name: 'listitem'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'menuitem'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'option'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command']]
  };
  var _default = menuitemRole;
  exports.default = _default;
});
unwrapExports(menuitemRole_1);
var menuitemcheckboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var menuitemcheckboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox'], ['roletype', 'widget', 'command', 'menuitem']]
  };
  var _default = menuitemcheckboxRole;
  exports.default = _default;
});
unwrapExports(menuitemcheckboxRole_1);
var menuitemradioRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var menuitemradioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'menuitem'
      },
      module: 'ARIA'
    }],
    requireContextRole: ['group', 'menu', 'menubar'],
    requiredContextRole: ['group', 'menu', 'menubar'],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox', 'menuitemcheckbox'], ['roletype', 'widget', 'command', 'menuitem', 'menuitemcheckbox'], ['roletype', 'widget', 'input', 'radio']]
  };
  var _default = menuitemradioRole;
  exports.default = _default;
});
unwrapExports(menuitemradioRole_1);
var meterRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var meterRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-valuemax': null,
      'aria-valuemin': null,
      'aria-valuenow': null
    },
    superClass: [['roletype', 'structure', 'range']]
  };
  var _default = meterRole;
  exports.default = _default;
});
unwrapExports(meterRole_1);
var navigationRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var navigationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'nav'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = navigationRole;
  exports.default = _default;
});
unwrapExports(navigationRole_1);
var noneRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var noneRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  };
  var _default = noneRole;
  exports.default = _default;
});
unwrapExports(noneRole_1);
var noteRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var noteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = noteRole;
  exports.default = _default;
});
unwrapExports(noteRole_1);
var optionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var optionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-posinset': null,
      'aria-setsize': null,
      'aria-selected': 'false'
    },
    relatedConcepts: [{
      concept: {
        name: 'item'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'listitem'
      },
      module: 'ARIA'
    }, {
      concept: {
        name: 'option'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-selected': 'false'
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = optionRole;
  exports.default = _default;
});
unwrapExports(optionRole_1);
var paragraphRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var paragraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = paragraphRole;
  exports.default = _default;
});
unwrapExports(paragraphRole_1);
var presentationRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var presentationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = presentationRole;
  exports.default = _default;
});
unwrapExports(presentationRole_1);
var progressbarRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var progressbarRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'progress'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'status'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
  };
  var _default = progressbarRole;
  exports.default = _default;
});
unwrapExports(progressbarRole_1);
var radioRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var radioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-checked': null,
      'aria-posinset': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'radio'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = radioRole;
  exports.default = _default;
});
unwrapExports(radioRole_1);
var radiogroupRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var radiogroupRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        name: 'list'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['radio']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = radiogroupRole;
  exports.default = _default;
});
unwrapExports(radiogroupRole_1);
var regionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var regionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-label'
        }],
        name: 'section'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['set'],
          name: 'aria-labelledby'
        }],
        name: 'section'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'Device Independence Glossart perceivable unit'
      }
    }, {
      concept: {
        name: 'frame'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = regionRole;
  exports.default = _default;
});
unwrapExports(regionRole_1);
var rowRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var rowRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-colindex': null,
      'aria-expanded': null,
      'aria-level': null,
      'aria-posinset': null,
      'aria-rowindex': null,
      'aria-selected': null,
      'aria-setsize': null
    },
    relatedConcepts: [{
      concept: {
        name: 'tr'
      },
      module: 'HTML'
    }],
    requireContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
    requiredContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
    requiredOwnedElements: [['cell'], ['columnheader'], ['gridcell'], ['rowheader']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'group'], ['roletype', 'widget']]
  };
  var _default = rowRole;
  exports.default = _default;
});
unwrapExports(rowRole_1);
var rowgroupRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var rowgroupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'tbody'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'tfoot'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'thead'
      },
      module: 'HTML'
    }],
    requireContextRole: ['grid', 'table', 'treegrid'],
    requiredContextRole: ['grid', 'table', 'treegrid'],
    requiredOwnedElements: [['row']],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = rowgroupRole;
  exports.default = _default;
});
unwrapExports(rowgroupRole_1);
var rowheaderRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var rowheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-sort': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'scope',
          value: 'row'
        }],
        name: 'th'
      },
      module: 'HTML'
    }],
    requireContextRole: ['row'],
    requiredContextRole: ['row'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
  };
  var _default = rowheaderRole;
  exports.default = _default;
});
unwrapExports(rowheaderRole_1);
var scrollbarRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var scrollbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-orientation': 'vertical',
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-controls': null,
      'aria-valuenow': null
    },
    superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
  };
  var _default = scrollbarRole;
  exports.default = _default;
});
unwrapExports(scrollbarRole_1);
var searchRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var searchRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = searchRole;
  exports.default = _default;
});
unwrapExports(searchRole_1);
var searchboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var searchboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'search'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'input', 'textbox']]
  };
  var _default = searchboxRole;
  exports.default = _default;
});
unwrapExports(searchboxRole_1);
var separatorRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var separatorRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-valuetext': null,
      'aria-orientation': 'horizontal',
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [{
      concept: {
        name: 'hr'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure']]
  };
  var _default = separatorRole;
  exports.default = _default;
});
unwrapExports(separatorRole_1);
var sliderRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var sliderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-orientation': 'horizontal',
      'aria-valuemax': '100',
      'aria-valuemin': '0'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'range'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-valuenow': null
    },
    superClass: [['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
  };
  var _default = sliderRole;
  exports.default = _default;
});
unwrapExports(sliderRole_1);
var spinbuttonRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var spinbuttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-readonly': null,
      'aria-required': null,
      'aria-valuenow': '0'
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: 'type',
          value: 'number'
        }],
        name: 'input'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite'], ['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
  };
  var _default = spinbuttonRole;
  exports.default = _default;
});
unwrapExports(spinbuttonRole_1);
var statusRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var statusRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-atomic': 'true',
      'aria-live': 'polite'
    },
    relatedConcepts: [{
      concept: {
        name: 'output'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = statusRole;
  exports.default = _default;
});
unwrapExports(statusRole_1);
var strongRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var strongRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = strongRole;
  exports.default = _default;
});
unwrapExports(strongRole_1);
var subscriptRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var subscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = subscriptRole;
  exports.default = _default;
});
unwrapExports(subscriptRole_1);
var superscriptRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var superscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['prohibited'],
    prohibitedProps: ['aria-label', 'aria-labelledby'],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = superscriptRole;
  exports.default = _default;
});
unwrapExports(superscriptRole_1);
var switchRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var switchRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'button'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      'aria-checked': null
    },
    superClass: [['roletype', 'widget', 'input', 'checkbox']]
  };
  var _default = switchRole;
  exports.default = _default;
});
unwrapExports(switchRole_1);
var tabRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var tabRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-posinset': null,
      'aria-setsize': null,
      'aria-selected': 'false'
    },
    relatedConcepts: [],
    requireContextRole: ['tablist'],
    requiredContextRole: ['tablist'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'sectionhead'], ['roletype', 'widget']]
  };
  var _default = tabRole;
  exports.default = _default;
});
unwrapExports(tabRole_1);
var tableRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var tableRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-colcount': null,
      'aria-rowcount': null
    },
    relatedConcepts: [{
      concept: {
        name: 'table'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tableRole;
  exports.default = _default;
});
unwrapExports(tableRole_1);
var tablistRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var tablistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-level': null,
      'aria-multiselectable': null,
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      module: 'DAISY',
      concept: {
        name: 'guide'
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['tab']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite']]
  };
  var _default = tablistRole;
  exports.default = _default;
});
unwrapExports(tablistRole_1);
var tabpanelRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var tabpanelRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tabpanelRole;
  exports.default = _default;
});
unwrapExports(tabpanelRole_1);
var termRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var termRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'dfn'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = termRole;
  exports.default = _default;
});
unwrapExports(termRole_1);
var textboxRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var textboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-activedescendant': null,
      'aria-autocomplete': null,
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null,
      'aria-multiline': null,
      'aria-placeholder': null,
      'aria-readonly': null,
      'aria-required': null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'type'
        }, {
          constraints: ['undefined'],
          name: 'list'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'email'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'tel'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'text'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        attributes: [{
          constraints: ['undefined'],
          name: 'list'
        }, {
          name: 'type',
          value: 'url'
        }],
        name: 'input'
      },
      module: 'HTML'
    }, {
      concept: {
        name: 'input'
      },
      module: 'XForms'
    }, {
      concept: {
        name: 'textarea'
      },
      module: 'HTML'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'input']]
  };
  var _default = textboxRole;
  exports.default = _default;
});
unwrapExports(textboxRole_1);
var timeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var timeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = timeRole;
  exports.default = _default;
});
unwrapExports(timeRole_1);
var timerRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var timerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'status']]
  };
  var _default = timerRole;
  exports.default = _default;
});
unwrapExports(timerRole_1);
var toolbarRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var toolbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-orientation': 'horizontal'
    },
    relatedConcepts: [{
      concept: {
        name: 'menubar'
      },
      module: 'ARIA'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'group']]
  };
  var _default = toolbarRole;
  exports.default = _default;
});
unwrapExports(toolbarRole_1);
var tooltipRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var tooltipRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = tooltipRole;
  exports.default = _default;
});
unwrapExports(tooltipRole_1);
var treeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var treeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-invalid': null,
      'aria-multiselectable': null,
      'aria-required': null,
      'aria-orientation': 'vertical'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['treeitem', 'group'], ['treeitem']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
  };
  var _default = treeRole;
  exports.default = _default;
});
unwrapExports(treeRole_1);
var treegridRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var treegridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['row'], ['row', 'rowgroup']],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'composite', 'grid'], ['roletype', 'structure', 'section', 'table', 'grid'], ['roletype', 'widget', 'composite', 'select', 'tree'], ['roletype', 'structure', 'section', 'group', 'select', 'tree']]
  };
  var _default = treegridRole;
  exports.default = _default;
});
unwrapExports(treegridRole_1);
var treeitemRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var treeitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-expanded': null,
      'aria-haspopup': null
    },
    relatedConcepts: [],
    requireContextRole: ['group', 'tree'],
    requiredContextRole: ['group', 'tree'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'listitem'], ['roletype', 'widget', 'input', 'option']]
  };
  var _default = treeitemRole;
  exports.default = _default;
});
unwrapExports(treeitemRole_1);
var ariaLiteralRoles_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _map = interopRequireDefault(map$2);
  var _alertRole = interopRequireDefault(alertRole_1);
  var _alertdialogRole = interopRequireDefault(alertdialogRole_1);
  var _applicationRole = interopRequireDefault(applicationRole_1);
  var _articleRole = interopRequireDefault(articleRole_1);
  var _bannerRole = interopRequireDefault(bannerRole_1);
  var _blockquoteRole = interopRequireDefault(blockquoteRole_1);
  var _buttonRole = interopRequireDefault(buttonRole_1);
  var _captionRole = interopRequireDefault(captionRole_1);
  var _cellRole = interopRequireDefault(cellRole_1);
  var _checkboxRole = interopRequireDefault(checkboxRole_1);
  var _codeRole = interopRequireDefault(codeRole_1);
  var _columnheaderRole = interopRequireDefault(columnheaderRole_1);
  var _comboboxRole = interopRequireDefault(comboboxRole_1);
  var _complementaryRole = interopRequireDefault(complementaryRole_1);
  var _contentinfoRole = interopRequireDefault(contentinfoRole_1);
  var _definitionRole = interopRequireDefault(definitionRole_1);
  var _deletionRole = interopRequireDefault(deletionRole_1);
  var _dialogRole = interopRequireDefault(dialogRole_1);
  var _directoryRole = interopRequireDefault(directoryRole_1);
  var _documentRole = interopRequireDefault(documentRole_1);
  var _emphasisRole = interopRequireDefault(emphasisRole_1);
  var _feedRole = interopRequireDefault(feedRole_1);
  var _figureRole = interopRequireDefault(figureRole_1);
  var _formRole = interopRequireDefault(formRole_1);
  var _genericRole = interopRequireDefault(genericRole_1);
  var _gridRole = interopRequireDefault(gridRole_1);
  var _gridcellRole = interopRequireDefault(gridcellRole_1);
  var _groupRole = interopRequireDefault(groupRole_1);
  var _headingRole = interopRequireDefault(headingRole_1);
  var _imgRole = interopRequireDefault(imgRole_1);
  var _insertionRole = interopRequireDefault(insertionRole_1);
  var _linkRole = interopRequireDefault(linkRole_1);
  var _listRole = interopRequireDefault(listRole_1);
  var _listboxRole = interopRequireDefault(listboxRole_1);
  var _listitemRole = interopRequireDefault(listitemRole_1);
  var _logRole = interopRequireDefault(logRole_1);
  var _mainRole = interopRequireDefault(mainRole_1);
  var _marqueeRole = interopRequireDefault(marqueeRole_1);
  var _mathRole = interopRequireDefault(mathRole_1);
  var _menuRole = interopRequireDefault(menuRole_1);
  var _menubarRole = interopRequireDefault(menubarRole_1);
  var _menuitemRole = interopRequireDefault(menuitemRole_1);
  var _menuitemcheckboxRole = interopRequireDefault(menuitemcheckboxRole_1);
  var _menuitemradioRole = interopRequireDefault(menuitemradioRole_1);
  var _meterRole = interopRequireDefault(meterRole_1);
  var _navigationRole = interopRequireDefault(navigationRole_1);
  var _noneRole = interopRequireDefault(noneRole_1);
  var _noteRole = interopRequireDefault(noteRole_1);
  var _optionRole = interopRequireDefault(optionRole_1);
  var _paragraphRole = interopRequireDefault(paragraphRole_1);
  var _presentationRole = interopRequireDefault(presentationRole_1);
  var _progressbarRole = interopRequireDefault(progressbarRole_1);
  var _radioRole = interopRequireDefault(radioRole_1);
  var _radiogroupRole = interopRequireDefault(radiogroupRole_1);
  var _regionRole = interopRequireDefault(regionRole_1);
  var _rowRole = interopRequireDefault(rowRole_1);
  var _rowgroupRole = interopRequireDefault(rowgroupRole_1);
  var _rowheaderRole = interopRequireDefault(rowheaderRole_1);
  var _scrollbarRole = interopRequireDefault(scrollbarRole_1);
  var _searchRole = interopRequireDefault(searchRole_1);
  var _searchboxRole = interopRequireDefault(searchboxRole_1);
  var _separatorRole = interopRequireDefault(separatorRole_1);
  var _sliderRole = interopRequireDefault(sliderRole_1);
  var _spinbuttonRole = interopRequireDefault(spinbuttonRole_1);
  var _statusRole = interopRequireDefault(statusRole_1);
  var _strongRole = interopRequireDefault(strongRole_1);
  var _subscriptRole = interopRequireDefault(subscriptRole_1);
  var _superscriptRole = interopRequireDefault(superscriptRole_1);
  var _switchRole = interopRequireDefault(switchRole_1);
  var _tabRole = interopRequireDefault(tabRole_1);
  var _tableRole = interopRequireDefault(tableRole_1);
  var _tablistRole = interopRequireDefault(tablistRole_1);
  var _tabpanelRole = interopRequireDefault(tabpanelRole_1);
  var _termRole = interopRequireDefault(termRole_1);
  var _textboxRole = interopRequireDefault(textboxRole_1);
  var _timeRole = interopRequireDefault(timeRole_1);
  var _timerRole = interopRequireDefault(timerRole_1);
  var _toolbarRole = interopRequireDefault(toolbarRole_1);
  var _tooltipRole = interopRequireDefault(tooltipRole_1);
  var _treeRole = interopRequireDefault(treeRole_1);
  var _treegridRole = interopRequireDefault(treegridRole_1);
  var _treeitemRole = interopRequireDefault(treeitemRole_1);
  var ariaLiteralRoles = new _map.default([['alert', _alertRole.default], ['alertdialog', _alertdialogRole.default], ['application', _applicationRole.default], ['article', _articleRole.default], ['banner', _bannerRole.default], ['blockquote', _blockquoteRole.default], ['button', _buttonRole.default], ['caption', _captionRole.default], ['cell', _cellRole.default], ['checkbox', _checkboxRole.default], ['code', _codeRole.default], ['columnheader', _columnheaderRole.default], ['combobox', _comboboxRole.default], ['complementary', _complementaryRole.default], ['contentinfo', _contentinfoRole.default], ['definition', _definitionRole.default], ['deletion', _deletionRole.default], ['dialog', _dialogRole.default], ['directory', _directoryRole.default], ['document', _documentRole.default], ['emphasis', _emphasisRole.default], ['feed', _feedRole.default], ['figure', _figureRole.default], ['form', _formRole.default], ['generic', _genericRole.default], ['grid', _gridRole.default], ['gridcell', _gridcellRole.default], ['group', _groupRole.default], ['heading', _headingRole.default], ['img', _imgRole.default], ['insertion', _insertionRole.default], ['link', _linkRole.default], ['list', _listRole.default], ['listbox', _listboxRole.default], ['listitem', _listitemRole.default], ['log', _logRole.default], ['main', _mainRole.default], ['marquee', _marqueeRole.default], ['math', _mathRole.default], ['menu', _menuRole.default], ['menubar', _menubarRole.default], ['menuitem', _menuitemRole.default], ['menuitemcheckbox', _menuitemcheckboxRole.default], ['menuitemradio', _menuitemradioRole.default], ['meter', _meterRole.default], ['navigation', _navigationRole.default], ['none', _noneRole.default], ['note', _noteRole.default], ['option', _optionRole.default], ['paragraph', _paragraphRole.default], ['presentation', _presentationRole.default], ['progressbar', _progressbarRole.default], ['radio', _radioRole.default], ['radiogroup', _radiogroupRole.default], ['region', _regionRole.default], ['row', _rowRole.default], ['rowgroup', _rowgroupRole.default], ['rowheader', _rowheaderRole.default], ['scrollbar', _scrollbarRole.default], ['search', _searchRole.default], ['searchbox', _searchboxRole.default], ['separator', _separatorRole.default], ['slider', _sliderRole.default], ['spinbutton', _spinbuttonRole.default], ['status', _statusRole.default], ['strong', _strongRole.default], ['subscript', _subscriptRole.default], ['superscript', _superscriptRole.default], ['switch', _switchRole.default], ['tab', _tabRole.default], ['table', _tableRole.default], ['tablist', _tablistRole.default], ['tabpanel', _tabpanelRole.default], ['term', _termRole.default], ['textbox', _textboxRole.default], ['time', _timeRole.default], ['timer', _timerRole.default], ['toolbar', _toolbarRole.default], ['tooltip', _tooltipRole.default], ['tree', _treeRole.default], ['treegrid', _treegridRole.default], ['treeitem', _treeitemRole.default]]);
  var _default = ariaLiteralRoles;
  exports.default = _default;
});
unwrapExports(ariaLiteralRoles_1);
var docAbstractRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docAbstractRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'abstract [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docAbstractRole;
  exports.default = _default;
});
unwrapExports(docAbstractRole_1);
var docAcknowledgmentsRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docAcknowledgmentsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'acknowledgments [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAcknowledgmentsRole;
  exports.default = _default;
});
unwrapExports(docAcknowledgmentsRole_1);
var docAfterwordRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docAfterwordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'afterword [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAfterwordRole;
  exports.default = _default;
});
unwrapExports(docAfterwordRole_1);
var docAppendixRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docAppendixRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'appendix [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docAppendixRole;
  exports.default = _default;
});
unwrapExports(docAppendixRole_1);
var docBacklinkRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docBacklinkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'content'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'referrer [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docBacklinkRole;
  exports.default = _default;
});
unwrapExports(docBacklinkRole_1);
var docBiblioentryRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docBiblioentryRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'EPUB biblioentry [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: ['doc-bibliography'],
    requiredContextRole: ['doc-bibliography'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'listitem']]
  };
  var _default = docBiblioentryRole;
  exports.default = _default;
});
unwrapExports(docBiblioentryRole_1);
var docBibliographyRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docBibliographyRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'bibliography [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['doc-biblioentry']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docBibliographyRole;
  exports.default = _default;
});
unwrapExports(docBibliographyRole_1);
var docBibliorefRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docBibliorefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'biblioref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docBibliorefRole;
  exports.default = _default;
});
unwrapExports(docBibliorefRole_1);
var docChapterRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docChapterRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'chapter [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docChapterRole;
  exports.default = _default;
});
unwrapExports(docChapterRole_1);
var docColophonRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docColophonRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'colophon [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docColophonRole;
  exports.default = _default;
});
unwrapExports(docColophonRole_1);
var docConclusionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docConclusionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'conclusion [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docConclusionRole;
  exports.default = _default;
});
unwrapExports(docConclusionRole_1);
var docCoverRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docCoverRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'cover [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'img']]
  };
  var _default = docCoverRole;
  exports.default = _default;
});
unwrapExports(docCoverRole_1);
var docCreditRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docCreditRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'credit [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docCreditRole;
  exports.default = _default;
});
unwrapExports(docCreditRole_1);
var docCreditsRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docCreditsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'credits [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docCreditsRole;
  exports.default = _default;
});
unwrapExports(docCreditsRole_1);
var docDedicationRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docDedicationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'dedication [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docDedicationRole;
  exports.default = _default;
});
unwrapExports(docDedicationRole_1);
var docEndnoteRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docEndnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rearnote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: ['doc-endnotes'],
    requiredContextRole: ['doc-endnotes'],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'listitem']]
  };
  var _default = docEndnoteRole;
  exports.default = _default;
});
unwrapExports(docEndnoteRole_1);
var docEndnotesRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docEndnotesRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'rearnotes [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['doc-endnote']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docEndnotesRole;
  exports.default = _default;
});
unwrapExports(docEndnotesRole_1);
var docEpigraphRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docEpigraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'epigraph [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docEpigraphRole;
  exports.default = _default;
});
unwrapExports(docEpigraphRole_1);
var docEpilogueRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docEpilogueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'epilogue [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docEpilogueRole;
  exports.default = _default;
});
unwrapExports(docEpilogueRole_1);
var docErrataRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docErrataRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'errata [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docErrataRole;
  exports.default = _default;
});
unwrapExports(docErrataRole_1);
var docExampleRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docExampleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docExampleRole;
  exports.default = _default;
});
unwrapExports(docExampleRole_1);
var docFootnoteRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docFootnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'footnote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docFootnoteRole;
  exports.default = _default;
});
unwrapExports(docFootnoteRole_1);
var docForewordRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docForewordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'foreword [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docForewordRole;
  exports.default = _default;
});
unwrapExports(docForewordRole_1);
var docGlossaryRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docGlossaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'glossary [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [['definition'], ['term']],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docGlossaryRole;
  exports.default = _default;
});
unwrapExports(docGlossaryRole_1);
var docGlossrefRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docGlossrefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'glossref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docGlossrefRole;
  exports.default = _default;
});
unwrapExports(docGlossrefRole_1);
var docIndexRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docIndexRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'index [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docIndexRole;
  exports.default = _default;
});
unwrapExports(docIndexRole_1);
var docIntroductionRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docIntroductionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'introduction [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docIntroductionRole;
  exports.default = _default;
});
unwrapExports(docIntroductionRole_1);
var docNoterefRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docNoterefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author', 'contents'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'noteref [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'widget', 'command', 'link']]
  };
  var _default = docNoterefRole;
  exports.default = _default;
});
unwrapExports(docNoterefRole_1);
var docNoticeRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docNoticeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'notice [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'note']]
  };
  var _default = docNoticeRole;
  exports.default = _default;
});
unwrapExports(docNoticeRole_1);
var docPagebreakRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPagebreakRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'pagebreak [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'separator']]
  };
  var _default = docPagebreakRole;
  exports.default = _default;
});
unwrapExports(docPagebreakRole_1);
var docPagelistRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPagelistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'page-list [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docPagelistRole;
  exports.default = _default;
});
unwrapExports(docPagelistRole_1);
var docPartRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPartRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'part [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPartRole;
  exports.default = _default;
});
unwrapExports(docPartRole_1);
var docPrefaceRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPrefaceRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'preface [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPrefaceRole;
  exports.default = _default;
});
unwrapExports(docPrefaceRole_1);
var docPrologueRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPrologueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'prologue [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark']]
  };
  var _default = docPrologueRole;
  exports.default = _default;
});
unwrapExports(docPrologueRole_1);
var docPullquoteRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docPullquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: 'pullquote [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['none']]
  };
  var _default = docPullquoteRole;
  exports.default = _default;
});
unwrapExports(docPullquoteRole_1);
var docQnaRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docQnaRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'qna [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section']]
  };
  var _default = docQnaRole;
  exports.default = _default;
});
unwrapExports(docQnaRole_1);
var docSubtitleRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docSubtitleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'subtitle [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'sectionhead']]
  };
  var _default = docSubtitleRole;
  exports.default = _default;
});
unwrapExports(docSubtitleRole_1);
var docTipRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docTipRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'help [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'note']]
  };
  var _default = docTipRole;
  exports.default = _default;
});
unwrapExports(docTipRole_1);
var docTocRole_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var docTocRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: ['author'],
    prohibitedProps: [],
    props: {
      'aria-disabled': null,
      'aria-errormessage': null,
      'aria-expanded': null,
      'aria-haspopup': null,
      'aria-invalid': null
    },
    relatedConcepts: [{
      concept: {
        name: 'toc [EPUB-SSV]'
      },
      module: 'EPUB'
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
  };
  var _default = docTocRole;
  exports.default = _default;
});
unwrapExports(docTocRole_1);
var ariaDpubRoles_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _map = interopRequireDefault(map$2);
  var _docAbstractRole = interopRequireDefault(docAbstractRole_1);
  var _docAcknowledgmentsRole = interopRequireDefault(docAcknowledgmentsRole_1);
  var _docAfterwordRole = interopRequireDefault(docAfterwordRole_1);
  var _docAppendixRole = interopRequireDefault(docAppendixRole_1);
  var _docBacklinkRole = interopRequireDefault(docBacklinkRole_1);
  var _docBiblioentryRole = interopRequireDefault(docBiblioentryRole_1);
  var _docBibliographyRole = interopRequireDefault(docBibliographyRole_1);
  var _docBibliorefRole = interopRequireDefault(docBibliorefRole_1);
  var _docChapterRole = interopRequireDefault(docChapterRole_1);
  var _docColophonRole = interopRequireDefault(docColophonRole_1);
  var _docConclusionRole = interopRequireDefault(docConclusionRole_1);
  var _docCoverRole = interopRequireDefault(docCoverRole_1);
  var _docCreditRole = interopRequireDefault(docCreditRole_1);
  var _docCreditsRole = interopRequireDefault(docCreditsRole_1);
  var _docDedicationRole = interopRequireDefault(docDedicationRole_1);
  var _docEndnoteRole = interopRequireDefault(docEndnoteRole_1);
  var _docEndnotesRole = interopRequireDefault(docEndnotesRole_1);
  var _docEpigraphRole = interopRequireDefault(docEpigraphRole_1);
  var _docEpilogueRole = interopRequireDefault(docEpilogueRole_1);
  var _docErrataRole = interopRequireDefault(docErrataRole_1);
  var _docExampleRole = interopRequireDefault(docExampleRole_1);
  var _docFootnoteRole = interopRequireDefault(docFootnoteRole_1);
  var _docForewordRole = interopRequireDefault(docForewordRole_1);
  var _docGlossaryRole = interopRequireDefault(docGlossaryRole_1);
  var _docGlossrefRole = interopRequireDefault(docGlossrefRole_1);
  var _docIndexRole = interopRequireDefault(docIndexRole_1);
  var _docIntroductionRole = interopRequireDefault(docIntroductionRole_1);
  var _docNoterefRole = interopRequireDefault(docNoterefRole_1);
  var _docNoticeRole = interopRequireDefault(docNoticeRole_1);
  var _docPagebreakRole = interopRequireDefault(docPagebreakRole_1);
  var _docPagelistRole = interopRequireDefault(docPagelistRole_1);
  var _docPartRole = interopRequireDefault(docPartRole_1);
  var _docPrefaceRole = interopRequireDefault(docPrefaceRole_1);
  var _docPrologueRole = interopRequireDefault(docPrologueRole_1);
  var _docPullquoteRole = interopRequireDefault(docPullquoteRole_1);
  var _docQnaRole = interopRequireDefault(docQnaRole_1);
  var _docSubtitleRole = interopRequireDefault(docSubtitleRole_1);
  var _docTipRole = interopRequireDefault(docTipRole_1);
  var _docTocRole = interopRequireDefault(docTocRole_1);
  var ariaDpubRoles = new _map.default([['doc-abstract', _docAbstractRole.default], ['doc-acknowledgments', _docAcknowledgmentsRole.default], ['doc-afterword', _docAfterwordRole.default], ['doc-appendix', _docAppendixRole.default], ['doc-backlink', _docBacklinkRole.default], ['doc-biblioentry', _docBiblioentryRole.default], ['doc-bibliography', _docBibliographyRole.default], ['doc-biblioref', _docBibliorefRole.default], ['doc-chapter', _docChapterRole.default], ['doc-colophon', _docColophonRole.default], ['doc-conclusion', _docConclusionRole.default], ['doc-cover', _docCoverRole.default], ['doc-credit', _docCreditRole.default], ['doc-credits', _docCreditsRole.default], ['doc-dedication', _docDedicationRole.default], ['doc-endnote', _docEndnoteRole.default], ['doc-endnotes', _docEndnotesRole.default], ['doc-epigraph', _docEpigraphRole.default], ['doc-epilogue', _docEpilogueRole.default], ['doc-errata', _docErrataRole.default], ['doc-example', _docExampleRole.default], ['doc-footnote', _docFootnoteRole.default], ['doc-foreword', _docForewordRole.default], ['doc-glossary', _docGlossaryRole.default], ['doc-glossref', _docGlossrefRole.default], ['doc-index', _docIndexRole.default], ['doc-introduction', _docIntroductionRole.default], ['doc-noteref', _docNoterefRole.default], ['doc-notice', _docNoticeRole.default], ['doc-pagebreak', _docPagebreakRole.default], ['doc-pagelist', _docPagelistRole.default], ['doc-part', _docPartRole.default], ['doc-preface', _docPrefaceRole.default], ['doc-prologue', _docPrologueRole.default], ['doc-pullquote', _docPullquoteRole.default], ['doc-qna', _docQnaRole.default], ['doc-subtitle', _docSubtitleRole.default], ['doc-tip', _docTipRole.default], ['doc-toc', _docTocRole.default]]);
  var _default = ariaDpubRoles;
  exports.default = _default;
});
unwrapExports(ariaDpubRoles_1);
var rolesMap_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _getIterator2 = interopRequireDefault(getIterator$1);
  var _isArray = interopRequireDefault(isArray$3);
  var _getIteratorMethod2 = interopRequireDefault(getIteratorMethod$1);
  var _symbol = interopRequireDefault(symbol$2);
  var _from = interopRequireDefault(from_1$2);
  var _slice = interopRequireDefault(slice$2);
  var _defineProperty2 = interopRequireDefault(defineProperty$8);
  var _assign = interopRequireDefault(assign$2);
  var _keys = interopRequireDefault(keys$3);
  var _forEach = interopRequireDefault(forEach$3);
  var _map = interopRequireDefault(map$2);
  var _ariaAbstractRoles = interopRequireDefault(ariaAbstractRoles_1);
  var _ariaLiteralRoles = interopRequireDefault(ariaLiteralRoles_1);
  var _ariaDpubRoles = interopRequireDefault(ariaDpubRoles_1);
  var _context;
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof _symbol.default === "undefined" || (0, _getIteratorMethod2.default)(o) == null) {
      if ((0, _isArray.default)(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        var F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = (0, _getIterator2.default)(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
  function _unsupportedIterableToArray(o, minLen) {
    var _context2;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = (0, _slice.default)(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return (0, _from.default)(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var rolesMap = new _map.default([]);
  (0, _forEach.default)(_context = [_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default]).call(_context, function (roleSet) {
    (0, _forEach.default)(roleSet).call(roleSet, function (roleDefinition, name) {
      return rolesMap.set(name, roleDefinition);
    });
  });
  (0, _forEach.default)(rolesMap).call(rolesMap, function (roleDefinition, name) {
    // Conglomerate the properties
    var _iterator = _createForOfIteratorHelper(roleDefinition.superClass),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var superClassIter = _step.value;
        var _iterator2 = _createForOfIteratorHelper(superClassIter),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var superClassName = _step2.value;
            var superClassDefinition = rolesMap.get(superClassName);
            if (superClassDefinition) {
              for (var _i = 0, _Object$keys = (0, _keys.default)(superClassDefinition.props); _i < _Object$keys.length; _i++) {
                var prop = _Object$keys[_i];
                if (!Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) {
                  (0, _assign.default)(roleDefinition.props, (0, _defineProperty2.default)({}, prop, superClassDefinition.props[prop]));
                }
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  var _default = rolesMap;
  exports.default = _default;
});
unwrapExports(rolesMap_1);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
var es_set = collection('Set', function (init) {
  return function Set() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);
var set$1 = path.Set;
var set$2 = set$1;
var set$3 = set$2;
var isArray$4 = isArray$1;
var isArray$5 = isArray$4;
var arrayWithHoles = createCommonjsModule(function (module) {
  function _arrayWithHoles(arr) {
    if (isArray$5(arr)) return arr;
  }
  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayWithHoles);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');

// TODO: remove from `core-js@4`

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');

// TODO: remove from `core-js@4`

defineWellKnownSymbol('replaceAll');

// TODO: Remove from `core-js@4`

// TODO: Remove from `core-js@4`

var symbol$3 = symbol;
var symbol$4 = symbol$3;
var iterableToArrayLimit = createCommonjsModule(function (module) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof symbol$4 !== "undefined" && getIteratorMethod$1(arr) || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(iterableToArrayLimit);
var slice$3 = slice_1;
var slice$4 = slice$3;
var from_1$3 = from_1;
var from_1$4 = from_1$3;
var arrayLikeToArray = createCommonjsModule(function (module) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayLikeToArray);
var unsupportedIterableToArray = createCommonjsModule(function (module) {
  function _unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = slice$4(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return from_1$4(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }
  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(unsupportedIterableToArray);
var nonIterableRest = createCommonjsModule(function (module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(nonIterableRest);
var slicedToArray = createCommonjsModule(function (module) {
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }
  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(slicedToArray);
var entries = entryVirtual('Array').entries;
var entries$1 = entries;
var ArrayPrototype$3 = Array.prototype;
var DOMIterables$1 = {
  DOMTokenList: true,
  NodeList: true
};
var entries_1 = function entries_1(it) {
  var own = it.entries;
  return it === ArrayPrototype$3 || it instanceof Array && own === ArrayPrototype$3.entries
  // eslint-disable-next-line no-prototype-builtins -- safe
  || DOMIterables$1.hasOwnProperty(classof(it)) ? entries$1 : own;
};
var entries$2 = entries_1;
var $find = arrayIteration.find;
var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () {
  SKIPS_HOLES = false;
});

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({
  target: 'Array',
  proto: true,
  forced: SKIPS_HOLES
}, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
var find = entryVirtual('Array').find;
var ArrayPrototype$4 = Array.prototype;
var find_1 = function find_1(it) {
  var own = it.find;
  return it === ArrayPrototype$4 || it instanceof Array && own === ArrayPrototype$4.find ? find : own;
};
var find$1 = find_1;
var find$2 = find$1;
var $stringify$1 = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var fix = function fix(match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if (low.test(match) && !hi.test(next) || hi.test(match) && !low.test(prev)) {
    return "\\u" + match.charCodeAt(0).toString(16);
  }
  return match;
};
var FORCED$1 = fails(function () {
  return $stringify$1("\uDF06\uD834") !== "\"\\udf06\\ud834\"" || $stringify$1("\uDEAD") !== "\"\\udead\"";
});
if ($stringify$1) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  _export({
    target: 'JSON',
    stat: true,
    forced: FORCED$1
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify$1.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}

// eslint-disable-next-line es/no-json -- safe
if (!path.JSON) path.JSON = {
  stringify: JSON.stringify
};

// eslint-disable-next-line no-unused-vars -- required for `.length`
var stringify = function stringify(it, replacer, space) {
  return path.JSON.stringify.apply(null, arguments);
};
var stringify$1 = stringify;
var stringify$2 = stringify$1;
var concat = entryVirtual('Array').concat;
var ArrayPrototype$5 = Array.prototype;
var concat_1 = function concat_1(it) {
  var own = it.concat;
  return it === ArrayPrototype$5 || it instanceof Array && own === ArrayPrototype$5.concat ? concat : own;
};
var concat$1 = concat_1;
var concat$2 = concat$1;
var keys$4 = entryVirtual('Array').keys;
var keys$5 = keys$4;
var ArrayPrototype$6 = Array.prototype;
var DOMIterables$2 = {
  DOMTokenList: true,
  NodeList: true
};
var keys_1 = function keys_1(it) {
  var own = it.keys;
  return it === ArrayPrototype$6 || it instanceof Array && own === ArrayPrototype$6.keys
  // eslint-disable-next-line no-prototype-builtins -- safe
  || DOMIterables$2.hasOwnProperty(classof(it)) ? keys$5 : own;
};
var keys$6 = keys_1;
var arrayWithoutHoles = createCommonjsModule(function (module) {
  function _arrayWithoutHoles(arr) {
    if (isArray$5(arr)) return arrayLikeToArray(arr);
  }
  module.exports = _arrayWithoutHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayWithoutHoles);
var iterableToArray = createCommonjsModule(function (module) {
  function _iterableToArray(iter) {
    if (typeof symbol$4 !== "undefined" && getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return from_1$4(iter);
  }
  module.exports = _iterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(iterableToArray);
var nonIterableSpread = createCommonjsModule(function (module) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableSpread;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(nonIterableSpread);
var toConsumableArray = createCommonjsModule(function (module) {
  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }
  module.exports = _toConsumableArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(toConsumableArray);
var elementRoleMap_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _set = interopRequireDefault(set$3);
  var _slicedToArray2 = interopRequireDefault(slicedToArray);
  var _entries = interopRequireDefault(entries$2);
  var _find = interopRequireDefault(find$2);
  var _stringify = interopRequireDefault(stringify$2);
  var _concat = interopRequireDefault(concat$2);
  var _keys = interopRequireDefault(keys$6);
  var _toConsumableArray2 = interopRequireDefault(toConsumableArray);
  var _forEach = interopRequireDefault(forEach$3);
  var _map = interopRequireDefault(map$2);
  var _rolesMap = interopRequireDefault(rolesMap_1);
  var _context;
  var elementRoleMap = new _map.default([]);
  (0, _forEach.default)(_context = (0, _toConsumableArray2.default)((0, _keys.default)(_rolesMap.default).call(_rolesMap.default))).call(_context, function (key) {
    var role = _rolesMap.default.get(key);
    if (role) {
      var _context2, _context3;
      (0, _forEach.default)(_context2 = (0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)(role.baseConcepts), (0, _toConsumableArray2.default)(role.relatedConcepts))).call(_context2, function (relation) {
        if (relation.module === 'HTML') {
          var concept = relation.concept;
          if (concept) {
            var _context4;
            var conceptStr = (0, _stringify.default)(concept);
            var roles = ((0, _find.default)(_context4 = (0, _toConsumableArray2.default)((0, _entries.default)(elementRoleMap).call(elementRoleMap))).call(_context4, function (_ref) {
              var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];
              return (0, _stringify.default)(key) === conceptStr;
            }) || [])[1];
            if (!roles) {
              roles = new _set.default([]);
            }
            roles.add(key);
            elementRoleMap.set(concept, roles);
          }
        }
      });
    }
  });
  var _default = elementRoleMap;
  exports.default = _default;
});
unwrapExports(elementRoleMap_1);
var roleElementMap_1 = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _set = interopRequireDefault(set$3);
  var _concat = interopRequireDefault(concat$2);
  var _keys = interopRequireDefault(keys$6);
  var _toConsumableArray2 = interopRequireDefault(toConsumableArray);
  var _forEach = interopRequireDefault(forEach$3);
  var _map = interopRequireDefault(map$2);
  var _rolesMap = interopRequireDefault(rolesMap_1);
  var _context;
  var roleElementMap = new _map.default([]);
  (0, _forEach.default)(_context = (0, _toConsumableArray2.default)((0, _keys.default)(_rolesMap.default).call(_rolesMap.default))).call(_context, function (key) {
    var role = _rolesMap.default.get(key);
    if (role) {
      var _context2, _context3;
      (0, _forEach.default)(_context2 = (0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)(role.baseConcepts), (0, _toConsumableArray2.default)(role.relatedConcepts))).call(_context2, function (relation) {
        if (relation.module === 'HTML') {
          var concept = relation.concept;
          if (concept) {
            var relationConcepts = roleElementMap.get(key) || new _set.default([]);
            relationConcepts.add(concept);
            roleElementMap.set(key, relationConcepts);
          }
        }
      });
    }
  });
  var _default = roleElementMap;
  exports.default = _default;
});
unwrapExports(roleElementMap_1);
var lib = createCommonjsModule(function (module, exports) {
  defineProperty$1(exports, "__esModule", {
    value: true
  });
  exports.roleElements = exports.elementRoles = exports.roles = exports.dom = exports.aria = void 0;
  var _ariaPropsMap = interopRequireDefault(ariaPropsMap_1);
  var _domMap = interopRequireDefault(domMap_1);
  var _rolesMap = interopRequireDefault(rolesMap_1);
  var _elementRoleMap = interopRequireDefault(elementRoleMap_1);
  var _roleElementMap = interopRequireDefault(roleElementMap_1);
  var aria = _ariaPropsMap.default;
  exports.aria = aria;
  var dom = _domMap.default;
  exports.dom = dom;
  var roles = _rolesMap.default;
  exports.roles = roles;
  var elementRoles = _elementRoleMap.default;
  exports.elementRoles = elementRoles;
  var roleElements = _roleElementMap.default;
  exports.roleElements = roleElements;
});
unwrapExports(lib);
var lib_1 = lib.roleElements;
var lib_2 = lib.elementRoles;
var lib_3 = lib.roles;
var lib_4 = lib.dom;
var lib_5 = lib.aria;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }
    exports.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }
    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction ||
      // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
        // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    exports.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;
        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function () {
      return this;
    };
    Gp.toString = function () {
      return "[object Generator]";
    };
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports.keys = function (object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }
              next.value = undefined$1;
              next.done = true;
              return next;
            };
          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return {
        next: doneResult
      };
    }
    exports.values = values;
    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }
    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };

    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
  }(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});
var regenerator = runtime_1;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var lzString = createCommonjsModule(function (module) {
  // Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
  // This work is free. You can redistribute it and/or modify it
  // under the terms of the WTFPL, Version 2
  // For more information see LICENSE.txt or http://www.wtfpl.net/
  //
  // For more information, the home page:
  // http://pieroxy.net/blog/pages/lz-string/testing.html
  //
  // LZ-based compression algorithm, version 1.4.4
  var LZString = function () {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
      if (!baseReverseDic[alphabet]) {
        baseReverseDic[alphabet] = {};
        for (var i = 0; i < alphabet.length; i++) {
          baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
      }
      return baseReverseDic[alphabet][character];
    }
    var LZString = {
      compressToBase64: function compressToBase64(input) {
        if (input == null) return "";
        var res = LZString._compress(input, 6, function (a) {
          return keyStrBase64.charAt(a);
        });
        switch (res.length % 4) {
          // To produce valid Base64
          default: // When could this happen ?
          case 0:
            return res;
          case 1:
            return res + "===";
          case 2:
            return res + "==";
          case 3:
            return res + "=";
        }
      },
      decompressFromBase64: function decompressFromBase64(input) {
        if (input == null) return "";
        if (input == "") return null;
        return LZString._decompress(input.length, 32, function (index) {
          return getBaseValue(keyStrBase64, input.charAt(index));
        });
      },
      compressToUTF16: function compressToUTF16(input) {
        if (input == null) return "";
        return LZString._compress(input, 15, function (a) {
          return f(a + 32);
        }) + " ";
      },
      decompressFromUTF16: function decompressFromUTF16(compressed) {
        if (compressed == null) return "";
        if (compressed == "") return null;
        return LZString._decompress(compressed.length, 16384, function (index) {
          return compressed.charCodeAt(index) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function compressToUint8Array(uncompressed) {
        var compressed = LZString.compress(uncompressed);
        var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character

        for (var i = 0, TotalLen = compressed.length; i < TotalLen; i++) {
          var current_value = compressed.charCodeAt(i);
          buf[i * 2] = current_value >>> 8;
          buf[i * 2 + 1] = current_value % 256;
        }
        return buf;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function decompressFromUint8Array(compressed) {
        if (compressed === null || compressed === undefined) {
          return LZString.decompress(compressed);
        } else {
          var buf = new Array(compressed.length / 2); // 2 bytes per character
          for (var i = 0, TotalLen = buf.length; i < TotalLen; i++) {
            buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
          }
          var result = [];
          buf.forEach(function (c) {
            result.push(f(c));
          });
          return LZString.decompress(result.join(''));
        }
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function compressToEncodedURIComponent(input) {
        if (input == null) return "";
        return LZString._compress(input, 6, function (a) {
          return keyStrUriSafe.charAt(a);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function decompressFromEncodedURIComponent(input) {
        if (input == null) return "";
        if (input == "") return null;
        input = input.replace(/ /g, "+");
        return LZString._decompress(input.length, 32, function (index) {
          return getBaseValue(keyStrUriSafe, input.charAt(index));
        });
      },
      compress: function compress(uncompressed) {
        return LZString._compress(uncompressed, 16, function (a) {
          return f(a);
        });
      },
      _compress: function _compress(uncompressed, bitsPerChar, getCharFromInt) {
        if (uncompressed == null) return "";
        var i,
          value,
          context_dictionary = {},
          context_dictionaryToCreate = {},
          context_c = "",
          context_wc = "",
          context_w = "",
          context_enlargeIn = 2,
          // Compensate for the first entry which should not count
          context_dictSize = 3,
          context_numBits = 2,
          context_data = [],
          context_data_val = 0,
          context_data_position = 0,
          ii;
        for (ii = 0; ii < uncompressed.length; ii += 1) {
          context_c = uncompressed.charAt(ii);
          if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
            context_dictionary[context_c] = context_dictSize++;
            context_dictionaryToCreate[context_c] = true;
          }
          context_wc = context_w + context_c;
          if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
            context_w = context_wc;
          } else {
            if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
              if (context_w.charCodeAt(0) < 256) {
                for (i = 0; i < context_numBits; i++) {
                  context_data_val = context_data_val << 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                }
                value = context_w.charCodeAt(0);
                for (i = 0; i < 8; i++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              } else {
                value = 1;
                for (i = 0; i < context_numBits; i++) {
                  context_data_val = context_data_val << 1 | value;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = 0;
                }
                value = context_w.charCodeAt(0);
                for (i = 0; i < 16; i++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              }
              context_enlargeIn--;
              if (context_enlargeIn == 0) {
                context_enlargeIn = Math.pow(2, context_numBits);
                context_numBits++;
              }
              delete context_dictionaryToCreate[context_w];
            } else {
              value = context_dictionary[context_w];
              for (i = 0; i < context_numBits; i++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn == 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            // Add wc to the dictionary.
            context_dictionary[context_wc] = context_dictSize++;
            context_w = String(context_c);
          }
        }

        // Output the code for w.
        if (context_w !== "") {
          if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
            if (context_w.charCodeAt(0) < 256) {
              for (i = 0; i < context_numBits; i++) {
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
              }
              value = context_w.charCodeAt(0);
              for (i = 0; i < 8; i++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            } else {
              value = 1;
              for (i = 0; i < context_numBits; i++) {
                context_data_val = context_data_val << 1 | value;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = 0;
              }
              value = context_w.charCodeAt(0);
              for (i = 0; i < 16; i++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn == 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            delete context_dictionaryToCreate[context_w];
          } else {
            value = context_dictionary[context_w];
            for (i = 0; i < context_numBits; i++) {
              context_data_val = context_data_val << 1 | value & 1;
              if (context_data_position == bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
        }

        // Mark the end of the stream
        value = 2;
        for (i = 0; i < context_numBits; i++) {
          context_data_val = context_data_val << 1 | value & 1;
          if (context_data_position == bitsPerChar - 1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }

        // Flush the last char
        while (true) {
          context_data_val = context_data_val << 1;
          if (context_data_position == bitsPerChar - 1) {
            context_data.push(getCharFromInt(context_data_val));
            break;
          } else context_data_position++;
        }
        return context_data.join('');
      },
      decompress: function decompress(compressed) {
        if (compressed == null) return "";
        if (compressed == "") return null;
        return LZString._decompress(compressed.length, 32768, function (index) {
          return compressed.charCodeAt(index);
        });
      },
      _decompress: function _decompress(length, resetValue, getNextValue) {
        var dictionary = [],
          next,
          enlargeIn = 4,
          dictSize = 4,
          numBits = 3,
          entry = "",
          result = [],
          i,
          w,
          bits,
          resb,
          maxpower,
          power,
          c,
          data = {
            val: getNextValue(0),
            position: resetValue,
            index: 1
          };
        for (i = 0; i < 3; i += 1) {
          dictionary[i] = i;
        }
        bits = 0;
        maxpower = Math.pow(2, 2);
        power = 1;
        while (power != maxpower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position == 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        switch (next = bits) {
          case 0:
            bits = 0;
            maxpower = Math.pow(2, 8);
            power = 1;
            while (power != maxpower) {
              resb = data.val & data.position;
              data.position >>= 1;
              if (data.position == 0) {
                data.position = resetValue;
                data.val = getNextValue(data.index++);
              }
              bits |= (resb > 0 ? 1 : 0) * power;
              power <<= 1;
            }
            c = f(bits);
            break;
          case 1:
            bits = 0;
            maxpower = Math.pow(2, 16);
            power = 1;
            while (power != maxpower) {
              resb = data.val & data.position;
              data.position >>= 1;
              if (data.position == 0) {
                data.position = resetValue;
                data.val = getNextValue(data.index++);
              }
              bits |= (resb > 0 ? 1 : 0) * power;
              power <<= 1;
            }
            c = f(bits);
            break;
          case 2:
            return "";
        }
        dictionary[3] = c;
        w = c;
        result.push(c);
        while (true) {
          if (data.index > length) {
            return "";
          }
          bits = 0;
          maxpower = Math.pow(2, numBits);
          power = 1;
          while (power != maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          switch (c = bits) {
            case 0:
              bits = 0;
              maxpower = Math.pow(2, 8);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              dictionary[dictSize++] = f(bits);
              c = dictSize - 1;
              enlargeIn--;
              break;
            case 1:
              bits = 0;
              maxpower = Math.pow(2, 16);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              dictionary[dictSize++] = f(bits);
              c = dictSize - 1;
              enlargeIn--;
              break;
            case 2:
              return result.join('');
          }
          if (enlargeIn == 0) {
            enlargeIn = Math.pow(2, numBits);
            numBits++;
          }
          if (dictionary[c]) {
            entry = dictionary[c];
          } else {
            if (c === dictSize) {
              entry = w + w.charAt(0);
            } else {
              return null;
            }
          }
          result.push(entry);

          // Add w+entry[0] to the dictionary.
          dictionary[dictSize++] = w + entry.charAt(0);
          enlargeIn--;
          w = entry;
          if (enlargeIn == 0) {
            enlargeIn = Math.pow(2, numBits);
            numBits++;
          }
        }
      }
    };
    return LZString;
  }();
  if (module != null) {
    module.exports = LZString;
  }
});
var lzString_1 = lzString.compressToEncodedURIComponent;

// We try to load node dependencies
var chalk = null;
var readFileSync = null;
var codeFrameColumns = null;
try {
  var nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, 'fs').readFileSync;
  codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
  chalk = nodeRequire.call(module, 'chalk');
} catch (_unused) {// We're in a browser environment
} // frame has the form "at myMethod (location/to/my/file.js:10:2)"

function getCodeFrame(frame) {
  var locationStart = frame.indexOf('(') + 1;
  var locationEnd = frame.indexOf(')');
  var frameLocation = frame.slice(locationStart, locationEnd);
  var frameLocationElements = frameLocation.split(':');
  var _ref = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)],
    filename = _ref[0],
    line = _ref[1],
    column = _ref[2];
  var rawFileContents = '';
  try {
    rawFileContents = readFileSync(filename, 'utf-8');
  } catch (_unused2) {
    return '';
  }
  var codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line: line,
      column: column
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
  // If we couldn't load dependencies, we can't generate the user trace

  /* istanbul ignore next */
  if (!readFileSync || !codeFrameColumns) {
    return '';
  }
  var err = new Error();
  var firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
  .find(function (frame) {
    return !frame.includes('node_modules/');
  }); // Ignore frames from 3rd party libraries

  return getCodeFrame(firstClientCodeFrame);
}
var globalObj = typeof window === 'undefined' ? global : window; // Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants

var TEXT_NODE = 3; // Currently this fn only supports jest timers, but it could support other test runners in the future.

function runWithRealTimers(callback) {
  return hasJestTimers() ? runWithJestRealTimers(callback).callbackReturnValue :
  // istanbul ignore next
  callback();
}
function hasJestTimers() {
  return typeof jest !== 'undefined' && jest !== null && typeof jest.useRealTimers === 'function';
}
function runWithJestRealTimers(callback) {
  var timerAPI = {
    clearInterval: clearInterval,
    clearTimeout: clearTimeout,
    setInterval: setInterval,
    setTimeout: setTimeout
  }; // For more on why we have the check here,
  // checkout https://github.com/testing-library/dom-testing-library/issues/914

  if (typeof setImmediate === 'function') {
    timerAPI.setImmediate = setImmediate;
  }
  if (typeof clearImmediate === 'function') {
    timerAPI.clearImmediate = clearImmediate;
  }
  jest.useRealTimers();
  var callbackReturnValue = callback();
  var usedFakeTimers = Object.entries(timerAPI).some(function (_ref) {
    var name = _ref[0],
      func = _ref[1];
    return func !== globalObj[name];
  });
  if (usedFakeTimers) {
    var _timerAPI$setTimeout;
    jest.useFakeTimers((_timerAPI$setTimeout = timerAPI.setTimeout) != null && _timerAPI$setTimeout.clock ? 'modern' : 'legacy');
  }
  return {
    callbackReturnValue: callbackReturnValue,
    usedFakeTimers: usedFakeTimers
  };
}
function jestFakeTimersAreEnabled() {
  return hasJestTimers() ? runWithJestRealTimers(function () {}).usedFakeTimers :
  // istanbul ignore next
  false;
} // we only run our tests in node, and setImmediate is supported in node.
// istanbul ignore next

function setImmediatePolyfill(fn) {
  return globalObj.setTimeout(fn, 0);
}
function getTimeFunctions() {
  // istanbul ignore next
  return {
    clearTimeoutFn: globalObj.clearTimeout,
    setImmediateFn: globalObj.setImmediate || setImmediatePolyfill,
    setTimeoutFn: globalObj.setTimeout
  };
}
var _runWithRealTimers = runWithRealTimers(getTimeFunctions),
  clearTimeoutFn = _runWithRealTimers.clearTimeoutFn,
  setImmediateFn = _runWithRealTimers.setImmediateFn,
  setTimeoutFn = _runWithRealTimers.setTimeoutFn;
function getDocument() {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    throw new Error('Could not find default container');
  }
  return window.document;
}
function getWindowFromNode(node) {
  if (node.defaultView) {
    // node is document
    return node.defaultView;
  } else if (node.ownerDocument && node.ownerDocument.defaultView) {
    // node is a DOM node
    return node.ownerDocument.defaultView;
  } else if (node.window) {
    // node is window
    return node.window;
  } else if (node.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    // The user passed something unusual to a calling function
    throw new Error("Unable to find the \"window\" object for the given node. Please file an issue with the code that's causing you to see this error: https://github.com/testing-library/dom-testing-library/issues/new");
  }
}
function checkContainerType(container) {
  if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
  }
  function getTypeName(object) {
    if (typeof object === 'object') {
      return object === null ? 'null' : object.constructor.name;
    }
    return typeof object;
  }
}
function inCypress(dom) {
  var window = dom.ownerDocument && dom.ownerDocument.defaultView || undefined;
  return typeof global !== 'undefined' && global.Cypress || typeof window !== 'undefined' && window.Cypress;
}
var inNode = function inNode() {
  return typeof process !== 'undefined' && process.versions !== undefined && process.versions.node !== undefined;
};
var getMaxLength = function getMaxLength(dom) {
  return inCypress(dom) ? 0 : typeof process !== 'undefined' && process.env.DEBUG_PRINT_LIMIT || 7000;
};
var _prettyFormat$plugins = prettyFormat.plugins,
  DOMElement$1 = _prettyFormat$plugins.DOMElement,
  DOMCollection$1 = _prettyFormat$plugins.DOMCollection;
function prettyDOM(dom, maxLength, options) {
  if (!dom) {
    dom = getDocument().body;
  }
  if (typeof maxLength !== 'number') {
    maxLength = getMaxLength(dom);
  }
  if (maxLength === 0) {
    return '';
  }
  if (dom.documentElement) {
    dom = dom.documentElement;
  }
  var domTypeName = typeof dom;
  if (domTypeName === 'object') {
    domTypeName = dom.constructor.name;
  } else {
    // To don't fall with `in` operator
    dom = {};
  }
  if (!('outerHTML' in dom)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  var debugContent = prettyFormat(dom, _extends({
    plugins: [DOMElement$1, DOMCollection$1],
    printFunctionName: false,
    highlight: inNode()
  }, options));
  return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
var logDOM = function logDOM() {
  var userCodeFrame = getUserCodeFrame();
  if (userCodeFrame) {
    console.log(prettyDOM.apply(void 0, arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM.apply(void 0, arguments));
  }
};

// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
var config = {
  testIdAttribute: 'data-testid',
  asyncUtilTimeout: 1000,
  // this is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: function asyncWrapper(cb) {
    return cb();
  },
  eventWrapper: function eventWrapper(cb) {
    return cb();
  },
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError: function getElementError(message, container) {
    var error = new Error([message, prettyDOM(container)].filter(Boolean).join('\n\n'));
    error.name = 'TestingLibraryElementError';
    return error;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
var DEFAULT_IGNORE_TAGS = 'script, style';
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === 'function') {
    // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
  } // Merge the incoming config delta

  config = _extends({}, config, newConfig);
}
function getConfig() {
  return config;
}
var labelledNodeNames = ['button', 'meter', 'output', 'progress', 'select', 'textarea', 'input'];
function getTextContent(node) {
  if (labelledNodeNames.includes(node.nodeName.toLowerCase())) {
    return '';
  }
  if (node.nodeType === TEXT_NODE) return node.textContent;
  return Array.from(node.childNodes).map(function (childNode) {
    return getTextContent(childNode);
  }).join('');
}
function getLabelContent(element) {
  var textContent;
  if (element.tagName.toLowerCase() === 'label') {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
} // Based on https://github.com/eps1lon/dom-accessibility-api/pull/352

function getRealLabels(element) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
  if (element.labels !== undefined) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable(element)) return [];
  var labels = element.ownerDocument.querySelectorAll('label');
  return Array.from(labels).filter(function (label) {
    return label.control === element;
  });
}
function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}
function getLabels$1(container, element, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$selector = _ref.selector,
    selector = _ref$selector === void 0 ? '*' : _ref$selector;
  var ariaLabelledBy = element.getAttribute('aria-labelledby');
  var labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
  return labelsId.length ? labelsId.map(function (labelId) {
    var labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: '',
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map(function (label) {
    var textToMatch = getLabelContent(label);
    var formControlSelector = 'button, input, meter, output, progress, select, textarea';
    var labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(function (formControlElement) {
      return formControlElement.matches(selector);
    })[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}
function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === undefined) {
    throw new Error(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
    "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
  }
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  var normalizedText = normalizer(textToMatch);
  if (typeof matcher === 'string' || typeof matcher === 'number') {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === 'function') {
    return matcher(normalizedText, node);
  } else {
    return matcher.test(normalizedText);
  }
}
function matches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  var normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node);
  } else if (matcher instanceof RegExp) {
    return matcher.test(normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? true : _ref$trim,
    _ref$collapseWhitespa = _ref.collapseWhitespace,
    collapseWhitespace = _ref$collapseWhitespa === void 0 ? true : _ref$collapseWhitespa;
  return function (text) {
    var normalizedText = text;
    normalizedText = trim ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
    return normalizedText;
  };
}
/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */

function makeNormalizer(_ref2) {
  var trim = _ref2.trim,
    collapseWhitespace = _ref2.collapseWhitespace,
    normalizer = _ref2.normalizer;
  if (normalizer) {
    // User has specified a custom normalizer
    if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') {
      // They've also specified a value for trim or collapseWhitespace
      throw new Error('trim and collapseWhitespace are not supported with a normalizer. ' + 'If you want to use the default trim and collapseWhitespace logic in your normalizer, ' + 'use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
    }
    return normalizer;
  } else {
    // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
      trim: trim,
      collapseWhitespace: collapseWhitespace
    });
  }
}
function getNodeText(node) {
  if (node.matches('input[type=submit], input[type=button]')) {
    return node.value;
  }
  return Array.from(node.childNodes).filter(function (child) {
    return child.nodeType === TEXT_NODE && Boolean(child.textContent);
  }).map(function (c) {
    return c.textContent;
  }).join('');
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var elementRoleList = buildElementRoleList(lib_2);
/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */

function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute('aria-hidden') === 'true') {
    return true;
  }
  var window = element.ownerDocument.defaultView;
  if (window.getComputedStyle(element).display === 'none') {
    return true;
  }
  return false;
}
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */

function isInaccessible(element, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$isSubtreeIna = _options.isSubtreeInaccessible,
    isSubtreeInaccessibleImpl = _options$isSubtreeIna === void 0 ? isSubtreeInaccessible : _options$isSubtreeIna;
  var window = element.ownerDocument.defaultView; // since visibility is inherited we can exit early

  if (window.getComputedStyle(element).visibility === 'hidden') {
    return true;
  }
  var currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles(currentNode) {
  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (var _iterator = _createForOfIteratorHelperLoose(elementRoleList), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
      match = _step$value.match,
      roles = _step$value.roles;
    if (match(currentNode)) {
      return [].concat(roles);
    }
  }
  return [];
}
function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref) {
    var name = _ref.name,
      attributes = _ref.attributes;
    return "" + name + attributes.map(function (_ref2) {
      var attributeName = _ref2.name,
        value = _ref2.value,
        _ref2$constraints = _ref2.constraints,
        constraints = _ref2$constraints === void 0 ? [] : _ref2$constraints;
      var shouldNotExist = constraints.indexOf('undefined') !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + "=\"" + value + "\"]";
      } else {
        return "[" + attributeName + "]";
      }
    }).join('');
  }
  function getSelectorSpecificity(_ref3) {
    var _ref3$attributes = _ref3.attributes,
      attributes = _ref3$attributes === void 0 ? [] : _ref3$attributes;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    var leftSpecificity = _ref4.specificity;
    var rightSpecificity = _ref5.specificity;
    return rightSpecificity - leftSpecificity;
  }
  function match(element) {
    return function (node) {
      var _element$attributes = element.attributes,
        attributes = _element$attributes === void 0 ? [] : _element$attributes; // https://github.com/testing-library/dom-testing-library/issues/814

      var typeTextIndex = attributes.findIndex(function (attribute) {
        return attribute.value && attribute.name === 'type' && attribute.value === 'text';
      });
      if (typeTextIndex >= 0) {
        // not using splice to not mutate the attributes array
        attributes = [].concat(attributes.slice(0, typeTextIndex), attributes.slice(typeTextIndex + 1));
        if (node.type !== 'text') {
          return false;
        }
      }
      return node.matches(makeElementSelector(_extends({}, element, {
        attributes: attributes
      })));
    };
  }
  var result = []; // eslint bug here:
  // eslint-disable-next-line no-unused-vars

  for (var _iterator2 = _createForOfIteratorHelperLoose(elementRolesMap.entries()), _step2; !(_step2 = _iterator2()).done;) {
    var _step2$value = _step2.value,
      element = _step2$value[0],
      roles = _step2$value[1];
    result = [].concat(result, [{
      match: match(element),
      roles: Array.from(roles),
      specificity: getSelectorSpecificity(element)
    }]);
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
  var _ref6 = _temp === void 0 ? {} : _temp,
    _ref6$hidden = _ref6.hidden,
    hidden = _ref6$hidden === void 0 ? false : _ref6$hidden;
  function flattenDOM(node) {
    return [node].concat(Array.from(node.children).reduce(function (acc, child) {
      return [].concat(acc, flattenDOM(child));
    }, []));
  }
  return flattenDOM(container).filter(function (element) {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce(function (acc, node) {
    var roles = []; // TODO: This violates html-aria which does not allow any role on every element

    if (node.hasAttribute('role')) {
      roles = node.getAttribute('role').split(' ').slice(0, 1);
    } else {
      roles = getImplicitAriaRoles(node);
    }
    return roles.reduce(function (rolesAcc, role) {
      var _extends2, _extends3;
      return Array.isArray(rolesAcc[role]) ? _extends({}, rolesAcc, (_extends2 = {}, _extends2[role] = [].concat(rolesAcc[role], [node]), _extends2)) : _extends({}, rolesAcc, (_extends3 = {}, _extends3[role] = [node], _extends3));
    }, acc);
  }, {});
}
function prettyRoles(dom, _ref7) {
  var hidden = _ref7.hidden;
  var roles = getRoles(dom, {
    hidden: hidden
  }); // We prefer to skip generic role, we don't recommend it

  return Object.entries(roles).filter(function (_ref8) {
    var role = _ref8[0];
    return role !== 'generic';
  }).map(function (_ref9) {
    var role = _ref9[0],
      elements = _ref9[1];
    var delimiterBar = '-'.repeat(50);
    var elementsString = elements.map(function (el) {
      var nameString = "Name \"" + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + "\":\n";
      var domString = prettyDOM(el.cloneNode(false));
      return "" + nameString + domString;
    }).join('\n\n');
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join('\n');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */

function computeAriaSelected(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-97
  if (element.tagName === 'OPTION') {
    return element.selected;
  } // explicit value

  return checkBooleanAttribute(element, 'aria-selected');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */

function computeAriaChecked(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-56
  // https://www.w3.org/TR/html-aam-1.0/#details-id-67
  if ('indeterminate' in element && element.indeterminate) {
    return undefined;
  }
  if ('checked' in element) {
    return element.checked;
  } // explicit value

  return checkBooleanAttribute(element, 'aria-checked');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */

function computeAriaPressed(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
  return checkBooleanAttribute(element, 'aria-pressed');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */

function computeAriaExpanded(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  return checkBooleanAttribute(element, 'aria-expanded');
}
function checkBooleanAttribute(element, attribute) {
  var attributeValue = element.getAttribute(attribute);
  if (attributeValue === 'true') {
    return true;
  }
  if (attributeValue === 'false') {
    return false;
  }
  return undefined;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */

function computeHeadingLevel(element) {
  // https://w3c.github.io/html-aam/#el-h1-h6
  // https://w3c.github.io/html-aam/#el-h1-h6
  var implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  }; // explicit aria-level value
  // https://www.w3.org/TR/wai-aria-1.2/#aria-level

  var ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
var normalize$1 = getDefaultNormalizer();
function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function getRegExpMatcher(string) {
  return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}
function makeSuggestion(queryName, element, content, _ref) {
  var variant = _ref.variant,
    name = _ref.name;
  var warning = '';
  var queryOptions = {};
  var queryArgs = [['Role', 'TestId'].includes(queryName) ? content : getRegExpMatcher(content)];
  if (name) {
    queryOptions.name = getRegExpMatcher(name);
  }
  if (queryName === 'Role' && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  var queryMethod = variant + "By" + queryName;
  return {
    queryName: queryName,
    queryMethod: queryMethod,
    queryArgs: queryArgs,
    variant: variant,
    warning: warning,
    toString: function toString() {
      if (warning) {
        console.warn(warning);
      }
      var text = queryArgs[0],
        options = queryArgs[1];
      text = typeof text === 'string' ? "'" + text + "'" : text;
      options = options ? ", { " + Object.entries(options).map(function (_ref2) {
        var k = _ref2[0],
          v = _ref2[1];
        return k + ": " + v;
      }).join(', ') + " }" : '';
      return queryMethod + "(" + text + options + ")";
    }
  };
}
function canSuggest(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant === void 0) {
    variant = 'get';
  }

  // don't create suggestions for script and style elements
  if (element.matches(DEFAULT_IGNORE_TAGS)) {
    return undefined;
  } //We prefer to suggest something else if the role is generic

  var role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== 'generic' && canSuggest('Role', method, role)) {
    return makeSuggestion('Role', element, role, {
      variant: variant,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }
  var labelText = getLabels$1(document, element).map(function (label) {
    return label.content;
  }).join(' ');
  if (canSuggest('LabelText', method, labelText)) {
    return makeSuggestion('LabelText', element, labelText, {
      variant: variant
    });
  }
  var placeholderText = element.getAttribute('placeholder');
  if (canSuggest('PlaceholderText', method, placeholderText)) {
    return makeSuggestion('PlaceholderText', element, placeholderText, {
      variant: variant
    });
  }
  var textContent = normalize$1(getNodeText(element));
  if (canSuggest('Text', method, textContent)) {
    return makeSuggestion('Text', element, textContent, {
      variant: variant
    });
  }
  if (canSuggest('DisplayValue', method, element.value)) {
    return makeSuggestion('DisplayValue', element, normalize$1(element.value), {
      variant: variant
    });
  }
  var alt = element.getAttribute('alt');
  if (canSuggest('AltText', method, alt)) {
    return makeSuggestion('AltText', element, alt, {
      variant: variant
    });
  }
  var title = element.getAttribute('title');
  if (canSuggest('Title', method, title)) {
    return makeSuggestion('Title', element, title, {
      variant: variant
    });
  }
  var testId = element.getAttribute(getConfig().testIdAttribute);
  if (canSuggest('TestId', method, testId)) {
    return makeSuggestion('TestId', element, testId, {
      variant: variant
    });
  }
  return undefined;
}

// closer to their code (because async stack traces are hard to follow).

function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
  var _ref$container = _ref.container,
    container = _ref$container === void 0 ? getDocument() : _ref$container,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? getConfig().asyncUtilTimeout : _ref$timeout,
    _ref$showOriginalStac = _ref.showOriginalStackTrace,
    showOriginalStackTrace = _ref$showOriginalStac === void 0 ? getConfig().showOriginalStackTrace : _ref$showOriginalStac,
    stackTraceError = _ref.stackTraceError,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? 50 : _ref$interval,
    _ref$onTimeout = _ref.onTimeout,
    onTimeout = _ref$onTimeout === void 0 ? function (error) {
      error.message = getConfig().getElementError(error.message, container).message;
      return error;
    } : _ref$onTimeout,
    _ref$mutationObserver = _ref.mutationObserverOptions,
    mutationObserverOptions = _ref$mutationObserver === void 0 ? {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    } : _ref$mutationObserver;
  if (typeof callback !== 'function') {
    throw new TypeError('Received `callback` arg must be a function');
  }
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(resolve, reject) {
      var lastError, intervalId, observer, finished, promiseStatus, overallTimeoutTimer, usingJestFakeTimers, error, _getWindowFromNode, MutationObserver, onDone, checkRealTimersCallback, checkCallback, handleTimeout;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleTimeout = function _handleTimeout() {
                var error;
                if (lastError) {
                  error = lastError;
                  if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') {
                    copyStackTrace(error, stackTraceError);
                  }
                } else {
                  error = new Error('Timed out in waitFor.');
                  if (!showOriginalStackTrace) {
                    copyStackTrace(error, stackTraceError);
                  }
                }
                onDone(onTimeout(error), null);
              };
              checkCallback = function _checkCallback() {
                if (promiseStatus === 'pending') return;
                try {
                  var result = runWithExpensiveErrorDiagnosticsDisabled(callback);
                  if (typeof (result == null ? void 0 : result.then) === 'function') {
                    promiseStatus = 'pending';
                    result.then(function (resolvedValue) {
                      promiseStatus = 'resolved';
                      onDone(null, resolvedValue);
                    }, function (rejectedValue) {
                      promiseStatus = 'rejected';
                      lastError = rejectedValue;
                    });
                  } else {
                    onDone(null, result);
                  } // If `callback` throws, wait for the next mutation, interval, or timeout.
                } catch (error) {
                  // Save the most recent callback error to reject the promise with it in the event of a timeout
                  lastError = error;
                }
              };
              checkRealTimersCallback = function _checkRealTimersCallb() {
                if (jestFakeTimersAreEnabled()) {
                  var _error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
                  if (!showOriginalStackTrace) copyStackTrace(_error, stackTraceError);
                  return reject(_error);
                } else {
                  return checkCallback();
                }
              };
              onDone = function _onDone(error, result) {
                finished = true;
                clearTimeoutFn(overallTimeoutTimer);
                if (!usingJestFakeTimers) {
                  clearInterval(intervalId);
                  observer.disconnect();
                }
                if (error) {
                  reject(error);
                } else {
                  resolve(result);
                }
              };
              finished = false;
              promiseStatus = 'idle';
              overallTimeoutTimer = setTimeoutFn(handleTimeout, timeout);
              usingJestFakeTimers = jestFakeTimersAreEnabled();
              if (!usingJestFakeTimers) {
                _context.next = 24;
                break;
              }
              checkCallback();
            // this is a dangerous rule to disable because it could lead to an
            // infinite loop. However, eslint isn't smart enough to know that we're
            // setting finished inside `onDone` which will be called when we're done
            // waiting or when we've timed out.
            // eslint-disable-next-line no-unmodified-loop-condition

            case 10:
              if (finished) {
                _context.next = 22;
                break;
              }
              if (jestFakeTimersAreEnabled()) {
                _context.next = 16;
                break;
              }
              error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
              if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
              reject(error);
              return _context.abrupt("return");
            case 16:
              // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
              // possible that could make this loop go on forever if someone is using
              // third party code that's setting up recursive timers so rapidly that
              // the user's timer's don't get a chance to resolve. So we'll advance
              // by an interval instead. (We have a test for this case).
              jest.advanceTimersByTime(interval); // It's really important that checkCallback is run *before* we flush
              // in-flight promises. To be honest, I'm not sure why, and I can't quite
              // think of a way to reproduce the problem in a test, but I spent
              // an entire day banging my head against a wall on this.

              checkCallback(); // In this rare case, we *need* to wait for in-flight promises
              // to resolve before continuing. We don't need to take advantage
              // of parallelization so we're fine.
              // https://stackoverflow.com/a/59243586/971592
              // eslint-disable-next-line no-await-in-loop

              _context.next = 20;
              return new Promise(function (r) {
                return setImmediateFn(r);
              });
            case 20:
              _context.next = 10;
              break;
            case 22:
              _context.next = 37;
              break;
            case 24:
              _context.prev = 24;
              checkContainerType(container);
              _context.next = 32;
              break;
            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](24);
              reject(_context.t0);
              return _context.abrupt("return");
            case 32:
              intervalId = setInterval(checkRealTimersCallback, interval);
              _getWindowFromNode = getWindowFromNode(container), MutationObserver = _getWindowFromNode.MutationObserver;
              observer = new MutationObserver(checkRealTimersCallback);
              observer.observe(container, mutationObserverOptions);
              checkCallback();
            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[24, 28]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function waitForWrapper(callback, options) {
  // create the error here so its stack trace is as close to the
  // calling code as possible
  var stackTraceError = new Error('STACK_TRACE_MESSAGE');
  return getConfig().asyncWrapper(function () {
    return waitFor(callback, _extends({
      stackTraceError: stackTraceError
    }, options));
  });
}
/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/

function getElementError(message, container) {
  return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    trim = _ref.trim,
    normalizer = _ref.normalizer;
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(function (node) {
    return matcher(node.getAttribute(attribute), node, text, matchNormalizer);
  });
}
// if more than one elements is returned, otherwise it returns the first
// element or null

function makeSingleQuery(allQuery, getMultipleError) {
  return function (container) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    var els = allQuery.apply(void 0, [container].concat(args));
    if (els.length > 1) {
      var elementStrings = els.map(function (element) {
        return getElementError(null, element).message;
      }).join('\n\n');
      throw getMultipleElementsFoundError(getMultipleError.apply(void 0, [container].concat(args)) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
    }
    return els[0] || null;
  };
}
function getSuggestionError(suggestion, container) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
} // this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned

function makeGetAllQuery(allQuery, getMissingError) {
  return function (container) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    var els = allQuery.apply(void 0, [container].concat(args));
    if (!els.length) {
      throw getConfig().getElementError(getMissingError.apply(void 0, [container].concat(args)), container);
    }
    return els;
  };
} // this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.

function makeFindQuery(getter) {
  return function (container, text, options, waitForOptions) {
    return waitForWrapper(function () {
      return getter(container, text, options);
    }, _extends({
      container: container
    }, waitForOptions));
  };
}
var wrapSingleQueryWithSuggestion = function wrapSingleQueryWithSuggestion(query, queryAllByName, variant) {
  return function (container) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    var element = query.apply(void 0, [container].concat(args));
    var _args$slice = args.slice(-1),
      _args$slice$ = _args$slice[0];
    _args$slice$ = _args$slice$ === void 0 ? {} : _args$slice$;
    var _args$slice$$suggest = _args$slice$.suggest,
      suggest = _args$slice$$suggest === void 0 ? getConfig().throwSuggestions : _args$slice$$suggest;
    if (element && suggest) {
      var suggestion = getSuggestedQuery(element, variant);
      if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
        throw getSuggestionError(suggestion.toString(), container);
      }
    }
    return element;
  };
};
var wrapAllByQueryWithSuggestion = function wrapAllByQueryWithSuggestion(query, queryAllByName, variant) {
  return function (container) {
    for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      args[_key5 - 1] = arguments[_key5];
    }
    var els = query.apply(void 0, [container].concat(args));
    var _args$slice2 = args.slice(-1),
      _args$slice2$ = _args$slice2[0];
    _args$slice2$ = _args$slice2$ === void 0 ? {} : _args$slice2$;
    var _args$slice2$$suggest = _args$slice2$.suggest,
      suggest = _args$slice2$$suggest === void 0 ? getConfig().throwSuggestions : _args$slice2$$suggest;
    if (els.length && suggest) {
      // get a unique list of all suggestion messages.  We are only going to make a suggestion if
      // all the suggestions are the same
      var uniqueSuggestionMessages = [].concat(new Set(els.map(function (element) {
        var _getSuggestedQuery;
        return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
      })));
      if (
      // only want to suggest if all the els have the same suggestion.
      uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(getSuggestedQuery(els[0], variant).queryName)) {
        throw getSuggestionError(uniqueSuggestionMessages[0], container);
      }
    }
    return els;
  };
};
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
  var queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
  var getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
  var getBy = makeSingleQuery(getAllBy, getMultipleError);
  var getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
  var getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
  var findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
  var findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}
function queryAllLabels(container) {
  return Array.from(container.querySelectorAll('label,input')).map(function (node) {
    return {
      node: node,
      textToMatch: getLabelContent(node)
    };
  }).filter(function (_ref) {
    var textToMatch = _ref.textToMatch;
    return textToMatch !== null;
  });
}
var queryAllLabelsByText = function queryAllLabelsByText(container, text, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$exact = _ref2.exact,
    exact = _ref2$exact === void 0 ? true : _ref2$exact,
    trim = _ref2.trim,
    collapseWhitespace = _ref2.collapseWhitespace,
    normalizer = _ref2.normalizer;
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  var textToMatchByLabels = queryAllLabels(container);
  return textToMatchByLabels.filter(function (_ref3) {
    var node = _ref3.node,
      textToMatch = _ref3.textToMatch;
    return matcher(textToMatch, node, text, matchNormalizer);
  }).map(function (_ref4) {
    var node = _ref4.node;
    return node;
  });
};
var queryAllByLabelText = function queryAllByLabelText(container, text, _temp2) {
  var _ref5 = _temp2 === void 0 ? {} : _temp2,
    _ref5$selector = _ref5.selector,
    selector = _ref5$selector === void 0 ? '*' : _ref5$selector,
    _ref5$exact = _ref5.exact,
    exact = _ref5$exact === void 0 ? true : _ref5$exact,
    collapseWhitespace = _ref5.collapseWhitespace,
    trim = _ref5.trim,
    normalizer = _ref5.normalizer;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  var matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(function (element) {
    return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
  }).reduce(function (labelledElements, labelledElement) {
    var labelList = getLabels$1(container, labelledElement, {
      selector: selector
    });
    labelList.filter(function (label) {
      return Boolean(label.formControl);
    }).forEach(function (label) {
      if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
    });
    var labelsValue = labelList.filter(function (label) {
      return Boolean(label.content);
    }).map(function (label) {
      return label.content;
    });
    if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
    if (labelsValue.length > 1) {
      labelsValue.forEach(function (labelValue, index) {
        if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        var labelsFiltered = [].concat(labelsValue);
        labelsFiltered.splice(index, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        }
      });
    }
    return labelledElements;
  }, []).concat(
  // TODO: Remove ignore after `queryAllByAttribute` will be moved to TS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  queryAllByAttribute('aria-label', container, text, {
    exact: exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter(function (element) {
    return element.matches(selector);
  });
}; // the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.

var getAllByLabelText = function getAllByLabelText(container, text) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  var els = queryAllByLabelText.apply(void 0, [container, text].concat(rest));
  if (!els.length) {
    var labels = queryAllLabelsByText.apply(void 0, [container, text].concat(rest));
    if (labels.length) {
      var tagNames = labels.map(function (label) {
        return getTagNameOfElementAssociatedWithLabelViaFor(container, label);
      }).filter(function (tagName) {
        return !!tagName;
      });
      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map(function (tagName) {
          return "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.";
        }).join('\n\n'), container);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
  var htmlFor = label.getAttribute('for');
  if (!htmlFor) {
    return null;
  }
  var element = container.querySelector("[id=\"" + htmlFor + "\"]");
  return element ? element.tagName.toLowerCase() : null;
} // the reason mentioned above is the same reason we're not using buildQueries

var getMultipleError$7 = function getMultipleError(c, text) {
  return "Found multiple elements with the text of: " + text;
};
var queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
var getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
var findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
var findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
var getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
var getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
var queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');
var queryAllByPlaceholderText = function queryAllByPlaceholderText() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]); // TODO: Remove ignore after `queryAllByAttribute` will be moved to TS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error

  return queryAllByAttribute.apply(void 0, ['placeholder'].concat(args));
};
var getMultipleError$6 = function getMultipleError(c, text) {
  return "Found multiple elements with the placeholder text of: " + text;
};
var getMissingError$6 = function getMissingError(c, text) {
  return "Unable to find an element with the placeholder text of: " + text;
};
var queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
var _buildQueries$6 = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6),
  queryByPlaceholderText = _buildQueries$6[0],
  getAllByPlaceholderText = _buildQueries$6[1],
  getByPlaceholderText = _buildQueries$6[2],
  findAllByPlaceholderText = _buildQueries$6[3],
  findByPlaceholderText = _buildQueries$6[4];
var queryAllByText = function queryAllByText(container, text, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$selector = _ref.selector,
    selector = _ref$selector === void 0 ? '*' : _ref$selector,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    trim = _ref.trim,
    _ref$ignore = _ref.ignore,
    ignore = _ref$ignore === void 0 ? DEFAULT_IGNORE_TAGS : _ref$ignore,
    normalizer = _ref.normalizer;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  var baseArray = [];
  if (typeof container.matches === 'function' && container.matches(selector)) {
    baseArray = [container];
  }
  return [].concat(baseArray, Array.from(container.querySelectorAll(selector))) // TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
  .filter(function (node) {
    return !ignore || !node.matches(ignore);
  }).filter(function (node) {
    return matcher(getNodeText(node), node, text, matchNormalizer);
  });
};
var getMultipleError$5 = function getMultipleError(c, text) {
  return "Found multiple elements with the text: " + text;
};
var getMissingError$5 = function getMissingError(c, text) {
  return "Unable to find an element with the text: " + text + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
var queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
var _buildQueries$5 = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5),
  queryByText = _buildQueries$5[0],
  getAllByText = _buildQueries$5[1],
  getByText = _buildQueries$5[2],
  findAllByText = _buildQueries$5[3],
  findByText = _buildQueries$5[4];
var queryAllByDisplayValue = function queryAllByDisplayValue(container, value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    trim = _ref.trim,
    normalizer = _ref.normalizer;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  return Array.from(container.querySelectorAll("input,textarea,select")).filter(function (node) {
    if (node.tagName === 'SELECT') {
      var selectedOptions = Array.from(node.options).filter(function (option) {
        return option.selected;
      });
      return selectedOptions.some(function (optionNode) {
        return matcher(getNodeText(optionNode), optionNode, value, matchNormalizer);
      });
    } else {
      return matcher(node.value, node, value, matchNormalizer);
    }
  });
};
var getMultipleError$4 = function getMultipleError(c, value) {
  return "Found multiple elements with the display value: " + value + ".";
};
var getMissingError$4 = function getMissingError(c, value) {
  return "Unable to find an element with the display value: " + value + ".";
};
var queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
var _buildQueries$4 = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4),
  queryByDisplayValue = _buildQueries$4[0],
  getAllByDisplayValue = _buildQueries$4[1],
  getByDisplayValue = _buildQueries$4[2],
  findAllByDisplayValue = _buildQueries$4[3],
  findByDisplayValue = _buildQueries$4[4];
var queryAllByAltText = function queryAllByAltText(container, alt, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    trim = _ref.trim,
    normalizer = _ref.normalizer;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  return Array.from(container.querySelectorAll('img,input,area')).filter(function (node) {
    return matcher(node.getAttribute('alt'), node, alt, matchNormalizer);
  });
};
var getMultipleError$3 = function getMultipleError(c, alt) {
  return "Found multiple elements with the alt text: " + alt;
};
var getMissingError$3 = function getMissingError(c, alt) {
  return "Unable to find an element with the alt text: " + alt;
};
var queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
var _buildQueries$3 = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3),
  queryByAltText = _buildQueries$3[0],
  getAllByAltText = _buildQueries$3[1],
  getByAltText = _buildQueries$3[2],
  findAllByAltText = _buildQueries$3[3],
  findByAltText = _buildQueries$3[4];
var isSvgTitle = function isSvgTitle(node) {
  var _node$parentElement;
  return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};
var queryAllByTitle = function queryAllByTitle(container, text, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    trim = _ref.trim,
    normalizer = _ref.normalizer;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  return Array.from(container.querySelectorAll('[title], svg > title')).filter(function (node) {
    return matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer);
  });
};
var getMultipleError$2 = function getMultipleError(c, title) {
  return "Found multiple elements with the title: " + title + ".";
};
var getMissingError$2 = function getMissingError(c, title) {
  return "Unable to find an element with the title: " + title + ".";
};
var queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
var _buildQueries$2 = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2),
  queryByTitle = _buildQueries$2[0],
  getAllByTitle = _buildQueries$2[1],
  getByTitle = _buildQueries$2[2],
  findAllByTitle = _buildQueries$2[3],
  findByTitle = _buildQueries$2[4];
function queryAllByRole(container, role, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? true : _ref$exact,
    collapseWhitespace = _ref.collapseWhitespace,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? getConfig().defaultHidden : _ref$hidden,
    name = _ref.name,
    trim = _ref.trim,
    normalizer = _ref.normalizer,
    _ref$queryFallbacks = _ref.queryFallbacks,
    queryFallbacks = _ref$queryFallbacks === void 0 ? false : _ref$queryFallbacks,
    selected = _ref.selected,
    checked = _ref.checked,
    pressed = _ref.pressed,
    level = _ref.level,
    expanded = _ref.expanded;
  checkContainerType(container);
  var matcher = exact ? matches : fuzzyMatches;
  var matchNormalizer = makeNormalizer({
    collapseWhitespace: collapseWhitespace,
    trim: trim,
    normalizer: normalizer
  });
  if (selected !== undefined) {
    var _allRoles$get;

    // guard against unknown roles
    if (((_allRoles$get = lib_3.get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) {
      throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
  }
  if (checked !== undefined) {
    var _allRoles$get2;

    // guard against unknown roles
    if (((_allRoles$get2 = lib_3.get(role)) == null ? void 0 : _allRoles$get2.props['aria-checked']) === undefined) {
      throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
  }
  if (pressed !== undefined) {
    var _allRoles$get3;

    // guard against unknown roles
    if (((_allRoles$get3 = lib_3.get(role)) == null ? void 0 : _allRoles$get3.props['aria-pressed']) === undefined) {
      throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
  }
  if (level !== undefined) {
    // guard against using `level` option with any role other than `heading`
    if (role !== 'heading') {
      throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
  }
  if (expanded !== undefined) {
    var _allRoles$get4;

    // guard against unknown roles
    if (((_allRoles$get4 = lib_3.get(role)) == null ? void 0 : _allRoles$get4.props['aria-expanded']) === undefined) {
      throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
  }
  var subtreeIsInaccessibleCache = new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container.querySelectorAll('*')).filter(function (node) {
    var isRoleSpecifiedExplicitly = node.hasAttribute('role');
    if (isRoleSpecifiedExplicitly) {
      var roleValue = node.getAttribute('role');
      if (queryFallbacks) {
        return roleValue.split(' ').filter(Boolean).some(function (text) {
          return matcher(text, node, role, matchNormalizer);
        });
      } // if a custom normalizer is passed then let normalizer handle the role value

      if (normalizer) {
        return matcher(roleValue, node, role, matchNormalizer);
      } // other wise only send the first word to match

      var _roleValue$split = roleValue.split(' '),
        firstWord = _roleValue$split[0];
      return matcher(firstWord, node, role, matchNormalizer);
    }
    var implicitRoles = getImplicitAriaRoles(node);
    return implicitRoles.some(function (implicitRole) {
      return matcher(implicitRole, node, role, matchNormalizer);
    });
  }).filter(function (element) {
    if (selected !== undefined) {
      return selected === computeAriaSelected(element);
    }
    if (checked !== undefined) {
      return checked === computeAriaChecked(element);
    }
    if (pressed !== undefined) {
      return pressed === computeAriaPressed(element);
    }
    if (expanded !== undefined) {
      return expanded === computeAriaExpanded(element);
    }
    if (level !== undefined) {
      return level === computeHeadingLevel(element);
    } // don't care if aria attributes are unspecified

    return true;
  }).filter(function (element) {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  }).filter(function (element) {
    if (name === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name, function (text) {
      return text;
    });
  });
}
var getMultipleError$1 = function getMultipleError(c, role, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    name = _ref2.name;
  var nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  return "Found multiple elements with the role \"" + role + "\"" + nameHint;
};
var getMissingError$1 = function getMissingError(container, role, _temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$hidden = _ref3.hidden,
    hidden = _ref3$hidden === void 0 ? getConfig().defaultHidden : _ref3$hidden,
    name = _ref3.name;
  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return "Unable to find role=\"" + role + "\"";
  }
  var roles = '';
  Array.from(container.children).forEach(function (childElement) {
    roles += prettyRoles(childElement, {
      hidden: hidden,
      includeName: name !== undefined
    });
  });
  var roleMessage;
  if (roles.length === 0) {
    if (hidden === false) {
      roleMessage = 'There are no accessible roles. But there might be some inaccessible roles. ' + 'If you wish to access them, then set the `hidden` option to `true`. ' + 'Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole';
    } else {
      roleMessage = 'There are no available roles.';
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
  }
  var nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + "\n\n" + roleMessage).trim();
};
var queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
var _buildQueries$1 = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1),
  queryByRole = _buildQueries$1[0],
  getAllByRole = _buildQueries$1[1],
  getByRole = _buildQueries$1[2],
  findAllByRole = _buildQueries$1[3],
  findByRole = _buildQueries$1[4];
var getTestIdAttribute = function getTestIdAttribute() {
  return getConfig().testIdAttribute;
};
var queryAllByTestId = function queryAllByTestId() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]); // TODO: Remove ignore after `queryAllByAttribute` will be moved to TS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error

  return queryAllByAttribute.apply(void 0, [getTestIdAttribute()].concat(args));
};
var getMultipleError = function getMultipleError(c, id) {
  return "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
};
var getMissingError = function getMissingError(c, id) {
  return "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
};
var queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
var _buildQueries = buildQueries(queryAllByTestId, getMultipleError, getMissingError),
  queryByTestId = _buildQueries[0],
  getAllByTestId = _buildQueries[1],
  getByTestId = _buildQueries[2],
  findAllByTestId = _buildQueries[3],
  findByTestId = _buildQueries[4];
var queries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText: queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText: findAllByLabelText,
  findByLabelText: findByLabelText,
  queryByPlaceholderText: queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText: getByPlaceholderText,
  getAllByPlaceholderText: getAllByPlaceholderText,
  findAllByPlaceholderText: findAllByPlaceholderText,
  findByPlaceholderText: findByPlaceholderText,
  queryByText: queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText: getByText,
  getAllByText: getAllByText,
  findAllByText: findAllByText,
  findByText: findByText,
  queryByDisplayValue: queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue: getByDisplayValue,
  getAllByDisplayValue: getAllByDisplayValue,
  findAllByDisplayValue: findAllByDisplayValue,
  findByDisplayValue: findByDisplayValue,
  queryByAltText: queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText: getByAltText,
  getAllByAltText: getAllByAltText,
  findAllByAltText: findAllByAltText,
  findByAltText: findByAltText,
  queryByTitle: queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle: getByTitle,
  getAllByTitle: getAllByTitle,
  findAllByTitle: findAllByTitle,
  findByTitle: findByTitle,
  queryByRole: queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole: getAllByRole,
  getByRole: getByRole,
  findAllByRole: findAllByRole,
  findByRole: findByRole,
  queryByTestId: queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId: getByTestId,
  getAllByTestId: getAllByTestId,
  findAllByTestId: findAllByTestId,
  findByTestId: findByTestId
});

/**
 * @typedef {{[key: string]: Function}} FuncMap
 */

/**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */

function getQueriesForElement(element, queries$1, initialValue) {
  if (queries$1 === void 0) {
    queries$1 = queries;
  }
  if (initialValue === void 0) {
    initialValue = {};
  }
  return Object.keys(queries$1).reduce(function (helpers, key) {
    var fn = queries$1[key];
    helpers[key] = fn.bind(null, element);
    return helpers;
  }, initialValue);
}
var eventMap = {
  // Clipboard Events
  copy: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: 'InputEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  scroll: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: 'WheelEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Image Events
  load: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionEnd: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // pointer events
  pointerOver: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: 'PopStateEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  }
};
var eventAliasMap = {
  doubleClick: 'dblClick'
};
function fireEvent(element, event) {
  return getConfig().eventWrapper(function () {
    if (!event) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }
    if (!element) {
      throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
    }
    return element.dispatchEvent(event);
  });
}
function createEvent(eventName, node, init, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$EventType = _ref.EventType,
    EventType = _ref$EventType === void 0 ? 'Event' : _ref$EventType,
    _ref$defaultInit = _ref.defaultInit,
    defaultInit = _ref$defaultInit === void 0 ? {} : _ref$defaultInit;
  if (!node) {
    throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
  }
  var eventInit = _extends({}, defaultInit, init);
  var _eventInit$target = eventInit.target;
  _eventInit$target = _eventInit$target === void 0 ? {} : _eventInit$target;
  var value = _eventInit$target.value,
    files = _eventInit$target.files,
    targetProperties = _objectWithoutPropertiesLoose(_eventInit$target, ["value", "files"]);
  if (value !== undefined) {
    setNativeValue(node, value);
  }
  if (files !== undefined) {
    // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files
    });
  }
  Object.assign(node, targetProperties);
  var window = getWindowFromNode(node);
  var EventConstructor = window[EventType] || window.Event;
  var event;
  /* istanbul ignore else  */

  if (typeof EventConstructor === 'function') {
    event = new EventConstructor(eventName, eventInit);
  } else {
    // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = window.document.createEvent(EventType);
    var bubbles = eventInit.bubbles,
      cancelable = eventInit.cancelable,
      detail = eventInit.detail,
      otherInit = _objectWithoutPropertiesLoose(eventInit, ["bubbles", "cancelable", "detail"]);
    event.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach(function (eventKey) {
      event[eventKey] = otherInit[eventKey];
    });
  } // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568

  var dataTransferProperties = ['dataTransfer', 'clipboardData'];
  dataTransferProperties.forEach(function (dataTransferKey) {
    var dataTransferValue = eventInit[dataTransferKey];
    if (typeof dataTransferValue === 'object') {
      /* istanbul ignore if  */
      if (typeof window.DataTransfer === 'function') {
        Object.defineProperty(event, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce(function (acc, propName) {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window.DataTransfer())
        });
      } else {
        Object.defineProperty(event, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event;
}
Object.keys(eventMap).forEach(function (key) {
  var _eventMap$key = eventMap[key],
    EventType = _eventMap$key.EventType,
    defaultInit = _eventMap$key.defaultInit;
  var eventName = key.toLowerCase();
  createEvent[key] = function (node, init) {
    return createEvent(eventName, node, init, {
      EventType: EventType,
      defaultInit: defaultInit
    });
  };
  fireEvent[key] = function (node, init) {
    return fireEvent(node, createEvent[key](node, init));
  };
}); // function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776

function setNativeValue(element, value) {
  var _ref2 = Object.getOwnPropertyDescriptor(element, 'value') || {},
    valueSetter = _ref2.set;
  var prototype = Object.getPrototypeOf(element);
  var _ref3 = Object.getOwnPropertyDescriptor(prototype, 'value') || {},
    prototypeValueSetter = _ref3.set;
  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  }
  /* istanbul ignore next (I don't want to bother) */else if (valueSetter) {
    valueSetter.call(element, value);
  } else {
    throw new Error('The given element does not have a value setter');
  }
}
Object.keys(eventAliasMap).forEach(function (aliasKey) {
  var key = eventAliasMap[aliasKey];
  fireEvent[aliasKey] = function () {
    return fireEvent[key].apply(fireEvent, arguments);
  };
});
/* eslint complexity:["error", 9] */

function unindent(string) {
  // remove white spaces first, to save a few bytes.
  // testing-playground will reformat on load any ways.
  return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}
function encode(value) {
  return lzString_1(unindent(value));
}
function getPlaygroundUrl(markup) {
  return "https://testing-playground.com/#markup=" + encode(markup);
}
var debug = function debug(element, maxLength, options) {
  return Array.isArray(element) ? element.forEach(function (el) {
    return logDOM(el, maxLength, options);
  }) : logDOM(element, maxLength, options);
};
var logTestingPlaygroundURL = function logTestingPlaygroundURL(element) {
  if (element === void 0) {
    element = getDocument().body;
  }
  if (!element || !('innerHTML' in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  console.log("Open this URL in your browser\n\n" + getPlaygroundUrl(element.innerHTML));
};
var initialValue = {
  debug: debug,
  logTestingPlaygroundURL: logTestingPlaygroundURL
};
var screen = typeof document !== 'undefined' && document.body ? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce(function (helpers, key) {
  helpers[key] = function () {
    throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
  };
  return helpers;
}, initialValue);
var openMaterialUISelect = function openMaterialUISelect(input) {
  var button = getMaterialUISelectButton(input);
  fireEvent.mouseDown(button);
};
var getMaterialUISelectButton = function getMaterialUISelectButton(input) {
  return input.previousElementSibling;
};
var selectMaterialUIOption = function selectMaterialUIOption(input, optionIndex, component) {
  return __awaiter(void 0, void 0, void 0, function () {
    var options;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          openMaterialUISelect(input);
          options = [];
          return [4 /*yield*/, waitForWrapper(function () {
            options = component.getAllByRole('option');
          })];
        case 1:
          _a.sent();
          fireEvent.click(options[optionIndex]);
          return [2 /*return*/];
      }
    });
  });
};

var reactAct = act$1;
var actSupported = reactAct !== undefined; // act is supported react-dom@16.8.0
// so for versions that don't have act from test utils
// we do this little polyfill. No warnings, but it's
// better than nothing.

function actPolyfill(cb) {
  ReactDOM.unstable_batchedUpdates(cb);
  ReactDOM.render( /*#__PURE__*/createElement("div", null), document.createElement('div'));
}
var act = reactAct || actPolyfill;
var youHaveBeenWarned = false;
var isAsyncActSupported = null;
function asyncAct(cb) {
  if (actSupported === true) {
    if (isAsyncActSupported === null) {
      return new Promise(function (resolve, reject) {
        // patch console.error here
        var originalConsoleError = console.error;
        console.error = function error() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          /* if console.error fired *with that specific message* */

          /* istanbul ignore next */
          var firstArgIsString = typeof args[0] === 'string';
          if (firstArgIsString && args[0].indexOf('Warning: Do not await the result of calling ReactTestUtils.act') === 0) {
            // v16.8.6
            isAsyncActSupported = false;
          } else if (firstArgIsString && args[0].indexOf('Warning: The callback passed to ReactTestUtils.act(...) function must not return anything') === 0) ;else {
            originalConsoleError.apply(console, args);
          }
        };
        var cbReturn, result;
        try {
          result = reactAct(function () {
            cbReturn = cb();
            return cbReturn;
          });
        } catch (err) {
          console.error = originalConsoleError;
          reject(err);
          return;
        }
        result.then(function () {
          console.error = originalConsoleError; // if it got here, it means async act is supported

          isAsyncActSupported = true;
          resolve();
        }, function (err) {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          reject(err);
        }); // 16.8.6's act().then() doesn't call a resolve handler, so we need to manually flush here, sigh

        if (isAsyncActSupported === false) {
          console.error = originalConsoleError;
          /* istanbul ignore next */

          if (!youHaveBeenWarned) {
            // if act is supported and async act isn't and they're trying to use async
            // act, then they need to upgrade from 16.8 to 16.9.
            // This is a seamless upgrade, so we'll add a warning
            console.error("It looks like you're using a version of react-dom that supports the \"act\" function, but not an awaitable version of \"act\" which you will need. Please upgrade to at least react-dom@16.9.0 to remove this warning.");
            youHaveBeenWarned = true;
          }
          cbReturn.then(function () {
            // a faux-version.
            // todo - copy https://github.com/facebook/react/blob/master/packages/shared/enqueueTask.js
            Promise.resolve().then(function () {
              // use sync act to flush effects
              act(function () {});
              resolve();
            });
          }, reject);
        }
      });
    } else if (isAsyncActSupported === false) {
      // use the polyfill directly
      var _result;
      act(function () {
        _result = cb();
      });
      return _result.then(function () {
        return Promise.resolve().then(function () {
          // use sync act to flush effects
          act(function () {});
        });
      });
    } // all good! regular act

    return act(cb);
  } // use the polyfill

  var result;
  act(function () {
    result = cb();
  });
  return result.then(function () {
    return Promise.resolve().then(function () {
      // use sync act to flush effects
      act(function () {});
    });
  });
}
Object.keys(fireEvent).forEach(function (key) {}); // React event system tracks native mouseOver/mouseOut events for

configure({
  asyncWrapper: function () {
    var _asyncWrapper = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(cb) {
      var result;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return asyncAct( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
                return regenerator.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cb();
                      case 2:
                        result = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 2:
              return _context2.abrupt("return", result);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function asyncWrapper(_x) {
      return _asyncWrapper.apply(this, arguments);
    }
    return asyncWrapper;
  }(),
  eventWrapper: function eventWrapper(cb) {
    var result;
    act(function () {
      result = cb();
    });
    return result;
  }
});
var mountedContainers = new Set();
function render(ui, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    container = _ref2.container,
    _ref2$baseElement = _ref2.baseElement,
    baseElement = _ref2$baseElement === void 0 ? container : _ref2$baseElement,
    queries = _ref2.queries,
    _ref2$hydrate = _ref2.hydrate,
    hydrate = _ref2$hydrate === void 0 ? false : _ref2$hydrate,
    WrapperComponent = _ref2.wrapper;
  if (!baseElement) {
    // default to document.body instead of documentElement to avoid output of potentially-large
    // head elements (such as JSS style blocks) in debug output
    baseElement = document.body;
  }
  if (!container) {
    container = baseElement.appendChild(document.createElement('div'));
  } // we'll add it to the mounted containers regardless of whether it's actually
  // added to document.body so the cleanup method works regardless of whether
  // they're passing us a custom container or not.

  mountedContainers.add(container);
  var wrapUiIfNeeded = function wrapUiIfNeeded(innerElement) {
    return WrapperComponent ? /*#__PURE__*/createElement(WrapperComponent, null, innerElement) : innerElement;
  };
  act(function () {
    if (hydrate) {
      ReactDOM.hydrate(wrapUiIfNeeded(ui), container);
    } else {
      ReactDOM.render(wrapUiIfNeeded(ui), container);
    }
  });
  return _extends({
    container: container,
    baseElement: baseElement,
    debug: function debug(el, maxLength, options) {
      if (el === void 0) {
        el = baseElement;
      }
      return Array.isArray(el) ?
      // eslint-disable-next-line no-console
      el.forEach(function (e) {
        return console.log(prettyDOM(e, maxLength, options));
      }) :
      // eslint-disable-next-line no-console,
      console.log(prettyDOM(el, maxLength, options));
    },
    unmount: function unmount() {
      act(function () {
        ReactDOM.unmountComponentAtNode(container);
      });
    },
    rerender: function rerender(rerenderUi) {
      render(wrapUiIfNeeded(rerenderUi), {
        container: container,
        baseElement: baseElement
      }); // Intentionally do not return anything to avoid unnecessarily complicating the API.
      // folks can use all the same utilities we return in the first place that are bound to the container
    },

    asFragment: function asFragment() {
      /* istanbul ignore else (old jsdom limitation) */
      if (typeof document.createRange === 'function') {
        return document.createRange().createContextualFragment(container.innerHTML);
      } else {
        var template = document.createElement('template');
        template.innerHTML = container.innerHTML;
        return template.content;
      }
    }
  }, getQueriesForElement(baseElement, queries));
}
function cleanup() {
  mountedContainers.forEach(cleanupAtContainer);
} // maybe one day we'll expose this (perhaps even as a utility returned by render).
// but let's wait until someone asks for it.

function cleanupAtContainer(container) {
  act(function () {
    ReactDOM.unmountComponentAtNode(container);
  });
  if (container.parentNode === document.body) {
    document.body.removeChild(container);
  }
  mountedContainers.delete(container);
} // just re-export everything from dom-testing-library
// thing for people using react-dom@16.8.0. Anyone else doesn't need it and
// people should just upgrade anyway.

/* eslint func-name-matching:0 */

var _process$env;
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.

if (typeof process === "undefined" || !((_process$env = process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  // ignore teardown() in code coverage because Jest does not support it

  /* istanbul ignore else */
  if (typeof afterEach === 'function') {
    afterEach(function () {
      cleanup();
    });
  } else if (typeof teardown === 'function') {
    // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(function () {
      cleanup();
    });
  }
}
var renderWithStore = function renderWithStore(element, store) {
  var Wrapper = function Wrapper(_a) {
    var children = _a.children;
    return React__default.createElement(Provider, {
      store: store
    }, children);
  };
  return render(element, {
    wrapper: Wrapper
  });
};
var bladeAreaName = "REACT_TOOLS_BLADE_STATE";
var ActionTypes;
(function (ActionTypes) {
  ActionTypes["MARK_SHOULD_CLOSE"] = "MARK_SHOULD_CLOSE";
  ActionTypes["MARK_WAIT_CLOSE"] = "MARK_WAIT_CLOSE";
  ActionTypes["CREATE_BLADE"] = "CREATE_BLADE";
  ActionTypes["UPDATE_BLADE"] = "UPDATE_BLADE";
  ActionTypes["CLOSE_BLADE"] = "CLOSE_BLADE";
  ActionTypes["CLOSE_CHILDREN_BLADES"] = "CLOSE_CHILDREN_BLADES";
  ActionTypes["CANCEL_BLADE_CLOSE"] = "CANCEL_BLADE_CLOSE";
  ActionTypes["FORCE_CLOSE_BLADE"] = "FORCE_CLOSE_BLADE";
  ActionTypes["SET_BLADE_NEWLY_CREATED_STATE"] = "SET_BLADE_NEWLY_CREATED_STATE";
  ActionTypes["FREEZE_BLADES"] = "HIGHLIGHT_BLADES";
  ActionTypes["CLEAR_FROZEN_BLADES"] = "CLEAR_HIGHLIGHT_BLADES";
  ActionTypes["SET_TITLE"] = "SET_TITLE";
  ActionTypes["HARD_CLEAR_ALL_BLADES"] = "HARD_CLEAR_ALL_BLADES";
  ActionTypes["SET_FOCUSED"] = "SET_FOCUSED";
  ActionTypes["FORCE_CLOSE_CHILDREN_BLADES"] = "FORCE_CLOSE_CHILDREN_BLADES";
})(ActionTypes || (ActionTypes = {}));
var createBlade = function createBlade(blade) {
  return action(ActionTypes.CREATE_BLADE, blade);
};
var updateBlade = function updateBlade(blade) {
  return action(ActionTypes.UPDATE_BLADE, blade);
};
var closeBlade = function closeBlade(bladeId, actionAfterClosing, actionOnCancel) {
  return action(ActionTypes.CLOSE_BLADE, {
    bladeId: bladeId,
    actionAfterClosing: actionAfterClosing,
    actionOnCancel: actionOnCancel
  });
};
var closeChildrenBlades = function closeChildrenBlades(bladeId, actionAfterClosing, actionOnCancel) {
  return action(ActionTypes.CLOSE_CHILDREN_BLADES, {
    bladeId: bladeId,
    actionAfterClosing: actionAfterClosing,
    actionOnCancel: actionOnCancel
  });
};
var forceCloseChildrenBlades = function forceCloseChildrenBlades(bladeId) {
  return action(ActionTypes.FORCE_CLOSE_CHILDREN_BLADES, {
    bladeId: bladeId
  });
};
var cancelCloseBlade = function cancelCloseBlade() {
  return action(ActionTypes.CANCEL_BLADE_CLOSE);
};
var forceCloseBlade = function forceCloseBlade(bladeId) {
  return action(ActionTypes.FORCE_CLOSE_BLADE, bladeId);
};
var setBladeNewlyCreateState = function setBladeNewlyCreateState(bladeId, isNewlyCreated) {
  return action(ActionTypes.SET_BLADE_NEWLY_CREATED_STATE, {
    bladeId: bladeId,
    isNewlyCreated: isNewlyCreated
  });
};
var freezeBlades = function freezeBlades(bladeIds) {
  return action(ActionTypes.FREEZE_BLADES, bladeIds);
};
var clearFrozenBlades = function clearFrozenBlades(bladeIds) {
  return action(ActionTypes.CLEAR_FROZEN_BLADES, bladeIds);
};
var setTitle = function setTitle(bladeId, value) {
  return action(ActionTypes.SET_TITLE, {
    bladeId: bladeId,
    value: value
  });
};
var hardClearAllBlades = function hardClearAllBlades() {
  return action(ActionTypes.HARD_CLEAR_ALL_BLADES);
};
var setFocused = function setFocused(bladeId) {
  return action(ActionTypes.SET_FOCUSED, {
    bladeId: bladeId
  });
};
var BladeActions = {
  createBlade: createBlade,
  updateBlade: updateBlade,
  closeBlade: closeBlade,
  closeChildrenBlades: closeChildrenBlades,
  cancelCloseBlade: cancelCloseBlade,
  forceCloseBlade: forceCloseBlade,
  forceCloseChildrenBlades: forceCloseChildrenBlades,
  setBladeNewlyCreateState: setBladeNewlyCreateState,
  freezeBlades: freezeBlades,
  clearFrozenBlades: clearFrozenBlades,
  setTitle: setTitle,
  hardClearAllBlades: hardClearAllBlades,
  setFocused: setFocused
};
function denormalize(obj) {
  var arr = Object.keys(obj).map(function (k) {
    return obj[k];
  });
  return arr;
}
function normalize$2(arr, key) {
  return arr.reduce(function (obj, item) {
    obj[item[key]] = item;
    return obj;
  }, {});
}
/* eslint-disable no-extend-native */
Array.prototype._findBy = function (key, value) {
  return this.findIndex(function (t) {
    return t[key] === value;
  }) !== -1;
};
Array.prototype._findIndexBy = function (key, value) {
  return this.findIndex(function (t) {
    return t[key] === value;
  });
};
Array.prototype._difference = function (other) {
  return this.filter(function (f) {
    return other.indexOf(f) === -1;
  });
};
Array.prototype._insert = function (element, position) {
  this.splice(position, 0, element);
  return this;
};
String.prototype._contains = function (value, caseSensitive) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  if (caseSensitive) {
    return this.indexOf(value) !== -1;
  } else {
    return this.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  }
};
String.prototype._containsAny = function (values) {
  var _this = this;
  return values.some(function (v) {
    return _this.indexOf(v) !== -1;
  });
};
Number.prototype._padLeft2 = function () {
  var s = "0" + this.toString();
  return s.substr(s.length - 2, 2);
};
/* eslint-enable no-extend-native */

var selectActiveBlades = function selectActiveBlades(state) {
  return state[bladeAreaName].items;
};
var selectActiveBladesDenormalized = function selectActiveBladesDenormalized(state) {
  var items = selectActiveBlades(state);
  return denormalize(items);
};
var selectBladeById = function selectBladeById(state, bladeId) {
  var items = selectActiveBlades(state);
  return items[bladeId];
};
var selectFrozenBlades = function selectFrozenBlades(state) {
  var items = selectActiveBladesDenormalized(state);
  return items.filter(function (b) {
    return b.frozen;
  }).map(function (b) {
    return b.id;
  });
};
var selectClosingBlades = function selectClosingBlades(state) {
  var bladeState = state[bladeAreaName];
  return bladeState.itemsForClosing.map(function (id) {
    return bladeState.items[id];
  });
};
var selectFocusedBlade = function selectFocusedBlade(state) {
  var bladeState = state[bladeAreaName];
  var focusedBlade = denormalize(bladeState.items).filter(function (e) {
    return e.focused;
  });
  return focusedBlade.length ? focusedBlade[0] : null;
};
var selectPostClosingAction = function selectPostClosingAction(state) {
  var bladeState = state[bladeAreaName];
  return bladeState.postClosingAction;
};
var selectOnCloseCancelAction = function selectOnCloseCancelAction(state) {
  var bladeState = state[bladeAreaName];
  return bladeState.cancelClosingAction;
};
var BladeSelectors = {
  selectActiveBlades: selectActiveBlades,
  selectActiveBladesDenormalized: selectActiveBladesDenormalized,
  selectBladeById: selectBladeById,
  selectFrozenBlades: selectFrozenBlades,
  selectClosingBlades: selectClosingBlades,
  selectPostClosingAction: selectPostClosingAction,
  selectOnCloseCancelAction: selectOnCloseCancelAction
};
var styles = function styles(theme) {
  return createStyles({
    blade: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      position: "relative"
    },
    paper: {
      height: "100%",
      backgroundColor: theme.palette.grey[100]
    },
    content: {
      flexGrow: 1
    },
    dragHandle: {
      width: "4px",
      height: "100%",
      zIndex: 100,
      cursor: "col-resize",
      right: "-2px",
      position: "absolute",
      top: 0,
      "&:hover": {
        backgroundColor: theme.palette.grey[100]
      }
    },
    dragHandleActive: {
      zIndex: 100,
      backgroundColor: theme.palette.grey[500]
    },
    dragHandleActiveLessThanMin: {
      backgroudColor: "rgba(255, 0, 0, 0.2)"
    },
    noSelect: {
      userSelect: "none"
    }
  });
};
var errorBoundaryStyles = createStyles({
  error: {
    background: "red",
    display: "flex",
    alignItems: "center"
  },
  errorStack: {
    maxHeight: "300px",
    overflow: "auto"
  },
  icon: {
    color: "#ffffff",
    marginLeft: 16
  },
  message: {
    color: "#ffffff",
    marginLeft: 8
  },
  stack: {
    color: "#ffffff",
    marginLeft: 48
  }
});
var useStyles = makeStyles(styles);
var BladeErrorBoundaryUnstyled = /** @class */function (_super) {
  __extends(BladeErrorBoundaryUnstyled, _super);
  function BladeErrorBoundaryUnstyled(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      error: null,
      snackOpen: false
    };
    return _this;
  }
  BladeErrorBoundaryUnstyled.getDerivedStateFromError = function (error) {
    return {
      error: error,
      snackOpen: true
    };
  };
  BladeErrorBoundaryUnstyled.prototype.render = function () {
    var _a = this.props,
      classes = _a.classes,
      children = _a.children;
    var error = this.state.error;
    return error !== null ? React__default.createElement("div", null, React__default.createElement("div", {
      className: classes.error
    }, React__default.createElement(ErrorIcon, {
      className: classes.icon
    }), React__default.createElement(Typography, {
      variant: "h6",
      className: classes.message
    }, error.message)), React__default.createElement("div", {
      className: classNames(classes.error, classes.errorStack)
    }, React__default.createElement(Typography, {
      variant: "body2",
      className: classes.stack
    }, error.stack))) : children;
  };
  return BladeErrorBoundaryUnstyled;
}(React__default.Component);
var BladeErrorBoundary = withStyles(errorBoundaryStyles)(BladeErrorBoundaryUnstyled);
var defaultTheme = createMuiTheme();
var BladeHeaderThemeContext = createContext(defaultTheme);
var BladeHeaderThemeProvider = function BladeHeaderThemeProvider(props) {
  return React__default.createElement(BladeHeaderThemeContext.Provider, {
    value: props.theme
  }, props.children);
};
var BladeCache = /** @class */function () {
  function BladeCache() {}
  BladeCache.registerBladeType = function (config, component) {
    if (!this.isBladeTypeRegistered(config.bladeType)) {
      this.bladeConfigCache[config.bladeType] = {
        componentFactory: React__default.createFactory(component),
        config: config
      };
    }
  };
  BladeCache.getBladeConfig = function (bladeType) {
    if (this.isBladeTypeRegistered(bladeType)) {
      return this.bladeConfigCache[bladeType];
    }
    throw new Error("No blade defined for type " + bladeType);
  };
  BladeCache.isBladeTypeRegistered = function (bladeType) {
    return !!this.bladeConfigCache[bladeType];
  };
  BladeCache.registerBladeProps = function (bladeId, props) {
    if (this.bladeCache[bladeId]) {
      this.bladeCache[bladeId].props = _assign2(_assign2({}, this.bladeCache[bladeId].props), props);
    } else {
      this.bladeCache[bladeId] = {
        props: props
      };
    }
  };
  BladeCache.getBladeProps = function (bladeId) {
    if (this.areBladePropsRegistered(bladeId)) {
      return this.bladeCache[bladeId].props;
    }
    throw new Error("No props defined for blade id " + bladeId);
  };
  BladeCache.getBladeOnCloseProps = function (bladeId) {
    if (this.areBladePropsRegistered(bladeId)) {
      return {
        canClose: this.bladeCache[bladeId].canClose,
        onClose: this.bladeCache[bladeId].onClose
      };
    }
    throw new Error("No props defined for blade id " + bladeId);
  };
  BladeCache.getBladeInstanceCacheEntry = function (bladeId) {
    if (this.areBladePropsRegistered(bladeId)) {
      return this.bladeCache[bladeId];
    }
    throw new Error("No props defined for blade id " + bladeId);
  };
  BladeCache.registerClosingCallback = function (bladeId, canClose, onClose) {
    if (this.areBladePropsRegistered(bladeId)) {
      this.bladeCache[bladeId].canClose = canClose;
      this.bladeCache[bladeId].onClose = onClose;
    } else {
      throw new Error("No props defined for blade id " + bladeId);
    }
  };
  BladeCache.areBladePropsRegistered = function (bladeId) {
    return !!this.bladeCache[bladeId];
  };
  BladeCache.bladeConfigCache = {};
  BladeCache.bladeCache = {};
  return BladeCache;
}();
var BladesContextValue = {
  registerBladeClose: function registerBladeClose(bladeId, canClose, onClose) {
    return BladeCache.registerClosingCallback(bladeId, canClose, onClose);
  }
};
var closingBladesCallback = function closingBladesCallback(closingBlades) {
  closingBlades.forEach(function (blade) {
    var entry = BladeCache.getBladeInstanceCacheEntry(blade.id);
    if (entry.onClose) {
      entry.onClose();
    }
  });
};
var BladesContext = React__default.createContext(BladesContextValue);
var BladeRowContextProvider = function BladeRowContextProvider(props) {
  return React__default.createElement(BladesContext.Provider, {
    value: BladesContextValue
  }, props.children);
};
var BladeContext = React__default.createContext({
  updateBladeButtons: function updateBladeButtons() {
    return null;
  },
  buttons: []
});
var BladeContextProvider = function BladeContextProvider(props) {
  var _a = useState([]),
    buttons = _a[0],
    setButtons = _a[1];
  var value = {
    buttons: buttons,
    updateBladeButtons: function updateBladeButtons(headerButtons) {
      return setButtons(headerButtons);
    }
  };
  return React__default.createElement(BladeContext.Provider, {
    value: value
  }, props.children);
};
var useBladeClosing = function useBladeClosing(bladeId, canClose, onClose, deps) {
  var registerBladeClose = useContext(BladesContext).registerBladeClose;
  useEffect(function () {
    registerBladeClose(bladeId, canClose, onClose);
  }, deps);
};
var useBladeButtons = function useBladeButtons(buttons, deps) {
  var updateBladeButtons = useContext(BladeContext).updateBladeButtons;
  useEffect(function () {
    updateBladeButtons(buttons);
  }, deps);
};
var useHeaderButtons = function useHeaderButtons() {
  var context = useContext(BladeContext);
  return context.buttons;
};
var styles$1 = function styles$1(theme) {
  return createStyles$1({
    header: {
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.primary.main
    },
    dirtyIcon: {
      marginRight: theme.spacing(1)
    },
    title: {
      flexGrow: 1,
      marginRight: theme.spacing(2),
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    closeButton: {
      marginRight: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      color: theme.palette.grey[50]
    },
    headerButton: {
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0.5)
    }
  });
};
var useStyles$1 = makeStyles(styles$1);
var styles$2 = function styles$2(theme) {
  return createStyles$1({
    headerButton: {
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0.5)
    }
  });
};
var useStyles$2 = makeStyles(styles$2);
var SingleButton = function SingleButton(props) {
  var t = useTranslation()[0];
  var classes = useStyles$2();
  var button = React__default.createElement(IconButton, {
    className: classes.headerButton,
    onClick: props.onClick,
    disabled: props.disabled
  }, props.icon && props.icon());
  return props.disabled ? button : React__default.createElement(Tooltip, {
    title: t(props.tooltip ? props.tooltip : '').toString(),
    key: "Button_" + (props.icon ? props.icon.toString() : '')
  }, button);
};
var MenuButton = function MenuButton(props) {
  var menuItems = props.menuItems,
    onClick = props.onClick;
  if (!menuItems) throw 'ButtonItem has no children';
  var t = useTranslation()[0];
  var _a = React__default.useState(null),
    anchorEl = _a[0],
    setAnchorEl = _a[1];
  var handleClick = React__default.useCallback(function (e) {
    setAnchorEl(e.currentTarget);
  }, [setAnchorEl]);
  var handleClose = React__default.useCallback(function (e) {
    setAnchorEl(null);
    if (onClick && e.currentTarget.value) {
      onClick(e.currentTarget.value);
    }
  }, [onClick, setAnchorEl]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(SingleButton, _assign2({}, props, {
    onClick: handleClick
  })), React__default.createElement(Menu, {
    id: "simple-menu",
    anchorEl: anchorEl,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, menuItems.map(function (mi) {
    return React__default.createElement(MenuItem, {
      key: mi.value.toString(),
      value: mi.value,
      onClick: handleClose
    }, mi.icon && React__default.createElement(ListItemIcon, null, mi.icon), t(mi.label));
  })));
};
var BladeHeaderButton = function BladeHeaderButton(props) {
  if (props.menuItems) {
    return React__default.createElement(MenuButton, _assign2({}, props));
  } else {
    return React__default.createElement(SingleButton, _assign2({}, props));
  }
};
var BladeHeader = React__default.memo(function (props) {
  var closeBlade = props.closeBlade;
  var buttons = useHeaderButtons();
  var closeButtonClick = useCallback(function (_) {
    closeBlade(props.bladeInstance.id);
  }, [props.bladeInstance.id, closeBlade]);
  var classes = useStyles$1();
  var t = useTranslation()[0];
  var buttonContainerStyle = useMemo(function () {
    return {
      minWidth: (buttons ? 72 + buttons.length * 36 : 72) + "px"
    };
  }, [buttons]);
  return React__default.createElement("div", {
    className: classes.header
  }, props.isDirty && React__default.createElement(Tooltip, {
    title: t('blade.dirty.warning').toString()
  }, React__default.createElement(WarningRounded, {
    color: "error",
    className: classes.dirtyIcon
  })), React__default.createElement(Typography, {
    variant: "h6",
    className: classes.title,
    color: "textPrimary"
  }, props.bladeInstance.title), React__default.createElement("div", {
    style: buttonContainerStyle
  }, buttons && buttons.map(function (button, index) {
    return React__default.createElement(BladeHeaderButton, _assign2({
      key: index
    }, button));
  }), React__default.createElement(Tooltip, {
    title: t('blade.openHelpDialogButtonTooltip').toString()
  }, React__default.createElement(IconButton$1, {
    className: classes.headerButton,
    onClick: props.openHelpDialog
  }, React__default.createElement(Help, null))), React__default.createElement(Tooltip, {
    title: t('blade.closeBladeButtonTooltip').toString()
  }, React__default.createElement(IconButton$1, {
    className: classes.headerButton,
    onClick: closeButtonClick
  }, React__default.createElement(Close, null)))));
}, function (prevProps, nextProps) {
  return prevProps.bladeInstance.id === nextProps.bladeInstance.id && prevProps.isDirty === nextProps.isDirty && prevProps.bladeInstance.title === nextProps.bladeInstance.title;
});
var generateClassName = createGenerateClassName({
  productionPrefix: "mvrt"
});
var BladeHeaderContainer = function BladeHeaderContainer(props) {
  var dispatch = useDispatch();
  var handleBladeClose = useCallback(function (bladeId) {
    return dispatch(closeBlade(bladeId));
  }, [dispatch]);
  var theme = useContext(BladeHeaderThemeContext);
  return React__default.createElement(StylesProvider, {
    generateClassName: generateClassName
  }, React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(BladeHeader, _assign2({}, props, {
    closeBlade: handleBladeClose
  }))));
};
var openBlade = function openBlade(parentBladeId, childBladeType, childBladeInstanceProps) {
  var blade = BladeCache.getBladeConfig(childBladeType);
  var id = childBladeType + "_" + +new Date();
  var title = blade.config.title(childBladeInstanceProps);
  var createBladeAction = createBlade({
    parentId: parentBladeId,
    id: id,
    type: childBladeType,
    title: title,
    newlyCreated: true,
    frozen: false,
    focused: true
  });
  BladeCache.registerBladeProps(id, childBladeInstanceProps);
  return createBladeAction;
};
var updateBladeProps = function updateBladeProps(bladeId, bladeType, bladeProps) {
  var bladeConfig = BladeCache.getBladeConfig(bladeType);
  if (!bladeConfig) throw "Blade config for type '" + bladeType + "' could not be found";
  var title = bladeConfig.config.title(bladeProps);
  BladeCache.registerBladeProps(bladeId, bladeProps);
  return updateBlade({
    id: bladeId,
    title: title
  });
};
var getBladeComponent = function getBladeComponent(bladeInfo, isDirty, setBladeDirty, width) {
  var bladeConfig = BladeCache.getBladeConfig(bladeInfo.type);
  var props = BladeCache.getBladeProps(bladeInfo.id);
  var component = bladeConfig.componentFactory(_assign2(_assign2({}, props), {
    isDirty: isDirty,
    bladeId: bladeInfo.id,
    width: width,
    setDirty: function setDirty(dirty) {
      return setBladeDirty(bladeInfo.id, dirty);
    }
  }));
  return component;
};
var bladeConnect = function bladeConnect(mapStateToProps, mapDispatchToProps, bladeConfig) {
  var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
    var mergedProps = _assign2(_assign2(_assign2({}, stateProps), dispatchProps), ownProps);
    return mergedProps;
  };
  var connectWithRegisterBlade = function connectWithRegisterBlade(component) {
    var containerComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps, {
      forwardRef: false
    })(component);
    BladeCache.registerBladeType(bladeConfig, containerComponent);
    return containerComponent;
  };
  return connectWithRegisterBlade;
};
var styles$3 = function styles$3(_) {
  return createStyles({
    helpDialog: {
      overflowX: 'hidden',
      '& img': {
        maxWidth: '100%'
      },
      '& td': {
        textAlign: 'left'
      },
      '& a': {
        color: '#1976d2'
      }
    }
  });
};
var useStyles$3 = makeStyles(styles$3);
var markdownNotFound = "\n  ### Ooops\n  #### Could not find the corresponding MD File.\n";
var HelpDialog = function HelpDialog(props) {
  var _a = useState(''),
    markdown = _a[0],
    setMarkdown = _a[1];
  var t = useTranslation()[0];
  var classes = useStyles$3();
  var fetchHelpText = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var response, _a, ex_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3,, 4]);
            return [4 /*yield*/, fetch(process.env.PUBLIC_URL + "/help/" + props.type + ".md")];
          case 1:
            response = _b.sent();
            if (response.status !== 200) {
              throw new Error('File not Found');
            }
            _a = setMarkdown;
            return [4 /*yield*/, response.text()];
          case 2:
            _a.apply(void 0, [_b.sent()]);
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _b.sent();
            setMarkdown(markdownNotFound);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [props.type]);
  useEffect(function () {
    if (markdown === '') {
      fetchHelpText();
    }
  }, [props.type, fetchHelpText, markdown]);
  return React__default.createElement(Dialog, {
    open: props.isOpen && !!markdown,
    scroll: 'paper',
    maxWidth: 'md',
    onEscapeKeyDown: props.closeDialog
  }, React__default.createElement(DialogTitle, null, t('help')), React__default.createElement(DialogContent, {
    dividers: true,
    className: classes.helpDialog
  }, React__default.createElement(ReactMarkdown, {
    source: markdown,
    escapeHtml: false,
    renderers: renderers
  })), React__default.createElement(DialogActions, null, React__default.createElement(Button, {
    onClick: props.closeDialog,
    onTouchStart: props.closeDialog,
    color: 'primary'
  }, t('close'))));
};
var Heading = function Heading(props) {
  switch (props.level) {
    case 1:
      return React__default.createElement(Typography, {
        variant: 'h4'
      }, props.children);
    case 2:
      return React__default.createElement(Typography, {
        variant: 'h5'
      }, props.children);
    case 3:
      return React__default.createElement(Typography, {
        variant: 'h6'
      }, props.children);
    default:
      return React__default.createElement(Typography, {
        variant: 'subtitle1'
      }, props.children);
  }
};
var renderers = {
  table: function table(props) {
    return React__default.createElement(Table, null, props.children);
  },
  tableHead: function tableHead(props) {
    return React__default.createElement(TableHead, null, props.children);
  },
  tableCell: function tableCell(props) {
    return React__default.createElement(TableCell, null, props.children);
  },
  tableBody: function tableBody(props) {
    return React__default.createElement(TableBody, null, props.children);
  },
  tableRow: function tableRow(props) {
    return React__default.createElement(TableRow, null, props.children);
  },
  heading: function heading(props) {
    return React__default.createElement(Heading, _assign2({}, props));
  },
  link: function link(props) {
    return React__default.createElement(Typography, null, React__default.createElement(Link, {
      href: props.href
    }, props.children));
  }
};
var Blade = function Blade(props) {
  var config = useMemo(function () {
    return BladeCache.getBladeConfig(props.instance.type).config;
  }, [props.instance.type]);
  var classes = useStyles();
  var _a = useState(false),
    isDirty = _a[0],
    setIsDirty = _a[1];
  var _b = useState(config.size.defaultWidth),
    width = _b[0],
    setWidth = _b[1];
  var _c = useState(false),
    isHelpOpen = _c[0],
    setIsHelpOpen = _c[1];
  var dispatch = useDispatch();
  var focusedBlade = useSelector(selectFocusedBlade);
  var setBladeDirty = useCallback(function (_, dirty) {
    setIsDirty(dirty);
  }, []);
  var component = getBladeComponent(props.instance, isDirty, setBladeDirty, width);
  var innerBladeDivRef = useRef(null);
  useEffect(function () {
    if (innerBladeDivRef.current) {
      setWidth(innerBladeDivRef.current.offsetWidth);
    }
  }, [innerBladeDivRef]);
  var resizeDragStopped = function resizeDragStopped(_, data) {
    return setWidth(Math.max(config.size.minWidth, width + data.x));
  };
  var openHelpDialog = useCallback(function () {
    return setIsHelpOpen(true);
  }, []);
  var closeHelpDialog = useCallback(function () {
    return setIsHelpOpen(false);
  }, []);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Paper, {
    square: true,
    className: classes.paper,
    style: width !== 0 ? {
      width: width + "px"
    } : undefined
  }, React__default.createElement("div", {
    ref: innerBladeDivRef,
    className: classes.blade
  }, React__default.createElement(BladeContextProvider, {
    bladeId: props.instance.id
  }, React__default.createElement(BladeHeaderContainer, {
    isDirty: isDirty,
    bladeInstance: props.instance,
    openHelpDialog: openHelpDialog
  }), React__default.createElement(BladeErrorBoundary, null, component)), React__default.createElement(Draggable, {
    axis: 'x',
    defaultClassName: classes.dragHandle,
    defaultClassNameDragging: width >= config.size.minWidth ? classes.dragHandleActive : classes.dragHandleActiveLessThanMin,
    position: {
      x: 0,
      y: 0
    },
    onStop: resizeDragStopped
  }, React__default.createElement("div", {
    className: classes.noSelect
  })), React__default.createElement(HelpDialog, {
    isOpen: isHelpOpen,
    type: props.instance.type,
    closeDialog: closeHelpDialog
  }))));
};
var propsAreEqual = function propsAreEqual(prevProps, nextProps) {
  return prevProps.instance.id === nextProps.instance.id && prevProps.instance.title === nextProps.instance.title;
};
var MemoBlade = React__default.memo(Blade, propsAreEqual);
var BladeIcon = React__default.memo(function (props) {
  return React__default.createElement(Icon, null, props.canClose === undefined ? React__default.createElement(Autorenew, null) : props.canClose ? React__default.createElement(CheckCircle, null) : React__default.createElement(WarningRounded, {
    color: 'error'
  }));
});
var BladeClosingDialog = function BladeClosingDialog(props) {
  var t = useTranslation()[0];
  return React__default.createElement(Dialog, {
    open: props.opened
  }, React__default.createElement(DialogTitle, null, t("blade.closeDialog.title")), React__default.createElement(DialogContent$1, null, React__default.createElement(DialogContentText, null, t("blade.closeDialog.message"), React__default.createElement("br", null), t("blade.closeDialog.message.secondLine")), React__default.createElement(List, null, props.bladesToClose.map(function (b) {
    return React__default.createElement(ListItem, {
      key: b.blade.id
    }, React__default.createElement(ListItemIcon, null, React__default.createElement(BladeIcon, {
      canClose: b.canClose
    })), React__default.createElement(ListItemText, {
      primary: b.blade.title
    }));
  }))), React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
    onClick: props.onCancel,
    color: "primary",
    autoFocus: true
  }, t("cancel")), React__default.createElement(Button, {
    onClick: props.onCloseAll,
    color: "primary"
  }, t("blade.close.all"))));
};
var styles$4 = function styles$4() {
  return createStyles$1({
    bladeContainer: {
      display: 'flex',
      alignItems: 'stretch',
      flexGrow: 1,
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollBehavior: 'smooth',
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
        cursor: "pointer",
        background: "#D4CCC7"
      },
      "&::webkit-scrollbar-track": {
        background: "#9A9791",
        cursor: "pointer"
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#9A9791",
        borderRadius: "5px",
        cursor: "pointer",
        "&:hover": {
          background: "#9A9791"
        }
      }
    },
    '@keyframes fade': {
      from: {
        opacity: 1
      },
      to: {
        opacity: 0.4
      }
    },
    faded: {
      animationName: '$fade',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
      pointerEvents: "none"
    },
    bufferSpace: {
      flexGrow: 1,
      flexBasis: '200px',
      width: '200px'
    }
  });
};
var useStyles$4 = makeStyles(styles$4);
var BladeRow = function BladeRow(props) {
  var bladeContainerRef = useRef(null);
  var classes = useStyles$4();
  var anyNewBlade = props.blades.some(function (b) {
    return b.newlyCreated;
  });
  var setBladeNewlyCreateState = props.setBladeNewlyCreateState,
    forceCloseBlades = props.forceCloseBlades;
  useEffect(function () {
    if (bladeContainerRef.current) {
      var containerDiv = bladeContainerRef.current;
      if (containerDiv.childElementCount > 1) {
        // last element is always a space buffer div so we need the child before last
        var lastChild = containerDiv.children[containerDiv.childElementCount - 2];
        var isNew = lastChild.getAttribute("data-new") === "true";
        var newBladeId_1 = lastChild.getAttribute("data-key");
        if (isNew && newBladeId_1) {
          scrollToBlade(lastChild, containerDiv);
          setTimeout(function () {
            return setBladeNewlyCreateState(newBladeId_1, false);
          });
        }
      }
    }
  }, [anyNewBlade, setBladeNewlyCreateState]);
  useEffect(function () {
    if (bladeContainerRef.current) {
      var containerDiv = bladeContainerRef.current;
      if (containerDiv.childElementCount > 1) {
        var focusedBladeInstance_1 = props.blades.find(function (blade) {
          return blade.focused;
        });
        if (focusedBladeInstance_1) {
          var focusedBlade = Array.prototype.slice.call(containerDiv.children).find(function (blade) {
            return blade.getAttribute("data-key") === focusedBladeInstance_1.id;
          });
          scrollToBlade(focusedBlade, containerDiv);
        }
      }
    }
  }, [props.blades]);
  var scrollToBlade = function scrollToBlade(bladeDiv, containerDiv) {
    containerDiv.scrollLeft = bladeDiv.offsetLeft - containerDiv.offsetLeft;
  };
  // check every blade to see if it can close
  var closingBladesState = props.closingBlades.map(function (b) {
    var props = BladeCache.getBladeOnCloseProps(b.id);
    return {
      blade: b,
      canClose: props.canClose ? props.canClose() : true
    };
  });
  // if we have at least one that cannot be closed we will need to show the dialog
  var atLeastOneBladeCantClose = closingBladesState.reduce(function (atLeastOne, blade) {
    return atLeastOne || !blade.canClose;
  }, false);
  var forceCloseAll = useCallback(function () {
    closingBladesCallback(props.closingBlades);
    forceCloseBlades(props.actionAfterClosing);
  }, [forceCloseBlades, props.closingBlades, props.actionAfterClosing]);
  useEffect(function () {
    // if all the blades can be safely closed then close them
    if (closingBladesState.length > 0 && !atLeastOneBladeCantClose) {
      closingBladesCallback(props.closingBlades);
      forceCloseBlades(props.actionAfterClosing);
    }
    // there is a case where some component wishes to close some blades and dispatch an action after, but those blades are not opened.
    // this would mean that closingBlades from Redux state is empty but we still need to dispatch that afterClosingAction
    if (closingBladesState.length === 0 && props.actionAfterClosing) {
      // we call the same forceCloseBades action because this also clears the actionAfterClosing from Redux state
      forceCloseBlades(props.actionAfterClosing);
    }
  }, [closingBladesState, forceCloseBlades, props.actionAfterClosing, props.closingBlades, atLeastOneBladeCantClose]);
  var highlights = props.frozenBlades && props.frozenBlades.length > 0;
  var blades = props.blades.map(function (b, i) {
    var _a;
    return React__default.createElement("div", {
      className: classNames((_a = {}, _a[classes.faded] = highlights && props.frozenBlades.indexOf(b.id) > -1, _a)),
      "data-key": b.id,
      "data-new": b.newlyCreated ? "true" : "false",
      key: b.id,
      style: {
        zIndex: 100 - i
      }
    }, React__default.createElement(MemoBlade, {
      instance: b
    }));
  });
  blades.push(React__default.createElement("div", {
    key: 'BUFFER_SPACE'
  }, React__default.createElement("div", {
    className: classes.bufferSpace
  })));
  return React__default.createElement("div", {
    className: classes.bladeContainer,
    ref: bladeContainerRef
  }, React__default.createElement(BladeRowContextProvider, null, blades), props.closingBlades.length > 0 && React__default.createElement(BladeClosingDialog, {
    bladesToClose: closingBladesState,
    onCloseAll: forceCloseAll,
    onCancel: props.cancelBladeClose,
    opened: atLeastOneBladeCantClose
  }));
};
var BladeRowContainer = function BladeRowContainer(props) {
  var blades = useSelector(BladeSelectors.selectActiveBladesDenormalized);
  var frozenBlades = useSelector(BladeSelectors.selectFrozenBlades);
  var closingBlades = useSelector(BladeSelectors.selectClosingBlades);
  var actionAfterClosing = useSelector(BladeSelectors.selectPostClosingAction);
  var actionOnCloseCancel = useSelector(BladeSelectors.selectOnCloseCancelAction);
  var dispatch = useDispatch();
  var forceCloseBlades = useCallback(function () {
    dispatch(BladeActions.forceCloseBlade());
    if (actionAfterClosing) {
      if (Array.isArray(actionAfterClosing)) {
        setTimeout(function () {
          return batch(function () {
            actionAfterClosing.map(function (action) {
              return dispatch(action);
            });
          });
        }, 0);
      } else {
        setTimeout(function () {
          return dispatch(actionAfterClosing);
        }, 0);
      }
    }
  }, [dispatch, actionAfterClosing]);
  var cancelBladeClose = useCallback(function () {
    dispatch(BladeActions.cancelCloseBlade());
    if (actionOnCloseCancel) {
      if (Array.isArray(actionOnCloseCancel)) {
        setTimeout(function () {
          return batch(function () {
            actionOnCloseCancel.map(function (action) {
              if (typeof action === 'function') {
                action();
              } else {
                dispatch(action);
              }
            });
          });
        }, 0);
      } else {
        if (typeof actionOnCloseCancel === 'function') {
          actionOnCloseCancel();
        } else {
          setTimeout(function () {
            return dispatch(actionOnCloseCancel);
          }, 0);
        }
      }
    }
  }, [dispatch, actionOnCloseCancel]);
  var setBladeNewlyCreateState = useCallback(function (bladeId, isNewlyCreated) {
    return dispatch(BladeActions.setBladeNewlyCreateState(bladeId, isNewlyCreated));
  }, [dispatch]);
  return props.theme && React__default.createElement(BladeHeaderThemeProvider, {
    theme: props.theme
  }, React__default.createElement(BladeRow, {
    blades: blades,
    closingBlades: closingBlades,
    actionAfterClosing: actionAfterClosing,
    frozenBlades: frozenBlades,
    forceCloseBlades: forceCloseBlades,
    cancelBladeClose: cancelBladeClose,
    setBladeNewlyCreateState: setBladeNewlyCreateState
  }));
};
var initialState = {
  items: {},
  itemsForClosing: [],
  postClosingAction: undefined,
  cancelClosingAction: undefined
};
var getRelatedBladeIds = function getRelatedBladeIds(blades, parentBladeIds, includeParents) {
  if (includeParents === void 0) {
    includeParents = true;
  }
  var parentIds = Array.isArray(parentBladeIds) ? parentBladeIds : [parentBladeIds];
  var childrenIds = new Set(parentIds.filter(function (id) {
    return blades[id] !== undefined;
  }));
  Object.keys(blades).forEach(function (id) {
    if (childrenIds.has(blades[id].parentId)) {
      childrenIds.add(blades[id].id);
    }
  });
  if (!includeParents) {
    parentIds.forEach(function (p) {
      return childrenIds.delete(p);
    });
  }
  return childrenIds;
};
var bladeReducer = function bladeReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }
  return produce(state, function (draftState) {
    switch (action.type) {
      case ActionTypes.CREATE_BLADE:
        {
          var blades = Object.values(draftState.items);
          var existingBladesOfTheSameType = blades.reduce(function (count, blade) {
            return blade.type === action.payload.type ? count + 1 : count;
          }, 0);
          var bladeConfig = BladeCache.getBladeConfig(action.payload.type);
          if (!bladeConfig) break;
          if (!bladeConfig.config.allowMultipleInstances && existingBladesOfTheSameType > 0) break;
          blades.map(function (blade) {
            return blade.focused = false;
          });
          if (draftState.items[action.payload.id]) {
            draftState.items[action.payload.id].newlyCreated = true;
            draftState.items[action.payload.id].focused = true;
          } else {
            draftState.items[action.payload.id] = action.payload;
          }
          break;
        }
      case ActionTypes.UPDATE_BLADE:
        {
          var bladeInstance = draftState.items[action.payload.id];
          if (bladeInstance) {
            draftState.items[action.payload.id] = _assign2(_assign2({}, bladeInstance), action.payload);
          }
          break;
        }
      case ActionTypes.SET_FOCUSED:
        {
          var currentlyFocusedBlade = Object.values(draftState.items).filter(function (blade) {
            return blade.focused;
          });
          if (currentlyFocusedBlade.length && currentlyFocusedBlade[0].id === action.payload.bladeId) {
            break;
          }
          Object.values(draftState.items).map(function (blade) {
            return blade.focused = false;
          });
          draftState.items[action.payload.bladeId].focused = true;
          break;
        }
      case ActionTypes.CLOSE_BLADE:
        {
          // no bladeId in payload means close all blades
          draftState.itemsForClosing = action.payload.bladeId ? Array.from(getRelatedBladeIds(draftState.items, action.payload.bladeId)) : Object.keys(draftState.items);
          draftState.postClosingAction = action.payload.actionAfterClosing;
          draftState.cancelClosingAction = action.payload.actionOnCancel;
          break;
        }
      case ActionTypes.CLOSE_CHILDREN_BLADES:
        {
          draftState.itemsForClosing = Array.from(getRelatedBladeIds(draftState.items, action.payload.bladeId, false));
          draftState.postClosingAction = action.payload.actionAfterClosing;
          draftState.cancelClosingAction = action.payload.actionOnCancel;
          break;
        }
      case ActionTypes.FORCE_CLOSE_CHILDREN_BLADES:
        {
          draftState.postClosingAction = undefined;
          draftState.cancelClosingAction = undefined;
          var bladeIds_1 = Array.from(getRelatedBladeIds(draftState.items, action.payload.bladeId, false));
          bladeIds_1.forEach(function (id) {
            delete draftState.items[id];
          });
          draftState.itemsForClosing = draftState.itemsForClosing.filter(function (bladeId) {
            return !bladeIds_1.includes(bladeId);
          });
          break;
        }
      case ActionTypes.FORCE_CLOSE_BLADE:
        {
          draftState.postClosingAction = undefined;
          draftState.cancelClosingAction = undefined;
          if (action.payload) {
            var bladeIds_2 = Array.isArray(action.payload) ? action.payload : [action.payload];
            bladeIds_2.forEach(function (id) {
              delete draftState.items[id];
            });
            draftState.itemsForClosing = draftState.itemsForClosing.filter(function (bladeId) {
              return !bladeIds_2.includes(bladeId);
            });
          } else {
            draftState.itemsForClosing.forEach(function (id) {
              delete draftState.items[id];
            });
            draftState.itemsForClosing = [];
          }
          break;
        }
      case ActionTypes.CANCEL_BLADE_CLOSE:
        {
          draftState.postClosingAction = undefined;
          draftState.cancelClosingAction = undefined;
          draftState.itemsForClosing = [];
          break;
        }
      case ActionTypes.SET_BLADE_NEWLY_CREATED_STATE:
        {
          draftState.items[action.payload.bladeId].newlyCreated = action.payload.isNewlyCreated;
          break;
        }
      case ActionTypes.FREEZE_BLADES:
        {
          action.payload.forEach(function (id) {
            return draftState.items[id].frozen = true;
          });
          break;
        }
      case ActionTypes.CLEAR_FROZEN_BLADES:
        {
          if (action.payload) {
            action.payload.forEach(function (bladeId) {
              return draftState.items[bladeId].frozen = false;
            });
          } else {
            Object.keys(draftState.items).forEach(function (bladeId) {
              return draftState.items[bladeId].frozen = false;
            });
          }
          break;
        }
      case ActionTypes.SET_TITLE:
        {
          draftState.items[action.payload.bladeId].title = action.payload.value;
          break;
        }
      case ActionTypes.HARD_CLEAR_ALL_BLADES:
        {
          draftState.items = {};
          break;
        }
    }
  });
};
var withRegisterBlade = function withRegisterBlade(bladeConfig) {
  return function (Component) {
    BladeCache.registerBladeType(bladeConfig, Component);
    return function (props) {
      return React__default.createElement(Component, _assign2({}, props));
    };
  };
};
var createBtn = function createBtn(onClick) {
  return {
    icon: function icon() {
      return React__default.createElement(AddIcon, null);
    },
    onClick: onClick
  };
};
var editBtn = function editBtn(onClick, disabled) {
  return {
    icon: function icon() {
      return React__default.createElement(Create, null);
    },
    onClick: onClick,
    disabled: disabled ? disabled : false
  };
};
var deleteBtn = function deleteBtn(onClick) {
  return {
    icon: function icon() {
      return React__default.createElement(Delete, null);
    },
    onClick: onClick
  };
};
var importBtn = function importBtn(onClick) {
  return {
    icon: function icon() {
      return React__default.createElement(CloudUpload, null);
    },
    onClick: onClick
  };
};
var createEditDelete = function createEditDelete(createFn, editFn, deleteFn) {
  return [createBtn(createFn), editBtn(editFn), deleteBtn(deleteFn)];
};
var customBtn = function customBtn(label, onClick, icon) {
  return {
    icon: icon,
    onClick: onClick
  };
};

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * If value is undefined, null or blank, returns null, otherwise returns the value
 * @param {T} value
 * @returns {T | null}
 */
function makeNull(value) {
  if (value == null || value === '') {
    return null;
  }
  return value;
}
function exists(value, allowEmptyString) {
  if (allowEmptyString === void 0) {
    allowEmptyString = false;
  }
  return value != null && (value !== '' || allowEmptyString);
}
function missing(value) {
  return !exists(value);
}
function missingOrEmpty(value) {
  return value == null || value.length === 0;
}
function toStringOrNull(value) {
  return value != null && typeof value.toString === 'function' ? value.toString() : null;
}
// for parsing html attributes, where we want empty strings and missing attributes to be undefined
function attrToNumber(value) {
  if (value === undefined) {
    // undefined or empty means ignore the value
    return;
  }
  if (value === null || value === '') {
    // null or blank means clear
    return null;
  }
  if (typeof value === 'number') {
    return isNaN(value) ? undefined : value;
  }
  var valueParsed = parseInt(value, 10);
  return isNaN(valueParsed) ? undefined : valueParsed;
}
// for parsing html attributes, where we want empty strings and missing attributes to be undefined
function attrToBoolean(value) {
  if (value === undefined) {
    // undefined or empty means ignore the value
    return;
  }
  if (value === null || value === '') {
    // null means clear
    return false;
  }
  if (typeof value === 'boolean') {
    // if simple boolean, return the boolean
    return value;
  }
  // if equal to the string 'true' (ignoring case) then return true
  return /true/i.test(value);
}
// for parsing html attributes, where we want empty strings and missing attributes to be undefined
function attrToString(value) {
  if (value == null || value === '') {
    return;
  }
  return value;
}
/** @deprecated */
function referenceCompare(left, right) {
  if (left == null && right == null) {
    return true;
  }
  if (left == null && right != null) {
    return false;
  }
  if (left != null && right == null) {
    return false;
  }
  return left === right;
}
function jsonEquals(val1, val2) {
  var val1Json = val1 ? JSON.stringify(val1) : null;
  var val2Json = val2 ? JSON.stringify(val2) : null;
  return val1Json === val2Json;
}
function defaultComparator(valueA, valueB, accentedCompare) {
  if (accentedCompare === void 0) {
    accentedCompare = false;
  }
  var valueAMissing = valueA == null;
  var valueBMissing = valueB == null;
  // this is for aggregations sum and avg, where the result can be a number that is wrapped.
  // if we didn't do this, then the toString() value would be used, which would result in
  // the strings getting used instead of the numbers.
  if (valueA && valueA.toNumber) {
    valueA = valueA.toNumber();
  }
  if (valueB && valueB.toNumber) {
    valueB = valueB.toNumber();
  }
  if (valueAMissing && valueBMissing) {
    return 0;
  }
  if (valueAMissing) {
    return -1;
  }
  if (valueBMissing) {
    return 1;
  }
  function doQuickCompare(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }
  if (typeof valueA !== 'string') {
    return doQuickCompare(valueA, valueB);
  }
  if (!accentedCompare) {
    return doQuickCompare(valueA, valueB);
  }
  try {
    // using local compare also allows chinese comparisons
    return valueA.localeCompare(valueB);
  } catch (e) {
    // if something wrong with localeCompare, eg not supported
    // by browser, then just continue with the quick one
    return doQuickCompare(valueA, valueB);
  }
}
function find$3(collection, predicate, value) {
  if (collection === null || collection === undefined) {
    return null;
  }
  if (!Array.isArray(collection)) {
    var objToArray = values(collection);
    return find$3(objToArray, predicate, value);
  }
  var collectionAsArray = collection;
  var firstMatchingItem = null;
  for (var i = 0; i < collectionAsArray.length; i++) {
    var item = collectionAsArray[i];
    if (typeof predicate === 'string') {
      if (item[predicate] === value) {
        firstMatchingItem = item;
        break;
      }
    } else {
      var callback = predicate;
      if (callback(item)) {
        firstMatchingItem = item;
        break;
      }
    }
  }
  return firstMatchingItem;
}
function values(object) {
  if (object instanceof Set || object instanceof Map) {
    var arr_1 = [];
    object.forEach(function (value) {
      return arr_1.push(value);
    });
    return arr_1;
  }
  return Object.keys(object).map(function (key) {
    return object[key];
  });
}
var GenericUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  makeNull: makeNull,
  exists: exists,
  missing: missing,
  missingOrEmpty: missingOrEmpty,
  toStringOrNull: toStringOrNull,
  attrToNumber: attrToNumber,
  attrToBoolean: attrToBoolean,
  attrToString: attrToString,
  referenceCompare: referenceCompare,
  jsonEquals: jsonEquals,
  defaultComparator: defaultComparator,
  find: find$3,
  values: values
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ColumnKeyCreator = /** @class */function () {
  function ColumnKeyCreator() {
    this.existingKeys = {};
  }
  ColumnKeyCreator.prototype.addExistingKeys = function (keys) {
    for (var i = 0; i < keys.length; i++) {
      this.existingKeys[keys[i]] = true;
    }
  };
  ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
    // in case user passed in number for colId, convert to string
    colId = toStringOrNull(colId);
    var count = 0;
    while (true) {
      var idToTry = void 0;
      if (colId) {
        idToTry = colId;
        if (count !== 0) {
          idToTry += '_' + count;
        }
      } else if (colField) {
        idToTry = colField;
        if (count !== 0) {
          idToTry += '_' + count;
        }
      } else {
        idToTry = '' + count;
      }
      if (!this.existingKeys[idToTry]) {
        this.existingKeys[idToTry] = true;
        return idToTry;
      }
      count++;
    }
  };
  return ColumnKeyCreator;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function firstExistingValue() {
  var values = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    values[_i] = arguments[_i];
  }
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    if (exists(value)) {
      return value;
    }
  }
  return null;
}
/** @deprecated */
function anyExists(values) {
  return values && firstExistingValue(values) != null;
}
function existsAndNotEmpty(value) {
  return value != null && value.length > 0;
}
function last(arr) {
  if (!arr || !arr.length) {
    return;
  }
  return arr[arr.length - 1];
}
function areEqual(a, b, comparator) {
  if (a == null && b == null) {
    return true;
  }
  return a != null && b != null && a.length === b.length && every(a, function (value, index) {
    return comparator ? comparator(value, b[index]) : b[index] === value;
  });
}
/** @deprecated */
function compareArrays(array1, array2) {
  return areEqual(array1, array2);
}
/** @deprecated */
function shallowCompare(arr1, arr2) {
  return areEqual(arr1, arr2);
}
function sortNumerically(array) {
  return array.sort(function (a, b) {
    return a - b;
  });
}
function removeRepeatsFromArray(array, object) {
  if (!array) {
    return;
  }
  for (var index = array.length - 2; index >= 0; index--) {
    var thisOneMatches = array[index] === object;
    var nextOneMatches = array[index + 1] === object;
    if (thisOneMatches && nextOneMatches) {
      array.splice(index + 1, 1);
    }
  }
}
function removeFromArray(array, object) {
  var index = array.indexOf(object);
  if (index >= 0) {
    array.splice(index, 1);
  }
}
function removeAllFromArray(array, toRemove) {
  forEach$4(toRemove, function (item) {
    return removeFromArray(array, item);
  });
}
function insertIntoArray(array, object, toIndex) {
  array.splice(toIndex, 0, object);
}
function insertArrayIntoArray(dest, src, toIndex) {
  if (dest == null || src == null) {
    return;
  }
  // put items in backwards, otherwise inserted items end up in reverse order
  for (var i = src.length - 1; i >= 0; i--) {
    var item = src[i];
    insertIntoArray(dest, item, toIndex);
  }
}
function moveInArray(array, objectsToMove, toIndex) {
  // first take out items from the array
  removeAllFromArray(array, objectsToMove);
  // now add the objects, in same order as provided to us, that means we start at the end
  // as the objects will be pushed to the right as they are inserted
  forEach$4(objectsToMove.slice().reverse(), function (obj) {
    return insertIntoArray(array, obj, toIndex);
  });
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function flatten(arrayOfArrays) {
  return [].concat.apply([], arrayOfArrays);
}
function pushAll(target, source) {
  if (source == null || target == null) {
    return;
  }
  forEach$4(source, function (value) {
    return target.push(value);
  });
}
function toStrings(array) {
  return map$3(array, toStringOrNull);
}
function findIndex(collection, predicate) {
  for (var i = 0; i < collection.length; i++) {
    if (predicate(collection[i], i, collection)) {
      return i;
    }
  }
  return -1;
}
function fill(collection, value, start, end) {
  if (value === void 0) {
    value = null;
  }
  if (start === void 0) {
    start = 0;
  }
  if (end === void 0) {
    end = collection.length;
  }
  for (var i = start; i < end; i++) {
    collection[i] = value;
  }
  return collection;
}
/**
 * The implementation of Array.prototype.every in browsers is always slower than just using a simple for loop, so
 * use this for improved performance.
 * https://jsbench.me/bek91dtit8/
 */
function every(list, predicate) {
  if (list == null) {
    return true;
  }
  for (var i = 0; i < list.length; i++) {
    if (!predicate(list[i], i)) {
      return false;
    }
  }
  return true;
}
/**
 * The implementation of Array.prototype.some in browsers is always slower than just using a simple for loop, so
 * use this for improved performance.
 * https://jsbench.me/5dk91e4tmt/
 */
function some(list, predicate) {
  if (list == null) {
    return false;
  }
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i], i)) {
      return true;
    }
  }
  return false;
}
/**
 * The implementation of Array.prototype.forEach in browsers is often slower than just using a simple for loop, so
 * use this for improved performance.
 * https://jsbench.me/apk91elt8a/
 */
function forEach$4(list, action) {
  if (list == null) {
    return;
  }
  for (var i = 0; i < list.length; i++) {
    action(list[i], i);
  }
}
function forEachReverse(list, action) {
  if (list == null) {
    return;
  }
  for (var i = list.length - 1; i >= 0; i--) {
    action(list[i], i);
  }
}
/**
 * The implementation of Array.prototype.map in browsers is generally the same as just using a simple for loop. However,
 * Firefox does exhibit some difference, and this performs no worse in other browsers, so use this if you want improved
 * performance.
 * https://jsbench.me/njk91ez8pc/
 */
function map$3(list, process) {
  if (list == null) {
    return null;
  }
  var mapped = [];
  for (var i = 0; i < list.length; i++) {
    mapped.push(process(list[i], i));
  }
  return mapped;
}
/**
 * The implementation of Array.prototype.filter in browsers is always slower than just using a simple for loop, so
 * use this for improved performance.
 * https://jsbench.me/7bk91fk08c/
 */
function filter(list, predicate) {
  if (list == null) {
    return null;
  }
  var filtered = [];
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i], i)) {
      filtered.push(list[i]);
    }
  }
  return filtered;
}
/**
 * The implementation of Array.prototype.reduce in browsers is generally the same as just using a simple for loop. However,
 * Chrome does exhibit some difference, and this performs no worse in other browsers, so use this if you want improved
 * performance.
 * https://jsbench.me/7vk92n6u1f/
 */
function reduce(list, step, initial) {
  if (list == null || initial == null) {
    return null;
  }
  var result = initial;
  for (var i = 0; i < list.length; i++) {
    result = step(result, list[i], i);
  }
  return result;
}
/** @deprecated */
function forEachSnapshotFirst(list, callback) {
  if (!list) {
    return;
  }
  var arrayCopy = list.slice(0);
  arrayCopy.forEach(callback);
}
var ArrayUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  firstExistingValue: firstExistingValue,
  anyExists: anyExists,
  existsAndNotEmpty: existsAndNotEmpty,
  last: last,
  areEqual: areEqual,
  compareArrays: compareArrays,
  shallowCompare: shallowCompare,
  sortNumerically: sortNumerically,
  removeRepeatsFromArray: removeRepeatsFromArray,
  removeFromArray: removeFromArray,
  removeAllFromArray: removeAllFromArray,
  insertIntoArray: insertIntoArray,
  insertArrayIntoArray: insertArrayIntoArray,
  moveInArray: moveInArray,
  includes: includes,
  flatten: flatten,
  pushAll: pushAll,
  toStrings: toStrings,
  findIndex: findIndex,
  fill: fill,
  every: every,
  some: some,
  forEach: forEach$4,
  forEachReverse: forEachReverse,
  map: map$3,
  filter: filter,
  reduce: reduce,
  forEachSnapshotFirst: forEachSnapshotFirst
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function iterateObject(object, callback) {
  if (object == null) {
    return;
  }
  if (Array.isArray(object)) {
    forEach$4(object, function (value, index) {
      return callback("" + index, value);
    });
  } else {
    forEach$4(Object.keys(object), function (key) {
      return callback(key, object[key]);
    });
  }
}
function cloneObject(object) {
  var copy = {};
  var keys = Object.keys(object);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = object[key];
    copy[key] = value;
  }
  return copy;
}
function deepCloneObject(object) {
  return JSON.parse(JSON.stringify(object));
}
// returns copy of an object, doing a deep clone of any objects with that object.
// this is used for eg creating copies of Column Definitions, where we want to
// deep copy all objects, but do not want to deep copy functions (eg when user provides
// a function or class for colDef.cellRenderer)
function deepCloneDefinition(object, keysToSkip) {
  if (!object) {
    return;
  }
  var obj = object;
  var res = {};
  Object.keys(obj).forEach(function (key) {
    if (keysToSkip && keysToSkip.indexOf(key) >= 0) {
      return;
    }
    var value = obj[key];
    // 'simple object' means a bunch of key/value pairs, eg {filter: 'myFilter'}. it does
    // NOT include the following:
    // 1) arrays
    // 2) functions or classes (eg ColumnAPI instance)
    var sourceIsSimpleObject = isNonNullObject(value) && value.constructor === Object;
    if (sourceIsSimpleObject) {
      res[key] = deepCloneDefinition(value);
    } else {
      res[key] = value;
    }
  });
  return res;
}
function getProperty(object, key) {
  return object[key];
}
function setProperty(object, key, value) {
  object[key] = value;
}
/**
 * Will copy the specified properties from `source` into the equivalent properties on `target`, ignoring properties with
 * a value of `undefined`.
 */
function copyPropertiesIfPresent(source, target) {
  var properties = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    properties[_i - 2] = arguments[_i];
  }
  forEach$4(properties, function (p) {
    return copyPropertyIfPresent(source, target, p);
  });
}
/**
 * Will copy the specified property from `source` into the equivalent property on `target`, unless the property has a
 * value of `undefined`. If a transformation is provided, it will be applied to the value before being set on `target`.
 */
function copyPropertyIfPresent(source, target, property, transform) {
  var value = getProperty(source, property);
  if (value !== undefined) {
    setProperty(target, property, transform ? transform(value) : value);
  }
}
function getAllKeysInObjects(objects) {
  var allValues = {};
  objects.filter(function (obj) {
    return obj != null;
  }).forEach(function (obj) {
    forEach$4(Object.keys(obj), function (key) {
      return allValues[key] = null;
    });
  });
  return Object.keys(allValues);
}
function getAllValuesInObject(obj) {
  if (!obj) {
    return [];
  }
  var anyObject = Object;
  if (typeof anyObject.values === 'function') {
    return anyObject.values(obj);
  }
  var ret = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
      ret.push(obj[key]);
    }
  }
  return ret;
}
function mergeDeep(dest, source, copyUndefined, makeCopyOfSimpleObjects) {
  if (copyUndefined === void 0) {
    copyUndefined = true;
  }
  if (makeCopyOfSimpleObjects === void 0) {
    makeCopyOfSimpleObjects = false;
  }
  if (!exists(source)) {
    return;
  }
  iterateObject(source, function (key, sourceValue) {
    var destValue = dest[key];
    if (destValue === sourceValue) {
      return;
    }
    // when creating params, we don't want to just copy objects over. otherwise merging ColDefs (eg DefaultColDef
    // and Column Types) would result in params getting shared between objects.
    // by putting an empty value into destValue first, it means we end up copying over values from
    // the source object, rather than just copying in the source object in it's entirety.
    if (makeCopyOfSimpleObjects) {
      var objectIsDueToBeCopied = destValue == null && sourceValue != null;
      if (objectIsDueToBeCopied) {
        // 'simple object' means a bunch of key/value pairs, eg {filter: 'myFilter'}, as opposed
        // to a Class instance (such as ColumnAPI instance).
        var sourceIsSimpleObject = typeof sourceValue === 'object' && sourceValue.constructor === Object;
        var dontCopy = sourceIsSimpleObject;
        if (dontCopy) {
          destValue = {};
          dest[key] = destValue;
        }
      }
    }
    if (isNonNullObject(sourceValue) && isNonNullObject(destValue) && !Array.isArray(destValue)) {
      mergeDeep(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
    } else if (copyUndefined || sourceValue !== undefined) {
      dest[key] = sourceValue;
    }
  });
}
function assign$3(object) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  forEach$4(sources, function (source) {
    return iterateObject(source, function (key, value) {
      return object[key] = value;
    });
  });
  return object;
}
function missingOrEmptyObject(value) {
  return missing(value) || Object.keys(value).length === 0;
}
function get$1(source, expression, defaultValue) {
  if (source == null) {
    return defaultValue;
  }
  var keys = expression.split('.');
  var objectToRead = source;
  while (keys.length > 1) {
    objectToRead = objectToRead[keys.shift()];
    if (objectToRead == null) {
      return defaultValue;
    }
  }
  var value = objectToRead[keys[0]];
  return value != null ? value : defaultValue;
}
function set$4(target, expression, value) {
  if (target == null) {
    return;
  }
  var keys = expression.split('.');
  var objectToUpdate = target;
  while (keys.length > 1) {
    objectToUpdate = objectToUpdate[keys.shift()];
    if (objectToUpdate == null) {
      return;
    }
  }
  objectToUpdate[keys[0]] = value;
}
function deepFreeze(object) {
  Object.freeze(object);
  forEach$4(values(object), function (v) {
    if (isNonNullObject(v) || typeof v === 'function') {
      deepFreeze(v);
    }
  });
  return object;
}
function getValueUsingField(data, field, fieldContainsDots) {
  if (!field || !data) {
    return;
  }
  // if no '.', then it's not a deep value
  if (!fieldContainsDots) {
    return data[field];
  }
  // otherwise it is a deep value, so need to dig for it
  var fields = field.split('.');
  var currentObject = data;
  for (var i = 0; i < fields.length; i++) {
    if (currentObject == null) {
      return undefined;
    }
    currentObject = currentObject[fields[i]];
  }
  return currentObject;
}
// used by ColumnAPI and GridAPI to remove all references, so keeping grid in memory resulting in a
// memory leak if user is not disposing of the GridAPI or ColumnApi references
function removeAllReferences(obj, objectName) {
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    // we want to replace all the @autowired services, which are objects. any simple types (boolean, string etc)
    // we don't care about
    if (typeof value === 'object') {
      obj[key] = undefined;
    }
  });
  var proto = Object.getPrototypeOf(obj);
  var properties = {};
  Object.keys(proto).forEach(function (key) {
    var value = proto[key];
    // leave all basic types - this is needed for GridAPI to leave the "destroyed: boolean" attribute alone
    if (typeof value === 'function') {
      var func = function func() {
        console.warn("AG Grid: " + objectName + " function " + key + "() cannot be called as the grid has been destroyed.\n                     Please don't call grid API functions on destroyed grids - as a matter of fact you shouldn't\n                     be keeping the API reference, your application has a memory leak! Remove the API reference\n                     when the grid is destroyed.");
      };
      properties[key] = {
        value: func,
        writable: true
      };
    }
  });
  Object.defineProperties(obj, properties);
}
function isNonNullObject(value) {
  return typeof value === 'object' && value !== null;
}
var ObjectUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  iterateObject: iterateObject,
  cloneObject: cloneObject,
  deepCloneObject: deepCloneObject,
  deepCloneDefinition: deepCloneDefinition,
  getProperty: getProperty,
  setProperty: setProperty,
  copyPropertiesIfPresent: copyPropertiesIfPresent,
  copyPropertyIfPresent: copyPropertyIfPresent,
  getAllKeysInObjects: getAllKeysInObjects,
  getAllValuesInObject: getAllValuesInObject,
  mergeDeep: mergeDeep,
  assign: assign$3,
  missingOrEmptyObject: missingOrEmptyObject,
  get: get$1,
  set: set$4,
  deepFreeze: deepFreeze,
  getValueUsingField: getValueUsingField,
  removeAllReferences: removeAllReferences,
  isNonNullObject: isNonNullObject
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
var doOnceFlags = {};
/**
 * If the key was passed before, then doesn't execute the func
 * @param {Function} func
 * @param {string} key
 */
function doOnce(func, key) {
  if (doOnceFlags[key]) {
    return;
  }
  func();
  doOnceFlags[key] = true;
}
function getFunctionName(funcConstructor) {
  // for every other browser in the world
  if (funcConstructor.name) {
    return funcConstructor.name;
  }
  // for the pestilence that is ie11
  var matches = /function\s+([^\(]+)/.exec(funcConstructor.toString());
  return matches && matches.length === 2 ? matches[1].trim() : null;
}
/** @deprecated */
function getFunctionParameters(func) {
  var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
  return fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES) || [];
}
function isFunction(val) {
  return !!(val && val.constructor && val.call && val.apply);
}
function executeInAWhile(funcs) {
  executeAfter(funcs, 400);
}
var executeNextVMTurnFuncs = [];
var executeNextVMTurnPending = false;
function executeNextVMTurn(func) {
  executeNextVMTurnFuncs.push(func);
  if (executeNextVMTurnPending) {
    return;
  }
  executeNextVMTurnPending = true;
  window.setTimeout(function () {
    var funcsCopy = executeNextVMTurnFuncs.slice();
    executeNextVMTurnFuncs.length = 0;
    executeNextVMTurnPending = false;
    funcsCopy.forEach(function (func) {
      return func();
    });
  }, 0);
}
function executeAfter(funcs, milliseconds) {
  if (milliseconds === void 0) {
    milliseconds = 0;
  }
  if (funcs.length > 0) {
    window.setTimeout(function () {
      return funcs.forEach(function (func) {
        return func();
      });
    }, milliseconds);
  }
}
/**
 * from https://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
 * @param {Function} func The function to be debounced
 * @param {number} wait The time in ms to debounce
 * @param {boolean} immediate If it should run immediately or wait for the initial debounce delay
 * @return {Function} The debounced function
 */
function debounce(func, wait, immediate) {
  if (immediate === void 0) {
    immediate = false;
  }
  // 'private' variable for instance
  // The returned function will be able to reference this due to closure.
  // Each call to the returned function will share this common timer.
  var timeout;
  // Calling debounce returns a new anonymous function
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    // reference the context and args for the setTimeout function
    var context = this;
    // Should the function be called now? If immediate is true
    //   and not already in a timeout then the answer is: Yes
    var callNow = immediate && !timeout;
    // This is the basic debounce behaviour where you can call this
    //   function several times, but it will only execute once
    //   [before or after imposing a delay].
    //   Each time the returned function is called, the timer starts over.
    window.clearTimeout(timeout);
    // Set the new timeout
    timeout = window.setTimeout(function () {
      // Inside the timeout function, clear the timeout variable
      // which will let the next execution run when in 'immediate' mode
      timeout = null;
      // Check if the function already ran with the immediate flag
      if (!immediate) {
        // Call the original function with apply
        // apply lets you define the 'this' object as well as the arguments
        //    (both captured before setTimeout)
        func.apply(context, args);
      }
    }, wait);
    // Immediate mode and no wait timer? Execute the function..
    if (callNow) {
      func.apply(context, args);
    }
  };
}
function waitUntil(condition, callback, timeout, timeoutMessage) {
  if (timeout === void 0) {
    timeout = 100;
  }
  var timeStamp = new Date().getTime();
  var interval = null;
  var executed = false;
  var internalCallback = function internalCallback() {
    var reachedTimeout = new Date().getTime() - timeStamp > timeout;
    if (condition() || reachedTimeout) {
      callback();
      executed = true;
      if (interval != null) {
        window.clearInterval(interval);
        interval = null;
      }
      if (reachedTimeout && timeoutMessage) {
        console.warn(timeoutMessage);
      }
    }
  };
  internalCallback();
  if (!executed) {
    interval = window.setInterval(internalCallback, 10);
  }
}
function compose() {
  var fns = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    fns[_i] = arguments[_i];
  }
  return function (arg) {
    return fns.reduce(function (composed, f) {
      return f(composed);
    }, arg);
  };
}
function callIfPresent(func) {
  if (func) {
    func();
  }
}
var FunctionUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  doOnce: doOnce,
  getFunctionName: getFunctionName,
  getFunctionParameters: getFunctionParameters,
  isFunction: isFunction,
  executeInAWhile: executeInAWhile,
  executeNextVMTurn: executeNextVMTurn,
  executeAfter: executeAfter,
  debounce: debounce,
  waitUntil: waitUntil,
  compose: compose,
  callIfPresent: callIfPresent
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var Context = /** @class */function () {
  function Context(params, logger) {
    this.beanWrappers = {};
    this.destroyed = false;
    if (!params || !params.beanClasses) {
      return;
    }
    this.contextParams = params;
    this.logger = logger;
    this.logger.log(">> creating ag-Application Context");
    this.createBeans();
    var beanInstances = this.getBeanInstances();
    this.wireBeans(beanInstances);
    this.logger.log(">> ag-Application Context ready - component is alive");
  }
  Context.prototype.getBeanInstances = function () {
    return values(this.beanWrappers).map(function (beanEntry) {
      return beanEntry.beanInstance;
    });
  };
  Context.prototype.createBean = function (bean, afterPreCreateCallback) {
    if (!bean) {
      throw Error("Can't wire to bean since it is null");
    }
    this.wireBeans([bean], afterPreCreateCallback);
    return bean;
  };
  Context.prototype.wireBeans = function (beanInstances, afterPreCreateCallback) {
    this.autoWireBeans(beanInstances);
    this.methodWireBeans(beanInstances);
    this.callLifeCycleMethods(beanInstances, 'preConstructMethods');
    // the callback sets the attributes, so the component has access to attributes
    // before postConstruct methods in the component are executed
    if (exists(afterPreCreateCallback)) {
      beanInstances.forEach(afterPreCreateCallback);
    }
    this.callLifeCycleMethods(beanInstances, 'postConstructMethods');
  };
  Context.prototype.createBeans = function () {
    var _this = this;
    // register all normal beans
    this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this));
    // register override beans, these will overwrite beans above of same name
    // instantiate all beans - overridden beans will be left out
    iterateObject(this.beanWrappers, function (key, beanEntry) {
      var constructorParamsMeta;
      if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) {
        constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
      }
      var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
      var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
      beanEntry.beanInstance = newInstance;
    });
    var createdBeanNames = Object.keys(this.beanWrappers).join(', ');
    this.logger.log("created beans: " + createdBeanNames);
  };
  // tslint:disable-next-line
  Context.prototype.createBeanWrapper = function (BeanClass) {
    var metaData = BeanClass.__agBeanMetaData;
    if (!metaData) {
      var beanName = void 0;
      if (BeanClass.prototype.constructor) {
        beanName = getFunctionName(BeanClass.prototype.constructor);
      } else {
        beanName = "" + BeanClass;
      }
      console.error("Context item " + beanName + " is not a bean");
      return;
    }
    var beanEntry = {
      bean: BeanClass,
      beanInstance: null,
      beanName: metaData.beanName
    };
    this.beanWrappers[metaData.beanName] = beanEntry;
  };
  Context.prototype.autoWireBeans = function (beanInstances) {
    var _this = this;
    beanInstances.forEach(function (beanInstance) {
      _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
        var attributes = metaData.agClassAttributes;
        if (!attributes) {
          return;
        }
        attributes.forEach(function (attribute) {
          var otherBean = _this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
          beanInstance[attribute.attributeName] = otherBean;
        });
      });
    });
  };
  Context.prototype.methodWireBeans = function (beanInstances) {
    var _this = this;
    beanInstances.forEach(function (beanInstance) {
      _this.forEachMetaDataInHierarchy(beanInstance, function (metaData, beanName) {
        iterateObject(metaData.autowireMethods, function (methodName, wireParams) {
          // skip constructor, as this is dealt with elsewhere
          if (methodName === "agConstructor") {
            return;
          }
          var initParams = _this.getBeansForParameters(wireParams, beanName);
          beanInstance[methodName].apply(beanInstance, initParams);
        });
      });
    });
  };
  Context.prototype.forEachMetaDataInHierarchy = function (beanInstance, callback) {
    var prototype = Object.getPrototypeOf(beanInstance);
    while (prototype != null) {
      var constructor = prototype.constructor;
      if (constructor.hasOwnProperty('__agBeanMetaData')) {
        var metaData = constructor.__agBeanMetaData;
        var beanName = this.getBeanName(constructor);
        callback(metaData, beanName);
      }
      prototype = Object.getPrototypeOf(prototype);
    }
  };
  Context.prototype.getBeanName = function (constructor) {
    if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) {
      return constructor.__agBeanMetaData.beanName;
    }
    var constructorString = constructor.toString();
    var beanName = constructorString.substring(9, constructorString.indexOf("("));
    return beanName;
  };
  Context.prototype.getBeansForParameters = function (parameters, beanName) {
    var _this = this;
    var beansList = [];
    if (parameters) {
      iterateObject(parameters, function (paramIndex, otherBeanName) {
        var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
        beansList[Number(paramIndex)] = otherBean;
      });
    }
    return beansList;
  };
  Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
    if (optional === void 0) {
      optional = false;
    }
    if (beanName === "context") {
      return this;
    }
    if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(beanName)) {
      return this.contextParams.providedBeanInstances[beanName];
    }
    var beanEntry = this.beanWrappers[beanName];
    if (beanEntry) {
      return beanEntry.beanInstance;
    }
    if (!optional) {
      console.error("AG Grid: unable to find bean reference " + beanName + " while initialising " + wiringBean);
    }
    return null;
  };
  Context.prototype.callLifeCycleMethods = function (beanInstances, lifeCycleMethod) {
    var _this = this;
    beanInstances.forEach(function (beanInstance) {
      return _this.callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod);
    });
  };
  Context.prototype.callLifeCycleMethodsOnBean = function (beanInstance, lifeCycleMethod, methodToIgnore) {
    // putting all methods into a map removes duplicates
    var allMethods = {};
    // dump methods from each level of the metadata hierarchy
    this.forEachMetaDataInHierarchy(beanInstance, function (metaData) {
      var methods = metaData[lifeCycleMethod];
      if (methods) {
        methods.forEach(function (methodName) {
          if (methodName != methodToIgnore) {
            allMethods[methodName] = true;
          }
        });
      }
    });
    var allMethodsList = Object.keys(allMethods);
    allMethodsList.forEach(function (methodName) {
      return beanInstance[methodName]();
    });
  };
  Context.prototype.getBean = function (name) {
    return this.lookupBeanInstance("getBean", name, true);
  };
  Context.prototype.destroy = function () {
    if (this.destroyed) {
      return;
    }
    this.logger.log(">> Shutting down ag-Application Context");
    var beanInstances = this.getBeanInstances();
    this.destroyBeans(beanInstances);
    this.contextParams.providedBeanInstances = null;
    this.destroyed = true;
    this.logger.log(">> ag-Application Context shut down - component is dead");
  };
  Context.prototype.destroyBean = function (bean) {
    if (!bean) {
      return;
    }
    this.destroyBeans([bean]);
  };
  Context.prototype.destroyBeans = function (beans) {
    var _this = this;
    if (!beans) {
      return [];
    }
    beans.forEach(function (bean) {
      _this.callLifeCycleMethodsOnBean(bean, 'preDestroyMethods', 'destroy');
      // call destroy() explicitly if it exists
      var beanAny = bean;
      if (typeof beanAny.destroy === 'function') {
        beanAny.destroy();
      }
    });
    return [];
  };
  return Context;
}();
// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
// allows calling 'apply' on a constructor
function applyToConstructor(constructor, argArray) {
  var args = [null].concat(argArray);
  var factoryFunction = constructor.bind.apply(constructor, args);
  return new factoryFunction();
}
function PreConstruct(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);
  if (!props.preConstructMethods) {
    props.preConstructMethods = [];
  }
  props.preConstructMethods.push(methodName);
}
function PostConstruct(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);
  if (!props.postConstructMethods) {
    props.postConstructMethods = [];
  }
  props.postConstructMethods.push(methodName);
}
function PreDestroy(target, methodName, descriptor) {
  var props = getOrCreateProps(target.constructor);
  if (!props.preDestroyMethods) {
    props.preDestroyMethods = [];
  }
  props.preDestroyMethods.push(methodName);
}
function Bean(beanName) {
  return function (classConstructor) {
    var props = getOrCreateProps(classConstructor);
    props.beanName = beanName;
  };
}
function Autowired(name) {
  return function (target, propertyKey, descriptor) {
    autowiredFunc(target, name, false, target, propertyKey, null);
  };
}
function Optional(name) {
  return function (target, propertyKey, descriptor) {
    autowiredFunc(target, name, true, target, propertyKey, null);
  };
}
function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
  if (name === null) {
    console.error("AG Grid: Autowired name should not be null");
    return;
  }
  if (typeof index === "number") {
    console.error("AG Grid: Autowired should be on an attribute");
    return;
  }
  // it's an attribute on the class
  var props = getOrCreateProps(target.constructor);
  if (!props.agClassAttributes) {
    props.agClassAttributes = [];
  }
  props.agClassAttributes.push({
    attributeName: methodOrAttributeName,
    beanName: name,
    optional: optional
  });
}
function Qualifier(name) {
  return function (classPrototype, methodOrAttributeName, index) {
    var constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
    var props;
    if (typeof index === "number") {
      // it's a parameter on a method
      var methodName = void 0;
      if (methodOrAttributeName) {
        props = getOrCreateProps(constructor);
        methodName = methodOrAttributeName;
      } else {
        props = getOrCreateProps(constructor);
        methodName = "agConstructor";
      }
      if (!props.autowireMethods) {
        props.autowireMethods = {};
      }
      if (!props.autowireMethods[methodName]) {
        props.autowireMethods[methodName] = {};
      }
      props.autowireMethods[methodName][index] = name;
    }
  };
}
function getOrCreateProps(target) {
  if (!target.hasOwnProperty("__agBeanMetaData")) {
    target.__agBeanMetaData = {};
  }
  return target.__agBeanMetaData;
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var EventService = /** @class */function () {
  function EventService() {
    this.allSyncListeners = new Map();
    this.allAsyncListeners = new Map();
    this.globalSyncListeners = new Set();
    this.globalAsyncListeners = new Set();
    this.asyncFunctionsQueue = [];
    this.scheduled = false;
    // using an object performs better than a Set for the number of different events we have
    this.firedEvents = {};
  }
  // because this class is used both inside the context and outside the context, we do not
  // use autowired attributes, as that would be confusing, as sometimes the attributes
  // would be wired, and sometimes not.
  //
  // the global event servers used by AG Grid is autowired by the context once, and this
  // setBeans method gets called once.
  //
  // the times when this class is used outside of the context (eg RowNode has an instance of this
  // class) then it is not a bean, and this setBeans method is not called.
  EventService.prototype.setBeans = function (loggerFactory, gridOptionsWrapper, frameworkOverrides, globalEventListener) {
    if (globalEventListener === void 0) {
      globalEventListener = null;
    }
    this.frameworkOverrides = frameworkOverrides;
    if (globalEventListener) {
      var async = gridOptionsWrapper.useAsyncEvents();
      this.addGlobalListener(globalEventListener, async);
    }
  };
  EventService.prototype.getListeners = function (eventType, async, autoCreateListenerCollection) {
    var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
    var listeners = listenerMap.get(eventType);
    // Note: 'autoCreateListenerCollection' should only be 'true' if a listener is about to be added. For instance
    // getListeners() is also called during event dispatch even though no listeners are added. This measure protects
    // against 'memory bloat' as empty collections will prevent the RowNode's event service from being removed after
    // the RowComp is destroyed, see noRegisteredListenersExist() below.
    if (!listeners && autoCreateListenerCollection) {
      listeners = new Set();
      listenerMap.set(eventType, listeners);
    }
    return listeners;
  };
  EventService.prototype.noRegisteredListenersExist = function () {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  };
  EventService.prototype.addEventListener = function (eventType, listener, async) {
    if (async === void 0) {
      async = false;
    }
    this.getListeners(eventType, async, true).add(listener);
  };
  EventService.prototype.removeEventListener = function (eventType, listener, async) {
    if (async === void 0) {
      async = false;
    }
    var listeners = this.getListeners(eventType, async, false);
    if (!listeners) {
      return;
    }
    listeners.delete(listener);
    if (listeners.size === 0) {
      var listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
      listenerMap.delete(eventType);
    }
  };
  EventService.prototype.addGlobalListener = function (listener, async) {
    if (async === void 0) {
      async = false;
    }
    (async ? this.globalAsyncListeners : this.globalSyncListeners).add(listener);
  };
  EventService.prototype.removeGlobalListener = function (listener, async) {
    if (async === void 0) {
      async = false;
    }
    (async ? this.globalAsyncListeners : this.globalSyncListeners).delete(listener);
  };
  EventService.prototype.dispatchEvent = function (event) {
    this.dispatchToListeners(event, true);
    this.dispatchToListeners(event, false);
    this.firedEvents[event.type] = true;
  };
  EventService.prototype.dispatchEventOnce = function (event) {
    if (!this.firedEvents[event.type]) {
      this.dispatchEvent(event);
    }
  };
  EventService.prototype.dispatchToListeners = function (event, async) {
    var _this = this;
    var eventType = event.type;
    var processEventListeners = function processEventListeners(listeners) {
      return listeners.forEach(function (listener) {
        if (async) {
          _this.dispatchAsync(function () {
            return listener(event);
          });
        } else {
          listener(event);
        }
      });
    };
    var listeners = this.getListeners(eventType, async, false);
    if (listeners) {
      processEventListeners(listeners);
    }
    var globalListeners = async ? this.globalAsyncListeners : this.globalSyncListeners;
    globalListeners.forEach(function (listener) {
      if (async) {
        _this.dispatchAsync(function () {
          return _this.frameworkOverrides.dispatchEvent(eventType, function () {
            return listener(eventType, event);
          }, true);
        });
      } else {
        _this.frameworkOverrides.dispatchEvent(eventType, function () {
          return listener(eventType, event);
        }, true);
      }
    });
  };
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  EventService.prototype.dispatchAsync = function (func) {
    // add to the queue for executing later in the next VM turn
    this.asyncFunctionsQueue.push(func);
    // check if timeout is already scheduled. the first time the grid calls
    // this within it's thread turn, this should be false, so it will schedule
    // the 'flush queue' method the first time it comes here. then the flag is
    // set to 'true' so it will know it's already scheduled for subsequent calls.
    if (!this.scheduled) {
      // if not scheduled, schedule one
      window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      // mark that it is scheduled
      this.scheduled = true;
    }
  };
  // this happens in the next VM turn only, and empties the queue of events
  EventService.prototype.flushAsyncQueue = function () {
    this.scheduled = false;
    // we take a copy, because the event listener could be using
    // the grid, which would cause more events, which would be potentially
    // added to the queue, so safe to take a copy, the new events will
    // get executed in a later VM turn rather than risk updating the
    // queue as we are flushing it.
    var queueCopy = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [];
    // execute the queue
    queueCopy.forEach(function (func) {
      return func();
    });
  };
  __decorate([__param(0, Qualifier('loggerFactory')), __param(1, Qualifier('gridOptionsWrapper')), __param(2, Qualifier('frameworkOverrides')), __param(3, Qualifier('globalEventListener'))], EventService.prototype, "setBeans", null);
  EventService = __decorate([Bean('eventService')], EventService);
  return EventService;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var Constants = /** @class */function () {
  function Constants() {}
  Constants.ROW_BUFFER_SIZE = 10;
  Constants.LAYOUT_INTERVAL = 500;
  Constants.BATCH_WAIT_MILLIS = 50;
  Constants.EXPORT_TYPE_DRAG_COPY = 'dragCopy';
  Constants.EXPORT_TYPE_CLIPBOARD = 'clipboard';
  Constants.EXPORT_TYPE_EXCEL = 'excel';
  Constants.EXPORT_TYPE_CSV = 'csv';
  Constants.ROW_MODEL_TYPE_INFINITE = 'infinite';
  Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
  Constants.ROW_MODEL_TYPE_CLIENT_SIDE = 'clientSide';
  Constants.ROW_MODEL_TYPE_SERVER_SIDE = 'serverSide';
  Constants.ALWAYS = 'always';
  Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
  Constants.PINNED_TOP = 'top';
  Constants.PINNED_BOTTOM = 'bottom';
  Constants.DOM_LAYOUT_NORMAL = 'normal';
  Constants.DOM_LAYOUT_PRINT = 'print';
  Constants.DOM_LAYOUT_AUTO_HEIGHT = 'autoHeight';
  Constants.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
  Constants.SOURCE_PASTE = 'paste';
  Constants.PINNED_RIGHT = 'right';
  Constants.PINNED_LEFT = 'left';
  Constants.SORT_ASC = 'asc';
  Constants.SORT_DESC = 'desc';
  Constants.INPUT_SELECTOR = 'input, select, button, textarea';
  Constants.FOCUSABLE_SELECTOR = '[tabindex], input, select, button, textarea';
  Constants.FOCUSABLE_EXCLUDE = '.ag-hidden, .ag-hidden *, [disabled], .ag-disabled, .ag-disabled *';
  return Constants;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ModuleNames;
(function (ModuleNames) {
  // when using modules, user references this
  ModuleNames["CommunityCoreModule"] = "@ag-grid-community/core";
  // when not using modules, user references this
  ModuleNames["CommunityAllModules"] = "@ag-grid-community/all";
  // community modules
  ModuleNames["InfiniteRowModelModule"] = "@ag-grid-community/infinite-row-model";
  ModuleNames["ClientSideRowModelModule"] = "@ag-grid-community/client-side-row-model";
  ModuleNames["CsvExportModule"] = "@ag-grid-community/csv-export";
  // enterprise core - users never import on this, but other enterprise modules do
  ModuleNames["EnterpriseCoreModule"] = "@ag-grid-enterprise/core";
  // when not using modules, user references this
  ModuleNames["EnterpriseAllModules"] = "@ag-grid-enterprise/all";
  // enterprise modules
  ModuleNames["RowGroupingModule"] = "@ag-grid-enterprise/row-grouping";
  ModuleNames["ColumnToolPanelModule"] = "@ag-grid-enterprise/column-tool-panel";
  ModuleNames["FiltersToolPanelModule"] = "@ag-grid-enterprise/filter-tool-panel";
  ModuleNames["MenuModule"] = "@ag-grid-enterprise/menu";
  ModuleNames["SetFilterModule"] = "@ag-grid-enterprise/set-filter";
  ModuleNames["MultiFilterModule"] = "@ag-grid-enterprise/multi-filter";
  ModuleNames["StatusBarModule"] = "@ag-grid-enterprise/status-bar";
  ModuleNames["SideBarModule"] = "@ag-grid-enterprise/side-bar";
  ModuleNames["RangeSelectionModule"] = "@ag-grid-enterprise/range-selection";
  ModuleNames["MasterDetailModule"] = "@ag-grid-enterprise/master-detail";
  ModuleNames["RichSelectModule"] = "@ag-grid-enterprise/rich-select";
  ModuleNames["GridChartsModule"] = "@ag-grid-enterprise/charts";
  ModuleNames["ViewportRowModelModule"] = "@ag-grid-enterprise/viewport-row-model";
  ModuleNames["ServerSideRowModelModule"] = "@ag-grid-enterprise/server-side-row-model";
  ModuleNames["ExcelExportModule"] = "@ag-grid-enterprise/excel-export";
  ModuleNames["ClipboardModule"] = "@ag-grid-enterprise/clipboard";
  ModuleNames["SparklinesModule"] = "@ag-grid-enterprise/sparklines";
  // framework wrappers currently don't provide beans, comps etc, so no need to be modules,
  // however i argue they should be as in theory they 'could' provide beans etc
  ModuleNames["AngularModule"] = "@ag-grid-community/angular";
  ModuleNames["ReactModule"] = "@ag-grid-community/react";
  ModuleNames["VueModule"] = "@ag-grid-community/vue";
  ModuleNames["PolymerModule"] = "@ag-grid-community/polymer";
  // and then this, which is definitely not a grid module, as it should not have any dependency
  // on the grid (ie shouldn't even reference the Module interface)
  // ChartsModule = "@ag-grid-community/charts-core",
})(ModuleNames || (ModuleNames = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ModuleRegistry = /** @class */function () {
  function ModuleRegistry() {}
  ModuleRegistry.register = function (module, moduleBased) {
    if (moduleBased === void 0) {
      moduleBased = true;
    }
    ModuleRegistry.modulesMap[module.moduleName] = module;
    if (ModuleRegistry.moduleBased === undefined) {
      ModuleRegistry.moduleBased = moduleBased;
    } else {
      if (ModuleRegistry.moduleBased !== moduleBased) {
        doOnce(function () {
          console.warn("AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms.");
          console.warn('Please see https://www.ag-grid.com/javascript-grid/packages-modules/ for more information.');
        }, 'ModulePackageCheck');
      }
    }
  };
  // noinspection JSUnusedGlobalSymbols
  ModuleRegistry.registerModules = function (modules, moduleBased) {
    if (moduleBased === void 0) {
      moduleBased = true;
    }
    if (!modules) {
      return;
    }
    modules.forEach(function (module) {
      return ModuleRegistry.register(module, moduleBased);
    });
  };
  ModuleRegistry.assertRegistered = function (moduleName, reason) {
    if (this.isRegistered(moduleName)) {
      return true;
    }
    var warningKey = reason + moduleName;
    var warningMessage = "AG Grid: unable to use " + reason + " as module " + moduleName + " is not present. Please see: https://www.ag-grid.com/javascript-grid/modules/";
    doOnce(function () {
      console.warn(warningMessage);
    }, warningKey);
    return false;
  };
  ModuleRegistry.isRegistered = function (moduleName) {
    return !!ModuleRegistry.modulesMap[moduleName];
  };
  ModuleRegistry.getRegisteredModules = function () {
    return values(ModuleRegistry.modulesMap);
  };
  ModuleRegistry.isPackageBased = function () {
    return !ModuleRegistry.moduleBased;
  };
  // having in a map a) removes duplicates and b) allows fast lookup
  ModuleRegistry.modulesMap = {};
  return ModuleRegistry;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$1 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var instanceIdSequence = 0;
// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
// appear as a child of either the original tree or the displayed tree. However the relevant group classes
// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
// can only appear in OriginalColumn tree).
var Column = /** @class */function () {
  function Column(colDef, userProvidedColDef, colId, primary) {
    // used by React (and possibly other frameworks) as key for rendering
    this.instanceId = instanceIdSequence++;
    this.moving = false;
    this.menuVisible = false;
    this.filterActive = false;
    this.eventService = new EventService();
    this.rowGroupActive = false;
    this.pivotActive = false;
    this.aggregationActive = false;
    this.colDef = colDef;
    this.userProvidedColDef = userProvidedColDef;
    this.colId = colId;
    this.primary = primary;
    this.setState(colDef);
  }
  Column.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  Column.prototype.setState = function (colDef) {
    // sort
    if (colDef.sort !== undefined) {
      if (colDef.sort === Constants.SORT_ASC || colDef.sort === Constants.SORT_DESC) {
        this.sort = colDef.sort;
      }
    } else {
      if (colDef.initialSort === Constants.SORT_ASC || colDef.initialSort === Constants.SORT_DESC) {
        this.sort = colDef.initialSort;
      }
    }
    // sortIndex
    var sortIndex = attrToNumber(colDef.sortIndex);
    var initialSortIndex = attrToNumber(colDef.initialSortIndex);
    if (sortIndex !== undefined) {
      if (sortIndex !== null) {
        this.sortIndex = sortIndex;
      }
    } else {
      if (initialSortIndex !== null) {
        this.sortIndex = initialSortIndex;
      }
    }
    // hide
    var hide = attrToBoolean(colDef.hide);
    var initialHide = attrToBoolean(colDef.initialHide);
    if (hide !== undefined) {
      this.visible = !hide;
    } else {
      this.visible = !initialHide;
    }
    // pinned
    if (colDef.pinned !== undefined) {
      this.setPinned(colDef.pinned);
    } else {
      this.setPinned(colDef.initialPinned);
    }
    // flex
    var flex = attrToNumber(colDef.flex);
    var initialFlex = attrToNumber(colDef.initialFlex);
    if (flex !== undefined) {
      this.flex = flex;
    } else if (initialFlex !== undefined) {
      this.flex = initialFlex;
    }
  };
  // gets called when user provides an alternative colDef, eg
  Column.prototype.setColDef = function (colDef, userProvidedColDef) {
    this.colDef = colDef;
    this.userProvidedColDef = userProvidedColDef;
    this.initMinAndMaxWidths();
    this.initDotNotation();
  };
  /**
   * Returns the column definition provided by the application.
   * This may not be correct, as items can be superseded by default column options.
   * However it's useful for comparison, eg to know which application column definition matches that column.
   */
  Column.prototype.getUserProvidedColDef = function () {
    return this.userProvidedColDef;
  };
  Column.prototype.setParent = function (parent) {
    this.parent = parent;
  };
  /** Returns the parent column group, if column grouping is active. */
  Column.prototype.getParent = function () {
    return this.parent;
  };
  Column.prototype.setOriginalParent = function (originalParent) {
    this.originalParent = originalParent;
  };
  Column.prototype.getOriginalParent = function () {
    return this.originalParent;
  };
  // this is done after constructor as it uses gridOptionsWrapper
  Column.prototype.initialise = function () {
    this.initMinAndMaxWidths();
    this.resetActualWidth('gridInitializing');
    this.initDotNotation();
    this.validate();
  };
  Column.prototype.initDotNotation = function () {
    var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
    this.fieldContainsDots = exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
    this.tooltipFieldContainsDots = exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
  };
  Column.prototype.initMinAndMaxWidths = function () {
    var colDef = this.colDef;
    this.minWidth = this.columnUtils.calculateColMinWidth(colDef);
    this.maxWidth = this.columnUtils.calculateColMaxWidth(colDef);
  };
  Column.prototype.resetActualWidth = function (source) {
    if (source === void 0) {
      source = 'api';
    }
    var initialWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
    this.setActualWidth(initialWidth, source, true);
  };
  Column.prototype.isEmptyGroup = function () {
    return false;
  };
  Column.prototype.isRowGroupDisplayed = function (colId) {
    if (missing(this.colDef) || missing(this.colDef.showRowGroup)) {
      return false;
    }
    var showingAllGroups = this.colDef.showRowGroup === true;
    var showingThisGroup = this.colDef.showRowGroup === colId;
    return showingAllGroups || showingThisGroup;
  };
  /** Returns `true` if column is a primary column, `false` if secondary. Secondary columns are used for pivoting. */
  Column.prototype.isPrimary = function () {
    return this.primary;
  };
  /** Returns `true` if column filtering is allowed. */
  Column.prototype.isFilterAllowed = function () {
    // filter defined means it's a string, class or true.
    // if its false, null or undefined then it's false.
    var filterDefined = !!this.colDef.filter || !!this.colDef.filterFramework;
    return this.primary && filterDefined;
  };
  Column.prototype.isFieldContainsDots = function () {
    return this.fieldContainsDots;
  };
  Column.prototype.isTooltipFieldContainsDots = function () {
    return this.tooltipFieldContainsDots;
  };
  Column.prototype.validate = function () {
    var colDefAny = this.colDef;
    function warnOnce(msg, key, obj) {
      doOnce(function () {
        if (obj) {
          console.warn(msg, obj);
        } else {
          doOnce(function () {
            return console.warn(msg);
          }, key);
        }
      }, key);
    }
    var usingCSRM = this.gridOptionsWrapper.isRowModelDefault();
    if (usingCSRM && !ModuleRegistry.isRegistered(ModuleNames.RowGroupingModule)) {
      var rowGroupingItems = ['enableRowGroup', 'rowGroup', 'rowGroupIndex', 'enablePivot', 'enableValue', 'pivot', 'pivotIndex', 'aggFunc'];
      rowGroupingItems.forEach(function (item) {
        if (exists(colDefAny[item])) {
          if (ModuleRegistry.isPackageBased()) {
            warnOnce("AG Grid: " + item + " is only valid in ag-grid-enterprise, your column definition should not have " + item, 'ColumnRowGroupingMissing' + item);
          } else {
            warnOnce("AG Grid: " + item + " is only valid with AG Grid Enterprise Module " + ModuleNames.RowGroupingModule + " - your column definition should not have " + item, 'ColumnRowGroupingMissing' + item);
          }
        }
      });
    }
    if (!ModuleRegistry.isRegistered(ModuleNames.RichSelectModule)) {
      if (this.colDef.cellEditor === 'agRichSelect') {
        if (ModuleRegistry.isPackageBased()) {
          warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with ag-grid-enterprise", 'ColumnRichSelectMissing');
        } else {
          warnOnce("AG Grid: " + this.colDef.cellEditor + " can only be used with AG Grid Enterprise Module " + ModuleNames.RichSelectModule, 'ColumnRichSelectMissing');
        }
      }
    }
    if (this.gridOptionsWrapper.isTreeData()) {
      var itemsNotAllowedWithTreeData = ['rowGroup', 'rowGroupIndex', 'pivot', 'pivotIndex'];
      itemsNotAllowedWithTreeData.forEach(function (item) {
        if (exists(colDefAny[item])) {
          warnOnce("AG Grid: " + item + " is not possible when doing tree data, your column definition should not have " + item, 'TreeDataCannotRowGroup');
        }
      });
    }
    if (exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
      warnOnce('AG Grid: colDef.width should be a number, not ' + typeof this.colDef.width, 'ColumnCheck_asdfawef');
    }
    if (colDefAny.pinnedRowCellRenderer) {
      warnOnce('AG Grid: pinnedRowCellRenderer no longer exists, use cellRendererSelector if you want a different Cell Renderer for pinned rows. Check params.node.rowPinned. This was an unfortunate (but necessary) change we had to do to allow future plans we have of re-skinng the data grid in frameworks such as React, Angular and Vue. See https://www.ag-grid.com/javascript-grid/cell-rendering/#many-renderers-one-column', 'colDef.pinnedRowCellRenderer-deprecated');
    }
    if (colDefAny.pinnedRowCellRendererParams) {
      warnOnce('AG Grid: pinnedRowCellRenderer no longer exists, use cellRendererSelector if you want a different Cell Renderer for pinned rows. Check params.node.rowPinned. This was an unfortunate (but necessary) change we had to do to allow future plans we have of re-skinng the data grid in frameworks such as React, Angular and Vue. See https://www.ag-grid.com/javascript-grid/cell-rendering/#many-renderers-one-column', 'colDef.pinnedRowCellRenderer-deprecated');
    }
    if (colDefAny.pinnedRowCellRendererFramework) {
      warnOnce('AG Grid: pinnedRowCellRenderer no longer exists, use cellRendererSelector if you want a different Cell Renderer for pinned rows. Check params.node.rowPinned. This was an unfortunate (but necessary) change we had to do to allow future plans we have of re-skinng the data grid in frameworks such as React, Angular and Vue. See https://www.ag-grid.com/javascript-grid/cell-rendering/#many-renderers-one-column', 'colDef.pinnedRowCellRenderer-deprecated');
    }
    if (colDefAny.pinnedRowValueGetter) {
      warnOnce('AG Grid: pinnedRowCellRenderer is deprecated, use cellRendererSelector if you want a different Cell Renderer for pinned rows. Check params.node.rowPinned. This was an unfortunate (but necessary) change we had to do to allow future plans we have of re-skinng the data grid in frameworks such as React, Angular and Vue.', 'colDef.pinnedRowCellRenderer-deprecated');
    }
  };
  /** Add an event listener to the column. */
  Column.prototype.addEventListener = function (eventType, listener) {
    this.eventService.addEventListener(eventType, listener);
  };
  /** Remove event listener from the column. */
  Column.prototype.removeEventListener = function (eventType, listener) {
    this.eventService.removeEventListener(eventType, listener);
  };
  Column.prototype.createColumnFunctionCallbackParams = function (rowNode) {
    return {
      node: rowNode,
      data: rowNode.data,
      column: this,
      colDef: this.colDef,
      context: this.gridOptionsWrapper.getContext(),
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi()
    };
  };
  Column.prototype.isSuppressNavigable = function (rowNode) {
    // if boolean set, then just use it
    if (typeof this.colDef.suppressNavigable === 'boolean') {
      return this.colDef.suppressNavigable;
    }
    // if function, then call the function to find out
    if (typeof this.colDef.suppressNavigable === 'function') {
      var params = this.createColumnFunctionCallbackParams(rowNode);
      var userFunc = this.colDef.suppressNavigable;
      return userFunc(params);
    }
    return false;
  };
  Column.prototype.isCellEditable = function (rowNode) {
    // only allow editing of groups if the user has this option enabled
    if (rowNode.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
      return false;
    }
    return this.isColumnFunc(rowNode, this.colDef.editable);
  };
  Column.prototype.isSuppressFillHandle = function () {
    return !!this.colDef.suppressFillHandle;
  };
  Column.prototype.isRowDrag = function (rowNode) {
    return this.isColumnFunc(rowNode, this.colDef.rowDrag);
  };
  Column.prototype.isDndSource = function (rowNode) {
    return this.isColumnFunc(rowNode, this.colDef.dndSource);
  };
  Column.prototype.isCellCheckboxSelection = function (rowNode) {
    return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
  };
  Column.prototype.isSuppressPaste = function (rowNode) {
    return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
  };
  Column.prototype.isResizable = function () {
    return this.colDef.resizable === true;
  };
  Column.prototype.isColumnFunc = function (rowNode, value) {
    // if boolean set, then just use it
    if (typeof value === 'boolean') {
      return value;
    }
    // if function, then call the function to find out
    if (typeof value === 'function') {
      var params = this.createColumnFunctionCallbackParams(rowNode);
      var editableFunc = value;
      return editableFunc(params);
    }
    return false;
  };
  Column.prototype.setMoving = function (moving, source) {
    if (source === void 0) {
      source = "api";
    }
    this.moving = moving;
    this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MOVING_CHANGED, source));
  };
  Column.prototype.createColumnEvent = function (type, source) {
    return {
      api: this.gridApi,
      columnApi: this.columnApi,
      type: type,
      column: this,
      columns: [this],
      source: source
    };
  };
  Column.prototype.isMoving = function () {
    return this.moving;
  };
  /** If sorting is active, returns the sort direction e.g. `'asc'` or `'desc'`. */
  Column.prototype.getSort = function () {
    return this.sort;
  };
  Column.prototype.setSort = function (sort, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.sort !== sort) {
      this.sort = sort;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_SORT_CHANGED, source));
    }
  };
  Column.prototype.setMenuVisible = function (visible, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.menuVisible !== visible) {
      this.menuVisible = visible;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_MENU_VISIBLE_CHANGED, source));
    }
  };
  Column.prototype.isMenuVisible = function () {
    return this.menuVisible;
  };
  Column.prototype.isSortAscending = function () {
    return this.sort === Constants.SORT_ASC;
  };
  Column.prototype.isSortDescending = function () {
    return this.sort === Constants.SORT_DESC;
  };
  Column.prototype.isSortNone = function () {
    return missing(this.sort);
  };
  Column.prototype.isSorting = function () {
    return exists(this.sort);
  };
  Column.prototype.getSortIndex = function () {
    return this.sortIndex;
  };
  Column.prototype.setSortIndex = function (sortOrder) {
    this.sortIndex = sortOrder;
  };
  Column.prototype.setAggFunc = function (aggFunc) {
    this.aggFunc = aggFunc;
  };
  /** If aggregation is set for the column, returns the aggregation function. */
  Column.prototype.getAggFunc = function () {
    return this.aggFunc;
  };
  Column.prototype.getLeft = function () {
    return this.left;
  };
  Column.prototype.getOldLeft = function () {
    return this.oldLeft;
  };
  Column.prototype.getRight = function () {
    return this.left + this.actualWidth;
  };
  Column.prototype.setLeft = function (left, source) {
    if (source === void 0) {
      source = "api";
    }
    this.oldLeft = this.left;
    if (this.left !== left) {
      this.left = left;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LEFT_CHANGED, source));
    }
  };
  /** Returns `true` if filter is active on the column. */
  Column.prototype.isFilterActive = function () {
    return this.filterActive;
  };
  // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
  Column.prototype.setFilterActive = function (active, source, additionalEventAttributes) {
    if (source === void 0) {
      source = "api";
    }
    if (this.filterActive !== active) {
      this.filterActive = active;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FILTER_ACTIVE_CHANGED, source));
    }
    var filterChangedEvent = this.createColumnEvent(Column.EVENT_FILTER_CHANGED, source);
    if (additionalEventAttributes) {
      mergeDeep(filterChangedEvent, additionalEventAttributes);
    }
    this.eventService.dispatchEvent(filterChangedEvent);
  };
  Column.prototype.setPinned = function (pinned) {
    if (pinned === true || pinned === Constants.PINNED_LEFT) {
      this.pinned = Constants.PINNED_LEFT;
    } else if (pinned === Constants.PINNED_RIGHT) {
      this.pinned = Constants.PINNED_RIGHT;
    } else {
      this.pinned = null;
    }
  };
  Column.prototype.setFirstRightPinned = function (firstRightPinned, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.firstRightPinned !== firstRightPinned) {
      this.firstRightPinned = firstRightPinned;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, source));
    }
  };
  Column.prototype.setLastLeftPinned = function (lastLeftPinned, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.lastLeftPinned !== lastLeftPinned) {
      this.lastLeftPinned = lastLeftPinned;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED, source));
    }
  };
  Column.prototype.isFirstRightPinned = function () {
    return this.firstRightPinned;
  };
  Column.prototype.isLastLeftPinned = function () {
    return this.lastLeftPinned;
  };
  Column.prototype.isPinned = function () {
    return this.pinned === Constants.PINNED_LEFT || this.pinned === Constants.PINNED_RIGHT;
  };
  Column.prototype.isPinnedLeft = function () {
    return this.pinned === Constants.PINNED_LEFT;
  };
  Column.prototype.isPinnedRight = function () {
    return this.pinned === Constants.PINNED_RIGHT;
  };
  Column.prototype.getPinned = function () {
    return this.pinned;
  };
  Column.prototype.setVisible = function (visible, source) {
    if (source === void 0) {
      source = "api";
    }
    var newValue = visible === true;
    if (this.visible !== newValue) {
      this.visible = newValue;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VISIBLE_CHANGED, source));
    }
  };
  Column.prototype.isVisible = function () {
    return this.visible;
  };
  /** Returns the column definition for this column.
   * The column definition will be the result of merging the application provided column definition with any provided defaults
   * (e.g. `defaultColDef` grid option, or column types.
   *
   * Equivalent: `getDefinition` */
  Column.prototype.getColDef = function () {
    return this.colDef;
  };
  Column.prototype.getColumnGroupShow = function () {
    return this.colDef.columnGroupShow;
  };
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getId`, `getUniqueId` */
  Column.prototype.getColId = function () {
    return this.colId;
  };
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getUniqueId` */
  Column.prototype.getId = function () {
    return this.getColId();
  };
  /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getId` */
  Column.prototype.getUniqueId = function () {
    return this.getId();
  };
  Column.prototype.getDefinition = function () {
    return this.colDef;
  };
  /** Returns the current width of the column. If the column is resized, the actual width is the new size. */
  Column.prototype.getActualWidth = function () {
    return this.actualWidth;
  };
  Column.prototype.createBaseColDefParams = function (rowNode) {
    var params = {
      node: rowNode,
      data: rowNode.data,
      colDef: this.colDef,
      column: this,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      context: this.gridOptionsWrapper.getContext()
    };
    return params;
  };
  Column.prototype.getColSpan = function (rowNode) {
    if (missing(this.colDef.colSpan)) {
      return 1;
    }
    var params = this.createBaseColDefParams(rowNode);
    var colSpan = this.colDef.colSpan(params);
    // colSpan must be number equal to or greater than 1
    return Math.max(colSpan, 1);
  };
  Column.prototype.getRowSpan = function (rowNode) {
    if (missing(this.colDef.rowSpan)) {
      return 1;
    }
    var params = this.createBaseColDefParams(rowNode);
    var rowSpan = this.colDef.rowSpan(params);
    // rowSpan must be number equal to or greater than 1
    return Math.max(rowSpan, 1);
  };
  Column.prototype.setActualWidth = function (actualWidth, source, silent) {
    if (source === void 0) {
      source = "api";
    }
    if (silent === void 0) {
      silent = false;
    }
    if (this.minWidth != null) {
      actualWidth = Math.max(actualWidth, this.minWidth);
    }
    if (this.maxWidth != null) {
      actualWidth = Math.min(actualWidth, this.maxWidth);
    }
    if (this.actualWidth !== actualWidth) {
      // disable flex for this column if it was manually resized.
      this.actualWidth = actualWidth;
      if (this.flex && source !== 'flex' && source !== 'gridInitializing') {
        this.flex = null;
      }
      if (!silent) {
        this.fireColumnWidthChangedEvent(source);
      }
    }
  };
  Column.prototype.fireColumnWidthChangedEvent = function (source) {
    this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_WIDTH_CHANGED, source));
  };
  Column.prototype.isGreaterThanMax = function (width) {
    if (this.maxWidth != null) {
      return width > this.maxWidth;
    }
    return false;
  };
  Column.prototype.getMinWidth = function () {
    return this.minWidth;
  };
  Column.prototype.getMaxWidth = function () {
    return this.maxWidth;
  };
  Column.prototype.getFlex = function () {
    return this.flex || 0;
  };
  // this method should only be used by the columnModel to
  // change flex when required by the setColumnState method.
  Column.prototype.setFlex = function (flex) {
    if (this.flex !== flex) {
      this.flex = flex;
    }
  };
  Column.prototype.setMinimum = function (source) {
    if (source === void 0) {
      source = "api";
    }
    if (exists(this.minWidth)) {
      this.setActualWidth(this.minWidth, source);
    }
  };
  Column.prototype.setRowGroupActive = function (rowGroup, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.rowGroupActive !== rowGroup) {
      this.rowGroupActive = rowGroup;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_ROW_GROUP_CHANGED, source));
    }
  };
  /** Returns `true` if row group is currently active for this column. */
  Column.prototype.isRowGroupActive = function () {
    return this.rowGroupActive;
  };
  Column.prototype.setPivotActive = function (pivot, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.pivotActive !== pivot) {
      this.pivotActive = pivot;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_PIVOT_CHANGED, source));
    }
  };
  /** Returns `true` if pivot is currently active for this column. */
  Column.prototype.isPivotActive = function () {
    return this.pivotActive;
  };
  Column.prototype.isAnyFunctionActive = function () {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  };
  Column.prototype.isAnyFunctionAllowed = function () {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  };
  Column.prototype.setValueActive = function (value, source) {
    if (source === void 0) {
      source = "api";
    }
    if (this.aggregationActive !== value) {
      this.aggregationActive = value;
      this.eventService.dispatchEvent(this.createColumnEvent(Column.EVENT_VALUE_CHANGED, source));
    }
  };
  /** Returns `true` if value (aggregation) is currently active for this column. */
  Column.prototype.isValueActive = function () {
    return this.aggregationActive;
  };
  Column.prototype.isAllowPivot = function () {
    return this.colDef.enablePivot === true;
  };
  Column.prototype.isAllowValue = function () {
    return this.colDef.enableValue === true;
  };
  Column.prototype.isAllowRowGroup = function () {
    return this.colDef.enableRowGroup === true;
  };
  Column.prototype.getMenuTabs = function (defaultValues) {
    var menuTabs = this.getColDef().menuTabs;
    if (menuTabs == null) {
      menuTabs = defaultValues;
    }
    return menuTabs;
  };
  // this used to be needed, as previous version of ag-grid had lockPosition as column state,
  // so couldn't depend on colDef version.
  Column.prototype.isLockPosition = function () {
    console.warn('AG Grid: since v21, col.isLockPosition() should not be used, please use col.getColDef().lockPosition instead.');
    return this.colDef ? !!this.colDef.lockPosition : false;
  };
  // this used to be needed, as previous version of ag-grid had lockVisible as column state,
  // so couldn't depend on colDef version.
  Column.prototype.isLockVisible = function () {
    console.warn('AG Grid: since v21, col.isLockVisible() should not be used, please use col.getColDef().lockVisible instead.');
    return this.colDef ? !!this.colDef.lockVisible : false;
  };
  // this used to be needed, as previous version of ag-grid had lockPinned as column state,
  // so couldn't depend on colDef version.
  Column.prototype.isLockPinned = function () {
    console.warn('AG Grid: since v21, col.isLockPinned() should not be used, please use col.getColDef().lockPinned instead.');
    return this.colDef ? !!this.colDef.lockPinned : false;
  };
  // + renderedHeaderCell - for making header cell transparent when moving
  Column.EVENT_MOVING_CHANGED = 'movingChanged';
  // + renderedCell - changing left position
  Column.EVENT_LEFT_CHANGED = 'leftChanged';
  // + renderedCell - changing width
  Column.EVENT_WIDTH_CHANGED = 'widthChanged';
  // + renderedCell - for changing pinned classes
  Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
  Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
  // + renderedColumn - for changing visibility icon
  Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
  // + every time the filter changes, used in the floating filters
  Column.EVENT_FILTER_CHANGED = 'filterChanged';
  // + renderedHeaderCell - marks the header with filter icon
  Column.EVENT_FILTER_ACTIVE_CHANGED = 'filterActiveChanged';
  // + renderedHeaderCell - marks the header with sort icon
  Column.EVENT_SORT_CHANGED = 'sortChanged';
  Column.EVENT_MENU_VISIBLE_CHANGED = 'menuVisibleChanged';
  // + toolpanel, for gui updates
  Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
  // + toolpanel, for gui updates
  Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
  // + toolpanel, for gui updates
  Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
  __decorate$1([Autowired('gridOptionsWrapper')], Column.prototype, "gridOptionsWrapper", void 0);
  __decorate$1([Autowired('columnUtils')], Column.prototype, "columnUtils", void 0);
  __decorate$1([Autowired('columnApi')], Column.prototype, "columnApi", void 0);
  __decorate$1([Autowired('gridApi')], Column.prototype, "gridApi", void 0);
  __decorate$1([Autowired('context')], Column.prototype, "context", void 0);
  __decorate$1([PostConstruct], Column.prototype, "initialise", null);
  return Column;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$2 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnGroup = /** @class */function () {
  function ColumnGroup(originalColumnGroup, groupId, instanceId, pinned) {
    // depends on the open/closed state of the group, only displaying columns are stored here
    this.displayedChildren = [];
    this.localEventService = new EventService();
    this.groupId = groupId;
    this.instanceId = instanceId;
    this.originalColumnGroup = originalColumnGroup;
    this.pinned = pinned;
  }
  // this is static, a it is used outside of this class
  ColumnGroup.createUniqueId = function (groupId, instanceId) {
    return groupId + '_' + instanceId;
  };
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  ColumnGroup.prototype.reset = function () {
    this.parent = null;
    this.children = null;
    this.displayedChildren = null;
  };
  ColumnGroup.prototype.getParent = function () {
    return this.parent;
  };
  ColumnGroup.prototype.setParent = function (parent) {
    this.parent = parent;
  };
  ColumnGroup.prototype.getUniqueId = function () {
    return ColumnGroup.createUniqueId(this.groupId, this.instanceId);
  };
  ColumnGroup.prototype.isEmptyGroup = function () {
    return this.displayedChildren.length === 0;
  };
  ColumnGroup.prototype.isMoving = function () {
    var allLeafColumns = this.getOriginalColumnGroup().getLeafColumns();
    if (!allLeafColumns || allLeafColumns.length === 0) {
      return false;
    }
    return allLeafColumns.every(function (col) {
      return col.isMoving();
    });
  };
  ColumnGroup.prototype.checkLeft = function () {
    // first get all children to setLeft, as it impacts our decision below
    this.displayedChildren.forEach(function (child) {
      if (child instanceof ColumnGroup) {
        child.checkLeft();
      }
    });
    // set our left based on first displayed column
    if (this.displayedChildren.length > 0) {
      if (this.gridOptionsWrapper.isEnableRtl()) {
        var lastChild = last(this.displayedChildren);
        var lastChildLeft = lastChild.getLeft();
        this.setLeft(lastChildLeft);
      } else {
        var firstChildLeft = this.displayedChildren[0].getLeft();
        this.setLeft(firstChildLeft);
      }
    } else {
      // this should never happen, as if we have no displayed columns, then
      // this groups should not even exist.
      this.setLeft(null);
    }
  };
  ColumnGroup.prototype.getLeft = function () {
    return this.left;
  };
  ColumnGroup.prototype.getOldLeft = function () {
    return this.oldLeft;
  };
  ColumnGroup.prototype.setLeft = function (left) {
    this.oldLeft = left;
    if (this.left !== left) {
      this.left = left;
      this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_LEFT_CHANGED));
    }
  };
  ColumnGroup.prototype.getPinned = function () {
    return this.pinned;
  };
  ColumnGroup.prototype.createAgEvent = function (type) {
    return {
      type: type
    };
  };
  ColumnGroup.prototype.addEventListener = function (eventType, listener) {
    this.localEventService.addEventListener(eventType, listener);
  };
  ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
    this.localEventService.removeEventListener(eventType, listener);
  };
  ColumnGroup.prototype.getGroupId = function () {
    return this.groupId;
  };
  ColumnGroup.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
    var result = false;
    this.children.forEach(function (foundChild) {
      if (wantedChild === foundChild) {
        result = true;
      }
      if (foundChild instanceof ColumnGroup) {
        if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
          result = true;
        }
      }
    });
    return result;
  };
  ColumnGroup.prototype.getActualWidth = function () {
    var groupActualWidth = 0;
    if (this.displayedChildren) {
      this.displayedChildren.forEach(function (child) {
        groupActualWidth += child.getActualWidth();
      });
    }
    return groupActualWidth;
  };
  ColumnGroup.prototype.isResizable = function () {
    if (!this.displayedChildren) {
      return false;
    }
    // if at least one child is resizable, then the group is resizable
    var result = false;
    this.displayedChildren.forEach(function (child) {
      if (child.isResizable()) {
        result = true;
      }
    });
    return result;
  };
  ColumnGroup.prototype.getMinWidth = function () {
    var result = 0;
    this.displayedChildren.forEach(function (groupChild) {
      result += groupChild.getMinWidth() || 0;
    });
    return result;
  };
  ColumnGroup.prototype.addChild = function (child) {
    if (!this.children) {
      this.children = [];
    }
    this.children.push(child);
  };
  ColumnGroup.prototype.getDisplayedChildren = function () {
    return this.displayedChildren;
  };
  ColumnGroup.prototype.getLeafColumns = function () {
    var result = [];
    this.addLeafColumns(result);
    return result;
  };
  ColumnGroup.prototype.getDisplayedLeafColumns = function () {
    var result = [];
    this.addDisplayedLeafColumns(result);
    return result;
  };
  // why two methods here doing the same thing?
  ColumnGroup.prototype.getDefinition = function () {
    return this.originalColumnGroup.getColGroupDef();
  };
  ColumnGroup.prototype.getColGroupDef = function () {
    return this.originalColumnGroup.getColGroupDef();
  };
  ColumnGroup.prototype.isPadding = function () {
    return this.originalColumnGroup.isPadding();
  };
  ColumnGroup.prototype.isExpandable = function () {
    return this.originalColumnGroup.isExpandable();
  };
  ColumnGroup.prototype.isExpanded = function () {
    return this.originalColumnGroup.isExpanded();
  };
  ColumnGroup.prototype.setExpanded = function (expanded) {
    this.originalColumnGroup.setExpanded(expanded);
  };
  ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
    this.displayedChildren.forEach(function (child) {
      if (child instanceof Column) {
        leafColumns.push(child);
      } else if (child instanceof ColumnGroup) {
        child.addDisplayedLeafColumns(leafColumns);
      }
    });
  };
  ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
    this.children.forEach(function (child) {
      if (child instanceof Column) {
        leafColumns.push(child);
      } else if (child instanceof ColumnGroup) {
        child.addLeafColumns(leafColumns);
      }
    });
  };
  ColumnGroup.prototype.getChildren = function () {
    return this.children;
  };
  ColumnGroup.prototype.getColumnGroupShow = function () {
    return this.originalColumnGroup.getColumnGroupShow();
  };
  ColumnGroup.prototype.getOriginalColumnGroup = function () {
    return this.originalColumnGroup;
  };
  ColumnGroup.prototype.getPaddingLevel = function () {
    var parent = this.getParent();
    if (!this.isPadding() || !parent || !parent.isPadding()) {
      return 0;
    }
    return 1 + parent.getPaddingLevel();
  };
  ColumnGroup.prototype.calculateDisplayedColumns = function () {
    var _this = this;
    // clear out last time we calculated
    this.displayedChildren = [];
    // find the column group that is controlling expandable. this is relevant when we have padding (empty)
    // groups, where the expandable is actually the first parent that is not a padding group.
    var parentWithExpansion = this;
    while (parentWithExpansion != null && parentWithExpansion.isPadding()) {
      parentWithExpansion = parentWithExpansion.getParent();
    }
    var isExpandable = parentWithExpansion ? parentWithExpansion.originalColumnGroup.isExpandable() : false;
    // it not expandable, everything is visible
    if (!isExpandable) {
      this.displayedChildren = this.children;
      this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
      return;
    }
    // Add cols based on columnGroupShow
    // Note - the below also adds padding groups, these are always added because they never have
    // colDef.columnGroupShow set.
    this.children.forEach(function (child) {
      // never add empty groups
      var emptyGroup = child instanceof ColumnGroup && (!child.displayedChildren || !child.displayedChildren.length);
      if (emptyGroup) {
        return;
      }
      var headerGroupShow = child.getColumnGroupShow();
      switch (headerGroupShow) {
        case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
          // when set to open, only show col if group is open
          if (parentWithExpansion.originalColumnGroup.isExpanded()) {
            _this.displayedChildren.push(child);
          }
          break;
        case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
          // when set to open, only show col if group is open
          if (!parentWithExpansion.originalColumnGroup.isExpanded()) {
            _this.displayedChildren.push(child);
          }
          break;
        default:
          _this.displayedChildren.push(child);
          break;
      }
    });
    this.localEventService.dispatchEvent(this.createAgEvent(ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
  };
  ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
  ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
  ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
  ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = 'displayedChildrenChanged';
  __decorate$2([Autowired('gridOptionsWrapper')], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
  return ColumnGroup;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ProvidedColumnGroup = /** @class */function () {
  function ProvidedColumnGroup(colGroupDef, groupId, padding, level) {
    this.localEventService = new EventService();
    this.expandable = false;
    this.colGroupDef = colGroupDef;
    this.groupId = groupId;
    this.expanded = !!colGroupDef && !!colGroupDef.openByDefault;
    this.padding = padding;
    this.level = level;
  }
  ProvidedColumnGroup.prototype.setOriginalParent = function (originalParent) {
    this.originalParent = originalParent;
  };
  ProvidedColumnGroup.prototype.getOriginalParent = function () {
    return this.originalParent;
  };
  ProvidedColumnGroup.prototype.getLevel = function () {
    return this.level;
  };
  ProvidedColumnGroup.prototype.isVisible = function () {
    // return true if at least one child is visible
    if (this.children) {
      return this.children.some(function (child) {
        return child.isVisible();
      });
    }
    return false;
  };
  ProvidedColumnGroup.prototype.isPadding = function () {
    return this.padding;
  };
  ProvidedColumnGroup.prototype.setExpanded = function (expanded) {
    this.expanded = expanded === undefined ? false : expanded;
    var event = {
      type: ProvidedColumnGroup.EVENT_EXPANDED_CHANGED
    };
    this.localEventService.dispatchEvent(event);
  };
  ProvidedColumnGroup.prototype.isExpandable = function () {
    return this.expandable;
  };
  ProvidedColumnGroup.prototype.isExpanded = function () {
    return this.expanded;
  };
  ProvidedColumnGroup.prototype.getGroupId = function () {
    return this.groupId;
  };
  ProvidedColumnGroup.prototype.getId = function () {
    return this.getGroupId();
  };
  ProvidedColumnGroup.prototype.setChildren = function (children) {
    this.children = children;
  };
  ProvidedColumnGroup.prototype.getChildren = function () {
    return this.children;
  };
  ProvidedColumnGroup.prototype.getColGroupDef = function () {
    return this.colGroupDef;
  };
  ProvidedColumnGroup.prototype.getLeafColumns = function () {
    var result = [];
    this.addLeafColumns(result);
    return result;
  };
  ProvidedColumnGroup.prototype.addLeafColumns = function (leafColumns) {
    if (!this.children) {
      return;
    }
    this.children.forEach(function (child) {
      if (child instanceof Column) {
        leafColumns.push(child);
      } else if (child instanceof ProvidedColumnGroup) {
        child.addLeafColumns(leafColumns);
      }
    });
  };
  ProvidedColumnGroup.prototype.getColumnGroupShow = function () {
    var colGroupDef = this.colGroupDef;
    if (!colGroupDef) {
      return;
    }
    return colGroupDef.columnGroupShow;
  };
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  ProvidedColumnGroup.prototype.setupExpandable = function () {
    var _this = this;
    this.setExpandable();
    // note - we should be removing this event listener
    this.getLeafColumns().forEach(function (col) {
      return col.addEventListener(Column.EVENT_VISIBLE_CHANGED, _this.onColumnVisibilityChanged.bind(_this));
    });
  };
  ProvidedColumnGroup.prototype.setExpandable = function () {
    if (this.isPadding()) {
      return;
    }
    // want to make sure the group doesn't disappear when it's open
    var atLeastOneShowingWhenOpen = false;
    // want to make sure the group doesn't disappear when it's closed
    var atLeastOneShowingWhenClosed = false;
    // want to make sure the group has something to show / hide
    var atLeastOneChangeable = false;
    var children = this.findChildrenRemovingPadding();
    for (var i = 0, j = children.length; i < j; i++) {
      var abstractColumn = children[i];
      if (!abstractColumn.isVisible()) {
        continue;
      }
      // if the abstractColumn is a grid generated group, there will be no colDef
      var headerGroupShow = abstractColumn.getColumnGroupShow();
      if (headerGroupShow === ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
        atLeastOneShowingWhenOpen = true;
        atLeastOneChangeable = true;
      } else if (headerGroupShow === ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
        atLeastOneShowingWhenClosed = true;
        atLeastOneChangeable = true;
      } else {
        atLeastOneShowingWhenOpen = true;
        atLeastOneShowingWhenClosed = true;
      }
    }
    var expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
    if (this.expandable !== expandable) {
      this.expandable = expandable;
      var event_1 = {
        type: ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED
      };
      this.localEventService.dispatchEvent(event_1);
    }
  };
  ProvidedColumnGroup.prototype.findChildrenRemovingPadding = function () {
    var res = [];
    var process = function process(items) {
      items.forEach(function (item) {
        // if padding, we add this children instead of the padding
        var skipBecausePadding = item instanceof ProvidedColumnGroup && item.isPadding();
        if (skipBecausePadding) {
          process(item.children);
        } else {
          res.push(item);
        }
      });
    };
    process(this.children);
    return res;
  };
  ProvidedColumnGroup.prototype.onColumnVisibilityChanged = function () {
    this.setExpandable();
  };
  ProvidedColumnGroup.prototype.addEventListener = function (eventType, listener) {
    this.localEventService.addEventListener(eventType, listener);
  };
  ProvidedColumnGroup.prototype.removeEventListener = function (eventType, listener) {
    this.localEventService.removeEventListener(eventType, listener);
  };
  ProvidedColumnGroup.EVENT_EXPANDED_CHANGED = 'expandedChanged';
  ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED = 'expandableChanged';
  return ProvidedColumnGroup;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var DefaultColumnTypes = {
  numericColumn: {
    headerClass: 'ag-right-aligned-header',
    cellClass: 'ag-right-aligned-cell'
  },
  rightAligned: {
    headerClass: 'ag-right-aligned-header',
    cellClass: 'ag-right-aligned-cell'
  }
};

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var AG_GRID_STOP_PROPAGATION = '__ag_Grid_Stop_Propagation';
var PASSIVE_EVENTS = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
var supports = {};
/**
 * a user once raised an issue - they said that when you opened a popup (eg context menu)
 * and then clicked on a selection checkbox, the popup wasn't closed. this is because the
 * popup listens for clicks on the body, however ag-grid WAS stopping propagation on the
 * checkbox clicks (so the rows didn't pick them up as row selection selection clicks).
 * to get around this, we have a pattern to stop propagation for the purposes of AG Grid,
 * but we still let the event pass back to the body.
 * @param {Event} event
 */
function stopPropagationForAgGrid(event) {
  event[AG_GRID_STOP_PROPAGATION] = true;
}
function isStopPropagationForAgGrid(event) {
  return event[AG_GRID_STOP_PROPAGATION] === true;
}
var isEventSupported = function () {
  var tags = {
    select: 'input',
    change: 'input',
    submit: 'form',
    reset: 'form',
    error: 'img',
    load: 'img',
    abort: 'img'
  };
  var eventChecker = function eventChecker(eventName) {
    if (typeof supports[eventName] === 'boolean') {
      return supports[eventName];
    }
    var el = document.createElement(tags[eventName] || 'div');
    eventName = 'on' + eventName;
    var isSupported = (eventName in el);
    if (!isSupported) {
      el.setAttribute(eventName, 'return;');
      isSupported = typeof el[eventName] == 'function';
    }
    return supports[eventName] = isSupported;
  };
  return eventChecker;
}();
function getCtrlForEvent(gridOptionsWrapper, event, type) {
  var sourceElement = getTarget(event);
  while (sourceElement) {
    var renderedComp = gridOptionsWrapper.getDomData(sourceElement, type);
    if (renderedComp) {
      return renderedComp;
    }
    sourceElement = sourceElement.parentElement;
  }
  return null;
}
/**
 * @deprecated
 * Adds all type of change listeners to an element, intended to be a text field
 * @param {HTMLElement} element
 * @param {EventListener} listener
 */
function addChangeListener(element, listener) {
  element.addEventListener('changed', listener);
  element.addEventListener('paste', listener);
  element.addEventListener('input', listener);
  // IE doesn't fire changed for special keys (eg delete, backspace), so need to
  // listen for this further ones
  element.addEventListener('keydown', listener);
  element.addEventListener('keyup', listener);
}
/**
 * srcElement is only available in IE. In all other browsers it is target
 * http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
 * @param {Event} event
 * @returns {Element}
 */
function getTarget(event) {
  var eventNoType = event;
  return eventNoType.target || eventNoType.srcElement;
}
function isElementInEventPath(element, event) {
  if (!event || !element) {
    return false;
  }
  return getEventPath(event).indexOf(element) >= 0;
}
function createEventPath(event) {
  var res = [];
  var pointer = getTarget(event);
  while (pointer) {
    res.push(pointer);
    pointer = pointer.parentElement;
  }
  return res;
}
/**
 * firefox doesn't have event.path set, or any alternative to it, so we hack
 * it in. this is needed as it's to late to work out the path when the item is
 * removed from the dom. used by MouseEventService, where it works out if a click
 * was from the current grid, or a detail grid (master / detail).
 * @param {Event} event
 */
function addAgGridEventPath(event) {
  event.__agGridEventPath = getEventPath(event);
}
/**
 * Gets the path for an Event.
 * https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
 * https://developer.mozilla.org/en-US/docs/Web/API/Event
 * @param {Event} event
 * @returns {EventTarget[]}
 */
function getEventPath(event) {
  var eventNoType = event;
  if (eventNoType.deepPath) {
    // IE supports deep path
    return eventNoType.deepPath();
  }
  if (eventNoType.path) {
    // Chrome supports path
    return eventNoType.path;
  }
  if (eventNoType.composedPath) {
    // Firefox supports composePath
    return eventNoType.composedPath();
  }
  if (eventNoType.__agGridEventPath) {
    // Firefox supports composePath
    return eventNoType.__agGridEventPath;
  }
  // and finally, if none of the above worked,
  // we create the path ourselves
  return createEventPath(event);
}
function addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
  var isPassive = includes(PASSIVE_EVENTS, event);
  var options = isPassive ? {
    passive: true
  } : undefined;
  // this check is here for certain scenarios where I believe the user must be destroying
  // the grid somehow but continuing for it to be used
  if (frameworkOverrides && frameworkOverrides.addEventListener) {
    frameworkOverrides.addEventListener(eElement, event, listener, options);
  }
}
var EventUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  stopPropagationForAgGrid: stopPropagationForAgGrid,
  isStopPropagationForAgGrid: isStopPropagationForAgGrid,
  isEventSupported: isEventSupported,
  getCtrlForEvent: getCtrlForEvent,
  addChangeListener: addChangeListener,
  getTarget: getTarget,
  isElementInEventPath: isElementInEventPath,
  createEventPath: createEventPath,
  addAgGridEventPath: addAgGridEventPath,
  getEventPath: getEventPath,
  addSafePassiveEventListener: addSafePassiveEventListener
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$3 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BeanStub = /** @class */function () {
  function BeanStub() {
    var _this = this;
    this.destroyFunctions = [];
    this.destroyed = false;
    // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
    // prevents vue from creating proxies for created objects and prevents identity related issues
    this.__v_skip = true;
    this.isAlive = function () {
      return !_this.destroyed;
    };
  }
  // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
  // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
  // points to a bean or component that was not properly disposed of.
  // constructor() {
  //     setTimeout(()=> {
  //         if (this.isAlive()) {
  //             let prototype: any = Object.getPrototypeOf(this);
  //             const constructor: any = prototype.constructor;
  //             const constructorString = constructor.toString();
  //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
  //             console.log('is alive ' + beanName);
  //         }
  //     }, 5000);
  // }
  // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
  BeanStub.prototype.getFrameworkOverrides = function () {
    return this.frameworkOverrides;
  };
  BeanStub.prototype.getContext = function () {
    return this.context;
  };
  BeanStub.prototype.destroy = function () {
    // let prototype: any = Object.getPrototypeOf(this);
    // const constructor: any = prototype.constructor;
    // const constructorString = constructor.toString();
    // const beanName = constructorString.substring(9, constructorString.indexOf("("));
    this.destroyFunctions.forEach(function (func) {
      return func();
    });
    this.destroyFunctions.length = 0;
    this.destroyed = true;
    this.dispatchEvent({
      type: BeanStub.EVENT_DESTROYED
    });
  };
  BeanStub.prototype.addEventListener = function (eventType, listener) {
    if (!this.localEventService) {
      this.localEventService = new EventService();
    }
    this.localEventService.addEventListener(eventType, listener);
  };
  BeanStub.prototype.removeEventListener = function (eventType, listener) {
    if (this.localEventService) {
      this.localEventService.removeEventListener(eventType, listener);
    }
  };
  BeanStub.prototype.dispatchEventAsync = function (event) {
    var _this = this;
    window.setTimeout(function () {
      return _this.dispatchEvent(event);
    }, 0);
  };
  BeanStub.prototype.dispatchEvent = function (event) {
    if (this.localEventService) {
      this.localEventService.dispatchEvent(event);
    }
  };
  BeanStub.prototype.addManagedListener = function (object, event, listener) {
    var _this = this;
    if (this.destroyed) {
      return;
    }
    if (object instanceof HTMLElement) {
      addSafePassiveEventListener(this.getFrameworkOverrides(), object, event, listener);
    } else {
      object.addEventListener(event, listener);
    }
    var destroyFunc = function destroyFunc() {
      object.removeEventListener(event, listener);
      _this.destroyFunctions = _this.destroyFunctions.filter(function (fn) {
        return fn !== destroyFunc;
      });
      return null;
    };
    this.destroyFunctions.push(destroyFunc);
    return destroyFunc;
  };
  BeanStub.prototype.addDestroyFunc = function (func) {
    // if we are already destroyed, we execute the func now
    if (this.isAlive()) {
      this.destroyFunctions.push(func);
    } else {
      func();
    }
  };
  BeanStub.prototype.createManagedBean = function (bean, context) {
    var res = this.createBean(bean, context);
    this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
    return res;
  };
  BeanStub.prototype.createBean = function (bean, context, afterPreCreateCallback) {
    return (context || this.getContext()).createBean(bean, afterPreCreateCallback);
  };
  BeanStub.prototype.destroyBean = function (bean, context) {
    return (context || this.getContext()).destroyBean(bean);
  };
  BeanStub.prototype.destroyBeans = function (beans, context) {
    var _this = this;
    if (beans) {
      forEach$4(beans, function (bean) {
        return _this.destroyBean(bean, context);
      });
    }
    return [];
  };
  BeanStub.EVENT_DESTROYED = 'destroyed';
  __decorate$3([Autowired('frameworkOverrides')], BeanStub.prototype, "frameworkOverrides", void 0);
  __decorate$3([Autowired('context')], BeanStub.prototype, "context", void 0);
  __decorate$3([Autowired('eventService')], BeanStub.prototype, "eventService", void 0);
  __decorate$3([Autowired('gridOptionsWrapper')], BeanStub.prototype, "gridOptionsWrapper", void 0);
  __decorate$3([PreDestroy], BeanStub.prototype, "destroy", null);
  return BeanStub;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1 = undefined && undefined.__extends || function () {
  var _extendStatics2 = function extendStatics(d, b) {
    _extendStatics2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics2(d, b);
  };
  return function (d, b) {
    _extendStatics2(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$1 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
// takes ColDefs and ColGroupDefs and turns them into Columns and OriginalGroups
var ColumnFactory = /** @class */function (_super) {
  __extends$1(ColumnFactory, _super);
  function ColumnFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnFactory.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('ColumnFactory');
  };
  ColumnFactory.prototype.createColumnTree = function (defs, primaryColumns, existingTree) {
    // column key creator dishes out unique column id's in a deterministic way,
    // so if we have two grids (that could be master/slave) with same column definitions,
    // then this ensures the two grids use identical id's.
    var columnKeyCreator = new ColumnKeyCreator();
    var _a = this.extractExistingTreeData(existingTree),
      existingCols = _a.existingCols,
      existingGroups = _a.existingGroups,
      existingColKeys = _a.existingColKeys;
    columnKeyCreator.addExistingKeys(existingColKeys);
    // create am unbalanced tree that maps the provided definitions
    var unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups);
    var treeDept = this.findMaxDept(unbalancedTree, 0);
    this.logger.log('Number of levels for grouped columns is ' + treeDept);
    var columnTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
    var deptFirstCallback = function deptFirstCallback(child, parent) {
      if (child instanceof ProvidedColumnGroup) {
        child.setupExpandable();
      }
      // we set the original parents at the end, rather than when we go along, as balancing the tree
      // adds extra levels into the tree. so we can only set parents when balancing is done.
      child.setOriginalParent(parent);
    };
    this.columnUtils.depthFirstOriginalTreeSearch(null, columnTree, deptFirstCallback);
    return {
      columnTree: columnTree,
      treeDept: treeDept
    };
  };
  ColumnFactory.prototype.extractExistingTreeData = function (existingTree) {
    var existingCols = [];
    var existingGroups = [];
    var existingColKeys = [];
    if (existingTree) {
      this.columnUtils.depthFirstOriginalTreeSearch(null, existingTree, function (item) {
        if (item instanceof ProvidedColumnGroup) {
          var group = item;
          existingGroups.push(group);
        } else {
          var col = item;
          existingColKeys.push(col.getId());
          existingCols.push(col);
        }
      });
    }
    return {
      existingCols: existingCols,
      existingGroups: existingGroups,
      existingColKeys: existingColKeys
    };
  };
  ColumnFactory.prototype.createForAutoGroups = function (autoGroupCols, gridBalancedTree) {
    var _this = this;
    var autoColBalancedTree = [];
    autoGroupCols.forEach(function (col) {
      var fakeTreeItem = _this.createAutoGroupTreeItem(gridBalancedTree, col);
      autoColBalancedTree.push(fakeTreeItem);
    });
    return autoColBalancedTree;
  };
  ColumnFactory.prototype.createAutoGroupTreeItem = function (balancedColumnTree, column) {
    var dept = this.findDepth(balancedColumnTree);
    // at the end, this will be the top of the tree item.
    var nextChild = column;
    for (var i = dept - 1; i >= 0; i--) {
      var autoGroup = new ProvidedColumnGroup(null, "FAKE_PATH_" + column.getId() + "}_" + i, true, i);
      this.context.createBean(autoGroup);
      autoGroup.setChildren([nextChild]);
      nextChild.setOriginalParent(autoGroup);
      nextChild = autoGroup;
    }
    // at this point, the nextChild is the top most item in the tree
    return nextChild;
  };
  ColumnFactory.prototype.findDepth = function (balancedColumnTree) {
    var dept = 0;
    var pointer = balancedColumnTree;
    while (pointer && pointer[0] && pointer[0] instanceof ProvidedColumnGroup) {
      dept++;
      pointer = pointer[0].getChildren();
    }
    return dept;
  };
  ColumnFactory.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
    var result = [];
    // go through each child, for groups, recurse a level deeper,
    // for columns we need to pad
    for (var i = 0; i < unbalancedTree.length; i++) {
      var child = unbalancedTree[i];
      if (child instanceof ProvidedColumnGroup) {
        // child is a group, all we do is go to the next level of recursion
        var originalGroup = child;
        var newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
        originalGroup.setChildren(newChildren);
        result.push(originalGroup);
      } else {
        // child is a column - so here we add in the padded column groups if needed
        var firstPaddedGroup = void 0;
        var currentPaddedGroup = void 0;
        // this for loop will NOT run any loops if no padded column groups are needed
        for (var j = columnDept - 1; j >= currentDept; j--) {
          var newColId = columnKeyCreator.getUniqueKey(null, null);
          var colGroupDefMerged = this.createMergedColGroupDef(null);
          var paddedGroup = new ProvidedColumnGroup(colGroupDefMerged, newColId, true, currentDept);
          this.context.createBean(paddedGroup);
          if (currentPaddedGroup) {
            currentPaddedGroup.setChildren([paddedGroup]);
          }
          currentPaddedGroup = paddedGroup;
          if (!firstPaddedGroup) {
            firstPaddedGroup = currentPaddedGroup;
          }
        }
        // likewise this if statement will not run if no padded groups
        if (firstPaddedGroup && currentPaddedGroup) {
          result.push(firstPaddedGroup);
          var hasGroups = unbalancedTree.some(function (leaf) {
            return leaf instanceof ProvidedColumnGroup;
          });
          if (hasGroups) {
            currentPaddedGroup.setChildren([child]);
            continue;
          } else {
            currentPaddedGroup.setChildren(unbalancedTree);
            break;
          }
        }
        result.push(child);
      }
    }
    return result;
  };
  ColumnFactory.prototype.findMaxDept = function (treeChildren, dept) {
    var maxDeptThisLevel = dept;
    for (var i = 0; i < treeChildren.length; i++) {
      var abstractColumn = treeChildren[i];
      if (abstractColumn instanceof ProvidedColumnGroup) {
        var originalGroup = abstractColumn;
        var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
        if (maxDeptThisLevel < newDept) {
          maxDeptThisLevel = newDept;
        }
      }
    }
    return maxDeptThisLevel;
  };
  ColumnFactory.prototype.recursivelyCreateColumns = function (defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups) {
    var _this = this;
    var result = [];
    if (!defs) {
      return result;
    }
    defs.forEach(function (def) {
      var newGroupOrColumn;
      if (_this.isColumnGroup(def)) {
        newGroupOrColumn = _this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups);
      } else {
        newGroupOrColumn = _this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator);
      }
      result.push(newGroupOrColumn);
    });
    return result;
  };
  ColumnFactory.prototype.createColumnGroup = function (primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups) {
    var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
    var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId || null, null);
    var originalGroup = new ProvidedColumnGroup(colGroupDefMerged, groupId, false, level);
    this.context.createBean(originalGroup);
    var existingGroup = this.findExistingGroup(colGroupDef, existingGroups);
    if (existingGroup && existingGroup.isExpanded()) {
      originalGroup.setExpanded(true);
    }
    var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups);
    originalGroup.setChildren(children);
    return originalGroup;
  };
  ColumnFactory.prototype.createMergedColGroupDef = function (colGroupDef) {
    var colGroupDefMerged = {};
    assign$3(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
    assign$3(colGroupDefMerged, colGroupDef);
    this.checkForDeprecatedItems(colGroupDefMerged);
    return colGroupDefMerged;
  };
  ColumnFactory.prototype.createColumn = function (primaryColumns, colDef, existingColsCopy, columnKeyCreator) {
    var colDefMerged = this.mergeColDefs(colDef);
    this.checkForDeprecatedItems(colDefMerged);
    // see if column already exists
    var column = this.findExistingColumn(colDef, existingColsCopy);
    if (!column) {
      // no existing column, need to create one
      var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
      column = new Column(colDefMerged, colDef, colId, primaryColumns);
      this.context.createBean(column);
    } else {
      column.setColDef(colDefMerged, colDef);
      this.applyColumnState(column, colDefMerged);
    }
    return column;
  };
  ColumnFactory.prototype.applyColumnState = function (column, colDef) {
    // flex
    var flex = attrToNumber(colDef.flex);
    if (flex !== undefined) {
      column.setFlex(flex);
    }
    // width - we only set width if column is not flexing
    var noFlexThisCol = column.getFlex() <= 0;
    if (noFlexThisCol) {
      // both null and undefined means we skip, as it's not possible to 'clear' width (a column must have a width)
      var width = attrToNumber(colDef.width);
      if (width != null) {
        column.setActualWidth(width);
      } else {
        // otherwise set the width again, in case min or max width has changed,
        // and width needs to be adjusted.
        var widthBeforeUpdate = column.getActualWidth();
        column.setActualWidth(widthBeforeUpdate);
      }
    }
    // sort - anything but undefined will set sort, thus null or empty string will clear the sort
    if (colDef.sort !== undefined) {
      if (colDef.sort == Constants.SORT_ASC || colDef.sort == Constants.SORT_DESC) {
        column.setSort(colDef.sort);
      } else {
        column.setSort(undefined);
      }
    }
    // sorted at - anything but undefined, thus null will clear the sortIndex
    var sortIndex = attrToNumber(colDef.sortIndex);
    if (sortIndex !== undefined) {
      column.setSortIndex(sortIndex);
    }
    // hide - anything but undefined, thus null will clear the hide
    var hide = attrToBoolean(colDef.hide);
    if (hide !== undefined) {
      column.setVisible(!hide);
    }
    // pinned - anything but undefined, thus null or empty string will remove pinned
    if (colDef.pinned !== undefined) {
      column.setPinned(colDef.pinned);
    }
  };
  ColumnFactory.prototype.findExistingColumn = function (newColDef, existingColsCopy) {
    var res = find$3(existingColsCopy, function (existingCol) {
      var existingColDef = existingCol.getUserProvidedColDef();
      if (!existingColDef) {
        return false;
      }
      var newHasId = newColDef.colId != null;
      var newHasField = newColDef.field != null;
      if (newHasId) {
        return existingCol.getId() === newColDef.colId;
      }
      if (newHasField) {
        return existingColDef.field === newColDef.field;
      }
      // if no id or field present, then try object equivalence.
      if (existingColDef === newColDef) {
        return true;
      }
      return false;
    });
    // make sure we remove, so if user provided duplicate id, then we don't have more than
    // one column instance for colDef with common id
    if (existingColsCopy && res) {
      removeFromArray(existingColsCopy, res);
    }
    return res;
  };
  ColumnFactory.prototype.findExistingGroup = function (newGroupDef, existingGroups) {
    var res = find$3(existingGroups, function (existingGroup) {
      var existingDef = existingGroup.getColGroupDef();
      if (!existingDef) {
        return false;
      }
      var newHasId = newGroupDef.groupId != null;
      if (newHasId) {
        return existingGroup.getId() === newGroupDef.groupId;
      }
      return false;
    });
    // make sure we remove, so if user provided duplicate id, then we don't have more than
    // one column instance for colDef with common id
    if (res) {
      removeFromArray(existingGroups, res);
    }
    return res;
  };
  ColumnFactory.prototype.mergeColDefs = function (colDef) {
    // start with empty merged definition
    var colDefMerged = {};
    // merge properties from default column definitions
    var defaultColDef = this.gridOptionsWrapper.getDefaultColDef();
    mergeDeep(colDefMerged, defaultColDef, false, true);
    // merge properties from column type properties
    var columnType = colDef.type;
    if (!columnType) {
      columnType = defaultColDef && defaultColDef.type;
    }
    // if type of both colDef and defaultColDef, then colDef gets preference
    if (columnType) {
      this.assignColumnTypes(columnType, colDefMerged);
    }
    // merge properties from column definitions
    mergeDeep(colDefMerged, colDef, false, true);
    return colDefMerged;
  };
  ColumnFactory.prototype.assignColumnTypes = function (type, colDefMerged) {
    var typeKeys = [];
    if (type instanceof Array) {
      var invalidArray = type.some(function (a) {
        return typeof a !== 'string';
      });
      if (invalidArray) {
        console.warn("ag-grid: if colDef.type is supplied an array it should be of type 'string[]'");
      } else {
        typeKeys = type;
      }
    } else if (typeof type === 'string') {
      typeKeys = type.split(',');
    } else {
      console.warn("ag-grid: colDef.type should be of type 'string' | 'string[]'");
      return;
    }
    // merge user defined with default column types
    var allColumnTypes = assign$3({}, DefaultColumnTypes);
    var userTypes = this.gridOptionsWrapper.getColumnTypes() || {};
    iterateObject(userTypes, function (key, value) {
      if (key in allColumnTypes) {
        console.warn("AG Grid: the column type '" + key + "' is a default column type and cannot be overridden.");
      } else {
        allColumnTypes[key] = value;
      }
    });
    typeKeys.forEach(function (t) {
      var typeColDef = allColumnTypes[t.trim()];
      if (typeColDef) {
        mergeDeep(colDefMerged, typeColDef, false, true);
      } else {
        console.warn("ag-grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
      }
    });
  };
  ColumnFactory.prototype.checkForDeprecatedItems = function (colDef) {
    if (colDef) {
      var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
      if (colDefNoType.group !== undefined) {
        console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
      }
      if (colDefNoType.headerGroup !== undefined) {
        console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
      }
      if (colDefNoType.headerGroupShow !== undefined) {
        console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
      }
      if (colDefNoType.suppressRowGroup !== undefined) {
        console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
      }
      if (colDefNoType.suppressAggregation !== undefined) {
        console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
      }
      if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
        console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
      }
      if (colDefNoType.displayName) {
        console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
        colDefNoType.headerName = colDefNoType.displayName;
      }
    }
  };
  // if object has children, we assume it's a group
  ColumnFactory.prototype.isColumnGroup = function (abstractColDef) {
    return abstractColDef.children !== undefined;
  };
  __decorate$4([Autowired('columnUtils')], ColumnFactory.prototype, "columnUtils", void 0);
  __decorate$4([__param$1(0, Qualifier('loggerFactory'))], ColumnFactory.prototype, "setBeans", null);
  ColumnFactory = __decorate$4([Bean('columnFactory')], ColumnFactory);
  return ColumnFactory;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var Events = /** @class */function () {
  function Events() {}
  /** Everything has changed with the columns. Either complete new set of columns set, or user called setState() */
  /** @deprecated - grid no longer uses this, and setSate() also fires individual events */
  Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
  /** User has set in new columns. */
  Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
  /** The pivot mode flag was changed */
  Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
  /** A row group column was added, removed or order changed. */
  Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
  /** expandAll / collapseAll was called from the api. */
  Events.EVENT_EXPAND_COLLAPSE_ALL = 'expandOrCollapseAll';
  /** A pivot column was added, removed or order changed. */
  Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
  /** The list of grid columns has changed. */
  Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
  /** A value column was added, removed or agg function was changed. */
  Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
  /** A column was moved */
  Events.EVENT_COLUMN_MOVED = 'columnMoved';
  /** One or more columns was shown / hidden */
  Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
  /** One or more columns was pinned / unpinned*/
  Events.EVENT_COLUMN_PINNED = 'columnPinned';
  /** A column group was opened / closed */
  Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
  /** One or more columns was resized. If just one, the column in the event is set. */
  Events.EVENT_COLUMN_RESIZED = 'columnResized';
  /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
  Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
  /** The list of virtual columns has changed, results from viewport changing */
  Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
  /** Async Transactions Executed */
  Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED = 'asyncTransactionsFlushed';
  /** A row group was opened / closed */
  Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
  /** The client has set new data into the grid */
  Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
  /** The client has updated data for the grid */
  Events.EVENT_ROW_DATA_UPDATED = 'rowDataUpdated';
  /** The client has set new floating data into the grid */
  Events.EVENT_PINNED_ROW_DATA_CHANGED = 'pinnedRowDataChanged';
  /** Range selection has changed */
  Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
  /** Chart was created */
  Events.EVENT_CHART_CREATED = 'chartCreated';
  /** Chart Range selection has changed */
  Events.EVENT_CHART_RANGE_SELECTION_CHANGED = 'chartRangeSelectionChanged';
  /** Chart Options have changed */
  Events.EVENT_CHART_OPTIONS_CHANGED = 'chartOptionsChanged';
  /** Chart was destroyed */
  Events.EVENT_CHART_DESTROYED = 'chartDestroyed';
  /** For when the tool panel is shown / hidden */
  Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = 'toolPanelVisibleChanged';
  Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START = 'columnPanelItemDragStart';
  Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END = 'columnPanelItemDragEnd';
  /** Model was updated - grid updates the drawn rows when this happens */
  Events.EVENT_MODEL_UPDATED = 'modelUpdated';
  Events.EVENT_PASTE_START = 'pasteStart';
  Events.EVENT_PASTE_END = 'pasteEnd';
  Events.EVENT_FILL_START = 'fillStart';
  Events.EVENT_FILL_END = 'fillEnd';
  Events.EVENT_CELL_CLICKED = 'cellClicked';
  Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
  Events.EVENT_CELL_MOUSE_DOWN = 'cellMouseDown';
  Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
  Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
  Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
  Events.EVENT_CELL_FOCUSED = 'cellFocused';
  Events.EVENT_ROW_SELECTED = 'rowSelected';
  Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
  Events.EVENT_CELL_KEY_DOWN = 'cellKeyDown';
  Events.EVENT_CELL_KEY_PRESS = 'cellKeyPress';
  Events.EVENT_CELL_MOUSE_OVER = 'cellMouseOver';
  Events.EVENT_CELL_MOUSE_OUT = 'cellMouseOut';
  /** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */
  Events.EVENT_FILTER_CHANGED = 'filterChanged';
  /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
  Events.EVENT_FILTER_MODIFIED = 'filterModified';
  Events.EVENT_FILTER_OPENED = 'filterOpened';
  Events.EVENT_SORT_CHANGED = 'sortChanged';
  /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
  Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
  Events.EVENT_ROW_CLICKED = 'rowClicked';
  Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
  /** Gets called once after the grid has finished initialising. */
  Events.EVENT_GRID_READY = 'gridReady';
  /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
   * changed, so always filling the space it was given. */
  Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
  /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
  Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
  /* The width of the scrollbar has been calculated */
  Events.EVENT_SCROLLBAR_WIDTH_CHANGED = 'scrollbarWidthChanged';
  /** Rows were rendered for the first time (ie on async data load). */
  Events.EVENT_FIRST_DATA_RENDERED = 'firstDataRendered';
  /** A column drag has started, either resizing a column or moving a column. */
  Events.EVENT_DRAG_STARTED = 'dragStarted';
  /** A column drag has stopped */
  Events.EVENT_DRAG_STOPPED = 'dragStopped';
  Events.EVENT_CHECKBOX_CHANGED = 'checkboxChanged';
  Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
  Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
  Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
  Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
  /** Main body of grid has scrolled, either horizontally or vertically */
  Events.EVENT_BODY_SCROLL = 'bodyScroll';
  /** Main body of the grid has stopped scrolling, either horizontally or vertically */
  Events.EVENT_BODY_SCROLL_END = 'bodyScrollEnd';
  Events.EVENT_HEIGHT_SCALE_CHANGED = 'heightScaleChanged';
  /** The displayed page for pagination has changed. For example the data was filtered or sorted,
   * or the user has moved to a different page. */
  Events.EVENT_PAGINATION_CHANGED = 'paginationChanged';
  /** Only used by React, Angular 2+, Web Components and VueJS AG Grid components
   * (not used if doing plain JavaScript or Angular 1.x). If the grid receives changes due
   * to bound properties, this event fires after the grid has finished processing the change. */
  Events.EVENT_COMPONENT_STATE_CHANGED = 'componentStateChanged';
  /*****************************  INTERNAL EVENTS: START ******************************************* */
  /** Please remember to add to ComponentUtil.EXCLUDED_INTERNAL_EVENTS to not have these events exposed to framework components. */
  /** All items from here down are used internally by the grid, not intended for external use. */
  // not documented, either experimental, or we just don't want users using an depending on them
  Events.EVENT_BODY_HEIGHT_CHANGED = 'bodyHeightChanged';
  Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
  Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
  Events.EVENT_COLUMN_HOVER_CHANGED = 'columnHoverChanged';
  Events.EVENT_FLASH_CELLS = 'flashCells';
  Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = 'paginationPixelOffsetChanged';
  Events.EVENT_DISPLAYED_ROWS_CHANGED = 'displayedRowsChanged';
  Events.EVENT_LEFT_PINNED_WIDTH_CHANGED = 'leftPinnedWidthChanged';
  Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED = 'rightPinnedWidthChanged';
  Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = 'rowContainerHeightChanged';
  Events.EVENT_ROW_DRAG_ENTER = 'rowDragEnter';
  Events.EVENT_ROW_DRAG_MOVE = 'rowDragMove';
  Events.EVENT_ROW_DRAG_LEAVE = 'rowDragLeave';
  Events.EVENT_ROW_DRAG_END = 'rowDragEnd';
  // primarily for charts
  Events.EVENT_POPUP_TO_FRONT = 'popupToFront';
  // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
  // to design these better around server side functions and then release to general public when fully working with
  // all the row models.
  Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
  Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
  Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
  Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
  Events.EVENT_KEYBOARD_FOCUS = 'keyboardFocus';
  Events.EVENT_MOUSE_FOCUS = 'mouseFocus';
  Events.EVENT_STORE_UPDATED = 'storeUpdated';
  return Events;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// class returns unique instance id's for columns.
// eg, the following calls (in this order) will result in:
//
// getInstanceIdForKey('country') => 0
// getInstanceIdForKey('country') => 1
// getInstanceIdForKey('country') => 2
// getInstanceIdForKey('country') => 3
// getInstanceIdForKey('age') => 0
// getInstanceIdForKey('age') => 1
// getInstanceIdForKey('country') => 4
var GroupInstanceIdCreator = /** @class */function () {
  function GroupInstanceIdCreator() {
    // this map contains keys to numbers, so we remember what the last call was
    this.existingIds = {};
  }
  GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
    var lastResult = this.existingIds[key];
    var result;
    if (typeof lastResult !== 'number') {
      // first time this key
      result = 0;
    } else {
      result = lastResult + 1;
    }
    this.existingIds[key] = result;
    return result;
  };
  return GroupInstanceIdCreator;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var reUnescapedHtml = /[&<>"']/g;
/**
 * HTML Escapes.
 */
var HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
/**
 * It encodes any string in UTF-8 format
 * taken from https://github.com/mathiasbynens/utf8.js
 * @param {string} s
 * @returns {string}
 */
function utf8_encode(s) {
  var stringFromCharCode = String.fromCharCode;
  function ucs2decode(string) {
    var output = [];
    if (!string) {
      return [];
    }
    var len = string.length;
    var counter = 0;
    var value;
    var extra;
    while (counter < len) {
      value = string.charCodeAt(counter++);
      if (value >= 0xD800 && value <= 0xDBFF && counter < len) {
        // high surrogate, and there is a next character
        extra = string.charCodeAt(counter++);
        if ((extra & 0xFC00) == 0xDC00) {
          // low surrogate
          output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          // unmatched surrogate; only append this code unit, in case the next
          // code unit is the high surrogate of a surrogate pair
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }
    return output;
  }
  function checkScalarValue(point) {
    if (point >= 0xD800 && point <= 0xDFFF) {
      throw Error('Lone surrogate U+' + point.toString(16).toUpperCase() + ' is not a scalar value');
    }
  }
  function createByte(point, shift) {
    return stringFromCharCode(point >> shift & 0x3F | 0x80);
  }
  function encodeCodePoint(point) {
    if (point >= 0 && point <= 31 && point !== 10) {
      var convertedCode = point.toString(16).toUpperCase();
      var paddedCode = padStart(convertedCode, 4, '0');
      return "_x" + paddedCode + "_";
    }
    if ((point & 0xFFFFFF80) == 0) {
      // 1-byte sequence
      return stringFromCharCode(point);
    }
    var symbol = '';
    if ((point & 0xFFFFF800) == 0) {
      // 2-byte sequence
      symbol = stringFromCharCode(point >> 6 & 0x1F | 0xC0);
    } else if ((point & 0xFFFF0000) == 0) {
      // 3-byte sequence
      checkScalarValue(point);
      symbol = stringFromCharCode(point >> 12 & 0x0F | 0xE0);
      symbol += createByte(point, 6);
    } else if ((point & 0xFFE00000) == 0) {
      // 4-byte sequence
      symbol = stringFromCharCode(point >> 18 & 0x07 | 0xF0);
      symbol += createByte(point, 12);
      symbol += createByte(point, 6);
    }
    symbol += stringFromCharCode(point & 0x3F | 0x80);
    return symbol;
  }
  var codePoints = ucs2decode(s);
  var length = codePoints.length;
  var index = -1;
  var codePoint;
  var byteString = '';
  while (++index < length) {
    codePoint = codePoints[index];
    byteString += encodeCodePoint(codePoint);
  }
  return byteString;
}
/**
 * @param str The string to be repeated
 * @param len The size of the output string
 * @returns A string with size len created from repeated `str`.
 */
function stringRepeat(str, len) {
  len = Math.floor(len);
  if (str.length === 0 || len === 0) {
    return '';
  }
  var maxCount = str.length * len;
  len = Math.floor(Math.log(len) / Math.log(2));
  while (len) {
    str += str;
    len--;
  }
  str += str.substring(0, maxCount - str.length);
  return str;
}
/**
 * @param str The string to be padded
 * @param totalLength The final length needed
 * @param padStr The string to generate the padding
 * @returns The padded string
 */
function padStart(str, totalLength, padStr) {
  if (str.length > totalLength) {
    return str;
  }
  totalLength -= str.length;
  if (totalLength > padStr.length) {
    padStr += stringRepeat(padStr, totalLength / padStr.length);
  }
  return padStr.slice(0, totalLength) + str;
}
/**
 * Converts a camelCase string into hyphenated string
 * from https://gist.github.com/youssman/745578062609e8acac9f
 * @param {string} str
 * @return {string}
 */
function camelCaseToHyphen(str) {
  if (str === null || str === undefined) {
    return null;
  }
  return str.replace(/([A-Z])/g, function (g) {
    return '-' + g[0].toLowerCase();
  });
}
/**
 * Converts a hyphenated string into camelCase string
 * from https://stackoverflow.com/questions/6660977/convert-hyphens-to-camel-case-camelcase
 * @param {string} str
 * @return {string}
 */
function hyphenToCamelCase(str) {
  if (str === null || str === undefined) {
    return null;
  }
  return str.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}
function capitalise(str) {
  return str[0].toUpperCase() + str.substr(1).toLowerCase();
}
function escapeString(toEscape) {
  // we call toString() twice, in case value is an object, where user provides
  // a toString() method, and first call to toString() returns back something other
  // than a string (eg a number to render)
  return toEscape == null ? null : toEscape.toString().toString().replace(reUnescapedHtml, function (chr) {
    return HTML_ESCAPES[chr];
  });
}
/**
 * Converts a camelCase string into regular text
 * from: https://stackoverflow.com/questions/15369566/putting-space-in-camel-case-string-using-regular-expression
 * @param {string} camelCase
 * @return {string}
 */
function camelCaseToHumanText(camelCase) {
  if (!camelCase || camelCase == null) {
    return null;
  }
  var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
  var words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
  return words.map(function (word) {
    return word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : '');
  }).join(' ');
}
function startsWith(str, matchStart) {
  if (str === matchStart) {
    return true;
  }
  return str != null && str.slice(0, matchStart.length) === matchStart;
}
var StringUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  utf8_encode: utf8_encode,
  stringRepeat: stringRepeat,
  padStart: padStart,
  camelCaseToHyphen: camelCaseToHyphen,
  hyphenToCamelCase: hyphenToCamelCase,
  capitalise: capitalise,
  escapeString: escapeString,
  camelCaseToHumanText: camelCaseToHumanText,
  startsWith: startsWith
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function convertToMap(arr) {
  var map = new Map();
  arr.forEach(function (pair) {
    return map.set(pair[0], pair[1]);
  });
  return map;
}
// handy for organising a list into a map, where each item is mapped by an attribute, eg mapping Columns by ID
function mapById(arr, callback) {
  var map = new Map();
  arr.forEach(function (item) {
    return map.set(callback(item), item);
  });
  return map;
}
function keys$7(map) {
  var arr = [];
  map.forEach(function (_, key) {
    return arr.push(key);
  });
  return arr;
}
var MapUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertToMap: convertToMap,
  mapById: mapById,
  keys: keys$7
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2 = undefined && undefined.__extends || function () {
  var _extendStatics3 = function extendStatics(d, b) {
    _extendStatics3 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics3(d, b);
  };
  return function (d, b) {
    _extendStatics3(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$5 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$2 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var __spreadArrays$1 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ColumnModel = /** @class */function (_super) {
  __extends$2(ColumnModel, _super);
  function ColumnModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // header row count, based on user provided columns
    _this.primaryHeaderRowCount = 0;
    _this.secondaryHeaderRowCount = 0;
    _this.secondaryColumnsPresent = false;
    // header row count, either above, or based on pivoting if we are pivoting
    _this.gridHeaderRowCount = 0;
    // leave level columns of the displayed trees
    _this.displayedColumnsLeft = [];
    _this.displayedColumnsRight = [];
    _this.displayedColumnsCenter = [];
    // all three lists above combined
    _this.displayedColumns = [];
    // for fast lookup, to see if a column or group is still displayed
    _this.displayedColumnsAndGroupsMap = {};
    // all columns to be rendered
    _this.viewportColumns = [];
    // all columns to be rendered in the centre
    _this.viewportColumnsCenter = [];
    _this.autoHeightActiveAtLeastOnce = false;
    _this.rowGroupColumns = [];
    _this.valueColumns = [];
    _this.pivotColumns = [];
    _this.ready = false;
    _this.autoGroupsNeedBuilding = false;
    _this.forceRecreateAutoGroups = false;
    _this.pivotMode = false;
    _this.bodyWidth = 0;
    _this.leftWidth = 0;
    _this.rightWidth = 0;
    _this.bodyWidthDirty = true;
    _this.colDefVersion = 0;
    _this.flexColsCalculatedAtLestOnce = false;
    return _this;
  }
  ColumnModel.prototype.init = function () {
    this.suppressColumnVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation();
    var pivotMode = this.gridOptionsWrapper.isPivotMode();
    if (this.isPivotSettingAllowed(pivotMode)) {
      this.pivotMode = pivotMode;
    }
    this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    this.addManagedListener(this.gridOptionsWrapper, 'autoGroupColumnDef', this.onAutoGroupColumnDefChanged.bind(this));
  };
  ColumnModel.prototype.onAutoGroupColumnDefChanged = function () {
    this.autoGroupsNeedBuilding = true;
    this.forceRecreateAutoGroups = true;
    this.updateGridColumns();
    this.updateDisplayedColumns('gridOptionsChanged');
  };
  ColumnModel.prototype.getColDefVersion = function () {
    return this.colDefVersion;
  };
  ColumnModel.prototype.setColumnDefs = function (columnDefs, source) {
    var _this = this;
    if (source === void 0) {
      source = 'api';
    }
    var colsPreviouslyExisted = !!this.columnDefs;
    this.colDefVersion++;
    var raiseEventsFunc = this.compareColumnStatesAndRaiseEvents(source);
    this.columnDefs = columnDefs;
    // always invalidate cache on changing columns, as the column id's for the new columns
    // could overlap with the old id's, so the cache would return old values for new columns.
    this.valueCache.expire();
    // NOTE ==================
    // we should be destroying the existing columns and groups if they exist, for example, the original column
    // group adds a listener to the columns, it should be also removing the listeners
    this.autoGroupsNeedBuilding = true;
    var oldPrimaryColumns = this.primaryColumns;
    var oldPrimaryTree = this.primaryColumnTree;
    var balancedTreeResult = this.columnFactory.createColumnTree(columnDefs, true, oldPrimaryTree);
    this.primaryColumnTree = balancedTreeResult.columnTree;
    this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
    this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
    this.primaryColumnsMap = {};
    this.primaryColumns.forEach(function (col) {
      return _this.primaryColumnsMap[col.getId()] = col;
    });
    this.extractRowGroupColumns(source, oldPrimaryColumns);
    this.extractPivotColumns(source, oldPrimaryColumns);
    this.extractValueColumns(source, oldPrimaryColumns);
    this.ready = true;
    this.updateGridColumns();
    if (colsPreviouslyExisted && this.gridColsArePrimary && !this.gridOptionsWrapper.isMaintainColumnOrder()) {
      this.orderGridColumnsLikePrimary();
    }
    this.updateDisplayedColumns(source);
    this.checkViewportColumns();
    // this event is not used by AG Grid, but left here for backwards compatibility,
    // in case applications use it
    this.dispatchEverythingChanged(source);
    raiseEventsFunc();
    this.dispatchNewColumnsLoaded();
  };
  ColumnModel.prototype.dispatchNewColumnsLoaded = function () {
    var newColumnsLoadedEvent = {
      type: Events.EVENT_NEW_COLUMNS_LOADED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(newColumnsLoadedEvent);
  };
  // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded
  ColumnModel.prototype.dispatchEverythingChanged = function (source) {
    if (source === void 0) {
      source = 'api';
    }
    var eventEverythingChanged = {
      type: Events.EVENT_COLUMN_EVERYTHING_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(eventEverythingChanged);
  };
  ColumnModel.prototype.orderGridColumnsLikePrimary = function () {
    var _this = this;
    var primaryColumns = this.primaryColumns;
    if (!primaryColumns) {
      return;
    }
    this.gridColumns.sort(function (colA, colB) {
      var primaryIndexA = primaryColumns.indexOf(colA);
      var primaryIndexB = primaryColumns.indexOf(colB);
      // if both cols are present in primary, then we just return the position,
      // so position is maintained.
      var indexAPresent = primaryIndexA >= 0;
      var indexBPresent = primaryIndexB >= 0;
      if (indexAPresent && indexBPresent) {
        return primaryIndexA - primaryIndexB;
      }
      if (indexAPresent) {
        // B is auto group column, so put B first
        return 1;
      }
      if (indexBPresent) {
        // A is auto group column, so put A first
        return -1;
      }
      // otherwise both A and B are auto-group columns. so we just keep the order
      // as they were already in.
      var gridIndexA = _this.gridColumns.indexOf(colA);
      var gridIndexB = _this.gridColumns.indexOf(colB);
      return gridIndexA - gridIndexB;
    });
  };
  ColumnModel.prototype.getAllDisplayedAutoHeightCols = function () {
    return this.displayedAutoHeightCols;
  };
  ColumnModel.prototype.setViewport = function () {
    if (this.gridOptionsWrapper.isEnableRtl()) {
      this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
      this.viewportRight = this.bodyWidth - this.scrollPosition;
    } else {
      this.viewportLeft = this.scrollPosition;
      this.viewportRight = this.scrollWidth + this.scrollPosition;
    }
  };
  // used by clipboard service, to know what columns to paste into
  ColumnModel.prototype.getDisplayedColumnsStartingAt = function (column) {
    var currentColumn = column;
    var columns = [];
    while (currentColumn != null) {
      columns.push(currentColumn);
      currentColumn = this.getDisplayedColAfter(currentColumn);
    }
    return columns;
  };
  // checks what columns are currently displayed due to column virtualisation. fires an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  ColumnModel.prototype.checkViewportColumns = function () {
    // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
    if (this.displayedColumnsCenter == null) {
      return;
    }
    var hashBefore = this.viewportColumns.map(function (column) {
      return column.getId();
    }).join('#');
    this.extractViewport();
    var hashAfter = this.viewportColumns.map(function (column) {
      return column.getId();
    }).join('#');
    if (hashBefore !== hashAfter) {
      var event_1 = {
        type: Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  ColumnModel.prototype.setViewportPosition = function (scrollWidth, scrollPosition) {
    if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
      this.scrollWidth = scrollWidth;
      this.scrollPosition = scrollPosition;
      // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
      // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
      // virtual columns again
      this.bodyWidthDirty = true;
      this.setViewport();
      if (this.ready) {
        this.checkViewportColumns();
      }
    }
  };
  ColumnModel.prototype.isPivotMode = function () {
    return this.pivotMode;
  };
  ColumnModel.prototype.isPivotSettingAllowed = function (pivot) {
    if (pivot && this.gridOptionsWrapper.isTreeData()) {
      console.warn("AG Grid: Pivot mode not available in conjunction Tree Data i.e. 'gridOptions.treeData: true'");
      return false;
    }
    return true;
  };
  ColumnModel.prototype.setPivotMode = function (pivotMode, source) {
    if (source === void 0) {
      source = 'api';
    }
    if (pivotMode === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) {
      return;
    }
    this.pivotMode = pivotMode;
    // we need to update grid columns to cover the scenario where user has groupSuppressAutoColumn=true, as
    // this means we don't use auto group column UNLESS we are in pivot mode (it's mandatory in pivot mode),
    // so need to updateGridColumn() to check it autoGroupCol needs to be added / removed
    this.autoGroupsNeedBuilding = true;
    this.updateGridColumns();
    this.updateDisplayedColumns(source);
    var event = {
      type: Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
    if (!this.secondaryColumnsPresent || !this.secondaryColumns) {
      return null;
    }
    var valueColumnToFind = this.getPrimaryColumn(valueColKey);
    var foundColumn = null;
    this.secondaryColumns.forEach(function (column) {
      var thisPivotKeys = column.getColDef().pivotKeys;
      var pivotValueColumn = column.getColDef().pivotValueColumn;
      var pivotKeyMatches = areEqual(thisPivotKeys, pivotKeys);
      var pivotValueMatches = pivotValueColumn === valueColumnToFind;
      if (pivotKeyMatches && pivotValueMatches) {
        foundColumn = column;
      }
    });
    return foundColumn;
  };
  ColumnModel.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('columnModel');
  };
  ColumnModel.prototype.setFirstRightAndLastLeftPinned = function (source) {
    var lastLeft;
    var firstRight;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      lastLeft = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null;
      firstRight = this.displayedColumnsRight ? last(this.displayedColumnsRight) : null;
    } else {
      lastLeft = this.displayedColumnsLeft ? last(this.displayedColumnsLeft) : null;
      firstRight = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null;
    }
    this.gridColumns.forEach(function (column) {
      column.setLastLeftPinned(column === lastLeft, source);
      column.setFirstRightPinned(column === firstRight, source);
    });
  };
  ColumnModel.prototype.autoSizeColumns = function (keys, skipHeader, source) {
    // because of column virtualisation, we can only do this function on columns that are
    // actually rendered, as non-rendered columns (outside the viewport and not rendered
    // due to column virtualisation) are not present. this can result in all rendered columns
    // getting narrowed, which in turn introduces more rendered columns on the RHS which
    // did not get autosized in the original run, leaving the visible grid with columns on
    // the LHS sized, but RHS no. so we keep looping through the visible columns until
    // no more cols are available (rendered) to be resized
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    // we autosize after animation frames finish in case any cell renderers need to complete first. this can
    // happen eg if client code is calling api.autoSizeAllColumns() straight after grid is initialised, but grid
    // hasn't fully drawn out all the cells yet (due to cell renderers in animation frames).
    this.animationFrameService.flushAllFrames();
    // keep track of which cols we have resized in here
    var columnsAutosized = [];
    // initialise with anything except 0 so that while loop executes at least once
    var changesThisTimeAround = -1;
    if (skipHeader == null) {
      skipHeader = this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
    }
    while (changesThisTimeAround !== 0) {
      changesThisTimeAround = 0;
      this.actionOnGridColumns(keys, function (column) {
        // if already autosized, skip it
        if (columnsAutosized.indexOf(column) >= 0) {
          return false;
        }
        // get how wide this col should be
        var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column, skipHeader);
        // preferredWidth = -1 if this col is not on the screen
        if (preferredWidth > 0) {
          var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
          column.setActualWidth(newWidth, source);
          columnsAutosized.push(column);
          changesThisTimeAround++;
        }
        return true;
      }, source);
    }
    this.fireColumnResizedEvent(columnsAutosized, true, 'autosizeColumns');
  };
  ColumnModel.prototype.fireColumnResizedEvent = function (columns, finished, source, flexColumns) {
    if (flexColumns === void 0) {
      flexColumns = null;
    }
    if (columns && columns.length) {
      var event_2 = {
        type: Events.EVENT_COLUMN_RESIZED,
        columns: columns,
        column: columns.length === 1 ? columns[0] : null,
        flexColumns: flexColumns,
        finished: finished,
        api: this.gridApi,
        columnApi: this.columnApi,
        source: source
      };
      this.eventService.dispatchEvent(event_2);
    }
  };
  ColumnModel.prototype.autoSizeColumn = function (key, skipHeader, source) {
    if (source === void 0) {
      source = "api";
    }
    if (key) {
      this.autoSizeColumns([key], skipHeader, source);
    }
  };
  ColumnModel.prototype.autoSizeAllColumns = function (skipHeader, source) {
    if (source === void 0) {
      source = "api";
    }
    var allDisplayedColumns = this.getAllDisplayedColumns();
    this.autoSizeColumns(allDisplayedColumns, skipHeader, source);
  };
  ColumnModel.prototype.getColumnsFromTree = function (rootColumns) {
    var result = [];
    var recursiveFindColumns = function recursiveFindColumns(childColumns) {
      for (var i = 0; i < childColumns.length; i++) {
        var child = childColumns[i];
        if (child instanceof Column) {
          result.push(child);
        } else if (child instanceof ProvidedColumnGroup) {
          recursiveFindColumns(child.getChildren());
        }
      }
    };
    recursiveFindColumns(rootColumns);
    return result;
  };
  ColumnModel.prototype.getAllDisplayedTrees = function () {
    if (this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre) {
      return this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight);
    }
    return null;
  };
  // + columnSelectPanel
  ColumnModel.prototype.getPrimaryColumnTree = function () {
    return this.primaryColumnTree;
  };
  // + gridPanel -> for resizing the body and setting top margin
  ColumnModel.prototype.getHeaderRowCount = function () {
    return this.gridHeaderRowCount;
  };
  // + headerRenderer -> setting pinned body width
  ColumnModel.prototype.getDisplayedTreeLeft = function () {
    return this.displayedTreeLeft;
  };
  // + headerRenderer -> setting pinned body width
  ColumnModel.prototype.getDisplayedTreeRight = function () {
    return this.displayedTreeRight;
  };
  // + headerRenderer -> setting pinned body width
  ColumnModel.prototype.getDisplayedTreeCentre = function () {
    return this.displayedTreeCentre;
  };
  // gridPanel -> ensureColumnVisible
  ColumnModel.prototype.isColumnDisplayed = function (column) {
    return this.getAllDisplayedColumns().indexOf(column) >= 0;
  };
  // + csvCreator
  ColumnModel.prototype.getAllDisplayedColumns = function () {
    return this.displayedColumns;
  };
  ColumnModel.prototype.getViewportColumns = function () {
    return this.viewportColumns;
  };
  ColumnModel.prototype.getDisplayedLeftColumnsForRow = function (rowNode) {
    if (!this.colSpanActive) {
      return this.displayedColumnsLeft;
    }
    return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsLeft);
  };
  ColumnModel.prototype.getDisplayedRightColumnsForRow = function (rowNode) {
    if (!this.colSpanActive) {
      return this.displayedColumnsRight;
    }
    return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsRight);
  };
  ColumnModel.prototype.getDisplayedColumnsForRow = function (rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
    var result = [];
    var lastConsideredCol = null;
    var _loop_1 = function _loop_1(i) {
      var col = displayedColumns[i];
      var maxAllowedColSpan = displayedColumns.length - i;
      var colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
      var columnsToCheckFilter = [col];
      if (colSpan > 1) {
        var colsToRemove = colSpan - 1;
        for (var j = 1; j <= colsToRemove; j++) {
          columnsToCheckFilter.push(displayedColumns[i + j]);
        }
        i += colsToRemove;
      }
      // see which cols we should take out for column virtualisation
      var filterPasses;
      if (filterCallback) {
        // if user provided a callback, means some columns may not be in the viewport.
        // the user will NOT provide a callback if we are talking about pinned areas,
        // as pinned areas have no horizontal scroll and do not virtualise the columns.
        // if lots of columns, that means column spanning, and we set filterPasses = true
        // if one or more of the columns spanned pass the filter.
        filterPasses = false;
        columnsToCheckFilter.forEach(function (colForFilter) {
          if (filterCallback(colForFilter)) {
            filterPasses = true;
          }
        });
      } else {
        filterPasses = true;
      }
      if (filterPasses) {
        if (result.length === 0 && lastConsideredCol) {
          var gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
          if (gapBeforeColumn) {
            result.push(lastConsideredCol);
          }
        }
        result.push(col);
      }
      lastConsideredCol = col;
      out_i_1 = i;
    };
    var out_i_1;
    for (var i = 0; i < displayedColumns.length; i++) {
      _loop_1(i);
      i = out_i_1;
    }
    return result;
  };
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  ColumnModel.prototype.getViewportCenterColumnsForRow = function (rowNode) {
    var _this = this;
    if (!this.colSpanActive) {
      return this.viewportColumnsCenter;
    }
    var emptySpaceBeforeColumn = function emptySpaceBeforeColumn(col) {
      var left = col.getLeft();
      return exists(left) && left > _this.viewportLeft;
    };
    // if doing column virtualisation, then we filter based on the viewport.
    var filterCallback = this.suppressColumnVirtualisation ? null : this.isColumnInViewport.bind(this);
    return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsCenter, filterCallback, emptySpaceBeforeColumn);
  };
  ColumnModel.prototype.getAriaColumnIndex = function (col) {
    return this.getAllGridColumns().indexOf(col) + 1;
  };
  ColumnModel.prototype.isColumnInViewport = function (col) {
    // we never filter out autoHeight columns, as we need them in the DOM for calculating Auto Height
    if (col.getColDef().autoHeight) {
      return true;
    }
    var columnLeft = col.getLeft() || 0;
    var columnRight = columnLeft + col.getActualWidth();
    // adding 200 for buffer size, so some cols off viewport are rendered.
    // this helps horizontal scrolling so user rarely sees white space (unless
    // they scroll horizontally fast). however we are conservative, as the more
    // buffer the slower the vertical redraw speed
    var leftBounds = this.viewportLeft - 200;
    var rightBounds = this.viewportRight + 200;
    var columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
    var columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
    return !columnToMuchLeft && !columnToMuchRight;
  };
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  ColumnModel.prototype.getDisplayedColumnsLeftWidth = function () {
    return this.getWidthOfColsInList(this.displayedColumnsLeft);
  };
  // note: this should be cached
  ColumnModel.prototype.getDisplayedColumnsRightWidth = function () {
    return this.getWidthOfColsInList(this.displayedColumnsRight);
  };
  ColumnModel.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType, source) {
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    if (!keys || missingOrEmpty(keys)) {
      return;
    }
    var atLeastOne = false;
    keys.forEach(function (key) {
      var columnToAdd = _this.getPrimaryColumn(key);
      if (!columnToAdd) {
        return;
      }
      if (actionIsAdd) {
        if (masterList.indexOf(columnToAdd) >= 0) {
          return;
        }
        masterList.push(columnToAdd);
      } else {
        if (masterList.indexOf(columnToAdd) < 0) {
          return;
        }
        removeFromArray(masterList, columnToAdd);
      }
      columnCallback(columnToAdd);
      atLeastOne = true;
    });
    if (!atLeastOne) {
      return;
    }
    if (this.autoGroupsNeedBuilding) {
      this.updateGridColumns();
    }
    this.updateDisplayedColumns(source);
    var event = {
      type: eventType,
      columns: masterList,
      column: masterList.length === 1 ? masterList[0] : null,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.setRowGroupColumns = function (colKeys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.autoGroupsNeedBuilding = true;
    this.setPrimaryColumnList(colKeys, this.rowGroupColumns, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this), source);
  };
  ColumnModel.prototype.setRowGroupActive = function (active, column, source) {
    if (active === column.isRowGroupActive()) {
      return;
    }
    column.setRowGroupActive(active, source);
    if (!active && !this.gridOptionsWrapper.isSuppressMakeColumnVisibleAfterUnGroup()) {
      column.setVisible(true, source);
    }
  };
  ColumnModel.prototype.addRowGroupColumn = function (key, source) {
    if (source === void 0) {
      source = "api";
    }
    if (key) {
      this.addRowGroupColumns([key], source);
    }
  };
  ColumnModel.prototype.addRowGroupColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.autoGroupsNeedBuilding = true;
    this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
  };
  ColumnModel.prototype.removeRowGroupColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.autoGroupsNeedBuilding = true;
    this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
  };
  ColumnModel.prototype.removeRowGroupColumn = function (key, source) {
    if (source === void 0) {
      source = "api";
    }
    if (key) {
      this.removeRowGroupColumns([key], source);
    }
  };
  ColumnModel.prototype.addPivotColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) {
      return column.setPivotActive(true, source);
    }, Events.EVENT_COLUMN_PIVOT_CHANGED, source);
  };
  ColumnModel.prototype.setPivotColumns = function (colKeys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.setPrimaryColumnList(colKeys, this.pivotColumns, Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
      column.setPivotActive(added, source);
    }, source);
  };
  ColumnModel.prototype.addPivotColumn = function (key, source) {
    if (source === void 0) {
      source = "api";
    }
    this.addPivotColumns([key], source);
  };
  ColumnModel.prototype.removePivotColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) {
      return column.setPivotActive(false, source);
    }, Events.EVENT_COLUMN_PIVOT_CHANGED, source);
  };
  ColumnModel.prototype.removePivotColumn = function (key, source) {
    if (source === void 0) {
      source = "api";
    }
    this.removePivotColumns([key], source);
  };
  ColumnModel.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback, source) {
    var _this = this;
    masterList.length = 0;
    if (exists(colKeys)) {
      colKeys.forEach(function (key) {
        var column = _this.getPrimaryColumn(key);
        if (column) {
          masterList.push(column);
        }
      });
    }
    (this.primaryColumns || []).forEach(function (column) {
      var added = masterList.indexOf(column) >= 0;
      columnCallback(added, column);
    });
    if (this.autoGroupsNeedBuilding) {
      this.updateGridColumns();
    }
    this.updateDisplayedColumns(source);
    this.fireColumnEvent(eventName, masterList, source);
  };
  ColumnModel.prototype.setValueColumns = function (colKeys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.setPrimaryColumnList(colKeys, this.valueColumns, Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this), source);
  };
  ColumnModel.prototype.setValueActive = function (active, column, source) {
    if (active === column.isValueActive()) {
      return;
    }
    column.setValueActive(active, source);
    if (active && !column.getAggFunc()) {
      var initialAggFunc = this.aggFuncService.getDefaultAggFunc(column);
      column.setAggFunc(initialAggFunc);
    }
  };
  ColumnModel.prototype.addValueColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), Events.EVENT_COLUMN_VALUE_CHANGED, source);
  };
  ColumnModel.prototype.addValueColumn = function (colKey, source) {
    if (source === void 0) {
      source = "api";
    }
    if (colKey) {
      this.addValueColumns([colKey], source);
    }
  };
  ColumnModel.prototype.removeValueColumn = function (colKey, source) {
    if (source === void 0) {
      source = "api";
    }
    this.removeValueColumns([colKey], source);
  };
  ColumnModel.prototype.removeValueColumns = function (keys, source) {
    if (source === void 0) {
      source = "api";
    }
    this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), Events.EVENT_COLUMN_VALUE_CHANGED, source);
  };
  // returns the width we can set to this col, taking into consideration min and max widths
  ColumnModel.prototype.normaliseColumnWidth = function (column, newWidth) {
    var minWidth = column.getMinWidth();
    if (exists(minWidth) && newWidth < minWidth) {
      newWidth = minWidth;
    }
    var maxWidth = column.getMaxWidth();
    if (exists(maxWidth) && column.isGreaterThanMax(newWidth)) {
      newWidth = maxWidth;
    }
    return newWidth;
  };
  ColumnModel.prototype.getPrimaryOrGridColumn = function (key) {
    var column = this.getPrimaryColumn(key);
    return column || this.getGridColumn(key);
  };
  ColumnModel.prototype.setColumnWidths = function (columnWidths, shiftKey,
  // @takeFromAdjacent - if user has 'shift' pressed, then pixels are taken from adjacent column
  finished,
  // @finished - ends up in the event, tells the user if more events are to come
  source) {
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    var sets = [];
    columnWidths.forEach(function (columnWidth) {
      var col = _this.getPrimaryOrGridColumn(columnWidth.key);
      if (!col) {
        return;
      }
      sets.push({
        width: columnWidth.newWidth,
        ratios: [1],
        columns: [col]
      });
      // if user wants to do shift resize by default, then we invert the shift operation
      var defaultIsShift = _this.gridOptionsWrapper.getColResizeDefault() === 'shift';
      if (defaultIsShift) {
        shiftKey = !shiftKey;
      }
      if (shiftKey) {
        var otherCol = _this.getDisplayedColAfter(col);
        if (!otherCol) {
          return;
        }
        var widthDiff = col.getActualWidth() - columnWidth.newWidth;
        var otherColWidth = otherCol.getActualWidth() + widthDiff;
        sets.push({
          width: otherColWidth,
          ratios: [1],
          columns: [otherCol]
        });
      }
    });
    if (sets.length === 0) {
      return;
    }
    this.resizeColumnSets(sets, finished, source);
  };
  ColumnModel.prototype.checkMinAndMaxWidthsForSet = function (columnResizeSet) {
    var columns = columnResizeSet.columns,
      width = columnResizeSet.width;
    // every col has a min width, so sum them all up and see if we have enough room
    // for all the min widths
    var minWidthAccumulated = 0;
    var maxWidthAccumulated = 0;
    var maxWidthActive = true;
    columns.forEach(function (col) {
      var minWidth = col.getMinWidth();
      minWidthAccumulated += minWidth || 0;
      var maxWidth = col.getMaxWidth();
      if (exists(maxWidth) && maxWidth > 0) {
        maxWidthAccumulated += maxWidth;
      } else {
        // if at least one columns has no max width, it means the group of columns
        // then has no max width, as at least one column can take as much width as possible
        maxWidthActive = false;
      }
    });
    var minWidthPasses = width >= minWidthAccumulated;
    var maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
    return minWidthPasses && maxWidthPasses;
  };
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  ColumnModel.prototype.resizeColumnSets = function (resizeSets, finished, source) {
    var _this = this;
    var passMinMaxCheck = !resizeSets || resizeSets.every(function (columnResizeSet) {
      return _this.checkMinAndMaxWidthsForSet(columnResizeSet);
    });
    if (!passMinMaxCheck) {
      // even though we are not going to resize beyond min/max size, we still need to raise event when finished
      if (finished) {
        var columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
        this.fireColumnResizedEvent(columns, finished, source);
      }
      return; // don't resize!
    }

    var changedCols = [];
    var allResizedCols = [];
    resizeSets.forEach(function (set) {
      var width = set.width,
        columns = set.columns,
        ratios = set.ratios;
      // keep track of pixels used, and last column gets the remaining,
      // to cater for rounding errors, and min width adjustments
      var newWidths = {};
      var finishedCols = {};
      columns.forEach(function (col) {
        return allResizedCols.push(col);
      });
      // the loop below goes through each col. if a col exceeds it's min/max width,
      // it then gets set to its min/max width and the column is removed marked as 'finished'
      // and the calculation is done again leaving this column out. take for example columns
      // {A, width: 50, maxWidth: 100}
      // {B, width: 50}
      // {C, width: 50}
      // and then the set is set to width 600 - on the first pass the grid tries to set each column
      // to 200. it checks A and sees 200 > 100 and so sets the width to 100. col A is then marked
      // as 'finished' and the calculation is done again with the remaining cols B and C, which end up
      // splitting the remaining 500 pixels.
      var finishedColsGrew = true;
      var loopCount = 0;
      var _loop_2 = function _loop_2() {
        loopCount++;
        if (loopCount > 1000) {
          // this should never happen, but in the future, someone might introduce a bug here,
          // so we stop the browser from hanging and report bug properly
          console.error('AG Grid: infinite loop in resizeColumnSets');
          return "break";
        }
        finishedColsGrew = false;
        var subsetCols = [];
        var subsetRatioTotal = 0;
        var pixelsToDistribute = width;
        columns.forEach(function (col, index) {
          var thisColFinished = finishedCols[col.getId()];
          if (thisColFinished) {
            pixelsToDistribute -= newWidths[col.getId()];
          } else {
            subsetCols.push(col);
            var ratioThisCol = ratios[index];
            subsetRatioTotal += ratioThisCol;
          }
        });
        // because we are not using all of the ratios (cols can be missing),
        // we scale the ratio. if all columns are included, then subsetRatioTotal=1,
        // and so the ratioScale will be 1.
        var ratioScale = 1 / subsetRatioTotal;
        subsetCols.forEach(function (col, index) {
          var lastCol = index === subsetCols.length - 1;
          var colNewWidth;
          if (lastCol) {
            colNewWidth = pixelsToDistribute;
          } else {
            colNewWidth = Math.round(ratios[index] * width * ratioScale);
            pixelsToDistribute -= colNewWidth;
          }
          var minWidth = col.getMinWidth();
          var maxWidth = col.getMaxWidth();
          if (exists(minWidth) && colNewWidth < minWidth) {
            colNewWidth = minWidth;
            finishedCols[col.getId()] = true;
            finishedColsGrew = true;
          } else if (exists(maxWidth) && maxWidth > 0 && colNewWidth > maxWidth) {
            colNewWidth = maxWidth;
            finishedCols[col.getId()] = true;
            finishedColsGrew = true;
          }
          newWidths[col.getId()] = colNewWidth;
        });
      };
      while (finishedColsGrew) {
        var state_1 = _loop_2();
        if (state_1 === "break") break;
      }
      columns.forEach(function (col) {
        var newWidth = newWidths[col.getId()];
        if (col.getActualWidth() !== newWidth) {
          col.setActualWidth(newWidth, source);
          changedCols.push(col);
        }
      });
    });
    // if no cols changed, then no need to update more or send event.
    var atLeastOneColChanged = changedCols.length > 0;
    var flexedCols = this.refreshFlexedColumns({
      resizingCols: allResizedCols,
      skipSetLeft: true
    });
    if (atLeastOneColChanged) {
      this.setLeftValues(source);
      this.updateBodyWidths();
      this.checkViewportColumns();
    }
    // check for change first, to avoid unnecessary firing of events
    // however we always fire 'finished' events. this is important
    // when groups are resized, as if the group is changing slowly,
    // eg 1 pixel at a time, then each change will fire change events
    // in all the columns in the group, but only one with get the pixel.
    var colsForEvent = allResizedCols.concat(flexedCols);
    if (atLeastOneColChanged || finished) {
      this.fireColumnResizedEvent(colsForEvent, finished, source, flexedCols);
    }
  };
  ColumnModel.prototype.setColumnAggFunc = function (key, aggFunc, source) {
    if (source === void 0) {
      source = "api";
    }
    if (!key) {
      return;
    }
    var column = this.getPrimaryColumn(key);
    if (!column) {
      return;
    }
    column.setAggFunc(aggFunc);
    this.fireColumnEvent(Events.EVENT_COLUMN_VALUE_CHANGED, [column], source);
  };
  ColumnModel.prototype.fireColumnEvent = function (type, columns, source) {
    var event = {
      type: type,
      columns: columns,
      column: columns && columns.length == 1 ? columns[0] : null,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.moveRowGroupColumn = function (fromIndex, toIndex, source) {
    if (source === void 0) {
      source = "api";
    }
    var column = this.rowGroupColumns[fromIndex];
    this.rowGroupColumns.splice(fromIndex, 1);
    this.rowGroupColumns.splice(toIndex, 0, column);
    var event = {
      type: Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
      columns: this.rowGroupColumns,
      column: this.rowGroupColumns.length === 1 ? this.rowGroupColumns[0] : null,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.moveColumns = function (columnsToMoveKeys, toIndex, source) {
    if (source === void 0) {
      source = "api";
    }
    this.columnAnimationService.start();
    if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
      console.warn('AG Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
      console.warn('AG Grid: remember that you should not count the moving columns when calculating the new index');
      return;
    }
    // we want to pull all the columns out first and put them into an ordered list
    var columnsToMove = this.getGridColumns(columnsToMoveKeys);
    var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
    if (failedRules) {
      return;
    }
    moveInArray(this.gridColumns, columnsToMove, toIndex);
    this.updateDisplayedColumns(source);
    var event = {
      type: Events.EVENT_COLUMN_MOVED,
      columns: columnsToMove,
      column: columnsToMove.length === 1 ? columnsToMove[0] : null,
      toIndex: toIndex,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
    this.columnAnimationService.finish();
  };
  ColumnModel.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
    // make a copy of what the grid columns would look like after the move
    var proposedColumnOrder = this.gridColumns.slice();
    moveInArray(proposedColumnOrder, columnsToMove, toIndex);
    // then check that the new proposed order of the columns passes all rules
    if (!this.doesMovePassMarryChildren(proposedColumnOrder)) {
      return false;
    }
    if (!this.doesMovePassLockedPositions(proposedColumnOrder)) {
      return false;
    }
    return true;
  };
  // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
  // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]
  ColumnModel.prototype.sortColumnsLikeGridColumns = function (cols) {
    var _this = this;
    if (!cols || cols.length <= 1) {
      return;
    }
    var notAllColsInGridColumns = cols.filter(function (c) {
      return _this.gridColumns.indexOf(c) < 0;
    }).length > 0;
    if (notAllColsInGridColumns) {
      return;
    }
    cols.sort(function (a, b) {
      var indexA = _this.gridColumns.indexOf(a);
      var indexB = _this.gridColumns.indexOf(b);
      return indexA - indexB;
    });
  };
  ColumnModel.prototype.doesMovePassLockedPositions = function (proposedColumnOrder) {
    var foundNonLocked = false;
    var rulePassed = true;
    // go though the cols, see if any non-locked appear before any locked
    proposedColumnOrder.forEach(function (col) {
      if (col.getColDef().lockPosition) {
        if (foundNonLocked) {
          rulePassed = false;
        }
      } else {
        foundNonLocked = true;
      }
    });
    return rulePassed;
  };
  ColumnModel.prototype.doesMovePassMarryChildren = function (allColumnsCopy) {
    var rulePassed = true;
    this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (child) {
      if (!(child instanceof ProvidedColumnGroup)) {
        return;
      }
      var columnGroup = child;
      var colGroupDef = columnGroup.getColGroupDef();
      var marryChildren = colGroupDef && colGroupDef.marryChildren;
      if (!marryChildren) {
        return;
      }
      var newIndexes = [];
      columnGroup.getLeafColumns().forEach(function (col) {
        var newColIndex = allColumnsCopy.indexOf(col);
        newIndexes.push(newColIndex);
      });
      var maxIndex = Math.max.apply(Math, newIndexes);
      var minIndex = Math.min.apply(Math, newIndexes);
      // spread is how far the first column in this group is away from the last column
      var spread = maxIndex - minIndex;
      var maxSpread = columnGroup.getLeafColumns().length - 1;
      // if the columns
      if (spread > maxSpread) {
        rulePassed = false;
      }
      // console.log(`maxIndex = ${maxIndex}, minIndex = ${minIndex}, spread = ${spread}, maxSpread = ${maxSpread}, fail = ${spread > (count-1)}`)
      // console.log(allColumnsCopy.map( col => col.getColDef().field).join(','));
    });

    return rulePassed;
  };
  ColumnModel.prototype.moveColumn = function (key, toIndex, source) {
    if (source === void 0) {
      source = "api";
    }
    this.moveColumns([key], toIndex, source);
  };
  ColumnModel.prototype.moveColumnByIndex = function (fromIndex, toIndex, source) {
    if (source === void 0) {
      source = "api";
    }
    var column = this.gridColumns[fromIndex];
    this.moveColumn(column, toIndex, source);
  };
  ColumnModel.prototype.getColumnDefs = function () {
    var _this = this;
    if (!this.primaryColumns) {
      return;
    }
    var cols = this.primaryColumns.slice();
    if (this.gridColsArePrimary) {
      cols.sort(function (a, b) {
        return _this.gridColumns.indexOf(a) - _this.gridColumns.indexOf(b);
      });
    } else if (this.lastPrimaryOrder) {
      cols.sort(function (a, b) {
        return _this.lastPrimaryOrder.indexOf(a) - _this.lastPrimaryOrder.indexOf(b);
      });
    }
    return this.columnDefFactory.buildColumnDefs(cols, this.rowGroupColumns, this.pivotColumns);
  };
  // used by:
  // + angularGrid -> for setting body width
  // + rowController -> setting main row widths (when inserting and resizing)
  // need to cache this
  ColumnModel.prototype.getBodyContainerWidth = function () {
    return this.bodyWidth;
  };
  ColumnModel.prototype.getContainerWidth = function (pinned) {
    switch (pinned) {
      case Constants.PINNED_LEFT:
        return this.leftWidth;
      case Constants.PINNED_RIGHT:
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  };
  // after setColumnWidth or updateGroupsAndDisplayedColumns
  ColumnModel.prototype.updateBodyWidths = function () {
    var newBodyWidth = this.getWidthOfColsInList(this.displayedColumnsCenter);
    var newLeftWidth = this.getWidthOfColsInList(this.displayedColumnsLeft);
    var newRightWidth = this.getWidthOfColsInList(this.displayedColumnsRight);
    // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
    // columns, due to RTL inverting the y coordinates
    this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
    var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
    if (atLeastOneChanged) {
      this.bodyWidth = newBodyWidth;
      this.leftWidth = newLeftWidth;
      this.rightWidth = newRightWidth;
      // when this fires, it is picked up by the gridPanel, which ends up in
      // gridPanel calling setWidthAndScrollPosition(), which in turn calls setViewportPosition()
      var event_3 = {
        type: Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_3);
    }
  };
  // + rowController
  ColumnModel.prototype.getValueColumns = function () {
    return this.valueColumns ? this.valueColumns : [];
  };
  // + rowController
  ColumnModel.prototype.getPivotColumns = function () {
    return this.pivotColumns ? this.pivotColumns : [];
  };
  // + clientSideRowModel
  ColumnModel.prototype.isPivotActive = function () {
    return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
  };
  // + toolPanel
  ColumnModel.prototype.getRowGroupColumns = function () {
    return this.rowGroupColumns ? this.rowGroupColumns : [];
  };
  // + rowController -> while inserting rows
  ColumnModel.prototype.getDisplayedCenterColumns = function () {
    return this.displayedColumnsCenter;
  };
  // + rowController -> while inserting rows
  ColumnModel.prototype.getDisplayedLeftColumns = function () {
    return this.displayedColumnsLeft;
  };
  ColumnModel.prototype.getDisplayedRightColumns = function () {
    return this.displayedColumnsRight;
  };
  ColumnModel.prototype.getDisplayedColumns = function (type) {
    switch (type) {
      case Constants.PINNED_LEFT:
        return this.getDisplayedLeftColumns();
      case Constants.PINNED_RIGHT:
        return this.getDisplayedRightColumns();
      default:
        return this.getDisplayedCenterColumns();
    }
  };
  // used by:
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  ColumnModel.prototype.getAllPrimaryColumns = function () {
    return this.primaryColumns ? this.primaryColumns.slice() : null;
  };
  ColumnModel.prototype.getSecondaryColumns = function () {
    return this.secondaryColumns ? this.secondaryColumns.slice() : null;
  };
  ColumnModel.prototype.getAllColumnsForQuickFilter = function () {
    return this.columnsForQuickFilter;
  };
  // + moveColumnController
  ColumnModel.prototype.getAllGridColumns = function () {
    return this.gridColumns;
  };
  ColumnModel.prototype.isEmpty = function () {
    return missingOrEmpty(this.gridColumns);
  };
  ColumnModel.prototype.isRowGroupEmpty = function () {
    return missingOrEmpty(this.rowGroupColumns);
  };
  ColumnModel.prototype.setColumnVisible = function (key, visible, source) {
    if (source === void 0) {
      source = "api";
    }
    this.setColumnsVisible([key], visible, source);
  };
  ColumnModel.prototype.setColumnsVisible = function (keys, visible, source) {
    var _this = this;
    if (visible === void 0) {
      visible = false;
    }
    if (source === void 0) {
      source = "api";
    }
    this.columnAnimationService.start();
    this.actionOnGridColumns(keys, function (column) {
      if (column.isVisible() !== visible) {
        column.setVisible(visible, source);
        return true;
      }
      return false;
    }, source, function () {
      var event = {
        type: Events.EVENT_COLUMN_VISIBLE,
        visible: visible,
        column: null,
        columns: null,
        api: _this.gridApi,
        columnApi: _this.columnApi,
        source: source
      };
      return event;
    });
    this.columnAnimationService.finish();
  };
  ColumnModel.prototype.setColumnPinned = function (key, pinned, source) {
    if (source === void 0) {
      source = "api";
    }
    if (key) {
      this.setColumnsPinned([key], pinned, source);
    }
  };
  ColumnModel.prototype.setColumnsPinned = function (keys, pinned, source) {
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    if (this.gridOptionsWrapper.getDomLayout() === 'print') {
      console.warn("Changing the column pinning status is not allowed with domLayout='print'");
      return;
    }
    this.columnAnimationService.start();
    var actualPinned;
    if (pinned === true || pinned === Constants.PINNED_LEFT) {
      actualPinned = Constants.PINNED_LEFT;
    } else if (pinned === Constants.PINNED_RIGHT) {
      actualPinned = Constants.PINNED_RIGHT;
    } else {
      actualPinned = null;
    }
    this.actionOnGridColumns(keys, function (col) {
      if (col.getPinned() !== actualPinned) {
        col.setPinned(actualPinned);
        return true;
      }
      return false;
    }, source, function () {
      var event = {
        type: Events.EVENT_COLUMN_PINNED,
        pinned: actualPinned,
        column: null,
        columns: null,
        api: _this.gridApi,
        columnApi: _this.columnApi,
        source: source
      };
      return event;
    });
    this.columnAnimationService.finish();
  };
  // does an action on a set of columns. provides common functionality for looking up the
  // columns based on key, getting a list of effected columns, and then updated the event
  // with either one column (if it was just one col) or a list of columns
  // used by: autoResize, setVisible, setPinned
  ColumnModel.prototype.actionOnGridColumns = function (
  // the column keys this action will be on
  keys,
  // the action to do - if this returns false, the column was skipped
  // and won't be included in the event
  action,
  // should return back a column event of the right type
  source, createEvent) {
    var _this = this;
    if (missingOrEmpty(keys)) {
      return;
    }
    var updatedColumns = [];
    keys.forEach(function (key) {
      var column = _this.getGridColumn(key);
      if (!column) {
        return;
      }
      // need to check for false with type (ie !== instead of !=)
      // as not returning anything (undefined) would also be false
      var resultOfAction = action(column);
      if (resultOfAction !== false) {
        updatedColumns.push(column);
      }
    });
    if (!updatedColumns.length) {
      return;
    }
    this.updateDisplayedColumns(source);
    if (exists(createEvent) && createEvent) {
      var event_4 = createEvent();
      event_4.columns = updatedColumns;
      event_4.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
      this.eventService.dispatchEvent(event_4);
    }
  };
  ColumnModel.prototype.getDisplayedColBefore = function (col) {
    var allDisplayedColumns = this.getAllDisplayedColumns();
    var oldIndex = allDisplayedColumns.indexOf(col);
    if (oldIndex > 0) {
      return allDisplayedColumns[oldIndex - 1];
    }
    return null;
  };
  // used by:
  // + rowRenderer -> for navigation
  ColumnModel.prototype.getDisplayedColAfter = function (col) {
    var allDisplayedColumns = this.getAllDisplayedColumns();
    var oldIndex = allDisplayedColumns.indexOf(col);
    if (oldIndex < allDisplayedColumns.length - 1) {
      return allDisplayedColumns[oldIndex + 1];
    }
    return null;
  };
  ColumnModel.prototype.getDisplayedGroupAfter = function (columnGroup) {
    return this.getDisplayedGroupAtDirection(columnGroup, 'After');
  };
  ColumnModel.prototype.getDisplayedGroupBefore = function (columnGroup) {
    return this.getDisplayedGroupAtDirection(columnGroup, 'Before');
  };
  ColumnModel.prototype.getDisplayedGroupAtDirection = function (columnGroup, direction) {
    // pick the last displayed column in this group
    var requiredLevel = columnGroup.getOriginalColumnGroup().getLevel() + columnGroup.getPaddingLevel();
    var colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
    var col = direction === 'After' ? last(colGroupLeafColumns) : colGroupLeafColumns[0];
    var getDisplayColMethod = "getDisplayedCol" + direction;
    while (true) {
      // keep moving to the next col, until we get to another group
      var column = this[getDisplayColMethod](col);
      if (!column) {
        return null;
      }
      var groupPointer = this.getColumnGroupAtLevel(column, requiredLevel);
      if (groupPointer !== columnGroup) {
        return groupPointer;
      }
    }
  };
  ColumnModel.prototype.getColumnGroupAtLevel = function (column, level) {
    // get group at same level as the one we are looking for
    var groupPointer = column.getParent();
    var originalGroupLevel;
    var groupPointerLevel;
    while (true) {
      var groupPointerOriginalColumnGroup = groupPointer.getOriginalColumnGroup();
      originalGroupLevel = groupPointerOriginalColumnGroup.getLevel();
      groupPointerLevel = groupPointer.getPaddingLevel();
      if (originalGroupLevel + groupPointerLevel <= level) {
        break;
      }
      groupPointer = groupPointer.getParent();
    }
    return groupPointer;
  };
  ColumnModel.prototype.isPinningLeft = function () {
    return this.displayedColumnsLeft.length > 0;
  };
  ColumnModel.prototype.isPinningRight = function () {
    return this.displayedColumnsRight.length > 0;
  };
  ColumnModel.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
    var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
    if (this.groupAutoColumns && exists(this.groupAutoColumns)) {
      this.groupAutoColumns.forEach(function (col) {
        return result.push(col);
      });
    }
    if (this.secondaryColumnsPresent && this.secondaryColumns) {
      this.secondaryColumns.forEach(function (column) {
        return result.push(column);
      });
    }
    return result;
  };
  ColumnModel.prototype.createStateItemFromColumn = function (column) {
    var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
    var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
    var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
    var sort = column.getSort() != null ? column.getSort() : null;
    var sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
    var flex = column.getFlex() != null && column.getFlex() > 0 ? column.getFlex() : null;
    var res = {
      colId: column.getColId(),
      width: column.getActualWidth(),
      hide: !column.isVisible(),
      pinned: column.getPinned(),
      sort: sort,
      sortIndex: sortIndex,
      aggFunc: aggFunc,
      rowGroup: column.isRowGroupActive(),
      rowGroupIndex: rowGroupIndex,
      pivot: column.isPivotActive(),
      pivotIndex: pivotIndex,
      flex: flex
    };
    return res;
  };
  ColumnModel.prototype.getColumnState = function () {
    if (missing(this.primaryColumns) || !this.isAlive()) {
      return [];
    }
    var colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
    var res = colsForState.map(this.createStateItemFromColumn.bind(this));
    if (!this.pivotMode) {
      this.orderColumnStateList(res);
    }
    return res;
  };
  ColumnModel.prototype.getPrimaryAndAutoGroupCols = function () {
    if (!this.groupAutoColumns) {
      return this.primaryColumns;
    }
    return __spreadArrays$1(this.primaryColumns || [], this.groupAutoColumns);
  };
  ColumnModel.prototype.orderColumnStateList = function (columnStateList) {
    // for fast looking, store the index of each column
    var gridColumnIdMap = convertToMap(this.gridColumns.map(function (col, index) {
      return [col.getColId(), index];
    }));
    columnStateList.sort(function (itemA, itemB) {
      var posA = gridColumnIdMap.has(itemA.colId) ? gridColumnIdMap.get(itemA.colId) : -1;
      var posB = gridColumnIdMap.has(itemB.colId) ? gridColumnIdMap.get(itemB.colId) : -1;
      return posA - posB;
    });
  };
  ColumnModel.prototype.resetColumnState = function (source) {
    // NOTE = there is one bug here that no customer has noticed - if a column has colDef.lockPosition,
    // this is ignored  below when ordering the cols. to work, we should always put lockPosition cols first.
    // As a work around, developers should just put lockPosition columns first in their colDef list.
    if (source === void 0) {
      source = "api";
    }
    // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
    var primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
    var columnStates = [];
    // we start at 1000, so if user has mix of rowGroup and group specified, it will work with both.
    // eg IF user has ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=true,
    // THEN result will be ColA.rowGroupIndex=0, ColB.rowGroupIndex=1, ColC.rowGroup=1000
    var letRowGroupIndex = 1000;
    var letPivotIndex = 1000;
    var colsToProcess = [];
    if (this.groupAutoColumns) {
      colsToProcess = colsToProcess.concat(this.groupAutoColumns);
    }
    if (primaryColumns) {
      colsToProcess = colsToProcess.concat(primaryColumns);
    }
    colsToProcess.forEach(function (column) {
      var getValueOrNull = function getValueOrNull(a, b) {
        return a != null ? a : b != null ? b : null;
      };
      var colDef = column.getColDef();
      var sort = getValueOrNull(colDef.sort, colDef.initialSort);
      var sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
      var hide = getValueOrNull(colDef.hide, colDef.initialHide);
      var pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
      var width = getValueOrNull(colDef.width, colDef.initialWidth);
      var flex = getValueOrNull(colDef.flex, colDef.initialFlex);
      var rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
      var rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
      if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
        rowGroupIndex = null;
        rowGroup = null;
      }
      var pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
      var pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
      if (pivotIndex == null && (pivot == null || pivot == false)) {
        pivotIndex = null;
        pivot = null;
      }
      var aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
      var stateItem = {
        colId: column.getColId(),
        sort: sort,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
      };
      if (missing(rowGroupIndex) && rowGroup) {
        stateItem.rowGroupIndex = letRowGroupIndex++;
      }
      if (missing(pivotIndex) && pivot) {
        stateItem.pivotIndex = letPivotIndex++;
      }
      columnStates.push(stateItem);
    });
    this.applyColumnState({
      state: columnStates,
      applyOrder: true
    }, source);
  };
  ColumnModel.prototype.applyColumnState = function (params, source) {
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    if (missingOrEmpty(this.primaryColumns)) {
      return false;
    }
    if (params && params.state && !params.state.forEach) {
      console.warn('AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.');
      return false;
    }
    this.columnAnimationService.start();
    var raiseEventsFunc = this.compareColumnStatesAndRaiseEvents(source);
    this.autoGroupsNeedBuilding = true;
    // at the end below, this list will have all columns we got no state for
    var columnsWithNoState = this.primaryColumns.slice();
    var success = true;
    var rowGroupIndexes = {};
    var pivotIndexes = {};
    var autoGroupColumnStates = [];
    var previousRowGroupCols = this.rowGroupColumns.slice();
    var previousPivotCols = this.pivotColumns.slice();
    if (params.state) {
      params.state.forEach(function (state) {
        var groupAutoColumnId = Constants.GROUP_AUTO_COLUMN_ID;
        var colId = state.colId || '';
        // auto group columns are re-created so deferring syncing with ColumnState
        var isAutoGroupColumn = startsWith(colId, groupAutoColumnId);
        if (isAutoGroupColumn) {
          autoGroupColumnStates.push(state);
          return;
        }
        var column = _this.getPrimaryColumn(colId);
        if (!column) {
          // we don't log the failure, as it's possible the user is applying that has extra
          // cols in it. for example they could of save while row-grouping (so state includes
          // auto-group column) and then applied state when not grouping (so the auto-group
          // column would be in the state but no used).
          success = false;
        } else {
          _this.syncColumnWithStateItem(column, state, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
          removeFromArray(columnsWithNoState, column);
        }
      });
    }
    // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
    var applyDefaultsFunc = function applyDefaultsFunc(col) {
      return _this.syncColumnWithStateItem(col, null, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
    };
    columnsWithNoState.forEach(applyDefaultsFunc);
    // sort the lists according to the indexes that were provided
    var comparator = function comparator(indexes, oldList, colA, colB) {
      var indexA = indexes[colA.getId()];
      var indexB = indexes[colB.getId()];
      var aHasIndex = indexA != null;
      var bHasIndex = indexB != null;
      if (aHasIndex && bHasIndex) {
        // both a and b are new cols with index, so sort on index
        return indexA - indexB;
      }
      if (aHasIndex) {
        // a has an index, so it should be before a
        return -1;
      }
      if (bHasIndex) {
        // b has an index, so it should be before a
        return 1;
      }
      var oldIndexA = oldList.indexOf(colA);
      var oldIndexB = oldList.indexOf(colB);
      var aHasOldIndex = oldIndexA >= 0;
      var bHasOldIndex = oldIndexB >= 0;
      if (aHasOldIndex && bHasOldIndex) {
        // both a and b are old cols, so sort based on last order
        return oldIndexA - oldIndexB;
      }
      if (aHasOldIndex) {
        // a is old, b is new, so b is first
        return -1;
      }
      // this bit does matter, means both are new cols
      // but without index or that b is old and a is new
      return 1;
    };
    this.rowGroupColumns.sort(comparator.bind(this, rowGroupIndexes, previousRowGroupCols));
    this.pivotColumns.sort(comparator.bind(this, pivotIndexes, previousPivotCols));
    this.updateGridColumns();
    // sync newly created auto group columns with ColumnState
    var autoGroupColsCopy = this.groupAutoColumns ? this.groupAutoColumns.slice() : [];
    autoGroupColumnStates.forEach(function (stateItem) {
      var autoCol = _this.getAutoColumn(stateItem.colId);
      removeFromArray(autoGroupColsCopy, autoCol);
      _this.syncColumnWithStateItem(autoCol, stateItem, params.defaultState, null, null, true, source);
    });
    // autogroup cols with nothing else, apply the default
    autoGroupColsCopy.forEach(applyDefaultsFunc);
    this.applyOrderAfterApplyState(params);
    this.updateDisplayedColumns(source);
    this.dispatchEverythingChanged(source);
    raiseEventsFunc();
    this.columnAnimationService.finish();
    return success;
  };
  ColumnModel.prototype.applyOrderAfterApplyState = function (params) {
    if (!this.gridColsArePrimary || !params.applyOrder || !params.state) {
      return;
    }
    var newOrder = [];
    var processedColIds = {};
    var gridColumnsMap = {};
    this.gridColumns.forEach(function (col) {
      return gridColumnsMap[col.getId()] = col;
    });
    params.state.forEach(function (item) {
      if (!item.colId || processedColIds[item.colId]) {
        return;
      }
      var col = gridColumnsMap[item.colId];
      if (col) {
        newOrder.push(col);
        processedColIds[item.colId] = true;
      }
    });
    // add in all other columns
    this.gridColumns.forEach(function (col) {
      if (!processedColIds[col.getColId()]) {
        newOrder.push(col);
      }
    });
    // this is already done in updateGridColumns, however we changed the order above (to match the order of the state
    // columns) so we need to do it again. we could of put logic into the order above to take into account fixed
    // columns, however if we did then we would have logic for updating fixed columns twice. reusing the logic here
    // is less sexy for the code here, but it keeps consistency.
    newOrder = this.putFixedColumnsFirst(newOrder);
    if (!this.doesMovePassMarryChildren(newOrder)) {
      console.warn('AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.');
      return;
    }
    this.gridColumns = newOrder;
  };
  ColumnModel.prototype.compareColumnStatesAndRaiseEvents = function (source) {
    var _this = this;
    // if no columns to begin with, then it means we are setting columns for the first time, so
    // there should be no events fired to show differences in columns.
    var colsPreviouslyExisted = !!this.columnDefs;
    if (!colsPreviouslyExisted) {
      return function () {};
    }
    var startState = {
      rowGroupColumns: this.rowGroupColumns.slice(),
      pivotColumns: this.pivotColumns.slice(),
      valueColumns: this.valueColumns.slice()
    };
    var columnStateBefore = this.getColumnState();
    var columnStateBeforeMap = {};
    columnStateBefore.forEach(function (col) {
      columnStateBeforeMap[col.colId] = col;
    });
    return function () {
      if (_this.gridOptionsWrapper.isSuppressColumnStateEvents()) {
        return;
      }
      var colsForState = _this.getPrimaryAndAutoGroupCols();
      // raises generic ColumnEvents where all columns are returned rather than what has changed
      var raiseWhenListsDifferent = function raiseWhenListsDifferent(eventType, colsBefore, colsAfter, idMapper) {
        var beforeList = colsBefore.map(idMapper);
        var afterList = colsAfter.map(idMapper);
        var unchanged = areEqual(beforeList, afterList);
        if (unchanged) {
          return;
        }
        // returning all columns rather than what has changed!
        var event = {
          type: eventType,
          columns: colsAfter,
          column: colsAfter.length === 1 ? colsAfter[0] : null,
          api: _this.gridApi,
          columnApi: _this.columnApi,
          source: source
        };
        _this.eventService.dispatchEvent(event);
      };
      // determines which columns have changed according to supplied predicate
      var getChangedColumns = function getChangedColumns(changedPredicate) {
        var changedColumns = [];
        (colsForState || []).forEach(function (column) {
          var colStateBefore = columnStateBeforeMap[column.getColId()];
          if (colStateBefore && changedPredicate(colStateBefore, column)) {
            changedColumns.push(column);
          }
        });
        return changedColumns;
      };
      var columnIdMapper = function columnIdMapper(c) {
        return c.getColId();
      };
      raiseWhenListsDifferent(Events.EVENT_COLUMN_ROW_GROUP_CHANGED, startState.rowGroupColumns, _this.rowGroupColumns, columnIdMapper);
      raiseWhenListsDifferent(Events.EVENT_COLUMN_PIVOT_CHANGED, startState.pivotColumns, _this.pivotColumns, columnIdMapper);
      var valueChangePredicate = function valueChangePredicate(cs, c) {
        var oldActive = cs.aggFunc != null;
        var activeChanged = oldActive != c.isValueActive();
        // we only check aggFunc if the agg is active
        var aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
        return activeChanged || aggFuncChanged;
      };
      var changedValues = getChangedColumns(valueChangePredicate);
      if (changedValues.length > 0) {
        // we pass all value columns, now the ones that changed. this is the same
        // as pivot and rowGroup cols, but different to all other properties below.
        // this is more for backwards compatibility, as it's always been this way.
        // really it should be the other way, as the order of the cols makes no difference
        // for valueColumns (apart from displaying them in the tool panel).
        _this.fireColumnEvent(Events.EVENT_COLUMN_VALUE_CHANGED, _this.valueColumns, source);
      }
      var resizeChangePredicate = function resizeChangePredicate(cs, c) {
        return cs.width != c.getActualWidth();
      };
      _this.fireColumnResizedEvent(getChangedColumns(resizeChangePredicate), true, source);
      var pinnedChangePredicate = function pinnedChangePredicate(cs, c) {
        return cs.pinned != c.getPinned();
      };
      _this.raiseColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
      var visibilityChangePredicate = function visibilityChangePredicate(cs, c) {
        return cs.hide == c.isVisible();
      };
      _this.raiseColumnVisibleEvent(getChangedColumns(visibilityChangePredicate), source);
      var sortChangePredicate = function sortChangePredicate(cs, c) {
        return cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
      };
      if (getChangedColumns(sortChangePredicate).length > 0) {
        _this.sortController.dispatchSortChangedEvents();
      }
      // special handling for moved column events
      _this.raiseColumnMovedEvent(columnStateBefore, source);
    };
  };
  ColumnModel.prototype.raiseColumnPinnedEvent = function (changedColumns, source) {
    if (!changedColumns.length) {
      return;
    }
    // if just one column, we use this, otherwise we don't include the col
    var column = changedColumns.length === 1 ? changedColumns[0] : null;
    // only include visible if it's common in all columns
    var pinned = this.getCommonValue(changedColumns, function (col) {
      return col.getPinned();
    });
    var event = {
      type: Events.EVENT_COLUMN_PINNED,
      // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
      pinned: pinned != null ? pinned : null,
      columns: changedColumns,
      column: column,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.getCommonValue = function (cols, valueGetter) {
    if (!cols || cols.length == 0) {
      return undefined;
    }
    // compare each value to the first value. if nothing differs, then value is common so return it.
    var firstValue = valueGetter(cols[0]);
    for (var i = 1; i < cols.length; i++) {
      if (firstValue !== valueGetter(cols[i])) {
        // values differ, no common value
        return undefined;
      }
    }
    return firstValue;
  };
  ColumnModel.prototype.raiseColumnVisibleEvent = function (changedColumns, source) {
    if (!changedColumns.length) {
      return;
    }
    // if just one column, we use this, otherwise we don't include the col
    var column = changedColumns.length === 1 ? changedColumns[0] : null;
    // only include visible if it's common in all columns
    var visible = this.getCommonValue(changedColumns, function (col) {
      return col.isVisible();
    });
    var event = {
      type: Events.EVENT_COLUMN_VISIBLE,
      visible: visible,
      columns: changedColumns,
      column: column,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.raiseColumnMovedEvent = function (colStateBefore, source) {
    // we are only interested in columns that were both present and visible before and after
    var _this = this;
    var colStateAfter = this.getColumnState();
    var colStateAfterMapped = {};
    colStateAfter.forEach(function (s) {
      return colStateAfterMapped[s.colId] = s;
    });
    // get id's of cols in both before and after lists
    var colsIntersectIds = {};
    colStateBefore.forEach(function (s) {
      if (colStateAfterMapped[s.colId]) {
        colsIntersectIds[s.colId] = true;
      }
    });
    // filter state lists, so we only have cols that were present before and after
    var beforeFiltered = filter(colStateBefore, function (c) {
      return colsIntersectIds[c.colId];
    });
    var afterFiltered = filter(colStateAfter, function (c) {
      return colsIntersectIds[c.colId];
    });
    // see if any cols are in a different location
    var movedColumns = [];
    afterFiltered.forEach(function (csAfter, index) {
      var csBefore = beforeFiltered && beforeFiltered[index];
      if (csBefore && csBefore.colId !== csAfter.colId) {
        var gridCol = _this.getGridColumn(csBefore.colId);
        if (gridCol) {
          movedColumns.push(gridCol);
        }
      }
    });
    if (!movedColumns.length) {
      return;
    }
    var event = {
      type: Events.EVENT_COLUMN_MOVED,
      columns: movedColumns,
      column: null,
      api: this.gridApi,
      columnApi: this.columnApi,
      source: source
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.syncColumnWithStateItem = function (column, stateItem, defaultState, rowGroupIndexes, pivotIndexes, autoCol, source) {
    if (!column) {
      return;
    }
    var getValue = function getValue(key1, key2) {
      var stateAny = stateItem;
      var defaultAny = defaultState;
      var obj = {
        value1: undefined,
        value2: undefined
      };
      var calculated = false;
      if (stateAny) {
        if (stateAny[key1] !== undefined) {
          obj.value1 = stateAny[key1];
          calculated = true;
        }
        if (exists(key2) && stateAny[key2] !== undefined) {
          obj.value2 = stateAny[key2];
          calculated = true;
        }
      }
      if (!calculated && defaultAny) {
        if (defaultAny[key1] !== undefined) {
          obj.value1 = defaultAny[key1];
        }
        if (exists(key2) && defaultAny[key2] !== undefined) {
          obj.value2 = defaultAny[key2];
        }
      }
      return obj;
    };
    // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
    var hide = getValue('hide').value1;
    if (hide !== undefined) {
      column.setVisible(!hide, source);
    }
    // sets pinned to 'left' or 'right'
    var pinned = getValue('pinned').value1;
    if (pinned !== undefined) {
      column.setPinned(pinned);
    }
    // if width provided and valid, use it, otherwise stick with the old width
    var minColWidth = this.columnUtils.calculateColMinWidth(column.getColDef());
    // flex
    var flex = getValue('flex').value1;
    if (flex !== undefined) {
      column.setFlex(flex);
    }
    // width - we only set width if column is not flexing
    var noFlexThisCol = column.getFlex() <= 0;
    if (noFlexThisCol) {
      // both null and undefined means we skip, as it's not possible to 'clear' width (a column must have a width)
      var width = getValue('width').value1;
      if (width != null) {
        if (minColWidth != null && width >= minColWidth) {
          column.setActualWidth(width, source);
        }
      }
    }
    var sort = getValue('sort').value1;
    if (sort !== undefined) {
      if (sort === Constants.SORT_DESC || sort === Constants.SORT_ASC) {
        column.setSort(sort);
      } else {
        column.setSort(undefined);
      }
    }
    var sortIndex = getValue('sortIndex').value1;
    if (sortIndex !== undefined) {
      column.setSortIndex(sortIndex);
    }
    // we do not do aggFunc, rowGroup or pivot for auto cols, as you can't do these with auto col
    if (autoCol) {
      return;
    }
    var aggFunc = getValue('aggFunc').value1;
    if (aggFunc !== undefined) {
      if (typeof aggFunc === 'string') {
        column.setAggFunc(aggFunc);
        if (!column.isValueActive()) {
          column.setValueActive(true, source);
          this.valueColumns.push(column);
        }
      } else {
        if (exists(aggFunc)) {
          console.warn('AG Grid: stateItem.aggFunc must be a string. if using your own aggregation ' + 'functions, register the functions first before using them in get/set state. This is because it is ' + 'intended for the column state to be stored and retrieved as simple JSON.');
        }
        // Note: we do not call column.setAggFunc(null), so that next time we aggregate
        // by this column (eg drag teh column to the agg section int he toolpanel) it will
        // default to the last aggregation function.
        if (column.isValueActive()) {
          column.setValueActive(false, source);
          removeFromArray(this.valueColumns, column);
        }
      }
    }
    var _a = getValue('rowGroup', 'rowGroupIndex'),
      rowGroup = _a.value1,
      rowGroupIndex = _a.value2;
    if (rowGroup !== undefined || rowGroupIndex !== undefined) {
      if (typeof rowGroupIndex === 'number' || rowGroup) {
        if (!column.isRowGroupActive()) {
          column.setRowGroupActive(true, source);
          this.rowGroupColumns.push(column);
        }
        if (rowGroupIndexes && typeof rowGroupIndex === 'number') {
          rowGroupIndexes[column.getId()] = rowGroupIndex;
        }
      } else {
        if (column.isRowGroupActive()) {
          column.setRowGroupActive(false, source);
          removeFromArray(this.rowGroupColumns, column);
        }
      }
    }
    var _b = getValue('pivot', 'pivotIndex'),
      pivot = _b.value1,
      pivotIndex = _b.value2;
    if (pivot !== undefined || pivotIndex !== undefined) {
      if (typeof pivotIndex === 'number' || pivot) {
        if (!column.isPivotActive()) {
          column.setPivotActive(true, source);
          this.pivotColumns.push(column);
        }
        if (pivotIndexes && typeof pivotIndex === 'number') {
          pivotIndexes[column.getId()] = pivotIndex;
        }
      } else {
        if (column.isPivotActive()) {
          column.setPivotActive(false, source);
          removeFromArray(this.pivotColumns, column);
        }
      }
    }
  };
  ColumnModel.prototype.getGridColumns = function (keys) {
    return this.getColumns(keys, this.getGridColumn.bind(this));
  };
  ColumnModel.prototype.getColumns = function (keys, columnLookupCallback) {
    var foundColumns = [];
    if (keys) {
      keys.forEach(function (key) {
        var column = columnLookupCallback(key);
        if (column) {
          foundColumns.push(column);
        }
      });
    }
    return foundColumns;
  };
  // used by growGroupPanel
  ColumnModel.prototype.getColumnWithValidation = function (key) {
    if (key == null) {
      return null;
    }
    var column = this.getGridColumn(key);
    if (!column) {
      console.warn('AG Grid: could not find column ' + key);
    }
    return column;
  };
  ColumnModel.prototype.getPrimaryColumn = function (key) {
    if (!this.primaryColumns) {
      return null;
    }
    return this.getColumn(key, this.primaryColumns, this.primaryColumnsMap);
  };
  ColumnModel.prototype.getGridColumn = function (key) {
    return this.getColumn(key, this.gridColumns, this.gridColumnsMap);
  };
  ColumnModel.prototype.getColumn = function (key, columnList, columnMap) {
    if (!key) {
      return null;
    }
    // most of the time this method gets called the key is a string, so we put this shortcut in
    // for performance reasons, to see if we can match for ID (it doesn't do auto columns, that's done below)
    if (typeof key == 'string' && columnMap[key]) {
      return columnMap[key];
    }
    for (var i = 0; i < columnList.length; i++) {
      if (this.columnsMatch(columnList[i], key)) {
        return columnList[i];
      }
    }
    return this.getAutoColumn(key);
  };
  ColumnModel.prototype.getAutoColumn = function (key) {
    var _this = this;
    if (!this.groupAutoColumns || !exists(this.groupAutoColumns) || missing(this.groupAutoColumns)) {
      return null;
    }
    return find$3(this.groupAutoColumns, function (groupCol) {
      return _this.columnsMatch(groupCol, key);
    });
  };
  ColumnModel.prototype.columnsMatch = function (column, key) {
    var columnMatches = column === key;
    var colDefMatches = column.getColDef() === key;
    var idMatches = column.getColId() == key;
    return columnMatches || colDefMatches || idMatches;
  };
  ColumnModel.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
    if (includeAggFunc === void 0) {
      includeAggFunc = false;
    }
    if (!column) {
      return null;
    }
    var headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
    if (includeAggFunc) {
      return this.wrapHeaderNameWithAggFunc(column, headerName);
    }
    return headerName;
  };
  ColumnModel.prototype.getDisplayNameForOriginalColumnGroup = function (columnGroup, originalColumnGroup, location) {
    var colGroupDef = originalColumnGroup ? originalColumnGroup.getColGroupDef() : null;
    if (colGroupDef) {
      return this.getHeaderName(colGroupDef, null, columnGroup, originalColumnGroup, location);
    }
    return null;
  };
  ColumnModel.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
    return this.getDisplayNameForOriginalColumnGroup(columnGroup, columnGroup.getOriginalColumnGroup(), location);
  };
  // location is where the column is going to appear, ie who is calling us
  ColumnModel.prototype.getHeaderName = function (colDef, column, columnGroup, originalColumnGroup, location) {
    var headerValueGetter = colDef.headerValueGetter;
    if (headerValueGetter) {
      var params = {
        colDef: colDef,
        column: column,
        columnGroup: columnGroup,
        originalColumnGroup: originalColumnGroup,
        location: location,
        api: this.gridOptionsWrapper.getApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      if (typeof headerValueGetter === 'function') {
        // valueGetter is a function, so just call it
        return headerValueGetter(params);
      } else if (typeof headerValueGetter === 'string') {
        // valueGetter is an expression, so execute the expression
        return this.expressionService.evaluate(headerValueGetter, params);
      }
      console.warn('ag-grid: headerValueGetter must be a function or a string');
      return '';
    } else if (colDef.headerName != null) {
      return colDef.headerName;
    } else if (colDef.field) {
      return camelCaseToHumanText(colDef.field);
    }
    return '';
  };
  ColumnModel.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
    if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
      return headerName;
    }
    // only columns with aggregation active can have aggregations
    var pivotValueColumn = column.getColDef().pivotValueColumn;
    var pivotActiveOnThisColumn = exists(pivotValueColumn);
    var aggFunc = null;
    var aggFuncFound;
    // otherwise we have a measure that is active, and we are doing aggregation on it
    if (pivotActiveOnThisColumn) {
      aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
      aggFuncFound = true;
    } else {
      var measureActive = column.isValueActive();
      var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
      if (measureActive && aggregationPresent) {
        aggFunc = column.getAggFunc();
        aggFuncFound = true;
      } else {
        aggFuncFound = false;
      }
    }
    if (aggFuncFound) {
      var aggFuncString = typeof aggFunc === 'string' ? aggFunc : 'func';
      var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
      var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
      return aggFuncStringTranslated + "(" + headerName + ")";
    }
    return headerName;
  };
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  ColumnModel.prototype.getColumnGroup = function (colId, instanceId) {
    if (!colId) {
      return null;
    }
    if (colId instanceof ColumnGroup) {
      return colId;
    }
    var allColumnGroups = this.getAllDisplayedTrees();
    var checkInstanceId = typeof instanceId === 'number';
    var result = null;
    this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
      if (child instanceof ColumnGroup) {
        var columnGroup = child;
        var matched = void 0;
        if (checkInstanceId) {
          matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
        } else {
          matched = colId === columnGroup.getGroupId();
        }
        if (matched) {
          result = columnGroup;
        }
      }
    });
    return result;
  };
  ColumnModel.prototype.isReady = function () {
    return this.ready;
  };
  ColumnModel.prototype.extractValueColumns = function (source, oldPrimaryColumns) {
    this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, function (col, flag) {
      return col.setValueActive(flag, source);
    },
    // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
    function () {
      return undefined;
    }, function () {
      return undefined;
    },
    // aggFunc is a string, so return it's existence
    function (colDef) {
      var aggFunc = colDef.aggFunc;
      // null or empty string means clear
      if (aggFunc === null || aggFunc === '') {
        return null;
      }
      if (aggFunc === undefined) {
        return;
      }
      return !!aggFunc;
    }, function (colDef) {
      // return false if any of the following: null, undefined, empty string
      return colDef.initialAggFunc != null && colDef.initialAggFunc != '';
    });
    // all new columns added will have aggFunc missing, so set it to what is in the colDef
    this.valueColumns.forEach(function (col) {
      var colDef = col.getColDef();
      // if aggFunc provided, we always override, as reactive property
      if (colDef.aggFunc != null && colDef.aggFunc != '') {
        col.setAggFunc(colDef.aggFunc);
      } else {
        // otherwise we use initialAggFunc only if no agg func set - which happens when new column only
        if (!col.getAggFunc()) {
          col.setAggFunc(colDef.initialAggFunc);
        }
      }
    });
  };
  ColumnModel.prototype.extractRowGroupColumns = function (source, oldPrimaryColumns) {
    this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, function (col, flag) {
      return col.setRowGroupActive(flag, source);
    }, function (colDef) {
      return colDef.rowGroupIndex;
    }, function (colDef) {
      return colDef.initialRowGroupIndex;
    }, function (colDef) {
      return colDef.rowGroup;
    }, function (colDef) {
      return colDef.initialRowGroup;
    });
  };
  ColumnModel.prototype.extractColumns = function (oldPrimaryColumns, previousCols, setFlagFunc, getIndexFunc, getInitialIndexFunc, getValueFunc, getInitialValueFunc) {
    if (oldPrimaryColumns === void 0) {
      oldPrimaryColumns = [];
    }
    if (previousCols === void 0) {
      previousCols = [];
    }
    var colsWithIndex = [];
    var colsWithValue = [];
    // go though all cols.
    // if value, change
    // if default only, change only if new
    (this.primaryColumns || []).forEach(function (col) {
      var colIsNew = oldPrimaryColumns.indexOf(col) < 0;
      var colDef = col.getColDef();
      var value = attrToBoolean(getValueFunc(colDef));
      var initialValue = attrToBoolean(getInitialValueFunc(colDef));
      var index = attrToNumber(getIndexFunc(colDef));
      var initialIndex = attrToNumber(getInitialIndexFunc(colDef));
      var include;
      var valuePresent = value !== undefined;
      var indexPresent = index !== undefined;
      var initialValuePresent = initialValue !== undefined;
      var initialIndexPresent = initialIndex !== undefined;
      if (valuePresent) {
        include = value; // boolean value is guaranteed as attrToBoolean() is used above
      } else if (indexPresent) {
        if (index === null) {
          // if col is new we don't want to use the default / initial if index is set to null. Similarly,
          // we don't want to include the property for existing columns, i.e. we want to 'clear' it.
          include = false;
        } else {
          // note that 'null >= 0' evaluates to true which means 'rowGroupIndex = null' would enable row
          // grouping if the null check didn't exist above.
          include = index >= 0;
        }
      } else {
        if (colIsNew) {
          // as no value or index is 'present' we use the default / initial when col is new
          if (initialValuePresent) {
            include = initialValue;
          } else if (initialIndexPresent) {
            include = initialIndex != null && initialIndex >= 0;
          } else {
            include = false;
          }
        } else {
          // otherwise include it if included last time, e.g. if we are extracting row group cols and this col
          // is an existing row group col (i.e. it exists in 'previousCols') then we should include it.
          include = previousCols.indexOf(col) >= 0;
        }
      }
      if (include) {
        var useIndex = colIsNew ? index != null || initialIndex != null : index != null;
        useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
      }
    });
    var getIndexForCol = function getIndexForCol(col) {
      var index = getIndexFunc(col.getColDef());
      var defaultIndex = getInitialIndexFunc(col.getColDef());
      return index != null ? index : defaultIndex;
    };
    // sort cols with index, and add these first
    colsWithIndex.sort(function (colA, colB) {
      var indexA = getIndexForCol(colA);
      var indexB = getIndexForCol(colB);
      if (indexA === indexB) {
        return 0;
      }
      if (indexA < indexB) {
        return -1;
      }
      return 1;
    });
    var res = [].concat(colsWithIndex);
    // second add columns that were there before and in the same order as they were before,
    // so we are preserving order of current grouping of columns that simply have rowGroup=true
    previousCols.forEach(function (col) {
      if (colsWithValue.indexOf(col) >= 0) {
        res.push(col);
      }
    });
    // lastly put in all remaining cols
    colsWithValue.forEach(function (col) {
      if (res.indexOf(col) < 0) {
        res.push(col);
      }
    });
    // set flag=false for removed cols
    previousCols.forEach(function (col) {
      if (res.indexOf(col) < 0) {
        setFlagFunc(col, false);
      }
    });
    // set flag=true for newly added cols
    res.forEach(function (col) {
      if (previousCols.indexOf(col) < 0) {
        setFlagFunc(col, true);
      }
    });
    return res;
  };
  ColumnModel.prototype.extractPivotColumns = function (source, oldPrimaryColumns) {
    this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, function (col, flag) {
      return col.setPivotActive(flag, source);
    }, function (colDef) {
      return colDef.pivotIndex;
    }, function (colDef) {
      return colDef.initialPivotIndex;
    }, function (colDef) {
      return colDef.pivot;
    }, function (colDef) {
      return colDef.initialPivot;
    });
  };
  ColumnModel.prototype.resetColumnGroupState = function (source) {
    if (source === void 0) {
      source = "api";
    }
    var stateItems = [];
    this.columnUtils.depthFirstOriginalTreeSearch(null, this.primaryColumnTree, function (child) {
      if (child instanceof ProvidedColumnGroup) {
        var colGroupDef = child.getColGroupDef();
        var groupState = {
          groupId: child.getGroupId(),
          open: !colGroupDef ? undefined : colGroupDef.openByDefault
        };
        stateItems.push(groupState);
      }
    });
    this.setColumnGroupState(stateItems, source);
  };
  ColumnModel.prototype.getColumnGroupState = function () {
    var columnGroupState = [];
    this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
      if (node instanceof ProvidedColumnGroup) {
        var originalColumnGroup = node;
        columnGroupState.push({
          groupId: originalColumnGroup.getGroupId(),
          open: originalColumnGroup.isExpanded()
        });
      }
    });
    return columnGroupState;
  };
  ColumnModel.prototype.setColumnGroupState = function (stateItems, source) {
    var _this = this;
    if (source === void 0) {
      source = "api";
    }
    this.columnAnimationService.start();
    var impactedGroups = [];
    stateItems.forEach(function (stateItem) {
      var groupKey = stateItem.groupId;
      var newValue = stateItem.open;
      var originalColumnGroup = _this.getOriginalColumnGroup(groupKey);
      if (!originalColumnGroup) {
        return;
      }
      if (originalColumnGroup.isExpanded() === newValue) {
        return;
      }
      _this.logger.log('columnGroupOpened(' + originalColumnGroup.getGroupId() + ',' + newValue + ')');
      originalColumnGroup.setExpanded(newValue);
      impactedGroups.push(originalColumnGroup);
    });
    this.updateGroupsAndDisplayedColumns(source);
    this.setFirstRightAndLastLeftPinned(source);
    impactedGroups.forEach(function (originalColumnGroup) {
      var event = {
        type: Events.EVENT_COLUMN_GROUP_OPENED,
        columnGroup: originalColumnGroup,
        api: _this.gridApi,
        columnApi: _this.columnApi
      };
      _this.eventService.dispatchEvent(event);
    });
    this.columnAnimationService.finish();
  };
  // called by headerRenderer - when a header is opened or closed
  ColumnModel.prototype.setColumnGroupOpened = function (key, newValue, source) {
    if (source === void 0) {
      source = "api";
    }
    var keyAsString;
    if (key instanceof ProvidedColumnGroup) {
      keyAsString = key.getId();
    } else {
      keyAsString = key || '';
    }
    this.setColumnGroupState([{
      groupId: keyAsString,
      open: newValue
    }], source);
  };
  ColumnModel.prototype.getOriginalColumnGroup = function (key) {
    if (key instanceof ProvidedColumnGroup) {
      return key;
    }
    if (typeof key !== 'string') {
      console.error('AG Grid: group key must be a string');
    }
    // otherwise, search for the column group by id
    var res = null;
    this.columnUtils.depthFirstOriginalTreeSearch(null, this.gridBalancedTree, function (node) {
      if (node instanceof ProvidedColumnGroup) {
        var originalColumnGroup = node;
        if (originalColumnGroup.getId() === key) {
          res = originalColumnGroup;
        }
      }
    });
    return res;
  };
  ColumnModel.prototype.calculateColumnsForDisplay = function () {
    var _this = this;
    var columnsForDisplay;
    if (this.pivotMode && !this.secondaryColumnsPresent) {
      // pivot mode is on, but we are not pivoting, so we only
      // show columns we are aggregating on
      columnsForDisplay = this.gridColumns.filter(function (column) {
        var isAutoGroupCol = _this.groupAutoColumns && includes(_this.groupAutoColumns, column);
        var isValueCol = _this.valueColumns && includes(_this.valueColumns, column);
        return isAutoGroupCol || isValueCol;
      });
    } else {
      // otherwise continue as normal. this can be working on the primary
      // or secondary columns, whatever the gridColumns are set to
      columnsForDisplay = this.gridColumns.filter(function (column) {
        // keep col if a) it's auto-group or b) it's visible
        var isAutoGroupCol = _this.groupAutoColumns && includes(_this.groupAutoColumns, column);
        return isAutoGroupCol || column.isVisible();
      });
    }
    return columnsForDisplay;
  };
  ColumnModel.prototype.checkColSpanActiveInCols = function (columns) {
    var result = false;
    columns.forEach(function (col) {
      if (exists(col.getColDef().colSpan)) {
        result = true;
      }
    });
    return result;
  };
  ColumnModel.prototype.calculateColumnsForGroupDisplay = function () {
    var _this = this;
    this.groupDisplayColumns = [];
    var checkFunc = function checkFunc(col) {
      var colDef = col.getColDef();
      if (colDef && exists(colDef.showRowGroup)) {
        _this.groupDisplayColumns.push(col);
      }
    };
    this.gridColumns.forEach(checkFunc);
    if (this.groupAutoColumns) {
      this.groupAutoColumns.forEach(checkFunc);
    }
  };
  ColumnModel.prototype.getGroupDisplayColumns = function () {
    return this.groupDisplayColumns;
  };
  ColumnModel.prototype.updateDisplayedColumns = function (source) {
    var columnsForDisplay = this.calculateColumnsForDisplay();
    this.buildDisplayedTrees(columnsForDisplay);
    this.calculateColumnsForGroupDisplay();
    // also called when group opened/closed
    this.updateGroupsAndDisplayedColumns(source);
    // also called when group opened/closed
    this.setFirstRightAndLastLeftPinned(source);
  };
  ColumnModel.prototype.isSecondaryColumnsPresent = function () {
    return this.secondaryColumnsPresent;
  };
  ColumnModel.prototype.setSecondaryColumns = function (colDefs, source) {
    if (source === void 0) {
      source = "api";
    }
    var newColsPresent = colDefs && colDefs.length > 0;
    // if not cols passed, and we had to cols anyway, then do nothing
    if (!newColsPresent && !this.secondaryColumnsPresent) {
      return;
    }
    if (newColsPresent) {
      this.processSecondaryColumnDefinitions(colDefs);
      var balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false);
      this.secondaryBalancedTree = balancedTreeResult.columnTree;
      this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
      this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
      this.secondaryColumnsPresent = true;
    } else {
      this.secondaryBalancedTree = null;
      this.secondaryHeaderRowCount = -1;
      this.secondaryColumns = null;
      this.secondaryColumnsPresent = false;
    }
    this.updateGridColumns();
    this.updateDisplayedColumns(source);
  };
  ColumnModel.prototype.processSecondaryColumnDefinitions = function (colDefs) {
    var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
    var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
    if (!columnCallback && !groupCallback) {
      return undefined;
    }
    var searchForColDefs = function searchForColDefs(colDefs2) {
      colDefs2.forEach(function (abstractColDef) {
        var isGroup = exists(abstractColDef.children);
        if (isGroup) {
          var colGroupDef = abstractColDef;
          if (groupCallback) {
            groupCallback(colGroupDef);
          }
          searchForColDefs(colGroupDef.children);
        } else {
          var colDef = abstractColDef;
          if (columnCallback) {
            columnCallback(colDef);
          }
        }
      });
    };
    if (colDefs) {
      searchForColDefs(colDefs);
    }
  };
  // called from: setColumnState, setColumnDefs, setSecondaryColumns
  ColumnModel.prototype.updateGridColumns = function () {
    var _this = this;
    if (this.gridColsArePrimary) {
      this.lastPrimaryOrder = this.gridColumns;
    }
    if (this.secondaryColumns && this.secondaryBalancedTree) {
      this.gridBalancedTree = this.secondaryBalancedTree.slice();
      this.gridHeaderRowCount = this.secondaryHeaderRowCount;
      this.gridColumns = this.secondaryColumns.slice();
      this.gridColsArePrimary = false;
    } else if (this.primaryColumns) {
      this.gridBalancedTree = this.primaryColumnTree.slice();
      this.gridHeaderRowCount = this.primaryHeaderRowCount;
      this.gridColumns = this.primaryColumns.slice();
      this.gridColsArePrimary = true;
      // updateGridColumns gets called after user adds a row group. we want to maintain the order of the columns
      // when this happens (eg if user moved a column) rather than revert back to the original column order.
      // likewise if changing in/out of pivot mode, we want to maintain the order of the primary cols
      this.orderGridColsLikeLastPrimary();
    }
    this.addAutoGroupToGridColumns();
    this.gridColumns = this.putFixedColumnsFirst(this.gridColumns);
    this.setupQuickFilterColumns();
    this.clearDisplayedAndViewportColumns();
    this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
    this.gridColumnsMap = {};
    this.gridColumns.forEach(function (col) {
      return _this.gridColumnsMap[col.getId()] = col;
    });
    this.setAutoHeightActive();
    var event = {
      type: Events.EVENT_GRID_COLUMNS_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.setAutoHeightActive = function () {
    this.autoHeightActive = this.gridColumns.filter(function (col) {
      return col.getColDef().autoHeight;
    }).length > 0;
    if (this.autoHeightActive) {
      this.autoHeightActiveAtLeastOnce = true;
      var rowModelType = this.rowModel.getType();
      var supportedRowModel = rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE || rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE;
      if (!supportedRowModel) {
        var message_1 = 'AG Grid - autoHeight columns only work with Client Side Row Model and Server Side Row Model.';
        doOnce(function () {
          return console.warn(message_1);
        }, 'autoHeightActive.wrongRowModel');
      }
    }
  };
  ColumnModel.prototype.orderGridColsLikeLastPrimary = function () {
    if (missing(this.lastPrimaryOrder)) {
      return;
    }
    var lastPrimaryOrderMapped = convertToMap(this.lastPrimaryOrder.map(function (col, index) {
      return [col, index];
    }));
    // only do the sort if at least one column is accounted for. columns will be not accounted for
    // if changing from secondary to primary columns
    var noColsFound = true;
    this.gridColumns.forEach(function (col) {
      if (lastPrimaryOrderMapped.has(col)) {
        noColsFound = false;
      }
    });
    if (noColsFound) {
      return;
    }
    // order cols in the same order as before. we need to make sure that all
    // cols still exists, so filter out any that no longer exist.
    var gridColsMap = convertToMap(this.gridColumns.map(function (col) {
      return [col, true];
    }));
    var oldColsOrdered = this.lastPrimaryOrder.filter(function (col) {
      return gridColsMap.has(col);
    });
    var oldColsMap = convertToMap(oldColsOrdered.map(function (col) {
      return [col, true];
    }));
    var newColsOrdered = this.gridColumns.filter(function (col) {
      return !oldColsMap.has(col);
    });
    // add in the new columns, at the end (if no group), or at the end of the group (if a group)
    var newGridColumns = oldColsOrdered.slice();
    newColsOrdered.forEach(function (newCol) {
      var parent = newCol.getOriginalParent();
      // if no parent, means we are not grouping, so just add the column to the end
      if (!parent) {
        newGridColumns.push(newCol);
        return;
      }
      // find the group the column belongs to. if no siblings at the current level (eg col in group on it's
      // own) then go up one level and look for siblings there.
      var siblings = [];
      while (!siblings.length && parent) {
        var leafCols = parent.getLeafColumns();
        leafCols.forEach(function (leafCol) {
          var presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
          var noYetInSiblings = siblings.indexOf(leafCol) < 0;
          if (presentInNewGriColumns && noYetInSiblings) {
            siblings.push(leafCol);
          }
        });
        parent = parent.getOriginalParent();
      }
      // if no siblings exist at any level, this means the col is in a group (or parent groups) on it's own
      if (!siblings.length) {
        newGridColumns.push(newCol);
        return;
      }
      // find index of last column in the group
      var indexes = siblings.map(function (col) {
        return newGridColumns.indexOf(col);
      });
      var lastIndex = Math.max.apply(Math, indexes);
      insertIntoArray(newGridColumns, newCol, lastIndex + 1);
    });
    this.gridColumns = newGridColumns;
  };
  ColumnModel.prototype.isPrimaryColumnGroupsPresent = function () {
    return this.primaryHeaderRowCount > 1;
  };
  // if we are using autoGroupCols, then they should be included for quick filter. this covers the
  // following scenarios:
  // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
  // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
  //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
  ColumnModel.prototype.setupQuickFilterColumns = function () {
    if (this.groupAutoColumns) {
      this.columnsForQuickFilter = (this.primaryColumns || []).concat(this.groupAutoColumns);
    } else if (this.primaryColumns) {
      this.columnsForQuickFilter = this.primaryColumns;
    }
  };
  ColumnModel.prototype.putFixedColumnsFirst = function (cols) {
    var locked = cols.filter(function (c) {
      return c.getColDef().lockPosition;
    });
    var unlocked = cols.filter(function (c) {
      return !c.getColDef().lockPosition;
    });
    return locked.concat(unlocked);
  };
  ColumnModel.prototype.addAutoGroupToGridColumns = function () {
    // add in auto-group here
    this.createGroupAutoColumnsIfNeeded();
    if (missing(this.groupAutoColumns)) {
      return;
    }
    this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
    var autoColBalancedTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
    this.gridBalancedTree = autoColBalancedTree.concat(this.gridBalancedTree);
  };
  // gets called after we copy down grid columns, to make sure any part of the gui
  // that tries to draw, eg the header, it will get empty lists of columns rather
  // than stale columns. for example, the header will received gridColumnsChanged
  // event, so will try and draw, but it will draw successfully when it acts on the
  // virtualColumnsChanged event
  ColumnModel.prototype.clearDisplayedAndViewportColumns = function () {
    this.displayedTreeLeft = [];
    this.displayedTreeRight = [];
    this.displayedTreeCentre = [];
    this.viewportRowLeft = {};
    this.viewportRowRight = {};
    this.viewportRowCenter = {};
    this.displayedColumnsLeft = [];
    this.displayedColumnsRight = [];
    this.displayedColumnsCenter = [];
    this.displayedColumns = [];
    this.viewportColumns = [];
  };
  ColumnModel.prototype.updateGroupsAndDisplayedColumns = function (source) {
    this.updateOpenClosedVisibilityInColumnGroups();
    this.deriveDisplayedColumns(source);
    this.refreshFlexedColumns();
    this.extractViewport();
    this.updateBodyWidths();
    // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
    var event = {
      type: Events.EVENT_DISPLAYED_COLUMNS_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnModel.prototype.deriveDisplayedColumns = function (source) {
    this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft);
    this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter);
    this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight);
    this.joinDisplayedColumns();
    this.setLeftValues(source);
    this.displayedAutoHeightCols = this.displayedColumns.filter(function (col) {
      return col.getColDef().autoHeight;
    });
  };
  ColumnModel.prototype.isAutoRowHeightActive = function () {
    return this.autoHeightActive;
  };
  ColumnModel.prototype.wasAutoRowHeightEverActive = function () {
    return this.autoHeightActiveAtLeastOnce;
  };
  ColumnModel.prototype.joinDisplayedColumns = function () {
    if (this.gridOptionsWrapper.isEnableRtl()) {
      this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft);
    } else {
      this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
    }
  };
  // sets the left pixel position of each column
  ColumnModel.prototype.setLeftValues = function (source) {
    this.setLeftValuesOfColumns(source);
    this.setLeftValuesOfGroups();
  };
  ColumnModel.prototype.setLeftValuesOfColumns = function (source) {
    var _this = this;
    if (!this.primaryColumns) {
      return;
    }
    // go through each list of displayed columns
    var allColumns = this.primaryColumns.slice(0);
    // let totalColumnWidth = this.getWidthOfColsInList()
    var doingRtl = this.gridOptionsWrapper.isEnableRtl();
    [this.displayedColumnsLeft, this.displayedColumnsRight, this.displayedColumnsCenter].forEach(function (columns) {
      if (doingRtl) {
        // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
        var left_1 = _this.getWidthOfColsInList(columns);
        columns.forEach(function (column) {
          left_1 -= column.getActualWidth();
          column.setLeft(left_1, source);
        });
      } else {
        // otherwise normal LTR, we start at zero
        var left_2 = 0;
        columns.forEach(function (column) {
          column.setLeft(left_2, source);
          left_2 += column.getActualWidth();
        });
      }
      removeAllFromArray(allColumns, columns);
    });
    // items left in allColumns are columns not displayed, so remove the left position. this is
    // important for the rows, as if a col is made visible, then taken out, then made visible again,
    // we don't want the animation of the cell floating in from the old position, whatever that was.
    allColumns.forEach(function (column) {
      column.setLeft(null, source);
    });
  };
  ColumnModel.prototype.setLeftValuesOfGroups = function () {
    // a groups left value is the lest left value of it's children
    [this.displayedTreeLeft, this.displayedTreeRight, this.displayedTreeCentre].forEach(function (columns) {
      columns.forEach(function (column) {
        if (column instanceof ColumnGroup) {
          var columnGroup = column;
          columnGroup.checkLeft();
        }
      });
    });
  };
  ColumnModel.prototype.derivedDisplayedColumnsFromDisplayedTree = function (tree, columns) {
    columns.length = 0;
    this.columnUtils.depthFirstDisplayedColumnTreeSearch(tree, function (child) {
      if (child instanceof Column) {
        columns.push(child);
      }
    });
  };
  ColumnModel.prototype.extractViewportColumns = function () {
    if (this.suppressColumnVirtualisation) {
      // no virtualisation, so don't filter
      this.viewportColumnsCenter = this.displayedColumnsCenter;
    } else {
      // filter out what should be visible
      this.viewportColumnsCenter = this.filterOutColumnsWithinViewport();
    }
    this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
  };
  ColumnModel.prototype.getVirtualHeaderGroupRow = function (type, dept) {
    var result;
    switch (type) {
      case Constants.PINNED_LEFT:
        result = this.viewportRowLeft[dept];
        break;
      case Constants.PINNED_RIGHT:
        result = this.viewportRowRight[dept];
        break;
      default:
        result = this.viewportRowCenter[dept];
        break;
    }
    if (missing(result)) {
      result = [];
    }
    return result;
  };
  ColumnModel.prototype.extractViewportRows = function () {
    // go through each group, see if any of it's cols are displayed, and if yes,
    // then this group is included
    this.viewportRowLeft = {};
    this.viewportRowRight = {};
    this.viewportRowCenter = {};
    // for easy lookup when building the groups.
    var virtualColIds = {};
    this.viewportColumns.forEach(function (col) {
      return virtualColIds[col.getId()] = true;
    });
    var testGroup = function testGroup(children, result, dept) {
      var returnValue = false;
      for (var i = 0; i < children.length; i++) {
        // see if this item is within viewport
        var child = children[i];
        var addThisItem = false;
        if (child instanceof Column) {
          // for column, test if column is included
          addThisItem = virtualColIds[child.getId()] === true;
        } else {
          // if group, base decision on children
          var columnGroup = child;
          var displayedChildren = columnGroup.getDisplayedChildren();
          if (displayedChildren) {
            addThisItem = testGroup(displayedChildren, result, dept + 1);
          }
        }
        if (addThisItem) {
          returnValue = true;
          if (!result[dept]) {
            result[dept] = [];
          }
          result[dept].push(child);
        }
      }
      return returnValue;
    };
    testGroup(this.displayedTreeLeft, this.viewportRowLeft, 0);
    testGroup(this.displayedTreeRight, this.viewportRowRight, 0);
    testGroup(this.displayedTreeCentre, this.viewportRowCenter, 0);
  };
  ColumnModel.prototype.extractViewport = function () {
    this.extractViewportColumns();
    this.extractViewportRows();
  };
  ColumnModel.prototype.filterOutColumnsWithinViewport = function () {
    return this.displayedColumnsCenter.filter(this.isColumnInViewport.bind(this));
  };
  ColumnModel.prototype.refreshFlexedColumns = function (params) {
    var _this = this;
    if (params === void 0) {
      params = {};
    }
    var source = params.source ? params.source : 'flex';
    if (params.viewportWidth != null) {
      this.flexViewportWidth = params.viewportWidth;
    }
    if (!this.flexViewportWidth) {
      return [];
    }
    // If the grid has left-over space, divide it between flexing columns in proportion to their flex value.
    // A "flexing column" is one that has a 'flex' value set and is not currently being constrained by its
    // minWidth or maxWidth rules.
    var flexAfterDisplayIndex = -1;
    if (params.resizingCols) {
      params.resizingCols.forEach(function (col) {
        var indexOfCol = _this.displayedColumnsCenter.indexOf(col);
        if (flexAfterDisplayIndex < indexOfCol) {
          flexAfterDisplayIndex = indexOfCol;
        }
      });
    }
    var isColFlex = function isColFlex(col) {
      var afterResizingCols = _this.displayedColumnsCenter.indexOf(col) > flexAfterDisplayIndex;
      return col.getFlex() && afterResizingCols;
    };
    var knownWidthColumns = this.displayedColumnsCenter.filter(function (col) {
      return !isColFlex(col);
    });
    var flexingColumns = this.displayedColumnsCenter.filter(function (col) {
      return isColFlex(col);
    });
    var changedColumns = [];
    if (!flexingColumns.length) {
      return [];
    }
    var flexingColumnSizes = [];
    var spaceForFlexingColumns;
    outer: while (true) {
      var totalFlex = flexingColumns.reduce(function (count, col) {
        return count + col.getFlex();
      }, 0);
      spaceForFlexingColumns = this.flexViewportWidth - this.getWidthOfColsInList(knownWidthColumns);
      for (var i = 0; i < flexingColumns.length; i++) {
        var col = flexingColumns[i];
        var widthByFlexRule = spaceForFlexingColumns * col.getFlex() / totalFlex;
        var constrainedWidth = 0;
        var minWidth = col.getMinWidth();
        var maxWidth = col.getMaxWidth();
        if (exists(minWidth) && widthByFlexRule < minWidth) {
          constrainedWidth = minWidth;
        } else if (exists(maxWidth) && widthByFlexRule > maxWidth) {
          constrainedWidth = maxWidth;
        }
        if (constrainedWidth) {
          // This column is not in fact flexing as it is being constrained to a specific size
          // so remove it from the list of flexing columns and start again
          col.setActualWidth(constrainedWidth, source);
          removeFromArray(flexingColumns, col);
          changedColumns.push(col);
          knownWidthColumns.push(col);
          continue outer;
        }
        flexingColumnSizes[i] = Math.round(widthByFlexRule);
      }
      break;
    }
    var remainingSpace = spaceForFlexingColumns;
    flexingColumns.forEach(function (col, i) {
      col.setActualWidth(Math.min(flexingColumnSizes[i], remainingSpace), source);
      changedColumns.push(col);
      remainingSpace -= flexingColumnSizes[i];
    });
    if (!params.skipSetLeft) {
      this.setLeftValues(source);
    }
    if (params.updateBodyWidths) {
      this.updateBodyWidths();
    }
    if (params.fireResizedEvent) {
      this.fireColumnResizedEvent(changedColumns, true, source, flexingColumns);
    }
    // if the user sets rowData directly into GridOptions, then the row data is set before
    // grid is attached to the DOM. this means the columns are not flexed, and then the rows
    // have the wrong height (as they depend on column widths). so once the columns have
    // been flexed for the first time (only happens once grid is attached to DOM, as dependency
    // on getting the grid width, which only happens after attached after ResizeObserver fires)
    // we get get rows to re-calc their heights.
    if (!this.flexColsCalculatedAtLestOnce) {
      if (this.gridOptionsWrapper.isRowModelDefault()) {
        this.rowModel.resetRowHeights();
      }
      this.flexColsCalculatedAtLestOnce = true;
    }
    return flexingColumns;
  };
  // called from api
  ColumnModel.prototype.sizeColumnsToFit = function (gridWidth, source, silent) {
    if (source === void 0) {
      source = "sizeColumnsToFit";
    }
    // avoid divide by zero
    var allDisplayedColumns = this.getAllDisplayedColumns();
    if (gridWidth <= 0 || !allDisplayedColumns.length) {
      return;
    }
    var colsToSpread = [];
    var colsToNotSpread = [];
    allDisplayedColumns.forEach(function (column) {
      if (column.getColDef().suppressSizeToFit === true) {
        colsToNotSpread.push(column);
      } else {
        colsToSpread.push(column);
      }
    });
    // make a copy of the cols that are going to be resized
    var colsToFireEventFor = colsToSpread.slice(0);
    var finishedResizing = false;
    var moveToNotSpread = function moveToNotSpread(column) {
      removeFromArray(colsToSpread, column);
      colsToNotSpread.push(column);
    };
    // resetting cols to their original width makes the sizeColumnsToFit more deterministic,
    // rather than depending on the current size of the columns. most users call sizeColumnsToFit
    // immediately after grid is created, so will make no difference. however if application is calling
    // sizeColumnsToFit repeatedly (eg after column group is opened / closed repeatedly) we don't want
    // the columns to start shrinking / growing over time.
    //
    // NOTE: the process below will assign values to `this.actualWidth` of each column without firing events
    // for this reason we need to manually fire resize events after the resize has been done for each column.
    colsToSpread.forEach(function (column) {
      return column.resetActualWidth(source);
    });
    while (!finishedResizing) {
      finishedResizing = true;
      var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
      if (availablePixels <= 0) {
        // no width, set everything to minimum
        colsToSpread.forEach(function (column) {
          column.setMinimum(source);
        });
      } else {
        var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
        // we set the pixels for the last col based on what's left, as otherwise
        // we could be a pixel or two short or extra because of rounding errors.
        var pixelsForLastCol = availablePixels;
        // backwards through loop, as we are removing items as we go
        for (var i = colsToSpread.length - 1; i >= 0; i--) {
          var column = colsToSpread[i];
          var minWidth = column.getMinWidth();
          var maxWidth = column.getMaxWidth();
          var newWidth = Math.round(column.getActualWidth() * scale);
          if (exists(minWidth) && newWidth < minWidth) {
            newWidth = minWidth;
            moveToNotSpread(column);
            finishedResizing = false;
          } else if (exists(maxWidth) && column.isGreaterThanMax(newWidth)) {
            newWidth = maxWidth;
            moveToNotSpread(column);
            finishedResizing = false;
          } else if (i === 0) {
            // if this is the last column
            newWidth = pixelsForLastCol;
          }
          column.setActualWidth(newWidth, source, true);
          pixelsForLastCol -= newWidth;
        }
      }
    }
    // see notes above
    colsToFireEventFor.forEach(function (col) {
      col.fireColumnWidthChangedEvent(source);
    });
    this.setLeftValues(source);
    this.updateBodyWidths();
    if (silent) {
      return;
    }
    this.fireColumnResizedEvent(colsToFireEventFor, true, source);
  };
  ColumnModel.prototype.buildDisplayedTrees = function (visibleColumns) {
    var leftVisibleColumns = [];
    var rightVisibleColumns = [];
    var centerVisibleColumns = [];
    visibleColumns.forEach(function (column) {
      switch (column.getPinned()) {
        case "left":
          leftVisibleColumns.push(column);
          break;
        case "right":
          rightVisibleColumns.push(column);
          break;
        default:
          centerVisibleColumns.push(column);
          break;
      }
    });
    var groupInstanceIdCreator = new GroupInstanceIdCreator();
    this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, Constants.PINNED_LEFT, this.displayedTreeLeft);
    this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, Constants.PINNED_RIGHT, this.displayedTreeRight);
    this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator, null, this.displayedTreeCentre);
    this.updateDisplayedMap();
  };
  ColumnModel.prototype.updateDisplayedMap = function () {
    var _this = this;
    this.displayedColumnsAndGroupsMap = {};
    var func = function func(child) {
      _this.displayedColumnsAndGroupsMap[child.getUniqueId()] = child;
    };
    this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeCentre, func);
    this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeLeft, func);
    this.columnUtils.depthFirstAllColumnTreeSearch(this.displayedTreeRight, func);
  };
  ColumnModel.prototype.isDisplayed = function (item) {
    var fromMap = this.displayedColumnsAndGroupsMap[item.getUniqueId()];
    // check for reference, in case new column / group with same id is now present
    return fromMap === item;
  };
  ColumnModel.prototype.updateOpenClosedVisibilityInColumnGroups = function () {
    var allColumnGroups = this.getAllDisplayedTrees();
    this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
      if (child instanceof ColumnGroup) {
        var columnGroup = child;
        columnGroup.calculateDisplayedColumns();
      }
    });
  };
  ColumnModel.prototype.getGroupAutoColumns = function () {
    return this.groupAutoColumns;
  };
  ColumnModel.prototype.createGroupAutoColumnsIfNeeded = function () {
    if (!this.autoGroupsNeedBuilding) {
      return;
    }
    this.autoGroupsNeedBuilding = false;
    var groupFullWidthRow = this.gridOptionsWrapper.isGroupUseEntireRow(this.pivotMode);
    // we need to allow suppressing auto-column separately for group and pivot as the normal situation
    // is CSRM and user provides group column themselves for normal view, but when they go into pivot the
    // columns are generated by the grid so no opportunity for user to provide group column. so need a way
    // to suppress auto-col for grouping only, and not pivot.
    // however if using Viewport RM or SSRM and user is providing the columns, the user may wish full control
    // of the group column in this instance.
    var suppressAutoColumn = this.pivotMode ? this.gridOptionsWrapper.isPivotSuppressAutoColumn() : this.gridOptionsWrapper.isGroupSuppressAutoColumn();
    var groupingActive = this.rowGroupColumns.length > 0 || this.usingTreeData;
    var needAutoColumns = groupingActive && !suppressAutoColumn && !groupFullWidthRow;
    if (needAutoColumns) {
      var newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
      var autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
      // we force recreate when suppressColumnStateEvents changes, so new group cols pick up the new
      // definitions. otherwise we could ignore the new cols because they appear to be the same.
      if (autoColsDifferent || this.forceRecreateAutoGroups) {
        this.groupAutoColumns = newAutoGroupCols;
      }
    } else {
      this.groupAutoColumns = null;
    }
  };
  ColumnModel.prototype.autoColsEqual = function (colsA, colsB) {
    return areEqual(colsA, colsB, function (a, b) {
      return a.getColId() === b.getColId();
    });
  };
  ColumnModel.prototype.getWidthOfColsInList = function (columnList) {
    return columnList.reduce(function (width, col) {
      return width + col.getActualWidth();
    }, 0);
  };
  ColumnModel.prototype.getGridBalancedTree = function () {
    return this.gridBalancedTree;
  };
  ColumnModel.prototype.hasFloatingFilters = function () {
    if (!this.gridColumns) {
      return false;
    }
    var res = this.gridColumns.some(function (col) {
      return col.getColDef().floatingFilter;
    });
    return res;
  };
  ColumnModel.prototype.getFirstDisplayedColumn = function () {
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    var queryOrder = ['getDisplayedLeftColumns', 'getDisplayedCenterColumns', 'getDisplayedRightColumns'];
    if (isRtl) {
      queryOrder.reverse();
    }
    for (var i = 0; i < queryOrder.length; i++) {
      var container = this[queryOrder[i]]();
      if (container.length) {
        return isRtl ? last(container) : container[0];
      }
    }
    return null;
  };
  __decorate$5([Autowired('expressionService')], ColumnModel.prototype, "expressionService", void 0);
  __decorate$5([Autowired('columnFactory')], ColumnModel.prototype, "columnFactory", void 0);
  __decorate$5([Autowired('displayedGroupCreator')], ColumnModel.prototype, "displayedGroupCreator", void 0);
  __decorate$5([Autowired('autoWidthCalculator')], ColumnModel.prototype, "autoWidthCalculator", void 0);
  __decorate$5([Autowired('columnUtils')], ColumnModel.prototype, "columnUtils", void 0);
  __decorate$5([Autowired('columnAnimationService')], ColumnModel.prototype, "columnAnimationService", void 0);
  __decorate$5([Autowired('autoGroupColService')], ColumnModel.prototype, "autoGroupColService", void 0);
  __decorate$5([Optional('aggFuncService')], ColumnModel.prototype, "aggFuncService", void 0);
  __decorate$5([Optional('valueCache')], ColumnModel.prototype, "valueCache", void 0);
  __decorate$5([Optional('animationFrameService')], ColumnModel.prototype, "animationFrameService", void 0);
  __decorate$5([Autowired('rowModel')], ColumnModel.prototype, "rowModel", void 0);
  __decorate$5([Autowired('columnApi')], ColumnModel.prototype, "columnApi", void 0);
  __decorate$5([Autowired('gridApi')], ColumnModel.prototype, "gridApi", void 0);
  __decorate$5([Autowired('sortController')], ColumnModel.prototype, "sortController", void 0);
  __decorate$5([Autowired('columnDefFactory')], ColumnModel.prototype, "columnDefFactory", void 0);
  __decorate$5([PostConstruct], ColumnModel.prototype, "init", null);
  __decorate$5([__param$2(0, Qualifier('loggerFactory'))], ColumnModel.prototype, "setBeans", null);
  ColumnModel = __decorate$5([Bean('columnModel')], ColumnModel);
  return ColumnModel;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function padStartWidthZeros(value, totalStringSize) {
  return padStart(value.toString(), totalStringSize, '0');
}
function createArrayOfNumbers(first, last) {
  var result = [];
  for (var i = first; i <= last; i++) {
    result.push(i);
  }
  return result;
}
/**
 * Check if a value is numeric
 * from http://stackoverflow.com/questions/9716468/is-there-any-function-like-isnumeric-in-javascript-to-validate-numbers
 * @param {any} value
 * @return {boolean}
 */
function isNumeric(value) {
  return value !== '' && !isNaN(parseFloat(value)) && isFinite(value);
}
function getMaxSafeInteger() {
  // @ts-ignore
  return Number.MAX_SAFE_INTEGER || 9007199254740991;
}
function cleanNumber(value) {
  if (typeof value === 'string') {
    value = parseInt(value, 10);
  }
  if (typeof value === 'number') {
    return Math.floor(value);
  }
  return null;
}
function decToHex(number, bytes) {
  var hex = '';
  for (var i = 0; i < bytes; i++) {
    hex += String.fromCharCode(number & 0xff);
    number >>>= 8;
  }
  return hex;
}
function formatNumberTwoDecimalPlacesAndCommas(value) {
  if (typeof value !== 'number') {
    return '';
  }
  return formatNumberCommas(Math.round(value * 100) / 100);
}
/**
 * the native method number.toLocaleString(undefined, {minimumFractionDigits: 0})
 * puts in decimal places in IE, so we use this method instead
 * from: http://blog.tompawlak.org/number-currency-formatting-javascript
 * @param {number} value
 * @returns {string}
 */
function formatNumberCommas(value) {
  if (typeof value !== 'number') {
    return '';
  }
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
function sum(values) {
  return values == null ? null : values.reduce(function (total, value) {
    return total + value;
  }, 0);
}
var NumberUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  padStartWidthZeros: padStartWidthZeros,
  createArrayOfNumbers: createArrayOfNumbers,
  isNumeric: isNumeric,
  getMaxSafeInteger: getMaxSafeInteger,
  cleanNumber: cleanNumber,
  decToHex: decToHex,
  formatNumberTwoDecimalPlacesAndCommas: formatNumberTwoDecimalPlacesAndCommas,
  formatNumberCommas: formatNumberCommas,
  sum: sum
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$3 = undefined && undefined.__extends || function () {
  var _extendStatics4 = function extendStatics(d, b) {
    _extendStatics4 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics4(d, b);
  };
  return function (d, b) {
    _extendStatics4(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$6 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// takes in a list of columns, as specified by the column definitions, and returns column groups
var ColumnUtils = /** @class */function (_super) {
  __extends$3(ColumnUtils, _super);
  function ColumnUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnUtils.prototype.calculateColMinWidth = function (colDef) {
    return colDef.minWidth != null ? colDef.minWidth : this.gridOptionsWrapper.getMinColWidth();
  };
  ColumnUtils.prototype.calculateColMaxWidth = function (colDef) {
    return colDef.maxWidth != null ? colDef.maxWidth : this.gridOptionsWrapper.getMaxColWidth() || getMaxSafeInteger();
  };
  ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
    var minColWidth = this.calculateColMinWidth(colDef);
    var maxColWidth = this.calculateColMaxWidth(colDef);
    var width;
    var colDefWidth = attrToNumber(colDef.width);
    var colDefInitialWidth = attrToNumber(colDef.initialWidth);
    if (colDefWidth != null) {
      width = colDefWidth;
    } else if (colDefInitialWidth != null) {
      width = colDefInitialWidth;
    } else {
      width = this.gridOptionsWrapper.getColWidth();
    }
    return Math.max(Math.min(width, maxColWidth), minColWidth);
  };
  ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
    var result = [];
    var found = false;
    var recursePath = function recursePath(balancedColumnTree, dept) {
      for (var i = 0; i < balancedColumnTree.length; i++) {
        if (found) {
          return;
        }
        // quit the search, so 'result' is kept with the found result
        var node = balancedColumnTree[i];
        if (node instanceof ProvidedColumnGroup) {
          var nextNode = node;
          recursePath(nextNode.getChildren(), dept + 1);
          result[dept] = node;
        } else if (node === column) {
          found = true;
        }
      }
    };
    recursePath(originalBalancedTree, 0);
    // we should always find the path, but in case there is a bug somewhere, returning null
    // will make it fail rather than provide a 'hard to track down' bug
    return found ? result : null;
  };
  ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (parent, tree, callback) {
    var _this = this;
    if (!tree) {
      return;
    }
    tree.forEach(function (child) {
      if (child instanceof ProvidedColumnGroup) {
        _this.depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
      }
      callback(child, parent);
    });
  };
  ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
    var _this = this;
    if (!tree) {
      return;
    }
    tree.forEach(function (child) {
      if (child instanceof ColumnGroup) {
        _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
      }
      callback(child);
    });
  };
  ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
    var _this = this;
    if (!tree) {
      return;
    }
    tree.forEach(function (child) {
      if (child instanceof ColumnGroup) {
        _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
      }
      callback(child);
    });
  };
  ColumnUtils = __decorate$6([Bean('columnUtils')], ColumnUtils);
  return ColumnUtils;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$4 = undefined && undefined.__extends || function () {
  var _extendStatics5 = function extendStatics(d, b) {
    _extendStatics5 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics5(d, b);
  };
  return function (d, b) {
    _extendStatics5(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$7 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// takes in a list of columns, as specified by the column definitions, and returns column groups
var DisplayedGroupCreator = /** @class */function (_super) {
  __extends$4(DisplayedGroupCreator, _super);
  function DisplayedGroupCreator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DisplayedGroupCreator.prototype.createDisplayedGroups = function (
  // all displayed columns sorted - this is the columns the grid should show
  sortedVisibleColumns,
  // the tree of columns, as provided by the users, used to know what groups columns roll up into
  balancedColumnTree,
  // creates unique id's for the group
  groupInstanceIdCreator,
  // whether it's left, right or center col
  pinned,
  // we try to reuse old groups if we can, to allow gui to do animation
  oldDisplayedGroups) {
    var _this = this;
    var result = [];
    var previousRealPath;
    var previousOriginalPath;
    var oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
    // go through each column, then do a bottom up comparison to the previous column, and start
    // to share groups if they converge at any point.
    sortedVisibleColumns.forEach(function (currentColumn) {
      var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
      var currentRealPath = [];
      var firstColumn = !previousOriginalPath;
      for (var i = 0; i < currentOriginalPath.length; i++) {
        if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
          // new group needed
          var newGroup = _this.createColumnGroup(currentOriginalPath[i], groupInstanceIdCreator, oldColumnsMapped, pinned);
          currentRealPath[i] = newGroup;
          // if top level, add to result, otherwise add to parent
          if (i == 0) {
            result.push(newGroup);
          } else {
            currentRealPath[i - 1].addChild(newGroup);
          }
        } else {
          // reuse old group
          currentRealPath[i] = previousRealPath[i];
        }
      }
      var noColumnGroups = currentRealPath.length === 0;
      if (noColumnGroups) {
        // if we are not grouping, then the result of the above is an empty
        // path (no groups), and we just add the column to the root list.
        result.push(currentColumn);
      } else {
        var leafGroup = last(currentRealPath);
        leafGroup.addChild(currentColumn);
      }
      previousRealPath = currentRealPath;
      previousOriginalPath = currentOriginalPath;
    });
    this.setupParentsIntoColumns(result, null);
    return result;
  };
  DisplayedGroupCreator.prototype.createColumnGroup = function (originalGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
    var groupId = originalGroup.getGroupId();
    var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
    var uniqueId = ColumnGroup.createUniqueId(groupId, instanceId);
    var columnGroup = oldColumnsMapped[uniqueId];
    // if the user is setting new colDefs, it is possible that the id's overlap, and we
    // would have a false match from above. so we double check we are talking about the
    // same original column group.
    if (columnGroup && columnGroup.getOriginalColumnGroup() !== originalGroup) {
      columnGroup = null;
    }
    if (exists(columnGroup)) {
      // clean out the old column group here, as we will be adding children into it again
      columnGroup.reset();
    } else {
      columnGroup = new ColumnGroup(originalGroup, groupId, instanceId, pinned);
      this.context.createBean(columnGroup);
    }
    return columnGroup;
  };
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  DisplayedGroupCreator.prototype.mapOldGroupsById = function (displayedGroups) {
    var result = {};
    var recursive = function recursive(columnsOrGroups) {
      columnsOrGroups.forEach(function (columnOrGroup) {
        if (columnOrGroup instanceof ColumnGroup) {
          var columnGroup = columnOrGroup;
          result[columnOrGroup.getUniqueId()] = columnGroup;
          recursive(columnGroup.getChildren());
        }
      });
    };
    if (displayedGroups) {
      recursive(displayedGroups);
    }
    return result;
  };
  DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
    var _this = this;
    columnsOrGroups.forEach(function (columnsOrGroup) {
      columnsOrGroup.setParent(parent);
      if (columnsOrGroup instanceof ColumnGroup) {
        var columnGroup = columnsOrGroup;
        _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
      }
    });
  };
  DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
    var result = [];
    var found = false;
    var recursePath = function recursePath(columnTree, dept) {
      for (var i = 0; i < columnTree.length; i++) {
        // quit the search, so 'result' is kept with the found result
        if (found) {
          return;
        }
        var node = columnTree[i];
        if (node instanceof ProvidedColumnGroup) {
          var nextNode = node;
          recursePath(nextNode.getChildren(), dept + 1);
          result[dept] = node;
        } else if (node === column) {
          found = true;
        }
      }
    };
    recursePath(balancedColumnTree, 0);
    // it's possible we didn't find a path. this happens if the column is generated
    // by the grid (auto-group), in that the definition didn't come from the client. in this case,
    // we create a fake original path.
    if (found) {
      return result;
    }
    console.warn('could not get path');
    return null;
  };
  DisplayedGroupCreator = __decorate$7([Bean('displayedGroupCreator')], DisplayedGroupCreator);
  return DisplayedGroupCreator;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __spreadArrays$2 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
/**
 * These keys are used for validating properties supplied on a gridOptions object, and for code generation.
 * If you change the properties on the gridOptions interface, you *must* update this file as well to be consistent.
 */
var PropertyKeys = /** @class */function () {
  function PropertyKeys() {}
  PropertyKeys.STRING_PROPERTIES = ['sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate', 'overlayNoRowsTemplate', 'quickFilterText', 'rowModelType', 'editType', 'domLayout', 'clipboardDeliminator', 'rowGroupPanelShow', 'multiSortKey', 'pivotColumnGroupTotals', 'pivotRowTotals', 'pivotPanelShow', 'fillHandleDirection', 'serverSideStoreType', 'groupDisplayType', 'treeDataDisplayType'];
  PropertyKeys.OBJECT_PROPERTIES = ['components', 'frameworkComponents', 'rowStyle', 'context', 'autoGroupColumnDef', 'localeText', 'icons', 'datasource', 'serverSideDatasource', 'viewportDatasource', 'groupRowRendererParams', 'aggFuncs', 'fullWidthCellRendererParams', 'defaultColGroupDef', 'defaultColDef', 'defaultExportParams', 'defaultCsvExportParams', 'defaultExcelExportParams', 'columnTypes', 'rowClassRules', 'detailCellRendererParams', 'loadingCellRendererParams', 'loadingOverlayComponentParams', 'noRowsOverlayComponentParams', 'popupParent', 'colResizeDefault', 'statusBar', 'sideBar', 'chartThemeOverrides', 'customChartThemes'];
  PropertyKeys.ARRAY_PROPERTIES = ['alignedGrids', 'rowData', 'columnDefs', 'excelStyles', 'pinnedTopRowData', 'pinnedBottomRowData', 'chartThemes'];
  PropertyKeys.NUMBER_PROPERTIES = ['rowHeight', 'detailRowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupHeaderHeight', 'floatingFiltersHeight', 'pivotHeaderHeight', 'pivotGroupHeaderHeight', 'groupDefaultExpanded', 'minColWidth', 'maxColWidth', 'viewportRowModelPageSize', 'viewportRowModelBufferSize', 'autoSizePadding', 'maxBlocksInCache', 'maxConcurrentDatasourceRequests', 'tooltipShowDelay', 'cacheOverflowSize', 'paginationPageSize', 'cacheBlockSize', 'infiniteInitialRowCount', 'scrollbarWidth', 'batchUpdateWaitMillis', 'asyncTransactionWaitMillis', 'blockLoadDebounceMillis', 'keepDetailRowsCount', 'undoRedoCellEditingLimit', 'cellFlashDelay', 'cellFadeDelay', 'tabIndex'];
  PropertyKeys.BOOLEAN_PROPERTIES = ['suppressMakeColumnVisibleAfterUnGroup', 'suppressRowClickSelection', 'suppressCellSelection', 'suppressHorizontalScroll', 'alwaysShowHorizontalScroll', 'alwaysShowVerticalScroll', 'debug', 'enableBrowserTooltips', 'enableCellExpressions', 'angularCompileRows', 'angularCompileFilters', 'groupSuppressAutoColumn', 'groupSelectsChildren', 'groupIncludeFooter', 'groupIncludeTotalFooter', 'groupUseEntireRow', 'groupSuppressBlankHeader', 'suppressMenuHide', 'suppressRowDeselection', 'unSortIcon', 'suppressMultiSort', 'singleClickEdit', 'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize', 'skipHeaderOnAutoSize', 'suppressParentsInRowNodes', 'suppressColumnMoveAnimation', 'suppressMovableColumns', 'suppressFieldDotNotation', 'enableRangeSelection', 'enableRangeHandle', 'enableFillHandle', 'suppressClearOnFillReduction', 'deltaSort', 'suppressTouch', 'suppressAsyncEvents', 'allowContextMenuWithControlKey', 'suppressContextMenu', 'rememberGroupStateWhenNewData', 'enableCellChangeFlash', 'suppressDragLeaveHidesColumns', 'suppressMiddleClickScrolls', 'suppressPreventDefaultOnMouseWheel', 'suppressCopyRowsToClipboard', 'copyHeadersToClipboard', 'pivotMode', 'suppressAggFuncInHeader', 'suppressColumnVirtualisation', 'suppressAggAtRootLevel', 'suppressFocusAfterRefresh', 'functionsPassive', 'functionsReadOnly', 'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren', 'groupRemoveLowestSingleChildren', 'enableRtl', 'suppressClickEdit', 'rowDragEntireRow', 'rowDragManaged', 'suppressRowDrag', 'suppressMoveWhenRowDragging', 'rowDragMultiRow', 'enableGroupEdit', 'embedFullWidthRows', 'deprecatedEmbedFullWidthRows', 'suppressPaginationPanel', 'floatingFilter', 'groupHideOpenParents', 'groupMultiAutoColumn', 'pagination', 'stopEditingWhenGridLosesFocus', 'paginationAutoPageSize', 'suppressScrollOnNewData', 'suppressScrollWhenPopupsAreOpen', 'purgeClosedRowNodes', 'cacheQuickFilter', 'deltaRowDataMode', 'ensureDomOrder', 'accentedSort', 'suppressChangeDetection', 'valueCache', 'valueCacheNeverExpires', 'aggregateOnlyChangedColumns', 'suppressAnimationFrame', 'suppressExcelExport', 'suppressCsvExport', 'treeData', 'masterDetail', 'suppressMultiRangeSelection', 'enterMovesDownAfterEdit', 'enterMovesDown', 'suppressPropertyNamesCheck', 'rowMultiSelectWithClick', 'suppressEnterpriseResetOnNewColumns', 'enableOldSetFilterModel', 'suppressRowHoverHighlight', 'suppressRowTransform', 'suppressClipboardPaste', 'suppressLastEmptyLineOnPaste', 'serverSideSortingAlwaysResets', 'suppressSetColumnStateEvents', 'suppressColumnStateEvents', 'enableCharts', 'deltaColumnMode', 'suppressMaintainUnsortedOrder', 'enableCellTextSelection', 'suppressBrowserResizeObserver', 'suppressMaxRenderedRowRestriction', 'excludeChildrenWhenTreeDataFiltering', 'tooltipMouseTrack', 'keepDetailRows', 'paginateChildRows', 'preventDefaultOnContextMenu', 'undoRedoCellEditing', 'allowDragFromColumnsToolPanel', 'immutableData', 'immutableColumns', 'pivotSuppressAutoColumn', 'suppressExpandablePivotGroups', 'applyColumnDefOrder', 'debounceVerticalScrollbar', 'detailRowAutoHeight', 'serverSideFilteringAlwaysResets', 'suppressAggFilteredOnly', 'showOpenedGroup', 'suppressClipboardApi', 'suppressModelUpdateAfterUpdateTransaction', 'stopEditingWhenCellsLoseFocus', 'maintainColumnOrder', 'groupMaintainOrder', 'columnHoverHighlight', 'reactUi'];
  /** You do not need to include event callbacks in this list, as they are generated automatically. */
  PropertyKeys.FUNCTION_PROPERTIES = ['localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework', 'groupRowRenderer', 'groupRowRendererFramework', 'isExternalFilterPresent', 'getRowHeight', 'doesExternalFilterPass', 'getRowClass', 'getRowStyle', 'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard', 'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer', 'fullWidthCellRendererFramework', 'processSecondaryColDef', 'processSecondaryColGroupDef', 'getBusinessKeyForNode', 'sendToClipboard', 'navigateToNextHeader', 'tabToNextHeader', 'navigateToNextCell', 'tabToNextCell', 'processCellFromClipboard', 'getDocument', 'postProcessPopup', 'getChildCount', 'getDataPath', 'loadingCellRenderer', 'loadingCellRendererFramework', 'loadingOverlayComponent', 'loadingOverlayComponentFramework', 'noRowsOverlayComponent', 'noRowsOverlayComponentFramework', 'detailCellRenderer', 'detailCellRendererFramework', 'isRowMaster', 'isRowSelectable', 'postSort', 'processHeaderForClipboard', 'paginationNumberFormatter', 'processDataFromClipboard', 'getServerSideGroupKey', 'isServerSideGroup', 'suppressKeyboardEvent', 'createChartContainer', 'getChartToolbarItems', 'fillOperation', 'isApplyServerSideTransaction', 'getServerSideStoreParams', 'isServerSideGroupOpenByDefault', 'isGroupOpenByDefault', 'defaultGroupSortComparator', 'defaultGroupOrderComparator', 'loadingCellRendererSelector'];
  PropertyKeys.ALL_PROPERTIES = __spreadArrays$2(PropertyKeys.ARRAY_PROPERTIES, PropertyKeys.OBJECT_PROPERTIES, PropertyKeys.STRING_PROPERTIES, PropertyKeys.NUMBER_PROPERTIES, PropertyKeys.FUNCTION_PROPERTIES, PropertyKeys.BOOLEAN_PROPERTIES);
  /**
   * Used when performing property checks. This avoids noise caused when using frameworks, which can add their own
   * framework-specific properties to colDefs, gridOptions etc.
   */
  PropertyKeys.FRAMEWORK_PROPERTIES = ['__ob__', '__v_skip', '__metadata__', 'mappedColumnProperties', 'hasChildColumns', 'toColDef', 'createColDefFromGridColumn'];
  return PropertyKeys;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var __spreadArrays$3 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ComponentUtil = /** @class */function () {
  function ComponentUtil() {}
  ComponentUtil.getEventCallbacks = function () {
    if (!ComponentUtil.EVENT_CALLBACKS) {
      ComponentUtil.EVENT_CALLBACKS = ComponentUtil.EVENTS.map(function (event) {
        return ComponentUtil.getCallbackForEvent(event);
      });
    }
    return ComponentUtil.EVENT_CALLBACKS;
  };
  ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component, skipEventDeprecationCheck) {
    // create empty grid options if none were passed
    if (typeof gridOptions !== 'object') {
      gridOptions = {};
    }
    // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
    var pGridOptions = gridOptions;
    var keyExists = function keyExists(key) {
      return typeof component[key] !== 'undefined';
    };
    // add in all the simple properties
    __spreadArrays$3(ComponentUtil.ARRAY_PROPERTIES, ComponentUtil.STRING_PROPERTIES, ComponentUtil.OBJECT_PROPERTIES, ComponentUtil.FUNCTION_PROPERTIES, ComponentUtil.getEventCallbacks()).filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = component[key];
    });
    ComponentUtil.BOOLEAN_PROPERTIES.filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = ComponentUtil.toBoolean(component[key]);
    });
    ComponentUtil.NUMBER_PROPERTIES.filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = ComponentUtil.toNumber(component[key]);
    });
    return gridOptions;
  };
  ComponentUtil.getCallbackForEvent = function (eventName) {
    if (!eventName || eventName.length < 2) {
      return eventName;
    }
    return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
  };
  ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
    if (!changes) {
      return;
    }
    var changesToApply = __assign$1({}, changes);
    // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
    var pGridOptions = gridOptions;
    var keyExists = function keyExists(key) {
      return changesToApply[key];
    };
    // check if any change for the simple types, and if so, then just copy in the new value
    __spreadArrays$3(ComponentUtil.ARRAY_PROPERTIES, ComponentUtil.OBJECT_PROPERTIES, ComponentUtil.STRING_PROPERTIES, ComponentUtil.getEventCallbacks()).filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = changesToApply[key].currentValue;
    });
    ComponentUtil.BOOLEAN_PROPERTIES.filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = ComponentUtil.toBoolean(changesToApply[key].currentValue);
    });
    ComponentUtil.NUMBER_PROPERTIES.filter(keyExists).forEach(function (key) {
      return pGridOptions[key] = ComponentUtil.toNumber(changesToApply[key].currentValue);
    });
    if (changesToApply.enableCellTextSelection) {
      api.setEnableCellTextSelection(ComponentUtil.toBoolean(changesToApply.enableCellTextSelection.currentValue));
      delete changesToApply.enableCellTextSelection;
    }
    if (changesToApply.quickFilterText) {
      api.setQuickFilter(changesToApply.quickFilterText.currentValue);
      delete changesToApply.quickFilterText;
    }
    if (changesToApply.autoGroupColumnDef) {
      api.setAutoGroupColumnDef(changesToApply.autoGroupColumnDef.currentValue, "gridOptionsChanged");
      delete changesToApply.autoGroupColumnDef;
    }
    if (changesToApply.columnDefs) {
      api.setColumnDefs(changesToApply.columnDefs.currentValue, "gridOptionsChanged");
      delete changesToApply.columnDefs;
    }
    if (changesToApply.paginationPageSize) {
      api.paginationSetPageSize(ComponentUtil.toNumber(changesToApply.paginationPageSize.currentValue));
      delete changesToApply.paginationPageSize;
    }
    if (changesToApply.pivotMode) {
      columnApi.setPivotMode(ComponentUtil.toBoolean(changesToApply.pivotMode.currentValue));
      delete changesToApply.pivotMode;
    }
    if (changesToApply.groupRemoveSingleChildren) {
      api.setGroupRemoveSingleChildren(ComponentUtil.toBoolean(changesToApply.groupRemoveSingleChildren.currentValue));
      delete changesToApply.groupRemoveSingleChildren;
    }
    if (changesToApply.suppressRowDrag) {
      api.setSuppressRowDrag(ComponentUtil.toBoolean(changesToApply.suppressRowDrag.currentValue));
      delete changesToApply.suppressRowDrag;
    }
    if (changesToApply.suppressMoveWhenRowDragging) {
      api.setSuppressMoveWhenRowDragging(ComponentUtil.toBoolean(changesToApply.suppressMoveWhenRowDragging.currentValue));
      delete changesToApply.suppressMoveWhenRowDragging;
    }
    if (changesToApply.suppressRowClickSelection) {
      api.setSuppressRowClickSelection(ComponentUtil.toBoolean(changesToApply.suppressRowClickSelection.currentValue));
      delete changesToApply.suppressRowClickSelection;
    }
    if (changesToApply.suppressClipboardPaste) {
      api.setSuppressClipboardPaste(ComponentUtil.toBoolean(changesToApply.suppressClipboardPaste.currentValue));
      delete changesToApply.suppressClipboardPaste;
    }
    if (changesToApply.headerHeight) {
      api.setHeaderHeight(ComponentUtil.toNumber(changesToApply.headerHeight.currentValue));
      delete changesToApply.headerHeight;
    }
    // any remaining properties can be set in a generic way
    // ie the setter takes the form of setXXX and the argument requires no formatting/translation first
    var dynamicApi = api;
    Object.keys(changesToApply).forEach(function (property) {
      var setterName = "set" + property.charAt(0).toUpperCase() + property.substring(1);
      if (dynamicApi[setterName]) {
        dynamicApi[setterName](changes[property].currentValue);
      }
    });
    // copy changes into an event for dispatch
    var event = {
      type: Events.EVENT_COMPONENT_STATE_CHANGED,
      api: gridOptions.api,
      columnApi: gridOptions.columnApi
    };
    iterateObject(changes, function (key, value) {
      event[key] = value;
    });
    api.dispatchEvent(event);
  };
  ComponentUtil.toBoolean = function (value) {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      // for boolean, compare to empty String to allow attributes appearing with
      // no value to be treated as 'true'
      return value.toUpperCase() === 'TRUE' || value == '';
    }
    return false;
  };
  ComponentUtil.toNumber = function (value) {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      return Number(value);
    }
  };
  // all the events are populated in here AFTER this class (at the bottom of the file).
  ComponentUtil.EVENTS = [];
  // events that are available for use by users of AG Grid and so should be documented
  ComponentUtil.PUBLIC_EVENTS = [];
  // events that are internal to AG Grid and should not be exposed to users via documentation or generated framework components
  ComponentUtil.EXCLUDED_INTERNAL_EVENTS = [];
  ComponentUtil.STRING_PROPERTIES = PropertyKeys.STRING_PROPERTIES;
  ComponentUtil.OBJECT_PROPERTIES = PropertyKeys.OBJECT_PROPERTIES;
  ComponentUtil.ARRAY_PROPERTIES = PropertyKeys.ARRAY_PROPERTIES;
  ComponentUtil.NUMBER_PROPERTIES = PropertyKeys.NUMBER_PROPERTIES;
  ComponentUtil.BOOLEAN_PROPERTIES = PropertyKeys.BOOLEAN_PROPERTIES;
  ComponentUtil.FUNCTION_PROPERTIES = PropertyKeys.FUNCTION_PROPERTIES;
  ComponentUtil.ALL_PROPERTIES = PropertyKeys.ALL_PROPERTIES;
  return ComponentUtil;
}();
ComponentUtil.EVENTS = values(Events);
/** Exclude the following internal events from code generation to prevent exposing these events via framework components */
ComponentUtil.EXCLUDED_INTERNAL_EVENTS = [Events.EVENT_SCROLLBAR_WIDTH_CHANGED, Events.EVENT_CHECKBOX_CHANGED, Events.EVENT_HEIGHT_SCALE_CHANGED, Events.EVENT_BODY_HEIGHT_CHANGED, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, Events.EVENT_SCROLL_VISIBILITY_CHANGED, Events.EVENT_COLUMN_HOVER_CHANGED, Events.EVENT_FLASH_CELLS, Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, Events.EVENT_DISPLAYED_ROWS_CHANGED, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, Events.EVENT_POPUP_TO_FRONT, Events.EVENT_KEYBOARD_FOCUS, Events.EVENT_MOUSE_FOCUS, Events.EVENT_STORE_UPDATED, Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START, Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END, Events.EVENT_FILL_START, Events.EVENT_FILL_END];
/** EVENTS that should be exposed via code generation for the framework components.  */
ComponentUtil.PUBLIC_EVENTS = ComponentUtil.EVENTS.filter(function (e) {
  return !includes(ComponentUtil.EXCLUDED_INTERNAL_EVENTS, e);
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$5 = undefined && undefined.__extends || function () {
  var _extendStatics6 = function extendStatics(d, b) {
    _extendStatics6 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics6(d, b);
  };
  return function (d, b) {
    _extendStatics6(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$8 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgStackComponentsRegistry = /** @class */function (_super) {
  __extends$5(AgStackComponentsRegistry, _super);
  function AgStackComponentsRegistry() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.componentsMappedByName = {};
    return _this;
  }
  AgStackComponentsRegistry.prototype.setupComponents = function (components) {
    var _this = this;
    if (components) {
      components.forEach(function (componentMeta) {
        return _this.addComponent(componentMeta);
      });
    }
  };
  AgStackComponentsRegistry.prototype.addComponent = function (componentMeta) {
    // get name of the class as a string
    // let className = getNameOfClass(ComponentClass);
    // insert a dash after every capital letter
    // let classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
    var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    // put all to upper case
    var classUpperCase = classEscaped.toUpperCase();
    // finally store
    this.componentsMappedByName[classUpperCase] = componentMeta.componentClass;
  };
  AgStackComponentsRegistry.prototype.getComponentClass = function (htmlTag) {
    return this.componentsMappedByName[htmlTag];
  };
  AgStackComponentsRegistry = __decorate$8([Bean('agStackComponentsRegistry')], AgStackComponentsRegistry);
  return AgStackComponentsRegistry;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __spreadArrays$4 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ColDefUtil = /** @class */function () {
  function ColDefUtil() {}
  ColDefUtil.STRING_PROPERTIES = ['headerName', 'columnGroupShow', 'headerClass', 'toolPanelClass', 'headerValueGetter', 'pivotKeys', 'groupId', 'colId', 'sort', 'initialSort', 'field', 'type', 'tooltipComponent', 'tooltipField', 'headerTooltip', 'cellClass', 'showRowGroup', 'template', 'templateUrl', 'filter', 'initialAggFunc', 'aggFunc', 'cellRenderer', 'cellEditor', 'pinned', 'initialPinned', 'chartDataType', 'cellEditorPopupPosition'];
  ColDefUtil.OBJECT_PROPERTIES = ['headerGroupComponent', 'headerGroupComponentFramework', 'headerGroupComponentParams', 'cellStyle', 'cellRendererParams', 'cellEditorFramework', 'cellEditorParams', 'pinnedRowCellRendererFramework', 'pinnedRowCellRendererParams', 'filterFramework', 'filterParams', 'pivotValueColumn', 'headerComponent', 'headerComponentFramework', 'headerComponentParams', 'floatingFilterComponent', 'floatingFilterComponentParams', 'floatingFilterComponentFramework', 'tooltipComponent', 'tooltipComponentParams', 'tooltipComponentFramework', 'refData', 'columnsMenuParams'];
  ColDefUtil.ARRAY_PROPERTIES = ['children', 'sortingOrder', 'allowedAggFuncs', 'menuTabs', 'pivotTotalColumnIds', 'cellClassRules', 'icons'];
  ColDefUtil.NUMBER_PROPERTIES = ['sortedAt', 'sortIndex', 'initialSortIndex', 'flex', 'initialFlex', 'width', 'initialWidth', 'minWidth', 'maxWidth', 'rowGroupIndex', 'initialRowGroupIndex', 'pivotIndex', 'initialPivotIndex'];
  ColDefUtil.BOOLEAN_PROPERTIES = ['suppressCellFlash', 'suppressColumnsToolPanel', 'suppressFiltersToolPanel', 'openByDefault', 'marryChildren', 'hide', 'initialHide', 'rowGroup', 'initialRowGroup', 'pivot', 'initialPivot', 'checkboxSelection', 'headerCheckboxSelection', 'headerCheckboxSelectionFilteredOnly', 'suppressMenu', 'suppressMovable', 'lockPosition', 'lockVisible', 'lockPinned', 'unSortIcon', 'suppressSizeToFit', 'suppressAutoSize', 'enableRowGroup', 'enablePivot', 'enableValue', 'editable', 'suppressPaste', 'suppressNavigable', 'enableCellChangeFlash', 'rowDrag', 'dndSource', 'autoHeight', 'wrapText', 'sortable', 'resizable', 'singleClickEdit', 'floatingFilter', 'cellEditorPopup', 'suppressFillHandle'];
  ColDefUtil.FUNCTION_PROPERTIES = ['dndSourceOnRowDrag', 'valueGetter', 'valueSetter', 'filterValueGetter', 'keyCreator', 'cellRenderer', 'cellRendererFramework', 'pinnedRowCellRenderer', 'valueFormatter', 'pinnedRowValueFormatter', 'valueParser', 'comparator', 'equals', 'pivotComparator', 'suppressKeyboardEvent', 'suppressHeaderKeyboardEvent', 'colSpan', 'rowSpan', 'getQuickFilterText', 'newValueHandler', 'onCellValueChanged', 'onCellClicked', 'onCellDoubleClicked', 'onCellContextMenu', 'rowDragText', 'tooltipValueGetter', 'tooltipComponent', 'tooltipComponentFramework', 'cellRendererSelector', 'cellEditorSelector'];
  ColDefUtil.ALL_PROPERTIES = __spreadArrays$4(ColDefUtil.ARRAY_PROPERTIES, ColDefUtil.OBJECT_PROPERTIES, ColDefUtil.STRING_PROPERTIES, ColDefUtil.NUMBER_PROPERTIES, ColDefUtil.FUNCTION_PROPERTIES, ColDefUtil.BOOLEAN_PROPERTIES);
  // used when doing property checks - this causes noise when using frameworks which can add their own fw specific
  // properties to colDefs, gridOptions etc
  ColDefUtil.FRAMEWORK_PROPERTIES = ['__ob__', '__v_skip', '__metadata__', 'mappedColumnProperties', 'hasChildColumns', 'toColDef', 'createColDefFromGridColumn'];
  return ColDefUtil;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var Color = /** @class */function () {
  /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */
  function Color(r, g, b, a) {
    if (a === void 0) {
      a = 1;
    }
    // NaN is treated as 0.
    this.r = Math.min(1, Math.max(0, r || 0));
    this.g = Math.min(1, Math.max(0, g || 0));
    this.b = Math.min(1, Math.max(0, b || 0));
    this.a = Math.min(1, Math.max(0, a || 0));
  }
  /**
   * The given string can be in one of the following formats:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   * @param str
   */
  Color.fromString = function (str) {
    // hexadecimal notation
    if (str.indexOf('#') >= 0) {
      // there can be some leading whitespace
      return Color.fromHexString(str);
    }
    // color name
    var hex = Color.nameToHex[str];
    if (hex) {
      return Color.fromHexString(hex);
    }
    // rgb(a) notation
    if (str.indexOf('rgb') >= 0) {
      return Color.fromRgbaString(str);
    }
    throw new Error("Invalid color string: '" + str + "'");
  };
  // See https://drafts.csswg.org/css-color/#hex-notation
  Color.parseHex = function (input) {
    input = input.replace(/ /g, '').slice(1);
    var parts;
    switch (input.length) {
      case 6:
      case 8:
        parts = [];
        for (var i = 0; i < input.length; i += 2) {
          parts.push(parseInt("" + input[i] + input[i + 1], 16));
        }
        break;
      case 3:
      case 4:
        parts = input.split('').map(function (p) {
          return parseInt(p, 16);
        }).map(function (p) {
          return p + p * 16;
        });
        break;
    }
    if (parts.length >= 3) {
      if (parts.every(function (p) {
        return p >= 0;
      })) {
        if (parts.length === 3) {
          parts.push(255);
        }
        return parts;
      }
    }
  };
  Color.fromHexString = function (str) {
    var values = Color.parseHex(str);
    if (values) {
      var r = values[0],
        g = values[1],
        b = values[2],
        a = values[3];
      return new Color(r / 255, g / 255, b / 255, a / 255);
    }
    throw new Error("Malformed hexadecimal color string: '" + str + "'");
  };
  Color.stringToRgba = function (str) {
    // Find positions of opening and closing parentheses.
    var _a = [NaN, NaN],
      po = _a[0],
      pc = _a[1];
    for (var i = 0; i < str.length; i++) {
      var c = str[i];
      if (!po && c === '(') {
        po = i;
      } else if (c === ')') {
        pc = i;
        break;
      }
    }
    var contents = po && pc && str.substring(po + 1, pc);
    if (!contents) {
      return;
    }
    var parts = contents.split(',');
    var rgba = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var value = parseFloat(part);
      if (isNaN(value)) {
        return;
      }
      if (part.indexOf('%') >= 0) {
        // percentage r, g, or b value
        value = Math.max(0, Math.min(100, value));
        value /= 100;
      } else {
        if (i === 3) {
          // alpha component
          value = Math.max(0, Math.min(1, value));
        } else {
          // absolute r, g, or b value
          value = Math.max(0, Math.min(255, value));
          value /= 255;
        }
      }
      rgba.push(value);
    }
    return rgba;
  };
  Color.fromRgbaString = function (str) {
    var rgba = Color.stringToRgba(str);
    if (rgba) {
      if (rgba.length === 3) {
        return new Color(rgba[0], rgba[1], rgba[2]);
      } else if (rgba.length === 4) {
        return new Color(rgba[0], rgba[1], rgba[2], rgba[3]);
      }
    }
    throw new Error("Malformed rgb/rgba color string: '" + str + "'");
  };
  Color.fromArray = function (arr) {
    if (arr.length === 4) {
      return new Color(arr[0], arr[1], arr[2], arr[3]);
    }
    if (arr.length === 3) {
      return new Color(arr[0], arr[1], arr[2]);
    }
    throw new Error('The given array should contain 3 or 4 color components (numbers).');
  };
  Color.fromHSB = function (h, s, b, alpha) {
    if (alpha === void 0) {
      alpha = 1;
    }
    var rgb = Color.HSBtoRGB(h, s, b);
    return new Color(rgb[0], rgb[1], rgb[2], alpha);
  };
  Color.padHex = function (str) {
    // Can't use `padStart(2, '0')` here because of IE.
    return str.length === 1 ? '0' + str : str;
  };
  Color.prototype.toHexString = function () {
    var hex = '#' + Color.padHex(Math.round(this.r * 255).toString(16)) + Color.padHex(Math.round(this.g * 255).toString(16)) + Color.padHex(Math.round(this.b * 255).toString(16));
    if (this.a < 1) {
      hex += Color.padHex(Math.round(this.a * 255).toString(16));
    }
    return hex;
  };
  Color.prototype.toRgbaString = function (fractionDigits) {
    if (fractionDigits === void 0) {
      fractionDigits = 3;
    }
    var components = [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
    var k = Math.pow(10, fractionDigits);
    if (this.a !== 1) {
      components.push(Math.round(this.a * k) / k);
      return "rgba(" + components.join(', ') + ")";
    }
    return "rgb(" + components.join(', ') + ")";
  };
  Color.prototype.toString = function () {
    if (this.a === 1) {
      return this.toHexString();
    }
    return this.toRgbaString();
  };
  Color.prototype.toHSB = function () {
    return Color.RGBtoHSB(this.r, this.g, this.b);
  };
  /**
   * Converts the given RGB triple to an array of HSB (HSV) components.
   * The hue component will be `NaN` for achromatic colors.
   */
  Color.RGBtoHSB = function (r, g, b) {
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var S = max !== 0 ? (max - min) / max : 0;
    var H = NaN;
    // min == max, means all components are the same
    // and the color is a shade of gray with no hue (H is NaN)
    if (min !== max) {
      var delta = max - min;
      var rc = (max - r) / delta;
      var gc = (max - g) / delta;
      var bc = (max - b) / delta;
      if (r === max) {
        H = bc - gc;
      } else if (g === max) {
        H = 2.0 + rc - bc;
      } else {
        H = 4.0 + gc - rc;
      }
      H /= 6.0;
      if (H < 0) {
        H = H + 1.0;
      }
    }
    return [H * 360, S, max];
  };
  /**
   * Converts the given HSB (HSV) triple to an array of RGB components.
   */
  Color.HSBtoRGB = function (H, S, B) {
    if (isNaN(H)) {
      H = 0;
    }
    H = (H % 360 + 360) % 360 / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
    var r = 0;
    var g = 0;
    var b = 0;
    if (S === 0) {
      r = g = b = B;
    } else {
      var h = (H - Math.floor(H)) * 6;
      var f = h - Math.floor(h);
      var p = B * (1 - S);
      var q = B * (1 - S * f);
      var t = B * (1 - S * (1 - f));
      switch (h >> 0) {
        // discard the floating point part of the number
        case 0:
          r = B;
          g = t;
          b = p;
          break;
        case 1:
          r = q;
          g = B;
          b = p;
          break;
        case 2:
          r = p;
          g = B;
          b = t;
          break;
        case 3:
          r = p;
          g = q;
          b = B;
          break;
        case 4:
          r = t;
          g = p;
          b = B;
          break;
        case 5:
          r = B;
          g = p;
          b = q;
          break;
      }
    }
    return [r, g, b];
  };
  Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
    var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
    var b = hsb[2];
    if (b == 0 && brightnessFactor > 1.0) {
      b = 0.05;
    }
    var h = ((hsb[0] + hueShift) % 360 + 360) % 360;
    var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
    b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
    var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
    var rgba = Color.HSBtoRGB(h, s, b);
    rgba.push(a);
    return Color.fromArray(rgba);
  };
  Color.prototype.brighter = function () {
    return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
  };
  Color.prototype.darker = function () {
    return this.derive(0, 1.0, 0.7, 1.0);
  };
  /**
   * CSS Color Module Level 4:
   * https://drafts.csswg.org/css-color/#named-colors
   */
  Color.nameToHex = Object.freeze({
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#00FFFF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000000',
    blanchedalmond: '#FFEBCD',
    blue: '#0000FF',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#00FFFF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgreen: '#006400',
    darkgrey: '#A9A9A9',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#FF00FF',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    grey: '#808080',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgreen: '#90EE90',
    lightgrey: '#D3D3D3',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#00FF00',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#FF00FF',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#FF0000',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFFFFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FFFF00',
    yellowgreen: '#9ACD32'
  });
  return Color;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// Based on https://stackoverflow.com/a/14991797
// This will parse a delimited string into an array of arrays.
function stringToArray(strData, delimiter) {
  if (delimiter === void 0) {
    delimiter = ',';
  }
  var data = [];
  var isNewline = function isNewline(char) {
    return char === '\r' || char === '\n';
  };
  var insideQuotedField = false;
  if (strData === '') {
    return [['']];
  }
  var _loop_1 = function _loop_1(row, column, position) {
    var previousChar = strData[position - 1];
    var currentChar = strData[position];
    var nextChar = strData[position + 1];
    var ensureDataExists = function ensureDataExists() {
      if (!data[row]) {
        // create row if it doesn't exist
        data[row] = [];
      }
      if (!data[row][column]) {
        // create column if it doesn't exist
        data[row][column] = '';
      }
    };
    ensureDataExists();
    if (currentChar === '"') {
      if (insideQuotedField) {
        if (nextChar === '"') {
          // unescape double quote
          data[row][column] += '"';
          position++;
        } else {
          // exit quoted field
          insideQuotedField = false;
        }
        return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
      } else if (previousChar === undefined || previousChar === delimiter || isNewline(previousChar)) {
        // enter quoted field
        insideQuotedField = true;
        return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
      }
    }
    if (!insideQuotedField) {
      if (currentChar === delimiter) {
        // move to next column
        column++;
        ensureDataExists();
        return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
      } else if (isNewline(currentChar)) {
        // move to next row
        column = 0;
        row++;
        ensureDataExists();
        if (currentChar === '\r' && nextChar === '\n') {
          // skip over second newline character if it exists
          position++;
        }
        return out_row_1 = row, out_column_1 = column, out_position_1 = position, "continue";
      }
    }
    // add current character to current column
    data[row][column] += currentChar;
    out_row_1 = row;
    out_column_1 = column;
    out_position_1 = position;
  };
  var out_row_1, out_column_1, out_position_1;
  // iterate over each character, keep track of current row and column (of the returned array)
  for (var row = 0, column = 0, position = 0; position < strData.length; position++) {
    _loop_1(row, column, position);
    row = out_row_1;
    column = out_column_1;
    position = out_position_1;
  }
  return data;
}
var CsvUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  stringToArray: stringToArray
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * These variables are lazy loaded, as otherwise they try and get initialised when we are loading
 * unit tests and we don't have references to window or document in the unit tests
 * from http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */
var isSafari;
var isIE;
var isEdge;
var isChrome;
var isFirefox;
var isIOS;
var invisibleScrollbar;
var browserScrollbarWidth;
function isBrowserIE() {
  if (isIE === undefined) {
    isIE = /*@cc_on!@*/!!document.documentMode; // At least IE6
  }

  return isIE;
}
function isBrowserEdge() {
  if (isEdge === undefined) {
    isEdge = !isBrowserIE() && !!window.StyleMedia;
  }
  return isEdge;
}
function isBrowserSafari() {
  if (isSafari === undefined) {
    // taken from https://stackoverflow.com/a/23522755/1388233
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  return isSafari;
}
function isBrowserChrome() {
  if (isChrome === undefined) {
    var win = window;
    isChrome = !!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return isChrome;
}
function isBrowserFirefox() {
  if (isFirefox === undefined) {
    var win = window;
    isFirefox = typeof win.InstallTrigger !== 'undefined';
  }
  return isFirefox;
}
function isIOSUserAgent() {
  if (isIOS === undefined) {
    // taken from https://stackoverflow.com/a/58064481/1388233
    isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
    // eslint-disable-next-line
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) &&
    // @ts-ignore
    !window.MSStream;
  }
  return isIOS;
}
function getTabIndex(el) {
  if (!el) {
    return null;
  }
  var numberTabIndex = el.tabIndex;
  var tabIndex = el.getAttribute('tabIndex');
  if (isBrowserIE() && numberTabIndex === 0 && tabIndex === null) {
    var map = {
      a: true,
      body: true,
      button: true,
      frame: true,
      iframe: true,
      img: true,
      input: true,
      isindex: true,
      object: true,
      select: true,
      textarea: true
    };
    return map[el.nodeName.toLowerCase()] === true ? '0' : null;
  }
  if (numberTabIndex === -1 && (tabIndex === null || tabIndex === '' && !isBrowserFirefox())) {
    return null;
  }
  return numberTabIndex.toString();
}
function getMaxDivHeight() {
  if (!document.body) {
    return -1;
  }
  var res = 1000000;
  // FF reports the height back but still renders blank after ~6M px
  var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
  var div = document.createElement('div');
  document.body.appendChild(div);
  while (true) {
    var test = res * 2;
    div.style.height = test + 'px';
    if (test > testUpTo || div.clientHeight !== test) {
      break;
    } else {
      res = test;
    }
  }
  document.body.removeChild(div);
  return res;
}
function getScrollbarWidth() {
  if (browserScrollbarWidth == null) {
    initScrollbarWidthAndVisibility();
  }
  return browserScrollbarWidth;
}
function initScrollbarWidthAndVisibility() {
  var body = document.body;
  var div = document.createElement('div');
  div.style.width = div.style.height = '100px';
  div.style.opacity = '0';
  div.style.overflow = 'scroll';
  div.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  div.style.position = 'absolute';
  body.appendChild(div);
  var width = div.offsetWidth - div.clientWidth;
  // if width is 0 and client width is 0, means the DOM isn't ready
  if (width === 0 && div.clientWidth === 0) {
    width = null;
  }
  // remove div
  if (div.parentNode) {
    div.parentNode.removeChild(div);
  }
  if (width != null) {
    browserScrollbarWidth = width;
    invisibleScrollbar = width === 0;
  }
}
function isInvisibleScrollbar() {
  if (invisibleScrollbar == null) {
    initScrollbarWidthAndVisibility();
  }
  return invisibleScrollbar;
}
/** @deprecated */
function hasOverflowScrolling() {
  var prefixes = ['webkit', 'moz', 'o', 'ms'];
  var div = document.createElement('div');
  var body = document.getElementsByTagName('body')[0];
  var found = false;
  var p;
  body.appendChild(div);
  div.setAttribute('style', prefixes.map(function (prefix) {
    return "-" + prefix + "-overflow-scrolling: touch";
  }).concat('overflow-scrolling: touch').join(';'));
  var computedStyle = window.getComputedStyle(div);
  if (computedStyle.overflowScrolling === 'touch') {
    found = true;
  }
  if (!found) {
    for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
      p = prefixes_1[_i];
      if (computedStyle[p + "OverflowScrolling"] === 'touch') {
        found = true;
        break;
      }
    }
  }
  if (div.parentNode) {
    div.parentNode.removeChild(div);
  }
  return found;
}
/**
 * Gets the document body width
 * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
 * @returns {number}
 */
function getBodyWidth() {
  if (document.body) {
    return document.body.clientWidth;
  }
  if (window.innerHeight) {
    return window.innerWidth;
  }
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth;
  }
  return -1;
}
/**
 * Gets the body height
 * from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
 * @returns {number}
 */
function getBodyHeight() {
  if (document.body) {
    return document.body.clientHeight;
  }
  if (window.innerHeight) {
    return window.innerHeight;
  }
  if (document.documentElement && document.documentElement.clientHeight) {
    return document.documentElement.clientHeight;
  }
  return -1;
}
var BrowserUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isBrowserIE: isBrowserIE,
  isBrowserEdge: isBrowserEdge,
  isBrowserSafari: isBrowserSafari,
  isBrowserChrome: isBrowserChrome,
  isBrowserFirefox: isBrowserFirefox,
  isIOSUserAgent: isIOSUserAgent,
  getTabIndex: getTabIndex,
  getMaxDivHeight: getMaxDivHeight,
  getScrollbarWidth: getScrollbarWidth,
  isInvisibleScrollbar: isInvisibleScrollbar,
  hasOverflowScrolling: hasOverflowScrolling,
  getBodyWidth: getBodyWidth,
  getBodyHeight: getBodyHeight
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var rtlNegativeScroll;
function addCssClass(element, className) {
  if (!element || !className || className.length === 0) {
    return;
  }
  if (className.indexOf(' ') >= 0) {
    className.split(' ').forEach(function (value) {
      return addCssClass(element, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.add(className);
  } else if (element.className && element.className.length > 0) {
    var cssClasses = element.className.split(' ');
    if (cssClasses.indexOf(className) < 0) {
      cssClasses.push(className);
      element.setAttribute('class', cssClasses.join(' '));
    }
  } else {
    // do not use element.classList = className here, it will cause
    // a read-only assignment error on some browsers (IE/Edge).
    element.setAttribute('class', className);
  }
  return element;
}
function removeCssClass(element, className) {
  if (!element || !className || className.length === 0) {
    return;
  }
  if (className.indexOf(' ') >= 0) {
    className.split(' ').forEach(function (value) {
      return removeCssClass(element, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.remove(className);
  } else if (element.className && element.className.length > 0) {
    var newClassName = element.className.split(' ').filter(function (c) {
      return c !== className;
    }).join(' ');
    element.setAttribute('class', newClassName);
  }
}
function addOrRemoveCssClass(element, className, addOrRemove) {
  if (addOrRemove) {
    addCssClass(element, className);
  } else {
    removeCssClass(element, className);
  }
}
/**
 * This method adds a class to an element and remove that class from all siblings.
 * Useful for toggling state.
 * @param {HTMLElement} element The element to receive the class
 * @param {string} elementClass The class to be assigned to the element
 * @param {boolean} otherElementClass The class to be assigned to siblings of the element, but not the element itself
 */
function radioCssClass(element, elementClass, otherElementClass) {
  var parent = element.parentElement;
  var sibling = parent && parent.firstChild;
  while (sibling) {
    if (elementClass) {
      addOrRemoveCssClass(sibling, elementClass, sibling === element);
    }
    if (otherElementClass) {
      addOrRemoveCssClass(sibling, otherElementClass, sibling !== element);
    }
    sibling = sibling.nextSibling;
  }
}
function containsClass(element, className) {
  if (element.classList) {
    // for modern browsers
    return element.classList.contains(className);
  }
  if (element.className) {
    // for older browsers, check against the string of class names
    // if only one class, can check for exact match
    var onlyClass = element.className === className;
    // if many classes, check for class name, we have to pad with ' ' to stop other
    // class names that are a substring of this class
    var contains = element.className.indexOf(' ' + className + ' ') >= 0;
    // the padding above then breaks when it's the first or last class names
    var startsWithClass = element.className.indexOf(className + ' ') === 0;
    var endsWithClass = element.className.lastIndexOf(' ' + className) === element.className.length - className.length - 1;
    return onlyClass || contains || startsWithClass || endsWithClass;
  }
  // if item is not a node
  return false;
}
function isFocusableFormField(element) {
  var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
  var isFocusable = matches.call(element, Constants.INPUT_SELECTOR);
  var isNotFocusable = matches.call(element, Constants.FOCUSABLE_EXCLUDE);
  var isElementVisible = isVisible(element);
  var focusable = isFocusable && !isNotFocusable && isElementVisible;
  return focusable;
}
function setDisplayed(element, displayed) {
  addOrRemoveCssClass(element, 'ag-hidden', !displayed);
}
function setVisible(element, visible) {
  addOrRemoveCssClass(element, 'ag-invisible', !visible);
}
function setDisabled(element, disabled) {
  var attributeName = 'disabled';
  var addOrRemoveDisabledAttribute = disabled ? function (e) {
    return e.setAttribute(attributeName, '');
  } : function (e) {
    return e.removeAttribute(attributeName);
  };
  addOrRemoveDisabledAttribute(element);
  nodeListForEach(element.querySelectorAll('input'), function (input) {
    return addOrRemoveDisabledAttribute(input);
  });
}
function isElementChildOfClass(element, cls, maxNest) {
  var counter = 0;
  while (element) {
    if (containsClass(element, cls)) {
      return true;
    }
    element = element.parentElement;
    if (maxNest && ++counter > maxNest) {
      break;
    }
  }
  return false;
}
// returns back sizes as doubles instead of strings. similar to
// getBoundingClientRect, however getBoundingClientRect does not:
// a) work with fractions (eg browser is zooming)
// b) has CSS transitions applied (eg CSS scale, browser zoom), which we don't want, we want the un-transitioned values
function getElementSize(el) {
  var _a = window.getComputedStyle(el),
    height = _a.height,
    width = _a.width,
    paddingTop = _a.paddingTop,
    paddingRight = _a.paddingRight,
    paddingBottom = _a.paddingBottom,
    paddingLeft = _a.paddingLeft,
    marginTop = _a.marginTop,
    marginRight = _a.marginRight,
    marginBottom = _a.marginBottom,
    marginLeft = _a.marginLeft,
    boxSizing = _a.boxSizing;
  return {
    height: parseFloat(height),
    width: parseFloat(width),
    paddingTop: parseFloat(paddingTop),
    paddingRight: parseFloat(paddingRight),
    paddingBottom: parseFloat(paddingBottom),
    paddingLeft: parseFloat(paddingLeft),
    marginTop: parseFloat(marginTop),
    marginRight: parseFloat(marginRight),
    marginBottom: parseFloat(marginBottom),
    marginLeft: parseFloat(marginLeft),
    boxSizing: boxSizing
  };
}
function getInnerHeight(el) {
  var size = getElementSize(el);
  if (size.boxSizing === 'border-box') {
    return size.height - size.paddingTop - size.paddingBottom;
  }
  return size.height;
}
function getInnerWidth(el) {
  var size = getElementSize(el);
  if (size.boxSizing === 'border-box') {
    return size.width - size.paddingLeft - size.paddingRight;
  }
  return size.width;
}
function getAbsoluteHeight(el) {
  var size = getElementSize(el);
  var marginRight = size.marginBottom + size.marginTop;
  return Math.ceil(el.offsetHeight + marginRight);
}
function getAbsoluteWidth(el) {
  var size = getElementSize(el);
  var marginWidth = size.marginLeft + size.marginRight;
  return Math.ceil(el.offsetWidth + marginWidth);
}
function isRtlNegativeScroll() {
  if (typeof rtlNegativeScroll === "boolean") {
    return rtlNegativeScroll;
  }
  var template = document.createElement('div');
  template.style.direction = 'rtl';
  template.style.width = '1px';
  template.style.height = '1px';
  template.style.position = 'fixed';
  template.style.top = '0px';
  template.style.overflow = 'hidden';
  template.dir = 'rtl';
  template.innerHTML = /* html */
  "<div style=\"width: 2px\">\n            <span style=\"display: inline-block; width: 1px\"></span>\n            <span style=\"display: inline-block; width: 1px\"></span>\n        </div>";
  document.body.appendChild(template);
  template.scrollLeft = 1;
  rtlNegativeScroll = Math.floor(template.scrollLeft) === 0;
  document.body.removeChild(template);
  return rtlNegativeScroll;
}
function getScrollLeft(element, rtl) {
  var scrollLeft = element.scrollLeft;
  if (rtl) {
    // Absolute value - for FF that reports RTL scrolls in negative numbers
    scrollLeft = Math.abs(scrollLeft);
    if (isBrowserChrome() && !isRtlNegativeScroll()) {
      scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
    }
  }
  return scrollLeft;
}
function setScrollLeft(element, value, rtl) {
  if (rtl) {
    // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
    if (isRtlNegativeScroll()) {
      value *= -1;
    } else if (isBrowserSafari() || isBrowserChrome()) {
      value = element.scrollWidth - element.clientWidth - value;
    }
  }
  element.scrollLeft = value;
}
function clearElement(el) {
  while (el && el.firstChild) {
    el.removeChild(el.firstChild);
  }
}
/** @deprecated */
function removeElement(parent, cssSelector) {
  removeFromParent(parent.querySelector(cssSelector));
}
function removeFromParent(node) {
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}
function isVisible(element) {
  return element.offsetParent !== null;
}
/**
 * Loads the template and returns it as an element. makes up for no simple way in
 * the dom api to load html directly, eg we cannot do this: document.createElement(template)
 * @param {string} template
 * @returns {HTMLElement}
 */
function loadTemplate(template) {
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = (template || '').trim();
  return tempDiv.firstChild;
}
function appendHtml(eContainer, htmlTemplate) {
  if (eContainer.lastChild) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
    // we put the items at the start, so new items appear underneath old items,
    // so when expanding/collapsing groups, the new rows don't go on top of the
    // rows below that are moving our of the way
    eContainer.insertAdjacentHTML('afterbegin', htmlTemplate);
  } else {
    eContainer.innerHTML = htmlTemplate;
  }
}
/** @deprecated */
function getElementAttribute(element, attributeName) {
  if (element.attributes && element.attributes[attributeName]) {
    var attribute = element.attributes[attributeName];
    return attribute.value;
  }
  return null;
}
function offsetHeight(element) {
  return element && element.clientHeight ? element.clientHeight : 0;
}
function offsetWidth(element) {
  return element && element.clientWidth ? element.clientWidth : 0;
}
function ensureDomOrder(eContainer, eChild, eChildBefore) {
  // if already in right order, do nothing
  if (eChildBefore && eChildBefore.nextSibling === eChild) {
    return;
  }
  if (eChildBefore) {
    if (eChildBefore.nextSibling) {
      // insert between the eRowBefore and the row after it
      eContainer.insertBefore(eChild, eChildBefore.nextSibling);
    } else {
      // if nextSibling is missing, means other row is at end, so just append new row at the end
      eContainer.appendChild(eChild);
    }
  } else {
    // otherwise put at start
    if (eContainer.firstChild && eContainer.firstChild !== eChild) {
      // insert it at the first location
      eContainer.insertAdjacentElement('afterbegin', eChild);
    }
  }
}
function setDomChildOrder(eContainer, orderedChildren) {
  for (var i = 0; i < orderedChildren.length; i++) {
    var correctCellAtIndex = orderedChildren[i];
    var actualCellAtIndex = eContainer.children[i];
    if (actualCellAtIndex !== correctCellAtIndex) {
      eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
  }
}
function insertWithDomOrder(eContainer, eToInsert, eChildBefore) {
  if (eChildBefore) {
    // if previous element exists, just slot in after the previous element
    eChildBefore.insertAdjacentElement('afterend', eToInsert);
  } else {
    if (eContainer.firstChild) {
      // insert it at the first location
      eContainer.insertAdjacentElement('afterbegin', eToInsert);
    } else {
      // otherwise eContainer is empty, so just append it
      eContainer.appendChild(eToInsert);
    }
  }
}
/** @deprecated */
function prependDC(parent, documentFragment) {
  if (exists(parent.firstChild)) {
    parent.insertBefore(documentFragment, parent.firstChild);
  } else {
    parent.appendChild(documentFragment);
  }
}
function addStylesToElement(eElement, styles) {
  if (!styles) {
    return;
  }
  Object.keys(styles).forEach(function (key) {
    var keyCamelCase = hyphenToCamelCase(key);
    if (keyCamelCase) {
      eElement.style[keyCamelCase] = styles[key];
    }
  });
}
function isHorizontalScrollShowing(element) {
  return element.clientWidth < element.scrollWidth;
}
function isVerticalScrollShowing(element) {
  return element.clientHeight < element.scrollHeight;
}
function setElementWidth(element, width) {
  if (width === 'flex') {
    element.style.removeProperty('width');
    element.style.removeProperty('minWidth');
    element.style.removeProperty('maxWidth');
    element.style.flex = '1 1 auto';
  } else {
    setFixedWidth(element, width);
  }
}
function setFixedWidth(element, width) {
  width = formatSize(width);
  element.style.width = width.toString();
  element.style.maxWidth = width.toString();
  element.style.minWidth = width.toString();
}
function setElementHeight(element, height) {
  if (height === 'flex') {
    element.style.removeProperty('height');
    element.style.removeProperty('minHeight');
    element.style.removeProperty('maxHeight');
    element.style.flex = '1 1 auto';
  } else {
    setFixedHeight(element, height);
  }
}
function setFixedHeight(element, height) {
  height = formatSize(height);
  element.style.height = height.toString();
  element.style.maxHeight = height.toString();
  element.style.minHeight = height.toString();
}
function formatSize(size) {
  if (typeof size === 'number') {
    return size + "px";
  }
  return size;
}
/**
 * Returns true if it is a DOM node
 * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
 * @param {any} o
 * @return {boolean}
 */
function isNode(o) {
  return typeof Node === 'function' ? o instanceof Node : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string';
}
//
/**
 * Returns true if it is a DOM element
 * taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
 * @param {any} o
 * @returns {boolean}
 */
function isElement$2(o) {
  return typeof HTMLElement === 'function' ? o instanceof HTMLElement //DOM2
  : o && isNonNullObject(o) && o.nodeType === 1 && typeof o.nodeName === 'string';
}
function isNodeOrElement(o) {
  return isNode(o) || isElement$2(o);
}
/**
 * Makes a copy of a node list into a list
 * @param {NodeList} nodeList
 * @returns {Node[]}
 */
function copyNodeList(nodeList) {
  if (nodeList == null) {
    return [];
  }
  var result = [];
  nodeListForEach(nodeList, function (node) {
    return result.push(node);
  });
  return result;
}
function iterateNamedNodeMap(map, callback) {
  if (!map) {
    return;
  }
  for (var i = 0; i < map.length; i++) {
    var attr = map[i];
    callback(attr.name, attr.value);
  }
}
/** @deprecated */
function setCheckboxState(eCheckbox, state) {
  if (typeof state === 'boolean') {
    eCheckbox.checked = state;
    eCheckbox.indeterminate = false;
  } else {
    // isNodeSelected returns back undefined if it's a group and the children
    // are a mix of selected and unselected
    eCheckbox.indeterminate = true;
  }
}
function addOrRemoveAttribute(element, name, value) {
  if (value == null) {
    element.removeAttribute(name);
  } else {
    element.setAttribute(name, value.toString());
  }
}
function nodeListForEach(nodeList, action) {
  if (nodeList == null) {
    return;
  }
  for (var i = 0; i < nodeList.length; i++) {
    action(nodeList[i]);
  }
}
var DomUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addCssClass: addCssClass,
  removeCssClass: removeCssClass,
  addOrRemoveCssClass: addOrRemoveCssClass,
  radioCssClass: radioCssClass,
  containsClass: containsClass,
  isFocusableFormField: isFocusableFormField,
  setDisplayed: setDisplayed,
  setVisible: setVisible,
  setDisabled: setDisabled,
  isElementChildOfClass: isElementChildOfClass,
  getElementSize: getElementSize,
  getInnerHeight: getInnerHeight,
  getInnerWidth: getInnerWidth,
  getAbsoluteHeight: getAbsoluteHeight,
  getAbsoluteWidth: getAbsoluteWidth,
  isRtlNegativeScroll: isRtlNegativeScroll,
  getScrollLeft: getScrollLeft,
  setScrollLeft: setScrollLeft,
  clearElement: clearElement,
  removeElement: removeElement,
  removeFromParent: removeFromParent,
  isVisible: isVisible,
  loadTemplate: loadTemplate,
  appendHtml: appendHtml,
  getElementAttribute: getElementAttribute,
  offsetHeight: offsetHeight,
  offsetWidth: offsetWidth,
  ensureDomOrder: ensureDomOrder,
  setDomChildOrder: setDomChildOrder,
  insertWithDomOrder: insertWithDomOrder,
  prependDC: prependDC,
  addStylesToElement: addStylesToElement,
  isHorizontalScrollShowing: isHorizontalScrollShowing,
  isVerticalScrollShowing: isVerticalScrollShowing,
  setElementWidth: setElementWidth,
  setFixedWidth: setFixedWidth,
  setElementHeight: setElementHeight,
  setFixedHeight: setFixedHeight,
  formatSize: formatSize,
  isNode: isNode,
  isElement: isElement$2,
  isNodeOrElement: isNodeOrElement,
  copyNodeList: copyNodeList,
  iterateNamedNodeMap: iterateNamedNodeMap,
  setCheckboxState: setCheckboxState,
  addOrRemoveAttribute: addOrRemoveAttribute,
  nodeListForEach: nodeListForEach
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/** @deprecated */
function getNameOfClass(theClass) {
  var funcNameRegex = /function (.{1,})\(/;
  var funcAsString = theClass.toString();
  var results = funcNameRegex.exec(funcAsString);
  return results && results.length > 1 ? results[1] : "";
}
function findLineByLeastSquares(values) {
  var len = values.length;
  var maxDecimals = 0;
  if (len <= 1) {
    return values;
  }
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    var splitExponent = value.toString().split('e-');
    if (splitExponent.length > 1) {
      maxDecimals = Math.max(maxDecimals, parseInt(splitExponent[1], 10));
      continue;
    }
    if (Math.floor(value) === value) {
      continue;
    }
    maxDecimals = Math.max(maxDecimals, value.toString().split('.')[1].length);
  }
  var sum_x = 0;
  var sum_y = 0;
  var sum_xy = 0;
  var sum_xx = 0;
  var y = 0;
  for (var x = 0; x < len; x++) {
    y = values[x];
    sum_x += x;
    sum_y += y;
    sum_xx += x * x;
    sum_xy += x * y;
  }
  var m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
  var b = sum_y / len - m * sum_x / len;
  var result = [];
  for (var x = 0; x <= len; x++) {
    result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
  }
  return result;
}
/**
 * Converts a CSS object into string
 * @param {Object} stylesToUse an object eg: {color: 'black', top: '25px'}
 * @return {string} A string like "color: black; top: 25px;" for html
 */
function cssStyleObjectToMarkup(stylesToUse) {
  if (!stylesToUse) {
    return '';
  }
  var resParts = [];
  iterateObject(stylesToUse, function (styleKey, styleValue) {
    var styleKeyDashed = camelCaseToHyphen(styleKey);
    resParts.push(styleKeyDashed + ": " + styleValue + ";");
  });
  return resParts.join(' ');
}
/**
 * Displays a message to the browser. this is useful in iPad, where you can't easily see the console.
 * so the javascript code can use this to give feedback. this is NOT intended to be called in production.
 * it is intended the AG Grid developer calls this to troubleshoot, but then takes out the calls before
 * checking in.
 * @param {string} msg
 */
function message(msg) {
  var eMessage = document.createElement('div');
  var eBox = document.querySelector('#__ag__message');
  eMessage.innerHTML = msg;
  if (!eBox) {
    var template = "<div id=\"__ag__message\" style=\"display: inline-block; position: absolute; top: 0px; left: 0px; color: white; background-color: black; z-index: 20; padding: 2px; border: 1px solid darkred; height: 200px; overflow-y: auto;\"></div>";
    eBox = loadTemplate(template);
    if (document.body) {
      document.body.appendChild(eBox);
    }
  }
  eBox.insertBefore(eMessage, eBox.children[0]);
}
/**
 * cell renderers are used in a few places. they bind to dom slightly differently to other cell renderes as they
 * can return back strings (instead of html elemnt) in the getGui() method. common code placed here to handle that.
 * @param {AgPromise<ICellRendererComp>} cellRendererPromise
 * @param {HTMLElement} eTarget
 */
function bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
  cellRendererPromise.then(function (cellRenderer) {
    var gui = cellRenderer.getGui();
    if (gui != null) {
      if (typeof gui === 'object') {
        eTarget.appendChild(gui);
      } else {
        eTarget.innerHTML = gui;
      }
    }
  });
}
var GeneralUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getNameOfClass: getNameOfClass,
  findLineByLeastSquares: findLineByLeastSquares,
  cssStyleObjectToMarkup: cssStyleObjectToMarkup,
  message: message,
  bindCellRendererToHtmlElement: bindCellRendererToHtmlElement
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// ARIA HELPER FUNCTIONS
function setAriaAttribute(element, attribute, value) {
  element.setAttribute(ariaAttributeName(attribute), value.toString());
}
function removeAriaAttribute(element, attribute) {
  element.removeAttribute(ariaAttributeName(attribute));
}
function ariaAttributeName(attribute) {
  return "aria-" + attribute;
}
function setAriaRole(element, role) {
  if (role) {
    element.setAttribute('role', role);
  } else {
    element.removeAttribute('role');
  }
}
function getAriaSortState(column) {
  var sort;
  if (column.isSortAscending()) {
    sort = 'ascending';
  } else if (column.isSortDescending()) {
    sort = 'descending';
  } else {
    sort = 'none';
  }
  return sort;
}
// ARIA ATTRIBUTE GETTERS
function getAriaLevel(element) {
  return parseInt(element.getAttribute('aria-level'), 10);
}
function getAriaPosInSet(element) {
  return parseInt(element.getAttribute('aria-posinset'), 10);
}
function getAriaDescribedBy(element) {
  return element.getAttribute('aria-describedby') || '';
}
// ARIA ATTRIBUTE SETTERS
function _setAriaLabel(element, label) {
  var key = 'label';
  if (label) {
    setAriaAttribute(element, key, label);
  } else {
    removeAriaAttribute(element, key);
  }
}
function setAriaLabelledBy(element, labelledBy) {
  var key = 'labelledby';
  if (labelledBy) {
    setAriaAttribute(element, key, labelledBy);
  } else {
    removeAriaAttribute(element, key);
  }
}
function _setAriaDescribedBy(element, describedby) {
  var key = 'describedby';
  if (describedby) {
    setAriaAttribute(element, key, describedby);
  } else {
    removeAriaAttribute(element, key);
  }
}
function setAriaLevel(element, level) {
  setAriaAttribute(element, 'level', level);
}
function setAriaDisabled(element, disabled) {
  setAriaAttribute(element, 'disabled', disabled);
}
function _setAriaExpanded(element, expanded) {
  setAriaAttribute(element, 'expanded', expanded);
}
function removeAriaExpanded(element) {
  removeAriaAttribute(element, 'expanded');
}
function setAriaSetSize(element, setsize) {
  setAriaAttribute(element, 'setsize', setsize);
}
function setAriaPosInSet(element, position) {
  setAriaAttribute(element, 'posinset', position);
}
function setAriaMultiSelectable(element, multiSelectable) {
  setAriaAttribute(element, 'multiselectable', multiSelectable);
}
function setAriaRowCount(element, rowCount) {
  setAriaAttribute(element, 'rowcount', rowCount);
}
function _setAriaRowIndex(element, rowIndex) {
  setAriaAttribute(element, 'rowindex', rowIndex);
}
function setAriaColCount(element, colCount) {
  setAriaAttribute(element, 'colcount', colCount);
}
function _setAriaColIndex(element, colIndex) {
  setAriaAttribute(element, 'colindex', colIndex);
}
function setAriaColSpan(element, colSpan) {
  setAriaAttribute(element, 'colspan', colSpan);
}
function _setAriaSort(element, sort) {
  setAriaAttribute(element, 'sort', sort);
}
function removeAriaSort(element) {
  removeAriaAttribute(element, 'sort');
}
function _setAriaSelected(element, selected) {
  var attributeName = 'selected';
  if (selected) {
    setAriaAttribute(element, attributeName, selected);
  } else {
    removeAriaAttribute(element, attributeName);
  }
}
function setAriaChecked(element, checked) {
  setAriaAttribute(element, 'checked', checked === undefined ? 'mixed' : checked);
}
var AriaUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setAriaRole: setAriaRole,
  getAriaSortState: getAriaSortState,
  getAriaLevel: getAriaLevel,
  getAriaPosInSet: getAriaPosInSet,
  getAriaDescribedBy: getAriaDescribedBy,
  setAriaLabel: _setAriaLabel,
  setAriaLabelledBy: setAriaLabelledBy,
  setAriaDescribedBy: _setAriaDescribedBy,
  setAriaLevel: setAriaLevel,
  setAriaDisabled: setAriaDisabled,
  setAriaExpanded: _setAriaExpanded,
  removeAriaExpanded: removeAriaExpanded,
  setAriaSetSize: setAriaSetSize,
  setAriaPosInSet: setAriaPosInSet,
  setAriaMultiSelectable: setAriaMultiSelectable,
  setAriaRowCount: setAriaRowCount,
  setAriaRowIndex: _setAriaRowIndex,
  setAriaColCount: setAriaColCount,
  setAriaColIndex: _setAriaColIndex,
  setAriaColSpan: setAriaColSpan,
  setAriaSort: _setAriaSort,
  removeAriaSort: removeAriaSort,
  setAriaSelected: _setAriaSelected,
  setAriaChecked: setAriaChecked
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * Serialises a Date to a string of format `yyyy-MM-dd HH:mm:ss`.
 * An alternative separator can be provided to be used instead of hyphens.
 * @param date The date to serialise
 * @param includeTime Whether to include the time in the serialised string
 * @param separator The separator to use between date parts
 */
function serialiseDate(date, includeTime, separator) {
  if (includeTime === void 0) {
    includeTime = true;
  }
  if (separator === void 0) {
    separator = '-';
  }
  if (!date) {
    return null;
  }
  var serialised = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(function (part) {
    return padStartWidthZeros(part, 2);
  }).join(separator);
  if (includeTime) {
    serialised += ' ' + [date.getHours(), date.getMinutes(), date.getSeconds()].map(function (part) {
      return padStartWidthZeros(part, 2);
    }).join(':');
  }
  return serialised;
}
/**
 * Parses a date and time from a string in the format `yyyy-MM-dd HH:mm:ss`
 */
function parseDateTimeFromString(value) {
  if (!value) {
    return null;
  }
  var _a = value.split(' '),
    dateStr = _a[0],
    timeStr = _a[1];
  if (!dateStr) {
    return null;
  }
  var fields = dateStr.split('-').map(function (f) {
    return parseInt(f, 10);
  });
  if (fields.filter(function (f) {
    return !isNaN(f);
  }).length !== 3) {
    return null;
  }
  var year = fields[0],
    month = fields[1],
    day = fields[2];
  var date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    // date was not parsed as expected so must have been invalid
    return null;
  }
  if (!timeStr || timeStr === '00:00:00') {
    return date;
  }
  var _b = timeStr.split(':').map(function (part) {
      return parseInt(part, 10);
    }),
    hours = _b[0],
    minutes = _b[1],
    seconds = _b[2];
  if (hours >= 0 && hours < 24) {
    date.setHours(hours);
  }
  if (minutes >= 0 && minutes < 60) {
    date.setMinutes(minutes);
  }
  if (seconds >= 0 && seconds < 60) {
    date.setSeconds(seconds);
  }
  return date;
}
var DateUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  serialiseDate: serialiseDate,
  parseDateTimeFromString: parseDateTimeFromString
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
  var fuzzyMatches = {};
  var invalidInputs = inputValues.filter(function (inputValue) {
    return !validValues.some(function (validValue) {
      return validValue === inputValue;
    });
  });
  if (invalidInputs.length > 0) {
    invalidInputs.forEach(function (invalidInput) {
      return fuzzyMatches[invalidInput] = fuzzySuggestions(invalidInput, allSuggestions);
    });
  }
  return fuzzyMatches;
}
/**
 *
 * @param {String} inputValue The value to be compared against a list of strings
 * @param allSuggestions The list of strings to be compared against
 * @param hideIrrelevant By default, fuzzy suggestions will just sort the allSuggestions list, set this to true
 *        to filter out the irrelevant values
 * @param weighted Set this to true, to make letters matched in the order they were typed have priority in the results.
 */
function fuzzySuggestions(inputValue, allSuggestions, hideIrrelevant, weighted) {
  var search = weighted ? string_weighted_distances : string_distances;
  var thisSuggestions = allSuggestions.map(function (text) {
    return {
      value: text,
      relevance: search(inputValue.toLowerCase(), text.toLocaleLowerCase())
    };
  });
  thisSuggestions.sort(function (a, b) {
    return b.relevance - a.relevance;
  });
  if (hideIrrelevant) {
    thisSuggestions = thisSuggestions.filter(function (suggestion) {
      return suggestion.relevance !== 0;
    });
  }
  return thisSuggestions.map(function (suggestion) {
    return suggestion.value;
  });
}
/**
 * Algorithm to do fuzzy search
 * from https://stackoverflow.com/questions/23305000/javascript-fuzzy-search-that-makes-sense
 * @param {string} from
 * @return {[]}
 */
function get_bigrams(from) {
  var s = from.toLowerCase();
  var v = new Array(s.length - 1);
  var i;
  var j;
  var ref;
  for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
    v[i] = s.slice(i, i + 2);
  }
  return v;
}
function string_distances(str1, str2) {
  if (str1.length === 0 && str2.length === 0) {
    return 0;
  }
  var pairs1 = get_bigrams(str1);
  var pairs2 = get_bigrams(str2);
  var union = pairs1.length + pairs2.length;
  var hit_count = 0;
  var j;
  var len;
  for (j = 0, len = pairs1.length; j < len; j++) {
    var x = pairs1[j];
    var k = void 0;
    var len1 = void 0;
    for (k = 0, len1 = pairs2.length; k < len1; k++) {
      var y = pairs2[k];
      if (x === y) {
        hit_count++;
      }
    }
  }
  return hit_count > 0 ? 2 * hit_count / union : 0;
}
function string_weighted_distances(str1, str2) {
  var a = str1.replace(/\s/g, '');
  var b = str2.replace(/\s/g, '');
  var weight = 0;
  var lastIndex = 0;
  for (var i = 0; i < a.length; i++) {
    var idx = b.indexOf(a[i], lastIndex);
    if (idx === -1) {
      continue;
    }
    lastIndex = idx;
    weight += 100 - lastIndex * 100 / 10000 * 100;
  }
  return weight;
}
var FuzzyMatchUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fuzzyCheckStrings: fuzzyCheckStrings,
  fuzzySuggestions: fuzzySuggestions,
  get_bigrams: get_bigrams,
  string_distances: string_distances,
  string_weighted_distances: string_weighted_distances
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
//
// IMPORTANT NOTE!
//
// If you change the list below, copy/paste the new content into the docs page javascript-grid-icons
//
var iconNameClassMap = {
  // header column group shown when expanded (click to contract)
  columnGroupOpened: 'expanded',
  // header column group shown when contracted (click to expand)
  columnGroupClosed: 'contracted',
  // tool panel column group contracted (click to expand)
  columnSelectClosed: 'tree-closed',
  // tool panel column group expanded (click to contract)
  columnSelectOpen: 'tree-open',
  // column tool panel header expand/collapse all button, shown when some children are expanded and
  //     others are collapsed
  columnSelectIndeterminate: 'tree-indeterminate',
  // shown on ghost icon while dragging column to the side of the grid to pin
  columnMovePin: 'pin',
  // shown on ghost icon while dragging over part of the page that is not a drop zone
  columnMoveHide: 'eye-slash',
  // shown on ghost icon while dragging columns to reorder
  columnMoveMove: 'arrows',
  // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
  columnMoveLeft: 'left',
  // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
  columnMoveRight: 'right',
  // shown on ghost icon while dragging over Row Groups drop zone
  columnMoveGroup: 'group',
  // shown on ghost icon while dragging over Values drop zone
  columnMoveValue: 'aggregation',
  // shown on ghost icon while dragging over pivot drop zone
  columnMovePivot: 'pivot',
  // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
  //     string column over aggregation drop zone
  dropNotAllowed: 'not-allowed',
  // shown on row group when contracted (click to expand)
  groupContracted: 'tree-closed',
  // shown on row group when expanded (click to contract)
  groupExpanded: 'tree-open',
  // context menu chart item
  chart: 'chart',
  // chart window title bar
  close: 'cross',
  // X (remove) on column 'pill' after adding it to a drop zone list
  cancel: 'cancel',
  // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
  check: 'tick',
  // "go to first" button in pagination controls
  first: 'first',
  // "go to previous" button in pagination controls
  previous: 'previous',
  // "go to next" button in pagination controls
  next: 'next',
  // "go to last" button in pagination controls
  last: 'last',
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: 'linked',
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: 'unlinked',
  // "Choose colour" button on chart settings tab
  colorPicker: 'color-picker',
  // rotating spinner shown by the loading cell renderer
  groupLoading: 'loading',
  // button to launch enterprise column menu
  menu: 'menu',
  // filter tool panel tab
  filter: 'filter',
  // column tool panel tab
  columns: 'columns',
  // button in chart regular size window title bar (click to maximise)
  maximize: 'maximize',
  // button in chart maximised window title bar (click to make regular size)
  minimize: 'minimize',
  // "Pin column" item in column header menu
  menuPin: 'pin',
  // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
  menuValue: 'aggregation',
  // "Group by {column-name}" item in column header menu
  menuAddRowGroup: 'group',
  // "Un-Group by {column-name}" item in column header menu
  menuRemoveRowGroup: 'group',
  // context menu copy item
  clipboardCopy: 'copy',
  // context menu paste item
  clipboardPaste: 'paste',
  // identifies the pivot drop zone
  pivotPanel: 'pivot',
  // "Row groups" drop zone in column tool panel
  rowGroupPanel: 'group',
  // columns tool panel Values drop zone
  valuePanel: 'aggregation',
  // drag handle used to pick up draggable columns
  columnDrag: 'grip',
  // drag handle used to pick up draggable rows
  rowDrag: 'grip',
  // context menu export item
  save: 'save',
  // csv export
  csvExport: 'csv',
  // excel export,
  excelExport: 'excel',
  // icon on dropdown editors
  smallDown: 'small-down',
  // version of small-right used in RTL mode
  smallLeft: 'small-left',
  // separater between column 'pills' when you add multiple columns to the header drop zone
  smallRight: 'small-right',
  smallUp: 'small-up',
  // show on column header when column is sorted ascending
  sortAscending: 'asc',
  // show on column header when column is sorted descending
  sortDescending: 'desc',
  // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
  sortUnSort: 'none'
};
/**
 * If icon provided, use this (either a string, or a function callback).
 * if not, then use the default icon from the theme
 * @param {string} iconName
 * @param {GridOptionsWrapper} gridOptionsWrapper
 * @param {Column | null} [column]
 * @returns {HTMLElement}
 */
function createIcon(iconName, gridOptionsWrapper, column) {
  var iconContents = createIconNoSpan(iconName, gridOptionsWrapper, column);
  if (iconContents && iconContents.className.indexOf('ag-icon') > -1) {
    return iconContents;
  }
  var eResult = document.createElement('span');
  eResult.appendChild(iconContents);
  return eResult;
}
function createIconNoSpan(iconName, gridOptionsWrapper, column, forceCreate) {
  var userProvidedIcon = null;
  // check col for icon first
  var icons = column && column.getColDef().icons;
  if (icons) {
    userProvidedIcon = icons[iconName];
  }
  // if not in col, try grid options
  if (gridOptionsWrapper && !userProvidedIcon) {
    var optionsIcons = gridOptionsWrapper.getIcons();
    if (optionsIcons) {
      userProvidedIcon = optionsIcons[iconName];
    }
  }
  // now if user provided, use it
  if (userProvidedIcon) {
    var rendererResult = void 0;
    if (typeof userProvidedIcon === 'function') {
      rendererResult = userProvidedIcon();
    } else if (typeof userProvidedIcon === 'string') {
      rendererResult = userProvidedIcon;
    } else {
      throw new Error('icon from grid options needs to be a string or a function');
    }
    if (typeof rendererResult === 'string') {
      return loadTemplate(rendererResult);
    }
    if (isNodeOrElement(rendererResult)) {
      return rendererResult;
    }
    console.warn('AG Grid: iconRenderer should return back a string or a dom object');
  } else {
    var span = document.createElement('span');
    var cssClass = iconNameClassMap[iconName];
    if (!cssClass) {
      if (!forceCreate) {
        console.warn("AG Grid: Did not find icon " + iconName);
        cssClass = '';
      } else {
        cssClass = iconName;
      }
    }
    span.setAttribute('class', "ag-icon ag-icon-" + cssClass);
    span.setAttribute('unselectable', 'on');
    setAriaRole(span, 'presentation');
    return span;
  }
}
var IconUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  iconNameClassMap: iconNameClassMap,
  createIcon: createIcon,
  createIconNoSpan: createIconNoSpan
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var NUMPAD_DEL_NUMLOCK_ON_KEY = 'Del';
var NUMPAD_DEL_NUMLOCK_ON_CHARCODE = 46;
function isKeyPressed(event, keyToCheck) {
  return (event.which || event.keyCode) === keyToCheck;
}
function isEventFromPrintableCharacter(event) {
  // no allowed printable chars have alt or ctrl key combinations
  if (event.altKey || event.ctrlKey || event.metaKey) {
    return false;
  }
  // if key is length 1, eg if it is 'a' for the a key, or '2' for the '2' key.
  // non-printable characters have names, eg 'Enter' or 'Backspace'.
  var printableCharacter = event.key.length === 1;
  // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key,
  // so this addition checks if its IE11/Edge and handles that specific case the same was as all other browsers
  var numpadDelWithNumlockOnForEdgeOrIe = isNumpadDelWithNumlockOnForEdgeOrIe(event);
  return printableCharacter || numpadDelWithNumlockOnForEdgeOrIe;
}
/**
 * Allows user to tell the grid to skip specific keyboard events
 * @param {GridOptionsWrapper} gridOptionsWrapper
 * @param {KeyboardEvent} keyboardEvent
 * @param {RowNode} rowNode
 * @param {Column} column
 * @param {boolean} editing
 * @returns {boolean}
 */
function isUserSuppressingKeyboardEvent(gridOptionsWrapper, keyboardEvent, rowNode, column, editing) {
  var gridOptionsFunc = gridOptionsWrapper.getSuppressKeyboardEventFunc();
  var colDefFunc = column ? column.getColDef().suppressKeyboardEvent : undefined;
  // if no callbacks provided by user, then do nothing
  if (!gridOptionsFunc && !colDefFunc) {
    return false;
  }
  var params = {
    event: keyboardEvent,
    editing: editing,
    column: column,
    api: gridOptionsWrapper.getApi(),
    node: rowNode,
    data: rowNode.data,
    colDef: column.getColDef(),
    context: gridOptionsWrapper.getContext(),
    columnApi: gridOptionsWrapper.getColumnApi()
  };
  // colDef get first preference on suppressing events
  if (colDefFunc) {
    var colDefFuncResult = colDefFunc(params);
    // if colDef func suppressed, then return now, no need to call gridOption func
    if (colDefFuncResult) {
      return true;
    }
  }
  if (gridOptionsFunc) {
    // if gridOption func, return the result
    return gridOptionsFunc(params);
  }
  // otherwise return false, don't suppress, as colDef didn't suppress and no func on gridOptions
  return false;
}
function isUserSuppressingHeaderKeyboardEvent(gridOptionsWrapper, keyboardEvent, headerRowIndex, column) {
  var colDef = column.getDefinition();
  var colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
  if (!exists(colDefFunc)) {
    return false;
  }
  var params = {
    api: gridOptionsWrapper.getApi(),
    columnApi: gridOptionsWrapper.getColumnApi(),
    context: gridOptionsWrapper.getContext(),
    colDef: colDef,
    column: column,
    headerRowIndex: headerRowIndex,
    event: keyboardEvent
  };
  return !!colDefFunc(params);
}
function isNumpadDelWithNumlockOnForEdgeOrIe(event) {
  return (isBrowserEdge() || isBrowserIE()) && event.key === NUMPAD_DEL_NUMLOCK_ON_KEY && event.charCode === NUMPAD_DEL_NUMLOCK_ON_CHARCODE;
}
var KeyboardUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isKeyPressed: isKeyPressed,
  isEventFromPrintableCharacter: isEventFromPrintableCharacter,
  isUserSuppressingKeyboardEvent: isUserSuppressingKeyboardEvent,
  isUserSuppressingHeaderKeyboardEvent: isUserSuppressingHeaderKeyboardEvent
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * @deprecated
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 * from: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
 * @param {any} event
 * @return {any}
 */
function normalizeWheel(event) {
  var PIXEL_STEP = 10;
  var LINE_HEIGHT = 40;
  var PAGE_HEIGHT = 800;
  // spinX, spinY
  var sX = 0;
  var sY = 0;
  // pixelX, pixelY
  var pX = 0;
  var pY = 0;
  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }
  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }
  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;
  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }
  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }
  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }
  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
}
/**
 * @deprecated
 * Checks if event was issued by a left click
 * from https://stackoverflow.com/questions/3944122/detect-left-mouse-button-press
 * @param {MouseEvent} mouseEvent
 * @returns {boolean}
 */
function isLeftClick(mouseEvent) {
  if ('buttons' in mouseEvent) {
    return mouseEvent.buttons == 1;
  }
  var button = mouseEvent.which || mouseEvent.button;
  return button == 1;
}
/**
 * `True` if the event is close to the original event by X pixels either vertically or horizontally.
 * we only start dragging after X pixels so this allows us to know if we should start dragging yet.
 * @param {MouseEvent | TouchEvent} e1
 * @param {MouseEvent | TouchEvent} e2
 * @param {number} pixelCount
 * @returns {boolean}
 */
function areEventsNear(e1, e2, pixelCount) {
  // by default, we wait 4 pixels before starting the drag
  if (pixelCount === 0) {
    return false;
  }
  var diffX = Math.abs(e1.clientX - e2.clientX);
  var diffY = Math.abs(e1.clientY - e2.clientY);
  return Math.max(diffX, diffY) <= pixelCount;
}
var MouseUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  normalizeWheel: normalizeWheel,
  isLeftClick: isLeftClick,
  areEventsNear: areEventsNear
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * Gets called by: a) ClientSideNodeManager and b) GroupStage to do sorting.
 * when in ClientSideNodeManager we always have indexes (as this sorts the items the
 * user provided) but when in GroupStage, the nodes can contain filler nodes that
 * don't have order id's
 * @param {RowNode[]} rowNodes
 * @param {Object} rowNodeOrder
 */
function sortRowNodesByOrder(rowNodes, rowNodeOrder) {
  if (!rowNodes) {
    return;
  }
  var comparator = function comparator(nodeA, nodeB) {
    var positionA = rowNodeOrder[nodeA.id];
    var positionB = rowNodeOrder[nodeB.id];
    var aHasIndex = positionA !== undefined;
    var bHasIndex = positionB !== undefined;
    var bothNodesAreUserNodes = aHasIndex && bHasIndex;
    var bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
    if (bothNodesAreUserNodes) {
      // when comparing two nodes the user has provided, they always
      // have indexes
      return positionA - positionB;
    }
    if (bothNodesAreFillerNodes) {
      // when comparing two filler nodes, we have no index to compare them
      // against, however we want this sorting to be deterministic, so that
      // the rows don't jump around as the user does delta updates. so we
      // want the same sort result. so we use the __objectId - which doesn't make sense
      // from a sorting point of view, but does give consistent behaviour between
      // calls. otherwise groups jump around as delta updates are done.
      // note: previously here we used nodeId, however this gave a strange order
      // as string ordering of numbers is wrong, so using id based on creation order
      // as least gives better looking order.
      return nodeA.__objectId - nodeB.__objectId;
    }
    if (aHasIndex) {
      return 1;
    }
    return -1;
  };
  // check if the list first needs sorting
  var rowNodeA;
  var rowNodeB;
  var atLeastOneOutOfOrder = false;
  for (var i = 0; i < rowNodes.length - 1; i++) {
    rowNodeA = rowNodes[i];
    rowNodeB = rowNodes[i + 1];
    if (comparator(rowNodeA, rowNodeB) > 0) {
      atLeastOneOutOfOrder = true;
      break;
    }
  }
  if (atLeastOneOutOfOrder) {
    rowNodes.sort(comparator);
  }
}
function traverseNodesWithKey(nodes, callback) {
  var keyParts = [];
  recursiveSearchNodes(nodes);
  function recursiveSearchNodes(currentNodes) {
    if (!currentNodes) {
      return;
    }
    currentNodes.forEach(function (node) {
      // also checking for children for tree data
      if (node.group || node.hasChildren()) {
        keyParts.push(node.key);
        var key = keyParts.join('|');
        callback(node, key);
        recursiveSearchNodes(node.childrenAfterGroup);
        keyParts.pop();
      }
    });
  }
}
var RowNodeUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sortRowNodesByOrder: sortRowNodesByOrder,
  traverseNodesWithKey: traverseNodesWithKey
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function convertToSet(list) {
  var set = new Set();
  list.forEach(function (x) {
    return set.add(x);
  });
  return set;
}
var SetUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertToSet: convertToSet
});

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __assign$2 = undefined && undefined.__assign || function () {
  __assign$2 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
var utils = __assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2(__assign$2({}, GeneralUtils), AriaUtils), ArrayUtils), BrowserUtils), CsvUtils), DateUtils), DomUtils), EventUtils), FunctionUtils), FuzzyMatchUtils), GenericUtils), IconUtils), KeyboardUtils), MapUtils), MouseUtils), NumberUtils), ObjectUtils), RowNodeUtils), SetUtils), StringUtils);
var _ = utils;

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var NumberSequence = /** @class */function () {
  function NumberSequence(initValue, step) {
    if (initValue === void 0) {
      initValue = 0;
    }
    if (step === void 0) {
      step = 1;
    }
    this.nextValue = initValue;
    this.step = step;
  }
  NumberSequence.prototype.next = function () {
    var valToReturn = this.nextValue;
    this.nextValue += this.step;
    return valToReturn;
  };
  NumberSequence.prototype.peek = function () {
    return this.nextValue;
  };
  NumberSequence.prototype.skip = function (count) {
    this.nextValue += count;
  };
  return NumberSequence;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var AgPromiseStatus;
(function (AgPromiseStatus) {
  AgPromiseStatus[AgPromiseStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
  AgPromiseStatus[AgPromiseStatus["RESOLVED"] = 1] = "RESOLVED";
})(AgPromiseStatus || (AgPromiseStatus = {}));
var AgPromise = /** @class */function () {
  function AgPromise(callback) {
    var _this = this;
    this.status = AgPromiseStatus.IN_PROGRESS;
    this.resolution = null;
    this.waiters = [];
    callback(function (value) {
      return _this.onDone(value);
    }, function (params) {
      return _this.onReject(params);
    });
  }
  AgPromise.all = function (promises) {
    return new AgPromise(function (resolve) {
      var remainingToResolve = promises.length;
      var combinedValues = new Array(remainingToResolve);
      forEach$4(promises, function (promise, index) {
        promise.then(function (value) {
          combinedValues[index] = value;
          remainingToResolve--;
          if (remainingToResolve === 0) {
            resolve(combinedValues);
          }
        });
      });
    });
  };
  AgPromise.resolve = function (value) {
    if (value === void 0) {
      value = null;
    }
    return new AgPromise(function (resolve) {
      return resolve(value);
    });
  };
  AgPromise.prototype.then = function (func) {
    var _this = this;
    return new AgPromise(function (resolve) {
      if (_this.status === AgPromiseStatus.RESOLVED) {
        resolve(func(_this.resolution));
      } else {
        _this.waiters.push(function (value) {
          return resolve(func(value));
        });
      }
    });
  };
  AgPromise.prototype.resolveNow = function (ifNotResolvedValue, ifResolved) {
    return this.status === AgPromiseStatus.RESOLVED ? ifResolved(this.resolution) : ifNotResolvedValue;
  };
  AgPromise.prototype.onDone = function (value) {
    this.status = AgPromiseStatus.RESOLVED;
    this.resolution = value;
    forEach$4(this.waiters, function (waiter) {
      return waiter(value);
    });
  };
  AgPromise.prototype.onReject = function (params) {
    console.warn('TBI');
  };
  return AgPromise;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/**
 * A Util Class only used when debugging for printing time to console
 */
var Timer = /** @class */function () {
  function Timer() {
    this.timestamp = new Date().getTime();
  }
  Timer.prototype.print = function (msg) {
    var duration = new Date().getTime() - this.timestamp;
    console.info(msg + " = " + duration);
    this.timestamp = new Date().getTime();
  };
  return Timer;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$6 = undefined && undefined.__extends || function () {
  var _extendStatics7 = function extendStatics(d, b) {
    _extendStatics7 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics7(d, b);
  };
  return function (d, b) {
    _extendStatics7(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$3 = undefined && undefined.__assign || function () {
  __assign$3 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$3.apply(this, arguments);
};
var __decorate$9 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TooltipStates;
(function (TooltipStates) {
  TooltipStates[TooltipStates["NOTHING"] = 0] = "NOTHING";
  TooltipStates[TooltipStates["WAITING_TO_SHOW"] = 1] = "WAITING_TO_SHOW";
  TooltipStates[TooltipStates["SHOWING"] = 2] = "SHOWING";
})(TooltipStates || (TooltipStates = {}));
var CustomTooltipFeature = /** @class */function (_super) {
  __extends$6(CustomTooltipFeature, _super);
  function CustomTooltipFeature(parentComp) {
    var _this = _super.call(this) || this;
    _this.DEFAULT_HIDE_TOOLTIP_TIMEOUT = 10000;
    _this.SHOW_QUICK_TOOLTIP_DIFF = 1000;
    _this.FADE_OUT_TOOLTIP_TIMEOUT = 1000;
    _this.state = TooltipStates.NOTHING;
    // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
    // async we could request two tooltips before the first instance returns, in which case we should
    // disregard the second instance.
    _this.tooltipInstanceCount = 0;
    _this.tooltipMouseTrack = false;
    _this.parentComp = parentComp;
    return _this;
  }
  CustomTooltipFeature.prototype.postConstruct = function () {
    this.tooltipShowDelay = this.gridOptionsWrapper.getTooltipShowDelay() || 2000;
    this.tooltipMouseTrack = this.gridOptionsWrapper.isTooltipMouseTrack();
    var el = this.parentComp.getGui();
    this.addManagedListener(el, 'mouseenter', this.onMouseEnter.bind(this));
    this.addManagedListener(el, 'mouseleave', this.onMouseLeave.bind(this));
    this.addManagedListener(el, 'mousemove', this.onMouseMove.bind(this));
    this.addManagedListener(el, 'mousedown', this.onMouseDown.bind(this));
    this.addManagedListener(el, 'keydown', this.onKeyDown.bind(this));
  };
  CustomTooltipFeature.prototype.destroy = function () {
    // if this component gets destroyed while tooltip is showing, need to make sure
    // we don't end with no mouseLeave event resulting in zombie tooltip
    this.setToDoNothing();
    _super.prototype.destroy.call(this);
  };
  CustomTooltipFeature.prototype.onMouseEnter = function (e) {
    if (isIOSUserAgent()) {
      return;
    }
    // every mouseenter should be following by a mouseleave, however for some unkonwn, it's possible for
    // mouseenter to be called twice in a row, which can happen if editing the cell. this was reported
    // in https://ag-grid.atlassian.net/browse/AG-4422. to get around this, we check the state, and if
    // state is !=nothing, then we know mouseenter was already received.
    if (this.state != TooltipStates.NOTHING) {
      return;
    }
    // if another tooltip was hidden very recently, we only wait 200ms to show, not the normal waiting time
    var delay = this.isLastTooltipHiddenRecently() ? 200 : this.tooltipShowDelay;
    this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
    this.lastMouseEvent = e;
    this.state = TooltipStates.WAITING_TO_SHOW;
  };
  CustomTooltipFeature.prototype.onMouseLeave = function () {
    this.setToDoNothing();
  };
  CustomTooltipFeature.prototype.onKeyDown = function () {
    this.setToDoNothing();
  };
  CustomTooltipFeature.prototype.setToDoNothing = function () {
    if (this.state === TooltipStates.SHOWING) {
      this.hideTooltip();
    }
    this.clearTimeouts();
    this.state = TooltipStates.NOTHING;
  };
  CustomTooltipFeature.prototype.onMouseMove = function (e) {
    // there is a delay from the time we mouseOver a component and the time the
    // tooltip is displayed, so we need to track mousemove to be able to correctly
    // position the tooltip when showTooltip is called.
    this.lastMouseEvent = e;
    if (this.tooltipMouseTrack && this.state === TooltipStates.SHOWING && this.tooltipComp) {
      this.positionTooltipUnderLastMouseEvent();
    }
  };
  CustomTooltipFeature.prototype.onMouseDown = function () {
    this.setToDoNothing();
  };
  CustomTooltipFeature.prototype.hideTooltip = function () {
    // check if comp exists - due to async, although we asked for
    // one, the instance may not be back yet
    if (this.tooltipComp) {
      this.destroyTooltipComp();
      CustomTooltipFeature.lastTooltipHideTime = new Date().getTime();
    }
    this.state = TooltipStates.NOTHING;
  };
  CustomTooltipFeature.prototype.destroyTooltipComp = function () {
    var _this = this;
    // add class to fade out the tooltip
    addCssClass(this.tooltipComp.getGui(), 'ag-tooltip-hiding');
    // make local copies of these variables, as we use them in the async function below,
    // and we clear then to 'undefined' later, so need to take a copy before they are undefined.
    var tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
    var tooltipComp = this.tooltipComp;
    window.setTimeout(function () {
      tooltipPopupDestroyFunc();
      _this.getContext().destroyBean(tooltipComp);
    }, this.FADE_OUT_TOOLTIP_TIMEOUT);
    this.tooltipPopupDestroyFunc = undefined;
    this.tooltipComp = undefined;
  };
  CustomTooltipFeature.prototype.isLastTooltipHiddenRecently = function () {
    // return true if <1000ms since last time we hid a tooltip
    var now = new Date().getTime();
    var then = CustomTooltipFeature.lastTooltipHideTime;
    return now - then < this.SHOW_QUICK_TOOLTIP_DIFF;
  };
  CustomTooltipFeature.prototype.showTooltip = function () {
    var params = __assign$3({
      api: this.gridApi,
      columnApi: this.columnApi,
      context: this.gridOptionsWrapper.getContext()
    }, this.parentComp.getTooltipParams());
    if (!exists(params.value)) {
      this.setToDoNothing();
      return;
    }
    this.state = TooltipStates.SHOWING;
    this.tooltipInstanceCount++;
    // we pass in tooltipInstanceCount so the callback knows what the count was when
    // we requested the tooltip, so if another tooltip was requested in the mean time
    // we disregard it
    var callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
    var userDetails = this.userComponentFactory.getTooltipCompDetails(params);
    userDetails.newAgStackInstance().then(callback);
  };
  CustomTooltipFeature.prototype.newTooltipComponentCallback = function (tooltipInstanceCopy, tooltipComp) {
    var compNoLongerNeeded = this.state !== TooltipStates.SHOWING || this.tooltipInstanceCount !== tooltipInstanceCopy;
    if (compNoLongerNeeded) {
      this.getContext().destroyBean(tooltipComp);
      return;
    }
    var eGui = tooltipComp.getGui();
    this.tooltipComp = tooltipComp;
    if (!containsClass(eGui, 'ag-tooltip')) {
      addCssClass(eGui, 'ag-tooltip-custom');
    }
    if (this.gridOptionsWrapper.isReactUi()) {
      addCssClass(eGui, 'ag-tooltip-reactui');
    }
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      eChild: eGui,
      ariaLabel: translate('ariaLabelTooltip', 'Tooltip')
    });
    if (addPopupRes) {
      this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
    }
    // this.tooltipPopupDestroyFunc = this.popupService.addPopup(false, eGui, false);
    this.positionTooltipUnderLastMouseEvent();
    this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.DEFAULT_HIDE_TOOLTIP_TIMEOUT);
  };
  CustomTooltipFeature.prototype.positionTooltipUnderLastMouseEvent = function () {
    this.popupService.positionPopupUnderMouseEvent({
      type: 'tooltip',
      mouseEvent: this.lastMouseEvent,
      ePopup: this.tooltipComp.getGui(),
      nudgeY: 18
    });
  };
  CustomTooltipFeature.prototype.clearTimeouts = function () {
    if (this.showTooltipTimeoutId) {
      window.clearTimeout(this.showTooltipTimeoutId);
      this.showTooltipTimeoutId = undefined;
    }
    if (this.hideTooltipTimeoutId) {
      window.clearTimeout(this.hideTooltipTimeoutId);
      this.hideTooltipTimeoutId = undefined;
    }
  };
  __decorate$9([Autowired('popupService')], CustomTooltipFeature.prototype, "popupService", void 0);
  __decorate$9([Autowired('userComponentFactory')], CustomTooltipFeature.prototype, "userComponentFactory", void 0);
  __decorate$9([Autowired('columnApi')], CustomTooltipFeature.prototype, "columnApi", void 0);
  __decorate$9([Autowired('gridApi')], CustomTooltipFeature.prototype, "gridApi", void 0);
  __decorate$9([PostConstruct], CustomTooltipFeature.prototype, "postConstruct", null);
  return CustomTooltipFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$7 = undefined && undefined.__extends || function () {
  var _extendStatics8 = function extendStatics(d, b) {
    _extendStatics8 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics8(d, b);
  };
  return function (d, b) {
    _extendStatics8(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var compIdSequence = new NumberSequence();
var Component = /** @class */function (_super) {
  __extends$7(Component, _super);
  function Component(template) {
    var _this = _super.call(this) || this;
    // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
    _this.displayed = true;
    // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
    _this.visible = true;
    // unique id for this row component. this is used for getting a reference to the HTML dom.
    // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
    // around as we create a new rowComp instance for the same row node).
    _this.compId = compIdSequence.next();
    // to minimise DOM hits, we only apply CSS classes if they have changed. as addding a CSS class that is already
    // there, or removing one that wasn't present, all takes CPU.
    _this.cssClassStates = {};
    if (template) {
      _this.setTemplate(template);
    }
    return _this;
  }
  Component.prototype.preConstructOnComponent = function () {
    this.usingBrowserTooltips = this.gridOptionsWrapper.isEnableBrowserTooltips();
  };
  Component.prototype.getCompId = function () {
    return this.compId;
  };
  Component.prototype.getTooltipParams = function () {
    return {
      value: this.tooltipText,
      location: 'UNKNOWN'
    };
  };
  Component.prototype.setTooltip = function (newTooltipText) {
    var _this = this;
    var removeTooltip = function removeTooltip() {
      if (_this.usingBrowserTooltips) {
        _this.getGui().removeAttribute('title');
      } else {
        _this.tooltipFeature = _this.destroyBean(_this.tooltipFeature);
      }
    };
    var addTooltip = function addTooltip() {
      if (_this.usingBrowserTooltips) {
        _this.getGui().setAttribute('title', _this.tooltipText);
      } else {
        _this.tooltipFeature = _this.createBean(new CustomTooltipFeature(_this));
      }
    };
    if (this.tooltipText != newTooltipText) {
      if (this.tooltipText) {
        removeTooltip();
      }
      if (newTooltipText != null) {
        this.tooltipText = newTooltipText;
        if (this.tooltipText) {
          addTooltip();
        }
      }
    }
  };
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  Component.prototype.createChildComponentsFromTags = function (parentNode, paramsMap) {
    var _this = this;
    // we MUST take a copy of the list first, as the 'swapComponentForNode' adds comments into the DOM
    // which messes up the traversal order of the children.
    var childNodeList = copyNodeList(parentNode.childNodes);
    forEach$4(childNodeList, function (childNode) {
      if (!(childNode instanceof HTMLElement)) {
        return;
      }
      var childComp = _this.createComponentFromElement(childNode, function (childComp) {
        // copy over all attributes, including css classes, so any attributes user put on the tag
        // wll be carried across
        var childGui = childComp.getGui();
        if (childGui) {
          _this.copyAttributesFromNode(childNode, childComp.getGui());
        }
      }, paramsMap);
      if (childComp) {
        if (childComp.addItems && childNode.children.length) {
          _this.createChildComponentsFromTags(childNode, paramsMap);
          // converting from HTMLCollection to Array
          var items = Array.prototype.slice.call(childNode.children);
          childComp.addItems(items);
        }
        // replace the tag (eg ag-checkbox) with the proper HTMLElement (eg 'div') in the dom
        _this.swapComponentForNode(childComp, parentNode, childNode);
      } else if (childNode.childNodes) {
        _this.createChildComponentsFromTags(childNode, paramsMap);
      }
    });
  };
  Component.prototype.createComponentFromElement = function (element, afterPreCreateCallback, paramsMap) {
    var key = element.nodeName;
    var componentParams = paramsMap ? paramsMap[element.getAttribute('ref')] : undefined;
    var ComponentClass = this.agStackComponentsRegistry.getComponentClass(key);
    if (ComponentClass) {
      Component.elementGettingCreated = element;
      var newComponent = new ComponentClass(componentParams);
      newComponent.setParentComponent(this);
      this.createBean(newComponent, null, afterPreCreateCallback);
      return newComponent;
    }
    return null;
  };
  Component.prototype.copyAttributesFromNode = function (source, dest) {
    iterateNamedNodeMap(source.attributes, function (name, value) {
      return dest.setAttribute(name, value);
    });
  };
  Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
    var eComponent = newComponent.getGui();
    parentNode.replaceChild(eComponent, childNode);
    parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
    this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
    this.swapInComponentForQuerySelectors(newComponent, childNode);
  };
  Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
    var thisNoType = this;
    this.iterateOverQuerySelectors(function (querySelector) {
      if (thisNoType[querySelector.attributeName] === childNode) {
        thisNoType[querySelector.attributeName] = newComponent;
      }
    });
  };
  Component.prototype.iterateOverQuerySelectors = function (action) {
    var thisPrototype = Object.getPrototypeOf(this);
    while (thisPrototype != null) {
      var metaData = thisPrototype.__agComponentMetaData;
      var currentProtoName = getFunctionName(thisPrototype.constructor);
      if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) {
        forEach$4(metaData[currentProtoName].querySelectors, function (querySelector) {
          return action(querySelector);
        });
      }
      thisPrototype = Object.getPrototypeOf(thisPrototype);
    }
  };
  Component.prototype.setTemplate = function (template, paramsMap) {
    var eGui = loadTemplate(template);
    this.setTemplateFromElement(eGui, paramsMap);
  };
  Component.prototype.setTemplateFromElement = function (element, paramsMap) {
    this.eGui = element;
    this.eGui.__agComponent = this;
    this.wireQuerySelectors();
    // context will not be available when user sets template in constructor
    if (!!this.getContext()) {
      this.createChildComponentsFromTags(this.getGui(), paramsMap);
    }
  };
  Component.prototype.createChildComponentsPreConstruct = function () {
    // ui exists if user sets template in constructor. when this happens, we have to wait for the context
    // to be autoWired first before we can create child components.
    if (!!this.getGui()) {
      this.createChildComponentsFromTags(this.getGui());
    }
  };
  Component.prototype.wireQuerySelectors = function () {
    var _this = this;
    if (!this.eGui) {
      return;
    }
    var thisNoType = this;
    this.iterateOverQuerySelectors(function (querySelector) {
      var setResult = function setResult(result) {
        return thisNoType[querySelector.attributeName] = result;
      };
      // if it's a ref selector, and match is on top level component, we return
      // the element. otherwise no way of components putting ref=xxx on the top
      // level element as querySelector only looks at children.
      var topLevelRefMatch = querySelector.refSelector && _this.eGui.getAttribute('ref') === querySelector.refSelector;
      if (topLevelRefMatch) {
        setResult(_this.eGui);
      } else {
        // otherwise use querySelector, which looks at children
        var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
        if (resultOfQuery) {
          setResult(resultOfQuery.__agComponent || resultOfQuery);
        }
      }
    });
  };
  Component.prototype.getGui = function () {
    return this.eGui;
  };
  Component.prototype.getFocusableElement = function () {
    return this.eGui;
  };
  Component.prototype.setParentComponent = function (component) {
    this.parentComponent = component;
  };
  Component.prototype.getParentComponent = function () {
    return this.parentComponent;
  };
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  Component.prototype.setGui = function (eGui) {
    this.eGui = eGui;
  };
  Component.prototype.queryForHtmlElement = function (cssSelector) {
    return this.eGui.querySelector(cssSelector);
  };
  Component.prototype.queryForHtmlInputElement = function (cssSelector) {
    return this.eGui.querySelector(cssSelector);
  };
  Component.prototype.appendChild = function (newChild, container) {
    if (!container) {
      container = this.eGui;
    }
    if (newChild == null) {
      return;
    }
    if (isNodeOrElement(newChild)) {
      container.appendChild(newChild);
    } else {
      var childComponent = newChild;
      container.appendChild(childComponent.getGui());
      this.addDestroyFunc(this.destroyBean.bind(this, childComponent));
    }
  };
  Component.prototype.isDisplayed = function () {
    return this.displayed;
  };
  Component.prototype.setVisible = function (visible) {
    if (visible !== this.visible) {
      this.visible = visible;
      setVisible(this.eGui, visible);
    }
  };
  Component.prototype.setDisplayed = function (displayed) {
    if (displayed !== this.displayed) {
      this.displayed = displayed;
      setDisplayed(this.eGui, displayed);
      var event_1 = {
        type: Component.EVENT_DISPLAYED_CHANGED,
        visible: this.displayed
      };
      this.dispatchEvent(event_1);
    }
  };
  Component.prototype.destroy = function () {
    if (this.tooltipFeature) {
      this.tooltipFeature = this.destroyBean(this.tooltipFeature);
    }
    _super.prototype.destroy.call(this);
  };
  Component.prototype.addGuiEventListener = function (event, listener) {
    var _this = this;
    this.eGui.addEventListener(event, listener);
    this.addDestroyFunc(function () {
      return _this.eGui.removeEventListener(event, listener);
    });
  };
  Component.prototype.addCssClass = function (className) {
    var updateNeeded = this.cssClassStates[className] !== true;
    if (updateNeeded) {
      addCssClass(this.eGui, className);
      this.cssClassStates[className] = true;
    }
  };
  Component.prototype.removeCssClass = function (className) {
    var updateNeeded = this.cssClassStates[className] !== false;
    if (updateNeeded) {
      removeCssClass(this.eGui, className);
      this.cssClassStates[className] = false;
    }
  };
  Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
    var updateNeeded = this.cssClassStates[className] !== addOrRemove;
    if (updateNeeded) {
      addOrRemoveCssClass(this.eGui, className, addOrRemove);
      this.cssClassStates[className] = addOrRemove;
    }
  };
  Component.prototype.getAttribute = function (key) {
    var eGui = this.eGui;
    return eGui ? eGui.getAttribute(key) : null;
  };
  Component.prototype.getRefElement = function (refName) {
    return this.queryForHtmlElement("[ref=\"" + refName + "\"]");
  };
  Component.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
  __decorate$a([Autowired('agStackComponentsRegistry')], Component.prototype, "agStackComponentsRegistry", void 0);
  __decorate$a([PreConstruct], Component.prototype, "preConstructOnComponent", null);
  __decorate$a([PreConstruct], Component.prototype, "createChildComponentsPreConstruct", null);
  return Component;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function QuerySelector(selector) {
  return querySelectorFunc.bind(this, selector, undefined);
}
function RefSelector(ref) {
  return querySelectorFunc.bind(this, "[ref=" + ref + "]", ref);
}
function querySelectorFunc(selector, refSelector, classPrototype, methodOrAttributeName, index) {
  if (selector === null) {
    console.error('AG Grid: QuerySelector selector should not be null');
    return;
  }
  if (typeof index === 'number') {
    console.error('AG Grid: QuerySelector should be on an attribute');
    return;
  }
  addToObjectProps(classPrototype, 'querySelectors', {
    attributeName: methodOrAttributeName,
    querySelector: selector,
    refSelector: refSelector
  });
}
// // think we should take this out, put property bindings on the
// export function Method(eventName?: string): Function {
//     return methodFunc.bind(this, eventName);
// }
//
// function methodFunc(alias: string, target: Object, methodName: string) {
//     if (alias === null) {
//         console.error("AG Grid: EventListener eventName should not be null");
//         return;
//     }
//
//     addToObjectProps(target, 'methods', {
//         methodName: methodName,
//         alias: alias
//     });
// }
function addToObjectProps(target, key, value) {
  // it's an attribute on the class
  var props = getOrCreateProps$1(target, getFunctionName(target.constructor));
  if (!props[key]) {
    props[key] = [];
  }
  props[key].push(value);
}
function getOrCreateProps$1(target, instanceName) {
  if (!target.__agComponentMetaData) {
    target.__agComponentMetaData = {};
  }
  if (!target.__agComponentMetaData[instanceName]) {
    target.__agComponentMetaData[instanceName] = {};
  }
  return target.__agComponentMetaData[instanceName];
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$8 = undefined && undefined.__extends || function () {
  var _extendStatics9 = function extendStatics(d, b) {
    _extendStatics9 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics9(d, b);
  };
  return function (d, b) {
    _extendStatics9(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$b = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// optional floating filter for user provided filters - instead of providing a floating filter,
// they can provide a getModelAsString() method on the filter instead. this class just displays
// the string returned from getModelAsString()
var ReadOnlyFloatingFilter = /** @class */function (_super) {
  __extends$8(ReadOnlyFloatingFilter, _super);
  function ReadOnlyFloatingFilter() {
    return _super.call(this, /* html */"\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterText\"></ag-input-text-field>\n            </div>") || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  ReadOnlyFloatingFilter.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  ReadOnlyFloatingFilter.prototype.init = function (params) {
    this.params = params;
    var displayName = this.columnModel.getDisplayNameForColumn(params.column, 'header', true);
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(displayName + " " + translate('ariaFilterInput', 'Filter Input'));
  };
  ReadOnlyFloatingFilter.prototype.onParentModelChanged = function (parentModel) {
    var _this = this;
    if (!parentModel) {
      this.eFloatingFilterText.setValue('');
      return;
    }
    this.params.parentFilterInstance(function (filterInstance) {
      // it would be nice to check if getModelAsString was present before creating this component,
      // however that is not possible, as React Hooks and VueJS don't attached the methods to the Filter until
      // AFTER the filter is created, not allowing inspection before this (we create floating filters as columns
      // are drawn, but the parent filters are only created when needed).
      if (filterInstance.getModelAsString) {
        var modelAsString = filterInstance.getModelAsString(parentModel);
        _this.eFloatingFilterText.setValue(modelAsString);
      }
    });
  };
  __decorate$b([RefSelector('eFloatingFilterText')], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", void 0);
  __decorate$b([Autowired('columnModel')], ReadOnlyFloatingFilter.prototype, "columnModel", void 0);
  return ReadOnlyFloatingFilter;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/** Provides sync access to async component. Date component can be lazy created - this class encapsulates
 * this by keeping value locally until DateComp has loaded, then passing DateComp the value. */
var DateCompWrapper = /** @class */function () {
  function DateCompWrapper(context, userComponentFactory, dateComponentParams, eParent) {
    var _this = this;
    this.alive = true;
    this.context = context;
    this.eParent = eParent;
    var compDetails = userComponentFactory.getDateCompDetails(dateComponentParams);
    var promise = compDetails.newAgStackInstance();
    promise.then(function (dateComp) {
      // because async, check the filter still exists after component comes back
      if (!_this.alive) {
        context.destroyBean(dateComp);
        return;
      }
      _this.dateComp = dateComp;
      if (!dateComp) {
        return;
      }
      eParent.appendChild(dateComp.getGui());
      if (dateComp.afterGuiAttached) {
        dateComp.afterGuiAttached();
      }
      if (_this.tempValue) {
        dateComp.setDate(_this.tempValue);
      }
      if (_this.disabled != null) {
        _this.setDateCompDisabled(_this.disabled);
      }
    });
  }
  DateCompWrapper.prototype.destroy = function () {
    this.alive = false;
    this.dateComp = this.context.destroyBean(this.dateComp);
  };
  DateCompWrapper.prototype.getDate = function () {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  };
  DateCompWrapper.prototype.setDate = function (value) {
    if (this.dateComp) {
      this.dateComp.setDate(value);
    } else {
      this.tempValue = value;
    }
  };
  DateCompWrapper.prototype.setDisabled = function (disabled) {
    if (this.dateComp) {
      this.setDateCompDisabled(disabled);
    } else {
      this.disabled = disabled;
    }
  };
  DateCompWrapper.prototype.setDisplayed = function (displayed) {
    setDisplayed(this.eParent, displayed);
  };
  DateCompWrapper.prototype.setInputPlaceholder = function (placeholder) {
    if (this.dateComp && this.dateComp.setInputPlaceholder) {
      this.dateComp.setInputPlaceholder(placeholder);
    }
  };
  DateCompWrapper.prototype.setInputAriaLabel = function (label) {
    if (this.dateComp && this.dateComp.setInputAriaLabel) {
      this.dateComp.setInputAriaLabel(label);
    }
  };
  DateCompWrapper.prototype.afterGuiAttached = function (params) {
    if (this.dateComp && typeof this.dateComp.afterGuiAttached === 'function') {
      this.dateComp.afterGuiAttached(params);
    }
  };
  DateCompWrapper.prototype.setDateCompDisabled = function (disabled) {
    if (this.dateComp == null) {
      return;
    }
    if (this.dateComp.setDisabled == null) {
      return;
    }
    this.dateComp.setDisabled(disabled);
  };
  return DateCompWrapper;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __assign$4 = undefined && undefined.__assign || function () {
  __assign$4 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$4.apply(this, arguments);
};
/* Common logic for options, used by both filters and floating filters. */
var OptionsFactory = /** @class */function () {
  function OptionsFactory() {
    this.customFilterOptions = {};
  }
  OptionsFactory.prototype.init = function (params, defaultOptions) {
    this.filterOptions = params.filterOptions || defaultOptions;
    this.mapCustomOptions();
    this.selectDefaultItem(params);
    this.checkForDeprecatedParams();
  };
  OptionsFactory.prototype.checkForDeprecatedParams = function () {
    if (_.some(this.filterOptions, function (opt) {
      return typeof opt != 'string' && opt.test != null;
    })) {
      console.warn("AG Grid: [IFilterOptionDef] since v26.2.0, test() has been replaced with predicate().");
    }
    if (_.some(this.filterOptions, function (opt) {
      return typeof opt != 'string' && opt.hideFilterInput != null;
    })) {
      console.warn("AG Grid: [IFilterOptionDef] since v26.2.0, useOfHideFilterInput has been replaced with numberOfInputs.");
    }
  };
  OptionsFactory.prototype.getFilterOptions = function () {
    return this.filterOptions;
  };
  OptionsFactory.prototype.mapCustomOptions = function () {
    var _this = this;
    if (!this.filterOptions) {
      return;
    }
    this.filterOptions.forEach(function (filterOption) {
      if (typeof filterOption === 'string') {
        return;
      }
      var requiredProperties = [['displayKey'], ['displayName'], ['predicate', 'test']];
      var propertyCheck = function propertyCheck(keys) {
        if (!some(keys, function (key) {
          return filterOption[key] != null;
        })) {
          console.warn("AG Grid: ignoring FilterOptionDef as it doesn't contain one of '" + keys + "'");
          return false;
        }
        return true;
      };
      if (!every(requiredProperties, propertyCheck)) {
        _this.filterOptions = _.filter(_this.filterOptions, function (v) {
          return v === filterOption;
        }) || [];
        return;
      }
      var test = filterOption.test;
      var mutatedFilterOptions = __assign$4({}, filterOption);
      if (test != null && filterOption.predicate == null) {
        mutatedFilterOptions.predicate = function (v, cv) {
          return test(v[0], cv);
        };
        delete mutatedFilterOptions.test;
      }
      if (mutatedFilterOptions.hideFilterInput && mutatedFilterOptions.numberOfInputs == null) {
        mutatedFilterOptions.numberOfInputs = 0;
        delete mutatedFilterOptions.hideFilterInput;
      }
      _this.customFilterOptions[filterOption.displayKey] = mutatedFilterOptions;
    });
  };
  OptionsFactory.prototype.selectDefaultItem = function (params) {
    if (params.defaultOption) {
      this.defaultOption = params.defaultOption;
    } else if (this.filterOptions.length >= 1) {
      var firstFilterOption = this.filterOptions[0];
      if (typeof firstFilterOption === 'string') {
        this.defaultOption = firstFilterOption;
      } else if (firstFilterOption.displayKey) {
        this.defaultOption = firstFilterOption.displayKey;
      } else {
        console.warn("AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'");
      }
    } else {
      console.warn('AG Grid: no filter options for filter');
    }
  };
  OptionsFactory.prototype.getDefaultOption = function () {
    return this.defaultOption;
  };
  OptionsFactory.prototype.getCustomOption = function (name) {
    return this.customFilterOptions[name];
  };
  return OptionsFactory;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var DEFAULT_FILTER_LOCALE_TEXT = {
  applyFilter: 'Apply',
  clearFilter: 'Clear',
  resetFilter: 'Reset',
  cancelFilter: 'Cancel',
  textFilter: 'Text Filter',
  numberFilter: 'Number Filter',
  dateFilter: 'Date Filter',
  setFilter: 'Set Filter',
  filterOoo: 'Filter...',
  empty: 'Choose One',
  equals: 'Equals',
  notEqual: 'Not equal',
  lessThan: 'Less than',
  greaterThan: 'Greater than',
  inRange: 'In range',
  inRangeStart: 'From',
  inRangeEnd: 'To',
  lessThanOrEqual: 'Less than or equals',
  greaterThanOrEqual: 'Greater than or equals',
  contains: 'Contains',
  notContains: 'Not contains',
  startsWith: 'Starts with',
  endsWith: 'Ends with',
  andCondition: 'AND',
  orCondition: 'OR',
  dateFormatOoo: 'yyyy-mm-dd'
};

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var KeyCode = /** @class */function () {
  function KeyCode() {}
  KeyCode.BACKSPACE = 8;
  KeyCode.TAB = 9;
  KeyCode.ENTER = 13;
  KeyCode.SHIFT = 16;
  KeyCode.ESCAPE = 27;
  KeyCode.SPACE = 32;
  KeyCode.LEFT = 37;
  KeyCode.UP = 38;
  KeyCode.RIGHT = 39;
  KeyCode.DOWN = 40;
  KeyCode.DELETE = 46;
  KeyCode.A = 65;
  KeyCode.C = 67;
  KeyCode.V = 86;
  KeyCode.D = 68;
  KeyCode.Z = 90;
  KeyCode.Y = 89;
  KeyCode.F2 = 113;
  KeyCode.PAGE_UP = 33;
  KeyCode.PAGE_DOWN = 34;
  KeyCode.PAGE_HOME = 36;
  KeyCode.PAGE_END = 35;
  return KeyCode;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$9 = undefined && undefined.__extends || function () {
  var _extendStatics10 = function extendStatics(d, b) {
    _extendStatics10 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics10(d, b);
  };
  return function (d, b) {
    _extendStatics10(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$5 = undefined && undefined.__assign || function () {
  __assign$5 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$5.apply(this, arguments);
};
var __decorate$c = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ManagedFocusFeature = /** @class */function (_super) {
  __extends$9(ManagedFocusFeature, _super);
  function ManagedFocusFeature(eFocusableElement, callbacks) {
    if (callbacks === void 0) {
      callbacks = {};
    }
    var _this = _super.call(this) || this;
    _this.eFocusableElement = eFocusableElement;
    _this.callbacks = callbacks;
    _this.callbacks = __assign$5({
      shouldStopEventPropagation: function shouldStopEventPropagation() {
        return false;
      },
      onTabKeyDown: function onTabKeyDown(e) {
        if (e.defaultPrevented) {
          return;
        }
        var nextRoot = _this.focusService.findNextFocusableElement(_this.eFocusableElement, false, e.shiftKey);
        if (!nextRoot) {
          return;
        }
        nextRoot.focus();
        e.preventDefault();
      }
    }, callbacks);
    return _this;
  }
  ManagedFocusFeature.prototype.postConstruct = function () {
    addCssClass(this.eFocusableElement, ManagedFocusFeature.FOCUS_MANAGED_CLASS);
    this.addKeyDownListeners(this.eFocusableElement);
    if (this.callbacks.onFocusIn) {
      this.addManagedListener(this.eFocusableElement, 'focusin', this.callbacks.onFocusIn);
    }
    if (this.callbacks.onFocusOut) {
      this.addManagedListener(this.eFocusableElement, 'focusout', this.callbacks.onFocusOut);
    }
  };
  ManagedFocusFeature.prototype.addKeyDownListeners = function (eGui) {
    var _this = this;
    this.addManagedListener(eGui, 'keydown', function (e) {
      if (e.defaultPrevented || isStopPropagationForAgGrid(e)) {
        return;
      }
      if (_this.callbacks.shouldStopEventPropagation(e)) {
        stopPropagationForAgGrid(e);
        return;
      }
      if (e.keyCode === KeyCode.TAB) {
        _this.callbacks.onTabKeyDown(e);
      } else if (_this.callbacks.handleKeyDown) {
        _this.callbacks.handleKeyDown(e);
      }
    });
  };
  ManagedFocusFeature.FOCUS_MANAGED_CLASS = 'ag-focus-managed';
  __decorate$c([Autowired('focusService')], ManagedFocusFeature.prototype, "focusService", void 0);
  __decorate$c([PostConstruct], ManagedFocusFeature.prototype, "postConstruct", null);
  return ManagedFocusFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$a = undefined && undefined.__extends || function () {
  var _extendStatics11 = function extendStatics(d, b) {
    _extendStatics11 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics11(d, b);
  };
  return function (d, b) {
    _extendStatics11(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$d = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Contains common logic to all provided filters (apply button, clear button, etc).
 * All the filters that come with AG Grid extend this class. User filters do not
 * extend this class.
 *
 * @param M type of filter-model managed by the concrete sub-class that extends this type
 * @param V type of value managed by the concrete sub-class that extends this type
 */
var ProvidedFilter = /** @class */function (_super) {
  __extends$a(ProvidedFilter, _super);
  function ProvidedFilter(filterNameKey) {
    var _this = _super.call(this) || this;
    _this.filterNameKey = filterNameKey;
    _this.applyActive = false;
    _this.hidePopup = null;
    // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
    // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
    // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
    // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
    // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
    // not active) then this appliedModel will be null/undefined.
    _this.appliedModel = null;
    return _this;
  }
  ProvidedFilter.prototype.postConstruct = function () {
    this.resetTemplate(); // do this first to create the DOM
    this.createManagedBean(new ManagedFocusFeature(this.getFocusableElement(), {
      handleKeyDown: this.handleKeyDown.bind(this)
    }));
  };
  // override
  ProvidedFilter.prototype.handleKeyDown = function (e) {};
  ProvidedFilter.prototype.getFilterTitle = function () {
    return this.translate(this.filterNameKey);
  };
  /** @deprecated */
  ProvidedFilter.prototype.onFilterChanged = function () {
    console.warn("AG Grid: you should not call onFilterChanged() directly on the filter, please call\n        gridApi.onFilterChanged() instead. onFilterChanged is not part of the exposed filter interface (it was\n        a method that existed on an old version of the filters that was not intended for public use.");
    this.providedFilterParams.filterChangedCallback();
  };
  ProvidedFilter.prototype.isFilterActive = function () {
    // filter is active if we have a valid applied model
    return !!this.appliedModel;
  };
  ProvidedFilter.prototype.resetTemplate = function (paramsMap) {
    var templateString = /* html */"\n            <div class=\"ag-filter-wrapper\">\n                <div class=\"ag-filter-body-wrapper ag-" + this.getCssIdentifier() + "-body-wrapper\">\n                    " + this.createBodyTemplate() + "\n                </div>\n            </div>";
    this.setTemplate(templateString, paramsMap);
  };
  ProvidedFilter.prototype.isReadOnly = function () {
    return !!this.providedFilterParams.readOnly;
  };
  ProvidedFilter.prototype.init = function (params) {
    var _this = this;
    this.setParams(params);
    this.resetUiToDefaults(true).then(function () {
      _this.updateUiVisibility();
      _this.setupOnBtApplyDebounce();
    });
  };
  ProvidedFilter.prototype.setParams = function (params) {
    ProvidedFilter.checkForDeprecatedParams(params);
    this.providedFilterParams = params;
    if (params.newRowsAction === 'keep') {
      this.newRowsActionKeep = true;
    } else if (params.newRowsAction === 'clear') {
      this.newRowsActionKeep = false;
    } else {
      // the default for SSRM and IRM is 'keep', for CSRM and VRM the default is 'clear'
      var modelsForKeep = [Constants.ROW_MODEL_TYPE_SERVER_SIDE, Constants.ROW_MODEL_TYPE_INFINITE];
      this.newRowsActionKeep = modelsForKeep.indexOf(this.rowModel.getType()) >= 0;
    }
    this.applyActive = ProvidedFilter.isUseApplyButton(params);
    this.createButtonPanel();
  };
  ProvidedFilter.prototype.createButtonPanel = function () {
    var _this = this;
    var buttons = this.providedFilterParams.buttons;
    if (!buttons || buttons.length < 1 || this.isReadOnly()) {
      return;
    }
    var eButtonsPanel = document.createElement('div');
    addCssClass(eButtonsPanel, 'ag-filter-apply-panel');
    var addButton = function addButton(type) {
      var text;
      var clickListener;
      switch (type) {
        case 'apply':
          text = _this.translate('applyFilter');
          clickListener = function clickListener(e) {
            return _this.onBtApply(false, false, e);
          };
          break;
        case 'clear':
          text = _this.translate('clearFilter');
          clickListener = function clickListener() {
            return _this.onBtClear();
          };
          break;
        case 'reset':
          text = _this.translate('resetFilter');
          clickListener = function clickListener() {
            return _this.onBtReset();
          };
          break;
        case 'cancel':
          text = _this.translate('cancelFilter');
          clickListener = function clickListener(e) {
            _this.onBtCancel(e);
          };
          break;
        default:
          console.warn('Unknown button type specified');
          return;
      }
      var button = loadTemplate( /* html */
      "<button\n                    type=\"button\"\n                    ref=\"" + type + "FilterButton\"\n                    class=\"ag-standard-button ag-filter-apply-panel-button\"\n                >" + text + "\n                </button>");
      eButtonsPanel.appendChild(button);
      _this.addManagedListener(button, 'click', clickListener);
    };
    convertToSet(buttons).forEach(function (type) {
      return addButton(type);
    });
    this.getGui().appendChild(eButtonsPanel);
  };
  ProvidedFilter.checkForDeprecatedParams = function (params) {
    var buttons = params.buttons || [];
    if (buttons.length > 0) {
      return;
    }
    var applyButton = params.applyButton,
      resetButton = params.resetButton,
      clearButton = params.clearButton;
    if (clearButton) {
      console.warn('AG Grid: as of AG Grid v23.2, filterParams.clearButton is deprecated. Please use filterParams.buttons instead');
      buttons.push('clear');
    }
    if (resetButton) {
      console.warn('AG Grid: as of AG Grid v23.2, filterParams.resetButton is deprecated. Please use filterParams.buttons instead');
      buttons.push('reset');
    }
    if (applyButton) {
      console.warn('AG Grid: as of AG Grid v23.2, filterParams.applyButton is deprecated. Please use filterParams.buttons instead');
      buttons.push('apply');
    }
    if (params.apply) {
      console.warn('AG Grid: as of AG Grid v21, filterParams.apply is deprecated. Please use filterParams.buttons instead');
      buttons.push('apply');
    }
    params.buttons = buttons;
  };
  // subclasses can override this to provide alternative debounce defaults
  ProvidedFilter.prototype.getDefaultDebounceMs = function () {
    return 0;
  };
  ProvidedFilter.prototype.setupOnBtApplyDebounce = function () {
    var debounceMs = ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
    this.onBtApplyDebounce = debounce(this.onBtApply.bind(this), debounceMs);
  };
  ProvidedFilter.prototype.getModel = function () {
    return this.appliedModel;
  };
  ProvidedFilter.prototype.setModel = function (model) {
    var _this = this;
    var promise = model ? this.setModelIntoUi(model) : this.resetUiToDefaults();
    return promise.then(function () {
      _this.updateUiVisibility();
      // we set the model from the GUI, rather than the provided model,
      // so the model is consistent, e.g. handling of null/undefined will be the same,
      // or if model is case insensitive, then casing is removed.
      _this.applyModel();
    });
  };
  ProvidedFilter.prototype.onBtCancel = function (e) {
    var _this = this;
    var currentModel = this.getModel();
    var afterAppliedFunc = function afterAppliedFunc() {
      _this.onUiChanged(false, 'prevent');
      if (_this.providedFilterParams.closeOnApply) {
        _this.close(e);
      }
    };
    if (currentModel != null) {
      this.setModelIntoUi(currentModel).then(afterAppliedFunc);
    } else {
      this.resetUiToDefaults().then(afterAppliedFunc);
    }
  };
  ProvidedFilter.prototype.onBtClear = function () {
    var _this = this;
    this.resetUiToDefaults().then(function () {
      return _this.onUiChanged();
    });
  };
  ProvidedFilter.prototype.onBtReset = function () {
    this.onBtClear();
    this.onBtApply();
  };
  /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */
  ProvidedFilter.prototype.applyModel = function () {
    var newModel = this.getModelFromUi();
    if (!this.isModelValid(newModel)) {
      return false;
    }
    var previousModel = this.appliedModel;
    this.appliedModel = newModel;
    // models can be same if user pasted same content into text field, or maybe just changed the case
    // and it's a case insensitive filter
    return !this.areModelsEqual(previousModel, newModel);
  };
  ProvidedFilter.prototype.isModelValid = function (model) {
    return true;
  };
  ProvidedFilter.prototype.onBtApply = function (afterFloatingFilter, afterDataChange, e) {
    if (afterFloatingFilter === void 0) {
      afterFloatingFilter = false;
    }
    if (afterDataChange === void 0) {
      afterDataChange = false;
    }
    if (this.applyModel()) {
      // the floating filter uses 'afterFloatingFilter' info, so it doesn't refresh after filter changed if change
      // came from floating filter
      this.providedFilterParams.filterChangedCallback({
        afterFloatingFilter: afterFloatingFilter,
        afterDataChange: afterDataChange
      });
    }
    var closeOnApply = this.providedFilterParams.closeOnApply;
    // only close if an apply button is visible, otherwise we'd be closing every time a change was made!
    if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) {
      this.close(e);
    }
  };
  ProvidedFilter.prototype.onNewRowsLoaded = function () {
    var _this = this;
    if (!this.newRowsActionKeep) {
      this.resetUiToDefaults().then(function () {
        return _this.appliedModel = null;
      });
    }
  };
  ProvidedFilter.prototype.close = function (e) {
    if (!this.hidePopup) {
      return;
    }
    var keyboardEvent = e;
    var key = keyboardEvent && keyboardEvent.key;
    var params;
    if (key === 'Enter' || key === 'Space') {
      params = {
        keyboardEvent: keyboardEvent
      };
    }
    this.hidePopup(params);
    this.hidePopup = null;
  };
  // called by set filter
  ProvidedFilter.prototype.isNewRowsActionKeep = function () {
    return this.newRowsActionKeep;
  };
  /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */
  ProvidedFilter.prototype.onUiChanged = function (fromFloatingFilter, apply) {
    if (fromFloatingFilter === void 0) {
      fromFloatingFilter = false;
    }
    this.updateUiVisibility();
    this.providedFilterParams.filterModifiedCallback();
    if (this.applyActive && !this.isReadOnly) {
      var isValid = this.isModelValid(this.getModelFromUi());
      setDisabled(this.getRefElement('applyFilterButton'), !isValid);
    }
    if (fromFloatingFilter && !apply || apply === 'immediately') {
      this.onBtApply(fromFloatingFilter);
    } else if (!this.applyActive && !apply || apply === 'debounce') {
      this.onBtApplyDebounce();
    }
  };
  ProvidedFilter.prototype.afterGuiAttached = function (params) {
    if (params == null) {
      return;
    }
    this.hidePopup = params.hidePopup;
  };
  // static, as used by floating filter also
  ProvidedFilter.getDebounceMs = function (params, debounceDefault) {
    if (ProvidedFilter.isUseApplyButton(params)) {
      if (params.debounceMs != null) {
        console.warn('AG Grid: debounceMs is ignored when apply button is present');
      }
      return 0;
    }
    return params.debounceMs != null ? params.debounceMs : debounceDefault;
  };
  // static, as used by floating filter also
  ProvidedFilter.isUseApplyButton = function (params) {
    ProvidedFilter.checkForDeprecatedParams(params);
    return !!params.buttons && params.buttons.indexOf('apply') >= 0;
  };
  ProvidedFilter.prototype.destroy = function () {
    this.hidePopup = null;
    _super.prototype.destroy.call(this);
  };
  ProvidedFilter.prototype.translate = function (key) {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    return translate(key, DEFAULT_FILTER_LOCALE_TEXT[key]);
  };
  ProvidedFilter.prototype.getCellValue = function (rowNode) {
    return this.providedFilterParams.valueGetter(rowNode);
  };
  __decorate$d([Autowired('rowModel')], ProvidedFilter.prototype, "rowModel", void 0);
  __decorate$d([PostConstruct], ProvidedFilter.prototype, "postConstruct", null);
  return ProvidedFilter;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$b = undefined && undefined.__extends || function () {
  var _extendStatics12 = function extendStatics(d, b) {
    _extendStatics12 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics12(d, b);
  };
  return function (d, b) {
    _extendStatics12(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$e = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgAbstractLabel = /** @class */function (_super) {
  __extends$b(AgAbstractLabel, _super);
  function AgAbstractLabel(config, template) {
    var _this = _super.call(this, template) || this;
    _this.labelSeparator = '';
    _this.labelAlignment = 'left';
    _this.label = '';
    _this.config = config || {};
    return _this;
  }
  AgAbstractLabel.prototype.postConstruct = function () {
    addCssClass(this.getGui(), 'ag-labeled');
    addCssClass(this.eLabel, 'ag-label');
    var _a = this.config,
      labelSeparator = _a.labelSeparator,
      label = _a.label,
      labelWidth = _a.labelWidth,
      labelAlignment = _a.labelAlignment;
    if (labelSeparator != null) {
      this.setLabelSeparator(labelSeparator);
    }
    if (label != null) {
      this.setLabel(label);
    }
    if (labelWidth != null) {
      this.setLabelWidth(labelWidth);
    }
    this.setLabelAlignment(labelAlignment || this.labelAlignment);
    this.refreshLabel();
  };
  AgAbstractLabel.prototype.refreshLabel = function () {
    clearElement(this.eLabel);
    if (typeof this.label === 'string') {
      this.eLabel.innerText = this.label + this.labelSeparator;
    } else if (this.label) {
      this.eLabel.appendChild(this.label);
    }
    if (this.label === '') {
      addCssClass(this.eLabel, 'ag-hidden');
      setAriaRole(this.eLabel, 'presentation');
    } else {
      removeCssClass(this.eLabel, 'ag-hidden');
      setAriaRole(this.eLabel, null);
    }
  };
  AgAbstractLabel.prototype.setLabelSeparator = function (labelSeparator) {
    if (this.labelSeparator === labelSeparator) {
      return this;
    }
    this.labelSeparator = labelSeparator;
    if (this.label != null) {
      this.refreshLabel();
    }
    return this;
  };
  AgAbstractLabel.prototype.getLabelId = function () {
    this.eLabel.id = this.eLabel.id || "ag-" + this.getCompId() + "-label";
    return this.eLabel.id;
  };
  AgAbstractLabel.prototype.getLabel = function () {
    return this.label;
  };
  AgAbstractLabel.prototype.setLabel = function (label) {
    if (this.label === label) {
      return this;
    }
    this.label = label;
    this.refreshLabel();
    return this;
  };
  AgAbstractLabel.prototype.setLabelAlignment = function (alignment) {
    var eGui = this.getGui();
    addOrRemoveCssClass(eGui, 'ag-label-align-left', alignment === 'left');
    addOrRemoveCssClass(eGui, 'ag-label-align-right', alignment === 'right');
    addOrRemoveCssClass(eGui, 'ag-label-align-top', alignment === 'top');
    return this;
  };
  AgAbstractLabel.prototype.setLabelWidth = function (width) {
    if (this.label == null) {
      return this;
    }
    setElementWidth(this.eLabel, width);
    return this;
  };
  __decorate$e([PostConstruct], AgAbstractLabel.prototype, "postConstruct", null);
  return AgAbstractLabel;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$c = undefined && undefined.__extends || function () {
  var _extendStatics13 = function extendStatics(d, b) {
    _extendStatics13 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics13(d, b);
  };
  return function (d, b) {
    _extendStatics13(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgAbstractField = /** @class */function (_super) {
  __extends$c(AgAbstractField, _super);
  function AgAbstractField(config, template, className) {
    var _this = _super.call(this, config, template) || this;
    _this.className = className;
    _this.disabled = false;
    return _this;
  }
  AgAbstractField.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    if (this.className) {
      addCssClass(this.getGui(), this.className);
    }
  };
  AgAbstractField.prototype.onValueChange = function (callbackFn) {
    var _this = this;
    this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () {
      return callbackFn(_this.getValue());
    });
    return this;
  };
  AgAbstractField.prototype.getWidth = function () {
    return this.getGui().clientWidth;
  };
  AgAbstractField.prototype.setWidth = function (width) {
    setFixedWidth(this.getGui(), width);
    return this;
  };
  AgAbstractField.prototype.getPreviousValue = function () {
    return this.previousValue;
  };
  AgAbstractField.prototype.getValue = function () {
    return this.value;
  };
  AgAbstractField.prototype.setValue = function (value, silent) {
    if (this.value === value) {
      return this;
    }
    this.previousValue = this.value;
    this.value = value;
    if (!silent) {
      this.dispatchEvent({
        type: AgAbstractField.EVENT_CHANGED
      });
    }
    return this;
  };
  AgAbstractField.prototype.setDisabled = function (disabled) {
    disabled = !!disabled;
    var element = this.getGui();
    setDisabled(element, disabled);
    addOrRemoveCssClass(element, 'ag-disabled', disabled);
    this.disabled = disabled;
    return this;
  };
  AgAbstractField.prototype.isDisabled = function () {
    return !!this.disabled;
  };
  AgAbstractField.EVENT_CHANGED = 'valueChange';
  return AgAbstractField;
}(AgAbstractLabel);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$d = undefined && undefined.__extends || function () {
  var _extendStatics14 = function extendStatics(d, b) {
    _extendStatics14 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics14(d, b);
  };
  return function (d, b) {
    _extendStatics14(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$f = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgPickerField = /** @class */function (_super) {
  __extends$d(AgPickerField, _super);
  function AgPickerField(config, className, pickerIcon, popupRole) {
    var _this = _super.call(this, config, /* html */"<div class=\"ag-picker-field\" role=\"presentation\">\n                <div ref=\"eLabel\"></div>\n                <div ref=\"eWrapper\"\n                    class=\"ag-wrapper ag-picker-field-wrapper\"\n                    tabIndex=\"-1\"\n                    " + (popupRole ? "aria-haspopup=\"" + popupRole + "\"" : '') + "\n                >\n                    <div ref=\"eDisplayField\" class=\"ag-picker-field-display\"></div>\n                    <div ref=\"eIcon\" class=\"ag-picker-field-icon\" aria-hidden=\"true\"></div>\n                </div>\n            </div>", className) || this;
    _this.pickerIcon = pickerIcon;
    _this.isPickerDisplayed = false;
    _this.isDestroyingPicker = false;
    _this.skipClick = false;
    return _this;
  }
  AgPickerField.prototype.postConstruct = function () {
    var _this = this;
    _super.prototype.postConstruct.call(this);
    var displayId = this.getCompId() + "-display";
    this.eDisplayField.setAttribute('id', displayId);
    _setAriaDescribedBy(this.eWrapper, displayId);
    var clickHandler = function clickHandler() {
      if (_this.skipClick) {
        _this.skipClick = false;
        return;
      }
      if (_this.isDisabled()) {
        return;
      }
      _this.pickerComponent = _this.showPicker();
    };
    var eGui = this.getGui();
    this.addManagedListener(eGui, 'mousedown', function (e) {
      if (!_this.skipClick && _this.pickerComponent && _this.pickerComponent.isAlive() && isVisible(_this.pickerComponent.getGui()) && eGui.contains(e.target)) {
        _this.skipClick = true;
      }
    });
    this.addManagedListener(eGui, 'keydown', function (e) {
      switch (e.keyCode) {
        case KeyCode.UP:
        case KeyCode.DOWN:
        case KeyCode.ENTER:
        case KeyCode.SPACE:
          clickHandler();
        case KeyCode.ESCAPE:
          if (_this.isPickerDisplayed) {
            e.preventDefault();
          }
          break;
      }
    });
    this.addManagedListener(this.eWrapper, 'click', clickHandler);
    this.addManagedListener(this.eLabel, 'click', clickHandler);
    if (this.pickerIcon) {
      var icon = createIconNoSpan(this.pickerIcon, this.gridOptionsWrapper);
      if (icon) {
        this.eIcon.appendChild(icon);
      }
    }
  };
  AgPickerField.prototype.refreshLabel = function () {
    if (exists(this.getLabel())) {
      setAriaLabelledBy(this.eWrapper, this.getLabelId());
    } else {
      this.eWrapper.removeAttribute('aria-labelledby');
    }
    _super.prototype.refreshLabel.call(this);
  };
  AgPickerField.prototype.setAriaLabel = function (label) {
    _setAriaLabel(this.eWrapper, label);
    return this;
  };
  AgPickerField.prototype.setInputWidth = function (width) {
    setElementWidth(this.eWrapper, width);
    return this;
  };
  AgPickerField.prototype.getFocusableElement = function () {
    return this.eWrapper;
  };
  __decorate$f([RefSelector('eLabel')], AgPickerField.prototype, "eLabel", void 0);
  __decorate$f([RefSelector('eWrapper')], AgPickerField.prototype, "eWrapper", void 0);
  __decorate$f([RefSelector('eDisplayField')], AgPickerField.prototype, "eDisplayField", void 0);
  __decorate$f([RefSelector('eIcon')], AgPickerField.prototype, "eIcon", void 0);
  return AgPickerField;
}(AgAbstractField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$e = undefined && undefined.__extends || function () {
  var _extendStatics15 = function extendStatics(d, b) {
    _extendStatics15 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics15(d, b);
  };
  return function (d, b) {
    _extendStatics15(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$g = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgList = /** @class */function (_super) {
  __extends$e(AgList, _super);
  function AgList(cssIdentifier) {
    if (cssIdentifier === void 0) {
      cssIdentifier = 'default';
    }
    var _this = _super.call(this, /* html */"<div class=\"ag-list ag-" + cssIdentifier + "-list\" role=\"listbox\"></div>") || this;
    _this.cssIdentifier = cssIdentifier;
    _this.options = [];
    _this.itemEls = [];
    return _this;
  }
  AgList.prototype.init = function () {
    this.addManagedListener(this.getGui(), 'keydown', this.handleKeyDown.bind(this));
  };
  AgList.prototype.handleKeyDown = function (e) {
    var key = e.keyCode;
    switch (key) {
      case KeyCode.ENTER:
        if (!this.highlightedEl) {
          this.setValue(this.getValue());
        } else {
          var pos = this.itemEls.indexOf(this.highlightedEl);
          this.setValueByIndex(pos);
        }
        break;
      case KeyCode.DOWN:
      case KeyCode.UP:
        var isDown = key === KeyCode.DOWN;
        var itemToHighlight = void 0;
        e.preventDefault();
        if (!this.highlightedEl) {
          itemToHighlight = this.itemEls[isDown ? 0 : this.itemEls.length - 1];
        } else {
          var currentIdx = this.itemEls.indexOf(this.highlightedEl);
          var nextPos = currentIdx + (isDown ? 1 : -1);
          nextPos = Math.min(Math.max(nextPos, 0), this.itemEls.length - 1);
          itemToHighlight = this.itemEls[nextPos];
        }
        this.highlightItem(itemToHighlight);
        break;
    }
  };
  AgList.prototype.addOptions = function (listOptions) {
    var _this = this;
    listOptions.forEach(function (listOption) {
      return _this.addOption(listOption);
    });
    return this;
  };
  AgList.prototype.addOption = function (listOption) {
    var value = listOption.value,
      text = listOption.text;
    var sanitisedText = escapeString(text || value);
    this.options.push({
      value: value,
      text: sanitisedText
    });
    this.renderOption(value, sanitisedText);
    return this;
  };
  AgList.prototype.renderOption = function (value, text) {
    var _this = this;
    var itemEl = document.createElement('div');
    setAriaRole(itemEl, 'option');
    addCssClass(itemEl, 'ag-list-item');
    addCssClass(itemEl, "ag-" + this.cssIdentifier + "-list-item");
    itemEl.innerHTML = "<span>" + text + "</span>";
    itemEl.tabIndex = -1;
    this.itemEls.push(itemEl);
    this.addManagedListener(itemEl, 'mouseover', function () {
      return _this.highlightItem(itemEl);
    });
    this.addManagedListener(itemEl, 'mouseleave', function () {
      return _this.clearHighlighted();
    });
    this.addManagedListener(itemEl, 'click', function () {
      return _this.setValue(value);
    });
    this.getGui().appendChild(itemEl);
  };
  AgList.prototype.setValue = function (value, silent) {
    if (this.value === value) {
      this.fireItemSelected();
      return this;
    }
    if (value == null) {
      this.reset();
      return this;
    }
    var idx = findIndex(this.options, function (option) {
      return option.value === value;
    });
    if (idx !== -1) {
      var option = this.options[idx];
      this.value = option.value;
      this.displayValue = option.text != null ? option.text : option.value;
      this.highlightItem(this.itemEls[idx]);
      if (!silent) {
        this.fireChangeEvent();
      }
    }
    return this;
  };
  AgList.prototype.setValueByIndex = function (idx) {
    return this.setValue(this.options[idx].value);
  };
  AgList.prototype.getValue = function () {
    return this.value;
  };
  AgList.prototype.getDisplayValue = function () {
    return this.displayValue;
  };
  AgList.prototype.refreshHighlighted = function () {
    var _this = this;
    this.clearHighlighted();
    var idx = findIndex(this.options, function (option) {
      return option.value === _this.value;
    });
    if (idx !== -1) {
      this.highlightItem(this.itemEls[idx]);
    }
  };
  AgList.prototype.reset = function () {
    this.value = null;
    this.displayValue = null;
    this.clearHighlighted();
    this.fireChangeEvent();
  };
  AgList.prototype.highlightItem = function (el) {
    if (!el.offsetParent) {
      return;
    }
    this.clearHighlighted();
    this.highlightedEl = el;
    addCssClass(this.highlightedEl, AgList.ACTIVE_CLASS);
    _setAriaSelected(this.highlightedEl, true);
    this.highlightedEl.focus();
  };
  AgList.prototype.clearHighlighted = function () {
    if (!this.highlightedEl || !this.highlightedEl.offsetParent) {
      return;
    }
    removeCssClass(this.highlightedEl, AgList.ACTIVE_CLASS);
    _setAriaSelected(this.highlightedEl, false);
    this.highlightedEl = null;
  };
  AgList.prototype.fireChangeEvent = function () {
    this.dispatchEvent({
      type: AgAbstractField.EVENT_CHANGED
    });
    this.fireItemSelected();
  };
  AgList.prototype.fireItemSelected = function () {
    this.dispatchEvent({
      type: AgList.EVENT_ITEM_SELECTED
    });
  };
  AgList.EVENT_ITEM_SELECTED = 'selectedItem';
  AgList.ACTIVE_CLASS = 'ag-active-item';
  __decorate$g([PostConstruct], AgList.prototype, "init", null);
  return AgList;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$f = undefined && undefined.__extends || function () {
  var _extendStatics16 = function extendStatics(d, b) {
    _extendStatics16 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics16(d, b);
  };
  return function (d, b) {
    _extendStatics16(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$h = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgSelect = /** @class */function (_super) {
  __extends$f(AgSelect, _super);
  function AgSelect(config) {
    return _super.call(this, config, 'ag-select', 'smallDown', 'listbox') || this;
  }
  AgSelect.prototype.init = function () {
    var _this = this;
    this.listComponent = this.createBean(new AgList('select'));
    this.listComponent.setParentComponent(this);
    this.eWrapper.tabIndex = 0;
    this.listComponent.addManagedListener(this.listComponent, AgList.EVENT_ITEM_SELECTED, function () {
      if (_this.hideList) {
        _this.hideList();
      }
    });
    this.listComponent.addManagedListener(this.listComponent, AgAbstractField.EVENT_CHANGED, function () {
      _this.setValue(_this.listComponent.getValue(), false, true);
      if (_this.hideList) {
        _this.hideList();
      }
    });
  };
  AgSelect.prototype.showPicker = function () {
    var _this = this;
    var listGui = this.listComponent.getGui();
    var destroyMouseWheelFunc = this.addManagedListener(document.body, 'wheel', function (e) {
      if (!listGui.contains(e.target) && _this.hideList) {
        _this.hideList();
      }
    });
    var destroyFocusOutFunc = this.addManagedListener(listGui, 'focusout', function (e) {
      if (!listGui.contains(e.relatedTarget) && _this.hideList) {
        _this.hideList();
      }
    });
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: listGui,
      closeOnEsc: true,
      closedCallback: function closedCallback() {
        _this.hideList = null;
        _this.isPickerDisplayed = false;
        destroyFocusOutFunc();
        destroyMouseWheelFunc();
        if (_this.isAlive()) {
          _this.getFocusableElement().focus();
        }
      },
      ariaLabel: translate('ariaLabelSelectField', 'Select Field')
    });
    if (addPopupRes) {
      this.hideList = addPopupRes.hideFunc;
    }
    this.isPickerDisplayed = true;
    setElementWidth(listGui, getAbsoluteWidth(this.eWrapper));
    listGui.style.maxHeight = getInnerHeight(this.popupService.getPopupParent()) + 'px';
    listGui.style.position = 'absolute';
    this.popupService.positionPopupUnderComponent({
      type: 'ag-list',
      eventSource: this.eWrapper,
      ePopup: listGui,
      keepWithinBounds: true
    });
    this.listComponent.refreshHighlighted();
    return this.listComponent;
  };
  AgSelect.prototype.addOptions = function (options) {
    var _this = this;
    options.forEach(function (option) {
      return _this.addOption(option);
    });
    return this;
  };
  AgSelect.prototype.addOption = function (option) {
    this.listComponent.addOption(option);
    return this;
  };
  AgSelect.prototype.setValue = function (value, silent, fromPicker) {
    if (this.value === value) {
      return this;
    }
    if (!fromPicker) {
      this.listComponent.setValue(value, true);
    }
    var newValue = this.listComponent.getValue();
    if (newValue === this.getValue()) {
      return this;
    }
    this.eDisplayField.innerHTML = this.listComponent.getDisplayValue();
    return _super.prototype.setValue.call(this, value, silent);
  };
  AgSelect.prototype.destroy = function () {
    if (this.hideList) {
      this.hideList();
    }
    this.destroyBean(this.listComponent);
    _super.prototype.destroy.call(this);
  };
  __decorate$h([Autowired('popupService')], AgSelect.prototype, "popupService", void 0);
  __decorate$h([PostConstruct], AgSelect.prototype, "init", null);
  return AgSelect;
}(AgPickerField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$g = undefined && undefined.__extends || function () {
  var _extendStatics17 = function extendStatics(d, b) {
    _extendStatics17 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics17(d, b);
  };
  return function (d, b) {
    _extendStatics17(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$i = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgAbstractInputField = /** @class */function (_super) {
  __extends$g(AgAbstractInputField, _super);
  function AgAbstractInputField(config, className, inputType, displayFieldTag) {
    if (inputType === void 0) {
      inputType = 'text';
    }
    if (displayFieldTag === void 0) {
      displayFieldTag = 'input';
    }
    var _this = _super.call(this, config, /* html */"\n            <div role=\"presentation\">\n                <div ref=\"eLabel\" class=\"ag-input-field-label\"></div>\n                <div ref=\"eWrapper\" class=\"ag-wrapper ag-input-wrapper\" role=\"presentation\">\n                    <" + displayFieldTag + " ref=\"eInput\" class=\"ag-input-field-input\"></" + displayFieldTag + ">\n                </div>\n            </div>", className) || this;
    _this.inputType = inputType;
    _this.displayFieldTag = displayFieldTag;
    return _this;
  }
  AgAbstractInputField.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    this.setInputType();
    addCssClass(this.eLabel, this.className + "-label");
    addCssClass(this.eWrapper, this.className + "-input-wrapper");
    addCssClass(this.eInput, this.className + "-input");
    addCssClass(this.getGui(), 'ag-input-field');
    this.eInput.id = this.eInput.id || "ag-" + this.getCompId() + "-input";
    var _a = this.config,
      width = _a.width,
      value = _a.value;
    if (width != null) {
      this.setWidth(width);
    }
    if (value != null) {
      this.setValue(value);
    }
    this.addInputListeners();
  };
  AgAbstractInputField.prototype.refreshLabel = function () {
    if (exists(this.getLabel())) {
      setAriaLabelledBy(this.eInput, this.getLabelId());
    } else {
      this.eInput.removeAttribute('aria-labelledby');
    }
    _super.prototype.refreshLabel.call(this);
  };
  AgAbstractInputField.prototype.addInputListeners = function () {
    var _this = this;
    this.addManagedListener(this.eInput, 'input', function (e) {
      return _this.setValue(e.target.value);
    });
  };
  AgAbstractInputField.prototype.setInputType = function () {
    if (this.displayFieldTag === 'input') {
      this.eInput.setAttribute('type', this.inputType);
    }
  };
  AgAbstractInputField.prototype.getInputElement = function () {
    return this.eInput;
  };
  AgAbstractInputField.prototype.setInputWidth = function (width) {
    setElementWidth(this.eWrapper, width);
    return this;
  };
  AgAbstractInputField.prototype.setInputName = function (name) {
    this.getInputElement().setAttribute('name', name);
    return this;
  };
  AgAbstractInputField.prototype.getFocusableElement = function () {
    return this.eInput;
  };
  AgAbstractInputField.prototype.setMaxLength = function (length) {
    var eInput = this.eInput;
    eInput.maxLength = length;
    return this;
  };
  AgAbstractInputField.prototype.setInputPlaceholder = function (placeholder) {
    addOrRemoveAttribute(this.eInput, 'placeholder', placeholder);
    return this;
  };
  AgAbstractInputField.prototype.setInputAriaLabel = function (label) {
    _setAriaLabel(this.eInput, label);
    return this;
  };
  AgAbstractInputField.prototype.setDisabled = function (disabled) {
    setDisabled(this.eInput, disabled);
    return _super.prototype.setDisabled.call(this, disabled);
  };
  __decorate$i([RefSelector('eLabel')], AgAbstractInputField.prototype, "eLabel", void 0);
  __decorate$i([RefSelector('eWrapper')], AgAbstractInputField.prototype, "eWrapper", void 0);
  __decorate$i([RefSelector('eInput')], AgAbstractInputField.prototype, "eInput", void 0);
  return AgAbstractInputField;
}(AgAbstractField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$h = undefined && undefined.__extends || function () {
  var _extendStatics18 = function extendStatics(d, b) {
    _extendStatics18 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics18(d, b);
  };
  return function (d, b) {
    _extendStatics18(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$j = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ConditionPosition;
(function (ConditionPosition) {
  ConditionPosition[ConditionPosition["One"] = 0] = "One";
  ConditionPosition[ConditionPosition["Two"] = 1] = "Two";
})(ConditionPosition || (ConditionPosition = {}));
/**
 * Every filter with a dropdown where the user can specify a comparing type against the filter values.
 *
 * @param M type of filter-model managed by the concrete sub-class that extends this type
 * @param V type of value managed by the concrete sub-class that extends this type
 * @param E type of UI element used for collecting user-input
 */
var SimpleFilter = /** @class */function (_super) {
  __extends$h(SimpleFilter, _super);
  function SimpleFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SimpleFilter.prototype.getNumberOfInputs = function (type) {
    var customOpts = this.optionsFactory.getCustomOption(type);
    if (customOpts) {
      var numberOfInputs = customOpts.numberOfInputs;
      return numberOfInputs != null ? numberOfInputs : 1;
    }
    if (type === SimpleFilter.EMPTY) {
      return 0;
    } else if (type === SimpleFilter.IN_RANGE) {
      return 2;
    }
    return 1;
  };
  // floating filter calls this when user applies filter from floating filter
  SimpleFilter.prototype.onFloatingFilterChanged = function (type, value) {
    this.setTypeFromFloatingFilter(type);
    this.setValueFromFloatingFilter(value);
    this.onUiChanged(true);
  };
  SimpleFilter.prototype.setTypeFromFloatingFilter = function (type) {
    this.eType1.setValue(type);
    this.eType2.setValue(this.optionsFactory.getDefaultOption());
    (this.isDefaultOperator('AND') ? this.eJoinOperatorAnd : this.eJoinOperatorOr).setValue(true);
  };
  SimpleFilter.prototype.getModelFromUi = function () {
    if (!this.isConditionUiComplete(ConditionPosition.One)) {
      return null;
    }
    if (this.isAllowTwoConditions() && this.isConditionUiComplete(ConditionPosition.Two)) {
      return {
        filterType: this.getFilterType(),
        operator: this.getJoinOperator(),
        condition1: this.createCondition(ConditionPosition.One),
        condition2: this.createCondition(ConditionPosition.Two)
      };
    }
    return this.createCondition(ConditionPosition.One);
  };
  SimpleFilter.prototype.getConditionTypes = function () {
    return [this.eType1.getValue(), this.eType2.getValue()];
  };
  SimpleFilter.prototype.getJoinOperator = function () {
    return this.eJoinOperatorOr.getValue() === true ? 'OR' : 'AND';
  };
  SimpleFilter.prototype.areModelsEqual = function (a, b) {
    // both are missing
    if (!a && !b) {
      return true;
    }
    // one is missing, other present
    if (!a && b || a && !b) {
      return false;
    }
    // one is combined, the other is not
    var aIsSimple = !a.operator;
    var bIsSimple = !b.operator;
    var oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
    if (oneSimpleOneCombined) {
      return false;
    }
    var res;
    // otherwise both present, so compare
    if (aIsSimple) {
      var aSimple = a;
      var bSimple = b;
      res = this.areSimpleModelsEqual(aSimple, bSimple);
    } else {
      var aCombined = a;
      var bCombined = b;
      res = aCombined.operator === bCombined.operator && this.areSimpleModelsEqual(aCombined.condition1, bCombined.condition1) && this.areSimpleModelsEqual(aCombined.condition2, bCombined.condition2);
    }
    return res;
  };
  SimpleFilter.prototype.setModelIntoUi = function (model) {
    var isCombined = model.operator;
    if (isCombined) {
      var combinedModel = model;
      var orChecked = combinedModel.operator === 'OR';
      this.eJoinOperatorAnd.setValue(!orChecked);
      this.eJoinOperatorOr.setValue(orChecked);
      this.eType1.setValue(combinedModel.condition1.type);
      this.eType2.setValue(combinedModel.condition2.type);
      this.setConditionIntoUi(combinedModel.condition1, ConditionPosition.One);
      this.setConditionIntoUi(combinedModel.condition2, ConditionPosition.Two);
    } else {
      var simpleModel = model;
      this.eJoinOperatorAnd.setValue(this.isDefaultOperator('AND'));
      this.eJoinOperatorOr.setValue(this.isDefaultOperator('OR'));
      this.eType1.setValue(simpleModel.type);
      this.eType2.setValue(this.optionsFactory.getDefaultOption());
      this.setConditionIntoUi(simpleModel, ConditionPosition.One);
      this.setConditionIntoUi(null, ConditionPosition.Two);
    }
    return AgPromise.resolve();
  };
  SimpleFilter.prototype.doesFilterPass = function (params) {
    var _this = this;
    var model = this.getModel();
    if (model == null) {
      return true;
    }
    var operator = model.operator;
    var models = [];
    if (operator) {
      var combinedModel = model;
      models.push(combinedModel.condition1, combinedModel.condition2);
    } else {
      models.push(model);
    }
    var combineFunction = operator && operator === 'OR' ? some : every;
    return combineFunction(models, function (m) {
      return _this.individualConditionPasses(params, m);
    });
  };
  SimpleFilter.prototype.setParams = function (params) {
    _super.prototype.setParams.call(this, params);
    this.optionsFactory = new OptionsFactory();
    this.optionsFactory.init(params, this.getDefaultFilterOptions());
    this.allowTwoConditions = !params.suppressAndOrCondition;
    this.alwaysShowBothConditions = !!params.alwaysShowBothConditions;
    this.defaultJoinOperator = this.getDefaultJoinOperator(params.defaultJoinOperator);
    this.putOptionsIntoDropdown();
    this.addChangedListeners();
  };
  SimpleFilter.prototype.getDefaultJoinOperator = function (defaultJoinOperator) {
    return includes(['AND', 'OR'], defaultJoinOperator) ? defaultJoinOperator : 'AND';
  };
  SimpleFilter.prototype.putOptionsIntoDropdown = function () {
    var _this = this;
    var filterOptions = this.optionsFactory.getFilterOptions();
    var eTypes = [this.eType1, this.eType2];
    // Add specified options to all condition drop-downs.
    forEach$4(filterOptions, function (option) {
      var listOption = typeof option === 'string' ? _this.createBoilerplateListOption(option) : _this.createCustomListOption(option);
      forEach$4(eTypes, function (eType) {
        return eType.addOption(listOption);
      });
    });
    // Make drop-downs read-only if there is only one option.
    forEach$4(eTypes, function (eType) {
      return eType.setDisabled(filterOptions.length <= 1);
    });
  };
  SimpleFilter.prototype.createBoilerplateListOption = function (option) {
    return {
      value: option,
      text: this.translate(option)
    };
  };
  SimpleFilter.prototype.createCustomListOption = function (option) {
    var displayKey = option.displayKey;
    var customOption = this.optionsFactory.getCustomOption(option.displayKey);
    return {
      value: displayKey,
      text: customOption ? this.gridOptionsWrapper.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
    };
  };
  SimpleFilter.prototype.isAllowTwoConditions = function () {
    return this.allowTwoConditions;
  };
  SimpleFilter.prototype.createBodyTemplate = function () {
    return (/* html */"\n            <ag-select class=\"ag-filter-select\" ref=\"eOptions1\"></ag-select>\n            " + this.createValueTemplate(ConditionPosition.One) + "\n            <div class=\"ag-filter-condition\" ref=\"eJoinOperatorPanel\">\n               <ag-radio-button ref=\"eJoinOperatorAnd\" class=\"ag-filter-condition-operator ag-filter-condition-operator-and\"></ag-radio-button>\n               <ag-radio-button ref=\"eJoinOperatorOr\" class=\"ag-filter-condition-operator ag-filter-condition-operator-or\"></ag-radio-button>\n            </div>\n            <ag-select class=\"ag-filter-select\" ref=\"eOptions2\"></ag-select>\n            " + this.createValueTemplate(ConditionPosition.Two)
    );
  };
  SimpleFilter.prototype.getCssIdentifier = function () {
    return 'simple-filter';
  };
  SimpleFilter.prototype.updateUiVisibility = function () {
    var _this = this;
    var elementConditionGroups = [[this.eType1], [this.eType2, this.eJoinOperatorPanel, this.eJoinOperatorAnd, this.eJoinOperatorOr]];
    var elementBodies = [this.eCondition1Body, this.eCondition2Body];
    forEach$4(elementConditionGroups, function (group, position) {
      var visible = _this.isConditionVisible(position);
      var disabled = _this.isConditionDisabled(position);
      forEach$4(group, function (element) {
        if (element instanceof AgAbstractInputField || element instanceof AgSelect) {
          element.setDisabled(disabled);
          element.setDisplayed(visible);
        } else {
          setDisabled(element, disabled);
          setDisplayed(element, visible);
        }
      });
    });
    forEach$4(elementBodies, function (element, index) {
      setDisplayed(element, _this.isConditionBodyVisible(index));
    });
    this.forEachInput(function (element, index, position, numberOfInputs) {
      _this.setElementDisplayed(element, index < numberOfInputs);
      _this.setElementDisabled(element, _this.isConditionDisabled(position));
    });
    this.resetPlaceholder();
  };
  SimpleFilter.prototype.afterGuiAttached = function (params) {
    _super.prototype.afterGuiAttached.call(this, params);
    this.resetPlaceholder();
    if (!params || !params.suppressFocus && !this.isReadOnly()) {
      var firstInput = this.getInputs()[0][0];
      if (!firstInput) {
        return;
      }
      if (firstInput instanceof AgAbstractInputField) {
        firstInput.getInputElement().focus();
      }
    }
  };
  // allow sub-classes to reset HTML placeholders after UI update.
  SimpleFilter.prototype.resetPlaceholder = function () {
    var _this = this;
    var globalTranslate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.forEachInput(function (element, index, _, numberOfInputs) {
      if (!(element instanceof AgAbstractInputField)) {
        return;
      }
      var placeholder = index === 0 && numberOfInputs > 1 ? 'inRangeStart' : index === 0 ? 'filterOoo' : 'inRangeEnd';
      var ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate('ariaFilterFromValue', 'Filter from value') : index === 0 ? globalTranslate('ariaFilterValue', 'Filter Value') : globalTranslate('ariaFilterToValue', 'Filter to Value');
      element.setInputPlaceholder(_this.translate(placeholder));
      element.setInputAriaLabel(ariaLabel);
    });
  };
  SimpleFilter.prototype.setElementValue = function (element, value, silent) {
    if (element instanceof AgAbstractInputField) {
      element.setValue(value ? String(value) : null, silent);
    }
  };
  SimpleFilter.prototype.setElementDisplayed = function (element, displayed) {
    if (element instanceof Component) {
      setDisplayed(element.getGui(), displayed);
    }
  };
  SimpleFilter.prototype.setElementDisabled = function (element, disabled) {
    if (element instanceof Component) {
      setDisabled(element.getGui(), disabled);
    }
  };
  SimpleFilter.prototype.attachElementOnChange = function (element, listener) {
    if (element instanceof AgAbstractInputField) {
      element.onValueChange(listener);
    }
  };
  SimpleFilter.prototype.forEachInput = function (cb) {
    var _this = this;
    var inputs = this.getInputs();
    this.getConditionTypes().forEach(function (type, position) {
      var numberOfInputs = _this.getNumberOfInputs(type);
      for (var index = 0; index < inputs[position].length; index++) {
        var input = inputs[position][index];
        if (input != null) {
          cb(input, index, position, numberOfInputs);
        }
      }
    });
  };
  SimpleFilter.prototype.isConditionVisible = function (position) {
    if (position === 0) {
      return true;
    } // Position 0 should always be visible.
    if (!this.allowTwoConditions) {
      return false;
    } // Short-circuit if no tail conditions.
    if (this.isReadOnly()) {
      // Only display a condition when read-only if the condition is complete.
      return this.isConditionUiComplete(position);
    }
    if (this.alwaysShowBothConditions) {
      return true;
    }
    // Only display a 2nd or later condition when the previous condition is complete.
    return this.isConditionUiComplete(position - 1);
  };
  SimpleFilter.prototype.isConditionDisabled = function (position) {
    if (this.isReadOnly()) {
      return true;
    } // Read-only mode trumps everything.
    if (!this.isConditionVisible(position)) {
      return true;
    } // Invisible implies disabled.
    if (position === 0) {
      return false;
    } // Position 0 should typically be editable.
    // Only allow editing of a 2nd or later condition if the previous condition is complete.
    return !this.isConditionUiComplete(position - 1);
  };
  SimpleFilter.prototype.isConditionBodyVisible = function (position) {
    if (!this.isConditionVisible(position)) {
      return false;
    }
    // Check that the condition needs inputs.
    var type = this.getConditionTypes()[position];
    var numberOfInputs = this.getNumberOfInputs(type);
    return numberOfInputs > 0;
  };
  // returns true if the UI represents a working filter, eg all parts are filled out.
  // eg if text filter and textfield blank then returns false.
  SimpleFilter.prototype.isConditionUiComplete = function (position) {
    var type = this.getConditionTypes()[position];
    if (type === SimpleFilter.EMPTY) {
      return false;
    }
    if (_.some(this.getValues(position), function (v) {
      return v == null;
    })) {
      return false;
    }
    return true;
  };
  SimpleFilter.prototype.resetUiToDefaults = function (silent) {
    var _this = this;
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var filteringLabel = translate('ariaFilteringOperator', 'Filtering operator');
    var uniqueGroupId = 'ag-simple-filter-and-or-' + this.getCompId();
    var defaultOption = this.optionsFactory.getDefaultOption();
    this.eType1.setValue(defaultOption, silent).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly());
    this.eType2.setValue(this.optionsFactory.getDefaultOption(), silent).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly());
    this.eJoinOperatorAnd.setValue(this.isDefaultOperator('AND'), silent).setName(uniqueGroupId).setLabel(this.translate('andCondition')).setDisabled(this.isReadOnly());
    this.eJoinOperatorOr.setValue(this.isDefaultOperator('OR'), silent).setName(uniqueGroupId).setLabel(this.translate('orCondition')).setDisabled(this.isReadOnly());
    this.forEachInput(function (element) {
      _this.setElementValue(element, null, silent);
      _this.setElementDisabled(element, _this.isReadOnly());
    });
    this.resetPlaceholder();
    return AgPromise.resolve();
  };
  // puts model values into the UI
  SimpleFilter.prototype.setConditionIntoUi = function (model, position) {
    var _this = this;
    var values = this.mapValuesFromModel(model);
    this.forEachInput(function (element, index, elPosition, _) {
      if (elPosition !== position) {
        return;
      }
      _this.setElementValue(element, values[index] ? values[index] : null);
    });
  };
  // after floating filter changes, this sets the 'value' section. this is implemented by the base class
  // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
  SimpleFilter.prototype.setValueFromFloatingFilter = function (value) {
    var _this = this;
    this.forEachInput(function (element, index, position, _) {
      _this.setElementValue(element, index === 0 && position === 0 ? value : null);
    });
  };
  SimpleFilter.prototype.isDefaultOperator = function (operator) {
    return operator === this.defaultJoinOperator;
  };
  SimpleFilter.prototype.addChangedListeners = function () {
    var _this = this;
    if (this.isReadOnly()) {
      return;
    }
    var listener = function listener() {
      return _this.onUiChanged();
    };
    this.eType1.onValueChange(listener);
    this.eType2.onValueChange(listener);
    this.eJoinOperatorOr.onValueChange(listener);
    this.eJoinOperatorAnd.onValueChange(listener);
    this.forEachInput(function (element) {
      _this.attachElementOnChange(element, listener);
    });
  };
  /** returns true if the row passes the said condition */
  SimpleFilter.prototype.individualConditionPasses = function (params, filterModel) {
    var cellValue = this.getCellValue(params.node);
    var values = this.mapValuesFromModel(filterModel);
    var customFilterOption = this.optionsFactory.getCustomOption(filterModel.type);
    var customFilterResult = this.evaluateCustomFilter(customFilterOption, values, cellValue);
    if (customFilterResult != null) {
      return customFilterResult;
    }
    if (cellValue == null) {
      return this.evaluateNullValue(filterModel.type);
    }
    return this.evaluateNonNullValue(values, cellValue, filterModel);
  };
  SimpleFilter.prototype.evaluateCustomFilter = function (customFilterOption, values, cellValue) {
    if (customFilterOption == null) {
      return;
    }
    var predicate = customFilterOption.predicate;
    // only execute the custom filter if a value exists or a value isn't required, i.e. input is hidden
    if (predicate != null && !_.some(values, function (v) {
      return v == null;
    })) {
      return predicate(values, cellValue);
    }
    // No custom filter invocation, indicate that to the caller.
    return;
  };
  SimpleFilter.EMPTY = 'empty';
  SimpleFilter.EQUALS = 'equals';
  SimpleFilter.NOT_EQUAL = 'notEqual';
  SimpleFilter.LESS_THAN = 'lessThan';
  SimpleFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
  SimpleFilter.GREATER_THAN = 'greaterThan';
  SimpleFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
  SimpleFilter.IN_RANGE = 'inRange';
  SimpleFilter.CONTAINS = 'contains';
  SimpleFilter.NOT_CONTAINS = 'notContains';
  SimpleFilter.STARTS_WITH = 'startsWith';
  SimpleFilter.ENDS_WITH = 'endsWith';
  __decorate$j([RefSelector('eOptions1')], SimpleFilter.prototype, "eType1", void 0);
  __decorate$j([RefSelector('eOptions2')], SimpleFilter.prototype, "eType2", void 0);
  __decorate$j([RefSelector('eJoinOperatorPanel')], SimpleFilter.prototype, "eJoinOperatorPanel", void 0);
  __decorate$j([RefSelector('eJoinOperatorAnd')], SimpleFilter.prototype, "eJoinOperatorAnd", void 0);
  __decorate$j([RefSelector('eJoinOperatorOr')], SimpleFilter.prototype, "eJoinOperatorOr", void 0);
  __decorate$j([RefSelector('eCondition1Body')], SimpleFilter.prototype, "eCondition1Body", void 0);
  __decorate$j([RefSelector('eCondition2Body')], SimpleFilter.prototype, "eCondition2Body", void 0);
  return SimpleFilter;
}(ProvidedFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$i = undefined && undefined.__extends || function () {
  var _extendStatics19 = function extendStatics(d, b) {
    _extendStatics19 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics19(d, b);
  };
  return function (d, b) {
    _extendStatics19(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ScalarFilter = /** @class */function (_super) {
  __extends$i(ScalarFilter, _super);
  function ScalarFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ScalarFilter.prototype.setParams = function (params) {
    _super.prototype.setParams.call(this, params);
    this.scalarFilterParams = params;
    this.checkDeprecatedParams();
  };
  ScalarFilter.prototype.checkDeprecatedParams = function () {
    if (this.scalarFilterParams.nullComparator) {
      console.warn('AG Grid: Since v21.0, the property filterParams.nullComparator is deprecated. ' + 'Please use filterParams.includeBlanksInEquals, filterParams.includeBlanksInLessThan and ' + 'filterParams.includeBlanksInGreaterThan instead.');
      this.scalarFilterParams.includeBlanksInEquals = this.scalarFilterParams.nullComparator.equals;
      this.scalarFilterParams.includeBlanksInLessThan = this.scalarFilterParams.nullComparator.lessThan;
      this.scalarFilterParams.includeBlanksInGreaterThan = this.scalarFilterParams.nullComparator.greaterThan;
    }
  };
  ScalarFilter.prototype.evaluateNullValue = function (filterType) {
    switch (filterType) {
      case ScalarFilter.EQUALS:
      case ScalarFilter.NOT_EQUAL:
        if (this.scalarFilterParams.includeBlanksInEquals) {
          return true;
        }
        break;
      case ScalarFilter.GREATER_THAN:
      case ScalarFilter.GREATER_THAN_OR_EQUAL:
        if (this.scalarFilterParams.includeBlanksInGreaterThan) {
          return true;
        }
        break;
      case ScalarFilter.LESS_THAN:
      case ScalarFilter.LESS_THAN_OR_EQUAL:
        if (this.scalarFilterParams.includeBlanksInLessThan) {
          return true;
        }
        break;
      case ScalarFilter.IN_RANGE:
        if (this.scalarFilterParams.includeBlanksInRange) {
          return true;
        }
        break;
    }
    return false;
  };
  ScalarFilter.prototype.evaluateNonNullValue = function (values, cellValue, filterModel) {
    var comparator = this.comparator();
    var compareResult = comparator(values[0], cellValue);
    switch (filterModel.type) {
      case ScalarFilter.EQUALS:
        return compareResult === 0;
      case ScalarFilter.NOT_EQUAL:
        return compareResult !== 0;
      case ScalarFilter.GREATER_THAN:
        return compareResult > 0;
      case ScalarFilter.GREATER_THAN_OR_EQUAL:
        return compareResult >= 0;
      case ScalarFilter.LESS_THAN:
        return compareResult < 0;
      case ScalarFilter.LESS_THAN_OR_EQUAL:
        return compareResult <= 0;
      case ScalarFilter.IN_RANGE:
        {
          var compareToResult = comparator(values[1], cellValue);
          return this.scalarFilterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
        }
      default:
        console.warn('AG Grid: Unexpected type of filter "' + filterModel.type + '", it looks like the filter was configured with incorrect Filter Options');
        return true;
    }
  };
  return ScalarFilter;
}(SimpleFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$j = undefined && undefined.__extends || function () {
  var _extendStatics20 = function extendStatics(d, b) {
    _extendStatics20 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics20(d, b);
  };
  return function (d, b) {
    _extendStatics20(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$6 = undefined && undefined.__assign || function () {
  __assign$6 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$6.apply(this, arguments);
};
var __decorate$k = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DEFAULT_MIN_YEAR = 1000;
var DEFAULT_MAX_YEAR = Infinity;
var DateFilter = /** @class */function (_super) {
  __extends$j(DateFilter, _super);
  function DateFilter() {
    var _this = _super.call(this, 'dateFilter') || this;
    _this.minValidYear = DEFAULT_MIN_YEAR;
    _this.maxValidYear = DEFAULT_MAX_YEAR;
    return _this;
  }
  DateFilter.prototype.afterGuiAttached = function (params) {
    _super.prototype.afterGuiAttached.call(this, params);
    this.dateCondition1FromComp.afterGuiAttached(params);
  };
  DateFilter.prototype.mapValuesFromModel = function (filterModel) {
    // unlike the other filters, we do two things here:
    // 1) allow for different attribute names (same as done for other filters) (eg the 'from' and 'to'
    //    are in different locations in Date and Number filter models)
    // 2) convert the type (because Date filter uses Dates, however model is 'string')
    //
    // NOTE: The conversion of string to date also removes the timezone - i.e. when user picks
    //       a date from the UI, it will have timezone info in it. This is lost when creating
    //       the model. When we recreate the date again here, it's without a timezone.
    var _a = filterModel || {},
      dateFrom = _a.dateFrom,
      dateTo = _a.dateTo,
      type = _a.type;
    return [dateFrom && parseDateTimeFromString(dateFrom) || null, dateTo && parseDateTimeFromString(dateTo) || null].slice(0, this.getNumberOfInputs(type));
  };
  DateFilter.prototype.comparator = function () {
    return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
  };
  DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
    // The default comparator assumes that the cellValue is a date
    var cellAsDate = cellValue;
    if (cellValue == null || cellAsDate < filterDate) {
      return -1;
    }
    if (cellAsDate > filterDate) {
      return 1;
    }
    return 0;
  };
  DateFilter.prototype.setParams = function (params) {
    _super.prototype.setParams.call(this, params);
    this.dateFilterParams = params;
    var yearParser = function yearParser(param, fallback) {
      if (params[param] != null) {
        if (!isNaN(params[param])) {
          return params[param] == null ? fallback : Number(params[param]);
        } else {
          console.warn("AG Grid: DateFilter " + param + " is not a number");
        }
      }
      return fallback;
    };
    this.minValidYear = yearParser('minValidYear', DEFAULT_MIN_YEAR);
    this.maxValidYear = yearParser('maxValidYear', DEFAULT_MAX_YEAR);
    if (this.minValidYear > this.maxValidYear) {
      console.warn("AG Grid: DateFilter minValidYear should be <= maxValidYear");
    }
    this.createDateComponents();
  };
  DateFilter.prototype.createDateComponents = function () {
    var _this = this;
    var createDateCompWrapper = function createDateCompWrapper(element) {
      return new DateCompWrapper(_this.getContext(), _this.userComponentFactory, {
        onDateChanged: function onDateChanged() {
          return _this.onUiChanged();
        },
        filterParams: _this.dateFilterParams
      }, element);
    };
    this.dateCondition1FromComp = createDateCompWrapper(this.eCondition1PanelFrom);
    this.dateCondition1ToComp = createDateCompWrapper(this.eCondition1PanelTo);
    this.dateCondition2FromComp = createDateCompWrapper(this.eCondition2PanelFrom);
    this.dateCondition2ToComp = createDateCompWrapper(this.eCondition2PanelTo);
    this.addDestroyFunc(function () {
      _this.forEachInput(function (element) {
        return element.destroy();
      });
    });
  };
  DateFilter.prototype.setElementValue = function (element, value, silent) {
    element.setDate(value);
  };
  DateFilter.prototype.setElementDisplayed = function (element, displayed) {
    element.setDisplayed(displayed);
  };
  DateFilter.prototype.setElementDisabled = function (element, disabled) {
    element.setDisabled(disabled);
  };
  DateFilter.prototype.getDefaultFilterOptions = function () {
    return DateFilter.DEFAULT_FILTER_OPTIONS;
  };
  DateFilter.prototype.createValueTemplate = function (position) {
    var pos = position === ConditionPosition.One ? '1' : '2';
    return (/* html */"\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\">\n                <div class=\"ag-filter-from ag-filter-date-from\" ref=\"eCondition" + pos + "PanelFrom\"></div>\n                <div class=\"ag-filter-to ag-filter-date-to\" ref=\"eCondition" + pos + "PanelTo\"></div>\n            </div>"
    );
  };
  DateFilter.prototype.isConditionUiComplete = function (position) {
    var _this = this;
    if (!_super.prototype.isConditionUiComplete.call(this, position)) {
      return false;
    }
    var isValidDate = function isValidDate(value) {
      return value != null && value.getUTCFullYear() >= _this.minValidYear && value.getUTCFullYear() <= _this.maxValidYear;
    };
    var valid = true;
    this.forEachInput(function (element, index, elPosition, numberOfInputs) {
      if (elPosition !== position || !valid || index >= numberOfInputs) {
        return;
      }
      valid = valid && isValidDate(element.getDate());
    });
    return valid;
  };
  DateFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
    return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
  };
  DateFilter.prototype.getFilterType = function () {
    return 'date';
  };
  DateFilter.prototype.createCondition = function (position) {
    var type = this.getConditionTypes()[position];
    var model = {};
    var values = this.getValues(position);
    if (values.length > 0) {
      model.dateFrom = serialiseDate(values[0]);
    }
    if (values.length > 1) {
      model.dateTo = serialiseDate(values[1]);
    }
    return __assign$6({
      dateFrom: null,
      dateTo: null,
      filterType: this.getFilterType(),
      type: type
    }, model);
  };
  DateFilter.prototype.resetPlaceholder = function () {
    var globalTranslate = this.gridOptionsWrapper.getLocaleTextFunc();
    var placeholder = this.translate('dateFormatOoo');
    var ariaLabel = globalTranslate('ariaFilterValue', 'Filter Value');
    this.forEachInput(function (element) {
      element.setInputPlaceholder(placeholder);
      element.setInputAriaLabel(ariaLabel);
    });
  };
  DateFilter.prototype.getInputs = function () {
    return [[this.dateCondition1FromComp, this.dateCondition1ToComp], [this.dateCondition2FromComp, this.dateCondition2ToComp]];
  };
  DateFilter.prototype.getValues = function (position) {
    var result = [];
    this.forEachInput(function (element, index, elPosition, numberOfInputs) {
      if (position === elPosition && index < numberOfInputs) {
        result.push(element.getDate());
      }
    });
    return result;
  };
  DateFilter.DEFAULT_FILTER_OPTIONS = [ScalarFilter.EQUALS, ScalarFilter.GREATER_THAN, ScalarFilter.LESS_THAN, ScalarFilter.NOT_EQUAL, ScalarFilter.IN_RANGE];
  __decorate$k([RefSelector('eCondition1PanelFrom')], DateFilter.prototype, "eCondition1PanelFrom", void 0);
  __decorate$k([RefSelector('eCondition1PanelTo')], DateFilter.prototype, "eCondition1PanelTo", void 0);
  __decorate$k([RefSelector('eCondition2PanelFrom')], DateFilter.prototype, "eCondition2PanelFrom", void 0);
  __decorate$k([RefSelector('eCondition2PanelTo')], DateFilter.prototype, "eCondition2PanelTo", void 0);
  __decorate$k([Autowired('userComponentFactory')], DateFilter.prototype, "userComponentFactory", void 0);
  return DateFilter;
}(ScalarFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$k = undefined && undefined.__extends || function () {
  var _extendStatics21 = function extendStatics(d, b) {
    _extendStatics21 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics21(d, b);
  };
  return function (d, b) {
    _extendStatics21(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SimpleFloatingFilter = /** @class */function (_super) {
  __extends$k(SimpleFloatingFilter, _super);
  function SimpleFloatingFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SimpleFloatingFilter.prototype.getDefaultDebounceMs = function () {
    return 0;
  };
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  SimpleFloatingFilter.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
  SimpleFloatingFilter.prototype.getTextFromModel = function (model) {
    if (!model) {
      return null;
    }
    var isCombined = model.operator != null;
    if (isCombined) {
      var combinedModel = model;
      var _a = combinedModel || {},
        condition1 = _a.condition1,
        condition2 = _a.condition2;
      var customOption1 = this.optionsFactory.getCustomOption(condition1.type);
      var customOption2 = this.optionsFactory.getCustomOption(condition2.type);
      return [this.conditionToString(condition1, customOption1), combinedModel.operator, this.conditionToString(condition2, customOption2)].join(' ');
    } else {
      var condition = model;
      var customOption = this.optionsFactory.getCustomOption(condition.type);
      // For custom filter options we display the Name of the filter instead
      // of displaying the `from` value, as it wouldn't be relevant
      var _b = customOption || {},
        displayKey = _b.displayKey,
        displayName = _b.displayName,
        numberOfInputs = _b.numberOfInputs;
      if (displayKey && displayName && numberOfInputs === 0) {
        this.gridOptionsWrapper.getLocaleTextFunc()(displayKey, displayName);
        return displayName;
      }
      return this.conditionToString(condition, customOption);
    }
  };
  SimpleFloatingFilter.prototype.isEventFromFloatingFilter = function (event) {
    return event && event.afterFloatingFilter;
  };
  SimpleFloatingFilter.prototype.getLastType = function () {
    return this.lastType;
  };
  SimpleFloatingFilter.prototype.isReadOnly = function () {
    return this.readOnly;
  };
  SimpleFloatingFilter.prototype.setLastTypeFromModel = function (model) {
    // if no model provided by the parent filter use default
    if (!model) {
      this.lastType = this.optionsFactory.getDefaultOption();
      return;
    }
    var isCombined = model.operator;
    var condition;
    if (isCombined) {
      var combinedModel = model;
      condition = combinedModel.condition1;
    } else {
      condition = model;
    }
    this.lastType = condition.type;
  };
  SimpleFloatingFilter.prototype.canWeEditAfterModelFromParentFilter = function (model) {
    if (!model) {
      // if no model, then we can edit as long as the lastType is something we can edit, as this
      // is the type we will provide to the parent filter if the user decides to use the floating filter.
      return this.isTypeEditable(this.lastType);
    }
    // never allow editing if the filter is combined (ie has two parts)
    var isCombined = model.operator;
    if (isCombined) {
      return false;
    }
    var simpleModel = model;
    return this.isTypeEditable(simpleModel.type);
  };
  SimpleFloatingFilter.prototype.init = function (params) {
    this.optionsFactory = new OptionsFactory();
    this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
    this.lastType = this.optionsFactory.getDefaultOption();
    // readOnly is a property of IProvidedFilterParams - we need to find a better (type-safe)
    // way to support reading this in the future.
    this.readOnly = !!params.filterParams.readOnly;
    // we are editable if:
    // 1) there is a type (user has configured filter wrong if not type)
    //  AND
    // 2) the default type is not 'in range'
    var editable = this.isTypeEditable(this.lastType);
    this.setEditable(editable);
  };
  SimpleFloatingFilter.prototype.doesFilterHaveSingleInput = function (filterType) {
    var customFilterOption = this.optionsFactory.getCustomOption(filterType);
    var numberOfInputs = (customFilterOption || {}).numberOfInputs;
    return numberOfInputs == null || numberOfInputs == 1;
  };
  SimpleFloatingFilter.prototype.isTypeEditable = function (type) {
    return !!type && !this.isReadOnly() && this.doesFilterHaveSingleInput(type) && type !== SimpleFilter.IN_RANGE && type !== SimpleFilter.EMPTY;
  };
  return SimpleFloatingFilter;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$l = undefined && undefined.__extends || function () {
  var _extendStatics22 = function extendStatics(d, b) {
    _extendStatics22 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics22(d, b);
  };
  return function (d, b) {
    _extendStatics22(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$l = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DateFloatingFilter = /** @class */function (_super) {
  __extends$l(DateFloatingFilter, _super);
  function DateFloatingFilter() {
    return _super.call(this, /* html */"\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eReadOnlyText\"></ag-input-text-field>\n                <div ref=\"eDateWrapper\" style=\"display: flex;\"></div>\n            </div>") || this;
  }
  DateFloatingFilter.prototype.getDefaultFilterOptions = function () {
    return DateFilter.DEFAULT_FILTER_OPTIONS;
  };
  DateFloatingFilter.prototype.conditionToString = function (condition, options) {
    var type = condition.type;
    var numberOfInputs = (options || {}).numberOfInputs;
    var isRange = type == SimpleFilter.IN_RANGE || numberOfInputs === 2;
    var dateFrom = parseDateTimeFromString(condition.dateFrom);
    var dateTo = parseDateTimeFromString(condition.dateTo);
    if (isRange) {
      return serialiseDate(dateFrom, false) + "-" + serialiseDate(dateTo, false);
    }
    if (dateFrom != null) {
      return "" + serialiseDate(dateFrom, false);
    }
    // cater for when the type doesn't need a value
    return "" + type;
  };
  DateFloatingFilter.prototype.init = function (params) {
    _super.prototype.init.call(this, params);
    this.params = params;
    this.createDateComponent();
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate('ariaDateFilterInput', 'Date Filter Input'));
  };
  DateFloatingFilter.prototype.setEditable = function (editable) {
    setDisplayed(this.eDateWrapper, editable);
    setDisplayed(this.eReadOnlyText.getGui(), !editable);
  };
  DateFloatingFilter.prototype.onParentModelChanged = function (model, event) {
    // We don't want to update the floating filter if the floating filter caused the change,
    // because the UI is already in sync. if we didn't do this, the UI would behave strangely
    // as it would be updating as the user is typing
    if (this.isEventFromFloatingFilter(event)) {
      return;
    }
    _super.prototype.setLastTypeFromModel.call(this, model);
    var allowEditing = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(model);
    this.setEditable(allowEditing);
    if (allowEditing) {
      if (model) {
        var dateModel = model;
        this.dateComp.setDate(parseDateTimeFromString(dateModel.dateFrom));
      } else {
        this.dateComp.setDate(null);
      }
      this.eReadOnlyText.setValue('');
    } else {
      this.eReadOnlyText.setValue(this.getTextFromModel(model));
      this.dateComp.setDate(null);
    }
  };
  DateFloatingFilter.prototype.onDateChanged = function () {
    var _this = this;
    var filterValueDate = this.dateComp.getDate();
    var filterValueText = serialiseDate(filterValueDate);
    this.params.parentFilterInstance(function (filterInstance) {
      if (filterInstance) {
        var simpleFilter = filterInstance;
        simpleFilter.onFloatingFilterChanged(_this.getLastType(), parseDateTimeFromString(filterValueText));
      }
    });
  };
  DateFloatingFilter.prototype.createDateComponent = function () {
    var _this = this;
    var debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
    var dateComponentParams = {
      onDateChanged: debounce(this.onDateChanged.bind(this), debounceMs),
      filterParams: this.params.column.getColDef().filterParams
    };
    this.dateComp = new DateCompWrapper(this.getContext(), this.userComponentFactory, dateComponentParams, this.eDateWrapper);
    this.addDestroyFunc(function () {
      return _this.dateComp.destroy();
    });
  };
  __decorate$l([Autowired('userComponentFactory')], DateFloatingFilter.prototype, "userComponentFactory", void 0);
  __decorate$l([RefSelector('eReadOnlyText')], DateFloatingFilter.prototype, "eReadOnlyText", void 0);
  __decorate$l([RefSelector('eDateWrapper')], DateFloatingFilter.prototype, "eDateWrapper", void 0);
  return DateFloatingFilter;
}(SimpleFloatingFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$m = undefined && undefined.__extends || function () {
  var _extendStatics23 = function extendStatics(d, b) {
    _extendStatics23 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics23(d, b);
  };
  return function (d, b) {
    _extendStatics23(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$m = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DefaultDateComponent = /** @class */function (_super) {
  __extends$m(DefaultDateComponent, _super);
  function DefaultDateComponent() {
    return _super.call(this, /* html */"\n            <div class=\"ag-filter-filter\">\n                <ag-input-text-field class=\"ag-date-filter\" ref=\"eDateInput\"></ag-input-text-field>\n            </div>") || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  DefaultDateComponent.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  DefaultDateComponent.prototype.init = function (params) {
    var _this = this;
    var inputElement = this.eDateInput.getInputElement();
    if (this.shouldUseBrowserDatePicker(params)) {
      if (isBrowserIE()) {
        console.warn('ag-grid: browserDatePicker is specified to true, but it is not supported in IE 11; reverting to text date picker');
      } else {
        inputElement.type = 'date';
      }
    }
    // ensures that the input element is focussed when a clear button is clicked
    this.addManagedListener(inputElement, 'mousedown', function () {
      if (_this.eDateInput.isDisabled()) {
        return;
      }
      inputElement.focus();
    });
    this.addManagedListener(inputElement, 'input', function (e) {
      if (e.target !== document.activeElement) {
        return;
      }
      if (_this.eDateInput.isDisabled()) {
        return;
      }
      params.onDateChanged();
    });
    var _a = params.filterParams || {},
      minValidYear = _a.minValidYear,
      maxValidYear = _a.maxValidYear;
    if (minValidYear) {
      inputElement.min = minValidYear + "-01-01";
    }
    if (maxValidYear) {
      inputElement.max = maxValidYear + "-12-31";
    }
  };
  DefaultDateComponent.prototype.getDate = function () {
    return parseDateTimeFromString(this.eDateInput.getValue());
  };
  DefaultDateComponent.prototype.setDate = function (date) {
    this.eDateInput.setValue(serialiseDate(date, false));
  };
  DefaultDateComponent.prototype.setInputPlaceholder = function (placeholder) {
    this.eDateInput.setInputPlaceholder(placeholder);
  };
  DefaultDateComponent.prototype.setDisabled = function (disabled) {
    this.eDateInput.setDisabled(disabled);
  };
  DefaultDateComponent.prototype.afterGuiAttached = function (params) {
    if (!params || !params.suppressFocus) {
      this.eDateInput.getInputElement().focus();
    }
  };
  DefaultDateComponent.prototype.shouldUseBrowserDatePicker = function (params) {
    if (params.filterParams && params.filterParams.browserDatePicker != null) {
      return params.filterParams.browserDatePicker;
    }
    return isBrowserChrome() || isBrowserFirefox();
  };
  __decorate$m([RefSelector('eDateInput')], DefaultDateComponent.prototype, "eDateInput", void 0);
  return DefaultDateComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$n = undefined && undefined.__extends || function () {
  var _extendStatics24 = function extendStatics(d, b) {
    _extendStatics24 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics24(d, b);
  };
  return function (d, b) {
    _extendStatics24(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$n = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NumberFilter = /** @class */function (_super) {
  __extends$n(NumberFilter, _super);
  function NumberFilter() {
    return _super.call(this, 'numberFilter') || this;
  }
  NumberFilter.prototype.mapValuesFromModel = function (filterModel) {
    var _a = filterModel || {},
      filter = _a.filter,
      filterTo = _a.filterTo,
      type = _a.type;
    return [filter || null, filterTo || null].slice(0, this.getNumberOfInputs(type));
  };
  NumberFilter.prototype.getDefaultDebounceMs = function () {
    return 500;
  };
  NumberFilter.prototype.comparator = function () {
    return function (left, right) {
      if (left === right) {
        return 0;
      }
      return left < right ? 1 : -1;
    };
  };
  NumberFilter.prototype.setParams = function (params) {
    this.numberFilterParams = params;
    var allowedCharPattern = this.getAllowedCharPattern();
    if (allowedCharPattern) {
      var config = {
        allowedCharPattern: allowedCharPattern
      };
      this.resetTemplate({
        eValueFrom1: config,
        eValueTo1: config,
        eValueFrom2: config,
        eValueTo2: config
      });
    }
    _super.prototype.setParams.call(this, params);
  };
  NumberFilter.prototype.getDefaultFilterOptions = function () {
    return NumberFilter.DEFAULT_FILTER_OPTIONS;
  };
  NumberFilter.prototype.createValueTemplate = function (position) {
    var pos = position === ConditionPosition.One ? '1' : '2';
    var allowedCharPattern = this.getAllowedCharPattern();
    var agElementTag = allowedCharPattern ? 'ag-input-text-field' : 'ag-input-number-field';
    return (/* html */"\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n                <" + agElementTag + " class=\"ag-filter-from ag-filter-filter\" ref=\"eValue-index0-" + pos + "\"></" + agElementTag + ">\n                <" + agElementTag + " class=\"ag-filter-to ag-filter-filter\" ref=\"eValue-index1-" + pos + "\"></" + agElementTag + ">\n            </div>"
    );
  };
  NumberFilter.prototype.getValues = function (position) {
    var _this = this;
    var result = [];
    this.forEachInput(function (element, index, elPosition, numberOfInputs) {
      if (position === elPosition && index < numberOfInputs) {
        result.push(_this.stringToFloat(element.getValue()));
      }
    });
    return result;
  };
  NumberFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
    return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
  };
  NumberFilter.prototype.getFilterType = function () {
    return 'number';
  };
  NumberFilter.prototype.stringToFloat = function (value) {
    if (typeof value === 'number') {
      return value;
    }
    var filterText = makeNull(value);
    if (filterText != null && filterText.trim() === '') {
      filterText = null;
    }
    if (this.numberFilterParams.numberParser) {
      return this.numberFilterParams.numberParser(filterText);
    }
    return filterText == null || filterText.trim() === '-' ? null : parseFloat(filterText);
  };
  NumberFilter.prototype.createCondition = function (position) {
    var type = this.getConditionTypes()[position];
    var model = {
      filterType: this.getFilterType(),
      type: type
    };
    var values = this.getValues(position);
    if (values.length > 0) {
      model.filter = values[0];
    }
    if (values.length > 1) {
      model.filterTo = values[1];
    }
    return model;
  };
  NumberFilter.prototype.getInputs = function () {
    return [[this.eValueFrom1, this.eValueTo1], [this.eValueFrom2, this.eValueTo2]];
  };
  NumberFilter.prototype.getAllowedCharPattern = function () {
    var allowedCharPattern = (this.numberFilterParams || {}).allowedCharPattern;
    if (allowedCharPattern) {
      return allowedCharPattern;
    }
    if (!isBrowserChrome() && !isBrowserEdge()) {
      // only Chrome and Edge support the HTML5 number field, so for other browsers we provide an equivalent
      // constraint instead
      return '\\d\\-\\.';
    }
    return null;
  };
  NumberFilter.DEFAULT_FILTER_OPTIONS = [ScalarFilter.EQUALS, ScalarFilter.NOT_EQUAL, ScalarFilter.LESS_THAN, ScalarFilter.LESS_THAN_OR_EQUAL, ScalarFilter.GREATER_THAN, ScalarFilter.GREATER_THAN_OR_EQUAL, ScalarFilter.IN_RANGE];
  __decorate$n([RefSelector('eValue-index0-1')], NumberFilter.prototype, "eValueFrom1", void 0);
  __decorate$n([RefSelector('eValue-index1-1')], NumberFilter.prototype, "eValueTo1", void 0);
  __decorate$n([RefSelector('eValue-index0-2')], NumberFilter.prototype, "eValueFrom2", void 0);
  __decorate$n([RefSelector('eValue-index1-2')], NumberFilter.prototype, "eValueTo2", void 0);
  return NumberFilter;
}(ScalarFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$o = undefined && undefined.__extends || function () {
  var _extendStatics25 = function extendStatics(d, b) {
    _extendStatics25 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics25(d, b);
  };
  return function (d, b) {
    _extendStatics25(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$o = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TextFilter = /** @class */function (_super) {
  __extends$o(TextFilter, _super);
  function TextFilter() {
    return _super.call(this, 'textFilter') || this;
  }
  TextFilter.trimInput = function (value) {
    var trimmedInput = value && value.trim();
    // trim the input, unless it is all whitespace (this is consistent with Excel behaviour)
    return trimmedInput === '' ? value : trimmedInput;
  };
  TextFilter.prototype.getDefaultDebounceMs = function () {
    return 500;
  };
  TextFilter.prototype.setParams = function (params) {
    _super.prototype.setParams.call(this, params);
    this.textFilterParams = params;
    this.comparator = this.textFilterParams.textCustomComparator || TextFilter.DEFAULT_COMPARATOR;
    this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? TextFilter.DEFAULT_FORMATTER : TextFilter.DEFAULT_LOWERCASE_FORMATTER);
  };
  TextFilter.prototype.createCondition = function (position) {
    var type = this.getConditionTypes()[position];
    var model = {
      filterType: this.getFilterType(),
      type: type
    };
    var values = this.getValues(position);
    if (values.length > 0) {
      model.filter = values[0];
    }
    if (values.length > 1) {
      model.filterTo = values[1];
    }
    return model;
  };
  TextFilter.prototype.getFilterType = function () {
    return 'text';
  };
  TextFilter.prototype.areSimpleModelsEqual = function (aSimple, bSimple) {
    return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
  };
  TextFilter.prototype.getInputs = function () {
    return [[this.eValueFrom1, this.eValueTo1], [this.eValueFrom2, this.eValueTo2]];
  };
  TextFilter.prototype.getValues = function (position) {
    var _this = this;
    var result = [];
    this.forEachInput(function (element, index, elPosition, numberOfInputs) {
      if (position === elPosition && index < numberOfInputs) {
        var value = makeNull(element.getValue());
        var cleanValue = (_this.textFilterParams.trimInput ? TextFilter.trimInput(value) : value) || null;
        result.push(cleanValue);
        element.setValue(cleanValue, true); // ensure clean value is visible
      }
    });

    return result;
  };
  TextFilter.prototype.getDefaultFilterOptions = function () {
    return TextFilter.DEFAULT_FILTER_OPTIONS;
  };
  TextFilter.prototype.createValueTemplate = function (position) {
    var pos = position === ConditionPosition.One ? '1' : '2';
    return (/* html */"\n            <div class=\"ag-filter-body\" ref=\"eCondition" + pos + "Body\" role=\"presentation\">\n                <ag-input-text-field class=\".ag-filter-from ag-filter-filter\" ref=\"eValue-index0-" + pos + "\"></ag-input-text-field>\n                <ag-input-text-field class=\"ag-filter-to ag-filter-filter\" ref=\"eValue-index1-" + pos + "\"></ag-input-text-field>\n            </div>"
    );
  };
  TextFilter.prototype.mapValuesFromModel = function (filterModel) {
    var _a = filterModel || {},
      filter = _a.filter,
      filterTo = _a.filterTo,
      type = _a.type;
    return [filter || null, filterTo || null].slice(0, this.getNumberOfInputs(type));
  };
  TextFilter.prototype.evaluateNullValue = function (filterType) {
    return filterType === SimpleFilter.NOT_EQUAL || filterType === SimpleFilter.NOT_CONTAINS;
  };
  TextFilter.prototype.evaluateNonNullValue = function (values, cellValue, filterModel) {
    var _this = this;
    var formattedValues = _.map(values, function (v) {
      return _this.formatter(v);
    }) || [];
    var cellValueFormatted = this.formatter(cellValue);
    return _.some(formattedValues, function (v) {
      return _this.comparator(filterModel.type, cellValueFormatted, v);
    });
  };
  TextFilter.DEFAULT_FILTER_OPTIONS = [SimpleFilter.CONTAINS, SimpleFilter.NOT_CONTAINS, SimpleFilter.EQUALS, SimpleFilter.NOT_EQUAL, SimpleFilter.STARTS_WITH, SimpleFilter.ENDS_WITH];
  TextFilter.DEFAULT_FORMATTER = function (from) {
    return from;
  };
  TextFilter.DEFAULT_LOWERCASE_FORMATTER = function (from) {
    return from == null ? null : from.toString().toLowerCase();
  };
  TextFilter.DEFAULT_COMPARATOR = function (filter, value, filterText) {
    switch (filter) {
      case TextFilter.CONTAINS:
        return value.indexOf(filterText) >= 0;
      case TextFilter.NOT_CONTAINS:
        return value.indexOf(filterText) < 0;
      case TextFilter.EQUALS:
        return value === filterText;
      case TextFilter.NOT_EQUAL:
        return value != filterText;
      case TextFilter.STARTS_WITH:
        return value.indexOf(filterText) === 0;
      case TextFilter.ENDS_WITH:
        var index = value.lastIndexOf(filterText);
        return index >= 0 && index === value.length - filterText.length;
      default:
        return false;
    }
  };
  __decorate$o([RefSelector('eValue-index0-1')], TextFilter.prototype, "eValueFrom1", void 0);
  __decorate$o([RefSelector('eValue-index1-1')], TextFilter.prototype, "eValueTo1", void 0);
  __decorate$o([RefSelector('eValue-index0-2')], TextFilter.prototype, "eValueFrom2", void 0);
  __decorate$o([RefSelector('eValue-index1-2')], TextFilter.prototype, "eValueTo2", void 0);
  return TextFilter;
}(SimpleFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$p = undefined && undefined.__extends || function () {
  var _extendStatics26 = function extendStatics(d, b) {
    _extendStatics26 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics26(d, b);
  };
  return function (d, b) {
    _extendStatics26(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$p = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TextInputFloatingFilter = /** @class */function (_super) {
  __extends$p(TextInputFloatingFilter, _super);
  function TextInputFloatingFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TextInputFloatingFilter.prototype.postConstruct = function () {
    this.setTemplate( /* html */"\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterInput\"></ag-input-text-field>\n            </div>");
  };
  TextInputFloatingFilter.prototype.getDefaultDebounceMs = function () {
    return 500;
  };
  TextInputFloatingFilter.prototype.onParentModelChanged = function (model, event) {
    if (this.isEventFromFloatingFilter(event)) {
      // if the floating filter triggered the change, it is already in sync
      return;
    }
    this.setLastTypeFromModel(model);
    this.eFloatingFilterInput.setValue(this.getTextFromModel(model));
    this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
  };
  TextInputFloatingFilter.prototype.init = function (params) {
    _super.prototype.init.call(this, params);
    this.params = params;
    this.applyActive = ProvidedFilter.isUseApplyButton(this.params.filterParams);
    if (!this.isReadOnly()) {
      var debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
      var toDebounce = debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
      var filterGui = this.eFloatingFilterInput.getGui();
      this.addManagedListener(filterGui, 'input', toDebounce);
      this.addManagedListener(filterGui, 'keypress', toDebounce);
      this.addManagedListener(filterGui, 'keydown', toDebounce);
    }
    var columnDef = params.column.getDefinition();
    if (this.isReadOnly() || columnDef.filterParams && columnDef.filterParams.filterOptions && columnDef.filterParams.filterOptions.length === 1 && columnDef.filterParams.filterOptions[0] === 'inRange') {
      this.eFloatingFilterInput.setDisabled(true);
    }
    var displayName = this.columnModel.getDisplayNameForColumn(params.column, 'header', true);
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFloatingFilterInput.setInputAriaLabel(displayName + " " + translate('ariaFilterInput', 'Filter Input'));
  };
  TextInputFloatingFilter.prototype.syncUpWithParentFilter = function (e) {
    var _this = this;
    var enterKeyPressed = isKeyPressed(e, KeyCode.ENTER);
    if (this.applyActive && !enterKeyPressed) {
      return;
    }
    var value = this.eFloatingFilterInput.getValue();
    if (this.params.filterParams.trimInput) {
      value = TextFilter.trimInput(value);
      this.eFloatingFilterInput.setValue(value, true); // ensure visible value is trimmed
    }

    this.params.parentFilterInstance(function (filterInstance) {
      if (filterInstance) {
        var simpleFilter = filterInstance;
        simpleFilter.onFloatingFilterChanged(_this.getLastType(), value || null);
      }
    });
  };
  TextInputFloatingFilter.prototype.conditionToString = function (condition, options) {
    var numberOfInputs = (options || {}).numberOfInputs;
    var isRange = condition.type == SimpleFilter.IN_RANGE || numberOfInputs === 2;
    if (isRange) {
      return condition.filter + "-" + condition.filterTo;
    }
    // cater for when the type doesn't need a value
    if (condition.filter != null) {
      return "" + condition.filter;
    }
    return "" + condition.type;
  };
  TextInputFloatingFilter.prototype.setEditable = function (editable) {
    this.eFloatingFilterInput.setDisabled(!editable);
  };
  __decorate$p([Autowired('columnModel')], TextInputFloatingFilter.prototype, "columnModel", void 0);
  __decorate$p([RefSelector('eFloatingFilterInput')], TextInputFloatingFilter.prototype, "eFloatingFilterInput", void 0);
  __decorate$p([PostConstruct], TextInputFloatingFilter.prototype, "postConstruct", null);
  return TextInputFloatingFilter;
}(SimpleFloatingFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$q = undefined && undefined.__extends || function () {
  var _extendStatics27 = function extendStatics(d, b) {
    _extendStatics27 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics27(d, b);
  };
  return function (d, b) {
    _extendStatics27(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var NumberFloatingFilter = /** @class */function (_super) {
  __extends$q(NumberFloatingFilter, _super);
  function NumberFloatingFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NumberFloatingFilter.prototype.getDefaultFilterOptions = function () {
    return NumberFilter.DEFAULT_FILTER_OPTIONS;
  };
  return NumberFloatingFilter;
}(TextInputFloatingFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$r = undefined && undefined.__extends || function () {
  var _extendStatics28 = function extendStatics(d, b) {
    _extendStatics28 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics28(d, b);
  };
  return function (d, b) {
    _extendStatics28(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TextFloatingFilter = /** @class */function (_super) {
  __extends$r(TextFloatingFilter, _super);
  function TextFloatingFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TextFloatingFilter.prototype.getDefaultFilterOptions = function () {
    return TextFilter.DEFAULT_FILTER_OPTIONS;
  };
  return TextFloatingFilter;
}(TextInputFloatingFilter);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var TouchListener = /** @class */function () {
  function TouchListener(eElement, preventMouseClick) {
    var _this = this;
    if (preventMouseClick === void 0) {
      preventMouseClick = false;
    }
    this.destroyFuncs = [];
    this.touching = false;
    this.eventService = new EventService();
    this.eElement = eElement;
    this.preventMouseClick = preventMouseClick;
    var startListener = this.onTouchStart.bind(this);
    var moveListener = this.onTouchMove.bind(this);
    var endListener = this.onTouchEnd.bind(this);
    this.eElement.addEventListener("touchstart", startListener, {
      passive: true
    });
    this.eElement.addEventListener("touchmove", moveListener, {
      passive: true
    });
    // we set passive=false, as we want to prevent default on this event
    this.eElement.addEventListener("touchend", endListener, {
      passive: false
    });
    this.destroyFuncs.push(function () {
      _this.eElement.removeEventListener("touchstart", startListener, {
        passive: true
      });
      _this.eElement.removeEventListener("touchmove", moveListener, {
        passive: true
      });
      _this.eElement.removeEventListener("touchend", endListener, {
        passive: false
      });
    });
  }
  TouchListener.prototype.getActiveTouch = function (touchList) {
    for (var i = 0; i < touchList.length; i++) {
      var matches = touchList[i].identifier === this.touchStart.identifier;
      if (matches) {
        return touchList[i];
      }
    }
    return null;
  };
  TouchListener.prototype.addEventListener = function (eventType, listener) {
    this.eventService.addEventListener(eventType, listener);
  };
  TouchListener.prototype.removeEventListener = function (eventType, listener) {
    this.eventService.removeEventListener(eventType, listener);
  };
  TouchListener.prototype.onTouchStart = function (touchEvent) {
    var _this = this;
    // only looking at one touch point at any time
    if (this.touching) {
      return;
    }
    this.touchStart = touchEvent.touches[0];
    this.touching = true;
    this.moved = false;
    var touchStartCopy = this.touchStart;
    window.setTimeout(function () {
      var touchesMatch = _this.touchStart === touchStartCopy;
      if (_this.touching && touchesMatch && !_this.moved) {
        _this.moved = true;
        var event_1 = {
          type: TouchListener.EVENT_LONG_TAP,
          touchStart: _this.touchStart,
          touchEvent: touchEvent
        };
        _this.eventService.dispatchEvent(event_1);
      }
    }, 500);
  };
  TouchListener.prototype.onTouchMove = function (touchEvent) {
    if (!this.touching) {
      return;
    }
    var touch = this.getActiveTouch(touchEvent.touches);
    if (!touch) {
      return;
    }
    var eventIsFarAway = !areEventsNear(touch, this.touchStart, 4);
    if (eventIsFarAway) {
      this.moved = true;
    }
  };
  TouchListener.prototype.onTouchEnd = function (touchEvent) {
    if (!this.touching) {
      return;
    }
    if (!this.moved) {
      var event_2 = {
        type: TouchListener.EVENT_TAP,
        touchStart: this.touchStart
      };
      this.eventService.dispatchEvent(event_2);
      this.checkForDoubleTap();
    }
    // stops the tap from also been processed as a mouse click
    if (this.preventMouseClick) {
      touchEvent.preventDefault();
    }
    this.touching = false;
  };
  TouchListener.prototype.checkForDoubleTap = function () {
    var now = new Date().getTime();
    if (this.lastTapTime && this.lastTapTime > 0) {
      // if previous tap, see if duration is short enough to be considered double tap
      var interval = now - this.lastTapTime;
      if (interval > TouchListener.DOUBLE_TAP_MILLIS) {
        // dispatch double tap event
        var event_3 = {
          type: TouchListener.EVENT_DOUBLE_TAP,
          touchStart: this.touchStart
        };
        this.eventService.dispatchEvent(event_3);
        // this stops a tripple tap ending up as two double taps
        this.lastTapTime = null;
      } else {
        this.lastTapTime = now;
      }
    } else {
      this.lastTapTime = now;
    }
  };
  TouchListener.prototype.destroy = function () {
    this.destroyFuncs.forEach(function (func) {
      return func();
    });
  };
  TouchListener.EVENT_TAP = "tap";
  TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
  TouchListener.EVENT_LONG_TAP = "longTap";
  TouchListener.DOUBLE_TAP_MILLIS = 500;
  return TouchListener;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$s = undefined && undefined.__extends || function () {
  var _extendStatics29 = function extendStatics(d, b) {
    _extendStatics29 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics29(d, b);
  };
  return function (d, b) {
    _extendStatics29(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderComp = /** @class */function (_super) {
  __extends$s(HeaderComp, _super);
  function HeaderComp() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.lastMovingChanged = 0;
    return _this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  HeaderComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  HeaderComp.prototype.refresh = function (params) {
    this.params = params;
    // if template changed, then recreate the whole comp, the code required to manage
    // a changing template is to difficult for what it's worth.
    if (this.workOutTemplate() != this.currentTemplate) {
      return false;
    }
    if (this.workOutShowMenu() != this.currentShowMenu) {
      return false;
    }
    if (this.workOutSort() != this.currentSort) {
      return false;
    }
    this.setDisplayName(params);
    return true;
  };
  HeaderComp.prototype.workOutTemplate = function () {
    var template = firstExistingValue(this.params.template, HeaderComp.TEMPLATE);
    // take account of any newlines & whitespace before/after the actual template
    template = template && template.trim ? template.trim() : template;
    return template;
  };
  HeaderComp.prototype.init = function (params) {
    this.params = params;
    this.currentTemplate = this.workOutTemplate();
    this.setTemplate(this.currentTemplate);
    this.setupTap();
    this.setupIcons(params.column);
    this.setMenu();
    this.setupSort();
    this.setupFilterIcon();
    this.setDisplayName(params);
  };
  HeaderComp.prototype.setDisplayName = function (params) {
    if (this.currentDisplayName != params.displayName) {
      this.currentDisplayName = params.displayName;
      var displayNameSanitised = escapeString(this.currentDisplayName);
      if (this.eText) {
        this.eText.innerHTML = displayNameSanitised;
      }
    }
  };
  HeaderComp.prototype.setupIcons = function (column) {
    this.addInIcon('sortAscending', this.eSortAsc, column);
    this.addInIcon('sortDescending', this.eSortDesc, column);
    this.addInIcon('sortUnSort', this.eSortNone, column);
    this.addInIcon('menu', this.eMenu, column);
    this.addInIcon('filter', this.eFilter, column);
  };
  HeaderComp.prototype.addInIcon = function (iconName, eParent, column) {
    if (eParent == null) {
      return;
    }
    var eIcon = createIconNoSpan(iconName, this.gridOptionsWrapper, column);
    if (eIcon) {
      eParent.appendChild(eIcon);
    }
  };
  HeaderComp.prototype.setupTap = function () {
    var _this = this;
    var options = this.gridOptionsWrapper;
    if (options.isSuppressTouch()) {
      return;
    }
    var touchListener = new TouchListener(this.getGui(), true);
    var suppressMenuHide = options.isSuppressMenuHide();
    var tapMenuButton = suppressMenuHide && exists(this.eMenu);
    var menuTouchListener = tapMenuButton ? new TouchListener(this.eMenu, true) : touchListener;
    if (this.params.enableMenu) {
      var eventType = tapMenuButton ? 'EVENT_TAP' : 'EVENT_LONG_TAP';
      var showMenuFn = function showMenuFn(event) {
        options.getApi().showColumnMenuAfterMouseClick(_this.params.column, event.touchStart);
      };
      this.addManagedListener(menuTouchListener, TouchListener[eventType], showMenuFn);
    }
    if (this.params.enableSorting) {
      var tapListener = function tapListener(event) {
        var target = event.touchStart.target;
        // When suppressMenuHide is true, a tap on the menu icon will bubble up
        // to the header container, in that case we should not sort
        if (suppressMenuHide && _this.eMenu.contains(target)) {
          return;
        }
        _this.sortController.progressSort(_this.params.column, false, "uiColumnSorted");
      };
      this.addManagedListener(touchListener, TouchListener.EVENT_TAP, tapListener);
    }
    // if tapMenuButton is true `touchListener` and `menuTouchListener` are different
    // so we need to make sure to destroy both listeners here
    this.addDestroyFunc(function () {
      return touchListener.destroy();
    });
    if (tapMenuButton) {
      this.addDestroyFunc(function () {
        return menuTouchListener.destroy();
      });
    }
  };
  HeaderComp.prototype.workOutShowMenu = function () {
    // we don't show the menu if on an iPad/iPhone, as the user cannot have a pointer device/
    // However if suppressMenuHide is set to true the menu will be displayed alwasys, so it's ok
    // to show it on iPad in this case (as hover isn't needed). If suppressMenuHide
    // is false (default) user will need to use longpress to display the menu.
    var menuHides = !this.gridOptionsWrapper.isSuppressMenuHide();
    var onIpadAndMenuHides = isIOSUserAgent() && menuHides;
    var showMenu = this.params.enableMenu && !onIpadAndMenuHides;
    return showMenu;
  };
  HeaderComp.prototype.setMenu = function () {
    var _this = this;
    // if no menu provided in template, do nothing
    if (!this.eMenu) {
      return;
    }
    this.currentShowMenu = this.workOutShowMenu();
    if (!this.currentShowMenu) {
      removeFromParent(this.eMenu);
      return;
    }
    var suppressMenuHide = this.gridOptionsWrapper.isSuppressMenuHide();
    this.addManagedListener(this.eMenu, 'click', function () {
      return _this.showMenu(_this.eMenu);
    });
    addOrRemoveCssClass(this.eMenu, 'ag-header-menu-always-show', suppressMenuHide);
  };
  HeaderComp.prototype.showMenu = function (eventSource) {
    if (!eventSource) {
      eventSource = this.eMenu;
    }
    this.menuFactory.showMenuAfterButtonClick(this.params.column, eventSource, 'columnMenu');
  };
  HeaderComp.prototype.removeSortIcons = function () {
    removeFromParent(this.eSortAsc);
    removeFromParent(this.eSortDesc);
    removeFromParent(this.eSortNone);
    removeFromParent(this.eSortOrder);
  };
  HeaderComp.prototype.workOutSort = function () {
    return this.params.enableSorting;
  };
  HeaderComp.prototype.setupSort = function () {
    var _this = this;
    this.currentSort = this.params.enableSorting;
    if (!this.currentSort) {
      this.removeSortIcons();
      return;
    }
    var sortUsingCtrl = this.gridOptionsWrapper.isMultiSortKeyCtrl();
    // keep track of last time the moving changed flag was set
    this.addManagedListener(this.params.column, Column.EVENT_MOVING_CHANGED, function () {
      _this.lastMovingChanged = new Date().getTime();
    });
    // add the event on the header, so when clicked, we do sorting
    if (this.eLabel) {
      this.addManagedListener(this.eLabel, 'click', function (event) {
        // sometimes when moving a column via dragging, this was also firing a clicked event.
        // here is issue raised by user: https://ag-grid.zendesk.com/agent/tickets/1076
        // this check stops sort if a) column is moving or b) column moved less than 200ms ago (so caters for race condition)
        var moving = _this.params.column.isMoving();
        var nowTime = new Date().getTime();
        // typically there is <2ms if moving flag was set recently, as it would be done in same VM turn
        var movedRecently = nowTime - _this.lastMovingChanged < 50;
        var columnMoving = moving || movedRecently;
        if (!columnMoving) {
          var multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
          _this.params.progressSort(multiSort);
        }
      });
    }
    this.addManagedListener(this.params.column, Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    this.onSortChanged();
    this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.setMultiSortOrder.bind(this));
    this.setMultiSortOrder();
  };
  HeaderComp.prototype.onSortChanged = function () {
    addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
    addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
    addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.params.column.isSortNone());
    if (this.eSortAsc) {
      addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.params.column.isSortAscending());
    }
    if (this.eSortDesc) {
      addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.params.column.isSortDescending());
    }
    if (this.eSortNone) {
      var alwaysHideNoSort = !this.params.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
      addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.params.column.isSortNone());
    }
  };
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  HeaderComp.prototype.setMultiSortOrder = function () {
    if (!this.eSortOrder) {
      return;
    }
    var col = this.params.column;
    var allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
    var indexThisCol = allColumnsWithSorting.indexOf(col);
    var moreThanOneColSorting = allColumnsWithSorting.length > 1;
    var showIndex = col.isSorting() && moreThanOneColSorting;
    setDisplayed(this.eSortOrder, showIndex);
    if (indexThisCol >= 0) {
      this.eSortOrder.innerHTML = (indexThisCol + 1).toString();
    } else {
      clearElement(this.eSortOrder);
    }
  };
  HeaderComp.prototype.setupFilterIcon = function () {
    if (!this.eFilter) {
      return;
    }
    this.addManagedListener(this.params.column, Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    this.onFilterChanged();
  };
  HeaderComp.prototype.onFilterChanged = function () {
    var filterPresent = this.params.column.isFilterActive();
    addOrRemoveCssClass(this.eFilter, 'ag-hidden', !filterPresent);
  };
  HeaderComp.TEMPLATE = "<div class=\"ag-cell-label-container\" role=\"presentation\">\n            <span ref=\"eMenu\" class=\"ag-header-icon ag-header-cell-menu-button\" aria-hidden=\"true\"></span>\n            <div ref=\"eLabel\" class=\"ag-header-cell-label\" role=\"presentation\" unselectable=\"on\">\n                <span ref=\"eText\" class=\"ag-header-cell-text\" unselectable=\"on\"></span>\n                <span ref=\"eFilter\" class=\"ag-header-icon ag-header-label-icon ag-filter-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortOrder\" class=\"ag-header-icon ag-header-label-icon ag-sort-order\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortAsc\" class=\"ag-header-icon ag-header-label-icon ag-sort-ascending-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortDesc\" class=\"ag-header-icon ag-header-label-icon ag-sort-descending-icon\" aria-hidden=\"true\"></span>\n                <span ref=\"eSortNone\" class=\"ag-header-icon ag-header-label-icon ag-sort-none-icon\" aria-hidden=\"true\"></span>\n            </div>\n        </div>";
  __decorate$q([Autowired('sortController')], HeaderComp.prototype, "sortController", void 0);
  __decorate$q([Autowired('menuFactory')], HeaderComp.prototype, "menuFactory", void 0);
  __decorate$q([RefSelector('eFilter')], HeaderComp.prototype, "eFilter", void 0);
  __decorate$q([RefSelector('eSortAsc')], HeaderComp.prototype, "eSortAsc", void 0);
  __decorate$q([RefSelector('eSortDesc')], HeaderComp.prototype, "eSortDesc", void 0);
  __decorate$q([RefSelector('eSortNone')], HeaderComp.prototype, "eSortNone", void 0);
  __decorate$q([RefSelector('eSortOrder')], HeaderComp.prototype, "eSortOrder", void 0);
  __decorate$q([RefSelector('eMenu')], HeaderComp.prototype, "eMenu", void 0);
  __decorate$q([RefSelector('eLabel')], HeaderComp.prototype, "eLabel", void 0);
  __decorate$q([RefSelector('eText')], HeaderComp.prototype, "eText", void 0);
  return HeaderComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$t = undefined && undefined.__extends || function () {
  var _extendStatics30 = function extendStatics(d, b) {
    _extendStatics30 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics30(d, b);
  };
  return function (d, b) {
    _extendStatics30(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$r = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderGroupComp = /** @class */function (_super) {
  __extends$t(HeaderGroupComp, _super);
  function HeaderGroupComp() {
    return _super.call(this, HeaderGroupComp.TEMPLATE) || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  HeaderGroupComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  HeaderGroupComp.prototype.init = function (params) {
    this.params = params;
    this.checkWarnings();
    this.setupLabel();
    this.addGroupExpandIcon();
    this.setupExpandIcons();
  };
  HeaderGroupComp.prototype.checkWarnings = function () {
    var paramsAny = this.params;
    if (paramsAny.template) {
      var message_1 = "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)";
      doOnce(function () {
        return console.warn(message_1);
      }, 'HeaderGroupComp.templateNotSupported');
    }
  };
  HeaderGroupComp.prototype.setupExpandIcons = function () {
    var _this = this;
    this.addInIcon("columnGroupOpened", "agOpened");
    this.addInIcon("columnGroupClosed", "agClosed");
    var expandAction = function expandAction(event) {
      if (isStopPropagationForAgGrid(event)) {
        return;
      }
      var newExpandedValue = !_this.params.columnGroup.isExpanded();
      _this.columnModel.setColumnGroupOpened(_this.params.columnGroup.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
    };
    this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
    this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
    var stopPropagationAction = function stopPropagationAction(event) {
      stopPropagationForAgGrid(event);
    };
    // adding stopPropagation to the double click for the icons prevents double click action happening
    // when the icons are clicked. if the icons are double clicked, then the groups should open and
    // then close again straight away. if we also listened to double click, then the group would open,
    // close, then open, which is not what we want. double click should only action if the user double
    // clicks outside of the icons.
    this.addManagedListener(this.eCloseIcon, "dblclick", stopPropagationAction);
    this.addManagedListener(this.eOpenIcon, "dblclick", stopPropagationAction);
    this.addManagedListener(this.getGui(), "dblclick", expandAction);
    this.updateIconVisibility();
    var originalColumnGroup = this.params.columnGroup.getOriginalColumnGroup();
    this.addManagedListener(originalColumnGroup, ProvidedColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
    this.addManagedListener(originalColumnGroup, ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
  };
  HeaderGroupComp.prototype.addTouchAndClickListeners = function (eElement, action) {
    var touchListener = new TouchListener(eElement, true);
    this.addManagedListener(touchListener, TouchListener.EVENT_TAP, action);
    this.addDestroyFunc(function () {
      return touchListener.destroy();
    });
    this.addManagedListener(eElement, "click", action);
  };
  HeaderGroupComp.prototype.updateIconVisibility = function () {
    var columnGroup = this.params.columnGroup;
    if (columnGroup.isExpandable()) {
      var expanded = this.params.columnGroup.isExpanded();
      setDisplayed(this.eOpenIcon, expanded);
      setDisplayed(this.eCloseIcon, !expanded);
    } else {
      setDisplayed(this.eOpenIcon, false);
      setDisplayed(this.eCloseIcon, false);
    }
  };
  HeaderGroupComp.prototype.addInIcon = function (iconName, refName) {
    var eIcon = createIconNoSpan(iconName, this.gridOptionsWrapper, null);
    if (eIcon) {
      this.getRefElement(refName).appendChild(eIcon);
    }
  };
  HeaderGroupComp.prototype.addGroupExpandIcon = function () {
    if (!this.params.columnGroup.isExpandable()) {
      setDisplayed(this.eOpenIcon, false);
      setDisplayed(this.eCloseIcon, false);
      return;
    }
  };
  HeaderGroupComp.prototype.setupLabel = function () {
    // no renderer, default text render
    var displayName = this.params.displayName;
    if (exists(displayName)) {
      var displayNameSanitised = escapeString(displayName);
      this.getRefElement('agLabel').innerHTML = displayNameSanitised;
    }
  };
  HeaderGroupComp.TEMPLATE = "<div class=\"ag-header-group-cell-label\" ref=\"agContainer\" role=\"presentation\">\n            <span ref=\"agLabel\" class=\"ag-header-group-text\" role=\"presentation\"></span>\n            <span ref=\"agOpened\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded\"></span>\n            <span ref=\"agClosed\" class=\"ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed\"></span>\n        </div>";
  __decorate$r([Autowired("columnModel")], HeaderGroupComp.prototype, "columnModel", void 0);
  __decorate$r([RefSelector("agOpened")], HeaderGroupComp.prototype, "eOpenIcon", void 0);
  __decorate$r([RefSelector("agClosed")], HeaderGroupComp.prototype, "eCloseIcon", void 0);
  return HeaderGroupComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$u = undefined && undefined.__extends || function () {
  var _extendStatics31 = function extendStatics(d, b) {
    _extendStatics31 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics31(d, b);
  };
  return function (d, b) {
    _extendStatics31(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PopupComponent = /** @class */function (_super) {
  __extends$u(PopupComponent, _super);
  function PopupComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PopupComponent.prototype.isPopup = function () {
    return true;
  };
  PopupComponent.prototype.setParentComponent = function (container) {
    addCssClass(container.getGui(), 'ag-has-popup');
    _super.prototype.setParentComponent.call(this, container);
  };
  PopupComponent.prototype.destroy = function () {
    var parentComp = this.parentComponent;
    var hasParent = parentComp && parentComp.isAlive();
    if (hasParent) {
      removeCssClass(parentComp.getGui(), 'ag-has-popup');
    }
    _super.prototype.destroy.call(this);
  };
  return PopupComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$v = undefined && undefined.__extends || function () {
  var _extendStatics32 = function extendStatics(d, b) {
    _extendStatics32 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics32(d, b);
  };
  return function (d, b) {
    _extendStatics32(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$s = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LargeTextCellEditor = /** @class */function (_super) {
  __extends$v(LargeTextCellEditor, _super);
  function LargeTextCellEditor() {
    return _super.call(this, LargeTextCellEditor.TEMPLATE) || this;
  }
  LargeTextCellEditor.prototype.init = function (params) {
    this.params = params;
    this.focusAfterAttached = params.cellStartedEdit;
    this.eTextArea.setMaxLength(params.maxLength || 200).setCols(params.cols || 60).setRows(params.rows || 10);
    if (exists(params.value)) {
      this.eTextArea.setValue(params.value.toString(), true);
    }
    this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
  };
  LargeTextCellEditor.prototype.onKeyDown = function (event) {
    var key = event.which || event.keyCode;
    if (key === KeyCode.LEFT || key === KeyCode.UP || key === KeyCode.RIGHT || key === KeyCode.DOWN || event.shiftKey && key === KeyCode.ENTER) {
      // shift+enter allows for newlines
      event.stopPropagation();
    }
  };
  LargeTextCellEditor.prototype.afterGuiAttached = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eTextArea.setInputAriaLabel(translate('ariaInputEditor', 'Input Editor'));
    if (this.focusAfterAttached) {
      this.eTextArea.getFocusableElement().focus();
    }
  };
  LargeTextCellEditor.prototype.getValue = function () {
    return this.params.parseValue(this.eTextArea.getValue());
  };
  LargeTextCellEditor.TEMPLATE = "<div class=\"ag-large-text\" tabindex=\"0\">\n            <ag-input-text-area ref=\"eTextArea\" class=\"ag-large-text-input\"></ag-input-text-area>\n        </div>";
  __decorate$s([RefSelector("eTextArea")], LargeTextCellEditor.prototype, "eTextArea", void 0);
  return LargeTextCellEditor;
}(PopupComponent);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$w = undefined && undefined.__extends || function () {
  var _extendStatics33 = function extendStatics(d, b) {
    _extendStatics33 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics33(d, b);
  };
  return function (d, b) {
    _extendStatics33(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$t = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SelectCellEditor = /** @class */function (_super) {
  __extends$w(SelectCellEditor, _super);
  function SelectCellEditor() {
    var _this = _super.call(this, '<div class="ag-cell-edit-wrapper"><ag-select class="ag-cell-editor" ref="eSelect"></ag-select></div>') || this;
    _this.startedByEnter = false;
    return _this;
  }
  SelectCellEditor.prototype.init = function (params) {
    var _this = this;
    this.focusAfterAttached = params.cellStartedEdit;
    if (missing(params.values)) {
      console.warn('AG Grid: no values found for select cellEditor');
      return;
    }
    this.startedByEnter = params.keyPress === KeyCode.ENTER;
    var hasValue = false;
    params.values.forEach(function (value) {
      var option = {
        value: value
      };
      var valueFormatted = _this.valueFormatterService.formatValue(params.column, null, null, value);
      var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
      option.text = valueFormattedExits ? valueFormatted : value;
      _this.eSelect.addOption(option);
      hasValue = hasValue || params.value === value;
    });
    if (hasValue) {
      this.eSelect.setValue(params.value, true);
    } else if (params.values.length) {
      this.eSelect.setValue(params.values[0], true);
    }
    // we don't want to add this if full row editing, otherwise selecting will stop the
    // full row editing.
    if (!this.gridOptionsWrapper.isFullRowEdit()) {
      this.eSelect.onValueChange(function () {
        return params.stopEditing();
      });
    }
  };
  SelectCellEditor.prototype.afterGuiAttached = function () {
    if (this.focusAfterAttached) {
      this.eSelect.getFocusableElement().focus();
    }
    if (this.startedByEnter) {
      this.eSelect.showPicker();
    }
  };
  SelectCellEditor.prototype.focusIn = function () {
    this.eSelect.getFocusableElement().focus();
  };
  SelectCellEditor.prototype.getValue = function () {
    return this.eSelect.getValue();
  };
  SelectCellEditor.prototype.isPopup = function () {
    return false;
  };
  __decorate$t([Autowired('valueFormatterService')], SelectCellEditor.prototype, "valueFormatterService", void 0);
  __decorate$t([RefSelector('eSelect')], SelectCellEditor.prototype, "eSelect", void 0);
  return SelectCellEditor;
}(PopupComponent);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$x = undefined && undefined.__extends || function () {
  var _extendStatics34 = function extendStatics(d, b) {
    _extendStatics34 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics34(d, b);
  };
  return function (d, b) {
    _extendStatics34(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PopupSelectCellEditor = /** @class */function (_super) {
  __extends$x(PopupSelectCellEditor, _super);
  function PopupSelectCellEditor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PopupSelectCellEditor.prototype.isPopup = function () {
    return true;
  };
  return PopupSelectCellEditor;
}(SelectCellEditor);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$y = undefined && undefined.__extends || function () {
  var _extendStatics35 = function extendStatics(d, b) {
    _extendStatics35 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics35(d, b);
  };
  return function (d, b) {
    _extendStatics35(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$u = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TextCellEditor = /** @class */function (_super) {
  __extends$y(TextCellEditor, _super);
  function TextCellEditor() {
    return _super.call(this, TextCellEditor.TEMPLATE) || this;
  }
  TextCellEditor.prototype.init = function (params) {
    this.params = params;
    var eInput = this.eInput;
    var startValue;
    // cellStartedEdit is only false if we are doing fullRow editing
    if (params.cellStartedEdit) {
      this.focusAfterAttached = true;
      if (params.keyPress === KeyCode.BACKSPACE || params.keyPress === KeyCode.DELETE) {
        startValue = '';
      } else if (params.charPress) {
        startValue = params.charPress;
      } else {
        startValue = this.getStartValue(params);
        if (params.keyPress !== KeyCode.F2) {
          this.highlightAllOnFocus = true;
        }
      }
    } else {
      this.focusAfterAttached = false;
      startValue = this.getStartValue(params);
    }
    if (startValue != null) {
      eInput.setValue(startValue, true);
    }
    this.addManagedListener(eInput.getGui(), 'keydown', function (event) {
      var keyCode = event.keyCode;
      if (keyCode === KeyCode.PAGE_UP || keyCode === KeyCode.PAGE_DOWN) {
        event.preventDefault();
      }
    });
  };
  TextCellEditor.prototype.afterGuiAttached = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var eInput = this.eInput;
    eInput.setInputAriaLabel(translate('ariaInputEditor', 'Input Editor'));
    if (!this.focusAfterAttached) {
      return;
    }
    // Added for AG-3238. We can't remove this explicit focus() because Chrome requires an input
    // to be focused before setSelectionRange will work. But it triggers a bug in Safari where
    // explicitly focusing then blurring an empty field will cause the parent container to scroll.
    if (!isBrowserSafari()) {
      eInput.getFocusableElement().focus();
    }
    var inputEl = eInput.getInputElement();
    if (this.highlightAllOnFocus) {
      inputEl.select();
    } else {
      // when we started editing, we want the caret at the end, not the start.
      // this comes into play in two scenarios: a) when user hits F2 and b)
      // when user hits a printable character, then on IE (and only IE) the caret
      // was placed after the first character, thus 'apply' would end up as 'pplea'
      var value = eInput.getValue();
      var len = exists(value) && value.length || 0;
      if (len) {
        inputEl.setSelectionRange(len, len);
      }
    }
  };
  // gets called when tabbing trough cells and in full row edit mode
  TextCellEditor.prototype.focusIn = function () {
    var eInput = this.eInput;
    var focusEl = eInput.getFocusableElement();
    var inputEl = eInput.getInputElement();
    focusEl.focus();
    inputEl.select();
  };
  TextCellEditor.prototype.focusOut = function () {
    var inputEl = this.eInput.getInputElement();
    if (isBrowserIE()) {
      inputEl.setSelectionRange(0, 0);
    }
  };
  TextCellEditor.prototype.getValue = function () {
    var eInput = this.eInput;
    return this.params.parseValue(eInput.getValue());
  };
  TextCellEditor.prototype.getStartValue = function (params) {
    var formatValue = params.useFormatter || params.column.getColDef().refData;
    return formatValue ? params.formatValue(params.value) : params.value;
  };
  TextCellEditor.prototype.isPopup = function () {
    return false;
  };
  TextCellEditor.TEMPLATE = '<div class="ag-cell-edit-wrapper"><ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field></div>';
  __decorate$u([RefSelector('eInput')], TextCellEditor.prototype, "eInput", void 0);
  return TextCellEditor;
}(PopupComponent);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$z = undefined && undefined.__extends || function () {
  var _extendStatics36 = function extendStatics(d, b) {
    _extendStatics36 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics36(d, b);
  };
  return function (d, b) {
    _extendStatics36(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PopupTextCellEditor = /** @class */function (_super) {
  __extends$z(PopupTextCellEditor, _super);
  function PopupTextCellEditor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PopupTextCellEditor.prototype.isPopup = function () {
    return true;
  };
  return PopupTextCellEditor;
}(TextCellEditor);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$A = undefined && undefined.__extends || function () {
  var _extendStatics37 = function extendStatics(d, b) {
    _extendStatics37 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics37(d, b);
  };
  return function (d, b) {
    _extendStatics37(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$v = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ARROW_UP = "\u2191";
var ARROW_DOWN = "\u2193";
var AnimateShowChangeCellRenderer = /** @class */function (_super) {
  __extends$A(AnimateShowChangeCellRenderer, _super);
  function AnimateShowChangeCellRenderer() {
    var _this = _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE) || this;
    _this.refreshCount = 0;
    return _this;
  }
  AnimateShowChangeCellRenderer.prototype.init = function (params) {
    // this.params = params;
    this.eValue = this.queryForHtmlElement('.ag-value-change-value');
    this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
    this.refresh(params);
  };
  AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
    var absDelta = Math.abs(delta);
    var valueFormatted = params.formatValue(absDelta);
    var valueToUse = exists(valueFormatted) ? valueFormatted : absDelta;
    var deltaUp = delta >= 0;
    if (deltaUp) {
      this.eDelta.innerHTML = ARROW_UP + valueToUse;
    } else {
      // because negative, use ABS to remove sign
      this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
    }
    addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
    addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
  };
  AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
    var _this = this;
    // the refreshCount makes sure that if the value updates again while
    // the below timer is waiting, then the below timer will realise it
    // is not the most recent and will not try to remove the delta value.
    this.refreshCount++;
    var refreshCountCopy = this.refreshCount;
    window.setTimeout(function () {
      if (refreshCountCopy === _this.refreshCount) {
        _this.hideDeltaValue();
      }
    }, 2000);
  };
  AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
    removeCssClass(this.eValue, 'ag-value-change-value-highlight');
    clearElement(this.eDelta);
  };
  AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
    var value = params.value;
    if (value === this.lastValue) {
      return false;
    }
    if (exists(params.valueFormatted)) {
      this.eValue.innerHTML = params.valueFormatted;
    } else if (exists(params.value)) {
      this.eValue.innerHTML = value;
    } else {
      clearElement(this.eValue);
    }
    // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
    // with regards processingFilterChange
    if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
      return false;
    }
    if (typeof value === 'number' && typeof this.lastValue === 'number') {
      var delta = value - this.lastValue;
      this.showDelta(params, delta);
    }
    // highlight the current value, but only if it's not new, otherwise it
    // would get highlighted first time the value is shown
    if (this.lastValue) {
      addCssClass(this.eValue, 'ag-value-change-value-highlight');
    }
    this.setTimerToRemoveDelta();
    this.lastValue = value;
    return true;
  };
  AnimateShowChangeCellRenderer.TEMPLATE = '<span>' + '<span class="ag-value-change-delta"></span>' + '<span class="ag-value-change-value"></span>' + '</span>';
  __decorate$v([Autowired('filterManager')], AnimateShowChangeCellRenderer.prototype, "filterManager", void 0);
  return AnimateShowChangeCellRenderer;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$B = undefined && undefined.__extends || function () {
  var _extendStatics38 = function extendStatics(d, b) {
    _extendStatics38 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics38(d, b);
  };
  return function (d, b) {
    _extendStatics38(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$w = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AnimateSlideCellRenderer = /** @class */function (_super) {
  __extends$B(AnimateSlideCellRenderer, _super);
  function AnimateSlideCellRenderer() {
    var _this = _super.call(this, AnimateSlideCellRenderer.TEMPLATE) || this;
    _this.refreshCount = 0;
    _this.eCurrent = _this.queryForHtmlElement('.ag-value-slide-current');
    return _this;
  }
  AnimateSlideCellRenderer.prototype.init = function (params) {
    this.refresh(params);
  };
  AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
    var _this = this;
    this.refreshCount++;
    // below we keep checking this, and stop working on the animation
    // if it no longer matches - this means another animation has started
    // and this one is stale.
    var refreshCountCopy = this.refreshCount;
    // if old animation, remove it
    if (this.ePrevious) {
      this.getGui().removeChild(this.ePrevious);
    }
    this.ePrevious = loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
    this.ePrevious.innerHTML = this.eCurrent.innerHTML;
    this.getGui().insertBefore(this.ePrevious, this.eCurrent);
    // having timeout of 0 allows use to skip to the next css turn,
    // so we know the previous css classes have been applied. so the
    // complex set of setTimeout below creates the animation
    window.setTimeout(function () {
      if (refreshCountCopy !== _this.refreshCount) {
        return;
      }
      addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
    }, 50);
    window.setTimeout(function () {
      if (refreshCountCopy !== _this.refreshCount) {
        return;
      }
      _this.getGui().removeChild(_this.ePrevious);
      _this.ePrevious = null;
    }, 3000);
  };
  AnimateSlideCellRenderer.prototype.refresh = function (params) {
    var value = params.value;
    if (missing(value)) {
      value = '';
    }
    if (value === this.lastValue) {
      return false;
    }
    // we don't show the delta if we are in the middle of a filter. see comment on FilterManager
    // with regards processingFilterChange
    if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) {
      return false;
    }
    this.addSlideAnimation();
    this.lastValue = value;
    if (exists(params.valueFormatted)) {
      this.eCurrent.innerHTML = params.valueFormatted;
    } else if (exists(params.value)) {
      this.eCurrent.innerHTML = value;
    } else {
      clearElement(this.eCurrent);
    }
    return true;
  };
  AnimateSlideCellRenderer.TEMPLATE = "<span>\n            <span class=\"ag-value-slide-current\"></span>\n        </span>";
  __decorate$w([Autowired('filterManager')], AnimateSlideCellRenderer.prototype, "filterManager", void 0);
  return AnimateSlideCellRenderer;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var RowHighlightPosition;
(function (RowHighlightPosition) {
  RowHighlightPosition[RowHighlightPosition["Above"] = 0] = "Above";
  RowHighlightPosition[RowHighlightPosition["Below"] = 1] = "Below";
})(RowHighlightPosition || (RowHighlightPosition = {}));
var RowNode = /** @class */function () {
  function RowNode(beans) {
    /** The current row index. If the row is filtered out or in a collapsed group, this value will be `null`. */
    this.rowIndex = null;
    /** The key for the group eg Ireland, UK, USA */
    this.key = null;
    /** Children mapped by the pivot columns. */
    this.childrenMapped = {};
    /**
     * This will be `true` if it has a rowIndex assigned, otherwise `false`.
     */
    this.displayed = false;
    /** The row top position in pixels. */
    this.rowTop = null;
    /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */
    this.oldRowTop = null;
    /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */
    this.selectable = true;
    /** Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers. */
    this.__objectId = RowNode.OBJECT_ID_SEQUENCE++;
    /** When one or more Columns are using autoHeight, this keeps track of height of each autoHeight Cell,
     * indexed by the Column ID. */
    this.__autoHeights = {};
    /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */
    this.alreadyRendered = false;
    this.highlighted = null;
    this.selected = false;
    this.beans = beans;
  }
  /** Replaces the data on the `rowNode`. When complete, the grid will refresh the the entire rendered row if it is showing. */
  RowNode.prototype.setData = function (data) {
    this.setDataCommon(data, false);
  };
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
  RowNode.prototype.updateData = function (data) {
    this.setDataCommon(data, true);
  };
  RowNode.prototype.setDataCommon = function (data, update) {
    var oldData = this.data;
    this.data = data;
    this.beans.valueCache.onDataChanged();
    this.updateDataOnDetailNode();
    this.checkRowSelectable();
    var event = this.createDataChangedEvent(data, oldData, update);
    this.dispatchLocalEvent(event);
  };
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  RowNode.prototype.updateDataOnDetailNode = function () {
    if (this.detailNode) {
      this.detailNode.data = this.data;
    }
  };
  RowNode.prototype.createDataChangedEvent = function (newData, oldData, update) {
    return {
      type: RowNode.EVENT_DATA_CHANGED,
      node: this,
      oldData: oldData,
      newData: newData,
      update: update
    };
  };
  RowNode.prototype.createLocalRowEvent = function (type) {
    return {
      type: type,
      node: this
    };
  };
  RowNode.prototype.getRowIndexString = function () {
    if (this.rowPinned === Constants.PINNED_TOP) {
      return 't-' + this.rowIndex;
    }
    if (this.rowPinned === Constants.PINNED_BOTTOM) {
      return 'b-' + this.rowIndex;
    }
    return this.rowIndex.toString();
  };
  RowNode.prototype.createDaemonNode = function () {
    var oldNode = new RowNode(this.beans);
    // just copy the id and data, this is enough for the node to be used
    // in the selection controller (the selection controller is the only
    // place where daemon nodes can live).
    oldNode.id = this.id;
    oldNode.data = this.data;
    oldNode.daemon = true;
    oldNode.selected = this.selected;
    oldNode.level = this.level;
    return oldNode;
  };
  RowNode.prototype.setDataAndId = function (data, id) {
    var oldNode = exists(this.id) ? this.createDaemonNode() : null;
    var oldData = this.data;
    this.data = data;
    this.updateDataOnDetailNode();
    this.setId(id);
    this.beans.selectionService.syncInRowNode(this, oldNode);
    this.checkRowSelectable();
    var event = this.createDataChangedEvent(data, oldData, false);
    this.dispatchLocalEvent(event);
  };
  RowNode.prototype.checkRowSelectable = function () {
    var isRowSelectableFunc = this.beans.gridOptionsWrapper.getIsRowSelectableFunc();
    this.setRowSelectable(isRowSelectableFunc ? isRowSelectableFunc(this) : true);
  };
  RowNode.prototype.setRowSelectable = function (newVal) {
    if (this.selectable !== newVal) {
      this.selectable = newVal;
      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_SELECTABLE_CHANGED));
      }
    }
  };
  RowNode.prototype.setId = function (id) {
    // see if user is providing the id's
    var getRowNodeId = this.beans.gridOptionsWrapper.getRowNodeIdFunc();
    if (getRowNodeId) {
      // if user is providing the id's, then we set the id only after the data has been set.
      // this is important for virtual pagination and viewport, where empty rows exist.
      if (this.data) {
        this.id = getRowNodeId(this.data);
        // make sure id provided doesn't start with 'row-group-' as this is reserved. also check that
        // it has 'startsWith' in case the user provided a number.
        if (this.id && typeof this.id === 'string' && startsWith(this.id, RowNode.ID_PREFIX_ROW_GROUP)) {
          console.error("AG Grid: Row ID's cannot start with " + RowNode.ID_PREFIX_ROW_GROUP + ", this is a reserved prefix for AG Grid's row grouping feature.");
        }
        // force id to be a string
        if (this.id && typeof this.id !== 'string') {
          this.id = '' + this.id;
        }
      } else {
        // this can happen if user has set blank into the rowNode after the row previously
        // having data. this happens in virtual page row model, when data is delete and
        // the page is refreshed.
        this.id = undefined;
      }
    } else {
      this.id = id;
    }
  };
  RowNode.prototype.isPixelInRange = function (pixel) {
    if (!exists(this.rowTop) || !exists(this.rowHeight)) {
      return false;
    }
    return pixel >= this.rowTop && pixel < this.rowTop + this.rowHeight;
  };
  RowNode.prototype.setFirstChild = function (firstChild) {
    if (this.firstChild === firstChild) {
      return;
    }
    this.firstChild = firstChild;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_FIRST_CHILD_CHANGED));
    }
  };
  RowNode.prototype.setLastChild = function (lastChild) {
    if (this.lastChild === lastChild) {
      return;
    }
    this.lastChild = lastChild;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_LAST_CHILD_CHANGED));
    }
  };
  RowNode.prototype.setChildIndex = function (childIndex) {
    if (this.childIndex === childIndex) {
      return;
    }
    this.childIndex = childIndex;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_CHILD_INDEX_CHANGED));
    }
  };
  RowNode.prototype.setRowTop = function (rowTop) {
    this.oldRowTop = this.rowTop;
    if (this.rowTop === rowTop) {
      return;
    }
    this.rowTop = rowTop;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_TOP_CHANGED));
    }
    this.setDisplayed(rowTop !== null);
  };
  RowNode.prototype.clearRowTopAndRowIndex = function () {
    this.oldRowTop = null;
    this.setRowTop(null);
    this.setRowIndex(null);
  };
  RowNode.prototype.setDisplayed = function (displayed) {
    if (this.displayed === displayed) {
      return;
    }
    this.displayed = displayed;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DISPLAYED_CHANGED));
    }
  };
  RowNode.prototype.setDragging = function (dragging) {
    if (this.dragging === dragging) {
      return;
    }
    this.dragging = dragging;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_DRAGGING_CHANGED));
    }
  };
  RowNode.prototype.setHighlighted = function (highlighted) {
    if (highlighted === this.highlighted) {
      return;
    }
    this.highlighted = highlighted;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HIGHLIGHT_CHANGED));
    }
  };
  RowNode.prototype.setAllChildrenCount = function (allChildrenCount) {
    if (this.allChildrenCount === allChildrenCount) {
      return;
    }
    this.allChildrenCount = allChildrenCount;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
    }
  };
  RowNode.prototype.setMaster = function (master) {
    if (this.master === master) {
      return;
    }
    // if changing AWAY from master, then unexpand, otherwise
    // next time it's shown it is expanded again
    if (this.master && !master) {
      this.expanded = false;
    }
    this.master = master;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_MASTER_CHANGED));
    }
  };
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  RowNode.prototype.setRowHeight = function (rowHeight, estimated) {
    if (estimated === void 0) {
      estimated = false;
    }
    this.rowHeight = rowHeight;
    this.rowHeightEstimated = estimated;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HEIGHT_CHANGED));
    }
  };
  RowNode.prototype.setRowAutoHeight = function (cellHeight, column) {
    if (!this.__autoHeights) {
      this.__autoHeights = {};
    }
    var autoHeights = this.__autoHeights;
    autoHeights[column.getId()] = cellHeight;
    if (cellHeight != null) {
      if (this.checkAutoHeightsDebounced == null) {
        this.checkAutoHeightsDebounced = debounce(this.checkAutoHeights.bind(this), 1);
      }
      this.checkAutoHeightsDebounced();
    }
  };
  RowNode.prototype.checkAutoHeights = function () {
    var notAllPresent = false;
    var nonePresent = true;
    var newRowHeight = 0;
    var autoHeights = this.__autoHeights;
    if (autoHeights == null) {
      return;
    }
    var displayedAutoHeightCols = this.beans.columnModel.getAllDisplayedAutoHeightCols();
    displayedAutoHeightCols.forEach(function (col) {
      var cellHeight = autoHeights[col.getId()];
      if (cellHeight == null) {
        notAllPresent = true;
        return;
      }
      nonePresent = false;
      if (cellHeight > newRowHeight) {
        newRowHeight = cellHeight;
      }
    });
    if (notAllPresent) {
      return;
    }
    // we take min of 10, so we don't adjust for empty rows. if <10, we put to default.
    // this prevents the row starting very small when waiting for async components, 
    // which would then mean the grid squashes in far to many rows (as small heights
    // means more rows fit in) which looks crap. so best ignore small values and assume 
    // we are still waiting for values to render.
    if (nonePresent || newRowHeight < 10) {
      newRowHeight = this.beans.gridOptionsWrapper.getRowHeightForNode(this).height;
    }
    if (newRowHeight == this.rowHeight) {
      return;
    }
    this.setRowHeight(newRowHeight);
    var rowModel = this.beans.rowModel;
    rowModel.onRowHeightChanged && rowModel.onRowHeightChanged();
  };
  RowNode.prototype.setRowIndex = function (rowIndex) {
    if (this.rowIndex === rowIndex) {
      return;
    }
    this.rowIndex = rowIndex;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_INDEX_CHANGED));
    }
  };
  RowNode.prototype.setUiLevel = function (uiLevel) {
    if (this.uiLevel === uiLevel) {
      return;
    }
    this.uiLevel = uiLevel;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_UI_LEVEL_CHANGED));
    }
  };
  RowNode.prototype.setExpanded = function (expanded) {
    if (this.expanded === expanded) {
      return;
    }
    this.expanded = expanded;
    if (this.eventService) {
      this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_EXPANDED_CHANGED));
    }
    var event = assign$3({}, this.createGlobalRowEvent(Events.EVENT_ROW_GROUP_OPENED), {
      expanded: expanded
    });
    this.beans.rowNodeEventThrottle.dispatchExpanded(event);
    // when using footers we need to refresh the group row, as the aggregation
    // values jump between group and footer
    if (this.beans.gridOptionsWrapper.isGroupIncludeFooter()) {
      this.beans.rowRenderer.refreshCells({
        rowNodes: [this]
      });
    }
  };
  RowNode.prototype.createGlobalRowEvent = function (type) {
    return {
      type: type,
      node: this,
      data: this.data,
      rowIndex: this.rowIndex,
      rowPinned: this.rowPinned,
      context: this.beans.gridOptionsWrapper.getContext(),
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi()
    };
  };
  RowNode.prototype.dispatchLocalEvent = function (event) {
    if (this.eventService) {
      this.eventService.dispatchEvent(event);
    }
  };
  // we also allow editing the value via the editors. when it is done via
  // the editors, no 'cell changed' event gets fired, as it's assumed that
  // the cell knows about the change given it's in charge of the editing.
  // this method is for the client to call, so the cell listens for the change
  // event, and also flashes the cell when the change occurs.
  /** Replaces the value on the `rowNode` for the specified column. When complete, the grid will refresh the rendered cell on the required row only. */
  RowNode.prototype.setDataValue = function (colKey, newValue, eventSource) {
    var column = this.beans.columnModel.getPrimaryColumn(colKey);
    var oldValue = this.beans.valueService.getValue(column, this);
    this.beans.valueService.setValue(this, column, newValue, eventSource);
    this.dispatchCellChangedEvent(column, newValue, oldValue);
  };
  RowNode.prototype.setGroupValue = function (colKey, newValue) {
    var column = this.beans.columnModel.getGridColumn(colKey);
    if (missing(this.groupData)) {
      this.groupData = {};
    }
    var columnId = column.getColId();
    var oldValue = this.groupData[columnId];
    if (oldValue === newValue) {
      return;
    }
    this.groupData[columnId] = newValue;
    this.dispatchCellChangedEvent(column, newValue, oldValue);
  };
  // sets the data for an aggregation
  RowNode.prototype.setAggData = function (newAggData) {
    var _this = this;
    // find out all keys that could potentially change
    var colIds = getAllKeysInObjects([this.aggData, newAggData]);
    var oldAggData = this.aggData;
    this.aggData = newAggData;
    // if no event service, nobody has registered for events, so no need fire event
    if (this.eventService) {
      colIds.forEach(function (colId) {
        var column = _this.beans.columnModel.getGridColumn(colId);
        var value = _this.aggData ? _this.aggData[colId] : undefined;
        var oldValue = oldAggData ? oldAggData[colId] : undefined;
        _this.dispatchCellChangedEvent(column, value, oldValue);
      });
    }
  };
  RowNode.prototype.updateHasChildren = function () {
    // we need to return true when this.group=true, as this is used by server side row model
    // (as children are lazy loaded and stored in a cache anyway). otherwise we return true
    // if children exist.
    var newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    if (newValue !== this.__hasChildren) {
      this.__hasChildren = !!newValue;
      if (this.eventService) {
        this.eventService.dispatchEvent(this.createLocalRowEvent(RowNode.EVENT_HAS_CHILDREN_CHANGED));
      }
    }
  };
  RowNode.prototype.hasChildren = function () {
    if (this.__hasChildren == null) {
      this.updateHasChildren();
    }
    return this.__hasChildren;
  };
  RowNode.prototype.isEmptyRowGroupNode = function () {
    return this.group && missingOrEmpty(this.childrenAfterGroup);
  };
  RowNode.prototype.dispatchCellChangedEvent = function (column, newValue, oldValue) {
    var cellChangedEvent = {
      type: RowNode.EVENT_CELL_CHANGED,
      node: this,
      column: column,
      newValue: newValue,
      oldValue: oldValue
    };
    this.dispatchLocalEvent(cellChangedEvent);
  };
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */
  RowNode.prototype.resetQuickFilterAggregateText = function () {
    this.quickFilterAggregateText = null;
  };
  RowNode.prototype.isExpandable = function () {
    return this.hasChildren() && !this.footer || this.master ? true : false;
  };
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  RowNode.prototype.isSelected = function () {
    // for footers, we just return what our sibling selected state is, as cannot select a footer
    if (this.footer) {
      return this.sibling.isSelected();
    }
    return this.selected;
  };
  /** Perform a depth-first search of this node and its children. */
  RowNode.prototype.depthFirstSearch = function (callback) {
    if (this.childrenAfterGroup) {
      this.childrenAfterGroup.forEach(function (child) {
        return child.depthFirstSearch(callback);
      });
    }
    callback(this);
  };
  // + rowController.updateGroupsInSelection()
  // + selectionController.calculatedSelectedForAllGroupNodes()
  RowNode.prototype.calculateSelectedFromChildren = function () {
    var atLeastOneSelected = false;
    var atLeastOneDeSelected = false;
    var atLeastOneMixed = false;
    var newSelectedValue;
    if (this.childrenAfterGroup) {
      for (var i = 0; i < this.childrenAfterGroup.length; i++) {
        var child = this.childrenAfterGroup[i];
        // skip non-selectable nodes to prevent inconsistent selection values
        if (!child.selectable) {
          continue;
        }
        var childState = child.isSelected();
        switch (childState) {
          case true:
            atLeastOneSelected = true;
            break;
          case false:
            atLeastOneDeSelected = true;
            break;
          default:
            atLeastOneMixed = true;
            break;
        }
      }
    }
    if (atLeastOneMixed) {
      newSelectedValue = undefined;
    } else if (atLeastOneSelected && !atLeastOneDeSelected) {
      newSelectedValue = true;
    } else if (!atLeastOneSelected && atLeastOneDeSelected) {
      newSelectedValue = false;
    } else {
      newSelectedValue = undefined;
    }
    this.selectThisNode(newSelectedValue);
  };
  RowNode.prototype.setSelectedInitialValue = function (selected) {
    this.selected = selected;
  };
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` for `clearSelection` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param suppressFinishActions
   */
  RowNode.prototype.setSelected = function (newValue, clearSelection, suppressFinishActions) {
    if (clearSelection === void 0) {
      clearSelection = false;
    }
    if (suppressFinishActions === void 0) {
      suppressFinishActions = false;
    }
    this.setSelectedParams({
      newValue: newValue,
      clearSelection: clearSelection,
      suppressFinishActions: suppressFinishActions,
      rangeSelect: false
    });
  };
  RowNode.prototype.isRowPinned = function () {
    return this.rowPinned === Constants.PINNED_TOP || this.rowPinned === Constants.PINNED_BOTTOM;
  };
  // to make calling code more readable, this is the same method as setSelected except it takes names parameters
  RowNode.prototype.setSelectedParams = function (params) {
    var groupSelectsChildren = this.beans.gridOptionsWrapper.isGroupSelectsChildren();
    var newValue = params.newValue === true;
    var clearSelection = params.clearSelection === true;
    var suppressFinishActions = params.suppressFinishActions === true;
    var rangeSelect = params.rangeSelect === true;
    // groupSelectsFiltered only makes sense when group selects children
    var groupSelectsFiltered = groupSelectsChildren && params.groupSelectsFiltered === true;
    if (this.id === undefined) {
      console.warn('AG Grid: cannot select node until id for node is known');
      return 0;
    }
    if (this.rowPinned) {
      console.warn('AG Grid: cannot select pinned rows');
      return 0;
    }
    // if we are a footer, we don't do selection, just pass the info
    // to the sibling (the parent of the group)
    if (this.footer) {
      return this.sibling.setSelectedParams(params);
    }
    if (rangeSelect && this.beans.selectionService.getLastSelectedNode()) {
      var newRowClicked = this.beans.selectionService.getLastSelectedNode() !== this;
      var allowMultiSelect = this.beans.gridOptionsWrapper.isRowSelectionMulti();
      if (newRowClicked && allowMultiSelect) {
        var nodesChanged = this.doRowRangeSelection(params.newValue);
        this.beans.selectionService.setLastSelectedNode(this);
        return nodesChanged;
      }
    }
    var updatedCount = 0;
    // when groupSelectsFiltered, then this node may end up intermediate despite
    // trying to set it to true / false. this group will be calculated further on
    // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
    // here, otherwise the updatedCount would include it.
    var skipThisNode = groupSelectsFiltered && this.group;
    if (!skipThisNode) {
      var thisNodeWasSelected = this.selectThisNode(newValue);
      if (thisNodeWasSelected) {
        updatedCount++;
      }
    }
    if (groupSelectsChildren && this.group) {
      updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
    }
    // clear other nodes if not doing multi select
    if (!suppressFinishActions) {
      var clearOtherNodes = newValue && (clearSelection || !this.beans.gridOptionsWrapper.isRowSelectionMulti());
      if (clearOtherNodes) {
        updatedCount += this.beans.selectionService.clearOtherNodes(this);
      }
      // only if we selected something, then update groups and fire events
      if (updatedCount > 0) {
        this.beans.selectionService.updateGroupsFromChildrenSelections();
        // this is the very end of the 'action node', so we are finished all the updates,
        // include any parent / child changes that this method caused
        var event_1 = {
          type: Events.EVENT_SELECTION_CHANGED,
          api: this.beans.gridApi,
          columnApi: this.beans.columnApi
        };
        this.beans.eventService.dispatchEvent(event_1);
      }
      // so if user next does shift-select, we know where to start the selection from
      if (newValue) {
        this.beans.selectionService.setLastSelectedNode(this);
      }
    }
    return updatedCount;
  };
  // selects all rows between this node and the last selected node (or the top if this is the first selection).
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  RowNode.prototype.doRowRangeSelection = function (value) {
    var _this = this;
    if (value === void 0) {
      value = true;
    }
    var groupsSelectChildren = this.beans.gridOptionsWrapper.isGroupSelectsChildren();
    var lastSelectedNode = this.beans.selectionService.getLastSelectedNode();
    var nodesToSelect = this.beans.rowModel.getNodesInRangeForSelection(this, lastSelectedNode);
    var updatedCount = 0;
    nodesToSelect.forEach(function (rowNode) {
      if (rowNode.group && groupsSelectChildren || value === false && _this === rowNode) {
        return;
      }
      var nodeWasSelected = rowNode.selectThisNode(value);
      if (nodeWasSelected) {
        updatedCount++;
      }
    });
    this.beans.selectionService.updateGroupsFromChildrenSelections();
    var event = {
      type: Events.EVENT_SELECTION_CHANGED,
      api: this.beans.gridApi,
      columnApi: this.beans.columnApi
    };
    this.beans.eventService.dispatchEvent(event);
    return updatedCount;
  };
  RowNode.prototype.isParentOfNode = function (potentialParent) {
    var parentNode = this.parent;
    while (parentNode) {
      if (parentNode === potentialParent) {
        return true;
      }
      parentNode = parentNode.parent;
    }
    return false;
  };
  RowNode.prototype.selectThisNode = function (newValue) {
    // we only check selectable when newValue=true (ie selecting) to allow unselecting values,
    // as selectable is dynamic, need a way to unselect rows when selectable becomes false.
    var selectionNotAllowed = !this.selectable && newValue;
    var selectionNotChanged = this.selected === newValue;
    if (selectionNotAllowed || selectionNotChanged) {
      return false;
    }
    this.selected = newValue;
    if (this.eventService) {
      this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_ROW_SELECTED));
    }
    var event = this.createGlobalRowEvent(Events.EVENT_ROW_SELECTED);
    this.beans.eventService.dispatchEvent(event);
    return true;
  };
  RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
    var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
    if (missing(children)) {
      return 0;
    }
    var updatedCount = 0;
    for (var i = 0; i < children.length; i++) {
      updatedCount += children[i].setSelectedParams({
        newValue: newValue,
        clearSelection: false,
        suppressFinishActions: true,
        groupSelectsFiltered: groupSelectsFiltered
      });
    }
    return updatedCount;
  };
  /** Add an event listener. */
  RowNode.prototype.addEventListener = function (eventType, listener) {
    if (!this.eventService) {
      this.eventService = new EventService();
    }
    this.eventService.addEventListener(eventType, listener);
  };
  /** Remove event listener. */
  RowNode.prototype.removeEventListener = function (eventType, listener) {
    if (!this.eventService) {
      return;
    }
    this.eventService.removeEventListener(eventType, listener);
    if (this.eventService.noRegisteredListenersExist()) {
      this.eventService = null;
    }
  };
  RowNode.prototype.onMouseEnter = function () {
    this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_ENTER));
  };
  RowNode.prototype.onMouseLeave = function () {
    this.dispatchLocalEvent(this.createLocalRowEvent(RowNode.EVENT_MOUSE_LEAVE));
  };
  RowNode.prototype.getFirstChildOfFirstChild = function (rowGroupColumn) {
    var currentRowNode = this;
    var isCandidate = true;
    var foundFirstChildPath = false;
    var nodeToSwapIn = null;
    // if we are hiding groups, then if we are the first child, of the first child,
    // all the way up to the column we are interested in, then we show the group cell.
    while (isCandidate && !foundFirstChildPath) {
      var parentRowNode = currentRowNode.parent;
      var firstChild = exists(parentRowNode) && currentRowNode.firstChild;
      if (firstChild) {
        if (parentRowNode.rowGroupColumn === rowGroupColumn) {
          foundFirstChildPath = true;
          nodeToSwapIn = parentRowNode;
        }
      } else {
        isCandidate = false;
      }
      currentRowNode = parentRowNode;
    }
    return foundFirstChildPath ? nodeToSwapIn : null;
  };
  RowNode.prototype.isFullWidthCell = function () {
    var isFullWidthCellFunc = this.beans.gridOptionsWrapper.getIsFullWidthCellFunc();
    return isFullWidthCellFunc ? isFullWidthCellFunc(this) : false;
  };
  /**
   * Returns the route of the row node. If the Row Node is a group, it returns the route to that Row Node.
   * If the Row Node is not a group, it returns `undefined`.
   */
  RowNode.prototype.getRoute = function () {
    if (this.key == null) {
      return;
    }
    var res = [];
    var pointer = this;
    while (pointer.key != null) {
      res.push(pointer.key);
      pointer = pointer.parent;
    }
    return res.reverse();
  };
  RowNode.ID_PREFIX_ROW_GROUP = 'row-group-';
  RowNode.ID_PREFIX_TOP_PINNED = 't-';
  RowNode.ID_PREFIX_BOTTOM_PINNED = 'b-';
  RowNode.OBJECT_ID_SEQUENCE = 0;
  RowNode.EVENT_ROW_SELECTED = 'rowSelected';
  RowNode.EVENT_DATA_CHANGED = 'dataChanged';
  RowNode.EVENT_CELL_CHANGED = 'cellChanged';
  RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = 'allChildrenCountChanged';
  RowNode.EVENT_MASTER_CHANGED = 'masterChanged';
  RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
  RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
  RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
  RowNode.EVENT_TOP_CHANGED = 'topChanged';
  RowNode.EVENT_DISPLAYED_CHANGED = 'displayedChanged';
  RowNode.EVENT_FIRST_CHILD_CHANGED = 'firstChildChanged';
  RowNode.EVENT_LAST_CHILD_CHANGED = 'lastChildChanged';
  RowNode.EVENT_CHILD_INDEX_CHANGED = 'childIndexChanged';
  RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
  RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
  RowNode.EVENT_HAS_CHILDREN_CHANGED = 'hasChildrenChanged';
  RowNode.EVENT_SELECTABLE_CHANGED = 'selectableChanged';
  RowNode.EVENT_UI_LEVEL_CHANGED = 'uiLevelChanged';
  RowNode.EVENT_HIGHLIGHT_CHANGED = 'rowHighlightChanged';
  RowNode.EVENT_DRAGGING_CHANGED = 'draggingChanged';
  return RowNode;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$C = undefined && undefined.__extends || function () {
  var _extendStatics39 = function extendStatics(d, b) {
    _extendStatics39 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics39(d, b);
  };
  return function (d, b) {
    _extendStatics39(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$x = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CheckboxSelectionComponent = /** @class */function (_super) {
  __extends$C(CheckboxSelectionComponent, _super);
  function CheckboxSelectionComponent() {
    return _super.call(this, /* html*/"\n            <div class=\"ag-selection-checkbox\" role=\"presentation\">\n                <ag-checkbox role=\"presentation\" ref=\"eCheckbox\"></ag-checkbox>\n            </div>") || this;
  }
  CheckboxSelectionComponent.prototype.postConstruct = function () {
    this.eCheckbox.setPassive(true);
  };
  CheckboxSelectionComponent.prototype.getCheckboxId = function () {
    return this.eCheckbox.getInputElement().id;
  };
  CheckboxSelectionComponent.prototype.onDataChanged = function () {
    // when rows are loaded for the second time, this can impact the selection, as a row
    // could be loaded as already selected (if user scrolls down, and then up again).
    this.onSelectionChanged();
  };
  CheckboxSelectionComponent.prototype.onSelectableChanged = function () {
    this.showOrHideSelect();
  };
  CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var state = this.rowNode.isSelected();
    var stateName = state === undefined ? translate('ariaIndeterminate', 'indeterminate') : state === true ? translate('ariaChecked', 'checked') : translate('ariaUnchecked', 'unchecked');
    var ariaLabel = translate('ariaRowToggleSelection', 'Press Space to toggle row selection');
    this.eCheckbox.setValue(state, true);
    this.eCheckbox.setInputAriaLabel(ariaLabel + " (" + stateName + ")");
  };
  CheckboxSelectionComponent.prototype.onCheckedClicked = function (event) {
    var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
    var updatedCount = this.rowNode.setSelectedParams({
      newValue: false,
      rangeSelect: event.shiftKey,
      groupSelectsFiltered: groupSelectsFiltered
    });
    return updatedCount;
  };
  CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
    var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
    var updatedCount = this.rowNode.setSelectedParams({
      newValue: true,
      rangeSelect: event.shiftKey,
      groupSelectsFiltered: groupSelectsFiltered
    });
    return updatedCount;
  };
  CheckboxSelectionComponent.prototype.init = function (params) {
    var _this = this;
    this.rowNode = params.rowNode;
    this.column = params.column;
    this.onSelectionChanged();
    // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
    // would possibly get selected twice
    this.addGuiEventListener('click', function (event) {
      return stopPropagationForAgGrid(event);
    });
    // likewise we don't want double click on this icon to open a group
    this.addGuiEventListener('dblclick', function (event) {
      return stopPropagationForAgGrid(event);
    });
    this.addManagedListener(this.eCheckbox.getInputElement(), 'click', function (event) {
      var isSelected = _this.eCheckbox.getValue();
      var previousValue = _this.eCheckbox.getPreviousValue();
      if (previousValue === undefined) {
        // indeterminate
        var result = _this.onUncheckedClicked(event || {});
        if (result === 0) {
          _this.onCheckedClicked(event);
        }
      } else if (isSelected) {
        _this.onCheckedClicked(event);
      } else {
        _this.onUncheckedClicked(event || {});
      }
    });
    this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
    var isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
    var checkboxVisibleIsDynamic = isRowSelectableFunc || this.checkboxCallbackExists();
    if (checkboxVisibleIsDynamic) {
      var showOrHideSelectListener = this.showOrHideSelect.bind(this);
      this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, showOrHideSelectListener);
      this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, showOrHideSelectListener);
      this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, showOrHideSelectListener);
      this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute('tabindex', '-1');
  };
  CheckboxSelectionComponent.prototype.showOrHideSelect = function () {
    // if the isRowSelectable() is not provided the row node is selectable by default
    var selectable = this.rowNode.selectable;
    // checkboxSelection callback is deemed a legacy solution however we will still consider it's result.
    // If selectable, then also check the colDef callback. if not selectable, this it short circuits - no need
    // to call the colDef callback.
    if (selectable && this.checkboxCallbackExists()) {
      selectable = this.column.isCellCheckboxSelection(this.rowNode);
    }
    // show checkbox if both conditions are true
    this.setVisible(selectable);
  };
  CheckboxSelectionComponent.prototype.checkboxCallbackExists = function () {
    // column will be missing if groupUseEntireRow=true
    var colDef = this.column ? this.column.getColDef() : null;
    return !!colDef && typeof colDef.checkboxSelection === 'function';
  };
  __decorate$x([RefSelector('eCheckbox')], CheckboxSelectionComponent.prototype, "eCheckbox", void 0);
  __decorate$x([PostConstruct], CheckboxSelectionComponent.prototype, "postConstruct", null);
  return CheckboxSelectionComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$D = undefined && undefined.__extends || function () {
  var _extendStatics40 = function extendStatics(d, b) {
    _extendStatics40 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics40(d, b);
  };
  return function (d, b) {
    _extendStatics40(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DragSourceType;
(function (DragSourceType) {
  DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
  DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
  DragSourceType[DragSourceType["RowDrag"] = 2] = "RowDrag";
  DragSourceType[DragSourceType["ChartPanel"] = 3] = "ChartPanel";
})(DragSourceType || (DragSourceType = {}));
var VerticalDirection;
(function (VerticalDirection) {
  VerticalDirection[VerticalDirection["Up"] = 0] = "Up";
  VerticalDirection[VerticalDirection["Down"] = 1] = "Down";
})(VerticalDirection || (VerticalDirection = {}));
var HorizontalDirection;
(function (HorizontalDirection) {
  HorizontalDirection[HorizontalDirection["Left"] = 0] = "Left";
  HorizontalDirection[HorizontalDirection["Right"] = 1] = "Right";
})(HorizontalDirection || (HorizontalDirection = {}));
var DragAndDropService = /** @class */function (_super) {
  __extends$D(DragAndDropService, _super);
  function DragAndDropService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.dragSourceAndParamsList = [];
    _this.dropTargets = [];
    return _this;
  }
  DragAndDropService_1 = DragAndDropService;
  DragAndDropService.prototype.init = function () {
    this.ePinnedIcon = createIcon('columnMovePin', this.gridOptionsWrapper, null);
    this.eHideIcon = createIcon('columnMoveHide', this.gridOptionsWrapper, null);
    this.eMoveIcon = createIcon('columnMoveMove', this.gridOptionsWrapper, null);
    this.eLeftIcon = createIcon('columnMoveLeft', this.gridOptionsWrapper, null);
    this.eRightIcon = createIcon('columnMoveRight', this.gridOptionsWrapper, null);
    this.eGroupIcon = createIcon('columnMoveGroup', this.gridOptionsWrapper, null);
    this.eAggregateIcon = createIcon('columnMoveValue', this.gridOptionsWrapper, null);
    this.ePivotIcon = createIcon('columnMovePivot', this.gridOptionsWrapper, null);
    this.eDropNotAllowedIcon = createIcon('dropNotAllowed', this.gridOptionsWrapper, null);
  };
  DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
    if (allowTouch === void 0) {
      allowTouch = false;
    }
    var params = {
      eElement: dragSource.eElement,
      dragStartPixels: dragSource.dragStartPixels,
      onDragStart: this.onDragStart.bind(this, dragSource),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this)
    };
    this.dragSourceAndParamsList.push({
      params: params,
      dragSource: dragSource
    });
    this.dragService.addDragSource(params, allowTouch);
  };
  DragAndDropService.prototype.removeDragSource = function (dragSource) {
    var sourceAndParams = find$3(this.dragSourceAndParamsList, function (item) {
      return item.dragSource === dragSource;
    });
    if (sourceAndParams) {
      this.dragService.removeDragSource(sourceAndParams.params);
      removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
    }
  };
  DragAndDropService.prototype.clearDragSourceParamsList = function () {
    var _this = this;
    this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
      return _this.dragService.removeDragSource(sourceAndParams.params);
    });
    this.dragSourceAndParamsList.length = 0;
  };
  DragAndDropService.prototype.nudge = function () {
    if (this.dragging) {
      this.onDragging(this.eventLastTime, true);
    }
  };
  DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
    this.dragging = true;
    this.dragSource = dragSource;
    this.eventLastTime = mouseEvent;
    this.dragItem = this.dragSource.getDragItem();
    this.lastDropTarget = this.dragSource.dragSourceDropTarget;
    if (this.dragSource.onDragStarted) {
      this.dragSource.onDragStarted();
    }
    this.createGhost();
  };
  DragAndDropService.prototype.onDragStop = function (mouseEvent) {
    this.eventLastTime = null;
    this.dragging = false;
    if (this.dragSource.onDragStopped) {
      this.dragSource.onDragStopped();
    }
    if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
      var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
      this.lastDropTarget.onDragStop(draggingEvent);
    }
    this.lastDropTarget = null;
    this.dragItem = null;
    this.removeGhost();
  };
  DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
    var _this = this;
    var hDirection = this.getHorizontalDirection(mouseEvent);
    var vDirection = this.getVerticalDirection(mouseEvent);
    this.eventLastTime = mouseEvent;
    this.positionGhost(mouseEvent);
    // check if mouseEvent intersects with any of the drop targets
    var validDropTargets = this.dropTargets.filter(function (target) {
      return _this.isMouseOnDropTarget(mouseEvent, target);
    });
    var len = validDropTargets.length;
    var dropTarget = null;
    if (len > 0) {
      dropTarget = len === 1 ? validDropTargets[0]
      // the current mouse position could intersect with more than 1 element
      // if they are nested. In that case we need to get the most specific
      // container, which is the one that does not contain any other targets.
      : validDropTargets.reduce(function (prevTarget, currTarget) {
        if (!prevTarget) {
          return currTarget;
        }
        var prevContainer = prevTarget.getContainer();
        var currContainer = currTarget.getContainer();
        if (prevContainer.contains(currContainer)) {
          return currTarget;
        }
        return prevTarget;
      });
    }
    if (dropTarget !== this.lastDropTarget) {
      this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
      this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
      this.lastDropTarget = dropTarget;
    } else if (dropTarget && dropTarget.onDragging) {
      var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
      dropTarget.onDragging(draggingEvent);
    }
  };
  DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
    if (!dropTarget) {
      return;
    }
    if (dropTarget.onDragEnter) {
      var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
      dropTarget.onDragEnter(dragEnterEvent);
    }
    this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
  };
  DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
    if (!this.lastDropTarget) {
      return;
    }
    if (this.lastDropTarget.onDragLeave) {
      var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
      this.lastDropTarget.onDragLeave(dragLeaveEvent);
    }
    this.setGhostIcon(null);
  };
  DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
    var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
    var containers = [[dropTarget.getContainer()]];
    return secondaryContainers ? containers.concat(secondaryContainers) : containers;
  };
  DragAndDropService.prototype.allContainersIntersect = function (mouseEvent, containers) {
    for (var _i = 0, containers_1 = containers; _i < containers_1.length; _i++) {
      var container = containers_1[_i];
      var rect = container.getBoundingClientRect();
      // if element is not visible, then width and height are zero
      if (rect.width === 0 || rect.height === 0) {
        return false;
      }
      var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX < rect.right;
      var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY < rect.bottom;
      if (!horizontalFit || !verticalFit) {
        return false;
      }
    }
    return true;
  };
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
    var allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
    var mouseOverTarget = false;
    for (var _i = 0, allContainersFromDropTarget_1 = allContainersFromDropTarget; _i < allContainersFromDropTarget_1.length; _i++) {
      var currentContainers = allContainersFromDropTarget_1[_i];
      if (this.allContainersIntersect(mouseEvent, currentContainers)) {
        mouseOverTarget = true;
        break;
      }
    }
    return mouseOverTarget && dropTarget.isInterestedIn(this.dragSource.type);
  };
  DragAndDropService.prototype.addDropTarget = function (dropTarget) {
    this.dropTargets.push(dropTarget);
  };
  DragAndDropService.prototype.removeDropTarget = function (dropTarget) {
    this.dropTargets = this.dropTargets.filter(function (target) {
      return target.getContainer() !== dropTarget.getContainer();
    });
  };
  DragAndDropService.prototype.hasExternalDropZones = function () {
    return this.dropTargets.some(function (zones) {
      return zones.external;
    });
  };
  DragAndDropService.prototype.findExternalZone = function (params) {
    var externalTargets = this.dropTargets.filter(function (target) {
      return target.external;
    });
    return find$3(externalTargets, function (zone) {
      return zone.getContainer() === params.getContainer();
    });
  };
  DragAndDropService.prototype.getHorizontalDirection = function (event) {
    var clientX = this.eventLastTime && this.eventLastTime.clientX;
    var eClientX = event.clientX;
    if (clientX === eClientX) {
      return null;
    }
    return clientX > eClientX ? HorizontalDirection.Left : HorizontalDirection.Right;
  };
  DragAndDropService.prototype.getVerticalDirection = function (event) {
    var clientY = this.eventLastTime && this.eventLastTime.clientY;
    var eClientY = event.clientY;
    if (clientY === eClientY) {
      return null;
    }
    return clientY > eClientY ? VerticalDirection.Up : VerticalDirection.Down;
  };
  DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
    // localise x and y to the target
    var dropZoneTarget = dropTarget.getContainer();
    var rect = dropZoneTarget.getBoundingClientRect();
    var _a = this,
      api = _a.gridApi,
      columnApi = _a.columnApi,
      dragItem = _a.dragItem,
      dragSource = _a.dragSource;
    var x = event.clientX - rect.left;
    var y = event.clientY - rect.top;
    return {
      event: event,
      x: x,
      y: y,
      vDirection: vDirection,
      hDirection: hDirection,
      dragSource: dragSource,
      fromNudge: fromNudge,
      dragItem: dragItem,
      api: api,
      columnApi: columnApi,
      dropZoneTarget: dropZoneTarget
    };
  };
  DragAndDropService.prototype.positionGhost = function (event) {
    var ghost = this.eGhost;
    if (!ghost) {
      return;
    }
    var ghostRect = ghost.getBoundingClientRect();
    var ghostHeight = ghostRect.height;
    // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
    // then brought in scrollbars to the browser. no idea why, but putting in -2 here
    // works around it which is good enough for me.
    var browserWidth = getBodyWidth() - 2;
    var browserHeight = getBodyHeight() - 2;
    var top = event.pageY - ghostHeight / 2;
    var left = event.pageX - 10;
    var usrDocument = this.gridOptionsWrapper.getDocument();
    var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
    var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
    // check ghost is not positioned outside of the browser
    if (browserWidth > 0 && left + ghost.clientWidth > browserWidth + windowScrollX) {
      left = browserWidth + windowScrollX - ghost.clientWidth;
    }
    if (left < 0) {
      left = 0;
    }
    if (browserHeight > 0 && top + ghost.clientHeight > browserHeight + windowScrollY) {
      top = browserHeight + windowScrollY - ghost.clientHeight;
    }
    if (top < 0) {
      top = 0;
    }
    ghost.style.left = left + "px";
    ghost.style.top = top + "px";
  };
  DragAndDropService.prototype.removeGhost = function () {
    if (this.eGhost && this.eGhostParent) {
      this.eGhostParent.removeChild(this.eGhost);
    }
    this.eGhost = null;
  };
  DragAndDropService.prototype.createGhost = function () {
    this.eGhost = loadTemplate(DragAndDropService_1.GHOST_TEMPLATE);
    var theme = this.environment.getTheme().theme;
    if (theme) {
      addCssClass(this.eGhost, theme);
    }
    this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
    this.setGhostIcon(null);
    var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
    var dragItemName = this.dragSource.dragItemName;
    if (isFunction(dragItemName)) {
      dragItemName = dragItemName();
    }
    eText.innerHTML = escapeString(dragItemName) || '';
    this.eGhost.style.height = '25px';
    this.eGhost.style.top = '20px';
    this.eGhost.style.left = '20px';
    var usrDocument = this.gridOptionsWrapper.getDocument();
    var targetEl = usrDocument.fullscreenElement || usrDocument.querySelector('body');
    this.eGhostParent = targetEl;
    if (!this.eGhostParent) {
      console.warn('AG Grid: could not find document body, it is needed for dragging columns');
    } else {
      this.eGhostParent.appendChild(this.eGhost);
    }
  };
  DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
    if (shake === void 0) {
      shake = false;
    }
    clearElement(this.eGhostIcon);
    var eIcon = null;
    if (!iconName) {
      iconName = this.dragSource.defaultIconName || DragAndDropService_1.ICON_NOT_ALLOWED;
    }
    switch (iconName) {
      case DragAndDropService_1.ICON_PINNED:
        eIcon = this.ePinnedIcon;
        break;
      case DragAndDropService_1.ICON_MOVE:
        eIcon = this.eMoveIcon;
        break;
      case DragAndDropService_1.ICON_LEFT:
        eIcon = this.eLeftIcon;
        break;
      case DragAndDropService_1.ICON_RIGHT:
        eIcon = this.eRightIcon;
        break;
      case DragAndDropService_1.ICON_GROUP:
        eIcon = this.eGroupIcon;
        break;
      case DragAndDropService_1.ICON_AGGREGATE:
        eIcon = this.eAggregateIcon;
        break;
      case DragAndDropService_1.ICON_PIVOT:
        eIcon = this.ePivotIcon;
        break;
      case DragAndDropService_1.ICON_NOT_ALLOWED:
        eIcon = this.eDropNotAllowedIcon;
        break;
      case DragAndDropService_1.ICON_HIDE:
        eIcon = this.eHideIcon;
        break;
    }
    addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
    if (eIcon === this.eHideIcon && this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns()) {
      return;
    }
    if (eIcon) {
      this.eGhostIcon.appendChild(eIcon);
    }
  };
  var DragAndDropService_1;
  DragAndDropService.ICON_PINNED = 'pinned';
  DragAndDropService.ICON_MOVE = 'move';
  DragAndDropService.ICON_LEFT = 'left';
  DragAndDropService.ICON_RIGHT = 'right';
  DragAndDropService.ICON_GROUP = 'group';
  DragAndDropService.ICON_AGGREGATE = 'aggregate';
  DragAndDropService.ICON_PIVOT = 'pivot';
  DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
  DragAndDropService.ICON_HIDE = 'hide';
  DragAndDropService.GHOST_TEMPLATE = "<div class=\"ag-dnd-ghost ag-unselectable\">\n            <span class=\"ag-dnd-ghost-icon ag-shake-left-to-right\"></span>\n            <div class=\"ag-dnd-ghost-label\"></div>\n        </div>";
  __decorate$y([Autowired('dragService')], DragAndDropService.prototype, "dragService", void 0);
  __decorate$y([Autowired('environment')], DragAndDropService.prototype, "environment", void 0);
  __decorate$y([Autowired('columnApi')], DragAndDropService.prototype, "columnApi", void 0);
  __decorate$y([Autowired('gridApi')], DragAndDropService.prototype, "gridApi", void 0);
  __decorate$y([PostConstruct], DragAndDropService.prototype, "init", null);
  __decorate$y([PreDestroy], DragAndDropService.prototype, "clearDragSourceParamsList", null);
  DragAndDropService = DragAndDropService_1 = __decorate$y([Bean('dragAndDropService')], DragAndDropService);
  return DragAndDropService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$E = undefined && undefined.__extends || function () {
  var _extendStatics41 = function extendStatics(d, b) {
    _extendStatics41 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics41(d, b);
  };
  return function (d, b) {
    _extendStatics41(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowDragComp = /** @class */function (_super) {
  __extends$E(RowDragComp, _super);
  function RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange) {
    var _this = _super.call(this) || this;
    _this.cellValueFn = cellValueFn;
    _this.rowNode = rowNode;
    _this.column = column;
    _this.customGui = customGui;
    _this.dragStartPixels = dragStartPixels;
    _this.suppressVisibilityChange = suppressVisibilityChange;
    _this.dragSource = null;
    return _this;
  }
  RowDragComp.prototype.isCustomGui = function () {
    return this.customGui != null;
  };
  RowDragComp.prototype.postConstruct = function () {
    if (!this.customGui) {
      this.setTemplate( /* html */"<div class=\"ag-drag-handle ag-row-drag\" aria-hidden=\"true\"></div>");
      this.getGui().appendChild(createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
      this.addDragSource();
    } else {
      this.setDragElement(this.customGui, this.dragStartPixels);
    }
    this.checkCompatibility();
    if (!this.suppressVisibilityChange) {
      var strategy = this.beans.gridOptionsWrapper.isRowDragManaged() ? new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column) : new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column);
      this.createManagedBean(strategy, this.beans.context);
    }
  };
  RowDragComp.prototype.setDragElement = function (dragElement, dragStartPixels) {
    this.setTemplateFromElement(dragElement);
    this.addDragSource(dragStartPixels);
  };
  RowDragComp.prototype.getSelectedCount = function () {
    var isRowDragMultiRow = this.beans.gridOptionsWrapper.isRowDragMultiRow();
    if (!isRowDragMultiRow) {
      return 1;
    }
    var selection = this.beans.selectionService.getSelectedNodes();
    return selection.indexOf(this.rowNode) !== -1 ? selection.length : 1;
  };
  // returns true if all compatibility items work out
  RowDragComp.prototype.checkCompatibility = function () {
    var managed = this.beans.gridOptionsWrapper.isRowDragManaged();
    var treeData = this.beans.gridOptionsWrapper.isTreeData();
    if (treeData && managed) {
      doOnce(function () {
        return console.warn('AG Grid: If using row drag with tree data, you cannot have rowDragManaged=true');
      }, 'RowDragComp.managedAndTreeData');
    }
  };
  RowDragComp.prototype.addDragSource = function (dragStartPixels) {
    var _this = this;
    if (dragStartPixels === void 0) {
      dragStartPixels = 4;
    }
    // if this is changing the drag element, delete the previous dragSource
    if (this.dragSource) {
      this.removeDragSource();
    }
    var dragItem = {
      rowNode: this.rowNode,
      columns: this.column ? [this.column] : undefined,
      defaultTextValue: this.cellValueFn()
    };
    var rowDragText = this.column && this.column.getColDef().rowDragText;
    this.dragSource = {
      type: DragSourceType.RowDrag,
      eElement: this.getGui(),
      dragItemName: function dragItemName() {
        var dragItemCount = _this.getSelectedCount();
        if (rowDragText) {
          return rowDragText(dragItem, dragItemCount);
        }
        return dragItemCount === 1 ? _this.cellValueFn() : dragItemCount + " rows";
      },
      getDragItem: function getDragItem() {
        return dragItem;
      },
      dragStartPixels: dragStartPixels,
      dragSourceDomDataKey: this.beans.gridOptionsWrapper.getDomDataKey()
    };
    this.addMouseDownListenerIfNeeded();
    this.beans.dragAndDropService.addDragSource(this.dragSource, true);
  };
  RowDragComp.prototype.addMouseDownListenerIfNeeded = function () {
    var _this = this;
    if (this.customGui || !this.column || !this.gridOptionsWrapper.isEnableCellTextSelect()) {
      return;
    }
    // mouse down needs to be prevented when enableCellTextSelect
    // is true so text doesn't get selected while dragging rows
    this.addManagedListener(this.getGui(), 'mousedown', function (e) {
      e.preventDefault();
      _this.beans.focusService.setFocusedCell(_this.rowNode.rowIndex, _this.column, _this.rowNode.rowPinned, true);
    });
  };
  RowDragComp.prototype.removeDragSource = function () {
    if (this.dragSource) {
      this.beans.dragAndDropService.removeDragSource(this.dragSource);
    }
    this.dragSource = null;
  };
  __decorate$z([Autowired('beans')], RowDragComp.prototype, "beans", void 0);
  __decorate$z([PostConstruct], RowDragComp.prototype, "postConstruct", null);
  __decorate$z([PreDestroy], RowDragComp.prototype, "removeDragSource", null);
  return RowDragComp;
}(Component);
var VisibilityStrategy = /** @class */function (_super) {
  __extends$E(VisibilityStrategy, _super);
  function VisibilityStrategy(parent, rowNode, column) {
    var _this = _super.call(this) || this;
    _this.parent = parent;
    _this.rowNode = rowNode;
    _this.column = column;
    return _this;
  }
  VisibilityStrategy.prototype.setDisplayedOrVisible = function (neverDisplayed) {
    if (neverDisplayed) {
      this.parent.setDisplayed(false);
    } else {
      var shown = true;
      var isShownSometimes = false;
      if (this.column) {
        shown = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui();
        isShownSometimes = isFunction(this.column.getColDef().rowDrag);
      }
      // if shown sometimes, them some rows can have drag handle while other don't,
      // so we use setVisible to keep the handles horizontally aligned (as setVisible
      // keeps the empty space, whereas setDisplayed looses the space)
      if (isShownSometimes) {
        this.parent.setDisplayed(true);
        this.parent.setVisible(shown);
      } else {
        this.parent.setDisplayed(shown);
        this.parent.setVisible(true);
      }
    }
  };
  return VisibilityStrategy;
}(BeanStub);
// when non managed, the visibility depends on suppressRowDrag property only
var NonManagedVisibilityStrategy = /** @class */function (_super) {
  __extends$E(NonManagedVisibilityStrategy, _super);
  function NonManagedVisibilityStrategy(parent, beans, rowNode, column) {
    var _this = _super.call(this, parent, rowNode, column) || this;
    _this.beans = beans;
    return _this;
  }
  NonManagedVisibilityStrategy.prototype.postConstruct = function () {
    this.addManagedListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
    // in case data changes, then we need to update visibility of drag item
    this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
    this.workOutVisibility();
  };
  NonManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
    this.workOutVisibility();
  };
  NonManagedVisibilityStrategy.prototype.workOutVisibility = function () {
    // only show the drag if both sort and filter are not present
    var neverDisplayed = this.beans.gridOptionsWrapper.isSuppressRowDrag();
    this.setDisplayedOrVisible(neverDisplayed);
  };
  __decorate$z([PostConstruct], NonManagedVisibilityStrategy.prototype, "postConstruct", null);
  return NonManagedVisibilityStrategy;
}(VisibilityStrategy);
// when managed, the visibility depends on sort, filter and row group, as well as suppressRowDrag property
var ManagedVisibilityStrategy = /** @class */function (_super) {
  __extends$E(ManagedVisibilityStrategy, _super);
  function ManagedVisibilityStrategy(parent, beans, rowNode, column) {
    var _this = _super.call(this, parent, rowNode, column) || this;
    _this.beans = beans;
    return _this;
  }
  ManagedVisibilityStrategy.prototype.postConstruct = function () {
    // we do not show the component if sort, filter or grouping is active
    this.addManagedListener(this.beans.eventService, Events.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.beans.eventService, Events.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.beans.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
    // in case data changes, then we need to update visibility of drag item
    this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
    this.addManagedListener(this.beans.gridOptionsWrapper, 'suppressRowDrag', this.onSuppressRowDrag.bind(this));
    this.workOutVisibility();
  };
  ManagedVisibilityStrategy.prototype.onSuppressRowDrag = function () {
    this.workOutVisibility();
  };
  ManagedVisibilityStrategy.prototype.workOutVisibility = function () {
    // only show the drag if both sort and filter are not present
    var gridBodyCon = this.beans.ctrlsService.getGridBodyCtrl();
    var rowDragFeature = gridBodyCon.getRowDragFeature();
    var shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
    var suppressRowDrag = this.beans.gridOptionsWrapper.isSuppressRowDrag();
    var hasExternalDropZones = this.beans.dragAndDropService.hasExternalDropZones();
    var neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
    this.setDisplayedOrVisible(neverDisplayed);
  };
  __decorate$z([PostConstruct], ManagedVisibilityStrategy.prototype, "postConstruct", null);
  return ManagedVisibilityStrategy;
}(VisibilityStrategy);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$F = undefined && undefined.__extends || function () {
  var _extendStatics42 = function extendStatics(d, b) {
    _extendStatics42 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics42(d, b);
  };
  return function (d, b) {
    _extendStatics42(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$7 = undefined && undefined.__assign || function () {
  __assign$7 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$7.apply(this, arguments);
};
var __decorate$A = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupCellRendererCtrl = /** @class */function (_super) {
  __extends$F(GroupCellRendererCtrl, _super);
  function GroupCellRendererCtrl() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GroupCellRendererCtrl.prototype.init = function (comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
    this.params = params;
    this.eGui = eGui;
    this.eCheckbox = eCheckbox;
    this.eExpanded = eExpanded;
    this.eContracted = eContracted;
    this.comp = comp;
    this.compClass = compClass;
    var topLevelFooter = this.isTopLevelFooter();
    var embeddedRowMismatch = this.isEmbeddedRowMismatch();
    // This allows for empty strings to appear as groups since
    // it will only return for null or undefined.
    var nullValue = params.value == null;
    var skipCell = false;
    // if the groupCellRenderer is inside of a footer and groupHideOpenParents is true
    // we should only display the groupCellRenderer if the current column is the rowGroupedColumn
    if (this.gridOptionsWrapper.isGroupIncludeFooter() && this.gridOptionsWrapper.isGroupHideOpenParents()) {
      var node = params.node;
      if (node.footer) {
        var showRowGroup = params.colDef && params.colDef.showRowGroup;
        var rowGroupColumnId = node.rowGroupColumn && node.rowGroupColumn.getColId();
        skipCell = showRowGroup !== rowGroupColumnId;
      }
    }
    this.cellIsBlank = topLevelFooter ? false : embeddedRowMismatch || nullValue || skipCell;
    if (this.cellIsBlank) {
      return;
    }
    this.setupShowingValueForOpenedParent();
    this.findDisplayedGroupNode();
    this.addFullWidthRowDraggerIfNeeded();
    this.addExpandAndContract();
    this.addCheckboxIfNeeded();
    this.addValueElement();
    this.setupIndent();
  };
  GroupCellRendererCtrl.prototype.isTopLevelFooter = function () {
    if (!this.gridOptionsWrapper.isGroupIncludeTotalFooter()) {
      return false;
    }
    if (this.params.value != null || this.params.node.level != -1) {
      return false;
    }
    // at this point, we know it's the root node and there is no value present, so it's a footer cell.
    // the only thing to work out is if we are displaying groups  across multiple
    // columns (groupMultiAutoColumn=true), we only want 'total' to appear in the first column.
    var colDef = this.params.colDef;
    var doingFullWidth = colDef == null;
    if (doingFullWidth) {
      return true;
    }
    if (colDef.showRowGroup === true) {
      return true;
    }
    var rowGroupCols = this.columnModel.getRowGroupColumns();
    // this is a sanity check, rowGroupCols should always be present
    if (!rowGroupCols || rowGroupCols.length === 0) {
      return true;
    }
    var firstRowGroupCol = rowGroupCols[0];
    return firstRowGroupCol.getId() === colDef.showRowGroup;
  };
  // if we are doing embedded full width rows, we only show the renderer when
  // in the body, or if pinning in the pinned section, or if pinning and RTL,
  // in the right section. otherwise we would have the cell repeated in each section.
  GroupCellRendererCtrl.prototype.isEmbeddedRowMismatch = function () {
    if (!this.params.fullWidth || !this.gridOptionsWrapper.isEmbedFullWidthRows()) {
      return false;
    }
    var pinnedLeftCell = this.params.pinned === Constants.PINNED_LEFT;
    var pinnedRightCell = this.params.pinned === Constants.PINNED_RIGHT;
    var bodyCell = !pinnedLeftCell && !pinnedRightCell;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      if (this.columnModel.isPinningLeft()) {
        return !pinnedRightCell;
      }
      return !bodyCell;
    }
    if (this.columnModel.isPinningLeft()) {
      return !pinnedLeftCell;
    }
    return !bodyCell;
  };
  GroupCellRendererCtrl.prototype.findDisplayedGroupNode = function () {
    var column = this.params.column;
    var rowNode = this.params.node;
    if (this.showingValueForOpenedParent) {
      var pointer = rowNode.parent;
      while (pointer != null) {
        if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
          this.displayedGroupNode = pointer;
          break;
        }
        pointer = pointer.parent;
      }
    }
    // if we didn't find a displayed group, set it to the row node
    if (missing(this.displayedGroupNode)) {
      this.displayedGroupNode = rowNode;
    }
  };
  GroupCellRendererCtrl.prototype.setupShowingValueForOpenedParent = function () {
    // note - this code depends on sortService.updateGroupDataForHiddenOpenParents, where group data
    // is updated to reflect the dragged down parents
    var rowNode = this.params.node;
    var column = this.params.column;
    if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
      this.showingValueForOpenedParent = false;
      return;
    }
    // hideOpenParents means rowNode.groupData can have data for the group this column is displaying, even though
    // this rowNode isn't grouping by the column we are displaying
    // if no groupData at all, we are not showing a parent value
    if (!rowNode.groupData) {
      this.showingValueForOpenedParent = false;
      return;
    }
    // this is the normal case, in that we are showing a group for which this column is configured. note that
    // this means the Row Group is closed (if it was open, we would not be displaying it)
    var showingGroupNode = rowNode.rowGroupColumn != null;
    if (showingGroupNode) {
      var keyOfGroupingColumn = rowNode.rowGroupColumn.getId();
      var configuredToShowThisGroupLevel = column.isRowGroupDisplayed(keyOfGroupingColumn);
      // if showing group as normal, we didn't take group info from parent
      if (configuredToShowThisGroupLevel) {
        this.showingValueForOpenedParent = false;
        return;
      }
    }
    // see if we are showing a Group Value for the Displayed Group. if we are showing a group value, and this Row Node
    // is not grouping by this Displayed Group, we must of gotten the value from a parent node
    var valPresent = rowNode.groupData[column.getId()] != null;
    this.showingValueForOpenedParent = valPresent;
  };
  GroupCellRendererCtrl.prototype.addValueElement = function () {
    if (this.displayedGroupNode.footer) {
      this.addFooterValue();
    } else {
      this.addGroupValue();
      this.addChildCount();
    }
  };
  GroupCellRendererCtrl.prototype.addGroupValue = function () {
    // we try and use the cellRenderer of the column used for the grouping if we can
    var paramsAdjusted = this.adjustParamsWithDetailsFromRelatedColumn();
    var innerCompDetails = this.getInnerCompDetails(paramsAdjusted);
    var valueFormatted = paramsAdjusted.valueFormatted,
      value = paramsAdjusted.value;
    var valueWhenNoRenderer = valueFormatted != null ? valueFormatted : value;
    this.comp.setInnerRenderer(innerCompDetails, valueWhenNoRenderer);
  };
  GroupCellRendererCtrl.prototype.adjustParamsWithDetailsFromRelatedColumn = function () {
    var relatedColumn = this.displayedGroupNode.rowGroupColumn;
    var column = this.params.column;
    if (!relatedColumn) {
      return this.params;
    }
    var notFullWidth = column != null;
    if (notFullWidth) {
      var showingThisRowGroup = column.isRowGroupDisplayed(relatedColumn.getId());
      if (!showingThisRowGroup) {
        return this.params;
      }
    }
    var params = this.params;
    var _a = this.params,
      value = _a.value,
      scope = _a.scope,
      node = _a.node;
    var valueFormatted = this.valueFormatterService.formatValue(relatedColumn, node, scope, value);
    // we don't update the original params, as they could of come through React,
    // as react has RowGroupCellRenderer, which means the params could be props which
    // would be read only
    var paramsAdjusted = __assign$7(__assign$7({}, params), {
      valueFormatted: valueFormatted
    });
    return paramsAdjusted;
  };
  GroupCellRendererCtrl.prototype.addFooterValue = function () {
    var footerValueGetter = this.params.footerValueGetter;
    var footerValue = '';
    if (footerValueGetter) {
      // params is same as we were given, except we set the value as the item to display
      var paramsClone = cloneObject(this.params);
      paramsClone.value = this.params.value;
      if (typeof footerValueGetter === 'function') {
        footerValue = footerValueGetter(paramsClone);
      } else if (typeof footerValueGetter === 'string') {
        footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
      } else {
        console.warn('AG Grid: footerValueGetter should be either a function or a string (expression)');
      }
    } else {
      footerValue = 'Total ' + (this.params.value != null ? this.params.value : '');
    }
    var innerCompDetails = this.getInnerCompDetails(this.params);
    this.comp.setInnerRenderer(innerCompDetails, footerValue);
  };
  GroupCellRendererCtrl.prototype.getInnerCompDetails = function (params) {
    var _this = this;
    // for full width rows, we don't do any of the below
    if (params.fullWidth) {
      return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gridOptions.groupRowRendererParams, params);
    }
    // when grouping, the normal case is we use the cell renderer of the grouped column. eg if grouping by country
    // and then rating, we will use the country cell renderer for each country group row and likewise the rating
    // cell renderer for each rating group row.
    //
    // however if the user has innerCellRenderer defined, this gets preference and we don't use cell renderers
    // of the grouped columns.
    //
    // so we check and use in the following order:
    //
    // 1) thisColDef.cellRendererParams.innerRenderer of the column showing the groups (eg auto group column)
    // 2) groupedColDef.cellRenderer of the grouped column
    // 3) groupedColDef.cellRendererParams.innerRenderer
    // we check if cell renderer provided for the group cell renderer, eg colDef.cellRendererParams.innerRenderer
    var innerCompDetails = this.userComponentFactory.getInnerRendererDetails(params, params);
    // avoid using GroupCellRenderer again, otherwise stack overflow, as we insert same renderer again and again.
    // this covers off chance user is grouping by a column that is also configured with GroupCellRenderer
    var isGroupRowRenderer = function isGroupRowRenderer(details) {
      return details && details.componentClass == _this.compClass;
    };
    if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) {
      // use the renderer defined in cellRendererParams.innerRenderer
      return innerCompDetails;
    }
    var relatedColumn = this.displayedGroupNode.rowGroupColumn;
    var relatedColDef = relatedColumn ? relatedColumn.getColDef() : undefined;
    if (!relatedColDef) {
      return;
    }
    // otherwise see if we can use the cellRenderer of the column we are grouping by
    var relatedCompDetails = this.userComponentFactory.getCellRendererDetails(relatedColDef, params);
    if (relatedCompDetails && !isGroupRowRenderer(relatedCompDetails)) {
      // Only if the original column is using a specific renderer, it it is a using a DEFAULT one ignore it
      return relatedCompDetails;
    }
    if (isGroupRowRenderer(relatedCompDetails) && relatedColDef.cellRendererParams && relatedColDef.cellRendererParams.innerRenderer) {
      // edge case - this comes from a column which has been grouped dynamically, that has a renderer 'group'
      // and has an inner cell renderer
      var res = this.userComponentFactory.getInnerRendererDetails(relatedColDef.cellRendererParams, params);
      return res;
    }
  };
  GroupCellRendererCtrl.prototype.addChildCount = function () {
    // only include the child count if it's included, eg if user doing custom aggregation,
    // then this could be left out, or set to -1, ie no child count
    if (this.params.suppressCount) {
      return;
    }
    this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
    // filtering changes the child count, so need to cater for it
    this.updateChildCount();
  };
  GroupCellRendererCtrl.prototype.updateChildCount = function () {
    var allChildrenCount = this.displayedGroupNode.allChildrenCount;
    var showingGroupForThisNode = this.isShowRowGroupForThisRow();
    var showCount = showingGroupForThisNode && allChildrenCount != null && allChildrenCount >= 0;
    var countString = showCount ? "(" + allChildrenCount + ")" : "";
    this.comp.setChildCount(countString);
  };
  GroupCellRendererCtrl.prototype.isShowRowGroupForThisRow = function () {
    if (this.gridOptionsWrapper.isTreeData()) {
      return true;
    }
    var rowGroupColumn = this.displayedGroupNode.rowGroupColumn;
    if (!rowGroupColumn) {
      return false;
    }
    // column is null for fullWidthRows
    var column = this.params.column;
    var thisColumnIsInterested = column == null || column.isRowGroupDisplayed(rowGroupColumn.getId());
    return thisColumnIsInterested;
  };
  GroupCellRendererCtrl.prototype.addExpandAndContract = function () {
    var params = this.params;
    var eExpandedIcon = createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null);
    var eContractedIcon = createIconNoSpan('groupContracted', this.gridOptionsWrapper, null);
    if (eExpandedIcon) {
      this.eExpanded.appendChild(eExpandedIcon);
    }
    if (eContractedIcon) {
      this.eContracted.appendChild(eContractedIcon);
    }
    var eGroupCell = params.eGridCell;
    // if editing groups, then double click is to start editing
    if (!this.gridOptionsWrapper.isEnableGroupEdit() && this.isExpandable() && !params.suppressDoubleClickExpand) {
      this.addManagedListener(eGroupCell, 'dblclick', this.onCellDblClicked.bind(this));
    }
    this.addManagedListener(this.eExpanded, 'click', this.onExpandClicked.bind(this));
    this.addManagedListener(this.eContracted, 'click', this.onExpandClicked.bind(this));
    // expand / contract as the user hits enter
    this.addManagedListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
    this.addManagedListener(params.node, RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
    this.showExpandAndContractIcons();
    // because we don't show the expand / contract when there are no children, we need to check every time
    // the number of children change.
    var expandableChangedListener = this.onRowNodeIsExpandableChanged.bind(this);
    this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, expandableChangedListener);
    this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_MASTER_CHANGED, expandableChangedListener);
    this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_HAS_CHILDREN_CHANGED, expandableChangedListener);
  };
  GroupCellRendererCtrl.prototype.onExpandClicked = function (mouseEvent) {
    if (isStopPropagationForAgGrid(mouseEvent)) {
      return;
    }
    // so if we expand a node, it does not also get selected.
    stopPropagationForAgGrid(mouseEvent);
    this.onExpandOrContract();
  };
  GroupCellRendererCtrl.prototype.onExpandOrContract = function () {
    // must use the displayedGroup, so if data was dragged down, we expand the parent, not this row
    var rowNode = this.displayedGroupNode;
    var nextExpandState = !rowNode.expanded;
    rowNode.setExpanded(nextExpandState);
  };
  GroupCellRendererCtrl.prototype.isExpandable = function () {
    if (this.showingValueForOpenedParent) {
      return true;
    }
    var rowNode = this.displayedGroupNode;
    var reducedLeafNode = this.columnModel.isPivotMode() && rowNode.leafGroup;
    var expandableGroup = rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode;
    if (!expandableGroup) {
      return false;
    }
    // column is null for fullWidthRows
    var column = this.params.column;
    var displayingForOneColumnOnly = column != null && typeof column.getColDef().showRowGroup === 'string';
    if (displayingForOneColumnOnly) {
      var showing = this.isShowRowGroupForThisRow();
      return showing;
    }
    return true;
  };
  GroupCellRendererCtrl.prototype.showExpandAndContractIcons = function () {
    var _a = this,
      params = _a.params,
      displayedGroup = _a.displayedGroupNode,
      columnModel = _a.columnModel;
    var node = params.node;
    var isExpandable = this.isExpandable();
    if (isExpandable) {
      // if expandable, show one based on expand state.
      // if we were dragged down, means our parent is always expanded
      var expanded = this.showingValueForOpenedParent ? true : node.expanded;
      this.comp.setExpandedDisplayed(expanded);
      this.comp.setContractedDisplayed(!expanded);
    } else {
      // it not expandable, show neither
      this.comp.setExpandedDisplayed(false);
      this.comp.setContractedDisplayed(false);
    }
    // compensation padding for leaf nodes, so there is blank space instead of the expand icon
    var pivotMode = columnModel.isPivotMode();
    var pivotModeAndLeafGroup = pivotMode && displayedGroup.leafGroup;
    var addExpandableCss = isExpandable && !pivotModeAndLeafGroup;
    var isTotalFooterNode = node.footer && node.level === -1;
    this.comp.addOrRemoveCssClass('ag-cell-expandable', addExpandableCss);
    this.comp.addOrRemoveCssClass('ag-row-group', addExpandableCss);
    if (pivotMode) {
      this.comp.addOrRemoveCssClass('ag-pivot-leaf-group', pivotModeAndLeafGroup);
    } else if (!isTotalFooterNode) {
      this.comp.addOrRemoveCssClass('ag-row-group-leaf-indent', !addExpandableCss);
    }
  };
  GroupCellRendererCtrl.prototype.onRowNodeIsExpandableChanged = function () {
    // maybe if no children now, we should hide the expand / contract icons
    this.showExpandAndContractIcons();
    // if we have no children, this impacts the indent
    this.setIndent();
  };
  GroupCellRendererCtrl.prototype.setupIndent = function () {
    // only do this if an indent - as this overwrites the padding that
    // the theme set, which will make things look 'not aligned' for the
    // first group level.
    var node = this.params.node;
    var suppressPadding = this.params.suppressPadding;
    if (!suppressPadding) {
      this.addManagedListener(node, RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
      this.setIndent();
    }
  };
  GroupCellRendererCtrl.prototype.setIndent = function () {
    if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
      return;
    }
    var params = this.params;
    var rowNode = params.node;
    // if we are only showing one group column, we don't want to be indenting based on level
    var fullWithRow = !!params.colDef;
    var treeData = this.gridOptionsWrapper.isTreeData();
    var manyDimensionThisColumn = !fullWithRow || treeData || params.colDef.showRowGroup === true;
    var paddingCount = manyDimensionThisColumn ? rowNode.uiLevel : 0;
    var userProvidedPaddingPixelsTheDeprecatedWay = params.padding >= 0;
    if (userProvidedPaddingPixelsTheDeprecatedWay) {
      doOnce(function () {
        return console.warn('AG Grid: cellRendererParams.padding no longer works, it was deprecated in since v14.2 and removed in v26, configuring padding for groupCellRenderer should be done with Sass variables and themes. Please see the AG Grid documentation page for Themes, in particular the property $row-group-indent-size.');
      }, 'groupCellRenderer->doDeprecatedWay');
    }
    if (this.indentClass) {
      this.comp.addOrRemoveCssClass(this.indentClass, false);
    }
    this.indentClass = 'ag-row-group-indent-' + paddingCount;
    this.comp.addOrRemoveCssClass(this.indentClass, true);
  };
  GroupCellRendererCtrl.prototype.addFullWidthRowDraggerIfNeeded = function () {
    var _this = this;
    if (!this.params.fullWidth || !this.params.rowDrag) {
      return;
    }
    var rowDragComp = new RowDragComp(function () {
      return _this.params.value;
    }, this.params.node);
    this.createManagedBean(rowDragComp, this.context);
    this.eGui.insertAdjacentElement('afterbegin', rowDragComp.getGui());
  };
  GroupCellRendererCtrl.prototype.isUserWantsSelected = function () {
    var paramsCheckbox = this.params.checkbox;
    if (typeof paramsCheckbox === 'function') {
      return paramsCheckbox(this.params);
    }
    return paramsCheckbox === true;
  };
  GroupCellRendererCtrl.prototype.addCheckboxIfNeeded = function () {
    var _this = this;
    var rowNode = this.displayedGroupNode;
    var checkboxNeeded = this.isUserWantsSelected() &&
    // footers cannot be selected
    !rowNode.footer &&
    // pinned rows cannot be selected
    !rowNode.rowPinned &&
    // details cannot be selected
    !rowNode.detail;
    if (checkboxNeeded) {
      var cbSelectionComponent_1 = new CheckboxSelectionComponent();
      this.getContext().createBean(cbSelectionComponent_1);
      cbSelectionComponent_1.init({
        rowNode: rowNode,
        column: this.params.column
      });
      this.eCheckbox.appendChild(cbSelectionComponent_1.getGui());
      this.addDestroyFunc(function () {
        return _this.getContext().destroyBean(cbSelectionComponent_1);
      });
    }
    this.comp.setCheckboxVisible(checkboxNeeded);
  };
  GroupCellRendererCtrl.prototype.onKeyDown = function (event) {
    var enterKeyPressed = isKeyPressed(event, KeyCode.ENTER);
    if (!enterKeyPressed || this.params.suppressEnterExpand) {
      return;
    }
    var cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
    if (cellEditable) {
      return;
    }
    this.onExpandOrContract();
  };
  GroupCellRendererCtrl.prototype.onCellDblClicked = function (mouseEvent) {
    if (isStopPropagationForAgGrid(mouseEvent)) {
      return;
    }
    // we want to avoid acting on double click events on the expand / contract icon,
    // as that icons already has expand / collapse functionality on it. otherwise if
    // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
    // is open->close->open, however double click should be open->close only.
    var targetIsExpandIcon = isElementInEventPath(this.eExpanded, mouseEvent) || isElementInEventPath(this.eContracted, mouseEvent);
    if (!targetIsExpandIcon) {
      this.onExpandOrContract();
    }
  };
  __decorate$A([Autowired('expressionService')], GroupCellRendererCtrl.prototype, "expressionService", void 0);
  __decorate$A([Autowired('valueFormatterService')], GroupCellRendererCtrl.prototype, "valueFormatterService", void 0);
  __decorate$A([Autowired('columnModel')], GroupCellRendererCtrl.prototype, "columnModel", void 0);
  __decorate$A([Autowired('userComponentFactory')], GroupCellRendererCtrl.prototype, "userComponentFactory", void 0);
  __decorate$A([Autowired('gridOptions')], GroupCellRendererCtrl.prototype, "gridOptions", void 0);
  return GroupCellRendererCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$G = undefined && undefined.__extends || function () {
  var _extendStatics43 = function extendStatics(d, b) {
    _extendStatics43 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics43(d, b);
  };
  return function (d, b) {
    _extendStatics43(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$B = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupCellRenderer = /** @class */function (_super) {
  __extends$G(GroupCellRenderer, _super);
  function GroupCellRenderer() {
    return _super.call(this, GroupCellRenderer.TEMPLATE) || this;
  }
  GroupCellRenderer.prototype.init = function (params) {
    var _this = this;
    var compProxy = {
      setInnerRenderer: function setInnerRenderer(compDetails, valueToDisplay) {
        return _this.setRenderDetails(compDetails, valueToDisplay);
      },
      setChildCount: function setChildCount(count) {
        return _this.eChildCount.innerHTML = count;
      },
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClass, value) {
        return _this.addOrRemoveCssClass(cssClass, value);
      },
      setContractedDisplayed: function setContractedDisplayed(expanded) {
        return setDisplayed(_this.eContracted, expanded);
      },
      setExpandedDisplayed: function setExpandedDisplayed(expanded) {
        return setDisplayed(_this.eExpanded, expanded);
      },
      setCheckboxVisible: function setCheckboxVisible(visible) {
        return addOrRemoveCssClass(_this.eCheckbox, 'ag-invisible', !visible);
      }
    };
    var ctrl = this.createManagedBean(new GroupCellRendererCtrl());
    var fullWidth = !params.colDef;
    var eGui = this.getGui();
    ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);
    if (fullWidth) {
      setAriaRole(eGui, 'gridcell');
    }
  };
  GroupCellRenderer.prototype.setRenderDetails = function (compDetails, valueToDisplay) {
    var _this = this;
    if (compDetails) {
      var componentPromise = compDetails.newAgStackInstance();
      if (!componentPromise) {
        return;
      }
      componentPromise.then(function (comp) {
        if (!comp) {
          return;
        }
        var destroyComp = function destroyComp() {
          return _this.context.destroyBean(comp);
        };
        if (_this.isAlive()) {
          _this.eValue.appendChild(comp.getGui());
          _this.addDestroyFunc(destroyComp);
        } else {
          destroyComp();
        }
      });
    } else {
      this.eValue.innerText = valueToDisplay;
    }
  };
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to have public here instead of private or protected
  GroupCellRenderer.prototype.destroy = function () {
    this.getContext().destroyBean(this.innerCellRenderer);
    _super.prototype.destroy.call(this);
  };
  GroupCellRenderer.prototype.refresh = function () {
    return false;
  };
  GroupCellRenderer.TEMPLATE = "<span class=\"ag-cell-wrapper\">\n            <span class=\"ag-group-expanded\" ref=\"eExpanded\"></span>\n            <span class=\"ag-group-contracted\" ref=\"eContracted\"></span>\n            <span class=\"ag-group-checkbox ag-invisible\" ref=\"eCheckbox\"></span>\n            <span class=\"ag-group-value\" ref=\"eValue\"></span>\n            <span class=\"ag-group-child-count\" ref=\"eChildCount\"></span>\n        </span>";
  __decorate$B([Autowired('userComponentFactory')], GroupCellRenderer.prototype, "userComponentFactory", void 0);
  __decorate$B([RefSelector('eExpanded')], GroupCellRenderer.prototype, "eExpanded", void 0);
  __decorate$B([RefSelector('eContracted')], GroupCellRenderer.prototype, "eContracted", void 0);
  __decorate$B([RefSelector('eCheckbox')], GroupCellRenderer.prototype, "eCheckbox", void 0);
  __decorate$B([RefSelector('eValue')], GroupCellRenderer.prototype, "eValue", void 0);
  __decorate$B([RefSelector('eChildCount')], GroupCellRenderer.prototype, "eChildCount", void 0);
  return GroupCellRenderer;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$H = undefined && undefined.__extends || function () {
  var _extendStatics44 = function extendStatics(d, b) {
    _extendStatics44 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics44(d, b);
  };
  return function (d, b) {
    _extendStatics44(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$C = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LoadingCellRenderer = /** @class */function (_super) {
  __extends$H(LoadingCellRenderer, _super);
  function LoadingCellRenderer() {
    return _super.call(this, LoadingCellRenderer.TEMPLATE) || this;
  }
  LoadingCellRenderer.prototype.init = function (params) {
    params.node.failedLoad ? this.setupFailed() : this.setupLoading();
  };
  LoadingCellRenderer.prototype.setupFailed = function () {
    this.eLoadingText.innerText = 'ERR';
  };
  LoadingCellRenderer.prototype.setupLoading = function () {
    var eLoadingIcon = createIconNoSpan('groupLoading', this.gridOptionsWrapper, null);
    if (eLoadingIcon) {
      this.eLoadingIcon.appendChild(eLoadingIcon);
    }
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eLoadingText.innerText = localeTextFunc('loadingOoo', 'Loading');
  };
  LoadingCellRenderer.prototype.refresh = function (params) {
    return false;
  };
  LoadingCellRenderer.TEMPLATE = "<div class=\"ag-loading\">\n            <span class=\"ag-loading-icon\" ref=\"eLoadingIcon\"></span>\n            <span class=\"ag-loading-text\" ref=\"eLoadingText\"></span>\n        </div>";
  __decorate$C([RefSelector('eLoadingIcon')], LoadingCellRenderer.prototype, "eLoadingIcon", void 0);
  __decorate$C([RefSelector('eLoadingText')], LoadingCellRenderer.prototype, "eLoadingText", void 0);
  return LoadingCellRenderer;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$I = undefined && undefined.__extends || function () {
  var _extendStatics45 = function extendStatics(d, b) {
    _extendStatics45 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics45(d, b);
  };
  return function (d, b) {
    _extendStatics45(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var LoadingOverlayComponent = /** @class */function (_super) {
  __extends$I(LoadingOverlayComponent, _super);
  function LoadingOverlayComponent() {
    return _super.call(this) || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  LoadingOverlayComponent.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  LoadingOverlayComponent.prototype.init = function (params) {
    var template = this.gridOptionsWrapper.getOverlayLoadingTemplate() ? this.gridOptionsWrapper.getOverlayLoadingTemplate() : LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE;
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var localisedTemplate = template.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
    this.setTemplate(localisedTemplate);
  };
  LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
  return LoadingOverlayComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$J = undefined && undefined.__extends || function () {
  var _extendStatics46 = function extendStatics(d, b) {
    _extendStatics46 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics46(d, b);
  };
  return function (d, b) {
    _extendStatics46(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var NoRowsOverlayComponent = /** @class */function (_super) {
  __extends$J(NoRowsOverlayComponent, _super);
  function NoRowsOverlayComponent() {
    return _super.call(this) || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  NoRowsOverlayComponent.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  NoRowsOverlayComponent.prototype.init = function (params) {
    var template = this.gridOptionsWrapper.getOverlayNoRowsTemplate() ? this.gridOptionsWrapper.getOverlayNoRowsTemplate() : NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE;
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var localisedTemplate = template.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
    this.setTemplate(localisedTemplate);
  };
  NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
  return NoRowsOverlayComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$K = undefined && undefined.__extends || function () {
  var _extendStatics47 = function extendStatics(d, b) {
    _extendStatics47 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics47(d, b);
  };
  return function (d, b) {
    _extendStatics47(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TooltipComponent = /** @class */function (_super) {
  __extends$K(TooltipComponent, _super);
  function TooltipComponent() {
    return _super.call(this, /* html */"<div class=\"ag-tooltip\"></div>") || this;
  }
  // will need to type params
  TooltipComponent.prototype.init = function (params) {
    var value = params.value;
    this.getGui().innerHTML = escapeString(value);
  };
  return TooltipComponent;
}(PopupComponent);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$L = undefined && undefined.__extends || function () {
  var _extendStatics48 = function extendStatics(d, b) {
    _extendStatics48 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics48(d, b);
  };
  return function (d, b) {
    _extendStatics48(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$D = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserComponentRegistry = /** @class */function (_super) {
  __extends$L(UserComponentRegistry, _super);
  function UserComponentRegistry() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.agGridDefaults = {
      //date
      agDateInput: DefaultDateComponent,
      //header
      agColumnHeader: HeaderComp,
      agColumnGroupHeader: HeaderGroupComp,
      //floating filters
      agTextColumnFloatingFilter: TextFloatingFilter,
      agNumberColumnFloatingFilter: NumberFloatingFilter,
      agDateColumnFloatingFilter: DateFloatingFilter,
      agReadOnlyFloatingFilter: ReadOnlyFloatingFilter,
      // renderers
      agAnimateShowChangeCellRenderer: AnimateShowChangeCellRenderer,
      agAnimateSlideCellRenderer: AnimateSlideCellRenderer,
      agGroupCellRenderer: GroupCellRenderer,
      agGroupRowRenderer: GroupCellRenderer,
      agLoadingCellRenderer: LoadingCellRenderer,
      //editors
      agCellEditor: TextCellEditor,
      agTextCellEditor: TextCellEditor,
      agSelectCellEditor: SelectCellEditor,
      agPopupTextCellEditor: PopupTextCellEditor,
      agPopupSelectCellEditor: PopupSelectCellEditor,
      agLargeTextCellEditor: LargeTextCellEditor,
      //filter
      agTextColumnFilter: TextFilter,
      agNumberColumnFilter: NumberFilter,
      agDateColumnFilter: DateFilter,
      //overlays
      agLoadingOverlay: LoadingOverlayComponent,
      agNoRowsOverlay: NoRowsOverlayComponent,
      // tooltips
      agTooltipComponent: TooltipComponent
    };
    _this.agDeprecatedNames = {
      set: {
        newComponentName: 'agSetColumnFilter',
        propertyHolder: 'filter'
      },
      text: {
        newComponentName: 'agTextColumnFilter',
        propertyHolder: 'filter'
      },
      number: {
        newComponentName: 'agNumberColumnFilter',
        propertyHolder: 'filter'
      },
      date: {
        newComponentName: 'agDateColumnFilter',
        propertyHolder: 'filter'
      },
      group: {
        newComponentName: 'agGroupCellRenderer',
        propertyHolder: 'cellRenderer'
      },
      animateShowChange: {
        newComponentName: 'agAnimateShowChangeCellRenderer',
        propertyHolder: 'cellRenderer'
      },
      animateSlide: {
        newComponentName: 'agAnimateSlideCellRenderer',
        propertyHolder: 'cellRenderer'
      },
      select: {
        newComponentName: 'agSelectCellEditor',
        propertyHolder: 'cellEditor'
      },
      largeText: {
        newComponentName: 'agLargeTextCellEditor',
        propertyHolder: 'cellEditor'
      },
      popupSelect: {
        newComponentName: 'agPopupSelectCellEditor',
        propertyHolder: 'cellEditor'
      },
      popupText: {
        newComponentName: 'agPopupTextCellEditor',
        propertyHolder: 'cellEditor'
      },
      richSelect: {
        newComponentName: 'agRichSelectCellEditor',
        propertyHolder: 'cellEditor'
      },
      headerComponent: {
        newComponentName: 'agColumnHeader',
        propertyHolder: 'headerComponent'
      }
    };
    _this.jsComponents = {};
    _this.frameworkComponents = {};
    return _this;
  }
  UserComponentRegistry.prototype.init = function () {
    var _this = this;
    if (this.gridOptions.components != null) {
      iterateObject(this.gridOptions.components, function (key, component) {
        return _this.registerComponent(key, component);
      });
    }
    if (this.gridOptions.frameworkComponents != null) {
      iterateObject(this.gridOptions.frameworkComponents, function (key, component) {
        return _this.registerFwComponent(key, component);
      });
    }
  };
  UserComponentRegistry.prototype.registerDefaultComponent = function (rawName, component) {
    var name = this.translateIfDeprecated(rawName);
    if (this.agGridDefaults[name]) {
      console.error("Trying to overwrite a default component. You should call registerComponent");
      return;
    }
    this.agGridDefaults[name] = component;
  };
  UserComponentRegistry.prototype.registerComponent = function (rawName, component) {
    var name = this.translateIfDeprecated(rawName);
    if (this.frameworkComponents[name]) {
      console.error("Trying to register a component that you have already registered for frameworks: " + name);
      return;
    }
    this.jsComponents[name] = component;
  };
  /**
   * B the business interface (ie IHeader)
   * A the agGridComponent interface (ie IHeaderComp). The final object acceptable by ag-grid
   */
  UserComponentRegistry.prototype.registerFwComponent = function (rawName, component) {
    var name = this.translateIfDeprecated(rawName);
    if (this.jsComponents[name]) {
      console.error("Trying to register a component that you have already registered for plain javascript: " + name);
      return;
    }
    this.frameworkComponents[name] = component;
  };
  UserComponentRegistry.prototype.retrieve = function (rawName) {
    var name = this.translateIfDeprecated(rawName);
    var frameworkComponent = this.frameworkComponents[name] || this.getFrameworkOverrides().frameworkComponent(name);
    if (frameworkComponent) {
      return {
        componentFromFramework: true,
        component: frameworkComponent
      };
    }
    var jsComponent = this.jsComponents[name];
    if (jsComponent) {
      return {
        componentFromFramework: false,
        component: jsComponent
      };
    }
    var defaultComponent = this.agGridDefaults[name];
    if (defaultComponent) {
      return {
        componentFromFramework: false,
        component: defaultComponent
      };
    }
    if (Object.keys(this.agGridDefaults).indexOf(name) < 0) {
      console.warn("AG Grid: Looking for component [" + name + "] but it wasn't found.");
    }
    return null;
  };
  UserComponentRegistry.prototype.translateIfDeprecated = function (raw) {
    var deprecatedInfo = this.agDeprecatedNames[raw];
    if (deprecatedInfo != null) {
      doOnce(function () {
        console.warn("ag-grid. Since v15.0 component names have been renamed to be namespaced. You should rename " + deprecatedInfo.propertyHolder + ":" + raw + " to " + deprecatedInfo.propertyHolder + ":" + deprecatedInfo.newComponentName);
      }, 'DEPRECATE_COMPONENT_' + raw);
      return deprecatedInfo.newComponentName;
    }
    return raw;
  };
  __decorate$D([Autowired('gridOptions')], UserComponentRegistry.prototype, "gridOptions", void 0);
  __decorate$D([PostConstruct], UserComponentRegistry.prototype, "init", null);
  UserComponentRegistry = __decorate$D([Bean('userComponentRegistry')], UserComponentRegistry);
  return UserComponentRegistry;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var DateComponent = {
  propertyName: 'dateComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var HeaderComponent = {
  propertyName: 'headerComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var HeaderGroupComponent = {
  propertyName: 'headerGroupComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var CellRendererComponent = {
  propertyName: 'cellRenderer',
  isCellRenderer: function isCellRenderer() {
    return true;
  }
};
var CellEditorComponent = {
  propertyName: 'cellEditor',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var InnerRendererComponent = {
  propertyName: 'innerRenderer',
  isCellRenderer: function isCellRenderer() {
    return true;
  }
};
var LoadingOverlayComponent$1 = {
  propertyName: 'loadingOverlayComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var NoRowsOverlayComponent$1 = {
  propertyName: 'noRowsOverlayComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var TooltipComponent$1 = {
  propertyName: 'tooltipComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var FilterComponent = {
  propertyName: 'filter',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var FloatingFilterComponent = {
  propertyName: 'floatingFilterComponent',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var ToolPanelComponent = {
  propertyName: 'toolPanel',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};
var StatusPanelComponent = {
  propertyName: 'statusPanel',
  isCellRenderer: function isCellRenderer() {
    return false;
  }
};

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$M = undefined && undefined.__extends || function () {
  var _extendStatics49 = function extendStatics(d, b) {
    _extendStatics49 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics49(d, b);
  };
  return function (d, b) {
    _extendStatics49(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$E = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserComponentFactory = /** @class */function (_super) {
  __extends$M(UserComponentFactory, _super);
  function UserComponentFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UserComponentFactory.prototype.getHeaderCompDetails = function (colDef, params) {
    return this.getCompDetails(colDef, HeaderComponent, 'agColumnHeader', params);
  };
  UserComponentFactory.prototype.getHeaderGroupCompDetails = function (params) {
    var colGroupDef = params.columnGroup.getColGroupDef();
    return this.getCompDetails(colGroupDef, HeaderGroupComponent, 'agColumnGroupHeader', params);
  };
  // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
  // so we have to pass the type in.
  UserComponentFactory.prototype.getFullWidthCellRendererDetails = function (params, cellRendererType, cellRendererName) {
    return this.getCompDetails(this.gridOptions, {
      propertyName: cellRendererType,
      isCellRenderer: function isCellRenderer() {
        return true;
      }
    }, cellRendererName, params);
  };
  // CELL RENDERER
  UserComponentFactory.prototype.getInnerRendererDetails = function (def, params) {
    return this.getCompDetails(def, InnerRendererComponent, null, params);
  };
  UserComponentFactory.prototype.getFullWidthGroupRowInnerCellRenderer = function (def, params) {
    return this.getCompDetails(def, InnerRendererComponent, null, params);
  };
  UserComponentFactory.prototype.getCellRendererDetails = function (def, params) {
    return this.getCompDetails(def, CellRendererComponent, null, params);
  };
  // CELL EDITOR
  UserComponentFactory.prototype.getCellEditorDetails = function (def, params) {
    return this.getCompDetails(def, CellEditorComponent, 'agCellEditor', params, true);
  };
  // FILTER
  UserComponentFactory.prototype.getFilterDetails = function (def, params, defaultFilter) {
    return this.getCompDetails(def, FilterComponent, defaultFilter, params, true);
  };
  UserComponentFactory.prototype.getDateCompDetails = function (params) {
    return this.getCompDetails(this.gridOptions, DateComponent, 'agDateInput', params, true);
  };
  UserComponentFactory.prototype.getLoadingOverlayCompDetails = function (params) {
    return this.getCompDetails(this.gridOptions, LoadingOverlayComponent$1, 'agLoadingOverlay', params, true);
  };
  UserComponentFactory.prototype.getNoRowsOverlayCompDetails = function (params) {
    return this.getCompDetails(this.gridOptions, NoRowsOverlayComponent$1, 'agNoRowsOverlay', params, true);
  };
  UserComponentFactory.prototype.getTooltipCompDetails = function (params) {
    return this.getCompDetails(params.colDef, TooltipComponent$1, 'agTooltipComponent', params, true);
  };
  UserComponentFactory.prototype.getSetFilterCellRendererDetails = function (def, params) {
    return this.getCompDetails(def, CellRendererComponent, null, params);
  };
  UserComponentFactory.prototype.getFloatingFilterCompDetails = function (def, params, defaultFloatingFilter) {
    return this.getCompDetails(def, FloatingFilterComponent, defaultFloatingFilter, params);
  };
  UserComponentFactory.prototype.getToolPanelCompDetails = function (toolPanelDef, params) {
    return this.getCompDetails(toolPanelDef, ToolPanelComponent, null, params, true);
  };
  UserComponentFactory.prototype.getStatusPanelCompDetails = function (def, params) {
    return this.getCompDetails(def, StatusPanelComponent, null, params, true);
  };
  UserComponentFactory.prototype.getCompDetails = function (defObject, type, defaultName, params, mandatory) {
    var _this = this;
    if (mandatory === void 0) {
      mandatory = false;
    }
    var propertyName = type.propertyName;
    var comp;
    var frameworkComp;
    var paramsFromSelector;
    // pull from defObject if available
    if (defObject) {
      var defObjectAny = defObject;
      // if selector, use this
      var selectorFunc = defObjectAny[propertyName + 'Selector'];
      var selectorRes = selectorFunc ? selectorFunc(params) : null;
      if (selectorRes) {
        comp = selectorRes.component;
        frameworkComp = selectorRes.frameworkComponent;
        paramsFromSelector = selectorRes.params;
      } else {
        // if no selector, or result of selector is empty, take from defObject
        comp = defObjectAny[propertyName];
        frameworkComp = defObjectAny[propertyName + 'Framework'];
      }
      // for filters only, we allow 'true' for the component, which means default filter to be used
      if (comp === true) {
        comp = undefined;
      }
    }
    var lookupFromRegistry = function lookupFromRegistry(key) {
      var item = _this.userComponentRegistry.retrieve(key);
      if (item) {
        comp = !item.componentFromFramework ? item.component : undefined;
        frameworkComp = item.componentFromFramework ? item.component : undefined;
      } else {
        comp = undefined;
        frameworkComp = undefined;
      }
    };
    // if compOption is a string, means we need to look the item up
    if (typeof comp === 'string') {
      lookupFromRegistry(comp);
    }
    // if lookup brought nothing back, and we have a default, lookup the default
    if (comp == null && frameworkComp == null && defaultName != null) {
      lookupFromRegistry(defaultName);
    }
    // if we have a comp option, and it's a function, replace it with an object equivalent adaptor
    if (comp && !this.agComponentUtils.doesImplementIComponent(comp)) {
      comp = this.agComponentUtils.adaptFunction(propertyName, comp);
    }
    if (!comp && !frameworkComp) {
      if (mandatory) {
        var overrideName = defObject ? defObject[propertyName] : defaultName;
        var nameToReport = overrideName ? overrideName : defaultName;
        console.error("Could not find component " + nameToReport + ", did you forget to configure this component?");
      }
      return;
    }
    var paramsMerged = this.mergeParamsWithApplicationProvidedParams(defObject, propertyName, params, paramsFromSelector);
    var componentFromFramework = comp == null;
    var componentClass = comp ? comp : frameworkComp;
    return {
      componentFromFramework: componentFromFramework,
      componentClass: componentClass,
      params: paramsMerged,
      type: type,
      newAgStackInstance: function newAgStackInstance(defaultCompName) {
        return _this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type, defaultCompName);
      }
    };
  };
  UserComponentFactory.prototype.newAgStackInstance = function (ComponentClass, componentFromFramework, params, type, defaultComponentName) {
    var propertyName = type.propertyName;
    // using javascript component
    var instance;
    var jsComponent = !componentFromFramework;
    if (jsComponent) {
      instance = new ComponentClass();
    } else {
      // Using framework component
      var thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
      instance = this.frameworkComponentWrapper.wrap(ComponentClass, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, type, defaultComponentName);
    }
    var deferredInit = this.initComponent(instance, params);
    if (deferredInit == null) {
      return AgPromise.resolve(instance);
    }
    return deferredInit.then(function () {
      return instance;
    });
  };
  // used by Floating Filter
  UserComponentFactory.prototype.mergeParamsWithApplicationProvidedParams = function (defObject, propertyName, paramsFromGrid, paramsFromSelector) {
    if (paramsFromSelector === void 0) {
      paramsFromSelector = null;
    }
    var params = {};
    mergeDeep(params, paramsFromGrid);
    var userParams = defObject ? defObject[propertyName + "Params"] : null;
    if (userParams != null) {
      if (typeof userParams === 'function') {
        var userParamsFromFunc = userParams(paramsFromGrid);
        mergeDeep(params, userParamsFromFunc);
      } else if (typeof userParams === 'object') {
        mergeDeep(params, userParams);
      }
    }
    mergeDeep(params, paramsFromSelector);
    return params;
  };
  UserComponentFactory.prototype.initComponent = function (component, params) {
    this.context.createBean(component);
    if (component.init == null) {
      return;
    }
    return component.init(params);
  };
  __decorate$E([Autowired('gridOptions')], UserComponentFactory.prototype, "gridOptions", void 0);
  __decorate$E([Autowired('agComponentUtils')], UserComponentFactory.prototype, "agComponentUtils", void 0);
  __decorate$E([Autowired('componentMetadataProvider')], UserComponentFactory.prototype, "componentMetadataProvider", void 0);
  __decorate$E([Autowired('userComponentRegistry')], UserComponentFactory.prototype, "userComponentRegistry", void 0);
  __decorate$E([Optional('frameworkComponentWrapper')], UserComponentFactory.prototype, "frameworkComponentWrapper", void 0);
  UserComponentFactory = __decorate$E([Bean('userComponentFactory')], UserComponentFactory);
  return UserComponentFactory;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var SideBarDefParser = /** @class */function () {
  function SideBarDefParser() {}
  SideBarDefParser.parse = function (toParse) {
    if (!toParse) {
      return null;
    }
    if (toParse === true) {
      return {
        toolPanels: [SideBarDefParser.DEFAULT_COLUMN_COMP, SideBarDefParser.DEFAULT_FILTER_COMP],
        defaultToolPanel: 'columns'
      };
    }
    if (typeof toParse === 'string') {
      return SideBarDefParser.parse([toParse]);
    }
    if (Array.isArray(toParse)) {
      var comps_1 = [];
      toParse.forEach(function (key) {
        var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[key];
        if (!lookupResult) {
          console.warn("ag-grid: the key " + key + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
          return;
        }
        comps_1.push(lookupResult);
      });
      if (comps_1.length === 0) {
        return null;
      }
      return {
        toolPanels: comps_1,
        defaultToolPanel: comps_1[0].id
      };
    }
    var result = {
      toolPanels: SideBarDefParser.parseComponents(toParse.toolPanels),
      defaultToolPanel: toParse.defaultToolPanel,
      hiddenByDefault: toParse.hiddenByDefault,
      position: toParse.position
    };
    return result;
  };
  SideBarDefParser.parseComponents = function (from) {
    var result = [];
    if (!from) {
      return result;
    }
    from.forEach(function (it) {
      var toAdd = null;
      if (typeof it === 'string') {
        var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[it];
        if (!lookupResult) {
          console.warn("ag-grid: the key " + it + " is not a valid key for specifying a tool panel, valid keys are: " + Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','));
          return;
        }
        toAdd = lookupResult;
      } else {
        toAdd = it;
      }
      result.push(toAdd);
    });
    return result;
  };
  SideBarDefParser.DEFAULT_COLUMN_COMP = {
    id: 'columns',
    labelDefault: 'Columns',
    labelKey: 'columns',
    iconKey: 'columns',
    toolPanel: 'agColumnsToolPanel'
  };
  SideBarDefParser.DEFAULT_FILTER_COMP = {
    id: 'filters',
    labelDefault: 'Filters',
    labelKey: 'filters',
    iconKey: 'filter',
    toolPanel: 'agFiltersToolPanel'
  };
  SideBarDefParser.DEFAULT_BY_KEY = {
    columns: SideBarDefParser.DEFAULT_COLUMN_COMP,
    filters: SideBarDefParser.DEFAULT_FILTER_COMP
  };
  return SideBarDefParser;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$F = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$3 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var __spreadArrays$5 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var DEFAULT_ROW_HEIGHT = 25;
var DEFAULT_DETAIL_ROW_HEIGHT = 300;
var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
var DEFAULT_KEEP_DETAIL_ROW_COUNT = 10;
function isTrue(value) {
  return value === true || value === 'true';
}
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (typeof value == 'string') {
    return parseInt(value, 10);
  }
}
function zeroOrGreater(value, defaultValue) {
  if (value >= 0) {
    return value;
  }
  // zero gets returned if number is missing or the wrong type
  return defaultValue;
}
function oneOrGreater(value, defaultValue) {
  var valueNumber = parseInt(value, 10);
  if (isNumeric(valueNumber) && valueNumber > 0) {
    return valueNumber;
  }
  return defaultValue;
}
var GridOptionsWrapper = /** @class */function () {
  function GridOptionsWrapper() {
    this.propertyEventService = new EventService();
    this.domDataKey = '__AG_' + Math.random().toString();
    this.destroyed = false;
  }
  GridOptionsWrapper_1 = GridOptionsWrapper;
  GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
    this.gridOptions.api = gridApi;
    this.gridOptions.columnApi = columnApi;
    this.checkForDeprecated();
    this.checkForViolations();
  };
  GridOptionsWrapper.prototype.destroy = function () {
    // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
    // remove the references in case the user keeps the grid options, we want the rest
    // of the grid to be picked up by the garbage collector
    this.gridOptions.api = null;
    this.gridOptions.columnApi = null;
    this.destroyed = true;
  };
  GridOptionsWrapper.prototype.init = function () {
    var _this = this;
    if (this.gridOptions.suppressPropertyNamesCheck !== true) {
      this.checkGridOptionsProperties();
      this.checkColumnDefProperties();
    }
    // parse side bar options into correct format
    if (this.gridOptions.sideBar != null) {
      this.gridOptions.sideBar = SideBarDefParser.parse(this.gridOptions.sideBar);
    }
    var async = this.useAsyncEvents();
    this.eventService.addGlobalListener(this.globalEventHandler.bind(this), async);
    if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
      console.warn("AG Grid: 'groupSelectsChildren' does not work with 'suppressParentsInRowNodes', this selection method needs the part in rowNode to work");
    }
    if (this.isGroupSelectsChildren()) {
      if (!this.isRowSelectionMulti()) {
        console.warn("AG Grid: rowSelection must be 'multiple' for groupSelectsChildren to make sense");
      }
      if (this.isRowModelServerSide()) {
        console.warn('AG Grid: group selects children is NOT support for Server Side Row Model. ' + 'This is because the rows are lazy loaded, so selecting a group is not possible as' + 'the grid has no way of knowing what the children are.');
      }
    }
    if (this.isGroupRemoveSingleChildren() && this.isGroupHideOpenParents()) {
      console.warn("AG Grid: groupRemoveSingleChildren and groupHideOpenParents do not work with each other, you need to pick one. And don't ask us how to us these together on our support forum either you will get the same answer!");
    }
    if (this.isRowModelServerSide()) {
      var msg = function msg(prop) {
        return "AG Grid: '" + prop + "' is not supported on the Server-Side Row Model";
      };
      if (exists(this.gridOptions.groupDefaultExpanded)) {
        console.warn(msg('groupDefaultExpanded'));
      }
      if (exists(this.gridOptions.groupDefaultExpanded)) {
        console.warn(msg('groupIncludeFooter'));
      }
      if (exists(this.gridOptions.groupDefaultExpanded)) {
        console.warn(msg('groupIncludeTotalFooter'));
      }
    }
    if (this.isEnableRangeSelection()) {
      ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'enableRangeSelection');
    }
    if (!this.isEnableRangeSelection() && (this.isEnableRangeHandle() || this.isEnableFillHandle())) {
      console.warn("AG Grid: 'enableRangeHandle' and 'enableFillHandle' will not work unless 'enableRangeSelection' is set to true");
    }
    var warnOfDeprecaredIcon = function warnOfDeprecaredIcon(name) {
      if (_this.gridOptions.icons && _this.gridOptions.icons[name]) {
        console.warn("gridOptions.icons." + name + " is no longer supported. For information on how to style checkboxes and radio buttons, see https://www.ag-grid.com/javascript-grid-icons/");
      }
    };
    warnOfDeprecaredIcon('radioButtonOff');
    warnOfDeprecaredIcon('radioButtonOn');
    warnOfDeprecaredIcon('checkboxChecked');
    warnOfDeprecaredIcon('checkboxUnchecked');
    warnOfDeprecaredIcon('checkboxIndeterminate');
    // sets an initial calculation for the scrollbar width
    this.getScrollbarWidth();
  };
  GridOptionsWrapper.prototype.checkColumnDefProperties = function () {
    var _this = this;
    if (this.gridOptions.columnDefs == null) {
      return;
    }
    this.gridOptions.columnDefs.forEach(function (colDef) {
      var userProperties = Object.getOwnPropertyNames(colDef);
      var validProperties = __spreadArrays$5(ColDefUtil.ALL_PROPERTIES, ColDefUtil.FRAMEWORK_PROPERTIES);
      _this.checkProperties(userProperties, validProperties, validProperties, 'colDef', 'https://www.ag-grid.com/javascript-grid-column-properties/');
    });
  };
  GridOptionsWrapper.prototype.checkGridOptionsProperties = function () {
    var userProperties = Object.getOwnPropertyNames(this.gridOptions);
    var validProperties = __spreadArrays$5(PropertyKeys.ALL_PROPERTIES, PropertyKeys.FRAMEWORK_PROPERTIES, values(Events).map(function (event) {
      return ComponentUtil.getCallbackForEvent(event);
    }));
    var validPropertiesAndExceptions = __spreadArrays$5(validProperties, ['api', 'columnApi']);
    this.checkProperties(userProperties, validPropertiesAndExceptions, validProperties, 'gridOptions', 'https://www.ag-grid.com/javascript-grid-properties/');
  };
  GridOptionsWrapper.prototype.checkProperties = function (userProperties, validPropertiesAndExceptions, validProperties, containerName, docsUrl) {
    var invalidProperties = fuzzyCheckStrings(userProperties, validPropertiesAndExceptions, validProperties);
    iterateObject(invalidProperties, function (key, value) {
      console.warn("ag-grid: invalid " + containerName + " property '" + key + "' did you mean any of these: " + value.slice(0, 8).join(", "));
    });
    if (Object.keys(invalidProperties).length > 0) {
      console.warn("ag-grid: to see all the valid " + containerName + " properties please check: " + docsUrl);
    }
  };
  GridOptionsWrapper.prototype.getDomDataKey = function () {
    return this.domDataKey;
  };
  // returns the dom data, or undefined if not found
  GridOptionsWrapper.prototype.getDomData = function (element, key) {
    var domData = element[this.getDomDataKey()];
    return domData ? domData[key] : undefined;
  };
  GridOptionsWrapper.prototype.setDomData = function (element, key, value) {
    var domDataKey = this.getDomDataKey();
    var domData = element[domDataKey];
    if (missing(domData)) {
      domData = {};
      element[domDataKey] = domData;
    }
    domData[key] = value;
  };
  GridOptionsWrapper.prototype.isRowSelection = function () {
    return this.gridOptions.rowSelection === 'single' || this.gridOptions.rowSelection === 'multiple';
  };
  GridOptionsWrapper.prototype.isSuppressRowDeselection = function () {
    return isTrue(this.gridOptions.suppressRowDeselection);
  };
  GridOptionsWrapper.prototype.isRowSelectionMulti = function () {
    return this.gridOptions.rowSelection === 'multiple';
  };
  GridOptionsWrapper.prototype.isRowMultiSelectWithClick = function () {
    return isTrue(this.gridOptions.rowMultiSelectWithClick);
  };
  GridOptionsWrapper.prototype.getContext = function () {
    return this.gridOptions.context;
  };
  GridOptionsWrapper.prototype.isPivotMode = function () {
    return isTrue(this.gridOptions.pivotMode);
  };
  GridOptionsWrapper.prototype.isSuppressExpandablePivotGroups = function () {
    return isTrue(this.gridOptions.suppressExpandablePivotGroups);
  };
  GridOptionsWrapper.prototype.getPivotColumnGroupTotals = function () {
    return this.gridOptions.pivotColumnGroupTotals;
  };
  GridOptionsWrapper.prototype.getPivotRowTotals = function () {
    return this.gridOptions.pivotRowTotals;
  };
  GridOptionsWrapper.prototype.isRowModelInfinite = function () {
    return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_INFINITE;
  };
  GridOptionsWrapper.prototype.isRowModelViewport = function () {
    return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_VIEWPORT;
  };
  GridOptionsWrapper.prototype.isRowModelServerSide = function () {
    return this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE;
  };
  GridOptionsWrapper.prototype.isRowModelDefault = function () {
    return missing(this.gridOptions.rowModelType) || this.gridOptions.rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
  };
  GridOptionsWrapper.prototype.isFullRowEdit = function () {
    return this.gridOptions.editType === 'fullRow';
  };
  GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () {
    return isTrue(this.gridOptions.suppressFocusAfterRefresh);
  };
  GridOptionsWrapper.prototype.isSuppressBrowserResizeObserver = function () {
    return isTrue(this.gridOptions.suppressBrowserResizeObserver);
  };
  GridOptionsWrapper.prototype.isSuppressMaintainUnsortedOrder = function () {
    return isTrue(this.gridOptions.suppressMaintainUnsortedOrder);
  };
  GridOptionsWrapper.prototype.isSuppressClearOnFillReduction = function () {
    return isTrue(this.gridOptions.suppressClearOnFillReduction);
  };
  GridOptionsWrapper.prototype.isShowToolPanel = function () {
    return isTrue(this.gridOptions.sideBar && Array.isArray(this.getSideBar().toolPanels));
  };
  GridOptionsWrapper.prototype.getSideBar = function () {
    return this.gridOptions.sideBar;
  };
  GridOptionsWrapper.prototype.isSuppressTouch = function () {
    return isTrue(this.gridOptions.suppressTouch);
  };
  GridOptionsWrapper.prototype.isMaintainColumnOrder = function () {
    return isTrue(this.gridOptions.maintainColumnOrder);
  };
  GridOptionsWrapper.prototype.isSuppressRowTransform = function () {
    return isTrue(this.gridOptions.suppressRowTransform);
  };
  GridOptionsWrapper.prototype.isSuppressColumnStateEvents = function () {
    return isTrue(this.gridOptions.suppressColumnStateEvents);
  };
  GridOptionsWrapper.prototype.isAllowDragFromColumnsToolPanel = function () {
    return isTrue(this.gridOptions.allowDragFromColumnsToolPanel);
  };
  GridOptionsWrapper.prototype.useAsyncEvents = function () {
    return !isTrue(this.gridOptions.suppressAsyncEvents);
  };
  GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () {
    return isTrue(this.gridOptions.enableCellChangeFlash);
  };
  GridOptionsWrapper.prototype.getCellFlashDelay = function () {
    return this.gridOptions.cellFlashDelay || 500;
  };
  GridOptionsWrapper.prototype.getCellFadeDelay = function () {
    return this.gridOptions.cellFadeDelay || 1000;
  };
  GridOptionsWrapper.prototype.isGroupSelectsChildren = function () {
    var result = isTrue(this.gridOptions.groupSelectsChildren);
    if (result && this.isTreeData()) {
      console.warn('AG Grid: groupSelectsChildren does not work with tree data');
      return false;
    }
    return result;
  };
  GridOptionsWrapper.prototype.isSuppressRowHoverHighlight = function () {
    return isTrue(this.gridOptions.suppressRowHoverHighlight);
  };
  GridOptionsWrapper.prototype.isColumnHoverHighlight = function () {
    return isTrue(this.gridOptions.columnHoverHighlight);
  };
  GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () {
    return isTrue(this.gridOptions.groupSelectsFiltered);
  };
  GridOptionsWrapper.prototype.isGroupHideOpenParents = function () {
    return isTrue(this.gridOptions.groupHideOpenParents);
  };
  GridOptionsWrapper.prototype.isGroupMaintainOrder = function () {
    return isTrue(this.gridOptions.groupMaintainOrder);
  };
  GridOptionsWrapper.prototype.getAutoGroupColumnDef = function () {
    return this.gridOptions.autoGroupColumnDef;
  };
  GridOptionsWrapper.prototype.isGroupMultiAutoColumn = function () {
    if (this.gridOptions.groupDisplayType) {
      return this.matchesGroupDisplayType('multipleColumns', this.gridOptions.groupDisplayType);
    }
    // if we are doing hideOpenParents we also show multiple columns, otherwise hideOpenParents would not work
    return isTrue(this.gridOptions.groupHideOpenParents);
  };
  GridOptionsWrapper.prototype.isGroupUseEntireRow = function (pivotMode) {
    // we never allow groupUseEntireRow if in pivot mode, otherwise we won't see the pivot values.
    if (pivotMode) {
      return false;
    }
    return this.gridOptions.groupDisplayType ? this.matchesGroupDisplayType('groupRows', this.gridOptions.groupDisplayType) : false;
  };
  GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () {
    var isCustomRowGroups = this.gridOptions.groupDisplayType ? this.matchesGroupDisplayType('custom', this.gridOptions.groupDisplayType) : false;
    if (isCustomRowGroups) {
      return true;
    }
    return this.gridOptions.treeDataDisplayType ? this.matchesTreeDataDisplayType('custom', this.gridOptions.treeDataDisplayType) : false;
  };
  GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () {
    return isTrue(this.gridOptions.groupRemoveSingleChildren);
  };
  GridOptionsWrapper.prototype.isGroupRemoveLowestSingleChildren = function () {
    return isTrue(this.gridOptions.groupRemoveLowestSingleChildren);
  };
  GridOptionsWrapper.prototype.isGroupIncludeFooter = function () {
    return isTrue(this.gridOptions.groupIncludeFooter);
  };
  GridOptionsWrapper.prototype.isGroupIncludeTotalFooter = function () {
    return isTrue(this.gridOptions.groupIncludeTotalFooter);
  };
  GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () {
    return isTrue(this.gridOptions.groupSuppressBlankHeader);
  };
  GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () {
    return isTrue(this.gridOptions.suppressRowClickSelection);
  };
  GridOptionsWrapper.prototype.isSuppressCellSelection = function () {
    return isTrue(this.gridOptions.suppressCellSelection);
  };
  GridOptionsWrapper.prototype.isSuppressMultiSort = function () {
    return isTrue(this.gridOptions.suppressMultiSort);
  };
  GridOptionsWrapper.prototype.isMultiSortKeyCtrl = function () {
    return this.gridOptions.multiSortKey === 'ctrl';
  };
  GridOptionsWrapper.prototype.isPivotSuppressAutoColumn = function () {
    return isTrue(this.gridOptions.pivotSuppressAutoColumn);
  };
  GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () {
    return isTrue(this.gridOptions.suppressDragLeaveHidesColumns);
  };
  GridOptionsWrapper.prototype.isSuppressScrollOnNewData = function () {
    return isTrue(this.gridOptions.suppressScrollOnNewData);
  };
  GridOptionsWrapper.prototype.isSuppressScrollWhenPopupsAreOpen = function () {
    return isTrue(this.gridOptions.suppressScrollWhenPopupsAreOpen);
  };
  GridOptionsWrapper.prototype.isRowDragEntireRow = function () {
    return isTrue(this.gridOptions.rowDragEntireRow);
  };
  GridOptionsWrapper.prototype.isSuppressRowDrag = function () {
    return isTrue(this.gridOptions.suppressRowDrag);
  };
  GridOptionsWrapper.prototype.isRowDragManaged = function () {
    return isTrue(this.gridOptions.rowDragManaged);
  };
  GridOptionsWrapper.prototype.isSuppressMoveWhenRowDragging = function () {
    return isTrue(this.gridOptions.suppressMoveWhenRowDragging);
  };
  GridOptionsWrapper.prototype.isRowDragMultiRow = function () {
    return isTrue(this.gridOptions.rowDragMultiRow);
  };
  // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
  GridOptionsWrapper.prototype.getDomLayout = function () {
    var domLayout = this.gridOptions.domLayout || Constants.DOM_LAYOUT_NORMAL;
    var validLayouts = [Constants.DOM_LAYOUT_PRINT, Constants.DOM_LAYOUT_AUTO_HEIGHT, Constants.DOM_LAYOUT_NORMAL];
    if (validLayouts.indexOf(domLayout) === -1) {
      doOnce(function () {
        return console.warn("AG Grid: " + domLayout + " is not valid for DOM Layout, valid values are " + Constants.DOM_LAYOUT_NORMAL + ", " + Constants.DOM_LAYOUT_AUTO_HEIGHT + " and " + Constants.DOM_LAYOUT_PRINT);
      }, 'warn about dom layout values');
      return Constants.DOM_LAYOUT_NORMAL;
    }
    return domLayout;
  };
  GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () {
    return isTrue(this.gridOptions.suppressHorizontalScroll);
  };
  GridOptionsWrapper.prototype.isSuppressMaxRenderedRowRestriction = function () {
    return isTrue(this.gridOptions.suppressMaxRenderedRowRestriction);
  };
  GridOptionsWrapper.prototype.isExcludeChildrenWhenTreeDataFiltering = function () {
    return isTrue(this.gridOptions.excludeChildrenWhenTreeDataFiltering);
  };
  GridOptionsWrapper.prototype.isAlwaysShowHorizontalScroll = function () {
    return isTrue(this.gridOptions.alwaysShowHorizontalScroll);
  };
  GridOptionsWrapper.prototype.isAlwaysShowVerticalScroll = function () {
    return isTrue(this.gridOptions.alwaysShowVerticalScroll);
  };
  GridOptionsWrapper.prototype.isDebounceVerticalScrollbar = function () {
    return isTrue(this.gridOptions.debounceVerticalScrollbar);
  };
  GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () {
    return isTrue(this.gridOptions.suppressLoadingOverlay);
  };
  GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () {
    return isTrue(this.gridOptions.suppressNoRowsOverlay);
  };
  GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () {
    return isTrue(this.gridOptions.suppressFieldDotNotation);
  };
  GridOptionsWrapper.prototype.getPinnedTopRowData = function () {
    return this.gridOptions.pinnedTopRowData;
  };
  GridOptionsWrapper.prototype.getPinnedBottomRowData = function () {
    return this.gridOptions.pinnedBottomRowData;
  };
  GridOptionsWrapper.prototype.isFunctionsPassive = function () {
    return isTrue(this.gridOptions.functionsPassive);
  };
  GridOptionsWrapper.prototype.isSuppressChangeDetection = function () {
    return isTrue(this.gridOptions.suppressChangeDetection);
  };
  GridOptionsWrapper.prototype.isSuppressAnimationFrame = function () {
    return isTrue(this.gridOptions.suppressAnimationFrame);
  };
  GridOptionsWrapper.prototype.getQuickFilterText = function () {
    return this.gridOptions.quickFilterText;
  };
  GridOptionsWrapper.prototype.isCacheQuickFilter = function () {
    return isTrue(this.gridOptions.cacheQuickFilter);
  };
  GridOptionsWrapper.prototype.isUnSortIcon = function () {
    return isTrue(this.gridOptions.unSortIcon);
  };
  GridOptionsWrapper.prototype.isSuppressMenuHide = function () {
    return isTrue(this.gridOptions.suppressMenuHide);
  };
  GridOptionsWrapper.prototype.isEnterMovesDownAfterEdit = function () {
    return isTrue(this.gridOptions.enterMovesDownAfterEdit);
  };
  GridOptionsWrapper.prototype.isEnterMovesDown = function () {
    return isTrue(this.gridOptions.enterMovesDown);
  };
  GridOptionsWrapper.prototype.isUndoRedoCellEditing = function () {
    return isTrue(this.gridOptions.undoRedoCellEditing);
  };
  GridOptionsWrapper.prototype.getUndoRedoCellEditingLimit = function () {
    return toNumber(this.gridOptions.undoRedoCellEditingLimit);
  };
  GridOptionsWrapper.prototype.getRowStyle = function () {
    return this.gridOptions.rowStyle;
  };
  GridOptionsWrapper.prototype.getRowClass = function () {
    return this.gridOptions.rowClass;
  };
  GridOptionsWrapper.prototype.getRowStyleFunc = function () {
    return this.gridOptions.getRowStyle;
  };
  GridOptionsWrapper.prototype.getRowClassFunc = function () {
    return this.gridOptions.getRowClass;
  };
  GridOptionsWrapper.prototype.rowClassRules = function () {
    return this.gridOptions.rowClassRules;
  };
  GridOptionsWrapper.prototype.getServerSideStoreType = function () {
    return this.gridOptions.serverSideStoreType;
  };
  GridOptionsWrapper.prototype.getServerSideStoreParamsFunc = function () {
    return this.gridOptions.getServerSideStoreParams;
  };
  GridOptionsWrapper.prototype.getCreateChartContainerFunc = function () {
    return this.gridOptions.createChartContainer;
  };
  GridOptionsWrapper.prototype.getPopupParent = function () {
    return this.gridOptions.popupParent;
  };
  GridOptionsWrapper.prototype.getBlockLoadDebounceMillis = function () {
    return this.gridOptions.blockLoadDebounceMillis;
  };
  GridOptionsWrapper.prototype.getPostProcessPopupFunc = function () {
    return this.gridOptions.postProcessPopup;
  };
  GridOptionsWrapper.prototype.getPaginationNumberFormatterFunc = function () {
    return this.gridOptions.paginationNumberFormatter;
  };
  GridOptionsWrapper.prototype.getChildCountFunc = function () {
    return this.gridOptions.getChildCount;
  };
  GridOptionsWrapper.prototype.getIsApplyServerSideTransactionFunc = function () {
    return this.gridOptions.isApplyServerSideTransaction;
  };
  GridOptionsWrapper.prototype.getDefaultGroupOrderComparator = function () {
    return this.gridOptions.defaultGroupOrderComparator;
  };
  GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () {
    return this.gridOptions.isFullWidthCell;
  };
  GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () {
    return this.gridOptions.fullWidthCellRendererParams;
  };
  GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () {
    return isTrue(this.gridOptions.embedFullWidthRows) || isTrue(this.gridOptions.deprecatedEmbedFullWidthRows);
  };
  GridOptionsWrapper.prototype.isDetailRowAutoHeight = function () {
    return isTrue(this.gridOptions.detailRowAutoHeight);
  };
  GridOptionsWrapper.prototype.getSuppressKeyboardEventFunc = function () {
    return this.gridOptions.suppressKeyboardEvent;
  };
  GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () {
    return this.gridOptions.getBusinessKeyForNode;
  };
  GridOptionsWrapper.prototype.getApi = function () {
    return this.gridOptions.api;
  };
  GridOptionsWrapper.prototype.getColumnApi = function () {
    return this.gridOptions.columnApi;
  };
  GridOptionsWrapper.prototype.isImmutableData = function () {
    return isTrue(this.gridOptions.immutableData);
  };
  GridOptionsWrapper.prototype.isEnsureDomOrder = function () {
    return isTrue(this.gridOptions.ensureDomOrder);
  };
  GridOptionsWrapper.prototype.isEnableCharts = function () {
    if (isTrue(this.gridOptions.enableCharts)) {
      return ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'enableCharts');
    }
    return false;
  };
  GridOptionsWrapper.prototype.getColResizeDefault = function () {
    return this.gridOptions.colResizeDefault;
  };
  GridOptionsWrapper.prototype.isSingleClickEdit = function () {
    return isTrue(this.gridOptions.singleClickEdit);
  };
  GridOptionsWrapper.prototype.isSuppressClickEdit = function () {
    return isTrue(this.gridOptions.suppressClickEdit);
  };
  GridOptionsWrapper.prototype.isStopEditingWhenCellsLoseFocus = function () {
    return isTrue(this.gridOptions.stopEditingWhenCellsLoseFocus);
  };
  GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () {
    return this.gridOptions.groupDefaultExpanded;
  };
  GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () {
    return this.gridOptions.maxConcurrentDatasourceRequests;
  };
  GridOptionsWrapper.prototype.getMaxBlocksInCache = function () {
    return this.gridOptions.maxBlocksInCache;
  };
  GridOptionsWrapper.prototype.getCacheOverflowSize = function () {
    return this.gridOptions.cacheOverflowSize;
  };
  GridOptionsWrapper.prototype.getPaginationPageSize = function () {
    return toNumber(this.gridOptions.paginationPageSize);
  };
  GridOptionsWrapper.prototype.isPaginateChildRows = function () {
    var shouldPaginate = this.isGroupRemoveSingleChildren() || this.isGroupRemoveLowestSingleChildren();
    if (shouldPaginate) {
      return true;
    }
    return isTrue(this.gridOptions.paginateChildRows);
  };
  GridOptionsWrapper.prototype.getCacheBlockSize = function () {
    return oneOrGreater(this.gridOptions.cacheBlockSize);
  };
  GridOptionsWrapper.prototype.getInfiniteInitialRowCount = function () {
    return this.gridOptions.infiniteInitialRowCount;
  };
  GridOptionsWrapper.prototype.isPurgeClosedRowNodes = function () {
    return isTrue(this.gridOptions.purgeClosedRowNodes);
  };
  GridOptionsWrapper.prototype.isSuppressPaginationPanel = function () {
    return isTrue(this.gridOptions.suppressPaginationPanel);
  };
  GridOptionsWrapper.prototype.getRowData = function () {
    return this.gridOptions.rowData;
  };
  GridOptionsWrapper.prototype.isEnableRtl = function () {
    return isTrue(this.gridOptions.enableRtl);
  };
  GridOptionsWrapper.prototype.getRowGroupPanelShow = function () {
    return this.gridOptions.rowGroupPanelShow;
  };
  GridOptionsWrapper.prototype.getPivotPanelShow = function () {
    return this.gridOptions.pivotPanelShow;
  };
  GridOptionsWrapper.prototype.isAngularCompileRows = function () {
    return isTrue(this.gridOptions.angularCompileRows);
  };
  GridOptionsWrapper.prototype.isAngularCompileFilters = function () {
    return isTrue(this.gridOptions.angularCompileFilters);
  };
  GridOptionsWrapper.prototype.isDebug = function () {
    return isTrue(this.gridOptions.debug);
  };
  GridOptionsWrapper.prototype.getColumnDefs = function () {
    return this.gridOptions.columnDefs;
  };
  GridOptionsWrapper.prototype.getColumnTypes = function () {
    return this.gridOptions.columnTypes;
  };
  GridOptionsWrapper.prototype.getDatasource = function () {
    return this.gridOptions.datasource;
  };
  GridOptionsWrapper.prototype.getViewportDatasource = function () {
    return this.gridOptions.viewportDatasource;
  };
  GridOptionsWrapper.prototype.getServerSideDatasource = function () {
    return this.gridOptions.serverSideDatasource;
  };
  GridOptionsWrapper.prototype.isAccentedSort = function () {
    return isTrue(this.gridOptions.accentedSort);
  };
  GridOptionsWrapper.prototype.isEnableBrowserTooltips = function () {
    return isTrue(this.gridOptions.enableBrowserTooltips);
  };
  GridOptionsWrapper.prototype.isEnableCellExpressions = function () {
    return isTrue(this.gridOptions.enableCellExpressions);
  };
  GridOptionsWrapper.prototype.isEnableGroupEdit = function () {
    return isTrue(this.gridOptions.enableGroupEdit);
  };
  GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () {
    return isTrue(this.gridOptions.suppressMiddleClickScrolls);
  };
  GridOptionsWrapper.prototype.isPreventDefaultOnContextMenu = function () {
    return isTrue(this.gridOptions.preventDefaultOnContextMenu);
  };
  GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () {
    return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel);
  };
  GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () {
    return isTrue(this.gridOptions.suppressColumnVirtualisation);
  };
  GridOptionsWrapper.prototype.isSuppressContextMenu = function () {
    return isTrue(this.gridOptions.suppressContextMenu);
  };
  GridOptionsWrapper.prototype.isAllowContextMenuWithControlKey = function () {
    return isTrue(this.gridOptions.allowContextMenuWithControlKey);
  };
  GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () {
    return isTrue(this.gridOptions.suppressCopyRowsToClipboard);
  };
  GridOptionsWrapper.prototype.isCopyHeadersToClipboard = function () {
    return isTrue(this.gridOptions.copyHeadersToClipboard);
  };
  GridOptionsWrapper.prototype.isSuppressClipboardPaste = function () {
    return isTrue(this.gridOptions.suppressClipboardPaste);
  };
  GridOptionsWrapper.prototype.isSuppressLastEmptyLineOnPaste = function () {
    return isTrue(this.gridOptions.suppressLastEmptyLineOnPaste);
  };
  GridOptionsWrapper.prototype.isPagination = function () {
    return isTrue(this.gridOptions.pagination);
  };
  GridOptionsWrapper.prototype.isSuppressEnterpriseResetOnNewColumns = function () {
    return isTrue(this.gridOptions.suppressEnterpriseResetOnNewColumns);
  };
  GridOptionsWrapper.prototype.getProcessDataFromClipboardFunc = function () {
    return this.gridOptions.processDataFromClipboard;
  };
  GridOptionsWrapper.prototype.getAsyncTransactionWaitMillis = function () {
    return exists(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : Constants.BATCH_WAIT_MILLIS;
  };
  GridOptionsWrapper.prototype.isSuppressMovableColumns = function () {
    return isTrue(this.gridOptions.suppressMovableColumns);
  };
  GridOptionsWrapper.prototype.isAnimateRows = function () {
    // never allow animating if enforcing the row order
    if (this.isEnsureDomOrder()) {
      return false;
    }
    return isTrue(this.gridOptions.animateRows);
  };
  GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () {
    return isTrue(this.gridOptions.suppressColumnMoveAnimation);
  };
  GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () {
    return isTrue(this.gridOptions.suppressAggFuncInHeader);
  };
  GridOptionsWrapper.prototype.isSuppressAggAtRootLevel = function () {
    return isTrue(this.gridOptions.suppressAggAtRootLevel);
  };
  GridOptionsWrapper.prototype.isSuppressAggFilteredOnly = function () {
    return isTrue(this.gridOptions.suppressAggFilteredOnly);
  };
  GridOptionsWrapper.prototype.isShowOpenedGroup = function () {
    return isTrue(this.gridOptions.showOpenedGroup);
  };
  GridOptionsWrapper.prototype.isReactUi = function () {
    return isTrue(this.gridOptions.reactUi);
  };
  GridOptionsWrapper.prototype.isEnableRangeSelection = function () {
    return ModuleRegistry.isRegistered(ModuleNames.RangeSelectionModule) && isTrue(this.gridOptions.enableRangeSelection);
  };
  GridOptionsWrapper.prototype.isEnableRangeHandle = function () {
    return isTrue(this.gridOptions.enableRangeHandle);
  };
  GridOptionsWrapper.prototype.isEnableFillHandle = function () {
    return isTrue(this.gridOptions.enableFillHandle);
  };
  GridOptionsWrapper.prototype.getFillHandleDirection = function () {
    var direction = this.gridOptions.fillHandleDirection;
    if (!direction) {
      return 'xy';
    }
    if (direction !== 'x' && direction !== 'y' && direction !== 'xy') {
      doOnce(function () {
        return console.warn("AG Grid: valid values for fillHandleDirection are 'x', 'y' and 'xy'. Default to 'xy'.");
      }, 'warn invalid fill direction');
      return 'xy';
    }
    return direction;
  };
  GridOptionsWrapper.prototype.getFillOperation = function () {
    return this.gridOptions.fillOperation;
  };
  GridOptionsWrapper.prototype.isSuppressMultiRangeSelection = function () {
    return isTrue(this.gridOptions.suppressMultiRangeSelection);
  };
  GridOptionsWrapper.prototype.isPaginationAutoPageSize = function () {
    return isTrue(this.gridOptions.paginationAutoPageSize);
  };
  GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () {
    return isTrue(this.gridOptions.rememberGroupStateWhenNewData);
  };
  GridOptionsWrapper.prototype.getIcons = function () {
    return this.gridOptions.icons;
  };
  GridOptionsWrapper.prototype.getAggFuncs = function () {
    return this.gridOptions.aggFuncs;
  };
  GridOptionsWrapper.prototype.getSortingOrder = function () {
    return this.gridOptions.sortingOrder;
  };
  GridOptionsWrapper.prototype.getAlignedGrids = function () {
    return this.gridOptions.alignedGrids;
  };
  GridOptionsWrapper.prototype.isMasterDetail = function () {
    var masterDetail = isTrue(this.gridOptions.masterDetail);
    if (masterDetail) {
      return ModuleRegistry.assertRegistered(ModuleNames.MasterDetailModule, 'masterDetail');
    } else {
      return false;
    }
  };
  GridOptionsWrapper.prototype.isKeepDetailRows = function () {
    return isTrue(this.gridOptions.keepDetailRows);
  };
  GridOptionsWrapper.prototype.getKeepDetailRowsCount = function () {
    var keepDetailRowsCount = this.gridOptions.keepDetailRowsCount;
    if (exists(keepDetailRowsCount) && keepDetailRowsCount > 0) {
      return this.gridOptions.keepDetailRowsCount;
    }
    return DEFAULT_KEEP_DETAIL_ROW_COUNT;
  };
  GridOptionsWrapper.prototype.getIsRowMasterFunc = function () {
    return this.gridOptions.isRowMaster;
  };
  GridOptionsWrapper.prototype.getIsRowSelectableFunc = function () {
    return this.gridOptions.isRowSelectable;
  };
  GridOptionsWrapper.prototype.getGroupRowRendererParams = function () {
    return this.gridOptions.groupRowRendererParams;
  };
  GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () {
    return this.gridOptions.overlayLoadingTemplate;
  };
  GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () {
    return this.gridOptions.overlayNoRowsTemplate;
  };
  GridOptionsWrapper.prototype.isSuppressAutoSize = function () {
    return isTrue(this.gridOptions.suppressAutoSize);
  };
  GridOptionsWrapper.prototype.isEnableCellTextSelection = function () {
    return isTrue(this.gridOptions.enableCellTextSelection);
  };
  GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () {
    return isTrue(this.gridOptions.suppressParentsInRowNodes);
  };
  GridOptionsWrapper.prototype.isSuppressClipboardApi = function () {
    return isTrue(this.gridOptions.suppressClipboardApi);
  };
  GridOptionsWrapper.prototype.isFunctionsReadOnly = function () {
    return isTrue(this.gridOptions.functionsReadOnly);
  };
  GridOptionsWrapper.prototype.isFloatingFilter = function () {
    return this.gridOptions.floatingFilter;
  };
  GridOptionsWrapper.prototype.isEnableCellTextSelect = function () {
    return isTrue(this.gridOptions.enableCellTextSelection);
  };
  GridOptionsWrapper.prototype.isEnableOldSetFilterModel = function () {
    return isTrue(this.gridOptions.enableOldSetFilterModel);
  };
  GridOptionsWrapper.prototype.getDefaultColDef = function () {
    return this.gridOptions.defaultColDef;
  };
  GridOptionsWrapper.prototype.getDefaultColGroupDef = function () {
    return this.gridOptions.defaultColGroupDef;
  };
  GridOptionsWrapper.prototype.getDefaultExportParams = function (type) {
    if (this.gridOptions.defaultExportParams) {
      console.warn("AG Grid: Since v25.2 `defaultExportParams`  has been replaced by `default" + capitalise(type) + "ExportParams`'");
      if (type === 'csv') {
        return this.gridOptions.defaultExportParams;
      }
      return this.gridOptions.defaultExportParams;
    }
    if (type === 'csv' && this.gridOptions.defaultCsvExportParams) {
      return this.gridOptions.defaultCsvExportParams;
    }
    if (type === 'excel' && this.gridOptions.defaultExcelExportParams) {
      return this.gridOptions.defaultExcelExportParams;
    }
  };
  GridOptionsWrapper.prototype.isSuppressCsvExport = function () {
    return isTrue(this.gridOptions.suppressCsvExport);
  };
  GridOptionsWrapper.prototype.isAllowShowChangeAfterFilter = function () {
    return isTrue(this.gridOptions.allowShowChangeAfterFilter);
  };
  GridOptionsWrapper.prototype.isSuppressExcelExport = function () {
    return isTrue(this.gridOptions.suppressExcelExport);
  };
  GridOptionsWrapper.prototype.isSuppressMakeColumnVisibleAfterUnGroup = function () {
    return isTrue(this.gridOptions.suppressMakeColumnVisibleAfterUnGroup);
  };
  GridOptionsWrapper.prototype.getDataPathFunc = function () {
    return this.gridOptions.getDataPath;
  };
  GridOptionsWrapper.prototype.getIsServerSideGroupFunc = function () {
    return this.gridOptions.isServerSideGroup;
  };
  GridOptionsWrapper.prototype.getIsServerSideGroupOpenByDefaultFunc = function () {
    return this.gridOptions.isServerSideGroupOpenByDefault;
  };
  GridOptionsWrapper.prototype.getIsGroupOpenByDefaultFunc = function () {
    return this.gridOptions.isGroupOpenByDefault;
  };
  GridOptionsWrapper.prototype.getServerSideGroupKeyFunc = function () {
    return this.gridOptions.getServerSideGroupKey;
  };
  GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () {
    return this.gridOptions.groupRowAggNodes;
  };
  GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () {
    return this.gridOptions.getContextMenuItems;
  };
  GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () {
    return this.gridOptions.getMainMenuItems;
  };
  GridOptionsWrapper.prototype.getRowNodeIdFunc = function () {
    return this.gridOptions.getRowNodeId;
  };
  GridOptionsWrapper.prototype.getNavigateToNextHeaderFunc = function () {
    return this.gridOptions.navigateToNextHeader;
  };
  GridOptionsWrapper.prototype.getTabToNextHeaderFunc = function () {
    return this.gridOptions.tabToNextHeader;
  };
  GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () {
    return this.gridOptions.navigateToNextCell;
  };
  GridOptionsWrapper.prototype.getTabToNextCellFunc = function () {
    return this.gridOptions.tabToNextCell;
  };
  GridOptionsWrapper.prototype.getGridTabIndex = function () {
    return (this.gridOptions.tabIndex || 0).toString();
  };
  GridOptionsWrapper.prototype.isTreeData = function () {
    var usingTreeData = isTrue(this.gridOptions.treeData);
    if (usingTreeData) {
      return ModuleRegistry.assertRegistered(ModuleNames.RowGroupingModule, 'Tree Data');
    }
    return false;
  };
  GridOptionsWrapper.prototype.isValueCache = function () {
    return isTrue(this.gridOptions.valueCache);
  };
  GridOptionsWrapper.prototype.isValueCacheNeverExpires = function () {
    return isTrue(this.gridOptions.valueCacheNeverExpires);
  };
  GridOptionsWrapper.prototype.isDeltaSort = function () {
    return isTrue(this.gridOptions.deltaSort);
  };
  GridOptionsWrapper.prototype.isAggregateOnlyChangedColumns = function () {
    return isTrue(this.gridOptions.aggregateOnlyChangedColumns);
  };
  GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () {
    return this.gridOptions.processSecondaryColDef;
  };
  GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () {
    return this.gridOptions.processSecondaryColGroupDef;
  };
  GridOptionsWrapper.prototype.getSendToClipboardFunc = function () {
    return this.gridOptions.sendToClipboard;
  };
  GridOptionsWrapper.prototype.getProcessRowPostCreateFunc = function () {
    return this.gridOptions.processRowPostCreate;
  };
  GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () {
    return this.gridOptions.processCellForClipboard;
  };
  GridOptionsWrapper.prototype.getProcessHeaderForClipboardFunc = function () {
    return this.gridOptions.processHeaderForClipboard;
  };
  GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () {
    return this.gridOptions.processCellFromClipboard;
  };
  GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () {
    return oneOrGreater(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE);
  };
  GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () {
    return zeroOrGreater(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE);
  };
  GridOptionsWrapper.prototype.isServerSideSortingAlwaysResets = function () {
    return isTrue(this.gridOptions.serverSideSortingAlwaysResets);
  };
  GridOptionsWrapper.prototype.isServerSideFilteringAlwaysResets = function () {
    return isTrue(this.gridOptions.serverSideFilteringAlwaysResets);
  };
  GridOptionsWrapper.prototype.getPostSortFunc = function () {
    return this.gridOptions.postSort;
  };
  GridOptionsWrapper.prototype.getChartToolbarItemsFunc = function () {
    return this.gridOptions.getChartToolbarItems;
  };
  GridOptionsWrapper.prototype.getChartThemeOverrides = function () {
    return this.gridOptions.chartThemeOverrides;
  };
  GridOptionsWrapper.prototype.getCustomChartThemes = function () {
    return this.gridOptions.customChartThemes;
  };
  GridOptionsWrapper.prototype.getChartThemes = function () {
    // return default themes if user hasn't supplied any
    return this.gridOptions.chartThemes || ['ag-default', 'ag-material', 'ag-pastel', 'ag-vivid', 'ag-solar'];
  };
  GridOptionsWrapper.prototype.getClipboardDeliminator = function () {
    return exists(this.gridOptions.clipboardDeliminator) ? this.gridOptions.clipboardDeliminator : '\t';
  };
  GridOptionsWrapper.prototype.setProperty = function (key, value, force) {
    if (force === void 0) {
      force = false;
    }
    var gridOptionsNoType = this.gridOptions;
    var previousValue = gridOptionsNoType[key];
    if (force || previousValue !== value) {
      gridOptionsNoType[key] = value;
      var event_1 = {
        type: key,
        currentValue: value,
        previousValue: previousValue
      };
      this.propertyEventService.dispatchEvent(event_1);
    }
  };
  GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
    this.propertyEventService.addEventListener(key, listener);
  };
  GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
    this.propertyEventService.removeEventListener(key, listener);
  };
  GridOptionsWrapper.prototype.isSkipHeaderOnAutoSize = function () {
    return !!this.gridOptions.skipHeaderOnAutoSize;
  };
  GridOptionsWrapper.prototype.getAutoSizePadding = function () {
    var value = this.gridOptions.autoSizePadding;
    return value != null && value >= 0 ? value : 20;
  };
  // properties
  GridOptionsWrapper.prototype.getHeaderHeight = function () {
    if (typeof this.gridOptions.headerHeight === 'number') {
      return this.gridOptions.headerHeight;
    }
    return this.getFromTheme(25, 'headerHeight');
  };
  GridOptionsWrapper.prototype.getFloatingFiltersHeight = function () {
    if (typeof this.gridOptions.floatingFiltersHeight === 'number') {
      return this.gridOptions.floatingFiltersHeight;
    }
    return this.getFromTheme(25, 'headerHeight');
  };
  GridOptionsWrapper.prototype.getGroupHeaderHeight = function () {
    if (typeof this.gridOptions.groupHeaderHeight === 'number') {
      return this.gridOptions.groupHeaderHeight;
    }
    return this.getHeaderHeight();
  };
  GridOptionsWrapper.prototype.getPivotHeaderHeight = function () {
    if (typeof this.gridOptions.pivotHeaderHeight === 'number') {
      return this.gridOptions.pivotHeaderHeight;
    }
    return this.getHeaderHeight();
  };
  GridOptionsWrapper.prototype.getPivotGroupHeaderHeight = function () {
    if (typeof this.gridOptions.pivotGroupHeaderHeight === 'number') {
      return this.gridOptions.pivotGroupHeaderHeight;
    }
    return this.getGroupHeaderHeight();
  };
  GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
    if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
      return this.gridOptions.isExternalFilterPresent();
    }
    return false;
  };
  GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
    if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
      return this.gridOptions.doesExternalFilterPass(node);
    }
    return false;
  };
  GridOptionsWrapper.prototype.getTooltipShowDelay = function () {
    var tooltipShowDelay = this.gridOptions.tooltipShowDelay;
    if (exists(tooltipShowDelay)) {
      if (tooltipShowDelay < 0) {
        console.warn('ag-grid: tooltipShowDelay should not be lower than 0');
      }
      return Math.max(200, tooltipShowDelay);
    }
    return null;
  };
  GridOptionsWrapper.prototype.isTooltipMouseTrack = function () {
    return isTrue(this.gridOptions.tooltipMouseTrack);
  };
  GridOptionsWrapper.prototype.isSuppressModelUpdateAfterUpdateTransaction = function () {
    return isTrue(this.gridOptions.suppressModelUpdateAfterUpdateTransaction);
  };
  GridOptionsWrapper.prototype.getDocument = function () {
    // if user is providing document, we use the users one,
    // otherwise we use the document on the global namespace.
    var result = null;
    if (this.gridOptions.getDocument && exists(this.gridOptions.getDocument)) {
      result = this.gridOptions.getDocument();
    }
    if (result && exists(result)) {
      return result;
    }
    return document;
  };
  GridOptionsWrapper.prototype.getMinColWidth = function () {
    var minColWidth = this.gridOptions.minColWidth;
    if (exists(minColWidth) && minColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
      return this.gridOptions.minColWidth;
    }
    var measuredMin = this.getFromTheme(null, 'headerCellMinWidth');
    return exists(measuredMin) ? Math.max(measuredMin, GridOptionsWrapper_1.MIN_COL_WIDTH) : GridOptionsWrapper_1.MIN_COL_WIDTH;
  };
  GridOptionsWrapper.prototype.getMaxColWidth = function () {
    if (this.gridOptions.maxColWidth && this.gridOptions.maxColWidth > GridOptionsWrapper_1.MIN_COL_WIDTH) {
      return this.gridOptions.maxColWidth;
    }
    return null;
  };
  GridOptionsWrapper.prototype.getColWidth = function () {
    if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper_1.MIN_COL_WIDTH) {
      return 200;
    }
    return this.gridOptions.colWidth;
  };
  GridOptionsWrapper.prototype.getRowBuffer = function () {
    var rowBuffer = this.gridOptions.rowBuffer;
    if (typeof rowBuffer === 'number') {
      if (rowBuffer < 0) {
        doOnce(function () {
          return console.warn("AG Grid: rowBuffer should not be negative");
        }, 'warn rowBuffer negative');
        this.gridOptions.rowBuffer = rowBuffer = 0;
      }
    } else {
      rowBuffer = Constants.ROW_BUFFER_SIZE;
    }
    return rowBuffer;
  };
  GridOptionsWrapper.prototype.getRowBufferInPixels = function () {
    var rowsToBuffer = this.getRowBuffer();
    var defaultRowHeight = this.getRowHeightAsNumber();
    return rowsToBuffer * defaultRowHeight;
  };
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  GridOptionsWrapper.prototype.getScrollbarWidth = function () {
    if (this.scrollbarWidth == null) {
      var useGridOptions = typeof this.gridOptions.scrollbarWidth === 'number' && this.gridOptions.scrollbarWidth >= 0;
      var scrollbarWidth = useGridOptions ? this.gridOptions.scrollbarWidth : getScrollbarWidth();
      if (scrollbarWidth != null) {
        this.scrollbarWidth = scrollbarWidth;
        this.eventService.dispatchEvent({
          type: Events.EVENT_SCROLLBAR_WIDTH_CHANGED
        });
      }
    }
    return this.scrollbarWidth;
  };
  GridOptionsWrapper.prototype.checkForDeprecated = function () {
    // casting to generic object, so typescript compiles even though
    // we are looking for attributes that don't exist
    var options = this.gridOptions;
    if (options.deprecatedEmbedFullWidthRows) {
      console.warn("AG Grid: since v21.2, deprecatedEmbedFullWidthRows has been replaced with embedFullWidthRows.");
    }
    if (options.enableOldSetFilterModel) {
      console.warn('AG Grid: since v22.x, enableOldSetFilterModel is deprecated. Please move to the new Set Filter Model as the old one may not be supported in v23 onwards.');
    }
    if (options.floatingFilter) {
      console.warn('AG Grid: since v23.1, floatingFilter on the gridOptions is deprecated. Please use floatingFilter on the colDef instead.');
      if (!options.defaultColDef) {
        options.defaultColDef = {};
      }
      if (options.defaultColDef.floatingFilter == null) {
        options.defaultColDef.floatingFilter = true;
      }
    }
    if (options.rowDeselection) {
      console.warn('AG Grid: since v24.x, rowDeselection is deprecated and the behaviour is true by default. Please use `suppressRowDeselection` to prevent rows from being deselected.');
    }
    if (options.enableMultiRowDragging) {
      options.rowDragMultiRow = true;
      delete options.enableMultiRowDragging;
      console.warn('AG Grid: since v26.1, `enableMultiRowDragging` is deprecated. Please use `rowDragMultiRow`.');
    }
    var checkRenamedProperty = function checkRenamedProperty(oldProp, newProp, version) {
      if (options[oldProp] != null) {
        console.warn("ag-grid: since version " + version + ", '" + oldProp + "' is deprecated / renamed, please use the new property name '" + newProp + "' instead.");
        if (options[newProp] == null) {
          options[newProp] = options[oldProp];
        }
      }
    };
    checkRenamedProperty('batchUpdateWaitMillis', 'asyncTransactionWaitMillis', '23.1.x');
    checkRenamedProperty('deltaRowDataMode', 'immutableData', '23.1.x');
    if (options.immutableColumns || options.deltaColumnMode) {
      console.warn('AG Grid: since v24.0, immutableColumns and deltaColumnMode properties are gone. The grid now works like this as default. To keep column order maintained, set grid property applyColumnDefOrder=true');
    }
    checkRenamedProperty('suppressSetColumnStateEvents', 'suppressColumnStateEvents', '24.0.x');
    if (options.groupRowInnerRenderer || options.groupRowInnerRendererParams || options.groupRowInnerRendererFramework) {
      console.warn('AG Grid: since v24.0, grid properties groupRowInnerRenderer, groupRowInnerRendererFramework and groupRowInnerRendererParams are no longer used.');
      console.warn('  Instead use the grid properties groupRowRendererParams.innerRenderer, groupRowRendererParams.innerRendererFramework and groupRowRendererParams.innerRendererParams.');
      console.warn('  For example instead of this:');
      console.warn('    groupRowInnerRenderer: "myRenderer"');
      console.warn('    groupRowInnerRendererParams: {x: a}');
      console.warn('  Replace with this:');
      console.warn('    groupRowRendererParams: {');
      console.warn('      innerRenderer: "myRenderer",');
      console.warn('      innerRendererParams: {x: a}');
      console.warn('    }');
      console.warn('  We have copied the properties over for you. However to stop this error message, please change your application code.');
      if (!options.groupRowRendererParams) {
        options.groupRowRendererParams = {};
      }
      var params = options.groupRowRendererParams;
      if (options.groupRowInnerRenderer) {
        params.innerRenderer = options.groupRowInnerRenderer;
      }
      if (options.groupRowInnerRendererParams) {
        params.innerRendererParams = options.groupRowInnerRendererParams;
      }
      if (options.groupRowInnerRendererFramework) {
        params.innerRendererFramework = options.groupRowInnerRendererFramework;
      }
    }
    if (options.rememberGroupStateWhenNewData) {
      console.warn('AG Grid: since v24.0, grid property rememberGroupStateWhenNewData is deprecated. This feature was provided before Transaction Updates worked (which keep group state). Now that transaction updates are possible and they keep group state, this feature is no longer needed.');
    }
    if (options.detailCellRendererParams && options.detailCellRendererParams.autoHeight) {
      console.warn('AG Grid: since v24.1, grid property detailCellRendererParams.autoHeight is replaced with grid property detailRowAutoHeight. This allows this feature to work when you provide a custom DetailCellRenderer');
      options.detailRowAutoHeight = true;
    }
    if (options.suppressKeyboardEvent) {
      console.warn("AG Grid: since v24.1 suppressKeyboardEvent in the gridOptions has been deprecated and will be removed in\n                 future versions of AG Grid. If you need this to be set for every column use the defaultColDef property.");
    }
    if (options.suppressEnterpriseResetOnNewColumns) {
      console.warn('AG Grid: since v25, grid property suppressEnterpriseResetOnNewColumns is deprecated. This was a temporary property to allow changing columns in Server Side Row Model without triggering a reload. Now that it is possible to dynamically change columns in the grid, this is no longer needed.');
    }
    if (options.suppressColumnStateEvents) {
      console.warn('AG Grid: since v25, grid property suppressColumnStateEvents no longer works due to a refactor that we did. It should be possible to achieve similar using event.source, which would be "api" if the event was due to setting column state via the API');
    }
    if (options.defaultExportParams) {
      console.warn('AG Grid: since v25.2, the grid property `defaultExportParams` has been replaced by `defaultCsvExportParams` and `defaultExcelExportParams`.');
    }
    if (options.stopEditingWhenGridLosesFocus) {
      console.warn('AG Grid: since v25.2.2, the grid property `stopEditingWhenGridLosesFocus` has been replaced by `stopEditingWhenCellsLoseFocus`.');
      options.stopEditingWhenCellsLoseFocus = true;
    }
    if (options.applyColumnDefOrder) {
      console.warn('AG Grid: since v26.0, the grid property `applyColumnDefOrder` is no longer needed, as this is the default behaviour. To turn this behaviour off, set maintainColumnOrder=true');
    }
    if (options.groupMultiAutoColumn) {
      console.warn("AG Grid: since v26.0, the grid property `groupMultiAutoColumn` has been replaced by `groupDisplayType = 'multipleColumns'`");
      options.groupDisplayType = 'multipleColumns';
    }
    if (options.groupUseEntireRow) {
      console.warn("AG Grid: since v26.0, the grid property `groupUseEntireRow` has been replaced by `groupDisplayType = 'groupRows'`");
      options.groupDisplayType = 'groupRows';
    }
    if (options.groupSuppressAutoColumn) {
      var propName = options.treeData ? 'treeDataDisplayType' : 'groupDisplayType';
      console.warn("AG Grid: since v26.0, the grid property `groupSuppressAutoColumn` has been replaced by `" + propName + " = 'custom'`");
      options.groupDisplayType = 'custom';
    }
    if (options.defaultGroupSortComparator) {
      console.warn("AG Grid: since v26.0, the grid property `defaultGroupSortComparator` has been replaced by `defaultGroupOrderComparator`");
      options.defaultGroupOrderComparator = options.defaultGroupSortComparator;
    }
    if (options.colWidth) {
      console.warn('AG Grid: since v26.1, the grid property `colWidth` is deprecated and should be set via `defaultColDef.width`.');
    }
    if (options.minColWidth) {
      console.warn('AG Grid: since v26.1, the grid property `minColWidth` is deprecated and should be set via `defaultColDef.minWidth`.');
    }
    if (options.maxColWidth) {
      console.warn('AG Grid: since v26.1, the grid property `maxColWidth` is deprecated and should be set via `defaultColDef.maxWidth`.');
    }
  };
  GridOptionsWrapper.prototype.checkForViolations = function () {
    if (this.isTreeData()) {
      this.treeDataViolations();
    }
  };
  GridOptionsWrapper.prototype.treeDataViolations = function () {
    if (this.isRowModelDefault()) {
      if (missing(this.getDataPathFunc())) {
        console.warn('AG Grid: property usingTreeData=true with rowModel=clientSide, but you did not ' + 'provide getDataPath function, please provide getDataPath function if using tree data.');
      }
    }
    if (this.isRowModelServerSide()) {
      if (missing(this.getIsServerSideGroupFunc())) {
        console.warn('AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' + 'provide isServerSideGroup function, please provide isServerSideGroup function if using tree data.');
      }
      if (missing(this.getServerSideGroupKeyFunc())) {
        console.warn('AG Grid: property usingTreeData=true with rowModel=serverSide, but you did not ' + 'provide getServerSideGroupKey function, please provide getServerSideGroupKey function if using tree data.');
      }
    }
  };
  GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
    if (this.gridOptions.localeTextFunc) {
      return this.gridOptions.localeTextFunc;
    }
    var localeText = this.gridOptions.localeText;
    return function (key, defaultValue) {
      return localeText && localeText[key] ? localeText[key] : defaultValue;
    };
  };
  // responsible for calling the onXXX functions on gridOptions
  GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
    // prevent events from being fired _after_ the grid has been destroyed
    if (this.destroyed) {
      return;
    }
    var callbackMethodName = ComponentUtil.getCallbackForEvent(eventName);
    if (typeof this.gridOptions[callbackMethodName] === 'function') {
      this.gridOptions[callbackMethodName](event);
    }
  };
  // we don't allow dynamic row height for virtual paging
  GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
    if (!this.gridOptions.rowHeight || missing(this.gridOptions.rowHeight)) {
      return this.getDefaultRowHeight();
    }
    if (this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight)) {
      return this.gridOptions.rowHeight;
    }
    console.warn('AG Grid row height must be a number if not using standard row model');
    return this.getDefaultRowHeight();
  };
  GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode, allowEstimate, defaultRowHeight) {
    if (allowEstimate === void 0) {
      allowEstimate = false;
    }
    if (defaultRowHeight == null) {
      defaultRowHeight = this.getDefaultRowHeight();
    }
    // check the function first, in case use set both function and
    // number, when using virtual pagination then function can be
    // used for pinned rows and the number for the body rows.
    if (typeof this.gridOptions.getRowHeight === 'function') {
      if (allowEstimate) {
        return {
          height: this.getDefaultRowHeight(),
          estimated: true
        };
      }
      var params = {
        node: rowNode,
        data: rowNode.data,
        api: this.gridOptions.api,
        context: this.gridOptions.context
      };
      var height = this.gridOptions.getRowHeight(params);
      if (this.isNumeric(height)) {
        if (height === 0) {
          doOnce(function () {
            return console.warn('AG Grid: The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.');
          }, 'invalidRowHeight');
        }
        return {
          height: Math.max(1, height),
          estimated: false
        };
      }
    }
    if (rowNode.detail && this.isMasterDetail()) {
      if (this.isNumeric(this.gridOptions.detailRowHeight)) {
        return {
          height: this.gridOptions.detailRowHeight,
          estimated: false
        };
      }
      return {
        height: DEFAULT_DETAIL_ROW_HEIGHT,
        estimated: false
      };
    }
    var rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : defaultRowHeight;
    return {
      height: rowHeight,
      estimated: false
    };
  };
  GridOptionsWrapper.prototype.isDynamicRowHeight = function () {
    return typeof this.gridOptions.getRowHeight === 'function';
  };
  GridOptionsWrapper.prototype.getListItemHeight = function () {
    return this.getFromTheme(20, 'listItemHeight');
  };
  GridOptionsWrapper.prototype.chartMenuPanelWidth = function () {
    return this.environment.chartMenuPanelWidth();
  };
  GridOptionsWrapper.prototype.isNumeric = function (value) {
    return !isNaN(value) && typeof value === 'number' && isFinite(value);
  };
  GridOptionsWrapper.prototype.getFromTheme = function (defaultValue, sassVariableName) {
    var theme = this.environment.getTheme().theme;
    if (theme && theme.indexOf('ag-theme') === 0) {
      return this.environment.getSassVariable(theme, sassVariableName);
    }
    return defaultValue;
  };
  GridOptionsWrapper.prototype.getDefaultRowHeight = function () {
    return this.getFromTheme(DEFAULT_ROW_HEIGHT, 'rowHeight');
  };
  GridOptionsWrapper.prototype.matchesGroupDisplayType = function (toMatch, supplied) {
    var groupDisplayTypeValues = ['groupRows', 'multipleColumns', 'custom', 'singleColumn'];
    if (groupDisplayTypeValues.indexOf(supplied) < 0) {
      console.warn("AG Grid: '" + supplied + "' is not a valid groupDisplayType value - possible values are: '" + groupDisplayTypeValues.join("', '") + "'");
      return false;
    }
    return supplied === toMatch;
  };
  GridOptionsWrapper.prototype.matchesTreeDataDisplayType = function (toMatch, supplied) {
    var treeDataDisplayTypeValues = ['auto', 'custom'];
    if (treeDataDisplayTypeValues.indexOf(supplied) < 0) {
      console.warn("AG Grid: '" + supplied + "' is not a valid treeDataDisplayType value - possible values are: '" + treeDataDisplayTypeValues.join("', '") + "'");
      return false;
    }
    return supplied === toMatch;
  };
  var GridOptionsWrapper_1;
  GridOptionsWrapper.MIN_COL_WIDTH = 10;
  GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
  GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN = 'groupRemoveSingleChildren';
  GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN = 'groupRemoveLowestSingleChildren';
  GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT = 'pivotHeaderHeight';
  GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE = 'suppressClipboardPaste';
  GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT = 'groupHeaderHeight';
  GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT = 'pivotGroupHeaderHeight';
  GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_CELL = 'navigateToNextCell';
  GridOptionsWrapper.PROP_TAB_TO_NEXT_CELL = 'tabToNextCell';
  GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_HEADER = 'navigateToNextHeader';
  GridOptionsWrapper.PROP_TAB_TO_NEXT_HEADER = 'tabToNextHeader';
  GridOptionsWrapper.PROP_IS_EXTERNAL_FILTER_PRESENT = 'isExternalFilterPresent';
  GridOptionsWrapper.PROP_DOES_EXTERNAL_FILTER_PASS = 'doesExternalFilterPass';
  GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT = 'floatingFiltersHeight';
  GridOptionsWrapper.PROP_SUPPRESS_ROW_CLICK_SELECTION = 'suppressRowClickSelection';
  GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG = 'suppressRowDrag';
  GridOptionsWrapper.PROP_SUPPRESS_MOVE_WHEN_ROW_DRAG = 'suppressMoveWhenRowDragging';
  GridOptionsWrapper.PROP_GET_ROW_CLASS = 'getRowClass';
  GridOptionsWrapper.PROP_GET_ROW_STYLE = 'getRowStyle';
  GridOptionsWrapper.PROP_GET_ROW_HEIGHT = 'getRowHeight';
  GridOptionsWrapper.PROP_POPUP_PARENT = 'popupParent';
  GridOptionsWrapper.PROP_DOM_LAYOUT = 'domLayout';
  GridOptionsWrapper.PROP_FILL_HANDLE_DIRECTION = 'fillHandleDirection';
  GridOptionsWrapper.PROP_GROUP_ROW_AGG_NODES = 'groupRowAggNodes';
  GridOptionsWrapper.PROP_GET_BUSINESS_KEY_FOR_NODE = 'getBusinessKeyForNode';
  GridOptionsWrapper.PROP_GET_CHILD_COUNT = 'getChildCount';
  GridOptionsWrapper.PROP_PROCESS_ROW_POST_CREATE = 'processRowPostCreate';
  GridOptionsWrapper.PROP_GET_ROW_NODE_ID = 'getRowNodeId';
  GridOptionsWrapper.PROP_IS_FULL_WIDTH_CELL = 'isFullWidthCell';
  GridOptionsWrapper.PROP_IS_ROW_SELECTABLE = 'isRowSelectable';
  GridOptionsWrapper.PROP_IS_ROW_MASTER = 'isRowMaster';
  GridOptionsWrapper.PROP_POST_SORT = 'postSort';
  GridOptionsWrapper.PROP_GET_DOCUMENT = 'getDocument';
  GridOptionsWrapper.PROP_POST_PROCESS_POPUP = 'postProcessPopup';
  GridOptionsWrapper.PROP_DEFAULT_GROUP_ORDER_COMPARATOR = 'defaultGroupOrderComparator';
  GridOptionsWrapper.PROP_PAGINATION_NUMBER_FORMATTER = 'paginationNumberFormatter';
  GridOptionsWrapper.PROP_GET_CONTEXT_MENU_ITEMS = 'getContextMenuItems';
  GridOptionsWrapper.PROP_GET_MAIN_MENU_ITEMS = 'getMainMenuItems';
  GridOptionsWrapper.PROP_PROCESS_CELL_FOR_CLIPBOARD = 'processCellForClipboard';
  GridOptionsWrapper.PROP_PROCESS_CELL_FROM_CLIPBOARD = 'processCellFromClipboard';
  GridOptionsWrapper.PROP_SEND_TO_CLIPBOARD = 'sendToClipboard';
  GridOptionsWrapper.PROP_PROCESS_TO_SECONDARY_COLDEF = 'processSecondaryColDef';
  GridOptionsWrapper.PROP_PROCESS_SECONDARY_COL_GROUP_DEF = 'processSecondaryColGroupDef';
  GridOptionsWrapper.PROP_GET_CHART_TOOLBAR_ITEMS = 'getChartToolbarItems';
  GridOptionsWrapper.PROP_GET_SERVER_SIDE_STORE_PARAMS = 'getServerSideStoreParams';
  GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUPS_OPEN_BY_DEFAULT = 'isServerSideGroupOpenByDefault';
  GridOptionsWrapper.PROP_IS_APPLY_SERVER_SIDE_TRANSACTION = 'isApplyServerSideTransaction';
  GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUP = 'isServerSideGroup';
  GridOptionsWrapper.PROP_GET_SERVER_SIDE_GROUP_KEY = 'getServerSideGroupKey';
  __decorate$F([Autowired('gridOptions')], GridOptionsWrapper.prototype, "gridOptions", void 0);
  __decorate$F([Autowired('eventService')], GridOptionsWrapper.prototype, "eventService", void 0);
  __decorate$F([Autowired('environment')], GridOptionsWrapper.prototype, "environment", void 0);
  __decorate$F([__param$3(0, Qualifier('gridApi')), __param$3(1, Qualifier('columnApi'))], GridOptionsWrapper.prototype, "agWire", null);
  __decorate$F([PreDestroy], GridOptionsWrapper.prototype, "destroy", null);
  __decorate$F([PostConstruct], GridOptionsWrapper.prototype, "init", null);
  GridOptionsWrapper = GridOptionsWrapper_1 = __decorate$F([Bean('gridOptionsWrapper')], GridOptionsWrapper);
  return GridOptionsWrapper;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// when doing transactions, or change detection, and grouping is present
// in the data, there is no need for the ClientSideRowModel to update each
// group after an update, ony parts that were impacted by the change.
// this class keeps track of all groups that were impacted by a transaction.
// the the different CSRM operations (filter, sort etc) use the forEach method
// to visit each group that was changed.
var ChangedPath = /** @class */function () {
  function ChangedPath(keepingColumns, rootNode) {
    // whether changed path is active of not. it is active when a) doing
    // a transaction update or b) doing change detection. if we are doing
    // a CSRM refresh for other reasons (after sort or filter, or user calling
    // setRowData() without delta mode) then we are not active. we are also
    // marked as not active if secondary columns change in pivot (as this impacts
    // aggregations)
    this.active = true;
    // for each node in the change path, we also store which columns need
    // to be re-aggregated.
    this.nodeIdsToColumns = {};
    // for quick lookup, all items in the change path are mapped by nodeId
    this.mapToItems = {};
    this.keepingColumns = keepingColumns;
    this.pathRoot = {
      rowNode: rootNode,
      children: null
    };
    this.mapToItems[rootNode.id] = this.pathRoot;
  }
  // can be set inactive by:
  // a) ClientSideRowModel, if no transactions or
  // b) PivotService, if secondary columns changed
  ChangedPath.prototype.setInactive = function () {
    this.active = false;
  };
  ChangedPath.prototype.isActive = function () {
    return this.active;
  };
  ChangedPath.prototype.depthFirstSearchChangedPath = function (pathItem, callback) {
    if (pathItem.children) {
      for (var i = 0; i < pathItem.children.length; i++) {
        this.depthFirstSearchChangedPath(pathItem.children[i], callback);
      }
    }
    callback(pathItem.rowNode);
  };
  ChangedPath.prototype.depthFirstSearchEverything = function (rowNode, callback, traverseEverything) {
    if (rowNode.childrenAfterGroup) {
      for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
        var childNode = rowNode.childrenAfterGroup[i];
        if (childNode.childrenAfterGroup) {
          this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
        } else if (traverseEverything) {
          callback(childNode);
        }
      }
    }
    callback(rowNode);
  };
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  ChangedPath.prototype.forEachChangedNodeDepthFirst = function (callback, traverseLeafNodes) {
    if (traverseLeafNodes === void 0) {
      traverseLeafNodes = false;
    }
    if (this.active) {
      // if we are active, then use the change path to callback
      // only for updated groups
      this.depthFirstSearchChangedPath(this.pathRoot, callback);
    } else {
      // we are not active, so callback for everything, walk the entire path
      this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
  };
  ChangedPath.prototype.executeFromRootNode = function (callback) {
    callback(this.pathRoot.rowNode);
  };
  ChangedPath.prototype.createPathItems = function (rowNode) {
    var pointer = rowNode;
    var newEntryCount = 0;
    while (!this.mapToItems[pointer.id]) {
      var newEntry = {
        rowNode: pointer,
        children: null
      };
      this.mapToItems[pointer.id] = newEntry;
      newEntryCount++;
      pointer = pointer.parent;
    }
    return newEntryCount;
  };
  ChangedPath.prototype.populateColumnsMap = function (rowNode, columns) {
    var _this = this;
    if (!this.keepingColumns || !columns) {
      return;
    }
    var pointer = rowNode;
    while (pointer) {
      // if columns, add the columns in all the way to parent, merging
      // in any other columns that might be there already
      if (!this.nodeIdsToColumns[pointer.id]) {
        this.nodeIdsToColumns[pointer.id] = {};
      }
      columns.forEach(function (col) {
        return _this.nodeIdsToColumns[pointer.id][col.getId()] = true;
      });
      pointer = pointer.parent;
    }
  };
  ChangedPath.prototype.linkPathItems = function (rowNode, newEntryCount) {
    var pointer = rowNode;
    for (var i = 0; i < newEntryCount; i++) {
      var thisItem = this.mapToItems[pointer.id];
      var parentItem = this.mapToItems[pointer.parent.id];
      if (!parentItem.children) {
        parentItem.children = [];
      }
      parentItem.children.push(thisItem);
      pointer = pointer.parent;
    }
  };
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  ChangedPath.prototype.addParentNode = function (rowNode, columns) {
    if (!rowNode || rowNode.isRowPinned()) {
      return;
    }
    // we cannot do  both steps below in the same loop as
    // the second loop has a dependency on the first loop.
    // ie the hierarchy cannot be stitched up yet because
    // we don't have it built yet
    // create the new PathItem objects.
    var newEntryCount = this.createPathItems(rowNode);
    // link in the node items
    this.linkPathItems(rowNode, newEntryCount);
    // update columns
    this.populateColumnsMap(rowNode, columns);
  };
  ChangedPath.prototype.canSkip = function (rowNode) {
    return this.active && !this.mapToItems[rowNode.id];
  };
  ChangedPath.prototype.getValueColumnsForNode = function (rowNode, valueColumns) {
    if (!this.keepingColumns) {
      return valueColumns;
    }
    var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
    var result = valueColumns.filter(function (col) {
      return colsForThisNode[col.getId()];
    });
    return result;
  };
  ChangedPath.prototype.getNotValueColumnsForNode = function (rowNode, valueColumns) {
    if (!this.keepingColumns) {
      return null;
    }
    var colsForThisNode = this.nodeIdsToColumns[rowNode.id];
    var result = valueColumns.filter(function (col) {
      return !colsForThisNode[col.getId()];
    });
    return result;
  };
  return ChangedPath;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$N = undefined && undefined.__extends || function () {
  var _extendStatics50 = function extendStatics(d, b) {
    _extendStatics50 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics50(d, b);
  };
  return function (d, b) {
    _extendStatics50(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$G = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$4 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var SelectionService = /** @class */function (_super) {
  __extends$N(SelectionService, _super);
  function SelectionService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SelectionService.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('selectionService');
    this.reset();
    if (this.gridOptionsWrapper.isRowModelDefault()) {
      this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
    }
  };
  SelectionService.prototype.init = function () {
    this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
    this.addManagedListener(this.eventService, Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
  };
  SelectionService.prototype.setLastSelectedNode = function (rowNode) {
    this.lastSelectedNode = rowNode;
  };
  SelectionService.prototype.getLastSelectedNode = function () {
    return this.lastSelectedNode;
  };
  SelectionService.prototype.getSelectedNodes = function () {
    var selectedNodes = [];
    iterateObject(this.selectedNodes, function (key, rowNode) {
      if (rowNode) {
        selectedNodes.push(rowNode);
      }
    });
    return selectedNodes;
  };
  SelectionService.prototype.getSelectedRows = function () {
    var selectedRows = [];
    iterateObject(this.selectedNodes, function (key, rowNode) {
      if (rowNode && rowNode.data) {
        selectedRows.push(rowNode.data);
      }
    });
    return selectedRows;
  };
  SelectionService.prototype.removeGroupsFromSelection = function () {
    var _this = this;
    iterateObject(this.selectedNodes, function (key, rowNode) {
      if (rowNode && rowNode.group) {
        _this.selectedNodes[rowNode.id] = undefined;
      }
    });
  };
  // should only be called if groupSelectsChildren=true
  SelectionService.prototype.updateGroupsFromChildrenSelections = function (changedPath) {
    // we only do this when group selection state depends on selected children
    if (!this.gridOptionsWrapper.isGroupSelectsChildren()) {
      return;
    }
    // also only do it if CSRM (code should never allow this anyway)
    if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      return;
    }
    var clientSideRowModel = this.rowModel;
    var rootNode = clientSideRowModel.getRootNode();
    if (!changedPath) {
      changedPath = new ChangedPath(true, rootNode);
      changedPath.setInactive();
    }
    changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
      if (rowNode !== rootNode) {
        rowNode.calculateSelectedFromChildren();
      }
    });
    // clientSideRowModel.getTopLevelNodes()!.forEach((rowNode: RowNode) => {
    //     rowNode.depthFirstSearch((node) => {
    //         if (node.group) {
    //         }
    //     });
    // });
  };

  SelectionService.prototype.getNodeForIdIfSelected = function (id) {
    return this.selectedNodes[id];
  };
  SelectionService.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
    var _this = this;
    var groupsToRefresh = {};
    var updatedCount = 0;
    iterateObject(this.selectedNodes, function (key, otherRowNode) {
      if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
        var rowNode = _this.selectedNodes[otherRowNode.id];
        updatedCount += rowNode.setSelectedParams({
          newValue: false,
          clearSelection: false,
          suppressFinishActions: true
        });
        if (_this.groupSelectsChildren && otherRowNode.parent) {
          groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
        }
      }
    });
    iterateObject(groupsToRefresh, function (key, group) {
      group.calculateSelectedFromChildren();
    });
    return updatedCount;
  };
  SelectionService.prototype.onRowSelected = function (event) {
    var rowNode = event.node;
    // we do not store the group rows when the groups select children
    if (this.groupSelectsChildren && rowNode.group) {
      return;
    }
    if (rowNode.isSelected()) {
      this.selectedNodes[rowNode.id] = rowNode;
    } else {
      this.selectedNodes[rowNode.id] = undefined;
    }
  };
  SelectionService.prototype.syncInRowNode = function (rowNode, oldNode) {
    this.syncInOldRowNode(rowNode, oldNode);
    this.syncInNewRowNode(rowNode);
  };
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  SelectionService.prototype.syncInOldRowNode = function (rowNode, oldNode) {
    var oldNodeHasDifferentId = exists(oldNode) && rowNode.id !== oldNode.id;
    if (oldNodeHasDifferentId && oldNode) {
      var id = oldNode.id;
      var oldNodeSelected = this.selectedNodes[id] == rowNode;
      if (oldNodeSelected) {
        this.selectedNodes[oldNode.id] = oldNode;
      }
    }
  };
  SelectionService.prototype.syncInNewRowNode = function (rowNode) {
    if (exists(this.selectedNodes[rowNode.id])) {
      rowNode.setSelectedInitialValue(true);
      this.selectedNodes[rowNode.id] = rowNode;
    } else {
      rowNode.setSelectedInitialValue(false);
    }
  };
  SelectionService.prototype.reset = function () {
    this.logger.log('reset');
    this.selectedNodes = {};
    this.lastSelectedNode = null;
  };
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  SelectionService.prototype.getBestCostNodeSelection = function () {
    if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      console.warn('getBestCostNodeSelection is only available when using normal row model');
      return;
    }
    var clientSideRowModel = this.rowModel;
    var topLevelNodes = clientSideRowModel.getTopLevelNodes();
    if (topLevelNodes === null) {
      console.warn('selectAll not available doing rowModel=virtual');
      return;
    }
    var result = [];
    // recursive function, to find the selected nodes
    function traverse(nodes) {
      for (var i = 0, l = nodes.length; i < l; i++) {
        var node = nodes[i];
        if (node.isSelected()) {
          result.push(node);
        } else {
          // if not selected, then if it's a group, and the group
          // has children, continue to search for selections
          var maybeGroup = node;
          if (maybeGroup.group && maybeGroup.children) {
            traverse(maybeGroup.children);
          }
        }
      }
    }
    traverse(topLevelNodes);
    return result;
  };
  SelectionService.prototype.setRowModel = function (rowModel) {
    this.rowModel = rowModel;
  };
  SelectionService.prototype.isEmpty = function () {
    var count = 0;
    iterateObject(this.selectedNodes, function (nodeId, rowNode) {
      if (rowNode) {
        count++;
      }
    });
    return count === 0;
  };
  SelectionService.prototype.deselectAllRowNodes = function (justFiltered) {
    if (justFiltered === void 0) {
      justFiltered = false;
    }
    var callback = function callback(rowNode) {
      return rowNode.selectThisNode(false);
    };
    var rowModelClientSide = this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
    if (justFiltered) {
      if (!rowModelClientSide) {
        console.error('AG Grid: selecting just filtered only works with In Memory Row Model');
        return;
      }
      var clientSideRowModel = this.rowModel;
      clientSideRowModel.forEachNodeAfterFilter(callback);
    } else {
      iterateObject(this.selectedNodes, function (id, rowNode) {
        // remember the reference can be to null, as we never 'delete' from the map
        if (rowNode) {
          callback(rowNode);
        }
      });
      // this clears down the map (whereas above only sets the items in map to 'undefined')
      this.reset();
    }
    // the above does not clean up the parent rows if they are selected
    if (rowModelClientSide && this.groupSelectsChildren) {
      this.updateGroupsFromChildrenSelections();
    }
    var event = {
      type: Events.EVENT_SELECTION_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  SelectionService.prototype.selectAllRowNodes = function (justFiltered) {
    if (justFiltered === void 0) {
      justFiltered = false;
    }
    if (this.rowModel.getType() !== Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      throw new Error("selectAll only available with normal row model, ie not " + this.rowModel.getType());
    }
    var clientSideRowModel = this.rowModel;
    var callback = function callback(rowNode) {
      return rowNode.selectThisNode(true);
    };
    if (justFiltered) {
      clientSideRowModel.forEachNodeAfterFilter(callback);
    } else {
      clientSideRowModel.forEachNode(callback);
    }
    // the above does not clean up the parent rows if they are selected
    if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE && this.groupSelectsChildren) {
      this.updateGroupsFromChildrenSelections();
    }
    var event = {
      type: Events.EVENT_SELECTION_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  /**
   * @method
   * @deprecated
   */
  SelectionService.prototype.selectNode = function (rowNode, tryMulti) {
    if (rowNode) {
      rowNode.setSelectedParams({
        newValue: true,
        clearSelection: !tryMulti
      });
    }
  };
  /**
   * @method
   * @deprecated
   */
  SelectionService.prototype.deselectIndex = function (rowIndex) {
    var node = this.rowModel.getRow(rowIndex);
    this.deselectNode(node);
  };
  /**
   * @method
   * @deprecated
   */
  SelectionService.prototype.deselectNode = function (rowNode) {
    if (rowNode) {
      rowNode.setSelectedParams({
        newValue: false,
        clearSelection: false
      });
    }
  };
  /**
   * @method
   * @deprecated
   */
  SelectionService.prototype.selectIndex = function (index, tryMulti) {
    var node = this.rowModel.getRow(index);
    this.selectNode(node, tryMulti);
  };
  __decorate$G([Autowired('rowModel')], SelectionService.prototype, "rowModel", void 0);
  __decorate$G([Autowired('columnApi')], SelectionService.prototype, "columnApi", void 0);
  __decorate$G([Autowired('gridApi')], SelectionService.prototype, "gridApi", void 0);
  __decorate$G([__param$4(0, Qualifier('loggerFactory'))], SelectionService.prototype, "setBeans", null);
  __decorate$G([PostConstruct], SelectionService.prototype, "init", null);
  SelectionService = __decorate$G([Bean('selectionService')], SelectionService);
  return SelectionService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$H = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnApi = /** @class */function () {
  function ColumnApi() {}
  /** Gets the grid to size the columns to the specified width in pixels, e.g. `sizeColumnsToFit(900)`. To have the grid fit the columns to the grid's width, use the Grid API `gridApi.sizeColumnsToFit()` instead. */
  ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) {
    // AG-3403 validate that gridWidth is provided because this method has the same name as
    // a method on the grid API that takes no arguments, and it's easy to confuse the two
    if (typeof gridWidth === "undefined") {
      console.error('AG Grid: missing parameter to columnApi.sizeColumnsToFit(gridWidth)');
    }
    this.columnModel.sizeColumnsToFit(gridWidth, 'api');
  };
  /** Call this if you want to open or close a column group. */
  ColumnApi.prototype.setColumnGroupOpened = function (group, newValue) {
    this.columnModel.setColumnGroupOpened(group, newValue, 'api');
  };
  /** Returns the column group with the given name. */
  ColumnApi.prototype.getColumnGroup = function (name, instanceId) {
    return this.columnModel.getColumnGroup(name, instanceId);
  };
  ColumnApi.prototype.getOriginalColumnGroup = function (name) {
    return this.columnModel.getOriginalColumnGroup(name);
  };
  /** Returns the display name for a column. Useful if you are doing your own header rendering and want the grid to work out if `headerValueGetter` is used, or if you are doing your own column management GUI, to know what to show as the column name. */
  ColumnApi.prototype.getDisplayNameForColumn = function (column, location) {
    return this.columnModel.getDisplayNameForColumn(column, location) || '';
  };
  /** Returns the display name for a column group (when grouping columns). */
  ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
    return this.columnModel.getDisplayNameForColumnGroup(columnGroup, location) || '';
  };
  /** Returns the column with the given `colKey`, which can either be the `colId` (a string) or the `colDef` (an object). */
  ColumnApi.prototype.getColumn = function (key) {
    return this.columnModel.getPrimaryColumn(key);
  };
  /** Applies the state of the columns from a previous state. Returns `false` if one or more columns could not be found. */
  ColumnApi.prototype.applyColumnState = function (params) {
    return this.columnModel.applyColumnState(params, 'api');
  };
  /** Gets the state of the columns. Typically used when saving column state. */
  ColumnApi.prototype.getColumnState = function () {
    return this.columnModel.getColumnState();
  };
  /** Sets the state back to match the originally provided column definitions. */
  ColumnApi.prototype.resetColumnState = function () {
    this.columnModel.resetColumnState('api');
  };
  /** Gets the state of the column groups. Typically used when saving column group state. */
  ColumnApi.prototype.getColumnGroupState = function () {
    return this.columnModel.getColumnGroupState();
  };
  /** Sets the state of the column group state from a previous state. */
  ColumnApi.prototype.setColumnGroupState = function (stateItems) {
    this.columnModel.setColumnGroupState(stateItems, 'api');
  };
  /** Sets the state back to match the originally provided column definitions. */
  ColumnApi.prototype.resetColumnGroupState = function () {
    this.columnModel.resetColumnGroupState('api');
  };
  /** Returns `true` if pinning left or right, otherwise `false`. */
  ColumnApi.prototype.isPinning = function () {
    return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
  };
  /** Returns `true` if pinning left, otherwise `false`. */
  ColumnApi.prototype.isPinningLeft = function () {
    return this.columnModel.isPinningLeft();
  };
  /** Returns `true` if pinning right, otherwise `false`. */
  ColumnApi.prototype.isPinningRight = function () {
    return this.columnModel.isPinningRight();
  };
  /** Returns the column to the right of the provided column, taking into consideration open / closed column groups and visible columns. This is useful if you need to know what column is beside yours e.g. if implementing your own cell navigation. */
  ColumnApi.prototype.getDisplayedColAfter = function (col) {
    return this.columnModel.getDisplayedColAfter(col);
  };
  /** Same as `getVisibleColAfter` except gives column to the left. */
  ColumnApi.prototype.getDisplayedColBefore = function (col) {
    return this.columnModel.getDisplayedColBefore(col);
  };
  /** Sets the visibility of a column. Key can be the column ID or `Column` object. */
  ColumnApi.prototype.setColumnVisible = function (key, visible) {
    this.columnModel.setColumnVisible(key, visible, 'api');
  };
  /** Same as `setColumnVisible`, but provide a list of column keys. */
  ColumnApi.prototype.setColumnsVisible = function (keys, visible) {
    this.columnModel.setColumnsVisible(keys, visible, 'api');
  };
  /** Sets the column pinned / unpinned. Key can be the column ID, field, `ColDef` object or `Column` object. */
  ColumnApi.prototype.setColumnPinned = function (key, pinned) {
    this.columnModel.setColumnPinned(key, pinned, 'api');
  };
  /** Same as `setColumnPinned`, but provide a list of column keys. */
  ColumnApi.prototype.setColumnsPinned = function (keys, pinned) {
    this.columnModel.setColumnsPinned(keys, pinned, 'api');
  };
  /** Returns all the columns, regardless of visible or not. */
  ColumnApi.prototype.getAllColumns = function () {
    return this.columnModel.getAllPrimaryColumns();
  };
  /**
   * Returns all the grid columns, same as `getAllColumns()`, except
   *
   *  a) it has the order of the columns that are presented in the grid
   *
   *  b) it's after the 'pivot' step, so if pivoting, has the value columns for the pivot.
   */
  ColumnApi.prototype.getAllGridColumns = function () {
    return this.columnModel.getAllGridColumns();
  };
  /** Same as `getAllDisplayedColumns` but just for the pinned left portion of the grid. */
  ColumnApi.prototype.getDisplayedLeftColumns = function () {
    return this.columnModel.getDisplayedLeftColumns();
  };
  /** Same as `getAllDisplayedColumns` but just for the center portion of the grid. */
  ColumnApi.prototype.getDisplayedCenterColumns = function () {
    return this.columnModel.getDisplayedCenterColumns();
  };
  /** Same as `getAllDisplayedColumns` but just for the pinned right portion of the grid. */
  ColumnApi.prototype.getDisplayedRightColumns = function () {
    return this.columnModel.getDisplayedRightColumns();
  };
  /** Returns all columns currently displayed (e.g. are visible and if in a group, the group is showing the columns) for the pinned left, centre and pinned right portions of the grid. */
  ColumnApi.prototype.getAllDisplayedColumns = function () {
    return this.columnModel.getAllDisplayedColumns();
  };
  /** Same as `getAllGridColumns()`, except only returns rendered columns, i.e. columns that are not within the viewport and therefore not rendered, due to column virtualisation, are not displayed. */
  ColumnApi.prototype.getAllDisplayedVirtualColumns = function () {
    return this.columnModel.getViewportColumns();
  };
  /** Moves a column to `toIndex`. The column is first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */
  ColumnApi.prototype.moveColumn = function (key, toIndex) {
    if (typeof key === 'number') {
      // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
      console.warn('AG Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
      this.columnModel.moveColumnByIndex(key, toIndex, 'api');
    } else {
      this.columnModel.moveColumn(key, toIndex, 'api');
    }
  };
  /** Same as `moveColumn` but works on index locations. */
  ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) {
    this.columnModel.moveColumnByIndex(fromIndex, toIndex, 'api');
  };
  /** Same as `moveColumn` but works on list. */
  ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) {
    this.columnModel.moveColumns(columnsToMoveKeys, toIndex, 'api');
  };
  /** Move the column to a new position in the row grouping order. */
  ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) {
    this.columnModel.moveRowGroupColumn(fromIndex, toIndex);
  };
  /** Sets the agg function for a column. `aggFunc` can be one of `'min' | 'max' | 'sum'`. */
  ColumnApi.prototype.setColumnAggFunc = function (key, aggFunc) {
    this.columnModel.setColumnAggFunc(key, aggFunc);
  };
  /** Sets the column width on a single column. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */
  ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished, source) {
    if (finished === void 0) {
      finished = true;
    }
    this.columnModel.setColumnWidths([{
      key: key,
      newWidth: newWidth
    }], false, finished, source);
  };
  /** Sets the column widths on multiple columns. This method offers better performance than calling `setColumnWidth` multiple times. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */
  ColumnApi.prototype.setColumnWidths = function (columnWidths, finished, source) {
    if (finished === void 0) {
      finished = true;
    }
    this.columnModel.setColumnWidths(columnWidths, false, finished, source);
  };
  /** Set the pivot mode. */
  ColumnApi.prototype.setPivotMode = function (pivotMode) {
    this.columnModel.setPivotMode(pivotMode);
  };
  /** Get the pivot mode. */
  ColumnApi.prototype.isPivotMode = function () {
    return this.columnModel.isPivotMode();
  };
  /** Returns the pivot column for the given `pivotKeys` and `valueColId`. Useful to then call operations on the pivot column. */
  ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
    return this.columnModel.getSecondaryPivotColumn(pivotKeys, valueColKey);
  };
  ColumnApi.prototype.setValueColumns = function (colKeys) {
    this.columnModel.setValueColumns(colKeys, 'api');
  };
  /** Get value columns. */
  ColumnApi.prototype.getValueColumns = function () {
    return this.columnModel.getValueColumns();
  };
  /** Remove a value column. */
  ColumnApi.prototype.removeValueColumn = function (colKey) {
    this.columnModel.removeValueColumn(colKey, 'api');
  };
  /** Same as `removeValueColumns` but provide a list. */
  ColumnApi.prototype.removeValueColumns = function (colKeys) {
    this.columnModel.removeValueColumns(colKeys, 'api');
  };
  /** Add a value column. */
  ColumnApi.prototype.addValueColumn = function (colKey) {
    this.columnModel.addValueColumn(colKey, 'api');
  };
  /** Same as `addValueColumn` but provide a list. */
  ColumnApi.prototype.addValueColumns = function (colKeys) {
    this.columnModel.addValueColumns(colKeys, 'api');
  };
  /** Set the row group columns. */
  ColumnApi.prototype.setRowGroupColumns = function (colKeys) {
    this.columnModel.setRowGroupColumns(colKeys, 'api');
  };
  /** Remove a column from the row groups. */
  ColumnApi.prototype.removeRowGroupColumn = function (colKey) {
    this.columnModel.removeRowGroupColumn(colKey, 'api');
  };
  /** Same as `removeRowGroupColumn` but provide a list of columns. */
  ColumnApi.prototype.removeRowGroupColumns = function (colKeys) {
    this.columnModel.removeRowGroupColumns(colKeys, 'api');
  };
  /** Add a column to the row groups. */
  ColumnApi.prototype.addRowGroupColumn = function (colKey) {
    this.columnModel.addRowGroupColumn(colKey, 'api');
  };
  /** Same as `addRowGroupColumn` but provide a list of columns. */
  ColumnApi.prototype.addRowGroupColumns = function (colKeys) {
    this.columnModel.addRowGroupColumns(colKeys, 'api');
  };
  /** Get row group columns. */
  ColumnApi.prototype.getRowGroupColumns = function () {
    return this.columnModel.getRowGroupColumns();
  };
  /** Set the pivot columns. */
  ColumnApi.prototype.setPivotColumns = function (colKeys) {
    this.columnModel.setPivotColumns(colKeys, 'api');
  };
  /** Remove a pivot column. */
  ColumnApi.prototype.removePivotColumn = function (colKey) {
    this.columnModel.removePivotColumn(colKey, 'api');
  };
  /** Same as `removePivotColumn` but provide a list of columns. */
  ColumnApi.prototype.removePivotColumns = function (colKeys) {
    this.columnModel.removePivotColumns(colKeys, 'api');
  };
  /** Add a pivot column. */
  ColumnApi.prototype.addPivotColumn = function (colKey) {
    this.columnModel.addPivotColumn(colKey, 'api');
  };
  /** Same as `addPivotColumn` but provide a list of columns. */
  ColumnApi.prototype.addPivotColumns = function (colKeys) {
    this.columnModel.addPivotColumns(colKeys, 'api');
  };
  /** Get the pivot columns. */
  ColumnApi.prototype.getPivotColumns = function () {
    return this.columnModel.getPivotColumns();
  };
  /** Same as `getAllDisplayedColumnGroups` but just for the pinned left portion of the grid. */
  ColumnApi.prototype.getLeftDisplayedColumnGroups = function () {
    return this.columnModel.getDisplayedTreeLeft();
  };
  /** Same as `getAllDisplayedColumnGroups` but just for the center portion of the grid. */
  ColumnApi.prototype.getCenterDisplayedColumnGroups = function () {
    return this.columnModel.getDisplayedTreeCentre();
  };
  /** Same as `getAllDisplayedColumnGroups` but just for the pinned right portion of the grid. */
  ColumnApi.prototype.getRightDisplayedColumnGroups = function () {
    return this.columnModel.getDisplayedTreeRight();
  };
  /** Returns all 'root' column headers. If you are not grouping columns, these return the columns. If you are grouping, these return the top level groups - you can navigate down through each one to get the other lower level headers and finally the columns at the bottom. */
  ColumnApi.prototype.getAllDisplayedColumnGroups = function () {
    return this.columnModel.getAllDisplayedTrees();
  };
  /** Auto-sizes a column based on its contents. */
  ColumnApi.prototype.autoSizeColumn = function (key, skipHeader) {
    return this.columnModel.autoSizeColumn(key, skipHeader, 'api');
  };
  /** Same as `autoSizeColumn`, but provide a list of column keys. */
  ColumnApi.prototype.autoSizeColumns = function (keys, skipHeader) {
    return this.columnModel.autoSizeColumns(keys, skipHeader, 'api');
  };
  /** Calls `autoSizeColumns` on all displayed columns. */
  ColumnApi.prototype.autoSizeAllColumns = function (skipHeader) {
    this.columnModel.autoSizeAllColumns(skipHeader, 'api');
  };
  /** Set the secondary pivot columns. */
  ColumnApi.prototype.setSecondaryColumns = function (colDefs) {
    this.columnModel.setSecondaryColumns(colDefs, 'api');
  };
  /** Returns the grid's secondary columns. */
  ColumnApi.prototype.getSecondaryColumns = function () {
    return this.columnModel.getSecondaryColumns();
  };
  /** Returns the grid's primary columns. */
  ColumnApi.prototype.getPrimaryColumns = function () {
    return this.columnModel.getAllPrimaryColumns();
  };
  ColumnApi.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function () {
    // some users were raising support issues with regards memory leaks. the problem was the customers applications
    // were keeping references to the API. trying to educate them all would be difficult, easier to just remove
    // all references in teh API so at least the core grid can be garbage collected.
    //
    // wait about 100ms before clearing down the references, in case user has some cleanup to do,
    // and needs to deference the API first
    setTimeout(_.removeAllReferences.bind(window, this, 'Column API'), 100);
  };
  // below goes through deprecated items, prints message to user, then calls the new version of the same method
  // public getColumnDefs(): (ColDef | ColGroupDef)[] {
  //     this.setColumnGroupOpened(group, newValue);
  //     return null;
  // }
  /** @deprecated columnGroupOpened no longer exists, use setColumnGroupOpened */
  ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
    console.error('AG Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
    this.setColumnGroupOpened(group, newValue);
  };
  /** @deprecated hideColumns is deprecated, use setColumnsVisible */
  ColumnApi.prototype.hideColumns = function (colIds, hide) {
    console.error('AG Grid: hideColumns is deprecated, use setColumnsVisible');
    this.columnModel.setColumnsVisible(colIds, !hide, 'api');
  };
  /** @deprecated hideColumn is deprecated, use setColumnVisible */
  ColumnApi.prototype.hideColumn = function (colId, hide) {
    console.error('AG Grid: hideColumn is deprecated, use setColumnVisible');
    this.columnModel.setColumnVisible(colId, !hide, 'api');
  };
  /** @deprecated setState is deprecated, use setColumnState */
  ColumnApi.prototype.setState = function (columnState) {
    console.error('AG Grid: setState is deprecated, use setColumnState');
    return this.setColumnState(columnState);
  };
  /** @deprecated getState is deprecated, use getColumnState */
  ColumnApi.prototype.getState = function () {
    console.error('AG Grid: getState is deprecated, use getColumnState');
    return this.getColumnState();
  };
  /** @deprecated resetState is deprecated, use resetColumnState */
  ColumnApi.prototype.resetState = function () {
    console.error('AG Grid: resetState is deprecated, use resetColumnState');
    this.resetColumnState();
  };
  /** @deprecated getAggregationColumns is deprecated, use getValueColumns */
  ColumnApi.prototype.getAggregationColumns = function () {
    console.error('AG Grid: getAggregationColumns is deprecated, use getValueColumns');
    return this.columnModel.getValueColumns();
  };
  /** @deprecated removeAggregationColumn is deprecated, use removeValueColumn */
  ColumnApi.prototype.removeAggregationColumn = function (colKey) {
    console.error('AG Grid: removeAggregationColumn is deprecated, use removeValueColumn');
    this.columnModel.removeValueColumn(colKey, 'api');
  };
  /** @deprecated removeAggregationColumns is deprecated, use removeValueColumns */
  ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
    console.error('AG Grid: removeAggregationColumns is deprecated, use removeValueColumns');
    this.columnModel.removeValueColumns(colKeys, 'api');
  };
  /** @deprecated addAggregationColumn is deprecated, use addValueColumn */
  ColumnApi.prototype.addAggregationColumn = function (colKey) {
    console.error('AG Grid: addAggregationColumn is deprecated, use addValueColumn');
    this.columnModel.addValueColumn(colKey, 'api');
  };
  /** @deprecated addAggregationColumns is deprecated, use addValueColumns */
  ColumnApi.prototype.addAggregationColumns = function (colKeys) {
    console.error('AG Grid: addAggregationColumns is deprecated, use addValueColumns');
    this.columnModel.addValueColumns(colKeys, 'api');
  };
  /** @deprecated setColumnAggFunction is deprecated, use setColumnAggFunc */
  ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
    console.error('AG Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
    this.columnModel.setColumnAggFunc(column, aggFunc, 'api');
  };
  /** @deprecated getDisplayNameForCol is deprecated, use getDisplayNameForColumn */
  ColumnApi.prototype.getDisplayNameForCol = function (column) {
    console.error('AG Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
    return this.getDisplayNameForColumn(column, null);
  };
  /** @deprecated setColumnState is deprecated, use applyColumnState. */
  ColumnApi.prototype.setColumnState = function (columnState) {
    console.error('AG Grid: setColumnState is deprecated, use applyColumnState');
    return this.columnModel.applyColumnState({
      state: columnState,
      applyOrder: true
    }, 'api');
  };
  __decorate$H([Autowired('columnModel')], ColumnApi.prototype, "columnModel", void 0);
  __decorate$H([PreDestroy], ColumnApi.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null);
  ColumnApi = __decorate$H([Bean('columnApi')], ColumnApi);
  return ColumnApi;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var SelectionHandleType;
(function (SelectionHandleType) {
  SelectionHandleType[SelectionHandleType["FILL"] = 0] = "FILL";
  SelectionHandleType[SelectionHandleType["RANGE"] = 1] = "RANGE";
})(SelectionHandleType || (SelectionHandleType = {}));
var CellRangeType;
(function (CellRangeType) {
  CellRangeType[CellRangeType["VALUE"] = 0] = "VALUE";
  CellRangeType[CellRangeType["DIMENSION"] = 1] = "DIMENSION";
})(CellRangeType || (CellRangeType = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var CSS_CELL_RANGE_SELECTED = 'ag-cell-range-selected';
var CSS_CELL_RANGE_CHART = 'ag-cell-range-chart';
var CSS_CELL_RANGE_SINGLE_CELL = 'ag-cell-range-single-cell';
var CSS_CELL_RANGE_CHART_CATEGORY = 'ag-cell-range-chart-category';
var CSS_CELL_RANGE_HANDLE = 'ag-cell-range-handle';
var CSS_CELL_RANGE_TOP = 'ag-cell-range-top';
var CSS_CELL_RANGE_RIGHT = 'ag-cell-range-right';
var CSS_CELL_RANGE_BOTTOM = 'ag-cell-range-bottom';
var CSS_CELL_RANGE_LEFT = 'ag-cell-range-left';
var CellRangeFeature = /** @class */function () {
  function CellRangeFeature(beans, ctrl) {
    this.beans = beans;
    this.cellCtrl = ctrl;
  }
  CellRangeFeature.prototype.setComp = function (cellComp) {
    this.cellComp = cellComp;
    this.onRangeSelectionChanged();
  };
  CellRangeFeature.prototype.onRangeSelectionChanged = function () {
    this.rangeCount = this.beans.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition());
    this.hasChartRange = this.getHasChartRange();
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED, this.rangeCount !== 0);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED + "-1", this.rangeCount === 1);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED + "-2", this.rangeCount === 2);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED + "-3", this.rangeCount === 3);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED + "-4", this.rangeCount >= 4);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART, this.hasChartRange);
    this.cellComp.setAriaSelected(this.rangeCount > 0 ? true : undefined);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
    this.updateRangeBorders();
    this.refreshHandle();
  };
  CellRangeFeature.prototype.updateRangeBorders = function () {
    var rangeBorders = this.getRangeBorders();
    var isSingleCell = this.isSingleCell();
    var isTop = !isSingleCell && rangeBorders.top;
    var isRight = !isSingleCell && rangeBorders.right;
    var isBottom = !isSingleCell && rangeBorders.bottom;
    var isLeft = !isSingleCell && rangeBorders.left;
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_TOP, isTop);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_RIGHT, isRight);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_BOTTOM, isBottom);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_LEFT, isLeft);
  };
  CellRangeFeature.prototype.isSingleCell = function () {
    var rangeService = this.beans.rangeService;
    return this.rangeCount === 1 && rangeService && !rangeService.isMoreThanOneCell();
  };
  CellRangeFeature.prototype.getHasChartRange = function () {
    var rangeService = this.beans.rangeService;
    if (!this.rangeCount || !rangeService) {
      return false;
    }
    var cellRanges = rangeService.getCellRanges();
    return cellRanges.length > 0 && cellRanges.every(function (range) {
      return includes([CellRangeType.DIMENSION, CellRangeType.VALUE], range.type);
    });
  };
  CellRangeFeature.prototype.updateRangeBordersIfRangeCount = function () {
    // we only need to update range borders if we are in a range
    if (this.rangeCount > 0) {
      this.updateRangeBorders();
      this.refreshHandle();
    }
  };
  CellRangeFeature.prototype.getRangeBorders = function () {
    var _this = this;
    var isRtl = this.beans.gridOptionsWrapper.isEnableRtl();
    var top = false;
    var right = false;
    var bottom = false;
    var left = false;
    var thisCol = this.cellCtrl.getCellPosition().column;
    var _a = this.beans,
      rangeService = _a.rangeService,
      columnModel = _a.columnModel;
    var leftCol;
    var rightCol;
    if (isRtl) {
      leftCol = columnModel.getDisplayedColAfter(thisCol);
      rightCol = columnModel.getDisplayedColBefore(thisCol);
    } else {
      leftCol = columnModel.getDisplayedColBefore(thisCol);
      rightCol = columnModel.getDisplayedColAfter(thisCol);
    }
    var ranges = rangeService.getCellRanges().filter(function (range) {
      return rangeService.isCellInSpecificRange(_this.cellCtrl.getCellPosition(), range);
    });
    // this means we are the first column in the grid
    if (!leftCol) {
      left = true;
    }
    // this means we are the last column in the grid
    if (!rightCol) {
      right = true;
    }
    for (var i = 0; i < ranges.length; i++) {
      if (top && right && bottom && left) {
        break;
      }
      var range = ranges[i];
      var startRow = rangeService.getRangeStartRow(range);
      var endRow = rangeService.getRangeEndRow(range);
      if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellCtrl.getCellPosition())) {
        top = true;
      }
      if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellCtrl.getCellPosition())) {
        bottom = true;
      }
      if (!left && leftCol && range.columns.indexOf(leftCol) < 0) {
        left = true;
      }
      if (!right && rightCol && range.columns.indexOf(rightCol) < 0) {
        right = true;
      }
    }
    return {
      top: top,
      right: right,
      bottom: bottom,
      left: left
    };
  };
  CellRangeFeature.prototype.refreshHandle = function () {
    if (!this.beans.rangeService) {
      return;
    }
    var shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
    if (this.selectionHandle && !shouldHaveSelectionHandle) {
      this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
    }
    if (shouldHaveSelectionHandle) {
      this.addSelectionHandle();
    }
    this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
  };
  CellRangeFeature.prototype.shouldHaveSelectionHandle = function () {
    var _a = this.beans,
      gridOptionsWrapper = _a.gridOptionsWrapper,
      rangeService = _a.rangeService;
    var cellRanges = rangeService.getCellRanges();
    var rangesLen = cellRanges.length;
    if (this.rangeCount < 1 || rangesLen < 1) {
      return false;
    }
    var cellRange = last(cellRanges);
    var cellPosition = this.cellCtrl.getCellPosition();
    var isFillHandleAvailable = gridOptionsWrapper.isEnableFillHandle() && !this.cellCtrl.isSuppressFillHandle();
    var isRangeHandleAvailable = gridOptionsWrapper.isEnableRangeHandle();
    var handleIsAvailable = rangesLen === 1 && !this.cellCtrl.isEditing() && (isFillHandleAvailable || isRangeHandleAvailable);
    if (this.hasChartRange) {
      var hasCategoryRange = cellRanges[0].type === CellRangeType.DIMENSION;
      var isCategoryCell = hasCategoryRange && rangeService.isCellInSpecificRange(cellPosition, cellRanges[0]);
      this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
      handleIsAvailable = cellRange.type === CellRangeType.VALUE;
    }
    return handleIsAvailable && cellRange.endRow != null && rangeService.isContiguousRange(cellRange) && rangeService.isBottomRightCell(cellRange, cellPosition);
  };
  CellRangeFeature.prototype.addSelectionHandle = function () {
    var _a = this.beans,
      gridOptionsWrapper = _a.gridOptionsWrapper,
      rangeService = _a.rangeService;
    var cellRangeType = last(rangeService.getCellRanges()).type;
    var selectionHandleFill = gridOptionsWrapper.isEnableFillHandle() && missing(cellRangeType);
    var type = selectionHandleFill ? SelectionHandleType.FILL : SelectionHandleType.RANGE;
    if (this.selectionHandle && this.selectionHandle.getType() !== type) {
      this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
    }
    if (!this.selectionHandle) {
      this.selectionHandle = this.beans.selectionHandleFactory.createSelectionHandle(type);
    }
    this.selectionHandle.refresh(this.cellCtrl);
  };
  CellRangeFeature.prototype.destroy = function () {
    this.beans.context.destroyBean(this.selectionHandle);
  };
  return CellRangeFeature;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$O = undefined && undefined.__extends || function () {
  var _extendStatics51 = function extendStatics(d, b) {
    _extendStatics51 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics51(d, b);
  };
  return function (d, b) {
    _extendStatics51(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * Takes care of:
 *  #) Cell Width (including when doing cell spanning, which makes width cover many columns)
 *  #) Cell Height (when doing row span, otherwise we don't touch the height as it's just row height)
 *  #) Cell Left (the horizontal positioning of the cell, the vertical positioning is on the row)
 */
var CellPositionFeature = /** @class */function (_super) {
  __extends$O(CellPositionFeature, _super);
  function CellPositionFeature(ctrl, beans) {
    var _this = _super.call(this) || this;
    _this.cellCtrl = ctrl;
    _this.beans = beans;
    _this.column = ctrl.getColumn();
    _this.rowNode = ctrl.getRowNode();
    _this.setupColSpan();
    _this.setupRowSpan();
    return _this;
  }
  CellPositionFeature.prototype.setupRowSpan = function () {
    this.rowSpan = this.column.getRowSpan(this.rowNode);
  };
  CellPositionFeature.prototype.setComp = function (comp) {
    this.cellComp = comp;
    this.onLeftChanged();
    this.onWidthChanged();
    this.applyRowSpan();
  };
  CellPositionFeature.prototype.onDisplayColumnsChanged = function () {
    var colsSpanning = this.getColSpanningList();
    if (!areEqual(this.colsSpanning, colsSpanning)) {
      this.colsSpanning = colsSpanning;
      this.onWidthChanged();
      this.onLeftChanged(); // left changes when doing RTL
    }
  };

  CellPositionFeature.prototype.setupColSpan = function () {
    // if no col span is active, then we don't set it up, as it would be wasteful of CPU
    if (this.column.getColDef().colSpan == null) {
      return;
    }
    this.colsSpanning = this.getColSpanningList();
    // because we are col spanning, a reorder of the cols can change what cols we are spanning over
    this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
    // because we are spanning over multiple cols, we check for width any time any cols width changes.
    // this is expensive - really we should be explicitly checking only the cols we are spanning over
    // instead of every col, however it would be tricky code to track the cols we are spanning over, so
    // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
    this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
  };
  CellPositionFeature.prototype.onWidthChanged = function () {
    if (!this.cellComp) {
      return;
    }
    var width = this.getCellWidth();
    this.cellComp.setWidth(width + "px");
  };
  CellPositionFeature.prototype.getCellWidth = function () {
    if (!this.colsSpanning) {
      return this.column.getActualWidth();
    }
    return this.colsSpanning.reduce(function (width, col) {
      return width + col.getActualWidth();
    }, 0);
  };
  CellPositionFeature.prototype.getColSpanningList = function () {
    var colSpan = this.column.getColSpan(this.rowNode);
    var colsSpanning = [];
    // if just one col, the col span is just the column we are in
    if (colSpan === 1) {
      colsSpanning.push(this.column);
    } else {
      var pointer = this.column;
      var pinned = this.column.getPinned();
      for (var i = 0; pointer && i < colSpan; i++) {
        colsSpanning.push(pointer);
        pointer = this.beans.columnModel.getDisplayedColAfter(pointer);
        if (!pointer || missing(pointer)) {
          break;
        }
        // we do not allow col spanning to span outside of pinned areas
        if (pinned !== pointer.getPinned()) {
          break;
        }
      }
    }
    return colsSpanning;
  };
  CellPositionFeature.prototype.onLeftChanged = function () {
    if (!this.cellComp) {
      return;
    }
    var left = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.cellComp.setLeft(left + 'px');
  };
  CellPositionFeature.prototype.getCellLeft = function () {
    var mostLeftCol;
    if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
      mostLeftCol = last(this.colsSpanning);
    } else {
      mostLeftCol = this.column;
    }
    return mostLeftCol.getLeft();
  };
  CellPositionFeature.prototype.modifyLeftForPrintLayout = function (leftPosition) {
    if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === Constants.PINNED_LEFT) {
      return leftPosition;
    }
    var leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
    if (this.column.getPinned() === Constants.PINNED_RIGHT) {
      var bodyWidth = this.beans.columnModel.getBodyContainerWidth();
      return leftWidth + bodyWidth + (leftPosition || 0);
    }
    // is in body
    return leftWidth + (leftPosition || 0);
  };
  CellPositionFeature.prototype.applyRowSpan = function () {
    if (this.rowSpan === 1) {
      return;
    }
    var singleRowHeight = this.beans.gridOptionsWrapper.getRowHeightAsNumber();
    var totalRowHeight = singleRowHeight * this.rowSpan;
    this.cellComp.setHeight(totalRowHeight + "px");
    this.cellComp.setZIndex('1');
  };
  // overriding to make public, as we don't dispose this bean via context
  CellPositionFeature.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  return CellPositionFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$P = undefined && undefined.__extends || function () {
  var _extendStatics52 = function extendStatics(d, b) {
    _extendStatics52 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics52(d, b);
  };
  return function (d, b) {
    _extendStatics52(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CellCustomStyleFeature = /** @class */function (_super) {
  __extends$P(CellCustomStyleFeature, _super);
  function CellCustomStyleFeature(ctrl, beans) {
    var _this = _super.call(this) || this;
    _this.staticClasses = [];
    _this.cellCtrl = ctrl;
    _this.beans = beans;
    _this.column = ctrl.getColumn();
    _this.rowNode = ctrl.getRowNode();
    return _this;
  }
  CellCustomStyleFeature.prototype.setComp = function (comp, scope) {
    this.cellComp = comp;
    this.scope = scope;
    this.applyUserStyles();
    this.applyCellClassRules();
    this.applyClassesFromColDef();
  };
  CellCustomStyleFeature.prototype.applyCellClassRules = function () {
    var _this = this;
    var colDef = this.column.getColDef();
    var cellClassParams = {
      value: this.cellCtrl.getValue(),
      data: this.rowNode.data,
      node: this.rowNode,
      colDef: colDef,
      rowIndex: this.rowNode.rowIndex,
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      $scope: this.scope,
      context: this.beans.gridOptionsWrapper.getContext()
    };
    this.beans.stylingService.processClassRules(colDef.cellClassRules, cellClassParams, function (className) {
      return _this.cellComp.addOrRemoveCssClass(className, true);
    }, function (className) {
      return _this.cellComp.addOrRemoveCssClass(className, false);
    });
  };
  CellCustomStyleFeature.prototype.applyUserStyles = function () {
    var colDef = this.column.getColDef();
    if (!colDef.cellStyle) {
      return;
    }
    var styles;
    if (typeof colDef.cellStyle === 'function') {
      var cellStyleParams = {
        column: this.column,
        value: this.cellCtrl.getValue(),
        colDef: colDef,
        data: this.rowNode.data,
        node: this.rowNode,
        rowIndex: this.rowNode.rowIndex,
        $scope: this.scope,
        api: this.beans.gridOptionsWrapper.getApi(),
        columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
        context: this.beans.gridOptionsWrapper.getContext()
      };
      var cellStyleFunc = colDef.cellStyle;
      styles = cellStyleFunc(cellStyleParams);
    } else {
      styles = colDef.cellStyle;
    }
    this.cellComp.setUserStyles(styles);
  };
  CellCustomStyleFeature.prototype.applyClassesFromColDef = function () {
    var _this = this;
    var colDef = this.column.getColDef();
    var cellClassParams = {
      value: this.cellCtrl.getValue(),
      data: this.rowNode.data,
      node: this.rowNode,
      colDef: colDef,
      rowIndex: this.rowNode.rowIndex,
      $scope: this.scope,
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext()
    };
    if (this.staticClasses.length) {
      this.staticClasses.forEach(function (className) {
        return _this.cellComp.addOrRemoveCssClass(className, false);
      });
    }
    this.staticClasses = this.beans.stylingService.getStaticCellClasses(colDef, cellClassParams);
    if (this.staticClasses.length) {
      this.staticClasses.forEach(function (className) {
        return _this.cellComp.addOrRemoveCssClass(className, true);
      });
    }
  };
  // overriding to make public, as we don't dispose this bean via context
  CellCustomStyleFeature.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  return CellCustomStyleFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$Q = undefined && undefined.__extends || function () {
  var _extendStatics53 = function extendStatics(d, b) {
    _extendStatics53 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics53(d, b);
  };
  return function (d, b) {
    _extendStatics53(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TooltipFeature = /** @class */function (_super) {
  __extends$Q(TooltipFeature, _super);
  function TooltipFeature(ctrl, beans) {
    var _this = _super.call(this) || this;
    _this.ctrl = ctrl;
    _this.beans = beans;
    return _this;
  }
  TooltipFeature.prototype.setComp = function (comp) {
    this.comp = comp;
    this.setupTooltip();
  };
  TooltipFeature.prototype.setupTooltip = function () {
    this.browserTooltips = this.beans.gridOptionsWrapper.isEnableBrowserTooltips();
    this.updateTooltipText();
    if (this.browserTooltips) {
      this.comp.setTitle(this.tooltipSanatised != null ? this.tooltipSanatised : undefined);
    } else {
      this.createTooltipFeatureIfNeeded();
    }
  };
  TooltipFeature.prototype.updateTooltipText = function () {
    this.tooltip = this.ctrl.getTooltipValue();
    this.tooltipSanatised = escapeString(this.tooltip);
  };
  TooltipFeature.prototype.createTooltipFeatureIfNeeded = function () {
    var _this = this;
    if (this.genericTooltipFeature != null) {
      return;
    }
    var parent = {
      getTooltipParams: function getTooltipParams() {
        return _this.getTooltipParams();
      },
      getGui: function getGui() {
        return _this.ctrl.getGui();
      }
    };
    this.genericTooltipFeature = this.createManagedBean(new CustomTooltipFeature(parent), this.beans.context);
  };
  TooltipFeature.prototype.refreshToolTip = function () {
    this.updateTooltipText();
    if (this.browserTooltips) {
      this.comp.setTitle(this.tooltipSanatised != null ? this.tooltipSanatised : undefined);
    }
  };
  TooltipFeature.prototype.getTooltipParams = function () {
    var ctrl = this.ctrl;
    var column = ctrl.getColumn ? ctrl.getColumn() : undefined;
    var colDef = ctrl.getColDef ? ctrl.getColDef() : undefined;
    var rowNode = ctrl.getRowNode ? ctrl.getRowNode() : undefined;
    return {
      location: ctrl.getLocation(),
      colDef: colDef,
      column: column,
      rowIndex: ctrl.getRowIndex ? ctrl.getRowIndex() : undefined,
      node: rowNode,
      data: rowNode ? rowNode.data : undefined,
      value: this.getTooltipText(),
      valueFormatted: ctrl.getValueFormatted ? ctrl.getValueFormatted() : undefined
    };
  };
  TooltipFeature.prototype.getTooltipText = function () {
    return this.tooltip;
  };
  // overriding to make public, as we don't dispose this bean via context
  TooltipFeature.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  return TooltipFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$I = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/** Using the IoC has a slight performance consideration, which is no problem most of the
 * time, unless we are trashing objects - which is the case when scrolling and rowComp
 * and cellComp. So for performance reasons, RowComp and CellComp do not get autowired
 * with the IoC. Instead they get passed this object which is all the beans the RowComp
 * and CellComp need. Not autowiring all the cells gives performance improvement. */
var Beans = /** @class */function () {
  function Beans() {}
  Beans.prototype.postConstruct = function () {
    this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
    if (this.gridOptionsWrapper.isRowModelDefault()) {
      this.clientSideRowModel = this.rowModel;
    }
    if (this.gridOptionsWrapper.isRowModelServerSide()) {
      this.serverSideRowModel = this.rowModel;
    }
  };
  __decorate$I([Autowired('resizeObserverService')], Beans.prototype, "resizeObserverService", void 0);
  __decorate$I([Autowired('paginationProxy')], Beans.prototype, "paginationProxy", void 0);
  __decorate$I([Autowired('context')], Beans.prototype, "context", void 0);
  __decorate$I([Autowired('columnApi')], Beans.prototype, "columnApi", void 0);
  __decorate$I([Autowired('gridApi')], Beans.prototype, "gridApi", void 0);
  __decorate$I([Autowired('gridOptionsWrapper')], Beans.prototype, "gridOptionsWrapper", void 0);
  __decorate$I([Autowired('expressionService')], Beans.prototype, "expressionService", void 0);
  __decorate$I([Autowired('rowRenderer')], Beans.prototype, "rowRenderer", void 0);
  __decorate$I([Autowired('$compile')], Beans.prototype, "$compile", void 0);
  __decorate$I([Autowired('templateService')], Beans.prototype, "templateService", void 0);
  __decorate$I([Autowired('valueService')], Beans.prototype, "valueService", void 0);
  __decorate$I([Autowired('eventService')], Beans.prototype, "eventService", void 0);
  __decorate$I([Autowired('columnModel')], Beans.prototype, "columnModel", void 0);
  __decorate$I([Autowired('headerNavigationService')], Beans.prototype, "headerNavigationService", void 0);
  __decorate$I([Autowired('navigationService')], Beans.prototype, "navigationService", void 0);
  __decorate$I([Autowired('columnAnimationService')], Beans.prototype, "columnAnimationService", void 0);
  __decorate$I([Optional('rangeService')], Beans.prototype, "rangeService", void 0);
  __decorate$I([Autowired('focusService')], Beans.prototype, "focusService", void 0);
  __decorate$I([Optional('contextMenuFactory')], Beans.prototype, "contextMenuFactory", void 0);
  __decorate$I([Autowired('popupService')], Beans.prototype, "popupService", void 0);
  __decorate$I([Autowired('valueFormatterService')], Beans.prototype, "valueFormatterService", void 0);
  __decorate$I([Autowired('stylingService')], Beans.prototype, "stylingService", void 0);
  __decorate$I([Autowired('columnHoverService')], Beans.prototype, "columnHoverService", void 0);
  __decorate$I([Autowired('userComponentFactory')], Beans.prototype, "userComponentFactory", void 0);
  __decorate$I([Autowired('userComponentRegistry')], Beans.prototype, "userComponentRegistry", void 0);
  __decorate$I([Autowired('animationFrameService')], Beans.prototype, "animationFrameService", void 0);
  __decorate$I([Autowired('dragAndDropService')], Beans.prototype, "dragAndDropService", void 0);
  __decorate$I([Autowired('sortController')], Beans.prototype, "sortController", void 0);
  __decorate$I([Autowired('filterManager')], Beans.prototype, "filterManager", void 0);
  __decorate$I([Autowired('rowContainerHeightService')], Beans.prototype, "rowContainerHeightService", void 0);
  __decorate$I([Autowired('frameworkOverrides')], Beans.prototype, "frameworkOverrides", void 0);
  __decorate$I([Autowired('cellPositionUtils')], Beans.prototype, "cellPositionUtils", void 0);
  __decorate$I([Autowired('rowPositionUtils')], Beans.prototype, "rowPositionUtils", void 0);
  __decorate$I([Autowired('selectionService')], Beans.prototype, "selectionService", void 0);
  __decorate$I([Optional('selectionHandleFactory')], Beans.prototype, "selectionHandleFactory", void 0);
  __decorate$I([Autowired('rowCssClassCalculator')], Beans.prototype, "rowCssClassCalculator", void 0);
  __decorate$I([Autowired('rowModel')], Beans.prototype, "rowModel", void 0);
  __decorate$I([Autowired('ctrlsService')], Beans.prototype, "ctrlsService", void 0);
  __decorate$I([Autowired('ctrlsFactory')], Beans.prototype, "ctrlsFactory", void 0);
  __decorate$I([Autowired('agStackComponentsRegistry')], Beans.prototype, "agStackComponentsRegistry", void 0);
  __decorate$I([Autowired('valueCache')], Beans.prototype, "valueCache", void 0);
  __decorate$I([Autowired('rowNodeEventThrottle')], Beans.prototype, "rowNodeEventThrottle", void 0);
  __decorate$I([PostConstruct], Beans.prototype, "postConstruct", null);
  Beans = __decorate$I([Bean('beans')], Beans);
  return Beans;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$R = undefined && undefined.__extends || function () {
  var _extendStatics54 = function extendStatics(d, b) {
    _extendStatics54 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics54(d, b);
  };
  return function (d, b) {
    _extendStatics54(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CellMouseListenerFeature = /** @class */function (_super) {
  __extends$R(CellMouseListenerFeature, _super);
  function CellMouseListenerFeature(ctrl, beans, column) {
    var _this = _super.call(this) || this;
    _this.cellCtrl = ctrl;
    _this.beans = beans;
    _this.column = column;
    return _this;
  }
  CellMouseListenerFeature.prototype.onMouseEvent = function (eventName, mouseEvent) {
    if (isStopPropagationForAgGrid(mouseEvent)) {
      return;
    }
    switch (eventName) {
      case 'click':
        this.onCellClicked(mouseEvent);
        break;
      case 'mousedown':
      case 'touchstart':
        this.onMouseDown(mouseEvent);
        break;
      case 'dblclick':
        this.onCellDoubleClicked(mouseEvent);
        break;
      case 'mouseout':
        this.onMouseOut(mouseEvent);
        break;
      case 'mouseover':
        this.onMouseOver(mouseEvent);
        break;
    }
  };
  CellMouseListenerFeature.prototype.onCellClicked = function (mouseEvent) {
    // iPad doesn't have double click - so we need to mimic it to enable editing for iPad.
    if (this.isDoubleClickOnIPad()) {
      this.onCellDoubleClicked(mouseEvent);
      mouseEvent.preventDefault(); // if we don't do this, then iPad zooms in
      return;
    }
    var _a = this.beans,
      eventService = _a.eventService,
      gridOptionsWrapper = _a.gridOptionsWrapper;
    var cellClickedEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_CLICKED);
    eventService.dispatchEvent(cellClickedEvent);
    var colDef = this.column.getColDef();
    if (colDef.onCellClicked) {
      // to make callback async, do in a timeout
      window.setTimeout(function () {
        return colDef.onCellClicked(cellClickedEvent);
      }, 0);
    }
    var editOnSingleClick = (gridOptionsWrapper.isSingleClickEdit() || colDef.singleClickEdit) && !gridOptionsWrapper.isSuppressClickEdit();
    if (editOnSingleClick) {
      this.cellCtrl.startRowOrCellEdit();
    }
  };
  // returns true if on iPad and this is second 'click' event in 200ms
  CellMouseListenerFeature.prototype.isDoubleClickOnIPad = function () {
    if (!isIOSUserAgent() || isEventSupported('dblclick')) {
      return false;
    }
    var nowMillis = new Date().getTime();
    var res = nowMillis - this.lastIPadMouseClickEvent < 200;
    this.lastIPadMouseClickEvent = nowMillis;
    return res;
  };
  CellMouseListenerFeature.prototype.onCellDoubleClicked = function (mouseEvent) {
    var colDef = this.column.getColDef();
    // always dispatch event to eventService
    var cellDoubleClickedEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_DOUBLE_CLICKED);
    this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
    // check if colDef also wants to handle event
    if (typeof colDef.onCellDoubleClicked === 'function') {
      // to make the callback async, do in a timeout
      window.setTimeout(function () {
        return colDef.onCellDoubleClicked(cellDoubleClickedEvent);
      }, 0);
    }
    var editOnDoubleClick = !this.beans.gridOptionsWrapper.isSingleClickEdit() && !this.beans.gridOptionsWrapper.isSuppressClickEdit();
    if (editOnDoubleClick) {
      this.cellCtrl.startRowOrCellEdit();
    }
  };
  CellMouseListenerFeature.prototype.onMouseDown = function (mouseEvent) {
    var ctrlKey = mouseEvent.ctrlKey,
      metaKey = mouseEvent.metaKey,
      shiftKey = mouseEvent.shiftKey;
    var target = mouseEvent.target;
    var _a = this.beans,
      eventService = _a.eventService,
      rangeService = _a.rangeService;
    // do not change the range for right-clicks inside an existing range
    if (this.isRightClickInExistingRange(mouseEvent)) {
      return;
    }
    var ranges = rangeService && rangeService.getCellRanges().length != 0;
    if (!shiftKey || !ranges) {
      // We only need to pass true to focusCell when the browser is IE/Edge and we are trying
      // to focus the cell itself. This should never be true if the mousedown was triggered
      // due to a click on a cell editor for example.
      var forceBrowserFocus = (isBrowserIE() || isBrowserEdge()) && !this.cellCtrl.isEditing() && !isFocusableFormField(target);
      this.cellCtrl.focusCell(forceBrowserFocus);
    }
    // if shift clicking, and a range exists, we keep the focus on the cell that started the
    // range as the user then changes the range selection.
    if (shiftKey && ranges) {
      // this stops the cell from getting focused
      mouseEvent.preventDefault();
    }
    // if we are clicking on a checkbox, we need to make sure the cell wrapping that checkbox
    // is focused but we don't want to change the range selection, so return here.
    if (this.containsWidget(target)) {
      return;
    }
    if (rangeService) {
      var thisCell = this.cellCtrl.getCellPosition();
      if (shiftKey) {
        rangeService.extendLatestRangeToCell(thisCell);
      } else {
        var ctrlKeyPressed = ctrlKey || metaKey;
        rangeService.setRangeToCell(thisCell, ctrlKeyPressed);
      }
    }
    eventService.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_DOWN));
  };
  CellMouseListenerFeature.prototype.isRightClickInExistingRange = function (mouseEvent) {
    var rangeService = this.beans.rangeService;
    if (rangeService) {
      var cellInRange = rangeService.isCellInAnyRange(this.cellCtrl.getCellPosition());
      if (cellInRange && mouseEvent.button === 2) {
        return true;
      }
    }
    return false;
  };
  CellMouseListenerFeature.prototype.containsWidget = function (target) {
    return isElementChildOfClass(target, 'ag-selection-checkbox', 3);
  };
  CellMouseListenerFeature.prototype.onMouseOut = function (mouseEvent) {
    if (this.mouseStayingInsideCell(mouseEvent)) {
      return;
    }
    var cellMouseOutEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OUT);
    this.beans.eventService.dispatchEvent(cellMouseOutEvent);
    this.beans.columnHoverService.clearMouseOver();
  };
  CellMouseListenerFeature.prototype.onMouseOver = function (mouseEvent) {
    if (this.mouseStayingInsideCell(mouseEvent)) {
      return;
    }
    var cellMouseOverEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OVER);
    this.beans.eventService.dispatchEvent(cellMouseOverEvent);
    this.beans.columnHoverService.setMouseOver([this.column]);
  };
  CellMouseListenerFeature.prototype.mouseStayingInsideCell = function (e) {
    if (!e.target || !e.relatedTarget) {
      return false;
    }
    var eGui = this.cellCtrl.getGui();
    var cellContainsTarget = eGui.contains(e.target);
    var cellContainsRelatedTarget = eGui.contains(e.relatedTarget);
    return cellContainsTarget && cellContainsRelatedTarget;
  };
  CellMouseListenerFeature.prototype.destroy = function () {};
  return CellMouseListenerFeature;
}(Beans);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$S = undefined && undefined.__extends || function () {
  var _extendStatics55 = function extendStatics(d, b) {
    _extendStatics55 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics55(d, b);
  };
  return function (d, b) {
    _extendStatics55(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CellKeyboardListenerFeature = /** @class */function (_super) {
  __extends$S(CellKeyboardListenerFeature, _super);
  function CellKeyboardListenerFeature(ctrl, beans, column, rowNode, scope, rowCtrl) {
    var _this = _super.call(this) || this;
    _this.cellCtrl = ctrl;
    _this.beans = beans;
    _this.column = column;
    _this.rowNode = rowNode;
    _this.rowCtrl = rowCtrl;
    return _this;
  }
  CellKeyboardListenerFeature.prototype.setComp = function (eGui) {
    this.eGui = eGui;
  };
  CellKeyboardListenerFeature.prototype.onKeyDown = function (event) {
    var key = event.which || event.keyCode;
    switch (key) {
      case KeyCode.ENTER:
        this.onEnterKeyDown(event);
        break;
      case KeyCode.F2:
        this.onF2KeyDown();
        break;
      case KeyCode.ESCAPE:
        this.onEscapeKeyDown();
        break;
      case KeyCode.TAB:
        this.onTabKeyDown(event);
        break;
      case KeyCode.BACKSPACE:
      case KeyCode.DELETE:
        this.onBackspaceOrDeleteKeyPressed(key);
        break;
      case KeyCode.DOWN:
      case KeyCode.UP:
      case KeyCode.RIGHT:
      case KeyCode.LEFT:
        this.onNavigationKeyPressed(event, key);
        break;
    }
  };
  CellKeyboardListenerFeature.prototype.onNavigationKeyPressed = function (event, key) {
    if (this.cellCtrl.isEditing()) {
      return;
    }
    if (event.shiftKey && this.cellCtrl.isRangeSelectionEnabled()) {
      this.onShiftRangeSelect(key);
    } else {
      this.beans.navigationService.navigateToNextCell(event, key, this.cellCtrl.getCellPosition(), true);
    }
    // if we don't prevent default, the grid will scroll with the navigation keys
    event.preventDefault();
  };
  CellKeyboardListenerFeature.prototype.onShiftRangeSelect = function (key) {
    if (!this.beans.rangeService) {
      return;
    }
    var endCell = this.beans.rangeService.extendLatestRangeInDirection(key);
    if (endCell) {
      this.beans.navigationService.ensureCellVisible(endCell);
    }
  };
  CellKeyboardListenerFeature.prototype.onTabKeyDown = function (event) {
    this.beans.navigationService.onTabKeyDown(this.cellCtrl, event);
  };
  CellKeyboardListenerFeature.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
    if (!this.cellCtrl.isEditing()) {
      this.cellCtrl.startRowOrCellEdit(key);
    }
  };
  CellKeyboardListenerFeature.prototype.onEnterKeyDown = function (e) {
    if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing()) {
      this.cellCtrl.stopEditingAndFocus();
    } else {
      if (this.beans.gridOptionsWrapper.isEnterMovesDown()) {
        this.beans.navigationService.navigateToNextCell(null, KeyCode.DOWN, this.cellCtrl.getCellPosition(), false);
      } else {
        this.cellCtrl.startRowOrCellEdit(KeyCode.ENTER);
        if (this.cellCtrl.isEditing()) {
          // if we started editing, then we need to prevent default, otherwise the Enter action can get
          // applied to the cell editor. this happened, for example, with largeTextCellEditor where not
          // preventing default results in a 'new line' character getting inserted in the text area
          // when the editing was started
          e.preventDefault();
        }
      }
    }
  };
  CellKeyboardListenerFeature.prototype.onF2KeyDown = function () {
    if (!this.cellCtrl.isEditing()) {
      this.cellCtrl.startRowOrCellEdit(KeyCode.F2);
    }
  };
  CellKeyboardListenerFeature.prototype.onEscapeKeyDown = function () {
    if (this.cellCtrl.isEditing()) {
      this.cellCtrl.stopRowOrCellEdit(true);
      this.cellCtrl.focusCell(true);
    }
  };
  CellKeyboardListenerFeature.prototype.onKeyPress = function (event) {
    // check this, in case focus is on a (for example) a text field inside the cell,
    // in which cse we should not be listening for these key pressed
    var eventTarget = getTarget(event);
    var eventOnChildComponent = eventTarget !== this.eGui;
    if (eventOnChildComponent || this.cellCtrl.isEditing()) {
      return;
    }
    var pressedChar = String.fromCharCode(event.charCode);
    if (pressedChar === ' ') {
      this.onSpaceKeyPressed(event);
    } else if (isEventFromPrintableCharacter(event)) {
      this.cellCtrl.startRowOrCellEdit(null, pressedChar);
      // if we don't prevent default, then the keypress also gets applied to the text field
      // (at least when doing the default editor), but we need to allow the editor to decide
      // what it wants to do. we only do this IF editing was started - otherwise it messes
      // up when the use is not doing editing, but using rendering with text fields in cellRenderer
      // (as it would block the the user from typing into text fields).
      event.preventDefault();
    }
  };
  CellKeyboardListenerFeature.prototype.onSpaceKeyPressed = function (event) {
    var gridOptionsWrapper = this.beans.gridOptionsWrapper;
    if (!this.cellCtrl.isEditing() && gridOptionsWrapper.isRowSelection()) {
      var currentSelection = this.rowNode.isSelected();
      var newSelection = !currentSelection;
      if (newSelection || !gridOptionsWrapper.isSuppressRowDeselection()) {
        var groupSelectsFiltered = this.beans.gridOptionsWrapper.isGroupSelectsFiltered();
        var updatedCount = this.rowNode.setSelectedParams({
          newValue: newSelection,
          rangeSelect: event.shiftKey,
          groupSelectsFiltered: groupSelectsFiltered
        });
        if (currentSelection === undefined && updatedCount === 0) {
          this.rowNode.setSelectedParams({
            newValue: false,
            rangeSelect: event.shiftKey,
            groupSelectsFiltered: groupSelectsFiltered
          });
        }
      }
    }
    // prevent default as space key, by default, moves browser scroll down
    event.preventDefault();
  };
  CellKeyboardListenerFeature.prototype.destroy = function () {};
  return CellKeyboardListenerFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$T = undefined && undefined.__extends || function () {
  var _extendStatics56 = function extendStatics(d, b) {
    _extendStatics56 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics56(d, b);
  };
  return function (d, b) {
    _extendStatics56(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$J = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DndSourceComp = /** @class */function (_super) {
  __extends$T(DndSourceComp, _super);
  function DndSourceComp(rowNode, column, beans, eCell) {
    var _this = _super.call(this, "<div class=\"ag-drag-handle ag-row-drag\" draggable=\"true\"></div>") || this;
    _this.rowNode = rowNode;
    _this.column = column;
    _this.beans = beans;
    _this.eCell = eCell;
    return _this;
  }
  DndSourceComp.prototype.postConstruct = function () {
    var eGui = this.getGui();
    eGui.appendChild(createIconNoSpan('rowDrag', this.beans.gridOptionsWrapper, null));
    // we need to stop the event propagation here to avoid starting a range selection while dragging
    this.addGuiEventListener('mousedown', function (e) {
      e.stopPropagation();
    });
    this.addDragSource();
    this.checkVisibility();
  };
  DndSourceComp.prototype.addDragSource = function () {
    this.addGuiEventListener('dragstart', this.onDragStart.bind(this));
  };
  DndSourceComp.prototype.onDragStart = function (dragEvent) {
    var _this = this;
    var providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
    var isIE = isBrowserIE();
    if (!isIE) {
      dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
    }
    // default behaviour is to convert data to json and set into drag component
    var defaultOnRowDrag = function defaultOnRowDrag() {
      try {
        var jsonData = JSON.stringify(_this.rowNode.data);
        if (isIE) {
          dragEvent.dataTransfer.setData('text', jsonData);
        } else {
          dragEvent.dataTransfer.setData('application/json', jsonData);
          dragEvent.dataTransfer.setData('text/plain', jsonData);
        }
      } catch (e) {
        // if we cannot convert the data to json, then we do not set the type
      }
    };
    if (providedOnRowDrag) {
      providedOnRowDrag({
        rowNode: this.rowNode,
        dragEvent: dragEvent
      });
    } else {
      defaultOnRowDrag();
    }
  };
  DndSourceComp.prototype.checkVisibility = function () {
    var visible = this.column.isDndSource(this.rowNode);
    this.setDisplayed(visible);
  };
  __decorate$J([PostConstruct], DndSourceComp.prototype, "postConstruct", null);
  return DndSourceComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$U = undefined && undefined.__extends || function () {
  var _extendStatics57 = function extendStatics(d, b) {
    _extendStatics57 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics57(d, b);
  };
  return function (d, b) {
    _extendStatics57(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$8 = undefined && undefined.__assign || function () {
  __assign$8 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$8.apply(this, arguments);
};
var CSS_CELL = 'ag-cell';
var CSS_AUTO_HEIGHT = 'ag-cell-auto-height';
var CSS_NORMAL_HEIGHT = 'ag-cell-normal-height';
var CSS_CELL_FOCUS = 'ag-cell-focus';
var CSS_CELL_FIRST_RIGHT_PINNED = 'ag-cell-first-right-pinned';
var CSS_CELL_LAST_LEFT_PINNED = 'ag-cell-last-left-pinned';
var CSS_CELL_NOT_INLINE_EDITING = 'ag-cell-not-inline-editing';
var CSS_CELL_INLINE_EDITING = 'ag-cell-inline-editing';
var CSS_CELL_POPUP_EDITING = 'ag-cell-popup-editing';
var CSS_COLUMN_HOVER = 'ag-column-hover';
var CSS_CELL_WRAP_TEXT = 'ag-cell-wrap-text';
var instanceIdSequence$1 = 0;
var CellCtrl = /** @class */function (_super) {
  __extends$U(CellCtrl, _super);
  function CellCtrl(column, rowNode, beans, rowCtrl) {
    var _this = _super.call(this) || this;
    _this.suppressRefreshCell = false;
    _this.column = column;
    _this.rowNode = rowNode;
    _this.beans = beans;
    _this.rowCtrl = rowCtrl;
    // unique id to this instance, including the column ID to help with debugging in React as it's used in 'key'
    _this.instanceId = column.getId() + '-' + instanceIdSequence$1++;
    _this.createCellPosition();
    _this.addFeatures();
    return _this;
  }
  CellCtrl.prototype.addFeatures = function () {
    var _this = this;
    this.cellPositionFeature = new CellPositionFeature(this, this.beans);
    this.addDestroyFunc(function () {
      return _this.cellPositionFeature.destroy();
    });
    this.cellCustomStyleFeature = new CellCustomStyleFeature(this, this.beans);
    this.addDestroyFunc(function () {
      return _this.cellCustomStyleFeature.destroy();
    });
    this.cellMouseListenerFeature = new CellMouseListenerFeature(this, this.beans, this.column);
    this.addDestroyFunc(function () {
      return _this.cellMouseListenerFeature.destroy();
    });
    this.cellKeyboardListenerFeature = new CellKeyboardListenerFeature(this, this.beans, this.column, this.rowNode, this.scope, this.rowCtrl);
    this.addDestroyFunc(function () {
      return _this.cellKeyboardListenerFeature.destroy();
    });
    var rangeSelectionEnabled = this.beans.rangeService && this.beans.gridOptionsWrapper.isEnableRangeSelection();
    if (rangeSelectionEnabled) {
      this.cellRangeFeature = new CellRangeFeature(this.beans, this);
      this.addDestroyFunc(function () {
        return _this.cellRangeFeature.destroy();
      });
    }
    this.addTooltipFeature();
  };
  CellCtrl.prototype.addTooltipFeature = function () {
    var _this = this;
    var getTooltipValue = function getTooltipValue() {
      var colDef = _this.column.getColDef();
      var data = _this.rowNode.data;
      if (colDef.tooltipField && exists(data)) {
        return getValueUsingField(data, colDef.tooltipField, _this.column.isTooltipFieldContainsDots());
      }
      var valueGetter = colDef.tooltipValueGetter;
      if (valueGetter) {
        return valueGetter({
          location: 'cell',
          api: _this.beans.gridOptionsWrapper.getApi(),
          columnApi: _this.beans.gridOptionsWrapper.getColumnApi(),
          context: _this.beans.gridOptionsWrapper.getContext(),
          colDef: _this.column.getColDef(),
          column: _this.column,
          rowIndex: _this.cellPosition.rowIndex,
          node: _this.rowNode,
          data: _this.rowNode.data,
          value: _this.value,
          valueFormatted: _this.valueFormatted
        });
      }
      return null;
    };
    var tooltipCtrl = {
      getColumn: function getColumn() {
        return _this.column;
      },
      getColDef: function getColDef() {
        return _this.column.getColDef();
      },
      getRowIndex: function getRowIndex() {
        return _this.cellPosition.rowIndex;
      },
      getRowNode: function getRowNode() {
        return _this.rowNode;
      },
      getGui: function getGui() {
        return _this.getGui();
      },
      getLocation: function getLocation() {
        return 'cell';
      },
      getTooltipValue: getTooltipValue,
      // this makes no sense, why is the cell formatted value passed to the tooltip???
      getValueFormatted: function getValueFormatted() {
        return _this.valueFormatted;
      }
    };
    this.tooltipFeature = new TooltipFeature(tooltipCtrl, this.beans);
    this.addDestroyFunc(function () {
      return _this.tooltipFeature.destroy();
    });
  };
  CellCtrl.prototype.setComp = function (comp, scope, eGui, printLayout, startEditing) {
    this.cellComp = comp;
    this.gow = this.beans.gridOptionsWrapper;
    this.scope = scope;
    this.eGui = eGui;
    this.printLayout = printLayout;
    // we force to make sure formatter gets called at least once,
    // even if value has not changed (is is undefined)
    this.updateAndFormatValue(true);
    this.addDomData();
    this.onCellFocused();
    this.applyStaticCssClasses();
    this.setWrapText();
    this.onFirstRightPinnedChanged();
    this.onLastLeftPinnedChanged();
    this.onColumnHover();
    this.setupControlComps();
    this.setupAriaExpanded();
    this.setupAutoHeight();
    var colIdSanitised = escapeString(this.column.getId());
    var ariaColIndex = this.beans.columnModel.getAriaColumnIndex(this.column);
    this.cellComp.setTabIndex(-1);
    this.cellComp.setRole('gridcell');
    this.cellComp.setAriaColIndex(ariaColIndex);
    this.cellComp.setColId(colIdSanitised);
    this.cellComp.setUnselectable(!this.beans.gridOptionsWrapper.isEnableCellTextSelection() ? 'on' : null);
    this.cellPositionFeature.setComp(comp);
    this.cellCustomStyleFeature.setComp(comp, scope);
    this.tooltipFeature.setComp(comp);
    this.cellKeyboardListenerFeature.setComp(this.eGui);
    if (this.cellRangeFeature) {
      this.cellRangeFeature.setComp(comp);
    }
    if (startEditing && this.isCellEditable()) {
      this.startEditing();
    } else {
      this.showValue();
    }
  };
  CellCtrl.prototype.setupAutoHeight = function () {
    var _this = this;
    if (!this.column.getColDef().autoHeight) {
      return;
    }
    var measureHeight = function measureHeight(timesCalled) {
      // if not in doc yet, means framework not yet inserted, so wait for next VM turn,
      // maybe it will be ready next VM turn
      var doc = _this.beans.gridOptionsWrapper.getDocument();
      if ((!doc || !doc.contains(_this.eGui)) && timesCalled < 5) {
        _this.beans.frameworkOverrides.setTimeout(function () {
          return measureHeight(timesCalled++);
        }, 0);
        return;
      }
      var newHeight = _this.eGui.offsetHeight;
      _this.rowNode.setRowAutoHeight(newHeight, _this.column);
    };
    var listener = function listener() {
      return measureHeight(0);
    };
    // do once to set size in case size doesn't change, common when cell is blank
    listener();
    var destroyResizeObserver = this.beans.resizeObserverService.observeResize(this.eGui, listener);
    this.addDestroyFunc(function () {
      destroyResizeObserver();
      _this.rowNode.setRowAutoHeight(undefined, _this.column);
    });
  };
  CellCtrl.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  CellCtrl.prototype.showValue = function (forceNewCellRendererInstance) {
    if (forceNewCellRendererInstance === void 0) {
      forceNewCellRendererInstance = false;
    }
    var valueToDisplay = this.valueFormatted != null ? this.valueFormatted : this.value;
    var params = this.createCellRendererParams();
    var compDetails = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), params);
    this.cellComp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
    this.refreshHandle();
  };
  CellCtrl.prototype.setupControlComps = function () {
    var colDef = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(colDef.checkboxSelection);
    this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
    this.includeDndSource = this.isIncludeControl(colDef.dndSource);
    // text selection requires the value to be wrapped in another element
    var forceWrapper = this.beans.gridOptionsWrapper.isEnableCellTextSelection() || this.column.getColDef().autoHeight == true;
    this.cellComp.setIncludeSelection(this.includeSelection);
    this.cellComp.setIncludeDndSource(this.includeDndSource);
    this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    this.cellComp.setForceWrapper(forceWrapper);
  };
  CellCtrl.prototype.isIncludeControl = function (value) {
    var rowNodePinned = this.rowNode.rowPinned != null;
    var isFunc = typeof value === 'function';
    var res = rowNodePinned ? false : isFunc || value === true;
    return res;
  };
  CellCtrl.prototype.setupAriaExpanded = function () {
    var _this = this;
    var colDef = this.column.getColDef();
    if (!this.rowNode.isExpandable()) {
      return;
    }
    var showRowGroup = colDef.showRowGroup;
    var rowGroupColumn = this.rowNode.rowGroupColumn;
    var showingAllGroups = showRowGroup === true;
    var showingThisGroup = rowGroupColumn && rowGroupColumn.getColId() === showRowGroup;
    var colMatches = showingAllGroups || showingThisGroup;
    if (!colMatches) {
      return;
    }
    var listener = function listener() {
      _this.cellComp.setAriaExpanded(!!_this.rowNode.expanded);
    };
    this.addManagedListener(this.rowNode, RowNode.EVENT_EXPANDED_CHANGED, listener);
    listener();
  };
  CellCtrl.prototype.refreshShouldDestroy = function () {
    var colDef = this.column.getColDef();
    var selectionChanged = this.includeSelection != this.isIncludeControl(colDef.checkboxSelection);
    var rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
    var dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
    return selectionChanged || rowDragChanged || dndSourceChanged;
  };
  // either called internally if single cell editing, or called by rowRenderer if row editing
  CellCtrl.prototype.startEditing = function (keyPress, charPress, cellStartedEdit) {
    if (keyPress === void 0) {
      keyPress = null;
    }
    if (charPress === void 0) {
      charPress = null;
    }
    if (cellStartedEdit === void 0) {
      cellStartedEdit = false;
    }
    if (!this.isCellEditable() || this.editing) {
      return;
    }
    var editorParams = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
    var colDef = this.column.getColDef();
    var compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
    var popup = !!colDef.cellEditorPopup;
    var position = colDef.cellEditorPopupPosition;
    this.setEditing(true, popup);
    this.cellComp.setEditDetails(compDetails, popup, position);
    var event = this.createEvent(null, Events.EVENT_CELL_EDITING_STARTED);
    this.beans.eventService.dispatchEvent(event);
  };
  CellCtrl.prototype.setEditing = function (editing, inPopup) {
    if (inPopup === void 0) {
      inPopup = false;
    }
    if (this.editing === editing) {
      return;
    }
    this.editing = editing;
    this.editingInPopup = inPopup;
    this.setInlineEditingClass();
  };
  // pass in 'true' to cancel the editing.
  CellCtrl.prototype.stopRowOrCellEdit = function (cancel) {
    if (cancel === void 0) {
      cancel = false;
    }
    if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
      this.rowCtrl.stopRowEditing(cancel);
    } else {
      this.stopEditing(cancel);
    }
  };
  CellCtrl.prototype.onPopupEditorClosed = function () {
    if (!this.isEditing()) {
      return;
    }
    // note: this happens because of a click outside of the grid or if the popupEditor
    // is closed with `Escape` key. if another cell was clicked, then the editing will
    // have already stopped and returned on the conditional above.
    this.stopEditingAndFocus();
  };
  CellCtrl.prototype.takeValueFromCellEditor = function (cancel) {
    var noValueResult = {
      newValueExists: false
    };
    if (cancel) {
      return noValueResult;
    }
    var cellEditor = this.cellComp.getCellEditor();
    if (!cellEditor) {
      return noValueResult;
    }
    var userWantsToCancel = cellEditor.isCancelAfterEnd && cellEditor.isCancelAfterEnd();
    if (userWantsToCancel) {
      return noValueResult;
    }
    var newValue = cellEditor.getValue();
    return {
      newValue: newValue,
      newValueExists: true
    };
  };
  CellCtrl.prototype.saveNewValue = function (oldValue, newValue) {
    if (newValue !== oldValue) {
      // we suppressRefreshCell because the call to rowNode.setDataValue() results in change detection
      // getting triggered, which results in all cells getting refreshed. we do not want this refresh
      // to happen on this call as we want to call it explicitly below. otherwise refresh gets called twice.
      // if we only did this refresh (and not the one below) then the cell would flash and not be forced.
      this.suppressRefreshCell = true;
      this.rowNode.setDataValue(this.column, newValue);
      this.suppressRefreshCell = false;
    }
  };
  CellCtrl.prototype.stopEditing = function (cancel) {
    if (cancel === void 0) {
      cancel = false;
    }
    if (!this.editing) {
      return;
    }
    var _a = this.takeValueFromCellEditor(cancel),
      newValue = _a.newValue,
      newValueExists = _a.newValueExists;
    var oldValue = this.getValueFromValueService();
    if (newValueExists) {
      this.saveNewValue(oldValue, newValue);
    }
    this.setEditing(false);
    this.cellComp.setEditDetails(); // passing nothing stops editing
    this.updateAndFormatValue();
    this.refreshCell({
      forceRefresh: true,
      suppressFlash: true
    });
    this.dispatchEditingStoppedEvent(oldValue, newValue);
  };
  CellCtrl.prototype.dispatchEditingStoppedEvent = function (oldValue, newValue) {
    var editingStoppedEvent = __assign$8(__assign$8({}, this.createEvent(null, Events.EVENT_CELL_EDITING_STOPPED)), {
      oldValue: oldValue,
      newValue: newValue
    });
    this.beans.eventService.dispatchEvent(editingStoppedEvent);
  };
  // if we are editing inline, then we don't have the padding in the cell (set in the themes)
  // to allow the text editor full access to the entire cell
  CellCtrl.prototype.setInlineEditingClass = function () {
    if (!this.isAlive()) {
      return;
    }
    // ag-cell-inline-editing - appears when user is inline editing
    // ag-cell-not-inline-editing - appears when user is no inline editing
    // ag-cell-popup-editing - appears when user is editing cell in popup (appears on the cell, not on the popup)
    // note: one of {ag-cell-inline-editing, ag-cell-not-inline-editing} is always present, they toggle.
    //       however {ag-cell-popup-editing} shows when popup, so you have both {ag-cell-popup-editing}
    //       and {ag-cell-not-inline-editing} showing at the same time.
    var editingInline = this.editing && !this.editingInPopup;
    var popupEditorShowing = this.editing && this.editingInPopup;
    this.cellComp.addOrRemoveCssClass(CSS_CELL_INLINE_EDITING, editingInline);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_NOT_INLINE_EDITING, !editingInline);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_POPUP_EDITING, popupEditorShowing);
    this.rowCtrl.setInlineEditingCss(this.editing);
  };
  // this is needed as the JS CellComp still allows isPopup() on the CellEditor class, so
  // it's possible the editor is in a popup even though it's not configured via the colDef as so
  CellCtrl.prototype.hackSayEditingInPopup = function () {
    if (this.editingInPopup) {
      return;
    }
    this.editingInPopup = true;
    this.setInlineEditingClass();
  };
  CellCtrl.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
    var res = {
      value: this.getValueFromValueService(),
      keyPress: keyPress,
      charPress: charPress,
      column: this.column,
      colDef: this.column.getColDef(),
      rowIndex: this.getCellPosition().rowIndex,
      node: this.rowNode,
      data: this.rowNode.data,
      api: this.beans.gridOptionsWrapper.getApi(),
      cellStartedEdit: cellStartedEdit,
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext(),
      onKeyDown: this.onKeyDown.bind(this),
      stopEditing: this.stopEditingAndFocus.bind(this),
      eGridCell: this.getGui(),
      parseValue: this.parseValue.bind(this),
      formatValue: this.formatValue.bind(this)
    };
    if (this.scope) {
      res.$scope = this.scope;
    }
    return res;
  };
  CellCtrl.prototype.createCellRendererParams = function () {
    var _this = this;
    var addRowCompListener = function addRowCompListener(eventType, listener) {
      console.warn('AG Grid: since AG Grid v26, params.addRowCompListener() is deprecated. If you need this functionality, please contact AG Grid support and advise why so that we can revert with an appropriate workaround, as we dont have any valid use cases for it. This method was originally provided as a work around to know when cells were destroyed in AG Grid before custom Cell Renderers could be provided.');
      _this.rowCtrl.addEventListener(eventType, listener);
    };
    var res = {
      value: this.value,
      valueFormatted: this.valueFormatted,
      getValue: this.getValueFromValueService.bind(this),
      setValue: function setValue(value) {
        return _this.beans.valueService.setValue(_this.rowNode, _this.column, value);
      },
      formatValue: this.formatValue.bind(this),
      data: this.rowNode.data,
      node: this.rowNode,
      colDef: this.column.getColDef(),
      column: this.column,
      rowIndex: this.getCellPosition().rowIndex,
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext(),
      refreshCell: this.refreshCell.bind(this),
      eGridCell: this.getGui(),
      eParentOfValue: this.cellComp.getParentOfValue(),
      registerRowDragger: function registerRowDragger(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange) {
        return _this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange);
      },
      // this function is not documented anywhere, so we could drop it
      // it was in the olden days to allow user to register for when rendered
      // row was removed (the row comp was removed), however now that the user
      // can provide components for cells, the destroy method gets call when this
      // happens so no longer need to fire event.
      addRowCompListener: addRowCompListener
    };
    if (this.scope) {
      res.$scope = this.scope;
    }
    return res;
  };
  CellCtrl.prototype.parseValue = function (newValue) {
    var colDef = this.column.getColDef();
    var params = {
      node: this.rowNode,
      data: this.rowNode.data,
      oldValue: this.getValue(),
      newValue: newValue,
      colDef: colDef,
      column: this.column,
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext()
    };
    var valueParser = colDef.valueParser;
    return exists(valueParser) ? this.beans.expressionService.evaluate(valueParser, params) : newValue;
  };
  CellCtrl.prototype.setFocusOutOnEditor = function () {
    if (!this.editing) {
      return;
    }
    var cellEditor = this.cellComp.getCellEditor();
    if (cellEditor && cellEditor.focusOut) {
      cellEditor.focusOut();
    }
  };
  CellCtrl.prototype.setFocusInOnEditor = function () {
    if (!this.editing) {
      return;
    }
    var cellEditor = this.cellComp.getCellEditor();
    if (cellEditor && cellEditor.focusIn) {
      // if the editor is present, then we just focus it
      cellEditor.focusIn();
    } else {
      // if the editor is not present, it means async cell editor (eg React fibre)
      // and we are trying to set focus before the cell editor is present, so we
      // focus the cell instead
      this.focusCell(true);
    }
  };
  CellCtrl.prototype.onCellChanged = function (event) {
    var eventImpactsThisCell = event.column === this.column;
    if (eventImpactsThisCell) {
      this.refreshCell({});
    }
  };
  // + stop editing {forceRefresh: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  CellCtrl.prototype.refreshCell = function (params) {
    // if we are in the middle of 'stopEditing', then we don't refresh here, as refresh gets called explicitly
    if (this.suppressRefreshCell || this.editing) {
      return;
    }
    var colDef = this.column.getColDef();
    var newData = params != null && !!params.newData;
    var suppressFlash = params != null && !!params.suppressFlash || !!colDef.suppressCellFlash;
    // we always refresh if cell has no value - this can happen when user provides Cell Renderer and the
    // cell renderer doesn't rely on a value, instead it could be looking directly at the data, or maybe
    // printing the current time (which would be silly)???. Generally speaking
    // non of {field, valueGetter, showRowGroup} is bad in the users application, however for this edge case, it's
    // best always refresh and take the performance hit rather than never refresh and users complaining in support
    // that cells are not updating.
    var noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
    var forceRefresh = params && params.forceRefresh || noValueProvided || newData;
    var valuesDifferent = this.updateAndFormatValue();
    var dataNeedsUpdating = forceRefresh || valuesDifferent;
    if (dataNeedsUpdating) {
      // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
      // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
      // then we are not showing a movement in the stock price, rather we are showing different stock.
      this.showValue(newData);
      // we don't want to flash the cells when processing a filter change, as otherwise the UI would
      // be to busy. see comment in FilterManager with regards processingFilterChange
      var processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
      var flashCell = !suppressFlash && !processingFilterChange && (this.beans.gridOptionsWrapper.isEnableCellChangeFlash() || colDef.enableCellChangeFlash);
      if (flashCell) {
        this.flashCell();
      }
      this.cellCustomStyleFeature.applyUserStyles();
      this.cellCustomStyleFeature.applyClassesFromColDef();
    }
    // we can't readily determine if the data in an angularjs template has changed, so here we just update
    // and recompile (if applicable)
    this.refreshToolTip();
    // we do cellClassRules even if the value has not changed, so that users who have rules that
    // look at other parts of the row (where the other part of the row might of changed) will work.
    this.cellCustomStyleFeature.applyCellClassRules();
  };
  // cell editors call this, when they want to stop for reasons other
  // than what we pick up on. eg selecting from a dropdown ends editing.
  CellCtrl.prototype.stopEditingAndFocus = function (suppressNavigateAfterEdit) {
    if (suppressNavigateAfterEdit === void 0) {
      suppressNavigateAfterEdit = false;
    }
    this.stopRowOrCellEdit();
    this.focusCell(true);
    if (!suppressNavigateAfterEdit) {
      this.navigateAfterEdit();
    }
  };
  CellCtrl.prototype.navigateAfterEdit = function () {
    var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
    if (fullRowEdit) {
      return;
    }
    var enterMovesDownAfterEdit = this.beans.gridOptionsWrapper.isEnterMovesDownAfterEdit();
    if (enterMovesDownAfterEdit) {
      this.beans.navigationService.navigateToNextCell(null, KeyCode.DOWN, this.getCellPosition(), false);
    }
  };
  // user can also call this via API
  CellCtrl.prototype.flashCell = function (delays) {
    var flashDelay = delays && delays.flashDelay;
    var fadeDelay = delays && delays.fadeDelay;
    this.animateCell('data-changed', flashDelay, fadeDelay);
  };
  CellCtrl.prototype.animateCell = function (cssName, flashDelay, fadeDelay) {
    var _this = this;
    var fullName = "ag-cell-" + cssName;
    var animationFullName = "ag-cell-" + cssName + "-animation";
    var gridOptionsWrapper = this.beans.gridOptionsWrapper;
    if (!flashDelay) {
      flashDelay = gridOptionsWrapper.getCellFlashDelay();
    }
    if (!exists(fadeDelay)) {
      fadeDelay = gridOptionsWrapper.getCellFadeDelay();
    }
    // we want to highlight the cells, without any animation
    this.cellComp.addOrRemoveCssClass(fullName, true);
    this.cellComp.addOrRemoveCssClass(animationFullName, false);
    // then once that is applied, we remove the highlight with animation
    window.setTimeout(function () {
      _this.cellComp.addOrRemoveCssClass(fullName, false);
      _this.cellComp.addOrRemoveCssClass(animationFullName, true);
      _this.cellComp.setTransition("background-color " + fadeDelay + "ms");
      window.setTimeout(function () {
        // and then to leave things as we got them, we remove the animation
        _this.cellComp.addOrRemoveCssClass(animationFullName, false);
        _this.cellComp.setTransition('transition');
      }, fadeDelay);
    }, flashDelay);
  };
  CellCtrl.prototype.onFlashCells = function (event) {
    var cellId = this.beans.cellPositionUtils.createId(this.getCellPosition());
    var shouldFlash = event.cells[cellId];
    if (shouldFlash) {
      this.animateCell('highlight');
    }
  };
  CellCtrl.prototype.isCellEditable = function () {
    return this.column.isCellEditable(this.rowNode);
  };
  CellCtrl.prototype.isSuppressFillHandle = function () {
    return this.column.isSuppressFillHandle();
  };
  CellCtrl.prototype.formatValue = function (value) {
    var res = this.callValueFormatter(value);
    return res != null ? res : value;
  };
  CellCtrl.prototype.callValueFormatter = function (value) {
    return this.beans.valueFormatterService.formatValue(this.column, this.rowNode, this.scope, value);
  };
  CellCtrl.prototype.updateAndFormatValue = function (force) {
    if (force === void 0) {
      force = false;
    }
    var oldValue = this.value;
    var oldValueFormatted = this.valueFormatted;
    this.value = this.getValueFromValueService();
    this.valueFormatted = this.callValueFormatter(this.value);
    var valuesDifferent = force ? true : !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
    return valuesDifferent;
  };
  CellCtrl.prototype.valuesAreEqual = function (val1, val2) {
    // if the user provided an equals method, use that, otherwise do simple comparison
    var colDef = this.column.getColDef();
    return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
  };
  CellCtrl.prototype.getComp = function () {
    return this.cellComp;
  };
  CellCtrl.prototype.getValueFromValueService = function () {
    // if we don't check this, then the grid will render leaf groups as open even if we are not
    // allowing the user to open leaf groups. confused? remember for pivot mode we don't allow
    // opening leaf groups, so we have to force leafGroups to be closed in case the user expanded
    // them via the API, or user user expanded them in the UI before turning on pivot mode
    var lockedClosedGroup = this.rowNode.leafGroup && this.beans.columnModel.isPivotMode();
    var isOpenGroup = this.rowNode.group && this.rowNode.expanded && !this.rowNode.footer && !lockedClosedGroup;
    // are we showing group footers
    var groupFootersEnabled = this.beans.gridOptionsWrapper.isGroupIncludeFooter();
    // if doing footers, we normally don't show agg data at group level when group is open
    var groupAlwaysShowAggData = this.beans.gridOptionsWrapper.isGroupSuppressBlankHeader();
    // if doing grouping and footers, we don't want to include the agg value
    // in the header when the group is open
    var ignoreAggData = isOpenGroup && groupFootersEnabled && !groupAlwaysShowAggData;
    var value = this.beans.valueService.getValue(this.column, this.rowNode, false, ignoreAggData);
    return value;
  };
  CellCtrl.prototype.getValue = function () {
    return this.value;
  };
  CellCtrl.prototype.getValueFormatted = function () {
    return this.valueFormatted;
  };
  CellCtrl.prototype.addDomData = function () {
    var _this = this;
    var element = this.getGui();
    this.beans.gridOptionsWrapper.setDomData(element, CellCtrl.DOM_DATA_KEY_CELL_CTRL, this);
    this.addDestroyFunc(function () {
      return _this.beans.gridOptionsWrapper.setDomData(element, CellCtrl.DOM_DATA_KEY_CELL_CTRL, null);
    });
  };
  CellCtrl.prototype.createEvent = function (domEvent, eventType) {
    var event = {
      type: eventType,
      node: this.rowNode,
      data: this.rowNode.data,
      value: this.value,
      column: this.column,
      colDef: this.column.getColDef(),
      context: this.beans.gridOptionsWrapper.getContext(),
      api: this.beans.gridApi,
      columnApi: this.beans.columnApi,
      rowPinned: this.rowNode.rowPinned,
      event: domEvent,
      rowIndex: this.rowNode.rowIndex
    };
    // because we are hacking in $scope for angular 1, we have to de-reference
    if (this.scope) {
      event.$scope = this.scope;
    }
    return event;
  };
  CellCtrl.prototype.onKeyPress = function (event) {
    this.cellKeyboardListenerFeature.onKeyPress(event);
  };
  CellCtrl.prototype.onKeyDown = function (event) {
    this.cellKeyboardListenerFeature.onKeyDown(event);
  };
  CellCtrl.prototype.onMouseEvent = function (eventName, mouseEvent) {
    this.cellMouseListenerFeature.onMouseEvent(eventName, mouseEvent);
  };
  CellCtrl.prototype.getGui = function () {
    return this.eGui;
  };
  CellCtrl.prototype.refreshToolTip = function () {
    this.tooltipFeature.refreshToolTip();
  };
  CellCtrl.prototype.getColSpanningList = function () {
    return this.cellPositionFeature.getColSpanningList();
  };
  CellCtrl.prototype.onLeftChanged = function () {
    this.cellPositionFeature.onLeftChanged();
    this.refreshAriaIndex(); // should change this to listen for when column order changes
  };

  CellCtrl.prototype.refreshAriaIndex = function () {
    var colIdx = this.beans.columnModel.getAriaColumnIndex(this.column);
    this.cellComp.setAriaColIndex(colIdx);
  };
  CellCtrl.prototype.isSuppressNavigable = function () {
    return this.column.isSuppressNavigable(this.rowNode);
  };
  CellCtrl.prototype.onWidthChanged = function () {
    return this.cellPositionFeature.onWidthChanged();
  };
  CellCtrl.prototype.getColumn = function () {
    return this.column;
  };
  CellCtrl.prototype.getRowNode = function () {
    return this.rowNode;
  };
  CellCtrl.prototype.getBeans = function () {
    return this.beans;
  };
  CellCtrl.prototype.isPrintLayout = function () {
    return this.printLayout;
  };
  CellCtrl.prototype.appendChild = function (htmlElement) {
    this.eGui.appendChild(htmlElement);
  };
  CellCtrl.prototype.refreshHandle = function () {
    if (this.editing) {
      return;
    }
    if (this.cellRangeFeature) {
      this.cellRangeFeature.refreshHandle();
    }
  };
  CellCtrl.prototype.getCellPosition = function () {
    return this.cellPosition;
  };
  CellCtrl.prototype.isEditing = function () {
    return this.editing;
  };
  // called by rowRenderer when user navigates via tab key
  CellCtrl.prototype.startRowOrCellEdit = function (keyPress, charPress) {
    if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
      this.rowCtrl.startRowEditing(keyPress, charPress, this);
    } else {
      this.startEditing(keyPress, charPress, true);
    }
  };
  CellCtrl.prototype.getRowCtrl = function () {
    return this.rowCtrl;
  };
  CellCtrl.prototype.getRowPosition = function () {
    return {
      rowIndex: this.cellPosition.rowIndex,
      rowPinned: this.cellPosition.rowPinned
    };
  };
  CellCtrl.prototype.updateRangeBordersIfRangeCount = function () {
    if (this.cellRangeFeature) {
      this.cellRangeFeature.updateRangeBordersIfRangeCount();
    }
  };
  CellCtrl.prototype.onRangeSelectionChanged = function () {
    if (this.cellRangeFeature) {
      this.cellRangeFeature.onRangeSelectionChanged();
    }
  };
  CellCtrl.prototype.isRangeSelectionEnabled = function () {
    return this.cellRangeFeature != null;
  };
  CellCtrl.prototype.focusCell = function (forceBrowserFocus) {
    if (forceBrowserFocus === void 0) {
      forceBrowserFocus = false;
    }
    this.beans.focusService.setFocusedCell(this.getCellPosition().rowIndex, this.column, this.rowNode.rowPinned, forceBrowserFocus);
  };
  CellCtrl.prototype.onRowIndexChanged = function () {
    // when index changes, this influences items that need the index, so we update the
    // grid cell so they are working off the new index.
    this.createCellPosition();
    // when the index of the row changes, ie means the cell may have lost or gained focus
    this.onCellFocused();
    // check range selection
    if (this.cellRangeFeature) {
      this.cellRangeFeature.onRangeSelectionChanged();
    }
  };
  CellCtrl.prototype.onFirstRightPinnedChanged = function () {
    if (!this.cellComp) {
      return;
    }
    var firstRightPinned = this.column.isFirstRightPinned();
    this.cellComp.addOrRemoveCssClass(CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
  };
  CellCtrl.prototype.onLastLeftPinnedChanged = function () {
    if (!this.cellComp) {
      return;
    }
    var lastLeftPinned = this.column.isLastLeftPinned();
    this.cellComp.addOrRemoveCssClass(CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
  };
  CellCtrl.prototype.onCellFocused = function (event) {
    if (!this.cellComp) {
      return;
    }
    var cellFocused = this.beans.focusService.isCellFocused(this.cellPosition);
    if (!this.gow.isSuppressCellSelection()) {
      this.cellComp.addOrRemoveCssClass(CSS_CELL_FOCUS, cellFocused);
    }
    // see if we need to force browser focus - this can happen if focus is programmatically set
    if (cellFocused && event && event.forceBrowserFocus) {
      var focusEl = this.cellComp.getFocusableElement();
      focusEl.focus();
      // Fix for AG-3465 "IE11 - After editing cell's content, selection doesn't go one cell below on enter"
      // IE can fail to focus the cell after the first call to focus(), and needs a second call
      if (!document.activeElement || document.activeElement === document.body) {
        focusEl.focus();
      }
    }
    // if another cell was focused, and we are editing, then stop editing
    var fullRowEdit = this.beans.gridOptionsWrapper.isFullRowEdit();
    if (!cellFocused && !fullRowEdit && this.editing) {
      this.stopRowOrCellEdit();
    }
  };
  CellCtrl.prototype.createCellPosition = function () {
    this.cellPosition = {
      rowIndex: this.rowNode.rowIndex,
      rowPinned: this.rowNode.rowPinned,
      column: this.column
    };
  };
  // CSS Classes that only get applied once, they never change
  CellCtrl.prototype.applyStaticCssClasses = function () {
    this.cellComp.addOrRemoveCssClass(CSS_CELL, true);
    this.cellComp.addOrRemoveCssClass(CSS_CELL_NOT_INLINE_EDITING, true);
    // normal cells fill the height of the row. autoHeight cells have no height to let them
    // fit the height of content.
    var autoHeight = this.column.getColDef().autoHeight == true;
    this.cellComp.addOrRemoveCssClass(CSS_AUTO_HEIGHT, autoHeight);
    this.cellComp.addOrRemoveCssClass(CSS_NORMAL_HEIGHT, !autoHeight);
  };
  CellCtrl.prototype.onColumnHover = function () {
    if (!this.cellComp) {
      return;
    }
    if (!this.beans.gridOptionsWrapper.isColumnHoverHighlight()) {
      return;
    }
    var isHovered = this.beans.columnHoverService.isHovered(this.column);
    this.cellComp.addOrRemoveCssClass(CSS_COLUMN_HOVER, isHovered);
  };
  CellCtrl.prototype.onNewColumnsLoaded = function () {
    if (!this.cellComp) {
      return;
    }
    this.setWrapText();
    if (!this.editing) {
      this.refreshCell({
        forceRefresh: true,
        suppressFlash: true
      });
    }
  };
  CellCtrl.prototype.setWrapText = function () {
    var value = this.column.getColDef().wrapText == true;
    this.cellComp.addOrRemoveCssClass(CSS_CELL_WRAP_TEXT, value);
  };
  CellCtrl.prototype.dispatchCellContextMenuEvent = function (event) {
    var colDef = this.column.getColDef();
    var cellContextMenuEvent = this.createEvent(event, Events.EVENT_CELL_CONTEXT_MENU);
    this.beans.eventService.dispatchEvent(cellContextMenuEvent);
    if (colDef.onCellContextMenu) {
      // to make the callback async, do in a timeout
      window.setTimeout(function () {
        return colDef.onCellContextMenu(cellContextMenuEvent);
      }, 0);
    }
  };
  CellCtrl.prototype.getCellRenderer = function () {
    return this.cellComp ? this.cellComp.getCellRenderer() : null;
  };
  CellCtrl.prototype.getCellEditor = function () {
    return this.cellComp ? this.cellComp.getCellEditor() : null;
  };
  CellCtrl.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  CellCtrl.prototype.createSelectionCheckbox = function () {
    var cbSelectionComponent = new CheckboxSelectionComponent();
    this.beans.context.createBean(cbSelectionComponent);
    cbSelectionComponent.init({
      rowNode: this.rowNode,
      column: this.column
    });
    // put the checkbox in before the value
    return cbSelectionComponent;
  };
  CellCtrl.prototype.createDndSource = function () {
    var dndSourceComp = new DndSourceComp(this.rowNode, this.column, this.beans, this.eGui);
    this.beans.context.createBean(dndSourceComp);
    return dndSourceComp;
  };
  CellCtrl.prototype.registerRowDragger = function (customElement, dragStartPixels, suppressVisibilityChange) {
    var _this = this;
    // if previously existed, then we are only updating
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(customElement, dragStartPixels);
      return;
    }
    var newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);
    if (newComp) {
      this.customRowDragComp = newComp;
      this.addDestroyFunc(function () {
        return _this.beans.context.destroyBean(newComp);
      });
    }
  };
  CellCtrl.prototype.createRowDragComp = function (customElement, dragStartPixels, suppressVisibilityChange) {
    var _this = this;
    var pagination = this.beans.gridOptionsWrapper.isPagination();
    var rowDragManaged = this.beans.gridOptionsWrapper.isRowDragManaged();
    var clientSideRowModelActive = this.beans.gridOptionsWrapper.isRowModelDefault();
    if (rowDragManaged) {
      // row dragging only available in default row model
      if (!clientSideRowModelActive) {
        doOnce(function () {
          return console.warn('AG Grid: managed row dragging is only allowed in the Client Side Row Model');
        }, 'CellComp.addRowDragging');
        return;
      }
      if (pagination) {
        doOnce(function () {
          return console.warn('AG Grid: managed row dragging is not possible when doing pagination');
        }, 'CellComp.addRowDragging');
        return;
      }
    }
    // otherwise (normal case) we are creating a RowDraggingComp for the first time
    var rowDragComp = new RowDragComp(function () {
      return _this.value;
    }, this.rowNode, this.column, customElement, dragStartPixels, suppressVisibilityChange);
    this.beans.context.createBean(rowDragComp);
    return rowDragComp;
  };
  CellCtrl.DOM_DATA_KEY_CELL_CTRL = 'cellCtrl';
  return CellCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __assign$9 = undefined && undefined.__assign || function () {
  __assign$9 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$9.apply(this, arguments);
};
var AngularRowUtils = /** @class */function () {
  function AngularRowUtils() {}
  AngularRowUtils.createChildScopeOrNull = function (rowNode, parentScope, gridOptionsWrapper) {
    var isAngularCompileRows = gridOptionsWrapper.isAngularCompileRows();
    if (!isAngularCompileRows) {
      return null;
    }
    var newChildScope = parentScope.$new();
    newChildScope.data = __assign$9({}, rowNode.data);
    newChildScope.rowNode = rowNode;
    newChildScope.context = gridOptionsWrapper.getContext();
    var destroyFunc = function destroyFunc() {
      newChildScope.$destroy();
      newChildScope.data = null;
      newChildScope.rowNode = null;
      newChildScope.context = null;
    };
    return {
      scope: newChildScope,
      scopeDestroyFunc: destroyFunc
    };
  };
  return AngularRowUtils;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$V = undefined && undefined.__extends || function () {
  var _extendStatics58 = function extendStatics(d, b) {
    _extendStatics58 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics58(d, b);
  };
  return function (d, b) {
    _extendStatics58(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __spreadArrays$6 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var RowType;
(function (RowType) {
  RowType["Normal"] = "Normal";
  RowType["FullWidth"] = "FullWidth";
  RowType["FullWidthLoading"] = "FullWidthLoading";
  RowType["FullWidthGroup"] = "FullWidthGroup";
  RowType["FullWidthDetail"] = "FullWidthDetail";
})(RowType || (RowType = {}));
var FullWidthRenderers = convertToMap([[RowType.FullWidthLoading, 'agLoadingCellRenderer'], [RowType.FullWidthGroup, 'agGroupRowRenderer'], [RowType.FullWidthDetail, 'agDetailCellRenderer']]);
var FullWidthKeys = convertToMap([[RowType.FullWidth, 'fullWidthCellRenderer'], [RowType.FullWidthLoading, 'loadingCellRenderer'], [RowType.FullWidthGroup, 'groupRowRenderer'], [RowType.FullWidthDetail, 'detailCellRenderer']]);
var instanceIdSequence$2 = 0;
var RowCtrl = /** @class */function (_super) {
  __extends$V(RowCtrl, _super);
  function RowCtrl(parentScope, rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout) {
    var _this = _super.call(this) || this;
    _this.allRowGuis = [];
    _this.active = true;
    _this.centerCellCtrls = {
      list: [],
      map: {}
    };
    _this.leftCellCtrls = {
      list: [],
      map: {}
    };
    _this.rightCellCtrls = {
      list: [],
      map: {}
    };
    _this.lastMouseDownOnDragger = false;
    _this.updateColumnListsPending = false;
    _this.parentScope = parentScope;
    _this.beans = beans;
    _this.rowNode = rowNode;
    _this.paginationPage = _this.beans.paginationProxy.getCurrentPage();
    _this.useAnimationFrameForCreate = useAnimationFrameForCreate;
    _this.printLayout = printLayout;
    _this.instanceId = rowNode.id + '-' + instanceIdSequence$2++;
    _this.setAnimateFlags(animateIn);
    _this.rowFocused = _this.beans.focusService.isRowFocused(_this.rowNode.rowIndex, _this.rowNode.rowPinned);
    _this.setupAngular1Scope();
    _this.rowLevel = _this.beans.rowCssClassCalculator.calculateRowLevel(_this.rowNode);
    _this.setRowType();
    _this.addListeners();
    _this.setInitialRowTop();
    return _this;
  }
  RowCtrl.prototype.getBeans = function () {
    return this.beans;
  };
  RowCtrl.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  RowCtrl.prototype.setComp = function (rowComp, element, pinned) {
    var gui = {
      rowComp: rowComp,
      element: element,
      pinned: pinned
    };
    this.allRowGuis.push(gui);
    if (pinned === Constants.PINNED_LEFT) {
      this.leftGui = gui;
    } else if (pinned === Constants.PINNED_RIGHT) {
      this.rightGui = gui;
    } else if (this.isFullWidth() && !this.beans.gridOptionsWrapper.isEmbedFullWidthRows()) {
      this.fullWidthGui = gui;
    } else {
      this.centerGui = gui;
    }
    var allNormalPresent = this.leftGui != null && this.rightGui != null && this.centerGui != null;
    var fullWidthPresent = this.fullWidthGui != null;
    if (allNormalPresent || fullWidthPresent) {
      this.initialiseRowComps();
    }
  };
  RowCtrl.prototype.isCacheable = function () {
    return this.rowType === RowType.FullWidthDetail && this.beans.gridOptionsWrapper.isKeepDetailRows();
  };
  RowCtrl.prototype.setCached = function (cached) {
    var displayValue = cached ? 'none' : undefined;
    this.allRowGuis.forEach(function (rg) {
      return rg.rowComp.setDisplay(displayValue);
    });
  };
  RowCtrl.prototype.initialiseRowComps = function () {
    var _this = this;
    var gow = this.beans.gridOptionsWrapper;
    this.onRowHeightChanged();
    this.updateRowIndexes();
    this.setFocusedClasses();
    this.setStylesFromGridOptions();
    if (gow.isRowSelection() && this.rowNode.selectable) {
      this.onRowSelected();
    }
    this.updateColumnLists(!this.useAnimationFrameForCreate);
    if (this.slideRowIn) {
      executeNextVMTurn(this.onTopChanged.bind(this));
    }
    if (this.fadeRowIn) {
      executeNextVMTurn(function () {
        _this.allRowGuis.forEach(function (gui) {
          return gui.rowComp.addOrRemoveCssClass('ag-opacity-zero', false);
        });
      });
    }
    var businessKey = this.getRowBusinessKey();
    var rowIdSanitised = escapeString(this.rowNode.id);
    var businessKeySanitised = escapeString(businessKey);
    this.allRowGuis.forEach(function (gui) {
      var comp = gui.rowComp;
      comp.setRole('row');
      var initialRowClasses = _this.getInitialRowClasses(gui.pinned);
      initialRowClasses.forEach(function (name) {
        return comp.addOrRemoveCssClass(name, true);
      });
      if (_this.rowNode.group) {
        comp.setAriaExpanded(_this.rowNode.expanded == true);
      }
      if (rowIdSanitised != null) {
        comp.setRowId(rowIdSanitised);
      }
      if (businessKeySanitised != null) {
        comp.setRowBusinessKey(businessKeySanitised);
      }
      if (_this.isFullWidth()) {
        comp.setTabIndex(-1);
      }
      // DOM DATA
      gow.setDomData(gui.element, RowCtrl.DOM_DATA_KEY_ROW_CTRL, _this);
      _this.addDestroyFunc(function () {
        return gow.setDomData(gui.element, RowCtrl.DOM_DATA_KEY_ROW_CTRL, null);
      });
      // adding hover functionality adds listener to this row, so we
      // do it lazily in an animation frame
      if (_this.useAnimationFrameForCreate) {
        _this.beans.animationFrameService.createTask(_this.addHoverFunctionality.bind(_this, gui.element), _this.rowNode.rowIndex, 'createTasksP2');
      } else {
        _this.addHoverFunctionality(gui.element);
      }
      if (_this.isFullWidth()) {
        _this.setupFullWidth(gui);
      }
      if (gow.isRowDragEntireRow()) {
        _this.addRowDraggerToRow(gui);
      }
      // the height animation we only want active after the row is alive for 1 second.
      // this stops the row animation working when rows are initially crated. otherwise
      // auto-height rows get inserted into the dom and resized immediately, which gives
      // very bad UX (eg 10 rows get inserted, then all 10 expand, look particularly bad
      // when scrolling). so this makes sure when rows are shown for the first time, they
      // are resized immediately without animation.
      _this.beans.animationFrameService.addDestroyTask(function () {
        if (_this.isAlive()) {
          gui.rowComp.addOrRemoveCssClass('ag-after-created', true);
        }
      });
    });
    this.executeProcessRowPostCreateFunc();
  };
  RowCtrl.prototype.addRowDraggerToRow = function (gui) {
    var gow = this.beans.gridOptionsWrapper;
    if (gow.isEnableRangeSelection()) {
      doOnce(function () {
        console.warn('AG Grid: Setting `rowDragEntireRow: true` in the gridOptions doesn\'t work with `enableRangeSelection: true`');
      }, 'rowDragAndRangeSelectionEnabled');
      return;
    }
    var rowDragComp = new RowDragComp(function () {
      return '1 row';
    }, this.rowNode, undefined, gui.element, undefined, true);
    this.createManagedBean(rowDragComp, this.beans.context);
  };
  RowCtrl.prototype.getFullWidthCellRendererType = function () {
    return FullWidthKeys.get(this.rowType);
  };
  RowCtrl.prototype.getFullWidthCellRendererName = function () {
    return FullWidthRenderers.get(this.rowType);
  };
  RowCtrl.prototype.setupFullWidth = function (gui) {
    var params = this.createFullWidthParams(gui.element, gui.pinned);
    var cellRendererType = this.getFullWidthCellRendererType();
    var cellRendererName = this.getFullWidthCellRendererName();
    var compDetails = this.beans.userComponentFactory.getFullWidthCellRendererDetails(params, cellRendererType, cellRendererName);
    if (compDetails) {
      gui.rowComp.showFullWidth(compDetails);
    } else {
      var masterDetailModuleLoaded = ModuleRegistry.isRegistered(ModuleNames.MasterDetailModule);
      if (cellRendererName === 'agDetailCellRenderer' && !masterDetailModuleLoaded) {
        console.warn("AG Grid: cell renderer agDetailCellRenderer (for master detail) not found. Did you forget to include the master detail module?");
      } else {
        console.error("AG Grid: fullWidthCellRenderer " + cellRendererName + " not found");
      }
    }
  };
  RowCtrl.prototype.getScope = function () {
    return this.scope;
  };
  RowCtrl.prototype.isPrintLayout = function () {
    return this.printLayout;
  };
  RowCtrl.prototype.setupAngular1Scope = function () {
    var scopeResult = AngularRowUtils.createChildScopeOrNull(this.rowNode, this.parentScope, this.beans.gridOptionsWrapper);
    if (scopeResult) {
      this.scope = scopeResult.scope;
      this.addDestroyFunc(scopeResult.scopeDestroyFunc);
    }
  };
  // use by autoWidthCalculator, as it clones the elements
  RowCtrl.prototype.getCellElement = function (column) {
    var cellCtrl = this.getCellCtrl(column);
    return cellCtrl ? cellCtrl.getGui() : null;
  };
  RowCtrl.prototype.executeProcessRowPostCreateFunc = function () {
    var func = this.beans.gridOptionsWrapper.getProcessRowPostCreateFunc();
    if (!func) {
      return;
    }
    var params = {
      eRow: this.centerGui ? this.centerGui.element : undefined,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : undefined,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : undefined,
      node: this.rowNode,
      api: this.beans.gridOptionsWrapper.getApi(),
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext()
    };
    func(params);
  };
  RowCtrl.prototype.setRowType = function () {
    var isStub = this.rowNode.stub;
    var isFullWidthCell = this.rowNode.isFullWidthCell();
    var isDetailCell = this.beans.doingMasterDetail && this.rowNode.detail;
    var pivotMode = this.beans.columnModel.isPivotMode();
    // we only use full width for groups, not footers. it wouldn't make sense to include footers if not looking
    // for totals. if users complain about this, then we should introduce a new property 'footerUseEntireRow'
    // so each can be set independently (as a customer complained about footers getting full width, hence
    // introducing this logic)
    var isGroupRow = !!this.rowNode.group && !this.rowNode.footer;
    var isFullWidthGroup = isGroupRow && this.beans.gridOptionsWrapper.isGroupUseEntireRow(pivotMode);
    if (isStub) {
      this.rowType = RowType.FullWidthLoading;
    } else if (isDetailCell) {
      this.rowType = RowType.FullWidthDetail;
    } else if (isFullWidthCell) {
      this.rowType = RowType.FullWidth;
    } else if (isFullWidthGroup) {
      this.rowType = RowType.FullWidthGroup;
    } else {
      this.rowType = RowType.Normal;
    }
  };
  RowCtrl.prototype.updateColumnLists = function (suppressAnimationFrame) {
    var _this = this;
    if (suppressAnimationFrame === void 0) {
      suppressAnimationFrame = false;
    }
    if (this.isFullWidth()) {
      return;
    }
    var noAnimation = suppressAnimationFrame || this.beans.gridOptionsWrapper.isSuppressAnimationFrame() || this.printLayout;
    if (noAnimation) {
      this.updateColumnListsImpl();
      return;
    }
    if (this.updateColumnListsPending) {
      return;
    }
    this.beans.animationFrameService.createTask(function () {
      if (!_this.active) {
        return;
      }
      _this.updateColumnListsImpl();
    }, this.rowNode.rowIndex, 'createTasksP1');
    this.updateColumnListsPending = true;
  };
  RowCtrl.prototype.createCellCtrls = function (prev, cols, pinned) {
    var _this = this;
    if (pinned === void 0) {
      pinned = null;
    }
    var res = {
      list: [],
      map: {}
    };
    var addCell = function addCell(colInstanceId, cellCtrl) {
      res.list.push(cellCtrl);
      res.map[colInstanceId] = cellCtrl;
    };
    cols.forEach(function (col) {
      // we use instanceId's rather than colId as it's possible there is a Column with same Id,
      // but it's referring to a different column instance. Happens a lot with pivot, as pivot col id's are
      // reused eg pivot_0, pivot_1 etc
      var colInstanceId = col.getInstanceId();
      var cellCtrl = prev.map[colInstanceId];
      if (!cellCtrl) {
        cellCtrl = new CellCtrl(col, _this.rowNode, _this.beans, _this);
      }
      addCell(colInstanceId, cellCtrl);
    });
    prev.list.forEach(function (prevCellCtrl) {
      var cellInResult = res.map[prevCellCtrl.getColumn().getInstanceId()] != null;
      if (cellInResult) {
        return;
      }
      var keepCell = !_this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
      if (keepCell) {
        addCell(prevCellCtrl.getColumn().getInstanceId(), prevCellCtrl);
        return;
      }
      prevCellCtrl.destroy();
    });
    return res;
  };
  RowCtrl.prototype.updateColumnListsImpl = function () {
    var _this = this;
    this.updateColumnListsPending = false;
    var columnModel = this.beans.columnModel;
    if (this.printLayout) {
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, columnModel.getAllDisplayedColumns());
      this.leftCellCtrls = {
        list: [],
        map: {}
      };
      this.rightCellCtrls = {
        list: [],
        map: {}
      };
    } else {
      var centerCols = columnModel.getViewportCenterColumnsForRow(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
      var leftCols = columnModel.getDisplayedLeftColumnsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, Constants.PINNED_LEFT);
      var rightCols = columnModel.getDisplayedRightColumnsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, Constants.PINNED_RIGHT);
    }
    this.allRowGuis.forEach(function (item) {
      var cellControls = item.pinned === Constants.PINNED_LEFT ? _this.leftCellCtrls : item.pinned === Constants.PINNED_RIGHT ? _this.rightCellCtrls : _this.centerCellCtrls;
      item.rowComp.setCellCtrls(cellControls.list);
    });
  };
  RowCtrl.prototype.isCellEligibleToBeRemoved = function (cellCtrl, nextContainerPinned) {
    var REMOVE_CELL = true;
    var KEEP_CELL = false;
    // always remove the cell if it's not rendered or if it's in the wrong pinned location
    var column = cellCtrl.getColumn();
    if (column.getPinned() != nextContainerPinned) {
      return REMOVE_CELL;
    }
    // we want to try and keep editing and focused cells
    var editing = cellCtrl.isEditing();
    var focused = this.beans.focusService.isCellFocused(cellCtrl.getCellPosition());
    var mightWantToKeepCell = editing || focused;
    if (mightWantToKeepCell) {
      var column_1 = cellCtrl.getColumn();
      var displayedColumns = this.beans.columnModel.getAllDisplayedColumns();
      var cellStillDisplayed = displayedColumns.indexOf(column_1) >= 0;
      return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
    }
    return REMOVE_CELL;
  };
  RowCtrl.prototype.setAnimateFlags = function (animateIn) {
    if (animateIn) {
      var oldRowTopExists = exists(this.rowNode.oldRowTop);
      // if the row had a previous position, we slide it in (animate row top)
      this.slideRowIn = oldRowTopExists;
      // if the row had no previous position, we fade it in (animate
      this.fadeRowIn = !oldRowTopExists;
    } else {
      this.slideRowIn = false;
      this.fadeRowIn = false;
    }
  };
  RowCtrl.prototype.isEditing = function () {
    return this.editingRow;
  };
  RowCtrl.prototype.stopRowEditing = function (cancel) {
    this.stopEditing(cancel);
  };
  RowCtrl.prototype.isFullWidth = function () {
    return this.rowType !== RowType.Normal;
  };
  RowCtrl.prototype.getRowType = function () {
    return this.rowType;
  };
  RowCtrl.prototype.refreshFullWidth = function () {
    var _this = this;
    // returns 'true' if refresh succeeded
    var tryRefresh = function tryRefresh(gui, pinned) {
      if (!gui) {
        return true;
      } // no refresh needed
      var cellRenderer = gui.rowComp.getFullWidthCellRenderer();
      // no cell renderer, either means comp not yet ready, or comp ready but now reference
      // to it (happens in react when comp is stateless). if comp not ready, we don't need to
      // refresh, however we don't know which one, so we refresh to cover the case where it's
      // react comp without reference so need to force a refresh
      if (!cellRenderer) {
        return false;
      }
      // no refresh method present, so can't refresh, hard refresh needed
      if (!cellRenderer.refresh) {
        return false;
      }
      var params = _this.createFullWidthParams(gui.element, pinned);
      var refreshSucceeded = cellRenderer.refresh(params);
      return refreshSucceeded;
    };
    var fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
    var centerSuccess = tryRefresh(this.centerGui, null);
    var leftSuccess = tryRefresh(this.leftGui, Constants.PINNED_LEFT);
    var rightSuccess = tryRefresh(this.rightGui, Constants.PINNED_RIGHT);
    var allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
    return allFullWidthRowsRefreshed;
  };
  RowCtrl.prototype.addListeners = function () {
    this.addManagedListener(this.rowNode, RowNode.EVENT_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.onRowNodeCellChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_DRAGGING_CHANGED, this.onRowNodeDraggingChanged.bind(this));
    this.addManagedListener(this.rowNode, RowNode.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
    var eventService = this.beans.eventService;
    this.addManagedListener(eventService, Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
    this.addManagedListener(eventService, Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
    this.addManagedListener(eventService, Events.EVENT_COLUMN_MOVED, this.onColumnMoved.bind(this));
    this.addListenersForCellComps();
  };
  RowCtrl.prototype.onColumnMoved = function () {
    this.updateColumnLists();
  };
  RowCtrl.prototype.addListenersForCellComps = function () {
    var _this = this;
    this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, function () {
      _this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onRowIndexChanged();
      });
    });
    this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, function (event) {
      _this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onCellChanged(event);
      });
    });
  };
  RowCtrl.prototype.onRowNodeDataChanged = function (event) {
    // if this is an update, we want to refresh, as this will allow the user to put in a transition
    // into the cellRenderer refresh method. otherwise this might be completely new data, in which case
    // we will want to completely replace the cells
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      return cellCtrl.refreshCell({
        suppressFlash: !event.update,
        newData: !event.update
      });
    });
    // check for selected also, as this could be after lazy loading of the row data, in which case
    // the id might of just gotten set inside the row and the row selected state may of changed
    // as a result. this is what happens when selected rows are loaded in virtual pagination.
    // - niall note - since moving to the stub component, this may no longer be true, as replacing
    // the stub component now replaces the entire row
    this.onRowSelected();
    // as data has changed, then the style and class needs to be recomputed
    this.postProcessCss();
  };
  RowCtrl.prototype.onRowNodeCellChanged = function () {
    // as data has changed, then the style and class needs to be recomputed
    this.postProcessCss();
  };
  RowCtrl.prototype.postProcessCss = function () {
    this.setStylesFromGridOptions();
    this.postProcessClassesFromGridOptions();
    this.postProcessRowClassRules();
    this.postProcessRowDragging();
  };
  RowCtrl.prototype.onRowNodeHighlightChanged = function () {
    var highlighted = this.rowNode.highlighted;
    this.allRowGuis.forEach(function (gui) {
      var aboveOn = highlighted === RowHighlightPosition.Above;
      var belowOn = highlighted === RowHighlightPosition.Below;
      gui.rowComp.addOrRemoveCssClass('ag-row-highlight-above', aboveOn);
      gui.rowComp.addOrRemoveCssClass('ag-row-highlight-below', belowOn);
    });
  };
  RowCtrl.prototype.onRowNodeDraggingChanged = function () {
    this.postProcessRowDragging();
  };
  RowCtrl.prototype.postProcessRowDragging = function () {
    var dragging = this.rowNode.dragging;
    this.allRowGuis.forEach(function (gui) {
      return gui.rowComp.addOrRemoveCssClass('ag-row-dragging', dragging);
    });
  };
  RowCtrl.prototype.updateExpandedCss = function () {
    var expandable = this.rowNode.isExpandable();
    var expanded = this.rowNode.expanded == true;
    this.allRowGuis.forEach(function (gui) {
      gui.rowComp.addOrRemoveCssClass('ag-row-group', expandable);
      gui.rowComp.addOrRemoveCssClass('ag-row-group-expanded', expandable && expanded);
      gui.rowComp.addOrRemoveCssClass('ag-row-group-contracted', expandable && !expanded);
      gui.rowComp.setAriaExpanded(expandable && expanded);
    });
  };
  RowCtrl.prototype.onDisplayedColumnsChanged = function () {
    // we skip animations for onDisplayedColumnChanged, as otherwise the client could remove columns and
    // then set data, and any old valueGetter's (ie from cols that were removed) would still get called.
    this.updateColumnLists(true);
    if (this.beans.columnModel.wasAutoRowHeightEverActive()) {
      this.rowNode.checkAutoHeights();
    }
  };
  RowCtrl.prototype.onVirtualColumnsChanged = function () {
    this.updateColumnLists();
  };
  RowCtrl.prototype.getRowPosition = function () {
    return {
      rowPinned: this.rowNode.rowPinned,
      rowIndex: this.rowNode.rowIndex
    };
  };
  RowCtrl.prototype.onKeyboardNavigate = function (keyboardEvent) {
    var currentFullWidthComp = find$3(this.allRowGuis, function (c) {
      return c.element.contains(keyboardEvent.target);
    });
    var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
    var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
    if (!isFullWidthContainerFocused) {
      return;
    }
    var node = this.rowNode;
    var lastFocusedCell = this.beans.focusService.getFocusedCell();
    var cellPosition = {
      rowIndex: node.rowIndex,
      rowPinned: node.rowPinned,
      column: lastFocusedCell && lastFocusedCell.column
    };
    this.beans.navigationService.navigateToNextCell(keyboardEvent, keyboardEvent.keyCode, cellPosition, true);
    keyboardEvent.preventDefault();
  };
  RowCtrl.prototype.onTabKeyDown = function (keyboardEvent) {
    if (keyboardEvent.defaultPrevented || isStopPropagationForAgGrid(keyboardEvent)) {
      return;
    }
    var currentFullWidthComp = find$3(this.allRowGuis, function (c) {
      return c.element.contains(keyboardEvent.target);
    });
    var currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
    var isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
    var nextEl = null;
    if (!isFullWidthContainerFocused) {
      nextEl = this.beans.focusService.findNextFocusableElement(currentFullWidthContainer, false, keyboardEvent.shiftKey);
    }
    if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) {
      this.beans.navigationService.onTabKeyDown(this, keyboardEvent);
    }
  };
  RowCtrl.prototype.onFullWidthRowFocused = function (event) {
    var node = this.rowNode;
    var isFocused = this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
    var element = this.fullWidthGui ? this.fullWidthGui.element : this.centerGui.element;
    addOrRemoveCssClass(element, 'ag-full-width-focus', isFocused);
    if (isFocused) {
      // we don't scroll normal rows into view when we focus them, so we don't want
      // to scroll Full Width rows either.
      element.focus({
        preventScroll: true
      });
    }
  };
  RowCtrl.prototype.refreshCell = function (cellCtrl) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
    this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
    this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
    this.updateColumnLists();
  };
  RowCtrl.prototype.removeCellCtrl = function (prev, cellCtrlToRemove) {
    var res = {
      list: [],
      map: {}
    };
    prev.list.forEach(function (cellCtrl) {
      if (cellCtrl === cellCtrlToRemove) {
        return;
      }
      res.list.push(cellCtrl);
      res.map[cellCtrl.getInstanceId()] = cellCtrl;
    });
    return res;
  };
  RowCtrl.prototype.onMouseEvent = function (eventName, mouseEvent) {
    switch (eventName) {
      case 'dblclick':
        this.onRowDblClick(mouseEvent);
        break;
      case 'click':
        this.onRowClick(mouseEvent);
        break;
      case 'touchstart':
      case 'mousedown':
        this.onRowMouseDown(mouseEvent);
        break;
    }
  };
  RowCtrl.prototype.createRowEvent = function (type, domEvent) {
    return {
      type: type,
      node: this.rowNode,
      data: this.rowNode.data,
      rowIndex: this.rowNode.rowIndex,
      rowPinned: this.rowNode.rowPinned,
      context: this.beans.gridOptionsWrapper.getContext(),
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      event: domEvent
    };
  };
  RowCtrl.prototype.createRowEventWithSource = function (type, domEvent) {
    var event = this.createRowEvent(type, domEvent);
    // when first developing this, we included the rowComp in the event.
    // this seems very weird. so when introducing the event types, i left the 'source'
    // out of the type, and just include the source in the two places where this event
    // was fired (rowClicked and rowDoubleClicked). it doesn't make sense for any
    // users to be using this, as the rowComp isn't an object we expose, so would be
    // very surprising if a user was using it.
    event.source = this;
    return event;
  };
  RowCtrl.prototype.onRowDblClick = function (mouseEvent) {
    if (isStopPropagationForAgGrid(mouseEvent)) {
      return;
    }
    var agEvent = this.createRowEventWithSource(Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
    this.beans.eventService.dispatchEvent(agEvent);
  };
  RowCtrl.prototype.onRowMouseDown = function (mouseEvent) {
    this.lastMouseDownOnDragger = isElementChildOfClass(mouseEvent.target, 'ag-row-drag', 3);
    if (!this.isFullWidth()) {
      return;
    }
    var node = this.rowNode;
    var columnModel = this.beans.columnModel;
    this.beans.focusService.setFocusedCell(node.rowIndex, columnModel.getAllDisplayedColumns()[0], node.rowPinned, true);
  };
  RowCtrl.prototype.onRowClick = function (mouseEvent) {
    var stop = isStopPropagationForAgGrid(mouseEvent) || this.lastMouseDownOnDragger;
    if (stop) {
      return;
    }
    var agEvent = this.createRowEventWithSource(Events.EVENT_ROW_CLICKED, mouseEvent);
    this.beans.eventService.dispatchEvent(agEvent);
    // ctrlKey for windows, metaKey for Apple
    var multiSelectKeyPressed = mouseEvent.ctrlKey || mouseEvent.metaKey;
    var shiftKeyPressed = mouseEvent.shiftKey;
    // we do not allow selecting the group by clicking, when groupSelectChildren, as the logic to
    // handle this is broken. to observe, change the logic below and allow groups to be selected.
    // you will see the group gets selected, then all children get selected, then the grid unselects
    // the children (as the default behaviour when clicking is to unselect other rows) which results
    // in the group getting unselected (as all children are unselected). the correct thing would be
    // to change this, so that children of the selected group are not then subsequenly un-selected.
    var groupSelectsChildren = this.beans.gridOptionsWrapper.isGroupSelectsChildren();
    if (
    // we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
    // so return if it's a group row
    groupSelectsChildren && this.rowNode.group ||
    // this is needed so we don't unselect other rows when we click this row, eg if this row is not selectable,
    // and we click it, the selection should not change (ie any currently selected row should stay selected)
    !this.rowNode.selectable ||
    // we also don't allow selection of pinned rows
    this.rowNode.rowPinned ||
    // if no selection method enabled, do nothing
    !this.beans.gridOptionsWrapper.isRowSelection() ||
    // if click selection suppressed, do nothing
    this.beans.gridOptionsWrapper.isSuppressRowClickSelection()) {
      return;
    }
    var multiSelectOnClick = this.beans.gridOptionsWrapper.isRowMultiSelectWithClick();
    var rowDeselectionWithCtrl = !this.beans.gridOptionsWrapper.isSuppressRowDeselection();
    if (this.rowNode.isSelected()) {
      if (multiSelectOnClick) {
        this.rowNode.setSelectedParams({
          newValue: false
        });
      } else if (multiSelectKeyPressed) {
        if (rowDeselectionWithCtrl) {
          this.rowNode.setSelectedParams({
            newValue: false
          });
        }
      } else {
        // selected with no multi key, must make sure anything else is unselected
        this.rowNode.setSelectedParams({
          newValue: !shiftKeyPressed,
          clearSelection: !shiftKeyPressed,
          rangeSelect: shiftKeyPressed
        });
      }
    } else {
      var clearSelection = multiSelectOnClick ? false : !multiSelectKeyPressed;
      this.rowNode.setSelectedParams({
        newValue: true,
        clearSelection: clearSelection,
        rangeSelect: shiftKeyPressed
      });
    }
  };
  RowCtrl.prototype.setupDetailRowAutoHeight = function (eDetailGui) {
    var _this = this;
    if (!this.beans.gridOptionsWrapper.isDetailRowAutoHeight()) {
      return;
    }
    var checkRowSizeFunc = function checkRowSizeFunc() {
      var clientHeight = eDetailGui.clientHeight;
      // if the UI is not ready, the height can be 0, which we ignore, as otherwise a flicker will occur
      // as UI goes from the default height, to 0, then to the real height as UI becomes ready. this means
      // it's not possible for have 0 as auto-height, however this is an improbable use case, as even an
      // empty detail grid would still have some styling around it giving at least a few pixels.
      if (clientHeight != null && clientHeight > 0) {
        // we do the update in a timeout, to make sure we are not calling from inside the grid
        // doing another update
        var updateRowHeightFunc = function updateRowHeightFunc() {
          _this.rowNode.setRowHeight(clientHeight);
          if (_this.beans.clientSideRowModel) {
            _this.beans.clientSideRowModel.onRowHeightChanged();
          } else if (_this.beans.serverSideRowModel) {
            _this.beans.serverSideRowModel.onRowHeightChanged();
          }
        };
        _this.beans.frameworkOverrides.setTimeout(updateRowHeightFunc, 0);
      }
    };
    var resizeObserverDestroyFunc = this.beans.resizeObserverService.observeResize(eDetailGui, checkRowSizeFunc);
    this.addDestroyFunc(resizeObserverDestroyFunc);
    checkRowSizeFunc();
  };
  RowCtrl.prototype.createFullWidthParams = function (eRow, pinned) {
    var _this = this;
    var params = {
      fullWidth: true,
      data: this.rowNode.data,
      node: this.rowNode,
      value: this.rowNode.key,
      valueFormatted: this.rowNode.key,
      $scope: this.scope ? this.scope : this.parentScope,
      $compile: this.beans.$compile,
      rowIndex: this.rowNode.rowIndex,
      api: this.beans.gridOptionsWrapper.getApi(),
      columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
      context: this.beans.gridOptionsWrapper.getContext(),
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: eRow,
      eParentOfValue: eRow,
      pinned: pinned,
      addRenderedRowListener: this.addEventListener.bind(this),
      registerRowDragger: function registerRowDragger(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange) {
        return _this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange);
      }
    };
    return params;
  };
  RowCtrl.prototype.addFullWidthRowDragging = function (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange) {
    if (value === void 0) {
      value = '';
    }
    if (!this.isFullWidth()) {
      return;
    }
    var rowDragComp = new RowDragComp(function () {
      return value;
    }, this.rowNode, undefined, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
    this.createManagedBean(rowDragComp, this.beans.context);
  };
  RowCtrl.prototype.onUiLevelChanged = function () {
    var newLevel = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
    if (this.rowLevel != newLevel) {
      var classToAdd_1 = 'ag-row-level-' + newLevel;
      var classToRemove_1 = 'ag-row-level-' + this.rowLevel;
      this.allRowGuis.forEach(function (gui) {
        gui.rowComp.addOrRemoveCssClass(classToAdd_1, true);
        gui.rowComp.addOrRemoveCssClass(classToRemove_1, false);
      });
    }
    this.rowLevel = newLevel;
  };
  RowCtrl.prototype.isFirstRowOnPage = function () {
    return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
  };
  RowCtrl.prototype.isLastRowOnPage = function () {
    return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
  };
  RowCtrl.prototype.onModelUpdated = function () {
    var newFirst = this.isFirstRowOnPage();
    var newLast = this.isLastRowOnPage();
    if (this.firstRowOnPage !== newFirst) {
      this.firstRowOnPage = newFirst;
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass('ag-row-first', newFirst);
      });
    }
    if (this.lastRowOnPage !== newLast) {
      this.lastRowOnPage = newLast;
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass('ag-row-last', newLast);
      });
    }
  };
  RowCtrl.prototype.stopEditing = function (cancel) {
    if (cancel === void 0) {
      cancel = false;
    }
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      return cellCtrl.stopEditing(cancel);
    });
    if (!this.editingRow) {
      return;
    }
    if (!cancel) {
      var event_1 = this.createRowEvent(Events.EVENT_ROW_VALUE_CHANGED);
      this.beans.eventService.dispatchEvent(event_1);
    }
    this.setEditingRow(false);
  };
  RowCtrl.prototype.setInlineEditingCss = function (editing) {
    this.allRowGuis.forEach(function (gui) {
      gui.rowComp.addOrRemoveCssClass("ag-row-inline-editing", editing);
      gui.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !editing);
    });
  };
  RowCtrl.prototype.setEditingRow = function (value) {
    this.editingRow = value;
    this.allRowGuis.forEach(function (gui) {
      return gui.rowComp.addOrRemoveCssClass('ag-row-editing', value);
    });
    var event = value ? this.createRowEvent(Events.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(Events.EVENT_ROW_EDITING_STOPPED);
    this.beans.eventService.dispatchEvent(event);
  };
  RowCtrl.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
    if (keyPress === void 0) {
      keyPress = null;
    }
    if (charPress === void 0) {
      charPress = null;
    }
    if (sourceRenderedCell === void 0) {
      sourceRenderedCell = null;
    }
    // don't do it if already editing
    if (this.editingRow) {
      return;
    }
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      var cellStartedEdit = cellCtrl === sourceRenderedCell;
      if (cellStartedEdit) {
        cellCtrl.startEditing(keyPress, charPress, cellStartedEdit);
      } else {
        cellCtrl.startEditing(null, null, cellStartedEdit);
      }
    });
    this.setEditingRow(true);
  };
  RowCtrl.prototype.getAllCellCtrls = function () {
    var res = __spreadArrays$6(this.centerCellCtrls.list, this.leftCellCtrls.list, this.rightCellCtrls.list);
    return res;
  };
  RowCtrl.prototype.postProcessClassesFromGridOptions = function () {
    var _this = this;
    var cssClasses = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode, this.scope);
    if (!cssClasses || !cssClasses.length) {
      return;
    }
    cssClasses.forEach(function (classStr) {
      _this.allRowGuis.forEach(function (c) {
        return c.rowComp.addOrRemoveCssClass(classStr, true);
      });
    });
  };
  RowCtrl.prototype.postProcessRowClassRules = function () {
    var _this = this;
    this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, this.scope, function (className) {
      _this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass(className, true);
      });
    }, function (className) {
      _this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass(className, false);
      });
    });
  };
  RowCtrl.prototype.setStylesFromGridOptions = function () {
    var rowStyles = this.processStylesFromGridOptions();
    this.allRowGuis.forEach(function (gui) {
      return gui.rowComp.setUserStyles(rowStyles);
    });
  };
  RowCtrl.prototype.getRowBusinessKey = function () {
    var businessKeyForNodeFunc = this.beans.gridOptionsWrapper.getBusinessKeyForNodeFunc();
    if (typeof businessKeyForNodeFunc !== 'function') {
      return;
    }
    return businessKeyForNodeFunc(this.rowNode);
  };
  RowCtrl.prototype.getInitialRowClasses = function (pinned) {
    var params = {
      rowNode: this.rowNode,
      rowFocused: this.rowFocused,
      fadeRowIn: this.fadeRowIn,
      rowIsEven: this.rowNode.rowIndex % 2 === 0,
      rowLevel: this.rowLevel,
      fullWidthRow: this.isFullWidth(),
      firstRowOnPage: this.isFirstRowOnPage(),
      lastRowOnPage: this.isLastRowOnPage(),
      printLayout: this.printLayout,
      expandable: this.rowNode.isExpandable(),
      scope: this.scope,
      pinned: pinned
    };
    return this.beans.rowCssClassCalculator.getInitialRowClasses(params);
  };
  RowCtrl.prototype.processStylesFromGridOptions = function () {
    // part 1 - rowStyle
    var rowStyle = this.beans.gridOptionsWrapper.getRowStyle();
    if (rowStyle && typeof rowStyle === 'function') {
      console.warn('AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
      return;
    }
    // part 1 - rowStyleFunc
    var rowStyleFunc = this.beans.gridOptionsWrapper.getRowStyleFunc();
    var rowStyleFuncResult;
    if (rowStyleFunc) {
      var params = {
        data: this.rowNode.data,
        node: this.rowNode,
        rowIndex: this.rowNode.rowIndex,
        $scope: this.scope,
        api: this.beans.gridOptionsWrapper.getApi(),
        columnApi: this.beans.gridOptionsWrapper.getColumnApi(),
        context: this.beans.gridOptionsWrapper.getContext()
      };
      rowStyleFuncResult = rowStyleFunc(params);
    }
    return assign$3({}, rowStyle, rowStyleFuncResult);
  };
  RowCtrl.prototype.onRowSelected = function () {
    var _this = this;
    var selected = this.rowNode.isSelected();
    this.allRowGuis.forEach(function (gui) {
      gui.rowComp.setAriaSelected(selected ? true : undefined);
      gui.rowComp.addOrRemoveCssClass('ag-row-selected', selected);
      gui.rowComp.setAriaLabel(_this.createAriaLabel());
    });
  };
  RowCtrl.prototype.createAriaLabel = function () {
    var selected = this.rowNode.isSelected();
    if (selected && this.beans.gridOptionsWrapper.isSuppressRowDeselection()) {
      return undefined;
    }
    var translate = this.beans.gridOptionsWrapper.getLocaleTextFunc();
    var label = translate(selected ? 'ariaRowDeselect' : 'ariaRowSelect', "Press SPACE to " + (selected ? 'deselect' : 'select') + " this row.");
    return label;
  };
  RowCtrl.prototype.isUseAnimationFrameForCreate = function () {
    return this.useAnimationFrameForCreate;
  };
  RowCtrl.prototype.addHoverFunctionality = function (eRow) {
    var _this = this;
    // because we use animation frames to do this, it's possible the row no longer exists
    // by the time we get to add it
    if (!this.active) {
      return;
    }
    // because mouseenter and mouseleave do not propagate, we cannot listen on the gridPanel
    // like we do for all the other mouse events.
    // because of the pinning, we cannot simply add / remove the class based on the eRow. we
    // have to check all eRow's (body & pinned). so the trick is if any of the rows gets a
    // mouse hover, it sets such in the rowNode, and then all three reflect the change as
    // all are listening for event on the row node.
    // step 1 - add listener, to set flag on row node
    this.addManagedListener(eRow, 'mouseenter', function () {
      return _this.rowNode.onMouseEnter();
    });
    this.addManagedListener(eRow, 'mouseleave', function () {
      return _this.rowNode.onMouseLeave();
    });
    // step 2 - listen for changes on row node (which any eRow can trigger)
    this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_ENTER, function () {
      // if hover turned off, we don't add the class. we do this here so that if the application
      // toggles this property mid way, we remove the hover form the last row, but we stop
      // adding hovers from that point onwards.
      if (!_this.beans.gridOptionsWrapper.isSuppressRowHoverHighlight()) {
        addCssClass(eRow, 'ag-row-hover');
      }
    });
    this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_LEAVE, function () {
      removeCssClass(eRow, 'ag-row-hover');
    });
  };
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  RowCtrl.prototype.roundRowTopToBounds = function (rowTop) {
    var gridBodyCon = this.beans.ctrlsService.getGridBodyCtrl();
    var range = gridBodyCon.getScrollFeature().getVScrollPosition();
    var minPixel = this.applyPaginationOffset(range.top, true) - 100;
    var maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
    return Math.min(Math.max(minPixel, rowTop), maxPixel);
  };
  RowCtrl.prototype.getFrameworkOverrides = function () {
    return this.beans.frameworkOverrides;
  };
  RowCtrl.prototype.onRowHeightChanged = function () {
    // check for exists first - if the user is resetting the row height, then
    // it will be null (or undefined) momentarily until the next time the flatten
    // stage is called where the row will then update again with a new height
    if (exists(this.rowNode.rowHeight)) {
      var heightPx_1 = this.rowNode.rowHeight + "px";
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.setHeight(heightPx_1);
      });
    }
  };
  RowCtrl.prototype.addEventListener = function (eventType, listener) {
    if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
      eventType = Events.EVENT_VIRTUAL_ROW_REMOVED;
      console.warn('AG Grid: Since version 11, event renderedRowRemoved is now called ' + Events.EVENT_VIRTUAL_ROW_REMOVED);
    }
    _super.prototype.addEventListener.call(this, eventType, listener);
  };
  RowCtrl.prototype.removeEventListener = function (eventType, listener) {
    if (eventType === 'renderedRowRemoved' || eventType === 'rowRemoved') {
      eventType = Events.EVENT_VIRTUAL_ROW_REMOVED;
      console.warn('AG Grid: Since version 11, event renderedRowRemoved and rowRemoved is now called ' + Events.EVENT_VIRTUAL_ROW_REMOVED);
    }
    _super.prototype.removeEventListener.call(this, eventType, listener);
  };
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  RowCtrl.prototype.destroyFirstPass = function () {
    this.active = false;
    // why do we have this method? shouldn't everything below be added as a destroy func beside
    // the corresponding create logic?
    this.setupRemoveAnimation();
    var event = this.createRowEvent(Events.EVENT_VIRTUAL_ROW_REMOVED);
    this.dispatchEvent(event);
    this.beans.eventService.dispatchEvent(event);
    _super.prototype.destroy.call(this);
  };
  RowCtrl.prototype.setupRemoveAnimation = function () {
    var rowStillVisibleJustNotInViewport = this.rowNode.rowTop != null;
    if (rowStillVisibleJustNotInViewport) {
      // if the row is not rendered, but in viewport, it means it has moved,
      // so we animate the row out. if the new location is very far away,
      // the animation will be so fast the row will look like it's just disappeared,
      // so instead we animate to a position just outside the viewport.
      var rowTop = this.roundRowTopToBounds(this.rowNode.rowTop);
      this.setRowTop(rowTop);
    } else {
      this.allRowGuis.forEach(function (gui) {
        return gui.rowComp.addOrRemoveCssClass('ag-opacity-zero', true);
      });
    }
  };
  RowCtrl.prototype.destroySecondPass = function () {
    this.allRowGuis.length = 0;
    var destroyCellCtrls = function destroyCellCtrls(ctrls) {
      ctrls.list.forEach(function (c) {
        return c.destroy();
      });
      return {
        list: [],
        map: {}
      };
    };
    this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
    this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
    this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
  };
  RowCtrl.prototype.setFocusedClasses = function () {
    var _this = this;
    this.allRowGuis.forEach(function (gui) {
      gui.rowComp.addOrRemoveCssClass('ag-row-focus', _this.rowFocused);
      gui.rowComp.addOrRemoveCssClass('ag-row-no-focus', !_this.rowFocused);
    });
  };
  RowCtrl.prototype.onCellFocusChanged = function () {
    var rowFocused = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    if (rowFocused !== this.rowFocused) {
      this.rowFocused = rowFocused;
      this.setFocusedClasses();
    }
    // if we are editing, then moving the focus out of a row will stop editing
    if (!rowFocused && this.editingRow) {
      this.stopEditing(false);
    }
  };
  RowCtrl.prototype.onPaginationChanged = function () {
    var currentPage = this.beans.paginationProxy.getCurrentPage();
    // it is possible this row is in the new page, but the page number has changed, which means
    // it needs to reposition itself relative to the new page
    if (this.paginationPage !== currentPage) {
      this.paginationPage = currentPage;
      this.onTopChanged();
    }
  };
  RowCtrl.prototype.onTopChanged = function () {
    this.setRowTop(this.rowNode.rowTop);
  };
  RowCtrl.prototype.onPaginationPixelOffsetChanged = function () {
    // the pixel offset is used when calculating rowTop to set on the row DIV
    this.onTopChanged();
  };
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  RowCtrl.prototype.applyPaginationOffset = function (topPx, reverse) {
    if (reverse === void 0) {
      reverse = false;
    }
    if (this.rowNode.isRowPinned()) {
      return topPx;
    }
    var pixelOffset = this.beans.paginationProxy.getPixelOffset();
    var multiplier = reverse ? 1 : -1;
    return topPx + pixelOffset * multiplier;
  };
  RowCtrl.prototype.setRowTop = function (pixels) {
    // print layout uses normal flow layout for row positioning
    if (this.printLayout) {
      return;
    }
    // need to make sure rowTop is not null, as this can happen if the node was once
    // visible (ie parent group was expanded) but is now not visible
    if (exists(pixels)) {
      var afterPaginationPixels = this.applyPaginationOffset(pixels);
      var afterScalingPixels = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
      var topPx = afterScalingPixels + "px";
      this.setRowTopStyle(topPx);
    }
  };
  RowCtrl.prototype.getInitialRowTop = function () {
    return this.initialTop;
  };
  RowCtrl.prototype.getInitialTransform = function () {
    return this.initialTransform;
  };
  RowCtrl.prototype.setInitialRowTop = function () {
    // print layout uses normal flow layout for row positioning
    if (this.printLayout) {
      return '';
    }
    // if sliding in, we take the old row top. otherwise we just set the current row top.
    var pixels = this.slideRowIn ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
    var afterPaginationPixels = this.applyPaginationOffset(pixels);
    // we don't apply scaling if row is pinned
    var afterScalingPixels = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
    var res = afterScalingPixels + 'px';
    var suppressRowTransform = this.beans.gridOptionsWrapper.isSuppressRowTransform();
    if (suppressRowTransform) {
      this.initialTop = res;
    } else {
      this.initialTransform = "translateY(" + res + ")";
    }
  };
  RowCtrl.prototype.setRowTopStyle = function (topPx) {
    var suppressRowTransform = this.beans.gridOptionsWrapper.isSuppressRowTransform();
    this.allRowGuis.forEach(function (gui) {
      return suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform("translateY(" + topPx + ")");
    });
  };
  RowCtrl.prototype.getRowNode = function () {
    return this.rowNode;
  };
  RowCtrl.prototype.getCellCtrl = function (column) {
    // first up, check for cell directly linked to this column
    var res = null;
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      if (cellCtrl.getColumn() == column) {
        res = cellCtrl;
      }
    });
    if (res != null) {
      return res;
    }
    // second up, if not found, then check for spanned cols.
    // we do this second (and not at the same time) as this is
    // more expensive, as spanning cols is a
    // infrequently used feature so we don't need to do this most
    // of the time
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      if (cellCtrl.getColSpanningList().indexOf(column) >= 0) {
        res = cellCtrl;
      }
    });
    return res;
  };
  RowCtrl.prototype.onRowIndexChanged = function () {
    // we only bother updating if the rowIndex is present. if it is not present, it means this row
    // is child of a group node, and the group node was closed, it's the only way to have no row index.
    // when this happens, row is about to be de-rendered, so we don't care, rowComp is about to die!
    if (this.rowNode.rowIndex != null) {
      this.onCellFocusChanged();
      this.updateRowIndexes();
    }
  };
  RowCtrl.prototype.updateRowIndexes = function () {
    var _this = this;
    var rowIndexStr = this.rowNode.getRowIndexString();
    var headerRowCount = this.beans.headerNavigationService.getHeaderRowCount();
    var rowIsEven = this.rowNode.rowIndex % 2 === 0;
    this.allRowGuis.forEach(function (c) {
      c.rowComp.setRowIndex(rowIndexStr);
      c.rowComp.setAriaRowIndex(headerRowCount + _this.rowNode.rowIndex + 1);
      c.rowComp.addOrRemoveCssClass('ag-row-even', rowIsEven);
      c.rowComp.addOrRemoveCssClass('ag-row-odd', !rowIsEven);
    });
  };
  // returns the pinned left container, either the normal one, or the embedded full with one if exists
  RowCtrl.prototype.getPinnedLeftRowElement = function () {
    return this.leftGui ? this.leftGui.element : undefined;
  };
  // returns the pinned right container, either the normal one, or the embedded full with one if exists
  RowCtrl.prototype.getPinnedRightRowElement = function () {
    return this.rightGui ? this.rightGui.element : undefined;
  };
  // returns the body container, either the normal one, or the embedded full with one if exists
  RowCtrl.prototype.getBodyRowElement = function () {
    return this.centerGui ? this.centerGui.element : undefined;
  };
  // returns the full width container
  RowCtrl.prototype.getFullWidthRowElement = function () {
    return this.fullWidthGui ? this.fullWidthGui.element : undefined;
  };
  RowCtrl.DOM_DATA_KEY_ROW_CTRL = 'renderedRow';
  return RowCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$W = undefined && undefined.__extends || function () {
  var _extendStatics59 = function extendStatics(d, b) {
    _extendStatics59 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics59(d, b);
  };
  return function (d, b) {
    _extendStatics59(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$K = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$7 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var RowRenderer = /** @class */function (_super) {
  __extends$W(RowRenderer, _super);
  function RowRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.destroyFuncsForColumnListeners = [];
    // map of row ids to row objects. keeps track of which elements
    // are rendered for which rows in the dom.
    _this.rowCtrlsByRowIndex = {};
    _this.zombieRowCtrls = {};
    _this.allRowCtrls = [];
    _this.topRowCtrls = [];
    _this.bottomRowCtrls = [];
    // we only allow one refresh at a time, otherwise the internal memory structure here
    // will get messed up. this can happen if the user has a cellRenderer, and inside the
    // renderer they call an API method that results in another pass of the refresh,
    // then it will be trying to draw rows in the middle of a refresh.
    _this.refreshInProgress = false;
    return _this;
  }
  RowRenderer.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function () {
      _this.gridBodyCtrl = _this.ctrlsService.getGridBodyCtrl();
      _this.initialise();
    });
  };
  RowRenderer.prototype.initialise = function () {
    this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.redrawAfterScroll.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.redrawAfterScroll.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDomLayoutChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
    this.registerCellEventListeners();
    this.initialiseCache();
    this.printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    this.embedFullWidthRows = this.printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
    this.redrawAfterModelUpdate();
  };
  RowRenderer.prototype.initialiseCache = function () {
    if (this.gridOptionsWrapper.isKeepDetailRows()) {
      var countProp = this.gridOptionsWrapper.getKeepDetailRowsCount();
      var count = countProp != null ? countProp : 3;
      this.cachedRowCtrls = new RowCtrlCache(count);
    }
  };
  RowRenderer.prototype.getRowCtrls = function () {
    return this.allRowCtrls;
  };
  RowRenderer.prototype.updateAllRowCtrls = function () {
    var liveList = getAllValuesInObject(this.rowCtrlsByRowIndex);
    if (this.beans.gridOptionsWrapper.isEnsureDomOrder()) {
      liveList.sort(function (a, b) {
        return a.getRowNode().rowIndex - b.getRowNode.rowIndex;
      });
    }
    var zombieList = getAllValuesInObject(this.zombieRowCtrls);
    var cachedList = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
    this.allRowCtrls = __spreadArrays$7(liveList, zombieList, cachedList);
  };
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  RowRenderer.prototype.registerCellEventListeners = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_CELL_FOCUSED, function (event) {
      _this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onCellFocused(event);
      });
      _this.getAllRowCtrls().forEach(function (rowCtrl) {
        if (rowCtrl.isFullWidth()) {
          rowCtrl.onFullWidthRowFocused(event);
        }
      });
    });
    this.addManagedListener(this.eventService, Events.EVENT_FLASH_CELLS, function (event) {
      _this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onFlashCells(event);
      });
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, function () {
      _this.getAllCellCtrls().forEach(function (cellCtrl) {
        return cellCtrl.onColumnHover();
      });
    });
    // only for printLayout - because we are rendering all the cells in the same row, regardless of pinned state,
    // then changing the width of the containers will impact left position. eg the center cols all have their
    // left position adjusted by the width of the left pinned column, so if the pinned left column width changes,
    // all the center cols need to be shifted to accommodate this. when in normal layout, the pinned cols are
    // in different containers so doesn't impact.
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, function () {
      if (_this.printLayout) {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onLeftChanged();
        });
      }
    });
    var rangeSelectionEnabled = this.gridOptionsWrapper.isEnableRangeSelection();
    if (rangeSelectionEnabled) {
      this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, function () {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.onRangeSelectionChanged();
        });
      });
      this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, function () {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.updateRangeBordersIfRangeCount();
        });
      });
      this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, function () {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.updateRangeBordersIfRangeCount();
        });
      });
      this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, function () {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          return cellCtrl.updateRangeBordersIfRangeCount();
        });
      });
    }
    // add listeners to the grid columns
    this.refreshListenersToColumnsForCellComps();
    // if the grid columns change, then refresh the listeners again
    this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
    this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  };
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  RowRenderer.prototype.removeGridColumnListeners = function () {
    this.destroyFuncsForColumnListeners.forEach(function (func) {
      return func();
    });
    this.destroyFuncsForColumnListeners.length = 0;
  };
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  RowRenderer.prototype.refreshListenersToColumnsForCellComps = function () {
    var _this = this;
    this.removeGridColumnListeners();
    var cols = this.columnModel.getAllGridColumns();
    if (!cols) {
      return;
    }
    cols.forEach(function (col) {
      var forEachCellWithThisCol = function forEachCellWithThisCol(callback) {
        _this.getAllCellCtrls().forEach(function (cellCtrl) {
          if (cellCtrl.getColumn() === col) {
            callback(cellCtrl);
          }
        });
      };
      var leftChangedListener = function leftChangedListener() {
        forEachCellWithThisCol(function (cellCtrl) {
          return cellCtrl.onLeftChanged();
        });
      };
      var widthChangedListener = function widthChangedListener() {
        forEachCellWithThisCol(function (cellCtrl) {
          return cellCtrl.onWidthChanged();
        });
      };
      var firstRightPinnedChangedListener = function firstRightPinnedChangedListener() {
        forEachCellWithThisCol(function (cellCtrl) {
          return cellCtrl.onFirstRightPinnedChanged();
        });
      };
      var lastLeftPinnedChangedListener = function lastLeftPinnedChangedListener() {
        forEachCellWithThisCol(function (cellCtrl) {
          return cellCtrl.onLastLeftPinnedChanged();
        });
      };
      col.addEventListener(Column.EVENT_LEFT_CHANGED, leftChangedListener);
      col.addEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
      col.addEventListener(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
      col.addEventListener(Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
      _this.destroyFuncsForColumnListeners.push(function () {
        col.removeEventListener(Column.EVENT_LEFT_CHANGED, leftChangedListener);
        col.removeEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
        col.removeEventListener(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstRightPinnedChangedListener);
        col.removeEventListener(Column.EVENT_LAST_LEFT_PINNED_CHANGED, lastLeftPinnedChangedListener);
      });
    });
  };
  RowRenderer.prototype.onDomLayoutChanged = function () {
    var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    var embedFullWidthRows = printLayout || this.gridOptionsWrapper.isEmbedFullWidthRows();
    // if moving towards or away from print layout, means we need to destroy all rows, as rows are not laid
    // out using absolute positioning when doing print layout
    var destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
    this.printLayout = printLayout;
    this.embedFullWidthRows = embedFullWidthRows;
    if (destroyRows) {
      this.redrawAfterModelUpdate();
    }
  };
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  RowRenderer.prototype.datasourceChanged = function () {
    this.firstRenderedRow = 0;
    this.lastRenderedRow = -1;
    var rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(rowIndexesToRemove);
  };
  RowRenderer.prototype.onPageLoaded = function (event) {
    var params = {
      recycleRows: event.keepRenderedRows,
      animate: event.animate,
      newData: event.newData,
      newPage: event.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: true
    };
    this.redrawAfterModelUpdate(params);
  };
  RowRenderer.prototype.getAllCellsForColumn = function (column) {
    var res = [];
    this.getAllRowCtrls().forEach(function (rowCtrl) {
      var eCell = rowCtrl.getCellElement(column);
      if (eCell) {
        res.push(eCell);
      }
    });
    return res;
  };
  RowRenderer.prototype.refreshFloatingRowComps = function () {
    this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData());
    this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
  };
  RowRenderer.prototype.getTopRowCtrls = function () {
    return this.topRowCtrls;
  };
  RowRenderer.prototype.getBottomRowCtrls = function () {
    return this.bottomRowCtrls;
  };
  RowRenderer.prototype.refreshFloatingRows = function (rowComps, rowNodes) {
    var _this = this;
    rowComps.forEach(function (row) {
      row.destroyFirstPass();
      row.destroySecondPass();
    });
    rowComps.length = 0;
    if (!rowNodes) {
      return;
    }
    rowNodes.forEach(function (rowNode) {
      var rowCon = new RowCtrl(_this.$scope, rowNode, _this.beans, false, false, _this.printLayout);
      rowComps.push(rowCon);
    });
  };
  RowRenderer.prototype.onPinnedRowDataChanged = function () {
    // recycling rows in order to ensure cell editing is not cancelled
    var params = {
      recycleRows: true
    };
    this.redrawAfterModelUpdate(params);
  };
  // if the row nodes are not rendered, no index is returned
  RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
    var result = [];
    if (missing(rowNodes)) {
      return result;
    }
    iterateObject(this.rowCtrlsByRowIndex, function (index, renderedRow) {
      var rowNode = renderedRow.getRowNode();
      if (rowNodes.indexOf(rowNode) >= 0) {
        result.push(index);
      }
    });
    return result;
  };
  RowRenderer.prototype.redrawRows = function (rowNodes) {
    // if no row nodes provided, then refresh everything
    var partialRefresh = rowNodes != null && rowNodes.length > 0;
    if (partialRefresh) {
      var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
      // remove the rows
      this.removeRowCtrls(indexesToRemove);
    }
    // add draw them again
    this.redrawAfterModelUpdate({
      recycleRows: partialRefresh
    });
  };
  RowRenderer.prototype.getCellToRestoreFocusToAfterRefresh = function (params) {
    var focusedCell = params.suppressKeepFocus ? null : this.focusService.getFocusCellToUseAfterRefresh();
    if (focusedCell == null) {
      return null;
    }
    // if the dom is not actually focused on a cell, then we don't try to refocus. the problem this
    // solves is with editing - if the user is editing, eg focus is on a text field, and not on the
    // cell itself, then the cell can be registered as having focus, however it's the text field that
    // has the focus and not the cell div. therefore, when the refresh is finished, the grid will focus
    // the cell, and not the textfield. that means if the user is in a text field, and the grid refreshes,
    // the focus is lost from the text field. we do not want this.
    var activeElement = document.activeElement;
    var cellDomData = this.gridOptionsWrapper.getDomData(activeElement, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
    var rowDomData = this.gridOptionsWrapper.getDomData(activeElement, RowCtrl.DOM_DATA_KEY_ROW_CTRL);
    var gridElementFocused = cellDomData || rowDomData;
    return gridElementFocused ? focusedCell : null;
  };
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  RowRenderer.prototype.redrawAfterModelUpdate = function (params) {
    if (params === void 0) {
      params = {};
    }
    this.getLockOnRefresh();
    var focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
    this.updateContainerHeights();
    this.scrollToTopIfNewData(params);
    // never recycle rows when print layout, we draw each row again from scratch. this is because print layout
    // uses normal dom layout to put cells into dom - it doesn't allow reordering rows.
    var recycleRows = !this.printLayout && !!params.recycleRows;
    var animate = params.animate && this.gridOptionsWrapper.isAnimateRows();
    // after modelUpdate, row indexes can change, so we clear out the rowsByIndex map,
    // however we can reuse the rows, so we keep them but index by rowNode.id
    var rowsToRecycle = recycleRows ? this.recycleRows() : null;
    if (!recycleRows) {
      this.removeAllRowComps();
    }
    var isFocusedCellGettingRecycled = function isFocusedCellGettingRecycled() {
      if (focusedCell == null || rowsToRecycle == null) {
        return false;
      }
      var res = false;
      iterateObject(rowsToRecycle, function (key, rowComp) {
        var rowNode = rowComp.getRowNode();
        var rowIndexEqual = rowNode.rowIndex == focusedCell.rowIndex;
        var pinnedEqual = rowNode.rowPinned == focusedCell.rowPinned;
        if (rowIndexEqual && pinnedEqual) {
          res = true;
        }
      });
      return res;
    };
    var focusedCellRecycled = isFocusedCellGettingRecycled();
    this.redraw(rowsToRecycle, animate);
    if (!params.onlyBody) {
      this.refreshFloatingRowComps();
    }
    this.dispatchDisplayedRowsChanged();
    // if we focus a cell that's already focused, then we get an unnecessary 'cellFocused' event fired.
    // this was happening when user clicked 'expand' on a rowGroup, then cellFocused was getting fired twice.
    if (!focusedCellRecycled) {
      this.restoreFocusedCell(focusedCell);
    }
    this.releaseLockOnRefresh();
  };
  RowRenderer.prototype.scrollToTopIfNewData = function (params) {
    var scrollToTop = params.newData || params.newPage;
    var suppressScrollToTop = this.gridOptionsWrapper.isSuppressScrollOnNewData();
    if (scrollToTop && !suppressScrollToTop) {
      this.gridBodyCtrl.getScrollFeature().scrollToTop();
    }
  };
  RowRenderer.prototype.updateContainerHeights = function () {
    // when doing print layout, we don't explicitly set height on the containers
    if (this.printLayout) {
      this.rowContainerHeightService.setModelHeight(null);
      return;
    }
    var containerHeight = this.paginationProxy.getCurrentPageHeight();
    // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
    // we still want the scroll to be present, otherwise there would be no way to scroll the header
    // which might be needed us user wants to access columns
    // on the RHS - and if that was where the filter was that cause no rows to be presented, there
    // is no way to remove the filter.
    if (containerHeight === 0) {
      containerHeight = 1;
    }
    this.rowContainerHeightService.setModelHeight(containerHeight);
  };
  RowRenderer.prototype.getLockOnRefresh = function () {
    if (this.refreshInProgress) {
      throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. " + "Your code probably called a grid API method while the grid was in the render stage. To overcome " + "this, put the API call into a timeout, e.g. instead of api.refreshView(), " + "call setTimeout(function() { api.refreshView(); }, 0). To see what part of your code " + "that caused the refresh check this stacktrace.");
    }
    this.refreshInProgress = true;
  };
  RowRenderer.prototype.releaseLockOnRefresh = function () {
    this.refreshInProgress = false;
  };
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  RowRenderer.prototype.restoreFocusedCell = function (cellPosition) {
    if (cellPosition) {
      this.focusService.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
    }
  };
  RowRenderer.prototype.stopEditing = function (cancel) {
    if (cancel === void 0) {
      cancel = false;
    }
    this.getAllRowCtrls().forEach(function (rowCtrl) {
      rowCtrl.stopEditing(cancel);
    });
  };
  RowRenderer.prototype.onNewColumnsLoaded = function () {
    // we don't want each cellComp to register for events, as would increase rendering time.
    // so for newColumnsLoaded, we register once here (in rowRenderer) and then inform
    // each cell if / when event was fired.
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      return cellCtrl.onNewColumnsLoaded();
    });
  };
  RowRenderer.prototype.getAllCellCtrls = function () {
    var res = [];
    this.getAllRowCtrls().forEach(function (rowCtrl) {
      return res = res.concat(rowCtrl.getAllCellCtrls());
    });
    return res;
  };
  RowRenderer.prototype.getAllRowCtrls = function () {
    var _this = this;
    var res = __spreadArrays$7(this.topRowCtrls, this.bottomRowCtrls);
    Object.keys(this.rowCtrlsByRowIndex).forEach(function (key) {
      return res.push(_this.rowCtrlsByRowIndex[key]);
    });
    return res;
  };
  RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
    var rowComp = this.rowCtrlsByRowIndex[rowIndex];
    if (rowComp) {
      rowComp.addEventListener(eventName, callback);
    }
  };
  RowRenderer.prototype.flashCells = function (params) {
    if (params === void 0) {
      params = {};
    }
    var flashDelay = params.flashDelay,
      fadeDelay = params.fadeDelay;
    this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
      return cellCtrl.flashCell({
        flashDelay: flashDelay,
        fadeDelay: fadeDelay
      });
    });
  };
  RowRenderer.prototype.refreshCells = function (params) {
    if (params === void 0) {
      params = {};
    }
    var refreshCellParams = {
      forceRefresh: params.force,
      newData: false,
      suppressFlash: params.suppressFlash
    };
    this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
      if (cellCtrl.refreshShouldDestroy()) {
        var rowCtrl = cellCtrl.getRowCtrl();
        if (rowCtrl) {
          rowCtrl.refreshCell(cellCtrl);
        }
      } else {
        cellCtrl.refreshCell(refreshCellParams);
      }
    });
  };
  RowRenderer.prototype.getCellRendererInstances = function (params) {
    var res = this.getCellCtrls(params.rowNodes, params.columns).map(function (cellCtrl) {
      return cellCtrl.getCellRenderer();
    }).filter(function (renderer) {
      return renderer != null;
    });
    return res;
  };
  RowRenderer.prototype.getCellEditorInstances = function (params) {
    var res = [];
    this.getCellCtrls(params.rowNodes, params.columns).forEach(function (cellCtrl) {
      var cellEditor = cellCtrl.getCellEditor();
      if (cellEditor) {
        res.push(cellEditor);
      }
    });
    return res;
  };
  RowRenderer.prototype.getEditingCells = function () {
    var res = [];
    this.getAllCellCtrls().forEach(function (cellCtrl) {
      if (cellCtrl.isEditing()) {
        var cellPosition = cellCtrl.getCellPosition();
        res.push(cellPosition);
      }
    });
    return res;
  };
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  RowRenderer.prototype.getCellCtrls = function (rowNodes, columns) {
    var _this = this;
    var rowIdsMap;
    var res = [];
    if (exists(rowNodes)) {
      rowIdsMap = {
        top: {},
        bottom: {},
        normal: {}
      };
      rowNodes.forEach(function (rowNode) {
        var id = rowNode.id;
        if (rowNode.rowPinned === Constants.PINNED_TOP) {
          rowIdsMap.top[id] = true;
        } else if (rowNode.rowPinned === Constants.PINNED_BOTTOM) {
          rowIdsMap.bottom[id] = true;
        } else {
          rowIdsMap.normal[id] = true;
        }
      });
    }
    var colIdsMap;
    if (exists(columns)) {
      colIdsMap = {};
      columns.forEach(function (colKey) {
        var column = _this.columnModel.getGridColumn(colKey);
        if (exists(column)) {
          colIdsMap[column.getId()] = true;
        }
      });
    }
    var processRow = function processRow(rowComp) {
      var rowNode = rowComp.getRowNode();
      var id = rowNode.id;
      var floating = rowNode.rowPinned;
      // skip this row if it is missing from the provided list
      if (exists(rowIdsMap)) {
        if (floating === Constants.PINNED_BOTTOM) {
          if (!rowIdsMap.bottom[id]) {
            return;
          }
        } else if (floating === Constants.PINNED_TOP) {
          if (!rowIdsMap.top[id]) {
            return;
          }
        } else {
          if (!rowIdsMap.normal[id]) {
            return;
          }
        }
      }
      rowComp.getAllCellCtrls().forEach(function (cellCtrl) {
        var colId = cellCtrl.getColumn().getId();
        var excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
        if (excludeColFromRefresh) {
          return;
        }
        res.push(cellCtrl);
      });
    };
    iterateObject(this.rowCtrlsByRowIndex, function (index, rowComp) {
      processRow(rowComp);
    });
    if (this.topRowCtrls) {
      this.topRowCtrls.forEach(processRow);
    }
    if (this.bottomRowCtrls) {
      this.bottomRowCtrls.forEach(processRow);
    }
    return res;
  };
  RowRenderer.prototype.destroy = function () {
    this.removeAllRowComps();
    _super.prototype.destroy.call(this);
  };
  RowRenderer.prototype.removeAllRowComps = function () {
    var rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(rowIndexesToRemove);
  };
  RowRenderer.prototype.recycleRows = function () {
    // remove all stub nodes, they can't be reused, as no rowNode id
    var stubNodeIndexes = [];
    iterateObject(this.rowCtrlsByRowIndex, function (index, rowComp) {
      var stubNode = rowComp.getRowNode().id == null;
      if (stubNode) {
        stubNodeIndexes.push(index);
      }
    });
    this.removeRowCtrls(stubNodeIndexes);
    // then clear out rowCompsByIndex, but before that take a copy, but index by id, not rowIndex
    var nodesByIdMap = {};
    iterateObject(this.rowCtrlsByRowIndex, function (index, rowComp) {
      var rowNode = rowComp.getRowNode();
      nodesByIdMap[rowNode.id] = rowComp;
    });
    this.rowCtrlsByRowIndex = {};
    return nodesByIdMap;
  };
  // takes array of row indexes
  RowRenderer.prototype.removeRowCtrls = function (rowsToRemove) {
    var _this = this;
    // if no fromIndex then set to -1, which will refresh everything
    // let realFromIndex = -1;
    rowsToRemove.forEach(function (indexToRemove) {
      var rowCtrl = _this.rowCtrlsByRowIndex[indexToRemove];
      if (rowCtrl) {
        rowCtrl.destroyFirstPass();
        rowCtrl.destroySecondPass();
      }
      delete _this.rowCtrlsByRowIndex[indexToRemove];
    });
  };
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  RowRenderer.prototype.redrawAfterScroll = function () {
    this.getLockOnRefresh();
    this.redraw(null, false, true);
    this.releaseLockOnRefresh();
    this.dispatchDisplayedRowsChanged();
  };
  RowRenderer.prototype.removeRowCompsNotToDraw = function (indexesToDraw) {
    // for speedy lookup, dump into map
    var indexesToDrawMap = {};
    indexesToDraw.forEach(function (index) {
      return indexesToDrawMap[index] = true;
    });
    var existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
    var indexesNotToDraw = existingIndexes.filter(function (index) {
      return !indexesToDrawMap[index];
    });
    this.removeRowCtrls(indexesNotToDraw);
  };
  RowRenderer.prototype.calculateIndexesToDraw = function (rowsToRecycle) {
    var _this = this;
    // all in all indexes in the viewport
    var indexesToDraw = createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
    var checkRowToDraw = function checkRowToDraw(indexStr, rowComp) {
      var index = rowComp.getRowNode().rowIndex;
      if (index == null) {
        return;
      }
      if (index < _this.firstRenderedRow || index > _this.lastRenderedRow) {
        if (_this.doNotUnVirtualiseRow(rowComp)) {
          indexesToDraw.push(index);
        }
      }
    };
    // if we are redrawing due to scrolling change, then old rows are in this.rowCompsByIndex
    iterateObject(this.rowCtrlsByRowIndex, checkRowToDraw);
    // if we are redrawing due to model update, then old rows are in rowsToRecycle
    iterateObject(rowsToRecycle, checkRowToDraw);
    indexesToDraw.sort(function (a, b) {
      return a - b;
    });
    return indexesToDraw;
  };
  RowRenderer.prototype.redraw = function (rowsToRecycle, animate, afterScroll) {
    var _this = this;
    if (animate === void 0) {
      animate = false;
    }
    if (afterScroll === void 0) {
      afterScroll = false;
    }
    this.rowContainerHeightService.updateOffset();
    this.workOutFirstAndLastRowsToRender();
    // the row can already exist and be in the following:
    // rowsToRecycle -> if model change, then the index may be different, however row may
    //                         exist here from previous time (mapped by id).
    // this.rowCompsByIndex -> if just a scroll, then this will contain what is currently in the viewport
    // this is all the indexes we want, including those that already exist, so this method
    // will end up going through each index and drawing only if the row doesn't already exist
    var indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
    this.removeRowCompsNotToDraw(indexesToDraw);
    // never animate when doing print layout - as we want to get things ready to print as quickly as possible,
    // otherwise we risk the printer printing a row that's half faded (half way through fading in)
    if (this.printLayout) {
      animate = false;
    }
    indexesToDraw.forEach(function (rowIndex) {
      var rowCtrl = _this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
      if (exists(rowCtrl)) ;
    });
    if (rowsToRecycle) {
      var useAnimationFrame = afterScroll && !this.gridOptionsWrapper.isSuppressAnimationFrame() && !this.printLayout;
      if (useAnimationFrame) {
        this.beans.animationFrameService.addDestroyTask(function () {
          _this.destroyRowCtrls(rowsToRecycle, animate);
          _this.updateAllRowCtrls();
          _this.dispatchDisplayedRowsChanged();
        });
      } else {
        this.destroyRowCtrls(rowsToRecycle, animate);
      }
    }
    this.updateAllRowCtrls();
    this.checkAngularCompile();
    this.gridBodyCtrl.updateRowCount();
  };
  RowRenderer.prototype.dispatchDisplayedRowsChanged = function () {
    var event = {
      type: Events.EVENT_DISPLAYED_ROWS_CHANGED
    };
    this.eventService.dispatchEvent(event);
  };
  RowRenderer.prototype.onDisplayedColumnsChanged = function () {
    var pinningLeft = this.columnModel.isPinningLeft();
    var pinningRight = this.columnModel.isPinningRight();
    var atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
    if (atLeastOneChanged) {
      this.pinningLeft = pinningLeft;
      this.pinningRight = pinningRight;
      if (this.embedFullWidthRows) {
        this.redrawFullWidthEmbeddedRows();
      }
    }
  };
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  RowRenderer.prototype.redrawFullWidthEmbeddedRows = function () {
    // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
    // embedded, as what appears in each section depends on whether we are pinned or not
    var rowsToRemove = [];
    iterateObject(this.rowCtrlsByRowIndex, function (id, rowComp) {
      if (rowComp.isFullWidth()) {
        var rowIndex = rowComp.getRowNode().rowIndex;
        rowsToRemove.push(rowIndex.toString());
      }
    });
    this.refreshFloatingRowComps();
    this.removeRowCtrls(rowsToRemove);
    this.redrawAfterScroll();
  };
  RowRenderer.prototype.refreshFullWidthRows = function (rowNodesToRefresh) {
    var rowsToRemove = [];
    var selectivelyRefreshing = !!rowNodesToRefresh;
    var idsToRefresh = selectivelyRefreshing ? {} : undefined;
    if (selectivelyRefreshing && idsToRefresh) {
      rowNodesToRefresh.forEach(function (r) {
        return idsToRefresh[r.id] = true;
      });
    }
    iterateObject(this.rowCtrlsByRowIndex, function (id, rowCtrl) {
      if (!rowCtrl.isFullWidth()) {
        return;
      }
      var rowNode = rowCtrl.getRowNode();
      if (selectivelyRefreshing && idsToRefresh) {
        // we refresh if a) this node is present or b) this parents nodes is present. checking parent
        // node is important for master/detail, as we want detail to refresh on changes to parent node.
        // it's also possible, if user is provider their own fullWidth, that details panels contain
        // some info on the parent, eg if in tree data and child row shows some data from parent row also.
        var parentId = rowNode.level > 0 && rowNode.parent ? rowNode.parent.id : undefined;
        var skipThisNode = !idsToRefresh[rowNode.id] && !idsToRefresh[parentId];
        if (skipThisNode) {
          return;
        }
      }
      var fullWidthRowsRefreshed = rowCtrl.refreshFullWidth();
      if (!fullWidthRowsRefreshed) {
        var rowIndex = rowCtrl.getRowNode().rowIndex;
        rowsToRemove.push(rowIndex.toString());
      }
    });
    this.removeRowCtrls(rowsToRemove);
    this.redrawAfterScroll();
  };
  RowRenderer.prototype.createOrUpdateRowCtrl = function (rowIndex, rowsToRecycle, animate, afterScroll) {
    var rowNode;
    var rowCon = this.rowCtrlsByRowIndex[rowIndex];
    // if no row comp, see if we can get it from the previous rowComps
    if (!rowCon) {
      rowNode = this.paginationProxy.getRow(rowIndex);
      if (exists(rowNode) && exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
        rowCon = rowsToRecycle[rowNode.id];
        rowsToRecycle[rowNode.id] = null;
      }
    }
    var creatingNewRowCon = !rowCon;
    if (creatingNewRowCon) {
      // create a new one
      if (!rowNode) {
        rowNode = this.paginationProxy.getRow(rowIndex);
      }
      if (exists(rowNode)) {
        rowCon = this.createRowCon(rowNode, animate, afterScroll);
      } else {
        // this should never happen - if somehow we are trying to create
        // a row for a rowNode that does not exist.
        return;
      }
    }
    if (rowNode) {
      // set node as 'alreadyRendered' to ensure we only recycle rowComps that have been rendered, this ensures
      // we don't reuse rowComps that have been removed and then re-added in the same batch transaction.
      rowNode.alreadyRendered = true;
    }
    this.rowCtrlsByRowIndex[rowIndex] = rowCon;
    return rowCon;
  };
  RowRenderer.prototype.destroyRowCtrls = function (rowCtrlsMap, animate) {
    var _this = this;
    var executeInAWhileFuncs = [];
    iterateObject(rowCtrlsMap, function (nodeId, rowCtrl) {
      // if row was used, then it's null
      if (!rowCtrl) {
        return;
      }
      if (_this.cachedRowCtrls && rowCtrl.isCacheable()) {
        _this.cachedRowCtrls.addRow(rowCtrl);
        return;
      }
      rowCtrl.destroyFirstPass();
      if (animate) {
        _this.zombieRowCtrls[rowCtrl.getInstanceId()] = rowCtrl;
        executeInAWhileFuncs.push(function () {
          rowCtrl.destroySecondPass();
          delete _this.zombieRowCtrls[rowCtrl.getInstanceId()];
        });
      } else {
        rowCtrl.destroySecondPass();
      }
    });
    if (animate) {
      // this ensures we fire displayedRowsChanged AFTER all the 'executeInAWhileFuncs' get
      // executed, as we added it to the end of the list.
      executeInAWhileFuncs.push(function () {
        _this.updateAllRowCtrls();
        _this.dispatchDisplayedRowsChanged();
      });
      executeInAWhile(executeInAWhileFuncs);
    }
  };
  RowRenderer.prototype.checkAngularCompile = function () {
    var _this = this;
    // if we are doing angular compiling, then do digest the scope here
    if (this.gridOptionsWrapper.isAngularCompileRows()) {
      // we do it in a timeout, in case we are already in an apply
      window.setTimeout(function () {
        _this.$scope.$apply();
      }, 0);
    }
  };
  RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
    var _this = this;
    var newFirst;
    var newLast;
    if (!this.paginationProxy.isRowsToRender()) {
      newFirst = 0;
      newLast = -1; // setting to -1 means nothing in range
    } else if (this.printLayout) {
      newFirst = this.paginationProxy.getPageFirstRow();
      newLast = this.paginationProxy.getPageLastRow();
    } else {
      var bufferPixels = this.gridOptionsWrapper.getRowBufferInPixels();
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var rowHeightsChanged = false;
      var firstPixel = void 0;
      var lastPixel = void 0;
      do {
        var paginationOffset = this.paginationProxy.getPixelOffset();
        var _a = this.paginationProxy.getCurrentPagePixelRange(),
          pageFirstPixel = _a.pageFirstPixel,
          pageLastPixel = _a.pageLastPixel;
        var divStretchOffset = this.rowContainerHeightService.getDivStretchOffset();
        var bodyVRange = gridBodyCon.getScrollFeature().getVScrollPosition();
        var bodyTopPixel = bodyVRange.top;
        var bodyBottomPixel = bodyVRange.bottom;
        firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
        lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
        // if the rows we are about to display get their heights changed, then that upsets the calcs from above.
        rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
      } while (rowHeightsChanged);
      var firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
      var lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
      var pageFirstRow = this.paginationProxy.getPageFirstRow();
      var pageLastRow = this.paginationProxy.getPageLastRow();
      // adjust, in case buffer extended actual size
      if (firstRowIndex < pageFirstRow) {
        firstRowIndex = pageFirstRow;
      }
      if (lastRowIndex > pageLastRow) {
        lastRowIndex = pageLastRow;
      }
      newFirst = firstRowIndex;
      newLast = lastRowIndex;
    }
    // sometimes user doesn't set CSS right and ends up with grid with no height and grid ends up
    // trying to render all the rows, eg 10,000+ rows. this will kill the browser. so instead of
    // killing the browser, we limit the number of rows. just in case some use case we didn't think
    // of, we also have a property to not do this operation.
    var rowLayoutNormal = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
    var suppressRowCountRestriction = this.gridOptionsWrapper.isSuppressMaxRenderedRowRestriction();
    var rowBufferMaxSize = Math.max(this.gridOptionsWrapper.getRowBuffer(), 500);
    if (rowLayoutNormal && !suppressRowCountRestriction) {
      if (newLast - newFirst > rowBufferMaxSize) {
        newLast = newFirst + rowBufferMaxSize;
      }
    }
    var firstDiffers = newFirst !== this.firstRenderedRow;
    var lastDiffers = newLast !== this.lastRenderedRow;
    if (firstDiffers || lastDiffers) {
      this.firstRenderedRow = newFirst;
      this.lastRenderedRow = newLast;
      var event_1 = {
        type: Events.EVENT_VIEWPORT_CHANGED,
        firstRow: newFirst,
        lastRow: newLast,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
    // only dispatch firstDataRendered if we have actually rendered some data
    if (this.paginationProxy.isRowsToRender()) {
      var event_2 = {
        type: Events.EVENT_FIRST_DATA_RENDERED,
        firstRow: newFirst,
        lastRow: newLast,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      // added a small delay here because in some scenarios this can be fired
      // before the grid is actually rendered, causing component creation
      // on EVENT_FIRST_DATA_RENDERED to fail.
      window.setTimeout(function () {
        return _this.eventService.dispatchEventOnce(event_2);
      }, 50);
    }
  };
  RowRenderer.prototype.ensureAllRowsInRangeHaveHeightsCalculated = function (topPixel, bottomPixel) {
    // ensureRowHeightsVisible only works with CSRM, as it's the only row model that allows lazy row height calcs.
    // all the other row models just hard code so the method just returns back false
    var res = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
    if (res) {
      this.updateContainerHeights();
    }
    return res;
  };
  RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
    return this.firstRenderedRow;
  };
  RowRenderer.prototype.getLastVirtualRenderedRow = function () {
    return this.lastRenderedRow;
  };
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  RowRenderer.prototype.doNotUnVirtualiseRow = function (rowComp) {
    var REMOVE_ROW = false;
    var KEEP_ROW = true;
    var rowNode = rowComp.getRowNode();
    var rowHasFocus = this.focusService.isRowNodeFocused(rowNode);
    var rowIsEditing = rowComp.isEditing();
    var rowIsDetail = rowNode.detail;
    var mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
    // if we deffo don't want to keep it,
    if (!mightWantToKeepRow) {
      return REMOVE_ROW;
    }
    // editing row, only remove if it is no longer rendered, eg filtered out or new data set.
    // the reason we want to keep is if user is scrolling up and down, we don't want to loose
    // the context of the editing in process.
    var rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
    return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
  };
  RowRenderer.prototype.createRowCon = function (rowNode, animate, afterScroll) {
    var rowCtrlFromCache = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(rowNode) : null;
    if (rowCtrlFromCache) {
      return rowCtrlFromCache;
    }
    // we don't use animations frames for printing, so the user can put the grid into print mode
    // and immediately print - otherwise the user would have to wait for the rows to draw in the background
    // (via the animation frames) which is awkward to do from code.
    // we only do the animation frames after scrolling, as this is where we want the smooth user experience.
    // having animation frames for other times makes the grid look 'jumpy'.
    var suppressAnimationFrame = this.gridOptionsWrapper.isSuppressAnimationFrame();
    var useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
    var res = new RowCtrl(this.$scope, rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
    return res;
  };
  RowRenderer.prototype.getRenderedNodes = function () {
    var renderedRows = this.rowCtrlsByRowIndex;
    return Object.keys(renderedRows).map(function (key) {
      return renderedRows[key].getRowNode();
    });
  };
  RowRenderer.prototype.getRowByPosition = function (rowPosition) {
    var rowComponent;
    switch (rowPosition.rowPinned) {
      case Constants.PINNED_TOP:
        rowComponent = this.topRowCtrls[rowPosition.rowIndex];
        break;
      case Constants.PINNED_BOTTOM:
        rowComponent = this.bottomRowCtrls[rowPosition.rowIndex];
        break;
      default:
        rowComponent = this.rowCtrlsByRowIndex[rowPosition.rowIndex];
        break;
    }
    return rowComponent;
  };
  RowRenderer.prototype.getRowNode = function (gridRow) {
    switch (gridRow.rowPinned) {
      case Constants.PINNED_TOP:
        return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
      case Constants.PINNED_BOTTOM:
        return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
      default:
        return this.rowModel.getRow(gridRow.rowIndex);
    }
  };
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  RowRenderer.prototype.isRangeInRenderedViewport = function (startIndex, endIndex) {
    // parent closed means the parent node is not expanded, thus these blocks are not visible
    var parentClosed = startIndex == null || endIndex == null;
    if (parentClosed) {
      return false;
    }
    var blockAfterViewport = startIndex > this.lastRenderedRow;
    var blockBeforeViewport = endIndex < this.firstRenderedRow;
    var blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
    return blockInsideViewport;
  };
  __decorate$K([Autowired("paginationProxy")], RowRenderer.prototype, "paginationProxy", void 0);
  __decorate$K([Autowired("columnModel")], RowRenderer.prototype, "columnModel", void 0);
  __decorate$K([Autowired("$scope")], RowRenderer.prototype, "$scope", void 0);
  __decorate$K([Autowired("pinnedRowModel")], RowRenderer.prototype, "pinnedRowModel", void 0);
  __decorate$K([Autowired("rowModel")], RowRenderer.prototype, "rowModel", void 0);
  __decorate$K([Autowired("focusService")], RowRenderer.prototype, "focusService", void 0);
  __decorate$K([Autowired("columnApi")], RowRenderer.prototype, "columnApi", void 0);
  __decorate$K([Autowired("gridApi")], RowRenderer.prototype, "gridApi", void 0);
  __decorate$K([Autowired("beans")], RowRenderer.prototype, "beans", void 0);
  __decorate$K([Autowired("rowContainerHeightService")], RowRenderer.prototype, "rowContainerHeightService", void 0);
  __decorate$K([Optional("ctrlsService")], RowRenderer.prototype, "ctrlsService", void 0);
  __decorate$K([PostConstruct], RowRenderer.prototype, "postConstruct", null);
  RowRenderer = __decorate$K([Bean("rowRenderer")], RowRenderer);
  return RowRenderer;
}(BeanStub);
var RowCtrlCache = /** @class */function () {
  function RowCtrlCache(maxCount) {
    // map for fast access
    this.entriesMap = {};
    // list for keeping order
    this.entriesList = [];
    this.maxCount = maxCount;
  }
  RowCtrlCache.prototype.toString = function () {
    return this.entriesList.map(function (item) {
      return item.getRowNode().data.name;
    }).join(', ');
  };
  RowCtrlCache.prototype.addRow = function (rowCtrl) {
    this.entriesMap[rowCtrl.getRowNode().id] = rowCtrl;
    this.entriesList.push(rowCtrl);
    rowCtrl.setCached(true);
    if (this.entriesList.length > this.maxCount) {
      var rowCtrlToDestroy = this.entriesList[0];
      rowCtrlToDestroy.destroyFirstPass();
      rowCtrlToDestroy.destroySecondPass();
      this.removeFromCache(rowCtrlToDestroy);
    }
  };
  RowCtrlCache.prototype.getRow = function (rowNode) {
    if (rowNode == null || rowNode.id == null) {
      return null;
    }
    var res = this.entriesMap[rowNode.id];
    if (!res) {
      return null;
    }
    this.removeFromCache(res);
    res.setCached(false);
    // this can happen if user reloads data, and a new RowNode is reusing
    // the same ID as the old one
    var rowNodeMismatch = res.getRowNode() != rowNode;
    return rowNodeMismatch ? null : res;
  };
  RowCtrlCache.prototype.removeFromCache = function (rowCtrl) {
    var rowNodeId = rowCtrl.getRowNode().id;
    delete this.entriesMap[rowNodeId];
    removeFromArray(this.entriesList, rowCtrl);
  };
  RowCtrlCache.prototype.getEntries = function () {
    return this.entriesList;
  };
  return RowCtrlCache;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$X = undefined && undefined.__extends || function () {
  var _extendStatics60 = function extendStatics(d, b) {
    _extendStatics60 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics60(d, b);
  };
  return function (d, b) {
    _extendStatics60(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AbstractHeaderCellComp = /** @class */function (_super) {
  __extends$X(AbstractHeaderCellComp, _super);
  function AbstractHeaderCellComp(template, ctrl) {
    var _this = _super.call(this, template) || this;
    _this.ctrl = ctrl;
    return _this;
  }
  AbstractHeaderCellComp.prototype.getCtrl = function () {
    return this.ctrl;
  };
  return AbstractHeaderCellComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$Y = undefined && undefined.__extends || function () {
  var _extendStatics61 = function extendStatics(d, b) {
    _extendStatics61 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics61(d, b);
  };
  return function (d, b) {
    _extendStatics61(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$L = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderCellComp = /** @class */function (_super) {
  __extends$Y(HeaderCellComp, _super);
  function HeaderCellComp(ctrl) {
    var _this = _super.call(this, HeaderCellComp.TEMPLATE, ctrl) || this;
    _this.headerCompVersion = 0;
    _this.column = ctrl.getColumnGroupChild();
    _this.pinned = ctrl.getPinned();
    return _this;
  }
  HeaderCellComp.prototype.postConstruct = function () {
    var _this = this;
    var eGui = this.getGui();
    var setAttribute = function setAttribute(name, value, element) {
      var actualElement = element ? element : eGui;
      if (value != null && value != '') {
        actualElement.setAttribute(name, value);
      } else {
        actualElement.removeAttribute(name);
      }
    };
    var compProxy = {
      setWidth: function setWidth(width) {
        return eGui.style.width = width;
      },
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setAriaSort: function setAriaSort(sort) {
        return sort ? _setAriaSort(eGui, sort) : removeAriaSort(eGui);
      },
      setColId: function setColId(id) {
        return setAttribute('col-id', id);
      },
      setTitle: function setTitle(title) {
        return setAttribute('title', title);
      },
      setAriaDescribedBy: function setAriaDescribedBy(value) {
        return _setAriaDescribedBy(eGui, value);
      },
      setUserCompDetails: function setUserCompDetails(compDetails) {
        return _this.setUserCompDetails(compDetails);
      },
      getUserCompInstance: function getUserCompInstance() {
        return _this.headerComp;
      }
    };
    this.ctrl.setComp(compProxy, this.getGui(), this.eResize);
    var selectAllGui = this.ctrl.getSelectAllGui();
    this.eResize.insertAdjacentElement('afterend', selectAllGui);
  };
  HeaderCellComp.prototype.destroyHeaderComp = function () {
    if (this.headerComp) {
      this.getGui().removeChild(this.headerCompGui);
      this.headerComp = this.destroyBean(this.headerComp);
      this.headerCompGui = undefined;
    }
  };
  HeaderCellComp.prototype.setUserCompDetails = function (compDetails) {
    var _this = this;
    this.headerCompVersion++;
    var versionCopy = this.headerCompVersion;
    compDetails.newAgStackInstance().then(function (comp) {
      return _this.afterCompCreated(versionCopy, comp);
    });
  };
  HeaderCellComp.prototype.afterCompCreated = function (version, headerComp) {
    if (version != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(headerComp);
      return;
    }
    this.destroyHeaderComp();
    this.headerComp = headerComp;
    this.headerCompGui = headerComp.getGui();
    this.getGui().appendChild(this.headerCompGui);
    this.ctrl.setDragSource(this.headerCompGui);
  };
  HeaderCellComp.TEMPLATE = "<div class=\"ag-header-cell\" role=\"columnheader\" unselectable=\"on\" tabindex=\"-1\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n        </div>";
  __decorate$L([RefSelector('eResize')], HeaderCellComp.prototype, "eResize", void 0);
  __decorate$L([PostConstruct], HeaderCellComp.prototype, "postConstruct", null);
  __decorate$L([PreDestroy], HeaderCellComp.prototype, "destroyHeaderComp", null);
  return HeaderCellComp;
}(AbstractHeaderCellComp);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$Z = undefined && undefined.__extends || function () {
  var _extendStatics62 = function extendStatics(d, b) {
    _extendStatics62 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics62(d, b);
  };
  return function (d, b) {
    _extendStatics62(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$M = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderGroupCellComp = /** @class */function (_super) {
  __extends$Z(HeaderGroupCellComp, _super);
  function HeaderGroupCellComp(ctrl) {
    return _super.call(this, HeaderGroupCellComp.TEMPLATE, ctrl) || this;
  }
  HeaderGroupCellComp.prototype.postConstruct = function () {
    var _this = this;
    var eGui = this.getGui();
    var setAttribute = function setAttribute(key, value) {
      return value != undefined ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
    };
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      addOrRemoveResizableCssClass: function addOrRemoveResizableCssClass(cssClassName, on) {
        return addOrRemoveCssClass(_this.eResize, cssClassName, on);
      },
      setWidth: function setWidth(width) {
        return eGui.style.width = width;
      },
      setColId: function setColId(id) {
        return eGui.setAttribute("col-id", id);
      },
      setAriaExpanded: function setAriaExpanded(expanded) {
        return setAttribute('aria-expanded', expanded);
      },
      setTitle: function setTitle(title) {
        return setAttribute("title", title);
      },
      setUserCompDetails: function setUserCompDetails(details) {
        return _this.setUserCompDetails(details);
      }
    };
    this.ctrl.setComp(compProxy, eGui, this.eResize);
  };
  HeaderGroupCellComp.prototype.setUserCompDetails = function (details) {
    var _this = this;
    details.newAgStackInstance().then(function (comp) {
      return _this.afterHeaderCompCreated(comp);
    });
  };
  HeaderGroupCellComp.prototype.afterHeaderCompCreated = function (headerGroupComp) {
    var _this = this;
    var destroyFunc = function destroyFunc() {
      return _this.destroyBean(headerGroupComp);
    };
    if (!this.isAlive()) {
      destroyFunc();
      return;
    }
    this.getGui().appendChild(headerGroupComp.getGui());
    this.addDestroyFunc(destroyFunc);
    this.ctrl.setDragSource(headerGroupComp.getGui());
  };
  HeaderGroupCellComp.TEMPLATE = "<div class=\"ag-header-group-cell\" role=\"columnheader\" tabindex=\"-1\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n        </div>";
  __decorate$M([Autowired('userComponentFactory')], HeaderGroupCellComp.prototype, "userComponentFactory", void 0);
  __decorate$M([RefSelector('eResize')], HeaderGroupCellComp.prototype, "eResize", void 0);
  __decorate$M([PostConstruct], HeaderGroupCellComp.prototype, "postConstruct", null);
  return HeaderGroupCellComp;
}(AbstractHeaderCellComp);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$_ = undefined && undefined.__extends || function () {
  var _extendStatics63 = function extendStatics(d, b) {
    _extendStatics63 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics63(d, b);
  };
  return function (d, b) {
    _extendStatics63(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$N = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderFilterCellComp = /** @class */function (_super) {
  __extends$_(HeaderFilterCellComp, _super);
  function HeaderFilterCellComp(ctrl) {
    return _super.call(this, HeaderFilterCellComp.TEMPLATE, ctrl) || this;
  }
  HeaderFilterCellComp.prototype.postConstruct = function () {
    var _this = this;
    var eGui = this.getGui();
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      addOrRemoveBodyCssClass: function addOrRemoveBodyCssClass(cssClassName, on) {
        return addOrRemoveCssClass(_this.eFloatingFilterBody, cssClassName, on);
      },
      addOrRemoveButtonWrapperCssClass: function addOrRemoveButtonWrapperCssClass(cssClassName, on) {
        return addOrRemoveCssClass(_this.eButtonWrapper, cssClassName, on);
      },
      setCompDetails: function setCompDetails(compDetails) {
        return _this.setCompDetails(compDetails);
      },
      getFloatingFilterComp: function getFloatingFilterComp() {
        return _this.compPromise;
      },
      setWidth: function setWidth(width) {
        return eGui.style.width = width;
      },
      setMenuIcon: function setMenuIcon(eIcon) {
        return _this.eButtonShowMainFilter.appendChild(eIcon);
      }
    };
    this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody);
  };
  HeaderFilterCellComp.prototype.setCompDetails = function (compDetails) {
    var _this = this;
    // because we are providing defaultFloatingFilterType, we know it will never be undefined;
    this.compPromise = compDetails.newAgStackInstance();
    this.compPromise.then(function (comp) {
      return _this.afterCompCreated(comp);
    });
  };
  HeaderFilterCellComp.prototype.afterCompCreated = function (comp) {
    var _this = this;
    if (!comp) {
      return;
    }
    this.addDestroyFunc(function () {
      return _this.context.destroyBean(comp);
    });
    if (!this.isAlive()) {
      return;
    }
    this.eFloatingFilterBody.appendChild(comp.getGui());
    if (comp.afterGuiAttached) {
      comp.afterGuiAttached();
    }
  };
  HeaderFilterCellComp.TEMPLATE = "<div class=\"ag-header-cell ag-floating-filter\" role=\"gridcell\" tabindex=\"-1\">\n            <div ref=\"eFloatingFilterBody\" role=\"presentation\"></div>\n            <div class=\"ag-floating-filter-button ag-hidden\" ref=\"eButtonWrapper\" role=\"presentation\">\n                <button type=\"button\" aria-label=\"Open Filter Menu\" class=\"ag-floating-filter-button-button\" ref=\"eButtonShowMainFilter\" tabindex=\"-1\"></button>\n            </div>\n        </div>";
  __decorate$N([RefSelector('eFloatingFilterBody')], HeaderFilterCellComp.prototype, "eFloatingFilterBody", void 0);
  __decorate$N([RefSelector('eButtonWrapper')], HeaderFilterCellComp.prototype, "eButtonWrapper", void 0);
  __decorate$N([RefSelector('eButtonShowMainFilter')], HeaderFilterCellComp.prototype, "eButtonShowMainFilter", void 0);
  __decorate$N([PostConstruct], HeaderFilterCellComp.prototype, "postConstruct", null);
  return HeaderFilterCellComp;
}(AbstractHeaderCellComp);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$$ = undefined && undefined.__extends || function () {
  var _extendStatics64 = function extendStatics(d, b) {
    _extendStatics64 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics64(d, b);
  };
  return function (d, b) {
    _extendStatics64(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$O = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderRowType;
(function (HeaderRowType) {
  HeaderRowType["COLUMN_GROUP"] = "group";
  HeaderRowType["COLUMN"] = "column";
  HeaderRowType["FLOATING_FILTER"] = "filter";
})(HeaderRowType || (HeaderRowType = {}));
var HeaderRowComp = /** @class */function (_super) {
  __extends$$(HeaderRowComp, _super);
  function HeaderRowComp(ctrl) {
    var _this = _super.call(this) || this;
    _this.headerComps = {};
    var extraClass = ctrl.getType() == HeaderRowType.COLUMN_GROUP ? "ag-header-row-column-group" : ctrl.getType() == HeaderRowType.FLOATING_FILTER ? "ag-header-row-column-filter" : "ag-header-row-column";
    _this.setTemplate( /* html */"<div class=\"ag-header-row " + extraClass + "\" role=\"row\"></div>");
    _this.ctrl = ctrl;
    return _this;
  }
  //noinspection JSUnusedLocalSymbols
  HeaderRowComp.prototype.init = function () {
    var _this = this;
    var compProxy = {
      setTransform: function setTransform(transform) {
        return _this.getGui().style.transform = transform;
      },
      setHeight: function setHeight(height) {
        return _this.getGui().style.height = height;
      },
      setTop: function setTop(top) {
        return _this.getGui().style.top = top;
      },
      setHeaderCtrls: function setHeaderCtrls(ctrls) {
        return _this.setHeaderCtrls(ctrls);
      },
      setWidth: function setWidth(width) {
        return _this.getGui().style.width = width;
      },
      setAriaRowIndex: function setAriaRowIndex(rowIndex) {
        return _setAriaRowIndex(_this.getGui(), rowIndex);
      }
    };
    this.ctrl.setComp(compProxy);
  };
  HeaderRowComp.prototype.destroyHeaderCtrls = function () {
    this.setHeaderCtrls([]);
  };
  HeaderRowComp.prototype.setHeaderCtrls = function (ctrls) {
    var _this = this;
    if (!this.isAlive()) {
      return;
    }
    var oldComps = this.headerComps;
    this.headerComps = {};
    ctrls.forEach(function (ctrl) {
      var id = ctrl.getInstanceId();
      var comp = oldComps[id];
      delete oldComps[id];
      if (comp == null) {
        comp = _this.createHeaderComp(ctrl);
        _this.getGui().appendChild(comp.getGui());
      }
      _this.headerComps[id] = comp;
    });
    iterateObject(oldComps, function (id, comp) {
      _this.getGui().removeChild(comp.getGui());
      _this.destroyBean(comp);
    });
    var ensureDomOrder = this.gridOptionsWrapper.isEnsureDomOrder();
    if (ensureDomOrder) {
      var comps = getAllValuesInObject(this.headerComps);
      // ordering the columns by left position orders them in the order they appear on the screen
      comps.sort(function (a, b) {
        var leftA = a.getCtrl().getColumnGroupChild().getLeft();
        var leftB = b.getCtrl().getColumnGroupChild().getLeft();
        return leftA - leftB;
      });
      var elementsInOrder = comps.map(function (c) {
        return c.getGui();
      });
      setDomChildOrder(this.getGui(), elementsInOrder);
    }
  };
  HeaderRowComp.prototype.createHeaderComp = function (headerCtrl) {
    var result;
    switch (this.ctrl.getType()) {
      case HeaderRowType.COLUMN_GROUP:
        result = new HeaderGroupCellComp(headerCtrl);
        break;
      case HeaderRowType.FLOATING_FILTER:
        result = new HeaderFilterCellComp(headerCtrl);
        break;
      default:
        result = new HeaderCellComp(headerCtrl);
        break;
    }
    this.createBean(result);
    result.setParentComponent(this);
    return result;
  };
  __decorate$O([PostConstruct], HeaderRowComp.prototype, "init", null);
  __decorate$O([PreDestroy], HeaderRowComp.prototype, "destroyHeaderCtrls", null);
  return HeaderRowComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$10 = undefined && undefined.__extends || function () {
  var _extendStatics65 = function extendStatics(d, b) {
    _extendStatics65 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics65(d, b);
  };
  return function (d, b) {
    _extendStatics65(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$P = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderNavigationDirection;
(function (HeaderNavigationDirection) {
  HeaderNavigationDirection[HeaderNavigationDirection["UP"] = 0] = "UP";
  HeaderNavigationDirection[HeaderNavigationDirection["DOWN"] = 1] = "DOWN";
  HeaderNavigationDirection[HeaderNavigationDirection["LEFT"] = 2] = "LEFT";
  HeaderNavigationDirection[HeaderNavigationDirection["RIGHT"] = 3] = "RIGHT";
})(HeaderNavigationDirection || (HeaderNavigationDirection = {}));
var HeaderNavigationService = /** @class */function (_super) {
  __extends$10(HeaderNavigationService, _super);
  function HeaderNavigationService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HeaderNavigationService.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      _this.gridBodyCon = p.gridBodyCtrl;
    });
  };
  HeaderNavigationService.prototype.getHeaderRowCount = function () {
    var centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
    return centerHeaderContainer ? centerHeaderContainer.getRowCount() : 0;
  };
  HeaderNavigationService.prototype.getHeaderRowType = function (rowIndex) {
    var centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
    if (centerHeaderContainer) {
      return centerHeaderContainer.getRowType(rowIndex);
    }
  };
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  HeaderNavigationService.prototype.navigateVertically = function (direction, fromHeader, event) {
    if (!fromHeader) {
      fromHeader = this.focusService.getFocusedHeader();
    }
    if (!fromHeader) {
      return false;
    }
    var headerRowIndex = fromHeader.headerRowIndex,
      column = fromHeader.column;
    var rowLen = this.getHeaderRowCount();
    var isUp = direction === HeaderNavigationDirection.UP;
    var nextRow = isUp ? headerRowIndex - 1 : headerRowIndex + 1;
    var nextFocusColumn = null;
    var skipColumn = false;
    if (nextRow < 0) {
      nextRow = 0;
      nextFocusColumn = column;
      skipColumn = true;
    }
    if (nextRow >= rowLen) {
      nextRow = -1; // -1 indicates the focus should move to grid rows.
    }

    var currentRowType = this.getHeaderRowType(headerRowIndex);
    if (!skipColumn) {
      if (currentRowType === HeaderRowType.COLUMN_GROUP) {
        var currentColumn = column;
        nextFocusColumn = isUp ? column.getParent() : currentColumn.getDisplayedChildren()[0];
      } else if (currentRowType === HeaderRowType.FLOATING_FILTER) {
        nextFocusColumn = column;
      } else {
        var currentColumn = column;
        nextFocusColumn = isUp ? currentColumn.getParent() : currentColumn;
      }
      if (!nextFocusColumn) {
        return false;
      }
    }
    return this.focusService.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: nextRow,
        column: nextFocusColumn
      },
      allowUserOverride: true,
      event: event
    });
  };
  /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  HeaderNavigationService.prototype.navigateHorizontally = function (direction, fromTab, event) {
    if (fromTab === void 0) {
      fromTab = false;
    }
    var focusedHeader = this.focusService.getFocusedHeader();
    var isLeft = direction === HeaderNavigationDirection.LEFT;
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    var nextHeader;
    var normalisedDirection;
    // either navigating to the left or isRtl (cannot be both)
    if (isLeft !== isRtl) {
      normalisedDirection = 'Before';
      nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
    } else {
      normalisedDirection = 'After';
      nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
    }
    if (nextHeader) {
      return this.focusService.focusHeaderPosition({
        headerPosition: nextHeader,
        direction: normalisedDirection,
        fromTab: fromTab,
        allowUserOverride: true,
        event: event
      });
    }
    if (!fromTab) {
      return true;
    }
    return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
  };
  HeaderNavigationService.prototype.focusNextHeaderRow = function (focusedHeader, direction, event) {
    var currentIndex = focusedHeader.headerRowIndex;
    var nextPosition = null;
    var nextRowIndex;
    if (direction === 'Before') {
      if (currentIndex > 0) {
        nextRowIndex = currentIndex - 1;
        nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, 'end');
      }
    } else {
      nextRowIndex = currentIndex + 1;
      nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, 'start');
    }
    return this.focusService.focusHeaderPosition({
      headerPosition: nextPosition,
      direction: direction,
      fromTab: true,
      allowUserOverride: true,
      event: event
    });
  };
  HeaderNavigationService.prototype.scrollToColumn = function (column, direction) {
    if (direction === void 0) {
      direction = 'After';
    }
    if (column.getPinned()) {
      return;
    }
    var columnToScrollTo;
    if (column instanceof ColumnGroup) {
      var columns = column.getDisplayedLeafColumns();
      columnToScrollTo = direction === 'Before' ? last(columns) : columns[0];
    } else {
      columnToScrollTo = column;
    }
    this.gridBodyCon.getScrollFeature().ensureColumnVisible(columnToScrollTo);
    // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
    // floating cell, the scrolls get out of sync
    this.gridBodyCon.getScrollFeature().horizontallyScrollHeaderCenterAndFloatingCenter();
    // need to flush frames, to make sure the correct cells are rendered
    this.animationFrameService.flushAllFrames();
  };
  __decorate$P([Autowired('focusService')], HeaderNavigationService.prototype, "focusService", void 0);
  __decorate$P([Autowired('headerPositionUtils')], HeaderNavigationService.prototype, "headerPositionUtils", void 0);
  __decorate$P([Autowired('animationFrameService')], HeaderNavigationService.prototype, "animationFrameService", void 0);
  __decorate$P([Autowired('ctrlsService')], HeaderNavigationService.prototype, "ctrlsService", void 0);
  __decorate$P([PostConstruct], HeaderNavigationService.prototype, "postConstruct", null);
  HeaderNavigationService = __decorate$P([Bean('headerNavigationService')], HeaderNavigationService);
  return HeaderNavigationService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$11 = undefined && undefined.__extends || function () {
  var _extendStatics66 = function extendStatics(d, b) {
    _extendStatics66 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics66(d, b);
  };
  return function (d, b) {
    _extendStatics66(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$Q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridHeaderCtrl = /** @class */function (_super) {
  __extends$11(GridHeaderCtrl, _super);
  function GridHeaderCtrl() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GridHeaderCtrl.prototype.setComp = function (comp, eGui, eFocusableElement) {
    this.comp = comp;
    this.eGui = eGui;
    this.createManagedBean(new ManagedFocusFeature(eFocusableElement, {
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      onFocusOut: this.onFocusOut.bind(this)
    }));
    // for setting ag-pivot-on / ag-pivot-off CSS classes
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
    this.onPivotModeChanged();
    this.setupHeaderHeight();
    this.ctrlsService.registerGridHeaderCtrl(this);
  };
  GridHeaderCtrl.prototype.setupHeaderHeight = function () {
    var listener = this.setHeaderHeight.bind(this);
    listener();
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_HEADER_HEIGHT, listener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, listener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, listener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, listener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, listener);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
  };
  GridHeaderCtrl.prototype.setHeaderHeight = function () {
    var _a = this,
      columnModel = _a.columnModel,
      gridOptionsWrapper = _a.gridOptionsWrapper;
    var numberOfFloating = 0;
    var headerRowCount = columnModel.getHeaderRowCount();
    var totalHeaderHeight;
    var groupHeight;
    var headerHeight;
    if (columnModel.isPivotMode()) {
      groupHeight = gridOptionsWrapper.getPivotGroupHeaderHeight();
      headerHeight = gridOptionsWrapper.getPivotHeaderHeight();
    } else {
      var hasFloatingFilters = columnModel.hasFloatingFilters();
      if (hasFloatingFilters) {
        headerRowCount++;
        numberOfFloating = 1;
      }
      groupHeight = gridOptionsWrapper.getGroupHeaderHeight();
      headerHeight = gridOptionsWrapper.getHeaderHeight();
    }
    var numberOfNonGroups = 1 + numberOfFloating;
    var numberOfGroups = headerRowCount - numberOfNonGroups;
    totalHeaderHeight = numberOfFloating * gridOptionsWrapper.getFloatingFiltersHeight();
    totalHeaderHeight += numberOfGroups * groupHeight;
    totalHeaderHeight += headerHeight;
    // one extra pixel is needed here to account for the
    // height of the border
    var px = totalHeaderHeight + 1 + "px";
    this.comp.setHeightAndMinHeight(px);
  };
  GridHeaderCtrl.prototype.onPivotModeChanged = function () {
    var pivotMode = this.columnModel.isPivotMode();
    this.comp.addOrRemoveCssClass('ag-pivot-on', pivotMode);
    this.comp.addOrRemoveCssClass('ag-pivot-off', !pivotMode);
  };
  GridHeaderCtrl.prototype.onTabKeyDown = function (e) {
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    var direction = e.shiftKey !== isRtl ? HeaderNavigationDirection.LEFT : HeaderNavigationDirection.RIGHT;
    if (this.headerNavigationService.navigateHorizontally(direction, true, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) {
      e.preventDefault();
    }
  };
  GridHeaderCtrl.prototype.handleKeyDown = function (e) {
    var direction = null;
    switch (e.keyCode) {
      case KeyCode.LEFT:
        direction = HeaderNavigationDirection.LEFT;
      case KeyCode.RIGHT:
        if (!exists(direction)) {
          direction = HeaderNavigationDirection.RIGHT;
        }
        this.headerNavigationService.navigateHorizontally(direction, false, e);
        break;
      case KeyCode.UP:
        direction = HeaderNavigationDirection.UP;
      case KeyCode.DOWN:
        if (!exists(direction)) {
          direction = HeaderNavigationDirection.DOWN;
        }
        if (this.headerNavigationService.navigateVertically(direction, null, e)) {
          e.preventDefault();
        }
        break;
      default:
        return;
    }
  };
  GridHeaderCtrl.prototype.onFocusOut = function (e) {
    var relatedTarget = e.relatedTarget;
    if (!relatedTarget && this.eGui.contains(document.activeElement)) {
      return;
    }
    if (!this.eGui.contains(relatedTarget)) {
      this.focusService.clearFocusedHeader();
    }
  };
  __decorate$Q([Autowired('headerNavigationService')], GridHeaderCtrl.prototype, "headerNavigationService", void 0);
  __decorate$Q([Autowired('focusService')], GridHeaderCtrl.prototype, "focusService", void 0);
  __decorate$Q([Autowired('columnModel')], GridHeaderCtrl.prototype, "columnModel", void 0);
  __decorate$Q([Autowired('ctrlsService')], GridHeaderCtrl.prototype, "ctrlsService", void 0);
  return GridHeaderCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$12 = undefined && undefined.__extends || function () {
  var _extendStatics67 = function extendStatics(d, b) {
    _extendStatics67 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics67(d, b);
  };
  return function (d, b) {
    _extendStatics67(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$R = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CenterWidthFeature = /** @class */function (_super) {
  __extends$12(CenterWidthFeature, _super);
  function CenterWidthFeature(callback) {
    var _this = _super.call(this) || this;
    _this.callback = callback;
    return _this;
  }
  CenterWidthFeature.prototype.postConstruct = function () {
    var listener = this.setWidth.bind(this);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
    this.setWidth();
  };
  CenterWidthFeature.prototype.setWidth = function () {
    var columnModel = this.columnModel;
    var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    var centerWidth = columnModel.getBodyContainerWidth();
    var leftWidth = columnModel.getDisplayedColumnsLeftWidth();
    var rightWidth = columnModel.getDisplayedColumnsRightWidth();
    var totalWidth = printLayout ? centerWidth + leftWidth + rightWidth : centerWidth;
    this.callback(totalWidth);
  };
  __decorate$R([Autowired('columnModel')], CenterWidthFeature.prototype, "columnModel", void 0);
  __decorate$R([PostConstruct], CenterWidthFeature.prototype, "postConstruct", null);
  return CenterWidthFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$S = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MoveColumnFeature = /** @class */function () {
  function MoveColumnFeature(pinned, eContainer) {
    this.needToMoveLeft = false;
    this.needToMoveRight = false;
    this.pinned = pinned;
    this.eContainer = eContainer;
    this.centerContainer = !exists(pinned);
  }
  MoveColumnFeature.prototype.init = function () {
    var _this = this;
    this.ctrlsService.whenReady(function () {
      _this.gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
    });
  };
  MoveColumnFeature.prototype.getIconName = function () {
    return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
  };
  MoveColumnFeature.prototype.onDragEnter = function (draggingEvent) {
    // we do dummy drag, so make sure column appears in the right location when first placed
    var columns = draggingEvent.dragItem.columns;
    var dragCameFromToolPanel = draggingEvent.dragSource.type === DragSourceType.ToolPanel;
    if (dragCameFromToolPanel) {
      // the if statement doesn't work if drag leaves grid, then enters again
      this.setColumnsVisible(columns, true, "uiColumnDragged");
    } else {
      // restore previous state of visible columns upon re-entering. this means if the user drags
      // a group out, and then drags the group back in, only columns that were originally visible
      // will be visible again. otherwise a group with three columns (but only two visible) could
      // be dragged out, then when it's dragged in again, all three are visible. this stops that.
      var visibleState_1 = draggingEvent.dragItem.visibleState;
      var visibleColumns = (columns || []).filter(function (column) {
        return visibleState_1[column.getId()];
      });
      this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
    }
    this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
    this.onDragging(draggingEvent, true);
  };
  MoveColumnFeature.prototype.onDragLeave = function (draggingEvent) {
    var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
    if (hideColumnOnExit) {
      var dragItem = draggingEvent.dragSource.getDragItem();
      var columns = dragItem.columns;
      this.setColumnsVisible(columns, false, "uiColumnDragged");
    }
    this.ensureIntervalCleared();
  };
  MoveColumnFeature.prototype.setColumnsVisible = function (columns, visible, source) {
    if (source === void 0) {
      source = "api";
    }
    if (columns) {
      var allowedCols = columns.filter(function (c) {
        return !c.getColDef().lockVisible;
      });
      this.columnModel.setColumnsVisible(allowedCols, visible, source);
    }
  };
  MoveColumnFeature.prototype.setColumnsPinned = function (columns, pinned, source) {
    if (source === void 0) {
      source = "api";
    }
    if (columns) {
      var allowedCols = columns.filter(function (c) {
        return !c.getColDef().lockPinned;
      });
      this.columnModel.setColumnsPinned(allowedCols, pinned, source);
    }
  };
  MoveColumnFeature.prototype.onDragStop = function () {
    this.ensureIntervalCleared();
  };
  MoveColumnFeature.prototype.normaliseX = function (x) {
    // flip the coordinate if doing RTL
    if (this.gridOptionsWrapper.isEnableRtl()) {
      var clientWidth = this.eContainer.clientWidth;
      x = clientWidth - x;
    }
    // adjust for scroll only if centre container (the pinned containers don't scroll)
    if (this.centerContainer) {
      x += this.ctrlsService.getCenterRowContainerCtrl().getCenterViewportScrollLeft();
    }
    return x;
  };
  MoveColumnFeature.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
    if (this.centerContainer) {
      // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
      // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
      var firstVisiblePixel = this.ctrlsService.getCenterRowContainerCtrl().getCenterViewportScrollLeft();
      var lastVisiblePixel = firstVisiblePixel + this.ctrlsService.getCenterRowContainerCtrl().getCenterWidth();
      if (this.gridOptionsWrapper.isEnableRtl()) {
        this.needToMoveRight = xAdjustedForScroll < firstVisiblePixel + 50;
        this.needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - 50;
      } else {
        this.needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + 50;
        this.needToMoveRight = xAdjustedForScroll > lastVisiblePixel - 50;
      }
      if (this.needToMoveLeft || this.needToMoveRight) {
        this.ensureIntervalStarted();
      } else {
        this.ensureIntervalCleared();
      }
    }
  };
  MoveColumnFeature.prototype.onDragging = function (draggingEvent, fromEnter) {
    var _this = this;
    if (fromEnter === void 0) {
      fromEnter = false;
    }
    this.lastDraggingEvent = draggingEvent;
    // if moving up or down (ie not left or right) then do nothing
    if (missing(draggingEvent.hDirection)) {
      return;
    }
    var mouseXNormalised = this.normaliseX(draggingEvent.x);
    // if the user is dragging into the panel, ie coming from the side panel into the main grid,
    // we don't want to scroll the grid this time, it would appear like the table is jumping
    // each time a column is dragged in.
    if (!fromEnter) {
      this.checkCenterForScrolling(mouseXNormalised);
    }
    var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
    var dragSourceType = draggingEvent.dragSource.type;
    var columnsToMove = draggingEvent.dragSource.getDragItem().columns;
    columnsToMove = columnsToMove.filter(function (col) {
      if (col.getColDef().lockPinned) {
        // if locked return true only if both col and container are same pin type.
        // double equals (==) here on purpose so that null==undefined is true (for not pinned options)
        return col.getPinned() == _this.pinned;
      }
      // if not pin locked, then always allowed to be in this container
      return true;
    });
    this.attemptMoveColumns(dragSourceType, columnsToMove, hDirectionNormalised, mouseXNormalised, fromEnter);
  };
  MoveColumnFeature.prototype.normaliseDirection = function (hDirection) {
    if (this.gridOptionsWrapper.isEnableRtl()) {
      switch (hDirection) {
        case HorizontalDirection.Left:
          return HorizontalDirection.Right;
        case HorizontalDirection.Right:
          return HorizontalDirection.Left;
        default:
          console.error("AG Grid: Unknown direction " + hDirection);
      }
    } else {
      return hDirection;
    }
  };
  // returns the index of the first column in the list ONLY if the cols are all beside
  // each other. if the cols are not beside each other, then returns null
  MoveColumnFeature.prototype.calculateOldIndex = function (movingCols) {
    var gridCols = this.columnModel.getAllGridColumns();
    var indexes = sortNumerically(movingCols.map(function (col) {
      return gridCols.indexOf(col);
    }));
    var firstIndex = indexes[0];
    var lastIndex = last(indexes);
    var spread = lastIndex - firstIndex;
    var gapsExist = spread !== indexes.length - 1;
    return gapsExist ? null : firstIndex;
  };
  MoveColumnFeature.prototype.attemptMoveColumns = function (dragSourceType, allMovingColumns, hDirection, mouseX, fromEnter) {
    var draggingLeft = hDirection === HorizontalDirection.Left;
    var draggingRight = hDirection === HorizontalDirection.Right;
    // it is important to sort the moving columns as they are in grid columns, as the list of moving columns
    // could themselves be part of 'married children' groups, which means we need to maintain the order within
    // the moving list.
    var allMovingColumnsOrdered = allMovingColumns.slice();
    this.columnModel.sortColumnsLikeGridColumns(allMovingColumnsOrdered);
    var validMoves = this.calculateValidMoves(allMovingColumnsOrdered, draggingRight, mouseX);
    // if cols are not adjacent, then this returns null. when moving, we constrain the direction of the move
    // (ie left or right) to the mouse direction. however
    var oldIndex = this.calculateOldIndex(allMovingColumnsOrdered);
    if (validMoves.length === 0) {
      return;
    }
    var firstValidMove = validMoves[0];
    // the two check below stop an error when the user grabs a group my a middle column, then
    // it is possible the mouse pointer is to the right of a column while been dragged left.
    // so we need to make sure that the mouse pointer is actually left of the left most column
    // if moving left, and right of the right most column if moving right
    // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
    // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
    // place the column to the RHS even if the mouse is moving left and the column is already on
    // the LHS. otherwise we stick to the rule described above.
    var constrainDirection = oldIndex !== null && !fromEnter;
    // don't consider 'fromEnter' when dragging header cells, otherwise group can jump to opposite direction of drag
    if (dragSourceType == DragSourceType.HeaderCell) {
      constrainDirection = oldIndex !== null;
    }
    if (constrainDirection) {
      // only allow left drag if this column is moving left
      if (draggingLeft && firstValidMove >= oldIndex) {
        return;
      }
      // only allow right drag if this column is moving right
      if (draggingRight && firstValidMove <= oldIndex) {
        return;
      }
    }
    for (var i = 0; i < validMoves.length; i++) {
      var move = validMoves[i];
      if (!this.columnModel.doesMovePassRules(allMovingColumnsOrdered, move)) {
        continue;
      }
      this.columnModel.moveColumns(allMovingColumnsOrdered, move, "uiColumnDragged");
      // important to return here, so once we do the first valid move, we don't try do any more
      return;
    }
  };
  MoveColumnFeature.prototype.calculateValidMoves = function (movingCols, draggingRight, mouseX) {
    var isMoveBlocked = this.gridOptionsWrapper.isSuppressMovableColumns() || movingCols.some(function (col) {
      return col.getColDef().suppressMovable;
    });
    if (isMoveBlocked) {
      return [];
    }
    // this is the list of cols on the screen, so it's these we use when comparing the x mouse position
    var allDisplayedCols = this.columnModel.getDisplayedColumns(this.pinned);
    // but this list is the list of all cols, when we move a col it's the index within this list that gets used,
    // so the result we return has to be and index location for this list
    var allGridCols = this.columnModel.getAllGridColumns();
    var movingDisplayedCols = allDisplayedCols.filter(function (col) {
      return includes(movingCols, col);
    });
    var otherDisplayedCols = allDisplayedCols.filter(function (col) {
      return !includes(movingCols, col);
    });
    var otherGridCols = allGridCols.filter(function (col) {
      return !includes(movingCols, col);
    });
    // work out how many DISPLAYED columns fit before the 'x' position. this gives us the displayIndex.
    // for example, if cols are a,b,c,d and we find a,b fit before 'x', then we want to place the moving
    // col between b and c (so that it is under the mouse position).
    var displayIndex = 0;
    var availableWidth = mouseX;
    // if we are dragging right, then the columns will be to the left of the mouse, so we also want to
    // include the width of the moving columns
    if (draggingRight) {
      var widthOfMovingDisplayedCols_1 = 0;
      movingDisplayedCols.forEach(function (col) {
        return widthOfMovingDisplayedCols_1 += col.getActualWidth();
      });
      availableWidth -= widthOfMovingDisplayedCols_1;
    }
    if (availableWidth > 0) {
      // now count how many of the displayed columns will fit to the left
      for (var i = 0; i < otherDisplayedCols.length; i++) {
        var col = otherDisplayedCols[i];
        availableWidth -= col.getActualWidth();
        if (availableWidth < 0) {
          break;
        }
        displayIndex++;
      }
      // trial and error, if going right, we adjust by one, i didn't manage to quantify why, but it works
      if (draggingRight) {
        displayIndex++;
      }
    }
    // the display index is with respect to all the showing columns, however when we move, it's with
    // respect to all grid columns, so we need to translate from display index to grid index
    var firstValidMove;
    if (displayIndex > 0) {
      var leftColumn = otherDisplayedCols[displayIndex - 1];
      firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
    } else {
      firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
      if (firstValidMove === -1) {
        firstValidMove = 0;
      }
    }
    var validMoves = [firstValidMove];
    var numberComparator = function numberComparator(a, b) {
      return a - b;
    };
    // add in other valid moves due to hidden columns and married children. for example, a particular
    // move might break a group that has married children (so move isn't valid), however there could
    // be hidden columns (not displayed) that we could jump over to make the move valid. because
    // they are hidden, user doesn't see any different, however it allows moves that would otherwise
    // not work. for example imagine a group with 9 columns and all columns are hidden except the
    // middle one (so 4 hidden to left, 4 hidden to right), then when moving 'firstValidMove' will
    // be relative to the not-shown column, however we need to consider the move jumping over all the
    // hidden children. if we didn't do this, then if the group just described was at the end (RHS) of the
    // grid, there would be no way to put a column after it (as the grid would only consider beside the
    // visible column, which would fail valid move rules).
    if (draggingRight) {
      // if dragging right, then we add all the additional moves to the right. so in other words
      // if the next move is not valid, find the next move to the right that is valid.
      var pointer = firstValidMove + 1;
      var lastIndex = allGridCols.length - 1;
      while (pointer <= lastIndex) {
        validMoves.push(pointer);
        pointer++;
      }
      // adding columns here means the order is now messed up
      validMoves.sort(numberComparator);
    } else {
      // if dragging left we do the reverse of dragging right, we add in all the valid moves to the
      // left. however we also have to consider moves to the right for all hidden columns first.
      // (this logic is hard to reason with, it was worked out with trial and error,
      // more observation rather than science).
      // add moves to the right
      var pointer = firstValidMove;
      var lastIndex = allGridCols.length - 1;
      var displacedCol = allGridCols[pointer];
      while (pointer <= lastIndex && this.isColumnHidden(allDisplayedCols, displacedCol)) {
        pointer++;
        validMoves.push(pointer);
        displacedCol = allGridCols[pointer];
      }
      // add moves to the left
      pointer = firstValidMove - 1;
      var firstDisplayIndex = 0;
      while (pointer >= firstDisplayIndex) {
        validMoves.push(pointer);
        pointer--;
      }
      // adding columns here means the order is now messed up
      validMoves.sort(numberComparator).reverse();
    }
    return validMoves;
  };
  // isHidden takes into account visible=false and group=closed, ie it is not displayed
  MoveColumnFeature.prototype.isColumnHidden = function (displayedColumns, col) {
    return displayedColumns.indexOf(col) < 0;
  };
  MoveColumnFeature.prototype.ensureIntervalStarted = function () {
    if (!this.movingIntervalId) {
      this.intervalCount = 0;
      this.failedMoveAttempts = 0;
      this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
      if (this.needToMoveLeft) {
        this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_LEFT, true);
      } else {
        this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_RIGHT, true);
      }
    }
  };
  MoveColumnFeature.prototype.ensureIntervalCleared = function () {
    if (this.movingIntervalId) {
      window.clearInterval(this.movingIntervalId);
      this.movingIntervalId = null;
      this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_MOVE);
    }
  };
  MoveColumnFeature.prototype.moveInterval = function () {
    // the amounts we move get bigger at each interval, so the speed accelerates, starting a bit slow
    // and getting faster. this is to give smoother user experience. we max at 100px to limit the speed.
    var pixelsToMove;
    this.intervalCount++;
    pixelsToMove = 10 + this.intervalCount * 5;
    if (pixelsToMove > 100) {
      pixelsToMove = 100;
    }
    var pixelsMoved = null;
    var scrollFeature = this.gridBodyCon.getScrollFeature();
    if (this.needToMoveLeft) {
      pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
    } else if (this.needToMoveRight) {
      pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
    }
    if (pixelsMoved !== 0) {
      this.onDragging(this.lastDraggingEvent);
      this.failedMoveAttempts = 0;
    } else {
      // we count the failed move attempts. if we fail to move 7 times, then we pin the column.
      // this is how we achieve pining by dragging the column to the edge of the grid.
      this.failedMoveAttempts++;
      var columns = this.lastDraggingEvent.dragItem.columns;
      var columnsThatCanPin = columns.filter(function (c) {
        return !c.getColDef().lockPinned;
      });
      if (columnsThatCanPin.length > 0) {
        this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_PINNED);
        if (this.failedMoveAttempts > 7) {
          var pinType = this.needToMoveLeft ? Constants.PINNED_LEFT : Constants.PINNED_RIGHT;
          this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
          this.dragAndDropService.nudge();
        }
      }
    }
  };
  __decorate$S([Autowired('columnModel')], MoveColumnFeature.prototype, "columnModel", void 0);
  __decorate$S([Autowired('dragAndDropService')], MoveColumnFeature.prototype, "dragAndDropService", void 0);
  __decorate$S([Autowired('gridOptionsWrapper')], MoveColumnFeature.prototype, "gridOptionsWrapper", void 0);
  __decorate$S([Autowired('ctrlsService')], MoveColumnFeature.prototype, "ctrlsService", void 0);
  __decorate$S([PostConstruct], MoveColumnFeature.prototype, "init", null);
  return MoveColumnFeature;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$T = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BodyDropPivotTarget = /** @class */function () {
  function BodyDropPivotTarget(pinned) {
    this.columnsToAggregate = [];
    this.columnsToGroup = [];
    this.columnsToPivot = [];
    this.pinned = pinned;
  }
  /** Callback for when drag enters */
  BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
    var _this = this;
    this.clearColumnsList();
    // in pivot mode, we don't accept any drops if functions are read only
    if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
      return;
    }
    var dragColumns = draggingEvent.dragItem.columns;
    if (!dragColumns) {
      return;
    }
    dragColumns.forEach(function (column) {
      // we don't allow adding secondary columns
      if (!column.isPrimary()) {
        return;
      }
      if (column.isAnyFunctionActive()) {
        return;
      }
      if (column.isAllowValue()) {
        _this.columnsToAggregate.push(column);
      } else if (column.isAllowRowGroup()) {
        _this.columnsToGroup.push(column);
      } else if (column.isAllowPivot()) {
        _this.columnsToPivot.push(column);
      }
    });
  };
  BodyDropPivotTarget.prototype.getIconName = function () {
    var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
    if (totalColumns > 0) {
      return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
    }
    return null;
  };
  /** Callback for when drag leaves */
  BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
    // if we are taking columns out of the center, then we remove them from the report
    this.clearColumnsList();
  };
  BodyDropPivotTarget.prototype.clearColumnsList = function () {
    this.columnsToAggregate.length = 0;
    this.columnsToGroup.length = 0;
    this.columnsToPivot.length = 0;
  };
  /** Callback for when dragging */
  BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {};
  /** Callback for when drag stops */
  BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
    if (this.columnsToAggregate.length > 0) {
      this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
    }
    if (this.columnsToGroup.length > 0) {
      this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
    }
    if (this.columnsToPivot.length > 0) {
      this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
  };
  __decorate$T([Autowired('columnModel')], BodyDropPivotTarget.prototype, "columnModel", void 0);
  __decorate$T([Autowired('gridOptionsWrapper')], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
  return BodyDropPivotTarget;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$13 = undefined && undefined.__extends || function () {
  var _extendStatics68 = function extendStatics(d, b) {
    _extendStatics68 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics68(d, b);
  };
  return function (d, b) {
    _extendStatics68(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$U = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BodyDropTarget = /** @class */function (_super) {
  __extends$13(BodyDropTarget, _super);
  function BodyDropTarget(pinned, eContainer) {
    var _this = _super.call(this) || this;
    _this.pinned = pinned;
    _this.eContainer = eContainer;
    return _this;
  }
  BodyDropTarget.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      switch (_this.pinned) {
        case Constants.PINNED_LEFT:
          _this.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.leftRowContainerCtrl.getContainerElement()], [p.bottomLeftRowContainerCtrl.getContainerElement()], [p.topLeftRowContainerCtrl.getContainerElement()]];
          break;
        case Constants.PINNED_RIGHT:
          _this.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.rightRowContainerCtrl.getContainerElement()], [p.bottomRightRowContainerCtrl.getContainerElement()], [p.topRightRowContainerCtrl.getContainerElement()]];
          break;
        default:
          _this.eSecondaryContainers = [[p.gridBodyCtrl.getBodyViewportElement(), p.centerRowContainerCtrl.getViewportElement()], [p.bottomCenterRowContainerCtrl.getViewportElement()], [p.topCenterRowContainerCtrl.getViewportElement()]];
          break;
      }
    });
  };
  BodyDropTarget.prototype.isInterestedIn = function (type) {
    return type === DragSourceType.HeaderCell || type === DragSourceType.ToolPanel && this.gridOptionsWrapper.isAllowDragFromColumnsToolPanel();
  };
  BodyDropTarget.prototype.getSecondaryContainers = function () {
    return this.eSecondaryContainers;
  };
  BodyDropTarget.prototype.getContainer = function () {
    return this.eContainer;
  };
  BodyDropTarget.prototype.init = function () {
    this.moveColumnFeature = this.createManagedBean(new MoveColumnFeature(this.pinned, this.eContainer));
    this.bodyDropPivotTarget = this.createManagedBean(new BodyDropPivotTarget(this.pinned));
    this.dragAndDropService.addDropTarget(this);
  };
  BodyDropTarget.prototype.getIconName = function () {
    return this.currentDropListener.getIconName();
  };
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  BodyDropTarget.prototype.isDropColumnInPivotMode = function (draggingEvent) {
    // in pivot mode, then if moving a column (ie didn't come from toolpanel) then it's
    // a standard column move, however if it came from the toolpanel, then we are introducing
    // dimensions or values to the grid
    return this.columnModel.isPivotMode() && draggingEvent.dragSource.type === DragSourceType.ToolPanel;
  };
  BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
    // we pick the drop listener depending on whether we are in pivot mode are not. if we are
    // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
    // we change visibility state and position.
    this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
    this.currentDropListener.onDragEnter(draggingEvent);
  };
  BodyDropTarget.prototype.onDragLeave = function (params) {
    this.currentDropListener.onDragLeave(params);
  };
  BodyDropTarget.prototype.onDragging = function (params) {
    this.currentDropListener.onDragging(params);
  };
  BodyDropTarget.prototype.onDragStop = function (params) {
    this.currentDropListener.onDragStop(params);
  };
  __decorate$U([Autowired('dragAndDropService')], BodyDropTarget.prototype, "dragAndDropService", void 0);
  __decorate$U([Autowired('columnModel')], BodyDropTarget.prototype, "columnModel", void 0);
  __decorate$U([Autowired('ctrlsService')], BodyDropTarget.prototype, "ctrlsService", void 0);
  __decorate$U([PostConstruct], BodyDropTarget.prototype, "postConstruct", null);
  __decorate$U([PostConstruct], BodyDropTarget.prototype, "init", null);
  return BodyDropTarget;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$14 = undefined && undefined.__extends || function () {
  var _extendStatics69 = function extendStatics(d, b) {
    _extendStatics69 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics69(d, b);
  };
  return function (d, b) {
    _extendStatics69(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$V = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var instanceIdSequence$3 = 0;
var AbstractHeaderCellCtrl = /** @class */function (_super) {
  __extends$14(AbstractHeaderCellCtrl, _super);
  function AbstractHeaderCellCtrl(columnGroupChild, parentRowCtrl) {
    var _this = _super.call(this) || this;
    _this.lastFocusEvent = null;
    _this.columnGroupChild = columnGroupChild;
    _this.parentRowCtrl = parentRowCtrl;
    // unique id to this instance, including the column ID to help with debugging in React as it's used in 'key'
    _this.instanceId = columnGroupChild.getUniqueId() + '-' + instanceIdSequence$3++;
    return _this;
  }
  AbstractHeaderCellCtrl.prototype.shouldStopEventPropagation = function (e) {
    var _a = this.focusService.getFocusedHeader(),
      headerRowIndex = _a.headerRowIndex,
      column = _a.column;
    return isUserSuppressingHeaderKeyboardEvent(this.gridOptionsWrapper, e, headerRowIndex, column);
  };
  AbstractHeaderCellCtrl.prototype.setGui = function (eGui) {
    this.eGui = eGui;
    this.addDomData();
  };
  AbstractHeaderCellCtrl.prototype.addDomData = function () {
    var _this = this;
    var key = AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL;
    this.gridOptionsWrapper.setDomData(this.eGui, key, this);
    this.addDestroyFunc(function () {
      return _this.gridOptionsWrapper.setDomData(_this.eGui, key, null);
    });
  };
  AbstractHeaderCellCtrl.prototype.focus = function (event) {
    if (!this.eGui) {
      return false;
    }
    this.lastFocusEvent = event || null;
    this.eGui.focus();
    return true;
  };
  AbstractHeaderCellCtrl.prototype.getRowIndex = function () {
    return this.parentRowCtrl.getRowIndex();
  };
  AbstractHeaderCellCtrl.prototype.getParentRowCtrl = function () {
    return this.parentRowCtrl;
  };
  AbstractHeaderCellCtrl.prototype.getPinned = function () {
    return this.parentRowCtrl.getPinned();
  };
  AbstractHeaderCellCtrl.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  AbstractHeaderCellCtrl.prototype.getColumnGroupChild = function () {
    return this.columnGroupChild;
  };
  AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL = 'headerCtrl';
  __decorate$V([Autowired('focusService')], AbstractHeaderCellCtrl.prototype, "focusService", void 0);
  return AbstractHeaderCellCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var FloatingFilterMapper = /** @class */function () {
  function FloatingFilterMapper() {}
  FloatingFilterMapper.getFloatingFilterType = function (filterType) {
    return this.filterToFloatingFilterMapping[filterType];
  };
  FloatingFilterMapper.filterToFloatingFilterMapping = {
    set: 'agSetColumnFloatingFilter',
    agSetColumnFilter: 'agSetColumnFloatingFilter',
    multi: 'agMultiColumnFloatingFilter',
    agMultiColumnFilter: 'agMultiColumnFloatingFilter',
    number: 'agNumberColumnFloatingFilter',
    agNumberColumnFilter: 'agNumberColumnFloatingFilter',
    date: 'agDateColumnFloatingFilter',
    agDateColumnFilter: 'agDateColumnFloatingFilter',
    text: 'agTextColumnFloatingFilter',
    agTextColumnFilter: 'agTextColumnFloatingFilter'
  };
  return FloatingFilterMapper;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$15 = undefined && undefined.__extends || function () {
  var _extendStatics70 = function extendStatics(d, b) {
    _extendStatics70 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics70(d, b);
  };
  return function (d, b) {
    _extendStatics70(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$W = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetLeftFeature = /** @class */function (_super) {
  __extends$15(SetLeftFeature, _super);
  function SetLeftFeature(columnOrGroup, eCell, beans, colsSpanning) {
    var _this = _super.call(this) || this;
    _this.columnOrGroup = columnOrGroup;
    _this.eCell = eCell;
    _this.ariaEl = _this.eCell.querySelector('[role=columnheader]') || _this.eCell;
    _this.colsSpanning = colsSpanning;
    _this.beans = beans;
    return _this;
  }
  SetLeftFeature.prototype.setColsSpanning = function (colsSpanning) {
    this.colsSpanning = colsSpanning;
    this.onLeftChanged();
  };
  SetLeftFeature.prototype.getColumnOrGroup = function () {
    if (this.beans.gridOptionsWrapper.isEnableRtl() && this.colsSpanning) {
      return last(this.colsSpanning);
    }
    return this.columnOrGroup;
  };
  SetLeftFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.columnOrGroup, Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
    this.setLeftFirstTime();
    // when in print layout, the left position is also dependent on the width of the pinned sections.
    // so additionally update left if any column width changes.
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this));
    // setting left has a dependency on print layout
    this.addManagedListener(this.beans.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.onLeftChanged.bind(this));
  };
  SetLeftFeature.prototype.setLeftFirstTime = function () {
    var suppressMoveAnimation = this.beans.gridOptionsWrapper.isSuppressColumnMoveAnimation();
    var oldLeftExists = exists(this.columnOrGroup.getOldLeft());
    var animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
    if (animateColumnMove) {
      this.animateInLeft();
    } else {
      this.onLeftChanged();
    }
  };
  SetLeftFeature.prototype.animateInLeft = function () {
    var _this = this;
    var colOrGroup = this.getColumnOrGroup();
    var left = colOrGroup.getLeft();
    var oldLeft = colOrGroup.getOldLeft();
    var oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, oldLeft);
    var actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
    this.setLeft(oldActualLeft);
    // we must keep track of the left we want to set to, as this would otherwise lead to a race
    // condition, if the user changed the left value many times in one VM turn, then we want to make
    // make sure the actualLeft we set in the timeout below (in the next VM turn) is the correct left
    // position. eg if user changes column position twice, then setLeft() below executes twice in next
    // VM turn, but only one (the correct one) should get applied.
    this.actualLeft = actualLeft;
    this.beans.columnAnimationService.executeNextVMTurn(function () {
      // test this left value is the latest one to be applied, and if not, do nothing
      if (_this.actualLeft === actualLeft) {
        _this.setLeft(actualLeft);
      }
    });
  };
  SetLeftFeature.prototype.onLeftChanged = function () {
    var colOrGroup = this.getColumnOrGroup();
    var left = colOrGroup.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
    this.setLeft(this.actualLeft);
  };
  SetLeftFeature.prototype.modifyLeftForPrintLayout = function (colOrGroup, leftPosition) {
    var printLayout = this.beans.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    if (!printLayout) {
      return leftPosition;
    }
    if (colOrGroup.getPinned() === Constants.PINNED_LEFT) {
      return leftPosition;
    }
    var leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
    if (colOrGroup.getPinned() === Constants.PINNED_RIGHT) {
      var bodyWidth = this.beans.columnModel.getBodyContainerWidth();
      return leftWidth + bodyWidth + leftPosition;
    }
    // is in body
    return leftWidth + leftPosition;
  };
  SetLeftFeature.prototype.setLeft = function (value) {
    // if the value is null, then that means the column is no longer
    // displayed. there is logic in the rendering to fade these columns
    // out, so we don't try and change their left positions.
    if (exists(value)) {
      this.eCell.style.left = value + "px";
    }
    var indexColumn;
    if (this.columnOrGroup instanceof Column) {
      indexColumn = this.columnOrGroup;
    } else {
      var columnGroup = this.columnOrGroup;
      var children = columnGroup.getLeafColumns();
      if (!children.length) {
        return;
      }
      if (children.length > 1) {
        setAriaColSpan(this.ariaEl, children.length);
      }
      indexColumn = children[0];
    }
    var index = this.beans.columnModel.getAriaColumnIndex(indexColumn);
    _setAriaColIndex(this.ariaEl, index);
  };
  __decorate$W([PostConstruct], SetLeftFeature.prototype, "postConstruct", null);
  return SetLeftFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$16 = undefined && undefined.__extends || function () {
  var _extendStatics71 = function extendStatics(d, b) {
    _extendStatics71 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics71(d, b);
  };
  return function (d, b) {
    _extendStatics71(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$X = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HoverFeature = /** @class */function (_super) {
  __extends$16(HoverFeature, _super);
  function HoverFeature(columns, element) {
    var _this = _super.call(this) || this;
    _this.columns = columns;
    _this.element = element;
    return _this;
  }
  HoverFeature.prototype.postConstruct = function () {
    if (this.gridOptionsWrapper.isColumnHoverHighlight()) {
      this.addMouseHoverListeners();
    }
  };
  HoverFeature.prototype.addMouseHoverListeners = function () {
    this.addManagedListener(this.element, 'mouseout', this.onMouseOut.bind(this));
    this.addManagedListener(this.element, 'mouseover', this.onMouseOver.bind(this));
  };
  HoverFeature.prototype.onMouseOut = function () {
    this.columnHoverService.clearMouseOver();
  };
  HoverFeature.prototype.onMouseOver = function () {
    this.columnHoverService.setMouseOver(this.columns);
  };
  __decorate$X([Autowired('columnHoverService')], HoverFeature.prototype, "columnHoverService", void 0);
  __decorate$X([PostConstruct], HoverFeature.prototype, "postConstruct", null);
  return HoverFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$17 = undefined && undefined.__extends || function () {
  var _extendStatics72 = function extendStatics(d, b) {
    _extendStatics72 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics72(d, b);
  };
  return function (d, b) {
    _extendStatics72(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$Y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderFilterCellCtrl = /** @class */function (_super) {
  __extends$17(HeaderFilterCellCtrl, _super);
  function HeaderFilterCellCtrl(column, parentRowCtrl) {
    var _this = _super.call(this, column, parentRowCtrl) || this;
    _this.column = column;
    return _this;
  }
  HeaderFilterCellCtrl.prototype.setComp = function (comp, eGui, eButtonShowMainFilter, eFloatingFilterBody) {
    _super.prototype.setGui.call(this, eGui);
    this.comp = comp;
    this.eButtonShowMainFilter = eButtonShowMainFilter;
    this.eFloatingFilterBody = eFloatingFilterBody;
    var colDef = this.column.getColDef();
    // const active = !(!(colDef.filter && colDef.floatingFilter) && !(colDef.filterFramework && colDef.floatingFilterComponentFramework));
    this.active = (!!colDef.filter || !!colDef.filterFramework) && !!colDef.floatingFilter;
    this.setupWidth();
    this.setupLeft();
    this.setupHover();
    this.setupFocus();
    this.setupUserComp();
    this.setupSyncWithFilter();
    this.setupUi();
    this.addManagedListener(this.eButtonShowMainFilter, 'click', this.showParentFilter.bind(this));
  };
  HeaderFilterCellCtrl.prototype.setupUi = function () {
    this.comp.addOrRemoveButtonWrapperCssClass('ag-hidden', !this.active || this.suppressFilterButton);
    if (!this.active) {
      return;
    }
    this.comp.addOrRemoveBodyCssClass('ag-floating-filter-full-body', this.suppressFilterButton);
    this.comp.addOrRemoveBodyCssClass('ag-floating-filter-body', !this.suppressFilterButton);
    var eMenuIcon = createIconNoSpan('filter', this.gridOptionsWrapper, this.column);
    if (eMenuIcon) {
      this.eButtonShowMainFilter.appendChild(eMenuIcon);
    }
  };
  HeaderFilterCellCtrl.prototype.setupFocus = function () {
    this.createManagedBean(new ManagedFocusFeature(this.eGui, {
      shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      onFocusIn: this.onFocusIn.bind(this)
    }));
  };
  HeaderFilterCellCtrl.prototype.onTabKeyDown = function (e) {
    var activeEl = document.activeElement;
    var wrapperHasFocus = activeEl === this.eGui;
    if (wrapperHasFocus) {
      return;
    }
    var nextFocusableEl = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
    if (nextFocusableEl) {
      e.preventDefault();
      nextFocusableEl.focus();
    }
  };
  HeaderFilterCellCtrl.prototype.handleKeyDown = function (e) {
    var activeEl = document.activeElement;
    var wrapperHasFocus = activeEl === this.eGui;
    switch (e.keyCode) {
      case KeyCode.UP:
      case KeyCode.DOWN:
        if (!wrapperHasFocus) {
          e.preventDefault();
        }
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
        if (wrapperHasFocus) {
          return;
        }
        e.stopPropagation();
      case KeyCode.ENTER:
        if (wrapperHasFocus) {
          if (this.focusService.focusInto(this.eGui)) {
            e.preventDefault();
          }
        }
        break;
      case KeyCode.ESCAPE:
        if (!wrapperHasFocus) {
          this.eGui.focus();
        }
    }
  };
  HeaderFilterCellCtrl.prototype.onFocusIn = function (e) {
    var isRelatedWithin = this.eGui.contains(e.relatedTarget);
    // when the focus is already within the component,
    // we default to the browser's behavior
    if (isRelatedWithin) {
      return;
    }
    var keyboardMode = this.focusService.isKeyboardMode();
    var notFromHeaderWrapper = !!e.relatedTarget && !containsClass(e.relatedTarget, 'ag-floating-filter');
    var fromWithinHeader = !!e.relatedTarget && isElementChildOfClass(e.relatedTarget, 'ag-floating-filter');
    if (keyboardMode && notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
      var lastFocusEvent = this.lastFocusEvent;
      var fromTab = !!(lastFocusEvent && lastFocusEvent.keyCode === KeyCode.TAB);
      if (lastFocusEvent && fromTab) {
        var currentFocusedHeader = this.beans.focusService.getFocusedHeader();
        var nextColumn = this.beans.columnModel.getDisplayedColAfter(this.column);
        var fromNextColumn = currentFocusedHeader && nextColumn === currentFocusedHeader.column;
        var shouldFocusLast = !!(keyboardMode && lastFocusEvent.shiftKey && fromNextColumn);
        this.focusService.focusInto(this.eGui, shouldFocusLast);
      }
    }
    var rowIndex = this.getRowIndex();
    this.beans.focusService.setFocusedHeader(rowIndex, this.column);
  };
  HeaderFilterCellCtrl.prototype.setupHover = function () {
    var _this = this;
    this.createManagedBean(new HoverFeature([this.column], this.eGui));
    var listener = function listener() {
      if (!_this.gridOptionsWrapper.isColumnHoverHighlight()) {
        return;
      }
      var hovered = _this.columnHoverService.isHovered(_this.column);
      _this.comp.addOrRemoveCssClass('ag-column-hover', hovered);
    };
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, listener);
    listener();
  };
  HeaderFilterCellCtrl.prototype.setupLeft = function () {
    var setLeftFeature = new SetLeftFeature(this.column, this.eGui, this.beans);
    this.createManagedBean(setLeftFeature);
  };
  HeaderFilterCellCtrl.prototype.setupUserComp = function () {
    if (!this.active) {
      return;
    }
    var colDef = this.column.getColDef();
    var filterParams = this.filterManager.createFilterParams(this.column, colDef);
    var finalFilterParams = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(colDef, 'filter', filterParams);
    var defaultFloatingFilterType = HeaderFilterCellCtrl.getDefaultFloatingFilterType(colDef);
    if (defaultFloatingFilterType == null) {
      defaultFloatingFilterType = 'agReadOnlyFloatingFilter';
    }
    var params = {
      api: this.gridApi,
      column: this.column,
      filterParams: finalFilterParams,
      currentParentModel: this.currentParentModel.bind(this),
      parentFilterInstance: this.parentFilterInstance.bind(this),
      showParentFilter: this.showParentFilter.bind(this),
      onFloatingFilterChanged: this.onFloatingFilterChanged.bind(this),
      suppressFilterButton: false // This one might be overridden from the colDef
    };
    // this is unusual - we need a params value OUTSIDE the component the params are for.
    // the params are for the floating filter component, but this property is actually for the wrapper.
    this.suppressFilterButton = colDef.floatingFilterComponentParams ? !!colDef.floatingFilterComponentParams.suppressFilterButton : false;
    var compDetails = this.userComponentFactory.getFloatingFilterCompDetails(colDef, params, defaultFloatingFilterType);
    if (compDetails) {
      this.comp.setCompDetails(compDetails);
    }
  };
  HeaderFilterCellCtrl.getDefaultFloatingFilterType = function (def) {
    if (def == null) {
      return null;
    }
    var defaultFloatingFilterType = null;
    if (typeof def.filter === 'string') {
      // will be undefined if not in the map
      defaultFloatingFilterType = FloatingFilterMapper.getFloatingFilterType(def.filter);
    } else if (def.filterFramework) ;else if (def.filter === true) {
      var setFilterModuleLoaded = ModuleRegistry.isRegistered(ModuleNames.SetFilterModule);
      defaultFloatingFilterType = setFilterModuleLoaded ? 'agSetColumnFloatingFilter' : 'agTextColumnFloatingFilter';
    }
    return defaultFloatingFilterType;
  };
  HeaderFilterCellCtrl.prototype.currentParentModel = function () {
    var filterComponent = this.getFilterComponent(false);
    return filterComponent ? filterComponent.resolveNow(null, function (filter) {
      return filter && filter.getModel();
    }) : null;
  };
  HeaderFilterCellCtrl.prototype.getFilterComponent = function (createIfDoesNotExist) {
    if (createIfDoesNotExist === void 0) {
      createIfDoesNotExist = true;
    }
    return this.filterManager.getFilterComponent(this.column, 'NO_UI', createIfDoesNotExist);
  };
  HeaderFilterCellCtrl.prototype.onFloatingFilterChanged = function () {
    console.warn('AG Grid: since version 21.x, how floating filters are implemented has changed. ' + 'Instead of calling params.onFloatingFilterChanged(), get a reference to the main filter via ' + 'params.parentFilterInstance() and then set a value on the parent filter directly.');
  };
  HeaderFilterCellCtrl.prototype.parentFilterInstance = function (callback) {
    var _this = this;
    var filterComponent = this.getFilterComponent();
    if (filterComponent) {
      filterComponent.then(function (instance) {
        var instanceUnwrapped = _this.frameworkComponentWrapper ? _this.frameworkComponentWrapper.unwrap(instance) : instance;
        callback(instanceUnwrapped);
      });
    }
  };
  HeaderFilterCellCtrl.prototype.showParentFilter = function () {
    var eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    this.menuFactory.showMenuAfterButtonClick(this.column, eventSource, 'floatingFilter', 'filterMenuTab', ['filterMenuTab']);
  };
  HeaderFilterCellCtrl.prototype.setupSyncWithFilter = function () {
    var _this = this;
    if (!this.active) {
      return;
    }
    var syncWithFilter = function syncWithFilter(filterChangedEvent) {
      var compPromise = _this.comp.getFloatingFilterComp();
      if (!compPromise) {
        return;
      }
      var parentModel = _this.currentParentModel();
      compPromise.then(function (comp) {
        return comp && comp.onParentModelChanged(parentModel, filterChangedEvent);
      });
    };
    this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, syncWithFilter);
    if (this.filterManager.isFilterActive(this.column)) {
      syncWithFilter(null);
    }
  };
  HeaderFilterCellCtrl.prototype.setupWidth = function () {
    var _this = this;
    var listener = function listener() {
      var width = _this.column.getActualWidth() + "px";
      _this.comp.setWidth(width);
    };
    this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, listener);
    listener();
  };
  __decorate$Y([Autowired('userComponentFactory')], HeaderFilterCellCtrl.prototype, "userComponentFactory", void 0);
  __decorate$Y([Autowired('filterManager')], HeaderFilterCellCtrl.prototype, "filterManager", void 0);
  __decorate$Y([Autowired('columnHoverService')], HeaderFilterCellCtrl.prototype, "columnHoverService", void 0);
  __decorate$Y([Autowired('gridApi')], HeaderFilterCellCtrl.prototype, "gridApi", void 0);
  __decorate$Y([Autowired('menuFactory')], HeaderFilterCellCtrl.prototype, "menuFactory", void 0);
  __decorate$Y([Autowired('beans')], HeaderFilterCellCtrl.prototype, "beans", void 0);
  __decorate$Y([Optional('frameworkComponentWrapper')], HeaderFilterCellCtrl.prototype, "frameworkComponentWrapper", void 0);
  return HeaderFilterCellCtrl;
}(AbstractHeaderCellCtrl);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var CssClassApplier = /** @class */function () {
  function CssClassApplier() {}
  CssClassApplier.getHeaderClassesFromColDef = function (abstractColDef, gridOptionsWrapper, column, columnGroup) {
    if (missing(abstractColDef)) {
      return [];
    }
    return this.getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gridOptionsWrapper, column, columnGroup);
  };
  CssClassApplier.getToolPanelClassesFromColDef = function (abstractColDef, gridOptionsWrapper, column, columnGroup) {
    if (missing(abstractColDef)) {
      return [];
    }
    return this.getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gridOptionsWrapper, column, columnGroup);
  };
  CssClassApplier.getColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, gridOptionsWrapper, column, columnGroup) {
    if (missing(classesOrFunc)) {
      return [];
    }
    var classToUse;
    if (typeof classesOrFunc === 'function') {
      var params = {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup,
        context: gridOptionsWrapper.getContext(),
        api: gridOptionsWrapper.getApi()
      };
      classToUse = classesOrFunc(params);
    } else {
      classToUse = classesOrFunc;
    }
    if (typeof classToUse === 'string') {
      return [classToUse];
    } else if (Array.isArray(classToUse)) {
      return classToUse;
    } else {
      return [];
    }
  };
  return CssClassApplier;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$18 = undefined && undefined.__extends || function () {
  var _extendStatics73 = function extendStatics(d, b) {
    _extendStatics73 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics73(d, b);
  };
  return function (d, b) {
    _extendStatics73(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$Z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ResizeFeature = /** @class */function (_super) {
  __extends$18(ResizeFeature, _super);
  function ResizeFeature(pinned, column, eResize, comp, ctrl) {
    var _this = _super.call(this) || this;
    _this.pinned = pinned;
    _this.column = column;
    _this.eResize = eResize;
    _this.comp = comp;
    _this.ctrl = ctrl;
    return _this;
  }
  ResizeFeature.prototype.postConstruct = function () {
    var _this = this;
    var colDef = this.column.getColDef();
    var destroyResizeFuncs = [];
    var canResize;
    var canAutosize;
    var addResize = function addResize() {
      setDisplayed(_this.eResize, canResize);
      if (!canResize) {
        return;
      }
      var finishedWithResizeFunc = _this.horizontalResizeService.addResizeBar({
        eResizeBar: _this.eResize,
        onResizeStart: _this.onResizeStart.bind(_this),
        onResizing: _this.onResizing.bind(_this, false),
        onResizeEnd: _this.onResizing.bind(_this, true)
      });
      destroyResizeFuncs.push(finishedWithResizeFunc);
      if (canAutosize) {
        var skipHeaderOnAutoSize_1 = _this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
        var autoSizeColListener_1 = function autoSizeColListener_1() {
          _this.columnModel.autoSizeColumn(_this.column, skipHeaderOnAutoSize_1, "uiColumnResized");
        };
        _this.eResize.addEventListener('dblclick', autoSizeColListener_1);
        var touchListener_1 = new TouchListener(_this.eResize);
        touchListener_1.addEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener_1);
        _this.addDestroyFunc(function () {
          _this.eResize.removeEventListener('dblclick', autoSizeColListener_1);
          touchListener_1.removeEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener_1);
          touchListener_1.destroy();
        });
      }
    };
    var removeResize = function removeResize() {
      destroyResizeFuncs.forEach(function (f) {
        return f();
      });
      destroyResizeFuncs.length = 0;
    };
    var refresh = function refresh() {
      var resize = _this.column.isResizable();
      var autoSize = !_this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
      var propertyChange = resize !== canResize || autoSize !== canAutosize;
      if (propertyChange) {
        canResize = resize;
        canAutosize = autoSize;
        removeResize();
        addResize();
      }
    };
    refresh();
    this.addDestroyFunc(removeResize);
    this.ctrl.addRefreshFunction(refresh);
  };
  ResizeFeature.prototype.onResizing = function (finished, resizeAmount) {
    var resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
    var columnWidths = [{
      key: this.column,
      newWidth: this.resizeStartWidth + resizeAmountNormalised
    }];
    this.columnModel.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnDragged");
    if (finished) {
      this.comp.addOrRemoveCssClass('ag-column-resizing', false);
    }
  };
  ResizeFeature.prototype.onResizeStart = function (shiftKey) {
    this.resizeStartWidth = this.column.getActualWidth();
    this.resizeWithShiftKey = shiftKey;
    this.comp.addOrRemoveCssClass('ag-column-resizing', true);
  };
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  ResizeFeature.prototype.normaliseResizeAmount = function (dragChange) {
    var result = dragChange;
    var notPinningLeft = this.pinned !== Constants.PINNED_LEFT;
    var pinningRight = this.pinned === Constants.PINNED_RIGHT;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      // for RTL, dragging left makes the col bigger, except when pinning left
      if (notPinningLeft) {
        result *= -1;
      }
    } else {
      // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
      if (pinningRight) {
        result *= -1;
      }
    }
    return result;
  };
  __decorate$Z([Autowired('horizontalResizeService')], ResizeFeature.prototype, "horizontalResizeService", void 0);
  __decorate$Z([Autowired('columnModel')], ResizeFeature.prototype, "columnModel", void 0);
  __decorate$Z([PostConstruct], ResizeFeature.prototype, "postConstruct", null);
  return ResizeFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$19 = undefined && undefined.__extends || function () {
  var _extendStatics74 = function extendStatics(d, b) {
    _extendStatics74 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics74(d, b);
  };
  return function (d, b) {
    _extendStatics74(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgCheckbox = /** @class */function (_super) {
  __extends$19(AgCheckbox, _super);
  function AgCheckbox(config, className, inputType) {
    if (className === void 0) {
      className = 'ag-checkbox';
    }
    if (inputType === void 0) {
      inputType = 'checkbox';
    }
    var _this = _super.call(this, config, className, inputType) || this;
    _this.labelAlignment = 'right';
    _this.selected = false;
    _this.readOnly = false;
    _this.passive = false;
    return _this;
  }
  AgCheckbox.prototype.addInputListeners = function () {
    this.addManagedListener(this.eInput, 'click', this.onCheckboxClick.bind(this));
    this.addManagedListener(this.eLabel, 'click', this.toggle.bind(this));
  };
  AgCheckbox.prototype.getNextValue = function () {
    return this.selected === undefined ? true : !this.selected;
  };
  AgCheckbox.prototype.setPassive = function (passive) {
    this.passive = passive;
  };
  AgCheckbox.prototype.isReadOnly = function () {
    return this.readOnly;
  };
  AgCheckbox.prototype.setReadOnly = function (readOnly) {
    addOrRemoveCssClass(this.eWrapper, 'ag-disabled', readOnly);
    this.eInput.disabled = readOnly;
    this.readOnly = readOnly;
  };
  AgCheckbox.prototype.setDisabled = function (disabled) {
    addOrRemoveCssClass(this.eWrapper, 'ag-disabled', disabled);
    return _super.prototype.setDisabled.call(this, disabled);
  };
  AgCheckbox.prototype.toggle = function () {
    if (this.eInput.disabled) {
      return;
    }
    var previousValue = this.isSelected();
    var nextValue = this.getNextValue();
    if (this.passive) {
      this.dispatchChange(nextValue, previousValue);
    } else {
      this.setValue(nextValue);
    }
  };
  AgCheckbox.prototype.getValue = function () {
    return this.isSelected();
  };
  AgCheckbox.prototype.setValue = function (value, silent) {
    this.refreshSelectedClass(value);
    this.setSelected(value, silent);
    return this;
  };
  AgCheckbox.prototype.setName = function (name) {
    var input = this.getInputElement();
    input.name = name;
    return this;
  };
  AgCheckbox.prototype.isSelected = function () {
    return this.selected;
  };
  AgCheckbox.prototype.setSelected = function (selected, silent) {
    if (this.isSelected() === selected) {
      return;
    }
    this.previousValue = this.isSelected();
    selected = this.selected = typeof selected === 'boolean' ? selected : undefined;
    this.eInput.checked = selected;
    this.eInput.indeterminate = selected === undefined;
    if (!silent) {
      this.dispatchChange(this.selected, this.previousValue);
    }
  };
  AgCheckbox.prototype.dispatchChange = function (selected, previousValue, event) {
    this.dispatchEvent({
      type: AgCheckbox.EVENT_CHANGED,
      selected: selected,
      previousValue: previousValue,
      event: event
    });
    var input = this.getInputElement();
    var checkboxChangedEvent = {
      type: Events.EVENT_CHECKBOX_CHANGED,
      id: input.id,
      name: input.name,
      selected: selected,
      previousValue: previousValue
    };
    this.eventService.dispatchEvent(checkboxChangedEvent);
  };
  AgCheckbox.prototype.onCheckboxClick = function (e) {
    if (this.passive || this.eInput.disabled) {
      return;
    }
    var previousValue = this.isSelected();
    var selected = this.selected = e.target.checked;
    this.refreshSelectedClass(selected);
    this.dispatchChange(selected, previousValue, e);
  };
  AgCheckbox.prototype.refreshSelectedClass = function (value) {
    addOrRemoveCssClass(this.eWrapper, 'ag-checked', value === true);
    addOrRemoveCssClass(this.eWrapper, 'ag-indeterminate', value == null);
  };
  return AgCheckbox;
}(AgAbstractInputField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1a = undefined && undefined.__extends || function () {
  var _extendStatics75 = function extendStatics(d, b) {
    _extendStatics75 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics75(d, b);
  };
  return function (d, b) {
    _extendStatics75(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$_ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SelectAllFeature = /** @class */function (_super) {
  __extends$1a(SelectAllFeature, _super);
  function SelectAllFeature(column) {
    var _this = _super.call(this) || this;
    _this.cbSelectAllVisible = false;
    _this.processingEventFromCheckbox = false;
    _this.column = column;
    var colDef = column.getColDef();
    _this.filteredOnly = colDef ? !!colDef.headerCheckboxSelectionFilteredOnly : false;
    return _this;
  }
  SelectAllFeature.prototype.onSpaceKeyPressed = function (e) {
    var checkbox = this.cbSelectAll;
    if (checkbox.isDisplayed() && !checkbox.getGui().contains(document.activeElement)) {
      e.preventDefault();
      checkbox.setValue(!checkbox.getValue());
    }
  };
  SelectAllFeature.prototype.getCheckboxGui = function () {
    return this.cbSelectAll.getGui();
  };
  SelectAllFeature.prototype.setComp = function (comp) {
    this.comp = comp;
    this.cbSelectAll = this.createManagedBean(new AgCheckbox());
    this.cbSelectAll.addCssClass('ag-header-select-all');
    setAriaRole(this.cbSelectAll.getGui(), 'presentation');
    this.showOrHideSelectAll();
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideSelectAll.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.showOrHideSelectAll.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
    this.addManagedListener(this.cbSelectAll, AgCheckbox.EVENT_CHANGED, this.onCbSelectAll.bind(this));
    this.cbSelectAll.getInputElement().setAttribute('tabindex', '-1');
    this.refreshSelectAllLabel();
  };
  SelectAllFeature.prototype.showOrHideSelectAll = function () {
    this.cbSelectAllVisible = this.isCheckboxSelection();
    this.cbSelectAll.setDisplayed(this.cbSelectAllVisible);
    if (this.cbSelectAllVisible) {
      // in case user is trying this feature with the wrong model type
      this.checkRightRowModelType();
      // make sure checkbox is showing the right state
      this.updateStateOfCheckbox();
    }
    this.refreshHeaderAriaDescribedBy(this.cbSelectAllVisible);
  };
  SelectAllFeature.prototype.refreshHeaderAriaDescribedBy = function (isSelectAllVisible) {
    var describedBy = isSelectAllVisible ? this.cbSelectAll.getInputElement().id : undefined;
    this.comp.setAriaDescribedBy(describedBy);
  };
  SelectAllFeature.prototype.onModelChanged = function () {
    if (!this.cbSelectAllVisible) {
      return;
    }
    this.updateStateOfCheckbox();
  };
  SelectAllFeature.prototype.onSelectionChanged = function () {
    if (!this.cbSelectAllVisible) {
      return;
    }
    this.updateStateOfCheckbox();
  };
  SelectAllFeature.prototype.getNextCheckboxState = function (selectionCount) {
    // if no rows, always have it unselected
    if (selectionCount.selected === 0 && selectionCount.notSelected === 0) {
      return false;
    }
    // if mix of selected and unselected, this is the tri-state
    if (selectionCount.selected > 0 && selectionCount.notSelected > 0) {
      return null;
    }
    // only selected
    if (selectionCount.selected > 0) {
      return true;
    }
    // nothing selected
    return false;
  };
  SelectAllFeature.prototype.updateStateOfCheckbox = function () {
    if (this.processingEventFromCheckbox) {
      return;
    }
    this.processingEventFromCheckbox = true;
    var selectionCount = this.getSelectionCount();
    var allSelected = this.getNextCheckboxState(selectionCount);
    this.cbSelectAll.setValue(allSelected);
    this.refreshSelectAllLabel();
    this.processingEventFromCheckbox = false;
  };
  SelectAllFeature.prototype.refreshSelectAllLabel = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var checked = this.cbSelectAll.getValue();
    var ariaStatus = checked ? translate('ariaChecked', 'checked') : translate('ariaUnchecked', 'unchecked');
    var ariaLabel = translate('ariaRowSelectAll', 'Press Space to toggle all rows selection');
    this.cbSelectAll.setInputAriaLabel(ariaLabel + " (" + ariaStatus + ")");
  };
  SelectAllFeature.prototype.getSelectionCount = function () {
    var _this = this;
    var selectedCount = 0;
    var notSelectedCount = 0;
    var callback = function callback(node) {
      if (_this.gridOptionsWrapper.isGroupSelectsChildren() && node.group) {
        return;
      }
      if (node.isSelected()) {
        selectedCount++;
      } else if (!node.selectable) ;else {
        notSelectedCount++;
      }
    };
    if (this.filteredOnly) {
      this.gridApi.forEachNodeAfterFilter(callback);
    } else {
      this.gridApi.forEachNode(callback);
    }
    return {
      notSelected: notSelectedCount,
      selected: selectedCount
    };
  };
  SelectAllFeature.prototype.checkRightRowModelType = function () {
    var rowModelType = this.rowModel.getType();
    var rowModelMatches = rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
    if (!rowModelMatches) {
      console.warn("AG Grid: selectAllCheckbox is only available if using normal row model, you are using " + rowModelType);
    }
  };
  SelectAllFeature.prototype.onCbSelectAll = function () {
    if (this.processingEventFromCheckbox) {
      return;
    }
    if (!this.cbSelectAllVisible) {
      return;
    }
    var value = this.cbSelectAll.getValue();
    if (value) {
      this.selectionService.selectAllRowNodes(this.filteredOnly);
    } else {
      this.selectionService.deselectAllRowNodes(this.filteredOnly);
    }
  };
  SelectAllFeature.prototype.isCheckboxSelection = function () {
    var result = this.column.getColDef().headerCheckboxSelection;
    if (typeof result === 'function') {
      var func = result;
      result = func({
        column: this.column,
        colDef: this.column.getColDef(),
        columnApi: this.columnApi,
        api: this.gridApi
      });
    }
    if (result) {
      if (this.gridOptionsWrapper.isRowModelServerSide()) {
        console.warn('headerCheckboxSelection is not supported for Server Side Row Model');
        return false;
      }
      if (this.gridOptionsWrapper.isRowModelInfinite()) {
        console.warn('headerCheckboxSelection is not supported for Infinite Row Model');
        return false;
      }
      if (this.gridOptionsWrapper.isRowModelViewport()) {
        console.warn('headerCheckboxSelection is not supported for Viewport Row Model');
        return false;
      }
      // otherwise the row model is compatible, so return true
      return true;
    }
    return false;
  };
  __decorate$_([Autowired('gridApi')], SelectAllFeature.prototype, "gridApi", void 0);
  __decorate$_([Autowired('columnApi')], SelectAllFeature.prototype, "columnApi", void 0);
  __decorate$_([Autowired('rowModel')], SelectAllFeature.prototype, "rowModel", void 0);
  __decorate$_([Autowired('selectionService')], SelectAllFeature.prototype, "selectionService", void 0);
  return SelectAllFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1b = undefined && undefined.__extends || function () {
  var _extendStatics76 = function extendStatics(d, b) {
    _extendStatics76 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics76(d, b);
  };
  return function (d, b) {
    _extendStatics76(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$$ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderCellCtrl = /** @class */function (_super) {
  __extends$1b(HeaderCellCtrl, _super);
  function HeaderCellCtrl(column, parentRowCtrl) {
    var _this = _super.call(this, column, parentRowCtrl) || this;
    _this.refreshFunctions = [];
    _this.userHeaderClasses = new Set();
    _this.column = column;
    return _this;
  }
  HeaderCellCtrl.prototype.setComp = function (comp, eGui, eResize) {
    var _this = this;
    _super.prototype.setGui.call(this, eGui);
    this.comp = comp;
    this.colDefVersion = this.columnModel.getColDefVersion();
    this.updateState();
    this.setupWidth();
    this.setupMovingCss();
    this.setupMenuClass();
    this.setupSortableClass();
    this.addColumnHoverListener();
    this.setupFilterCss();
    this.setupColId();
    this.setupClassesFromColDef();
    this.setupTooltip();
    this.addActiveHeaderMouseListeners();
    this.setupSelectAll();
    this.setupUserComp();
    this.createManagedBean(new ResizeFeature(this.getPinned(), this.column, eResize, comp, this));
    this.createManagedBean(new HoverFeature([this.column], eGui));
    this.createManagedBean(new SetLeftFeature(this.column, eGui, this.beans));
    this.createManagedBean(new ManagedFocusFeature(eGui, {
      shouldStopEventPropagation: function shouldStopEventPropagation(e) {
        return _this.shouldStopEventPropagation(e);
      },
      onTabKeyDown: function onTabKeyDown() {
        return null;
      },
      handleKeyDown: this.handleKeyDown.bind(this),
      onFocusIn: this.onFocusIn.bind(this),
      onFocusOut: this.onFocusOut.bind(this)
    }));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
  };
  HeaderCellCtrl.prototype.setupUserComp = function () {
    var compDetails = this.lookupUserCompDetails();
    this.setCompDetails(compDetails);
  };
  HeaderCellCtrl.prototype.setCompDetails = function (compDetails) {
    this.userCompDetails = compDetails;
    this.comp.setUserCompDetails(compDetails);
  };
  HeaderCellCtrl.prototype.lookupUserCompDetails = function () {
    var params = this.createParams();
    var colDef = this.column.getColDef();
    return this.userComponentFactory.getHeaderCompDetails(colDef, params);
  };
  HeaderCellCtrl.prototype.createParams = function () {
    var _this = this;
    var colDef = this.column.getColDef();
    var params = {
      column: this.column,
      displayName: this.displayName,
      enableSorting: colDef.sortable,
      enableMenu: this.menuEnabled,
      showColumnMenu: function showColumnMenu(source) {
        _this.gridApi.showColumnMenuAfterButtonClick(_this.column, source);
      },
      progressSort: function progressSort(multiSort) {
        _this.sortController.progressSort(_this.column, !!multiSort, "uiColumnSorted");
      },
      setSort: function setSort(sort, multiSort) {
        _this.sortController.setSortForColumn(_this.column, sort, !!multiSort, "uiColumnSorted");
      },
      api: this.gridApi,
      columnApi: this.columnApi,
      context: this.gridOptionsWrapper.getContext(),
      eGridHeader: this.getGui()
    };
    return params;
  };
  HeaderCellCtrl.prototype.setupSelectAll = function () {
    this.selectAllFeature = this.createManagedBean(new SelectAllFeature(this.column));
    this.selectAllFeature.setComp(this.comp);
  };
  HeaderCellCtrl.prototype.getSelectAllGui = function () {
    return this.selectAllFeature.getCheckboxGui();
  };
  HeaderCellCtrl.prototype.handleKeyDown = function (e) {
    if (e.keyCode === KeyCode.SPACE) {
      this.selectAllFeature.onSpaceKeyPressed(e);
    }
    if (e.keyCode === KeyCode.ENTER) {
      this.onEnterKeyPressed(e);
    }
  };
  HeaderCellCtrl.prototype.onEnterKeyPressed = function (e) {
    /// THIS IS BAD - we are assuming the header is not a user provided comp
    var headerComp = this.comp.getUserCompInstance();
    if (!headerComp) {
      return;
    }
    if (e.ctrlKey || e.metaKey) {
      if (this.menuEnabled && headerComp.showMenu) {
        e.preventDefault();
        headerComp.showMenu();
      }
    } else if (this.sortable) {
      var multiSort = e.shiftKey;
      this.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
    }
  };
  HeaderCellCtrl.prototype.isMenuEnabled = function () {
    return this.menuEnabled;
  };
  HeaderCellCtrl.prototype.onFocusIn = function (e) {
    if (!this.getGui().contains(e.relatedTarget)) {
      var rowIndex = this.getRowIndex();
      this.focusService.setFocusedHeader(rowIndex, this.column);
    }
    this.setActiveHeader(true);
  };
  HeaderCellCtrl.prototype.onFocusOut = function (e) {
    if (this.getGui().contains(e.relatedTarget)) {
      return;
    }
    this.setActiveHeader(false);
  };
  HeaderCellCtrl.prototype.setupTooltip = function () {
    var _this = this;
    var tooltipCtrl = {
      getColumn: function getColumn() {
        return _this.column;
      },
      getColDef: function getColDef() {
        return _this.column.getColDef();
      },
      getGui: function getGui() {
        return _this.eGui;
      },
      getLocation: function getLocation() {
        return 'header';
      },
      getTooltipValue: function getTooltipValue() {
        var res = _this.column.getColDef().headerTooltip;
        return res;
      }
    };
    var tooltipFeature = this.createManagedBean(new TooltipFeature(tooltipCtrl, this.beans));
    tooltipFeature.setComp(this.comp);
    this.refreshFunctions.push(function () {
      return tooltipFeature.refreshToolTip();
    });
  };
  HeaderCellCtrl.prototype.setupClassesFromColDef = function () {
    var _this = this;
    var refreshHeaderClasses = function refreshHeaderClasses() {
      var colDef = _this.column.getColDef();
      var goa = _this.gridOptionsWrapper;
      var classes = CssClassApplier.getHeaderClassesFromColDef(colDef, goa, _this.column, null);
      var oldClasses = _this.userHeaderClasses;
      _this.userHeaderClasses = new Set(classes);
      classes.forEach(function (c) {
        if (oldClasses.has(c)) {
          // class already added, no need to apply it, but remove from old set
          oldClasses.delete(c);
        } else {
          // class new since last time, so apply it
          _this.comp.addOrRemoveCssClass(c, true);
        }
      });
      // now old set only has classes that were applied last time, but not this time, so remove them
      oldClasses.forEach(function (c) {
        return _this.comp.addOrRemoveCssClass(c, false);
      });
    };
    this.refreshFunctions.push(refreshHeaderClasses);
    refreshHeaderClasses();
  };
  HeaderCellCtrl.prototype.getGui = function () {
    return this.eGui;
  };
  HeaderCellCtrl.prototype.setDragSource = function (eSource) {
    var _this = this;
    this.dragSourceElement = eSource;
    this.removeDragSource();
    if (!eSource) {
      return;
    }
    if (!this.draggable) {
      return;
    }
    this.moveDragSource = {
      type: DragSourceType.HeaderCell,
      eElement: eSource,
      defaultIconName: DragAndDropService.ICON_HIDE,
      getDragItem: function getDragItem() {
        return _this.createDragItem();
      },
      dragItemName: this.displayName,
      onDragStarted: function onDragStarted() {
        return _this.column.setMoving(true, "uiColumnMoved");
      },
      onDragStopped: function onDragStopped() {
        return _this.column.setMoving(false, "uiColumnMoved");
      }
    };
    this.dragAndDropService.addDragSource(this.moveDragSource, true);
  };
  HeaderCellCtrl.prototype.createDragItem = function () {
    var visibleState = {};
    visibleState[this.column.getId()] = this.column.isVisible();
    return {
      columns: [this.column],
      visibleState: visibleState
    };
  };
  HeaderCellCtrl.prototype.removeDragSource = function () {
    if (this.moveDragSource) {
      this.dragAndDropService.removeDragSource(this.moveDragSource);
      this.moveDragSource = undefined;
    }
  };
  HeaderCellCtrl.prototype.onNewColumnsLoaded = function () {
    var colDefVersionNow = this.columnModel.getColDefVersion();
    if (colDefVersionNow != this.colDefVersion) {
      this.colDefVersion = colDefVersionNow;
      this.refresh();
    }
  };
  HeaderCellCtrl.prototype.updateState = function () {
    var colDef = this.column.getColDef();
    this.menuEnabled = this.menuFactory.isMenuEnabled(this.column) && !colDef.suppressMenu;
    this.sortable = colDef.sortable;
    this.displayName = this.calculateDisplayName();
    this.draggable = this.workOutDraggable();
  };
  HeaderCellCtrl.prototype.addRefreshFunction = function (func) {
    this.refreshFunctions.push(func);
  };
  HeaderCellCtrl.prototype.refresh = function () {
    this.updateState();
    this.refreshHeaderComp();
    this.refreshFunctions.forEach(function (f) {
      return f();
    });
  };
  HeaderCellCtrl.prototype.refreshHeaderComp = function () {
    var newCompDetails = this.lookupUserCompDetails();
    var compInstance = this.comp.getUserCompInstance();
    // only try refresh if old comp exists adn it is the correct type
    var attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
    var headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
    if (headerCompRefreshed) {
      // we do this as a refresh happens after colDefs change, and it's possible the column has had it's
      // draggable property toggled. no need to call this if not refreshing, as setDragSource is done
      // as part of appendHeaderComp
      this.setDragSource(this.dragSourceElement);
    } else {
      this.setCompDetails(newCompDetails);
    }
  };
  HeaderCellCtrl.prototype.attemptHeaderCompRefresh = function (params) {
    var headerComp = this.comp.getUserCompInstance();
    if (!headerComp) {
      return false;
    }
    // if no refresh method, then we want to replace the headerComp
    if (!headerComp.refresh) {
      return false;
    }
    var res = headerComp.refresh(params);
    return res;
  };
  HeaderCellCtrl.prototype.calculateDisplayName = function () {
    return this.columnModel.getDisplayNameForColumn(this.column, 'header', true);
  };
  HeaderCellCtrl.prototype.checkDisplayName = function () {
    // display name can change if aggFunc different, eg sum(Gold) is now max(Gold)
    if (this.displayName !== this.calculateDisplayName()) {
      this.refresh();
    }
  };
  HeaderCellCtrl.prototype.workOutDraggable = function () {
    var colDef = this.column.getColDef();
    var isSuppressMovableColumns = this.gridOptionsWrapper.isSuppressMovableColumns();
    var colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
    // we should still be allowed drag the column, even if it can't be moved, if the column
    // can be dragged to a rowGroup or pivot drop zone
    return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
  };
  HeaderCellCtrl.prototype.onColumnRowGroupChanged = function () {
    this.checkDisplayName();
  };
  HeaderCellCtrl.prototype.onColumnPivotChanged = function () {
    this.checkDisplayName();
  };
  HeaderCellCtrl.prototype.onColumnValueChanged = function () {
    this.checkDisplayName();
  };
  HeaderCellCtrl.prototype.setupWidth = function () {
    var _this = this;
    var listener = function listener() {
      _this.comp.setWidth(_this.column.getActualWidth() + 'px');
    };
    this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, listener);
    listener();
  };
  HeaderCellCtrl.prototype.setupMovingCss = function () {
    var _this = this;
    var listener = function listener() {
      // this is what makes the header go dark when it is been moved (gives impression to
      // user that the column was picked up).
      _this.comp.addOrRemoveCssClass('ag-header-cell-moving', _this.column.isMoving());
    };
    this.addManagedListener(this.column, Column.EVENT_MOVING_CHANGED, listener);
    listener();
  };
  HeaderCellCtrl.prototype.setupMenuClass = function () {
    var _this = this;
    var listener = function listener() {
      _this.comp.addOrRemoveCssClass('ag-column-menu-visible', _this.column.isMenuVisible());
    };
    this.addManagedListener(this.column, Column.EVENT_MENU_VISIBLE_CHANGED, listener);
    listener();
  };
  HeaderCellCtrl.prototype.setupSortableClass = function () {
    var _this = this;
    var updateSortableCssClass = function updateSortableCssClass() {
      _this.comp.addOrRemoveCssClass('ag-header-cell-sortable', !!_this.sortable);
    };
    var updateAriaSort = function updateAriaSort() {
      if (_this.sortable) {
        _this.comp.setAriaSort(getAriaSortState(_this.column));
      } else {
        _this.comp.setAriaSort(undefined);
      }
    };
    updateSortableCssClass();
    updateAriaSort();
    this.addRefreshFunction(updateSortableCssClass);
    this.addRefreshFunction(updateAriaSort);
    this.addManagedListener(this.column, Column.EVENT_SORT_CHANGED, updateAriaSort);
  };
  HeaderCellCtrl.prototype.addColumnHoverListener = function () {
    var _this = this;
    var listener = function listener() {
      if (!_this.gridOptionsWrapper.isColumnHoverHighlight()) {
        return;
      }
      var isHovered = _this.columnHoverService.isHovered(_this.column);
      _this.comp.addOrRemoveCssClass('ag-column-hover', isHovered);
    };
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, listener);
    listener();
  };
  HeaderCellCtrl.prototype.setupFilterCss = function () {
    var _this = this;
    var listener = function listener() {
      _this.comp.addOrRemoveCssClass('ag-header-cell-filtered', _this.column.isFilterActive());
    };
    this.addManagedListener(this.column, Column.EVENT_FILTER_ACTIVE_CHANGED, listener);
    listener();
  };
  HeaderCellCtrl.prototype.setupColId = function () {
    this.comp.setColId(this.column.getColId());
  };
  HeaderCellCtrl.prototype.addActiveHeaderMouseListeners = function () {
    var _this = this;
    var listener = function listener(e) {
      return _this.setActiveHeader(e.type === 'mouseenter');
    };
    this.addManagedListener(this.getGui(), 'mouseenter', listener);
    this.addManagedListener(this.getGui(), 'mouseleave', listener);
  };
  HeaderCellCtrl.prototype.setActiveHeader = function (active) {
    this.comp.addOrRemoveCssClass('ag-header-active', active);
  };
  __decorate$$([Autowired('columnModel')], HeaderCellCtrl.prototype, "columnModel", void 0);
  __decorate$$([Autowired('columnHoverService')], HeaderCellCtrl.prototype, "columnHoverService", void 0);
  __decorate$$([Autowired('beans')], HeaderCellCtrl.prototype, "beans", void 0);
  __decorate$$([Autowired('sortController')], HeaderCellCtrl.prototype, "sortController", void 0);
  __decorate$$([Autowired('menuFactory')], HeaderCellCtrl.prototype, "menuFactory", void 0);
  __decorate$$([Autowired('dragAndDropService')], HeaderCellCtrl.prototype, "dragAndDropService", void 0);
  __decorate$$([Autowired('gridApi')], HeaderCellCtrl.prototype, "gridApi", void 0);
  __decorate$$([Autowired('columnApi')], HeaderCellCtrl.prototype, "columnApi", void 0);
  __decorate$$([Autowired('userComponentFactory')], HeaderCellCtrl.prototype, "userComponentFactory", void 0);
  __decorate$$([PreDestroy], HeaderCellCtrl.prototype, "removeDragSource", null);
  return HeaderCellCtrl;
}(AbstractHeaderCellCtrl);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1c = undefined && undefined.__extends || function () {
  var _extendStatics77 = function extendStatics(d, b) {
    _extendStatics77 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics77(d, b);
  };
  return function (d, b) {
    _extendStatics77(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$10 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupResizeFeature = /** @class */function (_super) {
  __extends$1c(GroupResizeFeature, _super);
  function GroupResizeFeature(comp, eResize, pinned, columnGroup) {
    var _this = _super.call(this) || this;
    _this.eResize = eResize;
    _this.comp = comp;
    _this.pinned = pinned;
    _this.columnGroup = columnGroup;
    return _this;
  }
  GroupResizeFeature.prototype.postConstruct = function () {
    var _this = this;
    if (!this.columnGroup.isResizable()) {
      this.comp.addOrRemoveResizableCssClass('ag-hidden', true);
      return;
    }
    var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, false),
      onResizeEnd: this.onResizing.bind(this, true)
    });
    this.addDestroyFunc(finishedWithResizeFunc);
    if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
      var skipHeaderOnAutoSize_1 = this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
      this.eResize.addEventListener('dblclick', function (event) {
        // get list of all the column keys we are responsible for
        var keys = [];
        _this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
          // not all cols in the group may be participating with auto-resize
          if (!column.getColDef().suppressAutoSize) {
            keys.push(column.getColId());
          }
        });
        if (keys.length > 0) {
          _this.columnModel.autoSizeColumns(keys, skipHeaderOnAutoSize_1, "uiColumnResized");
        }
      });
    }
  };
  GroupResizeFeature.prototype.onResizeStart = function (shiftKey) {
    var _this = this;
    var leafCols = this.columnGroup.getDisplayedLeafColumns();
    this.resizeCols = leafCols.filter(function (col) {
      return col.isResizable();
    });
    this.resizeStartWidth = 0;
    this.resizeCols.forEach(function (col) {
      return _this.resizeStartWidth += col.getActualWidth();
    });
    this.resizeRatios = [];
    this.resizeCols.forEach(function (col) {
      return _this.resizeRatios.push(col.getActualWidth() / _this.resizeStartWidth);
    });
    var takeFromGroup = null;
    if (shiftKey) {
      takeFromGroup = this.columnModel.getDisplayedGroupAfter(this.columnGroup);
    }
    if (takeFromGroup) {
      var takeFromLeafCols = takeFromGroup.getDisplayedLeafColumns();
      this.resizeTakeFromCols = takeFromLeafCols.filter(function (col) {
        return col.isResizable();
      });
      this.resizeTakeFromStartWidth = 0;
      this.resizeTakeFromCols.forEach(function (col) {
        return _this.resizeTakeFromStartWidth += col.getActualWidth();
      });
      this.resizeTakeFromRatios = [];
      this.resizeTakeFromCols.forEach(function (col) {
        return _this.resizeTakeFromRatios.push(col.getActualWidth() / _this.resizeTakeFromStartWidth);
      });
    } else {
      this.resizeTakeFromCols = null;
      this.resizeTakeFromStartWidth = null;
      this.resizeTakeFromRatios = null;
    }
    this.comp.addOrRemoveCssClass('ag-column-resizing', true);
  };
  GroupResizeFeature.prototype.onResizing = function (finished, resizeAmount) {
    var resizeSets = [];
    var resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
    resizeSets.push({
      columns: this.resizeCols,
      ratios: this.resizeRatios,
      width: this.resizeStartWidth + resizeAmountNormalised
    });
    if (this.resizeTakeFromCols) {
      resizeSets.push({
        columns: this.resizeTakeFromCols,
        ratios: this.resizeTakeFromRatios,
        width: this.resizeTakeFromStartWidth - resizeAmountNormalised
      });
    }
    this.columnModel.resizeColumnSets(resizeSets, finished, 'uiColumnDragged');
    if (finished) {
      this.comp.addOrRemoveCssClass('ag-column-resizing', false);
    }
  };
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  GroupResizeFeature.prototype.normaliseDragChange = function (dragChange) {
    var result = dragChange;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      // for RTL, dragging left makes the col bigger, except when pinning left
      if (this.pinned !== Constants.PINNED_LEFT) {
        result *= -1;
      }
    } else if (this.pinned === Constants.PINNED_RIGHT) {
      // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
      result *= -1;
    }
    return result;
  };
  __decorate$10([Autowired('horizontalResizeService')], GroupResizeFeature.prototype, "horizontalResizeService", void 0);
  __decorate$10([Autowired('columnModel')], GroupResizeFeature.prototype, "columnModel", void 0);
  __decorate$10([PostConstruct], GroupResizeFeature.prototype, "postConstruct", null);
  return GroupResizeFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1d = undefined && undefined.__extends || function () {
  var _extendStatics78 = function extendStatics(d, b) {
    _extendStatics78 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics78(d, b);
  };
  return function (d, b) {
    _extendStatics78(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$11 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupWidthFeature = /** @class */function (_super) {
  __extends$1d(GroupWidthFeature, _super);
  function GroupWidthFeature(comp, columnGroup) {
    var _this = _super.call(this) || this;
    // the children can change, we keep destroy functions related to listening to the children here
    _this.removeChildListenersFuncs = [];
    _this.columnGroup = columnGroup;
    _this.comp = comp;
    return _this;
  }
  GroupWidthFeature.prototype.postConstruct = function () {
    // we need to listen to changes in child columns, as they impact our width
    this.addListenersToChildrenColumns();
    // the children belonging to this group can change, so we need to add and remove listeners as they change
    this.addManagedListener(this.columnGroup, ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
    this.onWidthChanged();
    // the child listeners are not tied to this components life-cycle, as children can get added and removed
    // to the group - hence they are on a different life-cycle. so we must make sure the existing children
    // listeners are removed when we finally get destroyed
    this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  };
  GroupWidthFeature.prototype.addListenersToChildrenColumns = function () {
    var _this = this;
    // first destroy any old listeners
    this.removeListenersOnChildrenColumns();
    // now add new listeners to the new set of children
    var widthChangedListener = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach(function (column) {
      column.addEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
      column.addEventListener(Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
      _this.removeChildListenersFuncs.push(function () {
        column.removeEventListener(Column.EVENT_WIDTH_CHANGED, widthChangedListener);
        column.removeEventListener(Column.EVENT_VISIBLE_CHANGED, widthChangedListener);
      });
    });
  };
  GroupWidthFeature.prototype.removeListenersOnChildrenColumns = function () {
    this.removeChildListenersFuncs.forEach(function (func) {
      return func();
    });
    this.removeChildListenersFuncs = [];
  };
  GroupWidthFeature.prototype.onDisplayedChildrenChanged = function () {
    this.addListenersToChildrenColumns();
    this.onWidthChanged();
  };
  GroupWidthFeature.prototype.onWidthChanged = function () {
    this.comp.setWidth(this.columnGroup.getActualWidth() + 'px');
  };
  __decorate$11([PostConstruct], GroupWidthFeature.prototype, "postConstruct", null);
  return GroupWidthFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1e = undefined && undefined.__extends || function () {
  var _extendStatics79 = function extendStatics(d, b) {
    _extendStatics79 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics79(d, b);
  };
  return function (d, b) {
    _extendStatics79(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$12 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderGroupCellCtrl = /** @class */function (_super) {
  __extends$1e(HeaderGroupCellCtrl, _super);
  function HeaderGroupCellCtrl(columnGroup, parentRowCtrl) {
    var _this = _super.call(this, columnGroup, parentRowCtrl) || this;
    _this.columnGroup = columnGroup;
    return _this;
  }
  HeaderGroupCellCtrl.prototype.setComp = function (comp, eGui, eResize) {
    _super.prototype.setGui.call(this, eGui);
    this.comp = comp;
    this.displayName = this.columnModel.getDisplayNameForColumnGroup(this.columnGroup, 'header');
    this.addClasses();
    this.addAttributes();
    this.setupMovingCss();
    this.setupExpandable();
    this.setupTooltip();
    this.setupUserComp();
    var pinned = this.getParentRowCtrl().getPinned();
    var leafCols = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
    this.createManagedBean(new HoverFeature(leafCols, eGui));
    this.createManagedBean(new SetLeftFeature(this.columnGroup, eGui, this.beans));
    this.createManagedBean(new GroupResizeFeature(comp, eResize, pinned, this.columnGroup));
    this.createManagedBean(new GroupWidthFeature(comp, this.columnGroup));
    this.createManagedBean(new ManagedFocusFeature(eGui, {
      shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
      onTabKeyDown: function onTabKeyDown() {
        return undefined;
      },
      handleKeyDown: this.handleKeyDown.bind(this),
      onFocusIn: this.onFocusIn.bind(this)
    }));
  };
  HeaderGroupCellCtrl.prototype.setupUserComp = function () {
    var _this = this;
    var displayName = this.displayName;
    var params = {
      displayName: this.displayName,
      columnGroup: this.columnGroup,
      setExpanded: function setExpanded(expanded) {
        _this.columnModel.setColumnGroupOpened(_this.columnGroup.getOriginalColumnGroup(), expanded, "gridInitializing");
      },
      api: this.gridApi,
      columnApi: this.columnApi,
      context: this.gridOptionsWrapper.getContext()
    };
    if (!displayName) {
      var columnGroup = this.columnGroup;
      var leafCols = columnGroup.getLeafColumns();
      // find the top most column group that represents the same columns. so if we are dragging a group, we also
      // want to visually show the parent groups dragging for the same column set. for example imaging 5 levels
      // of grouping, with each group only containing the next group, and the last group containing three columns,
      // then when you move any group (even the lowest level group) you are in-fact moving all the groups, as all
      // the groups represent the same column set.
      while (columnGroup.getParent() && columnGroup.getParent().getLeafColumns().length === leafCols.length) {
        columnGroup = columnGroup.getParent();
      }
      var colGroupDef = columnGroup.getColGroupDef();
      if (colGroupDef) {
        displayName = colGroupDef.headerName;
      }
      if (!displayName) {
        displayName = leafCols ? this.columnModel.getDisplayNameForColumn(leafCols[0], 'header', true) : '';
      }
    }
    var compDetails = this.userComponentFactory.getHeaderGroupCompDetails(params);
    this.comp.setUserCompDetails(compDetails);
  };
  HeaderGroupCellCtrl.prototype.setupTooltip = function () {
    var _this = this;
    var colGroupDef = this.columnGroup.getColGroupDef();
    var tooltipCtrl = {
      getColumn: function getColumn() {
        return _this.columnGroup;
      },
      getGui: function getGui() {
        return _this.eGui;
      },
      getLocation: function getLocation() {
        return 'headerGroup';
      },
      getTooltipValue: function getTooltipValue() {
        return colGroupDef && colGroupDef.headerTooltip;
      }
    };
    if (colGroupDef) {
      tooltipCtrl.getColDef = function () {
        return colGroupDef;
      };
    }
    var tooltipFeature = this.createManagedBean(new TooltipFeature(tooltipCtrl, this.beans));
    tooltipFeature.setComp(this.comp);
  };
  HeaderGroupCellCtrl.prototype.setupExpandable = function () {
    var providedColGroup = this.columnGroup.getOriginalColumnGroup();
    this.refreshExpanded();
    this.addManagedListener(providedColGroup, ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this));
    this.addManagedListener(providedColGroup, ProvidedColumnGroup.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
  };
  HeaderGroupCellCtrl.prototype.refreshExpanded = function () {
    var column = this.columnGroup;
    this.expandable = column.isExpandable();
    var expanded = column.isExpanded();
    if (this.expandable) {
      this.comp.setAriaExpanded(expanded ? 'true' : 'false');
    } else {
      this.comp.setAriaExpanded(undefined);
    }
  };
  HeaderGroupCellCtrl.prototype.addAttributes = function () {
    this.comp.setColId(this.columnGroup.getUniqueId());
  };
  HeaderGroupCellCtrl.prototype.addClasses = function () {
    var _this = this;
    var colGroupDef = this.columnGroup.getColGroupDef();
    var classes = CssClassApplier.getHeaderClassesFromColDef(colGroupDef, this.gridOptionsWrapper, null, this.columnGroup);
    // having different classes below allows the style to not have a bottom border
    // on the group header, if no group is specified
    classes.push(this.columnGroup.isPadding() ? "ag-header-group-cell-no-group" : "ag-header-group-cell-with-group");
    classes.forEach(function (c) {
      return _this.comp.addOrRemoveCssClass(c, true);
    });
  };
  HeaderGroupCellCtrl.prototype.setupMovingCss = function () {
    var _this = this;
    var providedColumnGroup = this.columnGroup.getOriginalColumnGroup();
    var leafColumns = providedColumnGroup.getLeafColumns();
    // this function adds or removes the moving css, based on if the col is moving.
    // this is what makes the header go dark when it is been moved (gives impression to
    // user that the column was picked up).
    var listener = function listener() {
      return _this.comp.addOrRemoveCssClass('ag-header-cell-moving', _this.columnGroup.isMoving());
    };
    leafColumns.forEach(function (col) {
      _this.addManagedListener(col, Column.EVENT_MOVING_CHANGED, listener);
    });
    listener();
  };
  HeaderGroupCellCtrl.prototype.onFocusIn = function (e) {
    if (!this.eGui.contains(e.relatedTarget)) {
      var rowIndex = this.getRowIndex();
      this.beans.focusService.setFocusedHeader(rowIndex, this.columnGroup);
    }
  };
  HeaderGroupCellCtrl.prototype.handleKeyDown = function (e) {
    var activeEl = document.activeElement;
    var wrapperHasFocus = activeEl === this.eGui;
    if (!this.expandable || !wrapperHasFocus) {
      return;
    }
    if (e.keyCode === KeyCode.ENTER) {
      var column = this.columnGroup;
      var newExpandedValue = !column.isExpanded();
      this.columnModel.setColumnGroupOpened(column.getOriginalColumnGroup(), newExpandedValue, "uiColumnExpanded");
    }
  };
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  HeaderGroupCellCtrl.prototype.setDragSource = function (eHeaderGroup) {
    var _this = this;
    if (this.isSuppressMoving()) {
      return;
    }
    var allLeafColumns = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
    var dragSource = {
      type: DragSourceType.HeaderCell,
      eElement: eHeaderGroup,
      defaultIconName: DragAndDropService.ICON_HIDE,
      dragItemName: this.displayName,
      // we add in the original group leaf columns, so we move both visible and non-visible items
      getDragItem: this.getDragItemForGroup.bind(this),
      onDragStarted: function onDragStarted() {
        return allLeafColumns.forEach(function (col) {
          return col.setMoving(true, "uiColumnDragged");
        });
      },
      onDragStopped: function onDragStopped() {
        return allLeafColumns.forEach(function (col) {
          return col.setMoving(false, "uiColumnDragged");
        });
      }
    };
    this.dragAndDropService.addDragSource(dragSource, true);
    this.addDestroyFunc(function () {
      return _this.dragAndDropService.removeDragSource(dragSource);
    });
  };
  // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
  // and in the order they are currently in the screen.
  HeaderGroupCellCtrl.prototype.getDragItemForGroup = function () {
    var allColumnsOriginalOrder = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
    // capture visible state, used when re-entering grid to dictate which columns should be visible
    var visibleState = {};
    allColumnsOriginalOrder.forEach(function (column) {
      return visibleState[column.getId()] = column.isVisible();
    });
    var allColumnsCurrentOrder = [];
    this.columnModel.getAllDisplayedColumns().forEach(function (column) {
      if (allColumnsOriginalOrder.indexOf(column) >= 0) {
        allColumnsCurrentOrder.push(column);
        removeFromArray(allColumnsOriginalOrder, column);
      }
    });
    // we are left with non-visible columns, stick these in at the end
    allColumnsOriginalOrder.forEach(function (column) {
      return allColumnsCurrentOrder.push(column);
    });
    // create and return dragItem
    return {
      columns: allColumnsCurrentOrder,
      visibleState: visibleState
    };
  };
  HeaderGroupCellCtrl.prototype.isSuppressMoving = function () {
    // if any child is fixed, then don't allow moving
    var childSuppressesMoving = false;
    this.columnGroup.getLeafColumns().forEach(function (column) {
      if (column.getColDef().suppressMovable || column.getColDef().lockPosition) {
        childSuppressesMoving = true;
      }
    });
    var result = childSuppressesMoving || this.gridOptionsWrapper.isSuppressMovableColumns();
    return result;
  };
  __decorate$12([Autowired('beans')], HeaderGroupCellCtrl.prototype, "beans", void 0);
  __decorate$12([Autowired('columnModel')], HeaderGroupCellCtrl.prototype, "columnModel", void 0);
  __decorate$12([Autowired('dragAndDropService')], HeaderGroupCellCtrl.prototype, "dragAndDropService", void 0);
  __decorate$12([Autowired('userComponentFactory')], HeaderGroupCellCtrl.prototype, "userComponentFactory", void 0);
  __decorate$12([Autowired('gridApi')], HeaderGroupCellCtrl.prototype, "gridApi", void 0);
  __decorate$12([Autowired('columnApi')], HeaderGroupCellCtrl.prototype, "columnApi", void 0);
  return HeaderGroupCellCtrl;
}(AbstractHeaderCellCtrl);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1f = undefined && undefined.__extends || function () {
  var _extendStatics80 = function extendStatics(d, b) {
    _extendStatics80 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics80(d, b);
  };
  return function (d, b) {
    _extendStatics80(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$13 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var instanceIdSequence$4 = 0;
var HeaderRowCtrl = /** @class */function (_super) {
  __extends$1f(HeaderRowCtrl, _super);
  function HeaderRowCtrl(rowIndex, pinned, type) {
    var _this = _super.call(this) || this;
    _this.instanceId = instanceIdSequence$4++;
    _this.headerCellCtrls = {};
    _this.rowIndex = rowIndex;
    _this.pinned = pinned;
    _this.type = type;
    return _this;
  }
  HeaderRowCtrl.prototype.getInstanceId = function () {
    return this.instanceId;
  };
  HeaderRowCtrl.prototype.setComp = function (comp) {
    this.comp = comp;
    this.onRowHeightChanged();
    this.onVirtualColumnsChanged();
    this.setWidth();
    this.addEventListeners();
    if (isBrowserSafari()) {
      // fix for a Safari rendering bug that caused the header to flicker above chart panels
      // as you move the mouse over the header
      this.comp.setTransform('translateZ(0)');
    }
    comp.setAriaRowIndex(this.rowIndex + 1);
  };
  HeaderRowCtrl.prototype.addEventListeners = function () {
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
    // when print layout changes, it changes what columns are in what section
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, this.onRowHeightChanged.bind(this));
  };
  HeaderRowCtrl.prototype.getHtmlElementForColumnHeader = function (column) {
    if (this.type != HeaderRowType.COLUMN) {
      return;
    }
    var cellCtrl = find$3(this.headerCellCtrls, function (cellCtrl) {
      return cellCtrl.getColumnGroupChild() == column;
    });
    if (!cellCtrl) {
      return;
    }
    var res = cellCtrl.getGui();
    return res;
  };
  HeaderRowCtrl.prototype.onDisplayedColumnsChanged = function () {
    this.onVirtualColumnsChanged();
    this.setWidth();
  };
  HeaderRowCtrl.prototype.getType = function () {
    return this.type;
  };
  HeaderRowCtrl.prototype.onColumnResized = function () {
    this.setWidth();
  };
  HeaderRowCtrl.prototype.setWidth = function () {
    var width = this.getWidthForRow();
    this.comp.setWidth(width + 'px');
  };
  HeaderRowCtrl.prototype.getWidthForRow = function () {
    var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    if (printLayout) {
      var pinned = this.pinned != null;
      if (pinned) {
        return 0;
      }
      return this.columnModel.getContainerWidth(Constants.PINNED_RIGHT) + this.columnModel.getContainerWidth(Constants.PINNED_LEFT) + this.columnModel.getContainerWidth(null);
    }
    // if not printing, just return the width as normal
    return this.columnModel.getContainerWidth(this.pinned);
  };
  HeaderRowCtrl.prototype.onRowHeightChanged = function () {
    var headerRowCount = this.columnModel.getHeaderRowCount();
    var sizes = [];
    var numberOfFloating = 0;
    var groupHeight;
    var headerHeight;
    if (this.columnModel.isPivotMode()) {
      groupHeight = this.gridOptionsWrapper.getPivotGroupHeaderHeight();
      headerHeight = this.gridOptionsWrapper.getPivotHeaderHeight();
    } else {
      if (this.columnModel.hasFloatingFilters()) {
        headerRowCount++;
        numberOfFloating = 1;
      }
      groupHeight = this.gridOptionsWrapper.getGroupHeaderHeight();
      headerHeight = this.gridOptionsWrapper.getHeaderHeight();
    }
    var numberOfNonGroups = 1 + numberOfFloating;
    var numberOfGroups = headerRowCount - numberOfNonGroups;
    for (var i = 0; i < numberOfGroups; i++) {
      sizes.push(groupHeight);
    }
    sizes.push(headerHeight);
    for (var i = 0; i < numberOfFloating; i++) {
      sizes.push(this.gridOptionsWrapper.getFloatingFiltersHeight());
    }
    var rowHeight = 0;
    for (var i = 0; i < this.rowIndex; i++) {
      rowHeight += sizes[i];
    }
    this.comp.setTop(rowHeight + 'px');
    this.comp.setHeight(sizes[this.rowIndex] + 'px');
  };
  HeaderRowCtrl.prototype.getPinned = function () {
    return this.pinned;
  };
  HeaderRowCtrl.prototype.getRowIndex = function () {
    return this.rowIndex;
  };
  HeaderRowCtrl.prototype.onVirtualColumnsChanged = function () {
    var _this = this;
    var oldCtrls = this.headerCellCtrls;
    this.headerCellCtrls = {};
    var columns = this.getColumnsInViewport();
    columns.forEach(function (child) {
      // skip groups that have no displayed children. this can happen when the group is broken,
      // and this section happens to have nothing to display for the open / closed state.
      // (a broken group is one that is split, ie columns in the group have a non-group column
      // in between them)
      if (child.isEmptyGroup()) {
        return;
      }
      var idOfChild = child.getUniqueId();
      // if we already have this cell rendered, do nothing
      var headerCtrl = oldCtrls[idOfChild];
      delete oldCtrls[idOfChild];
      // it's possible there is a new Column with the same ID, but it's for a different Column.
      // this is common with pivoting, where the pivot cols change, but the id's are still pivot_0,
      // pivot_1 etc. so if new col but same ID, need to remove the old col here first as we are
      // about to replace it in the this.headerComps map.
      var forOldColumn = headerCtrl && headerCtrl.getColumnGroupChild() != child;
      if (forOldColumn) {
        _this.destroyBean(headerCtrl);
        headerCtrl = undefined;
      }
      if (headerCtrl == null) {
        switch (_this.type) {
          case HeaderRowType.FLOATING_FILTER:
            headerCtrl = _this.createBean(new HeaderFilterCellCtrl(child, _this));
            break;
          case HeaderRowType.COLUMN_GROUP:
            headerCtrl = _this.createBean(new HeaderGroupCellCtrl(child, _this));
            break;
          default:
            headerCtrl = _this.createBean(new HeaderCellCtrl(child, _this));
            break;
        }
      }
      _this.headerCellCtrls[idOfChild] = headerCtrl;
    });
    // we want to keep columns that are focused, otherwise keyboard navigation breaks
    var isFocusedAndDisplayed = function isFocusedAndDisplayed(ctrl) {
      var isFocused = _this.focusService.isHeaderWrapperFocused(ctrl);
      if (!isFocused) {
        return false;
      }
      var isDisplayed = _this.columnModel.isDisplayed(ctrl.getColumnGroupChild());
      return isDisplayed;
    };
    iterateObject(oldCtrls, function (id, oldCtrl) {
      var keepCtrl = isFocusedAndDisplayed(oldCtrl);
      if (keepCtrl) {
        _this.headerCellCtrls[id] = oldCtrl;
      } else {
        _this.destroyBean(oldCtrl);
      }
    });
    var ctrlsToDisplay = getAllValuesInObject(this.headerCellCtrls);
    this.comp.setHeaderCtrls(ctrlsToDisplay);
  };
  HeaderRowCtrl.prototype.getColumnsInViewport = function () {
    var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    return printLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
  };
  HeaderRowCtrl.prototype.getColumnsInViewportPrintLayout = function () {
    var _this = this;
    // for print layout, we add all columns into the center
    if (this.pinned != null) {
      return [];
    }
    var viewportColumns = [];
    var actualDepth = this.getActualDepth();
    [Constants.PINNED_LEFT, null, Constants.PINNED_RIGHT].forEach(function (pinned) {
      var items = _this.columnModel.getVirtualHeaderGroupRow(pinned, actualDepth);
      viewportColumns = viewportColumns.concat(items);
    });
    return viewportColumns;
  };
  HeaderRowCtrl.prototype.getActualDepth = function () {
    return this.type == HeaderRowType.FLOATING_FILTER ? this.rowIndex - 1 : this.rowIndex;
  };
  HeaderRowCtrl.prototype.getColumnsInViewportNormalLayout = function () {
    // when in normal layout, we add the columns for that container only
    return this.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
  };
  HeaderRowCtrl.prototype.focusHeader = function (column, event) {
    var allCtrls = getAllValuesInObject(this.headerCellCtrls);
    var ctrl = find$3(allCtrls, function (ctrl) {
      return ctrl.getColumnGroupChild() == column;
    });
    if (!ctrl) {
      return false;
    }
    ctrl.focus(event);
    return true;
  };
  __decorate$13([Autowired('columnModel')], HeaderRowCtrl.prototype, "columnModel", void 0);
  __decorate$13([Autowired('focusService')], HeaderRowCtrl.prototype, "focusService", void 0);
  return HeaderRowCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1g = undefined && undefined.__extends || function () {
  var _extendStatics81 = function extendStatics(d, b) {
    _extendStatics81 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics81(d, b);
  };
  return function (d, b) {
    _extendStatics81(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$14 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$8 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var HeaderRowContainerCtrl = /** @class */function (_super) {
  __extends$1g(HeaderRowContainerCtrl, _super);
  function HeaderRowContainerCtrl(pinned) {
    var _this = _super.call(this) || this;
    _this.groupsRowCtrls = [];
    _this.pinned = pinned;
    return _this;
  }
  HeaderRowContainerCtrl.prototype.setComp = function (comp, eGui) {
    this.comp = comp;
    this.setupCenterWidth();
    this.setupPinnedWidth();
    this.setupDragAndDrop(eGui);
    this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
    this.ctrlsService.registerHeaderContainer(this, this.pinned);
    if (this.columnModel.isReady()) {
      this.refresh();
    }
  };
  HeaderRowContainerCtrl.prototype.setupDragAndDrop = function (dropContainer) {
    var bodyDropTarget = new BodyDropTarget(this.pinned, dropContainer);
    this.createManagedBean(bodyDropTarget);
  };
  HeaderRowContainerCtrl.prototype.refresh = function (keepColumns) {
    var _this = this;
    if (keepColumns === void 0) {
      keepColumns = false;
    }
    var sequence = new NumberSequence();
    var focusedHeaderPosition = this.focusService.getFocusHeaderToUseAfterRefresh();
    var refreshColumnGroups = function refreshColumnGroups() {
      var groupRowCount = _this.columnModel.getHeaderRowCount() - 1;
      _this.groupsRowCtrls = _this.destroyBeans(_this.groupsRowCtrls);
      for (var i = 0; i < groupRowCount; i++) {
        var ctrl = _this.createBean(new HeaderRowCtrl(sequence.next(), _this.pinned, HeaderRowType.COLUMN_GROUP));
        _this.groupsRowCtrls.push(ctrl);
      }
    };
    var refreshColumns = function refreshColumns() {
      var rowIndex = sequence.next();
      var needNewInstance = _this.columnsRowCtrl == null || !keepColumns || _this.columnsRowCtrl.getRowIndex() !== rowIndex;
      if (needNewInstance) {
        _this.destroyBean(_this.columnsRowCtrl);
        _this.columnsRowCtrl = _this.createBean(new HeaderRowCtrl(rowIndex, _this.pinned, HeaderRowType.COLUMN));
      }
    };
    var refreshFilters = function refreshFilters() {
      var includeFloatingFilter = !_this.columnModel.isPivotMode() && _this.columnModel.hasFloatingFilters();
      var destroyPreviousComp = function destroyPreviousComp() {
        _this.filtersRowCtrl = _this.destroyBean(_this.filtersRowCtrl);
      };
      if (!includeFloatingFilter) {
        destroyPreviousComp();
        return;
      }
      var rowIndex = sequence.next();
      if (_this.filtersRowCtrl) {
        var rowIndexMismatch = _this.filtersRowCtrl.getRowIndex() !== rowIndex;
        if (!keepColumns || rowIndexMismatch) {
          destroyPreviousComp();
        }
      }
      if (!_this.filtersRowCtrl) {
        _this.filtersRowCtrl = _this.createBean(new HeaderRowCtrl(rowIndex, _this.pinned, HeaderRowType.FLOATING_FILTER));
      }
    };
    refreshColumnGroups();
    refreshColumns();
    refreshFilters();
    var allCtrls = this.getAllCtrls();
    this.comp.setCtrls(allCtrls);
    this.restoreFocusOnHeader(focusedHeaderPosition);
  };
  HeaderRowContainerCtrl.prototype.restoreFocusOnHeader = function (position) {
    if (position == null || position.column.getPinned() != this.pinned) {
      return;
    }
    this.focusService.focusHeaderPosition({
      headerPosition: position
    });
  };
  HeaderRowContainerCtrl.prototype.getAllCtrls = function () {
    var res = __spreadArrays$8(this.groupsRowCtrls, [this.columnsRowCtrl]);
    if (this.filtersRowCtrl) {
      res.push(this.filtersRowCtrl);
    }
    return res;
  };
  // grid cols have changed - this also means the number of rows in the header can have
  // changed. so we remove all the old rows and insert new ones for a complete refresh
  HeaderRowContainerCtrl.prototype.onGridColumnsChanged = function () {
    this.refresh(true);
  };
  HeaderRowContainerCtrl.prototype.setupCenterWidth = function () {
    var _this = this;
    if (this.pinned != null) {
      return;
    }
    this.createManagedBean(new CenterWidthFeature(function (width) {
      return _this.comp.setCenterWidth(width + "px");
    }));
  };
  HeaderRowContainerCtrl.prototype.setHorizontalScroll = function (offset) {
    this.comp.setContainerTransform("translateX(" + offset + "px)");
  };
  HeaderRowContainerCtrl.prototype.setupPinnedWidth = function () {
    var _this = this;
    if (this.pinned == null) {
      return;
    }
    var pinningLeft = this.pinned === Constants.PINNED_LEFT;
    var pinningRight = this.pinned === Constants.PINNED_RIGHT;
    var listener = function listener() {
      var width = pinningLeft ? _this.pinnedWidthService.getPinnedLeftWidth() : _this.pinnedWidthService.getPinnedRightWidth();
      if (width == null) {
        return;
      } // can happen at initialisation, width not yet set
      var hidden = width == 0;
      var isRtl = _this.gridOptionsWrapper.isEnableRtl();
      var scrollbarWidth = _this.gridOptionsWrapper.getScrollbarWidth();
      // if there is a scroll showing (and taking up space, so Windows, and not iOS)
      // in the body, then we add extra space to keep header aligned with the body,
      // as body width fits the cols and the scrollbar
      var addPaddingForScrollbar = _this.scrollVisibleService.isVerticalScrollShowing() && (isRtl && pinningLeft || !isRtl && pinningRight);
      var widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
      _this.comp.setPinnedContainerWidth(widthWithPadding + 'px');
      _this.comp.addOrRemoveCssClass('ag-hidden', hidden);
    };
    this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
    this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
    this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
    this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
  };
  HeaderRowContainerCtrl.prototype.getHtmlElementForColumnHeader = function (column) {
    if (this.columnsRowCtrl) {
      return this.columnsRowCtrl.getHtmlElementForColumnHeader(column);
    }
  };
  HeaderRowContainerCtrl.prototype.getRowType = function (rowIndex) {
    var allCtrls = this.getAllCtrls();
    var ctrl = allCtrls[rowIndex];
    return ctrl ? ctrl.getType() : undefined;
  };
  HeaderRowContainerCtrl.prototype.focusHeader = function (rowIndex, column, event) {
    var allCtrls = this.getAllCtrls();
    var ctrl = allCtrls[rowIndex];
    if (!ctrl) {
      return false;
    }
    return ctrl.focusHeader(column, event);
  };
  HeaderRowContainerCtrl.prototype.getRowCount = function () {
    return this.getAllCtrls().length;
  };
  __decorate$14([Autowired('ctrlsService')], HeaderRowContainerCtrl.prototype, "ctrlsService", void 0);
  __decorate$14([Autowired('scrollVisibleService')], HeaderRowContainerCtrl.prototype, "scrollVisibleService", void 0);
  __decorate$14([Autowired('pinnedWidthService')], HeaderRowContainerCtrl.prototype, "pinnedWidthService", void 0);
  __decorate$14([Autowired('columnModel')], HeaderRowContainerCtrl.prototype, "columnModel", void 0);
  __decorate$14([Autowired('focusService')], HeaderRowContainerCtrl.prototype, "focusService", void 0);
  return HeaderRowContainerCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1h = undefined && undefined.__extends || function () {
  var _extendStatics82 = function extendStatics(d, b) {
    _extendStatics82 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics82(d, b);
  };
  return function (d, b) {
    _extendStatics82(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$15 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderRowContainerComp = /** @class */function (_super) {
  __extends$1h(HeaderRowContainerComp, _super);
  function HeaderRowContainerComp(pinned) {
    var _this = _super.call(this) || this;
    _this.headerRowComps = {};
    _this.rowCompsList = [];
    _this.pinned = pinned;
    return _this;
  }
  HeaderRowContainerComp.prototype.init = function () {
    var _this = this;
    this.selectAndSetTemplate();
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setCtrls: function setCtrls(ctrls) {
        return _this.setCtrls(ctrls);
      },
      // only gets called for center section
      setCenterWidth: function setCenterWidth(width) {
        return _this.eCenterContainer.style.width = width;
      },
      setContainerTransform: function setContainerTransform(transform) {
        return _this.eCenterContainer.style.transform = transform;
      },
      // only gets called for pinned sections
      setPinnedContainerWidth: function setPinnedContainerWidth(width) {
        var eGui = _this.getGui();
        eGui.style.width = width;
        eGui.style.maxWidth = width;
        eGui.style.minWidth = width;
      }
    };
    var ctrl = this.createManagedBean(new HeaderRowContainerCtrl(this.pinned));
    ctrl.setComp(compProxy, this.getGui());
  };
  HeaderRowContainerComp.prototype.selectAndSetTemplate = function () {
    var pinnedLeft = this.pinned == Constants.PINNED_LEFT;
    var pinnedRight = this.pinned == Constants.PINNED_RIGHT;
    var template = pinnedLeft ? HeaderRowContainerComp.PINNED_LEFT_TEMPLATE : pinnedRight ? HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE : HeaderRowContainerComp.CENTER_TEMPLATE;
    this.setTemplate(template);
    // for left and right, we add rows directly to the root element,
    // but for center container we add elements to the child container.
    this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
  };
  HeaderRowContainerComp.prototype.destroyRowComps = function () {
    this.setCtrls([]);
  };
  HeaderRowContainerComp.prototype.destroyRowComp = function (rowComp) {
    this.destroyBean(rowComp);
    this.eRowContainer.removeChild(rowComp.getGui());
  };
  HeaderRowContainerComp.prototype.setCtrls = function (ctrls) {
    var _this = this;
    var oldRowComps = this.headerRowComps;
    this.headerRowComps = {};
    this.rowCompsList = [];
    var prevGui;
    var appendEnsuringDomOrder = function appendEnsuringDomOrder(rowComp) {
      var eGui = rowComp.getGui();
      var notAlreadyIn = eGui.parentElement != _this.eRowContainer;
      if (notAlreadyIn) {
        _this.eRowContainer.appendChild(eGui);
      }
      if (prevGui) {
        ensureDomOrder(_this.eRowContainer, eGui, prevGui);
      }
      prevGui = eGui;
    };
    ctrls.forEach(function (ctrl) {
      var ctrlId = ctrl.getInstanceId();
      var existingComp = oldRowComps[ctrlId];
      delete oldRowComps[ctrlId];
      var rowComp = existingComp ? existingComp : _this.createBean(new HeaderRowComp(ctrl));
      _this.headerRowComps[ctrlId] = rowComp;
      _this.rowCompsList.push(rowComp);
      appendEnsuringDomOrder(rowComp);
    });
    getAllValuesInObject(oldRowComps).forEach(function (c) {
      return _this.destroyRowComp(c);
    });
  };
  HeaderRowContainerComp.PINNED_LEFT_TEMPLATE = "<div class=\"ag-pinned-left-header\" role=\"presentation\"/>";
  HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE = "<div class=\"ag-pinned-right-header\" role=\"presentation\"/>";
  HeaderRowContainerComp.CENTER_TEMPLATE = "<div class=\"ag-header-viewport\" role=\"presentation\">\n            <div class=\"ag-header-container\" ref=\"eCenterContainer\" role=\"rowgroup\"></div>\n        </div>";
  __decorate$15([RefSelector('eCenterContainer')], HeaderRowContainerComp.prototype, "eCenterContainer", void 0);
  __decorate$15([PostConstruct], HeaderRowContainerComp.prototype, "init", null);
  __decorate$15([PreDestroy], HeaderRowContainerComp.prototype, "destroyRowComps", null);
  return HeaderRowContainerComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1i = undefined && undefined.__extends || function () {
  var _extendStatics83 = function extendStatics(d, b) {
    _extendStatics83 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics83(d, b);
  };
  return function (d, b) {
    _extendStatics83(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$16 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridHeaderComp = /** @class */function (_super) {
  __extends$1i(GridHeaderComp, _super);
  function GridHeaderComp() {
    return _super.call(this, GridHeaderComp.TEMPLATE) || this;
  }
  GridHeaderComp.prototype.postConstruct = function () {
    var _this = this;
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setHeightAndMinHeight: function setHeightAndMinHeight(height) {
        _this.getGui().style.height = height;
        _this.getGui().style.minHeight = height;
      }
    };
    var ctrl = this.createManagedBean(new GridHeaderCtrl());
    ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
    var addContainer = function addContainer(container) {
      _this.createManagedBean(container);
      _this.appendChild(container);
    };
    addContainer(new HeaderRowContainerComp(Constants.PINNED_LEFT));
    addContainer(new HeaderRowContainerComp(null));
    addContainer(new HeaderRowContainerComp(Constants.PINNED_RIGHT));
  };
  GridHeaderComp.TEMPLATE = "<div class=\"ag-header\" role=\"presentation\" unselectable=\"on\"/>";
  __decorate$16([PostConstruct], GridHeaderComp.prototype, "postConstruct", null);
  return GridHeaderComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1j = undefined && undefined.__extends || function () {
  var _extendStatics84 = function extendStatics(d, b) {
    _extendStatics84 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics84(d, b);
  };
  return function (d, b) {
    _extendStatics84(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$a = undefined && undefined.__assign || function () {
  __assign$a = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$a.apply(this, arguments);
};
var __decorate$17 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterManager = /** @class */function (_super) {
  __extends$1j(FilterManager, _super);
  function FilterManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.allAdvancedFilters = new Map();
    _this.activeAdvancedFilters = [];
    _this.quickFilter = null;
    _this.quickFilterParts = null;
    // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
    // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
    // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
    // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
    // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
    _this.processingFilterChange = false;
    return _this;
  }
  FilterManager_1 = FilterManager;
  FilterManager.prototype.init = function () {
    this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
    this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
    this.setQuickFilterParts();
    this.allowShowChangeAfterFilter = this.gridOptionsWrapper.isAllowShowChangeAfterFilter();
  };
  FilterManager.prototype.setQuickFilterParts = function () {
    this.quickFilterParts = this.quickFilter ? this.quickFilter.split(' ') : null;
  };
  FilterManager.prototype.setFilterModel = function (model) {
    var _this = this;
    var allPromises = [];
    var previousModel = this.getFilterModel();
    if (model) {
      // mark the filters as we set them, so any active filters left over we stop
      var modelKeys_1 = convertToSet(Object.keys(model));
      this.allAdvancedFilters.forEach(function (filterWrapper, colId) {
        var newModel = model[colId];
        allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
        modelKeys_1.delete(colId);
      });
      // at this point, processedFields contains data for which we don't have a filter working yet
      modelKeys_1.forEach(function (colId) {
        var column = _this.columnModel.getPrimaryColumn(colId);
        if (!column) {
          console.warn('AG-Grid: setFilterModel() - no column found for colId: ' + colId);
          return;
        }
        if (!column.isFilterAllowed()) {
          console.warn('AG-Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: ' + colId);
          return;
        }
        var filterWrapper = _this.getOrCreateFilterWrapper(column, 'NO_UI');
        allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
      });
    } else {
      this.allAdvancedFilters.forEach(function (filterWrapper) {
        allPromises.push(_this.setModelOnFilterWrapper(filterWrapper.filterPromise, null));
      });
    }
    AgPromise.all(allPromises).then(function () {
      var currentModel = _this.getFilterModel();
      var columns = [];
      _this.allAdvancedFilters.forEach(function (filterWrapper, colId) {
        var before = previousModel ? previousModel[colId] : null;
        var after = currentModel ? currentModel[colId] : null;
        if (!_.jsonEquals(before, after)) {
          columns.push(filterWrapper.column);
        }
      });
      if (columns.length > 0) {
        _this.onFilterChanged({
          columns: columns
        });
      }
    });
  };
  FilterManager.prototype.setModelOnFilterWrapper = function (filterPromise, newModel) {
    return new AgPromise(function (resolve) {
      filterPromise.then(function (filter) {
        if (typeof filter.setModel !== 'function') {
          console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
          resolve();
        }
        (filter.setModel(newModel) || AgPromise.resolve()).then(function () {
          return resolve();
        });
      });
    });
  };
  FilterManager.prototype.getFilterModel = function () {
    var result = {};
    this.allAdvancedFilters.forEach(function (filterWrapper, key) {
      // because user can provide filters, we provide useful error checking and messages
      var filterPromise = filterWrapper.filterPromise;
      var filter = filterPromise.resolveNow(null, function (promiseFilter) {
        return promiseFilter;
      });
      if (filter == null) {
        return null;
      }
      if (typeof filter.getModel !== 'function') {
        console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
        return;
      }
      var model = filter.getModel();
      if (exists(model)) {
        result[key] = model;
      }
    });
    return result;
  };
  // returns true if any advanced filter (ie not quick filter) active
  FilterManager.prototype.isAdvancedFilterPresent = function () {
    return this.activeAdvancedFilters.length > 0;
  };
  // called by:
  // 1) onFilterChanged()
  // 2) onNewRowsLoaded()
  FilterManager.prototype.updateActiveFilters = function () {
    var _this = this;
    this.activeAdvancedFilters.length = 0;
    var isFilterActive = function isFilterActive(filter) {
      if (!filter) {
        return false;
      } // this never happens, including to avoid compile error
      if (!filter.isFilterActive) {
        console.warn('AG Grid: Filter is missing isFilterActive() method');
        return false;
      }
      return filter.isFilterActive();
    };
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      if (filterWrapper.filterPromise.resolveNow(false, isFilterActive)) {
        var resolvedPromise = filterWrapper.filterPromise.resolveNow(null, function (filter) {
          return filter;
        });
        _this.activeAdvancedFilters.push(resolvedPromise);
      }
    });
  };
  FilterManager.prototype.updateFilterFlagInColumns = function (source, additionalEventAttributes) {
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      var isFilterActive = filterWrapper.filterPromise.resolveNow(false, function (filter) {
        return filter.isFilterActive();
      });
      filterWrapper.column.setFilterActive(isFilterActive, source, additionalEventAttributes);
    });
  };
  FilterManager.prototype.isAnyFilterPresent = function () {
    return this.isQuickFilterPresent() || this.isAdvancedFilterPresent() || this.gridOptionsWrapper.isExternalFilterPresent();
  };
  FilterManager.prototype.doAdvancedFiltersPass = function (node, filterToSkip) {
    var data = node.data;
    for (var i = 0; i < this.activeAdvancedFilters.length; i++) {
      var filter = this.activeAdvancedFilters[i];
      if (filter == null || filter === filterToSkip) {
        continue;
      }
      if (typeof filter.doesFilterPass !== 'function') {
        // because users can do custom filters, give nice error message
        throw new Error('Filter is missing method doesFilterPass');
      }
      if (!filter.doesFilterPass({
        node: node,
        data: data
      })) {
        return false;
      }
    }
    return true;
  };
  FilterManager.prototype.parseQuickFilter = function (newFilter) {
    if (!exists(newFilter)) {
      return null;
    }
    if (!this.gridOptionsWrapper.isRowModelDefault()) {
      console.warn('ag-grid: quick filtering only works with the Client-Side Row Model');
      return null;
    }
    return newFilter.toUpperCase();
  };
  FilterManager.prototype.setQuickFilter = function (newFilter) {
    var parsedFilter = this.parseQuickFilter(newFilter);
    if (this.quickFilter !== parsedFilter) {
      this.quickFilter = parsedFilter;
      this.setQuickFilterParts();
      this.onFilterChanged();
    }
  };
  FilterManager.prototype.onFilterChanged = function (params) {
    if (params === void 0) {
      params = {};
    }
    var filterInstance = params.filterInstance,
      additionalEventAttributes = params.additionalEventAttributes,
      columns = params.columns;
    this.updateActiveFilters();
    this.updateFilterFlagInColumns('filterChanged', additionalEventAttributes);
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      if (!filterWrapper.filterPromise) {
        return;
      }
      filterWrapper.filterPromise.then(function (filter) {
        if (filter && filter !== filterInstance && filter.onAnyFilterChanged) {
          filter.onAnyFilterChanged();
        }
      });
    });
    var filterChangedEvent = {
      type: Events.EVENT_FILTER_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi,
      columns: columns || []
    };
    if (additionalEventAttributes) {
      mergeDeep(filterChangedEvent, additionalEventAttributes);
    }
    // because internal events are not async in ag-grid, when the dispatchEvent
    // method comes back, we know all listeners have finished executing.
    this.processingFilterChange = true;
    this.eventService.dispatchEvent(filterChangedEvent);
    this.processingFilterChange = false;
  };
  FilterManager.prototype.isSuppressFlashingCellsBecauseFiltering = function () {
    // if user has elected to always flash cell changes, then always return false, otherwise we suppress flashing
    // changes when filtering
    return !this.allowShowChangeAfterFilter && this.processingFilterChange;
  };
  FilterManager.prototype.isQuickFilterPresent = function () {
    return this.quickFilter !== null;
  };
  FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
    return this.doesRowPassFilter({
      rowNode: node,
      filterInstanceToSkip: filterToSkip
    });
  };
  FilterManager.prototype.doesRowPassQuickFilterNoCache = function (node, filterPart) {
    var _this = this;
    var columns = this.columnModel.getAllColumnsForQuickFilter();
    return some(columns, function (column) {
      var part = _this.getQuickFilterTextForColumn(column, node);
      return exists(part) && part.indexOf(filterPart) >= 0;
    });
  };
  FilterManager.prototype.doesRowPassQuickFilterCache = function (node, filterPart) {
    if (!node.quickFilterAggregateText) {
      this.aggregateRowForQuickFilter(node);
    }
    return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
  };
  FilterManager.prototype.doesRowPassQuickFilter = function (node) {
    var _this = this;
    var usingCache = this.gridOptionsWrapper.isCacheQuickFilter();
    // each part must pass, if any fails, then the whole filter fails
    return every(this.quickFilterParts, function (part) {
      return usingCache ? _this.doesRowPassQuickFilterCache(node, part) : _this.doesRowPassQuickFilterNoCache(node, part);
    });
  };
  FilterManager.prototype.doesRowPassFilter = function (params) {
    // the row must pass ALL of the filters, so if any of them fail,
    // we return true. that means if a row passes the quick filter,
    // but fails the column filter, it fails overall
    // first up, check quick filter
    if (this.isQuickFilterPresent() && !this.doesRowPassQuickFilter(params.rowNode)) {
      return false;
    }
    // secondly, give the client a chance to reject this row
    if (this.gridOptionsWrapper.isExternalFilterPresent() && !this.gridOptionsWrapper.doesExternalFilterPass(params.rowNode)) {
      return false;
    }
    // lastly, check our internal advanced filter
    if (this.isAdvancedFilterPresent() && !this.doAdvancedFiltersPass(params.rowNode, params.filterInstanceToSkip)) {
      return false;
    }
    // got this far, all filters pass
    return true;
  };
  FilterManager.prototype.getQuickFilterTextForColumn = function (column, node) {
    var value = this.valueService.getValue(column, node, true);
    var colDef = column.getColDef();
    if (colDef.getQuickFilterText) {
      var params = {
        value: value,
        node: node,
        data: node.data,
        column: column,
        colDef: colDef,
        context: this.gridOptionsWrapper.getContext()
      };
      value = colDef.getQuickFilterText(params);
    }
    return exists(value) ? value.toString().toUpperCase() : null;
  };
  FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
    var _this = this;
    var stringParts = [];
    var columns = this.columnModel.getAllColumnsForQuickFilter();
    forEach$4(columns, function (column) {
      var part = _this.getQuickFilterTextForColumn(column, node);
      if (exists(part)) {
        stringParts.push(part);
      }
    });
    node.quickFilterAggregateText = stringParts.join(FilterManager_1.QUICK_FILTER_SEPARATOR);
  };
  FilterManager.prototype.onNewRowsLoaded = function (source) {
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      filterWrapper.filterPromise.then(function (filter) {
        if (filter.onNewRowsLoaded) {
          filter.onNewRowsLoaded();
        }
      });
    });
    this.updateFilterFlagInColumns(source);
    this.updateActiveFilters();
  };
  FilterManager.prototype.createValueGetter = function (column) {
    var _this = this;
    return function (node) {
      return _this.valueService.getValue(column, node, true);
    };
  };
  FilterManager.prototype.getFilterComponent = function (column, source, createIfDoesNotExist) {
    if (createIfDoesNotExist === void 0) {
      createIfDoesNotExist = true;
    }
    if (createIfDoesNotExist) {
      return this.getOrCreateFilterWrapper(column, source).filterPromise;
    }
    var filterWrapper = this.cachedFilter(column);
    return filterWrapper ? filterWrapper.filterPromise : null;
  };
  FilterManager.prototype.isFilterActive = function (column) {
    var filterWrapper = this.cachedFilter(column);
    return !!filterWrapper && filterWrapper.filterPromise.resolveNow(false, function (filter) {
      return filter.isFilterActive();
    });
  };
  FilterManager.prototype.getOrCreateFilterWrapper = function (column, source) {
    var filterWrapper = this.cachedFilter(column);
    if (!filterWrapper) {
      filterWrapper = this.createFilterWrapper(column, source);
      this.allAdvancedFilters.set(column.getColId(), filterWrapper);
    } else if (source !== 'NO_UI') {
      this.putIntoGui(filterWrapper, source);
    }
    return filterWrapper;
  };
  FilterManager.prototype.cachedFilter = function (column) {
    return this.allAdvancedFilters.get(column.getColId());
  };
  FilterManager.prototype.createFilterInstance = function (column, $scope) {
    var _this = this;
    var defaultFilter = ModuleRegistry.isRegistered(ModuleNames.SetFilterModule) ? 'agSetColumnFilter' : 'agTextColumnFilter';
    var colDef = column.getColDef();
    var filterInstance;
    var params = __assign$a(__assign$a({}, this.createFilterParams(column, colDef, $scope)), {
      filterModifiedCallback: function filterModifiedCallback() {
        var event = {
          type: Events.EVENT_FILTER_MODIFIED,
          api: _this.gridApi,
          columnApi: _this.columnApi,
          column: column,
          filterInstance: filterInstance
        };
        _this.eventService.dispatchEvent(event);
      },
      filterChangedCallback: function filterChangedCallback(additionalEventAttributes) {
        return _this.onFilterChanged({
          filterInstance: filterInstance,
          additionalEventAttributes: additionalEventAttributes,
          columns: [column]
        });
      },
      doesRowPassOtherFilter: function doesRowPassOtherFilter(node) {
        return _this.doesRowPassOtherFilters(filterInstance, node);
      }
    });
    var compDetails = this.userComponentFactory.getFilterDetails(colDef, params, defaultFilter);
    if (!compDetails) {
      return null;
    }
    var componentPromise = compDetails.newAgStackInstance();
    if (componentPromise) {
      componentPromise.then(function (r) {
        return filterInstance = r;
      });
    }
    return componentPromise;
  };
  FilterManager.prototype.createFilterParams = function (column, colDef, $scope) {
    if ($scope === void 0) {
      $scope = null;
    }
    var params = {
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      column: column,
      colDef: cloneObject(colDef),
      rowModel: this.rowModel,
      filterChangedCallback: function filterChangedCallback() {},
      filterModifiedCallback: function filterModifiedCallback() {},
      valueGetter: this.createValueGetter(column),
      context: this.gridOptionsWrapper.getContext(),
      doesRowPassOtherFilter: function doesRowPassOtherFilter() {
        return true;
      }
    };
    // hack in scope if using AngularJS
    if ($scope) {
      params.$scope = $scope;
    }
    return params;
  };
  FilterManager.prototype.createFilterWrapper = function (column, source) {
    var filterWrapper = {
      column: column,
      filterPromise: null,
      scope: null,
      compiledElement: null,
      guiPromise: AgPromise.resolve(null)
    };
    filterWrapper.scope = this.gridOptionsWrapper.isAngularCompileFilters() ? this.$scope.$new() : null;
    filterWrapper.filterPromise = this.createFilterInstance(column, filterWrapper.scope);
    if (filterWrapper.filterPromise) {
      this.putIntoGui(filterWrapper, source);
    }
    return filterWrapper;
  };
  FilterManager.prototype.putIntoGui = function (filterWrapper, source) {
    var _this = this;
    var eFilterGui = document.createElement('div');
    eFilterGui.className = 'ag-filter';
    filterWrapper.guiPromise = new AgPromise(function (resolve) {
      filterWrapper.filterPromise.then(function (filter) {
        var guiFromFilter = filter.getGui();
        if (!exists(guiFromFilter)) {
          console.warn("getGui method from filter returned " + guiFromFilter + ", it should be a DOM element or an HTML template string.");
        }
        // for backwards compatibility with Angular 1 - we
        // used to allow providing back HTML from getGui().
        // once we move away from supporting Angular 1
        // directly, we can change this.
        if (typeof guiFromFilter === 'string') {
          guiFromFilter = loadTemplate(guiFromFilter);
        }
        eFilterGui.appendChild(guiFromFilter);
        if (filterWrapper.scope) {
          var compiledElement = _this.$compile(eFilterGui)(filterWrapper.scope);
          filterWrapper.compiledElement = compiledElement;
          window.setTimeout(function () {
            return filterWrapper.scope.$apply();
          }, 0);
        }
        resolve(eFilterGui);
        _this.eventService.dispatchEvent({
          type: Events.EVENT_FILTER_OPENED,
          column: filterWrapper.column,
          source: source,
          eGui: eFilterGui,
          api: _this.gridApi,
          columnApi: _this.columnApi
        });
      });
    });
  };
  FilterManager.prototype.onNewColumnsLoaded = function () {
    var _this = this;
    var atLeastOneFilterGone = false;
    var columns = [];
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      var oldColumn = !_this.columnModel.getPrimaryColumn(filterWrapper.column);
      if (oldColumn) {
        atLeastOneFilterGone = true;
        columns.push(filterWrapper.column);
        _this.disposeFilterWrapper(filterWrapper, 'filterDestroyed');
      }
    });
    if (atLeastOneFilterGone) {
      this.onFilterChanged({
        columns: columns
      });
    }
  };
  // destroys the filter, so it not longer takes part
  FilterManager.prototype.destroyFilter = function (column, source) {
    if (source === void 0) {
      source = 'api';
    }
    var filterWrapper = this.allAdvancedFilters.get(column.getColId());
    if (filterWrapper) {
      this.disposeFilterWrapper(filterWrapper, source);
      this.onFilterChanged({
        columns: [column]
      });
    }
  };
  FilterManager.prototype.disposeFilterWrapper = function (filterWrapper, source) {
    var _this = this;
    filterWrapper.filterPromise.then(function (filter) {
      (filter.setModel(null) || AgPromise.resolve()).then(function () {
        _this.getContext().destroyBean(filter);
        filterWrapper.column.setFilterActive(false, source);
        if (filterWrapper.scope) {
          if (filterWrapper.compiledElement) {
            filterWrapper.compiledElement.remove();
          }
          filterWrapper.scope.$destroy();
        }
        _this.allAdvancedFilters.delete(filterWrapper.column.getColId());
      });
    });
  };
  FilterManager.prototype.destroy = function () {
    var _this = this;
    _super.prototype.destroy.call(this);
    this.allAdvancedFilters.forEach(function (filterWrapper) {
      return _this.disposeFilterWrapper(filterWrapper, 'filterDestroyed');
    });
  };
  var FilterManager_1;
  FilterManager.QUICK_FILTER_SEPARATOR = '\n';
  __decorate$17([Autowired('$compile')], FilterManager.prototype, "$compile", void 0);
  __decorate$17([Autowired('$scope')], FilterManager.prototype, "$scope", void 0);
  __decorate$17([Autowired('valueService')], FilterManager.prototype, "valueService", void 0);
  __decorate$17([Autowired('columnModel')], FilterManager.prototype, "columnModel", void 0);
  __decorate$17([Autowired('rowModel')], FilterManager.prototype, "rowModel", void 0);
  __decorate$17([Autowired('columnApi')], FilterManager.prototype, "columnApi", void 0);
  __decorate$17([Autowired('gridApi')], FilterManager.prototype, "gridApi", void 0);
  __decorate$17([Autowired('userComponentFactory')], FilterManager.prototype, "userComponentFactory", void 0);
  __decorate$17([PostConstruct], FilterManager.prototype, "init", null);
  __decorate$17([PreDestroy], FilterManager.prototype, "destroy", null);
  FilterManager = FilterManager_1 = __decorate$17([Bean('filterManager')], FilterManager);
  return FilterManager;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1k = undefined && undefined.__extends || function () {
  var _extendStatics85 = function extendStatics(d, b) {
    _extendStatics85 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics85(d, b);
  };
  return function (d, b) {
    _extendStatics85(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$18 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ValueService = /** @class */function (_super) {
  __extends$1k(ValueService, _super);
  function ValueService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.initialised = false;
    return _this;
  }
  ValueService.prototype.init = function () {
    this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
    this.initialised = true;
  };
  ValueService.prototype.getValue = function (column, rowNode, forFilter, ignoreAggData) {
    if (forFilter === void 0) {
      forFilter = false;
    }
    if (ignoreAggData === void 0) {
      ignoreAggData = false;
    }
    // hack - the grid is getting refreshed before this bean gets initialised, race condition.
    // really should have a way so they get initialised in the right order???
    if (!this.initialised) {
      this.init();
    }
    if (!rowNode) {
      return;
    }
    // pull these out to make code below easier to read
    var colDef = column.getColDef();
    var field = colDef.field;
    var colId = column.getId();
    var data = rowNode.data;
    var result;
    // if there is a value getter, this gets precedence over a field
    var groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== undefined;
    var aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== undefined;
    if (forFilter && colDef.filterValueGetter) {
      result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
    } else if (this.gridOptionsWrapper.isTreeData() && aggDataExists) {
      result = rowNode.aggData[colId];
    } else if (this.gridOptionsWrapper.isTreeData() && colDef.valueGetter) {
      result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
    } else if (this.gridOptionsWrapper.isTreeData() && field && data) {
      result = getValueUsingField(data, field, column.isFieldContainsDots());
    } else if (groupDataExists) {
      result = rowNode.groupData[colId];
    } else if (aggDataExists) {
      result = rowNode.aggData[colId];
    } else if (colDef.valueGetter) {
      result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
    } else if (field && data) {
      result = getValueUsingField(data, field, column.isFieldContainsDots());
    }
    // the result could be an expression itself, if we are allowing cell values to be expressions
    if (this.cellExpressions && typeof result === 'string' && result.indexOf('=') === 0) {
      var cellValueGetter = result.substring(1);
      result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
    }
    if (result == null) {
      var openedGroup = this.getOpenedGroup(rowNode, column);
      if (openedGroup != null) {
        return openedGroup;
      }
    }
    return result;
  };
  ValueService.prototype.getOpenedGroup = function (rowNode, column) {
    if (!this.gridOptionsWrapper.isShowOpenedGroup()) {
      return;
    }
    var colDef = column.getColDef();
    if (!colDef.showRowGroup) {
      return;
    }
    var showRowGroup = column.getColDef().showRowGroup;
    var pointer = rowNode.parent;
    while (pointer != null) {
      if (pointer.rowGroupColumn && (showRowGroup === true || showRowGroup === pointer.rowGroupColumn.getId())) {
        return pointer.key;
      }
      pointer = pointer.parent;
    }
    return undefined;
  };
  ValueService.prototype.setValue = function (rowNode, colKey, newValue, eventSource) {
    var column = this.columnModel.getPrimaryColumn(colKey);
    if (!rowNode || !column) {
      return;
    }
    // this will only happen if user is trying to paste into a group row, which doesn't make sense
    // the user should not be trying to paste into group rows
    if (missing(rowNode.data)) {
      rowNode.data = {};
    }
    // for backwards compatibility we are also retrieving the newValueHandler as well as the valueSetter
    var _a = column.getColDef(),
      field = _a.field,
      newValueHandler = _a.newValueHandler,
      valueSetter = _a.valueSetter;
    // need either a field or a newValueHandler for this to work
    if (missing(field) && missing(newValueHandler) && missing(valueSetter)) {
      // we don't tell user about newValueHandler, as that is deprecated
      console.warn("AG Grid: you need either field or valueSetter set on colDef for editing to work");
      return;
    }
    var params = {
      node: rowNode,
      data: rowNode.data,
      oldValue: this.getValue(column, rowNode),
      newValue: newValue,
      colDef: column.getColDef(),
      column: column,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      context: this.gridOptionsWrapper.getContext()
    };
    params.newValue = newValue;
    var valueWasDifferent;
    if (newValueHandler && exists(newValueHandler)) {
      valueWasDifferent = newValueHandler(params);
    } else if (exists(valueSetter)) {
      valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
    } else {
      valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
    }
    // in case user forgot to return something (possible if they are not using TypeScript
    // and just forgot, or using an old newValueHandler we didn't always expect a return
    // value here), we default the return value to true, so we always refresh.
    if (valueWasDifferent === undefined) {
      valueWasDifferent = true;
    }
    // if no change to the value, then no need to do the updating, or notifying via events.
    // otherwise the user could be tabbing around the grid, and cellValueChange would get called
    // all the time.
    if (!valueWasDifferent) {
      return;
    }
    // reset quick filter on this row
    rowNode.resetQuickFilterAggregateText();
    this.valueCache.onDataChanged();
    params.newValue = this.getValue(column, rowNode);
    var onCellValueChanged = column.getColDef().onCellValueChanged;
    if (typeof onCellValueChanged === 'function') {
      // to make callback async, do in a timeout
      setTimeout(function () {
        return onCellValueChanged(params);
      }, 0);
    }
    var event = {
      type: Events.EVENT_CELL_VALUE_CHANGED,
      event: null,
      rowIndex: rowNode.rowIndex,
      rowPinned: rowNode.rowPinned,
      column: params.column,
      api: params.api,
      columnApi: params.columnApi,
      colDef: params.colDef,
      context: params.context,
      data: rowNode.data,
      node: rowNode,
      oldValue: params.oldValue,
      newValue: params.newValue,
      value: params.newValue,
      source: eventSource
    };
    this.eventService.dispatchEvent(event);
  };
  ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
    if (!field) {
      return false;
    }
    // if no '.', then it's not a deep value
    var valuesAreSame = false;
    if (!isFieldContainsDots) {
      data[field] = newValue;
    } else {
      // otherwise it is a deep value, so need to dig for it
      var fieldPieces = field.split('.');
      var currentObject = data;
      while (fieldPieces.length > 0 && currentObject) {
        var fieldPiece = fieldPieces.shift();
        if (fieldPieces.length === 0) {
          currentObject[fieldPiece] = newValue;
        } else {
          currentObject = currentObject[fieldPiece];
        }
      }
    }
    return !valuesAreSame;
  };
  ValueService.prototype.executeFilterValueGetter = function (valueGetter, data, column, rowNode) {
    var params = {
      data: data,
      node: rowNode,
      column: column,
      colDef: column.getColDef(),
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      context: this.gridOptionsWrapper.getContext(),
      getValue: this.getValueCallback.bind(this, rowNode)
    };
    return this.expressionService.evaluate(valueGetter, params);
  };
  ValueService.prototype.executeValueGetter = function (valueGetter, data, column, rowNode) {
    var colId = column.getId();
    // if inside the same turn, just return back the value we got last time
    var valueFromCache = this.valueCache.getValue(rowNode, colId);
    if (valueFromCache !== undefined) {
      return valueFromCache;
    }
    var params = {
      data: data,
      node: rowNode,
      column: column,
      colDef: column.getColDef(),
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      context: this.gridOptionsWrapper.getContext(),
      getValue: this.getValueCallback.bind(this, rowNode)
    };
    var result = this.expressionService.evaluate(valueGetter, params);
    // if a turn is active, store the value in case the grid asks for it again
    this.valueCache.setValue(rowNode, colId, result);
    return result;
  };
  ValueService.prototype.getValueCallback = function (node, field) {
    var otherColumn = this.columnModel.getPrimaryColumn(field);
    if (otherColumn) {
      return this.getValue(otherColumn, node);
    }
    return null;
  };
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  ValueService.prototype.getKeyForNode = function (col, rowNode) {
    var value = this.getValue(col, rowNode);
    var keyCreator = col.getColDef().keyCreator;
    var result = value;
    if (keyCreator) {
      var keyParams = {
        value: value,
        colDef: col.getColDef(),
        column: col,
        node: rowNode,
        data: rowNode.data,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      result = keyCreator(keyParams);
    }
    // if already a string, or missing, just return it
    if (typeof result === 'string' || result == null) {
      return result;
    }
    result = String(result);
    if (result === '[object Object]') {
      doOnce(function () {
        console.warn('AG Grid: a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key');
      }, 'getKeyForNode - warn about [object,object]');
    }
    return result;
  };
  __decorate$18([Autowired('expressionService')], ValueService.prototype, "expressionService", void 0);
  __decorate$18([Autowired('columnModel')], ValueService.prototype, "columnModel", void 0);
  __decorate$18([Autowired('valueCache')], ValueService.prototype, "valueCache", void 0);
  __decorate$18([PostConstruct], ValueService.prototype, "init", null);
  ValueService = __decorate$18([Bean('valueService')], ValueService);
  return ValueService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1l = undefined && undefined.__extends || function () {
  var _extendStatics86 = function extendStatics(d, b) {
    _extendStatics86 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics86(d, b);
  };
  return function (d, b) {
    _extendStatics86(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$19 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LayoutCssClasses;
(function (LayoutCssClasses) {
  LayoutCssClasses["AUTO_HEIGHT"] = "ag-layout-auto-height";
  LayoutCssClasses["NORMAL"] = "ag-layout-normal";
  LayoutCssClasses["PRINT"] = "ag-layout-print";
})(LayoutCssClasses || (LayoutCssClasses = {}));
var LayoutFeature = /** @class */function (_super) {
  __extends$1l(LayoutFeature, _super);
  function LayoutFeature(view) {
    var _this = _super.call(this) || this;
    _this.view = view;
    return _this;
  }
  LayoutFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, this.updateLayoutClasses.bind(this));
    this.updateLayoutClasses();
  };
  LayoutFeature.prototype.updateLayoutClasses = function () {
    var domLayout = this.gridOptionsWrapper.getDomLayout();
    var params = {
      autoHeight: domLayout === Constants.DOM_LAYOUT_AUTO_HEIGHT,
      normal: domLayout === Constants.DOM_LAYOUT_NORMAL,
      print: domLayout === Constants.DOM_LAYOUT_PRINT
    };
    var cssClass = params.autoHeight ? LayoutCssClasses.AUTO_HEIGHT : params.print ? LayoutCssClasses.PRINT : LayoutCssClasses.NORMAL;
    this.view.updateLayoutClasses(cssClass, params);
  };
  __decorate$19([Autowired('gridOptionsWrapper')], LayoutFeature.prototype, "gridOptionsWrapper", void 0);
  __decorate$19([PostConstruct], LayoutFeature.prototype, "postConstruct", null);
  return LayoutFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1m = undefined && undefined.__extends || function () {
  var _extendStatics87 = function extendStatics(d, b) {
    _extendStatics87 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics87(d, b);
  };
  return function (d, b) {
    _extendStatics87(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridBodyScrollFeature = /** @class */function (_super) {
  __extends$1m(GridBodyScrollFeature, _super);
  function GridBodyScrollFeature(eBodyViewport) {
    var _this = _super.call(this) || this;
    _this.scrollLeft = -1;
    _this.nextScrollTop = -1;
    _this.scrollTop = -1;
    _this.eBodyViewport = eBodyViewport;
    _this.resetLastHorizontalScrollElementDebounced = debounce(_this.resetLastHorizontalScrollElement.bind(_this), 500);
    return _this;
  }
  GridBodyScrollFeature.prototype.postConstruct = function () {
    var _this = this;
    this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    this.ctrlsService.whenReady(function (p) {
      _this.centerRowContainerCon = p.centerRowContainerCtrl;
      _this.onDisplayedColumnsWidthChanged();
      _this.addScrollListener();
    });
  };
  GridBodyScrollFeature.prototype.addScrollListener = function () {
    var fakeHScroll = this.ctrlsService.getFakeHScrollCtrl();
    this.addManagedListener(this.centerRowContainerCon.getViewportElement(), 'scroll', this.onCenterViewportScroll.bind(this));
    this.addManagedListener(fakeHScroll.getViewport(), 'scroll', this.onFakeHorizontalScroll.bind(this));
    var onVerticalScroll = this.gridOptionsWrapper.isDebounceVerticalScrollbar() ? debounce(this.onVerticalScroll.bind(this), 100) : this.onVerticalScroll.bind(this);
    this.addManagedListener(this.eBodyViewport, 'scroll', onVerticalScroll);
  };
  GridBodyScrollFeature.prototype.onDisplayedColumnsWidthChanged = function () {
    if (this.enableRtl) {
      // because RTL is all backwards, a change in the width of the row
      // can cause a change in the scroll position, without a scroll event,
      // because the scroll position in RTL is a function that depends on
      // the width. to be convinced of this, take out this line, enable RTL,
      // scroll all the way to the left and then resize a column
      this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
  };
  GridBodyScrollFeature.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function (scrollLeft) {
    if (scrollLeft === undefined) {
      scrollLeft = this.centerRowContainerCon.getCenterViewportScrollLeft();
    }
    var offset = this.enableRtl ? scrollLeft : -scrollLeft;
    var topCenterContainer = this.ctrlsService.getTopCenterRowContainerCtrl();
    var bottomCenterContainer = this.ctrlsService.getBottomCenterRowContainerCtrl();
    var fakeHScroll = this.ctrlsService.getFakeHScrollCtrl();
    var centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
    centerHeaderContainer.setHorizontalScroll(offset);
    bottomCenterContainer.setContainerTranslateX(offset);
    topCenterContainer.setContainerTranslateX(offset);
    var partner = this.lastHorizontalScrollElement === this.centerRowContainerCon.getViewportElement() ? fakeHScroll.getViewport() : this.centerRowContainerCon.getViewportElement();
    setScrollLeft(partner, Math.abs(scrollLeft), this.enableRtl);
  };
  GridBodyScrollFeature.prototype.isControllingScroll = function (eDiv) {
    if (!this.lastHorizontalScrollElement) {
      this.lastHorizontalScrollElement = eDiv;
      return true;
    }
    return eDiv === this.lastHorizontalScrollElement;
  };
  GridBodyScrollFeature.prototype.onFakeHorizontalScroll = function () {
    var fakeHScrollViewport = this.ctrlsService.getFakeHScrollCtrl().getViewport();
    if (!this.isControllingScroll(fakeHScrollViewport)) {
      return;
    }
    this.onBodyHorizontalScroll(fakeHScrollViewport);
  };
  GridBodyScrollFeature.prototype.onCenterViewportScroll = function () {
    var centerContainerViewport = this.centerRowContainerCon.getViewportElement();
    if (!this.isControllingScroll(centerContainerViewport)) {
      return;
    }
    this.onBodyHorizontalScroll(centerContainerViewport);
  };
  GridBodyScrollFeature.prototype.onBodyHorizontalScroll = function (eSource) {
    var centerContainerViewport = this.centerRowContainerCon.getViewportElement();
    var scrollLeft = centerContainerViewport.scrollLeft;
    if (this.shouldBlockScrollUpdate('horizontal', scrollLeft, true)) {
      return;
    }
    // we do Math.round() rather than Math.floor(), to mirror how scroll values are applied.
    // eg if a scale is applied (ie user has zoomed the browser), then applying scroll=200
    // could result in 199.88, which then floor(199.88) = 199, however round(199.88) = 200.
    // initially Math.floor() was used, however this caused (almost) infinite loop with aligned grids,
    // as the scroll would move 1px at at time bouncing from one grid to the next (eg one grid would cause
    // scroll to 200px, the next to 199px, then the first back to 198px and so on).
    this.doHorizontalScroll(Math.round(getScrollLeft(eSource, this.enableRtl)));
    this.resetLastHorizontalScrollElementDebounced();
  };
  GridBodyScrollFeature.prototype.onVerticalScroll = function () {
    var scrollTop = this.eBodyViewport.scrollTop;
    if (this.shouldBlockScrollUpdate('vertical', scrollTop, true)) {
      return;
    }
    this.animationFrameService.setScrollTop(scrollTop);
    this.nextScrollTop = scrollTop;
    if (this.gridOptionsWrapper.isSuppressAnimationFrame()) {
      this.scrollTop = this.nextScrollTop;
      this.redrawRowsAfterScroll();
    } else {
      this.animationFrameService.schedule();
    }
  };
  GridBodyScrollFeature.prototype.resetLastHorizontalScrollElement = function () {
    this.lastHorizontalScrollElement = null;
  };
  GridBodyScrollFeature.prototype.doHorizontalScroll = function (scrollLeft) {
    var fakeHScrollViewport = this.ctrlsService.getFakeHScrollCtrl().getViewport();
    var fakeScrollLeft = getScrollLeft(fakeHScrollViewport, this.enableRtl);
    if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) {
      return;
    }
    this.scrollLeft = scrollLeft;
    this.fireScrollEvent('horizontal');
    this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
    this.onHorizontalViewportChanged();
  };
  GridBodyScrollFeature.prototype.fireScrollEvent = function (direction) {
    var _this = this;
    var bodyScrollEvent = {
      type: Events.EVENT_BODY_SCROLL,
      api: this.gridApi,
      columnApi: this.columnApi,
      direction: direction,
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.eventService.dispatchEvent(bodyScrollEvent);
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = undefined;
    this.scrollTimer = window.setTimeout(function () {
      var bodyScrollEndEvent = assign$3({}, bodyScrollEvent, {
        type: Events.EVENT_BODY_SCROLL_END
      });
      _this.eventService.dispatchEvent(bodyScrollEndEvent);
    }, 100);
  };
  GridBodyScrollFeature.prototype.shouldBlockScrollUpdate = function (direction, scrollTo, touchOnly) {
    // touch devices allow elastic scroll - which temporally scrolls the panel outside of the viewport
    // (eg user uses touch to go to the left of the grid, but drags past the left, the rows will actually
    // scroll past the left until the user releases the mouse). when this happens, we want ignore the scroll,
    // as otherwise it was causing the rows and header to flicker.
    if (touchOnly === void 0) {
      touchOnly = false;
    }
    // sometimes when scrolling, we got values that extended the maximum scroll allowed. we used to
    // ignore these scrolls. problem is the max scroll position could be skipped (eg the previous scroll event
    // could be 10px before the max position, and then current scroll event could be 20px after the max position).
    // if we just ignored the last event, we would be setting the scroll to 10px before the max position, when in
    // actual fact the user has exceeded the max scroll and thus scroll should be set to the max.
    if (touchOnly && !isIOSUserAgent()) {
      return false;
    }
    if (direction === 'vertical') {
      var clientHeight = getInnerHeight(this.eBodyViewport);
      var scrollHeight = this.eBodyViewport.scrollHeight;
      if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) {
        return true;
      }
    }
    if (direction === 'horizontal') {
      var clientWidth = this.centerRowContainerCon.getCenterWidth();
      var scrollWidth = this.centerRowContainerCon.getViewportElement().scrollWidth;
      if (this.enableRtl && isRtlNegativeScroll()) {
        if (scrollTo > 0) {
          return true;
        }
      } else if (scrollTo < 0) {
        return true;
      }
      if (Math.abs(scrollTo) + clientWidth > scrollWidth) {
        return true;
      }
    }
    return false;
  };
  GridBodyScrollFeature.prototype.redrawRowsAfterScroll = function () {
    this.fireScrollEvent('vertical');
  };
  GridBodyScrollFeature.prototype.onHorizontalViewportChanged = function () {
    this.centerRowContainerCon.onHorizontalViewportChanged();
  };
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  GridBodyScrollFeature.prototype.checkScrollLeft = function () {
    if (this.scrollLeft !== this.centerRowContainerCon.getCenterViewportScrollLeft()) {
      this.onBodyHorizontalScroll(this.centerRowContainerCon.getViewportElement());
    }
  };
  GridBodyScrollFeature.prototype.executeAnimationFrameScroll = function () {
    var frameNeeded = this.scrollTop != this.nextScrollTop;
    if (frameNeeded) {
      this.scrollTop = this.nextScrollTop;
      this.redrawRowsAfterScroll();
    }
    return frameNeeded;
  };
  // called by scrollHorizontally method and alignedGridsService
  GridBodyScrollFeature.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
    var minScrollLeft = 0;
    var maxScrollLeft = this.centerRowContainerCon.getViewportElement().scrollWidth - this.centerRowContainerCon.getCenterWidth();
    if (this.shouldBlockScrollUpdate('horizontal', hScrollPosition)) {
      if (this.enableRtl && isRtlNegativeScroll()) {
        hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
      } else {
        hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
      }
    }
    setScrollLeft(this.centerRowContainerCon.getViewportElement(), Math.abs(hScrollPosition), this.enableRtl);
    // we need to manually do the event handling (rather than wait for the event)
    // for the alignedGridsService, as if we don't, the aligned grid service gets
    // notified async, and then it's 'consuming' flag doesn't get used right, and
    // we can end up with an infinite loop
    this.doHorizontalScroll(hScrollPosition);
  };
  GridBodyScrollFeature.prototype.setVerticalScrollPosition = function (vScrollPosition) {
    this.eBodyViewport.scrollTop = vScrollPosition;
  };
  GridBodyScrollFeature.prototype.getVScrollPosition = function () {
    var result = {
      top: this.eBodyViewport.scrollTop,
      bottom: this.eBodyViewport.scrollTop + this.eBodyViewport.offsetHeight
    };
    return result;
  };
  GridBodyScrollFeature.prototype.getHScrollPosition = function () {
    return this.centerRowContainerCon.getHScrollPosition();
  };
  GridBodyScrollFeature.prototype.isHorizontalScrollShowing = function () {
    return this.centerRowContainerCon.isHorizontalScrollShowing();
  };
  // called by the headerRootComp and moveColumnController
  GridBodyScrollFeature.prototype.scrollHorizontally = function (pixels) {
    var oldScrollPosition = this.centerRowContainerCon.getViewportElement().scrollLeft;
    this.setHorizontalScrollPosition(oldScrollPosition + pixels);
    return this.centerRowContainerCon.getViewportElement().scrollLeft - oldScrollPosition;
  };
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  GridBodyScrollFeature.prototype.scrollToTop = function () {
    this.eBodyViewport.scrollTop = 0;
  };
  // Valid values for position are bottom, middle and top
  GridBodyScrollFeature.prototype.ensureNodeVisible = function (comparator, position) {
    if (position === void 0) {
      position = null;
    }
    // look for the node index we want to display
    var rowCount = this.rowModel.getRowCount();
    var comparatorIsAFunction = typeof comparator === 'function';
    var indexToSelect = -1;
    // go through all the nodes, find the one we want to show
    for (var i = 0; i < rowCount; i++) {
      var node = this.rowModel.getRow(i);
      if (comparatorIsAFunction) {
        if (comparator(node)) {
          indexToSelect = i;
          break;
        }
      } else {
        // check object equality against node and data
        if (comparator === node || comparator === node.data) {
          indexToSelect = i;
          break;
        }
      }
    }
    if (indexToSelect >= 0) {
      this.ensureIndexVisible(indexToSelect, position);
    }
  };
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  GridBodyScrollFeature.prototype.ensureIndexVisible = function (index, position) {
    // if for print or auto height, everything is always visible
    if (this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT) {
      return;
    }
    var rowCount = this.paginationProxy.getRowCount();
    if (typeof index !== 'number' || index < 0 || index >= rowCount) {
      console.warn('invalid row index for ensureIndexVisible: ' + index);
      return;
    }
    var isPaging = this.gridOptionsWrapper.isPagination();
    var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
    if (!paginationPanelEnabled) {
      this.paginationProxy.goToPageWithIndex(index);
    }
    var rowNode = this.paginationProxy.getRow(index);
    var rowGotShiftedDuringOperation;
    do {
      var startingRowTop = rowNode.rowTop;
      var startingRowHeight = rowNode.rowHeight;
      var paginationOffset = this.paginationProxy.getPixelOffset();
      var rowTopPixel = rowNode.rowTop - paginationOffset;
      var rowBottomPixel = rowTopPixel + rowNode.rowHeight;
      var scrollPosition = this.getVScrollPosition();
      var heightOffset = this.heightScaler.getDivStretchOffset();
      var vScrollTop = scrollPosition.top + heightOffset;
      var vScrollBottom = scrollPosition.bottom + heightOffset;
      var viewportHeight = vScrollBottom - vScrollTop;
      // work out the pixels for top, middle and bottom up front,
      // make the if/else below easier to read
      var pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
      var pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
      // make sure if middle, the row is not outside the top of the grid
      var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
      var rowBelowViewport = vScrollTop > rowTopPixel;
      var rowAboveViewport = vScrollBottom < rowBottomPixel;
      var newScrollPosition = null;
      if (position === 'top') {
        newScrollPosition = pxTop;
      } else if (position === 'bottom') {
        newScrollPosition = pxBottom;
      } else if (position === 'middle') {
        newScrollPosition = pxMiddle;
      } else if (rowBelowViewport) {
        // if row is before, scroll up with row at top
        newScrollPosition = pxTop;
      } else if (rowAboveViewport) {
        // if row is below, scroll down with row at bottom
        newScrollPosition = pxBottom;
      }
      if (newScrollPosition !== null) {
        this.eBodyViewport.scrollTop = newScrollPosition;
        this.rowRenderer.redrawAfterScroll();
      }
      // the row can get shifted if during the rendering (during rowRenderer.redrawAfterScroll()),
      // the height of a row changes due to lazy calculation of row heights when using
      // colDef.autoHeight or gridOptions.getRowHeight.
      // if row was shifted, then the position we scrolled to is incorrect.
      rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
    } while (rowGotShiftedDuringOperation);
    // so when we return back to user, the cells have rendered
    this.animationFrameService.flushAllFrames();
  };
  GridBodyScrollFeature.prototype.ensureColumnVisible = function (key) {
    var column = this.columnModel.getGridColumn(key);
    if (!column) {
      return;
    }
    // calling ensureColumnVisible on a pinned column doesn't make sense
    if (column.isPinned()) {
      return;
    }
    // defensive
    if (!this.columnModel.isColumnDisplayed(column)) {
      return;
    }
    var colLeftPixel = column.getLeft();
    var colRightPixel = colLeftPixel + column.getActualWidth();
    var viewportWidth = this.centerRowContainerCon.getCenterWidth();
    var scrollPosition = this.centerRowContainerCon.getCenterViewportScrollLeft();
    var bodyWidth = this.columnModel.getBodyContainerWidth();
    var viewportLeftPixel;
    var viewportRightPixel;
    // the logic of working out left and right viewport px is both here and in the ColumnController,
    // need to refactor it out to one place
    if (this.enableRtl) {
      viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
      viewportRightPixel = bodyWidth - scrollPosition;
    } else {
      viewportLeftPixel = scrollPosition;
      viewportRightPixel = viewportWidth + scrollPosition;
    }
    var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
    var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
    var colToSmallForViewport = viewportWidth < column.getActualWidth();
    var alignColToLeft = viewportScrolledPastCol || colToSmallForViewport;
    var alignColToRight = viewportScrolledBeforeCol;
    if (alignColToLeft || alignColToRight) {
      var newScrollPosition = void 0;
      if (this.enableRtl) {
        newScrollPosition = alignColToLeft ? bodyWidth - viewportWidth - colLeftPixel : bodyWidth - colRightPixel;
      } else {
        newScrollPosition = alignColToLeft ? colLeftPixel : colRightPixel - viewportWidth;
      }
      this.centerRowContainerCon.setCenterViewportScrollLeft(newScrollPosition);
    }
    // this will happen anyway, as the move will cause a 'scroll' event on the body, however
    // it is possible that the ensureColumnVisible method is called from within AG Grid and
    // the caller will need to have the columns rendered to continue, which will be before
    // the event has been worked on (which is the case for cell navigation).
    this.centerRowContainerCon.onHorizontalViewportChanged();
    // so when we return back to user, the cells have rendered
    this.animationFrameService.flushAllFrames();
  };
  __decorate$1a([Autowired('ctrlsService')], GridBodyScrollFeature.prototype, "ctrlsService", void 0);
  __decorate$1a([Autowired('animationFrameService')], GridBodyScrollFeature.prototype, "animationFrameService", void 0);
  __decorate$1a([Autowired('columnApi')], GridBodyScrollFeature.prototype, "columnApi", void 0);
  __decorate$1a([Autowired('gridApi')], GridBodyScrollFeature.prototype, "gridApi", void 0);
  __decorate$1a([Autowired('paginationProxy')], GridBodyScrollFeature.prototype, "paginationProxy", void 0);
  __decorate$1a([Autowired('rowModel')], GridBodyScrollFeature.prototype, "rowModel", void 0);
  __decorate$1a([Autowired('rowContainerHeightService')], GridBodyScrollFeature.prototype, "heightScaler", void 0);
  __decorate$1a([Autowired('rowRenderer')], GridBodyScrollFeature.prototype, "rowRenderer", void 0);
  __decorate$1a([Autowired('columnModel')], GridBodyScrollFeature.prototype, "columnModel", void 0);
  __decorate$1a([PostConstruct], GridBodyScrollFeature.prototype, "postConstruct", null);
  return GridBodyScrollFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var AutoScrollService = /** @class */function () {
  function AutoScrollService(params) {
    this.tickingInterval = null;
    this.onScrollCallback = null;
    this.scrollContainer = params.scrollContainer;
    this.scrollHorizontally = params.scrollAxis.indexOf('x') !== -1;
    this.scrollVertically = params.scrollAxis.indexOf('y') !== -1;
    this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
    if (params.onScrollCallback) {
      this.onScrollCallback = params.onScrollCallback;
    }
    if (this.scrollVertically) {
      this.getVerticalPosition = params.getVerticalPosition;
      this.setVerticalPosition = params.setVerticalPosition;
    }
    if (this.scrollHorizontally) {
      this.getHorizontalPosition = params.getHorizontalPosition;
      this.setHorizontalPosition = params.setHorizontalPosition;
    }
    this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || function () {
      return false;
    };
    this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || function () {
      return false;
    };
  }
  AutoScrollService.prototype.check = function (mouseEvent, forceSkipVerticalScroll) {
    if (forceSkipVerticalScroll === void 0) {
      forceSkipVerticalScroll = false;
    }
    var skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
    if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) {
      return;
    }
    var rect = this.scrollContainer.getBoundingClientRect();
    var scrollTick = this.scrollByTick;
    this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
    this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
    this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
    this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
    if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) {
      this.ensureTickingStarted();
    } else {
      this.ensureCleared();
    }
  };
  AutoScrollService.prototype.ensureTickingStarted = function () {
    if (this.tickingInterval === null) {
      this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
      this.tickCount = 0;
    }
  };
  AutoScrollService.prototype.doTick = function () {
    this.tickCount++;
    var tickAmount;
    tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
    if (this.scrollVertically) {
      var vScrollPosition = this.getVerticalPosition();
      if (this.tickUp) {
        this.setVerticalPosition(vScrollPosition - tickAmount);
      }
      if (this.tickDown) {
        this.setVerticalPosition(vScrollPosition + tickAmount);
      }
    }
    if (this.scrollHorizontally) {
      var hScrollPosition = this.getHorizontalPosition();
      if (this.tickLeft) {
        this.setHorizontalPosition(hScrollPosition - tickAmount);
      }
      if (this.tickRight) {
        this.setHorizontalPosition(hScrollPosition + tickAmount);
      }
    }
    if (this.onScrollCallback) {
      this.onScrollCallback();
    }
  };
  AutoScrollService.prototype.ensureCleared = function () {
    if (this.tickingInterval) {
      window.clearInterval(this.tickingInterval);
      this.tickingInterval = null;
    }
  };
  return AutoScrollService;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1n = undefined && undefined.__extends || function () {
  var _extendStatics88 = function extendStatics(d, b) {
    _extendStatics88 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics88(d, b);
  };
  return function (d, b) {
    _extendStatics88(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$b = undefined && undefined.__assign || function () {
  __assign$b = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$b.apply(this, arguments);
};
var __decorate$1b = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$9 = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var RowDragFeature = /** @class */function (_super) {
  __extends$1n(RowDragFeature, _super);
  function RowDragFeature(eContainer) {
    var _this = _super.call(this) || this;
    _this.isMultiRowDrag = false;
    _this.isGridSorted = false;
    _this.isGridFiltered = false;
    _this.isRowGroupActive = false;
    _this.eContainer = eContainer;
    return _this;
  }
  RowDragFeature.prototype.postConstruct = function () {
    var _this = this;
    if (this.gridOptionsWrapper.isRowModelDefault()) {
      this.clientSideRowModel = this.rowModel;
    }
    var refreshStatus = function refreshStatus() {
      _this.onSortChanged();
      _this.onFilterChanged();
      _this.onRowGroupChanged();
    };
    this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, function () {
      refreshStatus();
    });
    refreshStatus();
    this.ctrlsService.whenReady(function () {
      var gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
      _this.autoScrollService = new AutoScrollService({
        scrollContainer: gridBodyCon.getBodyViewportElement(),
        scrollAxis: 'y',
        getVerticalPosition: function getVerticalPosition() {
          return gridBodyCon.getScrollFeature().getVScrollPosition().top;
        },
        setVerticalPosition: function setVerticalPosition(position) {
          return gridBodyCon.getScrollFeature().setVerticalScrollPosition(position);
        },
        onScrollCallback: function onScrollCallback() {
          _this.onDragging(_this.lastDraggingEvent);
        }
      });
    });
  };
  RowDragFeature.prototype.onSortChanged = function () {
    this.isGridSorted = this.sortController.isSortActive();
  };
  RowDragFeature.prototype.onFilterChanged = function () {
    this.isGridFiltered = this.filterManager.isAnyFilterPresent();
  };
  RowDragFeature.prototype.onRowGroupChanged = function () {
    var rowGroups = this.columnModel.getRowGroupColumns();
    this.isRowGroupActive = !missingOrEmpty(rowGroups);
  };
  RowDragFeature.prototype.getContainer = function () {
    return this.eContainer;
  };
  RowDragFeature.prototype.isInterestedIn = function (type) {
    return type === DragSourceType.RowDrag;
  };
  RowDragFeature.prototype.getIconName = function () {
    var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
    if (managedDrag && this.shouldPreventRowMove()) {
      return DragAndDropService.ICON_NOT_ALLOWED;
    }
    return DragAndDropService.ICON_MOVE;
  };
  RowDragFeature.prototype.shouldPreventRowMove = function () {
    return this.isGridSorted || this.isGridFiltered || this.isRowGroupActive;
  };
  RowDragFeature.prototype.getRowNodes = function (draggingEvent) {
    if (!this.isFromThisGrid(draggingEvent)) {
      return draggingEvent.dragItem.rowNodes || [];
    }
    var isRowDragMultiRow = this.gridOptionsWrapper.isRowDragMultiRow();
    var selectedNodes = this.selectionService.getSelectedNodes();
    var currentNode = draggingEvent.dragItem.rowNode;
    if (isRowDragMultiRow && selectedNodes.indexOf(currentNode) !== -1) {
      this.isMultiRowDrag = true;
      return __spreadArrays$9(selectedNodes);
    }
    this.isMultiRowDrag = false;
    return [currentNode];
  };
  RowDragFeature.prototype.onDragEnter = function (draggingEvent) {
    // when entering, we fire the enter event, then in onEnterOrDragging,
    // we also fire the move event. so we get both events when entering.
    this.dispatchGridEvent(Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
    this.getRowNodes(draggingEvent).forEach(function (rowNode) {
      rowNode.setDragging(true);
    });
    this.onEnterOrDragging(draggingEvent);
  };
  RowDragFeature.prototype.onDragging = function (draggingEvent) {
    this.onEnterOrDragging(draggingEvent);
  };
  RowDragFeature.prototype.isFromThisGrid = function (draggingEvent) {
    var dragSourceDomDataKey = draggingEvent.dragSource.dragSourceDomDataKey;
    return dragSourceDomDataKey === this.gridOptionsWrapper.getDomDataKey();
  };
  RowDragFeature.prototype.isDropZoneWithinThisGrid = function (draggingEvent) {
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var gridGui = gridBodyCon.getGui();
    var dropZoneTarget = draggingEvent.dropZoneTarget;
    return !gridGui.contains(dropZoneTarget);
  };
  RowDragFeature.prototype.onEnterOrDragging = function (draggingEvent) {
    // this event is fired for enter and move
    this.dispatchGridEvent(Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
    this.lastDraggingEvent = draggingEvent;
    var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
    var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
    if (managedDrag) {
      this.doManagedDrag(draggingEvent, pixel);
    }
    this.autoScrollService.check(draggingEvent.event);
  };
  RowDragFeature.prototype.doManagedDrag = function (draggingEvent, pixel) {
    var _this = this;
    var rowNodes;
    var isFromThisGrid = this.isFromThisGrid(draggingEvent);
    if (isFromThisGrid) {
      rowNodes = [draggingEvent.dragItem.rowNode];
      if (this.isMultiRowDrag) {
        rowNodes = __spreadArrays$9(this.selectionService.getSelectedNodes()).sort(function (a, b) {
          return _this.getRowIndexNumber(a) - _this.getRowIndexNumber(b);
        });
      }
      draggingEvent.dragItem.rowNodes = rowNodes;
    } else {
      rowNodes = draggingEvent.dragItem.rowNodes;
    }
    var managedDrag = this.gridOptionsWrapper.isRowDragManaged();
    if (managedDrag && this.shouldPreventRowMove()) {
      return;
    }
    if (this.gridOptionsWrapper.isSuppressMoveWhenRowDragging() || !isFromThisGrid) {
      if (!this.isDropZoneWithinThisGrid(draggingEvent)) {
        this.clientSideRowModel.highlightRowAtPixel(rowNodes[0], pixel);
      }
    } else {
      this.moveRows(rowNodes, pixel);
    }
  };
  RowDragFeature.prototype.getRowIndexNumber = function (rowNode) {
    return parseInt(last(rowNode.getRowIndexString().split('-')), 10);
  };
  RowDragFeature.prototype.moveRowAndClearHighlight = function (draggingEvent) {
    var _this = this;
    var lastHighlightedRowNode = this.clientSideRowModel.getLastHighlightedRowNode();
    var isBelow = lastHighlightedRowNode && lastHighlightedRowNode.highlighted === RowHighlightPosition.Below;
    var pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
    var rowNodes = draggingEvent.dragItem.rowNodes;
    var increment = isBelow ? 1 : 0;
    if (this.isFromThisGrid(draggingEvent)) {
      rowNodes.forEach(function (rowNode) {
        if (rowNode.rowTop < pixel) {
          increment -= 1;
        }
      });
      this.moveRows(rowNodes, pixel, increment);
    } else {
      var getRowNodeId_1 = this.gridOptionsWrapper.getRowNodeIdFunc();
      var addIndex = this.clientSideRowModel.getRowIndexAtPixel(pixel) + 1;
      if (this.clientSideRowModel.getHighlightPosition(pixel) === RowHighlightPosition.Above) {
        addIndex--;
      }
      this.clientSideRowModel.updateRowData({
        add: rowNodes.map(function (node) {
          return node.data;
        }).filter(function (data) {
          return !_this.clientSideRowModel.getRowNode(getRowNodeId_1 ? getRowNodeId_1(data) : data.id);
        }),
        addIndex: addIndex
      });
    }
    this.clearRowHighlight();
  };
  RowDragFeature.prototype.clearRowHighlight = function () {
    this.clientSideRowModel.highlightRowAtPixel(null);
  };
  RowDragFeature.prototype.moveRows = function (rowNodes, pixel, increment) {
    if (increment === void 0) {
      increment = 0;
    }
    var rowWasMoved = this.clientSideRowModel.ensureRowsAtPixel(rowNodes, pixel, increment);
    if (rowWasMoved) {
      this.focusService.clearFocusedCell();
      if (this.rangeService) {
        this.rangeService.removeAllCellRanges();
      }
    }
  };
  RowDragFeature.prototype.addRowDropZone = function (params) {
    var _this = this;
    if (!params.getContainer()) {
      doOnce(function () {
        return console.warn('AG Grid: addRowDropZone - A container target needs to be provided');
      }, 'add-drop-zone-empty-target');
      return;
    }
    if (this.dragAndDropService.findExternalZone(params)) {
      console.warn('AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.');
      return;
    }
    var processedParams = {
      getContainer: params.getContainer
    };
    if (params.fromGrid) {
      params.fromGrid = undefined;
      processedParams = params;
    } else {
      if (params.onDragEnter) {
        processedParams.onDragEnter = function (e) {
          params.onDragEnter(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
        };
      }
      if (params.onDragLeave) {
        processedParams.onDragLeave = function (e) {
          params.onDragLeave(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
        };
      }
      if (params.onDragging) {
        processedParams.onDragging = function (e) {
          params.onDragging(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
        };
      }
      if (params.onDragStop) {
        processedParams.onDragStop = function (e) {
          params.onDragStop(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
        };
      }
    }
    this.dragAndDropService.addDropTarget(__assign$b({
      isInterestedIn: function isInterestedIn(type) {
        return type === DragSourceType.RowDrag;
      },
      getIconName: function getIconName() {
        return DragAndDropService.ICON_MOVE;
      },
      external: true
    }, processedParams));
  };
  RowDragFeature.prototype.getRowDropZone = function (events) {
    var _this = this;
    var getContainer = this.getContainer.bind(this);
    var onDragEnter = this.onDragEnter.bind(this);
    var onDragLeave = this.onDragLeave.bind(this);
    var onDragging = this.onDragging.bind(this);
    var onDragStop = this.onDragStop.bind(this);
    if (!events) {
      return {
        getContainer: getContainer,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onDragging: onDragging,
        onDragStop: onDragStop,
        /* @private */fromGrid: true
      };
    }
    return {
      getContainer: getContainer,
      onDragEnter: events.onDragEnter ? function (e) {
        onDragEnter(e);
        events.onDragEnter(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
      } : onDragEnter,
      onDragLeave: events.onDragLeave ? function (e) {
        onDragLeave(e);
        events.onDragLeave(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
      } : onDragLeave,
      onDragging: events.onDragging ? function (e) {
        onDragging(e);
        events.onDragging(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
      } : onDragging,
      onDragStop: events.onDragStop ? function (e) {
        onDragStop(e);
        events.onDragStop(_this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
      } : onDragStop,
      fromGrid: true /* @private */
    };
  };

  RowDragFeature.prototype.draggingToRowDragEvent = function (type, draggingEvent) {
    var yNormalised = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
    var mouseIsPastLastRow = yNormalised > this.paginationProxy.getCurrentPageHeight();
    var overIndex = -1;
    var overNode;
    if (!mouseIsPastLastRow) {
      overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
      overNode = this.rowModel.getRow(overIndex);
    }
    var vDirectionString;
    switch (draggingEvent.vDirection) {
      case VerticalDirection.Down:
        vDirectionString = 'down';
        break;
      case VerticalDirection.Up:
        vDirectionString = 'up';
        break;
      default:
        vDirectionString = null;
        break;
    }
    var event = {
      type: type,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      event: draggingEvent.event,
      node: draggingEvent.dragItem.rowNode,
      nodes: draggingEvent.dragItem.rowNodes,
      overIndex: overIndex,
      overNode: overNode,
      y: yNormalised,
      vDirection: vDirectionString
    };
    return event;
  };
  RowDragFeature.prototype.dispatchGridEvent = function (type, draggingEvent) {
    var event = this.draggingToRowDragEvent(type, draggingEvent);
    this.eventService.dispatchEvent(event);
  };
  RowDragFeature.prototype.onDragLeave = function (draggingEvent) {
    this.dispatchGridEvent(Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
    this.stopDragging(draggingEvent);
    if (this.gridOptionsWrapper.isRowDragManaged()) {
      this.clearRowHighlight();
    }
    if (this.isFromThisGrid(draggingEvent)) {
      this.isMultiRowDrag = false;
    }
  };
  RowDragFeature.prototype.onDragStop = function (draggingEvent) {
    this.dispatchGridEvent(Events.EVENT_ROW_DRAG_END, draggingEvent);
    this.stopDragging(draggingEvent);
    if (this.gridOptionsWrapper.isRowDragManaged() && (this.gridOptionsWrapper.isSuppressMoveWhenRowDragging() || !this.isFromThisGrid(draggingEvent)) && !this.isDropZoneWithinThisGrid(draggingEvent)) {
      this.moveRowAndClearHighlight(draggingEvent);
    }
  };
  RowDragFeature.prototype.stopDragging = function (draggingEvent) {
    this.autoScrollService.ensureCleared();
    this.getRowNodes(draggingEvent).forEach(function (rowNode) {
      rowNode.setDragging(false);
    });
  };
  __decorate$1b([Autowired('dragAndDropService')], RowDragFeature.prototype, "dragAndDropService", void 0);
  __decorate$1b([Autowired('rowModel')], RowDragFeature.prototype, "rowModel", void 0);
  __decorate$1b([Autowired('paginationProxy')], RowDragFeature.prototype, "paginationProxy", void 0);
  __decorate$1b([Autowired('columnModel')], RowDragFeature.prototype, "columnModel", void 0);
  __decorate$1b([Autowired('focusService')], RowDragFeature.prototype, "focusService", void 0);
  __decorate$1b([Autowired('sortController')], RowDragFeature.prototype, "sortController", void 0);
  __decorate$1b([Autowired('filterManager')], RowDragFeature.prototype, "filterManager", void 0);
  __decorate$1b([Autowired('selectionService')], RowDragFeature.prototype, "selectionService", void 0);
  __decorate$1b([Autowired('mouseEventService')], RowDragFeature.prototype, "mouseEventService", void 0);
  __decorate$1b([Autowired('ctrlsService')], RowDragFeature.prototype, "ctrlsService", void 0);
  __decorate$1b([Optional('rangeService')], RowDragFeature.prototype, "rangeService", void 0);
  __decorate$1b([PostConstruct], RowDragFeature.prototype, "postConstruct", null);
  return RowDragFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1o = undefined && undefined.__extends || function () {
  var _extendStatics89 = function extendStatics(d, b) {
    _extendStatics89 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics89(d, b);
  };
  return function (d, b) {
    _extendStatics89(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1c = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowAnimationCssClasses;
(function (RowAnimationCssClasses) {
  RowAnimationCssClasses["ANIMATION_ON"] = "ag-row-animation";
  RowAnimationCssClasses["ANIMATION_OFF"] = "ag-row-no-animation";
})(RowAnimationCssClasses || (RowAnimationCssClasses = {}));
var CSS_CLASS_CELL_SELECTABLE = 'ag-selectable';
var CSS_CLASS_FORCE_VERTICAL_SCROLL = 'ag-force-vertical-scroll';
var CSS_CLASS_COLUMN_MOVING = 'ag-column-moving';
var GridBodyCtrl = /** @class */function (_super) {
  __extends$1o(GridBodyCtrl, _super);
  function GridBodyCtrl() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.angularApplyTriggered = false;
    return _this;
  }
  GridBodyCtrl.prototype.getScrollFeature = function () {
    return this.bodyScrollFeature;
  };
  GridBodyCtrl.prototype.getBodyViewportElement = function () {
    return this.eBodyViewport;
  };
  GridBodyCtrl.prototype.setComp = function (comp, eGridBody, eBodyViewport, eTop, eBottom) {
    this.comp = comp;
    this.eGridBody = eGridBody;
    this.eBodyViewport = eBodyViewport;
    this.eTop = eTop;
    this.eBottom = eBottom;
    this.setCellTextSelection(this.gridOptionsWrapper.isEnableCellTextSelect());
    this.createManagedBean(new LayoutFeature(this.comp));
    this.bodyScrollFeature = this.createManagedBean(new GridBodyScrollFeature(this.eBodyViewport));
    this.addRowDragListener();
    this.setupRowAnimationCssClass();
    this.ctrlsService.registerGridBodyCtrl(this);
    this.addEventListeners();
    this.addFocusListeners([eTop, eBodyViewport, eBottom]);
    this.onGridColumnsChanged();
    this.addBodyViewportListener();
    this.setFloatingHeights();
    this.disableBrowserDragging();
    this.addStopEditingWhenGridLosesFocus();
    if (this.$scope) {
      this.addAngularApplyCheck();
    }
  };
  GridBodyCtrl.prototype.getComp = function () {
    return this.comp;
  };
  GridBodyCtrl.prototype.addEventListeners = function () {
    this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.setFloatingHeights.bind(this));
  };
  GridBodyCtrl.prototype.addFocusListeners = function (elements) {
    var _this = this;
    elements.forEach(function (element) {
      _this.addManagedListener(element, 'focusin', function () {
        addCssClass(element, 'ag-has-focus');
      });
      _this.addManagedListener(element, 'focusout', function (e) {
        if (!element.contains(e.relatedTarget)) {
          removeCssClass(element, 'ag-has-focus');
        }
      });
    });
  };
  // used by ColumnAnimationService
  GridBodyCtrl.prototype.setColumnMovingCss = function (moving) {
    this.comp.setColumnMovingCss(moving ? CSS_CLASS_COLUMN_MOVING : null, moving);
  };
  GridBodyCtrl.prototype.setCellTextSelection = function (selectable) {
    if (selectable === void 0) {
      selectable = false;
    }
    var cssClass = selectable ? CSS_CLASS_CELL_SELECTABLE : null;
    this.comp.setCellSelectableCss(cssClass, selectable);
  };
  GridBodyCtrl.prototype.onScrollVisibilityChanged = function () {
    var visible = this.scrollVisibleService.isVerticalScrollShowing();
    this.setVerticalScrollPaddingVisible(visible);
  };
  GridBodyCtrl.prototype.onGridColumnsChanged = function () {
    var columns = this.columnModel.getAllGridColumns();
    this.comp.setColumnCount(columns ? columns.length : 0);
  };
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  GridBodyCtrl.prototype.disableBrowserDragging = function () {
    this.addManagedListener(this.eGridBody, 'dragstart', function (event) {
      if (event.target instanceof HTMLImageElement) {
        event.preventDefault();
        return false;
      }
    });
  };
  GridBodyCtrl.prototype.addStopEditingWhenGridLosesFocus = function () {
    var _this = this;
    if (!this.gridOptionsWrapper.isStopEditingWhenCellsLoseFocus()) {
      return;
    }
    var focusOutListener = function focusOutListener(event) {
      // this is the element the focus is moving to
      var elementWithFocus = event.relatedTarget;
      if (getTabIndex(elementWithFocus) === null) {
        _this.rowRenderer.stopEditing();
        return;
      }
      var clickInsideGrid =
      // see if click came from inside the viewports
      viewports.some(function (viewport) {
        return viewport.contains(elementWithFocus);
      })
      // and also that it's not from a detail grid
      && _this.mouseEventService.isElementInThisGrid(elementWithFocus);
      if (!clickInsideGrid) {
        var popupService = _this.popupService;
        clickInsideGrid = popupService.getActivePopups().some(function (popup) {
          return popup.contains(elementWithFocus);
        }) || popupService.isElementWithinCustomPopup(elementWithFocus);
      }
      if (!clickInsideGrid) {
        _this.rowRenderer.stopEditing();
      }
    };
    var viewports = [this.eBodyViewport, this.eBottom, this.eTop];
    viewports.forEach(function (viewport) {
      return _this.addManagedListener(viewport, 'focusout', focusOutListener);
    });
  };
  GridBodyCtrl.prototype.updateRowCount = function () {
    var headerCount = this.headerNavigationService.getHeaderRowCount();
    var modelType = this.paginationProxy.getType();
    var rowCount = -1;
    if (modelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      rowCount = 0;
      this.paginationProxy.forEachNode(function (node) {
        if (!node.group) {
          rowCount++;
        }
      });
    }
    var total = rowCount === -1 ? -1 : headerCount + rowCount;
    this.comp.setRowCount(total);
  };
  GridBodyCtrl.prototype.registerBodyViewportResizeListener = function (listener) {
    this.comp.registerBodyViewportResizeListener(listener);
  };
  GridBodyCtrl.prototype.setVerticalScrollPaddingVisible = function (visible) {
    var overflowY = visible ? 'scroll' : 'hidden';
    this.comp.setPinnedTopBottomOverflowY(overflowY);
  };
  GridBodyCtrl.prototype.isVerticalScrollShowing = function () {
    var show = this.gridOptionsWrapper.isAlwaysShowVerticalScroll();
    var cssClass = show ? CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
    this.comp.setAlwaysVerticalScrollClass(cssClass, show);
    return show || isVerticalScrollShowing(this.eBodyViewport);
  };
  GridBodyCtrl.prototype.setupRowAnimationCssClass = function () {
    var _this = this;
    var listener = function listener() {
      // we don't want to use row animation if scaling, as rows jump strangely as you scroll,
      // when scaling and doing row animation.
      var animateRows = _this.gridOptionsWrapper.isAnimateRows() && !_this.rowContainerHeightService.isStretching();
      var animateRowsCssClass = animateRows ? RowAnimationCssClasses.ANIMATION_ON : RowAnimationCssClasses.ANIMATION_OFF;
      _this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
    };
    listener();
    this.addManagedListener(this.eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
  };
  GridBodyCtrl.prototype.getGridBodyElement = function () {
    return this.eGridBody;
  };
  GridBodyCtrl.prototype.addBodyViewportListener = function () {
    var _this = this;
    // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
    // the context menu if no rows or columns are displayed, or user simply clicks outside of a cell
    var listener = function listener(mouseEvent) {
      if (_this.gridOptionsWrapper.isPreventDefaultOnContextMenu()) {
        mouseEvent.preventDefault();
      }
      var target = getTarget(mouseEvent);
      if (target === _this.eBodyViewport || target === _this.ctrlsService.getCenterRowContainerCtrl().getViewportElement()) {
        // show it
        if (_this.contextMenuFactory) {
          _this.contextMenuFactory.onContextMenu(mouseEvent, null, null, null, null, _this.eGridBody);
        }
      }
    };
    this.addManagedListener(this.eBodyViewport, 'contextmenu', listener);
    this.addManagedListener(this.eBodyViewport, 'wheel', this.onWheel.bind(this));
  };
  GridBodyCtrl.prototype.onWheel = function (e) {
    if (!this.gridOptionsWrapper.isSuppressScrollWhenPopupsAreOpen()) {
      return;
    }
    if (this.popupService.hasAnchoredPopup()) {
      e.preventDefault();
    }
  };
  GridBodyCtrl.prototype.getGui = function () {
    return this.eGridBody;
  };
  // called by rowDragFeature
  GridBodyCtrl.prototype.scrollVertically = function (pixels) {
    var oldScrollPosition = this.eBodyViewport.scrollTop;
    this.bodyScrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
    return this.eBodyViewport.scrollTop - oldScrollPosition;
  };
  GridBodyCtrl.prototype.addRowDragListener = function () {
    this.rowDragFeature = this.createManagedBean(new RowDragFeature(this.eBodyViewport));
    this.dragAndDropService.addDropTarget(this.rowDragFeature);
  };
  GridBodyCtrl.prototype.getRowDragFeature = function () {
    return this.rowDragFeature;
  };
  GridBodyCtrl.prototype.setFloatingHeights = function () {
    var pinnedRowModel = this.pinnedRowModel;
    var floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
    if (floatingTopHeight) {
      // adding 1px for cell bottom border
      floatingTopHeight += 1;
    }
    var floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
    if (floatingBottomHeight) {
      // adding 1px for cell bottom border
      floatingBottomHeight += 1;
    }
    this.comp.setTopHeight(floatingTopHeight);
    this.comp.setBottomHeight(floatingBottomHeight);
    this.comp.setTopDisplay(floatingTopHeight ? 'inherit' : 'none');
    this.comp.setBottomDisplay(floatingBottomHeight ? 'inherit' : 'none');
  };
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  GridBodyCtrl.prototype.sizeColumnsToFit = function (nextTimeout) {
    var _this = this;
    // IE is different to the other browsers, it already removes the scroll width
    // while calling window.getComputedStyle() (which is called by getInnerWidth())
    var removeScrollWidth = this.isVerticalScrollShowing() && !isBrowserIE();
    var scrollWidthToRemove = removeScrollWidth ? this.gridOptionsWrapper.getScrollbarWidth() : 0;
    var bodyViewportWidth = getInnerWidth(this.eBodyViewport);
    var availableWidth = bodyViewportWidth - scrollWidthToRemove;
    if (availableWidth > 0) {
      this.columnModel.sizeColumnsToFit(availableWidth, "sizeColumnsToFit");
      return;
    }
    if (nextTimeout === undefined) {
      window.setTimeout(function () {
        _this.sizeColumnsToFit(100);
      }, 0);
    } else if (nextTimeout === 100) {
      window.setTimeout(function () {
        _this.sizeColumnsToFit(500);
      }, 100);
    } else if (nextTimeout === 500) {
      window.setTimeout(function () {
        _this.sizeColumnsToFit(-1);
      }, 500);
    } else {
      console.warn('AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' + 'zero width, maybe the grid is not visible yet on the screen?');
    }
  };
  // + rangeService
  GridBodyCtrl.prototype.addScrollEventListener = function (listener) {
    this.eBodyViewport.addEventListener('scroll', listener);
  };
  // + focusService
  GridBodyCtrl.prototype.removeScrollEventListener = function (listener) {
    this.eBodyViewport.removeEventListener('scroll', listener);
  };
  GridBodyCtrl.prototype.requestAngularApply = function () {
    var _this = this;
    if (this.angularApplyTriggered) {
      return;
    }
    this.angularApplyTriggered = true;
    window.setTimeout(function () {
      _this.angularApplyTriggered = false;
      _this.$scope.$apply();
    }, 0);
  };
  GridBodyCtrl.prototype.addAngularApplyCheck = function () {
    var _this = this;
    // these are the events we need to do an apply after - these are the ones that can end up
    // with columns added or removed
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, function () {
      return _this.requestAngularApply();
    });
    this.addManagedListener(this.eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, function () {
      return _this.requestAngularApply();
    });
  };
  __decorate$1c([Autowired('rowContainerHeightService')], GridBodyCtrl.prototype, "rowContainerHeightService", void 0);
  __decorate$1c([Autowired('ctrlsService')], GridBodyCtrl.prototype, "ctrlsService", void 0);
  __decorate$1c([Autowired('columnModel')], GridBodyCtrl.prototype, "columnModel", void 0);
  __decorate$1c([Autowired('scrollVisibleService')], GridBodyCtrl.prototype, "scrollVisibleService", void 0);
  __decorate$1c([Optional('contextMenuFactory')], GridBodyCtrl.prototype, "contextMenuFactory", void 0);
  __decorate$1c([Autowired('headerNavigationService')], GridBodyCtrl.prototype, "headerNavigationService", void 0);
  __decorate$1c([Autowired('paginationProxy')], GridBodyCtrl.prototype, "paginationProxy", void 0);
  __decorate$1c([Autowired('dragAndDropService')], GridBodyCtrl.prototype, "dragAndDropService", void 0);
  __decorate$1c([Autowired('pinnedRowModel')], GridBodyCtrl.prototype, "pinnedRowModel", void 0);
  __decorate$1c([Autowired('rowRenderer')], GridBodyCtrl.prototype, "rowRenderer", void 0);
  __decorate$1c([Autowired('popupService')], GridBodyCtrl.prototype, "popupService", void 0);
  __decorate$1c([Autowired('mouseEventService')], GridBodyCtrl.prototype, "mouseEventService", void 0);
  __decorate$1c([Autowired('$scope')], GridBodyCtrl.prototype, "$scope", void 0);
  return GridBodyCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1p = undefined && undefined.__extends || function () {
  var _extendStatics90 = function extendStatics(d, b) {
    _extendStatics90 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics90(d, b);
  };
  return function (d, b) {
    _extendStatics90(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1d = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowContainerEventsFeature = /** @class */function (_super) {
  __extends$1p(RowContainerEventsFeature, _super);
  function RowContainerEventsFeature(element) {
    var _this = _super.call(this) || this;
    _this.element = element;
    return _this;
  }
  RowContainerEventsFeature.prototype.postConstruct = function () {
    this.addMouseListeners();
    this.mockContextMenuForIPad();
    this.addKeyboardEvents();
  };
  RowContainerEventsFeature.prototype.addKeyboardEvents = function () {
    var _this = this;
    var eventNames = ['keydown', 'keypress'];
    eventNames.forEach(function (eventName) {
      var listener = _this.processKeyboardEvent.bind(_this, eventName);
      _this.addManagedListener(_this.element, eventName, listener);
    });
  };
  RowContainerEventsFeature.prototype.addMouseListeners = function () {
    var _this = this;
    var mouseDownEvent = isEventSupported('touchstart') ? 'touchstart' : 'mousedown';
    var eventNames = ['dblclick', 'contextmenu', 'mouseover', 'mouseout', 'click', mouseDownEvent];
    eventNames.forEach(function (eventName) {
      var listener = _this.processMouseEvent.bind(_this, eventName);
      _this.addManagedListener(_this.element, eventName, listener);
    });
  };
  RowContainerEventsFeature.prototype.processMouseEvent = function (eventName, mouseEvent) {
    if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) || isStopPropagationForAgGrid(mouseEvent)) {
      return;
    }
    var rowComp = this.getRowForEvent(mouseEvent);
    var cellCtrl = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
    if (eventName === "contextmenu") {
      this.handleContextMenuMouseEvent(mouseEvent, null, rowComp, cellCtrl);
    } else {
      if (cellCtrl) {
        cellCtrl.onMouseEvent(eventName, mouseEvent);
      }
      if (rowComp) {
        rowComp.onMouseEvent(eventName, mouseEvent);
      }
    }
  };
  RowContainerEventsFeature.prototype.mockContextMenuForIPad = function () {
    var _this = this;
    // we do NOT want this when not in iPad, otherwise we will be doing
    if (!isIOSUserAgent()) {
      return;
    }
    var touchListener = new TouchListener(this.element);
    var longTapListener = function longTapListener(event) {
      var rowComp = _this.getRowForEvent(event.touchEvent);
      var cellComp = _this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
      _this.handleContextMenuMouseEvent(null, event.touchEvent, rowComp, cellComp);
    };
    this.addManagedListener(touchListener, TouchListener.EVENT_LONG_TAP, longTapListener);
    this.addDestroyFunc(function () {
      return touchListener.destroy();
    });
  };
  RowContainerEventsFeature.prototype.getRowForEvent = function (event) {
    var sourceElement = getTarget(event);
    while (sourceElement) {
      var rowCon = this.gridOptionsWrapper.getDomData(sourceElement, RowCtrl.DOM_DATA_KEY_ROW_CTRL);
      if (rowCon) {
        return rowCon;
      }
      sourceElement = sourceElement.parentElement;
    }
    return null;
  };
  RowContainerEventsFeature.prototype.handleContextMenuMouseEvent = function (mouseEvent, touchEvent, rowComp, cellCtrl) {
    var rowNode = rowComp ? rowComp.getRowNode() : null;
    var column = cellCtrl ? cellCtrl.getColumn() : null;
    var value = null;
    if (column) {
      var event_1 = mouseEvent ? mouseEvent : touchEvent;
      cellCtrl.dispatchCellContextMenuEvent(event_1);
      value = this.valueService.getValue(column, rowNode);
    }
    // if user clicked on a cell, anchor to that cell, otherwise anchor to the grid panel
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var anchorToElement = cellCtrl ? cellCtrl.getGui() : gridBodyCon.getGridBodyElement();
    if (this.contextMenuFactory) {
      this.contextMenuFactory.onContextMenu(mouseEvent, touchEvent, rowNode, column, value, anchorToElement);
    }
  };
  RowContainerEventsFeature.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
    var cellComp = getCtrlForEvent(this.gridOptionsWrapper, keyboardEvent, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
    var rowComp = getCtrlForEvent(this.gridOptionsWrapper, keyboardEvent, RowCtrl.DOM_DATA_KEY_ROW_CTRL);
    if (keyboardEvent.defaultPrevented) {
      return;
    }
    if (cellComp) {
      this.processCellKeyboardEvent(cellComp, eventName, keyboardEvent);
    } else if (rowComp && rowComp.isFullWidth()) {
      this.processFullWidthRowKeyboardEvent(rowComp, eventName, keyboardEvent);
    }
  };
  RowContainerEventsFeature.prototype.processCellKeyboardEvent = function (cellCtrl, eventName, keyboardEvent) {
    var rowNode = cellCtrl.getRowNode();
    var column = cellCtrl.getColumn();
    var editing = cellCtrl.isEditing();
    var gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, editing);
    if (gridProcessingAllowed) {
      switch (eventName) {
        case 'keydown':
          // first see if it's a scroll key, page up / down, home / end etc
          var wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
          // if not a scroll key, then we pass onto cell
          if (!wasScrollKey) {
            cellCtrl.onKeyDown(keyboardEvent);
          }
          // perform clipboard and undo / redo operations
          this.doGridOperations(keyboardEvent, cellCtrl.isEditing());
          break;
        case 'keypress':
          cellCtrl.onKeyPress(keyboardEvent);
          break;
      }
    }
    if (eventName === 'keydown') {
      var cellKeyDownEvent = cellCtrl.createEvent(keyboardEvent, Events.EVENT_CELL_KEY_DOWN);
      this.eventService.dispatchEvent(cellKeyDownEvent);
    }
    if (eventName === 'keypress') {
      var cellKeyPressEvent = cellCtrl.createEvent(keyboardEvent, Events.EVENT_CELL_KEY_PRESS);
      this.eventService.dispatchEvent(cellKeyPressEvent);
    }
  };
  RowContainerEventsFeature.prototype.processFullWidthRowKeyboardEvent = function (rowComp, eventName, keyboardEvent) {
    var rowNode = rowComp.getRowNode();
    var focusedCell = this.focusService.getFocusedCell();
    var column = focusedCell && focusedCell.column;
    var gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gridOptionsWrapper, keyboardEvent, rowNode, column, false);
    if (gridProcessingAllowed) {
      var key = keyboardEvent.keyCode;
      if (eventName === 'keydown') {
        switch (key) {
          case KeyCode.UP:
          case KeyCode.DOWN:
            rowComp.onKeyboardNavigate(keyboardEvent);
            break;
          case KeyCode.TAB:
            rowComp.onTabKeyDown(keyboardEvent);
        }
      }
    }
    if (eventName === 'keydown') {
      var cellKeyDownEvent = rowComp.createRowEvent(Events.EVENT_CELL_KEY_DOWN, keyboardEvent);
      this.eventService.dispatchEvent(cellKeyDownEvent);
    }
    if (eventName === 'keypress') {
      var cellKeyPressEvent = rowComp.createRowEvent(Events.EVENT_CELL_KEY_PRESS, keyboardEvent);
      this.eventService.dispatchEvent(cellKeyPressEvent);
    }
  };
  RowContainerEventsFeature.prototype.doGridOperations = function (keyboardEvent, editing) {
    // check if ctrl or meta key pressed
    if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) {
      return;
    }
    // if the cell the event came from is editing, then we do not
    // want to do the default shortcut keys, otherwise the editor
    // (eg a text field) would not be able to do the normal cut/copy/paste
    if (editing) {
      return;
    }
    // for copy / paste, we don't want to execute when the event
    // was from a child grid (happens in master detail)
    if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) {
      return;
    }
    switch (keyboardEvent.which) {
      case KeyCode.A:
        return this.onCtrlAndA(keyboardEvent);
      case KeyCode.C:
        return this.onCtrlAndC(keyboardEvent);
      case KeyCode.V:
        return this.onCtrlAndV();
      case KeyCode.D:
        return this.onCtrlAndD(keyboardEvent);
      case KeyCode.Z:
        return keyboardEvent.shiftKey ? this.undoRedoService.redo() : this.undoRedoService.undo();
      case KeyCode.Y:
        return this.undoRedoService.redo();
    }
  };
  RowContainerEventsFeature.prototype.onCtrlAndA = function (event) {
    var _a = this,
      pinnedRowModel = _a.pinnedRowModel,
      paginationProxy = _a.paginationProxy,
      rangeService = _a.rangeService;
    var PINNED_BOTTOM = Constants.PINNED_BOTTOM,
      PINNED_TOP = Constants.PINNED_TOP;
    if (rangeService && paginationProxy.isRowsToRender()) {
      var _b = [pinnedRowModel.isEmpty(PINNED_TOP), pinnedRowModel.isEmpty(PINNED_BOTTOM)],
        isEmptyPinnedTop = _b[0],
        isEmptyPinnedBottom = _b[1];
      var floatingStart = isEmptyPinnedTop ? null : PINNED_TOP;
      var floatingEnd = void 0;
      var rowEnd = void 0;
      if (isEmptyPinnedBottom) {
        floatingEnd = null;
        rowEnd = this.paginationProxy.getRowCount() - 1;
      } else {
        floatingEnd = PINNED_BOTTOM;
        rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
      }
      var allDisplayedColumns = this.columnModel.getAllDisplayedColumns();
      if (missingOrEmpty(allDisplayedColumns)) {
        return;
      }
      rangeService.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: floatingStart,
        rowEndIndex: rowEnd,
        rowEndPinned: floatingEnd,
        columnStart: allDisplayedColumns[0],
        columnEnd: last(allDisplayedColumns)
      });
    }
    event.preventDefault();
  };
  RowContainerEventsFeature.prototype.onCtrlAndC = function (event) {
    if (!this.clipboardService || this.gridOptionsWrapper.isEnableCellTextSelection()) {
      return;
    }
    this.clipboardService.copyToClipboard();
    event.preventDefault();
  };
  RowContainerEventsFeature.prototype.onCtrlAndV = function () {
    if (ModuleRegistry.isRegistered(ModuleNames.ClipboardModule) && !this.gridOptionsWrapper.isSuppressClipboardPaste()) {
      this.clipboardService.pasteFromClipboard();
    }
  };
  RowContainerEventsFeature.prototype.onCtrlAndD = function (event) {
    if (ModuleRegistry.isRegistered(ModuleNames.ClipboardModule) && !this.gridOptionsWrapper.isSuppressClipboardPaste()) {
      this.clipboardService.copyRangeDown();
    }
    event.preventDefault();
  };
  __decorate$1d([Autowired('mouseEventService')], RowContainerEventsFeature.prototype, "mouseEventService", void 0);
  __decorate$1d([Autowired('valueService')], RowContainerEventsFeature.prototype, "valueService", void 0);
  __decorate$1d([Optional('contextMenuFactory')], RowContainerEventsFeature.prototype, "contextMenuFactory", void 0);
  __decorate$1d([Autowired('ctrlsService')], RowContainerEventsFeature.prototype, "ctrlsService", void 0);
  __decorate$1d([Autowired('navigationService')], RowContainerEventsFeature.prototype, "navigationService", void 0);
  __decorate$1d([Autowired('focusService')], RowContainerEventsFeature.prototype, "focusService", void 0);
  __decorate$1d([Autowired('undoRedoService')], RowContainerEventsFeature.prototype, "undoRedoService", void 0);
  __decorate$1d([Autowired('columnModel')], RowContainerEventsFeature.prototype, "columnModel", void 0);
  __decorate$1d([Autowired('paginationProxy')], RowContainerEventsFeature.prototype, "paginationProxy", void 0);
  __decorate$1d([Autowired('pinnedRowModel')], RowContainerEventsFeature.prototype, "pinnedRowModel", void 0);
  __decorate$1d([Optional('rangeService')], RowContainerEventsFeature.prototype, "rangeService", void 0);
  __decorate$1d([Optional('clipboardService')], RowContainerEventsFeature.prototype, "clipboardService", void 0);
  __decorate$1d([PostConstruct], RowContainerEventsFeature.prototype, "postConstruct", null);
  return RowContainerEventsFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1q = undefined && undefined.__extends || function () {
  var _extendStatics91 = function extendStatics(d, b) {
    _extendStatics91 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics91(d, b);
  };
  return function (d, b) {
    _extendStatics91(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1e = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// listens to changes in the center viewport size, for column and row virtualisation,
// and adjusts grid as necessary. there are two viewports, one for horizontal and one for
// vertical scrolling.
var ViewportSizeFeature = /** @class */function (_super) {
  __extends$1q(ViewportSizeFeature, _super);
  function ViewportSizeFeature(centerContainer) {
    var _this = _super.call(this) || this;
    _this.centerContainerCon = centerContainer;
    return _this;
  }
  ViewportSizeFeature.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function () {
      _this.gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
      _this.listenForResize();
    });
    this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
  };
  ViewportSizeFeature.prototype.listenForResize = function () {
    var listener = this.onCenterViewportResized.bind(this);
    // centerContainer gets horizontal resizes
    this.centerContainerCon.registerViewportResizeListener(listener);
    // eBodyViewport gets vertical resizes
    this.gridBodyCon.registerBodyViewportResizeListener(listener);
  };
  ViewportSizeFeature.prototype.onScrollbarWidthChanged = function () {
    this.checkViewportAndScrolls();
  };
  ViewportSizeFeature.prototype.onCenterViewportResized = function () {
    if (this.centerContainerCon.isViewportVisible()) {
      this.checkViewportAndScrolls();
      var newWidth = this.centerContainerCon.getCenterWidth();
      if (newWidth !== this.centerWidth) {
        this.centerWidth = newWidth;
        this.columnModel.refreshFlexedColumns({
          viewportWidth: this.centerWidth,
          updateBodyWidths: true,
          fireResizedEvent: true
        });
      }
    } else {
      this.bodyHeight = 0;
    }
  };
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  ViewportSizeFeature.prototype.checkViewportAndScrolls = function () {
    // results in updating anything that depends on scroll showing
    this.updateScrollVisibleService();
    // fires event if height changes, used by PaginationService, HeightScalerService, RowRenderer
    this.checkBodyHeight();
    // check for virtual columns for ColumnController
    this.onHorizontalViewportChanged();
    this.gridBodyCon.getScrollFeature().checkScrollLeft();
  };
  ViewportSizeFeature.prototype.getBodyHeight = function () {
    return this.bodyHeight;
  };
  ViewportSizeFeature.prototype.checkBodyHeight = function () {
    var eBodyViewport = this.gridBodyCon.getBodyViewportElement();
    var bodyHeight = getInnerHeight(eBodyViewport);
    if (this.bodyHeight !== bodyHeight) {
      this.bodyHeight = bodyHeight;
      var event_1 = {
        type: Events.EVENT_BODY_HEIGHT_CHANGED,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  ViewportSizeFeature.prototype.updateScrollVisibleService = function () {
    // because of column animation (which takes 200ms), we have to do this twice.
    // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
    // will animate to the left to fill the gap. this animation means just after
    // the cols are removed, the remaining cols are still in the original location
    // at the start of the animation, so pre animation the H scrollbar is still needed,
    // but post animation it is not.
    this.updateScrollVisibleServiceImpl();
    setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  };
  ViewportSizeFeature.prototype.updateScrollVisibleServiceImpl = function () {
    var params = {
      horizontalScrollShowing: this.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCon.isVerticalScrollShowing()
    };
    this.scrollVisibleService.setScrollsVisible(params);
    // fix - gridComp should just listen to event from above
    this.gridBodyCon.setVerticalScrollPaddingVisible(params.verticalScrollShowing);
  };
  ViewportSizeFeature.prototype.isHorizontalScrollShowing = function () {
    var isAlwaysShowHorizontalScroll = this.gridOptionsWrapper.isAlwaysShowHorizontalScroll();
    return isAlwaysShowHorizontalScroll || this.centerContainerCon.isViewportHScrollShowing();
  };
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
  ViewportSizeFeature.prototype.onHorizontalViewportChanged = function () {
    var scrollWidth = this.centerContainerCon.getCenterWidth();
    var scrollPosition = this.centerContainerCon.getViewportScrollLeft();
    this.columnModel.setViewportPosition(scrollWidth, scrollPosition);
  };
  __decorate$1e([Autowired('ctrlsService')], ViewportSizeFeature.prototype, "ctrlsService", void 0);
  __decorate$1e([Autowired('columnModel')], ViewportSizeFeature.prototype, "columnModel", void 0);
  __decorate$1e([Autowired('scrollVisibleService')], ViewportSizeFeature.prototype, "scrollVisibleService", void 0);
  __decorate$1e([Autowired('columnApi')], ViewportSizeFeature.prototype, "columnApi", void 0);
  __decorate$1e([Autowired('gridApi')], ViewportSizeFeature.prototype, "gridApi", void 0);
  __decorate$1e([PostConstruct], ViewportSizeFeature.prototype, "postConstruct", null);
  return ViewportSizeFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1r = undefined && undefined.__extends || function () {
  var _extendStatics92 = function extendStatics(d, b) {
    _extendStatics92 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics92(d, b);
  };
  return function (d, b) {
    _extendStatics92(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1f = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetPinnedLeftWidthFeature = /** @class */function (_super) {
  __extends$1r(SetPinnedLeftWidthFeature, _super);
  function SetPinnedLeftWidthFeature(element) {
    var _this = _super.call(this) || this;
    _this.element = element;
    return _this;
  }
  SetPinnedLeftWidthFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
  };
  SetPinnedLeftWidthFeature.prototype.onPinnedLeftWidthChanged = function () {
    var leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
    var displayed = leftWidth > 0;
    setDisplayed(this.element, displayed);
    if (displayed) {
      setFixedWidth(this.element, leftWidth);
    }
  };
  __decorate$1f([Autowired('pinnedWidthService')], SetPinnedLeftWidthFeature.prototype, "pinnedWidthService", void 0);
  __decorate$1f([PostConstruct], SetPinnedLeftWidthFeature.prototype, "postConstruct", null);
  return SetPinnedLeftWidthFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1s = undefined && undefined.__extends || function () {
  var _extendStatics93 = function extendStatics(d, b) {
    _extendStatics93 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics93(d, b);
  };
  return function (d, b) {
    _extendStatics93(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1g = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetPinnedRightWidthFeature = /** @class */function (_super) {
  __extends$1s(SetPinnedRightWidthFeature, _super);
  function SetPinnedRightWidthFeature(element) {
    var _this = _super.call(this) || this;
    _this.element = element;
    return _this;
  }
  SetPinnedRightWidthFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
  };
  SetPinnedRightWidthFeature.prototype.onPinnedRightWidthChanged = function () {
    var rightWidth = this.pinnedWidthService.getPinnedRightWidth();
    var displayed = rightWidth > 0;
    setDisplayed(this.element, displayed);
    if (displayed) {
      setFixedWidth(this.element, rightWidth);
    }
  };
  __decorate$1g([Autowired('pinnedWidthService')], SetPinnedRightWidthFeature.prototype, "pinnedWidthService", void 0);
  __decorate$1g([PostConstruct], SetPinnedRightWidthFeature.prototype, "postConstruct", null);
  return SetPinnedRightWidthFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1t = undefined && undefined.__extends || function () {
  var _extendStatics94 = function extendStatics(d, b) {
    _extendStatics94 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics94(d, b);
  };
  return function (d, b) {
    _extendStatics94(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1h = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetHeightFeature = /** @class */function (_super) {
  __extends$1t(SetHeightFeature, _super);
  function SetHeightFeature(eContainer, eWrapper) {
    var _this = _super.call(this) || this;
    _this.eContainer = eContainer;
    _this.eWrapper = eWrapper;
    return _this;
  }
  SetHeightFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
  };
  SetHeightFeature.prototype.onHeightChanged = function () {
    var height = this.maxDivHeightScaler.getUiContainerHeight();
    var heightString = height != null ? height + "px" : "";
    this.eContainer.style.height = heightString;
    if (this.eWrapper) {
      this.eWrapper.style.height = heightString;
    }
  };
  __decorate$1h([Autowired("rowContainerHeightService")], SetHeightFeature.prototype, "maxDivHeightScaler", void 0);
  __decorate$1h([PostConstruct], SetHeightFeature.prototype, "postConstruct", null);
  return SetHeightFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1u = undefined && undefined.__extends || function () {
  var _extendStatics95 = function extendStatics(d, b) {
    _extendStatics95 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics95(d, b);
  };
  return function (d, b) {
    _extendStatics95(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1i = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DragListenerFeature = /** @class */function (_super) {
  __extends$1u(DragListenerFeature, _super);
  function DragListenerFeature(eContainer) {
    var _this = _super.call(this) || this;
    _this.eContainer = eContainer;
    return _this;
  }
  DragListenerFeature.prototype.postConstruct = function () {
    var _this = this;
    if (!this.gridOptionsWrapper.isEnableRangeSelection() ||
    // no range selection if no property
    missing(this.rangeService) // no range selection if not enterprise version
    ) {
      return;
    }
    var params = {
      eElement: this.eContainer,
      onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
      onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
      onDragging: this.rangeService.onDragging.bind(this.rangeService)
    };
    this.dragService.addDragSource(params);
    this.addDestroyFunc(function () {
      return _this.dragService.removeDragSource(params);
    });
  };
  __decorate$1i([Optional('rangeService')], DragListenerFeature.prototype, "rangeService", void 0);
  __decorate$1i([Autowired('dragService')], DragListenerFeature.prototype, "dragService", void 0);
  __decorate$1i([PostConstruct], DragListenerFeature.prototype, "postConstruct", null);
  return DragListenerFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1v = undefined && undefined.__extends || function () {
  var _extendStatics96 = function extendStatics(d, b) {
    _extendStatics96 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics96(d, b);
  };
  return function (d, b) {
    _extendStatics96(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1j = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$a = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var RowContainerName;
(function (RowContainerName) {
  RowContainerName["LEFT"] = "left";
  RowContainerName["RIGHT"] = "right";
  RowContainerName["CENTER"] = "center";
  RowContainerName["FULL_WIDTH"] = "fullWidth";
  RowContainerName["TOP_LEFT"] = "topLeft";
  RowContainerName["TOP_RIGHT"] = "topRight";
  RowContainerName["TOP_CENTER"] = "topCenter";
  RowContainerName["TOP_FULL_WITH"] = "topFullWidth";
  RowContainerName["BOTTOM_LEFT"] = "bottomLeft";
  RowContainerName["BOTTOM_RIGHT"] = "bottomRight";
  RowContainerName["BOTTOM_CENTER"] = "bottomCenter";
  RowContainerName["BOTTOM_FULL_WITH"] = "bottomFullWidth";
})(RowContainerName || (RowContainerName = {}));
var ContainerCssClasses = convertToMap([[RowContainerName.CENTER, 'ag-center-cols-container'], [RowContainerName.LEFT, 'ag-pinned-left-cols-container'], [RowContainerName.RIGHT, 'ag-pinned-right-cols-container'], [RowContainerName.FULL_WIDTH, 'ag-full-width-container'], [RowContainerName.TOP_CENTER, 'ag-floating-top-container'], [RowContainerName.TOP_LEFT, 'ag-pinned-left-floating-top'], [RowContainerName.TOP_RIGHT, 'ag-pinned-right-floating-top'], [RowContainerName.TOP_FULL_WITH, 'ag-floating-top-full-width-container'], [RowContainerName.BOTTOM_CENTER, 'ag-floating-bottom-container'], [RowContainerName.BOTTOM_LEFT, 'ag-pinned-left-floating-bottom'], [RowContainerName.BOTTOM_RIGHT, 'ag-pinned-right-floating-bottom'], [RowContainerName.BOTTOM_FULL_WITH, 'ag-floating-bottom-full-width-container']]);
var ViewportCssClasses = convertToMap([[RowContainerName.CENTER, 'ag-center-cols-viewport'], [RowContainerName.TOP_CENTER, 'ag-floating-top-viewport'], [RowContainerName.BOTTOM_CENTER, 'ag-floating-bottom-viewport']]);
var WrapperCssClasses = convertToMap([[RowContainerName.CENTER, 'ag-center-cols-clipper']]);
var RowContainerCtrl = /** @class */function (_super) {
  __extends$1v(RowContainerCtrl, _super);
  function RowContainerCtrl(name) {
    var _this = _super.call(this) || this;
    _this.name = name;
    return _this;
  }
  RowContainerCtrl.getRowContainerCssClasses = function (name) {
    var containerClass = ContainerCssClasses.get(name);
    var viewportClass = ViewportCssClasses.get(name);
    var wrapperClass = WrapperCssClasses.get(name);
    return {
      container: containerClass,
      viewport: viewportClass,
      wrapper: wrapperClass
    };
  };
  RowContainerCtrl.getPinned = function (name) {
    switch (name) {
      case RowContainerName.BOTTOM_LEFT:
      case RowContainerName.TOP_LEFT:
      case RowContainerName.LEFT:
        return Constants.PINNED_LEFT;
      case RowContainerName.BOTTOM_RIGHT:
      case RowContainerName.TOP_RIGHT:
      case RowContainerName.RIGHT:
        return Constants.PINNED_RIGHT;
      default:
        return null;
    }
  };
  RowContainerCtrl.prototype.postConstruct = function () {
    var _this = this;
    this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
    this.embedFullWidthRows = this.gridOptionsWrapper.isEmbedFullWidthRows();
    this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_ROWS_CHANGED, this.onDisplayedRowsChanged.bind(this));
    this.forContainers([RowContainerName.CENTER], function () {
      return _this.viewportSizeFeature = _this.createManagedBean(new ViewportSizeFeature(_this));
    });
    this.registerWithCtrlsService();
  };
  RowContainerCtrl.prototype.registerWithCtrlsService = function () {
    switch (this.name) {
      case RowContainerName.CENTER:
        this.ctrlsService.registerCenterRowContainerCtrl(this);
        break;
      case RowContainerName.LEFT:
        this.ctrlsService.registerLeftRowContainerCtrl(this);
        break;
      case RowContainerName.RIGHT:
        this.ctrlsService.registerRightRowContainerCtrl(this);
        break;
      case RowContainerName.TOP_CENTER:
        this.ctrlsService.registerTopCenterRowContainerCtrl(this);
        break;
      case RowContainerName.TOP_LEFT:
        this.ctrlsService.registerTopLeftRowContainerCon(this);
        break;
      case RowContainerName.TOP_RIGHT:
        this.ctrlsService.registerTopRightRowContainerCtrl(this);
        break;
      case RowContainerName.BOTTOM_CENTER:
        this.ctrlsService.registerBottomCenterRowContainerCtrl(this);
        break;
      case RowContainerName.BOTTOM_LEFT:
        this.ctrlsService.registerBottomLeftRowContainerCtrl(this);
        break;
      case RowContainerName.BOTTOM_RIGHT:
        this.ctrlsService.registerBottomRightRowContainerCtrl(this);
        break;
    }
  };
  RowContainerCtrl.prototype.forContainers = function (names, callback) {
    if (names.indexOf(this.name) >= 0) {
      callback();
    }
  };
  RowContainerCtrl.prototype.getContainerElement = function () {
    return this.eContainer;
  };
  RowContainerCtrl.prototype.getViewportSizeFeature = function () {
    return this.viewportSizeFeature;
  };
  RowContainerCtrl.prototype.setComp = function (view, eContainer, eViewport, eWrapper) {
    var _this = this;
    this.comp = view;
    this.eContainer = eContainer;
    this.eViewport = eViewport;
    this.eWrapper = eWrapper;
    this.createManagedBean(new RowContainerEventsFeature(this.eContainer));
    this.addPreventScrollWhileDragging();
    this.listenOnDomOrder();
    this.stopHScrollOnPinnedRows();
    var allTopNoFW = [RowContainerName.TOP_CENTER, RowContainerName.TOP_LEFT, RowContainerName.TOP_RIGHT];
    var allBottomNoFW = [RowContainerName.BOTTOM_CENTER, RowContainerName.BOTTOM_LEFT, RowContainerName.BOTTOM_RIGHT];
    var allMiddleNoFW = [RowContainerName.CENTER, RowContainerName.LEFT, RowContainerName.RIGHT];
    var allNoFW = __spreadArrays$a(allTopNoFW, allBottomNoFW, allMiddleNoFW);
    var allMiddle = [RowContainerName.CENTER, RowContainerName.LEFT, RowContainerName.RIGHT, RowContainerName.FULL_WIDTH];
    var allCenter = [RowContainerName.CENTER, RowContainerName.TOP_CENTER, RowContainerName.BOTTOM_CENTER];
    var allLeft = [RowContainerName.LEFT, RowContainerName.BOTTOM_LEFT, RowContainerName.TOP_LEFT];
    var allRight = [RowContainerName.RIGHT, RowContainerName.BOTTOM_RIGHT, RowContainerName.TOP_RIGHT];
    this.forContainers(allLeft, function () {
      return _this.createManagedBean(new SetPinnedLeftWidthFeature(_this.eContainer));
    });
    this.forContainers(allRight, function () {
      return _this.createManagedBean(new SetPinnedRightWidthFeature(_this.eContainer));
    });
    this.forContainers(allMiddle, function () {
      return _this.createManagedBean(new SetHeightFeature(_this.eContainer, _this.eWrapper));
    });
    this.forContainers(allNoFW, function () {
      return _this.createManagedBean(new DragListenerFeature(_this.eContainer));
    });
    this.forContainers(allCenter, function () {
      return _this.createManagedBean(new CenterWidthFeature(function (width) {
        return _this.comp.setContainerWidth(width + "px");
      }));
    });
  };
  RowContainerCtrl.prototype.listenOnDomOrder = function () {
    var _this = this;
    var listener = function listener() {
      return _this.comp.setDomOrder(_this.gridOptionsWrapper.isEnsureDomOrder());
    };
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
    listener();
  };
  // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
  // scroll the column into view. we do not want this, the pinned sections should never scroll.
  // so we listen to scrolls on these containers and reset the scroll if we find one.
  RowContainerCtrl.prototype.stopHScrollOnPinnedRows = function () {
    var _this = this;
    this.forContainers([RowContainerName.TOP_CENTER, RowContainerName.BOTTOM_CENTER], function () {
      var resetScrollLeft = function resetScrollLeft() {
        return _this.eViewport.scrollLeft = 0;
      };
      _this.addManagedListener(_this.eViewport, 'scroll', resetScrollLeft);
    });
  };
  RowContainerCtrl.prototype.onDisplayedColumnsChanged = function () {
    var _this = this;
    this.forContainers([RowContainerName.CENTER], function () {
      return _this.onHorizontalViewportChanged();
    });
  };
  RowContainerCtrl.prototype.onDisplayedColumnsWidthChanged = function () {
    var _this = this;
    this.forContainers([RowContainerName.CENTER], function () {
      return _this.onHorizontalViewportChanged();
    });
  };
  RowContainerCtrl.prototype.onScrollVisibilityChanged = function () {
    if (this.name !== RowContainerName.CENTER) {
      return;
    }
    var visible = this.scrollVisibleService.isHorizontalScrollShowing();
    var scrollbarWidth = visible ? this.gridOptionsWrapper.getScrollbarWidth() || 0 : 0;
    var height = scrollbarWidth == 0 ? '100%' : "calc(100% + " + scrollbarWidth + "px)";
    this.comp.setViewportHeight(height);
  };
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  RowContainerCtrl.prototype.addPreventScrollWhileDragging = function () {
    var _this = this;
    var preventScroll = function preventScroll(e) {
      if (_this.dragService.isDragging()) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }
    };
    this.eContainer.addEventListener('touchmove', preventScroll, {
      passive: false
    });
    this.addDestroyFunc(function () {
      return _this.eContainer.removeEventListener('touchmove', preventScroll);
    });
  };
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged, API (doLayout)
  RowContainerCtrl.prototype.onHorizontalViewportChanged = function () {
    var scrollWidth = this.getCenterWidth();
    var scrollPosition = this.getCenterViewportScrollLeft();
    this.columnModel.setViewportPosition(scrollWidth, scrollPosition);
  };
  RowContainerCtrl.prototype.getCenterWidth = function () {
    return getInnerWidth(this.eViewport);
  };
  RowContainerCtrl.prototype.getCenterViewportScrollLeft = function () {
    // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
    return getScrollLeft(this.eViewport, this.enableRtl);
  };
  RowContainerCtrl.prototype.registerViewportResizeListener = function (listener) {
    var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eViewport, listener);
    this.addDestroyFunc(function () {
      return unsubscribeFromResize();
    });
  };
  RowContainerCtrl.prototype.isViewportVisible = function () {
    return isVisible(this.eViewport);
  };
  RowContainerCtrl.prototype.isViewportHScrollShowing = function () {
    return isHorizontalScrollShowing(this.eViewport);
  };
  RowContainerCtrl.prototype.getViewportScrollLeft = function () {
    return getScrollLeft(this.eViewport, this.enableRtl);
  };
  RowContainerCtrl.prototype.isHorizontalScrollShowing = function () {
    var isAlwaysShowHorizontalScroll = this.gridOptionsWrapper.isAlwaysShowHorizontalScroll();
    return isAlwaysShowHorizontalScroll || isHorizontalScrollShowing(this.eViewport);
  };
  RowContainerCtrl.prototype.getViewportElement = function () {
    return this.eViewport;
  };
  RowContainerCtrl.prototype.setContainerTranslateX = function (amount) {
    this.eContainer.style.transform = "translateX(" + amount + "px)";
  };
  RowContainerCtrl.prototype.getHScrollPosition = function () {
    var res = {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
    return res;
  };
  RowContainerCtrl.prototype.setCenterViewportScrollLeft = function (value) {
    // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
    setScrollLeft(this.eViewport, value, this.enableRtl);
  };
  RowContainerCtrl.prototype.onDisplayedRowsChanged = function () {
    var _this = this;
    var fullWithContainer = this.name === RowContainerName.TOP_FULL_WITH || this.name === RowContainerName.BOTTOM_FULL_WITH || this.name === RowContainerName.FULL_WIDTH;
    var doesRowMatch = function doesRowMatch(rowCtrl) {
      var fullWidthRow = rowCtrl.isFullWidth();
      var printLayout = _this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
      var embedFW = _this.embedFullWidthRows || printLayout;
      var match = fullWithContainer ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
      return match;
    };
    // this list contains either all pinned top, center or pinned bottom rows
    var allRowsRegardlessOfFullWidth = this.getRowCtrls();
    // this filters out rows not for this container, eg if it's a full with row, but we are not full with container
    var rowsThisContainer = allRowsRegardlessOfFullWidth.filter(doesRowMatch);
    this.comp.setRowCtrls(rowsThisContainer);
  };
  RowContainerCtrl.prototype.getRowCtrls = function () {
    switch (this.name) {
      case RowContainerName.TOP_CENTER:
      case RowContainerName.TOP_LEFT:
      case RowContainerName.TOP_RIGHT:
      case RowContainerName.TOP_FULL_WITH:
        return this.rowRenderer.getTopRowCtrls();
      case RowContainerName.BOTTOM_CENTER:
      case RowContainerName.BOTTOM_LEFT:
      case RowContainerName.BOTTOM_RIGHT:
      case RowContainerName.BOTTOM_FULL_WITH:
        return this.rowRenderer.getBottomRowCtrls();
      default:
        return this.rowRenderer.getRowCtrls();
    }
  };
  __decorate$1j([Autowired('scrollVisibleService')], RowContainerCtrl.prototype, "scrollVisibleService", void 0);
  __decorate$1j([Autowired('dragService')], RowContainerCtrl.prototype, "dragService", void 0);
  __decorate$1j([Autowired('ctrlsService')], RowContainerCtrl.prototype, "ctrlsService", void 0);
  __decorate$1j([Autowired('columnModel')], RowContainerCtrl.prototype, "columnModel", void 0);
  __decorate$1j([Autowired('resizeObserverService')], RowContainerCtrl.prototype, "resizeObserverService", void 0);
  __decorate$1j([Autowired('rowRenderer')], RowContainerCtrl.prototype, "rowRenderer", void 0);
  __decorate$1j([PostConstruct], RowContainerCtrl.prototype, "postConstruct", null);
  return RowContainerCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1w = undefined && undefined.__extends || function () {
  var _extendStatics97 = function extendStatics(d, b) {
    _extendStatics97 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics97(d, b);
  };
  return function (d, b) {
    _extendStatics97(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1k = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GRID_BODY_TEMPLATE = /* html */"<div class=\"ag-root ag-unselectable\" role=\"grid\" unselectable=\"on\">\n        <ag-header-root ref=\"gridHeader\" unselectable=\"on\"></ag-header-root>\n        <div class=\"ag-floating-top\" ref=\"eTop\" role=\"presentation\" unselectable=\"on\">\n            <ag-row-container ref=\"topLeftContainer\" name=\"" + RowContainerName.TOP_LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"topCenterContainer\" name=\"" + RowContainerName.TOP_CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"topRightContainer\" name=\"" + RowContainerName.TOP_RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"topFullWidthContainer\" name=\"" + RowContainerName.TOP_FULL_WITH + "\"></ag-row-container>\n        </div>\n        <div class=\"ag-body-viewport\" ref=\"eBodyViewport\" role=\"presentation\">\n            <ag-row-container ref=\"leftContainer\" name=\"" + RowContainerName.LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"centerContainer\" name=\"" + RowContainerName.CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"rightContainer\" name=\"" + RowContainerName.RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"fullWidthContainer\" name=\"" + RowContainerName.FULL_WIDTH + "\"></ag-row-container>\n        </div>\n        <div class=\"ag-floating-bottom\" ref=\"eBottom\" role=\"presentation\" unselectable=\"on\">\n            <ag-row-container ref=\"bottomLeftContainer\" name=\"" + RowContainerName.BOTTOM_LEFT + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomCenterContainer\" name=\"" + RowContainerName.BOTTOM_CENTER + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomRightContainer\" name=\"" + RowContainerName.BOTTOM_RIGHT + "\"></ag-row-container>\n            <ag-row-container ref=\"bottomFullWidthContainer\" name=\"" + RowContainerName.BOTTOM_FULL_WITH + "\"></ag-row-container>\n        </div>\n        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>\n        <ag-overlay-wrapper></ag-overlay-wrapper>\n    </div>";
var GridBodyComp = /** @class */function (_super) {
  __extends$1w(GridBodyComp, _super);
  function GridBodyComp() {
    return _super.call(this, GRID_BODY_TEMPLATE) || this;
  }
  GridBodyComp.prototype.init = function () {
    var _this = this;
    var setHeight = function setHeight(height, element) {
      var heightString = height + "px";
      element.style.minHeight = heightString;
      element.style.height = heightString;
    };
    var compProxy = {
      setRowAnimationCssOnBodyViewport: function setRowAnimationCssOnBodyViewport(cssClass, animate) {
        return _this.setRowAnimationCssOnBodyViewport(cssClass, animate);
      },
      setColumnCount: function setColumnCount(count) {
        return setAriaColCount(_this.getGui(), count);
      },
      setRowCount: function setRowCount(count) {
        return setAriaRowCount(_this.getGui(), count);
      },
      setTopHeight: function setTopHeight(height) {
        return setHeight(height, _this.eTop);
      },
      setBottomHeight: function setBottomHeight(height) {
        return setHeight(height, _this.eBottom);
      },
      setTopDisplay: function setTopDisplay(display) {
        return _this.eTop.style.display = display;
      },
      setBottomDisplay: function setBottomDisplay(display) {
        return _this.eBottom.style.display = display;
      },
      setColumnMovingCss: function setColumnMovingCss(cssClass, flag) {
        return _this.addOrRemoveCssClass(CSS_CLASS_COLUMN_MOVING, flag);
      },
      updateLayoutClasses: function updateLayoutClasses(cssClass, params) {
        addOrRemoveCssClass(_this.eBodyViewport, LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
        addOrRemoveCssClass(_this.eBodyViewport, LayoutCssClasses.NORMAL, params.normal);
        addOrRemoveCssClass(_this.eBodyViewport, LayoutCssClasses.PRINT, params.print);
        _this.addOrRemoveCssClass(LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
        _this.addOrRemoveCssClass(LayoutCssClasses.NORMAL, params.normal);
        _this.addOrRemoveCssClass(LayoutCssClasses.PRINT, params.print);
      },
      setAlwaysVerticalScrollClass: function setAlwaysVerticalScrollClass(cssClass, on) {
        return addOrRemoveCssClass(_this.eBodyViewport, CSS_CLASS_FORCE_VERTICAL_SCROLL, on);
      },
      registerBodyViewportResizeListener: function registerBodyViewportResizeListener(listener) {
        var unsubscribeFromResize = _this.resizeObserverService.observeResize(_this.eBodyViewport, listener);
        _this.addDestroyFunc(function () {
          return unsubscribeFromResize();
        });
      },
      setPinnedTopBottomOverflowY: function setPinnedTopBottomOverflowY(overflow) {
        return _this.eTop.style.overflowY = _this.eBottom.style.overflowY = overflow;
      },
      setCellSelectableCss: function setCellSelectableCss(cssClass, selectable) {
        [_this.eTop, _this.eBodyViewport, _this.eBottom].forEach(function (ct) {
          return addOrRemoveCssClass(ct, CSS_CLASS_CELL_SELECTABLE, selectable);
        });
      }
    };
    this.ctrl = this.createManagedBean(new GridBodyCtrl());
    this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom);
    if (this.rangeService || this.gridOptionsWrapper.isRowSelectionMulti()) {
      setAriaMultiSelectable(this.getGui(), true);
    }
  };
  GridBodyComp.prototype.setRowAnimationCssOnBodyViewport = function (cssClass, animateRows) {
    addOrRemoveCssClass(this.eBodyViewport, RowAnimationCssClasses.ANIMATION_ON, animateRows);
    addOrRemoveCssClass(this.eBodyViewport, RowAnimationCssClasses.ANIMATION_OFF, !animateRows);
  };
  GridBodyComp.prototype.getFloatingTopBottom = function () {
    return [this.eTop, this.eBottom];
  };
  __decorate$1k([Autowired('resizeObserverService')], GridBodyComp.prototype, "resizeObserverService", void 0);
  __decorate$1k([Optional('rangeService')], GridBodyComp.prototype, "rangeService", void 0);
  __decorate$1k([RefSelector('eBodyViewport')], GridBodyComp.prototype, "eBodyViewport", void 0);
  __decorate$1k([RefSelector('eTop')], GridBodyComp.prototype, "eTop", void 0);
  __decorate$1k([RefSelector('eBottom')], GridBodyComp.prototype, "eBottom", void 0);
  __decorate$1k([RefSelector('gridHeader')], GridBodyComp.prototype, "headerRootComp", void 0);
  __decorate$1k([PostConstruct], GridBodyComp.prototype, "init", null);
  return GridBodyComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// Excel Export
var ExcelFactoryMode;
(function (ExcelFactoryMode) {
  ExcelFactoryMode[ExcelFactoryMode["SINGLE_SHEET"] = 0] = "SINGLE_SHEET";
  ExcelFactoryMode[ExcelFactoryMode["MULTI_SHEET"] = 1] = "MULTI_SHEET";
})(ExcelFactoryMode || (ExcelFactoryMode = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ClientSideRowModelSteps;
(function (ClientSideRowModelSteps) {
  ClientSideRowModelSteps["EVERYTHING"] = "group";
  ClientSideRowModelSteps["FILTER"] = "filter";
  ClientSideRowModelSteps["SORT"] = "sort";
  ClientSideRowModelSteps["MAP"] = "map";
  ClientSideRowModelSteps["AGGREGATE"] = "aggregate";
  ClientSideRowModelSteps["PIVOT"] = "pivot";
  ClientSideRowModelSteps["NOTHING"] = "nothing";
})(ClientSideRowModelSteps || (ClientSideRowModelSteps = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$1l = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridApi = /** @class */function () {
  function GridApi() {
    this.detailGridInfoMap = {};
    this.destroyCalled = false;
  }
  GridApi.prototype.registerOverlayWrapperComp = function (overlayWrapperComp) {
    this.overlayWrapperComp = overlayWrapperComp;
  };
  GridApi.prototype.registerSideBarComp = function (sideBarComp) {
    this.sideBarComp = sideBarComp;
  };
  GridApi.prototype.init = function () {
    var _this = this;
    switch (this.rowModel.getType()) {
      case Constants.ROW_MODEL_TYPE_CLIENT_SIDE:
        this.clientSideRowModel = this.rowModel;
        break;
      case Constants.ROW_MODEL_TYPE_INFINITE:
        this.infiniteRowModel = this.rowModel;
        break;
      case Constants.ROW_MODEL_TYPE_SERVER_SIDE:
        this.serverSideRowModel = this.rowModel;
        break;
    }
    this.ctrlsService.whenReady(function () {
      _this.gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
    });
  };
  /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
  GridApi.prototype.__getAlignedGridService = function () {
    return this.alignedGridsService;
  };
  /** Register a detail grid with the master grid when it is created. */
  GridApi.prototype.addDetailGridInfo = function (id, gridInfo) {
    this.detailGridInfoMap[id] = gridInfo;
  };
  /** Unregister a detail grid from the master grid when it is destroyed. */
  GridApi.prototype.removeDetailGridInfo = function (id) {
    this.detailGridInfoMap[id] = undefined;
  };
  /** Returns the `DetailGridInfo` corresponding to the supplied `detailGridId`. */
  GridApi.prototype.getDetailGridInfo = function (id) {
    return this.detailGridInfoMap[id];
  };
  /** Iterates through each `DetailGridInfo` in the grid and calls the supplied callback on each. */
  GridApi.prototype.forEachDetailGridInfo = function (callback) {
    var index = 0;
    iterateObject(this.detailGridInfoMap, function (id, gridInfo) {
      // check for undefined, as old references will still be lying around
      if (exists(gridInfo)) {
        callback(gridInfo, index);
        index++;
      }
    });
  };
  /** Similar to `exportDataAsCsv`, except returns the result as a string rather than download it. */
  GridApi.prototype.getDataAsCsv = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.CsvExportModule, 'api.getDataAsCsv')) {
      return this.csvCreator.getDataAsCsv(params);
    }
  };
  /** Downloads a CSV export of the grid's data. */
  GridApi.prototype.exportDataAsCsv = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.CsvExportModule, 'api.exportDataAsCSv')) {
      this.csvCreator.exportDataAsCsv(params);
    }
  };
  /** Similar to `exportDataAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */
  GridApi.prototype.getDataAsExcel = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.ExcelExportModule, 'api.getDataAsExcel')) {
      var exportMode = params && params.exportMode || 'xlsx';
      if (this.excelCreator.getFactoryMode(exportMode) === ExcelFactoryMode.MULTI_SHEET) {
        console.warn('AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling `api.getMultipleSheetAsExcel()` or `api.exportMultipleSheetsAsExcel()`');
        return;
      }
      return this.excelCreator.getDataAsExcel(params);
    }
  };
  /** Downloads an Excel export of the grid's data. */
  GridApi.prototype.exportDataAsExcel = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.ExcelExportModule, 'api.exportDataAsExcel')) {
      var exportMode = params && params.exportMode || 'xlsx';
      if (this.excelCreator.getFactoryMode(exportMode) === ExcelFactoryMode.MULTI_SHEET) {
        console.warn('AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling `api.getMultipleSheetAsExcel()` or `api.exportMultipleSheetsAsExcel()`');
        return;
      }
      this.excelCreator.exportDataAsExcel(params);
    }
  };
  /** This is method to be used to get the grid's data as a sheet, that will later be exported either by `getMultipleSheetsAsExcel()` or `exportMultipleSheetsAsExcel()`. */
  GridApi.prototype.getSheetDataForExcel = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.ExcelExportModule, 'api.getSheetDataForExcel')) {
      var exportMode = params && params.exportMode || 'xlsx';
      this.excelCreator.setFactoryMode(ExcelFactoryMode.MULTI_SHEET, exportMode);
      return this.excelCreator.getSheetDataForExcel(params);
    }
  };
  /** Similar to `exportMultipleSheetsAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */
  GridApi.prototype.getMultipleSheetsAsExcel = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.ExcelExportModule, 'api.getMultipleSheetsAsExcel')) {
      return this.excelCreator.getMultipleSheetsAsExcel(params);
    }
  };
  /** Downloads an Excel export of multiple sheets in one file. */
  GridApi.prototype.exportMultipleSheetsAsExcel = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.ExcelExportModule, 'api.exportMultipleSheetsAsExcel')) {
      return this.excelCreator.exportMultipleSheetsAsExcel(params);
    }
  };
  /** @deprecated */
  GridApi.prototype.setEnterpriseDatasource = function (datasource) {
    console.warn("ag-grid: since version 18.x, api.setEnterpriseDatasource() should be replaced with api.setServerSideDatasource()");
    this.setServerSideDatasource(datasource);
  };
  /**
   * Sets an ARIA property in the grid panel (element with `role=\"grid\"`), and removes an ARIA property when the value is null.
   *
   * Example: `api.setGridAriaProperty('label', 'my grid')` will set `aria-label=\"my grid\"`.
   *
   * `api.setGridAriaProperty('label', null)` will remove the `aria-label` attribute from the grid element.
   */
  GridApi.prototype.setGridAriaProperty = function (property, value) {
    if (!property) {
      return;
    }
    var eGrid = this.ctrlsService.getGridBodyCtrl().getGui();
    var ariaProperty = "aria-" + property;
    if (value === null) {
      eGrid.removeAttribute(ariaProperty);
    } else {
      eGrid.setAttribute(ariaProperty, value);
    }
  };
  /** Set new datasource for Server-Side Row Model. */
  GridApi.prototype.setServerSideDatasource = function (datasource) {
    if (this.serverSideRowModel) {
      // should really have an IEnterpriseRowModel interface, so we are not casting to any
      this.serverSideRowModel.setDatasource(datasource);
    } else {
      console.warn("AG Grid: you can only use an enterprise datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_SERVER_SIDE + "'");
    }
  };
  /** Set new datasource for Infinite Row Model. */
  GridApi.prototype.setDatasource = function (datasource) {
    if (this.gridOptionsWrapper.isRowModelInfinite()) {
      this.rowModel.setDatasource(datasource);
    } else {
      console.warn("AG Grid: you can only use a datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_INFINITE + "'");
    }
  };
  /** Set new datasource for Viewport Row Model. */
  GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
    if (this.gridOptionsWrapper.isRowModelViewport()) {
      // this is bad coding, because it's using an interface that's exposed in the enterprise.
      // really we should create an interface in the core for viewportDatasource and let
      // the enterprise implement it, rather than casting to 'any' here
      this.rowModel.setViewportDatasource(viewportDatasource);
    } else {
      console.warn("AG Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
    }
  };
  /** Set the row data. */
  GridApi.prototype.setRowData = function (rowData) {
    if (this.gridOptionsWrapper.isRowModelDefault()) {
      if (this.gridOptionsWrapper.isImmutableData()) {
        var transactionAndMap = this.immutableService.createTransactionForRowData(rowData);
        if (!transactionAndMap) {
          return;
        }
        var transaction = transactionAndMap[0],
          orderIdMap = transactionAndMap[1];
        var nodeTransaction = this.clientSideRowModel.updateRowData(transaction, orderIdMap);
        // need to force updating of full width rows - note this wouldn't be necessary the full width cell comp listened
        // to the data change event on the row node and refreshed itself.
        if (nodeTransaction) {
          this.rowRenderer.refreshFullWidthRows(nodeTransaction.update);
        }
      } else {
        this.selectionService.reset();
        this.clientSideRowModel.setRowData(rowData);
      }
    } else {
      console.warn('cannot call setRowData unless using normal row model');
    }
  };
  /** @deprecated */
  GridApi.prototype.setFloatingTopRowData = function (rows) {
    console.warn('AG Grid: since v12, api.setFloatingTopRowData() is now api.setPinnedTopRowData()');
    this.setPinnedTopRowData(rows);
  };
  /** @deprecated */
  GridApi.prototype.setFloatingBottomRowData = function (rows) {
    console.warn('AG Grid: since v12, api.setFloatingBottomRowData() is now api.setPinnedBottomRowData()');
    this.setPinnedBottomRowData(rows);
  };
  /** @deprecated */
  GridApi.prototype.getFloatingTopRowCount = function () {
    console.warn('AG Grid: since v12, api.getFloatingTopRowCount() is now api.getPinnedTopRowCount()');
    return this.getPinnedTopRowCount();
  };
  /** @deprecated */
  GridApi.prototype.getFloatingBottomRowCount = function () {
    console.warn('AG Grid: since v12, api.getFloatingBottomRowCount() is now api.getPinnedBottomRowCount()');
    return this.getPinnedBottomRowCount();
  };
  /** @deprecated */
  GridApi.prototype.getFloatingTopRow = function (index) {
    console.warn('AG Grid: since v12, api.getFloatingTopRow() is now api.getPinnedTopRow()');
    return this.getPinnedTopRow(index);
  };
  /** @deprecated */
  GridApi.prototype.getFloatingBottomRow = function (index) {
    console.warn('AG Grid: since v12, api.getFloatingBottomRow() is now api.getPinnedBottomRow()');
    return this.getPinnedBottomRow(index);
  };
  /** Set the top pinned rows. */
  GridApi.prototype.setPinnedTopRowData = function (rows) {
    this.pinnedRowModel.setPinnedTopRowData(rows);
  };
  /** Set the bottom pinned rows. */
  GridApi.prototype.setPinnedBottomRowData = function (rows) {
    this.pinnedRowModel.setPinnedBottomRowData(rows);
  };
  /** Gets the number of top pinned rows. */
  GridApi.prototype.getPinnedTopRowCount = function () {
    return this.pinnedRowModel.getPinnedTopRowCount();
  };
  /** Gets the number of bottom pinned rows. */
  GridApi.prototype.getPinnedBottomRowCount = function () {
    return this.pinnedRowModel.getPinnedBottomRowCount();
  };
  /** Gets the top pinned row with the specified index. */
  GridApi.prototype.getPinnedTopRow = function (index) {
    return this.pinnedRowModel.getPinnedTopRow(index);
  };
  /** Gets the top pinned row with the specified index. */
  GridApi.prototype.getPinnedBottomRow = function (index) {
    return this.pinnedRowModel.getPinnedBottomRow(index);
  };
  /**
   * Call to set new column definitions. The grid will redraw all the column headers, and then redraw all of the rows.
   */
  GridApi.prototype.setColumnDefs = function (colDefs, source) {
    if (source === void 0) {
      source = "api";
    }
    this.columnModel.setColumnDefs(colDefs, source);
  };
  /** Call to set new auto group column definition. The grid will recreate any auto-group columns if present. */
  GridApi.prototype.setAutoGroupColumnDef = function (colDef, source) {
    this.gridOptionsWrapper.setProperty('autoGroupColumnDef', colDef, true);
  };
  GridApi.prototype.expireValueCache = function () {
    this.valueCache.expire();
  };
  /**
   * Returns an object with two properties:
   *  - `top`: The top pixel position of the current scroll in the grid
   *  - `bottom`: The bottom pixel position of the current scroll in the grid
   */
  GridApi.prototype.getVerticalPixelRange = function () {
    return this.gridBodyCon.getScrollFeature().getVScrollPosition();
  };
  /**
   * Returns an object with two properties:
   * - `left`: The left pixel position of the current scroll in the grid
   * - `right`: The right pixel position of the current scroll in the grid
   */
  GridApi.prototype.getHorizontalPixelRange = function () {
    return this.gridBodyCon.getScrollFeature().getHScrollPosition();
  };
  /** If `true`, the horizontal scrollbar will always be present, even if not required. Otherwise, it will only be displayed when necessary. */
  GridApi.prototype.setAlwaysShowHorizontalScroll = function (show) {
    this.gridOptionsWrapper.setProperty('alwaysShowHorizontalScroll', show);
  };
  /** If `true`, the vertical scrollbar will always be present, even if not required. Otherwise it will only be displayed when necessary. */
  GridApi.prototype.setAlwaysShowVerticalScroll = function (show) {
    this.gridOptionsWrapper.setProperty('alwaysShowVerticalScroll', show);
  };
  /** Force refresh all tool panels by calling their `refresh` method. */
  GridApi.prototype.refreshToolPanel = function () {
    if (!this.sideBarComp) {
      return;
    }
    this.sideBarComp.refresh();
  };
  /** Performs change detection on all cells, refreshing cells where required. */
  GridApi.prototype.refreshCells = function (params) {
    if (params === void 0) {
      params = {};
    }
    if (Array.isArray(params)) {
      // the old version of refreshCells() took an array of rowNodes for the first argument
      console.warn('since AG Grid v11.1, refreshCells() now takes parameters, please see the documentation.');
      return;
    }
    this.rowRenderer.refreshCells(params);
  };
  /** Flash rows, columns or individual cells. */
  GridApi.prototype.flashCells = function (params) {
    if (params === void 0) {
      params = {};
    }
    this.rowRenderer.flashCells(params);
  };
  /** Remove row(s) from the DOM and recreate them again from scratch. */
  GridApi.prototype.redrawRows = function (params) {
    if (params === void 0) {
      params = {};
    }
    var rowNodes = params ? params.rowNodes : undefined;
    this.rowRenderer.redrawRows(rowNodes);
  };
  /** @deprecated */
  GridApi.prototype.refreshView = function () {
    console.warn('AG Grid: since v11.1, refreshView() is deprecated, please call refreshCells() or redrawRows() instead');
    this.redrawRows();
  };
  /** @deprecated */
  GridApi.prototype.refreshRows = function (rowNodes) {
    console.warn('since AG Grid v11.1, refreshRows() is deprecated, please use refreshCells({rowNodes: rows}) or redrawRows({rowNodes: rows}) instead');
    this.refreshCells({
      rowNodes: rowNodes
    });
  };
  /** @deprecated */
  GridApi.prototype.rowDataChanged = function (rows) {
    console.warn('AG Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
    this.redrawRows();
  };
  /** @deprecated */
  GridApi.prototype.softRefreshView = function () {
    console.error('AG Grid: since v16, softRefreshView() is no longer supported. Please check the documentation on how to refresh.');
  };
  /** @deprecated */
  GridApi.prototype.refreshGroupRows = function () {
    console.warn('AG Grid: since v11.1, refreshGroupRows() is no longer supported, call refreshCells() instead. ' + 'Because refreshCells() now does dirty checking, it will only refresh cells that have changed, so it should ' + 'not be necessary to only refresh the group rows.');
    this.refreshCells();
  };
  GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
    this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
  };
  /** Redraws the header. Useful if a column name changes, or something else that changes how the column header is displayed. */
  GridApi.prototype.refreshHeader = function () {
    this.ctrlsService.getHeaderRowContainerCtrls().forEach(function (c) {
      return c.refresh();
    });
  };
  /** Returns `true` if any filter is set. This includes quick filter, advanced filter or external filter. */
  GridApi.prototype.isAnyFilterPresent = function () {
    return this.filterManager.isAnyFilterPresent();
  };
  /** @deprecated */
  GridApi.prototype.isAdvancedFilterPresent = function () {
    console.warn('AG Grid: isAdvancedFilterPresent() is deprecated, please use isColumnFilterPresent()');
    return this.isColumnFilterPresent();
  };
  /** Returns `true` if any column filter is set, otherwise `false`. */
  GridApi.prototype.isColumnFilterPresent = function () {
    return this.filterManager.isAdvancedFilterPresent();
  };
  /** Returns `true` if the quick filter is set, otherwise `false`. */
  GridApi.prototype.isQuickFilterPresent = function () {
    return this.filterManager.isQuickFilterPresent();
  };
  /**
   * Returns the row model inside the table.
   * From here you can see the original rows, rows after filter has been applied,
   * rows after aggregation has been applied, and the final set of 'to be displayed' rows.
   */
  GridApi.prototype.getModel = function () {
    return this.rowModel;
  };
  /** Expand or collapse a specific row node. */
  GridApi.prototype.setRowNodeExpanded = function (rowNode, expanded) {
    if (rowNode) {
      rowNode.setExpanded(expanded);
    }
  };
  /**
   *  If after getting the model, you expand or collapse a group, call this method to inform the grid.
   *  It will work out the final set of 'to be displayed' rows again (i.e. expand or collapse the group visually).
   */
  GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
    if (missing(this.clientSideRowModel)) {
      console.warn('AG Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
    }
    if (exists(deprecated_refreshFromIndex)) {
      console.warn('AG Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is no longer used, the grid will refresh all rows');
    }
    // we don't really want the user calling this if only one rowNode was expanded, instead they should be
    // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
    // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
    // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
    this.clientSideRowModel.refreshModel({
      step: ClientSideRowModelSteps.MAP
    });
  };
  GridApi.prototype.refreshInMemoryRowModel = function (step) {
    console.warn("ag-grid: since version 18.x, api.refreshInMemoryRowModel() should be replaced with api.refreshClientSideRowModel()");
    this.refreshClientSideRowModel(step);
  };
  /** Gets the Client-Side Row Model to refresh, executing the grouping, filtering and sorting again. */
  GridApi.prototype.refreshClientSideRowModel = function (step) {
    if (missing(this.clientSideRowModel)) {
      console.warn('cannot call refreshClientSideRowModel unless using normal row model');
    }
    var paramsStep = ClientSideRowModelSteps.EVERYTHING;
    var stepsMapped = {
      group: ClientSideRowModelSteps.EVERYTHING,
      filter: ClientSideRowModelSteps.FILTER,
      map: ClientSideRowModelSteps.MAP,
      aggregate: ClientSideRowModelSteps.AGGREGATE,
      sort: ClientSideRowModelSteps.SORT,
      pivot: ClientSideRowModelSteps.PIVOT
    };
    if (exists(step)) {
      paramsStep = stepsMapped[step];
    }
    if (missing(paramsStep)) {
      console.error("AG Grid: invalid step " + step + ", available steps are " + Object.keys(stepsMapped).join(', '));
      return;
    }
    var modelParams = {
      step: paramsStep,
      keepRenderedRows: true,
      animate: true,
      keepEditingRows: true
    };
    this.clientSideRowModel.refreshModel(modelParams);
  };
  /** Returns `true` when there are no more animation frames left to process. */
  GridApi.prototype.isAnimationFrameQueueEmpty = function () {
    return this.animationFrameService.isQueueEmpty();
  };
  GridApi.prototype.flushAllAnimationFrames = function () {
    this.animationFrameService.flushAllFrames();
  };
  /**
   * Returns the row node with the given ID.
   * The row node ID is the one you provide from the callback `getRowNodeId(data)`,
   * otherwise the ID is a number auto-generated by the grid when the row data is set.
   */
  GridApi.prototype.getRowNode = function (id) {
    return this.rowModel.getRowNode(id);
  };
  /**
   * Gets the sizes that various UI elements will be rendered at with the current theme.
   * If you override the row or header height using `gridOptions`, the override value you provided will be returned.
   */
  GridApi.prototype.getSizesForCurrentTheme = function () {
    return {
      rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
      headerHeight: this.gridOptionsWrapper.getHeaderHeight()
    };
  };
  /** Expand all groups. */
  GridApi.prototype.expandAll = function () {
    if (this.clientSideRowModel) {
      this.clientSideRowModel.expandOrCollapseAll(true);
    } else if (this.serverSideRowModel) {
      this.serverSideRowModel.expandAll(true);
    } else {
      console.warn('AG Grid: expandAll only works with Client Side Row Model and Server Side Row Model');
    }
  };
  /** Collapse all groups. */
  GridApi.prototype.collapseAll = function () {
    if (this.clientSideRowModel) {
      this.clientSideRowModel.expandOrCollapseAll(false);
    } else if (this.serverSideRowModel) {
      this.serverSideRowModel.expandAll(false);
    } else {
      console.warn('AG Grid: collapseAll only works with Client Side Row Model and Server Side Row Model');
    }
  };
  /** Gets the tool panel instance corresponding to the supplied `id`. */
  GridApi.prototype.getToolPanelInstance = function (id) {
    if (!this.sideBarComp) {
      console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
      return;
    }
    var comp = this.sideBarComp.getToolPanelInstance(id);
    var unwrapped = this.frameworkComponentWrapper ? this.frameworkComponentWrapper.unwrap(comp) : comp;
    return unwrapped;
  };
  GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
    if (typeof eventName !== 'string') {
      console.warn('AG Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
    }
    this.addRenderedRowListener(eventName, rowIndex, callback);
  };
  /**
   * Registers a callback to a virtual row.
   * A virtual row is a row that is visually rendered on the screen (rows that are not visible because of the scroll position are not rendered).
   * Unlike normal events, you do not need to unregister rendered row listeners.
   * When the rendered row is removed from the grid, all associated rendered row listeners will also be removed.
   * Currently supports only one event, `virtualRowRemoved`;
   * listen for this event if your `cellRenderer` needs to do cleanup when the row no longer exists.
   */
  GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
    if (eventName === 'virtualRowSelected') {
      console.warn("AG Grid: event virtualRowSelected is deprecated, to register for individual row\n                selection events, add a listener directly to the row node.");
    }
    this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
  };
  /** Pass a quick filter text into the grid for filtering. */
  GridApi.prototype.setQuickFilter = function (newFilter) {
    this.filterManager.setQuickFilter(newFilter);
  };
  GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
    console.warn('AG Grid: do not use api for selection, call node.setSelected(value) instead');
    if (suppressEvents) {
      console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
    }
    this.selectionService.selectIndex(index, tryMulti);
  };
  GridApi.prototype.deselectIndex = function (index, suppressEvents) {
    if (suppressEvents === void 0) {
      suppressEvents = false;
    }
    console.warn('AG Grid: do not use api for selection, call node.setSelected(value) instead');
    if (suppressEvents) {
      console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
    }
    this.selectionService.deselectIndex(index);
  };
  GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
    if (tryMulti === void 0) {
      tryMulti = false;
    }
    if (suppressEvents === void 0) {
      suppressEvents = false;
    }
    console.warn('AG Grid: API for selection is deprecated, call node.setSelected(value) instead');
    if (suppressEvents) {
      console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
    }
    node.setSelectedParams({
      newValue: true,
      clearSelection: !tryMulti
    });
  };
  GridApi.prototype.deselectNode = function (node, suppressEvents) {
    if (suppressEvents === void 0) {
      suppressEvents = false;
    }
    console.warn('AG Grid: API for selection is deprecated, call node.setSelected(value) instead');
    if (suppressEvents) {
      console.warn('AG Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
    }
    node.setSelectedParams({
      newValue: false
    });
  };
  /** Select all rows, regardless of filtering and rows that are not visible due to grouping being enabled and their groups not expanded. */
  GridApi.prototype.selectAll = function () {
    this.selectionService.selectAllRowNodes();
  };
  /** Clear all row selections, regardless of filtering. */
  GridApi.prototype.deselectAll = function () {
    this.selectionService.deselectAllRowNodes();
  };
  /** Select all filtered rows. */
  GridApi.prototype.selectAllFiltered = function () {
    this.selectionService.selectAllRowNodes(true);
  };
  /** Clear all filtered selections. */
  GridApi.prototype.deselectAllFiltered = function () {
    this.selectionService.deselectAllRowNodes(true);
  };
  GridApi.prototype.recomputeAggregates = function () {
    if (missing(this.clientSideRowModel)) {
      console.warn('cannot call recomputeAggregates unless using normal row model');
    }
    console.warn("recomputeAggregates is deprecated, please call api.refreshClientSideRowModel('aggregate') instead");
    this.clientSideRowModel.refreshModel({
      step: ClientSideRowModelSteps.AGGREGATE
    });
  };
  /** Sets columns to adjust in size to fit the grid horizontally. */
  GridApi.prototype.sizeColumnsToFit = function () {
    this.gridBodyCon.sizeColumnsToFit();
  };
  /** Show the 'loading' overlay. */
  GridApi.prototype.showLoadingOverlay = function () {
    this.overlayWrapperComp.showLoadingOverlay();
  };
  /** Show the 'no rows' overlay. */
  GridApi.prototype.showNoRowsOverlay = function () {
    this.overlayWrapperComp.showNoRowsOverlay();
  };
  /** Hides the overlay if showing. */
  GridApi.prototype.hideOverlay = function () {
    this.overlayWrapperComp.hideOverlay();
  };
  GridApi.prototype.isNodeSelected = function (node) {
    console.warn('AG Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
    return node.isSelected();
  };
  GridApi.prototype.getSelectedNodesById = function () {
    console.error('AG Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
    return null;
  };
  /**
   * Returns a list of selected nodes.
   * Getting the underlying node (rather than the data) is useful when working with tree / aggregated data,
   * as the node can be traversed.
   */
  GridApi.prototype.getSelectedNodes = function () {
    return this.selectionService.getSelectedNodes();
  };
  /** Returns a list of selected rows (i.e. row data that you provided). */
  GridApi.prototype.getSelectedRows = function () {
    return this.selectionService.getSelectedRows();
  };
  /**
   * Returns a list of all selected nodes at 'best cost', a feature to be used with groups / trees.
   * If a group has all its children selected, then the group appears in the result, but not the children.
   * Designed for use with `'children'` as the group selection type, where groups don't actually appear in the selection normally.
   */
  GridApi.prototype.getBestCostNodeSelection = function () {
    return this.selectionService.getBestCostNodeSelection();
  };
  /** Retrieve rendered nodes. Due to virtualisation this will contain only the current visible rows and those in the buffer. */
  GridApi.prototype.getRenderedNodes = function () {
    return this.rowRenderer.getRenderedNodes();
  };
  GridApi.prototype.ensureColIndexVisible = function (index) {
    console.warn('AG Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
  };
  /** Ensures the column is visible, scrolling the table if needed. */
  GridApi.prototype.ensureColumnVisible = function (key) {
    this.gridBodyCon.getScrollFeature().ensureColumnVisible(key);
  };
  /**
   * Ensures the row index is visible by vertically scrolling the grid.
   * If a position of `'top'`, `'middle'` or `'bottom'` is supplied, the grid will scroll the grid to place the row at the top, middle or bottom respectively.
   * Otherwise, the grid will do the minimum scrolling possible to show the row.
   * i.e.
   * - if the grid needs to scroll up then it will scroll so that the row is at the top,
   * - if the grid needs to scroll down then it will scroll so that the row is at the bottom,
   * - if the row is already in view then the grid will do nothing.
   */
  GridApi.prototype.ensureIndexVisible = function (index, position) {
    this.gridBodyCon.getScrollFeature().ensureIndexVisible(index, position);
  };
  /**
   * Ensures a row node is visible, scrolling the grid if needed.
   * Provide either:
   * - the node,
   * - the data object
   * - a comparator function (that takes the node as a parameter, and returns `true` for match or `false` for no match).
   */
  GridApi.prototype.ensureNodeVisible = function (comparator, position) {
    if (position === void 0) {
      position = null;
    }
    this.gridBodyCon.getScrollFeature().ensureNodeVisible(comparator, position);
  };
  /**
   * Similar to `forEachNode`, except lists all the leaf nodes.
   * This effectively goes through all the data that you provided to the grid before the grid performed any grouping.
   * If using tree data, goes through all the nodes for the data you provided, including nodes that have children,
   * but excluding groups the grid created where gaps were missing in the hierarchy.
   */
  GridApi.prototype.forEachLeafNode = function (callback) {
    if (missing(this.clientSideRowModel)) {
      console.warn('cannot call forEachNode unless using normal row model');
    }
    this.clientSideRowModel.forEachLeafNode(callback);
  };
  /**
   * Iterates through each node (row) in the grid and calls the callback for each node.
   * This works similar to the `forEach` method on a JavaScript array.
   * This is called for every node, ignoring any filtering or sorting applied within the grid.
   * If using the Infinite Row Model, then this gets called for each page loaded in the page cache.
   */
  GridApi.prototype.forEachNode = function (callback) {
    this.rowModel.forEachNode(callback);
  };
  /** Similar to `forEachNode`, except skips any filtered out data. */
  GridApi.prototype.forEachNodeAfterFilter = function (callback) {
    if (missing(this.clientSideRowModel)) {
      console.warn('cannot call forEachNodeAfterFilter unless using normal row model');
    }
    this.clientSideRowModel.forEachNodeAfterFilter(callback);
  };
  /** Similar to `forEachNodeAfterFilter`, except the callbacks are called in the order the rows are displayed in the grid. */
  GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
    if (missing(this.clientSideRowModel)) {
      console.warn('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
    }
    this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
  };
  GridApi.prototype.getFilterApiForColDef = function (colDef) {
    console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterInstance instead');
    return this.getFilterInstance(colDef);
  };
  /**
   * Returns the filter component instance for a column.
   * `key` can be a string field name or a ColDef object (matches on object reference, useful if field names are not unique).
   *  */
  GridApi.prototype.getFilterInstance = function (key, callback) {
    var _this = this;
    var column = this.columnModel.getPrimaryColumn(key);
    if (!column) {
      return undefined;
    }
    var filterPromise = this.filterManager.getFilterComponent(column, 'NO_UI');
    var currentValue = filterPromise && filterPromise.resolveNow(null, function (filterComp) {
      return filterComp;
    });
    var currentValueUnwrapped = this.frameworkComponentWrapper ? this.frameworkComponentWrapper.unwrap(currentValue) : currentValue;
    if (callback) {
      if (currentValueUnwrapped) {
        setTimeout(callback, 0, currentValueUnwrapped);
      } else if (filterPromise) {
        filterPromise.then(function (comp) {
          var unwrapped = _this.frameworkComponentWrapper ? _this.frameworkComponentWrapper.unwrap(comp) : comp;
          callback(unwrapped);
        });
      }
    }
    return currentValueUnwrapped;
  };
  GridApi.prototype.getFilterApi = function (key) {
    console.warn('AG Grid: getFilterApi is deprecated, use getFilterInstance instead');
    return this.getFilterInstance(key);
  };
  /** Destroys a filter. Useful to force a particular filter to be created from scratch again. */
  GridApi.prototype.destroyFilter = function (key) {
    var column = this.columnModel.getPrimaryColumn(key);
    if (column) {
      return this.filterManager.destroyFilter(column, "filterDestroyed");
    }
  };
  /** Gets the status panel instance corresponding to the supplied `id`. */
  GridApi.prototype.getStatusPanel = function (key) {
    if (!this.statusBarService) {
      return;
    }
    var comp = this.statusBarService.getStatusPanel(key);
    var unwrapped = this.frameworkComponentWrapper ? this.frameworkComponentWrapper.unwrap(comp) : comp;
    return unwrapped;
  };
  GridApi.prototype.getColumnDef = function (key) {
    var column = this.columnModel.getPrimaryColumn(key);
    if (column) {
      return column.getColDef();
    }
    return null;
  };
  /**
   * Returns the current column definitions.
  */
  GridApi.prototype.getColumnDefs = function () {
    return this.columnModel.getColumnDefs();
  };
  /** Informs the grid that a filter has changed. This is typically called after a filter change through one of the filter APIs. */
  GridApi.prototype.onFilterChanged = function () {
    this.filterManager.onFilterChanged();
  };
  /**
   * Gets the grid to act as if the sort was changed.
   * Useful if you update some values and want to get the grid to reorder them according to the new values.
   */
  GridApi.prototype.onSortChanged = function () {
    this.sortController.onSortChanged();
  };
  GridApi.prototype.setSortModel = function (sortModel, source) {
    console.warn('AG Grid: as of version 24.0.0, setSortModel() is deprecated, sort information is now part of Column State. Please use columnApi.applyColumnState() instead.');
    var columnState = [];
    if (sortModel) {
      sortModel.forEach(function (item, index) {
        columnState.push({
          colId: item.colId,
          sort: item.sort,
          sortIndex: index
        });
      });
    }
    this.columnModel.applyColumnState({
      state: columnState,
      defaultState: {
        sort: null
      }
    });
  };
  GridApi.prototype.getSortModel = function () {
    console.warn('AG Grid: as of version 24.0.0, getSortModel() is deprecated, sort information is now part of Column State. Please use columnApi.getColumnState() instead.');
    var columnState = this.columnModel.getColumnState();
    var filteredStates = columnState.filter(function (item) {
      return item.sort != null;
    });
    var indexes = {};
    filteredStates.forEach(function (state) {
      var id = state.colId;
      var sortIndex = state.sortIndex;
      indexes[id] = sortIndex;
    });
    var res = filteredStates.map(function (s) {
      return {
        colId: s.colId,
        sort: s.sort
      };
    });
    res.sort(function (a, b) {
      return indexes[a.colId] - indexes[b.colId];
    });
    return res;
  };
  /** Sets the state of all the advanced filters. Provide it with what you get from `getFilterModel()` to restore filter state. */
  GridApi.prototype.setFilterModel = function (model) {
    this.filterManager.setFilterModel(model);
  };
  /** Gets the current state of all the advanced filters. Used for saving filter state. */
  GridApi.prototype.getFilterModel = function () {
    return this.filterManager.getFilterModel();
  };
  /** Returns the focused cell (or the last focused cell if the grid lost focus). */
  GridApi.prototype.getFocusedCell = function () {
    return this.focusService.getFocusedCell();
  };
  /** Clears the focused cell. */
  GridApi.prototype.clearFocusedCell = function () {
    return this.focusService.clearFocusedCell();
  };
  /** Sets the focus to the specified cell. */
  GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
    this.focusService.setFocusedCell(rowIndex, colKey, floating, true);
  };
  /** Sets the `suppressRowDrag` property. */
  GridApi.prototype.setSuppressRowDrag = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_ROW_DRAG, value);
  };
  /** Sets the `suppressMoveWhenRowDragging` property. */
  GridApi.prototype.setSuppressMoveWhenRowDragging = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_MOVE_WHEN_ROW_DRAG, value);
  };
  /** Sets the `suppressRowClickSelection` property. */
  GridApi.prototype.setSuppressRowClickSelection = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_ROW_CLICK_SELECTION, value);
  };
  /** Adds a drop zone outside of the grid where rows can be dropped. */
  GridApi.prototype.addRowDropZone = function (params) {
    this.gridBodyCon.getRowDragFeature().addRowDropZone(params);
  };
  /** Removes an external drop zone added by `addRowDropZone`. */
  GridApi.prototype.removeRowDropZone = function (params) {
    var activeDropTarget = this.dragAndDropService.findExternalZone(params);
    if (activeDropTarget) {
      this.dragAndDropService.removeDropTarget(activeDropTarget);
    }
  };
  /** Returns the `RowDropZoneParams` to be used by another grid's `addRowDropZone` method. */
  GridApi.prototype.getRowDropZoneParams = function (events) {
    return this.gridBodyCon.getRowDragFeature().getRowDropZone(events);
  };
  /** Sets the height in pixels for the row containing the column label header. */
  GridApi.prototype.setHeaderHeight = function (headerHeight) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
  };
  GridApi.prototype.setDomLayout = function (domLayout) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DOM_LAYOUT, domLayout);
  };
  /** Sets the `enableCellTextSelection` property. */
  GridApi.prototype.setEnableCellTextSelection = function (selectable) {
    this.gridBodyCon.setCellTextSelection(selectable);
  };
  /** Sets the preferred direction for the selection fill handle. */
  GridApi.prototype.setFillHandleDirection = function (direction) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_FILL_HANDLE_DIRECTION, direction);
  };
  /** Sets the height in pixels for the rows containing header column groups. */
  GridApi.prototype.setGroupHeaderHeight = function (headerHeight) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_HEADER_HEIGHT, headerHeight);
  };
  /** Sets the height in pixels for the row containing the floating filters. */
  GridApi.prototype.setFloatingFiltersHeight = function (headerHeight) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_FLOATING_FILTERS_HEIGHT, headerHeight);
  };
  /** Sets the height in pixels for the row containing header column groups when in pivot mode. */
  GridApi.prototype.setPivotGroupHeaderHeight = function (headerHeight) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PIVOT_GROUP_HEADER_HEIGHT, headerHeight);
  };
  GridApi.prototype.setIsExternalFilterPresent = function (isExternalFilterPresentFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_EXTERNAL_FILTER_PRESENT, isExternalFilterPresentFunc);
  };
  GridApi.prototype.setDoesExternalFilterPass = function (doesExternalFilterPassFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DOES_EXTERNAL_FILTER_PASS, doesExternalFilterPassFunc);
  };
  GridApi.prototype.setNavigateToNextCell = function (navigateToNextCellFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_CELL, navigateToNextCellFunc);
  };
  GridApi.prototype.setTabToNextCell = function (tabToNextCellFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_TAB_TO_NEXT_CELL, tabToNextCellFunc);
  };
  GridApi.prototype.setTabToNextHeader = function (tabToNextHeaderFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_TAB_TO_NEXT_HEADER, tabToNextHeaderFunc);
  };
  GridApi.prototype.setNavigateToNextHeader = function (navigateToNextHeaderFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_NAVIGATE_TO_NEXT_HEADER, navigateToNextHeaderFunc);
  };
  GridApi.prototype.setGroupRowAggNodes = function (groupRowAggNodesFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_ROW_AGG_NODES, groupRowAggNodesFunc);
  };
  GridApi.prototype.setGetBusinessKeyForNode = function (getBusinessKeyForNodeFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_BUSINESS_KEY_FOR_NODE, getBusinessKeyForNodeFunc);
  };
  GridApi.prototype.setGetChildCount = function (getChildCountFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CHILD_COUNT, getChildCountFunc);
  };
  GridApi.prototype.setProcessRowPostCreate = function (processRowPostCreateFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_ROW_POST_CREATE, processRowPostCreateFunc);
  };
  GridApi.prototype.setGetRowNodeId = function (getRowNodeIdFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_NODE_ID, getRowNodeIdFunc);
  };
  GridApi.prototype.setGetRowClass = function (rowClassFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_CLASS, rowClassFunc);
  };
  GridApi.prototype.setIsFullWidthCell = function (isFullWidthCellFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_FULL_WIDTH_CELL, isFullWidthCellFunc);
  };
  GridApi.prototype.setIsRowSelectable = function (isRowSelectableFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_ROW_SELECTABLE, isRowSelectableFunc);
  };
  GridApi.prototype.setIsRowMaster = function (isRowMasterFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_ROW_MASTER, isRowMasterFunc);
  };
  GridApi.prototype.setPostSort = function (postSortFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POST_SORT, postSortFunc);
  };
  GridApi.prototype.setGetDocument = function (getDocumentFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_DOCUMENT, getDocumentFunc);
  };
  GridApi.prototype.setGetContextMenuItems = function (getContextMenuItemsFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CONTEXT_MENU_ITEMS, getContextMenuItemsFunc);
  };
  GridApi.prototype.setGetMainMenuItems = function (getMainMenuItemsFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_MAIN_MENU_ITEMS, getMainMenuItemsFunc);
  };
  GridApi.prototype.setProcessCellForClipboard = function (processCellForClipboardFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_CELL_FOR_CLIPBOARD, processCellForClipboardFunc);
  };
  GridApi.prototype.setSendToClipboard = function (sendToClipboardFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SEND_TO_CLIPBOARD, sendToClipboardFunc);
  };
  GridApi.prototype.setProcessCellFromClipboard = function (processCellFromClipboardFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_CELL_FROM_CLIPBOARD, processCellFromClipboardFunc);
  };
  GridApi.prototype.setProcessSecondaryColDef = function (processSecondaryColDefFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_TO_SECONDARY_COLDEF, processSecondaryColDefFunc);
  };
  GridApi.prototype.setProcessSecondaryColGroupDef = function (processSecondaryColGroupDefFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PROCESS_SECONDARY_COL_GROUP_DEF, processSecondaryColGroupDefFunc);
  };
  GridApi.prototype.setPostProcessPopup = function (postProcessPopupFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POST_PROCESS_POPUP, postProcessPopupFunc);
  };
  GridApi.prototype.setDefaultGroupOrderComparator = function (defaultGroupOrderComparatorFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_DEFAULT_GROUP_ORDER_COMPARATOR, defaultGroupOrderComparatorFunc);
  };
  GridApi.prototype.setGetChartToolbarItems = function (getChartToolbarItemsFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_CHART_TOOLBAR_ITEMS, getChartToolbarItemsFunc);
  };
  GridApi.prototype.setPaginationNumberFormatter = function (paginationNumberFormatterFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PAGINATION_NUMBER_FORMATTER, paginationNumberFormatterFunc);
  };
  GridApi.prototype.setGetServerSideStoreParams = function (getServerSideStoreParamsFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_SERVER_SIDE_STORE_PARAMS, getServerSideStoreParamsFunc);
  };
  GridApi.prototype.setIsServerSideGroupOpenByDefault = function (isServerSideGroupOpenByDefaultFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUPS_OPEN_BY_DEFAULT, isServerSideGroupOpenByDefaultFunc);
  };
  GridApi.prototype.setIsApplyServerSideTransaction = function (isApplyServerSideTransactionFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_APPLY_SERVER_SIDE_TRANSACTION, isApplyServerSideTransactionFunc);
  };
  GridApi.prototype.setIsServerSideGroup = function (isServerSideGroupFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_IS_SERVER_SIDE_GROUP, isServerSideGroupFunc);
  };
  GridApi.prototype.setGetServerSideGroupKey = function (getServerSideGroupKeyFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_SERVER_SIDE_GROUP_KEY, getServerSideGroupKeyFunc);
  };
  GridApi.prototype.setGetRowStyle = function (rowStyleFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_STYLE, rowStyleFunc);
  };
  GridApi.prototype.setGetRowHeight = function (rowHeightFunc) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GET_ROW_HEIGHT, rowHeightFunc);
  };
  /** Sets the height in pixels for the row containing the columns when in pivot mode. */
  GridApi.prototype.setPivotHeaderHeight = function (headerHeight) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_PIVOT_HEADER_HEIGHT, headerHeight);
  };
  /** Returns `true` if the side bar is visible. */
  GridApi.prototype.isSideBarVisible = function () {
    return this.sideBarComp ? this.sideBarComp.isDisplayed() : false;
  };
  /** Show/hide the entire side bar, including any visible panel and the tab buttons. */
  GridApi.prototype.setSideBarVisible = function (show) {
    if (!this.sideBarComp) {
      if (show) {
        console.warn('AG Grid: sideBar is not loaded');
      }
      return;
    }
    this.sideBarComp.setDisplayed(show);
  };
  /** Sets the side bar position relative to the grid. Possible values are `'left'` or `'right'`. */
  GridApi.prototype.setSideBarPosition = function (position) {
    if (!this.sideBarComp) {
      console.warn('AG Grid: sideBar is not loaded');
      return;
    }
    this.sideBarComp.setSideBarPosition(position);
  };
  /** Opens a particular tool panel. Provide the ID of the tool panel to open. */
  GridApi.prototype.openToolPanel = function (key) {
    if (!this.sideBarComp) {
      console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
      return;
    }
    this.sideBarComp.openToolPanel(key);
  };
  /** Closes the currently open tool panel (if any). */
  GridApi.prototype.closeToolPanel = function () {
    if (!this.sideBarComp) {
      console.warn('AG Grid: toolPanel is only available in AG Grid Enterprise');
      return;
    }
    this.sideBarComp.close();
  };
  /** Returns the ID of the currently shown tool panel if any, otherwise `null`. */
  GridApi.prototype.getOpenedToolPanel = function () {
    return this.sideBarComp ? this.sideBarComp.openedItem() : null;
  };
  /** Returns the current side bar configuration. If a shortcut was used, returns the detailed long form. */
  GridApi.prototype.getSideBar = function () {
    return this.gridOptionsWrapper.getSideBar();
  };
  /** Resets the side bar to the provided configuration. The parameter is the same as the sideBar grid property. The side bar is re-created from scratch with the new config. */
  GridApi.prototype.setSideBar = function (def) {
    this.gridOptionsWrapper.setProperty('sideBar', SideBarDefParser.parse(def));
  };
  GridApi.prototype.setSuppressClipboardPaste = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_SUPPRESS_CLIPBOARD_PASTE, value);
  };
  /** Returns `true` if the tool panel is showing, otherwise `false`. */
  GridApi.prototype.isToolPanelShowing = function () {
    return this.sideBarComp.isToolPanelShowing();
  };
  GridApi.prototype.doLayout = function () {
    var message = "AG Grid - since version 25.1, doLayout was taken out, as it's not needed. The grid responds to grid size changes automatically";
    doOnce(function () {
      return console.warn(message);
    }, 'doLayoutDeprecated');
  };
  /** Tells the grid to recalculate the row heights. */
  GridApi.prototype.resetRowHeights = function () {
    if (exists(this.clientSideRowModel)) {
      this.clientSideRowModel.resetRowHeights();
    }
  };
  GridApi.prototype.setGroupRemoveSingleChildren = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, value);
  };
  GridApi.prototype.setGroupRemoveLowestSingleChildren = function (value) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, value);
  };
  /** Tells the grid a row height has changed. To be used after calling `rowNode.setRowHeight(newHeight)`. */
  GridApi.prototype.onRowHeightChanged = function () {
    if (this.clientSideRowModel) {
      this.clientSideRowModel.onRowHeightChanged();
    } else if (this.serverSideRowModel) {
      this.serverSideRowModel.onRowHeightChanged();
    }
  };
  /**
   * Gets the value for a column for a particular `rowNode` (row).
   * This is useful if you want the raw value of a cell e.g. if implementing your own CSV export.
   */
  GridApi.prototype.getValue = function (colKey, rowNode) {
    var column = this.columnModel.getPrimaryColumn(colKey);
    if (missing(column)) {
      column = this.columnModel.getGridColumn(colKey);
    }
    if (missing(column)) {
      return null;
    }
    return this.valueService.getValue(column, rowNode);
  };
  /** Add an event listener for the specified `eventType`. Works similar to `addEventListener` for a browser DOM element. */
  GridApi.prototype.addEventListener = function (eventType, listener) {
    var async = this.gridOptionsWrapper.useAsyncEvents();
    this.eventService.addEventListener(eventType, listener, async);
  };
  /** Add an event listener for all event types coming from the grid. */
  GridApi.prototype.addGlobalListener = function (listener) {
    var async = this.gridOptionsWrapper.useAsyncEvents();
    this.eventService.addGlobalListener(listener, async);
  };
  /** Remove an event listener. */
  GridApi.prototype.removeEventListener = function (eventType, listener) {
    var async = this.gridOptionsWrapper.useAsyncEvents();
    this.eventService.removeEventListener(eventType, listener, async);
  };
  /** Remove a global event listener. */
  GridApi.prototype.removeGlobalListener = function (listener) {
    var async = this.gridOptionsWrapper.useAsyncEvents();
    this.eventService.removeGlobalListener(listener, async);
  };
  GridApi.prototype.dispatchEvent = function (event) {
    this.eventService.dispatchEvent(event);
  };
  /** Will destroy the grid and release resources. If you are using a framework you do not need to call this, as the grid links in with the framework lifecycle. However if you are using Web Components or native JavaScript, you do need to call this, to avoid a memory leak in your application. */
  GridApi.prototype.destroy = function () {
    // this is needed as GridAPI is a bean, and GridAPI.destroy() is called as part
    // of context.destroy(). so we need to stop the infinite loop.
    if (this.destroyCalled) {
      return;
    }
    this.destroyCalled = true;
    // destroy the UI first (as they use the services)
    var gridCtrl = this.ctrlsService.getGridCtrl();
    gridCtrl && gridCtrl.destroyGridUi();
    // destroy the services
    this.context.destroy();
  };
  GridApi.prototype.cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid = function () {
    // some users were raising support issues with regards memory leaks. the problem was the customers applications
    // were keeping references to the API. trying to educate them all would be difficult, easier to just remove
    // all references in teh API so at least the core grid can be garbage collected.
    //
    // wait about 100ms before clearing down the references, in case user has some cleanup to do,
    // and needs to deference the API first
    setTimeout(removeAllReferences.bind(window, this, 'Grid API'), 100);
  };
  GridApi.prototype.warnIfDestroyed = function (methodName) {
    if (this.destroyCalled) {
      console.warn("AG Grid: Grid API method " + methodName + " was called on a grid that was destroyed.");
    }
    return this.destroyCalled;
  };
  /** Reset the quick filter cache text on every rowNode. */
  GridApi.prototype.resetQuickFilter = function () {
    if (this.warnIfDestroyed('resetQuickFilter')) {
      return;
    }
    this.rowModel.forEachNode(function (node) {
      return node.quickFilterAggregateText = null;
    });
  };
  GridApi.prototype.getRangeSelections = function () {
    console.warn("AG Grid: in v20.1.x, api.getRangeSelections() is gone, please use getCellRanges() instead.\n        We had to change how cell selections works a small bit to allow charting to integrate. The return type of\n        getCellRanges() is a bit different, please check the AG Grid documentation.");
    return null;
  };
  /** Returns the list of selected cell ranges. */
  GridApi.prototype.getCellRanges = function () {
    if (this.rangeService) {
      return this.rangeService.getCellRanges();
    }
    console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
    return null;
  };
  GridApi.prototype.camelCaseToHumanReadable = function (camelCase) {
    return camelCaseToHumanText(camelCase);
  };
  GridApi.prototype.addRangeSelection = function (deprecatedNoLongerUsed) {
    console.warn('AG Grid: As of version 21.x, range selection changed slightly to allow charting integration. Please call api.addCellRange() instead of api.addRangeSelection()');
  };
  /** Adds the provided cell range to the selected ranges. */
  GridApi.prototype.addCellRange = function (params) {
    if (!this.rangeService) {
      console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
    }
    this.rangeService.addCellRange(params);
  };
  /** Clears the selected ranges. */
  GridApi.prototype.clearRangeSelection = function () {
    if (!this.rangeService) {
      console.warn('AG Grid: cell range selection is only available in AG Grid Enterprise');
    }
    this.rangeService.removeAllCellRanges();
  };
  /** Reverts the last cell edit. */
  GridApi.prototype.undoCellEditing = function () {
    this.undoRedoService.undo();
  };
  /** Re-applies the most recently undone cell edit. */
  GridApi.prototype.redoCellEditing = function () {
    this.undoRedoService.redo();
  };
  /** Returns current number of available cell edit undo operations. */
  GridApi.prototype.getCurrentUndoSize = function () {
    return this.undoRedoService.getCurrentUndoStackSize();
  };
  /** Returns current number of available cell edit redo operations. */
  GridApi.prototype.getCurrentRedoSize = function () {
    return this.undoRedoService.getCurrentRedoStackSize();
  };
  /** Returns a list of models with information about the charts that are currently rendered from the grid. */
  GridApi.prototype.getChartModels = function () {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.getChartModels') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.getChartModels')) {
      return this.chartService.getChartModels();
    }
  };
  /** Returns the `ChartRef` using the supplied `chartId`. */
  GridApi.prototype.getChartRef = function (chartId) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.getChartRef') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.getChartRef')) {
      return this.chartService.getChartRef(chartId);
    }
  };
  /** Returns a string containing the requested data URL which contains a representation of the chart image. */
  GridApi.prototype.getChartImageDataURL = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.getChartImageDataURL') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.getChartImageDataURL')) {
      return this.chartService.getChartImageDataURL(params);
    }
  };
  /** Used to programmatically create charts from a range. */
  GridApi.prototype.createRangeChart = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.createRangeChart') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.createRangeChart')) {
      return this.chartService.createRangeChart(params);
    }
  };
  /** Used to programmatically create cross filter charts from a range. */
  GridApi.prototype.createCrossFilterChart = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.createCrossFilterChart') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.createCrossFilterChart')) {
      return this.chartService.createCrossFilterChart(params);
    }
  };
  /** Restores a chart using the `ChartModel` that was previously obtained from `getChartModels()`. */
  GridApi.prototype.restoreChart = function (chartModel, chartContainer) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.restoreChart') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.restoreChart')) {
      return this.chartService.restoreChart(chartModel, chartContainer);
    }
  };
  /** Used to programmatically create pivot charts from a grid. */
  GridApi.prototype.createPivotChart = function (params) {
    if (ModuleRegistry.assertRegistered(ModuleNames.RangeSelectionModule, 'api.createPivotChart') && ModuleRegistry.assertRegistered(ModuleNames.GridChartsModule, 'api.createPivotChart')) {
      return this.chartService.createPivotChart(params);
    }
  };
  /**
   * Copies the selected rows to the clipboard.
   * Set `includeHeaders = true` to include the headers (default is `false`).
   * Set `columnKeys` to the list of columns if you want just specific columns.
   */
  GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
    if (!this.clipboardService) {
      console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
    }
    this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
  };
  /** Copies the selected ranges to the clipboard. */
  GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
    if (!this.clipboardService) {
      console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
    }
    this.clipboardService.copySelectedRangeToClipboard(includeHeader);
  };
  /** Copies the selected range down, similar to `Ctrl + D` in Excel. */
  GridApi.prototype.copySelectedRangeDown = function () {
    if (!this.clipboardService) {
      console.warn('AG Grid: clipboard is only available in AG Grid Enterprise');
    }
    this.clipboardService.copyRangeDown();
  };
  /** Shows the column menu after and positions it relative to the provided button element. Use in conjunction with your own header template. */
  GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
    // use grid column so works with pivot mode
    var column = this.columnModel.getGridColumn(colKey);
    this.menuFactory.showMenuAfterButtonClick(column, buttonElement, 'columnMenu');
  };
  /** Shows the column menu after and positions it relative to the mouse event. Use in conjunction with your own header template. */
  GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
    // use grid column so works with pivot mode
    var column = this.columnModel.getGridColumn(colKey);
    if (!column) {
      column = this.columnModel.getPrimaryColumn(colKey);
    }
    if (!column) {
      console.error("AG Grid: column '" + colKey + "' not found");
      return;
    }
    this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
  };
  /** Hides any visible context menu or column menu. */
  GridApi.prototype.hidePopupMenu = function () {
    // hide the context menu if in enterprise
    if (this.contextMenuFactory) {
      this.contextMenuFactory.hideActiveMenu();
    }
    // and hide the column menu always
    this.menuFactory.hideActiveMenu();
  };
  /** DOM element to use as the popup parent for grid popups (context menu, column menu etc). */
  GridApi.prototype.setPopupParent = function (ePopupParent) {
    this.gridOptionsWrapper.setProperty(GridOptionsWrapper.PROP_POPUP_PARENT, ePopupParent);
  };
  /** Navigates the grid focus to the next cell, as if tabbing. */
  GridApi.prototype.tabToNextCell = function () {
    return this.navigationService.tabToNextCell(false);
  };
  /** Navigates the grid focus to the previous cell, as if shift-tabbing. */
  GridApi.prototype.tabToPreviousCell = function () {
    return this.navigationService.tabToNextCell(true);
  };
  /** Returns the list of active cell renderer instances. */
  GridApi.prototype.getCellRendererInstances = function (params) {
    if (params === void 0) {
      params = {};
    }
    return this.rowRenderer.getCellRendererInstances(params);
  };
  /** Returns the list of active cell editor instances. Optionally provide parameters to restrict to certain columns / row nodes. */
  GridApi.prototype.getCellEditorInstances = function (params) {
    if (params === void 0) {
      params = {};
    }
    return this.rowRenderer.getCellEditorInstances(params);
  };
  /** If the grid is editing, returns back details of the editing cell(s). */
  GridApi.prototype.getEditingCells = function () {
    return this.rowRenderer.getEditingCells();
  };
  /** If a cell is editing, it stops the editing. Pass `true` if you want to cancel the editing (i.e. don't accept changes). */
  GridApi.prototype.stopEditing = function (cancel) {
    if (cancel === void 0) {
      cancel = false;
    }
    this.rowRenderer.stopEditing(cancel);
  };
  /** Start editing the provided cell. If another cell is editing, the editing will be stopped in that other cell. */
  GridApi.prototype.startEditingCell = function (params) {
    var column = this.columnModel.getGridColumn(params.colKey);
    if (!column) {
      console.warn("AG Grid: no column found for " + params.colKey);
      return;
    }
    var cellPosition = {
      rowIndex: params.rowIndex,
      rowPinned: params.rowPinned || null,
      column: column
    };
    var notPinned = params.rowPinned == null;
    if (notPinned) {
      this.gridBodyCon.getScrollFeature().ensureIndexVisible(params.rowIndex);
    }
    var cell = this.navigationService.getCellByPosition(cellPosition);
    if (!cell) {
      return;
    }
    cell.startRowOrCellEdit(params.keyPress, params.charPress);
  };
  /** Add an aggregation function with the specified key. */
  GridApi.prototype.addAggFunc = function (key, aggFunc) {
    if (this.aggFuncService) {
      this.aggFuncService.addAggFunc(key, aggFunc);
    }
  };
  /** Add aggregations function with the specified keys. */
  GridApi.prototype.addAggFuncs = function (aggFuncs) {
    if (this.aggFuncService) {
      this.aggFuncService.addAggFuncs(aggFuncs);
    }
  };
  /** Clears all aggregation functions (including those provided by the grid). */
  GridApi.prototype.clearAggFuncs = function () {
    if (this.aggFuncService) {
      this.aggFuncService.clear();
    }
  };
  /** Apply transactions to the server side row model. */
  GridApi.prototype.applyServerSideTransaction = function (transaction) {
    if (!this.serverSideTransactionManager) {
      console.warn('AG Grid: Cannot apply Server Side Transaction if not using the Server Side Row Model.');
      return;
    }
    return this.serverSideTransactionManager.applyTransaction(transaction);
  };
  GridApi.prototype.applyServerSideTransactionAsync = function (transaction, callback) {
    if (!this.serverSideTransactionManager) {
      console.warn('AG Grid: Cannot apply Server Side Transaction if not using the Server Side Row Model.');
      return;
    }
    return this.serverSideTransactionManager.applyTransactionAsync(transaction, callback);
  };
  /** Gets all failed server side loads to retry. */
  GridApi.prototype.retryServerSideLoads = function () {
    if (!this.serverSideRowModel) {
      console.warn('AG Grid: API retryServerSideLoads() can only be used when using Server-Side Row Model.');
      return;
    }
    this.serverSideRowModel.retryLoads();
  };
  GridApi.prototype.flushServerSideAsyncTransactions = function () {
    if (!this.serverSideTransactionManager) {
      console.warn('AG Grid: Cannot flush Server Side Transaction if not using the Server Side Row Model.');
      return;
    }
    return this.serverSideTransactionManager.flushAsyncTransactions();
  };
  /** Update row data. Pass a transaction object with lists for `add`, `remove` and `update`. */
  GridApi.prototype.applyTransaction = function (rowDataTransaction) {
    if (!this.clientSideRowModel) {
      console.error('AG Grid: updateRowData() only works with ClientSideRowModel. Working with InfiniteRowModel was deprecated in v23.1 and removed in v24.1');
      return;
    }
    var res = this.clientSideRowModel.updateRowData(rowDataTransaction);
    // refresh all the full width rows
    this.rowRenderer.refreshFullWidthRows(res.update);
    // do change detection for all present cells
    if (!this.gridOptionsWrapper.isSuppressChangeDetection()) {
      this.rowRenderer.refreshCells();
    }
    return res;
  };
  /** @deprecated */
  GridApi.prototype.updateRowData = function (rowDataTransaction) {
    var message = 'AG Grid: as of v23.1, grid API updateRowData(transaction) is now called applyTransaction(transaction). updateRowData is deprecated and will be removed in a future major release.';
    doOnce(function () {
      return console.warn(message);
    }, 'updateRowData deprecated');
    return this.applyTransaction(rowDataTransaction);
  };
  /** Same as `applyTransaction` except executes asynchronously for efficiency. */
  GridApi.prototype.applyTransactionAsync = function (rowDataTransaction, callback) {
    if (!this.clientSideRowModel) {
      console.error('AG Grid: api.applyTransactionAsync() only works with ClientSideRowModel.');
      return;
    }
    this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback);
  };
  /** Executes any remaining asynchronous grid transactions, if any are waiting to be executed. */
  GridApi.prototype.flushAsyncTransactions = function () {
    if (!this.clientSideRowModel) {
      console.error('AG Grid: api.applyTransactionAsync() only works with ClientSideRowModel.');
      return;
    }
    this.clientSideRowModel.flushAsyncTransactions();
  };
  /** @deprecated */
  GridApi.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
    var message = 'AG Grid: as of v23.1, grid API batchUpdateRowData(transaction, callback) is now called applyTransactionAsync(transaction, callback). batchUpdateRowData is deprecated and will be removed in a future major release.';
    doOnce(function () {
      return console.warn(message);
    }, 'batchUpdateRowData deprecated');
    this.applyTransactionAsync(rowDataTransaction, callback);
  };
  GridApi.prototype.insertItemsAtIndex = function (index, items, skipRefresh) {
    console.warn('AG Grid: insertItemsAtIndex() is deprecated, use updateRowData(transaction) instead.');
    this.updateRowData({
      add: items,
      addIndex: index,
      update: null,
      remove: null
    });
  };
  GridApi.prototype.removeItems = function (rowNodes, skipRefresh) {
    console.warn('AG Grid: removeItems() is deprecated, use updateRowData(transaction) instead.');
    var dataToRemove = rowNodes.map(function (rowNode) {
      return rowNode.data;
    });
    this.updateRowData({
      add: null,
      addIndex: null,
      update: null,
      remove: dataToRemove
    });
  };
  GridApi.prototype.addItems = function (items, skipRefresh) {
    console.warn('AG Grid: addItems() is deprecated, use updateRowData(transaction) instead.');
    this.updateRowData({
      add: items,
      addIndex: null,
      update: null,
      remove: null
    });
  };
  GridApi.prototype.refreshVirtualPageCache = function () {
    console.warn('AG Grid: refreshVirtualPageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
    this.refreshInfiniteCache();
  };
  GridApi.prototype.refreshInfinitePageCache = function () {
    console.warn('AG Grid: refreshInfinitePageCache() is now called refreshInfiniteCache(), please call refreshInfiniteCache() instead');
    this.refreshInfiniteCache();
  };
  /**
   * Marks all the currently loaded blocks in the cache for reload.
   * If you have 10 blocks in the cache, all 10 will be marked for reload.
   * The old data will continue to be displayed until the new data is loaded.
   */
  GridApi.prototype.refreshInfiniteCache = function () {
    if (this.infiniteRowModel) {
      this.infiniteRowModel.refreshCache();
    } else {
      console.warn("AG Grid: api.refreshInfiniteCache is only available when rowModelType='infinite'.");
    }
  };
  GridApi.prototype.purgeVirtualPageCache = function () {
    console.warn('AG Grid: purgeVirtualPageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
    this.purgeInfinitePageCache();
  };
  GridApi.prototype.purgeInfinitePageCache = function () {
    console.warn('AG Grid: purgeInfinitePageCache() is now called purgeInfiniteCache(), please call purgeInfiniteCache() instead');
    this.purgeInfiniteCache();
  };
  /**
   * Purges the cache.
   * The grid is then told to refresh. Only the blocks required to display the current data on screen are fetched (typically no more than 2).
   * The grid will display nothing while the new blocks are loaded.
   * Use this to immediately remove the old data from the user.
   */
  GridApi.prototype.purgeInfiniteCache = function () {
    if (this.infiniteRowModel) {
      this.infiniteRowModel.purgeCache();
    } else {
      console.warn("AG Grid: api.purgeInfiniteCache is only available when rowModelType='infinite'.");
    }
  };
  /** @deprecated */
  GridApi.prototype.purgeEnterpriseCache = function (route) {
    console.warn("ag-grid: since version 18.x, api.purgeEnterpriseCache() should be replaced with api.purgeServerSideCache()");
    this.purgeServerSideCache(route);
  };
  /** @deprecated */
  GridApi.prototype.purgeServerSideCache = function (route) {
    if (route === void 0) {
      route = [];
    }
    if (this.serverSideRowModel) {
      console.warn("AG Grid: since v25.0, api.purgeServerSideCache is deprecated. Please use api.refreshServerSideStore({purge: true}) instead.");
      this.refreshServerSideStore({
        route: route,
        purge: true
      });
    } else {
      console.warn("AG Grid: api.purgeServerSideCache is only available when rowModelType='serverSide'.");
    }
  };
  /**
   * Refresh a server-side store.
   * If you pass no parameters, then the top level cache is purged.
   * To purge a child cache, pass in the string of keys to get to the child cache.
   */
  GridApi.prototype.refreshServerSideStore = function (params) {
    if (this.serverSideRowModel) {
      this.serverSideRowModel.refreshStore(params);
    } else {
      console.warn("AG Grid: api.refreshServerSideStore is only available when rowModelType='serverSide'.");
    }
  };
  /** Returns info on all server side stores. */
  GridApi.prototype.getServerSideStoreState = function () {
    if (this.serverSideRowModel) {
      return this.serverSideRowModel.getStoreState();
    } else {
      console.warn("AG Grid: api.getServerSideStoreState is only available when rowModelType='serverSide'.");
      return [];
    }
  };
  GridApi.prototype.getVirtualRowCount = function () {
    console.warn('AG Grid: getVirtualRowCount() is now called getInfiniteRowCount(), please call getInfiniteRowCount() instead');
    return this.getInfiniteRowCount();
  };
  /** The row count defines how many rows the grid allows scrolling to. */
  GridApi.prototype.getInfiniteRowCount = function () {
    if (this.infiniteRowModel) {
      return this.infiniteRowModel.getRowCount();
    } else {
      console.warn("AG Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
    }
  };
  GridApi.prototype.isMaxRowFound = function () {
    console.warn("AG Grid: api.isLastRowIndexKnown is deprecated, please use api.isLastRowIndexKnown()");
    return this.isLastRowIndexKnown();
  };
  /** Returns `true` if grid allows for scrolling past the last row to load more rows, thus providing infinite scroll. */
  GridApi.prototype.isLastRowIndexKnown = function () {
    if (this.infiniteRowModel) {
      return this.infiniteRowModel.isLastRowIndexKnown();
    } else {
      console.warn("AG Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
    }
  };
  GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
    console.warn('AG Grid: setVirtualRowCount() is now called setInfiniteRowCount(), please call setInfiniteRowCount() instead');
    this.setRowCount(rowCount, maxRowFound);
  };
  GridApi.prototype.setInfiniteRowCount = function (rowCount, maxRowFound) {
    console.warn('AG Grid: setInfiniteRowCount() is now called setRowCount(), please call setRowCount() instead');
    this.setRowCount(rowCount, maxRowFound);
  };
  /**
   * Sets the `rowCount` and `lastRowIndexKnown` properties.
   * The second parameter, `lastRowIndexKnown`, is optional and if left out, only `rowCount` is set.
   * Set `rowCount` to adjust the height of the vertical scroll.
   * Set `lastRowIndexKnown` to enable / disable searching for more rows.
   * Use this method if you add or remove rows into the dataset and need to reset the number of rows or put the data back into 'look for data' mode.
   */
  GridApi.prototype.setRowCount = function (rowCount, maxRowFound) {
    if (this.infiniteRowModel) {
      this.infiniteRowModel.setRowCount(rowCount, maxRowFound);
    } else {
      console.warn("AG Grid: api.setRowCount is only available for Infinite Row Model.");
    }
  };
  GridApi.prototype.getVirtualPageState = function () {
    console.warn('AG Grid: getVirtualPageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
    return this.getCacheBlockState();
  };
  GridApi.prototype.getInfinitePageState = function () {
    console.warn('AG Grid: getInfinitePageState() is now called getCacheBlockState(), please call getCacheBlockState() instead');
    return this.getCacheBlockState();
  };
  /**
   * Returns an object representing the state of the cache. This is useful for debugging and understanding how the cache is working.
   */
  GridApi.prototype.getCacheBlockState = function () {
    return this.rowNodeBlockLoader.getBlockState();
  };
  GridApi.prototype.checkGridSize = function () {
    console.warn("in AG Grid v25.2.0, checkGridSize() was removed, as it was legacy and didn't do anything uesful.");
  };
  GridApi.prototype.getFirstRenderedRow = function () {
    console.warn('in AG Grid v12, getFirstRenderedRow() was renamed to getFirstDisplayedRow()');
    return this.getFirstDisplayedRow();
  };
  /** Get the index of the first displayed row due to scrolling (includes invisible rendered rows in the buffer). */
  GridApi.prototype.getFirstDisplayedRow = function () {
    return this.rowRenderer.getFirstVirtualRenderedRow();
  };
  GridApi.prototype.getLastRenderedRow = function () {
    console.warn('in AG Grid v12, getLastRenderedRow() was renamed to getLastDisplayedRow()');
    return this.getLastDisplayedRow();
  };
  /** Get the index of the last displayed row due to scrolling (includes invisible rendered rows in the buffer). */
  GridApi.prototype.getLastDisplayedRow = function () {
    return this.rowRenderer.getLastVirtualRenderedRow();
  };
  /** Returns the displayed `RowNode` at the given `index`. */
  GridApi.prototype.getDisplayedRowAtIndex = function (index) {
    return this.rowModel.getRow(index);
  };
  /** Returns the total number of displayed rows. */
  GridApi.prototype.getDisplayedRowCount = function () {
    return this.rowModel.getRowCount();
  };
  /**
   * Returns `true` when the last page is known.
   * This will always be `true` if you are using the Client-Side Row Model for pagination.
   * Returns `false` when the last page is not known; this only happens when using Infinite Row Model.
   */
  GridApi.prototype.paginationIsLastPageFound = function () {
    return this.paginationProxy.isLastPageFound();
  };
  /** Returns how many rows are being shown per page. */
  GridApi.prototype.paginationGetPageSize = function () {
    return this.paginationProxy.getPageSize();
  };
  /** Sets the `paginationPageSize`, then re-paginates the grid so the changes are applied immediately. */
  GridApi.prototype.paginationSetPageSize = function (size) {
    this.gridOptionsWrapper.setProperty('paginationPageSize', size);
  };
  /** Returns the 0-based index of the page which is showing. */
  GridApi.prototype.paginationGetCurrentPage = function () {
    return this.paginationProxy.getCurrentPage();
  };
  /** Returns the total number of pages. Returns `null` if `paginationIsLastPageFound() === false`. */
  GridApi.prototype.paginationGetTotalPages = function () {
    return this.paginationProxy.getTotalPages();
  };
  /** The total number of rows. Returns `null` if `paginationIsLastPageFound() === false`. */
  GridApi.prototype.paginationGetRowCount = function () {
    return this.paginationProxy.getMasterRowCount();
  };
  /** Navigates to the next page. */
  GridApi.prototype.paginationGoToNextPage = function () {
    this.paginationProxy.goToNextPage();
  };
  /** Navigates to the previous page. */
  GridApi.prototype.paginationGoToPreviousPage = function () {
    this.paginationProxy.goToPreviousPage();
  };
  /** Navigates to the first page. */
  GridApi.prototype.paginationGoToFirstPage = function () {
    this.paginationProxy.goToFirstPage();
  };
  /** Navigates to the last page. */
  GridApi.prototype.paginationGoToLastPage = function () {
    this.paginationProxy.goToLastPage();
  };
  /** Goes to the specified page. If the page requested doesn't exist, it will go to the last page. */
  GridApi.prototype.paginationGoToPage = function (page) {
    this.paginationProxy.goToPage(page);
  };
  __decorate$1l([Optional('immutableService')], GridApi.prototype, "immutableService", void 0);
  __decorate$1l([Optional('csvCreator')], GridApi.prototype, "csvCreator", void 0);
  __decorate$1l([Optional('excelCreator')], GridApi.prototype, "excelCreator", void 0);
  __decorate$1l([Autowired('rowRenderer')], GridApi.prototype, "rowRenderer", void 0);
  __decorate$1l([Autowired('navigationService')], GridApi.prototype, "navigationService", void 0);
  __decorate$1l([Autowired('filterManager')], GridApi.prototype, "filterManager", void 0);
  __decorate$1l([Autowired('columnModel')], GridApi.prototype, "columnModel", void 0);
  __decorate$1l([Autowired('selectionService')], GridApi.prototype, "selectionService", void 0);
  __decorate$1l([Autowired('gridOptionsWrapper')], GridApi.prototype, "gridOptionsWrapper", void 0);
  __decorate$1l([Autowired('valueService')], GridApi.prototype, "valueService", void 0);
  __decorate$1l([Autowired('alignedGridsService')], GridApi.prototype, "alignedGridsService", void 0);
  __decorate$1l([Autowired('eventService')], GridApi.prototype, "eventService", void 0);
  __decorate$1l([Autowired('pinnedRowModel')], GridApi.prototype, "pinnedRowModel", void 0);
  __decorate$1l([Autowired('context')], GridApi.prototype, "context", void 0);
  __decorate$1l([Autowired('rowModel')], GridApi.prototype, "rowModel", void 0);
  __decorate$1l([Autowired('sortController')], GridApi.prototype, "sortController", void 0);
  __decorate$1l([Autowired('paginationProxy')], GridApi.prototype, "paginationProxy", void 0);
  __decorate$1l([Autowired('focusService')], GridApi.prototype, "focusService", void 0);
  __decorate$1l([Autowired('dragAndDropService')], GridApi.prototype, "dragAndDropService", void 0);
  __decorate$1l([Optional('rangeService')], GridApi.prototype, "rangeService", void 0);
  __decorate$1l([Optional('clipboardService')], GridApi.prototype, "clipboardService", void 0);
  __decorate$1l([Optional('aggFuncService')], GridApi.prototype, "aggFuncService", void 0);
  __decorate$1l([Autowired('menuFactory')], GridApi.prototype, "menuFactory", void 0);
  __decorate$1l([Optional('contextMenuFactory')], GridApi.prototype, "contextMenuFactory", void 0);
  __decorate$1l([Autowired('valueCache')], GridApi.prototype, "valueCache", void 0);
  __decorate$1l([Autowired('animationFrameService')], GridApi.prototype, "animationFrameService", void 0);
  __decorate$1l([Optional('statusBarService')], GridApi.prototype, "statusBarService", void 0);
  __decorate$1l([Optional('chartService')], GridApi.prototype, "chartService", void 0);
  __decorate$1l([Optional('undoRedoService')], GridApi.prototype, "undoRedoService", void 0);
  __decorate$1l([Optional('rowNodeBlockLoader')], GridApi.prototype, "rowNodeBlockLoader", void 0);
  __decorate$1l([Optional('ssrmTransactionManager')], GridApi.prototype, "serverSideTransactionManager", void 0);
  __decorate$1l([Autowired('ctrlsService')], GridApi.prototype, "ctrlsService", void 0);
  __decorate$1l([Optional('frameworkComponentWrapper')], GridApi.prototype, "frameworkComponentWrapper", void 0);
  __decorate$1l([PostConstruct], GridApi.prototype, "init", null);
  __decorate$1l([PreDestroy], GridApi.prototype, "cleanDownReferencesToAvoidMemoryLeakInCaseApplicationIsKeepingReferenceToDestroyedGrid", null);
  GridApi = __decorate$1l([Bean('gridApi')], GridApi);
  return GridApi;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1x = undefined && undefined.__extends || function () {
  var _extendStatics98 = function extendStatics(d, b) {
    _extendStatics98 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics98(d, b);
  };
  return function (d, b) {
    _extendStatics98(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1m = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$5 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var ExpressionService = /** @class */function (_super) {
  __extends$1x(ExpressionService, _super);
  function ExpressionService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.expressionToFunctionCache = {};
    return _this;
  }
  ExpressionService.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('ExpressionService');
  };
  ExpressionService.prototype.evaluate = function (expressionOrFunc, params) {
    if (typeof expressionOrFunc === 'function') {
      // valueGetter is a function, so just call it
      var func = expressionOrFunc;
      return func(params);
    } else if (typeof expressionOrFunc === 'string') {
      // valueGetter is an expression, so execute the expression
      var expression = expressionOrFunc;
      return this.evaluateExpression(expression, params);
    } else {
      console.error('AG Grid: value should be either a string or a function', expressionOrFunc);
    }
  };
  ExpressionService.prototype.evaluateExpression = function (expression, params) {
    try {
      var javaScriptFunction = this.createExpressionFunction(expression);
      // the params don't have all these values, rather we add every possible
      // value a params can have, which makes whatever is in the params available.
      var result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
      return result;
    } catch (e) {
      // the expression failed, which can happen, as it's the client that
      // provides the expression. so print a nice message
      // tslint:disable-next-line
      console.log('Processing of the expression failed');
      // tslint:disable-next-line
      console.log('Expression = ' + expression);
      // tslint:disable-next-line
      console.log('Params =', params);
      // tslint:disable-next-line
      console.log('Exception = ' + e);
      return null;
    }
  };
  ExpressionService.prototype.createExpressionFunction = function (expression) {
    // check cache first
    if (this.expressionToFunctionCache[expression]) {
      return this.expressionToFunctionCache[expression];
    }
    // if not found in cache, return the function
    var functionBody = this.createFunctionBody(expression);
    var theFunction = new Function('x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup', functionBody);
    // store in cache
    this.expressionToFunctionCache[expression] = theFunction;
    return theFunction;
  };
  ExpressionService.prototype.createFunctionBody = function (expression) {
    // if the expression has the 'return' word in it, then use as is,
    // if not, then wrap it with return and ';' to make a function
    if (expression.indexOf('return') >= 0) {
      return expression;
    } else {
      return 'return ' + expression + ';';
    }
  };
  __decorate$1m([__param$5(0, Qualifier('loggerFactory'))], ExpressionService.prototype, "setBeans", null);
  ExpressionService = __decorate$1m([Bean('expressionService')], ExpressionService);
  return ExpressionService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1y = undefined && undefined.__extends || function () {
  var _extendStatics99 = function extendStatics(d, b) {
    _extendStatics99 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics99(d, b);
  };
  return function (d, b) {
    _extendStatics99(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1n = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TemplateService = /** @class */function (_super) {
  __extends$1y(TemplateService, _super);
  function TemplateService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.templateCache = {};
    _this.waitingCallbacks = {};
    return _this;
  }
  // returns the template if it is loaded, or null if it is not loaded
  // but will call the callback when it is loaded
  TemplateService.prototype.getTemplate = function (url, callback) {
    var templateFromCache = this.templateCache[url];
    if (templateFromCache) {
      return templateFromCache;
    }
    var callbackList = this.waitingCallbacks[url];
    var that = this;
    if (!callbackList) {
      // first time this was called, so need a new list for callbacks
      callbackList = [];
      this.waitingCallbacks[url] = callbackList;
      // and also need to do the http request
      var client = new XMLHttpRequest();
      client.onload = function () {
        that.handleHttpResult(this, url);
      };
      client.open("GET", url);
      client.send();
    }
    // add this callback
    if (callback) {
      callbackList.push(callback);
    }
    // caller needs to wait for template to load, so return null
    return null;
  };
  TemplateService.prototype.handleHttpResult = function (httpResult, url) {
    if (httpResult.status !== 200 || httpResult.response === null) {
      console.warn("Unable to get template error " + httpResult.status + " - " + url);
      return;
    }
    // response success, so process it
    // in IE9 the response is in - responseText
    this.templateCache[url] = httpResult.response || httpResult.responseText;
    // inform all listeners that this is now in the cache
    var callbacks = this.waitingCallbacks[url];
    for (var i = 0; i < callbacks.length; i++) {
      var callback = callbacks[i];
      // we could pass the callback the response, however we know the client of this code
      // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
      // which doesn't take any parameters.
      callback();
    }
    if (this.$scope) {
      var that_1 = this;
      window.setTimeout(function () {
        that_1.$scope.$apply();
      }, 0);
    }
  };
  __decorate$1n([Autowired('$scope')], TemplateService.prototype, "$scope", void 0);
  TemplateService = __decorate$1n([Bean('templateService')], TemplateService);
  return TemplateService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1z = undefined && undefined.__extends || function () {
  var _extendStatics100 = function extendStatics(d, b) {
    _extendStatics100 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics100(d, b);
  };
  return function (d, b) {
    _extendStatics100(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1o = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$b = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var FocusService = /** @class */function (_super) {
  __extends$1z(FocusService, _super);
  function FocusService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FocusService_1 = FocusService;
  /**
   * Adds a gridCore to the list of the gridCores monitoring Keyboard Mode
   * in a specific HTMLDocument.
   *
   * @param doc {Document} - The Document containing the gridCore.
   * @param gridCore {GridComp} - The GridCore to be monitored.
   */
  FocusService.addKeyboardModeEvents = function (doc, controller) {
    var docControllers = FocusService_1.instancesMonitored.get(doc);
    if (docControllers && docControllers.length > 0) {
      if (docControllers.indexOf(controller) === -1) {
        docControllers.push(controller);
      }
    } else {
      FocusService_1.instancesMonitored.set(doc, [controller]);
      doc.addEventListener('keydown', FocusService_1.toggleKeyboardMode);
      doc.addEventListener('mousedown', FocusService_1.toggleKeyboardMode);
    }
  };
  /**
   * Removes a gridCore from the list of the gridCores monitoring Keyboard Mode
   * in a specific HTMLDocument.
   *
   * @param doc {Document} - The Document containing the gridCore.
   * @param gridCore {GridComp} - The GridCore to be removed.
   */
  FocusService.removeKeyboardModeEvents = function (doc, controller) {
    var docControllers = FocusService_1.instancesMonitored.get(doc);
    var newControllers = [];
    if (docControllers && docControllers.length) {
      newControllers = __spreadArrays$b(docControllers).filter(function (currentGridCore) {
        return currentGridCore !== controller;
      });
      FocusService_1.instancesMonitored.set(doc, newControllers);
    }
    if (newControllers.length === 0) {
      doc.removeEventListener('keydown', FocusService_1.toggleKeyboardMode);
      doc.removeEventListener('mousedown', FocusService_1.toggleKeyboardMode);
    }
  };
  /**
   * This method will be called by `keydown` and `mousedown` events on all Documents monitoring
   * KeyboardMode. It will then fire a KEYBOARD_FOCUS, MOUSE_FOCUS on each gridCore present in
   * the Document allowing each gridCore to maintain a state for KeyboardMode.
   *
   * @param event {KeyboardEvent | MouseEvent | TouchEvent} - The event triggered.
   */
  FocusService.toggleKeyboardMode = function (event) {
    var isKeyboardActive = FocusService_1.keyboardModeActive;
    var isKeyboardEvent = event.type === 'keydown';
    if (isKeyboardEvent) {
      // the following keys should not toggle keyboard mode.
      if (event.ctrlKey || event.metaKey || event.altKey) {
        return;
      }
    }
    if (isKeyboardActive && isKeyboardEvent || !isKeyboardActive && !isKeyboardEvent) {
      return;
    }
    FocusService_1.keyboardModeActive = isKeyboardEvent;
    var doc = event.target.ownerDocument;
    if (!doc) {
      return;
    }
    var controllersForDoc = FocusService_1.instancesMonitored.get(doc);
    if (controllersForDoc) {
      controllersForDoc.forEach(function (controller) {
        controller.dispatchEvent({
          type: isKeyboardEvent ? Events.EVENT_KEYBOARD_FOCUS : Events.EVENT_MOUSE_FOCUS
        });
      });
    }
  };
  FocusService.prototype.init = function () {
    var _this = this;
    var clearFocusedCellListener = this.clearFocusedCell.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, clearFocusedCellListener);
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, clearFocusedCellListener);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, clearFocusedCellListener);
    this.ctrlsService.whenReady(function (p) {
      _this.gridCtrl = p.gridCtrl;
      var doc = _this.gridOptionsWrapper.getDocument();
      FocusService_1.addKeyboardModeEvents(doc, _this.gridCtrl);
      _this.addDestroyFunc(function () {
        return _this.unregisterGridCompController(_this.gridCtrl);
      });
    });
  };
  FocusService.prototype.unregisterGridCompController = function (gridCompController) {
    var doc = this.gridOptionsWrapper.getDocument();
    FocusService_1.removeKeyboardModeEvents(doc, gridCompController);
  };
  FocusService.prototype.onColumnEverythingChanged = function () {
    // if the columns change, check and see if this column still exists. if it does, then
    // we can keep the focused cell. if it doesn't, then we need to drop the focused cell.
    if (!this.focusedCellPosition) {
      return;
    }
    var col = this.focusedCellPosition.column;
    var colFromColumnModel = this.columnModel.getGridColumn(col.getId());
    if (col !== colFromColumnModel) {
      this.clearFocusedCell();
    }
  };
  FocusService.prototype.isKeyboardMode = function () {
    return FocusService_1.keyboardModeActive;
  };
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  FocusService.prototype.getFocusCellToUseAfterRefresh = function () {
    if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh() || !this.focusedCellPosition) {
      return null;
    }
    // we check that the browser is actually focusing on the grid, if it is not, then
    // we have nothing to worry about. we check for ROW data, as this covers both focused Rows (for Full Width Rows)
    // and Cells (covers cells as cells live in rows)
    if (this.isDomDataMissingInHierarchy(document.activeElement, RowCtrl.DOM_DATA_KEY_ROW_CTRL)) {
      return null;
    }
    return this.focusedCellPosition;
  };
  FocusService.prototype.getFocusHeaderToUseAfterRefresh = function () {
    if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh() || !this.focusedHeaderPosition) {
      return null;
    }
    // we check that the browser is actually focusing on the grid, if it is not, then
    // we have nothing to worry about
    if (this.isDomDataMissingInHierarchy(document.activeElement, AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL)) {
      return null;
    }
    return this.focusedHeaderPosition;
  };
  FocusService.prototype.isDomDataMissingInHierarchy = function (eBrowserCell, key) {
    var ePointer = eBrowserCell;
    while (ePointer) {
      var data = this.gridOptionsWrapper.getDomData(ePointer, key);
      if (data) {
        return false;
      }
      ePointer = ePointer.parentNode;
    }
    return true;
  };
  FocusService.prototype.clearFocusedCell = function () {
    this.focusedCellPosition = null;
    this.onCellFocused(false);
  };
  FocusService.prototype.getFocusedCell = function () {
    return this.focusedCellPosition;
  };
  FocusService.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
    if (forceBrowserFocus === void 0) {
      forceBrowserFocus = false;
    }
    var gridColumn = this.columnModel.getGridColumn(colKey);
    // if column doesn't exist, then blank the focused cell and return. this can happen when user sets new columns,
    // and the focused cell is in a column that no longer exists. after columns change, the grid refreshes and tries
    // to re-focus the focused cell.
    if (!gridColumn) {
      this.focusedCellPosition = null;
      return;
    }
    this.focusedCellPosition = gridColumn ? {
      rowIndex: rowIndex,
      rowPinned: makeNull(floating),
      column: gridColumn
    } : null;
    this.onCellFocused(forceBrowserFocus);
  };
  FocusService.prototype.isCellFocused = function (cellPosition) {
    if (this.focusedCellPosition == null) {
      return false;
    }
    return this.focusedCellPosition.column === cellPosition.column && this.isRowFocused(cellPosition.rowIndex, cellPosition.rowPinned);
  };
  FocusService.prototype.isRowNodeFocused = function (rowNode) {
    return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
  };
  FocusService.prototype.isHeaderWrapperFocused = function (headerCtrl) {
    if (this.focusedHeaderPosition == null) {
      return false;
    }
    var column = headerCtrl.getColumnGroupChild();
    var headerRowIndex = headerCtrl.getRowIndex();
    var pinned = headerCtrl.getPinned();
    var _a = this.focusedHeaderPosition,
      focusedColumn = _a.column,
      focusedHeaderRowIndex = _a.headerRowIndex;
    return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
  };
  FocusService.prototype.clearFocusedHeader = function () {
    this.focusedHeaderPosition = null;
  };
  FocusService.prototype.getFocusedHeader = function () {
    return this.focusedHeaderPosition;
  };
  FocusService.prototype.setFocusedHeader = function (headerRowIndex, column) {
    this.focusedHeaderPosition = {
      headerRowIndex: headerRowIndex,
      column: column
    };
  };
  FocusService.prototype.focusHeaderPosition = function (params) {
    var direction = params.direction,
      fromTab = params.fromTab,
      allowUserOverride = params.allowUserOverride,
      event = params.event;
    var headerPosition = params.headerPosition;
    if (allowUserOverride) {
      var gridOptionsWrapper = this.gridOptionsWrapper;
      var currentPosition = this.getFocusedHeader();
      var headerRowCount = this.headerNavigationService.getHeaderRowCount();
      if (fromTab) {
        var userFunc = gridOptionsWrapper.getTabToNextHeaderFunc();
        if (userFunc) {
          var params_1 = {
            backwards: direction === 'Before',
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount,
            api: gridOptionsWrapper.getApi(),
            columnApi: gridOptionsWrapper.getColumnApi()
          };
          headerPosition = userFunc(params_1);
        }
      } else {
        var userFunc = gridOptionsWrapper.getNavigateToNextHeaderFunc();
        if (userFunc && event) {
          var params_2 = {
            key: event.key,
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount,
            event: event,
            api: gridOptionsWrapper.getApi(),
            columnApi: gridOptionsWrapper.getColumnApi()
          };
          headerPosition = userFunc(params_2);
        }
      }
    }
    if (!headerPosition) {
      return false;
    }
    if (headerPosition.headerRowIndex === -1) {
      return this.focusGridView(headerPosition.column);
    }
    this.headerNavigationService.scrollToColumn(headerPosition.column, direction);
    var headerRowContainerCtrl = this.ctrlsService.getHeaderRowContainerCtrl(headerPosition.column.getPinned());
    // this will automatically call the setFocusedHeader method above
    var focusSuccess = headerRowContainerCtrl.focusHeader(headerPosition.headerRowIndex, headerPosition.column, event);
    return focusSuccess;
  };
  FocusService.prototype.isAnyCellFocused = function () {
    return !!this.focusedCellPosition;
  };
  FocusService.prototype.isRowFocused = function (rowIndex, floating) {
    if (this.focusedCellPosition == null) {
      return false;
    }
    return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === makeNull(floating);
  };
  FocusService.prototype.findFocusableElements = function (rootNode, exclude, onlyUnmanaged) {
    if (onlyUnmanaged === void 0) {
      onlyUnmanaged = false;
    }
    var focusableString = Constants.FOCUSABLE_SELECTOR;
    var excludeString = Constants.FOCUSABLE_EXCLUDE;
    if (exclude) {
      excludeString += ', ' + exclude;
    }
    if (onlyUnmanaged) {
      excludeString += ', [tabindex="-1"]';
    }
    var nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString));
    var excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
    if (!excludeNodes.length) {
      return nodes;
    }
    var diff = function diff(a, b) {
      return a.filter(function (element) {
        return b.indexOf(element) === -1;
      });
    };
    return diff(nodes, excludeNodes);
  };
  FocusService.prototype.focusInto = function (rootNode, up, onlyUnmanaged) {
    if (up === void 0) {
      up = false;
    }
    if (onlyUnmanaged === void 0) {
      onlyUnmanaged = false;
    }
    var focusableElements = this.findFocusableElements(rootNode, null, onlyUnmanaged);
    var toFocus = up ? last(focusableElements) : focusableElements[0];
    if (toFocus) {
      toFocus.focus();
      return true;
    }
    return false;
  };
  FocusService.prototype.findNextFocusableElement = function (rootNode, onlyManaged, backwards) {
    var focusable = this.findFocusableElements(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
    var currentIndex;
    if (onlyManaged) {
      currentIndex = findIndex(focusable, function (el) {
        return el.contains(document.activeElement);
      });
    } else {
      currentIndex = focusable.indexOf(document.activeElement);
    }
    var nextIndex = currentIndex + (backwards ? -1 : 1);
    if (nextIndex < 0 || nextIndex >= focusable.length) {
      return null;
    }
    return focusable[nextIndex];
  };
  FocusService.prototype.isFocusUnderManagedComponent = function (rootNode) {
    var managedContainers = rootNode.querySelectorAll("." + ManagedFocusFeature.FOCUS_MANAGED_CLASS);
    if (!managedContainers.length) {
      return false;
    }
    for (var i = 0; i < managedContainers.length; i++) {
      if (managedContainers[i].contains(document.activeElement)) {
        return true;
      }
    }
    return false;
  };
  FocusService.prototype.findTabbableParent = function (node, limit) {
    if (limit === void 0) {
      limit = 5;
    }
    var counter = 0;
    while (node && getTabIndex(node) === null && ++counter <= limit) {
      node = node.parentElement;
    }
    if (getTabIndex(node) === null) {
      return null;
    }
    return node;
  };
  FocusService.prototype.onCellFocused = function (forceBrowserFocus) {
    var event = {
      type: Events.EVENT_CELL_FOCUSED,
      forceBrowserFocus: forceBrowserFocus,
      rowIndex: null,
      column: null,
      floating: null,
      api: this.gridApi,
      columnApi: this.columnApi,
      rowPinned: null,
      isFullWidthCell: false
    };
    if (this.focusedCellPosition) {
      var rowIndex = event.rowIndex = this.focusedCellPosition.rowIndex;
      var rowPinned = event.rowPinned = this.focusedCellPosition.rowPinned;
      event.column = this.focusedCellPosition.column;
      var rowCtrl = this.rowRenderer.getRowByPosition({
        rowIndex: rowIndex,
        rowPinned: rowPinned
      });
      if (rowCtrl) {
        event.isFullWidthCell = rowCtrl.isFullWidth();
      }
    }
    this.eventService.dispatchEvent(event);
  };
  FocusService.prototype.focusGridView = function (column, backwards) {
    var nextRow = backwards ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
    if (!nextRow) {
      return false;
    }
    var rowIndex = nextRow.rowIndex,
      rowPinned = nextRow.rowPinned;
    var focusedHeader = this.getFocusedHeader();
    if (!column && focusedHeader) {
      column = focusedHeader.column;
    }
    if (rowIndex == null || !column) {
      return false;
    }
    this.navigationService.ensureCellVisible({
      rowIndex: rowIndex,
      column: column,
      rowPinned: rowPinned
    });
    this.setFocusedCell(rowIndex, column, makeNull(rowPinned), true);
    if (this.rangeService) {
      var cellPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned,
        column: column
      };
      this.rangeService.setRangeToCell(cellPosition);
    }
    return true;
  };
  FocusService.prototype.focusNextGridCoreContainer = function (backwards) {
    if (this.gridCtrl.focusNextInnerContainer(backwards)) {
      return true;
    }
    if (!backwards) {
      this.gridCtrl.forceFocusOutOfContainer();
    }
    return false;
  };
  var FocusService_1;
  FocusService.AG_KEYBOARD_FOCUS = 'ag-keyboard-focus';
  FocusService.keyboardModeActive = false;
  FocusService.instancesMonitored = new Map();
  __decorate$1o([Autowired('columnModel')], FocusService.prototype, "columnModel", void 0);
  __decorate$1o([Autowired('headerNavigationService')], FocusService.prototype, "headerNavigationService", void 0);
  __decorate$1o([Autowired('columnApi')], FocusService.prototype, "columnApi", void 0);
  __decorate$1o([Autowired('gridApi')], FocusService.prototype, "gridApi", void 0);
  __decorate$1o([Autowired('rowRenderer')], FocusService.prototype, "rowRenderer", void 0);
  __decorate$1o([Autowired('rowPositionUtils')], FocusService.prototype, "rowPositionUtils", void 0);
  __decorate$1o([Optional('rangeService')], FocusService.prototype, "rangeService", void 0);
  __decorate$1o([Autowired('navigationService')], FocusService.prototype, "navigationService", void 0);
  __decorate$1o([Autowired('ctrlsService')], FocusService.prototype, "ctrlsService", void 0);
  __decorate$1o([PostConstruct], FocusService.prototype, "init", null);
  FocusService = FocusService_1 = __decorate$1o([Bean('focusService')], FocusService);
  return FocusService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1A = undefined && undefined.__extends || function () {
  var _extendStatics101 = function extendStatics(d, b) {
    _extendStatics101 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics101(d, b);
  };
  return function (d, b) {
    _extendStatics101(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1p = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DIRECTION;
(function (DIRECTION) {
  DIRECTION[DIRECTION["vertical"] = 0] = "vertical";
  DIRECTION[DIRECTION["horizontal"] = 1] = "horizontal";
})(DIRECTION || (DIRECTION = {}));
var instanceIdSeq = 0;
var PopupService = /** @class */function (_super) {
  __extends$1A(PopupService, _super);
  function PopupService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.popupList = [];
    return _this;
  }
  PopupService.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      _this.gridCtrl = p.gridCtrl;
      _this.addManagedListener(_this.gridCtrl, Events.EVENT_KEYBOARD_FOCUS, function () {
        forEach$4(_this.popupList, function (popup) {
          return addCssClass(popup.element, FocusService.AG_KEYBOARD_FOCUS);
        });
      });
      _this.addManagedListener(_this.gridCtrl, Events.EVENT_MOUSE_FOCUS, function () {
        forEach$4(_this.popupList, function (popup) {
          return removeCssClass(popup.element, FocusService.AG_KEYBOARD_FOCUS);
        });
      });
    });
  };
  PopupService.prototype.getPopupParent = function () {
    var ePopupParent = this.gridOptionsWrapper.getPopupParent();
    if (ePopupParent) {
      return ePopupParent;
    }
    return this.gridCtrl.getGui();
  };
  PopupService.prototype.positionPopupForMenu = function (params) {
    var sourceRect = params.eventSource.getBoundingClientRect();
    var parentRect = this.getParentRect();
    var y = this.keepXYWithinBounds(params.ePopup, sourceRect.top - parentRect.top, DIRECTION.vertical);
    var minWidth = params.ePopup.clientWidth > 0 ? params.ePopup.clientWidth : 200;
    params.ePopup.style.minWidth = minWidth + "px";
    var widthOfParent = parentRect.right - parentRect.left;
    var maxX = widthOfParent - minWidth;
    // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
    // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
    // we try place it first to the left, and then if not to the right.
    var x;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      // for RTL, try left first
      x = xLeftPosition();
      if (x < 0) {
        x = xRightPosition();
      }
      if (x > maxX) {
        x = 0;
      }
    } else {
      // for LTR, try right first
      x = xRightPosition();
      if (x > maxX) {
        x = xLeftPosition();
      }
      if (x < 0) {
        x = 0;
      }
    }
    params.ePopup.style.left = x + "px";
    params.ePopup.style.top = y + "px";
    function xRightPosition() {
      return sourceRect.right - parentRect.left - 2;
    }
    function xLeftPosition() {
      return sourceRect.left - parentRect.left - minWidth;
    }
  };
  PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
    var ePopup = params.ePopup,
      nudgeX = params.nudgeX,
      nudgeY = params.nudgeY;
    var _a = this.calculatePointerAlign(params.mouseEvent),
      x = _a.x,
      y = _a.y;
    this.positionPopup({
      ePopup: ePopup,
      x: x,
      y: y,
      nudgeX: nudgeX,
      nudgeY: nudgeY,
      keepWithinBounds: true
    });
    this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode);
  };
  PopupService.prototype.calculatePointerAlign = function (e) {
    var parentRect = this.getParentRect();
    return {
      x: e.clientX - parentRect.left,
      y: e.clientY - parentRect.top
    };
  };
  PopupService.prototype.positionPopupUnderComponent = function (params) {
    var sourceRect = params.eventSource.getBoundingClientRect();
    var alignSide = params.alignSide || 'left';
    var parentRect = this.getParentRect();
    var x = sourceRect.left - parentRect.left;
    if (alignSide === 'right') {
      x -= params.ePopup.offsetWidth - sourceRect.width;
    }
    this.positionPopup({
      ePopup: params.ePopup,
      nudgeX: params.nudgeX,
      nudgeY: params.nudgeY,
      x: x,
      y: sourceRect.top - parentRect.top + sourceRect.height,
      keepWithinBounds: params.keepWithinBounds
    });
    this.callPostProcessPopup(params.type, params.ePopup, params.eventSource, null, params.column, params.rowNode);
  };
  PopupService.prototype.positionPopupOverComponent = function (params) {
    var sourceRect = params.eventSource.getBoundingClientRect();
    var parentRect = this.getParentRect();
    this.positionPopup({
      ePopup: params.ePopup,
      nudgeX: params.nudgeX,
      nudgeY: params.nudgeY,
      x: sourceRect.left - parentRect.left,
      y: sourceRect.top - parentRect.top,
      keepWithinBounds: params.keepWithinBounds
    });
    this.callPostProcessPopup(params.type, params.ePopup, params.eventSource, null, params.column, params.rowNode);
  };
  PopupService.prototype.callPostProcessPopup = function (type, ePopup, eventSource, mouseEvent, column, rowNode) {
    var callback = this.gridOptionsWrapper.getPostProcessPopupFunc();
    if (callback) {
      var params = {
        column: column,
        rowNode: rowNode,
        ePopup: ePopup,
        type: type,
        eventSource: eventSource,
        mouseEvent: mouseEvent
      };
      callback(params);
    }
  };
  PopupService.prototype.positionPopup = function (params) {
    var ePopup = params.ePopup,
      keepWithinBounds = params.keepWithinBounds,
      nudgeX = params.nudgeX,
      nudgeY = params.nudgeY;
    var x = params.x,
      y = params.y;
    if (nudgeX) {
      x += nudgeX;
    }
    if (nudgeY) {
      y += nudgeY;
    }
    // if popup is overflowing to the bottom, move it up
    if (keepWithinBounds) {
      x = this.keepXYWithinBounds(ePopup, x, DIRECTION.horizontal);
      y = this.keepXYWithinBounds(ePopup, y, DIRECTION.vertical);
    }
    ePopup.style.left = x + "px";
    ePopup.style.top = y + "px";
  };
  PopupService.prototype.getActivePopups = function () {
    return this.popupList.map(function (popup) {
      return popup.element;
    });
  };
  PopupService.prototype.getPopupList = function () {
    return this.popupList;
  };
  PopupService.prototype.getParentRect = function () {
    // subtract the popup parent borders, because popupParent.getBoundingClientRect
    // returns the rect outside the borders, but the 0,0 coordinate for absolute
    // positioning is inside the border, leading the popup to be off by the width
    // of the border
    var eDocument = this.gridOptionsWrapper.getDocument();
    var popupParent = this.getPopupParent();
    if (popupParent === eDocument.body) {
      popupParent = eDocument.documentElement;
    }
    var style = getComputedStyle(popupParent);
    var bounds = popupParent.getBoundingClientRect();
    return {
      top: bounds.top + parseFloat(style.borderTopWidth) || 0,
      left: bounds.left + parseFloat(style.borderLeftWidth) || 0,
      right: bounds.right + parseFloat(style.borderRightWidth) || 0,
      bottom: bounds.bottom + parseFloat(style.borderBottomWidth) || 0
    };
  };
  PopupService.prototype.keepXYWithinBounds = function (ePopup, position, direction) {
    var isVertical = direction === DIRECTION.vertical;
    var sizeProperty = isVertical ? 'clientHeight' : 'clientWidth';
    var anchorProperty = isVertical ? 'top' : 'left';
    var offsetProperty = isVertical ? 'offsetHeight' : 'offsetWidth';
    var scrollPositionProperty = isVertical ? 'scrollTop' : 'scrollLeft';
    var eDocument = this.gridOptionsWrapper.getDocument();
    var docElement = eDocument.documentElement;
    var popupParent = this.getPopupParent();
    var parentRect = popupParent.getBoundingClientRect();
    var documentRect = eDocument.documentElement.getBoundingClientRect();
    var isBody = popupParent === eDocument.body;
    var offsetSize = ePopup[offsetProperty];
    var getSize = isVertical ? getAbsoluteHeight : getAbsoluteWidth;
    var sizeOfParent = isBody ? getSize(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
    if (isBody) {
      sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
    }
    var max = sizeOfParent - offsetSize;
    return Math.min(Math.max(position, 0), Math.abs(max));
  };
  PopupService.prototype.keepPopupPositionedRelativeTo = function (params) {
    var _this = this;
    var eParent = this.getPopupParent();
    var parentRect = eParent.getBoundingClientRect();
    var sourceRect = params.element.getBoundingClientRect();
    var initialDiffTop = parentRect.top - sourceRect.top;
    var initialDiffLeft = parentRect.left - sourceRect.left;
    var lastDiffTop = initialDiffTop;
    var lastDiffLeft = initialDiffLeft;
    var topPx = params.ePopup.style.top;
    var top = parseInt(topPx.substring(0, topPx.length - 1), 10);
    var leftPx = params.ePopup.style.left;
    var left = parseInt(leftPx.substring(0, leftPx.length - 1), 10);
    return new AgPromise(function (resolve) {
      _this.getFrameworkOverrides().setInterval(function () {
        var pRect = eParent.getBoundingClientRect();
        var sRect = params.element.getBoundingClientRect();
        var elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
        if (elementNotInDom) {
          params.hidePopup();
          return;
        }
        var currentDiffTop = pRect.top - sRect.top;
        if (currentDiffTop != lastDiffTop) {
          var newTop = _this.keepXYWithinBounds(params.ePopup, top + initialDiffTop - currentDiffTop, DIRECTION.vertical);
          params.ePopup.style.top = newTop + "px";
        }
        lastDiffTop = currentDiffTop;
        var currentDiffLeft = pRect.left - sRect.left;
        if (currentDiffLeft != lastDiffLeft) {
          var newLeft = _this.keepXYWithinBounds(params.ePopup, left + initialDiffLeft - currentDiffLeft, DIRECTION.horizontal);
          params.ePopup.style.left = newLeft + "px";
        }
        lastDiffLeft = currentDiffLeft;
      }, 200).then(function (intervalId) {
        var result = function result() {
          if (intervalId != null) {
            window.clearInterval(intervalId);
          }
        };
        resolve(result);
      });
    });
  };
  PopupService.prototype.addPopup = function (params) {
    var _this = this;
    var modal = params.modal,
      eChild = params.eChild,
      closeOnEsc = params.closeOnEsc,
      closedCallback = params.closedCallback,
      click = params.click,
      alwaysOnTop = params.alwaysOnTop,
      afterGuiAttached = params.afterGuiAttached,
      positionCallback = params.positionCallback,
      anchorToElement = params.anchorToElement,
      ariaLabel = params.ariaLabel;
    var eDocument = this.gridOptionsWrapper.getDocument();
    var destroyPositionTracker = new AgPromise(function (resolve) {
      return resolve(function () {});
    });
    if (!eDocument) {
      console.warn('ag-grid: could not find the document, document is empty');
      return {
        hideFunc: function hideFunc() {},
        stopAnchoringPromise: destroyPositionTracker
      };
    }
    var pos = findIndex(this.popupList, function (popup) {
      return popup.element === eChild;
    });
    if (pos !== -1) {
      var popup = this.popupList[pos];
      return {
        hideFunc: popup.hideFunc,
        stopAnchoringPromise: popup.stopAnchoringPromise
      };
    }
    var ePopupParent = this.getPopupParent();
    if (eChild.style.top == null) {
      eChild.style.top = '0px';
    }
    if (eChild.style.left == null) {
      eChild.style.left = '0px';
    }
    // add env CSS class to child, in case user provided a popup parent, which means
    // theme class may be missing
    var eWrapper = document.createElement('div');
    var theme = this.environment.getTheme().theme;
    if (theme) {
      addCssClass(eWrapper, theme);
    }
    addCssClass(eWrapper, 'ag-popup');
    addCssClass(eChild, this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr');
    addCssClass(eChild, 'ag-popup-child');
    setAriaRole(eChild, 'dialog');
    _setAriaLabel(eChild, ariaLabel);
    if (this.focusService.isKeyboardMode()) {
      addCssClass(eChild, FocusService.AG_KEYBOARD_FOCUS);
    }
    eWrapper.appendChild(eChild);
    ePopupParent.appendChild(eWrapper);
    if (alwaysOnTop) {
      this.setAlwaysOnTop(eWrapper, true);
    } else {
      this.bringPopupToFront(eWrapper);
    }
    var popupHidden = false;
    var hidePopupOnKeyboardEvent = function hidePopupOnKeyboardEvent(event) {
      if (!eWrapper.contains(document.activeElement)) {
        return;
      }
      var key = event.which || event.keyCode;
      if (key === KeyCode.ESCAPE) {
        hidePopup({
          keyboardEvent: event
        });
      }
    };
    var hidePopupOnMouseEvent = function hidePopupOnMouseEvent(event) {
      return hidePopup({
        mouseEvent: event
      });
    };
    var hidePopupOnTouchEvent = function hidePopupOnTouchEvent(event) {
      return hidePopup({
        touchEvent: event
      });
    };
    var hidePopup = function hidePopup(popupParams) {
      if (popupParams === void 0) {
        popupParams = {};
      }
      var mouseEvent = popupParams.mouseEvent,
        touchEvent = popupParams.touchEvent,
        keyboardEvent = popupParams.keyboardEvent;
      if (
      // we don't hide popup if the event was on the child, or any
      // children of this child
      _this.isEventFromCurrentPopup({
        mouseEvent: mouseEvent,
        touchEvent: touchEvent
      }, eChild) ||
      // if the event to close is actually the open event, then ignore it
      _this.isEventSameChainAsOriginalEvent({
        originalMouseEvent: click,
        mouseEvent: mouseEvent,
        touchEvent: touchEvent
      }) ||
      // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      popupHidden) {
        return;
      }
      popupHidden = true;
      ePopupParent.removeChild(eWrapper);
      eDocument.removeEventListener('keydown', hidePopupOnKeyboardEvent);
      eDocument.removeEventListener('mousedown', hidePopupOnMouseEvent);
      eDocument.removeEventListener('touchstart', hidePopupOnTouchEvent);
      eDocument.removeEventListener('contextmenu', hidePopupOnMouseEvent);
      _this.eventService.removeEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
      if (closedCallback) {
        closedCallback(mouseEvent || touchEvent || keyboardEvent);
      }
      _this.popupList = _this.popupList.filter(function (popup) {
        return popup.element !== eChild;
      });
      if (destroyPositionTracker) {
        destroyPositionTracker.then(function (destroyFunc) {
          return destroyFunc && destroyFunc();
        });
      }
    };
    if (afterGuiAttached) {
      afterGuiAttached({
        hidePopup: hidePopup
      });
    }
    // if we add these listeners now, then the current mouse
    // click will be included, which we don't want
    window.setTimeout(function () {
      if (closeOnEsc) {
        eDocument.addEventListener('keydown', hidePopupOnKeyboardEvent);
      }
      if (modal) {
        eDocument.addEventListener('mousedown', hidePopupOnMouseEvent);
        _this.eventService.addEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
        eDocument.addEventListener('touchstart', hidePopupOnTouchEvent);
        eDocument.addEventListener('contextmenu', hidePopupOnMouseEvent);
      }
    }, 0);
    if (positionCallback) {
      positionCallback();
    }
    if (anchorToElement) {
      // keeps popup positioned under created, eg if context menu, if user scrolls
      // using touchpad and the cell moves, it moves the popup to keep it with the cell.
      destroyPositionTracker = this.keepPopupPositionedRelativeTo({
        element: anchorToElement,
        ePopup: eChild,
        hidePopup: hidePopup
      });
    }
    this.popupList.push({
      element: eChild,
      wrapper: eWrapper,
      hideFunc: hidePopup,
      stopAnchoringPromise: destroyPositionTracker,
      instanceId: instanceIdSeq++,
      isAnchored: !!anchorToElement
    });
    return {
      hideFunc: hidePopup,
      stopAnchoringPromise: destroyPositionTracker
    };
  };
  PopupService.prototype.hasAnchoredPopup = function () {
    return some(this.popupList, function (popup) {
      return popup.isAnchored;
    });
  };
  PopupService.prototype.isEventFromCurrentPopup = function (params, target) {
    var mouseEvent = params.mouseEvent,
      touchEvent = params.touchEvent;
    var event = mouseEvent ? mouseEvent : touchEvent;
    if (!event) {
      return false;
    }
    var indexOfThisChild = findIndex(this.popupList, function (popup) {
      return popup.element === target;
    });
    if (indexOfThisChild === -1) {
      return false;
    }
    for (var i = indexOfThisChild; i < this.popupList.length; i++) {
      var popup = this.popupList[i];
      if (isElementInEventPath(popup.element, event)) {
        return true;
      }
    }
    // if the user did not write their own Custom Element to be rendered as popup
    // and this component has an additional popup element, they should have the
    // `ag-custom-component-popup` class to be detected as part of the Custom Component
    return this.isElementWithinCustomPopup(event.target);
  };
  PopupService.prototype.isElementWithinCustomPopup = function (el) {
    while (el && el !== document.body) {
      if (el.classList.contains('ag-custom-component-popup') || el.parentElement === null) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  };
  // in some browsers, the context menu event can be fired before the click event, which means
  // the context menu event could open the popup, but then the click event closes it straight away.
  PopupService.prototype.isEventSameChainAsOriginalEvent = function (params) {
    var originalMouseEvent = params.originalMouseEvent,
      mouseEvent = params.mouseEvent,
      touchEvent = params.touchEvent;
    // we check the coordinates of the event, to see if it's the same event. there is a 1 / 1000 chance that
    // the event is a different event, however that is an edge case that is not very relevant (the user clicking
    // twice on the same location isn't a normal path).
    // event could be mouse event or touch event.
    var mouseEventOrTouch = null;
    if (mouseEvent) {
      // mouse event can be used direction, it has coordinates
      mouseEventOrTouch = mouseEvent;
    } else if (touchEvent) {
      // touch event doesn't have coordinates, need it's touch object
      mouseEventOrTouch = touchEvent.touches[0];
    }
    if (mouseEventOrTouch && originalMouseEvent) {
      // for x, allow 4px margin, to cover iPads, where touch (which opens menu) is followed
      // by browser click (when you finger up, touch is interrupted as click in browser)
      var screenX_1 = mouseEvent ? mouseEvent.screenX : 0;
      var screenY_1 = mouseEvent ? mouseEvent.screenY : 0;
      var xMatch = Math.abs(originalMouseEvent.screenX - screenX_1) < 5;
      var yMatch = Math.abs(originalMouseEvent.screenY - screenY_1) < 5;
      if (xMatch && yMatch) {
        return true;
      }
    }
    return false;
  };
  PopupService.prototype.getWrapper = function (ePopup) {
    while (!containsClass(ePopup, 'ag-popup') && ePopup.parentElement) {
      ePopup = ePopup.parentElement;
    }
    return containsClass(ePopup, 'ag-popup') ? ePopup : null;
  };
  PopupService.prototype.setAlwaysOnTop = function (ePopup, alwaysOnTop) {
    var eWrapper = this.getWrapper(ePopup);
    if (!eWrapper) {
      return;
    }
    addOrRemoveCssClass(eWrapper, 'ag-always-on-top', !!alwaysOnTop);
    if (alwaysOnTop) {
      this.bringPopupToFront(eWrapper);
    }
  };
  PopupService.prototype.bringPopupToFront = function (ePopup) {
    var parent = this.getPopupParent();
    var popupList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup'));
    var popupLen = popupList.length;
    var alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll('.ag-popup.ag-always-on-top'));
    var onTopLength = alwaysOnTopList.length;
    var eWrapper = this.getWrapper(ePopup);
    if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) {
      return;
    }
    var pos = popupList.indexOf(eWrapper);
    if (onTopLength) {
      var isPopupAlwaysOnTop = containsClass(eWrapper, 'ag-always-on-top');
      if (isPopupAlwaysOnTop) {
        if (pos !== popupLen - 1) {
          last(alwaysOnTopList).insertAdjacentElement('afterend', eWrapper);
        }
      } else if (pos !== popupLen - onTopLength - 1) {
        alwaysOnTopList[0].insertAdjacentElement('beforebegin', eWrapper);
      }
    } else if (pos !== popupLen - 1) {
      last(popupList).insertAdjacentElement('afterend', eWrapper);
    }
    var params = {
      type: 'popupToFront',
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      eWrapper: eWrapper
    };
    this.eventService.dispatchEvent(params);
  };
  __decorate$1p([Autowired('environment')], PopupService.prototype, "environment", void 0);
  __decorate$1p([Autowired('focusService')], PopupService.prototype, "focusService", void 0);
  __decorate$1p([Autowired('ctrlsService')], PopupService.prototype, "ctrlsService", void 0);
  __decorate$1p([PostConstruct], PopupService.prototype, "postConstruct", null);
  PopupService = __decorate$1p([Bean('popupService')], PopupService);
  return PopupService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1B = undefined && undefined.__extends || function () {
  var _extendStatics102 = function extendStatics(d, b) {
    _extendStatics102 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics102(d, b);
  };
  return function (d, b) {
    _extendStatics102(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$6 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var LoggerFactory = /** @class */function (_super) {
  __extends$1B(LoggerFactory, _super);
  function LoggerFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
    this.logging = gridOptionsWrapper.isDebug();
  };
  LoggerFactory.prototype.create = function (name) {
    return new Logger(name, this.isLogging.bind(this));
  };
  LoggerFactory.prototype.isLogging = function () {
    return this.logging;
  };
  __decorate$1q([__param$6(0, Qualifier('gridOptionsWrapper'))], LoggerFactory.prototype, "setBeans", null);
  LoggerFactory = __decorate$1q([Bean('loggerFactory')], LoggerFactory);
  return LoggerFactory;
}(BeanStub);
var Logger = /** @class */function () {
  function Logger(name, isLoggingFunc) {
    this.name = name;
    this.isLoggingFunc = isLoggingFunc;
  }
  Logger.prototype.isLogging = function () {
    return this.isLoggingFunc();
  };
  Logger.prototype.log = function (message) {
    if (this.isLoggingFunc()) {
      // tslint:disable-next-line
      console.log('AG Grid.' + this.name + ': ' + message);
    }
  };
  return Logger;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1C = undefined && undefined.__extends || function () {
  var _extendStatics103 = function extendStatics(d, b) {
    _extendStatics103 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics103(d, b);
  };
  return function (d, b) {
    _extendStatics103(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1r = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AutoWidthCalculator = /** @class */function (_super) {
  __extends$1C(AutoWidthCalculator, _super);
  function AutoWidthCalculator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AutoWidthCalculator.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      _this.centerRowContainerCon = p.centerRowContainerCtrl;
    });
  };
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column, skipHeader) {
    var eHeaderCell = this.getHeaderCellForColumn(column);
    // cell isn't visible
    if (!eHeaderCell) {
      return -1;
    }
    var eDummyContainer = document.createElement('span');
    // position fixed, so it isn't restricted to the boundaries of the parent
    eDummyContainer.style.position = 'fixed';
    // we put the dummy into the body container, so it will inherit all the
    // css styles that the real cells are inheriting
    var eBodyContainer = this.centerRowContainerCon.getContainerElement();
    eBodyContainer.appendChild(eDummyContainer);
    // get all the cells that are currently displayed (this only brings back
    // rendered cells, rows not rendered due to row visualisation will not be here)
    this.putRowCellsIntoDummyContainer(column, eDummyContainer);
    if (!skipHeader) {
      // we only consider the lowest level cell, not the group cell. in 99% of the time, this
      // will be enough. if we consider groups, then it gets too complicated for what it's worth,
      // as the groups can span columns and this class only considers one column at a time.
      this.cloneItemIntoDummy(eHeaderCell, eDummyContainer);
    }
    // at this point, all the clones are lined up vertically with natural widths. the dummy
    // container will have a width wide enough just to fit the largest.
    var dummyContainerWidth = eDummyContainer.offsetWidth;
    // we are finished with the dummy container, so get rid of it
    eBodyContainer.removeChild(eDummyContainer);
    // we add padding as I found sometimes the gui still put '...' after some of the texts. so the
    // user can configure the grid to add a few more pixels after the calculated width
    var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
    return dummyContainerWidth + autoSizePadding;
  };
  AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
    var element = null;
    this.ctrlsService.getHeaderRowContainerCtrls().forEach(function (container) {
      var res = container.getHtmlElementForColumnHeader(column);
      if (res != null) {
        element = res;
      }
    });
    return element;
  };
  AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
    var _this = this;
    var eCellElements = this.rowRenderer.getAllCellsForColumn(column);
    eCellElements.forEach(function (eCell) {
      return _this.cloneItemIntoDummy(eCell, eDummyContainer);
    });
  };
  AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
    // make a deep clone of the cell
    var eCellClone = eCell.cloneNode(true);
    // the original has a fixed width, we remove this to allow the natural width based on content
    eCellClone.style.width = '';
    // the original has position = absolute, we need to remove this so it's positioned normally
    eCellClone.style.position = 'static';
    eCellClone.style.left = '';
    // we put the cell into a containing div, as otherwise the cells would just line up
    // on the same line, standard flow layout, by putting them into divs, they are laid
    // out one per line
    var eCloneParent = document.createElement('div');
    if (containsClass(eCellClone, 'ag-header-cell')) {
      addCssClass(eCloneParent, 'ag-header');
      addCssClass(eCloneParent, 'ag-header-row');
      eCloneParent.style.position = 'static';
    } else {
      addCssClass(eCloneParent, 'ag-row');
    }
    // find parent using classes (headers have ag-header-cell, rows have ag-row), and copy classes from it.
    // if we didn't do this, things like ag-row-level-2 would be missing if present, which sets indents
    // onto group items.
    var pointer = eCell.parentElement;
    while (pointer) {
      if (pointer.classList.contains('ag-header-row') || pointer.classList.contains('ag-row')) {
        for (var i = 0; i < pointer.classList.length; i++) {
          var item = pointer.classList[i];
          // we skip ag-row-position-absolute, as this has structural CSS applied that stops the
          // element from fitting into it's parent, and we need the element to stretch the parent
          // as we are measuring the parents width
          if (item != 'ag-row-position-absolute') {
            addCssClass(eCloneParent, item);
          }
        }
        break;
      }
      pointer = pointer.parentElement;
    }
    // table-row, so that each cell is on a row. i also tried display='block', but this
    // didn't work in IE
    eCloneParent.style.display = 'table-row';
    // the twig on the branch, the branch on the tree, the tree in the hole,
    // the hole in the bog, the bog in the clone, the clone in the parent,
    // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
    eCloneParent.appendChild(eCellClone);
    eDummyContainer.appendChild(eCloneParent);
  };
  __decorate$1r([Autowired('rowRenderer')], AutoWidthCalculator.prototype, "rowRenderer", void 0);
  __decorate$1r([Autowired('ctrlsService')], AutoWidthCalculator.prototype, "ctrlsService", void 0);
  __decorate$1r([Autowired('rowCssClassCalculator')], AutoWidthCalculator.prototype, "rowCssClassCalculator", void 0);
  __decorate$1r([PostConstruct], AutoWidthCalculator.prototype, "postConstruct", null);
  AutoWidthCalculator = __decorate$1r([Bean('autoWidthCalculator')], AutoWidthCalculator);
  return AutoWidthCalculator;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1D = undefined && undefined.__extends || function () {
  var _extendStatics104 = function extendStatics(d, b) {
    _extendStatics104 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics104(d, b);
  };
  return function (d, b) {
    _extendStatics104(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1s = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HorizontalResizeService = /** @class */function (_super) {
  __extends$1D(HorizontalResizeService, _super);
  function HorizontalResizeService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HorizontalResizeService.prototype.addResizeBar = function (params) {
    var _this = this;
    var dragSource = {
      dragStartPixels: params.dragStartPixels || 0,
      eElement: params.eResizeBar,
      onDragStart: this.onDragStart.bind(this, params),
      onDragStop: this.onDragStop.bind(this, params),
      onDragging: this.onDragging.bind(this, params)
    };
    this.dragService.addDragSource(dragSource, true);
    // we pass remove func back to the caller, so call can tell us when they
    // are finished, and then we remove the listener from the drag source
    var finishedWithResizeFunc = function finishedWithResizeFunc() {
      return _this.dragService.removeDragSource(dragSource);
    };
    return finishedWithResizeFunc;
  };
  HorizontalResizeService.prototype.onDragStart = function (params, mouseEvent) {
    this.dragStartX = mouseEvent.clientX;
    this.setResizeIcons();
    var shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
    params.onResizeStart(shiftKey);
  };
  HorizontalResizeService.prototype.setResizeIcons = function () {
    var ctrl = this.ctrlsService.getGridCtrl();
    // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
    ctrl.setResizeCursor(true);
    // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
    ctrl.disableUserSelect(true);
  };
  HorizontalResizeService.prototype.onDragStop = function (params, mouseEvent) {
    params.onResizeEnd(this.resizeAmount);
    this.resetIcons();
  };
  HorizontalResizeService.prototype.resetIcons = function () {
    var ctrl = this.ctrlsService.getGridCtrl();
    ctrl.setResizeCursor(false);
    ctrl.disableUserSelect(false);
  };
  HorizontalResizeService.prototype.onDragging = function (params, mouseEvent) {
    this.resizeAmount = mouseEvent.clientX - this.dragStartX;
    params.onResizing(this.resizeAmount);
  };
  __decorate$1s([Autowired('dragService')], HorizontalResizeService.prototype, "dragService", void 0);
  __decorate$1s([Autowired('ctrlsService')], HorizontalResizeService.prototype, "ctrlsService", void 0);
  HorizontalResizeService = __decorate$1s([Bean('horizontalResizeService')], HorizontalResizeService);
  return HorizontalResizeService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1E = undefined && undefined.__extends || function () {
  var _extendStatics105 = function extendStatics(d, b) {
    _extendStatics105 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics105(d, b);
  };
  return function (d, b) {
    _extendStatics105(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1t = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridCtrl = /** @class */function (_super) {
  __extends$1E(GridCtrl, _super);
  function GridCtrl() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GridCtrl.prototype.postConstruct = function () {
    this.ctrlsService.registerGridCtrl(this);
  };
  GridCtrl.prototype.setComp = function (view, eGridDiv, eGui) {
    var _this = this;
    this.view = view;
    this.eGridHostDiv = eGridDiv;
    this.eGui = eGui;
    this.mouseEventService.stampTopLevelGridCompWithGridInstance(eGridDiv);
    this.createManagedBean(new LayoutFeature(this.view));
    // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
    // which doLayout indirectly depends on
    this.addRtlSupport();
    this.addManagedListener(this, Events.EVENT_KEYBOARD_FOCUS, function () {
      _this.view.addOrRemoveKeyboardFocusClass(true);
    });
    this.addManagedListener(this, Events.EVENT_MOUSE_FOCUS, function () {
      _this.view.addOrRemoveKeyboardFocusClass(false);
    });
    var unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(function () {
      return unsubscribeFromResize();
    });
  };
  GridCtrl.prototype.showDropZones = function () {
    return ModuleRegistry.isRegistered(ModuleNames.RowGroupingModule);
  };
  GridCtrl.prototype.showSideBar = function () {
    return ModuleRegistry.isRegistered(ModuleNames.SideBarModule);
  };
  GridCtrl.prototype.showStatusBar = function () {
    return ModuleRegistry.isRegistered(ModuleNames.StatusBarModule);
  };
  GridCtrl.prototype.showWatermark = function () {
    return ModuleRegistry.isRegistered(ModuleNames.EnterpriseCoreModule);
  };
  GridCtrl.prototype.onGridSizeChanged = function () {
    var event = {
      type: Events.EVENT_GRID_SIZE_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi,
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    };
    this.eventService.dispatchEvent(event);
  };
  GridCtrl.prototype.addRtlSupport = function () {
    var cssClass = this.gridOptionsWrapper.isEnableRtl() ? 'ag-rtl' : 'ag-ltr';
    this.view.setRtlClass(cssClass);
  };
  GridCtrl.prototype.destroyGridUi = function () {
    this.view.destroyGridUi();
  };
  GridCtrl.prototype.getGui = function () {
    return this.eGui;
  };
  GridCtrl.prototype.setResizeCursor = function (on) {
    this.view.setCursor(on ? 'ew-resize' : null);
  };
  GridCtrl.prototype.disableUserSelect = function (on) {
    this.view.setUserSelect(on ? 'none' : null);
  };
  GridCtrl.prototype.focusNextInnerContainer = function (backwards) {
    var focusableContainers = this.view.getFocusableContainers();
    var idxWithFocus = findIndex(focusableContainers, function (container) {
      return container.contains(document.activeElement);
    });
    var nextIdx = idxWithFocus + (backwards ? -1 : 1);
    if (nextIdx < 0 || nextIdx >= focusableContainers.length) {
      return false;
    }
    if (nextIdx === 0) {
      return this.focusGridHeader();
    }
    return this.focusService.focusInto(focusableContainers[nextIdx]);
  };
  GridCtrl.prototype.focusInnerElement = function (fromBottom) {
    var focusableContainers = this.view.getFocusableContainers();
    if (fromBottom) {
      if (focusableContainers.length > 1) {
        return this.focusService.focusInto(last(focusableContainers), true);
      }
      var lastColumn = last(this.columnModel.getAllDisplayedColumns());
      if (this.focusService.focusGridView(lastColumn, true)) {
        return true;
      }
    }
    return this.focusGridHeader();
  };
  GridCtrl.prototype.focusGridHeader = function () {
    var firstColumn = this.columnModel.getAllDisplayedColumns()[0];
    if (!firstColumn) {
      return false;
    }
    if (firstColumn.getParent()) {
      firstColumn = this.columnModel.getColumnGroupAtLevel(firstColumn, 0);
    }
    this.focusService.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: 0,
        column: firstColumn
      }
    });
    return true;
  };
  GridCtrl.prototype.forceFocusOutOfContainer = function (up) {
    if (up === void 0) {
      up = false;
    }
    this.view.forceFocusOutOfContainer(up);
  };
  __decorate$1t([Autowired('columnApi')], GridCtrl.prototype, "columnApi", void 0);
  __decorate$1t([Autowired('gridApi')], GridCtrl.prototype, "gridApi", void 0);
  __decorate$1t([Autowired('focusService')], GridCtrl.prototype, "focusService", void 0);
  __decorate$1t([Autowired('resizeObserverService')], GridCtrl.prototype, "resizeObserverService", void 0);
  __decorate$1t([Autowired('columnModel')], GridCtrl.prototype, "columnModel", void 0);
  __decorate$1t([Autowired('ctrlsService')], GridCtrl.prototype, "ctrlsService", void 0);
  __decorate$1t([Autowired('mouseEventService')], GridCtrl.prototype, "mouseEventService", void 0);
  __decorate$1t([PostConstruct], GridCtrl.prototype, "postConstruct", null);
  return GridCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1F = undefined && undefined.__extends || function () {
  var _extendStatics106 = function extendStatics(d, b) {
    _extendStatics106 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics106(d, b);
  };
  return function (d, b) {
    _extendStatics106(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1u = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TabGuardCtrl = /** @class */function (_super) {
  __extends$1F(TabGuardCtrl, _super);
  function TabGuardCtrl(params) {
    var _this = _super.call(this) || this;
    _this.skipTabGuardFocus = false;
    var comp = params.comp,
      eTopGuard = params.eTopGuard,
      eBottomGuard = params.eBottomGuard,
      focusInnerElement = params.focusInnerElement,
      onFocusIn = params.onFocusIn,
      onFocusOut = params.onFocusOut,
      shouldStopEventPropagation = params.shouldStopEventPropagation,
      onTabKeyDown = params.onTabKeyDown,
      handleKeyDown = params.handleKeyDown,
      eFocusableElement = params.eFocusableElement;
    _this.comp = comp;
    _this.eTopGuard = eTopGuard;
    _this.eBottomGuard = eBottomGuard;
    _this.providedFocusInnerElement = focusInnerElement;
    _this.eFocusableElement = eFocusableElement;
    _this.providedFocusIn = onFocusIn;
    _this.providedFocusOut = onFocusOut;
    _this.providedShouldStopEventPropagation = shouldStopEventPropagation;
    _this.providedOnTabKeyDown = onTabKeyDown;
    _this.providedHandleKeyDown = handleKeyDown;
    return _this;
  }
  TabGuardCtrl.prototype.postConstruct = function () {
    var _this = this;
    this.createManagedBean(new ManagedFocusFeature(this.eFocusableElement, {
      shouldStopEventPropagation: function shouldStopEventPropagation() {
        return _this.shouldStopEventPropagation();
      },
      onTabKeyDown: function onTabKeyDown(e) {
        return _this.onTabKeyDown(e);
      },
      handleKeyDown: function handleKeyDown(e) {
        return _this.handleKeyDown(e);
      },
      onFocusIn: function onFocusIn(e) {
        return _this.onFocusIn(e);
      },
      onFocusOut: function onFocusOut(e) {
        return _this.onFocusOut(e);
      }
    }));
    this.activateTabGuards();
    [this.eTopGuard, this.eBottomGuard].forEach(function (guard) {
      return _this.addManagedListener(guard, 'focus', _this.onFocus.bind(_this));
    });
  };
  TabGuardCtrl.prototype.handleKeyDown = function (e) {
    if (this.providedHandleKeyDown) {
      this.providedHandleKeyDown(e);
    }
  };
  TabGuardCtrl.prototype.tabGuardsAreActive = function () {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute('tabIndex');
  };
  TabGuardCtrl.prototype.shouldStopEventPropagation = function () {
    if (this.providedShouldStopEventPropagation) {
      return this.providedShouldStopEventPropagation();
    }
    return false;
  };
  TabGuardCtrl.prototype.activateTabGuards = function () {
    this.comp.setTabIndex(this.getGridTabIndex());
  };
  TabGuardCtrl.prototype.deactivateTabGuards = function () {
    this.comp.setTabIndex();
  };
  TabGuardCtrl.prototype.onFocus = function (e) {
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = false;
      return;
    }
    var fromBottom = e.target === this.eBottomGuard;
    if (this.providedFocusInnerElement) {
      this.providedFocusInnerElement(fromBottom);
    } else {
      this.focusInnerElement(fromBottom);
    }
  };
  TabGuardCtrl.prototype.onFocusIn = function (e) {
    if (this.providedFocusIn && this.providedFocusIn(e)) {
      return;
    }
    this.deactivateTabGuards();
  };
  TabGuardCtrl.prototype.onFocusOut = function (e) {
    if (this.providedFocusOut && this.providedFocusOut(e)) {
      return;
    }
    if (!this.eFocusableElement.contains(e.relatedTarget)) {
      this.activateTabGuards();
    }
  };
  TabGuardCtrl.prototype.onTabKeyDown = function (e) {
    var _this = this;
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (e.defaultPrevented) {
      return;
    }
    var tabGuardsAreActive = this.tabGuardsAreActive();
    if (tabGuardsAreActive) {
      this.deactivateTabGuards();
    }
    var nextRoot = this.getNextFocusableElement(e.shiftKey);
    if (tabGuardsAreActive) {
      // ensure the tab guards are only re-instated once the event has finished processing, to avoid the browser
      // tabbing to the tab guard from inside the component
      setTimeout(function () {
        return _this.activateTabGuards();
      }, 0);
    }
    if (!nextRoot) {
      return;
    }
    nextRoot.focus();
    e.preventDefault();
  };
  TabGuardCtrl.prototype.getGridTabIndex = function () {
    return this.gridOptionsWrapper.getGridTabIndex();
  };
  TabGuardCtrl.prototype.focusInnerElement = function (fromBottom) {
    if (fromBottom === void 0) {
      fromBottom = false;
    }
    var focusable = this.focusService.findFocusableElements(this.eFocusableElement);
    if (this.tabGuardsAreActive()) {
      // remove tab guards from this component from list of focusable elements
      focusable.splice(0, 1);
      focusable.splice(focusable.length - 1, 1);
    }
    if (!focusable.length) {
      return;
    }
    focusable[fromBottom ? focusable.length - 1 : 0].focus();
  };
  TabGuardCtrl.prototype.getNextFocusableElement = function (backwards) {
    return this.focusService.findNextFocusableElement(this.eFocusableElement, false, backwards);
  };
  TabGuardCtrl.prototype.forceFocusOutOfContainer = function (up) {
    if (up === void 0) {
      up = false;
    }
    var tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards();
    this.skipTabGuardFocus = true;
    tabGuardToFocus.focus();
  };
  __decorate$1u([Autowired('focusService')], TabGuardCtrl.prototype, "focusService", void 0);
  __decorate$1u([PostConstruct], TabGuardCtrl.prototype, "postConstruct", null);
  return TabGuardCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1G = undefined && undefined.__extends || function () {
  var _extendStatics107 = function extendStatics(d, b) {
    _extendStatics107 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics107(d, b);
  };
  return function (d, b) {
    _extendStatics107(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TabGuardComp = /** @class */function (_super) {
  __extends$1G(TabGuardComp, _super);
  function TabGuardComp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TabGuardComp.prototype.initialiseTabGuard = function (params) {
    this.eTopGuard = this.createTabGuard('top');
    this.eBottomGuard = this.createTabGuard('bottom');
    this.eFocusableElement = this.getFocusableElement();
    var tabGuards = [this.eTopGuard, this.eBottomGuard];
    var compProxy = {
      setTabIndex: function setTabIndex(tabIndex) {
        tabGuards.forEach(function (tabGuard) {
          return tabIndex != null ? tabGuard.setAttribute('tabIndex', tabIndex) : tabGuard.removeAttribute('tabIndex');
        });
      }
    };
    this.addTabGuards(this.eTopGuard, this.eBottomGuard);
    this.tabGuardCtrl = this.createManagedBean(new TabGuardCtrl({
      comp: compProxy,
      eTopGuard: this.eTopGuard,
      eBottomGuard: this.eBottomGuard,
      eFocusableElement: this.eFocusableElement,
      onFocusIn: params.onFocusIn,
      onFocusOut: params.onFocusOut,
      focusInnerElement: params.focusInnerElement,
      handleKeyDown: params.handleKeyDown,
      onTabKeyDown: params.onTabKeyDown,
      shouldStopEventPropagation: params.shouldStopEventPropagation
    }));
  };
  TabGuardComp.prototype.createTabGuard = function (side) {
    var tabGuard = document.createElement('div');
    tabGuard.classList.add('ag-tab-guard');
    tabGuard.classList.add("ag-tab-guard-" + side);
    setAriaRole(tabGuard, 'presentation');
    return tabGuard;
  };
  TabGuardComp.prototype.addTabGuards = function (topTabGuard, bottomTabGuard) {
    this.eFocusableElement.insertAdjacentElement('afterbegin', topTabGuard);
    this.eFocusableElement.insertAdjacentElement('beforeend', bottomTabGuard);
  };
  TabGuardComp.prototype.removeAllChildrenExceptTabGuards = function () {
    var tabGuards = [this.eTopGuard, this.eBottomGuard];
    clearElement(this.getFocusableElement());
    this.addTabGuards.apply(this, tabGuards);
  };
  TabGuardComp.prototype.forceFocusOutOfContainer = function (up) {
    if (up === void 0) {
      up = false;
    }
    this.tabGuardCtrl.forceFocusOutOfContainer(up);
  };
  TabGuardComp.prototype.appendChild = function (newChild, container) {
    if (!isNodeOrElement(newChild)) {
      newChild = newChild.getGui();
    }
    var bottomTabGuard = this.eBottomGuard;
    if (bottomTabGuard) {
      bottomTabGuard.insertAdjacentElement('beforebegin', newChild);
    } else {
      _super.prototype.appendChild.call(this, newChild, container);
    }
  };
  return TabGuardComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1H = undefined && undefined.__extends || function () {
  var _extendStatics108 = function extendStatics(d, b) {
    _extendStatics108 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics108(d, b);
  };
  return function (d, b) {
    _extendStatics108(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1v = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridComp = /** @class */function (_super) {
  __extends$1H(GridComp, _super);
  function GridComp(eGridDiv) {
    var _this = _super.call(this, undefined) || this;
    _this.eGridDiv = eGridDiv;
    return _this;
  }
  GridComp.prototype.postConstruct = function () {
    var _this = this;
    this.logger = this.loggerFactory.create('GridComp');
    var compProxy = {
      destroyGridUi: function destroyGridUi() {
        return _this.destroyBean(_this);
      },
      setRtlClass: function setRtlClass(cssClass) {
        return addCssClass(_this.getGui(), cssClass);
      },
      addOrRemoveKeyboardFocusClass: function addOrRemoveKeyboardFocusClass(addOrRemove) {
        return _this.addOrRemoveCssClass(FocusService.AG_KEYBOARD_FOCUS, addOrRemove);
      },
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: function setUserSelect(value) {
        _this.getGui().style.userSelect = value != null ? value : '';
        _this.getGui().style.webkitUserSelect = value != null ? value : '';
      },
      setCursor: function setCursor(value) {
        _this.getGui().style.cursor = value != null ? value : '';
      }
    };
    this.ctrl = this.createManagedBean(new GridCtrl());
    var template = this.createTemplate();
    this.setTemplate(template);
    this.ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
    this.insertGridIntoDom();
    this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: function onTabKeyDown() {
        return undefined;
      },
      focusInnerElement: function focusInnerElement(fromBottom) {
        return _this.ctrl.focusInnerElement(fromBottom);
      }
    });
  };
  GridComp.prototype.insertGridIntoDom = function () {
    var _this = this;
    var eGui = this.getGui();
    this.eGridDiv.appendChild(eGui);
    this.addDestroyFunc(function () {
      _this.eGridDiv.removeChild(eGui);
      _this.logger.log('Grid removed from DOM');
    });
  };
  GridComp.prototype.updateLayoutClasses = function (cssClass, params) {
    addOrRemoveCssClass(this.eRootWrapperBody, LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
    addOrRemoveCssClass(this.eRootWrapperBody, LayoutCssClasses.NORMAL, params.normal);
    addOrRemoveCssClass(this.eRootWrapperBody, LayoutCssClasses.PRINT, params.print);
    this.addOrRemoveCssClass(LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
    this.addOrRemoveCssClass(LayoutCssClasses.NORMAL, params.normal);
    this.addOrRemoveCssClass(LayoutCssClasses.PRINT, params.print);
  };
  GridComp.prototype.createTemplate = function () {
    var dropZones = this.ctrl.showDropZones() ? '<ag-grid-header-drop-zones></ag-grid-header-drop-zones>' : '';
    var sideBar = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : '';
    var statusBar = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : '';
    var watermark = this.ctrl.showWatermark() ? '<ag-watermark></ag-watermark>' : '';
    var template = /* html */"<div class=\"ag-root-wrapper\">\n                " + dropZones + "\n                <div class=\"ag-root-wrapper-body\" ref=\"rootWrapperBody\">\n                    <ag-grid-body ref=\"gridBody\"></ag-grid-body>\n                    " + sideBar + "\n                </div>\n                " + statusBar + "\n                <ag-pagination></ag-pagination>\n                " + watermark + "\n            </div>";
    return template;
  };
  GridComp.prototype.getFocusableElement = function () {
    return this.eRootWrapperBody;
  };
  GridComp.prototype.getFocusableContainers = function () {
    var focusableContainers = [this.gridBodyComp.getGui()];
    if (this.sideBarComp) {
      focusableContainers.push(this.sideBarComp.getGui());
    }
    return focusableContainers.filter(function (el) {
      return isVisible(el);
    });
  };
  __decorate$1v([Autowired('loggerFactory')], GridComp.prototype, "loggerFactory", void 0);
  __decorate$1v([RefSelector('gridBody')], GridComp.prototype, "gridBodyComp", void 0);
  __decorate$1v([RefSelector('sideBar')], GridComp.prototype, "sideBarComp", void 0);
  __decorate$1v([RefSelector('rootWrapperBody')], GridComp.prototype, "eRootWrapperBody", void 0);
  __decorate$1v([PostConstruct], GridComp.prototype, "postConstruct", null);
  return GridComp;
}(TabGuardComp);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1I = undefined && undefined.__extends || function () {
  var _extendStatics109 = function extendStatics(d, b) {
    _extendStatics109 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics109(d, b);
  };
  return function (d, b) {
    _extendStatics109(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1w = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/** Adds drag listening onto an element. In AG Grid this is used twice, first is resizing columns,
 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
var DragService = /** @class */function (_super) {
  __extends$1I(DragService, _super);
  function DragService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.dragEndFunctions = [];
    _this.dragSources = [];
    return _this;
  }
  DragService.prototype.init = function () {
    this.logger = this.loggerFactory.create('DragService');
  };
  DragService.prototype.removeAllListeners = function () {
    this.dragSources.forEach(this.removeListener.bind(this));
    this.dragSources.length = 0;
  };
  DragService.prototype.removeListener = function (dragSourceAndListener) {
    var element = dragSourceAndListener.dragSource.eElement;
    var mouseDownListener = dragSourceAndListener.mouseDownListener;
    element.removeEventListener('mousedown', mouseDownListener);
    // remove touch listener only if it exists
    if (dragSourceAndListener.touchEnabled) {
      var touchStartListener = dragSourceAndListener.touchStartListener;
      element.removeEventListener('touchstart', touchStartListener, {
        passive: true
      });
    }
  };
  DragService.prototype.removeDragSource = function (params) {
    var dragSourceAndListener = find$3(this.dragSources, function (item) {
      return item.dragSource === params;
    });
    if (!dragSourceAndListener) {
      return;
    }
    this.removeListener(dragSourceAndListener);
    removeFromArray(this.dragSources, dragSourceAndListener);
  };
  DragService.prototype.isDragging = function () {
    return this.dragging;
  };
  DragService.prototype.addDragSource = function (params, includeTouch) {
    var _this = this;
    if (includeTouch === void 0) {
      includeTouch = false;
    }
    var mouseListener = this.onMouseDown.bind(this, params);
    params.eElement.addEventListener('mousedown', mouseListener);
    var touchListener = null;
    var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
    if (includeTouch && !suppressTouch) {
      touchListener = function touchListener(touchEvent) {
        touchEvent.preventDefault();
        _this.onTouchStart(params, touchEvent);
      };
      params.eElement.addEventListener('touchstart', touchListener, {
        passive: true
      });
    }
    this.dragSources.push({
      dragSource: params,
      mouseDownListener: mouseListener,
      touchStartListener: touchListener,
      touchEnabled: includeTouch
    });
  };
  // gets called whenever mouse down on any drag source
  DragService.prototype.onTouchStart = function (params, touchEvent) {
    var _this = this;
    this.currentDragParams = params;
    this.dragging = false;
    var touch = touchEvent.touches[0];
    this.touchLastTime = touch;
    this.touchStart = touch;
    var touchMoveEvent = function touchMoveEvent(e) {
      return _this.onTouchMove(e, params.eElement);
    };
    var touchEndEvent = function touchEndEvent(e) {
      return _this.onTouchUp(e, params.eElement);
    };
    var documentTouchMove = function documentTouchMove(e) {
      if (e.cancelable) {
        e.preventDefault();
      }
    };
    var target = params.eElement;
    var events = [
    // Prevents the page document from moving while we are dragging items around.
    // preventDefault needs to be called in the touchmove listener and never inside the
    // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
    {
      target: document,
      type: 'touchmove',
      listener: documentTouchMove,
      options: {
        passive: false
      }
    }, {
      target: target,
      type: 'touchmove',
      listener: touchMoveEvent,
      options: {
        passive: true
      }
    }, {
      target: target,
      type: 'touchend',
      listener: touchEndEvent,
      options: {
        passive: true
      }
    }, {
      target: target,
      type: 'touchcancel',
      listener: touchEndEvent,
      options: {
        passive: true
      }
    }];
    // temporally add these listeners, for the duration of the drag
    this.addTemporaryEvents(events);
    // see if we want to start dragging straight away
    if (params.dragStartPixels === 0) {
      this.onCommonMove(touch, this.touchStart, params.eElement);
    }
  };
  // gets called whenever mouse down on any drag source
  DragService.prototype.onMouseDown = function (params, mouseEvent) {
    var _this = this;
    var e = mouseEvent;
    if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) {
      return;
    }
    // if there are two elements with parent / child relationship, and both are draggable,
    // when we drag the child, we should NOT drag the parent. an example of this is row moving
    // and range selection - row moving should get preference when use drags the rowDrag component.
    if (e._alreadyProcessedByDragService) {
      return;
    }
    e._alreadyProcessedByDragService = true;
    // only interested in left button clicks
    if (mouseEvent.button !== 0) {
      return;
    }
    this.currentDragParams = params;
    this.dragging = false;
    this.mouseStartEvent = mouseEvent;
    var eDocument = this.gridOptionsWrapper.getDocument();
    var mouseMoveEvent = function mouseMoveEvent(event) {
      return _this.onMouseMove(event, params.eElement);
    };
    var mouseUpEvent = function mouseUpEvent(event) {
      return _this.onMouseUp(event, params.eElement);
    };
    var contextEvent = function contextEvent(event) {
      return event.preventDefault();
    };
    var target = eDocument;
    var events = [{
      target: target,
      type: 'mousemove',
      listener: mouseMoveEvent
    }, {
      target: target,
      type: 'mouseup',
      listener: mouseUpEvent
    }, {
      target: target,
      type: 'contextmenu',
      listener: contextEvent
    }];
    // temporally add these listeners, for the duration of the drag
    this.addTemporaryEvents(events);
    //see if we want to start dragging straight away
    if (params.dragStartPixels === 0) {
      this.onMouseMove(mouseEvent, params.eElement);
    }
  };
  DragService.prototype.addTemporaryEvents = function (events) {
    events.forEach(function (currentEvent) {
      var target = currentEvent.target,
        type = currentEvent.type,
        listener = currentEvent.listener,
        options = currentEvent.options;
      target.addEventListener(type, listener, options);
    });
    this.dragEndFunctions.push(function () {
      events.forEach(function (currentEvent) {
        var target = currentEvent.target,
          type = currentEvent.type,
          listener = currentEvent.listener,
          options = currentEvent.options;
        target.removeEventListener(type, listener, options);
      });
    });
  };
  // returns true if the event is close to the original event by X pixels either vertically or horizontally.
  // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
  DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
    // by default, we wait 4 pixels before starting the drag
    var dragStartPixels = this.currentDragParams.dragStartPixels;
    var requiredPixelDiff = exists(dragStartPixels) ? dragStartPixels : 4;
    return areEventsNear(currentEvent, startEvent, requiredPixelDiff);
  };
  DragService.prototype.getFirstActiveTouch = function (touchList) {
    for (var i = 0; i < touchList.length; i++) {
      if (touchList[i].identifier === this.touchStart.identifier) {
        return touchList[i];
      }
    }
    return null;
  };
  DragService.prototype.onCommonMove = function (currentEvent, startEvent, el) {
    if (!this.dragging) {
      // if mouse hasn't travelled from the start position enough, do nothing
      if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) {
        return;
      }
      this.dragging = true;
      var event_1 = {
        type: Events.EVENT_DRAG_STARTED,
        api: this.gridApi,
        columnApi: this.columnApi,
        target: el
      };
      this.eventService.dispatchEvent(event_1);
      this.currentDragParams.onDragStart(startEvent);
      // we need ONE drag action at the startEvent, so that we are guaranteed the drop target
      // at the start gets notified. this is because the drag can start outside of the element
      // that started it, as the mouse is allowed drag away from the mouse down before it's
      // considered a drag (the isEventNearStartEvent() above). if we didn't do this, then
      // it would be possible to click a column by the edge, then drag outside of the drop zone
      // in less than 4 pixels and the drag officially starts outside of the header but the header
      // wouldn't be notified of the dragging.
      this.currentDragParams.onDragging(startEvent);
    }
    this.currentDragParams.onDragging(currentEvent);
  };
  DragService.prototype.onTouchMove = function (touchEvent, el) {
    var touch = this.getFirstActiveTouch(touchEvent.touches);
    if (!touch) {
      return;
    }
    // this.___statusPanel.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
    this.onCommonMove(touch, this.touchStart, el);
  };
  // only gets called after a mouse down - as this is only added after mouseDown
  // and is removed when mouseUp happens
  DragService.prototype.onMouseMove = function (mouseEvent, el) {
    this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
  };
  DragService.prototype.onTouchUp = function (touchEvent, el) {
    var touch = this.getFirstActiveTouch(touchEvent.changedTouches);
    // i haven't worked this out yet, but there is no matching touch
    // when we get the touch up event. to get around this, we swap in
    // the last touch. this is a hack to 'get it working' while we
    // figure out what's going on, why we are not getting a touch in
    // current event.
    if (!touch) {
      touch = this.touchLastTime;
    }
    // if mouse was left up before we started to move, then this is a tap.
    // we check this before onUpCommon as onUpCommon resets the dragging
    // let tap = !this.dragging;
    // let tapTarget = this.currentDragParams.eElement;
    this.onUpCommon(touch, el);
    // if tap, tell user
    // console.log(`${Math.random()} tap = ${tap}`);
    // if (tap) {
    //     tapTarget.click();
    // }
  };

  DragService.prototype.onMouseUp = function (mouseEvent, el) {
    this.onUpCommon(mouseEvent, el);
  };
  DragService.prototype.onUpCommon = function (eventOrTouch, el) {
    if (this.dragging) {
      this.dragging = false;
      this.currentDragParams.onDragStop(eventOrTouch);
      var event_2 = {
        type: Events.EVENT_DRAG_STOPPED,
        api: this.gridApi,
        columnApi: this.columnApi,
        target: el
      };
      this.eventService.dispatchEvent(event_2);
    }
    this.mouseStartEvent = null;
    this.touchStart = null;
    this.touchLastTime = null;
    this.currentDragParams = null;
    this.dragEndFunctions.forEach(function (func) {
      return func();
    });
    this.dragEndFunctions.length = 0;
  };
  __decorate$1w([Autowired('loggerFactory')], DragService.prototype, "loggerFactory", void 0);
  __decorate$1w([Autowired('columnApi')], DragService.prototype, "columnApi", void 0);
  __decorate$1w([Autowired('gridApi')], DragService.prototype, "gridApi", void 0);
  __decorate$1w([PostConstruct], DragService.prototype, "init", null);
  __decorate$1w([PreDestroy], DragService.prototype, "removeAllListeners", null);
  DragService = __decorate$1w([Bean('dragService')], DragService);
  return DragService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1J = undefined && undefined.__extends || function () {
  var _extendStatics110 = function extendStatics(d, b) {
    _extendStatics110 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics110(d, b);
  };
  return function (d, b) {
    _extendStatics110(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1x = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SortController = /** @class */function (_super) {
  __extends$1J(SortController, _super);
  function SortController() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SortController_1 = SortController;
  SortController.prototype.progressSort = function (column, multiSort, source) {
    if (source === void 0) {
      source = "api";
    }
    var nextDirection = this.getNextSortDirection(column);
    this.setSortForColumn(column, nextDirection, multiSort, source);
  };
  SortController.prototype.setSortForColumn = function (column, sort, multiSort, source) {
    if (source === void 0) {
      source = "api";
    }
    // auto correct - if sort not legal value, then set it to 'no sort' (which is null)
    if (sort !== Constants.SORT_ASC && sort !== Constants.SORT_DESC) {
      sort = null;
    }
    // update sort on current col
    column.setSort(sort, source);
    var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
    // clear sort on all columns except this one, and update the icons
    if (!doingMultiSort) {
      this.clearSortBarThisColumn(column, source);
    }
    // sortIndex used for knowing order of cols when multi-col sort
    this.updateSortIndex(column);
    this.dispatchSortChangedEvents();
  };
  SortController.prototype.updateSortIndex = function (lastColToChange) {
    // update sortIndex on all sorting cols
    var allSortedCols = this.getColumnsWithSortingOrdered();
    var sortIndex = 0;
    allSortedCols.forEach(function (col) {
      if (col !== lastColToChange) {
        col.setSortIndex(sortIndex);
        sortIndex++;
      }
    });
    // last col to change always gets the last sort index, it's added to the end
    if (lastColToChange.getSort()) {
      lastColToChange.setSortIndex(sortIndex);
    }
    // clear sort index on all cols not sorting
    var allCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
    allCols.filter(function (col) {
      return col.getSort() == null;
    }).forEach(function (col) {
      return col.setSortIndex();
    });
  };
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  SortController.prototype.onSortChanged = function () {
    this.dispatchSortChangedEvents();
  };
  SortController.prototype.isSortActive = function () {
    // pull out all the columns that have sorting set
    var allCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
    var sortedCols = allCols.filter(function (column) {
      return !!column.getSort();
    });
    return sortedCols && sortedCols.length > 0;
  };
  SortController.prototype.dispatchSortChangedEvents = function () {
    var event = {
      type: Events.EVENT_SORT_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  SortController.prototype.clearSortBarThisColumn = function (columnToSkip, source) {
    this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
      // Do not clear if either holding shift, or if column in question was clicked
      if (columnToClear !== columnToSkip) {
        // setting to 'undefined' as null means 'none' rather than cleared, otherwise issue will arise
        // if sort order is: ['desc', null , 'asc'], as it will start at null rather than 'desc'.
        columnToClear.setSort(undefined, source);
      }
    });
  };
  SortController.prototype.getNextSortDirection = function (column) {
    var sortingOrder;
    if (column.getColDef().sortingOrder) {
      sortingOrder = column.getColDef().sortingOrder;
    } else if (this.gridOptionsWrapper.getSortingOrder()) {
      sortingOrder = this.gridOptionsWrapper.getSortingOrder();
    } else {
      sortingOrder = SortController_1.DEFAULT_SORTING_ORDER;
    }
    if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
      console.warn("ag-grid: sortingOrder must be an array with at least one element, currently it's " + sortingOrder);
      return null;
    }
    var currentIndex = sortingOrder.indexOf(column.getSort());
    var notInArray = currentIndex < 0;
    var lastItemInArray = currentIndex == sortingOrder.length - 1;
    var result;
    if (notInArray || lastItemInArray) {
      result = sortingOrder[0];
    } else {
      result = sortingOrder[currentIndex + 1];
    }
    // verify the sort type exists, as the user could provide the sortingOrder, need to make sure it's valid
    if (SortController_1.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
      console.warn('ag-grid: invalid sort type ' + result);
      return null;
    }
    return result;
  };
  SortController.prototype.getColumnsWithSortingOrdered = function () {
    // pull out all the columns that have sorting set
    var allColumnsIncludingAuto = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
    var columnsWithSorting = allColumnsIncludingAuto.filter(function (column) {
      return !!column.getSort();
    });
    // when both cols are missing sortIndex, we use the position of the col in all cols list.
    // this means if colDefs only have sort, but no sortIndex, we deterministically pick which
    // cols is sorted by first.
    var allColsIndexes = {};
    allColumnsIncludingAuto.forEach(function (col, index) {
      return allColsIndexes[col.getId()] = index;
    });
    // put the columns in order of which one got sorted first
    columnsWithSorting.sort(function (a, b) {
      var iA = a.getSortIndex();
      var iB = b.getSortIndex();
      if (iA != null && iB != null) {
        return iA - iB; // both present, normal comparison
      } else if (iA == null && iB == null) {
        // both missing, compare using column positions
        var posA = allColsIndexes[a.getId()];
        var posB = allColsIndexes[b.getId()];
        return posA > posB ? 1 : -1;
      } else if (iB == null) {
        return -1; // iB missing
      } else {
        return 1; // iA missing
      }
    });

    return columnsWithSorting;
  };
  // used by server side row models, to sent sort to server
  SortController.prototype.getSortModel = function () {
    return this.getColumnsWithSortingOrdered().map(function (column) {
      return {
        sort: column.getSort(),
        colId: column.getId()
      };
    });
  };
  SortController.prototype.getSortOptions = function () {
    return this.getColumnsWithSortingOrdered().map(function (column) {
      return {
        sort: column.getSort(),
        column: column
      };
    });
  };
  var SortController_1;
  SortController.DEFAULT_SORTING_ORDER = [Constants.SORT_ASC, Constants.SORT_DESC, null];
  __decorate$1x([Autowired('columnModel')], SortController.prototype, "columnModel", void 0);
  __decorate$1x([Autowired('columnApi')], SortController.prototype, "columnApi", void 0);
  __decorate$1x([Autowired('gridApi')], SortController.prototype, "gridApi", void 0);
  SortController = SortController_1 = __decorate$1x([Bean('sortController')], SortController);
  return SortController;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1K = undefined && undefined.__extends || function () {
  var _extendStatics111 = function extendStatics(d, b) {
    _extendStatics111 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics111(d, b);
  };
  return function (d, b) {
    _extendStatics111(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MouseEventService = /** @class */function (_super) {
  __extends$1K(MouseEventService, _super);
  function MouseEventService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.gridInstanceId = MouseEventService_1.gridInstanceSequence.next();
    return _this;
  }
  MouseEventService_1 = MouseEventService;
  // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
  // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
  // for where this is used.
  MouseEventService.prototype.stampTopLevelGridCompWithGridInstance = function (eGridDiv) {
    eGridDiv[MouseEventService_1.GRID_DOM_KEY] = this.gridInstanceId;
  };
  MouseEventService.prototype.getRenderedCellForEvent = function (event) {
    return getCtrlForEvent(this.gridOptionsWrapper, event, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
  };
  // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
  // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
  // getting executed on many grids at the same time.
  MouseEventService.prototype.isEventFromThisGrid = function (event) {
    var res = this.isElementInThisGrid(event.target);
    return res;
  };
  MouseEventService.prototype.isElementInThisGrid = function (element) {
    var pointer = element;
    while (pointer) {
      var instanceId = pointer[MouseEventService_1.GRID_DOM_KEY];
      if (exists(instanceId)) {
        var eventFromThisGrid = instanceId === this.gridInstanceId;
        return eventFromThisGrid;
      }
      pointer = pointer.parentElement;
    }
    return false;
  };
  MouseEventService.prototype.getCellPositionForEvent = function (event) {
    var cellComp = this.getRenderedCellForEvent(event);
    return cellComp ? cellComp.getCellPosition() : null;
  };
  MouseEventService.prototype.getNormalisedPosition = function (event) {
    var gridPanelHasScrolls = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
    var e = event;
    var x;
    var y;
    if (e.clientX != null || e.clientY != null) {
      x = e.clientX;
      y = e.clientY;
    } else {
      x = e.x;
      y = e.y;
    }
    if (gridPanelHasScrolls) {
      var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
      var vRange = gridBodyCon.getScrollFeature().getVScrollPosition();
      var hRange = gridBodyCon.getScrollFeature().getHScrollPosition();
      x += hRange.left;
      y += vRange.top;
    }
    return {
      x: x,
      y: y
    };
  };
  var MouseEventService_1;
  MouseEventService.gridInstanceSequence = new NumberSequence();
  MouseEventService.GRID_DOM_KEY = '__ag_grid_instance';
  __decorate$1y([Autowired('ctrlsService')], MouseEventService.prototype, "ctrlsService", void 0);
  MouseEventService = MouseEventService_1 = __decorate$1y([Bean('mouseEventService')], MouseEventService);
  return MouseEventService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1L = undefined && undefined.__extends || function () {
  var _extendStatics112 = function extendStatics(d, b) {
    _extendStatics112 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics112(d, b);
  };
  return function (d, b) {
    _extendStatics112(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CellNavigationService = /** @class */function (_super) {
  __extends$1L(CellNavigationService, _super);
  function CellNavigationService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  // returns null if no cell to focus on, ie at the end of the grid
  CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
    // starting with the provided cell, we keep moving until we find a cell we can
    // focus on.
    var pointer = lastCellToFocus;
    var finished = false;
    // finished will be true when either:
    // a) cell found that we can focus on
    // b) run out of cells (ie the method returns null)
    while (!finished) {
      switch (key) {
        case KeyCode.UP:
          pointer = this.getCellAbove(pointer);
          break;
        case KeyCode.DOWN:
          pointer = this.getCellBelow(pointer);
          break;
        case KeyCode.RIGHT:
          if (this.gridOptionsWrapper.isEnableRtl()) {
            pointer = this.getCellToLeft(pointer);
          } else {
            pointer = this.getCellToRight(pointer);
          }
          break;
        case KeyCode.LEFT:
          if (this.gridOptionsWrapper.isEnableRtl()) {
            pointer = this.getCellToRight(pointer);
          } else {
            pointer = this.getCellToLeft(pointer);
          }
          break;
        default:
          pointer = null;
          console.warn('AG Grid: unknown key for navigation ' + key);
          break;
      }
      if (pointer) {
        finished = this.isCellGoodToFocusOn(pointer);
      } else {
        finished = true;
      }
    }
    return pointer;
  };
  CellNavigationService.prototype.isCellGoodToFocusOn = function (gridCell) {
    var column = gridCell.column;
    var rowNode;
    switch (gridCell.rowPinned) {
      case Constants.PINNED_TOP:
        rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
        break;
      case Constants.PINNED_BOTTOM:
        rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
        break;
      default:
        rowNode = this.rowModel.getRow(gridCell.rowIndex);
        break;
    }
    if (!rowNode) {
      return false;
    }
    var suppressNavigable = column.isSuppressNavigable(rowNode);
    return !suppressNavigable;
  };
  CellNavigationService.prototype.getCellToLeft = function (lastCell) {
    if (!lastCell) {
      return null;
    }
    var colToLeft = this.columnModel.getDisplayedColBefore(lastCell.column);
    if (!colToLeft) {
      return null;
    }
    return {
      rowIndex: lastCell.rowIndex,
      column: colToLeft,
      rowPinned: lastCell.rowPinned
    };
  };
  CellNavigationService.prototype.getCellToRight = function (lastCell) {
    if (!lastCell) {
      return null;
    }
    var colToRight = this.columnModel.getDisplayedColAfter(lastCell.column);
    // if already on right, do nothing
    if (!colToRight) {
      return null;
    }
    return {
      rowIndex: lastCell.rowIndex,
      column: colToRight,
      rowPinned: lastCell.rowPinned
    };
  };
  CellNavigationService.prototype.getRowBelow = function (rowPosition) {
    // if already on top row, do nothing
    var index = rowPosition.rowIndex;
    var pinned = rowPosition.rowPinned;
    if (this.isLastRowInContainer(rowPosition)) {
      switch (pinned) {
        case Constants.PINNED_BOTTOM:
          // never any rows after pinned bottom
          return null;
        case Constants.PINNED_TOP:
          // if on last row of pinned top, then next row is main body (if rows exist),
          // otherwise it's the pinned bottom
          if (this.rowModel.isRowsToRender()) {
            return {
              rowIndex: this.paginationProxy.getPageFirstRow(),
              rowPinned: null
            };
          }
          if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_BOTTOM)) {
            return {
              rowIndex: 0,
              rowPinned: Constants.PINNED_BOTTOM
            };
          }
          return null;
        default:
          // if in the main body, then try pinned bottom, otherwise return nothing
          if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_BOTTOM)) {
            return {
              rowIndex: 0,
              rowPinned: Constants.PINNED_BOTTOM
            };
          }
          return null;
      }
    }
    return {
      rowIndex: index + 1,
      rowPinned: pinned
    };
  };
  CellNavigationService.prototype.getCellBelow = function (lastCell) {
    if (!lastCell) {
      return null;
    }
    var rowBelow = this.getRowBelow(lastCell);
    if (rowBelow) {
      return {
        rowIndex: rowBelow.rowIndex,
        column: lastCell.column,
        rowPinned: rowBelow.rowPinned
      };
    }
    return null;
  };
  CellNavigationService.prototype.isLastRowInContainer = function (rowPosition) {
    var pinned = rowPosition.rowPinned;
    var index = rowPosition.rowIndex;
    if (pinned === Constants.PINNED_TOP) {
      var lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
      return lastTopIndex <= index;
    }
    if (pinned === Constants.PINNED_BOTTOM) {
      var lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
      return lastBottomIndex <= index;
    }
    var lastBodyIndex = this.paginationProxy.getPageLastRow();
    return lastBodyIndex <= index;
  };
  CellNavigationService.prototype.getRowAbove = function (rowPosition) {
    // if already on top row, do nothing
    var index = rowPosition.rowIndex;
    var pinned = rowPosition.rowPinned;
    var isFirstRow = pinned ? index === 0 : index === this.paginationProxy.getPageFirstRow();
    // if already on top row, do nothing
    if (isFirstRow) {
      if (pinned === Constants.PINNED_TOP) {
        return null;
      }
      if (!pinned) {
        if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_TOP)) {
          return this.getLastFloatingTopRow();
        }
        return null;
      }
      // last floating bottom
      if (this.rowModel.isRowsToRender()) {
        return this.getLastBodyCell();
      }
      if (this.pinnedRowModel.isRowsToRender(Constants.PINNED_TOP)) {
        return this.getLastFloatingTopRow();
      }
      return null;
    }
    return {
      rowIndex: index - 1,
      rowPinned: pinned
    };
  };
  CellNavigationService.prototype.getCellAbove = function (lastCell) {
    if (!lastCell) {
      return null;
    }
    var rowAbove = this.getRowAbove({
      rowIndex: lastCell.rowIndex,
      rowPinned: lastCell.rowPinned
    });
    if (rowAbove) {
      return {
        rowIndex: rowAbove.rowIndex,
        column: lastCell.column,
        rowPinned: rowAbove.rowPinned
      };
    }
    return null;
  };
  CellNavigationService.prototype.getLastBodyCell = function () {
    var lastBodyRow = this.paginationProxy.getPageLastRow();
    return {
      rowIndex: lastBodyRow,
      rowPinned: null
    };
  };
  CellNavigationService.prototype.getLastFloatingTopRow = function () {
    var lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
    return {
      rowIndex: lastFloatingRow,
      rowPinned: Constants.PINNED_TOP
    };
  };
  CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
    if (backwards) {
      return this.getNextTabbedCellBackwards(gridCell);
    }
    return this.getNextTabbedCellForwards(gridCell);
  };
  CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
    var displayedColumns = this.columnModel.getAllDisplayedColumns();
    var newRowIndex = gridCell.rowIndex;
    var newFloating = gridCell.rowPinned;
    // move along to the next cell
    var newColumn = this.columnModel.getDisplayedColAfter(gridCell.column);
    // check if end of the row, and if so, go forward a row
    if (!newColumn) {
      newColumn = displayedColumns[0];
      var rowBelow = this.getRowBelow(gridCell);
      if (missing(rowBelow)) {
        return null;
      }
      // If we are tabbing and there is a paging panel present, tabbing should go
      // to the paging panel instead of loading the next page.
      if (!rowBelow.rowPinned && !this.paginationProxy.isRowInPage(rowBelow)) {
        return null;
      }
      newRowIndex = rowBelow ? rowBelow.rowIndex : null;
      newFloating = rowBelow ? rowBelow.rowPinned : null;
    }
    return {
      rowIndex: newRowIndex,
      column: newColumn,
      rowPinned: newFloating
    };
  };
  CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
    var displayedColumns = this.columnModel.getAllDisplayedColumns();
    var newRowIndex = gridCell.rowIndex;
    var newFloating = gridCell.rowPinned;
    // move along to the next cell
    var newColumn = this.columnModel.getDisplayedColBefore(gridCell.column);
    // check if end of the row, and if so, go forward a row
    if (!newColumn) {
      newColumn = last(displayedColumns);
      var rowAbove = this.getRowAbove({
        rowIndex: gridCell.rowIndex,
        rowPinned: gridCell.rowPinned
      });
      if (missing(rowAbove)) {
        return null;
      }
      // If we are tabbing and there is a paging panel present, tabbing should go
      // to the paging panel instead of loading the next page.
      if (!rowAbove.rowPinned && !this.paginationProxy.isRowInPage(rowAbove)) {
        return null;
      }
      newRowIndex = rowAbove ? rowAbove.rowIndex : null;
      newFloating = rowAbove ? rowAbove.rowPinned : null;
    }
    return {
      rowIndex: newRowIndex,
      column: newColumn,
      rowPinned: newFloating
    };
  };
  __decorate$1z([Autowired('columnModel')], CellNavigationService.prototype, "columnModel", void 0);
  __decorate$1z([Autowired('rowModel')], CellNavigationService.prototype, "rowModel", void 0);
  __decorate$1z([Autowired('pinnedRowModel')], CellNavigationService.prototype, "pinnedRowModel", void 0);
  __decorate$1z([Autowired('paginationProxy')], CellNavigationService.prototype, "paginationProxy", void 0);
  CellNavigationService = __decorate$1z([Bean('cellNavigationService')], CellNavigationService);
  return CellNavigationService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1M = undefined && undefined.__extends || function () {
  var _extendStatics113 = function extendStatics(d, b) {
    _extendStatics113 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics113(d, b);
  };
  return function (d, b) {
    _extendStatics113(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1A = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ValueFormatterService = /** @class */function (_super) {
  __extends$1M(ValueFormatterService, _super);
  function ValueFormatterService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ValueFormatterService.prototype.formatValue = function (column, node, $scope, value, suppliedFormatter, useFormatterFromColumn) {
    if (useFormatterFromColumn === void 0) {
      useFormatterFromColumn = true;
    }
    var result = null;
    var formatter;
    var colDef = column.getColDef();
    if (suppliedFormatter) {
      // use supplied formatter if provided, e.g. set filter items can have their own value formatters
      formatter = suppliedFormatter;
    } else if (useFormatterFromColumn) {
      // if row is pinned, give preference to the pinned formatter
      formatter = node && node.rowPinned && colDef.pinnedRowValueFormatter ? colDef.pinnedRowValueFormatter : colDef.valueFormatter;
    }
    if (formatter) {
      var params = {
        value: value,
        node: node,
        data: node ? node.data : null,
        colDef: colDef,
        column: column,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      // originally we put the angular 1 scope here, but we don't want the scope
      // in the params interface, as other frameworks will see the interface, and
      // angular 1 is not cool any more. so we hack the scope in here (we cannot
      // include it above, as it's not in the interface, so would cause a compile error).
      // in the future, when we stop supporting angular 1, we can take this out.
      params.$scope = $scope;
      result = this.expressionService.evaluate(formatter, params);
    } else if (colDef.refData) {
      return colDef.refData[value] || '';
    }
    // if we don't do this, then arrays get displayed as 1,2,3, but we want 1, 2, 3 (i.e. with spaces)
    if (result == null && Array.isArray(value)) {
      result = value.join(', ');
    }
    return result;
  };
  __decorate$1A([Autowired('expressionService')], ValueFormatterService.prototype, "expressionService", void 0);
  ValueFormatterService = __decorate$1A([Bean('valueFormatterService')], ValueFormatterService);
  return ValueFormatterService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1N = undefined && undefined.__extends || function () {
  var _extendStatics114 = function extendStatics(d, b) {
    _extendStatics114 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics114(d, b);
  };
  return function (d, b) {
    _extendStatics114(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgRadioButton = /** @class */function (_super) {
  __extends$1N(AgRadioButton, _super);
  function AgRadioButton(config) {
    return _super.call(this, config, 'ag-radio-button', 'radio') || this;
  }
  AgRadioButton.prototype.isSelected = function () {
    return this.eInput.checked;
  };
  AgRadioButton.prototype.toggle = function () {
    if (this.eInput.disabled) {
      return;
    }
    // do not allow an active radio button to be deselected
    if (!this.isSelected()) {
      this.setValue(true);
    }
  };
  AgRadioButton.prototype.addInputListeners = function () {
    _super.prototype.addInputListeners.call(this);
    this.addManagedListener(this.eventService, Events.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
  };
  /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */
  AgRadioButton.prototype.onChange = function (event) {
    if (event.selected && event.name && this.eInput.name && this.eInput.name === event.name && event.id && this.eInput.id !== event.id) {
      this.setValue(false, true);
    }
  };
  return AgRadioButton;
}(AgCheckbox);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var OUTSIDE_ANGULAR_EVENTS = ['mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
var VanillaFrameworkOverrides = /** @class */function () {
  function VanillaFrameworkOverrides() {
    this.isOutsideAngular = function (eventType) {
      return includes(OUTSIDE_ANGULAR_EVENTS, eventType);
    };
  }
  // for Vanilla JS, we use simple timeout
  VanillaFrameworkOverrides.prototype.setTimeout = function (action, timeout) {
    window.setTimeout(action, timeout);
  };
  VanillaFrameworkOverrides.prototype.setInterval = function (action, timeout) {
    return new AgPromise(function (resolve) {
      resolve(window.setInterval(action, timeout));
    });
  };
  // for Vanilla JS, we just add the event to the element
  VanillaFrameworkOverrides.prototype.addEventListener = function (element, type, listener, useCapture) {
    element.addEventListener(type, listener, useCapture);
  };
  // for Vanilla JS, we just execute the listener
  VanillaFrameworkOverrides.prototype.dispatchEvent = function (eventType, listener, global) {
    listener();
  };
  VanillaFrameworkOverrides.prototype.frameworkComponent = function (name) {
    return null;
  };
  return VanillaFrameworkOverrides;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1O = undefined && undefined.__extends || function () {
  var _extendStatics115 = function extendStatics(d, b) {
    _extendStatics115 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics115(d, b);
  };
  return function (d, b) {
    _extendStatics115(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1B = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ScrollVisibleService = /** @class */function (_super) {
  __extends$1O(ScrollVisibleService, _super);
  function ScrollVisibleService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ScrollVisibleService.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
  };
  ScrollVisibleService.prototype.onDisplayedColumnsChanged = function () {
    this.update();
  };
  ScrollVisibleService.prototype.onDisplayedColumnsWidthChanged = function () {
    this.update();
  };
  ScrollVisibleService.prototype.update = function () {
    // because of column animation (which takes 200ms), we have to do this twice.
    // eg if user removes cols anywhere except at the RHS, then the cols on the RHS
    // will animate to the left to fill the gap. this animation means just after
    // the cols are removed, the remaining cols are still in the original location
    // at the start of the animation, so pre animation the H scrollbar is still needed,
    // but post animation it is not.
    this.updateImpl();
    setTimeout(this.updateImpl.bind(this), 500);
  };
  ScrollVisibleService.prototype.updateImpl = function () {
    var centerRowCtrl = this.ctrlsService.getCenterRowContainerCtrl();
    if (!centerRowCtrl) {
      return;
    }
    var params = {
      horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
      verticalScrollShowing: this.isVerticalScrollShowing()
    };
    this.setScrollsVisible(params);
  };
  ScrollVisibleService.prototype.setScrollsVisible = function (params) {
    var atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
    if (atLeastOneDifferent) {
      this.horizontalScrollShowing = params.horizontalScrollShowing;
      this.verticalScrollShowing = params.verticalScrollShowing;
      var event_1 = {
        type: Events.EVENT_SCROLL_VISIBILITY_CHANGED,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  // used by pagination service - to know page height
  ScrollVisibleService.prototype.isHorizontalScrollShowing = function () {
    return this.horizontalScrollShowing;
  };
  // used by header container
  ScrollVisibleService.prototype.isVerticalScrollShowing = function () {
    return this.verticalScrollShowing;
  };
  __decorate$1B([Autowired('columnApi')], ScrollVisibleService.prototype, "columnApi", void 0);
  __decorate$1B([Autowired('gridApi')], ScrollVisibleService.prototype, "gridApi", void 0);
  __decorate$1B([Autowired('ctrlsService')], ScrollVisibleService.prototype, "ctrlsService", void 0);
  __decorate$1B([PostConstruct], ScrollVisibleService.prototype, "postConstruct", null);
  ScrollVisibleService = __decorate$1B([Bean('scrollVisibleService')], ScrollVisibleService);
  return ScrollVisibleService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1P = undefined && undefined.__extends || function () {
  var _extendStatics116 = function extendStatics(d, b) {
    _extendStatics116 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics116(d, b);
  };
  return function (d, b) {
    _extendStatics116(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1C = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StylingService = /** @class */function (_super) {
  __extends$1P(StylingService, _super);
  function StylingService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  StylingService.prototype.processAllCellClasses = function (colDef, params, onApplicableClass, onNotApplicableClass) {
    this.processClassRules(colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
    this.processStaticCellClasses(colDef, params, onApplicableClass);
  };
  StylingService.prototype.processClassRules = function (classRules, params, onApplicableClass, onNotApplicableClass) {
    if (classRules == null) {
      return;
    }
    var classNames = Object.keys(classRules);
    var classesToApply = {};
    var classesToRemove = {};
    var _loop_1 = function _loop_1(i) {
      var className = classNames[i];
      var rule = classRules[className];
      var resultOfRule;
      if (typeof rule === 'string') {
        resultOfRule = this_1.expressionService.evaluate(rule, params);
      } else if (typeof rule === 'function') {
        resultOfRule = rule(params);
      }
      // in case className = 'my-class1 my-class2', we need to split into individual class names
      className.split(' ').forEach(function (singleClass) {
        if (singleClass == null || singleClass.trim() == '') {
          return;
        }
        resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
      });
      // we remove all classes first, then add all classes second,
      // in case a class appears in more than one rule, this means it will be added
      // if appears in at least one truthy rule
      if (onNotApplicableClass) {
        Object.keys(classesToRemove).forEach(onNotApplicableClass);
      }
      Object.keys(classesToApply).forEach(onApplicableClass);
    };
    var this_1 = this;
    for (var i = 0; i < classNames.length; i++) {
      _loop_1(i);
    }
  };
  StylingService.prototype.getStaticCellClasses = function (colDef, params) {
    var cellClass = colDef.cellClass;
    if (!cellClass) {
      return [];
    }
    var classOrClasses;
    if (typeof cellClass === 'function') {
      var cellClassFunc = colDef.cellClass;
      classOrClasses = cellClassFunc(params);
    } else {
      classOrClasses = cellClass;
    }
    if (typeof classOrClasses === 'string') {
      classOrClasses = [classOrClasses];
    }
    return classOrClasses;
  };
  StylingService.prototype.processStaticCellClasses = function (colDef, params, onApplicableClass) {
    var classOrClasses = this.getStaticCellClasses(colDef, params);
    classOrClasses.forEach(function (cssClassItem) {
      onApplicableClass(cssClassItem);
    });
  };
  __decorate$1C([Autowired('expressionService')], StylingService.prototype, "expressionService", void 0);
  StylingService = __decorate$1C([Bean('stylingService')], StylingService);
  return StylingService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1Q = undefined && undefined.__extends || function () {
  var _extendStatics117 = function extendStatics(d, b) {
    _extendStatics117 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics117(d, b);
  };
  return function (d, b) {
    _extendStatics117(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1D = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnHoverService = /** @class */function (_super) {
  __extends$1Q(ColumnHoverService, _super);
  function ColumnHoverService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnHoverService.prototype.setMouseOver = function (columns) {
    this.selectedColumns = columns;
    var event = {
      type: Events.EVENT_COLUMN_HOVER_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnHoverService.prototype.clearMouseOver = function () {
    this.selectedColumns = null;
    var event = {
      type: Events.EVENT_COLUMN_HOVER_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ColumnHoverService.prototype.isHovered = function (column) {
    return !!this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
  };
  __decorate$1D([Autowired('columnApi')], ColumnHoverService.prototype, "columnApi", void 0);
  __decorate$1D([Autowired('gridApi')], ColumnHoverService.prototype, "gridApi", void 0);
  ColumnHoverService = __decorate$1D([Bean('columnHoverService')], ColumnHoverService);
  return ColumnHoverService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1R = undefined && undefined.__extends || function () {
  var _extendStatics118 = function extendStatics(d, b) {
    _extendStatics118 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics118(d, b);
  };
  return function (d, b) {
    _extendStatics118(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1E = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnAnimationService = /** @class */function (_super) {
  __extends$1R(ColumnAnimationService, _super);
  function ColumnAnimationService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.executeNextFuncs = [];
    _this.executeLaterFuncs = [];
    _this.active = false;
    _this.animationThreadCount = 0;
    return _this;
  }
  ColumnAnimationService.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      return _this.gridBodyCtrl = p.gridBodyCtrl;
    });
  };
  ColumnAnimationService.prototype.isActive = function () {
    return this.active;
  };
  ColumnAnimationService.prototype.start = function () {
    if (this.active) {
      return;
    }
    if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
      return;
    }
    // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
    // the animation moves all the row the the right rather than to the left (ie it's the static
    // columns that actually get their coordinates updated)
    if (this.gridOptionsWrapper.isEnableRtl()) {
      return;
    }
    this.ensureAnimationCssClassPresent();
    this.active = true;
  };
  ColumnAnimationService.prototype.finish = function () {
    if (!this.active) {
      return;
    }
    this.flush();
    this.active = false;
  };
  ColumnAnimationService.prototype.executeNextVMTurn = function (func) {
    if (this.active) {
      this.executeNextFuncs.push(func);
    } else {
      func();
    }
  };
  ColumnAnimationService.prototype.executeLaterVMTurn = function (func) {
    if (this.active) {
      this.executeLaterFuncs.push(func);
    } else {
      func();
    }
  };
  ColumnAnimationService.prototype.ensureAnimationCssClassPresent = function () {
    var _this = this;
    // up the count, so we can tell if someone else has updated the count
    // by the time the 'wait' func executes
    this.animationThreadCount++;
    var animationThreadCountCopy = this.animationThreadCount;
    this.gridBodyCtrl.setColumnMovingCss(true);
    this.executeLaterFuncs.push(function () {
      // only remove the class if this thread was the last one to update it
      if (_this.animationThreadCount === animationThreadCountCopy) {
        _this.gridBodyCtrl.setColumnMovingCss(false);
      }
    });
  };
  ColumnAnimationService.prototype.flush = function () {
    var nowFuncs = this.executeNextFuncs;
    this.executeNextFuncs = [];
    var waitFuncs = this.executeLaterFuncs;
    this.executeLaterFuncs = [];
    if (nowFuncs.length === 0 && waitFuncs.length === 0) {
      return;
    }
    window.setTimeout(function () {
      return nowFuncs.forEach(function (func) {
        return func();
      });
    }, 0);
    window.setTimeout(function () {
      return waitFuncs.forEach(function (func) {
        return func();
      });
    }, 300);
  };
  __decorate$1E([Autowired('ctrlsService')], ColumnAnimationService.prototype, "ctrlsService", void 0);
  __decorate$1E([PostConstruct], ColumnAnimationService.prototype, "postConstruct", null);
  ColumnAnimationService = __decorate$1E([Bean('columnAnimationService')], ColumnAnimationService);
  return ColumnAnimationService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1S = undefined && undefined.__extends || function () {
  var _extendStatics119 = function extendStatics(d, b) {
    _extendStatics119 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics119(d, b);
  };
  return function (d, b) {
    _extendStatics119(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1F = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AutoGroupColService = /** @class */function (_super) {
  __extends$1S(AutoGroupColService, _super);
  function AutoGroupColService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AutoGroupColService_1 = AutoGroupColService;
  AutoGroupColService.prototype.createAutoGroupColumns = function (rowGroupColumns) {
    var _this = this;
    var groupAutoColumns = [];
    var doingTreeData = this.gridOptionsWrapper.isTreeData();
    var doingMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
    if (doingTreeData && doingMultiAutoColumn) {
      console.warn('AG Grid: you cannot mix groupMultiAutoColumn with treeData, only one column can be used to display groups when doing tree data');
      doingMultiAutoColumn = false;
    }
    // if doing groupMultiAutoColumn, then we call the method multiple times, once
    // for each column we are grouping by
    if (doingMultiAutoColumn) {
      rowGroupColumns.forEach(function (rowGroupCol, index) {
        groupAutoColumns.push(_this.createOneAutoGroupColumn(rowGroupCol, index));
      });
    } else {
      groupAutoColumns.push(this.createOneAutoGroupColumn());
    }
    return groupAutoColumns;
  };
  // rowGroupCol and index are missing if groupMultiAutoColumn=false
  AutoGroupColService.prototype.createOneAutoGroupColumn = function (rowGroupCol, index) {
    // if one provided by user, use it, otherwise create one
    var defaultAutoColDef = this.generateDefaultColDef(rowGroupCol);
    // if doing multi, set the field
    var colId;
    if (rowGroupCol) {
      colId = Constants.GROUP_AUTO_COLUMN_ID + "-" + rowGroupCol.getId();
    } else {
      colId = AutoGroupColService_1.GROUP_AUTO_COLUMN_BUNDLE_ID;
    }
    var userAutoColDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
    mergeDeep(defaultAutoColDef, userAutoColDef);
    defaultAutoColDef = this.columnFactory.mergeColDefs(defaultAutoColDef);
    defaultAutoColDef.colId = colId;
    // For tree data the filter is always allowed
    if (!this.gridOptionsWrapper.isTreeData()) {
      // we would only allow filter if the user has provided field or value getter. otherwise the filter
      // would not be able to work.
      var noFieldOrValueGetter = missing(defaultAutoColDef.field) && missing(defaultAutoColDef.valueGetter) && missing(defaultAutoColDef.filterValueGetter);
      if (noFieldOrValueGetter) {
        defaultAutoColDef.filter = false;
      }
    }
    // if showing many cols, we don't want to show more than one with a checkbox for selection
    if (index && index > 0) {
      defaultAutoColDef.headerCheckboxSelection = false;
    }
    var newCol = new Column(defaultAutoColDef, null, colId, true);
    this.context.createBean(newCol);
    return newCol;
  };
  AutoGroupColService.prototype.generateDefaultColDef = function (rowGroupCol) {
    var userDef = this.gridOptionsWrapper.getAutoGroupColumnDef();
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var res = {
      headerName: localeTextFunc('group', 'Group')
    };
    var userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererFramework || userDef.cellRendererSelector);
    // only add the default group cell renderer if user hasn't provided one
    if (!userHasProvidedGroupCellRenderer) {
      res.cellRenderer = 'agGroupCellRenderer';
    }
    // we never allow moving the group column
    // defaultAutoColDef.suppressMovable = true;
    if (rowGroupCol) {
      var colDef = rowGroupCol.getColDef();
      assign$3(res, {
        // cellRendererParams.groupKey: colDefToCopy.field;
        headerName: this.columnModel.getDisplayNameForColumn(rowGroupCol, 'header'),
        headerValueGetter: colDef.headerValueGetter
      });
      if (colDef.cellRenderer) {
        assign$3(res, {
          cellRendererParams: {
            innerRenderer: colDef.cellRenderer,
            innerRendererParams: colDef.cellRendererParams
          }
        });
      }
      res.showRowGroup = rowGroupCol.getColId();
    } else {
      res.showRowGroup = true;
    }
    return res;
  };
  var AutoGroupColService_1;
  AutoGroupColService.GROUP_AUTO_COLUMN_BUNDLE_ID = Constants.GROUP_AUTO_COLUMN_ID;
  __decorate$1F([Autowired('columnModel')], AutoGroupColService.prototype, "columnModel", void 0);
  __decorate$1F([Autowired('columnFactory')], AutoGroupColService.prototype, "columnFactory", void 0);
  AutoGroupColService = AutoGroupColService_1 = __decorate$1F([Bean('autoGroupColService')], AutoGroupColService);
  return AutoGroupColService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1T = undefined && undefined.__extends || function () {
  var _extendStatics120 = function extendStatics(d, b) {
    _extendStatics120 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics120(d, b);
  };
  return function (d, b) {
    _extendStatics120(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1G = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaginationProxy = /** @class */function (_super) {
  __extends$1T(PaginationProxy, _super);
  function PaginationProxy() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.currentPage = 0;
    _this.topDisplayedRowIndex = 0;
    _this.bottomDisplayedRowIndex = 0;
    _this.pixelOffset = 0;
    _this.masterRowCount = 0;
    return _this;
  }
  PaginationProxy.prototype.postConstruct = function () {
    this.active = this.gridOptionsWrapper.isPagination();
    this.paginateChildRows = this.gridOptionsWrapper.isPaginateChildRows();
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, 'paginationPageSize', this.onPaginationPageSizeChanged.bind(this));
    this.onModelUpdated();
  };
  PaginationProxy.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
    var res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
    if (res) {
      this.calculatePages();
    }
    return res;
  };
  PaginationProxy.prototype.onModelUpdated = function (modelUpdatedEvent) {
    this.calculatePages();
    var paginationChangedEvent = {
      type: Events.EVENT_PAGINATION_CHANGED,
      animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
      newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
      newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
      keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(paginationChangedEvent);
  };
  PaginationProxy.prototype.onPaginationPageSizeChanged = function () {
    this.calculatePages();
    var paginationChangedEvent = {
      type: Events.EVENT_PAGINATION_CHANGED,
      animate: false,
      newData: false,
      newPage: false,
      // important to keep rendered rows, otherwise every time grid is resized,
      // we would destroy all the rows.
      keepRenderedRows: true,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(paginationChangedEvent);
  };
  PaginationProxy.prototype.goToPage = function (page) {
    if (!this.active || this.currentPage === page) {
      return;
    }
    this.currentPage = page;
    var event = {
      type: Events.EVENT_MODEL_UPDATED,
      animate: false,
      keepRenderedRows: false,
      newData: false,
      newPage: true,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.onModelUpdated(event);
  };
  PaginationProxy.prototype.getPixelOffset = function () {
    return this.pixelOffset;
  };
  PaginationProxy.prototype.getRow = function (index) {
    return this.rowModel.getRow(index);
  };
  PaginationProxy.prototype.getRowNode = function (id) {
    return this.rowModel.getRowNode(id);
  };
  PaginationProxy.prototype.getRowIndexAtPixel = function (pixel) {
    return this.rowModel.getRowIndexAtPixel(pixel);
  };
  PaginationProxy.prototype.getCurrentPageHeight = function () {
    if (missing(this.topRowBounds) || missing(this.bottomRowBounds)) {
      return 0;
    }
    return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
  };
  PaginationProxy.prototype.getCurrentPagePixelRange = function () {
    var pageFirstPixel = this.topRowBounds ? this.topRowBounds.rowTop : 0;
    var pageLastPixel = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
    return {
      pageFirstPixel: pageFirstPixel,
      pageLastPixel: pageLastPixel
    };
  };
  PaginationProxy.prototype.isRowPresent = function (rowNode) {
    if (!this.rowModel.isRowPresent(rowNode)) {
      return false;
    }
    var nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
    return nodeIsInPage;
  };
  PaginationProxy.prototype.isEmpty = function () {
    return this.rowModel.isEmpty();
  };
  PaginationProxy.prototype.isRowsToRender = function () {
    return this.rowModel.isRowsToRender();
  };
  PaginationProxy.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
    return this.rowModel.getNodesInRangeForSelection(firstInRange, lastInRange);
  };
  PaginationProxy.prototype.forEachNode = function (callback) {
    return this.rowModel.forEachNode(callback);
  };
  PaginationProxy.prototype.getType = function () {
    return this.rowModel.getType();
  };
  PaginationProxy.prototype.getRowBounds = function (index) {
    var res = this.rowModel.getRowBounds(index);
    res.rowIndex = index;
    return res;
  };
  PaginationProxy.prototype.getPageFirstRow = function () {
    return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
  };
  PaginationProxy.prototype.getPageLastRow = function () {
    return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
  };
  PaginationProxy.prototype.getRowCount = function () {
    return this.rowModel.getRowCount();
  };
  PaginationProxy.prototype.getPageForIndex = function (index) {
    return Math.floor(index / this.pageSize);
  };
  PaginationProxy.prototype.goToPageWithIndex = function (index) {
    if (!this.active) {
      return;
    }
    var pageNumber = this.getPageForIndex(index);
    this.goToPage(pageNumber);
  };
  PaginationProxy.prototype.isRowInPage = function (row) {
    if (!this.active) {
      return true;
    }
    var rowPage = this.getPageForIndex(row.rowIndex);
    return rowPage === this.currentPage;
  };
  PaginationProxy.prototype.isLastPageFound = function () {
    return this.rowModel.isLastRowIndexKnown();
  };
  PaginationProxy.prototype.getCurrentPage = function () {
    return this.currentPage;
  };
  PaginationProxy.prototype.goToNextPage = function () {
    this.goToPage(this.currentPage + 1);
  };
  PaginationProxy.prototype.goToPreviousPage = function () {
    this.goToPage(this.currentPage - 1);
  };
  PaginationProxy.prototype.goToFirstPage = function () {
    this.goToPage(0);
  };
  PaginationProxy.prototype.goToLastPage = function () {
    var rowCount = this.rowModel.getRowCount();
    var lastPage = Math.floor(rowCount / this.pageSize);
    this.goToPage(lastPage);
  };
  PaginationProxy.prototype.getPageSize = function () {
    return this.pageSize;
  };
  PaginationProxy.prototype.getTotalPages = function () {
    return this.totalPages;
  };
  PaginationProxy.prototype.setPageSize = function () {
    // show put this into super class
    this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
    if (this.pageSize == null || this.pageSize < 1) {
      this.pageSize = 100;
    }
  };
  PaginationProxy.prototype.calculatePages = function () {
    if (this.active) {
      this.setPageSize();
      if (this.paginateChildRows) {
        this.calculatePagesAllRows();
      } else {
        this.calculatePagesMasterRowsOnly();
      }
    } else {
      this.calculatedPagesNotActive();
    }
    this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
    if (this.topRowBounds) {
      this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
    }
    this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
    if (this.bottomRowBounds) {
      this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
    }
    this.setPixelOffset(exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
  };
  PaginationProxy.prototype.setPixelOffset = function (value) {
    if (this.pixelOffset === value) {
      return;
    }
    this.pixelOffset = value;
    this.eventService.dispatchEvent({
      type: Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED
    });
  };
  PaginationProxy.prototype.setZeroRows = function () {
    this.masterRowCount = 0;
    this.topDisplayedRowIndex = 0;
    this.bottomDisplayedRowIndex = -1;
    this.currentPage = 0;
    this.totalPages = 0;
  };
  PaginationProxy.prototype.calculatePagesMasterRowsOnly = function () {
    // const csrm = <ClientSideRowModel> this.rowModel;
    // const rootNode = csrm.getRootNode();
    // const masterRows = rootNode.childrenAfterSort;
    this.masterRowCount = this.rowModel.getTopLevelRowCount();
    // we say <=0 (rather than =0) as viewport returns -1 when no rows
    if (this.masterRowCount <= 0) {
      this.setZeroRows();
      return;
    }
    var masterLastRowIndex = this.masterRowCount - 1;
    this.totalPages = Math.floor(masterLastRowIndex / this.pageSize) + 1;
    if (this.currentPage >= this.totalPages) {
      this.currentPage = this.totalPages - 1;
    }
    if (!isNumeric(this.currentPage) || this.currentPage < 0) {
      this.currentPage = 0;
    }
    var masterPageStartIndex = this.pageSize * this.currentPage;
    var masterPageEndIndex = this.pageSize * (this.currentPage + 1) - 1;
    if (masterPageEndIndex > masterLastRowIndex) {
      masterPageEndIndex = masterLastRowIndex;
    }
    this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
    // masterRows[masterPageStartIndex].rowIndex;
    if (masterPageEndIndex === masterLastRowIndex) {
      // if showing the last master row, then we want to show the very last row of the model
      this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    } else {
      var firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
      //masterRows[masterPageEndIndex + 1].rowIndex;
      // this gets the index of the last child - eg current row is open, we want to display all children,
      // the index of the last child is one less than the index of the next parent row.
      this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
    }
  };
  PaginationProxy.prototype.getMasterRowCount = function () {
    return this.masterRowCount;
  };
  PaginationProxy.prototype.calculatePagesAllRows = function () {
    this.masterRowCount = this.rowModel.getRowCount();
    if (this.masterRowCount === 0) {
      this.setZeroRows();
      return;
    }
    var maxRowIndex = this.masterRowCount - 1;
    this.totalPages = Math.floor(maxRowIndex / this.pageSize) + 1;
    if (this.currentPage >= this.totalPages) {
      this.currentPage = this.totalPages - 1;
    }
    if (!isNumeric(this.currentPage) || this.currentPage < 0) {
      this.currentPage = 0;
    }
    this.topDisplayedRowIndex = this.pageSize * this.currentPage;
    this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1;
    if (this.bottomDisplayedRowIndex > maxRowIndex) {
      this.bottomDisplayedRowIndex = maxRowIndex;
    }
  };
  PaginationProxy.prototype.calculatedPagesNotActive = function () {
    this.pageSize = this.rowModel.getRowCount();
    this.totalPages = 1;
    this.currentPage = 0;
    this.topDisplayedRowIndex = 0;
    this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
  };
  __decorate$1G([Autowired('rowModel')], PaginationProxy.prototype, "rowModel", void 0);
  __decorate$1G([Autowired('columnApi')], PaginationProxy.prototype, "columnApi", void 0);
  __decorate$1G([Autowired('gridApi')], PaginationProxy.prototype, "gridApi", void 0);
  __decorate$1G([PostConstruct], PaginationProxy.prototype, "postConstruct", null);
  PaginationProxy = __decorate$1G([Bean('paginationProxy')], PaginationProxy);
  return PaginationProxy;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1U = undefined && undefined.__extends || function () {
  var _extendStatics121 = function extendStatics(d, b) {
    _extendStatics121 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics121(d, b);
  };
  return function (d, b) {
    _extendStatics121(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1H = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaginationAutoPageSizeService = /** @class */function (_super) {
  __extends$1U(PaginationAutoPageSizeService, _super);
  function PaginationAutoPageSizeService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PaginationAutoPageSizeService.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      _this.centerRowContainerCon = p.centerRowContainerCtrl;
      _this.addManagedListener(_this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, _this.onBodyHeightChanged.bind(_this));
      _this.addManagedListener(_this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, _this.onScrollVisibilityChanged.bind(_this));
      _this.checkPageSize();
    });
  };
  PaginationAutoPageSizeService.prototype.notActive = function () {
    return !this.gridOptionsWrapper.isPaginationAutoPageSize();
  };
  PaginationAutoPageSizeService.prototype.onScrollVisibilityChanged = function () {
    this.checkPageSize();
  };
  PaginationAutoPageSizeService.prototype.onBodyHeightChanged = function () {
    this.checkPageSize();
  };
  PaginationAutoPageSizeService.prototype.checkPageSize = function () {
    if (this.notActive()) {
      return;
    }
    var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
    var bodyHeight = this.centerRowContainerCon.getViewportSizeFeature().getBodyHeight();
    if (bodyHeight > 0) {
      var newPageSize = Math.floor(bodyHeight / rowHeight);
      this.gridOptionsWrapper.setProperty('paginationPageSize', newPageSize);
    }
  };
  __decorate$1H([Autowired('ctrlsService')], PaginationAutoPageSizeService.prototype, "ctrlsService", void 0);
  __decorate$1H([PostConstruct], PaginationAutoPageSizeService.prototype, "postConstruct", null);
  PaginationAutoPageSizeService = __decorate$1H([Bean('paginationAutoPageSizeService')], PaginationAutoPageSizeService);
  return PaginationAutoPageSizeService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1V = undefined && undefined.__extends || function () {
  var _extendStatics122 = function extendStatics(d, b) {
    _extendStatics122 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics122(d, b);
  };
  return function (d, b) {
    _extendStatics122(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1I = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ValueCache = /** @class */function (_super) {
  __extends$1V(ValueCache, _super);
  function ValueCache() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.cacheVersion = 0;
    return _this;
  }
  ValueCache.prototype.init = function () {
    this.active = this.gridOptionsWrapper.isValueCache();
    this.neverExpires = this.gridOptionsWrapper.isValueCacheNeverExpires();
  };
  ValueCache.prototype.onDataChanged = function () {
    if (this.neverExpires) {
      return;
    }
    this.expire();
  };
  ValueCache.prototype.expire = function () {
    this.cacheVersion++;
  };
  ValueCache.prototype.setValue = function (rowNode, colId, value) {
    if (this.active) {
      if (rowNode.__cacheVersion !== this.cacheVersion) {
        rowNode.__cacheVersion = this.cacheVersion;
        rowNode.__cacheData = {};
      }
      rowNode.__cacheData[colId] = value;
    }
  };
  ValueCache.prototype.getValue = function (rowNode, colId) {
    if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) {
      return undefined;
    }
    return rowNode.__cacheData[colId];
  };
  __decorate$1I([PostConstruct], ValueCache.prototype, "init", null);
  ValueCache = __decorate$1I([Bean('valueCache')], ValueCache);
  return ValueCache;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1W = undefined && undefined.__extends || function () {
  var _extendStatics123 = function extendStatics(d, b) {
    _extendStatics123 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics123(d, b);
  };
  return function (d, b) {
    _extendStatics123(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1J = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChangeDetectionService = /** @class */function (_super) {
  __extends$1W(ChangeDetectionService, _super);
  function ChangeDetectionService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ChangeDetectionService.prototype.init = function () {
    if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      this.clientSideRowModel = this.rowModel;
    }
    this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
  };
  ChangeDetectionService.prototype.onCellValueChanged = function (event) {
    // Clipboard service manages its own change detection, so no need to do it here.
    // The clipboard manages its own as otherwise this would happen once for every cell
    // that got updated as part of a paste operation, so e.g. if 100 cells in a paste operation,
    // this doChangeDetection would get called 100 times (once for each cell), instead clipboard
    // service executes the logic we have here once (in essence batching up all cell changes
    // into one change detection).
    if (event.source === Constants.SOURCE_PASTE) {
      return;
    }
    this.doChangeDetection(event.node, event.column);
  };
  ChangeDetectionService.prototype.doChangeDetection = function (rowNode, column) {
    if (this.gridOptionsWrapper.isSuppressChangeDetection()) {
      return;
    }
    // step 1 of change detection is to update the aggregated values
    if (this.clientSideRowModel && !rowNode.isRowPinned()) {
      var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
      var changedPath = new ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
      changedPath.addParentNode(rowNode.parent, [column]);
      this.clientSideRowModel.doAggregate(changedPath);
    }
    // step 2 of change detection is to refresh the cells
    this.rowRenderer.refreshCells();
  };
  __decorate$1J([Autowired('rowModel')], ChangeDetectionService.prototype, "rowModel", void 0);
  __decorate$1J([Autowired('rowRenderer')], ChangeDetectionService.prototype, "rowRenderer", void 0);
  __decorate$1J([PostConstruct], ChangeDetectionService.prototype, "init", null);
  ChangeDetectionService = __decorate$1J([Bean('changeDetectionService')], ChangeDetectionService);
  return ChangeDetectionService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1X = undefined && undefined.__extends || function () {
  var _extendStatics124 = function extendStatics(d, b) {
    _extendStatics124 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics124(d, b);
  };
  return function (d, b) {
    _extendStatics124(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1K = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$7 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var AlignedGridsService = /** @class */function (_super) {
  __extends$1X(AlignedGridsService, _super);
  function AlignedGridsService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
    // while processing a master event) we mark this if consuming an event, and if we are, then
    // we don't fire back any events.
    _this.consuming = false;
    return _this;
  }
  AlignedGridsService.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('AlignedGridsService');
  };
  AlignedGridsService.prototype.init = function () {
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
  };
  // common logic across all the fire methods
  AlignedGridsService.prototype.fireEvent = function (callback) {
    // if we are already consuming, then we are acting on an event from a master,
    // so we don't cause a cyclic firing of events
    if (this.consuming) {
      return;
    }
    // iterate through the aligned grids, and pass each aligned grid service to the callback
    var otherGrids = this.gridOptionsWrapper.getAlignedGrids();
    if (otherGrids) {
      otherGrids.forEach(function (otherGridOptions) {
        if (otherGridOptions.api) {
          var alignedGridService = otherGridOptions.api.__getAlignedGridService();
          callback(alignedGridService);
        }
      });
    }
  };
  // common logic across all consume methods. very little common logic, however extracting
  // guarantees consistency across the methods.
  AlignedGridsService.prototype.onEvent = function (callback) {
    this.consuming = true;
    callback();
    this.consuming = false;
  };
  AlignedGridsService.prototype.fireColumnEvent = function (event) {
    this.fireEvent(function (alignedGridsService) {
      alignedGridsService.onColumnEvent(event);
    });
  };
  AlignedGridsService.prototype.fireScrollEvent = function (event) {
    if (event.direction !== 'horizontal') {
      return;
    }
    this.fireEvent(function (alignedGridsService) {
      alignedGridsService.onScrollEvent(event);
    });
  };
  AlignedGridsService.prototype.onScrollEvent = function (event) {
    var _this = this;
    this.onEvent(function () {
      var gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
      gridBodyCon.getScrollFeature().setHorizontalScrollPosition(event.left);
    });
  };
  AlignedGridsService.prototype.getMasterColumns = function (event) {
    var result = [];
    if (event.columns) {
      event.columns.forEach(function (column) {
        result.push(column);
      });
    } else if (event.column) {
      result.push(event.column);
    }
    return result;
  };
  AlignedGridsService.prototype.getColumnIds = function (event) {
    var result = [];
    if (event.columns) {
      event.columns.forEach(function (column) {
        result.push(column.getColId());
      });
    } else if (event.column) {
      result.push(event.column.getColId());
    }
    return result;
  };
  AlignedGridsService.prototype.onColumnEvent = function (event) {
    var _this = this;
    this.onEvent(function () {
      switch (event.type) {
        case Events.EVENT_COLUMN_MOVED:
        case Events.EVENT_COLUMN_VISIBLE:
        case Events.EVENT_COLUMN_PINNED:
        case Events.EVENT_COLUMN_RESIZED:
          var colEvent = event;
          _this.processColumnEvent(colEvent);
          break;
        case Events.EVENT_COLUMN_GROUP_OPENED:
          var groupOpenedEvent = event;
          _this.processGroupOpenedEvent(groupOpenedEvent);
          break;
        case Events.EVENT_COLUMN_PIVOT_CHANGED:
          // we cannot support pivoting with aligned grids as the columns will be out of sync as the
          // grids will have columns created based on the row data of the grid.
          console.warn('AG Grid: pivoting is not supported with aligned grids. ' + 'You can only use one of these features at a time in a grid.');
          break;
      }
    });
  };
  AlignedGridsService.prototype.processGroupOpenedEvent = function (groupOpenedEvent) {
    // likewise for column group
    var masterColumnGroup = groupOpenedEvent.columnGroup;
    var otherColumnGroup = null;
    if (masterColumnGroup) {
      var groupId = masterColumnGroup.getGroupId();
      otherColumnGroup = this.columnModel.getOriginalColumnGroup(groupId);
    }
    if (masterColumnGroup && !otherColumnGroup) {
      return;
    }
    this.logger.log('onColumnEvent-> processing ' + groupOpenedEvent + ' expanded = ' + masterColumnGroup.isExpanded());
    this.columnModel.setColumnGroupOpened(otherColumnGroup, masterColumnGroup.isExpanded(), "alignedGridChanged");
  };
  AlignedGridsService.prototype.processColumnEvent = function (colEvent) {
    var _this = this;
    // the column in the event is from the master grid. need to
    // look up the equivalent from this (other) grid
    var masterColumn = colEvent.column;
    var otherColumn = null;
    if (masterColumn) {
      otherColumn = this.columnModel.getPrimaryColumn(masterColumn.getColId());
    }
    // if event was with respect to a master column, that is not present in this
    // grid, then we ignore the event
    if (masterColumn && !otherColumn) {
      return;
    }
    // in time, all the methods below should use the column ids, it's a more generic way
    // of handling columns, and also allows for single or multi column events
    var masterColumns = this.getMasterColumns(colEvent);
    switch (colEvent.type) {
      case Events.EVENT_COLUMN_MOVED:
        // when the user moves columns via setColumnState, we can't depend on moving specific columns
        // to an index, as there maybe be many indexes columns moved to (as wasn't result of a mouse drag).
        // so only way to be sure is match the order of all columns using Column State.
        {
          var movedEvent = colEvent;
          var srcColState = colEvent.columnApi.getColumnState();
          var destColState = srcColState.map(function (s) {
            return {
              colId: s.colId
            };
          });
          this.columnModel.applyColumnState({
            state: destColState,
            applyOrder: true
          }, "alignedGridChanged");
          this.logger.log("onColumnEvent-> processing " + colEvent.type + " toIndex = " + movedEvent.toIndex);
        }
        break;
      case Events.EVENT_COLUMN_VISIBLE:
        // when the user changes visibility via setColumnState, we can't depend on visibility flag in event
        // as there maybe be mix of true/false (as wasn't result of a mouse click to set visiblity).
        // so only way to be sure is match the visibility of all columns using Column State.
        {
          var visibleEvent = colEvent;
          var srcColState = colEvent.columnApi.getColumnState();
          var destColState = srcColState.map(function (s) {
            return {
              colId: s.colId,
              hide: s.hide
            };
          });
          this.columnModel.applyColumnState({
            state: destColState
          }, "alignedGridChanged");
          this.logger.log("onColumnEvent-> processing " + colEvent.type + " visible = " + visibleEvent.visible);
        }
        break;
      case Events.EVENT_COLUMN_PINNED:
        {
          var pinnedEvent = colEvent;
          var srcColState = colEvent.columnApi.getColumnState();
          var destColState = srcColState.map(function (s) {
            return {
              colId: s.colId,
              pinned: s.pinned
            };
          });
          this.columnModel.applyColumnState({
            state: destColState
          }, "alignedGridChanged");
          this.logger.log("onColumnEvent-> processing " + colEvent.type + " pinned = " + pinnedEvent.pinned);
        }
        break;
      case Events.EVENT_COLUMN_RESIZED:
        var resizedEvent_1 = colEvent;
        masterColumns.forEach(function (column) {
          _this.logger.log("onColumnEvent-> processing " + colEvent.type + " actualWidth = " + column.getActualWidth());
          var columnWidths = [{
            key: column.getColId(),
            newWidth: column.getActualWidth()
          }];
          _this.columnModel.setColumnWidths(columnWidths, false, resizedEvent_1.finished, "alignedGridChanged");
        });
        break;
    }
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
    var alignedGrids = this.gridOptionsWrapper.getAlignedGrids();
    if (alignedGrids) {
      alignedGrids.forEach(function (grid) {
        if (grid.api) {
          grid.api.setAlwaysShowVerticalScroll(isVerticalScrollShowing);
        }
      });
    }
  };
  __decorate$1K([Autowired('columnModel')], AlignedGridsService.prototype, "columnModel", void 0);
  __decorate$1K([Autowired('ctrlsService')], AlignedGridsService.prototype, "ctrlsService", void 0);
  __decorate$1K([__param$7(0, Qualifier('loggerFactory'))], AlignedGridsService.prototype, "setBeans", null);
  __decorate$1K([PostConstruct], AlignedGridsService.prototype, "init", null);
  AlignedGridsService = __decorate$1K([Bean('alignedGridsService')], AlignedGridsService);
  return AlignedGridsService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1Y = undefined && undefined.__extends || function () {
  var _extendStatics125 = function extendStatics(d, b) {
    _extendStatics125 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics125(d, b);
  };
  return function (d, b) {
    _extendStatics125(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1L = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgComponentUtils = /** @class */function (_super) {
  __extends$1Y(AgComponentUtils, _super);
  function AgComponentUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AgComponentUtils.prototype.adaptFunction = function (propertyName, jsCompFunc) {
    var metadata = this.componentMetadataProvider.retrieve(propertyName);
    if (metadata && metadata.functionAdapter) {
      return metadata.functionAdapter(jsCompFunc);
    }
    return null;
  };
  AgComponentUtils.prototype.adaptCellRendererFunction = function (callback) {
    var Adapter = /** @class */function () {
      function Adapter() {}
      Adapter.prototype.refresh = function (params) {
        return false;
      };
      Adapter.prototype.getGui = function () {
        var callbackResult = callback(this.params);
        var type = typeof callbackResult;
        if (type === 'string' || type === 'number' || type === 'boolean') {
          return loadTemplate('<span>' + callbackResult + '</span>');
        }
        if (callbackResult == null) {
          return loadTemplate('<span></span>');
        }
        return callbackResult;
      };
      Adapter.prototype.init = function (params) {
        this.params = params;
      };
      return Adapter;
    }();
    return Adapter;
  };
  AgComponentUtils.prototype.doesImplementIComponent = function (candidate) {
    if (!candidate) {
      return false;
    }
    return candidate.prototype && 'getGui' in candidate.prototype;
  };
  __decorate$1L([Autowired("componentMetadataProvider")], AgComponentUtils.prototype, "componentMetadataProvider", void 0);
  AgComponentUtils = __decorate$1L([Bean("agComponentUtils")], AgComponentUtils);
  return AgComponentUtils;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1Z = undefined && undefined.__extends || function () {
  var _extendStatics126 = function extendStatics(d, b) {
    _extendStatics126 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics126(d, b);
  };
  return function (d, b) {
    _extendStatics126(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1M = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ComponentMetadataProvider = /** @class */function (_super) {
  __extends$1Z(ComponentMetadataProvider, _super);
  function ComponentMetadataProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ComponentMetadataProvider.prototype.postConstruct = function () {
    this.componentMetaData = {
      dateComponent: {
        mandatoryMethodList: ['getDate', 'setDate'],
        optionalMethodList: ['afterGuiAttached', 'setInputPlaceholder', 'setInputAriaLabel']
      },
      detailCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      headerComponent: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh']
      },
      headerGroupComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      loadingCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      loadingOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      noRowsOverlayComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      floatingFilterComponent: {
        mandatoryMethodList: ['onParentModelChanged'],
        optionalMethodList: ['afterGuiAttached']
      },
      floatingFilterWrapperComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      },
      cellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      cellEditor: {
        mandatoryMethodList: ['getValue'],
        optionalMethodList: ['isPopup', 'isCancelBeforeStart', 'isCancelAfterEnd', 'getPopupPosition', 'focusIn', 'focusOut', 'afterGuiAttached']
      },
      innerRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      fullWidthCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      pinnedRowCellRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      groupRowRenderer: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached'],
        functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
      },
      filter: {
        mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
        optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
      },
      filterComponent: {
        mandatoryMethodList: ['isFilterActive', 'doesFilterPass', 'getModel', 'setModel'],
        optionalMethodList: ['afterGuiAttached', 'onNewRowsLoaded', 'getModelAsString', 'onFloatingFilterChanged']
      },
      statusPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ['afterGuiAttached']
      },
      toolPanel: {
        mandatoryMethodList: [],
        optionalMethodList: ['refresh', 'afterGuiAttached']
      },
      tooltipComponent: {
        mandatoryMethodList: [],
        optionalMethodList: []
      }
    };
  };
  ComponentMetadataProvider.prototype.retrieve = function (name) {
    return this.componentMetaData[name];
  };
  __decorate$1M([Autowired("agComponentUtils")], ComponentMetadataProvider.prototype, "agComponentUtils", void 0);
  __decorate$1M([PostConstruct], ComponentMetadataProvider.prototype, "postConstruct", null);
  ComponentMetadataProvider = __decorate$1M([Bean("componentMetadataProvider")], ComponentMetadataProvider);
  return ComponentMetadataProvider;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1_ = undefined && undefined.__extends || function () {
  var _extendStatics127 = function extendStatics(d, b) {
    _extendStatics127 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics127(d, b);
  };
  return function (d, b) {
    _extendStatics127(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1N = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MAT_GRID_SIZE = 8;
var BASE_GRID_SIZE = 4;
var BALHAM_GRID_SIZE = 4;
var ALPINE_GRID_SIZE = 6;
var HARD_CODED_SIZES = {
  // this item is required for custom themes
  'ag-theme-custom': {
    headerHeight: 25,
    headerCellMinWidth: 24,
    listItemHeight: BASE_GRID_SIZE * 5,
    rowHeight: 25,
    chartMenuPanelWidth: 220
  },
  'ag-theme-material': {
    headerHeight: MAT_GRID_SIZE * 7,
    headerCellMinWidth: 48,
    listItemHeight: MAT_GRID_SIZE * 4,
    rowHeight: MAT_GRID_SIZE * 6,
    chartMenuPanelWidth: 240
  },
  'ag-theme-balham': {
    headerHeight: BALHAM_GRID_SIZE * 8,
    headerCellMinWidth: 24,
    listItemHeight: BALHAM_GRID_SIZE * 6,
    rowHeight: BALHAM_GRID_SIZE * 7,
    chartMenuPanelWidth: 220
  },
  'ag-theme-alpine': {
    headerHeight: ALPINE_GRID_SIZE * 8,
    headerCellMinWidth: 36,
    listItemHeight: ALPINE_GRID_SIZE * 4,
    rowHeight: ALPINE_GRID_SIZE * 7,
    chartMenuPanelWidth: 240
  }
};
/**
 * this object contains a list of Sass variables and an array
 * of CSS styles required to get the correct value.
 * eg. $virtual-item-height requires a structure, so we can get its height.
 * <div class="ag-theme-balham">
 *     <div class="ag-virtual-list-container">
 *         <div class="ag-virtual-list-item"></div>
 *     </div>
 * </div>
 */
var SASS_PROPERTY_BUILDER = {
  headerHeight: ['ag-header-row'],
  headerCellMinWidth: ['ag-header-cell'],
  listItemHeight: ['ag-virtual-list-item'],
  rowHeight: ['ag-row'],
  chartMenuPanelWidth: ['ag-chart-docked-container']
};
var CALCULATED_SIZES = {};
var Environment = /** @class */function (_super) {
  __extends$1_(Environment, _super);
  function Environment() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Environment.prototype.getSassVariable = function (theme, key) {
    var useTheme = 'ag-theme-' + (theme.match('material') ? 'material' : theme.match('balham') ? 'balham' : theme.match('alpine') ? 'alpine' : 'custom');
    var defaultValue = HARD_CODED_SIZES[useTheme][key];
    var calculatedValue = 0;
    if (!CALCULATED_SIZES[theme]) {
      CALCULATED_SIZES[theme] = {};
    }
    var size = CALCULATED_SIZES[theme][key];
    if (size != null) {
      return size;
    }
    if (SASS_PROPERTY_BUILDER[key]) {
      var classList = SASS_PROPERTY_BUILDER[key];
      var div = document.createElement('div');
      addCssClass(div, theme);
      div.style.position = 'absolute';
      var el = classList.reduce(function (prevEl, currentClass) {
        var currentDiv = document.createElement('div');
        currentDiv.style.position = 'static';
        addCssClass(currentDiv, currentClass);
        prevEl.appendChild(currentDiv);
        return currentDiv;
      }, div);
      if (document.body) {
        document.body.appendChild(div);
        var sizeName = key.toLowerCase().indexOf('height') !== -1 ? 'height' : 'width';
        calculatedValue = parseInt(window.getComputedStyle(el)[sizeName], 10);
        document.body.removeChild(div);
      }
    }
    CALCULATED_SIZES[theme][key] = calculatedValue || defaultValue;
    return CALCULATED_SIZES[theme][key];
  };
  Environment.prototype.isThemeDark = function () {
    var theme = this.getTheme().theme;
    return !!theme && theme.indexOf('dark') >= 0;
  };
  Environment.prototype.chartMenuPanelWidth = function () {
    var theme = this.getTheme().themeFamily;
    return this.getSassVariable(theme, 'chartMenuPanelWidth');
  };
  Environment.prototype.getTheme = function () {
    var reg = /\bag-(material|(?:theme-([\w\-]*)))\b/;
    var el = this.eGridDiv;
    var themeMatch = null;
    while (el) {
      themeMatch = reg.exec(el.className);
      if (!themeMatch) {
        el = el.parentElement || undefined;
      } else {
        break;
      }
    }
    if (!themeMatch) {
      return {};
    }
    var theme = themeMatch[0];
    var usingOldTheme = themeMatch[2] === undefined;
    if (usingOldTheme) {
      var newTheme_1 = theme.replace('ag-', 'ag-theme-');
      doOnce(function () {
        return console.warn("AG Grid: As of v19 old theme are no longer provided. Please replace " + theme + " with " + newTheme_1 + ".");
      }, 'using-old-theme');
    }
    return {
      theme: theme,
      el: el,
      themeFamily: theme.replace(/-dark$/, '')
    };
  };
  __decorate$1N([Autowired('eGridDiv')], Environment.prototype, "eGridDiv", void 0);
  Environment = __decorate$1N([Bean('environment')], Environment);
  return Environment;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$1$ = undefined && undefined.__extends || function () {
  var _extendStatics128 = function extendStatics(d, b) {
    _extendStatics128 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics128(d, b);
  };
  return function (d, b) {
    _extendStatics128(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1O = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AnimationFrameService = /** @class */function (_super) {
  __extends$1$(AnimationFrameService, _super);
  function AnimationFrameService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // p1 and p2 are create tasks are to do with row and cell creation.
    // for them we want to execute according to row order, so we use
    // TaskItem so we know what index the item is for.
    _this.createTasksP1 = {
      list: [],
      sorted: false
    }; // eg drawing back-ground of rows
    _this.createTasksP2 = {
      list: [],
      sorted: false
    }; // eg cell renderers, adding hover functionality
    // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
    // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
    // important.
    _this.destroyTasks = [];
    _this.ticking = false;
    // we need to know direction of scroll, to build up rows in the direction of
    // the scroll. eg if user scrolls down, we extend the rows by building down.
    _this.scrollGoingDown = true;
    _this.lastScrollTop = 0;
    _this.taskCount = 0;
    _this.cancelledTasks = new Set();
    return _this;
  }
  AnimationFrameService.prototype.setScrollTop = function (scrollTop) {
    this.scrollGoingDown = scrollTop > this.lastScrollTop;
    this.lastScrollTop = scrollTop;
  };
  AnimationFrameService.prototype.init = function () {
    this.useAnimationFrame = !this.gridOptionsWrapper.isSuppressAnimationFrame();
  };
  AnimationFrameService.prototype.isOn = function () {
    return this.useAnimationFrame;
  };
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  AnimationFrameService.prototype.verifyAnimationFrameOn = function (methodName) {
    if (this.useAnimationFrame === false) {
      console.warn("AG Grid: AnimationFrameService." + methodName + " called but animation frames are off");
    }
  };
  AnimationFrameService.prototype.createTask = function (task, index, list) {
    this.verifyAnimationFrameOn(list);
    var taskItem = {
      task: task,
      index: index,
      createOrder: ++this.taskCount
    };
    this.addTaskToList(this[list], taskItem);
    this.schedule();
  };
  AnimationFrameService.prototype.cancelTask = function (task) {
    this.cancelledTasks.add(task);
  };
  AnimationFrameService.prototype.addTaskToList = function (taskList, task) {
    taskList.list.push(task);
    taskList.sorted = false;
  };
  AnimationFrameService.prototype.sortTaskList = function (taskList) {
    if (taskList.sorted) {
      return;
    }
    var sortDirection = this.scrollGoingDown ? 1 : -1;
    // sort first by row index (taking into account scroll direction), then by
    // order of task creation (always ascending, so cells will render left-to-right)
    taskList.list.sort(function (a, b) {
      return a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder;
    });
    taskList.sorted = true;
  };
  AnimationFrameService.prototype.addDestroyTask = function (task) {
    this.verifyAnimationFrameOn('createTasksP3');
    this.destroyTasks.push(task);
    this.schedule();
  };
  AnimationFrameService.prototype.executeFrame = function (millis) {
    this.verifyAnimationFrameOn('executeFrame');
    var p1TaskList = this.createTasksP1;
    var p1Tasks = p1TaskList.list;
    var p2TaskList = this.createTasksP2;
    var p2Tasks = p2TaskList.list;
    var destroyTasks = this.destroyTasks;
    var frameStart = new Date().getTime();
    var duration = new Date().getTime() - frameStart;
    // 16ms is 60 fps
    var noMaxMillis = millis <= 0;
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    while (noMaxMillis || duration < millis) {
      var gridBodyDidSomething = gridBodyCon.getScrollFeature().executeAnimationFrameScroll();
      if (!gridBodyDidSomething) {
        var task = void 0;
        if (p1Tasks.length) {
          this.sortTaskList(p1TaskList);
          task = p1Tasks.pop().task;
        } else if (p2Tasks.length) {
          this.sortTaskList(p2TaskList);
          task = p2Tasks.pop().task;
        } else if (destroyTasks.length) {
          task = destroyTasks.pop();
        } else {
          this.cancelledTasks.clear();
          break;
        }
        if (!this.cancelledTasks.has(task)) {
          task();
        }
      }
      duration = new Date().getTime() - frameStart;
    }
    if (p1Tasks.length || p2Tasks.length || destroyTasks.length) {
      this.requestFrame();
    } else {
      this.stopTicking();
    }
  };
  AnimationFrameService.prototype.stopTicking = function () {
    this.ticking = false;
  };
  AnimationFrameService.prototype.flushAllFrames = function () {
    if (!this.useAnimationFrame) {
      return;
    }
    this.executeFrame(-1);
  };
  AnimationFrameService.prototype.schedule = function () {
    if (!this.useAnimationFrame) {
      return;
    }
    if (!this.ticking) {
      this.ticking = true;
      this.requestFrame();
    }
  };
  AnimationFrameService.prototype.requestFrame = function () {
    // check for the existence of requestAnimationFrame, and if
    // it's missing, then we polyfill it with setTimeout()
    var callback = this.executeFrame.bind(this, 60);
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(callback);
    } else if (window.webkitRequestAnimationFrame) {
      window.webkitRequestAnimationFrame(callback);
    } else {
      window.setTimeout(callback, 0);
    }
  };
  AnimationFrameService.prototype.isQueueEmpty = function () {
    return !this.ticking;
  };
  // a debounce utility used for parts of the app involved with rendering.
  // the advantage over normal debounce is the client can call flushAllFrames()
  // to make sure all rendering is complete. we don't wait any milliseconds,
  // as this is intended to batch calls in one VM turn.
  AnimationFrameService.prototype.debounce = function (func) {
    var _this = this;
    var pending = false;
    return function () {
      if (!_this.isOn()) {
        _this.getFrameworkOverrides().setTimeout(func, 0);
        return;
      }
      if (pending) {
        return;
      }
      pending = true;
      _this.addDestroyTask(function () {
        pending = false;
        func();
      });
    };
  };
  __decorate$1O([Autowired('ctrlsService')], AnimationFrameService.prototype, "ctrlsService", void 0);
  __decorate$1O([PostConstruct], AnimationFrameService.prototype, "init", null);
  AnimationFrameService = __decorate$1O([Bean('animationFrameService')], AnimationFrameService);
  return AnimationFrameService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$20 = undefined && undefined.__extends || function () {
  var _extendStatics129 = function extendStatics(d, b) {
    _extendStatics129 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics129(d, b);
  };
  return function (d, b) {
    _extendStatics129(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$c = undefined && undefined.__assign || function () {
  __assign$c = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$c.apply(this, arguments);
};
var __decorate$1P = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NavigationService = /** @class */function (_super) {
  __extends$20(NavigationService, _super);
  function NavigationService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.timeLastPageEventProcessed = 0;
    return _this;
  }
  NavigationService.prototype.postConstruct = function () {
    var _this = this;
    this.ctrlsService.whenReady(function (p) {
      _this.gridBodyCon = p.gridBodyCtrl;
    });
  };
  NavigationService.prototype.handlePageScrollingKey = function (event) {
    var key = event.which || event.keyCode;
    var alt = event.altKey;
    var ctrl = event.ctrlKey || event.metaKey;
    var currentCell = this.mouseEventService.getCellPositionForEvent(event);
    if (!currentCell) {
      return false;
    }
    var processed = false;
    switch (key) {
      case KeyCode.PAGE_HOME:
      case KeyCode.PAGE_END:
        // handle home and end when ctrl & alt are NOT pressed
        if (!ctrl && !alt) {
          this.onHomeOrEndKey(key);
          processed = true;
        }
        break;
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
        // handle left and right when ctrl is pressed only
        if (ctrl && !alt) {
          this.onCtrlLeftOrRight(key, currentCell);
          processed = true;
        }
        break;
      case KeyCode.UP:
      case KeyCode.DOWN:
        // handle up and down when ctrl is pressed only
        if (ctrl && !alt) {
          this.onCtrlUpOrDown(key, currentCell);
          processed = true;
        }
        break;
      case KeyCode.PAGE_DOWN:
        // handle page up and page down when ctrl & alt are NOT pressed
        if (!ctrl && !alt) {
          this.onPageDown(currentCell);
          processed = true;
        }
        break;
      case KeyCode.PAGE_UP:
        // handle page up and page down when ctrl & alt are NOT pressed
        if (!ctrl && !alt) {
          this.onPageUp(currentCell);
          processed = true;
        }
        break;
    }
    if (processed) {
      event.preventDefault();
    }
    return processed;
  };
  // the page up/down keys caused a problem, in that if the user
  // held the page up/down key down, lots of events got generated,
  // which clogged up the event queue (as they take time to process)
  // which in turn froze the grid. Logic below makes sure we wait 100ms
  // between processing the page up/down events, so when user has finger
  // held down on key, we ignore page up/down events until 100ms has passed,
  // which effectively empties the queue of page up/down events.
  NavigationService.prototype.isTimeSinceLastPageEventToRecent = function () {
    var now = new Date().getTime();
    var diff = now - this.timeLastPageEventProcessed;
    return diff < 100;
  };
  NavigationService.prototype.setTimeLastPageEventProcessed = function () {
    this.timeLastPageEventProcessed = new Date().getTime();
  };
  NavigationService.prototype.navigateTo = function (navigateParams) {
    var scrollIndex = navigateParams.scrollIndex,
      scrollType = navigateParams.scrollType,
      scrollColumn = navigateParams.scrollColumn,
      focusIndex = navigateParams.focusIndex,
      focusColumn = navigateParams.focusColumn;
    if (exists(scrollColumn) && !scrollColumn.isPinned()) {
      this.gridBodyCon.getScrollFeature().ensureColumnVisible(scrollColumn);
    }
    if (exists(scrollIndex)) {
      this.gridBodyCon.getScrollFeature().ensureIndexVisible(scrollIndex, scrollType);
    }
    // make sure the cell is rendered, needed if we are to focus
    this.animationFrameService.flushAllFrames();
    // if we don't do this, the range will be left on the last cell, which will leave the last focused cell
    // highlighted.
    this.focusService.setFocusedCell(focusIndex, focusColumn, null, true);
    if (this.rangeService) {
      var cellPosition = {
        rowIndex: focusIndex,
        rowPinned: null,
        column: focusColumn
      };
      this.rangeService.setRangeToCell(cellPosition);
    }
  };
  NavigationService.prototype.onPageDown = function (gridCell) {
    if (this.isTimeSinceLastPageEventToRecent()) {
      return;
    }
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
    var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
    var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
    if (this.ctrlsService.getCenterRowContainerCtrl().isHorizontalScrollShowing()) {
      pixelsInOnePage -= scrollbarWidth;
    }
    var pagingPixelOffset = this.paginationProxy.getPixelOffset();
    var currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
    var currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
    var scrollIndex = currentPageBottomRow;
    var currentCellPixel = this.paginationProxy.getRow(gridCell.rowIndex).rowTop;
    var nextCellPixel = currentCellPixel + pixelsInOnePage - pagingPixelOffset;
    var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
    var pageLastRow = this.paginationProxy.getPageLastRow();
    if (focusIndex > pageLastRow) {
      focusIndex = pageLastRow;
    }
    if (scrollIndex > pageLastRow) {
      scrollIndex = pageLastRow;
    }
    this.navigateTo({
      scrollIndex: scrollIndex,
      scrollType: 'top',
      scrollColumn: null,
      focusIndex: focusIndex,
      focusColumn: gridCell.column
    });
    this.setTimeLastPageEventProcessed();
  };
  NavigationService.prototype.onPageUp = function (gridCell) {
    if (this.isTimeSinceLastPageEventToRecent()) {
      return;
    }
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
    var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
    var pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
    if (this.ctrlsService.getCenterRowContainerCtrl().isHorizontalScrollShowing()) {
      pixelsInOnePage -= scrollbarWidth;
    }
    var pagingPixelOffset = this.paginationProxy.getPixelOffset();
    var currentPageTopPixel = scrollPosition.top;
    var currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
    var scrollIndex = currentPageTopRow;
    var currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
    var nextCellPixel = currentRowNode.rowTop + currentRowNode.rowHeight - pixelsInOnePage - pagingPixelOffset;
    var focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
    var firstRow = this.paginationProxy.getPageFirstRow();
    if (focusIndex < firstRow) {
      focusIndex = firstRow;
    }
    if (scrollIndex < firstRow) {
      scrollIndex = firstRow;
    }
    this.navigateTo({
      scrollIndex: scrollIndex,
      scrollType: 'bottom',
      scrollColumn: null,
      focusIndex: focusIndex,
      focusColumn: gridCell.column
    });
    this.setTimeLastPageEventProcessed();
  };
  NavigationService.prototype.getIndexToFocus = function (indexToScrollTo, isDown) {
    var indexToFocus = indexToScrollTo;
    // for SSRM, when user hits ctrl+down, we can end up trying to focus the loading row.
    // instead we focus the last row with data instead.
    if (isDown) {
      var node = this.paginationProxy.getRow(indexToScrollTo);
      if (node && node.stub) {
        indexToFocus -= 1;
      }
    }
    return indexToFocus;
  };
  // ctrl + up/down will bring focus to same column, first/last row. no horizontal scrolling.
  NavigationService.prototype.onCtrlUpOrDown = function (key, gridCell) {
    var upKey = key === KeyCode.UP;
    var rowIndexToScrollTo = upKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
    this.navigateTo({
      scrollIndex: rowIndexToScrollTo,
      scrollType: null,
      scrollColumn: gridCell.column,
      focusIndex: this.getIndexToFocus(rowIndexToScrollTo, !upKey),
      focusColumn: gridCell.column
    });
  };
  // ctrl + left/right will bring focus to same row, first/last cell. no vertical scrolling.
  NavigationService.prototype.onCtrlLeftOrRight = function (key, gridCell) {
    var leftKey = key === KeyCode.LEFT;
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    var columnToSelect = leftKey !== isRtl ? allColumns[0] : last(allColumns);
    this.navigateTo({
      scrollIndex: gridCell.rowIndex,
      scrollType: null,
      scrollColumn: columnToSelect,
      focusIndex: gridCell.rowIndex,
      focusColumn: columnToSelect
    });
  };
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  NavigationService.prototype.onHomeOrEndKey = function (key) {
    var homeKey = key === KeyCode.PAGE_HOME;
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var columnToSelect = homeKey ? allColumns[0] : last(allColumns);
    var scrollIndex = homeKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
    this.navigateTo({
      scrollIndex: scrollIndex,
      scrollType: null,
      scrollColumn: columnToSelect,
      focusIndex: this.getIndexToFocus(scrollIndex, !homeKey),
      focusColumn: columnToSelect
    });
  };
  // result of keyboard event
  NavigationService.prototype.onTabKeyDown = function (previous, keyboardEvent) {
    var backwards = keyboardEvent.shiftKey;
    var movedToNextCell = this.tabToNextCellCommon(previous, backwards);
    if (movedToNextCell) {
      // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
      // to the normal tabbing so user can exit the grid.
      keyboardEvent.preventDefault();
      return;
    }
    // if we didn't move to next cell, then need to tab out of the cells, ie to the header (if going
    // backwards)
    if (backwards) {
      var _a = previous.getRowPosition(),
        rowIndex = _a.rowIndex,
        rowPinned = _a.rowPinned;
      var firstRow = rowPinned ? rowIndex === 0 : rowIndex === this.paginationProxy.getPageFirstRow();
      if (firstRow) {
        keyboardEvent.preventDefault();
        var headerRowIndex = this.headerNavigationService.getHeaderRowCount() - 1;
        var column = last(this.columnModel.getAllDisplayedColumns());
        this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: headerRowIndex,
            column: column
          },
          event: keyboardEvent
        });
      }
    } else {
      // if the case it's a popup editor, the focus is on the editor and not the previous cell.
      // in order for the tab navigation to work, we need to focus the browser back onto the
      // previous cell.
      if (previous instanceof CellCtrl) {
        previous.focusCell(true);
      }
      if (this.focusService.focusNextGridCoreContainer(false)) {
        keyboardEvent.preventDefault();
      }
    }
  };
  // comes from API
  NavigationService.prototype.tabToNextCell = function (backwards) {
    var focusedCell = this.focusService.getFocusedCell();
    // if no focus, then cannot navigate
    if (!focusedCell) {
      return false;
    }
    var cellOrRow = this.getCellByPosition(focusedCell);
    // if cell is not rendered, means user has scrolled away from the cell
    // or that the focusedCell is a Full Width Row
    if (!cellOrRow) {
      cellOrRow = this.rowRenderer.getRowByPosition(focusedCell);
      if (!cellOrRow || !cellOrRow.isFullWidth()) {
        return false;
      }
    }
    return this.tabToNextCellCommon(cellOrRow, backwards);
  };
  NavigationService.prototype.tabToNextCellCommon = function (previous, backwards) {
    var editing = previous.isEditing();
    // if cell is not editing, there is still chance row is editing if it's Full Row Editing
    if (!editing && previous instanceof CellCtrl) {
      var cell = previous;
      var row = cell.getRowCtrl();
      if (row) {
        editing = row.isEditing();
      }
    }
    var res;
    if (editing) {
      // if we are editing, we know it's not a Full Width Row (RowComp)
      if (this.gridOptionsWrapper.isFullRowEdit()) {
        res = this.moveToNextEditingRow(previous, backwards);
      } else {
        res = this.moveToNextEditingCell(previous, backwards);
      }
    } else {
      res = this.moveToNextCellNotEditing(previous, backwards);
    }
    // if a cell wasn't found, it's possible that focus was moved to the header
    return res || !!this.focusService.getFocusedHeader();
  };
  NavigationService.prototype.moveToNextEditingCell = function (previousCell, backwards) {
    var previousPos = previousCell.getCellPosition();
    // need to do this before getting next cell to edit, in case the next cell
    // has editable function (eg colDef.editable=func() ) and it depends on the
    // result of this cell, so need to save updates from the first edit, in case
    // the value is referenced in the function.
    previousCell.stopEditing();
    // find the next cell to start editing
    var nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
    if (nextCell == null) {
      return false;
    }
    // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
    // to the normal tabbing so user can exit the grid.
    nextCell.startEditing(null, null, true);
    nextCell.focusCell(false);
    return true;
  };
  NavigationService.prototype.moveToNextEditingRow = function (previousCell, backwards) {
    var previousPos = previousCell.getCellPosition();
    // find the next cell to start editing
    var nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
    if (nextCell == null) {
      return false;
    }
    var nextPos = nextCell.getCellPosition();
    var previousEditable = this.isCellEditable(previousPos);
    var nextEditable = this.isCellEditable(nextPos);
    var rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;
    if (previousEditable) {
      previousCell.setFocusOutOnEditor();
    }
    if (!rowsMatch) {
      var pRow = previousCell.getRowCtrl();
      pRow.stopEditing();
      var nRow = nextCell.getRowCtrl();
      nRow.startRowEditing();
    }
    if (nextEditable) {
      nextCell.setFocusInOnEditor();
      nextCell.focusCell();
    } else {
      nextCell.focusCell(true);
    }
    return true;
  };
  NavigationService.prototype.moveToNextCellNotEditing = function (previousCell, backwards) {
    var displayedColumns = this.columnModel.getAllDisplayedColumns();
    var cellPos;
    if (previousCell instanceof RowCtrl) {
      cellPos = __assign$c(__assign$c({}, previousCell.getRowPosition()), {
        column: backwards ? displayedColumns[0] : last(displayedColumns)
      });
    } else {
      cellPos = previousCell.getCellPosition();
    }
    // find the next cell to start editing
    var nextCell = this.findNextCellToFocusOn(cellPos, backwards, false);
    // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
    // to the normal tabbing so user can exit the grid.
    if (nextCell instanceof CellCtrl) {
      nextCell.focusCell(true);
    } else if (nextCell) {
      return this.tryToFocusFullWidthRow(nextCell.getRowPosition(), backwards);
    }
    return exists(nextCell);
  };
  // called by the cell, when tab is pressed while editing.
  // @return: RenderedCell when navigation successful, otherwise null
  NavigationService.prototype.findNextCellToFocusOn = function (previousPosition, backwards, startEditing) {
    var nextPosition = previousPosition;
    while (true) {
      if (!backwards) {
        nextPosition = this.getLastCellOfColSpan(nextPosition);
      }
      nextPosition = this.cellNavigationService.getNextTabbedCell(nextPosition, backwards);
      // allow user to override what cell to go to next
      var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
      if (exists(userFunc)) {
        var params = {
          backwards: backwards,
          editing: startEditing,
          previousCellPosition: previousPosition,
          nextCellPosition: nextPosition ? nextPosition : null,
          api: this.gridOptionsWrapper.getApi(),
          columnApi: this.gridOptionsWrapper.getColumnApi()
        };
        var userCell = userFunc(params);
        if (exists(userCell)) {
          if (userCell.floating) {
            doOnce(function () {
              console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");
            }, 'no floating in userCell');
            userCell.rowPinned = userCell.floating;
          }
          nextPosition = {
            rowIndex: userCell.rowIndex,
            column: userCell.column,
            rowPinned: userCell.rowPinned
          };
        } else {
          nextPosition = null;
        }
      }
      // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
      // so bottom right cell going forwards, or top left going backwards
      if (!nextPosition) {
        return null;
      }
      if (nextPosition.rowIndex < 0) {
        var headerLen = this.headerNavigationService.getHeaderRowCount();
        this.focusService.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: headerLen + nextPosition.rowIndex,
            column: nextPosition.column
          }
        });
        return null;
      }
      // if editing, but cell not editable, skip cell. we do this before we do all of
      // the 'ensure index visible' and 'flush all frames', otherwise if we are skipping
      // a bunch of cells (eg 10 rows) then all the work on ensuring cell visible is useless
      // (except for the last one) which causes grid to stall for a while.
      // note - for full row edit, we do focus non-editable cells, as the row stays in edit mode.
      var fullRowEdit = this.gridOptionsWrapper.isFullRowEdit();
      if (startEditing && !fullRowEdit) {
        var cellIsEditable = this.isCellEditable(nextPosition);
        if (!cellIsEditable) {
          continue;
        }
      }
      this.ensureCellVisible(nextPosition);
      // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
      // or row that is not currently in view, hence the renderedCell would not exist
      var nextCell = this.getCellByPosition(nextPosition);
      // if next cell is fullWidth row, then no rendered cell,
      // as fullWidth rows have no cells, so we skip it
      if (!nextCell) {
        var row = this.rowRenderer.getRowByPosition(nextPosition);
        if (!row || !row.isFullWidth()) {
          continue;
        } else {
          return row;
        }
      }
      if (nextCell.isSuppressNavigable()) {
        continue;
      }
      // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
      // consistent, we set into range here also.
      if (this.rangeService) {
        this.rangeService.setRangeToCell(nextPosition);
      }
      // we successfully tabbed onto a grid cell, so return true
      return nextCell;
    }
  };
  NavigationService.prototype.isCellEditable = function (cell) {
    var rowNode = this.lookupRowNodeForCell(cell);
    if (rowNode) {
      return cell.column.isCellEditable(rowNode);
    }
    return false;
  };
  NavigationService.prototype.getCellByPosition = function (cellPosition) {
    var rowCtrl = this.rowRenderer.getRowByPosition(cellPosition);
    if (!rowCtrl) {
      return null;
    }
    return rowCtrl.getCellCtrl(cellPosition.column);
  };
  NavigationService.prototype.lookupRowNodeForCell = function (cell) {
    if (cell.rowPinned === Constants.PINNED_TOP) {
      return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
    }
    if (cell.rowPinned === Constants.PINNED_BOTTOM) {
      return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
    }
    return this.paginationProxy.getRow(cell.rowIndex);
  };
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  NavigationService.prototype.navigateToNextCell = function (event, key, currentCell, allowUserOverride) {
    // we keep searching for a next cell until we find one. this is how the group rows get skipped
    var nextCell = currentCell;
    var hitEdgeOfGrid = false;
    while (nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))) {
      // if the current cell is spanning across multiple columns, we need to move
      // our current position to be the last cell on the right before finding the
      // the next target.
      if (this.gridOptionsWrapper.isEnableRtl()) {
        if (key === KeyCode.LEFT) {
          nextCell = this.getLastCellOfColSpan(nextCell);
        }
      } else if (key === KeyCode.RIGHT) {
        nextCell = this.getLastCellOfColSpan(nextCell);
      }
      nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
      // eg if going down, and nextCell=undefined, means we are gone past the last row
      hitEdgeOfGrid = missing(nextCell);
    }
    if (hitEdgeOfGrid && event && event.keyCode === KeyCode.UP) {
      nextCell = {
        rowIndex: -1,
        rowPinned: null,
        column: currentCell.column
      };
    }
    // allow user to override what cell to go to next. when doing normal cell navigation (with keys)
    // we allow this, however if processing 'enter after edit' we don't allow override
    if (allowUserOverride) {
      var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
      if (exists(userFunc)) {
        var params = {
          key: key,
          previousCellPosition: currentCell,
          nextCellPosition: nextCell ? nextCell : null,
          event: event,
          api: this.gridOptionsWrapper.getApi(),
          columnApi: this.gridOptionsWrapper.getColumnApi()
        };
        var userCell = userFunc(params);
        if (exists(userCell)) {
          if (userCell.floating) {
            doOnce(function () {
              console.warn("AG Grid: tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?");
            }, 'no floating in userCell');
            userCell.rowPinned = userCell.floating;
          }
          nextCell = {
            rowPinned: userCell.rowPinned,
            rowIndex: userCell.rowIndex,
            column: userCell.column
          };
        } else {
          nextCell = null;
        }
      }
    }
    // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
    if (!nextCell) {
      return;
    }
    if (nextCell.rowIndex < 0) {
      var headerLen = this.headerNavigationService.getHeaderRowCount();
      this.focusService.focusHeaderPosition({
        headerPosition: {
          headerRowIndex: headerLen + nextCell.rowIndex,
          column: currentCell.column
        },
        event: event || undefined
      });
      return;
    }
    // in case we have col spanning we get the cellComp and use it to get the
    // position. This was we always focus the first cell inside the spanning.
    var normalisedPosition = this.getNormalisedPosition(nextCell);
    if (normalisedPosition) {
      this.focusPosition(normalisedPosition);
    } else {
      this.tryToFocusFullWidthRow(nextCell);
    }
  };
  NavigationService.prototype.getNormalisedPosition = function (cellPosition) {
    // ensureCellVisible first, to make sure cell at position is rendered.
    this.ensureCellVisible(cellPosition);
    var cellComp = this.getCellByPosition(cellPosition);
    // not guaranteed to have a cellComp when using the SSRM as blocks are loading.
    if (!cellComp) {
      return null;
    }
    cellPosition = cellComp.getCellPosition();
    // we call this again, as nextCell can be different to it's previous value due to Column Spanning
    // (ie if cursor moving from right to left, and cell is spanning columns, then nextCell was the
    // last column in the group, however now it's the first column in the group). if we didn't do
    // ensureCellVisible again, then we could only be showing the last portion (last column) of the
    // merged cells.
    this.ensureCellVisible(cellPosition);
    return cellPosition;
  };
  NavigationService.prototype.tryToFocusFullWidthRow = function (position, backwards) {
    if (backwards === void 0) {
      backwards = false;
    }
    var displayedColumns = this.columnModel.getAllDisplayedColumns();
    var rowComp = this.rowRenderer.getRowByPosition(position);
    if (!rowComp || !rowComp.isFullWidth()) {
      return false;
    }
    var cellPosition = {
      rowIndex: position.rowIndex,
      rowPinned: position.rowPinned,
      column: position.column || (backwards ? last(displayedColumns) : displayedColumns[0])
    };
    this.focusPosition(cellPosition);
    return true;
  };
  NavigationService.prototype.focusPosition = function (cellPosition) {
    this.focusService.setFocusedCell(cellPosition.rowIndex, cellPosition.column, cellPosition.rowPinned, true);
    if (this.rangeService) {
      this.rangeService.setRangeToCell(cellPosition);
    }
  };
  NavigationService.prototype.isValidNavigateCell = function (cell) {
    var rowNode = this.rowPositionUtils.getRowNode(cell);
    // we do not allow focusing on detail rows and full width rows
    return !!rowNode;
  };
  NavigationService.prototype.getLastCellOfColSpan = function (cell) {
    var cellCtrl = this.getCellByPosition(cell);
    if (!cellCtrl) {
      return cell;
    }
    var colSpanningList = cellCtrl.getColSpanningList();
    if (colSpanningList.length === 1) {
      return cell;
    }
    return {
      rowIndex: cell.rowIndex,
      column: last(colSpanningList),
      rowPinned: cell.rowPinned
    };
  };
  NavigationService.prototype.ensureCellVisible = function (gridCell) {
    // this scrolls the row into view
    if (missing(gridCell.rowPinned)) {
      this.gridBodyCon.getScrollFeature().ensureIndexVisible(gridCell.rowIndex);
    }
    if (!gridCell.column.isPinned()) {
      this.gridBodyCon.getScrollFeature().ensureColumnVisible(gridCell.column);
    }
    // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
    // floating cell, the scrolls get out of sync
    this.gridBodyCon.getScrollFeature().horizontallyScrollHeaderCenterAndFloatingCenter();
    // need to flush frames, to make sure the correct cells are rendered
    this.animationFrameService.flushAllFrames();
  };
  __decorate$1P([Autowired('mouseEventService')], NavigationService.prototype, "mouseEventService", void 0);
  __decorate$1P([Autowired('paginationProxy')], NavigationService.prototype, "paginationProxy", void 0);
  __decorate$1P([Autowired('focusService')], NavigationService.prototype, "focusService", void 0);
  __decorate$1P([Autowired('animationFrameService')], NavigationService.prototype, "animationFrameService", void 0);
  __decorate$1P([Optional('rangeService')], NavigationService.prototype, "rangeService", void 0);
  __decorate$1P([Autowired('columnModel')], NavigationService.prototype, "columnModel", void 0);
  __decorate$1P([Autowired('ctrlsService')], NavigationService.prototype, "ctrlsService", void 0);
  __decorate$1P([Autowired('rowRenderer')], NavigationService.prototype, "rowRenderer", void 0);
  __decorate$1P([Autowired('headerNavigationService')], NavigationService.prototype, "headerNavigationService", void 0);
  __decorate$1P([Autowired("rowPositionUtils")], NavigationService.prototype, "rowPositionUtils", void 0);
  __decorate$1P([Autowired("cellNavigationService")], NavigationService.prototype, "cellNavigationService", void 0);
  __decorate$1P([Autowired("pinnedRowModel")], NavigationService.prototype, "pinnedRowModel", void 0);
  __decorate$1P([PostConstruct], NavigationService.prototype, "postConstruct", null);
  NavigationService = __decorate$1P([Bean('navigationService')], NavigationService);
  return NavigationService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$21 = undefined && undefined.__extends || function () {
  var _extendStatics130 = function extendStatics(d, b) {
    _extendStatics130 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics130(d, b);
  };
  return function (d, b) {
    _extendStatics130(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1Q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$8 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
/**
 * This class solves the 'max height' problem, where the user might want to show more data than
 * the max div height actually allows.
 */
var RowContainerHeightService = /** @class */function (_super) {
  __extends$21(RowContainerHeightService, _super);
  function RowContainerHeightService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // the scrollY position
    _this.scrollY = 0;
    // how tall the body is
    _this.uiBodyHeight = 0;
    return _this;
  }
  RowContainerHeightService.prototype.agWire = function (loggerFactory) {
    this.logger = loggerFactory.create("RowContainerHeightService");
  };
  RowContainerHeightService.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
    this.maxDivHeight = getMaxDivHeight();
    this.logger.log('maxDivHeight = ' + this.maxDivHeight);
  };
  RowContainerHeightService.prototype.isStretching = function () {
    return this.stretching;
  };
  RowContainerHeightService.prototype.getDivStretchOffset = function () {
    return this.divStretchOffset;
  };
  RowContainerHeightService.prototype.updateOffset = function () {
    if (!this.stretching) {
      return;
    }
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var newScrollY = gridBodyCon.getScrollFeature().getVScrollPosition().top;
    var newBodyHeight = this.getUiBodyHeight();
    var atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
    if (atLeastOneChanged) {
      this.scrollY = newScrollY;
      this.uiBodyHeight = newBodyHeight;
      this.calculateOffset();
    }
  };
  RowContainerHeightService.prototype.calculateOffset = function () {
    this.setUiContainerHeight(this.maxDivHeight);
    this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
    this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    var scrollPercent = this.scrollY / this.maxScrollY;
    var divStretchOffset = scrollPercent * this.pixelsToShave;
    this.logger.log("Div Stretch Offset = " + divStretchOffset + " (" + this.pixelsToShave + " * " + scrollPercent + ")");
    this.setDivStretchOffset(divStretchOffset);
  };
  RowContainerHeightService.prototype.setUiContainerHeight = function (height) {
    if (height !== this.uiContainerHeight) {
      this.uiContainerHeight = height;
      this.eventService.dispatchEvent({
        type: Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED
      });
    }
  };
  RowContainerHeightService.prototype.clearOffset = function () {
    this.setUiContainerHeight(this.modelHeight);
    this.pixelsToShave = 0;
    this.setDivStretchOffset(0);
  };
  RowContainerHeightService.prototype.setDivStretchOffset = function (newOffset) {
    // because we are talking pixels, no point in confusing things with half numbers
    var newOffsetFloor = typeof newOffset === 'number' ? Math.floor(newOffset) : null;
    if (this.divStretchOffset === newOffsetFloor) {
      return;
    }
    this.divStretchOffset = newOffsetFloor;
    this.eventService.dispatchEvent({
      type: Events.EVENT_HEIGHT_SCALE_CHANGED
    });
  };
  RowContainerHeightService.prototype.setModelHeight = function (modelHeight) {
    this.modelHeight = modelHeight;
    this.stretching = modelHeight != null // null happens when in print layout
    && this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
    if (this.stretching) {
      this.calculateOffset();
    } else {
      this.clearOffset();
    }
  };
  RowContainerHeightService.prototype.getUiContainerHeight = function () {
    return this.uiContainerHeight;
  };
  RowContainerHeightService.prototype.getRealPixelPosition = function (modelPixel) {
    return modelPixel - this.divStretchOffset;
  };
  RowContainerHeightService.prototype.getUiBodyHeight = function () {
    var gridBodyCon = this.ctrlsService.getGridBodyCtrl();
    var pos = gridBodyCon.getScrollFeature().getVScrollPosition();
    return pos.bottom - pos.top;
  };
  RowContainerHeightService.prototype.getScrollPositionForPixel = function (rowTop) {
    if (this.pixelsToShave <= 0) {
      return rowTop;
    }
    var modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
    var scrollPercent = rowTop / modelMaxScroll;
    var scrollPixel = this.maxScrollY * scrollPercent;
    return scrollPixel;
  };
  __decorate$1Q([Autowired('ctrlsService')], RowContainerHeightService.prototype, "ctrlsService", void 0);
  __decorate$1Q([__param$8(0, Qualifier("loggerFactory"))], RowContainerHeightService.prototype, "agWire", null);
  __decorate$1Q([PostConstruct], RowContainerHeightService.prototype, "postConstruct", null);
  RowContainerHeightService = __decorate$1Q([Bean('rowContainerHeightService')], RowContainerHeightService);
  return RowContainerHeightService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$22 = undefined && undefined.__extends || function () {
  var _extendStatics131 = function extendStatics(d, b) {
    _extendStatics131 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics131(d, b);
  };
  return function (d, b) {
    _extendStatics131(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1R = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SelectableService = /** @class */function (_super) {
  __extends$22(SelectableService, _super);
  function SelectableService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SelectableService.prototype.init = function () {
    this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
    this.isRowSelectableFunc = this.gridOptionsWrapper.getIsRowSelectableFunc();
  };
  SelectableService.prototype.updateSelectableAfterGrouping = function (rowNode) {
    if (this.isRowSelectableFunc) {
      var nextChildrenFunc = function nextChildrenFunc(node) {
        return node.childrenAfterGroup;
      };
      this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
    }
  };
  SelectableService.prototype.updateSelectableAfterFiltering = function (rowNode) {
    if (this.isRowSelectableFunc) {
      var nextChildrenFunc = function nextChildrenFunc(node) {
        return node.childrenAfterFilter;
      };
      this.recurseDown(rowNode.childrenAfterGroup, nextChildrenFunc);
    }
  };
  SelectableService.prototype.recurseDown = function (children, nextChildrenFunc) {
    var _this = this;
    if (!children) {
      return;
    }
    children.forEach(function (child) {
      if (!child.group) {
        return;
      } // only interested in groups
      if (child.hasChildren()) {
        _this.recurseDown(nextChildrenFunc(child), nextChildrenFunc);
      }
      var rowSelectable;
      if (_this.groupSelectsChildren) {
        // have this group selectable if at least one direct child is selectable
        var firstSelectable = find$3(nextChildrenFunc(child), 'selectable', true);
        rowSelectable = exists(firstSelectable);
      } else {
        // directly retrieve selectable value from user callback
        rowSelectable = _this.isRowSelectableFunc ? _this.isRowSelectableFunc(child) : false;
      }
      child.setRowSelectable(rowSelectable);
    });
  };
  __decorate$1R([PostConstruct], SelectableService.prototype, "init", null);
  SelectableService = __decorate$1R([Bean('selectableService')], SelectableService);
  return SelectableService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$23 = undefined && undefined.__extends || function () {
  var _extendStatics132 = function extendStatics(d, b) {
    _extendStatics132 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics132(d, b);
  };
  return function (d, b) {
    _extendStatics132(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1S = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaginationComp = /** @class */function (_super) {
  __extends$23(PaginationComp, _super);
  function PaginationComp() {
    var _this = _super.call(this) || this;
    _this.previousAndFirstButtonsDisabled = false;
    _this.nextButtonDisabled = false;
    _this.lastButtonDisabled = false;
    return _this;
  }
  PaginationComp.prototype.postConstruct = function () {
    var _this = this;
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    this.setTemplate(this.getTemplate());
    this.btFirst.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'last' : 'first', this.gridOptionsWrapper));
    this.btPrevious.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'next' : 'previous', this.gridOptionsWrapper));
    this.btNext.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'previous' : 'next', this.gridOptionsWrapper));
    this.btLast.insertAdjacentElement('afterbegin', createIconNoSpan(isRtl ? 'first' : 'last', this.gridOptionsWrapper));
    var isPaging = this.gridOptionsWrapper.isPagination();
    var paginationPanelEnabled = isPaging && !this.gridOptionsWrapper.isSuppressPaginationPanel();
    if (!paginationPanelEnabled) {
      this.setDisplayed(false);
      return;
    }
    this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
    [{
      el: this.btFirst,
      fn: this.onBtFirst.bind(this)
    }, {
      el: this.btPrevious,
      fn: this.onBtPrevious.bind(this)
    }, {
      el: this.btNext,
      fn: this.onBtNext.bind(this)
    }, {
      el: this.btLast,
      fn: this.onBtLast.bind(this)
    }].forEach(function (item) {
      var el = item.el,
        fn = item.fn;
      _this.addManagedListener(el, 'click', fn);
      _this.addManagedListener(el, 'keydown', function (e) {
        if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
          e.preventDefault();
          fn();
        }
      });
    });
    this.onPaginationChanged();
  };
  PaginationComp.prototype.onPaginationChanged = function () {
    this.enableOrDisableButtons();
    this.updateRowLabels();
    this.setCurrentPageLabel();
    this.setTotalLabels();
  };
  PaginationComp.prototype.onBtFirst = function () {
    if (!this.previousAndFirstButtonsDisabled) {
      this.paginationProxy.goToFirstPage();
    }
  };
  PaginationComp.prototype.setCurrentPageLabel = function () {
    var pagesExist = this.paginationProxy.getTotalPages() > 0;
    var currentPage = this.paginationProxy.getCurrentPage();
    var toDisplay = pagesExist ? currentPage + 1 : 0;
    this.lbCurrent.innerHTML = this.formatNumber(toDisplay);
  };
  PaginationComp.prototype.formatNumber = function (value) {
    var userFunc = this.gridOptionsWrapper.getPaginationNumberFormatterFunc();
    if (userFunc) {
      return userFunc({
        value: value
      });
    }
    return formatNumberCommas(value);
  };
  PaginationComp.prototype.getTemplate = function () {
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var strPage = localeTextFunc('page', 'Page');
    var strTo = localeTextFunc('to', 'to');
    var strOf = localeTextFunc('of', 'of');
    var strFirst = localeTextFunc('firstPage', 'First Page');
    var strPrevious = localeTextFunc('previousPage', 'Previous Page');
    var strNext = localeTextFunc('nextPage', 'Next Page');
    var strLast = localeTextFunc('lastPage', 'Last Page');
    var compId = this.getCompId();
    return (/* html */"<div class=\"ag-paging-panel ag-unselectable\" id=\"ag-" + compId + "\">\n                <span class=\"ag-paging-row-summary-panel\" role=\"status\">\n                    <span id=\"ag-" + compId + "-first-row\" ref=\"lbFirstRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-" + compId + "-to\">" + strTo + "</span>\n                    <span id=\"ag-" + compId + "-last-row\" ref=\"lbLastRowOnPage\" class=\"ag-paging-row-summary-panel-number\"></span>\n                    <span id=\"ag-" + compId + "-of\">" + strOf + "</span>\n                    <span id=\"ag-" + compId + "-row-count\" ref=\"lbRecordCount\" class=\"ag-paging-row-summary-panel-number\"></span>\n                </span>\n                <span class=\"ag-paging-page-summary-panel\" role=\"presentation\">\n                    <div ref=\"btFirst\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strFirst + "\" tabindex=\"0\"></div>\n                    <div ref=\"btPrevious\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strPrevious + "\" tabindex=\"0\"></div>\n                    <span class=\"ag-paging-description\" role=\"status\">\n                        <span id=\"ag-" + compId + "-start-page\">" + strPage + "</span>\n                        <span id=\"ag-" + compId + "-start-page-number\" ref=\"lbCurrent\" class=\"ag-paging-number\"></span>\n                        <span id=\"ag-" + compId + "-of-page\">" + strOf + "</span>\n                        <span id=\"ag-" + compId + "-of-page-number\" ref=\"lbTotal\" class=\"ag-paging-number\"></span>\n                    </span>\n                    <div ref=\"btNext\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strNext + "\" tabindex=\"0\"></div>\n                    <div ref=\"btLast\" class=\"ag-paging-button\" role=\"button\" aria-label=\"" + strLast + "\" tabindex=\"0\"></div>\n                </span>\n            </div>"
    );
  };
  PaginationComp.prototype.onBtNext = function () {
    if (!this.nextButtonDisabled) {
      this.paginationProxy.goToNextPage();
    }
  };
  PaginationComp.prototype.onBtPrevious = function () {
    if (!this.previousAndFirstButtonsDisabled) {
      this.paginationProxy.goToPreviousPage();
    }
  };
  PaginationComp.prototype.onBtLast = function () {
    if (!this.lastButtonDisabled) {
      this.paginationProxy.goToLastPage();
    }
  };
  PaginationComp.prototype.enableOrDisableButtons = function () {
    var currentPage = this.paginationProxy.getCurrentPage();
    var maxRowFound = this.paginationProxy.isLastPageFound();
    var totalPages = this.paginationProxy.getTotalPages();
    this.previousAndFirstButtonsDisabled = currentPage === 0;
    addOrRemoveCssClass(this.btFirst, 'ag-disabled', this.previousAndFirstButtonsDisabled);
    setAriaDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
    addOrRemoveCssClass(this.btPrevious, 'ag-disabled', this.previousAndFirstButtonsDisabled);
    setAriaDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    var zeroPagesToDisplay = this.isZeroPagesToDisplay();
    var onLastPage = maxRowFound && currentPage === totalPages - 1;
    this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
    addOrRemoveCssClass(this.btNext, 'ag-disabled', this.nextButtonDisabled);
    setAriaDisabled(this.btNext, this.nextButtonDisabled);
    this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
    addOrRemoveCssClass(this.btLast, 'ag-disabled', this.lastButtonDisabled);
    setAriaDisabled(this.btLast, this.lastButtonDisabled);
  };
  PaginationComp.prototype.updateRowLabels = function () {
    var currentPage = this.paginationProxy.getCurrentPage();
    var pageSize = this.paginationProxy.getPageSize();
    var maxRowFound = this.paginationProxy.isLastPageFound();
    var rowCount = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null;
    var startRow;
    var endRow;
    if (this.isZeroPagesToDisplay()) {
      startRow = endRow = 0;
    } else {
      startRow = pageSize * currentPage + 1;
      endRow = startRow + pageSize - 1;
      if (maxRowFound && endRow > rowCount) {
        endRow = rowCount;
      }
    }
    this.lbFirstRowOnPage.innerHTML = this.formatNumber(startRow);
    if (this.rowNodeBlockLoader.isLoading()) {
      this.lbLastRowOnPage.innerHTML = '?';
    } else {
      this.lbLastRowOnPage.innerHTML = this.formatNumber(endRow);
    }
  };
  PaginationComp.prototype.isZeroPagesToDisplay = function () {
    var maxRowFound = this.paginationProxy.isLastPageFound();
    var totalPages = this.paginationProxy.getTotalPages();
    return maxRowFound && totalPages === 0;
  };
  PaginationComp.prototype.setTotalLabels = function () {
    var lastPageFound = this.paginationProxy.isLastPageFound();
    var totalPages = this.paginationProxy.getTotalPages();
    var rowCount = lastPageFound ? this.paginationProxy.getMasterRowCount() : null;
    // When `pivotMode=true` and no grouping or value columns exist, a single 'hidden' group row (root node) is in
    // the grid and the pagination totals will correctly display total = 1. However this is confusing to users as
    // they can't see it. To address this UX issue we simply set the totals to zero in the pagination panel.
    if (rowCount === 1) {
      var firstRow = this.paginationProxy.getRow(0);
      // a group node with no group or agg data will not be visible to users
      var hiddenGroupRow = firstRow && firstRow.group && !(firstRow.groupData || firstRow.aggData);
      if (hiddenGroupRow) {
        this.setTotalLabelsToZero();
        return;
      }
    }
    if (lastPageFound) {
      this.lbTotal.innerHTML = this.formatNumber(totalPages);
      this.lbRecordCount.innerHTML = this.formatNumber(rowCount);
    } else {
      var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
      this.lbTotal.innerHTML = moreText;
      this.lbRecordCount.innerHTML = moreText;
    }
  };
  PaginationComp.prototype.setTotalLabelsToZero = function () {
    this.lbFirstRowOnPage.innerHTML = this.formatNumber(0);
    this.lbCurrent.innerHTML = this.formatNumber(0);
    this.lbLastRowOnPage.innerHTML = this.formatNumber(0);
    this.lbTotal.innerHTML = this.formatNumber(0);
    this.lbRecordCount.innerHTML = this.formatNumber(0);
  };
  __decorate$1S([Autowired('paginationProxy')], PaginationComp.prototype, "paginationProxy", void 0);
  __decorate$1S([Autowired('rowNodeBlockLoader')], PaginationComp.prototype, "rowNodeBlockLoader", void 0);
  __decorate$1S([RefSelector('btFirst')], PaginationComp.prototype, "btFirst", void 0);
  __decorate$1S([RefSelector('btPrevious')], PaginationComp.prototype, "btPrevious", void 0);
  __decorate$1S([RefSelector('btNext')], PaginationComp.prototype, "btNext", void 0);
  __decorate$1S([RefSelector('btLast')], PaginationComp.prototype, "btLast", void 0);
  __decorate$1S([RefSelector('lbRecordCount')], PaginationComp.prototype, "lbRecordCount", void 0);
  __decorate$1S([RefSelector('lbFirstRowOnPage')], PaginationComp.prototype, "lbFirstRowOnPage", void 0);
  __decorate$1S([RefSelector('lbLastRowOnPage')], PaginationComp.prototype, "lbLastRowOnPage", void 0);
  __decorate$1S([RefSelector('lbCurrent')], PaginationComp.prototype, "lbCurrent", void 0);
  __decorate$1S([RefSelector('lbTotal')], PaginationComp.prototype, "lbTotal", void 0);
  __decorate$1S([PostConstruct], PaginationComp.prototype, "postConstruct", null);
  return PaginationComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$24 = undefined && undefined.__extends || function () {
  var _extendStatics133 = function extendStatics(d, b) {
    _extendStatics133 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics133(d, b);
  };
  return function (d, b) {
    _extendStatics133(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1T = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DEBOUNCE_DELAY = 50;
var ResizeObserverService = /** @class */function (_super) {
  __extends$24(ResizeObserverService, _super);
  function ResizeObserverService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.polyfillFunctions = [];
    return _this;
  }
  ResizeObserverService.prototype.observeResize = function (element, callback) {
    var _this = this;
    // this gets fired too often and might cause some relayout issues
    // so we add a debounce to the callback here to avoid the flashing effect.
    var debouncedCallback = debounce(callback, DEBOUNCE_DELAY);
    var useBrowserResizeObserver = function useBrowserResizeObserver() {
      var resizeObserver = new window.ResizeObserver(debouncedCallback);
      resizeObserver.observe(element);
      return function () {
        return resizeObserver.disconnect();
      };
    };
    var usePolyfill = function usePolyfill() {
      // initialise to the current width and height, so first call will have no changes
      var widthLastTime = offsetWidth(element);
      var heightLastTime = offsetHeight(element);
      // when finished, this gets turned to false.
      var running = true;
      var periodicallyCheckWidthAndHeight = function periodicallyCheckWidthAndHeight() {
        if (running) {
          var newWidth = offsetWidth(element);
          var newHeight = offsetHeight(element);
          var changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
          if (changed) {
            widthLastTime = newWidth;
            heightLastTime = newHeight;
            callback();
          }
          _this.doNextPolyfillTurn(periodicallyCheckWidthAndHeight);
        }
      };
      periodicallyCheckWidthAndHeight();
      // the callback function we return sets running to false
      return function () {
        return running = false;
      };
    };
    var suppressResize = this.gridOptionsWrapper.isSuppressBrowserResizeObserver();
    var resizeObserverExists = !!window.ResizeObserver;
    if (resizeObserverExists && !suppressResize) {
      return useBrowserResizeObserver();
    } else {
      return usePolyfill();
    }
  };
  ResizeObserverService.prototype.doNextPolyfillTurn = function (func) {
    this.polyfillFunctions.push(func);
    this.schedulePolyfill();
  };
  ResizeObserverService.prototype.schedulePolyfill = function () {
    var _this = this;
    if (this.polyfillScheduled) {
      return;
    }
    var executeAllFuncs = function executeAllFuncs() {
      var funcs = _this.polyfillFunctions;
      // make sure set scheduled to false and clear clear array
      // before executing the funcs, as the funcs could add more funcs
      _this.polyfillScheduled = false;
      _this.polyfillFunctions = [];
      funcs.forEach(function (f) {
        return f();
      });
    };
    this.polyfillScheduled = true;
    this.getFrameworkOverrides().setTimeout(executeAllFuncs, DEBOUNCE_DELAY);
  };
  ResizeObserverService = __decorate$1T([Bean('resizeObserverService')], ResizeObserverService);
  return ResizeObserverService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$25 = undefined && undefined.__extends || function () {
  var _extendStatics134 = function extendStatics(d, b) {
    _extendStatics134 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics134(d, b);
  };
  return function (d, b) {
    _extendStatics134(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1U = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LoadingType;
(function (LoadingType) {
  LoadingType[LoadingType["Loading"] = 0] = "Loading";
  LoadingType[LoadingType["NoRows"] = 1] = "NoRows";
})(LoadingType || (LoadingType = {}));
var OverlayWrapperComponent = /** @class */function (_super) {
  __extends$25(OverlayWrapperComponent, _super);
  function OverlayWrapperComponent() {
    var _this = _super.call(this, OverlayWrapperComponent.TEMPLATE) || this;
    _this.inProgress = false;
    _this.destroyRequested = false;
    return _this;
  }
  OverlayWrapperComponent.prototype.updateLayoutClasses = function (cssClass, params) {
    addOrRemoveCssClass(this.eOverlayWrapper, LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
    addOrRemoveCssClass(this.eOverlayWrapper, LayoutCssClasses.NORMAL, params.normal);
    addOrRemoveCssClass(this.eOverlayWrapper, LayoutCssClasses.PRINT, params.print);
  };
  OverlayWrapperComponent.prototype.postConstruct = function () {
    this.createManagedBean(new LayoutFeature(this));
    this.setDisplayed(false);
    this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATED, this.onRowDataChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
    if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
      this.showLoadingOverlay();
    }
    this.gridApi.registerOverlayWrapperComp(this);
  };
  OverlayWrapperComponent.prototype.setWrapperTypeClass = function (loadingType) {
    addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-loading-wrapper', loadingType === LoadingType.Loading);
    addOrRemoveCssClass(this.eOverlayWrapper, 'ag-overlay-no-rows-wrapper', loadingType === LoadingType.NoRows);
  };
  OverlayWrapperComponent.prototype.showLoadingOverlay = function () {
    if (this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
      return;
    }
    var params = {
      api: this.gridOptionsWrapper.getApi()
    };
    var compDetails = this.userComponentFactory.getLoadingOverlayCompDetails(params);
    var promise = compDetails.newAgStackInstance();
    this.showOverlay(promise, LoadingType.Loading);
  };
  OverlayWrapperComponent.prototype.showNoRowsOverlay = function () {
    if (this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
      return;
    }
    var params = {
      api: this.gridOptionsWrapper.getApi()
    };
    var compDetails = this.userComponentFactory.getNoRowsOverlayCompDetails(params);
    var promise = compDetails.newAgStackInstance();
    this.showOverlay(promise, LoadingType.NoRows);
  };
  OverlayWrapperComponent.prototype.showOverlay = function (workItem, type) {
    var _this = this;
    if (this.inProgress) {
      return;
    }
    this.setWrapperTypeClass(type);
    this.destroyActiveOverlay();
    this.inProgress = true;
    if (workItem) {
      workItem.then(function (comp) {
        _this.inProgress = false;
        _this.eOverlayWrapper.appendChild(comp.getGui());
        _this.activeOverlay = comp;
        if (_this.destroyRequested) {
          _this.destroyRequested = false;
          _this.destroyActiveOverlay();
        }
      });
    }
    this.setDisplayed(true);
  };
  OverlayWrapperComponent.prototype.destroyActiveOverlay = function () {
    if (this.inProgress) {
      this.destroyRequested = true;
      return;
    }
    if (!this.activeOverlay) {
      return;
    }
    this.activeOverlay = this.getContext().destroyBean(this.activeOverlay);
    clearElement(this.eOverlayWrapper);
  };
  OverlayWrapperComponent.prototype.hideOverlay = function () {
    this.destroyActiveOverlay();
    this.setDisplayed(false);
  };
  OverlayWrapperComponent.prototype.destroy = function () {
    this.destroyActiveOverlay();
    _super.prototype.destroy.call(this);
  };
  OverlayWrapperComponent.prototype.showOrHideOverlay = function () {
    var isEmpty = this.paginationProxy.isEmpty();
    var isSuppressNoRowsOverlay = this.gridOptionsWrapper.isSuppressNoRowsOverlay();
    if (isEmpty && !isSuppressNoRowsOverlay) {
      this.showNoRowsOverlay();
    } else {
      this.hideOverlay();
    }
  };
  OverlayWrapperComponent.prototype.onRowDataChanged = function () {
    this.showOrHideOverlay();
  };
  OverlayWrapperComponent.prototype.onNewColumnsLoaded = function () {
    // hide overlay if columns and rows exist, this can happen if columns are loaded after data.
    // this problem exists before of the race condition between the services (column controller in this case)
    // and the view (grid panel). if the model beans were all initialised first, and then the view beans second,
    // this race condition would not happen.
    if (this.columnModel.isReady() && !this.paginationProxy.isEmpty()) {
      this.hideOverlay();
    }
  };
  // wrapping in outer div, and wrapper, is needed to center the loading icon
  // The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
  OverlayWrapperComponent.TEMPLATE = "\n        <div class=\"ag-overlay\" aria-hidden=\"true\">\n            <div class=\"ag-overlay-panel\">\n                <div class=\"ag-overlay-wrapper\" ref=\"eOverlayWrapper\"></div>\n            </div>\n        </div>";
  __decorate$1U([Autowired('userComponentFactory')], OverlayWrapperComponent.prototype, "userComponentFactory", void 0);
  __decorate$1U([Autowired('paginationProxy')], OverlayWrapperComponent.prototype, "paginationProxy", void 0);
  __decorate$1U([Autowired('gridApi')], OverlayWrapperComponent.prototype, "gridApi", void 0);
  __decorate$1U([Autowired('columnModel')], OverlayWrapperComponent.prototype, "columnModel", void 0);
  __decorate$1U([RefSelector('eOverlayWrapper')], OverlayWrapperComponent.prototype, "eOverlayWrapper", void 0);
  __decorate$1U([PostConstruct], OverlayWrapperComponent.prototype, "postConstruct", null);
  return OverlayWrapperComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$26 = undefined && undefined.__extends || function () {
  var _extendStatics135 = function extendStatics(d, b) {
    _extendStatics135 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics135(d, b);
  };
  return function (d, b) {
    _extendStatics135(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1V = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgGroupComponent = /** @class */function (_super) {
  __extends$26(AgGroupComponent, _super);
  function AgGroupComponent(params) {
    if (params === void 0) {
      params = {};
    }
    var _this = _super.call(this, AgGroupComponent.getTemplate(params)) || this;
    _this.suppressEnabledCheckbox = true;
    _this.suppressOpenCloseIcons = false;
    var title = params.title,
      enabled = params.enabled,
      items = params.items,
      suppressEnabledCheckbox = params.suppressEnabledCheckbox,
      suppressOpenCloseIcons = params.suppressOpenCloseIcons;
    _this.title = title;
    _this.cssIdentifier = params.cssIdentifier || 'default';
    _this.enabled = enabled != null ? enabled : true;
    _this.items = items || [];
    _this.alignItems = params.alignItems || 'center';
    if (suppressEnabledCheckbox != null) {
      _this.suppressEnabledCheckbox = suppressEnabledCheckbox;
    }
    if (suppressOpenCloseIcons != null) {
      _this.suppressOpenCloseIcons = suppressOpenCloseIcons;
    }
    return _this;
  }
  AgGroupComponent.getTemplate = function (params) {
    var cssIdentifier = params.cssIdentifier || 'default';
    var direction = params.direction || 'vertical';
    return (/* html */"<div class=\"ag-group ag-" + cssIdentifier + "-group\" role=\"presentation\">\n            <div class=\"ag-group-title-bar ag-" + cssIdentifier + "-group-title-bar ag-unselectable\" ref=\"eTitleBar\" role=\"button\">\n                <span class=\"ag-group-title-bar-icon ag-" + cssIdentifier + "-group-title-bar-icon\" ref=\"eGroupOpenedIcon\" role=\"presentation\"></span>\n                <span class=\"ag-group-title-bar-icon ag-" + cssIdentifier + "-group-title-bar-icon\" ref=\"eGroupClosedIcon\" role=\"presentation\"></span>\n                <span ref=\"eTitle\" class=\"ag-group-title ag-" + cssIdentifier + "-group-title\"></span>\n            </div>\n            <div ref=\"eToolbar\" class=\"ag-group-toolbar ag-" + cssIdentifier + "-group-toolbar\">\n                <ag-checkbox ref=\"cbGroupEnabled\"></ag-checkbox>\n            </div>\n            <div ref=\"eContainer\" class=\"ag-group-container ag-group-container-" + direction + " ag-" + cssIdentifier + "-group-container\"></div>\n        </div>"
    );
  };
  AgGroupComponent.prototype.postConstruct = function () {
    if (this.items.length) {
      var initialItems = this.items;
      this.items = [];
      this.addItems(initialItems);
    }
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    this.cbGroupEnabled.setLabel(localeTextFunc('enabled', 'Enabled'));
    if (this.title) {
      this.setTitle(this.title);
    }
    if (this.enabled) {
      this.setEnabled(this.enabled);
    }
    this.setAlignItems(this.alignItems);
    this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
    this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
    this.setupExpandContract();
    this.refreshAriaStatus();
    this.refreshChildDisplay();
  };
  AgGroupComponent.prototype.setupExpandContract = function () {
    var _this = this;
    this.eGroupClosedIcon.appendChild(createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
    this.eGroupOpenedIcon.appendChild(createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
    this.addManagedListener(this.eTitleBar, 'click', function () {
      return _this.toggleGroupExpand();
    });
    this.addManagedListener(this.eTitleBar, 'keydown', function (e) {
      switch (e.keyCode) {
        case KeyCode.ENTER:
        case KeyCode.SPACE:
          e.preventDefault();
          _this.toggleGroupExpand();
          break;
        case KeyCode.RIGHT:
        case KeyCode.LEFT:
          e.preventDefault();
          _this.toggleGroupExpand(e.keyCode === KeyCode.RIGHT);
          break;
      }
    });
  };
  AgGroupComponent.prototype.refreshAriaStatus = function () {
    if (!this.suppressOpenCloseIcons) {
      _setAriaExpanded(this.eTitleBar, this.expanded);
    }
  };
  AgGroupComponent.prototype.refreshChildDisplay = function () {
    var showIcon = !this.suppressOpenCloseIcons;
    setDisplayed(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
    setDisplayed(this.eGroupOpenedIcon, showIcon && this.expanded);
    setDisplayed(this.eGroupClosedIcon, showIcon && !this.expanded);
  };
  AgGroupComponent.prototype.isExpanded = function () {
    return this.expanded;
  };
  AgGroupComponent.prototype.setAlignItems = function (alignment) {
    var eGui = this.getGui();
    if (this.alignItems !== alignment) {
      removeCssClass(eGui, "ag-group-item-alignment-" + this.alignItems);
    }
    this.alignItems = alignment;
    var newCls = "ag-group-item-alignment-" + this.alignItems;
    addCssClass(eGui, newCls);
    return this;
  };
  AgGroupComponent.prototype.toggleGroupExpand = function (expanded) {
    if (this.suppressOpenCloseIcons) {
      this.expanded = true;
      this.refreshChildDisplay();
      setDisplayed(this.eContainer, true);
      return this;
    }
    expanded = expanded != null ? expanded : !this.expanded;
    if (this.expanded === expanded) {
      return this;
    }
    this.expanded = expanded;
    this.refreshAriaStatus();
    this.refreshChildDisplay();
    setDisplayed(this.eContainer, expanded);
    this.dispatchEvent({
      type: this.expanded ? AgGroupComponent.EVENT_EXPANDED : AgGroupComponent.EVENT_COLLAPSED
    });
    return this;
  };
  AgGroupComponent.prototype.addItems = function (items) {
    var _this = this;
    items.forEach(function (item) {
      return _this.addItem(item);
    });
  };
  AgGroupComponent.prototype.addItem = function (item) {
    var container = this.eContainer;
    var el = item instanceof Component ? item.getGui() : item;
    addCssClass(el, 'ag-group-item');
    addCssClass(el, "ag-" + this.cssIdentifier + "-group-item");
    container.appendChild(el);
    this.items.push(el);
  };
  AgGroupComponent.prototype.hideItem = function (hide, index) {
    var itemToHide = this.items[index];
    addOrRemoveCssClass(itemToHide, 'ag-hidden', hide);
  };
  AgGroupComponent.prototype.setTitle = function (title) {
    this.eTitle.innerText = title;
    return this;
  };
  AgGroupComponent.prototype.addCssClassToTitleBar = function (cssClass) {
    addCssClass(this.eTitleBar, cssClass);
  };
  AgGroupComponent.prototype.setEnabled = function (enabled, skipToggle) {
    this.enabled = enabled;
    this.refreshDisabledStyles();
    this.toggleGroupExpand(enabled);
    if (!skipToggle) {
      this.cbGroupEnabled.setValue(enabled);
    }
    return this;
  };
  AgGroupComponent.prototype.isEnabled = function () {
    return this.enabled;
  };
  AgGroupComponent.prototype.onEnableChange = function (callbackFn) {
    var _this = this;
    this.cbGroupEnabled.onValueChange(function (newSelection) {
      _this.setEnabled(newSelection, true);
      callbackFn(newSelection);
    });
    return this;
  };
  AgGroupComponent.prototype.hideEnabledCheckbox = function (hide) {
    this.suppressEnabledCheckbox = hide;
    this.refreshChildDisplay();
    this.refreshDisabledStyles();
    return this;
  };
  AgGroupComponent.prototype.hideOpenCloseIcons = function (hide) {
    this.suppressOpenCloseIcons = hide;
    if (hide) {
      this.toggleGroupExpand(true);
    }
    return this;
  };
  AgGroupComponent.prototype.refreshDisabledStyles = function () {
    addOrRemoveCssClass(this.getGui(), 'ag-disabled', !this.enabled);
    if (this.suppressEnabledCheckbox && !this.enabled) {
      addCssClass(this.eTitleBar, 'ag-disabled-group-title-bar');
      this.eTitleBar.removeAttribute('tabindex');
    } else {
      removeCssClass(this.eTitleBar, 'ag-disabled-group-title-bar');
      this.eTitleBar.setAttribute('tabindex', '0');
    }
    addOrRemoveCssClass(this.eContainer, 'ag-disabled-group-container', !this.enabled);
  };
  AgGroupComponent.EVENT_EXPANDED = 'expanded';
  AgGroupComponent.EVENT_COLLAPSED = 'collapsed';
  __decorate$1V([RefSelector('eTitleBar')], AgGroupComponent.prototype, "eTitleBar", void 0);
  __decorate$1V([RefSelector('eGroupOpenedIcon')], AgGroupComponent.prototype, "eGroupOpenedIcon", void 0);
  __decorate$1V([RefSelector('eGroupClosedIcon')], AgGroupComponent.prototype, "eGroupClosedIcon", void 0);
  __decorate$1V([RefSelector('eToolbar')], AgGroupComponent.prototype, "eToolbar", void 0);
  __decorate$1V([RefSelector('cbGroupEnabled')], AgGroupComponent.prototype, "cbGroupEnabled", void 0);
  __decorate$1V([RefSelector('eTitle')], AgGroupComponent.prototype, "eTitle", void 0);
  __decorate$1V([RefSelector('eContainer')], AgGroupComponent.prototype, "eContainer", void 0);
  __decorate$1V([PostConstruct], AgGroupComponent.prototype, "postConstruct", null);
  return AgGroupComponent;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$27 = undefined && undefined.__extends || function () {
  var _extendStatics136 = function extendStatics(d, b) {
    _extendStatics136 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics136(d, b);
  };
  return function (d, b) {
    _extendStatics136(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1W = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RESIZE_CONTAINER_STYLE = 'ag-resizer-wrapper';
var RESIZE_TEMPLATE = /* html */"<div class=\"" + RESIZE_CONTAINER_STYLE + "\">\n        <div ref=\"eTopLeftResizer\" class=\"ag-resizer ag-resizer-topLeft\"></div>\n        <div ref=\"eTopResizer\" class=\"ag-resizer ag-resizer-top\"></div>\n        <div ref=\"eTopRightResizer\" class=\"ag-resizer ag-resizer-topRight\"></div>\n        <div ref=\"eRightResizer\" class=\"ag-resizer ag-resizer-right\"></div>\n        <div ref=\"eBottomRightResizer\" class=\"ag-resizer ag-resizer-bottomRight\"></div>\n        <div ref=\"eBottomResizer\" class=\"ag-resizer ag-resizer-bottom\"></div>\n        <div ref=\"eBottomLeftResizer\" class=\"ag-resizer ag-resizer-bottomLeft\"></div>\n        <div ref=\"eLeftResizer\" class=\"ag-resizer ag-resizer-left\"></div>\n    </div>";
var PositionableFeature = /** @class */function (_super) {
  __extends$27(PositionableFeature, _super);
  function PositionableFeature(element, config) {
    var _this = _super.call(this) || this;
    _this.element = element;
    _this.dragStartPosition = {
      x: 0,
      y: 0
    };
    _this.position = {
      x: 0,
      y: 0
    };
    _this.lastSize = {
      width: -1,
      height: -1
    };
    _this.positioned = false;
    _this.resizersAdded = false;
    _this.resizeListeners = [];
    _this.boundaryEl = null;
    _this.isResizing = false;
    _this.isMoving = false;
    _this.resizable = {};
    _this.movable = false;
    _this.currentResizer = null;
    _this.config = assign$3({}, {
      popup: false
    }, config);
    return _this;
  }
  PositionableFeature.prototype.center = function () {
    var _a = this.offsetParent,
      clientHeight = _a.clientHeight,
      clientWidth = _a.clientWidth;
    var x = clientWidth / 2 - this.getWidth() / 2;
    var y = clientHeight / 2 - this.getHeight() / 2;
    this.offsetElement(x, y);
  };
  PositionableFeature.prototype.initialisePosition = function () {
    var _a = this.config,
      centered = _a.centered,
      forcePopupParentAsOffsetParent = _a.forcePopupParentAsOffsetParent,
      minWidth = _a.minWidth,
      width = _a.width,
      minHeight = _a.minHeight,
      height = _a.height,
      x = _a.x,
      y = _a.y;
    if (!this.offsetParent) {
      this.setOffsetParent();
    }
    var computedMinHeight = 0;
    var computedMinWidth = 0;
    // here we don't use the main offset parent but the element's offsetParent
    // in order to calculated the minWidth and minHeight correctly
    var isVisible = !!this.element.offsetParent;
    if (isVisible) {
      var boundaryEl = this.findBoundaryElement();
      var offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
      if (offsetParentComputedStyles.minWidth != null) {
        var paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
        computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
      }
      if (offsetParentComputedStyles.minHeight != null) {
        var paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
        computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
      }
    }
    this.minHeight = minHeight || computedMinHeight;
    this.minWidth = minWidth || computedMinWidth;
    if (width) {
      this.setWidth(width);
    }
    if (height) {
      this.setHeight(height);
    }
    if (!width || !height) {
      this.refreshSize();
    }
    if (centered) {
      this.center();
    } else if (x || y) {
      this.offsetElement(x, y);
    } else if (isVisible && forcePopupParentAsOffsetParent && this.boundaryEl) {
      var top_1 = parseFloat(this.boundaryEl.style.top);
      var left = parseFloat(this.boundaryEl.style.left);
      this.offsetElement(isNaN(left) ? 0 : left, isNaN(top_1) ? 0 : top_1);
    }
    this.positioned = !!this.offsetParent;
  };
  PositionableFeature.prototype.isPositioned = function () {
    return this.positioned;
  };
  PositionableFeature.prototype.getPosition = function () {
    return this.position;
  };
  PositionableFeature.prototype.setMovable = function (movable, moveElement) {
    if (!this.config.popup || movable === this.movable) {
      return;
    }
    this.movable = movable;
    var params = this.moveElementDragListener || {
      eElement: moveElement,
      onDragStart: this.onMoveStart.bind(this),
      onDragging: this.onMove.bind(this),
      onDragStop: this.onMoveEnd.bind(this)
    };
    if (movable) {
      this.dragService.addDragSource(params);
      this.moveElementDragListener = params;
    } else {
      this.dragService.removeDragSource(params);
      this.moveElementDragListener = undefined;
    }
  };
  PositionableFeature.prototype.setResizable = function (resizable) {
    var _this = this;
    this.clearResizeListeners();
    if (resizable) {
      this.addResizers();
    } else {
      this.removeResizers();
    }
    if (typeof resizable === 'boolean') {
      if (resizable === false) {
        return;
      }
      resizable = {
        topLeft: resizable,
        top: resizable,
        topRight: resizable,
        right: resizable,
        bottomRight: resizable,
        bottom: resizable,
        bottomLeft: resizable,
        left: resizable
      };
    }
    Object.keys(resizable).forEach(function (side) {
      var resizableStructure = resizable;
      var val = !!resizableStructure[side];
      var resizerEl = _this.getResizerElement(side);
      var params = {
        dragStartPixels: 0,
        eElement: resizerEl,
        onDragStart: function onDragStart(e) {
          return _this.onResizeStart(e, side);
        },
        onDragging: _this.onResize.bind(_this),
        onDragStop: function onDragStop(e) {
          return _this.onResizeEnd(e, side);
        }
      };
      if (!!_this.resizable[side] !== val || !_this.isAlive() && !val) {
        if (val) {
          _this.dragService.addDragSource(params);
          _this.resizeListeners.push(params);
          resizerEl.style.pointerEvents = 'all';
        } else {
          resizerEl.style.pointerEvents = 'none';
        }
      }
    });
  };
  PositionableFeature.prototype.removeSizeFromEl = function () {
    this.element.style.removeProperty('height');
    this.element.style.removeProperty('width');
    this.element.style.removeProperty('flex');
  };
  PositionableFeature.prototype.restoreLastSize = function () {
    this.element.style.flex = '0 0 auto';
    var _a = this.lastSize,
      height = _a.height,
      width = _a.width;
    if (width !== -1) {
      this.element.style.width = width + "px";
    }
    if (height !== -1) {
      this.element.style.height = height + "px";
    }
  };
  PositionableFeature.prototype.getHeight = function () {
    return this.element.offsetHeight;
  };
  PositionableFeature.prototype.setHeight = function (height) {
    var popup = this.config.popup;
    var eGui = this.element;
    var isPercent = false;
    if (typeof height === 'string' && height.indexOf('%') !== -1) {
      setFixedHeight(eGui, height);
      height = getAbsoluteHeight(eGui);
      isPercent = true;
    } else if (this.positioned) {
      var elRect = this.element.getBoundingClientRect();
      var parentRect = this.offsetParent.getBoundingClientRect();
      height = Math.max(this.minHeight, height);
      var clientHeight = this.offsetParent.clientHeight;
      var yPosition = popup ? this.position.y : elRect.top;
      var parentTop = popup ? 0 : parentRect.top;
      if (clientHeight && height + yPosition > clientHeight + parentTop) {
        height = clientHeight - yPosition;
      }
    }
    if (this.getHeight() === height) {
      return;
    }
    if (!isPercent) {
      if (popup) {
        setFixedHeight(eGui, height);
      } else {
        eGui.style.height = height + "px";
        eGui.style.flex = '0 0 auto';
        this.lastSize.height = typeof height === 'number' ? height : parseFloat(height);
      }
    } else {
      eGui.style.maxHeight = 'unset';
      eGui.style.minHeight = 'unset';
    }
  };
  PositionableFeature.prototype.getWidth = function () {
    return this.element.offsetWidth;
  };
  PositionableFeature.prototype.setWidth = function (width) {
    var eGui = this.element;
    var popup = this.config.popup;
    var isPercent = false;
    if (typeof width === 'string' && width.indexOf('%') !== -1) {
      setFixedWidth(eGui, width);
      width = getAbsoluteWidth(eGui);
      isPercent = true;
    } else if (this.positioned) {
      width = Math.max(this.minWidth, width);
      var clientWidth = this.offsetParent.clientWidth;
      var xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
      if (clientWidth && width + xPosition > clientWidth) {
        width = clientWidth - xPosition;
      }
    }
    if (this.getWidth() === width) {
      return;
    }
    if (!isPercent) {
      if (this.config.popup) {
        setFixedWidth(eGui, width);
      } else {
        eGui.style.width = width + "px";
        eGui.style.flex = ' unset';
        this.lastSize.width = typeof width === 'number' ? width : parseFloat(width);
      }
    } else {
      eGui.style.maxWidth = 'unset';
      eGui.style.minWidth = 'unset';
    }
  };
  PositionableFeature.prototype.offsetElement = function (x, y) {
    if (x === void 0) {
      x = 0;
    }
    if (y === void 0) {
      y = 0;
    }
    var ePopup = this.config.forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
    this.popupService.positionPopup({
      ePopup: ePopup,
      x: x,
      y: y,
      keepWithinBounds: true
    });
    this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
  };
  PositionableFeature.prototype.setPosition = function (x, y) {
    this.position.x = x;
    this.position.y = y;
  };
  PositionableFeature.prototype.updateDragStartPosition = function (x, y) {
    this.dragStartPosition = {
      x: x,
      y: y
    };
  };
  PositionableFeature.prototype.calculateMouseMovement = function (params) {
    var e = params.e,
      isLeft = params.isLeft,
      isTop = params.isTop,
      anywhereWithin = params.anywhereWithin,
      topBuffer = params.topBuffer;
    var xDiff = e.clientX - this.dragStartPosition.x;
    var yDiff = e.clientY - this.dragStartPosition.y;
    var movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
    var movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
    return {
      movementX: movementX,
      movementY: movementY
    };
  };
  PositionableFeature.prototype.shouldSkipX = function (e, isLeft, anywhereWithin, diff) {
    var elRect = this.element.getBoundingClientRect();
    var parentRect = this.offsetParent.getBoundingClientRect();
    var boundaryElRect = this.boundaryEl.getBoundingClientRect();
    var xPosition = this.config.popup ? this.position.x : elRect.left;
    // skip if cursor is outside of popupParent horizontally
    var skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
    if (skipX) {
      return true;
    }
    if (isLeft) {
      skipX =
      // skip if we are moving to the left and the cursor
      // is positioned to the right of the left side anchor
      diff < 0 && e.clientX > xPosition + parentRect.left ||
      // skip if we are moving to the right and the cursor
      // is positioned to the left of the dialog
      diff > 0 && e.clientX < xPosition + parentRect.left;
    } else {
      if (anywhereWithin) {
        // if anywhereWithin is true, we allow to move
        // as long as the cursor is within the dialog
        skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
      } else {
        skipX =
        // if the movement is bound to the right side of the dialog
        // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right ||
        // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
      }
    }
    return skipX;
  };
  PositionableFeature.prototype.shouldSkipY = function (e, isTop, topBuffer, diff) {
    if (topBuffer === void 0) {
      topBuffer = 0;
    }
    var elRect = this.element.getBoundingClientRect();
    var parentRect = this.offsetParent.getBoundingClientRect();
    var boundaryElRect = this.boundaryEl.getBoundingClientRect();
    var yPosition = this.config.popup ? this.position.y : elRect.top;
    // skip if cursor is outside of popupParent vertically
    var skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
    if (skipY) {
      return true;
    }
    if (isTop) {
      skipY =
      // skip if we are moving to towards top and the cursor is
      // below the top anchor + topBuffer
      // note: topBuffer is used when moving the dialog using the title bar
      diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer ||
      // skip if we are moving to the bottom and the cursor is
      // above the top anchor
      diff > 0 && e.clientY < yPosition + parentRect.top;
    } else {
      skipY =
      // skip if we are moving towards the top and the cursor
      // is below the bottom anchor
      diff < 0 && e.clientY > boundaryElRect.bottom ||
      // skip if we are moving towards the bottom and the cursor
      // is above the bottom anchor
      diff > 0 && e.clientY < boundaryElRect.bottom;
    }
    return skipY;
  };
  PositionableFeature.prototype.createResizeMap = function () {
    var eGui = this.element;
    this.resizerMap = {
      topLeft: {
        element: eGui.querySelector('[ref=eTopLeftResizer]')
      },
      top: {
        element: eGui.querySelector('[ref=eTopResizer]')
      },
      topRight: {
        element: eGui.querySelector('[ref=eTopRightResizer]')
      },
      right: {
        element: eGui.querySelector('[ref=eRightResizer]')
      },
      bottomRight: {
        element: eGui.querySelector('[ref=eBottomRightResizer]')
      },
      bottom: {
        element: eGui.querySelector('[ref=eBottomResizer]')
      },
      bottomLeft: {
        element: eGui.querySelector('[ref=eBottomLeftResizer]')
      },
      left: {
        element: eGui.querySelector('[ref=eLeftResizer]')
      }
    };
  };
  PositionableFeature.prototype.addResizers = function () {
    if (this.resizersAdded) {
      return;
    }
    var eGui = this.element;
    if (!eGui) {
      return;
    }
    var parser = new DOMParser();
    var resizers = parser.parseFromString(RESIZE_TEMPLATE, 'text/html').body;
    eGui.appendChild(resizers.firstChild);
    this.createResizeMap();
    this.resizersAdded = true;
  };
  PositionableFeature.prototype.removeResizers = function () {
    this.resizerMap = undefined;
    var resizerEl = this.element.querySelector("." + RESIZE_CONTAINER_STYLE);
    if (resizerEl) {
      this.element.removeChild(resizerEl);
    }
    this.resizersAdded = false;
  };
  PositionableFeature.prototype.getResizerElement = function (side) {
    return this.resizerMap[side].element;
  };
  PositionableFeature.prototype.onResizeStart = function (e, side) {
    this.boundaryEl = this.findBoundaryElement();
    if (!this.positioned) {
      this.initialisePosition();
    }
    this.currentResizer = {
      isTop: !!side.match(/top/i),
      isRight: !!side.match(/right/i),
      isBottom: !!side.match(/bottom/i),
      isLeft: !!side.match(/left/i)
    };
    addCssClass(this.element, 'ag-resizing');
    addCssClass(this.resizerMap[side].element, 'ag-active');
    var _a = this.config,
      popup = _a.popup,
      forcePopupParentAsOffsetParent = _a.forcePopupParentAsOffsetParent;
    if (!popup && !forcePopupParentAsOffsetParent) {
      this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
    }
    this.isResizing = true;
    this.updateDragStartPosition(e.clientX, e.clientY);
  };
  PositionableFeature.prototype.getSiblings = function () {
    var element = this.element;
    var parent = element.parentElement;
    if (!parent) {
      return null;
    }
    return Array.prototype.slice.call(parent.children).filter(function (el) {
      return !containsClass(el, 'ag-hidden');
    });
  };
  PositionableFeature.prototype.getMinSizeOfSiblings = function () {
    var siblings = this.getSiblings() || [];
    var height = 0;
    var width = 0;
    for (var i = 0; i < siblings.length; i++) {
      var currentEl = siblings[i];
      var isFlex = !!currentEl.style.flex && currentEl.style.flex !== '0 0 auto';
      if (currentEl === this.element) {
        continue;
      }
      var nextHeight = this.minHeight || 0;
      var nextWidth = this.minWidth || 0;
      if (isFlex) {
        var computedStyle = window.getComputedStyle(currentEl);
        if (computedStyle.minHeight) {
          nextHeight = parseInt(computedStyle.minHeight, 10);
        }
        if (computedStyle.minWidth) {
          nextWidth = parseInt(computedStyle.minWidth, 10);
        }
      } else {
        nextHeight = currentEl.offsetHeight;
        nextWidth = currentEl.offsetWidth;
      }
      height += nextHeight;
      width += nextWidth;
    }
    return {
      height: height,
      width: width
    };
  };
  PositionableFeature.prototype.applySizeToSiblings = function (vertical) {
    var containerToFlex = null;
    var siblings = this.getSiblings();
    if (!siblings) {
      return;
    }
    for (var i = 0; i < siblings.length; i++) {
      var el = siblings[i];
      if (el === containerToFlex) {
        continue;
      }
      if (vertical) {
        el.style.height = el.offsetHeight + "px";
      } else {
        el.style.width = el.offsetWidth + "px";
      }
      el.style.flex = '0 0 auto';
      if (el === this.element) {
        containerToFlex = siblings[i + 1];
      }
    }
    if (containerToFlex) {
      containerToFlex.style.removeProperty('height');
      containerToFlex.style.removeProperty('min-height');
      containerToFlex.style.removeProperty('max-height');
      containerToFlex.style.flex = '1 1 auto';
    }
  };
  PositionableFeature.prototype.onResize = function (e) {
    if (!this.isResizing || !this.currentResizer) {
      return;
    }
    var _a = this.config,
      popup = _a.popup,
      forcePopupParentAsOffsetParent = _a.forcePopupParentAsOffsetParent;
    var _b = this.currentResizer,
      isTop = _b.isTop,
      isRight = _b.isRight,
      isBottom = _b.isBottom,
      isLeft = _b.isLeft;
    var isHorizontal = isRight || isLeft;
    var isVertical = isBottom || isTop;
    var _c = this.calculateMouseMovement({
        e: e,
        isLeft: isLeft,
        isTop: isTop
      }),
      movementX = _c.movementX,
      movementY = _c.movementY;
    var xPosition = this.position.x;
    var yPosition = this.position.y;
    var offsetLeft = 0;
    var offsetTop = 0;
    if (isHorizontal && movementX) {
      var direction = isLeft ? -1 : 1;
      var oldWidth = this.getWidth();
      var newWidth = oldWidth + movementX * direction;
      var skipWidth = false;
      if (isLeft) {
        offsetLeft = oldWidth - newWidth;
        if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
          skipWidth = true;
          offsetLeft = 0;
        }
      }
      if (!skipWidth) {
        this.setWidth(newWidth);
      }
    }
    if (isVertical && movementY) {
      var direction = isTop ? -1 : 1;
      var oldHeight = this.getHeight();
      var newHeight = oldHeight + movementY * direction;
      var skipHeight = false;
      if (isTop) {
        offsetTop = oldHeight - newHeight;
        if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
          skipHeight = true;
          offsetTop = 0;
        }
      } else {
        // do not let the size of all siblings be higher than the parent container
        if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) {
          skipHeight = true;
        }
      }
      if (!skipHeight) {
        this.setHeight(newHeight);
      }
    }
    this.updateDragStartPosition(e.clientX, e.clientY);
    if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) {
      this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
  };
  PositionableFeature.prototype.onResizeEnd = function (e, side) {
    this.isResizing = false;
    this.currentResizer = null;
    this.boundaryEl = null;
    var params = {
      type: 'resize',
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi()
    };
    removeCssClass(this.element, 'ag-resizing');
    removeCssClass(this.resizerMap[side].element, 'ag-active');
    this.dispatchEvent(params);
  };
  PositionableFeature.prototype.refreshSize = function () {
    var eGui = this.element;
    if (this.config.popup) {
      if (!this.config.width) {
        this.setWidth(eGui.offsetWidth);
      }
      if (!this.config.height) {
        this.setHeight(eGui.offsetHeight);
      }
    }
  };
  PositionableFeature.prototype.onMoveStart = function (e) {
    this.boundaryEl = this.findBoundaryElement();
    if (!this.positioned) {
      this.initialisePosition();
    }
    this.isMoving = true;
    addCssClass(this.element, 'ag-moving');
    this.updateDragStartPosition(e.clientX, e.clientY);
  };
  PositionableFeature.prototype.onMove = function (e) {
    if (!this.isMoving) {
      return;
    }
    var _a = this.position,
      x = _a.x,
      y = _a.y;
    var topBuffer;
    if (this.config.calculateTopBuffer) {
      topBuffer = this.config.calculateTopBuffer();
    }
    var _b = this.calculateMouseMovement({
        e: e,
        isTop: true,
        anywhereWithin: true,
        topBuffer: topBuffer
      }),
      movementX = _b.movementX,
      movementY = _b.movementY;
    this.offsetElement(x + movementX, y + movementY);
    this.updateDragStartPosition(e.clientX, e.clientY);
  };
  PositionableFeature.prototype.onMoveEnd = function () {
    this.isMoving = false;
    this.boundaryEl = null;
    removeCssClass(this.element, 'ag-moving');
  };
  PositionableFeature.prototype.setOffsetParent = function () {
    if (this.config.forcePopupParentAsOffsetParent) {
      this.offsetParent = this.popupService.getPopupParent();
    } else {
      this.offsetParent = this.element.offsetParent;
    }
  };
  PositionableFeature.prototype.findBoundaryElement = function () {
    var el = this.element;
    while (el) {
      if (window.getComputedStyle(el).position !== 'static') {
        return el;
      }
      el = el.parentElement;
    }
    return this.element;
  };
  PositionableFeature.prototype.clearResizeListeners = function () {
    while (this.resizeListeners.length) {
      var params = this.resizeListeners.pop();
      this.dragService.removeDragSource(params);
    }
  };
  PositionableFeature.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    if (this.moveElementDragListener) {
      this.dragService.removeDragSource(this.moveElementDragListener);
    }
    this.clearResizeListeners();
    this.removeResizers();
  };
  __decorate$1W([Autowired('popupService')], PositionableFeature.prototype, "popupService", void 0);
  __decorate$1W([Autowired('dragService')], PositionableFeature.prototype, "dragService", void 0);
  return PositionableFeature;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$28 = undefined && undefined.__extends || function () {
  var _extendStatics137 = function extendStatics(d, b) {
    _extendStatics137 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics137(d, b);
  };
  return function (d, b) {
    _extendStatics137(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1X = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgPanel = /** @class */function (_super) {
  __extends$28(AgPanel, _super);
  function AgPanel(config) {
    var _this = _super.call(this, AgPanel.getTemplate(config)) || this;
    _this.closable = true;
    _this.config = config;
    return _this;
  }
  AgPanel.getTemplate = function (config) {
    var cssIdentifier = config && config.cssIdentifier || 'default';
    return (/* html */"<div class=\"ag-panel ag-" + cssIdentifier + "-panel\" tabindex=\"-1\">\n            <div ref=\"eTitleBar\" class=\"ag-panel-title-bar ag-" + cssIdentifier + "-panel-title-bar ag-unselectable\">\n                <span ref=\"eTitle\" class=\"ag-panel-title-bar-title ag-" + cssIdentifier + "-panel-title-bar-title\"></span>\n                <div ref=\"eTitleBarButtons\" class=\"ag-panel-title-bar-buttons ag-" + cssIdentifier + "-panel-title-bar-buttons\"></div>\n            </div>\n            <div ref=\"eContentWrapper\" class=\"ag-panel-content-wrapper ag-" + cssIdentifier + "-panel-content-wrapper\"></div>\n        </div>"
    );
  };
  AgPanel.prototype.postConstruct = function () {
    var _this = this;
    var _a = this.config,
      component = _a.component,
      closable = _a.closable,
      hideTitleBar = _a.hideTitleBar,
      title = _a.title,
      _b = _a.minWidth,
      minWidth = _b === void 0 ? 250 : _b,
      width = _a.width,
      _c = _a.minHeight,
      minHeight = _c === void 0 ? 250 : _c,
      height = _a.height,
      centered = _a.centered,
      popup = _a.popup,
      x = _a.x,
      y = _a.y;
    this.positionableFeature = new PositionableFeature(this.getGui(), {
      minWidth: minWidth,
      width: width,
      minHeight: minHeight,
      height: height,
      centered: centered,
      x: x,
      y: y,
      popup: popup,
      calculateTopBuffer: function calculateTopBuffer() {
        return _this.positionableFeature.getHeight() - _this.getBodyHeight();
      }
    });
    this.createManagedBean(this.positionableFeature);
    var eGui = this.getGui();
    if (component) {
      this.setBodyComponent(component);
    }
    if (!hideTitleBar) {
      if (title) {
        this.setTitle(title);
      }
      this.setClosable(closable != null ? closable : this.closable);
    } else {
      addCssClass(this.eTitleBar, 'ag-hidden');
    }
    this.addManagedListener(this.eTitleBar, 'mousedown', function (e) {
      if (eGui.contains(e.relatedTarget) || eGui.contains(document.activeElement) || _this.eTitleBarButtons.contains(e.target)) {
        e.preventDefault();
        return;
      }
      var focusEl = _this.eContentWrapper.querySelector('button, [href], input, select, textarea, [tabindex]');
      if (focusEl) {
        focusEl.focus();
      }
    });
    if (popup && this.positionableFeature.isPositioned()) {
      return;
    }
    if (this.renderComponent) {
      this.renderComponent();
    }
    this.positionableFeature.initialisePosition();
    this.eContentWrapper.style.height = '0';
  };
  AgPanel.prototype.renderComponent = function () {
    var _this = this;
    var eGui = this.getGui();
    eGui.focus();
    this.close = function () {
      eGui.parentElement.removeChild(eGui);
      _this.destroy();
    };
  };
  AgPanel.prototype.getHeight = function () {
    return this.positionableFeature.getHeight();
  };
  AgPanel.prototype.setHeight = function (height) {
    this.positionableFeature.setHeight(height);
  };
  AgPanel.prototype.getWidth = function () {
    return this.positionableFeature.getWidth();
  };
  AgPanel.prototype.setWidth = function (width) {
    this.positionableFeature.setWidth(width);
  };
  AgPanel.prototype.setClosable = function (closable) {
    if (closable !== this.closable) {
      this.closable = closable;
    }
    if (closable) {
      var closeButtonComp = this.closeButtonComp = new Component(AgPanel.CLOSE_BTN_TEMPLATE);
      this.getContext().createBean(closeButtonComp);
      var eGui = closeButtonComp.getGui();
      eGui.appendChild(addCssClass(createIconNoSpan('close', this.gridOptionsWrapper), 'ag-panel-title-bar-button-icon'));
      this.addTitleBarButton(closeButtonComp);
      closeButtonComp.addManagedListener(eGui, 'click', this.onBtClose.bind(this));
    } else if (this.closeButtonComp) {
      var eGui = this.closeButtonComp.getGui();
      eGui.parentElement.removeChild(eGui);
      this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
  };
  AgPanel.prototype.setBodyComponent = function (bodyComponent) {
    bodyComponent.setParentComponent(this);
    this.eContentWrapper.appendChild(bodyComponent.getGui());
  };
  AgPanel.prototype.addTitleBarButton = function (button, position) {
    var eTitleBarButtons = this.eTitleBarButtons;
    var buttons = eTitleBarButtons.children;
    var len = buttons.length;
    if (position == null) {
      position = len;
    }
    position = Math.max(0, Math.min(position, len));
    var eGui = button.getGui();
    addCssClass(eGui, 'ag-panel-title-bar-button');
    if (position === 0) {
      eTitleBarButtons.insertAdjacentElement('afterbegin', eGui);
    } else if (position === len) {
      eTitleBarButtons.insertAdjacentElement('beforeend', eGui);
    } else {
      buttons[position - 1].insertAdjacentElement('afterend', eGui);
    }
    button.setParentComponent(this);
  };
  AgPanel.prototype.getBodyHeight = function () {
    return getInnerHeight(this.eContentWrapper);
  };
  AgPanel.prototype.getBodyWidth = function () {
    return getInnerWidth(this.eContentWrapper);
  };
  AgPanel.prototype.setTitle = function (title) {
    this.eTitle.innerText = title;
  };
  // called when user hits the 'x' in the top right
  AgPanel.prototype.onBtClose = function () {
    this.close();
  };
  AgPanel.prototype.destroy = function () {
    if (this.closeButtonComp) {
      this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
    var eGui = this.getGui();
    if (eGui && eGui.offsetParent) {
      this.close();
    }
    _super.prototype.destroy.call(this);
  };
  AgPanel.CLOSE_BTN_TEMPLATE = "<div class=\"ag-button\"></div>";
  __decorate$1X([RefSelector('eContentWrapper')], AgPanel.prototype, "eContentWrapper", void 0);
  __decorate$1X([RefSelector('eTitleBar')], AgPanel.prototype, "eTitleBar", void 0);
  __decorate$1X([RefSelector('eTitleBarButtons')], AgPanel.prototype, "eTitleBarButtons", void 0);
  __decorate$1X([RefSelector('eTitle')], AgPanel.prototype, "eTitle", void 0);
  __decorate$1X([PostConstruct], AgPanel.prototype, "postConstruct", null);
  return AgPanel;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$29 = undefined && undefined.__extends || function () {
  var _extendStatics138 = function extendStatics(d, b) {
    _extendStatics138 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics138(d, b);
  };
  return function (d, b) {
    _extendStatics138(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$d = undefined && undefined.__assign || function () {
  __assign$d = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$d.apply(this, arguments);
};
var __decorate$1Y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgDialog = /** @class */function (_super) {
  __extends$29(AgDialog, _super);
  function AgDialog(config) {
    var _this = _super.call(this, __assign$d(__assign$d({}, config), {
      popup: true
    })) || this;
    _this.isMaximizable = false;
    _this.isMaximized = false;
    _this.maximizeListeners = [];
    _this.resizeListenerDestroy = null;
    _this.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    return _this;
  }
  AgDialog.prototype.postConstruct = function () {
    var _this = this;
    var eGui = this.getGui();
    var _a = this.config,
      movable = _a.movable,
      resizable = _a.resizable,
      maximizable = _a.maximizable;
    addCssClass(eGui, 'ag-dialog');
    _super.prototype.postConstruct.call(this);
    this.addManagedListener(eGui, 'focusin', function (e) {
      if (eGui.contains(e.relatedTarget)) {
        return;
      }
      _this.popupService.bringPopupToFront(eGui);
    });
    if (movable) {
      this.setMovable(movable);
    }
    if (maximizable) {
      this.setMaximizable(maximizable);
    }
    if (resizable) {
      this.setResizable(resizable);
    }
  };
  AgDialog.prototype.renderComponent = function () {
    var eGui = this.getGui();
    var _a = this.config,
      alwaysOnTop = _a.alwaysOnTop,
      modal = _a.modal,
      title = _a.title;
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: modal,
      eChild: eGui,
      closeOnEsc: true,
      closedCallback: this.destroy.bind(this),
      alwaysOnTop: alwaysOnTop,
      ariaLabel: title || translate('ariaLabelDialog', 'Dialog')
    });
    if (addPopupRes) {
      this.close = addPopupRes.hideFunc;
    }
  };
  AgDialog.prototype.toggleMaximize = function () {
    var position = this.positionableFeature.getPosition();
    if (this.isMaximized) {
      var _a = this.lastPosition,
        x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
      this.setWidth(width);
      this.setHeight(height);
      this.positionableFeature.offsetElement(x, y);
    } else {
      this.lastPosition.width = this.getWidth();
      this.lastPosition.height = this.getHeight();
      this.lastPosition.x = position.x;
      this.lastPosition.y = position.y;
      this.positionableFeature.offsetElement(0, 0);
      this.setHeight('100%');
      this.setWidth('100%');
    }
    this.isMaximized = !this.isMaximized;
    this.refreshMaximizeIcon();
  };
  AgDialog.prototype.refreshMaximizeIcon = function () {
    setDisplayed(this.maximizeIcon, !this.isMaximized);
    setDisplayed(this.minimizeIcon, this.isMaximized);
  };
  AgDialog.prototype.clearMaximizebleListeners = function () {
    if (this.maximizeListeners.length) {
      this.maximizeListeners.forEach(function (destroyListener) {
        return destroyListener();
      });
      this.maximizeListeners.length = 0;
    }
    if (this.resizeListenerDestroy) {
      this.resizeListenerDestroy();
      this.resizeListenerDestroy = null;
    }
  };
  AgDialog.prototype.destroy = function () {
    this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
    this.clearMaximizebleListeners();
    _super.prototype.destroy.call(this);
  };
  AgDialog.prototype.setResizable = function (resizable) {
    this.positionableFeature.setResizable(resizable);
  };
  AgDialog.prototype.setMovable = function (movable) {
    this.positionableFeature.setMovable(movable, this.eTitleBar);
  };
  AgDialog.prototype.setMaximizable = function (maximizable) {
    var _this = this;
    if (!maximizable) {
      this.clearMaximizebleListeners();
      if (this.maximizeButtonComp) {
        this.destroyBean(this.maximizeButtonComp);
        this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = undefined;
      }
      return;
    }
    var eTitleBar = this.eTitleBar;
    if (!eTitleBar || maximizable === this.isMaximizable) {
      return;
    }
    var maximizeButtonComp = this.maximizeButtonComp = this.createBean(new Component( /* html */"<div class=\"ag-dialog-button\"></span>"));
    var eGui = maximizeButtonComp.getGui();
    eGui.appendChild(this.maximizeIcon = createIconNoSpan('maximize', this.gridOptionsWrapper));
    addCssClass(this.maximizeIcon, 'ag-panel-title-bar-button-icon');
    eGui.appendChild(this.minimizeIcon = createIconNoSpan('minimize', this.gridOptionsWrapper));
    addCssClass(this.minimizeIcon, 'ag-panel-title-bar-button-icon');
    addCssClass(this.minimizeIcon, 'ag-hidden');
    maximizeButtonComp.addManagedListener(eGui, 'click', this.toggleMaximize.bind(this));
    this.addTitleBarButton(maximizeButtonComp, 0);
    this.maximizeListeners.push(this.addManagedListener(eTitleBar, 'dblclick', this.toggleMaximize.bind(this)));
    this.resizeListenerDestroy = this.addManagedListener(this, 'resize', function () {
      _this.isMaximized = false;
      _this.refreshMaximizeIcon();
    });
  };
  __decorate$1Y([Autowired('popupService')], AgDialog.prototype, "popupService", void 0);
  return AgDialog;
}(AgPanel);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2a = undefined && undefined.__extends || function () {
  var _extendStatics139 = function extendStatics(d, b) {
    _extendStatics139 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics139(d, b);
  };
  return function (d, b) {
    _extendStatics139(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgInputTextField = /** @class */function (_super) {
  __extends$2a(AgInputTextField, _super);
  function AgInputTextField(config, className, inputType) {
    if (className === void 0) {
      className = 'ag-text-field';
    }
    if (inputType === void 0) {
      inputType = 'text';
    }
    return _super.call(this, config, className, inputType) || this;
  }
  AgInputTextField.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    if (this.config.allowedCharPattern) {
      this.preventDisallowedCharacters();
    }
  };
  AgInputTextField.prototype.setValue = function (value, silent) {
    var ret = _super.prototype.setValue.call(this, value, silent);
    if (this.eInput.value !== value) {
      this.eInput.value = exists(value) ? value : '';
    }
    return ret;
  };
  AgInputTextField.prototype.preventDisallowedCharacters = function () {
    var pattern = new RegExp("[" + this.config.allowedCharPattern + "]");
    var preventDisallowedCharacters = function preventDisallowedCharacters(event) {
      if (event.key && !pattern.test(event.key)) {
        event.preventDefault();
      }
    };
    this.addManagedListener(this.eInput, 'keypress', preventDisallowedCharacters);
    this.addManagedListener(this.eInput, 'paste', function (e) {
      var text = e.clipboardData.getData('text');
      if (some(text, function (c) {
        return !pattern.test(c);
      })) {
        e.preventDefault();
      }
    });
  };
  return AgInputTextField;
}(AgAbstractInputField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2b = undefined && undefined.__extends || function () {
  var _extendStatics140 = function extendStatics(d, b) {
    _extendStatics140 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics140(d, b);
  };
  return function (d, b) {
    _extendStatics140(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgInputTextArea = /** @class */function (_super) {
  __extends$2b(AgInputTextArea, _super);
  function AgInputTextArea(config) {
    return _super.call(this, config, 'ag-text-area', null, 'textarea') || this;
  }
  AgInputTextArea.prototype.setValue = function (value, silent) {
    var ret = _super.prototype.setValue.call(this, value, silent);
    this.eInput.value = value;
    return ret;
  };
  AgInputTextArea.prototype.setCols = function (cols) {
    this.eInput.cols = cols;
    return this;
  };
  AgInputTextArea.prototype.setRows = function (rows) {
    this.eInput.rows = rows;
    return this;
  };
  return AgInputTextArea;
}(AgAbstractInputField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2c = undefined && undefined.__extends || function () {
  var _extendStatics141 = function extendStatics(d, b) {
    _extendStatics141 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics141(d, b);
  };
  return function (d, b) {
    _extendStatics141(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1Z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgSlider = /** @class */function (_super) {
  __extends$2c(AgSlider, _super);
  function AgSlider(config) {
    var _this = _super.call(this, config, AgSlider.TEMPLATE) || this;
    _this.labelAlignment = 'top';
    return _this;
  }
  AgSlider.prototype.init = function () {
    addCssClass(this.eSlider.getGui(), 'ag-slider-field');
  };
  AgSlider.prototype.onValueChange = function (callbackFn) {
    var _this = this;
    var eventChanged = AgAbstractField.EVENT_CHANGED;
    this.addManagedListener(this.eText, eventChanged, function () {
      var textValue = parseFloat(_this.eText.getValue());
      _this.eSlider.setValue(textValue.toString(), true);
      callbackFn(textValue || 0);
    });
    this.addManagedListener(this.eSlider, eventChanged, function () {
      var sliderValue = _this.eSlider.getValue();
      _this.eText.setValue(sliderValue, true);
      callbackFn(parseFloat(sliderValue));
    });
    return this;
  };
  AgSlider.prototype.setSliderWidth = function (width) {
    this.eSlider.setWidth(width);
    return this;
  };
  AgSlider.prototype.setTextFieldWidth = function (width) {
    this.eText.setWidth(width);
    return this;
  };
  AgSlider.prototype.setMinValue = function (minValue) {
    this.eSlider.setMinValue(minValue);
    this.eText.setMin(minValue);
    return this;
  };
  AgSlider.prototype.setMaxValue = function (maxValue) {
    this.eSlider.setMaxValue(maxValue);
    this.eText.setMax(maxValue);
    return this;
  };
  AgSlider.prototype.getValue = function () {
    return this.eText.getValue();
  };
  AgSlider.prototype.setValue = function (value) {
    if (this.getValue() === value) {
      return this;
    }
    this.eText.setValue(value, true);
    this.eSlider.setValue(value, true);
    this.dispatchEvent({
      type: AgAbstractField.EVENT_CHANGED
    });
    return this;
  };
  AgSlider.prototype.setStep = function (step) {
    this.eSlider.setStep(step);
    this.eText.setStep(step);
    return this;
  };
  AgSlider.TEMPLATE = "<div class=\"ag-slider\">\n            <label ref=\"eLabel\"></label>\n            <div class=\"ag-wrapper ag-slider-wrapper\">\n                <ag-input-range ref=\"eSlider\"></ag-input-range>\n                <ag-input-number-field ref=\"eText\"></ag-input-number-field>\n            </div>\n        </div>";
  __decorate$1Z([RefSelector('eLabel')], AgSlider.prototype, "eLabel", void 0);
  __decorate$1Z([RefSelector('eSlider')], AgSlider.prototype, "eSlider", void 0);
  __decorate$1Z([RefSelector('eText')], AgSlider.prototype, "eText", void 0);
  __decorate$1Z([PostConstruct], AgSlider.prototype, "init", null);
  return AgSlider;
}(AgAbstractLabel);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2d = undefined && undefined.__extends || function () {
  var _extendStatics142 = function extendStatics(d, b) {
    _extendStatics142 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics142(d, b);
  };
  return function (d, b) {
    _extendStatics142(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1_ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgColorPanel = /** @class */function (_super) {
  __extends$2d(AgColorPanel, _super);
  function AgColorPanel(config) {
    var _this = _super.call(this, AgColorPanel.TEMPLATE) || this;
    _this.H = 1; // in the [0, 1] range
    _this.S = 1; // in the [0, 1] range
    _this.B = 1; // in the [0, 1] range
    _this.A = 1; // in the [0, 1] range
    _this.isSpectrumDragging = false;
    _this.isSpectrumHueDragging = false;
    _this.isSpectrumAlphaDragging = false;
    _this.colorChanged = false;
    _this.picker = config.picker;
    return _this;
  }
  AgColorPanel.prototype.postConstruct = function () {
    var eGui = this.getGui();
    this.initRecentColors();
    this.addManagedListener(this.spectrumVal, 'mousedown', this.onSpectrumDraggerDown.bind(this));
    this.addManagedListener(eGui, 'mousemove', this.onSpectrumDraggerMove.bind(this));
    this.addManagedListener(this.spectrumHue, 'mousedown', this.onSpectrumHueDown.bind(this));
    this.addManagedListener(eGui, 'mousemove', this.onSpectrumHueMove.bind(this));
    this.addManagedListener(this.spectrumAlpha, 'mousedown', this.onSpectrumAlphaDown.bind(this));
    this.addManagedListener(eGui, 'mousemove', this.onSpectrumAlphaMove.bind(this));
    // Listening to `mouseup` on the document on purpose. The user might release the mouse button
    // outside the UI control. When the mouse returns back to the control's area, the dragging
    // of the thumb is not expected and seen as a bug.
    this.addManagedListener(document, 'mouseup', this.onMouseUp.bind(this));
    this.addManagedListener(this.recentColors, 'click', this.onRecentColorClick.bind(this));
  };
  AgColorPanel.prototype.refreshSpectrumRect = function () {
    return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
  };
  AgColorPanel.prototype.refreshHueRect = function () {
    return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
  };
  AgColorPanel.prototype.refreshAlphaRect = function () {
    return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
  };
  AgColorPanel.prototype.onSpectrumDraggerDown = function (e) {
    this.refreshSpectrumRect();
    this.isSpectrumDragging = true;
    this.moveDragger(e);
  };
  AgColorPanel.prototype.onSpectrumDraggerMove = function (e) {
    if (this.isSpectrumDragging) {
      this.moveDragger(e);
    }
  };
  AgColorPanel.prototype.onSpectrumHueDown = function (e) {
    this.refreshHueRect();
    this.isSpectrumHueDragging = true;
    this.moveHueSlider(e);
  };
  AgColorPanel.prototype.onSpectrumHueMove = function (e) {
    if (this.isSpectrumHueDragging) {
      this.moveHueSlider(e);
    }
  };
  AgColorPanel.prototype.onSpectrumAlphaDown = function (e) {
    this.refreshAlphaRect();
    this.isSpectrumAlphaDragging = true;
    this.moveAlphaSlider(e);
  };
  AgColorPanel.prototype.onSpectrumAlphaMove = function (e) {
    if (this.isSpectrumAlphaDragging) {
      this.moveAlphaSlider(e);
    }
  };
  AgColorPanel.prototype.onMouseUp = function () {
    this.isSpectrumDragging = false;
    this.isSpectrumHueDragging = false;
    this.isSpectrumAlphaDragging = false;
  };
  AgColorPanel.prototype.moveDragger = function (e) {
    var valRect = this.spectrumValRect;
    if (valRect) {
      var x = e.clientX - valRect.left;
      var y = e.clientY - valRect.top;
      x = Math.max(x, 0);
      x = Math.min(x, valRect.width);
      y = Math.max(y, 0);
      y = Math.min(y, valRect.height);
      this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
    }
  };
  AgColorPanel.prototype.moveHueSlider = function (e) {
    var hueRect = this.spectrumHueRect;
    if (hueRect) {
      var slider = this.spectrumHueSlider;
      var sliderRect = slider.getBoundingClientRect();
      var x = e.clientX - hueRect.left;
      x = Math.max(x, 0);
      x = Math.min(x, hueRect.width);
      this.H = 1 - x / hueRect.width;
      slider.style.left = x + sliderRect.width / 2 + 'px';
      this.update();
    }
  };
  AgColorPanel.prototype.moveAlphaSlider = function (e) {
    var alphaRect = this.spectrumAlphaRect;
    if (alphaRect) {
      var slider = this.spectrumAlphaSlider;
      var sliderRect = slider.getBoundingClientRect();
      var x = e.clientX - alphaRect.left;
      x = Math.max(x, 0);
      x = Math.min(x, alphaRect.width);
      this.A = x / alphaRect.width;
      slider.style.left = x + sliderRect.width / 2 + 'px';
      this.update();
    }
  };
  AgColorPanel.prototype.update = function () {
    var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
    var spectrumColor = Color.fromHSB(this.H * 360, 1, 1);
    var rgbaColor = color.toRgbaString();
    // the recent color list needs to know color has actually changed
    var colorPicker = this.picker;
    var existingColor = Color.fromString(colorPicker.getValue());
    if (existingColor.toRgbaString() !== rgbaColor) {
      this.colorChanged = true;
    }
    colorPicker.setValue(rgbaColor);
    this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
    this.spectrumDragger.style.backgroundColor = rgbaColor;
  };
  /**
   * @param saturation In the [0, 1] interval.
   * @param brightness In the [0, 1] interval.
   */
  AgColorPanel.prototype.setSpectrumValue = function (saturation, brightness) {
    var valRect = this.spectrumValRect || this.refreshSpectrumRect();
    if (valRect) {
      var dragger = this.spectrumDragger;
      var draggerRect = dragger.getBoundingClientRect();
      saturation = Math.max(0, saturation);
      saturation = Math.min(1, saturation);
      brightness = Math.max(0, brightness);
      brightness = Math.min(1, brightness);
      this.S = saturation;
      this.B = brightness;
      dragger.style.left = saturation * valRect.width - draggerRect.width / 2 + 'px';
      dragger.style.top = (1 - brightness) * valRect.height - draggerRect.height / 2 + 'px';
      this.update();
    }
  };
  AgColorPanel.prototype.initRecentColors = function () {
    var recentColors = AgColorPanel.recentColors;
    var innerHtml = recentColors.map(function (color, index) {
      return "<div class=\"ag-recent-color\" id=" + index + " style=\"background-color: " + color + "; width: 15px; height: 15px;\" recent-color=\"" + color + "\"></div>";
    });
    this.recentColors.innerHTML = innerHtml.join('');
  };
  AgColorPanel.prototype.setValue = function (val) {
    var color = Color.fromString(val);
    var _a = color.toHSB(),
      h = _a[0],
      s = _a[1],
      b = _a[2];
    this.H = (isNaN(h) ? 0 : h) / 360;
    this.A = color.a;
    var spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
    var spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
    this.spectrumHueSlider.style.left = (this.H - 1) * -spectrumHueRect.width + "px";
    this.spectrumAlphaSlider.style.left = this.A * spectrumAlphaRect.width + "px";
    this.setSpectrumValue(s, b);
  };
  AgColorPanel.prototype.onRecentColorClick = function (e) {
    var target = e.target;
    if (!exists(target.id)) {
      return;
    }
    var id = parseInt(target.id, 10);
    this.setValue(AgColorPanel.recentColors[id]);
    this.destroy();
  };
  AgColorPanel.prototype.addRecentColor = function () {
    var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
    var rgbaColor = color.toRgbaString();
    var recentColors = AgColorPanel.recentColors;
    if (!this.colorChanged || recentColors[0] === rgbaColor) {
      return;
    }
    // remove duplicate color
    recentColors = recentColors.filter(function (currentColor) {
      return currentColor != rgbaColor;
    });
    // add color to head
    recentColors = [rgbaColor].concat(recentColors);
    // ensure we don't exceed max number of recent colors
    if (recentColors.length > AgColorPanel.maxRecentColors) {
      recentColors = recentColors.slice(0, AgColorPanel.maxRecentColors);
    }
    AgColorPanel.recentColors = recentColors;
  };
  AgColorPanel.prototype.destroy = function () {
    this.addRecentColor();
    _super.prototype.destroy.call(this);
  };
  AgColorPanel.maxRecentColors = 8;
  AgColorPanel.recentColors = [];
  AgColorPanel.TEMPLATE = "<div class=\"ag-color-panel\">\n            <div ref=\"spectrumColor\" class=\"ag-spectrum-color\">\n                <div class=\"ag-spectrum-sat ag-spectrum-fill\">\n                    <div ref=\"spectrumVal\" class=\"ag-spectrum-val ag-spectrum-fill\">\n                        <div ref=\"spectrumDragger\" class=\"ag-spectrum-dragger\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"ag-spectrum-tools\">\n                <div ref=\"spectrumHue\" class=\"ag-spectrum-hue ag-spectrum-tool\">\n                    <div class=\"ag-spectrum-hue-background\"></div>\n                    <div ref=\"spectrumHueSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"spectrumAlpha\" class=\"ag-spectrum-alpha ag-spectrum-tool\">\n                    <div class=\"ag-spectrum-alpha-background\"></div>\n                    <div ref=\"spectrumAlphaSlider\" class=\"ag-spectrum-slider\"></div>\n                </div>\n                <div ref=\"recentColors\" class=\"ag-recent-colors\"></div>\n            </div>\n        </div>";
  __decorate$1_([RefSelector('spectrumColor')], AgColorPanel.prototype, "spectrumColor", void 0);
  __decorate$1_([RefSelector('spectrumVal')], AgColorPanel.prototype, "spectrumVal", void 0);
  __decorate$1_([RefSelector('spectrumDragger')], AgColorPanel.prototype, "spectrumDragger", void 0);
  __decorate$1_([RefSelector('spectrumHue')], AgColorPanel.prototype, "spectrumHue", void 0);
  __decorate$1_([RefSelector('spectrumHueSlider')], AgColorPanel.prototype, "spectrumHueSlider", void 0);
  __decorate$1_([RefSelector('spectrumAlpha')], AgColorPanel.prototype, "spectrumAlpha", void 0);
  __decorate$1_([RefSelector('spectrumAlphaSlider')], AgColorPanel.prototype, "spectrumAlphaSlider", void 0);
  __decorate$1_([RefSelector('recentColors')], AgColorPanel.prototype, "recentColors", void 0);
  __decorate$1_([PostConstruct], AgColorPanel.prototype, "postConstruct", null);
  return AgColorPanel;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2e = undefined && undefined.__extends || function () {
  var _extendStatics143 = function extendStatics(d, b) {
    _extendStatics143 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics143(d, b);
  };
  return function (d, b) {
    _extendStatics143(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgColorPicker = /** @class */function (_super) {
  __extends$2e(AgColorPicker, _super);
  function AgColorPicker(config) {
    var _this = _super.call(this, config, 'ag-color-picker', 'colorPicker') || this;
    if (config && config.color) {
      _this.value = config.color;
    }
    return _this;
  }
  AgColorPicker.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    if (this.value) {
      this.setValue(this.value);
    }
  };
  AgColorPicker.prototype.showPicker = function () {
    var _this = this;
    var eGuiRect = this.getGui().getBoundingClientRect();
    var colorDialog = this.createBean(new AgDialog({
      closable: false,
      modal: true,
      hideTitleBar: true,
      minWidth: 190,
      width: 190,
      height: 250,
      x: eGuiRect.right - 190,
      y: eGuiRect.top - 250
    }));
    this.isPickerDisplayed = true;
    addCssClass(colorDialog.getGui(), 'ag-color-dialog');
    var colorPanel = this.createBean(new AgColorPanel({
      picker: this
    }));
    colorPanel.addDestroyFunc(function () {
      if (colorDialog.isAlive()) {
        _this.destroyBean(colorDialog);
      }
    });
    colorDialog.setParentComponent(this);
    colorDialog.setBodyComponent(colorPanel);
    colorPanel.setValue(this.getValue());
    colorDialog.addDestroyFunc(function () {
      // here we check if the picker was already being
      // destroyed to avoid a stack overflow
      if (!_this.isDestroyingPicker) {
        _this.isDestroyingPicker = true;
        if (colorPanel.isAlive()) {
          _this.destroyBean(colorPanel);
        }
      } else {
        _this.isDestroyingPicker = false;
      }
      if (_this.isAlive()) {
        _this.getFocusableElement().focus();
      }
      _this.isPickerDisplayed = false;
    });
    return colorDialog;
  };
  AgColorPicker.prototype.setValue = function (color) {
    if (this.value === color) {
      return this;
    }
    this.eDisplayField.style.backgroundColor = color;
    return _super.prototype.setValue.call(this, color);
  };
  AgColorPicker.prototype.getValue = function () {
    return this.value;
  };
  return AgColorPicker;
}(AgPickerField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2f = undefined && undefined.__extends || function () {
  var _extendStatics144 = function extendStatics(d, b) {
    _extendStatics144 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics144(d, b);
  };
  return function (d, b) {
    _extendStatics144(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgInputNumberField = /** @class */function (_super) {
  __extends$2f(AgInputNumberField, _super);
  function AgInputNumberField(config) {
    return _super.call(this, config, 'ag-number-field', 'number') || this;
  }
  AgInputNumberField.prototype.postConstruct = function () {
    var _this = this;
    _super.prototype.postConstruct.call(this);
    this.addManagedListener(this.eInput, 'blur', function () {
      var floatedValue = parseFloat(_this.eInput.value);
      var value = isNaN(floatedValue) ? '' : _this.normalizeValue(floatedValue.toString());
      if (_this.value !== value) {
        _this.setValue(value);
      }
    });
  };
  AgInputNumberField.prototype.normalizeValue = function (value) {
    if (value === '') {
      return '';
    }
    if (this.precision) {
      value = this.adjustPrecision(value);
    }
    var val = parseFloat(value);
    if (this.min != null && val < this.min) {
      value = this.min.toString();
    } else if (this.max != null && val > this.max) {
      value = this.max.toString();
    }
    return value;
  };
  AgInputNumberField.prototype.adjustPrecision = function (value) {
    if (this.precision) {
      var floatString = parseFloat(value).toFixed(this.precision);
      value = parseFloat(floatString).toString();
    }
    return value;
  };
  AgInputNumberField.prototype.setMin = function (min) {
    if (this.min === min) {
      return this;
    }
    this.min = min;
    addOrRemoveAttribute(this.eInput, 'min', min);
    return this;
  };
  AgInputNumberField.prototype.setMax = function (max) {
    if (this.max === max) {
      return this;
    }
    this.max = max;
    addOrRemoveAttribute(this.eInput, 'max', max);
    return this;
  };
  AgInputNumberField.prototype.setPrecision = function (precision) {
    this.precision = precision;
    return this;
  };
  AgInputNumberField.prototype.setStep = function (step) {
    if (this.step === step) {
      return this;
    }
    this.step = step;
    addOrRemoveAttribute(this.eInput, 'step', step);
    return this;
  };
  AgInputNumberField.prototype.setValue = function (value, silent) {
    value = this.adjustPrecision(value);
    var normalizedValue = this.normalizeValue(value);
    if (value != normalizedValue) {
      return this;
    }
    return _super.prototype.setValue.call(this, value, silent);
  };
  return AgInputNumberField;
}(AgInputTextField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2g = undefined && undefined.__extends || function () {
  var _extendStatics145 = function extendStatics(d, b) {
    _extendStatics145 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics145(d, b);
  };
  return function (d, b) {
    _extendStatics145(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgInputRange = /** @class */function (_super) {
  __extends$2g(AgInputRange, _super);
  function AgInputRange(config) {
    return _super.call(this, config, 'ag-range-field', 'range') || this;
  }
  AgInputRange.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    var _a = this.config,
      min = _a.min,
      max = _a.max,
      step = _a.step;
    if (min != null) {
      this.setMinValue(min);
    }
    if (max != null) {
      this.setMaxValue(max);
    }
    this.setStep(step || 1);
  };
  AgInputRange.prototype.addInputListeners = function () {
    var _this = this;
    var isIE = isBrowserIE();
    var eventName = isIE ? 'change' : 'input';
    this.addManagedListener(this.eInput, eventName, function (e) {
      var value = e.target.value;
      _this.setValue(value);
    });
  };
  AgInputRange.prototype.setMinValue = function (value) {
    this.min = value;
    this.eInput.setAttribute('min', value.toString());
    return this;
  };
  AgInputRange.prototype.setMaxValue = function (value) {
    this.max = value;
    this.eInput.setAttribute('max', value.toString());
    return this;
  };
  AgInputRange.prototype.setStep = function (value) {
    this.eInput.setAttribute('step', value.toString());
    return this;
  };
  AgInputRange.prototype.setValue = function (value, silent) {
    if (this.min != null) {
      value = Math.max(parseFloat(value), this.min).toString();
    }
    if (this.max != null) {
      value = Math.min(parseFloat(value), this.max).toString();
    }
    var ret = _super.prototype.setValue.call(this, value, silent);
    this.eInput.value = value;
    return ret;
  };
  return AgInputRange;
}(AgAbstractInputField);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2h = undefined && undefined.__extends || function () {
  var _extendStatics146 = function extendStatics(d, b) {
    _extendStatics146 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics146(d, b);
  };
  return function (d, b) {
    _extendStatics146(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$1$ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AgAngleSelect = /** @class */function (_super) {
  __extends$2h(AgAngleSelect, _super);
  function AgAngleSelect(config) {
    var _this = _super.call(this, config, AgAngleSelect.TEMPLATE) || this;
    _this.radius = 0;
    _this.offsetX = 0;
    _this.offsetY = 0;
    return _this;
  }
  AgAngleSelect.prototype.postConstruct = function () {
    var _this = this;
    _super.prototype.postConstruct.call(this);
    this.dragListener = {
      eElement: this.eParentCircle,
      dragStartPixels: 0,
      onDragStart: function onDragStart(e) {
        _this.parentCircleRect = _this.eParentCircle.getBoundingClientRect();
      },
      onDragging: function onDragging(e) {
        return _this.calculateAngleDrag(e);
      },
      onDragStop: function onDragStop() {}
    };
    this.dragService.addDragSource(this.dragListener);
    this.eAngleValue.setLabel('').setLabelWidth(5).setInputWidth(45).setMin(0).setMax(360).setValue("" + this.degrees).onValueChange(function (value) {
      if (value == null || value === '') {
        value = '0';
      }
      value = _this.eAngleValue.normalizeValue(value);
      var floatValue = parseFloat(value);
      if (floatValue > 180) {
        floatValue = floatValue - 360;
      }
      _this.setValue(floatValue);
    });
    this.updateNumberInput();
    if (exists(this.getValue())) {
      this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
    }
    this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () {
      if (_this.eAngleValue.getInputElement().contains(document.activeElement)) {
        return;
      }
      _this.updateNumberInput();
    });
  };
  AgAngleSelect.prototype.updateNumberInput = function () {
    var normalizedValue = this.normalizeNegativeValue(this.getValue());
    this.eAngleValue.setValue(normalizedValue.toString());
  };
  AgAngleSelect.prototype.positionChildCircle = function (radians) {
    var rect = this.parentCircleRect || {
      width: 24,
      height: 24
    };
    var eChildCircle = this.eChildCircle;
    var centerX = rect.width / 2;
    var centerY = rect.height / 2;
    eChildCircle.style.left = centerX + Math.cos(radians) * 8 + "px";
    eChildCircle.style.top = centerY + Math.sin(radians) * 8 + "px";
  };
  AgAngleSelect.prototype.calculatePolar = function () {
    var x = this.offsetX;
    var y = this.offsetY;
    var radians = Math.atan2(y, x);
    this.degrees = this.toDegrees(radians);
    this.radius = Math.sqrt(x * x + y * y);
    this.positionChildCircle(radians);
  };
  AgAngleSelect.prototype.calculateCartesian = function () {
    var radians = this.toRadians(this.getValue());
    var radius = this.getRadius();
    this.setOffsetX(Math.cos(radians) * radius).setOffsetY(Math.sin(radians) * radius);
  };
  AgAngleSelect.prototype.setOffsetX = function (offset) {
    if (this.offsetX !== offset) {
      this.offsetX = offset;
      this.calculatePolar();
    }
    return this;
  };
  AgAngleSelect.prototype.setOffsetY = function (offset) {
    if (this.offsetY !== offset) {
      this.offsetY = offset;
      this.calculatePolar();
    }
    return this;
  };
  AgAngleSelect.prototype.calculateAngleDrag = function (e) {
    var rect = this.parentCircleRect;
    var centerX = rect.width / 2;
    var centerY = rect.height / 2;
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var dx = x - centerX;
    var dy = y - centerY;
    var radians = Math.atan2(dy, dx);
    this.setValue(radians, true);
  };
  AgAngleSelect.prototype.toDegrees = function (radians) {
    return radians / Math.PI * 180;
  };
  AgAngleSelect.prototype.toRadians = function (degrees) {
    return degrees / 180 * Math.PI;
  };
  AgAngleSelect.prototype.normalizeNegativeValue = function (degrees) {
    return degrees < 0 ? 360 + degrees : degrees;
  };
  AgAngleSelect.prototype.normalizeAngle180 = function (radians) {
    radians %= Math.PI * 2;
    if (radians < -Math.PI) {
      radians += Math.PI * 2;
    } else if (radians >= Math.PI) {
      radians -= Math.PI * 2;
    }
    return radians;
  };
  AgAngleSelect.prototype.getRadius = function () {
    return this.radius;
  };
  AgAngleSelect.prototype.setRadius = function (r) {
    if (this.radius === r) {
      return this;
    }
    this.radius = r;
    this.calculateCartesian();
    return this;
  };
  AgAngleSelect.prototype.onValueChange = function (callbackFn) {
    var _this = this;
    this.addManagedListener(this, AgAbstractField.EVENT_CHANGED, function () {
      callbackFn(_this.degrees);
    });
    return this;
  };
  AgAngleSelect.prototype.getValue = function (radians) {
    return radians ? this.toRadians(this.degrees) : this.degrees;
  };
  AgAngleSelect.prototype.setValue = function (degrees, radians) {
    var radiansValue;
    if (!radians) {
      radiansValue = this.normalizeAngle180(this.toRadians(degrees));
    } else {
      radiansValue = degrees;
    }
    degrees = this.toDegrees(radiansValue);
    if (this.degrees !== degrees) {
      this.degrees = Math.floor(degrees);
      this.calculateCartesian();
      this.positionChildCircle(radiansValue);
      this.dispatchEvent({
        type: AgAbstractField.EVENT_CHANGED
      });
    }
    return this;
  };
  AgAngleSelect.prototype.setWidth = function (width) {
    setFixedWidth(this.getGui(), width);
    return this;
  };
  AgAngleSelect.prototype.destroy = function () {
    this.dragService.removeDragSource(this.dragListener);
    _super.prototype.destroy.call(this);
  };
  AgAngleSelect.TEMPLATE = "<div class=\"ag-angle-select\">\n            <div ref=\"eLabel\"></div>\n            <div class=\"ag-wrapper ag-angle-select-wrapper\">\n                <div ref=\"eAngleSelectField\" class=\"ag-angle-select-field\">\n                    <div ref=\"eParentCircle\" class=\"ag-angle-select-parent-circle\">\n                        <div ref=\"eChildCircle\" class=\"ag-angle-select-child-circle\"></div>\n                    </div>\n                </div>\n                <ag-input-number-field ref=\"eAngleValue\"></ag-input-number-field>\n            </div>\n        </div>";
  __decorate$1$([RefSelector('eLabel')], AgAngleSelect.prototype, "eLabel", void 0);
  __decorate$1$([RefSelector('eParentCircle')], AgAngleSelect.prototype, "eParentCircle", void 0);
  __decorate$1$([RefSelector('eChildCircle')], AgAngleSelect.prototype, "eChildCircle", void 0);
  __decorate$1$([RefSelector('eAngleValue')], AgAngleSelect.prototype, "eAngleValue", void 0);
  __decorate$1$([Autowired('dragService')], AgAngleSelect.prototype, "dragService", void 0);
  return AgAngleSelect;
}(AgAbstractLabel);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2i = undefined && undefined.__extends || function () {
  var _extendStatics147 = function extendStatics(d, b) {
    _extendStatics147 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics147(d, b);
  };
  return function (d, b) {
    _extendStatics147(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var AgToggleButton = /** @class */function (_super) {
  __extends$2i(AgToggleButton, _super);
  function AgToggleButton(config) {
    return _super.call(this, config, 'ag-toggle-button') || this;
  }
  AgToggleButton.prototype.setValue = function (value, silent) {
    _super.prototype.setValue.call(this, value, silent);
    addOrRemoveCssClass(this.getGui(), 'ag-selected', this.getValue());
    return this;
  };
  return AgToggleButton;
}(AgCheckbox);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2j = undefined && undefined.__extends || function () {
  var _extendStatics148 = function extendStatics(d, b) {
    _extendStatics148 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics148(d, b);
  };
  return function (d, b) {
    _extendStatics148(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$20 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowPositionUtils = /** @class */function (_super) {
  __extends$2j(RowPositionUtils, _super);
  function RowPositionUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RowPositionUtils.prototype.getFirstRow = function () {
    var rowIndex = 0;
    var rowPinned;
    if (this.pinnedRowModel.getPinnedTopRowCount()) {
      rowPinned = Constants.PINNED_TOP;
    } else if (this.rowModel.getRowCount()) {
      rowPinned = null;
      rowIndex = this.paginationProxy.getPageFirstRow();
    } else if (this.pinnedRowModel.getPinnedBottomRowCount()) {
      rowPinned = Constants.PINNED_BOTTOM;
    }
    return rowPinned === undefined ? null : {
      rowIndex: rowIndex,
      rowPinned: rowPinned
    };
  };
  RowPositionUtils.prototype.getLastRow = function () {
    var rowIndex;
    var rowPinned = null;
    var pinnedBottomCount = this.pinnedRowModel.getPinnedBottomRowCount();
    var pinnedTopCount = this.pinnedRowModel.getPinnedTopRowCount();
    if (pinnedBottomCount) {
      rowPinned = Constants.PINNED_BOTTOM;
      rowIndex = pinnedBottomCount - 1;
    } else if (this.rowModel.getRowCount()) {
      rowPinned = null;
      rowIndex = this.paginationProxy.getPageLastRow();
    } else if (pinnedTopCount) {
      rowPinned = Constants.PINNED_TOP;
      rowIndex = pinnedTopCount - 1;
    }
    return rowIndex === undefined ? null : {
      rowIndex: rowIndex,
      rowPinned: rowPinned
    };
  };
  RowPositionUtils.prototype.getRowNode = function (gridRow) {
    switch (gridRow.rowPinned) {
      case Constants.PINNED_TOP:
        return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
      case Constants.PINNED_BOTTOM:
        return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
      default:
        return this.rowModel.getRow(gridRow.rowIndex);
    }
  };
  RowPositionUtils.prototype.sameRow = function (rowA, rowB) {
    // if both missing
    if (!rowA && !rowB) {
      return true;
    }
    // if only one missing
    if (rowA && !rowB || !rowA && rowB) {
      return false;
    }
    // otherwise compare (use == to compare rowPinned because it can be null or undefined)
    return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
  };
  // tests if this row selection is before the other row selection
  RowPositionUtils.prototype.before = function (rowA, rowB) {
    switch (rowA.rowPinned) {
      case Constants.PINNED_TOP:
        // we we are floating top, and other isn't, then we are always before
        if (rowB.rowPinned !== Constants.PINNED_TOP) {
          return true;
        }
        break;
      case Constants.PINNED_BOTTOM:
        // if we are floating bottom, and the other isn't, then we are never before
        if (rowB.rowPinned !== Constants.PINNED_BOTTOM) {
          return false;
        }
        break;
      default:
        // if we are not floating, but the other one is floating...
        if (exists(rowB.rowPinned)) {
          return rowB.rowPinned !== Constants.PINNED_TOP;
        }
        break;
    }
    return rowA.rowIndex < rowB.rowIndex;
  };
  __decorate$20([Autowired('rowModel')], RowPositionUtils.prototype, "rowModel", void 0);
  __decorate$20([Autowired('pinnedRowModel')], RowPositionUtils.prototype, "pinnedRowModel", void 0);
  __decorate$20([Autowired('paginationProxy')], RowPositionUtils.prototype, "paginationProxy", void 0);
  RowPositionUtils = __decorate$20([Bean('rowPositionUtils')], RowPositionUtils);
  return RowPositionUtils;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2k = undefined && undefined.__extends || function () {
  var _extendStatics149 = function extendStatics(d, b) {
    _extendStatics149 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics149(d, b);
  };
  return function (d, b) {
    _extendStatics149(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$21 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CellPositionUtils = /** @class */function (_super) {
  __extends$2k(CellPositionUtils, _super);
  function CellPositionUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CellPositionUtils.prototype.createId = function (cellPosition) {
    var rowIndex = cellPosition.rowIndex,
      rowPinned = cellPosition.rowPinned,
      column = cellPosition.column;
    return this.createIdFromValues(rowIndex, column, rowPinned);
  };
  CellPositionUtils.prototype.createIdFromValues = function (rowIndex, column, rowPinned) {
    return rowIndex + "." + (rowPinned == null ? 'null' : rowPinned) + "." + column.getId();
  };
  CellPositionUtils.prototype.equals = function (cellA, cellB) {
    var colsMatch = cellA.column === cellB.column;
    var floatingMatch = cellA.rowPinned === cellB.rowPinned;
    var indexMatch = cellA.rowIndex === cellB.rowIndex;
    return colsMatch && floatingMatch && indexMatch;
  };
  CellPositionUtils = __decorate$21([Bean('cellPositionUtils')], CellPositionUtils);
  return CellPositionUtils;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2l = undefined && undefined.__extends || function () {
  var _extendStatics150 = function extendStatics(d, b) {
    _extendStatics150 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics150(d, b);
  };
  return function (d, b) {
    _extendStatics150(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$22 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PinnedRowModel = /** @class */function (_super) {
  __extends$2l(PinnedRowModel, _super);
  function PinnedRowModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PinnedRowModel.prototype.init = function () {
    this.setPinnedTopRowData(this.gridOptionsWrapper.getPinnedTopRowData());
    this.setPinnedBottomRowData(this.gridOptionsWrapper.getPinnedBottomRowData());
  };
  PinnedRowModel.prototype.isEmpty = function (floating) {
    var rows = floating === Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
    return missingOrEmpty(rows);
  };
  PinnedRowModel.prototype.isRowsToRender = function (floating) {
    return !this.isEmpty(floating);
  };
  PinnedRowModel.prototype.getRowAtPixel = function (pixel, floating) {
    var rows = floating === Constants.PINNED_TOP ? this.pinnedTopRows : this.pinnedBottomRows;
    if (missingOrEmpty(rows)) {
      return 0; // this should never happen, just in case, 0 is graceful failure
    }

    for (var i = 0; i < rows.length; i++) {
      var rowNode = rows[i];
      var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
      // only need to range check against the top pixel, as we are going through the list
      // in order, first row to hit the pixel wins
      if (rowTopPixel >= pixel) {
        return i;
      }
    }
    return rows.length - 1;
  };
  PinnedRowModel.prototype.setPinnedTopRowData = function (rowData) {
    this.pinnedTopRows = this.createNodesFromData(rowData, true);
    var event = {
      type: Events.EVENT_PINNED_ROW_DATA_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  PinnedRowModel.prototype.setPinnedBottomRowData = function (rowData) {
    this.pinnedBottomRows = this.createNodesFromData(rowData, false);
    var event = {
      type: Events.EVENT_PINNED_ROW_DATA_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  PinnedRowModel.prototype.createNodesFromData = function (allData, isTop) {
    var _this = this;
    var rowNodes = [];
    if (allData) {
      var nextRowTop_1 = 0;
      allData.forEach(function (dataItem, index) {
        var rowNode = new RowNode(_this.beans);
        rowNode.data = dataItem;
        var idPrefix = isTop ? RowNode.ID_PREFIX_TOP_PINNED : RowNode.ID_PREFIX_BOTTOM_PINNED;
        rowNode.id = idPrefix + index;
        rowNode.rowPinned = isTop ? Constants.PINNED_TOP : Constants.PINNED_BOTTOM;
        rowNode.setRowTop(nextRowTop_1);
        rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
        rowNode.setRowIndex(index);
        nextRowTop_1 += rowNode.rowHeight;
        rowNodes.push(rowNode);
      });
    }
    return rowNodes;
  };
  PinnedRowModel.prototype.getPinnedTopRowData = function () {
    return this.pinnedTopRows;
  };
  PinnedRowModel.prototype.getPinnedBottomRowData = function () {
    return this.pinnedBottomRows;
  };
  PinnedRowModel.prototype.getPinnedTopTotalHeight = function () {
    return this.getTotalHeight(this.pinnedTopRows);
  };
  PinnedRowModel.prototype.getPinnedTopRowCount = function () {
    return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
  };
  PinnedRowModel.prototype.getPinnedBottomRowCount = function () {
    return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
  };
  PinnedRowModel.prototype.getPinnedTopRow = function (index) {
    return this.pinnedTopRows[index];
  };
  PinnedRowModel.prototype.getPinnedBottomRow = function (index) {
    return this.pinnedBottomRows[index];
  };
  PinnedRowModel.prototype.forEachPinnedTopRow = function (callback) {
    if (missingOrEmpty(this.pinnedTopRows)) {
      return;
    }
    this.pinnedTopRows.forEach(callback);
  };
  PinnedRowModel.prototype.forEachPinnedBottomRow = function (callback) {
    if (missingOrEmpty(this.pinnedBottomRows)) {
      return;
    }
    this.pinnedBottomRows.forEach(callback);
  };
  PinnedRowModel.prototype.getPinnedBottomTotalHeight = function () {
    return this.getTotalHeight(this.pinnedBottomRows);
  };
  PinnedRowModel.prototype.getTotalHeight = function (rowNodes) {
    if (!rowNodes || rowNodes.length === 0) {
      return 0;
    }
    var lastNode = last(rowNodes);
    return lastNode.rowTop + lastNode.rowHeight;
  };
  __decorate$22([Autowired('columnApi')], PinnedRowModel.prototype, "columnApi", void 0);
  __decorate$22([Autowired('gridApi')], PinnedRowModel.prototype, "gridApi", void 0);
  __decorate$22([Autowired('beans')], PinnedRowModel.prototype, "beans", void 0);
  __decorate$22([PostConstruct], PinnedRowModel.prototype, "init", null);
  PinnedRowModel = __decorate$22([Bean('pinnedRowModel')], PinnedRowModel);
  return PinnedRowModel;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2m = undefined && undefined.__extends || function () {
  var _extendStatics151 = function extendStatics(d, b) {
    _extendStatics151 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics151(d, b);
  };
  return function (d, b) {
    _extendStatics151(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var UndoRedoAction = /** @class */function () {
  function UndoRedoAction(cellValueChanges) {
    this.cellValueChanges = cellValueChanges;
  }
  return UndoRedoAction;
}();
var FillUndoRedoAction = /** @class */function (_super) {
  __extends$2m(FillUndoRedoAction, _super);
  function FillUndoRedoAction(cellValueChanges, initialRange, finalRange) {
    var _this = _super.call(this, cellValueChanges) || this;
    _this.initialRange = initialRange;
    _this.finalRange = finalRange;
    return _this;
  }
  return FillUndoRedoAction;
}(UndoRedoAction);
var UndoRedoStack = /** @class */function () {
  function UndoRedoStack(maxStackSize) {
    this.actionStack = [];
    this.maxStackSize = maxStackSize ? maxStackSize : UndoRedoStack.DEFAULT_STACK_SIZE;
    this.actionStack = new Array(this.maxStackSize);
  }
  UndoRedoStack.prototype.pop = function () {
    return this.actionStack.pop();
  };
  UndoRedoStack.prototype.push = function (item) {
    var shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
    if (!shouldAddActions) {
      return;
    }
    if (this.actionStack.length === this.maxStackSize) {
      this.actionStack.shift();
    }
    this.actionStack.push(item);
  };
  UndoRedoStack.prototype.clear = function () {
    this.actionStack = [];
  };
  UndoRedoStack.prototype.getCurrentStackSize = function () {
    return this.actionStack.length;
  };
  UndoRedoStack.DEFAULT_STACK_SIZE = 10;
  return UndoRedoStack;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2n = undefined && undefined.__extends || function () {
  var _extendStatics152 = function extendStatics(d, b) {
    _extendStatics152 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics152(d, b);
  };
  return function (d, b) {
    _extendStatics152(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$23 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UndoRedoService = /** @class */function (_super) {
  __extends$2n(UndoRedoService, _super);
  function UndoRedoService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.cellValueChanges = [];
    _this.activeCellEdit = null;
    _this.activeRowEdit = null;
    _this.isPasting = false;
    _this.isFilling = false;
    _this.onCellValueChanged = function (event) {
      var eventCell = {
        column: event.column,
        rowIndex: event.rowIndex,
        rowPinned: event.rowPinned
      };
      var isCellEditing = _this.activeCellEdit !== null && _this.cellPositionUtils.equals(_this.activeCellEdit, eventCell);
      var isRowEditing = _this.activeRowEdit !== null && _this.rowPositionUtils.sameRow(_this.activeRowEdit, eventCell);
      var shouldCaptureAction = isCellEditing || isRowEditing || _this.isPasting || _this.isFilling;
      if (!shouldCaptureAction) {
        return;
      }
      var rowPinned = event.rowPinned,
        rowIndex = event.rowIndex,
        column = event.column,
        oldValue = event.oldValue,
        value = event.value;
      var cellValueChange = {
        rowPinned: rowPinned,
        rowIndex: rowIndex,
        columnId: column.getColId(),
        newValue: value,
        oldValue: oldValue
      };
      _this.cellValueChanges.push(cellValueChange);
    };
    _this.clearStacks = function () {
      _this.undoStack.clear();
      _this.redoStack.clear();
    };
    return _this;
  }
  UndoRedoService.prototype.init = function () {
    if (!this.gridOptionsWrapper.isUndoRedoCellEditing()) {
      return;
    }
    var undoRedoLimit = this.gridOptionsWrapper.getUndoRedoCellEditingLimit();
    if (undoRedoLimit <= 0) {
      return;
    }
    this.undoStack = new UndoRedoStack(undoRedoLimit);
    this.redoStack = new UndoRedoStack(undoRedoLimit);
    this.addRowEditingListeners();
    this.addCellEditingListeners();
    this.addPasteListeners();
    this.addFillListeners();
    this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged);
    // undo / redo is restricted to actual editing so we clear the stacks when other operations are
    // performed that change the order of the row / cols.
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.clearStacks);
    this.addManagedListener(this.eventService, Events.EVENT_ROW_DRAG_END, this.clearStacks);
  };
  UndoRedoService.prototype.getCurrentUndoStackSize = function () {
    return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
  };
  UndoRedoService.prototype.getCurrentRedoStackSize = function () {
    return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
  };
  UndoRedoService.prototype.undo = function () {
    if (!this.undoStack) {
      return;
    }
    var undoAction = this.undoStack.pop();
    if (!undoAction || !undoAction.cellValueChanges) {
      return;
    }
    this.processAction(undoAction, function (cellValueChange) {
      return cellValueChange.oldValue;
    });
    if (undoAction instanceof FillUndoRedoAction) {
      this.processRangeAndCellFocus(undoAction.cellValueChanges, undoAction.initialRange);
    } else {
      this.processRangeAndCellFocus(undoAction.cellValueChanges);
    }
    this.redoStack.push(undoAction);
  };
  UndoRedoService.prototype.redo = function () {
    if (!this.redoStack) {
      return;
    }
    var redoAction = this.redoStack.pop();
    if (!redoAction || !redoAction.cellValueChanges) {
      return;
    }
    this.processAction(redoAction, function (cellValueChange) {
      return cellValueChange.newValue;
    });
    if (redoAction instanceof FillUndoRedoAction) {
      this.processRangeAndCellFocus(redoAction.cellValueChanges, redoAction.finalRange);
    } else {
      this.processRangeAndCellFocus(redoAction.cellValueChanges);
    }
    this.undoStack.push(redoAction);
  };
  UndoRedoService.prototype.processAction = function (action, valueExtractor) {
    var _this = this;
    action.cellValueChanges.forEach(function (cellValueChange) {
      var rowIndex = cellValueChange.rowIndex,
        rowPinned = cellValueChange.rowPinned,
        columnId = cellValueChange.columnId;
      var rowPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned
      };
      var currentRow = _this.getRowNode(rowPosition);
      // checks if the row has been filtered out
      if (!currentRow.displayed) {
        return;
      }
      currentRow.setDataValue(columnId, valueExtractor(cellValueChange));
    });
  };
  UndoRedoService.prototype.processRangeAndCellFocus = function (cellValueChanges, range) {
    var lastFocusedCell;
    if (range) {
      var startRow = range.startRow;
      var endRow = range.endRow;
      lastFocusedCell = {
        rowPinned: startRow.rowPinned,
        rowIndex: startRow.rowIndex,
        columnId: range.startColumn.getColId()
      };
      this.setLastFocusedCell(lastFocusedCell);
      var cellRangeParams = {
        rowStartIndex: startRow.rowIndex,
        rowStartPinned: startRow.rowPinned,
        rowEndIndex: endRow.rowIndex,
        rowEndPinned: endRow.rowPinned,
        columnStart: range.startColumn,
        columns: range.columns
      };
      this.gridApi.addCellRange(cellRangeParams);
      return;
    }
    var cellValueChange = cellValueChanges[0];
    var rowIndex = cellValueChange.rowIndex,
      rowPinned = cellValueChange.rowPinned;
    var rowPosition = {
      rowIndex: rowIndex,
      rowPinned: rowPinned
    };
    var row = this.getRowNode(rowPosition);
    lastFocusedCell = {
      rowPinned: cellValueChange.rowPinned,
      rowIndex: row.rowIndex,
      columnId: cellValueChange.columnId
    };
    this.setLastFocusedCell(lastFocusedCell);
  };
  UndoRedoService.prototype.setLastFocusedCell = function (lastFocusedCell) {
    var rowIndex = lastFocusedCell.rowIndex,
      columnId = lastFocusedCell.columnId,
      rowPinned = lastFocusedCell.rowPinned;
    this.gridApi.ensureIndexVisible(rowIndex);
    this.gridApi.ensureColumnVisible(columnId);
    if (ModuleRegistry.isRegistered(ModuleNames.RangeSelectionModule)) {
      this.gridApi.clearRangeSelection();
    }
    this.focusService.setFocusedCell(rowIndex, columnId, rowPinned, true);
  };
  UndoRedoService.prototype.addRowEditingListeners = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STARTED, function (e) {
      _this.activeRowEdit = {
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned
      };
    });
    this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STOPPED, function () {
      var action = new UndoRedoAction(_this.cellValueChanges);
      _this.pushActionsToUndoStack(action);
      _this.activeRowEdit = null;
    });
  };
  UndoRedoService.prototype.addCellEditingListeners = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STARTED, function (e) {
      _this.activeCellEdit = {
        column: e.column,
        rowIndex: e.rowIndex,
        rowPinned: e.rowPinned
      };
    });
    this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STOPPED, function () {
      _this.activeCellEdit = null;
      var shouldPushAction = !_this.activeRowEdit && !_this.isPasting && !_this.isFilling;
      if (shouldPushAction) {
        var action = new UndoRedoAction(_this.cellValueChanges);
        _this.pushActionsToUndoStack(action);
      }
    });
  };
  UndoRedoService.prototype.addPasteListeners = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_PASTE_START, function () {
      _this.isPasting = true;
    });
    this.addManagedListener(this.eventService, Events.EVENT_PASTE_END, function () {
      var action = new UndoRedoAction(_this.cellValueChanges);
      _this.pushActionsToUndoStack(action);
      _this.isPasting = false;
    });
  };
  UndoRedoService.prototype.addFillListeners = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_FILL_START, function () {
      _this.isFilling = true;
    });
    this.addManagedListener(this.eventService, Events.EVENT_FILL_END, function (event) {
      var action = new FillUndoRedoAction(_this.cellValueChanges, event.initialRange, event.finalRange);
      _this.pushActionsToUndoStack(action);
      _this.isFilling = false;
    });
  };
  UndoRedoService.prototype.pushActionsToUndoStack = function (action) {
    this.undoStack.push(action);
    this.cellValueChanges = [];
    this.redoStack.clear();
  };
  UndoRedoService.prototype.getRowNode = function (gridRow) {
    switch (gridRow.rowPinned) {
      case Constants.PINNED_TOP:
        return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
      case Constants.PINNED_BOTTOM:
        return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
      default:
        return this.rowModel.getRow(gridRow.rowIndex);
    }
  };
  __decorate$23([Autowired('focusService')], UndoRedoService.prototype, "focusService", void 0);
  __decorate$23([Autowired('gridApi')], UndoRedoService.prototype, "gridApi", void 0);
  __decorate$23([Autowired('rowModel')], UndoRedoService.prototype, "rowModel", void 0);
  __decorate$23([Autowired('pinnedRowModel')], UndoRedoService.prototype, "pinnedRowModel", void 0);
  __decorate$23([Autowired('cellPositionUtils')], UndoRedoService.prototype, "cellPositionUtils", void 0);
  __decorate$23([Autowired('rowPositionUtils')], UndoRedoService.prototype, "rowPositionUtils", void 0);
  __decorate$23([PostConstruct], UndoRedoService.prototype, "init", null);
  UndoRedoService = __decorate$23([Bean('undoRedoService')], UndoRedoService);
  return UndoRedoService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2o = undefined && undefined.__extends || function () {
  var _extendStatics153 = function extendStatics(d, b) {
    _extendStatics153 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics153(d, b);
  };
  return function (d, b) {
    _extendStatics153(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$24 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeaderPositionUtils = /** @class */function (_super) {
  __extends$2o(HeaderPositionUtils, _super);
  function HeaderPositionUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HeaderPositionUtils.prototype.findHeader = function (focusedHeader, direction) {
    var nextColumn;
    var getGroupMethod;
    var getColMethod;
    if (focusedHeader.column instanceof ColumnGroup) {
      getGroupMethod = "getDisplayedGroup" + direction;
      nextColumn = this.columnModel[getGroupMethod](focusedHeader.column);
    } else {
      getColMethod = "getDisplayedCol" + direction;
      nextColumn = this.columnModel[getColMethod](focusedHeader.column);
    }
    if (nextColumn) {
      return {
        column: nextColumn,
        headerRowIndex: focusedHeader.headerRowIndex
      };
    }
  };
  HeaderPositionUtils.prototype.findColAtEdgeForHeaderRow = function (level, position) {
    var displayedColumns = this.columnModel.getAllDisplayedColumns();
    var column = displayedColumns[position === 'start' ? 0 : displayedColumns.length - 1];
    if (!column) {
      return;
    }
    var childContainer = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned());
    var type = childContainer.getRowType(level);
    console.log("level=" + level + " type = " + type);
    if (type == HeaderRowType.COLUMN_GROUP) {
      var columnGroup = this.columnModel.getColumnGroupAtLevel(column, level);
      return {
        headerRowIndex: level,
        column: columnGroup
      };
    }
    return {
      // if type==null, means the header level didn't exist
      headerRowIndex: type == null ? -1 : level,
      column: column
    };
  };
  __decorate$24([Autowired('columnModel')], HeaderPositionUtils.prototype, "columnModel", void 0);
  __decorate$24([Autowired('ctrlsService')], HeaderPositionUtils.prototype, "ctrlsService", void 0);
  HeaderPositionUtils = __decorate$24([Bean('headerPositionUtils')], HeaderPositionUtils);
  return HeaderPositionUtils;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$25 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnDefFactory = /** @class */function () {
  function ColumnDefFactory() {}
  ColumnDefFactory.prototype.buildColumnDefs = function (cols, rowGroupColumns, pivotColumns) {
    var _this = this;
    var res = [];
    var colGroupDefs = {};
    cols.forEach(function (col) {
      var colDef = _this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
      var addToResult = true;
      var childDef = colDef;
      var pointer = col.getOriginalParent();
      while (pointer) {
        var parentDef = null;
        // we don't include padding groups, as the column groups provided
        // by application didn't have these. the whole point of padding groups
        // is to balance the column tree that the user provided.
        if (pointer.isPadding()) {
          pointer = pointer.getOriginalParent();
          continue;
        }
        // if colDef for this group already exists, use it
        var existingParentDef = colGroupDefs[pointer.getGroupId()];
        if (existingParentDef) {
          existingParentDef.children.push(childDef);
          // if we added to result, it would be the second time we did it
          addToResult = false;
          // we don't want to continue up the tree, as it has already been
          // done for this group
          break;
        }
        parentDef = _this.createDefFromGroup(pointer);
        if (parentDef) {
          parentDef.children = [childDef];
          colGroupDefs[parentDef.groupId] = parentDef;
          childDef = parentDef;
          pointer = pointer.getOriginalParent();
        }
      }
      if (addToResult) {
        res.push(childDef);
      }
    });
    return res;
  };
  ColumnDefFactory.prototype.createDefFromGroup = function (group) {
    var defCloned = deepCloneDefinition(group.getColGroupDef(), ['children']);
    if (defCloned) {
      defCloned.groupId = group.getGroupId();
    }
    return defCloned;
  };
  ColumnDefFactory.prototype.createDefFromColumn = function (col, rowGroupColumns, pivotColumns) {
    var colDefCloned = deepCloneDefinition(col.getColDef());
    colDefCloned.colId = col.getColId();
    colDefCloned.width = col.getActualWidth();
    colDefCloned.rowGroup = col.isRowGroupActive();
    colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
    colDefCloned.pivot = col.isPivotActive();
    colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
    colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
    colDefCloned.hide = col.isVisible() ? undefined : true;
    colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
    colDefCloned.sort = col.getSort() ? col.getSort() : null;
    colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
    return colDefCloned;
  };
  ColumnDefFactory = __decorate$25([Bean('columnDefFactory')], ColumnDefFactory);
  return ColumnDefFactory;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$26 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowCssClassCalculator = /** @class */function () {
  function RowCssClassCalculator() {}
  RowCssClassCalculator.prototype.getInitialRowClasses = function (params) {
    var classes = [];
    if (exists(params.extraCssClass)) {
      classes.push(params.extraCssClass);
    }
    classes.push('ag-row');
    classes.push(params.rowFocused ? 'ag-row-focus' : 'ag-row-no-focus');
    if (params.fadeRowIn) {
      classes.push('ag-opacity-zero');
    }
    classes.push(params.rowIsEven ? 'ag-row-even' : 'ag-row-odd');
    if (params.rowNode.isRowPinned()) {
      classes.push('ag-row-pinned');
    }
    if (params.rowNode.isSelected()) {
      classes.push('ag-row-selected');
    }
    if (params.rowNode.footer) {
      classes.push('ag-row-footer');
    }
    classes.push('ag-row-level-' + params.rowLevel);
    if (params.rowNode.stub) {
      classes.push('ag-row-loading');
    }
    if (params.fullWidthRow) {
      classes.push('ag-full-width-row');
    }
    if (params.expandable) {
      classes.push('ag-row-group');
      classes.push(params.rowNode.expanded ? 'ag-row-group-expanded' : 'ag-row-group-contracted');
    }
    if (params.rowNode.dragging) {
      classes.push('ag-row-dragging');
    }
    pushAll(classes, this.processClassesFromGridOptions(params.rowNode, params.scope));
    pushAll(classes, this.preProcessRowClassRules(params.rowNode, params.scope));
    // we use absolute position unless we are doing print layout
    classes.push(params.printLayout ? 'ag-row-position-relative' : 'ag-row-position-absolute');
    if (params.firstRowOnPage) {
      classes.push('ag-row-first');
    }
    if (params.lastRowOnPage) {
      classes.push('ag-row-last');
    }
    if (params.fullWidthRow) {
      if (params.pinned === Constants.PINNED_LEFT) {
        classes.push('ag-cell-last-left-pinned');
      }
      if (params.pinned === Constants.PINNED_RIGHT) {
        classes.push('ag-cell-first-right-pinned');
      }
    }
    return classes;
  };
  RowCssClassCalculator.prototype.processClassesFromGridOptions = function (rowNode, scope) {
    var res = [];
    var process = function process(rowCls) {
      if (typeof rowCls === 'string') {
        res.push(rowCls);
      } else if (Array.isArray(rowCls)) {
        rowCls.forEach(function (e) {
          return res.push(e);
        });
      }
    };
    // part 1 - rowClass
    var rowClass = this.gridOptionsWrapper.getRowClass();
    if (rowClass) {
      if (typeof rowClass === 'function') {
        console.warn('AG Grid: rowClass should not be a function, please use getRowClass instead');
        return [];
      }
      process(rowClass);
    }
    // part 2 - rowClassFunc
    var rowClassFunc = this.gridOptionsWrapper.getRowClassFunc();
    if (rowClassFunc) {
      var params = {
        data: rowNode.data,
        node: rowNode,
        rowIndex: rowNode.rowIndex,
        $scope: scope,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      var rowClassFuncResult = rowClassFunc(params);
      process(rowClassFuncResult);
    }
    return res;
  };
  RowCssClassCalculator.prototype.preProcessRowClassRules = function (rowNode, scope) {
    var res = [];
    this.processRowClassRules(rowNode, scope, function (className) {
      res.push(className);
    }, function (className) {
      // not catered for, if creating, no need
      // to remove class as it was never there
    });
    return res;
  };
  RowCssClassCalculator.prototype.processRowClassRules = function (rowNode, scope, onApplicableClass, onNotApplicableClass) {
    var rowClassParams = {
      data: rowNode.data,
      node: rowNode,
      rowIndex: rowNode.rowIndex,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      $scope: scope,
      context: this.gridOptionsWrapper.getContext()
    };
    this.stylingService.processClassRules(this.gridOptionsWrapper.rowClassRules(), rowClassParams, onApplicableClass, onNotApplicableClass);
  };
  RowCssClassCalculator.prototype.calculateRowLevel = function (rowNode) {
    if (rowNode.group) {
      return rowNode.level;
    }
    // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
    return rowNode.parent ? rowNode.parent.level + 1 : 0;
  };
  __decorate$26([Autowired('stylingService')], RowCssClassCalculator.prototype, "stylingService", void 0);
  __decorate$26([Autowired('gridOptionsWrapper')], RowCssClassCalculator.prototype, "gridOptionsWrapper", void 0);
  RowCssClassCalculator = __decorate$26([Bean('rowCssClassCalculator')], RowCssClassCalculator);
  return RowCssClassCalculator;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2p = undefined && undefined.__extends || function () {
  var _extendStatics154 = function extendStatics(d, b) {
    _extendStatics154 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics154(d, b);
  };
  return function (d, b) {
    _extendStatics154(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RowNodeBlock = /** @class */function (_super) {
  __extends$2p(RowNodeBlock, _super);
  function RowNodeBlock(id) {
    var _this = _super.call(this) || this;
    _this.state = RowNodeBlock.STATE_WAITING_TO_LOAD;
    _this.version = 0;
    _this.id = id;
    return _this;
  }
  RowNodeBlock.prototype.getId = function () {
    return this.id;
  };
  RowNodeBlock.prototype.load = function () {
    this.state = RowNodeBlock.STATE_LOADING;
    this.loadFromDatasource();
  };
  RowNodeBlock.prototype.getVersion = function () {
    return this.version;
  };
  RowNodeBlock.prototype.setStateWaitingToLoad = function () {
    // in case any current loads in progress, this will have their results ignored
    this.version++;
    this.state = RowNodeBlock.STATE_WAITING_TO_LOAD;
  };
  RowNodeBlock.prototype.getState = function () {
    return this.state;
  };
  RowNodeBlock.prototype.pageLoadFailed = function (version) {
    var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
    if (requestMostRecentAndLive) {
      this.state = RowNodeBlock.STATE_FAILED;
      this.processServerFail();
    }
    this.dispatchLoadCompleted(false);
  };
  RowNodeBlock.prototype.success = function (version, params) {
    this.successCommon(version, params);
  };
  RowNodeBlock.prototype.pageLoaded = function (version, rows, lastRow) {
    this.successCommon(version, {
      rowData: rows,
      rowCount: lastRow
    });
  };
  RowNodeBlock.prototype.isRequestMostRecentAndLive = function (version) {
    // thisIsMostRecentRequest - if block was refreshed, then another request
    // could of been sent after this one.
    var thisIsMostRecentRequest = version === this.version;
    // weAreNotDestroyed - if InfiniteStore is purged, then blocks are destroyed
    // and new blocks created. so data loads of old blocks are discarded.
    var weAreNotDestroyed = this.isAlive();
    return thisIsMostRecentRequest && weAreNotDestroyed;
  };
  RowNodeBlock.prototype.successCommon = function (version, params) {
    // need to dispatch load complete before processing the data, as PaginationComp checks
    // RowNodeBlockLoader to see if it is still loading, so the RowNodeBlockLoader needs to
    // be updated first (via LoadComplete event) before PaginationComp updates (via processServerResult method)
    this.dispatchLoadCompleted();
    var requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
    if (requestMostRecentAndLive) {
      this.state = RowNodeBlock.STATE_LOADED;
      this.processServerResult(params);
    }
  };
  RowNodeBlock.prototype.dispatchLoadCompleted = function (success) {
    if (success === void 0) {
      success = true;
    }
    // we fire event regardless of processing data or now, as we want
    // the concurrentLoadRequests count to be reduced in BlockLoader
    var event = {
      type: RowNodeBlock.EVENT_LOAD_COMPLETE,
      success: success,
      block: this
    };
    this.dispatchEvent(event);
  };
  RowNodeBlock.EVENT_LOAD_COMPLETE = 'loadComplete';
  RowNodeBlock.STATE_WAITING_TO_LOAD = 'needsLoading';
  RowNodeBlock.STATE_LOADING = 'loading';
  RowNodeBlock.STATE_LOADED = 'loaded';
  RowNodeBlock.STATE_FAILED = 'failed';
  return RowNodeBlock;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2q = undefined && undefined.__extends || function () {
  var _extendStatics155 = function extendStatics(d, b) {
    _extendStatics155 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics155(d, b);
  };
  return function (d, b) {
    _extendStatics155(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$27 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$9 = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var RowNodeBlockLoader = /** @class */function (_super) {
  __extends$2q(RowNodeBlockLoader, _super);
  function RowNodeBlockLoader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.activeBlockLoadsCount = 0;
    _this.blocks = [];
    _this.active = true;
    return _this;
  }
  RowNodeBlockLoader_1 = RowNodeBlockLoader;
  RowNodeBlockLoader.prototype.postConstruct = function () {
    this.maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
    var blockLoadDebounceMillis = this.gridOptionsWrapper.getBlockLoadDebounceMillis();
    if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) {
      this.checkBlockToLoadDebounce = _.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
  };
  RowNodeBlockLoader.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('RowNodeBlockLoader');
  };
  RowNodeBlockLoader.prototype.addBlock = function (block) {
    this.blocks.push(block);
    // note that we do not remove this listener when removing the block. this is because the
    // cache can get destroyed (and containing blocks) when a block is loading. however the loading block
    // is still counted as an active loading block and we must decrement activeBlockLoadsCount when it finishes.
    block.addEventListener(RowNodeBlock.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this));
    this.checkBlockToLoad();
  };
  RowNodeBlockLoader.prototype.removeBlock = function (block) {
    _.removeFromArray(this.blocks, block);
  };
  RowNodeBlockLoader.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    this.active = false;
  };
  RowNodeBlockLoader.prototype.loadComplete = function () {
    this.activeBlockLoadsCount--;
    this.checkBlockToLoad();
    if (this.activeBlockLoadsCount == 0) {
      this.dispatchEvent({
        type: RowNodeBlockLoader_1.BLOCK_LOADER_FINISHED_EVENT
      });
    }
  };
  RowNodeBlockLoader.prototype.checkBlockToLoad = function () {
    if (this.checkBlockToLoadDebounce) {
      this.checkBlockToLoadDebounce();
    } else {
      this.performCheckBlocksToLoad();
    }
  };
  RowNodeBlockLoader.prototype.performCheckBlocksToLoad = function () {
    if (!this.active) {
      return;
    }
    this.printCacheStatus();
    if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
      this.logger.log("checkBlockToLoad: max loads exceeded");
      return;
    }
    var blockToLoad = null;
    this.blocks.forEach(function (block) {
      if (block.getState() === RowNodeBlock.STATE_WAITING_TO_LOAD) {
        blockToLoad = block;
      }
    });
    if (blockToLoad) {
      blockToLoad.load();
      this.activeBlockLoadsCount++;
      this.printCacheStatus();
    }
  };
  RowNodeBlockLoader.prototype.getBlockState = function () {
    var result = {};
    this.blocks.forEach(function (block) {
      var _a = block.getBlockStateJson(),
        id = _a.id,
        state = _a.state;
      result[id] = state;
    });
    return result;
  };
  RowNodeBlockLoader.prototype.printCacheStatus = function () {
    if (this.logger.isLogging()) {
      this.logger.log("printCacheStatus: activePageLoadsCount = " + this.activeBlockLoadsCount + "," + (" blocks = " + JSON.stringify(this.getBlockState())));
    }
  };
  RowNodeBlockLoader.prototype.isLoading = function () {
    return this.activeBlockLoadsCount > 0;
  };
  var RowNodeBlockLoader_1;
  RowNodeBlockLoader.BLOCK_LOADER_FINISHED_EVENT = 'blockLoaderFinished';
  __decorate$27([PostConstruct], RowNodeBlockLoader.prototype, "postConstruct", null);
  __decorate$27([__param$9(0, Qualifier('loggerFactory'))], RowNodeBlockLoader.prototype, "setBeans", null);
  RowNodeBlockLoader = RowNodeBlockLoader_1 = __decorate$27([Bean('rowNodeBlockLoader')], RowNodeBlockLoader);
  return RowNodeBlockLoader;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __decorate$28 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// this logic is used by both SSRM and CSRM
var RowNodeSorter = /** @class */function () {
  function RowNodeSorter() {}
  RowNodeSorter.prototype.doFullSort = function (rowNodes, sortOptions) {
    var mapper = function mapper(rowNode, pos) {
      return {
        currentPos: pos,
        rowNode: rowNode
      };
    };
    var sortedRowNodes = rowNodes.map(mapper);
    sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
    return sortedRowNodes.map(function (item) {
      return item.rowNode;
    });
  };
  RowNodeSorter.prototype.compareRowNodes = function (sortOptions, sortedNodeA, sortedNodeB) {
    var nodeA = sortedNodeA.rowNode;
    var nodeB = sortedNodeB.rowNode;
    // Iterate columns, return the first that doesn't match
    for (var i = 0, len = sortOptions.length; i < len; i++) {
      var sortOption = sortOptions[i];
      var isInverted = sortOption.sort === Constants.SORT_DESC;
      var valueA = this.getValue(nodeA, sortOption.column);
      var valueB = this.getValue(nodeB, sortOption.column);
      var comparatorResult = void 0;
      var providedComparator = this.getComparator(sortOption, nodeA);
      if (providedComparator) {
        //if comparator provided, use it
        comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isInverted);
      } else {
        //otherwise do our own comparison
        comparatorResult = _.defaultComparator(valueA, valueB, this.gridOptionsWrapper.isAccentedSort());
      }
      // user provided comparators can return 'NaN' if they don't correctly handle 'undefined' values, this
      // typically occurs when the comparator is used on a group row
      var validResult = !isNaN(comparatorResult);
      if (validResult && comparatorResult !== 0) {
        return sortOption.sort === Constants.SORT_ASC ? comparatorResult : comparatorResult * -1;
      }
    }
    // All matched, we make is so that the original sort order is kept:
    return sortedNodeA.currentPos - sortedNodeB.currentPos;
  };
  RowNodeSorter.prototype.getComparator = function (sortOption, rowNode) {
    var column = sortOption.column;
    // comparator on col get preference over everything else
    var comparatorOnCol = column.getColDef().comparator;
    if (comparatorOnCol != null) {
      return comparatorOnCol;
    }
    // if no comparator on col, see if we are showing a group, and if we are, get comparator from row group col
    if (rowNode.rowGroupColumn) {
      return rowNode.rowGroupColumn.getColDef().comparator;
    }
    if (!column.getColDef().showRowGroup) {
      return;
    }
    // if a 'field' is supplied on the autoGroupColumnDef we need to use the associated column comparator
    var groupLeafField = !rowNode.group && column.getColDef().field;
    if (!groupLeafField) {
      return;
    }
    var primaryColumn = this.columnModel.getPrimaryColumn(groupLeafField);
    if (!primaryColumn) {
      return;
    }
    return primaryColumn.getColDef().comparator;
  };
  RowNodeSorter.prototype.getValue = function (nodeA, column) {
    return this.valueService.getValue(column, nodeA, false, false);
  };
  __decorate$28([Autowired('gridOptionsWrapper')], RowNodeSorter.prototype, "gridOptionsWrapper", void 0);
  __decorate$28([Autowired('valueService')], RowNodeSorter.prototype, "valueService", void 0);
  __decorate$28([Autowired('columnModel')], RowNodeSorter.prototype, "columnModel", void 0);
  RowNodeSorter = __decorate$28([Bean('rowNodeSorter')], RowNodeSorter);
  return RowNodeSorter;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2r = undefined && undefined.__extends || function () {
  var _extendStatics156 = function extendStatics(d, b) {
    _extendStatics156 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics156(d, b);
  };
  return function (d, b) {
    _extendStatics156(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$29 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CtrlsService = /** @class */function (_super) {
  __extends$2r(CtrlsService, _super);
  function CtrlsService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.ready = false;
    _this.readyCallbacks = [];
    return _this;
  }
  CtrlsService.prototype.checkReady = function () {
    this.ready = this.gridCtrl != null && this.gridBodyCtrl != null && this.centerRowContainerCtrl != null && this.leftRowContainerCtrl != null && this.rightRowContainerCtrl != null && this.bottomCenterRowContainerCtrl != null && this.bottomLeftRowContainerCtrl != null && this.bottomRightRowContainerCtrl != null && this.topCenterRowContainerCtrl != null && this.topLeftRowContainerCtrl != null && this.topRightRowContainerCtrl != null && this.centerHeaderRowContainerCtrl != null && this.leftHeaderRowContainerCtrl != null && this.rightHeaderRowContainerCtrl != null && this.fakeHScrollCtrl != null && this.gridHeaderCtrl != null;
    if (this.ready) {
      var p_1 = this.createReadyParams();
      this.readyCallbacks.forEach(function (c) {
        return c(p_1);
      });
      this.readyCallbacks.length = 0;
    }
  };
  CtrlsService.prototype.whenReady = function (callback) {
    if (this.ready) {
      callback(this.createReadyParams());
    } else {
      this.readyCallbacks.push(callback);
    }
  };
  CtrlsService.prototype.createReadyParams = function () {
    return {
      centerRowContainerCtrl: this.centerRowContainerCtrl,
      leftRowContainerCtrl: this.leftRowContainerCtrl,
      rightRowContainerCtrl: this.rightRowContainerCtrl,
      bottomCenterRowContainerCtrl: this.bottomCenterRowContainerCtrl,
      bottomLeftRowContainerCtrl: this.bottomLeftRowContainerCtrl,
      bottomRightRowContainerCtrl: this.bottomRightRowContainerCtrl,
      topCenterRowContainerCtrl: this.topCenterRowContainerCtrl,
      topLeftRowContainerCtrl: this.topLeftRowContainerCtrl,
      topRightRowContainerCtrl: this.topRightRowContainerCtrl,
      centerHeaderRowContainerCtrl: this.centerHeaderRowContainerCtrl,
      leftHeaderRowContainerCtrl: this.leftHeaderRowContainerCtrl,
      rightHeaderRowContainerCtrl: this.rightHeaderRowContainerCtrl,
      fakeHScrollCtrl: this.fakeHScrollCtrl,
      gridBodyCtrl: this.gridBodyCtrl,
      gridCtrl: this.gridCtrl,
      gridHeaderCtrl: this.gridHeaderCtrl
    };
  };
  CtrlsService.prototype.registerFakeHScrollCtrl = function (ctrl) {
    this.fakeHScrollCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerGridHeaderCtrl = function (gridHeaderCtrl) {
    this.gridHeaderCtrl = gridHeaderCtrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerCenterRowContainerCtrl = function (ctrl) {
    this.centerRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerLeftRowContainerCtrl = function (ctrl) {
    this.leftRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerRightRowContainerCtrl = function (ctrl) {
    this.rightRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerTopCenterRowContainerCtrl = function (ctrl) {
    this.topCenterRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerTopLeftRowContainerCon = function (ctrl) {
    this.topLeftRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerTopRightRowContainerCtrl = function (ctrl) {
    this.topRightRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerBottomCenterRowContainerCtrl = function (ctrl) {
    this.bottomCenterRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerBottomLeftRowContainerCtrl = function (ctrl) {
    this.bottomLeftRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerBottomRightRowContainerCtrl = function (ctrl) {
    this.bottomRightRowContainerCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerHeaderContainer = function (ctrl, pinned) {
    switch (pinned) {
      case Constants.PINNED_LEFT:
        this.leftHeaderRowContainerCtrl = ctrl;
        break;
      case Constants.PINNED_RIGHT:
        this.rightHeaderRowContainerCtrl = ctrl;
        break;
      default:
        this.centerHeaderRowContainerCtrl = ctrl;
        break;
    }
    this.checkReady();
  };
  CtrlsService.prototype.registerGridBodyCtrl = function (ctrl) {
    this.gridBodyCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.registerGridCtrl = function (ctrl) {
    this.gridCtrl = ctrl;
    this.checkReady();
  };
  CtrlsService.prototype.getFakeHScrollCtrl = function () {
    return this.fakeHScrollCtrl;
  };
  CtrlsService.prototype.getGridHeaderCtrl = function () {
    return this.gridHeaderCtrl;
  };
  CtrlsService.prototype.getGridCtrl = function () {
    return this.gridCtrl;
  };
  CtrlsService.prototype.getCenterRowContainerCtrl = function () {
    return this.centerRowContainerCtrl;
  };
  CtrlsService.prototype.getTopCenterRowContainerCtrl = function () {
    return this.topCenterRowContainerCtrl;
  };
  CtrlsService.prototype.getBottomCenterRowContainerCtrl = function () {
    return this.bottomCenterRowContainerCtrl;
  };
  CtrlsService.prototype.getGridBodyCtrl = function () {
    return this.gridBodyCtrl;
  };
  CtrlsService.prototype.getHeaderRowContainerCtrls = function () {
    return [this.leftHeaderRowContainerCtrl, this.rightHeaderRowContainerCtrl, this.centerHeaderRowContainerCtrl];
  };
  CtrlsService.prototype.getHeaderRowContainerCtrl = function (pinned) {
    switch (pinned) {
      case Constants.PINNED_LEFT:
        return this.leftHeaderRowContainerCtrl;
      case Constants.PINNED_RIGHT:
        return this.rightHeaderRowContainerCtrl;
      default:
        return this.centerHeaderRowContainerCtrl;
    }
  };
  CtrlsService = __decorate$29([Bean('ctrlsService')], CtrlsService);
  return CtrlsService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2s = undefined && undefined.__extends || function () {
  var _extendStatics157 = function extendStatics(d, b) {
    _extendStatics157 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics157(d, b);
  };
  return function (d, b) {
    _extendStatics157(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CtrlsFactory = /** @class */function (_super) {
  __extends$2s(CtrlsFactory, _super);
  function CtrlsFactory() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.registry = {};
    return _this;
  }
  CtrlsFactory.prototype.register = function (meta) {
    this.registry[meta.controllerName] = meta.controllerClass;
  };
  CtrlsFactory.prototype.getInstance = function (name) {
    var ControllerClass = this.registry[name];
    if (ControllerClass == null) {
      return undefined;
    }
    return new ControllerClass();
  };
  CtrlsFactory = __decorate$2a([Bean('ctrlsFactory')], CtrlsFactory);
  return CtrlsFactory;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2t = undefined && undefined.__extends || function () {
  var _extendStatics158 = function extendStatics(d, b) {
    _extendStatics158 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics158(d, b);
  };
  return function (d, b) {
    _extendStatics158(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2b = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FakeHScrollCtrl = /** @class */function (_super) {
  __extends$2t(FakeHScrollCtrl, _super);
  function FakeHScrollCtrl() {
    return _super.call(this) || this;
  }
  FakeHScrollCtrl.prototype.setComp = function (view, eGui, eViewport, eContainer) {
    this.view = view;
    this.eViewport = eViewport;
    this.eContainer = eContainer;
    this.eGui = eGui;
    this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
    this.onScrollVisibilityChanged();
    // When doing printing, this changes whether cols are pinned or not
    var spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, spacerWidthsListener);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, spacerWidthsListener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, spacerWidthsListener);
    this.setFakeHScrollSpacerWidths();
    if (this.invisibleScrollbar) {
      this.hideAndShowInvisibleScrollAsNeeded();
      this.addActiveListenerToggles();
    }
    this.ctrlsService.registerFakeHScrollCtrl(this);
  };
  FakeHScrollCtrl.prototype.addActiveListenerToggles = function () {
    var _this = this;
    var activateEvents = ['mouseenter', 'mousedown', 'touchstart'];
    var deactivateEvents = ['mouseleave', 'mouseup', 'touchend'];
    activateEvents.forEach(function (eventName) {
      return _this.addManagedListener(_this.eGui, eventName, function () {
        return _this.view.addOrRemoveCssClass('ag-scrollbar-active', true);
      });
    });
    deactivateEvents.forEach(function (eventName) {
      return _this.addManagedListener(_this.eGui, eventName, function () {
        return _this.view.addOrRemoveCssClass('ag-scrollbar-active', false);
      });
    });
  };
  FakeHScrollCtrl.prototype.postConstruct = function () {
    this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
    this.invisibleScrollbar = isInvisibleScrollbar();
  };
  FakeHScrollCtrl.prototype.onScrollVisibilityChanged = function () {
    this.setScrollVisible();
    this.setFakeHScrollSpacerWidths();
  };
  FakeHScrollCtrl.prototype.hideAndShowInvisibleScrollAsNeeded = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, function (params) {
      if (params.direction === 'horizontal') {
        _this.view.addOrRemoveCssClass('ag-scrollbar-scrolling', true);
      }
    });
    this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL_END, function () {
      return _this.view.addOrRemoveCssClass('ag-scrollbar-scrolling', false);
    });
  };
  FakeHScrollCtrl.prototype.setFakeHScrollSpacerWidths = function () {
    var vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
    // we pad the right based on a) if cols are pinned to the right and
    // b) if v scroll is showing on the right (normal position of scroll)
    var rightSpacing = this.columnModel.getDisplayedColumnsRightWidth();
    var scrollOnRight = !this.enableRtl && vScrollShowing;
    var scrollbarWidth = this.gridOptionsWrapper.getScrollbarWidth();
    if (scrollOnRight) {
      rightSpacing += scrollbarWidth;
    }
    this.view.setRightSpacerFixedWidth(rightSpacing);
    this.view.includeRightSpacerScrollerCss('ag-scroller-corner', rightSpacing <= scrollbarWidth);
    // we pad the left based on a) if cols are pinned to the left and
    // b) if v scroll is showing on the left (happens in LTR layout only)
    var leftSpacing = this.columnModel.getDisplayedColumnsLeftWidth();
    var scrollOnLeft = this.enableRtl && vScrollShowing;
    if (scrollOnLeft) {
      leftSpacing += scrollbarWidth;
    }
    this.view.setLeftSpacerFixedWidth(leftSpacing);
    this.view.includeLeftSpacerScrollerCss('ag-scroller-corner', leftSpacing <= scrollbarWidth);
  };
  FakeHScrollCtrl.prototype.setScrollVisible = function () {
    var hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
    var invisibleScrollbar = this.invisibleScrollbar;
    var isSuppressHorizontalScroll = this.gridOptionsWrapper.isSuppressHorizontalScroll();
    var scrollbarWidth = hScrollShowing ? this.gridOptionsWrapper.getScrollbarWidth() || 0 : 0;
    var adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar ? 15 : scrollbarWidth;
    var scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
    var addIEPadding = isBrowserIE() && hScrollShowing;
    this.view.addOrRemoveCssClass('ag-scrollbar-invisible', invisibleScrollbar);
    this.view.setHeight(scrollContainerSize);
    // we have to add an extra pixel to the scroller viewport on IE because
    // if the container has the same size as the scrollbar, the scroll button won't work
    this.view.setViewportHeight(scrollContainerSize + (addIEPadding ? 1 : 0));
    this.view.setContainerHeight(scrollContainerSize);
  };
  FakeHScrollCtrl.prototype.getViewport = function () {
    return this.eViewport;
  };
  FakeHScrollCtrl.prototype.getContainer = function () {
    return this.eContainer;
  };
  __decorate$2b([Autowired('scrollVisibleService')], FakeHScrollCtrl.prototype, "scrollVisibleService", void 0);
  __decorate$2b([Autowired('columnModel')], FakeHScrollCtrl.prototype, "columnModel", void 0);
  __decorate$2b([Autowired('ctrlsService')], FakeHScrollCtrl.prototype, "ctrlsService", void 0);
  __decorate$2b([PostConstruct], FakeHScrollCtrl.prototype, "postConstruct", null);
  return FakeHScrollCtrl;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2u = undefined && undefined.__extends || function () {
  var _extendStatics159 = function extendStatics(d, b) {
    _extendStatics159 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics159(d, b);
  };
  return function (d, b) {
    _extendStatics159(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2c = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FakeHScrollComp = /** @class */function (_super) {
  __extends$2u(FakeHScrollComp, _super);
  function FakeHScrollComp() {
    return _super.call(this, FakeHScrollComp.TEMPLATE) || this;
  }
  FakeHScrollComp.prototype.postConstruct = function () {
    var _this = this;
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setHeight: function setHeight(height) {
        return setFixedHeight(_this.getGui(), height);
      },
      setContainerHeight: function setContainerHeight(height) {
        return setFixedHeight(_this.eContainer, height);
      },
      setViewportHeight: function setViewportHeight(height) {
        return setFixedHeight(_this.eViewport, height);
      },
      setRightSpacerFixedWidth: function setRightSpacerFixedWidth(width) {
        return setFixedWidth(_this.eRightSpacer, width);
      },
      setLeftSpacerFixedWidth: function setLeftSpacerFixedWidth(width) {
        return setFixedWidth(_this.eLeftSpacer, width);
      },
      includeLeftSpacerScrollerCss: function includeLeftSpacerScrollerCss(cssClass, include) {
        return addOrRemoveCssClass(_this.eLeftSpacer, cssClass, include);
      },
      includeRightSpacerScrollerCss: function includeRightSpacerScrollerCss(cssClass, include) {
        return addOrRemoveCssClass(_this.eRightSpacer, cssClass, include);
      }
    };
    var ctrl = this.createManagedBean(new FakeHScrollCtrl());
    ctrl.setComp(compProxy, this.getGui(), this.eViewport, this.eContainer);
    this.createManagedBean(new CenterWidthFeature(function (width) {
      return _this.eContainer.style.width = width + "px";
    }));
  };
  FakeHScrollComp.TEMPLATE = "<div class=\"ag-body-horizontal-scroll\" aria-hidden=\"true\">\n            <div class=\"ag-horizontal-left-spacer\" ref=\"eLeftSpacer\"></div>\n            <div class=\"ag-body-horizontal-scroll-viewport\" ref=\"eViewport\">\n                <div class=\"ag-body-horizontal-scroll-container\" ref=\"eContainer\"></div>\n            </div>\n            <div class=\"ag-horizontal-right-spacer\" ref=\"eRightSpacer\"></div>\n        </div>";
  __decorate$2c([RefSelector('eLeftSpacer')], FakeHScrollComp.prototype, "eLeftSpacer", void 0);
  __decorate$2c([RefSelector('eRightSpacer')], FakeHScrollComp.prototype, "eRightSpacer", void 0);
  __decorate$2c([RefSelector('eViewport')], FakeHScrollComp.prototype, "eViewport", void 0);
  __decorate$2c([RefSelector('eContainer')], FakeHScrollComp.prototype, "eContainer", void 0);
  __decorate$2c([PostConstruct], FakeHScrollComp.prototype, "postConstruct", null);
  return FakeHScrollComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2v = undefined && undefined.__extends || function () {
  var _extendStatics160 = function extendStatics(d, b) {
    _extendStatics160 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics160(d, b);
  };
  return function (d, b) {
    _extendStatics160(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2d = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PinnedWidthService = /** @class */function (_super) {
  __extends$2v(PinnedWidthService, _super);
  function PinnedWidthService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PinnedWidthService.prototype.postConstruct = function () {
    var listener = this.checkContainerWidths.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
    this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_DOM_LAYOUT, listener);
  };
  PinnedWidthService.prototype.checkContainerWidths = function () {
    var printLayout = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_PRINT;
    var newLeftWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsLeftWidth();
    var newRightWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
    if (newLeftWidth != this.leftWidth) {
      this.leftWidth = newLeftWidth;
      this.eventService.dispatchEvent({
        type: Events.EVENT_LEFT_PINNED_WIDTH_CHANGED
      });
    }
    if (newRightWidth != this.rightWidth) {
      this.rightWidth = newRightWidth;
      this.eventService.dispatchEvent({
        type: Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED
      });
    }
  };
  PinnedWidthService.prototype.getPinnedRightWidth = function () {
    return this.rightWidth;
  };
  PinnedWidthService.prototype.getPinnedLeftWidth = function () {
    return this.leftWidth;
  };
  __decorate$2d([Autowired('columnModel')], PinnedWidthService.prototype, "columnModel", void 0);
  __decorate$2d([PostConstruct], PinnedWidthService.prototype, "postConstruct", null);
  PinnedWidthService = __decorate$2d([Bean('pinnedWidthService')], PinnedWidthService);
  return PinnedWidthService;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2w = undefined && undefined.__extends || function () {
  var _extendStatics161 = function extendStatics(d, b) {
    _extendStatics161 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics161(d, b);
  };
  return function (d, b) {
    _extendStatics161(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2e = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PopupEditorWrapper = /** @class */function (_super) {
  __extends$2w(PopupEditorWrapper, _super);
  function PopupEditorWrapper(params) {
    var _this = _super.call(this, /* html */"<div class=\"ag-popup-editor\" tabindex=\"-1\"/>") || this;
    _this.params = params;
    return _this;
  }
  PopupEditorWrapper.prototype.postConstruct = function () {
    this.gridOptionsWrapper.setDomData(this.getGui(), PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
    this.addKeyDownListener();
  };
  PopupEditorWrapper.prototype.addKeyDownListener = function () {
    var _this = this;
    var eGui = this.getGui();
    var params = this.params;
    var listener = function listener(event) {
      if (!isUserSuppressingKeyboardEvent(_this.gridOptionsWrapper, event, params.node, params.column, true)) {
        params.onKeyDown(event);
      }
    };
    this.addManagedListener(eGui, 'keydown', listener);
  };
  PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = 'popupEditorWrapper';
  __decorate$2e([PostConstruct], PopupEditorWrapper.prototype, "postConstruct", null);
  return PopupEditorWrapper;
}(PopupComponent);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2x = undefined && undefined.__extends || function () {
  var _extendStatics162 = function extendStatics(d, b) {
    _extendStatics162 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics162(d, b);
  };
  return function (d, b) {
    _extendStatics162(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$e = undefined && undefined.__assign || function () {
  __assign$e = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$e.apply(this, arguments);
};
var CellComp = /** @class */function (_super) {
  __extends$2x(CellComp, _super);
  function CellComp(scope, beans, cellCtrl, autoHeightCell, printLayout, eRow, editingRow) {
    var _this = _super.call(this) || this;
    _this.scope = null;
    // every time we go into edit mode, or back again, this gets incremented.
    // it's the components way of dealing with the async nature of framework components,
    // so if a framework component takes a while to be created, we know if the object
    // is still relevant when creating is finished. eg we could click edit / un-edit 20
    // times before the first React edit component comes back - we should discard
    // the first 19.
    _this.rendererVersion = 0;
    _this.editorVersion = 0;
    _this.scope = scope;
    _this.beans = beans;
    _this.column = cellCtrl.getColumn();
    _this.rowNode = cellCtrl.getRowNode();
    _this.rowCtrl = cellCtrl.getRowCtrl();
    _this.autoHeightCell = autoHeightCell;
    _this.eRow = eRow;
    _this.setTemplate( /* html */"<div comp-id=\"" + _this.getCompId() + "\"/>");
    var eGui = _this.getGui();
    var style = eGui.style;
    _this.eCellValue = eGui;
    var setAttribute = function setAttribute(name, value, element) {
      var actualElement = element ? element : eGui;
      if (value != null && value != '') {
        actualElement.setAttribute(name, value);
      } else {
        actualElement.removeAttribute(name);
      }
    };
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setUserStyles: function setUserStyles(styles) {
        return addStylesToElement(eGui, styles);
      },
      setAriaSelected: function setAriaSelected(selected) {
        return _setAriaSelected(eGui, selected);
      },
      setAriaExpanded: function setAriaExpanded(selected) {
        return _setAriaExpanded(eGui, selected);
      },
      getFocusableElement: function getFocusableElement() {
        return _this.getFocusableElement();
      },
      setLeft: function setLeft(left) {
        return style.left = left;
      },
      setWidth: function setWidth(width) {
        return style.width = width;
      },
      setAriaColIndex: function setAriaColIndex(index) {
        return _setAriaColIndex(_this.getGui(), index);
      },
      setHeight: function setHeight(height) {
        return style.height = height;
      },
      setZIndex: function setZIndex(zIndex) {
        return style.zIndex = zIndex;
      },
      setTabIndex: function setTabIndex(tabIndex) {
        return setAttribute('tabindex', tabIndex.toString());
      },
      setRole: function setRole(role) {
        return setAriaRole(eGui, role);
      },
      setColId: function setColId(colId) {
        return setAttribute('col-id', colId);
      },
      setTitle: function setTitle(title) {
        return setAttribute('title', title);
      },
      setUnselectable: function setUnselectable(value) {
        return setAttribute('unselectable', value, _this.eCellValue);
      },
      setTransition: function setTransition(transition) {
        return style.transition = transition ? transition : '';
      },
      setIncludeSelection: function setIncludeSelection(include) {
        return _this.includeSelection = include;
      },
      setIncludeRowDrag: function setIncludeRowDrag(include) {
        return _this.includeRowDrag = include;
      },
      setIncludeDndSource: function setIncludeDndSource(include) {
        return _this.includeDndSource = include;
      },
      setForceWrapper: function setForceWrapper(force) {
        return _this.forceWrapper = force;
      },
      setRenderDetails: function setRenderDetails(compDetails, valueToDisplay, force) {
        return _this.setRenderDetails(compDetails, valueToDisplay, force);
      },
      setEditDetails: function setEditDetails(compDetails, popup, position) {
        return _this.setEditDetails(compDetails, popup, position);
      },
      getCellEditor: function getCellEditor() {
        return _this.cellEditor || null;
      },
      getCellRenderer: function getCellRenderer() {
        return _this.cellRenderer || null;
      },
      getParentOfValue: function getParentOfValue() {
        return _this.eCellValue;
      }
    };
    _this.cellCtrl = cellCtrl;
    cellCtrl.setComp(compProxy, _this.scope, _this.getGui(), printLayout, editingRow);
    return _this;
  }
  CellComp.prototype.setRenderDetails = function (compDetails, valueToDisplay, forceNewCellRendererInstance) {
    // this can happen if the users asks for the cell to refresh, but we are not showing the vale as we are editing
    var isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
    if (isInlineEditing) {
      return;
    }
    // this means firstRender will be true for one pass only, as it's initialised to undefined
    this.firstRender = this.firstRender == null;
    var usingAngular1Template = this.isUsingAngular1Template();
    // if display template has changed, means any previous Cell Renderer is in the wrong location
    var controlWrapperChanged = this.setupControlsWrapper();
    // all of these have dependencies on the eGui, so only do them after eGui is set
    if (compDetails) {
      var neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
      var cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
      if (!cellRendererRefreshSuccessful) {
        this.destroyRenderer();
        this.createCellRendererInstance(compDetails);
      }
    } else {
      this.destroyRenderer();
      if (usingAngular1Template) {
        this.insertValueUsingAngular1Template();
      } else {
        this.insertValueWithoutCellRenderer(valueToDisplay);
      }
    }
  };
  CellComp.prototype.setEditDetails = function (compDetails, popup, position) {
    if (compDetails) {
      this.createCellEditorInstance(compDetails, popup, position);
    } else {
      this.destroyEditor();
    }
  };
  CellComp.prototype.removeControlsWrapper = function () {
    this.eCellValue = this.getGui();
    this.eCellWrapper = null;
    this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp);
    this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp);
    this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
  };
  // returns true if wrapper was changed
  CellComp.prototype.setupControlsWrapper = function () {
    var usingWrapper = this.includeRowDrag || this.includeDndSource || this.includeSelection || this.forceWrapper;
    var changed = true;
    var notChanged = false;
    this.addOrRemoveCssClass('ag-cell-value', !usingWrapper);
    // turn wrapper on
    if (usingWrapper && !this.eCellWrapper) {
      this.addControlsWrapper();
      return changed;
    }
    // turn wrapper off
    if (!usingWrapper && this.eCellWrapper) {
      this.removeControlsWrapper();
      return changed;
    }
    return notChanged;
  };
  CellComp.prototype.addControlsWrapper = function () {
    var eGui = this.getGui();
    eGui.innerHTML = /* html */
    "<div ref=\"eCellWrapper\" class=\"ag-cell-wrapper\" role=\"presentation\">\n                <span ref=\"eCellValue\" class=\"ag-cell-value\" role=\"presentation\"></span>\n            </div>";
    this.eCellValue = this.getRefElement('eCellValue');
    this.eCellWrapper = this.getRefElement('eCellWrapper');
    if (!this.forceWrapper) {
      this.eCellValue.setAttribute('unselectable', 'on');
    }
    var id = this.eCellValue.id = "cell-" + this.getCompId();
    var describedByIds = [];
    if (this.includeRowDrag) {
      this.rowDraggingComp = this.cellCtrl.createRowDragComp();
      if (this.rowDraggingComp) {
        // put the checkbox in before the value
        this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue);
      }
    }
    if (this.includeDndSource) {
      this.dndSourceComp = this.cellCtrl.createDndSource();
      // put the checkbox in before the value
      this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue);
    }
    if (this.includeSelection) {
      this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox();
      this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue);
      describedByIds.push(this.checkboxSelectionComp.getCheckboxId());
    }
    describedByIds.push(id);
    _setAriaDescribedBy(this.getGui(), describedByIds.join(' '));
  };
  CellComp.prototype.createCellEditorInstance = function (compDetails, popup, position) {
    var _this = this;
    var versionCopy = this.editorVersion;
    var cellEditorPromise = compDetails.newAgStackInstance();
    if (!cellEditorPromise) {
      return;
    } // if empty, userComponentFactory already did a console message
    var params = compDetails.params;
    cellEditorPromise.then(function (c) {
      return _this.afterCellEditorCreated(versionCopy, c, params, popup, position);
    });
    // if we don't do this, and editor component is async, then there will be a period
    // when the component isn't present and keyboard navigation won't work - so example
    // of user hitting tab quickly (more quickly than renderers getting created) won't work
    var cellEditorAsync = missing(this.cellEditor);
    if (cellEditorAsync && params.cellStartedEdit) {
      this.cellCtrl.focusCell(true);
    }
  };
  CellComp.prototype.insertValueWithoutCellRenderer = function (valueToDisplay) {
    var escapedValue = valueToDisplay != null ? escapeString(valueToDisplay) : null;
    if (escapedValue != null) {
      this.eCellValue.innerHTML = escapedValue;
    } else {
      clearElement(this.eCellValue);
    }
  };
  CellComp.prototype.insertValueUsingAngular1Template = function () {
    var _this = this;
    var _a = this.column.getColDef(),
      template = _a.template,
      templateUrl = _a.templateUrl;
    var templateToInsert;
    if (template != null) {
      templateToInsert = template;
    } else if (templateUrl != null) {
      // first time this happens it will return nothing, as the template will still be loading async,
      // however once loaded it will refresh the cell and second time around it will be returned sync
      // as in cache.
      templateToInsert = this.beans.templateService.getTemplate(templateUrl, function () {
        return _this.cellCtrl.refreshCell({
          forceRefresh: true
        });
      });
    }
    if (templateToInsert != null) {
      this.eCellValue.innerHTML = templateToInsert;
      this.updateAngular1ScopeAndCompile();
    }
  };
  CellComp.prototype.destroyEditorAndRenderer = function () {
    this.destroyRenderer();
    this.destroyEditor();
  };
  CellComp.prototype.destroyRenderer = function () {
    var context = this.beans.context;
    this.cellRenderer = context.destroyBean(this.cellRenderer);
    removeFromParent(this.cellRendererGui);
    this.cellRendererGui = null;
    this.rendererVersion++;
  };
  CellComp.prototype.destroyEditor = function () {
    var context = this.beans.context;
    if (this.hideEditorPopup) {
      this.hideEditorPopup();
    }
    this.hideEditorPopup = undefined;
    this.cellEditor = context.destroyBean(this.cellEditor);
    this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
    removeFromParent(this.cellEditorGui);
    this.cellEditorGui = null;
    this.editorVersion++;
  };
  CellComp.prototype.refreshCellRenderer = function (compClassAndParams) {
    if (this.cellRenderer == null || this.cellRenderer.refresh == null) {
      return false;
    }
    // if different Cell Renderer configured this time (eg user is using selector, and
    // returns different component) then don't refresh, force recreate of Cell Renderer
    if (this.cellRendererClass !== compClassAndParams.componentClass) {
      return false;
    }
    // take any custom params off of the user
    var result = this.cellRenderer.refresh(compClassAndParams.params);
    // NOTE on undefined: previous version of the cellRenderer.refresh() interface
    // returned nothing, if the method existed, we assumed it refreshed. so for
    // backwards compatibility, we assume if method exists and returns nothing,
    // that it was successful.
    return result === true || result === undefined;
  };
  CellComp.prototype.createCellRendererInstance = function (compDetails) {
    var _this = this;
    // never use task service if angularCompileRows=true, as that assume the cell renderers
    // are finished when the row is created. also we never use it if animation frame service
    // is turned off.
    // and lastly we never use it if doing auto-height, as the auto-height service checks the
    // row height directly after the cell is created, it doesn't wait around for the tasks to complete
    var angularCompileRows = this.beans.gridOptionsWrapper.isAngularCompileRows();
    var suppressAnimationFrame = this.beans.gridOptionsWrapper.isSuppressAnimationFrame();
    var useTaskService = !angularCompileRows && !suppressAnimationFrame && !this.autoHeightCell;
    var displayComponentVersionCopy = this.rendererVersion;
    var componentClass = compDetails.componentClass;
    var createCellRendererFunc = function createCellRendererFunc() {
      var staleTask = _this.rendererVersion !== displayComponentVersionCopy || !_this.isAlive();
      if (staleTask) {
        return;
      }
      // this can return null in the event that the user has switched from a renderer component to nothing, for example
      // when using a cellRendererSelect to return a component or null depending on row data etc
      var componentPromise = compDetails.newAgStackInstance();
      var callback = _this.afterCellRendererCreated.bind(_this, displayComponentVersionCopy, componentClass);
      if (componentPromise) {
        componentPromise.then(callback);
      }
    };
    // we only use task service when rendering for first time, which means it is not used when doing edits.
    // if we changed this (always use task service) would make sense, however it would break tests, possibly
    // test of users.
    if (useTaskService && this.firstRender) {
      this.beans.animationFrameService.createTask(createCellRendererFunc, this.rowNode.rowIndex, 'createTasksP2');
    } else {
      createCellRendererFunc();
    }
  };
  CellComp.prototype.isUsingAngular1Template = function () {
    var colDef = this.column.getColDef();
    var res = colDef.template != null || colDef.templateUrl != null;
    return res;
  };
  CellComp.prototype.getCtrl = function () {
    return this.cellCtrl;
  };
  CellComp.prototype.getRowCtrl = function () {
    return this.rowCtrl;
  };
  CellComp.prototype.getCellRenderer = function () {
    return this.cellRenderer;
  };
  CellComp.prototype.getCellEditor = function () {
    return this.cellEditor;
  };
  CellComp.prototype.afterCellRendererCreated = function (cellRendererVersion, cellRendererClass, cellRenderer) {
    var staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
    if (staleTask) {
      this.beans.context.destroyBean(cellRenderer);
      return;
    }
    this.cellRenderer = cellRenderer;
    this.cellRendererClass = cellRendererClass;
    this.cellRendererGui = this.cellRenderer.getGui();
    if (this.cellRendererGui != null) {
      clearElement(this.eCellValue);
      this.eCellValue.appendChild(this.cellRendererGui);
      this.updateAngular1ScopeAndCompile();
    }
  };
  CellComp.prototype.afterCellEditorCreated = function (requestVersion, cellEditor, params, popup, position) {
    // if editingCell=false, means user cancelled the editor before component was ready.
    // if versionMismatch, then user cancelled the edit, then started the edit again, and this
    //   is the first editor which is now stale.
    var staleComp = requestVersion !== this.editorVersion;
    if (staleComp) {
      this.beans.context.destroyBean(cellEditor);
      return;
    }
    var editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
    if (editingCancelledByUserComp) {
      this.beans.context.destroyBean(cellEditor);
      this.cellCtrl.stopEditing();
      return;
    }
    if (!cellEditor.getGui) {
      console.warn("AG Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
      this.beans.context.destroyBean(cellEditor);
      return;
    }
    this.cellEditor = cellEditor;
    this.cellEditorGui = cellEditor.getGui();
    var cellEditorInPopup = popup || cellEditor.isPopup !== undefined && cellEditor.isPopup();
    if (cellEditorInPopup) {
      if (!popup) {
        this.cellCtrl.hackSayEditingInPopup();
      }
      this.addPopupCellEditor(params, position);
    } else {
      this.addInCellEditor();
    }
    if (cellEditor.afterGuiAttached) {
      cellEditor.afterGuiAttached();
    }
  };
  CellComp.prototype.addInCellEditor = function () {
    var eGui = this.getGui();
    // if focus is inside the cell, we move focus to the cell itself
    // before removing it's contents, otherwise errors could be thrown.
    if (eGui.contains(document.activeElement)) {
      eGui.focus();
    }
    this.destroyRenderer();
    this.removeControlsWrapper();
    this.clearCellElement();
    if (this.cellEditorGui) {
      eGui.appendChild(this.cellEditorGui);
    }
  };
  CellComp.prototype.addPopupCellEditor = function (params, position) {
    var _this = this;
    if (this.beans.gridOptionsWrapper.isFullRowEdit()) {
      console.warn('AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' + '- either turn off fullRowEdit, or stop using popup editors.');
    }
    var cellEditor = this.cellEditor;
    // if a popup, then we wrap in a popup editor and return the popup
    this.cellEditorPopupWrapper = this.beans.context.createBean(new PopupEditorWrapper(params));
    var ePopupGui = this.cellEditorPopupWrapper.getGui();
    if (this.cellEditorGui) {
      ePopupGui.appendChild(this.cellEditorGui);
    }
    var popupService = this.beans.popupService;
    var useModelPopup = this.beans.gridOptionsWrapper.isStopEditingWhenCellsLoseFocus();
    // see if position provided by colDef, if not then check old way of method on cellComp
    var positionToUse = position != null ? position : cellEditor.getPopupPosition ? cellEditor.getPopupPosition() : 'over';
    var positionParams = {
      column: this.column,
      rowNode: this.rowNode,
      type: 'popupCellEditor',
      eventSource: this.getGui(),
      ePopup: ePopupGui,
      keepWithinBounds: true
    };
    var positionCallback = position === 'under' ? popupService.positionPopupUnderComponent.bind(popupService, positionParams) : popupService.positionPopupOverComponent.bind(popupService, positionParams);
    var translate = this.beans.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = popupService.addPopup({
      modal: useModelPopup,
      eChild: ePopupGui,
      closeOnEsc: true,
      closedCallback: function closedCallback() {
        _this.cellCtrl.onPopupEditorClosed();
      },
      anchorToElement: this.getGui(),
      positionCallback: positionCallback,
      ariaLabel: translate('ariaLabelCellEditor', 'Cell Editor')
    });
    if (addPopupRes) {
      this.hideEditorPopup = addPopupRes.hideFunc;
    }
  };
  CellComp.prototype.detach = function () {
    this.eRow.removeChild(this.getGui());
  };
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  CellComp.prototype.destroy = function () {
    this.cellCtrl.stopEditing();
    this.destroyEditorAndRenderer();
    this.removeControlsWrapper();
    if (this.angularCompiledElement) {
      this.angularCompiledElement.remove();
      this.angularCompiledElement = undefined;
    }
    _super.prototype.destroy.call(this);
  };
  CellComp.prototype.clearCellElement = function () {
    var eGui = this.getGui();
    // if focus is inside the cell, we move focus to the cell itself
    // before removing it's contents, otherwise errors could be thrown.
    if (eGui.contains(document.activeElement) && !isBrowserIE()) {
      eGui.focus({
        preventScroll: true
      });
    }
    clearElement(eGui);
  };
  CellComp.prototype.updateAngular1ScopeAndCompile = function () {
    if (this.beans.gridOptionsWrapper.isAngularCompileRows() && this.scope) {
      this.scope.data = __assign$e({}, this.rowNode.data);
      if (this.angularCompiledElement) {
        this.angularCompiledElement.remove();
      }
      this.angularCompiledElement = this.beans.$compile(this.eCellValue.children)(this.scope);
      // because this.scope is set, we are guaranteed GridBodyComp is vanilla JS, ie it's GridBodyComp.ts from AG Stack and and not react
      this.beans.ctrlsService.getGridBodyCtrl().requestAngularApply();
    }
  };
  return CellComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2y = undefined && undefined.__extends || function () {
  var _extendStatics163 = function extendStatics(d, b) {
    _extendStatics163 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics163(d, b);
  };
  return function (d, b) {
    _extendStatics163(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RowComp = /** @class */function (_super) {
  __extends$2y(RowComp, _super);
  function RowComp(ctrl, beans, pinned) {
    var _this = _super.call(this) || this;
    _this.cellComps = {};
    _this.beans = beans;
    _this.rowCtrl = ctrl;
    _this.setTemplate( /* html */"<div comp-id=\"" + _this.getCompId() + "\" style=\"" + _this.getInitialStyle() + "\"/>");
    var eGui = _this.getGui();
    var style = eGui.style;
    var compProxy = {
      setDisplay: function setDisplay(value) {
        if (value == null) {
          style.removeProperty('display');
        } else {
          style.setProperty('display', 'none');
        }
      },
      setDomOrder: function setDomOrder(domOrder) {
        return _this.domOrder = domOrder;
      },
      setCellCtrls: function setCellCtrls(cellCtrls) {
        return _this.setCellCtrls(cellCtrls);
      },
      showFullWidth: function showFullWidth(compDetails) {
        return _this.showFullWidth(compDetails);
      },
      getFullWidthCellRenderer: function getFullWidthCellRenderer() {
        return _this.getFullWidthCellRenderer();
      },
      addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
        return _this.addOrRemoveCssClass(name, on);
      },
      setAriaExpanded: function setAriaExpanded(on) {
        return _setAriaExpanded(eGui, on);
      },
      setUserStyles: function setUserStyles(styles) {
        return addStylesToElement(eGui, styles);
      },
      setAriaSelected: function setAriaSelected(value) {
        return _setAriaSelected(eGui, value);
      },
      setAriaLabel: function setAriaLabel(value) {
        _setAriaLabel(eGui, value == null ? '' : value);
      },
      setHeight: function setHeight(height) {
        return style.height = height;
      },
      setTop: function setTop(top) {
        return style.top = top;
      },
      setTransform: function setTransform(transform) {
        return style.transform = transform;
      },
      setRowIndex: function setRowIndex(rowIndex) {
        return eGui.setAttribute('row-index', rowIndex);
      },
      setRole: function setRole(role) {
        return setAriaRole(eGui, role);
      },
      setAriaRowIndex: function setAriaRowIndex(rowIndex) {
        return _setAriaRowIndex(_this.getGui(), rowIndex);
      },
      setRowId: function setRowId(rowId) {
        return eGui.setAttribute('row-id', rowId);
      },
      setRowBusinessKey: function setRowBusinessKey(businessKey) {
        return eGui.setAttribute('row-business-key', businessKey);
      },
      setTabIndex: function setTabIndex(tabIndex) {
        return eGui.setAttribute('tabindex', tabIndex.toString());
      }
    };
    ctrl.setComp(compProxy, _this.getGui(), pinned);
    return _this;
  }
  RowComp.prototype.getInitialStyle = function () {
    var transform = this.rowCtrl.getInitialTransform();
    var top = this.rowCtrl.getInitialRowTop();
    return transform ? "transform: " + transform : "top: " + top;
  };
  RowComp.prototype.showFullWidth = function (compDetails) {
    var _this = this;
    var callback = function callback(cellRenderer) {
      if (_this.isAlive()) {
        var eGui = cellRenderer.getGui();
        _this.getGui().appendChild(eGui);
        if (_this.rowCtrl.getRowType() === RowType.FullWidthDetail) {
          _this.rowCtrl.setupDetailRowAutoHeight(eGui);
        }
        _this.setFullWidthRowComp(cellRenderer);
      } else {
        _this.beans.context.destroyBean(cellRenderer);
      }
    };
    // if not in cache, create new one
    var res = compDetails.newAgStackInstance(this.rowCtrl.getFullWidthCellRendererType());
    if (!res) {
      return;
    }
    res.then(callback);
  };
  RowComp.prototype.setCellCtrls = function (cellCtrls) {
    var _this = this;
    var cellsToRemove = assign$3({}, this.cellComps);
    cellCtrls.forEach(function (cellCtrl) {
      var key = cellCtrl.getInstanceId();
      var existingCellComp = _this.cellComps[key];
      if (existingCellComp == null) {
        _this.newCellComp(cellCtrl);
      } else {
        cellsToRemove[key] = null;
      }
    });
    var cellCompsToRemove = getAllValuesInObject(cellsToRemove).filter(function (cellComp) {
      return cellComp != null;
    });
    this.destroyCells(cellCompsToRemove);
    this.ensureDomOrder(cellCtrls);
  };
  RowComp.prototype.ensureDomOrder = function (cellCtrls) {
    var _this = this;
    if (!this.domOrder) {
      return;
    }
    var elementsInOrder = [];
    cellCtrls.forEach(function (cellCtrl) {
      var cellComp = _this.cellComps[cellCtrl.getInstanceId()];
      if (cellComp) {
        elementsInOrder.push(cellComp.getGui());
      }
    });
    setDomChildOrder(this.getGui(), elementsInOrder);
  };
  RowComp.prototype.newCellComp = function (cellCtrl) {
    var cellComp = new CellComp(this.rowCtrl.getScope(), this.beans, cellCtrl, false, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
    this.cellComps[cellCtrl.getInstanceId()] = cellComp;
    this.getGui().appendChild(cellComp.getGui());
  };
  RowComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    this.destroyAllCells();
  };
  RowComp.prototype.destroyAllCells = function () {
    var cellsToDestroy = getAllValuesInObject(this.cellComps).filter(function (cp) {
      return cp != null;
    });
    this.destroyCells(cellsToDestroy);
  };
  RowComp.prototype.setFullWidthRowComp = function (fullWidthRowComponent) {
    var _this = this;
    if (this.fullWidthCellRenderer) {
      console.error('AG Grid - should not be setting fullWidthRowComponent twice');
    }
    this.fullWidthCellRenderer = fullWidthRowComponent;
    this.addDestroyFunc(function () {
      _this.fullWidthCellRenderer = _this.beans.context.destroyBean(_this.fullWidthCellRenderer);
    });
  };
  RowComp.prototype.getFullWidthCellRenderer = function () {
    return this.fullWidthCellRenderer;
  };
  RowComp.prototype.destroyCells = function (cellComps) {
    var _this = this;
    cellComps.forEach(function (cellComp) {
      // could be old reference, ie removed cell
      if (!cellComp) {
        return;
      }
      // check cellComp belongs in this container
      var instanceId = cellComp.getCtrl().getInstanceId();
      if (_this.cellComps[instanceId] !== cellComp) {
        return;
      }
      cellComp.detach();
      cellComp.destroy();
      _this.cellComps[instanceId] = null;
    });
  };
  return RowComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2z = undefined && undefined.__extends || function () {
  var _extendStatics164 = function extendStatics(d, b) {
    _extendStatics164 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics164(d, b);
  };
  return function (d, b) {
    _extendStatics164(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$f = undefined && undefined.__assign || function () {
  __assign$f = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$f.apply(this, arguments);
};
var __decorate$2f = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function templateFactory() {
  var name = Component.elementGettingCreated.getAttribute('name');
  var cssClasses = RowContainerCtrl.getRowContainerCssClasses(name);
  var res;
  var template1 = name === RowContainerName.CENTER;
  var template2 = name === RowContainerName.TOP_CENTER || name === RowContainerName.BOTTOM_CENTER;
  if (template1) {
    res = /* html */
    "<div class=\"" + cssClasses.wrapper + "\" ref=\"eWrapper\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"" + cssClasses.viewport + "\" ref=\"eViewport\" role=\"presentation\">\n                    <div class=\"" + cssClasses.container + "\" ref=\"eContainer\" role=\"rowgroup\" unselectable=\"on\"></div>\n                </div>\n            </div>";
  } else if (template2) {
    res = /* html */
    "<div class=\"" + cssClasses.viewport + "\" ref=\"eViewport\" role=\"presentation\" unselectable=\"on\">\n                <div class=\"" + cssClasses.container + "\" ref=\"eContainer\" role=\"presentation\" unselectable=\"on\"></div>\n            </div>";
  } else {
    res = /* html */
    "<div class=\"" + cssClasses.container + "\" ref=\"eContainer\" role=\"presentation\" unselectable=\"on\"></div>";
  }
  return res;
}
var RowContainerComp = /** @class */function (_super) {
  __extends$2z(RowContainerComp, _super);
  function RowContainerComp() {
    var _this = _super.call(this, templateFactory()) || this;
    _this.rowComps = {};
    _this.name = Component.elementGettingCreated.getAttribute('name');
    return _this;
  }
  RowContainerComp.prototype.postConstruct = function () {
    var _this = this;
    var compProxy = {
      setViewportHeight: function setViewportHeight(height) {
        return _this.eViewport.style.height = height;
      },
      setRowCtrls: function setRowCtrls(rowCtrls) {
        return _this.setRowCtrls(rowCtrls);
      },
      setDomOrder: function setDomOrder(domOrder) {
        _this.domOrder = domOrder;
      },
      setContainerWidth: function setContainerWidth(width) {
        return _this.eContainer.style.width = width;
      }
    };
    var ctrl = this.createManagedBean(new RowContainerCtrl(this.name));
    ctrl.setComp(compProxy, this.eContainer, this.eViewport, this.eWrapper);
  };
  RowContainerComp.prototype.preDestroy = function () {
    // destroys all row comps
    this.setRowCtrls([]);
  };
  RowContainerComp.prototype.setRowCtrls = function (rowCtrls) {
    var _this = this;
    var oldRows = __assign$f({}, this.rowComps);
    this.rowComps = {};
    this.lastPlacedElement = null;
    var processRow = function processRow(rowCon) {
      var instanceId = rowCon.getInstanceId();
      var existingRowComp = oldRows[instanceId];
      if (existingRowComp) {
        _this.rowComps[instanceId] = existingRowComp;
        delete oldRows[instanceId];
        _this.ensureDomOrder(existingRowComp.getGui());
      } else {
        var rowComp = _this.newRowComp(rowCon);
        _this.rowComps[instanceId] = rowComp;
        _this.appendRow(rowComp.getGui());
      }
    };
    rowCtrls.forEach(processRow);
    getAllValuesInObject(oldRows).forEach(function (oldRowComp) {
      _this.eContainer.removeChild(oldRowComp.getGui());
      oldRowComp.destroy();
    });
  };
  RowContainerComp.prototype.appendRow = function (element) {
    if (this.domOrder) {
      insertWithDomOrder(this.eContainer, element, this.lastPlacedElement);
    } else {
      this.eContainer.appendChild(element);
    }
    this.lastPlacedElement = element;
  };
  RowContainerComp.prototype.ensureDomOrder = function (eRow) {
    if (this.domOrder) {
      ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
      this.lastPlacedElement = eRow;
    }
  };
  RowContainerComp.prototype.newRowComp = function (rowCtrl) {
    var pinned = RowContainerCtrl.getPinned(this.name);
    var res = new RowComp(rowCtrl, this.beans, pinned);
    return res;
  };
  __decorate$2f([Autowired('beans')], RowContainerComp.prototype, "beans", void 0);
  __decorate$2f([RefSelector('eViewport')], RowContainerComp.prototype, "eViewport", void 0);
  __decorate$2f([RefSelector('eContainer')], RowContainerComp.prototype, "eContainer", void 0);
  __decorate$2f([RefSelector('eWrapper')], RowContainerComp.prototype, "eWrapper", void 0);
  __decorate$2f([PostConstruct], RowContainerComp.prototype, "postConstruct", null);
  __decorate$2f([PreDestroy], RowContainerComp.prototype, "preDestroy", null);
  return RowContainerComp;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2A = undefined && undefined.__extends || function () {
  var _extendStatics165 = function extendStatics(d, b) {
    _extendStatics165 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics165(d, b);
  };
  return function (d, b) {
    _extendStatics165(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2g = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowNodeEventThrottle = /** @class */function (_super) {
  __extends$2A(RowNodeEventThrottle, _super);
  function RowNodeEventThrottle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.events = [];
    return _this;
  }
  RowNodeEventThrottle.prototype.postConstruct = function () {
    if (this.rowModel.getType() == Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      this.clientSideRowModel = this.rowModel;
    }
  };
  // because the user can call rowNode.setExpanded() many times in one VM turn,
  // we throttle the calls to ClientSideRowModel using animationFrameService. this means for 100
  // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
  // CSRM has updated.
  // 
  // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
  // to re-render 100+ times, which would be a performance lag.
  //    
  // we use animationFrameService
  // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
  // (eg user calls api.ensureRowVisible(), which in turn flushes ).
  RowNodeEventThrottle.prototype.dispatchExpanded = function (event) {
    var _this = this;
    this.events.push(event);
    if (this.dispatchExpandedDebounced == null) {
      this.dispatchExpandedDebounced = this.animationFrameService.debounce(function () {
        _this.clientSideRowModel && _this.clientSideRowModel.onRowGroupOpened();
        _this.events.forEach(function (e) {
          return _this.eventService.dispatchEvent(e);
        });
        _this.events = [];
      });
    }
    this.dispatchExpandedDebounced();
  };
  __decorate$2g([Autowired('animationFrameService')], RowNodeEventThrottle.prototype, "animationFrameService", void 0);
  __decorate$2g([Autowired('rowModel')], RowNodeEventThrottle.prototype, "rowModel", void 0);
  __decorate$2g([PostConstruct], RowNodeEventThrottle.prototype, "postConstruct", null);
  RowNodeEventThrottle = __decorate$2g([Bean('rowNodeEventThrottle')], RowNodeEventThrottle);
  return RowNodeEventThrottle;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2B = undefined && undefined.__extends || function () {
  var _extendStatics166 = function extendStatics(d, b) {
    _extendStatics166 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics166(d, b);
  };
  return function (d, b) {
    _extendStatics166(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2h = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StandardMenuFactory = /** @class */function (_super) {
  __extends$2B(StandardMenuFactory, _super);
  function StandardMenuFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  StandardMenuFactory.prototype.hideActiveMenu = function () {
    if (this.hidePopup) {
      this.hidePopup();
    }
  };
  StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
    var _this = this;
    this.showPopup(column, function (eMenu) {
      _this.popupService.positionPopupUnderMouseEvent({
        column: column,
        type: 'columnMenu',
        mouseEvent: mouseEvent,
        ePopup: eMenu
      });
    }, mouseEvent.target);
  };
  StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource, containerType) {
    var _this = this;
    this.showPopup(column, function (eMenu) {
      _this.popupService.positionPopupUnderComponent({
        type: containerType,
        eventSource: eventSource,
        ePopup: eMenu,
        keepWithinBounds: true,
        column: column
      });
    }, eventSource);
  };
  StandardMenuFactory.prototype.showPopup = function (column, _positionCallback, eventSource) {
    var _this = this;
    var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, 'COLUMN_MENU');
    var eMenu = document.createElement('div');
    setAriaRole(eMenu, 'presentation');
    addCssClass(eMenu, 'ag-menu');
    this.tabListener = this.addManagedListener(eMenu, 'keydown', function (e) {
      return _this.trapFocusWithin(e, eMenu);
    });
    filterWrapper.guiPromise.then(function (gui) {
      return eMenu.appendChild(gui);
    });
    var hidePopup;
    var anchorToElement = eventSource || this.ctrlsService.getGridBodyCtrl().getGui();
    var closedCallback = function closedCallback(e) {
      column.setMenuVisible(false, 'contextMenu');
      var isKeyboardEvent = e instanceof KeyboardEvent;
      if (_this.tabListener) {
        _this.tabListener = _this.tabListener();
      }
      if (isKeyboardEvent && eventSource && isVisible(eventSource)) {
        var focusableEl = _this.focusService.findTabbableParent(eventSource);
        if (focusableEl) {
          focusableEl.focus();
        }
      }
    };
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: eMenu,
      closeOnEsc: true,
      closedCallback: closedCallback,
      positionCallback: function positionCallback() {
        return _positionCallback(eMenu);
      },
      anchorToElement: anchorToElement,
      ariaLabel: translate('ariaLabelColumnMenu', 'Column Menu')
    });
    if (addPopupRes) {
      this.hidePopup = hidePopup = addPopupRes.hideFunc;
    }
    filterWrapper.filterPromise.then(function (filter) {
      // need to make sure the filter is present before positioning, as only
      // after filter it is visible can we find out what the width of it is
      _positionCallback(eMenu);
      if (filter.afterGuiAttached) {
        filter.afterGuiAttached({
          container: 'columnMenu',
          hidePopup: hidePopup
        });
      }
    });
    column.setMenuVisible(true, 'contextMenu');
  };
  StandardMenuFactory.prototype.trapFocusWithin = function (e, menu) {
    if (e.keyCode !== KeyCode.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(menu, false, e.shiftKey)) {
      return;
    }
    e.preventDefault();
    this.focusService.focusInto(menu, e.shiftKey);
  };
  StandardMenuFactory.prototype.isMenuEnabled = function (column) {
    // for standard, we show menu if filter is enabled, and the menu is not suppressed
    return column.isFilterAllowed();
  };
  __decorate$2h([Autowired('filterManager')], StandardMenuFactory.prototype, "filterManager", void 0);
  __decorate$2h([Autowired('popupService')], StandardMenuFactory.prototype, "popupService", void 0);
  __decorate$2h([Autowired('focusService')], StandardMenuFactory.prototype, "focusService", void 0);
  __decorate$2h([Autowired('ctrlsService')], StandardMenuFactory.prototype, "ctrlsService", void 0);
  StandardMenuFactory = __decorate$2h([Bean('menuFactory')], StandardMenuFactory);
  return StandardMenuFactory;
}(BeanStub);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
// creates JavaScript vanilla Grid, including JavaScript (ag-stack) components, which can
// be wrapped by the framework wrappers
var Grid = /** @class */function () {
  function Grid(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
      console.error('AG Grid: no gridOptions provided to the grid');
      return;
    }
    this.gridOptions = gridOptions;
    new GridCoreCreator().create(eGridDiv, gridOptions, function (context) {
      var gridComp = new GridComp(eGridDiv);
      context.createBean(gridComp);
    }, params);
  }
  Grid.prototype.destroy = function () {
    if (this.gridOptions && this.gridOptions.api) {
      this.gridOptions.api.destroy();
    }
  };
  return Grid;
}();
// created services of grid only, no UI, so frameworks can use this if providing
// their own UI
var GridCoreCreator = /** @class */function () {
  function GridCoreCreator() {}
  GridCoreCreator.prototype.create = function (eGridDiv, gridOptions, uiCallback, params) {
    var _this = this;
    var debug = !!gridOptions.debug;
    var registeredModules = this.getRegisteredModules(params);
    var beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules);
    var providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
    if (!beanClasses) {
      return;
    } // happens when no row model found
    var contextParams = {
      providedBeanInstances: providedBeanInstances,
      beanClasses: beanClasses,
      debug: debug
    };
    var logger = new Logger('AG Grid', function () {
      return gridOptions.debug;
    });
    var contextLogger = new Logger('Context', function () {
      return contextParams.debug;
    });
    var context = new Context(contextParams, contextLogger);
    var beans = context.getBean('beans');
    this.registerModuleUserComponents(beans, registeredModules);
    this.registerStackComponents(beans, registeredModules);
    this.registerControllers(beans, registeredModules);
    uiCallback(context);
    // we wait until the UI has finished initialising before setting in columns and rows
    beans.ctrlsService.whenReady(function () {
      _this.setColumnsAndData(beans);
      _this.dispatchGridReadyEvent(beans, gridOptions);
      var isEnterprise = ModuleRegistry.isRegistered(ModuleNames.EnterpriseCoreModule);
      logger.log("initialised successfully, enterprise = " + isEnterprise);
    });
  };
  GridCoreCreator.prototype.registerControllers = function (beans, registeredModules) {
    registeredModules.forEach(function (module) {
      module.controllers && module.controllers.forEach(function (meta) {
        return beans.ctrlsFactory.register(meta);
      });
    });
  };
  GridCoreCreator.prototype.registerStackComponents = function (beans, registeredModules) {
    var agStackComponents = this.createAgStackComponentsList(registeredModules);
    beans.agStackComponentsRegistry.setupComponents(agStackComponents);
  };
  GridCoreCreator.prototype.getRegisteredModules = function (params) {
    var passedViaConstructor = params ? params.modules : null;
    var registered = ModuleRegistry.getRegisteredModules();
    var allModules = [];
    var mapNames = {};
    // adds to list and removes duplicates
    function addModule(moduleBased, mod) {
      function addIndividualModule(currentModule) {
        if (!mapNames[currentModule.moduleName]) {
          mapNames[currentModule.moduleName] = true;
          allModules.push(currentModule);
          ModuleRegistry.register(currentModule, moduleBased);
        }
      }
      addIndividualModule(mod);
      if (mod.dependantModules) {
        mod.dependantModules.forEach(addModule.bind(null, moduleBased));
      }
    }
    if (passedViaConstructor) {
      passedViaConstructor.forEach(addModule.bind(null, true));
    }
    if (registered) {
      registered.forEach(addModule.bind(null, !ModuleRegistry.isPackageBased()));
    }
    return allModules;
  };
  GridCoreCreator.prototype.registerModuleUserComponents = function (beans, registeredModules) {
    var moduleUserComps = this.extractModuleEntity(registeredModules, function (module) {
      return module.userComponents ? module.userComponents : [];
    });
    moduleUserComps.forEach(function (compMeta) {
      beans.userComponentRegistry.registerDefaultComponent(compMeta.componentName, compMeta.componentClass);
    });
  };
  GridCoreCreator.prototype.createProvidedBeans = function (eGridDiv, gridOptions, params) {
    var frameworkOverrides = params ? params.frameworkOverrides : null;
    if (missing(frameworkOverrides)) {
      frameworkOverrides = new VanillaFrameworkOverrides();
    }
    var seed = {
      gridOptions: gridOptions,
      eGridDiv: eGridDiv,
      $scope: params ? params.$scope : null,
      $compile: params ? params.$compile : null,
      globalEventListener: params ? params.globalEventListener : null,
      frameworkOverrides: frameworkOverrides
    };
    if (params && params.providedBeanInstances) {
      assign$3(seed, params.providedBeanInstances);
    }
    return seed;
  };
  GridCoreCreator.prototype.createAgStackComponentsList = function (registeredModules) {
    var components = [{
      componentName: 'AgCheckbox',
      componentClass: AgCheckbox
    }, {
      componentName: 'AgRadioButton',
      componentClass: AgRadioButton
    }, {
      componentName: 'AgToggleButton',
      componentClass: AgToggleButton
    }, {
      componentName: 'AgInputTextField',
      componentClass: AgInputTextField
    }, {
      componentName: 'AgInputTextArea',
      componentClass: AgInputTextArea
    }, {
      componentName: 'AgInputNumberField',
      componentClass: AgInputNumberField
    }, {
      componentName: 'AgInputRange',
      componentClass: AgInputRange
    }, {
      componentName: 'AgSelect',
      componentClass: AgSelect
    }, {
      componentName: 'AgSlider',
      componentClass: AgSlider
    }, {
      componentName: 'AgAngleSelect',
      componentClass: AgAngleSelect
    }, {
      componentName: 'AgColorPicker',
      componentClass: AgColorPicker
    }, {
      componentName: 'AgGridBody',
      componentClass: GridBodyComp
    }, {
      componentName: 'AgHeaderRoot',
      componentClass: GridHeaderComp
    }, {
      componentName: 'AgPagination',
      componentClass: PaginationComp
    }, {
      componentName: 'AgOverlayWrapper',
      componentClass: OverlayWrapperComponent
    }, {
      componentName: 'AgGroupComponent',
      componentClass: AgGroupComponent
    }, {
      componentName: 'AgPanel',
      componentClass: AgPanel
    }, {
      componentName: 'AgDialog',
      componentClass: AgDialog
    }, {
      componentName: 'AgRowContainer',
      componentClass: RowContainerComp
    }, {
      componentName: 'AgFakeHorizontalScroll',
      componentClass: FakeHScrollComp
    }];
    var moduleAgStackComps = this.extractModuleEntity(registeredModules, function (module) {
      return module.agStackComponents ? module.agStackComponents : [];
    });
    components = components.concat(moduleAgStackComps);
    return components;
  };
  GridCoreCreator.prototype.createBeansList = function (rowModelType, registeredModules) {
    var rowModelClass = this.getRowModelClass(rowModelType, registeredModules);
    if (!rowModelClass) {
      return;
    }
    // beans should only contain SERVICES, it should NEVER contain COMPONENTS
    var beans = [rowModelClass, Beans, RowPositionUtils, CellPositionUtils, HeaderPositionUtils, PaginationAutoPageSizeService, GridApi, UserComponentRegistry, AgComponentUtils, ComponentMetadataProvider, ResizeObserverService, UserComponentFactory, RowContainerHeightService, HorizontalResizeService, PinnedRowModel, DragService, DisplayedGroupCreator, EventService, GridOptionsWrapper, PopupService, SelectionService, FilterManager, ColumnModel, HeaderNavigationService, PaginationProxy, RowRenderer, ExpressionService, ColumnFactory, TemplateService, AlignedGridsService, NavigationService, ValueCache, ValueService, LoggerFactory, ColumnUtils, AutoWidthCalculator, StandardMenuFactory, DragAndDropService, ColumnApi, FocusService, MouseEventService, Environment, CellNavigationService, ValueFormatterService, StylingService, ScrollVisibleService, SortController, ColumnHoverService, ColumnAnimationService, SelectableService, AutoGroupColService, ChangeDetectionService, AnimationFrameService, UndoRedoService, AgStackComponentsRegistry, ColumnDefFactory, RowCssClassCalculator, RowNodeBlockLoader, RowNodeSorter, CtrlsService, PinnedWidthService, RowNodeEventThrottle, CtrlsFactory];
    var moduleBeans = this.extractModuleEntity(registeredModules, function (module) {
      return module.beans ? module.beans : [];
    });
    beans.push.apply(beans, moduleBeans);
    // check for duplicates, as different modules could include the same beans that
    // they depend on, eg ClientSideRowModel in enterprise, and ClientSideRowModel in community
    var beansNoDuplicates = [];
    beans.forEach(function (bean) {
      if (beansNoDuplicates.indexOf(bean) < 0) {
        beansNoDuplicates.push(bean);
      }
    });
    return beansNoDuplicates;
  };
  GridCoreCreator.prototype.extractModuleEntity = function (moduleEntities, extractor) {
    return [].concat.apply([], moduleEntities.map(extractor));
  };
  GridCoreCreator.prototype.setColumnsAndData = function (beans) {
    var columnDefs = beans.gridOptionsWrapper.getColumnDefs();
    beans.columnModel.setColumnDefs(columnDefs || [], "gridInitializing");
    beans.rowModel.start();
  };
  GridCoreCreator.prototype.dispatchGridReadyEvent = function (beans, gridOptions) {
    var readyEvent = {
      type: Events.EVENT_GRID_READY,
      api: gridOptions.api,
      columnApi: gridOptions.columnApi
    };
    beans.eventService.dispatchEvent(readyEvent);
  };
  GridCoreCreator.prototype.getRowModelClass = function (rowModelType, registeredModules) {
    // default to client side
    if (!rowModelType) {
      rowModelType = Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
    }
    var rowModelClasses = {};
    registeredModules.forEach(function (module) {
      iterateObject(module.rowModels, function (key, value) {
        rowModelClasses[key] = value;
      });
    });
    var rowModelClass = rowModelClasses[rowModelType];
    if (exists(rowModelClass)) {
      return rowModelClass;
    }
    if (rowModelType === Constants.ROW_MODEL_TYPE_INFINITE) {
      console.error("AG Grid: Row Model \"Infinite\" not found. Please ensure the " + ModuleNames.InfiniteRowModelModule + " is registered.';");
    }
    console.error('AG Grid: could not find matching row model for rowModelType ' + rowModelType);
    if (rowModelType === Constants.ROW_MODEL_TYPE_VIEWPORT) {
      console.error("AG Grid: Row Model \"Viewport\" not found. Please ensure the AG Grid Enterprise Module " + ModuleNames.ViewportRowModelModule + " is registered.';");
    }
    if (rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE) {
      console.error("AG Grid: Row Model \"Server Side\" not found. Please ensure the AG Grid Enterprise Module " + ModuleNames.ServerSideRowModelModule + " is registered.';");
    }
    if (rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      console.error("AG Grid: Row Model \"Client Side\" not found. Please ensure the " + ModuleNames.ClientSideRowModelModule + " is registered.';");
    }
  };
  return GridCoreCreator;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function initialiseAgGridWithAngular1(angular) {
  var angularModule = angular.module("agGrid", []);
  angularModule.directive("agGrid", function () {
    return {
      restrict: "A",
      controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
      scope: true
    };
  });
}
function AngularDirectiveController($element, $scope, $compile, $attrs) {
  var gridOptions;
  var keyOfGridInScope = $attrs.agGrid;
  gridOptions = $scope.$eval(keyOfGridInScope);
  if (!gridOptions) {
    console.warn("WARNING - grid options for AG Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
    return;
  }
  var eGridDiv = $element[0];
  var gridParams = {
    $scope: $scope,
    $compile: $compile
  };
  var grid = new Grid(eGridDiv, gridOptions, gridParams);
  var quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
  var quickFilterUnregisterFn = $scope.$watch(quickFilterOnScope, function (newFilter) {
    gridOptions.api.setQuickFilter(newFilter);
  });
  $scope.$on("$destroy", function () {
    quickFilterUnregisterFn();
    if (grid) {
      grid.destroy();
    }
    grid = null;
  });
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var registered = false;
function initialiseAgGridWithWebComponents() {
  console.warn('ag-grid: initialiseAgGridWithWebComponents is deprecated. Please use the ag-grid-webcomponent dependency instead. ');
  // only register to WebComponents once
  if (registered) {
    return;
  }
  registered = true;
  if (typeof document === 'undefined' || !document.registerElement) {
    console.error('AG Grid: unable to find document.registerElement() function, unable to initialise AG Grid as a Web Component');
  }
  // i don't think this type of extension is possible in TypeScript, so back to
  // plain Javascript to create this object
  var AgileGridProto = Object.create(HTMLElement.prototype);
  // wrap each property with a get and set method, so we can track when changes are done
  ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
    Object.defineProperty(AgileGridProto, key, {
      set: function set(v) {
        this.__agGridSetProperty(key, v);
      },
      get: function get() {
        return this.__agGridGetProperty(key);
      },
      enumerable: true,
      configurable: true
    });
  });
  var agGridProtoNoType = AgileGridProto;
  agGridProtoNoType.__agGridSetProperty = function (key, value) {
    if (!this.__attributes) {
      this.__attributes = {};
    }
    this.__attributes[key] = value;
    // keeping this consistent with the ng2 onChange, so I can reuse the handling code
    var changeObject = {};
    changeObject[key] = {
      currentValue: value
    };
    this.onChange(changeObject);
  };
  agGridProtoNoType.onChange = function (changes) {
    if (this._initialised) {
      ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
    }
  };
  agGridProtoNoType.__agGridGetProperty = function (key) {
    if (!this.__attributes) {
      this.__attributes = {};
    }
    return this.__attributes[key];
  };
  agGridProtoNoType.setGridOptions = function (options) {
    var globalEventListener = this.globalEventListener.bind(this);
    this._gridOptions = ComponentUtil.copyAttributesToGridOptions(options, this);
    var gridParams = {
      globalEventListener: globalEventListener
    };
    this._agGrid = new Grid(this, this._gridOptions, gridParams);
    this.api = options.api;
    this.columnApi = options.columnApi;
    this._initialised = true;
  };
  // copies all the attributes into this object
  agGridProtoNoType.createdCallback = function () {
    for (var i = 0; i < this.attributes.length; i++) {
      var attribute = this.attributes[i];
      this.setPropertyFromAttribute(attribute);
    }
  };
  agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
    var name = toCamelCase(attribute.nodeName);
    var value = attribute.nodeValue;
    if (ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
      this[name] = value;
    }
  };
  agGridProtoNoType.attachedCallback = function (params) {};
  agGridProtoNoType.detachedCallback = function (params) {};
  agGridProtoNoType.attributeChangedCallback = function (attributeName) {
    var attribute = this.attributes[attributeName];
    this.setPropertyFromAttribute(attribute);
  };
  agGridProtoNoType.globalEventListener = function (eventType, event) {
    var eventLowerCase = eventType.toLowerCase();
    var browserEvent = new Event(eventLowerCase);
    var browserEventNoType = browserEvent;
    browserEventNoType.agGridDetails = event;
    this.dispatchEvent(browserEvent);
    var callbackMethod = 'on' + eventLowerCase;
    if (typeof this[callbackMethod] === 'function') {
      this[callbackMethod](browserEvent);
    }
  };
  // finally, register
  document.registerElement('ag-grid', {
    prototype: AgileGridProto
  });
}
function toCamelCase(myString) {
  if (typeof myString === 'string') {
    var result = myString.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    return result;
  } else {
    return myString;
  }
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2C = undefined && undefined.__extends || function () {
  var _extendStatics167 = function extendStatics(d, b) {
    _extendStatics167 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics167(d, b);
  };
  return function (d, b) {
    _extendStatics167(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2i = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TabbedLayout = /** @class */function (_super) {
  __extends$2C(TabbedLayout, _super);
  function TabbedLayout(params) {
    var _this = _super.call(this, TabbedLayout.getTemplate(params.cssClass)) || this;
    _this.items = [];
    _this.params = params;
    if (params.items) {
      params.items.forEach(function (item) {
        return _this.addItem(item);
      });
    }
    return _this;
  }
  TabbedLayout.prototype.postConstruct = function () {
    this.createManagedBean(new ManagedFocusFeature(this.getFocusableElement(), {
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this)
    }));
  };
  TabbedLayout.getTemplate = function (cssClass) {
    return (/* html */"<div class=\"ag-tabs " + cssClass + "\">\n            <div ref=\"eHeader\" role=\"tablist\" class=\"ag-tabs-header " + (cssClass ? cssClass + "-header" : '') + "\"></div>\n            <div ref=\"eBody\" role=\"presentation\" class=\"ag-tabs-body " + (cssClass ? cssClass + "-body" : '') + "\"></div>\n        </div>"
    );
  };
  TabbedLayout.prototype.handleKeyDown = function (e) {
    switch (e.keyCode) {
      case KeyCode.RIGHT:
      case KeyCode.LEFT:
        if (!this.eHeader.contains(document.activeElement)) {
          return;
        }
        var currentPosition = this.items.indexOf(this.activeItem);
        var nextPosition = e.keyCode === KeyCode.RIGHT ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
        if (currentPosition === nextPosition) {
          return;
        }
        e.preventDefault();
        var nextItem = this.items[nextPosition];
        this.showItemWrapper(nextItem);
        nextItem.eHeaderButton.focus();
        break;
      case KeyCode.UP:
      case KeyCode.DOWN:
        e.stopPropagation();
        break;
    }
  };
  TabbedLayout.prototype.onTabKeyDown = function (e) {
    if (e.defaultPrevented) {
      return;
    }
    var _a = this,
      focusService = _a.focusService,
      eHeader = _a.eHeader,
      eBody = _a.eBody,
      activeItem = _a.activeItem;
    var activeElement = document.activeElement;
    e.preventDefault();
    if (eHeader.contains(activeElement)) {
      // focus is in header, move into body of popup
      focusService.focusInto(eBody, e.shiftKey);
    } else {
      // focus is in body, establish if it should return to header
      if (focusService.isFocusUnderManagedComponent(eBody)) {
        // focus was in a managed focus component and has now left, so we can return to the header
        activeItem.eHeaderButton.focus();
      } else {
        var nextEl = focusService.findNextFocusableElement(eBody, false, e.shiftKey);
        if (nextEl) {
          // if another element exists in the body that can be focussed, go to that
          nextEl.focus();
        } else {
          // otherwise return to the header
          activeItem.eHeaderButton.focus();
        }
      }
    }
  };
  TabbedLayout.prototype.setAfterAttachedParams = function (params) {
    this.afterAttachedParams = params;
  };
  TabbedLayout.prototype.showFirstItem = function () {
    if (this.items.length > 0) {
      this.showItemWrapper(this.items[0]);
    }
  };
  TabbedLayout.prototype.addItem = function (item) {
    var eHeaderButton = document.createElement('span');
    setAriaRole(eHeaderButton, 'tab');
    eHeaderButton.setAttribute('tabIndex', '-1');
    eHeaderButton.appendChild(item.title);
    addCssClass(eHeaderButton, 'ag-tab');
    this.eHeader.appendChild(eHeaderButton);
    _setAriaLabel(eHeaderButton, item.titleLabel);
    var wrapper = {
      tabbedItem: item,
      eHeaderButton: eHeaderButton
    };
    this.items.push(wrapper);
    eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
  };
  TabbedLayout.prototype.showItem = function (tabbedItem) {
    var itemWrapper = find$3(this.items, function (wrapper) {
      return wrapper.tabbedItem === tabbedItem;
    });
    if (itemWrapper) {
      this.showItemWrapper(itemWrapper);
    }
  };
  TabbedLayout.prototype.showItemWrapper = function (wrapper) {
    var _this = this;
    if (this.params.onItemClicked) {
      this.params.onItemClicked({
        item: wrapper.tabbedItem
      });
    }
    if (this.activeItem === wrapper) {
      callIfPresent(this.params.onActiveItemClicked);
      return;
    }
    clearElement(this.eBody);
    wrapper.tabbedItem.bodyPromise.then(function (body) {
      _this.eBody.appendChild(body);
      var onlyUnmanaged = !_this.focusService.isKeyboardMode();
      _this.focusService.focusInto(_this.eBody, false, onlyUnmanaged);
      if (wrapper.tabbedItem.afterAttachedCallback) {
        wrapper.tabbedItem.afterAttachedCallback(_this.afterAttachedParams);
      }
    });
    if (this.activeItem) {
      removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
    }
    addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
    this.activeItem = wrapper;
  };
  __decorate$2i([Autowired('focusService')], TabbedLayout.prototype, "focusService", void 0);
  __decorate$2i([RefSelector('eHeader')], TabbedLayout.prototype, "eHeader", void 0);
  __decorate$2i([RefSelector('eBody')], TabbedLayout.prototype, "eBody", void 0);
  __decorate$2i([PostConstruct], TabbedLayout.prototype, "postConstruct", null);
  return TabbedLayout;
}(Component);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
/* deprecated */
function simpleHttpRequest(params) {
  return new AgPromise(function (resolve) {
    var httpRequest = new XMLHttpRequest();
    httpRequest.open('GET', params.url);
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        resolve(JSON.parse(httpRequest.responseText));
      }
    };
  });
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ServerSideTransactionResultStatus;
(function (ServerSideTransactionResultStatus) {
  /** Transaction was successfully applied */
  ServerSideTransactionResultStatus["Applied"] = "Applied";
  /**
   * Store was not found, transaction not applied.
   * Either invalid route, or the parent row has not yet been expanded.
   */
  ServerSideTransactionResultStatus["StoreNotFound"] = "StoreNotFound";
  /**
   * Store is loading, transaction not applied.
   */
  ServerSideTransactionResultStatus["StoreLoading"] = "StoreLoading";
  /**
   * Store is loading (as max loads exceeded), transaction not applied.
   */
  ServerSideTransactionResultStatus["StoreWaitingToLoad"] = "StoreWaitingToLoad";
  /**
   * Store load attempt failed, transaction not applied.
   */
  ServerSideTransactionResultStatus["StoreLoadingFailed"] = "StoreLoadingFailed";
  /**
   * Store is type Partial, which doesn't accept transactions
   */
  ServerSideTransactionResultStatus["StoreWrongType"] = "StoreWrongType";
  /**
   * Transaction was cancelled, due to grid.
   * Callback isApplyServerSideTransaction() returning false
   */
  ServerSideTransactionResultStatus["Cancelled"] = "Cancelled";
})(ServerSideTransactionResultStatus || (ServerSideTransactionResultStatus = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends$2D = undefined && undefined.__extends || function () {
  var _extendStatics168 = function extendStatics(d, b) {
    _extendStatics168 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics168(d, b);
  };
  return function (d, b) {
    _extendStatics168(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2j = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var VirtualList = /** @class */function (_super) {
  __extends$2D(VirtualList, _super);
  function VirtualList(cssIdentifier, ariaRole, listName) {
    if (cssIdentifier === void 0) {
      cssIdentifier = 'default';
    }
    if (ariaRole === void 0) {
      ariaRole = 'listbox';
    }
    var _this = _super.call(this, VirtualList.getTemplate(cssIdentifier)) || this;
    _this.cssIdentifier = cssIdentifier;
    _this.ariaRole = ariaRole;
    _this.listName = listName;
    _this.renderedRows = new Map();
    _this.rowHeight = 20;
    _this.isDestroyed = false;
    return _this;
  }
  VirtualList.prototype.postConstruct = function () {
    var _this = this;
    this.addScrollListener();
    this.rowHeight = this.getItemHeight();
    this.addResizeObserver();
    this.initialiseTabGuard({
      onFocusIn: function onFocusIn(e) {
        return _this.onFocusIn(e);
      },
      onFocusOut: function onFocusOut(e) {
        return _this.onFocusOut(e);
      },
      focusInnerElement: function focusInnerElement(fromBottom) {
        return _this.focusInnerElement(fromBottom);
      },
      onTabKeyDown: function onTabKeyDown(e) {
        return _this.onTabKeyDown(e);
      },
      handleKeyDown: function handleKeyDown(e) {
        return _this.handleKeyDown(e);
      }
    });
    this.setAriaProperties();
  };
  VirtualList.prototype.setAriaProperties = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var listName = translate('ariaDefaultListName', this.listName || 'List');
    var ariaEl = this.eContainer;
    setAriaRole(ariaEl, this.ariaRole);
    _setAriaLabel(ariaEl, listName);
  };
  VirtualList.prototype.addResizeObserver = function () {
    var listener = this.drawVirtualRows.bind(this);
    var destroyObserver = this.resizeObserverService.observeResize(this.getGui(), listener);
    this.addDestroyFunc(destroyObserver);
  };
  VirtualList.prototype.focusInnerElement = function (fromBottom) {
    this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
  };
  VirtualList.prototype.onFocusIn = function (e) {
    var target = e.target;
    if (containsClass(target, 'ag-virtual-list-item')) {
      this.lastFocusedRowIndex = getAriaPosInSet(target) - 1;
    }
    return false;
  };
  VirtualList.prototype.onFocusOut = function (e) {
    if (!this.getFocusableElement().contains(e.relatedTarget)) {
      this.lastFocusedRowIndex = null;
    }
    return false;
  };
  VirtualList.prototype.handleKeyDown = function (e) {
    switch (e.keyCode) {
      case KeyCode.UP:
      case KeyCode.DOWN:
        if (this.navigate(e.keyCode === KeyCode.UP)) {
          e.preventDefault();
        }
        break;
    }
  };
  VirtualList.prototype.onTabKeyDown = function (e) {
    if (this.navigate(e.shiftKey)) {
      e.preventDefault();
    } else {
      // focus on the first or last focusable element to ensure that any other handlers start from there
      this.focusService.focusInto(this.getGui(), !e.shiftKey);
    }
  };
  VirtualList.prototype.navigate = function (up) {
    if (this.lastFocusedRowIndex == null) {
      return false;
    }
    var nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
    if (nextRow < 0 || nextRow >= this.model.getRowCount()) {
      return false;
    }
    this.focusRow(nextRow);
    return true;
  };
  VirtualList.prototype.getLastFocusedRow = function () {
    return this.lastFocusedRowIndex;
  };
  VirtualList.prototype.focusRow = function (rowNumber) {
    var _this = this;
    this.ensureIndexVisible(rowNumber);
    window.setTimeout(function () {
      var renderedRow = _this.renderedRows.get(rowNumber);
      if (renderedRow) {
        renderedRow.eDiv.focus();
      }
    }, 10);
  };
  VirtualList.prototype.getComponentAt = function (rowIndex) {
    var comp = this.renderedRows.get(rowIndex);
    return comp && comp.rowComponent;
  };
  VirtualList.getTemplate = function (cssIdentifier) {
    return (/* html */"\n            <div class=\"ag-virtual-list-viewport ag-" + cssIdentifier + "-virtual-list-viewport\" role=\"presentation\">\n                <div class=\"ag-virtual-list-container ag-" + cssIdentifier + "-virtual-list-container\" ref=\"eContainer\"></div>\n            </div>"
    );
  };
  VirtualList.prototype.getItemHeight = function () {
    return this.gridOptionsWrapper.getListItemHeight();
  };
  VirtualList.prototype.ensureIndexVisible = function (index) {
    var lastRow = this.model.getRowCount();
    if (typeof index !== 'number' || index < 0 || index >= lastRow) {
      console.warn('invalid row index for ensureIndexVisible: ' + index);
      return;
    }
    var rowTopPixel = index * this.rowHeight;
    var rowBottomPixel = rowTopPixel + this.rowHeight;
    var eGui = this.getGui();
    var viewportTopPixel = eGui.scrollTop;
    var viewportHeight = eGui.offsetHeight;
    var viewportBottomPixel = viewportTopPixel + viewportHeight;
    var viewportScrolledPastRow = viewportTopPixel > rowTopPixel;
    var viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel;
    if (viewportScrolledPastRow) {
      // if row is before, scroll up with row at top
      eGui.scrollTop = rowTopPixel;
    } else if (viewportScrolledBeforeRow) {
      // if row is below, scroll down with row at bottom
      var newScrollPosition = rowBottomPixel - viewportHeight;
      eGui.scrollTop = newScrollPosition;
    }
  };
  VirtualList.prototype.setComponentCreator = function (componentCreator) {
    this.componentCreator = componentCreator;
  };
  VirtualList.prototype.getRowHeight = function () {
    return this.rowHeight;
  };
  VirtualList.prototype.getScrollTop = function () {
    return this.getGui().scrollTop;
  };
  VirtualList.prototype.setRowHeight = function (rowHeight) {
    this.rowHeight = rowHeight;
    this.refresh();
  };
  VirtualList.prototype.refresh = function () {
    var _this = this;
    if (this.model == null || this.isDestroyed) {
      return;
    }
    var rowCount = this.model.getRowCount();
    this.eContainer.style.height = rowCount * this.rowHeight + "px";
    // ensure height is applied before attempting to redraw rows
    waitUntil(function () {
      return _this.eContainer.clientHeight >= rowCount * _this.rowHeight;
    }, function () {
      if (_this.isDestroyed) {
        return;
      }
      _this.clearVirtualRows();
      _this.drawVirtualRows();
    });
  };
  VirtualList.prototype.clearVirtualRows = function () {
    var _this = this;
    this.renderedRows.forEach(function (_, rowIndex) {
      return _this.removeRow(rowIndex);
    });
  };
  VirtualList.prototype.drawVirtualRows = function () {
    var gui = this.getGui();
    var topPixel = gui.scrollTop;
    var bottomPixel = topPixel + gui.offsetHeight;
    var firstRow = Math.floor(topPixel / this.rowHeight);
    var lastRow = Math.floor(bottomPixel / this.rowHeight);
    this.ensureRowsRendered(firstRow, lastRow);
  };
  VirtualList.prototype.ensureRowsRendered = function (start, finish) {
    var _this = this;
    // remove any rows that are no longer required
    this.renderedRows.forEach(function (_, rowIndex) {
      if ((rowIndex < start || rowIndex > finish) && rowIndex !== _this.lastFocusedRowIndex) {
        _this.removeRow(rowIndex);
      }
    });
    // insert any required new rows
    for (var rowIndex = start; rowIndex <= finish; rowIndex++) {
      if (this.renderedRows.has(rowIndex)) {
        continue;
      }
      // check this row actually exists (in case overflow buffer window exceeds real data)
      if (rowIndex < this.model.getRowCount()) {
        this.insertRow(rowIndex);
      }
    }
  };
  VirtualList.prototype.insertRow = function (rowIndex) {
    var _this = this;
    var value = this.model.getRow(rowIndex);
    var eDiv = document.createElement('div');
    addCssClass(eDiv, 'ag-virtual-list-item');
    addCssClass(eDiv, "ag-" + this.cssIdentifier + "-virtual-list-item");
    setAriaRole(eDiv, this.ariaRole === 'tree' ? 'treeitem' : 'option');
    setAriaSetSize(eDiv, this.model.getRowCount());
    setAriaPosInSet(eDiv, rowIndex + 1);
    eDiv.setAttribute('tabindex', '-1');
    if (typeof this.model.isRowSelected === 'function') {
      var isSelected = this.model.isRowSelected(rowIndex);
      _setAriaSelected(eDiv, !!isSelected);
      setAriaChecked(eDiv, isSelected);
    }
    eDiv.style.height = this.rowHeight + "px";
    eDiv.style.top = this.rowHeight * rowIndex + "px";
    var rowComponent = this.componentCreator(value, eDiv);
    rowComponent.addGuiEventListener('focusin', function () {
      return _this.lastFocusedRowIndex = rowIndex;
    });
    eDiv.appendChild(rowComponent.getGui());
    // keep the DOM order consistent with the order of the rows
    if (this.renderedRows.has(rowIndex - 1)) {
      this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement('afterend', eDiv);
    } else if (this.renderedRows.has(rowIndex + 1)) {
      this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement('beforebegin', eDiv);
    } else {
      this.eContainer.appendChild(eDiv);
    }
    this.renderedRows.set(rowIndex, {
      rowComponent: rowComponent,
      eDiv: eDiv
    });
  };
  VirtualList.prototype.removeRow = function (rowIndex) {
    var component = this.renderedRows.get(rowIndex);
    this.eContainer.removeChild(component.eDiv);
    this.destroyBean(component.rowComponent);
    this.renderedRows.delete(rowIndex);
  };
  VirtualList.prototype.addScrollListener = function () {
    var _this = this;
    this.addGuiEventListener('scroll', function () {
      return _this.drawVirtualRows();
    });
  };
  VirtualList.prototype.setModel = function (model) {
    this.model = model;
  };
  VirtualList.prototype.destroy = function () {
    if (this.isDestroyed) {
      return;
    }
    this.clearVirtualRows();
    this.isDestroyed = true;
    _super.prototype.destroy.call(this);
  };
  __decorate$2j([Autowired('resizeObserverService')], VirtualList.prototype, "resizeObserverService", void 0);
  __decorate$2j([Autowired('focusService')], VirtualList.prototype, "focusService", void 0);
  __decorate$2j([RefSelector('eContainer')], VirtualList.prototype, "eContainer", void 0);
  __decorate$2j([PostConstruct], VirtualList.prototype, "postConstruct", null);
  return VirtualList;
}(TabGuardComp);

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
function defaultGroupComparator(valueA, valueB, nodeA, nodeB, accentedCompare) {
  if (accentedCompare === void 0) {
    accentedCompare = false;
  }
  console.warn('AG Grid: Since ag-grid 11.0.0 defaultGroupComparator is not necessary. You can remove this from your colDef');
  var nodeAIsGroup = exists(nodeA) && nodeA.group;
  var nodeBIsGroup = exists(nodeB) && nodeB.group;
  var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
  var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
  if (bothAreGroups) {
    return defaultComparator(nodeA.key, nodeB.key, accentedCompare);
  }
  if (bothAreNormal) {
    return defaultComparator(valueA, valueB, accentedCompare);
  }
  if (nodeAIsGroup) {
    return 1;
  }
  return -1;
}

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var BaseComponentWrapper = /** @class */function () {
  function BaseComponentWrapper() {}
  BaseComponentWrapper.prototype.wrap = function (OriginalConstructor, mandatoryMethodList, optionalMethodList, componentType, componentName) {
    var _this = this;
    if (optionalMethodList === void 0) {
      optionalMethodList = [];
    }
    var wrapper = this.createWrapper(OriginalConstructor, componentType, componentName);
    mandatoryMethodList.forEach(function (methodName) {
      _this.createMethod(wrapper, methodName, true);
    });
    optionalMethodList.forEach(function (methodName) {
      _this.createMethod(wrapper, methodName, false);
    });
    return wrapper;
  };
  BaseComponentWrapper.prototype.unwrap = function (comp) {
    return comp;
  };
  BaseComponentWrapper.prototype.createMethod = function (wrapper, methodName, mandatory) {
    wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
  };
  BaseComponentWrapper.prototype.createMethodProxy = function (wrapper, methodName, mandatory) {
    return function () {
      if (wrapper.hasMethod(methodName)) {
        return wrapper.callMethod(methodName, arguments);
      }
      if (mandatory) {
        console.warn('AG Grid: Framework component is missing the method ' + methodName + '()');
      }
      return null;
    };
  };
  return BaseComponentWrapper;
}();

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var ChartType;
(function (ChartType) {
  ChartType["Column"] = "column";
  ChartType["GroupedColumn"] = "groupedColumn";
  ChartType["StackedColumn"] = "stackedColumn";
  ChartType["NormalizedColumn"] = "normalizedColumn";
  ChartType["Bar"] = "bar";
  ChartType["GroupedBar"] = "groupedBar";
  ChartType["StackedBar"] = "stackedBar";
  ChartType["NormalizedBar"] = "normalizedBar";
  ChartType["Line"] = "line";
  ChartType["Scatter"] = "scatter";
  ChartType["Bubble"] = "bubble";
  ChartType["Pie"] = "pie";
  ChartType["Doughnut"] = "doughnut";
  ChartType["Area"] = "area";
  ChartType["StackedArea"] = "stackedArea";
  ChartType["NormalizedArea"] = "normalizedArea";
  ChartType["Histogram"] = "histogram";
})(ChartType || (ChartType = {}));

/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var globalObj$1 = typeof global === 'undefined' ? {} : global;
globalObj$1.HTMLElement = typeof HTMLElement === 'undefined' ? {} : HTMLElement;
globalObj$1.HTMLButtonElement = typeof HTMLButtonElement === 'undefined' ? {} : HTMLButtonElement;
globalObj$1.HTMLSelectElement = typeof HTMLSelectElement === 'undefined' ? {} : HTMLSelectElement;
globalObj$1.HTMLInputElement = typeof HTMLInputElement === 'undefined' ? {} : HTMLInputElement;
globalObj$1.Node = typeof Node === 'undefined' ? {} : Node;
globalObj$1.MouseEvent = typeof MouseEvent === 'undefined' ? {} : MouseEvent;
var main = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ColumnFactory: ColumnFactory,
  ColumnModel: ColumnModel,
  ColumnKeyCreator: ColumnKeyCreator,
  ColumnUtils: ColumnUtils,
  DisplayedGroupCreator: DisplayedGroupCreator,
  GroupInstanceIdCreator: GroupInstanceIdCreator,
  ComponentUtil: ComponentUtil,
  AgStackComponentsRegistry: AgStackComponentsRegistry,
  ColDefUtil: ColDefUtil,
  UserComponentRegistry: UserComponentRegistry,
  UserComponentFactory: UserComponentFactory,
  initialiseAgGridWithAngular1: initialiseAgGridWithAngular1,
  initialiseAgGridWithWebComponents: initialiseAgGridWithWebComponents,
  BeanStub: BeanStub,
  Context: Context,
  Autowired: Autowired,
  PostConstruct: PostConstruct,
  PreConstruct: PreConstruct,
  Optional: Optional,
  Bean: Bean,
  Qualifier: Qualifier,
  PreDestroy: PreDestroy,
  QuerySelector: QuerySelector,
  RefSelector: RefSelector,
  get ExcelFactoryMode() {
    return ExcelFactoryMode;
  },
  DragAndDropService: DragAndDropService,
  get DragSourceType() {
    return DragSourceType;
  },
  get HorizontalDirection() {
    return HorizontalDirection;
  },
  get VerticalDirection() {
    return VerticalDirection;
  },
  DragService: DragService,
  Column: Column,
  ColumnGroup: ColumnGroup,
  ProvidedColumnGroup: ProvidedColumnGroup,
  RowNode: RowNode,
  get RowHighlightPosition() {
    return RowHighlightPosition;
  },
  FilterManager: FilterManager,
  ProvidedFilter: ProvidedFilter,
  SimpleFilter: SimpleFilter,
  ScalarFilter: ScalarFilter,
  NumberFilter: NumberFilter,
  TextFilter: TextFilter,
  DateFilter: DateFilter,
  TextFloatingFilter: TextFloatingFilter,
  HeaderFilterCellComp: HeaderFilterCellComp,
  FloatingFilterMapper: FloatingFilterMapper,
  GridBodyComp: GridBodyComp,
  GridBodyCtrl: GridBodyCtrl,
  get RowAnimationCssClasses() {
    return RowAnimationCssClasses;
  },
  ScrollVisibleService: ScrollVisibleService,
  MouseEventService: MouseEventService,
  NavigationService: NavigationService,
  RowContainerComp: RowContainerComp,
  get RowContainerName() {
    return RowContainerName;
  },
  RowContainerCtrl: RowContainerCtrl,
  BodyDropPivotTarget: BodyDropPivotTarget,
  BodyDropTarget: BodyDropTarget,
  CssClassApplier: CssClassApplier,
  HeaderRowContainerComp: HeaderRowContainerComp,
  GridHeaderComp: GridHeaderComp,
  GridHeaderCtrl: GridHeaderCtrl,
  HeaderRowComp: HeaderRowComp,
  get HeaderRowType() {
    return HeaderRowType;
  },
  HeaderRowCtrl: HeaderRowCtrl,
  HeaderCellCtrl: HeaderCellCtrl,
  HeaderFilterCellCtrl: HeaderFilterCellCtrl,
  HeaderGroupCellCtrl: HeaderGroupCellCtrl,
  AbstractHeaderCellCtrl: AbstractHeaderCellCtrl,
  HeaderRowContainerCtrl: HeaderRowContainerCtrl,
  HorizontalResizeService: HorizontalResizeService,
  MoveColumnFeature: MoveColumnFeature,
  StandardMenuFactory: StandardMenuFactory,
  TabbedLayout: TabbedLayout,
  simpleHttpRequest: simpleHttpRequest,
  ResizeObserverService: ResizeObserverService,
  AnimationFrameService: AnimationFrameService,
  LargeTextCellEditor: LargeTextCellEditor,
  PopupEditorWrapper: PopupEditorWrapper,
  PopupSelectCellEditor: PopupSelectCellEditor,
  PopupTextCellEditor: PopupTextCellEditor,
  SelectCellEditor: SelectCellEditor,
  TextCellEditor: TextCellEditor,
  Beans: Beans,
  AnimateShowChangeCellRenderer: AnimateShowChangeCellRenderer,
  AnimateSlideCellRenderer: AnimateSlideCellRenderer,
  GroupCellRenderer: GroupCellRenderer,
  GroupCellRendererCtrl: GroupCellRendererCtrl,
  SetLeftFeature: SetLeftFeature,
  PositionableFeature: PositionableFeature,
  AutoWidthCalculator: AutoWidthCalculator,
  CheckboxSelectionComponent: CheckboxSelectionComponent,
  CellComp: CellComp,
  CellCtrl: CellCtrl,
  RowCtrl: RowCtrl,
  RowRenderer: RowRenderer,
  ValueFormatterService: ValueFormatterService,
  PinnedRowModel: PinnedRowModel,
  get ServerSideTransactionResultStatus() {
    return ServerSideTransactionResultStatus;
  },
  ChangedPath: ChangedPath,
  RowNodeBlock: RowNodeBlock,
  RowNodeBlockLoader: RowNodeBlockLoader,
  PaginationProxy: PaginationProxy,
  get ClientSideRowModelSteps() {
    return ClientSideRowModelSteps;
  },
  StylingService: StylingService,
  get LayoutCssClasses() {
    return LayoutCssClasses;
  },
  AgAbstractField: AgAbstractField,
  AgCheckbox: AgCheckbox,
  AgRadioButton: AgRadioButton,
  AgToggleButton: AgToggleButton,
  AgInputTextField: AgInputTextField,
  AgInputTextArea: AgInputTextArea,
  AgInputNumberField: AgInputNumberField,
  AgInputRange: AgInputRange,
  AgSelect: AgSelect,
  AgSlider: AgSlider,
  AgAngleSelect: AgAngleSelect,
  AgColorPicker: AgColorPicker,
  AgGroupComponent: AgGroupComponent,
  AgDialog: AgDialog,
  AgPanel: AgPanel,
  Component: Component,
  ManagedFocusFeature: ManagedFocusFeature,
  TabGuardComp: TabGuardComp,
  TabGuardCtrl: TabGuardCtrl,
  PopupComponent: PopupComponent,
  PopupService: PopupService,
  TouchListener: TouchListener,
  VirtualList: VirtualList,
  get CellRangeType() {
    return CellRangeType;
  },
  get SelectionHandleType() {
    return SelectionHandleType;
  },
  AutoScrollService: AutoScrollService,
  VanillaFrameworkOverrides: VanillaFrameworkOverrides,
  CellNavigationService: CellNavigationService,
  AlignedGridsService: AlignedGridsService,
  Constants: Constants,
  KeyCode: KeyCode,
  Grid: Grid,
  GridCoreCreator: GridCoreCreator,
  GridApi: GridApi,
  Events: Events,
  FocusService: FocusService,
  defaultGroupComparator: defaultGroupComparator,
  GridOptionsWrapper: GridOptionsWrapper,
  EventService: EventService,
  SelectableService: SelectableService,
  RowNodeSorter: RowNodeSorter,
  CtrlsService: CtrlsService,
  GridComp: GridComp,
  GridCtrl: GridCtrl,
  Logger: Logger,
  LoggerFactory: LoggerFactory,
  SelectionService: SelectionService,
  SortController: SortController,
  TemplateService: TemplateService,
  ValueService: ValueService,
  ValueCache: ValueCache,
  ExpressionService: ExpressionService,
  CellPositionUtils: CellPositionUtils,
  RowPositionUtils: RowPositionUtils,
  HeaderPositionUtils: HeaderPositionUtils,
  HeaderNavigationService: HeaderNavigationService,
  get HeaderNavigationDirection() {
    return HeaderNavigationDirection;
  },
  ColumnApi: ColumnApi,
  BaseComponentWrapper: BaseComponentWrapper,
  Environment: Environment,
  CustomTooltipFeature: CustomTooltipFeature,
  get ModuleNames() {
    return ModuleNames;
  },
  ModuleRegistry: ModuleRegistry,
  Color: Color,
  stringToArray: stringToArray,
  _: _,
  NumberSequence: NumberSequence,
  get AgPromiseStatus() {
    return AgPromiseStatus;
  },
  AgPromise: AgPromise,
  Timer: Timer,
  PropertyKeys: PropertyKeys,
  get ChartType() {
    return ChartType;
  }
});
var __extends$2E = undefined && undefined.__extends || function () {
  var _extendStatics169 = function extendStatics(d, b) {
    _extendStatics169 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics169(d, b);
  };
  return function (d, b) {
    _extendStatics169(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2k = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LicenseManager = /** @class */function (_super) {
  __extends$2E(LicenseManager, _super);
  function LicenseManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.watermarkMessage = undefined;
    return _this;
  }
  LicenseManager_1 = LicenseManager;
  LicenseManager.prototype.validateLicense = function () {
    if (_.missingOrEmpty(LicenseManager_1.licenseKey)) {
      this.outputMissingLicenseKey();
    } else if (LicenseManager_1.licenseKey.length > 32) {
      var _a = LicenseManager_1.extractLicenseComponents(LicenseManager_1.licenseKey),
        md5 = _a.md5,
        license = _a.license,
        version = _a.version,
        isTrial = _a.isTrial;
      if (md5 === this.md5.md5(license)) {
        if (_.exists(version) && version) {
          this.validateLicenseKeyForVersion(version, !!isTrial, license);
        } else {
          this.validateLegacyKey(license);
        }
      } else {
        this.outputInvalidLicenseKey();
      }
    } else {
      this.outputInvalidLicenseKey();
    }
  };
  LicenseManager.extractExpiry = function (license) {
    var restrictionHashed = license.substring(license.lastIndexOf('_') + 1, license.length);
    return new Date(parseInt(LicenseManager_1.decode(restrictionHashed), 10));
  };
  LicenseManager.extractLicenseComponents = function (licenseKey) {
    // when users copy the license key from a PDF extra zero width characters are sometimes copied too
    // carriage returns and line feeds are problematic too
    // all of which causes license key validation to fail - strip these out
    var cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, '');
    cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, '');
    var hashStart = cleanedLicenseKey.length - 32;
    var md5 = cleanedLicenseKey.substring(hashStart);
    var license = cleanedLicenseKey.substring(0, hashStart);
    var _a = LicenseManager_1.extractBracketedInformation(cleanedLicenseKey),
      version = _a[0],
      isTrial = _a[1];
    return {
      md5: md5,
      license: license,
      version: version,
      isTrial: isTrial
    };
  };
  LicenseManager.prototype.getLicenseDetails = function (licenseKey) {
    var _a = LicenseManager_1.extractLicenseComponents(licenseKey),
      md5 = _a.md5,
      license = _a.license,
      version = _a.version,
      isTrial = _a.isTrial;
    var valid = md5 === this.md5.md5(license);
    var expiry = null;
    if (valid) {
      expiry = LicenseManager_1.extractExpiry(license);
      valid = !isNaN(expiry.getTime());
    }
    return {
      licenseKey: licenseKey,
      valid: valid,
      expiry: valid ? LicenseManager_1.formatDate(expiry) : null,
      version: version ? version : 'legacy',
      isTrial: isTrial
    };
  };
  LicenseManager.prototype.isDisplayWatermark = function () {
    return !_.missingOrEmpty(this.watermarkMessage);
  };
  LicenseManager.prototype.getWatermarkMessage = function () {
    return this.watermarkMessage || '';
  };
  LicenseManager.formatDate = function (date) {
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  };
  LicenseManager.getGridReleaseDate = function () {
    return new Date(parseInt(LicenseManager_1.decode(LicenseManager_1.RELEASE_INFORMATION), 10));
  };
  LicenseManager.decode = function (input) {
    var keystr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var t = '';
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    var e = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (f < e.length) {
      s = keystr.indexOf(e.charAt(f++));
      o = keystr.indexOf(e.charAt(f++));
      u = keystr.indexOf(e.charAt(f++));
      a = keystr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = LicenseManager_1.utf8_decode(t);
    return t;
  };
  LicenseManager.utf8_decode = function (input) {
    input = input.replace(/rn/g, 'n');
    var t = '';
    for (var n = 0; n < input.length; n++) {
      var r = input.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  };
  LicenseManager.setLicenseKey = function (licenseKey) {
    LicenseManager_1.licenseKey = licenseKey;
  };
  LicenseManager.extractBracketedInformation = function (licenseKey) {
    var matches = licenseKey.split('[').filter(function (v) {
      return v.indexOf(']') > -1;
    }).map(function (value) {
      return value.split(']')[0];
    });
    if (!matches || matches.length === 0) {
      return [null, null];
    }
    var isTrial = matches.filter(function (match) {
      return match === 'TRIAL';
    }).length === 1;
    var version = matches.filter(function (match) {
      return match.indexOf("v") === 0;
    }).map(function (match) {
      return match.replace(/^v/, "");
    })[0];
    return [version, isTrial];
  };
  LicenseManager.prototype.validateLicenseKeyForVersion = function (version, isTrial, license) {
    if (version !== '2') {
      return;
    }
    if (isTrial) {
      this.validateForTrial(license);
    } else {
      this.validateLegacyKey(license);
    }
  };
  LicenseManager.prototype.validateLegacyKey = function (license) {
    var gridReleaseDate = LicenseManager_1.getGridReleaseDate();
    var expiry = LicenseManager_1.extractExpiry(license);
    var valid = false;
    var current = false;
    if (!isNaN(expiry.getTime())) {
      valid = true;
      current = gridReleaseDate < expiry;
    }
    if (!valid) {
      this.outputInvalidLicenseKey();
    } else if (!current) {
      var formattedExpiryDate = LicenseManager_1.formatDate(expiry);
      var formattedReleaseDate = LicenseManager_1.formatDate(gridReleaseDate);
      this.outputIncompatibleVersion(formattedExpiryDate, formattedReleaseDate);
    }
  };
  LicenseManager.prototype.validateForTrial = function (license) {
    var expiry = LicenseManager_1.extractExpiry(license);
    var now = new Date();
    var valid = false;
    var current = false;
    if (!isNaN(expiry.getTime())) {
      valid = true;
      current = expiry > now;
    }
    if (!valid) {
      this.outputInvalidLicenseKey();
    } else if (!current) {
      var formattedExpiryDate = LicenseManager_1.formatDate(expiry);
      this.outputExpiredTrialKey(formattedExpiryDate);
    }
  };
  LicenseManager.prototype.outputInvalidLicenseKey = function () {
    console.error('*****************************************************************************************************************');
    console.error('***************************************** AG Grid Enterprise License ********************************************');
    console.error('********************************************* Invalid License ***************************************************');
    console.error('* Your license for AG Grid Enterprise is not valid - please contact info@ag-grid.com to obtain a valid license. *');
    console.error('*****************************************************************************************************************');
    console.error('*****************************************************************************************************************');
    this.watermarkMessage = "Invalid License";
  };
  LicenseManager.prototype.outputExpiredTrialKey = function (formattedExpiryDate) {
    console.error('****************************************************************************************************************');
    console.error('***************************************** AG Grid Enterprise License *******************************************');
    console.error('*****************************************   Trial Period Expired.    *******************************************');
    console.error("* Your license for AG Grid Enterprise expired on " + formattedExpiryDate + ".                                                *");
    console.error('* Please email info@ag-grid.com to purchase a license.                                                         *');
    console.error('****************************************************************************************************************');
    console.error('****************************************************************************************************************');
    this.watermarkMessage = "Trial Period Expired";
  };
  LicenseManager.prototype.outputMissingLicenseKey = function () {
    console.error('****************************************************************************************************************');
    console.error('***************************************** AG Grid Enterprise License *******************************************');
    console.error('****************************************** License Key Not Found ***********************************************');
    console.error('* All AG Grid Enterprise features are unlocked.                                                                *');
    console.error('* This is an evaluation only version, it is not licensed for development projects intended for production.     *');
    console.error('* If you want to hide the watermark, please email info@ag-grid.com for a trial license.                        *');
    console.error('****************************************************************************************************************');
    console.error('****************************************************************************************************************');
    this.watermarkMessage = "For Trial Use Only";
  };
  LicenseManager.prototype.outputIncompatibleVersion = function (formattedExpiryDate, formattedReleaseDate) {
    console.error('****************************************************************************************************************************');
    console.error('****************************************************************************************************************************');
    console.error('*                                             AG Grid Enterprise License                                                   *');
    console.error('*                           License not compatible with installed version of AG Grid Enterprise.                           *');
    console.error('*                                                                                                                          *');
    console.error("* Your AG Grid License entitles you to all versions of AG Grid that we release within the time covered by your license     *");
    console.error("* - typically we provide one year licenses which entitles you to all releases / updates of AG Grid within that year.       *");
    console.error("* Your license has an end (expiry) date which stops the license key working with versions of AG Grid released after the    *");
    console.error("* license end date. The license key that you have expires on " + formattedExpiryDate + ", however the version of AG Grid you    *");
    console.error("* are trying to use was released on " + formattedReleaseDate + ".                                                               *");
    console.error('*                                                                                                                          *');
    console.error('* Please contact info@ag-grid.com to renew your subscription to new versions and get a new license key to work with this   *');
    console.error('* version of AG Grid.                                                                                                      *');
    console.error('****************************************************************************************************************************');
    console.error('****************************************************************************************************************************');
    this.watermarkMessage = "License Expired";
  };
  var LicenseManager_1;
  LicenseManager.RELEASE_INFORMATION = 'MTYzNjkxNzQ5MjczNA==';
  __decorate$2k([Autowired('md5')], LicenseManager.prototype, "md5", void 0);
  __decorate$2k([PreConstruct], LicenseManager.prototype, "validateLicense", null);
  LicenseManager = LicenseManager_1 = __decorate$2k([Bean('licenseManager')], LicenseManager);
  return LicenseManager;
}(BeanStub);
var __extends$2F = undefined && undefined.__extends || function () {
  var _extendStatics170 = function extendStatics(d, b) {
    _extendStatics170 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics170(d, b);
  };
  return function (d, b) {
    _extendStatics170(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2l = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MD5 = /** @class */function (_super) {
  __extends$2F(MD5, _super);
  function MD5() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.ieCompatibility = false;
    return _this;
  }
  MD5.prototype.init = function () {
    this.ieCompatibility = this.md5('hello') != '5d41402abc4b2a76b9719d911017c592';
  };
  MD5.prototype.md5cycle = function (x, k) {
    var a = x[0],
      b = x[1],
      c = x[2],
      d = x[3];
    a = this.ff(a, b, c, d, k[0], 7, -680876936);
    d = this.ff(d, a, b, c, k[1], 12, -389564586);
    c = this.ff(c, d, a, b, k[2], 17, 606105819);
    b = this.ff(b, c, d, a, k[3], 22, -1044525330);
    a = this.ff(a, b, c, d, k[4], 7, -176418897);
    d = this.ff(d, a, b, c, k[5], 12, 1200080426);
    c = this.ff(c, d, a, b, k[6], 17, -1473231341);
    b = this.ff(b, c, d, a, k[7], 22, -45705983);
    a = this.ff(a, b, c, d, k[8], 7, 1770035416);
    d = this.ff(d, a, b, c, k[9], 12, -1958414417);
    c = this.ff(c, d, a, b, k[10], 17, -42063);
    b = this.ff(b, c, d, a, k[11], 22, -1990404162);
    a = this.ff(a, b, c, d, k[12], 7, 1804603682);
    d = this.ff(d, a, b, c, k[13], 12, -40341101);
    c = this.ff(c, d, a, b, k[14], 17, -1502002290);
    b = this.ff(b, c, d, a, k[15], 22, 1236535329);
    a = this.gg(a, b, c, d, k[1], 5, -165796510);
    d = this.gg(d, a, b, c, k[6], 9, -1069501632);
    c = this.gg(c, d, a, b, k[11], 14, 643717713);
    b = this.gg(b, c, d, a, k[0], 20, -373897302);
    a = this.gg(a, b, c, d, k[5], 5, -701558691);
    d = this.gg(d, a, b, c, k[10], 9, 38016083);
    c = this.gg(c, d, a, b, k[15], 14, -660478335);
    b = this.gg(b, c, d, a, k[4], 20, -405537848);
    a = this.gg(a, b, c, d, k[9], 5, 568446438);
    d = this.gg(d, a, b, c, k[14], 9, -1019803690);
    c = this.gg(c, d, a, b, k[3], 14, -187363961);
    b = this.gg(b, c, d, a, k[8], 20, 1163531501);
    a = this.gg(a, b, c, d, k[13], 5, -1444681467);
    d = this.gg(d, a, b, c, k[2], 9, -51403784);
    c = this.gg(c, d, a, b, k[7], 14, 1735328473);
    b = this.gg(b, c, d, a, k[12], 20, -1926607734);
    a = this.hh(a, b, c, d, k[5], 4, -378558);
    d = this.hh(d, a, b, c, k[8], 11, -2022574463);
    c = this.hh(c, d, a, b, k[11], 16, 1839030562);
    b = this.hh(b, c, d, a, k[14], 23, -35309556);
    a = this.hh(a, b, c, d, k[1], 4, -1530992060);
    d = this.hh(d, a, b, c, k[4], 11, 1272893353);
    c = this.hh(c, d, a, b, k[7], 16, -155497632);
    b = this.hh(b, c, d, a, k[10], 23, -1094730640);
    a = this.hh(a, b, c, d, k[13], 4, 681279174);
    d = this.hh(d, a, b, c, k[0], 11, -358537222);
    c = this.hh(c, d, a, b, k[3], 16, -722521979);
    b = this.hh(b, c, d, a, k[6], 23, 76029189);
    a = this.hh(a, b, c, d, k[9], 4, -640364487);
    d = this.hh(d, a, b, c, k[12], 11, -421815835);
    c = this.hh(c, d, a, b, k[15], 16, 530742520);
    b = this.hh(b, c, d, a, k[2], 23, -995338651);
    a = this.ii(a, b, c, d, k[0], 6, -198630844);
    d = this.ii(d, a, b, c, k[7], 10, 1126891415);
    c = this.ii(c, d, a, b, k[14], 15, -1416354905);
    b = this.ii(b, c, d, a, k[5], 21, -57434055);
    a = this.ii(a, b, c, d, k[12], 6, 1700485571);
    d = this.ii(d, a, b, c, k[3], 10, -1894986606);
    c = this.ii(c, d, a, b, k[10], 15, -1051523);
    b = this.ii(b, c, d, a, k[1], 21, -2054922799);
    a = this.ii(a, b, c, d, k[8], 6, 1873313359);
    d = this.ii(d, a, b, c, k[15], 10, -30611744);
    c = this.ii(c, d, a, b, k[6], 15, -1560198380);
    b = this.ii(b, c, d, a, k[13], 21, 1309151649);
    a = this.ii(a, b, c, d, k[4], 6, -145523070);
    d = this.ii(d, a, b, c, k[11], 10, -1120210379);
    c = this.ii(c, d, a, b, k[2], 15, 718787259);
    b = this.ii(b, c, d, a, k[9], 21, -343485551);
    x[0] = this.add32(a, x[0]);
    x[1] = this.add32(b, x[1]);
    x[2] = this.add32(c, x[2]);
    x[3] = this.add32(d, x[3]);
  };
  MD5.prototype.cmn = function (q, a, b, x, s, t) {
    a = this.add32(this.add32(a, q), this.add32(x, t));
    return this.add32(a << s | a >>> 32 - s, b);
  };
  MD5.prototype.ff = function (a, b, c, d, x, s, t) {
    return this.cmn(b & c | ~b & d, a, b, x, s, t);
  };
  MD5.prototype.gg = function (a, b, c, d, x, s, t) {
    return this.cmn(b & d | c & ~d, a, b, x, s, t);
  };
  MD5.prototype.hh = function (a, b, c, d, x, s, t) {
    return this.cmn(b ^ c ^ d, a, b, x, s, t);
  };
  MD5.prototype.ii = function (a, b, c, d, x, s, t) {
    return this.cmn(c ^ (b | ~d), a, b, x, s, t);
  };
  MD5.prototype.md51 = function (s) {
    var n = s.length;
    var state = [1732584193, -271733879, -1732584194, 271733878];
    var i;
    for (i = 64; i <= s.length; i += 64) {
      this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
    }
    s = s.substring(i - 64);
    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < s.length; i++) {
      tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
    }
    tail[i >> 2] |= 0x80 << (i % 4 << 3);
    if (i > 55) {
      this.md5cycle(state, tail);
      for (i = 0; i < 16; i++) {
        tail[i] = 0;
      }
    }
    tail[14] = n * 8;
    this.md5cycle(state, tail);
    return state;
  };
  /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */
  MD5.prototype.md5blk = function (s) {
    var md5blks = [];
    /* Andy King said do it this way. */
    for (var i = 0; i < 64; i += 4) {
      md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
  };
  MD5.prototype.rhex = function (n) {
    var hex_chr = '0123456789abcdef'.split('');
    var s = '',
      j = 0;
    for (; j < 4; j++) {
      s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
    }
    return s;
  };
  MD5.prototype.hex = function (x) {
    for (var i = 0; i < x.length; i++) {
      x[i] = this.rhex(x[i]);
    }
    return x.join('');
  };
  MD5.prototype.md5 = function (s) {
    return this.hex(this.md51(s));
  };
  MD5.prototype.add32 = function (a, b) {
    return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
  };
  /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */
  MD5.prototype.add32Std = function (a, b) {
    return a + b & 0xFFFFFFFF;
  };
  MD5.prototype.add32Compat = function (x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF),
      msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  };
  __decorate$2l([PostConstruct], MD5.prototype, "init", null);
  MD5 = __decorate$2l([Bean('md5')], MD5);
  return MD5;
}(BeanStub);
var __extends$2G = undefined && undefined.__extends || function () {
  var _extendStatics171 = function extendStatics(d, b) {
    _extendStatics171 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics171(d, b);
  };
  return function (d, b) {
    _extendStatics171(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2m = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var WatermarkComp = /** @class */function (_super) {
  __extends$2G(WatermarkComp, _super);
  function WatermarkComp() {
    return _super.call(this, "<div class=\"ag-watermark\">\n                    <div ref=\"eLicenseTextRef\" class=\"ag-watermark-text\"></div>\n               </div>") || this;
  }
  WatermarkComp.prototype.postConstruct = function () {
    var _this = this;
    var show = this.shouldDisplayWatermark();
    _.addOrRemoveCssClass(this.getGui(), 'ag-hidden', !show);
    if (show) {
      this.eLicenseTextRef.innerText = this.licenseManager.getWatermarkMessage();
      window.setTimeout(function () {
        return _this.addCssClass('ag-opacity-zero');
      }, 0);
      window.setTimeout(function () {
        return _this.addCssClass('ag-hidden');
      }, 5000);
    }
  };
  WatermarkComp.prototype.shouldDisplayWatermark = function () {
    var isDisplayWatermark = this.licenseManager.isDisplayWatermark();
    var isWhiteListURL = location.hostname.match('^(?:127\.0\.0\.1|localhost|(?:\w+\.)?ag-grid\.com)$') != null;
    var isForceWatermark = location.pathname ? location.pathname.indexOf('forceWatermark') !== -1 : false;
    return isForceWatermark || isDisplayWatermark && !isWhiteListURL;
  };
  __decorate$2m([Autowired('licenseManager')], WatermarkComp.prototype, "licenseManager", void 0);
  __decorate$2m([RefSelector('eLicenseTextRef')], WatermarkComp.prototype, "eLicenseTextRef", void 0);
  __decorate$2m([PostConstruct], WatermarkComp.prototype, "postConstruct", null);
  return WatermarkComp;
}(Component);
var EnterpriseCoreModule = {
  moduleName: ModuleNames.EnterpriseCoreModule,
  beans: [LicenseManager, MD5],
  agStackComponents: [{
    componentName: 'AgWatermark',
    componentClass: WatermarkComp
  }]
};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1 = "function" === typeof Symbol && Symbol.for,
  c$1 = b$1 ? Symbol.for("react.element") : 60103,
  d$1 = b$1 ? Symbol.for("react.portal") : 60106,
  e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
  f$8 = b$1 ? Symbol.for("react.strict_mode") : 60108,
  g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
  h$1 = b$1 ? Symbol.for("react.provider") : 60109,
  k$1 = b$1 ? Symbol.for("react.context") : 60110,
  l$1 = b$1 ? Symbol.for("react.async_mode") : 60111,
  m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
  n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112,
  p$1 = b$1 ? Symbol.for("react.suspense") : 60113,
  q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120,
  r$1 = b$1 ? Symbol.for("react.memo") : 60115,
  t = b$1 ? Symbol.for("react.lazy") : 60116,
  v$1 = b$1 ? Symbol.for("react.block") : 60121,
  w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
  x$1 = b$1 ? Symbol.for("react.responder") : 60118,
  y$1 = b$1 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$8:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t:
              case r$1:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d$1:
        return u;
    }
  }
}
function A$1(a) {
  return z$1(a) === m$1;
}
var AsyncMode = l$1;
var ConcurrentMode = m$1;
var ContextConsumer$1 = k$1;
var ContextProvider$1 = h$1;
var Element$2 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t;
var Memo$1 = r$1;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$8;
var Suspense$1 = p$1;
var isAsyncMode$1 = function isAsyncMode$1(a) {
  return A$1(a) || z$1(a) === l$1;
};
var isConcurrentMode$1 = A$1;
var isContextConsumer$1 = function isContextConsumer$1(a) {
  return z$1(a) === k$1;
};
var isContextProvider$1 = function isContextProvider$1(a) {
  return z$1(a) === h$1;
};
var isElement$3 = function isElement$3(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};
var isForwardRef$1 = function isForwardRef$1(a) {
  return z$1(a) === n$1;
};
var isFragment$1 = function isFragment$1(a) {
  return z$1(a) === e$1;
};
var isLazy$1 = function isLazy$1(a) {
  return z$1(a) === t;
};
var isMemo$1 = function isMemo$1(a) {
  return z$1(a) === r$1;
};
var isPortal$1 = function isPortal$1(a) {
  return z$1(a) === d$1;
};
var isProfiler$1 = function isProfiler$1(a) {
  return z$1(a) === g$1;
};
var isStrictMode$1 = function isStrictMode$1(a) {
  return z$1(a) === f$8;
};
var isSuspense$1 = function isSuspense$1(a) {
  return z$1(a) === p$1;
};
var isValidElementType$1 = function isValidElementType$1(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$8 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
var typeOf$1 = z$1;
var reactIs_production_min$1 = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer$1,
  ContextProvider: ContextProvider$1,
  Element: Element$2,
  ForwardRef: ForwardRef$1,
  Fragment: Fragment$1,
  Lazy: Lazy$1,
  Memo: Memo$1,
  Portal: Portal$1,
  Profiler: Profiler$1,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  isAsyncMode: isAsyncMode$1,
  isConcurrentMode: isConcurrentMode$1,
  isContextConsumer: isContextConsumer$1,
  isContextProvider: isContextProvider$1,
  isElement: isElement$3,
  isForwardRef: isForwardRef$1,
  isFragment: isFragment$1,
  isLazy: isLazy$1,
  isMemo: isMemo$1,
  isPortal: isPortal$1,
  isProfiler: isProfiler$1,
  isStrictMode: isStrictMode$1,
  isSuspense: isSuspense$1,
  isValidElementType: isValidElementType$1,
  typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1$1 = reactIs_development$1.AsyncMode;
var reactIs_development_2$1 = reactIs_development$1.ConcurrentMode;
var reactIs_development_3$1 = reactIs_development$1.ContextConsumer;
var reactIs_development_4$1 = reactIs_development$1.ContextProvider;
var reactIs_development_5$1 = reactIs_development$1.Element;
var reactIs_development_6$1 = reactIs_development$1.ForwardRef;
var reactIs_development_7$1 = reactIs_development$1.Fragment;
var reactIs_development_8$1 = reactIs_development$1.Lazy;
var reactIs_development_9$1 = reactIs_development$1.Memo;
var reactIs_development_10$1 = reactIs_development$1.Portal;
var reactIs_development_11$1 = reactIs_development$1.Profiler;
var reactIs_development_12$1 = reactIs_development$1.StrictMode;
var reactIs_development_13$1 = reactIs_development$1.Suspense;
var reactIs_development_14$1 = reactIs_development$1.isAsyncMode;
var reactIs_development_15$1 = reactIs_development$1.isConcurrentMode;
var reactIs_development_16$1 = reactIs_development$1.isContextConsumer;
var reactIs_development_17$1 = reactIs_development$1.isContextProvider;
var reactIs_development_18$1 = reactIs_development$1.isElement;
var reactIs_development_19$1 = reactIs_development$1.isForwardRef;
var reactIs_development_20$1 = reactIs_development$1.isFragment;
var reactIs_development_21$1 = reactIs_development$1.isLazy;
var reactIs_development_22$1 = reactIs_development$1.isMemo;
var reactIs_development_23$1 = reactIs_development$1.isPortal;
var reactIs_development_24$1 = reactIs_development$1.isProfiler;
var reactIs_development_25$1 = reactIs_development$1.isStrictMode;
var reactIs_development_26$1 = reactIs_development$1.isSuspense;
var reactIs_development_27 = reactIs_development$1.isValidElementType;
var reactIs_development_28 = reactIs_development$1.typeOf;
var reactIs$1 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign$1 = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function printWarning$1() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var utils$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // effectively Object.assign - here for IE compatibility
  exports.assignProperties = function (to, from) {
    var styleKeys = Object.keys(from);
    styleKeys.forEach(function (key) {
      to[key] = from[key];
    });
  };
  /*
   * http://stackoverflow.com/a/13719799/2393347
   */
  exports.assign = function (obj, prop, value) {
    if (typeof prop === 'string') prop = prop.split('.');
    if (prop.length > 1) {
      var e = prop.shift();
      exports.assign(obj[e] = Object.prototype.toString.call(obj[e]) === '[object Object]' ? obj[e] : {}, prop, value);
    } else obj[prop[0]] = value;
  };
});
unwrapExports(utils$1);
var utils_1 = utils$1.assignProperties;
var utils_2 = utils$1.assign;
var reactComponent = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics172 = function extendStatics(d, b) {
      _extendStatics172 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics172(d, b);
    };
    return function (d, b) {
      _extendStatics172(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var BaseReactComponent = /** @class */function () {
    function BaseReactComponent() {}
    return BaseReactComponent;
  }();
  var ReactComponent = /** @class */function (_super) {
    __extends(ReactComponent, _super);
    function ReactComponent(reactComponent, portalManager, componentType) {
      var _this = _super.call(this) || this;
      _this.portal = null;
      _this.reactComponent = reactComponent;
      _this.portalManager = portalManager;
      _this.componentType = componentType;
      _this.statelessComponent = _this.isStateless(_this.reactComponent);
      return _this;
    }
    ReactComponent.prototype.getGui = function () {
      return this.eParentElement;
    };
    ReactComponent.prototype.destroy = function () {
      if (this.componentInstance && typeof this.componentInstance.destroy == 'function') {
        this.componentInstance.destroy();
      }
      return this.portalManager.destroyPortal(this.portal);
    };
    ReactComponent.prototype.createParentElement = function (params) {
      var componentWrappingElement = this.portalManager.getComponentWrappingElement();
      var eParentElement = document.createElement(componentWrappingElement || 'div');
      main._.addCssClass(eParentElement, 'ag-react-container');
      // DEPRECATED - use componentInstance.getReactContainerStyle or componentInstance.getReactContainerClasses instead
      // so user can have access to the react container, to add css class or style
      params.reactContainer = eParentElement;
      return eParentElement;
    };
    ReactComponent.prototype.addParentContainerStyleAndClasses = function () {
      var _this = this;
      if (!this.componentInstance) {
        return;
      }
      if (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle()) {
        utils$1.assignProperties(this.eParentElement.style, this.componentInstance.getReactContainerStyle());
      }
      if (this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses()) {
        var parentContainerClasses = this.componentInstance.getReactContainerClasses();
        parentContainerClasses.forEach(function (className) {
          return main._.addCssClass(_this.eParentElement, className);
        });
      }
    };
    ReactComponent.prototype.statelessComponentRendered = function () {
      // fixed fragmentsFuncRendererCreateDestroy funcRendererWithNan (changeDetectionService too for NaN)
      return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    };
    ReactComponent.prototype.getFrameworkComponentInstance = function () {
      return this.componentInstance;
    };
    ReactComponent.prototype.isStatelessComponent = function () {
      return this.statelessComponent;
    };
    ReactComponent.prototype.getReactComponentName = function () {
      return this.reactComponent.name;
    };
    ReactComponent.prototype.getMemoType = function () {
      return this.hasSymbol() ? Symbol.for('react.memo') : 0xead3;
    };
    ReactComponent.prototype.hasSymbol = function () {
      return typeof Symbol === 'function' && Symbol.for;
    };
    ReactComponent.prototype.isStateless = function (Component) {
      return typeof Component === 'function' && !(Component.prototype && Component.prototype.isReactComponent) || typeof Component === 'object' && Component.$$typeof === this.getMemoType();
    };
    ReactComponent.prototype.hasMethod = function (name) {
      var frameworkComponentInstance = this.getFrameworkComponentInstance();
      return !!frameworkComponentInstance && frameworkComponentInstance[name] !== null || this.fallbackMethodAvailable(name);
    };
    ReactComponent.prototype.callMethod = function (name, args) {
      var _this = this;
      var frameworkComponentInstance = this.getFrameworkComponentInstance();
      if (this.isStatelessComponent()) {
        return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
      } else if (!!!frameworkComponentInstance) {
        // instance not ready yet - wait for it
        setTimeout(function () {
          return _this.callMethod(name, args);
        });
        return;
      }
      var method = frameworkComponentInstance[name];
      if (!!method) {
        return method.apply(frameworkComponentInstance, args);
      }
      if (this.fallbackMethodAvailable(name)) {
        return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
      }
    };
    ReactComponent.prototype.addMethod = function (name, callback) {
      this[name] = callback;
    };
    return ReactComponent;
  }(BaseReactComponent);
  exports.ReactComponent = ReactComponent;
});
unwrapExports(reactComponent);
var reactComponent_1 = reactComponent.ReactComponent;
var keyGenerator = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var counter = 0;
  function generateNewKey() {
    return "agPortalKey_" + ++counter;
  }
  exports.default = generateNewKey;
});
unwrapExports(keyGenerator);
var legacyReactComponent = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics173 = function extendStatics(d, b) {
      _extendStatics173 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics173(d, b);
    };
    return function (d, b) {
      _extendStatics173(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var keyGenerator_1 = __importDefault(keyGenerator);
  var LegacyReactComponent = /** @class */function (_super) {
    __extends(LegacyReactComponent, _super);
    function LegacyReactComponent(reactComponent, parentComponent, portalManager, componentType) {
      var _this = _super.call(this, reactComponent, portalManager, componentType) || this;
      _this.staticMarkup = null;
      _this.staticRenderTime = 0;
      _this.parentComponent = parentComponent;
      return _this;
    }
    LegacyReactComponent.prototype.init = function (params) {
      var _this = this;
      this.eParentElement = this.createParentElement(params);
      this.renderStaticMarkup(params);
      return new main.AgPromise(function (resolve) {
        return _this.createReactComponent(params, resolve);
      });
    };
    LegacyReactComponent.prototype.createReactComponent = function (params, resolve) {
      var _this = this;
      // regular components (ie not functional)
      if (!this.isStatelessComponent()) {
        // grab hold of the actual instance created
        params.ref = function (element) {
          _this.componentInstance = element;
          _this.addParentContainerStyleAndClasses();
          _this.removeStaticMarkup();
        };
      }
      var reactComponent = React__default.createElement(this.reactComponent, params);
      var portal = ReactDOM.createPortal(reactComponent, this.eParentElement, keyGenerator_1.default() // fixed deltaRowModeRefreshCompRenderer
      );

      this.portal = portal;
      this.portalManager.mountReactPortal(portal, this, function (value) {
        resolve(value);
        // functional/stateless components have a slightly different lifecycle (no refs) so we'll clean them up
        // here
        if (_this.isStatelessComponent()) {
          if (_this.isSlowRenderer()) {
            _this.removeStaticMarkup();
          }
          setTimeout(function () {
            _this.removeStaticMarkup();
          });
        }
      });
    };
    LegacyReactComponent.prototype.fallbackMethodAvailable = function (name) {
      return false;
    };
    LegacyReactComponent.prototype.fallbackMethod = function (name, params) {};
    LegacyReactComponent.prototype.isSlowRenderer = function () {
      return this.staticRenderTime >= LegacyReactComponent.SLOW_RENDERING_THRESHOLD;
    };
    LegacyReactComponent.prototype.isNullValue = function () {
      return this.staticMarkup === '';
    };
    /*
     * Attempt to render the component as static markup if possible
     * What this does is eliminate any visible flicker for the user in the scenario where a component is destroyed and
     * recreated with exactly the same data (ie with force refresh)
     * Note: Some use cases will throw an error (ie when using Context) so if an error occurs just ignore it any move on
     */
    LegacyReactComponent.prototype.renderStaticMarkup = function (params) {
      if (this.parentComponent.isDisableStaticMarkup() || this.componentType.isCellRenderer && !this.componentType.isCellRenderer()) {
        return;
      }
      var originalConsoleError = console.error;
      var reactComponent = React__default.createElement(this.reactComponent, params);
      try {
        // if a user is doing anything that uses useLayoutEffect (like material ui) then it will throw and we
        // can't do anything to stop it; this is just a warning and has no effect on anything so just suppress it
        // for this single operation
        console.error = function () {};
        var start = Date.now();
        var staticMarkup = server.renderToStaticMarkup(reactComponent);
        this.staticRenderTime = Date.now() - start;
        console.error = originalConsoleError;
        // if the render method returns null the result will be an empty string
        if (staticMarkup === '') {
          this.staticMarkup = staticMarkup;
        } else {
          if (staticMarkup) {
            // we wrap the content as if there is "trailing" text etc it's not easy to safely remove
            // the same is true for memoized renderers, renderers that that return simple strings or NaN etc
            this.staticMarkup = document.createElement('span');
            this.staticMarkup.innerHTML = staticMarkup;
            this.eParentElement.appendChild(this.staticMarkup);
          }
        }
      } catch (e) {
        // we tried - this can happen with certain (rare) edge cases
      } finally {
        console.error = originalConsoleError;
      }
    };
    LegacyReactComponent.prototype.removeStaticMarkup = function () {
      if (this.parentComponent.isDisableStaticMarkup() || !this.componentType.isCellRenderer()) {
        return;
      }
      if (this.staticMarkup) {
        if (this.staticMarkup.remove) {
          // everyone else in the world
          this.staticMarkup.remove();
          this.staticMarkup = null;
        } else if (this.eParentElement.removeChild) {
          // ie11...
          this.eParentElement.removeChild(this.staticMarkup);
          this.staticMarkup = null;
        }
      }
    };
    LegacyReactComponent.prototype.rendered = function () {
      return this.isNullValue() || !!this.staticMarkup || this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    };
    LegacyReactComponent.SLOW_RENDERING_THRESHOLD = 3;
    return LegacyReactComponent;
  }(reactComponent.ReactComponent);
  exports.LegacyReactComponent = LegacyReactComponent;
});
unwrapExports(legacyReactComponent);
var legacyReactComponent_1 = legacyReactComponent.LegacyReactComponent;
var agGridColumn = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics174 = function extendStatics(d, b) {
      _extendStatics174 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics174(d, b);
    };
    return function (d, b) {
      _extendStatics174(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __rest = commonjsGlobal && commonjsGlobal.__rest || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var prop_types_1 = __importDefault(propTypes);
  var AgGrid = __importStar(main);
  var AgGridColumn = /** @class */function (_super) {
    __extends(AgGridColumn, _super);
    function AgGridColumn(props) {
      var _this = _super.call(this, props) || this;
      _this.props = props;
      return _this;
    }
    AgGridColumn.prototype.render = function () {
      return null;
    };
    AgGridColumn.mapChildColumnDefs = function (children) {
      return react_1.default.Children.map(children, function (child) {
        return !!child ? AgGridColumn.toColDef(child.props) : null;
      });
    };
    AgGridColumn.toColDef = function (columnProps) {
      var children = columnProps.children,
        colDef = __rest(columnProps, ["children"]);
      if (AgGridColumn.hasChildColumns(children)) {
        colDef.children = AgGridColumn.mapChildColumnDefs(children);
      }
      return colDef;
    };
    AgGridColumn.hasChildColumns = function (children) {
      return react_1.default.Children.count(children) > 0;
    };
    return AgGridColumn;
  }(react_1.Component);
  exports.AgGridColumn = AgGridColumn;
  addProperties(AgGrid.ColDefUtil.BOOLEAN_PROPERTIES, prop_types_1.default.bool);
  addProperties(AgGrid.ColDefUtil.STRING_PROPERTIES, prop_types_1.default.string);
  addProperties(AgGrid.ColDefUtil.OBJECT_PROPERTIES, prop_types_1.default.object);
  addProperties(AgGrid.ColDefUtil.ARRAY_PROPERTIES, prop_types_1.default.array);
  addProperties(AgGrid.ColDefUtil.NUMBER_PROPERTIES, prop_types_1.default.number);
  addProperties(AgGrid.ColDefUtil.FUNCTION_PROPERTIES, prop_types_1.default.func);
  function addProperties(listOfProps, propType) {
    listOfProps.forEach(function (propKey) {
      // @ts-ignore
      AgGridColumn[propKey] = propType;
    });
  }
});
unwrapExports(agGridColumn);
var agGridColumn_1 = agGridColumn.AgGridColumn;
var changeDetectionService = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ChangeDetectionStrategyType;
  (function (ChangeDetectionStrategyType) {
    ChangeDetectionStrategyType["IdentityCheck"] = "IdentityCheck";
    ChangeDetectionStrategyType["DeepValueCheck"] = "DeepValueCheck";
    ChangeDetectionStrategyType["NoCheck"] = "NoCheck";
  })(ChangeDetectionStrategyType = exports.ChangeDetectionStrategyType || (exports.ChangeDetectionStrategyType = {}));
  var SimpleFunctionalStrategy = /** @class */function () {
    function SimpleFunctionalStrategy(strategy) {
      this.strategy = strategy;
    }
    SimpleFunctionalStrategy.prototype.areEqual = function (a, b) {
      return this.strategy(a, b);
    };
    return SimpleFunctionalStrategy;
  }();
  var DeepValueStrategy = /** @class */function () {
    function DeepValueStrategy() {}
    DeepValueStrategy.prototype.areEqual = function (a, b) {
      return DeepValueStrategy.areEquivalent(DeepValueStrategy.copy(a), DeepValueStrategy.copy(b));
    };
    /*
     * deeper object comparison - taken from https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
     */
    DeepValueStrategy.unwrapStringOrNumber = function (obj) {
      return obj instanceof Number || obj instanceof String ? obj.valueOf() : obj;
    };
    // sigh, here for ie compatibility
    DeepValueStrategy.copy = function (value) {
      if (!value) {
        return value;
      }
      if (Array.isArray(value)) {
        // shallow copy the array - this will typically be either rowData or columnDefs
        var arrayCopy = [];
        for (var i = 0; i < value.length; i++) {
          arrayCopy.push(this.copy(value[i]));
        }
        return arrayCopy;
      }
      // for anything without keys (boolean, string etc).
      // Object.keys - chrome will swallow them, IE will fail (correctly, imho)
      if (typeof value !== "object") {
        return value;
      }
      return [{}, value].reduce(function (r, o) {
        Object.keys(o).forEach(function (k) {
          r[k] = o[k];
        });
        return r;
      }, {});
    };
    DeepValueStrategy.isNaN = function (value) {
      if (Number.isNaN) {
        return Number.isNaN(value);
      }
      // for ie11...
      return typeof value === 'number' && isNaN(value);
    };
    /*
     * slightly modified, but taken from https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
     *
     * What we're trying to do here is determine if the property being checked has changed in _value_, not just in reference
     *
     * For eg, if a user updates the columnDefs via property binding, but the actual columns defs are the same before and
     * after, then we don't want the grid to re-render
     */
    DeepValueStrategy.areEquivalent = function (a, b) {
      a = DeepValueStrategy.unwrapStringOrNumber(a);
      b = DeepValueStrategy.unwrapStringOrNumber(b);
      if (a === b) return true; //e.g. a and b both null
      if (a === null || b === null || typeof a !== typeof b) return false;
      if (DeepValueStrategy.isNaN(a) && DeepValueStrategy.isNaN(b)) {
        return true;
      }
      if (a instanceof Date) {
        return b instanceof Date && a.valueOf() === b.valueOf();
      }
      if (typeof a === "function") {
        // false to allow for callbacks to be reactive...
        return false;
      }
      if (typeof a !== "object" || a.$$typeof && a.$$typeof.toString() === "Symbol(react.element)") {
        return a == b; //for boolean, number, string, function, xml
      }

      if (Object.isFrozen(a) || Object.isFrozen(b)) {
        return a === b;
      }
      var newA = a.areEquivPropertyTracking === undefined,
        newB = b.areEquivPropertyTracking === undefined;
      try {
        var prop = void 0;
        if (newA) {
          a.areEquivPropertyTracking = [];
        } else if (a.areEquivPropertyTracking.some(function (other) {
          return other === b;
        })) return true;
        if (newB) {
          b.areEquivPropertyTracking = [];
        } else if (b.areEquivPropertyTracking.some(function (other) {
          return other === a;
        })) {
          return true;
        }
        a.areEquivPropertyTracking.push(b);
        b.areEquivPropertyTracking.push(a);
        var tmp = {};
        for (prop in a) if (prop != "areEquivPropertyTracking") {
          tmp[prop] = null;
        }
        for (prop in b) if (prop != "areEquivPropertyTracking") {
          tmp[prop] = null;
        }
        for (prop in tmp) {
          if (!this.areEquivalent(a[prop], b[prop])) {
            return false;
          }
        }
        return true;
      } finally {
        if (newA) delete a.areEquivPropertyTracking;
        if (newB) delete b.areEquivPropertyTracking;
      }
    };
    return DeepValueStrategy;
  }();
  var ChangeDetectionService = /** @class */function () {
    function ChangeDetectionService() {
      var _a;
      this.strategyMap = (_a = {}, _a[ChangeDetectionStrategyType.DeepValueCheck] = new DeepValueStrategy(), _a[ChangeDetectionStrategyType.IdentityCheck] = new SimpleFunctionalStrategy(function (a, b) {
        return a === b;
      }), _a[ChangeDetectionStrategyType.NoCheck] = new SimpleFunctionalStrategy(function (a, b) {
        return false;
      }), _a);
    }
    ChangeDetectionService.prototype.getStrategy = function (changeDetectionStrategy) {
      return this.strategyMap[changeDetectionStrategy];
    };
    return ChangeDetectionService;
  }();
  exports.ChangeDetectionService = ChangeDetectionService;
});
unwrapExports(changeDetectionService);
var changeDetectionService_1 = changeDetectionService.ChangeDetectionStrategyType;
var changeDetectionService_2 = changeDetectionService.ChangeDetectionService;
var newReactComponent = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics175 = function extendStatics(d, b) {
      _extendStatics175 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics175(d, b);
    };
    return function (d, b) {
      _extendStatics175(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var keyGenerator_1 = __importDefault(keyGenerator);
  var NewReactComponent = /** @class */function (_super) {
    __extends(NewReactComponent, _super);
    function NewReactComponent(reactComponent, parentComponent, componentType) {
      var _this = _super.call(this, reactComponent, parentComponent, componentType) || this;
      _this.oldPortal = null;
      _this.key = keyGenerator_1.default();
      _this.portalKey = keyGenerator_1.default();
      return _this;
    }
    NewReactComponent.prototype.init = function (params) {
      var _this = this;
      this.eParentElement = this.createParentElement(params);
      this.params = params;
      this.createOrUpdatePortal(params);
      return new main.AgPromise(function (resolve) {
        return _this.createReactComponent(resolve);
      });
    };
    NewReactComponent.prototype.createOrUpdatePortal = function (params) {
      var _this = this;
      if (!this.isStatelessComponent()) {
        // grab hold of the actual instance created
        params.ref = function (element) {
          _this.componentInstance = element;
          _this.addParentContainerStyleAndClasses();
        };
      }
      this.reactElement = React__default.createElement(this.reactComponent, __assign(__assign({}, params), {
        key: this.key
      }));
      this.portal = ReactDOM.createPortal(this.reactElement, this.eParentElement, this.portalKey // fixed deltaRowModeRefreshCompRenderer
      );
    };

    NewReactComponent.prototype.createReactComponent = function (resolve) {
      this.portalManager.mountReactPortal(this.portal, this, function (value) {
        resolve(value);
      });
    };
    NewReactComponent.prototype.isNullValue = function () {
      return this.valueRenderedIsNull(this.params);
    };
    NewReactComponent.prototype.rendered = function () {
      return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    };
    NewReactComponent.prototype.valueRenderedIsNull = function (params) {
      // we only do this for cellRenderers
      if (this.componentType.isCellRenderer && !this.componentType.isCellRenderer()) {
        return false;
      }
      // we've no way of knowing if a component returns null without rendering it first
      // so we render it to markup and check the output - if it'll be null we know and won't timeout
      // waiting for a component that will never be created
      var originalConsoleError = console.error;
      try {
        // if a user is doing anything that uses useLayoutEffect (like material ui) then it will throw and we
        // can't do anything to stop it; this is just a warning and has no effect on anything so just suppress it
        // for this single operation
        console.error = function () {};
        var staticMarkup = server.renderToStaticMarkup(React__default.createElement(this.reactComponent, params));
        return staticMarkup === '';
      } catch (ignore) {} finally {
        console.error = originalConsoleError;
      }
      return false;
    };
    /*
    * fallback methods - these will be invoked if a corresponding instance method is not present
    * for example if refresh is called and is not available on the component instance, then refreshComponent on this
    * class will be invoked instead
    *
    * Currently only refresh is supported
    */
    NewReactComponent.prototype.refreshComponent = function (args) {
      this.oldPortal = this.portal;
      this.createOrUpdatePortal(args);
      this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    };
    NewReactComponent.prototype.fallbackMethod = function (name, params) {
      var method = this[name + "Component"];
      if (!!method) {
        return method.bind(this)(params);
      }
    };
    NewReactComponent.prototype.fallbackMethodAvailable = function (name) {
      var method = this[name + "Component"];
      return !!method;
    };
    return NewReactComponent;
  }(reactComponent.ReactComponent);
  exports.NewReactComponent = NewReactComponent;
});
unwrapExports(newReactComponent);
var newReactComponent_1 = newReactComponent.NewReactComponent;
var portalManager = createCommonjsModule(function (module, exports) {
  var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PortalManager = /** @class */function () {
    function PortalManager(parent, wrappingElement, maxComponentCreationTimeMs) {
      this.destroyed = false;
      this.portals = [];
      this.hasPendingPortalUpdate = false;
      this.wrappingElement = wrappingElement ? wrappingElement : 'div';
      this.parent = parent;
      this.maxComponentCreationTimeMs = maxComponentCreationTimeMs ? maxComponentCreationTimeMs : PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    PortalManager.prototype.getPortals = function () {
      return this.portals;
    };
    PortalManager.prototype.destroy = function () {
      this.destroyed = true;
    };
    PortalManager.prototype.destroyPortal = function (portal) {
      this.portals = this.portals.filter(function (curPortal) {
        return curPortal !== portal;
      });
      this.batchUpdate();
    };
    PortalManager.prototype.getComponentWrappingElement = function () {
      return this.wrappingElement;
    };
    PortalManager.prototype.mountReactPortal = function (portal, reactComponent, resolve) {
      this.portals = __spreadArrays(this.portals, [portal]);
      this.waitForInstance(reactComponent, resolve);
      this.batchUpdate();
    };
    PortalManager.prototype.updateReactPortal = function (oldPortal, newPortal) {
      this.portals[this.portals.indexOf(oldPortal)] = newPortal;
      this.batchUpdate();
    };
    PortalManager.prototype.batchUpdate = function () {
      var _this = this;
      if (this.hasPendingPortalUpdate) {
        return;
      }
      setTimeout(function () {
        if (!_this.destroyed) {
          // destroyed?
          _this.parent.forceUpdate(function () {
            _this.hasPendingPortalUpdate = false;
          });
        }
      });
      this.hasPendingPortalUpdate = true;
    };
    PortalManager.prototype.waitForInstance = function (reactComponent, resolve, startTime) {
      var _this = this;
      if (startTime === void 0) {
        startTime = Date.now();
      }
      // if the grid has been destroyed in the meantime just resolve
      if (this.destroyed) {
        resolve(null);
        return;
      }
      if (reactComponent.rendered()) {
        resolve(reactComponent);
      } else {
        if (Date.now() - startTime >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
          // last check - we check if this is a null value being rendered - we do this last as using SSR to check the value
          // can mess up contexts
          if (reactComponent.isNullValue()) {
            resolve(reactComponent);
            return;
          }
          console.error("AG Grid: React Component '" + reactComponent.getReactComponentName() + "' not created within " + this.maxComponentCreationTimeMs + "ms");
          return;
        }
        window.setTimeout(function () {
          _this.waitForInstance(reactComponent, resolve, startTime);
        });
      }
    };
    PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS = 1000; // a second should be more than enough to instantiate a component
    return PortalManager;
  }();
  exports.PortalManager = PortalManager;
});
unwrapExports(portalManager);
var portalManager_1 = portalManager.PortalManager;
var agGridReactLegacy = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics176 = function extendStatics(d, b) {
      _extendStatics176 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics176(d, b);
    };
    return function (d, b) {
      _extendStatics176(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var prop_types_1 = __importDefault(propTypes);
  var react_1 = __importStar(React__default);
  var AgGridReactLegacy = /** @class */function (_super) {
    __extends(AgGridReactLegacy, _super);
    function AgGridReactLegacy(props) {
      var _this = _super.call(this, props) || this;
      _this.props = props;
      _this.changeDetectionService = new changeDetectionService.ChangeDetectionService();
      _this.api = null;
      _this.destroyed = false;
      _this.SYNCHRONOUS_CHANGE_PROPERTIES = ['context'];
      _this.portalManager = new portalManager.PortalManager(_this, props.componentWrappingElement, props.maxComponentCreationTimeMs);
      return _this;
    }
    AgGridReactLegacy.prototype.render = function () {
      var _this = this;
      return react_1.default.createElement('div', {
        style: this.createStyleForDiv(),
        className: this.props.className,
        ref: function ref(e) {
          _this.eGridDiv = e;
        }
      }, this.portalManager.getPortals());
    };
    AgGridReactLegacy.prototype.createStyleForDiv = function () {
      return __assign({
        height: '100%'
      }, this.props.containerStyle || {});
    };
    AgGridReactLegacy.prototype.componentDidMount = function () {
      var modules = this.props.modules || [];
      var gridParams = {
        providedBeanInstances: {
          agGridReact: this,
          frameworkComponentWrapper: new ReactFrameworkComponentWrapper(this, this.portalManager)
        },
        modules: modules
      };
      var gridOptions = this.props.gridOptions || {};
      var children = this.props.children;
      if (agGridColumn.AgGridColumn.hasChildColumns(children)) {
        gridOptions.columnDefs = agGridColumn.AgGridColumn.mapChildColumnDefs(children);
      }
      this.gridOptions = main.ComponentUtil.copyAttributesToGridOptions(gridOptions, this.props);
      // don't need the return value
      new main.Grid(this.eGridDiv, this.gridOptions, gridParams);
      this.api = this.gridOptions.api;
      this.columnApi = this.gridOptions.columnApi;
      this.props.setGridApi(this.api, this.columnApi);
    };
    AgGridReactLegacy.prototype.getStrategyTypeForProp = function (propKey) {
      if (propKey === 'rowData') {
        if (this.props.rowDataChangeDetectionStrategy) {
          return this.props.rowDataChangeDetectionStrategy;
        } else if (this.isImmutableDataActive()) {
          return changeDetectionService.ChangeDetectionStrategyType.IdentityCheck;
        }
      }
      // all other cases will default to DeepValueCheck
      return changeDetectionService.ChangeDetectionStrategyType.DeepValueCheck;
    };
    AgGridReactLegacy.prototype.isImmutableDataActive = function () {
      return this.props.deltaRowDataMode || this.props.immutableData || this.props.gridOptions && (this.props.gridOptions.deltaRowDataMode || this.props.gridOptions.immutableData);
    };
    AgGridReactLegacy.prototype.shouldComponentUpdate = function (nextProps) {
      this.processPropsChanges(this.props, nextProps);
      // we want full control of the dom, as AG Grid doesn't use React internally,
      // so for performance reasons we tell React we don't need render called after
      // property changes.
      return false;
    };
    AgGridReactLegacy.prototype.componentDidUpdate = function (prevProps) {
      this.processPropsChanges(prevProps, this.props);
    };
    AgGridReactLegacy.prototype.processPropsChanges = function (prevProps, nextProps) {
      var changes = {};
      this.extractGridPropertyChanges(prevProps, nextProps, changes);
      this.extractDeclarativeColDefChanges(nextProps, changes);
      this.processSynchronousChanges(changes);
      this.processAsynchronousChanges(changes);
    };
    AgGridReactLegacy.prototype.extractDeclarativeColDefChanges = function (nextProps, changes) {
      // if columnDefs are provided on gridOptions we use those - you can't combine both
      // we also skip if columnDefs are provided as a prop directly on AgGridReact
      if (this.props.gridOptions && this.props.gridOptions.columnDefs || this.props.columnDefs) {
        return;
      }
      var debugLogging = !!nextProps.debug;
      var propKey = 'columnDefs';
      var currentColDefs = this.gridOptions.columnDefs;
      if (agGridColumn.AgGridColumn.hasChildColumns(nextProps.children)) {
        var detectionStrategy = this.changeDetectionService.getStrategy(this.getStrategyTypeForProp(propKey));
        var newColDefs = agGridColumn.AgGridColumn.mapChildColumnDefs(nextProps.children);
        if (!detectionStrategy.areEqual(currentColDefs, newColDefs)) {
          if (debugLogging) {
            console.log("agGridReact: colDefs definitions changed");
          }
          changes[propKey] = {
            previousValue: currentColDefs,
            currentValue: newColDefs
          };
        }
      } else if (currentColDefs && currentColDefs.length > 0) {
        changes[propKey] = {
          previousValue: currentColDefs,
          currentValue: []
        };
      }
    };
    AgGridReactLegacy.prototype.extractGridPropertyChanges = function (prevProps, nextProps, changes) {
      var _this = this;
      var debugLogging = !!nextProps.debug;
      Object.keys(nextProps).forEach(function (propKey) {
        if (main._.includes(main.ComponentUtil.ALL_PROPERTIES, propKey)) {
          var changeDetectionStrategy = _this.changeDetectionService.getStrategy(_this.getStrategyTypeForProp(propKey));
          if (!changeDetectionStrategy.areEqual(prevProps[propKey], nextProps[propKey])) {
            if (debugLogging) {
              console.log("agGridReact: [" + propKey + "] property changed");
            }
            changes[propKey] = {
              previousValue: prevProps[propKey],
              currentValue: nextProps[propKey]
            };
          }
        }
      });
      main.ComponentUtil.getEventCallbacks().forEach(function (funcName) {
        if (prevProps[funcName] !== nextProps[funcName]) {
          if (debugLogging) {
            console.log("agGridReact: [" + funcName + "] event callback changed");
          }
          changes[funcName] = {
            previousValue: prevProps[funcName],
            currentValue: nextProps[funcName]
          };
        }
      });
    };
    AgGridReactLegacy.prototype.componentWillUnmount = function () {
      if (this.api) {
        this.api.destroy();
        this.api = null;
      }
      this.destroyed = true;
      this.portalManager.destroy();
    };
    AgGridReactLegacy.prototype.isDisableStaticMarkup = function () {
      return this.props.disableStaticMarkup === true;
    };
    AgGridReactLegacy.prototype.isLegacyComponentRendering = function () {
      return this.props.legacyComponentRendering === true;
    };
    AgGridReactLegacy.prototype.processSynchronousChanges = function (changes) {
      var asyncChanges = __assign({}, changes);
      if (Object.keys(asyncChanges).length > 0) {
        var synchronousChanges_1 = {};
        this.SYNCHRONOUS_CHANGE_PROPERTIES.forEach(function (synchronousChangeProperty) {
          if (asyncChanges[synchronousChangeProperty]) {
            synchronousChanges_1[synchronousChangeProperty] = asyncChanges[synchronousChangeProperty];
            delete asyncChanges[synchronousChangeProperty];
          }
        });
        if (Object.keys(synchronousChanges_1).length > 0 && !!this.api) {
          main.ComponentUtil.processOnChange(synchronousChanges_1, this.gridOptions, this.api, this.columnApi);
        }
      }
      return asyncChanges;
    };
    AgGridReactLegacy.prototype.processAsynchronousChanges = function (changes) {
      var _this = this;
      if (Object.keys(changes).length > 0) {
        window.setTimeout(function () {
          // destroyed?
          if (_this.api) {
            main.ComponentUtil.processOnChange(changes, _this.gridOptions, _this.api, _this.columnApi);
          }
        });
      }
    };
    AgGridReactLegacy.MAX_COMPONENT_CREATION_TIME_IN_MS = 1000; // a second should be more than enough to instantiate a component
    AgGridReactLegacy.defaultProps = {
      legacyComponentRendering: false,
      disableStaticMarkup: false,
      maxComponentCreationTimeMs: AgGridReactLegacy.MAX_COMPONENT_CREATION_TIME_IN_MS
    };
    return AgGridReactLegacy;
  }(react_1.Component);
  exports.AgGridReactLegacy = AgGridReactLegacy;
  AgGridReactLegacy.propTypes = {
    gridOptions: prop_types_1.default.object
  };
  addProperties(main.ComponentUtil.getEventCallbacks(), prop_types_1.default.func);
  addProperties(main.ComponentUtil.BOOLEAN_PROPERTIES, prop_types_1.default.bool);
  addProperties(main.ComponentUtil.STRING_PROPERTIES, prop_types_1.default.string);
  addProperties(main.ComponentUtil.OBJECT_PROPERTIES, prop_types_1.default.object);
  addProperties(main.ComponentUtil.ARRAY_PROPERTIES, prop_types_1.default.array);
  addProperties(main.ComponentUtil.NUMBER_PROPERTIES, prop_types_1.default.number);
  addProperties(main.ComponentUtil.FUNCTION_PROPERTIES, prop_types_1.default.func);
  function addProperties(listOfProps, propType) {
    listOfProps.forEach(function (propKey) {
      AgGridReactLegacy[propKey] = propType;
    });
  }
  var ReactFrameworkComponentWrapper = /** @class */function (_super) {
    __extends(ReactFrameworkComponentWrapper, _super);
    function ReactFrameworkComponentWrapper(agGridReact, portalManager) {
      var _this = _super.call(this) || this;
      _this.agGridReact = agGridReact;
      _this.portalManager = portalManager;
      return _this;
    }
    ReactFrameworkComponentWrapper.prototype.createWrapper = function (UserReactComponent, componentType) {
      if (this.agGridReact.isLegacyComponentRendering()) {
        return new legacyReactComponent.LegacyReactComponent(UserReactComponent, this.agGridReact, this.portalManager, componentType);
      } else {
        return new newReactComponent.NewReactComponent(UserReactComponent, this.portalManager, componentType);
      }
    };
    return ReactFrameworkComponentWrapper;
  }(main.BaseComponentWrapper);
});
unwrapExports(agGridReactLegacy);
var agGridReactLegacy_1 = agGridReactLegacy.AgGridReactLegacy;
var beansContext = createCommonjsModule(function (module, exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importDefault(React__default);
  exports.BeansContext = react_1.default.createContext({});
});
unwrapExports(beansContext);
var beansContext_1 = beansContext.BeansContext;
var utils$2 = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.classesList = function () {
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      list[_i] = arguments[_i];
    }
    var filtered = list.filter(function (s) {
      return s != null && s !== '';
    });
    return filtered.join(' ');
  };
  var CssClasses = /** @class */function () {
    function CssClasses() {
      this.classesMap = {};
    }
    CssClasses.prototype.setClass = function (className, on) {
      // important to not make a copy if nothing has changed, so react
      // won't trigger a render cycle on new object instance
      var nothingHasChanged = !!this.classesMap[className] == on;
      if (nothingHasChanged) {
        return this;
      }
      var res = new CssClasses();
      res.classesMap = __assign({}, this.classesMap);
      res.classesMap[className] = on;
      return res;
    };
    CssClasses.prototype.toString = function () {
      var _this = this;
      var res = Object.keys(this.classesMap).filter(function (key) {
        return _this.classesMap[key];
      }).join(' ');
      return res;
    };
    return CssClasses;
  }();
  exports.CssClasses = CssClasses;
  exports.isComponentStateless = function (Component) {
    var hasSymbol = function hasSymbol() {
      return typeof Symbol === 'function' && Symbol.for;
    };
    var getMemoType = function getMemoType() {
      return hasSymbol() ? Symbol.for('react.memo') : 0xead3;
    };
    return typeof Component === 'function' && !(Component.prototype && Component.prototype.isReactComponent) || typeof Component === 'object' && Component.$$typeof === getMemoType();
  };
});
unwrapExports(utils$2);
var utils_1$1 = utils$2.classesList;
var utils_2$1 = utils$2.CssClasses;
var utils_3 = utils$2.isComponentStateless;
var jsComp = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showJsComp = function (compDetails, context, eParent, ref) {
    var doNothing = !compDetails || compDetails.componentFromFramework;
    if (doNothing) {
      return;
    }
    var comp = exports.createJsComp(compDetails);
    if (!comp) {
      return;
    }
    var compGui = comp.getGui();
    eParent.appendChild(compGui);
    setRef(ref, comp);
    return function () {
      var compGui = comp.getGui();
      if (compGui && compGui.parentElement) {
        compGui.parentElement.removeChild(compGui);
      }
      context.destroyBean(comp);
      if (ref) {
        setRef(ref, undefined);
      }
    };
  };
  var setRef = function setRef(ref, value) {
    if (!ref) {
      return;
    }
    if (ref instanceof Function) {
      var refCallback = ref;
      refCallback(value);
    } else {
      var refObj = ref;
      refObj.current = value;
    }
  };
  exports.createJsComp = function (compDetails) {
    var promise = compDetails.newAgStackInstance();
    if (!promise) {
      return;
    }
    return promise.resolveNow(null, function (x) {
      return x;
    }); // js comps are never async
  };
});

unwrapExports(jsComp);
var jsComp_1 = jsComp.showJsComp;
var jsComp_2 = jsComp.createJsComp;
var headerCellComp = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var HeaderCellComp = function HeaderCellComp(props) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var _a = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _a[0],
      setCssClasses = _a[1];
    var _b = react_1.useState(),
      width = _b[0],
      _setWidth = _b[1];
    var _c = react_1.useState(),
      title = _c[0],
      _setTitle = _c[1];
    var _d = react_1.useState(),
      colId = _d[0],
      _setColId = _d[1];
    var _e = react_1.useState(),
      ariaSort = _e[0],
      _setAriaSort2 = _e[1];
    var _f = react_1.useState(),
      ariaDescribedBy = _f[0],
      _setAriaDescribedBy2 = _f[1];
    var _g = react_1.useState(),
      userCompDetails = _g[0],
      _setUserCompDetails = _g[1];
    var eGui = react_1.useRef(null);
    var eResize = react_1.useRef(null);
    var userCompRef = react_1.useRef();
    var ctrl = props.ctrl;
    react_1.useEffect(function () {
      var compProxy = {
        setWidth: function setWidth(width) {
          return _setWidth(width);
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setAriaSort: function setAriaSort(sort) {
          return _setAriaSort2(sort);
        },
        setColId: function setColId(id) {
          return _setColId(id);
        },
        setTitle: function setTitle(title) {
          return _setTitle(title);
        },
        setAriaDescribedBy: function setAriaDescribedBy(value) {
          return _setAriaDescribedBy2(value);
        },
        setUserCompDetails: function setUserCompDetails(compDetails) {
          return _setUserCompDetails(compDetails);
        },
        getUserCompInstance: function getUserCompInstance() {
          return userCompRef.current || undefined;
        }
      };
      ctrl.setComp(compProxy, eGui.current, eResize.current);
      var selectAllGui = ctrl.getSelectAllGui();
      eResize.current.insertAdjacentElement('afterend', selectAllGui);
    }, []);
    // js comps
    react_1.useEffect(function () {
      return jsComp.showJsComp(userCompDetails, context, eGui.current, userCompRef);
    }, [userCompDetails]);
    // add drag handling, must be done after component is added to the dom
    react_1.useEffect(function () {
      var userCompDomElement = undefined;
      eGui.current.childNodes.forEach(function (node) {
        if (node != null && node !== eResize.current) {
          userCompDomElement = node;
        }
      });
      ctrl.setDragSource(userCompDomElement);
    }, [userCompDetails]);
    var style = react_1.useMemo(function () {
      return {
        width: width
      };
    }, [width]);
    var className = react_1.useMemo(function () {
      return 'ag-header-cell ' + cssClasses.toString();
    }, [cssClasses]);
    var userCompStateless = react_1.useMemo(function () {
      var res = userCompDetails && userCompDetails.componentFromFramework && utils$2.isComponentStateless(userCompDetails.componentClass);
      return !!res;
    }, [userCompDetails]);
    var reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    var UserCompClass = userCompDetails && userCompDetails.componentClass;
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      style: style,
      title: title,
      "col-id": colId,
      "aria-sort": ariaSort,
      role: "columnheader",
      unselectable: "on",
      tabIndex: -1,
      "aria-describedby": ariaDescribedBy
    }, react_1.default.createElement("div", {
      ref: eResize,
      className: "ag-header-cell-resize",
      role: "presentation"
    }), reactUserComp && userCompStateless && react_1.default.createElement(UserCompClass, __assign({}, userCompDetails.params)), reactUserComp && !userCompStateless && react_1.default.createElement(UserCompClass, __assign({}, userCompDetails.params, {
      ref: userCompRef
    })));
  };
  exports.default = react_1.memo(HeaderCellComp);
});
unwrapExports(headerCellComp);
var headerGroupCellComp = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var HeaderGroupCellComp = function HeaderGroupCellComp(props) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var _a = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _a[0],
      setCssClasses = _a[1];
    var _b = react_1.useState(new utils$2.CssClasses()),
      cssResizableClasses = _b[0],
      setResizableCssClasses = _b[1];
    var _c = react_1.useState(),
      width = _c[0],
      _setWidth2 = _c[1];
    var _d = react_1.useState(),
      title = _d[0],
      _setTitle2 = _d[1];
    var _e = react_1.useState(),
      colId = _e[0],
      _setColId2 = _e[1];
    var _f = react_1.useState(),
      ariaExpanded = _f[0],
      _setAriaExpanded2 = _f[1];
    var _g = react_1.useState(),
      userCompDetails = _g[0],
      _setUserCompDetails2 = _g[1];
    var eGui = react_1.useRef(null);
    var eResize = react_1.useRef(null);
    var ctrl = props.ctrl;
    react_1.useEffect(function () {
      var compProxy = {
        setWidth: function setWidth(width) {
          return _setWidth2(width);
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setColId: function setColId(id) {
          return _setColId2(id);
        },
        setTitle: function setTitle(title) {
          return _setTitle2(title);
        },
        setUserCompDetails: function setUserCompDetails(compDetails) {
          return _setUserCompDetails2(compDetails);
        },
        addOrRemoveResizableCssClass: function addOrRemoveResizableCssClass(name, on) {
          return setResizableCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setAriaExpanded: function setAriaExpanded(expanded) {
          return _setAriaExpanded2(expanded);
        }
      };
      ctrl.setComp(compProxy, eGui.current, eResize.current);
    }, []);
    // js comps
    react_1.useEffect(function () {
      return jsComp.showJsComp(userCompDetails, context, eGui.current);
    }, [userCompDetails]);
    // add drag handling, must be done after component is added to the dom
    react_1.useEffect(function () {
      var userCompDomElement = undefined;
      eGui.current.childNodes.forEach(function (node) {
        if (node != null && node !== eResize.current) {
          userCompDomElement = node;
        }
      });
      userCompDomElement && ctrl.setDragSource(userCompDomElement);
    }, [userCompDetails]);
    var style = react_1.useMemo(function () {
      return {
        width: width
      };
    }, [width]);
    var className = react_1.useMemo(function () {
      return 'ag-header-group-cell ' + cssClasses.toString();
    }, [cssClasses]);
    var resizableClassName = react_1.useMemo(function () {
      return 'ag-header-cell-resize ' + cssResizableClasses.toString();
    }, [cssResizableClasses]);
    var reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    var UserCompClass = userCompDetails && userCompDetails.componentClass;
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      style: style,
      title: title,
      "col-id": colId,
      role: "columnheader",
      tabIndex: -1,
      "aria-expanded": ariaExpanded
    }, reactUserComp && react_1.default.createElement(UserCompClass, __assign({}, userCompDetails.params)), react_1.default.createElement("div", {
      ref: eResize,
      className: resizableClassName
    }));
  };
  exports.default = react_1.memo(HeaderGroupCellComp);
});
unwrapExports(headerGroupCellComp);
var headerFilterCellComp = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var HeaderFilterCellComp = function HeaderFilterCellComp(props) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var _a = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _a[0],
      setCssClasses = _a[1];
    var _b = react_1.useState(new utils$2.CssClasses()),
      cssBodyClasses = _b[0],
      setBodyCssClasses = _b[1];
    var _c = react_1.useState(new utils$2.CssClasses()),
      cssButtonWrapperClasses = _c[0],
      setButtonWrapperCssClasses = _c[1];
    var _d = react_1.useState(),
      width = _d[0],
      _setWidth3 = _d[1];
    var _e = react_1.useState(),
      userCompDetails = _e[0],
      setUserCompDetails = _e[1];
    var eGui = react_1.useRef(null);
    var eFloatingFilterBody = react_1.useRef(null);
    var eButtonWrapper = react_1.useRef(null);
    var eButtonShowMainFilter = react_1.useRef(null);
    var userCompRef = react_1.useRef();
    var ctrl = props.ctrl;
    react_1.useEffect(function () {
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        addOrRemoveBodyCssClass: function addOrRemoveBodyCssClass(name, on) {
          return setBodyCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        addOrRemoveButtonWrapperCssClass: function addOrRemoveButtonWrapperCssClass(name, on) {
          return setButtonWrapperCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setWidth: function setWidth(width) {
          return _setWidth3(width);
        },
        setCompDetails: function setCompDetails(compDetails) {
          return setUserCompDetails(compDetails);
        },
        getFloatingFilterComp: function getFloatingFilterComp() {
          return userCompRef.current ? main.AgPromise.resolve(userCompRef.current) : null;
        },
        setMenuIcon: function setMenuIcon(eIcon) {
          return eButtonShowMainFilter.current.appendChild(eIcon);
        }
      };
      ctrl.setComp(compProxy, eGui.current, eButtonShowMainFilter.current, eFloatingFilterBody.current);
    }, []);
    // js comps
    react_1.useEffect(function () {
      return jsComp.showJsComp(userCompDetails, context, eFloatingFilterBody.current, userCompRef);
    }, [userCompDetails]);
    var style = react_1.useMemo(function () {
      return {
        width: width
      };
    }, [width]);
    var className = react_1.useMemo(function () {
      return 'ag-header-cell ag-floating-filter ' + cssClasses.toString();
    }, [cssClasses]);
    var bodyClassName = react_1.useMemo(function () {
      return cssBodyClasses.toString();
    }, [cssBodyClasses]);
    var buttonWrapperClassName = react_1.useMemo(function () {
      return 'ag-floating-filter-button ' + cssButtonWrapperClasses.toString();
    }, [cssBodyClasses]);
    var userCompStateless = react_1.useMemo(function () {
      var res = userCompDetails && userCompDetails.componentFromFramework && utils$2.isComponentStateless(userCompDetails.componentClass);
      return !!res;
    }, [userCompDetails]);
    var reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    var UserCompClass = userCompDetails && userCompDetails.componentClass;
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      style: style,
      role: "gridcell",
      tabIndex: -1
    }, react_1.default.createElement("div", {
      ref: eFloatingFilterBody,
      className: bodyClassName,
      role: "presentation"
    }, reactUserComp && userCompStateless && react_1.default.createElement(UserCompClass, __assign({}, userCompDetails.params)), reactUserComp && !userCompStateless && react_1.default.createElement(UserCompClass, __assign({}, userCompDetails.params, {
      ref: userCompRef
    }))), react_1.default.createElement("div", {
      ref: eButtonWrapper,
      className: buttonWrapperClassName,
      role: "presentation"
    }, react_1.default.createElement("button", {
      ref: eButtonShowMainFilter,
      type: "button",
      "aria-label": "Open Filter Menu",
      className: "ag-floating-filter-button-button",
      tabIndex: -1
    })));
  };
  exports.default = react_1.memo(HeaderFilterCellComp);
});
unwrapExports(headerFilterCellComp);
var headerRowComp = createCommonjsModule(function (module, exports) {
  var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var headerCellComp_1 = __importDefault(headerCellComp);
  var headerGroupCellComp_1 = __importDefault(headerGroupCellComp);
  var headerFilterCellComp_1 = __importDefault(headerFilterCellComp);
  var HeaderRowComp = function HeaderRowComp(props) {
    var gridOptionsWrapper = react_1.useContext(beansContext.BeansContext).gridOptionsWrapper;
    var _a = react_1.useState(),
      transform = _a[0],
      _setTransform = _a[1];
    var _b = react_1.useState(),
      height = _b[0],
      _setHeight = _b[1];
    var _c = react_1.useState(),
      top = _c[0],
      _setTop = _c[1];
    var _d = react_1.useState(),
      width = _d[0],
      _setWidth4 = _d[1];
    var _e = react_1.useState(),
      ariaRowIndex = _e[0],
      _setAriaRowIndex2 = _e[1];
    var _f = react_1.useState([]),
      cellCtrls = _f[0],
      setCellCtrls = _f[1];
    var eGui = react_1.useRef(null);
    var ctrl = props.ctrl;
    var typeColumn = ctrl.getType() === main.HeaderRowType.COLUMN;
    var typeGroup = ctrl.getType() === main.HeaderRowType.COLUMN_GROUP;
    var typeFilter = ctrl.getType() === main.HeaderRowType.FLOATING_FILTER;
    var setCellCtrlsMaintainOrder = react_1.useCallback(function (prev, next) {
      // if we are ensuring dom order, we set the ctrls into the dom in the same order they appear on screen
      if (gridOptionsWrapper.isEnsureDomOrder()) {
        return next;
      }
      // if not maintaining order, we want to keep the dom elements we have and add new ones to the end,
      // otherwise we will loose transition effects as elements are placed in different dom locations
      var prevMap = main._.mapById(prev, function (c) {
        return c.getInstanceId();
      });
      var nextMap = main._.mapById(next, function (c) {
        return c.getInstanceId();
      });
      var oldCtrlsWeAreKeeping = prev.filter(function (c) {
        return nextMap.has(c.getInstanceId());
      });
      var newCtrls = next.filter(function (c) {
        return !prevMap.has(c.getInstanceId());
      });
      return __spreadArrays(oldCtrlsWeAreKeeping, newCtrls);
    }, []);
    react_1.useEffect(function () {
      var compProxy = {
        setTransform: function setTransform(transform) {
          return _setTransform(transform);
        },
        setHeight: function setHeight(height) {
          return _setHeight(height);
        },
        setTop: function setTop(top) {
          return _setTop(top);
        },
        setHeaderCtrls: function setHeaderCtrls(ctrls) {
          return setCellCtrls(function (prev) {
            return setCellCtrlsMaintainOrder(prev, ctrls);
          });
        },
        setWidth: function setWidth(width) {
          return _setWidth4(width);
        },
        setAriaRowIndex: function setAriaRowIndex(rowIndex) {
          return _setAriaRowIndex2(rowIndex);
        }
      };
      ctrl.setComp(compProxy);
    }, []);
    var style = react_1.useMemo(function () {
      return {
        transform: transform,
        height: height,
        top: top,
        width: width
      };
    }, [transform, height, top, width]);
    var className = react_1.useMemo(function () {
      var res = ["ag-header-row"];
      typeColumn && res.push("ag-header-row-column");
      typeGroup && res.push("ag-header-row-column-group");
      typeFilter && res.push("ag-header-row-column-filter");
      return res.join(' ');
    }, []);
    var createCellJsx = react_1.useCallback(function (cellCtrl) {
      switch (ctrl.getType()) {
        case main.HeaderRowType.COLUMN_GROUP:
          return react_1.default.createElement(headerGroupCellComp_1.default, {
            ctrl: cellCtrl,
            key: cellCtrl.getInstanceId()
          });
        case main.HeaderRowType.FLOATING_FILTER:
          return react_1.default.createElement(headerFilterCellComp_1.default, {
            ctrl: cellCtrl,
            key: cellCtrl.getInstanceId()
          });
        default:
          return react_1.default.createElement(headerCellComp_1.default, {
            ctrl: cellCtrl,
            key: cellCtrl.getInstanceId()
          });
      }
    }, []);
    // below, we are not doing floating filters, not yet
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      role: "row",
      style: style,
      "aria-rowindex": ariaRowIndex
    }, cellCtrls.map(createCellJsx));
  };
  exports.default = react_1.memo(HeaderRowComp);
});
unwrapExports(headerRowComp);
var headerRowContainerComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var headerRowComp_1 = __importDefault(headerRowComp);
  var HeaderRowContainerComp = function HeaderRowContainerComp(props) {
    var _a = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _a[0],
      setCssClasses = _a[1];
    var _b = react_1.useState(),
      centerContainerWidth = _b[0],
      setCenterContainerWidth = _b[1];
    var _c = react_1.useState(),
      centerContainerTransform = _c[0],
      setCenterContainerTransform = _c[1];
    var _d = react_1.useState(),
      pinnedContainerWidth = _d[0],
      _setPinnedContainerWidth = _d[1];
    var _e = react_1.useState([]),
      headerRowCtrls = _e[0],
      setHeaderRowCtrls = _e[1];
    var context = react_1.useContext(beansContext.BeansContext).context;
    var eGui = react_1.useRef(null);
    var pinnedLeft = props.pinned === main.Constants.PINNED_LEFT;
    var pinnedRight = props.pinned === main.Constants.PINNED_RIGHT;
    var centre = !pinnedLeft && !pinnedRight;
    react_1.useEffect(function () {
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setCtrls: function setCtrls(ctrls) {
          return setHeaderRowCtrls(ctrls);
        },
        // centre only
        setCenterWidth: function setCenterWidth(width) {
          return setCenterContainerWidth(width);
        },
        setContainerTransform: function setContainerTransform(transform) {
          return setCenterContainerTransform(transform);
        },
        // pinned only
        setPinnedContainerWidth: function setPinnedContainerWidth(width) {
          return _setPinnedContainerWidth(width);
        }
      };
      var ctrl = context.createBean(new main.HeaderRowContainerCtrl(props.pinned));
      ctrl.setComp(compProxy, eGui.current);
      return function () {
        context.destroyBean(ctrl);
      };
    }, []);
    var className = react_1.useMemo(function () {
      return cssClasses.toString();
    }, [cssClasses]);
    var insertRowsJsx = function insertRowsJsx() {
      return headerRowCtrls.map(function (ctrl) {
        return react_1.default.createElement(headerRowComp_1.default, {
          ctrl: ctrl,
          key: ctrl.getInstanceId()
        });
      });
    };
    var eCenterContainerStyle = react_1.useMemo(function () {
      return {
        width: centerContainerWidth,
        transform: centerContainerTransform
      };
    }, [centerContainerWidth, centerContainerTransform]);
    var ePinnedStyle = react_1.useMemo(function () {
      return {
        width: pinnedContainerWidth,
        minWidth: pinnedContainerWidth,
        maxWidth: pinnedContainerWidth
      };
    }, [pinnedContainerWidth]);
    return react_1.default.createElement(react_1.default.Fragment, null, pinnedLeft && react_1.default.createElement("div", {
      ref: eGui,
      className: "ag-pinned-left-header " + className,
      role: "presentation",
      style: ePinnedStyle
    }, insertRowsJsx()), pinnedRight && react_1.default.createElement("div", {
      ref: eGui,
      className: "ag-pinned-right-header " + className,
      role: "presentation",
      style: ePinnedStyle
    }, insertRowsJsx()), centre && react_1.default.createElement("div", {
      ref: eGui,
      className: "ag-header-viewport " + className,
      role: "presentation"
    }, react_1.default.createElement("div", {
      className: "ag-header-container",
      role: "rowgroup",
      style: eCenterContainerStyle
    }, insertRowsJsx())));
  };
  exports.default = react_1.memo(HeaderRowContainerComp);
});
unwrapExports(headerRowContainerComp);
var gridHeaderComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var headerRowContainerComp_1 = __importDefault(headerRowContainerComp);
  var GridHeaderComp = function GridHeaderComp() {
    var _a = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _a[0],
      setCssClasses = _a[1];
    var _b = react_1.useState(),
      height = _b[0],
      setHeight = _b[1];
    var context = react_1.useContext(beansContext.BeansContext).context;
    var eGui = react_1.useRef(null);
    react_1.useEffect(function () {
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setHeightAndMinHeight: function setHeightAndMinHeight(height) {
          return setHeight(height);
        }
      };
      var ctrl = context.createBean(new main.GridHeaderCtrl());
      ctrl.setComp(compProxy, eGui.current, eGui.current);
      return function () {
        context.destroyBean(ctrl);
      };
    }, []);
    var className = react_1.useMemo(function () {
      var res = cssClasses.toString();
      return 'ag-header ' + res;
    }, [cssClasses]);
    var style = react_1.useMemo(function () {
      return {
        height: height,
        minHeight: height
      };
    }, [height]);
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      style: style,
      role: "presentation",
      unselectable: "on"
    }, react_1.default.createElement(headerRowContainerComp_1.default, {
      pinned: main.Constants.PINNED_LEFT
    }), react_1.default.createElement(headerRowContainerComp_1.default, {
      pinned: null
    }), react_1.default.createElement(headerRowContainerComp_1.default, {
      pinned: main.Constants.PINNED_RIGHT
    }));
  };
  exports.default = react_1.memo(GridHeaderComp);
});
unwrapExports(gridHeaderComp);
var reactComment = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var useReactCommentEffect = function useReactCommentEffect(comment, eForCommentRef) {
    React__default.useEffect(function () {
      var eForComment = eForCommentRef.current;
      var eParent = eForComment.parentElement;
      if (!eParent) {
        return;
      }
      var eComment = document.createComment(comment);
      eParent.insertBefore(eComment, eForComment);
      return function () {
        eParent.removeChild(eComment);
      };
    }, []);
  };
  exports.default = useReactCommentEffect;
});
unwrapExports(reactComment);
var popupEditorComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var PopupEditorComp = function PopupEditorComp(props) {
    var _a = react_1.useState(),
      popupEditorWrapper = _a[0],
      setPopupEditorWrapper = _a[1];
    var _b = react_1.useContext(beansContext.BeansContext),
      context = _b.context,
      popupService = _b.popupService,
      gridOptionsWrapper = _b.gridOptionsWrapper;
    react_1.useEffect(function () {
      var editDetails = props.editDetails,
        cellCtrl = props.cellCtrl,
        eParentCell = props.eParentCell;
      var compDetails = editDetails.compDetails;
      var useModelPopup = gridOptionsWrapper.isStopEditingWhenCellsLoseFocus();
      var wrapper = new main.PopupEditorWrapper(compDetails.params);
      var ePopupGui = wrapper.getGui();
      if (props.jsChildComp) {
        var eChildGui = props.jsChildComp.getGui();
        if (eChildGui) {
          ePopupGui.appendChild(eChildGui);
        }
      }
      var positionParams = {
        column: cellCtrl.getColumn(),
        rowNode: cellCtrl.getRowNode(),
        type: 'popupCellEditor',
        eventSource: eParentCell,
        ePopup: ePopupGui,
        keepWithinBounds: true
      };
      var positionCallback = editDetails.popupPosition === 'under' ? popupService.positionPopupUnderComponent.bind(popupService, positionParams) : popupService.positionPopupOverComponent.bind(popupService, positionParams);
      var translate = gridOptionsWrapper.getLocaleTextFunc();
      var addPopupRes = popupService.addPopup({
        modal: useModelPopup,
        eChild: ePopupGui,
        closeOnEsc: true,
        closedCallback: function closedCallback() {
          cellCtrl.onPopupEditorClosed();
        },
        anchorToElement: eParentCell,
        positionCallback: positionCallback,
        ariaLabel: translate('ariaLabelCellEditor', 'Cell Editor')
      });
      var hideEditorPopup = addPopupRes ? addPopupRes.hideFunc : undefined;
      setPopupEditorWrapper(wrapper);
      props.jsChildComp && props.jsChildComp.afterGuiAttached && props.jsChildComp.afterGuiAttached();
      return function () {
        if (hideEditorPopup != null) {
          hideEditorPopup();
        }
        context.destroyBean(wrapper);
      };
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, popupEditorWrapper && props.wrappedContent && ReactDOM.createPortal(props.wrappedContent, popupEditorWrapper.getGui()));
  };
  exports.default = react_1.memo(PopupEditorComp);
});
unwrapExports(popupEditorComp);
var showJsRenderer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var useJsCellRenderer = function useJsCellRenderer(showDetails, showTools, toolsValueSpan, jsCellRendererRef, eGui) {
    var _a = React__default.useContext(beansContext.BeansContext),
      context = _a.context,
      userComponentFactory = _a.userComponentFactory;
    var destroyCellRenderer = React__default.useCallback(function () {
      var comp = jsCellRendererRef.current;
      if (!comp) {
        return;
      }
      var compGui = comp.getGui();
      if (compGui && compGui.parentElement) {
        compGui.parentElement.removeChild(compGui);
      }
      context.destroyBean(comp);
      jsCellRendererRef.current = undefined;
    }, []);
    // create or refresh JS cell renderer
    React__default.useEffect(function () {
      var showValue = showDetails != null;
      var jsCompDetails = showDetails && showDetails.compDetails && !showDetails.compDetails.componentFromFramework;
      var waitingForToolsSetup = showTools && toolsValueSpan == null;
      var showComp = showValue && jsCompDetails && !waitingForToolsSetup;
      // if not showing comp, destroy any existing one and return
      if (!showComp) {
        destroyCellRenderer();
        return;
      }
      var compDetails = showDetails.compDetails;
      if (jsCellRendererRef.current) {
        // attempt refresh if refresh method exists
        var comp_1 = jsCellRendererRef.current;
        var attemptRefresh = comp_1.refresh != null && showDetails.force == false;
        var refreshResult = attemptRefresh ? comp_1.refresh(compDetails.params) : false;
        var refreshWorked = refreshResult === true || refreshResult === undefined;
        // if refresh worked, nothing else to do
        if (refreshWorked) {
          return;
        }
        // if refresh didn't work, we destroy it and continue, so new cell renderer created below
        destroyCellRenderer();
      }
      var promise = compDetails.newAgStackInstance();
      if (!promise) {
        return;
      }
      var comp = promise.resolveNow(null, function (x) {
        return x;
      }); // js comps are never async
      if (!comp) {
        return;
      }
      var compGui = comp.getGui();
      var parent = showTools ? toolsValueSpan : eGui.current;
      parent.appendChild(compGui);
      jsCellRendererRef.current = comp;
    }, [showDetails, showTools, toolsValueSpan]);
    // this effect makes sure destroyCellRenderer gets called when the
    // component is destroyed. as the other effect only updates when there
    // is a change in state
    React__default.useEffect(function () {
      return destroyCellRenderer;
    }, []);
  };
  exports.default = useJsCellRenderer;
});
unwrapExports(showJsRenderer);
var cellComp = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var popupEditorComp_1 = __importDefault(popupEditorComp);
  var showJsRenderer_1 = __importDefault(showJsRenderer);
  var CellCompState;
  (function (CellCompState) {
    CellCompState[CellCompState["ShowValue"] = 0] = "ShowValue";
    CellCompState[CellCompState["EditValue"] = 1] = "EditValue";
  })(CellCompState = exports.CellCompState || (exports.CellCompState = {}));
  var checkCellEditorDeprecations = function checkCellEditorDeprecations(popup, cellEditor, cellCtrl) {
    var col = cellCtrl.getColumn();
    // cellEditor is written to be a popup editor, however colDef.cellEditorPopup is not set
    if (!popup && cellEditor.isPopup && cellEditor.isPopup()) {
      var msg_1 = "AG Grid: Found an issue in column " + col.getColId() + ". If using ReactUI, specify an editor is a popup using colDef.cellEditorPopup=true";
      main._.doOnce(function () {
        return console.warn(msg_1);
      }, 'jsEditorComp-isPopup-' + cellCtrl.getColumn().getColId());
    }
    // cellEditor is a popup and is trying to position itself the deprecated way
    if (popup && cellEditor.getPopupPosition && cellEditor.getPopupPosition() != null) {
      var msg_2 = "AG Grid: AG Grid: Found an issue in column " + col.getColId() + ". If using ReactUI, specify an editor popup position using colDef.cellEditorPopupPosition=[value]";
      main._.doOnce(function () {
        return console.warn(msg_2);
      }, 'jsEditorComp-getPopupPosition-' + cellCtrl.getColumn().getColId());
    }
  };
  var jsxEditValue = function jsxEditValue(editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui, cellCtrl, jsEditorComp) {
    var compDetails = editDetails.compDetails;
    var CellEditorClass = compDetails.componentClass;
    var reactInlineEditor = compDetails.componentFromFramework && !editDetails.popup;
    var reactPopupEditor = compDetails.componentFromFramework && editDetails.popup;
    var jsPopupEditor = !compDetails.componentFromFramework && editDetails.popup;
    return react_1.default.createElement(react_1.default.Fragment, null, reactInlineEditor && react_1.default.createElement(CellEditorClass, __assign({}, editDetails.compDetails.params, {
      ref: setInlineCellEditorRef
    })), reactPopupEditor && react_1.default.createElement(popupEditorComp_1.default, {
      editDetails: editDetails,
      cellCtrl: cellCtrl,
      eParentCell: eGui,
      wrappedContent: react_1.default.createElement(CellEditorClass, __assign({}, editDetails.compDetails.params, {
        ref: setPopupCellEditorRef
      }))
    }), jsPopupEditor && jsEditorComp && react_1.default.createElement(popupEditorComp_1.default, {
      editDetails: editDetails,
      cellCtrl: cellCtrl,
      eParentCell: eGui,
      jsChildComp: jsEditorComp
    }));
  };
  var jsxShowValue = function jsxShowValue(showDetails, parentId, cellRendererRef, showTools, unSelectable, reactCellRendererStateless, toolsRefCallback, toolsValueRefCallback) {
    var compDetails = showDetails.compDetails,
      value = showDetails.value;
    var noCellRenderer = !compDetails;
    var reactCellRenderer = compDetails && compDetails.componentFromFramework;
    var CellRendererClass = compDetails && compDetails.componentClass;
    var bodyJsxFunc = function bodyJsxFunc() {
      return react_1.default.createElement(react_1.default.Fragment, null, noCellRenderer && react_1.default.createElement(react_1.default.Fragment, null, value), reactCellRenderer && !reactCellRendererStateless && react_1.default.createElement(CellRendererClass, __assign({}, compDetails.params, {
        ref: cellRendererRef
      })), reactCellRenderer && reactCellRendererStateless && react_1.default.createElement(CellRendererClass, __assign({}, compDetails.params)));
    };
    return react_1.default.createElement(react_1.default.Fragment, null, showTools ? react_1.default.createElement("div", {
      className: "ag-cell-wrapper",
      role: "presentation",
      ref: toolsRefCallback
    }, react_1.default.createElement("span", {
      role: "presentation",
      id: "cell-" + parentId,
      className: "ag-cell-value",
      unselectable: unSelectable,
      ref: toolsValueRefCallback
    }, bodyJsxFunc())) : bodyJsxFunc());
  };
  var CellComp = function CellComp(props) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var cellCtrl = props.cellCtrl,
      printLayout = props.printLayout,
      editingRow = props.editingRow;
    var _a = react_1.useState(),
      renderDetails = _a[0],
      _setRenderDetails = _a[1];
    var _b = react_1.useState(),
      editDetails = _b[0],
      _setEditDetails = _b[1];
    var _c = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _c[0],
      setCssClasses = _c[1];
    var _d = react_1.useState(),
      userStyles = _d[0],
      _setUserStyles = _d[1];
    var _e = react_1.useState('on'),
      unselectable = _e[0],
      _setUnselectable = _e[1];
    var _f = react_1.useState(),
      left = _f[0],
      _setLeft = _f[1];
    var _g = react_1.useState(),
      width = _g[0],
      _setWidth5 = _g[1];
    var _h = react_1.useState(),
      height = _h[0],
      _setHeight2 = _h[1];
    var _j = react_1.useState(),
      transition = _j[0],
      _setTransition = _j[1];
    var _k = react_1.useState(),
      tabIndex = _k[0],
      _setTabIndex = _k[1];
    var _l = react_1.useState(),
      ariaSelected = _l[0],
      _setAriaSelected2 = _l[1];
    var _m = react_1.useState(),
      ariaExpanded = _m[0],
      _setAriaExpanded3 = _m[1];
    var _o = react_1.useState(),
      ariaColIndex = _o[0],
      _setAriaColIndex2 = _o[1];
    var _p = react_1.useState(),
      ariaDescribedBy = _p[0],
      setAriaDescribedBy = _p[1];
    var _q = react_1.useState(),
      zIndex = _q[0],
      _setZIndex = _q[1];
    var _r = react_1.useState(),
      role = _r[0],
      _setRole = _r[1];
    var _s = react_1.useState(),
      colId = _s[0],
      _setColId3 = _s[1];
    var _t = react_1.useState(),
      title = _t[0],
      _setTitle3 = _t[1];
    var _u = react_1.useState(false),
      includeSelection = _u[0],
      _setIncludeSelection = _u[1];
    var _v = react_1.useState(false),
      includeRowDrag = _v[0],
      _setIncludeRowDrag = _v[1];
    var _w = react_1.useState(false),
      includeDndSource = _w[0],
      _setIncludeDndSource = _w[1];
    var _x = react_1.useState(false),
      forceWrapper = _x[0],
      _setForceWrapper = _x[1];
    var _y = react_1.useState(),
      jsEditorComp = _y[0],
      setJsEditorComp = _y[1];
    var eGui = react_1.useRef(null);
    var cellRendererRef = react_1.useRef(null);
    var jsCellRendererRef = react_1.useRef();
    var cellEditorRef = react_1.useRef();
    var _z = react_1.useState(),
      toolsSpan = _z[0],
      setToolsSpan = _z[1];
    var _0 = react_1.useState(),
      toolsValueSpan = _0[0],
      setToolsValueSpan = _0[1];
    var showTools = renderDetails != null && (includeSelection || includeDndSource || includeRowDrag || forceWrapper);
    var setCellEditorRef = react_1.useCallback(function (popup, cellEditor) {
      cellEditorRef.current = cellEditor;
      if (cellEditor) {
        checkCellEditorDeprecations(popup, cellEditor, cellCtrl);
        var editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
        if (editingCancelledByUserComp) {
          // we cannot set state inside render, so hack is to do it in next VM turn
          setTimeout(function () {
            return cellCtrl.stopEditing();
          }, 0);
        }
      }
    }, []);
    var setPopupCellEditorRef = react_1.useCallback(function (cellRenderer) {
      return setCellEditorRef(true, cellRenderer);
    }, []);
    var setInlineCellEditorRef = react_1.useCallback(function (cellRenderer) {
      return setCellEditorRef(false, cellRenderer);
    }, []);
    showJsRenderer_1.default(renderDetails, showTools, toolsValueSpan, jsCellRendererRef, eGui);
    react_1.useEffect(function () {
      var doingJsEditor = editDetails && !editDetails.compDetails.componentFromFramework;
      if (!doingJsEditor) {
        return;
      }
      var compDetails = editDetails.compDetails;
      var isPopup = editDetails.popup === true;
      var cellEditor = jsComp.createJsComp(compDetails);
      if (!cellEditor) {
        return;
      }
      var compGui = cellEditor.getGui();
      setCellEditorRef(isPopup, cellEditor);
      if (!isPopup) {
        eGui.current.appendChild(compGui);
        cellEditor.afterGuiAttached && cellEditor.afterGuiAttached();
      }
      setJsEditorComp(cellEditor);
      return function () {
        context.destroyBean(cellEditor);
        setCellEditorRef(isPopup, undefined);
        setJsEditorComp(undefined);
        if (compGui && compGui.parentElement) {
          compGui.parentElement.removeChild(compGui);
        }
      };
    }, [editDetails]);
    // tool widgets effect
    react_1.useEffect(function () {
      if (!cellCtrl || !context) {
        return;
      }
      setAriaDescribedBy(!!toolsSpan ? "cell-" + cellCtrl.getInstanceId() : undefined);
      if (!toolsSpan) {
        return;
      }
      var beansToDestroy = [];
      var addComp = function addComp(comp) {
        if (comp) {
          toolsSpan.insertAdjacentElement('afterbegin', comp.getGui());
          beansToDestroy.push(comp);
        }
        return comp;
      };
      if (includeSelection) {
        addComp(cellCtrl.createSelectionCheckbox());
      }
      if (includeDndSource) {
        addComp(cellCtrl.createDndSource());
      }
      if (includeRowDrag) {
        addComp(cellCtrl.createRowDragComp());
      }
      return function () {
        context.destroyBeans(beansToDestroy);
      };
    }, [includeDndSource, includeRowDrag, includeSelection, toolsSpan]);
    // attaching the ref to state makes sure we render again when state is set. this is
    // how we make sure the tools are added, as it's not possible to have an effect depend
    // on a reference, as reference is not state, it doesn't create another render cycle.
    var toolsRefCallback = react_1.useCallback(function (ref) {
      return setToolsSpan(ref);
    }, []);
    var toolsValueRefCallback = react_1.useCallback(function (ref) {
      return setToolsValueSpan(ref);
    }, []);
    react_1.useEffect(function () {
      if (!cellCtrl) {
        return;
      }
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setUserStyles: function setUserStyles(styles) {
          return _setUserStyles(styles);
        },
        setAriaSelected: function setAriaSelected(value) {
          return _setAriaSelected2(value);
        },
        setAriaExpanded: function setAriaExpanded(value) {
          return _setAriaExpanded3(value);
        },
        getFocusableElement: function getFocusableElement() {
          return eGui.current;
        },
        setLeft: function setLeft(left) {
          return _setLeft(left);
        },
        setWidth: function setWidth(width) {
          return _setWidth5(width);
        },
        setAriaColIndex: function setAriaColIndex(index) {
          return _setAriaColIndex2(index);
        },
        setHeight: function setHeight(height) {
          return _setHeight2(height);
        },
        setZIndex: function setZIndex(zIndex) {
          return _setZIndex(zIndex);
        },
        setTabIndex: function setTabIndex(tabIndex) {
          return _setTabIndex(tabIndex);
        },
        setRole: function setRole(role) {
          return _setRole(role);
        },
        setColId: function setColId(colId) {
          return _setColId3(colId);
        },
        setTitle: function setTitle(title) {
          return _setTitle3(title);
        },
        setUnselectable: function setUnselectable(value) {
          return _setUnselectable(value || undefined);
        },
        setTransition: function setTransition(transition) {
          return _setTransition(transition);
        },
        setIncludeSelection: function setIncludeSelection(include) {
          return _setIncludeSelection(include);
        },
        setIncludeRowDrag: function setIncludeRowDrag(include) {
          return _setIncludeRowDrag(include);
        },
        setIncludeDndSource: function setIncludeDndSource(include) {
          return _setIncludeDndSource(include);
        },
        setForceWrapper: function setForceWrapper(force) {
          return _setForceWrapper(force);
        },
        getCellEditor: function getCellEditor() {
          return cellEditorRef.current || null;
        },
        getCellRenderer: function getCellRenderer() {
          return cellRendererRef.current ? cellRendererRef.current : jsCellRendererRef.current;
        },
        getParentOfValue: function getParentOfValue() {
          return toolsValueSpan ? toolsValueSpan : eGui.current;
        },
        setRenderDetails: function setRenderDetails(compDetails, value, force) {
          _setRenderDetails({
            value: value,
            compDetails: compDetails,
            force: force
          });
        },
        setEditDetails: function setEditDetails(compDetails, popup, popupPosition) {
          if (compDetails) {
            // start editing
            _setEditDetails({
              compDetails: compDetails,
              popup: popup,
              popupPosition: popupPosition
            });
            if (!popup) {
              _setRenderDetails(undefined);
            }
          } else {
            // stop editing
            _setEditDetails(undefined);
          }
        }
      };
      cellCtrl.setComp(compProxy, null, eGui.current, printLayout, editingRow);
    }, []);
    var reactCellRendererStateless = react_1.useMemo(function () {
      var res = renderDetails && renderDetails.compDetails && renderDetails.compDetails.componentFromFramework && utils$2.isComponentStateless(renderDetails.compDetails.componentClass);
      return !!res;
    }, [renderDetails]);
    var className = react_1.useMemo(function () {
      var res = cssClasses.toString();
      if (!showTools) {
        res += ' ag-cell-value';
      }
      return res;
    }, [cssClasses, showTools]);
    var cellStyles = react_1.useMemo(function () {
      var res = {
        left: left,
        width: width,
        height: height,
        transition: transition,
        zIndex: zIndex
      };
      main._.assign(res, userStyles);
      return res;
    }, [left, width, height, transition, zIndex, userStyles]);
    var cellInstanceId = react_1.useMemo(function () {
      return cellCtrl.getInstanceId();
    }, []);
    return react_1.default.createElement("div", {
      ref: eGui,
      className: className,
      style: cellStyles,
      tabIndex: tabIndex,
      "aria-selected": ariaSelected,
      "aria-colindex": ariaColIndex,
      role: role,
      "aria-expanded": ariaExpanded,
      "col-id": colId,
      title: title,
      unselectable: unselectable,
      "aria-describedby": ariaDescribedBy
    }, renderDetails != null && jsxShowValue(renderDetails, cellInstanceId, cellRendererRef, showTools, unselectable, reactCellRendererStateless, toolsRefCallback, toolsValueRefCallback), editDetails != null && jsxEditValue(editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui.current, cellCtrl, jsEditorComp));
  };
  exports.default = react_1.memo(CellComp);
});
unwrapExports(cellComp);
var cellComp_1 = cellComp.CellCompState;
var rowComp = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var cellComp_1 = __importDefault(cellComp);
  var maintainOrderOnColumns = function maintainOrderOnColumns(prev, next, domOrder) {
    if (domOrder) {
      var res_1 = {
        list: next,
        instanceIdMap: new Map()
      };
      next.forEach(function (c) {
        return res_1.instanceIdMap.set(c.getInstanceId(), c);
      });
      return res_1;
    }
    // if dom order not important, we don't want to change the order
    // of the elements in the dom, as this would break transition styles
    var oldCellCtrls = [];
    var newCellCtrls = [];
    var newInstanceIdMap = new Map();
    var tempMap = new Map();
    next.forEach(function (c) {
      return tempMap.set(c.getInstanceId(), c);
    });
    prev.list.forEach(function (c) {
      var instanceId = c.getInstanceId();
      if (tempMap.has(instanceId)) {
        oldCellCtrls.push(c);
        newInstanceIdMap.set(instanceId, c);
      }
    });
    next.forEach(function (c) {
      var instanceId = c.getInstanceId();
      if (!prev.instanceIdMap.has(instanceId)) {
        newCellCtrls.push(c);
        newInstanceIdMap.set(instanceId, c);
      }
    });
    var res = {
      list: __spreadArrays(oldCellCtrls, newCellCtrls),
      instanceIdMap: newInstanceIdMap
    };
    return res;
  };
  var RowComp = function RowComp(params) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var rowCtrl = params.rowCtrl,
      pinned = params.pinned;
    var _a = react_1.useState(),
      height = _a[0],
      _setHeight3 = _a[1];
    var _b = react_1.useState(rowCtrl.getInitialRowTop()),
      top = _b[0],
      _setTop2 = _b[1];
    var _c = react_1.useState(rowCtrl.getInitialTransform()),
      transform = _c[0],
      _setTransform2 = _c[1];
    var _d = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _d[0],
      setCssClasses = _d[1];
    var _e = react_1.useState(),
      rowIndex = _e[0],
      _setRowIndex = _e[1];
    var _f = react_1.useState(),
      rowId = _f[0],
      _setRowId = _f[1];
    var _g = react_1.useState(),
      role = _g[0],
      _setRole2 = _g[1];
    var _h = react_1.useState(),
      rowBusinessKey = _h[0],
      _setRowBusinessKey = _h[1];
    var _j = react_1.useState(),
      tabIndex = _j[0],
      _setTabIndex2 = _j[1];
    var _k = react_1.useState(),
      ariaRowIndex = _k[0],
      _setAriaRowIndex3 = _k[1];
    var _l = react_1.useState(),
      ariaExpanded = _l[0],
      _setAriaExpanded4 = _l[1];
    var _m = react_1.useState(),
      ariaLabel = _m[0],
      _setAriaLabel2 = _m[1];
    var _o = react_1.useState(),
      ariaSelected = _o[0],
      _setAriaSelected3 = _o[1];
    var _p = react_1.useState(),
      userStyles = _p[0],
      _setUserStyles2 = _p[1];
    var _q = react_1.useState({
        list: [],
        instanceIdMap: new Map()
      }),
      cellCtrls = _q[0],
      _setCellCtrls = _q[1];
    var _r = react_1.useState(),
      fullWidthCompDetails = _r[0],
      setFullWidthCompDetails = _r[1];
    var _s = react_1.useState(false),
      domOrder = _s[0],
      _setDomOrder = _s[1];
    var _t = react_1.useState(),
      display = _t[0],
      _setDisplay = _t[1];
    var eGui = react_1.useRef(null);
    var fullWidthCompRef = react_1.useRef();
    react_1.useEffect(function () {
      var compProxy = {
        setDisplay: function setDisplay(value) {
          return _setDisplay(value);
        },
        setDomOrder: function setDomOrder(domOrder) {
          return _setDomOrder(domOrder);
        },
        setHeight: function setHeight(value) {
          return _setHeight3(value);
        },
        setTop: function setTop(value) {
          return _setTop2(value);
        },
        setTransform: function setTransform(value) {
          return _setTransform2(value);
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setRowIndex: function setRowIndex(value) {
          return _setRowIndex(value);
        },
        setAriaRowIndex: function setAriaRowIndex(value) {
          return _setAriaRowIndex3(value);
        },
        setAriaExpanded: function setAriaExpanded(value) {
          return _setAriaExpanded4(value);
        },
        setAriaLabel: function setAriaLabel(value) {
          return _setAriaLabel2(value);
        },
        setRowId: function setRowId(value) {
          return _setRowId(value);
        },
        setRowBusinessKey: function setRowBusinessKey(value) {
          return _setRowBusinessKey(value);
        },
        setTabIndex: function setTabIndex(value) {
          return _setTabIndex2(value);
        },
        setUserStyles: function setUserStyles(styles) {
          return _setUserStyles2(styles);
        },
        setAriaSelected: function setAriaSelected(value) {
          return _setAriaSelected3(value);
        },
        setRole: function setRole(value) {
          return _setRole2(value);
        },
        // if we don't maintain the order, then cols will be ripped out and into the dom
        // when cols reordered, which would stop the CSS transitions from working
        setCellCtrls: function setCellCtrls(next) {
          return _setCellCtrls(function (prev) {
            return maintainOrderOnColumns(prev, next, domOrder);
          });
        },
        showFullWidth: function showFullWidth(compDetails) {
          return setFullWidthCompDetails(compDetails);
        },
        getFullWidthCellRenderer: function getFullWidthCellRenderer() {
          return fullWidthCompRef.current;
        }
      };
      rowCtrl.setComp(compProxy, eGui.current, pinned);
    }, []);
    react_1.useEffect(function () {
      return jsComp.showJsComp(fullWidthCompDetails, context, eGui.current, fullWidthCompRef);
    }, [fullWidthCompDetails]);
    var rowStyles = react_1.useMemo(function () {
      var res = {
        height: height,
        top: top,
        transform: transform,
        display: display
      };
      main._.assign(res, userStyles);
      return res;
    }, [height, top, transform, userStyles, display]);
    var className = react_1.useMemo(function () {
      return cssClasses.toString();
    }, [cssClasses]);
    var showFullWidthFramework = fullWidthCompDetails && fullWidthCompDetails.componentFromFramework;
    var showCells = cellCtrls != null;
    var reactFullWidthCellRendererStateless = react_1.useMemo(function () {
      var res = fullWidthCompDetails && fullWidthCompDetails.componentFromFramework && utils$2.isComponentStateless(fullWidthCompDetails.componentClass);
      return !!res;
    }, [fullWidthCompDetails]);
    var showCellsJsx = function showCellsJsx() {
      return cellCtrls.list.map(function (cellCtrl) {
        return react_1.default.createElement(cellComp_1.default, {
          cellCtrl: cellCtrl,
          editingRow: rowCtrl.isEditing(),
          printLayout: rowCtrl.isPrintLayout(),
          key: cellCtrl.getInstanceId()
        });
      });
    };
    var showFullWidthFrameworkJsx = function showFullWidthFrameworkJsx() {
      var FullWidthComp = fullWidthCompDetails.componentClass;
      return react_1.default.createElement(react_1.default.Fragment, null, reactFullWidthCellRendererStateless && react_1.default.createElement(FullWidthComp, __assign({}, fullWidthCompDetails.params)), !reactFullWidthCellRendererStateless && react_1.default.createElement(FullWidthComp, __assign({}, fullWidthCompDetails.params, {
        ref: fullWidthCompRef
      })));
    };
    return react_1.default.createElement("div", {
      ref: eGui,
      role: role,
      className: className,
      style: rowStyles,
      "row-index": rowIndex,
      "aria-rowindex": ariaRowIndex,
      "aria-expanded": ariaExpanded,
      "aria-label": ariaLabel,
      "aria-selected": ariaSelected,
      "row-id": rowId,
      "row-business-key": rowBusinessKey,
      tabIndex: tabIndex
    }, showCells && showCellsJsx(), showFullWidthFramework && showFullWidthFrameworkJsx());
  };
  exports.default = react_1.memo(RowComp);
});
unwrapExports(rowComp);
var rowContainerComp = createCommonjsModule(function (module, exports) {
  var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var reactComment_1 = __importDefault(reactComment);
  var rowComp_1 = __importDefault(rowComp);
  var RowContainerComp = function RowContainerComp(params) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var _a = react_1.useState(''),
      viewportHeight = _a[0],
      setViewportHeight = _a[1];
    var _b = react_1.useState([]),
      rowCtrls = _b[0],
      _setRowCtrls = _b[1];
    var _c = react_1.useState(false),
      domOrder = _c[0],
      _setDomOrder2 = _c[1];
    var _d = react_1.useState(''),
      containerWidth = _d[0],
      _setContainerWidth = _d[1];
    var name = params.name;
    var pinned = react_1.useMemo(function () {
      return main.RowContainerCtrl.getPinned(name);
    }, [name]);
    var eWrapper = react_1.useRef(null);
    var eViewport = react_1.useRef(null);
    var eContainer = react_1.useRef(null);
    var cssClasses = react_1.useMemo(function () {
      return main.RowContainerCtrl.getRowContainerCssClasses(name);
    }, [name]);
    var wrapperClasses = react_1.useMemo(function () {
      return utils$2.classesList(cssClasses.wrapper);
    }, []);
    var viewportClasses = react_1.useMemo(function () {
      return utils$2.classesList(cssClasses.viewport);
    }, []);
    var containerClasses = react_1.useMemo(function () {
      return utils$2.classesList(cssClasses.container);
    }, []);
    // no need to useMemo for boolean types
    var template1 = name === main.RowContainerName.CENTER;
    var template2 = name === main.RowContainerName.TOP_CENTER || name === main.RowContainerName.BOTTOM_CENTER;
    var template3 = !template1 && !template2;
    var topLevelRef = template1 ? eWrapper : template2 ? eViewport : eContainer;
    reactComment_1.default(' AG Row Container ' + name + ' ', topLevelRef);
    react_1.useEffect(function () {
      var beansToDestroy = [];
      var compProxy = {
        setViewportHeight: setViewportHeight,
        setRowCtrls: function setRowCtrls(rowCtrls) {
          _setRowCtrls(function (prev) {
            if (domOrder) {
              return rowCtrls;
            }
            // if dom order not important, we don't want to change the order
            // of the elements in the dom, as this would break transition styles
            var oldRows = prev.filter(function (r) {
              return rowCtrls.indexOf(r) >= 0;
            });
            var newRows = rowCtrls.filter(function (r) {
              return oldRows.indexOf(r) < 0;
            });
            var next = __spreadArrays(oldRows, newRows);
            return next;
          });
        },
        setDomOrder: function setDomOrder(domOrder) {
          return _setDomOrder2(domOrder);
        },
        setContainerWidth: function setContainerWidth(width) {
          return _setContainerWidth(width);
        }
      };
      var ctrl = context.createBean(new main.RowContainerCtrl(name));
      beansToDestroy.push(ctrl);
      ctrl.setComp(compProxy, eContainer.current, eViewport.current, eWrapper.current);
      return function () {
        context.destroyBeans(beansToDestroy);
      };
    }, []);
    var viewportStyle = react_1.useMemo(function () {
      return {
        height: viewportHeight
      };
    }, [viewportHeight]);
    var containerStyle = react_1.useMemo(function () {
      return {
        width: containerWidth
      };
    }, [containerWidth]);
    var buildContainer = function buildContainer() {
      return react_1.default.createElement("div", {
        className: containerClasses,
        ref: eContainer,
        role: "rowgroup",
        style: containerStyle,
        unselectable: "on"
      }, rowCtrls.map(function (rowCtrl) {
        return react_1.default.createElement(rowComp_1.default, {
          rowCtrl: rowCtrl,
          pinned: pinned,
          key: rowCtrl.getInstanceId()
        });
      }));
    };
    return react_1.default.createElement(react_1.default.Fragment, null, template1 && react_1.default.createElement("div", {
      className: wrapperClasses,
      ref: eWrapper,
      role: "presentation",
      unselectable: "on"
    }, react_1.default.createElement("div", {
      className: viewportClasses,
      ref: eViewport,
      role: "presentation",
      style: viewportStyle
    }, buildContainer())), template2 && react_1.default.createElement("div", {
      className: viewportClasses,
      ref: eViewport,
      role: "presentation",
      style: viewportStyle
    }, buildContainer()), template3 && buildContainer());
  };
  exports.default = react_1.memo(RowContainerComp);
});
unwrapExports(rowContainerComp);
var gridBodyComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var gridHeaderComp_1 = __importDefault(gridHeaderComp);
  var reactComment_1 = __importDefault(reactComment);
  var rowContainerComp_1 = __importDefault(rowContainerComp);
  var GridBodyComp = function GridBodyComp() {
    var _a = react_1.useContext(beansContext.BeansContext),
      context = _a.context,
      agStackComponentsRegistry = _a.agStackComponentsRegistry,
      resizeObserverService = _a.resizeObserverService;
    var _b = react_1.useState(''),
      rowAnimationClass = _b[0],
      setRowAnimationClass = _b[1];
    var _c = react_1.useState(0),
      ariaColCount = _c[0],
      setAriaColCount = _c[1];
    var _d = react_1.useState(0),
      ariaRowCount = _d[0],
      setAriaRowCount = _d[1];
    var _e = react_1.useState(0),
      topHeight = _e[0],
      setTopHeight = _e[1];
    var _f = react_1.useState(0),
      bottomHeight = _f[0],
      setBottomHeight = _f[1];
    var _g = react_1.useState(''),
      topDisplay = _g[0],
      setTopDisplay = _g[1];
    var _h = react_1.useState(''),
      bottomDisplay = _h[0],
      setBottomDisplay = _h[1];
    var _j = react_1.useState(null),
      movingCss = _j[0],
      setMovingCss = _j[1];
    var _k = react_1.useState(''),
      layoutClass = _k[0],
      setLayoutClass = _k[1];
    var _l = react_1.useState(null),
      forceVerticalScrollClass = _l[0],
      setForceVerticalScrollClass = _l[1];
    var _m = react_1.useState(''),
      topAndBottomOverflowY = _m[0],
      setTopAndBottomOverflowY = _m[1];
    var _o = react_1.useState(null),
      cellSelectableCss = _o[0],
      setCellSelectableCss = _o[1];
    var eRoot = react_1.useRef(null);
    var eTop = react_1.useRef(null);
    var eBodyViewport = react_1.useRef(null);
    var eBottom = react_1.useRef(null);
    reactComment_1.default(' AG Grid Body ', eRoot);
    reactComment_1.default(' AG Pinned Top ', eTop);
    reactComment_1.default(' AG Middle ', eBodyViewport);
    reactComment_1.default(' AG Pinned Bottom ', eBottom);
    react_1.useEffect(function () {
      var beansToDestroy = [];
      var destroyFuncs = [];
      if (!context) {
        return;
      }
      var newComp = function newComp(tag) {
        var CompClass = agStackComponentsRegistry.getComponentClass(tag);
        var comp = context.createBean(new CompClass());
        beansToDestroy.push(comp);
        return comp;
      };
      eRoot.current.appendChild(document.createComment(' AG Fake Horizontal Scroll '));
      eRoot.current.appendChild(newComp('AG-FAKE-HORIZONTAL-SCROLL').getGui());
      eRoot.current.appendChild(document.createComment(' AG Overlay Wrapper '));
      eRoot.current.appendChild(newComp('AG-OVERLAY-WRAPPER').getGui());
      var compProxy = {
        setRowAnimationCssOnBodyViewport: setRowAnimationClass,
        setColumnCount: setAriaColCount,
        setRowCount: setAriaRowCount,
        setTopHeight: setTopHeight,
        setBottomHeight: setBottomHeight,
        setTopDisplay: setTopDisplay,
        setBottomDisplay: setBottomDisplay,
        setColumnMovingCss: setMovingCss,
        updateLayoutClasses: setLayoutClass,
        setAlwaysVerticalScrollClass: setForceVerticalScrollClass,
        setPinnedTopBottomOverflowY: setTopAndBottomOverflowY,
        setCellSelectableCss: setCellSelectableCss,
        registerBodyViewportResizeListener: function registerBodyViewportResizeListener(listener) {
          var unsubscribeFromResize = resizeObserverService.observeResize(eBodyViewport.current, listener);
          destroyFuncs.push(function () {
            return unsubscribeFromResize();
          });
        }
      };
      var ctrl = context.createBean(new main.GridBodyCtrl());
      beansToDestroy.push(ctrl);
      ctrl.setComp(compProxy, eRoot.current, eBodyViewport.current, eTop.current, eBottom.current);
      return function () {
        context.destroyBeans(beansToDestroy);
        destroyFuncs.forEach(function (f) {
          return f();
        });
      };
    }, []);
    var rootClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-root', 'ag-unselectable', movingCss, layoutClass);
    }, [movingCss, layoutClass]);
    var bodyViewportClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-body-viewport', rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss);
    }, [rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss]);
    var topClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-floating-top', cellSelectableCss);
    }, [cellSelectableCss]);
    var bottomClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-floating-bottom', cellSelectableCss);
    }, [cellSelectableCss]);
    var topStyle = react_1.useMemo(function () {
      return {
        height: topHeight,
        minHeight: topHeight,
        display: topDisplay,
        overflowY: topAndBottomOverflowY
      };
    }, [topHeight, topDisplay, topAndBottomOverflowY]);
    var bottomStyle = react_1.useMemo(function () {
      return {
        height: bottomHeight,
        minHeight: bottomHeight,
        display: bottomDisplay,
        overflowY: topAndBottomOverflowY
      };
    }, [bottomHeight, bottomDisplay, topAndBottomOverflowY]);
    var createRowContainer = function createRowContainer(container) {
      return react_1.default.createElement(rowContainerComp_1.default, {
        name: container,
        key: container + "-container"
      });
    };
    var createSection = function createSection(_a) {
      var section = _a.section,
        children = _a.children,
        className = _a.className,
        style = _a.style,
        unselectable = _a.unselectable;
      return react_1.default.createElement("div", {
        ref: section,
        className: className,
        role: "presentation",
        style: style,
        unselectable: unselectable
      }, children.map(createRowContainer));
    };
    return react_1.default.createElement("div", {
      ref: eRoot,
      className: rootClasses,
      role: "grid",
      unselectable: "on",
      "aria-colcount": ariaColCount,
      "aria-rowcount": ariaRowCount
    }, react_1.default.createElement(gridHeaderComp_1.default, null), createSection({
      section: eTop,
      className: topClasses,
      style: topStyle,
      unselectable: 'on',
      children: [main.RowContainerName.TOP_LEFT, main.RowContainerName.TOP_CENTER, main.RowContainerName.TOP_RIGHT, main.RowContainerName.TOP_FULL_WITH]
    }), createSection({
      section: eBodyViewport,
      className: bodyViewportClasses,
      children: [main.RowContainerName.LEFT, main.RowContainerName.CENTER, main.RowContainerName.RIGHT, main.RowContainerName.FULL_WIDTH]
    }), createSection({
      section: eBottom,
      className: bottomClasses,
      style: bottomStyle,
      unselectable: 'on',
      children: [main.RowContainerName.BOTTOM_LEFT, main.RowContainerName.BOTTOM_CENTER, main.RowContainerName.BOTTOM_RIGHT, main.RowContainerName.BOTTOM_FULL_WITH]
    }));
  };
  exports.default = react_1.memo(GridBodyComp);
});
unwrapExports(gridBodyComp);
var tabGuardComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var TabGuardCompRef = function TabGuardCompRef(props, forwardRef) {
    var children = props.children,
      eFocusableElement = props.eFocusableElement,
      onTabKeyDown = props.onTabKeyDown,
      gridCtrl = props.gridCtrl;
    var context = react_1.useContext(beansContext.BeansContext).context;
    var topTabGuardRef = react_1.useRef(null);
    var bottomTabGuardRef = react_1.useRef(null);
    var tabGuardCtrlRef = react_1.useRef();
    var _a = react_1.useState(),
      tabIndex = _a[0],
      _setTabIndex3 = _a[1];
    react_1.useImperativeHandle(forwardRef, function () {
      return {
        forceFocusOutOfContainer: function forceFocusOutOfContainer() {
          tabGuardCtrlRef.current.forceFocusOutOfContainer();
        }
      };
    });
    react_1.useEffect(function () {
      var eTopGuard = topTabGuardRef.current;
      var eBottomGuard = bottomTabGuardRef.current;
      var compProxy = {
        setTabIndex: function setTabIndex(value) {
          return value == null ? _setTabIndex3(undefined) : _setTabIndex3(parseInt(value, 10));
        }
      };
      var ctrl = tabGuardCtrlRef.current = context.createBean(new main.TabGuardCtrl({
        comp: compProxy,
        eTopGuard: eTopGuard,
        eBottomGuard: eBottomGuard,
        eFocusableElement: eFocusableElement,
        onTabKeyDown: onTabKeyDown,
        focusInnerElement: function focusInnerElement(fromBottom) {
          return gridCtrl.focusInnerElement(fromBottom);
        }
      }));
      return function () {
        context.destroyBean(ctrl);
      };
    }, []);
    var createTabGuard = function createTabGuard(side) {
      return react_1.default.createElement("div", {
        className: "ag-tab-guard ag-tab-guard-" + side,
        role: "presentation",
        tabIndex: tabIndex,
        ref: side === 'top' ? topTabGuardRef : bottomTabGuardRef
      });
    };
    return react_1.default.createElement(react_1.default.Fragment, null, createTabGuard('top'), children, createTabGuard('bottom'));
  };
  var TabGuardComp = react_1.forwardRef(TabGuardCompRef);
  exports.default = react_1.memo(TabGuardComp);
});
unwrapExports(tabGuardComp);
var gridComp = createCommonjsModule(function (module, exports) {
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var gridBodyComp_1 = __importDefault(gridBodyComp);
  var reactComment_1 = __importDefault(reactComment);
  var tabGuardComp_1 = __importDefault(tabGuardComp);
  var GridComp = function GridComp(_a) {
    var context = _a.context;
    var _b = react_1.useState(''),
      rtlClass = _b[0],
      setRtlClass = _b[1];
    var _c = react_1.useState(''),
      keyboardFocusClass = _c[0],
      setKeyboardFocusClass = _c[1];
    var _d = react_1.useState(''),
      layoutClass = _d[0],
      setLayoutClass = _d[1];
    var _e = react_1.useState(null),
      cursor = _e[0],
      setCursor = _e[1];
    var _f = react_1.useState(null),
      userSelect = _f[0],
      setUserSelect = _f[1];
    var _g = react_1.useState(false),
      initialised = _g[0],
      setInitialised = _g[1];
    var _h = react_1.useState(),
      tabGuardReady = _h[0],
      setTabGuardReady = _h[1];
    var gridCtrlRef = react_1.useRef(null);
    var eRootWrapperRef = react_1.useRef(null);
    var tabGuardRef = react_1.useRef();
    var eGridBodyParentRef = react_1.useRef(null);
    var focusInnerElementRef = react_1.useRef(function () {
      return undefined;
    });
    var onTabKeyDown = react_1.useCallback(function () {
      return undefined;
    }, []);
    var beans = react_1.useMemo(function () {
      return context.getBean('beans');
    }, []);
    reactComment_1.default(' AG Grid ', eRootWrapperRef);
    // create shared controller.
    react_1.useEffect(function () {
      var currentController = gridCtrlRef.current = context.createBean(new main.GridCtrl());
      return function () {
        context.destroyBean(currentController);
        gridCtrlRef.current = null;
      };
    }, []);
    // initialise the UI
    react_1.useEffect(function () {
      var gridCtrl = gridCtrlRef.current;
      focusInnerElementRef.current = gridCtrl.focusInnerElement.bind(gridCtrl);
      var compProxy = {
        destroyGridUi: function destroyGridUi() {},
        setRtlClass: setRtlClass,
        addOrRemoveKeyboardFocusClass: function addOrRemoveKeyboardFocusClass(addOrRemove) {
          return setKeyboardFocusClass(addOrRemove ? main.FocusService.AG_KEYBOARD_FOCUS : '');
        },
        forceFocusOutOfContainer: function forceFocusOutOfContainer() {
          tabGuardRef.current.forceFocusOutOfContainer();
        },
        updateLayoutClasses: setLayoutClass,
        getFocusableContainers: function getFocusableContainers() {
          var els = [];
          var gridBodyCompEl = eRootWrapperRef.current.querySelector('.ag-root');
          var sideBarEl = eRootWrapperRef.current.querySelector('.ag-side-bar');
          if (gridBodyCompEl) {
            els.push(gridBodyCompEl);
          }
          if (sideBarEl) {
            els.push(sideBarEl);
          }
          return els;
        },
        setCursor: setCursor,
        setUserSelect: setUserSelect
      };
      gridCtrl.setComp(compProxy, eRootWrapperRef.current, eRootWrapperRef.current);
      setInitialised(true);
    }, []);
    // initialise the extra components
    react_1.useEffect(function () {
      if (!tabGuardReady) {
        return;
      }
      var gridCtrl = gridCtrlRef.current;
      var beansToDestroy = [];
      var agStackComponentsRegistry = beans.agStackComponentsRegistry;
      var HeaderDropZonesClass = agStackComponentsRegistry.getComponentClass('AG-GRID-HEADER-DROP-ZONES');
      var SideBarClass = agStackComponentsRegistry.getComponentClass('AG-SIDE-BAR');
      var StatusBarClass = agStackComponentsRegistry.getComponentClass('AG-STATUS-BAR');
      var WatermarkClass = agStackComponentsRegistry.getComponentClass('AG-WATERMARK');
      var PaginationClass = agStackComponentsRegistry.getComponentClass('AG-PAGINATION');
      var additionalEls = [];
      var eRootWrapper = eRootWrapperRef.current;
      var eGridBodyParent = eGridBodyParentRef.current;
      if (gridCtrl.showDropZones() && HeaderDropZonesClass) {
        var headerDropZonesComp = context.createBean(new HeaderDropZonesClass());
        var eGui = headerDropZonesComp.getGui();
        eRootWrapper.insertAdjacentElement('afterbegin', eGui);
        additionalEls.push(eGui);
        beansToDestroy.push(headerDropZonesComp);
      }
      if (gridCtrl.showSideBar() && SideBarClass) {
        var sideBarComp = context.createBean(new SideBarClass());
        var eGui = sideBarComp.getGui();
        var bottomTabGuard = eGridBodyParent.querySelector('.ag-tab-guard-bottom');
        if (bottomTabGuard) {
          bottomTabGuard.insertAdjacentElement('beforebegin', eGui);
          additionalEls.push(eGui);
        }
        beansToDestroy.push(sideBarComp);
      }
      if (gridCtrl.showStatusBar() && StatusBarClass) {
        var statusBarComp = context.createBean(new StatusBarClass());
        var eGui = statusBarComp.getGui();
        eRootWrapper.insertAdjacentElement('beforeend', eGui);
        additionalEls.push(eGui);
        beansToDestroy.push(statusBarComp);
      }
      if (PaginationClass) {
        var paginationComp = context.createBean(new PaginationClass());
        var eGui = paginationComp.getGui();
        eRootWrapper.insertAdjacentElement('beforeend', eGui);
        additionalEls.push(eGui);
        beansToDestroy.push(paginationComp);
      }
      if (gridCtrl.showWatermark() && WatermarkClass) {
        var watermarkComp = context.createBean(new WatermarkClass());
        var eGui = watermarkComp.getGui();
        eRootWrapper.insertAdjacentElement('beforeend', eGui);
        additionalEls.push(eGui);
        beansToDestroy.push(watermarkComp);
      }
      return function () {
        context.destroyBeans(beansToDestroy);
        additionalEls.forEach(function (el) {
          if (el.parentElement) {
            el.parentElement.removeChild(el);
          }
        });
      };
    }, [tabGuardReady]);
    var rootWrapperClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-root-wrapper', rtlClass, keyboardFocusClass, layoutClass);
    }, [rtlClass, keyboardFocusClass, layoutClass]);
    var rootWrapperBodyClasses = react_1.useMemo(function () {
      return utils$2.classesList('ag-root-wrapper-body', 'ag-focus-managed', layoutClass);
    }, [layoutClass]);
    var topStyle = react_1.useMemo(function () {
      return {
        userSelect: userSelect != null ? userSelect : '',
        WebkitUserSelect: userSelect != null ? userSelect : '',
        cursor: cursor != null ? cursor : ''
      };
    }, [userSelect, cursor]);
    var eGridBodyParent = eGridBodyParentRef.current;
    var setTabGuardCompRef = react_1.useCallback(function (ref) {
      tabGuardRef.current = ref;
      setTabGuardReady(true);
    }, []);
    return react_1.default.createElement("div", {
      ref: eRootWrapperRef,
      className: rootWrapperClasses,
      style: topStyle
    }, react_1.default.createElement("div", {
      className: rootWrapperBodyClasses,
      ref: eGridBodyParentRef
    }, initialised && eGridBodyParent && react_1.default.createElement(beansContext.BeansContext.Provider, {
      value: beans
    }, react_1.default.createElement(tabGuardComp_1.default, {
      ref: setTabGuardCompRef,
      eFocusableElement: eGridBodyParent,
      onTabKeyDown: onTabKeyDown,
      gridCtrl: gridCtrlRef.current
    },
    // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    react_1.default.createElement(gridBodyComp_1.default, null)))));
  };
  exports.default = react_1.memo(GridComp);
});
unwrapExports(gridComp);
var groupCellRenderer = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var GroupCellRenderer = function GroupCellRenderer(props) {
    var context = react_1.useContext(beansContext.BeansContext).context;
    var eGui = react_1.useRef(null);
    var eValueRef = react_1.useRef(null);
    var eCheckboxRef = react_1.useRef(null);
    var eExpandedRef = react_1.useRef(null);
    var eContractedRef = react_1.useRef(null);
    var _a = react_1.useState(),
      innerCompDetails = _a[0],
      setInnerCompDetails = _a[1];
    var _b = react_1.useState(),
      childCount = _b[0],
      _setChildCount = _b[1];
    var _c = react_1.useState(),
      value = _c[0],
      setValue = _c[1];
    var _d = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _d[0],
      setCssClasses = _d[1];
    var _e = react_1.useState(new utils$2.CssClasses()),
      expandedCssClasses = _e[0],
      setExpandedCssClasses = _e[1];
    var _f = react_1.useState(new utils$2.CssClasses()),
      contractedCssClasses = _f[0],
      setContractedCssClasses = _f[1];
    var _g = react_1.useState(new utils$2.CssClasses()),
      checkboxCssClasses = _g[0],
      setCheckboxCssClasses = _g[1];
    react_1.useEffect(function () {
      return jsComp.showJsComp(innerCompDetails, context, eValueRef.current);
    }, [innerCompDetails]);
    react_1.useEffect(function () {
      var compProxy = {
        setInnerRenderer: function setInnerRenderer(details, valueToDisplay) {
          setInnerCompDetails(details);
          setValue(valueToDisplay);
        },
        setChildCount: function setChildCount(count) {
          return _setChildCount(count);
        },
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setContractedDisplayed: function setContractedDisplayed(displayed) {
          return setContractedCssClasses(function (prev) {
            return prev.setClass('ag-hidden', !displayed);
          });
        },
        setExpandedDisplayed: function setExpandedDisplayed(displayed) {
          return setExpandedCssClasses(function (prev) {
            return prev.setClass('ag-hidden', !displayed);
          });
        },
        setCheckboxVisible: function setCheckboxVisible(visible) {
          setCheckboxCssClasses(function (prev) {
            return prev.setClass('ag-invisible', !visible);
          });
        }
      };
      var ctrl = context.createBean(new main.GroupCellRendererCtrl());
      ctrl.init(compProxy, eGui.current, eCheckboxRef.current, eExpandedRef.current, eContractedRef.current, GroupCellRenderer, props);
      return function () {
        context.destroyBean(ctrl);
      };
    }, []);
    var className = react_1.useMemo(function () {
      return "ag-cell-wrapper " + cssClasses.toString();
    }, [cssClasses]);
    var expandedClassName = react_1.useMemo(function () {
      return "ag-group-expanded " + expandedCssClasses.toString();
    }, [expandedCssClasses]);
    var contractedClassName = react_1.useMemo(function () {
      return "ag-group-contracted " + contractedCssClasses.toString();
    }, [contractedCssClasses]);
    var checkboxClassName = react_1.useMemo(function () {
      return "ag-group-checkbox " + checkboxCssClasses.toString();
    }, [checkboxCssClasses]);
    var useFwRenderer = innerCompDetails && innerCompDetails.componentFromFramework;
    var FwRenderer = useFwRenderer ? innerCompDetails.componentClass : undefined;
    var useValue = innerCompDetails == null && value != null;
    return react_1.default.createElement("span", __assign({
      className: className,
      ref: eGui
    }, !props.colDef ? {
      role: 'gridcell'
    } : {}), react_1.default.createElement("span", {
      className: expandedClassName,
      ref: eExpandedRef
    }), react_1.default.createElement("span", {
      className: contractedClassName,
      ref: eContractedRef
    }), react_1.default.createElement("span", {
      className: checkboxClassName,
      ref: eCheckboxRef
    }), react_1.default.createElement("span", {
      className: "ag-group-value",
      ref: eValueRef
    }, useValue && react_1.default.createElement(react_1.default.Fragment, null, value), useFwRenderer && react_1.default.createElement(FwRenderer, __assign({}, innerCompDetails.params))), react_1.default.createElement("span", {
      className: "ag-group-child-count"
    }, childCount));
  };
  exports.default = react_1.memo(GroupCellRenderer);
});
unwrapExports(groupCellRenderer);
var detailCellRenderer = createCommonjsModule(function (module, exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var DetailCellRenderer = function DetailCellRenderer(props, ref) {
    var _a = react_1.useContext(beansContext.BeansContext),
      ctrlsFactory = _a.ctrlsFactory,
      context = _a.context,
      gridOptionsWrapper = _a.gridOptionsWrapper,
      resizeObserverService = _a.resizeObserverService,
      clientSideRowModel = _a.clientSideRowModel,
      serverSideRowModel = _a.serverSideRowModel;
    var _b = react_1.useState(new utils$2.CssClasses()),
      cssClasses = _b[0],
      setCssClasses = _b[1];
    var _c = react_1.useState(new utils$2.CssClasses()),
      gridCssClasses = _c[0],
      setGridCssClasses = _c[1];
    var _d = react_1.useState(),
      detailGridOptions = _d[0],
      setDetailGridOptions = _d[1];
    var _e = react_1.useState(),
      detailRowData = _e[0],
      setDetailRowData = _e[1];
    var ctrlRef = react_1.useRef();
    var eGuiRef = react_1.useRef(null);
    var topClassName = react_1.useMemo(function () {
      return cssClasses.toString() + ' ag-details-row';
    }, [cssClasses]);
    var gridClassName = react_1.useMemo(function () {
      return gridCssClasses.toString() + ' ag-details-grid';
    }, [gridCssClasses]);
    if (ref) {
      react_1.useImperativeHandle(ref, function () {
        return {
          refresh: function refresh() {
            return ctrlRef.current.refresh();
          }
        };
      });
    }
    react_1.useEffect(function () {
      if (props.template) {
        console.warn('AG Grid: detailCellRendererParams.template is not supported by React UI - this only works with frameworks that work against String templates. To change the template, please provide your own React Detail Cell Renderer.');
      }
    }, []);
    react_1.useEffect(function () {
      var compProxy = {
        addOrRemoveCssClass: function addOrRemoveCssClass(name, on) {
          return setCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        addOrRemoveDetailGridCssClass: function addOrRemoveDetailGridCssClass(name, on) {
          return setGridCssClasses(function (prev) {
            return prev.setClass(name, on);
          });
        },
        setDetailGrid: function setDetailGrid(gridOptions) {
          return setDetailGridOptions(gridOptions);
        },
        setRowData: function setRowData(rowData) {
          return setDetailRowData(rowData);
        }
      };
      var ctrl = ctrlsFactory.getInstance('detailCellRenderer');
      if (!ctrl) {
        return;
      } // should never happen, means master/detail module not loaded
      context.createBean(ctrl);
      ctrl.init(compProxy, props);
      ctrlRef.current = ctrl;
      var resizeObserverDestroyFunc;
      if (gridOptionsWrapper.isDetailRowAutoHeight()) {
        var checkRowSizeFunc = function checkRowSizeFunc() {
          var clientHeight = eGuiRef.current.clientHeight;
          // if the UI is not ready, the height can be 0, which we ignore, as otherwise a flicker will occur
          // as UI goes from the default height, to 0, then to the real height as UI becomes ready. this means
          // it's not possible for have 0 as auto-height, however this is an improbable use case, as even an
          // empty detail grid would still have some styling around it giving at least a few pixels.
          if (clientHeight != null && clientHeight > 0) {
            // we do the update in a timeout, to make sure we are not calling from inside the grid
            // doing another update
            var updateRowHeightFunc = function updateRowHeightFunc() {
              props.node.setRowHeight(clientHeight);
              if (clientSideRowModel) {
                clientSideRowModel.onRowHeightChanged();
              } else if (serverSideRowModel) {
                serverSideRowModel.onRowHeightChanged();
              }
            };
            setTimeout(updateRowHeightFunc, 0);
          }
        };
        resizeObserverDestroyFunc = resizeObserverService.observeResize(eGuiRef.current, checkRowSizeFunc);
        checkRowSizeFunc();
      }
      return function () {
        context.destroyBean(ctrl);
      };
    }, []);
    var setGridApi = react_1.useCallback(function (api, columnApi) {
      ctrlRef.current.registerDetailWithMaster(api, columnApi);
    }, []);
    return react_1.default.createElement("div", {
      className: topClassName,
      ref: eGuiRef
    }, detailGridOptions && react_1.default.createElement(agGridReactUi.AgGridReactUi, __assign({
      className: gridClassName
    }, detailGridOptions, {
      rowData: detailRowData,
      setGridApi: setGridApi
    })));
  };
  exports.default = react_1.forwardRef(DetailCellRenderer);
});
unwrapExports(detailCellRenderer);
var reactFrameworkOverrides = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics177 = function extendStatics(d, b) {
      _extendStatics177 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics177(d, b);
    };
    return function (d, b) {
      _extendStatics177(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var groupCellRenderer_1 = __importDefault(groupCellRenderer);
  var detailCellRenderer_1 = __importDefault(detailCellRenderer);
  var ReactFrameworkOverrides = /** @class */function (_super) {
    __extends(ReactFrameworkOverrides, _super);
    function ReactFrameworkOverrides() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.frameworkComponents = {
        agGroupCellRenderer: groupCellRenderer_1.default,
        agGroupRowRenderer: groupCellRenderer_1.default,
        agDetailCellRenderer: detailCellRenderer_1.default
      };
      return _this;
    }
    ReactFrameworkOverrides.prototype.frameworkComponent = function (name) {
      return this.frameworkComponents[name];
    };
    return ReactFrameworkOverrides;
  }(main.VanillaFrameworkOverrides);
  exports.ReactFrameworkOverrides = ReactFrameworkOverrides;
});
unwrapExports(reactFrameworkOverrides);
var reactFrameworkOverrides_1 = reactFrameworkOverrides.ReactFrameworkOverrides;
var agGridReactUi = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics178 = function extendStatics(d, b) {
      _extendStatics178 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics178(d, b);
    };
    return function (d, b) {
      _extendStatics178(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var gridComp_1 = __importDefault(gridComp);
  var AgGridReactUi = /** @class */function (_super) {
    __extends(AgGridReactUi, _super);
    function AgGridReactUi(props) {
      var _this = _super.call(this, props) || this;
      _this.props = props;
      _this.destroyFuncs = [];
      _this.changeDetectionService = new changeDetectionService.ChangeDetectionService();
      _this.eGui = react_1.default.createRef();
      _this.state = {
        context: undefined
      };
      _this.portalManager = new portalManager.PortalManager(_this, props.componentWrappingElement, props.maxComponentCreationTimeMs);
      return _this;
    }
    AgGridReactUi.prototype.render = function () {
      return react_1.default.createElement("div", {
        style: this.createStyleForDiv(),
        className: this.props.className,
        ref: this.eGui
      }, this.state.context && react_1.default.createElement(gridComp_1.default, {
        context: this.state.context
      }), this.portalManager.getPortals());
    };
    AgGridReactUi.prototype.createStyleForDiv = function () {
      return __assign({
        height: '100%'
      }, this.props.containerStyle || {});
    };
    AgGridReactUi.prototype.componentDidMount = function () {
      var _this = this;
      var modules = this.props.modules || [];
      var gridParams = {
        providedBeanInstances: {
          frameworkComponentWrapper: new ReactFrameworkComponentWrapper(this.portalManager)
        },
        modules: modules,
        frameworkOverrides: new reactFrameworkOverrides.ReactFrameworkOverrides()
      };
      this.gridOptions = __assign({}, this.props.gridOptions);
      var children = this.props.children;
      if (agGridColumn.AgGridColumn.hasChildColumns(children)) {
        this.gridOptions.columnDefs = agGridColumn.AgGridColumn.mapChildColumnDefs(children);
      }
      this.gridOptions = main.ComponentUtil.copyAttributesToGridOptions(this.gridOptions, this.props);
      // don't need the return value
      var gridCoreCreator = new main.GridCoreCreator();
      gridCoreCreator.create(this.eGui.current, this.gridOptions, function (context) {
        _this.setState({
          context: context
        });
      }, gridParams);
      this.destroyFuncs.push(function () {
        return _this.gridOptions.api.destroy();
      });
      this.api = this.gridOptions.api;
      this.columnApi = this.gridOptions.columnApi;
      this.props.setGridApi(this.api, this.columnApi);
    };
    AgGridReactUi.prototype.componentWillUnmount = function () {
      this.destroyFuncs.forEach(function (f) {
        return f();
      });
    };
    AgGridReactUi.prototype.componentDidUpdate = function (prevProps) {
      this.processPropsChanges(prevProps, this.props);
    };
    AgGridReactUi.prototype.processPropsChanges = function (prevProps, nextProps) {
      var changes = {};
      this.extractGridPropertyChanges(prevProps, nextProps, changes);
      this.extractDeclarativeColDefChanges(nextProps, changes);
      this.processChanges(changes);
    };
    AgGridReactUi.prototype.extractDeclarativeColDefChanges = function (nextProps, changes) {
      // if columnDefs are provided on gridOptions we use those - you can't combine both
      // we also skip if columnDefs are provided as a prop directly on AgGridReact
      if (this.props.gridOptions && this.props.gridOptions.columnDefs || this.props.columnDefs) {
        return;
      }
      var debugLogging = !!nextProps.debug;
      var propKey = 'columnDefs';
      var currentColDefs = this.gridOptions.columnDefs;
      if (agGridColumn.AgGridColumn.hasChildColumns(nextProps.children)) {
        var detectionStrategy = this.changeDetectionService.getStrategy(this.getStrategyTypeForProp(propKey));
        var newColDefs = agGridColumn.AgGridColumn.mapChildColumnDefs(nextProps.children);
        if (!detectionStrategy.areEqual(currentColDefs, newColDefs)) {
          if (debugLogging) {
            console.log("agGridReact: colDefs definitions changed");
          }
          changes[propKey] = {
            previousValue: currentColDefs,
            currentValue: newColDefs
          };
        }
      } else if (currentColDefs && currentColDefs.length > 0) {
        changes[propKey] = {
          previousValue: currentColDefs,
          currentValue: []
        };
      }
    };
    AgGridReactUi.prototype.extractGridPropertyChanges = function (prevProps, nextProps, changes) {
      var _this = this;
      var debugLogging = !!nextProps.debug;
      Object.keys(nextProps).forEach(function (propKey) {
        if (main._.includes(main.ComponentUtil.ALL_PROPERTIES, propKey)) {
          var changeDetectionStrategy = _this.changeDetectionService.getStrategy(_this.getStrategyTypeForProp(propKey));
          if (!changeDetectionStrategy.areEqual(prevProps[propKey], nextProps[propKey])) {
            if (debugLogging) {
              console.log("agGridReact: [" + propKey + "] property changed");
            }
            changes[propKey] = {
              previousValue: prevProps[propKey],
              currentValue: nextProps[propKey]
            };
          }
        }
      });
      main.ComponentUtil.getEventCallbacks().forEach(function (funcName) {
        if (prevProps[funcName] !== nextProps[funcName]) {
          if (debugLogging) {
            console.log("agGridReact: [" + funcName + "] event callback changed");
          }
          changes[funcName] = {
            previousValue: prevProps[funcName],
            currentValue: nextProps[funcName]
          };
        }
      });
    };
    AgGridReactUi.prototype.processChanges = function (changes) {
      if (this.api) {
        main.ComponentUtil.processOnChange(changes, this.gridOptions, this.api, this.columnApi);
      }
    };
    AgGridReactUi.prototype.getStrategyTypeForProp = function (propKey) {
      if (propKey === 'rowData') {
        if (this.props.rowDataChangeDetectionStrategy) {
          return this.props.rowDataChangeDetectionStrategy;
        }
        if (this.isImmutableDataActive()) {
          return changeDetectionService.ChangeDetectionStrategyType.IdentityCheck;
        }
      }
      // all other cases will default to DeepValueCheck
      return changeDetectionService.ChangeDetectionStrategyType.DeepValueCheck;
    };
    AgGridReactUi.prototype.isImmutableDataActive = function () {
      return this.props.deltaRowDataMode || this.props.immutableData || this.props.gridOptions && (this.props.gridOptions.deltaRowDataMode || this.props.gridOptions.immutableData);
    };
    return AgGridReactUi;
  }(react_1.Component);
  exports.AgGridReactUi = AgGridReactUi;
  var ReactFrameworkComponentWrapper = /** @class */function (_super) {
    __extends(ReactFrameworkComponentWrapper, _super);
    function ReactFrameworkComponentWrapper(parent) {
      var _this = _super.call(this) || this;
      _this.parent = parent;
      return _this;
    }
    ReactFrameworkComponentWrapper.prototype.createWrapper = function (UserReactComponent, componentType) {
      return new newReactComponent.NewReactComponent(UserReactComponent, this.parent, componentType);
    };
    ReactFrameworkComponentWrapper.prototype.unwrap = function (comp) {
      if (comp && comp.getFrameworkComponentInstance) {
        return comp.getFrameworkComponentInstance();
      }
      return comp;
    };
    return ReactFrameworkComponentWrapper;
  }(main.BaseComponentWrapper);
});
unwrapExports(agGridReactUi);
var agGridReactUi_1 = agGridReactUi.AgGridReactUi;
var agGridReact = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics179 = function extendStatics(d, b) {
      _extendStatics179 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics179(d, b);
    };
    return function (d, b) {
      _extendStatics179(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var react_1 = __importStar(React__default);
  var AgGridReact = /** @class */function (_super) {
    __extends(AgGridReact, _super);
    function AgGridReact() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.setGridApi = function (api, columnApi) {
        _this.api = api;
        _this.columnApi = columnApi;
      };
      return _this;
    }
    AgGridReact.prototype.render = function () {
      if (this.props.reactUi) {
        return react_1.default.createElement(agGridReactUi.AgGridReactUi, __assign({}, this.props, {
          setGridApi: this.setGridApi
        }));
      }
      return react_1.default.createElement(agGridReactLegacy.AgGridReactLegacy, __assign({}, this.props, {
        setGridApi: this.setGridApi
      }));
    };
    return AgGridReact;
  }(react_1.Component);
  exports.AgGridReact = AgGridReact;
});
unwrapExports(agGridReact);
var agGridReact_1 = agGridReact.AgGridReact;
var AgGridReact = agGridReact.AgGridReact;
var AgGridColumn = agGridColumn.AgGridColumn;
var ChangeDetectionStrategyType = changeDetectionService.ChangeDetectionStrategyType;
var AgGridReactUi = agGridReactUi.AgGridReactUi;
var __spreadArrays$c = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ClientSideNodeManager = /** @class */function () {
  function ClientSideNodeManager(rootNode, gridOptionsWrapper, eventService, columnModel, gridApi, columnApi, selectionService, beans) {
    this.nextId = 0;
    // when user is provide the id's, we also keep a map of ids to row nodes for convenience
    this.allNodesMap = {};
    this.rootNode = rootNode;
    this.gridOptionsWrapper = gridOptionsWrapper;
    this.eventService = eventService;
    this.columnModel = columnModel;
    this.gridApi = gridApi;
    this.columnApi = columnApi;
    this.beans = beans;
    this.selectionService = selectionService;
    this.rootNode.group = true;
    this.rootNode.level = -1;
    this.rootNode.id = ClientSideNodeManager.ROOT_NODE_ID;
    this.rootNode.allLeafChildren = [];
    this.rootNode.childrenAfterGroup = [];
    this.rootNode.childrenAfterSort = [];
    this.rootNode.childrenAfterFilter = [];
    // if we make this class a bean, then can annotate postConstruct
    this.postConstruct();
  }
  // @PostConstruct - this is not a bean, so postConstruct called by constructor
  ClientSideNodeManager.prototype.postConstruct = function () {
    // func below doesn't have 'this' pointer, so need to pull out these bits
    this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
    this.isRowMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
    this.doingTreeData = this.gridOptionsWrapper.isTreeData();
    this.doingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
  };
  ClientSideNodeManager.prototype.getCopyOfNodesMap = function () {
    return _.cloneObject(this.allNodesMap);
  };
  ClientSideNodeManager.prototype.getRowNode = function (id) {
    return this.allNodesMap[id];
  };
  ClientSideNodeManager.prototype.setRowData = function (rowData) {
    var _this = this;
    if (typeof rowData === 'string') {
      console.warn('AG Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
      return;
    }
    var rootNode = this.rootNode;
    var sibling = this.rootNode.sibling;
    rootNode.childrenAfterFilter = null;
    rootNode.childrenAfterGroup = null;
    rootNode.childrenAfterSort = null;
    rootNode.childrenMapped = null;
    rootNode.updateHasChildren();
    this.nextId = 0;
    this.allNodesMap = {};
    if (rowData) {
      // we use rootNode as the parent, however if using ag-grid-enterprise, the grouping stage
      // sets the parent node on each row (even if we are not grouping). so setting parent node
      // here is for benefit of ag-grid-community users
      rootNode.allLeafChildren = rowData.map(function (dataItem) {
        return _this.createNode(dataItem, _this.rootNode, ClientSideNodeManager.TOP_LEVEL);
      });
    } else {
      rootNode.allLeafChildren = [];
      rootNode.childrenAfterGroup = [];
    }
    if (sibling) {
      sibling.childrenAfterFilter = rootNode.childrenAfterFilter;
      sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
      sibling.childrenAfterSort = rootNode.childrenAfterSort;
      sibling.childrenMapped = rootNode.childrenMapped;
      sibling.allLeafChildren = rootNode.allLeafChildren;
    }
  };
  ClientSideNodeManager.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
    var rowNodeTransaction = {
      remove: [],
      update: [],
      add: []
    };
    var nodesToUnselect = [];
    this.executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect);
    this.executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect);
    this.executeAdd(rowDataTran, rowNodeTransaction);
    this.updateSelection(nodesToUnselect);
    if (rowNodeOrder) {
      _.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
    }
    return rowNodeTransaction;
  };
  ClientSideNodeManager.prototype.updateSelection = function (nodesToUnselect) {
    var selectionChanged = nodesToUnselect.length > 0;
    if (selectionChanged) {
      nodesToUnselect.forEach(function (rowNode) {
        rowNode.setSelected(false, false, true);
      });
    }
    // we do this regardless of nodes to unselect or not, as it's possible
    // a new node was inserted, so a parent that was previously selected (as all
    // children were selected) should not be tri-state (as new one unselected against
    // all other selected children).
    this.selectionService.updateGroupsFromChildrenSelections();
    if (selectionChanged) {
      var event_1 = {
        type: Events.EVENT_SELECTION_CHANGED,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  ClientSideNodeManager.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
    var _this = this;
    var add = rowDataTran.add,
      addIndex = rowDataTran.addIndex;
    if (_.missingOrEmpty(add)) {
      return;
    }
    // create new row nodes for each data item
    var newNodes = add.map(function (item) {
      return _this.createNode(item, _this.rootNode, ClientSideNodeManager.TOP_LEVEL);
    });
    // add new row nodes to the root nodes 'allLeafChildren'
    var useIndex = typeof addIndex === 'number' && addIndex >= 0;
    if (useIndex) {
      // new rows are inserted in one go by concatenating them in between the existing rows at the desired index.
      // this is much faster than splicing them individually into 'allLeafChildren' when there are large inserts.
      var existingLeafChildren = this.rootNode.allLeafChildren;
      var nodesBeforeIndex = existingLeafChildren.slice(0, addIndex);
      var nodesAfterIndex = existingLeafChildren.slice(addIndex, existingLeafChildren.length);
      this.rootNode.allLeafChildren = __spreadArrays$c(nodesBeforeIndex, newNodes, nodesAfterIndex);
    } else {
      this.rootNode.allLeafChildren = __spreadArrays$c(this.rootNode.allLeafChildren, newNodes);
    }
    if (this.rootNode.sibling) {
      this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
    }
    // add new row nodes to the transaction add items
    rowNodeTransaction.add = newNodes;
  };
  ClientSideNodeManager.prototype.executeRemove = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
    var _this = this;
    var remove = rowDataTran.remove;
    if (_.missingOrEmpty(remove)) {
      return;
    }
    var rowIdsRemoved = {};
    remove.forEach(function (item) {
      var rowNode = _this.lookupRowNode(item);
      if (!rowNode) {
        return;
      }
      // do delete - setting 'suppressFinishActions = true' to ensure EVENT_SELECTION_CHANGED is not raised for
      // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
      if (rowNode.isSelected()) {
        nodesToUnselect.push(rowNode);
      }
      // so row renderer knows to fade row out (and not reposition it)
      rowNode.clearRowTopAndRowIndex();
      // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
      // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
      rowIdsRemoved[rowNode.id] = true;
      // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
      delete _this.allNodesMap[rowNode.id];
      rowNodeTransaction.remove.push(rowNode);
    });
    this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter(function (rowNode) {
      return !rowIdsRemoved[rowNode.id];
    });
    if (this.rootNode.sibling) {
      this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
    }
  };
  ClientSideNodeManager.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
    var _this = this;
    var update = rowDataTran.update;
    if (_.missingOrEmpty(update)) {
      return;
    }
    update.forEach(function (item) {
      var rowNode = _this.lookupRowNode(item);
      if (!rowNode) {
        return;
      }
      rowNode.updateData(item);
      if (!rowNode.selectable && rowNode.isSelected()) {
        nodesToUnselect.push(rowNode);
      }
      _this.setMasterForRow(rowNode, item, ClientSideNodeManager.TOP_LEVEL, false);
      rowNodeTransaction.update.push(rowNode);
    });
  };
  ClientSideNodeManager.prototype.lookupRowNode = function (data) {
    var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
    var rowNode;
    if (_.exists(rowNodeIdFunc)) {
      // find rowNode using id
      var id = rowNodeIdFunc(data);
      rowNode = this.allNodesMap[id];
      if (!rowNode) {
        console.error("AG Grid: could not find row id=" + id + ", data item was not found for this id");
        return null;
      }
    } else {
      // find rowNode using object references
      rowNode = _.find(this.rootNode.allLeafChildren, function (node) {
        return node.data === data;
      });
      if (!rowNode) {
        console.error("AG Grid: could not find data item as object was not found", data);
        console.error("Consider using getRowNodeId to help the Grid find matching row data");
        return null;
      }
    }
    return rowNode;
  };
  ClientSideNodeManager.prototype.createNode = function (dataItem, parent, level) {
    var node = new RowNode(this.beans);
    node.group = false;
    this.setMasterForRow(node, dataItem, level, true);
    if (parent && !this.suppressParentsInRowNodes) {
      node.parent = parent;
    }
    node.level = level;
    node.setDataAndId(dataItem, this.nextId.toString());
    if (this.allNodesMap[node.id]) {
      console.warn("ag-grid: duplicate node id '" + node.id + "' detected from getRowNodeId callback, this could cause issues in your grid.");
    }
    this.allNodesMap[node.id] = node;
    this.nextId++;
    return node;
  };
  ClientSideNodeManager.prototype.setMasterForRow = function (rowNode, data, level, setExpanded) {
    if (this.doingTreeData) {
      rowNode.setMaster(false);
      if (setExpanded) {
        rowNode.expanded = false;
      }
    } else {
      // this is the default, for when doing grid data
      if (this.doingMasterDetail) {
        // if we are doing master detail, then the
        // default is that everything can be a Master Row.
        if (this.isRowMasterFunc) {
          rowNode.setMaster(this.isRowMasterFunc(data));
        } else {
          rowNode.setMaster(true);
        }
      } else {
        rowNode.setMaster(false);
      }
      if (setExpanded) {
        var rowGroupColumns = this.columnModel.getRowGroupColumns();
        var numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
        // need to take row group into account when determining level
        var masterRowLevel = level + numRowGroupColumns;
        rowNode.expanded = rowNode.master ? this.isExpanded(masterRowLevel) : false;
      }
    }
  };
  ClientSideNodeManager.prototype.isExpanded = function (level) {
    var expandByDefault = this.gridOptionsWrapper.getGroupDefaultExpanded();
    if (expandByDefault === -1) {
      return true;
    }
    return level < expandByDefault;
  };
  ClientSideNodeManager.TOP_LEVEL = 0;
  ClientSideNodeManager.ROOT_NODE_ID = 'ROOT_NODE_ID';
  return ClientSideNodeManager;
}();
var __extends$2H = undefined && undefined.__extends || function () {
  var _extendStatics180 = function extendStatics(d, b) {
    _extendStatics180 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics180(d, b);
  };
  return function (d, b) {
    _extendStatics180(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2n = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RecursionType;
(function (RecursionType) {
  RecursionType[RecursionType["Normal"] = 0] = "Normal";
  RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
  RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
  RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
})(RecursionType || (RecursionType = {}));
var ClientSideRowModel = /** @class */function (_super) {
  __extends$2H(ClientSideRowModel, _super);
  function ClientSideRowModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ClientSideRowModel.prototype.init = function () {
    var refreshEverythingFunc = this.refreshModel.bind(this, {
      step: ClientSideRowModelSteps.EVERYTHING
    });
    var refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
      step: ClientSideRowModelSteps.EVERYTHING,
      afterColumnsChanged: true,
      keepRenderedRows: true,
      animate: true
    });
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refreshEverythingAfterColsChangedFunc);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, {
      step: ClientSideRowModelSteps.PIVOT
    }));
    this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
    var refreshMapListener = this.refreshModel.bind(this, {
      step: ClientSideRowModelSteps.MAP,
      keepRenderedRows: true,
      animate: true
    });
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_REMOVE_SINGLE_CHILDREN, refreshMapListener);
    this.addManagedListener(this.gridOptionsWrapper, GridOptionsWrapper.PROP_GROUP_REMOVE_LOWEST_SINGLE_CHILDREN, refreshMapListener);
    this.rootNode = new RowNode(this.beans);
    this.nodeManager = new ClientSideNodeManager(this.rootNode, this.gridOptionsWrapper, this.eventService, this.columnModel, this.gridApi, this.columnApi, this.selectionService, this.beans);
  };
  ClientSideRowModel.prototype.start = function () {
    var rowData = this.gridOptionsWrapper.getRowData();
    if (rowData) {
      this.setRowData(rowData);
    }
  };
  ClientSideRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
    var atLeastOneChange;
    var res = false;
    // we do this multiple times as changing the row heights can also change the first and last rows,
    // so the first pass can make lots of rows smaller, which means the second pass we end up changing
    // more rows.
    do {
      atLeastOneChange = false;
      var rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
      var rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
      // keep check to current page if doing pagination
      var firstRow = Math.max(rowAtStartPixel, startLimitIndex);
      var lastRow = Math.min(rowAtEndPixel, endLimitIndex);
      for (var rowIndex = firstRow; rowIndex <= lastRow; rowIndex++) {
        var rowNode = this.getRow(rowIndex);
        if (rowNode.rowHeightEstimated) {
          var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
          rowNode.setRowHeight(rowHeight.height);
          atLeastOneChange = true;
          res = true;
        }
      }
      if (atLeastOneChange) {
        this.setRowTopAndRowIndex();
      }
    } while (atLeastOneChange);
    return res;
  };
  ClientSideRowModel.prototype.setRowTopAndRowIndex = function () {
    var defaultRowHeight = this.gridOptionsWrapper.getDefaultRowHeight();
    var nextRowTop = 0;
    // mapping displayed rows is not needed for this method, however it's used in
    // clearRowTopAndRowIndex(), and given we are looping through this.rowsToDisplay here,
    // we create the map here for performance reasons, so we don't loop a second time
    // in clearRowTopAndRowIndex()
    var displayedRowsMapped = new Set();
    // we don't estimate if doing fullHeight or autoHeight, as all rows get rendered all the time
    // with these two layouts.
    var allowEstimate = this.gridOptionsWrapper.getDomLayout() === Constants.DOM_LAYOUT_NORMAL;
    for (var i = 0; i < this.rowsToDisplay.length; i++) {
      var rowNode = this.rowsToDisplay[i];
      if (rowNode.id != null) {
        displayedRowsMapped.add(rowNode.id);
      }
      if (rowNode.rowHeight == null) {
        var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode, allowEstimate, defaultRowHeight);
        rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
      }
      rowNode.setRowTop(nextRowTop);
      rowNode.setRowIndex(i);
      nextRowTop += rowNode.rowHeight;
    }
    return displayedRowsMapped;
  };
  ClientSideRowModel.prototype.clearRowTopAndRowIndex = function (changedPath, displayedRowsMapped) {
    var changedPathActive = changedPath.isActive();
    var clearIfNotDisplayed = function clearIfNotDisplayed(rowNode) {
      if (rowNode && rowNode.id != null && !displayedRowsMapped.has(rowNode.id)) {
        rowNode.clearRowTopAndRowIndex();
      }
    };
    var recurse = function recurse(rowNode) {
      clearIfNotDisplayed(rowNode);
      clearIfNotDisplayed(rowNode.detailNode);
      clearIfNotDisplayed(rowNode.sibling);
      if (rowNode.hasChildren()) {
        if (rowNode.childrenAfterGroup) {
          // if a changedPath is active, it means we are here because of a transaction update or
          // a change detection. neither of these impacts the open/closed state of groups. so if
          // a group is not open this time, it was not open last time. so we know all closed groups
          // already have their top positions cleared. so there is no need to traverse all the way
          // when changedPath is active and the rowNode is not expanded.
          var isRootNode = rowNode.level == -1; // we need to give special consideration for root node,
          // as expanded=undefined for root node
          var skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
          if (!skipChildren) {
            rowNode.childrenAfterGroup.forEach(recurse);
          }
        }
      }
    };
    recurse(this.rootNode);
  };
  // returns false if row was moved, otherwise true
  ClientSideRowModel.prototype.ensureRowsAtPixel = function (rowNodes, pixel, increment) {
    var _this = this;
    if (increment === void 0) {
      increment = 0;
    }
    var indexAtPixelNow = this.getRowIndexAtPixel(pixel);
    var rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
    if (rowNodeAtPixelNow === rowNodes[0]) {
      return false;
    }
    rowNodes.forEach(function (rowNode) {
      _.removeFromArray(_this.rootNode.allLeafChildren, rowNode);
    });
    rowNodes.forEach(function (rowNode, idx) {
      _.insertIntoArray(_this.rootNode.allLeafChildren, rowNode, Math.max(indexAtPixelNow + increment, 0) + idx);
    });
    this.refreshModel({
      step: ClientSideRowModelSteps.EVERYTHING,
      keepRenderedRows: true,
      animate: true,
      keepEditingRows: true
    });
    return true;
  };
  ClientSideRowModel.prototype.highlightRowAtPixel = function (rowNode, pixel) {
    var indexAtPixelNow = pixel != null ? this.getRowIndexAtPixel(pixel) : null;
    var rowNodeAtPixelNow = indexAtPixelNow != null ? this.getRow(indexAtPixelNow) : null;
    if (!rowNodeAtPixelNow || !rowNode || rowNodeAtPixelNow === rowNode || pixel == null) {
      if (this.lastHighlightedRow) {
        this.lastHighlightedRow.setHighlighted(null);
        this.lastHighlightedRow = null;
      }
      return;
    }
    var highlight = this.getHighlightPosition(pixel, rowNodeAtPixelNow);
    if (this.lastHighlightedRow && this.lastHighlightedRow !== rowNodeAtPixelNow) {
      this.lastHighlightedRow.setHighlighted(null);
      this.lastHighlightedRow = null;
    }
    rowNodeAtPixelNow.setHighlighted(highlight);
    this.lastHighlightedRow = rowNodeAtPixelNow;
  };
  ClientSideRowModel.prototype.getHighlightPosition = function (pixel, rowNode) {
    if (!rowNode) {
      var index = this.getRowIndexAtPixel(pixel);
      rowNode = this.getRow(index || 0);
      if (!rowNode) {
        return RowHighlightPosition.Below;
      }
    }
    var rowTop = rowNode.rowTop,
      rowHeight = rowNode.rowHeight;
    return pixel - rowTop < rowHeight / 2 ? RowHighlightPosition.Above : RowHighlightPosition.Below;
  };
  ClientSideRowModel.prototype.getLastHighlightedRowNode = function () {
    return this.lastHighlightedRow;
  };
  ClientSideRowModel.prototype.isLastRowIndexKnown = function () {
    return true;
  };
  ClientSideRowModel.prototype.getRowCount = function () {
    if (this.rowsToDisplay) {
      return this.rowsToDisplay.length;
    }
    return 0;
  };
  ClientSideRowModel.prototype.getTopLevelRowCount = function () {
    var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
    if (showingRootNode) {
      return 1;
    }
    return this.rootNode.childrenAfterFilter ? this.rootNode.childrenAfterFilter.length : 0;
  };
  ClientSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    var showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
    if (showingRootNode) {
      return topLevelIndex;
    }
    var rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
    if (this.gridOptionsWrapper.isGroupHideOpenParents()) {
      // if hideOpenParents, and this row open, then this row is now displayed at this index, first child is
      while (rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0) {
        rowNode = rowNode.childrenAfterSort[0];
      }
    }
    return rowNode.rowIndex;
  };
  ClientSideRowModel.prototype.getRowBounds = function (index) {
    if (_.missing(this.rowsToDisplay)) {
      return null;
    }
    var rowNode = this.rowsToDisplay[index];
    if (rowNode) {
      return {
        rowTop: rowNode.rowTop,
        rowHeight: rowNode.rowHeight
      };
    }
    return null;
  };
  ClientSideRowModel.prototype.onRowGroupOpened = function () {
    var animate = this.gridOptionsWrapper.isAnimateRows();
    this.refreshModel({
      step: ClientSideRowModelSteps.MAP,
      keepRenderedRows: true,
      animate: animate
    });
  };
  ClientSideRowModel.prototype.onFilterChanged = function (event) {
    if (event.afterDataChange) {
      return;
    }
    var animate = this.gridOptionsWrapper.isAnimateRows();
    this.refreshModel({
      step: ClientSideRowModelSteps.FILTER,
      keepRenderedRows: true,
      animate: animate
    });
  };
  ClientSideRowModel.prototype.onSortChanged = function () {
    var animate = this.gridOptionsWrapper.isAnimateRows();
    this.refreshModel({
      step: ClientSideRowModelSteps.SORT,
      keepRenderedRows: true,
      animate: animate,
      keepEditingRows: true
    });
  };
  ClientSideRowModel.prototype.getType = function () {
    return Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
  };
  ClientSideRowModel.prototype.onValueChanged = function () {
    if (this.columnModel.isPivotActive()) {
      this.refreshModel({
        step: ClientSideRowModelSteps.PIVOT
      });
    } else {
      this.refreshModel({
        step: ClientSideRowModelSteps.AGGREGATE
      });
    }
  };
  ClientSideRowModel.prototype.createChangePath = function (rowNodeTransactions) {
    // for updates, if the row is updated at all, then we re-calc all the values
    // in that row. we could compare each value to each old value, however if we
    // did this, we would be calling the valueService twice, once on the old value
    // and once on the new value. so it's less valueGetter calls if we just assume
    // each column is different. that way the changedPath is used so that only
    // the impacted parent rows are recalculated, parents who's children have
    // not changed are not impacted.
    var noTransactions = _.missingOrEmpty(rowNodeTransactions);
    var changedPath = new ChangedPath(false, this.rootNode);
    if (noTransactions || this.gridOptionsWrapper.isTreeData()) {
      changedPath.setInactive();
    }
    return changedPath;
  };
  ClientSideRowModel.prototype.isSuppressModelUpdateAfterUpdateTransaction = function (params) {
    if (!this.gridOptionsWrapper.isSuppressModelUpdateAfterUpdateTransaction()) {
      return false;
    }
    // return true if we are only doing update transactions
    if (params.rowNodeTransactions == null) {
      return false;
    }
    var transWithAddsOrDeletes = _.filter(params.rowNodeTransactions, function (tx) {
      return tx.add != null && tx.add.length > 0 || tx.remove != null && tx.remove.length > 0;
    });
    var transactionsContainUpdatesOnly = transWithAddsOrDeletes == null || transWithAddsOrDeletes.length == 0;
    return transactionsContainUpdatesOnly;
  };
  ClientSideRowModel.prototype.refreshModel = function (params) {
    var _this = this;
    if (this.isSuppressModelUpdateAfterUpdateTransaction(params)) {
      return;
    }
    // this goes through the pipeline of stages. what's in my head is similar
    // to the diagram on this page:
    // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
    // however we want to keep the results of each stage, hence we manually call
    // each step rather than have them chain each other.
    // fallthrough in below switch is on purpose,
    // eg if STEP_FILTER, then all steps below this
    // step get done
    // let start: number;
    // console.log('======= start =======');
    var changedPath = this.createChangePath(params.rowNodeTransactions);
    switch (params.step) {
      case ClientSideRowModelSteps.EVERYTHING:
        this.doRowGrouping(params.groupState, params.rowNodeTransactions, params.rowNodeOrder, changedPath, !!params.afterColumnsChanged);
      case ClientSideRowModelSteps.FILTER:
        this.doFilter(changedPath);
      case ClientSideRowModelSteps.PIVOT:
        this.doPivot(changedPath);
      case ClientSideRowModelSteps.AGGREGATE:
        // depends on agg fields
        this.doAggregate(changedPath);
      case ClientSideRowModelSteps.SORT:
        this.doSort(params.rowNodeTransactions, changedPath);
      case ClientSideRowModelSteps.MAP:
        this.doRowsToDisplay();
    }
    // set all row tops to null, then set row tops on all visible rows. if we don't
    // do this, then the algorithm below only sets row tops, old row tops from old rows
    // will still lie around
    var displayedNodesMapped = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
    var event = {
      type: Events.EVENT_MODEL_UPDATED,
      api: this.gridApi,
      columnApi: this.columnApi,
      animate: params.animate,
      keepRenderedRows: params.keepRenderedRows,
      newData: params.newData,
      newPage: false
    };
    this.eventService.dispatchEvent(event);
    if (this.$scope) {
      window.setTimeout(function () {
        _this.$scope.$apply();
      }, 0);
    }
  };
  ClientSideRowModel.prototype.isEmpty = function () {
    var rowsMissing = _.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
    return _.missing(this.rootNode) || rowsMissing || !this.columnModel.isReady();
  };
  ClientSideRowModel.prototype.isRowsToRender = function () {
    return _.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
  };
  ClientSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
    // if lastSelectedNode is missing, we start at the first row
    var firstRowHit = !lastInRange;
    var lastRowHit = false;
    var lastRow;
    var result = [];
    var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
    this.forEachNodeAfterFilterAndSort(function (rowNode) {
      var lookingForLastRow = firstRowHit && !lastRowHit;
      // check if we need to flip the select switch
      if (!firstRowHit) {
        if (rowNode === lastInRange || rowNode === firstInRange) {
          firstRowHit = true;
        }
      }
      var skipThisGroupNode = rowNode.group && groupsSelectChildren;
      if (!skipThisGroupNode) {
        var inRange = firstRowHit && !lastRowHit;
        var childOfLastRow = rowNode.isParentOfNode(lastRow);
        if (inRange || childOfLastRow) {
          result.push(rowNode);
        }
      }
      if (lookingForLastRow) {
        if (rowNode === lastInRange || rowNode === firstInRange) {
          lastRowHit = true;
          if (rowNode === lastInRange) {
            lastRow = lastInRange;
          } else {
            lastRow = firstInRange;
          }
        }
      }
    });
    return result;
  };
  ClientSideRowModel.prototype.setDatasource = function (datasource) {
    console.error('AG Grid: should never call setDatasource on clientSideRowController');
  };
  ClientSideRowModel.prototype.getTopLevelNodes = function () {
    return this.rootNode ? this.rootNode.childrenAfterGroup : null;
  };
  ClientSideRowModel.prototype.getRootNode = function () {
    return this.rootNode;
  };
  ClientSideRowModel.prototype.getRow = function (index) {
    return this.rowsToDisplay[index];
  };
  ClientSideRowModel.prototype.isRowPresent = function (rowNode) {
    return this.rowsToDisplay.indexOf(rowNode) >= 0;
  };
  ClientSideRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
    if (this.isEmpty()) {
      return -1;
    }
    // do binary search of tree
    // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
    var bottomPointer = 0;
    var topPointer = this.rowsToDisplay.length - 1;
    // quick check, if the pixel is out of bounds, then return last row
    if (pixelToMatch <= 0) {
      // if pixel is less than or equal zero, it's always the first row
      return 0;
    }
    var lastNode = _.last(this.rowsToDisplay);
    if (lastNode.rowTop <= pixelToMatch) {
      return this.rowsToDisplay.length - 1;
    }
    while (true) {
      var midPointer = Math.floor((bottomPointer + topPointer) / 2);
      var currentRowNode = this.rowsToDisplay[midPointer];
      if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
        return midPointer;
      }
      if (currentRowNode.rowTop < pixelToMatch) {
        bottomPointer = midPointer + 1;
      } else if (currentRowNode.rowTop > pixelToMatch) {
        topPointer = midPointer - 1;
      }
    }
  };
  ClientSideRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
    var topPixel = rowNode.rowTop;
    var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
    var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
    return pixelInRow;
  };
  ClientSideRowModel.prototype.forEachLeafNode = function (callback) {
    if (this.rootNode.allLeafChildren) {
      this.rootNode.allLeafChildren.forEach(function (rowNode, index) {
        return callback(rowNode, index);
      });
    }
  };
  ClientSideRowModel.prototype.forEachNode = function (callback) {
    this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
  };
  ClientSideRowModel.prototype.forEachNodeAfterFilter = function (callback) {
    this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
  };
  ClientSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
    this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
  };
  ClientSideRowModel.prototype.forEachPivotNode = function (callback) {
    this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
  };
  // iterates through each item in memory, and calls the callback function
  // nodes - the rowNodes to traverse
  // callback - the user provided callback
  // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
  // index - works similar to the index in forEach in javascript's array function
  ClientSideRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
    if (!nodes) {
      return index;
    }
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      callback(node, index++);
      // go to the next level if it is a group
      if (node.hasChildren()) {
        // depending on the recursion type, we pick a difference set of children
        var nodeChildren = null;
        switch (recursionType) {
          case RecursionType.Normal:
            nodeChildren = node.childrenAfterGroup;
            break;
          case RecursionType.AfterFilter:
            nodeChildren = node.childrenAfterFilter;
            break;
          case RecursionType.AfterFilterAndSort:
            nodeChildren = node.childrenAfterSort;
            break;
          case RecursionType.PivotNodes:
            // for pivot, we don't go below leafGroup levels
            nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
            break;
        }
        if (nodeChildren) {
          index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
        }
      }
    }
    return index;
  };
  // it's possible to recompute the aggregate without doing the other parts
  // + gridApi.recomputeAggregates()
  ClientSideRowModel.prototype.doAggregate = function (changedPath) {
    if (this.aggregationStage) {
      this.aggregationStage.execute({
        rowNode: this.rootNode,
        changedPath: changedPath
      });
    }
  };
  // + gridApi.expandAll()
  // + gridApi.collapseAll()
  ClientSideRowModel.prototype.expandOrCollapseAll = function (expand) {
    var usingTreeData = this.gridOptionsWrapper.isTreeData();
    if (this.rootNode) {
      recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
    }
    function recursiveExpandOrCollapse(rowNodes) {
      if (!rowNodes) {
        return;
      }
      rowNodes.forEach(function (rowNode) {
        var shouldExpandOrCollapse = usingTreeData ? _.exists(rowNode.childrenAfterGroup) : rowNode.group;
        if (shouldExpandOrCollapse) {
          rowNode.expanded = expand;
          recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
        }
      });
    }
    this.refreshModel({
      step: ClientSideRowModelSteps.MAP
    });
    var eventSource = expand ? 'expandAll' : 'collapseAll';
    var event = {
      api: this.gridApi,
      columnApi: this.columnApi,
      type: Events.EVENT_EXPAND_COLLAPSE_ALL,
      source: eventSource
    };
    this.eventService.dispatchEvent(event);
  };
  ClientSideRowModel.prototype.doSort = function (rowNodeTransactions, changedPath) {
    this.sortStage.execute({
      rowNode: this.rootNode,
      rowNodeTransactions: rowNodeTransactions,
      changedPath: changedPath
    });
  };
  ClientSideRowModel.prototype.doRowGrouping = function (groupState, rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
    if (this.groupStage) {
      if (rowNodeTransactions) {
        this.groupStage.execute({
          rowNode: this.rootNode,
          rowNodeTransactions: rowNodeTransactions,
          rowNodeOrder: rowNodeOrder,
          changedPath: changedPath
        });
      } else {
        this.groupStage.execute({
          rowNode: this.rootNode,
          changedPath: changedPath,
          afterColumnsChanged: afterColumnsChanged
        });
        // set open/closed state on groups
        this.restoreGroupState(groupState);
      }
      if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
        this.selectionService.updateGroupsFromChildrenSelections(changedPath);
      }
    } else {
      this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
      if (this.rootNode.sibling) {
        this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup;
      }
      this.rootNode.updateHasChildren();
    }
  };
  ClientSideRowModel.prototype.restoreGroupState = function (groupState) {
    if (!groupState) {
      return;
    }
    _.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
      // if the group was open last time, then open it this time. however
      // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
      // setting will take effect.
      if (typeof groupState[key] === 'boolean') {
        node.expanded = groupState[key];
      }
    });
  };
  ClientSideRowModel.prototype.doFilter = function (changedPath) {
    this.filterStage.execute({
      rowNode: this.rootNode,
      changedPath: changedPath
    });
  };
  ClientSideRowModel.prototype.doPivot = function (changedPath) {
    if (this.pivotStage) {
      this.pivotStage.execute({
        rowNode: this.rootNode,
        changedPath: changedPath
      });
    }
  };
  ClientSideRowModel.prototype.getGroupState = function () {
    if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
      return null;
    }
    var result = {};
    _.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
      return result[key] = node.expanded;
    });
    return result;
  };
  ClientSideRowModel.prototype.getCopyOfNodesMap = function () {
    return this.nodeManager.getCopyOfNodesMap();
  };
  ClientSideRowModel.prototype.getRowNode = function (id) {
    // although id is typed a string, this could be called by the user, and they could have passed a number
    var idIsGroup = typeof id == 'string' && id.indexOf(RowNode.ID_PREFIX_ROW_GROUP) == 0;
    if (idIsGroup) {
      // only one users complained about getRowNode not working for groups, after years of
      // this working for normal rows. so have done quick implementation. if users complain
      // about performance, then GroupStage should store / manage created groups in a map,
      // which is a chunk of work.
      var res_1 = undefined;
      this.forEachNode(function (node) {
        if (node.id === id) {
          res_1 = node;
        }
      });
      return res_1;
    } else {
      return this.nodeManager.getRowNode(id);
    }
  };
  // rows: the rows to put into the model
  ClientSideRowModel.prototype.setRowData = function (rowData) {
    // no need to invalidate cache, as the cache is stored on the rowNode,
    // so new rowNodes means the cache is wiped anyway.
    // remember group state, so we can expand groups that should be expanded
    var groupState = this.getGroupState();
    this.nodeManager.setRowData(rowData);
    // this event kicks off:
    // - clears selection
    // - updates filters
    // - shows 'no rows' overlay if needed
    var rowDataChangedEvent = {
      type: Events.EVENT_ROW_DATA_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(rowDataChangedEvent);
    this.refreshModel({
      step: ClientSideRowModelSteps.EVERYTHING,
      groupState: groupState,
      newData: true
    });
  };
  ClientSideRowModel.prototype.batchUpdateRowData = function (rowDataTransaction, callback) {
    var _this = this;
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      var waitMillis = this.gridOptionsWrapper.getAsyncTransactionWaitMillis();
      this.applyAsyncTransactionsTimeout = window.setTimeout(function () {
        _this.executeBatchUpdateRowData();
      }, waitMillis);
    }
    this.rowDataTransactionBatch.push({
      rowDataTransaction: rowDataTransaction,
      callback: callback
    });
  };
  ClientSideRowModel.prototype.flushAsyncTransactions = function () {
    if (this.applyAsyncTransactionsTimeout != null) {
      clearTimeout(this.applyAsyncTransactionsTimeout);
      this.executeBatchUpdateRowData();
    }
  };
  ClientSideRowModel.prototype.executeBatchUpdateRowData = function () {
    var _this = this;
    this.valueCache.onDataChanged();
    var callbackFuncsBound = [];
    var rowNodeTrans = [];
    // The rowGroup stage uses rowNodeOrder if order was provided. if we didn't pass 'true' to
    // commonUpdateRowData, using addIndex would have no effect when grouping.
    var forceRowNodeOrder = false;
    if (this.rowDataTransactionBatch) {
      this.rowDataTransactionBatch.forEach(function (tranItem) {
        var rowNodeTran = _this.nodeManager.updateRowData(tranItem.rowDataTransaction, undefined);
        rowNodeTrans.push(rowNodeTran);
        if (tranItem.callback) {
          callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
        }
        if (typeof tranItem.rowDataTransaction.addIndex === 'number') {
          forceRowNodeOrder = true;
        }
      });
    }
    this.commonUpdateRowData(rowNodeTrans, undefined, forceRowNodeOrder);
    // do callbacks in next VM turn so it's async
    if (callbackFuncsBound.length > 0) {
      window.setTimeout(function () {
        callbackFuncsBound.forEach(function (func) {
          return func();
        });
      }, 0);
    }
    if (rowNodeTrans.length > 0) {
      var event_1 = {
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        type: Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
        results: rowNodeTrans
      };
      this.eventService.dispatchEvent(event_1);
    }
    this.rowDataTransactionBatch = null;
    this.applyAsyncTransactionsTimeout = undefined;
  };
  ClientSideRowModel.prototype.updateRowData = function (rowDataTran, rowNodeOrder) {
    this.valueCache.onDataChanged();
    var rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
    // if doing immutableData, addIndex is never present. however if doing standard transaction, and user
    // provided addIndex, then this is used in updateRowData. However if doing Enterprise, then the rowGroup
    // stage also uses the
    var forceRowNodeOrder = typeof rowDataTran.addIndex === 'number';
    this.commonUpdateRowData([rowNodeTran], rowNodeOrder, forceRowNodeOrder);
    return rowNodeTran;
  };
  ClientSideRowModel.prototype.createRowNodeOrder = function () {
    var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
    if (suppressSortOrder) {
      return;
    }
    var orderMap = {};
    if (this.rootNode && this.rootNode.allLeafChildren) {
      for (var index = 0; index < this.rootNode.allLeafChildren.length; index++) {
        var node = this.rootNode.allLeafChildren[index];
        orderMap[node.id] = index;
      }
    }
    return orderMap;
  };
  // common to updateRowData and batchUpdateRowData
  ClientSideRowModel.prototype.commonUpdateRowData = function (rowNodeTrans, rowNodeOrder, forceRowNodeOrder) {
    if (forceRowNodeOrder) {
      rowNodeOrder = this.createRowNodeOrder();
    }
    this.refreshModel({
      step: ClientSideRowModelSteps.EVERYTHING,
      rowNodeTransactions: rowNodeTrans,
      rowNodeOrder: rowNodeOrder,
      keepRenderedRows: true,
      animate: true,
      keepEditingRows: true
    });
    var event = {
      type: Events.EVENT_ROW_DATA_UPDATED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(event);
  };
  ClientSideRowModel.prototype.doRowsToDisplay = function () {
    this.rowsToDisplay = this.flattenStage.execute({
      rowNode: this.rootNode
    });
  };
  ClientSideRowModel.prototype.onRowHeightChanged = function () {
    this.refreshModel({
      step: ClientSideRowModelSteps.MAP,
      keepRenderedRows: true,
      keepEditingRows: true
    });
  };
  ClientSideRowModel.prototype.resetRowHeights = function () {
    var atLeastOne = false;
    this.forEachNode(function (rowNode) {
      rowNode.setRowHeight(rowNode.rowHeight, true);
      // we keep the height each row is at, however we set estimated=true rather than clear the height.
      // this means the grid will not reset the row heights back to defaults, rather it will re-calc
      // the height for each row as the row is displayed. otherwise the scroll will jump when heights are reset.
      var detailNode = rowNode.detailNode;
      if (detailNode) {
        detailNode.setRowHeight(detailNode.rowHeight, true);
      }
      atLeastOne = true;
    });
    if (atLeastOne) {
      this.onRowHeightChanged();
    }
  };
  __decorate$2n([Autowired('columnModel')], ClientSideRowModel.prototype, "columnModel", void 0);
  __decorate$2n([Autowired('$scope')], ClientSideRowModel.prototype, "$scope", void 0);
  __decorate$2n([Autowired('selectionService')], ClientSideRowModel.prototype, "selectionService", void 0);
  __decorate$2n([Autowired('valueCache')], ClientSideRowModel.prototype, "valueCache", void 0);
  __decorate$2n([Autowired('columnApi')], ClientSideRowModel.prototype, "columnApi", void 0);
  __decorate$2n([Autowired('gridApi')], ClientSideRowModel.prototype, "gridApi", void 0);
  __decorate$2n([Autowired('animationFrameService')], ClientSideRowModel.prototype, "animationFrameService", void 0);
  __decorate$2n([Autowired('beans')], ClientSideRowModel.prototype, "beans", void 0);
  __decorate$2n([Autowired('filterStage')], ClientSideRowModel.prototype, "filterStage", void 0);
  __decorate$2n([Autowired('sortStage')], ClientSideRowModel.prototype, "sortStage", void 0);
  __decorate$2n([Autowired('flattenStage')], ClientSideRowModel.prototype, "flattenStage", void 0);
  __decorate$2n([Optional('groupStage')], ClientSideRowModel.prototype, "groupStage", void 0);
  __decorate$2n([Optional('aggregationStage')], ClientSideRowModel.prototype, "aggregationStage", void 0);
  __decorate$2n([Optional('pivotStage')], ClientSideRowModel.prototype, "pivotStage", void 0);
  __decorate$2n([PostConstruct], ClientSideRowModel.prototype, "init", null);
  ClientSideRowModel = __decorate$2n([Bean('rowModel')], ClientSideRowModel);
  return ClientSideRowModel;
}(BeanStub);
var __extends$2I = undefined && undefined.__extends || function () {
  var _extendStatics181 = function extendStatics(d, b) {
    _extendStatics181 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics181(d, b);
  };
  return function (d, b) {
    _extendStatics181(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2o = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterStage = /** @class */function (_super) {
  __extends$2I(FilterStage, _super);
  function FilterStage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FilterStage.prototype.execute = function (params) {
    var rowNode = params.rowNode,
      changedPath = params.changedPath;
    this.filterService.filter(changedPath);
    this.selectableService.updateSelectableAfterFiltering(rowNode);
  };
  __decorate$2o([Autowired('selectableService')], FilterStage.prototype, "selectableService", void 0);
  __decorate$2o([Autowired('filterService')], FilterStage.prototype, "filterService", void 0);
  FilterStage = __decorate$2o([Bean('filterStage')], FilterStage);
  return FilterStage;
}(BeanStub);
var __extends$2J = undefined && undefined.__extends || function () {
  var _extendStatics182 = function extendStatics(d, b) {
    _extendStatics182 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics182(d, b);
  };
  return function (d, b) {
    _extendStatics182(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2p = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SortStage = /** @class */function (_super) {
  __extends$2J(SortStage, _super);
  function SortStage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SortStage.prototype.execute = function (params) {
    var sortOptions = this.sortController.getSortOptions();
    var sortActive = _.exists(sortOptions) && sortOptions.length > 0;
    var deltaSort = sortActive && _.exists(params.rowNodeTransactions)
    // in time we can remove this check, so that delta sort is always
    // on if transactions are present. it's off for now so that we can
    // selectively turn it on and test it with some select users before
    // rolling out to everyone.
    && this.gridOptionsWrapper.isDeltaSort();
    // we only need dirty nodes if doing delta sort
    var dirtyLeafNodes = deltaSort ? this.calculateDirtyNodes(params.rowNodeTransactions) : null;
    var noAggregations = _.missingOrEmpty(this.columnModel.getValueColumns());
    var sortContainsGroupColumns = _.some(sortOptions, function (opt) {
      return !!opt.column.getColDef().showRowGroup;
    });
    this.sortService.sort(sortOptions, sortActive, deltaSort, dirtyLeafNodes, params.changedPath, noAggregations, sortContainsGroupColumns);
  };
  SortStage.prototype.calculateDirtyNodes = function (rowNodeTransactions) {
    var dirtyNodes = {};
    var addNodesFunc = function addNodesFunc(rowNodes) {
      if (rowNodes) {
        rowNodes.forEach(function (rowNode) {
          return dirtyNodes[rowNode.id] = true;
        });
      }
    };
    // all leaf level nodes in the transaction were impacted
    if (rowNodeTransactions) {
      rowNodeTransactions.forEach(function (tran) {
        addNodesFunc(tran.add);
        addNodesFunc(tran.update);
        addNodesFunc(tran.remove);
      });
    }
    return dirtyNodes;
  };
  __decorate$2p([Autowired('sortService')], SortStage.prototype, "sortService", void 0);
  __decorate$2p([Autowired('sortController')], SortStage.prototype, "sortController", void 0);
  __decorate$2p([Autowired('columnModel')], SortStage.prototype, "columnModel", void 0);
  SortStage = __decorate$2p([Bean('sortStage')], SortStage);
  return SortStage;
}(BeanStub);
var __extends$2K = undefined && undefined.__extends || function () {
  var _extendStatics183 = function extendStatics(d, b) {
    _extendStatics183 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics183(d, b);
  };
  return function (d, b) {
    _extendStatics183(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FlattenStage = /** @class */function (_super) {
  __extends$2K(FlattenStage, _super);
  function FlattenStage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FlattenStage.prototype.execute = function (params) {
    var rootNode = params.rowNode;
    // even if not doing grouping, we do the mapping, as the client might
    // of passed in data that already has a grouping in it somewhere
    var result = [];
    // putting value into a wrapper so it's passed by reference
    var nextRowTop = {
      value: 0
    };
    var skipLeafNodes = this.columnModel.isPivotMode();
    // if we are reducing, and not grouping, then we want to show the root node, as that
    // is where the pivot values are
    var showRootNode = skipLeafNodes && rootNode.leafGroup;
    var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
    this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, skipLeafNodes, 0);
    // we do not want the footer total if the gris is empty
    var atLeastOneRowPresent = result.length > 0;
    var includeGroupTotalFooter = !showRootNode
    // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
    && atLeastOneRowPresent && this.gridOptionsWrapper.isGroupIncludeTotalFooter();
    if (includeGroupTotalFooter) {
      this.ensureFooterNodeExists(rootNode);
      this.addRowNodeToRowsToDisplay(rootNode.sibling, result, nextRowTop, 0);
    }
    return result;
  };
  FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, skipLeafNodes, uiLevel) {
    if (_.missingOrEmpty(rowsToFlatten)) {
      return;
    }
    var hideOpenParents = this.gridOptionsWrapper.isGroupHideOpenParents();
    // these two are mutually exclusive, so if first set, we don't set the second
    var groupRemoveSingleChildren = this.gridOptionsWrapper.isGroupRemoveSingleChildren();
    var groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
    for (var i = 0; i < rowsToFlatten.length; i++) {
      var rowNode = rowsToFlatten[i];
      // check all these cases, for working out if this row should be included in the final mapped list
      var isParent = rowNode.hasChildren();
      var isSkippedLeafNode = skipLeafNodes && !isParent;
      var isRemovedSingleChildrenGroup = groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
      var isRemovedLowestSingleChildrenGroup = groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
      // hide open parents means when group is open, we don't show it. we also need to make sure the
      // group is expandable in the first place (as leaf groups are not expandable if pivot mode is on).
      // the UI will never allow expanding leaf  groups, however the user might via the API (or menu option 'expand all')
      var neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
      var isHiddenOpenParent = hideOpenParents && rowNode.expanded && !neverAllowToExpand;
      var thisRowShouldBeRendered = !isSkippedLeafNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
      if (thisRowShouldBeRendered) {
        this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop, uiLevel);
      }
      // if we are pivoting, we never map below the leaf group
      if (skipLeafNodes && rowNode.leafGroup) {
        continue;
      }
      if (isParent) {
        var excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
        // we traverse the group if it is expended, however we always traverse if the parent node
        // was removed (as the group will never be opened if it is not displayed, we show the children instead)
        if (rowNode.expanded || excludedParent) {
          // if the parent was excluded, then ui level is that of the parent
          var uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
          this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, skipLeafNodes, uiLevelForChildren);
          // put a footer in if user is looking for it
          if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
            this.ensureFooterNodeExists(rowNode);
            this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop, uiLevel);
          }
        }
      } else if (rowNode.master && rowNode.expanded) {
        var detailNode = this.createDetailNode(rowNode);
        this.addRowNodeToRowsToDisplay(detailNode, result, nextRowTop, uiLevel);
      }
    }
  };
  // duplicated method, it's also in floatingRowModel
  FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop, uiLevel) {
    var isGroupMultiAutoColumn = this.gridOptionsWrapper.isGroupMultiAutoColumn();
    result.push(rowNode);
    rowNode.setUiLevel(isGroupMultiAutoColumn ? 0 : uiLevel);
  };
  FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
    // only create footer node once, otherwise we have daemons and
    // the animate screws up with the daemons hanging around
    if (_.exists(groupNode.sibling)) {
      return;
    }
    var footerNode = new RowNode(this.beans);
    Object.keys(groupNode).forEach(function (key) {
      footerNode[key] = groupNode[key];
    });
    footerNode.footer = true;
    footerNode.setRowTop(null);
    footerNode.setRowIndex(null);
    // manually set oldRowTop to null so we discard any
    // previous information about its position.
    footerNode.oldRowTop = null;
    if (_.exists(footerNode.id)) {
      footerNode.id = 'rowGroupFooter_' + footerNode.id;
    }
    // get both header and footer to reference each other as siblings. this is never undone,
    // only overwritten. so if a group is expanded, then contracted, it will have a ghost
    // sibling - but that's fine, as we can ignore this if the header is contracted.
    footerNode.sibling = groupNode;
    groupNode.sibling = footerNode;
  };
  FlattenStage.prototype.createDetailNode = function (masterNode) {
    if (_.exists(masterNode.detailNode)) {
      return masterNode.detailNode;
    }
    var detailNode = new RowNode(this.beans);
    detailNode.detail = true;
    detailNode.selectable = false;
    detailNode.parent = masterNode;
    if (_.exists(masterNode.id)) {
      detailNode.id = 'detail_' + masterNode.id;
    }
    detailNode.data = masterNode.data;
    detailNode.level = masterNode.level + 1;
    masterNode.detailNode = detailNode;
    return detailNode;
  };
  __decorate$2q([Autowired('columnModel')], FlattenStage.prototype, "columnModel", void 0);
  __decorate$2q([Autowired('beans')], FlattenStage.prototype, "beans", void 0);
  FlattenStage = __decorate$2q([Bean('flattenStage')], FlattenStage);
  return FlattenStage;
}(BeanStub);
var __extends$2L = undefined && undefined.__extends || function () {
  var _extendStatics184 = function extendStatics(d, b) {
    _extendStatics184 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics184(d, b);
  };
  return function (d, b) {
    _extendStatics184(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2r = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SortService = /** @class */function (_super) {
  __extends$2L(SortService, _super);
  function SortService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SortService.prototype.init = function () {
    this.postSortFunc = this.gridOptionsWrapper.getPostSortFunc();
  };
  SortService.prototype.sort = function (sortOptions, sortActive, deltaSort, dirtyLeafNodes, changedPath, noAggregations, sortContainsGroupColumns) {
    var _this = this;
    var groupMaintainOrder = this.gridOptionsWrapper.isGroupMaintainOrder();
    var groupColumnsPresent = _.some(this.columnModel.getAllGridColumns(), function (c) {
      return c.isRowGroupActive();
    });
    var callback = function callback(rowNode) {
      // we clear out the 'pull down open parents' first, as the values mix up the sorting
      _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterFilter, true);
      // Javascript sort is non deterministic when all the array items are equals, ie Comparator always returns 0,
      // so to ensure the array keeps its order, add an additional sorting condition manually, in this case we
      // are going to inspect the original array position. This is what sortedRowNodes is for.
      if (sortActive) {
        // when 'groupMaintainOrder' is enabled we skip sorting groups unless we are sorting on group columns
        var skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup && !sortContainsGroupColumns;
        if (skipSortingGroups) {
          rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
        } else {
          rowNode.childrenAfterSort = deltaSort ? _this.doDeltaSort(rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations) : _this.rowNodeSorter.doFullSort(rowNode.childrenAfterFilter, sortOptions);
        }
      } else {
        rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
      }
      if (rowNode.sibling) {
        rowNode.sibling.childrenAfterSort = rowNode.childrenAfterSort;
      }
      _this.updateChildIndexes(rowNode);
      if (_this.postSortFunc) {
        _this.postSortFunc(rowNode.childrenAfterSort);
      }
    };
    if (changedPath) {
      changedPath.forEachChangedNodeDepthFirst(callback);
    }
    this.updateGroupDataForHideOpenParents(changedPath);
  };
  SortService.prototype.mapNodeToSortedNode = function (rowNode, pos) {
    return {
      currentPos: pos,
      rowNode: rowNode
    };
  };
  SortService.prototype.doDeltaSort = function (rowNode, sortOptions, dirtyLeafNodes, changedPath, noAggregations) {
    // clean nodes will be a list of all row nodes that remain in the set
    // and ordered. we start with the old sorted set and take out any nodes
    // that were removed or changed (but not added, added doesn't make sense,
    // if a node was added, there is no way it could be here from last time).
    var cleanNodes = rowNode.childrenAfterSort.filter(function (node) {
      // take out all nodes that were changed as part of the current transaction.
      // a changed node could a) be in a different sort position or b) may
      // no longer be in this set as the changed node may not pass filtering,
      // or be in a different group.
      var passesDirtyNodesCheck = !dirtyLeafNodes[node.id];
      // also remove group nodes in the changed path, as they can have different aggregate
      // values which could impact the sort order.
      // note: changed path is not active if a) no value columns or b) no transactions. it is never
      // (b) in deltaSort as we only do deltaSort for transactions. for (a) if no value columns, then
      // there is no value in the group that could of changed (ie no aggregate values)
      var passesChangedPathCheck = noAggregations || changedPath && changedPath.canSkip(node);
      return passesDirtyNodesCheck && passesChangedPathCheck;
    }).map(this.mapNodeToSortedNode.bind(this));
    // for fast access below, we map them
    var cleanNodesMapped = {};
    cleanNodes.forEach(function (sortedRowNode) {
      return cleanNodesMapped[sortedRowNode.rowNode.id] = sortedRowNode.rowNode;
    });
    // these are all nodes that need to be placed
    var changedNodes = rowNode.childrenAfterFilter
    // ignore nodes in the clean list
    .filter(function (node) {
      return !cleanNodesMapped[node.id];
    }).map(this.mapNodeToSortedNode.bind(this));
    // sort changed nodes. note that we don't need to sort cleanNodes as they are
    // already sorted from last time.
    changedNodes.sort(this.rowNodeSorter.compareRowNodes.bind(this, sortOptions));
    var result;
    if (changedNodes.length === 0) {
      result = cleanNodes;
    } else if (cleanNodes.length === 0) {
      result = changedNodes;
    } else {
      result = this.mergeSortedArrays(sortOptions, cleanNodes, changedNodes);
    }
    return result.map(function (item) {
      return item.rowNode;
    });
  };
  // Merge two sorted arrays into each other
  SortService.prototype.mergeSortedArrays = function (sortOptions, arr1, arr2) {
    var res = [];
    var i = 0;
    var j = 0;
    // Traverse both array, adding them in order
    while (i < arr1.length && j < arr2.length) {
      // Check if current element of first
      // array is smaller than current element
      // of second array. If yes, store first
      // array element and increment first array
      // index. Otherwise do same with second array
      var compareResult = this.rowNodeSorter.compareRowNodes(sortOptions, arr1[i], arr2[j]);
      if (compareResult < 0) {
        res.push(arr1[i++]);
      } else {
        res.push(arr2[j++]);
      }
    }
    // add remaining from arr1
    while (i < arr1.length) {
      res.push(arr1[i++]);
    }
    // add remaining from arr2
    while (j < arr2.length) {
      res.push(arr2[j++]);
    }
    return res;
  };
  SortService.prototype.updateChildIndexes = function (rowNode) {
    if (_.missing(rowNode.childrenAfterSort)) {
      return;
    }
    var listToSort = rowNode.childrenAfterSort;
    for (var i = 0; i < listToSort.length; i++) {
      var child = listToSort[i];
      var firstChild = i === 0;
      var lastChild = i === rowNode.childrenAfterSort.length - 1;
      child.setFirstChild(firstChild);
      child.setLastChild(lastChild);
      child.setChildIndex(i);
    }
  };
  SortService.prototype.updateGroupDataForHideOpenParents = function (changedPath) {
    var _this = this;
    if (!this.gridOptionsWrapper.isGroupHideOpenParents()) {
      return;
    }
    if (this.gridOptionsWrapper.isTreeData()) {
      var msg_1 = "AG Grid: The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them (as opposed to Row Grouping, which only has Aggregated Values at the group level).";
      _.doOnce(function () {
        return console.warn(msg_1);
      }, 'sortService.hideOpenParentsWithTreeData');
      return false;
    }
    // recurse breadth first over group nodes after sort to 'pull down' group data to child groups
    var callback = function callback(rowNode) {
      _this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
      rowNode.childrenAfterSort.forEach(function (child) {
        if (child.hasChildren()) {
          callback(child);
        }
      });
    };
    if (changedPath) {
      changedPath.executeFromRootNode(function (rowNode) {
        return callback(rowNode);
      });
    }
  };
  SortService.prototype.pullDownGroupDataForHideOpenParents = function (rowNodes, clearOperation) {
    var _this = this;
    if (!this.gridOptionsWrapper.isGroupHideOpenParents() || _.missing(rowNodes)) {
      return;
    }
    rowNodes.forEach(function (childRowNode) {
      var groupDisplayCols = _this.columnModel.getGroupDisplayColumns();
      groupDisplayCols.forEach(function (groupDisplayCol) {
        var showRowGroup = groupDisplayCol.getColDef().showRowGroup;
        if (typeof showRowGroup !== 'string') {
          console.error('AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup');
          return;
        }
        var displayingGroupKey = showRowGroup;
        var rowGroupColumn = _this.columnModel.getPrimaryColumn(displayingGroupKey);
        var thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
        if (thisRowNodeMatches) {
          return;
        }
        if (clearOperation) {
          // if doing a clear operation, we clear down the value for every possible group column
          childRowNode.setGroupValue(groupDisplayCol.getId(), undefined);
        } else {
          // if doing a set operation, we set only where the pull down is to occur
          var parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
          if (parentToStealFrom) {
            childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
          }
        }
      });
    });
  };
  __decorate$2r([Autowired('columnModel')], SortService.prototype, "columnModel", void 0);
  __decorate$2r([Autowired('rowNodeSorter')], SortService.prototype, "rowNodeSorter", void 0);
  __decorate$2r([PostConstruct], SortService.prototype, "init", null);
  SortService = __decorate$2r([Bean('sortService')], SortService);
  return SortService;
}(BeanStub);
var __extends$2M = undefined && undefined.__extends || function () {
  var _extendStatics185 = function extendStatics(d, b) {
    _extendStatics185 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics185(d, b);
  };
  return function (d, b) {
    _extendStatics185(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2s = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterService = /** @class */function (_super) {
  __extends$2M(FilterService, _super);
  function FilterService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FilterService.prototype.postConstruct = function () {
    this.doingTreeData = this.gridOptionsWrapper.isTreeData();
  };
  FilterService.prototype.filter = function (changedPath) {
    var filterActive = this.filterManager.isAnyFilterPresent();
    this.filterNodes(filterActive, changedPath);
  };
  FilterService.prototype.filterNodes = function (filterActive, changedPath) {
    var _this = this;
    var filterCallback = function filterCallback(rowNode, includeChildNodes) {
      // recursively get all children that are groups to also filter
      if (rowNode.hasChildren()) {
        // result of filter for this node. when filtering tree data, includeChildNodes = true when parent passes
        if (filterActive && !includeChildNodes) {
          rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter(function (childNode) {
            // a group is included in the result if it has any children of it's own.
            // by this stage, the child groups are already filtered
            var passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
            // both leaf level nodes and tree data nodes have data. these get added if
            // the data passes the filter
            var passBecauseDataPasses = childNode.data && _this.filterManager.doesRowPassFilter({
              rowNode: childNode
            });
            // note - tree data nodes pass either if a) they pass themselves or b) any children of that node pass
            return passBecauseChildren || passBecauseDataPasses;
          });
        } else {
          // if not filtering, the result is the original list
          rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
        }
        _this.setAllChildrenCount(rowNode);
      } else {
        rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
        rowNode.setAllChildrenCount(null);
      }
      if (rowNode.sibling) {
        rowNode.sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
      }
    };
    if (this.doingTreeDataFiltering()) {
      var treeDataDepthFirstFilter_1 = function treeDataDepthFirstFilter_1(rowNode, alreadyFoundInParent) {
        // tree data filter traverses the hierarchy depth first and includes child nodes if parent passes
        // filter, and parent nodes will be include if any children exist.
        if (rowNode.childrenAfterGroup) {
          for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
            var childNode = rowNode.childrenAfterGroup[i];
            // first check if current node passes filter before invoking child nodes
            var foundInParent = alreadyFoundInParent || _this.filterManager.doesRowPassFilter({
              rowNode: childNode
            });
            if (childNode.childrenAfterGroup) {
              treeDataDepthFirstFilter_1(rowNode.childrenAfterGroup[i], foundInParent);
            } else {
              filterCallback(childNode, foundInParent);
            }
          }
        }
        filterCallback(rowNode, alreadyFoundInParent);
      };
      var treeDataFilterCallback = function treeDataFilterCallback(rowNode) {
        return treeDataDepthFirstFilter_1(rowNode, false);
      };
      changedPath.executeFromRootNode(treeDataFilterCallback);
    } else {
      var defaultFilterCallback = function defaultFilterCallback(rowNode) {
        return filterCallback(rowNode, false);
      };
      changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
    }
  };
  FilterService.prototype.setAllChildrenCountTreeData = function (rowNode) {
    // for tree data, we include all children, groups and leafs
    var allChildrenCount = 0;
    rowNode.childrenAfterFilter.forEach(function (child) {
      // include child itself
      allChildrenCount++;
      // include children of children
      allChildrenCount += child.allChildrenCount;
    });
    rowNode.setAllChildrenCount(allChildrenCount);
  };
  FilterService.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
    // for grid data, we only count the leafs
    var allChildrenCount = 0;
    rowNode.childrenAfterFilter.forEach(function (child) {
      if (child.group) {
        allChildrenCount += child.allChildrenCount;
      } else {
        allChildrenCount++;
      }
    });
    rowNode.setAllChildrenCount(allChildrenCount);
  };
  FilterService.prototype.setAllChildrenCount = function (rowNode) {
    if (this.doingTreeData) {
      this.setAllChildrenCountTreeData(rowNode);
    } else {
      this.setAllChildrenCountGridGrouping(rowNode);
    }
  };
  FilterService.prototype.doingTreeDataFiltering = function () {
    return this.gridOptionsWrapper.isTreeData() && !this.gridOptionsWrapper.isExcludeChildrenWhenTreeDataFiltering();
  };
  __decorate$2s([Autowired('filterManager')], FilterService.prototype, "filterManager", void 0);
  __decorate$2s([PostConstruct], FilterService.prototype, "postConstruct", null);
  FilterService = __decorate$2s([Bean("filterService")], FilterService);
  return FilterService;
}(BeanStub);
var __extends$2N = undefined && undefined.__extends || function () {
  var _extendStatics186 = function extendStatics(d, b) {
    _extendStatics186 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics186(d, b);
  };
  return function (d, b) {
    _extendStatics186(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2t = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImmutableService = /** @class */function (_super) {
  __extends$2N(ImmutableService, _super);
  function ImmutableService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ImmutableService.prototype.postConstruct = function () {
    if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      this.clientSideRowModel = this.rowModel;
    }
  };
  // converts the setRowData() command to a transaction
  ImmutableService.prototype.createTransactionForRowData = function (data) {
    if (_.missing(this.clientSideRowModel)) {
      console.error('AG Grid: ImmutableService only works with ClientSideRowModel');
      return;
    }
    var getRowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
    if (!getRowNodeIdFunc || _.missing(getRowNodeIdFunc)) {
      console.error('AG Grid: ImmutableService requires getRowNodeId() callback to be implemented, your row data need IDs!');
      return;
    }
    // convert the data into a transaction object by working out adds, removes and updates
    var transaction = {
      remove: [],
      update: [],
      add: []
    };
    var existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
    var suppressSortOrder = this.gridOptionsWrapper.isSuppressMaintainUnsortedOrder();
    var orderMap = suppressSortOrder ? null : {};
    if (_.exists(data)) {
      // split all the new data in the following:
      // if new, push to 'add'
      // if update, push to 'update'
      // if not changed, do not include in the transaction
      data.forEach(function (dataItem, index) {
        var id = getRowNodeIdFunc(dataItem);
        var existingNode = existingNodesMap[id];
        if (orderMap) {
          orderMap[id] = index;
        }
        if (existingNode) {
          var dataHasChanged = existingNode.data !== dataItem;
          if (dataHasChanged) {
            transaction.update.push(dataItem);
          }
          // otherwise, if data not changed, we just don't include it anywhere, as it's not a delta
          // remove from list, so we know the item is not to be removed
          existingNodesMap[id] = undefined;
        } else {
          transaction.add.push(dataItem);
        }
      });
    }
    // at this point, all rows that are left, should be removed
    _.iterateObject(existingNodesMap, function (id, rowNode) {
      if (rowNode) {
        transaction.remove.push(rowNode.data);
      }
    });
    return [transaction, orderMap];
  };
  __decorate$2t([Autowired('rowModel')], ImmutableService.prototype, "rowModel", void 0);
  __decorate$2t([PostConstruct], ImmutableService.prototype, "postConstruct", null);
  ImmutableService = __decorate$2t([Bean('immutableService')], ImmutableService);
  return ImmutableService;
}(BeanStub);
var ClientSideRowModelModule = {
  moduleName: ModuleNames.ClientSideRowModelModule,
  beans: [FilterStage, SortStage, FlattenStage, SortService, FilterService, ImmutableService],
  rowModels: {
    clientSide: ClientSideRowModel
  }
};
var __extends$2O = undefined && undefined.__extends || function () {
  var _extendStatics187 = function extendStatics(d, b) {
    _extendStatics187 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics187(d, b);
  };
  return function (d, b) {
    _extendStatics187(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2u = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var InfiniteBlock = /** @class */function (_super) {
  __extends$2O(InfiniteBlock, _super);
  function InfiniteBlock(id, parentCache, params) {
    var _this = _super.call(this, id) || this;
    _this.parentCache = parentCache;
    _this.params = params;
    // we don't need to calculate these now, as the inputs don't change,
    // however it makes the code easier to read if we work them out up front
    _this.startRow = id * params.blockSize;
    _this.endRow = _this.startRow + params.blockSize;
    return _this;
  }
  InfiniteBlock.prototype.postConstruct = function () {
    this.createRowNodes();
  };
  InfiniteBlock.prototype.getBlockStateJson = function () {
    return {
      id: '' + this.getId(),
      state: {
        blockNumber: this.getId(),
        startRow: this.getStartRow(),
        endRow: this.getEndRow(),
        pageStatus: this.getState()
      }
    };
  };
  InfiniteBlock.prototype.setDataAndId = function (rowNode, data, index) {
    // if there's no id and the rowNode was rendered before, it means this
    // was a placeholder rowNode and should not be recycled. Setting
    // `alreadyRendered`  to `false` forces the rowRenderer to flush it.
    if (!rowNode.id && rowNode.alreadyRendered) {
      rowNode.alreadyRendered = false;
    }
    if (_.exists(data)) {
      // this means if the user is not providing id's we just use the
      // index for the row. this will allow selection to work (that is based
      // on index) as long user is not inserting or deleting rows,
      // or wanting to keep selection between server side sorting or filtering
      rowNode.setDataAndId(data, index.toString());
    } else {
      rowNode.setDataAndId(undefined, undefined);
    }
  };
  InfiniteBlock.prototype.loadFromDatasource = function () {
    var _this = this;
    var params = this.createLoadParams();
    if (_.missing(this.params.datasource.getRows)) {
      console.warn("AG Grid: datasource is missing getRows method");
      return;
    }
    // put in timeout, to force result to be async
    window.setTimeout(function () {
      _this.params.datasource.getRows(params);
    }, 0);
  };
  InfiniteBlock.prototype.processServerFail = function () {
    // todo - this method has better handling in SSRM
  };
  InfiniteBlock.prototype.createLoadParams = function () {
    // PROBLEM . . . . when the user sets sort via colDef.sort, then this code
    // is executing before the sort is set up, so server is not getting the sort
    // model. need to change with regards order - so the server side request is
    // AFTER thus it gets the right sort model.
    var params = {
      startRow: this.getStartRow(),
      endRow: this.getEndRow(),
      successCallback: this.pageLoaded.bind(this, this.getVersion()),
      failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
      sortModel: this.params.sortModel,
      filterModel: this.params.filterModel,
      context: this.gridOptionsWrapper.getContext()
    };
    return params;
  };
  InfiniteBlock.prototype.forEachNode = function (callback, sequence, rowCount) {
    var _this = this;
    this.rowNodes.forEach(function (rowNode, index) {
      var rowIndex = _this.startRow + index;
      if (rowIndex < rowCount) {
        callback(rowNode, sequence.next());
      }
    });
  };
  InfiniteBlock.prototype.getLastAccessed = function () {
    return this.lastAccessed;
  };
  InfiniteBlock.prototype.getRow = function (rowIndex, dontTouchLastAccessed) {
    if (dontTouchLastAccessed === void 0) {
      dontTouchLastAccessed = false;
    }
    if (!dontTouchLastAccessed) {
      this.lastAccessed = this.params.lastAccessedSequence.next();
    }
    var localIndex = rowIndex - this.startRow;
    return this.rowNodes[localIndex];
  };
  InfiniteBlock.prototype.getStartRow = function () {
    return this.startRow;
  };
  InfiniteBlock.prototype.getEndRow = function () {
    return this.endRow;
  };
  // creates empty row nodes, data is missing as not loaded yet
  InfiniteBlock.prototype.createRowNodes = function () {
    this.rowNodes = [];
    for (var i = 0; i < this.params.blockSize; i++) {
      var rowIndex = this.startRow + i;
      var rowNode = new RowNode(this.beans);
      rowNode.setRowHeight(this.params.rowHeight);
      rowNode.uiLevel = 0;
      rowNode.setRowIndex(rowIndex);
      rowNode.setRowTop(this.params.rowHeight * rowIndex);
      this.rowNodes.push(rowNode);
    }
  };
  InfiniteBlock.prototype.processServerResult = function (params) {
    var _this = this;
    this.rowNodes.forEach(function (rowNode, index) {
      var data = params.rowData ? params.rowData[index] : undefined;
      _this.setDataAndId(rowNode, data, _this.startRow + index);
    });
    var finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : undefined;
    this.parentCache.pageLoaded(this, finalRowCount);
  };
  InfiniteBlock.prototype.destroyRowNodes = function () {
    this.rowNodes.forEach(function (rowNode) {
      // this is needed, so row render knows to fade out the row, otherwise it
      // sees row top is present, and thinks the row should be shown.
      rowNode.clearRowTopAndRowIndex();
    });
  };
  __decorate$2u([Autowired('beans')], InfiniteBlock.prototype, "beans", void 0);
  __decorate$2u([PostConstruct], InfiniteBlock.prototype, "postConstruct", null);
  __decorate$2u([PreDestroy], InfiniteBlock.prototype, "destroyRowNodes", null);
  return InfiniteBlock;
}(RowNodeBlock);
var __extends$2P = undefined && undefined.__extends || function () {
  var _extendStatics188 = function extendStatics(d, b) {
    _extendStatics188 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics188(d, b);
  };
  return function (d, b) {
    _extendStatics188(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2v = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$a = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var InfiniteCache = /** @class */function (_super) {
  __extends$2P(InfiniteCache, _super);
  function InfiniteCache(params) {
    var _this = _super.call(this) || this;
    _this.lastRowIndexKnown = false;
    _this.blocks = {};
    _this.blockCount = 0;
    _this.rowCount = params.initialRowCount;
    _this.params = params;
    return _this;
  }
  InfiniteCache.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('InfiniteCache');
  };
  // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
  // it will want new pages in the cache as it asks for rows. only when we are inserting /
  // removing rows via the api is dontCreatePage set, where we move rows between the pages.
  InfiniteCache.prototype.getRow = function (rowIndex, dontCreatePage) {
    if (dontCreatePage === void 0) {
      dontCreatePage = false;
    }
    var blockId = Math.floor(rowIndex / this.params.blockSize);
    var block = this.blocks[blockId];
    if (!block) {
      if (dontCreatePage) {
        return undefined;
      }
      block = this.createBlock(blockId);
    }
    return block.getRow(rowIndex);
  };
  InfiniteCache.prototype.createBlock = function (blockNumber) {
    var newBlock = this.createBean(new InfiniteBlock(blockNumber, this, this.params));
    this.blocks[newBlock.getId()] = newBlock;
    this.blockCount++;
    this.purgeBlocksIfNeeded(newBlock);
    this.params.rowNodeBlockLoader.addBlock(newBlock);
    return newBlock;
  };
  // we have this on infinite row model only, not server side row model,
  // because for server side, it would leave the children in inconsistent
  // state - eg if a node had children, but after the refresh it had data
  // for a different row, then the children would be with the wrong row node.
  InfiniteCache.prototype.refreshCache = function () {
    var nothingToRefresh = this.blockCount == 0;
    if (nothingToRefresh) {
      this.purgeCache();
      return;
    }
    this.getBlocksInOrder().forEach(function (block) {
      return block.setStateWaitingToLoad();
    });
    this.params.rowNodeBlockLoader.checkBlockToLoad();
  };
  InfiniteCache.prototype.destroyAllBlocks = function () {
    var _this = this;
    this.getBlocksInOrder().forEach(function (block) {
      return _this.destroyBlock(block);
    });
  };
  InfiniteCache.prototype.getRowCount = function () {
    return this.rowCount;
  };
  InfiniteCache.prototype.isLastRowIndexKnown = function () {
    return this.lastRowIndexKnown;
  };
  // block calls this, when page loaded
  InfiniteCache.prototype.pageLoaded = function (block, lastRow) {
    // if we are not active, then we ignore all events, otherwise we could end up getting the
    // grid to refresh even though we are no longer the active cache
    if (!this.isAlive()) {
      return;
    }
    this.logger.log("onPageLoaded: page = " + block.getId() + ", lastRow = " + lastRow);
    this.checkRowCount(block, lastRow);
    // we fire cacheUpdated even if the row count has not changed, as some items need updating even
    // if no new rows to render. for example the pagination panel has '?' as the total rows when loading
    // is underway, which would need to get updated when loading finishes.
    this.onCacheUpdated();
  };
  InfiniteCache.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
    var _this = this;
    // we exclude checking for the page just created, as this has yet to be accessed and hence
    // the lastAccessed stamp will not be updated for the first time yet
    var blocksForPurging = this.getBlocksInOrder().filter(function (b) {
      return b != blockToExclude;
    });
    var lastAccessedComparator = function lastAccessedComparator(a, b) {
      return b.getLastAccessed() - a.getLastAccessed();
    };
    blocksForPurging.sort(lastAccessedComparator);
    // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
    // in other words, after the splice operation below, we have taken out the blocks
    // we want to keep, which means we are left with blocks that we can potentially purge
    var maxBlocksProvided = this.params.maxBlocksInCache > 0;
    var blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
    var emptyBlocksToKeep = InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
    blocksForPurging.forEach(function (block, index) {
      var purgeBecauseBlockEmpty = block.getState() === InfiniteBlock.STATE_WAITING_TO_LOAD && index >= emptyBlocksToKeep;
      var purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
      if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
        // if the block currently has rows been displayed, then don't remove it either.
        // this can happen if user has maxBlocks=2, and blockSize=5 (thus 10 max rows in cache)
        // but the screen is showing 20 rows, so at least 4 blocks are needed.
        if (_this.isBlockCurrentlyDisplayed(block)) {
          return;
        }
        // don't want to loose keyboard focus, so keyboard navigation can continue. so keep focused blocks.
        if (_this.isBlockFocused(block)) {
          return;
        }
        // at this point, block is not needed, so burn baby burn
        _this.removeBlockFromCache(block);
      }
    });
  };
  InfiniteCache.prototype.isBlockFocused = function (block) {
    var focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
    if (!focusedCell) {
      return false;
    }
    if (focusedCell.rowPinned != null) {
      return false;
    }
    var blockIndexStart = block.getStartRow();
    var blockIndexEnd = block.getEndRow();
    var hasFocus = focusedCell.rowIndex >= blockIndexStart && focusedCell.rowIndex < blockIndexEnd;
    return hasFocus;
  };
  InfiniteCache.prototype.isBlockCurrentlyDisplayed = function (block) {
    var startIndex = block.getStartRow();
    var endIndex = block.getEndRow() - 1;
    return this.rowRenderer.isRangeInRenderedViewport(startIndex, endIndex);
  };
  InfiniteCache.prototype.removeBlockFromCache = function (blockToRemove) {
    if (!blockToRemove) {
      return;
    }
    this.destroyBlock(blockToRemove);
    // we do not want to remove the 'loaded' event listener, as the
    // concurrent loads count needs to be updated when the load is complete
    // if the purged page is in loading state
  };

  InfiniteCache.prototype.checkRowCount = function (block, lastRow) {
    // if client provided a last row, we always use it, as it could change between server calls
    // if user deleted data and then called refresh on the grid.
    if (typeof lastRow === 'number' && lastRow >= 0) {
      this.rowCount = lastRow;
      this.lastRowIndexKnown = true;
    } else if (!this.lastRowIndexKnown) {
      // otherwise, see if we need to add some virtual rows
      var lastRowIndex = (block.getId() + 1) * this.params.blockSize;
      var lastRowIndexPlusOverflow = lastRowIndex + this.params.overflowSize;
      if (this.rowCount < lastRowIndexPlusOverflow) {
        this.rowCount = lastRowIndexPlusOverflow;
      }
    }
  };
  InfiniteCache.prototype.setRowCount = function (rowCount, lastRowIndexKnown) {
    this.rowCount = rowCount;
    // if undefined is passed, we do not set this value, if one of {true,false}
    // is passed, we do set the value.
    if (_.exists(lastRowIndexKnown)) {
      this.lastRowIndexKnown = lastRowIndexKnown;
    }
    // if we are still searching, then the row count must not end at the end
    // of a particular page, otherwise the searching will not pop into the
    // next page
    if (!this.lastRowIndexKnown) {
      if (this.rowCount % this.params.blockSize === 0) {
        this.rowCount++;
      }
    }
    this.onCacheUpdated();
  };
  InfiniteCache.prototype.forEachNodeDeep = function (callback) {
    var _this = this;
    var sequence = new NumberSequence();
    this.getBlocksInOrder().forEach(function (block) {
      return block.forEachNode(callback, sequence, _this.rowCount);
    });
  };
  InfiniteCache.prototype.getBlocksInOrder = function () {
    // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
    var blockComparator = function blockComparator(a, b) {
      return a.getId() - b.getId();
    };
    var blocks = _.getAllValuesInObject(this.blocks).sort(blockComparator);
    return blocks;
  };
  InfiniteCache.prototype.destroyBlock = function (block) {
    delete this.blocks[block.getId()];
    this.destroyBean(block);
    this.blockCount--;
    this.params.rowNodeBlockLoader.removeBlock(block);
  };
  // gets called 1) row count changed 2) cache purged 3) items inserted
  InfiniteCache.prototype.onCacheUpdated = function () {
    if (this.isAlive()) {
      // if the virtualRowCount is shortened, then it's possible blocks exist that are no longer
      // in the valid range. so we must remove these. this can happen if user explicitly sets
      // the virtual row count, or the datasource returns a result and sets lastRow to something
      // less than virtualRowCount (can happen if user scrolls down, server reduces dataset size).
      this.destroyAllBlocksPastVirtualRowCount();
      // this results in both row models (infinite and server side) firing ModelUpdated,
      // however server side row model also updates the row indexes first
      var event_1 = {
        type: Events.EVENT_STORE_UPDATED
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  InfiniteCache.prototype.destroyAllBlocksPastVirtualRowCount = function () {
    var _this = this;
    var blocksToDestroy = [];
    this.getBlocksInOrder().forEach(function (block) {
      var startRow = block.getId() * _this.params.blockSize;
      if (startRow >= _this.rowCount) {
        blocksToDestroy.push(block);
      }
    });
    if (blocksToDestroy.length > 0) {
      blocksToDestroy.forEach(function (block) {
        return _this.destroyBlock(block);
      });
    }
  };
  InfiniteCache.prototype.purgeCache = function () {
    var _this = this;
    this.getBlocksInOrder().forEach(function (block) {
      return _this.removeBlockFromCache(block);
    });
    this.lastRowIndexKnown = false;
    // if zero rows in the cache, we need to get the SSRM to start asking for rows again.
    // otherwise if set to zero rows last time, and we don't update the row count, then after
    // the purge there will still be zero rows, meaning the SSRM won't request any rows.
    // to kick things off, at least one row needs to be asked for.
    if (this.rowCount === 0) {
      this.rowCount = this.params.initialRowCount;
    }
    this.onCacheUpdated();
  };
  InfiniteCache.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
    var _this = this;
    var result = [];
    var lastBlockId = -1;
    var inActiveRange = false;
    var numberSequence = new NumberSequence();
    // if only one node passed, we start the selection at the top
    if (_.missing(firstInRange)) {
      inActiveRange = true;
    }
    var foundGapInSelection = false;
    this.getBlocksInOrder().forEach(function (block) {
      if (foundGapInSelection) {
        return;
      }
      if (inActiveRange && lastBlockId + 1 !== block.getId()) {
        foundGapInSelection = true;
        return;
      }
      lastBlockId = block.getId();
      block.forEachNode(function (rowNode) {
        var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
        if (inActiveRange || hitFirstOrLast) {
          result.push(rowNode);
        }
        if (hitFirstOrLast) {
          inActiveRange = !inActiveRange;
        }
      }, numberSequence, _this.rowCount);
    });
    // inActiveRange will be still true if we never hit the second rowNode
    var invalidRange = foundGapInSelection || inActiveRange;
    return invalidRange ? [] : result;
  };
  // this property says how many empty blocks should be in a cache, eg if scrolls down fast and creates 10
  // blocks all for loading, the grid will only load the last 2 - it will assume the blocks the user quickly
  // scrolled over are not needed to be loaded.
  InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
  __decorate$2v([Autowired('rowRenderer')], InfiniteCache.prototype, "rowRenderer", void 0);
  __decorate$2v([Autowired("focusService")], InfiniteCache.prototype, "focusService", void 0);
  __decorate$2v([__param$a(0, Qualifier('loggerFactory'))], InfiniteCache.prototype, "setBeans", null);
  __decorate$2v([PreDestroy], InfiniteCache.prototype, "destroyAllBlocks", null);
  return InfiniteCache;
}(BeanStub);
var __extends$2Q = undefined && undefined.__extends || function () {
  var _extendStatics189 = function extendStatics(d, b) {
    _extendStatics189 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics189(d, b);
  };
  return function (d, b) {
    _extendStatics189(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2w = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var InfiniteRowModel = /** @class */function (_super) {
  __extends$2Q(InfiniteRowModel, _super);
  function InfiniteRowModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InfiniteRowModel.prototype.getRowBounds = function (index) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * index
    };
  };
  // we don't implement as lazy row heights is not supported in this row model
  InfiniteRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
    return false;
  };
  InfiniteRowModel.prototype.init = function () {
    var _this = this;
    if (!this.gridOptionsWrapper.isRowModelInfinite()) {
      return;
    }
    this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
    this.addEventListeners();
    this.addDestroyFunc(function () {
      return _this.destroyCache();
    });
    this.verifyProps();
  };
  InfiniteRowModel.prototype.verifyProps = function () {
    if (this.gridOptionsWrapper.getDefaultGroupOrderComparator() != null) {
      var message_1 = "AG Grid: defaultGroupOrderComparator cannot be used with Infinite Row Model. If using Infinite Row Model, then sorting is done on the server side, nothing to do with the client.";
      _.doOnce(function () {
        return console.warn(message_1);
      }, 'IRM.DefaultGroupOrderComparator');
    }
  };
  InfiniteRowModel.prototype.start = function () {
    this.setDatasource(this.gridOptionsWrapper.getDatasource());
  };
  InfiniteRowModel.prototype.destroyDatasource = function () {
    if (this.datasource) {
      this.getContext().destroyBean(this.datasource);
      this.rowRenderer.datasourceChanged();
      this.datasource = null;
    }
  };
  InfiniteRowModel.prototype.addEventListeners = function () {
    this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this));
  };
  InfiniteRowModel.prototype.onFilterChanged = function () {
    this.reset();
  };
  InfiniteRowModel.prototype.onSortChanged = function () {
    this.reset();
  };
  InfiniteRowModel.prototype.onColumnEverything = function () {
    var resetRequired;
    // if cache params, we require reset only if sort model has changed. we don't need to check
    // for filter model, as the filter manager will fire an event when columns change that result
    // in the filter changing.
    if (this.cacheParams) {
      resetRequired = this.isSortModelDifferent();
    } else {
      // if no cacheParams, means first time creating the cache, so always create one
      resetRequired = true;
    }
    if (resetRequired) {
      this.reset();
    }
  };
  InfiniteRowModel.prototype.isSortModelDifferent = function () {
    return !_.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
  };
  InfiniteRowModel.prototype.getType = function () {
    return Constants.ROW_MODEL_TYPE_INFINITE;
  };
  InfiniteRowModel.prototype.setDatasource = function (datasource) {
    this.destroyDatasource();
    this.datasource = datasource;
    // only reset if we have a valid datasource to working with
    if (datasource) {
      this.reset();
    }
  };
  InfiniteRowModel.prototype.isEmpty = function () {
    return !this.infiniteCache;
  };
  InfiniteRowModel.prototype.isRowsToRender = function () {
    return !!this.infiniteCache;
  };
  InfiniteRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
    return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
  };
  InfiniteRowModel.prototype.reset = function () {
    // important to return here, as the user could be setting filter or sort before
    // data-source is set
    if (!this.datasource) {
      return;
    }
    // if user is providing id's, then this means we can keep the selection between datasource hits,
    // as the rows will keep their unique id's even if, for example, server side sorting or filtering
    // is done.
    var userGeneratingIds = _.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
    if (!userGeneratingIds) {
      this.selectionService.reset();
    }
    this.resetCache();
    var event = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(event);
  };
  InfiniteRowModel.prototype.createModelUpdatedEvent = function () {
    return {
      type: Events.EVENT_MODEL_UPDATED,
      api: this.gridApi,
      columnApi: this.columnApi,
      // not sure if these should all be false - noticed if after implementing,
      // maybe they should be true?
      newPage: false,
      newData: false,
      keepRenderedRows: true,
      animate: false
    };
  };
  InfiniteRowModel.prototype.resetCache = function () {
    // if not first time creating a cache, need to destroy the old one
    this.destroyCache();
    var maxConcurrentRequests = this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests();
    this.cacheParams = {
      // the user provided datasource
      datasource: this.datasource,
      // sort and filter model
      filterModel: this.filterManager.getFilterModel(),
      sortModel: this.sortController.getSortModel(),
      rowNodeBlockLoader: this.rowNodeBlockLoader,
      // properties - this way we take a snapshot of them, so if user changes any, they will be
      // used next time we create a new cache, which is generally after a filter or sort change,
      // or a new datasource is set
      maxConcurrentRequests: this.defaultIfInvalid(maxConcurrentRequests, 2),
      initialRowCount: this.defaultIfInvalid(this.gridOptionsWrapper.getInfiniteInitialRowCount(), 1),
      maxBlocksInCache: this.gridOptionsWrapper.getMaxBlocksInCache(),
      rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
      // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
      // the current page and request first row of next page
      overflowSize: this.defaultIfInvalid(this.gridOptionsWrapper.getCacheOverflowSize(), 1),
      // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
      // server for one page at a time. so the default if not specified is 100.
      blockSize: this.defaultIfInvalid(this.gridOptionsWrapper.getCacheBlockSize(), 100),
      // the cache could create this, however it is also used by the pages, so handy to create it
      // here as the settings are also passed to the pages
      lastAccessedSequence: new NumberSequence()
    };
    this.infiniteCache = this.createBean(new InfiniteCache(this.cacheParams));
  };
  InfiniteRowModel.prototype.defaultIfInvalid = function (value, defaultValue) {
    return value > 0 ? value : defaultValue;
  };
  InfiniteRowModel.prototype.destroyCache = function () {
    if (this.infiniteCache) {
      this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
  };
  InfiniteRowModel.prototype.onCacheUpdated = function () {
    var event = this.createModelUpdatedEvent();
    this.eventService.dispatchEvent(event);
  };
  InfiniteRowModel.prototype.getRow = function (rowIndex) {
    if (!this.infiniteCache) {
      return undefined;
    }
    if (rowIndex >= this.infiniteCache.getRowCount()) {
      return undefined;
    }
    return this.infiniteCache.getRow(rowIndex);
  };
  InfiniteRowModel.prototype.getRowNode = function (id) {
    var result = undefined;
    this.forEachNode(function (rowNode) {
      if (rowNode.id === id) {
        result = rowNode;
      }
    });
    return result;
  };
  InfiniteRowModel.prototype.forEachNode = function (callback) {
    if (this.infiniteCache) {
      this.infiniteCache.forEachNodeDeep(callback);
    }
  };
  InfiniteRowModel.prototype.getTopLevelRowCount = function () {
    return this.getRowCount();
  };
  InfiniteRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    return topLevelIndex;
  };
  InfiniteRowModel.prototype.getRowIndexAtPixel = function (pixel) {
    if (this.rowHeight !== 0) {
      // avoid divide by zero error
      var rowIndexForPixel = Math.floor(pixel / this.rowHeight);
      var lastRowIndex = this.getRowCount() - 1;
      if (rowIndexForPixel > lastRowIndex) {
        return lastRowIndex;
      }
      return rowIndexForPixel;
    }
    return 0;
  };
  InfiniteRowModel.prototype.getRowCount = function () {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  };
  InfiniteRowModel.prototype.isRowPresent = function (rowNode) {
    var foundRowNode = this.getRowNode(rowNode.id);
    return !!foundRowNode;
  };
  InfiniteRowModel.prototype.refreshCache = function () {
    if (this.infiniteCache) {
      this.infiniteCache.refreshCache();
    }
  };
  InfiniteRowModel.prototype.purgeCache = function () {
    if (this.infiniteCache) {
      this.infiniteCache.purgeCache();
    }
  };
  // for iRowModel
  InfiniteRowModel.prototype.isLastRowIndexKnown = function () {
    if (this.infiniteCache) {
      return this.infiniteCache.isLastRowIndexKnown();
    }
    return false;
  };
  InfiniteRowModel.prototype.setRowCount = function (rowCount, lastRowIndexKnown) {
    if (this.infiniteCache) {
      this.infiniteCache.setRowCount(rowCount, lastRowIndexKnown);
    }
  };
  __decorate$2w([Autowired('filterManager')], InfiniteRowModel.prototype, "filterManager", void 0);
  __decorate$2w([Autowired('sortController')], InfiniteRowModel.prototype, "sortController", void 0);
  __decorate$2w([Autowired('selectionService')], InfiniteRowModel.prototype, "selectionService", void 0);
  __decorate$2w([Autowired('gridApi')], InfiniteRowModel.prototype, "gridApi", void 0);
  __decorate$2w([Autowired('columnApi')], InfiniteRowModel.prototype, "columnApi", void 0);
  __decorate$2w([Autowired('rowRenderer')], InfiniteRowModel.prototype, "rowRenderer", void 0);
  __decorate$2w([Autowired('rowNodeBlockLoader')], InfiniteRowModel.prototype, "rowNodeBlockLoader", void 0);
  __decorate$2w([PostConstruct], InfiniteRowModel.prototype, "init", null);
  __decorate$2w([PreDestroy], InfiniteRowModel.prototype, "destroyDatasource", null);
  InfiniteRowModel = __decorate$2w([Bean('rowModel')], InfiniteRowModel);
  return InfiniteRowModel;
}(BeanStub);
var InfiniteRowModelModule = {
  moduleName: ModuleNames.InfiniteRowModelModule,
  rowModels: {
    infinite: InfiniteRowModel
  }
};
var BaseCreator = /** @class */function () {
  function BaseCreator() {}
  BaseCreator.prototype.setBeans = function (beans) {
    this.beans = beans;
  };
  BaseCreator.prototype.getFileName = function (fileName) {
    var extension = this.getDefaultFileExtension();
    if (fileName == null || !fileName.length) {
      fileName = this.getDefaultFileName();
    }
    return fileName.indexOf('.') === -1 ? fileName + "." + extension : fileName;
  };
  BaseCreator.prototype.getMergedParamsAndData = function (userParams) {
    var mergedParams = this.mergeDefaultParams(userParams);
    var data = this.beans.gridSerializer.serialize(this.createSerializingSession(mergedParams), mergedParams);
    return {
      mergedParams: mergedParams,
      data: data
    };
  };
  BaseCreator.prototype.mergeDefaultParams = function (userParams) {
    var baseParams = this.getDefaultExportParams();
    var params = {};
    _.assign(params, baseParams);
    _.assign(params, userParams);
    return params;
  };
  return BaseCreator;
}();
var BaseGridSerializingSession = /** @class */function () {
  function BaseGridSerializingSession(config) {
    this.groupColumns = [];
    var columnModel = config.columnModel,
      valueService = config.valueService,
      gridOptionsWrapper = config.gridOptionsWrapper,
      processCellCallback = config.processCellCallback,
      processHeaderCallback = config.processHeaderCallback,
      processGroupHeaderCallback = config.processGroupHeaderCallback,
      processRowGroupCallback = config.processRowGroupCallback;
    this.columnModel = columnModel;
    this.valueService = valueService;
    this.gridOptionsWrapper = gridOptionsWrapper;
    this.processCellCallback = processCellCallback;
    this.processHeaderCallback = processHeaderCallback;
    this.processGroupHeaderCallback = processGroupHeaderCallback;
    this.processRowGroupCallback = processRowGroupCallback;
  }
  BaseGridSerializingSession.prototype.prepare = function (columnsToExport) {
    this.groupColumns = _.filter(columnsToExport, function (col) {
      return !!col.getColDef().showRowGroup;
    });
  };
  BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
    var value = this.getHeaderName(this.processHeaderCallback, column);
    return value != null ? value : '';
  };
  BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, accumulatedRowIndex, type, node) {
    // we render the group summary text e.g. "-> Parent -> Child"...
    var groupIndex = this.gridOptionsWrapper.isGroupMultiAutoColumn() ? node.rowGroupIndex : 0;
    var renderGroupSummaryCell =
    // on group rows
    node && node.group && (
    // in the group column if groups appear in regular grid cells
    index === groupIndex && this.groupColumns.indexOf(column) !== -1
    // or the first cell in the row, if we're doing full width rows
    || index === 0 && this.gridOptionsWrapper.isGroupUseEntireRow(this.columnModel.isPivotMode()));
    var valueForCell;
    if (renderGroupSummaryCell) {
      valueForCell = this.createValueForGroupNode(node);
    } else {
      valueForCell = this.valueService.getValue(column, node);
    }
    var value = this.processCell(accumulatedRowIndex, node, column, valueForCell, this.processCellCallback, type);
    return value != null ? value : '';
  };
  BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
    if (callback) {
      return callback({
        column: column,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      });
    }
    return this.columnModel.getDisplayNameForColumn(column, 'csv', true);
  };
  BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
    if (this.processRowGroupCallback) {
      return this.processRowGroupCallback({
        node: node,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      });
    }
    var keys = [node.key];
    if (!this.gridOptionsWrapper.isGroupMultiAutoColumn()) {
      while (node.parent) {
        node = node.parent;
        keys.push(node.key);
      }
    }
    return keys.reverse().join(' -> ');
  };
  BaseGridSerializingSession.prototype.processCell = function (accumulatedRowIndex, rowNode, column, value, processCellCallback, type) {
    if (processCellCallback) {
      return processCellCallback({
        accumulatedRowIndex: accumulatedRowIndex,
        column: column,
        node: rowNode,
        value: value,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext(),
        type: type
      });
    }
    return value != null ? value : '';
  };
  return BaseGridSerializingSession;
}();
var Downloader = /** @class */function () {
  function Downloader() {}
  Downloader.download = function (fileName, content) {
    var win = document.defaultView || window;
    if (!win) {
      console.warn('AG Grid: There is no `window` associated with the current `document`');
      return;
    }
    // Internet Explorer
    // @ts-ignore
    if (win.navigator.msSaveOrOpenBlob) {
      // @ts-ignore
      win.navigator.msSaveOrOpenBlob(content, fileName);
    } else {
      // Other Browsers
      var element = document.createElement('a');
      // @ts-ignore
      var url_1 = win.URL.createObjectURL(content);
      element.setAttribute('href', url_1);
      element.setAttribute('download', fileName);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.dispatchEvent(new MouseEvent('click', {
        bubbles: false,
        cancelable: true,
        view: win
      }));
      document.body.removeChild(element);
      win.setTimeout(function () {
        // @ts-ignore
        win.URL.revokeObjectURL(url_1);
      }, 0);
    }
  };
  return Downloader;
}();
var __extends$2R = undefined && undefined.__extends || function () {
  var _extendStatics190 = function extendStatics(d, b) {
    _extendStatics190 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics190(d, b);
  };
  return function (d, b) {
    _extendStatics190(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var LINE_SEPARATOR = '\r\n';
var CsvSerializingSession = /** @class */function (_super) {
  __extends$2R(CsvSerializingSession, _super);
  function CsvSerializingSession(config) {
    var _this = _super.call(this, config) || this;
    _this.isFirstLine = true;
    _this.result = '';
    var suppressQuotes = config.suppressQuotes,
      columnSeparator = config.columnSeparator;
    _this.suppressQuotes = suppressQuotes;
    _this.columnSeparator = columnSeparator;
    return _this;
  }
  CsvSerializingSession.prototype.addCustomContent = function (content) {
    var _this = this;
    if (!content) {
      return;
    }
    if (typeof content === 'string') {
      if (!/^\s*\n/.test(content)) {
        this.beginNewLine();
      }
      // replace whatever newlines are supplied with the style we're using
      content = content.replace(/\r?\n/g, LINE_SEPARATOR);
      this.result += content;
    } else {
      content.forEach(function (row) {
        _this.beginNewLine();
        row.forEach(function (cell, index) {
          if (index !== 0) {
            _this.result += _this.columnSeparator;
          }
          _this.result += _this.putInQuotes(cell.data.value || '');
          if (cell.mergeAcross) {
            _this.appendEmptyCells(cell.mergeAcross);
          }
        });
      });
    }
  };
  CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
    this.beginNewLine();
    return {
      onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
    };
  };
  CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
    if (index != 0) {
      this.result += this.columnSeparator;
    }
    this.result += this.putInQuotes(header);
    this.appendEmptyCells(span);
  };
  CsvSerializingSession.prototype.appendEmptyCells = function (count) {
    for (var i = 1; i <= count; i++) {
      this.result += this.columnSeparator + this.putInQuotes("");
    }
  };
  CsvSerializingSession.prototype.onNewHeaderRow = function () {
    this.beginNewLine();
    return {
      onColumn: this.onNewHeaderRowColumn.bind(this)
    };
  };
  CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index) {
    if (index != 0) {
      this.result += this.columnSeparator;
    }
    this.result += this.putInQuotes(this.extractHeaderValue(column));
  };
  CsvSerializingSession.prototype.onNewBodyRow = function () {
    this.beginNewLine();
    return {
      onColumn: this.onNewBodyRowColumn.bind(this)
    };
  };
  CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
    if (index != 0) {
      this.result += this.columnSeparator;
    }
    this.result += this.putInQuotes(this.extractRowCellValue(column, index, index, Constants.EXPORT_TYPE_CSV, node));
  };
  CsvSerializingSession.prototype.putInQuotes = function (value) {
    if (this.suppressQuotes) {
      return value;
    }
    if (value === null || value === undefined) {
      return '""';
    }
    var stringValue;
    if (typeof value === 'string') {
      stringValue = value;
    } else if (typeof value.toString === 'function') {
      stringValue = value.toString();
    } else {
      console.warn('unknown value type during csv conversion');
      stringValue = '';
    }
    // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
    var valueEscaped = stringValue.replace(/"/g, "\"\"");
    return '"' + valueEscaped + '"';
  };
  CsvSerializingSession.prototype.parse = function () {
    return this.result;
  };
  CsvSerializingSession.prototype.beginNewLine = function () {
    if (!this.isFirstLine) {
      this.result += LINE_SEPARATOR;
    }
    this.isFirstLine = false;
  };
  return CsvSerializingSession;
}(BaseGridSerializingSession);
var __extends$2S = undefined && undefined.__extends || function () {
  var _extendStatics191 = function extendStatics(d, b) {
    _extendStatics191 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics191(d, b);
  };
  return function (d, b) {
    _extendStatics191(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2x = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CsvCreator = /** @class */function (_super) {
  __extends$2S(CsvCreator, _super);
  function CsvCreator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CsvCreator.prototype.postConstruct = function () {
    this.setBeans({
      gridSerializer: this.gridSerializer,
      gridOptionsWrapper: this.gridOptionsWrapper
    });
  };
  CsvCreator.prototype.getDefaultExportParams = function () {
    return this.gridOptionsWrapper.getDefaultExportParams('csv');
  };
  CsvCreator.prototype.export = function (userParams) {
    if (this.isExportSuppressed()) {
      console.warn("ag-grid: Export cancelled. Export is not allowed as per your configuration.");
      return '';
    }
    var _a = this.getMergedParamsAndData(userParams),
      mergedParams = _a.mergedParams,
      data = _a.data;
    var packagedFile = new Blob(["\uFEFF", data], {
      // @ts-ignore
      type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
    });
    Downloader.download(this.getFileName(mergedParams.fileName), packagedFile);
    return data;
  };
  CsvCreator.prototype.exportDataAsCsv = function (params) {
    return this.export(params);
  };
  CsvCreator.prototype.getDataAsCsv = function (params) {
    return this.getMergedParamsAndData(params).data;
  };
  CsvCreator.prototype.getMimeType = function () {
    return 'text/csv;charset=utf-8;';
  };
  CsvCreator.prototype.getDefaultFileName = function () {
    return 'export.csv';
  };
  CsvCreator.prototype.getDefaultFileExtension = function () {
    return 'csv';
  };
  CsvCreator.prototype.createSerializingSession = function (params) {
    var _a = this,
      columnModel = _a.columnModel,
      valueService = _a.valueService,
      gridOptionsWrapper = _a.gridOptionsWrapper;
    var _b = params,
      processCellCallback = _b.processCellCallback,
      processHeaderCallback = _b.processHeaderCallback,
      processGroupHeaderCallback = _b.processGroupHeaderCallback,
      processRowGroupCallback = _b.processRowGroupCallback,
      suppressQuotes = _b.suppressQuotes,
      columnSeparator = _b.columnSeparator;
    return new CsvSerializingSession({
      columnModel: columnModel,
      valueService: valueService,
      gridOptionsWrapper: gridOptionsWrapper,
      processCellCallback: processCellCallback || undefined,
      processHeaderCallback: processHeaderCallback || undefined,
      processGroupHeaderCallback: processGroupHeaderCallback || undefined,
      processRowGroupCallback: processRowGroupCallback || undefined,
      suppressQuotes: suppressQuotes || false,
      columnSeparator: columnSeparator || ','
    });
  };
  CsvCreator.prototype.isExportSuppressed = function () {
    return this.gridOptionsWrapper.isSuppressCsvExport();
  };
  __decorate$2x([Autowired('columnModel')], CsvCreator.prototype, "columnModel", void 0);
  __decorate$2x([Autowired('valueService')], CsvCreator.prototype, "valueService", void 0);
  __decorate$2x([Autowired('gridSerializer')], CsvCreator.prototype, "gridSerializer", void 0);
  __decorate$2x([Autowired('gridOptionsWrapper')], CsvCreator.prototype, "gridOptionsWrapper", void 0);
  __decorate$2x([PostConstruct], CsvCreator.prototype, "postConstruct", null);
  CsvCreator = __decorate$2x([Bean('csvCreator')], CsvCreator);
  return CsvCreator;
}(BaseCreator);
var __extends$2T = undefined && undefined.__extends || function () {
  var _extendStatics192 = function extendStatics(d, b) {
    _extendStatics192 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics192(d, b);
  };
  return function (d, b) {
    _extendStatics192(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowType$1;
(function (RowType) {
  RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
  RowType[RowType["HEADER"] = 1] = "HEADER";
  RowType[RowType["BODY"] = 2] = "BODY";
})(RowType$1 || (RowType$1 = {}));
var GridSerializer = /** @class */function (_super) {
  __extends$2T(GridSerializer, _super);
  function GridSerializer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
    if (params === void 0) {
      params = {};
    }
    var columnsToExport = this.getColumnsToExport(params.allColumns, params.columnKeys);
    var serializeChain = _.compose(
    // first pass, put in the header names of the cols
    this.prepareSession(columnsToExport), this.prependContent(params), this.exportColumnGroups(params, columnsToExport), this.exportHeaders(params, columnsToExport), this.processPinnedTopRows(params, columnsToExport), this.processRows(params, columnsToExport), this.processPinnedBottomRows(params, columnsToExport), this.appendContent(params));
    return serializeChain(gridSerializingSession).parse();
  };
  GridSerializer.prototype.processRow = function (gridSerializingSession, params, columnsToExport, node) {
    var rowSkipper = params.shouldRowBeSkipped || function () {
      return false;
    };
    var gridOptionsWrapper = this.gridOptionsWrapper;
    var context = gridOptionsWrapper.getContext();
    var api = gridOptionsWrapper.getApi();
    var columnApi = gridOptionsWrapper.getColumnApi();
    var skipSingleChildrenGroup = gridOptionsWrapper.isGroupRemoveSingleChildren();
    var hideOpenParents = gridOptionsWrapper.isGroupHideOpenParents();
    var skipLowestSingleChildrenGroup = gridOptionsWrapper.isGroupRemoveLowestSingleChildren();
    var isLeafNode = this.columnModel.isPivotMode() ? node.leafGroup : !node.group;
    var skipRowGroups = params.skipGroups || params.skipRowGroups;
    var shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
    var shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
    if (skipRowGroups && params.skipGroups) {
      _.doOnce(function () {
        return console.warn('AG Grid: Since v25.2 `skipGroups` has been renamed to `skipRowGroups`.');
      }, 'gridSerializer-skipGroups');
    }
    if (!isLeafNode && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === 'top' || params.skipPinnedBottom && node.rowPinned === 'bottom') {
      return;
    }
    // if we are in pivotMode, then the grid will show the root node only
    // if it's not a leaf group
    var nodeIsRootNode = node.level === -1;
    if (nodeIsRootNode && !node.leafGroup) {
      return;
    }
    var shouldRowBeSkipped = rowSkipper({
      node: node,
      api: api,
      context: context
    });
    if (shouldRowBeSkipped) {
      return;
    }
    var rowAccumulator = gridSerializingSession.onNewBodyRow();
    columnsToExport.forEach(function (column, index) {
      rowAccumulator.onColumn(column, index, node);
    });
    if (params.getCustomContentBelowRow) {
      var content = params.getCustomContentBelowRow({
        node: node,
        api: api,
        columnApi: columnApi,
        context: context
      });
      if (content) {
        gridSerializingSession.addCustomContent(content);
      }
    }
  };
  GridSerializer.prototype.appendContent = function (params) {
    return function (gridSerializingSession) {
      var appendContent = params.customFooter || params.appendContent;
      if (appendContent) {
        if (params.customFooter) {
          _.doOnce(function () {
            return console.warn('AG Grid: Since version 25.2.0 the `customFooter` param has been deprecated. Use `appendContent` instead.');
          }, 'gridSerializer-customFooter');
        }
        gridSerializingSession.addCustomContent(appendContent);
      }
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.prependContent = function (params) {
    return function (gridSerializingSession) {
      var prependContent = params.customHeader || params.prependContent;
      if (prependContent) {
        if (params.customHeader) {
          _.doOnce(function () {
            return console.warn('AG Grid: Since version 25.2.0 the `customHeader` param has been deprecated. Use `prependContent` instead.');
          }, 'gridSerializer-customHeader');
        }
        gridSerializingSession.addCustomContent(prependContent);
      }
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.prepareSession = function (columnsToExport) {
    return function (gridSerializingSession) {
      gridSerializingSession.prepare(columnsToExport);
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.exportColumnGroups = function (params, columnsToExport) {
    var _this = this;
    return function (gridSerializingSession) {
      if (!params.skipColumnGroupHeaders) {
        var groupInstanceIdCreator = new GroupInstanceIdCreator();
        var displayedGroups = _this.displayedGroupCreator.createDisplayedGroups(columnsToExport, _this.columnModel.getGridBalancedTree(), groupInstanceIdCreator, null);
        _this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
      } else if (params.columnGroups) {
        _.doOnce(function () {
          return console.warn('AG Grid: Since v25.2 the `columnGroups` param has deprecated, and groups are exported by default.');
        }, 'gridSerializer-columnGroups');
      }
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.exportHeaders = function (params, columnsToExport) {
    return function (gridSerializingSession) {
      if (!params.skipHeader && !params.skipColumnHeaders) {
        var gridRowIterator_1 = gridSerializingSession.onNewHeaderRow();
        columnsToExport.forEach(function (column, index) {
          gridRowIterator_1.onColumn(column, index, undefined);
        });
      } else if (params.skipHeader) {
        _.doOnce(function () {
          return console.warn('AG Grid: Since v25.2 the `skipHeader` param has been renamed to `skipColumnHeaders`.');
        }, 'gridSerializer-skipHeader');
      }
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.processPinnedTopRows = function (params, columnsToExport) {
    var _this = this;
    return function (gridSerializingSession) {
      var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
      _this.pinnedRowModel.forEachPinnedTopRow(processRow);
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.processRows = function (params, columnsToExport) {
    var _this = this;
    return function (gridSerializingSession) {
      // when in pivot mode, we always render cols on screen, never 'all columns'
      var rowModel = _this.rowModel;
      var rowModelType = rowModel.getType();
      var usingCsrm = rowModelType === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
      var usingSsrm = rowModelType === Constants.ROW_MODEL_TYPE_SERVER_SIDE;
      var onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
      var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
      if (_this.columnModel.isPivotMode()) {
        if (usingCsrm) {
          rowModel.forEachPivotNode(processRow);
        } else {
          // must be enterprise, so we can just loop through all the nodes
          rowModel.forEachNode(processRow);
        }
      } else {
        // onlySelectedAllPages: user doing pagination and wants selected items from
        // other pages, so cannot use the standard row model as it won't have rows from
        // other pages.
        // onlySelectedNonStandardModel: if user wants selected in non standard row model
        // (eg viewport) then again RowModel cannot be used, so need to use selected instead.
        if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
          var selectedNodes = _this.selectionService.getSelectedNodes();
          selectedNodes.forEach(processRow);
        } else {
          // here is everything else - including standard row model and selected. we don't use
          // the selection model even when just using selected, so that the result is the order
          // of the rows appearing on the screen.
          if (usingCsrm) {
            rowModel.forEachNodeAfterFilterAndSort(processRow);
          } else if (usingSsrm) {
            rowModel.forEachNodeAfterFilterAndSort(processRow);
          } else {
            rowModel.forEachNode(processRow);
          }
        }
      }
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.processPinnedBottomRows = function (params, columnsToExport) {
    var _this = this;
    return function (gridSerializingSession) {
      var processRow = _this.processRow.bind(_this, gridSerializingSession, params, columnsToExport);
      _this.pinnedRowModel.forEachPinnedBottomRow(processRow);
      return gridSerializingSession;
    };
  };
  GridSerializer.prototype.getColumnsToExport = function (allColumns, columnKeys) {
    if (allColumns === void 0) {
      allColumns = false;
    }
    var isPivotMode = this.columnModel.isPivotMode();
    if (columnKeys && columnKeys.length) {
      return this.columnModel.getGridColumns(columnKeys);
    }
    if (allColumns && !isPivotMode) {
      // add auto group column for tree data
      var columns = this.gridOptionsWrapper.isTreeData() ? this.columnModel.getGridColumns([Constants.GROUP_AUTO_COLUMN_ID]) : [];
      return columns.concat(this.columnModel.getAllPrimaryColumns() || []);
    }
    return this.columnModel.getAllDisplayedColumns();
  };
  GridSerializer.prototype.recursivelyAddHeaderGroups = function (displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
    var directChildrenHeaderGroups = [];
    displayedGroups.forEach(function (columnGroupChild) {
      var columnGroup = columnGroupChild;
      if (!columnGroup.getChildren) {
        return;
      }
      columnGroup.getChildren().forEach(function (it) {
        return directChildrenHeaderGroups.push(it);
      });
    });
    if (displayedGroups.length > 0 && displayedGroups[0] instanceof ColumnGroup) {
      this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
    }
    if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) {
      this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
  };
  GridSerializer.prototype.doAddHeaderHeader = function (gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
    var _this = this;
    var gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
    var columnIndex = 0;
    displayedGroups.forEach(function (columnGroupChild) {
      var columnGroup = columnGroupChild;
      var name;
      if (processGroupHeaderCallback) {
        name = processGroupHeaderCallback({
          columnGroup: columnGroup,
          api: _this.gridOptionsWrapper.getApi(),
          columnApi: _this.gridOptionsWrapper.getColumnApi(),
          context: _this.gridOptionsWrapper.getContext()
        });
      } else {
        name = _this.columnModel.getDisplayNameForColumnGroup(columnGroup, 'header');
      }
      gridRowIterator.onColumn(name || '', columnIndex++, columnGroup.getLeafColumns().length - 1);
    });
  };
  __decorate$2y([Autowired('displayedGroupCreator')], GridSerializer.prototype, "displayedGroupCreator", void 0);
  __decorate$2y([Autowired('columnModel')], GridSerializer.prototype, "columnModel", void 0);
  __decorate$2y([Autowired('rowModel')], GridSerializer.prototype, "rowModel", void 0);
  __decorate$2y([Autowired('pinnedRowModel')], GridSerializer.prototype, "pinnedRowModel", void 0);
  __decorate$2y([Autowired('selectionService')], GridSerializer.prototype, "selectionService", void 0);
  GridSerializer = __decorate$2y([Bean("gridSerializer")], GridSerializer);
  return GridSerializer;
}(BeanStub);
var CsvExportModule = {
  moduleName: ModuleNames.CsvExportModule,
  beans: [CsvCreator, GridSerializer]
};
var LINE_SEPARATOR$1 = '\r\n';
var XmlFactory = /** @class */function () {
  function XmlFactory() {}
  XmlFactory.createHeader = function (headerElement) {
    if (headerElement === void 0) {
      headerElement = {};
    }
    var headerStart = '<?';
    var headerEnd = '?>';
    var keys = ['version'];
    if (!headerElement.version) {
      headerElement.version = "1.0";
    }
    if (headerElement.encoding) {
      keys.push('encoding');
    }
    if (headerElement.standalone) {
      keys.push('standalone');
    }
    var att = keys.map(function (key) {
      return key + "=\"" + headerElement[key] + "\"";
    }).join(' ');
    return headerStart + "xml " + att + " " + headerEnd;
  };
  XmlFactory.createXml = function (xmlElement, booleanTransformer) {
    var _this = this;
    var props = '';
    if (xmlElement.properties) {
      if (xmlElement.properties.prefixedAttributes) {
        xmlElement.properties.prefixedAttributes.forEach(function (prefixedSet) {
          Object.keys(prefixedSet.map).forEach(function (key) {
            props += _this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
          });
        });
      }
      if (xmlElement.properties.rawMap) {
        Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
          props += _this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
        });
      }
    }
    var result = '<' + xmlElement.name + props;
    if (!xmlElement.children && xmlElement.textNode == null) {
      return result + '/>' + LINE_SEPARATOR$1;
    }
    if (xmlElement.textNode != null) {
      return result + '>' + xmlElement.textNode + '</' + xmlElement.name + '>' + LINE_SEPARATOR$1;
    }
    result += '>' + LINE_SEPARATOR$1;
    if (xmlElement.children) {
      xmlElement.children.forEach(function (it) {
        result += _this.createXml(it, booleanTransformer);
      });
    }
    return result + '</' + xmlElement.name + '>' + LINE_SEPARATOR$1;
  };
  XmlFactory.returnAttributeIfPopulated = function (key, value, booleanTransformer) {
    if (!value && value !== '' && value !== 0) {
      return '';
    }
    var xmlValue = value;
    if (typeof value === 'boolean') {
      if (booleanTransformer) {
        xmlValue = booleanTransformer(value);
      }
    }
    return " " + key + "=\"" + xmlValue + "\"";
  };
  return XmlFactory;
}();

// table for crc calculation
// from: https://referencesource.microsoft.com/#System/sys/System/IO/compression/Crc32Helper.cs,3b31978c7d7f7246,references
var crcTable = new Uint32Array([0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419, 0x706af48f, 0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4, 0xe0d5e91e, 0x97d2d988, 0x09b64c2b, 0x7eb17cbd, 0xe7b82d07, 0x90bf1d91, 0x1db71064, 0x6ab020f2, 0xf3b97148, 0x84be41de, 0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7, 0x136c9856, 0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9, 0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4, 0xa2677172, 0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b, 0x35b5a8fa, 0x42b2986c, 0xdbbbc9d6, 0xacbcf940, 0x32d86ce3, 0x45df5c75, 0xdcd60dcf, 0xabd13d59, 0x26d930ac, 0x51de003a, 0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423, 0xcfba9599, 0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924, 0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190, 0x01db7106, 0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f, 0x9fbfe4a5, 0xe8b8d433, 0x7807c9a2, 0x0f00f934, 0x9609a88e, 0xe10e9818, 0x7f6a0dbb, 0x086d3d2d, 0x91646c97, 0xe6635c01, 0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e, 0x6c0695ed, 0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950, 0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3, 0xfbd44c65, 0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2, 0x4adfa541, 0x3dd895d7, 0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a, 0x346ed9fc, 0xad678846, 0xda60b8d0, 0x44042d73, 0x33031de5, 0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa, 0xbe0b1010, 0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f, 0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17, 0x2eb40d81, 0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6, 0x03b6e20c, 0x74b1d29a, 0xead54739, 0x9dd277af, 0x04db2615, 0x73dc1683, 0xe3630b12, 0x94643b84, 0x0d6d6a3e, 0x7a6a5aa8, 0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1, 0xf00f9344, 0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb, 0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a, 0x67dd4acc, 0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5, 0xd6d6a3e8, 0xa1d1937e, 0x38d8c2c4, 0x4fdff252, 0xd1bb67f1, 0xa6bc5767, 0x3fb506dd, 0x48b2364b, 0xd80d2bda, 0xaf0a1b4c, 0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55, 0x316e8eef, 0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236, 0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe, 0xb2bd0b28, 0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31, 0x2cd99e8b, 0x5bdeae1d, 0x9b64c2b0, 0xec63f226, 0x756aa39c, 0x026d930a, 0x9c0906a9, 0xeb0e363f, 0x72076785, 0x05005713, 0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38, 0x92d28e9b, 0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242, 0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1, 0x18b74777, 0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c, 0x8f659eff, 0xf862ae69, 0x616bffd3, 0x166ccf45, 0xa00ae278, 0xd70dd2ee, 0x4e048354, 0x3903b3c2, 0xa7672661, 0xd06016f7, 0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc, 0x40df0b66, 0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9, 0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605, 0xcdd70693, 0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8, 0x5d681b02, 0x2a6f2b94, 0xb40bbe37, 0xc30c8ea1, 0x5a05df1b, 0x2d02ef8d]);
var ZipContainer = /** @class */function () {
  function ZipContainer() {}
  ZipContainer.addFolders = function (paths) {
    paths.forEach(this.addFolder.bind(this));
  };
  ZipContainer.addFolder = function (path) {
    this.folders.push({
      path: path,
      created: new Date(),
      isBase64: false
    });
  };
  ZipContainer.addFile = function (path, content, isBase64) {
    if (isBase64 === void 0) {
      isBase64 = false;
    }
    this.files.push({
      path: path,
      created: new Date(),
      content: content,
      isBase64: isBase64
    });
  };
  ZipContainer.getContent = function (mimeType) {
    if (mimeType === void 0) {
      mimeType = 'application/zip';
    }
    var textOutput = this.buildFileStream();
    var uInt8Output = this.buildUint8Array(textOutput);
    this.clearStream();
    return new Blob([uInt8Output], {
      type: mimeType
    });
  };
  ZipContainer.clearStream = function () {
    this.folders = [];
    this.files = [];
  };
  ZipContainer.buildFileStream = function (fData) {
    if (fData === void 0) {
      fData = '';
    }
    var totalFiles = this.folders.concat(this.files);
    var len = totalFiles.length;
    var foData = '';
    var lL = 0;
    var cL = 0;
    for (var _i = 0, totalFiles_1 = totalFiles; _i < totalFiles_1.length; _i++) {
      var currentFile = totalFiles_1[_i];
      var _a = this.getHeader(currentFile, lL),
        fileHeader = _a.fileHeader,
        folderHeader = _a.folderHeader,
        content = _a.content;
      lL += fileHeader.length + content.length;
      cL += folderHeader.length;
      fData += fileHeader + content;
      foData += folderHeader;
    }
    var foEnd = this.buildFolderEnd(len, cL, lL);
    return fData + foData + foEnd;
  };
  ZipContainer.getHeader = function (currentFile, offset) {
    var content = currentFile.content,
      path = currentFile.path,
      created = currentFile.created,
      isBase64 = currentFile.isBase64;
    var utf8_encode = _.utf8_encode,
      decToHex = _.decToHex;
    var utfPath = utf8_encode(path);
    var isUTF8 = utfPath !== path;
    var time = this.convertTime(created);
    var dt = this.convertDate(created);
    var extraFields = '';
    if (isUTF8) {
      var uExtraFieldPath = decToHex(1, 1) + decToHex(this.getFromCrc32Table(utfPath), 4) + utfPath;
      extraFields = "\x75\x70" + decToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
    }
    var _a = !content ? {
        size: 0,
        content: ''
      } : this.getConvertedContent(content, isBase64),
      size = _a.size,
      convertedContent = _a.content;
    var header = '\x0A\x00' + (isUTF8 ? '\x00\x08' : '\x00\x00') + '\x00\x00' + decToHex(time, 2) +
    // last modified time
    decToHex(dt, 2) +
    // last modified date
    decToHex(size ? this.getFromCrc32Table(convertedContent) : 0, 4) + decToHex(size, 4) +
    // compressed size
    decToHex(size, 4) +
    // uncompressed size
    decToHex(utfPath.length, 2) +
    // file name length
    decToHex(extraFields.length, 2); // extra field length
    var fileHeader = 'PK\x03\x04' + header + utfPath + extraFields;
    var folderHeader = 'PK\x01\x02' +
    // central header
    '\x14\x00' + header +
    // file header
    '\x00\x00' + '\x00\x00' + '\x00\x00' + (content ? '\x00\x00\x00\x00' : '\x10\x00\x00\x00') +
    // external file attributes
    decToHex(offset, 4) +
    // relative offset of local header
    utfPath +
    // file name
    extraFields; // extra field
    return {
      fileHeader: fileHeader,
      folderHeader: folderHeader,
      content: convertedContent || ''
    };
  };
  ZipContainer.getConvertedContent = function (content, isBase64) {
    if (isBase64 === void 0) {
      isBase64 = false;
    }
    if (isBase64) {
      content = content.split(';base64,')[1];
    }
    content = isBase64 ? atob(content) : content;
    return {
      size: content.length,
      content: content
    };
  };
  ZipContainer.buildFolderEnd = function (tLen, cLen, lLen) {
    var decToHex = _.decToHex;
    return 'PK\x05\x06' +
    // central folder end
    '\x00\x00' + '\x00\x00' + decToHex(tLen, 2) +
    // total number of entries in the central folder
    decToHex(tLen, 2) +
    // total number of entries in the central folder
    decToHex(cLen, 4) +
    // size of the central folder
    decToHex(lLen, 4) +
    // central folder start offset
    '\x00\x00';
  };
  ZipContainer.buildUint8Array = function (content) {
    var uint8 = new Uint8Array(content.length);
    for (var i = 0; i < uint8.length; i++) {
      uint8[i] = content.charCodeAt(i);
    }
    return uint8;
  };
  ZipContainer.getFromCrc32Table = function (content) {
    if (!content.length) {
      return 0;
    }
    var size = content.length;
    var iterable = new Uint8Array(size);
    for (var i = 0; i < size; i++) {
      iterable[i] = content.charCodeAt(i);
    }
    var crc = 0 ^ -1;
    var j = 0;
    var k = 0;
    var l = 0;
    for (var i = 0; i < size; i++) {
      j = iterable[i];
      k = (crc ^ j) & 0xFF;
      l = crcTable[k];
      crc = crc >>> 8 ^ l;
    }
    return crc ^ -1;
  };
  ZipContainer.convertTime = function (date) {
    var time = date.getHours();
    time <<= 6;
    time = time | date.getMinutes();
    time <<= 5;
    time = time | date.getSeconds() / 2;
    return time;
  };
  ZipContainer.convertDate = function (date) {
    var dt = date.getFullYear() - 1980;
    dt <<= 4;
    dt = dt | date.getMonth() + 1;
    dt <<= 5;
    dt = dt | date.getDate();
    return dt;
  };
  ZipContainer.folders = [];
  ZipContainer.files = [];
  return ZipContainer;
}();
var AllCommunityModules = [ClientSideRowModelModule, InfiniteRowModelModule, CsvExportModule];
var __extends$2U = undefined && undefined.__extends || function () {
  var _extendStatics193 = function extendStatics(d, b) {
    _extendStatics193 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics193(d, b);
  };
  return function (d, b) {
    _extendStatics193(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ClipboardService = /** @class */function (_super) {
  __extends$2U(ClipboardService, _super);
  function ClipboardService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.navigatorApiFailed = false;
    return _this;
  }
  ClipboardService.prototype.init = function () {
    var _this = this;
    this.logger = this.loggerFactory.create('ClipboardService');
    if (this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      this.clientSideRowModel = this.rowModel;
    }
    this.ctrlsService.whenReady(function (p) {
      _this.gridCtrl = p.gridCtrl;
    });
  };
  ClipboardService.prototype.pasteFromClipboard = function () {
    var _this = this;
    this.logger.log('pasteFromClipboard');
    // Method 1 - native clipboard API, available in modern chrome browsers
    var allowNavigator = !this.gridOptionsWrapper.isSuppressClipboardApi();
    // Some browsers (Firefox) do not allow Web Applications to read from
    // the clipboard so verify if not only the ClipboardAPI is available,
    // but also if the `readText` method is public.
    if (allowNavigator && !this.navigatorApiFailed && navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard.readText().then(this.processClipboardData.bind(this)).catch(function (e) {
        _.doOnce(function () {
          console.warn(e);
          console.warn('AG Grid: Unable to use the Clipboard API (navigator.clipboard.readText()). ' + 'The reason why it could not be used has been logged in the previous line. ' + 'For this reason the grid has defaulted to using a workaround which doesn\'t perform as well. ' + 'Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid ' + 'property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API');
        }, 'clipboardApiError');
        _this.navigatorApiFailed = true;
        _this.pasteFromClipboardLegacy();
      });
    } else {
      this.pasteFromClipboardLegacy();
    }
  };
  ClipboardService.prototype.pasteFromClipboardLegacy = function () {
    var _this = this;
    // Method 2 - if modern API fails, the old school hack
    this.executeOnTempElement(function (textArea) {
      return textArea.focus({
        preventScroll: true
      });
    }, function (element) {
      var data = element.value;
      _this.processClipboardData(data);
    });
  };
  ClipboardService.prototype.processClipboardData = function (data) {
    var _this = this;
    if (data == null) {
      return;
    }
    var parsedData = _.stringToArray(data, this.gridOptionsWrapper.getClipboardDeliminator());
    var userFunc = this.gridOptionsWrapper.getProcessDataFromClipboardFunc();
    if (userFunc) {
      parsedData = userFunc({
        data: parsedData
      });
    }
    if (parsedData == null) {
      return;
    }
    if (this.gridOptionsWrapper.isSuppressLastEmptyLineOnPaste()) {
      this.removeLastLineIfBlank(parsedData);
    }
    var pasteOperation = function pasteOperation(cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
      var rangeActive = _this.rangeService && _this.rangeService.isMoreThanOneCell();
      var pasteIntoRange = rangeActive && !_this.hasOnlyOneValueToPaste(parsedData);
      if (pasteIntoRange) {
        _this.pasteIntoActiveRange(parsedData, cellsToFlash, updatedRowNodes, changedPath);
      } else {
        _this.pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath);
      }
    };
    this.doPasteOperation(pasteOperation);
  };
  // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
  ClipboardService.prototype.doPasteOperation = function (pasteOperationFunc) {
    var api = this.gridOptionsWrapper.getApi();
    var columnApi = this.gridOptionsWrapper.getColumnApi();
    var source = 'clipboard';
    this.eventService.dispatchEvent({
      type: Events.EVENT_PASTE_START,
      api: api,
      columnApi: columnApi,
      source: source
    });
    var changedPath;
    if (this.clientSideRowModel) {
      var onlyChangedColumns = this.gridOptionsWrapper.isAggregateOnlyChangedColumns();
      changedPath = new ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
    }
    var cellsToFlash = {};
    var updatedRowNodes = [];
    var focusedCell = this.focusService.getFocusedCell();
    pasteOperationFunc(cellsToFlash, updatedRowNodes, focusedCell, changedPath);
    if (changedPath) {
      this.clientSideRowModel.doAggregate(changedPath);
    }
    this.rowRenderer.refreshCells();
    this.dispatchFlashCells(cellsToFlash);
    this.fireRowChanged(updatedRowNodes);
    // if using the clipboard hack with a temp element, then the focus has been lost,
    // so need to put it back. otherwise paste operation loosed focus on cell and keyboard
    // navigation stops.
    if (focusedCell) {
      this.focusService.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned, true);
    }
    this.eventService.dispatchEvent({
      type: Events.EVENT_PASTE_END,
      api: api,
      columnApi: columnApi,
      source: source
    });
  };
  ClipboardService.prototype.pasteIntoActiveRange = function (clipboardData, cellsToFlash, updatedRowNodes, changedPath) {
    var _this = this;
    // true if clipboard data can be evenly pasted into range, otherwise false
    var abortRepeatingPasteIntoRows = this.getRangeSize() % clipboardData.length != 0;
    var indexOffset = 0;
    var dataRowIndex = 0;
    var rowCallback = function rowCallback(currentRow, rowNode, columns, index) {
      var atEndOfClipboardData = index - indexOffset >= clipboardData.length;
      if (atEndOfClipboardData) {
        if (abortRepeatingPasteIntoRows) {
          return;
        }
        // increment offset and reset data index to repeat paste of data
        indexOffset += dataRowIndex;
        dataRowIndex = 0;
      }
      var currentRowData = clipboardData[index - indexOffset];
      // otherwise we are not the first row, so copy
      updatedRowNodes.push(rowNode);
      var processCellFromClipboardFunc = _this.gridOptionsWrapper.getProcessCellFromClipboardFunc();
      columns.forEach(function (column, idx) {
        if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
          return;
        }
        // repeat data for columns we don't have data for - happens when to range is bigger than copied data range
        if (idx >= currentRowData.length) {
          idx = idx % currentRowData.length;
        }
        var newValue = _this.processCell(rowNode, column, currentRowData[idx], Constants.EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc);
        rowNode.setDataValue(column, newValue, Constants.SOURCE_PASTE);
        if (changedPath) {
          changedPath.addParentNode(rowNode.parent, [column]);
        }
        var cellId = _this.cellPositionUtils.createIdFromValues(currentRow.rowIndex, column, currentRow.rowPinned);
        cellsToFlash[cellId] = true;
      });
      dataRowIndex++;
    };
    this.iterateActiveRanges(false, rowCallback);
  };
  ClipboardService.prototype.pasteStartingFromFocusedCell = function (parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
    if (!focusedCell) {
      return;
    }
    var currentRow = {
      rowIndex: focusedCell.rowIndex,
      rowPinned: focusedCell.rowPinned
    };
    var columnsToPasteInto = this.columnModel.getDisplayedColumnsStartingAt(focusedCell.column);
    if (this.isPasteSingleValueIntoRange(parsedData)) {
      this.pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath);
    } else {
      this.pasteMultipleValues(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, Constants.EXPORT_TYPE_CLIPBOARD, changedPath);
    }
  };
  // if range is active, and only one cell, then we paste this cell into all cells in the active range.
  ClipboardService.prototype.isPasteSingleValueIntoRange = function (parsedData) {
    return this.hasOnlyOneValueToPaste(parsedData) && this.rangeService != null && !this.rangeService.isEmpty();
  };
  ClipboardService.prototype.pasteSingleValueIntoRange = function (parsedData, updatedRowNodes, cellsToFlash, changedPath) {
    var _this = this;
    var value = parsedData[0][0];
    var rowCallback = function rowCallback(currentRow, rowNode, columns) {
      updatedRowNodes.push(rowNode);
      columns.forEach(function (column) {
        return _this.updateCellValue(rowNode, column, value, cellsToFlash, Constants.EXPORT_TYPE_CLIPBOARD, changedPath);
      });
    };
    this.iterateActiveRanges(false, rowCallback);
  };
  ClipboardService.prototype.hasOnlyOneValueToPaste = function (parsedData) {
    return parsedData.length === 1 && parsedData[0].length === 1;
  };
  ClipboardService.prototype.copyRangeDown = function () {
    var _this = this;
    if (!this.rangeService || this.rangeService.isEmpty()) {
      return;
    }
    var firstRowValues = [];
    var pasteOperation = function pasteOperation(cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
      var processCellForClipboardFunc = _this.gridOptionsWrapper.getProcessCellForClipboardFunc();
      var processCellFromClipboardFunc = _this.gridOptionsWrapper.getProcessCellFromClipboardFunc();
      var rowCallback = function rowCallback(currentRow, rowNode, columns) {
        // take reference of first row, this is the one we will be using to copy from
        if (!firstRowValues.length) {
          // two reasons for looping through columns
          columns.forEach(function (column) {
            // get the initial values to copy down
            var value = _this.processCell(rowNode, column, _this.valueService.getValue(column, rowNode), Constants.EXPORT_TYPE_DRAG_COPY, processCellForClipboardFunc);
            firstRowValues.push(value);
          });
        } else {
          // otherwise we are not the first row, so copy
          updatedRowNodes.push(rowNode);
          columns.forEach(function (column, index) {
            if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
              return;
            }
            var firstRowValue = _this.processCell(rowNode, column, firstRowValues[index], Constants.EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc);
            rowNode.setDataValue(column, firstRowValue, Constants.SOURCE_PASTE);
            if (changedPath) {
              changedPath.addParentNode(rowNode.parent, [column]);
            }
            var cellId = _this.cellPositionUtils.createIdFromValues(currentRow.rowIndex, column, currentRow.rowPinned);
            cellsToFlash[cellId] = true;
          });
        }
      };
      _this.iterateActiveRanges(true, rowCallback);
    };
    this.doPasteOperation(pasteOperation);
  };
  ClipboardService.prototype.removeLastLineIfBlank = function (parsedData) {
    // remove last row if empty, excel puts empty last row in
    var lastLine = _.last(parsedData);
    var lastLineIsBlank = lastLine && lastLine.length === 1 && lastLine[0] === '';
    if (lastLineIsBlank) {
      _.removeFromArray(parsedData, lastLine);
    }
  };
  ClipboardService.prototype.fireRowChanged = function (rowNodes) {
    var _this = this;
    if (!this.gridOptionsWrapper.isFullRowEdit()) {
      return;
    }
    rowNodes.forEach(function (rowNode) {
      var event = {
        type: Events.EVENT_ROW_VALUE_CHANGED,
        node: rowNode,
        data: rowNode.data,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned,
        context: _this.gridOptionsWrapper.getContext(),
        api: _this.gridOptionsWrapper.getApi(),
        columnApi: _this.gridOptionsWrapper.getColumnApi()
      };
      _this.eventService.dispatchEvent(event);
    });
  };
  ClipboardService.prototype.pasteMultipleValues = function (clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, type, changedPath) {
    var _this = this;
    var rowPointer = currentRow;
    // if doing CSRM and NOT tree data, then it means groups are aggregates, which are read only,
    // so we should skip them when doing paste operations.
    var skipGroupRows = this.clientSideRowModel != null && !this.gridOptionsWrapper.isTreeData();
    var getNextGoodRowNode = function getNextGoodRowNode() {
      while (true) {
        if (!rowPointer) {
          return null;
        }
        var res = _this.rowPositionUtils.getRowNode(rowPointer);
        // move to next row down for next set of values
        rowPointer = _this.cellNavigationService.getRowBelow({
          rowPinned: rowPointer.rowPinned,
          rowIndex: rowPointer.rowIndex
        });
        // if no more rows, return null
        if (res == null) {
          return null;
        }
        // skip details rows and footer rows, never paste into them as they don't hold data
        var skipRow = res.detail || res.footer || skipGroupRows && res.group;
        // skipping row means we go into the next iteration of the while loop
        if (!skipRow) {
          return res;
        }
      }
    };
    clipboardGridData.forEach(function (clipboardRowData) {
      var rowNode = getNextGoodRowNode();
      // if we have come to end of rows in grid, then skip
      if (!rowNode) {
        return;
      }
      clipboardRowData.forEach(function (value, index) {
        return _this.updateCellValue(rowNode, columnsToPasteInto[index], value, cellsToFlash, type, changedPath);
      });
      updatedRowNodes.push(rowNode);
    });
  };
  ClipboardService.prototype.updateCellValue = function (rowNode, column, value, cellsToFlash, type, changedPath) {
    if (!rowNode || !column || !column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
      return;
    }
    var processedValue = this.processCell(rowNode, column, value, type, this.gridOptionsWrapper.getProcessCellFromClipboardFunc());
    rowNode.setDataValue(column, processedValue, Constants.SOURCE_PASTE);
    var cellId = this.cellPositionUtils.createIdFromValues(rowNode.rowIndex, column, rowNode.rowPinned);
    cellsToFlash[cellId] = true;
    if (changedPath) {
      changedPath.addParentNode(rowNode.parent, [column]);
    }
  };
  ClipboardService.prototype.copyToClipboard = function (includeHeaders) {
    this.logger.log("copyToClipboard: includeHeaders = " + includeHeaders);
    // don't override 'includeHeaders' if it has been explicitly set to 'false'
    if (includeHeaders == null) {
      includeHeaders = this.gridOptionsWrapper.isCopyHeadersToClipboard();
    }
    var selectedRowsToCopy = !this.selectionService.isEmpty() && !this.gridOptionsWrapper.isSuppressCopyRowsToClipboard();
    // default is copy range if exists, otherwise rows
    if (this.rangeService && this.rangeService.isMoreThanOneCell()) {
      this.copySelectedRangeToClipboard(includeHeaders);
    } else if (selectedRowsToCopy) {
      // otherwise copy selected rows if they exist
      this.copySelectedRowsToClipboard(includeHeaders);
    } else if (this.focusService.isAnyCellFocused()) {
      // if there is a focused cell, copy this
      this.copyFocusedCellToClipboard(includeHeaders);
    } else {
      // lastly if no focused cell, try range again. this can happen
      // if use has cellSelection turned off (so no focused cell)
      // but has a cell clicked, so there exists a cell range
      // of exactly one cell (hence the first 'if' above didn't
      // get executed).
      this.copySelectedRangeToClipboard(includeHeaders);
    }
  };
  ClipboardService.prototype.iterateActiveRanges = function (onlyFirst, rowCallback, columnCallback) {
    var _this = this;
    if (!this.rangeService || this.rangeService.isEmpty()) {
      return;
    }
    var cellRanges = this.rangeService.getCellRanges();
    if (onlyFirst) {
      this.iterateActiveRange(cellRanges[0], rowCallback, columnCallback, true);
    } else {
      cellRanges.forEach(function (range, idx) {
        return _this.iterateActiveRange(range, rowCallback, columnCallback, idx === cellRanges.length - 1);
      });
    }
  };
  ClipboardService.prototype.iterateActiveRange = function (range, rowCallback, columnCallback, isLastRange) {
    if (!this.rangeService) {
      return;
    }
    var currentRow = this.rangeService.getRangeStartRow(range);
    var lastRow = this.rangeService.getRangeEndRow(range);
    if (columnCallback && range.columns) {
      columnCallback(range.columns);
    }
    var rangeIndex = 0;
    var isLastRow = false;
    // the currentRow could be missing if the user sets the active range manually, and sets a range
    // that is outside of the grid (eg. sets range rows 0 to 100, but grid has only 20 rows).
    while (!isLastRow && currentRow != null) {
      var rowNode = this.rowPositionUtils.getRowNode(currentRow);
      isLastRow = this.rowPositionUtils.sameRow(currentRow, lastRow);
      rowCallback(currentRow, rowNode, range.columns, rangeIndex++, isLastRow && isLastRange);
      currentRow = this.cellNavigationService.getRowBelow(currentRow);
    }
  };
  ClipboardService.prototype.copySelectedRangeToClipboard = function (includeHeaders) {
    var _this = this;
    if (includeHeaders === void 0) {
      includeHeaders = false;
    }
    if (!this.rangeService || this.rangeService.isEmpty()) {
      return;
    }
    var deliminator = this.gridOptionsWrapper.getClipboardDeliminator();
    var data = '';
    var cellsToFlash = {};
    // adds columns to the data
    var columnCallback = function columnCallback(columns) {
      if (!includeHeaders) {
        return;
      }
      var processHeaderForClipboardFunc = _this.gridOptionsWrapper.getProcessHeaderForClipboardFunc();
      var columnNames = columns.map(function (column) {
        var name = _this.columnModel.getDisplayNameForColumn(column, 'clipboard', true);
        return _this.processHeader(column, name, processHeaderForClipboardFunc) || '';
      });
      data += columnNames.join(deliminator) + '\r\n';
    };
    // adds cell values to the data
    var rowCallback = function rowCallback(currentRow, rowNode, columns, _2, isLastRow) {
      var processCellForClipboardFunc = _this.gridOptionsWrapper.getProcessCellForClipboardFunc();
      columns.forEach(function (column, index) {
        var value = _this.valueService.getValue(column, rowNode);
        var processedValue = _this.processCell(rowNode, column, value, Constants.EXPORT_TYPE_CLIPBOARD, processCellForClipboardFunc);
        if (index != 0) {
          data += deliminator;
        }
        if (_.exists(processedValue)) {
          data += processedValue;
        }
        var cellId = _this.cellPositionUtils.createIdFromValues(currentRow.rowIndex, column, currentRow.rowPinned);
        cellsToFlash[cellId] = true;
      });
      if (!isLastRow) {
        data += '\r\n';
      }
    };
    this.iterateActiveRanges(false, rowCallback, columnCallback);
    this.copyDataToClipboard(data);
    this.dispatchFlashCells(cellsToFlash);
  };
  ClipboardService.prototype.copyFocusedCellToClipboard = function (includeHeaders) {
    var _a;
    if (includeHeaders === void 0) {
      includeHeaders = false;
    }
    var focusedCell = this.focusService.getFocusedCell();
    if (focusedCell == null) {
      return;
    }
    var cellId = this.cellPositionUtils.createId(focusedCell);
    var currentRow = {
      rowPinned: focusedCell.rowPinned,
      rowIndex: focusedCell.rowIndex
    };
    var rowNode = this.rowPositionUtils.getRowNode(currentRow);
    var column = focusedCell.column;
    var value = this.valueService.getValue(column, rowNode);
    var processedValue = this.processCell(rowNode, column, value, Constants.EXPORT_TYPE_CLIPBOARD, this.gridOptionsWrapper.getProcessCellForClipboardFunc());
    processedValue = _.missing(processedValue) ? '' : processedValue.toString();
    var data;
    if (includeHeaders) {
      var headerValue = this.columnModel.getDisplayNameForColumn(column, 'clipboard', true);
      data = this.processHeader(column, headerValue, this.gridOptionsWrapper.getProcessHeaderForClipboardFunc()) + '\r\n' + processedValue;
    } else {
      data = processedValue;
    }
    this.copyDataToClipboard(data);
    this.dispatchFlashCells((_a = {}, _a[cellId] = true, _a));
  };
  ClipboardService.prototype.dispatchFlashCells = function (cellsToFlash) {
    var _this = this;
    window.setTimeout(function () {
      var event = {
        type: Events.EVENT_FLASH_CELLS,
        cells: cellsToFlash,
        api: _this.gridApi,
        columnApi: _this.columnApi
      };
      _this.eventService.dispatchEvent(event);
    }, 0);
  };
  ClipboardService.prototype.processCell = function (rowNode, column, value, type, func) {
    if (func) {
      var params = {
        column: column,
        node: rowNode,
        value: value,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext(),
        type: type
      };
      return func(params);
    }
    return value;
  };
  ClipboardService.prototype.processHeader = function (column, value, func) {
    if (func) {
      var params = {
        column: column,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      return func(params);
    }
    return value;
  };
  ClipboardService.prototype.copySelectedRowsToClipboard = function (includeHeaders, columnKeys) {
    if (includeHeaders === void 0) {
      includeHeaders = false;
    }
    var params = {
      columnKeys: columnKeys,
      skipColumnHeaders: !includeHeaders,
      suppressQuotes: true,
      columnSeparator: this.gridOptionsWrapper.getClipboardDeliminator(),
      onlySelected: true,
      processCellCallback: this.gridOptionsWrapper.getProcessCellForClipboardFunc(),
      processHeaderCallback: this.gridOptionsWrapper.getProcessHeaderForClipboardFunc()
    };
    var data = this.csvCreator.getDataAsCsv(params);
    this.copyDataToClipboard(data);
  };
  ClipboardService.prototype.copyDataToClipboard = function (data) {
    var _this = this;
    var userProvidedFunc = this.gridOptionsWrapper.getSendToClipboardFunc();
    // method 1 - user provided func
    if (userProvidedFunc) {
      userProvidedFunc({
        data: data
      });
      return;
    }
    // method 2 - native clipboard API, available in modern chrome browsers
    var allowNavigator = !this.gridOptionsWrapper.isSuppressClipboardApi();
    if (allowNavigator && navigator.clipboard) {
      navigator.clipboard.writeText(data).catch(function (e) {
        _.doOnce(function () {
          console.warn(e);
          console.warn('AG Grid: Unable to use the Clipboard API (navigator.clipboard.writeText()). ' + 'The reason why it could not be used has been logged in the previous line. ' + 'For this reason the grid has defaulted to using a workaround which doesn\'t perform as well. ' + 'Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid ' + 'property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.');
        }, 'clipboardApiError');
        _this.copyDataToClipboardLegacy(data);
      });
      return;
    }
    this.copyDataToClipboardLegacy(data);
  };
  ClipboardService.prototype.copyDataToClipboardLegacy = function (data) {
    var _this = this;
    // method 3 - if all else fails, the old school hack
    this.executeOnTempElement(function (element) {
      var focusedElementBefore = _this.gridOptionsWrapper.getDocument().activeElement;
      element.value = data || ' '; // has to be non-empty value or execCommand will not do anything
      element.select();
      element.focus({
        preventScroll: true
      });
      var result = document.execCommand('copy');
      if (!result) {
        console.warn('ag-grid: Browser did not allow document.execCommand(\'copy\'). Ensure ' + 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise ' + 'the browser will prevent it for security reasons.');
      }
      if (focusedElementBefore != null && focusedElementBefore.focus != null) {
        focusedElementBefore.focus({
          preventScroll: true
        });
      }
    });
  };
  ClipboardService.prototype.executeOnTempElement = function (callbackNow, callbackAfter) {
    var eDoc = this.gridOptionsWrapper.getDocument();
    var eTempInput = eDoc.createElement('textarea');
    eTempInput.style.width = '1px';
    eTempInput.style.height = '1px';
    // removing items from the DOM causes the document element to scroll to the
    // position where the element was positioned. Here we set scrollTop / scrollLeft
    // to prevent the document element from scrolling when we remove it from the DOM.
    eTempInput.style.top = eDoc.documentElement.scrollTop + 'px';
    eTempInput.style.left = eDoc.documentElement.scrollLeft + 'px';
    eTempInput.style.position = 'absolute';
    eTempInput.style.opacity = '0';
    var guiRoot = this.gridCtrl.getGui();
    guiRoot.appendChild(eTempInput);
    try {
      callbackNow(eTempInput);
    } catch (err) {
      console.warn('ag-grid: Browser does not support document.execCommand(\'copy\') for clipboard operations');
    }
    //It needs 100 otherwise OS X seemed to not always be able to paste... Go figure...
    if (callbackAfter) {
      window.setTimeout(function () {
        callbackAfter(eTempInput);
        guiRoot.removeChild(eTempInput);
      }, 100);
    } else {
      guiRoot.removeChild(eTempInput);
    }
  };
  ClipboardService.prototype.getRangeSize = function () {
    var ranges = this.rangeService.getCellRanges();
    var startRangeIndex = 0;
    var endRangeIndex = 0;
    if (ranges.length > 0) {
      startRangeIndex = this.rangeService.getRangeStartRow(ranges[0]).rowIndex;
      endRangeIndex = this.rangeService.getRangeEndRow(ranges[0]).rowIndex;
    }
    return startRangeIndex - endRangeIndex + 1;
  };
  __decorate$2z([Autowired('csvCreator')], ClipboardService.prototype, "csvCreator", void 0);
  __decorate$2z([Autowired('loggerFactory')], ClipboardService.prototype, "loggerFactory", void 0);
  __decorate$2z([Autowired('selectionService')], ClipboardService.prototype, "selectionService", void 0);
  __decorate$2z([Optional('rangeService')], ClipboardService.prototype, "rangeService", void 0);
  __decorate$2z([Autowired('rowModel')], ClipboardService.prototype, "rowModel", void 0);
  __decorate$2z([Autowired('ctrlsService')], ClipboardService.prototype, "ctrlsService", void 0);
  __decorate$2z([Autowired('valueService')], ClipboardService.prototype, "valueService", void 0);
  __decorate$2z([Autowired('focusService')], ClipboardService.prototype, "focusService", void 0);
  __decorate$2z([Autowired('rowRenderer')], ClipboardService.prototype, "rowRenderer", void 0);
  __decorate$2z([Autowired('columnModel')], ClipboardService.prototype, "columnModel", void 0);
  __decorate$2z([Autowired('cellNavigationService')], ClipboardService.prototype, "cellNavigationService", void 0);
  __decorate$2z([Autowired('columnApi')], ClipboardService.prototype, "columnApi", void 0);
  __decorate$2z([Autowired('gridApi')], ClipboardService.prototype, "gridApi", void 0);
  __decorate$2z([Autowired('cellPositionUtils')], ClipboardService.prototype, "cellPositionUtils", void 0);
  __decorate$2z([Autowired('rowPositionUtils')], ClipboardService.prototype, "rowPositionUtils", void 0);
  __decorate$2z([PostConstruct], ClipboardService.prototype, "init", null);
  ClipboardService = __decorate$2z([Bean('clipboardService')], ClipboardService);
  return ClipboardService;
}(BeanStub);
var ClipboardModule = {
  moduleName: ModuleNames.ClipboardModule,
  beans: [ClipboardService],
  dependantModules: [EnterpriseCoreModule, CsvExportModule]
};
var __extends$2V = undefined && undefined.__extends || function () {
  var _extendStatics194 = function extendStatics(d, b) {
    _extendStatics194 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics194(d, b);
  };
  return function (d, b) {
    _extendStatics194(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2A = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ExpandState;
(function (ExpandState) {
  ExpandState[ExpandState["EXPANDED"] = 0] = "EXPANDED";
  ExpandState[ExpandState["COLLAPSED"] = 1] = "COLLAPSED";
  ExpandState[ExpandState["INDETERMINATE"] = 2] = "INDETERMINATE";
})(ExpandState || (ExpandState = {}));
var PrimaryColsHeaderPanel = /** @class */function (_super) {
  __extends$2V(PrimaryColsHeaderPanel, _super);
  function PrimaryColsHeaderPanel() {
    return _super.call(this, PrimaryColsHeaderPanel.TEMPLATE) || this;
  }
  PrimaryColsHeaderPanel.prototype.postConstruct = function () {
    var _this = this;
    this.createExpandIcons();
    this.addManagedListener(this.eExpand, 'click', this.onExpandClicked.bind(this));
    this.addManagedListener(this.eExpand, 'keydown', function (e) {
      if (e.keyCode === KeyCode.SPACE) {
        _this.onExpandClicked();
      }
    });
    this.addManagedListener(this.eSelect.getInputElement(), 'click', this.onSelectClicked.bind(this));
    this.eFilterTextField.onValueChange(function () {
      return _this.onFilterTextChanged();
    });
    this.addManagedListener(this.eFilterTextField.getInputElement(), 'keypress', this.onMiniFilterKeyPress.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eSelect.setInputAriaLabel(translate('ariaColumnSelectAll', 'Toggle Select All Columns'));
    this.eFilterTextField.setInputAriaLabel(translate('ariaFilterColumnsInput', 'Filter Columns Input'));
  };
  PrimaryColsHeaderPanel.prototype.init = function (params) {
    this.params = params;
    if (this.columnModel.isReady()) {
      this.showOrHideOptions();
    }
  };
  PrimaryColsHeaderPanel.prototype.createExpandIcons = function () {
    this.eExpand.appendChild(this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsWrapper));
    this.eExpand.appendChild(this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsWrapper));
    this.eExpand.appendChild(this.eExpandIndeterminate = _.createIconNoSpan('columnSelectIndeterminate', this.gridOptionsWrapper));
    this.setExpandState(ExpandState.EXPANDED);
  };
  // we only show expand / collapse if we are showing columns
  PrimaryColsHeaderPanel.prototype.showOrHideOptions = function () {
    var showFilter = !this.params.suppressColumnFilter;
    var showSelect = !this.params.suppressColumnSelectAll;
    var showExpand = !this.params.suppressColumnExpandAll;
    var groupsPresent = this.columnModel.isPrimaryColumnGroupsPresent();
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFilterTextField.setInputPlaceholder(translate('searchOoo', 'Search...'));
    _.setDisplayed(this.eFilterTextField.getGui(), showFilter);
    _.setDisplayed(this.eSelect.getGui(), showSelect);
    _.setDisplayed(this.eExpand, showExpand && groupsPresent);
  };
  PrimaryColsHeaderPanel.prototype.onFilterTextChanged = function () {
    var _this = this;
    if (!this.onFilterTextChangedDebounced) {
      this.onFilterTextChangedDebounced = _.debounce(function () {
        var filterText = _this.eFilterTextField.getValue();
        _this.dispatchEvent({
          type: "filterChanged",
          filterText: filterText
        });
      }, PrimaryColsHeaderPanel.DEBOUNCE_DELAY);
    }
    this.onFilterTextChangedDebounced();
  };
  PrimaryColsHeaderPanel.prototype.onMiniFilterKeyPress = function (e) {
    var _this = this;
    if (_.isKeyPressed(e, KeyCode.ENTER)) {
      // we need to add a delay that corresponds to the filter text debounce delay to ensure
      // the text filtering has happened, otherwise all columns will be deselected
      setTimeout(function () {
        return _this.onSelectClicked();
      }, PrimaryColsHeaderPanel.DEBOUNCE_DELAY);
    }
  };
  PrimaryColsHeaderPanel.prototype.onSelectClicked = function () {
    this.dispatchEvent({
      type: this.selectState ? 'unselectAll' : 'selectAll'
    });
  };
  PrimaryColsHeaderPanel.prototype.onExpandClicked = function () {
    this.dispatchEvent({
      type: this.expandState === ExpandState.EXPANDED ? 'collapseAll' : 'expandAll'
    });
  };
  PrimaryColsHeaderPanel.prototype.setExpandState = function (state) {
    this.expandState = state;
    _.setDisplayed(this.eExpandChecked, this.expandState === ExpandState.EXPANDED);
    _.setDisplayed(this.eExpandUnchecked, this.expandState === ExpandState.COLLAPSED);
    _.setDisplayed(this.eExpandIndeterminate, this.expandState === ExpandState.INDETERMINATE);
  };
  PrimaryColsHeaderPanel.prototype.setSelectionState = function (state) {
    this.selectState = state;
    this.eSelect.setValue(this.selectState);
  };
  PrimaryColsHeaderPanel.DEBOUNCE_DELAY = 300;
  PrimaryColsHeaderPanel.TEMPLATE = "<div class=\"ag-column-select-header\" role=\"presentation\" tabindex=\"-1\">\n            <div ref=\"eExpand\" class=\"ag-column-select-header-icon\" tabindex=\"0\"></div>\n            <ag-checkbox ref=\"eSelect\" class=\"ag-column-select-header-checkbox\"></ag-checkbox>\n            <ag-input-text-field class=\"ag-column-select-header-filter-wrapper\" ref=\"eFilterTextField\"></ag-input-text-field>\n        </div>";
  __decorate$2A([Autowired('columnModel')], PrimaryColsHeaderPanel.prototype, "columnModel", void 0);
  __decorate$2A([RefSelector('eExpand')], PrimaryColsHeaderPanel.prototype, "eExpand", void 0);
  __decorate$2A([RefSelector('eSelect')], PrimaryColsHeaderPanel.prototype, "eSelect", void 0);
  __decorate$2A([RefSelector('eFilterTextField')], PrimaryColsHeaderPanel.prototype, "eFilterTextField", void 0);
  __decorate$2A([PostConstruct], PrimaryColsHeaderPanel.prototype, "postConstruct", null);
  return PrimaryColsHeaderPanel;
}(Component);
var ColumnModelItem = /** @class */function () {
  function ColumnModelItem(displayName, columnOrGroup, dept, group, expanded) {
    if (group === void 0) {
      group = false;
    }
    this.eventService = new EventService();
    this.displayName = displayName;
    this.dept = dept;
    this.group = group;
    if (group) {
      this.columnGroup = columnOrGroup;
      this.expanded = expanded;
      this.children = [];
    } else {
      this.column = columnOrGroup;
    }
  }
  ColumnModelItem.prototype.isGroup = function () {
    return this.group;
  };
  ColumnModelItem.prototype.getDisplayName = function () {
    return this.displayName;
  };
  ColumnModelItem.prototype.getColumnGroup = function () {
    return this.columnGroup;
  };
  ColumnModelItem.prototype.getColumn = function () {
    return this.column;
  };
  ColumnModelItem.prototype.getDept = function () {
    return this.dept;
  };
  ColumnModelItem.prototype.isExpanded = function () {
    return !!this.expanded;
  };
  ColumnModelItem.prototype.getChildren = function () {
    return this.children;
  };
  ColumnModelItem.prototype.isPassesFilter = function () {
    return this.passesFilter;
  };
  ColumnModelItem.prototype.setExpanded = function (expanded) {
    if (expanded === this.expanded) {
      return;
    }
    this.expanded = expanded;
    this.eventService.dispatchEvent({
      type: ColumnModelItem.EVENT_EXPANDED_CHANGED
    });
  };
  ColumnModelItem.prototype.setPassesFilter = function (passesFilter) {
    this.passesFilter = passesFilter;
  };
  ColumnModelItem.prototype.addEventListener = function (eventType, listener) {
    this.eventService.addEventListener(eventType, listener);
  };
  ColumnModelItem.prototype.removeEventListener = function (eventType, listener) {
    this.eventService.removeEventListener(eventType, listener);
  };
  ColumnModelItem.EVENT_EXPANDED_CHANGED = 'expandedChanged';
  return ColumnModelItem;
}();
var __extends$2W = undefined && undefined.__extends || function () {
  var _extendStatics195 = function extendStatics(d, b) {
    _extendStatics195 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics195(d, b);
  };
  return function (d, b) {
    _extendStatics195(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2B = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelColumnGroupComp = /** @class */function (_super) {
  __extends$2W(ToolPanelColumnGroupComp, _super);
  function ToolPanelColumnGroupComp(modelItem, allowDragging, eventType, focusWrapper) {
    var _this = _super.call(this) || this;
    _this.modelItem = modelItem;
    _this.allowDragging = allowDragging;
    _this.eventType = eventType;
    _this.focusWrapper = focusWrapper;
    _this.processingColumnStateChange = false;
    _this.modelItem = modelItem;
    _this.columnGroup = modelItem.getColumnGroup();
    _this.columnDept = modelItem.getDept();
    _this.allowDragging = allowDragging;
    return _this;
  }
  ToolPanelColumnGroupComp.prototype.init = function () {
    var _this = this;
    this.setTemplate(ToolPanelColumnGroupComp.TEMPLATE);
    this.eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsWrapper);
    _.addCssClass(this.eDragHandle, 'ag-drag-handle');
    _.addCssClass(this.eDragHandle, 'ag-column-select-column-group-drag-handle');
    var checkboxGui = this.cbSelect.getGui();
    var checkboxInput = this.cbSelect.getInputElement();
    checkboxGui.insertAdjacentElement('afterend', this.eDragHandle);
    checkboxInput.setAttribute('tabindex', '-1');
    this.displayName = this.columnModel.getDisplayNameForOriginalColumnGroup(null, this.columnGroup, this.eventType);
    if (_.missing(this.displayName)) {
      this.displayName = '>>';
    }
    this.eLabel.innerHTML = this.displayName ? this.displayName : '';
    this.setupExpandContract();
    this.addCssClass('ag-column-select-indent-' + this.columnDept);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
    this.addManagedListener(this.cbSelect, AgCheckbox.EVENT_CHANGED, this.onCheckboxChanged.bind(this));
    this.addManagedListener(this.modelItem, ColumnModelItem.EVENT_EXPANDED_CHANGED, this.onExpandChanged.bind(this));
    this.addManagedListener(this.focusWrapper, 'keydown', this.handleKeyDown.bind(this));
    this.setOpenClosedIcons();
    this.setupDragging();
    this.onColumnStateChanged();
    this.addVisibilityListenersToAllChildren();
    this.refreshAriaExpanded();
    this.refreshAriaLabel();
    this.setupTooltip();
    var classes = CssClassApplier.getToolPanelClassesFromColDef(this.columnGroup.getColGroupDef(), this.gridOptionsWrapper, null, this.columnGroup);
    classes.forEach(function (c) {
      return _this.addOrRemoveCssClass(c, true);
    });
  };
  ToolPanelColumnGroupComp.prototype.getColumns = function () {
    return this.columnGroup.getLeafColumns();
  };
  ToolPanelColumnGroupComp.prototype.setupTooltip = function () {
    var _this = this;
    var colGroupDef = this.columnGroup.getColGroupDef();
    if (!colGroupDef) {
      return;
    }
    var refresh = function refresh() {
      var newTooltipText = colGroupDef.headerTooltip;
      _this.setTooltip(newTooltipText);
    };
    refresh();
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
  };
  ToolPanelColumnGroupComp.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'columnToolPanelColumnGroup';
    return res;
  };
  ToolPanelColumnGroupComp.prototype.handleKeyDown = function (e) {
    switch (e.keyCode) {
      case KeyCode.LEFT:
        e.preventDefault();
        this.modelItem.setExpanded(false);
        break;
      case KeyCode.RIGHT:
        e.preventDefault();
        this.modelItem.setExpanded(true);
        break;
      case KeyCode.SPACE:
        e.preventDefault();
        if (this.isSelectable()) {
          this.onSelectAllChanged(!this.isSelected());
        }
        break;
    }
  };
  ToolPanelColumnGroupComp.prototype.addVisibilityListenersToAllChildren = function () {
    var _this = this;
    this.columnGroup.getLeafColumns().forEach(function (column) {
      _this.addManagedListener(column, Column.EVENT_VISIBLE_CHANGED, _this.onColumnStateChanged.bind(_this));
      _this.addManagedListener(column, Column.EVENT_VALUE_CHANGED, _this.onColumnStateChanged.bind(_this));
      _this.addManagedListener(column, Column.EVENT_PIVOT_CHANGED, _this.onColumnStateChanged.bind(_this));
      _this.addManagedListener(column, Column.EVENT_ROW_GROUP_CHANGED, _this.onColumnStateChanged.bind(_this));
    });
  };
  ToolPanelColumnGroupComp.prototype.setupDragging = function () {
    var _this = this;
    if (!this.allowDragging) {
      _.setDisplayed(this.eDragHandle, false);
      return;
    }
    var dragSource = {
      type: DragSourceType.ToolPanel,
      eElement: this.eDragHandle,
      dragItemName: this.displayName,
      getDragItem: function getDragItem() {
        return _this.createDragItem();
      },
      onDragStarted: function onDragStarted() {
        var event = {
          type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
          column: _this.columnGroup
        };
        _this.eventService.dispatchEvent(event);
      },
      onDragStopped: function onDragStopped() {
        var event = {
          type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END
        };
        _this.eventService.dispatchEvent(event);
      }
    };
    this.dragAndDropService.addDragSource(dragSource, true);
    this.addDestroyFunc(function () {
      return _this.dragAndDropService.removeDragSource(dragSource);
    });
  };
  ToolPanelColumnGroupComp.prototype.createDragItem = function () {
    var visibleState = {};
    this.columnGroup.getLeafColumns().forEach(function (col) {
      visibleState[col.getId()] = col.isVisible();
    });
    return {
      columns: this.columnGroup.getLeafColumns(),
      visibleState: visibleState
    };
  };
  ToolPanelColumnGroupComp.prototype.setupExpandContract = function () {
    this.eGroupClosedIcon.appendChild(_.createIcon('columnSelectClosed', this.gridOptionsWrapper, null));
    this.eGroupOpenedIcon.appendChild(_.createIcon('columnSelectOpen', this.gridOptionsWrapper, null));
    this.addManagedListener(this.eGroupClosedIcon, 'click', this.onExpandOrContractClicked.bind(this));
    this.addManagedListener(this.eGroupOpenedIcon, 'click', this.onExpandOrContractClicked.bind(this));
    var touchListener = new TouchListener(this.eColumnGroupIcons, true);
    this.addManagedListener(touchListener, TouchListener.EVENT_TAP, this.onExpandOrContractClicked.bind(this));
    this.addDestroyFunc(touchListener.destroy.bind(touchListener));
  };
  ToolPanelColumnGroupComp.prototype.onLabelClicked = function () {
    var nextState = !this.cbSelect.getValue();
    this.onChangeCommon(nextState);
  };
  ToolPanelColumnGroupComp.prototype.onCheckboxChanged = function (event) {
    this.onChangeCommon(event.selected);
  };
  ToolPanelColumnGroupComp.prototype.getVisibleLeafColumns = function () {
    var childColumns = [];
    var extractCols = function extractCols(children) {
      children.forEach(function (child) {
        if (!child.isPassesFilter()) {
          return;
        }
        if (child.isGroup()) {
          extractCols(child.getChildren());
        } else {
          childColumns.push(child.getColumn());
        }
      });
    };
    extractCols(this.modelItem.getChildren());
    return childColumns;
  };
  ToolPanelColumnGroupComp.prototype.onChangeCommon = function (nextState) {
    this.refreshAriaLabel();
    if (this.processingColumnStateChange) {
      return;
    }
    this.modelItemUtils.selectAllChildren(this.modelItem.getChildren(), nextState, this.eventType);
  };
  ToolPanelColumnGroupComp.prototype.refreshAriaLabel = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var columnLabel = translate('ariaColumnGroup', 'Column Group');
    var state = this.cbSelect.getValue() ? translate('ariaVisible', 'visible') : translate('ariaHidden', 'hidden');
    var visibilityLabel = translate('ariaToggleVisibility', 'Press SPACE to toggle visibility');
    _.setAriaLabel(this.focusWrapper, this.displayName + " " + columnLabel);
    this.cbSelect.setInputAriaLabel(visibilityLabel + " (" + state + ")");
    _.setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
  };
  ToolPanelColumnGroupComp.prototype.onColumnStateChanged = function () {
    var selectedValue = this.workOutSelectedValue();
    var readOnlyValue = this.workOutReadOnlyValue();
    this.processingColumnStateChange = true;
    this.cbSelect.setValue(selectedValue);
    this.cbSelect.setReadOnly(readOnlyValue);
    _.addOrRemoveCssClass(this.getGui(), 'ag-column-select-column-group-readonly', readOnlyValue);
    this.processingColumnStateChange = false;
  };
  ToolPanelColumnGroupComp.prototype.workOutSelectedValue = function () {
    var _this = this;
    var pivotMode = this.columnModel.isPivotMode();
    var visibleLeafColumns = this.getVisibleLeafColumns();
    var checkedCount = 0;
    var uncheckedCount = 0;
    visibleLeafColumns.forEach(function (column) {
      if (!pivotMode && column.getColDef().lockVisible) {
        return;
      }
      if (_this.isColumnChecked(column, pivotMode)) {
        checkedCount++;
      } else {
        uncheckedCount++;
      }
    });
    if (checkedCount > 0 && uncheckedCount > 0) {
      return undefined;
    }
    return checkedCount > 0;
  };
  ToolPanelColumnGroupComp.prototype.workOutReadOnlyValue = function () {
    var pivotMode = this.columnModel.isPivotMode();
    var colsThatCanAction = 0;
    this.columnGroup.getLeafColumns().forEach(function (col) {
      if (pivotMode) {
        if (col.isAnyFunctionAllowed()) {
          colsThatCanAction++;
        }
      } else {
        if (!col.getColDef().lockVisible) {
          colsThatCanAction++;
        }
      }
    });
    return colsThatCanAction === 0;
  };
  ToolPanelColumnGroupComp.prototype.isColumnChecked = function (column, pivotMode) {
    if (pivotMode) {
      var pivoted = column.isPivotActive();
      var grouped = column.isRowGroupActive();
      var aggregated = column.isValueActive();
      return pivoted || grouped || aggregated;
    }
    return column.isVisible();
  };
  ToolPanelColumnGroupComp.prototype.onExpandOrContractClicked = function () {
    var oldState = this.modelItem.isExpanded();
    this.modelItem.setExpanded(!oldState);
  };
  ToolPanelColumnGroupComp.prototype.onExpandChanged = function () {
    this.setOpenClosedIcons();
    this.refreshAriaExpanded();
  };
  ToolPanelColumnGroupComp.prototype.setOpenClosedIcons = function () {
    var folderOpen = this.modelItem.isExpanded();
    _.setDisplayed(this.eGroupClosedIcon, !folderOpen);
    _.setDisplayed(this.eGroupOpenedIcon, folderOpen);
  };
  ToolPanelColumnGroupComp.prototype.refreshAriaExpanded = function () {
    _.setAriaExpanded(this.focusWrapper, this.modelItem.isExpanded());
  };
  ToolPanelColumnGroupComp.prototype.getDisplayName = function () {
    return this.displayName;
  };
  ToolPanelColumnGroupComp.prototype.onSelectAllChanged = function (value) {
    var cbValue = this.cbSelect.getValue();
    var readOnly = this.cbSelect.isReadOnly();
    if (!readOnly && (value && !cbValue || !value && cbValue)) {
      this.cbSelect.toggle();
    }
  };
  ToolPanelColumnGroupComp.prototype.isSelected = function () {
    return this.cbSelect.getValue();
  };
  ToolPanelColumnGroupComp.prototype.isSelectable = function () {
    return !this.cbSelect.isReadOnly();
  };
  ToolPanelColumnGroupComp.prototype.setSelected = function (selected) {
    this.cbSelect.setValue(selected, true);
  };
  ToolPanelColumnGroupComp.TEMPLATE = "<div class=\"ag-column-select-column-group\" aria-hidden=\"true\">\n            <span class=\"ag-column-group-icons\" ref=\"eColumnGroupIcons\" >\n                <span class=\"ag-column-group-closed-icon\" ref=\"eGroupClosedIcon\"></span>\n                <span class=\"ag-column-group-opened-icon\" ref=\"eGroupOpenedIcon\"></span>\n            </span>\n            <ag-checkbox ref=\"cbSelect\" class=\"ag-column-select-checkbox\"></ag-checkbox>\n            <span class=\"ag-column-select-column-label\" ref=\"eLabel\"></span>\n        </div>";
  __decorate$2B([Autowired('columnModel')], ToolPanelColumnGroupComp.prototype, "columnModel", void 0);
  __decorate$2B([Autowired('dragAndDropService')], ToolPanelColumnGroupComp.prototype, "dragAndDropService", void 0);
  __decorate$2B([Autowired('modelItemUtils')], ToolPanelColumnGroupComp.prototype, "modelItemUtils", void 0);
  __decorate$2B([RefSelector('cbSelect')], ToolPanelColumnGroupComp.prototype, "cbSelect", void 0);
  __decorate$2B([RefSelector('eLabel')], ToolPanelColumnGroupComp.prototype, "eLabel", void 0);
  __decorate$2B([RefSelector('eGroupOpenedIcon')], ToolPanelColumnGroupComp.prototype, "eGroupOpenedIcon", void 0);
  __decorate$2B([RefSelector('eGroupClosedIcon')], ToolPanelColumnGroupComp.prototype, "eGroupClosedIcon", void 0);
  __decorate$2B([RefSelector('eColumnGroupIcons')], ToolPanelColumnGroupComp.prototype, "eColumnGroupIcons", void 0);
  __decorate$2B([PostConstruct], ToolPanelColumnGroupComp.prototype, "init", null);
  return ToolPanelColumnGroupComp;
}(Component);
var __extends$2X = undefined && undefined.__extends || function () {
  var _extendStatics196 = function extendStatics(d, b) {
    _extendStatics196 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics196(d, b);
  };
  return function (d, b) {
    _extendStatics196(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2C = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PRIMARY_COLS_LIST_ITEM_HOVERED = 'ag-column-list-item-hovered';
var PrimaryColsListPanelItemDragFeature = /** @class */function (_super) {
  __extends$2X(PrimaryColsListPanelItemDragFeature, _super);
  function PrimaryColsListPanelItemDragFeature(comp, virtualList) {
    var _this = _super.call(this) || this;
    _this.comp = comp;
    _this.virtualList = virtualList;
    _this.currentDragColumn = null;
    _this.lastHoveredColumnItem = null;
    return _this;
  }
  PrimaryColsListPanelItemDragFeature.prototype.postConstruct = function () {
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START, this.columnPanelItemDragStart.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END, this.columnPanelItemDragEnd.bind(this));
    this.createDropTarget();
    this.createAutoScrollService();
  };
  PrimaryColsListPanelItemDragFeature.prototype.columnPanelItemDragStart = function (_a) {
    var column = _a.column;
    this.currentDragColumn = column;
    var currentColumns = this.getCurrentColumns();
    var hasNotMovable = _.find(currentColumns, function (col) {
      var colDef = col.getColDef();
      return !!colDef.suppressMovable || !!colDef.lockPosition;
    });
    if (hasNotMovable) {
      this.moveBlocked = true;
    }
  };
  PrimaryColsListPanelItemDragFeature.prototype.columnPanelItemDragEnd = function () {
    var _this = this;
    window.setTimeout(function () {
      _this.currentDragColumn = null;
      _this.moveBlocked = false;
    }, 10);
  };
  PrimaryColsListPanelItemDragFeature.prototype.createDropTarget = function () {
    var _this = this;
    var dropTarget = {
      isInterestedIn: function isInterestedIn(type) {
        return type === DragSourceType.ToolPanel;
      },
      getIconName: function getIconName() {
        return DragAndDropService[_this.moveBlocked ? 'ICON_NOT_ALLOWED' : 'ICON_MOVE'];
      },
      getContainer: function getContainer() {
        return _this.comp.getGui();
      },
      onDragging: function onDragging(e) {
        return _this.onDragging(e);
      },
      onDragStop: function onDragStop() {
        return _this.onDragStop();
      },
      onDragLeave: function onDragLeave() {
        return _this.onDragLeave();
      }
    };
    this.dragAndDropService.addDropTarget(dropTarget);
  };
  PrimaryColsListPanelItemDragFeature.prototype.createAutoScrollService = function () {
    var virtualListGui = this.virtualList.getGui();
    this.autoScrollService = new AutoScrollService({
      scrollContainer: virtualListGui,
      scrollAxis: 'y',
      getVerticalPosition: function getVerticalPosition() {
        return virtualListGui.scrollTop;
      },
      setVerticalPosition: function setVerticalPosition(position) {
        return virtualListGui.scrollTop = position;
      }
    });
  };
  PrimaryColsListPanelItemDragFeature.prototype.onDragging = function (e) {
    if (!this.currentDragColumn || this.moveBlocked) {
      return;
    }
    var hoveredColumnItem = this.getDragColumnItem(e);
    var comp = this.virtualList.getComponentAt(hoveredColumnItem.rowIndex);
    if (!comp) {
      return;
    }
    var el = comp.getGui().parentElement;
    if (this.lastHoveredColumnItem && this.lastHoveredColumnItem.rowIndex === hoveredColumnItem.rowIndex && this.lastHoveredColumnItem.position === hoveredColumnItem.position) {
      return;
    }
    this.autoScrollService.check(e.event);
    this.clearHoveredItems();
    this.lastHoveredColumnItem = hoveredColumnItem;
    _.radioCssClass(el, "" + PRIMARY_COLS_LIST_ITEM_HOVERED);
    _.radioCssClass(el, "ag-item-highlight-" + hoveredColumnItem.position);
  };
  PrimaryColsListPanelItemDragFeature.prototype.getDragColumnItem = function (e) {
    var virtualListGui = this.virtualList.getGui();
    var paddingTop = parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
    var rowHeight = this.virtualList.getRowHeight();
    var scrollTop = this.virtualList.getScrollTop();
    var rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
    var maxLen = this.comp.getDisplayedColsList().length - 1;
    var normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
    return {
      rowIndex: normalizedRowIndex,
      position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? 'bottom' : 'top',
      component: this.virtualList.getComponentAt(normalizedRowIndex)
    };
  };
  PrimaryColsListPanelItemDragFeature.prototype.onDragStop = function () {
    if (this.moveBlocked) {
      return;
    }
    var targetIndex = this.getTargetIndex();
    var columnsToMove = this.getCurrentColumns();
    if (targetIndex != null) {
      this.columnModel.moveColumns(columnsToMove, targetIndex);
    }
    this.clearHoveredItems();
    this.autoScrollService.ensureCleared();
  };
  PrimaryColsListPanelItemDragFeature.prototype.getMoveDiff = function (end) {
    var allColumns = this.columnModel.getAllGridColumns();
    var currentColumns = this.getCurrentColumns();
    var currentColumn = currentColumns[0];
    var span = currentColumns.length;
    var currentIndex = allColumns.indexOf(currentColumn);
    if (currentIndex < end) {
      return span;
    }
    return 0;
  };
  PrimaryColsListPanelItemDragFeature.prototype.getCurrentColumns = function () {
    if (this.currentDragColumn instanceof ProvidedColumnGroup) {
      return this.currentDragColumn.getLeafColumns();
    }
    return [this.currentDragColumn];
  };
  PrimaryColsListPanelItemDragFeature.prototype.getTargetIndex = function () {
    if (!this.lastHoveredColumnItem) {
      return null;
    }
    var columnItemComponent = this.lastHoveredColumnItem.component;
    var isBefore = this.lastHoveredColumnItem.position === 'top';
    var targetColumn;
    if (columnItemComponent instanceof ToolPanelColumnGroupComp) {
      var columns = columnItemComponent.getColumns();
      targetColumn = columns[0];
      isBefore = true;
    } else {
      targetColumn = columnItemComponent.getColumn();
    }
    var targetColumnIndex = this.columnModel.getAllGridColumns().indexOf(targetColumn);
    var adjustedTarget = isBefore ? targetColumnIndex : targetColumnIndex + 1;
    var diff = this.getMoveDiff(adjustedTarget);
    return adjustedTarget - diff;
  };
  PrimaryColsListPanelItemDragFeature.prototype.onDragLeave = function () {
    this.clearHoveredItems();
    this.autoScrollService.ensureCleared();
  };
  PrimaryColsListPanelItemDragFeature.prototype.clearHoveredItems = function () {
    var virtualListGui = this.virtualList.getGui();
    virtualListGui.querySelectorAll("." + PRIMARY_COLS_LIST_ITEM_HOVERED).forEach(function (el) {
      [PRIMARY_COLS_LIST_ITEM_HOVERED, 'ag-item-highlight-top', 'ag-item-highlight-bottom'].forEach(function (cls) {
        _.removeCssClass(el, cls);
      });
    });
    this.lastHoveredColumnItem = null;
  };
  __decorate$2C([Autowired('columnModel')], PrimaryColsListPanelItemDragFeature.prototype, "columnModel", void 0);
  __decorate$2C([Autowired('dragAndDropService')], PrimaryColsListPanelItemDragFeature.prototype, "dragAndDropService", void 0);
  __decorate$2C([PostConstruct], PrimaryColsListPanelItemDragFeature.prototype, "postConstruct", null);
  return PrimaryColsListPanelItemDragFeature;
}(BeanStub);
var __extends$2Y = undefined && undefined.__extends || function () {
  var _extendStatics197 = function extendStatics(d, b) {
    _extendStatics197 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics197(d, b);
  };
  return function (d, b) {
    _extendStatics197(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2D = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelColumnComp = /** @class */function (_super) {
  __extends$2Y(ToolPanelColumnComp, _super);
  function ToolPanelColumnComp(column, columnDept, allowDragging, groupsExist, focusWrapper) {
    var _this = _super.call(this) || this;
    _this.column = column;
    _this.columnDept = columnDept;
    _this.allowDragging = allowDragging;
    _this.groupsExist = groupsExist;
    _this.focusWrapper = focusWrapper;
    _this.processingColumnStateChange = false;
    return _this;
  }
  ToolPanelColumnComp.prototype.init = function () {
    var _this = this;
    this.setTemplate(ToolPanelColumnComp.TEMPLATE);
    this.eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsWrapper);
    _.addCssClass(this.eDragHandle, 'ag-drag-handle');
    _.addCssClass(this.eDragHandle, 'ag-column-select-column-drag-handle');
    var checkboxGui = this.cbSelect.getGui();
    var checkboxInput = this.cbSelect.getInputElement();
    checkboxGui.insertAdjacentElement('afterend', this.eDragHandle);
    checkboxInput.setAttribute('tabindex', '-1');
    this.displayName = this.columnModel.getDisplayNameForColumn(this.column, 'columnToolPanel');
    var displayNameSanitised = _.escapeString(this.displayName);
    this.eLabel.innerHTML = displayNameSanitised;
    // if grouping, we add an extra level of indent, to cater for expand/contract icons we need to indent for
    var indent = this.columnDept;
    if (this.groupsExist) {
      this.addCssClass('ag-column-select-add-group-indent');
    }
    this.addCssClass("ag-column-select-indent-" + indent);
    this.setupDragging();
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.column, Column.EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.column, Column.EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.column, Column.EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.column, Column.EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.focusWrapper, 'keydown', this.handleKeyDown.bind(this));
    this.addManagedListener(this.gridOptionsWrapper, 'functionsReadOnly', this.onColumnStateChanged.bind(this));
    this.addManagedListener(this.cbSelect, AgCheckbox.EVENT_CHANGED, this.onCheckboxChanged.bind(this));
    this.addManagedListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
    this.onColumnStateChanged();
    this.refreshAriaLabel();
    this.setupTooltip();
    var classes = CssClassApplier.getToolPanelClassesFromColDef(this.column.getColDef(), this.gridOptionsWrapper, this.column, null);
    classes.forEach(function (c) {
      return _this.addOrRemoveCssClass(c, true);
    });
  };
  ToolPanelColumnComp.prototype.getColumn = function () {
    return this.column;
  };
  ToolPanelColumnComp.prototype.setupTooltip = function () {
    var _this = this;
    var refresh = function refresh() {
      var newTooltipText = _this.column.getColDef().headerTooltip;
      _this.setTooltip(newTooltipText);
    };
    refresh();
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
  };
  ToolPanelColumnComp.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'columnToolPanelColumn';
    res.colDef = this.column.getColDef();
    return res;
  };
  ToolPanelColumnComp.prototype.handleKeyDown = function (e) {
    if (e.keyCode === KeyCode.SPACE) {
      e.preventDefault();
      if (this.isSelectable()) {
        this.onSelectAllChanged(!this.isSelected());
      }
    }
  };
  ToolPanelColumnComp.prototype.onLabelClicked = function () {
    if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
      return;
    }
    var nextState = !this.cbSelect.getValue();
    this.onChangeCommon(nextState);
  };
  ToolPanelColumnComp.prototype.onCheckboxChanged = function (event) {
    this.onChangeCommon(event.selected);
  };
  ToolPanelColumnComp.prototype.onChangeCommon = function (nextState) {
    // ignore lock visible columns
    if (this.cbSelect.isReadOnly()) {
      return;
    }
    this.refreshAriaLabel();
    // only want to action if the user clicked the checkbox, not if we are setting the checkbox because
    // of a change in the model
    if (this.processingColumnStateChange) {
      return;
    }
    this.modelItemUtils.setColumn(this.column, nextState, 'toolPanelUi');
  };
  ToolPanelColumnComp.prototype.refreshAriaLabel = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var columnLabel = translate('ariaColumn', 'Column');
    var state = this.cbSelect.getValue() ? translate('ariaVisible', 'visible') : translate('ariaHidden', 'hidden');
    var visibilityLabel = translate('ariaToggleVisibility', 'Press SPACE to toggle visibility');
    _.setAriaLabel(this.focusWrapper, this.displayName + " " + columnLabel);
    this.cbSelect.setInputAriaLabel(visibilityLabel + " (" + state + ")");
    _.setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
  };
  ToolPanelColumnComp.prototype.setupDragging = function () {
    var _this = this;
    if (!this.allowDragging) {
      _.setDisplayed(this.eDragHandle, false);
      return;
    }
    var dragSource = {
      type: DragSourceType.ToolPanel,
      eElement: this.eDragHandle,
      dragItemName: this.displayName,
      getDragItem: function getDragItem() {
        return _this.createDragItem();
      },
      onDragStarted: function onDragStarted() {
        var event = {
          type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
          column: _this.column
        };
        _this.eventService.dispatchEvent(event);
      },
      onDragStopped: function onDragStopped() {
        var event = {
          type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END
        };
        _this.eventService.dispatchEvent(event);
      }
    };
    this.dragAndDropService.addDragSource(dragSource, true);
    this.addDestroyFunc(function () {
      return _this.dragAndDropService.removeDragSource(dragSource);
    });
  };
  ToolPanelColumnComp.prototype.createDragItem = function () {
    var visibleState = {};
    visibleState[this.column.getId()] = this.column.isVisible();
    return {
      columns: [this.column],
      visibleState: visibleState
    };
  };
  ToolPanelColumnComp.prototype.onColumnStateChanged = function () {
    this.processingColumnStateChange = true;
    var isPivotMode = this.columnModel.isPivotMode();
    if (isPivotMode) {
      // if reducing, checkbox means column is one of pivot, value or group
      var anyFunctionActive = this.column.isAnyFunctionActive();
      this.cbSelect.setValue(anyFunctionActive);
    } else {
      // if not reducing, the checkbox tells us if column is visible or not
      this.cbSelect.setValue(this.column.isVisible());
    }
    var canBeToggled = true;
    var canBeDragged = true;
    if (isPivotMode) {
      // when in pivot mode, the item should be read only if:
      //  a) gui is not allowed make any changes
      var functionsReadOnly = this.gridOptionsWrapper.isFunctionsReadOnly();
      //  b) column is not allow any functions on it
      var noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
      canBeToggled = !functionsReadOnly && !noFunctionsAllowed;
    } else {
      canBeToggled = !this.column.getColDef().lockVisible;
      canBeDragged = !this.column.getColDef().lockPosition;
    }
    this.cbSelect.setReadOnly(!canBeToggled);
    _.addOrRemoveCssClass(this.eDragHandle, 'ag-column-select-column-readonly', !canBeDragged);
    _.addOrRemoveCssClass(this.getGui(), 'ag-column-select-column-readonly', !canBeDragged && !canBeToggled);
    var checkboxPassive = isPivotMode && this.gridOptionsWrapper.isFunctionsPassive();
    this.cbSelect.setPassive(checkboxPassive);
    this.processingColumnStateChange = false;
  };
  ToolPanelColumnComp.prototype.getDisplayName = function () {
    return this.displayName;
  };
  ToolPanelColumnComp.prototype.onSelectAllChanged = function (value) {
    if (value !== this.cbSelect.getValue()) {
      if (!this.cbSelect.isReadOnly()) {
        this.cbSelect.toggle();
      }
    }
  };
  ToolPanelColumnComp.prototype.isSelected = function () {
    return this.cbSelect.getValue();
  };
  ToolPanelColumnComp.prototype.isSelectable = function () {
    return !this.cbSelect.isReadOnly();
  };
  ToolPanelColumnComp.prototype.isExpandable = function () {
    return false;
  };
  ToolPanelColumnComp.prototype.setExpanded = function (value) {
    console.warn('ag-grid: can not expand a column item that does not represent a column group header');
  };
  ToolPanelColumnComp.TEMPLATE = "<div class=\"ag-column-select-column\" aria-hidden=\"true\">\n            <ag-checkbox ref=\"cbSelect\" class=\"ag-column-select-checkbox\"></ag-checkbox>\n            <span class=\"ag-column-select-column-label\" ref=\"eLabel\"></span>\n        </div>";
  __decorate$2D([Autowired('columnModel')], ToolPanelColumnComp.prototype, "columnModel", void 0);
  __decorate$2D([Autowired('dragAndDropService')], ToolPanelColumnComp.prototype, "dragAndDropService", void 0);
  __decorate$2D([Autowired('modelItemUtils')], ToolPanelColumnComp.prototype, "modelItemUtils", void 0);
  __decorate$2D([RefSelector('eLabel')], ToolPanelColumnComp.prototype, "eLabel", void 0);
  __decorate$2D([RefSelector('cbSelect')], ToolPanelColumnComp.prototype, "cbSelect", void 0);
  __decorate$2D([PostConstruct], ToolPanelColumnComp.prototype, "init", null);
  return ToolPanelColumnComp;
}(Component);
var __extends$2Z = undefined && undefined.__extends || function () {
  var _extendStatics198 = function extendStatics(d, b) {
    _extendStatics198 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics198(d, b);
  };
  return function (d, b) {
    _extendStatics198(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2E = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UIColumnModel = /** @class */function () {
  function UIColumnModel(items) {
    this.items = items;
  }
  UIColumnModel.prototype.getRowCount = function () {
    return this.items.length;
  };
  UIColumnModel.prototype.getRow = function (index) {
    return this.items[index];
  };
  return UIColumnModel;
}();
var PRIMARY_COLS_LIST_PANEL_CLASS = 'ag-column-select-list';
var PrimaryColsListPanel = /** @class */function (_super) {
  __extends$2Z(PrimaryColsListPanel, _super);
  function PrimaryColsListPanel() {
    var _this = _super.call(this, PrimaryColsListPanel.TEMPLATE) || this;
    _this.destroyColumnItemFuncs = [];
    return _this;
  }
  PrimaryColsListPanel.prototype.destroyColumnTree = function () {
    this.allColsTree = [];
    this.destroyColumnItemFuncs.forEach(function (f) {
      return f();
    });
    this.destroyColumnItemFuncs = [];
  };
  PrimaryColsListPanel.prototype.init = function (params, allowDragging, eventType) {
    var _this = this;
    this.params = params;
    this.allowDragging = allowDragging;
    this.eventType = eventType;
    if (!this.params.suppressSyncLayoutWithGrid) {
      this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.onColumnsChanged.bind(this));
    }
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnsChanged.bind(this));
    var eventsImpactingCheckedState = [Events.EVENT_COLUMN_PIVOT_CHANGED, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, Events.EVENT_COLUMN_VALUE_CHANGED, Events.EVENT_COLUMN_VISIBLE, Events.EVENT_NEW_COLUMNS_LOADED];
    eventsImpactingCheckedState.forEach(function (event) {
      // update header select all checkbox with current selection state
      _this.addManagedListener(_this.eventService, event, _this.fireSelectionChangedEvent.bind(_this));
    });
    this.expandGroupsByDefault = !this.params.contractColumnSelection;
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var columnListName = translate('ariaColumnList', 'Column List');
    this.virtualList = this.createManagedBean(new VirtualList('column-select', 'tree', columnListName));
    this.appendChild(this.virtualList.getGui());
    this.virtualList.setComponentCreator(function (item, listItemElement) {
      _.setAriaLevel(listItemElement, item.getDept() + 1);
      return _this.createComponentFromItem(item, listItemElement);
    });
    if (this.columnModel.isReady()) {
      this.onColumnsChanged();
    }
    if (!params.suppressColumnMove && !this.gridOptionsWrapper.isSuppressMovableColumns()) {
      this.createManagedBean(new PrimaryColsListPanelItemDragFeature(this, this.virtualList));
    }
  };
  PrimaryColsListPanel.prototype.createComponentFromItem = function (item, listItemElement) {
    if (item.isGroup()) {
      var renderedGroup = new ToolPanelColumnGroupComp(item, this.allowDragging, this.eventType, listItemElement);
      this.getContext().createBean(renderedGroup);
      return renderedGroup;
    }
    var columnComp = new ToolPanelColumnComp(item.getColumn(), item.getDept(), this.allowDragging, this.groupsExist, listItemElement);
    this.getContext().createBean(columnComp);
    return columnComp;
  };
  PrimaryColsListPanel.prototype.onColumnsChanged = function () {
    var expandedStates = this.getExpandedStates();
    var pivotModeActive = this.columnModel.isPivotMode();
    var shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
    if (shouldSyncColumnLayoutWithGrid) {
      this.buildTreeFromWhatGridIsDisplaying();
    } else {
      this.buildTreeFromProvidedColumnDefs();
    }
    this.setExpandedStates(expandedStates);
    this.markFilteredColumns();
    this.flattenAndFilterModel();
  };
  PrimaryColsListPanel.prototype.getDisplayedColsList = function () {
    return this.displayedColsList;
  };
  PrimaryColsListPanel.prototype.getExpandedStates = function () {
    if (!this.allColsTree) {
      return {};
    }
    var res = {};
    this.forEachItem(function (item) {
      if (!item.isGroup()) {
        return;
      }
      var colGroup = item.getColumnGroup();
      if (colGroup) {
        // group should always exist, this is defensive
        res[colGroup.getId()] = item.isExpanded();
      }
    });
    return res;
  };
  PrimaryColsListPanel.prototype.setExpandedStates = function (states) {
    if (!this.allColsTree) {
      return;
    }
    this.forEachItem(function (item) {
      if (!item.isGroup()) {
        return;
      }
      var colGroup = item.getColumnGroup();
      if (colGroup) {
        // group should always exist, this is defensive
        var expanded = states[colGroup.getId()];
        var groupExistedLastTime = expanded != null;
        if (groupExistedLastTime) {
          item.setExpanded(expanded);
        }
      }
    });
  };
  PrimaryColsListPanel.prototype.buildTreeFromWhatGridIsDisplaying = function () {
    this.colDefService.syncLayoutWithGrid(this.setColumnLayout.bind(this));
  };
  PrimaryColsListPanel.prototype.setColumnLayout = function (colDefs) {
    var columnTree = this.colDefService.createColumnTree(colDefs);
    this.buildListModel(columnTree);
    // using col defs to check if groups exist as it could be a custom layout
    this.groupsExist = colDefs.some(function (colDef) {
      return colDef && typeof colDef.children !== 'undefined';
    });
    this.markFilteredColumns();
    this.flattenAndFilterModel();
  };
  PrimaryColsListPanel.prototype.buildTreeFromProvidedColumnDefs = function () {
    // add column / group comps to tool panel
    this.buildListModel(this.columnModel.getPrimaryColumnTree());
    this.groupsExist = this.columnModel.isPrimaryColumnGroupsPresent();
  };
  PrimaryColsListPanel.prototype.buildListModel = function (columnTree) {
    var _this = this;
    var columnExpandedListener = this.onColumnExpanded.bind(this);
    var addListeners = function addListeners(item) {
      item.addEventListener(ColumnModelItem.EVENT_EXPANDED_CHANGED, columnExpandedListener);
      var removeFunc = item.removeEventListener.bind(item, ColumnModelItem.EVENT_EXPANDED_CHANGED, columnExpandedListener);
      _this.destroyColumnItemFuncs.push(removeFunc);
    };
    var recursivelyBuild = function recursivelyBuild(tree, dept, parentList) {
      tree.forEach(function (child) {
        if (child instanceof ProvidedColumnGroup) {
          createGroupItem(child, dept, parentList);
        } else {
          createColumnItem(child, dept, parentList);
        }
      });
    };
    var createGroupItem = function createGroupItem(columnGroup, dept, parentList) {
      var columnGroupDef = columnGroup.getColGroupDef();
      var skipThisGroup = columnGroupDef && columnGroupDef.suppressColumnsToolPanel;
      if (skipThisGroup) {
        return;
      }
      if (columnGroup.isPadding()) {
        recursivelyBuild(columnGroup.getChildren(), dept, parentList);
        return;
      }
      var displayName = _this.columnModel.getDisplayNameForOriginalColumnGroup(null, columnGroup, _this.eventType);
      var item = new ColumnModelItem(displayName, columnGroup, dept, true, _this.expandGroupsByDefault);
      parentList.push(item);
      addListeners(item);
      recursivelyBuild(columnGroup.getChildren(), dept + 1, item.getChildren());
    };
    var createColumnItem = function createColumnItem(column, dept, parentList) {
      var skipThisColumn = column.getColDef() && column.getColDef().suppressColumnsToolPanel;
      if (skipThisColumn) {
        return;
      }
      var displayName = _this.columnModel.getDisplayNameForColumn(column, 'columnToolPanel');
      parentList.push(new ColumnModelItem(displayName, column, dept));
    };
    this.destroyColumnTree();
    recursivelyBuild(columnTree, 0, this.allColsTree);
  };
  PrimaryColsListPanel.prototype.onColumnExpanded = function () {
    this.flattenAndFilterModel();
  };
  PrimaryColsListPanel.prototype.flattenAndFilterModel = function () {
    var _this = this;
    this.displayedColsList = [];
    var recursiveFunc = function recursiveFunc(item) {
      if (!item.isPassesFilter()) {
        return;
      }
      _this.displayedColsList.push(item);
      if (item.isGroup() && item.isExpanded()) {
        item.getChildren().forEach(recursiveFunc);
      }
    };
    this.allColsTree.forEach(recursiveFunc);
    this.virtualList.setModel(new UIColumnModel(this.displayedColsList));
    var focusedRow = this.virtualList.getLastFocusedRow();
    this.virtualList.refresh();
    if (focusedRow != null) {
      this.focusRowIfAlive(focusedRow);
    }
    this.notifyListeners();
  };
  PrimaryColsListPanel.prototype.focusRowIfAlive = function (rowIndex) {
    var _this = this;
    window.setTimeout(function () {
      if (_this.isAlive()) {
        _this.virtualList.focusRow(rowIndex);
      }
    }, 0);
  };
  PrimaryColsListPanel.prototype.forEachItem = function (callback) {
    var recursiveFunc = function recursiveFunc(items) {
      items.forEach(function (item) {
        callback(item);
        if (item.isGroup()) {
          recursiveFunc(item.getChildren());
        }
      });
    };
    recursiveFunc(this.allColsTree);
  };
  PrimaryColsListPanel.prototype.doSetExpandedAll = function (value) {
    this.forEachItem(function (item) {
      if (item.isGroup()) {
        item.setExpanded(value);
      }
    });
  };
  PrimaryColsListPanel.prototype.setGroupsExpanded = function (expand, groupIds) {
    if (!groupIds) {
      this.doSetExpandedAll(expand);
      return;
    }
    var expandedGroupIds = [];
    this.forEachItem(function (item) {
      if (!item.isGroup()) {
        return;
      }
      var groupId = item.getColumnGroup().getId();
      if (groupIds.indexOf(groupId) >= 0) {
        item.setExpanded(expand);
        expandedGroupIds.push(groupId);
      }
    });
    var unrecognisedGroupIds = groupIds.filter(function (groupId) {
      return !_.includes(expandedGroupIds, groupId);
    });
    if (unrecognisedGroupIds.length > 0) {
      console.warn('AG Grid: unable to find group(s) for supplied groupIds:', unrecognisedGroupIds);
    }
  };
  PrimaryColsListPanel.prototype.getExpandState = function () {
    var expandedCount = 0;
    var notExpandedCount = 0;
    this.forEachItem(function (item) {
      if (!item.isGroup()) {
        return;
      }
      if (item.isExpanded()) {
        expandedCount++;
      } else {
        notExpandedCount++;
      }
    });
    if (expandedCount > 0 && notExpandedCount > 0) {
      return ExpandState.INDETERMINATE;
    }
    if (notExpandedCount > 0) {
      return ExpandState.COLLAPSED;
    }
    return ExpandState.EXPANDED;
  };
  PrimaryColsListPanel.prototype.doSetSelectedAll = function (selectAllChecked) {
    this.modelItemUtils.selectAllChildren(this.allColsTree, selectAllChecked, this.eventType);
  };
  PrimaryColsListPanel.prototype.getSelectionState = function () {
    var checkedCount = 0;
    var uncheckedCount = 0;
    var pivotMode = this.columnModel.isPivotMode();
    this.forEachItem(function (item) {
      if (item.isGroup()) {
        return;
      }
      if (!item.isPassesFilter()) {
        return;
      }
      var column = item.getColumn();
      var colDef = column.getColDef();
      var checked;
      if (pivotMode) {
        var noPivotModeOptionsAllowed = !column.isAllowPivot() && !column.isAllowRowGroup() && !column.isAllowValue();
        if (noPivotModeOptionsAllowed) {
          return;
        }
        checked = column.isValueActive() || column.isPivotActive() || column.isRowGroupActive();
      } else {
        if (colDef.lockVisible) {
          return;
        }
        checked = column.isVisible();
      }
      checked ? checkedCount++ : uncheckedCount++;
    });
    if (checkedCount > 0 && uncheckedCount > 0) {
      return undefined;
    }
    return !(checkedCount === 0 || uncheckedCount > 0);
  };
  PrimaryColsListPanel.prototype.setFilterText = function (filterText) {
    this.filterText = _.exists(filterText) ? filterText.toLowerCase() : null;
    this.markFilteredColumns();
    this.flattenAndFilterModel();
  };
  PrimaryColsListPanel.prototype.markFilteredColumns = function () {
    var _this = this;
    var passesFilter = function passesFilter(item) {
      if (!_.exists(_this.filterText)) {
        return true;
      }
      var displayName = item.getDisplayName();
      return displayName == null || displayName.toLowerCase().indexOf(_this.filterText) !== -1;
    };
    var recursivelyCheckFilter = function recursivelyCheckFilter(item, parentPasses) {
      var atLeastOneChildPassed = false;
      if (item.isGroup()) {
        var groupPasses_1 = passesFilter(item);
        item.getChildren().forEach(function (child) {
          var childPasses = recursivelyCheckFilter(child, groupPasses_1 || parentPasses);
          if (childPasses) {
            atLeastOneChildPassed = childPasses;
          }
        });
      }
      var filterPasses = parentPasses || atLeastOneChildPassed ? true : passesFilter(item);
      item.setPassesFilter(filterPasses);
      return filterPasses;
    };
    this.allColsTree.forEach(function (item) {
      return recursivelyCheckFilter(item, false);
    });
  };
  PrimaryColsListPanel.prototype.notifyListeners = function () {
    this.fireGroupExpandedEvent();
    this.fireSelectionChangedEvent();
  };
  PrimaryColsListPanel.prototype.fireGroupExpandedEvent = function () {
    var expandState = this.getExpandState();
    this.dispatchEvent({
      type: 'groupExpanded',
      state: expandState
    });
  };
  PrimaryColsListPanel.prototype.fireSelectionChangedEvent = function () {
    var selectionState = this.getSelectionState();
    this.dispatchEvent({
      type: 'selectionChanged',
      state: selectionState
    });
  };
  PrimaryColsListPanel.TEMPLATE = "<div class=\"" + PRIMARY_COLS_LIST_PANEL_CLASS + "\" role=\"presentation\"></div>";
  __decorate$2E([Autowired('columnModel')], PrimaryColsListPanel.prototype, "columnModel", void 0);
  __decorate$2E([Autowired('toolPanelColDefService')], PrimaryColsListPanel.prototype, "colDefService", void 0);
  __decorate$2E([Autowired('modelItemUtils')], PrimaryColsListPanel.prototype, "modelItemUtils", void 0);
  __decorate$2E([PreDestroy], PrimaryColsListPanel.prototype, "destroyColumnTree", null);
  return PrimaryColsListPanel;
}(Component);
var __extends$2_ = undefined && undefined.__extends || function () {
  var _extendStatics199 = function extendStatics(d, b) {
    _extendStatics199 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics199(d, b);
  };
  return function (d, b) {
    _extendStatics199(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2F = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PivotModePanel = /** @class */function (_super) {
  __extends$2_(PivotModePanel, _super);
  function PivotModePanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PivotModePanel.prototype.createTemplate = function () {
    return (/* html */"<div class=\"ag-pivot-mode-panel\">\n                <ag-toggle-button ref=\"cbPivotMode\" class=\"ag-pivot-mode-select\"></ag-toggle-button>\n            </div>"
    );
  };
  PivotModePanel.prototype.init = function () {
    this.setTemplate(this.createTemplate());
    this.cbPivotMode.setValue(this.columnModel.isPivotMode());
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    this.cbPivotMode.setLabel(localeTextFunc('pivotMode', 'Pivot Mode'));
    this.addManagedListener(this.cbPivotMode, AgCheckbox.EVENT_CHANGED, this.onBtPivotMode.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onPivotModeChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
  };
  PivotModePanel.prototype.onBtPivotMode = function () {
    var newValue = !!this.cbPivotMode.getValue();
    if (newValue !== this.columnModel.isPivotMode()) {
      this.columnModel.setPivotMode(newValue, "toolPanelUi");
      var api = this.gridOptionsWrapper.getApi();
      if (api) {
        api.refreshHeader();
      }
    }
  };
  PivotModePanel.prototype.onPivotModeChanged = function () {
    var pivotModeActive = this.columnModel.isPivotMode();
    this.cbPivotMode.setValue(pivotModeActive);
  };
  __decorate$2F([Autowired('columnModel')], PivotModePanel.prototype, "columnModel", void 0);
  __decorate$2F([RefSelector('cbPivotMode')], PivotModePanel.prototype, "cbPivotMode", void 0);
  __decorate$2F([PreConstruct], PivotModePanel.prototype, "init", null);
  return PivotModePanel;
}(Component);
var __extends$2$ = undefined && undefined.__extends || function () {
  var _extendStatics200 = function extendStatics(d, b) {
    _extendStatics200 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics200(d, b);
  };
  return function (d, b) {
    _extendStatics200(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2G = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AggregationStage = /** @class */function (_super) {
  __extends$2$(AggregationStage, _super);
  function AggregationStage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + gridApi.recomputeAggregates()
  AggregationStage.prototype.execute = function (params) {
    // if changed path is active, it means we came from a) change detection or b) transaction update.
    // for both of these, if no value columns are present, it means there is nothing to aggregate now
    // and there is no cleanup to be done (as value columns don't change between transactions or change
    // detections). if no value columns and no changed path, means we have to go through all nodes in
    // case we need to clean up agg data from before.
    var noValueColumns = _.missingOrEmpty(this.columnModel.getValueColumns());
    var noUserAgg = !this.gridOptionsWrapper.getGroupRowAggNodesFunc();
    var changedPathActive = params.changedPath && params.changedPath.isActive();
    if (noValueColumns && noUserAgg && changedPathActive) {
      return;
    }
    var aggDetails = this.createAggDetails(params);
    this.recursivelyCreateAggData(aggDetails);
  };
  AggregationStage.prototype.createAggDetails = function (params) {
    var pivotActive = this.columnModel.isPivotActive();
    var measureColumns = this.columnModel.getValueColumns();
    var pivotColumns = pivotActive ? this.columnModel.getPivotColumns() : [];
    var aggDetails = {
      changedPath: params.changedPath,
      valueColumns: measureColumns,
      pivotColumns: pivotColumns
    };
    return aggDetails;
  };
  AggregationStage.prototype.recursivelyCreateAggData = function (aggDetails) {
    var _this = this;
    // update prop, in case changed since last time
    this.filteredOnly = !this.gridOptionsWrapper.isSuppressAggFilteredOnly();
    var callback = function callback(rowNode) {
      var hasNoChildren = !rowNode.hasChildren();
      if (hasNoChildren) {
        // this check is needed for TreeData, in case the node is no longer a child,
        // but it was a child previously.
        if (rowNode.aggData) {
          rowNode.setAggData(null);
        }
        // never agg data for leaf nodes
        return;
      }
      //Optionally prevent the aggregation at the root Node
      //https://ag-grid.atlassian.net/browse/AG-388
      var isRootNode = rowNode.level === -1;
      if (isRootNode) {
        var notPivoting = !_this.columnModel.isPivotMode();
        var suppressAggAtRootLevel = _this.gridOptionsWrapper.isSuppressAggAtRootLevel();
        if (suppressAggAtRootLevel && notPivoting) {
          return;
        }
      }
      _this.aggregateRowNode(rowNode, aggDetails);
    };
    aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
  };
  AggregationStage.prototype.aggregateRowNode = function (rowNode, aggDetails) {
    var measureColumnsMissing = aggDetails.valueColumns.length === 0;
    var pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
    var userFunc = this.gridOptionsWrapper.getGroupRowAggNodesFunc();
    var aggResult;
    if (userFunc) {
      aggResult = userFunc(rowNode.childrenAfterFilter);
    } else if (measureColumnsMissing) {
      aggResult = null;
    } else if (pivotColumnsMissing) {
      aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
    } else {
      aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
    }
    rowNode.setAggData(aggResult);
    // if we are grouping, then it's possible there is a sibling footer
    // to the group, so update the data here also if there is one
    if (rowNode.sibling) {
      rowNode.sibling.setAggData(aggResult);
    }
  };
  AggregationStage.prototype.aggregateRowNodeUsingValuesAndPivot = function (rowNode) {
    var _this = this;
    var result = {};
    var pivotColumnDefs = this.pivotStage.getPivotColumnDefs();
    // Step 1: process value columns
    pivotColumnDefs.filter(function (v) {
      return !_.exists(v.pivotTotalColumnIds);
    }) // only process pivot value columns
    .forEach(function (valueColDef) {
      var keys = valueColDef.pivotKeys || [];
      var values;
      var valueColumn = valueColDef.pivotValueColumn;
      var colId = valueColDef.colId;
      if (rowNode.leafGroup) {
        // lowest level group, get the values from the mapped set
        values = _this.getValuesFromMappedSet(rowNode.childrenMapped, keys, valueColumn);
      } else {
        // value columns and pivot columns, non-leaf group
        values = _this.getValuesPivotNonLeaf(rowNode, colId);
      }
      result[colId] = _this.aggregateValues(values, valueColumn.getAggFunc(), valueColumn, rowNode);
    });
    // Step 2: process total columns
    pivotColumnDefs.filter(function (v) {
      return _.exists(v.pivotTotalColumnIds);
    }) // only process pivot total columns
    .forEach(function (totalColDef) {
      var aggResults = [];
      var pivotValueColumn = totalColDef.pivotValueColumn,
        pivotTotalColumnIds = totalColDef.pivotTotalColumnIds,
        colId = totalColDef.colId;
      //retrieve results for colIds associated with this pivot total column
      if (!pivotTotalColumnIds || !pivotTotalColumnIds.length) {
        return;
      }
      pivotTotalColumnIds.forEach(function (currentColId) {
        aggResults.push(result[currentColId]);
      });
      result[colId] = _this.aggregateValues(aggResults, pivotValueColumn.getAggFunc(), pivotValueColumn, rowNode);
    });
    return result;
  };
  AggregationStage.prototype.aggregateRowNodeUsingValuesOnly = function (rowNode, aggDetails) {
    var _this = this;
    var result = {};
    var changedValueColumns = aggDetails.changedPath.isActive() ? aggDetails.changedPath.getValueColumnsForNode(rowNode, aggDetails.valueColumns) : aggDetails.valueColumns;
    var notChangedValueColumns = aggDetails.changedPath.isActive() ? aggDetails.changedPath.getNotValueColumnsForNode(rowNode, aggDetails.valueColumns) : null;
    var values2d = this.getValuesNormal(rowNode, changedValueColumns);
    var oldValues = rowNode.aggData;
    changedValueColumns.forEach(function (valueColumn, index) {
      result[valueColumn.getId()] = _this.aggregateValues(values2d[index], valueColumn.getAggFunc(), valueColumn, rowNode);
    });
    if (notChangedValueColumns && oldValues) {
      notChangedValueColumns.forEach(function (valueColumn) {
        result[valueColumn.getId()] = oldValues[valueColumn.getId()];
      });
    }
    return result;
  };
  AggregationStage.prototype.getValuesPivotNonLeaf = function (rowNode, colId) {
    var values = [];
    rowNode.childrenAfterFilter.forEach(function (node) {
      var value = node.aggData[colId];
      values.push(value);
    });
    return values;
  };
  AggregationStage.prototype.getValuesFromMappedSet = function (mappedSet, keys, valueColumn) {
    var _this = this;
    var mapPointer = mappedSet;
    keys.forEach(function (key) {
      return mapPointer = mapPointer ? mapPointer[key] : null;
    });
    if (!mapPointer) {
      return [];
    }
    var values = [];
    mapPointer.forEach(function (rowNode) {
      var value = _this.valueService.getValue(valueColumn, rowNode);
      values.push(value);
    });
    return values;
  };
  AggregationStage.prototype.getValuesNormal = function (rowNode, valueColumns) {
    // create 2d array, of all values for all valueColumns
    var values = [];
    valueColumns.forEach(function () {
      return values.push([]);
    });
    var valueColumnCount = valueColumns.length;
    var nodeList = this.filteredOnly ? rowNode.childrenAfterFilter : rowNode.childrenAfterGroup;
    var rowCount = nodeList.length;
    for (var i = 0; i < rowCount; i++) {
      var childNode = nodeList[i];
      for (var j = 0; j < valueColumnCount; j++) {
        var valueColumn = valueColumns[j];
        // if the row is a group, then it will only have an agg result value,
        // which means valueGetter is never used.
        var value = this.valueService.getValue(valueColumn, childNode);
        values[j].push(value);
      }
    }
    return values;
  };
  AggregationStage.prototype.aggregateValues = function (values, aggFuncOrString, column, rowNode) {
    var aggFunc = typeof aggFuncOrString === 'string' ? this.aggFuncService.getAggFunc(aggFuncOrString) : aggFuncOrString;
    if (typeof aggFunc !== 'function') {
      console.error("AG Grid: unrecognised aggregation function " + aggFuncOrString);
      return null;
    }
    var deprecationWarning = function deprecationWarning() {
      _.doOnce(function () {
        console.warn('AG Grid: since v24.0, custom aggregation functions take a params object. Please alter your aggregation function to use params.values');
      }, 'aggregationStage.aggregateValues Deprecation');
    };
    var aggFuncAny = aggFunc;
    var params = {
      values: values,
      column: column,
      colDef: column ? column.getColDef() : undefined,
      rowNode: rowNode,
      data: rowNode ? rowNode.data : undefined,
      api: this.gridApi,
      columnApi: this.columnApi,
      context: this.gridOptionsWrapper.getContext(),
      // the three things below are for logging warning messages in case anyone is treating
      // the params object as an array. in previous grid versions, we didn't pass params object,
      // but passed values array instead.
      forEach: function forEach(callback, thisArg) {
        deprecationWarning();
        return values.forEach(callback, thisArg);
      },
      get length() {
        deprecationWarning();
        return values.length;
      },
      set length(val) {
        deprecationWarning();
        values.length = val;
      }
    }; // the "as any" is needed to allow the deprecation warning messages
    return aggFuncAny(params);
  };
  __decorate$2G([Autowired('columnModel')], AggregationStage.prototype, "columnModel", void 0);
  __decorate$2G([Autowired('valueService')], AggregationStage.prototype, "valueService", void 0);
  __decorate$2G([Autowired('pivotStage')], AggregationStage.prototype, "pivotStage", void 0);
  __decorate$2G([Autowired('aggFuncService')], AggregationStage.prototype, "aggFuncService", void 0);
  __decorate$2G([Autowired('gridApi')], AggregationStage.prototype, "gridApi", void 0);
  __decorate$2G([Autowired('columnApi')], AggregationStage.prototype, "columnApi", void 0);
  AggregationStage = __decorate$2G([Bean('aggregationStage')], AggregationStage);
  return AggregationStage;
}(BeanStub);
var BatchRemover = /** @class */function () {
  function BatchRemover() {
    this.allSets = {};
    this.allParents = [];
  }
  BatchRemover.prototype.removeFromChildrenAfterGroup = function (parent, child) {
    var set = this.getSet(parent);
    set.removeFromChildrenAfterGroup[child.id] = true;
  };
  BatchRemover.prototype.removeFromAllLeafChildren = function (parent, child) {
    var set = this.getSet(parent);
    set.removeFromAllLeafChildren[child.id] = true;
  };
  BatchRemover.prototype.getSet = function (parent) {
    if (!this.allSets[parent.id]) {
      this.allSets[parent.id] = {
        removeFromAllLeafChildren: {},
        removeFromChildrenAfterGroup: {}
      };
      this.allParents.push(parent);
    }
    return this.allSets[parent.id];
  };
  BatchRemover.prototype.getAllParents = function () {
    return this.allParents;
  };
  BatchRemover.prototype.flush = function () {
    var _this = this;
    this.allParents.forEach(function (parent) {
      var nodeDetails = _this.allSets[parent.id];
      parent.childrenAfterGroup = parent.childrenAfterGroup.filter(function (child) {
        return !nodeDetails.removeFromChildrenAfterGroup[child.id];
      });
      parent.allLeafChildren = parent.allLeafChildren.filter(function (child) {
        return !nodeDetails.removeFromAllLeafChildren[child.id];
      });
      parent.updateHasChildren();
      if (parent.sibling) {
        parent.sibling.childrenAfterGroup = parent.childrenAfterGroup;
        parent.sibling.allLeafChildren = parent.allLeafChildren;
      }
    });
    this.allSets = {};
    this.allParents.length = 0;
  };
  return BatchRemover;
}();
var __extends$30 = undefined && undefined.__extends || function () {
  var _extendStatics201 = function extendStatics(d, b) {
    _extendStatics201 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics201(d, b);
  };
  return function (d, b) {
    _extendStatics201(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2H = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GroupStage = /** @class */function (_super) {
  __extends$30(GroupStage, _super);
  function GroupStage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // we use a sequence variable so that each time we do a grouping, we don't
    // reuse the ids - otherwise the rowRenderer will confuse rowNodes between redraws
    // when it tries to animate between rows.
    _this.groupIdSequence = new NumberSequence();
    return _this;
  }
  GroupStage.prototype.postConstruct = function () {
    this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    if (this.usingTreeData) {
      this.getDataPath = this.gridOptionsWrapper.getDataPathFunc();
    }
  };
  GroupStage.prototype.execute = function (params) {
    var details = this.createGroupingDetails(params);
    if (details.transactions) {
      this.handleTransaction(details);
    } else {
      var afterColsChanged = params.afterColumnsChanged === true;
      this.shotgunResetEverything(details, afterColsChanged);
    }
    this.sortGroupsWithComparator(details.rootNode);
    this.selectableService.updateSelectableAfterGrouping(details.rootNode);
  };
  GroupStage.prototype.createGroupingDetails = function (params) {
    var rowNode = params.rowNode,
      changedPath = params.changedPath,
      rowNodeTransactions = params.rowNodeTransactions,
      rowNodeOrder = params.rowNodeOrder;
    var groupedCols = this.usingTreeData ? null : this.columnModel.getRowGroupColumns();
    var details = {
      // someone complained that the parent attribute was causing some change detection
      // to break is some angular add-on - which i never used. taking the parent out breaks
      // a cyclic dependency, hence this flag got introduced.
      includeParents: !this.gridOptionsWrapper.isSuppressParentsInRowNodes(),
      expandByDefault: this.gridOptionsWrapper.getGroupDefaultExpanded(),
      groupedCols: groupedCols,
      rootNode: rowNode,
      pivotMode: this.columnModel.isPivotMode(),
      groupedColCount: this.usingTreeData || !groupedCols ? 0 : groupedCols.length,
      rowNodeOrder: rowNodeOrder,
      transactions: rowNodeTransactions,
      // if no transaction, then it's shotgun, changed path would be 'not active' at this point anyway
      changedPath: changedPath
    };
    return details;
  };
  GroupStage.prototype.handleTransaction = function (details) {
    var _this = this;
    details.transactions.forEach(function (tran) {
      // we don't allow batch remover for tree data as tree data uses Filler Nodes,
      // and creating/deleting filler nodes needs to be done alongside the node deleting
      // and moving. if we want to Batch Remover working with tree data then would need
      // to consider how Filler Nodes would be impacted (it's possible that it can be easily
      // modified to work, however for now I don't have the brain energy to work it all out).
      var batchRemover = !_this.usingTreeData ? new BatchRemover() : undefined;
      // the order here of [add, remove, update] needs to be the same as in ClientSideNodeManager,
      // as the order is important when a record with the same id is added and removed in the same
      // transaction.
      if (_.existsAndNotEmpty(tran.remove)) {
        _this.removeNodes(tran.remove, details, batchRemover);
      }
      if (_.existsAndNotEmpty(tran.update)) {
        _this.moveNodesInWrongPath(tran.update, details, batchRemover);
      }
      if (_.existsAndNotEmpty(tran.add)) {
        _this.insertNodes(tran.add, details, false);
      }
      // must flush here, and not allow another transaction to be applied,
      // as each transaction must finish leaving the data in a consistent state.
      if (batchRemover) {
        var parentsWithChildrenRemoved = batchRemover.getAllParents().slice();
        batchRemover.flush();
        _this.removeEmptyGroups(parentsWithChildrenRemoved, details);
      }
    });
    if (details.rowNodeOrder) {
      this.sortChildren(details);
    }
  };
  // this is used when doing delta updates, eg Redux, keeps nodes in right order
  GroupStage.prototype.sortChildren = function (details) {
    details.changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
      _.sortRowNodesByOrder(rowNode.childrenAfterGroup, details.rowNodeOrder);
    });
  };
  GroupStage.prototype.sortGroupsWithComparator = function (rootNode) {
    // we don't do group sorting for tree data
    if (this.usingTreeData) {
      return;
    }
    var comparator = this.gridOptionsWrapper.getDefaultGroupOrderComparator();
    if (_.exists(comparator)) {
      recursiveSort(rootNode);
    }
    function recursiveSort(rowNode) {
      var doSort = _.exists(rowNode.childrenAfterGroup) &&
      // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
      !rowNode.leafGroup;
      if (doSort) {
        rowNode.childrenAfterGroup.sort(comparator);
        rowNode.childrenAfterGroup.forEach(function (childNode) {
          return recursiveSort(childNode);
        });
      }
    }
  };
  GroupStage.prototype.getExistingPathForNode = function (node, details) {
    var res = [];
    // when doing tree data, the node is part of the path,
    // but when doing grid grouping, the node is not part of the path so we start with the parent.
    var pointer = this.usingTreeData ? node : node.parent;
    while (pointer && pointer !== details.rootNode) {
      res.push({
        key: pointer.key,
        rowGroupColumn: pointer.rowGroupColumn,
        field: pointer.field
      });
      pointer = pointer.parent;
    }
    res.reverse();
    return res;
  };
  GroupStage.prototype.moveNodesInWrongPath = function (childNodes, details, batchRemover) {
    var _this = this;
    childNodes.forEach(function (childNode) {
      // we add node, even if parent has not changed, as the data could have
      // changed, hence aggregations will be wrong
      if (details.changedPath.isActive()) {
        details.changedPath.addParentNode(childNode.parent);
      }
      var infoToKeyMapper = function infoToKeyMapper(item) {
        return item.key;
      };
      var oldPath = _this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
      var newPath = _this.getGroupInfo(childNode, details).map(infoToKeyMapper);
      var nodeInCorrectPath = _.areEqual(oldPath, newPath);
      if (!nodeInCorrectPath) {
        _this.moveNode(childNode, details, batchRemover);
      }
    });
  };
  GroupStage.prototype.moveNode = function (childNode, details, batchRemover) {
    this.removeNodesInStages([childNode], details, batchRemover);
    this.insertOneNode(childNode, details, true);
    // hack - if we didn't do this, then renaming a tree item (ie changing rowNode.key) wouldn't get
    // refreshed into the gui.
    // this is needed to kick off the event that rowComp listens to for refresh. this in turn
    // then will get each cell in the row to refresh - which is what we need as we don't know which
    // columns will be displaying the rowNode.key info.
    childNode.setData(childNode.data);
    // we add both old and new parents to changed path, as both will need to be refreshed.
    // we already added the old parent (in calling method), so just add the new parent here
    if (details.changedPath.isActive()) {
      var newParent = childNode.parent;
      details.changedPath.addParentNode(newParent);
    }
  };
  GroupStage.prototype.removeNodes = function (leafRowNodes, details, batchRemover) {
    this.removeNodesInStages(leafRowNodes, details, batchRemover);
    if (details.changedPath.isActive()) {
      leafRowNodes.forEach(function (rowNode) {
        return details.changedPath.addParentNode(rowNode.parent);
      });
    }
  };
  GroupStage.prototype.removeNodesInStages = function (leafRowNodes, details, batchRemover) {
    this.removeNodesFromParents(leafRowNodes, details, batchRemover);
    if (this.usingTreeData) {
      this.postRemoveCreateFillerNodes(leafRowNodes, details);
      // When not TreeData, then removeEmptyGroups is called just before the BatchRemover is flushed.
      // However for TreeData, there is no BatchRemover, so we have to call removeEmptyGroups here.
      var nodeParents = leafRowNodes.map(function (n) {
        return n.parent;
      });
      this.removeEmptyGroups(nodeParents, details);
    }
  };
  GroupStage.prototype.forEachParentGroup = function (details, group, callback) {
    var pointer = group;
    while (pointer && pointer !== details.rootNode) {
      callback(pointer);
      pointer = pointer.parent;
    }
  };
  GroupStage.prototype.removeNodesFromParents = function (nodesToRemove, details, provided) {
    var _this = this;
    // this method can be called with BatchRemover as optional. if it is missed, we created a local version
    // and flush it at the end. if one is provided, we add to the provided one and it gets flushed elsewhere.
    var batchRemoverIsLocal = provided == null;
    var batchRemoverToUse = provided ? provided : new BatchRemover();
    nodesToRemove.forEach(function (nodeToRemove) {
      _this.removeFromParent(nodeToRemove, batchRemoverToUse);
      // remove from allLeafChildren. we clear down all parents EXCEPT the Root Node, as
      // the ClientSideNodeManager is responsible for the Root Node.
      _this.forEachParentGroup(details, nodeToRemove.parent, function (parentNode) {
        batchRemoverToUse.removeFromAllLeafChildren(parentNode, nodeToRemove);
      });
    });
    if (batchRemoverIsLocal) {
      batchRemoverToUse.flush();
    }
  };
  GroupStage.prototype.postRemoveCreateFillerNodes = function (nodesToRemove, details) {
    var _this = this;
    nodesToRemove.forEach(function (nodeToRemove) {
      // if not group, and children are present, need to move children to a group.
      // otherwise if no children, we can just remove without replacing.
      var replaceWithGroup = nodeToRemove.hasChildren();
      if (replaceWithGroup) {
        var oldPath = _this.getExistingPathForNode(nodeToRemove, details);
        // because we just removed the userGroup, this will always return new support group
        var newGroupNode_1 = _this.findParentForNode(nodeToRemove, oldPath, details);
        // these properties are the ones that will be incorrect in the newly created group,
        // so copy them from the old childNode
        newGroupNode_1.expanded = nodeToRemove.expanded;
        newGroupNode_1.allLeafChildren = nodeToRemove.allLeafChildren;
        newGroupNode_1.childrenAfterGroup = nodeToRemove.childrenAfterGroup;
        newGroupNode_1.childrenMapped = nodeToRemove.childrenMapped;
        newGroupNode_1.updateHasChildren();
        newGroupNode_1.childrenAfterGroup.forEach(function (rowNode) {
          return rowNode.parent = newGroupNode_1;
        });
      }
    });
  };
  GroupStage.prototype.removeEmptyGroups = function (possibleEmptyGroups, details) {
    var _this = this;
    // we do this multiple times, as when we remove groups, that means the parent of just removed
    // group can then be empty. to get around this, if we remove, then we check everything again for
    // newly emptied groups. the max number of times this will execute is the depth of the group tree.
    var checkAgain = true;
    var groupShouldBeRemoved = function groupShouldBeRemoved(rowNode) {
      // because of the while loop below, it's possible we already moved the node,
      // so double check before trying to remove again.
      var mapKey = _this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
      var parentRowNode = rowNode.parent;
      var groupAlreadyRemoved = parentRowNode && parentRowNode.childrenMapped ? !parentRowNode.childrenMapped[mapKey] : true;
      if (groupAlreadyRemoved) {
        // if not linked, then group was already removed
        return false;
      }
      // if still not removed, then we remove if this group is empty
      return !!rowNode.isEmptyRowGroupNode();
    };
    var _loop_1 = function _loop_1() {
      checkAgain = false;
      var batchRemover = new BatchRemover();
      possibleEmptyGroups.forEach(function (possibleEmptyGroup) {
        // remove empty groups
        _this.forEachParentGroup(details, possibleEmptyGroup, function (rowNode) {
          if (groupShouldBeRemoved(rowNode)) {
            checkAgain = true;
            _this.removeFromParent(rowNode, batchRemover);
            // we remove selection on filler nodes here, as the selection would not be removed
            // from the RowNodeManager, as filler nodes don't exist on the RowNodeManager
            rowNode.setSelected(false);
          }
        });
      });
      batchRemover.flush();
    };
    while (checkAgain) {
      _loop_1();
    }
  };
  // removes the node from the parent by:
  // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
  // b) removing from childrenMapped (immediately)
  // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
  // d) setRowIndex(null) - as the rowNode will no longer be displayed.
  GroupStage.prototype.removeFromParent = function (child, batchRemover) {
    if (child.parent) {
      if (batchRemover) {
        batchRemover.removeFromChildrenAfterGroup(child.parent, child);
      } else {
        _.removeFromArray(child.parent.childrenAfterGroup, child);
        child.parent.updateHasChildren();
      }
    }
    var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
    if (child.parent && child.parent.childrenMapped) {
      child.parent.childrenMapped[mapKey] = undefined;
    }
    // this is important for transition, see rowComp removeFirstPassFuncs. when doing animation and
    // remove, if rowTop is still present, the rowComp thinks it's just moved position.
    child.setRowTop(null);
    child.setRowIndex(null);
  };
  GroupStage.prototype.addToParent = function (child, parent) {
    var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
    if (parent) {
      var children = parent.childrenMapped != null;
      if (children) {
        parent.childrenMapped[mapKey] = child;
      }
      parent.childrenAfterGroup.push(child);
      parent.updateHasChildren();
    }
  };
  GroupStage.prototype.areGroupColsEqual = function (d1, d2) {
    if (d1 == null || d2 == null || d1.pivotMode !== d2.pivotMode) {
      return false;
    }
    return _.areEqual(d1.groupedCols, d2.groupedCols);
  };
  GroupStage.prototype.checkAllGroupDataAfterColsChanged = function (details) {
    var _this = this;
    var recurse = function recurse(rowNodes) {
      if (!rowNodes) {
        return;
      }
      rowNodes.forEach(function (rowNode) {
        var isLeafNode = !_this.usingTreeData && !rowNode.group;
        if (isLeafNode) {
          return;
        }
        var groupInfo = {
          field: rowNode.field,
          key: rowNode.key,
          rowGroupColumn: rowNode.rowGroupColumn
        };
        _this.setGroupData(rowNode, groupInfo);
        recurse(rowNode.childrenAfterGroup);
      });
    };
    recurse(details.rootNode.childrenAfterGroup);
  };
  GroupStage.prototype.shotgunResetEverything = function (details, afterColumnsChanged) {
    if (this.noChangeInGroupingColumns(details, afterColumnsChanged)) {
      return;
    }
    // groups are about to get disposed, so need to deselect any that are selected
    this.selectionService.removeGroupsFromSelection();
    var rootNode = details.rootNode,
      groupedCols = details.groupedCols;
    // because we are not creating the root node each time, we have the logic
    // here to change leafGroup once.
    // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
    // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
    rootNode.leafGroup = this.usingTreeData ? false : groupedCols.length === 0;
    // we are doing everything from scratch, so reset childrenAfterGroup and childrenMapped from the rootNode
    rootNode.childrenAfterGroup = [];
    rootNode.childrenMapped = {};
    rootNode.updateHasChildren();
    var sibling = rootNode.sibling;
    if (sibling) {
      sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
      sibling.childrenMapped = rootNode.childrenMapped;
    }
    this.insertNodes(rootNode.allLeafChildren, details, false);
  };
  GroupStage.prototype.noChangeInGroupingColumns = function (details, afterColumnsChanged) {
    var noFurtherProcessingNeeded = false;
    var groupDisplayColumns = this.columnModel.getGroupDisplayColumns();
    var newGroupDisplayColIds = groupDisplayColumns ? groupDisplayColumns.map(function (c) {
      return c.getId();
    }).join('-') : '';
    if (afterColumnsChanged) {
      // we only need to redo grouping if doing normal grouping (ie not tree data)
      // and the group cols have changed.
      noFurtherProcessingNeeded = this.usingTreeData || this.areGroupColsEqual(details, this.oldGroupingDetails);
      // if the group display cols have changed, then we need to update rowNode.groupData
      // (regardless of tree data or row grouping)
      if (this.oldGroupDisplayColIds !== newGroupDisplayColIds) {
        this.checkAllGroupDataAfterColsChanged(details);
      }
    }
    this.oldGroupingDetails = details;
    this.oldGroupDisplayColIds = newGroupDisplayColIds;
    return noFurtherProcessingNeeded;
  };
  GroupStage.prototype.insertNodes = function (newRowNodes, details, isMove) {
    var _this = this;
    newRowNodes.forEach(function (rowNode) {
      _this.insertOneNode(rowNode, details, isMove);
      if (details.changedPath.isActive()) {
        details.changedPath.addParentNode(rowNode.parent);
      }
    });
  };
  GroupStage.prototype.insertOneNode = function (childNode, details, isMove) {
    var path = this.getGroupInfo(childNode, details);
    var parentGroup = this.findParentForNode(childNode, path, details);
    if (!parentGroup.group) {
      console.warn("AG Grid: duplicate group keys for row data, keys should be unique", [parentGroup.data, childNode.data]);
    }
    if (this.usingTreeData) {
      this.swapGroupWithUserNode(parentGroup, childNode, isMove);
    } else {
      childNode.parent = parentGroup;
      childNode.level = path.length;
      parentGroup.childrenAfterGroup.push(childNode);
      parentGroup.updateHasChildren();
    }
  };
  GroupStage.prototype.findParentForNode = function (childNode, path, details) {
    var _this = this;
    var nextNode = details.rootNode;
    path.forEach(function (groupInfo, level) {
      nextNode = _this.getOrCreateNextNode(nextNode, groupInfo, level, details);
      // node gets added to all group nodes.
      // note: we do not add to rootNode here, as the rootNode is the master list of rowNodes
      nextNode.allLeafChildren.push(childNode);
    });
    return nextNode;
  };
  GroupStage.prototype.swapGroupWithUserNode = function (fillerGroup, userGroup, isMove) {
    userGroup.parent = fillerGroup.parent;
    userGroup.key = fillerGroup.key;
    userGroup.field = fillerGroup.field;
    userGroup.groupData = fillerGroup.groupData;
    userGroup.level = fillerGroup.level;
    // AG-3441 - preserve the existing expanded status of the node if we're moving it, so that
    // you can drag a sub tree from one parent to another without changing its expansion
    if (!isMove) {
      userGroup.expanded = fillerGroup.expanded;
    }
    // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
    // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
    userGroup.leafGroup = fillerGroup.leafGroup;
    // always null for userGroups, as row grouping is not allowed when doing tree data
    userGroup.rowGroupIndex = fillerGroup.rowGroupIndex;
    userGroup.allLeafChildren = fillerGroup.allLeafChildren;
    userGroup.childrenAfterGroup = fillerGroup.childrenAfterGroup;
    userGroup.childrenMapped = fillerGroup.childrenMapped;
    userGroup.updateHasChildren();
    this.removeFromParent(fillerGroup);
    userGroup.childrenAfterGroup.forEach(function (rowNode) {
      return rowNode.parent = userGroup;
    });
    this.addToParent(userGroup, fillerGroup.parent);
  };
  GroupStage.prototype.getOrCreateNextNode = function (parentGroup, groupInfo, level, details) {
    var key = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
    var nextNode = parentGroup.childrenMapped ? parentGroup.childrenMapped[key] : undefined;
    if (!nextNode) {
      nextNode = this.createGroup(groupInfo, parentGroup, level, details);
      // attach the new group to the parent
      this.addToParent(nextNode, parentGroup);
    }
    return nextNode;
  };
  GroupStage.prototype.createGroup = function (groupInfo, parent, level, details) {
    var groupNode = new RowNode(this.beans);
    groupNode.group = true;
    groupNode.field = groupInfo.field;
    groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
    this.setGroupData(groupNode, groupInfo);
    // we put 'row-group-' before the group id, so it doesn't clash with standard row id's. we also use 't-' and 'b-'
    // for top pinned and bottom pinned rows.
    groupNode.id = RowNode.ID_PREFIX_ROW_GROUP + this.groupIdSequence.next();
    groupNode.key = groupInfo.key;
    groupNode.level = level;
    groupNode.leafGroup = this.usingTreeData ? false : level === details.groupedColCount - 1;
    groupNode.allLeafChildren = [];
    // why is this done here? we are not updating the children count as we go,
    // i suspect this is updated in the filter stage
    groupNode.setAllChildrenCount(0);
    groupNode.rowGroupIndex = this.usingTreeData ? null : level;
    groupNode.childrenAfterGroup = [];
    groupNode.childrenMapped = {};
    groupNode.updateHasChildren();
    groupNode.parent = details.includeParents ? parent : null;
    this.setExpandedInitialValue(details, groupNode);
    return groupNode;
  };
  GroupStage.prototype.setGroupData = function (groupNode, groupInfo) {
    var _this = this;
    groupNode.groupData = {};
    var groupDisplayCols = this.columnModel.getGroupDisplayColumns();
    groupDisplayCols.forEach(function (col) {
      // newGroup.rowGroupColumn=null when working off GroupInfo, and we always display the group in the group column
      // if rowGroupColumn is present, then it's grid row grouping and we only include if configuration says so
      var displayGroupForCol = _this.usingTreeData || (groupNode.rowGroupColumn ? col.isRowGroupDisplayed(groupNode.rowGroupColumn.getId()) : false);
      if (displayGroupForCol) {
        groupNode.groupData[col.getColId()] = groupInfo.key;
      }
    });
  };
  GroupStage.prototype.getChildrenMappedKey = function (key, rowGroupColumn) {
    if (rowGroupColumn) {
      // grouping by columns
      return rowGroupColumn.getId() + '-' + key;
    }
    // tree data - we don't have rowGroupColumns
    return key;
  };
  GroupStage.prototype.setExpandedInitialValue = function (details, groupNode) {
    // if pivoting the leaf group is never expanded as we do not show leaf rows
    if (details.pivotMode && groupNode.leafGroup) {
      groupNode.expanded = false;
      return;
    }
    // use callback if exists
    var userCallback = this.gridOptionsWrapper.getIsGroupOpenByDefaultFunc();
    if (userCallback) {
      var params = {
        rowNode: groupNode,
        field: groupNode.field,
        key: groupNode.key,
        level: groupNode.level,
        rowGroupColumn: groupNode.rowGroupColumn
      };
      groupNode.expanded = userCallback(params) == true;
      return;
    }
    // use expandByDefault if exists
    var expandByDefault = details.expandByDefault;
    if (details.expandByDefault === -1) {
      groupNode.expanded = true;
      return;
    }
    // otherwise
    groupNode.expanded = groupNode.level < expandByDefault;
  };
  GroupStage.prototype.getGroupInfo = function (rowNode, details) {
    if (this.usingTreeData) {
      return this.getGroupInfoFromCallback(rowNode);
    }
    return this.getGroupInfoFromGroupColumns(rowNode, details);
  };
  GroupStage.prototype.getGroupInfoFromCallback = function (rowNode) {
    var keys = this.getDataPath ? this.getDataPath(rowNode.data) : null;
    if (keys === null || keys === undefined || keys.length === 0) {
      _.doOnce(function () {
        return console.warn("getDataPath() should not return an empty path for data", rowNode.data);
      }, 'groupStage.getGroupInfoFromCallback');
    }
    var groupInfoMapper = function groupInfoMapper(key) {
      return {
        key: key,
        field: null,
        rowGroupColumn: null
      };
    };
    return keys ? keys.map(groupInfoMapper) : [];
  };
  GroupStage.prototype.getGroupInfoFromGroupColumns = function (rowNode, details) {
    var _this = this;
    var res = [];
    details.groupedCols.forEach(function (groupCol) {
      var key = _this.valueService.getKeyForNode(groupCol, rowNode);
      var keyExists = key !== null && key !== undefined;
      // unbalanced tree and pivot mode don't work together - not because of the grid, it doesn't make
      // mathematical sense as you are building up a cube. so if pivot mode, we put in a blank key where missing.
      // this keeps the tree balanced and hence can be represented as a group.
      if (details.pivotMode && !keyExists) {
        key = ' ';
        keyExists = true;
      }
      if (keyExists) {
        var item = {
          key: key,
          field: groupCol.getColDef().field,
          rowGroupColumn: groupCol
        };
        res.push(item);
      }
    });
    return res;
  };
  __decorate$2H([Autowired('columnModel')], GroupStage.prototype, "columnModel", void 0);
  __decorate$2H([Autowired('selectableService')], GroupStage.prototype, "selectableService", void 0);
  __decorate$2H([Autowired('valueService')], GroupStage.prototype, "valueService", void 0);
  __decorate$2H([Autowired('beans')], GroupStage.prototype, "beans", void 0);
  __decorate$2H([Autowired('selectionService')], GroupStage.prototype, "selectionService", void 0);
  __decorate$2H([PostConstruct], GroupStage.prototype, "postConstruct", null);
  GroupStage = __decorate$2H([Bean('groupStage')], GroupStage);
  return GroupStage;
}(BeanStub);
var __extends$31 = undefined && undefined.__extends || function () {
  var _extendStatics202 = function extendStatics(d, b) {
    _extendStatics202 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics202(d, b);
  };
  return function (d, b) {
    _extendStatics202(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2I = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$d = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var PivotColDefService = /** @class */function (_super) {
  __extends$31(PivotColDefService, _super);
  function PivotColDefService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PivotColDefService_1 = PivotColDefService;
  PivotColDefService.prototype.createPivotColumnDefs = function (uniqueValues) {
    // this is passed to the columnModel, to configure the columns and groups we show
    var pivotColumnGroupDefs = [];
    // this is used by the aggregation stage, to do the aggregation based on the pivot columns
    var pivotColumnDefs = [];
    var pivotColumns = this.columnModel.getPivotColumns();
    var valueColumns = this.columnModel.getValueColumns();
    var levelsDeep = pivotColumns.length;
    var columnIdSequence = new NumberSequence();
    this.recursivelyAddGroup(pivotColumnGroupDefs, pivotColumnDefs, 1, uniqueValues, [], columnIdSequence, levelsDeep, pivotColumns);
    // additional columns that contain the aggregated total for each value column per row
    this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs, valueColumns, columnIdSequence);
    // additional group columns that contain child totals for each collapsed child column / group
    this.addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence);
    // additional group columns that contain an aggregated total across all child columns
    this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence);
    // we clone, so the colDefs in pivotColumnsGroupDefs and pivotColumnDefs are not shared. this is so that
    // any changes the user makes (via processSecondaryColumnDefinitions) don't impact the internal aggregations,
    // as these use the col defs also
    var pivotColumnDefsClone = pivotColumnDefs.map(function (colDef) {
      return _.cloneObject(colDef);
    });
    return {
      pivotColumnGroupDefs: pivotColumnGroupDefs,
      pivotColumnDefs: pivotColumnDefsClone
    };
  };
  // parentChildren - the list of colDefs we are adding to
  // @index - how far the column is from the top (also same as pivotKeys.length)
  // @uniqueValues - the values for which we should create a col for
  // @pivotKeys - the keys for the pivot, eg if pivoting on {Language,Country} then could be {English,Ireland}
  PivotColDefService.prototype.recursivelyAddGroup = function (parentChildren, pivotColumnDefs, index, uniqueValues, pivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns) {
    var _this = this;
    _.iterateObject(uniqueValues, function (key, value) {
      var newPivotKeys = __spreadArrays$d(pivotKeys, [key]);
      var createGroup = index !== levelsDeep;
      if (createGroup) {
        var groupDef = {
          children: [],
          headerName: key,
          pivotKeys: newPivotKeys,
          columnGroupShow: 'open',
          groupId: 'pivot' + columnIdSequence.next()
        };
        parentChildren.push(groupDef);
        _this.recursivelyAddGroup(groupDef.children, pivotColumnDefs, index + 1, value, newPivotKeys, columnIdSequence, levelsDeep, primaryPivotColumns);
      } else {
        var measureColumns = _this.columnModel.getValueColumns();
        var valueGroup_1 = {
          children: [],
          headerName: key,
          pivotKeys: newPivotKeys,
          columnGroupShow: 'open',
          groupId: 'pivot' + columnIdSequence.next()
        };
        // if no value columns selected, then we insert one blank column, so the user at least sees columns
        // rendered. otherwise the grid would render with no columns (just empty groups) which would give the
        // impression that the grid is broken
        if (measureColumns.length === 0) {
          // this is the blank column, for when no value columns enabled.
          var colDef = _this.createColDef(null, '-', newPivotKeys, columnIdSequence);
          valueGroup_1.children.push(colDef);
          pivotColumnDefs.push(colDef);
        } else {
          measureColumns.forEach(function (measureColumn) {
            var columnName = _this.columnModel.getDisplayNameForColumn(measureColumn, 'header');
            var colDef = _this.createColDef(measureColumn, columnName, newPivotKeys, columnIdSequence);
            colDef.columnGroupShow = 'open';
            valueGroup_1.children.push(colDef);
            pivotColumnDefs.push(colDef);
          });
        }
        parentChildren.push(valueGroup_1);
      }
    });
    // sort by either user provided comparator, or our own one
    var primaryPivotColumnDefs = primaryPivotColumns[index - 1].getColDef();
    var userComparator = primaryPivotColumnDefs.pivotComparator;
    var comparator = this.headerNameComparator.bind(this, userComparator);
    parentChildren.sort(comparator);
  };
  PivotColDefService.prototype.addExpandablePivotGroups = function (pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence) {
    var _this = this;
    if (this.gridOptionsWrapper.isSuppressExpandablePivotGroups() || this.gridOptionsWrapper.getPivotColumnGroupTotals()) {
      return;
    }
    var recursivelyAddSubTotals = function recursivelyAddSubTotals(groupDef, currentPivotColumnDefs, currentColumnIdSequence, acc) {
      var group = groupDef;
      if (group.children) {
        var childAcc_1 = new Map();
        group.children.forEach(function (grp) {
          recursivelyAddSubTotals(grp, currentPivotColumnDefs, currentColumnIdSequence, childAcc_1);
        });
        var firstGroup_1 = !group.children.some(function (child) {
          return child.children;
        });
        _this.columnModel.getValueColumns().forEach(function (valueColumn) {
          var columnName = _this.columnModel.getDisplayNameForColumn(valueColumn, 'header');
          var totalColDef = _this.createColDef(valueColumn, columnName, groupDef.pivotKeys, currentColumnIdSequence);
          totalColDef.pivotTotalColumnIds = childAcc_1.get(valueColumn.getColId());
          totalColDef.columnGroupShow = 'closed';
          totalColDef.aggFunc = valueColumn.getAggFunc();
          if (!firstGroup_1) {
            // add total colDef to group and pivot colDefs array
            var children = groupDef.children;
            children.push(totalColDef);
            currentPivotColumnDefs.push(totalColDef);
          }
        });
        _this.merge(acc, childAcc_1);
      } else {
        var def = groupDef;
        // check that value column exists, i.e. aggFunc is supplied
        if (!def.pivotValueColumn) {
          return;
        }
        var pivotValueColId = def.pivotValueColumn.getColId();
        var arr = acc.has(pivotValueColId) ? acc.get(pivotValueColId) : [];
        arr.push(def.colId);
        acc.set(pivotValueColId, arr);
      }
    };
    pivotColumnGroupDefs.forEach(function (groupDef) {
      recursivelyAddSubTotals(groupDef, pivotColumnDefs, columnIdSequence, new Map());
    });
  };
  PivotColDefService.prototype.addPivotTotalsToGroups = function (pivotColumnGroupDefs, pivotColumnDefs, columnIdSequence) {
    var _this = this;
    if (!this.gridOptionsWrapper.getPivotColumnGroupTotals()) {
      return;
    }
    var insertAfter = this.gridOptionsWrapper.getPivotColumnGroupTotals() === 'after';
    var valueCols = this.columnModel.getValueColumns();
    var aggFuncs = valueCols.map(function (valueCol) {
      return valueCol.getAggFunc();
    });
    // don't add pivot totals if there is less than 1 aggFunc or they are not all the same
    if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) {
      // console.warn('AG Grid: aborting adding pivot total columns - value columns require same aggFunc');
      return;
    }
    // arbitrarily select a value column to use as a template for pivot columns
    var valueColumn = valueCols[0];
    pivotColumnGroupDefs.forEach(function (groupDef) {
      _this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter);
    });
  };
  PivotColDefService.prototype.recursivelyAddPivotTotal = function (groupDef, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter) {
    var _this = this;
    var group = groupDef;
    if (!group.children) {
      var def = groupDef;
      return def.colId ? [def.colId] : null;
    }
    var colIds = [];
    // need to recurse children first to obtain colIds used in the aggregation stage
    group.children.forEach(function (grp) {
      var childColIds = _this.recursivelyAddPivotTotal(grp, pivotColumnDefs, columnIdSequence, valueColumn, insertAfter);
      if (childColIds) {
        colIds = colIds.concat(childColIds);
      }
    });
    // only add total colDef if there is more than 1 child node
    if (group.children.length > 1) {
      var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
      var headerName = localeTextFunc('pivotColumnGroupTotals', 'Total');
      //create total colDef using an arbitrary value column as a template
      var totalColDef = this.createColDef(valueColumn, headerName, groupDef.pivotKeys, columnIdSequence);
      totalColDef.pivotTotalColumnIds = colIds;
      totalColDef.aggFunc = valueColumn.getAggFunc();
      // add total colDef to group and pivot colDefs array
      var children = groupDef.children;
      insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
      pivotColumnDefs.push(totalColDef);
    }
    return colIds;
  };
  PivotColDefService.prototype.addRowGroupTotals = function (pivotColumnGroupDefs, pivotColumnDefs, valueColumns, columnIdSequence) {
    var _this = this;
    if (!this.gridOptionsWrapper.getPivotRowTotals()) {
      return;
    }
    var insertAfter = this.gridOptionsWrapper.getPivotRowTotals() === 'after';
    // order of row group totals depends on position
    var valueCols = insertAfter ? valueColumns.slice() : valueColumns.slice().reverse();
    var _loop_1 = function _loop_1(i) {
      var valueCol = valueCols[i];
      var colIds = [];
      pivotColumnGroupDefs.forEach(function (groupDef) {
        colIds = colIds.concat(_this.extractColIdsForValueColumn(groupDef, valueCol));
      });
      this_1.createRowGroupTotal(pivotColumnGroupDefs, pivotColumnDefs, [], columnIdSequence, valueCol, colIds, insertAfter);
    };
    var this_1 = this;
    for (var i = 0; i < valueCols.length; i++) {
      _loop_1(i);
    }
  };
  PivotColDefService.prototype.extractColIdsForValueColumn = function (groupDef, valueColumn) {
    var _this = this;
    var group = groupDef;
    if (!group.children) {
      var colDef = group;
      return colDef.pivotValueColumn === valueColumn && colDef.colId ? [colDef.colId] : [];
    }
    var colIds = [];
    group.children.forEach(function (grp) {
      _this.extractColIdsForValueColumn(grp, valueColumn);
      var childColIds = _this.extractColIdsForValueColumn(grp, valueColumn);
      colIds = colIds.concat(childColIds);
    });
    return colIds;
  };
  PivotColDefService.prototype.createRowGroupTotal = function (parentChildren, pivotColumnDefs, pivotKeys, columnIdSequence, valueColumn, colIds, insertAfter) {
    var newPivotKeys = pivotKeys.slice(0);
    var measureColumns = this.columnModel.getValueColumns();
    var valueGroup = {
      children: [],
      pivotKeys: newPivotKeys,
      groupId: PivotColDefService_1.PIVOT_ROW_TOTAL_PREFIX + columnIdSequence.next()
    };
    if (measureColumns.length === 0) {
      var colDef = this.createColDef(null, '-', newPivotKeys, columnIdSequence);
      valueGroup.children.push(colDef);
      pivotColumnDefs.push(colDef);
    } else {
      var columnName = this.columnModel.getDisplayNameForColumn(valueColumn, 'header');
      var colDef = this.createColDef(valueColumn, columnName, newPivotKeys, columnIdSequence);
      colDef.pivotTotalColumnIds = colIds;
      valueGroup.children.push(colDef);
      pivotColumnDefs.push(colDef);
    }
    insertAfter ? parentChildren.push(valueGroup) : parentChildren.unshift(valueGroup);
  };
  PivotColDefService.prototype.createColDef = function (valueColumn, headerName, pivotKeys, columnIdSequence) {
    var colDef = {};
    if (valueColumn) {
      var colDefToCopy = valueColumn.getColDef();
      _.assign(colDef, colDefToCopy);
      // even if original column was hidden, we always show the pivot value column, otherwise it would be
      // very confusing for people thinking the pivot is broken
      colDef.hide = false;
    }
    colDef.headerName = headerName;
    colDef.colId = 'pivot_' + columnIdSequence.next();
    // pivot columns repeat over field, so it makes sense to use the unique id instead. For example if you want to
    // assign values to pinned bottom rows using setPinnedBottomRowData the value service will use this colId.
    colDef.field = colDef.colId;
    colDef.pivotKeys = pivotKeys;
    colDef.pivotValueColumn = valueColumn;
    colDef.filter = false;
    return colDef;
  };
  PivotColDefService.prototype.sameAggFuncs = function (aggFuncs) {
    if (aggFuncs.length == 1) {
      return true;
    }
    //check if all aggFunc's match
    for (var i = 1; i < aggFuncs.length; i++) {
      if (aggFuncs[i] !== aggFuncs[0]) {
        return false;
      }
    }
    return true;
  };
  PivotColDefService.prototype.headerNameComparator = function (userComparator, a, b) {
    if (userComparator) {
      return userComparator(a.headerName, b.headerName);
    } else {
      if (a.headerName && !b.headerName) {
        return 1;
      } else if (!a.headerName && b.headerName) {
        return -1;
      }
      // slightly naff here - just to satify typescript
      // really should be &&, but if so ts complains
      // the above if/else checks would deal with either being falsy, so at this stage if either are falsy, both are
      // ..still naff though
      if (!a.headerName || !b.headerName) {
        return 0;
      }
      if (a.headerName < b.headerName) {
        return -1;
      }
      if (a.headerName > b.headerName) {
        return 1;
      }
      return 0;
    }
  };
  PivotColDefService.prototype.merge = function (m1, m2) {
    m2.forEach(function (value, key, map) {
      var existingList = m1.has(key) ? m1.get(key) : [];
      var updatedList = __spreadArrays$d(existingList, value);
      m1.set(key, updatedList);
    });
  };
  var PivotColDefService_1;
  PivotColDefService.PIVOT_ROW_TOTAL_PREFIX = 'PivotRowTotal_';
  __decorate$2I([Autowired('columnModel')], PivotColDefService.prototype, "columnModel", void 0);
  PivotColDefService = PivotColDefService_1 = __decorate$2I([Bean('pivotColDefService')], PivotColDefService);
  return PivotColDefService;
}(BeanStub);
var __extends$32 = undefined && undefined.__extends || function () {
  var _extendStatics203 = function extendStatics(d, b) {
    _extendStatics203 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics203(d, b);
  };
  return function (d, b) {
    _extendStatics203(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2J = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PivotStage = /** @class */function (_super) {
  __extends$32(PivotStage, _super);
  function PivotStage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.uniqueValues = {};
    return _this;
  }
  PivotStage.prototype.execute = function (params) {
    var rootNode = params.rowNode;
    var changedPath = params.changedPath;
    if (this.columnModel.isPivotActive()) {
      this.executePivotOn(rootNode, changedPath);
    } else {
      this.executePivotOff(changedPath);
    }
  };
  PivotStage.prototype.executePivotOff = function (changedPath) {
    this.aggregationColumnsHashLastTime = null;
    this.uniqueValues = {};
    if (this.columnModel.isSecondaryColumnsPresent()) {
      this.columnModel.setSecondaryColumns(null, "rowModelUpdated");
      if (changedPath) {
        changedPath.setInactive();
      }
    }
  };
  PivotStage.prototype.executePivotOn = function (rootNode, changedPath) {
    var uniqueValues = this.bucketUpRowNodes(rootNode);
    var uniqueValuesChanged = this.setUniqueValues(uniqueValues);
    var aggregationColumns = this.columnModel.getValueColumns();
    var aggregationColumnsHash = aggregationColumns.map(function (column) {
      return column.getId();
    }).join('#');
    var aggregationFuncsHash = aggregationColumns.map(function (column) {
      return column.getAggFunc().toString();
    }).join('#');
    var aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
    var aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
    this.aggregationColumnsHashLastTime = aggregationColumnsHash;
    this.aggregationFuncsHashLastTime = aggregationFuncsHash;
    if (uniqueValuesChanged || aggregationColumnsChanged || aggregationFuncsChanged) {
      var _a = this.pivotColDefService.createPivotColumnDefs(this.uniqueValues),
        pivotColumnGroupDefs = _a.pivotColumnGroupDefs,
        pivotColumnDefs = _a.pivotColumnDefs;
      this.pivotColumnDefs = pivotColumnDefs;
      this.columnModel.setSecondaryColumns(pivotColumnGroupDefs, "rowModelUpdated");
      // because the secondary columns have changed, then the aggregation needs to visit the whole
      // tree again, so we make the changedPath not active, to force aggregation to visit all paths.
      if (changedPath) {
        changedPath.setInactive();
      }
    }
  };
  PivotStage.prototype.setUniqueValues = function (newValues) {
    var json1 = JSON.stringify(newValues);
    var json2 = JSON.stringify(this.uniqueValues);
    var uniqueValuesChanged = json1 !== json2;
    // we only continue the below if the unique values are different, as otherwise
    // the result will be the same as the last time we did it
    if (uniqueValuesChanged) {
      this.uniqueValues = newValues;
      return true;
    } else {
      return false;
    }
  };
  // returns true if values were different
  PivotStage.prototype.bucketUpRowNodes = function (rootNode) {
    var _this = this;
    // accessed from inside inner function
    var uniqueValues = {};
    // finds all leaf groups and calls mapRowNode with it
    var recursivelySearchForLeafNodes = function recursivelySearchForLeafNodes(rowNode) {
      if (rowNode.leafGroup) {
        _this.bucketRowNode(rowNode, uniqueValues);
      } else {
        rowNode.childrenAfterFilter.forEach(function (child) {
          recursivelySearchForLeafNodes(child);
        });
      }
    };
    recursivelySearchForLeafNodes(rootNode);
    return uniqueValues;
  };
  PivotStage.prototype.bucketRowNode = function (rowNode, uniqueValues) {
    var pivotColumns = this.columnModel.getPivotColumns();
    if (pivotColumns.length === 0) {
      rowNode.childrenMapped = null;
    } else {
      rowNode.childrenMapped = this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues);
    }
    if (rowNode.sibling) {
      rowNode.sibling.childrenMapped = rowNode.childrenMapped;
    }
  };
  PivotStage.prototype.bucketChildren = function (children, pivotColumns, pivotIndex, uniqueValues) {
    var _this = this;
    var mappedChildren = {};
    var pivotColumn = pivotColumns[pivotIndex];
    // map the children out based on the pivot column
    children.forEach(function (child) {
      var key = _this.valueService.getKeyForNode(pivotColumn, child);
      if (_.missing(key)) {
        key = '';
      }
      if (!uniqueValues[key]) {
        uniqueValues[key] = {};
      }
      if (!mappedChildren[key]) {
        mappedChildren[key] = [];
      }
      mappedChildren[key].push(child);
    });
    // if it's the last pivot column, return as is, otherwise go one level further in the map
    if (pivotIndex === pivotColumns.length - 1) {
      return mappedChildren;
    } else {
      var result_1 = {};
      _.iterateObject(mappedChildren, function (key, value) {
        result_1[key] = _this.bucketChildren(value, pivotColumns, pivotIndex + 1, uniqueValues[key]);
      });
      return result_1;
    }
  };
  PivotStage.prototype.getPivotColumnDefs = function () {
    return this.pivotColumnDefs;
  };
  __decorate$2J([Autowired('valueService')], PivotStage.prototype, "valueService", void 0);
  __decorate$2J([Autowired('columnModel')], PivotStage.prototype, "columnModel", void 0);
  __decorate$2J([Autowired('pivotColDefService')], PivotStage.prototype, "pivotColDefService", void 0);
  PivotStage = __decorate$2J([Bean('pivotStage')], PivotStage);
  return PivotStage;
}(BeanStub);
var __extends$33 = undefined && undefined.__extends || function () {
  var _extendStatics204 = function extendStatics(d, b) {
    _extendStatics204 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics204(d, b);
  };
  return function (d, b) {
    _extendStatics204(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2K = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-ignore
var AGBigInt = typeof BigInt === 'undefined' ? null : BigInt;
var AggFuncService = /** @class */function (_super) {
  __extends$33(AggFuncService, _super);
  function AggFuncService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.aggFuncsMap = {};
    _this.initialised = false;
    return _this;
  }
  AggFuncService_1 = AggFuncService;
  AggFuncService.prototype.init = function () {
    if (this.initialised) {
      return;
    }
    this.initialiseWithDefaultAggregations();
    this.addAggFuncs(this.gridOptionsWrapper.getAggFuncs());
  };
  AggFuncService.prototype.initialiseWithDefaultAggregations = function () {
    this.aggFuncsMap[AggFuncService_1.AGG_SUM] = aggSum;
    this.aggFuncsMap[AggFuncService_1.AGG_FIRST] = aggFirst;
    this.aggFuncsMap[AggFuncService_1.AGG_LAST] = aggLast;
    this.aggFuncsMap[AggFuncService_1.AGG_MIN] = aggMin;
    this.aggFuncsMap[AggFuncService_1.AGG_MAX] = aggMax;
    this.aggFuncsMap[AggFuncService_1.AGG_COUNT] = aggCount;
    this.aggFuncsMap[AggFuncService_1.AGG_AVG] = aggAvg;
    this.initialised = true;
  };
  AggFuncService.prototype.getDefaultAggFunc = function (column) {
    var allKeys = this.getFuncNames(column);
    // use 'sum' if it's a) allowed for the column and b) still registered
    // (ie not removed by user)
    var sumInKeysList = _.includes(allKeys, AggFuncService_1.AGG_SUM);
    var sumInFuncs = _.exists(this.aggFuncsMap[AggFuncService_1.AGG_SUM]);
    if (sumInKeysList && sumInFuncs) {
      return AggFuncService_1.AGG_SUM;
    }
    return _.existsAndNotEmpty(allKeys) ? allKeys[0] : null;
  };
  AggFuncService.prototype.addAggFuncs = function (aggFuncs) {
    _.iterateObject(aggFuncs, this.addAggFunc.bind(this));
  };
  AggFuncService.prototype.addAggFunc = function (key, aggFunc) {
    this.init();
    this.aggFuncsMap[key] = aggFunc;
  };
  AggFuncService.prototype.getAggFunc = function (name) {
    this.init();
    return this.aggFuncsMap[name];
  };
  AggFuncService.prototype.getFuncNames = function (column) {
    var userAllowedFuncs = column.getColDef().allowedAggFuncs;
    return userAllowedFuncs == null ? Object.keys(this.aggFuncsMap).sort() : userAllowedFuncs;
  };
  AggFuncService.prototype.clear = function () {
    this.aggFuncsMap = {};
  };
  var AggFuncService_1;
  AggFuncService.AGG_SUM = 'sum';
  AggFuncService.AGG_FIRST = 'first';
  AggFuncService.AGG_LAST = 'last';
  AggFuncService.AGG_MIN = 'min';
  AggFuncService.AGG_MAX = 'max';
  AggFuncService.AGG_COUNT = 'count';
  AggFuncService.AGG_AVG = 'avg';
  __decorate$2K([PostConstruct], AggFuncService.prototype, "init", null);
  AggFuncService = AggFuncService_1 = __decorate$2K([Bean('aggFuncService')], AggFuncService);
  return AggFuncService;
}(BeanStub);
function aggSum(params) {
  var values = params.values;
  var result = null; // the logic ensures that we never combine bigint arithmetic with numbers, but TS is hard to please
  // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    if (typeof value === 'number') {
      if (result === null) {
        result = value;
      } else {
        if (AGBigInt) {
          result += typeof result === 'number' ? value : AGBigInt(value);
        } else {
          result += value;
        }
      }
    } else if (typeof value === 'bigint') {
      if (result === null) {
        result = value;
      } else {
        result = (typeof result === 'bigint' ? result : AGBigInt(result)) + value;
      }
    }
  }
  return result;
}
function aggFirst(params) {
  return params.values.length > 0 ? params.values[0] : null;
}
function aggLast(params) {
  return params.values.length > 0 ? _.last(params.values) : null;
}
function aggMin(params) {
  var values = params.values;
  var result = null;
  // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    if ((typeof value === 'number' || typeof value === 'bigint') && (result === null || result > value)) {
      result = value;
    }
  }
  return result;
}
function aggMax(params) {
  var values = params.values;
  var result = null;
  // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    if ((typeof value === 'number' || typeof value === 'bigint') && (result === null || result < value)) {
      result = value;
    }
  }
  return result;
}
function aggCount(params) {
  var values = params.values;
  var result = 0;
  // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    // check if the value is from a group, in which case use the group's count
    result += value != null && typeof value.value === 'number' ? value.value : 1;
  }
  return {
    value: result,
    toString: function toString() {
      return this.value.toString();
    },
    // used for sorting
    toNumber: function toNumber() {
      return this.value;
    }
  };
}
// the average function is tricky as the multiple levels require weighted averages
// for the non-leaf node aggregations.
function aggAvg(params) {
  var values = params.values;
  var sum = 0; // the logic ensures that we never combine bigint arithmetic with numbers, but TS is hard to please
  var count = 0;
  // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
  for (var i = 0; i < values.length; i++) {
    var currentValue = values[i];
    var valueToAdd = null;
    if (typeof currentValue === 'number' || typeof currentValue === 'bigint') {
      valueToAdd = currentValue;
      count++;
    } else if (currentValue != null && (typeof currentValue.value === 'number' || typeof currentValue.value === 'bigint') && typeof currentValue.count === 'number') {
      // we are aggregating groups, so we take the aggregated values to calculated a weighted average
      if (AGBigInt) {
        valueToAdd = currentValue.value * (typeof currentValue.value === 'number' ? currentValue.count : AGBigInt(currentValue.count));
      } else {
        valueToAdd = currentValue.value * currentValue.count;
      }
      count += currentValue.count;
    }
    if (typeof valueToAdd === 'number') {
      if (AGBigInt) {
        sum += typeof sum === 'number' ? valueToAdd : AGBigInt(valueToAdd);
      } else {
        sum += valueToAdd;
      }
    } else if (typeof valueToAdd === 'bigint') {
      sum = (typeof sum === 'bigint' ? sum : AGBigInt(sum)) + valueToAdd;
    }
  }
  var value = null;
  // avoid divide by zero error
  if (count > 0) {
    if (AGBigInt) {
      value = sum / (typeof sum === 'number' ? count : AGBigInt(count));
    } else {
      value = sum / count;
    }
  }
  // the result will be an object. when this cell is rendered, only the avg is shown.
  // however when this cell is part of another aggregation, the count is also needed
  // to create a weighted average for the next level.
  return {
    count: count,
    value: value,
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function toString() {
      return typeof this.value === 'number' || typeof this.value === 'bigint' ? this.value.toString() : '';
    },
    // used for sorting
    toNumber: function toNumber() {
      return this.value;
    }
  };
}
var __extends$34 = undefined && undefined.__extends || function () {
  var _extendStatics205 = function extendStatics(d, b) {
    _extendStatics205 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics205(d, b);
  };
  return function (d, b) {
    _extendStatics205(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2L = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DropZoneColumnComp = /** @class */function (_super) {
  __extends$34(DropZoneColumnComp, _super);
  function DropZoneColumnComp(column, dragSourceDropTarget, ghost, valueColumn, horizontal) {
    var _this = _super.call(this) || this;
    _this.column = column;
    _this.dragSourceDropTarget = dragSourceDropTarget;
    _this.ghost = ghost;
    _this.valueColumn = valueColumn;
    _this.horizontal = horizontal;
    _this.popupShowing = false;
    return _this;
  }
  DropZoneColumnComp.prototype.init = function () {
    this.setTemplate(DropZoneColumnComp.TEMPLATE);
    this.addElementClasses(this.getGui());
    this.addElementClasses(this.eDragHandle, 'drag-handle');
    this.addElementClasses(this.eText, 'text');
    this.addElementClasses(this.eButton, 'button');
    this.eDragHandle.appendChild(_.createIconNoSpan('columnDrag', this.gridOptionsWrapper));
    this.eButton.appendChild(_.createIconNoSpan('cancel', this.gridOptionsWrapper));
    this.displayName = this.columnModel.getDisplayNameForColumn(this.column, 'columnDrop');
    this.setupComponents();
    if (!this.ghost && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
      this.addDragSource();
    }
    this.setupTooltip();
  };
  DropZoneColumnComp.prototype.setupTooltip = function () {
    var _this = this;
    var refresh = function refresh() {
      var newTooltipText = _this.column.getColDef().headerTooltip;
      _this.setTooltip(newTooltipText);
    };
    refresh();
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
  };
  DropZoneColumnComp.prototype.addDragSource = function () {
    var _this = this;
    var dragSource = {
      type: DragSourceType.ToolPanel,
      eElement: this.eDragHandle,
      defaultIconName: DragAndDropService.ICON_HIDE,
      getDragItem: function getDragItem() {
        return _this.createDragItem();
      },
      dragItemName: this.displayName,
      dragSourceDropTarget: this.dragSourceDropTarget
    };
    this.dragAndDropService.addDragSource(dragSource, true);
    this.addDestroyFunc(function () {
      return _this.dragAndDropService.removeDragSource(dragSource);
    });
  };
  DropZoneColumnComp.prototype.createDragItem = function () {
    var visibleState = {};
    visibleState[this.column.getId()] = this.column.isVisible();
    return {
      columns: [this.column],
      visibleState: visibleState
    };
  };
  DropZoneColumnComp.prototype.setupComponents = function () {
    this.setTextValue();
    this.setupRemove();
    if (this.ghost) {
      _.addCssClass(this.getGui(), 'ag-column-drop-cell-ghost');
    }
    if (this.valueColumn && !this.gridOptionsWrapper.isFunctionsReadOnly()) {
      this.addGuiEventListener('click', this.onShowAggFuncSelection.bind(this));
    }
  };
  DropZoneColumnComp.prototype.setupRemove = function () {
    var _this = this;
    _.setDisplayed(this.eButton, !this.gridOptionsWrapper.isFunctionsReadOnly());
    this.addManagedListener(this.eButton, 'click', function (mouseEvent) {
      var agEvent = {
        type: DropZoneColumnComp.EVENT_COLUMN_REMOVE
      };
      _this.dispatchEvent(agEvent);
      mouseEvent.stopPropagation();
    });
    var touchListener = new TouchListener(this.eButton);
    this.addManagedListener(touchListener, TouchListener.EVENT_TAP, function (event) {
      var agEvent = {
        type: DropZoneColumnComp.EVENT_COLUMN_REMOVE
      };
      _this.dispatchEvent(agEvent);
    });
    this.addDestroyFunc(touchListener.destroy.bind(touchListener));
  };
  DropZoneColumnComp.prototype.setTextValue = function () {
    var displayValue;
    if (this.valueColumn) {
      var aggFunc = this.column.getAggFunc();
      // if aggFunc is a string, we can use it, but if it's a function, then we swap with 'func'
      var aggFuncString = typeof aggFunc === 'string' ? aggFunc : 'agg';
      var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
      var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
      displayValue = aggFuncStringTranslated + "(" + this.displayName + ")";
    } else {
      displayValue = this.displayName;
    }
    var displayValueSanitised = _.escapeString(displayValue);
    this.eText.innerHTML = displayValueSanitised;
  };
  DropZoneColumnComp.prototype.onShowAggFuncSelection = function () {
    var _this = this;
    if (this.popupShowing) {
      return;
    }
    this.popupShowing = true;
    var virtualList = new VirtualList('select-agg-func');
    var rows = this.aggFuncService.getFuncNames(this.column);
    virtualList.setModel({
      getRow: function getRow(index) {
        return rows[index];
      },
      getRowCount: function getRowCount() {
        return rows.length;
      }
    });
    this.getContext().createBean(virtualList);
    var ePopup = _.loadTemplate('<div class="ag-select-agg-func-popup"></div>');
    ePopup.style.top = '0px';
    ePopup.style.left = '0px';
    ePopup.appendChild(virtualList.getGui());
    // ePopup.style.height = this.gridOptionsWrapper.getAggFuncPopupHeight() + 'px';
    ePopup.style.width = this.getGui().clientWidth + 'px';
    var popupHiddenFunc = function popupHiddenFunc() {
      _this.destroyBean(virtualList);
      _this.popupShowing = false;
    };
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: ePopup,
      closeOnEsc: true,
      closedCallback: popupHiddenFunc,
      ariaLabel: translate('ariaLabelAggregationFunction', 'Aggregation Function')
    });
    if (addPopupRes) {
      virtualList.setComponentCreator(this.createAggSelect.bind(this, addPopupRes.hideFunc));
    }
    this.popupService.positionPopupUnderComponent({
      type: 'aggFuncSelect',
      eventSource: this.getGui(),
      ePopup: ePopup,
      keepWithinBounds: true,
      column: this.column
    });
    virtualList.refresh();
  };
  DropZoneColumnComp.prototype.createAggSelect = function (hidePopup, value) {
    var _this = this;
    var itemSelected = function itemSelected() {
      hidePopup();
      if (_this.gridOptionsWrapper.isFunctionsPassive()) {
        var event_1 = {
          type: Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST,
          columns: [_this.column],
          aggFunc: value,
          api: _this.gridApi,
          columnApi: _this.columnApi
        };
        _this.eventService.dispatchEvent(event_1);
      } else {
        _this.columnModel.setColumnAggFunc(_this.column, value, "toolPanelDragAndDrop");
      }
    };
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var aggFuncString = value.toString();
    var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
    var comp = new AggItemComp(itemSelected, aggFuncStringTranslated);
    return comp;
  };
  DropZoneColumnComp.prototype.addElementClasses = function (el, suffix) {
    suffix = suffix ? "-" + suffix : '';
    _.addCssClass(el, "ag-column-drop-cell" + suffix);
    var direction = this.horizontal ? 'horizontal' : 'vertical';
    _.addCssClass(el, "ag-column-drop-" + direction + "-cell" + suffix);
  };
  DropZoneColumnComp.EVENT_COLUMN_REMOVE = 'columnRemove';
  DropZoneColumnComp.TEMPLATE = "<span>\n          <span ref=\"eDragHandle\" class=\"ag-drag-handle ag-column-drop-cell-drag-handle\"></span>\n          <span ref=\"eText\" class=\"ag-column-drop-cell-text\"></span>\n          <span ref=\"eButton\" class=\"ag-column-drop-cell-button\"></span>\n        </span>";
  __decorate$2L([Autowired('dragAndDropService')], DropZoneColumnComp.prototype, "dragAndDropService", void 0);
  __decorate$2L([Autowired('columnModel')], DropZoneColumnComp.prototype, "columnModel", void 0);
  __decorate$2L([Autowired('popupService')], DropZoneColumnComp.prototype, "popupService", void 0);
  __decorate$2L([Optional('aggFuncService')], DropZoneColumnComp.prototype, "aggFuncService", void 0);
  __decorate$2L([Autowired('columnApi')], DropZoneColumnComp.prototype, "columnApi", void 0);
  __decorate$2L([Autowired('gridApi')], DropZoneColumnComp.prototype, "gridApi", void 0);
  __decorate$2L([RefSelector('eText')], DropZoneColumnComp.prototype, "eText", void 0);
  __decorate$2L([RefSelector('eDragHandle')], DropZoneColumnComp.prototype, "eDragHandle", void 0);
  __decorate$2L([RefSelector('eButton')], DropZoneColumnComp.prototype, "eButton", void 0);
  __decorate$2L([PostConstruct], DropZoneColumnComp.prototype, "init", null);
  return DropZoneColumnComp;
}(Component);
var AggItemComp = /** @class */function (_super) {
  __extends$34(AggItemComp, _super);
  function AggItemComp(itemSelected, value) {
    var _this = _super.call(this, '<div class="ag-select-agg-func-item"/>') || this;
    _this.getGui().innerText = value;
    _this.value = value;
    _this.addGuiEventListener('click', itemSelected);
    return _this;
  }
  return AggItemComp;
}(Component);
var __extends$35 = undefined && undefined.__extends || function () {
  var _extendStatics206 = function extendStatics(d, b) {
    _extendStatics206 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics206(d, b);
  };
  return function (d, b) {
    _extendStatics206(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var BaseDropZonePanel = /** @class */function (_super) {
  __extends$35(BaseDropZonePanel, _super);
  function BaseDropZonePanel(horizontal, valueColumn) {
    var _this = _super.call(this, "<div class=\"ag-unselectable\"></div>") || this;
    _this.horizontal = horizontal;
    _this.valueColumn = valueColumn;
    _this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
    _this.guiDestroyFunctions = [];
    _this.childColumnComponents = [];
    _this.resizeEnabled = false;
    _this.addElementClasses(_this.getGui());
    _this.eColumnDropList = document.createElement('div');
    _this.addElementClasses(_this.eColumnDropList, 'list');
    return _this;
  }
  BaseDropZonePanel.prototype.isHorizontal = function () {
    return this.horizontal;
  };
  BaseDropZonePanel.prototype.toggleResizable = function (resizable) {
    this.positionableFeature.setResizable(resizable ? {
      bottom: true
    } : false);
    this.resizeEnabled = resizable;
  };
  BaseDropZonePanel.prototype.setBeans = function (beans) {
    this.beans = beans;
  };
  BaseDropZonePanel.prototype.destroy = function () {
    this.destroyGui();
    _super.prototype.destroy.call(this);
  };
  BaseDropZonePanel.prototype.destroyGui = function () {
    this.guiDestroyFunctions.forEach(function (func) {
      return func();
    });
    this.guiDestroyFunctions.length = 0;
    this.childColumnComponents.length = 0;
    _.clearElement(this.getGui());
    _.clearElement(this.eColumnDropList);
  };
  BaseDropZonePanel.prototype.init = function (params) {
    this.params = params;
    this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.refreshGui.bind(this));
    this.addManagedListener(this.beans.gridOptionsWrapper, 'functionsReadOnly', this.refreshGui.bind(this));
    this.setupDropTarget();
    this.positionableFeature = new PositionableFeature(this.getGui(), {
      minHeight: 100
    });
    this.createManagedBean(this.positionableFeature);
    // we don't know if this bean will be initialised before columnModel.
    // if columnModel first, then below will work
    // if columnModel second, then below will put blank in, and then above event gets first when columnModel is set up
    this.refreshGui();
  };
  BaseDropZonePanel.prototype.addElementClasses = function (el, suffix) {
    suffix = suffix ? "-" + suffix : '';
    _.addCssClass(el, "ag-column-drop" + suffix);
    var direction = this.horizontal ? 'horizontal' : 'vertical';
    _.addCssClass(el, "ag-column-drop-" + direction + suffix);
  };
  BaseDropZonePanel.prototype.setupDropTarget = function () {
    this.dropTarget = {
      getContainer: this.getGui.bind(this),
      getIconName: this.getIconName.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragEnter: this.onDragEnter.bind(this),
      onDragLeave: this.onDragLeave.bind(this),
      onDragStop: this.onDragStop.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    };
    this.beans.dragAndDropService.addDropTarget(this.dropTarget);
  };
  BaseDropZonePanel.prototype.isInterestedIn = function (type) {
    // not interested in row drags
    return type === DragSourceType.HeaderCell || type === DragSourceType.ToolPanel;
  };
  BaseDropZonePanel.prototype.checkInsertIndex = function (draggingEvent) {
    var newIndex = this.horizontal ? this.getNewHorizontalInsertIndex(draggingEvent) : this.getNewVerticalInsertIndex(draggingEvent);
    // <0 happens when drag is no a direction we are interested in, eg drag is up/down but in horizontal panel
    if (newIndex < 0) {
      return false;
    }
    var changed = newIndex !== this.insertIndex;
    if (changed) {
      this.insertIndex = newIndex;
    }
    return changed;
  };
  BaseDropZonePanel.prototype.getNewHorizontalInsertIndex = function (draggingEvent) {
    if (_.missing(draggingEvent.hDirection)) {
      return -1;
    }
    var newIndex = 0;
    var mouseEvent = draggingEvent.event;
    var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
    var goingLeft = draggingEvent.hDirection === HorizontalDirection.Left;
    var mouseX = mouseEvent.clientX;
    this.childColumnComponents.forEach(function (childColumn) {
      var rect = childColumn.getGui().getBoundingClientRect();
      var rectX = goingLeft ? rect.right : rect.left;
      var horizontalFit = enableRtl ? mouseX <= rectX : mouseX >= rectX;
      if (horizontalFit) {
        newIndex++;
      }
    });
    return newIndex;
  };
  BaseDropZonePanel.prototype.getNewVerticalInsertIndex = function (draggingEvent) {
    if (_.missing(draggingEvent.vDirection)) {
      return -1;
    }
    var newIndex = 0;
    var mouseEvent = draggingEvent.event;
    this.childColumnComponents.forEach(function (childColumn) {
      var rect = childColumn.getGui().getBoundingClientRect();
      var verticalFit = mouseEvent.clientY >= (draggingEvent.vDirection === VerticalDirection.Down ? rect.top : rect.bottom);
      if (verticalFit) {
        newIndex++;
      }
    });
    return newIndex;
  };
  BaseDropZonePanel.prototype.checkDragStartedBySelf = function (draggingEvent) {
    if (this.state !== BaseDropZonePanel.STATE_NOT_DRAGGING) {
      return;
    }
    this.state = BaseDropZonePanel.STATE_REARRANGE_COLUMNS;
    this.potentialDndColumns = draggingEvent.dragSource.getDragItem().columns || [];
    this.refreshGui();
    this.checkInsertIndex(draggingEvent);
    this.refreshGui();
  };
  BaseDropZonePanel.prototype.onDragging = function (draggingEvent) {
    this.checkDragStartedBySelf(draggingEvent);
    if (this.checkInsertIndex(draggingEvent)) {
      this.refreshGui();
    }
  };
  BaseDropZonePanel.prototype.onDragEnter = function (draggingEvent) {
    // this will contain all columns that are potential drops
    var dragColumns = draggingEvent.dragSource.getDragItem().columns || [];
    this.state = BaseDropZonePanel.STATE_NEW_COLUMNS_IN;
    // take out columns that are not droppable
    var goodDragColumns = dragColumns.filter(this.isColumnDroppable.bind(this));
    if (goodDragColumns.length > 0) {
      this.potentialDndColumns = goodDragColumns;
      this.checkInsertIndex(draggingEvent);
      this.refreshGui();
    }
  };
  BaseDropZonePanel.prototype.isPotentialDndColumns = function () {
    return _.existsAndNotEmpty(this.potentialDndColumns);
  };
  BaseDropZonePanel.prototype.onDragLeave = function (draggingEvent) {
    // if the dragging started from us, we remove the group, however if it started
    // someplace else, then we don't, as it was only 'asking'
    if (this.state === BaseDropZonePanel.STATE_REARRANGE_COLUMNS) {
      var columns = draggingEvent.dragSource.getDragItem().columns || [];
      this.removeColumns(columns);
    }
    if (this.isPotentialDndColumns()) {
      this.potentialDndColumns = [];
      this.refreshGui();
    }
    this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
  };
  BaseDropZonePanel.prototype.onDragStop = function () {
    if (this.isPotentialDndColumns()) {
      var success = false;
      if (this.state === BaseDropZonePanel.STATE_NEW_COLUMNS_IN) {
        this.addColumns(this.potentialDndColumns);
        success = true;
      } else {
        success = this.rearrangeColumns(this.potentialDndColumns);
      }
      this.potentialDndColumns = [];
      // If the function is passive, then we don't refresh, as we assume the client application
      // is going to call setRowGroups / setPivots / setValues at a later point which will then
      // cause a refresh. This gives a nice GUI where the ghost stays until the app has caught
      // up with the changes. However, if there was no change in the order, then we do need to
      // refresh to reset the columns
      if (!this.beans.gridOptionsWrapper.isFunctionsPassive() || !success) {
        this.refreshGui();
      }
    }
    this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
  };
  BaseDropZonePanel.prototype.removeColumns = function (columnsToRemove) {
    var newColumnList = this.getExistingColumns().filter(function (col) {
      return !_.includes(columnsToRemove, col);
    });
    this.updateColumns(newColumnList);
  };
  BaseDropZonePanel.prototype.addColumns = function (columnsToAdd) {
    if (!columnsToAdd) {
      return;
    }
    var newColumnList = this.getExistingColumns().slice();
    var colsToAddNoDuplicates = columnsToAdd.filter(function (col) {
      return newColumnList.indexOf(col) < 0;
    });
    _.insertArrayIntoArray(newColumnList, colsToAddNoDuplicates, this.insertIndex);
    this.updateColumns(newColumnList);
  };
  BaseDropZonePanel.prototype.rearrangeColumns = function (columnsToAdd) {
    var newColumnList = this.getNonGhostColumns().slice();
    _.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
    if (_.areEqual(newColumnList, this.getExistingColumns())) {
      return false;
    }
    this.updateColumns(newColumnList);
    return true;
  };
  BaseDropZonePanel.prototype.refreshGui = function () {
    // we reset the scroll position after the refresh.
    // if we don't do this, then the list will always scroll to the top
    // each time we refresh it. this is because part of the refresh empties
    // out the list which sets scroll to zero. so the user could be just
    // reordering the list - we want to prevent the resetting of the scroll.
    // this is relevant for vertical display only (as horizontal has no scroll)
    var scrollTop = this.eColumnDropList.scrollTop;
    var resizeEnabled = this.resizeEnabled;
    this.toggleResizable(false);
    this.destroyGui();
    this.addIconAndTitleToGui();
    this.addEmptyMessageToGui();
    this.addColumnsToGui();
    if (!this.isHorizontal()) {
      this.eColumnDropList.scrollTop = scrollTop;
    }
    if (resizeEnabled) {
      this.toggleResizable(resizeEnabled);
    }
  };
  BaseDropZonePanel.prototype.getNonGhostColumns = function () {
    var _this = this;
    var existingColumns = this.getExistingColumns();
    if (this.isPotentialDndColumns()) {
      return existingColumns.filter(function (column) {
        return !_.includes(_this.potentialDndColumns, column);
      });
    }
    return existingColumns;
  };
  BaseDropZonePanel.prototype.addColumnsToGui = function () {
    var _this = this;
    var nonGhostColumns = this.getNonGhostColumns();
    var addingGhosts = this.isPotentialDndColumns();
    var itemsToAddToGui = [];
    nonGhostColumns.forEach(function (column, index) {
      if (addingGhosts && index >= _this.insertIndex) {
        return;
      }
      var columnComponent = _this.createColumnComponent(column, false);
      itemsToAddToGui.push(columnComponent);
    });
    if (this.isPotentialDndColumns()) {
      this.potentialDndColumns.forEach(function (column) {
        var columnComponent = _this.createColumnComponent(column, true);
        itemsToAddToGui.push(columnComponent);
      });
      nonGhostColumns.forEach(function (column, index) {
        if (index < _this.insertIndex) {
          return;
        }
        var columnComponent = _this.createColumnComponent(column, false);
        itemsToAddToGui.push(columnComponent);
      });
    }
    this.getGui().appendChild(this.eColumnDropList);
    itemsToAddToGui.forEach(function (columnComponent, index) {
      if (index > 0) {
        _this.addArrow(_this.eColumnDropList);
      }
      _this.eColumnDropList.appendChild(columnComponent.getGui());
    });
  };
  BaseDropZonePanel.prototype.createColumnComponent = function (column, ghost) {
    var _this = this;
    var columnComponent = new DropZoneColumnComp(column, this.dropTarget, ghost, this.valueColumn, this.horizontal);
    columnComponent.addEventListener(DropZoneColumnComp.EVENT_COLUMN_REMOVE, this.removeColumns.bind(this, [column]));
    this.beans.context.createBean(columnComponent);
    this.guiDestroyFunctions.push(function () {
      return _this.destroyBean(columnComponent);
    });
    if (!ghost) {
      this.childColumnComponents.push(columnComponent);
    }
    return columnComponent;
  };
  BaseDropZonePanel.prototype.addIconAndTitleToGui = function () {
    var eGroupIcon = this.params.icon;
    var eTitleBar = document.createElement('div');
    this.addElementClasses(eTitleBar, 'title-bar');
    this.addElementClasses(eGroupIcon, 'icon');
    _.addOrRemoveCssClass(this.getGui(), 'ag-column-drop-empty', this.isExistingColumnsEmpty());
    eTitleBar.appendChild(eGroupIcon);
    if (!this.horizontal) {
      var eTitle = document.createElement('span');
      this.addElementClasses(eTitle, 'title');
      eTitle.innerHTML = this.params.title;
      eTitleBar.appendChild(eTitle);
    }
    this.getGui().appendChild(eTitleBar);
  };
  BaseDropZonePanel.prototype.isExistingColumnsEmpty = function () {
    return this.getExistingColumns().length === 0;
  };
  BaseDropZonePanel.prototype.addEmptyMessageToGui = function () {
    if (!this.isExistingColumnsEmpty() || this.isPotentialDndColumns()) {
      return;
    }
    var eMessage = document.createElement('span');
    eMessage.innerHTML = this.params.emptyMessage;
    this.addElementClasses(eMessage, 'empty-message');
    this.eColumnDropList.appendChild(eMessage);
  };
  BaseDropZonePanel.prototype.addArrow = function (eParent) {
    // only add the arrows if the layout is horizontal
    if (this.horizontal) {
      // for RTL it's a left arrow, otherwise it's a right arrow
      var enableRtl = this.beans.gridOptionsWrapper.isEnableRtl();
      var icon = _.createIconNoSpan(enableRtl ? 'smallLeft' : 'smallRight', this.beans.gridOptionsWrapper);
      this.addElementClasses(icon, 'cell-separator');
      eParent.appendChild(icon);
    }
  };
  BaseDropZonePanel.STATE_NOT_DRAGGING = 'notDragging';
  BaseDropZonePanel.STATE_NEW_COLUMNS_IN = 'newColumnsIn';
  BaseDropZonePanel.STATE_REARRANGE_COLUMNS = 'rearrangeColumns';
  return BaseDropZonePanel;
}(Component);
var __extends$36 = undefined && undefined.__extends || function () {
  var _extendStatics207 = function extendStatics(d, b) {
    _extendStatics207 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics207(d, b);
  };
  return function (d, b) {
    _extendStatics207(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2M = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RowGroupDropZonePanel = /** @class */function (_super) {
  __extends$36(RowGroupDropZonePanel, _super);
  function RowGroupDropZonePanel(horizontal) {
    return _super.call(this, horizontal, false) || this;
  }
  RowGroupDropZonePanel.prototype.passBeansUp = function () {
    _super.prototype.setBeans.call(this, {
      gridOptionsWrapper: this.gridOptionsWrapper,
      eventService: this.eventService,
      context: this.getContext(),
      loggerFactory: this.loggerFactory,
      dragAndDropService: this.dragAndDropService
    });
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var emptyMessage = localeTextFunc('rowGroupColumnsEmptyMessage', 'Drag here to set row groups');
    var title = localeTextFunc('groups', 'Row Groups');
    _super.prototype.init.call(this, {
      dragAndDropIcon: DragAndDropService.ICON_GROUP,
      icon: _.createIconNoSpan('rowGroupPanel', this.gridOptionsWrapper, null),
      emptyMessage: emptyMessage,
      title: title
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshGui.bind(this));
  };
  RowGroupDropZonePanel.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'rowGroupColumnsList';
    return res;
  };
  RowGroupDropZonePanel.prototype.isColumnDroppable = function (column) {
    // we never allow grouping of secondary columns
    if (this.gridOptionsWrapper.isFunctionsReadOnly() || !column.isPrimary()) {
      return false;
    }
    return column.isAllowRowGroup() && !column.isRowGroupActive();
  };
  RowGroupDropZonePanel.prototype.updateColumns = function (columns) {
    if (this.gridOptionsWrapper.isFunctionsPassive()) {
      var event_1 = {
        type: Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
        columns: columns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    } else {
      this.columnModel.setRowGroupColumns(columns, "toolPanelUi");
    }
  };
  RowGroupDropZonePanel.prototype.getIconName = function () {
    return this.isPotentialDndColumns() ? DragAndDropService.ICON_GROUP : DragAndDropService.ICON_NOT_ALLOWED;
  };
  RowGroupDropZonePanel.prototype.getExistingColumns = function () {
    return this.columnModel.getRowGroupColumns();
  };
  __decorate$2M([Autowired('columnModel')], RowGroupDropZonePanel.prototype, "columnModel", void 0);
  __decorate$2M([Autowired('loggerFactory')], RowGroupDropZonePanel.prototype, "loggerFactory", void 0);
  __decorate$2M([Autowired('dragAndDropService')], RowGroupDropZonePanel.prototype, "dragAndDropService", void 0);
  __decorate$2M([Autowired('columnApi')], RowGroupDropZonePanel.prototype, "columnApi", void 0);
  __decorate$2M([Autowired('gridApi')], RowGroupDropZonePanel.prototype, "gridApi", void 0);
  __decorate$2M([PostConstruct], RowGroupDropZonePanel.prototype, "passBeansUp", null);
  return RowGroupDropZonePanel;
}(BaseDropZonePanel);
var __extends$37 = undefined && undefined.__extends || function () {
  var _extendStatics208 = function extendStatics(d, b) {
    _extendStatics208 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics208(d, b);
  };
  return function (d, b) {
    _extendStatics208(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2N = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PivotDropZonePanel = /** @class */function (_super) {
  __extends$37(PivotDropZonePanel, _super);
  function PivotDropZonePanel(horizontal) {
    return _super.call(this, horizontal, false) || this;
  }
  PivotDropZonePanel.prototype.passBeansUp = function () {
    _super.prototype.setBeans.call(this, {
      gridOptionsWrapper: this.gridOptionsWrapper,
      eventService: this.eventService,
      context: this.getContext(),
      loggerFactory: this.loggerFactory,
      dragAndDropService: this.dragAndDropService
    });
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var emptyMessage = localeTextFunc('pivotColumnsEmptyMessage', 'Drag here to set column labels');
    var title = localeTextFunc('pivots', 'Column Labels');
    _super.prototype.init.call(this, {
      dragAndDropIcon: DragAndDropService.ICON_GROUP,
      icon: _.createIconNoSpan('pivotPanel', this.gridOptionsWrapper, null),
      emptyMessage: emptyMessage,
      title: title
    });
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.refresh.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.refresh.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.checkVisibility.bind(this));
    this.refresh();
  };
  PivotDropZonePanel.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'pivotColumnsList';
    return res;
  };
  PivotDropZonePanel.prototype.refresh = function () {
    this.checkVisibility();
    this.refreshGui();
  };
  PivotDropZonePanel.prototype.checkVisibility = function () {
    var pivotMode = this.columnModel.isPivotMode();
    if (this.isHorizontal()) {
      // what we do for horizontal (ie the pivot panel at the top) depends
      // on the user property as well as pivotMode.
      switch (this.gridOptionsWrapper.getPivotPanelShow()) {
        case 'always':
          this.setDisplayed(pivotMode);
          break;
        case 'onlyWhenPivoting':
          var pivotActive = this.columnModel.isPivotActive();
          this.setDisplayed(pivotMode && pivotActive);
          break;
        default:
          // never show it
          this.setDisplayed(false);
          break;
      }
    } else {
      // in toolPanel, the pivot panel is always shown when pivot mode is on
      this.setDisplayed(pivotMode);
    }
  };
  PivotDropZonePanel.prototype.isColumnDroppable = function (column) {
    // we never allow grouping of secondary columns
    if (this.gridOptionsWrapper.isFunctionsReadOnly() || !column.isPrimary()) {
      return false;
    }
    return column.isAllowPivot() && !column.isPivotActive();
  };
  PivotDropZonePanel.prototype.updateColumns = function (columns) {
    if (this.gridOptionsWrapper.isFunctionsPassive()) {
      var event_1 = {
        type: Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
        columns: columns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    } else {
      this.columnModel.setPivotColumns(columns, "toolPanelUi");
    }
  };
  PivotDropZonePanel.prototype.getIconName = function () {
    return this.isPotentialDndColumns() ? DragAndDropService.ICON_PIVOT : DragAndDropService.ICON_NOT_ALLOWED;
  };
  PivotDropZonePanel.prototype.getExistingColumns = function () {
    return this.columnModel.getPivotColumns();
  };
  __decorate$2N([Autowired('columnModel')], PivotDropZonePanel.prototype, "columnModel", void 0);
  __decorate$2N([Autowired('loggerFactory')], PivotDropZonePanel.prototype, "loggerFactory", void 0);
  __decorate$2N([Autowired('dragAndDropService')], PivotDropZonePanel.prototype, "dragAndDropService", void 0);
  __decorate$2N([Autowired('columnApi')], PivotDropZonePanel.prototype, "columnApi", void 0);
  __decorate$2N([Autowired('gridApi')], PivotDropZonePanel.prototype, "gridApi", void 0);
  __decorate$2N([PostConstruct], PivotDropZonePanel.prototype, "passBeansUp", null);
  return PivotDropZonePanel;
}(BaseDropZonePanel);
var __extends$38 = undefined && undefined.__extends || function () {
  var _extendStatics209 = function extendStatics(d, b) {
    _extendStatics209 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics209(d, b);
  };
  return function (d, b) {
    _extendStatics209(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2O = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridHeaderDropZones = /** @class */function (_super) {
  __extends$38(GridHeaderDropZones, _super);
  function GridHeaderDropZones() {
    return _super.call(this) || this;
  }
  GridHeaderDropZones.prototype.postConstruct = function () {
    this.setGui(this.createNorthPanel());
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onRowGroupChanged.bind(this));
    this.onRowGroupChanged();
  };
  GridHeaderDropZones.prototype.createNorthPanel = function () {
    var topPanelGui = document.createElement('div');
    var dropPanelVisibleListener = this.onDropPanelVisible.bind(this);
    _.addCssClass(topPanelGui, 'ag-column-drop-wrapper');
    this.rowGroupComp = new RowGroupDropZonePanel(true);
    this.createManagedBean(this.rowGroupComp);
    this.pivotComp = new PivotDropZonePanel(true);
    this.createManagedBean(this.pivotComp);
    topPanelGui.appendChild(this.rowGroupComp.getGui());
    topPanelGui.appendChild(this.pivotComp.getGui());
    this.addManagedListener(this.rowGroupComp, Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
    this.addManagedListener(this.pivotComp, Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
    this.onDropPanelVisible();
    return topPanelGui;
  };
  GridHeaderDropZones.prototype.onDropPanelVisible = function () {
    var bothDisplayed = this.rowGroupComp.isDisplayed() && this.pivotComp.isDisplayed();
    this.rowGroupComp.addOrRemoveCssClass('ag-column-drop-horizontal-half-width', bothDisplayed);
    this.pivotComp.addOrRemoveCssClass('ag-column-drop-horizontal-half-width', bothDisplayed);
  };
  GridHeaderDropZones.prototype.onRowGroupChanged = function () {
    if (!this.rowGroupComp) {
      return;
    }
    var rowGroupPanelShow = this.gridOptionsWrapper.getRowGroupPanelShow();
    if (rowGroupPanelShow === Constants.ALWAYS) {
      this.rowGroupComp.setDisplayed(true);
    } else if (rowGroupPanelShow === Constants.ONLY_WHEN_GROUPING) {
      var grouping = !this.columnModel.isRowGroupEmpty();
      this.rowGroupComp.setDisplayed(grouping);
    } else {
      this.rowGroupComp.setDisplayed(false);
    }
  };
  __decorate$2O([Autowired('columnModel')], GridHeaderDropZones.prototype, "columnModel", void 0);
  __decorate$2O([PostConstruct], GridHeaderDropZones.prototype, "postConstruct", null);
  return GridHeaderDropZones;
}(Component);
var RowGroupingModule = {
  moduleName: ModuleNames.RowGroupingModule,
  beans: [AggregationStage, GroupStage, PivotColDefService, PivotStage, AggFuncService],
  agStackComponents: [{
    componentName: 'AgGridHeaderDropZones',
    componentClass: GridHeaderDropZones
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$39 = undefined && undefined.__extends || function () {
  var _extendStatics210 = function extendStatics(d, b) {
    _extendStatics210 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics210(d, b);
  };
  return function (d, b) {
    _extendStatics210(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2P = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ValuesDropZonePanel = /** @class */function (_super) {
  __extends$39(ValuesDropZonePanel, _super);
  function ValuesDropZonePanel(horizontal) {
    return _super.call(this, horizontal, true) || this;
  }
  ValuesDropZonePanel.prototype.passBeansUp = function () {
    _super.prototype.setBeans.call(this, {
      gridOptionsWrapper: this.gridOptionsWrapper,
      eventService: this.eventService,
      context: this.getContext(),
      loggerFactory: this.loggerFactory,
      dragAndDropService: this.dragAndDropService
    });
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var emptyMessage = localeTextFunc('valueColumnsEmptyMessage', 'Drag here to aggregate');
    var title = localeTextFunc('values', 'Values');
    _super.prototype.init.call(this, {
      dragAndDropIcon: DragAndDropService.ICON_AGGREGATE,
      icon: _.createIconNoSpan('valuePanel', this.gridOptionsWrapper, null),
      emptyMessage: emptyMessage,
      title: title
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshGui.bind(this));
  };
  ValuesDropZonePanel.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'valueColumnsList';
    return res;
  };
  ValuesDropZonePanel.prototype.getIconName = function () {
    return this.isPotentialDndColumns() ? DragAndDropService.ICON_AGGREGATE : DragAndDropService.ICON_NOT_ALLOWED;
  };
  ValuesDropZonePanel.prototype.isColumnDroppable = function (column) {
    // we never allow grouping of secondary columns
    if (this.gridOptionsWrapper.isFunctionsReadOnly() || !column.isPrimary()) {
      return false;
    }
    return column.isAllowValue() && !column.isValueActive();
  };
  ValuesDropZonePanel.prototype.updateColumns = function (columns) {
    if (this.gridOptionsWrapper.isFunctionsPassive()) {
      var event_1 = {
        type: Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
        columns: columns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    } else {
      this.columnModel.setValueColumns(columns, "toolPanelUi");
    }
  };
  ValuesDropZonePanel.prototype.getExistingColumns = function () {
    return this.columnModel.getValueColumns();
  };
  __decorate$2P([Autowired('columnModel')], ValuesDropZonePanel.prototype, "columnModel", void 0);
  __decorate$2P([Autowired('loggerFactory')], ValuesDropZonePanel.prototype, "loggerFactory", void 0);
  __decorate$2P([Autowired('dragAndDropService')], ValuesDropZonePanel.prototype, "dragAndDropService", void 0);
  __decorate$2P([Autowired('columnApi')], ValuesDropZonePanel.prototype, "columnApi", void 0);
  __decorate$2P([Autowired('gridApi')], ValuesDropZonePanel.prototype, "gridApi", void 0);
  __decorate$2P([PostConstruct], ValuesDropZonePanel.prototype, "passBeansUp", null);
  return ValuesDropZonePanel;
}(BaseDropZonePanel);
var __extends$3a = undefined && undefined.__extends || function () {
  var _extendStatics211 = function extendStatics(d, b) {
    _extendStatics211 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics211(d, b);
  };
  return function (d, b) {
    _extendStatics211(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2Q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PrimaryColsPanel = /** @class */function (_super) {
  __extends$3a(PrimaryColsPanel, _super);
  function PrimaryColsPanel() {
    return _super.call(this, PrimaryColsPanel.TEMPLATE) || this;
  }
  PrimaryColsPanel.prototype.postConstruct = function () {
    this.initialiseTabGuard({});
  };
  // we allow dragging in the toolPanel, but not when this component appears in the column menu
  PrimaryColsPanel.prototype.init = function (allowDragging, params, eventType) {
    this.allowDragging = allowDragging;
    this.params = params;
    this.eventType = eventType;
    this.primaryColsHeaderPanel.init(this.params);
    var hideFilter = this.params.suppressColumnFilter;
    var hideSelect = this.params.suppressColumnSelectAll;
    var hideExpand = this.params.suppressColumnExpandAll;
    if (hideExpand && hideFilter && hideSelect) {
      this.primaryColsHeaderPanel.setDisplayed(false);
    }
    this.addManagedListener(this.primaryColsListPanel, 'groupExpanded', this.onGroupExpanded.bind(this));
    this.addManagedListener(this.primaryColsListPanel, 'selectionChanged', this.onSelectionChange.bind(this));
    this.primaryColsListPanel.init(this.params, this.allowDragging, this.eventType);
    this.addManagedListener(this.primaryColsHeaderPanel, 'expandAll', this.onExpandAll.bind(this));
    this.addManagedListener(this.primaryColsHeaderPanel, 'collapseAll', this.onCollapseAll.bind(this));
    this.addManagedListener(this.primaryColsHeaderPanel, 'selectAll', this.onSelectAll.bind(this));
    this.addManagedListener(this.primaryColsHeaderPanel, 'unselectAll', this.onUnselectAll.bind(this));
    this.addManagedListener(this.primaryColsHeaderPanel, 'filterChanged', this.onFilterChanged.bind(this));
    this.positionableFeature = new PositionableFeature(this.getGui(), {
      minHeight: 100
    });
    this.createManagedBean(this.positionableFeature);
  };
  PrimaryColsPanel.prototype.toggleResizable = function (resizable) {
    this.positionableFeature.setResizable(resizable ? {
      bottom: true
    } : false);
  };
  PrimaryColsPanel.prototype.onExpandAll = function () {
    this.primaryColsListPanel.doSetExpandedAll(true);
  };
  PrimaryColsPanel.prototype.onCollapseAll = function () {
    this.primaryColsListPanel.doSetExpandedAll(false);
  };
  PrimaryColsPanel.prototype.expandGroups = function (groupIds) {
    this.primaryColsListPanel.setGroupsExpanded(true, groupIds);
  };
  PrimaryColsPanel.prototype.collapseGroups = function (groupIds) {
    this.primaryColsListPanel.setGroupsExpanded(false, groupIds);
  };
  PrimaryColsPanel.prototype.setColumnLayout = function (colDefs) {
    this.primaryColsListPanel.setColumnLayout(colDefs);
  };
  PrimaryColsPanel.prototype.onFilterChanged = function (event) {
    this.primaryColsListPanel.setFilterText(event.filterText);
  };
  PrimaryColsPanel.prototype.syncLayoutWithGrid = function () {
    this.primaryColsListPanel.onColumnsChanged();
  };
  PrimaryColsPanel.prototype.onSelectAll = function () {
    this.primaryColsListPanel.doSetSelectedAll(true);
  };
  PrimaryColsPanel.prototype.onUnselectAll = function () {
    this.primaryColsListPanel.doSetSelectedAll(false);
  };
  PrimaryColsPanel.prototype.onGroupExpanded = function (event) {
    this.primaryColsHeaderPanel.setExpandState(event.state);
  };
  PrimaryColsPanel.prototype.onSelectionChange = function (event) {
    this.primaryColsHeaderPanel.setSelectionState(event.state);
  };
  PrimaryColsPanel.TEMPLATE = "<div class=\"ag-column-select\">\n            <ag-primary-cols-header ref=\"primaryColsHeaderPanel\"></ag-primary-cols-header>\n            <ag-primary-cols-list ref=\"primaryColsListPanel\"></ag-primary-cols-list>\n        </div>";
  __decorate$2Q([RefSelector('primaryColsHeaderPanel')], PrimaryColsPanel.prototype, "primaryColsHeaderPanel", void 0);
  __decorate$2Q([RefSelector('primaryColsListPanel')], PrimaryColsPanel.prototype, "primaryColsListPanel", void 0);
  __decorate$2Q([PostConstruct], PrimaryColsPanel.prototype, "postConstruct", null);
  return PrimaryColsPanel;
}(TabGuardComp);
var __extends$3b = undefined && undefined.__extends || function () {
  var _extendStatics212 = function extendStatics(d, b) {
    _extendStatics212 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics212(d, b);
  };
  return function (d, b) {
    _extendStatics212(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2R = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnToolPanel = /** @class */function (_super) {
  __extends$3b(ColumnToolPanel, _super);
  function ColumnToolPanel() {
    var _this = _super.call(this, ColumnToolPanel.TEMPLATE) || this;
    _this.initialised = false;
    _this.childDestroyFuncs = [];
    return _this;
  }
  // lazy initialise the panel
  ColumnToolPanel.prototype.setVisible = function (visible) {
    _super.prototype.setDisplayed.call(this, visible);
    if (visible && !this.initialised) {
      this.init(this.params);
    }
  };
  ColumnToolPanel.prototype.init = function (params) {
    var _this = this;
    var defaultParams = {
      suppressColumnMove: false,
      suppressColumnSelectAll: false,
      suppressColumnFilter: false,
      suppressColumnExpandAll: false,
      contractColumnSelection: false,
      suppressPivotMode: false,
      suppressRowGroups: false,
      suppressValues: false,
      suppressPivots: false,
      suppressSyncLayoutWithGrid: false,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    _.mergeDeep(defaultParams, params);
    this.params = defaultParams;
    if (this.isRowGroupingModuleLoaded() && !this.params.suppressPivotMode) {
      this.pivotModePanel = this.createBean(new PivotModePanel()); // DO NOT CHANGE TO createManagedBean
      this.childDestroyFuncs.push(function () {
        return _this.destroyBean(_this.pivotModePanel);
      });
      this.appendChild(this.pivotModePanel);
    }
    this.primaryColsPanel = this.createBean(new PrimaryColsPanel()); // DO NOT CHANGE TO createManagedBean
    this.childDestroyFuncs.push(function () {
      return _this.destroyBean(_this.primaryColsPanel);
    });
    this.primaryColsPanel.init(true, this.params, "toolPanelUi");
    _.addCssClass(this.primaryColsPanel.getGui(), 'ag-column-panel-column-select');
    this.appendChild(this.primaryColsPanel);
    if (this.isRowGroupingModuleLoaded()) {
      if (!this.params.suppressRowGroups) {
        this.rowGroupDropZonePanel = this.createBean(new RowGroupDropZonePanel(false)); // DO NOT CHANGE TO createManagedBean
        this.childDestroyFuncs.push(function () {
          return _this.destroyBean(_this.rowGroupDropZonePanel);
        });
        this.appendChild(this.rowGroupDropZonePanel);
      }
      if (!this.params.suppressValues) {
        this.valuesDropZonePanel = this.createBean(new ValuesDropZonePanel(false)); // DO NOT CHANGE TO createManagedBean
        this.childDestroyFuncs.push(function () {
          return _this.destroyBean(_this.valuesDropZonePanel);
        });
        this.appendChild(this.valuesDropZonePanel);
      }
      if (!this.params.suppressPivots) {
        this.pivotDropZonePanel = this.createBean(new PivotDropZonePanel(false)); // DO NOT CHANGE TO createManagedBean
        this.childDestroyFuncs.push(function () {
          return _this.destroyBean(_this.pivotDropZonePanel);
        });
        this.appendChild(this.pivotDropZonePanel);
      }
      this.setLastVisible();
      var pivotModeListener_1 = this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
        _this.resetChildrenHeight();
        _this.setLastVisible();
      });
      this.childDestroyFuncs.push(function () {
        return pivotModeListener_1();
      });
    }
    this.initialised = true;
  };
  ColumnToolPanel.prototype.setPivotModeSectionVisible = function (visible) {
    var _this = this;
    if (!this.isRowGroupingModuleLoaded()) {
      return;
    }
    if (this.pivotModePanel) {
      this.pivotModePanel.setDisplayed(visible);
    } else if (visible) {
      this.pivotModePanel = this.createBean(new PivotModePanel());
      // ensure pivot mode panel is positioned at the top of the columns tool panel
      this.getGui().insertBefore(this.pivotModePanel.getGui(), this.getGui().firstChild);
      this.childDestroyFuncs.push(function () {
        return _this.destroyBean(_this.pivotModePanel);
      });
    }
    this.setLastVisible();
  };
  ColumnToolPanel.prototype.setRowGroupsSectionVisible = function (visible) {
    if (!this.isRowGroupingModuleLoaded()) {
      return;
    }
    if (this.rowGroupDropZonePanel) {
      this.rowGroupDropZonePanel.setDisplayed(visible);
    } else if (visible) {
      this.rowGroupDropZonePanel = this.createManagedBean(new RowGroupDropZonePanel(false));
      this.appendChild(this.rowGroupDropZonePanel);
    }
    this.setLastVisible();
  };
  ColumnToolPanel.prototype.setValuesSectionVisible = function (visible) {
    if (!this.isRowGroupingModuleLoaded()) {
      return;
    }
    if (this.valuesDropZonePanel) {
      this.valuesDropZonePanel.setDisplayed(visible);
    } else if (visible) {
      this.valuesDropZonePanel = this.createManagedBean(new ValuesDropZonePanel(false));
      this.appendChild(this.valuesDropZonePanel);
    }
    this.setLastVisible();
  };
  ColumnToolPanel.prototype.setPivotSectionVisible = function (visible) {
    if (!this.isRowGroupingModuleLoaded()) {
      return;
    }
    if (this.pivotDropZonePanel) {
      this.pivotDropZonePanel.setDisplayed(visible);
    } else if (visible) {
      this.pivotDropZonePanel = this.createManagedBean(new PivotDropZonePanel(false));
      this.appendChild(this.pivotDropZonePanel);
      this.pivotDropZonePanel.setDisplayed(visible);
    }
    this.setLastVisible();
  };
  ColumnToolPanel.prototype.setResizers = function () {
    [this.primaryColsPanel, this.rowGroupDropZonePanel, this.valuesDropZonePanel, this.pivotDropZonePanel].forEach(function (panel) {
      if (!panel) {
        return;
      }
      var eGui = panel.getGui();
      panel.toggleResizable(!_.containsClass(eGui, 'ag-last-column-drop') && !_.containsClass(eGui, 'ag-hidden'));
    });
  };
  ColumnToolPanel.prototype.setLastVisible = function () {
    var eGui = this.getGui();
    var columnDrops = Array.prototype.slice.call(eGui.querySelectorAll('.ag-column-drop'));
    columnDrops.forEach(function (columnDrop) {
      return _.removeCssClass(columnDrop, 'ag-last-column-drop');
    });
    var columnDropEls = eGui.querySelectorAll('.ag-column-drop:not(.ag-hidden)');
    var lastVisible = _.last(columnDropEls);
    if (lastVisible) {
      _.addCssClass(lastVisible, 'ag-last-column-drop');
    }
    this.setResizers();
  };
  ColumnToolPanel.prototype.resetChildrenHeight = function () {
    var eGui = this.getGui();
    var children = eGui.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      child.style.removeProperty('height');
      child.style.removeProperty('flex');
    }
  };
  ColumnToolPanel.prototype.isRowGroupingModuleLoaded = function () {
    return ModuleRegistry.assertRegistered(ModuleNames.RowGroupingModule, 'Row Grouping');
  };
  ColumnToolPanel.prototype.expandColumnGroups = function (groupIds) {
    this.primaryColsPanel.expandGroups(groupIds);
  };
  ColumnToolPanel.prototype.collapseColumnGroups = function (groupIds) {
    this.primaryColsPanel.collapseGroups(groupIds);
  };
  ColumnToolPanel.prototype.setColumnLayout = function (colDefs) {
    this.primaryColsPanel.setColumnLayout(colDefs);
  };
  ColumnToolPanel.prototype.syncLayoutWithGrid = function () {
    this.primaryColsPanel.syncLayoutWithGrid();
  };
  ColumnToolPanel.prototype.destroyChildren = function () {
    this.childDestroyFuncs.forEach(function (func) {
      return func();
    });
    this.childDestroyFuncs.length = 0;
    _.clearElement(this.getGui());
  };
  ColumnToolPanel.prototype.refresh = function () {
    this.destroyChildren();
    this.init(this.params);
  };
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so this must be public.
  ColumnToolPanel.prototype.destroy = function () {
    this.destroyChildren();
    _super.prototype.destroy.call(this);
  };
  ColumnToolPanel.TEMPLATE = "<div class=\"ag-column-panel\"></div>";
  __decorate$2R([Autowired("gridApi")], ColumnToolPanel.prototype, "gridApi", void 0);
  __decorate$2R([Autowired("columnApi")], ColumnToolPanel.prototype, "columnApi", void 0);
  return ColumnToolPanel;
}(Component);
var __extends$3c = undefined && undefined.__extends || function () {
  var _extendStatics213 = function extendStatics(d, b) {
    _extendStatics213 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics213(d, b);
  };
  return function (d, b) {
    _extendStatics213(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2S = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HorizontalResizeComp = /** @class */function (_super) {
  __extends$3c(HorizontalResizeComp, _super);
  function HorizontalResizeComp() {
    var _this = _super.call(this, /* html */"<div class=\"ag-tool-panel-horizontal-resize\"></div>") || this;
    _this.minWidth = 100;
    _this.maxWidth = null;
    return _this;
  }
  HorizontalResizeComp.prototype.setElementToResize = function (elementToResize) {
    this.elementToResize = elementToResize;
  };
  HorizontalResizeComp.prototype.postConstruct = function () {
    var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
      eResizeBar: this.getGui(),
      dragStartPixels: 1,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this),
      onResizeEnd: this.onResizing.bind(this)
    });
    this.addDestroyFunc(finishedWithResizeFunc);
    this.setInverted(this.gridOptionsWrapper.isEnableRtl());
  };
  HorizontalResizeComp.prototype.onResizeStart = function () {
    this.startingWidth = this.elementToResize.offsetWidth;
  };
  HorizontalResizeComp.prototype.onResizing = function (delta) {
    var direction = this.inverted ? -1 : 1;
    var newWidth = Math.max(this.minWidth, Math.floor(this.startingWidth - delta * direction));
    if (this.maxWidth != null) {
      newWidth = Math.min(this.maxWidth, newWidth);
    }
    this.elementToResize.style.width = newWidth + "px";
  };
  HorizontalResizeComp.prototype.setInverted = function (inverted) {
    this.inverted = inverted;
  };
  HorizontalResizeComp.prototype.setMaxWidth = function (value) {
    this.maxWidth = value;
  };
  HorizontalResizeComp.prototype.setMinWidth = function (value) {
    if (value != null) {
      this.minWidth = value;
    } else {
      this.minWidth = 100;
    }
  };
  __decorate$2S([Autowired('horizontalResizeService')], HorizontalResizeComp.prototype, "horizontalResizeService", void 0);
  __decorate$2S([PostConstruct], HorizontalResizeComp.prototype, "postConstruct", null);
  return HorizontalResizeComp;
}(Component);
var __extends$3d = undefined && undefined.__extends || function () {
  var _extendStatics214 = function extendStatics(d, b) {
    _extendStatics214 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics214(d, b);
  };
  return function (d, b) {
    _extendStatics214(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2T = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SideBarButtonComp = /** @class */function (_super) {
  __extends$3d(SideBarButtonComp, _super);
  function SideBarButtonComp(toolPanelDef) {
    var _this = _super.call(this) || this;
    _this.toolPanelDef = toolPanelDef;
    return _this;
  }
  SideBarButtonComp.prototype.getToolPanelId = function () {
    return this.toolPanelDef.id;
  };
  SideBarButtonComp.prototype.postConstruct = function () {
    var template = this.createTemplate();
    this.setTemplate(template);
    this.eIconWrapper.insertAdjacentElement('afterbegin', _.createIconNoSpan(this.toolPanelDef.iconKey, this.gridOptionsWrapper));
    this.addManagedListener(this.eToggleButton, 'click', this.onButtonPressed.bind(this));
  };
  SideBarButtonComp.prototype.createTemplate = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var def = this.toolPanelDef;
    var label = translate(def.labelKey, def.labelDefault);
    var res = /* html */"<div class=\"ag-side-button\" role=\"presentation\">\n                <button type=\"button\" ref=\"eToggleButton\" tabindex=\"-1\" role=\"tab\" class=\"ag-side-button-button\">\n                    <div ref=\"eIconWrapper\" class=\"ag-side-button-icon-wrapper\" aria-hidden=\"true\"></div>\n                    <span class=\"ag-side-button-label\">" + label + "</span>\n                </button>\n            </div>";
    return res;
  };
  SideBarButtonComp.prototype.onButtonPressed = function () {
    this.dispatchEvent({
      type: SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED
    });
  };
  SideBarButtonComp.prototype.setSelected = function (selected) {
    this.addOrRemoveCssClass('ag-selected', selected);
  };
  SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED = 'toggleButtonClicked';
  __decorate$2T([RefSelector('eToggleButton')], SideBarButtonComp.prototype, "eToggleButton", void 0);
  __decorate$2T([RefSelector('eIconWrapper')], SideBarButtonComp.prototype, "eIconWrapper", void 0);
  __decorate$2T([PostConstruct], SideBarButtonComp.prototype, "postConstruct", null);
  return SideBarButtonComp;
}(Component);
var __extends$3e = undefined && undefined.__extends || function () {
  var _extendStatics215 = function extendStatics(d, b) {
    _extendStatics215 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics215(d, b);
  };
  return function (d, b) {
    _extendStatics215(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2U = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SideBarButtonsComp = /** @class */function (_super) {
  __extends$3e(SideBarButtonsComp, _super);
  function SideBarButtonsComp() {
    var _this = _super.call(this, SideBarButtonsComp.TEMPLATE) || this;
    _this.buttonComps = [];
    return _this;
  }
  SideBarButtonsComp.prototype.postConstruct = function () {
    this.addManagedListener(this.getFocusableElement(), 'keydown', this.handleKeyDown.bind(this));
  };
  SideBarButtonsComp.prototype.handleKeyDown = function (e) {
    if (e.keyCode !== KeyCode.TAB || !e.shiftKey) {
      return;
    }
    var lastColumn = _.last(this.columnModel.getAllDisplayedColumns());
    if (this.focusService.focusGridView(lastColumn, true)) {
      e.preventDefault();
    }
  };
  SideBarButtonsComp.prototype.setToolPanelDefs = function (toolPanelDefs) {
    toolPanelDefs.forEach(this.addButtonComp.bind(this));
  };
  SideBarButtonsComp.prototype.setActiveButton = function (id) {
    this.buttonComps.forEach(function (comp) {
      comp.setSelected(id === comp.getToolPanelId());
    });
  };
  SideBarButtonsComp.prototype.addButtonComp = function (def) {
    var _this = this;
    var buttonComp = this.createBean(new SideBarButtonComp(def));
    this.buttonComps.push(buttonComp);
    this.appendChild(buttonComp);
    buttonComp.addEventListener(SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED, function () {
      _this.dispatchEvent({
        type: SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED,
        toolPanelId: def.id
      });
    });
  };
  SideBarButtonsComp.prototype.clearButtons = function () {
    this.buttonComps = this.destroyBeans(this.buttonComps);
    _.clearElement(this.getGui());
  };
  SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED = 'sideBarButtonClicked';
  SideBarButtonsComp.TEMPLATE = "<div class=\"ag-side-buttons\" role=\"tablist\"></div>";
  __decorate$2U([Autowired('focusService')], SideBarButtonsComp.prototype, "focusService", void 0);
  __decorate$2U([Autowired('columnModel')], SideBarButtonsComp.prototype, "columnModel", void 0);
  __decorate$2U([PostConstruct], SideBarButtonsComp.prototype, "postConstruct", null);
  __decorate$2U([PreDestroy], SideBarButtonsComp.prototype, "clearButtons", null);
  return SideBarButtonsComp;
}(Component);
var __extends$3f = undefined && undefined.__extends || function () {
  var _extendStatics216 = function extendStatics(d, b) {
    _extendStatics216 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics216(d, b);
  };
  return function (d, b) {
    _extendStatics216(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2V = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelWrapper = /** @class */function (_super) {
  __extends$3f(ToolPanelWrapper, _super);
  function ToolPanelWrapper() {
    return _super.call(this, ToolPanelWrapper.TEMPLATE) || this;
  }
  ToolPanelWrapper.prototype.setupResize = function () {
    var eGui = this.getGui();
    var resizeBar = this.resizeBar = new HorizontalResizeComp();
    this.getContext().createBean(resizeBar);
    resizeBar.setElementToResize(eGui);
    this.appendChild(resizeBar);
  };
  ToolPanelWrapper.prototype.getToolPanelId = function () {
    return this.toolPanelId;
  };
  ToolPanelWrapper.prototype.setToolPanelDef = function (toolPanelDef) {
    var id = toolPanelDef.id,
      minWidth = toolPanelDef.minWidth,
      maxWidth = toolPanelDef.maxWidth,
      width = toolPanelDef.width;
    this.toolPanelId = id;
    this.width = width;
    var params = {
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi()
    };
    var compDetails = this.userComponentFactory.getToolPanelCompDetails(toolPanelDef, params);
    var componentPromise = compDetails.newAgStackInstance();
    if (componentPromise == null) {
      console.warn("ag-grid: error processing tool panel component " + id + ". You need to specify either 'toolPanel' or 'toolPanelFramework'");
      return;
    }
    componentPromise.then(this.setToolPanelComponent.bind(this));
    if (minWidth != null) {
      this.resizeBar.setMinWidth(minWidth);
    }
    if (maxWidth != null) {
      this.resizeBar.setMaxWidth(maxWidth);
    }
  };
  ToolPanelWrapper.prototype.setToolPanelComponent = function (compInstance) {
    var _this = this;
    this.toolPanelCompInstance = compInstance;
    this.appendChild(compInstance.getGui());
    this.addDestroyFunc(function () {
      _this.destroyBean(compInstance);
    });
    if (this.width) {
      this.getGui().style.width = this.width + "px";
    }
  };
  ToolPanelWrapper.prototype.getToolPanelInstance = function () {
    return this.toolPanelCompInstance;
  };
  ToolPanelWrapper.prototype.setResizerSizerSide = function (side) {
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    var isLeft = side === 'left';
    var inverted = isRtl ? isLeft : !isLeft;
    this.resizeBar.setInverted(inverted);
  };
  ToolPanelWrapper.prototype.refresh = function () {
    this.toolPanelCompInstance.refresh();
  };
  ToolPanelWrapper.TEMPLATE = "<div class=\"ag-tool-panel-wrapper\"/>";
  __decorate$2V([Autowired("userComponentFactory")], ToolPanelWrapper.prototype, "userComponentFactory", void 0);
  __decorate$2V([PostConstruct], ToolPanelWrapper.prototype, "setupResize", null);
  return ToolPanelWrapper;
}(Component);
var __extends$3g = undefined && undefined.__extends || function () {
  var _extendStatics217 = function extendStatics(d, b) {
    _extendStatics217 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics217(d, b);
  };
  return function (d, b) {
    _extendStatics217(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2W = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SideBarComp = /** @class */function (_super) {
  __extends$3g(SideBarComp, _super);
  function SideBarComp() {
    var _this = _super.call(this, SideBarComp.TEMPLATE) || this;
    _this.toolPanelWrappers = [];
    return _this;
  }
  SideBarComp.prototype.postConstruct = function () {
    var _this = this;
    this.sideBarButtonsComp.addEventListener(SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED, this.onToolPanelButtonClicked.bind(this));
    this.setSideBarDef();
    this.gridOptionsWrapper.addEventListener('sideBar', function () {
      _this.clearDownUi();
      _this.setSideBarDef();
    });
    this.gridApi.registerSideBarComp(this);
    this.createManagedBean(new ManagedFocusFeature(this.getFocusableElement(), {
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this)
    }));
  };
  SideBarComp.prototype.onTabKeyDown = function (e) {
    if (e.defaultPrevented) {
      return;
    }
    var _a = this,
      focusService = _a.focusService,
      sideBarButtonsComp = _a.sideBarButtonsComp;
    var eGui = this.getGui();
    var sideBarGui = sideBarButtonsComp.getGui();
    var activeElement = document.activeElement;
    var openPanel = eGui.querySelector('.ag-tool-panel-wrapper:not(.ag-hidden)');
    if (!openPanel) {
      return;
    }
    if (sideBarGui.contains(activeElement)) {
      if (focusService.focusInto(openPanel, e.shiftKey)) {
        e.preventDefault();
      }
    } else {
      if (!focusService.isFocusUnderManagedComponent(openPanel) && e.shiftKey) {
        var firstFocusableEl = focusService.findFocusableElements(openPanel)[0];
        if (document.activeElement === firstFocusableEl) {
          var selectedButton = sideBarGui.querySelector('.ag-selected button');
          if (selectedButton) {
            e.preventDefault();
            selectedButton.focus();
          }
        }
      }
    }
  };
  SideBarComp.prototype.handleKeyDown = function (e) {
    if (!this.sideBarButtonsComp.getGui().contains(document.activeElement)) {
      return;
    }
    var sideBarGui = this.sideBarButtonsComp.getGui();
    var buttons = Array.prototype.slice.call(sideBarGui.querySelectorAll('.ag-side-button'));
    var currentButton = document.activeElement;
    var currentPos = _.findIndex(buttons, function (button) {
      return button.contains(currentButton);
    });
    var nextPos = null;
    switch (e.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.UP:
        nextPos = Math.max(0, currentPos - 1);
        break;
      case KeyCode.RIGHT:
      case KeyCode.DOWN:
        nextPos = Math.min(currentPos + 1, buttons.length - 1);
        break;
    }
    if (nextPos === null) {
      return;
    }
    var innerButton = buttons[nextPos].querySelector('button');
    if (innerButton) {
      innerButton.focus();
      e.preventDefault();
    }
  };
  SideBarComp.prototype.onToolPanelButtonClicked = function (event) {
    var id = event.toolPanelId;
    var openedItem = this.openedItem();
    // if item was already open, we close it
    if (openedItem === id) {
      this.openToolPanel(undefined); // passing undefined closes
    } else {
      this.openToolPanel(id);
    }
  };
  SideBarComp.prototype.clearDownUi = function () {
    this.sideBarButtonsComp.clearButtons();
    this.destroyToolPanelWrappers();
  };
  SideBarComp.prototype.setSideBarDef = function () {
    // initially hide side bar
    this.setDisplayed(false);
    var sideBar = this.gridOptionsWrapper.getSideBar();
    var sideBarExists = !!sideBar && !!sideBar.toolPanels;
    if (!sideBarExists) {
      return;
    }
    var shouldDisplaySideBar = sideBarExists && !sideBar.hiddenByDefault;
    this.setDisplayed(shouldDisplaySideBar);
    var toolPanelDefs = sideBar.toolPanels;
    this.sideBarButtonsComp.setToolPanelDefs(toolPanelDefs);
    this.setupToolPanels(toolPanelDefs);
    this.setSideBarPosition(sideBar.position);
    if (!sideBar.hiddenByDefault) {
      this.openToolPanel(sideBar.defaultToolPanel);
    }
  };
  SideBarComp.prototype.setSideBarPosition = function (position) {
    if (!position) {
      position = 'right';
    }
    var isLeft = position === 'left';
    var resizerSide = isLeft ? 'right' : 'left';
    var eGui = this.getGui();
    _.addOrRemoveCssClass(eGui, 'ag-side-bar-left', isLeft);
    _.addOrRemoveCssClass(eGui, 'ag-side-bar-right', !isLeft);
    this.toolPanelWrappers.forEach(function (wrapper) {
      wrapper.setResizerSizerSide(resizerSide);
    });
    return this;
  };
  SideBarComp.prototype.setupToolPanels = function (defs) {
    var _this = this;
    defs.forEach(function (def) {
      if (def.id == null) {
        console.warn("ag-grid: please review all your toolPanel components, it seems like at least one of them doesn't have an id");
        return;
      }
      // helpers, in case user doesn't have the right module loaded
      if (def.toolPanel === 'agColumnsToolPanel') {
        var moduleMissing = !ModuleRegistry.assertRegistered(ModuleNames.ColumnToolPanelModule, 'Column Tool Panel');
        if (moduleMissing) {
          return;
        }
      }
      if (def.toolPanel === 'agFiltersToolPanel') {
        var moduleMissing = !ModuleRegistry.assertRegistered(ModuleNames.FiltersToolPanelModule, 'Filters Tool Panel');
        if (moduleMissing) {
          return;
        }
      }
      var wrapper = new ToolPanelWrapper();
      _this.getContext().createBean(wrapper);
      wrapper.setToolPanelDef(def);
      wrapper.setDisplayed(false);
      _this.getGui().appendChild(wrapper.getGui());
      _this.toolPanelWrappers.push(wrapper);
    });
  };
  SideBarComp.prototype.refresh = function () {
    this.toolPanelWrappers.forEach(function (wrapper) {
      return wrapper.refresh();
    });
  };
  SideBarComp.prototype.openToolPanel = function (key) {
    var currentlyOpenedKey = this.openedItem();
    if (currentlyOpenedKey === key) {
      return;
    }
    this.toolPanelWrappers.forEach(function (wrapper) {
      var show = key === wrapper.getToolPanelId();
      wrapper.setDisplayed(show);
    });
    var newlyOpenedKey = this.openedItem();
    var openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
    if (openToolPanelChanged) {
      this.sideBarButtonsComp.setActiveButton(key);
      this.raiseToolPanelVisibleEvent(key);
    }
  };
  SideBarComp.prototype.getToolPanelInstance = function (key) {
    var toolPanelWrapper = this.toolPanelWrappers.filter(function (toolPanel) {
      return toolPanel.getToolPanelId() === key;
    })[0];
    if (!toolPanelWrapper) {
      console.warn("ag-grid: unable to lookup Tool Panel as invalid key supplied: " + key);
      return;
    }
    return toolPanelWrapper.getToolPanelInstance();
  };
  SideBarComp.prototype.raiseToolPanelVisibleEvent = function (key) {
    var event = {
      type: Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED,
      source: key,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi()
    };
    this.eventService.dispatchEvent(event);
  };
  SideBarComp.prototype.close = function () {
    this.openToolPanel(undefined);
  };
  SideBarComp.prototype.isToolPanelShowing = function () {
    return !!this.openedItem();
  };
  SideBarComp.prototype.openedItem = function () {
    var activeToolPanel = null;
    this.toolPanelWrappers.forEach(function (wrapper) {
      if (wrapper.isDisplayed()) {
        activeToolPanel = wrapper.getToolPanelId();
      }
    });
    return activeToolPanel;
  };
  SideBarComp.prototype.destroyToolPanelWrappers = function () {
    var _this = this;
    this.toolPanelWrappers.forEach(function (wrapper) {
      _.removeFromParent(wrapper.getGui());
      _this.destroyBean(wrapper);
    });
    this.toolPanelWrappers.length = 0;
  };
  SideBarComp.prototype.destroy = function () {
    this.destroyToolPanelWrappers();
    _super.prototype.destroy.call(this);
  };
  SideBarComp.TEMPLATE = "<div class=\"ag-side-bar ag-unselectable\">\n            <ag-side-bar-buttons ref=\"sideBarButtons\"></ag-side-bar-buttons>\n        </div>";
  __decorate$2W([Autowired('gridApi')], SideBarComp.prototype, "gridApi", void 0);
  __decorate$2W([Autowired('focusService')], SideBarComp.prototype, "focusService", void 0);
  __decorate$2W([RefSelector('sideBarButtons')], SideBarComp.prototype, "sideBarButtonsComp", void 0);
  __decorate$2W([PostConstruct], SideBarComp.prototype, "postConstruct", null);
  return SideBarComp;
}(Component);
var __extends$3h = undefined && undefined.__extends || function () {
  var _extendStatics218 = function extendStatics(d, b) {
    _extendStatics218 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics218(d, b);
  };
  return function (d, b) {
    _extendStatics218(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2X = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelColDefService = /** @class */function (_super) {
  __extends$3h(ToolPanelColDefService, _super);
  function ToolPanelColDefService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isColGroupDef = function (colDef) {
      return colDef && typeof colDef.children !== 'undefined';
    };
    _this.getId = function (colDef) {
      return _this.isColGroupDef(colDef) ? colDef.groupId : colDef.colId;
    };
    return _this;
  }
  ToolPanelColDefService.prototype.createColumnTree = function (colDefs) {
    var _this = this;
    var invalidColIds = [];
    var createDummyColGroup = function createDummyColGroup(abstractColDef, depth) {
      if (_this.isColGroupDef(abstractColDef)) {
        // creating 'dummy' group which is not associated with grid column group
        var groupDef = abstractColDef;
        var groupId = typeof groupDef.groupId !== 'undefined' ? groupDef.groupId : groupDef.headerName;
        var group = new ProvidedColumnGroup(groupDef, groupId, false, depth);
        var children_1 = [];
        groupDef.children.forEach(function (def) {
          var child = createDummyColGroup(def, depth + 1);
          // check column exists in case invalid colDef is supplied for primary column
          if (child) {
            children_1.push(child);
          }
        });
        group.setChildren(children_1);
        return group;
      } else {
        var colDef = abstractColDef;
        var key = colDef.colId ? colDef.colId : colDef.field;
        var column = _this.columnModel.getPrimaryColumn(key);
        if (!column) {
          invalidColIds.push(colDef);
        }
        return column;
      }
    };
    var mappedResults = [];
    colDefs.forEach(function (colDef) {
      var result = createDummyColGroup(colDef, 0);
      if (result) {
        // only return correctly mapped colDef results
        mappedResults.push(result);
      }
    });
    if (invalidColIds.length > 0) {
      console.warn('AG Grid: unable to find grid columns for the supplied colDef(s):', invalidColIds);
    }
    return mappedResults;
  };
  ToolPanelColDefService.prototype.syncLayoutWithGrid = function (syncLayoutCallback) {
    // extract ordered list of leaf path trees (column group hierarchy for each individual leaf column)
    var leafPathTrees = this.getLeafPathTrees();
    // merge leaf path tree taking split column groups into account
    var mergedColumnTrees = this.mergeLeafPathTrees(leafPathTrees);
    // sync layout with merged column trees
    syncLayoutCallback(mergedColumnTrees);
  };
  ToolPanelColDefService.prototype.getLeafPathTrees = function () {
    // leaf tree paths are obtained by walking up the tree starting at a column until we reach the top level group.
    var getLeafPathTree = function getLeafPathTree(node, childDef) {
      var leafPathTree;
      // build up tree in reverse order
      if (node instanceof ProvidedColumnGroup) {
        if (node.isPadding()) {
          // skip over padding groups
          leafPathTree = childDef;
        } else {
          var groupDef = _.assign({}, node.getColGroupDef());
          // ensure group contains groupId
          groupDef.groupId = node.getGroupId();
          groupDef.children = [childDef];
          leafPathTree = groupDef;
        }
      } else {
        var colDef = _.assign({}, node.getColDef());
        // ensure col contains colId
        colDef.colId = node.getColId();
        leafPathTree = colDef;
      }
      // walk tree
      var parent = node.getOriginalParent();
      if (parent) {
        // keep walking up the tree until we reach the root
        return getLeafPathTree(parent, leafPathTree);
      } else {
        // we have reached the root - exit with resulting leaf path tree
        return leafPathTree;
      }
    };
    // obtain a sorted list of all grid columns
    var allGridColumns = this.columnModel.getAllGridColumns();
    // only primary columns and non row group columns should appear in the tool panel
    var allPrimaryGridColumns = allGridColumns.filter(function (column) {
      var colDef = column.getColDef();
      return column.isPrimary() && !colDef.showRowGroup;
    });
    // construct a leaf path tree for each column
    return allPrimaryGridColumns.map(function (col) {
      return getLeafPathTree(col, col.getColDef());
    });
  };
  ToolPanelColDefService.prototype.mergeLeafPathTrees = function (leafPathTrees) {
    var _this = this;
    var matchingRootGroupIds = function matchingRootGroupIds(pathA, pathB) {
      var bothPathsAreGroups = _this.isColGroupDef(pathA) && _this.isColGroupDef(pathB);
      return bothPathsAreGroups && _this.getId(pathA) === _this.getId(pathB);
    };
    var mergeTrees = function mergeTrees(treeA, treeB) {
      if (!_this.isColGroupDef(treeB)) {
        return treeA;
      }
      var mergeResult = treeA;
      var groupToMerge = treeB;
      if (groupToMerge.children && groupToMerge.groupId) {
        var added = _this.addChildrenToGroup(mergeResult, groupToMerge.groupId, groupToMerge.children[0]);
        if (added) {
          return mergeResult;
        }
      }
      groupToMerge.children.forEach(function (child) {
        return mergeTrees(mergeResult, child);
      });
      return mergeResult;
    };
    // we can't just merge the leaf path trees as groups can be split apart - instead only merge if leaf
    // path groups with the same root group id are contiguous.
    var mergeColDefs = [];
    for (var i = 1; i <= leafPathTrees.length; i++) {
      var first = leafPathTrees[i - 1];
      var second = leafPathTrees[i];
      if (matchingRootGroupIds(first, second)) {
        leafPathTrees[i] = mergeTrees(first, second);
      } else {
        mergeColDefs.push(first);
      }
    }
    return mergeColDefs;
  };
  ToolPanelColDefService.prototype.addChildrenToGroup = function (tree, groupId, colDef) {
    var _this = this;
    var subGroupIsSplit = function subGroupIsSplit(currentSubGroup, currentSubGroupToAdd) {
      var existingChildIds = currentSubGroup.children.map(_this.getId);
      var childGroupAlreadyExists = _.includes(existingChildIds, _this.getId(currentSubGroupToAdd));
      var lastChild = _.last(currentSubGroup.children);
      var lastChildIsDifferent = lastChild && _this.getId(lastChild) !== _this.getId(currentSubGroupToAdd);
      return childGroupAlreadyExists && lastChildIsDifferent;
    };
    if (!this.isColGroupDef(tree)) {
      return true;
    }
    var currentGroup = tree;
    var groupToAdd = colDef;
    if (subGroupIsSplit(currentGroup, groupToAdd)) {
      currentGroup.children.push(groupToAdd);
      return true;
    }
    if (currentGroup.groupId === groupId) {
      // add children that don't already exist to group
      var existingChildIds = currentGroup.children.map(this.getId);
      var colDefAlreadyPresent = _.includes(existingChildIds, this.getId(groupToAdd));
      if (!colDefAlreadyPresent) {
        currentGroup.children.push(groupToAdd);
        return true;
      }
    }
    // recurse until correct group is found to add children
    currentGroup.children.forEach(function (subGroup) {
      return _this.addChildrenToGroup(subGroup, groupId, colDef);
    });
    return false;
  };
  __decorate$2X([Autowired('columnModel')], ToolPanelColDefService.prototype, "columnModel", void 0);
  ToolPanelColDefService = __decorate$2X([Bean('toolPanelColDefService')], ToolPanelColDefService);
  return ToolPanelColDefService;
}(BeanStub);
var SideBarModule = {
  moduleName: ModuleNames.SideBarModule,
  beans: [ToolPanelColDefService],
  agStackComponents: [{
    componentName: 'AgHorizontalResize',
    componentClass: HorizontalResizeComp
  }, {
    componentName: 'AgSideBar',
    componentClass: SideBarComp
  }, {
    componentName: 'AgSideBarButtons',
    componentClass: SideBarButtonsComp
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __decorate$2Y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ModelItemUtils = /** @class */function () {
  function ModelItemUtils() {}
  ModelItemUtils.prototype.selectAllChildren = function (colTree, selectAllChecked, eventType) {
    var cols = this.extractAllLeafColumns(colTree);
    this.setAllColumns(cols, selectAllChecked, eventType);
  };
  ModelItemUtils.prototype.setColumn = function (col, selectAllChecked, eventType) {
    this.setAllColumns([col], selectAllChecked, eventType);
  };
  ModelItemUtils.prototype.setAllColumns = function (cols, selectAllChecked, eventType) {
    if (this.columnModel.isPivotMode()) {
      this.setAllPivot(cols, selectAllChecked, eventType);
    } else {
      this.setAllVisible(cols, selectAllChecked, eventType);
    }
  };
  ModelItemUtils.prototype.extractAllLeafColumns = function (allItems) {
    var res = [];
    var recursiveFunc = function recursiveFunc(items) {
      items.forEach(function (item) {
        if (!item.isPassesFilter()) {
          return;
        }
        if (item.isGroup()) {
          recursiveFunc(item.getChildren());
        } else {
          res.push(item.getColumn());
        }
      });
    };
    recursiveFunc(allItems);
    return res;
  };
  ModelItemUtils.prototype.setAllVisible = function (columns, visible, eventType) {
    var colStateItems = [];
    columns.forEach(function (col) {
      if (col.getColDef().lockVisible) {
        return;
      }
      if (col.isVisible() != visible) {
        colStateItems.push({
          colId: col.getId(),
          hide: !visible
        });
      }
    });
    if (colStateItems.length > 0) {
      this.columnModel.applyColumnState({
        state: colStateItems
      }, eventType);
    }
  };
  ModelItemUtils.prototype.setAllPivot = function (columns, value, eventType) {
    if (this.gridOptionsWrapper.isFunctionsPassive()) {
      this.setAllPivotPassive(columns, value);
    } else {
      this.setAllPivotActive(columns, value, eventType);
    }
  };
  ModelItemUtils.prototype.setAllPivotPassive = function (columns, value) {
    var copyOfPivotColumns = this.columnModel.getPivotColumns().slice();
    var copyOfValueColumns = this.columnModel.getValueColumns().slice();
    var copyOfRowGroupColumns = this.columnModel.getRowGroupColumns().slice();
    var pivotChanged = false;
    var valueChanged = false;
    var rowGroupChanged = false;
    var turnOnAction = function turnOnAction(col) {
      // don't change any column that's already got a function active
      if (col.isAnyFunctionActive()) {
        return;
      }
      if (col.isAllowValue()) {
        copyOfValueColumns.push(col);
        valueChanged = true;
      } else if (col.isAllowRowGroup()) {
        copyOfRowGroupColumns.push(col);
        pivotChanged = true;
      } else if (col.isAllowPivot()) {
        copyOfPivotColumns.push(col);
        rowGroupChanged = true;
      }
    };
    var turnOffAction = function turnOffAction(col) {
      if (!col.isAnyFunctionActive()) {
        return;
      }
      if (copyOfPivotColumns.indexOf(col) >= 0) {
        _.removeFromArray(copyOfPivotColumns, col);
        pivotChanged = true;
      }
      if (copyOfValueColumns.indexOf(col) >= 0) {
        _.removeFromArray(copyOfValueColumns, col);
        valueChanged = true;
      }
      if (copyOfRowGroupColumns.indexOf(col) >= 0) {
        _.removeFromArray(copyOfRowGroupColumns, col);
        rowGroupChanged = true;
      }
    };
    var action = value ? turnOnAction : turnOffAction;
    columns.forEach(action);
    if (pivotChanged) {
      var event_1 = {
        type: Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
        columns: copyOfPivotColumns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_1);
    }
    if (rowGroupChanged) {
      var event_2 = {
        type: Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
        columns: copyOfRowGroupColumns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_2);
    }
    if (valueChanged) {
      var event_3 = {
        type: Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
        columns: copyOfRowGroupColumns,
        api: this.gridApi,
        columnApi: this.columnApi
      };
      this.eventService.dispatchEvent(event_3);
    }
  };
  ModelItemUtils.prototype.setAllPivotActive = function (columns, value, eventType) {
    var _this = this;
    var colStateItems = [];
    var turnOnAction = function turnOnAction(col) {
      // don't change any column that's already got a function active
      if (col.isAnyFunctionActive()) {
        return;
      }
      if (col.isAllowValue()) {
        var aggFunc = typeof col.getAggFunc() === 'string' ? col.getAggFunc() : _this.aggFuncService.getDefaultAggFunc(col);
        colStateItems.push({
          colId: col.getId(),
          aggFunc: aggFunc
        });
      } else if (col.isAllowRowGroup()) {
        colStateItems.push({
          colId: col.getId(),
          rowGroup: true
        });
      } else if (col.isAllowPivot()) {
        colStateItems.push({
          colId: col.getId(),
          pivot: true
        });
      }
    };
    var turnOffAction = function turnOffAction(col) {
      var isActive = col.isPivotActive() || col.isRowGroupActive() || col.isValueActive();
      if (isActive) {
        colStateItems.push({
          colId: col.getId(),
          pivot: false,
          rowGroup: false,
          aggFunc: null
        });
      }
    };
    var action = value ? turnOnAction : turnOffAction;
    columns.forEach(action);
    if (colStateItems.length > 0) {
      this.columnModel.applyColumnState({
        state: colStateItems
      }, eventType);
    }
  };
  __decorate$2Y([Autowired('aggFuncService')], ModelItemUtils.prototype, "aggFuncService", void 0);
  __decorate$2Y([Autowired('columnModel')], ModelItemUtils.prototype, "columnModel", void 0);
  __decorate$2Y([Autowired('gridOptionsWrapper')], ModelItemUtils.prototype, "gridOptionsWrapper", void 0);
  __decorate$2Y([Autowired('columnApi')], ModelItemUtils.prototype, "columnApi", void 0);
  __decorate$2Y([Autowired('gridApi')], ModelItemUtils.prototype, "gridApi", void 0);
  __decorate$2Y([Autowired('eventService')], ModelItemUtils.prototype, "eventService", void 0);
  ModelItemUtils = __decorate$2Y([Bean('modelItemUtils')], ModelItemUtils);
  return ModelItemUtils;
}();
var ColumnsToolPanelModule = {
  moduleName: ModuleNames.ColumnToolPanelModule,
  beans: [ModelItemUtils],
  agStackComponents: [{
    componentName: 'AgPrimaryColsHeader',
    componentClass: PrimaryColsHeaderPanel
  }, {
    componentName: 'AgPrimaryColsList',
    componentClass: PrimaryColsListPanel
  }, {
    componentName: 'AgPrimaryCols',
    componentClass: PrimaryColsPanel
  }],
  userComponents: [{
    componentName: 'agColumnsToolPanel',
    componentClass: ColumnToolPanel
  }],
  dependantModules: [EnterpriseCoreModule, RowGroupingModule, SideBarModule]
};
var workbook = {
  getTemplate: function getTemplate() {
    return {
      name: "Workbook",
      properties: {
        prefixedAttributes: [{
          prefix: "xmlns:",
          map: {
            o: "urn:schemas-microsoft-com:office:office",
            x: "urn:schemas-microsoft-com:office:excel",
            ss: "urn:schemas-microsoft-com:office:spreadsheet",
            html: "http://www.w3.org/TR/REC-html40"
          }
        }],
        rawMap: {
          xmlns: "urn:schemas-microsoft-com:office:spreadsheet"
        }
      }
    };
  }
};
var excelWorkbook = {
  getTemplate: function getTemplate() {
    return {
      name: "ExcelWorkbook",
      properties: {
        rawMap: {
          xmlns: "urn:schemas-microsoft-com:office:excel"
        }
      },
      children: [{
        name: "WindowHeight",
        textNode: "8130"
      }, {
        name: "WindowWidth",
        textNode: "15135"
      }, {
        name: "WindowHeight",
        textNode: "8130"
      }, {
        name: "WindowTopX",
        textNode: "120"
      }, {
        name: "WindowTopY",
        textNode: "45"
      }, {
        name: "ProtectStructure",
        textNode: "False"
      }, {
        name: "ProtectWindow",
        textNode: "False"
      }]
    };
  }
};
var column = {
  getTemplate: function getTemplate(c) {
    var width = c.width;
    return {
      name: "Column",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Width: width
          }
        }]
      }
    };
  }
};
var cell = {
  getTemplate: function getTemplate(c) {
    var mergeAcross = c.mergeAcross,
      styleId = c.styleId,
      data = c.data;
    var properties = {};
    if (mergeAcross) {
      properties.MergeAcross = mergeAcross;
    }
    if (styleId) {
      properties.StyleID = styleId;
    }
    return {
      name: "Cell",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: properties
        }]
      },
      children: [{
        name: "Data",
        properties: {
          prefixedAttributes: [{
            prefix: "ss:",
            map: {
              Type: data.type
            }
          }]
        },
        textNode: data.value
      }]
    };
  }
};
var row = {
  getTemplate: function getTemplate(r) {
    var cells = r.cells;
    return {
      name: "Row",
      children: cells.map(function (it) {
        return cell.getTemplate(it);
      })
    };
  }
};
var worksheet = {
  getTemplate: function getTemplate(ws) {
    var table = ws.table,
      name = ws.name;
    var columns = table.columns,
      rows = table.rows;
    var c = columns.map(function (it) {
      return column.getTemplate(it);
    });
    var r = rows.map(function (it) {
      return row.getTemplate(it);
    });
    return {
      name: "Worksheet",
      children: [{
        name: "Table",
        children: c.concat(r)
      }],
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Name: name
          }
        }]
      }
    };
  }
};
var documentProperties = {
  getTemplate: function getTemplate() {
    return {
      name: "DocumentProperties",
      properties: {
        rawMap: {
          xmlns: "urn:schemas-microsoft-com:office:office"
        }
      },
      children: [{
        name: "Version",
        textNode: "12.00"
      }]
    };
  }
};
var alignment = {
  getTemplate: function getTemplate(styleProperties) {
    var _a = styleProperties.alignment,
      vertical = _a.vertical,
      horizontal = _a.horizontal,
      indent = _a.indent,
      readingOrder = _a.readingOrder,
      rotate = _a.rotate,
      shrinkToFit = _a.shrinkToFit,
      verticalText = _a.verticalText,
      wrapText = _a.wrapText;
    return {
      name: 'Alignment',
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Vertical: vertical,
            Horizontal: horizontal,
            Indent: indent,
            ReadingOrder: readingOrder,
            Rotate: rotate,
            ShrinkToFit: shrinkToFit,
            VerticalText: verticalText,
            WrapText: wrapText
          }
        }]
      }
    };
  }
};
var borders = {
  getTemplate: function getTemplate(styleProperties) {
    var _a = styleProperties.borders,
      borderBottom = _a.borderBottom,
      borderLeft = _a.borderLeft,
      borderRight = _a.borderRight,
      borderTop = _a.borderTop;
    return {
      name: 'Borders',
      children: [borderBottom, borderLeft, borderRight, borderTop].map(function (it, index) {
        var current = index == 0 ? "Bottom" : index == 1 ? "Left" : index == 2 ? "Right" : "Top";
        return {
          name: 'Border',
          properties: {
            prefixedAttributes: [{
              prefix: 'ss:',
              map: {
                Position: current,
                LineStyle: it.lineStyle,
                Weight: it.weight,
                Color: it.color
              }
            }]
          }
        };
      })
    };
  }
};
var font = {
  getTemplate: function getTemplate(styleProperties) {
    var _a = styleProperties.font,
      bold = _a.bold,
      fontName = _a.fontName,
      italic = _a.italic,
      color = _a.color,
      outline = _a.outline,
      shadow = _a.shadow,
      size = _a.size,
      strikeThrough = _a.strikeThrough,
      underline = _a.underline,
      verticalAlign = _a.verticalAlign,
      charSet = _a.charSet,
      family = _a.family;
    return {
      name: "Font",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Bold: bold,
            FontName: fontName,
            Italic: italic,
            Color: color,
            Outline: outline,
            Shadow: shadow,
            Size: size,
            StrikeThrough: strikeThrough,
            Underline: underline,
            VerticalAlign: verticalAlign
          }
        }, {
          prefix: "x:",
          map: {
            CharSet: charSet,
            Family: family
          }
        }]
      }
    };
  }
};
var interior = {
  getTemplate: function getTemplate(styleProperties) {
    var _a = styleProperties.interior,
      color = _a.color,
      pattern = _a.pattern,
      patternColor = _a.patternColor;
    return {
      name: "Interior",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Color: color,
            Pattern: pattern,
            PatternColor: patternColor
          }
        }]
      }
    };
  }
};
var protection = {
  getTemplate: function getTemplate(styleProperties) {
    return {
      name: "Protection",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Protected: styleProperties.protection.protected,
            HideFormula: styleProperties.protection.hideFormula
          }
        }]
      }
    };
  }
};
var numberFormat = {
  getTemplate: function getTemplate(styleProperties) {
    var format = styleProperties.numberFormat.format;
    return {
      name: "NumberFormat",
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            Format: format
          }
        }]
      }
    };
  }
};
var style = {
  getTemplate: function getTemplate(styleProperties) {
    var id = styleProperties.id,
      name = styleProperties.name;
    return {
      name: 'Style',
      properties: {
        prefixedAttributes: [{
          prefix: "ss:",
          map: {
            ID: id,
            Name: name ? name : id
          }
        }]
      }
    };
  }
};

/**
 * See https://msdn.microsoft.com/en-us/library/aa140066(v=office.10).aspx
 */
var ExcelXmlFactory = /** @class */function () {
  function ExcelXmlFactory() {}
  ExcelXmlFactory.createExcel = function (styles, currentWorksheet) {
    var header = this.excelXmlHeader();
    var docProps = documentProperties.getTemplate();
    var eWorkbook = excelWorkbook.getTemplate();
    var wb = this.workbook(docProps, eWorkbook, styles, currentWorksheet);
    return "" + header + XmlFactory.createXml(wb, function (boolean) {
      return boolean ? '1' : '0';
    });
  };
  ExcelXmlFactory.workbook = function (docProperties, eWorkbook, styles, currentWorksheet) {
    var children = [docProperties, eWorkbook, this.stylesXmlElement(styles)].concat(worksheet.getTemplate(currentWorksheet));
    return _.assign({}, workbook.getTemplate(), {
      children: children
    });
  };
  ExcelXmlFactory.excelXmlHeader = function () {
    return "<?xml version=\"1.0\" ?>\n        <?mso-application progid=\"Excel.Sheet\" ?>\n        ";
  };
  ExcelXmlFactory.stylesXmlElement = function (styles) {
    var _this = this;
    return {
      name: 'Styles',
      children: styles ? styles.map(function (it) {
        return _this.styleXmlElement(it);
      }) : []
    };
  };
  ExcelXmlFactory.styleXmlElement = function (styleProperties) {
    var children = _.compose(this.addProperty('alignment', styleProperties), this.addProperty('borders', styleProperties), this.addProperty('font', styleProperties), this.addProperty('interior', styleProperties), this.addProperty('protection', styleProperties), this.addProperty('numberFormat', styleProperties))([]);
    return _.assign({}, style.getTemplate(styleProperties), {
      children: children
    });
  };
  ExcelXmlFactory.addProperty = function (property, styleProperties) {
    return function (children) {
      if (!styleProperties[property]) {
        return children;
      }
      var options = {
        alignment: alignment,
        borders: borders,
        font: font,
        interior: interior,
        numberFormat: numberFormat,
        protection: protection
      };
      return children.concat(options[property].getTemplate(styleProperties));
    };
  };
  ExcelXmlFactory.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
  return ExcelXmlFactory;
}();
var INCH_TO_EMU = 9525;
var numberFormatMap = {
  '0': 1,
  '0.00': 2,
  '#,##0': 3,
  '#,##0.00': 4,
  '0%': 9,
  '0.00%': 10,
  '0.00E+00': 11,
  '# ?/?': 12,
  '# ??/??': 13,
  'mm-dd-yy': 14,
  'd-mmm-yy': 15,
  'd-mmm': 16,
  'mmm-yy': 17,
  'h:mm AM/PM': 18,
  'h:mm:ss AM/PM': 19,
  'h:mm': 20,
  'h:mm:ss': 21,
  'm/d/yy h:mm': 22,
  '#,##0 ;(#,##0)': 37,
  '#,##0 ;[Red](#,##0)': 38,
  '#,##0.00;(#,##0.00)': 39,
  '#,##0.00;[Red](#,##0.00)': 40,
  'mm:ss': 45,
  '[h]:mm:ss': 46,
  'mmss.0': 47,
  '##0.0E+0': 48,
  '@': 49
};
var pixelsToPoint = function pixelsToPoint(pixels) {
  return Math.round(pixels * 72 / 96);
};
var pointsToPixel = function pointsToPixel(points) {
  return Math.round(points * 96 / 72);
};
var pixelsToEMU = function pixelsToEMU(value) {
  return Math.ceil(value * INCH_TO_EMU);
};
var getFontFamilyId = function getFontFamilyId(name) {
  if (name === undefined) {
    return;
  }
  var families = ['Automatic', 'Roman', 'Swiss', 'Modern', 'Script', 'Decorative'];
  var pos = families.indexOf(name || 'Automatic');
  return Math.max(pos, 0);
};
var getHeightFromProperty = function getHeightFromProperty(rowIndex, height) {
  if (!height) {
    return;
  }
  var finalHeight;
  if (typeof height === 'number') {
    finalHeight = height;
  } else {
    var heightFunc = height;
    finalHeight = heightFunc({
      rowIndex: rowIndex
    });
  }
  return pixelsToPoint(finalHeight);
};
var setExcelImageTotalWidth = function setExcelImageTotalWidth(image, columnsToExport) {
  var _a = image.position,
    colSpan = _a.colSpan,
    column = _a.column;
  if (image.width) {
    if (colSpan) {
      var columnsInSpan = columnsToExport.slice(column - 1, column + colSpan - 1);
      var totalWidth = 0;
      for (var i = 0; i < columnsInSpan.length; i++) {
        var colWidth = columnsInSpan[i].getActualWidth();
        if (image.width < totalWidth + colWidth) {
          image.position.colSpan = i + 1;
          image.totalWidth = image.width;
          image.width = image.totalWidth - totalWidth;
          break;
        }
        totalWidth += colWidth;
      }
    } else {
      image.totalWidth = image.width;
    }
  }
};
var setExcelImageTotalHeight = function setExcelImageTotalHeight(image, rowHeight) {
  var _a = image.position,
    rowSpan = _a.rowSpan,
    row = _a.row;
  if (image.height) {
    if (rowSpan) {
      var totalHeight = 0;
      var counter = 0;
      for (var i = row; i < row + rowSpan; i++) {
        var nextRowHeight = pointsToPixel(getHeightFromProperty(i, rowHeight) || 20);
        if (image.height < totalHeight + nextRowHeight) {
          image.position.rowSpan = counter + 1;
          image.totalHeight = image.height;
          image.height = image.totalHeight - totalHeight;
          break;
        }
        totalHeight += nextRowHeight;
        counter++;
      }
    } else {
      image.totalHeight = image.height;
    }
  }
};
var createXmlPart = function createXmlPart(body) {
  var header = XmlFactory.createHeader({
    encoding: 'UTF-8',
    standalone: 'yes'
  });
  var xmlBody = XmlFactory.createXml(body);
  return "" + header + xmlBody;
};
var getExcelColumnName = function getExcelColumnName(colIdx) {
  var startCode = 65;
  var tableWidth = 26;
  var fromCharCode = String.fromCharCode;
  var pos = Math.floor(colIdx / tableWidth);
  var tableIdx = colIdx % tableWidth;
  if (!pos || colIdx === tableWidth) {
    return fromCharCode(startCode + colIdx - 1);
  }
  if (!tableIdx) {
    return getExcelColumnName(pos - 1) + 'Z';
  }
  if (pos < tableWidth) {
    return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
  }
  return getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
};
var __extends$3i = undefined && undefined.__extends || function () {
  var _extendStatics219 = function extendStatics(d, b) {
    _extendStatics219 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics219(d, b);
  };
  return function (d, b) {
    _extendStatics219(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$g = undefined && undefined.__assign || function () {
  __assign$g = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$g.apply(this, arguments);
};
var __spreadArrays$e = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var BaseExcelSerializingSession = /** @class */function (_super) {
  __extends$3i(BaseExcelSerializingSession, _super);
  function BaseExcelSerializingSession(config) {
    var _this = _super.call(this, config) || this;
    _this.mixedStyles = {};
    _this.mixedStyleCounter = 0;
    _this.rows = [];
    _this.config = _.assign({}, config);
    _this.stylesByIds = {};
    _this.config.baseExcelStyles.forEach(function (style) {
      _this.stylesByIds[style.id] = style;
    });
    _this.excelStyles = __spreadArrays$e(_this.config.baseExcelStyles);
    return _this;
  }
  BaseExcelSerializingSession.prototype.addCustomContent = function (customContent) {
    var _this = this;
    customContent.forEach(function (row) {
      var rowLen = _this.rows.length + 1;
      _this.rows.push({
        height: getHeightFromProperty(rowLen, _this.config.rowHeight),
        cells: row.map(function (cell, idx) {
          var image = _this.addImage(rowLen, _this.columnsToExport[idx], cell.data.value);
          var ret = __assign$g({}, cell);
          if (image) {
            ret.data = {};
            if (image.value != null) {
              ret.data.value = image.value;
            } else {
              ret.data.type = 'e';
              ret.data.value = null;
            }
          }
          return ret;
        })
      });
    });
  };
  BaseExcelSerializingSession.prototype.onNewHeaderGroupingRow = function () {
    var _this = this;
    var currentCells = [];
    this.rows.push({
      cells: currentCells,
      height: getHeightFromProperty(this.rows.length + 1, this.config.headerRowHeight)
    });
    return {
      onColumn: function onColumn(header, index, span) {
        var styleIds = _this.config.styleLinker(RowType$1.HEADER_GROUPING, 1, "grouping-" + header, undefined, undefined);
        currentCells.push(_this.createMergedCell(_this.getStyleId(styleIds), _this.getDataTypeForValue('string'), header, span));
      }
    };
  };
  BaseExcelSerializingSession.prototype.onNewHeaderRow = function () {
    return this.onNewRow(this.onNewHeaderColumn, this.config.headerRowHeight);
  };
  BaseExcelSerializingSession.prototype.onNewBodyRow = function () {
    return this.onNewRow(this.onNewBodyColumn, this.config.rowHeight);
  };
  BaseExcelSerializingSession.prototype.prepare = function (columnsToExport) {
    var _this = this;
    _super.prototype.prepare.call(this, columnsToExport);
    this.columnsToExport = __spreadArrays$e(columnsToExport);
    this.cols = columnsToExport.map(function (col, i) {
      return _this.convertColumnToExcel(col, i);
    });
  };
  BaseExcelSerializingSession.prototype.parse = function () {
    // adding custom content might have made some rows wider than the grid, so add new columns
    var longestRow = this.rows.reduce(function (a, b) {
      return Math.max(a, b.cells.length);
    }, 0);
    while (this.cols.length < longestRow) {
      this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
    }
    var data = {
      name: this.config.sheetName,
      table: {
        columns: this.cols,
        rows: this.rows
      }
    };
    return this.createExcel(data);
  };
  BaseExcelSerializingSession.prototype.isFormula = function (value) {
    if (value == null) {
      return false;
    }
    return this.config.autoConvertFormulas && _.startsWith(value.toString(), '=');
  };
  BaseExcelSerializingSession.prototype.getStyleById = function (styleId) {
    if (styleId == null) {
      return null;
    }
    return this.stylesByIds[styleId] || null;
  };
  BaseExcelSerializingSession.prototype.convertColumnToExcel = function (column, index) {
    var columnWidth = this.config.columnWidth;
    if (columnWidth) {
      if (typeof columnWidth === 'number') {
        return {
          width: columnWidth
        };
      }
      return {
        width: columnWidth({
          column: column,
          index: index
        })
      };
    }
    if (column) {
      var smallestUsefulWidth = 75;
      return {
        width: Math.max(column.getActualWidth(), smallestUsefulWidth)
      };
    }
    return {};
  };
  BaseExcelSerializingSession.prototype.onNewHeaderColumn = function (rowIndex, currentCells) {
    var _this = this;
    return function (column, index) {
      var nameForCol = _this.extractHeaderValue(column);
      var styleIds = _this.config.styleLinker(RowType$1.HEADER, rowIndex, nameForCol, column, undefined);
      currentCells.push(_this.createCell(_this.getStyleId(styleIds), _this.getDataTypeForValue('string'), nameForCol));
    };
  };
  BaseExcelSerializingSession.prototype.onNewRow = function (onNewColumnAccumulator, height) {
    var currentCells = [];
    this.rows.push({
      cells: currentCells,
      height: getHeightFromProperty(this.rows.length + 1, height)
    });
    return {
      onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
    };
  };
  BaseExcelSerializingSession.prototype.onNewBodyColumn = function (rowIndex, currentCells) {
    var _this = this;
    var skipCols = 0;
    return function (column, index, node) {
      if (skipCols > 0) {
        skipCols -= 1;
        return;
      }
      var valueForCell = _this.extractRowCellValue(column, index, rowIndex, Constants.EXPORT_TYPE_EXCEL, node);
      var styleIds = _this.config.styleLinker(RowType$1.BODY, rowIndex, valueForCell, column, node);
      var excelStyleId = _this.getStyleId(styleIds);
      var colSpan = column.getColSpan(node);
      var addedImage = _this.addImage(rowIndex, column, valueForCell);
      if (addedImage) {
        currentCells.push(_this.createCell(excelStyleId, _this.getDataTypeForValue(addedImage.value), addedImage.value == null ? '' : addedImage.value));
      } else if (colSpan > 1) {
        skipCols = colSpan - 1;
        currentCells.push(_this.createMergedCell(excelStyleId, _this.getDataTypeForValue(valueForCell), valueForCell, colSpan - 1));
      } else {
        currentCells.push(_this.createCell(excelStyleId, _this.getDataTypeForValue(valueForCell), valueForCell));
      }
    };
  };
  BaseExcelSerializingSession.prototype.getStyleId = function (styleIds) {
    if (!styleIds || !styleIds.length) {
      return null;
    }
    if (styleIds.length === 1) {
      return styleIds[0];
    }
    var key = styleIds.join("-");
    if (!this.mixedStyles[key]) {
      this.addNewMixedStyle(styleIds);
    }
    return this.mixedStyles[key].excelID;
  };
  BaseExcelSerializingSession.prototype.addNewMixedStyle = function (styleIds) {
    var _this = this;
    this.mixedStyleCounter += 1;
    var excelId = "mixedStyle" + this.mixedStyleCounter;
    var resultantStyle = {};
    styleIds.forEach(function (styleId) {
      _this.excelStyles.forEach(function (excelStyle) {
        if (excelStyle.id === styleId) {
          _.mergeDeep(resultantStyle, _.deepCloneObject(excelStyle));
        }
      });
    });
    resultantStyle.id = excelId;
    resultantStyle.name = excelId;
    var key = styleIds.join("-");
    this.mixedStyles[key] = {
      excelID: excelId,
      key: key,
      result: resultantStyle
    };
    this.excelStyles.push(resultantStyle);
    this.stylesByIds[excelId] = resultantStyle;
  };
  return BaseExcelSerializingSession;
}(BaseGridSerializingSession);
var __extends$3j = undefined && undefined.__extends || function () {
  var _extendStatics220 = function extendStatics(d, b) {
    _extendStatics220 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics220(d, b);
  };
  return function (d, b) {
    _extendStatics220(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ExcelXmlSerializingSession = /** @class */function (_super) {
  __extends$3j(ExcelXmlSerializingSession, _super);
  function ExcelXmlSerializingSession() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ExcelXmlSerializingSession.prototype.createExcel = function (data) {
    return ExcelXmlFactory.createExcel(this.excelStyles, data);
  };
  ExcelXmlSerializingSession.prototype.getDataTypeForValue = function (valueForCell) {
    return _.isNumeric(valueForCell) ? 'Number' : 'String';
  };
  ExcelXmlSerializingSession.prototype.getType = function (type, style, value) {
    if (this.isFormula(value)) {
      return 'Formula';
    }
    if (style && style.dataType) {
      switch (style.dataType.toLocaleLowerCase()) {
        case 'string':
          return 'Formula';
        case 'number':
          return 'Number';
        case 'datetime':
          return 'DateTime';
        case 'error':
          return 'Error';
        case 'boolean':
          return 'Boolean';
        default:
          console.warn("ag-grid: Unrecognized data type for excel export [" + style.id + ".dataType=" + style.dataType + "]");
      }
    }
    return type;
  };
  ExcelXmlSerializingSession.prototype.addImage = function () {
    return;
  };
  ExcelXmlSerializingSession.prototype.createCell = function (styleId, type, value) {
    var actualStyle = this.getStyleById(styleId);
    var typeTransformed = this.getType(type, actualStyle, value) || type;
    return {
      styleId: !!actualStyle ? styleId : undefined,
      data: {
        type: typeTransformed,
        value: this.getValueTransformed(typeTransformed, value)
      }
    };
  };
  ExcelXmlSerializingSession.prototype.getValueTransformed = function (typeTransformed, value) {
    var _this = this;
    var wrapText = function wrapText(val) {
      if (_this.config.suppressTextAsCDATA) {
        return _.escapeString(val);
      }
      var cdataStart = '<![CDATA[';
      var cdataEnd = ']]>';
      var cdataEndRegex = new RegExp(cdataEnd, "g");
      return cdataStart
      // CDATA sections are closed by the character sequence ']]>' and there is no
      // way of escaping this, so if the text contains the offending sequence, emit
      // multiple CDATA sections and split the characters between them.
      + String(val).replace(cdataEndRegex, ']]' + cdataEnd + cdataStart + '>') + cdataEnd;
    };
    var convertBoolean = function convertBoolean(val) {
      if (!val || val === '0' || val === 'false') {
        return '0';
      }
      return '1';
    };
    switch (typeTransformed) {
      case 'String':
        return wrapText(value);
      case 'Number':
        return Number(value).valueOf() + '';
      case 'Boolean':
        return convertBoolean(value);
      default:
        return value;
    }
  };
  ExcelXmlSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
    return {
      styleId: !!this.getStyleById(styleId) ? styleId : undefined,
      data: {
        type: type,
        value: value
      },
      mergeAcross: numOfCells
    };
  };
  return ExcelXmlSerializingSession;
}(BaseExcelSerializingSession);
var coreFactory = {
  getTemplate: function getTemplate(author) {
    var dt = new Date();
    var jsonDate = dt.toJSON();
    return {
      name: 'cp:coreProperties',
      properties: {
        prefixedAttributes: [{
          prefix: "xmlns:",
          map: {
            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
            dc: 'http://purl.org/dc/elements/1.1/',
            dcterms: 'http://purl.org/dc/terms/',
            dcmitype: 'http://purl.org/dc/dcmitype/',
            xsi: 'http://www.w3.org/2001/XMLSchema-instance'
          }
        }]
      },
      children: [{
        name: 'dc:creator',
        textNode: author
      }, {
        name: 'dc:title',
        textNode: 'Workbook'
      }, {
        name: 'dcterms:created',
        properties: {
          rawMap: {
            'xsi:type': 'dcterms:W3CDTF'
          }
        },
        textNode: jsonDate
      }, {
        name: 'dcterms:modified',
        properties: {
          rawMap: {
            'xsi:type': 'dcterms:W3CDTF'
          }
        },
        textNode: jsonDate
      }]
    };
  }
};
var contentTypeFactory = {
  getTemplate: function getTemplate(config) {
    var name = config.name,
      ContentType = config.ContentType,
      Extension = config.Extension,
      PartName = config.PartName;
    return {
      name: name,
      properties: {
        rawMap: {
          Extension: Extension,
          PartName: PartName,
          ContentType: ContentType
        }
      }
    };
  }
};
var __spreadArrays$f = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var contentTypesFactory = {
  getTemplate: function getTemplate(sheetLen) {
    var worksheets = _.fill(new Array(sheetLen), undefined).map(function (v, i) {
      return {
        name: 'Override',
        ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml',
        PartName: "/xl/worksheets/sheet" + (i + 1) + ".xml"
      };
    });
    var sheetsWithImages = ExcelXlsxFactory.worksheetImages.size;
    var imageTypesObject = {};
    ExcelXlsxFactory.workbookImageIds.forEach(function (v) {
      imageTypesObject[v.type] = true;
    });
    var imageDocs = _.fill(new Array(sheetsWithImages), undefined).map(function (v, i) {
      return {
        name: 'Override',
        ContentType: 'application/vnd.openxmlformats-officedocument.drawing+xml',
        PartName: "/xl/drawings/drawing" + (i + 1) + ".xml"
      };
    });
    var imageTypes = Object.keys(imageTypesObject).map(function (ext) {
      return {
        name: 'Default',
        ContentType: "image/" + ext,
        Extension: ext
      };
    });
    var children = __spreadArrays$f(imageTypes, [{
      name: 'Default',
      Extension: 'rels',
      ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
    }, {
      name: 'Default',
      ContentType: 'application/xml',
      Extension: 'xml'
    }, {
      name: 'Override',
      ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml',
      PartName: "/xl/workbook.xml"
    }], worksheets, [{
      name: 'Override',
      ContentType: 'application/vnd.openxmlformats-officedocument.theme+xml',
      PartName: '/xl/theme/theme1.xml'
    }, {
      name: 'Override',
      ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml',
      PartName: '/xl/styles.xml'
    }, {
      name: 'Override',
      ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml',
      PartName: '/xl/sharedStrings.xml'
    }], imageDocs, [{
      name: 'Override',
      ContentType: 'application/vnd.openxmlformats-package.core-properties+xml',
      PartName: '/docProps/core.xml'
    }]).map(function (contentType) {
      return contentTypeFactory.getTemplate(contentType);
    });
    return {
      name: "Types",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
        }
      },
      children: children
    };
  }
};
var getAnchor = function getAnchor(name, imageAnchor) {
  return {
    name: "xdr:" + name,
    children: [{
      name: 'xdr:col',
      textNode: imageAnchor.col.toString()
    }, {
      name: 'xdr:colOff',
      textNode: imageAnchor.offsetX.toString()
    }, {
      name: 'xdr:row',
      textNode: imageAnchor.row.toString()
    }, {
      name: 'xdr:rowOff',
      textNode: imageAnchor.offsetY.toString()
    }]
  };
};
var getExt = function getExt(image) {
  var children = [{
    name: 'a:ext',
    properties: {
      rawMap: {
        uri: '{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}'
      }
    },
    children: [{
      name: 'a16:creationId',
      properties: {
        rawMap: {
          id: '{822E6D20-D7BC-2841-A643-D49A6EF008A2}',
          'xmlns:a16': 'http://schemas.microsoft.com/office/drawing/2014/main'
        }
      }
    }]
  }];
  var recolor = image.recolor && image.recolor.toLowerCase();
  switch (recolor) {
    case 'grayscale':
    case 'sepia':
    case 'washout':
      children.push({
        name: 'a:ext',
        properties: {
          rawMap: {
            uri: '{C183D7F6-B498-43B3-948B-1728B52AA6E4}'
          }
        },
        children: [{
          name: 'adec:decorative',
          properties: {
            rawMap: {
              val: '0',
              'xmlns:adec': 'http://schemas.microsoft.com/office/drawing/2017/decorative'
            }
          }
        }]
      });
  }
  return {
    name: 'a:extLst',
    children: children
  };
};
var getNvPicPr = function getNvPicPr(image, index) {
  return {
    name: 'xdr:nvPicPr',
    children: [{
      name: 'xdr:cNvPr',
      properties: {
        rawMap: {
          id: index,
          name: image.id,
          descr: image.altText != null ? image.altText : undefined
        }
      },
      children: [getExt(image)]
    }, {
      name: 'xdr:cNvPicPr',
      properties: {
        rawMap: {
          preferRelativeResize: '0'
        }
      },
      children: [{
        name: 'a:picLocks'
      }]
    }]
  };
};
var getColorDetails = function getColorDetails(color) {
  if (!color.saturation && !color.tint) {
    return;
  }
  var ret = [];
  if (color.saturation) {
    ret.push({
      name: 'a:satMod',
      properties: {
        rawMap: {
          val: color.saturation * 1000
        }
      }
    });
  }
  if (color.tint) {
    ret.push({
      name: 'a:tint',
      properties: {
        rawMap: {
          val: color.tint * 1000
        }
      }
    });
  }
  return ret;
};
var getDuoTone = function getDuoTone(primaryColor, secondaryColor) {
  return {
    name: 'a:duotone',
    children: [{
      name: 'a:prstClr',
      properties: {
        rawMap: {
          val: primaryColor.color
        }
      },
      children: getColorDetails(primaryColor)
    }, {
      name: 'a:srgbClr',
      properties: {
        rawMap: {
          val: secondaryColor.color
        }
      },
      children: getColorDetails(secondaryColor)
    }]
  };
};
var getBlipFill = function getBlipFill(image, index) {
  var blipChildren;
  if (image.transparency) {
    var transparency = Math.min(Math.max(image.transparency, 0), 100);
    blipChildren = [{
      name: 'a:alphaModFix',
      properties: {
        rawMap: {
          amt: 100000 - Math.round(transparency * 1000)
        }
      }
    }];
  }
  if (image.recolor) {
    if (!blipChildren) {
      blipChildren = [];
    }
    switch (image.recolor.toLocaleLowerCase()) {
      case 'grayscale':
        blipChildren.push({
          name: 'a:grayscl'
        });
        break;
      case 'sepia':
        blipChildren.push(getDuoTone({
          color: 'black'
        }, {
          color: 'D9C3A5',
          tint: 50,
          saturation: 180
        }));
        break;
      case 'washout':
        blipChildren.push({
          name: 'a:lum',
          properties: {
            rawMap: {
              bright: '70000',
              contrast: '-70000'
            }
          }
        });
        break;
    }
  }
  return {
    name: 'xdr:blipFill',
    children: [{
      name: 'a:blip',
      properties: {
        rawMap: {
          cstate: 'print',
          'r:embed': "rId" + index,
          'xmlns:r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships'
        }
      },
      children: blipChildren
    }, {
      name: 'a:stretch',
      children: [{
        name: 'a:fillRect'
      }]
    }]
  };
};
var getSpPr = function getSpPr(image, imageBoxSize) {
  var xfrm = {
    name: 'a:xfrm',
    children: [{
      name: 'a:off',
      properties: {
        rawMap: {
          x: 0,
          y: 0
        }
      }
    }, {
      name: 'a:ext',
      properties: {
        rawMap: {
          cx: imageBoxSize.width,
          cy: imageBoxSize.height
        }
      }
    }]
  };
  if (image.rotation) {
    var rotation = image.rotation;
    xfrm.properties = {
      rawMap: {
        rot: Math.min(Math.max(rotation, 0), 360) * 60000
      }
    };
  }
  var prstGeom = {
    name: 'a:prstGeom',
    properties: {
      rawMap: {
        prst: 'rect'
      }
    },
    children: [{
      name: 'a:avLst'
    }]
  };
  var ret = {
    name: 'xdr:spPr',
    children: [xfrm, prstGeom]
  };
  return ret;
};
var getImageBoxSize = function getImageBoxSize(image) {
  image.fitCell = !!image.fitCell || !image.width || !image.height;
  var _a = image.position,
    position = _a === void 0 ? {} : _a,
    fitCell = image.fitCell,
    _b = image.width,
    width = _b === void 0 ? 0 : _b,
    _c = image.height,
    height = _c === void 0 ? 0 : _c,
    totalHeight = image.totalHeight,
    totalWidth = image.totalWidth;
  var _d = position.offsetX,
    offsetX = _d === void 0 ? 0 : _d,
    _e = position.offsetY,
    offsetY = _e === void 0 ? 0 : _e,
    _f = position.row,
    row = _f === void 0 ? 1 : _f,
    _g = position.rowSpan,
    rowSpan = _g === void 0 ? 1 : _g,
    _h = position.column,
    column = _h === void 0 ? 1 : _h,
    _j = position.colSpan,
    colSpan = _j === void 0 ? 1 : _j;
  return {
    from: {
      row: row - 1,
      col: column - 1,
      offsetX: pixelsToEMU(offsetX),
      offsetY: pixelsToEMU(offsetY)
    },
    to: {
      row: row - 1 + (fitCell ? 1 : rowSpan - 1),
      col: column - 1 + (fitCell ? 1 : colSpan - 1),
      offsetX: pixelsToEMU(width + offsetX),
      offsetY: pixelsToEMU(height + offsetY)
    },
    height: pixelsToEMU(totalHeight || height),
    width: pixelsToEMU(totalWidth || width)
  };
};
var getPicture = function getPicture(image, currentIndex, worksheetImageIndex, imageBoxSize) {
  return {
    name: 'xdr:pic',
    children: [getNvPicPr(image, currentIndex + 1), getBlipFill(image, worksheetImageIndex + 1), getSpPr(image, imageBoxSize)]
  };
};
var drawingFactory = {
  getTemplate: function getTemplate(config) {
    var sheetIndex = config.sheetIndex;
    var sheetImages = ExcelXlsxFactory.worksheetImages.get(sheetIndex);
    var sheetImageIds = ExcelXlsxFactory.worksheetImageIds.get(sheetIndex);
    var children = sheetImages.map(function (image, idx) {
      var boxSize = getImageBoxSize(image);
      return {
        name: 'xdr:twoCellAnchor',
        properties: {
          rawMap: {
            editAs: 'absolute'
          }
        },
        children: [getAnchor('from', boxSize.from), getAnchor('to', boxSize.to), getPicture(image, idx, sheetImageIds.get(image.id).index, boxSize), {
          name: 'xdr:clientData'
        }]
      };
    });
    return {
      name: 'xdr:wsDr',
      properties: {
        rawMap: {
          'xmlns:a': 'http://schemas.openxmlformats.org/drawingml/2006/main',
          'xmlns:xdr': 'http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing'
        }
      },
      children: children
    };
  }
};
var getColorChildren = function getColorChildren(props) {
  var type = props[0],
    innerType = props[1],
    val = props[2],
    lastClr = props[3];
  return {
    name: "a:" + type,
    children: [{
      name: "a:" + innerType,
      properties: {
        rawMap: {
          val: val,
          lastClr: lastClr
        }
      }
    }]
  };
};
var colorScheme = {
  getTemplate: function getTemplate() {
    return {
      name: "a:clrScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [getColorChildren(['dk1', 'sysClr', 'windowText', '000000']), getColorChildren(['lt1', 'sysClr', 'window', 'FFFFFF']), getColorChildren(['dk2', 'srgbClr', '44546A']), getColorChildren(['lt2', 'srgbClr', 'E7E6E6']), getColorChildren(['accent1', 'srgbClr', '4472C4']), getColorChildren(['accent2', 'srgbClr', 'ED7D31']), getColorChildren(['accent3', 'srgbClr', 'A5A5A5']), getColorChildren(['accent4', 'srgbClr', 'FFC000']), getColorChildren(['accent5', 'srgbClr', '5B9BD5']), getColorChildren(['accent6', 'srgbClr', '70AD47']), getColorChildren(['hlink', 'srgbClr', '0563C1']), getColorChildren(['folHlink', 'srgbClr', '954F72'])]
    };
  }
};
var getFont = function getFont(props) {
  var type = props[0],
    typeface = props[1],
    script = props[2],
    panose = props[3];
  return {
    name: "a:" + type,
    properties: {
      rawMap: {
        script: script,
        typeface: typeface,
        panose: panose
      }
    }
  };
};
var fontScheme = {
  getTemplate: function getTemplate() {
    var utf8_encode = _.utf8_encode;
    return {
      name: "a:fontScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [{
        name: 'a:majorFont',
        children: [getFont(['latin', 'Calibri Light', undefined, '020F0302020204030204']), getFont(['ea', '']), getFont(['cs', '']), getFont(['font', utf8_encode('游ゴシック Light'), 'Jpan']), getFont(['font', utf8_encode('맑은 고딕'), 'Hang']), getFont(['font', utf8_encode('等线 Light'), 'Hans']), getFont(['font', utf8_encode('新細明體'), 'Hant']), getFont(['font', 'Times New Roman', 'Arab']), getFont(['font', 'Times New Roman', 'Hebr']), getFont(['font', 'Tahoma', 'Thai']), getFont(['font', 'Nyala', 'Ethi']), getFont(['font', 'Vrinda', 'Beng']), getFont(['font', 'Shruti', 'Gujr']), getFont(['font', 'MoolBoran', 'Khmr']), getFont(['font', 'Tunga', 'Knda']), getFont(['font', 'Raavi', 'Guru']), getFont(['font', 'Euphemia', 'Cans']), getFont(['font', 'Plantagenet Cherokee', 'Cher']), getFont(['font', 'Microsoft Yi Baiti', 'Yiii']), getFont(['font', 'Microsoft Himalaya', 'Tibt']), getFont(['font', 'MV Boli', 'Thaa']), getFont(['font', 'Mangal', 'Deva']), getFont(['font', 'Gautami', 'Telu']), getFont(['font', 'Latha', 'Taml']), getFont(['font', 'Estrangelo Edessa', 'Syrc']), getFont(['font', 'Kalinga', 'Orya']), getFont(['font', 'Kartika', 'Mlym']), getFont(['font', 'DokChampa', 'Laoo']), getFont(['font', 'Iskoola Pota', 'Sinh']), getFont(['font', 'Mongolian Baiti', 'Mong']), getFont(['font', 'Times New Roman', 'Viet']), getFont(['font', 'Microsoft Uighur', 'Uigh']), getFont(['font', 'Sylfaen', 'Geor']), getFont(['font', 'Arial', 'Armn']), getFont(['font', 'Leelawadee UI', 'Bugi']), getFont(['font', 'Microsoft JhengHei', 'Bopo']), getFont(['font', 'Javanese Text', 'Java']), getFont(['font', 'Segoe UI', 'Lisu']), getFont(['font', 'Myanmar Text', 'Mymr']), getFont(['font', 'Ebrima', 'Nkoo']), getFont(['font', 'Nirmala UI', 'Olck']), getFont(['font', 'Ebrima', 'Osma']), getFont(['font', 'Phagspa', 'Phag']), getFont(['font', 'Estrangelo Edessa', 'Syrn']), getFont(['font', 'Estrangelo Edessa', 'Syrj']), getFont(['font', 'Estrangelo Edessa', 'Syre']), getFont(['font', 'Nirmala UI', 'Sora']), getFont(['font', 'Microsoft Tai Le', 'Tale']), getFont(['font', 'Microsoft New Tai Lue', 'Talu']), getFont(['font', 'Ebrima', 'Tfng'])]
      }, {
        name: 'a:minorFont',
        children: [getFont(['latin', 'Calibri', undefined, '020F0502020204030204']), getFont(['ea', '']), getFont(['cs', '']), getFont(['font', utf8_encode('游ゴシック'), 'Jpan']), getFont(['font', utf8_encode('맑은 고딕'), 'Hang']), getFont(['font', utf8_encode('等线'), 'Hans']), getFont(['font', utf8_encode('新細明體'), 'Hant']), getFont(['font', 'Arial', 'Arab']), getFont(['font', 'Arial', 'Hebr']), getFont(['font', 'Tahoma', 'Thai']), getFont(['font', 'Nyala', 'Ethi']), getFont(['font', 'Vrinda', 'Beng']), getFont(['font', 'Shruti', 'Gujr']), getFont(['font', 'DaunPenh', 'Khmr']), getFont(['font', 'Tunga', 'Knda']), getFont(['font', 'Raavi', 'Guru']), getFont(['font', 'Euphemia', 'Cans']), getFont(['font', 'Plantagenet Cherokee', 'Cher']), getFont(['font', 'Microsoft Yi Baiti', 'Yiii']), getFont(['font', 'Microsoft Himalaya', 'Tibt']), getFont(['font', 'MV Boli', 'Thaa']), getFont(['font', 'Mangal', 'Deva']), getFont(['font', 'Gautami', 'Telu']), getFont(['font', 'Latha', 'Taml']), getFont(['font', 'Estrangelo Edessa', 'Syrc']), getFont(['font', 'Kalinga', 'Orya']), getFont(['font', 'Kartika', 'Mlym']), getFont(['font', 'DokChampa', 'Laoo']), getFont(['font', 'Iskoola Pota', 'Sinh']), getFont(['font', 'Mongolian Baiti', 'Mong']), getFont(['font', 'Arial', 'Viet']), getFont(['font', 'Microsoft Uighur', 'Uigh']), getFont(['font', 'Sylfaen', 'Geor']), getFont(['font', 'Arial', 'Armn']), getFont(['font', 'Leelawadee UI', 'Bugi']), getFont(['font', 'Microsoft JhengHei', 'Bopo']), getFont(['font', 'Javanese Text', 'Java']), getFont(['font', 'Segoe UI', 'Lisu']), getFont(['font', 'Myanmar Text', 'Mymr']), getFont(['font', 'Ebrima', 'Nkoo']), getFont(['font', 'Nirmala UI', 'Olck']), getFont(['font', 'Ebrima', 'Osma']), getFont(['font', 'Phagspa', 'Phag']), getFont(['font', 'Estrangelo Edessa', 'Syrn']), getFont(['font', 'Estrangelo Edessa', 'Syrj']), getFont(['font', 'Estrangelo Edessa', 'Syre']), getFont(['font', 'Nirmala UI', 'Sora']), getFont(['font', 'Microsoft Tai Le', 'Tale']), getFont(['font', 'Microsoft New Tai Lue', 'Talu']), getFont(['font', 'Ebrima', 'Tfng'])]
      }]
    };
  }
};
var getPropertyVal = function getPropertyVal(name, val, children) {
  return {
    name: "a:" + name,
    properties: {
      rawMap: {
        val: val
      }
    },
    children: children
  };
};
var getGs = function getGs(props) {
  var pos = props[0],
    schemeColor = props[1],
    satMod = props[2],
    lumMod = props[3],
    tint = props[4],
    shade = props[5];
  var children = [];
  children.push(getPropertyVal('satMod', satMod));
  if (lumMod) {
    children.push(getPropertyVal('lumMod', lumMod));
  }
  if (tint) {
    children.push(getPropertyVal('tint', tint));
  }
  if (shade) {
    children.push(getPropertyVal('shade', shade));
  }
  return {
    name: 'a:gs',
    properties: {
      rawMap: {
        pos: pos
      }
    },
    children: [{
      name: 'a:schemeClr',
      properties: {
        rawMap: {
          val: schemeColor
        }
      },
      children: children
    }]
  };
};
var getSolidFill = function getSolidFill(val, children) {
  return {
    name: 'a:solidFill',
    children: [getPropertyVal('schemeClr', val, children)]
  };
};
var getGradFill = function getGradFill(props) {
  var rotWithShape = props[0],
    gs1 = props[1],
    gs2 = props[2],
    gs3 = props[3],
    lin = props[4];
  var ang = lin[0],
    scaled = lin[1];
  return {
    name: 'a:gradFill',
    properties: {
      rawMap: {
        rotWithShape: rotWithShape
      }
    },
    children: [{
      name: 'a:gsLst',
      children: [getGs(gs1), getGs(gs2), getGs(gs3)]
    }, {
      name: 'a:lin',
      properties: {
        rawMap: {
          ang: ang,
          scaled: scaled
        }
      }
    }]
  };
};
var getLine = function getLine(props) {
  var w = props[0],
    cap = props[1],
    cmpd = props[2],
    algn = props[3];
  return {
    name: 'a:ln',
    properties: {
      rawMap: {
        w: w,
        cap: cap,
        cmpd: cmpd,
        algn: algn
      }
    },
    children: [getSolidFill('phClr'), getPropertyVal('prstDash', 'solid'), {
      name: 'a:miter',
      properties: {
        rawMap: {
          lim: '800000'
        }
      }
    }]
  };
};
var getEffectStyle = function getEffectStyle(shadow) {
  var children = [];
  if (shadow) {
    var blurRad = shadow[0],
      dist = shadow[1],
      dir = shadow[2],
      algn = shadow[3],
      rotWithShape = shadow[4];
    children.push({
      name: 'a:outerShdw',
      properties: {
        rawMap: {
          blurRad: blurRad,
          dist: dist,
          dir: dir,
          algn: algn,
          rotWithShape: rotWithShape
        }
      },
      children: [getPropertyVal('srgbClr', '000000', [getPropertyVal('alpha', '63000')])]
    });
  }
  return {
    name: 'a:effectStyle',
    children: [_.assign({}, {
      name: 'a:effectLst'
    }, children.length ? {
      children: children
    } : {})]
  };
};
var getFillStyleList = function getFillStyleList() {
  return {
    name: 'a:fillStyleLst',
    children: [getSolidFill('phClr'), getGradFill(['1', ['0', 'phClr', '105000', '110000', '67000'], ['50000', 'phClr', '103000', '105000', '73000'], ['100000', 'phClr', '109000', '105000', '81000'], ['5400000', '0']]), getGradFill(['1', ['0', 'phClr', '103000', '102000', '94000'], ['50000', 'phClr', '110000', '100000', undefined, '100000'], ['100000', 'phClr', '120000', '99000', undefined, '78000'], ['5400000', '0']])]
  };
};
var getLineStyleList = function getLineStyleList() {
  return {
    name: 'a:lnStyleLst',
    children: [getLine(['6350', 'flat', 'sng', 'ctr']), getLine(['12700', 'flat', 'sng', 'ctr']), getLine(['19050', 'flat', 'sng', 'ctr'])]
  };
};
var getEffectStyleList = function getEffectStyleList() {
  return {
    name: 'a:effectStyleLst',
    children: [getEffectStyle(), getEffectStyle(), getEffectStyle(['57150', '19050', '5400000', 'ctr', '0'])]
  };
};
var getBgFillStyleList = function getBgFillStyleList() {
  return {
    name: 'a:bgFillStyleLst',
    children: [getSolidFill('phClr'), getSolidFill('phClr', [getPropertyVal('tint', '95000'), getPropertyVal('satMod', '170000')]), getGradFill(['1', ['0', 'phClr', '150000', '102000', '93000', '98000'], ['50000', 'phClr', '130000', '103000', '98000', '90000'], ['100000', 'phClr', '120000', undefined, undefined, '63000'], ['5400000', '0']])]
  };
};
var formatScheme = {
  getTemplate: function getTemplate() {
    return {
      name: "a:fmtScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [getFillStyleList(), getLineStyleList(), getEffectStyleList(), getBgFillStyleList()]
    };
  }
};
var themeElements = {
  getTemplate: function getTemplate() {
    return {
      name: "a:themeElements",
      children: [colorScheme.getTemplate(), fontScheme.getTemplate(), formatScheme.getTemplate()]
    };
  }
};
var officeTheme = {
  getTemplate: function getTemplate() {
    return {
      name: "a:theme",
      properties: {
        prefixedAttributes: [{
          prefix: "xmlns:",
          map: {
            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
          }
        }],
        rawMap: {
          name: "Office Theme"
        }
      },
      children: [themeElements.getTemplate(), {
        name: 'a:objectDefaults'
      }, {
        name: 'a:extraClrSchemeLst'
      }]
    };
  }
};
var buildSharedString = function buildSharedString(strMap) {
  var ret = [];
  strMap.forEach(function (val, key) {
    var textNode = key.toString();
    var child = {
      name: 't',
      textNode: _.utf8_encode(_.escapeString(textNode))
    };
    // if we have leading or trailing spaces, instruct Excel not to trim them
    var preserveSpaces = textNode.trim().length !== textNode.length;
    if (preserveSpaces) {
      child.properties = {
        rawMap: {
          "xml:space": "preserve"
        }
      };
    }
    ret.push({
      name: 'si',
      children: [child]
    });
  });
  return ret;
};
var sharedStrings = {
  getTemplate: function getTemplate(strings) {
    return {
      name: "sst",
      properties: {
        rawMap: {
          xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
          count: strings.size,
          uniqueCount: strings.size
        }
      },
      children: buildSharedString(strings)
    };
  }
};
var numberFormatFactory = {
  getTemplate: function getTemplate(numberFormat) {
    var formatCode = numberFormat.formatCode,
      numFmtId = numberFormat.numFmtId;
    return {
      name: "numFmt",
      properties: {
        rawMap: {
          formatCode: formatCode,
          numFmtId: numFmtId
        }
      }
    };
  }
};
var numberFormatsFactory = {
  getTemplate: function getTemplate(numberFormats) {
    return {
      name: "numFmts",
      properties: {
        rawMap: {
          count: numberFormats.length
        }
      },
      children: numberFormats.map(function (numberFormat) {
        return numberFormatFactory.getTemplate(numberFormat);
      })
    };
  }
};
var fontFactory = {
  getTemplate: function getTemplate(font) {
    var size = font.size,
      colorTheme = font.colorTheme,
      _a = font.color,
      color = _a === void 0 ? 'FF000000' : _a,
      _b = font.fontName,
      fontName = _b === void 0 ? 'Calibri' : _b,
      family = font.family,
      scheme = font.scheme,
      italic = font.italic,
      bold = font.bold,
      strikeThrough = font.strikeThrough,
      outline = font.outline,
      shadow = font.shadow,
      underline = font.underline,
      verticalAlign = font.verticalAlign;
    var children = [{
      name: 'sz',
      properties: {
        rawMap: {
          val: size
        }
      }
    }, {
      name: 'color',
      properties: {
        rawMap: {
          theme: colorTheme,
          rgb: color
        }
      }
    }, {
      name: 'name',
      properties: {
        rawMap: {
          val: fontName
        }
      }
    }];
    if (family) {
      children.push({
        name: 'family',
        properties: {
          rawMap: {
            val: family
          }
        }
      });
    }
    if (scheme) {
      children.push({
        name: 'scheme',
        properties: {
          rawMap: {
            val: scheme
          }
        }
      });
    }
    if (italic) {
      children.push({
        name: 'i'
      });
    }
    if (bold) {
      children.push({
        name: 'b'
      });
    }
    if (strikeThrough) {
      children.push({
        name: 'strike'
      });
    }
    if (outline) {
      children.push({
        name: 'outline'
      });
    }
    if (shadow) {
      children.push({
        name: 'shadow'
      });
    }
    if (underline) {
      children.push({
        name: 'u',
        properties: {
          rawMap: {
            val: underline
          }
        }
      });
    }
    if (verticalAlign) {
      children.push({
        name: 'vertAlign',
        properties: {
          rawMap: {
            val: verticalAlign
          }
        }
      });
    }
    return {
      name: "font",
      children: children
    };
  }
};
var fontsFactory = {
  getTemplate: function getTemplate(fonts) {
    return {
      name: "fonts",
      properties: {
        rawMap: {
          count: fonts.length
        }
      },
      children: fonts.map(function (font) {
        return fontFactory.getTemplate(font);
      })
    };
  }
};
var fillFactory = {
  getTemplate: function getTemplate(fill) {
    var patternType = fill.patternType,
      fgTheme = fill.fgTheme,
      fgTint = fill.fgTint,
      fgRgb = fill.fgRgb,
      bgRgb = fill.bgRgb,
      bgIndexed = fill.bgIndexed;
    var pf = {
      name: 'patternFill',
      properties: {
        rawMap: {
          patternType: patternType
        }
      }
    };
    if (fgTheme || fgTint || fgRgb) {
      pf.children = [{
        name: 'fgColor',
        properties: {
          rawMap: {
            theme: fgTheme,
            tint: fgTint,
            rgb: fgRgb
          }
        }
      }];
    }
    if (bgIndexed) {
      if (!pf.children) {
        pf.children = [];
      }
      pf.children.push({
        name: 'bgColor',
        properties: {
          rawMap: {
            indexed: bgIndexed,
            rgb: bgRgb
          }
        }
      });
    }
    return {
      name: "fill",
      children: [pf]
    };
  }
};
var fillsFactory = {
  getTemplate: function getTemplate(fills) {
    return {
      name: "fills",
      properties: {
        rawMap: {
          count: fills.length
        }
      },
      children: fills.map(function (fill) {
        return fillFactory.getTemplate(fill);
      })
    };
  }
};
var getWeightName = function getWeightName(value) {
  switch (value) {
    case 1:
      return 'thin';
    case 2:
      return 'medium';
    case 3:
      return 'thick';
    default:
      return 'hair';
  }
};
var mappedBorderNames = {
  None: 'None',
  Dot: 'Dotted',
  Dash: 'Dashed',
  Double: 'Double',
  DashDot: 'DashDot',
  DashDotDot: 'DashDotDot',
  SlantDashDot: 'SlantDashDot'
};
var mediumBorders = ['Dashed', 'DashDot', 'DashDotDot'];
var colorMap = {
  None: 'none',
  Solid: 'solid',
  Gray50: 'mediumGray',
  Gray75: 'darkGray',
  Gray25: 'lightGray',
  HorzStripe: 'darkHorizontal',
  VertStripe: 'darkVertical',
  ReverseDiagStripe: 'darkDown',
  DiagStripe: 'darkUp',
  DiagCross: 'darkGrid',
  ThickDiagCross: 'darkTrellis',
  ThinHorzStripe: 'lightHorizontal',
  ThinVertStripe: 'lightVertical',
  ThinReverseDiagStripe: 'lightDown',
  ThinDiagStripe: 'lightUp',
  ThinHorzCross: 'lightGrid',
  ThinDiagCross: 'lightTrellis',
  Gray125: 'gray125',
  Gray0625: 'gray0625'
};
var horizontalAlignmentMap = {
  Automatic: 'general',
  Left: 'left',
  Center: 'center',
  Right: 'right',
  Fill: 'fill',
  Justify: 'justify',
  CenterAcrossSelection: 'centerContinuous',
  Distributed: 'distributed',
  JustifyDistributed: 'justify'
};
var verticalAlignmentMap = {
  Automatic: undefined,
  Top: 'top',
  Bottom: 'bottom',
  Center: 'center',
  Justify: 'justify',
  Distributed: 'distributed',
  JustifyDistributed: 'justify'
};
var convertLegacyPattern = function convertLegacyPattern(name) {
  if (!name) {
    return 'none';
  }
  return colorMap[name] || name;
};
var convertLegacyColor = function convertLegacyColor(color) {
  if (color == undefined) {
    return color;
  }
  if (color.charAt(0) === '#') {
    color = color.substr(1);
  }
  return color.length === 6 ? 'FF' + color : color;
};
var convertLegacyBorder = function convertLegacyBorder(type, weight) {
  if (!type) {
    return 'thin';
  }
  // Legacy Types are: None, Continuous, Dash, Dot, DashDot, DashDotDot, SlantDashDot, and Double
  // Weight represents: 0—Hairline, 1—Thin , 2—Medium, 3—Thick
  // New types: none, thin, medium, dashed, dotted, thick, double, hair, mediumDashed, dashDot, mediumDashDot,
  // dashDotDot, mediumDashDotDot, slantDashDot
  var namedWeight = getWeightName(weight);
  var mappedName = mappedBorderNames[type];
  if (type === 'Continuous') {
    return namedWeight;
  }
  if (namedWeight === 'medium' && mediumBorders.indexOf(mappedName) !== -1) {
    return "medium" + mappedName;
  }
  return mappedName.charAt(0).toLowerCase() + mappedName.substr(1);
};
var convertLegacyHorizontalAlignment = function convertLegacyHorizontalAlignment(alignment) {
  return horizontalAlignmentMap[alignment] || 'general';
};
var convertLegacyVerticalAlignment = function convertLegacyVerticalAlignment(alignment) {
  return verticalAlignmentMap[alignment] || undefined;
};
var getBorderColor = function getBorderColor(color) {
  return {
    name: 'color',
    properties: {
      rawMap: {
        rgb: convertLegacyColor(color || '#000000')
      }
    }
  };
};
var borderFactory = {
  getTemplate: function getTemplate(border) {
    var left = border.left,
      right = border.right,
      top = border.top,
      bottom = border.bottom,
      diagonal = border.diagonal;
    var leftChildren = left ? [getBorderColor(left.color)] : undefined;
    var rightChildren = right ? [getBorderColor(right.color)] : undefined;
    var topChildren = top ? [getBorderColor(top.color)] : undefined;
    var bottomChildren = bottom ? [getBorderColor(bottom.color)] : undefined;
    var diagonalChildren = diagonal ? [getBorderColor(diagonal.color)] : undefined;
    return {
      name: 'border',
      children: [{
        name: 'left',
        properties: {
          rawMap: {
            style: left && left.style
          }
        },
        children: leftChildren
      }, {
        name: 'right',
        properties: {
          rawMap: {
            style: right && right.style
          }
        },
        children: rightChildren
      }, {
        name: 'top',
        properties: {
          rawMap: {
            style: top && top.style
          }
        },
        children: topChildren
      }, {
        name: 'bottom',
        properties: {
          rawMap: {
            style: bottom && bottom.style
          }
        },
        children: bottomChildren
      }, {
        name: 'diagonal',
        properties: {
          rawMap: {
            style: diagonal && diagonal.style
          }
        },
        children: diagonalChildren
      }]
    };
  }
};
var bordersFactory = {
  getTemplate: function getTemplate(borders) {
    return {
      name: "borders",
      properties: {
        rawMap: {
          count: borders.length
        }
      },
      children: borders.map(function (border) {
        return borderFactory.getTemplate(border);
      })
    };
  }
};
var getReadingOrderId = function getReadingOrderId(readingOrder) {
  var order = ['Context', 'LeftToRight', 'RightToLeft'];
  var pos = order.indexOf(readingOrder);
  return Math.max(pos, 0);
};
var alignmentFactory = {
  getTemplate: function getTemplate(alignment) {
    var horizontal = alignment.horizontal,
      indent = alignment.indent,
      readingOrder = alignment.readingOrder,
      rotate = alignment.rotate,
      shrinkToFit = alignment.shrinkToFit,
      vertical = alignment.vertical,
      wrapText = alignment.wrapText;
    return {
      name: 'alignment',
      properties: {
        rawMap: {
          horizontal: horizontal && convertLegacyHorizontalAlignment(horizontal),
          indent: indent,
          readingOrder: readingOrder && getReadingOrderId(readingOrder),
          textRotation: rotate,
          shrinkToFit: shrinkToFit,
          vertical: vertical && convertLegacyVerticalAlignment(vertical),
          wrapText: wrapText
        }
      }
    };
  }
};
var protectionFactory = {
  getTemplate: function getTemplate(protection) {
    var locked = protection.protected === false ? 0 : 1;
    var hidden = protection.hideFormula === true ? 1 : 0;
    return {
      name: 'protection',
      properties: {
        rawMap: {
          hidden: hidden,
          locked: locked
        }
      }
    };
  }
};
var xfFactory = {
  getTemplate: function getTemplate(xf) {
    var alignment = xf.alignment,
      borderId = xf.borderId,
      fillId = xf.fillId,
      fontId = xf.fontId,
      numFmtId = xf.numFmtId,
      protection = xf.protection,
      xfId = xf.xfId;
    var children = [];
    if (alignment) {
      children.push(alignmentFactory.getTemplate(alignment));
    }
    if (protection) {
      children.push(protectionFactory.getTemplate(protection));
    }
    return {
      name: "xf",
      properties: {
        rawMap: {
          applyAlignment: alignment ? 1 : undefined,
          applyProtection: protection ? 1 : undefined,
          applyBorder: borderId ? 1 : undefined,
          applyFill: fillId ? 1 : undefined,
          borderId: borderId,
          fillId: fillId,
          applyFont: fontId ? 1 : undefined,
          fontId: fontId,
          applyNumberFormat: numFmtId ? 1 : undefined,
          numFmtId: numFmtId,
          xfId: xfId
        }
      },
      children: children.length ? children : undefined
    };
  }
};
var cellStylesXfsFactory = {
  getTemplate: function getTemplate(xfs) {
    return {
      name: "cellStyleXfs",
      properties: {
        rawMap: {
          count: xfs.length
        }
      },
      children: xfs.map(function (xf) {
        return xfFactory.getTemplate(xf);
      })
    };
  }
};
var cellXfsFactory = {
  getTemplate: function getTemplate(xfs) {
    return {
      name: "cellXfs",
      properties: {
        rawMap: {
          count: xfs.length
        }
      },
      children: xfs.map(function (xf) {
        return xfFactory.getTemplate(xf);
      })
    };
  }
};
var borderFactory$1 = {
  getTemplate: function getTemplate(cellStyle) {
    var builtinId = cellStyle.builtinId,
      name = cellStyle.name,
      xfId = cellStyle.xfId;
    return {
      name: "cellStyle",
      properties: {
        rawMap: {
          builtinId: builtinId,
          name: name,
          xfId: xfId
        }
      }
    };
  }
};
var cellStylesFactory = {
  getTemplate: function getTemplate(cellStyles) {
    return {
      name: "cellStyles",
      properties: {
        rawMap: {
          count: cellStyles.length
        }
      },
      children: cellStyles.map(function (cellStyle) {
        return borderFactory$1.getTemplate(cellStyle);
      })
    };
  }
};
var __assign$h = undefined && undefined.__assign || function () {
  __assign$h = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$h.apply(this, arguments);
};
var stylesMap;
var registeredNumberFmts;
var registeredFonts;
var registeredFills;
var registeredBorders;
var registeredCellStyleXfs;
var registeredCellXfs;
var registeredCellStyles;
var currentSheet;
var getStyleName = function getStyleName(name, currentSheet) {
  if (name.indexOf('mixedStyle') !== -1 && currentSheet > 1) {
    name += "_" + currentSheet;
  }
  return name;
};
var resetStylesheetValues = function resetStylesheetValues() {
  stylesMap = {
    base: 0
  };
  registeredNumberFmts = [];
  registeredFonts = [{
    fontName: 'Calibri',
    colorTheme: '1',
    family: '2',
    scheme: 'minor'
  }];
  registeredFills = [{
    patternType: 'none'
  }, {
    patternType: 'gray125'
  }];
  registeredBorders = [{
    left: undefined,
    right: undefined,
    top: undefined,
    bottom: undefined,
    diagonal: undefined
  }];
  registeredCellStyleXfs = [{
    borderId: 0,
    fillId: 0,
    fontId: 0,
    numFmtId: 0
  }];
  registeredCellXfs = [{
    borderId: 0,
    fillId: 0,
    fontId: 0,
    numFmtId: 0,
    xfId: 0
  }];
  registeredCellStyles = [{
    builtinId: 0,
    name: 'Normal',
    xfId: 0
  }];
};
var registerFill = function registerFill(fill) {
  var convertedPattern = convertLegacyPattern(fill.pattern);
  var convertedFillColor = convertLegacyColor(fill.color);
  var convertedPatternColor = convertLegacyColor(fill.patternColor);
  var pos = _.findIndex(registeredFills, function (currentFill) {
    var patternType = currentFill.patternType,
      fgRgb = currentFill.fgRgb,
      bgRgb = currentFill.bgRgb;
    if (patternType != convertedPattern || fgRgb != convertedFillColor || bgRgb != convertedPatternColor) {
      return false;
    }
    return true;
  });
  if (pos === -1) {
    pos = registeredFills.length;
    registeredFills.push({
      patternType: convertedPattern,
      fgRgb: convertedFillColor,
      bgRgb: convertedPatternColor
    });
  }
  return pos;
};
var registerNumberFmt = function registerNumberFmt(format) {
  format = _.utf8_encode(format);
  if (numberFormatMap[format]) {
    return numberFormatMap[format];
  }
  var pos = _.findIndex(registeredNumberFmts, function (currentFormat) {
    return currentFormat.formatCode === format;
  });
  if (pos === -1) {
    pos = registeredNumberFmts.length + 164;
    registeredNumberFmts.push({
      formatCode: format,
      numFmtId: pos
    });
  } else {
    pos = registeredNumberFmts[pos].numFmtId;
  }
  return pos;
};
var registerBorders = function registerBorders(borders) {
  var borderBottom = borders.borderBottom,
    borderTop = borders.borderTop,
    borderLeft = borders.borderLeft,
    borderRight = borders.borderRight;
  var bottomStyle;
  var topStyle;
  var leftStyle;
  var rightStyle;
  var bottomColor;
  var topColor;
  var leftColor;
  var rightColor;
  if (borderLeft) {
    leftStyle = convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
    leftColor = convertLegacyColor(borderLeft.color);
  }
  if (borderRight) {
    rightStyle = convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
    rightColor = convertLegacyColor(borderRight.color);
  }
  if (borderBottom) {
    bottomStyle = convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
    bottomColor = convertLegacyColor(borderBottom.color);
  }
  if (borderTop) {
    topStyle = convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
    topColor = convertLegacyColor(borderTop.color);
  }
  var pos = _.findIndex(registeredBorders, function (currentBorder) {
    var left = currentBorder.left,
      right = currentBorder.right,
      top = currentBorder.top,
      bottom = currentBorder.bottom;
    if (!left && (leftStyle || leftColor)) {
      return false;
    }
    if (!right && (rightStyle || rightColor)) {
      return false;
    }
    if (!top && (topStyle || topColor)) {
      return false;
    }
    if (!bottom && (bottomStyle || bottomColor)) {
      return false;
    }
    var _a = left || {},
      clS = _a.style,
      clC = _a.color;
    var _b = right || {},
      crS = _b.style,
      crC = _b.color;
    var _c = top || {},
      ctS = _c.style,
      ctC = _c.color;
    var _d = bottom || {},
      cbS = _d.style,
      cbC = _d.color;
    if (clS != leftStyle || clC != leftColor) {
      return false;
    }
    if (crS != rightStyle || crC != rightColor) {
      return false;
    }
    if (ctS != topStyle || ctC != topColor) {
      return false;
    }
    if (cbS != bottomStyle || cbC != bottomColor) {
      return false;
    }
    return true;
  });
  if (pos === -1) {
    pos = registeredBorders.length;
    registeredBorders.push({
      left: {
        style: leftStyle,
        color: leftColor
      },
      right: {
        style: rightStyle,
        color: rightColor
      },
      top: {
        style: topStyle,
        color: topColor
      },
      bottom: {
        style: bottomStyle,
        color: bottomColor
      },
      diagonal: {
        style: undefined,
        color: undefined
      }
    });
  }
  return pos;
};
var registerFont = function registerFont(font) {
  var _a = font.fontName,
    name = _a === void 0 ? 'Calibri' : _a,
    color = font.color,
    size = font.size,
    bold = font.bold,
    italic = font.italic,
    outline = font.outline,
    shadow = font.shadow,
    strikeThrough = font.strikeThrough,
    underline = font.underline,
    family = font.family,
    verticalAlign = font.verticalAlign;
  var utf8Name = name ? _.utf8_encode(name) : name;
  var convertedColor = convertLegacyColor(color);
  var familyId = getFontFamilyId(family);
  var convertedUnderline = underline ? underline.toLocaleLowerCase() : undefined;
  var convertedVerticalAlign = verticalAlign ? verticalAlign.toLocaleLowerCase() : undefined;
  var pos = _.findIndex(registeredFonts, function (currentFont) {
    if (currentFont.fontName != utf8Name || currentFont.color != convertedColor || currentFont.size != size || currentFont.bold != bold || currentFont.italic != italic || currentFont.outline != outline || currentFont.shadow != shadow || currentFont.strikeThrough != strikeThrough || currentFont.underline != convertedUnderline || currentFont.verticalAlign != convertedVerticalAlign ||
    // @ts-ignore
    currentFont.family != familyId) {
      return false;
    }
    return true;
  });
  if (pos === -1) {
    pos = registeredFonts.length;
    registeredFonts.push({
      fontName: utf8Name,
      color: convertedColor,
      size: size,
      bold: bold,
      italic: italic,
      outline: outline,
      shadow: shadow,
      strikeThrough: strikeThrough,
      underline: convertedUnderline,
      verticalAlign: convertedVerticalAlign,
      family: familyId != null ? familyId.toString() : undefined
    });
  }
  return pos;
};
var registerStyle = function registerStyle(config) {
  var alignment = config.alignment,
    borders = config.borders,
    font = config.font,
    interior = config.interior,
    numberFormat = config.numberFormat,
    protection = config.protection;
  var id = config.id;
  var currentFill = 0;
  var currentBorder = 0;
  var currentFont = 0;
  var currentNumberFmt = 0;
  if (!id) {
    return;
  }
  id = getStyleName(id, currentSheet);
  if (stylesMap[id] != undefined) {
    return;
  }
  if (interior) {
    currentFill = registerFill(interior);
  }
  if (borders) {
    currentBorder = registerBorders(borders);
  }
  if (font) {
    currentFont = registerFont(font);
  }
  if (numberFormat) {
    currentNumberFmt = registerNumberFmt(numberFormat.format);
  }
  stylesMap[id] = registeredCellXfs.length;
  registeredCellXfs.push({
    alignment: alignment,
    borderId: currentBorder || 0,
    fillId: currentFill || 0,
    fontId: currentFont || 0,
    numFmtId: currentNumberFmt || 0,
    protection: protection,
    xfId: 0
  });
};
var stylesheetFactory = {
  getTemplate: function getTemplate(defaultFontSize) {
    var numberFormats = numberFormatsFactory.getTemplate(registeredNumberFmts);
    var fonts = fontsFactory.getTemplate(registeredFonts.map(function (font) {
      return __assign$h(__assign$h({}, font), {
        size: font.size != null ? font.size : defaultFontSize
      });
    }));
    var fills = fillsFactory.getTemplate(registeredFills);
    var borders = bordersFactory.getTemplate(registeredBorders);
    var cellStylesXfs = cellStylesXfsFactory.getTemplate(registeredCellStyleXfs);
    var cellXfs = cellXfsFactory.getTemplate(registeredCellXfs);
    var cellStyles = cellStylesFactory.getTemplate(registeredCellStyles);
    resetStylesheetValues();
    return {
      name: 'styleSheet',
      properties: {
        rawMap: {
          'mc:Ignorable': 'x14ac x16r2 xr',
          'xmlns': 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
          'xmlns:mc': 'http://schemas.openxmlformats.org/markup-compatibility/2006',
          'xmlns:x14ac': 'http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac',
          'xmlns:x16r2': 'http://schemas.microsoft.com/office/spreadsheetml/2015/02/main',
          'xmlns:xr': 'http://schemas.microsoft.com/office/spreadsheetml/2014/revision'
        }
      },
      children: [numberFormats, fonts, fills, borders, cellStylesXfs, cellXfs, cellStyles, {
        name: 'tableStyles',
        properties: {
          rawMap: {
            count: 0,
            defaultPivotStyle: 'PivotStyleLight16',
            defaultTableStyle: 'TableStyleMedium2'
          }
        }
      }]
    };
  }
};
var getStyleId = function getStyleId(name, currentSheet) {
  return stylesMap[getStyleName(name, currentSheet)] || 0;
};
var registerStyles = function registerStyles(styles, _currentSheet) {
  currentSheet = _currentSheet;
  if (currentSheet === 1) {
    resetStylesheetValues();
  }
  styles.forEach(registerStyle);
};
var sheetFactory = {
  getTemplate: function getTemplate(name, idx) {
    var sheetId = (idx + 1).toString();
    return {
      name: "sheet",
      properties: {
        rawMap: {
          "name": name,
          "sheetId": sheetId,
          "r:id": "rId" + sheetId
        }
      }
    };
  }
};
var sheetsFactory = {
  getTemplate: function getTemplate(names) {
    return {
      name: "sheets",
      children: names.map(function (sheet, idx) {
        return sheetFactory.getTemplate(sheet, idx);
      })
    };
  }
};
var workbookFactory = {
  getTemplate: function getTemplate(names) {
    return {
      name: "workbook",
      properties: {
        prefixedAttributes: [{
          prefix: "xmlns:",
          map: {
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
          }
        }],
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
        }
      },
      children: [sheetsFactory.getTemplate(names)]
    };
  }
};

// https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-column-widths
var getExcelCellWidth = function getExcelCellWidth(width) {
  return Math.ceil((width - 12) / 7 + 1);
};
var columnFactory = {
  getTemplate: function getTemplate(config) {
    var min = config.min,
      max = config.max,
      s = config.s,
      width = config.width,
      hidden = config.hidden,
      bestFit = config.bestFit;
    var excelWidth = 1;
    var customWidth = '0';
    if (width > 1) {
      excelWidth = getExcelCellWidth(width);
      customWidth = '1';
    }
    return {
      name: 'col',
      properties: {
        rawMap: {
          min: min,
          max: max,
          width: excelWidth,
          style: s,
          hidden: hidden ? '1' : '0',
          bestFit: bestFit ? '1' : '0',
          customWidth: customWidth
        }
      }
    };
  }
};
var convertLegacyType = function convertLegacyType(type) {
  var t = type.charAt(0).toLowerCase();
  return t === 's' ? 'inlineStr' : t;
};
var cellFactory = {
  getTemplate: function getTemplate(config, idx, currentSheet) {
    var ref = config.ref,
      data = config.data,
      styleId = config.styleId;
    var type = data.type,
      value = data.value;
    var convertedType = type;
    if (type === 'f') {
      convertedType = 'str';
    } else if (type.charAt(0) === type.charAt(0).toUpperCase()) {
      convertedType = convertLegacyType(type);
    }
    var obj = {
      name: 'c',
      properties: {
        rawMap: {
          r: ref,
          t: convertedType === 'empty' ? undefined : convertedType,
          s: styleId ? getStyleId(styleId, currentSheet) : undefined
        }
      }
    };
    if (convertedType === 'empty') {
      return obj;
    }
    var children;
    if (convertedType === 'str' && type === 'f') {
      children = [{
        name: 'f',
        textNode: _.escapeString(_.utf8_encode(value))
      }];
    } else if (convertedType === 'inlineStr') {
      children = [{
        name: 'is',
        children: [{
          name: 't',
          textNode: _.escapeString(_.utf8_encode(value))
        }]
      }];
    } else {
      children = [{
        name: 'v',
        textNode: value
      }];
    }
    return _.assign({}, obj, {
      children: children
    });
  }
};
var __spreadArrays$g = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var addEmptyCells = function addEmptyCells(cells, rowIdx) {
  var mergeMap = [];
  var posCounter = 0;
  for (var i = 0; i < cells.length; i++) {
    var cell = cells[i];
    if (cell.mergeAcross) {
      mergeMap.push({
        pos: i,
        excelPos: posCounter
      });
      posCounter += cell.mergeAcross;
    }
    posCounter++;
  }
  if (mergeMap.length) {
    for (var i = mergeMap.length - 1; i >= 0; i--) {
      var mergedCells = [];
      var cell = cells[mergeMap[i].pos];
      for (var j = 1; j <= cell.mergeAcross; j++) {
        mergedCells.push({
          ref: "" + getExcelColumnName(mergeMap[i].excelPos + 1 + j) + (rowIdx + 1),
          styleId: cell.styleId,
          data: {
            type: 'empty',
            value: null
          }
        });
      }
      if (mergedCells.length) {
        cells.splice.apply(cells, __spreadArrays$g([mergeMap[i].pos + 1, 0], mergedCells));
      }
    }
  }
};
var shouldDisplayCell = function shouldDisplayCell(cell) {
  return cell.data.value !== '' || cell.styleId !== undefined;
};
var rowFactory = {
  getTemplate: function getTemplate(config, idx, currentSheet) {
    var index = config.index,
      collapsed = config.collapsed,
      hidden = config.hidden,
      height = config.height,
      s = config.s,
      _a = config.cells,
      cells = _a === void 0 ? [] : _a;
    addEmptyCells(cells, idx);
    var children = cells.filter(shouldDisplayCell).map(function (cell, idx) {
      return cellFactory.getTemplate(cell, idx, currentSheet);
    });
    return {
      name: "row",
      properties: {
        rawMap: {
          r: index,
          collapsed: collapsed,
          hidden: hidden ? '1' : '0',
          ht: height,
          customHeight: height != null ? '1' : '0',
          s: s,
          customFormat: s != null ? '1' : '0'
        }
      },
      children: children
    };
  }
};
var mergeCellFactory = {
  getTemplate: function getTemplate(ref) {
    return {
      name: 'mergeCell',
      properties: {
        rawMap: {
          ref: ref
        }
      }
    };
  }
};
var updateColMinMax = function updateColMinMax(col, min, range, prevCol) {
  if (!col.min) {
    col.min = min;
    col.max = min + range;
    return;
  }
  var currentMin = min;
  if (prevCol) {
    currentMin = Math.max(currentMin, prevCol.min);
  }
  col.min = Math.max(col.min, currentMin);
  col.max = Math.max(col.max, currentMin + range);
};
var getMergedCells = function getMergedCells(rows, cols) {
  var mergedCells = [];
  rows.forEach(function (currentRow, rowIdx) {
    var cells = currentRow.cells;
    var merges = 0;
    currentRow.index = rowIdx + 1;
    var lastCol;
    cells.forEach(function (currentCell, cellIdx) {
      var min = cellIdx + merges + 1;
      var start = getExcelColumnName(min);
      var outputRow = rowIdx + 1;
      if (currentCell.mergeAcross) {
        merges += currentCell.mergeAcross;
        var end = getExcelColumnName(cellIdx + merges + 1);
        mergedCells.push("" + start + outputRow + ":" + end + outputRow);
      }
      if (!cols[min - 1]) {
        cols[min - 1] = {};
      }
      updateColMinMax(cols[min - 1], min, merges, lastCol);
      lastCol = cols[min - 1];
      currentCell.ref = "" + start + outputRow;
    });
  });
  return mergedCells;
};
var getPageOrientation = function getPageOrientation(orientation) {
  if (!orientation || orientation !== 'Portrait' && orientation !== 'Landscape') {
    return 'portrait';
  }
  return orientation.toLocaleLowerCase();
};
var getPageSize = function getPageSize(pageSize) {
  if (pageSize == null) {
    return 1;
  }
  var positions = ['Letter', 'Letter Small', 'Tabloid', 'Ledger', 'Legal', 'Statement', 'Executive', 'A3', 'A4', 'A4 Small', 'A5', 'A6', 'B4', 'B5', 'Folio', 'Envelope', 'Envelope DL', 'Envelope C5', 'Envelope B5', 'Envelope C3', 'Envelope C4', 'Envelope C6', 'Envelope Monarch', 'Japanese Postcard', 'Japanese Double Postcard'];
  var pos = positions.indexOf(pageSize);
  return pos === -1 ? 1 : pos + 1;
};
var addColumns = function addColumns(columns) {
  return function (children) {
    if (columns.length) {
      children.push({
        name: 'cols',
        children: columns.map(function (column) {
          return columnFactory.getTemplate(column);
        })
      });
    }
    return children;
  };
};
var addSheetData = function addSheetData(rows, sheetNumber) {
  return function (children) {
    if (rows.length) {
      children.push({
        name: 'sheetData',
        children: rows.map(function (row, idx) {
          return rowFactory.getTemplate(row, idx, sheetNumber);
        })
      });
    }
    return children;
  };
};
var addMergeCells = function addMergeCells(mergeCells) {
  return function (children) {
    if (mergeCells.length) {
      children.push({
        name: 'mergeCells',
        properties: {
          rawMap: {
            count: mergeCells.length
          }
        },
        children: mergeCells.map(function (mergedCell) {
          return mergeCellFactory.getTemplate(mergedCell);
        })
      });
    }
    return children;
  };
};
var addPageMargins = function addPageMargins(margins) {
  return function (children) {
    var _a = margins.top,
      top = _a === void 0 ? 0.75 : _a,
      _b = margins.right,
      right = _b === void 0 ? 0.7 : _b,
      _c = margins.bottom,
      bottom = _c === void 0 ? 0.75 : _c,
      _d = margins.left,
      left = _d === void 0 ? 0.7 : _d,
      _e = margins.header,
      header = _e === void 0 ? 0.3 : _e,
      _f = margins.footer,
      footer = _f === void 0 ? 0.3 : _f;
    children.push({
      name: 'pageMargins',
      properties: {
        rawMap: {
          bottom: bottom,
          footer: footer,
          header: header,
          left: left,
          right: right,
          top: top
        }
      }
    });
    return children;
  };
};
var addPageSetup = function addPageSetup(pageSetup) {
  return function (children) {
    if (pageSetup) {
      children.push({
        name: 'pageSetup',
        properties: {
          rawMap: {
            horizontalDpi: 0,
            verticalDpi: 0,
            orientation: getPageOrientation(pageSetup.orientation),
            paperSize: getPageSize(pageSetup.pageSize)
          }
        }
      });
    }
    return children;
  };
};
var replaceHeaderFooterTokens = function replaceHeaderFooterTokens(value) {
  var map = {
    '&[Page]': '&P',
    '&[Pages]': '&N',
    '&[Date]': '&D',
    '&[Time]': '&T',
    '&[Tab]': '&A',
    '&[Path]': '&Z',
    '&[File]': '&F'
  };
  _.iterateObject(map, function (key, val) {
    value = value.replace(key, val);
  });
  return value;
};
var getHeaderPosition = function getHeaderPosition(position) {
  if (position === 'Center') {
    return 'C';
  } else if (position === 'Right') {
    return 'R';
  }
  return 'L';
};
var applyHeaderFontStyle = function applyHeaderFontStyle(headerString, font) {
  if (!font) {
    return headerString;
  }
  headerString += '&amp;&quot;';
  headerString += font.fontName || 'Calibri';
  if (font.bold !== font.italic) {
    headerString += font.bold ? ',Bold' : ',Italic';
  } else if (font.bold) {
    headerString += ',Bold Italic';
  } else {
    headerString += ',Regular';
  }
  headerString += '&quot;';
  if (font.size) {
    headerString += "&amp;" + font.size;
  }
  if (font.strikeThrough) {
    headerString += '&amp;S';
  }
  if (font.underline) {
    headerString += "&amp;" + (font.underline === 'Double' ? 'E' : 'U');
  }
  if (font.color) {
    headerString += "&amp;K" + font.color.replace('#', '').toUpperCase();
  }
  return headerString;
};
var processHeaderFooterContent = function processHeaderFooterContent(content) {
  return content.reduce(function (prev, curr) {
    var pos = getHeaderPosition(curr.position);
    var output = applyHeaderFontStyle(prev + "&amp;" + pos, curr.font);
    return "" + output + _.escapeString(replaceHeaderFooterTokens(curr.value));
  }, '');
};
var buildHeaderFooter = function buildHeaderFooter(headerFooterConfig) {
  var rules = ['all', 'first', 'even'];
  var headersAndFooters = [];
  rules.forEach(function (rule) {
    var headerFooter = headerFooterConfig[rule];
    var namePrefix = rule === 'all' ? 'odd' : rule;
    if (!headerFooter || !headerFooter.header && !headerFooter.footer) {
      return;
    }
    _.iterateObject(headerFooter, function (key, value) {
      var nameSuffix = "" + key.charAt(0).toUpperCase() + key.slice(1);
      if (value) {
        headersAndFooters.push({
          name: "" + namePrefix + nameSuffix,
          properties: {
            rawMap: {
              'xml:space': 'preserve'
            }
          },
          textNode: processHeaderFooterContent(value)
        });
      }
    });
  });
  return headersAndFooters;
};
var addHeaderFooter = function addHeaderFooter(headerFooterConfig) {
  return function (children) {
    if (!headerFooterConfig) {
      return children;
    }
    var differentFirst = headerFooterConfig.first != null ? 1 : 0;
    var differentOddEven = headerFooterConfig.even != null ? 1 : 0;
    children.push({
      name: 'headerFooter',
      properties: {
        rawMap: {
          differentFirst: differentFirst,
          differentOddEven: differentOddEven
        }
      },
      children: buildHeaderFooter(headerFooterConfig)
    });
    return children;
  };
};
var addDrawingRel = function addDrawingRel(currentSheet) {
  return function (children) {
    if (ExcelXlsxFactory.worksheetImages.get(currentSheet)) {
      children.push({
        name: 'drawing',
        properties: {
          rawMap: {
            'r:id': 'rId1'
          }
        }
      });
    }
    return children;
  };
};
var worksheetFactory = {
  getTemplate: function getTemplate(params) {
    var worksheet = params.worksheet,
      currentSheet = params.currentSheet,
      _a = params.margins,
      margins = _a === void 0 ? {} : _a,
      pageSetup = params.pageSetup,
      headerFooterConfig = params.headerFooterConfig;
    var table = worksheet.table;
    var rows = table.rows,
      columns = table.columns;
    var mergedCells = columns && columns.length ? getMergedCells(rows, columns) : [];
    var createWorksheetChildren = _.compose(addColumns(columns), addSheetData(rows, currentSheet + 1), addMergeCells(mergedCells), addPageMargins(margins), addPageSetup(pageSetup), addHeaderFooter(headerFooterConfig), addDrawingRel(currentSheet));
    var children = createWorksheetChildren([]);
    return {
      name: "worksheet",
      properties: {
        prefixedAttributes: [{
          prefix: "xmlns:",
          map: {
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
          }
        }],
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
        }
      },
      children: children
    };
  }
};
var relationshipFactory = {
  getTemplate: function getTemplate(config) {
    var Id = config.Id,
      Type = config.Type,
      Target = config.Target;
    return {
      name: "Relationship",
      properties: {
        rawMap: {
          Id: Id,
          Type: Type,
          Target: Target
        }
      }
    };
  }
};
var relationshipsFactory = {
  getTemplate: function getTemplate(c) {
    var children = c.map(function (relationship) {
      return relationshipFactory.getTemplate(relationship);
    });
    return {
      name: "Relationships",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
        }
      },
      children: children
    };
  }
};
var __spreadArrays$h = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
/**
 * See https://www.ecma-international.org/news/TC45_current_work/OpenXML%20White%20Paper.pdf
 */
var ExcelXlsxFactory = /** @class */function () {
  function ExcelXlsxFactory() {}
  ExcelXlsxFactory.createExcel = function (styles, worksheet, margins, pageSetup, headerFooterConfig) {
    this.addSheetName(worksheet);
    registerStyles(styles, this.sheetNames.length);
    return this.createWorksheet(worksheet, margins, pageSetup, headerFooterConfig);
  };
  ExcelXlsxFactory.buildImageMap = function (image, rowIndex, col, columnsToExport, rowHeight) {
    var currentSheetIndex = this.sheetNames.length;
    var registeredImage = this.images.get(image.id);
    if (!image.position || !image.position.row || !image.position.column) {
      if (!image.position) {
        image.position = {};
      }
      image.position = _.assign({}, image.position, {
        row: rowIndex,
        column: columnsToExport.indexOf(col) + 1
      });
    }
    var calculatedImage = image;
    setExcelImageTotalWidth(calculatedImage, columnsToExport);
    setExcelImageTotalHeight(calculatedImage, rowHeight);
    if (registeredImage) {
      var currentSheetImages = _.find(registeredImage, function (currentImage) {
        return currentImage.sheetId === currentSheetIndex;
      });
      if (currentSheetImages) {
        currentSheetImages.image.push(calculatedImage);
      } else {
        registeredImage.push({
          sheetId: currentSheetIndex,
          image: [calculatedImage]
        });
      }
    } else {
      this.images.set(calculatedImage.id, [{
        sheetId: currentSheetIndex,
        image: [calculatedImage]
      }]);
      this.workbookImageIds.set(calculatedImage.id, {
        type: calculatedImage.imageType,
        index: this.workbookImageIds.size
      });
    }
    this.buildSheetImageMap(currentSheetIndex, calculatedImage);
  };
  ExcelXlsxFactory.buildSheetImageMap = function (sheetIndex, image) {
    var worksheetImageIdMap = this.worksheetImageIds.get(sheetIndex);
    if (!worksheetImageIdMap) {
      worksheetImageIdMap = new Map();
      this.worksheetImageIds.set(sheetIndex, worksheetImageIdMap);
    }
    var sheetImages = this.worksheetImages.get(sheetIndex);
    if (!sheetImages) {
      this.worksheetImages.set(sheetIndex, [image]);
      worksheetImageIdMap.set(image.id, {
        index: 0,
        type: image.imageType
      });
    } else {
      sheetImages.push(image);
      if (!worksheetImageIdMap.get(image.id)) {
        worksheetImageIdMap.set(image.id, {
          index: worksheetImageIdMap.size,
          type: image.imageType
        });
      }
    }
  };
  ExcelXlsxFactory.addSheetName = function (worksheet) {
    var name = worksheet.name;
    var append = '';
    while (this.sheetNames.indexOf(name + append) !== -1) {
      if (append === '') {
        append = '_1';
      } else {
        var curr = parseInt(append.slice(1), 10);
        append = "_" + (curr + 1);
      }
    }
    worksheet.name += append;
    this.sheetNames.push(worksheet.name);
  };
  ExcelXlsxFactory.getStringPosition = function (str) {
    if (this.sharedStrings.has(str)) {
      return this.sharedStrings.get(str);
    }
    this.sharedStrings.set(str, this.sharedStrings.size);
    return this.sharedStrings.size - 1;
  };
  ExcelXlsxFactory.resetFactory = function () {
    this.sharedStrings = new Map();
    this.images = new Map();
    this.worksheetImages = new Map();
    this.workbookImageIds = new Map();
    this.worksheetImageIds = new Map();
    this.sheetNames = [];
    this.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
  };
  ExcelXlsxFactory.createWorkbook = function () {
    return createXmlPart(workbookFactory.getTemplate(this.sheetNames));
  };
  ExcelXlsxFactory.createStylesheet = function (defaultFontSize) {
    return createXmlPart(stylesheetFactory.getTemplate(defaultFontSize));
  };
  ExcelXlsxFactory.createSharedStrings = function () {
    return createXmlPart(sharedStrings.getTemplate(this.sharedStrings));
  };
  ExcelXlsxFactory.createCore = function (author) {
    return createXmlPart(coreFactory.getTemplate(author));
  };
  ExcelXlsxFactory.createContentTypes = function (sheetLen) {
    return createXmlPart(contentTypesFactory.getTemplate(sheetLen));
  };
  ExcelXlsxFactory.createRels = function () {
    var rs = relationshipsFactory.getTemplate([{
      Id: 'rId1',
      Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument',
      Target: 'xl/workbook.xml'
    }, {
      Id: 'rId2',
      Type: 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties',
      Target: 'docProps/core.xml'
    }]);
    return createXmlPart(rs);
  };
  ExcelXlsxFactory.createTheme = function () {
    return createXmlPart(officeTheme.getTemplate());
  };
  ExcelXlsxFactory.createWorkbookRels = function (sheetLen) {
    var worksheets = _.fill(new Array(sheetLen), undefined).map(function (v, i) {
      return {
        Id: "rId" + (i + 1),
        Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet',
        Target: "worksheets/sheet" + (i + 1) + ".xml"
      };
    });
    var rs = relationshipsFactory.getTemplate(__spreadArrays$h(worksheets, [{
      Id: "rId" + (sheetLen + 1),
      Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme',
      Target: 'theme/theme1.xml'
    }, {
      Id: "rId" + (sheetLen + 2),
      Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles',
      Target: 'styles.xml'
    }, {
      Id: "rId" + (sheetLen + 3),
      Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings',
      Target: 'sharedStrings.xml'
    }]));
    return createXmlPart(rs);
  };
  ExcelXlsxFactory.createDrawing = function (sheetIndex) {
    return createXmlPart(drawingFactory.getTemplate({
      sheetIndex: sheetIndex
    }));
  };
  ExcelXlsxFactory.createDrawingRel = function (sheetIndex) {
    var _this = this;
    var worksheetImageIds = this.worksheetImageIds.get(sheetIndex);
    var XMLArr = [];
    worksheetImageIds.forEach(function (value, key) {
      XMLArr.push({
        Id: "rId" + (value.index + 1),
        Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image',
        Target: "../media/image" + (_this.workbookImageIds.get(key).index + 1) + "." + value.type
      });
    });
    return createXmlPart(relationshipsFactory.getTemplate(XMLArr));
  };
  ExcelXlsxFactory.createWorksheetDrawingRel = function (currentRelationIndex) {
    var rs = relationshipsFactory.getTemplate([{
      Id: 'rId1',
      Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing',
      Target: "../drawings/drawing" + (currentRelationIndex + 1) + ".xml"
    }]);
    return createXmlPart(rs);
  };
  ExcelXlsxFactory.createWorksheet = function (worksheet, margins, pageSetup, headerFooterConfig) {
    return createXmlPart(worksheetFactory.getTemplate({
      worksheet: worksheet,
      currentSheet: this.sheetNames.length - 1,
      margins: margins,
      pageSetup: pageSetup,
      headerFooterConfig: headerFooterConfig
    }));
  };
  ExcelXlsxFactory.sharedStrings = new Map();
  ExcelXlsxFactory.sheetNames = [];
  /** Maps images to sheet */
  ExcelXlsxFactory.images = new Map();
  /** Maps sheets to images */
  ExcelXlsxFactory.worksheetImages = new Map();
  /** Maps all workbook images to a global Id */
  ExcelXlsxFactory.workbookImageIds = new Map();
  /** Maps all sheet images to unique Ids */
  ExcelXlsxFactory.worksheetImageIds = new Map();
  ExcelXlsxFactory.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
  return ExcelXlsxFactory;
}();
var __extends$3k = undefined && undefined.__extends || function () {
  var _extendStatics221 = function extendStatics(d, b) {
    _extendStatics221 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics221(d, b);
  };
  return function (d, b) {
    _extendStatics221(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ExcelXlsxSerializingSession = /** @class */function (_super) {
  __extends$3k(ExcelXlsxSerializingSession, _super);
  function ExcelXlsxSerializingSession() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ExcelXlsxSerializingSession.prototype.createExcel = function (data) {
    var _a = this,
      excelStyles = _a.excelStyles,
      config = _a.config;
    var margins = config.margins,
      pageSetup = config.pageSetup,
      headerFooterConfig = config.headerFooterConfig;
    return ExcelXlsxFactory.createExcel(excelStyles, data, margins, pageSetup, headerFooterConfig);
  };
  ExcelXlsxSerializingSession.prototype.getDataTypeForValue = function (valueForCell) {
    if (valueForCell === undefined) {
      return 'empty';
    }
    return _.isNumeric(valueForCell) ? 'n' : 's';
  };
  ExcelXlsxSerializingSession.prototype.getType = function (type, style, value) {
    if (this.isFormula(value)) {
      return 'f';
    }
    if (style && style.dataType) {
      switch (style.dataType.toLocaleLowerCase()) {
        case 'formula':
          return 'f';
        case 'string':
          return 's';
        case 'number':
          return 'n';
        case 'datetime':
          return 'd';
        case 'error':
          return 'e';
        case 'boolean':
          return 'b';
        default:
          console.warn("ag-grid: Unrecognized data type for excel export [" + style.id + ".dataType=" + style.dataType + "]");
      }
    }
    return type;
  };
  ExcelXlsxSerializingSession.prototype.addImage = function (rowIndex, column, value) {
    if (!this.config.addImageToCell) {
      return;
    }
    var addedImage = this.config.addImageToCell(rowIndex, column, value);
    if (!addedImage) {
      return;
    }
    ExcelXlsxFactory.buildImageMap(addedImage.image, rowIndex, column, this.columnsToExport, this.config.rowHeight);
    return addedImage;
  };
  ExcelXlsxSerializingSession.prototype.createCell = function (styleId, type, value) {
    var actualStyle = this.getStyleById(styleId);
    var typeTransformed = this.getType(type, actualStyle, value) || type;
    return {
      styleId: actualStyle ? styleId : undefined,
      data: {
        type: typeTransformed,
        value: this.getCellValue(typeTransformed, value)
      }
    };
  };
  ExcelXlsxSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
    var valueToUse = value == null ? '' : value;
    return {
      styleId: !!this.getStyleById(styleId) ? styleId : undefined,
      data: {
        type: type,
        value: type === 's' ? ExcelXlsxFactory.getStringPosition(valueToUse).toString() : value
      },
      mergeAcross: numOfCells
    };
  };
  ExcelXlsxSerializingSession.prototype.getCellValue = function (type, value) {
    if (value == null) {
      return ExcelXlsxFactory.getStringPosition('').toString();
    }
    switch (type) {
      case 's':
        return value === '' ? '' : ExcelXlsxFactory.getStringPosition(value).toString();
      case 'f':
        return value.slice(1);
      case 'n':
        return Number(value).toString();
      default:
        return value;
    }
  };
  return ExcelXlsxSerializingSession;
}(BaseExcelSerializingSession);
var __extends$3l = undefined && undefined.__extends || function () {
  var _extendStatics222 = function extendStatics(d, b) {
    _extendStatics222 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics222(d, b);
  };
  return function (d, b) {
    _extendStatics222(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$i = undefined && undefined.__assign || function () {
  __assign$i = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$i.apply(this, arguments);
};
var __decorate$2Z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var getMultipleSheetsAsExcel = function getMultipleSheetsAsExcel(params) {
  var data = params.data,
    _a = params.fontSize,
    fontSize = _a === void 0 ? 11 : _a,
    _b = params.author,
    author = _b === void 0 ? 'AG Grid' : _b;
  var hasImages = ExcelXlsxFactory.images.size > 0;
  ZipContainer.addFolders(['_rels/', 'docProps/', 'xl/', 'xl/theme/', 'xl/_rels/', 'xl/worksheets/']);
  if (hasImages) {
    ZipContainer.addFolders(['xl/worksheets/_rels', 'xl/drawings/', 'xl/drawings/_rels', 'xl/media/']);
    var imgCounter_1 = 0;
    ExcelXlsxFactory.images.forEach(function (value) {
      var firstImage = value[0].image[0];
      var ext = firstImage.imageType;
      ZipContainer.addFile("xl/media/image" + ++imgCounter_1 + "." + ext, firstImage.base64, true);
    });
  }
  if (!data || data.length === 0) {
    console.warn("AG Grid: Invalid params supplied to getMultipleSheetsAsExcel() - `ExcelExportParams.data` is empty.");
    ExcelXlsxFactory.resetFactory();
    return;
  }
  var sheetLen = data.length;
  var imageRelationCounter = 0;
  data.forEach(function (value, idx) {
    ZipContainer.addFile("xl/worksheets/sheet" + (idx + 1) + ".xml", value);
    if (hasImages && ExcelXlsxFactory.worksheetImages.get(idx)) {
      createImageRelationsForSheet(idx, imageRelationCounter++);
    }
  });
  ZipContainer.addFile('xl/workbook.xml', ExcelXlsxFactory.createWorkbook());
  ZipContainer.addFile('xl/styles.xml', ExcelXlsxFactory.createStylesheet(fontSize));
  ZipContainer.addFile('xl/sharedStrings.xml', ExcelXlsxFactory.createSharedStrings());
  ZipContainer.addFile('xl/theme/theme1.xml', ExcelXlsxFactory.createTheme());
  ZipContainer.addFile('xl/_rels/workbook.xml.rels', ExcelXlsxFactory.createWorkbookRels(sheetLen));
  ZipContainer.addFile('docProps/core.xml', ExcelXlsxFactory.createCore(author));
  ZipContainer.addFile('[Content_Types].xml', ExcelXlsxFactory.createContentTypes(sheetLen));
  ZipContainer.addFile('_rels/.rels', ExcelXlsxFactory.createRels());
  ExcelXlsxFactory.resetFactory();
  return ZipContainer.getContent('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
};
var exportMultipleSheetsAsExcel = function exportMultipleSheetsAsExcel(params) {
  var _a = params.fileName,
    fileName = _a === void 0 ? 'export.xlsx' : _a;
  var contents = getMultipleSheetsAsExcel(params);
  if (contents) {
    Downloader.download(fileName, contents);
  }
};
var createImageRelationsForSheet = function createImageRelationsForSheet(sheetIndex, currentRelationIndex) {
  var drawingFolder = 'xl/drawings';
  var drawingFileName = drawingFolder + "/drawing" + (currentRelationIndex + 1) + ".xml";
  var relFileName = drawingFolder + "/_rels/drawing" + (currentRelationIndex + 1) + ".xml.rels";
  var worksheetRelFile = "xl/worksheets/_rels/sheet" + (sheetIndex + 1) + ".xml.rels";
  ZipContainer.addFile(relFileName, ExcelXlsxFactory.createDrawingRel(sheetIndex));
  ZipContainer.addFile(drawingFileName, ExcelXlsxFactory.createDrawing(sheetIndex));
  ZipContainer.addFile(worksheetRelFile, ExcelXlsxFactory.createWorksheetDrawingRel(currentRelationIndex));
};
var ExcelCreator = /** @class */function (_super) {
  __extends$3l(ExcelCreator, _super);
  function ExcelCreator() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.exportMode = 'xlsx';
    return _this;
  }
  ExcelCreator.prototype.postConstruct = function () {
    this.setBeans({
      gridSerializer: this.gridSerializer,
      gridOptionsWrapper: this.gridOptionsWrapper
    });
  };
  ExcelCreator.prototype.getDefaultExportParams = function () {
    return this.gridOptionsWrapper.getDefaultExportParams('excel');
  };
  ExcelCreator.prototype.export = function (userParams) {
    if (this.isExportSuppressed()) {
      console.warn("ag-grid: Export cancelled. Export is not allowed as per your configuration.");
      return '';
    }
    var _a = this.getMergedParamsAndData(userParams),
      mergedParams = _a.mergedParams,
      data = _a.data;
    var packageFile = this.packageFile({
      data: [data],
      fontSize: mergedParams.fontSize,
      author: mergedParams.author
    });
    if (packageFile) {
      Downloader.download(this.getFileName(mergedParams.fileName), packageFile);
    }
    return data;
  };
  ExcelCreator.prototype.exportDataAsExcel = function (params) {
    var exportMode = 'xlsx';
    if (params && params.exportMode) {
      exportMode = params.exportMode;
    }
    this.setExportMode(exportMode);
    return this.export(params);
  };
  ExcelCreator.prototype.getDataAsExcel = function (params) {
    var _a = this.getMergedParamsAndData(params),
      mergedParams = _a.mergedParams,
      data = _a.data;
    if (params && params.exportMode === 'xml') {
      return data;
    }
    return this.packageFile({
      data: [data],
      fontSize: mergedParams.fontSize,
      author: mergedParams.author
    });
  };
  ExcelCreator.prototype.setFactoryMode = function (factoryMode, exportMode) {
    if (exportMode === void 0) {
      exportMode = 'xlsx';
    }
    var factory = exportMode === 'xlsx' ? ExcelXlsxFactory : ExcelXmlFactory;
    factory.factoryMode = factoryMode;
  };
  ExcelCreator.prototype.getFactoryMode = function (exportMode) {
    var factory = exportMode === 'xlsx' ? ExcelXlsxFactory : ExcelXmlFactory;
    return factory.factoryMode;
  };
  ExcelCreator.prototype.getSheetDataForExcel = function (params) {
    return this.getMergedParamsAndData(params).data;
  };
  ExcelCreator.prototype.getMultipleSheetsAsExcel = function (params) {
    return getMultipleSheetsAsExcel(params);
  };
  ExcelCreator.prototype.exportMultipleSheetsAsExcel = function (params) {
    return exportMultipleSheetsAsExcel(params);
  };
  ExcelCreator.prototype.getMimeType = function () {
    return this.getExportMode() === 'xml' ? 'application/vnd.ms-excel' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  };
  ExcelCreator.prototype.getDefaultFileName = function () {
    return "export." + this.getExportMode();
  };
  ExcelCreator.prototype.getDefaultFileExtension = function () {
    return this.getExportMode();
  };
  ExcelCreator.prototype.createSerializingSession = function (params) {
    var _a = this,
      columnModel = _a.columnModel,
      valueService = _a.valueService,
      gridOptionsWrapper = _a.gridOptionsWrapper;
    var isXlsx = this.getExportMode() === 'xlsx';
    var sheetName = 'ag-grid';
    if (params.sheetName != null) {
      sheetName = _.utf8_encode(params.sheetName.toString().substr(0, 31));
    }
    var config = __assign$i(__assign$i({}, params), {
      sheetName: sheetName,
      columnModel: columnModel,
      valueService: valueService,
      gridOptionsWrapper: gridOptionsWrapper,
      headerRowHeight: params.headerRowHeight || params.rowHeight,
      baseExcelStyles: this.gridOptions.excelStyles || [],
      styleLinker: this.styleLinker.bind(this)
    });
    return new (isXlsx ? ExcelXlsxSerializingSession : ExcelXmlSerializingSession)(config);
  };
  ExcelCreator.prototype.styleLinker = function (rowType, rowIndex, value, column, node) {
    if (rowType === RowType$1.HEADER) {
      return ["header"];
    }
    if (rowType === RowType$1.HEADER_GROUPING) {
      return ["header", "headerGroup"];
    }
    var styles = this.gridOptions.excelStyles;
    var applicableStyles = ["cell"];
    if (!styles || !styles.length) {
      return applicableStyles;
    }
    var styleIds = styles.map(function (it) {
      return it.id;
    });
    this.stylingService.processAllCellClasses(column.getColDef(), {
      value: value,
      data: node.data,
      node: node,
      colDef: column.getColDef(),
      rowIndex: rowIndex,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      $scope: null,
      context: this.gridOptionsWrapper.getContext()
    }, function (className) {
      if (styleIds.indexOf(className) > -1) {
        applicableStyles.push(className);
      }
    });
    return applicableStyles.sort(function (left, right) {
      return styleIds.indexOf(left) < styleIds.indexOf(right) ? -1 : 1;
    });
  };
  ExcelCreator.prototype.isExportSuppressed = function () {
    return this.gridOptionsWrapper.isSuppressExcelExport();
  };
  ExcelCreator.prototype.setExportMode = function (exportMode) {
    this.exportMode = exportMode;
  };
  ExcelCreator.prototype.getExportMode = function () {
    return this.exportMode;
  };
  ExcelCreator.prototype.packageFile = function (params) {
    if (this.getExportMode() === 'xml') {
      return new Blob(["\uFEFF", params.data[0]], {
        // @ts-ignore
        type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
      });
    }
    return getMultipleSheetsAsExcel(params);
  };
  __decorate$2Z([Autowired('columnModel')], ExcelCreator.prototype, "columnModel", void 0);
  __decorate$2Z([Autowired('valueService')], ExcelCreator.prototype, "valueService", void 0);
  __decorate$2Z([Autowired('gridOptions')], ExcelCreator.prototype, "gridOptions", void 0);
  __decorate$2Z([Autowired('stylingService')], ExcelCreator.prototype, "stylingService", void 0);
  __decorate$2Z([Autowired('gridSerializer')], ExcelCreator.prototype, "gridSerializer", void 0);
  __decorate$2Z([Autowired('gridOptionsWrapper')], ExcelCreator.prototype, "gridOptionsWrapper", void 0);
  __decorate$2Z([PostConstruct], ExcelCreator.prototype, "postConstruct", null);
  ExcelCreator = __decorate$2Z([Bean('excelCreator')], ExcelCreator);
  return ExcelCreator;
}(BaseCreator);
var ExcelExportModule = {
  moduleName: ModuleNames.ExcelExportModule,
  beans: [
  // beans in this module
  ExcelCreator,
  // these beans are part of CSV Export module
  GridSerializer, CsvCreator],
  dependantModules: [CsvExportModule, EnterpriseCoreModule]
};
var __extends$3m = undefined && undefined.__extends || function () {
  var _extendStatics223 = function extendStatics(d, b) {
    _extendStatics223 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics223(d, b);
  };
  return function (d, b) {
    _extendStatics223(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2_ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EXPAND_STATE;
(function (EXPAND_STATE) {
  EXPAND_STATE[EXPAND_STATE["EXPANDED"] = 0] = "EXPANDED";
  EXPAND_STATE[EXPAND_STATE["COLLAPSED"] = 1] = "COLLAPSED";
  EXPAND_STATE[EXPAND_STATE["INDETERMINATE"] = 2] = "INDETERMINATE";
})(EXPAND_STATE || (EXPAND_STATE = {}));
var FiltersToolPanelHeaderPanel = /** @class */function (_super) {
  __extends$3m(FiltersToolPanelHeaderPanel, _super);
  function FiltersToolPanelHeaderPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FiltersToolPanelHeaderPanel.prototype.preConstruct = function () {
    this.setTemplate( /* html */"<div class=\"ag-filter-toolpanel-search\" role=\"presentation\">\n                <div ref=\"eExpand\" class=\"ag-filter-toolpanel-expand\"></div>\n                <ag-input-text-field ref=\"eFilterTextField\" class=\"ag-filter-toolpanel-search-input\"></ag-input-text-field>\n            </div>");
  };
  FiltersToolPanelHeaderPanel.prototype.postConstruct = function () {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFilterTextField.onValueChange(this.onSearchTextChanged.bind(this));
    this.eFilterTextField.setInputAriaLabel(translate('ariaFilterColumnsInput', 'Filter Columns Input'));
    this.createExpandIcons();
    this.setExpandState(EXPAND_STATE.EXPANDED);
    this.addManagedListener(this.eExpand, 'click', this.onExpandClicked.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
  };
  FiltersToolPanelHeaderPanel.prototype.init = function (params) {
    this.params = params;
    if (this.columnModel.isReady()) {
      this.showOrHideOptions();
    }
  };
  FiltersToolPanelHeaderPanel.prototype.createExpandIcons = function () {
    this.eExpand.appendChild(this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsWrapper));
    this.eExpand.appendChild(this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsWrapper));
    this.eExpand.appendChild(this.eExpandIndeterminate = _.createIconNoSpan('columnSelectIndeterminate', this.gridOptionsWrapper));
  };
  // we only show expand / collapse if we are showing filters
  FiltersToolPanelHeaderPanel.prototype.showOrHideOptions = function () {
    var showFilterSearch = !this.params.suppressFilterSearch;
    var showExpand = !this.params.suppressExpandAll;
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFilterTextField.setInputPlaceholder(translate('searchOoo', 'Search...'));
    var isFilterGroupPresent = function isFilterGroupPresent(col) {
      return col.getOriginalParent() && col.isFilterAllowed();
    };
    var filterGroupsPresent = this.columnModel.getAllGridColumns().some(isFilterGroupPresent);
    _.setDisplayed(this.eFilterTextField.getGui(), showFilterSearch);
    _.setDisplayed(this.eExpand, showExpand && filterGroupsPresent);
  };
  FiltersToolPanelHeaderPanel.prototype.onSearchTextChanged = function () {
    var _this = this;
    if (!this.onSearchTextChangedDebounced) {
      this.onSearchTextChangedDebounced = _.debounce(function () {
        _this.dispatchEvent({
          type: 'searchChanged',
          searchText: _this.eFilterTextField.getValue()
        });
      }, 300);
    }
    this.onSearchTextChangedDebounced();
  };
  FiltersToolPanelHeaderPanel.prototype.onExpandClicked = function () {
    var event = this.currentExpandState === EXPAND_STATE.EXPANDED ? {
      type: 'collapseAll'
    } : {
      type: 'expandAll'
    };
    this.dispatchEvent(event);
  };
  FiltersToolPanelHeaderPanel.prototype.setExpandState = function (state) {
    this.currentExpandState = state;
    _.setDisplayed(this.eExpandChecked, this.currentExpandState === EXPAND_STATE.EXPANDED);
    _.setDisplayed(this.eExpandUnchecked, this.currentExpandState === EXPAND_STATE.COLLAPSED);
    _.setDisplayed(this.eExpandIndeterminate, this.currentExpandState === EXPAND_STATE.INDETERMINATE);
  };
  __decorate$2_([Autowired('columnModel')], FiltersToolPanelHeaderPanel.prototype, "columnModel", void 0);
  __decorate$2_([RefSelector('eExpand')], FiltersToolPanelHeaderPanel.prototype, "eExpand", void 0);
  __decorate$2_([RefSelector('eFilterTextField')], FiltersToolPanelHeaderPanel.prototype, "eFilterTextField", void 0);
  __decorate$2_([PreConstruct], FiltersToolPanelHeaderPanel.prototype, "preConstruct", null);
  __decorate$2_([PostConstruct], FiltersToolPanelHeaderPanel.prototype, "postConstruct", null);
  return FiltersToolPanelHeaderPanel;
}(Component);
var __extends$3n = undefined && undefined.__extends || function () {
  var _extendStatics224 = function extendStatics(d, b) {
    _extendStatics224 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics224(d, b);
  };
  return function (d, b) {
    _extendStatics224(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$2$ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelFilterComp = /** @class */function (_super) {
  __extends$3n(ToolPanelFilterComp, _super);
  function ToolPanelFilterComp(hideHeader) {
    if (hideHeader === void 0) {
      hideHeader = false;
    }
    var _this = _super.call(this, ToolPanelFilterComp.TEMPLATE) || this;
    _this.expanded = false;
    _this.hideHeader = hideHeader;
    return _this;
  }
  ToolPanelFilterComp.prototype.postConstruct = function () {
    this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsWrapper);
    this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsWrapper);
    this.eExpand.appendChild(this.eExpandChecked);
    this.eExpand.appendChild(this.eExpandUnchecked);
  };
  ToolPanelFilterComp.prototype.setColumn = function (column) {
    var _this = this;
    this.column = column;
    this.eFilterName.innerText = this.columnModel.getDisplayNameForColumn(this.column, 'filterToolPanel', false) || '';
    this.addManagedListener(this.eFilterToolPanelHeader, 'click', this.toggleExpanded.bind(this));
    this.addManagedListener(this.eFilterToolPanelHeader, 'keydown', function (e) {
      if (e.keyCode === KeyCode.ENTER) {
        _this.toggleExpanded();
      }
    });
    this.addManagedListener(this.eventService, Events.EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
    this.addInIcon('filter', this.eFilterIcon, this.column);
    _.addOrRemoveCssClass(this.eFilterIcon, 'ag-hidden', !this.isFilterActive());
    _.addCssClass(this.eExpandChecked, 'ag-hidden');
    if (this.hideHeader) {
      _.addOrRemoveCssClass(this.eFilterToolPanelHeader, 'ag-hidden', true);
      this.eFilterToolPanelHeader.removeAttribute('tabindex');
    } else {
      this.eFilterToolPanelHeader.setAttribute('tabindex', '0');
    }
    this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
  };
  ToolPanelFilterComp.prototype.getColumn = function () {
    return this.column;
  };
  ToolPanelFilterComp.prototype.getColumnFilterName = function () {
    return this.columnModel.getDisplayNameForColumn(this.column, 'filterToolPanel', false);
  };
  ToolPanelFilterComp.prototype.addCssClassToTitleBar = function (cssClass) {
    _.addCssClass(this.eFilterToolPanelHeader, cssClass);
  };
  ToolPanelFilterComp.prototype.addInIcon = function (iconName, eParent, column) {
    if (eParent == null) {
      return;
    }
    var eIcon = _.createIconNoSpan(iconName, this.gridOptionsWrapper, column);
    eParent.appendChild(eIcon);
  };
  ToolPanelFilterComp.prototype.isFilterActive = function () {
    return this.filterManager.isFilterActive(this.column);
  };
  ToolPanelFilterComp.prototype.onFilterChanged = function () {
    _.addOrRemoveCssClass(this.eFilterIcon, 'ag-hidden', !this.isFilterActive());
    this.dispatchEvent({
      type: Column.EVENT_FILTER_CHANGED
    });
  };
  ToolPanelFilterComp.prototype.toggleExpanded = function () {
    this.expanded ? this.collapse() : this.expand();
  };
  ToolPanelFilterComp.prototype.expand = function () {
    var _this = this;
    if (this.expanded) {
      return;
    }
    this.expanded = true;
    _.setAriaExpanded(this.eFilterToolPanelHeader, true);
    var container = _.loadTemplate( /* html */"<div class=\"ag-filter-toolpanel-instance-filter\"></div>");
    var filterPromise = this.filterManager.getOrCreateFilterWrapper(this.column, 'TOOLBAR').filterPromise;
    if (filterPromise) {
      filterPromise.then(function (filter) {
        _this.underlyingFilter = filter;
        if (!filter) {
          return;
        }
        container.appendChild(filter.getGui());
        _this.agFilterToolPanelBody.appendChild(container);
        if (filter.afterGuiAttached) {
          filter.afterGuiAttached({
            container: 'toolPanel'
          });
        }
      });
    }
    _.setDisplayed(this.eExpandChecked, true);
    _.setDisplayed(this.eExpandUnchecked, false);
  };
  ToolPanelFilterComp.prototype.collapse = function () {
    if (!this.expanded) {
      return;
    }
    this.expanded = false;
    _.setAriaExpanded(this.eFilterToolPanelHeader, false);
    this.agFilterToolPanelBody.removeChild(this.agFilterToolPanelBody.children[0]);
    _.setDisplayed(this.eExpandChecked, false);
    _.setDisplayed(this.eExpandUnchecked, true);
  };
  ToolPanelFilterComp.prototype.refreshFilter = function () {
    if (!this.expanded) {
      return;
    }
    var filter = this.underlyingFilter;
    if (!filter) {
      return;
    }
    // set filters should be updated when the filter has been changed elsewhere, i.e. via api. Note that we can't
    // use 'afterGuiAttached' to refresh the virtual list as it also focuses on the mini filter which changes the
    // scroll position in the filter list panel
    if (typeof filter.refreshVirtualList === 'function') {
      filter.refreshVirtualList();
    }
  };
  ToolPanelFilterComp.prototype.onFilterOpened = function (event) {
    if (event.source !== 'COLUMN_MENU') {
      return;
    }
    if (event.column !== this.column) {
      return;
    }
    if (!this.expanded) {
      return;
    }
    this.collapse();
  };
  ToolPanelFilterComp.TEMPLATE = "\n        <div class=\"ag-filter-toolpanel-instance\">\n            <div class=\"ag-filter-toolpanel-header ag-filter-toolpanel-instance-header\" ref=\"eFilterToolPanelHeader\" role=\"button\" aria-expanded=\"false\">\n                <div ref=\"eExpand\" class=\"ag-filter-toolpanel-expand\"></div>\n                <span ref=\"eFilterName\" class=\"ag-header-cell-text\"></span>\n                <span ref=\"eFilterIcon\" class=\"ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon\" aria-hidden=\"true\"></span>\n            </div>\n            <div class=\"ag-filter-toolpanel-instance-body ag-filter\" ref=\"agFilterToolPanelBody\"></div>\n        </div>";
  __decorate$2$([RefSelector('eFilterToolPanelHeader')], ToolPanelFilterComp.prototype, "eFilterToolPanelHeader", void 0);
  __decorate$2$([RefSelector('eFilterName')], ToolPanelFilterComp.prototype, "eFilterName", void 0);
  __decorate$2$([RefSelector('agFilterToolPanelBody')], ToolPanelFilterComp.prototype, "agFilterToolPanelBody", void 0);
  __decorate$2$([RefSelector('eFilterIcon')], ToolPanelFilterComp.prototype, "eFilterIcon", void 0);
  __decorate$2$([RefSelector('eExpand')], ToolPanelFilterComp.prototype, "eExpand", void 0);
  __decorate$2$([Autowired('filterManager')], ToolPanelFilterComp.prototype, "filterManager", void 0);
  __decorate$2$([Autowired('columnModel')], ToolPanelFilterComp.prototype, "columnModel", void 0);
  __decorate$2$([PostConstruct], ToolPanelFilterComp.prototype, "postConstruct", null);
  return ToolPanelFilterComp;
}(Component);
var __extends$3o = undefined && undefined.__extends || function () {
  var _extendStatics225 = function extendStatics(d, b) {
    _extendStatics225 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics225(d, b);
  };
  return function (d, b) {
    _extendStatics225(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$30 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ToolPanelFilterGroupComp = /** @class */function (_super) {
  __extends$3o(ToolPanelFilterGroupComp, _super);
  function ToolPanelFilterGroupComp(columnGroup, childFilterComps, expandedCallback, depth, showingColumn) {
    var _this = _super.call(this) || this;
    _this.columnGroup = columnGroup;
    _this.childFilterComps = childFilterComps;
    _this.depth = depth;
    _this.expandedCallback = expandedCallback;
    _this.showingColumn = showingColumn;
    return _this;
  }
  ToolPanelFilterGroupComp.prototype.preConstruct = function () {
    var groupParams = {
      cssIdentifier: 'filter-toolpanel',
      direction: 'vertical'
    };
    this.setTemplate(ToolPanelFilterGroupComp.TEMPLATE, {
      filterGroupComp: groupParams
    });
  };
  ToolPanelFilterGroupComp.prototype.init = function () {
    var _this = this;
    this.setGroupTitle();
    this.filterGroupComp.setAlignItems('stretch');
    _.addCssClass(this.filterGroupComp.getGui(), "ag-filter-toolpanel-group-level-" + this.depth);
    this.filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-group-level-" + this.depth + "-header");
    this.childFilterComps.forEach(function (filterComp) {
      _this.filterGroupComp.addItem(filterComp);
      filterComp.addCssClassToTitleBar("ag-filter-toolpanel-group-level-" + (_this.depth + 1) + "-header");
    });
    this.addExpandCollapseListeners();
    this.addFilterChangedListeners();
    this.setupTooltip();
  };
  ToolPanelFilterGroupComp.prototype.setupTooltip = function () {
    var _this = this;
    // we don't show tooltips for groups, as when the group expands, it's div contains the columns which also
    // have tooltips, so the tooltips would clash. Eg mouse over group, tooltip shows, mouse over column, another
    // tooltip shows but cos we didn't leave the group the group tooltip remains. this should be fixed in the future,
    // maybe the group shouldn't contain the children form a DOM perspective.
    if (!this.showingColumn) {
      return;
    }
    var refresh = function refresh() {
      var newTooltipText = _this.columnGroup.getColDef().headerTooltip;
      _this.setTooltip(newTooltipText);
    };
    refresh();
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
  };
  ToolPanelFilterGroupComp.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'filterToolPanelColumnGroup';
    return res;
  };
  ToolPanelFilterGroupComp.prototype.addCssClassToTitleBar = function (cssClass) {
    this.filterGroupComp.addCssClassToTitleBar(cssClass);
  };
  ToolPanelFilterGroupComp.prototype.refreshFilters = function () {
    this.childFilterComps.forEach(function (filterComp) {
      if (filterComp instanceof ToolPanelFilterGroupComp) {
        filterComp.refreshFilters();
      } else {
        filterComp.refreshFilter();
      }
    });
  };
  ToolPanelFilterGroupComp.prototype.isColumnGroup = function () {
    return this.columnGroup instanceof ProvidedColumnGroup;
  };
  ToolPanelFilterGroupComp.prototype.isExpanded = function () {
    return this.filterGroupComp.isExpanded();
  };
  ToolPanelFilterGroupComp.prototype.getChildren = function () {
    return this.childFilterComps;
  };
  ToolPanelFilterGroupComp.prototype.getFilterGroupName = function () {
    return this.filterGroupName ? this.filterGroupName : '';
  };
  ToolPanelFilterGroupComp.prototype.getFilterGroupId = function () {
    return this.columnGroup.getId();
  };
  ToolPanelFilterGroupComp.prototype.hideGroupItem = function (hide, index) {
    this.filterGroupComp.hideItem(hide, index);
  };
  ToolPanelFilterGroupComp.prototype.hideGroup = function (hide) {
    _.addOrRemoveCssClass(this.getGui(), 'ag-hidden', hide);
  };
  ToolPanelFilterGroupComp.prototype.forEachToolPanelFilterChild = function (action) {
    _.forEach(this.childFilterComps, function (filterComp) {
      if (filterComp instanceof ToolPanelFilterComp) {
        action(filterComp);
      }
    });
  };
  ToolPanelFilterGroupComp.prototype.addExpandCollapseListeners = function () {
    var _this = this;
    var expandListener = this.isColumnGroup() ? function () {
      return _this.expandedCallback();
    } : function () {
      return _this.forEachToolPanelFilterChild(function (filterComp) {
        return filterComp.expand();
      });
    };
    var collapseListener = this.isColumnGroup() ? function () {
      return _this.expandedCallback();
    } : function () {
      return _this.forEachToolPanelFilterChild(function (filterComp) {
        return filterComp.collapse();
      });
    };
    this.addManagedListener(this.filterGroupComp, AgGroupComponent.EVENT_EXPANDED, expandListener);
    this.addManagedListener(this.filterGroupComp, AgGroupComponent.EVENT_COLLAPSED, collapseListener);
  };
  ToolPanelFilterGroupComp.prototype.addFilterChangedListeners = function () {
    var _this = this;
    if (this.columnGroup instanceof ProvidedColumnGroup) {
      var group_1 = this.columnGroup;
      var anyChildFiltersActive_1 = function anyChildFiltersActive_1() {
        return group_1.getLeafColumns().some(function (col) {
          return col.isFilterActive();
        });
      };
      group_1.getLeafColumns().forEach(function (column) {
        _this.addManagedListener(column, Column.EVENT_FILTER_CHANGED, function () {
          _.addOrRemoveCssClass(_this.filterGroupComp.getGui(), 'ag-has-filter', anyChildFiltersActive_1());
        });
      });
    } else {
      var column_1 = this.columnGroup;
      this.addManagedListener(this.eventService, Events.EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
      this.addManagedListener(column_1, Column.EVENT_FILTER_CHANGED, function () {
        _.addOrRemoveCssClass(_this.filterGroupComp.getGui(), 'ag-has-filter', column_1.isFilterActive());
      });
    }
  };
  ToolPanelFilterGroupComp.prototype.onFilterOpened = function (event) {
    // when a filter is opened elsewhere, i.e. column menu we close the filter comp so we also need to collapse
    // the column group. This approach means we don't need to try and sync filter models on the same column.
    if (event.source !== 'COLUMN_MENU') {
      return;
    }
    if (event.column !== this.columnGroup) {
      return;
    }
    if (!this.isExpanded()) {
      return;
    }
    this.collapse();
  };
  ToolPanelFilterGroupComp.prototype.expand = function () {
    this.filterGroupComp.toggleGroupExpand(true);
  };
  ToolPanelFilterGroupComp.prototype.collapse = function () {
    this.filterGroupComp.toggleGroupExpand(false);
  };
  ToolPanelFilterGroupComp.prototype.setGroupTitle = function () {
    this.filterGroupName = this.columnGroup instanceof ProvidedColumnGroup ? this.getColumnGroupName(this.columnGroup) : this.getColumnName(this.columnGroup);
    this.filterGroupComp.setTitle(this.filterGroupName || '');
  };
  ToolPanelFilterGroupComp.prototype.getColumnGroupName = function (columnGroup) {
    return this.columnModel.getDisplayNameForOriginalColumnGroup(null, columnGroup, 'filterToolPanel');
  };
  ToolPanelFilterGroupComp.prototype.getColumnName = function (column) {
    return this.columnModel.getDisplayNameForColumn(column, 'filterToolPanel', false);
  };
  ToolPanelFilterGroupComp.prototype.destroyFilters = function () {
    this.childFilterComps = this.destroyBeans(this.childFilterComps);
    _.clearElement(this.getGui());
  };
  ToolPanelFilterGroupComp.prototype.destroy = function () {
    this.destroyFilters();
    _super.prototype.destroy.call(this);
  };
  ToolPanelFilterGroupComp.TEMPLATE = "<div class=\"ag-filter-toolpanel-group-wrapper\">\n            <ag-group-component ref=\"filterGroupComp\"></ag-group-component>\n        </div>";
  __decorate$30([RefSelector('filterGroupComp')], ToolPanelFilterGroupComp.prototype, "filterGroupComp", void 0);
  __decorate$30([Autowired('columnModel')], ToolPanelFilterGroupComp.prototype, "columnModel", void 0);
  __decorate$30([PreConstruct], ToolPanelFilterGroupComp.prototype, "preConstruct", null);
  __decorate$30([PostConstruct], ToolPanelFilterGroupComp.prototype, "init", null);
  return ToolPanelFilterGroupComp;
}(Component);
var __extends$3p = undefined && undefined.__extends || function () {
  var _extendStatics226 = function extendStatics(d, b) {
    _extendStatics226 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics226(d, b);
  };
  return function (d, b) {
    _extendStatics226(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$31 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FiltersToolPanelListPanel = /** @class */function (_super) {
  __extends$3p(FiltersToolPanelListPanel, _super);
  function FiltersToolPanelListPanel() {
    var _this = _super.call(this, FiltersToolPanelListPanel.TEMPLATE) || this;
    _this.initialised = false;
    _this.filterGroupComps = [];
    return _this;
  }
  FiltersToolPanelListPanel.prototype.init = function (params) {
    var _this = this;
    this.initialised = true;
    var defaultParams = {
      suppressExpandAll: false,
      suppressFilterSearch: false,
      suppressSyncLayoutWithGrid: false,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    _.mergeDeep(defaultParams, params);
    this.params = defaultParams;
    if (!this.params.suppressSyncLayoutWithGrid) {
      this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, function () {
        return _this.onColumnsChanged();
      });
    }
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, function () {
      return _this.onColumnsChanged();
    });
    this.addManagedListener(this.eventService, Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED, function (event) {
      // when re-entering the filters tool panel we need to refresh the virtual lists in the set filters in case
      // filters have been changed elsewhere, i.e. via an api call.
      if (event.source === 'filters') {
        _this.refreshFilters();
      }
    });
    if (this.columnModel.isReady()) {
      this.onColumnsChanged();
    }
  };
  FiltersToolPanelListPanel.prototype.onColumnsChanged = function () {
    var pivotModeActive = this.columnModel.isPivotMode();
    var shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
    shouldSyncColumnLayoutWithGrid ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs();
  };
  FiltersToolPanelListPanel.prototype.syncFilterLayout = function () {
    this.toolPanelColDefService.syncLayoutWithGrid(this.setFiltersLayout.bind(this));
  };
  FiltersToolPanelListPanel.prototype.buildTreeFromProvidedColumnDefs = function () {
    var _this = this;
    this.destroyFilters();
    var columnTree = this.columnModel.getPrimaryColumnTree();
    this.filterGroupComps = this.recursivelyAddComps(columnTree, 0);
    var len = this.filterGroupComps.length;
    if (len) {
      this.filterGroupComps.forEach(function (comp) {
        return _this.appendChild(comp);
      });
      this.setFirstAndLastVisible(0, len - 1);
    }
    // perform search if searchFilterText exists
    if (_.exists(this.searchFilterText)) {
      this.searchFilters(this.searchFilterText);
    }
    // notify header of expand
    this.fireExpandedEvent();
  };
  FiltersToolPanelListPanel.prototype.setFiltersLayout = function (colDefs) {
    var _this = this;
    this.destroyFilters();
    var columnTree = this.toolPanelColDefService.createColumnTree(colDefs);
    this.filterGroupComps = this.recursivelyAddComps(columnTree, 0);
    var len = this.filterGroupComps.length;
    if (len) {
      this.filterGroupComps.forEach(function (comp) {
        return _this.appendChild(comp);
      });
      this.setFirstAndLastVisible(0, len - 1);
    }
    // perform search if searchFilterText exists
    if (_.exists(this.searchFilterText)) {
      this.searchFilters(this.searchFilterText);
    }
    // notify header of expand
    this.fireExpandedEvent();
  };
  FiltersToolPanelListPanel.prototype.recursivelyAddComps = function (tree, depth) {
    var _this = this;
    return _.flatten(tree.map(function (child) {
      if (child instanceof ProvidedColumnGroup) {
        return _.flatten(_this.recursivelyAddFilterGroupComps(child, depth));
      }
      var column = child;
      if (!_this.shouldDisplayFilter(column)) {
        return [];
      }
      var hideFilterCompHeader = depth === 0;
      var filterComp = new ToolPanelFilterComp(hideFilterCompHeader);
      _this.getContext().createBean(filterComp);
      filterComp.setColumn(column);
      if (depth > 0) {
        return filterComp;
      }
      var filterGroupComp = _this.createBean(new ToolPanelFilterGroupComp(column, [filterComp], _this.onGroupExpanded.bind(_this), depth, true));
      filterGroupComp.addCssClassToTitleBar('ag-filter-toolpanel-header');
      filterGroupComp.collapse();
      return filterGroupComp;
    }));
  };
  FiltersToolPanelListPanel.prototype.recursivelyAddFilterGroupComps = function (columnGroup, depth) {
    if (!this.filtersExistInChildren(columnGroup.getChildren())) {
      return;
    }
    var colGroupDef = columnGroup.getColGroupDef();
    if (colGroupDef && colGroupDef.suppressFiltersToolPanel) {
      return [];
    }
    var newDepth = columnGroup.isPadding() ? depth : depth + 1;
    var childFilterComps = _.flatten(this.recursivelyAddComps(columnGroup.getChildren(), newDepth));
    if (columnGroup.isPadding()) {
      return childFilterComps;
    }
    var filterGroupComp = new ToolPanelFilterGroupComp(columnGroup, childFilterComps, this.onGroupExpanded.bind(this), depth, false);
    this.getContext().createBean(filterGroupComp);
    filterGroupComp.addCssClassToTitleBar('ag-filter-toolpanel-header');
    return [filterGroupComp];
  };
  FiltersToolPanelListPanel.prototype.filtersExistInChildren = function (tree) {
    var _this = this;
    return tree.some(function (child) {
      if (child instanceof ProvidedColumnGroup) {
        return _this.filtersExistInChildren(child.getChildren());
      }
      return _this.shouldDisplayFilter(child);
    });
  };
  FiltersToolPanelListPanel.prototype.shouldDisplayFilter = function (column) {
    var suppressFiltersToolPanel = column.getColDef() && column.getColDef().suppressFiltersToolPanel;
    return column.isFilterAllowed() && !suppressFiltersToolPanel;
  };
  // we don't support refreshing, but must implement because it's on the tool panel interface
  FiltersToolPanelListPanel.prototype.refresh = function () {};
  // lazy initialise the panel
  FiltersToolPanelListPanel.prototype.setVisible = function (visible) {
    _super.prototype.setDisplayed.call(this, visible);
    if (visible && !this.initialised) {
      this.init(this.params);
    }
  };
  FiltersToolPanelListPanel.prototype.expandFilterGroups = function (expand, groupIds) {
    var updatedGroupIds = [];
    var updateGroupExpandState = function updateGroupExpandState(filterGroup) {
      var groupId = filterGroup.getFilterGroupId();
      var shouldExpandOrCollapse = !groupIds || _.includes(groupIds, groupId);
      if (shouldExpandOrCollapse) {
        // don't expand 'column groups', i.e. top level columns wrapped in a group
        if (expand && filterGroup.isColumnGroup()) {
          filterGroup.expand();
        } else {
          filterGroup.collapse();
        }
        updatedGroupIds.push(groupId);
      }
      // recursively look for more groups to expand / collapse
      filterGroup.getChildren().forEach(function (child) {
        if (child instanceof ToolPanelFilterGroupComp) {
          updateGroupExpandState(child);
        }
      });
    };
    this.filterGroupComps.forEach(updateGroupExpandState);
    // update header expand / collapse icon
    this.onGroupExpanded();
    if (groupIds) {
      var unrecognisedGroupIds = groupIds.filter(function (groupId) {
        return updatedGroupIds.indexOf(groupId) < 0;
      });
      if (unrecognisedGroupIds.length > 0) {
        console.warn('AG Grid: unable to find groups for these supplied groupIds:', unrecognisedGroupIds);
      }
    }
  };
  FiltersToolPanelListPanel.prototype.expandFilters = function (expand, colIds) {
    var updatedColIds = [];
    var updateGroupExpandState = function updateGroupExpandState(filterComp) {
      if (filterComp instanceof ToolPanelFilterGroupComp) {
        var anyChildrenChanged_1 = false;
        filterComp.getChildren().forEach(function (child) {
          var childUpdated = updateGroupExpandState(child);
          if (childUpdated) {
            if (expand) {
              filterComp.expand();
              anyChildrenChanged_1 = true;
            } else if (!filterComp.isColumnGroup()) {
              // we only collapse columns wrapped in groups
              filterComp.collapse();
            }
          }
        });
        return anyChildrenChanged_1;
      }
      var colId = filterComp.getColumn().getColId();
      var updateFilterExpandState = !colIds || _.includes(colIds, colId);
      if (updateFilterExpandState) {
        expand ? filterComp.expand() : filterComp.collapse();
        updatedColIds.push(colId);
      }
      return updateFilterExpandState;
    };
    this.filterGroupComps.forEach(updateGroupExpandState);
    // update header expand / collapse icon
    this.onGroupExpanded();
    if (colIds) {
      var unrecognisedColIds = colIds.filter(function (colId) {
        return updatedColIds.indexOf(colId) < 0;
      });
      if (unrecognisedColIds.length > 0) {
        console.warn('AG Grid: unable to find columns for these supplied colIds:', unrecognisedColIds);
      }
    }
  };
  FiltersToolPanelListPanel.prototype.onGroupExpanded = function () {
    this.fireExpandedEvent();
  };
  FiltersToolPanelListPanel.prototype.fireExpandedEvent = function () {
    var expandedCount = 0;
    var notExpandedCount = 0;
    var updateExpandCounts = function updateExpandCounts(filterGroup) {
      if (!filterGroup.isColumnGroup()) {
        return;
      }
      filterGroup.isExpanded() ? expandedCount++ : notExpandedCount++;
      filterGroup.getChildren().forEach(function (child) {
        if (child instanceof ToolPanelFilterGroupComp) {
          updateExpandCounts(child);
        }
      });
    };
    this.filterGroupComps.forEach(updateExpandCounts);
    var state;
    if (expandedCount > 0 && notExpandedCount > 0) {
      state = EXPAND_STATE.INDETERMINATE;
    } else if (notExpandedCount > 0) {
      state = EXPAND_STATE.COLLAPSED;
    } else {
      state = EXPAND_STATE.EXPANDED;
    }
    this.dispatchEvent({
      type: 'groupExpanded',
      state: state
    });
  };
  FiltersToolPanelListPanel.prototype.performFilterSearch = function (searchText) {
    this.searchFilterText = _.exists(searchText) ? searchText.toLowerCase() : null;
    this.searchFilters(this.searchFilterText);
  };
  FiltersToolPanelListPanel.prototype.searchFilters = function (searchFilter) {
    var passesFilter = function passesFilter(groupName) {
      return !_.exists(searchFilter) || groupName.toLowerCase().indexOf(searchFilter) !== -1;
    };
    var recursivelySearch = function recursivelySearch(filterItem, parentPasses) {
      if (!(filterItem instanceof ToolPanelFilterGroupComp)) {
        return passesFilter(filterItem.getColumnFilterName() || '');
      }
      var children = filterItem.getChildren();
      var groupNamePasses = passesFilter(filterItem.getFilterGroupName());
      // if group or parent already passed - ensure this group and all children are visible
      var alreadyPassed = parentPasses || groupNamePasses;
      if (alreadyPassed) {
        // ensure group visible
        filterItem.hideGroup(false);
        // ensure all children are visible
        for (var i = 0; i < children.length; i++) {
          recursivelySearch(children[i], alreadyPassed);
          filterItem.hideGroupItem(false, i);
        }
        return true;
      }
      // hide group item filters
      var anyChildPasses = false;
      children.forEach(function (child, index) {
        var childPasses = recursivelySearch(child, parentPasses);
        filterItem.hideGroupItem(!childPasses, index);
        if (childPasses) {
          anyChildPasses = true;
        }
      });
      // hide group if no children pass
      filterItem.hideGroup(!anyChildPasses);
      return anyChildPasses;
    };
    var firstVisible;
    var lastVisible;
    this.filterGroupComps.forEach(function (filterGroup, idx) {
      recursivelySearch(filterGroup, false);
      if (firstVisible === undefined) {
        if (!_.containsClass(filterGroup.getGui(), 'ag-hidden')) {
          firstVisible = idx;
          lastVisible = idx;
        }
      } else if (!_.containsClass(filterGroup.getGui(), 'ag-hidden') && lastVisible !== idx) {
        lastVisible = idx;
      }
    });
    this.setFirstAndLastVisible(firstVisible, lastVisible);
  };
  FiltersToolPanelListPanel.prototype.setFirstAndLastVisible = function (firstIdx, lastIdx) {
    this.filterGroupComps.forEach(function (filterGroup, idx) {
      _.removeCssClass(filterGroup.getGui(), 'ag-first-group-visible');
      _.removeCssClass(filterGroup.getGui(), 'ag-last-group-visible');
      if (idx === firstIdx) {
        _.addCssClass(filterGroup.getGui(), 'ag-first-group-visible');
      }
      if (idx === lastIdx) {
        _.addCssClass(filterGroup.getGui(), 'ag-last-group-visible');
      }
    });
  };
  FiltersToolPanelListPanel.prototype.refreshFilters = function () {
    this.filterGroupComps.forEach(function (filterGroupComp) {
      return filterGroupComp.refreshFilters();
    });
  };
  FiltersToolPanelListPanel.prototype.destroyFilters = function () {
    this.filterGroupComps = this.destroyBeans(this.filterGroupComps);
    _.clearElement(this.getGui());
  };
  FiltersToolPanelListPanel.prototype.destroy = function () {
    this.destroyFilters();
    _super.prototype.destroy.call(this);
  };
  FiltersToolPanelListPanel.TEMPLATE = "<div class=\"ag-filter-list-panel\"></div>";
  __decorate$31([Autowired("gridApi")], FiltersToolPanelListPanel.prototype, "gridApi", void 0);
  __decorate$31([Autowired("columnApi")], FiltersToolPanelListPanel.prototype, "columnApi", void 0);
  __decorate$31([Autowired('toolPanelColDefService')], FiltersToolPanelListPanel.prototype, "toolPanelColDefService", void 0);
  __decorate$31([Autowired('columnModel')], FiltersToolPanelListPanel.prototype, "columnModel", void 0);
  return FiltersToolPanelListPanel;
}(Component);
var __extends$3q = undefined && undefined.__extends || function () {
  var _extendStatics227 = function extendStatics(d, b) {
    _extendStatics227 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics227(d, b);
  };
  return function (d, b) {
    _extendStatics227(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$32 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FiltersToolPanel = /** @class */function (_super) {
  __extends$3q(FiltersToolPanel, _super);
  function FiltersToolPanel() {
    var _this = _super.call(this, FiltersToolPanel.TEMPLATE) || this;
    _this.initialised = false;
    _this.listenerDestroyFuncs = [];
    return _this;
  }
  FiltersToolPanel.prototype.init = function (params) {
    // if initialised is true, means this is a refresh
    if (this.initialised) {
      this.listenerDestroyFuncs.forEach(function (func) {
        return func();
      });
      this.listenerDestroyFuncs = [];
    }
    this.initialised = true;
    var defaultParams = {
      suppressExpandAll: false,
      suppressFilterSearch: false,
      suppressSyncLayoutWithGrid: false,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    _.mergeDeep(defaultParams, params);
    this.params = defaultParams;
    this.filtersToolPanelHeaderPanel.init(this.params);
    this.filtersToolPanelListPanel.init(this.params);
    var hideExpand = this.params.suppressExpandAll;
    var hideSearch = this.params.suppressFilterSearch;
    if (hideExpand && hideSearch) {
      this.filtersToolPanelHeaderPanel.setDisplayed(false);
    }
    // this is necessary to prevent a memory leak while refreshing the tool panel
    this.listenerDestroyFuncs.push(this.addManagedListener(this.filtersToolPanelHeaderPanel, 'expandAll', this.onExpandAll.bind(this)), this.addManagedListener(this.filtersToolPanelHeaderPanel, 'collapseAll', this.onCollapseAll.bind(this)), this.addManagedListener(this.filtersToolPanelHeaderPanel, 'searchChanged', this.onSearchChanged.bind(this)), this.addManagedListener(this.filtersToolPanelListPanel, 'groupExpanded', this.onGroupExpanded.bind(this)));
  };
  // lazy initialise the panel
  FiltersToolPanel.prototype.setVisible = function (visible) {
    _super.prototype.setDisplayed.call(this, visible);
    if (visible && !this.initialised) {
      this.init(this.params);
    }
  };
  FiltersToolPanel.prototype.onExpandAll = function () {
    this.filtersToolPanelListPanel.expandFilterGroups(true);
  };
  FiltersToolPanel.prototype.onCollapseAll = function () {
    this.filtersToolPanelListPanel.expandFilterGroups(false);
  };
  FiltersToolPanel.prototype.onSearchChanged = function (event) {
    this.filtersToolPanelListPanel.performFilterSearch(event.searchText);
  };
  FiltersToolPanel.prototype.setFilterLayout = function (colDefs) {
    this.filtersToolPanelListPanel.setFiltersLayout(colDefs);
  };
  FiltersToolPanel.prototype.onGroupExpanded = function (event) {
    this.filtersToolPanelHeaderPanel.setExpandState(event.state);
  };
  FiltersToolPanel.prototype.expandFilterGroups = function (groupIds) {
    this.filtersToolPanelListPanel.expandFilterGroups(true, groupIds);
  };
  FiltersToolPanel.prototype.collapseFilterGroups = function (groupIds) {
    this.filtersToolPanelListPanel.expandFilterGroups(false, groupIds);
  };
  FiltersToolPanel.prototype.expandFilters = function (colIds) {
    this.filtersToolPanelListPanel.expandFilters(true, colIds);
  };
  FiltersToolPanel.prototype.collapseFilters = function (colIds) {
    this.filtersToolPanelListPanel.expandFilters(false, colIds);
  };
  FiltersToolPanel.prototype.syncLayoutWithGrid = function () {
    this.filtersToolPanelListPanel.syncFilterLayout();
  };
  FiltersToolPanel.prototype.refresh = function () {
    this.init(this.params);
  };
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  FiltersToolPanel.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  FiltersToolPanel.TEMPLATE = "<div class=\"ag-filter-toolpanel\">\n            <ag-filters-tool-panel-header ref=\"filtersToolPanelHeaderPanel\"></ag-filters-tool-panel-header>\n            <ag-filters-tool-panel-list ref=\"filtersToolPanelListPanel\"></ag-filters-tool-panel-list>\n         </div>";
  __decorate$32([RefSelector('filtersToolPanelHeaderPanel')], FiltersToolPanel.prototype, "filtersToolPanelHeaderPanel", void 0);
  __decorate$32([RefSelector('filtersToolPanelListPanel')], FiltersToolPanel.prototype, "filtersToolPanelListPanel", void 0);
  __decorate$32([Autowired('gridApi')], FiltersToolPanel.prototype, "gridApi", void 0);
  __decorate$32([Autowired('columnApi')], FiltersToolPanel.prototype, "columnApi", void 0);
  return FiltersToolPanel;
}(Component);
var FiltersToolPanelModule = {
  moduleName: ModuleNames.FiltersToolPanelModule,
  beans: [],
  agStackComponents: [{
    componentName: 'AgFiltersToolPanelHeader',
    componentClass: FiltersToolPanelHeaderPanel
  }, {
    componentName: 'AgFiltersToolPanelList',
    componentClass: FiltersToolPanelListPanel
  }],
  userComponents: [{
    componentName: 'agFiltersToolPanel',
    componentClass: FiltersToolPanel
  }],
  dependantModules: [SideBarModule, EnterpriseCoreModule]
};
var __extends$3r = undefined && undefined.__extends || function () {
  var _extendStatics228 = function extendStatics(d, b) {
    _extendStatics228 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics228(d, b);
  };
  return function (d, b) {
    _extendStatics228(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$33 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartDatasource = /** @class */function (_super) {
  __extends$3r(ChartDatasource, _super);
  function ChartDatasource() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ChartDatasource.prototype.getData = function (params) {
    if (params.crossFiltering) {
      if (params.grouping) {
        console.warn("ag-grid: crossing filtering with row grouping is not supported.");
        return {
          data: [],
          columnNames: {}
        };
      }
      if (!this.gridOptionsWrapper.isRowModelDefault()) {
        console.warn("ag-grid: crossing filtering is only supported in the client side row model.");
        return {
          data: [],
          columnNames: {}
        };
      }
    }
    var isServerSide = this.gridOptionsWrapper.isRowModelServerSide();
    if (isServerSide && params.pivoting) {
      this.updatePivotKeysForSSRM();
    }
    var result = this.extractRowsFromGridRowModel(params);
    result.data = this.aggregateRowsByDimension(params, result.data);
    return result;
  };
  ChartDatasource.prototype.extractRowsFromGridRowModel = function (params) {
    var _this = this;
    var extractedRowData = [];
    var columnNames = {};
    // maps used to keep track of expanded groups that need to be removed
    var groupNodeIndexes = {};
    var groupsToRemove = {};
    // only used when cross filtering
    var filteredNodes = {};
    var allRowNodes = [];
    var numRows;
    if (params.crossFiltering) {
      filteredNodes = this.getFilteredRowNodes();
      allRowNodes = this.getAllRowNodes();
      numRows = allRowNodes.length;
    } else {
      // make sure enough rows in range to chart. if user filters and less rows, then end row will be
      // the last displayed row, not where the range ends.
      var modelLastRow = this.gridRowModel.getRowCount() - 1;
      var rangeLastRow = params.endRow >= 0 ? Math.min(params.endRow, modelLastRow) : modelLastRow;
      numRows = rangeLastRow - params.startRow + 1;
    }
    var _loop_1 = function _loop_1(i) {
      var data = {};
      var rowNode = params.crossFiltering ? allRowNodes[i] : this_1.gridRowModel.getRow(i + params.startRow);
      // first get data for dimensions columns
      params.dimensionCols.forEach(function (col) {
        var colId = col.colId;
        var column = _this.columnModel.getGridColumn(colId);
        if (column) {
          var valueObject = _this.valueService.getValue(column, rowNode);
          // when grouping we also need to build up multi category labels for charts
          if (params.grouping) {
            var valueString = valueObject && valueObject.toString ? String(valueObject.toString()) : '';
            // traverse parents to extract group label path
            var labels = ChartDatasource.getGroupLabels(rowNode, valueString);
            data[colId] = {
              labels: labels,
              toString: function toString() {
                return this.labels.filter(function (l) {
                  return !!l;
                }).reverse().join(' - ');
              }
            };
            // keep track of group node indexes so they can be padded when other groups are expanded
            if (rowNode.group) {
              groupNodeIndexes[labels.toString()] = i;
            }
            // if node (group or leaf) has parents then it is expanded and should be removed
            var groupKey = labels.slice(1, labels.length).toString();
            if (groupKey) {
              groupsToRemove[groupKey] = groupNodeIndexes[groupKey];
            }
          } else {
            // leaf nodes can be directly added to dimension columns
            data[colId] = valueObject;
          }
        } else {
          // introduce a default category when no dimensions exist with a value based off row index (+1)
          data[ChartDataModel.DEFAULT_CATEGORY] = i + 1;
        }
      });
      // then get data for value columns
      params.valueCols.forEach(function (col) {
        var columnNamesArr = [];
        // pivot keys should be added first
        var pivotKeys = col.getColDef().pivotKeys;
        if (pivotKeys) {
          columnNamesArr = pivotKeys.slice();
        }
        // then add column header name to results
        var headerName = col.getColDef().headerName;
        if (headerName) {
          columnNamesArr.push(headerName);
        }
        // add array of column names to results
        if (columnNamesArr.length > 0) {
          columnNames[col.getId()] = columnNamesArr;
        }
        var colId = col.getColId();
        if (params.crossFiltering) {
          var filteredOutColId = colId + '-filtered-out';
          // add data value to value column
          var value = _this.valueService.getValue(col, rowNode);
          var actualValue = value != null && typeof value.toNumber === 'function' ? value.toNumber() : value;
          if (filteredNodes[rowNode.id]) {
            data[colId] = actualValue;
            data[filteredOutColId] = params.aggFunc || params.isScatter ? undefined : 0;
          } else {
            data[colId] = params.aggFunc || params.isScatter ? undefined : 0;
            data[filteredOutColId] = actualValue;
          }
        } else {
          // add data value to value column
          var value = _this.valueService.getValue(col, rowNode);
          data[colId] = value != null && typeof value.toNumber === 'function' ? value.toNumber() : value;
        }
      });
      // add data to results
      extractedRowData.push(data);
    };
    var this_1 = this;
    for (var i = 0; i < numRows; i++) {
      _loop_1(i);
    }
    if (params.grouping) {
      var groupIndexesToRemove_1 = _.values(groupsToRemove);
      extractedRowData = extractedRowData.filter(function (_1, index) {
        return !_.includes(groupIndexesToRemove_1, index);
      });
    }
    return {
      data: extractedRowData,
      columnNames: columnNames
    };
  };
  ChartDatasource.prototype.aggregateRowsByDimension = function (params, dataFromGrid) {
    var _this = this;
    var dimensionCols = params.dimensionCols;
    if (!params.aggFunc || dimensionCols.length === 0) {
      return dataFromGrid;
    }
    var lastCol = _.last(dimensionCols);
    var lastColId = lastCol && lastCol.colId;
    var map = {};
    var dataAggregated = [];
    dataFromGrid.forEach(function (data) {
      var currentMap = map;
      dimensionCols.forEach(function (col) {
        var colId = col.colId;
        var key = data[colId];
        if (colId === lastColId) {
          var groupItem_1 = currentMap[key];
          if (!groupItem_1) {
            groupItem_1 = {
              __children: []
            };
            dimensionCols.forEach(function (dimCol) {
              var dimColId = dimCol.colId;
              groupItem_1[dimColId] = data[dimColId];
            });
            currentMap[key] = groupItem_1;
            dataAggregated.push(groupItem_1);
          }
          groupItem_1.__children.push(data);
        } else {
          // map of maps
          if (!currentMap[key]) {
            currentMap[key] = {};
          }
          currentMap = currentMap[key];
        }
      });
    });
    if (ModuleRegistry.assertRegistered(ModuleNames.RowGroupingModule, 'Charting Aggregation')) {
      dataAggregated.forEach(function (groupItem) {
        return params.valueCols.forEach(function (col) {
          if (params.crossFiltering) {
            params.valueCols.forEach(function (valueCol) {
              // filtered data
              var dataToAgg = groupItem.__children.filter(function (child) {
                return typeof child[valueCol.getColId()] !== 'undefined';
              }).map(function (child) {
                return child[valueCol.getColId()];
              });
              var aggResult = _this.aggregationStage.aggregateValues(dataToAgg, params.aggFunc);
              groupItem[valueCol.getId()] = aggResult && typeof aggResult.value !== 'undefined' ? aggResult.value : aggResult;
              // filtered out data
              var filteredOutColId = valueCol.getId() + '-filtered-out';
              var dataToAggFiltered = groupItem.__children.filter(function (child) {
                return typeof child[filteredOutColId] !== 'undefined';
              }).map(function (child) {
                return child[filteredOutColId];
              });
              var aggResultFiltered = _this.aggregationStage.aggregateValues(dataToAggFiltered, params.aggFunc);
              groupItem[filteredOutColId] = aggResultFiltered && typeof aggResultFiltered.value !== 'undefined' ? aggResultFiltered.value : aggResultFiltered;
            });
          } else {
            var dataToAgg = groupItem.__children.map(function (child) {
              return child[col.getId()];
            });
            var aggResult = 0;
            if (ModuleRegistry.assertRegistered(ModuleNames.RowGroupingModule, 'Charting Aggregation')) {
              aggResult = _this.aggregationStage.aggregateValues(dataToAgg, params.aggFunc);
            }
            groupItem[col.getId()] = aggResult && typeof aggResult.value !== 'undefined' ? aggResult.value : aggResult;
          }
        });
      });
    }
    return dataAggregated;
  };
  ChartDatasource.prototype.updatePivotKeysForSSRM = function () {
    var secondaryColumns = this.columnModel.getSecondaryColumns();
    if (!secondaryColumns) {
      return;
    }
    // we don't know what the application will use for the pivot key separator (i.e. '_' or '|' ) as the
    // secondary columns are provided to grid by the application via columnApi.setSecondaryColumns()
    var pivotKeySeparator = this.extractPivotKeySeparator(secondaryColumns);
    // 'pivotKeys' is not used by the SSRM for pivoting so it is safe to reuse this colDef property, this way
    // the same logic can be used for CSRM and SSRM to extract legend names in extractRowsFromGridRowModel()
    secondaryColumns.forEach(function (col) {
      var keys = col.getColId().split(pivotKeySeparator);
      col.getColDef().pivotKeys = keys.slice(0, keys.length - 1);
    });
  };
  ChartDatasource.prototype.extractPivotKeySeparator = function (secondaryColumns) {
    if (secondaryColumns.length === 0) {
      return "";
    }
    var extractSeparator = function extractSeparator(columnGroup, childId) {
      var groupId = columnGroup.getGroupId();
      if (!columnGroup.getParent()) {
        // removing groupId ('2000') from childId ('2000|Swimming') yields '|Swimming' so first char is separator
        return childId.split(groupId)[1][0];
      }
      return extractSeparator(columnGroup.getParent(), groupId);
    };
    var firstSecondaryCol = secondaryColumns[0];
    return extractSeparator(firstSecondaryCol.getParent(), firstSecondaryCol.getColId());
  };
  ChartDatasource.getGroupLabels = function (rowNode, initialLabel) {
    var labels = [initialLabel];
    while (rowNode && rowNode.level !== 0) {
      rowNode = rowNode.parent;
      if (rowNode) {
        labels.push(rowNode.key);
      }
    }
    return labels;
  };
  ChartDatasource.prototype.getFilteredRowNodes = function () {
    var filteredNodes = {};
    this.gridRowModel.forEachNodeAfterFilterAndSort(function (rowNode) {
      filteredNodes[rowNode.id] = rowNode;
    });
    return filteredNodes;
  };
  ChartDatasource.prototype.getAllRowNodes = function () {
    var allRowNodes = [];
    this.gridRowModel.forEachNode(function (rowNode) {
      allRowNodes.push(rowNode);
    });
    return this.sortRowNodes(allRowNodes);
  };
  ChartDatasource.prototype.sortRowNodes = function (rowNodes) {
    var sortOptions = this.sortController.getSortOptions();
    var noSort = !sortOptions || sortOptions.length == 0;
    if (noSort) return rowNodes;
    return this.rowNodeSorter.doFullSort(rowNodes, sortOptions);
  };
  __decorate$33([Autowired('rowModel')], ChartDatasource.prototype, "gridRowModel", void 0);
  __decorate$33([Autowired('valueService')], ChartDatasource.prototype, "valueService", void 0);
  __decorate$33([Autowired('columnModel')], ChartDatasource.prototype, "columnModel", void 0);
  __decorate$33([Autowired('rowNodeSorter')], ChartDatasource.prototype, "rowNodeSorter", void 0);
  __decorate$33([Autowired('sortController')], ChartDatasource.prototype, "sortController", void 0);
  __decorate$33([Optional('aggregationStage')], ChartDatasource.prototype, "aggregationStage", void 0);
  return ChartDatasource;
}(BeanStub);
var __extends$3s = undefined && undefined.__extends || function () {
  var _extendStatics229 = function extendStatics(d, b) {
    _extendStatics229 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics229(d, b);
  };
  return function (d, b) {
    _extendStatics229(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$34 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$i = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ChartDataModel = /** @class */function (_super) {
  __extends$3s(ChartDataModel, _super);
  function ChartDataModel(params) {
    var _this = _super.call(this) || this;
    _this.dimensionColState = [];
    _this.valueColState = [];
    _this.unlinked = false;
    _this.grouping = false;
    _this.crossFiltering = false;
    _this.columnNames = {};
    _this.pivotChart = params.pivotChart;
    _this.chartType = params.chartType;
    _this.chartThemeName = params.chartThemeName;
    _this.aggFunc = params.aggFunc;
    _this.referenceCellRange = params.cellRange;
    _this.suppliedCellRange = params.cellRange;
    _this.suppressChartRanges = params.suppressChartRanges;
    _this.unlinked = !!params.unlinkChart;
    _this.crossFiltering = !!params.crossFiltering;
    // this is used to associate chart ranges with charts
    _this.chartId = _this.generateId();
    return _this;
  }
  ChartDataModel.prototype.init = function () {
    this.datasource = this.createManagedBean(new ChartDatasource());
    this.updateCellRanges();
  };
  ChartDataModel.prototype.updateCellRanges = function (updatedColState) {
    if (this.valueCellRange) {
      this.referenceCellRange = this.valueCellRange;
    }
    var _a = this.getAllChartColumns(),
      dimensionCols = _a.dimensionCols,
      valueCols = _a.valueCols;
    var allColsFromRanges = this.getAllColumnsFromRanges();
    if (updatedColState) {
      this.updateColumnState(updatedColState);
    }
    this.setDimensionCellRange(dimensionCols, allColsFromRanges, updatedColState);
    this.setValueCellRange(valueCols, allColsFromRanges, updatedColState);
    if (!updatedColState) {
      this.resetColumnState();
      // dimension / category cell range could be out of sync after resetting column state when row grouping
      this.syncDimensionCellRange();
    }
    this.updateData();
  };
  ChartDataModel.prototype.getData = function () {
    return this.chartData;
  };
  ChartDataModel.prototype.isGroupActive = function () {
    var usingTreeData = this.gridOptionsWrapper.isTreeData();
    var groupedCols = usingTreeData ? null : this.columnModel.getRowGroupColumns();
    return usingTreeData || groupedCols && groupedCols.length > 0;
  };
  ChartDataModel.prototype.isGrouping = function () {
    // charts only group when the selected category is a group column
    var colId = this.getSelectedDimension().colId;
    var displayedGroupCols = this.columnModel.getGroupDisplayColumns();
    var groupDimensionSelected = displayedGroupCols.map(function (col) {
      return col.getColId();
    }).some(function (id) {
      return id === colId;
    });
    return !!this.isGroupActive() && groupDimensionSelected;
  };
  ChartDataModel.prototype.isPivotActive = function () {
    return this.columnModel.isPivotActive();
  };
  ChartDataModel.prototype.isPivotMode = function () {
    return this.columnModel.isPivotMode();
  };
  ChartDataModel.prototype.isPivotChart = function () {
    return this.pivotChart;
  };
  ChartDataModel.prototype.getChartId = function () {
    return this.chartId;
  };
  ChartDataModel.prototype.getValueColState = function () {
    return this.valueColState.map(this.displayNameMapper.bind(this));
  };
  ChartDataModel.prototype.getDimensionColState = function () {
    return this.dimensionColState;
  };
  ChartDataModel.prototype.getCellRanges = function () {
    return [this.dimensionCellRange, this.valueCellRange].filter(function (r) {
      return r;
    });
  };
  ChartDataModel.prototype.getCellRangeParams = function () {
    var cellRanges = this.getCellRanges();
    var firstCellRange = cellRanges[0];
    var startRow = firstCellRange && firstCellRange.startRow || null;
    var endRow = firstCellRange && firstCellRange.endRow || null;
    return {
      rowStartIndex: startRow && startRow.rowIndex,
      rowStartPinned: startRow && startRow.rowPinned,
      rowEndIndex: endRow && endRow.rowIndex,
      rowEndPinned: endRow && endRow.rowPinned,
      columns: cellRanges.reduce(function (columns, value) {
        return columns.concat(value.columns.map(function (c) {
          return c.getId();
        }));
      }, [])
    };
  };
  ChartDataModel.prototype.setChartType = function (chartType) {
    this.chartType = chartType;
  };
  ChartDataModel.prototype.getChartType = function () {
    return this.chartType;
  };
  ChartDataModel.prototype.setChartThemeName = function (chartThemeName) {
    this.chartThemeName = chartThemeName;
  };
  ChartDataModel.prototype.getChartThemeName = function () {
    return this.chartThemeName;
  };
  ChartDataModel.prototype.isSuppressChartRanges = function () {
    return this.suppressChartRanges;
  };
  ChartDataModel.prototype.isUnlinked = function () {
    return this.unlinked;
  };
  ChartDataModel.prototype.toggleUnlinked = function () {
    this.unlinked = !this.unlinked;
  };
  ChartDataModel.prototype.getAggFunc = function () {
    return this.aggFunc;
  };
  ChartDataModel.prototype.getSelectedValueColState = function () {
    return this.getValueColState().filter(function (cs) {
      return cs.selected;
    });
  };
  ChartDataModel.prototype.getSelectedValueCols = function () {
    return this.valueColState.filter(function (cs) {
      return cs.selected;
    }).map(function (cs) {
      return cs.column;
    });
  };
  ChartDataModel.prototype.getSelectedDimension = function () {
    return this.dimensionColState.filter(function (cs) {
      return cs.selected;
    })[0];
  };
  ChartDataModel.prototype.createCellRange = function (type) {
    var columns = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      columns[_i - 1] = arguments[_i];
    }
    return {
      id: this.chartId,
      startRow: this.referenceCellRange.startRow,
      endRow: this.referenceCellRange.endRow,
      columns: columns,
      startColumn: type === CellRangeType.DIMENSION ? columns[0] : this.referenceCellRange.startColumn,
      type: type
    };
  };
  ChartDataModel.prototype.getAllColumnsFromRanges = function () {
    if (this.pivotChart) {
      return _.convertToSet(this.columnModel.getAllDisplayedColumns());
    }
    var columns = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
    if (this.dimensionCellRange) {
      columns.push.apply(columns, this.dimensionCellRange.columns);
    }
    if (this.valueCellRange) {
      columns.push.apply(columns, this.valueCellRange.columns);
    }
    return _.convertToSet(columns);
  };
  ChartDataModel.prototype.getColDisplayName = function (col) {
    return this.columnModel.getDisplayNameForColumn(col, 'chart');
  };
  ChartDataModel.prototype.getRowIndexes = function () {
    var startRow = 0,
      endRow = 0;
    var rangeService = this.rangeService;
    var range = this.valueCellRange;
    if (rangeService && range) {
      startRow = rangeService.getRangeStartRow(range).rowIndex;
      endRow = rangeService.getRangeEndRow(range).rowIndex;
    }
    return {
      startRow: startRow,
      endRow: endRow
    };
  };
  ChartDataModel.prototype.getAllChartColumns = function () {
    var _this = this;
    var displayedCols = this.columnModel.getAllDisplayedColumns();
    var dimensionCols = new Set();
    var valueCols = new Set();
    displayedCols.forEach(function (col) {
      var colDef = col.getColDef();
      var chartDataType = colDef.chartDataType;
      if (chartDataType) {
        // chart data type was specified explicitly
        switch (chartDataType) {
          case 'category':
          case 'time':
            dimensionCols.add(col);
            return;
          case 'series':
            valueCols.add(col);
            return;
          case 'excluded':
            return;
          default:
            console.warn("AG Grid: unexpected chartDataType value '" + chartDataType + "' supplied, instead use 'category', 'series' or 'excluded'");
            break;
        }
      }
      if (colDef.colId === 'ag-Grid-AutoColumn') {
        dimensionCols.add(col);
        return;
      }
      if (!col.isPrimary()) {
        valueCols.add(col);
        return;
      }
      // if 'chartDataType' is not provided then infer type based data contained in first row
      (_this.isNumberCol(col) ? valueCols : dimensionCols).add(col);
    });
    return {
      dimensionCols: dimensionCols,
      valueCols: valueCols
    };
  };
  ChartDataModel.prototype.isNumberCol = function (col) {
    if (col.getColId() === 'ag-Grid-AutoColumn') {
      return false;
    }
    var row = this.rowRenderer.getRowNode({
      rowIndex: 0,
      rowPinned: null
    });
    if (!row) {
      return false;
    }
    var cellValue = this.valueService.getValue(col, row);
    if (cellValue == null) {
      cellValue = this.extractLeafData(row, col);
    }
    if (cellValue != null && typeof cellValue.toNumber === 'function') {
      cellValue = cellValue.toNumber();
    }
    return typeof cellValue === 'number';
  };
  ChartDataModel.prototype.extractLeafData = function (row, col) {
    if (!row.allLeafChildren) {
      return null;
    }
    for (var i = 0; i < row.allLeafChildren.length; i++) {
      var childRow = row.allLeafChildren[i];
      var value = this.valueService.getValue(col, childRow);
      if (value != null) {
        return value;
      }
    }
    return null;
  };
  ChartDataModel.prototype.displayNameMapper = function (col) {
    var columnNames = this.columnNames[col.colId];
    col.displayName = columnNames ? columnNames.join(' - ') : this.getColDisplayName(col.column);
    return col;
  };
  ChartDataModel.prototype.generateId = function () {
    return 'id-' + Math.random().toString(36).substr(2, 16);
  };
  ChartDataModel.prototype.updateData = function () {
    var _a = this.getRowIndexes(),
      startRow = _a.startRow,
      endRow = _a.endRow;
    if (this.pivotChart) {
      this.resetColumnState();
    }
    this.grouping = this.isGrouping();
    var params = {
      aggFunc: this.aggFunc,
      dimensionCols: [this.getSelectedDimension()],
      grouping: this.grouping,
      pivoting: this.isPivotActive(),
      crossFiltering: this.crossFiltering,
      valueCols: this.getSelectedValueCols(),
      startRow: startRow,
      endRow: endRow,
      isScatter: _.includes([ChartType.Scatter, ChartType.Bubble], this.chartType)
    };
    var result = this.datasource.getData(params);
    this.chartData = result.data;
    this.columnNames = result.columnNames;
  };
  ChartDataModel.prototype.resetColumnState = function () {
    var _this = this;
    var _a = this.getAllChartColumns(),
      dimensionCols = _a.dimensionCols,
      valueCols = _a.valueCols;
    var allCols = this.getAllColumnsFromRanges();
    var isInitialising = this.valueColState.length < 1;
    this.dimensionColState = [];
    this.valueColState = [];
    var hasSelectedDimension = false;
    var order = 1;
    var aggFuncDimension = this.suppliedCellRange.columns[0]; //TODO
    dimensionCols.forEach(function (column) {
      var isAutoGroupCol = column.getColId() === 'ag-Grid-AutoColumn';
      var selected = false;
      if (_this.crossFiltering && _this.aggFunc) {
        if (aggFuncDimension.getColId() === column.getColId()) {
          selected = true;
        }
      } else {
        selected = isAutoGroupCol ? true : !hasSelectedDimension && allCols.has(column);
      }
      _this.dimensionColState.push({
        column: column,
        colId: column.getColId(),
        displayName: _this.getColDisplayName(column),
        selected: selected,
        order: order++
      });
      if (selected) {
        hasSelectedDimension = true;
      }
    });
    var defaultCategory = {
      colId: ChartDataModel.DEFAULT_CATEGORY,
      displayName: this.chartTranslator.translate('defaultCategory'),
      selected: !hasSelectedDimension,
      order: 0
    };
    this.dimensionColState.unshift(defaultCategory);
    var valueColumnsFromReferenceRange = this.referenceCellRange.columns.filter(function (c) {
      return valueCols.has(c);
    });
    valueCols.forEach(function (column) {
      // first time the value cell range is set, preserve the column order from the supplied range
      if (isInitialising && _.includes(_this.referenceCellRange.columns, column)) {
        column = valueColumnsFromReferenceRange.shift();
      }
      _this.valueColState.push({
        column: column,
        colId: column.getColId(),
        displayName: _this.getColDisplayName(column),
        selected: allCols.has(column),
        order: order++
      });
    });
  };
  ChartDataModel.prototype.updateColumnState = function (updatedCol) {
    var idsMatch = function idsMatch(cs) {
      return cs.colId === updatedCol.colId;
    };
    var _a = this,
      dimensionColState = _a.dimensionColState,
      valueColState = _a.valueColState;
    if (dimensionColState.filter(idsMatch).length > 0) {
      // only one dimension should be selected
      dimensionColState.forEach(function (cs) {
        return cs.selected = idsMatch(cs);
      });
    } else {
      // just update the selected value on the supplied value column
      valueColState.filter(idsMatch).forEach(function (cs) {
        return cs.selected = updatedCol.selected;
      });
    }
    var allColumns = __spreadArrays$i(dimensionColState, valueColState);
    var orderedColIds = [];
    // calculate new order
    allColumns.forEach(function (col, i) {
      if (i === updatedCol.order) {
        orderedColIds.push(updatedCol.colId);
      }
      if (col.colId !== updatedCol.colId) {
        orderedColIds.push(col.colId);
      }
    });
    // update col state with new order
    allColumns.forEach(function (col) {
      var order = orderedColIds.indexOf(col.colId);
      col.order = order >= 0 ? orderedColIds.indexOf(col.colId) : allColumns.length - 1;
    });
    this.reorderColState();
  };
  ChartDataModel.prototype.reorderColState = function () {
    var _a = this,
      dimensionColState = _a.dimensionColState,
      valueColState = _a.valueColState;
    dimensionColState.sort(function (a, b) {
      return a.order - b.order;
    });
    valueColState.sort(function (a, b) {
      return a.order - b.order;
    });
  };
  ChartDataModel.prototype.setDimensionCellRange = function (dimensionCols, colsInRange, updatedColState) {
    var _this = this;
    this.dimensionCellRange = undefined;
    var dimensionColState = this.dimensionColState;
    if (!updatedColState && !dimensionColState.length) {
      // use first dimension column in range by default
      dimensionCols.forEach(function (col) {
        if (_this.dimensionCellRange || !colsInRange.has(col)) {
          return;
        }
        _this.dimensionCellRange = _this.createCellRange(CellRangeType.DIMENSION, col);
      });
      return;
    }
    var selectedDimensionColState = updatedColState;
    if (this.crossFiltering && this.aggFunc) {
      var aggFuncDimension_1 = this.suppliedCellRange.columns[0]; //TODO
      selectedDimensionColState = this.dimensionColState.filter(function (cs) {
        return cs.colId === aggFuncDimension_1.getColId();
      })[0];
    } else if (!selectedDimensionColState || !dimensionCols.has(selectedDimensionColState.column)) {
      selectedDimensionColState = this.dimensionColState.filter(function (cs) {
        return cs.selected;
      })[0];
    }
    if (selectedDimensionColState && selectedDimensionColState.colId !== ChartDataModel.DEFAULT_CATEGORY) {
      this.dimensionCellRange = this.createCellRange(CellRangeType.DIMENSION, selectedDimensionColState.column);
    }
  };
  ChartDataModel.prototype.setValueCellRange = function (valueCols, colsInRange, updatedColState) {
    this.valueCellRange = undefined;
    var selectedValueCols = [];
    valueCols.forEach(function (col) {
      if (updatedColState && updatedColState.colId === col.getColId()) {
        if (updatedColState.selected) {
          selectedValueCols.push(updatedColState.column);
        }
      } else if (colsInRange.has(col)) {
        selectedValueCols.push(col);
      }
    });
    if (selectedValueCols.length > 0) {
      var orderedColIds_1 = [];
      if (this.valueColState.length > 0) {
        orderedColIds_1 = this.valueColState.map(function (c) {
          return c.colId;
        });
      } else {
        colsInRange.forEach(function (c) {
          return orderedColIds_1.push(c.getColId());
        });
      }
      selectedValueCols.sort(function (a, b) {
        return orderedColIds_1.indexOf(a.getColId()) - orderedColIds_1.indexOf(b.getColId());
      });
      this.valueCellRange = this.createCellRange.apply(this, __spreadArrays$i([CellRangeType.VALUE], selectedValueCols));
    }
  };
  ChartDataModel.prototype.syncDimensionCellRange = function () {
    var selectedDimension = this.getSelectedDimension();
    if (selectedDimension && selectedDimension.column) {
      this.dimensionCellRange = this.createCellRange(CellRangeType.DIMENSION, selectedDimension.column);
    }
  };
  ChartDataModel.DEFAULT_CATEGORY = 'AG-GRID-DEFAULT-CATEGORY';
  __decorate$34([Autowired('columnModel')], ChartDataModel.prototype, "columnModel", void 0);
  __decorate$34([Autowired('valueService')], ChartDataModel.prototype, "valueService", void 0);
  __decorate$34([Autowired('rangeService')], ChartDataModel.prototype, "rangeService", void 0);
  __decorate$34([Autowired('rowRenderer')], ChartDataModel.prototype, "rowRenderer", void 0);
  __decorate$34([Autowired('chartTranslator')], ChartDataModel.prototype, "chartTranslator", void 0);
  __decorate$34([PostConstruct], ChartDataModel.prototype, "init", null);
  return ChartDataModel;
}(BeanStub);
var __assign$j = undefined && undefined.__assign || function () {
  __assign$j = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$j.apply(this, arguments);
};
var Observable = /** @class */function () {
  function Observable() {
    // Note that these maps can't be specified generically, so they are kept untyped.
    // Some methods in this class only need generics in their signatures, the generics inside the methods
    // are just for clarity. The generics in signatures allow for static type checking of user provided
    // listeners and for type inference, so that the users wouldn't have to specify the type of parameters
    // of their inline lambdas.
    this.allPropertyListeners = new Map(); // property name => property change listener => scopes
    this.allEventListeners = new Map(); // event type => event listener => scopes
  }

  Observable.prototype.addPropertyListener = function (name, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (!propertyListeners) {
      propertyListeners = new Map();
      allPropertyListeners.set(name, propertyListeners);
    }
    if (!propertyListeners.has(listener)) {
      var scopes_1 = new Set();
      propertyListeners.set(listener, scopes_1);
    }
    var scopes = propertyListeners.get(listener);
    if (scopes) {
      scopes.add(scope);
    }
  };
  Observable.prototype.removePropertyListener = function (name, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (propertyListeners) {
      if (listener) {
        var scopes = propertyListeners.get(listener);
        if (scopes) {
          scopes.delete(scope);
          if (!scopes.size) {
            propertyListeners.delete(listener);
          }
        }
      } else {
        propertyListeners.clear();
      }
    }
  };
  Observable.prototype.notifyPropertyListeners = function (name, oldValue, value) {
    var _this = this;
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (propertyListeners) {
      propertyListeners.forEach(function (scopes, listener) {
        scopes.forEach(function (scope) {
          return listener.call(scope, {
            type: name,
            source: _this,
            value: value,
            oldValue: oldValue
          });
        });
      });
    }
  };
  Observable.prototype.addEventListener = function (type, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allEventListeners = this.allEventListeners;
    var eventListeners = allEventListeners.get(type);
    if (!eventListeners) {
      eventListeners = new Map();
      allEventListeners.set(type, eventListeners);
    }
    if (!eventListeners.has(listener)) {
      var scopes_2 = new Set();
      eventListeners.set(listener, scopes_2);
    }
    var scopes = eventListeners.get(listener);
    if (scopes) {
      scopes.add(scope);
    }
  };
  Observable.prototype.removeEventListener = function (type, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allEventListeners = this.allEventListeners;
    var eventListeners = allEventListeners.get(type);
    if (eventListeners) {
      if (listener) {
        var scopes = eventListeners.get(listener);
        if (scopes) {
          scopes.delete(scope);
          if (!scopes.size) {
            eventListeners.delete(listener);
          }
        }
      } else {
        eventListeners.clear();
      }
    }
  };
  Observable.prototype.notifyEventListeners = function (types) {
    var _this = this;
    var allEventListeners = this.allEventListeners;
    types.forEach(function (type) {
      var listeners = allEventListeners.get(type);
      if (listeners) {
        listeners.forEach(function (scopes, listener) {
          scopes.forEach(function (scope) {
            return listener.call(scope, {
              type: type,
              source: _this
            });
          });
        });
      }
    });
  };
  // 'source' is added automatically and is always the object this method belongs to.
  Observable.prototype.fireEvent = function (event) {
    var _this = this;
    var listeners = this.allEventListeners.get(event.type);
    if (listeners) {
      listeners.forEach(function (scopes, listener) {
        scopes.forEach(function (scope) {
          return listener.call(scope, __assign$j(__assign$j({}, event), {
            source: _this
          }));
        });
      });
    }
  };
  Observable.privateKeyPrefix = '_';
  return Observable;
}();
function reactive() {
  var events = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    events[_i] = arguments[_i];
  }
  var debug = events.indexOf('debugger') >= 0;
  return function (target, key) {
    // `target` is either a constructor (static member) or prototype (instance member)
    var privateKey = Observable.privateKeyPrefix + key;
    var privateKeyEvents = privateKey + 'Events';
    if (!target[key]) {
      if (events) {
        target[privateKeyEvents] = events;
      }
      Object.defineProperty(target, key, {
        set: function set(value) {
          var oldValue = this[privateKey];
          // This is a way to stop inside the setter by adding the special
          // 'debugger' event to a reactive property, for example:
          //  @reactive('layoutChange', 'debugger') title?: Caption;
          if (debug) {
            // DO NOT REMOVE
            debugger;
          }
          if (value !== oldValue || typeof value === 'object' && value !== null) {
            this[privateKey] = value;
            this.notifyPropertyListeners(key, oldValue, value);
            var events_1 = this[privateKeyEvents];
            if (events_1) {
              this.notifyEventListeners(events_1);
            }
          }
        },
        get: function get() {
          return this[privateKey];
        },
        enumerable: true,
        configurable: true
      });
    }
  };
}
var __extends$3t = undefined && undefined.__extends || function () {
  var _extendStatics230 = function extendStatics(d, b) {
    _extendStatics230 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics230(d, b);
  };
  return function (d, b) {
    _extendStatics230(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$35 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Padding = /** @class */function (_super) {
  __extends$3t(Padding, _super);
  function Padding(top, right, bottom, left) {
    if (top === void 0) {
      top = 0;
    }
    if (right === void 0) {
      right = top;
    }
    if (bottom === void 0) {
      bottom = top;
    }
    if (left === void 0) {
      left = right;
    }
    var _this = _super.call(this) || this;
    _this.top = top;
    _this.right = right;
    _this.bottom = bottom;
    _this.left = left;
    return _this;
  }
  Padding.prototype.clear = function () {
    this.top = this.right = this.bottom = this.left = 0;
  };
  __decorate$35([reactive('layoutChange')], Padding.prototype, "top", void 0);
  __decorate$35([reactive('layoutChange')], Padding.prototype, "right", void 0);
  __decorate$35([reactive('layoutChange')], Padding.prototype, "bottom", void 0);
  __decorate$35([reactive('layoutChange')], Padding.prototype, "left", void 0);
  return Padding;
}(Observable);

// For small data structs like a bounding box, objects are superior to arrays
// in terms of performance (by 3-4% in Chrome 71, Safari 12 and by 20% in Firefox 64).
// They are also self descriptive and harder to abuse.
// For example, one has to do:
// `ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);`
// rather than become enticed by the much slower:
// `ctx.strokeRect(...bbox);`
// https://jsperf.com/array-vs-object-create-access
var BBox = /** @class */function () {
  function BBox(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
  BBox.prototype.isValid = function () {
    return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
  };
  BBox.prototype.dilate = function (value) {
    this.x -= value;
    this.y -= value;
    this.width += value * 2;
    this.height += value * 2;
  };
  BBox.prototype.containsPoint = function (x, y) {
    return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
  };
  BBox.prototype.render = function (ctx, params) {
    if (params === void 0) {
      params = BBox.noParams;
    }
    ctx.save();
    if (params.resetTransform) {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    ctx.strokeStyle = params.strokeStyle || 'cyan';
    ctx.lineWidth = params.lineWidth || 1;
    ctx.strokeRect(this.x, this.y, this.width, this.height);
    if (params.label) {
      ctx.fillStyle = params.fillStyle || 'black';
      ctx.textBaseline = 'bottom';
      ctx.fillText(params.label, this.x, this.y);
    }
    ctx.restore();
  };
  BBox.noParams = {};
  return BBox;
}();

/**
 * As of Jan 8, 2019, Firefox still doesn't implement
 * `getTransform(): DOMMatrix;`
 * `setTransform(transform?: DOMMatrix2DInit)`
 * in the `CanvasRenderingContext2D`.
 * Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=928150
 * IE11 and Edge 44 also don't have the support.
 * Thus this class, to keep track of the current transform and
 * combine transformations.
 * Standards:
 * https://html.spec.whatwg.org/dev/canvas.html
 * https://www.w3.org/TR/geometry-1/
 */
var Matrix = /** @class */function () {
  function Matrix(elements) {
    if (elements === void 0) {
      elements = [1, 0, 0, 1, 0, 0];
    }
    this.elements = elements;
  }
  Matrix.prototype.setElements = function (elements) {
    var e = this.elements;
    // `this.elements = elements.slice()` is 4-5 times slower
    // (in Chrome 71 and FF 64) than manually copying elements,
    // since slicing allocates new memory.
    // The performance of passing parameters individually
    // vs as an array is about the same in both browsers, so we
    // go with a single (array of elements) parameter, because
    // `setElements(elements)` and `setElements([a, b, c, d, e, f])`
    // calls give us roughly the same performance, versus
    // `setElements(...elements)` and `setElements(a, b, c, d, e, f)`,
    // where the spread operator causes a 20-30x performance drop
    // (30x when compiled to ES5's `.apply(this, elements)`
    //  20x when used natively).
    e[0] = elements[0];
    e[1] = elements[1];
    e[2] = elements[2];
    e[3] = elements[3];
    e[4] = elements[4];
    e[5] = elements[5];
    return this;
  };
  Matrix.prototype.setIdentityElements = function () {
    var e = this.elements;
    e[0] = 1;
    e[1] = 0;
    e[2] = 0;
    e[3] = 1;
    e[4] = 0;
    e[5] = 0;
    return this;
  };
  Object.defineProperty(Matrix.prototype, "identity", {
    get: function get() {
      var e = this.elements;
      return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "a", {
    get: function get() {
      return this.elements[0];
    },
    set: function set(value) {
      this.elements[0] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "b", {
    get: function get() {
      return this.elements[1];
    },
    set: function set(value) {
      this.elements[1] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "c", {
    get: function get() {
      return this.elements[2];
    },
    set: function set(value) {
      this.elements[2] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "d", {
    get: function get() {
      return this.elements[3];
    },
    set: function set(value) {
      this.elements[3] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "e", {
    get: function get() {
      return this.elements[4];
    },
    set: function set(value) {
      this.elements[4] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "f", {
    get: function get() {
      return this.elements[5];
    },
    set: function set(value) {
      this.elements[5] = value;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Performs the AxB matrix multiplication and saves the result
   * to `C`, if given, or to `A` otherwise.
   */
  Matrix.prototype.AxB = function (A, B, C) {
    var m11 = A[0],
      m12 = A[1],
      m21 = A[2],
      m22 = A[3],
      m31 = A[4],
      m32 = A[5];
    var o11 = B[0],
      o12 = B[1],
      o21 = B[2],
      o22 = B[3],
      o31 = B[4],
      o32 = B[5];
    C = C || A;
    C[0] = m11 * o11 + m21 * o12;
    C[1] = m12 * o11 + m22 * o12;
    C[2] = m11 * o21 + m21 * o22;
    C[3] = m12 * o21 + m22 * o22;
    C[4] = m11 * o31 + m21 * o32 + m31;
    C[5] = m12 * o31 + m22 * o32 + m32;
  };
  /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns the current matrix.
   * @param other
   */
  Matrix.prototype.multiplySelf = function (other) {
    this.AxB(this.elements, other.elements);
    return this;
  };
  /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns a new matrix.
   * @param other
   */
  Matrix.prototype.multiply = function (other) {
    var elements = new Array(6);
    this.AxB(this.elements, other.elements, elements);
    return new Matrix(elements);
  };
  Matrix.prototype.preMultiplySelf = function (other) {
    this.AxB(other.elements, this.elements, this.elements);
    return this;
  };
  /**
   * Returns the inverse of this matrix as a new matrix.
   */
  Matrix.prototype.inverse = function () {
    var _a = this.elements,
      a = _a[0],
      b = _a[1],
      c = _a[2],
      d = _a[3],
      e = _a[4],
      f = _a[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    return new Matrix([d, -b, -c, a, c * f - d * e, b * e - a * f]);
  };
  /**
   * Save the inverse of this matrix to the given matrix.
   */
  Matrix.prototype.inverseTo = function (other) {
    var _a = this.elements,
      a = _a[0],
      b = _a[1],
      c = _a[2],
      d = _a[3],
      e = _a[4],
      f = _a[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    other.setElements([d, -b, -c, a, c * f - d * e, b * e - a * f]);
    return this;
  };
  Matrix.prototype.invertSelf = function () {
    var elements = this.elements;
    var a = elements[0],
      b = elements[1],
      c = elements[2],
      d = elements[3],
      e = elements[4],
      f = elements[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    elements[0] = d;
    elements[1] = -b;
    elements[2] = -c;
    elements[3] = a;
    elements[4] = c * f - d * e;
    elements[5] = b * e - a * f;
    return this;
  };
  Matrix.prototype.clone = function () {
    return new Matrix(this.elements.slice());
  };
  Matrix.prototype.transformPoint = function (x, y) {
    var e = this.elements;
    return {
      x: x * e[0] + y * e[2] + e[4],
      y: x * e[1] + y * e[3] + e[5]
    };
  };
  Matrix.prototype.transformBBox = function (bbox, radius, target) {
    if (radius === void 0) {
      radius = 0;
    }
    var elements = this.elements;
    var xx = elements[0];
    var xy = elements[1];
    var yx = elements[2];
    var yy = elements[3];
    var h_w = bbox.width * 0.5;
    var h_h = bbox.height * 0.5;
    var cx = bbox.x + h_w;
    var cy = bbox.y + h_h;
    var w, h;
    if (radius) {
      h_w -= radius;
      h_h -= radius;
      var sx = Math.sqrt(xx * xx + yx * yx);
      var sy = Math.sqrt(xy * xy + yy * yy);
      w = Math.abs(h_w * xx) + Math.abs(h_h * yx) + Math.abs(sx * radius);
      h = Math.abs(h_w * xy) + Math.abs(h_h * yy) + Math.abs(sy * radius);
    } else {
      w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
      h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
    }
    if (!target) {
      target = new BBox(0, 0, 0, 0);
    }
    target.x = cx * xx + cy * yx + elements[4] - w;
    target.y = cx * xy + cy * yy + elements[5] - h;
    target.width = w + w;
    target.height = h + h;
    return target;
  };
  Matrix.prototype.toContext = function (ctx) {
    // It's fair to say that matrix multiplications are not cheap.
    // However, updating path definitions on every frame isn't either, so
    // it may be cheaper to just translate paths. It's also fair to
    // say, that most paths will have to be re-rendered anyway, say
    // rectangle paths in a bar chart, where an animation would happen when
    // the data set changes and existing bars are morphed into new ones.
    // Or a pie chart, where old sectors are also morphed into new ones.
    // Same for the line chart. The only plausible case where translating
    // existing paths would be enough, is the scatter chart, where marker
    // icons, typically circles, stay the same size. But if circle radii
    // are bound to some data points, even circle paths would have to be
    // updated. And thus it makes sense to optimize for fewer matrix
    // transforms, where transform matrices of paths are mostly identity
    // matrices and `x`/`y`, `centerX`/`centerY` and similar properties
    // are used to define a path at specific coordinates. And only groups
    // are used to collectively apply a transform to a set of nodes.
    // If the matrix is mostly identity (95% of the time),
    // the `if (this.isIdentity)` check can make this call 3-4 times
    // faster on average: https://jsperf.com/matrix-check-first-vs-always-set
    if (this.identity) {
      return;
    }
    var e = this.elements;
    ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
  };
  Matrix.flyweight = function (elements) {
    if (elements) {
      if (elements instanceof Matrix) {
        Matrix.matrix.setElements(elements.elements);
      } else {
        Matrix.matrix.setElements(elements);
      }
    } else {
      Matrix.matrix.setIdentityElements();
    }
    return Matrix.matrix;
  };
  Matrix.matrix = new Matrix();
  return Matrix;
}();
function createId(instance) {
  var constructor = instance.constructor;
  var className = constructor.className;
  if (!className) {
    throw new Error("The " + constructor + " is missing the 'className' property.");
  }
  return className + '-' + (constructor.id = (constructor.id || 0) + 1);
}
var PointerEvents;
(function (PointerEvents) {
  PointerEvents[PointerEvents["All"] = 0] = "All";
  PointerEvents[PointerEvents["None"] = 1] = "None";
})(PointerEvents || (PointerEvents = {}));
/**
 * Abstract scene graph node.
 * Each node can have zero or one parent and belong to zero or one scene.
 */
var Node$1 = /** @class */function () {
  function Node() {
    /**
     * Unique node ID in the form `ClassName-NaturalNumber`.
     */
    this.id = createId(this);
    /**
     * Some number to identify this node, typically within a `Group` node.
     * Usually this will be some enum value used as a selector.
     */
    this.tag = NaN;
    /**
     * To simplify the type system (especially in Selections) we don't have the `Parent` node
     * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
     * But we still need to distinguish regular leaf nodes from container leafs somehow.
     */
    this.isContainerNode = false;
    this._children = [];
    // Used to check for duplicate nodes.
    this.childSet = {}; // new Set<Node>()
    // These matrices may need to have package level visibility
    // for performance optimization purposes.
    this.matrix = new Matrix();
    this.inverseMatrix = new Matrix();
    this._dirtyTransform = false;
    this._scalingX = 1;
    this._scalingY = 1;
    /**
     * The center of scaling.
     * The default value of `null` means the scaling center will be
     * determined automatically, as the center of the bounding box
     * of a node.
     */
    this._scalingCenterX = null;
    this._scalingCenterY = null;
    this._rotationCenterX = null;
    this._rotationCenterY = null;
    /**
     * Rotation angle in radians.
     * The value is set as is. No normalization to the [-180, 180) or [0, 360)
     * interval is performed.
     */
    this._rotation = 0;
    this._translationX = 0;
    this._translationY = 0;
    /**
     * Each time a property of the node that effects how it renders changes
     * the `dirty` property of the node should be set to `true`. The change
     * to the `dirty` property of the node will propagate up to its parents
     * and eventually to the scene, at which point an animation frame callback
     * will be scheduled to rerender the scene and its nodes and reset the `dirty`
     * flags of all nodes and the {@link Scene._dirty | Scene} back to `false`.
     * Since changes to node properties are not rendered immediately, it's possible
     * to change as many properties on as many nodes as needed and the rendering
     * will still only happen once in the next animation frame callback.
     * The animation frame callback is only scheduled if it hasn't been already.
     */
    this._dirty = true;
    this._visible = true;
    this.dirtyZIndex = false;
    this._zIndex = 0;
    this.pointerEvents = PointerEvents.All;
  }
  /**
   * This is meaningfully faster than `instanceof` and should be the preferred way
   * of checking inside loops.
   * @param node
   */
  Node.isNode = function (node) {
    return node ? node.matrix !== undefined : false;
  };
  Node.prototype._setScene = function (value) {
    this._scene = value;
    var children = this.children;
    var n = children.length;
    for (var i = 0; i < n; i++) {
      children[i]._setScene(value);
    }
  };
  Object.defineProperty(Node.prototype, "scene", {
    get: function get() {
      return this._scene;
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype._setParent = function (value) {
    this._parent = value;
  };
  Object.defineProperty(Node.prototype, "parent", {
    get: function get() {
      return this._parent;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "children", {
    get: function get() {
      return this._children;
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.countChildren = function (depth) {
    if (depth === void 0) {
      depth = Node.MAX_SAFE_INTEGER;
    }
    if (depth <= 0) {
      return 0;
    }
    var children = this.children;
    var n = children.length;
    var size = n;
    for (var i = 0; i < n; i++) {
      size += children[i].countChildren(depth - 1);
    }
    return size;
  };
  /**
   * Appends one or more new node instances to this parent.
   * If one needs to:
   * - move a child to the end of the list of children
   * - move a child from one parent to another (including parents in other scenes)
   * one should use the {@link insertBefore} method instead.
   * @param nodes A node or nodes to append.
   */
  Node.prototype.append = function (nodes) {
    // Passing a single parameter to an open-ended version of `append`
    // would be 30-35% slower than this.
    if (Node.isNode(nodes)) {
      nodes = [nodes];
    }
    // The function takes an array rather than having open-ended
    // arguments like `...nodes: Node[]` because the latter is
    // transpiled to a function where the `arguments` object
    // is copied to a temporary array inside a loop.
    // So an array is created either way. And if we already have
    // an array of nodes we want to add, we have to use the prohibitively
    // expensive spread operator to pass it to the function,
    // and, on top of that, the copy of the `arguments` is still made.
    var n = nodes.length;
    for (var i = 0; i < n; i++) {
      var node = nodes[i];
      if (node.parent) {
        throw new Error(node + " already belongs to another parent: " + node.parent + ".");
      }
      if (node.scene) {
        throw new Error(node + " already belongs a scene: " + node.scene + ".");
      }
      if (this.childSet[node.id]) {
        // Cast to `any` to avoid `Property 'name' does not exist on type 'Function'`.
        throw new Error("Duplicate " + node.constructor.name + " node: " + node);
      }
      this._children.push(node);
      this.childSet[node.id] = true;
      node._setParent(this);
      node._setScene(this.scene);
    }
    this.dirty = true;
  };
  Node.prototype.appendChild = function (node) {
    if (node.parent) {
      throw new Error(node + " already belongs to another parent: " + node.parent + ".");
    }
    if (node.scene) {
      throw new Error(node + " already belongs to a scene: " + node.scene + ".");
    }
    if (this.childSet[node.id]) {
      // Cast to `any` to avoid `Property 'name' does not exist on type 'Function'`.
      throw new Error("Duplicate " + node.constructor.name + " node: " + node);
    }
    this._children.push(node);
    this.childSet[node.id] = true;
    node._setParent(this);
    node._setScene(this.scene);
    this.dirty = true;
    return node;
  };
  Node.prototype.removeChild = function (node) {
    if (node.parent === this) {
      var i = this.children.indexOf(node);
      if (i >= 0) {
        this._children.splice(i, 1);
        delete this.childSet[node.id];
        node._setParent();
        node._setScene();
        this.dirty = true;
        return node;
      }
    }
    throw new Error("The node to be removed is not a child of this node.");
  };
  /**
   * Inserts the node `node` before the existing child node `nextNode`.
   * If `nextNode` is null, insert `node` at the end of the list of children.
   * If the `node` belongs to another parent, it is first removed.
   * Returns the `node`.
   * @param node
   * @param nextNode
   */
  Node.prototype.insertBefore = function (node, nextNode) {
    var parent = node.parent;
    if (node.parent) {
      node.parent.removeChild(node);
    }
    if (nextNode && nextNode.parent === this) {
      var i = this.children.indexOf(nextNode);
      if (i >= 0) {
        this._children.splice(i, 0, node);
        this.childSet[node.id] = true;
        node._setParent(this);
        node._setScene(this.scene);
      } else {
        throw new Error(nextNode + " has " + parent + " as the parent, " + "but is not in its list of children.");
      }
      this.dirty = true;
    } else {
      this.append(node);
    }
    return node;
  };
  Object.defineProperty(Node.prototype, "nextSibling", {
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var children = parent.children;
        var index = children.indexOf(this);
        if (index >= 0 && index <= children.length - 1) {
          return children[index + 1];
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.transformPoint = function (x, y) {
    var matrix = Matrix.flyweight(this.matrix);
    var parent = this.parent;
    while (parent) {
      matrix.preMultiplySelf(parent.matrix);
      parent = parent.parent;
    }
    return matrix.invertSelf().transformPoint(x, y);
  };
  Node.prototype.inverseTransformPoint = function (x, y) {
    var matrix = Matrix.flyweight(this.matrix);
    var parent = this.parent;
    while (parent) {
      matrix.preMultiplySelf(parent.matrix);
      parent = parent.parent;
    }
    return matrix.transformPoint(x, y);
  };
  Object.defineProperty(Node.prototype, "dirtyTransform", {
    get: function get() {
      return this._dirtyTransform;
    },
    set: function set(value) {
      this._dirtyTransform = value;
      if (value) {
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingX", {
    get: function get() {
      return this._scalingX;
    },
    set: function set(value) {
      if (this._scalingX !== value) {
        this._scalingX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingY", {
    get: function get() {
      return this._scalingY;
    },
    set: function set(value) {
      if (this._scalingY !== value) {
        this._scalingY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingCenterX", {
    get: function get() {
      return this._scalingCenterX;
    },
    set: function set(value) {
      if (this._scalingCenterX !== value) {
        this._scalingCenterX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingCenterY", {
    get: function get() {
      return this._scalingCenterY;
    },
    set: function set(value) {
      if (this._scalingCenterY !== value) {
        this._scalingCenterY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationCenterX", {
    get: function get() {
      return this._rotationCenterX;
    },
    set: function set(value) {
      if (this._rotationCenterX !== value) {
        this._rotationCenterX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationCenterY", {
    get: function get() {
      return this._rotationCenterY;
    },
    set: function set(value) {
      if (this._rotationCenterY !== value) {
        this._rotationCenterY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotation", {
    get: function get() {
      return this._rotation;
    },
    set: function set(value) {
      if (this._rotation !== value) {
        this._rotation = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationDeg", {
    get: function get() {
      return this.rotation / Math.PI * 180;
    },
    /**
     * For performance reasons the rotation angle's internal representation
     * is in radians. Therefore, don't expect to get the same number you set.
     * Even with integer angles about a quarter of them from 0 to 359 cannot
     * be converted to radians and back without precision loss.
     * For example:
     *
     *     node.rotationDeg = 11;
     *     console.log(node.rotationDeg); // 10.999999999999998
     *
     * @param value Rotation angle in degrees.
     */
    set: function set(value) {
      this.rotation = value / 180 * Math.PI;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "translationX", {
    get: function get() {
      return this._translationX;
    },
    set: function set(value) {
      if (this._translationX !== value) {
        this._translationX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "translationY", {
    get: function get() {
      return this._translationY;
    },
    set: function set(value) {
      if (this._translationY !== value) {
        this._translationY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.containsPoint = function (x, y) {
    return false;
  };
  /**
   * Hit testing method.
   * Recursively checks if the given point is inside this node or any of its children.
   * Returns the first matching node or `undefined`.
   * Nodes that render later (show on top) are hit tested first.
   * @param x
   * @param y
   */
  Node.prototype.pickNode = function (x, y) {
    if (!this.visible || this.pointerEvents === PointerEvents.None || !this.containsPoint(x, y)) {
      return;
    }
    var children = this.children;
    if (children.length) {
      // Nodes added later should be hit-tested first,
      // as they are rendered on top of the previously added nodes.
      for (var i = children.length - 1; i >= 0; i--) {
        var hit = children[i].pickNode(x, y);
        if (hit) {
          return hit;
        }
      }
    } else if (!this.isContainerNode) {
      // a leaf node, but not a container leaf
      return this;
    }
  };
  Node.prototype.computeBBox = function () {
    return;
  };
  Node.prototype.computeBBoxCenter = function () {
    var bbox = this.computeBBox && this.computeBBox();
    if (bbox) {
      return [bbox.x + bbox.width * 0.5, bbox.y + bbox.height * 0.5];
    }
    return [0, 0];
  };
  Node.prototype.computeTransformMatrix = function () {
    // TODO: transforms without center of scaling and rotation correspond directly
    //       to `setAttribute('transform', 'translate(tx, ty) rotate(rDeg) scale(sx, sy)')`
    //       in SVG. Our use cases will mostly require positioning elements (rects, circles)
    //       within a group, rotating groups at right angles (e.g. for axis) and translating
    //       groups. We shouldn't even need `scale(1, -1)` (invert vertically), since this
    //       can be done using D3-like scales already by inverting the output range.
    //       So for now, just assume that centers of scaling and rotation are at the origin.
    // const [bbcx, bbcy] = this.computeBBoxCenter();
    var _a = [0, 0],
      bbcx = _a[0],
      bbcy = _a[1];
    var sx = this.scalingX;
    var sy = this.scalingY;
    var scx;
    var scy;
    if (sx === 1 && sy === 1) {
      scx = 0;
      scy = 0;
    } else {
      scx = this.scalingCenterX === null ? bbcx : this.scalingCenterX;
      scy = this.scalingCenterY === null ? bbcy : this.scalingCenterY;
    }
    var r = this.rotation;
    var cos = Math.cos(r);
    var sin = Math.sin(r);
    var rcx;
    var rcy;
    if (r === 0) {
      rcx = 0;
      rcy = 0;
    } else {
      rcx = this.rotationCenterX === null ? bbcx : this.rotationCenterX;
      rcy = this.rotationCenterY === null ? bbcy : this.rotationCenterY;
    }
    var tx = this.translationX;
    var ty = this.translationY;
    // The transform matrix `M` is a result of the following transformations:
    // 1) translate the center of scaling to the origin
    // 2) scale
    // 3) translate back
    // 4) translate the center of rotation to the origin
    // 5) rotate
    // 6) translate back
    // 7) translate
    //         (7)          (6)             (5)             (4)           (3)           (2)           (1)
    //     | 1 0 tx |   | 1 0 rcx |   | cos -sin 0 |   | 1 0 -rcx |   | 1 0 scx |   | sx 0 0 |   | 1 0 -scx |
    // M = | 0 1 ty | * | 0 1 rcy | * | sin  cos 0 | * | 0 1 -rcy | * | 0 1 scy | * | 0 sy 0 | * | 0 1 -scy |
    //     | 0 0  1 |   | 0 0  1  |   |  0    0  1 |   | 0 0  1   |   | 0 0  1  |   | 0  0 0 |   | 0 0  1   |
    // Translation after steps 1-4 above:
    var tx4 = scx * (1 - sx) - rcx;
    var ty4 = scy * (1 - sy) - rcy;
    this.dirtyTransform = false;
    this.matrix.setElements([cos * sx, sin * sx, -sin * sy, cos * sy, cos * tx4 - sin * ty4 + rcx + tx, sin * tx4 + cos * ty4 + rcy + ty]).inverseTo(this.inverseMatrix);
  };
  Object.defineProperty(Node.prototype, "dirty", {
    get: function get() {
      return this._dirty;
    },
    set: function set(value) {
      // TODO: check if we are already dirty (e.g. if (this._dirty !== value))
      //       if we are, then all parents and the scene have been
      //       notified already, and we are doing redundant work
      //       (but test if this is indeed the case)
      this._dirty = value;
      if (value) {
        if (this.parent) {
          this.parent.dirty = true;
        } else if (this.scene) {
          this.scene.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "visible", {
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      if (this._visible !== value) {
        this._visible = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "zIndex", {
    get: function get() {
      return this._zIndex;
    },
    set: function set(value) {
      if (this._zIndex !== value) {
        this._zIndex = value;
        if (this.parent) {
          this.parent.dirtyZIndex = true;
        }
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.MAX_SAFE_INTEGER = Math.pow(2, 53) - 1; // Number.MAX_SAFE_INTEGER
  return Node;
}();

/**
 * Creates a new object with a `parent` as its prototype
 * and copies properties from the `child` into it.
 * @param parent
 * @param child
 */
function chainObjects(parent, child) {
  var obj = Object.create(parent);
  for (var prop in child) {
    if (child.hasOwnProperty(prop)) {
      obj[prop] = child[prop];
    }
  }
  return obj;
}
function getValue(object, path, defaultValue) {
  var parts = Array.isArray(path) ? path : path.split('.');
  var value = object;
  try {
    parts.forEach(function (part) {
      value = value[part];
    });
  } catch (e) {
    if (arguments.length === 3) {
      value = defaultValue;
    } else {
      throw e;
    }
  }
  return value;
}
function emptyTarget(value) {
  return Array.isArray(value) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepMerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepMerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepMerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function defaultIsMergeableObject(value) {
  return isNonNullObject$1(value) && !isSpecial(value);
}
function isNonNullObject$1(value) {
  return !!value && typeof value === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]';
}
function deepMerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || defaultIsMergeableObject;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
function isObject$1(value) {
  return typeof value === 'object' && !Array.isArray(value);
}
var __extends$3u = undefined && undefined.__extends || function () {
  var _extendStatics231 = function extendStatics(d, b) {
    _extendStatics231 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics231(d, b);
  };
  return function (d, b) {
    _extendStatics231(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Shape = /** @class */function (_super) {
  __extends$3u(Shape, _super);
  function Shape() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.lastInstanceId = 0;
    _this._fillOpacity = 1;
    _this._strokeOpacity = 1;
    _this._fill = Shape.defaultStyles.fill;
    /**
     * Note that `strokeStyle = null` means invisible stroke,
     * while `lineWidth = 0` means no stroke, and sometimes this can mean different things.
     * For example, a rect shape with an invisible stroke may not align to the pixel grid
     * properly because the stroke affects the rules of alignment, and arc shapes forming
     * a pie chart will have a gap between them if they have an invisible stroke, whereas
     * there would be not gap if there was no stroke at all.
     * The preferred way of making the stroke invisible is setting the `lineWidth` to zero,
     * unless specific looks that is achieved by having an invisible stroke is desired.
     */
    _this._stroke = Shape.defaultStyles.stroke;
    _this._strokeWidth = Shape.defaultStyles.strokeWidth;
    _this._lineDash = Shape.defaultStyles.lineDash;
    _this._lineDashOffset = Shape.defaultStyles.lineDashOffset;
    _this._lineCap = Shape.defaultStyles.lineCap;
    _this._lineJoin = Shape.defaultStyles.lineJoin;
    _this._opacity = Shape.defaultStyles.opacity;
    _this.onShadowChange = function () {
      _this.dirty = true;
    };
    _this._fillShadow = Shape.defaultStyles.fillShadow;
    _this._strokeShadow = Shape.defaultStyles.strokeShadow;
    return _this;
  }
  /**
   * Creates a light-weight instance of the given shape (that serves as a template).
   * The created instance only stores the properites set on the instance itself
   * and the rest of the properties come via the prototype chain from the template.
   * This can greatly reduce memory usage in cases where one has many simular shapes,
   * for example, circles of different size, position and color. The exact memory usage
   * reduction will depend on the size of the template and the number of own properties
   * set on its lightweight instances, but will typically be around an order of magnitude
   * or more.
   *
   * Note: template shapes are not supposed to be part of the scene graph (they should not
   * have a parent).
   *
   * @param template
   */
  Shape.createInstance = function (template) {
    var shape = Object.create(template);
    shape._setParent(undefined);
    shape.id = template.id + '-Instance-' + String(++template.lastInstanceId);
    return shape;
  };
  /**
   * Restores the default styles introduced by this subclass.
   */
  Shape.prototype.restoreOwnStyles = function () {
    var styles = this.constructor.defaultStyles;
    var keys = Object.getOwnPropertyNames(styles);
    // getOwnPropertyNames is about 2.5 times faster than
    // for..in with the hasOwnProperty check and in this
    // case, where most properties are inherited, can be
    // more then an order of magnitude faster.
    for (var i = 0, n = keys.length; i < n; i++) {
      var key = keys[i];
      this[key] = styles[key];
    }
  };
  Shape.prototype.restoreAllStyles = function () {
    var styles = this.constructor.defaultStyles;
    for (var property in styles) {
      this[property] = styles[property];
    }
  };
  /**
   * Restores the base class default styles that have been overridden by this subclass.
   */
  Shape.prototype.restoreOverriddenStyles = function () {
    var styles = this.constructor.defaultStyles;
    var protoStyles = Object.getPrototypeOf(styles);
    for (var property in styles) {
      if (styles.hasOwnProperty(property) && protoStyles.hasOwnProperty(property)) {
        this[property] = styles[property];
      }
    }
  };
  Object.defineProperty(Shape.prototype, "fillOpacity", {
    get: function get() {
      return this._fillOpacity;
    },
    set: function set(value) {
      if (this._fillOpacity !== value) {
        this._fillOpacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeOpacity", {
    get: function get() {
      return this._strokeOpacity;
    },
    set: function set(value) {
      if (this._strokeOpacity !== value) {
        this._strokeOpacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "fill", {
    get: function get() {
      return this._fill;
    },
    set: function set(value) {
      if (this._fill !== value) {
        this._fill = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "stroke", {
    get: function get() {
      return this._stroke;
    },
    set: function set(value) {
      if (this._stroke !== value) {
        this._stroke = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "alignment", {
    // An offset value to align to the pixel grid.
    get: function get() {
      return Math.floor(this.strokeWidth) % 2 / 2;
    },
    enumerable: true,
    configurable: true
  });
  // Returns the aligned `start` or `length` value.
  // For example: `start` could be `y` and `length` could be `height` of a rectangle.
  Shape.prototype.align = function (alignment, start, length) {
    if (length != undefined) {
      return Math.floor(length) + Math.floor(start % 1 + length % 1);
    }
    return Math.floor(start) + alignment;
  };
  Object.defineProperty(Shape.prototype, "lineDash", {
    get: function get() {
      return this._lineDash;
    },
    set: function set(value) {
      var oldValue = this._lineDash;
      if (oldValue !== value) {
        if (oldValue && value && oldValue.length === value.length) {
          var identical = true;
          var n = value.length;
          for (var i = 0; i < n; i++) {
            if (oldValue[i] !== value[i]) {
              identical = false;
              break;
            }
          }
          if (identical) {
            return;
          }
        }
        this._lineDash = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineDashOffset", {
    get: function get() {
      return this._lineDashOffset;
    },
    set: function set(value) {
      if (this._lineDashOffset !== value) {
        this._lineDashOffset = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineCap", {
    get: function get() {
      return this._lineCap;
    },
    set: function set(value) {
      if (this._lineCap !== value) {
        this._lineCap = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineJoin", {
    get: function get() {
      return this._lineJoin;
    },
    set: function set(value) {
      if (this._lineJoin !== value) {
        this._lineJoin = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "opacity", {
    get: function get() {
      return this._opacity;
    },
    set: function set(value) {
      value = Math.min(1, Math.max(0, value));
      if (this._opacity !== value) {
        this._opacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "fillShadow", {
    get: function get() {
      return this._fillShadow;
    },
    set: function set(value) {
      var oldValue = this._fillShadow;
      if (oldValue !== value) {
        if (oldValue) {
          oldValue.removeEventListener('change', this.onShadowChange);
        }
        if (value) {
          value.addEventListener('change', this.onShadowChange);
        }
        this._fillShadow = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeShadow", {
    get: function get() {
      return this._strokeShadow;
    },
    set: function set(value) {
      var oldValue = this._strokeShadow;
      if (oldValue !== value) {
        if (oldValue) {
          oldValue.removeEventListener('change', this.onShadowChange);
        }
        if (value) {
          value.addEventListener('change', this.onShadowChange);
        }
        this._strokeShadow = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Shape.prototype.fillStroke = function (ctx) {
    if (!this.scene) {
      return;
    }
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    var globalAlpha = ctx.globalAlpha;
    if (this.fill) {
      ctx.fillStyle = this.fill;
      ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
      // The canvas context scaling (depends on the device's pixel ratio)
      // has no effect on shadows, so we have to account for the pixel ratio
      // manually here.
      var fillShadow = this.fillShadow;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fill();
    }
    ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    if (this.stroke && this.strokeWidth) {
      ctx.strokeStyle = this.stroke;
      ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
      ctx.lineWidth = this.strokeWidth;
      if (this.lineDash) {
        ctx.setLineDash(this.lineDash);
      }
      if (this.lineDashOffset) {
        ctx.lineDashOffset = this.lineDashOffset;
      }
      if (this.lineCap) {
        ctx.lineCap = this.lineCap;
      }
      if (this.lineJoin) {
        ctx.lineJoin = this.lineJoin;
      }
      var strokeShadow = this.strokeShadow;
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.stroke();
    }
  };
  Shape.prototype.containsPoint = function (x, y) {
    return this.isPointInPath(x, y);
  };
  /**
   * Defaults for style properties. Note that properties that affect the position
   * and shape of the node are not considered style properties, for example:
   * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
   * Can be used to reset to the original styling after some custom styling
   * has been applied (using the `restoreOwnStyles` and `restoreAllStyles` methods).
   * These static defaults are meant to be inherited by subclasses.
   */
  Shape.defaultStyles = chainObjects({}, {
    fill: 'black',
    stroke: undefined,
    strokeWidth: 0,
    lineDash: undefined,
    lineDashOffset: 0,
    lineCap: undefined,
    lineJoin: undefined,
    opacity: 1,
    fillShadow: undefined,
    strokeShadow: undefined
  });
  return Shape;
}(Node$1);

/**
 * Wraps the native Canvas element and overrides its CanvasRenderingContext2D to
 * provide resolution independent rendering based on `window.devicePixelRatio`.
 */
var HdpiCanvas = /** @class */function () {
  // The width/height attributes of the Canvas element default to
  // 300/150 according to w3.org.
  function HdpiCanvas(document, width, height) {
    if (document === void 0) {
      document = window.document;
    }
    if (width === void 0) {
      width = 600;
    }
    if (height === void 0) {
      height = 300;
    }
    this._container = undefined;
    // `NaN` is deliberate here, so that overrides are always applied
    // and the `resetTransform` inside the `resize` method works in IE11.
    this._pixelRatio = NaN;
    this._width = 0;
    this._height = 0;
    this.document = document;
    this.element = document.createElement('canvas');
    this.context = this.element.getContext('2d');
    this.element.style.userSelect = 'none';
    this.element.style.display = 'block';
    this.setPixelRatio();
    this.resize(width, height);
  }
  Object.defineProperty(HdpiCanvas.prototype, "container", {
    get: function get() {
      return this._container;
    },
    set: function set(value) {
      if (this._container !== value) {
        this.remove();
        if (value) {
          value.appendChild(this.element);
        }
        this._container = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.prototype.remove = function () {
    var parentNode = this.element.parentNode;
    if (parentNode != null) {
      parentNode.removeChild(this.element);
    }
  };
  HdpiCanvas.prototype.destroy = function () {
    this.element.remove();
    this._canvas = undefined;
    Object.freeze(this);
  };
  HdpiCanvas.prototype.toImage = function () {
    var img = this.document.createElement('img');
    img.src = this.getDataURL();
    return img;
  };
  HdpiCanvas.prototype.getDataURL = function (type) {
    return this.element.toDataURL(type);
  };
  /**
   * @param fileName The name of the file upon save. The `.png` extension is going to be added automatically.
   */
  HdpiCanvas.prototype.download = function (fileName) {
    fileName = ((fileName || '').trim() || 'image') + '.png';
    // Chart images saved as JPEG are a few times larger at 50% quality than PNG images,
    // so we don't support saving to JPEG.
    var type = 'image/png';
    var dataUrl = this.getDataURL(type);
    var document = this.document;
    if (navigator.msSaveOrOpenBlob) {
      // IE11
      var binary = atob(dataUrl.split(',')[1]); // strip the `data:image/png;base64,` part
      var array = [];
      for (var i = 0, n = binary.length; i < n; i++) {
        array.push(binary.charCodeAt(i));
      }
      var blob = new Blob([new Uint8Array(array)], {
        type: type
      });
      navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      var a = document.createElement('a');
      a.href = dataUrl;
      a.download = fileName;
      a.style.display = 'none';
      document.body.appendChild(a); // required for the `click` to work in Firefox
      a.click();
      document.body.removeChild(a);
    }
  };
  Object.defineProperty(HdpiCanvas.prototype, "pixelRatio", {
    get: function get() {
      return this._pixelRatio;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Changes the pixel ratio of the Canvas element to the given value,
   * or uses the window.devicePixelRatio (default), then resizes the Canvas
   * element accordingly (default).
   */
  HdpiCanvas.prototype.setPixelRatio = function (ratio) {
    var pixelRatio = ratio || window.devicePixelRatio;
    if (pixelRatio === this.pixelRatio) {
      return;
    }
    HdpiCanvas.overrideScale(this.context, pixelRatio);
    this._pixelRatio = pixelRatio;
    this.resize(this.width, this.height);
  };
  Object.defineProperty(HdpiCanvas.prototype, "pixelated", {
    get: function get() {
      return this.element.style.imageRendering === 'pixelated';
    },
    set: function set(value) {
      this.element.style.imageRendering = value ? 'pixelated' : 'auto';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas.prototype, "width", {
    get: function get() {
      return this._width;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas.prototype, "height", {
    get: function get() {
      return this._height;
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.prototype.resize = function (width, height) {
    if (!(width > 0 && height > 0)) {
      return;
    }
    var _a = this,
      element = _a.element,
      context = _a.context,
      pixelRatio = _a.pixelRatio;
    element.width = Math.round(width * pixelRatio);
    element.height = Math.round(height * pixelRatio);
    element.style.width = width + 'px';
    element.style.height = height + 'px';
    context.resetTransform();
    this._width = width;
    this._height = height;
  };
  Object.defineProperty(HdpiCanvas, "textMeasuringContext", {
    get: function get() {
      if (this._textMeasuringContext) {
        return this._textMeasuringContext;
      }
      var canvas = document.createElement('canvas');
      return this._textMeasuringContext = canvas.getContext('2d');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas, "svgText", {
    get: function get() {
      if (this._svgText) {
        return this._svgText;
      }
      var xmlns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(xmlns, 'svg');
      svg.setAttribute('width', '100');
      svg.setAttribute('height', '100');
      // Add a descriptive class name in case someone sees this SVG element
      // in devtools and wonders about its purpose:
      if (svg.classList) {
        svg.classList.add('text-measuring-svg');
      } else {
        svg.setAttribute('class', 'text-measuring-svg');
      }
      svg.style.position = 'absolute';
      svg.style.top = '-1000px';
      svg.style.visibility = 'hidden';
      var svgText = document.createElementNS(xmlns, 'text');
      svgText.setAttribute('x', '0');
      svgText.setAttribute('y', '30');
      svgText.setAttribute('text', 'black');
      svg.appendChild(svgText);
      document.body.appendChild(svg);
      this._svgText = svgText;
      return svgText;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas, "has", {
    get: function get() {
      if (this._has) {
        return this._has;
      }
      var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
      var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
      var isSafari = !isChrome && navigator.userAgent.indexOf('Safari') > -1;
      return this._has = Object.freeze({
        textMetrics: this.textMeasuringContext.measureText('test').actualBoundingBoxDescent !== undefined
        // Firefox implemented advanced TextMetrics object in v74:
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1102584
        // but it's buggy, so we'll keed using the SVG for text measurement in Firefox for now.
        && !isFirefox && !isSafari,
        getTransform: this.textMeasuringContext.getTransform !== undefined
      });
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.measureText = function (text, font, textBaseline, textAlign) {
    var ctx = this.textMeasuringContext;
    ctx.font = font;
    ctx.textBaseline = textBaseline;
    ctx.textAlign = textAlign;
    return ctx.measureText(text);
  };
  /**
   * Returns the width and height of the measured text.
   * @param text The single-line text to measure.
   * @param font The font shorthand string.
   */
  HdpiCanvas.getTextSize = function (text, font) {
    if (this.has.textMetrics) {
      var ctx = this.textMeasuringContext;
      ctx.font = font;
      var metrics = ctx.measureText(text);
      return {
        width: metrics.width,
        height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
      };
    } else {
      return this.measureSvgText(text, font);
    }
  };
  HdpiCanvas.measureSvgText = function (text, font) {
    var cache = this.textSizeCache;
    var fontCache = cache[font];
    // Note: consider not caching the size of numeric strings.
    // For example: if (isNaN(+text)) { // skip
    if (fontCache) {
      var size_1 = fontCache[text];
      if (size_1) {
        return size_1;
      }
    } else {
      cache[font] = {};
    }
    var svgText = this.svgText;
    svgText.style.font = font;
    svgText.textContent = text;
    // `getBBox` returns an instance of `SVGRect` with the same `width` and `height`
    // measurements as `DOMRect` instance returned by the `getBoundingClientRect`.
    // But the `SVGRect` instance has half the properties of the `DOMRect`,
    // so we use the `getBBox` method.
    var bbox = svgText.getBBox();
    var size = {
      width: bbox.width,
      height: bbox.height
    };
    cache[font][text] = size;
    return size;
  };
  HdpiCanvas.overrideScale = function (ctx, scale) {
    var depth = 0;
    var overrides = {
      save: function save() {
        this.$save();
        depth++;
      },
      restore: function restore() {
        if (depth > 0) {
          this.$restore();
          depth--;
        }
      },
      setTransform: function setTransform(a, b, c, d, e, f) {
        this.$setTransform(a * scale, b * scale, c * scale, d * scale, e * scale, f * scale);
      },
      resetTransform: function resetTransform() {
        // As of Jan 8, 2019, `resetTransform` is still an "experimental technology",
        // and doesn't work in IE11 and Edge 44.
        this.$setTransform(scale, 0, 0, scale, 0, 0);
        this.save();
        depth = 0;
        // The scale above will be impossible to restore,
        // because we override the `ctx.restore` above and
        // check `depth` there.
      }
    };

    for (var name_1 in overrides) {
      if (overrides.hasOwnProperty(name_1)) {
        // Save native methods under prefixed names,
        // if this hasn't been done by the previous overrides already.
        if (!ctx['$' + name_1]) {
          ctx['$' + name_1] = ctx[name_1];
        }
        // Replace native methods with overrides,
        // or previous overrides with the new ones.
        ctx[name_1] = overrides[name_1];
      }
    }
  };
  HdpiCanvas.textSizeCache = {};
  return HdpiCanvas;
}();
var __extends$3v = undefined && undefined.__extends || function () {
  var _extendStatics232 = function extendStatics(d, b) {
    _extendStatics232 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics232(d, b);
  };
  return function (d, b) {
    _extendStatics232(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Text = /** @class */function (_super) {
  __extends$3v(Text, _super);
  function Text() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this.lineBreakRegex = /\r?\n/g;
    _this.lines = [];
    _this._text = '';
    _this._dirtyFont = true;
    _this._fontSize = 10;
    _this._fontFamily = 'sans-serif';
    _this._textAlign = Text.defaultStyles.textAlign;
    _this._textBaseline = Text.defaultStyles.textBaseline;
    _this._lineHeight = 14;
    return _this;
  }
  Object.defineProperty(Text.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.splitText = function () {
    this.lines = this._text.split(this.lineBreakRegex);
  };
  Object.defineProperty(Text.prototype, "text", {
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      var str = String(value); // `value` can be an object here
      if (this._text !== str) {
        this._text = str;
        this.splitText();
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "font", {
    get: function get() {
      if (this.dirtyFont) {
        this.dirtyFont = false;
        this._font = getFont$1(this.fontSize, this.fontFamily, this.fontStyle, this.fontWeight);
      }
      return this._font;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "dirtyFont", {
    get: function get() {
      return this._dirtyFont;
    },
    set: function set(value) {
      if (this._dirtyFont !== value) {
        this._dirtyFont = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontStyle", {
    get: function get() {
      return this._fontStyle;
    },
    set: function set(value) {
      if (this._fontStyle !== value) {
        this._fontStyle = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontWeight", {
    get: function get() {
      return this._fontWeight;
    },
    set: function set(value) {
      if (this._fontWeight !== value) {
        this._fontWeight = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontSize", {
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      if (!isFinite(value)) {
        value = 10;
      }
      if (this._fontSize !== value) {
        this._fontSize = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontFamily", {
    get: function get() {
      return this._fontFamily;
    },
    set: function set(value) {
      if (this._fontFamily !== value) {
        this._fontFamily = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textAlign", {
    get: function get() {
      return this._textAlign;
    },
    set: function set(value) {
      if (this._textAlign !== value) {
        this._textAlign = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textBaseline", {
    get: function get() {
      return this._textBaseline;
    },
    set: function set(value) {
      if (this._textBaseline !== value) {
        this._textBaseline = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "lineHeight", {
    get: function get() {
      return this._lineHeight;
    },
    set: function set(value) {
      // Multi-line text is complicated because:
      // - Canvas does not support it natively, so we have to implement it manually
      // - need to know the height of each line -> need to parse the font shorthand ->
      //   generally impossible to do because font size may not be in pixels
      // - so, need to measure the text instead, each line individually -> expensive
      // - or make the user provide the line height manually for multi-line text
      // - computeBBox should use the lineHeight for multi-line text but ignore it otherwise
      // - textBaseline kind of loses its meaning for multi-line text
      if (this._lineHeight !== value) {
        this._lineHeight = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.computeBBox = function () {
    return HdpiCanvas.has.textMetrics ? this.getPreciseBBox() : this.getApproximateBBox();
  };
  Text.prototype.getPreciseBBox = function () {
    var metrics = HdpiCanvas.measureText(this.text, this.font, this.textBaseline, this.textAlign);
    return new BBox(this.x - metrics.actualBoundingBoxLeft, this.y - metrics.actualBoundingBoxAscent, metrics.width, metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
  };
  Text.prototype.getApproximateBBox = function () {
    var size = HdpiCanvas.getTextSize(this.text, this.font);
    var _a = this,
      x = _a.x,
      y = _a.y;
    switch (this.textAlign) {
      case 'end':
      case 'right':
        x -= size.width;
        break;
      case 'center':
        x -= size.width / 2;
    }
    switch (this.textBaseline) {
      case 'alphabetic':
        y -= size.height * 0.7;
        break;
      case 'middle':
        y -= size.height * 0.45;
        break;
      case 'ideographic':
        y -= size.height;
        break;
      case 'hanging':
        y -= size.height * 0.2;
        break;
      case 'bottom':
        y -= size.height;
        break;
    }
    return new BBox(x, y, size.width, size.height);
  };
  Text.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return bbox ? bbox.containsPoint(point.x, point.y) : false;
  };
  Text.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Text.prototype.render = function (ctx) {
    if (!this.lines.length || !this.scene) {
      return;
    }
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    // this.matrix.transformBBox(this.computeBBox!()).render(ctx); // debug
    this.matrix.toContext(ctx);
    var _a = this,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth;
    ctx.font = this.font;
    ctx.textAlign = this.textAlign;
    ctx.textBaseline = this.textBaseline;
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    var globalAlpha = ctx.globalAlpha;
    if (fill) {
      ctx.fillStyle = fill;
      ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
      var _b = this,
        fillShadow = _b.fillShadow,
        text = _b.text,
        x = _b.x,
        y = _b.y;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fillText(text, x, y);
    }
    if (stroke && strokeWidth) {
      ctx.strokeStyle = stroke;
      ctx.lineWidth = strokeWidth;
      ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
      var _c = this,
        lineDash = _c.lineDash,
        lineDashOffset = _c.lineDashOffset,
        lineCap = _c.lineCap,
        lineJoin = _c.lineJoin,
        strokeShadow = _c.strokeShadow,
        text = _c.text,
        x = _c.x,
        y = _c.y;
      if (lineDash) {
        ctx.setLineDash(lineDash);
      }
      if (lineDashOffset) {
        ctx.lineDashOffset = lineDashOffset;
      }
      if (lineCap) {
        ctx.lineCap = lineCap;
      }
      if (lineJoin) {
        ctx.lineJoin = lineJoin;
      }
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.strokeText(text, x, y);
    }
    this.dirty = false;
  };
  Text.className = 'Text';
  Text.defaultStyles = chainObjects(Shape.defaultStyles, {
    textAlign: 'start',
    fontStyle: undefined,
    fontWeight: undefined,
    fontSize: 10,
    fontFamily: 'sans-serif',
    textBaseline: 'alphabetic'
  });
  return Text;
}(Shape);
function getFont$1(fontSize, fontFamily, fontStyle, fontWeight) {
  return [fontStyle || '', fontWeight || '', fontSize + 'px', fontFamily].join(' ').trim();
}
var __extends$3w = undefined && undefined.__extends || function () {
  var _extendStatics233 = function extendStatics(d, b) {
    _extendStatics233 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics233(d, b);
  };
  return function (d, b) {
    _extendStatics233(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$36 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Caption = /** @class */function (_super) {
  __extends$3w(Caption, _super);
  function Caption() {
    var _this = _super.call(this) || this;
    _this.node = new Text();
    _this.enabled = false;
    _this.padding = new Padding(10);
    var node = _this.node;
    node.textAlign = 'center';
    node.textBaseline = 'top';
    node.pointerEvents = PointerEvents.None;
    return _this;
  }
  Object.defineProperty(Caption.prototype, "text", {
    get: function get() {
      return this.node.text;
    },
    set: function set(value) {
      if (this.node.text !== value) {
        this.node.text = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Caption.prototype, "fontStyle", {
    get: function get() {
      return this.node.fontStyle;
    },
    set: function set(value) {
      if (this.node.fontStyle !== value) {
        this.node.fontStyle = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Caption.prototype, "fontWeight", {
    get: function get() {
      return this.node.fontWeight;
    },
    set: function set(value) {
      if (this.node.fontWeight !== value) {
        this.node.fontWeight = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Caption.prototype, "fontSize", {
    get: function get() {
      return this.node.fontSize;
    },
    set: function set(value) {
      if (this.node.fontSize !== value) {
        this.node.fontSize = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Caption.prototype, "fontFamily", {
    get: function get() {
      return this.node.fontFamily;
    },
    set: function set(value) {
      if (this.node.fontFamily !== value) {
        this.node.fontFamily = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Caption.prototype, "color", {
    get: function get() {
      return this.node.fill;
    },
    set: function set(value) {
      if (this.node.fill !== value) {
        this.node.fill = value;
        this.fireEvent({
          type: 'change'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  __decorate$36([reactive('change')], Caption.prototype, "enabled", void 0);
  __decorate$36([reactive('change')], Caption.prototype, "padding", void 0);
  return Caption;
}(Observable);
var constant = function constant(x) {
  return function () {
    return x;
  };
};
function interpolateNumber(a, b) {
  a = +a;
  b = +b;
  return function (t) {
    return a * (1 - t) + b * t;
  };
}
function date(a, b) {
  var date = new Date();
  var msA = +a;
  var msB = +b;
  return function (t) {
    date.setTime(msA * (1 - t) + msB * t);
    return date;
  };
}
function array(a, b) {
  var nb = b ? b.length : 0;
  var na = a ? Math.min(nb, a.length) : 0;
  var x = new Array(na);
  var c = new Array(nb);
  var i;
  for (i = 0; i < na; ++i) {
    x[i] = interpolateValue(a[i], b[i]);
  }
  for (; i < nb; ++i) {
    c[i] = b[i];
  }
  return function (t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }
    return c;
  };
}
function object(a, b) {
  var i = {};
  var c = {};
  var k;
  if (a === null || typeof a !== 'object') {
    a = {};
  }
  if (b === null || typeof b !== 'object') {
    b = {};
  }
  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }
    return c;
  };
}
var Color$1 = /** @class */function () {
  /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */
  function Color(r, g, b, a) {
    if (a === void 0) {
      a = 1;
    }
    // NaN is treated as 0.
    this.r = Math.min(1, Math.max(0, r || 0));
    this.g = Math.min(1, Math.max(0, g || 0));
    this.b = Math.min(1, Math.max(0, b || 0));
    this.a = Math.min(1, Math.max(0, a || 0));
  }
  /**
   * The given string can be in one of the following formats:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   * @param str
   */
  Color.fromString = function (str) {
    // hexadecimal notation
    if (str.indexOf('#') >= 0) {
      // there can be some leading whitespace
      return Color.fromHexString(str);
    }
    // color name
    var hex = Color.nameToHex[str];
    if (hex) {
      return Color.fromHexString(hex);
    }
    // rgb(a) notation
    if (str.indexOf('rgb') >= 0) {
      return Color.fromRgbaString(str);
    }
    throw new Error("Invalid color string: '" + str + "'");
  };
  // See https://drafts.csswg.org/css-color/#hex-notation
  Color.parseHex = function (input) {
    input = input.replace(/ /g, '').slice(1);
    var parts;
    switch (input.length) {
      case 6:
      case 8:
        parts = [];
        for (var i = 0; i < input.length; i += 2) {
          parts.push(parseInt("" + input[i] + input[i + 1], 16));
        }
        break;
      case 3:
      case 4:
        parts = input.split('').map(function (p) {
          return parseInt(p, 16);
        }).map(function (p) {
          return p + p * 16;
        });
        break;
    }
    if (parts.length >= 3) {
      if (parts.every(function (p) {
        return p >= 0;
      })) {
        if (parts.length === 3) {
          parts.push(255);
        }
        return parts;
      }
    }
  };
  Color.fromHexString = function (str) {
    var values = Color.parseHex(str);
    if (values) {
      var r = values[0],
        g = values[1],
        b = values[2],
        a = values[3];
      return new Color(r / 255, g / 255, b / 255, a / 255);
    }
    throw new Error("Malformed hexadecimal color string: '" + str + "'");
  };
  Color.stringToRgba = function (str) {
    // Find positions of opening and closing parentheses.
    var _a = [NaN, NaN],
      po = _a[0],
      pc = _a[1];
    for (var i = 0; i < str.length; i++) {
      var c = str[i];
      if (!po && c === '(') {
        po = i;
      } else if (c === ')') {
        pc = i;
        break;
      }
    }
    var contents = po && pc && str.substring(po + 1, pc);
    if (!contents) {
      return;
    }
    var parts = contents.split(',');
    var rgba = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var value = parseFloat(part);
      if (isNaN(value)) {
        return;
      }
      if (part.indexOf('%') >= 0) {
        // percentage r, g, or b value
        value = Math.max(0, Math.min(100, value));
        value /= 100;
      } else {
        if (i === 3) {
          // alpha component
          value = Math.max(0, Math.min(1, value));
        } else {
          // absolute r, g, or b value
          value = Math.max(0, Math.min(255, value));
          value /= 255;
        }
      }
      rgba.push(value);
    }
    return rgba;
  };
  Color.fromRgbaString = function (str) {
    var rgba = Color.stringToRgba(str);
    if (rgba) {
      if (rgba.length === 3) {
        return new Color(rgba[0], rgba[1], rgba[2]);
      } else if (rgba.length === 4) {
        return new Color(rgba[0], rgba[1], rgba[2], rgba[3]);
      }
    }
    throw new Error("Malformed rgb/rgba color string: '" + str + "'");
  };
  Color.fromArray = function (arr) {
    if (arr.length === 4) {
      return new Color(arr[0], arr[1], arr[2], arr[3]);
    }
    if (arr.length === 3) {
      return new Color(arr[0], arr[1], arr[2]);
    }
    throw new Error('The given array should contain 3 or 4 color components (numbers).');
  };
  Color.fromHSB = function (h, s, b, alpha) {
    if (alpha === void 0) {
      alpha = 1;
    }
    var rgb = Color.HSBtoRGB(h, s, b);
    return new Color(rgb[0], rgb[1], rgb[2], alpha);
  };
  Color.padHex = function (str) {
    // Can't use `padStart(2, '0')` here because of IE.
    return str.length === 1 ? '0' + str : str;
  };
  Color.prototype.toHexString = function () {
    var hex = '#' + Color.padHex(Math.round(this.r * 255).toString(16)) + Color.padHex(Math.round(this.g * 255).toString(16)) + Color.padHex(Math.round(this.b * 255).toString(16));
    if (this.a < 1) {
      hex += Color.padHex(Math.round(this.a * 255).toString(16));
    }
    return hex;
  };
  Color.prototype.toRgbaString = function (fractionDigits) {
    if (fractionDigits === void 0) {
      fractionDigits = 3;
    }
    var components = [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
    var k = Math.pow(10, fractionDigits);
    if (this.a !== 1) {
      components.push(Math.round(this.a * k) / k);
      return "rgba(" + components.join(', ') + ")";
    }
    return "rgb(" + components.join(', ') + ")";
  };
  Color.prototype.toString = function () {
    if (this.a === 1) {
      return this.toHexString();
    }
    return this.toRgbaString();
  };
  Color.prototype.toHSB = function () {
    return Color.RGBtoHSB(this.r, this.g, this.b);
  };
  /**
   * Converts the given RGB triple to an array of HSB (HSV) components.
   * The hue component will be `NaN` for achromatic colors.
   */
  Color.RGBtoHSB = function (r, g, b) {
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var S = max !== 0 ? (max - min) / max : 0;
    var H = NaN;
    // min == max, means all components are the same
    // and the color is a shade of gray with no hue (H is NaN)
    if (min !== max) {
      var delta = max - min;
      var rc = (max - r) / delta;
      var gc = (max - g) / delta;
      var bc = (max - b) / delta;
      if (r === max) {
        H = bc - gc;
      } else if (g === max) {
        H = 2.0 + rc - bc;
      } else {
        H = 4.0 + gc - rc;
      }
      H /= 6.0;
      if (H < 0) {
        H = H + 1.0;
      }
    }
    return [H * 360, S, max];
  };
  /**
   * Converts the given HSB (HSV) triple to an array of RGB components.
   */
  Color.HSBtoRGB = function (H, S, B) {
    if (isNaN(H)) {
      H = 0;
    }
    H = (H % 360 + 360) % 360 / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
    var r = 0;
    var g = 0;
    var b = 0;
    if (S === 0) {
      r = g = b = B;
    } else {
      var h = (H - Math.floor(H)) * 6;
      var f = h - Math.floor(h);
      var p = B * (1 - S);
      var q = B * (1 - S * f);
      var t = B * (1 - S * (1 - f));
      switch (h >> 0) {
        // discard the floating point part of the number
        case 0:
          r = B;
          g = t;
          b = p;
          break;
        case 1:
          r = q;
          g = B;
          b = p;
          break;
        case 2:
          r = p;
          g = B;
          b = t;
          break;
        case 3:
          r = p;
          g = q;
          b = B;
          break;
        case 4:
          r = t;
          g = p;
          b = B;
          break;
        case 5:
          r = B;
          g = p;
          b = q;
          break;
      }
    }
    return [r, g, b];
  };
  Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
    var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
    var b = hsb[2];
    if (b == 0 && brightnessFactor > 1.0) {
      b = 0.05;
    }
    var h = ((hsb[0] + hueShift) % 360 + 360) % 360;
    var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
    b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
    var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
    var rgba = Color.HSBtoRGB(h, s, b);
    rgba.push(a);
    return Color.fromArray(rgba);
  };
  Color.prototype.brighter = function () {
    return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
  };
  Color.prototype.darker = function () {
    return this.derive(0, 1.0, 0.7, 1.0);
  };
  /**
   * CSS Color Module Level 4:
   * https://drafts.csswg.org/css-color/#named-colors
   */
  Color.nameToHex = Object.freeze({
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#00FFFF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000000',
    blanchedalmond: '#FFEBCD',
    blue: '#0000FF',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#00FFFF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgreen: '#006400',
    darkgrey: '#A9A9A9',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#FF00FF',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    grey: '#808080',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgreen: '#90EE90',
    lightgrey: '#D3D3D3',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#00FF00',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#FF00FF',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#FF0000',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFFFFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FFFF00',
    yellowgreen: '#9ACD32'
  });
  return Color;
}();
function color(a, b) {
  if (typeof a === 'string') {
    try {
      a = Color$1.fromString(a);
    } catch (e) {
      a = Color$1.fromArray([0, 0, 0]);
    }
  }
  if (typeof b === 'string') {
    try {
      b = Color$1.fromString(b);
    } catch (e) {
      b = Color$1.fromArray([0, 0, 0]);
    }
  }
  var red = interpolateNumber(a.r, b.r);
  var green = interpolateNumber(a.g, b.g);
  var blue = interpolateNumber(a.b, b.b);
  var alpha = interpolateNumber(a.a, b.a);
  return function (t) {
    return Color$1.fromArray([red(t), green(t), blue(t), alpha(t)]).toRgbaString();
  };
}
function interpolateValue(a, b) {
  var t = typeof b;
  var c;
  if (b == null || t === 'boolean') {
    return constant(b);
  }
  if (t === 'number') {
    return interpolateNumber(a, b);
  }
  if (t === 'string') {
    try {
      c = Color$1.fromString(b);
      b = c;
      return color(a, b);
    } catch (e) {
      // return string(a, b);
    }
  }
  if (b instanceof Color$1) {
    return color(a, b);
  }
  if (b instanceof Date) {
    return date(a, b);
  }
  if (Array.isArray(b)) {
    return array(a, b);
  }
  if (typeof b.valueOf !== 'function' && typeof b.toString !== 'function' || isNaN(b)) {
    return object(a, b);
  }
  return interpolateNumber(a, b);
}
function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function bisectRight(list, x, comparator, lo, hi) {
  if (lo === void 0) {
    lo = 0;
  }
  if (hi === void 0) {
    hi = list.length;
  }
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (comparator(list[mid], x) > 0) {
      // list[mid] > x
      hi = mid;
    } else {
      lo = mid + 1;
    }
  }
  return lo;
}
function complexBisectRight(list, x, map, lo, hi) {
  if (lo === void 0) {
    lo = 0;
  }
  if (hi === void 0) {
    hi = list.length;
  }
  var comparator = ascendingComparator(map);
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (comparator(list[mid], x) < 0) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }
  return lo;
}
function ascendingComparator(map) {
  return function (item, x) {
    return ascending(map(item), x);
  };
}
var constant$1 = function constant$1(x) {
  return function () {
    return x;
  };
};
var identity = function identity(x) {
  return x;
};
function clamper(domain) {
  var _a;
  var a = domain[0];
  var b = domain[domain.length - 1];
  if (a > b) {
    _a = [b, a], a = _a[0], b = _a[1];
  }
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}
var ContinuousScale = /** @class */function () {
  function ContinuousScale() {
    /**
     * The output value of the scale for `undefined` or `NaN` input values.
     */
    this.unknown = undefined;
    this.clamper = clamper;
    this._clamp = identity;
    this._domain = [0, 1];
    this._range = [0, 1];
    this.transform = identity; // transforms domain value
    this.untransform = identity; // untransforms domain value
    this._interpolate = interpolateValue;
    this.rescale();
  }
  Object.defineProperty(ContinuousScale.prototype, "clamp", {
    get: function get() {
      return this._clamp !== identity;
    },
    set: function set(value) {
      this._clamp = value ? this.clamper(this.domain) : identity;
    },
    enumerable: true,
    configurable: true
  });
  ContinuousScale.prototype.setDomain = function (values) {
    this._domain = Array.prototype.map.call(values, function (v) {
      return +v;
    });
    if (this._clamp !== identity) {
      this._clamp = this.clamper(this.domain);
    }
    this.rescale();
  };
  ContinuousScale.prototype.getDomain = function () {
    return this._domain.slice();
  };
  Object.defineProperty(ContinuousScale.prototype, "domain", {
    get: function get() {
      return this.getDomain();
    },
    set: function set(values) {
      this.setDomain(values);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContinuousScale.prototype, "range", {
    get: function get() {
      return this._range.slice();
    },
    set: function set(values) {
      this._range = Array.prototype.slice.call(values);
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContinuousScale.prototype, "interpolate", {
    get: function get() {
      return this._interpolate;
    },
    set: function set(value) {
      this._interpolate = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  ContinuousScale.prototype.rescale = function () {
    if (Math.min(this.domain.length, this.range.length) > 2) {
      this.piecewise = this.polymap;
    } else {
      this.piecewise = this.bimap;
    }
    this.output = undefined;
    this.input = undefined;
  };
  /**
   * Returns a function that converts `x` in `[a, b]` to `t` in `[0, 1]`. Non-clamping.
   * @param a
   * @param b
   */
  ContinuousScale.prototype.normalize = function (a, b) {
    return (b -= a = +a) ? function (x) {
      return (x - a) / b;
    } : constant$1(isNaN(b) ? NaN : 0.5);
  };
  ContinuousScale.prototype.bimap = function (domain, range, interpolate) {
    var x0 = domain[0];
    var x1 = domain[1];
    var y0 = range[0];
    var y1 = range[1];
    var xt;
    var ty;
    if (x1 < x0) {
      xt = this.normalize(x1, x0);
      ty = interpolate(y1, y0);
    } else {
      xt = this.normalize(x0, x1);
      ty = interpolate(y0, y1);
    }
    return function (x) {
      return ty(xt(x));
    }; // domain value x --> t in [0, 1] --> range value y
  };

  ContinuousScale.prototype.polymap = function (domain, range, interpolate) {
    var _this = this;
    // number of segments in the polylinear scale
    var n = Math.min(domain.length, range.length) - 1;
    if (domain[n] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    // deinterpolators from domain segment value to t
    var dt = Array.from({
      length: n
    }, function (_, i) {
      return _this.normalize(domain[i], domain[i + 1]);
    });
    // reinterpolators from t to range segment value
    var tr = Array.from({
      length: n
    }, function (_, i) {
      return interpolate(range[i], range[i + 1]);
    });
    return function (x) {
      var i = bisectRight(domain, x, ascending, 1, n) - 1; // Find the domain segment that `x` belongs to.
      // This also tells us which deinterpolator/reinterpolator pair to use.
      return tr[i](dt[i](x));
    };
  };
  ContinuousScale.prototype.convert = function (x) {
    x = +x;
    if (isNaN(x)) {
      return this.unknown;
    }
    if (!this.output) {
      this.output = this.piecewise(this.domain.map(this.transform), this.range, this.interpolate);
    }
    var clamper = arguments[1];
    var clamp = clamper ? clamper(this.domain) : this._clamp;
    return this.output(this.transform(clamp(x)));
  };
  ContinuousScale.prototype.invert = function (y) {
    if (!this.input) {
      this.input = this.piecewise(this.range, this.domain.map(this.transform), interpolateNumber);
    }
    return this._clamp(this.untransform(this.input(y)));
  };
  return ContinuousScale;
}();
var __extends$3x = undefined && undefined.__extends || function () {
  var _extendStatics234 = function extendStatics(d, b) {
    _extendStatics234 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics234(d, b);
  };
  return function (d, b) {
    _extendStatics234(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
function ticks(a, b, count) {
  var step = tickStep(a, b, count);
  a = Math.ceil(a / step) * step;
  b = Math.floor(b / step) * step + step / 2;
  // Add half a step here so that the array returned by `range` includes the last tick.
  return range(a, b, step);
}
var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);
function tickStep(a, b, count) {
  var rawStep = Math.abs(b - a) / Math.max(0, count);
  var step = Math.pow(10, Math.floor(Math.log(rawStep) / Math.LN10)); // = Math.log10(rawStep)
  var error = rawStep / step;
  if (error >= e10) {
    step *= 10;
  } else if (error >= e5) {
    step *= 5;
  } else if (error >= e2) {
    step *= 2;
  }
  return b < a ? -step : step;
}
function tickIncrement(a, b, count) {
  var rawStep = (b - a) / Math.max(0, count);
  var power = Math.floor(Math.log(rawStep) / Math.LN10);
  var error = rawStep / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
var NumericTicks = /** @class */function (_super) {
  __extends$3x(NumericTicks, _super);
  function NumericTicks(fractionDigits, elements) {
    var _this = _super.call(this) || this;
    if (elements) {
      for (var i = 0, n = elements.length; i < n; i++) {
        _this[i] = elements[i];
      }
    }
    _this.fractionDigits = fractionDigits;
    return _this;
  }
  return NumericTicks;
}(Array);
function range(a, b, step) {
  if (step === void 0) {
    step = 1;
  }
  var absStep = Math.abs(step);
  var fractionDigits = absStep > 0 && absStep < 1 ? Math.abs(Math.floor(Math.log(absStep) / Math.LN10)) : 0;
  var f = Math.pow(10, fractionDigits);
  var n = Math.max(0, Math.ceil((b - a) / step)) || 0;
  var values = new NumericTicks(fractionDigits);
  for (var i = 0; i < n; i++) {
    var value = a + step * i;
    values[i] = Math.round(value * f) / f;
  }
  return values;
}
function formatDefault(x, p) {
  var xs = x.toPrecision(p);
  out: for (var n = xs.length, i = 1, i0 = -1, i1 = 0; i < n; ++i) {
    switch (xs[i]) {
      case '.':
        i0 = i1 = i;
        break;
      case '0':
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      case 'e':
        break out;
      default:
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? xs.slice(0, i0) + xs.slice(i1 + 1) : xs;
}
var formatTypes = {
  '': formatDefault,
  // Multiply by 100, and then decimal notation with a percent sign.
  '%': function _(x, p) {
    return (x * 100).toFixed(p);
  },
  // Binary notation, rounded to integer.
  'b': function b(x) {
    return Math.round(x).toString(2);
  },
  // Converts the integer to the corresponding unicode character before printing.
  'c': function c(x) {
    return String(x);
  },
  // Decimal notation, rounded to integer.
  'd': formatDecimal,
  // Exponent notation.
  'e': function e(x, p) {
    return x.toExponential(p);
  },
  // Fixed point notation.
  'f': function f(x, p) {
    return x.toFixed(p);
  },
  // Either decimal or exponent notation, rounded to significant digits.
  'g': function g(x, p) {
    return x.toPrecision(p);
  },
  // Octal notation, rounded to integer.
  'o': function o(x) {
    return Math.round(x).toString(8);
  },
  // Multiply by 100, round to significant digits, and then decimal notation with a percent sign.
  'p': function p(x, _p3) {
    return formatRounded(x * 100, _p3);
  },
  // Decimal notation, rounded to significant digits.
  'r': formatRounded,
  // Decimal notation with a SI prefix, rounded to significant digits.
  's': formatPrefixAuto,
  // Hexadecimal notation, using upper-case letters, rounded to integer.
  'X': function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  // Hexadecimal notation, using lower-case letters, rounded to integer.
  'x': function x(_x3) {
    return Math.round(_x3).toString(16);
  }
};
var prefixes = ['y', 'z', 'a', 'f', 'p', 'n', '\xB5', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
/**
 * [[fill]align][sign][#][0][width][grouping_option][.precision][type]
 */
var FormatSpecifier = /** @class */function () {
  function FormatSpecifier(specifier) {
    if (specifier instanceof FormatSpecifier) {
      this.fill = specifier.fill;
      this.align = specifier.align;
      this.sign = specifier.sign;
      this.symbol = specifier.symbol;
      this.zero = specifier.zero;
      this.width = specifier.width;
      this.comma = specifier.comma;
      this.precision = specifier.precision;
      this.trim = specifier.trim;
      this.type = specifier.type;
      this.string = specifier.string;
    } else {
      this.fill = specifier.fill === undefined ? ' ' : String(specifier.fill);
      this.align = specifier.align === undefined ? '>' : String(specifier.align);
      this.sign = specifier.sign === undefined ? '-' : String(specifier.sign);
      this.symbol = specifier.symbol === undefined ? '' : String(specifier.symbol);
      this.zero = !!specifier.zero;
      this.width = specifier.width === undefined ? undefined : +specifier.width;
      this.comma = !!specifier.comma;
      this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
      this.trim = !!specifier.trim;
      this.type = specifier.type === undefined ? '' : String(specifier.type);
      this.string = specifier.string;
    }
  }
  return FormatSpecifier;
}();
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var formatRegEx = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
var interpolateRegEx = /(#\{(.*?)\})/g;
function makeFormatSpecifier(specifier) {
  if (specifier instanceof FormatSpecifier) {
    return new FormatSpecifier(specifier);
  }
  var found = false;
  var string = specifier.replace(interpolateRegEx, function () {
    if (!found) {
      specifier = arguments[2];
      found = true;
    }
    return '#{}';
  });
  var match = formatRegEx.exec(specifier);
  if (!match) {
    throw new Error("Invalid format: " + specifier);
  }
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10],
    string: found ? string : undefined
  });
}
function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count);
  var formatSpecifier = makeFormatSpecifier(specifier == undefined ? ',f' : specifier);
  var precision;
  switch (formatSpecifier.type) {
    case 's':
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (formatSpecifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) {
          formatSpecifier.precision = precision;
        }
        return formatPrefix(formatSpecifier, value);
      }
    case '':
    case 'e':
    case 'g':
    case 'p':
    case 'r':
      {
        if (formatSpecifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) {
          formatSpecifier.precision = precision - +(formatSpecifier.type === 'e');
        }
        break;
      }
    case 'f':
    case '%':
      {
        if (formatSpecifier.precision == null && !isNaN(precision = precisionFixed(step))) {
          formatSpecifier.precision = precision - +(formatSpecifier.type === '%') * 2;
        }
        break;
      }
  }
  return format(formatSpecifier);
}
var prefixExponent;
function formatPrefixAuto(x, p) {
  if (p === void 0) {
    p = 0;
  }
  var d = formatDecimalParts(x, p);
  if (!d) {
    return String(x);
  }
  var coefficient = d[0];
  var exponent = d[1];
  prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3;
  var i = exponent - prefixExponent + 1;
  var n = coefficient.length;
  if (i === n) {
    return coefficient;
  } else {
    if (i > n) {
      return coefficient + new Array(i - n + 1).join('0');
    }
    if (i > 0) {
      return coefficient.slice(0, i) + '.' + coefficient.slice(i);
    } else {
      var parts = formatDecimalParts(x, Math.max(0, p + i - 1));
      return '0.' + new Array(1 - i).join('0') + parts[0]; // less than 1y!
    }
  }
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString('en').replace(/,/g, '') : x.toString(10);
}
function formatGroup(grouping, thousands) {
  return function (value, width) {
    var t = [];
    var i = value.length;
    var j = 0;
    var g = grouping[0];
    var length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) {
        g = Math.max(1, width - length);
      }
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) {
        break;
      }
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1 = 0; i < n; ++i) {
    switch (s[i]) {
      case '.':
        i0 = i1 = i;
        break;
      case '0':
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) {
    return String(x);
  }
  var coefficient = d[0];
  var exponent = d[1];
  if (exponent < 0) {
    return '0.' + new Array(-exponent).join('0') + coefficient;
  } else {
    if (coefficient.length > exponent + 1) {
      return coefficient.slice(0, exponent + 1) + '.' + coefficient.slice(exponent + 1);
    } else {
      return coefficient + new Array(exponent - coefficient.length + 2).join('0');
    }
  }
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ['123', 0].
function formatDecimalParts(x, p) {
  var sx = p ? x.toExponential(p - 1) : x.toExponential();
  var i = sx.indexOf('e');
  if (i < 0) {
    // NaN, ±Infinity
    return undefined;
  }
  var coefficient = sx.slice(0, i);
  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +sx.slice(i + 1)];
}
function identity$1(x) {
  return x;
}
var formatDefaultLocale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ',',
  grouping: [3],
  currency: ['$', '']
});
function defaultLocale(definition) {
  formatDefaultLocale = formatLocale(definition);
  format = formatDefaultLocale.format;
  formatPrefix = formatDefaultLocale.formatPrefix;
}
function exponent(x) {
  var parts = formatDecimalParts(Math.abs(x));
  if (parts) {
    return parts[1];
  }
  return NaN;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  var x = Math.floor(exponent(value) / 3);
  x = Math.min(8, x);
  x = Math.max(-8, x);
  return Math.max(0, x * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max) {
  step = Math.abs(step);
  max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}
function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$1 : formatGroup(Array.prototype.map.call(locale.grouping, Number), String(locale.thousands));
  var currencyPrefix = locale.currency === undefined ? '' : String(locale.currency[0]);
  var currencySuffix = locale.currency === undefined ? '' : String(locale.currency[1]);
  var decimal = locale.decimal === undefined ? '.' : String(locale.decimal);
  var numerals = locale.numerals === undefined ? identity$1 : formatNumerals(Array.prototype.map.call(locale.numerals, String));
  var percent = locale.percent === undefined ? '%' : String(locale.percent);
  var minus = locale.minus === undefined ? "\u2212" : String(locale.minus);
  var nan = locale.nan === undefined ? 'NaN' : String(locale.nan);
  function newFormat(specifier) {
    var formatSpecifier = makeFormatSpecifier(specifier);
    var fill = formatSpecifier.fill;
    var align = formatSpecifier.align;
    var sign = formatSpecifier.sign;
    var symbol = formatSpecifier.symbol;
    var zero = formatSpecifier.zero;
    var width = formatSpecifier.width;
    var comma = formatSpecifier.comma;
    var precision = formatSpecifier.precision;
    var trim = formatSpecifier.trim;
    var type = formatSpecifier.type;
    // The 'n' type is an alias for ',g'.
    if (type === 'n') {
      comma = true;
      type = 'g';
    } else if (!formatTypes[type]) {
      // The '' type, and any invalid type, is an alias for '.12~g'.
      if (precision === undefined) {
        precision = 12;
      }
      trim = true;
      type = 'g';
    }
    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === '0' && align === '=') {
      zero = true;
      fill = '0';
      align = '=';
    }
    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === '$' ? currencyPrefix : symbol === '#' && /[boxX]/.test(type) ? '0' + type.toLowerCase() : '';
    var suffix = symbol === '$' ? currencySuffix : /[%p]/.test(type) ? percent : '';
    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type];
    var maybeSuffix = /[defgprs%]/.test(type);
    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    if (precision === undefined) {
      precision = 6;
    } else if (/[gprs]/.test(type)) {
      precision = Math.max(1, Math.min(21, precision));
    } else {
      precision = Math.max(0, Math.min(20, precision));
    }
    function format(x) {
      var valuePrefix = prefix;
      var valueSuffix = suffix;
      var value;
      if (type === 'c') {
        valueSuffix = formatType(+x) + valueSuffix;
        value = '';
      } else {
        var nx = +x;
        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = x < 0 || 1 / nx < 0;
        // Perform the initial formatting.
        value = isNaN(nx) ? nan : formatType(Math.abs(nx), precision);
        // Trim insignificant zeros.
        if (trim) {
          value = formatTrim(value);
        }
        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== '+') {
          valueNegative = false;
        }
        // Compute the prefix and suffix.
        var signPrefix = valueNegative ? sign === '(' ? sign : minus : sign === '-' || sign === '(' ? '' : sign;
        var signSuffix = valueNegative && sign === '(' ? ')' : '';
        valuePrefix = signPrefix + valuePrefix;
        valueSuffix = (type === 's' ? prefixes[8 + prefixExponent / 3] : '') + valueSuffix + signSuffix;
        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          for (var i = 0, n = value.length; i < n; i++) {
            var c = value.charCodeAt(i);
            if (48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      // If the fill character is not '0', grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);
      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length;
      var padding = length < width ? new Array(width - length + 1).join(fill) : '';
      // If the fill character is '0', grouping is applied after padding.
      if (comma && zero) {
        value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity);
        padding = '';
      }
      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case '<':
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case '=':
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case '^':
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      var string = formatSpecifier.string;
      if (string) {
        return string.replace(interpolateRegEx, function () {
          return numerals(value);
        });
      }
      return numerals(value);
    }
    return format;
  }
  function formatPrefix(specifier, value) {
    var formatSpecifier = makeFormatSpecifier(specifier);
    formatSpecifier.type = 'f';
    var f = newFormat(formatSpecifier);
    var e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3;
    var k = Math.pow(10, -e);
    var prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * +value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}
var __extends$3y = undefined && undefined.__extends || function () {
  var _extendStatics235 = function extendStatics(d, b) {
    _extendStatics235 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics235(d, b);
  };
  return function (d, b) {
    _extendStatics235(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * Maps continuous domain to a continuous range.
 */
var LinearScale = /** @class */function (_super) {
  __extends$3y(LinearScale, _super);
  function LinearScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'linear';
    return _this;
  }
  LinearScale.prototype.ticks = function (count) {
    if (count === void 0) {
      count = 10;
    }
    var d = this._domain;
    return ticks(d[0], d[d.length - 1], count);
  };
  /**
   * Extends the domain so that it starts and ends on nice round values.
   * @param count Tick count.
   */
  LinearScale.prototype.nice = function (count) {
    if (count === void 0) {
      count = 10;
    }
    var d = this.domain;
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var step;
    if (stop < start) {
      step = start;
      start = stop;
      stop = step;
      step = i0;
      i0 = i1;
      i1 = step;
    }
    step = tickIncrement(start, stop, count);
    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }
    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      this.domain = d;
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      this.domain = d;
    }
  };
  LinearScale.prototype.tickFormat = function (count, specifier) {
    var d = this.domain;
    return tickFormat(d[0], d[d.length - 1], count == undefined ? 10 : count, specifier);
  };
  return LinearScale;
}(ContinuousScale);

// Custom `Array.find` implementation for legacy browsers.
function find$4(arr, predicate) {
  for (var i = 0; i < arr.length; i++) {
    var value = arr[i];
    if (predicate(value, i, arr)) {
      return value;
    }
  }
}
function identity$2(value) {
  return value;
}
function extent(values, predicate, map) {
  var transform = map || identity$2;
  var n = values.length;
  var i = -1;
  var value;
  var min;
  var max;
  while (++i < n) {
    // Find the first value.
    value = values[i];
    if (predicate(value)) {
      min = max = value;
      while (++i < n) {
        // Compare the remaining values.
        value = values[i];
        if (predicate(value)) {
          if (min > value) {
            min = value;
          }
          if (max < value) {
            max = value;
          }
        }
      }
    }
  }
  return min === undefined || max === undefined ? undefined : [transform(min), transform(max)];
}
/**
 * finds the min and max using a process appropriate for stacked values. Ie,
 * summing up the positive and negative numbers, and returning the totals of each
 */
function findMinMax(values) {
  var min = 0;
  var max = 0;
  for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
    var value = values_1[_i];
    if (value < 0) {
      min += value;
    } else {
      max += value;
    }
  }
  return {
    min: min,
    max: max
  };
}
function copy(array, start, count) {
  if (start === void 0) {
    start = 0;
  }
  if (count === void 0) {
    count = array.length;
  }
  var result = [];
  var n = array.length;
  if (n) {
    for (var i = 0; i < count; i++) {
      result.push(array[(start + i) % n]);
    }
  }
  return result;
}

// Simplified version of https://github.com/plotly/fast-isnumeric
// that doesn't treat number strings with leading/trailing whitespace as numbers.
function isNumber(value) {
  var type = typeof value;
  if (type === 'string') {
    return false;
  } else if (type !== 'number') {
    return false;
  }
  // value - value is going to be:
  // - zero, for any finite number
  // -  NaN, for NaN, Infinity, -Infinity
  return value - value < 1;
}
function isNumberObject(value) {
  return !!value && value.hasOwnProperty('valueOf') && isNumber(value.valueOf());
}
function isNumeric$1(value) {
  return isNumber(value) || isNumberObject(value);
}
function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}
function isString(value) {
  return typeof value === 'string';
}
function isStringObject(value) {
  return !!value && value.hasOwnProperty('toString') && isString(value.toString());
}
function isDiscrete(value) {
  return isString(value) || isStringObject(value);
}
function isContinuous(value) {
  return isNumeric$1(value) || isDate(value);
}
var __extends$3z = undefined && undefined.__extends || function () {
  var _extendStatics236 = function extendStatics(d, b) {
    _extendStatics236 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics236(d, b);
  };
  return function (d, b) {
    _extendStatics236(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Group = /** @class */function (_super) {
  __extends$3z(Group, _super);
  function Group() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isContainerNode = true;
    _this._opacity = 1;
    return _this;
  }
  Object.defineProperty(Group.prototype, "opacity", {
    get: function get() {
      return this._opacity;
    },
    set: function set(value) {
      value = Math.min(1, Math.max(0, value));
      if (this._opacity !== value) {
        this._opacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  // We consider a group to be boundless, thus any point belongs to it.
  Group.prototype.containsPoint = function (x, y) {
    return true;
  };
  Group.prototype.computeBBox = function () {
    var left = Infinity;
    var right = -Infinity;
    var top = Infinity;
    var bottom = -Infinity;
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.children.forEach(function (child) {
      if (!child.visible) {
        return;
      }
      var bbox = child.computeBBox();
      if (!bbox) {
        return;
      }
      if (!(child instanceof Group)) {
        if (child.dirtyTransform) {
          child.computeTransformMatrix();
        }
        var matrix = Matrix.flyweight(child.matrix);
        var parent_1 = child.parent;
        while (parent_1) {
          matrix.preMultiplySelf(parent_1.matrix);
          parent_1 = parent_1.parent;
        }
        matrix.transformBBox(bbox, 0, bbox);
      }
      var x = bbox.x;
      var y = bbox.y;
      if (x < left) {
        left = x;
      }
      if (y < top) {
        top = y;
      }
      if (x + bbox.width > right) {
        right = x + bbox.width;
      }
      if (y + bbox.height > bottom) {
        bottom = y + bbox.height;
      }
    });
    return new BBox(left, top, right - left, bottom - top);
  };
  Group.prototype.render = function (ctx) {
    // A group can have `scaling`, `rotation`, `translation` properties
    // that are applied to the canvas context before children are rendered,
    // so all children can be transformed at once.
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var children = this.children;
    var n = children.length;
    ctx.globalAlpha *= this.opacity;
    if (this.dirtyZIndex) {
      this.dirtyZIndex = false;
      children.sort(function (a, b) {
        return a.zIndex - b.zIndex;
      });
    }
    for (var i = 0; i < n; i++) {
      var child = children[i];
      if (child.visible) {
        ctx.save();
        child.render(ctx);
        ctx.restore();
      }
    }
    // debug
    // this.computeBBox().render(ctx, {
    //     label: this.id,
    //     resetTransform: true,
    //     fillStyle: 'rgba(0, 0, 0, 0.5)'
    // });
  };

  Group.className = 'Group';
  return Group;
}(Node$1);
var EnterNode = /** @class */function () {
  function EnterNode(parent, datum) {
    this.next = null;
    this.scene = parent.scene;
    this.parent = parent;
    this.datum = datum;
  }
  EnterNode.prototype.appendChild = function (node) {
    // This doesn't work without the `strict: true` in the `tsconfig.json`,
    // so we must have two `if` checks below, instead of this single one.
    // if (this.next && !Node.isNode(this.next)) {
    //     throw new Error(`${this.next} is not a Node.`);
    // }
    if (this.next === null) {
      return this.parent.insertBefore(node, null);
    }
    if (!Node$1.isNode(this.next)) {
      throw new Error(this.next + " is not a Node.");
    }
    return this.parent.insertBefore(node, this.next);
  };
  EnterNode.prototype.insertBefore = function (node, nextNode) {
    return this.parent.insertBefore(node, nextNode);
  };
  return EnterNode;
}();
/**
 * G - type of the selected node(s).
 * GDatum - type of the datum of the selected node(s).
 * P - type of the parent node(s).
 * PDatum - type of the datum of the parent node(s).
 */
var Selection = /** @class */function () {
  function Selection(groups, parents) {
    this.groups = groups;
    this.parents = parents;
  }
  Selection.select = function (node) {
    return new Selection([[typeof node === 'function' ? node() : node]], [undefined]);
  };
  Selection.selectAll = function (nodes) {
    return new Selection([nodes == null ? [] : nodes], [undefined]);
  };
  /**
   * Creates new nodes, appends them to the nodes of this selection and returns them
   * as a new selection. The created nodes inherit the datums and the parents of the nodes
   * they replace.
   * @param Class The constructor function to use to create the new nodes.
   */
  Selection.prototype.append = function (Class) {
    return this.select(function (node) {
      return node.appendChild(new Class());
    });
  };
  /**
   * Same as the {@link append}, but accepts a custom creator function with the
   * {@link NodeSelector} signature rather than a constructor function.
   * @param creator
   */
  Selection.prototype.appendFn = function (creator) {
    return this.select(function (node, data, index, group) {
      return node.appendChild(creator(node, data, index, group));
    });
  };
  /**
   * Runs the given selector that returns a single node for every node in each group.
   * The original nodes are then replaced by the nodes returned by the selector
   * and returned as a new selection.
   * The selected nodes inherit the datums and the parents of the original nodes.
   */
  Selection.prototype.select = function (selector) {
    var groups = this.groups;
    var numGroups = groups.length;
    var subgroups = [];
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      var subgroup = subgroups[j] = new Array(groupSize);
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          var subnode = selector(node, node.datum, i, group);
          if (subnode) {
            subnode.datum = node.datum;
          }
          subgroup[i] = subnode;
        }
        // else this can be a group of the `enter` selection,
        // for example, with no nodes at the i-th position,
        // only nodes at the end of the group
      }
    }

    return new Selection(subgroups, this.parents);
  };
  /**
   * Same as {@link select}, but uses the given {@param Class} (constructor) as a selector.
   * @param Class The constructor function to use to find matching nodes.
   */
  Selection.prototype.selectByClass = function (Class) {
    return this.select(function (node) {
      if (Node$1.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child instanceof Class) {
            return child;
          }
        }
      }
    });
  };
  Selection.prototype.selectByTag = function (tag) {
    return this.select(function (node) {
      if (Node$1.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child.tag === tag) {
            return child;
          }
        }
      }
    });
  };
  Selection.prototype.selectAllByClass = function (Class) {
    return this.selectAll(function (node) {
      var nodes = [];
      if (Node$1.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child instanceof Class) {
            nodes.push(child);
          }
        }
      }
      return nodes;
    });
  };
  Selection.prototype.selectAllByTag = function (tag) {
    return this.selectAll(function (node) {
      var nodes = [];
      if (Node$1.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child.tag === tag) {
            nodes.push(child);
          }
        }
      }
      return nodes;
    });
  };
  Selection.prototype.selectNone = function () {
    return [];
  };
  /**
   * Runs the given selector that returns a group of nodes for every node in each group.
   * The original nodes are then replaced by the groups of nodes returned by the selector
   * and returned as a new selection. The original nodes become the parent nodes for each
   * group in the new selection. The selected nodes do not inherit the datums of the original nodes.
   * If called without any parameters, creates a new selection with an empty group for each
   * node in this selection.
   */
  Selection.prototype.selectAll = function (selectorAll) {
    if (!selectorAll) {
      selectorAll = this.selectNone;
    }
    // Each subgroup is populated with the selector (run on each group node) results.
    var subgroups = [];
    // In the new selection that we return, subgroups become groups,
    // and group nodes become parents.
    var parents = [];
    var groups = this.groups;
    var groupCount = groups.length;
    for (var j = 0; j < groupCount; j++) {
      var group = groups[j];
      var groupLength = group.length;
      for (var i = 0; i < groupLength; i++) {
        var node = group[i];
        if (node) {
          subgroups.push(selectorAll(node, node.datum, i, group));
          parents.push(node);
        }
      }
    }
    return new Selection(subgroups, parents);
  };
  /**
   * Runs the given callback for every node in this selection and returns this selection.
   * @param cb
   */
  Selection.prototype.each = function (cb) {
    var groups = this.groups;
    var numGroups = groups.length;
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          cb(node, node.datum, i, group);
        }
      }
    }
    return this;
  };
  Selection.prototype.remove = function () {
    return this.each(function (node) {
      if (Node$1.isNode(node)) {
        var parent_1 = node.parent;
        if (parent_1) {
          parent_1.removeChild(node);
        }
      }
    });
  };
  Selection.prototype.merge = function (other) {
    var groups0 = this.groups;
    var groups1 = other.groups;
    var m0 = groups0.length;
    var m1 = groups1.length;
    var m = Math.min(m0, m1);
    var merges = new Array(m0);
    var j = 0;
    for (; j < m; j++) {
      var group0 = groups0[j];
      var group1 = groups1[j];
      var n = group0.length;
      var merge = merges[j] = new Array(n);
      for (var i = 0; i < n; i++) {
        var node = group0[i] || group1[i];
        merge[i] = node || undefined;
      }
    }
    for (; j < m0; j++) {
      merges[j] = groups0[j];
    }
    return new Selection(merges, this.parents);
  };
  /**
   * Return the first non-null element in this selection.
   * If the selection is empty, returns null.
   */
  Selection.prototype.node = function () {
    var groups = this.groups;
    var numGroups = groups.length;
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          return node;
        }
      }
    }
    return null;
  };
  Selection.prototype.attr = function (name, value) {
    this.each(function (node) {
      node[name] = value;
    });
    return this;
  };
  Selection.prototype.attrFn = function (name, value) {
    this.each(function (node, datum, index, group) {
      node[name] = value(node, datum, index, group);
    });
    return this;
  };
  /**
   * Invokes the given function once, passing in this selection.
   * Returns this selection. Facilitates method chaining.
   * @param cb
   */
  Selection.prototype.call = function (cb) {
    cb(this);
    return this;
  };
  Object.defineProperty(Selection.prototype, "size", {
    /**
     * Returns the total number of nodes in this selection.
     */
    get: function get() {
      var size = 0;
      this.each(function () {
        return size++;
      });
      return size;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "data", {
    /**
     * Returns the array of data for the selected elements.
     */
    get: function get() {
      var data = [];
      this.each(function (_, datum) {
        return data.push(datum);
      });
      return data;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "enter", {
    get: function get() {
      return new Selection(this.enterGroups ? this.enterGroups : [[]], this.parents);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "exit", {
    get: function get() {
      return new Selection(this.exitGroups ? this.exitGroups : [[]], this.parents);
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Binds the given value to each selected node and returns this selection
   * with its {@link GDatum} type changed to the type of the given value.
   * This method doesn't compute a join and doesn't affect indexes or the enter and exit selections.
   * This method can also be used to clear bound data.
   * @param value
   */
  Selection.prototype.setDatum = function (value) {
    return this.each(function (node) {
      node.datum = value;
    });
  };
  Object.defineProperty(Selection.prototype, "datum", {
    /**
     * Returns the bound datum for the first non-null element in the selection.
     * This is generally useful only if you know the selection contains exactly one element.
     */
    get: function get() {
      var node = this.node();
      return node ? node.datum : null;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Binds the specified array of values with the selected nodes, returning a new selection
   * that represents the _update_ selection: the nodes successfully bound to the values.
   * Also defines the {@link enter} and {@link exit} selections on the returned selection,
   * which can be used to add or remove the nodes to correspond to the new data.
   * The `values` is an array of values of a particular type, or a function that returns
   * an array of values for each group.
   * When values are assigned to the nodes, they are stored in the {@link Node.datum} property.
   * @param values
   * @param key
   */
  Selection.prototype.setData = function (values, key) {
    if (typeof values !== 'function') {
      var data_1 = values;
      values = function values() {
        return data_1;
      };
    }
    var groups = this.groups;
    var parents = this.parents;
    var numGroups = groups.length;
    var updateGroups = new Array(numGroups);
    var enterGroups = new Array(numGroups);
    var exitGroups = new Array(numGroups);
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var parent_2 = parents[j];
      if (!parent_2) {
        throw new Error("Group #" + j + " has no parent: " + group);
      }
      var groupSize = group.length;
      var data = values(parent_2, parent_2.datum, j, parents);
      var dataSize = data.length;
      var enterGroup = enterGroups[j] = new Array(dataSize);
      var updateGroup = updateGroups[j] = new Array(dataSize);
      var exitGroup = exitGroups[j] = new Array(groupSize);
      if (key) {
        this.bindKey(parent_2, group, enterGroup, updateGroup, exitGroup, data, key);
      } else {
        this.bindIndex(parent_2, group, enterGroup, updateGroup, exitGroup, data);
      }
      // Now connect the enter nodes to their following update node, such that
      // appendChild can insert the materialized enter node before this node,
      // rather than at the end of the parent node.
      for (var i0 = 0, i1 = 0; i0 < dataSize; i0++) {
        var previous = enterGroup[i0];
        if (previous) {
          if (i0 >= i1) {
            i1 = i0 + 1;
          }
          var next = void 0;
          while (!(next = updateGroup[i1]) && i1 < dataSize) {
            i1++;
          }
          previous.next = next || null;
        }
      }
    }
    var result = new Selection(updateGroups, parents);
    result.enterGroups = enterGroups;
    result.exitGroups = exitGroups;
    return result;
  };
  Selection.prototype.bindIndex = function (parent, group, enter, update, exit, data) {
    var groupSize = group.length;
    var dataSize = data.length;
    var i = 0;
    for (; i < dataSize; i++) {
      var node = group[i];
      if (node) {
        node.datum = data[i];
        update[i] = node;
      } else {
        // more datums than group nodes
        enter[i] = new EnterNode(parent, data[i]);
      }
    }
    // more group nodes than datums
    for (; i < groupSize; i++) {
      var node = group[i];
      if (node) {
        exit[i] = node;
      }
    }
  };
  Selection.prototype.bindKey = function (parent, group, enter, update, exit, data, key) {
    var groupSize = group.length;
    var dataSize = data.length;
    var keyValues = new Array(groupSize);
    var nodeByKeyValue = {};
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for (var i = 0; i < groupSize; i++) {
      var node = group[i];
      if (node) {
        var keyValue = keyValues[i] = Selection.keyPrefix + key(node, node.datum, i, group);
        if (keyValue in nodeByKeyValue) {
          exit[i] = node;
        } else {
          nodeByKeyValue[keyValue] = node;
        }
      }
    }
    // Compute the key for each datum.
    // If there is a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for (var i = 0; i < dataSize; i++) {
      var keyValue = Selection.keyPrefix + key(parent, data[i], i, data);
      var node = nodeByKeyValue[keyValue];
      if (node) {
        update[i] = node;
        node.datum = data[i];
        nodeByKeyValue[keyValue] = undefined;
      } else {
        enter[i] = new EnterNode(parent, data[i]);
      }
    }
    // Add any remaining nodes that were not bound to data to exit.
    for (var i = 0; i < groupSize; i++) {
      var node = group[i];
      if (node && nodeByKeyValue[keyValues[i]] === node) {
        exit[i] = node;
      }
    }
  };
  Selection.keyPrefix = '$'; // Protect against keys like '__proto__'.
  return Selection;
}();
var __extends$3A = undefined && undefined.__extends || function () {
  var _extendStatics237 = function extendStatics(d, b) {
    _extendStatics237 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics237(d, b);
  };
  return function (d, b) {
    _extendStatics237(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Line = /** @class */function (_super) {
  __extends$3A(Line, _super);
  function Line() {
    var _this = _super.call(this) || this;
    _this._x1 = 0;
    _this._y1 = 0;
    _this._x2 = 0;
    _this._y2 = 0;
    _this.restoreOwnStyles();
    return _this;
  }
  Object.defineProperty(Line.prototype, "x1", {
    get: function get() {
      // TODO: Investigate getter performance further in the context
      //       of the scene graph.
      //       In isolated benchmarks using a getter has the same
      //       performance as a direct property access in Firefox 64.
      //       But in Chrome 71 the getter is 60% slower than direct access.
      //       Direct read is 4.5+ times slower in Chrome than it is in Firefox.
      //       Property access and direct read have the same performance
      //       in Safari 12, which is 2+ times faster than Firefox at this.
      // https://jsperf.com/es5-getters-setters-versus-getter-setter-methods/18
      // This is a know Chrome issue. They say it's not a regression, since
      // the behavior is observed since M60, but jsperf.com history shows the
      // 10x slowdown happened between Chrome 48 and Chrome 57.
      // https://bugs.chromium.org/p/chromium/issues/detail?id=908743
      return this._x1;
    },
    set: function set(value) {
      if (this._x1 !== value) {
        this._x1 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "y1", {
    get: function get() {
      return this._y1;
    },
    set: function set(value) {
      if (this._y1 !== value) {
        this._y1 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "x2", {
    get: function get() {
      return this._x2;
    },
    set: function set(value) {
      if (this._x2 !== value) {
        this._x2 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "y2", {
    get: function get() {
      return this._y2;
    },
    set: function set(value) {
      if (this._y2 !== value) {
        this._y2 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Line.prototype.computeBBox = function () {
    return new BBox(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
  };
  Line.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Line.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Line.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var x1 = this.x1;
    var y1 = this.y1;
    var x2 = this.x2;
    var y2 = this.y2;
    // Align to the pixel grid if the line is strictly vertical
    // or horizontal (but not both, i.e. a dot).
    if (x1 === x2) {
      var x = Math.round(x1) + Math.floor(this.strokeWidth) % 2 / 2;
      x1 = x;
      x2 = x;
    } else if (y1 === y2) {
      var y = Math.round(y1) + Math.floor(this.strokeWidth) % 2 / 2;
      y1 = y;
      y2 = y;
    }
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Line.className = 'Line';
  Line.defaultStyles = chainObjects(Shape.defaultStyles, {
    fill: undefined,
    strokeWidth: 1
  });
  return Line;
}(Shape);

// @ts-ignore Suppress tsc error: Property 'sign' does not exist on type 'Math'
var sign = Math.sign ? Math.sign : function (x) {
  x = +x;
  if (x === 0 || isNaN(x)) {
    return x;
  }
  return x > 0 ? 1 : -1;
};
/**
 * Finds the roots of a parametric linear equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function linearRoot(a, b) {
  var t = -b / a;
  return a !== 0 && t >= 0 && t <= 1 ? [t] : [];
}
/**
 * Finds the roots of a parametric quadratic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function quadraticRoots(a, b, c) {
  if (a === 0) {
    return linearRoot(b, c);
  }
  var D = b * b - 4 * a * c; // The polynomial's discriminant.
  var roots = [];
  if (D === 0) {
    // A single real root.
    var t = -b / (2 * a);
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
  } else if (D > 0) {
    // A pair of distinct real roots.
    var rD = Math.sqrt(D);
    var t1 = (-b - rD) / (2 * a);
    var t2 = (-b + rD) / (2 * a);
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (t2 >= 0 && t2 <= 1) {
      roots.push(t2);
    }
  }
  // else -> Complex roots.
  return roots;
}
/**
 * Finds the roots of a parametric cubic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 * Returns an array of parametric intersection locations along the cubic,
 * excluding out-of-bounds intersections (before or after the end point
 * or in the imaginary plane).
 * An adaptation of http://www.particleincell.com/blog/2013/cubic-line-intersection/
 */
function cubicRoots(a, b, c, d) {
  if (a === 0) {
    return quadraticRoots(b, c, d);
  }
  var A = b / a;
  var B = c / a;
  var C = d / a;
  var Q = (3 * B - A * A) / 9;
  var R = (9 * A * B - 27 * C - 2 * A * A * A) / 54;
  var D = Q * Q * Q + R * R; // The polynomial's discriminant.
  var third = 1 / 3;
  var roots = [];
  if (D >= 0) {
    // Complex or duplicate roots.
    var rD = Math.sqrt(D);
    var S = sign(R + rD) * Math.pow(Math.abs(R + rD), third);
    var T = sign(R - rD) * Math.pow(Math.abs(R - rD), third);
    var Im = Math.abs(Math.sqrt(3) * (S - T) / 2); // Complex part of the root pair.
    var t = -third * A + (S + T); // A real root.
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
    if (Im === 0) {
      var t_1 = -third * A - (S + T) / 2; // The real part of a complex root.
      if (t_1 >= 0 && t_1 <= 1) {
        roots.push(t_1);
      }
    }
  } else {
    // Distinct real roots.
    var theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
    var thirdA = third * A;
    var twoSqrtQ = 2 * Math.sqrt(-Q);
    var t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
    var t2 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
    var t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (t2 >= 0 && t2 <= 1) {
      roots.push(t2);
    }
    if (t3 >= 0 && t3 <= 1) {
      roots.push(t3);
    }
  }
  return roots;
}

/**
 * Returns the intersection point for the given pair of line segments, or null,
 * if the segments are parallel or don't intersect.
 * Based on http://paulbourke.net/geometry/pointlineplane/
 */
function segmentIntersection(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
  var d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
  if (d === 0) {
    // The lines are parallel.
    return null;
  }
  var ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
  var ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
  if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
    return {
      x: ax1 + ua * (ax2 - ax1),
      y: ay1 + ua * (ay2 - ay1)
    };
  }
  return null; // The intersection point is outside either or both segments.
}
/**
 * Returns intersection points of the given cubic curve and the line segment.
 * Takes in x/y components of cubic control points and line segment start/end points
 * as parameters.
 */
function cubicSegmentIntersections(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
  var intersections = [];
  // Find line equation coefficients.
  var A = y1 - y2;
  var B = x2 - x1;
  var C = x1 * (y2 - y1) - y1 * (x2 - x1);
  // Find cubic Bezier curve equation coefficients from control points.
  var bx = bezierCoefficients(px1, px2, px3, px4);
  var by = bezierCoefficients(py1, py2, py3, py4);
  var a = A * bx[0] + B * by[0]; // t^3
  var b = A * bx[1] + B * by[1]; // t^2
  var c = A * bx[2] + B * by[2]; // t
  var d = A * bx[3] + B * by[3] + C; // 1
  var roots = cubicRoots(a, b, c, d);
  // Verify that the roots are within bounds of the linear segment.
  for (var i = 0; i < roots.length; i++) {
    var t = roots[i];
    var tt = t * t;
    var ttt = t * tt;
    // Find the cartesian plane coordinates for the parametric root `t`.
    var x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
    var y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
    // The parametric cubic roots we found are intersection points
    // with an infinite line, and so the x/y coordinates above are as well.
    // Make sure the x/y is also within the bounds of the given segment.
    var s = void 0;
    if (x1 !== x2) {
      s = (x - x1) / (x2 - x1);
    } else {
      // the line is vertical
      s = (y - y1) / (y2 - y1);
    }
    if (s >= 0 && s <= 1) {
      intersections.push({
        x: x,
        y: y
      });
    }
  }
  return intersections;
}
/**
 * Returns the given coordinates vector multiplied by the coefficient matrix
 * of the parametric cubic Bézier equation.
 */
function bezierCoefficients(P1, P2, P3, P4) {
  return [-P1 + 3 * P2 - 3 * P3 + P4, 3 * P1 - 6 * P2 + 3 * P3, -3 * P1 + 3 * P2, P1 //                 | 1  0  0  0| |P4|
  ];
}

var Path2D = /** @class */function () {
  function Path2D() {
    // The methods of this class will likely be called many times per animation frame,
    // and any allocation can trigger a GC cycle during animation, so we attempt
    // to minimize the number of allocations.
    this.commands = [];
    this.params = [];
    this._closedPath = false;
  }
  Path2D.prototype.draw = function (ctx) {
    var commands = this.commands;
    var params = this.params;
    var n = commands.length;
    var j = 0;
    ctx.beginPath();
    for (var i = 0; i < n; i++) {
      switch (commands[i]) {
        case 'M':
          ctx.moveTo(params[j++], params[j++]);
          break;
        case 'L':
          ctx.lineTo(params[j++], params[j++]);
          break;
        case 'C':
          ctx.bezierCurveTo(params[j++], params[j++], params[j++], params[j++], params[j++], params[j++]);
          break;
        case 'Z':
          ctx.closePath();
          break;
      }
    }
  };
  Path2D.prototype.moveTo = function (x, y) {
    if (this.xy) {
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.xy = [x, y];
    }
    this.commands.push('M');
    this.params.push(x, y);
  };
  Path2D.prototype.lineTo = function (x, y) {
    if (this.xy) {
      this.commands.push('L');
      this.params.push(x, y);
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.moveTo(x, y);
    }
  };
  Path2D.prototype.rect = function (x, y, width, height) {
    this.moveTo(x, y);
    this.lineTo(x + width, y);
    this.lineTo(x + width, y + height);
    this.lineTo(x, y + height);
    this.closePath();
  };
  /**
   * Adds an arc segment to the path definition.
   * https://www.w3.org/TR/SVG11/paths.html#PathDataEllipticalArcCommands
   * @param rx The major-axis radius.
   * @param ry The minor-axis radius.
   * @param rotation The x-axis rotation, expressed in radians.
   * @param fA The large arc flag. `1` to use angle > π.
   * @param fS The sweep flag. `1` for the arc that goes to `x`/`y` clockwise.
   * @param x2 The x coordinate to arc to.
   * @param y2 The y coordinate to arc to.
   */
  Path2D.prototype.arcTo = function (rx, ry, rotation, fA, fS, x2, y2) {
    // Convert from endpoint to center parametrization:
    // https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
    var xy = this.xy;
    if (!xy) {
      return;
    }
    if (rx < 0) {
      rx = -rx;
    }
    if (ry < 0) {
      ry = -ry;
    }
    var x1 = xy[0];
    var y1 = xy[1];
    var hdx = (x1 - x2) / 2;
    var hdy = (y1 - y2) / 2;
    var sinPhi = Math.sin(rotation);
    var cosPhi = Math.cos(rotation);
    var xp = cosPhi * hdx + sinPhi * hdy;
    var yp = -sinPhi * hdx + cosPhi * hdy;
    var ratX = xp / rx;
    var ratY = yp / ry;
    var lambda = ratX * ratX + ratY * ratY;
    var cx = (x1 + x2) / 2;
    var cy = (y1 + y2) / 2;
    var cpx = 0;
    var cpy = 0;
    if (lambda >= 1) {
      lambda = Math.sqrt(lambda);
      rx *= lambda;
      ry *= lambda;
      // me gives lambda == cpx == cpy == 0;
    } else {
      lambda = Math.sqrt(1 / lambda - 1);
      if (fA === fS) {
        lambda = -lambda;
      }
      cpx = lambda * rx * ratY;
      cpy = -lambda * ry * ratX;
      cx += cosPhi * cpx - sinPhi * cpy;
      cy += sinPhi * cpx + cosPhi * cpy;
    }
    var theta1 = Math.atan2((yp - cpy) / ry, (xp - cpx) / rx);
    var deltaTheta = Math.atan2((-yp - cpy) / ry, (-xp - cpx) / rx) - theta1;
    // if (fS) {
    //     if (deltaTheta <= 0) {
    //         deltaTheta += Math.PI * 2;
    //     }
    // }
    // else {
    //     if (deltaTheta >= 0) {
    //         deltaTheta -= Math.PI * 2;
    //     }
    // }
    this.cubicArc(cx, cy, rx, ry, rotation, theta1, theta1 + deltaTheta, 1 - fS);
  };
  /**
   * Approximates an elliptical arc with up to four cubic Bézier curves.
   * @param commands The string array to write SVG command letters to.
   * @param params The number array to write SVG command parameters (cubic control points) to.
   * @param cx The x-axis coordinate for the ellipse's center.
   * @param cy The y-axis coordinate for the ellipse's center.
   * @param rx The ellipse's major-axis radius.
   * @param ry The ellipse's minor-axis radius.
   * @param phi The rotation for this ellipse, expressed in radians.
   * @param theta1 The starting angle, measured clockwise from the positive x-axis and expressed in radians.
   * @param theta2 The ending angle, measured clockwise from the positive x-axis and expressed in radians.
   * @param anticlockwise The arc control points are always placed clockwise from `theta1` to `theta2`,
   * even when `theta1 > theta2`, unless this flag is set to `1`.
   */
  Path2D.cubicArc = function (commands, params, cx, cy, rx, ry, phi, theta1, theta2, anticlockwise) {
    if (anticlockwise) {
      var temp = theta1;
      theta1 = theta2;
      theta2 = temp;
    }
    var start = params.length;
    // See https://pomax.github.io/bezierinfo/#circles_cubic
    // Arc of unit circle (start angle = 0, end angle <= π/2) in cubic Bézier coordinates:
    // S = [1, 0]
    // C1 = [1, f]
    // C2 = [cos(θ) + f * sin(θ), sin(θ) - f * cos(θ)]
    // E = [cos(θ), sin(θ)]
    // f = 4/3 * tan(θ/4)
    var f90 = 0.5522847498307935; // f for θ = π/2 is 4/3 * (Math.sqrt(2) - 1)
    var sinTheta1 = Math.sin(theta1);
    var cosTheta1 = Math.cos(theta1);
    var sinPhi = Math.sin(phi);
    var cosPhi = Math.cos(phi);
    var rightAngle = Math.PI / 2;
    // Since we know how to draw an arc of a unit circle with a cubic Bézier,
    // to draw an elliptical arc with arbitrary rotation and radii we:
    // 1) rotate the Bézier coordinates that represent a circular arc by θ
    // 2) scale the circular arc separately along the x/y axes, making it elliptical
    // 3) rotate elliptical arc by φ
    // |cos(φ) -sin(φ)| |sx  0| |cos(θ) -sin(θ)| -> |xx xy|
    // |sin(φ)  cos(φ)| | 0 sy| |sin(θ)  cos(θ)| -> |yx yy|
    var xx = cosPhi * cosTheta1 * rx - sinPhi * sinTheta1 * ry;
    var yx = sinPhi * cosTheta1 * rx + cosPhi * sinTheta1 * ry;
    var xy = -cosPhi * sinTheta1 * rx - sinPhi * cosTheta1 * ry;
    var yy = -sinPhi * sinTheta1 * rx + cosPhi * cosTheta1 * ry;
    // TODO: what if delta between θ1 and θ2 is greater than 2π?
    // Always draw clockwise from θ1 to θ2.
    theta2 -= theta1;
    if (theta2 < 0) {
      theta2 += Math.PI * 2;
    }
    // Multiplying each point [x, y] by:
    // |xx xy cx| |x|
    // |yx yy cy| |y|
    // | 0  0  1| |1|
    // TODO: This move command may be redundant, if we are already at this point.
    // The coordinates of the point calculated here may differ ever so slightly
    // because of precision error.
    commands.push('M');
    params.push(xx + cx, yx + cy);
    while (theta2 >= rightAngle) {
      theta2 -= rightAngle;
      commands.push('C');
      // Temp workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=993330
      // Revert this commit when fixed ^^.
      var lastX = xy + cx;
      params.push(xx + xy * f90 + cx, yx + yy * f90 + cy, xx * f90 + xy + cx, yx * f90 + yy + cy, Math.abs(lastX) < 1e-8 ? 0 : lastX, yy + cy);
      // Prepend π/2 rotation matrix.
      // |xx xy| | 0 1| -> | xy -xx|
      // |yx yy| |-1 0| -> | yy -yx|
      // [xx, yx, xy, yy] = [xy, yy, -xx, -yx];
      // Compared to swapping with a temp variable, destructuring is:
      // - 10% faster in Chrome 70
      // - 99% slower in Firefox 63
      // Temp variable solution is 45% faster in FF than Chrome.
      // https://jsperf.com/multi-swap
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1165569
      var temp = xx;
      xx = xy;
      xy = -temp;
      temp = yx;
      yx = yy;
      yy = -temp;
    }
    if (theta2) {
      var f = 4 / 3 * Math.tan(theta2 / 4);
      var sinPhi2 = Math.sin(theta2);
      var cosPhi2 = Math.cos(theta2);
      var C2x = cosPhi2 + f * sinPhi2;
      var C2y = sinPhi2 - f * cosPhi2;
      commands.push('C');
      // Temp workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=993330
      // Revert this commit when fixed ^^.
      var lastX = xx * cosPhi2 + xy * sinPhi2 + cx;
      params.push(xx + xy * f + cx, yx + yy * f + cy, xx * C2x + xy * C2y + cx, yx * C2x + yy * C2y + cy, Math.abs(lastX) < 1e-8 ? 0 : lastX, yx * cosPhi2 + yy * sinPhi2 + cy);
    }
    if (anticlockwise) {
      for (var i = start, j = params.length - 2; i < j; i += 2, j -= 2) {
        var temp = params[i];
        params[i] = params[j];
        params[j] = temp;
        temp = params[i + 1];
        params[i + 1] = params[j + 1];
        params[j + 1] = temp;
      }
    }
  };
  Path2D.prototype.cubicArc = function (cx, cy, rx, ry, phi, theta1, theta2, anticlockwise) {
    var commands = this.commands;
    var params = this.params;
    var start = commands.length;
    Path2D.cubicArc(commands, params, cx, cy, rx, ry, phi, theta1, theta2, anticlockwise);
    var x = params[params.length - 2];
    var y = params[params.length - 1];
    if (this.xy) {
      commands[start] = 'L';
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.xy = [x, y];
    }
  };
  /**
   * Returns the `[x, y]` coordinates of the curve at `t`.
   * @param points `(n + 1) * 2` control point coordinates for a Bézier curve of n-th order.
   * @param t
   */
  Path2D.prototype.deCasteljau = function (points, t) {
    var n = points.length;
    if (n < 2 || n % 2 === 1) {
      throw new Error('Fewer than two points or not an even count.');
    } else if (n === 2 || t === 0) {
      return points.slice(0, 2);
    } else if (t === 1) {
      return points.slice(-2);
    } else {
      var newPoints = [];
      var last = n - 2;
      for (var i = 0; i < last; i += 2) {
        newPoints.push((1 - t) * points[i] + t * points[i + 2],
        // x
        (1 - t) * points[i + 1] + t * points[i + 3] // y
        );
      }

      return this.deCasteljau(newPoints, t);
    }
  };
  /**
   * Approximates the given curve using `n` line segments.
   * @param points `(n + 1) * 2` control point coordinates for a Bézier curve of n-th order.
   * @param n
   */
  Path2D.prototype.approximateCurve = function (points, n) {
    var xy = this.deCasteljau(points, 0);
    this.moveTo(xy[0], xy[1]);
    var step = 1 / n;
    for (var t = step; t <= 1; t += step) {
      var xy_1 = this.deCasteljau(points, t);
      this.lineTo(xy_1[0], xy_1[1]);
    }
  };
  /**
   * Adds a quadratic curve segment to the path definition.
   * Note: the given quadratic segment is converted and stored as a cubic one.
   * @param cx x-component of the curve's control point
   * @param cy y-component of the curve's control point
   * @param x x-component of the end point
   * @param y y-component of the end point
   */
  Path2D.prototype.quadraticCurveTo = function (cx, cy, x, y) {
    if (!this.xy) {
      this.moveTo(cx, cy);
    }
    // See https://pomax.github.io/bezierinfo/#reordering
    this.cubicCurveTo((this.xy[0] + 2 * cx) / 3, (this.xy[1] + 2 * cy) / 3,
    // 1/3 start + 2/3 control
    (2 * cx + x) / 3, (2 * cy + y) / 3,
    // 2/3 control + 1/3 end
    x, y);
  };
  Path2D.prototype.cubicCurveTo = function (cx1, cy1, cx2, cy2, x, y) {
    if (!this.xy) {
      this.moveTo(cx1, cy1);
    }
    this.commands.push('C');
    this.params.push(cx1, cy1, cx2, cy2, x, y);
    this.xy[0] = x;
    this.xy[1] = y;
  };
  Object.defineProperty(Path2D.prototype, "closedPath", {
    get: function get() {
      return this._closedPath;
    },
    enumerable: true,
    configurable: true
  });
  Path2D.prototype.closePath = function () {
    if (this.xy) {
      this.xy = undefined;
      this.commands.push('Z');
      this._closedPath = true;
    }
  };
  Path2D.prototype.clear = function () {
    this.commands.length = 0;
    this.params.length = 0;
    this.xy = undefined;
    this._closedPath = false;
  };
  Path2D.prototype.isPointInPath = function (x, y) {
    var commands = this.commands;
    var params = this.params;
    var cn = commands.length;
    // Hit testing using ray casting method, where the ray's origin is some point
    // outside the path. In this case, an offscreen point that is remote enough, so that
    // even if the path itself is large and is partially offscreen, the ray's origin
    // will likely be outside the path anyway. To test if the given point is inside the
    // path or not, we cast a ray from the origin to the given point and check the number
    // of intersections of this segment with the path. If the number of intersections is
    // even, then the ray both entered and exited the path an equal number of times,
    // therefore the point is outside the path, and inside the path, if the number of
    // intersections is odd. Since the path is compound, we check if the ray segment
    // intersects with each of the path's segments, which can be either a line segment
    // (one or no intersection points) or a Bézier curve segment (up to 3 intersection
    // points).
    var ox = -10000;
    var oy = -10000;
    // the starting point of the  current path
    var sx = NaN;
    var sy = NaN;
    // the previous point of the current path
    var px = 0;
    var py = 0;
    var intersectionCount = 0;
    for (var ci = 0, pi = 0; ci < cn; ci++) {
      switch (commands[ci]) {
        case 'M':
          if (!isNaN(sx)) {
            if (segmentIntersection(sx, sy, px, py, ox, oy, x, y)) {
              intersectionCount++;
            }
          }
          sx = px = params[pi++];
          sy = py = params[pi++];
          break;
        case 'L':
          if (segmentIntersection(px, py, px = params[pi++], py = params[pi++], ox, oy, x, y)) {
            intersectionCount++;
          }
          break;
        case 'C':
          intersectionCount += cubicSegmentIntersections(px, py, params[pi++], params[pi++], params[pi++], params[pi++], px = params[pi++], py = params[pi++], ox, oy, x, y).length;
          break;
        case 'Z':
          if (!isNaN(sx)) {
            if (segmentIntersection(sx, sy, px, py, ox, oy, x, y)) {
              intersectionCount++;
            }
          }
          break;
      }
    }
    return intersectionCount % 2 === 1;
  };
  Path2D.fromString = function (value) {
    var path = new Path2D();
    path.setFromString(value);
    return path;
  };
  /**
   * Split the SVG path at command letters,
   * then extract the command letter and parameters from each substring.
   * @param value
   */
  Path2D.parseSvgPath = function (value) {
    return value.trim().split(Path2D.splitCommandsRe).map(function (part) {
      var strParams = part.match(Path2D.matchParamsRe);
      return {
        command: part.substr(0, 1),
        params: strParams ? strParams.map(parseFloat) : []
      };
    });
  };
  Path2D.prettifySvgPath = function (value) {
    return Path2D.parseSvgPath(value).map(function (d) {
      return d.command + d.params.join(',');
    }).join('\n');
  };
  /**
   * See https://www.w3.org/TR/SVG11/paths.html
   * @param value
   */
  Path2D.prototype.setFromString = function (value) {
    var _this = this;
    this.clear();
    var parts = Path2D.parseSvgPath(value);
    // Current point.
    var x;
    var y;
    // Last control point. Used to calculate the reflection point
    // for `S`, `s`, `T`, `t` commands.
    var cpx;
    var cpy;
    var lastCommand;
    function checkQuadraticCP() {
      if (!lastCommand.match(Path2D.quadraticCommandRe)) {
        cpx = x;
        cpy = y;
      }
    }
    function checkCubicCP() {
      if (!lastCommand.match(Path2D.cubicCommandRe)) {
        cpx = x;
        cpy = y;
      }
    }
    // But that will make compiler complain about x/y, cpx/cpy
    // being used without being set first.
    parts.forEach(function (part) {
      var p = part.params;
      var n = p.length;
      var i = 0;
      switch (part.command) {
        case 'M':
          _this.moveTo(x = p[i++], y = p[i++]);
          while (i < n) {
            _this.lineTo(x = p[i++], y = p[i++]);
          }
          break;
        case 'm':
          _this.moveTo(x += p[i++], y += p[i++]);
          while (i < n) {
            _this.lineTo(x += p[i++], y += p[i++]);
          }
          break;
        case 'L':
          while (i < n) {
            _this.lineTo(x = p[i++], y = p[i++]);
          }
          break;
        case 'l':
          while (i < n) {
            _this.lineTo(x += p[i++], y += p[i++]);
          }
          break;
        case 'C':
          while (i < n) {
            _this.cubicCurveTo(p[i++], p[i++], cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'c':
          while (i < n) {
            _this.cubicCurveTo(x + p[i++], y + p[i++], cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'S':
          checkCubicCP();
          while (i < n) {
            _this.cubicCurveTo(x + x - cpx, y + y - cpy, cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 's':
          checkCubicCP();
          while (i < n) {
            _this.cubicCurveTo(x + x - cpx, y + y - cpy, cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'Q':
          while (i < n) {
            _this.quadraticCurveTo(cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'q':
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'T':
          checkQuadraticCP();
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + x - cpx, cpy = y + y - cpy, x = p[i++], y = p[i++]);
          }
          break;
        case 't':
          checkQuadraticCP();
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + x - cpx, cpy = y + y - cpy, x += p[i++], y += p[i++]);
          }
          break;
        case 'A':
          while (i < n) {
            _this.arcTo(p[i++], p[i++], p[i++] * Math.PI / 180, p[i++], p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'a':
          while (i < n) {
            _this.arcTo(p[i++], p[i++], p[i++] * Math.PI / 180, p[i++], p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'Z':
        case 'z':
          _this.closePath();
          break;
        case 'H':
          while (i < n) {
            _this.lineTo(x = p[i++], y);
          }
          break;
        case 'h':
          while (i < n) {
            _this.lineTo(x += p[i++], y);
          }
          break;
        case 'V':
          while (i < n) {
            _this.lineTo(x, y = p[i++]);
          }
          break;
        case 'v':
          while (i < n) {
            _this.lineTo(x, y += p[i++]);
          }
          break;
      }
      lastCommand = part.command;
    });
  };
  Path2D.prototype.toString = function () {
    var c = this.commands;
    var p = this.params;
    var cn = c.length;
    var out = [];
    for (var ci = 0, pi = 0; ci < cn; ci++) {
      switch (c[ci]) {
        case 'M':
          out.push('M' + p[pi++] + ',' + p[pi++]);
          break;
        case 'L':
          out.push('L' + p[pi++] + ',' + p[pi++]);
          break;
        case 'C':
          out.push('C' + p[pi++] + ',' + p[pi++] + ' ' + p[pi++] + ',' + p[pi++] + ' ' + p[pi++] + ',' + p[pi++]);
          break;
        case 'Z':
          out.push('Z');
          break;
      }
    }
    return out.join('');
  };
  Path2D.prototype.toPrettyString = function () {
    return Path2D.prettifySvgPath(this.toString());
  };
  Path2D.prototype.toSvg = function () {
    return Path2D.xmlDeclaration + "\n<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 50 50\" version=\"1.1\" xmlns=\"" + Path2D.xmlns + "\">\n    <path d=\"" + this.toString() + "\" style=\"fill:none;stroke:#000;stroke-width:0.5;\"/>\n</svg>";
  };
  Path2D.prototype.toDebugSvg = function () {
    var d = Path2D.prettifySvgPath(this.toString());
    return Path2D.xmlDeclaration + "\n<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" version=\"1.1\" xmlns=\"" + Path2D.xmlns + "\">\n    <path d=\"" + d + "\" style=\"fill:none;stroke:#000;stroke-width:0.5;\"/>\n</svg>";
  };
  /**
   * Returns an array of sub-paths of this Path,
   * where each sub-path is represented exclusively by cubic segments.
   */
  Path2D.prototype.toCubicPaths = function () {
    // Each sub-path is an array of `(n * 3 + 1) * 2` numbers,
    // where `n` is the number of segments.
    var paths = [];
    var params = this.params;
    // current path
    var path;
    // the starting point of the  current path
    var sx;
    var sy;
    // the previous point of the current path
    var px;
    var py;
    var i = 0; // current parameter
    this.commands.forEach(function (command) {
      switch (command) {
        case 'M':
          path = [sx = px = params[i++], sy = py = params[i++]];
          paths.push(path);
          break;
        case 'L':
          var x = params[i++];
          var y = params[i++];
          // Place control points along the line `a + (b - a) * t`
          // at t = 1/3 and 2/3:
          path.push((px + px + x) / 3, (py + py + y) / 3, (px + x + x) / 3, (py + y + y) / 3, px = x, py = y);
          break;
        case 'C':
          path.push(params[i++], params[i++], params[i++], params[i++], px = params[i++], py = params[i++]);
          break;
        case 'Z':
          path.push((px + px + sx) / 3, (py + py + sy) / 3, (px + sx + sx) / 3, (py + sy + sy) / 3, px = sx, py = sy);
          break;
      }
    });
    return paths;
  };
  Path2D.cubicPathToString = function (path) {
    var n = path.length;
    if (!(n % 2 === 0 && (n / 2 - 1) / 2 >= 1)) {
      throw new Error('Invalid path.');
    }
    return 'M' + path.slice(0, 2).join(',') + 'C' + path.slice(2).join(',');
  };
  Path2D.splitCommandsRe = /(?=[AaCcHhLlMmQqSsTtVvZz])/g;
  Path2D.matchParamsRe = /-?[0-9]*\.?\d+/g;
  Path2D.quadraticCommandRe = /[QqTt]/;
  Path2D.cubicCommandRe = /[CcSs]/;
  Path2D.xmlDeclaration = '<?xml version="1.0" encoding="UTF-8"?>';
  Path2D.xmlns = 'http://www.w3.org/2000/svg';
  return Path2D;
}();
var __extends$3B = undefined && undefined.__extends || function () {
  var _extendStatics238 = function extendStatics(d, b) {
    _extendStatics238 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics238(d, b);
  };
  return function (d, b) {
    _extendStatics238(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Path = /** @class */function (_super) {
  __extends$3B(Path, _super);
  function Path() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Declare a path to retain for later rendering and hit testing
     * using custom Path2D class. Think of it as a TypeScript version
     * of the native Path2D (with some differences) that works in all browsers.
     */
    _this.path = new Path2D();
    /**
    * The path only has to be updated when certain attributes change.
    * For example, if transform attributes (such as `translationX`)
    * are changed, we don't have to update the path. The `dirtyPath` flag
    * is how we keep track if the path has to be updated or not.
    */
    _this._dirtyPath = true;
    /**
     * Path definition in SVG path syntax:
     * https://www.w3.org/TR/SVG11/paths.html#DAttribute
     */
    _this._svgPath = '';
    return _this;
  }
  Object.defineProperty(Path.prototype, "dirtyPath", {
    get: function get() {
      return this._dirtyPath;
    },
    set: function set(value) {
      if (this._dirtyPath !== value) {
        this._dirtyPath = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Path.prototype, "svgPath", {
    get: function get() {
      return this._svgPath;
    },
    set: function set(value) {
      if (this._svgPath !== value) {
        this._svgPath = value;
        this.path.setFromString(value);
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Path.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    return this.path.closedPath && this.path.isPointInPath(point.x, point.y);
  };
  Path.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Path.prototype.updatePath = function () {};
  Path.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    // if (scene.debug.renderBoundingBoxes) {
    //     const bbox = this.computeBBox();
    //     if (bbox) {
    //         this.matrix.transformBBox(bbox).render(ctx);
    //     }
    // }
    this.matrix.toContext(ctx);
    if (this.dirtyPath) {
      this.updatePath();
      this.dirtyPath = false;
    }
    this.path.draw(ctx);
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Path.className = 'Path';
  return Path;
}(Shape);
var twoPi = Math.PI * 2;
/**
 * Normalize the given angle to be in the [0, 2π) interval.
 * @param radians Angle in radians.
 */
function normalizeAngle360(radians) {
  radians %= twoPi;
  radians += twoPi;
  radians %= twoPi;
  return radians;
}
function normalizeAngle360Inclusive(radians) {
  radians %= twoPi;
  radians += twoPi;
  if (radians !== twoPi) {
    radians %= twoPi;
  }
  return radians;
}
/**
 * Normalize the given angle to be in the [-π, π) interval.
 * @param radians Angle in radians.
 */
function normalizeAngle180(radians) {
  radians %= twoPi;
  if (radians < -Math.PI) {
    radians += twoPi;
  } else if (radians >= Math.PI) {
    radians -= twoPi;
  }
  return radians;
}
function toRadians(degrees) {
  return degrees / 180 * Math.PI;
}
function isEqual(a, b, epsilon) {
  if (epsilon === void 0) {
    epsilon = 1e-10;
  }
  return Math.abs(a - b) < epsilon;
}
/**
 * `Number.toFixed(n)` always formats a number so that it has `n` digits after the decimal point.
 * For example, `Number(0.00003427).toFixed(2)` returns `0.00`.
 * That's not very helpful, because all the meaningful information is lost.
 * In this case we would want the formatted value to have at least two significant digits: `0.000034`,
 * not two fraction digits.
 * @param value
 * @param fractionOrSignificantDigits
 */
function toFixed(value, fractionOrSignificantDigits) {
  if (fractionOrSignificantDigits === void 0) {
    fractionOrSignificantDigits = 2;
  }
  var power = Math.floor(Math.log(Math.abs(value)) / Math.LN10);
  if (power >= 0 || !isFinite(power)) {
    return value.toFixed(fractionOrSignificantDigits); // fraction digits
  }

  return value.toFixed(Math.abs(power) - 1 + fractionOrSignificantDigits); // significant digits
}

var __extends$3C = undefined && undefined.__extends || function () {
  var _extendStatics239 = function extendStatics(d, b) {
    _extendStatics239 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics239(d, b);
  };
  return function (d, b) {
    _extendStatics239(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ArcType;
(function (ArcType) {
  ArcType[ArcType["Open"] = 0] = "Open";
  ArcType[ArcType["Chord"] = 1] = "Chord";
  ArcType[ArcType["Round"] = 2] = "Round";
})(ArcType || (ArcType = {}));
/**
 * Elliptical arc node.
 */
var Arc = /** @class */function (_super) {
  __extends$3C(Arc, _super);
  function Arc() {
    var _this = _super.call(this) || this;
    _this._centerX = 0;
    _this._centerY = 0;
    _this._radiusX = 10;
    _this._radiusY = 10;
    _this._startAngle = 0;
    _this._endAngle = Math.PI * 2;
    _this._counterClockwise = false;
    /**
     * The type of arc to render:
     * - {@link ArcType.Open} - end points of the arc segment are not connected (default)
     * - {@link ArcType.Chord} - end points of the arc segment are connected by a line segment
     * - {@link ArcType.Round} - each of the end points of the arc segment are connected
     *                           to the center of the arc
     * Arcs with {@link ArcType.Open} do not support hit testing, even if they have their
     * {@link Shape.fillStyle} set, because they are not closed paths. Hit testing support
     * would require using two paths - one for rendering, another for hit testing - and there
     * doesn't seem to be a compelling reason to do that, when one can just use {@link ArcType.Chord}
     * to create a closed path.
     */
    _this._type = ArcType.Open;
    _this.restoreOwnStyles();
    return _this;
  }
  Object.defineProperty(Arc.prototype, "centerX", {
    get: function get() {
      return this._centerX;
    },
    set: function set(value) {
      if (this._centerX !== value) {
        this._centerX = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "centerY", {
    get: function get() {
      return this._centerY;
    },
    set: function set(value) {
      if (this._centerY !== value) {
        this._centerY = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "radiusX", {
    get: function get() {
      return this._radiusX;
    },
    set: function set(value) {
      if (this._radiusX !== value) {
        this._radiusX = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "radiusY", {
    get: function get() {
      return this._radiusY;
    },
    set: function set(value) {
      if (this._radiusY !== value) {
        this._radiusY = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "startAngle", {
    get: function get() {
      return this._startAngle;
    },
    set: function set(value) {
      if (this._startAngle !== value) {
        this._startAngle = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "endAngle", {
    get: function get() {
      return this._endAngle;
    },
    set: function set(value) {
      if (this._endAngle !== value) {
        this._endAngle = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "fullPie", {
    get: function get() {
      return isEqual(normalizeAngle360(this.startAngle), normalizeAngle360(this.endAngle));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "counterClockwise", {
    get: function get() {
      return this._counterClockwise;
    },
    set: function set(value) {
      if (this._counterClockwise !== value) {
        this._counterClockwise = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Arc.prototype, "type", {
    get: function get() {
      return this._type;
    },
    set: function set(value) {
      if (this._type !== value) {
        this._type = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Arc.prototype.updatePath = function () {
    var path = this.path;
    path.clear(); // No need to recreate the Path, can simply clear the existing one.
    // This is much faster than the native Path2D implementation even though this `cubicArc`
    // method is pure TypeScript and actually produces the definition of an elliptical arc,
    // where you can specify two radii and rotation, while Path2D's `arc` method simply produces
    // a circular arc. Maybe it's due to the experimental nature of the Path2D class,
    // maybe it's because we have to create a new instance of it on each render, who knows...
    path.cubicArc(this.centerX, this.centerY, this.radiusX, this.radiusY, 0, this.startAngle, this.endAngle, this.counterClockwise ? 1 : 0);
    if (this.type === ArcType.Chord) {
      path.closePath();
    } else if (this.type === ArcType.Round && !this.fullPie) {
      path.lineTo(this.centerX, this.centerY);
      path.closePath();
    }
  };
  Arc.prototype.computeBBox = function () {
    // Only works with full arcs (circles) and untransformed ellipses.
    return new BBox(this.centerX - this.radiusX, this.centerY - this.radiusY, this.radiusX * 2, this.radiusY * 2);
  };
  Arc.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return this.type !== ArcType.Open && bbox.containsPoint(point.x, point.y) && this.path.isPointInPath(point.x, point.y);
  };
  Arc.className = 'Arc';
  Arc.defaultStyles = chainObjects(Shape.defaultStyles, {
    lineWidth: 1,
    fillStyle: null
  });
  return Arc;
}(Path);

// import { Rect } from "./scene/shape/rect"; // debug (bbox)
var Tags;
(function (Tags) {
  Tags[Tags["Tick"] = 0] = "Tick";
  Tags[Tags["GridLine"] = 1] = "GridLine";
})(Tags || (Tags = {}));
var AxisTick = /** @class */function () {
  function AxisTick() {
    /**
     * The line width to be used by axis ticks.
     */
    this.width = 1;
    /**
     * The line length to be used by axis ticks.
     */
    this.size = 6;
    /**
     * The color of the axis ticks.
     * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make the ticks invisible.
     */
    this.color = 'rgba(195, 195, 195, 1)';
    /**
     * A hint of how many ticks to use (the exact number of ticks might differ),
     * a `TimeInterval` or a `CountableTimeInterval`.
     * For example:
     *
     *     axis.tick.count = 5;
     *     axis.tick.count = year;
     *     axis.tick.count = month.every(6);
     */
    this.count = 10;
  }
  return AxisTick;
}();
var AxisLabel = /** @class */function () {
  function AxisLabel() {
    this.fontSize = 12;
    this.fontFamily = 'Verdana, sans-serif';
    /**
     * The padding between the labels and the ticks.
     */
    this.padding = 5;
    /**
     * The color of the labels.
     * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make labels invisible.
     */
    this.color = 'rgba(87, 87, 87, 1)';
    /**
     * Custom label rotation in degrees.
     * Labels are rendered perpendicular to the axis line by default.
     * Or parallel to the axis line, if the {@link parallel} is set to `true`.
     * The value of this config is used as the angular offset/deflection
     * from the default rotation.
     */
    this.rotation = 0;
    /**
     * By default labels and ticks are positioned to the left of the axis line.
     * `true` positions the labels to the right of the axis line.
     * However, if the axis is rotated, its easier to think in terms
     * of this side or the opposite side, rather than left and right.
     * We use the term `mirror` for conciseness, although it's not
     * true mirroring - for example, when a label is rotated, so that
     * it is inclined at the 45 degree angle, text flowing from north-west
     * to south-east, ending at the tick to the left of the axis line,
     * and then we set this config to `true`, the text will still be flowing
     * from north-west to south-east, _starting_ at the tick to the right
     * of the axis line.
     */
    this.mirrored = false;
    /**
     * Labels are rendered perpendicular to the axis line by default.
     * Setting this config to `true` makes labels render parallel to the axis line
     * and center aligns labels' text at the ticks.
     */
    this.parallel = false;
  }
  Object.defineProperty(AxisLabel.prototype, "format", {
    get: function get() {
      return this._format;
    },
    set: function set(value) {
      // See `TimeLocaleObject` docs for the list of supported format directives.
      if (this._format !== value) {
        this._format = value;
        if (this.onFormatChange) {
          this.onFormatChange(value);
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  return AxisLabel;
}();
/**
 * A general purpose linear axis with no notion of orientation.
 * The axis is always rendered vertically, with horizontal labels positioned to the left
 * of the axis line by default. The axis can be {@link rotation | rotated} by an arbitrary angle,
 * so that it can be used as a top, right, bottom, left, radial or any other kind
 * of linear axis.
 * The generic `D` parameter is the type of the domain of the axis' scale.
 * The output range of the axis' scale is always numeric (screen coordinates).
 */
var Axis = /** @class */function () {
  function Axis(scale) {
    // debug (bbox)
    // private bboxRect = (() => {
    //     const rect = new Rect();
    //     rect.fill = undefined;
    //     rect.stroke = 'red';
    //     rect.strokeWidth = 1;
    //     rect.strokeOpacity = 0.2;
    //     return rect;
    // })();
    this.id = createId(this);
    this.lineNode = new Line();
    this.group = new Group();
    this.line = {
      width: 1,
      color: 'rgba(195, 195, 195, 1)'
    };
    this.tick = new AxisTick();
    this.label = new AxisLabel();
    this.translation = {
      x: 0,
      y: 0
    };
    this.rotation = 0; // axis rotation angle in degrees
    this.requestedRange = [0, 1];
    this._visibleRange = [0, 1];
    this._title = undefined;
    /**
     * The length of the grid. The grid is only visible in case of a non-zero value.
     * In case {@link radialGrid} is `true`, the value is interpreted as an angle
     * (in degrees).
     */
    this._gridLength = 0;
    /**
     * The array of styles to cycle through when rendering grid lines.
     * For example, use two {@link GridStyle} objects for alternating styles.
     * Contains only one {@link GridStyle} object by default, meaning all grid lines
     * have the same style.
     */
    this.gridStyle = [{
      stroke: 'rgba(219, 219, 219, 1)',
      lineDash: [4, 2]
    }];
    /**
     * `false` - render grid as lines of {@link gridLength} that extend the ticks
     *           on the opposite side of the axis
     * `true` - render grid as concentric circles that go through the ticks
     */
    this._radialGrid = false;
    this.fractionDigits = 0;
    this.thickness = 0;
    this.scale = scale;
    this.groupSelection = Selection.select(this.group).selectAll();
    this.label.onFormatChange = this.onLabelFormatChange.bind(this);
    this.group.append(this.lineNode);
    // this.group.append(this.bboxRect); // debug (bbox)
  }

  Object.defineProperty(Axis.prototype, "scale", {
    get: function get() {
      return this._scale;
    },
    set: function set(value) {
      this._scale = value;
      this.requestedRange = value.range.slice();
      this.onLabelFormatChange();
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Meant to be overridden in subclasses to provide extra context the the label formatter.
   * The return value of this function will be passed to the laber.formatter as the `axis` parameter.
   */
  Axis.prototype.getMeta = function () {};
  Axis.prototype.updateRange = function () {
    var _a = this,
      rr = _a.requestedRange,
      vr = _a.visibleRange,
      scale = _a.scale;
    var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
    var shift = span * vr[0];
    var start = rr[0] - shift;
    scale.range = [start, start + span];
  };
  /**
   * Checks if a point or an object is in range.
   * @param x A point (or object's starting point).
   * @param width Object's width.
   * @param tolerance Expands the range on both ends by this amount.
   */
  Axis.prototype.inRange = function (x, width, tolerance) {
    if (width === void 0) {
      width = 0;
    }
    if (tolerance === void 0) {
      tolerance = 0;
    }
    return this.inRangeEx(x, width, tolerance) === 0;
  };
  Axis.prototype.inRangeEx = function (x, width, tolerance) {
    if (width === void 0) {
      width = 0;
    }
    if (tolerance === void 0) {
      tolerance = 0;
    }
    var range = this.range;
    // Account for inverted ranges, for example [500, 100] as well as [100, 500]
    var min = Math.min(range[0], range[1]);
    var max = Math.max(range[0], range[1]);
    if (x + width < min - tolerance) {
      return -1; // left of range
    }

    if (x > max + tolerance) {
      return 1; // right of range
    }

    return 0; // in range
  };

  Object.defineProperty(Axis.prototype, "range", {
    get: function get() {
      return this.requestedRange.slice();
    },
    set: function set(value) {
      this.requestedRange = value.slice();
      this.updateRange();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Axis.prototype, "visibleRange", {
    get: function get() {
      return this._visibleRange.slice();
    },
    set: function set(value) {
      if (value && value.length === 2) {
        var min = value[0],
          max = value[1];
        min = Math.max(0, min);
        max = Math.min(1, max);
        min = Math.min(min, max);
        max = Math.max(min, max);
        this._visibleRange = [min, max];
        this.updateRange();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Axis.prototype, "domain", {
    get: function get() {
      return this.scale.domain.slice();
    },
    set: function set(value) {
      this.scale.domain = value.slice();
      this.onLabelFormatChange(this.label.format);
    },
    enumerable: true,
    configurable: true
  });
  Axis.prototype.onLabelFormatChange = function (format) {
    if (format && this.scale && this.scale.tickFormat) {
      try {
        this.labelFormatter = this.scale.tickFormat(this.tick.count, format);
      } catch (e) {
        this.labelFormatter = undefined;
        console.error(e);
      }
    } else {
      this.labelFormatter = undefined;
    }
  };
  Object.defineProperty(Axis.prototype, "title", {
    get: function get() {
      return this._title;
    },
    set: function set(value) {
      var oldTitle = this._title;
      if (oldTitle !== value) {
        if (oldTitle) {
          this.group.removeChild(oldTitle.node);
        }
        if (value) {
          value.node.rotation = -Math.PI / 2;
          this.group.appendChild(value.node);
        }
        this._title = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Axis.prototype, "gridLength", {
    get: function get() {
      return this._gridLength;
    },
    set: function set(value) {
      // Was visible and now invisible, or was invisible and now visible.
      if (this._gridLength && !value || !this._gridLength && value) {
        this.groupSelection = this.groupSelection.remove().setData([]);
      }
      this._gridLength = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Axis.prototype, "radialGrid", {
    get: function get() {
      return this._radialGrid;
    },
    set: function set(value) {
      if (this._radialGrid !== value) {
        this._radialGrid = value;
        this.groupSelection = this.groupSelection.remove().setData([]);
      }
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   * Supposed to be called _manually_ after changing _any_ of the axis properties.
   * This allows to bulk set axis properties before updating the nodes.
   * The node changes made by this method are rendered on the next animation frame.
   * We could schedule this method call automatically on the next animation frame
   * when any of the axis properties change (the way we do when properties of scene graph's
   * nodes change), but this will mean that we first wait for the next animation
   * frame to make changes to the nodes of the axis, then wait for another animation
   * frame to render those changes. It's nice to have everything update automatically,
   * but this extra level of async indirection will not just introduce an unwanted delay,
   * it will also make it harder to reason about the program.
   */
  Axis.prototype.update = function () {
    var _this = this;
    var _a = this,
      group = _a.group,
      scale = _a.scale,
      tick = _a.tick,
      label = _a.label,
      gridStyle = _a.gridStyle,
      requestedRange = _a.requestedRange;
    var requestedRangeMin = Math.min(requestedRange[0], requestedRange[1]);
    var requestedRangeMax = Math.max(requestedRange[0], requestedRange[1]);
    var rotation = toRadians(this.rotation);
    var parallelLabels = label.parallel;
    var labelRotation = normalizeAngle360(toRadians(label.rotation));
    group.translationX = this.translation.x;
    group.translationY = this.translation.y;
    group.rotation = rotation;
    var halfBandwidth = (scale.bandwidth || 0) / 2;
    // The side of the axis line to position the labels on.
    // -1 = left (default)
    //  1 = right
    var sideFlag = label.mirrored ? 1 : -1;
    // When labels are parallel to the axis line, the `parallelFlipFlag` is used to
    // flip the labels to avoid upside-down text, when the axis is rotated
    // such that it is in the right hemisphere, i.e. the angle of rotation
    // is in the [0, π] interval.
    // The rotation angle is normalized, so that we have an easier time checking
    // if it's in the said interval. Since the axis is always rendered vertically
    // and then rotated, zero rotation means 12 (not 3) o-clock.
    // -1 = flip
    //  1 = don't flip (default)
    var parallelFlipRotation = normalizeAngle360(rotation);
    var parallelFlipFlag = !labelRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
    var regularFlipRotation = normalizeAngle360(rotation - Math.PI / 2);
    // Flip if the axis rotation angle is in the top hemisphere.
    var regularFlipFlag = !labelRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
    var alignFlag = labelRotation >= 0 && labelRotation <= Math.PI ? -1 : 1;
    var ticks = scale.ticks(this.tick.count);
    var update = this.groupSelection.setData(ticks);
    update.exit.remove();
    var enter = update.enter.append(Group);
    // Line auto-snaps to pixel grid if vertical or horizontal.
    enter.append(Line).each(function (node) {
      return node.tag = Tags.Tick;
    });
    if (this.gridLength) {
      if (this.radialGrid) {
        enter.append(Arc).each(function (node) {
          return node.tag = Tags.GridLine;
        });
      } else {
        enter.append(Line).each(function (node) {
          return node.tag = Tags.GridLine;
        });
      }
    }
    enter.append(Text);
    var groupSelection = update.merge(enter);
    groupSelection.attrFn('translationY', function (_, datum) {
      return Math.round(scale.convert(datum) + halfBandwidth);
    }).attrFn('visible', function (node) {
      var min = Math.floor(requestedRangeMin);
      var max = Math.ceil(requestedRangeMax);
      return node.translationY >= min && node.translationY <= max;
    });
    groupSelection.selectByTag(Tags.Tick).each(function (line) {
      line.strokeWidth = tick.width;
      line.stroke = tick.color;
    }).attr('x1', sideFlag * tick.size).attr('x2', 0).attr('y1', 0).attr('y2', 0);
    if (this.gridLength && gridStyle.length) {
      var styleCount_1 = gridStyle.length;
      var gridLines = void 0;
      if (this.radialGrid) {
        var angularGridLength_1 = normalizeAngle360Inclusive(toRadians(this.gridLength));
        gridLines = groupSelection.selectByTag(Tags.GridLine).each(function (arc, datum) {
          var radius = Math.round(scale.convert(datum) + halfBandwidth);
          arc.centerX = 0;
          arc.centerY = scale.range[0] - radius;
          arc.endAngle = angularGridLength_1;
          arc.radiusX = radius;
          arc.radiusY = radius;
        });
      } else {
        gridLines = groupSelection.selectByTag(Tags.GridLine).each(function (line) {
          line.x1 = 0;
          line.x2 = -sideFlag * _this.gridLength;
          line.y1 = 0;
          line.y2 = 0;
          line.visible = Math.abs(line.parent.translationY - scale.range[0]) > 1;
        });
      }
      gridLines.each(function (gridLine, _, index) {
        var style = gridStyle[index % styleCount_1];
        gridLine.stroke = style.stroke;
        gridLine.strokeWidth = tick.width;
        gridLine.lineDash = style.lineDash;
        gridLine.fill = undefined;
      });
    }
    // `ticks instanceof NumericTicks` doesn't work here, so we feature detect.
    this.fractionDigits = ticks.fractionDigits >= 0 ? ticks.fractionDigits : 0;
    var labelSelection = groupSelection.selectByClass(Text).each(function (node, datum, index) {
      node.fontStyle = label.fontStyle;
      node.fontWeight = label.fontWeight;
      node.fontSize = label.fontSize;
      node.fontFamily = label.fontFamily;
      node.fill = label.color;
      node.textBaseline = parallelLabels && !labelRotation ? sideFlag * parallelFlipFlag === -1 ? 'hanging' : 'bottom' : 'middle';
      node.text = _this.formatTickDatum(datum, index);
      node.textAlign = parallelLabels ? labelRotation ? sideFlag * alignFlag === -1 ? 'end' : 'start' : 'center' : sideFlag * regularFlipFlag === -1 ? 'end' : 'start';
    });
    var labelX = sideFlag * (tick.size + label.padding);
    var autoRotation = parallelLabels ? parallelFlipFlag * Math.PI / 2 : regularFlipFlag === -1 ? Math.PI : 0;
    labelSelection.each(function (label) {
      label.x = labelX;
      label.rotationCenterX = labelX;
      label.rotation = autoRotation + labelRotation;
    });
    this.groupSelection = groupSelection;
    // Render axis line.
    var lineNode = this.lineNode;
    lineNode.x1 = 0;
    lineNode.x2 = 0;
    lineNode.y1 = requestedRange[0];
    lineNode.y2 = requestedRange[1];
    lineNode.strokeWidth = this.line.width;
    lineNode.stroke = this.line.color;
    lineNode.visible = ticks.length > 0;
    var title = this.title;
    var titleVisible = false;
    if (title && title.enabled && lineNode.visible) {
      titleVisible = true;
      var padding = title.padding.bottom;
      var titleNode = title.node;
      var bbox = this.computeBBox({
        excludeTitle: true
      });
      var titleRotationFlag = sideFlag === -1 && parallelFlipRotation > Math.PI && parallelFlipRotation < Math.PI * 2 ? -1 : 1;
      titleNode.rotation = titleRotationFlag * sideFlag * Math.PI / 2;
      titleNode.x = titleRotationFlag * sideFlag * (lineNode.y1 + lineNode.y2) / 2;
      titleNode.x = titleRotationFlag * sideFlag * (requestedRange[0] + requestedRange[1]) / 2;
      if (sideFlag === -1) {
        titleNode.y = titleRotationFlag * (-padding - bbox.width + Math.max(bbox.x + bbox.width, 0));
      } else {
        titleNode.y = -padding - bbox.width - Math.min(bbox.x, 0);
      }
      titleNode.textBaseline = titleRotationFlag === 1 ? 'bottom' : 'top';
    }
    if (title) {
      title.node.visible = titleVisible;
    }
    // debug (bbox)
    // const bbox = this.computeBBox();
    // const bboxRect = this.bboxRect;
    // bboxRect.x = bbox.x;
    // bboxRect.y = bbox.y;
    // bboxRect.width = bbox.width;
    // bboxRect.height = bbox.height;
  };
  // For formatting (nice rounded) tick values.
  Axis.prototype.formatTickDatum = function (datum, index) {
    var _a = this,
      label = _a.label,
      labelFormatter = _a.labelFormatter,
      fractionDigits = _a.fractionDigits;
    var meta = this.getMeta();
    return label.formatter ? label.formatter({
      value: fractionDigits >= 0 ? datum : String(datum),
      index: index,
      fractionDigits: fractionDigits,
      formatter: labelFormatter,
      axis: meta
    }) : labelFormatter ? labelFormatter(datum) : typeof datum === 'number' && fractionDigits >= 0
    // the `datum` is a floating point number
    ? datum.toFixed(fractionDigits)
    // the`datum` is an integer, a string or an object
    : String(datum);
  };
  // For formatting arbitrary values between the ticks.
  Axis.prototype.formatDatum = function (datum) {
    return String(datum);
  };
  Axis.prototype.computeBBox = function (options) {
    var _a = this,
      title = _a.title,
      lineNode = _a.lineNode;
    var labels = this.groupSelection.selectByClass(Text);
    var left = Infinity;
    var right = -Infinity;
    var top = Infinity;
    var bottom = -Infinity;
    labels.each(function (label) {
      // The label itself is rotated, but not translated, the group that
      // contains it is. So to capture the group transform in the label bbox
      // calculation we combine the transform matrices of the label and the group.
      // Depending on the timing of the `axis.computeBBox()` method call, we may
      // not have the group's and the label's transform matrices updated yet (because
      // the transform matrix is not recalculated whenever a node's transform attributes
      // change, instead it's marked for recalculation on the next frame by setting
      // the node's `dirtyTransform` flag to `true`), so we force them to update
      // right here by calling `computeTransformMatrix`.
      label.computeTransformMatrix();
      var matrix = Matrix.flyweight(label.matrix);
      var group = label.parent;
      group.computeTransformMatrix();
      matrix.preMultiplySelf(group.matrix);
      var labelBBox = label.computeBBox();
      if (labelBBox) {
        var bbox = matrix.transformBBox(labelBBox);
        left = Math.min(left, bbox.x);
        right = Math.max(right, bbox.x + bbox.width);
        top = Math.min(top, bbox.y);
        bottom = Math.max(bottom, bbox.y + bbox.height);
      }
    });
    if (title && title.enabled && lineNode.visible && (!options || !options.excludeTitle)) {
      var label = title.node;
      label.computeTransformMatrix();
      var matrix = Matrix.flyweight(label.matrix);
      var labelBBox = label.computeBBox();
      if (labelBBox) {
        var bbox = matrix.transformBBox(labelBBox);
        left = Math.min(left, bbox.x);
        right = Math.max(right, bbox.x + bbox.width);
        top = Math.min(top, bbox.y);
        bottom = Math.max(bottom, bbox.y + bbox.height);
      }
    }
    left = Math.min(left, 0);
    right = Math.max(right, 0);
    top = Math.min(top, lineNode.y1, lineNode.y2);
    bottom = Math.max(bottom, lineNode.y1, lineNode.y2);
    return new BBox(left, top, right - left, bottom - top);
  };
  return Axis;
}();
var __extends$3D = undefined && undefined.__extends || function () {
  var _extendStatics240 = function extendStatics(d, b) {
    _extendStatics240 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics240(d, b);
  };
  return function (d, b) {
    _extendStatics240(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ChartAxisDirection;
(function (ChartAxisDirection) {
  ChartAxisDirection["X"] = "x";
  ChartAxisDirection["Y"] = "y"; // means 'radius' in polar charts
})(ChartAxisDirection || (ChartAxisDirection = {}));
function flipChartAxisDirection(direction) {
  if (direction === ChartAxisDirection.X) {
    return ChartAxisDirection.Y;
  } else {
    return ChartAxisDirection.X;
  }
}
var ChartAxisPosition;
(function (ChartAxisPosition) {
  ChartAxisPosition["Top"] = "top";
  ChartAxisPosition["Right"] = "right";
  ChartAxisPosition["Bottom"] = "bottom";
  ChartAxisPosition["Left"] = "left";
  ChartAxisPosition["Angle"] = "angle";
  ChartAxisPosition["Radius"] = "radius";
})(ChartAxisPosition || (ChartAxisPosition = {}));
var ChartAxis = /** @class */function (_super) {
  __extends$3D(ChartAxis, _super);
  function ChartAxis() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.keys = [];
    _this.direction = ChartAxisDirection.Y;
    _this.boundSeries = [];
    _this._position = ChartAxisPosition.Left;
    return _this;
  }
  Object.defineProperty(ChartAxis.prototype, "type", {
    get: function get() {
      return this.constructor.type || '';
    },
    enumerable: true,
    configurable: true
  });
  ChartAxis.prototype.getMeta = function () {
    return {
      id: this.id,
      direction: this.direction,
      boundSeries: this.boundSeries
    };
  };
  Object.defineProperty(ChartAxis.prototype, "position", {
    get: function get() {
      return this._position;
    },
    set: function set(value) {
      if (this._position !== value) {
        this._position = value;
        switch (value) {
          case ChartAxisPosition.Top:
            this.direction = ChartAxisDirection.X;
            this.rotation = -90;
            this.label.mirrored = true;
            this.label.parallel = true;
            break;
          case ChartAxisPosition.Right:
            this.direction = ChartAxisDirection.Y;
            this.rotation = 0;
            this.label.mirrored = true;
            this.label.parallel = false;
            break;
          case ChartAxisPosition.Bottom:
            this.direction = ChartAxisDirection.X;
            this.rotation = -90;
            this.label.mirrored = false;
            this.label.parallel = true;
            break;
          case ChartAxisPosition.Left:
            this.direction = ChartAxisDirection.Y;
            this.rotation = 0;
            this.label.mirrored = false;
            this.label.parallel = false;
            break;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  return ChartAxis;
}(Axis);
var __extends$3E = undefined && undefined.__extends || function () {
  var _extendStatics241 = function extendStatics(d, b) {
    _extendStatics241 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics241(d, b);
  };
  return function (d, b) {
    _extendStatics241(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
// Instead of clamping the values outside of domain to the range,
// return NaNs to indicate invalid input.
function clamper$1(domain) {
  var _a;
  var a = domain[0];
  var b = domain[domain.length - 1];
  if (a > b) {
    _a = [b, a], a = _a[0], b = _a[1];
  }
  return function (x) {
    return x >= a && x <= b ? x : NaN;
  };
}
var NumberAxis = /** @class */function (_super) {
  __extends$3E(NumberAxis, _super);
  function NumberAxis() {
    var _this = _super.call(this, new LinearScale()) || this;
    _this._nice = true;
    _this._min = NaN;
    _this._max = NaN;
    _this.scale.clamper = clamper$1;
    return _this;
  }
  Object.defineProperty(NumberAxis.prototype, "nice", {
    get: function get() {
      return this._nice;
    },
    set: function set(value) {
      if (this._nice !== value) {
        this._nice = value;
        if (value && this.scale.nice) {
          this.scale.nice(this.tick.count);
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NumberAxis.prototype, "domain", {
    get: function get() {
      return this.scale.domain;
    },
    set: function set(domain) {
      if (domain.length > 2) {
        domain = extent(domain, isContinuous, Number) || [0, 1];
      }
      var _a = this,
        scale = _a.scale,
        min = _a.min,
        max = _a.max;
      domain = [isNaN(min) ? domain[0] : min, isNaN(max) ? domain[1] : max];
      scale.domain = domain;
      this.onLabelFormatChange(this.label.format);
      scale.clamp = true;
      if (this.nice && this.scale.nice) {
        this.scale.nice(this.tick.count);
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NumberAxis.prototype, "min", {
    get: function get() {
      return this._min;
    },
    set: function set(value) {
      if (this._min !== value) {
        this._min = value;
        if (!isNaN(value)) {
          this.scale.domain = [value, this.scale.domain[1]];
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NumberAxis.prototype, "max", {
    get: function get() {
      return this._max;
    },
    set: function set(value) {
      if (this._max !== value) {
        this._max = value;
        if (!isNaN(value)) {
          this.scale.domain = [this.scale.domain[0], value];
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  NumberAxis.prototype.formatDatum = function (datum) {
    return datum.toFixed(2);
  };
  NumberAxis.className = 'NumberAxis';
  NumberAxis.type = 'number';
  return NumberAxis;
}(ChartAxis);

/**
 * Maps a discrete domain to a continuous numeric range.
 * See https://github.com/d3/d3-scale#band-scales for more info.
 */
var BandScale = /** @class */function () {
  function BandScale() {
    this.type = 'band';
    /**
     * Maps datum to its index in the {@link domain} array.
     * Used to check for duplicate datums (not allowed).
     */
    this.index = new Map();
    /**
     * The output range values for datum at each index.
     */
    this.ordinalRange = [];
    /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */
    this._domain = [];
    this._range = [0, 1];
    this._bandwidth = 1;
    /**
     * The ratio of the range that is reserved for space between bands.
     */
    this._paddingInner = 0;
    /**
     * The ratio of the range that is reserved for space before the first
     * and after the last band.
     */
    this._paddingOuter = 0;
    this._round = false;
    /**
     * How the leftover range is distributed.
     * `0.5` - equal distribution of space before the first and after the last band,
     * with bands effectively centered within the range.
     */
    this._align = 0.5;
  }
  Object.defineProperty(BandScale.prototype, "domain", {
    get: function get() {
      return this._domain;
    },
    set: function set(values) {
      var domain = this._domain;
      domain.length = 0;
      this.index = new Map();
      var index = this.index;
      // In case one wants to have duplicate domain values, for example, two 'Italy' categories,
      // one should use objects rather than strings for domain values like so:
      // { toString: () => 'Italy' }
      // { toString: () => 'Italy' }
      values.forEach(function (value) {
        if (index.get(value) === undefined) {
          index.set(value, domain.push(value) - 1);
        }
      });
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "range", {
    get: function get() {
      return this._range;
    },
    set: function set(values) {
      this._range[0] = values[0];
      this._range[1] = values[1];
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  BandScale.prototype.ticks = function () {
    return this._domain;
  };
  BandScale.prototype.convert = function (d) {
    var i = this.index.get(d);
    if (i === undefined) {
      return NaN;
    }
    var r = this.ordinalRange[i];
    if (r === undefined) {
      return NaN;
    }
    return r;
  };
  Object.defineProperty(BandScale.prototype, "bandwidth", {
    get: function get() {
      return this._bandwidth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "padding", {
    get: function get() {
      return this._paddingInner;
    },
    set: function set(value) {
      value = Math.max(0, Math.min(1, value));
      this._paddingInner = value;
      this._paddingOuter = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "paddingInner", {
    get: function get() {
      return this._paddingInner;
    },
    set: function set(value) {
      this._paddingInner = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "paddingOuter", {
    get: function get() {
      return this._paddingOuter;
    },
    set: function set(value) {
      this._paddingOuter = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "round", {
    get: function get() {
      return this._round;
    },
    set: function set(value) {
      this._round = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "align", {
    get: function get() {
      return this._align;
    },
    set: function set(value) {
      this._align = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  BandScale.prototype.rescale = function () {
    var _a;
    var n = this._domain.length;
    if (!n) {
      return;
    }
    var _b = this._range,
      a = _b[0],
      b = _b[1];
    var reversed = b < a;
    if (reversed) {
      _a = [b, a], a = _a[0], b = _a[1];
    }
    var step = (b - a) / Math.max(1, n - this._paddingInner + this._paddingOuter * 2);
    if (this._round) {
      step = Math.floor(step);
    }
    a += (b - a - step * (n - this._paddingInner)) * this._align;
    this._bandwidth = step * (1 - this._paddingInner);
    if (this._round) {
      a = Math.round(a);
      this._bandwidth = Math.round(this._bandwidth);
    }
    var values = [];
    for (var i = 0; i < n; i++) {
      values.push(a + step * i);
    }
    this.ordinalRange = reversed ? values.reverse() : values;
  };
  return BandScale;
}();
var __extends$3F = undefined && undefined.__extends || function () {
  var _extendStatics242 = function extendStatics(d, b) {
    _extendStatics242 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics242(d, b);
  };
  return function (d, b) {
    _extendStatics242(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CategoryAxis = /** @class */function (_super) {
  __extends$3F(CategoryAxis, _super);
  function CategoryAxis() {
    var _this = _super.call(this, new BandScale()) || this;
    _this.scale.paddingInner = 0.2;
    _this.scale.paddingOuter = 0.3;
    return _this;
  }
  Object.defineProperty(CategoryAxis.prototype, "paddingInner", {
    get: function get() {
      return this.scale.paddingInner;
    },
    set: function set(value) {
      this.scale.paddingInner = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CategoryAxis.prototype, "paddingOuter", {
    get: function get() {
      return this.scale.paddingOuter;
    },
    set: function set(value) {
      this.scale.paddingOuter = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CategoryAxis.prototype, "domain", {
    get: function get() {
      return this.scale.domain.slice();
    },
    set: function set(values) {
      // Prevent duplicate categories.
      this.scale.domain = values.filter(function (s, i, arr) {
        return arr.indexOf(s) === i;
      });
    },
    enumerable: true,
    configurable: true
  });
  CategoryAxis.className = 'CategoryAxis';
  CategoryAxis.type = 'category';
  return CategoryAxis;
}(ChartAxis);

/**
 * The tree layout is calculated in abstract x/y coordinates, where the root is at (0, 0)
 * and the tree grows downward from the root.
 */
var TreeNode = /** @class */function () {
  function TreeNode(label, parent, number) {
    if (label === void 0) {
      label = '';
    }
    if (number === void 0) {
      number = 0;
    }
    this.x = 0;
    this.y = 0;
    this.subtreeLeft = NaN;
    this.subtreeRight = NaN;
    this.screenX = 0;
    this.screenY = 0;
    this.children = [];
    this.leafCount = 0;
    this.prelim = 0;
    this.mod = 0;
    this.ancestor = this;
    this.change = 0;
    this.shift = 0;
    this.label = label;
    // screenX and screenY are meant to be recomputed from (layout) x and y
    // when the tree is resized (without performing another layout)
    this.parent = parent;
    this.depth = parent ? parent.depth + 1 : 0;
    this.number = number;
  }
  TreeNode.prototype.getLeftSibling = function () {
    return this.number > 0 && this.parent ? this.parent.children[this.number - 1] : undefined;
  };
  TreeNode.prototype.getLeftmostSibling = function () {
    return this.number > 0 && this.parent ? this.parent.children[0] : undefined;
  };
  // traverse the left contour of a subtree, return the successor of v on this contour
  TreeNode.prototype.nextLeft = function () {
    return this.children ? this.children[0] : this.thread;
  };
  // traverse the right contour of a subtree, return the successor of v on this contour
  TreeNode.prototype.nextRight = function () {
    return this.children ? this.children[this.children.length - 1] : this.thread;
  };
  TreeNode.prototype.getSiblings = function () {
    var _this = this;
    return this.parent ? this.parent.children.filter(function (_, i) {
      return i !== _this.number;
    }) : [];
  };
  return TreeNode;
}();
/**
 * Converts an array of ticks, where each tick has an array of labels, to a label tree.
 * If `pad` is `true`, will ensure that every branch matches the depth of the tree by
 * creating empty labels.
 */
function ticksToTree(ticks, pad) {
  if (pad === void 0) {
    pad = true;
  }
  var root = new TreeNode();
  var depth = 0;
  if (pad) {
    ticks.forEach(function (tick) {
      return depth = Math.max(depth, tick.labels.length);
    });
  }
  ticks.forEach(function (tick) {
    if (pad) {
      while (tick.labels.length < depth) {
        tick.labels.unshift('');
      }
    }
    insertTick(root, tick);
  });
  return root;
}
function insertTick(root, tick) {
  var pathParts = tick.labels.slice().reverse(); // path elements from root to leaf label
  var lastPartIndex = pathParts.length - 1;
  pathParts.forEach(function (pathPart, partIndex) {
    var children = root.children;
    var existingNode = find$4(children, function (child) {
      return child.label === pathPart;
    });
    var isNotLeaf = partIndex !== lastPartIndex;
    if (existingNode && isNotLeaf) {
      // the isNotLeaf check is to allow duplicate leafs
      root = existingNode;
    } else {
      var node = new TreeNode(pathPart, root);
      node.number = children.length;
      children.push(node);
      if (isNotLeaf) {
        root = node;
      }
    }
  });
}
// Shift the subtree.
function moveSubtree(wm, wp, shift) {
  var subtrees = wp.number - wm.number;
  var ratio = shift / subtrees;
  wp.change -= ratio;
  wp.shift += shift;
  wm.change += ratio;
  wp.prelim += shift;
  wp.mod += shift;
}
function ancestor(vim, v, defaultAncestor) {
  return v.getSiblings().indexOf(vim.ancestor) >= 0 ? vim.ancestor : defaultAncestor;
}
// Spaces out the children.
function executeShifts(v) {
  var children = v.children;
  if (children) {
    var shift = 0;
    var change = 0;
    for (var i = children.length - 1; i >= 0; i--) {
      var w = children[i];
      w.prelim += shift;
      w.mod += shift;
      change += w.change;
      shift += w.shift + change;
    }
  }
}
// Moves current subtree with v as the root if some nodes are conflicting in space.
function apportion(v, defaultAncestor, distance) {
  var w = v.getLeftSibling();
  if (w) {
    var vop = v;
    var vip = v;
    var vim = w;
    var vom = vip.getLeftmostSibling();
    var sip = vip.mod;
    var sop = vop.mod;
    var sim = vim.mod;
    var som = vom.mod;
    while (vim.nextRight() && vip.nextLeft()) {
      vim = vim.nextRight();
      vip = vip.nextLeft();
      vom = vom.nextLeft();
      vop = vop.nextRight();
      vop.ancestor = v;
      var shift = vim.prelim + sim - (vip.prelim + sip) + distance;
      if (shift > 0) {
        moveSubtree(ancestor(vim, v, defaultAncestor), v, shift);
        sip += shift;
        sop += shift;
      }
      sim += vim.mod;
      sip += vip.mod;
      som += vom.mod;
      sop += vop.mod;
    }
    if (vim.nextRight() && !vop.nextRight()) {
      vop.thread = vim.nextRight();
      vop.mod += sim - sop;
    } else {
      if (vip.nextLeft() && !vom.nextLeft()) {
        vom.thread = vip.nextLeft();
        vom.mod += sip - som;
      }
      defaultAncestor = v;
    }
  }
  return defaultAncestor;
}
// Compute the preliminary x-coordinate of node and its children (recursively).
function firstWalk(node, distance) {
  var children = node.children;
  if (children.length) {
    var defaultAncestor_1 = children[0];
    children.forEach(function (child) {
      firstWalk(child, distance);
      defaultAncestor_1 = apportion(child, defaultAncestor_1, distance);
    });
    executeShifts(node);
    var midpoint = (children[0].prelim + children[children.length - 1].prelim) / 2;
    var leftSibling = node.getLeftSibling();
    if (leftSibling) {
      node.prelim = leftSibling.prelim + distance;
      node.mod = node.prelim - midpoint;
    } else {
      node.prelim = midpoint;
    }
  } else {
    var leftSibling = node.getLeftSibling();
    node.prelim = leftSibling ? leftSibling.prelim + distance : 0;
  }
}
var Dimensions = /** @class */function () {
  function Dimensions() {
    this.top = Infinity;
    this.right = -Infinity;
    this.bottom = -Infinity;
    this.left = Infinity;
  }
  Dimensions.prototype.update = function (node, xy) {
    var _a = xy(node),
      x = _a.x,
      y = _a.y;
    if (x > this.right) {
      this.right = x;
    }
    if (x < this.left) {
      this.left = x;
    }
    if (y > this.bottom) {
      this.bottom = y;
    }
    if (y < this.top) {
      this.top = y;
    }
  };
  return Dimensions;
}();
function secondWalk(v, m, layout) {
  v.x = v.prelim + m;
  v.y = v.depth;
  layout.update(v);
  v.children.forEach(function (w) {
    return secondWalk(w, m + v.mod, layout);
  });
}
// After the second walk the parent nodes are positioned at the center of their immediate children.
// If we want the parent nodes to be positioned at the center of the subtree for which they are roots,
// we need a third walk to adjust the positions.
function thirdWalk(v) {
  var children = v.children;
  var leafCount = 0;
  children.forEach(function (w) {
    thirdWalk(w);
    if (w.children.length) {
      leafCount += w.leafCount;
    } else {
      leafCount++;
    }
  });
  v.leafCount = leafCount;
  if (children.length) {
    v.subtreeLeft = children[0].subtreeLeft;
    v.subtreeRight = children[v.children.length - 1].subtreeRight;
    v.x = (v.subtreeLeft + v.subtreeRight) / 2;
  } else {
    v.subtreeLeft = v.x;
    v.subtreeRight = v.x;
  }
}
function treeLayout(root) {
  var layout = new TreeLayout();
  firstWalk(root, 1);
  secondWalk(root, -root.prelim, layout);
  thirdWalk(root);
  return layout;
}
var TreeLayout = /** @class */function () {
  function TreeLayout() {
    this.dimensions = new Dimensions();
    this.leafCount = 0;
    this.nodes = [];
    // One might want to process leaf nodes separately from the rest of the tree.
    // For example, position labels corresponding to leafs vertically, rather than horizontally.
    this.leafNodes = [];
    this.nonLeafNodes = [];
    this.depth = 0;
  }
  TreeLayout.prototype.update = function (node) {
    this.dimensions.update(node, function (node) {
      return {
        x: node.x,
        y: node.y
      };
    });
    if (!node.children.length) {
      this.leafCount++;
      this.leafNodes.push(node);
    } else {
      this.nonLeafNodes.push(node);
    }
    if (node.depth > this.depth) {
      this.depth = node.depth;
    }
    this.nodes.push(node);
  };
  TreeLayout.prototype.resize = function (width, height, shiftX, shiftY, flipX) {
    if (shiftX === void 0) {
      shiftX = 0;
    }
    if (shiftY === void 0) {
      shiftY = 0;
    }
    if (flipX === void 0) {
      flipX = false;
    }
    var xSteps = this.leafCount - 1;
    var ySteps = this.depth;
    var dimensions = this.dimensions;
    var scalingX = 1;
    var scalingY = 1;
    if (width > 0 && xSteps) {
      var existingSpacingX = (dimensions.right - dimensions.left) / xSteps;
      var desiredSpacingX = width / xSteps;
      scalingX = desiredSpacingX / existingSpacingX;
      if (flipX) {
        scalingX = -scalingX;
      }
    }
    if (height > 0 && ySteps) {
      var existingSpacingY = (dimensions.bottom - dimensions.top) / ySteps;
      var desiredSpacingY = height / ySteps;
      scalingY = desiredSpacingY / existingSpacingY;
    }
    var screenDimensions = new Dimensions();
    this.nodes.forEach(function (node) {
      node.screenX = node.x * scalingX;
      node.screenY = node.y * scalingY;
      screenDimensions.update(node, function (node) {
        return {
          x: node.screenX,
          y: node.screenY
        };
      });
    });
    // Normalize so that root top and leftmost leaf left start at zero.
    var offsetX = -screenDimensions.left;
    var offsetY = -screenDimensions.top;
    this.nodes.forEach(function (node) {
      node.screenX += offsetX + shiftX;
      node.screenY += offsetY + shiftY;
    });
  };
  return TreeLayout;
}();
var __extends$3G = undefined && undefined.__extends || function () {
  var _extendStatics243 = function extendStatics(d, b) {
    _extendStatics243 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics243(d, b);
  };
  return function (d, b) {
    _extendStatics243(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var GroupedCategoryAxisLabel = /** @class */function (_super) {
  __extends$3G(GroupedCategoryAxisLabel, _super);
  function GroupedCategoryAxisLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.grid = false;
    return _this;
  }
  return GroupedCategoryAxisLabel;
}(AxisLabel);
var GroupedCategoryAxis = /** @class */function (_super) {
  __extends$3G(GroupedCategoryAxis, _super);
  function GroupedCategoryAxis() {
    var _this = _super.call(this, new BandScale()) || this;
    // Label scale (labels are positionsed between ticks, tick count = label count + 1).
    // We don't call is `labelScale` for consistency with other axes.
    _this.tickScale = new BandScale();
    _this.longestSeparatorLength = 0;
    _this.translation = {
      x: 0,
      y: 0
    };
    /**
     * Axis rotation angle in degrees.
     */
    _this.rotation = 0;
    _this.line = {
      width: 1,
      color: 'rgba(195, 195, 195, 1)'
    };
    // readonly tick = new AxisTick();
    _this.label = new GroupedCategoryAxisLabel();
    /**
     * The color of the labels.
     * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make labels invisible.
     */
    _this.labelColor = 'rgba(87, 87, 87, 1)';
    var _a = _this,
      group = _a.group,
      tickScale = _a.tickScale,
      scale = _a.scale;
    scale.paddingOuter = 0.1;
    scale.paddingInner = scale.paddingOuter * 2;
    _this.requestedRange = scale.range.slice();
    _this.scale = scale;
    tickScale.paddingInner = 1;
    tickScale.paddingOuter = 0;
    _this.gridLineSelection = Selection.select(group).selectAll();
    _this.axisLineSelection = Selection.select(group).selectAll();
    _this.separatorSelection = Selection.select(group).selectAll();
    _this.labelSelection = Selection.select(group).selectAll();
    return _this;
    // this.group.append(this.bboxRect); // debug (bbox)
  }

  Object.defineProperty(GroupedCategoryAxis.prototype, "domain", {
    get: function get() {
      return this.scale.domain;
    },
    set: function set(values) {
      this.scale.domain = values;
      var tickTree = ticksToTree(values);
      this.tickTreeLayout = treeLayout(tickTree);
      var domain = values.slice();
      domain.push('');
      this.tickScale.domain = domain;
      this.resizeTickTree();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(GroupedCategoryAxis.prototype, "range", {
    get: function get() {
      return this.requestedRange.slice();
    },
    set: function set(value) {
      this.requestedRange = value.slice();
      this.updateRange();
    },
    enumerable: true,
    configurable: true
  });
  GroupedCategoryAxis.prototype.updateRange = function () {
    var _a = this,
      rr = _a.requestedRange,
      vr = _a.visibleRange,
      scale = _a.scale;
    var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
    var shift = span * vr[0];
    var start = rr[0] - shift;
    this.tickScale.range = scale.range = [start, start + span];
    this.resizeTickTree();
  };
  GroupedCategoryAxis.prototype.resizeTickTree = function () {
    var s = this.scale;
    var range = s.domain.length ? [s.convert(s.domain[0]), s.convert(s.domain[s.domain.length - 1])] : s.range;
    var layout = this.tickTreeLayout;
    var lineHeight = this.lineHeight;
    if (layout) {
      layout.resize(Math.abs(range[1] - range[0]), layout.depth * lineHeight, (Math.min(range[0], range[1]) || 0) + (s.bandwidth || 0) / 2, -layout.depth * lineHeight, range[1] - range[0] < 0);
    }
  };
  Object.defineProperty(GroupedCategoryAxis.prototype, "lineHeight", {
    get: function get() {
      return this.label.fontSize * 1.5;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(GroupedCategoryAxis.prototype, "gridLength", {
    get: function get() {
      return this._gridLength;
    },
    /**
     * The length of the grid. The grid is only visible in case of a non-zero value.
     */
    set: function set(value) {
      // Was visible and now invisible, or was invisible and now visible.
      if (this._gridLength && !value || !this._gridLength && value) {
        this.gridLineSelection = this.gridLineSelection.remove().setData([]);
        this.labelSelection = this.labelSelection.remove().setData([]);
      }
      this._gridLength = value;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   * Supposed to be called _manually_ after changing _any_ of the axis properties.
   * This allows to bulk set axis properties before updating the nodes.
   * The node changes made by this method are rendered on the next animation frame.
   * We could schedule this method call automatically on the next animation frame
   * when any of the axis properties change (the way we do when properties of scene graph's
   * nodes change), but this will mean that we first wait for the next animation
   * frame to make changes to the nodes of the axis, then wait for another animation
   * frame to render those changes. It's nice to have everything update automatically,
   * but this extra level of async indirection will not just introduce an unwanted delay,
   * it will also make it harder to reason about the program.
   */
  GroupedCategoryAxis.prototype.update = function () {
    var _this = this;
    var _a = this,
      group = _a.group,
      scale = _a.scale,
      label = _a.label,
      tickScale = _a.tickScale,
      requestedRange = _a.requestedRange;
    var rangeStart = scale.range[0];
    var rangeEnd = scale.range[1];
    var rangeLength = Math.abs(rangeEnd - rangeStart);
    var bandwidth = rangeLength / scale.domain.length || 0;
    var parallelLabels = label.parallel;
    var rotation = toRadians(this.rotation);
    var isHorizontal = Math.abs(Math.cos(rotation)) < 1e-8;
    var labelRotation = normalizeAngle360(toRadians(this.label.rotation));
    group.translationX = this.translation.x;
    group.translationY = this.translation.y;
    group.rotation = rotation;
    var title = this.title;
    // The Text `node` of the Caption is not used to render the title of the grouped category axis.
    // The phantom root of the tree layout is used instead.
    if (title) {
      title.node.visible = false;
    }
    var lineHeight = this.lineHeight;
    // Render ticks and labels.
    var tickTreeLayout = this.tickTreeLayout;
    var labels = scale.ticks();
    var treeLabels = tickTreeLayout ? tickTreeLayout.nodes : [];
    var isLabelTree = tickTreeLayout ? tickTreeLayout.depth > 1 : false;
    var ticks = tickScale.ticks();
    // The side of the axis line to position the labels on.
    // -1 = left (default)
    //  1 = right
    var sideFlag = label.mirrored ? 1 : -1;
    // When labels are parallel to the axis line, the `parallelFlipFlag` is used to
    // flip the labels to avoid upside-down text, when the axis is rotated
    // such that it is in the right hemisphere, i.e. the angle of rotation
    // is in the [0, π] interval.
    // The rotation angle is normalized, so that we have an easier time checking
    // if it's in the said interval. Since the axis is always rendered vertically
    // and then rotated, zero rotation means 12 (not 3) o-clock.
    // -1 = flip
    //  1 = don't flip (default)
    var parallelFlipRotation = normalizeAngle360(rotation);
    var parallelFlipFlag = !labelRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
    var regularFlipRotation = normalizeAngle360(rotation - Math.PI / 2);
    // Flip if the axis rotation angle is in the top hemisphere.
    var regularFlipFlag = !labelRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
    var updateGridLines = this.gridLineSelection.setData(this.gridLength ? ticks : []);
    updateGridLines.exit.remove();
    var enterGridLines = updateGridLines.enter.append(Line);
    var gridLineSelection = updateGridLines.merge(enterGridLines);
    var updateLabels = this.labelSelection.setData(treeLabels);
    updateLabels.exit.remove();
    var enterLabels = updateLabels.enter.append(Text);
    var labelSelection = updateLabels.merge(enterLabels);
    var labelFormatter = label.formatter;
    var maxLeafLabelWidth = 0;
    labelSelection.each(function (node, datum, index) {
      node.fontStyle = label.fontStyle;
      node.fontWeight = label.fontWeight;
      node.fontSize = label.fontSize;
      node.fontFamily = label.fontFamily;
      node.fill = label.color;
      node.textBaseline = parallelFlipFlag === -1 ? 'bottom' : 'hanging';
      // label.textBaseline = parallelLabels && !labelRotation
      //     ? (sideFlag * parallelFlipFlag === -1 ? 'hanging' : 'bottom')
      //     : 'middle';
      node.textAlign = 'center';
      node.translationX = datum.screenY - label.fontSize * 0.25;
      node.translationY = datum.screenX;
      if (index === 0) {
        // use the phantom root as the axis title
        if (title && title.enabled && labels.length > 0) {
          node.visible = true;
          node.text = title.text;
          node.fontSize = title.fontSize;
          node.fontStyle = title.fontStyle;
          node.fontWeight = title.fontWeight;
          node.fontFamily = title.fontFamily;
          node.textBaseline = 'hanging';
        } else {
          node.visible = false;
        }
      } else {
        node.text = labelFormatter ? labelFormatter({
          value: String(datum.label),
          index: index
        }) : String(datum.label);
        node.visible = datum.screenX >= requestedRange[0] && datum.screenX <= requestedRange[1];
      }
      var bbox = node.computeBBox();
      if (bbox && bbox.width > maxLeafLabelWidth) {
        maxLeafLabelWidth = bbox.width;
      }
    });
    var labelX = sideFlag * label.padding;
    var autoRotation = parallelLabels ? parallelFlipFlag * Math.PI / 2 : regularFlipFlag === -1 ? Math.PI : 0;
    var labelGrid = this.label.grid;
    var separatorData = [];
    labelSelection.each(function (label, datum, index) {
      label.x = labelX;
      label.rotationCenterX = labelX;
      if (!datum.children.length) {
        label.rotation = labelRotation;
        label.textAlign = 'end';
        label.textBaseline = 'middle';
      } else {
        label.translationX -= maxLeafLabelWidth - lineHeight + _this.label.padding;
        if (isHorizontal) {
          label.rotation = autoRotation;
        } else {
          label.rotation = -Math.PI / 2;
        }
      }
      // Calculate positions of label separators for all nodes except the root.
      // Each separator is placed to the top of the current label.
      if (datum.parent && isLabelTree) {
        var y = !datum.children.length ? datum.screenX - bandwidth / 2 : datum.screenX - datum.leafCount * bandwidth / 2;
        if (!datum.children.length) {
          if (datum.number !== datum.children.length - 1 || labelGrid) {
            separatorData.push({
              y: y,
              x1: 0,
              x2: -maxLeafLabelWidth - _this.label.padding * 2,
              toString: function toString() {
                return String(index);
              }
            });
          }
        } else {
          var x = -maxLeafLabelWidth - _this.label.padding * 2 + datum.screenY;
          separatorData.push({
            y: y,
            x1: x + lineHeight,
            x2: x,
            toString: function toString() {
              return String(index);
            }
          });
        }
      }
    });
    // Calculate the position of the long separator on the far bottom of the axis.
    var minX = 0;
    separatorData.forEach(function (d) {
      return minX = Math.min(minX, d.x2);
    });
    this.longestSeparatorLength = Math.abs(minX);
    separatorData.push({
      y: Math.max(rangeStart, rangeEnd),
      x1: 0,
      x2: minX,
      toString: function toString() {
        return String(separatorData.length);
      }
    });
    var updateSeparators = this.separatorSelection.setData(separatorData);
    updateSeparators.exit.remove();
    var enterSeparators = updateSeparators.enter.append(Line);
    var separatorSelection = updateSeparators.merge(enterSeparators);
    this.separatorSelection = separatorSelection;
    var epsilon = 0.0000001;
    separatorSelection.each(function (line, datum, i) {
      line.x1 = datum.x1;
      line.x2 = datum.x2;
      line.y1 = datum.y;
      line.y2 = datum.y;
      line.visible = datum.y >= requestedRange[0] - epsilon && datum.y <= requestedRange[1] + epsilon;
      line.stroke = _this.tick.color;
      line.fill = undefined;
      line.strokeWidth = 1;
    });
    this.gridLineSelection = gridLineSelection;
    this.labelSelection = labelSelection;
    // Render axis lines.
    var lineCount = tickTreeLayout ? tickTreeLayout.depth + 1 : 1;
    var lines = [];
    for (var i = 0; i < lineCount; i++) {
      lines.push(i);
    }
    var updateAxisLines = this.axisLineSelection.setData(lines);
    updateAxisLines.exit.remove();
    var enterAxisLines = updateAxisLines.enter.append(Line);
    var axisLineSelection = updateAxisLines.merge(enterAxisLines);
    this.axisLineSelection = axisLineSelection;
    axisLineSelection.each(function (line, _, index) {
      var x = index > 0 ? -maxLeafLabelWidth - _this.label.padding * 2 - (index - 1) * lineHeight : 0;
      line.x1 = x;
      line.x2 = x;
      line.y1 = requestedRange[0];
      line.y2 = requestedRange[1];
      line.strokeWidth = _this.line.width;
      line.stroke = _this.line.color;
      line.visible = labels.length > 0 && (index === 0 || labelGrid && isLabelTree);
    });
    if (this.gridLength) {
      var styles_1 = this.gridStyle;
      var styleCount_1 = styles_1.length;
      gridLineSelection.each(function (line, datum, index) {
        var y = Math.round(tickScale.convert(datum));
        line.x1 = 0;
        line.x2 = -sideFlag * _this.gridLength;
        line.y1 = y;
        line.y2 = y;
        line.visible = y >= requestedRange[0] && y <= requestedRange[1] && Math.abs(line.parent.translationY - rangeStart) > 1;
        var style = styles_1[index % styleCount_1];
        line.stroke = style.stroke;
        line.strokeWidth = _this.tick.width;
        line.lineDash = style.lineDash;
        line.fill = undefined;
      });
    }
    // debug (bbox)
    // const bbox = this.computeBBox();
    // const bboxRect = this.bboxRect;
    // bboxRect.x = bbox.x;
    // bboxRect.y = bbox.y;
    // bboxRect.width = bbox.width;
    // bboxRect.height = bbox.height;
  };

  GroupedCategoryAxis.prototype.computeBBox = function (options) {
    var includeTitle = !options || !options.excludeTitle;
    var left = Infinity;
    var right = -Infinity;
    var top = Infinity;
    var bottom = -Infinity;
    this.labelSelection.each(function (label, _, index) {
      // The label itself is rotated, but not translated, the group that
      // contains it is. So to capture the group transform in the label bbox
      // calculation we combine the transform matrices of the label and the group.
      // Depending on the timing of the `axis.computeBBox()` method call, we may
      // not have the group's and the label's transform matrices updated yet (because
      // the transform matrix is not recalculated whenever a node's transform attributes
      // change, instead it's marked for recalculation on the next frame by setting
      // the node's `dirtyTransform` flag to `true`), so we force them to update
      // right here by calling `computeTransformMatrix`.
      if (index > 0 || includeTitle) {
        // first node is the root (title)
        label.computeTransformMatrix();
        var matrix = Matrix.flyweight(label.matrix);
        var labelBBox = label.computeBBox();
        if (labelBBox) {
          var bbox = matrix.transformBBox(labelBBox);
          left = Math.min(left, bbox.x);
          right = Math.max(right, bbox.x + bbox.width);
          top = Math.min(top, bbox.y);
          bottom = Math.max(bottom, bbox.y + bbox.height);
        }
      }
    });
    return new BBox(left, top, Math.max(right - left, this.longestSeparatorLength), bottom - top);
  };
  // debug (bbox)
  // private bboxRect = (() => {
  //     const rect = new Rect();
  //     rect.fill = undefined;
  //     rect.stroke = 'red';
  //     rect.strokeWidth = 1;
  //     rect.strokeOpacity = 0.2;
  //     return rect;
  // })();
  GroupedCategoryAxis.className = 'GroupedCategoryAxis';
  GroupedCategoryAxis.type = 'groupedCategory';
  return GroupedCategoryAxis;
}(ChartAxis);
var __extends$3H = undefined && undefined.__extends || function () {
  var _extendStatics244 = function extendStatics(d, b) {
    _extendStatics244 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics244(d, b);
  };
  return function (d, b) {
    _extendStatics244(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var t0 = new Date();
var t1 = new Date();
/**
 * The interval methods don't mutate Date parameters.
 */
var TimeInterval = /** @class */function () {
  function TimeInterval(floor, offset) {
    this._floor = floor;
    this._offset = offset;
  }
  /**
   * Returns a new date representing the latest interval boundary date before or equal to date.
   * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
   * @param date
   */
  TimeInterval.prototype.floor = function (date) {
    date = new Date(+date);
    this._floor(date);
    return date;
  };
  /**
   * Returns a new date representing the earliest interval boundary date after or equal to date.
   * @param date
   */
  TimeInterval.prototype.ceil = function (date) {
    date = new Date(+date - 1);
    this._floor(date);
    this._offset(date, 1);
    this._floor(date);
    return date;
  };
  /**
   * Returns a new date representing the closest interval boundary date to date.
   * @param date
   */
  TimeInterval.prototype.round = function (date) {
    var d0 = this.floor(date);
    var d1 = this.ceil(date);
    var ms = +date;
    return ms - d0.getTime() < d1.getTime() - ms ? d0 : d1;
  };
  /**
   * Returns a new date equal to date plus step intervals.
   * @param date
   * @param step
   */
  TimeInterval.prototype.offset = function (date, step) {
    if (step === void 0) {
      step = 1;
    }
    date = new Date(+date);
    this._offset(date, Math.floor(step));
    return date;
  };
  /**
   * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
   * @param start
   * @param stop
   * @param step
   */
  TimeInterval.prototype.range = function (start, stop, step) {
    if (step === void 0) {
      step = 1;
    }
    var range = [];
    start = this.ceil(start);
    step = Math.floor(step);
    if (start > stop || step <= 0) {
      return range;
    }
    var previous;
    do {
      previous = new Date(+start);
      range.push(previous);
      this._offset(start, step);
      this._floor(start);
    } while (previous < start && start < stop);
    return range;
  };
  // Returns an interval that is a subset of this interval.
  // For example, to create an interval that return 1st, 11th, 21st and 31st of each month:
  // day.filter(date => (date.getDate() - 1) % 10 === 0)
  TimeInterval.prototype.filter = function (test) {
    var _this = this;
    var floor = function floor(date) {
      if (date >= date) {
        while (_this._floor(date), !test(date)) {
          date.setTime(date.getTime() - 1);
        }
      }
      return date;
    };
    var offset = function offset(date, step) {
      if (date >= date) {
        if (step < 0) {
          while (++step <= 0) {
            do {
              _this._offset(date, -1);
            } while (!test(date));
          }
        } else {
          while (--step >= 0) {
            do {
              _this._offset(date, 1);
            } while (!test(date));
          }
        }
      }
      return date;
    };
    return new TimeInterval(floor, offset);
  };
  return TimeInterval;
}();
var CountableTimeInterval = /** @class */function (_super) {
  __extends$3H(CountableTimeInterval, _super);
  function CountableTimeInterval(floor, offset, count, field) {
    var _this = _super.call(this, floor, offset) || this;
    _this._count = count;
    _this._field = field;
    return _this;
  }
  /**
   * Returns the number of interval boundaries after start (exclusive) and before or equal to end (inclusive).
   * @param start
   * @param end
   */
  CountableTimeInterval.prototype.count = function (start, end) {
    t0.setTime(+start);
    t1.setTime(+end);
    this._floor(t0);
    this._floor(t1);
    return Math.floor(this._count(t0, t1));
  };
  /**
   * Returns a filtered view of this interval representing every step'th date.
   * The meaning of step is dependent on this interval’s parent interval as defined by the `field` function.
   * @param step
   */
  CountableTimeInterval.prototype.every = function (step) {
    var _this = this;
    var result;
    step = Math.floor(step);
    if (isFinite(step) && step > 0) {
      if (step > 1) {
        var field_1 = this._field;
        if (field_1) {
          result = this.filter(function (d) {
            return field_1(d) % step === 0;
          });
        } else {
          result = this.filter(function (d) {
            return _this.count(0, d) % step === 0;
          });
        }
      } else {
        result = this;
      }
    }
    return result;
  };
  return CountableTimeInterval;
}(TimeInterval);
function floor$1(date) {
  return date;
}
function offset(date, milliseconds) {
  date.setTime(date.getTime() + milliseconds);
}
function count(start, end) {
  return end.getTime() - start.getTime();
}
var millisecond = new CountableTimeInterval(floor$1, offset, count);

// Common time unit sizes in milliseconds.
var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;
function floor$2(date) {
  date.setTime(date.getTime() - date.getMilliseconds());
}
function offset$1(date, seconds) {
  date.setTime(date.getTime() + seconds * durationSecond);
}
function count$1(start, end) {
  return (end.getTime() - start.getTime()) / durationSecond;
}
var second = new CountableTimeInterval(floor$2, offset$1, count$1);
function floor$3(date) {
  date.setTime(date.getTime() - date.getMilliseconds() - date.getSeconds() * durationSecond);
}
function offset$2(date, minutes) {
  date.setTime(date.getTime() + minutes * durationMinute);
}
function count$2(start, end) {
  return (end.getTime() - start.getTime()) / durationMinute;
}
function field(date) {
  return date.getMinutes();
}
var minute = new CountableTimeInterval(floor$3, offset$2, count$2, field);
function floor$4(date) {
  date.setTime(date.getTime() - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}
function offset$3(date, hours) {
  date.setTime(date.getTime() + hours * durationHour);
}
function count$3(start, end) {
  return (end.getTime() - start.getTime()) / durationHour;
}
function field$1(date) {
  return date.getHours();
}
var hour = new CountableTimeInterval(floor$4, offset$3, count$3, field$1);
function floor$5(date) {
  date.setHours(0, 0, 0, 0);
}
function offset$4(date, days) {
  date.setDate(date.getDate() + days);
}
function count$4(start, end) {
  var tzMinuteDelta = end.getTimezoneOffset() - start.getTimezoneOffset();
  return (end.getTime() - start.getTime() - tzMinuteDelta * durationMinute) / durationDay;
}
function field$2(date) {
  return date.getDate() - 1;
}
var day = new CountableTimeInterval(floor$5, offset$4, count$4, field$2);

// Set date to n-th day of the week.
function weekday(n) {
  // Sets the `date` to the start of the `n`-th day of the current week.
  // n == 0 is Sunday.
  function floor(date) {
    //                  1..31            1..7
    date.setDate(date.getDate() - (date.getDay() + 7 - n) % 7);
    date.setHours(0, 0, 0, 0); // h, m, s, ms
  }
  // Offset the date by the given number of weeks.
  function offset(date, weeks) {
    date.setDate(date.getDate() + weeks * 7);
  }
  // Count the number of weeks between the start and end dates.
  function count(start, end) {
    var msDelta = end.getTime() - start.getTime();
    var tzMinuteDelta = end.getTimezoneOffset() - start.getTimezoneOffset();
    return (msDelta - tzMinuteDelta * durationMinute) / durationWeek;
  }
  return new CountableTimeInterval(floor, offset, count);
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
function floor$6(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}
function offset$5(date, months) {
  date.setMonth(date.getMonth() + months);
}
function count$5(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}
function field$3(date) {
  return date.getMonth();
}
var month = new CountableTimeInterval(floor$6, offset$5, count$5, field$3);
function floor$7(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}
function offset$6(date, years) {
  date.setFullYear(date.getFullYear() + years);
}
function count$6(start, end) {
  return end.getFullYear() - start.getFullYear();
}
function field$4(date) {
  return date.getFullYear();
}
var year = new CountableTimeInterval(floor$7, offset$6, count$6, field$4);
function floor$8(date) {
  date.setUTCHours(0, 0, 0, 0);
}
function offset$7(date, days) {
  date.setUTCDate(date.getUTCDate() + days);
}
function count$7(start, end) {
  return (end.getTime() - start.getTime()) / durationDay;
}
function field$5(date) {
  return date.getUTCDate() - 1;
}
var utcDay = new CountableTimeInterval(floor$8, offset$7, count$7, field$5);
function floor$9(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}
function offset$8(date, years) {
  date.setUTCFullYear(date.getUTCFullYear() + years);
}
function count$8(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}
function field$6(date) {
  return date.getUTCFullYear();
}
var utcYear = new CountableTimeInterval(floor$9, offset$8, count$8, field$6);

// Set date to n-th day of the week.
function weekday$1(n) {
  // Sets the `date` to the start of the `n`-th day of the current week.
  // n == 0 is Sunday.
  function floor(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - n) % 7);
    date.setHours(0, 0, 0, 0); // h, m, s, ms
  }
  // Offset the date by the given number of weeks.
  function offset(date, weeks) {
    date.setUTCDate(date.getUTCDate() + weeks * 7);
  }
  // Count the number of weeks between the start and end dates.
  function count(start, end) {
    return (end.getTime() - start.getTime()) / durationWeek;
  }
  return new CountableTimeInterval(floor, offset, count);
}
var utcSunday = weekday$1(0);
var utcMonday = weekday$1(1);
var utcTuesday = weekday$1(2);
var utcWednesday = weekday$1(3);
var utcThursday = weekday$1(4);
var utcFriday = weekday$1(5);
var utcSaturday = weekday$1(6);
function localDate(d) {
  // For JS Dates the [0, 100) interval is a time warp, a fast forward to the 20th century.
  // For example, -1 is -0001 BC, 0 is already 1900 AD.
  if (d.y >= 0 && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (d.y >= 0 && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
/**
 * Creates a lookup map for array of names to go from a name to index.
 * @param names
 */
function formatLookup(names) {
  var map = {};
  for (var i = 0, n = names.length; i < n; i++) {
    map[names[i].toLowerCase()] = i;
  }
  return map;
}
function newYear(y) {
  return {
    y: y,
    m: 0,
    d: 1,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
var percentCharCode = 37;
var numberRe = /^\s*\d+/; // ignores next directive
var percentRe = /^%/;
var requoteRe = /[\\^$*+?|[\]().{}]/g;
/**
 * Prepends any character in the `requoteRe` set with a backslash.
 * @param s
 */
var requote = function requote(s) {
  return s.replace(requoteRe, '\\$&');
}; // $& - matched substring
/**
 * Returns a RegExp that matches any string that starts with any of the given names (case insensitive).
 * @param names
 */
var formatRe = function formatRe(names) {
  return new RegExp('^(?:' + names.map(requote).join('|') + ')', 'i');
};
// A map of padding modifiers to padding strings. Default is `0`.
var pads = {
  '-': '',
  '_': ' ',
  '0': '0'
};
function pad(value, fill, width) {
  var sign = value < 0 ? '-' : '';
  var string = String(sign ? -value : value);
  var length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
/**
 * Create a new time-locale-based object which exposes time-formatting
 * methods for the specified locale definition.
 *
 * @param timeLocale A time locale definition.
 */
function formatLocale$1(timeLocale) {
  var lDateTime = timeLocale.dateTime;
  var lDate = timeLocale.date;
  var lTime = timeLocale.time;
  var lPeriods = timeLocale.periods;
  var lWeekdays = timeLocale.days;
  var lShortWeekdays = timeLocale.shortDays;
  var lMonths = timeLocale.months;
  var lShortMonths = timeLocale.shortMonths;
  var periodRe = formatRe(lPeriods);
  var periodLookup = formatLookup(lPeriods);
  var weekdayRe = formatRe(lWeekdays);
  var weekdayLookup = formatLookup(lWeekdays);
  var shortWeekdayRe = formatRe(lShortWeekdays);
  var shortWeekdayLookup = formatLookup(lShortWeekdays);
  var monthRe = formatRe(lMonths);
  var monthLookup = formatLookup(lMonths);
  var shortMonthRe = formatRe(lShortMonths);
  var shortMonthLookup = formatLookup(lShortMonths);
  var formats = {
    'a': formatShortWeekday,
    'A': formatWeekday,
    'b': formatShortMonth,
    'B': formatMonth,
    'c': undefined,
    'd': formatDayOfMonth,
    'e': formatDayOfMonth,
    'f': formatMicroseconds,
    'H': formatHour24,
    'I': formatHour12,
    'j': formatDayOfYear,
    'L': formatMilliseconds,
    'm': formatMonthNumber,
    'M': formatMinutes,
    'p': formatPeriod,
    'Q': formatUnixTimestamp,
    's': formatUnixTimestampSeconds,
    'S': formatSeconds,
    'u': formatWeekdayNumberMonday,
    'U': formatWeekNumberSunday,
    'V': formatWeekNumberISO,
    'w': formatWeekdayNumberSunday,
    'W': formatWeekNumberMonday,
    'x': undefined,
    'X': undefined,
    'y': formatYear,
    'Y': formatFullYear,
    'Z': formatZone,
    '%': formatLiteralPercent
  };
  var utcFormats = {
    'a': formatUTCShortWeekday,
    'A': formatUTCWeekday,
    'b': formatUTCShortMonth,
    'B': formatUTCMonth,
    'c': undefined,
    'd': formatUTCDayOfMonth,
    'e': formatUTCDayOfMonth,
    'f': formatUTCMicroseconds,
    'H': formatUTCHour24,
    'I': formatUTCHour12,
    'j': formatUTCDayOfYear,
    'L': formatUTCMilliseconds,
    'm': formatUTCMonthNumber,
    'M': formatUTCMinutes,
    'p': formatUTCPeriod,
    'Q': formatUnixTimestamp,
    's': formatUnixTimestampSeconds,
    'S': formatUTCSeconds,
    'u': formatUTCWeekdayNumberMonday,
    'U': formatUTCWeekNumberSunday,
    'V': formatUTCWeekNumberISO,
    'w': formatUTCWeekdayNumberSunday,
    'W': formatUTCWeekNumberMonday,
    'x': undefined,
    'X': undefined,
    'y': formatUTCYear,
    'Y': formatUTCFullYear,
    'Z': formatUTCZone,
    '%': formatLiteralPercent
  };
  var parses = {
    'a': parseShortWeekday,
    'A': parseWeekday,
    'b': parseShortMonth,
    'B': parseMonth,
    'c': parseLocaleDateTime,
    'd': parseDayOfMonth,
    'e': parseDayOfMonth,
    'f': parseMicroseconds,
    'H': parseHour24,
    'I': parseHour24,
    'j': parseDayOfYear,
    'L': parseMilliseconds,
    'm': parseMonthNumber,
    'M': parseMinutes,
    'p': parsePeriod,
    'Q': parseUnixTimestamp,
    's': parseUnixTimestampSeconds,
    'S': parseSeconds,
    'u': parseWeekdayNumberMonday,
    'U': parseWeekNumberSunday,
    'V': parseWeekNumberISO,
    'w': parseWeekdayNumberSunday,
    'W': parseWeekNumberMonday,
    'x': parseLocaleDate,
    'X': parseLocaleTime,
    'y': parseYear,
    'Y': parseFullYear,
    'Z': parseZone,
    '%': parseLiteralPercent
  };
  // Recursive definitions.
  formats.x = newFormat(lDate, formats);
  formats.X = newFormat(lTime, formats);
  formats.c = newFormat(lDateTime, formats);
  utcFormats.x = newFormat(lDate, utcFormats);
  utcFormats.X = newFormat(lTime, utcFormats);
  utcFormats.c = newFormat(lDateTime, utcFormats);
  function newParse(specifier, newDate) {
    return function (str) {
      var d = newYear(1900);
      var i = parseSpecifier(d, specifier, str += '', 0);
      if (i != str.length) {
        return undefined;
      }
      // If a UNIX timestamp is specified, return it.
      if ('Q' in d) {
        return new Date(d.Q);
      }
      // The am-pm flag is 0 for AM, and 1 for PM.
      if ('p' in d) {
        d.H = d.H % 12 + d.p * 12;
      }
      // Convert day-of-week and week-of-year to day-of-year.
      if ('V' in d) {
        if (d.V < 1 || d.V > 53) {
          return undefined;
        }
        if (!('w' in d)) {
          d.w = 1;
        }
        if ('Z' in d) {
          var week = utcDate(newYear(d.y));
          var day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday.floor(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          var week = newDate(newYear(d.y));
          var day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday.floor(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ('W' in d || 'U' in d) {
        if (!('w' in d)) {
          d.w = 'u' in d ? d.u % 7 : 'W' in d ? 1 : 0;
        }
        var day$1 = 'Z' in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = 'W' in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }
      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ('Z' in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }
  /**
   * Creates a new function that formats the given Date or timestamp according to specifier.
   * @param specifier
   * @param formats
   */
  function newFormat(specifier, formats) {
    return function (date) {
      var string = [];
      var n = specifier.length;
      var i = -1;
      var j = 0;
      if (!(date instanceof Date)) {
        date = new Date(+date);
      }
      while (++i < n) {
        if (specifier.charCodeAt(i) === percentCharCode) {
          string.push(specifier.slice(j, i)); // copy the chunks of specifier with no directives as is
          var c = specifier.charAt(++i);
          var pad_1 = pads[c];
          if (pad_1 != undefined) {
            // if format directive has a padding modifier in front of it
            c = specifier.charAt(++i); // fetch the directive itself
          } else {
            pad_1 = c === 'e' ? ' ' : '0'; // use the default padding modifier
          }

          var format = formats[c];
          if (format) {
            // if the directive has a corresponding formatting function
            c = format(date, pad_1); // replace the directive with the formatted date
          }

          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join('');
    };
  }
  // Simultaneously walks over the specifier and the parsed string, populating the `d` map with parsed values.
  // The returned number is expected to equal the length of the parsed `string`, if parsing succeeded.
  function parseSpecifier(d, specifier, string, j) {
    // i - `specifier` string index
    // j - parsed `string` index
    var i = 0;
    var n = specifier.length;
    var m = string.length;
    while (i < n) {
      if (j >= m) {
        return -1;
      }
      var code = specifier.charCodeAt(i++);
      if (code === percentCharCode) {
        var char = specifier.charAt(i++);
        var parse = parses[char in pads ? specifier.charAt(i++) : char];
        if (!parse || (j = parse(d, string, j)) < 0) {
          return -1;
        }
      } else if (code != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  // ----------------------------- formats ----------------------------------
  function formatMicroseconds(date, fill) {
    return formatMilliseconds(date, fill) + '000';
  }
  function formatMilliseconds(date, fill) {
    return pad(date.getMilliseconds(), fill, 3);
  }
  function formatSeconds(date, fill) {
    return pad(date.getSeconds(), fill, 2);
  }
  function formatMinutes(date, fill) {
    return pad(date.getMinutes(), fill, 2);
  }
  function formatHour12(date, fill) {
    return pad(date.getHours() % 12 || 12, fill, 2);
  }
  function formatHour24(date, fill) {
    return pad(date.getHours(), fill, 2);
  }
  function formatPeriod(date) {
    return lPeriods[date.getHours() >= 12 ? 1 : 0];
  }
  function formatShortWeekday(date) {
    return lShortWeekdays[date.getDay()];
  }
  function formatWeekday(date) {
    return lWeekdays[date.getDay()];
  }
  function formatWeekdayNumberMonday(date) {
    var dayOfWeek = date.getDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
  }
  function formatWeekNumberSunday(date, fill) {
    return pad(sunday.count(year.floor(date), date), fill, 2);
  }
  function formatWeekNumberISO(date, fill) {
    var day = date.getDay();
    date = day >= 4 || day === 0 ? thursday.floor(date) : thursday.ceil(date);
    var yearStart = year.floor(date);
    return pad(thursday.count(yearStart, date) + (yearStart.getDay() === 4 ? 1 : 0), fill, 2);
  }
  function formatWeekdayNumberSunday(date) {
    return date.getDay();
  }
  function formatWeekNumberMonday(date, fill) {
    return pad(monday.count(year.floor(date), date), fill, 2);
  }
  function formatDayOfMonth(date, fill) {
    return pad(date.getDate(), fill, 2);
  }
  function formatDayOfYear(date, fill) {
    return pad(1 + day.count(year.floor(date), date), fill, 3);
  }
  function formatShortMonth(date) {
    return lShortMonths[date.getMonth()];
  }
  function formatMonth(date) {
    return lMonths[date.getMonth()];
  }
  function formatMonthNumber(date, fill) {
    return pad(date.getMonth() + 1, fill, 2);
  }
  function formatYear(date, fill) {
    return pad(date.getFullYear() % 100, fill, 2);
  }
  function formatFullYear(date, fill) {
    return pad(date.getFullYear() % 10000, fill, 4);
  }
  function formatZone(date) {
    var z = date.getTimezoneOffset();
    return (z > 0 ? '-' : (z *= -1, '+')) + pad(Math.floor(z / 60), '0', 2) + pad(z % 60, '0', 2);
  }
  // -------------------------- UTC formats -----------------------------------
  function formatUTCMicroseconds(date, fill) {
    return formatUTCMilliseconds(date, fill) + '000';
  }
  function formatUTCMilliseconds(date, fill) {
    return pad(date.getUTCMilliseconds(), fill, 3);
  }
  function formatUTCSeconds(date, fill) {
    return pad(date.getUTCSeconds(), fill, 2);
  }
  function formatUTCMinutes(date, fill) {
    return pad(date.getUTCMinutes(), fill, 2);
  }
  function formatUTCHour12(date, fill) {
    return pad(date.getUTCHours() % 12 || 12, fill, 2);
  }
  function formatUTCHour24(date, fill) {
    return pad(date.getUTCHours(), fill, 2);
  }
  function formatUTCPeriod(date) {
    return lPeriods[date.getUTCHours() >= 12 ? 1 : 0];
  }
  function formatUTCDayOfMonth(date, fill) {
    return pad(date.getUTCDate(), fill, 2);
  }
  function formatUTCDayOfYear(date, fill) {
    return pad(1 + utcDay.count(utcYear.floor(date), date), fill, 3);
  }
  function formatUTCMonthNumber(date, fill) {
    return pad(date.getUTCMonth() + 1, fill, 2);
  }
  function formatUTCShortMonth(date) {
    return lShortMonths[date.getUTCMonth()];
  }
  function formatUTCMonth(date) {
    return lMonths[date.getUTCMonth()];
  }
  function formatUTCShortWeekday(date) {
    return lShortWeekdays[date.getUTCDay()];
  }
  function formatUTCWeekday(date) {
    return lWeekdays[date.getUTCDay()];
  }
  function formatUTCWeekdayNumberMonday(date) {
    var dayOfWeek = date.getUTCDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
  }
  function formatUTCWeekNumberSunday(date, fill) {
    return pad(utcSunday.count(utcYear.floor(date), date), fill, 2);
  }
  function formatUTCWeekNumberISO(date, fill) {
    var day = date.getUTCDay();
    date = day >= 4 || day === 0 ? utcThursday.floor(date) : utcThursday.ceil(date);
    var yearStart = utcYear.floor(date);
    return pad(utcThursday.count(yearStart, date) + (yearStart.getUTCDay() === 4 ? 1 : 0), fill, 4);
  }
  function formatUTCWeekdayNumberSunday(date) {
    return date.getUTCDay();
  }
  function formatUTCWeekNumberMonday(date, fill) {
    return pad(utcMonday.count(utcYear.floor(date), date), fill, 2);
  }
  function formatUTCYear(date, fill) {
    return pad(date.getUTCFullYear() % 100, fill, 2);
  }
  function formatUTCFullYear(date, fill) {
    return pad(date.getUTCFullYear() % 10000, fill, 4);
  }
  function formatUTCZone() {
    return '+0000';
  }
  function formatLiteralPercent(date) {
    return '%';
  }
  function formatUnixTimestamp(date) {
    return date.getTime();
  }
  function formatUnixTimestampSeconds(date) {
    return Math.floor(date.getTime() / 1000);
  }
  // ------------------------------- parsers ------------------------------------
  function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(parseFloat(n[0]) / 1000), i + n[0].length) : -1;
  }
  function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
  }
  function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
  }
  function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
  }
  function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
  }
  function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
  }
  function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = parseFloat(n[0]) - 1, i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, lDateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, lDate, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, lTime, string, i);
  }
  function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
  }
  function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
  }
  function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
  }
  function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
  }
  function parseZone(d, string, i) {
    var n = /^(Z)|^([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || '00')), i + n[0].length) : -1;
  }
  function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  return {
    format: function format(specifier) {
      var f = newFormat(specifier, formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function parse(specifier) {
      var p = newParse(specifier, localDate);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function utcFormat(specifier) {
      var f = newFormat(specifier, utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function utcParse(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function () {
        return specifier;
      };
      return p;
    }
  };
}
var locale;
setDefaultLocale({
  dateTime: '%x, %X',
  date: '%-m/%-d/%Y',
  time: '%-I:%M:%S %p',
  periods: ['AM', 'PM'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
});
function setDefaultLocale(definition) {
  return locale = formatLocale$1(definition);
}
var __extends$3I = undefined && undefined.__extends || function () {
  var _extendStatics245 = function extendStatics(d, b) {
    _extendStatics245 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics245(d, b);
  };
  return function (d, b) {
    _extendStatics245(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TimeScale = /** @class */function (_super) {
  __extends$3I(TimeScale, _super);
  function TimeScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'time';
    _this.year = year;
    _this.month = month;
    _this.week = sunday;
    _this.day = day;
    _this.hour = hour;
    _this.minute = minute;
    _this.second = second;
    _this.millisecond = millisecond;
    _this.format = locale.format;
    /**
     * Array of default tick intervals in the following format:
     *
     *     [
     *         interval (unit of time),
     *         number of units (step),
     *         the length of that number of units in milliseconds
     *     ]
     */
    _this.tickIntervals = [[_this.second, 1, durationSecond], [_this.second, 5, 5 * durationSecond], [_this.second, 15, 15 * durationSecond], [_this.second, 30, 30 * durationSecond], [_this.minute, 1, durationMinute], [_this.minute, 5, 5 * durationMinute], [_this.minute, 15, 15 * durationMinute], [_this.minute, 30, 30 * durationMinute], [_this.hour, 1, durationHour], [_this.hour, 3, 3 * durationHour], [_this.hour, 6, 6 * durationHour], [_this.hour, 12, 12 * durationHour], [_this.day, 1, durationDay], [_this.day, 2, 2 * durationDay], [_this.week, 1, durationWeek], [_this.month, 1, durationMonth], [_this.month, 3, 3 * durationMonth], [_this.year, 1, durationYear]];
    _this.formatMillisecond = _this.format('.%L');
    _this.formatSecond = _this.format(':%S');
    _this.formatMinute = _this.format('%I:%M');
    _this.formatHour = _this.format('%I %p');
    _this.formatDay = _this.format('%a %d');
    _this.formatWeek = _this.format('%b %d');
    _this.formatMonth = _this.format('%B');
    _this.formatYear = _this.format('%Y');
    _this._domain = [new Date(2000, 0, 1), new Date(2000, 0, 2)];
    return _this;
  }
  TimeScale.prototype.defaultTickFormat = function (date) {
    return (this.second.floor(date) < date ? this.formatMillisecond : this.minute.floor(date) < date ? this.formatSecond : this.hour.floor(date) < date ? this.formatMinute : this.day.floor(date) < date ? this.formatHour : this.month.floor(date) < date ? this.week.floor(date) < date ? this.formatDay : this.formatWeek : this.year.floor(date) < date ? this.formatMonth : this.formatYear)(date);
  };
  /**
   *
   * @param interval If the `interval` is a number, it's interpreted as the desired tick count
   * and the method tries to pick an appropriate interval automatically, based on the extent of the domain.
   * If the `interval` is `undefined`, it defaults to `10`.
   * If the `interval` is a time interval, simply use it.
   * @param start The start time (timestamp).
   * @param stop The end time (timestamp).
   * @param step Number of intervals between ticks.
   */
  TimeScale.prototype.tickInterval = function (interval, start, stop, step) {
    var _a;
    if (typeof interval === 'number') {
      var tickCount = interval;
      var tickIntervals = this.tickIntervals;
      var target = Math.abs(stop - start) / tickCount;
      var i = complexBisectRight(tickIntervals, target, function (interval) {
        return interval[2];
      });
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, tickCount);
        interval = this.year;
      } else if (i) {
        _a = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], interval = _a[0], step = _a[1];
      } else {
        step = Math.max(tickStep(start, stop, interval), 1);
        interval = this.millisecond;
      }
    }
    return step == undefined ? interval : interval.every(step);
  };
  Object.defineProperty(TimeScale.prototype, "domain", {
    get: function get() {
      return _super.prototype.getDomain.call(this).map(function (t) {
        return new Date(t);
      });
    },
    set: function set(values) {
      _super.prototype.setDomain.call(this, Array.prototype.map.call(values, function (t) {
        return t instanceof Date ? +t : +new Date(+t);
      }));
    },
    enumerable: true,
    configurable: true
  });
  TimeScale.prototype.invert = function (y) {
    return new Date(_super.prototype.invert.call(this, y));
  };
  /**
   * Returns uniformly-spaced dates that represent the scale's domain.
   * @param interval The desired tick count or a time interval object.
   */
  TimeScale.prototype.ticks = function (interval) {
    if (interval === void 0) {
      interval = 10;
    }
    var d = _super.prototype.getDomain.call(this);
    var t0 = d[0];
    var t1 = d[d.length - 1];
    var reverse = t1 < t0;
    if (reverse) {
      var _ = t0;
      t0 = t1;
      t1 = _;
    }
    var t = this.tickInterval(interval, t0, t1);
    var i = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return reverse ? i.reverse() : i;
  };
  /**
   * Returns a time format function suitable for displaying tick values.
   * @param count Ignored. Used only to satisfy the {@link Scale} interface.
   * @param specifier If the specifier string is provided, this method is equivalent to
   * the {@link TimeLocaleObject.format} method.
   * If no specifier is provided, this method returns the default time format function.
   */
  TimeScale.prototype.tickFormat = function (count, specifier) {
    return specifier == undefined ? this.defaultTickFormat.bind(this) : this.format(specifier);
  };
  /**
   * Extends the domain so that it starts and ends on nice round values.
   * This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value.
   * @param interval
   */
  TimeScale.prototype.nice = function (interval) {
    if (interval === void 0) {
      interval = 10;
    }
    var d = _super.prototype.getDomain.call(this);
    var i = this.tickInterval(interval, d[0], d[d.length - 1]);
    if (i) {
      this.domain = this._nice(d, i);
    }
  };
  TimeScale.prototype._nice = function (domain, interval) {
    var _a, _b;
    domain = domain.slice();
    var i0 = 0;
    var i1 = domain.length - 1;
    var x0 = domain[i0];
    var x1 = domain[i1];
    if (x1 < x0) {
      _a = [i1, i0], i0 = _a[0], i1 = _a[1];
      _b = [x1, x0], x0 = _b[0], x1 = _b[1];
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
  };
  return TimeScale;
}(ContinuousScale);
var __extends$3J = undefined && undefined.__extends || function () {
  var _extendStatics246 = function extendStatics(d, b) {
    _extendStatics246 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics246(d, b);
  };
  return function (d, b) {
    _extendStatics246(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TimeAxis = /** @class */function (_super) {
  __extends$3J(TimeAxis, _super);
  function TimeAxis() {
    var _this = _super.call(this, new TimeScale()) || this;
    _this.datumFormat = '%m/%d/%y, %H:%M:%S';
    _this._nice = true;
    var scale = _this.scale;
    scale.clamp = true;
    _this.scale = scale;
    _this.datumFormatter = scale.tickFormat(_this.tick.count, _this.datumFormat);
    return _this;
  }
  Object.defineProperty(TimeAxis.prototype, "nice", {
    get: function get() {
      return this._nice;
    },
    set: function set(value) {
      if (this._nice !== value) {
        this._nice = value;
        if (value && this.scale.nice) {
          this.scale.nice(10);
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeAxis.prototype, "domain", {
    get: function get() {
      return this.scale.domain;
    },
    set: function set(domain) {
      if (domain.length > 2) {
        domain = (extent(domain, isContinuous, Number) || [0, 1000]).map(function (x) {
          return new Date(x);
        });
      }
      this.scale.domain = domain;
      if (this.nice && this.scale.nice) {
        this.scale.nice(10);
      }
    },
    enumerable: true,
    configurable: true
  });
  TimeAxis.prototype.onLabelFormatChange = function (format) {
    if (format) {
      _super.prototype.onLabelFormatChange.call(this, format);
    } else {
      // For time axis labels to look nice, even if date format wasn't set.
      this.labelFormatter = this.scale.tickFormat(this.tick.count, undefined);
    }
  };
  TimeAxis.prototype.formatDatum = function (datum) {
    return this.datumFormatter(datum);
  };
  TimeAxis.className = 'TimeAxis';
  TimeAxis.type = 'time';
  return TimeAxis;
}(ChartAxis);
var Scene = /** @class */function () {
  // As a rule of thumb, constructors with no parameters are preferred.
  // A few exceptions are:
  // - we absolutely need to know something at construction time (document)
  // - knowing something at construction time meaningfully improves performance (width, height)
  function Scene(document, width, height) {
    var _this = this;
    if (document === void 0) {
      document = window.document;
    }
    this.id = createId(this);
    this._dirty = false;
    this.animationFrameId = 0;
    this._root = null;
    this.debug = {
      renderFrameIndex: false,
      renderBoundingBoxes: false
    };
    this._frameIndex = 0;
    this.render = function () {
      var _a;
      var _b = _this,
        ctx = _b.ctx,
        root = _b.root,
        pendingSize = _b.pendingSize;
      _this.animationFrameId = 0;
      if (pendingSize) {
        (_a = _this.canvas).resize.apply(_a, pendingSize);
        _this.pendingSize = undefined;
      }
      if (root && !root.visible) {
        _this.dirty = false;
        return;
      }
      // start with a blank canvas, clear previous drawing
      ctx.clearRect(0, 0, _this.width, _this.height);
      if (root) {
        ctx.save();
        if (root.visible) {
          root.render(ctx);
        }
        ctx.restore();
      }
      _this._frameIndex++;
      if (_this.debug.renderFrameIndex) {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, 40, 15);
        ctx.fillStyle = 'black';
        ctx.fillText(_this.frameIndex.toString(), 2, 10);
      }
      _this.dirty = false;
    };
    this.canvas = new HdpiCanvas(document, width, height);
    this.ctx = this.canvas.context;
  }
  Object.defineProperty(Scene.prototype, "container", {
    get: function get() {
      return this.canvas.container;
    },
    set: function set(value) {
      this.canvas.container = value;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.download = function (fileName) {
    this.canvas.download(fileName);
  };
  Scene.prototype.getDataURL = function (type) {
    return this.canvas.getDataURL(type);
  };
  Object.defineProperty(Scene.prototype, "width", {
    get: function get() {
      return this.pendingSize ? this.pendingSize[0] : this.canvas.width;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scene.prototype, "height", {
    get: function get() {
      return this.pendingSize ? this.pendingSize[1] : this.canvas.height;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.resize = function (width, height) {
    width = Math.round(width);
    height = Math.round(height);
    if (width === this.width && height === this.height) {
      return;
    }
    this.pendingSize = [width, height];
    this.dirty = true;
  };
  Object.defineProperty(Scene.prototype, "dirty", {
    get: function get() {
      return this._dirty;
    },
    set: function set(dirty) {
      if (dirty) {
        if (!this._dirty) {
          this.animationFrameId = requestAnimationFrame(this.render);
        }
      } else if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = 0;
      }
      this._dirty = dirty;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scene.prototype, "root", {
    get: function get() {
      return this._root;
    },
    set: function set(node) {
      if (node === this._root) {
        return;
      }
      if (this._root) {
        this._root._setScene();
      }
      this._root = node;
      if (node) {
        // If `node` is the root node of another scene ...
        if (node.parent === null && node.scene && node.scene !== this) {
          node.scene.root = null;
        }
        node._setScene(this);
      }
      this.dirty = true;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scene.prototype, "frameIndex", {
    get: function get() {
      return this._frameIndex;
    },
    enumerable: true,
    configurable: true
  });
  Scene.className = 'Scene';
  return Scene;
}();
var Gradient = /** @class */function () {
  function Gradient() {
    this.stops = [];
  }
  return Gradient;
}();
var __extends$3K = undefined && undefined.__extends || function () {
  var _extendStatics247 = function extendStatics(d, b) {
    _extendStatics247 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics247(d, b);
  };
  return function (d, b) {
    _extendStatics247(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var LinearGradient = /** @class */function (_super) {
  __extends$3K(LinearGradient, _super);
  function LinearGradient() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.angle = 0;
    return _this;
  }
  LinearGradient.prototype.createGradient = function (ctx, bbox) {
    var stops = this.stops;
    var radians = this.angle % 360 * Math.PI / 180;
    var cos = Math.cos(radians);
    var sin = Math.sin(radians);
    var w = bbox.width;
    var h = bbox.height;
    var cx = bbox.x + w * 0.5;
    var cy = bbox.y + h * 0.5;
    if (w > 0 && h > 0) {
      var l = Math.sqrt(h * h + w * w) * Math.abs(Math.cos(radians - Math.atan(h / w))) / 2;
      var gradient_1 = ctx.createLinearGradient(cx + cos * l, cy + sin * l, cx - cos * l, cy - sin * l);
      stops.forEach(function (stop) {
        gradient_1.addColorStop(stop.offset, stop.color);
      });
      return gradient_1;
    }
    return 'black';
  };
  return LinearGradient;
}(Gradient);
var __extends$3L = undefined && undefined.__extends || function () {
  var _extendStatics248 = function extendStatics(d, b) {
    _extendStatics248 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics248(d, b);
  };
  return function (d, b) {
    _extendStatics248(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RectSizing;
(function (RectSizing) {
  RectSizing[RectSizing["Content"] = 0] = "Content";
  RectSizing[RectSizing["Border"] = 1] = "Border";
})(RectSizing || (RectSizing = {}));
var Rect = /** @class */function (_super) {
  __extends$3L(Rect, _super);
  function Rect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this._width = 10;
    _this._height = 10;
    _this._radius = 0;
    /**
     * If `true`, the rect is aligned to the pixel grid for crisp looking lines.
     * Animated rects may not look nice with this option enabled, for example
     * when a rect is translated by a sub-pixel value on each frame.
     */
    _this._crisp = false;
    _this._gradient = false;
    _this.effectiveStrokeWidth = Shape.defaultStyles.strokeWidth;
    /**
     * Similar to https://developer.mozilla.org/en-US/docs/Web/CSS/box-sizing
     */
    _this._sizing = RectSizing.Content;
    return _this;
  }
  Object.defineProperty(Rect.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "radius", {
    get: function get() {
      return this._radius;
    },
    set: function set(value) {
      if (this._radius !== value) {
        this._radius = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "crisp", {
    get: function get() {
      return this._crisp;
    },
    set: function set(value) {
      if (this._crisp !== value) {
        this._crisp = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "gradient", {
    get: function get() {
      return this._gradient;
    },
    set: function set(value) {
      if (this._gradient !== value) {
        this._gradient = value;
        this.updateGradientInstance();
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Rect.prototype.updateGradientInstance = function () {
    if (this.gradient) {
      var fill = this.fill;
      if (fill) {
        var gradient = new LinearGradient();
        gradient.angle = 270;
        gradient.stops = [{
          offset: 0,
          color: Color$1.fromString(fill).brighter().toString()
        }, {
          offset: 1,
          color: Color$1.fromString(fill).darker().toString()
        }];
        this.gradientInstance = gradient;
      }
    } else {
      this.gradientInstance = undefined;
    }
  };
  Object.defineProperty(Rect.prototype, "fill", {
    get: function get() {
      return this._fill;
    },
    set: function set(value) {
      if (this._fill !== value) {
        this._fill = value;
        this.updateGradientInstance();
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        // Normally, when the `lineWidth` changes, we only need to repaint the rect
        // without updating the path. If the `isCrisp` is set to `true` however,
        // we need to update the path to make sure the new stroke aligns to
        // the pixel grid. This is the reason we override the `lineWidth` setter
        // and getter here.
        if (this.crisp || this.sizing === RectSizing.Border) {
          this.dirtyPath = true;
        } else {
          this.effectiveStrokeWidth = value;
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rect.prototype, "sizing", {
    get: function get() {
      return this._sizing;
    },
    set: function set(value) {
      if (this._sizing !== value) {
        this._sizing = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Rect.prototype.updatePath = function () {
    var borderSizing = this.sizing === RectSizing.Border;
    var path = this.path;
    path.clear();
    var x = this.x;
    var y = this.y;
    var width = this.width;
    var height = this.height;
    var strokeWidth;
    if (borderSizing) {
      var halfWidth = width / 2;
      var halfHeight = height / 2;
      strokeWidth = Math.min(this.strokeWidth, halfWidth, halfHeight);
      x = Math.min(x + strokeWidth / 2, x + halfWidth);
      y = Math.min(y + strokeWidth / 2, y + halfHeight);
      width = Math.max(width - strokeWidth, 0);
      height = Math.max(height - strokeWidth, 0);
    } else {
      strokeWidth = this.strokeWidth;
    }
    this.effectiveStrokeWidth = strokeWidth;
    if (this.crisp && !borderSizing) {
      var _a = this,
        a = _a.alignment,
        al = _a.align;
      path.rect(al(a, x), al(a, y), al(a, x, width), al(a, y, height));
    } else {
      path.rect(x, y, width, height);
    }
  };
  Rect.prototype.computeBBox = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height;
    return new BBox(x, y, width, height);
  };
  Rect.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return bbox.containsPoint(point.x, point.y);
  };
  Rect.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Rect.prototype.fillStroke = function (ctx) {
    if (!this.scene) {
      return;
    }
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    if (this.fill) {
      if (this.gradientInstance) {
        ctx.fillStyle = this.gradientInstance.createGradient(ctx, this.computeBBox());
      } else {
        ctx.fillStyle = this.fill;
      }
      ctx.globalAlpha = this.opacity * this.fillOpacity;
      // The canvas context scaling (depends on the device's pixel ratio)
      // has no effect on shadows, so we have to account for the pixel ratio
      // manually here.
      var fillShadow = this.fillShadow;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fill();
    }
    ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    if (this.stroke && this.effectiveStrokeWidth) {
      ctx.strokeStyle = this.stroke;
      ctx.globalAlpha = this.opacity * this.strokeOpacity;
      ctx.lineWidth = this.effectiveStrokeWidth;
      if (this.lineDash) {
        ctx.setLineDash(this.lineDash);
      }
      if (this.lineDashOffset) {
        ctx.lineDashOffset = this.lineDashOffset;
      }
      if (this.lineCap) {
        ctx.lineCap = this.lineCap;
      }
      if (this.lineJoin) {
        ctx.lineJoin = this.lineJoin;
      }
      var strokeShadow = this.strokeShadow;
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.stroke();
    }
  };
  Rect.className = 'Rect';
  return Rect;
}(Path);
var __extends$3M = undefined && undefined.__extends || function () {
  var _extendStatics249 = function extendStatics(d, b) {
    _extendStatics249 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics249(d, b);
  };
  return function (d, b) {
    _extendStatics249(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Marker = /** @class */function (_super) {
  __extends$3M(Marker, _super);
  function Marker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this._size = 12;
    return _this;
  }
  Object.defineProperty(Marker.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "size", {
    get: function get() {
      return this._size;
    },
    set: function set(value) {
      if (this._size !== value) {
        this._size = Math.abs(value);
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Marker.prototype.computeBBox = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      size = _a.size;
    var half = size / 2;
    return new BBox(x - half, y - half, size, size);
  };
  return Marker;
}(Path);
var __extends$3N = undefined && undefined.__extends || function () {
  var _extendStatics250 = function extendStatics(d, b) {
    _extendStatics250 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics250(d, b);
  };
  return function (d, b) {
    _extendStatics250(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Square = /** @class */function (_super) {
  __extends$3N(Square, _super);
  function Square() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Square.prototype.updatePath = function () {
    var _a = this,
      path = _a.path,
      x = _a.x,
      y = _a.y;
    var hs = this.size / 2;
    var _b = this,
      a = _b.alignment,
      al = _b.align;
    path.clear();
    path.moveTo(al(a, x - hs), al(a, y - hs));
    path.lineTo(al(a, x + hs), al(a, y - hs));
    path.lineTo(al(a, x + hs), al(a, y + hs));
    path.lineTo(al(a, x - hs), al(a, y + hs));
    path.closePath();
  };
  Square.className = 'Square';
  return Square;
}(Marker);
var __extends$3O = undefined && undefined.__extends || function () {
  var _extendStatics251 = function extendStatics(d, b) {
    _extendStatics251 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics251(d, b);
  };
  return function (d, b) {
    _extendStatics251(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MarkerLabel = /** @class */function (_super) {
  __extends$3O(MarkerLabel, _super);
  function MarkerLabel() {
    var _this = _super.call(this) || this;
    _this.label = new Text();
    _this._marker = new Square();
    _this._markerSize = 15;
    _this._spacing = 8;
    var label = _this.label;
    label.textBaseline = 'middle';
    label.fontSize = 12;
    label.fontFamily = 'Verdana, sans-serif';
    label.fill = 'black';
    // For better looking vertical alignment of labels to markers.
    label.y = HdpiCanvas.has.textMetrics ? 1 : 0;
    _this.append([_this.marker, label]);
    _this.update();
    return _this;
  }
  Object.defineProperty(MarkerLabel.prototype, "text", {
    get: function get() {
      return this.label.text;
    },
    set: function set(value) {
      this.label.text = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "fontStyle", {
    get: function get() {
      return this.label.fontStyle;
    },
    set: function set(value) {
      this.label.fontStyle = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "fontWeight", {
    get: function get() {
      return this.label.fontWeight;
    },
    set: function set(value) {
      this.label.fontWeight = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "fontSize", {
    get: function get() {
      return this.label.fontSize;
    },
    set: function set(value) {
      this.label.fontSize = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "fontFamily", {
    get: function get() {
      return this.label.fontFamily;
    },
    set: function set(value) {
      this.label.fontFamily = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "color", {
    get: function get() {
      return this.label.fill;
    },
    set: function set(value) {
      this.label.fill = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "marker", {
    get: function get() {
      return this._marker;
    },
    set: function set(value) {
      if (this._marker !== value) {
        this.removeChild(this._marker);
        this._marker = value;
        this.appendChild(value);
        this.update();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerSize", {
    get: function get() {
      return this._markerSize;
    },
    set: function set(value) {
      if (this._markerSize !== value) {
        this._markerSize = value;
        this.update();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerFill", {
    get: function get() {
      return this.marker.fill;
    },
    set: function set(value) {
      this.marker.fill = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerStroke", {
    get: function get() {
      return this.marker.stroke;
    },
    set: function set(value) {
      this.marker.stroke = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerStrokeWidth", {
    get: function get() {
      return this.marker.strokeWidth;
    },
    set: function set(value) {
      this.marker.strokeWidth = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerFillOpacity", {
    get: function get() {
      return this.marker.fillOpacity;
    },
    set: function set(value) {
      this.marker.fillOpacity = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "markerStrokeOpacity", {
    get: function get() {
      return this.marker.strokeOpacity;
    },
    set: function set(value) {
      this.marker.strokeOpacity = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "opacity", {
    get: function get() {
      return this.marker.opacity;
    },
    set: function set(value) {
      this.marker.opacity = value;
      this.label.opacity = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MarkerLabel.prototype, "spacing", {
    get: function get() {
      return this._spacing;
    },
    set: function set(value) {
      if (this._spacing !== value) {
        this._spacing = value;
        this.update();
      }
    },
    enumerable: true,
    configurable: true
  });
  MarkerLabel.prototype.update = function () {
    var marker = this.marker;
    var markerSize = this.markerSize;
    marker.size = markerSize;
    this.label.x = markerSize / 2 + this.spacing;
  };
  MarkerLabel.className = 'MarkerLabel';
  return MarkerLabel;
}(Group);
var __extends$3P = undefined && undefined.__extends || function () {
  var _extendStatics252 = function extendStatics(d, b) {
    _extendStatics252 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics252(d, b);
  };
  return function (d, b) {
    _extendStatics252(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Circle = /** @class */function (_super) {
  __extends$3P(Circle, _super);
  function Circle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Circle.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      path = _a.path,
      size = _a.size;
    var r = size / 2;
    path.clear();
    path.cubicArc(x, y, r, r, 0, 0, Math.PI * 2, 0);
    path.closePath();
  };
  Circle.className = 'Circle';
  return Circle;
}(Marker);
var __extends$3Q = undefined && undefined.__extends || function () {
  var _extendStatics253 = function extendStatics(d, b) {
    _extendStatics253 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics253(d, b);
  };
  return function (d, b) {
    _extendStatics253(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Cross = /** @class */function (_super) {
  __extends$3Q(Cross, _super);
  function Cross() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Cross.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      y = _a.y;
    var _b = this,
      path = _b.path,
      size = _b.size;
    var s = size / 4.2;
    path.clear();
    path.moveTo(x -= s, y);
    path.lineTo(x -= s, y -= s);
    path.lineTo(x += s, y -= s);
    path.lineTo(x += s, y += s);
    path.lineTo(x += s, y -= s);
    path.lineTo(x += s, y += s);
    path.lineTo(x -= s, y += s);
    path.lineTo(x += s, y += s);
    path.lineTo(x -= s, y += s);
    path.lineTo(x -= s, y -= s);
    path.lineTo(x -= s, y += s);
    path.lineTo(x -= s, y -= s);
    path.closePath();
  };
  Cross.className = 'Cross';
  return Cross;
}(Marker);
var __extends$3R = undefined && undefined.__extends || function () {
  var _extendStatics254 = function extendStatics(d, b) {
    _extendStatics254 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics254(d, b);
  };
  return function (d, b) {
    _extendStatics254(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Diamond = /** @class */function (_super) {
  __extends$3R(Diamond, _super);
  function Diamond() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Diamond.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      y = _a.y;
    var _b = this,
      path = _b.path,
      size = _b.size;
    var s = size / 2;
    path.clear();
    path.moveTo(x, y -= s);
    path.lineTo(x += s, y += s);
    path.lineTo(x -= s, y += s);
    path.lineTo(x -= s, y -= s);
    path.lineTo(x += s, y -= s);
    path.closePath();
  };
  Diamond.className = 'Diamond';
  return Diamond;
}(Marker);
var __extends$3S = undefined && undefined.__extends || function () {
  var _extendStatics255 = function extendStatics(d, b) {
    _extendStatics255 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics255(d, b);
  };
  return function (d, b) {
    _extendStatics255(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Heart = /** @class */function (_super) {
  __extends$3S(Heart, _super);
  function Heart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Heart.prototype.rad = function (degree) {
    return degree / 180 * Math.PI;
  };
  Heart.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      path = _a.path,
      size = _a.size,
      rad = _a.rad;
    var r = size / 4;
    var y = this.y + r / 2;
    path.clear();
    path.cubicArc(x - r, y - r, r, r, 0, rad(130), rad(330), 0);
    path.cubicArc(x + r, y - r, r, r, 0, rad(220), rad(50), 0);
    path.lineTo(x, y + r);
    path.closePath();
  };
  Heart.className = 'Heart';
  return Heart;
}(Marker);
var __extends$3T = undefined && undefined.__extends || function () {
  var _extendStatics256 = function extendStatics(d, b) {
    _extendStatics256 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics256(d, b);
  };
  return function (d, b) {
    _extendStatics256(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Plus = /** @class */function (_super) {
  __extends$3T(Plus, _super);
  function Plus() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Plus.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      y = _a.y;
    var _b = this,
      path = _b.path,
      size = _b.size;
    var s = size / 3;
    var hs = s / 2;
    path.clear();
    path.moveTo(x -= hs, y -= hs);
    path.lineTo(x, y -= s);
    path.lineTo(x += s, y);
    path.lineTo(x, y += s);
    path.lineTo(x += s, y);
    path.lineTo(x, y += s);
    path.lineTo(x -= s, y);
    path.lineTo(x, y += s);
    path.lineTo(x -= s, y);
    path.lineTo(x, y -= s);
    path.lineTo(x -= s, y);
    path.lineTo(x, y -= s);
    path.closePath();
  };
  Plus.className = 'Plus';
  return Plus;
}(Marker);
var __extends$3U = undefined && undefined.__extends || function () {
  var _extendStatics257 = function extendStatics(d, b) {
    _extendStatics257 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics257(d, b);
  };
  return function (d, b) {
    _extendStatics257(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Triangle = /** @class */function (_super) {
  __extends$3U(Triangle, _super);
  function Triangle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Triangle.prototype.updatePath = function () {
    var _a = this,
      x = _a.x,
      y = _a.y;
    var _b = this,
      path = _b.path,
      size = _b.size;
    var s = size * 1.1;
    path.clear();
    path.moveTo(x, y -= s * 0.48);
    path.lineTo(x += s * 0.5, y += s * 0.87);
    path.lineTo(x -= s, y);
    path.closePath();
  };
  Triangle.className = 'Triangle';
  return Triangle;
}(Marker);

// This function is in its own file because putting it into SeriesMarker makes the Legend
// suddenly aware of the series (it's an agnostic component), and putting it into Marker
// introduces circular dependencies.
function getMarker(shape) {
  if (shape === void 0) {
    shape = Square;
  }
  if (typeof shape === 'string') {
    switch (shape) {
      case 'circle':
        return Circle;
      case 'cross':
        return Cross;
      case 'diamond':
        return Diamond;
      case 'heart':
        return Heart;
      case 'plus':
        return Plus;
      case 'triangle':
        return Triangle;
      default:
        return Square;
    }
  }
  if (typeof shape === 'function') {
    return shape;
  }
  return Square;
}
var __extends$3V = undefined && undefined.__extends || function () {
  var _extendStatics258 = function extendStatics(d, b) {
    _extendStatics258 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics258(d, b);
  };
  return function (d, b) {
    _extendStatics258(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$37 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LegendOrientation;
(function (LegendOrientation) {
  LegendOrientation[LegendOrientation["Vertical"] = 0] = "Vertical";
  LegendOrientation[LegendOrientation["Horizontal"] = 1] = "Horizontal";
})(LegendOrientation || (LegendOrientation = {}));
var LegendPosition;
(function (LegendPosition) {
  LegendPosition["Top"] = "top";
  LegendPosition["Right"] = "right";
  LegendPosition["Bottom"] = "bottom";
  LegendPosition["Left"] = "left";
})(LegendPosition || (LegendPosition = {}));
var LegendLabel = /** @class */function (_super) {
  __extends$3V(LegendLabel, _super);
  function LegendLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.color = 'black';
    _this.fontSize = 12;
    _this.fontFamily = 'Verdana, sans-serif';
    return _this;
  }
  __decorate$37([reactive('change')], LegendLabel.prototype, "color", void 0);
  __decorate$37([reactive('layoutChange')], LegendLabel.prototype, "fontStyle", void 0);
  __decorate$37([reactive('layoutChange')], LegendLabel.prototype, "fontWeight", void 0);
  __decorate$37([reactive('layoutChange')], LegendLabel.prototype, "fontSize", void 0);
  __decorate$37([reactive('layoutChange')], LegendLabel.prototype, "fontFamily", void 0);
  __decorate$37([reactive()], LegendLabel.prototype, "formatter", void 0);
  return LegendLabel;
}(Observable);
var LegendMarker = /** @class */function (_super) {
  __extends$3V(LegendMarker, _super);
  function LegendMarker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.size = 15;
    /**
     * Padding between the marker and the label within each legend item.
     */
    _this.padding = 8;
    _this.strokeWidth = 1;
    return _this;
  }
  __decorate$37([reactive('layoutChange')], LegendMarker.prototype, "size", void 0);
  __decorate$37([reactive('layoutChange')], LegendMarker.prototype, "shape", void 0);
  __decorate$37([reactive('layoutChange')], LegendMarker.prototype, "padding", void 0);
  __decorate$37([reactive('change')], LegendMarker.prototype, "strokeWidth", void 0);
  return LegendMarker;
}(Observable);
var LegendItem = /** @class */function (_super) {
  __extends$3V(LegendItem, _super);
  function LegendItem() {
    var _this = _super.call(this) || this;
    _this.marker = new LegendMarker();
    _this.label = new LegendLabel();
    /**
     * The legend uses grid layout for its items, occupying as few columns as possible when positioned to left or right,
     * and as few rows as possible when positioned to top or bottom. This config specifies the amount of horizontal
     * padding between legend items.
     */
    _this.paddingX = 16;
    /**
     * The legend uses grid layout for its items, occupying as few columns as possible when positioned to left or right,
     * and as few rows as possible when positioned to top or bottom. This config specifies the amount of vertical
     * padding between legend items.
     */
    _this.paddingY = 8;
    var changeListener = function changeListener() {
      return _this.fireEvent({
        type: 'change'
      });
    };
    _this.marker.addEventListener('change', changeListener);
    _this.label.addEventListener('change', changeListener);
    var layoutChangeListener = function layoutChangeListener() {
      return _this.fireEvent({
        type: 'layoutChange'
      });
    };
    _this.marker.addEventListener('layoutChange', layoutChangeListener);
    _this.label.addEventListener('layoutChange', layoutChangeListener);
    return _this;
  }
  __decorate$37([reactive('layoutChange')], LegendItem.prototype, "paddingX", void 0);
  __decorate$37([reactive('layoutChange')], LegendItem.prototype, "paddingY", void 0);
  return LegendItem;
}(Observable);
var Legend = /** @class */function (_super) {
  __extends$3V(Legend, _super);
  function Legend() {
    var _this = _super.call(this) || this;
    _this.id = createId(_this);
    _this.group = new Group();
    _this.itemSelection = Selection.select(_this.group).selectAll();
    _this.oldSize = [0, 0];
    _this.item = new LegendItem();
    _this.data = [];
    _this.enabled = true;
    _this.orientation = LegendOrientation.Vertical;
    _this.position = LegendPosition.Right;
    /**
     * Spacing between the legend and the edge of the chart's element.
     */
    _this.spacing = 20;
    _this._size = [0, 0];
    _this.addPropertyListener('data', _this.onDataChange);
    _this.addPropertyListener('enabled', _this.onEnabledChange);
    _this.addPropertyListener('position', _this.onPositionChange);
    _this.item.marker.addPropertyListener('shape', _this.onMarkerShapeChange, _this);
    _this.addEventListener('change', _this.update);
    _this.item.addEventListener('change', function () {
      return _this.fireEvent({
        type: 'change'
      });
    });
    _this.item.addEventListener('layoutChange', function () {
      return _this.fireEvent({
        type: 'layoutChange'
      });
    });
    return _this;
  }
  Object.defineProperty(Legend.prototype, "size", {
    get: function get() {
      return this._size;
    },
    enumerable: true,
    configurable: true
  });
  Legend.prototype.onDataChange = function (event) {
    this.group.visible = event.value.length > 0 && this.enabled;
  };
  Legend.prototype.onEnabledChange = function (event) {
    this.group.visible = event.value && this.data.length > 0;
  };
  Legend.prototype.onPositionChange = function (event) {
    switch (event.value) {
      case 'right':
      case 'left':
        this.orientation = LegendOrientation.Vertical;
        break;
      case 'bottom':
      case 'top':
        this.orientation = LegendOrientation.Horizontal;
        break;
    }
  };
  Legend.prototype.onMarkerShapeChange = function () {
    this.itemSelection = this.itemSelection.setData([]);
    this.itemSelection.exit.remove();
    if (this.group.scene) {
      this.group.scene.dirty = false;
    }
  };
  /**
   * The method is given the desired size of the legend, which only serves as a hint.
   * The vertically oriented legend will take as much horizontal space as needed, but will
   * respect the height constraints, and the horizontal legend will take as much vertical
   * space as needed in an attempt not to exceed the given width.
   * After the layout is done, the {@link size} will contain the actual size of the legend.
   * If the actual size is not the same as the previous actual size, the legend will fire
   * the 'layoutChange' event to communicate that another layout is needed, and the above
   * process should be repeated.
   * @param width
   * @param height
   */
  Legend.prototype.performLayout = function (width, height) {
    var item = this.item;
    var marker = item.marker,
      paddingX = item.paddingX,
      paddingY = item.paddingY;
    var updateSelection = this.itemSelection.setData(this.data, function (_, datum) {
      var MarkerShape = getMarker(marker.shape || datum.marker.shape);
      return datum.id + '-' + datum.itemId + '-' + MarkerShape.name;
    });
    updateSelection.exit.remove();
    var enterSelection = updateSelection.enter.append(MarkerLabel).each(function (node, datum) {
      var MarkerShape = getMarker(marker.shape || datum.marker.shape);
      node.marker = new MarkerShape();
    });
    var itemSelection = this.itemSelection = updateSelection.merge(enterSelection);
    var itemCount = itemSelection.size;
    // Update properties that affect the size of the legend items and measure them.
    var bboxes = [];
    var itemMarker = this.item.marker;
    var itemLabel = this.item.label;
    itemSelection.each(function (markerLabel, datum) {
      // TODO: measure only when one of these properties or data change (in a separate routine)
      markerLabel.markerSize = itemMarker.size;
      markerLabel.spacing = itemMarker.padding;
      markerLabel.fontStyle = itemLabel.fontStyle;
      markerLabel.fontWeight = itemLabel.fontWeight;
      markerLabel.fontSize = itemLabel.fontSize;
      markerLabel.fontFamily = itemLabel.fontFamily;
      markerLabel.text = datum.label.text;
      bboxes.push(markerLabel.computeBBox());
    });
    var itemHeight = bboxes.length && bboxes[0].height;
    var rowCount = 0;
    var columnWidth = 0;
    var paddedItemsWidth = 0;
    var paddedItemsHeight = 0;
    width = Math.max(1, width);
    height = Math.max(1, height);
    switch (this.orientation) {
      case LegendOrientation.Horizontal:
        if (!(isFinite(width) && width > 0)) {
          return false;
        }
        rowCount = 0;
        var columnCount = 0;
        // Split legend items into columns until the width is suitable.
        do {
          var itemsWidth = 0;
          columnCount = 0;
          columnWidth = 0;
          rowCount++;
          var i = 0;
          while (i < itemCount) {
            var bbox = bboxes[i];
            if (bbox.width > columnWidth) {
              columnWidth = bbox.width;
            }
            i++;
            if (i % rowCount === 0) {
              itemsWidth += columnWidth;
              columnWidth = 0;
              columnCount++;
            }
          }
          if (i % rowCount !== 0) {
            itemsWidth += columnWidth;
            columnCount++;
          }
          paddedItemsWidth = itemsWidth + (columnCount - 1) * paddingX;
        } while (paddedItemsWidth > width && columnCount > 1);
        paddedItemsHeight = itemHeight * rowCount + (rowCount - 1) * paddingY;
        break;
      case LegendOrientation.Vertical:
        if (!(isFinite(height) && height > 0)) {
          return false;
        }
        rowCount = itemCount * 2;
        // Split legend items into columns until the height is suitable.
        do {
          rowCount = (rowCount >> 1) + rowCount % 2;
          columnWidth = 0;
          var itemsWidth = 0;
          var itemsHeight = 0;
          var columnCount_1 = 0;
          var i = 0;
          while (i < itemCount) {
            var bbox = bboxes[i];
            if (!columnCount_1) {
              itemsHeight += bbox.height;
            }
            if (bbox.width > columnWidth) {
              columnWidth = bbox.width;
            }
            i++;
            if (i % rowCount === 0) {
              itemsWidth += columnWidth;
              columnWidth = 0;
              columnCount_1++;
            }
          }
          if (i % rowCount !== 0) {
            itemsWidth += columnWidth;
            columnCount_1++;
          }
          paddedItemsWidth = itemsWidth + (columnCount_1 - 1) * paddingX;
          paddedItemsHeight = itemsHeight + (rowCount - 1) * paddingY;
        } while (paddedItemsHeight > height && rowCount > 1);
        break;
    }
    // Top-left corner of the first legend item.
    var startX = (width - paddedItemsWidth) / 2;
    var startY = (height - paddedItemsHeight) / 2;
    var x = 0;
    var y = 0;
    columnWidth = 0;
    // Position legend items using the layout computed above.
    itemSelection.each(function (markerLabel, datum, i) {
      // Round off for pixel grid alignment to work properly.
      markerLabel.translationX = Math.floor(startX + x);
      markerLabel.translationY = Math.floor(startY + y);
      var bbox = bboxes[i];
      if (bbox.width > columnWidth) {
        columnWidth = bbox.width;
      }
      if ((i + 1) % rowCount === 0) {
        x += columnWidth + paddingX;
        y = 0;
        columnWidth = 0;
      } else {
        y += bbox.height + paddingY;
      }
    });
    // Update legend item properties that don't affect the layout.
    this.update();
    var size = this._size;
    var oldSize = this.oldSize;
    size[0] = paddedItemsWidth;
    size[1] = paddedItemsHeight;
    if (size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
      oldSize[0] = size[0];
      oldSize[1] = size[1];
    }
  };
  Legend.prototype.update = function () {
    var _this = this;
    this.itemSelection.each(function (markerLabel, datum) {
      var marker = datum.marker;
      markerLabel.markerFill = marker.fill;
      markerLabel.markerStroke = marker.stroke;
      markerLabel.markerStrokeWidth = _this.item.marker.strokeWidth;
      markerLabel.markerFillOpacity = marker.fillOpacity;
      markerLabel.markerStrokeOpacity = marker.strokeOpacity;
      markerLabel.opacity = datum.enabled ? 1 : 0.5;
      markerLabel.color = _this.item.label.color;
    });
  };
  Legend.prototype.getDatumForPoint = function (x, y) {
    var node = this.group.pickNode(x, y);
    if (node && node.parent) {
      return node.parent.datum;
    }
  };
  Legend.className = 'Legend';
  __decorate$37([reactive('layoutChange')], Legend.prototype, "data", void 0);
  __decorate$37([reactive('layoutChange')], Legend.prototype, "enabled", void 0);
  __decorate$37([reactive('layoutChange')], Legend.prototype, "orientation", void 0);
  __decorate$37([reactive('layoutChange')], Legend.prototype, "position", void 0);
  __decorate$37([reactive('layoutChange')], Legend.prototype, "spacing", void 0);
  return Legend;
}(Observable);
var SizeMonitor = /** @class */function () {
  function SizeMonitor() {}
  SizeMonitor.init = function () {
    var _this = this;
    var NativeResizeObserver = window.ResizeObserver;
    if (NativeResizeObserver) {
      this.resizeObserver = new NativeResizeObserver(function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
          var entry = entries_1[_i];
          var _a = entry.contentRect,
            width = _a.width,
            height = _a.height;
          _this.checkSize(_this.elements.get(entry.target), entry.target, width, height);
        }
      });
    } else {
      // polyfill (more reliable even in browsers that support ResizeObserver)
      var step = function step() {
        _this.elements.forEach(function (entry, element) {
          var width = element.clientWidth ? element.clientWidth : 0;
          var height = element.clientHeight ? element.clientHeight : 0;
          _this.checkSize(entry, element, width, height);
        });
      };
      window.setInterval(step, 100);
    }
    this.ready = true;
  };
  SizeMonitor.checkSize = function (entry, element, width, height) {
    if (entry) {
      if (!entry.size || width !== entry.size.width || height !== entry.size.height) {
        entry.size = {
          width: width,
          height: height
        };
        entry.cb(entry.size, element);
      }
    }
  };
  // Only a single callback is supported.
  SizeMonitor.observe = function (element, cb) {
    if (!this.ready) {
      this.init();
    }
    this.unobserve(element);
    if (this.resizeObserver) {
      this.resizeObserver.observe(element);
    }
    this.elements.set(element, {
      cb: cb
    });
  };
  SizeMonitor.unobserve = function (element) {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(element);
    }
    this.elements.delete(element);
  };
  SizeMonitor.elements = new Map();
  SizeMonitor.ready = false;
  return SizeMonitor;
}();
function circleRectOverlap(cx, cy, r, x, y, w, h) {
  // Find closest horizontal and vertical edges.
  var edgeX = cx < x ? x : cx > x + w ? x + w : cx;
  var edgeY = cy < y ? y : cy > y + h ? y + h : cy;
  // Find distance to closest edges.
  var dx = cx - edgeX;
  var dy = cy - edgeY;
  var d = Math.sqrt(dx * dx + dy * dy);
  return d <= r;
}
function rectRectOverlap(x1, y1, w1, h1, x2, y2, w2, h2) {
  var xOverlap = x1 + w1 > x2 && x1 < x2 + w2;
  var yOverlap = y1 + h1 > y2 && y1 < y2 + h2;
  return xOverlap && yOverlap;
}
function rectContainsRect(r1x, r1y, r1w, r1h, r2x, r2y, r2w, r2h) {
  return r2x + r2w < r1x + r1w && r2x > r1x && r2y > r1y && r2y + r2h < r1y + r1h;
}
/**
 * @param data Points and labels for one or more series. The order of series determines label placement precedence.
 * @param bounds Bounds to fit the labels into. If a label can't be fully contained, it doesn't fit.
 * @returns Placed labels for the given series (in the given order).
 */
function placeLabels(data, bounds, padding) {
  if (padding === void 0) {
    padding = 5;
  }
  var result = [];
  data = data.map(function (d) {
    return d.slice().sort(function (a, b) {
      return b.size - a.size;
    });
  });
  for (var j = 0; j < data.length; j++) {
    var labels = result[j] = [];
    var datum = data[j];
    if (!(datum && datum.length && datum[0].label)) {
      continue;
    }
    var _loop_1 = function _loop_1(i, ln) {
      var d = datum[i];
      var l = d.label;
      var r = d.size * 0.5;
      var x = d.point.x - l.width * 0.5;
      var y = d.point.y - r - l.height - padding;
      var width = l.width,
        height = l.height;
      var withinBounds = !bounds || rectContainsRect(bounds.x, bounds.y, bounds.width, bounds.height, x, y, width, height);
      if (!withinBounds) {
        return "continue";
      }
      var overlapPoints = data.some(function (datum) {
        return datum.some(function (d) {
          return circleRectOverlap(d.point.x, d.point.y, d.size * 0.5, x, y, width, height);
        });
      });
      if (overlapPoints) {
        return "continue";
      }
      var overlapLabels = result.some(function (labels) {
        return labels.some(function (l) {
          return rectRectOverlap(l.x, l.y, l.width, l.height, x, y, width, height);
        });
      });
      if (overlapLabels) {
        return "continue";
      }
      labels.push({
        index: i,
        text: l.text,
        x: x,
        y: y,
        width: width,
        height: height
      });
    };
    for (var i = 0, ln = datum.length; i < ln; i++) {
      _loop_1(i, ln);
    }
  }
  return result;
}
var __extends$3W = undefined && undefined.__extends || function () {
  var _extendStatics259 = function extendStatics(d, b) {
    _extendStatics259 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics259(d, b);
  };
  return function (d, b) {
    _extendStatics259(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$k = undefined && undefined.__assign || function () {
  __assign$k = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$k.apply(this, arguments);
};
var __decorate$38 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var defaultTooltipCss = "\n.ag-chart-tooltip {\n    display: table;\n    position: absolute;\n    user-select: none;\n    pointer-events: none;\n    white-space: nowrap;\n    z-index: 99999;\n    font: 12px Verdana, sans-serif;\n    color: black;\n    background: rgb(244, 244, 244);\n    border-radius: 5px;\n    box-shadow: 0 0 1px rgba(3, 3, 3, 0.7), 0.5vh 0.5vh 1vh rgba(3, 3, 3, 0.25);\n}\n\n.ag-chart-tooltip-hidden {\n    top: -10000px !important;\n}\n\n.ag-chart-tooltip-title {\n    font-weight: bold;\n    padding: 7px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    color: white;\n    background-color: #888888;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.ag-chart-tooltip-content {\n    padding: 7px;\n    line-height: 1.7em;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    overflow: hidden;\n}\n\n.ag-chart-tooltip-content:empty {\n    padding: 0;\n    height: 7px;\n}\n\n.ag-chart-tooltip-arrow::before {\n    content: \"\";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 6px solid #989898;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: #989898;\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-chart-tooltip-arrow::after {\n    content: \"\";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 5px solid black;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: rgb(244, 244, 244);\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-chart-wrapper {\n    box-sizing: border-box;\n    overflow: hidden;\n}\n";
function toTooltipHtml(input, defaults) {
  if (typeof input === 'string') {
    return input;
  }
  defaults = defaults || {};
  var _a = input.content,
    content = _a === void 0 ? defaults.content || '' : _a,
    _b = input.title,
    title = _b === void 0 ? defaults.title || undefined : _b,
    _c = input.color,
    color = _c === void 0 ? defaults.color || 'white' : _c,
    _d = input.backgroundColor,
    backgroundColor = _d === void 0 ? defaults.backgroundColor || '#888' : _d;
  var titleHtml = title ? "<div class=\"" + Chart.defaultTooltipClass + "-title\"\n        style=\"color: " + color + "; background-color: " + backgroundColor + "\">" + title + "</div>" : '';
  return titleHtml + "<div class=\"" + Chart.defaultTooltipClass + "-content\">" + content + "</div>";
}
var ChartTooltip = /** @class */function (_super) {
  __extends$3W(ChartTooltip, _super);
  function ChartTooltip(chart, document) {
    var _this = _super.call(this) || this;
    _this.enabled = true;
    _this.class = Chart.defaultTooltipClass;
    _this.delay = 0;
    /**
     * If `true`, the tooltip will be shown for the marker closest to the mouse cursor.
     * Only has effect on series with markers.
     */
    _this.tracking = true;
    _this.showTimeout = 0;
    _this.constrained = false;
    _this.chart = chart;
    _this.class = '';
    var tooltipRoot = document.body;
    var element = document.createElement('div');
    _this.element = tooltipRoot.appendChild(element);
    // Detect when the chart becomes invisible and hide the tooltip as well.
    if (window.IntersectionObserver) {
      var target_1 = _this.chart.scene.canvas.element;
      var observer = new IntersectionObserver(function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
          var entry = entries_1[_i];
          if (entry.target === target_1 && entry.intersectionRatio === 0) {
            _this.toggle(false);
          }
        }
      }, {
        root: tooltipRoot
      });
      observer.observe(target_1);
      _this.observer = observer;
    }
    return _this;
  }
  ChartTooltip.prototype.destroy = function () {
    var parentNode = this.element.parentNode;
    if (parentNode) {
      parentNode.removeChild(this.element);
    }
    if (this.observer) {
      this.observer.unobserve(this.chart.scene.canvas.element);
    }
  };
  ChartTooltip.prototype.isVisible = function () {
    var element = this.element;
    if (element.classList) {
      // if not IE11
      return !element.classList.contains(Chart.defaultTooltipClass + '-hidden');
    }
    // IE11 part.
    var classes = element.getAttribute('class');
    if (classes) {
      return classes.split(' ').indexOf(Chart.defaultTooltipClass + '-hidden') < 0;
    }
    return false;
  };
  ChartTooltip.prototype.updateClass = function (visible, constrained) {
    var classList = [Chart.defaultTooltipClass, this.class];
    if (visible !== true) {
      classList.push(Chart.defaultTooltipClass + "-hidden");
    }
    if (constrained !== true) {
      classList.push(Chart.defaultTooltipClass + "-arrow");
    }
    this.element.setAttribute('class', classList.join(' '));
  };
  /**
   * Shows tooltip at the given event's coordinates.
   * If the `html` parameter is missing, moves the existing tooltip to the new position.
   */
  ChartTooltip.prototype.show = function (meta, html, instantly) {
    var _this = this;
    if (instantly === void 0) {
      instantly = false;
    }
    var el = this.element;
    if (html !== undefined) {
      el.innerHTML = html;
    } else if (!el.innerHTML) {
      return;
    }
    var left = meta.pageX - el.clientWidth / 2;
    var top = meta.pageY - el.clientHeight - 8;
    this.constrained = false;
    if (this.chart.container) {
      var tooltipRect = el.getBoundingClientRect();
      var minLeft = 0;
      var maxLeft = window.innerWidth - tooltipRect.width - 1;
      if (left < minLeft) {
        left = minLeft;
        this.updateClass(true, this.constrained = true);
      } else if (left > maxLeft) {
        left = maxLeft;
        this.updateClass(true, this.constrained = true);
      }
      if (top < window.pageYOffset) {
        top = meta.pageY + 20;
        this.updateClass(true, this.constrained = true);
      }
    }
    el.style.left = Math.round(left) + "px";
    el.style.top = Math.round(top) + "px";
    if (this.delay > 0 && !instantly) {
      this.toggle(false);
      this.showTimeout = window.setTimeout(function () {
        _this.toggle(true);
      }, this.delay);
      return;
    }
    this.toggle(true);
  };
  ChartTooltip.prototype.toggle = function (visible) {
    if (!visible) {
      window.clearTimeout(this.showTimeout);
      if (this.chart.lastPick && !this.delay) {
        this.chart.dehighlightDatum();
        this.chart.lastPick = undefined;
      }
    }
    this.updateClass(visible, this.constrained);
  };
  __decorate$38([reactive()], ChartTooltip.prototype, "enabled", void 0);
  __decorate$38([reactive()], ChartTooltip.prototype, "class", void 0);
  __decorate$38([reactive()], ChartTooltip.prototype, "delay", void 0);
  __decorate$38([reactive()], ChartTooltip.prototype, "tracking", void 0);
  return ChartTooltip;
}(Observable);
var Chart = /** @class */function (_super) {
  __extends$3W(Chart, _super);
  function Chart(document) {
    if (document === void 0) {
      document = window.document;
    }
    var _this = _super.call(this) || this;
    _this.id = createId(_this);
    _this.background = new Rect();
    _this.legend = new Legend();
    _this.legendAutoPadding = new Padding();
    _this.captionAutoPadding = 0; // top padding only
    _this._container = undefined;
    _this._data = [];
    _this._autoSize = false;
    _this.padding = new Padding(20);
    _this._axes = [];
    _this._series = [];
    _this._axesChanged = false;
    _this._seriesChanged = false;
    _this.layoutCallbackId = 0;
    _this._performLayout = function () {
      _this.layoutCallbackId = 0;
      _this.background.width = _this.width;
      _this.background.height = _this.height;
      _this.performLayout();
      if (!_this.layoutPending) {
        _this.fireEvent({
          type: 'layoutDone'
        });
      }
    };
    _this.dataCallbackId = 0;
    _this.nodeData = new Map();
    _this.updateCallbackId = 0;
    _this.legendBBox = new BBox(0, 0, 0, 0);
    _this._onMouseDown = _this.onMouseDown.bind(_this);
    _this._onMouseMove = _this.onMouseMove.bind(_this);
    _this._onMouseUp = _this.onMouseUp.bind(_this);
    _this._onMouseOut = _this.onMouseOut.bind(_this);
    _this._onClick = _this.onClick.bind(_this);
    _this.pointerInsideLegend = false;
    var root = new Group();
    var background = _this.background;
    background.fill = 'white';
    root.appendChild(background);
    var element = _this._element = document.createElement('div');
    element.setAttribute('class', 'ag-chart-wrapper');
    var scene = new Scene(document);
    _this.scene = scene;
    scene.root = root;
    scene.container = element;
    _this.autoSize = true;
    _this.padding.addEventListener('layoutChange', _this.scheduleLayout, _this);
    var legend = _this.legend;
    legend.addEventListener('layoutChange', _this.scheduleLayout, _this);
    legend.item.label.addPropertyListener('formatter', _this.updateLegend, _this);
    legend.addPropertyListener('position', _this.onLegendPositionChange, _this);
    _this.tooltip = new ChartTooltip(_this, document);
    _this.tooltip.addPropertyListener('class', function () {
      return _this.tooltip.toggle();
    });
    if (Chart.tooltipDocuments.indexOf(document) < 0) {
      var styleElement = document.createElement('style');
      styleElement.innerHTML = defaultTooltipCss;
      // Make sure the default tooltip style goes before other styles so it can be overridden.
      document.head.insertBefore(styleElement, document.head.querySelector('style'));
      Chart.tooltipDocuments.push(document);
    }
    _this.setupDomListeners(scene.canvas.element);
    _this.addPropertyListener('title', _this.onCaptionChange);
    _this.addPropertyListener('subtitle', _this.onCaptionChange);
    _this.addEventListener('layoutChange', _this.scheduleLayout);
    return _this;
  }
  Object.defineProperty(Chart.prototype, "container", {
    get: function get() {
      return this._container;
    },
    set: function set(value) {
      if (this._container !== value) {
        var parentNode = this.element.parentNode;
        if (parentNode != null) {
          parentNode.removeChild(this.element);
        }
        if (value) {
          value.appendChild(this.element);
        }
        this._container = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "data", {
    get: function get() {
      return this._data;
    },
    set: function set(data) {
      this._data = data;
      this.series.forEach(function (series) {
        return series.data = data;
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "width", {
    get: function get() {
      return this.scene.width;
    },
    set: function set(value) {
      this.autoSize = false;
      if (this.width !== value) {
        this.scene.resize(value, this.height);
        this.fireEvent({
          type: 'layoutChange'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "height", {
    get: function get() {
      return this.scene.height;
    },
    set: function set(value) {
      this.autoSize = false;
      if (this.height !== value) {
        this.scene.resize(this.width, value);
        this.fireEvent({
          type: 'layoutChange'
        });
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "autoSize", {
    get: function get() {
      return this._autoSize;
    },
    set: function set(value) {
      if (this._autoSize !== value) {
        this._autoSize = value;
        var style = this.element.style;
        if (value) {
          var chart_1 = this; // capture `this` for IE11
          SizeMonitor.observe(this.element, function (size) {
            if (size.width !== chart_1.width || size.height !== chart_1.height) {
              chart_1.scene.resize(size.width, size.height);
              chart_1.fireEvent({
                type: 'layoutChange'
              });
            }
          });
          style.display = 'block';
          style.width = '100%';
          style.height = '100%';
        } else {
          SizeMonitor.unobserve(this.element);
          style.display = 'inline-block';
          style.width = 'auto';
          style.height = 'auto';
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Chart.prototype.download = function (fileName) {
    this.scene.download(fileName);
  };
  Chart.prototype.destroy = function () {
    this.tooltip.destroy();
    SizeMonitor.unobserve(this.element);
    this.container = undefined;
    this.cleanupDomListeners(this.scene.canvas.element);
    this.scene.container = undefined;
  };
  Chart.prototype.onLegendPositionChange = function () {
    this.legendAutoPadding.clear();
    this.layoutPending = true;
  };
  Chart.prototype.onCaptionChange = function (event) {
    var value = event.value,
      oldValue = event.oldValue;
    if (oldValue) {
      oldValue.removeEventListener('change', this.scheduleLayout, this);
      this.scene.root.removeChild(oldValue.node);
    }
    if (value) {
      value.addEventListener('change', this.scheduleLayout, this);
      this.scene.root.appendChild(value.node);
    }
  };
  Object.defineProperty(Chart.prototype, "element", {
    get: function get() {
      return this._element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "axes", {
    get: function get() {
      return this._axes;
    },
    set: function set(values) {
      var _this = this;
      this._axes.forEach(function (axis) {
        return _this.detachAxis(axis);
      });
      // make linked axes go after the regular ones (simulates stable sort by `linkedTo` property)
      this._axes = values.filter(function (a) {
        return !a.linkedTo;
      }).concat(values.filter(function (a) {
        return a.linkedTo;
      }));
      this._axes.forEach(function (axis) {
        return _this.attachAxis(axis);
      });
      this.axesChanged = true;
    },
    enumerable: true,
    configurable: true
  });
  Chart.prototype.attachAxis = function (axis) {
    this.scene.root.insertBefore(axis.group, this.seriesRoot);
  };
  Chart.prototype.detachAxis = function (axis) {
    this.scene.root.removeChild(axis.group);
  };
  Object.defineProperty(Chart.prototype, "series", {
    get: function get() {
      return this._series;
    },
    set: function set(values) {
      var _this = this;
      this.removeAllSeries();
      values.forEach(function (series) {
        return _this.addSeries(series);
      });
    },
    enumerable: true,
    configurable: true
  });
  Chart.prototype.scheduleLayout = function () {
    this.layoutPending = true;
  };
  Chart.prototype.scheduleData = function () {
    // To prevent the chart from thinking the cursor is over the same node
    // after a change to data (the nodes are reused on data changes).
    this.dehighlightDatum();
    this.dataPending = true;
  };
  Chart.prototype.addSeries = function (series, before) {
    var _a = this,
      allSeries = _a.series,
      seriesRoot = _a.seriesRoot;
    var canAdd = allSeries.indexOf(series) < 0;
    if (canAdd) {
      var beforeIndex = before ? allSeries.indexOf(before) : -1;
      if (beforeIndex >= 0) {
        allSeries.splice(beforeIndex, 0, series);
        seriesRoot.insertBefore(series.group, before.group);
      } else {
        allSeries.push(series);
        seriesRoot.append(series.group);
      }
      this.initSeries(series);
      this.seriesChanged = true;
      this.axesChanged = true;
      return true;
    }
    return false;
  };
  Chart.prototype.initSeries = function (series) {
    series.chart = this;
    if (!series.data) {
      series.data = this.data;
    }
    series.addEventListener('layoutChange', this.scheduleLayout, this);
    series.addEventListener('dataChange', this.scheduleData, this);
    series.addEventListener('legendChange', this.updateLegend, this);
    series.addEventListener('nodeClick', this.onSeriesNodeClick, this);
  };
  Chart.prototype.freeSeries = function (series) {
    series.chart = undefined;
    series.removeEventListener('layoutChange', this.scheduleLayout, this);
    series.removeEventListener('dataChange', this.scheduleData, this);
    series.removeEventListener('legendChange', this.updateLegend, this);
    series.removeEventListener('nodeClick', this.onSeriesNodeClick, this);
  };
  Chart.prototype.addSeriesAfter = function (series, after) {
    var _a = this,
      allSeries = _a.series,
      seriesRoot = _a.seriesRoot;
    var canAdd = allSeries.indexOf(series) < 0;
    if (canAdd) {
      var afterIndex = after ? this.series.indexOf(after) : -1;
      if (afterIndex >= 0) {
        if (afterIndex + 1 < allSeries.length) {
          seriesRoot.insertBefore(series.group, allSeries[afterIndex + 1].group);
        } else {
          seriesRoot.append(series.group);
        }
        this.initSeries(series);
        allSeries.splice(afterIndex + 1, 0, series);
      } else {
        if (allSeries.length > 0) {
          seriesRoot.insertBefore(series.group, allSeries[0].group);
        } else {
          seriesRoot.append(series.group);
        }
        this.initSeries(series);
        allSeries.unshift(series);
      }
      this.seriesChanged = true;
      this.axesChanged = true;
    }
    return false;
  };
  Chart.prototype.removeSeries = function (series) {
    var index = this.series.indexOf(series);
    if (index >= 0) {
      this.series.splice(index, 1);
      this.freeSeries(series);
      this.seriesRoot.removeChild(series.group);
      this.seriesChanged = true;
      return true;
    }
    return false;
  };
  Chart.prototype.removeAllSeries = function () {
    var _this = this;
    this.series.forEach(function (series) {
      _this.freeSeries(series);
      _this.seriesRoot.removeChild(series.group);
    });
    this._series = []; // using `_series` instead of `series` to prevent infinite recursion
    this.seriesChanged = true;
  };
  Chart.prototype.assignSeriesToAxes = function () {
    var _this = this;
    this.axes.forEach(function (axis) {
      var axisName = axis.direction + 'Axis';
      var boundSeries = [];
      _this.series.forEach(function (series) {
        if (series[axisName] === axis) {
          boundSeries.push(series);
        }
      });
      axis.boundSeries = boundSeries;
    });
    this.seriesChanged = false;
  };
  Chart.prototype.assignAxesToSeries = function (force) {
    var _this = this;
    if (force === void 0) {
      force = false;
    }
    // This method has to run before `assignSeriesToAxes`.
    var directionToAxesMap = {};
    this.axes.forEach(function (axis) {
      var direction = axis.direction;
      var directionAxes = directionToAxesMap[direction] || (directionToAxesMap[direction] = []);
      directionAxes.push(axis);
    });
    this.series.forEach(function (series) {
      series.directions.forEach(function (direction) {
        var axisName = direction + 'Axis';
        if (!series[axisName] || force) {
          var directionAxes = directionToAxesMap[direction];
          if (directionAxes) {
            var axis = _this.findMatchingAxis(directionAxes, series.getKeys(direction));
            if (axis) {
              series[axisName] = axis;
            }
          }
        }
      });
    });
    this.axesChanged = false;
  };
  Chart.prototype.findMatchingAxis = function (directionAxes, directionKeys) {
    for (var i = 0; i < directionAxes.length; i++) {
      var axis = directionAxes[i];
      var axisKeys = axis.keys;
      if (!axisKeys.length) {
        return axis;
      } else if (directionKeys) {
        for (var j = 0; j < directionKeys.length; j++) {
          if (axisKeys.indexOf(directionKeys[j]) >= 0) {
            return axis;
          }
        }
      }
    }
  };
  Object.defineProperty(Chart.prototype, "axesChanged", {
    get: function get() {
      return this._axesChanged;
    },
    set: function set(value) {
      this._axesChanged = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "seriesChanged", {
    get: function get() {
      return this._seriesChanged;
    },
    set: function set(value) {
      this._seriesChanged = value;
      if (value) {
        this.dataPending = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "layoutPending", {
    /**
     * Only `true` while we are waiting for the layout to start.
     * This will be `false` if the layout has already started and is ongoing.
     */
    get: function get() {
      return !!this.layoutCallbackId;
    },
    set: function set(value) {
      if (value) {
        if (!(this.layoutCallbackId || this.dataPending)) {
          this.layoutCallbackId = requestAnimationFrame(this._performLayout);
          this.series.forEach(function (s) {
            return s.nodeDataPending = true;
          });
        }
      } else if (this.layoutCallbackId) {
        cancelAnimationFrame(this.layoutCallbackId);
        this.layoutCallbackId = 0;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Chart.prototype, "dataPending", {
    get: function get() {
      return !!this.dataCallbackId;
    },
    set: function set(value) {
      var _this = this;
      if (this.dataCallbackId) {
        clearTimeout(this.dataCallbackId);
        this.dataCallbackId = 0;
      }
      if (value) {
        this.dataCallbackId = window.setTimeout(function () {
          _this.dataPending = false;
          _this.processData();
        }, 0);
      }
    },
    enumerable: true,
    configurable: true
  });
  Chart.prototype.processData = function () {
    this.layoutPending = false;
    if (this.axesChanged) {
      this.assignAxesToSeries(true);
      this.assignSeriesToAxes();
    }
    if (this.seriesChanged) {
      this.assignSeriesToAxes();
    }
    this.series.forEach(function (s) {
      return s.processData();
    });
    this.updateLegend();
    this.layoutPending = true;
  };
  Chart.prototype.createNodeData = function () {
    var _this = this;
    this.nodeData.clear();
    this.series.forEach(function (s) {
      var data = s.visible ? s.createNodeData() : [];
      _this.nodeData.set(s, data);
    });
  };
  Chart.prototype.placeLabels = function () {
    var series = [];
    var data = [];
    this.nodeData.forEach(function (d, s) {
      if (s.visible && s.label.enabled) {
        series.push(s);
        data.push(s.getLabelData());
      }
    });
    var seriesRect = this.seriesRect;
    var labels = seriesRect ? placeLabels(data, {
      x: 0,
      y: 0,
      width: seriesRect.width,
      height: seriesRect.height
    }) : [];
    return new Map(labels.map(function (l, i) {
      return [series[i], l];
    }));
  };
  Chart.prototype.updateLegend = function () {
    var legendData = [];
    this.series.filter(function (s) {
      return s.showInLegend;
    }).forEach(function (series) {
      return series.listSeriesItems(legendData);
    });
    var formatter = this.legend.item.label.formatter;
    if (formatter) {
      legendData.forEach(function (datum) {
        return datum.label.text = formatter({
          id: datum.id,
          itemId: datum.itemId,
          value: datum.label.text
        });
      });
    }
    this.legend.data = legendData;
  };
  Object.defineProperty(Chart.prototype, "updatePending", {
    get: function get() {
      return !!this.updateCallbackId;
    },
    set: function set(value) {
      var _this = this;
      if (this.updateCallbackId) {
        clearTimeout(this.updateCallbackId);
        this.updateCallbackId = 0;
      }
      if (value && !this.layoutPending) {
        this.updateCallbackId = window.setTimeout(function () {
          _this.update();
        }, 0);
      }
    },
    enumerable: true,
    configurable: true
  });
  Chart.prototype.update = function () {
    this.updatePending = false;
    this.series.forEach(function (series) {
      if (series.updatePending) {
        series.update();
      }
    });
  };
  Chart.prototype.positionCaptions = function () {
    var _a = this,
      title = _a.title,
      subtitle = _a.subtitle;
    var titleVisible = false;
    var subtitleVisible = false;
    var spacing = 10;
    var paddingTop = spacing;
    if (title && title.enabled) {
      title.node.x = this.width / 2;
      title.node.y = paddingTop;
      titleVisible = true;
      var titleBBox = title.node.computeBBox(); // make sure to set node's x/y, then computeBBox
      if (titleBBox) {
        paddingTop = titleBBox.y + titleBBox.height;
      }
      if (subtitle && subtitle.enabled) {
        subtitle.node.x = this.width / 2;
        subtitle.node.y = paddingTop + spacing;
        subtitleVisible = true;
        var subtitleBBox = subtitle.node.computeBBox();
        if (subtitleBBox) {
          paddingTop = subtitleBBox.y + subtitleBBox.height;
        }
      }
    }
    if (title) {
      title.node.visible = titleVisible;
    }
    if (subtitle) {
      subtitle.node.visible = subtitleVisible;
    }
    this.captionAutoPadding = Math.floor(paddingTop);
  };
  Chart.prototype.positionLegend = function () {
    if (!this.legend.enabled || !this.legend.data.length) {
      return;
    }
    var _a = this,
      legend = _a.legend,
      captionAutoPadding = _a.captionAutoPadding,
      legendAutoPadding = _a.legendAutoPadding;
    var width = this.width;
    var height = this.height - captionAutoPadding;
    var legendGroup = legend.group;
    var legendSpacing = legend.spacing;
    var translationX = 0;
    var translationY = 0;
    var legendBBox;
    switch (legend.position) {
      case 'bottom':
        legend.performLayout(width - legendSpacing * 2, 0);
        legendBBox = legendGroup.computeBBox();
        translationX = (width - legendBBox.width) / 2 - legendBBox.x;
        translationY = captionAutoPadding + height - legendBBox.height - legendBBox.y - legendSpacing;
        legendAutoPadding.bottom = legendBBox.height;
        break;
      case 'top':
        legend.performLayout(width - legendSpacing * 2, 0);
        legendBBox = legendGroup.computeBBox();
        translationX = (width - legendBBox.width) / 2 - legendBBox.x;
        translationY = captionAutoPadding + legendSpacing - legendBBox.y;
        legendAutoPadding.top = legendBBox.height;
        break;
      case 'left':
        legend.performLayout(0, height - legendSpacing * 2);
        legendBBox = legendGroup.computeBBox();
        translationX = legendSpacing - legendBBox.x;
        translationY = captionAutoPadding + (height - legendBBox.height) / 2 - legendBBox.y;
        legendAutoPadding.left = legendBBox.width;
        break;
      default:
        // case 'right':
        legend.performLayout(0, height - legendSpacing * 2);
        legendBBox = legendGroup.computeBBox();
        translationX = width - legendBBox.width - legendBBox.x - legendSpacing;
        translationY = captionAutoPadding + (height - legendBBox.height) / 2 - legendBBox.y;
        legendAutoPadding.right = legendBBox.width;
        break;
    }
    // Round off for pixel grid alignment to work properly.
    legendGroup.translationX = Math.floor(translationX + legendGroup.translationX);
    legendGroup.translationY = Math.floor(translationY + legendGroup.translationY);
    this.legendBBox = legendGroup.computeBBox();
  };
  Chart.prototype.setupDomListeners = function (chartElement) {
    chartElement.addEventListener('mousedown', this._onMouseDown);
    chartElement.addEventListener('mousemove', this._onMouseMove);
    chartElement.addEventListener('mouseup', this._onMouseUp);
    chartElement.addEventListener('mouseout', this._onMouseOut);
    chartElement.addEventListener('click', this._onClick);
  };
  Chart.prototype.cleanupDomListeners = function (chartElement) {
    chartElement.removeEventListener('mousedown', this._onMouseDown);
    chartElement.removeEventListener('mousemove', this._onMouseMove);
    chartElement.removeEventListener('mouseup', this._onMouseUp);
    chartElement.removeEventListener('mouseout', this._onMouseOut);
    chartElement.removeEventListener('click', this._onClick);
  };
  Chart.prototype.getSeriesRect = function () {
    return this.seriesRect;
  };
  // x/y are local canvas coordinates in CSS pixels, not actual pixels
  Chart.prototype.pickSeriesNode = function (x, y) {
    if (!(this.seriesRect && this.seriesRect.containsPoint(x, y))) {
      return undefined;
    }
    var allSeries = this.series;
    var node = undefined;
    for (var i = allSeries.length - 1; i >= 0; i--) {
      var series = allSeries[i];
      if (!series.visible) {
        continue;
      }
      node = series.pickGroup.pickNode(x, y);
      if (node) {
        return {
          series: series,
          node: node
        };
      }
    }
  };
  // Provided x/y are in canvas coordinates.
  Chart.prototype.pickClosestSeriesNodeDatum = function (x, y) {
    if (!this.seriesRect || !this.seriesRect.containsPoint(x, y)) {
      return undefined;
    }
    var allSeries = this.series;
    function getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    }
    var minDistance = Infinity;
    var closestDatum;
    var _loop_1 = function _loop_1(i) {
      var series = allSeries[i];
      if (!series.visible) {
        return "continue";
      }
      var hitPoint = series.group.transformPoint(x, y);
      series.getNodeData().forEach(function (datum) {
        if (!datum.point) {
          return;
        }
        var distance = getDistance(hitPoint, datum.point);
        if (distance < minDistance) {
          minDistance = distance;
          closestDatum = datum;
        }
      });
    };
    for (var i = allSeries.length - 1; i >= 0; i--) {
      _loop_1(i);
    }
    return closestDatum;
  };
  Chart.prototype.onMouseMove = function (event) {
    this.handleLegendMouseMove(event);
    if (this.tooltip.enabled) {
      if (this.tooltip.delay > 0) {
        this.tooltip.toggle(false);
      }
      this.handleTooltip(event);
    }
  };
  Chart.prototype.handleTooltip = function (event) {
    var _a = this,
      lastPick = _a.lastPick,
      tooltipTracking = _a.tooltip.tracking;
    var offsetX = event.offsetX,
      offsetY = event.offsetY;
    var pick = this.pickSeriesNode(offsetX, offsetY);
    var nodeDatum;
    if (pick && pick.node instanceof Shape) {
      var node = pick.node;
      nodeDatum = node.datum;
      if (lastPick && lastPick.datum === nodeDatum) {
        lastPick.node = node;
        lastPick.event = event;
      }
      // Marker nodes will have the `point` info in their datums.
      // Highlight if not a marker node or, if not in the tracking mode, highlight markers too.
      if (!node.datum.point || !tooltipTracking) {
        if (!lastPick // cursor moved from empty space to a node
        || lastPick.node !== node) {
          // cursor moved from one node to another
          this.onSeriesDatumPick(event, node.datum, node, event);
        } else if (pick.series.tooltip.enabled) {
          // cursor moved within the same node
          this.tooltip.show(event);
        }
        // A non-marker node (takes precedence over marker nodes) was highlighted.
        // Or we are not in the tracking mode.
        // Either way, we are done at this point.
        return;
      }
    }
    var hideTooltip = false;
    // In tracking mode a tooltip is shown for the closest rendered datum.
    // This makes it easier to show tooltips when markers are small and/or plentiful
    // and also gives the ability to show tooltips even when the series were configured
    // to not render markers.
    if (tooltipTracking) {
      var closestDatum = this.pickClosestSeriesNodeDatum(offsetX, offsetY);
      if (closestDatum && closestDatum.point) {
        var _b = closestDatum.point,
          x = _b.x,
          y = _b.y;
        var canvas = this.scene.canvas;
        var point = closestDatum.series.group.inverseTransformPoint(x, y);
        var canvasRect = canvas.element.getBoundingClientRect();
        this.onSeriesDatumPick({
          pageX: Math.round(canvasRect.left + window.pageXOffset + point.x),
          pageY: Math.round(canvasRect.top + window.pageYOffset + point.y)
        }, closestDatum, nodeDatum === closestDatum && pick ? pick.node : undefined, event);
      } else {
        hideTooltip = true;
      }
    }
    if (lastPick && (hideTooltip || !tooltipTracking)) {
      // Cursor moved from a non-marker node to empty space.
      this.dehighlightDatum();
      this.tooltip.toggle(false);
      this.lastPick = undefined;
    }
  };
  Chart.prototype.onMouseDown = function (event) {};
  Chart.prototype.onMouseUp = function (event) {};
  Chart.prototype.onMouseOut = function (event) {
    this.tooltip.toggle(false);
  };
  Chart.prototype.onClick = function (event) {
    if (this.checkSeriesNodeClick()) {
      return;
    }
    if (this.checkLegendClick(event)) {
      return;
    }
    this.fireEvent({
      type: 'click',
      event: event
    });
  };
  Chart.prototype.checkSeriesNodeClick = function () {
    var lastPick = this.lastPick;
    if (lastPick && lastPick.event && lastPick.node) {
      var event_1 = lastPick.event,
        datum = lastPick.datum;
      datum.series.fireNodeClickEvent(event_1, datum);
      return true;
    }
    return false;
  };
  Chart.prototype.onSeriesNodeClick = function (event) {
    this.fireEvent(__assign$k(__assign$k({}, event), {
      type: 'seriesNodeClick'
    }));
  };
  Chart.prototype.checkLegendClick = function (event) {
    var datum = this.legend.getDatumForPoint(event.offsetX, event.offsetY);
    if (datum) {
      var id_1 = datum.id,
        itemId = datum.itemId,
        enabled = datum.enabled;
      var series = find$4(this.series, function (series) {
        return series.id === id_1;
      });
      if (series) {
        series.toggleSeriesItem(itemId, !enabled);
        if (enabled) {
          this.tooltip.toggle(false);
        }
        this.legend.fireEvent({
          type: 'click',
          event: event,
          itemId: itemId,
          enabled: !enabled
        });
        return true;
      }
    }
    return false;
  };
  Chart.prototype.handleLegendMouseMove = function (event) {
    if (!this.legend.enabled) {
      return;
    }
    var offsetX = event.offsetX,
      offsetY = event.offsetY;
    var datum = this.legend.getDatumForPoint(offsetX, offsetY);
    var pointerInsideLegend = this.legendBBox.containsPoint(offsetX, offsetY);
    if (pointerInsideLegend) {
      if (!this.pointerInsideLegend) {
        this.pointerInsideLegend = true;
      }
    } else if (this.pointerInsideLegend) {
      this.pointerInsideLegend = false;
      // Dehighlight if the pointer was inside the legend and is now leaving it.
      if (this.highlightedDatum) {
        this.highlightedDatum = undefined;
        this.series.forEach(function (s) {
          return s.updatePending = true;
        });
      }
      return;
    }
    var oldHighlightedDatum = this.highlightedDatum;
    if (datum) {
      var id_2 = datum.id,
        itemId = datum.itemId,
        enabled = datum.enabled;
      if (enabled) {
        var series = find$4(this.series, function (series) {
          return series.id === id_2;
        });
        if (series) {
          this.highlightedDatum = {
            series: series,
            itemId: itemId,
            datum: undefined
          };
        }
      }
    }
    // Careful to only schedule updates when necessary.
    if (this.highlightedDatum && !oldHighlightedDatum || this.highlightedDatum && oldHighlightedDatum && (this.highlightedDatum.series !== oldHighlightedDatum.series || this.highlightedDatum.itemId !== oldHighlightedDatum.itemId)) {
      this.series.forEach(function (s) {
        return s.updatePending = true;
      });
    }
  };
  Chart.prototype.onSeriesDatumPick = function (meta, datum, node, event) {
    var lastPick = this.lastPick;
    if (lastPick) {
      if (lastPick.datum === datum) {
        return;
      }
      this.dehighlightDatum();
    }
    this.lastPick = {
      datum: datum,
      node: node,
      event: event
    };
    this.highlightDatum(datum);
    var html = datum.series.tooltip.enabled && datum.series.getTooltipHtml(datum);
    if (html) {
      this.tooltip.show(meta, html);
    }
  };
  Chart.prototype.highlightDatum = function (datum) {
    this.scene.canvas.element.style.cursor = datum.series.cursor;
    this.highlightedDatum = datum;
    this.series.forEach(function (s) {
      return s.updatePending = true;
    });
  };
  Chart.prototype.dehighlightDatum = function () {
    this.scene.canvas.element.style.cursor = 'default';
    this.highlightedDatum = undefined;
    this.series.forEach(function (s) {
      return s.updatePending = true;
    });
  };
  Chart.defaultTooltipClass = 'ag-chart-tooltip';
  Chart.tooltipDocuments = [];
  __decorate$38([reactive('layoutChange')], Chart.prototype, "title", void 0);
  __decorate$38([reactive('layoutChange')], Chart.prototype, "subtitle", void 0);
  return Chart;
}(Observable);
var __extends$3X = undefined && undefined.__extends || function () {
  var _extendStatics260 = function extendStatics(d, b) {
    _extendStatics260 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics260(d, b);
  };
  return function (d, b) {
    _extendStatics260(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * Acts as `Group` node but with specified bounds that form a rectangle.
 * Any parts of the child nodes outside that rectangle will not be visible.
 * Unlike the `Group` node, the `ClipRect` node cannot be transformed.
 */
var ClipRect = /** @class */function (_super) {
  __extends$3X(ClipRect, _super);
  function ClipRect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isContainerNode = true;
    _this.path = new Path2D();
    _this._enabled = true;
    _this._dirtyPath = true;
    _this._x = 0;
    _this._y = 0;
    _this._width = 10;
    _this._height = 10;
    return _this;
  }
  ClipRect.prototype.containsPoint = function (x, y) {
    var point = this.transformPoint(x, y);
    return point.x >= this.x && point.x <= this.x + this.width && point.y >= this.y && point.y <= this.y + this.height;
  };
  Object.defineProperty(ClipRect.prototype, "enabled", {
    get: function get() {
      return this._enabled;
    },
    set: function set(value) {
      if (this._enabled !== value) {
        this._enabled = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ClipRect.prototype, "dirtyPath", {
    get: function get() {
      return this._dirtyPath;
    },
    set: function set(value) {
      if (this._dirtyPath !== value) {
        this._dirtyPath = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ClipRect.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ClipRect.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ClipRect.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ClipRect.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  ClipRect.prototype.updatePath = function () {
    var path = this.path;
    path.clear();
    path.rect(this.x, this.y, this.width, this.height);
    this.dirtyPath = false;
  };
  ClipRect.prototype.computeBBox = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height;
    return new BBox(x, y, width, height);
  };
  ClipRect.prototype.render = function (ctx) {
    if (this.enabled) {
      if (this.dirtyPath) {
        this.updatePath();
      }
      this.path.draw(ctx);
      ctx.clip();
    }
    var children = this.children;
    var n = children.length;
    for (var i = 0; i < n; i++) {
      ctx.save();
      var child = children[i];
      if (child.visible) {
        child.render(ctx);
      }
      ctx.restore();
    }
    // debug
    // this.computeBBox().render(ctx, {
    //     label: this.id,
    //     resetTransform: true,
    //     fillStyle: 'rgba(0, 0, 0, 0.5)'
    // });
  };

  ClipRect.className = 'ClipRect';
  return ClipRect;
}(Node$1);
var __extends$3Y = undefined && undefined.__extends || function () {
  var _extendStatics261 = function extendStatics(d, b) {
    _extendStatics261 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics261(d, b);
  };
  return function (d, b) {
    _extendStatics261(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RangeHandle = /** @class */function (_super) {
  __extends$3Y(RangeHandle, _super);
  function RangeHandle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._fill = '#f2f2f2';
    _this._stroke = '#999999';
    _this._strokeWidth = 1;
    _this._lineCap = 'square';
    _this._centerX = 0;
    _this._centerY = 0;
    // Use an even number for better looking results.
    _this._width = 8;
    // Use an even number for better looking results.
    _this._gripLineGap = 2;
    // Use an even number for better looking results.
    _this._gripLineLength = 8;
    _this._height = 16;
    return _this;
  }
  Object.defineProperty(RangeHandle.prototype, "centerX", {
    get: function get() {
      return this._centerX;
    },
    set: function set(value) {
      if (this._centerX !== value) {
        this._centerX = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeHandle.prototype, "centerY", {
    get: function get() {
      return this._centerY;
    },
    set: function set(value) {
      if (this._centerY !== value) {
        this._centerY = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeHandle.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeHandle.prototype, "gripLineGap", {
    get: function get() {
      return this._gripLineGap;
    },
    set: function set(value) {
      if (this._gripLineGap !== value) {
        this._gripLineGap = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeHandle.prototype, "gripLineLength", {
    get: function get() {
      return this._gripLineLength;
    },
    set: function set(value) {
      if (this._gripLineLength !== value) {
        this._gripLineLength = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeHandle.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  RangeHandle.prototype.computeBBox = function () {
    var _a = this,
      centerX = _a.centerX,
      centerY = _a.centerY,
      width = _a.width,
      height = _a.height;
    var x = centerX - width / 2;
    var y = centerY - height / 2;
    return new BBox(x, y, width, height);
  };
  RangeHandle.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return bbox.containsPoint(point.x, point.y);
  };
  RangeHandle.prototype.updatePath = function () {
    var _a = this,
      path = _a.path,
      centerX = _a.centerX,
      centerY = _a.centerY,
      width = _a.width,
      height = _a.height;
    var _b = this,
      a = _b.alignment,
      al = _b.align;
    path.clear();
    var x = centerX - width / 2;
    var y = centerY - height / 2;
    var ax = al(a, x);
    var ay = al(a, y);
    var axw = ax + al(a, x, width);
    var ayh = ay + al(a, y, height);
    // Handle.
    path.moveTo(ax, ay);
    path.lineTo(axw, ay);
    path.lineTo(axw, ayh);
    path.lineTo(ax, ayh);
    path.lineTo(ax, ay);
    // Grip lines.
    var dx = this.gripLineGap / 2;
    var dy = this.gripLineLength / 2;
    path.moveTo(al(a, centerX - dx), al(a, centerY - dy));
    path.lineTo(al(a, centerX - dx), al(a, centerY + dy));
    path.moveTo(al(a, centerX + dx), al(a, centerY - dy));
    path.lineTo(al(a, centerX + dx), al(a, centerY + dy));
  };
  RangeHandle.className = 'RangeHandle';
  return RangeHandle;
}(Path);
var __extends$3Z = undefined && undefined.__extends || function () {
  var _extendStatics262 = function extendStatics(d, b) {
    _extendStatics262 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics262(d, b);
  };
  return function (d, b) {
    _extendStatics262(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RangeMask = /** @class */function (_super) {
  __extends$3Z(RangeMask, _super);
  function RangeMask() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._stroke = '#999999';
    _this._strokeWidth = 1;
    _this._fill = '#999999';
    _this._fillOpacity = 0.2;
    _this._lineCap = 'square';
    _this._x = 0;
    _this._y = 0;
    _this._width = 200;
    _this._height = 30;
    _this.minRange = 0.05;
    _this._min = 0;
    _this._max = 1;
    return _this;
  }
  Object.defineProperty(RangeMask.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeMask.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeMask.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeMask.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeMask.prototype, "min", {
    get: function get() {
      return this._min;
    },
    set: function set(value) {
      value = Math.min(Math.max(value, 0), this.max - this.minRange);
      if (isNaN(value)) {
        return;
      }
      if (this._min !== value) {
        this._min = value;
        this.dirtyPath = true;
        this.onRangeChange && this.onRangeChange(value, this.max);
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeMask.prototype, "max", {
    get: function get() {
      return this._max;
    },
    set: function set(value) {
      value = Math.max(Math.min(value, 1), this.min + this.minRange);
      if (isNaN(value)) {
        return;
      }
      if (this._max !== value) {
        this._max = value;
        this.dirtyPath = true;
        this.onRangeChange && this.onRangeChange(this.min, value);
      }
    },
    enumerable: true,
    configurable: true
  });
  RangeMask.prototype.computeBBox = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height;
    return new BBox(x, y, width, height);
  };
  RangeMask.prototype.computeVisibleRangeBBox = function () {
    var _a = this,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height,
      min = _a.min,
      max = _a.max;
    var minX = x + width * min;
    var maxX = x + width * max;
    return new BBox(minX, y, maxX - minX, height);
  };
  RangeMask.prototype.updatePath = function () {
    var _a = this,
      path = _a.path,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height,
      min = _a.min,
      max = _a.max;
    var _b = this,
      a = _b.alignment,
      al = _b.align;
    path.clear();
    var ax = al(a, x);
    var ay = al(a, y);
    var axw = ax + al(a, x, width);
    var ayh = ay + al(a, y, height);
    // Whole range.
    path.moveTo(ax, ay);
    path.lineTo(axw, ay);
    path.lineTo(axw, ayh);
    path.lineTo(ax, ayh);
    path.lineTo(ax, ay);
    var minX = al(a, x + width * min);
    var maxX = al(a, x + width * max);
    // Visible range.
    path.moveTo(minX, ay);
    path.lineTo(minX, ayh);
    path.lineTo(maxX, ayh);
    path.lineTo(maxX, ay);
    path.lineTo(minX, ay);
  };
  RangeMask.className = 'RangeMask';
  return RangeMask;
}(Path);
var __extends$3_ = undefined && undefined.__extends || function () {
  var _extendStatics263 = function extendStatics(d, b) {
    _extendStatics263 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics263(d, b);
  };
  return function (d, b) {
    _extendStatics263(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var RangeSelector = /** @class */function (_super) {
  __extends$3_(RangeSelector, _super);
  function RangeSelector() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isContainerNode = true;
    _this.minHandle = new RangeHandle();
    _this.maxHandle = new RangeHandle();
    _this.mask = function () {
      var _a = RangeSelector.defaults,
        x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height,
        min = _a.min,
        max = _a.max;
      var mask = new RangeMask();
      mask.x = x;
      mask.y = y;
      mask.width = width;
      mask.height = height;
      mask.min = min;
      mask.max = max;
      var _b = _this,
        minHandle = _b.minHandle,
        maxHandle = _b.maxHandle;
      minHandle.centerX = x;
      maxHandle.centerX = x + width;
      minHandle.centerY = maxHandle.centerY = y + height / 2;
      _this.append([mask, minHandle, maxHandle]);
      mask.onRangeChange = function (min, max) {
        _this.updateHandles();
        _this.onRangeChange && _this.onRangeChange(min, max);
      };
      return mask;
    }();
    _this._x = RangeSelector.defaults.x;
    _this._y = RangeSelector.defaults.y;
    _this._width = RangeSelector.defaults.width;
    _this._height = RangeSelector.defaults.height;
    _this._min = RangeSelector.defaults.min;
    _this._max = RangeSelector.defaults.max;
    return _this;
  }
  Object.defineProperty(RangeSelector.prototype, "x", {
    get: function get() {
      return this.mask.x;
    },
    set: function set(value) {
      this.mask.x = value;
      this.updateHandles();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeSelector.prototype, "y", {
    get: function get() {
      return this.mask.y;
    },
    set: function set(value) {
      this.mask.y = value;
      this.updateHandles();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeSelector.prototype, "width", {
    get: function get() {
      return this.mask.width;
    },
    set: function set(value) {
      this.mask.width = value;
      this.updateHandles();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeSelector.prototype, "height", {
    get: function get() {
      return this.mask.height;
    },
    set: function set(value) {
      this.mask.height = value;
      this.updateHandles();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeSelector.prototype, "min", {
    get: function get() {
      return this.mask.min;
    },
    set: function set(value) {
      this.mask.min = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RangeSelector.prototype, "max", {
    get: function get() {
      return this.mask.max;
    },
    set: function set(value) {
      this.mask.max = value;
    },
    enumerable: true,
    configurable: true
  });
  RangeSelector.prototype.updateHandles = function () {
    var _a = this,
      minHandle = _a.minHandle,
      maxHandle = _a.maxHandle,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height,
      mask = _a.mask;
    minHandle.centerX = x + width * mask.min;
    maxHandle.centerX = x + width * mask.max;
    minHandle.centerY = maxHandle.centerY = y + height / 2;
  };
  RangeSelector.prototype.computeBBox = function () {
    return this.mask.computeBBox();
  };
  RangeSelector.prototype.computeVisibleRangeBBox = function () {
    return this.mask.computeVisibleRangeBBox();
  };
  RangeSelector.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var _a = this,
      mask = _a.mask,
      minHandle = _a.minHandle,
      maxHandle = _a.maxHandle;
    [mask, minHandle, maxHandle].forEach(function (child) {
      ctx.save();
      if (child.visible) {
        child.render(ctx);
      }
      ctx.restore();
    });
  };
  RangeSelector.className = 'Range';
  RangeSelector.defaults = {
    x: 0,
    y: 0,
    width: 200,
    height: 30,
    min: 0,
    max: 1
  };
  return RangeSelector;
}(Group);
var NavigatorMask = /** @class */function () {
  function NavigatorMask(rangeMask) {
    this.rm = rangeMask;
  }
  Object.defineProperty(NavigatorMask.prototype, "fill", {
    get: function get() {
      return this.rm.fill;
    },
    set: function set(value) {
      this.rm.fill = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorMask.prototype, "stroke", {
    get: function get() {
      return this.rm.stroke;
    },
    set: function set(value) {
      this.rm.stroke = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorMask.prototype, "strokeWidth", {
    get: function get() {
      return this.rm.strokeWidth;
    },
    set: function set(value) {
      this.rm.strokeWidth = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorMask.prototype, "fillOpacity", {
    get: function get() {
      return this.rm.fillOpacity;
    },
    set: function set(value) {
      this.rm.fillOpacity = value;
    },
    enumerable: true,
    configurable: true
  });
  return NavigatorMask;
}();
var NavigatorHandle = /** @class */function () {
  function NavigatorHandle(rangeHandle) {
    this.rh = rangeHandle;
  }
  Object.defineProperty(NavigatorHandle.prototype, "fill", {
    get: function get() {
      return this.rh.fill;
    },
    set: function set(value) {
      this.rh.fill = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "stroke", {
    get: function get() {
      return this.rh.stroke;
    },
    set: function set(value) {
      this.rh.stroke = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "strokeWidth", {
    get: function get() {
      return this.rh.strokeWidth;
    },
    set: function set(value) {
      this.rh.strokeWidth = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "width", {
    get: function get() {
      return this.rh.width;
    },
    set: function set(value) {
      this.rh.width = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "height", {
    get: function get() {
      return this.rh.height;
    },
    set: function set(value) {
      this.rh.height = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "gripLineGap", {
    get: function get() {
      return this.rh.gripLineGap;
    },
    set: function set(value) {
      this.rh.gripLineGap = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NavigatorHandle.prototype, "gripLineLength", {
    get: function get() {
      return this.rh.gripLineLength;
    },
    set: function set(value) {
      this.rh.gripLineLength = value;
    },
    enumerable: true,
    configurable: true
  });
  return NavigatorHandle;
}();
var Navigator = /** @class */function () {
  function Navigator(chart) {
    var _this = this;
    this.rs = new RangeSelector();
    this.mask = new NavigatorMask(this.rs.mask);
    this.minHandle = new NavigatorHandle(this.rs.minHandle);
    this.maxHandle = new NavigatorHandle(this.rs.maxHandle);
    this.minHandleDragging = false;
    this.maxHandleDragging = false;
    this.panHandleOffset = NaN;
    this._margin = 10;
    this.chart = chart;
    chart.scene.root.append(this.rs);
    this.rs.onRangeChange = function (min, max) {
      return _this.updateAxes(min, max);
    };
  }
  Object.defineProperty(Navigator.prototype, "enabled", {
    get: function get() {
      return this.rs.visible;
    },
    set: function set(value) {
      this.rs.visible = value;
      this.chart.layoutPending = true;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "x", {
    get: function get() {
      return this.rs.x;
    },
    set: function set(value) {
      this.rs.x = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "y", {
    get: function get() {
      return this.rs.y;
    },
    set: function set(value) {
      this.rs.y = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "width", {
    get: function get() {
      return this.rs.width;
    },
    set: function set(value) {
      this.rs.width = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "height", {
    get: function get() {
      return this.rs.height;
    },
    set: function set(value) {
      this.rs.height = value;
      this.chart.layoutPending = true;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "margin", {
    get: function get() {
      return this._margin;
    },
    set: function set(value) {
      this._margin = value;
      this.chart.layoutPending = true;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "min", {
    get: function get() {
      return this.rs.min;
    },
    set: function set(value) {
      this.rs.min = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Navigator.prototype, "max", {
    get: function get() {
      return this.rs.max;
    },
    set: function set(value) {
      this.rs.max = value;
    },
    enumerable: true,
    configurable: true
  });
  Navigator.prototype.updateAxes = function (min, max) {
    var chart = this.chart;
    var clipSeries = false;
    chart.axes.forEach(function (axis) {
      if (axis.direction === ChartAxisDirection.X) {
        if (!clipSeries && (min > 0 || max < 1)) {
          clipSeries = true;
        }
        axis.visibleRange = [min, max];
        axis.update();
      }
    });
    chart.seriesRoot.enabled = clipSeries;
    chart.series.forEach(function (s) {
      return s.nodeDataPending = true;
    });
  };
  Navigator.prototype.onDragStart = function (offset) {
    if (!this.enabled) {
      return;
    }
    var offsetX = offset.offsetX,
      offsetY = offset.offsetY;
    var rs = this.rs;
    var minHandle = rs.minHandle,
      maxHandle = rs.maxHandle,
      x = rs.x,
      width = rs.width,
      min = rs.min;
    var visibleRange = rs.computeVisibleRangeBBox();
    if (!(this.minHandleDragging || this.maxHandleDragging)) {
      if (minHandle.containsPoint(offsetX, offsetY)) {
        this.minHandleDragging = true;
      } else if (maxHandle.containsPoint(offsetX, offsetY)) {
        this.maxHandleDragging = true;
      } else if (visibleRange.containsPoint(offsetX, offsetY)) {
        this.panHandleOffset = (offsetX - x) / width - min;
      }
    }
  };
  Navigator.prototype.onDrag = function (offset) {
    if (!this.enabled) {
      return;
    }
    var _a = this,
      rs = _a.rs,
      panHandleOffset = _a.panHandleOffset;
    var x = rs.x,
      y = rs.y,
      width = rs.width,
      height = rs.height,
      minHandle = rs.minHandle,
      maxHandle = rs.maxHandle;
    var style = this.chart.element.style;
    var offsetX = offset.offsetX,
      offsetY = offset.offsetY;
    var minX = x + width * rs.min;
    var maxX = x + width * rs.max;
    var visibleRange = new BBox(minX, y, maxX - minX, height);
    function getRatio() {
      return Math.min(Math.max((offsetX - x) / width, 0), 1);
    }
    if (minHandle.containsPoint(offsetX, offsetY)) {
      style.cursor = 'ew-resize';
    } else if (maxHandle.containsPoint(offsetX, offsetY)) {
      style.cursor = 'ew-resize';
    } else if (visibleRange.containsPoint(offsetX, offsetY)) {
      style.cursor = 'grab';
    } else {
      style.cursor = 'default';
    }
    if (this.minHandleDragging) {
      rs.min = getRatio();
    } else if (this.maxHandleDragging) {
      rs.max = getRatio();
    } else if (!isNaN(panHandleOffset)) {
      var span = rs.max - rs.min;
      var min = Math.min(getRatio() - panHandleOffset, 1 - span);
      if (min <= rs.min) {
        // pan left
        rs.min = min;
        rs.max = rs.min + span;
      } else {
        // pan right
        rs.max = min + span;
        rs.min = rs.max - span;
      }
    }
  };
  Navigator.prototype.onDragStop = function () {
    this.stopHandleDragging();
  };
  Navigator.prototype.stopHandleDragging = function () {
    this.minHandleDragging = this.maxHandleDragging = false;
    this.panHandleOffset = NaN;
  };
  return Navigator;
}();
var __extends$3$ = undefined && undefined.__extends || function () {
  var _extendStatics264 = function extendStatics(d, b) {
    _extendStatics264 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics264(d, b);
  };
  return function (d, b) {
    _extendStatics264(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CartesianChart = /** @class */function (_super) {
  __extends$3$(CartesianChart, _super);
  function CartesianChart(document) {
    if (document === void 0) {
      document = window.document;
    }
    var _this = _super.call(this, document) || this;
    _this._seriesRoot = new ClipRect();
    _this.navigator = new Navigator(_this);
    // Prevent the scene from rendering chart components in an invalid state
    // (before first layout is performed).
    _this.scene.root.visible = false;
    var root = _this.scene.root;
    root.append(_this.seriesRoot);
    root.append(_this.legend.group);
    _this.navigator.enabled = false;
    return _this;
  }
  Object.defineProperty(CartesianChart.prototype, "seriesRoot", {
    get: function get() {
      return this._seriesRoot;
    },
    enumerable: true,
    configurable: true
  });
  CartesianChart.prototype.performLayout = function () {
    if (this.dataPending) {
      return;
    }
    this.scene.root.visible = true;
    var _a = this,
      width = _a.width,
      height = _a.height,
      axes = _a.axes,
      legend = _a.legend,
      navigator = _a.navigator;
    var shrinkRect = new BBox(0, 0, width, height);
    this.positionCaptions();
    this.positionLegend();
    if (legend.enabled && legend.data.length) {
      var legendAutoPadding = this.legendAutoPadding;
      var legendPadding = this.legend.spacing;
      shrinkRect.x += legendAutoPadding.left;
      shrinkRect.y += legendAutoPadding.top;
      shrinkRect.width -= legendAutoPadding.left + legendAutoPadding.right;
      shrinkRect.height -= legendAutoPadding.top + legendAutoPadding.bottom;
      switch (this.legend.position) {
        case 'right':
          shrinkRect.width -= legendPadding;
          break;
        case 'bottom':
          shrinkRect.height -= legendPadding;
          break;
        case 'left':
          shrinkRect.x += legendPadding;
          shrinkRect.width -= legendPadding;
          break;
        case 'top':
          shrinkRect.y += legendPadding;
          shrinkRect.height -= legendPadding;
          break;
      }
    }
    var _b = this,
      captionAutoPadding = _b.captionAutoPadding,
      padding = _b.padding;
    this.updateAxes();
    shrinkRect.x += padding.left;
    shrinkRect.width -= padding.left + padding.right;
    shrinkRect.y += padding.top + captionAutoPadding;
    shrinkRect.height -= padding.top + captionAutoPadding + padding.bottom;
    if (navigator.enabled) {
      shrinkRect.height -= navigator.height + navigator.margin;
    }
    var bottomAxesHeight = 0;
    axes.forEach(function (axis) {
      axis.group.visible = true;
      var axisThickness = Math.floor(axis.thickness || axis.computeBBox().width);
      switch (axis.position) {
        case ChartAxisPosition.Top:
          shrinkRect.y += axisThickness;
          shrinkRect.height -= axisThickness;
          axis.translation.y = Math.floor(shrinkRect.y + 1);
          axis.label.mirrored = true;
          break;
        case ChartAxisPosition.Right:
          shrinkRect.width -= axisThickness;
          axis.translation.x = Math.floor(shrinkRect.x + shrinkRect.width);
          axis.label.mirrored = true;
          break;
        case ChartAxisPosition.Bottom:
          shrinkRect.height -= axisThickness;
          bottomAxesHeight += axisThickness;
          axis.translation.y = Math.floor(shrinkRect.y + shrinkRect.height + 1);
          break;
        case ChartAxisPosition.Left:
          shrinkRect.x += axisThickness;
          shrinkRect.width -= axisThickness;
          axis.translation.x = Math.floor(shrinkRect.x);
          break;
      }
    });
    axes.forEach(function (axis) {
      switch (axis.position) {
        case ChartAxisPosition.Top:
        case ChartAxisPosition.Bottom:
          axis.translation.x = Math.floor(shrinkRect.x);
          axis.range = [0, shrinkRect.width];
          axis.gridLength = shrinkRect.height;
          break;
        case ChartAxisPosition.Left:
        case ChartAxisPosition.Right:
          axis.translation.y = Math.floor(shrinkRect.y);
          if (axis instanceof CategoryAxis || axis instanceof GroupedCategoryAxis) {
            axis.range = [0, shrinkRect.height];
          } else {
            axis.range = [shrinkRect.height, 0];
          }
          axis.gridLength = shrinkRect.width;
          break;
      }
    });
    this.createNodeData();
    this.seriesRect = shrinkRect;
    this.series.forEach(function (series) {
      series.group.translationX = Math.floor(shrinkRect.x);
      series.group.translationY = Math.floor(shrinkRect.y);
      series.update(); // this has to happen after the `updateAxes` call
    });

    var seriesRoot = this.seriesRoot;
    seriesRoot.x = shrinkRect.x;
    seriesRoot.y = shrinkRect.y;
    seriesRoot.width = shrinkRect.width;
    seriesRoot.height = shrinkRect.height;
    if (navigator.enabled) {
      navigator.x = shrinkRect.x;
      navigator.y = shrinkRect.y + shrinkRect.height + bottomAxesHeight + navigator.margin;
      navigator.width = shrinkRect.width;
    }
    this.axes.forEach(function (axis) {
      return axis.update();
    });
  };
  CartesianChart.prototype.initSeries = function (series) {
    _super.prototype.initSeries.call(this, series);
    series.addEventListener('dataProcessed', this.updateAxes, this);
  };
  CartesianChart.prototype.freeSeries = function (series) {
    _super.prototype.freeSeries.call(this, series);
    series.removeEventListener('dataProcessed', this.updateAxes, this);
  };
  CartesianChart.prototype.setupDomListeners = function (chartElement) {
    _super.prototype.setupDomListeners.call(this, chartElement);
    this._onTouchStart = this.onTouchStart.bind(this);
    this._onTouchMove = this.onTouchMove.bind(this);
    this._onTouchEnd = this.onTouchEnd.bind(this);
    this._onTouchCancel = this.onTouchCancel.bind(this);
    chartElement.addEventListener('touchstart', this._onTouchStart);
    chartElement.addEventListener('touchmove', this._onTouchMove);
    chartElement.addEventListener('touchend', this._onTouchEnd);
    chartElement.addEventListener('touchcancel', this._onTouchCancel);
  };
  CartesianChart.prototype.cleanupDomListeners = function (chartElement) {
    _super.prototype.cleanupDomListeners.call(this, chartElement);
    chartElement.removeEventListener('touchstart', this._onTouchStart);
    chartElement.removeEventListener('touchmove', this._onTouchMove);
    chartElement.removeEventListener('touchend', this._onTouchEnd);
    chartElement.removeEventListener('touchcancel', this._onTouchCancel);
  };
  CartesianChart.prototype.getTouchOffset = function (event) {
    var rect = this.scene.canvas.element.getBoundingClientRect();
    var touch = event.touches[0];
    return touch ? {
      offsetX: touch.clientX - rect.left,
      offsetY: touch.clientY - rect.top
    } : undefined;
  };
  CartesianChart.prototype.onTouchStart = function (event) {
    var offset = this.getTouchOffset(event);
    if (offset) {
      this.navigator.onDragStart(offset);
    }
  };
  CartesianChart.prototype.onTouchMove = function (event) {
    var offset = this.getTouchOffset(event);
    if (offset) {
      this.navigator.onDrag(offset);
    }
  };
  CartesianChart.prototype.onTouchEnd = function (event) {
    this.navigator.onDragStop();
  };
  CartesianChart.prototype.onTouchCancel = function (event) {
    this.navigator.onDragStop();
  };
  CartesianChart.prototype.onMouseDown = function (event) {
    _super.prototype.onMouseDown.call(this, event);
    this.navigator.onDragStart(event);
  };
  CartesianChart.prototype.onMouseMove = function (event) {
    _super.prototype.onMouseMove.call(this, event);
    this.navigator.onDrag(event);
  };
  CartesianChart.prototype.onMouseUp = function (event) {
    _super.prototype.onMouseUp.call(this, event);
    this.navigator.onDragStop();
  };
  CartesianChart.prototype.onMouseOut = function (event) {
    _super.prototype.onMouseOut.call(this, event);
    this.navigator.onDragStop();
  };
  CartesianChart.prototype.assignAxesToSeries = function (force) {
    if (force === void 0) {
      force = false;
    }
    _super.prototype.assignAxesToSeries.call(this, force);
    this.series.forEach(function (series) {
      if (!series.xAxis) {
        console.warn("Could not find a matching xAxis for the " + series.id + " series.");
      }
      if (!series.yAxis) {
        console.warn("Could not find a matching yAxis for the " + series.id + " series.");
      }
    });
  };
  CartesianChart.prototype.updateAxes = function () {
    var navigator = this.navigator;
    var clipSeries = false;
    this.axes.forEach(function (axis) {
      var _a;
      var direction = axis.direction,
        boundSeries = axis.boundSeries;
      if (axis.linkedTo) {
        axis.domain = axis.linkedTo.domain;
      } else {
        var domains_1 = [];
        boundSeries.filter(function (s) {
          return s.visible;
        }).forEach(function (series) {
          domains_1.push(series.getDomain(direction));
        });
        axis.domain = (_a = new Array()).concat.apply(_a, domains_1);
      }
      if (axis.direction === ChartAxisDirection.X) {
        axis.visibleRange = [navigator.min, navigator.max];
      }
      if (!clipSeries && (axis.visibleRange[0] > 0 || axis.visibleRange[1] < 1)) {
        clipSeries = true;
      }
      axis.update();
    });
    this.seriesRoot.enabled = clipSeries;
  };
  CartesianChart.className = 'CartesianChart';
  CartesianChart.type = 'cartesian';
  return CartesianChart;
}(Chart);
var __extends$40 = undefined && undefined.__extends || function () {
  var _extendStatics265 = function extendStatics(d, b) {
    _extendStatics265 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics265(d, b);
  };
  return function (d, b) {
    _extendStatics265(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var HierarchyChart = /** @class */function (_super) {
  __extends$40(HierarchyChart, _super);
  function HierarchyChart(document) {
    if (document === void 0) {
      document = window.document;
    }
    var _this = _super.call(this, document) || this;
    _this._data = {};
    _this._seriesRoot = new ClipRect();
    // Prevent the scene from rendering chart components in an invalid state
    // (before first layout is performed).
    _this.scene.root.visible = false;
    var root = _this.scene.root;
    root.append(_this.seriesRoot);
    root.append(_this.legend.group);
    return _this;
  }
  Object.defineProperty(HierarchyChart.prototype, "seriesRoot", {
    get: function get() {
      return this._seriesRoot;
    },
    enumerable: true,
    configurable: true
  });
  HierarchyChart.prototype.performLayout = function () {
    if (this.dataPending) {
      return;
    }
    this.scene.root.visible = true;
    var _a = this,
      width = _a.width,
      height = _a.height,
      legend = _a.legend;
    var shrinkRect = new BBox(0, 0, width, height);
    this.positionCaptions();
    this.positionLegend();
    if (legend.enabled && legend.data.length) {
      var legendAutoPadding = this.legendAutoPadding;
      var legendPadding = this.legend.spacing;
      shrinkRect.x += legendAutoPadding.left;
      shrinkRect.y += legendAutoPadding.top;
      shrinkRect.width -= legendAutoPadding.left + legendAutoPadding.right;
      shrinkRect.height -= legendAutoPadding.top + legendAutoPadding.bottom;
      switch (this.legend.position) {
        case 'right':
          shrinkRect.width -= legendPadding;
          break;
        case 'bottom':
          shrinkRect.height -= legendPadding;
          break;
        case 'left':
          shrinkRect.x += legendPadding;
          shrinkRect.width -= legendPadding;
          break;
        case 'top':
          shrinkRect.y += legendPadding;
          shrinkRect.height -= legendPadding;
          break;
      }
    }
    var _b = this,
      captionAutoPadding = _b.captionAutoPadding,
      padding = _b.padding;
    shrinkRect.x += padding.left;
    shrinkRect.width -= padding.left + padding.right;
    shrinkRect.y += padding.top + captionAutoPadding;
    shrinkRect.height -= padding.top + captionAutoPadding + padding.bottom;
    this.seriesRect = shrinkRect;
    this.series.forEach(function (series) {
      series.group.translationX = Math.floor(shrinkRect.x);
      series.group.translationY = Math.floor(shrinkRect.y);
      series.update(); // this has to happen after the `updateAxes` call
    });

    var seriesRoot = this.seriesRoot;
    seriesRoot.x = shrinkRect.x;
    seriesRoot.y = shrinkRect.y;
    seriesRoot.width = shrinkRect.width;
    seriesRoot.height = shrinkRect.height;
  };
  HierarchyChart.className = 'HierarchyChart';
  HierarchyChart.type = 'hierarchy';
  return HierarchyChart;
}(Chart);
var __extends$41 = undefined && undefined.__extends || function () {
  var _extendStatics266 = function extendStatics(d, b) {
    _extendStatics266 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics266(d, b);
  };
  return function (d, b) {
    _extendStatics266(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var GroupedCategoryChart = /** @class */function (_super) {
  __extends$41(GroupedCategoryChart, _super);
  function GroupedCategoryChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GroupedCategoryChart.prototype.updateAxes = function () {
    this.axes.forEach(function (axis) {
      var _a;
      var direction = axis.direction,
        boundSeries = axis.boundSeries;
      var domains = [];
      var isNumericX = undefined;
      boundSeries.filter(function (s) {
        return s.visible;
      }).forEach(function (series) {
        if (direction === ChartAxisDirection.X) {
          if (isNumericX === undefined) {
            // always add first X domain
            var domain_1 = series.getDomain(direction);
            domains.push(domain_1);
            isNumericX = typeof domain_1[0] === 'number';
          } else if (isNumericX) {
            // only add further X domains if the axis is numeric
            domains.push(series.getDomain(direction));
          }
        } else {
          domains.push(series.getDomain(direction));
        }
      });
      var domain = (_a = new Array()).concat.apply(_a, domains);
      axis.domain = extent(domain, isContinuous) || domain;
      axis.update();
    });
  };
  GroupedCategoryChart.className = 'GroupedCategoryChart';
  GroupedCategoryChart.type = 'groupedCategory';
  return GroupedCategoryChart;
}(CartesianChart);
var __extends$42 = undefined && undefined.__extends || function () {
  var _extendStatics267 = function extendStatics(d, b) {
    _extendStatics267 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics267(d, b);
  };
  return function (d, b) {
    _extendStatics267(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$39 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Label = /** @class */function (_super) {
  __extends$42(Label, _super);
  function Label() {
    var _this = _super.call(this) || this;
    _this.enabled = true;
    _this.fontSize = 12;
    _this.fontFamily = 'Verdana, sans-serif';
    _this.color = 'rgba(70, 70, 70, 1)';
    return _this;
  }
  Label.prototype.getFont = function () {
    return getFont$1(this.fontSize, this.fontFamily, this.fontStyle, this.fontWeight);
  };
  __decorate$39([reactive('change', 'dataChange')], Label.prototype, "enabled", void 0);
  __decorate$39([reactive('change')], Label.prototype, "fontSize", void 0);
  __decorate$39([reactive('change')], Label.prototype, "fontFamily", void 0);
  __decorate$39([reactive('change')], Label.prototype, "fontStyle", void 0);
  __decorate$39([reactive('change')], Label.prototype, "fontWeight", void 0);
  __decorate$39([reactive('change')], Label.prototype, "color", void 0);
  return Label;
}(Observable);
var __extends$43 = undefined && undefined.__extends || function () {
  var _extendStatics268 = function extendStatics(d, b) {
    _extendStatics268 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics268(d, b);
  };
  return function (d, b) {
    _extendStatics268(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SeriesItemHighlightStyle = /** @class */function () {
  function SeriesItemHighlightStyle() {
    this.fill = 'yellow';
  }
  return SeriesItemHighlightStyle;
}();
var SeriesHighlightStyle = /** @class */function () {
  function SeriesHighlightStyle() {}
  return SeriesHighlightStyle;
}();
var HighlightStyle = /** @class */function () {
  function HighlightStyle() {
    this.item = new SeriesItemHighlightStyle();
    this.series = new SeriesHighlightStyle();
  }
  return HighlightStyle;
}();
var SeriesTooltip = /** @class */function (_super) {
  __extends$43(SeriesTooltip, _super);
  function SeriesTooltip() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.enabled = true;
    return _this;
  }
  __decorate$3a([reactive('change')], SeriesTooltip.prototype, "enabled", void 0);
  return SeriesTooltip;
}(Observable);
var Series = /** @class */function (_super) {
  __extends$43(Series, _super);
  function Series() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.id = createId(_this);
    // The group node that contains all the nodes used to render this series.
    _this.group = new Group();
    // The group node that contains all the nodes that can be "picked" (react to hover, tap, click).
    _this.pickGroup = _this.group.appendChild(new Group());
    _this.directions = [ChartAxisDirection.X, ChartAxisDirection.Y];
    _this.directionKeys = {};
    _this.label = new Label();
    _this.data = undefined;
    _this.visible = true;
    _this.showInLegend = true;
    _this.cursor = 'default';
    _this._nodeDataPending = true;
    _this._updatePending = false;
    _this.highlightStyle = new HighlightStyle();
    _this.scheduleLayout = function () {
      _this.fireEvent({
        type: 'layoutChange'
      });
    };
    _this.scheduleData = function () {
      _this.fireEvent({
        type: 'dataChange'
      });
    };
    return _this;
  }
  Object.defineProperty(Series.prototype, "type", {
    get: function get() {
      return this.constructor.type || '';
    },
    enumerable: true,
    configurable: true
  });
  Series.prototype.setColors = function (fills, strokes) {};
  // Returns the actual keys used (to fetch the values from `data` items) for the given direction.
  Series.prototype.getKeys = function (direction) {
    var _this = this;
    var directionKeys = this.directionKeys;
    var keys = directionKeys && directionKeys[direction];
    var values = [];
    if (keys) {
      keys.forEach(function (key) {
        var value = _this[key];
        if (value) {
          if (Array.isArray(value)) {
            values.push.apply(values, value);
          } else {
            values.push(value);
          }
        }
      });
    }
    return values;
  };
  // Using processed data, create data that backs visible nodes.
  Series.prototype.createNodeData = function () {
    return [];
  };
  // Returns persisted node data associated with the rendered portion of the series' data.
  Series.prototype.getNodeData = function () {
    return [];
  };
  Series.prototype.getLabelData = function () {
    return [];
  };
  Object.defineProperty(Series.prototype, "nodeDataPending", {
    get: function get() {
      return this._nodeDataPending;
    },
    set: function set(value) {
      if (this._nodeDataPending !== value) {
        this._nodeDataPending = value;
        this.updatePending = true;
        if (value && this.chart) {
          this.chart.updatePending = value;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Series.prototype.scheduleNodeDate = function () {
    this.nodeDataPending = true;
  };
  Object.defineProperty(Series.prototype, "updatePending", {
    get: function get() {
      return this._updatePending;
    },
    set: function set(value) {
      if (this._updatePending !== value) {
        this._updatePending = value;
        if (value && this.chart) {
          this.chart.updatePending = value;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Series.prototype.scheduleUpdate = function () {
    this.updatePending = true;
  };
  Series.prototype.getOpacity = function (datum) {
    var _a = this,
      chart = _a.chart,
      _b = _a.highlightStyle.series.dimOpacity,
      dimOpacity = _b === void 0 ? 1 : _b;
    return !chart || !chart.highlightedDatum || chart.highlightedDatum.series === this && (!datum || chart.highlightedDatum.itemId === datum.itemId) ? 1 : dimOpacity;
  };
  Series.prototype.getStrokeWidth = function (defaultStrokeWidth, datum) {
    var _a = this,
      chart = _a.chart,
      strokeWidth = _a.highlightStyle.series.strokeWidth;
    return chart && chart.highlightedDatum && chart.highlightedDatum.series === this && (!datum || chart.highlightedDatum.itemId === datum.itemId) && strokeWidth !== undefined ? strokeWidth : defaultStrokeWidth;
  };
  Series.prototype.fireNodeClickEvent = function (event, datum) {};
  Series.prototype.toggleSeriesItem = function (itemId, enabled) {
    this.visible = enabled;
  };
  // Each series is expected to have its own logic to efficiently update its nodes
  // on hightlight changes.
  Series.prototype.onHighlightChange = function () {};
  Series.prototype.fixNumericExtent = function (extent, type) {
    if (!extent) {
      // if (type) {
      //     console.warn(`The ${type}-domain could not be found (no valid values), using the default of [0, 1].`);
      // }
      return [0, 1];
    }
    var min = extent[0],
      max = extent[1];
    min = +min;
    max = +max;
    if (min === max) {
      var padding = Math.abs(min * 0.01);
      min -= padding;
      max += padding;
      // if (type) {
      //     console.warn(`The ${type}-domain has zero length and has been automatically expanded`
      //         + ` by 1 in each direction (from the single valid ${type}-value: ${min}).`);
      // }
    }

    if (!(isNumber(min) && isNumber(max))) {
      min = 0;
      max = 1;
      // if (type) {
      //     console.warn(`The ${type}-domain has infinite length, using the default of [0, 1].`);
      // }
    }

    return [min, max];
  };
  Series.highlightedZIndex = 1000000000000;
  __decorate$3a([reactive('dataChange')], Series.prototype, "data", void 0);
  __decorate$3a([reactive('dataChange')], Series.prototype, "visible", void 0);
  __decorate$3a([reactive('layoutChange')], Series.prototype, "showInLegend", void 0);
  return Series;
}(Observable);
var __extends$44 = undefined && undefined.__extends || function () {
  var _extendStatics269 = function extendStatics(d, b) {
    _extendStatics269 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics269(d, b);
  };
  return function (d, b) {
    _extendStatics269(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3b = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SeriesMarker = /** @class */function (_super) {
  __extends$44(SeriesMarker, _super);
  function SeriesMarker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.enabled = true;
    /**
     * One of the predefined marker names, or a marker constructor function (for user-defined markers).
     * A series will create one marker instance per data point.
     */
    _this.shape = Circle;
    _this.size = 6;
    /**
     * In case a series has the `sizeKey` set, the `sizeKey` values along with the `size` and `maxSize` configs
     * will be used to determine the size of the marker. All values will be mapped to a marker size
     * within the `[size, maxSize]` range, where the largest values will correspond to the `maxSize`
     * and the lowest to the `size`.
     */
    _this.maxSize = 30;
    _this.strokeWidth = 1;
    return _this;
  }
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "enabled", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "shape", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "size", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "maxSize", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "domain", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "fill", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "stroke", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "strokeWidth", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "fillOpacity", void 0);
  __decorate$3b([reactive('change')], SeriesMarker.prototype, "strokeOpacity", void 0);
  return SeriesMarker;
}(Observable);
var __extends$45 = undefined && undefined.__extends || function () {
  var _extendStatics270 = function extendStatics(d, b) {
    _extendStatics270 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics270(d, b);
  };
  return function (d, b) {
    _extendStatics270(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PolarSeries = /** @class */function (_super) {
  __extends$45(PolarSeries, _super);
  function PolarSeries() {
    var _a;
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.directionKeys = (_a = {}, _a[ChartAxisDirection.X] = ['angleKey'], _a[ChartAxisDirection.Y] = ['radiusKey'], _a);
    /**
     * The center of the polar series (for example, the center of a pie).
     * If the polar chart has multiple series, all of them will have their
     * center set to the same value as a result of the polar chart layout.
     * The center coordinates are not supposed to be set by the user.
     */
    _this.centerX = 0;
    _this.centerY = 0;
    /**
     * The maximum radius the series can use.
     * This value is set automatically as a result of the polar chart layout
     * and is not supposed to be set by the user.
     */
    _this.radius = 0;
    return _this;
  }
  return PolarSeries;
}(Series);
var PolarSeriesMarker = /** @class */function (_super) {
  __extends$45(PolarSeriesMarker, _super);
  function PolarSeriesMarker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return PolarSeriesMarker;
}(SeriesMarker);
var __extends$46 = undefined && undefined.__extends || function () {
  var _extendStatics271 = function extendStatics(d, b) {
    _extendStatics271 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics271(d, b);
  };
  return function (d, b) {
    _extendStatics271(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PolarChart = /** @class */function (_super) {
  __extends$46(PolarChart, _super);
  function PolarChart(document) {
    if (document === void 0) {
      document = window.document;
    }
    var _this = _super.call(this, document) || this;
    _this.padding = new Padding(40);
    _this.scene.root.append(_this.legend.group);
    _this.padding.addEventListener('layoutChange', _this.scheduleLayout, _this);
    return _this;
  }
  Object.defineProperty(PolarChart.prototype, "seriesRoot", {
    get: function get() {
      return this.scene.root;
    },
    enumerable: true,
    configurable: true
  });
  PolarChart.prototype.performLayout = function () {
    var shrinkRect = new BBox(0, 0, this.width, this.height);
    this.positionCaptions();
    this.positionLegend();
    var captionAutoPadding = this.captionAutoPadding;
    shrinkRect.y += captionAutoPadding;
    shrinkRect.height -= captionAutoPadding;
    if (this.legend.enabled && this.legend.data.length) {
      var legendAutoPadding = this.legendAutoPadding;
      shrinkRect.x += legendAutoPadding.left;
      shrinkRect.y += legendAutoPadding.top;
      shrinkRect.width -= legendAutoPadding.left + legendAutoPadding.right;
      shrinkRect.height -= legendAutoPadding.top + legendAutoPadding.bottom;
      var legendPadding = this.legend.spacing;
      switch (this.legend.position) {
        case 'right':
          shrinkRect.width -= legendPadding;
          break;
        case 'bottom':
          shrinkRect.height -= legendPadding;
          break;
        case 'left':
          shrinkRect.x += legendPadding;
          shrinkRect.width -= legendPadding;
          break;
        case 'top':
          shrinkRect.y += legendPadding;
          shrinkRect.height -= legendPadding;
          break;
      }
    }
    var padding = this.padding;
    shrinkRect.x += padding.left;
    shrinkRect.y += padding.top;
    shrinkRect.width -= padding.left + padding.right;
    shrinkRect.height -= padding.top + padding.bottom;
    this.seriesRect = shrinkRect;
    var centerX = shrinkRect.x + shrinkRect.width / 2;
    var centerY = shrinkRect.y + shrinkRect.height / 2;
    var radius = Math.min(shrinkRect.width, shrinkRect.height) / 2;
    this.series.forEach(function (series) {
      if (series instanceof PolarSeries) {
        series.centerX = centerX;
        series.centerY = centerY;
        series.radius = radius;
        series.update();
      }
    });
  };
  PolarChart.className = 'PolarChart';
  PolarChart.type = 'polar';
  return PolarChart;
}(Chart);
var __extends$47 = undefined && undefined.__extends || function () {
  var _extendStatics272 = function extendStatics(d, b) {
    _extendStatics272 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics272(d, b);
  };
  return function (d, b) {
    _extendStatics272(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CartesianSeries = /** @class */function (_super) {
  __extends$47(CartesianSeries, _super);
  function CartesianSeries() {
    var _a;
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.directionKeys = (_a = {}, _a[ChartAxisDirection.X] = ['xKey'], _a[ChartAxisDirection.Y] = ['yKey'], _a);
    return _this;
  }
  /**
   * Note: we are passing `isContinuousX` and `isContinuousY` into this method because it will
   *       typically be called inside a loop and this check only needs to happen once.
   * @param x A domain value to be plotted along the x-axis.
   * @param y A domain value to be plotted along the y-axis.
   * @param isContinuousX Typically this will be the value of `xAxis.scale instanceof ContinuousScale`.
   * @param isContinuousY Typically this will be the value of `yAxis.scale instanceof ContinuousScale`.
   * @returns `[x, y]`, if both x and y are valid domain values for their respective axes/scales, or `undefined`.
   */
  CartesianSeries.prototype.checkDomainXY = function (x, y, isContinuousX, isContinuousY) {
    var isValidDatum = (isContinuousX && isContinuous(x) || isDiscrete(x)) && (isContinuousY && isContinuous(y) || isDiscrete(y));
    return isValidDatum ? [x, y] : undefined;
  };
  /**
   * Note: we are passing the xAxis and yAxis because the calling code is supposed to make sure
   *       that series has both of them defined, and also to avoid one level of indirection,
   *       e.g. `this.xAxis!.inRange(x)`, both of which are suboptimal in tight loops where this method is used.
   * @param x A range value to be plotted along the x-axis.
   * @param y A range value to be plotted along the y-axis.
   * @param xAxis The series' x-axis.
   * @param yAxis The series' y-axis.
   * @returns
   */
  CartesianSeries.prototype.checkRangeXY = function (x, y, xAxis, yAxis) {
    return !isNaN(x) && !isNaN(y) && xAxis.inRange(x) && yAxis.inRange(y);
  };
  return CartesianSeries;
}(Series);
var CartesianSeriesMarker = /** @class */function (_super) {
  __extends$47(CartesianSeriesMarker, _super);
  function CartesianSeriesMarker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return CartesianSeriesMarker;
}(SeriesMarker);
function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length_1,
      i = void 0;
    if (Array.isArray(a)) {
      length_1 = a.length;
      if (length_1 != b.length) return false;
      for (i = length_1; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    // if ((a instanceof Map) && (b instanceof Map)) {
    //     if (a.size !== b.size) return false;
    //     for (i of a.entries())
    //         if (!b.has(i[0])) return false;
    //     for (i of a.entries())
    //         if (!equal(i[1], b.get(i[0]))) return false;
    //     return true;
    // }
    //
    // if ((a instanceof Set) && (b instanceof Set)) {
    //     if (a.size !== b.size) return false;
    //     for (i of a.entries())
    //         if (!b.has(i[0])) return false;
    //     return true;
    // }
    //
    // if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
    //     length = a.length;
    //     if (length != b.length) return false;
    //     for (i = length; i-- !== 0;)
    //         if (a[i] !== b[i]) return false;
    //     return true;
    // }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    var keys = Object.keys(a);
    length_1 = keys.length;
    if (length_1 !== Object.keys(b).length) return false;
    for (i = length_1; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length_1; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }
    return true;
  }
  // true if both NaN, false otherwise
  return a !== a && b !== b;
}
var interpolatePattern = /(#\{(.*?)\})/g;
function interpolate(input, values, formats) {
  return input.replace(interpolatePattern, function () {
    var name = arguments[2];
    var _a = name.split(':'),
      valueName = _a[0],
      formatName = _a[1];
    var value = values[valueName];
    if (typeof value === 'number') {
      var format = formatName && formats && formats[formatName];
      if (format) {
        var _b = format,
          locales = _b.locales,
          options = _b.options;
        return value.toLocaleString(locales, options);
      }
      return String(value);
    }
    if (value instanceof Date) {
      var format = formatName && formats && formats[formatName];
      if (typeof format === 'string') {
        var formatter = locale.format(format);
        return formatter(value);
      }
      return value.toDateString();
    }
    if (typeof value === 'string' || value && value.toString) {
      return String(value);
    }
    return '';
  });
}
var element = null;
function sanitizeHtml(text) {
  element = element || document.createElement('div');
  if (!text) {
    return '';
  }
  element.innerText = text;
  return element.innerHTML;
}
var __extends$48 = undefined && undefined.__extends || function () {
  var _extendStatics273 = function extendStatics(d, b) {
    _extendStatics273 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics273(d, b);
  };
  return function (d, b) {
    _extendStatics273(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3c = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AreaSeriesLabel = /** @class */function (_super) {
  __extends$48(AreaSeriesLabel, _super);
  function AreaSeriesLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3c([reactive('change')], AreaSeriesLabel.prototype, "formatter", void 0);
  return AreaSeriesLabel;
}(Label);
var AreaSeriesTooltip = /** @class */function (_super) {
  __extends$48(AreaSeriesTooltip, _super);
  function AreaSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3c([reactive('change')], AreaSeriesTooltip.prototype, "renderer", void 0);
  __decorate$3c([reactive('change')], AreaSeriesTooltip.prototype, "format", void 0);
  return AreaSeriesTooltip;
}(SeriesTooltip);
var AreaSeries = /** @class */function (_super) {
  __extends$48(AreaSeries, _super);
  function AreaSeries() {
    var _this = _super.call(this) || this;
    _this.tooltip = new AreaSeriesTooltip();
    _this.areaGroup = _this.group.insertBefore(new Group(), _this.pickGroup);
    _this.strokeGroup = _this.group.insertBefore(new Group(), _this.pickGroup);
    _this.markerGroup = _this.pickGroup.appendChild(new Group());
    _this.labelGroup = _this.group.appendChild(new Group());
    _this.fillSelection = Selection.select(_this.areaGroup).selectAll();
    _this.strokeSelection = Selection.select(_this.strokeGroup).selectAll();
    _this.markerSelection = Selection.select(_this.markerGroup).selectAll();
    _this.labelSelection = Selection.select(_this.labelGroup).selectAll();
    /**
     * The assumption is that the values will be reset (to `true`)
     * in the {@link yKeys} setter.
     */
    _this.seriesItemEnabled = new Map();
    _this.xData = [];
    _this.yData = [];
    _this.areaSelectionData = [];
    _this.markerSelectionData = [];
    _this.labelSelectionData = [];
    _this.yDomain = [];
    _this.directionKeys = {
      x: ['xKey'],
      y: ['yKeys']
    };
    _this.marker = new CartesianSeriesMarker();
    _this.label = new AreaSeriesLabel();
    _this.fills = ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'];
    _this.strokes = ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'];
    _this.fillOpacity = 1;
    _this.strokeOpacity = 1;
    _this.lineDash = [0];
    _this.lineDashOffset = 0;
    _this._xKey = '';
    _this.xName = '';
    _this._yKeys = [];
    _this.yNames = [];
    _this.strokeWidth = 2;
    _this.addEventListener('update', _this.scheduleUpdate);
    var _a = _this,
      marker = _a.marker,
      label = _a.label;
    marker.enabled = false;
    marker.addPropertyListener('shape', _this.onMarkerShapeChange, _this);
    marker.addEventListener('change', _this.scheduleUpdate, _this);
    label.enabled = false;
    label.addEventListener('change', _this.scheduleUpdate, _this);
    return _this;
  }
  AreaSeries.prototype.onMarkerShapeChange = function () {
    this.markerSelection = this.markerSelection.setData([]);
    this.markerSelection.exit.remove();
    this.fireEvent({
      type: 'legendChange'
    });
  };
  Object.defineProperty(AreaSeries.prototype, "xKey", {
    get: function get() {
      return this._xKey;
    },
    set: function set(value) {
      if (this._xKey !== value) {
        this._xKey = value;
        this.xData = [];
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AreaSeries.prototype, "yKeys", {
    get: function get() {
      return this._yKeys;
    },
    set: function set(values) {
      if (!equal(this._yKeys, values)) {
        this._yKeys = values;
        this.yData = [];
        var seriesItemEnabled_1 = this.seriesItemEnabled;
        seriesItemEnabled_1.clear();
        values.forEach(function (key) {
          return seriesItemEnabled_1.set(key, true);
        });
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  AreaSeries.prototype.setColors = function (fills, strokes) {
    this.fills = fills;
    this.strokes = strokes;
  };
  Object.defineProperty(AreaSeries.prototype, "normalizedTo", {
    get: function get() {
      return this._normalizedTo;
    },
    set: function set(value) {
      var absValue = value ? Math.abs(value) : undefined;
      if (this._normalizedTo !== absValue) {
        this._normalizedTo = absValue;
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  AreaSeries.prototype.processData = function () {
    var _a = this,
      xKey = _a.xKey,
      yKeys = _a.yKeys,
      seriesItemEnabled = _a.seriesItemEnabled;
    var data = xKey && yKeys.length && this.data ? this.data : [];
    // If the data is an array of rows like so:
    //
    // [{
    //   xKy: 'Jan',
    //   yKey1: 5,
    //   yKey2: 7,
    //   yKey3: -9,
    // }, {
    //   xKey: 'Feb',
    //   yKey1: 10,
    //   yKey2: -15,
    //   yKey3: 20
    // }]
    //
    var keysFound = true; // only warn once
    this.xData = data.map(function (datum) {
      if (keysFound && !(xKey in datum)) {
        keysFound = false;
        console.warn("The key '" + xKey + "' was not found in the data: ", datum);
      }
      return datum[xKey];
    });
    this.yData = data.map(function (datum) {
      return yKeys.map(function (yKey) {
        if (keysFound && !(yKey in datum)) {
          keysFound = false;
          console.warn("The key '" + yKey + "' was not found in the data: ", datum);
        }
        var value = datum[yKey];
        return isFinite(value) && seriesItemEnabled.get(yKey) ? value : 0;
      });
    });
    // xData: ['Jan', 'Feb']
    //
    // yData: [
    //   [5, 7, -9],
    //   [10, -15, 20]
    // ]
    var _b = this,
      yData = _b.yData,
      normalizedTo = _b.normalizedTo;
    var yMinMax = yData.map(function (values) {
      return findMinMax(values);
    }); // used for normalization
    var yLargestMinMax = this.findLargestMinMax(yMinMax);
    var yMin;
    var yMax;
    if (normalizedTo && isFinite(normalizedTo)) {
      yMin = yLargestMinMax.min < 0 ? -normalizedTo : 0;
      yMax = normalizedTo;
      yData.forEach(function (stack, i) {
        return stack.forEach(function (y, j) {
          if (y < 0) {
            stack[j] = -y / yMinMax[i].min * normalizedTo;
          } else {
            stack[j] = y / yMinMax[i].max * normalizedTo;
          }
        });
      });
    } else {
      yMin = yLargestMinMax.min;
      yMax = yLargestMinMax.max;
    }
    if (yMin === 0 && yMax === 0) {
      yMax = 1;
    }
    this.yDomain = this.fixNumericExtent([yMin, yMax], 'y');
    this.fireEvent({
      type: 'dataProcessed'
    });
    return true;
  };
  AreaSeries.prototype.findLargestMinMax = function (totals) {
    var min = 0;
    var max = 0;
    for (var _i = 0, totals_1 = totals; _i < totals_1.length; _i++) {
      var total = totals_1[_i];
      if (total.min < min) {
        min = total.min;
      }
      if (total.max > max) {
        max = total.max;
      }
    }
    return {
      min: min,
      max: max
    };
  };
  AreaSeries.prototype.getDomain = function (direction) {
    if (direction === ChartAxisDirection.X) {
      return this.xData;
    } else {
      return this.yDomain;
    }
  };
  AreaSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  AreaSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    this.createSelectionData();
    this.updateFillSelection();
    this.updateStrokeSelection();
    this.updateMarkerSelection();
    this.updateLabelSelection();
  };
  AreaSeries.prototype.updateNodes = function () {
    this.group.visible = this.visible && this.xData.length > 0 && this.yData.length > 0;
    this.updateFillNodes();
    this.updateStrokeNodes();
    this.updateMarkerNodes();
    this.updateLabelNodes();
  };
  AreaSeries.prototype.createSelectionData = function () {
    var _this = this;
    var _a = this,
      data = _a.data,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis,
      xData = _a.xData,
      yData = _a.yData,
      areaSelectionData = _a.areaSelectionData,
      markerSelectionData = _a.markerSelectionData,
      labelSelectionData = _a.labelSelectionData;
    if (!data || !xAxis || !yAxis || !xData.length || !yData.length) {
      return;
    }
    var _b = this,
      yKeys = _b.yKeys,
      marker = _b.marker,
      label = _b.label,
      fills = _b.fills,
      strokes = _b.strokes;
    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var xOffset = (xScale.bandwidth || 0) / 2;
    var yOffset = (yScale.bandwidth || 0) / 2;
    var last = xData.length * 2 - 1;
    areaSelectionData.length = 0;
    markerSelectionData.length = 0;
    labelSelectionData.length = 0;
    xData.forEach(function (xDatum, i) {
      var yDatum = yData[i];
      var seriesDatum = data[i];
      var x = xScale.convert(xDatum) + xOffset;
      var prevMin = 0;
      var prevMax = 0;
      yDatum.forEach(function (curr, j) {
        var prev = curr < 0 ? prevMin : prevMax;
        var y = yScale.convert(prev + curr) + yOffset;
        var yKey = yKeys[j];
        var yValue = seriesDatum[yKey];
        if (marker) {
          markerSelectionData.push({
            index: i,
            series: _this,
            itemId: yKey,
            datum: seriesDatum,
            yValue: yValue,
            yKey: yKey,
            point: {
              x: x,
              y: y
            },
            fill: fills[j % fills.length],
            stroke: strokes[j % strokes.length]
          });
        }
        var labelText;
        if (label.formatter) {
          labelText = label.formatter({
            value: yValue
          });
        } else {
          labelText = isNumber(yValue) ? yValue.toFixed(2) : String(yValue);
        }
        if (label) {
          labelSelectionData.push({
            index: i,
            itemId: yKey,
            point: {
              x: x,
              y: y
            },
            label: labelText ? {
              text: labelText,
              fontStyle: label.fontStyle,
              fontWeight: label.fontWeight,
              fontSize: label.fontSize,
              fontFamily: label.fontFamily,
              textAlign: 'center',
              textBaseline: 'bottom',
              fill: label.color
            } : undefined
          });
        }
        var areaDatum = areaSelectionData[j] || (areaSelectionData[j] = {
          itemId: yKey,
          points: []
        });
        var areaPoints = areaDatum.points;
        areaPoints[i] = {
          x: x,
          y: y
        };
        areaPoints[last - i] = {
          x: x,
          y: yScale.convert(prev) + yOffset
        }; // bottom y
        if (curr < 0) {
          prevMin += curr;
        } else {
          prevMax += curr;
        }
      });
    });
  };
  AreaSeries.prototype.updateFillSelection = function () {
    var updateFills = this.fillSelection.setData(this.areaSelectionData);
    updateFills.exit.remove();
    var enterFills = updateFills.enter.append(Path).each(function (path) {
      path.lineJoin = 'round';
      path.stroke = undefined;
      path.pointerEvents = PointerEvents.None;
    });
    this.fillSelection = updateFills.merge(enterFills);
  };
  AreaSeries.prototype.updateFillNodes = function () {
    var _this = this;
    var _a = this,
      fills = _a.fills,
      fillOpacity = _a.fillOpacity,
      strokes = _a.strokes,
      strokeOpacity = _a.strokeOpacity,
      strokeWidth = _a.strokeWidth,
      shadow = _a.shadow,
      seriesItemEnabled = _a.seriesItemEnabled;
    this.fillSelection.each(function (shape, datum, index) {
      var path = shape.path;
      shape.fill = fills[index % fills.length];
      shape.fillOpacity = fillOpacity;
      shape.stroke = strokes[index % strokes.length];
      shape.strokeOpacity = strokeOpacity;
      shape.strokeWidth = strokeWidth;
      shape.lineDash = _this.lineDash;
      shape.lineDashOffset = _this.lineDashOffset;
      shape.fillShadow = shadow;
      shape.visible = !!seriesItemEnabled.get(datum.itemId);
      shape.opacity = _this.getOpacity(datum);
      path.clear();
      var points = datum.points;
      points.forEach(function (_a, i) {
        var x = _a.x,
          y = _a.y;
        if (i > 0) {
          path.lineTo(x, y);
        } else {
          path.moveTo(x, y);
        }
      });
      path.closePath();
    });
  };
  AreaSeries.prototype.updateStrokeSelection = function () {
    var updateStrokes = this.strokeSelection.setData(this.areaSelectionData);
    updateStrokes.exit.remove();
    var enterStrokes = updateStrokes.enter.append(Path).each(function (path) {
      path.fill = undefined;
      path.lineJoin = path.lineCap = 'round';
      path.pointerEvents = PointerEvents.None;
    });
    this.strokeSelection = updateStrokes.merge(enterStrokes);
  };
  AreaSeries.prototype.updateStrokeNodes = function () {
    var _this = this;
    if (!this.data) {
      return;
    }
    var _a = this,
      data = _a.data,
      strokes = _a.strokes,
      strokeOpacity = _a.strokeOpacity,
      seriesItemEnabled = _a.seriesItemEnabled;
    this.strokeSelection.each(function (shape, datum, index) {
      var path = shape.path;
      shape.visible = !!seriesItemEnabled.get(datum.itemId);
      shape.opacity = _this.getOpacity(datum);
      shape.stroke = strokes[index % strokes.length];
      shape.strokeWidth = _this.getStrokeWidth(_this.strokeWidth, datum);
      shape.strokeOpacity = strokeOpacity;
      shape.lineDash = _this.lineDash;
      shape.lineDashOffset = _this.lineDashOffset;
      path.clear();
      var points = datum.points;
      // The stroke doesn't go all the way around the fill, only on top,
      // that's why we iterate until `data.length` (rather than `points.length`) and stop.
      for (var i = 0; i < data.length; i++) {
        var _a = points[i],
          x = _a.x,
          y = _a.y;
        if (i > 0) {
          path.lineTo(x, y);
        } else {
          path.moveTo(x, y);
        }
      }
    });
  };
  AreaSeries.prototype.updateMarkerSelection = function () {
    var MarkerShape = getMarker(this.marker.shape);
    var data = MarkerShape ? this.markerSelectionData : [];
    var updateMarkers = this.markerSelection.setData(data);
    updateMarkers.exit.remove();
    var enterMarkers = updateMarkers.enter.append(MarkerShape);
    this.markerSelection = updateMarkers.merge(enterMarkers);
  };
  AreaSeries.prototype.updateMarkerNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      xKey = _a.xKey,
      marker = _a.marker,
      seriesItemEnabled = _a.seriesItemEnabled,
      yKeys = _a.yKeys,
      fills = _a.fills,
      strokes = _a.strokes,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    var size = marker.size,
      formatter = marker.formatter;
    var markerStrokeWidth = marker.strokeWidth !== undefined ? marker.strokeWidth : this.strokeWidth;
    this.markerSelection.each(function (node, datum) {
      var yKeyIndex = yKeys.indexOf(datum.yKey);
      var isDatumHighlighted = datum === highlightedDatum;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : marker.fill || fills[yKeyIndex % fills.length];
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : marker.stroke || strokes[yKeyIndex % fills.length];
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : markerStrokeWidth;
      var format = undefined;
      if (formatter) {
        format = formatter({
          datum: datum.datum,
          xKey: xKey,
          yKey: datum.yKey,
          fill: fill,
          stroke: stroke,
          strokeWidth: strokeWidth,
          size: size,
          highlighted: isDatumHighlighted
        });
      }
      node.fill = format && format.fill || fill;
      node.stroke = format && format.stroke || stroke;
      node.strokeWidth = format && format.strokeWidth !== undefined ? format.strokeWidth : strokeWidth;
      node.size = format && format.size !== undefined ? format.size : size;
      node.translationX = datum.point.x;
      node.translationY = datum.point.y;
      node.visible = marker.enabled && node.size > 0 && !!seriesItemEnabled.get(datum.yKey) && !isNaN(datum.point.x);
      node.opacity = _this.getOpacity(datum);
    });
  };
  AreaSeries.prototype.updateLabelSelection = function () {
    var updateLabels = this.labelSelection.setData(this.labelSelectionData);
    updateLabels.exit.remove();
    var enterLabels = updateLabels.enter.append(Text);
    this.labelSelection = updateLabels.merge(enterLabels);
  };
  AreaSeries.prototype.updateLabelNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this.label,
      labelEnabled = _a.enabled,
      fontStyle = _a.fontStyle,
      fontWeight = _a.fontWeight,
      fontSize = _a.fontSize,
      fontFamily = _a.fontFamily,
      color = _a.color;
    this.labelSelection.each(function (text, datum) {
      var point = datum.point,
        label = datum.label;
      if (label && labelEnabled) {
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.textAlign = label.textAlign;
        text.textBaseline = label.textBaseline;
        text.text = label.text;
        text.x = point.x;
        text.y = point.y - 10;
        text.fill = color;
        text.visible = true;
        text.opacity = _this.getOpacity(datum);
      } else {
        text.visible = false;
      }
    });
  };
  AreaSeries.prototype.getNodeData = function () {
    return this.markerSelectionData;
  };
  AreaSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      xKey: this.xKey,
      yKey: datum.yKey
    });
  };
  AreaSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var xKey = this.xKey;
    var yKey = nodeDatum.yKey;
    if (!(xKey && yKey)) {
      return '';
    }
    var datum = nodeDatum.datum;
    var xValue = datum[xKey];
    var yValue = datum[yKey];
    var _a = this,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!(xAxis && yAxis && isNumber(yValue))) {
      return '';
    }
    var x = xAxis.scale.convert(xValue);
    var y = yAxis.scale.convert(yValue);
    // Don't show the tooltip for the off-screen markers.
    // Node: some markers might still go off-screen despite virtual rendering
    //       (to connect the dots and render the area properly).
    if (!(xAxis.inRange(x) && yAxis.inRange(y))) {
      return '';
    }
    var _b = this,
      xName = _b.xName,
      yKeys = _b.yKeys,
      yNames = _b.yNames,
      yData = _b.yData,
      fills = _b.fills,
      strokes = _b.strokes,
      tooltip = _b.tooltip,
      marker = _b.marker;
    var size = marker.size,
      markerFormatter = marker.formatter,
      markerStrokeWidth = marker.strokeWidth,
      markerFill = marker.fill,
      markerStroke = marker.stroke;
    var xString = xAxis.formatDatum(xValue);
    var yString = yAxis.formatDatum(yValue);
    var yKeyIndex = yKeys.indexOf(yKey);
    var yGroup = yData[nodeDatum.index];
    var processedYValue = yGroup[yKeyIndex];
    var yName = yNames[yKeyIndex];
    var title = sanitizeHtml(yName);
    var content = sanitizeHtml(xString + ': ' + yString);
    var strokeWidth = markerStrokeWidth !== undefined ? markerStrokeWidth : this.strokeWidth;
    var fill = markerFill || fills[yKeyIndex % fills.length];
    var stroke = markerStroke || strokes[yKeyIndex % fills.length];
    var format = undefined;
    if (markerFormatter) {
      format = markerFormatter({
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        size: size,
        highlighted: false
      });
    }
    var color = format && format.fill || markerFill;
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    var tooltipRenderer = tooltip.renderer,
      tooltipFormat = tooltip.format;
    if (tooltipFormat || tooltipRenderer) {
      var params = {
        datum: datum,
        xKey: xKey,
        xName: xName,
        xValue: xValue,
        yKey: yKey,
        yValue: yValue,
        processedYValue: processedYValue,
        yName: yName,
        color: color
      };
      if (tooltipFormat) {
        return toTooltipHtml({
          content: interpolate(tooltipFormat, params)
        }, defaults);
      }
      if (tooltipRenderer) {
        return toTooltipHtml(tooltipRenderer(params), defaults);
      }
    }
    return toTooltipHtml(defaults);
  };
  AreaSeries.prototype.listSeriesItems = function (legendData) {
    var _a = this,
      data = _a.data,
      id = _a.id,
      xKey = _a.xKey,
      yKeys = _a.yKeys,
      yNames = _a.yNames,
      seriesItemEnabled = _a.seriesItemEnabled,
      marker = _a.marker,
      fills = _a.fills,
      strokes = _a.strokes,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity;
    if (data && data.length && xKey && yKeys.length) {
      yKeys.forEach(function (yKey, index) {
        legendData.push({
          id: id,
          itemId: yKey,
          enabled: seriesItemEnabled.get(yKey) || false,
          label: {
            text: yNames[index] || yKeys[index]
          },
          marker: {
            shape: marker.shape,
            fill: marker.fill || fills[index % fills.length],
            stroke: marker.stroke || strokes[index % strokes.length],
            fillOpacity: fillOpacity,
            strokeOpacity: strokeOpacity
          }
        });
      });
    }
  };
  AreaSeries.prototype.toggleSeriesItem = function (itemId, enabled) {
    this.seriesItemEnabled.set(itemId, enabled);
    this.scheduleData();
  };
  AreaSeries.className = 'AreaSeries';
  AreaSeries.type = 'area';
  __decorate$3c([reactive('dataChange')], AreaSeries.prototype, "fills", void 0);
  __decorate$3c([reactive('dataChange')], AreaSeries.prototype, "strokes", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "fillOpacity", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "strokeOpacity", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "lineDash", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "lineDashOffset", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "xName", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "yNames", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "strokeWidth", void 0);
  __decorate$3c([reactive('update')], AreaSeries.prototype, "shadow", void 0);
  return AreaSeries;
}(CartesianSeries);
var __extends$49 = undefined && undefined.__extends || function () {
  var _extendStatics274 = function extendStatics(d, b) {
    _extendStatics274 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics274(d, b);
  };
  return function (d, b) {
    _extendStatics274(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3d = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BarSeriesNodeTag;
(function (BarSeriesNodeTag) {
  BarSeriesNodeTag[BarSeriesNodeTag["Bar"] = 0] = "Bar";
  BarSeriesNodeTag[BarSeriesNodeTag["Label"] = 1] = "Label";
})(BarSeriesNodeTag || (BarSeriesNodeTag = {}));
var BarLabelPlacement;
(function (BarLabelPlacement) {
  BarLabelPlacement["Inside"] = "inside";
  BarLabelPlacement["Outside"] = "outside";
})(BarLabelPlacement || (BarLabelPlacement = {}));
var BarSeriesLabel = /** @class */function (_super) {
  __extends$49(BarSeriesLabel, _super);
  function BarSeriesLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.placement = BarLabelPlacement.Inside;
    return _this;
  }
  __decorate$3d([reactive('change')], BarSeriesLabel.prototype, "formatter", void 0);
  __decorate$3d([reactive('change')], BarSeriesLabel.prototype, "placement", void 0);
  return BarSeriesLabel;
}(Label);
var BarSeriesTooltip = /** @class */function (_super) {
  __extends$49(BarSeriesTooltip, _super);
  function BarSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3d([reactive('change')], BarSeriesTooltip.prototype, "renderer", void 0);
  return BarSeriesTooltip;
}(SeriesTooltip);
function flat(arr, target) {
  if (target === void 0) {
    target = [];
  }
  arr.forEach(function (v) {
    if (Array.isArray(v)) {
      flat(v, target);
    } else {
      target.push(v);
    }
  });
  return target;
}
var BarSeries = /** @class */function (_super) {
  __extends$49(BarSeries, _super);
  function BarSeries() {
    var _a;
    var _this = _super.call(this) || this;
    // Need to put bar and label nodes into separate groups, because even though label nodes are
    // created after the bar nodes, this only guarantees that labels will always be on top of bars
    // on the first run. If on the next run more bars are added, they might clip the labels
    // rendered during the previous run.
    _this.rectGroup = _this.pickGroup.appendChild(new Group());
    _this.labelGroup = _this.group.appendChild(new Group());
    _this.rectSelection = Selection.select(_this.rectGroup).selectAll();
    _this.labelSelection = Selection.select(_this.labelGroup).selectAll();
    _this.nodeData = [];
    _this.xData = [];
    _this.yData = [];
    _this.yDomain = [];
    _this.label = new BarSeriesLabel();
    /**
     * The assumption is that the values will be reset (to `true`)
     * in the {@link yKeys} setter.
     */
    _this.seriesItemEnabled = new Map();
    _this.tooltip = new BarSeriesTooltip();
    _this.flipXY = false;
    _this.fills = ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'];
    _this.strokes = ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'];
    _this.fillOpacity = 1;
    _this.strokeOpacity = 1;
    _this.lineDash = [0];
    _this.lineDashOffset = 0;
    /**
     * Used to get the position of bars within each group.
     */
    _this.groupScale = new BandScale();
    _this.directionKeys = (_a = {}, _a[ChartAxisDirection.X] = ['xKey'], _a[ChartAxisDirection.Y] = ['yKeys'], _a);
    _this._xKey = '';
    _this._xName = '';
    _this.cumYKeyCount = [];
    _this.flatYKeys = undefined; // only set when a user used a flat array for yKeys
    _this.hideInLegend = [];
    /**
     * yKeys: [['coffee']] - regular bars, each category has a single bar that shows a value for coffee
     * yKeys: [['coffee'], ['tea'], ['milk']] - each category has three bars that show values for coffee, tea and milk
     * yKeys: [['coffee', 'tea', 'milk']] - each category has a single bar with three stacks that show values for coffee, tea and milk
     * yKeys: [['coffee', 'tea', 'milk'], ['paper', 'ink']] - each category has 2 stacked bars,
     *     first showing values for coffee, tea and milk and second values for paper and ink
     */
    _this._yKeys = [];
    _this._grouped = false;
    /**
     * A map of `yKeys` to their names (used in legends and tooltips).
     * For example, if a key is `product_name` it's name can be a more presentable `Product Name`.
     */
    _this._yNames = {};
    _this._strokeWidth = 1;
    _this.addEventListener('update', _this.scheduleUpdate);
    _this.label.enabled = false;
    _this.label.addEventListener('change', _this.scheduleUpdate, _this);
    return _this;
  }
  BarSeries.prototype.getKeys = function (direction) {
    var _this = this;
    var directionKeys = this.directionKeys;
    var keys = directionKeys && directionKeys[this.flipXY ? flipChartAxisDirection(direction) : direction];
    var values = [];
    if (keys) {
      keys.forEach(function (key) {
        var value = _this[key];
        if (value) {
          if (Array.isArray(value)) {
            values = values.concat(flat(value));
          } else {
            values.push(value);
          }
        }
      });
    }
    return values;
  };
  Object.defineProperty(BarSeries.prototype, "xKey", {
    get: function get() {
      return this._xKey;
    },
    set: function set(value) {
      if (this._xKey !== value) {
        this._xKey = value;
        this.xData = [];
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "xName", {
    get: function get() {
      return this._xName;
    },
    set: function set(value) {
      if (this._xName !== value) {
        this._xName = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "yKeys", {
    get: function get() {
      return this._yKeys;
    },
    set: function set(yKeys) {
      var _this = this;
      var flatYKeys = undefined;
      // Convert from flat y-keys to grouped y-keys.
      if (yKeys.length && !Array.isArray(yKeys[0])) {
        flatYKeys = yKeys;
        if (this.grouped) {
          yKeys = flatYKeys.map(function (k) {
            return [k];
          });
        } else {
          yKeys = [flatYKeys];
        }
      }
      if (!equal(this._yKeys, yKeys)) {
        if (flatYKeys) {
          this.flatYKeys = flatYKeys;
        } else {
          this.flatYKeys = undefined;
        }
        this._yKeys = yKeys;
        var prevYKeyCount_1 = 0;
        this.cumYKeyCount = [];
        var visibleStacks_1 = [];
        yKeys.forEach(function (stack, index) {
          if (stack.length > 0) {
            visibleStacks_1.push(String(index));
          }
          _this.cumYKeyCount.push(prevYKeyCount_1);
          prevYKeyCount_1 += stack.length;
        });
        this.yData = [];
        var seriesItemEnabled_1 = this.seriesItemEnabled;
        seriesItemEnabled_1.clear();
        yKeys.forEach(function (stack) {
          stack.forEach(function (yKey) {
            return seriesItemEnabled_1.set(yKey, true);
          });
        });
        var groupScale = this.groupScale;
        groupScale.domain = visibleStacks_1;
        groupScale.padding = 0.1;
        groupScale.round = true;
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "grouped", {
    get: function get() {
      return this._grouped;
    },
    set: function set(value) {
      if (this._grouped !== value) {
        this._grouped = value;
        if (this.flatYKeys) {
          this.yKeys = this.flatYKeys;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "yNames", {
    get: function get() {
      return this._yNames;
    },
    set: function set(values) {
      if (Array.isArray(values) && this.flatYKeys) {
        var map_1 = {};
        this.flatYKeys.forEach(function (k, i) {
          map_1[k] = values[i];
        });
        values = map_1;
      }
      this._yNames = values;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  BarSeries.prototype.setColors = function (fills, strokes) {
    this.fills = fills;
    this.strokes = strokes;
  };
  Object.defineProperty(BarSeries.prototype, "normalizedTo", {
    get: function get() {
      return this._normalizedTo;
    },
    set: function set(value) {
      var absValue = value ? Math.abs(value) : undefined;
      if (this._normalizedTo !== absValue) {
        this._normalizedTo = absValue;
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BarSeries.prototype, "shadow", {
    get: function get() {
      return this._shadow;
    },
    set: function set(value) {
      if (this._shadow !== value) {
        this._shadow = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  BarSeries.prototype.onHighlightChange = function () {
    this.updateRectNodes();
  };
  BarSeries.prototype.processData = function () {
    var _a = this,
      xKey = _a.xKey,
      yKeys = _a.yKeys,
      seriesItemEnabled = _a.seriesItemEnabled;
    var data = xKey && yKeys.length && this.data ? this.data : [];
    var keysFound = true; // only warn once
    this.xData = data.map(function (datum) {
      if (keysFound && !(xKey in datum)) {
        keysFound = false;
        console.warn("The key '" + xKey + "' was not found in the data: ", datum);
      }
      return datum[xKey];
    });
    this.yData = data.map(function (datum) {
      return yKeys.map(function (stack) {
        return stack.map(function (yKey) {
          if (keysFound && !(yKey in datum)) {
            keysFound = false;
            console.warn("The key '" + yKey + "' was not found in the data: ", datum);
          }
          var value = datum[yKey];
          return isFinite(value) && seriesItemEnabled.get(yKey) ? value : 0;
        });
      });
    });
    // Used for normalization of stacked bars. Contains min/max values for each stack in each group,
    // where min is zero and max is a positive total of all values in the stack
    // or min is a negative total of all values in the stack and max is zero.
    var yMinMax = this.yData.map(function (group) {
      return group.map(function (stack) {
        return findMinMax(stack);
      });
    });
    var _b = this,
      yData = _b.yData,
      normalizedTo = _b.normalizedTo;
    var yLargestMinMax = this.findLargestMinMax(yMinMax);
    var yMin;
    var yMax;
    if (normalizedTo && isFinite(normalizedTo)) {
      yMin = yLargestMinMax.min < 0 ? -normalizedTo : 0;
      yMax = normalizedTo;
      yData.forEach(function (group, i) {
        group.forEach(function (stack, j) {
          stack.forEach(function (y, k) {
            if (y < 0) {
              stack[k] = -y / yMinMax[i][j].min * normalizedTo;
            } else {
              stack[k] = y / yMinMax[i][j].max * normalizedTo;
            }
          });
        });
      });
    } else {
      yMin = yLargestMinMax.min;
      yMax = yLargestMinMax.max;
    }
    this.yDomain = this.fixNumericExtent([yMin, yMax], 'y');
    this.fireEvent({
      type: 'dataProcessed'
    });
    return true;
  };
  BarSeries.prototype.findLargestMinMax = function (groups) {
    var tallestStackMin = 0;
    var tallestStackMax = 0;
    for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
      var group = groups_1[_i];
      for (var _a = 0, group_1 = group; _a < group_1.length; _a++) {
        var stack = group_1[_a];
        if (stack.min < tallestStackMin) {
          tallestStackMin = stack.min;
        }
        if (stack.max > tallestStackMax) {
          tallestStackMax = stack.max;
        }
      }
    }
    return {
      min: tallestStackMin,
      max: tallestStackMax
    };
  };
  BarSeries.prototype.getDomain = function (direction) {
    if (this.flipXY) {
      direction = flipChartAxisDirection(direction);
    }
    if (direction === ChartAxisDirection.X) {
      return this.xData;
    } else {
      return this.yDomain;
    }
  };
  BarSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      xKey: this.xKey,
      yKey: datum.yKey
    });
  };
  BarSeries.prototype.getCategoryAxis = function () {
    return this.flipXY ? this.yAxis : this.xAxis;
  };
  BarSeries.prototype.getValueAxis = function () {
    return this.flipXY ? this.xAxis : this.yAxis;
  };
  BarSeries.prototype.createNodeData = function () {
    var _this = this;
    var _a = this,
      chart = _a.chart,
      data = _a.data,
      visible = _a.visible;
    var xAxis = this.getCategoryAxis();
    var yAxis = this.getValueAxis();
    if (!(chart && data && visible && xAxis && yAxis) || chart.layoutPending || chart.dataPending) {
      return [];
    }
    var flipXY = this.flipXY;
    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var _b = this,
      groupScale = _b.groupScale,
      yKeys = _b.yKeys,
      cumYKeyCount = _b.cumYKeyCount,
      fills = _b.fills,
      strokes = _b.strokes,
      strokeWidth = _b.strokeWidth,
      seriesItemEnabled = _b.seriesItemEnabled,
      xData = _b.xData,
      yData = _b.yData,
      label = _b.label;
    var labelFontStyle = label.fontStyle,
      labelFontWeight = label.fontWeight,
      labelFontSize = label.fontSize,
      labelFontFamily = label.fontFamily,
      labelColor = label.color,
      labelFormatter = label.formatter,
      labelPlacement = label.placement;
    groupScale.range = [0, xScale.bandwidth];
    var barWidth = groupScale.bandwidth;
    var nodeData = [];
    xData.forEach(function (group, groupIndex) {
      var seriesDatum = data[groupIndex];
      var x = xScale.convert(group);
      var groupYs = yData[groupIndex]; // y-data for groups of stacks
      for (var stackIndex = 0; stackIndex < groupYs.length; stackIndex++) {
        var stackYs = groupYs[stackIndex]; // y-data for a stack withing a group
        var zero = Math.max(0, yAxis.min, yScale.domain[0]);
        var prevMinY = 0;
        var prevMaxY = 0;
        for (var levelIndex = 0; levelIndex < stackYs.length; levelIndex++) {
          var currY = stackYs[levelIndex];
          var yKey = yKeys[stackIndex][levelIndex];
          var barX = x + groupScale.convert(String(stackIndex));
          // Bars outside of visible range are not rendered, so we create node data
          // only for the visible subset of user data.
          if (!xAxis.inRange(barX, barWidth)) {
            continue;
          }
          var prevY = currY < 0 ? prevMinY : prevMaxY;
          var continuousY = yScale instanceof ContinuousScale;
          // @ts-ignore
          var y = yScale.convert(prevY + currY, continuousY ? clamper : undefined);
          // @ts-ignore
          var bottomY = yScale.convert(prevY, continuousY ? clamper : undefined);
          var yValue = seriesDatum[yKey]; // unprocessed y-value
          var labelText = void 0;
          if (labelFormatter) {
            labelText = labelFormatter({
              value: isNumber(yValue) ? yValue : undefined
            });
          } else {
            labelText = isNumber(yValue) ? yValue.toFixed(2) : '';
          }
          var labelX = void 0;
          var labelY = void 0;
          if (flipXY) {
            labelY = barX + barWidth / 2;
            if (labelPlacement === BarLabelPlacement.Inside) {
              labelX = y + (yValue >= 0 ? -1 : 1) * Math.abs(bottomY - y) / 2;
            } else {
              labelX = y + (yValue >= 0 ? 1 : -1) * 4;
            }
          } else {
            labelX = barX + barWidth / 2;
            if (labelPlacement === BarLabelPlacement.Inside) {
              labelY = y + (yValue >= 0 ? 1 : -1) * Math.abs(bottomY - y) / 2;
            } else {
              labelY = y + (yValue >= 0 ? -3 : 4);
            }
          }
          var labelTextAlign = void 0;
          var labelTextBaseline = void 0;
          if (labelPlacement === BarLabelPlacement.Inside) {
            labelTextAlign = 'center';
            labelTextBaseline = 'middle';
          } else {
            labelTextAlign = flipXY ? yValue >= 0 ? 'start' : 'end' : 'center';
            labelTextBaseline = flipXY ? 'middle' : yValue >= 0 ? 'bottom' : 'top';
          }
          var colorIndex = cumYKeyCount[stackIndex] + levelIndex;
          nodeData.push({
            index: groupIndex,
            series: _this,
            itemId: yKey,
            datum: seriesDatum,
            yValue: yValue,
            yKey: yKey,
            x: flipXY ? Math.min(y, bottomY) : barX,
            y: flipXY ? barX : Math.min(y, bottomY),
            width: flipXY ? Math.abs(bottomY - y) : barWidth,
            height: flipXY ? barWidth : Math.abs(bottomY - y),
            fill: fills[colorIndex % fills.length],
            stroke: strokes[colorIndex % strokes.length],
            strokeWidth: strokeWidth,
            label: seriesItemEnabled.get(yKey) && labelText ? {
              text: labelText,
              fontStyle: labelFontStyle,
              fontWeight: labelFontWeight,
              fontSize: labelFontSize,
              fontFamily: labelFontFamily,
              textAlign: labelTextAlign,
              textBaseline: labelTextBaseline,
              fill: labelColor,
              x: labelX,
              y: labelY
            } : undefined
          });
          if (currY < 0) {
            prevMinY += currY;
          } else {
            prevMaxY += currY;
          }
        }
      }
    });
    return this.nodeData = nodeData;
  };
  BarSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  BarSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    this.createNodeData();
    this.updateRectSelection();
    this.updateLabelSelection();
  };
  BarSeries.prototype.updateNodes = function () {
    this.group.visible = this.visible;
    this.updateRectNodes();
    this.updateLabelNodes();
  };
  BarSeries.prototype.updateRectSelection = function () {
    var updateRects = this.rectSelection.setData(this.nodeData);
    updateRects.exit.remove();
    var enterRects = updateRects.enter.append(Rect).each(function (rect) {
      rect.tag = BarSeriesNodeTag.Bar;
      rect.crisp = true;
    });
    this.rectSelection = updateRects.merge(enterRects);
  };
  BarSeries.prototype.updateRectNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      fills = _a.fills,
      strokes = _a.strokes,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity,
      shadow = _a.shadow,
      formatter = _a.formatter,
      xKey = _a.xKey,
      flipXY = _a.flipXY,
      yKeys = _a.yKeys,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    this.rectSelection.each(function (rect, datum, index) {
      var colorIndex = 0;
      var i = 0;
      for (var j = 0; j < yKeys.length; j++) {
        var stack = yKeys[j];
        i = stack.indexOf(datum.yKey);
        if (i >= 0) {
          colorIndex += i;
          break;
        }
        colorIndex += stack.length;
      }
      var isDatumHighlighted = datum === highlightedDatum;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : fills[colorIndex % fills.length];
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : strokes[colorIndex % fills.length];
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : _this.getStrokeWidth(_this.strokeWidth, datum);
      var format = undefined;
      if (formatter) {
        format = formatter({
          datum: datum.datum,
          fill: fill,
          stroke: stroke,
          strokeWidth: strokeWidth,
          highlighted: isDatumHighlighted,
          xKey: xKey,
          yKey: datum.yKey
        });
      }
      rect.x = datum.x;
      rect.y = datum.y;
      rect.width = datum.width;
      rect.height = datum.height;
      rect.fill = format && format.fill || fill;
      rect.stroke = format && format.stroke || stroke;
      rect.strokeWidth = format && format.strokeWidth !== undefined ? format.strokeWidth : strokeWidth;
      rect.fillOpacity = fillOpacity;
      rect.strokeOpacity = strokeOpacity;
      rect.lineDash = _this.lineDash;
      rect.lineDashOffset = _this.lineDashOffset;
      rect.fillShadow = shadow;
      // Prevent stroke from rendering for zero height columns and zero width bars.
      rect.visible = flipXY ? datum.width > 0 : datum.height > 0;
      rect.zIndex = isDatumHighlighted ? Series.highlightedZIndex : index;
      rect.opacity = _this.getOpacity(datum);
    });
  };
  BarSeries.prototype.updateLabelSelection = function () {
    var updateLabels = this.labelSelection.setData(this.nodeData);
    updateLabels.exit.remove();
    var enterLabels = updateLabels.enter.append(Text).each(function (text) {
      text.tag = BarSeriesNodeTag.Label;
      text.pointerEvents = PointerEvents.None;
    });
    this.labelSelection = updateLabels.merge(enterLabels);
  };
  BarSeries.prototype.updateLabelNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.label,
      labelEnabled = _b.enabled,
      fontStyle = _b.fontStyle,
      fontWeight = _b.fontWeight,
      fontSize = _b.fontSize,
      fontFamily = _b.fontFamily,
      color = _b.color;
    this.labelSelection.each(function (text, datum, index) {
      var label = datum.label;
      if (label && labelEnabled) {
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.textAlign = label.textAlign;
        text.textBaseline = label.textBaseline;
        text.text = label.text;
        text.x = label.x;
        text.y = label.y;
        text.fill = color;
        text.visible = true;
        text.opacity = _this.getOpacity(datum);
      } else {
        text.visible = false;
      }
    });
  };
  BarSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var _a = this,
      xKey = _a.xKey,
      yKeys = _a.yKeys,
      yData = _a.yData;
    var xAxis = this.getCategoryAxis();
    var yAxis = this.getValueAxis();
    var yKey = nodeDatum.yKey;
    if (!yData.length || !xKey || !yKey || !xAxis || !yAxis) {
      return '';
    }
    var yGroup = yData[nodeDatum.index];
    var fillIndex = 0;
    var i = 0;
    var j = 0;
    for (; j < yKeys.length; j++) {
      var stack = yKeys[j];
      i = stack.indexOf(yKey);
      if (i >= 0) {
        fillIndex += i;
        break;
      }
      fillIndex += stack.length;
    }
    var _b = this,
      xName = _b.xName,
      yNames = _b.yNames,
      fills = _b.fills,
      strokes = _b.strokes,
      tooltip = _b.tooltip,
      formatter = _b.formatter;
    var tooltipRenderer = tooltip.renderer;
    var datum = nodeDatum.datum;
    var yName = yNames[yKey];
    var fill = fills[fillIndex % fills.length];
    var stroke = strokes[fillIndex % fills.length];
    var strokeWidth = this.getStrokeWidth(this.strokeWidth, datum);
    var xValue = datum[xKey];
    var yValue = datum[yKey];
    var processedYValue = yGroup[j][i];
    var xString = sanitizeHtml(xAxis.formatDatum(xValue));
    var yString = sanitizeHtml(yAxis.formatDatum(yValue));
    var title = sanitizeHtml(yName);
    var content = xString + ': ' + yString;
    var format = undefined;
    if (formatter) {
      format = formatter({
        datum: datum,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        highlighted: false,
        xKey: xKey,
        yKey: yKey
      });
    }
    var color = format && format.fill || fill;
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    if (tooltipRenderer) {
      return toTooltipHtml(tooltipRenderer({
        datum: datum,
        xKey: xKey,
        xValue: xValue,
        xName: xName,
        yKey: yKey,
        yValue: yValue,
        processedYValue: processedYValue,
        yName: yName,
        color: color
      }), defaults);
    }
    return toTooltipHtml(defaults);
  };
  BarSeries.prototype.listSeriesItems = function (legendData) {
    var _a = this,
      id = _a.id,
      data = _a.data,
      xKey = _a.xKey,
      yKeys = _a.yKeys,
      yNames = _a.yNames,
      cumYKeyCount = _a.cumYKeyCount,
      seriesItemEnabled = _a.seriesItemEnabled,
      hideInLegend = _a.hideInLegend,
      fills = _a.fills,
      strokes = _a.strokes,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity;
    if (data && data.length && xKey && yKeys.length) {
      this.yKeys.forEach(function (stack, stackIndex) {
        stack.forEach(function (yKey, levelIndex) {
          if (hideInLegend.indexOf(yKey) < 0) {
            var colorIndex = cumYKeyCount[stackIndex] + levelIndex;
            legendData.push({
              id: id,
              itemId: yKey,
              enabled: seriesItemEnabled.get(yKey) || false,
              label: {
                text: yNames[yKey] || yKey
              },
              marker: {
                fill: fills[colorIndex % fills.length],
                stroke: strokes[colorIndex % strokes.length],
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity
              }
            });
          }
        });
      });
    }
  };
  BarSeries.prototype.toggleSeriesItem = function (itemId, enabled) {
    var seriesItemEnabled = this.seriesItemEnabled;
    seriesItemEnabled.set(itemId, enabled);
    var yKeys = this.yKeys.map(function (stack) {
      return stack.slice();
    }); // deep clone
    seriesItemEnabled.forEach(function (enabled, yKey) {
      if (!enabled) {
        yKeys.forEach(function (stack) {
          var index = stack.indexOf(yKey);
          if (index >= 0) {
            stack.splice(index, 1);
          }
        });
      }
    });
    var visibleStacks = [];
    yKeys.forEach(function (stack, index) {
      if (stack.length > 0) {
        visibleStacks.push(String(index));
      }
    });
    this.groupScale.domain = visibleStacks;
    this.scheduleData();
  };
  BarSeries.className = 'BarSeries';
  BarSeries.type = 'bar';
  __decorate$3d([reactive('dataChange')], BarSeries.prototype, "flipXY", void 0);
  __decorate$3d([reactive('dataChange')], BarSeries.prototype, "fills", void 0);
  __decorate$3d([reactive('dataChange')], BarSeries.prototype, "strokes", void 0);
  __decorate$3d([reactive('update')], BarSeries.prototype, "fillOpacity", void 0);
  __decorate$3d([reactive('update')], BarSeries.prototype, "strokeOpacity", void 0);
  __decorate$3d([reactive('update')], BarSeries.prototype, "lineDash", void 0);
  __decorate$3d([reactive('update')], BarSeries.prototype, "lineDashOffset", void 0);
  __decorate$3d([reactive('update')], BarSeries.prototype, "formatter", void 0);
  __decorate$3d([reactive('layoutChange')], BarSeries.prototype, "hideInLegend", void 0);
  return BarSeries;
}(CartesianSeries);
var __extends$4a = undefined && undefined.__extends || function () {
  var _extendStatics275 = function extendStatics(d, b) {
    _extendStatics275 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics275(d, b);
  };
  return function (d, b) {
    _extendStatics275(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3e = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LineSeriesLabel = /** @class */function (_super) {
  __extends$4a(LineSeriesLabel, _super);
  function LineSeriesLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3e([reactive('change')], LineSeriesLabel.prototype, "formatter", void 0);
  return LineSeriesLabel;
}(Label);
var LineSeriesTooltip = /** @class */function (_super) {
  __extends$4a(LineSeriesTooltip, _super);
  function LineSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3e([reactive('change')], LineSeriesTooltip.prototype, "renderer", void 0);
  __decorate$3e([reactive('change')], LineSeriesTooltip.prototype, "format", void 0);
  return LineSeriesTooltip;
}(SeriesTooltip);
var LineSeries = /** @class */function (_super) {
  __extends$4a(LineSeries, _super);
  function LineSeries() {
    var _this = _super.call(this) || this;
    _this.xDomain = [];
    _this.yDomain = [];
    _this.xData = [];
    _this.yData = [];
    _this.lineNode = new Path();
    // We use groups for this selection even though each group only contains a marker ATM
    // because in the future we might want to add label support as well.
    _this.nodeSelection = Selection.select(_this.pickGroup).selectAll();
    _this.nodeData = [];
    _this.marker = new CartesianSeriesMarker();
    _this.label = new LineSeriesLabel();
    _this.stroke = '#874349';
    _this.lineDash = [0];
    _this.lineDashOffset = 0;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.tooltip = new LineSeriesTooltip();
    _this._xKey = '';
    _this.xName = '';
    _this._yKey = '';
    _this.yName = '';
    var lineNode = _this.lineNode;
    lineNode.fill = undefined;
    lineNode.lineJoin = 'round';
    lineNode.pointerEvents = PointerEvents.None;
    // Make line render before markers in the pick group.
    _this.group.insertBefore(lineNode, _this.pickGroup);
    _this.addEventListener('update', _this.scheduleUpdate);
    var _a = _this,
      marker = _a.marker,
      label = _a.label;
    marker.fill = '#c16068';
    marker.stroke = '#874349';
    marker.addPropertyListener('shape', _this.onMarkerShapeChange, _this);
    marker.addEventListener('change', _this.scheduleUpdate, _this);
    label.enabled = false;
    label.addEventListener('change', _this.scheduleUpdate, _this);
    return _this;
  }
  LineSeries.prototype.onMarkerShapeChange = function () {
    this.nodeSelection = this.nodeSelection.setData([]);
    this.nodeSelection.exit.remove();
    this.fireEvent({
      type: 'legendChange'
    });
  };
  LineSeries.prototype.setColors = function (fills, strokes) {
    this.stroke = fills[0];
    this.marker.stroke = strokes[0];
    this.marker.fill = fills[0];
  };
  Object.defineProperty(LineSeries.prototype, "xKey", {
    get: function get() {
      return this._xKey;
    },
    set: function set(value) {
      if (this._xKey !== value) {
        this._xKey = value;
        this.xData = [];
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LineSeries.prototype, "yKey", {
    get: function get() {
      return this._yKey;
    },
    set: function set(value) {
      if (this._yKey !== value) {
        this._yKey = value;
        this.yData = [];
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  LineSeries.prototype.processData = function () {
    var _a = this,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis,
      xKey = _a.xKey,
      yKey = _a.yKey,
      xData = _a.xData,
      yData = _a.yData;
    var data = xKey && yKey && this.data ? this.data : [];
    if (!xAxis || !yAxis) {
      return false;
    }
    var isContinuousX = xAxis.scale instanceof ContinuousScale;
    var isContinuousY = yAxis.scale instanceof ContinuousScale;
    xData.length = 0;
    yData.length = 0;
    for (var i = 0, n = data.length; i < n; i++) {
      var datum = data[i];
      var x = datum[xKey];
      var y = datum[yKey];
      if (isContinuousX) {
        xData.push(x);
      } else {
        // i.e. category axis
        xData.push(isDiscrete(x) ? x : String(x));
      }
      yData.push(y);
    }
    this.xDomain = isContinuousX ? this.fixNumericExtent(extent(xData, isContinuous), 'x') : xData;
    this.yDomain = isContinuousY ? this.fixNumericExtent(extent(yData, isContinuous), 'y') : yData;
    return true;
  };
  LineSeries.prototype.getDomain = function (direction) {
    if (direction === ChartAxisDirection.X) {
      return this.xDomain;
    }
    return this.yDomain;
  };
  LineSeries.prototype.onHighlightChange = function () {
    this.updateNodes();
  };
  LineSeries.prototype.resetHighlight = function () {
    this.lineNode.strokeWidth = this.strokeWidth;
  };
  LineSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  LineSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    this.updateLinePath(); // this will create node data too
    this.updateNodeSelection();
  };
  LineSeries.prototype.updateLinePath = function () {
    var _a = this,
      data = _a.data,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!data || !xAxis || !yAxis) {
      return;
    }
    var _b = this,
      xData = _b.xData,
      yData = _b.yData,
      lineNode = _b.lineNode,
      label = _b.label;
    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var isContinuousX = xScale instanceof ContinuousScale;
    var isContinuousY = yScale instanceof ContinuousScale;
    var xOffset = (xScale.bandwidth || 0) / 2;
    var yOffset = (yScale.bandwidth || 0) / 2;
    var linePath = lineNode.path;
    var nodeData = [];
    linePath.clear();
    var moveTo = true;
    var prevXInRange = undefined;
    var nextXYDatums = undefined;
    for (var i = 0; i < xData.length; i++) {
      var xyDatums = nextXYDatums || this.checkDomainXY(xData[i], yData[i], isContinuousX, isContinuousY);
      if (!xyDatums) {
        prevXInRange = undefined;
        moveTo = true;
      } else {
        var xDatum = xyDatums[0],
          yDatum = xyDatums[1];
        var x = xScale.convert(xDatum) + xOffset;
        if (isNaN(x)) {
          prevXInRange = undefined;
          moveTo = true;
          continue;
        }
        var tolerance = (xScale.bandwidth || this.marker.size * 0.5 + (this.marker.strokeWidth || 0)) + 1;
        nextXYDatums = this.checkDomainXY(xData[i + 1], yData[i + 1], isContinuousX, isContinuousY);
        var xInRange = xAxis.inRangeEx(x, 0, tolerance);
        var nextXInRange = nextXYDatums && xAxis.inRangeEx(xScale.convert(nextXYDatums[0]) + xOffset, 0, tolerance);
        if (xInRange === -1 && nextXInRange === -1) {
          moveTo = true;
          continue;
        }
        if (xInRange === 1 && prevXInRange === 1) {
          moveTo = true;
          continue;
        }
        prevXInRange = xInRange;
        var y = yScale.convert(yDatum) + yOffset;
        if (moveTo) {
          linePath.moveTo(x, y);
          moveTo = false;
        } else {
          linePath.lineTo(x, y);
        }
        var labelText = void 0;
        if (label.formatter) {
          labelText = label.formatter({
            value: yDatum
          });
        } else {
          labelText = typeof yDatum === 'number' && isFinite(yDatum) ? yDatum.toFixed(2) : yDatum ? String(yDatum) : '';
        }
        nodeData.push({
          series: this,
          datum: data[i],
          point: {
            x: x,
            y: y
          },
          label: labelText ? {
            text: labelText,
            fontStyle: label.fontStyle,
            fontWeight: label.fontWeight,
            fontSize: label.fontSize,
            fontFamily: label.fontFamily,
            textAlign: 'center',
            textBaseline: 'bottom',
            fill: label.color
          } : undefined
        });
      }
    }
    // Used by marker nodes and for hit-testing even when not using markers
    // when `chart.tooltip.tracking` is true.
    this.nodeData = nodeData;
  };
  LineSeries.prototype.updateNodeSelection = function () {
    var marker = this.marker;
    var nodeData = marker.shape ? this.nodeData : [];
    var MarkerShape = getMarker(marker.shape);
    var updateSelection = this.nodeSelection.setData(nodeData);
    updateSelection.exit.remove();
    var enterSelection = updateSelection.enter.append(Group);
    enterSelection.append(MarkerShape);
    enterSelection.append(Text);
    this.nodeSelection = updateSelection.merge(enterSelection);
  };
  LineSeries.prototype.updateNodes = function () {
    this.group.visible = this.visible;
    this.updateLineNode();
    this.updateMarkerNodes();
    this.updateTextNodes();
  };
  LineSeries.prototype.updateLineNode = function () {
    var lineNode = this.lineNode;
    lineNode.stroke = this.stroke;
    lineNode.strokeWidth = this.getStrokeWidth(this.strokeWidth);
    lineNode.strokeOpacity = this.strokeOpacity;
    lineNode.lineDash = this.lineDash;
    lineNode.lineDashOffset = this.lineDashOffset;
    lineNode.opacity = this.getOpacity();
  };
  LineSeries.prototype.updateMarkerNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      marker = _a.marker,
      xKey = _a.xKey,
      yKey = _a.yKey,
      lineStroke = _a.stroke,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    var size = marker.size,
      formatter = marker.formatter;
    var markerStrokeWidth = marker.strokeWidth !== undefined ? marker.strokeWidth : this.strokeWidth;
    var MarkerShape = getMarker(marker.shape);
    this.nodeSelection.selectByClass(MarkerShape).each(function (node, datum) {
      var isDatumHighlighted = datum === highlightedDatum;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : marker.fill;
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : marker.stroke || lineStroke;
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : markerStrokeWidth;
      var format = undefined;
      if (formatter) {
        format = formatter({
          datum: datum.datum,
          xKey: xKey,
          yKey: yKey,
          fill: fill,
          stroke: stroke,
          strokeWidth: strokeWidth,
          size: size,
          highlighted: isDatumHighlighted
        });
      }
      node.fill = format && format.fill || fill;
      node.stroke = format && format.stroke || stroke;
      node.strokeWidth = format && format.strokeWidth !== undefined ? format.strokeWidth : strokeWidth;
      node.size = format && format.size !== undefined ? format.size : size;
      node.translationX = datum.point.x;
      node.translationY = datum.point.y;
      node.opacity = _this.getOpacity(datum);
      node.visible = marker.enabled && node.size > 0;
    });
  };
  LineSeries.prototype.updateTextNodes = function () {
    var _this = this;
    this.nodeSelection.selectByClass(Text).each(function (text, datum) {
      var point = datum.point,
        label = datum.label;
      var _a = _this.label,
        labelEnabled = _a.enabled,
        fontStyle = _a.fontStyle,
        fontWeight = _a.fontWeight,
        fontSize = _a.fontSize,
        fontFamily = _a.fontFamily,
        color = _a.color;
      if (label && labelEnabled) {
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.textAlign = label.textAlign;
        text.textBaseline = label.textBaseline;
        text.text = label.text;
        text.x = point.x;
        text.y = point.y - 10;
        text.fill = color;
        text.visible = true;
      } else {
        text.visible = false;
      }
    });
  };
  LineSeries.prototype.getNodeData = function () {
    return this.nodeData;
  };
  LineSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      xKey: this.xKey,
      yKey: this.yKey
    });
  };
  LineSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var _a = this,
      xKey = _a.xKey,
      yKey = _a.yKey,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!xKey || !yKey || !xAxis || !yAxis) {
      return '';
    }
    var _b = this,
      xName = _b.xName,
      yName = _b.yName,
      tooltip = _b.tooltip,
      marker = _b.marker;
    var tooltipRenderer = tooltip.renderer,
      tooltipFormat = tooltip.format;
    var datum = nodeDatum.datum;
    var xValue = datum[xKey];
    var yValue = datum[yKey];
    var xString = xAxis.formatDatum(xValue);
    var yString = yAxis.formatDatum(yValue);
    var title = sanitizeHtml(this.title || yName);
    var content = sanitizeHtml(xString + ': ' + yString);
    var markerFormatter = marker.formatter,
      fill = marker.fill,
      stroke = marker.stroke,
      markerStrokeWidth = marker.strokeWidth,
      size = marker.size;
    var strokeWidth = markerStrokeWidth !== undefined ? markerStrokeWidth : this.strokeWidth;
    var format = undefined;
    if (markerFormatter) {
      format = markerFormatter({
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        size: size,
        highlighted: false
      });
    }
    var color = format && format.fill || fill;
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    if (tooltipFormat || tooltipRenderer) {
      var params = {
        datum: datum,
        xKey: xKey,
        xValue: xValue,
        xName: xName,
        yKey: yKey,
        yValue: yValue,
        yName: yName,
        title: title,
        color: color
      };
      if (tooltipFormat) {
        return toTooltipHtml({
          content: interpolate(tooltipFormat, params)
        }, defaults);
      }
      if (tooltipRenderer) {
        return toTooltipHtml(tooltipRenderer(params), defaults);
      }
    }
    return toTooltipHtml(defaults);
  };
  LineSeries.prototype.listSeriesItems = function (legendData) {
    var _a = this,
      id = _a.id,
      data = _a.data,
      xKey = _a.xKey,
      yKey = _a.yKey,
      yName = _a.yName,
      visible = _a.visible,
      title = _a.title,
      marker = _a.marker,
      stroke = _a.stroke,
      strokeOpacity = _a.strokeOpacity;
    if (data && data.length && xKey && yKey) {
      legendData.push({
        id: id,
        itemId: undefined,
        enabled: visible,
        label: {
          text: title || yName || yKey
        },
        marker: {
          shape: marker.shape,
          fill: marker.fill || 'rgba(0, 0, 0, 0)',
          stroke: marker.stroke || stroke || 'rgba(0, 0, 0, 0)',
          fillOpacity: 1,
          strokeOpacity: strokeOpacity
        }
      });
    }
  };
  LineSeries.className = 'LineSeries';
  LineSeries.type = 'line';
  __decorate$3e([reactive('layoutChange')], LineSeries.prototype, "title", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "stroke", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "lineDash", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "lineDashOffset", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "strokeWidth", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "strokeOpacity", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "xName", void 0);
  __decorate$3e([reactive('update')], LineSeries.prototype, "yName", void 0);
  return LineSeries;
}(CartesianSeries);
var __extends$4b = undefined && undefined.__extends || function () {
  var _extendStatics276 = function extendStatics(d, b) {
    _extendStatics276 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics276(d, b);
  };
  return function (d, b) {
    _extendStatics276(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$l = undefined && undefined.__assign || function () {
  __assign$l = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$l.apply(this, arguments);
};
var __decorate$3f = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ScatterSeriesTooltip = /** @class */function (_super) {
  __extends$4b(ScatterSeriesTooltip, _super);
  function ScatterSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3f([reactive('change')], ScatterSeriesTooltip.prototype, "renderer", void 0);
  return ScatterSeriesTooltip;
}(SeriesTooltip);
var ScatterSeries = /** @class */function (_super) {
  __extends$4b(ScatterSeries, _super);
  function ScatterSeries() {
    var _this = _super.call(this) || this;
    _this.xDomain = [];
    _this.yDomain = [];
    _this.xData = [];
    _this.yData = [];
    _this.sizeData = [];
    _this.sizeScale = new LinearScale();
    _this.nodeData = [];
    _this.markerSelection = Selection.select(_this.pickGroup).selectAll();
    _this.labelData = [];
    _this.labelSelection = Selection.select(_this.group).selectAll();
    _this.marker = new CartesianSeriesMarker();
    _this.label = new Label();
    _this._fill = '#c16068';
    _this._stroke = '#874349';
    _this._strokeWidth = 2;
    _this._fillOpacity = 1;
    _this._strokeOpacity = 1;
    _this.xKey = '';
    _this.yKey = '';
    _this.xName = '';
    _this.yName = '';
    _this.sizeName = 'Size';
    _this.labelName = 'Label';
    _this.tooltip = new ScatterSeriesTooltip();
    var _a = _this,
      marker = _a.marker,
      label = _a.label;
    marker.addPropertyListener('shape', _this.onMarkerShapeChange, _this);
    marker.addEventListener('change', _this.scheduleUpdate, _this);
    _this.addPropertyListener('xKey', function () {
      return _this.xData = [];
    });
    _this.addPropertyListener('yKey', function () {
      return _this.yData = [];
    });
    _this.addPropertyListener('sizeKey', function () {
      return _this.sizeData = [];
    });
    label.enabled = false;
    label.addEventListener('change', _this.scheduleUpdate, _this);
    label.addEventListener('dataChange', _this.scheduleData, _this);
    return _this;
  }
  Object.defineProperty(ScatterSeries.prototype, "fill", {
    get: function get() {
      return this._fill;
    },
    /**
     * @deprecated Use {@link marker.fill} instead.
     */
    set: function set(value) {
      if (this._fill !== value) {
        this._fill = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ScatterSeries.prototype, "stroke", {
    get: function get() {
      return this._stroke;
    },
    /**
     * @deprecated Use {@link marker.stroke} instead.
     */
    set: function set(value) {
      if (this._stroke !== value) {
        this._stroke = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ScatterSeries.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    /**
     * @deprecated Use {@link marker.strokeWidth} instead.
     */
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ScatterSeries.prototype, "fillOpacity", {
    get: function get() {
      return this._fillOpacity;
    },
    /**
     * @deprecated Use {@link marker.fillOpacity} instead.
     */
    set: function set(value) {
      if (this._fillOpacity !== value) {
        this._fillOpacity = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ScatterSeries.prototype, "strokeOpacity", {
    get: function get() {
      return this._strokeOpacity;
    },
    /**
     * @deprecated Use {@link marker.strokeOpacity} instead.
     */
    set: function set(value) {
      if (this._strokeOpacity !== value) {
        this._strokeOpacity = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  ScatterSeries.prototype.onHighlightChange = function () {
    this.updateMarkerNodes();
  };
  ScatterSeries.prototype.onMarkerShapeChange = function () {
    this.markerSelection = this.markerSelection.setData([]);
    this.markerSelection.exit.remove();
    this.fireEvent({
      type: 'legendChange'
    });
  };
  ScatterSeries.prototype.setColors = function (fills, strokes) {
    this.fill = fills[0];
    this.stroke = strokes[0];
    this.marker.fill = fills[0];
    this.marker.stroke = strokes[0];
  };
  ScatterSeries.prototype.processData = function () {
    var _a = this,
      xKey = _a.xKey,
      yKey = _a.yKey,
      sizeKey = _a.sizeKey,
      labelKey = _a.labelKey,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis,
      marker = _a.marker,
      label = _a.label;
    if (!xAxis || !yAxis) {
      return false;
    }
    var data = xKey && yKey && this.data ? this.data : [];
    this.xData = data.map(function (d) {
      return d[xKey];
    });
    this.yData = data.map(function (d) {
      return d[yKey];
    });
    this.sizeData = sizeKey ? data.map(function (d) {
      return d[sizeKey];
    }) : [];
    var font = label.getFont();
    this.labelData = labelKey ? data.map(function (d) {
      var text = String(d[labelKey]);
      var size = HdpiCanvas.getTextSize(text, font);
      return __assign$l({
        text: text
      }, size);
    }) : [];
    this.sizeScale.domain = marker.domain ? marker.domain : extent(this.sizeData, isContinuous) || [1, 1];
    if (xAxis.scale instanceof ContinuousScale) {
      this.xDomain = this.fixNumericExtent(extent(this.xData, isContinuous), 'x');
    } else {
      this.xDomain = this.xData;
    }
    if (yAxis.scale instanceof ContinuousScale) {
      this.yDomain = this.fixNumericExtent(extent(this.yData, isContinuous), 'y');
    } else {
      this.yDomain = this.yData;
    }
    return true;
  };
  ScatterSeries.prototype.getDomain = function (direction) {
    if (direction === ChartAxisDirection.X) {
      return this.xDomain;
    } else {
      return this.yDomain;
    }
  };
  ScatterSeries.prototype.getNodeData = function () {
    return this.nodeData;
  };
  ScatterSeries.prototype.getLabelData = function () {
    return this.nodeData;
  };
  ScatterSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      xKey: this.xKey,
      yKey: this.yKey,
      sizeKey: this.sizeKey
    });
  };
  ScatterSeries.prototype.createNodeData = function () {
    var _a = this,
      chart = _a.chart,
      data = _a.data,
      visible = _a.visible,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!(chart && data && visible && xAxis && yAxis) || chart.layoutPending || chart.dataPending) {
      return [];
    }
    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var isContinuousX = xScale instanceof ContinuousScale;
    var isContinuousY = yScale instanceof ContinuousScale;
    var xOffset = (xScale.bandwidth || 0) / 2;
    var yOffset = (yScale.bandwidth || 0) / 2;
    var _b = this,
      xData = _b.xData,
      yData = _b.yData,
      sizeData = _b.sizeData,
      sizeScale = _b.sizeScale,
      marker = _b.marker;
    var nodeData = [];
    sizeScale.range = [marker.size, marker.maxSize];
    for (var i = 0; i < xData.length; i++) {
      var xy = this.checkDomainXY(xData[i], yData[i], isContinuousX, isContinuousY);
      if (!xy) {
        continue;
      }
      var x = xScale.convert(xy[0]) + xOffset;
      var y = yScale.convert(xy[1]) + yOffset;
      if (!this.checkRangeXY(x, y, xAxis, yAxis)) {
        continue;
      }
      nodeData.push({
        series: this,
        datum: data[i],
        point: {
          x: x,
          y: y
        },
        size: sizeData.length ? sizeScale.convert(sizeData[i]) : marker.size,
        label: this.labelData[i]
      });
    }
    return this.nodeData = nodeData;
  };
  ScatterSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  ScatterSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    this.createNodeData();
    this.updateMarkerSelection();
    this.updateLabelSelection();
  };
  ScatterSeries.prototype.updateNodes = function () {
    this.group.visible = this.visible;
    this.updateMarkerNodes();
    this.updateLabelNodes();
  };
  ScatterSeries.prototype.updateLabelSelection = function () {
    var placedLabels = this.chart && this.chart.placeLabels().get(this) || [];
    var updateLabels = this.labelSelection.setData(placedLabels);
    updateLabels.exit.remove();
    var enterLabels = updateLabels.enter.append(Text);
    this.labelSelection = updateLabels.merge(enterLabels);
  };
  ScatterSeries.prototype.updateMarkerSelection = function () {
    var MarkerShape = getMarker(this.marker.shape);
    var updateMarkers = this.markerSelection.setData(this.nodeData);
    updateMarkers.exit.remove();
    var enterMarkers = updateMarkers.enter.append(MarkerShape);
    this.markerSelection = updateMarkers.merge(enterMarkers);
  };
  ScatterSeries.prototype.updateLabelNodes = function () {
    var label = this.label;
    this.labelSelection.each(function (text, datum) {
      text.text = datum.text;
      text.fill = label.color;
      text.x = datum.x;
      text.y = datum.y;
      text.fontStyle = label.fontStyle;
      text.fontWeight = label.fontWeight;
      text.fontSize = label.fontSize;
      text.fontFamily = label.fontFamily;
      text.textAlign = 'left';
      text.textBaseline = 'top';
    });
  };
  ScatterSeries.prototype.updateMarkerNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      marker = _a.marker,
      xKey = _a.xKey,
      yKey = _a.yKey,
      strokeWidth = _a.strokeWidth,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity,
      seriesFill = _a.fill,
      seriesStroke = _a.stroke,
      highlightedDatum = _a.chart.highlightedDatum,
      sizeScale = _a.sizeScale,
      sizeData = _a.sizeData,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    var markerStrokeWidth = marker.strokeWidth !== undefined ? marker.strokeWidth : strokeWidth;
    var formatter = marker.formatter;
    sizeScale.range = [marker.size, marker.maxSize];
    this.markerSelection.each(function (node, datum, index) {
      var isDatumHighlighted = datum === highlightedDatum;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : marker.fill || seriesFill;
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : marker.stroke || seriesStroke;
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : _this.getStrokeWidth(markerStrokeWidth, datum);
      var size = sizeData.length ? sizeScale.convert(sizeData[index]) : marker.size;
      var format = undefined;
      if (formatter) {
        format = formatter({
          datum: datum.datum,
          xKey: xKey,
          yKey: yKey,
          fill: fill,
          stroke: stroke,
          strokeWidth: strokeWidth,
          size: size,
          highlighted: isDatumHighlighted
        });
      }
      node.fill = format && format.fill || fill;
      node.stroke = format && format.stroke || stroke;
      node.strokeWidth = format && format.strokeWidth !== undefined ? format.strokeWidth : strokeWidth;
      node.size = format && format.size !== undefined ? format.size : size;
      node.fillOpacity = marker.fillOpacity !== undefined ? marker.fillOpacity : fillOpacity;
      node.strokeOpacity = marker.strokeOpacity !== undefined ? marker.strokeOpacity : strokeOpacity;
      node.translationX = datum.point.x;
      node.translationY = datum.point.y;
      node.opacity = _this.getOpacity(datum);
      node.zIndex = isDatumHighlighted ? Series.highlightedZIndex : index;
      node.visible = marker.enabled && node.size > 0;
    });
  };
  ScatterSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var _a = this,
      xKey = _a.xKey,
      yKey = _a.yKey,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!xKey || !yKey || !xAxis || !yAxis) {
      return '';
    }
    var _b = this,
      seriesFill = _b.fill,
      seriesStroke = _b.stroke,
      marker = _b.marker,
      tooltip = _b.tooltip,
      xName = _b.xName,
      yName = _b.yName,
      sizeKey = _b.sizeKey,
      sizeName = _b.sizeName,
      labelKey = _b.labelKey,
      labelName = _b.labelName;
    var fill = marker.fill || seriesFill;
    var stroke = marker.stroke || seriesStroke;
    var strokeWidth = this.getStrokeWidth(marker.strokeWidth || this.strokeWidth, nodeDatum);
    var formatter = this.marker.formatter;
    var format = undefined;
    if (formatter) {
      format = formatter({
        datum: nodeDatum,
        xKey: xKey,
        yKey: yKey,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        size: nodeDatum.size,
        highlighted: false
      });
    }
    var color = format && format.fill || fill || 'gray';
    var title = this.title || yName;
    var datum = nodeDatum.datum;
    var xValue = datum[xKey];
    var yValue = datum[yKey];
    var xString = sanitizeHtml(xAxis.formatDatum(xValue));
    var yString = sanitizeHtml(yAxis.formatDatum(yValue));
    var content = "<b>" + sanitizeHtml(xName || xKey) + "</b>: " + xString + "<br>" + ("<b>" + sanitizeHtml(yName || yKey) + "</b>: " + yString);
    if (sizeKey) {
      content += "<br><b>" + sanitizeHtml(sizeName || sizeKey) + "</b>: " + sanitizeHtml(datum[sizeKey]);
    }
    if (labelKey) {
      content = "<b>" + sanitizeHtml(labelName || labelKey) + "</b>: " + sanitizeHtml(datum[labelKey]) + "<br>" + content;
    }
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    var tooltipRenderer = tooltip.renderer;
    if (tooltipRenderer) {
      return toTooltipHtml(tooltipRenderer({
        datum: datum,
        xKey: xKey,
        xValue: xValue,
        xName: xName,
        yKey: yKey,
        yValue: yValue,
        yName: yName,
        sizeKey: sizeKey,
        sizeName: sizeName,
        labelKey: labelKey,
        labelName: labelName,
        title: title,
        color: color
      }), defaults);
    }
    return toTooltipHtml(defaults);
  };
  ScatterSeries.prototype.listSeriesItems = function (legendData) {
    var _a = this,
      id = _a.id,
      data = _a.data,
      xKey = _a.xKey,
      yKey = _a.yKey,
      yName = _a.yName,
      title = _a.title,
      visible = _a.visible,
      marker = _a.marker,
      fill = _a.fill,
      stroke = _a.stroke,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity;
    if (data && data.length && xKey && yKey) {
      legendData.push({
        id: id,
        itemId: undefined,
        enabled: visible,
        label: {
          text: title || yName || yKey
        },
        marker: {
          shape: marker.shape,
          fill: marker.fill || fill || 'rgba(0, 0, 0, 0)',
          stroke: marker.stroke || stroke || 'rgba(0, 0, 0, 0)',
          fillOpacity: marker.fillOpacity !== undefined ? marker.fillOpacity : fillOpacity,
          strokeOpacity: marker.strokeOpacity !== undefined ? marker.strokeOpacity : strokeOpacity
        }
      });
    }
  };
  ScatterSeries.className = 'ScatterSeries';
  ScatterSeries.type = 'scatter';
  __decorate$3f([reactive('layoutChange')], ScatterSeries.prototype, "title", void 0);
  __decorate$3f([reactive('dataChange')], ScatterSeries.prototype, "xKey", void 0);
  __decorate$3f([reactive('dataChange')], ScatterSeries.prototype, "yKey", void 0);
  __decorate$3f([reactive('dataChange')], ScatterSeries.prototype, "sizeKey", void 0);
  __decorate$3f([reactive('dataChange')], ScatterSeries.prototype, "labelKey", void 0);
  return ScatterSeries;
}(CartesianSeries);
var __extends$4c = undefined && undefined.__extends || function () {
  var _extendStatics277 = function extendStatics(d, b) {
    _extendStatics277 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics277(d, b);
  };
  return function (d, b) {
    _extendStatics277(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3g = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$j = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var HistogramSeriesNodeTag;
(function (HistogramSeriesNodeTag) {
  HistogramSeriesNodeTag[HistogramSeriesNodeTag["Bin"] = 0] = "Bin";
  HistogramSeriesNodeTag[HistogramSeriesNodeTag["Label"] = 1] = "Label";
})(HistogramSeriesNodeTag || (HistogramSeriesNodeTag = {}));
var HistogramSeriesLabel = /** @class */function (_super) {
  __extends$4c(HistogramSeriesLabel, _super);
  function HistogramSeriesLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3g([reactive('change')], HistogramSeriesLabel.prototype, "formatter", void 0);
  return HistogramSeriesLabel;
}(Label);
var defaultBinCount = 10;
var aggregationFunctions = {
  count: function count(bin) {
    return bin.data.length;
  },
  sum: function sum(bin, yKey) {
    return bin.data.reduce(function (acc, datum) {
      return acc + datum[yKey];
    }, 0);
  },
  mean: function mean(bin, yKey) {
    return aggregationFunctions.sum(bin, yKey) / aggregationFunctions.count(bin, yKey);
  }
};
var HistogramBin = /** @class */function () {
  function HistogramBin(_a) {
    var domainMin = _a[0],
      domainMax = _a[1];
    this.data = [];
    this.aggregatedValue = 0;
    this.frequency = 0;
    this.domain = [domainMin, domainMax];
  }
  HistogramBin.prototype.addDatum = function (datum) {
    this.data.push(datum);
    this.frequency++;
  };
  Object.defineProperty(HistogramBin.prototype, "domainWidth", {
    get: function get() {
      var _a = this.domain,
        domainMin = _a[0],
        domainMax = _a[1];
      return domainMax - domainMin;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramBin.prototype, "relativeHeight", {
    get: function get() {
      return this.aggregatedValue / this.domainWidth;
    },
    enumerable: true,
    configurable: true
  });
  HistogramBin.prototype.calculateAggregatedValue = function (aggregationName, yKey) {
    if (!yKey) {
      // not having a yKey forces us into a frequency plot
      aggregationName = 'count';
    }
    var aggregationFunction = aggregationFunctions[aggregationName];
    this.aggregatedValue = aggregationFunction(this, yKey);
  };
  HistogramBin.prototype.getY = function (areaPlot) {
    return areaPlot ? this.relativeHeight : this.aggregatedValue;
  };
  return HistogramBin;
}();
var HistogramSeriesTooltip = /** @class */function (_super) {
  __extends$4c(HistogramSeriesTooltip, _super);
  function HistogramSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3g([reactive('change')], HistogramSeriesTooltip.prototype, "renderer", void 0);
  return HistogramSeriesTooltip;
}(SeriesTooltip);
var HistogramSeries = /** @class */function (_super) {
  __extends$4c(HistogramSeries, _super);
  function HistogramSeries() {
    var _a;
    var _this = _super.call(this) || this;
    // Need to put column and label nodes into separate groups, because even though label nodes are
    // created after the column nodes, this only guarantees that labels will always be on top of columns
    // on the first run. If on the next run more columns are added, they might clip the labels
    // rendered during the previous run.
    _this.rectGroup = _this.pickGroup.appendChild(new Group());
    _this.textGroup = _this.group.appendChild(new Group());
    _this.rectSelection = Selection.select(_this.rectGroup).selectAll();
    _this.textSelection = Selection.select(_this.textGroup).selectAll();
    _this.binnedData = [];
    _this.xDomain = [];
    _this.yDomain = [];
    _this.label = new HistogramSeriesLabel();
    _this.seriesItemEnabled = true;
    _this.tooltip = new HistogramSeriesTooltip();
    _this.fill = undefined;
    _this.stroke = undefined;
    _this.fillOpacity = 1;
    _this.strokeOpacity = 1;
    _this.lineDash = [0];
    _this.lineDashOffset = 0;
    _this.directionKeys = (_a = {}, _a[ChartAxisDirection.X] = ['xKey'], _a[ChartAxisDirection.Y] = ['yKey'], _a);
    _this._xKey = '';
    _this._areaPlot = false;
    _this._bins = undefined;
    _this._aggregation = 'count';
    _this._binCount = undefined;
    _this._xName = '';
    _this._yKey = '';
    _this._yName = '';
    _this._strokeWidth = 1;
    _this.label.enabled = false;
    _this.label.addEventListener('change', _this.scheduleUpdate, _this);
    return _this;
  }
  HistogramSeries.prototype.getKeys = function (direction) {
    var _this = this;
    var directionKeys = this.directionKeys;
    var keys = directionKeys && directionKeys[direction];
    var values = [];
    if (keys) {
      keys.forEach(function (key) {
        var value = _this[key];
        if (value) {
          if (Array.isArray(value)) {
            values.push.apply(values, value);
          } else {
            values.push(value);
          }
        }
      });
    }
    return values;
  };
  Object.defineProperty(HistogramSeries.prototype, "xKey", {
    get: function get() {
      return this._xKey;
    },
    set: function set(value) {
      if (this._xKey !== value) {
        this._xKey = value;
        this.scheduleData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "areaPlot", {
    get: function get() {
      return this._areaPlot;
    },
    set: function set(c) {
      this._areaPlot = c;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "bins", {
    get: function get() {
      return this._bins;
    },
    set: function set(bins) {
      this._bins = bins;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "aggregation", {
    get: function get() {
      return this._aggregation;
    },
    set: function set(aggregation) {
      this._aggregation = aggregation;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "binCount", {
    get: function get() {
      return this._binCount;
    },
    set: function set(binCount) {
      this._binCount = binCount;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "xName", {
    get: function get() {
      return this._xName;
    },
    set: function set(value) {
      if (this._xName !== value) {
        this._xName = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "yKey", {
    get: function get() {
      return this._yKey;
    },
    set: function set(yKey) {
      this._yKey = yKey;
      this.seriesItemEnabled = true;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "yName", {
    get: function get() {
      return this._yName;
    },
    set: function set(values) {
      this._yName = values;
      this.scheduleData();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HistogramSeries.prototype, "shadow", {
    get: function get() {
      return this._shadow;
    },
    set: function set(value) {
      if (this._shadow !== value) {
        this._shadow = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  HistogramSeries.prototype.onHighlightChange = function () {
    this.updateRectNodes();
  };
  HistogramSeries.prototype.setColors = function (fills, strokes) {
    this.fill = fills[0];
    this.stroke = strokes[0];
  };
  // During processData phase, used to unify different ways of the user specifying
  // the bins. Returns bins in format[[min1, max1], [min2, max2], ... ].
  HistogramSeries.prototype.deriveBins = function () {
    var _this = this;
    var _a = this,
      bins = _a.bins,
      binCount = _a.binCount;
    if (!this.data) {
      return [];
    }
    if (bins) {
      return bins;
    }
    var xData = this.data.map(function (datum) {
      return datum[_this.xKey];
    });
    var xDomain = this.fixNumericExtent(extent(xData, isContinuous), 'x');
    var binStarts = ticks(xDomain[0], xDomain[1], this.binCount || defaultBinCount);
    var binSize = tickStep(xDomain[0], xDomain[1], this.binCount || defaultBinCount);
    var firstBinEnd = binStarts[0];
    var expandStartToBin = function expandStartToBin(n) {
      return [n, n + binSize];
    };
    return __spreadArrays$j([[firstBinEnd - binSize, firstBinEnd]], binStarts.map(expandStartToBin));
  };
  HistogramSeries.prototype.placeDataInBins = function (data) {
    var _this = this;
    var xKey = this.xKey;
    var derivedBins = this.deriveBins();
    // creating a sorted copy allows binning in O(n) rather than O(n²)
    // but at the expense of more temporary memory
    var sortedData = data.slice().sort(function (a, b) {
      if (a[xKey] < b[xKey]) {
        return -1;
      }
      if (a[xKey] > b[xKey]) {
        return 1;
      }
      return 0;
    });
    var currentBin = 0;
    var bins = [new HistogramBin(derivedBins[0])];
    loop: for (var i = 0, ln = sortedData.length; i < ln; i++) {
      var datum = sortedData[i];
      while (datum[xKey] > derivedBins[currentBin][1]) {
        currentBin++;
        var bin = derivedBins[currentBin];
        if (!bin) {
          break loop;
        }
        bins.push(new HistogramBin(bin));
      }
      bins[currentBin].addDatum(datum);
    }
    bins.forEach(function (b) {
      return b.calculateAggregatedValue(_this._aggregation, _this.yKey);
    });
    return bins;
  };
  Object.defineProperty(HistogramSeries.prototype, "xMax", {
    get: function get() {
      var _this = this;
      return this.data && this.data.reduce(function (acc, datum) {
        return Math.max(acc, datum[_this.xKey]);
      }, Number.NEGATIVE_INFINITY);
    },
    enumerable: true,
    configurable: true
  });
  HistogramSeries.prototype.processData = function () {
    var _this = this;
    var _a = this,
      xKey = _a.xKey,
      data = _a.data;
    this.binnedData = this.placeDataInBins(xKey && data ? data : []);
    var yData = this.binnedData.map(function (b) {
      return b.getY(_this.areaPlot);
    });
    var yMinMax = extent(yData, isContinuous);
    this.yDomain = this.fixNumericExtent([0, yMinMax ? yMinMax[1] : 1], 'y');
    var firstBin = this.binnedData[0];
    var lastBin = this.binnedData[this.binnedData.length - 1];
    var xMin = firstBin.domain[0];
    var xMax = lastBin.domain[1];
    this.xDomain = [xMin, xMax];
    this.fireEvent({
      type: 'dataProcessed'
    });
    return true;
  };
  HistogramSeries.prototype.getDomain = function (direction) {
    if (direction === ChartAxisDirection.X) {
      return this.xDomain;
    } else {
      return this.yDomain;
    }
  };
  HistogramSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      xKey: this.xKey
    });
  };
  HistogramSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  HistogramSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    var nodeData = this.createNodeData();
    this.updateRectSelection(nodeData);
    this.updateTextSelection(nodeData);
  };
  HistogramSeries.prototype.updateNodes = function () {
    this.group.visible = this.visible;
    this.updateRectNodes();
    this.updateTextNodes();
  };
  HistogramSeries.prototype.createNodeData = function () {
    var _this = this;
    var _a = this,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!this.seriesItemEnabled || !xAxis || !yAxis) {
      return [];
    }
    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var _b = this,
      fill = _b.fill,
      stroke = _b.stroke,
      strokeWidth = _b.strokeWidth;
    var nodeData = [];
    var defaultLabelFormatter = function defaultLabelFormatter(params) {
      return String(params.value);
    };
    var _c = this.label,
      _d = _c.formatter,
      labelFormatter = _d === void 0 ? defaultLabelFormatter : _d,
      labelFontStyle = _c.fontStyle,
      labelFontWeight = _c.fontWeight,
      labelFontSize = _c.fontSize,
      labelFontFamily = _c.fontFamily,
      labelColor = _c.color;
    this.binnedData.forEach(function (binOfData) {
      var total = binOfData.aggregatedValue,
        frequency = binOfData.frequency,
        _a = binOfData.domain,
        xDomainMin = _a[0],
        xDomainMax = _a[1],
        relativeHeight = binOfData.relativeHeight;
      var xMinPx = xScale.convert(xDomainMin),
        xMaxPx = xScale.convert(xDomainMax),
        // note: assuming can't be negative:
        y = _this.areaPlot ? relativeHeight : _this.yKey ? total : frequency,
        yZeroPx = yScale.convert(0),
        yMaxPx = yScale.convert(y),
        w = xMaxPx - xMinPx,
        h = Math.abs(yMaxPx - yZeroPx);
      var selectionDatumLabel = y !== 0 ? {
        text: labelFormatter({
          value: binOfData.aggregatedValue
        }),
        fontStyle: labelFontStyle,
        fontWeight: labelFontWeight,
        fontSize: labelFontSize,
        fontFamily: labelFontFamily,
        fill: labelColor,
        x: xMinPx + w / 2,
        y: yMaxPx + h / 2
      } : undefined;
      nodeData.push({
        series: _this,
        datum: binOfData,
        // since each selection is an aggregation of multiple data.
        x: xMinPx,
        y: yMaxPx,
        width: w,
        height: h,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        label: selectionDatumLabel
      });
    });
    return nodeData;
  };
  HistogramSeries.prototype.updateRectSelection = function (nodeData) {
    var updateRects = this.rectSelection.setData(nodeData);
    updateRects.exit.remove();
    var enterRects = updateRects.enter.append(Rect).each(function (rect) {
      rect.tag = HistogramSeriesNodeTag.Bin;
      rect.crisp = true;
    });
    this.rectSelection = updateRects.merge(enterRects);
  };
  HistogramSeries.prototype.updateRectNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity,
      shadow = _a.shadow,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    this.rectSelection.each(function (rect, datum, index) {
      var isDatumHighlighted = datum === highlightedDatum;
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : _this.getStrokeWidth(datum.strokeWidth, datum);
      rect.x = datum.x;
      rect.y = datum.y;
      rect.width = datum.width;
      rect.height = datum.height;
      rect.fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : datum.fill;
      rect.stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : datum.stroke;
      rect.fillOpacity = fillOpacity;
      rect.strokeOpacity = strokeOpacity;
      rect.strokeWidth = strokeWidth;
      rect.lineDash = _this.lineDash;
      rect.lineDashOffset = _this.lineDashOffset;
      rect.fillShadow = shadow;
      rect.zIndex = isDatumHighlighted ? Series.highlightedZIndex : index;
      rect.visible = datum.height > 0; // prevent stroke from rendering for zero height columns
      rect.opacity = _this.getOpacity(datum);
    });
  };
  HistogramSeries.prototype.updateTextSelection = function (nodeData) {
    var updateTexts = this.textSelection.setData(nodeData);
    updateTexts.exit.remove();
    var enterTexts = updateTexts.enter.append(Text).each(function (text) {
      text.tag = HistogramSeriesNodeTag.Label;
      text.pointerEvents = PointerEvents.None;
      text.textAlign = 'center';
      text.textBaseline = 'middle';
    });
    this.textSelection = updateTexts.merge(enterTexts);
  };
  HistogramSeries.prototype.updateTextNodes = function () {
    var labelEnabled = this.label.enabled;
    this.textSelection.each(function (text, datum) {
      var label = datum.label;
      if (label && labelEnabled) {
        text.text = label.text;
        text.x = label.x;
        text.y = label.y;
        text.fontStyle = label.fontStyle;
        text.fontWeight = label.fontWeight;
        text.fontSize = label.fontSize;
        text.fontFamily = label.fontFamily;
        text.fill = label.fill;
        text.visible = true;
      } else {
        text.visible = false;
      }
    });
  };
  HistogramSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var _a = this,
      xKey = _a.xKey,
      yKey = _a.yKey,
      xAxis = _a.xAxis,
      yAxis = _a.yAxis;
    if (!xKey || !xAxis || !yAxis) {
      return '';
    }
    var _b = this,
      xName = _b.xName,
      yName = _b.yName,
      color = _b.fill,
      tooltip = _b.tooltip,
      aggregation = _b.aggregation;
    var tooltipRenderer = tooltip.renderer;
    var bin = nodeDatum.datum;
    var aggregatedValue = bin.aggregatedValue,
      frequency = bin.frequency,
      _c = bin.domain,
      rangeMin = _c[0],
      rangeMax = _c[1];
    var title = sanitizeHtml(xName || xKey) + ": " + xAxis.formatDatum(rangeMin) + " - " + xAxis.formatDatum(rangeMax);
    var content = yKey ? "<b>" + sanitizeHtml(yName || yKey) + " (" + aggregation + ")</b>: " + yAxis.formatDatum(aggregatedValue) + "<br>" : '';
    content += "<b>Frequency</b>: " + frequency;
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    if (tooltipRenderer) {
      return toTooltipHtml(tooltipRenderer({
        datum: bin,
        xKey: xKey,
        xValue: bin.domain,
        xName: xName,
        yKey: yKey,
        yValue: bin.aggregatedValue,
        yName: yName,
        color: color
      }), defaults);
    }
    return toTooltipHtml(defaults);
  };
  HistogramSeries.prototype.listSeriesItems = function (legendData) {
    var _a = this,
      id = _a.id,
      data = _a.data,
      yKey = _a.yKey,
      yName = _a.yName,
      seriesItemEnabled = _a.seriesItemEnabled,
      fill = _a.fill,
      stroke = _a.stroke,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity;
    if (data && data.length) {
      legendData.push({
        id: id,
        itemId: yKey,
        enabled: seriesItemEnabled,
        label: {
          text: yName || yKey || 'Frequency'
        },
        marker: {
          fill: fill || 'rgba(0, 0, 0, 0)',
          stroke: stroke || 'rgba(0, 0, 0, 0)',
          fillOpacity: fillOpacity,
          strokeOpacity: strokeOpacity
        }
      });
    }
  };
  HistogramSeries.prototype.toggleSeriesItem = function (itemId, enabled) {
    if (itemId === this.yKey) {
      this.seriesItemEnabled = enabled;
    }
    this.scheduleData();
  };
  HistogramSeries.className = 'HistogramSeries';
  HistogramSeries.type = 'histogram';
  __decorate$3g([reactive('dataChange')], HistogramSeries.prototype, "fill", void 0);
  __decorate$3g([reactive('dataChange')], HistogramSeries.prototype, "stroke", void 0);
  __decorate$3g([reactive('layoutChange')], HistogramSeries.prototype, "fillOpacity", void 0);
  __decorate$3g([reactive('layoutChange')], HistogramSeries.prototype, "strokeOpacity", void 0);
  __decorate$3g([reactive('update')], HistogramSeries.prototype, "lineDash", void 0);
  __decorate$3g([reactive('update')], HistogramSeries.prototype, "lineDashOffset", void 0);
  return HistogramSeries;
}(CartesianSeries);
var __extends$4d = undefined && undefined.__extends || function () {
  var _extendStatics278 = function extendStatics(d, b) {
    _extendStatics278 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics278(d, b);
  };
  return function (d, b) {
    _extendStatics278(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3h = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HierarchySeries = /** @class */function (_super) {
  __extends$4d(HierarchySeries, _super);
  function HierarchySeries() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.data = undefined;
    return _this;
  }
  __decorate$3h([reactive('dataChange')], HierarchySeries.prototype, "data", void 0);
  return HierarchySeries;
}(Series);
var __extends$4e = undefined && undefined.__extends || function () {
  var _extendStatics279 = function extendStatics(d, b) {
    _extendStatics279 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics279(d, b);
  };
  return function (d, b) {
    _extendStatics279(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3i = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DropShadow = /** @class */function (_super) {
  __extends$4e(DropShadow, _super);
  function DropShadow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.enabled = true;
    _this.color = 'rgba(0, 0, 0, 0.5)';
    _this.xOffset = 0;
    _this.yOffset = 0;
    _this.blur = 5;
    return _this;
  }
  __decorate$3i([reactive('change')], DropShadow.prototype, "enabled", void 0);
  __decorate$3i([reactive('change')], DropShadow.prototype, "color", void 0);
  __decorate$3i([reactive('change')], DropShadow.prototype, "xOffset", void 0);
  __decorate$3i([reactive('change')], DropShadow.prototype, "yOffset", void 0);
  __decorate$3i([reactive('change')], DropShadow.prototype, "blur", void 0);
  return DropShadow;
}(Observable);
function slice$5(parent, x0, y0, x1, y1) {
  var nodes = parent.children;
  var k = parent.value && (y1 - y0) / parent.value;
  nodes.forEach(function (node) {
    node.x0 = x0;
    node.x1 = x1;
    node.y0 = y0;
    node.y1 = y0 += node.value * k;
  });
}
function dice(parent, x0, y0, x1, y1) {
  var nodes = parent.children;
  var k = parent.value && (x1 - x0) / parent.value;
  nodes.forEach(function (node) {
    node.x0 = x0;
    node.x1 = x0 += node.value * k;
    node.y0 = y0;
    node.y1 = y1;
  });
}
function roundNode(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [];
  var nodes = parent.children;
  var n = nodes.length;
  var value = parent.value;
  var i0 = 0;
  var i1 = 0;
  var dx;
  var dy;
  var nodeValue;
  var sumValue;
  var minValue;
  var maxValue;
  var newRatio;
  var minRatio;
  var alpha;
  var beta;
  while (i0 < n) {
    dx = x1 - x0;
    dy = y1 - y0;
    // Find the next non-empty node.
    do {
      sumValue = nodes[i1++].value;
    } while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);
    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      nodeValue = nodes[i1].value;
      sumValue += nodeValue;
      if (nodeValue < minValue) {
        minValue = nodeValue;
      }
      if (nodeValue > maxValue) {
        maxValue = nodeValue;
      }
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    // Position and record the row orientation.
    var row = {
      value: sumValue,
      dice: dx < dy,
      children: nodes.slice(i0, i1)
    };
    rows.push(row);
    if (row.dice) {
      dice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    } else {
      slice$5(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    }
    value -= sumValue;
    i0 = i1;
  }
  return rows;
}
var phi = (1 + Math.sqrt(5)) / 2;
var squarify = function custom(ratio) {
  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }
  squarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };
  return squarify;
}(phi);
var Treemap = /** @class */function () {
  function Treemap() {
    this.paddingStack = [0];
    this.dx = 1;
    this.dy = 1;
    this.round = true;
    this.tile = squarify;
    this.paddingInner = function (_) {
      return 0;
    };
    this.paddingTop = function (_) {
      return 0;
    };
    this.paddingRight = function (_) {
      return 0;
    };
    this.paddingBottom = function (_) {
      return 0;
    };
    this.paddingLeft = function (_) {
      return 0;
    };
  }
  Object.defineProperty(Treemap.prototype, "size", {
    get: function get() {
      return [this.dx, this.dy];
    },
    set: function set(size) {
      this.dx = size[0];
      this.dy = size[1];
    },
    enumerable: true,
    configurable: true
  });
  Treemap.prototype.processData = function (root) {
    root.x0 = 0;
    root.y0 = 0;
    root.x1 = this.dx;
    root.y1 = this.dy;
    root.eachBefore(this.positionNode.bind(this));
    this.paddingStack = [0];
    if (this.round) {
      root.eachBefore(roundNode);
    }
    return root;
  };
  Treemap.prototype.positionNode = function (node) {
    var p = this.paddingStack[node.depth];
    var x0 = node.x0 + p;
    var y0 = node.y0 + p;
    var x1 = node.x1 - p;
    var y1 = node.y1 - p;
    if (x1 < x0) {
      x0 = x1 = (x0 + x1) / 2;
    }
    if (y1 < y0) {
      y0 = y1 = (y0 + y1) / 2;
    }
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = this.paddingStack[node.depth + 1] = this.paddingInner(node) / 2;
      x0 += this.paddingLeft(node) - p;
      y0 += this.paddingTop(node) - p;
      x1 -= this.paddingRight(node) - p;
      y1 -= this.paddingBottom(node) - p;
      if (x1 < x0) {
        x0 = x1 = (x0 + x1) / 2;
      }
      if (y1 < y0) {
        y0 = y1 = (y0 + y1) / 2;
      }
      this.tile(node, x0, y0, x1, y1);
    }
  };
  return Treemap;
}();
var HierarchyNode = /** @class */function () {
  function HierarchyNode(datum) {
    this.value = 0;
    this.depth = 0;
    this.height = 0;
    this.parent = undefined;
    this.children = undefined;
    this.datum = datum;
  }
  HierarchyNode.prototype.countFn = function (node) {
    var sum = 0,
      children = node.children;
    if (!children || !children.length) {
      sum = 1;
    } else {
      var i = children.length;
      while (--i >= 0) {
        sum += children[i].value;
      }
    }
    node.value = sum;
  };
  HierarchyNode.prototype.count = function () {
    return this.eachAfter(this.countFn);
  };
  HierarchyNode.prototype.each = function (callback, scope) {
    var _this = this;
    var index = -1;
    this.iterator(function (node) {
      callback.call(scope, node, ++index, _this);
    });
    return this;
  };
  /**
   * Invokes the given callback for each node in post-order traversal.
   * @param callback
   * @param scope
   */
  HierarchyNode.prototype.eachAfter = function (callback, scope) {
    var node = this;
    var nodes = [node];
    var next = [];
    while (node = nodes.pop()) {
      next.push(node);
      var children = node.children;
      if (children) {
        for (var i = 0, n = children.length; i < n; ++i) {
          nodes.push(children[i]);
        }
      }
    }
    var index = -1;
    while (node = next.pop()) {
      callback.call(scope, node, ++index, this);
    }
    return this;
  };
  /**
   * Invokes the given callback for each node in pre-order traversal.
   * @param callback
   * @param scope
   */
  HierarchyNode.prototype.eachBefore = function (callback, scope) {
    var node = this;
    var nodes = [node];
    var index = -1;
    while (node = nodes.pop()) {
      callback.call(scope, node, ++index, this);
      var children = node.children;
      if (children) {
        for (var i = children.length - 1; i >= 0; --i) {
          var child = children[i];
          nodes.push(child);
        }
      }
    }
    return this;
  };
  HierarchyNode.prototype.find = function (callback, scope) {
    var _this = this;
    var index = -1;
    var result;
    this.iterator(function (node) {
      if (callback.call(scope, node, ++index, _this)) {
        result = node;
        return false;
      }
    });
    return result;
  };
  HierarchyNode.prototype.sum = function (value) {
    return this.eachAfter(function (node) {
      var sum = +value(node.datum) || 0;
      var children = node.children;
      if (children) {
        var i = children.length;
        while (--i >= 0) {
          sum += children[i].value;
        }
      }
      node.value = sum;
    });
  };
  HierarchyNode.prototype.sort = function (compare) {
    return this.eachBefore(function (node) {
      if (node.children) {
        node.children.sort(compare);
      }
    });
  };
  HierarchyNode.prototype.path = function (end) {
    var start = this;
    var ancestor = leastCommonAncestor(start, end);
    var nodes = [start];
    while (start !== ancestor) {
      start = start.parent;
      nodes.push(start);
    }
    var k = nodes.length;
    while (end !== ancestor) {
      nodes.splice(k, 0, end);
      end = end.parent;
    }
    // const otherBranch = [];
    // while (end !== ancestor) {
    //     otherBranch.push(end);
    //     end = end.parent;
    // }
    // nodes.concat(otherBranch.reverse());
    return nodes;
  };
  HierarchyNode.prototype.ancestors = function () {
    var node = this;
    var nodes = [node];
    while (node = node.parent) {
      nodes.push(node);
    }
    return nodes;
  };
  HierarchyNode.prototype.descendants = function () {
    var nodes = [];
    this.iterator(function (node) {
      return nodes.push(node);
    });
    return nodes;
  };
  HierarchyNode.prototype.leaves = function () {
    var leaves = [];
    this.eachBefore(function (node) {
      if (!node.children) {
        leaves.push(node);
      }
    });
    return leaves;
  };
  HierarchyNode.prototype.links = function () {
    var root = this;
    var links = [];
    root.each(function (node) {
      if (node !== root) {
        // Don’t include the root’s parent, if any.
        links.push({
          source: node.parent,
          target: node
        });
      }
    });
    return links;
  };
  HierarchyNode.prototype.copy = function () {
    // TODO
  };
  HierarchyNode.prototype.iterator = function (callback) {
    var node = this;
    var next = [node];
    var current;
    doLoop: do {
      current = next.reverse();
      next = [];
      while (node = current.pop()) {
        if (callback(node) === false) {
          break doLoop;
        }
        var children = node.children;
        if (children) {
          for (var i = 0, n = children.length; i < n; ++i) {
            next.push(children[i]);
          }
        }
      }
    } while (next.length);
  };
  return HierarchyNode;
}();
function hierarchy(data, children) {
  if (data instanceof Map) {
    data = [undefined, data];
    if (children === undefined) {
      children = mapChildren;
    }
  } else if (children === undefined) {
    children = objectChildren;
  }
  var root = new HierarchyNode(data);
  var nodes = [root];
  var node;
  var child, childs, i, n;
  while (node = nodes.pop()) {
    if ((childs = children(node.datum)) && (n = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new HierarchyNode(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }
  return root.eachBefore(computeHeight);
}
function computeHeight(node) {
  var height = 0;
  do {
    node.height = height;
  } while ((node = node.parent) && node.height < ++height);
}
function mapChildren(d) {
  return Array.isArray(d) ? d[1] : undefined;
}
function objectChildren(d) {
  return d.children;
}
function leastCommonAncestor(a, b) {
  if (!(a && b)) {
    return undefined;
  }
  if (a === b) {
    return a;
  }
  var aNodes = a.ancestors();
  var bNodes = b.ancestors();
  var c = undefined;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}
var __extends$4f = undefined && undefined.__extends || function () {
  var _extendStatics280 = function extendStatics(d, b) {
    _extendStatics280 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics280(d, b);
  };
  return function (d, b) {
    _extendStatics280(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3j = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TreemapSeriesTooltip = /** @class */function (_super) {
  __extends$4f(TreemapSeriesTooltip, _super);
  function TreemapSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3j([reactive('change')], TreemapSeriesTooltip.prototype, "renderer", void 0);
  return TreemapSeriesTooltip;
}(SeriesTooltip);
var TreemapSeriesLabel = /** @class */function (_super) {
  __extends$4f(TreemapSeriesLabel, _super);
  function TreemapSeriesLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.padding = 10;
    return _this;
  }
  __decorate$3j([reactive('change')], TreemapSeriesLabel.prototype, "padding", void 0);
  return TreemapSeriesLabel;
}(Label);
var TextNodeTag;
(function (TextNodeTag) {
  TextNodeTag[TextNodeTag["Name"] = 0] = "Name";
  TextNodeTag[TextNodeTag["Value"] = 1] = "Value";
})(TextNodeTag || (TextNodeTag = {}));
var TreemapSeries = /** @class */function (_super) {
  __extends$4f(TreemapSeries, _super);
  function TreemapSeries() {
    var _this = _super.call(this) || this;
    _this.groupSelection = Selection.select(_this.pickGroup).selectAll();
    _this.labelMap = new Map();
    _this.layout = new Treemap();
    _this.title = function () {
      var label = new TreemapSeriesLabel();
      label.color = 'white';
      label.fontWeight = 'bold';
      label.fontSize = 12;
      label.fontFamily = 'Verdana, sans-serif';
      label.padding = 15;
      return label;
    }();
    _this.subtitle = function () {
      var label = new TreemapSeriesLabel();
      label.color = 'white';
      label.fontSize = 9;
      label.fontFamily = 'Verdana, sans-serif';
      label.padding = 13;
      return label;
    }();
    _this.labels = {
      large: function () {
        var label = new Label();
        label.color = 'white';
        label.fontWeight = 'bold';
        label.fontSize = 18;
        return label;
      }(),
      medium: function () {
        var label = new Label();
        label.color = 'white';
        label.fontWeight = 'bold';
        label.fontSize = 14;
        return label;
      }(),
      small: function () {
        var label = new Label();
        label.color = 'white';
        label.fontWeight = 'bold';
        label.fontSize = 10;
        return label;
      }(),
      color: function () {
        var label = new Label();
        label.color = 'white';
        return label;
      }()
    };
    _this._nodePadding = 2;
    _this.labelKey = 'label';
    _this.sizeKey = 'size';
    _this.colorKey = 'color';
    _this.colorDomain = [-5, 5];
    _this.colorRange = ['#cb4b3f', '#6acb64'];
    _this.colorParents = false;
    _this.gradient = true;
    _this.colorName = 'Change';
    _this.rootName = 'Root';
    _this._shadow = function () {
      var shadow = new DropShadow();
      shadow.color = 'rgba(0, 0, 0, 0.4)';
      shadow.xOffset = 1.5;
      shadow.yOffset = 1.5;
      return shadow;
    }();
    _this.tooltip = new TreemapSeriesTooltip();
    _this.shadow.addEventListener('change', _this.scheduleUpdate, _this);
    _this.title.addEventListener('change', _this.scheduleUpdate, _this);
    _this.subtitle.addEventListener('change', _this.scheduleUpdate, _this);
    _this.labels.small.addEventListener('change', _this.scheduleUpdate, _this);
    _this.labels.medium.addEventListener('change', _this.scheduleUpdate, _this);
    _this.labels.large.addEventListener('change', _this.scheduleUpdate, _this);
    _this.labels.color.addEventListener('change', _this.scheduleUpdate, _this);
    return _this;
  }
  Object.defineProperty(TreemapSeries.prototype, "nodePadding", {
    get: function get() {
      return this._nodePadding;
    },
    set: function set(value) {
      if (this._nodePadding !== value) {
        this._nodePadding = value;
        this.updateLayoutPadding();
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TreemapSeries.prototype, "shadow", {
    get: function get() {
      return this._shadow;
    },
    set: function set(value) {
      if (this._shadow !== value) {
        this._shadow = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  TreemapSeries.prototype.onHighlightChange = function () {
    this.updateNodes();
  };
  TreemapSeries.prototype.updateLayoutPadding = function () {
    var _a = this,
      title = _a.title,
      subtitle = _a.subtitle,
      nodePadding = _a.nodePadding,
      labelKey = _a.labelKey;
    this.layout.paddingRight = function (_) {
      return nodePadding;
    };
    this.layout.paddingBottom = function (_) {
      return nodePadding;
    };
    this.layout.paddingLeft = function (_) {
      return nodePadding;
    };
    this.layout.paddingTop = function (node) {
      var name = node.datum[labelKey] || '';
      if (node.children) {
        name = name.toUpperCase();
      }
      var font = node.depth > 1 ? subtitle : title;
      var textSize = HdpiCanvas.getTextSize(name, [font.fontWeight, font.fontSize + 'px', font.fontFamily].join(' ').trim());
      var innerNodeWidth = node.x1 - node.x0 - nodePadding * 2;
      var hasTitle = node.depth > 0 && node.children && textSize.width <= innerNodeWidth;
      node.hasTitle = !!hasTitle;
      return hasTitle ? textSize.height + nodePadding * 2 : nodePadding;
    };
  };
  TreemapSeries.prototype.processData = function () {
    if (!this.data) {
      return false;
    }
    var _a = this,
      data = _a.data,
      sizeKey = _a.sizeKey,
      labelKey = _a.labelKey,
      colorKey = _a.colorKey,
      colorDomain = _a.colorDomain,
      colorRange = _a.colorRange,
      colorParents = _a.colorParents;
    var dataRoot;
    if (sizeKey) {
      dataRoot = hierarchy(data).sum(function (datum) {
        return datum.children ? 1 : datum[sizeKey];
      });
    } else {
      dataRoot = hierarchy(data).sum(function (datum) {
        return datum.children ? 0 : 1;
      });
    }
    this.dataRoot = dataRoot;
    var colorScale = new LinearScale();
    colorScale.domain = colorDomain;
    colorScale.range = colorRange;
    var series = this;
    function traverse(root, depth) {
      if (depth === void 0) {
        depth = 0;
      }
      var children = root.children,
        datum = root.datum;
      var label = datum[labelKey];
      var colorValue = colorKey ? datum[colorKey] : depth;
      root.series = series;
      root.fill = !children || colorParents ? colorScale.convert(colorValue) : '#272931';
      root.colorValue = colorValue;
      if (label) {
        root.label = children ? label.toUpperCase() : label;
      } else {
        root.label = '';
      }
      if (children) {
        children.forEach(function (child) {
          return traverse(child, depth + 1);
        });
      }
    }
    traverse(this.dataRoot);
    return true;
  };
  TreemapSeries.prototype.getLabelCenterX = function (datum) {
    return (datum.x0 + datum.x1) / 2;
  };
  TreemapSeries.prototype.getLabelCenterY = function (datum) {
    return (datum.y0 + datum.y1) / 2 + 2;
  };
  TreemapSeries.prototype.update = function () {
    this.updatePending = false;
    this.updateSelections();
    this.updateNodes();
  };
  TreemapSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    var _a = this,
      chart = _a.chart,
      dataRoot = _a.dataRoot;
    if (!chart || !dataRoot) {
      return;
    }
    var seriesRect = chart.getSeriesRect();
    if (!seriesRect) {
      return;
    }
    this.layout.size = [seriesRect.width, seriesRect.height];
    this.updateLayoutPadding();
    var descendants = this.layout.processData(dataRoot).descendants();
    var updateGroups = this.groupSelection.setData(descendants);
    updateGroups.exit.remove();
    var enterGroups = updateGroups.enter.append(Group);
    enterGroups.append(Rect);
    enterGroups.append(Text).each(function (node) {
      return node.tag = TextNodeTag.Name;
    });
    enterGroups.append(Text).each(function (node) {
      return node.tag = TextNodeTag.Value;
    });
    this.groupSelection = updateGroups.merge(enterGroups);
  };
  TreemapSeries.prototype.updateNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    var _a = this,
      colorKey = _a.colorKey,
      labelMap = _a.labelMap,
      nodePadding = _a.nodePadding,
      title = _a.title,
      subtitle = _a.subtitle,
      labels = _a.labels,
      shadow = _a.shadow,
      gradient = _a.gradient,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f;
    this.groupSelection.selectByClass(Rect).each(function (rect, datum) {
      var isDatumHighlighted = datum === highlightedDatum;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : datum.fill;
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : datum.depth < 2 ? undefined : 'black';
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : _this.getStrokeWidth(1, datum);
      rect.fill = fill;
      rect.stroke = stroke;
      rect.strokeWidth = strokeWidth;
      rect.crisp = true;
      rect.gradient = gradient;
      rect.x = datum.x0;
      rect.y = datum.y0;
      rect.width = datum.x1 - datum.x0;
      rect.height = datum.y1 - datum.y0;
    });
    this.groupSelection.selectByTag(TextNodeTag.Name).each(function (text, datum, index) {
      var isLeaf = !datum.children;
      var innerNodeWidth = datum.x1 - datum.x0 - nodePadding * 2;
      var innerNodeHeight = datum.y1 - datum.y0 - nodePadding * 2;
      var hasTitle = datum.hasTitle;
      var highlighted = datum === highlightedDatum;
      var label;
      if (isLeaf) {
        if (innerNodeWidth > 40 && innerNodeHeight > 40) {
          label = labels.large;
        } else if (innerNodeWidth > 20 && innerNodeHeight > 20) {
          label = labels.medium;
        } else {
          label = labels.small;
        }
      } else {
        if (datum.depth > 1) {
          label = subtitle;
        } else {
          label = title;
        }
      }
      text.fontWeight = label.fontWeight;
      text.fontSize = label.fontSize;
      text.fontFamily = label.fontFamily;
      text.textBaseline = isLeaf ? 'bottom' : hasTitle ? 'top' : 'middle';
      text.textAlign = hasTitle ? 'left' : 'center';
      text.text = datum.label;
      var textBBox = text.computeBBox();
      var hasLabel = isLeaf && !!textBBox && textBBox.width <= innerNodeWidth && textBBox.height * 2 + 8 <= innerNodeHeight;
      labelMap.set(index, text);
      text.fill = highlighted ? 'black' : label.color;
      text.fillShadow = hasLabel && !highlighted ? shadow : undefined;
      text.visible = hasTitle || hasLabel;
      if (hasTitle) {
        text.x = datum.x0 + nodePadding;
        text.y = datum.y0 + nodePadding;
      } else {
        text.x = _this.getLabelCenterX(datum);
        text.y = _this.getLabelCenterY(datum);
      }
    });
    this.groupSelection.selectByTag(TextNodeTag.Value).each(function (text, datum, index) {
      var isLeaf = !datum.children;
      var innerNodeWidth = datum.x1 - datum.x0 - nodePadding * 2;
      var highlighted = datum === highlightedDatum;
      var value = datum.colorValue;
      var label = labels.color;
      text.fontSize = label.fontSize;
      text.fontFamily = label.fontFamily;
      text.fontStyle = label.fontStyle;
      text.fontWeight = label.fontWeight;
      text.textBaseline = 'top';
      text.textAlign = 'center';
      text.text = typeof value === 'number' && isFinite(value) ? String(toFixed(datum.colorValue)) + '%' : '';
      var textBBox = text.computeBBox();
      var nameNode = labelMap.get(index);
      var hasLabel = !!nameNode && nameNode.visible;
      var isVisible = isLeaf && !!colorKey && hasLabel && !!textBBox && textBBox.width < innerNodeWidth;
      text.fill = highlighted ? 'black' : label.color;
      text.fillShadow = highlighted ? undefined : shadow;
      text.visible = isVisible;
      if (isVisible) {
        text.x = _this.getLabelCenterX(datum);
        text.y = _this.getLabelCenterY(datum);
      } else {
        if (nameNode && !(datum.children && datum.children.length)) {
          nameNode.textBaseline = 'middle';
          nameNode.y = _this.getLabelCenterY(datum);
        }
      }
    });
  };
  TreemapSeries.prototype.getDomain = function (direction) {
    return [0, 1];
  };
  TreemapSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      labelKey: this.labelKey,
      sizeKey: this.sizeKey,
      colorKey: this.colorKey
    });
  };
  TreemapSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var _a = this,
      tooltip = _a.tooltip,
      sizeKey = _a.sizeKey,
      labelKey = _a.labelKey,
      colorKey = _a.colorKey,
      colorName = _a.colorName,
      rootName = _a.rootName;
    var datum = nodeDatum.datum;
    var tooltipRenderer = tooltip.renderer;
    var title = nodeDatum.depth ? datum[labelKey] : rootName || datum[labelKey];
    var content = undefined;
    var color = nodeDatum.fill || 'gray';
    if (colorKey && colorName) {
      var colorValue = datum[colorKey];
      if (typeof colorValue === 'number' && isFinite(colorValue)) {
        content = "<b>" + colorName + "</b>: " + toFixed(datum[colorKey]);
      }
    }
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    if (tooltipRenderer) {
      return toTooltipHtml(tooltipRenderer({
        datum: nodeDatum,
        sizeKey: sizeKey,
        labelKey: labelKey,
        colorKey: colorKey,
        title: title,
        color: color
      }), defaults);
    }
    return toTooltipHtml(defaults);
  };
  TreemapSeries.prototype.listSeriesItems = function (legendData) {};
  TreemapSeries.className = 'TreemapSeries';
  TreemapSeries.type = 'treemap';
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "labelKey", void 0);
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "sizeKey", void 0);
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "colorKey", void 0);
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "colorDomain", void 0);
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "colorRange", void 0);
  __decorate$3j([reactive('dataChange')], TreemapSeries.prototype, "colorParents", void 0);
  __decorate$3j([reactive('update')], TreemapSeries.prototype, "gradient", void 0);
  return TreemapSeries;
}(HierarchySeries);
var __extends$4g = undefined && undefined.__extends || function () {
  var _extendStatics281 = function extendStatics(d, b) {
    _extendStatics281 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics281(d, b);
  };
  return function (d, b) {
    _extendStatics281(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Sector = /** @class */function (_super) {
  __extends$4g(Sector, _super);
  function Sector() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._centerX = 0;
    _this._centerY = 0;
    _this._centerOffset = 0;
    _this._innerRadius = 10;
    _this._outerRadius = 20;
    _this._startAngle = 0;
    _this._endAngle = Math.PI * 2;
    _this._angleOffset = 0;
    return _this;
  }
  Object.defineProperty(Sector.prototype, "centerX", {
    get: function get() {
      return this._centerX;
    },
    set: function set(value) {
      if (this._centerX !== value) {
        this._centerX = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "centerY", {
    get: function get() {
      return this._centerY;
    },
    set: function set(value) {
      if (this._centerY !== value) {
        this._centerY = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "centerOffset", {
    get: function get() {
      return this._centerOffset;
    },
    set: function set(value) {
      if (this._centerOffset !== value) {
        this._centerOffset = Math.max(0, value);
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "innerRadius", {
    get: function get() {
      return this._innerRadius;
    },
    set: function set(value) {
      if (this._innerRadius !== value) {
        this._innerRadius = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "outerRadius", {
    get: function get() {
      return this._outerRadius;
    },
    set: function set(value) {
      if (this._outerRadius !== value) {
        this._outerRadius = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "startAngle", {
    get: function get() {
      return this._startAngle;
    },
    set: function set(value) {
      if (this._startAngle !== value) {
        this._startAngle = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "endAngle", {
    get: function get() {
      return this._endAngle;
    },
    set: function set(value) {
      if (this._endAngle !== value) {
        this._endAngle = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sector.prototype, "angleOffset", {
    get: function get() {
      return this._angleOffset;
    },
    set: function set(value) {
      if (this._angleOffset !== value) {
        this._angleOffset = value;
        this.dirtyPath = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Sector.prototype.computeBBox = function () {
    var radius = this.outerRadius;
    return new BBox(this.centerX - radius, this.centerY - radius, radius * 2, radius * 2);
  };
  Sector.prototype.isFullPie = function () {
    return isEqual(normalizeAngle360(this.startAngle), normalizeAngle360(this.endAngle));
  };
  Sector.prototype.updatePath = function () {
    var path = this.path;
    var angleOffset = this.angleOffset;
    var startAngle = Math.min(this.startAngle, this.endAngle) + angleOffset;
    var endAngle = Math.max(this.startAngle, this.endAngle) + angleOffset;
    var midAngle = (startAngle + endAngle) * 0.5;
    var innerRadius = Math.min(this.innerRadius, this.outerRadius);
    var outerRadius = Math.max(this.innerRadius, this.outerRadius);
    var centerOffset = this.centerOffset;
    var fullPie = this.isFullPie();
    var centerX = this.centerX;
    var centerY = this.centerY;
    path.clear();
    if (centerOffset) {
      centerX += centerOffset * Math.cos(midAngle);
      centerY += centerOffset * Math.sin(midAngle);
    }
    if (!fullPie) {
      path.moveTo(centerX + innerRadius * Math.cos(startAngle), centerY + innerRadius * Math.sin(startAngle));
      // if (showTip) {
      //     path.lineTo(
      //         centerX + 0.5 * (innerRadius + outerRadius) * Math.cos(startAngle) + tipOffset * Math.cos(startAngle + Math.PI / 2),
      //         centerY + 0.5 * (innerRadius + outerRadius) * Math.sin(startAngle) + tipOffset * Math.sin(startAngle + Math.PI / 2)
      //     );
      // }
      path.lineTo(centerX + outerRadius * Math.cos(startAngle), centerY + outerRadius * Math.sin(startAngle));
    }
    path.cubicArc(centerX, centerY, outerRadius, outerRadius, 0, startAngle, endAngle, 0);
    // path[fullPie ? 'moveTo' : 'lineTo'](
    //     centerX + innerRadius * Math.cos(endAngle),
    //     centerY + innerRadius * Math.sin(endAngle)
    // );
    if (fullPie) {
      path.moveTo(centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle));
    } else {
      // if (showTip) {
      //     path.lineTo(
      //         centerX + 0.5 * (innerRadius + outerRadius) * Math.cos(endAngle) + tipOffset * Math.cos(endAngle + Math.PI / 2),
      //         centerY + 0.5 * (innerRadius + outerRadius) * Math.sin(endAngle) + tipOffset * Math.sin(endAngle + Math.PI / 2)
      //     );
      // }
      // Temp workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=993330
      // Revert this commit when fixed ^^.
      var x = centerX + innerRadius * Math.cos(endAngle);
      path.lineTo(Math.abs(x) < 1e-8 ? 0 : x, centerY + innerRadius * Math.sin(endAngle));
    }
    path.cubicArc(centerX, centerY, innerRadius, innerRadius, 0, endAngle, startAngle, 1);
    path.closePath();
    this.dirtyPath = false;
  };
  Sector.className = 'Sector';
  return Sector;
}(Path);
var __extends$4h = undefined && undefined.__extends || function () {
  var _extendStatics282 = function extendStatics(d, b) {
    _extendStatics282 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics282(d, b);
  };
  return function (d, b) {
    _extendStatics282(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3k = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PieHighlightStyle = /** @class */function (_super) {
  __extends$4h(PieHighlightStyle, _super);
  function PieHighlightStyle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return PieHighlightStyle;
}(HighlightStyle);
var PieNodeTag;
(function (PieNodeTag) {
  PieNodeTag[PieNodeTag["Sector"] = 0] = "Sector";
  PieNodeTag[PieNodeTag["Callout"] = 1] = "Callout";
  PieNodeTag[PieNodeTag["Label"] = 2] = "Label";
})(PieNodeTag || (PieNodeTag = {}));
var PieSeriesLabel = /** @class */function (_super) {
  __extends$4h(PieSeriesLabel, _super);
  function PieSeriesLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.offset = 3; // from the callout line
    _this.minAngle = 20; // in degrees
    return _this;
  }
  __decorate$3k([reactive('change')], PieSeriesLabel.prototype, "offset", void 0);
  __decorate$3k([reactive('dataChange')], PieSeriesLabel.prototype, "minAngle", void 0);
  __decorate$3k([reactive('dataChange')], PieSeriesLabel.prototype, "formatter", void 0);
  return PieSeriesLabel;
}(Label);
var PieSeriesCallout = /** @class */function (_super) {
  __extends$4h(PieSeriesCallout, _super);
  function PieSeriesCallout() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.colors = ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'];
    _this.length = 10;
    _this.strokeWidth = 1;
    return _this;
  }
  __decorate$3k([reactive('change')], PieSeriesCallout.prototype, "colors", void 0);
  __decorate$3k([reactive('change')], PieSeriesCallout.prototype, "length", void 0);
  __decorate$3k([reactive('change')], PieSeriesCallout.prototype, "strokeWidth", void 0);
  return PieSeriesCallout;
}(Observable);
var PieSeriesTooltip = /** @class */function (_super) {
  __extends$4h(PieSeriesTooltip, _super);
  function PieSeriesTooltip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate$3k([reactive('change')], PieSeriesTooltip.prototype, "renderer", void 0);
  return PieSeriesTooltip;
}(SeriesTooltip);
var PieTitle = /** @class */function (_super) {
  __extends$4h(PieTitle, _super);
  function PieTitle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.showInLegend = false;
    return _this;
  }
  __decorate$3k([reactive()], PieTitle.prototype, "showInLegend", void 0);
  return PieTitle;
}(Caption);
var PieSeries = /** @class */function (_super) {
  __extends$4h(PieSeries, _super);
  function PieSeries() {
    var _this = _super.call(this) || this;
    _this.radiusScale = new LinearScale();
    _this.groupSelection = Selection.select(_this.pickGroup).selectAll();
    /**
     * The processed data that gets visualized.
     */
    _this.groupSelectionData = [];
    _this.angleScale = function () {
      var scale = new LinearScale();
      // Each slice is a ratio of the whole, where all ratios add up to 1.
      scale.domain = [0, 1];
      // Add 90 deg to start the first pie at 12 o'clock.
      scale.range = [-Math.PI, Math.PI].map(function (angle) {
        return angle + Math.PI / 2;
      });
      return scale;
    }();
    // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
    _this.seriesItemEnabled = [];
    _this.label = new PieSeriesLabel();
    _this.callout = new PieSeriesCallout();
    _this.tooltip = new PieSeriesTooltip();
    /**
     * The key of the numeric field to use to determine the angle (for example,
     * a pie slice angle).
     */
    _this.angleKey = '';
    _this.angleName = '';
    _this._fills = ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'];
    _this._strokes = ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'];
    _this.fillOpacity = 1;
    _this.strokeOpacity = 1;
    _this.lineDash = [0];
    _this.lineDashOffset = 0;
    /**
     * The series rotation in degrees.
     */
    _this.rotation = 0;
    _this.outerRadiusOffset = 0;
    _this.innerRadiusOffset = 0;
    _this.strokeWidth = 1;
    _this.highlightStyle = new PieHighlightStyle();
    _this.addEventListener('update', _this.scheduleUpdate, _this);
    _this.label.addEventListener('change', _this.scheduleUpdate, _this);
    _this.label.addEventListener('dataChange', _this.scheduleData, _this);
    _this.callout.addEventListener('change', _this.scheduleLayout, _this);
    _this.addPropertyListener('data', function (event) {
      if (event.value) {
        event.source.seriesItemEnabled = event.value.map(function () {
          return true;
        });
      }
    });
    return _this;
  }
  Object.defineProperty(PieSeries.prototype, "title", {
    get: function get() {
      return this._title;
    },
    set: function set(value) {
      var oldTitle = this._title;
      function updateLegend() {
        this.fireEvent({
          type: 'legendChange'
        });
      }
      if (oldTitle !== value) {
        if (oldTitle) {
          oldTitle.removeEventListener('change', this.scheduleUpdate, this);
          oldTitle.addPropertyListener('showInLegend', updateLegend, this);
          this.group.removeChild(oldTitle.node);
        }
        if (value) {
          value.node.textBaseline = 'bottom';
          value.addEventListener('change', this.scheduleUpdate, this);
          value.addPropertyListener('showInLegend', updateLegend, this);
          this.group.appendChild(value.node);
        }
        this._title = value;
        this.scheduleUpdate();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PieSeries.prototype, "fills", {
    get: function get() {
      return this._fills;
    },
    set: function set(values) {
      this._fills = values;
      this.scheduleUpdate();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PieSeries.prototype, "strokes", {
    get: function get() {
      return this._strokes;
    },
    set: function set(values) {
      this._strokes = values;
      this.scheduleUpdate();
    },
    enumerable: true,
    configurable: true
  });
  PieSeries.prototype.onHighlightChange = function () {
    this.updateNodes();
  };
  PieSeries.prototype.setColors = function (fills, strokes) {
    this.fills = fills;
    this.strokes = strokes;
    this.callout.colors = strokes;
  };
  PieSeries.prototype.getDomain = function (direction) {
    if (direction === ChartAxisDirection.X) {
      return this.angleScale.domain;
    } else {
      return this.radiusScale.domain;
    }
  };
  PieSeries.prototype.processData = function () {
    var _this = this;
    var _a = this,
      angleKey = _a.angleKey,
      radiusKey = _a.radiusKey,
      seriesItemEnabled = _a.seriesItemEnabled,
      angleScale = _a.angleScale,
      groupSelectionData = _a.groupSelectionData,
      label = _a.label;
    var data = angleKey && this.data ? this.data : [];
    var angleData = data.map(function (datum, index) {
      return seriesItemEnabled[index] && Math.abs(+datum[angleKey]) || 0;
    });
    var angleDataTotal = angleData.reduce(function (a, b) {
      return a + b;
    }, 0);
    // The ratios (in [0, 1] interval) used to calculate the end angle value for every pie slice.
    // Each slice starts where the previous one ends, so we only keep the ratios for end angles.
    var angleDataRatios = function () {
      var sum = 0;
      return angleData.map(function (datum) {
        return sum += datum / angleDataTotal;
      });
    }();
    var labelFormatter = label.formatter;
    var labelKey = label.enabled && this.labelKey;
    var labelData = [];
    var radiusData = [];
    if (labelKey) {
      if (labelFormatter) {
        labelData = data.map(function (datum) {
          return labelFormatter({
            value: datum[labelKey]
          });
        });
      } else {
        labelData = data.map(function (datum) {
          return String(datum[labelKey]);
        });
      }
    }
    if (radiusKey) {
      var _b = this,
        radiusMin = _b.radiusMin,
        radiusMax = _b.radiusMax;
      var radii = data.map(function (datum) {
        return Math.abs(datum[radiusKey]);
      });
      var min_1 = radiusMin !== undefined ? radiusMin : Math.min.apply(Math, radii);
      var max = radiusMax !== undefined ? radiusMax : Math.max.apply(Math, radii);
      var delta_1 = max - min_1;
      radiusData = radii.map(function (value) {
        return delta_1 ? (value - min_1) / delta_1 : 1;
      });
    }
    groupSelectionData.length = 0;
    var rotation = toRadians(this.rotation);
    var halfPi = Math.PI / 2;
    var datumIndex = 0;
    // Simply use reduce here to pair up adjacent ratios.
    angleDataRatios.reduce(function (start, end) {
      var radius = radiusKey ? radiusData[datumIndex] : 1;
      var startAngle = angleScale.convert(start) + rotation;
      var endAngle = angleScale.convert(end) + rotation;
      var midAngle = (startAngle + endAngle) / 2;
      var span = Math.abs(endAngle - startAngle);
      var midCos = Math.cos(midAngle);
      var midSin = Math.sin(midAngle);
      var labelMinAngle = toRadians(label.minAngle);
      var labelVisible = labelKey && span > labelMinAngle;
      var midAngle180 = normalizeAngle180(midAngle);
      // Split the circle into quadrants like so: ⊗
      var quadrantStart = -3 * Math.PI / 4; // same as `normalizeAngle180(toRadians(-135))`
      var textAlign;
      var textBaseline;
      if (midAngle180 >= quadrantStart && midAngle180 < (quadrantStart += halfPi)) {
        textAlign = 'center';
        textBaseline = 'bottom';
      } else if (midAngle180 >= quadrantStart && midAngle180 < (quadrantStart += halfPi)) {
        textAlign = 'left';
        textBaseline = 'middle';
      } else if (midAngle180 >= quadrantStart && midAngle180 < (quadrantStart += halfPi)) {
        textAlign = 'center';
        textBaseline = 'hanging';
      } else {
        textAlign = 'right';
        textBaseline = 'middle';
      }
      groupSelectionData.push({
        series: _this,
        datum: data[datumIndex],
        itemId: datumIndex,
        index: datumIndex,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle,
        midAngle: midAngle,
        midCos: midCos,
        midSin: midSin,
        label: labelVisible ? {
          text: labelData[datumIndex],
          textAlign: textAlign,
          textBaseline: textBaseline
        } : undefined
      });
      datumIndex++;
      return end;
    }, 0);
    return true;
  };
  PieSeries.prototype.update = function () {
    this.updatePending = false;
    var _a = this,
      radius = _a.radius,
      innerRadiusOffset = _a.innerRadiusOffset,
      outerRadiusOffset = _a.outerRadiusOffset,
      title = _a.title;
    this.radiusScale.range = [innerRadiusOffset ? radius + innerRadiusOffset : 0, radius + (outerRadiusOffset || 0)];
    this.group.translationX = this.centerX;
    this.group.translationY = this.centerY;
    if (title) {
      title.node.translationY = -radius - outerRadiusOffset - 2;
      title.node.visible = title.enabled;
    }
    this.updateSelections();
    this.updateNodes();
  };
  PieSeries.prototype.updateSelections = function () {
    if (!this.nodeDataPending) {
      return;
    }
    this.nodeDataPending = false;
    this.updateGroupSelection();
  };
  PieSeries.prototype.updateGroupSelection = function () {
    var updateGroups = this.groupSelection.setData(this.groupSelectionData);
    updateGroups.exit.remove();
    var enterGroups = updateGroups.enter.append(Group);
    enterGroups.append(Sector).each(function (node) {
      return node.tag = PieNodeTag.Sector;
    });
    enterGroups.append(Line).each(function (node) {
      node.tag = PieNodeTag.Callout;
      node.pointerEvents = PointerEvents.None;
    });
    enterGroups.append(Text).each(function (node) {
      node.tag = PieNodeTag.Label;
      node.pointerEvents = PointerEvents.None;
    });
    this.groupSelection = updateGroups.merge(enterGroups);
  };
  PieSeries.prototype.updateNodes = function () {
    var _this = this;
    if (!this.chart) {
      return;
    }
    this.group.visible = this.visible && this.seriesItemEnabled.indexOf(true) >= 0;
    var _a = this,
      fills = _a.fills,
      strokes = _a.strokes,
      fillOpacity = _a.fillOpacity,
      strokeOpacity = _a.strokeOpacity,
      radiusScale = _a.radiusScale,
      callout = _a.callout,
      shadow = _a.shadow,
      highlightedDatum = _a.chart.highlightedDatum,
      _b = _a.highlightStyle,
      deprecatedFill = _b.fill,
      deprecatedStroke = _b.stroke,
      deprecatedStrokeWidth = _b.strokeWidth,
      _c = _b.item,
      _d = _c.fill,
      highlightedFill = _d === void 0 ? deprecatedFill : _d,
      _e = _c.stroke,
      highlightedStroke = _e === void 0 ? deprecatedStroke : _e,
      _f = _c.strokeWidth,
      highlightedDatumStrokeWidth = _f === void 0 ? deprecatedStrokeWidth : _f,
      angleKey = _a.angleKey,
      radiusKey = _a.radiusKey,
      formatter = _a.formatter;
    var centerOffsets = [];
    var innerRadius = radiusScale.convert(0);
    this.groupSelection.selectByTag(PieNodeTag.Sector).each(function (sector, datum, index) {
      var radius = radiusScale.convert(datum.radius);
      var isDatumHighlighted = !!highlightedDatum && highlightedDatum.series === _this && datum.itemId === highlightedDatum.itemId;
      var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : fills[index % fills.length];
      var stroke = isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : strokes[index % strokes.length];
      var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== undefined ? highlightedDatumStrokeWidth : _this.getStrokeWidth(_this.strokeWidth);
      var format = undefined;
      if (formatter) {
        format = formatter({
          datum: datum.datum,
          angleKey: angleKey,
          radiusKey: radiusKey,
          fill: fill,
          stroke: stroke,
          strokeWidth: strokeWidth,
          highlighted: isDatumHighlighted
        });
      }
      // Bring highlighted slice's parent group to front.
      var parent = sector.parent && sector.parent.parent;
      if (isDatumHighlighted && parent) {
        parent.removeChild(sector.parent);
        parent.appendChild(sector.parent);
      }
      sector.innerRadius = innerRadius;
      sector.outerRadius = radius;
      sector.startAngle = datum.startAngle;
      sector.endAngle = datum.endAngle;
      sector.fill = format && format.fill || fill;
      sector.stroke = format && format.stroke || stroke;
      sector.strokeWidth = format && format.strokeWidth !== undefined ? format.strokeWidth : strokeWidth;
      sector.fillOpacity = fillOpacity;
      sector.strokeOpacity = strokeOpacity;
      sector.lineDash = _this.lineDash;
      sector.lineDashOffset = _this.lineDashOffset;
      sector.fillShadow = shadow;
      sector.lineJoin = 'round';
      sector.opacity = _this.getOpacity();
      centerOffsets.push(sector.centerOffset);
    });
    var calloutColors = callout.colors,
      calloutLength = callout.length,
      calloutStrokeWidth = callout.strokeWidth;
    this.groupSelection.selectByTag(PieNodeTag.Callout).each(function (line, datum, index) {
      if (datum.label) {
        var radius = radiusScale.convert(datum.radius);
        line.strokeWidth = calloutStrokeWidth;
        line.stroke = calloutColors[index % calloutColors.length];
        line.x1 = datum.midCos * radius;
        line.y1 = datum.midSin * radius;
        line.x2 = datum.midCos * (radius + calloutLength);
        line.y2 = datum.midSin * (radius + calloutLength);
      } else {
        line.stroke = undefined;
      }
    });
    {
      var _g = this.label,
        offset_1 = _g.offset,
        fontStyle_1 = _g.fontStyle,
        fontWeight_1 = _g.fontWeight,
        fontSize_1 = _g.fontSize,
        fontFamily_1 = _g.fontFamily,
        color_1 = _g.color;
      this.groupSelection.selectByTag(PieNodeTag.Label).each(function (text, datum, index) {
        var label = datum.label;
        if (label) {
          var radius = radiusScale.convert(datum.radius);
          var labelRadius = centerOffsets[index] + radius + calloutLength + offset_1;
          text.fontStyle = fontStyle_1;
          text.fontWeight = fontWeight_1;
          text.fontSize = fontSize_1;
          text.fontFamily = fontFamily_1;
          text.text = label.text;
          text.x = datum.midCos * labelRadius;
          text.y = datum.midSin * labelRadius;
          text.fill = color_1;
          text.textAlign = label.textAlign;
          text.textBaseline = label.textBaseline;
        } else {
          text.fill = undefined;
        }
      });
    }
  };
  PieSeries.prototype.fireNodeClickEvent = function (event, datum) {
    this.fireEvent({
      type: 'nodeClick',
      event: event,
      series: this,
      datum: datum.datum,
      angleKey: this.angleKey,
      labelKey: this.labelKey,
      radiusKey: this.radiusKey
    });
  };
  PieSeries.prototype.getTooltipHtml = function (nodeDatum) {
    var angleKey = this.angleKey;
    if (!angleKey) {
      return '';
    }
    var _a = this,
      fills = _a.fills,
      tooltip = _a.tooltip,
      angleName = _a.angleName,
      radiusKey = _a.radiusKey,
      radiusName = _a.radiusName,
      labelKey = _a.labelKey,
      labelName = _a.labelName;
    var tooltipRenderer = tooltip.renderer;
    var color = fills[nodeDatum.index % fills.length];
    var datum = nodeDatum.datum;
    var label = labelKey ? datum[labelKey] + ": " : '';
    var angleValue = datum[angleKey];
    var formattedAngleValue = typeof angleValue === 'number' ? toFixed(angleValue) : angleValue.toString();
    var title = this.title ? this.title.text : undefined;
    var content = label + formattedAngleValue;
    var defaults = {
      title: title,
      backgroundColor: color,
      content: content
    };
    if (tooltipRenderer) {
      return toTooltipHtml(tooltipRenderer({
        datum: datum,
        angleKey: angleKey,
        angleValue: angleValue,
        angleName: angleName,
        radiusKey: radiusKey,
        radiusValue: radiusKey ? datum[radiusKey] : undefined,
        radiusName: radiusName,
        labelKey: labelKey,
        labelName: labelName,
        title: title,
        color: color
      }), defaults);
    }
    return toTooltipHtml(defaults);
  };
  PieSeries.prototype.listSeriesItems = function (legendData) {
    var _this = this;
    var _a = this,
      labelKey = _a.labelKey,
      data = _a.data;
    if (data && data.length && labelKey) {
      var _b = this,
        fills_1 = _b.fills,
        strokes_1 = _b.strokes,
        id_1 = _b.id;
      var titleText_1 = this.title && this.title.showInLegend && this.title.text;
      data.forEach(function (datum, index) {
        var labelParts = [];
        titleText_1 && labelParts.push(titleText_1);
        labelParts.push(String(datum[labelKey]));
        legendData.push({
          id: id_1,
          itemId: index,
          enabled: _this.seriesItemEnabled[index],
          label: {
            text: labelParts.join(' - ')
          },
          marker: {
            fill: fills_1[index % fills_1.length],
            stroke: strokes_1[index % strokes_1.length],
            fillOpacity: _this.fillOpacity,
            strokeOpacity: _this.strokeOpacity
          }
        });
      });
    }
  };
  PieSeries.prototype.toggleSeriesItem = function (itemId, enabled) {
    this.seriesItemEnabled[itemId] = enabled;
    this.scheduleData();
  };
  PieSeries.className = 'PieSeries';
  PieSeries.type = 'pie';
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "angleKey", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "angleName", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "radiusKey", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "radiusName", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "radiusMin", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "radiusMax", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "labelKey", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "labelName", void 0);
  __decorate$3k([reactive('layoutChange')], PieSeries.prototype, "fillOpacity", void 0);
  __decorate$3k([reactive('layoutChange')], PieSeries.prototype, "strokeOpacity", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "lineDash", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "lineDashOffset", void 0);
  __decorate$3k([reactive('update')], PieSeries.prototype, "formatter", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "rotation", void 0);
  __decorate$3k([reactive('layoutChange')], PieSeries.prototype, "outerRadiusOffset", void 0);
  __decorate$3k([reactive('dataChange')], PieSeries.prototype, "innerRadiusOffset", void 0);
  __decorate$3k([reactive('layoutChange')], PieSeries.prototype, "strokeWidth", void 0);
  __decorate$3k([reactive('layoutChange')], PieSeries.prototype, "shadow", void 0);
  return PieSeries;
}(PolarSeries);
function floor$a(date) {
  date.setUTCSeconds(0, 0);
}
function offset$9(date, minutes) {
  date.setTime(date.getTime() + minutes * durationMinute);
}
function count$9(start, end) {
  return (end.getTime() - start.getTime()) / durationMinute;
}
function field$7(date) {
  return date.getUTCMinutes();
}
var utcMinute = new CountableTimeInterval(floor$a, offset$9, count$9, field$7);
function floor$b(date) {
  date.setUTCMinutes(0, 0, 0);
}
function offset$a(date, hours) {
  date.setTime(date.getTime() + hours * durationHour);
}
function count$a(start, end) {
  return (end.getTime() - start.getTime()) / durationHour;
}
function field$8(date) {
  return date.getUTCHours();
}
var utcHour = new CountableTimeInterval(floor$b, offset$a, count$a, field$8);
function floor$c(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}
function offset$b(date, months) {
  date.setUTCMonth(date.getUTCMonth() + months);
}
function count$b(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}
function field$9(date) {
  return date.getUTCMonth();
}
var utcMonth = new CountableTimeInterval(floor$c, offset$b, count$b, field$9);
var __assign$m = undefined && undefined.__assign || function () {
  __assign$m = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$m.apply(this, arguments);
};
var palette = {
  fills: ['#f3622d', '#fba71b', '#57b757', '#41a9c9', '#4258c9', '#9a42c8', '#c84164', '#888888'],
  strokes: ['#aa4520', '#b07513', '#3d803d', '#2d768d', '#2e3e8d', '#6c2e8c', '#8c2d46', '#5f5f5f']
};
function arrayMerge(target, source, options) {
  return source;
}
function isMergeableObject(value) {
  return defaultIsMergeableObject(value) && !(value instanceof TimeInterval);
}
var mergeOptions = {
  arrayMerge: arrayMerge,
  isMergeableObject: isMergeableObject
};
var ChartTheme = /** @class */function () {
  function ChartTheme(options) {
    var defaults = this.createChartConfigPerSeries(this.getDefaults());
    if (isObject$1(options)) {
      options = deepMerge({}, options, mergeOptions);
      var overrides_1 = options.overrides;
      if (overrides_1) {
        if (isObject$1(overrides_1.common)) {
          ChartTheme.seriesTypes.concat(['cartesian', 'polar', 'hierarchy']).forEach(function (seriesType) {
            defaults[seriesType] = deepMerge(defaults[seriesType], overrides_1.common, mergeOptions);
          });
        }
        if (overrides_1.cartesian) {
          defaults.cartesian = deepMerge(defaults.cartesian, overrides_1.cartesian, mergeOptions);
          ChartTheme.cartesianSeriesTypes.forEach(function (seriesType) {
            defaults[seriesType] = deepMerge(defaults[seriesType], overrides_1.cartesian, mergeOptions);
          });
        }
        if (overrides_1.polar) {
          defaults.polar = deepMerge(defaults.polar, overrides_1.polar, mergeOptions);
          ChartTheme.polarSeriesTypes.forEach(function (seriesType) {
            defaults[seriesType] = deepMerge(defaults[seriesType], overrides_1.polar, mergeOptions);
          });
        }
        if (overrides_1.hierarchy) {
          defaults.hierarchy = deepMerge(defaults.hierarchy, overrides_1.hierarchy, mergeOptions);
          ChartTheme.hierarchySeriesTypes.forEach(function (seriesType) {
            defaults[seriesType] = deepMerge(defaults[seriesType], overrides_1.hierarchy, mergeOptions);
          });
        }
        ChartTheme.seriesTypes.forEach(function (seriesType) {
          var _a;
          var chartConfig = overrides_1[seriesType];
          if (chartConfig) {
            if (chartConfig.series) {
              chartConfig.series = (_a = {}, _a[seriesType] = chartConfig.series, _a);
            }
            defaults[seriesType] = deepMerge(defaults[seriesType], chartConfig, mergeOptions);
          }
        });
      }
    }
    this.palette = options && options.palette ? options.palette : this.getPalette();
    this.config = Object.freeze(defaults);
  }
  ChartTheme.prototype.getPalette = function () {
    return palette;
  };
  ChartTheme.getAxisDefaults = function () {
    return {
      top: {},
      right: {},
      bottom: {},
      left: {},
      thickness: 0,
      title: {
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10
        },
        text: 'Axis Title',
        fontStyle: undefined,
        fontWeight: 'bold',
        fontSize: 12,
        fontFamily: this.fontFamily,
        color: 'rgb(70, 70, 70)'
      },
      label: {
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 12,
        fontFamily: this.fontFamily,
        padding: 5,
        rotation: 0,
        color: 'rgb(87, 87, 87)',
        formatter: undefined
      },
      line: {
        width: 1,
        color: 'rgb(195, 195, 195)'
      },
      tick: {
        width: 1,
        size: 6,
        color: 'rgb(195, 195, 195)',
        count: 10
      },
      gridStyle: [{
        stroke: 'rgb(219, 219, 219)',
        lineDash: [4, 2]
      }]
    };
  };
  ChartTheme.getSeriesDefaults = function () {
    return {
      tooltip: {
        enabled: true,
        renderer: undefined,
        format: undefined
      },
      visible: true,
      showInLegend: true,
      cursor: 'default',
      highlightStyle: {
        item: {
          fill: 'yellow'
        },
        series: {
          dimOpacity: 1
        }
      }
    };
  };
  ChartTheme.getBarSeriesDefaults = function () {
    return __assign$m(__assign$m({}, this.getSeriesDefaults()), {
      flipXY: false,
      fillOpacity: 1,
      strokeOpacity: 1,
      xKey: '',
      xName: '',
      yKeys: [],
      yNames: [],
      grouped: false,
      normalizedTo: undefined,
      strokeWidth: 1,
      lineDash: [0],
      lineDashOffset: 0,
      tooltipRenderer: undefined,
      label: {
        enabled: false,
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 12,
        fontFamily: this.fontFamily,
        color: 'rgb(70, 70, 70)',
        formatter: undefined,
        placement: 'inside'
      },
      shadow: {
        enabled: false,
        color: 'rgba(0, 0, 0, 0.5)',
        xOffset: 3,
        yOffset: 3,
        blur: 5
      }
    });
  };
  ChartTheme.getCartesianSeriesMarkerDefaults = function () {
    return {
      enabled: true,
      shape: 'circle',
      size: 6,
      maxSize: 30,
      strokeWidth: 1,
      formatter: undefined
    };
  };
  ChartTheme.getChartDefaults = function () {
    return {
      width: 600,
      height: 300,
      autoSize: true,
      background: {
        visible: true,
        fill: 'white'
      },
      padding: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
      },
      title: {
        enabled: false,
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10
        },
        text: 'Title',
        fontStyle: undefined,
        fontWeight: 'bold',
        fontSize: 16,
        fontFamily: this.fontFamily,
        color: 'rgb(70, 70, 70)'
      },
      subtitle: {
        enabled: false,
        padding: {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10
        },
        text: 'Subtitle',
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 12,
        fontFamily: this.fontFamily,
        color: 'rgb(140, 140, 140)'
      },
      legend: {
        enabled: true,
        position: 'right',
        spacing: 20,
        item: {
          paddingX: 16,
          paddingY: 8,
          marker: {
            shape: undefined,
            size: 15,
            strokeWidth: 1,
            padding: 8
          },
          label: {
            color: 'black',
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 12,
            fontFamily: this.fontFamily,
            formatter: undefined
          }
        }
      },
      tooltip: {
        enabled: true,
        tracking: true,
        delay: 0,
        class: Chart.defaultTooltipClass
      }
    };
  };
  ChartTheme.prototype.createChartConfigPerSeries = function (config) {
    var typeToAliases = {
      cartesian: ChartTheme.cartesianSeriesTypes,
      polar: ChartTheme.polarSeriesTypes
    };
    var _loop_1 = function _loop_1(type) {
      typeToAliases[type].forEach(function (alias) {
        if (!config[alias]) {
          config[alias] = deepMerge({}, config[type], mergeOptions);
        }
      });
    };
    for (var type in typeToAliases) {
      _loop_1(type);
    }
    return config;
  };
  ChartTheme.prototype.getConfig = function (path, defaultValue) {
    var value = getValue(this.config, path, defaultValue);
    if (Array.isArray(value)) {
      return deepMerge([], value, mergeOptions);
    }
    if (isObject$1(value)) {
      return deepMerge({}, value, mergeOptions);
    }
    return value;
  };
  /**
   * Meant to be overridden in subclasses. For example:
   * ```
   *     getDefaults() {
   *         const subclassDefaults = { ... };
   *         return this.mergeWithParentDefaults(subclassDefaults);
   *     }
   * ```
   */
  ChartTheme.prototype.getDefaults = function () {
    return deepMerge({}, ChartTheme.defaults, mergeOptions);
  };
  ChartTheme.prototype.mergeWithParentDefaults = function (defaults) {
    var proto = Object.getPrototypeOf(Object.getPrototypeOf(this));
    if (proto === Object.prototype) {
      var config = deepMerge({}, ChartTheme.defaults, mergeOptions);
      config = deepMerge(config, defaults, mergeOptions);
      return config;
    }
    var parentDefaults = proto.getDefaults();
    return deepMerge(parentDefaults, defaults, mergeOptions);
  };
  ChartTheme.prototype.setSeriesColors = function (series, seriesOptions, firstColorIndex) {
    var palette = this.palette;
    var colorCount = this.getSeriesColorCount(seriesOptions);
    if (colorCount === Infinity) {
      series.setColors(palette.fills, palette.strokes);
    } else {
      var fills = copy(palette.fills, firstColorIndex, colorCount);
      var strokes = copy(palette.strokes, firstColorIndex, colorCount);
      series.setColors(fills, strokes);
      firstColorIndex += colorCount;
    }
    return firstColorIndex;
  };
  ChartTheme.prototype.getYKeyCount = function (yKeys) {
    if (!Array.isArray(yKeys)) {
      return 0;
    }
    var count = 0;
    yKeys.forEach(function (key) {
      if (Array.isArray(key)) {
        count += key.length;
      } else {
        count += 1;
      }
    });
    return count;
  };
  /**
   * This would typically correspond to the number of dependent variables the series plots.
   * If the color count is not fixed, for example it's data-dependent with one color per data point,
   * return Infinity to fetch all unique colors and manage them in the series.
   */
  ChartTheme.prototype.getSeriesColorCount = function (seriesOptions) {
    var type = seriesOptions.type;
    switch (type) {
      case 'bar':
      case 'column':
      case 'area':
        return this.getYKeyCount(seriesOptions.yKeys);
      case 'pie':
        return Infinity;
      default:
        return 1;
    }
  };
  ChartTheme.fontFamily = 'Verdana, sans-serif';
  ChartTheme.cartesianDefaults = __assign$m(__assign$m({}, ChartTheme.getChartDefaults()), {
    axes: {
      number: __assign$m({}, ChartTheme.getAxisDefaults()),
      log: __assign$m(__assign$m({}, ChartTheme.getAxisDefaults()), {
        base: 10
      }),
      category: __assign$m({}, ChartTheme.getAxisDefaults()),
      groupedCategory: __assign$m({}, ChartTheme.getAxisDefaults()),
      time: __assign$m({}, ChartTheme.getAxisDefaults())
    },
    series: {
      column: __assign$m(__assign$m({}, ChartTheme.getBarSeriesDefaults()), {
        flipXY: false
      }),
      bar: __assign$m(__assign$m({}, ChartTheme.getBarSeriesDefaults()), {
        flipXY: true
      }),
      line: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
        title: undefined,
        xKey: '',
        xName: '',
        yKey: '',
        yName: '',
        strokeWidth: 2,
        strokeOpacity: 1,
        lineDash: [0],
        lineDashOffset: 0,
        tooltipRenderer: undefined,
        marker: __assign$m({}, ChartTheme.getCartesianSeriesMarkerDefaults()),
        label: {
          enabled: false,
          fontStyle: undefined,
          fontWeight: undefined,
          fontSize: 12,
          fontFamily: ChartTheme.fontFamily,
          color: 'rgb(70, 70, 70)',
          formatter: undefined
        }
      }),
      scatter: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
        title: undefined,
        xKey: '',
        yKey: '',
        sizeKey: undefined,
        labelKey: undefined,
        xName: '',
        yName: '',
        sizeName: 'Size',
        labelName: 'Label',
        strokeWidth: 2,
        fillOpacity: 1,
        strokeOpacity: 1,
        tooltipRenderer: undefined,
        marker: __assign$m({}, ChartTheme.getCartesianSeriesMarkerDefaults()),
        label: {
          enabled: false,
          fontStyle: undefined,
          fontWeight: undefined,
          fontSize: 12,
          fontFamily: ChartTheme.fontFamily,
          color: 'rgb(70, 70, 70)'
        }
      }),
      area: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
        title: undefined,
        xKey: '',
        xName: '',
        yKeys: [],
        yNames: [],
        normalizedTo: undefined,
        fillOpacity: 0.8,
        strokeOpacity: 1,
        strokeWidth: 2,
        lineDash: [0],
        lineDashOffset: 0,
        shadow: {
          enabled: false,
          color: 'rgba(0, 0, 0, 0.5)',
          xOffset: 3,
          yOffset: 3,
          blur: 5
        },
        tooltipRenderer: undefined,
        marker: __assign$m(__assign$m({}, ChartTheme.getCartesianSeriesMarkerDefaults()), {
          enabled: false
        }),
        label: {
          enabled: false,
          fontStyle: undefined,
          fontWeight: undefined,
          fontSize: 12,
          fontFamily: ChartTheme.fontFamily,
          color: 'rgb(70, 70, 70)',
          formatter: undefined
        }
      }),
      histogram: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
        title: undefined,
        xKey: '',
        yKey: '',
        xName: '',
        yName: '',
        strokeWidth: 1,
        fillOpacity: 1,
        strokeOpacity: 1,
        lineDash: [0],
        lineDashOffset: 0,
        areaPlot: false,
        binCount: 10,
        bins: undefined,
        aggregation: 'sum',
        tooltipRenderer: undefined,
        label: {
          enabled: false,
          fontStyle: undefined,
          fontWeight: undefined,
          fontSize: 12,
          fontFamily: ChartTheme.fontFamily,
          color: 'rgb(70, 70, 70)',
          formatter: undefined
        }
      })
    },
    navigator: {
      enabled: false,
      height: 30,
      min: 0,
      max: 1,
      mask: {
        fill: '#999999',
        stroke: '#999999',
        strokeWidth: 1,
        fillOpacity: 0.2
      },
      minHandle: {
        fill: '#f2f2f2',
        stroke: '#999999',
        strokeWidth: 1,
        width: 8,
        height: 16,
        gripLineGap: 2,
        gripLineLength: 8
      },
      maxHandle: {
        fill: '#f2f2f2',
        stroke: '#999999',
        strokeWidth: 1,
        width: 8,
        height: 16,
        gripLineGap: 2,
        gripLineLength: 8
      }
    }
  });
  ChartTheme.defaults = {
    cartesian: ChartTheme.cartesianDefaults,
    groupedCategory: ChartTheme.cartesianDefaults,
    polar: __assign$m(__assign$m({}, ChartTheme.getChartDefaults()), {
      series: {
        pie: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
          title: {
            enabled: true,
            showInLegend: false,
            padding: new Padding(0),
            text: '',
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 12,
            fontFamily: ChartTheme.fontFamily,
            color: 'rgb(70, 70, 70)'
          },
          angleKey: '',
          angleName: '',
          radiusKey: undefined,
          radiusName: undefined,
          labelKey: undefined,
          labelName: undefined,
          label: {
            enabled: true,
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 12,
            fontFamily: ChartTheme.fontFamily,
            color: 'rgb(70, 70, 70)',
            offset: 3,
            minAngle: 20
          },
          callout: {
            length: 10,
            strokeWidth: 2
          },
          fillOpacity: 1,
          strokeOpacity: 1,
          strokeWidth: 1,
          lineDash: [0],
          lineDashOffset: 0,
          rotation: 0,
          outerRadiusOffset: 0,
          innerRadiusOffset: 0,
          shadow: {
            enabled: false,
            color: 'rgba(0, 0, 0, 0.5)',
            xOffset: 3,
            yOffset: 3,
            blur: 5
          }
        })
      }
    }),
    hierarchy: __assign$m(__assign$m({}, ChartTheme.getChartDefaults()), {
      series: {
        treemap: __assign$m(__assign$m({}, ChartTheme.getSeriesDefaults()), {
          showInLegend: false,
          labelKey: 'label',
          sizeKey: 'size',
          colorKey: 'color',
          colorDomain: [-5, 5],
          colorRange: ['#cb4b3f', '#6acb64'],
          colorParents: false,
          gradient: true,
          nodePadding: 2,
          title: {
            enabled: true,
            color: 'white',
            fontStyle: undefined,
            fontWeight: 'bold',
            fontSize: 12,
            fontFamily: 'Verdana, sans-serif',
            padding: 15
          },
          subtitle: {
            enabled: true,
            color: 'white',
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 9,
            fontFamily: 'Verdana, sans-serif',
            padding: 13
          },
          labels: {
            large: {
              enabled: true,
              fontStyle: undefined,
              fontWeight: 'bold',
              fontSize: 18,
              fontFamily: 'Verdana, sans-serif',
              color: 'white'
            },
            medium: {
              enabled: true,
              fontStyle: undefined,
              fontWeight: 'bold',
              fontSize: 14,
              fontFamily: 'Verdana, sans-serif',
              color: 'white'
            },
            small: {
              enabled: true,
              fontStyle: undefined,
              fontWeight: 'bold',
              fontSize: 10,
              fontFamily: 'Verdana, sans-serif',
              color: 'white'
            },
            color: {
              enabled: true,
              fontStyle: undefined,
              fontWeight: undefined,
              fontSize: 12,
              fontFamily: 'Verdana, sans-serif',
              color: 'white'
            }
          }
        })
      }
    })
  };
  ChartTheme.cartesianSeriesTypes = ['line', 'area', 'bar', 'column', 'scatter', 'histogram'];
  ChartTheme.polarSeriesTypes = ['pie'];
  ChartTheme.hierarchySeriesTypes = ['treemap'];
  ChartTheme.seriesTypes = ChartTheme.cartesianSeriesTypes.concat(ChartTheme.polarSeriesTypes);
  return ChartTheme;
}();
var __extends$4i = undefined && undefined.__extends || function () {
  var _extendStatics283 = function extendStatics(d, b) {
    _extendStatics283 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics283(d, b);
  };
  return function (d, b) {
    _extendStatics283(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$n = undefined && undefined.__assign || function () {
  __assign$n = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$n.apply(this, arguments);
};
var DarkTheme = /** @class */function (_super) {
  __extends$4i(DarkTheme, _super);
  function DarkTheme(options) {
    return _super.call(this, options) || this;
  }
  DarkTheme.prototype.getDefaults = function () {
    var fontColor = 'rgb(200, 200, 200)';
    var mutedFontColor = 'rgb(150, 150, 150)';
    var axisDefaults = {
      title: {
        color: fontColor
      },
      label: {
        color: fontColor
      },
      gridStyle: [{
        stroke: 'rgb(88, 88, 88)',
        lineDash: [4, 2]
      }]
    };
    var seriesLabelDefaults = {
      label: {
        color: fontColor
      }
    };
    var chartDefaults = {
      background: {
        fill: 'rgb(34, 38, 41)'
      },
      title: {
        color: fontColor
      },
      subtitle: {
        color: mutedFontColor
      },
      axes: {
        number: __assign$n({}, axisDefaults),
        category: __assign$n({}, axisDefaults),
        time: __assign$n({}, axisDefaults)
      },
      legend: {
        item: {
          label: {
            color: fontColor
          }
        }
      }
    };
    return this.mergeWithParentDefaults({
      cartesian: __assign$n(__assign$n({}, chartDefaults), {
        series: {
          bar: __assign$n({}, seriesLabelDefaults),
          column: __assign$n({}, seriesLabelDefaults),
          histogram: __assign$n({}, seriesLabelDefaults)
        }
      }),
      polar: __assign$n(__assign$n({}, chartDefaults), {
        series: {
          pie: __assign$n(__assign$n({}, seriesLabelDefaults), {
            title: {
              color: fontColor
            }
          })
        }
      })
    });
  };
  return DarkTheme;
}(ChartTheme);
var __extends$4j = undefined && undefined.__extends || function () {
  var _extendStatics284 = function extendStatics(d, b) {
    _extendStatics284 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics284(d, b);
  };
  return function (d, b) {
    _extendStatics284(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$1 = {
  fills: ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722'],
  strokes: ['#ab2f26', '#a31545', '#6d1b7b', '#482980', '#2c397f', '#1769aa', '#0276ab', '#008494', '#00695f', '#357a38', '#618834', '#909a28', '#b3a429', '#b38705', '#b36a00', '#b33d18']
};
var MaterialLight = /** @class */function (_super) {
  __extends$4j(MaterialLight, _super);
  function MaterialLight() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MaterialLight.prototype.getPalette = function () {
    return palette$1;
  };
  return MaterialLight;
}(ChartTheme);
var __extends$4k = undefined && undefined.__extends || function () {
  var _extendStatics285 = function extendStatics(d, b) {
    _extendStatics285 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics285(d, b);
  };
  return function (d, b) {
    _extendStatics285(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$2 = {
  fills: ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722'],
  strokes: ['#ab2f26', '#a31545', '#6d1b7b', '#482980', '#2c397f', '#1769aa', '#0276ab', '#008494', '#00695f', '#357a38', '#618834', '#909a28', '#b3a429', '#b38705', '#b36a00', '#b33d18']
};
var MaterialDark = /** @class */function (_super) {
  __extends$4k(MaterialDark, _super);
  function MaterialDark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MaterialDark.prototype.getPalette = function () {
    return palette$2;
  };
  return MaterialDark;
}(DarkTheme);
var __extends$4l = undefined && undefined.__extends || function () {
  var _extendStatics286 = function extendStatics(d, b) {
    _extendStatics286 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics286(d, b);
  };
  return function (d, b) {
    _extendStatics286(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$3 = {
  fills: ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'],
  strokes: ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692']
};
var PastelLight = /** @class */function (_super) {
  __extends$4l(PastelLight, _super);
  function PastelLight() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PastelLight.prototype.getPalette = function () {
    return palette$3;
  };
  return PastelLight;
}(ChartTheme);
var __extends$4m = undefined && undefined.__extends || function () {
  var _extendStatics287 = function extendStatics(d, b) {
    _extendStatics287 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics287(d, b);
  };
  return function (d, b) {
    _extendStatics287(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$4 = {
  fills: ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'],
  strokes: ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692']
};
var PastelDark = /** @class */function (_super) {
  __extends$4m(PastelDark, _super);
  function PastelDark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PastelDark.prototype.getPalette = function () {
    return palette$4;
  };
  return PastelDark;
}(DarkTheme);
var __extends$4n = undefined && undefined.__extends || function () {
  var _extendStatics288 = function extendStatics(d, b) {
    _extendStatics288 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics288(d, b);
  };
  return function (d, b) {
    _extendStatics288(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$5 = {
  fills: ['#febe76', '#ff7979', '#badc58', '#f9ca23', '#f0932b', '#eb4c4b', '#6ab04c', '#7ed6df', '#e056fd', '#686de0'],
  strokes: ['#b28553', '#b35555', '#829a3e', '#ae8d19', '#a8671e', '#a43535', '#4a7b35', '#58969c', '#9d3cb1', '#494c9d']
};
var SolarLight = /** @class */function (_super) {
  __extends$4n(SolarLight, _super);
  function SolarLight() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SolarLight.prototype.getPalette = function () {
    return palette$5;
  };
  return SolarLight;
}(ChartTheme);
var __extends$4o = undefined && undefined.__extends || function () {
  var _extendStatics289 = function extendStatics(d, b) {
    _extendStatics289 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics289(d, b);
  };
  return function (d, b) {
    _extendStatics289(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$6 = {
  fills: ['#febe76', '#ff7979', '#badc58', '#f9ca23', '#f0932b', '#eb4c4b', '#6ab04c', '#7ed6df', '#e056fd', '#686de0'],
  strokes: ['#b28553', '#b35555', '#829a3e', '#ae8d19', '#a8671e', '#a43535', '#4a7b35', '#58969c', '#9d3cb1', '#494c9d']
};
var SolarDark = /** @class */function (_super) {
  __extends$4o(SolarDark, _super);
  function SolarDark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SolarDark.prototype.getPalette = function () {
    return palette$6;
  };
  return SolarDark;
}(DarkTheme);
var __extends$4p = undefined && undefined.__extends || function () {
  var _extendStatics290 = function extendStatics(d, b) {
    _extendStatics290 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics290(d, b);
  };
  return function (d, b) {
    _extendStatics290(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$7 = {
  fills: ['#5BC0EB', '#FDE74C', '#9BC53D', '#E55934', '#FA7921', '#fa3081'],
  strokes: ['#4086a4', '#b1a235', '#6c8a2b', '#a03e24', '#af5517', '#af225a']
};
var VividLight = /** @class */function (_super) {
  __extends$4p(VividLight, _super);
  function VividLight() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  VividLight.prototype.getPalette = function () {
    return palette$7;
  };
  return VividLight;
}(ChartTheme);
var __extends$4q = undefined && undefined.__extends || function () {
  var _extendStatics291 = function extendStatics(d, b) {
    _extendStatics291 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics291(d, b);
  };
  return function (d, b) {
    _extendStatics291(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var palette$8 = {
  fills: ['#5BC0EB', '#FDE74C', '#9BC53D', '#E55934', '#FA7921', '#fa3081'],
  strokes: ['#4086a4', '#b1a235', '#6c8a2b', '#a03e24', '#af5517', '#af225a']
};
var VividDark = /** @class */function (_super) {
  __extends$4q(VividDark, _super);
  function VividDark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  VividDark.prototype.getPalette = function () {
    return palette$8;
  };
  return VividDark;
}(DarkTheme);
var __extends$4r = undefined && undefined.__extends || function () {
  var _extendStatics292 = function extendStatics(d, b) {
    _extendStatics292 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics292(d, b);
  };
  return function (d, b) {
    _extendStatics292(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var identity$3 = function identity$3(x) {
  return x;
};
var LogScale = /** @class */function (_super) {
  __extends$4r(LogScale, _super);
  function LogScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'log';
    _this._domain = [1, 10];
    _this.baseLog = identity$3; // takes a log with base `base` of `x`
    _this.basePow = identity$3; // raises `base` to the power of `x`
    _this._base = 10;
    return _this;
  }
  LogScale.prototype.setDomain = function (values) {
    var df = values[0];
    var dl = values[values.length - 1];
    if (df === 0 || dl === 0 || df < 0 && dl > 0 || df > 0 && dl < 0) {
      console.warn('Log scale domain should not start at, end at or cross zero.');
      if (df === 0 && dl > 0) {
        df = Number.EPSILON;
      } else if (dl === 0 && df < 0) {
        dl = -Number.EPSILON;
      } else if (df < 0 && dl > 0) {
        if (Math.abs(dl) >= Math.abs(df)) {
          df = Number.EPSILON;
        } else {
          dl = -Number.EPSILON;
        }
      } else if (df > 0 && dl < 0) {
        if (Math.abs(dl) >= Math.abs(df)) {
          df = -Number.EPSILON;
        } else {
          dl = Number.EPSILON;
        }
      }
      values = values.slice();
      values[0] = df;
      values[values.length - 1] = dl;
    }
    _super.prototype.setDomain.call(this, values);
  };
  LogScale.prototype.getDomain = function () {
    return _super.prototype.getDomain.call(this);
  };
  Object.defineProperty(LogScale.prototype, "base", {
    get: function get() {
      return this._base;
    },
    set: function set(value) {
      if (this._base !== value) {
        this._base = value;
        this.rescale();
      }
    },
    enumerable: true,
    configurable: true
  });
  LogScale.prototype.rescale = function () {
    var base = this.base;
    var baseLog = LogScale.makeLogFn(base);
    var basePow = LogScale.makePowFn(base);
    if (this.domain[0] < 0) {
      baseLog = this.reflect(baseLog);
      basePow = this.reflect(basePow);
      this.transform = function (x) {
        return -Math.log(-x);
      };
      this.untransform = function (x) {
        return -Math.exp(-x);
      };
    } else {
      this.transform = function (x) {
        return Math.log(x);
      };
      this.untransform = function (x) {
        return Math.exp(x);
      };
    }
    this.baseLog = baseLog;
    this.basePow = basePow;
    _super.prototype.rescale.call(this);
  };
  /**
   * For example, if `f` is `Math.log10`, we have
   *
   *     f(100) == 2
   *     f(-100) == NaN
   *     rf = reflect(f)
   *     rf(-100) == -2
   *
   * @param f
   */
  LogScale.prototype.reflect = function (f) {
    return function (x) {
      return -f(-x);
    };
  };
  LogScale.prototype.nice = function () {
    var _a, _b;
    var domain = this.domain;
    var i0 = 0;
    var i1 = domain.length - 1;
    var x0 = domain[i0];
    var x1 = domain[i1];
    if (x1 < x0) {
      _a = [i1, i0], i0 = _a[0], i1 = _a[1];
      _b = [x1, x0], x0 = _b[0], x1 = _b[1];
    }
    // For example, for base == 10:
    // [ 50, 900] becomes [ 10, 1000 ]
    domain[i0] = this.basePow(Math.floor(this.baseLog(x0)));
    domain[i1] = this.basePow(Math.ceil(this.baseLog(x1)));
    this.domain = domain;
  };
  LogScale.pow10 = function (x) {
    return isFinite(x) ? +('1e' + x) // to avoid precision issues, e.g. Math.pow(10, -4) is not 0.0001
    : x < 0 ? 0 : x;
  };
  LogScale.makePowFn = function (base) {
    if (base === 10) {
      return LogScale.pow10;
    }
    if (base === Math.E) {
      return Math.exp;
    }
    return function (x) {
      return Math.pow(base, x);
    };
  };
  // Make a log function witn an arbitrary base or return a native function if exists.
  LogScale.makeLogFn = function (base) {
    if (base === Math.E) {
      return Math.log;
    }
    if (base === 10) {
      return Math.log10;
    }
    if (base === 2) {
      return Math.log2;
    }
    var logBase = Math.log(base);
    return function (x) {
      return Math.log(x) / logBase;
    };
  };
  LogScale.prototype.ticks = function (count) {
    var _a;
    if (count === void 0) {
      count = 10;
    }
    var n = count == null ? 10 : +count;
    var base = this.base;
    var domain = this.domain;
    var d0 = domain[0];
    var d1 = domain[domain.length - 1];
    var isReversed = d1 < d0;
    if (isReversed) {
      _a = [d1, d0], d0 = _a[0], d1 = _a[1];
    }
    var p0 = this.baseLog(d0);
    var p1 = this.baseLog(d1);
    var z = [];
    // if `base` is an integer and delta in order of magnitudes is less than n
    if (!(base % 1) && p1 - p0 < n) {
      // For example, if n == 10, base == 10 and domain == [10^2, 10^6]
      // then p1 - p0 < n == true.
      p0 = Math.round(p0) - 1;
      p1 = Math.round(p1) + 1;
      if (d0 > 0) {
        for (; p0 < p1; ++p0) {
          for (var k = 1, p = this.basePow(p0); k < base; ++k) {
            var t = p * k;
            // The `t` checks are needed because we expanded the [p0, p1] by 1 in each direction.
            if (t < d0) continue;
            if (t > d1) break;
            z.push(t);
          }
        }
      } else {
        for (; p0 < p1; ++p0) {
          for (var k = base - 1, p = this.basePow(p0); k >= 1; --k) {
            var t = p * k;
            if (t < d0) continue;
            if (t > d1) break;
            z.push(t);
          }
        }
      }
      if (z.length * 2 < n) {
        z = ticks(d0, d1, n);
      }
    } else {
      // For example, if n == 4, base == 10 and domain == [10^2, 10^6]
      // then p1 - p0 < n == false.
      // `ticks` return [2, 3, 4, 5, 6], then mapped to [10^2, 10^3, 10^4, 10^5, 10^6].
      z = ticks(p0, p1, Math.min(p1 - p0, n)).map(this.basePow);
    }
    return isReversed ? z.reverse() : z;
  };
  LogScale.prototype.tickFormat = function (count, specifier) {
    var _this = this;
    var base = this.base;
    if (specifier == null) {
      specifier = base === 10 ? '.0e' : ',';
    }
    if (typeof specifier !== 'function') {
      specifier = format(specifier);
    }
    if (count === Infinity) {
      return specifier;
    }
    if (count == null) {
      count = 10;
    }
    var k = Math.max(1, base * count / this.ticks().length);
    return function (d) {
      var i = d / _this.basePow(Math.round(_this.baseLog(d)));
      if (i * base < base - 0.5) {
        i *= base;
      }
      return i <= k ? specifier(d) : '';
    };
  };
  return LogScale;
}(ContinuousScale);
var __extends$4s = undefined && undefined.__extends || function () {
  var _extendStatics293 = function extendStatics(d, b) {
    _extendStatics293 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics293(d, b);
  };
  return function (d, b) {
    _extendStatics293(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var LogAxis = /** @class */function (_super) {
  __extends$4s(LogAxis, _super);
  function LogAxis() {
    var _this = _super.call(this) || this;
    _this.scale = new LogScale();
    _this.scale.clamper = clamper$1;
    return _this;
  }
  Object.defineProperty(LogAxis.prototype, "base", {
    get: function get() {
      return this.scale.base;
    },
    set: function set(value) {
      this.scale.base = value;
    },
    enumerable: true,
    configurable: true
  });
  LogAxis.className = 'LogAxis';
  LogAxis.type = 'log';
  return LogAxis;
}(NumberAxis);
var __assign$o = undefined && undefined.__assign || function () {
  __assign$o = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$o.apply(this, arguments);
};
var _a, _b, _c, _d, _e;
/*
    This file defines the specs for creating different kinds of charts, but
    contains no code that uses the specs to actually create charts
*/
var chartPadding = 20;
var commonChartMappings = {
  background: {
    meta: {
      defaults: {
        visible: true,
        fill: 'white'
      }
    }
  },
  padding: {
    meta: {
      constructor: Padding,
      defaults: {
        top: chartPadding,
        right: chartPadding,
        bottom: chartPadding,
        left: chartPadding
      }
    }
  },
  tooltip: {
    meta: {
      defaults: {
        enabled: true,
        tracking: true,
        delay: 0,
        class: Chart.defaultTooltipClass
      }
    }
  },
  title: {
    meta: {
      constructor: Caption,
      defaults: {
        enabled: false,
        padding: {
          meta: {
            constructor: Padding,
            defaults: {
              top: 10,
              right: 10,
              bottom: 10,
              left: 10
            }
          }
        },
        text: 'Title',
        fontStyle: undefined,
        fontWeight: 'bold',
        fontSize: 14,
        fontFamily: 'Verdana, sans-serif',
        color: 'rgb(70, 70, 70)'
      }
    }
  },
  subtitle: {
    meta: {
      constructor: Caption,
      defaults: {
        enabled: false,
        padding: {
          meta: {
            constructor: Padding,
            defaults: {
              top: 10,
              right: 10,
              bottom: 10,
              left: 10
            }
          }
        },
        text: 'Subtitle',
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 12,
        fontFamily: 'Verdana, sans-serif',
        color: 'rgb(140, 140, 140)'
      }
    }
  },
  legend: {
    meta: {
      constructor: Legend,
      defaults: {
        enabled: true,
        position: LegendPosition.Right,
        spacing: 20
      }
    },
    item: {
      meta: {
        constructor: LegendItem,
        defaults: {
          paddingX: 16,
          paddingY: 8
        }
      },
      marker: {
        meta: {
          constructor: LegendMarker,
          defaults: {
            shape: undefined,
            size: 15,
            strokeWidth: 1,
            padding: 8
          }
        }
      },
      label: {
        meta: {
          constructor: LegendLabel,
          defaults: {
            color: 'black',
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 12,
            fontFamily: 'Verdana, sans-serif',
            formatter: undefined
          }
        }
      }
    }
  }
};
var chartDefaults = {
  container: undefined,
  autoSize: true,
  width: 600,
  height: 300,
  data: [],
  title: undefined,
  subtitle: undefined,
  padding: {},
  background: {},
  legend: {
    item: {
      marker: {},
      label: {}
    }
  },
  navigator: {
    mask: {},
    minHandle: {},
    maxHandle: {}
  },
  listeners: undefined
};
var chartMeta = {
  // Charts components' constructors normally don't take any parameters (which makes things consistent -- everything
  // is configured the same way, via the properties, and makes the factory pattern work well) but the charts
  // themselves are the exceptions.
  // If a chart config has the (optional) `document` property, it will be passed to the constructor.
  // There is no actual `document` property on the chart, it can only be supplied during instantiation.
  constructorParams: ['document'],
  setAsIs: ['container', 'data', 'tooltipOffset'],
  nonSerializable: ['container', 'data']
};
var axisDefaults = {
  defaults: {
    visibleRange: [0, 1],
    thickness: 0,
    label: {},
    tick: {},
    title: {},
    line: {},
    gridStyle: [{
      stroke: 'rgb(219, 219, 219)',
      lineDash: [4, 2]
    }]
  }
};
var seriesDefaults = {
  visible: true,
  showInLegend: true,
  cursor: 'default',
  listeners: undefined
};
var highlightStyleMapping = {
  highlightStyle: {
    item: {
      meta: {
        defaults: {
          fill: 'yellow'
        }
      }
    },
    series: {
      meta: {
        defaults: {
          dimOpacity: 1
        }
      }
    }
  }
};
var columnSeriesDefaults = {
  fillOpacity: 1,
  strokeOpacity: 1,
  xKey: '',
  xName: '',
  yKeys: [],
  yNames: {},
  grouped: false,
  normalizedTo: undefined,
  strokeWidth: 1,
  lineDash: undefined,
  lineDashOffset: 0,
  shadow: undefined
};
var shadowMapping = {
  shadow: {
    meta: {
      constructor: DropShadow,
      defaults: {
        enabled: true,
        color: 'rgba(0, 0, 0, 0.5)',
        xOffset: 0,
        yOffset: 0,
        blur: 5
      }
    }
  }
};
var labelDefaults = {
  enabled: true,
  fontStyle: undefined,
  fontWeight: undefined,
  fontSize: 12,
  fontFamily: 'Verdana, sans-serif',
  color: 'rgb(70, 70, 70)'
};
var barLabelMapping = {
  label: {
    meta: {
      defaults: __assign$o(__assign$o({}, labelDefaults), {
        formatter: undefined,
        placement: 'inside'
      })
    }
  }
};
var tooltipMapping = {
  tooltip: {
    meta: {
      defaults: {
        enabled: true,
        renderer: undefined,
        format: undefined
      }
    }
  }
};
var axisMappings = {
  line: {
    meta: {
      defaults: {
        width: 1,
        color: 'rgb(195, 195, 195)'
      }
    }
  },
  title: {
    meta: {
      constructor: Caption,
      defaults: {
        padding: {
          meta: {
            constructor: Padding,
            defaults: {
              top: 10,
              right: 10,
              bottom: 10,
              left: 10
            }
          }
        },
        text: 'Axis Title',
        fontStyle: undefined,
        fontWeight: 'bold',
        fontSize: 12,
        fontFamily: 'Verdana, sans-serif',
        color: 'rgb(70, 70, 70)'
      }
    }
  },
  label: {
    meta: {
      constructor: AxisLabel,
      defaults: {
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 12,
        fontFamily: 'Verdana, sans-serif',
        padding: 5,
        rotation: 0,
        color: 'rgb(87, 87, 87)',
        formatter: undefined
      }
    }
  },
  tick: {
    meta: {
      constructor: AxisTick,
      setAsIs: ['count'],
      defaults: {
        width: 1,
        size: 6,
        color: 'rgb(195, 195, 195)',
        count: 10
      }
    }
  }
};
var mappings = (_a = {}, _a[CartesianChart.type] = __assign$o(__assign$o({
  meta: __assign$o(__assign$o({
    constructor: CartesianChart
  }, chartMeta), {
    defaults: __assign$o(__assign$o({}, chartDefaults), {
      axes: [{
        type: NumberAxis.type,
        position: 'left'
      }, {
        type: CategoryAxis.type,
        position: 'bottom'
      }]
    })
  })
}, commonChartMappings), {
  axes: (_b = {}, _b[NumberAxis.type] = __assign$o({
    meta: __assign$o({
      constructor: NumberAxis,
      setAsIs: ['gridStyle', 'visibleRange']
    }, axisDefaults)
  }, axisMappings), _b[LogAxis.type] = __assign$o({
    meta: __assign$o(__assign$o({
      constructor: LogAxis,
      setAsIs: ['gridStyle', 'visibleRange']
    }, axisDefaults), {
      base: 10
    })
  }, axisMappings), _b[CategoryAxis.type] = __assign$o({
    meta: __assign$o({
      constructor: CategoryAxis,
      setAsIs: ['gridStyle', 'visibleRange']
    }, axisDefaults)
  }, axisMappings), _b[GroupedCategoryAxis.type] = __assign$o({
    meta: __assign$o({
      constructor: GroupedCategoryAxis,
      setAsIs: ['gridStyle', 'visibleRange']
    }, axisDefaults)
  }, axisMappings), _b[TimeAxis.type] = __assign$o({
    meta: __assign$o({
      constructor: TimeAxis,
      setAsIs: ['gridStyle', 'visibleRange']
    }, axisDefaults)
  }, axisMappings), _b),
  series: (_c = {
    column: __assign$o(__assign$o(__assign$o(__assign$o({
      meta: {
        constructor: BarSeries,
        setAsIs: ['lineDash', 'yNames'],
        defaults: __assign$o(__assign$o({
          flipXY: false
        }, seriesDefaults), columnSeriesDefaults)
      }
    }, highlightStyleMapping), tooltipMapping), barLabelMapping), shadowMapping)
  }, _c[BarSeries.type] = __assign$o(__assign$o(__assign$o(__assign$o({
    meta: {
      constructor: BarSeries,
      setAsIs: ['lineDash', 'yNames'],
      defaults: __assign$o(__assign$o({
        flipXY: true
      }, seriesDefaults), columnSeriesDefaults)
    }
  }, highlightStyleMapping), tooltipMapping), barLabelMapping), shadowMapping), _c[LineSeries.type] = __assign$o(__assign$o(__assign$o({
    meta: {
      constructor: LineSeries,
      setAsIs: ['lineDash'],
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        title: undefined,
        xKey: '',
        xName: '',
        yKey: '',
        yName: '',
        strokeWidth: 2,
        strokeOpacity: 1,
        lineDash: undefined,
        lineDashOffset: 0
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    label: {
      meta: {
        defaults: __assign$o(__assign$o({}, labelDefaults), {
          formatter: undefined
        })
      }
    },
    marker: {
      meta: {
        constructor: CartesianSeriesMarker,
        defaults: {
          enabled: true,
          shape: 'circle',
          size: 6,
          maxSize: 30,
          strokeWidth: 1,
          formatter: undefined
        }
      }
    }
  }), _c[ScatterSeries.type] = __assign$o(__assign$o(__assign$o({
    meta: {
      constructor: ScatterSeries,
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        title: undefined,
        xKey: '',
        yKey: '',
        sizeKey: undefined,
        labelKey: undefined,
        xName: '',
        yName: '',
        sizeName: 'Size',
        labelName: 'Label',
        strokeWidth: 2,
        fillOpacity: 1,
        strokeOpacity: 1
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    marker: {
      meta: {
        constructor: CartesianSeriesMarker,
        defaults: {
          enabled: true,
          shape: 'circle',
          size: 6,
          maxSize: 30,
          strokeWidth: 1,
          formatter: undefined
        }
      }
    },
    label: {
      meta: {
        defaults: __assign$o({}, labelDefaults)
      }
    }
  }), _c[AreaSeries.type] = __assign$o(__assign$o(__assign$o(__assign$o({
    meta: {
      constructor: AreaSeries,
      setAsIs: ['lineDash'],
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        xKey: '',
        xName: '',
        yKeys: [],
        yNames: [],
        normalizedTo: undefined,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 2,
        lineDash: undefined,
        lineDashOffset: 0,
        shadow: undefined
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    label: {
      meta: {
        defaults: __assign$o(__assign$o({}, labelDefaults), {
          formatter: undefined
        })
      }
    },
    marker: {
      meta: {
        constructor: CartesianSeriesMarker,
        defaults: {
          enabled: true,
          shape: 'circle',
          size: 6,
          maxSize: 30,
          strokeWidth: 1,
          formatter: undefined
        }
      }
    }
  }), shadowMapping), _c[HistogramSeries.type] = __assign$o(__assign$o(__assign$o(__assign$o({
    meta: {
      constructor: HistogramSeries,
      setAsIs: ['lineDash'],
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        title: undefined,
        xKey: '',
        yKey: '',
        xName: '',
        yName: '',
        strokeWidth: 1,
        fillOpacity: 1,
        strokeOpacity: 1,
        lineDash: undefined,
        lineDashOffset: 0,
        areaPlot: false,
        binCount: undefined,
        bins: undefined,
        aggregation: 'sum'
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    label: {
      meta: {
        defaults: __assign$o(__assign$o({}, labelDefaults), {
          formatter: undefined
        })
      }
    }
  }), shadowMapping), _c),
  navigator: {
    meta: {
      constructor: Navigator,
      defaults: {
        enabled: false,
        height: 30,
        min: 0,
        max: 1
      }
    },
    mask: {
      meta: {
        constructor: NavigatorMask,
        defaults: {
          fill: '#999999',
          stroke: '#999999',
          strokeWidth: 1,
          fillOpacity: 0.2
        }
      }
    },
    minHandle: {
      meta: {
        constructor: NavigatorHandle,
        defaults: {
          fill: '#f2f2f2',
          stroke: '#999999',
          strokeWidth: 1,
          width: 8,
          height: 16,
          gripLineGap: 2,
          gripLineLength: 8
        }
      }
    },
    maxHandle: {
      meta: {
        constructor: NavigatorHandle,
        defaults: {
          fill: '#f2f2f2',
          stroke: '#999999',
          strokeWidth: 1,
          width: 8,
          height: 16,
          gripLineGap: 2,
          gripLineLength: 8
        }
      }
    }
  }
}), _a[PolarChart.type] = __assign$o(__assign$o({
  meta: __assign$o(__assign$o({
    constructor: PolarChart
  }, chartMeta), {
    defaults: __assign$o(__assign$o({}, chartDefaults), {
      padding: {
        meta: {
          constructor: Padding,
          defaults: {
            top: 40,
            right: 40,
            bottom: 40,
            left: 40
          }
        }
      }
    })
  })
}, commonChartMappings), {
  series: (_d = {}, _d[PieSeries.type] = __assign$o(__assign$o(__assign$o(__assign$o({
    meta: {
      constructor: PieSeries,
      setAsIs: ['lineDash'],
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        title: undefined,
        angleKey: '',
        angleName: '',
        radiusKey: undefined,
        radiusName: undefined,
        labelKey: undefined,
        labelName: undefined,
        callout: {},
        fillOpacity: 1,
        strokeOpacity: 1,
        rotation: 0,
        outerRadiusOffset: 0,
        innerRadiusOffset: 0,
        strokeWidth: 1,
        lineDash: undefined,
        lineDashOffset: 0,
        shadow: undefined
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    title: {
      meta: {
        constructor: PieTitle,
        defaults: {
          enabled: true,
          showInLegend: false,
          padding: {
            meta: {
              constructor: Padding,
              defaults: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
              }
            }
          },
          text: 'Series Title',
          fontStyle: undefined,
          fontWeight: 'bold',
          fontSize: 14,
          fontFamily: 'Verdana, sans-serif',
          color: 'black'
        }
      }
    },
    label: {
      meta: {
        defaults: __assign$o(__assign$o({}, labelDefaults), {
          offset: 3,
          minAngle: 20
        })
      }
    },
    callout: {
      meta: {
        defaults: {
          length: 10,
          strokeWidth: 1
        }
      }
    }
  }), shadowMapping), _d)
}), _a[HierarchyChart.type] = __assign$o(__assign$o({
  meta: __assign$o(__assign$o({
    constructor: HierarchyChart
  }, chartMeta), {
    defaults: __assign$o({}, chartDefaults)
  })
}, commonChartMappings), {
  series: (_e = {}, _e[TreemapSeries.type] = __assign$o(__assign$o(__assign$o({
    meta: {
      constructor: TreemapSeries,
      defaults: __assign$o(__assign$o({}, seriesDefaults), {
        showInLegend: false,
        labelKey: 'label',
        sizeKey: 'size',
        colorKey: 'color',
        colorDomain: [-5, 5],
        colorRange: ['#cb4b3f', '#6acb64'],
        colorParents: false,
        gradient: true,
        nodePadding: 2,
        title: {},
        subtitle: {},
        labels: {
          large: {},
          medium: {},
          small: {},
          color: {}
        }
      })
    }
  }, tooltipMapping), highlightStyleMapping), {
    title: {
      meta: {
        defaults: {
          enabled: true,
          color: 'white',
          fontStyle: undefined,
          fontWeight: 'bold',
          fontSize: 12,
          fontFamily: 'Verdana, sans-serif',
          padding: 15
        }
      }
    },
    subtitle: {
      meta: {
        defaults: {
          enabled: true,
          color: 'white',
          fontStyle: undefined,
          fontWeight: undefined,
          fontSize: 9,
          fontFamily: 'Verdana, sans-serif',
          padding: 13
        }
      }
    },
    labels: {
      meta: {
        defaults: {
          large: {},
          medium: {},
          small: {},
          color: {}
        }
      },
      large: {
        meta: {
          constructor: Label,
          defaults: {
            enabled: true,
            fontStyle: undefined,
            fontWeight: 'bold',
            fontSize: 18,
            fontFamily: 'Verdana, sans-serif',
            color: 'white'
          }
        }
      },
      medium: {
        meta: {
          constructor: Label,
          defaults: {
            enabled: true,
            fontStyle: undefined,
            fontWeight: 'bold',
            fontSize: 14,
            fontFamily: 'Verdana, sans-serif',
            color: 'white'
          }
        }
      },
      small: {
        meta: {
          constructor: Label,
          defaults: {
            enabled: true,
            fontStyle: undefined,
            fontWeight: 'bold',
            fontSize: 10,
            fontFamily: 'Verdana, sans-serif',
            color: 'white'
          }
        }
      },
      color: {
        meta: {
          constructor: Label,
          defaults: {
            enabled: true,
            fontStyle: undefined,
            fontWeight: undefined,
            fontSize: 12,
            fontFamily: 'Verdana, sans-serif',
            color: 'white'
          }
        }
      }
    }
  }), _e)
}), _a);
// Amend the `mappings` object with aliases for different chart types.
{
  var typeToAliases = {
    cartesian: ['line', 'area', 'bar', 'column'],
    polar: ['pie'],
    hierarchy: ['treemap']
  };
  var _loop_1 = function _loop_1(type) {
    typeToAliases[type].forEach(function (alias) {
      mappings[alias] = mappings[type];
    });
  };
  for (var type in typeToAliases) {
    _loop_1(type);
  }
}
// Special handling for scatter and histogram charts, for which both axes should default to type `number`.
mappings['scatter'] = mappings['histogram'] = __assign$o(__assign$o({}, mappings.cartesian), {
  meta: __assign$o(__assign$o({}, mappings.cartesian.meta), {
    defaults: __assign$o(__assign$o({}, chartDefaults), {
      axes: [{
        type: 'number',
        position: 'bottom'
      }, {
        type: 'number',
        position: 'left'
      }]
    })
  })
});
// Special handling for bar charts, for which `bottom` axis should default to type `number` and `left` axis should default to type `category`.
mappings['bar'] = __assign$o(__assign$o({}, mappings.cartesian), {
  meta: __assign$o(__assign$o({}, mappings.cartesian.meta), {
    defaults: __assign$o(__assign$o({}, chartDefaults), {
      axes: [{
        type: 'number',
        position: 'bottom'
      }, {
        type: 'category',
        position: 'left'
      }]
    })
  })
});
var groupedCategoryChartMapping = Object.create(mappings[CartesianChart.type]);
var groupedCategoryChartMeta = Object.create(groupedCategoryChartMapping.meta);
groupedCategoryChartMeta.constructor = GroupedCategoryChart;
groupedCategoryChartMapping.meta = groupedCategoryChartMeta;
mappings[GroupedCategoryChart.type] = groupedCategoryChartMapping;
var __assign$p = undefined && undefined.__assign || function () {
  __assign$p = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$p.apply(this, arguments);
};
var __spreadArrays$k = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var lightTheme = new ChartTheme();
var darkTheme = new DarkTheme();
var lightThemes = {
  'undefined': lightTheme,
  'null': lightTheme,
  'ag-default': lightTheme,
  'ag-material': new MaterialLight(),
  'ag-pastel': new PastelLight(),
  'ag-solar': new SolarLight(),
  'ag-vivid': new VividLight()
};
var darkThemes = {
  'undefined': darkTheme,
  'null': darkTheme,
  'ag-default-dark': darkTheme,
  'ag-material-dark': new MaterialDark(),
  'ag-pastel-dark': new PastelDark(),
  'ag-solar-dark': new SolarDark(),
  'ag-vivid-dark': new VividDark()
};
var themes = __assign$p(__assign$p({}, darkThemes), lightThemes);
function getChartTheme(value) {
  if (value instanceof ChartTheme) {
    return value;
  }
  var stockTheme = themes[value];
  if (stockTheme) {
    return stockTheme;
  }
  value = value;
  if (value.baseTheme || value.overrides || value.palette) {
    var baseTheme = getChartTheme(value.baseTheme);
    return new baseTheme.constructor(value);
  }
  return lightTheme;
}
var firstColorIndex = 0;
var AgChart = /** @class */function () {
  function AgChart() {}
  AgChart.create = function (options, container, data) {
    options = Object.create(options); // avoid mutating user provided options
    if (container) {
      options.container = container;
    }
    if (data) {
      options.data = data;
    }
    // special handling when both `autoSize` and `width` / `height` are present in the options
    var autoSize = options && options.autoSize !== false;
    var theme = getChartTheme(options.theme);
    firstColorIndex = 0;
    var chart = create(options, undefined, undefined, theme);
    if (chart) {
      if (autoSize) {
        // `autoSize` takes precedence over `width` / `height`
        chart.autoSize = true;
      }
    }
    return chart;
  };
  AgChart.update = function (chart, options, container, data) {
    if (!(chart && options)) {
      return;
    }
    options = Object.create(options);
    if (container) {
      options.container = container;
    }
    if (data) {
      options.data = data;
    }
    var autoSize = options && options.autoSize !== false;
    var theme = getChartTheme(options.theme);
    firstColorIndex = 0;
    update(chart, options, undefined, theme);
    if (autoSize) {
      chart.autoSize = true;
    }
  };
  AgChart.createComponent = create;
  return AgChart;
}();
var pathToSeriesTypeMap = {
  'cartesian.series': 'line',
  'line.series': 'line',
  'area.series': 'area',
  'bar.series': 'bar',
  'column.series': 'column',
  'histogram.series': 'histogram',
  'scatter.series': 'scatter',
  'polar.series': 'pie',
  'pie.series': 'pie'
};
var actualSeriesTypeMap = function () {
  var map = {};
  var actualSeries = ['area', 'bar', 'histogram', 'line', 'pie', 'scatter'];
  actualSeries.forEach(function (series) {
    return map[series] = series;
  });
  // Aliases:
  map['column'] = 'bar';
  return map;
}();
function create(options, path, component, theme) {
  var _a;
  // Deprecate `chart.legend.item.marker.type` in integrated chart options.
  options = Object.create(options);
  if (component instanceof LegendMarker) {
    if (options.type) {
      options.shape = options.type;
    }
  } else {
    options = provideDefaultType(options, path);
    if (path) {
      if (options.type) {
        path = path + '.' + options.type;
      }
    } else {
      path = options.type;
    }
  }
  if (!path) {
    return;
  }
  var mapping = getValue(mappings, path);
  if (mapping) {
    options = provideDefaultOptions(path, options, mapping, theme);
    var meta = mapping.meta || {};
    var constructorParams = meta.constructorParams || [];
    var skipKeys = ['type', 'listeners'].concat(constructorParams);
    // TODO: Constructor params processing could be improved, but it's good enough for current params.
    var constructorParamValues = constructorParams.map(function (param) {
      return options[param];
    }).filter(function (value) {
      return value !== undefined;
    });
    if (!component) {
      component = new ((_a = meta.constructor).bind.apply(_a, __spreadArrays$k([void 0], constructorParamValues)))();
      if (theme && component instanceof Series) {
        firstColorIndex = theme.setSeriesColors(component, options, firstColorIndex);
      }
    }
    var _loop_1 = function _loop_1(key) {
      // Process every non-special key in the config object.
      if (skipKeys.indexOf(key) < 0) {
        var value = options[key];
        if (value && key in mapping && !(meta.setAsIs && meta.setAsIs.indexOf(key) >= 0)) {
          if (Array.isArray(value)) {
            var subComponents = value.map(function (config) {
              var axis = create(config, path + '.' + key, undefined, theme);
              if (theme && key === 'axes') {
                var fakeTheme = {
                  getConfig: function getConfig(path) {
                    var parts = path.split('.');
                    var modifiedPath = parts.slice(0, 3).join('.') + '.' + axis.position;
                    var after = parts.slice(3);
                    if (after.length) {
                      modifiedPath += '.' + after.join('.');
                    }
                    var config = theme.getConfig(path);
                    var modifiedConfig = theme.getConfig(modifiedPath);
                    isObject$1(theme.getConfig(modifiedPath));
                    if (isObject$1(config) && isObject$1(modifiedConfig)) {
                      return deepMerge(config, modifiedConfig, mergeOptions);
                    }
                    return modifiedConfig;
                  }
                };
                update(axis, config, path + '.' + key, fakeTheme);
              }
              return axis;
            }).filter(function (instance) {
              return !!instance;
            });
            component[key] = subComponents;
          } else {
            if (mapping[key] && component[key]) {
              // The instance property already exists on the component (e.g. chart.legend).
              // Simply configure the existing instance, without creating a new one.
              create(value, path + '.' + key, component[key], theme);
            } else {
              var subComponent = create(value, value.type ? path : path + '.' + key, undefined, theme);
              if (subComponent) {
                component[key] = subComponent;
              }
            }
          }
        } else {
          // if (key in meta.constructor.defaults) { // prevent users from creating custom properties
          component[key] = value;
        }
      }
    };
    for (var key in options) {
      _loop_1(key);
    }
    var listeners = options.listeners;
    if (component && component.addEventListener && listeners) {
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key)) {
          var listener = listeners[key];
          if (typeof listener === 'function') {
            component.addEventListener(key, listener);
          }
        }
      }
    }
    return component;
  }
}
function update(component, options, path, theme) {
  if (!(options && isObject$1(options))) {
    return;
  }
  // Deprecate `chart.legend.item.marker.type` in integrated chart options.
  if (component instanceof LegendMarker) {
    if (options.type) {
      options.shape = options.type;
    }
  } else {
    options = provideDefaultType(options, path);
    if (path) {
      if (options.type) {
        path = path + '.' + options.type;
      }
    } else {
      path = options.type;
    }
  }
  if (!path) {
    return;
  }
  var chart = path in mappings ? component : undefined;
  var mapping = getValue(mappings, path);
  if (mapping) {
    options = provideDefaultOptions(path, options, mapping, theme);
    var meta = mapping.meta || {};
    var constructorParams = meta && meta.constructorParams || [];
    var skipKeys = ['type'].concat(constructorParams);
    for (var key in options) {
      if (skipKeys.indexOf(key) < 0) {
        var value = options[key];
        var keyPath = path + '.' + key;
        if (meta.setAsIs && meta.setAsIs.indexOf(key) >= 0) {
          component[key] = value;
        } else {
          var oldValue = component[key];
          if (Array.isArray(oldValue) && Array.isArray(value)) {
            if (chart) {
              if (key === 'series') {
                updateSeries(component, value, keyPath, theme);
              } else if (key === 'axes') {
                updateAxes(component, value, keyPath, theme);
              }
            } else {
              component[key] = value;
            }
          } else if (isObject$1(oldValue)) {
            if (value) {
              update(oldValue, value, value.type ? path : keyPath, theme);
            } else if (key in options) {
              component[key] = value;
            }
          } else {
            var subComponent = isObject$1(value) && create(value, value.type ? path : keyPath, undefined, theme);
            if (subComponent) {
              component[key] = subComponent;
            } else {
              if (chart && options.autoSize && (key === 'width' || key === 'height')) {
                continue;
              }
              component[key] = value;
            }
          }
        }
      }
    }
  }
  if (chart) {
    chart.layoutPending = true;
  }
}
function updateSeries(chart, configs, keyPath, theme) {
  var allSeries = chart.series.slice();
  var prevSeries;
  var i = 0;
  for (; i < configs.length; i++) {
    var config = configs[i];
    var series = allSeries[i];
    if (series) {
      config = provideDefaultType(config, keyPath);
      var type = actualSeriesTypeMap[config.type];
      if (series.type === type) {
        if (theme) {
          firstColorIndex = theme.setSeriesColors(series, config, firstColorIndex);
        }
        update(series, config, keyPath, theme);
      } else {
        var newSeries = create(config, keyPath, undefined, theme);
        chart.removeSeries(series);
        chart.addSeriesAfter(newSeries, prevSeries);
        series = newSeries;
      }
    } else {
      // more new configs than existing series
      var newSeries = create(config, keyPath, undefined, theme);
      chart.addSeries(newSeries);
    }
    prevSeries = series;
  }
  // more existing series than new configs
  for (; i < allSeries.length; i++) {
    var series = allSeries[i];
    if (series) {
      chart.removeSeries(series);
    }
  }
}
function updateAxes(chart, configs, keyPath, theme) {
  var axes = chart.axes;
  var axesToAdd = [];
  var axesToUpdate = [];
  var _loop_2 = function _loop_2(config) {
    var axisToUpdate = find$4(axes, function (axis) {
      return axis.type === config.type && axis.position === config.position;
    });
    if (axisToUpdate) {
      axesToUpdate.push(axisToUpdate);
      update(axisToUpdate, config, keyPath, theme);
    } else {
      var axisToAdd = create(config, keyPath, undefined, theme);
      if (axisToAdd) {
        axesToAdd.push(axisToAdd);
      }
    }
  };
  for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
    var config = configs_1[_i];
    _loop_2(config);
  }
  chart.axes = axesToUpdate.concat(axesToAdd);
}
function provideDefaultChartType(options) {
  if (options.type) {
    return options;
  }
  // If chart type is not specified, try to infer it from the type of first series.
  var series = options.series && options.series[0];
  if (series && series.type) {
    options = Object.create(options);
    options.type = series.type;
    return options;
  }
  // If chart type is not specified in the first series either, set it to 'cartesian'.
  options = Object.create(options);
  options.type = 'cartesian';
  return options;
}
function provideDefaultType(options, path) {
  if (!path) {
    // if `path` is undefined, `options` is a top-level (chart) config
    path = '';
    options = provideDefaultChartType(options);
  }
  if (!options.type) {
    var seriesType = pathToSeriesTypeMap[path];
    if (seriesType) {
      options = Object.create(options);
      options.type = seriesType;
    }
  }
  return options;
}
function skipThemeKey(key) {
  return ['axes', 'series'].indexOf(key) >= 0;
}
var enabledKey = 'enabled';
/**
 * If certain options were not provided by the user, use the defaults from the theme and the mapping.
 * All three objects are provided for the current path in the config tree, not necessarily top-level.
 */
function provideDefaultOptions(path, options, mapping, theme) {
  var isChartConfig = path.indexOf('.') < 0;
  var themeDefaults = theme && theme.getConfig(path);
  var defaults = mapping && mapping.meta && mapping.meta.defaults;
  var isExplicitlyDisabled = options.enabled === false; // by the user
  if (defaults || themeDefaults) {
    options = Object.create(options);
  }
  // Fill in the gaps for properties not configured by the user using theme provided values.
  for (var key in themeDefaults) {
    // The default values for these special chart configs always come from the mappings, not theme.
    if (isChartConfig && skipThemeKey(key)) {
      continue;
    }
    if (!(key in options)) {
      options[key] = themeDefaults[key];
    }
  }
  // Fill in the gaps for properties not configured by the user, nor theme using chart mappings.
  for (var key in defaults) {
    if ((!themeDefaults || !(key in themeDefaults) || skipThemeKey(key)) && !(key in options)) {
      options[key] = defaults[key];
    }
  }
  // Special handling for the 'enabled' property. For example:
  // title: { text: 'Quarterly Revenue' } // means title is enabled
  // legend: {} // means legend is enabled
  var hasEnabledKey = themeDefaults && enabledKey in themeDefaults || defaults && enabledKey in defaults;
  if (hasEnabledKey && !isExplicitlyDisabled) {
    options[enabledKey] = true;
  }
  return options;
}
var __extends$4t = undefined && undefined.__extends || function () {
  var _extendStatics294 = function extendStatics(d, b) {
    _extendStatics294 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics294(d, b);
  };
  return function (d, b) {
    _extendStatics294(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3l = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartController = /** @class */function (_super) {
  __extends$4t(ChartController, _super);
  function ChartController(model) {
    var _this = _super.call(this) || this;
    _this.model = model;
    return _this;
  }
  ChartController.prototype.init = function () {
    var _this = this;
    this.setChartRange();
    this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, function (event) {
      if (event.id && event.id === _this.model.getChartId()) {
        _this.updateForRangeChange();
      }
    });
    if (this.model.isUnlinked()) {
      if (this.rangeService) {
        this.rangeService.setCellRanges([]);
      }
    }
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.updateForGridChange.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.updateForGridChange.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.updateForGridChange.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.updateForGridChange.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.updateForGridChange.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.updateForDataChange.bind(this));
  };
  ChartController.prototype.updateForGridChange = function () {
    if (this.model.isUnlinked()) {
      return;
    }
    this.model.updateCellRanges();
    this.setChartRange();
  };
  ChartController.prototype.updateForDataChange = function () {
    if (this.model.isUnlinked()) {
      return;
    }
    this.model.updateData();
    this.raiseChartUpdatedEvent();
  };
  ChartController.prototype.updateForRangeChange = function () {
    this.updateForGridChange();
    this.raiseChartRangeSelectionChangedEvent();
  };
  ChartController.prototype.updateForPanelChange = function (updatedCol) {
    this.model.updateCellRanges(updatedCol);
    this.setChartRange();
    this.raiseChartRangeSelectionChangedEvent();
  };
  ChartController.prototype.getChartModel = function () {
    var modelType = this.model.isPivotChart() ? 'pivot' : 'range';
    return {
      modelType: modelType,
      chartId: this.model.getChartId(),
      chartType: this.model.getChartType(),
      chartThemeName: this.getThemeName(),
      chartOptions: this.chartProxy.getChartOptions(),
      cellRange: this.model.getCellRangeParams(),
      suppressChartRanges: this.model.isSuppressChartRanges(),
      aggFunc: this.model.getAggFunc(),
      unlinkChart: this.model.isUnlinked()
    };
  };
  ChartController.prototype.getChartType = function () {
    return this.model.getChartType();
  };
  ChartController.prototype.isPivotChart = function () {
    return this.model.isPivotChart();
  };
  ChartController.prototype.isGrouping = function () {
    return this.model.isGrouping();
  };
  ChartController.prototype.getThemeName = function () {
    return this.model.getChartThemeName();
  };
  ChartController.prototype.getThemes = function () {
    return this.gridOptionsWrapper.getChartThemes();
  };
  ChartController.prototype.getPalettes = function () {
    var _this = this;
    var themeNames = this.gridOptionsWrapper.getChartThemes();
    return themeNames.map(function (themeName) {
      var stockTheme = _this.chartProxy.isStockTheme(themeName);
      var theme = stockTheme ? themeName : _this.chartProxy.lookupCustomChartTheme(themeName);
      return getChartTheme(theme).palette;
    });
  };
  ChartController.prototype.setChartType = function (chartType) {
    this.model.setChartType(chartType);
    this.raiseChartUpdatedEvent();
    this.raiseChartOptionsChangedEvent();
  };
  ChartController.prototype.setChartThemeName = function (chartThemeName) {
    this.model.setChartThemeName(chartThemeName);
    this.raiseChartUpdatedEvent();
    this.raiseChartOptionsChangedEvent();
  };
  ChartController.prototype.getColStateForMenu = function () {
    return {
      dimensionCols: this.model.getDimensionColState(),
      valueCols: this.model.getValueColState()
    };
  };
  ChartController.prototype.isDefaultCategorySelected = function () {
    return this.model.getSelectedDimension().colId === ChartDataModel.DEFAULT_CATEGORY;
  };
  ChartController.prototype.setChartRange = function (silent) {
    if (silent === void 0) {
      silent = false;
    }
    if (this.rangeService && !this.model.isSuppressChartRanges() && !this.model.isUnlinked()) {
      this.rangeService.setCellRanges(this.model.getCellRanges());
    }
    if (!silent) {
      this.raiseChartUpdatedEvent();
    }
  };
  ChartController.prototype.detachChartRange = function () {
    // when chart is detached it won't listen to changes from the grid
    this.model.toggleUnlinked();
    if (this.model.isUnlinked()) {
      // remove range from grid
      if (this.rangeService) {
        this.rangeService.setCellRanges([]);
      }
    } else {
      // update chart data may have changed
      this.updateForGridChange();
    }
  };
  ChartController.prototype.setChartProxy = function (chartProxy) {
    this.chartProxy = chartProxy;
  };
  ChartController.prototype.getChartProxy = function () {
    return this.chartProxy;
  };
  ChartController.prototype.isActiveXYChart = function () {
    return _.includes([ChartType.Scatter, ChartType.Bubble], this.getChartType());
  };
  ChartController.prototype.isChartLinked = function () {
    return !this.model.isUnlinked();
  };
  ChartController.prototype.raiseChartUpdatedEvent = function () {
    var event = Object.freeze({
      type: ChartController.EVENT_CHART_UPDATED
    });
    this.dispatchEvent(event);
  };
  ChartController.prototype.raiseChartOptionsChangedEvent = function () {
    var _a = this.getChartModel(),
      chartId = _a.chartId,
      chartType = _a.chartType;
    var event = Object.freeze({
      type: Events.EVENT_CHART_OPTIONS_CHANGED,
      chartId: chartId,
      chartType: chartType,
      chartThemeName: this.getThemeName(),
      chartOptions: this.chartProxy.getChartOptions(),
      api: this.gridApi,
      columnApi: this.columnApi
    });
    this.eventService.dispatchEvent(event);
  };
  ChartController.prototype.raiseChartRangeSelectionChangedEvent = function () {
    var event = Object.freeze({
      type: Events.EVENT_CHART_RANGE_SELECTION_CHANGED,
      id: this.model.getChartId(),
      chartId: this.model.getChartId(),
      cellRange: this.model.getCellRangeParams(),
      api: this.gridApi,
      columnApi: this.columnApi
    });
    this.eventService.dispatchEvent(event);
  };
  ChartController.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    if (this.rangeService) {
      this.rangeService.setCellRanges([]);
    }
  };
  ChartController.EVENT_CHART_UPDATED = 'chartUpdated';
  __decorate$3l([Autowired('rangeService')], ChartController.prototype, "rangeService", void 0);
  __decorate$3l([Autowired('gridApi')], ChartController.prototype, "gridApi", void 0);
  __decorate$3l([Autowired('columnApi')], ChartController.prototype, "columnApi", void 0);
  __decorate$3l([PostConstruct], ChartController.prototype, "init", null);
  return ChartController;
}(BeanStub);
var __extends$4u = undefined && undefined.__extends || function () {
  var _extendStatics295 = function extendStatics(d, b) {
    _extendStatics295 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics295(d, b);
  };
  return function (d, b) {
    _extendStatics295(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3m = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$l = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var ChartDataPanel = /** @class */function (_super) {
  __extends$4u(ChartDataPanel, _super);
  function ChartDataPanel(chartController, chartOptionsService) {
    var _this = _super.call(this, ChartDataPanel.TEMPLATE) || this;
    _this.chartController = chartController;
    _this.chartOptionsService = chartOptionsService;
    _this.columnComps = new Map();
    return _this;
  }
  ChartDataPanel.prototype.init = function () {
    this.updatePanels();
    this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, this.updatePanels.bind(this));
  };
  ChartDataPanel.prototype.destroy = function () {
    this.clearComponents();
    _super.prototype.destroy.call(this);
  };
  ChartDataPanel.prototype.updatePanels = function () {
    var _this = this;
    var currentChartType = this.chartType;
    var _a = this.chartController.getColStateForMenu(),
      dimensionCols = _a.dimensionCols,
      valueCols = _a.valueCols;
    var colIds = dimensionCols.map(function (c) {
      return c.colId;
    }).concat(valueCols.map(function (c) {
      return c.colId;
    }));
    this.chartType = this.chartController.getChartType();
    if (_.areEqual(_.keys(this.columnComps), colIds) && this.chartType === currentChartType) {
      // if possible, we just update existing components
      __spreadArrays$l(dimensionCols, valueCols).forEach(function (col) {
        _this.columnComps.get(col.colId).setValue(col.selected, true);
      });
      if (this.chartController.isActiveXYChart()) {
        var getSeriesLabel_1 = this.generateGetSeriesLabel();
        valueCols.forEach(function (col) {
          _this.columnComps.get(col.colId).setLabel(getSeriesLabel_1(col));
        });
      }
    } else {
      // otherwise we re-create everything
      this.clearComponents();
      this.createCategoriesGroupComponent(dimensionCols);
      this.createSeriesGroupComponent(valueCols);
    }
  };
  ChartDataPanel.prototype.addComponent = function (parent, component) {
    var eDiv = document.createElement('div');
    eDiv.className = 'ag-chart-data-section';
    eDiv.appendChild(component.getGui());
    parent.appendChild(eDiv);
  };
  ChartDataPanel.prototype.addChangeListener = function (component, columnState) {
    var _this = this;
    this.addManagedListener(component, AgAbstractField.EVENT_CHANGED, function () {
      columnState.selected = component.getValue();
      _this.chartController.updateForPanelChange(columnState);
    });
  };
  ChartDataPanel.prototype.createCategoriesGroupComponent = function (columns) {
    var _this = this;
    this.categoriesGroupComp = this.createBean(new AgGroupComponent({
      title: this.getCategoryGroupTitle(),
      enabled: true,
      suppressEnabledCheckbox: true,
      suppressOpenCloseIcons: false,
      cssIdentifier: 'charts-data'
    }));
    var inputName = "chartDimension" + this.getCompId();
    columns.forEach(function (col) {
      var comp = _this.categoriesGroupComp.createManagedBean(new AgRadioButton());
      comp.setLabel(_.escapeString(col.displayName));
      comp.setValue(col.selected);
      comp.setInputName(inputName);
      _this.addChangeListener(comp, col);
      _this.categoriesGroupComp.addItem(comp);
      _this.columnComps.set(col.colId, comp);
    });
    this.addComponent(this.getGui(), this.categoriesGroupComp);
  };
  ChartDataPanel.prototype.createSeriesGroupComponent = function (columns) {
    var _this = this;
    this.seriesGroupComp = this.createManagedBean(new AgGroupComponent({
      title: this.getSeriesGroupTitle(),
      enabled: true,
      suppressEnabledCheckbox: true,
      suppressOpenCloseIcons: false,
      cssIdentifier: 'charts-data'
    }));
    if (this.chartController.isActiveXYChart()) {
      var pairedModeToggle = this.seriesGroupComp.createManagedBean(new AgToggleButton());
      pairedModeToggle.setLabel(this.chartTranslator.translate('paired')).setLabelAlignment('left').setLabelWidth('flex').setInputWidth(45).setValue(this.chartOptionsService.getPairedMode()).onValueChange(function (newValue) {
        _this.chartOptionsService.setPairedMode(!!newValue);
        _this.chartController.updateForGridChange();
      });
      this.seriesGroupComp.addItem(pairedModeToggle);
    }
    var getSeriesLabel = this.generateGetSeriesLabel();
    columns.forEach(function (col) {
      var comp = _this.seriesGroupComp.createManagedBean(new AgCheckbox());
      comp.addCssClass('ag-data-select-checkbox');
      var label = getSeriesLabel(col);
      comp.setLabel(label);
      comp.setValue(col.selected);
      _this.addChangeListener(comp, col);
      _this.seriesGroupComp.addItem(comp);
      _this.columnComps.set(col.colId, comp);
      _this.addDragHandle(comp, col);
    });
    this.addComponent(this.getGui(), this.seriesGroupComp);
    var dropTarget = {
      getContainer: this.getGui.bind(this),
      onDragging: this.onDragging.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    };
    this.dragAndDropService.addDropTarget(dropTarget);
  };
  ChartDataPanel.prototype.addDragHandle = function (comp, col) {
    var _this = this;
    var eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsWrapper);
    _.addCssClass(eDragHandle, 'ag-drag-handle');
    _.addCssClass(eDragHandle, 'ag-chart-data-column-drag-handle');
    comp.getGui().insertAdjacentElement('beforeend', eDragHandle);
    var dragSource = {
      type: DragSourceType.ChartPanel,
      eElement: eDragHandle,
      dragItemName: col.displayName,
      defaultIconName: DragAndDropService.ICON_MOVE,
      getDragItem: function getDragItem() {
        return {
          columns: [col.column]
        };
      },
      onDragStopped: function onDragStopped() {
        _this.insertIndex = undefined;
      }
    };
    this.dragAndDropService.addDragSource(dragSource, true);
    this.addDestroyFunc(function () {
      return _this.dragAndDropService.removeDragSource(dragSource);
    });
  };
  ChartDataPanel.prototype.generateGetSeriesLabel = function () {
    if (!this.chartController.isActiveXYChart()) {
      return function (col) {
        return _.escapeString(col.displayName);
      };
    }
    var isBubble = this.chartType === ChartType.Bubble;
    var isInPairedMode = this.isInPairedMode();
    var selectedValuesCount = 0;
    var indexToAxisLabel = new Map();
    indexToAxisLabel.set(0, 'X');
    indexToAxisLabel.set(1, 'Y');
    indexToAxisLabel.set(2, 'size');
    return function (col) {
      var escapedLabel = _.escapeString(col.displayName);
      if (!col.selected) {
        return escapedLabel;
      }
      var axisLabel;
      if (isInPairedMode) {
        axisLabel = indexToAxisLabel.get(selectedValuesCount % (isBubble ? 3 : 2));
      } else {
        if (selectedValuesCount === 0) {
          axisLabel = 'X';
        } else {
          axisLabel = isBubble && selectedValuesCount % 2 === 0 ? 'size' : 'Y';
        }
      }
      selectedValuesCount++;
      return escapedLabel + " (" + axisLabel + ")";
    };
  };
  ChartDataPanel.prototype.getCategoryGroupTitle = function () {
    return this.chartTranslator.translate(this.chartController.isActiveXYChart() ? 'labels' : 'categories');
  };
  ChartDataPanel.prototype.getSeriesGroupTitle = function () {
    return this.chartTranslator.translate(this.chartController.isActiveXYChart() ? 'xyValues' : 'series');
  };
  ChartDataPanel.prototype.isInPairedMode = function () {
    return this.chartController.isActiveXYChart() && this.chartOptionsService.getSeriesOption('paired');
  };
  ChartDataPanel.prototype.clearComponents = function () {
    _.clearElement(this.getGui());
    this.categoriesGroupComp = this.destroyBean(this.categoriesGroupComp);
    this.seriesGroupComp = this.destroyBean(this.seriesGroupComp);
    this.columnComps.clear();
  };
  ChartDataPanel.prototype.onDragging = function (draggingEvent) {
    var _this = this;
    if (this.checkInsertIndex(draggingEvent)) {
      var column_1 = draggingEvent.dragItem.columns[0];
      var _a = this.chartController.getColStateForMenu(),
        dimensionCols = _a.dimensionCols,
        valueCols = _a.valueCols;
      __spreadArrays$l(dimensionCols, valueCols).filter(function (state) {
        return state.column === column_1;
      }).forEach(function (state) {
        state.order = _this.insertIndex;
        _this.chartController.updateForPanelChange(state);
      });
    }
  };
  ChartDataPanel.prototype.checkInsertIndex = function (draggingEvent) {
    if (_.missing(draggingEvent.vDirection)) {
      return false;
    }
    var newIndex = 0;
    var mouseEvent = draggingEvent.event;
    this.columnComps.forEach(function (comp) {
      var rect = comp.getGui().getBoundingClientRect();
      var verticalFit = mouseEvent.clientY >= (draggingEvent.vDirection === VerticalDirection.Down ? rect.top : rect.bottom);
      if (verticalFit) {
        newIndex++;
      }
    });
    var changed = this.insertIndex !== undefined && newIndex !== this.insertIndex;
    this.insertIndex = newIndex;
    return changed;
  };
  ChartDataPanel.prototype.isInterestedIn = function (type) {
    return type === DragSourceType.ChartPanel;
  };
  ChartDataPanel.TEMPLATE = "<div class=\"ag-chart-data-wrapper\"></div>";
  __decorate$3m([Autowired('dragAndDropService')], ChartDataPanel.prototype, "dragAndDropService", void 0);
  __decorate$3m([Autowired('chartTranslator')], ChartDataPanel.prototype, "chartTranslator", void 0);
  __decorate$3m([PostConstruct], ChartDataPanel.prototype, "init", null);
  return ChartDataPanel;
}(Component);
var __extends$4v = undefined && undefined.__extends || function () {
  var _extendStatics296 = function extendStatics(d, b) {
    _extendStatics296 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics296(d, b);
  };
  return function (d, b) {
    _extendStatics296(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3n = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FontPanel = /** @class */function (_super) {
  __extends$4v(FontPanel, _super);
  function FontPanel(params) {
    var _this = _super.call(this) || this;
    _this.activeComps = [];
    _this.params = params;
    return _this;
  }
  FontPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical',
      suppressOpenCloseIcons: true
    };
    this.setTemplate(FontPanel.TEMPLATE, {
      fontGroup: groupParams
    });
    this.initGroup();
    this.initFontFamilySelect();
    this.initFontWeightStyleSelect();
    this.initFontSizeSelect();
    this.initFontColorPicker();
  };
  FontPanel.prototype.addCompToPanel = function (comp) {
    this.fontGroup.addItem(comp);
    this.activeComps.push(comp);
  };
  FontPanel.prototype.setEnabled = function (enabled) {
    this.fontGroup.setEnabled(enabled);
  };
  FontPanel.prototype.initGroup = function () {
    var _this = this;
    this.fontGroup.setTitle(this.params.name || this.chartTranslator.translate('font')).setEnabled(this.params.enabled).hideEnabledCheckbox(!!this.params.suppressEnabledCheckbox).hideOpenCloseIcons(true).onEnableChange(function (enabled) {
      if (_this.params.setEnabled) {
        _this.params.setEnabled(enabled);
      }
    });
  };
  FontPanel.prototype.initFontFamilySelect = function () {
    var _this = this;
    var families = ['Arial, sans-serif', 'Aria Black, sans-serif', 'Book Antiqua,  serif', 'Charcoal, sans-serif', 'Comic Sans MS, cursive', 'Courier, monospace', 'Courier New, monospace', 'Gadget, sans-serif', 'Geneva, sans-serif', 'Helvetica, sans-serif', 'Impact, sans-serif', 'Lucida Console, monospace', 'Lucida Grande, sans-serif', 'Lucida Sans Unicode,  sans-serif', 'Monaco, monospace', 'Palatino Linotype, serif', 'Palatino, serif', 'Times New Roman, serif', 'Times, serif', 'Verdana, sans-serif'];
    var family = this.params.initialFont.family;
    var initialValue = families[0];
    if (family) {
      // check for known values using lowercase
      var lowerCaseValues = families.map(function (f) {
        return f.toLowerCase();
      });
      var valueIndex = lowerCaseValues.indexOf(family.toLowerCase());
      if (valueIndex >= 0) {
        initialValue = families[valueIndex];
      } else {
        // add user provided value to list
        var capitalisedFontValue = _.capitalise(family);
        families.push(capitalisedFontValue);
        initialValue = capitalisedFontValue;
      }
    }
    var options = families.sort().map(function (value) {
      return {
        value: value,
        text: value
      };
    });
    this.familySelect.addOptions(options).setInputWidth('flex').setValue("" + initialValue).onValueChange(function (newValue) {
      return _this.params.setFont({
        family: newValue
      });
    });
  };
  FontPanel.prototype.initFontSizeSelect = function () {
    var _this = this;
    var sizes = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36];
    var size = this.params.initialFont.size;
    if (!_.includes(sizes, size)) {
      sizes.push(size);
    }
    var options = sizes.sort(function (a, b) {
      return a - b;
    }).map(function (value) {
      return {
        value: "" + value,
        text: "" + value
      };
    });
    this.sizeSelect.addOptions(options).setInputWidth('flex').setValue("" + size).onValueChange(function (newValue) {
      return _this.params.setFont({
        size: parseInt(newValue, 10)
      });
    });
    this.sizeSelect.setLabel(this.chartTranslator.translate('size'));
  };
  FontPanel.prototype.initFontWeightStyleSelect = function () {
    var _this = this;
    var _a = this.params.initialFont,
      _b = _a.weight,
      weight = _b === void 0 ? 'normal' : _b,
      _c = _a.style,
      style = _c === void 0 ? 'normal' : _c;
    var weightStyles = [{
      name: 'normal',
      weight: 'normal',
      style: 'normal'
    }, {
      name: 'bold',
      weight: 'bold',
      style: 'normal'
    }, {
      name: 'italic',
      weight: 'normal',
      style: 'italic'
    }, {
      name: 'boldItalic',
      weight: 'bold',
      style: 'italic'
    }];
    var selectedOption = _.find(weightStyles, function (x) {
      return x.weight === weight && x.style === style;
    });
    if (!selectedOption) {
      selectedOption = {
        name: 'predefined',
        weight: weight,
        style: style
      };
      weightStyles.unshift(selectedOption);
    }
    var options = weightStyles.map(function (ws) {
      return {
        value: ws.name,
        text: _this.chartTranslator.translate(ws.name)
      };
    });
    this.weightStyleSelect.addOptions(options).setInputWidth('flex').setValue(selectedOption.name).onValueChange(function (newValue) {
      var selectedWeightStyle = _.find(weightStyles, function (x) {
        return x.name === newValue;
      });
      _this.params.setFont({
        weight: selectedWeightStyle.weight,
        style: selectedWeightStyle.style
      });
    });
  };
  FontPanel.prototype.initFontColorPicker = function () {
    var _this = this;
    this.colorPicker.setLabel(this.chartTranslator.translate('color')).setInputWidth(45).setValue("" + this.params.initialFont.color).onValueChange(function (newColor) {
      return _this.params.setFont({
        color: newColor
      });
    });
  };
  FontPanel.prototype.destroyActiveComps = function () {
    var _this = this;
    this.activeComps.forEach(function (comp) {
      _.removeFromParent(comp.getGui());
      _this.destroyBean(comp);
    });
  };
  FontPanel.prototype.destroy = function () {
    this.destroyActiveComps();
    _super.prototype.destroy.call(this);
  };
  FontPanel.TEMPLATE = "<div class=\"ag-font-panel\">\n            <ag-group-component ref=\"fontGroup\">\n                <ag-select ref=\"familySelect\"></ag-select>\n                <ag-select ref=\"weightStyleSelect\"></ag-select>\n                <div class=\"ag-charts-font-size-color\">\n                    <ag-select ref=\"sizeSelect\"></ag-select>\n                    <ag-color-picker ref=\"colorPicker\"></ag-color-picker>\n                </div>\n            </ag-group-component>\n        </div>";
  __decorate$3n([RefSelector('fontGroup')], FontPanel.prototype, "fontGroup", void 0);
  __decorate$3n([RefSelector('familySelect')], FontPanel.prototype, "familySelect", void 0);
  __decorate$3n([RefSelector('weightStyleSelect')], FontPanel.prototype, "weightStyleSelect", void 0);
  __decorate$3n([RefSelector('sizeSelect')], FontPanel.prototype, "sizeSelect", void 0);
  __decorate$3n([RefSelector('colorPicker')], FontPanel.prototype, "colorPicker", void 0);
  __decorate$3n([Autowired('chartTranslator')], FontPanel.prototype, "chartTranslator", void 0);
  __decorate$3n([PostConstruct], FontPanel.prototype, "init", null);
  return FontPanel;
}(Component);
var __extends$4w = undefined && undefined.__extends || function () {
  var _extendStatics297 = function extendStatics(d, b) {
    _extendStatics297 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics297(d, b);
  };
  return function (d, b) {
    _extendStatics297(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3o = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LegendPanel = /** @class */function (_super) {
  __extends$4w(LegendPanel, _super);
  function LegendPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  LegendPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(LegendPanel.TEMPLATE, {
      legendGroup: groupParams
    });
    this.initLegendGroup();
    this.initLegendPosition();
    this.initLegendPadding();
    this.initLegendItems();
    this.initLabelPanel();
  };
  LegendPanel.prototype.initLegendGroup = function () {
    var _this = this;
    this.legendGroup.setTitle(this.chartTranslator.translate("legend")).hideEnabledCheckbox(false).setEnabled(this.chartOptionsService.getChartOption("legend.enabled") || false).toggleGroupExpand(false).onEnableChange(function (enabled) {
      _this.chartOptionsService.setChartOption("legend.enabled", enabled);
      _this.legendGroup.toggleGroupExpand(true);
    });
  };
  LegendPanel.prototype.initLegendPosition = function () {
    var _this = this;
    var positions = [LegendPosition.Top, LegendPosition.Right, LegendPosition.Bottom, LegendPosition.Left];
    this.legendPositionSelect.setLabel(this.chartTranslator.translate("position")).setLabelWidth("flex").setInputWidth(80).addOptions(positions.map(function (position) {
      return {
        value: position,
        text: _this.chartTranslator.translate(position)
      };
    })).setValue(this.chartOptionsService.getChartOption("legend.position")).onValueChange(function (newValue) {
      return _this.chartOptionsService.setChartOption("legend.position", newValue);
    });
  };
  LegendPanel.prototype.initLegendPadding = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getChartOption("legend.spacing");
    this.legendPaddingSlider.setLabel(this.chartTranslator.translate("spacing")).setMaxValue(getMaxValue(currentValue, 200)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
      return _this.chartOptionsService.setChartOption("legend.spacing", newValue);
    });
  };
  LegendPanel.prototype.initLegendItems = function () {
    var _this = this;
    var initSlider = function initSlider(expression, labelKey, input, defaultMaxValue) {
      var currentValue = _this.chartOptionsService.getChartOption("legend." + expression);
      input.setLabel(_this.chartTranslator.translate(labelKey)).setMaxValue(getMaxValue(currentValue, defaultMaxValue)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
        _this.chartOptionsService.setChartOption("legend." + expression, newValue);
      });
    };
    initSlider("item.marker.size", "markerSize", this.markerSizeSlider, 40);
    initSlider("item.marker.strokeWidth", "markerStroke", this.markerStrokeSlider, 10);
    initSlider("item.marker.padding", "itemSpacing", this.markerPaddingSlider, 20);
    initSlider("item.paddingX", "layoutHorizontalSpacing", this.itemPaddingXSlider, 50);
    initSlider("item.paddingY", "layoutVerticalSpacing", this.itemPaddingYSlider, 50);
  };
  LegendPanel.prototype.initLabelPanel = function () {
    var _this = this;
    var chartProxy = this.chartOptionsService;
    var initialFont = {
      family: chartProxy.getChartOption("legend.item.label.fontFamily"),
      style: chartProxy.getChartOption("legend.item.label.fontStyle"),
      weight: chartProxy.getChartOption("legend.item.label.fontWeight"),
      size: chartProxy.getChartOption("legend.item.label.fontSize"),
      color: chartProxy.getChartOption("legend.item.label.color")
    };
    var setFont = function setFont(font) {
      var proxy = _this.chartOptionsService;
      if (font.family) {
        proxy.setChartOption("legend.item.label.fontFamily", font.family);
      }
      if (font.weight) {
        proxy.setChartOption("legend.item.label.fontWeight", font.weight);
      }
      if (font.style) {
        proxy.setChartOption("legend.item.label.fontStyle", font.style);
      }
      if (font.size) {
        proxy.setChartOption("legend.item.label.fontSize", font.size);
      }
      if (font.color) {
        proxy.setChartOption("legend.item.label.color", font.color);
      }
    };
    var params = {
      enabled: true,
      suppressEnabledCheckbox: true,
      initialFont: initialFont,
      setFont: setFont
    };
    var fontPanelComp = this.createBean(new FontPanel(params));
    this.legendGroup.addItem(fontPanelComp);
    this.activePanels.push(fontPanelComp);
  };
  LegendPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  LegendPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  LegendPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"legendGroup\">\n                <ag-select ref=\"legendPositionSelect\"></ag-select>\n                <ag-slider ref=\"legendPaddingSlider\"></ag-slider>\n                <ag-slider ref=\"markerSizeSlider\"></ag-slider>\n                <ag-slider ref=\"markerStrokeSlider\"></ag-slider>\n                <ag-slider ref=\"markerPaddingSlider\"></ag-slider>\n                <ag-slider ref=\"itemPaddingXSlider\"></ag-slider>\n                <ag-slider ref=\"itemPaddingYSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3o([RefSelector('legendGroup')], LegendPanel.prototype, "legendGroup", void 0);
  __decorate$3o([RefSelector('legendPositionSelect')], LegendPanel.prototype, "legendPositionSelect", void 0);
  __decorate$3o([RefSelector('legendPaddingSlider')], LegendPanel.prototype, "legendPaddingSlider", void 0);
  __decorate$3o([RefSelector('markerSizeSlider')], LegendPanel.prototype, "markerSizeSlider", void 0);
  __decorate$3o([RefSelector('markerStrokeSlider')], LegendPanel.prototype, "markerStrokeSlider", void 0);
  __decorate$3o([RefSelector('markerPaddingSlider')], LegendPanel.prototype, "markerPaddingSlider", void 0);
  __decorate$3o([RefSelector('itemPaddingXSlider')], LegendPanel.prototype, "itemPaddingXSlider", void 0);
  __decorate$3o([RefSelector('itemPaddingYSlider')], LegendPanel.prototype, "itemPaddingYSlider", void 0);
  __decorate$3o([Autowired('chartTranslator')], LegendPanel.prototype, "chartTranslator", void 0);
  __decorate$3o([PostConstruct], LegendPanel.prototype, "init", null);
  return LegendPanel;
}(Component);
var __extends$4x = undefined && undefined.__extends || function () {
  var _extendStatics298 = function extendStatics(d, b) {
    _extendStatics298 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics298(d, b);
  };
  return function (d, b) {
    _extendStatics298(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3p = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ShadowPanel = /** @class */function (_super) {
  __extends$4x(ShadowPanel, _super);
  function ShadowPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  ShadowPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical',
      suppressOpenCloseIcons: true
    };
    this.setTemplate(ShadowPanel.TEMPLATE, {
      shadowGroup: groupParams
    });
    this.shadowBlurSlider.setTextFieldWidth(45);
    this.shadowXOffsetSlider.setTextFieldWidth(45);
    this.shadowYOffsetSlider.setTextFieldWidth(45);
    this.initSeriesShadow();
  };
  ShadowPanel.prototype.initSeriesShadow = function () {
    var _this = this;
    this.shadowGroup.setTitle(this.chartTranslator.translate("shadow")).setEnabled(this.chartOptionsService.getSeriesOption("shadow.enabled")).hideOpenCloseIcons(true).hideEnabledCheckbox(false).onEnableChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("shadow.enabled", newValue);
    });
    this.shadowColorPicker.setLabel(this.chartTranslator.translate("color")).setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("shadow.color")).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("shadow.color", newValue);
    });
    var initInput = function initInput(input, property, minValue, defaultMaxValue) {
      var currentValue = _this.chartOptionsService.getSeriesOption("shadow." + property);
      input.setLabel(_this.chartTranslator.translate(property)).setMinValue(minValue).setMaxValue(getMaxValue(currentValue, defaultMaxValue)).setValue("" + currentValue).onValueChange(function (newValue) {
        return _this.chartOptionsService.setSeriesOption("shadow." + property, newValue);
      });
    };
    initInput(this.shadowBlurSlider, "blur", 0, 20);
    initInput(this.shadowXOffsetSlider, "xOffset", -10, 10);
    initInput(this.shadowYOffsetSlider, "yOffset", -10, 10);
  };
  ShadowPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"shadowGroup\">\n                <ag-color-picker ref=\"shadowColorPicker\"></ag-color-picker>\n                <ag-slider ref=\"shadowBlurSlider\"></ag-slider>\n                <ag-slider ref=\"shadowXOffsetSlider\"></ag-slider>\n                <ag-slider ref=\"shadowYOffsetSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3p([RefSelector('shadowGroup')], ShadowPanel.prototype, "shadowGroup", void 0);
  __decorate$3p([RefSelector('shadowColorPicker')], ShadowPanel.prototype, "shadowColorPicker", void 0);
  __decorate$3p([RefSelector('shadowBlurSlider')], ShadowPanel.prototype, "shadowBlurSlider", void 0);
  __decorate$3p([RefSelector('shadowXOffsetSlider')], ShadowPanel.prototype, "shadowXOffsetSlider", void 0);
  __decorate$3p([RefSelector('shadowYOffsetSlider')], ShadowPanel.prototype, "shadowYOffsetSlider", void 0);
  __decorate$3p([Autowired('chartTranslator')], ShadowPanel.prototype, "chartTranslator", void 0);
  __decorate$3p([PostConstruct], ShadowPanel.prototype, "init", null);
  return ShadowPanel;
}(Component);
function initLineOpacitySlider(seriesLineOpacitySlider, chartTranslator, chartOptionsService) {
  var currentValue = chartOptionsService.getSeriesOption("strokeOpacity");
  seriesLineOpacitySlider.setLabel(chartTranslator.translate("strokeOpacity")).setStep(0.05).setMaxValue(getMaxValue(currentValue, 1)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
    return chartOptionsService.setSeriesOption("strokeOpacity", newValue);
  });
}
function initFillOpacitySlider(seriesFillOpacitySlider, chartTranslator, chartOptionsService) {
  var currentValue = chartOptionsService.getSeriesOption("fillOpacity");
  seriesFillOpacitySlider.setLabel(chartTranslator.translate("fillOpacity")).setStep(0.05).setMaxValue(getMaxValue(currentValue, 1)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
    return chartOptionsService.setSeriesOption("fillOpacity", newValue);
  });
}
function initFontPanelParams(chartTranslator, chartOptionsService) {
  var initialFont = {
    family: chartOptionsService.getSeriesOption("label.fontFamily"),
    style: chartOptionsService.getSeriesOption("label.fontStyle"),
    weight: chartOptionsService.getSeriesOption("label.fontWeight"),
    size: chartOptionsService.getSeriesOption("label.fontSize"),
    color: chartOptionsService.getSeriesOption("label.color")
  };
  var setFont = function setFont(font) {
    if (font.family) {
      chartOptionsService.setSeriesOption("label.fontFamily", font.family);
    }
    if (font.weight) {
      chartOptionsService.setSeriesOption("label.fontWeight", font.weight);
    }
    if (font.style) {
      chartOptionsService.setSeriesOption("label.fontStyle", font.style);
    }
    if (font.size) {
      chartOptionsService.setSeriesOption("label.fontSize", font.size);
    }
    if (font.color) {
      chartOptionsService.setSeriesOption("label.color", font.color);
    }
  };
  var params = {
    name: chartTranslator.translate('labels'),
    enabled: chartOptionsService.getSeriesOption("label.enabled") || false,
    setEnabled: function setEnabled(enabled) {
      return chartOptionsService.setSeriesOption("label.enabled", enabled);
    },
    suppressEnabledCheckbox: false,
    initialFont: initialFont,
    setFont: setFont
  };
  return params;
}
var __extends$4y = undefined && undefined.__extends || function () {
  var _extendStatics299 = function extendStatics(d, b) {
    _extendStatics299 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics299(d, b);
  };
  return function (d, b) {
    _extendStatics299(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BarSeriesPanel = /** @class */function (_super) {
  __extends$4y(BarSeriesPanel, _super);
  function BarSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  BarSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(BarSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
    this.initSeriesTooltips();
    this.initSeriesStrokeWidth();
    this.initSeriesLineDash();
    this.initOpacity();
    this.initLabelPanel();
    this.initShadowPanel();
  };
  BarSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  BarSeriesPanel.prototype.initSeriesStrokeWidth = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("strokeWidth");
    this.seriesStrokeWidthSlider.setLabel(this.chartTranslator.translate("strokeWidth")).setMaxValue(getMaxValue(currentValue, 10)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeWidth", newValue);
    });
  };
  BarSeriesPanel.prototype.initSeriesLineDash = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("lineDash")[0];
    this.seriesLineDashSlider.setLabel(this.chartTranslator.translate('lineDash')).setMaxValue(getMaxValue(currentValue, 30)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("lineDash", [newValue]);
    });
  };
  BarSeriesPanel.prototype.initOpacity = function () {
    initLineOpacitySlider(this.seriesLineOpacitySlider, this.chartTranslator, this.chartOptionsService);
    initFillOpacitySlider(this.seriesFillOpacitySlider, this.chartTranslator, this.chartOptionsService);
  };
  BarSeriesPanel.prototype.initLabelPanel = function () {
    var params = initFontPanelParams(this.chartTranslator, this.chartOptionsService);
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  BarSeriesPanel.prototype.initShadowPanel = function () {
    var shadowPanelComp = this.createBean(new ShadowPanel(this.chartOptionsService));
    this.seriesGroup.addItem(shadowPanelComp);
    this.activePanels.push(shadowPanelComp);
  };
  BarSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  BarSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  BarSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n                <ag-slider ref=\"seriesStrokeWidthSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineDashSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineOpacitySlider\"></ag-slider>\n                <ag-slider ref=\"seriesFillOpacitySlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3q([RefSelector('seriesGroup')], BarSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3q([RefSelector('seriesTooltipsToggle')], BarSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3q([RefSelector('seriesStrokeWidthSlider')], BarSeriesPanel.prototype, "seriesStrokeWidthSlider", void 0);
  __decorate$3q([RefSelector('seriesLineDashSlider')], BarSeriesPanel.prototype, "seriesLineDashSlider", void 0);
  __decorate$3q([RefSelector('seriesLineOpacitySlider')], BarSeriesPanel.prototype, "seriesLineOpacitySlider", void 0);
  __decorate$3q([RefSelector('seriesFillOpacitySlider')], BarSeriesPanel.prototype, "seriesFillOpacitySlider", void 0);
  __decorate$3q([Autowired('chartTranslator')], BarSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3q([PostConstruct], BarSeriesPanel.prototype, "init", null);
  return BarSeriesPanel;
}(Component);
var __extends$4z = undefined && undefined.__extends || function () {
  var _extendStatics300 = function extendStatics(d, b) {
    _extendStatics300 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics300(d, b);
  };
  return function (d, b) {
    _extendStatics300(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3r = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AxisTicksPanel = /** @class */function (_super) {
  __extends$4z(AxisTicksPanel, _super);
  function AxisTicksPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  AxisTicksPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical',
      suppressOpenCloseIcons: true
    };
    this.setTemplate(AxisTicksPanel.TEMPLATE, {
      axisTicksGroup: groupParams
    });
    this.initAxisTicks();
  };
  AxisTicksPanel.prototype.initAxisTicks = function () {
    var _this = this;
    this.axisTicksGroup.setTitle(this.chartTranslator.translate("ticks")).hideOpenCloseIcons(true).hideEnabledCheckbox(true);
    this.axisTicksColorPicker.setLabel(this.chartTranslator.translate("color")).setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getAxisProperty("tick.color")).onValueChange(function (newColor) {
      return _this.chartOptionsService.setAxisProperty("tick.color", newColor);
    });
    var initInput = function initInput(expression, input, label, defaultMaxValue) {
      var currentValue = _this.chartOptionsService.getAxisProperty(expression);
      input.setLabel(label).setMaxValue(getMaxValue(currentValue, defaultMaxValue)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
        return _this.chartOptionsService.setAxisProperty(expression, newValue);
      });
    };
    initInput("tick.width", this.axisTicksWidthSlider, this.chartTranslator.translate("width"), 10);
    initInput("tick.size", this.axisTicksSizeSlider, this.chartTranslator.translate("length"), 30);
  };
  AxisTicksPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"axisTicksGroup\">\n                <ag-color-picker ref=\"axisTicksColorPicker\"></ag-color-picker>\n                <ag-slider ref=\"axisTicksWidthSlider\"></ag-slider>\n                <ag-slider ref=\"axisTicksSizeSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3r([RefSelector('axisTicksGroup')], AxisTicksPanel.prototype, "axisTicksGroup", void 0);
  __decorate$3r([RefSelector('axisTicksColorPicker')], AxisTicksPanel.prototype, "axisTicksColorPicker", void 0);
  __decorate$3r([RefSelector('axisTicksWidthSlider')], AxisTicksPanel.prototype, "axisTicksWidthSlider", void 0);
  __decorate$3r([RefSelector('axisTicksSizeSlider')], AxisTicksPanel.prototype, "axisTicksSizeSlider", void 0);
  __decorate$3r([Autowired('chartTranslator')], AxisTicksPanel.prototype, "chartTranslator", void 0);
  __decorate$3r([PostConstruct], AxisTicksPanel.prototype, "init", null);
  return AxisTicksPanel;
}(Component);
var __extends$4A = undefined && undefined.__extends || function () {
  var _extendStatics301 = function extendStatics(d, b) {
    _extendStatics301 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics301(d, b);
  };
  return function (d, b) {
    _extendStatics301(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3s = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AxisPanel = /** @class */function (_super) {
  __extends$4A(AxisPanel, _super);
  function AxisPanel(chartController, chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartController = chartController;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    _this.axisLabelUpdateFuncs = [];
    return _this;
  }
  AxisPanel.prototype.init = function () {
    var _this = this;
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(AxisPanel.TEMPLATE, {
      axisGroup: groupParams
    });
    this.initAxis();
    this.initAxisTicks();
    this.initAxisLabels();
    var updateAxisLabelRotations = function updateAxisLabelRotations() {
      return _this.axisLabelUpdateFuncs.forEach(function (func) {
        return func();
      });
    };
    this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, updateAxisLabelRotations);
  };
  AxisPanel.prototype.initAxis = function () {
    var _this = this;
    var chartTranslator = this.chartTranslator;
    this.axisGroup.setTitle(chartTranslator.translate("axis")).toggleGroupExpand(false).hideEnabledCheckbox(true);
    this.axisColorInput.setLabel(chartTranslator.translate("color")).setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getAxisProperty("line.color")).onValueChange(function (newColor) {
      return _this.chartOptionsService.setAxisProperty("line.color", newColor);
    });
    var currentValue = this.chartOptionsService.getAxisProperty("line.width");
    this.axisLineWidthSlider.setMaxValue(getMaxValue(currentValue, 10)).setLabel(chartTranslator.translate("thickness")).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setAxisProperty("line.width", newValue);
    });
    if (_.includes(['line', 'scatter', 'bubble'], this.chartController.getChartType()) && !this.chartController.isGrouping()) {
      var options_1 = [{
        value: '',
        text: chartTranslator.translate('automatic')
      }];
      ['category', 'time', 'number'].forEach(function (type) {
        options_1.push({
          value: type,
          text: chartTranslator.translate(type)
        });
      });
      this.xAxisTypeSelect.setLabel(chartTranslator.translate('xType')).setLabelWidth('flex').addOptions(options_1).setValue(this.chartOptionsService.getChartOption('xAxis.type') || '').onValueChange(function (newValue) {
        _this.chartOptionsService.setChartOption('xAxis.type', typeof newValue === 'string' && newValue.length && newValue);
        _this.chartController.updateForDataChange();
      });
    } else {
      this.xAxisTypeSelect.setDisplayed(false);
    }
  };
  AxisPanel.prototype.initAxisTicks = function () {
    var axisTicksComp = this.createBean(new AxisTicksPanel(this.chartOptionsService));
    this.axisGroup.addItem(axisTicksComp);
    this.activePanels.push(axisTicksComp);
  };
  AxisPanel.prototype.initAxisLabels = function () {
    var _this = this;
    var initialFont = {
      family: this.chartOptionsService.getAxisProperty("label.fontFamily"),
      style: this.chartOptionsService.getAxisProperty("label.fontStyle"),
      weight: this.chartOptionsService.getAxisProperty("label.fontWeight"),
      size: this.chartOptionsService.getAxisProperty("label.fontSize"),
      color: this.chartOptionsService.getAxisProperty("label.color")
    };
    var setFont = function setFont(font) {
      if (font.family) {
        _this.chartOptionsService.setAxisProperty("label.fontFamily", font.family);
      }
      if (font.weight) {
        _this.chartOptionsService.setAxisProperty("label.fontWeight", font.weight);
      }
      if (font.style) {
        _this.chartOptionsService.setAxisProperty("label.fontStyle", font.style);
      }
      if (font.size) {
        _this.chartOptionsService.setAxisProperty("label.fontSize", font.size);
      }
      if (font.color) {
        _this.chartOptionsService.setAxisProperty("label.color", font.color);
      }
      _this.chartController.getChartProxy().getChart().layoutPending = true;
    };
    var params = {
      enabled: true,
      suppressEnabledCheckbox: true,
      initialFont: initialFont,
      setFont: setFont
    };
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.axisGroup.addItem(labelPanelComp);
    this.activePanels.push(labelPanelComp);
    this.addAdditionalLabelComps(labelPanelComp);
  };
  AxisPanel.prototype.addAdditionalLabelComps = function (labelPanelComp) {
    var _this = this;
    var createAngleComp = function createAngleComp(label, axisType) {
      var value = _this.chartOptionsService.getLabelRotation(axisType);
      var angleSelect = new AgAngleSelect().setLabel(label).setLabelWidth("flex").setValue(value || 0).onValueChange(function (newValue) {
        return _this.chartOptionsService.setLabelRotation(axisType, newValue);
      });
      // the axis label rotation needs to be updated when the default category changes in the data panel
      _this.axisLabelUpdateFuncs.push(function () {
        var value = _this.chartOptionsService.getLabelRotation(axisType);
        angleSelect.setValue(value);
      });
      var rotationInput = _this.createBean(angleSelect);
      labelPanelComp.addCompToPanel(rotationInput);
    };
    var degreesSymbol = String.fromCharCode(176);
    var xRotationLabel = this.chartTranslator.translate("xRotation") + " " + degreesSymbol;
    var yRotationLabel = this.chartTranslator.translate("yRotation") + " " + degreesSymbol;
    createAngleComp(xRotationLabel, "xAxis");
    createAngleComp(yRotationLabel, "yAxis");
    var labelPaddingSlider = this.createBean(new AgSlider());
    var currentValue = this.chartOptionsService.getAxisProperty("label.padding");
    labelPaddingSlider.setLabel(this.chartTranslator.translate("padding")).setMaxValue(getMaxValue(currentValue, 30)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
      return _this.chartOptionsService.setAxisProperty("label.padding", newValue);
    });
    labelPanelComp.addCompToPanel(labelPaddingSlider);
  };
  AxisPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  AxisPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  AxisPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"axisGroup\">\n                <ag-color-picker ref=\"axisColorInput\"></ag-color-picker>\n                <ag-slider ref=\"axisLineWidthSlider\"></ag-slider>\n                <ag-select ref=\"xAxisTypeSelect\"></ag-select>\n            </ag-group-component>\n        </div>";
  __decorate$3s([RefSelector('axisGroup')], AxisPanel.prototype, "axisGroup", void 0);
  __decorate$3s([RefSelector('axisColorInput')], AxisPanel.prototype, "axisColorInput", void 0);
  __decorate$3s([RefSelector('axisLineWidthSlider')], AxisPanel.prototype, "axisLineWidthSlider", void 0);
  __decorate$3s([RefSelector('xAxisTypeSelect')], AxisPanel.prototype, "xAxisTypeSelect", void 0);
  __decorate$3s([Autowired('chartTranslator')], AxisPanel.prototype, "chartTranslator", void 0);
  __decorate$3s([PostConstruct], AxisPanel.prototype, "init", null);
  return AxisPanel;
}(Component);
var __extends$4B = undefined && undefined.__extends || function () {
  var _extendStatics302 = function extendStatics(d, b) {
    _extendStatics302 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics302(d, b);
  };
  return function (d, b) {
    _extendStatics302(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3t = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NavigatorPanel = /** @class */function (_super) {
  __extends$4B(NavigatorPanel, _super);
  function NavigatorPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  NavigatorPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(NavigatorPanel.TEMPLATE, {
      navigatorGroup: groupParams
    });
    this.initNavigator();
  };
  NavigatorPanel.prototype.initNavigator = function () {
    var _this = this;
    var chartTranslator = this.chartTranslator;
    this.navigatorGroup.setTitle(chartTranslator.translate("navigator")).toggleGroupExpand(false).hideEnabledCheckbox(false).setEnabled(this.chartOptionsService.getChartOption("navigator.enabled") || false).onEnableChange(function (enabled) {
      _this.chartOptionsService.setChartOption("navigator.enabled", enabled);
      _this.navigatorGroup.toggleGroupExpand(true);
    });
    var currentValue = this.chartOptionsService.getChartOption("navigator.height");
    this.navigatorHeightSlider.setLabel(chartTranslator.translate("height")).setMinValue(10).setMaxValue(getMaxValue(currentValue, 60)).setTextFieldWidth(45).setValue("" + (currentValue || 30)).onValueChange(function (height) {
      return _this.chartOptionsService.setChartOption("navigator.height", height);
    });
  };
  NavigatorPanel.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  NavigatorPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"navigatorGroup\">\n                <ag-slider ref=\"navigatorHeightSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3t([RefSelector('navigatorGroup')], NavigatorPanel.prototype, "navigatorGroup", void 0);
  __decorate$3t([RefSelector('navigatorHeightSlider')], NavigatorPanel.prototype, "navigatorHeightSlider", void 0);
  __decorate$3t([Autowired('chartTranslator')], NavigatorPanel.prototype, "chartTranslator", void 0);
  __decorate$3t([PostConstruct], NavigatorPanel.prototype, "init", null);
  return NavigatorPanel;
}(Component);
var __extends$4C = undefined && undefined.__extends || function () {
  var _extendStatics303 = function extendStatics(d, b) {
    _extendStatics303 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics303(d, b);
  };
  return function (d, b) {
    _extendStatics303(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3u = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MarkersPanel = /** @class */function (_super) {
  __extends$4C(MarkersPanel, _super);
  function MarkersPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  MarkersPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical'
    };
    this.setTemplate(MarkersPanel.TEMPLATE, {
      seriesMarkersGroup: groupParams
    });
    this.initMarkers();
  };
  MarkersPanel.prototype.initMarkers = function () {
    var _this = this;
    var seriesMarkerShapeOptions = [{
      value: 'square',
      text: 'Square'
    }, {
      value: 'circle',
      text: 'Circle'
    }, {
      value: 'cross',
      text: 'Cross'
    }, {
      value: 'diamond',
      text: 'Diamond'
    }, {
      value: 'plus',
      text: 'Plus'
    }, {
      value: 'triangle',
      text: 'Triangle'
    }, {
      value: 'heart',
      text: 'Heart'
    }];
    this.seriesMarkerShapeSelect.addOptions(seriesMarkerShapeOptions).setLabel(this.chartTranslator.translate('shape')).setValue(this.chartOptionsService.getSeriesOption("marker.shape")).onValueChange(function (value) {
      return _this.chartOptionsService.setSeriesOption("marker.shape", value);
    });
    // scatter charts should always show markers
    var chartType = this.chartOptionsService.getChartType();
    var shouldHideEnabledCheckbox = _.includes([ChartType.Scatter, ChartType.Bubble], chartType);
    this.seriesMarkersGroup.setTitle(this.chartTranslator.translate("markers")).hideEnabledCheckbox(shouldHideEnabledCheckbox).setEnabled(this.chartOptionsService.getSeriesOption("marker.enabled") || false).hideOpenCloseIcons(true).onEnableChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("marker.enabled", newValue);
    });
    var initInput = function initInput(expression, input, labelKey, defaultMaxValue) {
      var currentValue = _this.chartOptionsService.getSeriesOption(expression);
      input.setLabel(_this.chartTranslator.translate(labelKey)).setMaxValue(getMaxValue(currentValue, defaultMaxValue)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
        return _this.chartOptionsService.setSeriesOption(expression, newValue);
      });
    };
    if (chartType === ChartType.Bubble) {
      initInput("marker.maxSize", this.seriesMarkerMinSizeSlider, "maxSize", 60);
      initInput("marker.size", this.seriesMarkerSizeSlider, "minSize", 60);
    } else {
      this.seriesMarkerMinSizeSlider.setDisplayed(false);
      initInput("marker.size", this.seriesMarkerSizeSlider, "size", 60);
    }
    initInput("marker.strokeWidth", this.seriesMarkerStrokeWidthSlider, "strokeWidth", 10);
  };
  MarkersPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesMarkersGroup\">\n                <ag-select ref=\"seriesMarkerShapeSelect\"></ag-select>\n                <ag-slider ref=\"seriesMarkerMinSizeSlider\"></ag-slider>\n                <ag-slider ref=\"seriesMarkerSizeSlider\"></ag-slider>\n                <ag-slider ref=\"seriesMarkerStrokeWidthSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3u([RefSelector('seriesMarkersGroup')], MarkersPanel.prototype, "seriesMarkersGroup", void 0);
  __decorate$3u([RefSelector('seriesMarkerShapeSelect')], MarkersPanel.prototype, "seriesMarkerShapeSelect", void 0);
  __decorate$3u([RefSelector('seriesMarkerSizeSlider')], MarkersPanel.prototype, "seriesMarkerSizeSlider", void 0);
  __decorate$3u([RefSelector('seriesMarkerMinSizeSlider')], MarkersPanel.prototype, "seriesMarkerMinSizeSlider", void 0);
  __decorate$3u([RefSelector('seriesMarkerStrokeWidthSlider')], MarkersPanel.prototype, "seriesMarkerStrokeWidthSlider", void 0);
  __decorate$3u([Autowired('chartTranslator')], MarkersPanel.prototype, "chartTranslator", void 0);
  __decorate$3u([PostConstruct], MarkersPanel.prototype, "init", null);
  return MarkersPanel;
}(Component);
var __extends$4D = undefined && undefined.__extends || function () {
  var _extendStatics304 = function extendStatics(d, b) {
    _extendStatics304 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics304(d, b);
  };
  return function (d, b) {
    _extendStatics304(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3v = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LineSeriesPanel = /** @class */function (_super) {
  __extends$4D(LineSeriesPanel, _super);
  function LineSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  LineSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(LineSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.initSeriesGroup();
    this.initSeriesTooltips();
    this.initSeriesLineWidth();
    this.initSeriesLineDash();
    this.initMarkersPanel();
    this.initLabelPanel();
  };
  LineSeriesPanel.prototype.initSeriesGroup = function () {
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
  };
  LineSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  LineSeriesPanel.prototype.initSeriesLineWidth = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("strokeWidth");
    this.seriesLineWidthSlider.setLabel(this.chartTranslator.translate('lineWidth')).setMaxValue(getMaxValue(currentValue, 10)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeWidth", newValue);
    });
  };
  LineSeriesPanel.prototype.initSeriesLineDash = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("lineDash");
    this.seriesLineDashSlider.setLabel(this.chartTranslator.translate('lineDash')).setMaxValue(getMaxValue(currentValue, 30)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("lineDash", [newValue]);
    });
  };
  LineSeriesPanel.prototype.initMarkersPanel = function () {
    var markersPanelComp = this.createBean(new MarkersPanel(this.chartOptionsService));
    this.seriesGroup.addItem(markersPanelComp);
    this.activePanels.push(markersPanelComp);
  };
  LineSeriesPanel.prototype.initLabelPanel = function () {
    var params = initFontPanelParams(this.chartTranslator, this.chartOptionsService);
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  LineSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  LineSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  LineSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n                <ag-slider ref=\"seriesLineWidthSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineDashSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3v([RefSelector('seriesGroup')], LineSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3v([RefSelector('seriesTooltipsToggle')], LineSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3v([RefSelector('seriesLineWidthSlider')], LineSeriesPanel.prototype, "seriesLineWidthSlider", void 0);
  __decorate$3v([RefSelector('seriesLineDashSlider')], LineSeriesPanel.prototype, "seriesLineDashSlider", void 0);
  __decorate$3v([Autowired('chartTranslator')], LineSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3v([PostConstruct], LineSeriesPanel.prototype, "init", null);
  return LineSeriesPanel;
}(Component);
var __extends$4E = undefined && undefined.__extends || function () {
  var _extendStatics305 = function extendStatics(d, b) {
    _extendStatics305 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics305(d, b);
  };
  return function (d, b) {
    _extendStatics305(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3w = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CalloutPanel = /** @class */function (_super) {
  __extends$4E(CalloutPanel, _super);
  function CalloutPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  CalloutPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical'
    };
    this.setTemplate(CalloutPanel.TEMPLATE, {
      calloutGroup: groupParams
    });
    this.initCalloutOptions();
  };
  CalloutPanel.prototype.initCalloutOptions = function () {
    var _this = this;
    this.calloutGroup.setTitle(this.chartTranslator.translate("callout")).setEnabled(true).hideOpenCloseIcons(true).hideEnabledCheckbox(true);
    var initInput = function initInput(expression, input, labelKey, defaultMaxValue) {
      var currentValue = _this.chartOptionsService.getSeriesOption(expression);
      input.setLabel(_this.chartTranslator.translate(labelKey)).setMaxValue(getMaxValue(currentValue, defaultMaxValue)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
        return _this.chartOptionsService.setSeriesOption(expression, newValue);
      });
    };
    initInput("callout.length", this.calloutLengthSlider, "length", 40);
    initInput("callout.strokeWidth", this.calloutStrokeWidthSlider, "strokeWidth", 10);
    initInput("label.offset", this.labelOffsetSlider, "offset", 30);
  };
  CalloutPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"calloutGroup\">\n                <ag-slider ref=\"calloutLengthSlider\"></ag-slider>\n                <ag-slider ref=\"calloutStrokeWidthSlider\"></ag-slider>\n                <ag-slider ref=\"labelOffsetSlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3w([RefSelector('calloutGroup')], CalloutPanel.prototype, "calloutGroup", void 0);
  __decorate$3w([RefSelector('calloutLengthSlider')], CalloutPanel.prototype, "calloutLengthSlider", void 0);
  __decorate$3w([RefSelector('calloutStrokeWidthSlider')], CalloutPanel.prototype, "calloutStrokeWidthSlider", void 0);
  __decorate$3w([RefSelector('labelOffsetSlider')], CalloutPanel.prototype, "labelOffsetSlider", void 0);
  __decorate$3w([Autowired('chartTranslator')], CalloutPanel.prototype, "chartTranslator", void 0);
  __decorate$3w([PostConstruct], CalloutPanel.prototype, "init", null);
  return CalloutPanel;
}(Component);
var __extends$4F = undefined && undefined.__extends || function () {
  var _extendStatics306 = function extendStatics(d, b) {
    _extendStatics306 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics306(d, b);
  };
  return function (d, b) {
    _extendStatics306(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3x = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PieSeriesPanel = /** @class */function (_super) {
  __extends$4F(PieSeriesPanel, _super);
  function PieSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  PieSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(PieSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.initGroup();
    this.initSeriesTooltips();
    this.initSeriesStrokeWidth();
    this.initOpacity();
    this.initLabelPanel();
    this.initShadowPanel();
  };
  PieSeriesPanel.prototype.initGroup = function () {
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
  };
  PieSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  PieSeriesPanel.prototype.initSeriesStrokeWidth = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("strokeWidth");
    this.seriesStrokeWidthSlider.setLabel(this.chartTranslator.translate("strokeWidth")).setMaxValue(getMaxValue(currentValue, 10)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeWidth", newValue);
    });
  };
  PieSeriesPanel.prototype.initOpacity = function () {
    var _this = this;
    var currentLineOpacityValue = this.chartOptionsService.getSeriesOption("strokeOpacity") || 1;
    this.seriesLineOpacitySlider.setLabel(this.chartTranslator.translate("strokeOpacity")).setStep(0.05).setMaxValue(getMaxValue(currentLineOpacityValue, 1)).setTextFieldWidth(45).setValue("" + currentLineOpacityValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeOpacity", newValue);
    });
    var currentFillOpacityValue = this.chartOptionsService.getSeriesOption("fillOpacity") || 1;
    this.seriesFillOpacitySlider.setLabel(this.chartTranslator.translate("fillOpacity")).setStep(0.05).setMaxValue(getMaxValue(currentFillOpacityValue, 1)).setTextFieldWidth(45).setValue("" + currentFillOpacityValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("fillOpacity", newValue);
    });
  };
  PieSeriesPanel.prototype.initLabelPanel = function () {
    var _this = this;
    var initialFont = {
      family: this.chartOptionsService.getSeriesOption("label.fontFamily"),
      style: this.chartOptionsService.getSeriesOption("label.fontStyle"),
      weight: this.chartOptionsService.getSeriesOption("label.fontWeight"),
      size: this.chartOptionsService.getSeriesOption("label.fontSize"),
      color: this.chartOptionsService.getSeriesOption("label.color")
    };
    var setFont = function setFont(font) {
      if (font.family) {
        _this.chartOptionsService.setSeriesOption("label.fontFamily", font.family);
      }
      if (font.weight) {
        _this.chartOptionsService.setSeriesOption("label.fontWeight", font.weight);
      }
      if (font.style) {
        _this.chartOptionsService.setSeriesOption("label.fontStyle", font.style);
      }
      if (font.size) {
        _this.chartOptionsService.setSeriesOption("label.fontSize", font.size);
      }
      if (font.color) {
        _this.chartOptionsService.setSeriesOption("label.color", font.color);
      }
    };
    var params = {
      name: this.chartTranslator.translate('labels'),
      enabled: this.chartOptionsService.getSeriesOption("label.enabled") || false,
      setEnabled: function setEnabled(enabled) {
        return _this.chartOptionsService.setSeriesOption("label.enabled", enabled);
      },
      suppressEnabledCheckbox: false,
      initialFont: initialFont,
      setFont: setFont
    };
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    var calloutPanelComp = this.createBean(new CalloutPanel(this.chartOptionsService));
    labelPanelComp.addCompToPanel(calloutPanelComp);
    this.activePanels.push(calloutPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  PieSeriesPanel.prototype.initShadowPanel = function () {
    var shadowPanelComp = this.createBean(new ShadowPanel(this.chartOptionsService));
    this.seriesGroup.getGui().appendChild(shadowPanelComp.getGui());
    this.seriesGroup.addItem(shadowPanelComp);
  };
  PieSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  PieSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  PieSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n                <ag-slider ref=\"seriesStrokeWidthSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineOpacitySlider\"></ag-slider>\n                <ag-slider ref=\"seriesFillOpacitySlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3x([RefSelector('seriesGroup')], PieSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3x([RefSelector('seriesTooltipsToggle')], PieSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3x([RefSelector('seriesStrokeWidthSlider')], PieSeriesPanel.prototype, "seriesStrokeWidthSlider", void 0);
  __decorate$3x([RefSelector('seriesLineOpacitySlider')], PieSeriesPanel.prototype, "seriesLineOpacitySlider", void 0);
  __decorate$3x([RefSelector('seriesFillOpacitySlider')], PieSeriesPanel.prototype, "seriesFillOpacitySlider", void 0);
  __decorate$3x([Autowired('chartTranslator')], PieSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3x([PostConstruct], PieSeriesPanel.prototype, "init", null);
  return PieSeriesPanel;
}(Component);
var __extends$4G = undefined && undefined.__extends || function () {
  var _extendStatics307 = function extendStatics(d, b) {
    _extendStatics307 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics307(d, b);
  };
  return function (d, b) {
    _extendStatics307(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaddingPanel = /** @class */function (_super) {
  __extends$4G(PaddingPanel, _super);
  function PaddingPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  PaddingPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical',
      suppressOpenCloseIcons: true
    };
    this.setTemplate(PaddingPanel.TEMPLATE, {
      chartPaddingGroup: groupParams
    });
    this.initGroup();
    this.initChartPaddingItems();
  };
  PaddingPanel.prototype.initGroup = function () {
    this.chartPaddingGroup.setTitle(this.chartTranslator.translate("padding")).hideOpenCloseIcons(true).hideEnabledCheckbox(true);
  };
  PaddingPanel.prototype.initChartPaddingItems = function () {
    var _this = this;
    var initInput = function initInput(property, input) {
      var currentValue = _this.chartOptionsService.getChartOption('padding.' + property);
      input.setLabel(_this.chartTranslator.translate(property)).setMaxValue(getMaxValue(currentValue, 200)).setValue("" + currentValue).setTextFieldWidth(45).onValueChange(function (newValue) {
        return _this.chartOptionsService.setChartOption('padding.' + property, newValue);
      });
    };
    initInput('top', this.paddingTopSlider);
    initInput('right', this.paddingRightSlider);
    initInput('bottom', this.paddingBottomSlider);
    initInput('left', this.paddingLeftSlider);
  };
  PaddingPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"chartPaddingGroup\">\n                <ag-slider ref=\"paddingTopSlider\"></ag-slider>\n                <ag-slider ref=\"paddingRightSlider\"></ag-slider>\n                <ag-slider ref=\"paddingBottomSlider\"></ag-slider>\n                <ag-slider ref=\"paddingLeftSlider\"></ag-slider>\n            </ag-group-component>\n        <div>";
  __decorate$3y([RefSelector('chartPaddingGroup')], PaddingPanel.prototype, "chartPaddingGroup", void 0);
  __decorate$3y([RefSelector('paddingTopSlider')], PaddingPanel.prototype, "paddingTopSlider", void 0);
  __decorate$3y([RefSelector('paddingRightSlider')], PaddingPanel.prototype, "paddingRightSlider", void 0);
  __decorate$3y([RefSelector('paddingBottomSlider')], PaddingPanel.prototype, "paddingBottomSlider", void 0);
  __decorate$3y([RefSelector('paddingLeftSlider')], PaddingPanel.prototype, "paddingLeftSlider", void 0);
  __decorate$3y([Autowired('chartTranslator')], PaddingPanel.prototype, "chartTranslator", void 0);
  __decorate$3y([PostConstruct], PaddingPanel.prototype, "init", null);
  return PaddingPanel;
}(Component);
var __extends$4H = undefined && undefined.__extends || function () {
  var _extendStatics308 = function extendStatics(d, b) {
    _extendStatics308 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics308(d, b);
  };
  return function (d, b) {
    _extendStatics308(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BackgroundPanel = /** @class */function (_super) {
  __extends$4H(BackgroundPanel, _super);
  function BackgroundPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    return _this;
  }
  BackgroundPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-sub-level',
      direction: 'vertical',
      suppressOpenCloseIcons: true
    };
    this.setTemplate(BackgroundPanel.TEMPLATE, {
      chartBackgroundGroup: groupParams
    });
    this.initGroup();
    this.initColorPicker();
  };
  BackgroundPanel.prototype.initGroup = function () {
    var _this = this;
    this.group.setTitle(this.chartTranslator.translate('background')).setEnabled(this.chartOptionsService.getChartOption('background.visible')).hideOpenCloseIcons(true).hideEnabledCheckbox(false).onEnableChange(function (enabled) {
      return _this.chartOptionsService.setChartOption('background.visible', enabled);
    });
  };
  BackgroundPanel.prototype.initColorPicker = function () {
    var _this = this;
    this.colorPicker.setLabel(this.chartTranslator.translate('color')).setLabelWidth('flex').setInputWidth(45).setValue(this.chartOptionsService.getChartOption('background.fill')).onValueChange(function (newColor) {
      return _this.chartOptionsService.setChartOption('background.fill', newColor);
    });
  };
  BackgroundPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"chartBackgroundGroup\">\n                <ag-color-picker ref=\"colorPicker\"></ag-color-picker>\n            </ag-group-component>\n        <div>";
  __decorate$3z([RefSelector('chartBackgroundGroup')], BackgroundPanel.prototype, "group", void 0);
  __decorate$3z([RefSelector('colorPicker')], BackgroundPanel.prototype, "colorPicker", void 0);
  __decorate$3z([Autowired('chartTranslator')], BackgroundPanel.prototype, "chartTranslator", void 0);
  __decorate$3z([PostConstruct], BackgroundPanel.prototype, "init", null);
  return BackgroundPanel;
}(Component);
var __extends$4I = undefined && undefined.__extends || function () {
  var _extendStatics309 = function extendStatics(d, b) {
    _extendStatics309 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics309(d, b);
  };
  return function (d, b) {
    _extendStatics309(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3A = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TitlePanel = /** @class */function (_super) {
  __extends$4I(TitlePanel, _super);
  function TitlePanel(chartOptionsService) {
    var _this = _super.call(this, TitlePanel.TEMPLATE) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  TitlePanel.prototype.init = function () {
    this.initFontPanel();
    this.titlePlaceholder = this.chartTranslator.translate('titlePlaceholder');
  };
  TitlePanel.prototype.hasTitle = function () {
    var title = this.getOption('title');
    return title && title.enabled && title.text && title.text.length > 0;
  };
  TitlePanel.prototype.initFontPanel = function () {
    var _this = this;
    var hasTitle = this.hasTitle;
    var setFont = function setFont(font) {
      if (font.family) {
        _this.setOption('title.fontFamily', font.family);
      }
      if (font.weight) {
        _this.setOption('title.fontWeight', font.weight);
      }
      if (font.style) {
        _this.setOption('title.fontStyle', font.style);
      }
      if (font.size) {
        _this.setOption('title.fontSize', font.size);
      }
      if (font.color) {
        _this.setOption('title.color', font.color);
      }
    };
    var initialFont = {
      family: this.getOption('title.fontFamily'),
      style: this.getOption('title.fontStyle'),
      weight: this.getOption('title.fontWeight'),
      size: this.getOption('title.fontSize'),
      color: this.getOption('title.color')
    };
    if (!hasTitle) {
      setFont(initialFont);
    }
    var fontPanelParams = {
      name: this.chartTranslator.translate('title'),
      enabled: this.hasTitle(),
      suppressEnabledCheckbox: false,
      initialFont: initialFont,
      setFont: setFont,
      setEnabled: function setEnabled(enabled) {
        _this.setOption('title.enabled', enabled);
        var currentTitleText = _this.getOption('title.text');
        if (enabled && currentTitleText === 'Title') {
          _this.setOption('title.text', _this.titlePlaceholder);
        }
      }
    };
    var fontPanelComp = this.createBean(new FontPanel(fontPanelParams));
    this.getGui().appendChild(fontPanelComp.getGui());
    this.activePanels.push(fontPanelComp);
    // edits to the title can disable it, so keep the checkbox in sync:
    this.addManagedListener(this.eventService, 'chartTitleEdit', function () {
      fontPanelComp.setEnabled(_this.hasTitle());
    });
  };
  TitlePanel.prototype.getOption = function (expression) {
    return this.chartOptionsService.getChartOption(expression);
  };
  TitlePanel.prototype.setOption = function (property, value) {
    this.chartOptionsService.setChartOption(property, value);
  };
  TitlePanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  TitlePanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  TitlePanel.TEMPLATE = "<div></div>";
  __decorate$3A([Autowired('chartTranslator')], TitlePanel.prototype, "chartTranslator", void 0);
  __decorate$3A([PostConstruct], TitlePanel.prototype, "init", null);
  return TitlePanel;
}(Component);
var __extends$4J = undefined && undefined.__extends || function () {
  var _extendStatics310 = function extendStatics(d, b) {
    _extendStatics310 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics310(d, b);
  };
  return function (d, b) {
    _extendStatics310(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3B = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartPanel = /** @class */function (_super) {
  __extends$4J(ChartPanel, _super);
  function ChartPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  ChartPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(ChartPanel.TEMPLATE, {
      chartGroup: groupParams
    });
    this.initGroup();
    this.initTitles();
    this.initPaddingPanel();
    this.initBackgroundPanel();
  };
  ChartPanel.prototype.initGroup = function () {
    this.chartGroup.setTitle(this.chartTranslator.translate('chart')).toggleGroupExpand(true).hideEnabledCheckbox(true);
  };
  ChartPanel.prototype.initTitles = function () {
    var titlePanelComp = this.createBean(new TitlePanel(this.chartOptionsService));
    this.chartGroup.addItem(titlePanelComp);
    this.activePanels.push(titlePanelComp);
  };
  ChartPanel.prototype.initPaddingPanel = function () {
    var paddingPanelComp = this.createBean(new PaddingPanel(this.chartOptionsService));
    this.chartGroup.addItem(paddingPanelComp);
    this.activePanels.push(paddingPanelComp);
  };
  ChartPanel.prototype.initBackgroundPanel = function () {
    var backgroundPanelComp = this.createBean(new BackgroundPanel(this.chartOptionsService));
    this.chartGroup.addItem(backgroundPanelComp);
    this.activePanels.push(backgroundPanelComp);
  };
  ChartPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  ChartPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  ChartPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"chartGroup\"></ag-group-component>\n        </div>";
  __decorate$3B([RefSelector('chartGroup')], ChartPanel.prototype, "chartGroup", void 0);
  __decorate$3B([Autowired('chartTranslator')], ChartPanel.prototype, "chartTranslator", void 0);
  __decorate$3B([PostConstruct], ChartPanel.prototype, "init", null);
  return ChartPanel;
}(Component);
var __extends$4K = undefined && undefined.__extends || function () {
  var _extendStatics311 = function extendStatics(d, b) {
    _extendStatics311 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics311(d, b);
  };
  return function (d, b) {
    _extendStatics311(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3C = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AreaSeriesPanel = /** @class */function (_super) {
  __extends$4K(AreaSeriesPanel, _super);
  function AreaSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  AreaSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(AreaSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.initSeriesGroup();
    this.initSeriesTooltips();
    this.initSeriesLineWidth();
    this.initSeriesLineDash();
    this.initOpacity();
    this.initMarkersPanel();
    this.initLabelPanel();
    this.initShadowPanel();
  };
  AreaSeriesPanel.prototype.initSeriesGroup = function () {
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
  };
  AreaSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  AreaSeriesPanel.prototype.initSeriesLineWidth = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("strokeWidth");
    this.seriesLineWidthSlider.setLabel(this.chartTranslator.translate("lineWidth")).setMaxValue(getMaxValue(currentValue, 10)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeWidth", newValue);
    });
  };
  AreaSeriesPanel.prototype.initSeriesLineDash = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("lineDash");
    this.seriesLineDashSlider.setLabel(this.chartTranslator.translate('lineDash')).setMaxValue(getMaxValue(currentValue, 30)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("lineDash", [newValue]);
    });
  };
  AreaSeriesPanel.prototype.initOpacity = function () {
    initLineOpacitySlider(this.seriesLineOpacitySlider, this.chartTranslator, this.chartOptionsService);
    initFillOpacitySlider(this.seriesFillOpacitySlider, this.chartTranslator, this.chartOptionsService);
  };
  AreaSeriesPanel.prototype.initLabelPanel = function () {
    var params = initFontPanelParams(this.chartTranslator, this.chartOptionsService);
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  AreaSeriesPanel.prototype.initMarkersPanel = function () {
    var markersPanelComp = this.createBean(new MarkersPanel(this.chartOptionsService));
    this.seriesGroup.addItem(markersPanelComp);
    this.activePanels.push(markersPanelComp);
  };
  AreaSeriesPanel.prototype.initShadowPanel = function () {
    var shadowPanelComp = this.createBean(new ShadowPanel(this.chartOptionsService));
    this.seriesGroup.addItem(shadowPanelComp);
    this.activePanels.push(shadowPanelComp);
  };
  AreaSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  AreaSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  AreaSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n                <ag-slider ref=\"seriesLineWidthSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineDashSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineOpacitySlider\"></ag-slider>\n                <ag-slider ref=\"seriesFillOpacitySlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3C([RefSelector('seriesGroup')], AreaSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3C([RefSelector('seriesTooltipsToggle')], AreaSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3C([RefSelector('seriesLineWidthSlider')], AreaSeriesPanel.prototype, "seriesLineWidthSlider", void 0);
  __decorate$3C([RefSelector('seriesLineDashSlider')], AreaSeriesPanel.prototype, "seriesLineDashSlider", void 0);
  __decorate$3C([RefSelector('seriesLineOpacitySlider')], AreaSeriesPanel.prototype, "seriesLineOpacitySlider", void 0);
  __decorate$3C([RefSelector('seriesFillOpacitySlider')], AreaSeriesPanel.prototype, "seriesFillOpacitySlider", void 0);
  __decorate$3C([Autowired('chartTranslator')], AreaSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3C([PostConstruct], AreaSeriesPanel.prototype, "init", null);
  return AreaSeriesPanel;
}(Component);
var __extends$4L = undefined && undefined.__extends || function () {
  var _extendStatics312 = function extendStatics(d, b) {
    _extendStatics312 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics312(d, b);
  };
  return function (d, b) {
    _extendStatics312(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3D = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ScatterSeriesPanel = /** @class */function (_super) {
  __extends$4L(ScatterSeriesPanel, _super);
  function ScatterSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  ScatterSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(ScatterSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.initSeriesGroup();
    this.initSeriesTooltips();
    this.initMarkersPanel();
    this.initLabelPanel();
  };
  ScatterSeriesPanel.prototype.initSeriesGroup = function () {
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
  };
  ScatterSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  ScatterSeriesPanel.prototype.initMarkersPanel = function () {
    var markersPanelComp = this.createBean(new MarkersPanel(this.chartOptionsService));
    this.seriesGroup.addItem(markersPanelComp);
    this.activePanels.push(markersPanelComp);
  };
  ScatterSeriesPanel.prototype.initLabelPanel = function () {
    var params = initFontPanelParams(this.chartTranslator, this.chartOptionsService);
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  ScatterSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  ScatterSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  ScatterSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n            </ag-group-component>\n        </div>";
  __decorate$3D([RefSelector('seriesGroup')], ScatterSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3D([RefSelector('seriesTooltipsToggle')], ScatterSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3D([Autowired('chartTranslator')], ScatterSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3D([PostConstruct], ScatterSeriesPanel.prototype, "init", null);
  return ScatterSeriesPanel;
}(Component);
var __extends$4M = undefined && undefined.__extends || function () {
  var _extendStatics313 = function extendStatics(d, b) {
    _extendStatics313 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics313(d, b);
  };
  return function (d, b) {
    _extendStatics313(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3E = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HistogramSeriesPanel = /** @class */function (_super) {
  __extends$4M(HistogramSeriesPanel, _super);
  function HistogramSeriesPanel(chartOptionsService) {
    var _this = _super.call(this) || this;
    _this.chartOptionsService = chartOptionsService;
    _this.activePanels = [];
    return _this;
  }
  HistogramSeriesPanel.prototype.init = function () {
    var groupParams = {
      cssIdentifier: 'charts-format-top-level',
      direction: 'vertical'
    };
    this.setTemplate(HistogramSeriesPanel.TEMPLATE, {
      seriesGroup: groupParams
    });
    this.seriesGroup.setTitle(this.chartTranslator.translate("series")).toggleGroupExpand(false).hideEnabledCheckbox(true);
    this.initSeriesTooltips();
    this.initBins();
    this.initSeriesStrokeWidth();
    this.initSeriesLineDash();
    this.initOpacity();
    this.initLabelPanel();
    this.initShadowPanel();
  };
  HistogramSeriesPanel.prototype.initSeriesTooltips = function () {
    var _this = this;
    this.seriesTooltipsToggle.setLabel(this.chartTranslator.translate("tooltips")).setLabelAlignment("left").setLabelWidth("flex").setInputWidth(45).setValue(this.chartOptionsService.getSeriesOption("tooltip.enabled") || false).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("tooltip.enabled", newValue);
    });
  };
  HistogramSeriesPanel.prototype.initBins = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("binCount");
    this.seriesBinCountSlider.setLabel(this.chartTranslator.translate("histogramBinCount")).setMinValue(4).setMaxValue(getMaxValue(currentValue, 100)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("binCount", newValue);
    });
  };
  HistogramSeriesPanel.prototype.initSeriesStrokeWidth = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("strokeWidth");
    this.seriesStrokeWidthSlider.setLabel(this.chartTranslator.translate("strokeWidth")).setMaxValue(getMaxValue(currentValue, 10)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("strokeWidth", newValue);
    });
  };
  HistogramSeriesPanel.prototype.initSeriesLineDash = function () {
    var _this = this;
    var currentValue = this.chartOptionsService.getSeriesOption("lineDash");
    this.seriesLineDashSlider.setLabel(this.chartTranslator.translate('lineDash')).setMaxValue(getMaxValue(currentValue, 30)).setTextFieldWidth(45).setValue("" + currentValue).onValueChange(function (newValue) {
      return _this.chartOptionsService.setSeriesOption("lineDash", [newValue]);
    });
  };
  HistogramSeriesPanel.prototype.initOpacity = function () {
    initLineOpacitySlider(this.seriesLineOpacitySlider, this.chartTranslator, this.chartOptionsService);
    initFillOpacitySlider(this.seriesFillOpacitySlider, this.chartTranslator, this.chartOptionsService);
  };
  HistogramSeriesPanel.prototype.initLabelPanel = function () {
    var params = initFontPanelParams(this.chartTranslator, this.chartOptionsService);
    var labelPanelComp = this.createBean(new FontPanel(params));
    this.activePanels.push(labelPanelComp);
    this.seriesGroup.addItem(labelPanelComp);
  };
  HistogramSeriesPanel.prototype.initShadowPanel = function () {
    var shadowPanelComp = this.createBean(new ShadowPanel(this.chartOptionsService));
    this.seriesGroup.addItem(shadowPanelComp);
    this.activePanels.push(shadowPanelComp);
  };
  HistogramSeriesPanel.prototype.destroyActivePanels = function () {
    var _this = this;
    this.activePanels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  HistogramSeriesPanel.prototype.destroy = function () {
    this.destroyActivePanels();
    _super.prototype.destroy.call(this);
  };
  HistogramSeriesPanel.TEMPLATE = "<div>\n            <ag-group-component ref=\"seriesGroup\">\n                <ag-toggle-button ref=\"seriesTooltipsToggle\"></ag-toggle-button>\n                <ag-slider ref=\"binCountSlider\"></ag-slider>\n                <ag-slider ref=\"seriesStrokeWidthSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineDashSlider\"></ag-slider>\n                <ag-slider ref=\"seriesLineOpacitySlider\"></ag-slider>\n                <ag-slider ref=\"seriesFillOpacitySlider\"></ag-slider>\n            </ag-group-component>\n        </div>";
  __decorate$3E([RefSelector('seriesGroup')], HistogramSeriesPanel.prototype, "seriesGroup", void 0);
  __decorate$3E([RefSelector('seriesTooltipsToggle')], HistogramSeriesPanel.prototype, "seriesTooltipsToggle", void 0);
  __decorate$3E([RefSelector('binCountSlider')], HistogramSeriesPanel.prototype, "seriesBinCountSlider", void 0);
  __decorate$3E([RefSelector('seriesStrokeWidthSlider')], HistogramSeriesPanel.prototype, "seriesStrokeWidthSlider", void 0);
  __decorate$3E([RefSelector('seriesLineOpacitySlider')], HistogramSeriesPanel.prototype, "seriesLineOpacitySlider", void 0);
  __decorate$3E([RefSelector('seriesLineDashSlider')], HistogramSeriesPanel.prototype, "seriesLineDashSlider", void 0);
  __decorate$3E([RefSelector('seriesFillOpacitySlider')], HistogramSeriesPanel.prototype, "seriesFillOpacitySlider", void 0);
  __decorate$3E([Autowired('chartTranslator')], HistogramSeriesPanel.prototype, "chartTranslator", void 0);
  __decorate$3E([PostConstruct], HistogramSeriesPanel.prototype, "init", null);
  return HistogramSeriesPanel;
}(Component);
var __extends$4N = undefined && undefined.__extends || function () {
  var _extendStatics314 = function extendStatics(d, b) {
    _extendStatics314 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics314(d, b);
  };
  return function (d, b) {
    _extendStatics314(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3F = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function getMaxValue(currentValue, defaultMaxValue) {
  return Math.max(currentValue, defaultMaxValue);
}
var FormatPanel = /** @class */function (_super) {
  __extends$4N(FormatPanel, _super);
  function FormatPanel(chartController, chartOptionsService) {
    var _this = _super.call(this, FormatPanel.TEMPLATE) || this;
    _this.chartController = chartController;
    _this.chartOptionsService = chartOptionsService;
    _this.panels = [];
    return _this;
  }
  FormatPanel.prototype.init = function () {
    this.createPanels();
    this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, this.createPanels.bind(this));
  };
  FormatPanel.prototype.createPanels = function () {
    var chartType = this.chartController.getChartType();
    var isGrouping = this.chartController.isGrouping();
    if (chartType === this.chartType && isGrouping === this.isGrouping) {
      // existing panels can be re-used
      return;
    }
    this.destroyPanels();
    this.addComponent(new ChartPanel(this.chartOptionsService));
    this.addComponent(new LegendPanel(this.chartOptionsService));
    switch (chartType) {
      case ChartType.GroupedColumn:
      case ChartType.StackedColumn:
      case ChartType.NormalizedColumn:
      case ChartType.GroupedBar:
      case ChartType.StackedBar:
      case ChartType.NormalizedBar:
        this.addComponent(new AxisPanel(this.chartController, this.chartOptionsService));
        this.addComponent(new BarSeriesPanel(this.chartOptionsService));
        this.addComponent(new NavigatorPanel(this.chartOptionsService));
        break;
      case ChartType.Pie:
      case ChartType.Doughnut:
        this.addComponent(new PieSeriesPanel(this.chartOptionsService));
        break;
      case ChartType.Line:
        this.addComponent(new AxisPanel(this.chartController, this.chartOptionsService));
        this.addComponent(new LineSeriesPanel(this.chartOptionsService));
        this.addComponent(new NavigatorPanel(this.chartOptionsService));
        break;
      case ChartType.Scatter:
      case ChartType.Bubble:
        this.addComponent(new AxisPanel(this.chartController, this.chartOptionsService));
        this.addComponent(new ScatterSeriesPanel(this.chartOptionsService));
        this.addComponent(new NavigatorPanel(this.chartOptionsService));
        break;
      case ChartType.Area:
      case ChartType.StackedArea:
      case ChartType.NormalizedArea:
        this.addComponent(new AxisPanel(this.chartController, this.chartOptionsService));
        this.addComponent(new AreaSeriesPanel(this.chartOptionsService));
        this.addComponent(new NavigatorPanel(this.chartOptionsService));
        break;
      case ChartType.Histogram:
        this.addComponent(new AxisPanel(this.chartController, this.chartOptionsService));
        this.addComponent(new HistogramSeriesPanel(this.chartOptionsService));
        this.addComponent(new NavigatorPanel(this.chartOptionsService));
        break;
      default:
        console.warn("AG Grid: ChartFormattingPanel - unexpected chart type index: " + chartType + " supplied");
    }
    this.chartType = chartType;
    this.isGrouping = isGrouping;
  };
  FormatPanel.prototype.addComponent = function (component) {
    this.createBean(component);
    this.panels.push(component);
    _.addCssClass(component.getGui(), 'ag-chart-format-section');
    this.getGui().appendChild(component.getGui());
  };
  FormatPanel.prototype.destroyPanels = function () {
    var _this = this;
    this.panels.forEach(function (panel) {
      _.removeFromParent(panel.getGui());
      _this.destroyBean(panel);
    });
  };
  FormatPanel.prototype.destroy = function () {
    this.destroyPanels();
    _super.prototype.destroy.call(this);
  };
  FormatPanel.TEMPLATE = "<div class=\"ag-chart-format-wrapper\"></div>";
  __decorate$3F([PostConstruct], FormatPanel.prototype, "init", null);
  return FormatPanel;
}(Component);
var __extends$4O = undefined && undefined.__extends || function () {
  var _extendStatics315 = function extendStatics(d, b) {
    _extendStatics315 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics315(d, b);
  };
  return function (d, b) {
    _extendStatics315(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3G = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MiniChart = /** @class */function (_super) {
  __extends$4O(MiniChart, _super);
  function MiniChart(container, tooltipName) {
    var _this = _super.call(this) || this;
    _this.size = 58;
    _this.padding = 5;
    _this.root = new Group();
    var scene = new Scene(window.document, _this.size, _this.size);
    _.addCssClass(scene.canvas.element, 'ag-chart-mini-thumbnail-canvas');
    scene.root = _this.root;
    scene.container = container;
    _this.scene = scene;
    _this.tooltipName = tooltipName;
    return _this;
  }
  MiniChart.prototype.init = function () {
    this.scene.canvas.element.title = this.chartTranslator.translate(this.tooltipName);
  };
  __decorate$3G([Autowired('chartTranslator')], MiniChart.prototype, "chartTranslator", void 0);
  __decorate$3G([PostConstruct], MiniChart.prototype, "init", null);
  return MiniChart;
}(Component);
var __extends$4P = undefined && undefined.__extends || function () {
  var _extendStatics316 = function extendStatics(d, b) {
    _extendStatics316 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics316(d, b);
  };
  return function (d, b) {
    _extendStatics316(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3H = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MiniChartWithAxes = /** @class */function (_super) {
  __extends$4P(MiniChartWithAxes, _super);
  function MiniChartWithAxes(container, tooltipName) {
    var _this = _super.call(this, container, tooltipName) || this;
    _this.stroke = 'gray';
    _this.axisOvershoot = 3;
    return _this;
  }
  MiniChartWithAxes.prototype.addAxes = function () {
    var size = this.size;
    var padding = this.padding;
    var leftAxis = new Line();
    leftAxis.x1 = padding;
    leftAxis.y1 = padding;
    leftAxis.x2 = padding;
    leftAxis.y2 = size - padding + this.axisOvershoot;
    leftAxis.stroke = this.stroke;
    var bottomAxis = new Line();
    bottomAxis.x1 = padding - this.axisOvershoot + 1;
    bottomAxis.y1 = size - padding;
    bottomAxis.x2 = size - padding + 1;
    bottomAxis.y2 = size - padding;
    bottomAxis.stroke = this.stroke;
    var root = this.root;
    root.append(leftAxis);
    root.append(bottomAxis);
  };
  __decorate$3H([PostConstruct], MiniChartWithAxes.prototype, "addAxes", null);
  return MiniChartWithAxes;
}(MiniChart);
var __extends$4Q = undefined && undefined.__extends || function () {
  var _extendStatics317 = function extendStatics(d, b) {
    _extendStatics317 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics317(d, b);
  };
  return function (d, b) {
    _extendStatics317(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniColumn = /** @class */function (_super) {
  __extends$4Q(MiniColumn, _super);
  function MiniColumn(container, fills, strokes) {
    var _this = _super.call(this, container, "groupedColumnTooltip") || this;
    var padding = _this.padding;
    var size = _this.size;
    var data = [2, 3, 4];
    var xScale = new BandScale();
    xScale.domain = [0, 1, 2];
    xScale.range = [padding, size - padding];
    xScale.paddingInner = 0.3;
    xScale.paddingOuter = 0.3;
    var yScale = new LinearScale();
    yScale.domain = [0, 4];
    yScale.range = [size - padding, padding];
    var bottom = yScale.convert(0);
    var width = xScale.bandwidth;
    _this.bars = data.map(function (datum, i) {
      var top = yScale.convert(datum);
      var rect = new Rect();
      rect.x = xScale.convert(i);
      rect.y = top;
      rect.width = width;
      rect.height = bottom - top;
      rect.strokeWidth = 1;
      rect.crisp = true;
      return rect;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.bars);
    return _this;
  }
  MiniColumn.prototype.updateColors = function (fills, strokes) {
    this.bars.forEach(function (bar, i) {
      bar.fill = fills[i];
      bar.stroke = strokes[i];
    });
  };
  MiniColumn.chartType = ChartType.GroupedColumn;
  return MiniColumn;
}(MiniChartWithAxes);
var __extends$4R = undefined && undefined.__extends || function () {
  var _extendStatics318 = function extendStatics(d, b) {
    _extendStatics318 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics318(d, b);
  };
  return function (d, b) {
    _extendStatics318(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniStackedColumn = /** @class */function (_super) {
  __extends$4R(MiniStackedColumn, _super);
  function MiniStackedColumn(container, fills, strokes, data, yScaleDomain, tooltipName) {
    if (data === void 0) {
      data = MiniStackedColumn.data;
    }
    if (yScaleDomain === void 0) {
      yScaleDomain = [0, 16];
    }
    if (tooltipName === void 0) {
      tooltipName = "stackedColumnTooltip";
    }
    var _this = _super.call(this, container, tooltipName) || this;
    var padding = _this.padding;
    var size = _this.size;
    var xScale = new BandScale();
    xScale.domain = [0, 1, 2];
    xScale.range = [padding, size - padding];
    xScale.paddingInner = 0.3;
    xScale.paddingOuter = 0.3;
    var yScale = new LinearScale();
    yScale.domain = yScaleDomain;
    yScale.range = [size - padding, padding];
    var bottom = yScale.convert(0);
    var width = xScale.bandwidth;
    _this.bars = data.map(function (series) {
      return series.map(function (datum, i) {
        var top = yScale.convert(datum);
        var rect = new Rect();
        rect.x = xScale.convert(i);
        rect.y = top;
        rect.width = width;
        rect.height = bottom - top;
        rect.strokeWidth = 1;
        rect.crisp = true;
        return rect;
      });
    });
    _this.updateColors(fills, strokes);
    _this.root.append([].concat.apply([], _this.bars));
    return _this;
  }
  MiniStackedColumn.prototype.updateColors = function (fills, strokes) {
    this.bars.forEach(function (series, i) {
      return series.forEach(function (bar) {
        bar.fill = fills[i];
        bar.stroke = strokes[i];
      });
    });
  };
  MiniStackedColumn.chartType = ChartType.StackedColumn;
  MiniStackedColumn.data = [[8, 12, 16], [6, 9, 12], [2, 3, 4]];
  return MiniStackedColumn;
}(MiniChartWithAxes);
var __extends$4S = undefined && undefined.__extends || function () {
  var _extendStatics319 = function extendStatics(d, b) {
    _extendStatics319 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics319(d, b);
  };
  return function (d, b) {
    _extendStatics319(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniNormalizedColumn = /** @class */function (_super) {
  __extends$4S(MiniNormalizedColumn, _super);
  function MiniNormalizedColumn(container, fills, strokes) {
    return _super.call(this, container, fills, strokes, MiniNormalizedColumn.data, [0, 10], "normalizedColumnTooltip") || this;
  }
  MiniNormalizedColumn.chartType = ChartType.NormalizedColumn;
  MiniNormalizedColumn.data = [[10, 10, 10], [6, 7, 8], [2, 4, 6]];
  return MiniNormalizedColumn;
}(MiniStackedColumn);
var __extends$4T = undefined && undefined.__extends || function () {
  var _extendStatics320 = function extendStatics(d, b) {
    _extendStatics320 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics320(d, b);
  };
  return function (d, b) {
    _extendStatics320(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniBar = /** @class */function (_super) {
  __extends$4T(MiniBar, _super);
  function MiniBar(container, fills, strokes) {
    var _this = _super.call(this, container, "groupedBarTooltip") || this;
    var padding = _this.padding;
    var size = _this.size;
    var data = [2, 3, 4];
    var yScale = new BandScale();
    yScale.domain = [0, 1, 2];
    yScale.range = [padding, size - padding];
    yScale.paddingInner = 0.3;
    yScale.paddingOuter = 0.3;
    var xScale = new LinearScale();
    xScale.domain = [0, 4];
    xScale.range = [size - padding, padding];
    var bottom = xScale.convert(0);
    var height = yScale.bandwidth;
    _this.bars = data.map(function (datum, i) {
      var rect = new Rect();
      rect.x = padding;
      rect.y = yScale.convert(i);
      rect.width = bottom - xScale.convert(datum);
      rect.height = height;
      rect.strokeWidth = 1;
      rect.crisp = true;
      return rect;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.bars);
    return _this;
  }
  MiniBar.prototype.updateColors = function (fills, strokes) {
    this.bars.forEach(function (bar, i) {
      bar.fill = fills[i];
      bar.stroke = strokes[i];
    });
  };
  MiniBar.chartType = ChartType.GroupedBar;
  return MiniBar;
}(MiniChartWithAxes);
var __extends$4U = undefined && undefined.__extends || function () {
  var _extendStatics321 = function extendStatics(d, b) {
    _extendStatics321 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics321(d, b);
  };
  return function (d, b) {
    _extendStatics321(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniStackedBar = /** @class */function (_super) {
  __extends$4U(MiniStackedBar, _super);
  function MiniStackedBar(container, fills, strokes, data, xScaleDomain, tooltipName) {
    if (data === void 0) {
      data = MiniStackedBar.data;
    }
    if (xScaleDomain === void 0) {
      xScaleDomain = [0, 16];
    }
    if (tooltipName === void 0) {
      tooltipName = "stackedBarTooltip";
    }
    var _this = _super.call(this, container, tooltipName) || this;
    var size = _this.size;
    var padding = _this.padding;
    var yScale = new BandScale();
    yScale.domain = [0, 1, 2];
    yScale.range = [padding, size - padding];
    yScale.paddingInner = 0.3;
    yScale.paddingOuter = 0.3;
    var xScale = new LinearScale();
    xScale.domain = xScaleDomain;
    xScale.range = [size - padding, padding];
    var bottom = xScale.convert(0);
    var height = yScale.bandwidth;
    _this.bars = data.map(function (series) {
      return series.map(function (datum, i) {
        var rect = new Rect();
        rect.x = padding;
        rect.y = yScale.convert(i);
        rect.width = bottom - xScale.convert(datum);
        rect.height = height;
        rect.strokeWidth = 1;
        rect.crisp = true;
        return rect;
      });
    });
    _this.updateColors(fills, strokes);
    _this.root.append([].concat.apply([], _this.bars));
    return _this;
  }
  MiniStackedBar.prototype.updateColors = function (fills, strokes) {
    this.bars.forEach(function (series, i) {
      return series.forEach(function (bar) {
        bar.fill = fills[i];
        bar.stroke = strokes[i];
      });
    });
  };
  MiniStackedBar.chartType = ChartType.StackedBar;
  MiniStackedBar.data = [[8, 12, 16], [6, 9, 12], [2, 3, 4]];
  return MiniStackedBar;
}(MiniChartWithAxes);
var __extends$4V = undefined && undefined.__extends || function () {
  var _extendStatics322 = function extendStatics(d, b) {
    _extendStatics322 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics322(d, b);
  };
  return function (d, b) {
    _extendStatics322(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniNormalizedBar = /** @class */function (_super) {
  __extends$4V(MiniNormalizedBar, _super);
  function MiniNormalizedBar(container, fills, strokes) {
    return _super.call(this, container, fills, strokes, MiniNormalizedBar.data, [0, 10], "normalizedBarTooltip") || this;
  }
  MiniNormalizedBar.chartType = ChartType.NormalizedBar;
  MiniNormalizedBar.data = [[10, 10, 10], [6, 7, 8], [2, 4, 6]];
  return MiniNormalizedBar;
}(MiniStackedBar);
var __extends$4W = undefined && undefined.__extends || function () {
  var _extendStatics323 = function extendStatics(d, b) {
    _extendStatics323 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics323(d, b);
  };
  return function (d, b) {
    _extendStatics323(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniDoughnut = /** @class */function (_super) {
  __extends$4W(MiniDoughnut, _super);
  function MiniDoughnut(container, fills, strokes, centerRadiusScaler, tooltipName) {
    if (centerRadiusScaler === void 0) {
      centerRadiusScaler = 0.6;
    }
    if (tooltipName === void 0) {
      tooltipName = "doughnutTooltip";
    }
    var _this = _super.call(this, container, tooltipName) || this;
    var radius = (_this.size - _this.padding * 2) / 2;
    var center = radius + _this.padding;
    var angles = [[toRadians(-90), toRadians(30)], [toRadians(30), toRadians(120)], [toRadians(120), toRadians(180)], [toRadians(180), toRadians(210)], [toRadians(210), toRadians(240)], [toRadians(240), toRadians(270)]];
    _this.sectors = angles.map(function (_a) {
      var startAngle = _a[0],
        endAngle = _a[1];
      var sector = new Sector();
      sector.centerX = center;
      sector.centerY = center;
      sector.innerRadius = radius * centerRadiusScaler;
      sector.outerRadius = radius;
      sector.startAngle = startAngle;
      sector.endAngle = endAngle;
      sector.stroke = undefined;
      sector.strokeWidth = 1;
      return sector;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.sectors);
    return _this;
  }
  MiniDoughnut.prototype.updateColors = function (fills, strokes) {
    this.sectors.forEach(function (sector, i) {
      sector.fill = fills[i % fills.length];
      sector.stroke = strokes[i % strokes.length];
    });
  };
  MiniDoughnut.chartType = ChartType.Doughnut;
  return MiniDoughnut;
}(MiniChart);
var __extends$4X = undefined && undefined.__extends || function () {
  var _extendStatics324 = function extendStatics(d, b) {
    _extendStatics324 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics324(d, b);
  };
  return function (d, b) {
    _extendStatics324(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniPie = /** @class */function (_super) {
  __extends$4X(MiniPie, _super);
  function MiniPie(container, fills, strokes) {
    return _super.call(this, container, fills, strokes, 0, "pieTooltip") || this;
  }
  MiniPie.chartType = ChartType.Pie;
  return MiniPie;
}(MiniDoughnut);
var __extends$4Y = undefined && undefined.__extends || function () {
  var _extendStatics325 = function extendStatics(d, b) {
    _extendStatics325 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics325(d, b);
  };
  return function (d, b) {
    _extendStatics325(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniLine = /** @class */function (_super) {
  __extends$4Y(MiniLine, _super);
  function MiniLine(container, fills, strokes) {
    var _this = _super.call(this, container, "lineTooltip") || this;
    var size = _this.size;
    var padding = _this.padding;
    var xScale = new LinearScale();
    xScale.domain = [0, 4];
    xScale.range = [padding, size - padding];
    var yScale = new LinearScale();
    yScale.domain = [0, 10];
    yScale.range = [size - padding, padding];
    var data = [[9, 7, 8, 5, 6], [5, 6, 3, 4, 1], [1, 3, 4, 8, 7]];
    _this.lines = data.map(function (series) {
      var line = new Path();
      line.strokeWidth = 3;
      line.lineCap = "round";
      line.fill = undefined;
      series.forEach(function (datum, i) {
        line.path[i > 0 ? "lineTo" : "moveTo"](xScale.convert(i), yScale.convert(datum));
      });
      return line;
    });
    _this.updateColors(fills, strokes);
    var clipRect = new ClipRect();
    clipRect.x = clipRect.y = padding;
    clipRect.width = clipRect.height = size - padding * 2;
    clipRect.append(_this.lines);
    _this.root.append(clipRect);
    return _this;
  }
  MiniLine.prototype.updateColors = function (fills, strokes) {
    this.lines.forEach(function (line, i) {
      line.stroke = fills[i];
    });
  };
  MiniLine.chartType = ChartType.Line;
  return MiniLine;
}(MiniChartWithAxes);
var __extends$4Z = undefined && undefined.__extends || function () {
  var _extendStatics326 = function extendStatics(d, b) {
    _extendStatics326 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics326(d, b);
  };
  return function (d, b) {
    _extendStatics326(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniScatter = /** @class */function (_super) {
  __extends$4Z(MiniScatter, _super);
  function MiniScatter(container, fills, strokes) {
    var _this = _super.call(this, container, "scatterTooltip") || this;
    var size = _this.size;
    var padding = _this.padding;
    // [x, y] pairs
    var data = [[[0.3, 3], [1.1, 0.9], [2, 0.4], [3.4, 2.4]], [[0, 0.3], [1, 2], [2.4, 1.4], [3, 0]]];
    var xScale = new LinearScale();
    xScale.domain = [-0.5, 4];
    xScale.range = [padding * 2, size - padding];
    var yScale = new LinearScale();
    yScale.domain = [-0.5, 3.5];
    yScale.range = [size - padding, padding];
    var points = [];
    data.forEach(function (series) {
      series.forEach(function (_a) {
        var x = _a[0],
          y = _a[1];
        var arc = new Arc();
        arc.strokeWidth = 1;
        arc.centerX = xScale.convert(x);
        arc.centerY = yScale.convert(y);
        arc.radiusX = arc.radiusY = 2.5;
        points.push(arc);
      });
    });
    _this.points = points;
    _this.updateColors(fills, strokes);
    var clipRect = new ClipRect();
    clipRect.x = clipRect.y = padding;
    clipRect.width = clipRect.height = size - padding * 2;
    clipRect.append(_this.points);
    _this.root.append(clipRect);
    return _this;
  }
  MiniScatter.prototype.updateColors = function (fills, strokes) {
    this.points.forEach(function (line, i) {
      line.stroke = strokes[i % strokes.length];
      line.fill = fills[i % fills.length];
    });
  };
  MiniScatter.chartType = ChartType.Scatter;
  return MiniScatter;
}(MiniChartWithAxes);
var __extends$4_ = undefined && undefined.__extends || function () {
  var _extendStatics327 = function extendStatics(d, b) {
    _extendStatics327 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics327(d, b);
  };
  return function (d, b) {
    _extendStatics327(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniBubble = /** @class */function (_super) {
  __extends$4_(MiniBubble, _super);
  function MiniBubble(container, fills, strokes) {
    var _this = _super.call(this, container, "bubbleTooltip") || this;
    var size = _this.size;
    var padding = _this.padding;
    // [x, y, radius] triples
    var data = [[[0.1, 0.3, 5], [0.5, 0.4, 7], [0.2, 0.8, 7]], [[0.8, 0.7, 5], [0.7, 0.3, 9]]];
    var xScale = new LinearScale();
    xScale.domain = [0, 1];
    xScale.range = [padding * 2, size - padding];
    var yScale = new LinearScale();
    yScale.domain = [0, 1];
    yScale.range = [size - padding, padding];
    var points = [];
    data.forEach(function (series) {
      series.forEach(function (_a) {
        var x = _a[0],
          y = _a[1],
          radius = _a[2];
        var arc = new Arc();
        arc.strokeWidth = 1;
        arc.centerX = xScale.convert(x);
        arc.centerY = yScale.convert(y);
        arc.radiusX = arc.radiusY = radius;
        arc.fillOpacity = 0.7;
        points.push(arc);
      });
    });
    _this.points = points;
    _this.updateColors(fills, strokes);
    var clipRect = new ClipRect();
    clipRect.x = padding;
    clipRect.y = padding;
    clipRect.width = size - padding * 2;
    clipRect.height = size - padding * 2;
    clipRect.append(_this.points);
    _this.root.append(clipRect);
    return _this;
  }
  MiniBubble.prototype.updateColors = function (fills, strokes) {
    this.points.forEach(function (line, i) {
      line.stroke = strokes[i % strokes.length];
      line.fill = fills[i % fills.length];
    });
  };
  MiniBubble.chartType = ChartType.Bubble;
  return MiniBubble;
}(MiniChartWithAxes);
var __extends$4$ = undefined && undefined.__extends || function () {
  var _extendStatics328 = function extendStatics(d, b) {
    _extendStatics328 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics328(d, b);
  };
  return function (d, b) {
    _extendStatics328(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniArea = /** @class */function (_super) {
  __extends$4$(MiniArea, _super);
  function MiniArea(container, fills, strokes, data) {
    if (data === void 0) {
      data = MiniArea.data;
    }
    var _this = _super.call(this, container, "groupedAreaTooltip") || this;
    var size = _this.size;
    var padding = _this.padding;
    var xScale = new BandScale();
    xScale.domain = [0, 1, 2];
    xScale.paddingInner = 1;
    xScale.paddingOuter = 0;
    xScale.range = [padding + 0.5, size - padding - 0.5];
    var yScale = new LinearScale();
    yScale.domain = [0, 6];
    yScale.range = [size - padding + 0.5, padding];
    var xCount = data.length;
    var last = xCount * 2 - 1;
    var pathData = [];
    var bottomY = yScale.convert(0);
    data.forEach(function (datum, i) {
      var x = xScale.convert(i);
      datum.forEach(function (yDatum, j) {
        var y = yScale.convert(yDatum);
        var points = pathData[j] || (pathData[j] = []);
        points[i] = {
          x: x,
          y: y
        };
        points[last - i] = {
          x: x,
          y: bottomY
        };
      });
    });
    _this.areas = pathData.reverse().map(function (points) {
      var area = new Path();
      area.strokeWidth = 1;
      area.fillOpacity = 0.7;
      var path = area.path;
      path.clear();
      points.forEach(function (point, i) {
        return path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y);
      });
      path.closePath();
      return area;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.areas);
    return _this;
  }
  MiniArea.prototype.updateColors = function (fills, strokes) {
    this.areas.forEach(function (area, i) {
      area.fill = fills[i];
      area.stroke = strokes[i];
    });
  };
  MiniArea.chartType = ChartType.Area;
  MiniArea.data = [[1, 3, 5], [2, 6, 4], [5, 3, 1]];
  return MiniArea;
}(MiniChartWithAxes);
var __extends$50 = undefined && undefined.__extends || function () {
  var _extendStatics329 = function extendStatics(d, b) {
    _extendStatics329 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics329(d, b);
  };
  return function (d, b) {
    _extendStatics329(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniStackedArea = /** @class */function (_super) {
  __extends$50(MiniStackedArea, _super);
  function MiniStackedArea(container, fills, strokes, data, tooltipName) {
    if (data === void 0) {
      data = MiniStackedArea.data;
    }
    if (tooltipName === void 0) {
      tooltipName = "stackedAreaTooltip";
    }
    var _this = _super.call(this, container, tooltipName) || this;
    var size = _this.size;
    var padding = _this.padding;
    var xScale = new BandScale();
    xScale.domain = [0, 1, 2];
    xScale.paddingInner = 1;
    xScale.paddingOuter = 0;
    xScale.range = [padding + 0.5, size - padding - 0.5];
    var yScale = new LinearScale();
    yScale.domain = [0, 16];
    yScale.range = [size - padding + 0.5, padding + 0.5];
    var xCount = data.length;
    var last = xCount * 2 - 1;
    var pathData = [];
    data.forEach(function (datum, i) {
      var x = xScale.convert(i);
      var total = 0;
      datum.forEach(function (yDatum, j) {
        var y = yScale.convert(total + yDatum);
        var points = pathData[j] || (pathData[j] = []);
        points[i] = {
          x: x,
          y: y
        };
        points[last - i] = {
          x: x,
          y: yScale.convert(total) // bottom y
        };

        total += yDatum;
      });
    });
    _this.areas = pathData.map(function (points) {
      var area = new Path();
      area.strokeWidth = 1;
      var path = area.path;
      path.clear();
      points.forEach(function (point, i) {
        return path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y);
      });
      path.closePath();
      return area;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.areas);
    return _this;
  }
  MiniStackedArea.prototype.updateColors = function (fills, strokes) {
    this.areas.forEach(function (area, i) {
      area.fill = fills[i];
      area.stroke = strokes[i];
    });
  };
  MiniStackedArea.chartType = ChartType.StackedArea;
  MiniStackedArea.data = [[2, 3, 2], [3, 6, 5], [6, 2, 2]];
  return MiniStackedArea;
}(MiniChartWithAxes);
var __extends$51 = undefined && undefined.__extends || function () {
  var _extendStatics330 = function extendStatics(d, b) {
    _extendStatics330 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics330(d, b);
  };
  return function (d, b) {
    _extendStatics330(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniNormalizedArea = /** @class */function (_super) {
  __extends$51(MiniNormalizedArea, _super);
  function MiniNormalizedArea(container, fills, strokes, data) {
    if (data === void 0) {
      data = MiniNormalizedArea.data;
    }
    return _super.call(this, container, fills, strokes, data, "normalizedAreaTooltip") || this;
  }
  MiniNormalizedArea.chartType = ChartType.NormalizedArea;
  MiniNormalizedArea.data = MiniStackedArea.data.map(function (stack) {
    var sum = stack.reduce(function (p, c) {
      return p + c;
    }, 0);
    return stack.map(function (v) {
      return v / sum * 16;
    });
  });
  return MiniNormalizedArea;
}(MiniStackedArea);
var __extends$52 = undefined && undefined.__extends || function () {
  var _extendStatics331 = function extendStatics(d, b) {
    _extendStatics331 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics331(d, b);
  };
  return function (d, b) {
    _extendStatics331(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var MiniHistogram = /** @class */function (_super) {
  __extends$52(MiniHistogram, _super);
  function MiniHistogram(container, fills, strokes) {
    var _this = _super.call(this, container, "histogramTooltip") || this;
    var padding = _this.padding;
    var size = _this.size;
    // approx normal curve
    var data = [2, 5, 11, 13, 10, 6, 1];
    var xScale = new LinearScale();
    xScale.domain = [0, data.length];
    xScale.range = [padding, size - padding];
    var yScale = new LinearScale();
    yScale.domain = [0, data.reduce(function (a, b) {
      return Math.max(a, b);
    }, 0)];
    yScale.range = [size - padding, padding];
    var bottom = yScale.convert(0);
    _this.bars = data.map(function (datum, i) {
      var top = yScale.convert(datum);
      var left = xScale.convert(i);
      var right = xScale.convert(i + 1);
      var rect = new Rect();
      rect.x = left;
      rect.y = top;
      rect.width = right - left;
      rect.height = bottom - top;
      rect.strokeWidth = 1;
      rect.crisp = true;
      return rect;
    });
    _this.updateColors(fills, strokes);
    _this.root.append(_this.bars);
    return _this;
  }
  MiniHistogram.prototype.updateColors = function (_a, _b) {
    var fill = _a[0];
    var stroke = _b[0];
    this.bars.forEach(function (bar) {
      bar.fill = fill;
      bar.stroke = stroke;
    });
  };
  MiniHistogram.chartType = ChartType.Histogram;
  return MiniHistogram;
}(MiniChartWithAxes);
var __extends$53 = undefined && undefined.__extends || function () {
  var _extendStatics332 = function extendStatics(d, b) {
    _extendStatics332 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics332(d, b);
  };
  return function (d, b) {
    _extendStatics332(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3I = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MiniChartsContainer = /** @class */function (_super) {
  __extends$53(MiniChartsContainer, _super);
  function MiniChartsContainer(chartController, fills, strokes) {
    var _this = _super.call(this, MiniChartsContainer.TEMPLATE) || this;
    _this.wrappers = {};
    _this.chartController = chartController;
    _this.fills = fills;
    _this.strokes = strokes;
    return _this;
  }
  MiniChartsContainer.prototype.init = function () {
    var _this = this;
    var chartGroups = {
      columnGroup: [MiniColumn, MiniStackedColumn, MiniNormalizedColumn],
      barGroup: [MiniBar, MiniStackedBar, MiniNormalizedBar],
      pieGroup: [MiniPie, MiniDoughnut],
      lineGroup: [MiniLine],
      scatterGroup: [MiniScatter, MiniBubble],
      areaGroup: [MiniArea, MiniStackedArea, MiniNormalizedArea],
      histogramGroup: [MiniHistogram]
    };
    var eGui = this.getGui();
    Object.keys(chartGroups).forEach(function (group) {
      var chartGroup = chartGroups[group];
      var groupComponent = _this.createBean(new AgGroupComponent({
        title: _this.chartTranslator.translate(group),
        suppressEnabledCheckbox: true,
        enabled: true,
        suppressOpenCloseIcons: true,
        cssIdentifier: 'charts-settings',
        direction: 'horizontal'
      }));
      chartGroup.forEach(function (MiniClass) {
        var miniWrapper = document.createElement('div');
        _.addCssClass(miniWrapper, 'ag-chart-mini-thumbnail');
        _this.addManagedListener(miniWrapper, 'click', function () {
          _this.chartController.setChartType(MiniClass.chartType);
          _this.refreshSelected();
        });
        _this.wrappers[MiniClass.chartType] = miniWrapper;
        _this.createBean(new MiniClass(miniWrapper, _this.fills, _this.strokes));
        groupComponent.addItem(miniWrapper);
      });
      eGui.appendChild(groupComponent.getGui());
    });
    this.refreshSelected();
  };
  MiniChartsContainer.prototype.refreshSelected = function () {
    var type = this.chartController.getChartType();
    for (var wrapper in this.wrappers) {
      _.addOrRemoveCssClass(this.wrappers[wrapper], 'ag-selected', wrapper === type);
    }
  };
  MiniChartsContainer.TEMPLATE = "<div class=\"ag-chart-settings-mini-wrapper\"></div>";
  __decorate$3I([Autowired('chartTranslator')], MiniChartsContainer.prototype, "chartTranslator", void 0);
  __decorate$3I([PostConstruct], MiniChartsContainer.prototype, "init", null);
  return MiniChartsContainer;
}(Component);
var __extends$54 = undefined && undefined.__extends || function () {
  var _extendStatics333 = function extendStatics(d, b) {
    _extendStatics333 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics333(d, b);
  };
  return function (d, b) {
    _extendStatics333(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3J = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartSettingsPanel = /** @class */function (_super) {
  __extends$54(ChartSettingsPanel, _super);
  function ChartSettingsPanel(chartController) {
    var _this = _super.call(this, ChartSettingsPanel.TEMPLATE) || this;
    _this.miniCharts = [];
    _this.cardItems = [];
    _this.activePaletteIndex = 0;
    _this.palettes = [];
    _this.themes = [];
    _this.chartController = chartController;
    return _this;
  }
  ChartSettingsPanel.prototype.postConstruct = function () {
    var _this = this;
    this.resetPalettes();
    this.ePrevBtn.insertAdjacentElement('afterbegin', _.createIconNoSpan('previous', this.gridOptionsWrapper));
    this.eNextBtn.insertAdjacentElement('afterbegin', _.createIconNoSpan('next', this.gridOptionsWrapper));
    this.addManagedListener(this.ePrevBtn, 'click', function () {
      return _this.setActivePalette(_this.getPrev(), 'left');
    });
    this.addManagedListener(this.eNextBtn, 'click', function () {
      return _this.setActivePalette(_this.getNext(), 'right');
    });
    this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, this.resetPalettes.bind(this));
  };
  ChartSettingsPanel.prototype.resetPalettes = function () {
    var _this = this;
    var palettes = this.chartController.getPalettes();
    if (_.shallowCompare(palettes, this.palettes)) {
      return;
    }
    this.palettes = palettes;
    this.themes = this.chartController.getThemes();
    this.activePaletteIndex = _.findIndex(this.themes, function (name) {
      return name === _this.chartController.getThemeName();
    });
    this.cardItems = [];
    _.clearElement(this.eCardSelector);
    this.destroyMiniCharts();
    this.palettes.forEach(function (palette, index) {
      var isActivePalette = _this.activePaletteIndex === index;
      var fills = palette.fills,
        strokes = palette.strokes;
      var miniChartsContainer = _this.createBean(new MiniChartsContainer(_this.chartController, fills, strokes));
      _this.miniCharts.push(miniChartsContainer);
      _this.eMiniChartsContainer.appendChild(miniChartsContainer.getGui());
      _this.addCardLink(index);
      if (isActivePalette) {
        miniChartsContainer.refreshSelected();
      } else {
        _.addCssClass(miniChartsContainer.getGui(), 'ag-hidden');
      }
    });
    _.addOrRemoveCssClass(this.eNavBar, 'ag-hidden', this.palettes.length <= 1);
    _.radioCssClass(this.cardItems[this.activePaletteIndex], 'ag-selected', 'ag-not-selected');
  };
  ChartSettingsPanel.prototype.addCardLink = function (index) {
    var _this = this;
    var link = document.createElement('div');
    _.addCssClass(link, 'ag-chart-settings-card-item');
    this.addManagedListener(link, 'click', function () {
      var activePaletteIndex = _this.activePaletteIndex;
      _this.setActivePalette(index, index < activePaletteIndex ? 'left' : 'right');
    });
    this.eCardSelector.appendChild(link);
    this.cardItems.push(link);
  };
  ChartSettingsPanel.prototype.getPrev = function () {
    var prev = this.activePaletteIndex - 1;
    if (prev < 0) {
      prev = this.palettes.length - 1;
    }
    return prev;
  };
  ChartSettingsPanel.prototype.getNext = function () {
    var next = this.activePaletteIndex + 1;
    if (next >= this.palettes.length) {
      next = 0;
    }
    return next;
  };
  ChartSettingsPanel.prototype.setActivePalette = function (index, animationDirection) {
    var _this = this;
    if (this.isAnimating || this.activePaletteIndex === index) {
      return;
    }
    _.radioCssClass(this.cardItems[index], 'ag-selected', 'ag-not-selected');
    var currentPalette = this.miniCharts[this.activePaletteIndex];
    var currentGui = currentPalette.getGui();
    var futurePalette = this.miniCharts[index];
    var nextGui = futurePalette.getGui();
    currentPalette.refreshSelected();
    futurePalette.refreshSelected();
    var multiplier = animationDirection === 'left' ? -1 : 1;
    var final = nextGui.style.left = _.getAbsoluteWidth(this.getGui()) * multiplier + "px";
    var animatingClass = 'ag-animating';
    _.removeCssClass(nextGui, 'ag-hidden');
    _.addCssClass(currentGui, animatingClass);
    _.addCssClass(nextGui, animatingClass);
    this.activePaletteIndex = index;
    this.chartController.setChartThemeName(this.themes[index]);
    this.isAnimating = true;
    window.setTimeout(function () {
      currentGui.style.left = -parseFloat(final) + "px";
      nextGui.style.left = '0px';
    }, 0);
    window.setTimeout(function () {
      _this.isAnimating = false;
      _.removeCssClass(currentGui, animatingClass);
      _.removeCssClass(nextGui, animatingClass);
      _.addCssClass(currentGui, 'ag-hidden');
    }, 300);
  };
  ChartSettingsPanel.prototype.destroyMiniCharts = function () {
    _.clearElement(this.eMiniChartsContainer);
    this.miniCharts = this.destroyBeans(this.miniCharts);
  };
  ChartSettingsPanel.prototype.destroy = function () {
    this.destroyMiniCharts();
    _super.prototype.destroy.call(this);
  };
  ChartSettingsPanel.TEMPLATE = "<div class=\"ag-chart-settings-wrapper\">\n            <div ref=\"eMiniChartsContainer\" class=\"ag-chart-settings-mini-charts-container\"></div>\n            <div ref=\"eNavBar\" class=\"ag-chart-settings-nav-bar\">\n                <div ref=\"ePrevBtn\" class=\"ag-chart-settings-prev\">\n                    <button type=\"button\" class=\"ag-chart-settings-prev-button\"></button>\n                </div>\n                <div ref=\"eCardSelector\" class=\"ag-chart-settings-card-selector\"></div>\n                <div ref=\"eNextBtn\" class=\"ag-chart-settings-next\">\n                    <button type=\"button\" class=\"ag-chart-settings-next-button\"></button>\n                </div>\n            </div>\n        </div>";
  __decorate$3J([RefSelector('eMiniChartsContainer')], ChartSettingsPanel.prototype, "eMiniChartsContainer", void 0);
  __decorate$3J([RefSelector('eNavBar')], ChartSettingsPanel.prototype, "eNavBar", void 0);
  __decorate$3J([RefSelector('eCardSelector')], ChartSettingsPanel.prototype, "eCardSelector", void 0);
  __decorate$3J([RefSelector('ePrevBtn')], ChartSettingsPanel.prototype, "ePrevBtn", void 0);
  __decorate$3J([RefSelector('eNextBtn')], ChartSettingsPanel.prototype, "eNextBtn", void 0);
  __decorate$3J([PostConstruct], ChartSettingsPanel.prototype, "postConstruct", null);
  return ChartSettingsPanel;
}(Component);
var __extends$55 = undefined && undefined.__extends || function () {
  var _extendStatics334 = function extendStatics(d, b) {
    _extendStatics334 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics334(d, b);
  };
  return function (d, b) {
    _extendStatics334(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3K = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TabbedChartMenu = /** @class */function (_super) {
  __extends$55(TabbedChartMenu, _super);
  function TabbedChartMenu(params) {
    var _this = _super.call(this) || this;
    _this.tabs = [];
    var controller = params.controller,
      type = params.type,
      panels = params.panels,
      chartOptionsService = params.chartOptionsService;
    _this.chartController = controller;
    _this.chartOptionsService = chartOptionsService;
    _this.currentChartType = type;
    _this.panels = panels;
    return _this;
  }
  TabbedChartMenu.prototype.init = function () {
    var _this = this;
    this.panels.forEach(function (panel) {
      var panelType = panel.replace('chart', '').toLowerCase();
      var _a = _this.createTab(panel, panelType, _this.getPanelClass(panelType)),
        comp = _a.comp,
        tab = _a.tab;
      _this.tabs.push(tab);
      _this.addDestroyFunc(function () {
        return _this.destroyBean(comp);
      });
    });
    this.tabbedLayout = new TabbedLayout({
      items: this.tabs,
      cssClass: 'ag-chart-tabbed-menu'
    });
    this.getContext().createBean(this.tabbedLayout);
  };
  TabbedChartMenu.prototype.createTab = function (name, title, ChildClass) {
    var eWrapperDiv = document.createElement('div');
    _.addCssClass(eWrapperDiv, 'ag-chart-tab');
    _.addCssClass(eWrapperDiv, "ag-chart-" + title);
    var comp = new ChildClass(this.chartController, this.chartOptionsService);
    this.getContext().createBean(comp);
    eWrapperDiv.appendChild(comp.getGui());
    var titleEl = document.createElement('div');
    var translatedTitle = this.chartTranslator.translate(title);
    titleEl.innerText = translatedTitle;
    return {
      comp: comp,
      tab: {
        title: titleEl,
        titleLabel: translatedTitle,
        bodyPromise: AgPromise.resolve(eWrapperDiv),
        name: name
      }
    };
  };
  TabbedChartMenu.prototype.showTab = function (tab) {
    var tabItem = this.tabs[tab];
    this.tabbedLayout.showItem(tabItem);
  };
  TabbedChartMenu.prototype.getGui = function () {
    return this.tabbedLayout && this.tabbedLayout.getGui();
  };
  TabbedChartMenu.prototype.destroy = function () {
    if (this.parentComponent && this.parentComponent.isAlive()) {
      this.destroyBean(this.parentComponent);
    }
    _super.prototype.destroy.call(this);
  };
  TabbedChartMenu.prototype.getPanelClass = function (panelType) {
    switch (panelType) {
      case TabbedChartMenu.TAB_DATA:
        return ChartDataPanel;
      case TabbedChartMenu.TAB_FORMAT:
        return FormatPanel;
      default:
        return ChartSettingsPanel;
    }
  };
  TabbedChartMenu.TAB_DATA = 'data';
  TabbedChartMenu.TAB_FORMAT = 'format';
  __decorate$3K([Autowired('chartTranslator')], TabbedChartMenu.prototype, "chartTranslator", void 0);
  __decorate$3K([PostConstruct], TabbedChartMenu.prototype, "init", null);
  return TabbedChartMenu;
}(Component);
var __extends$56 = undefined && undefined.__extends || function () {
  var _extendStatics335 = function extendStatics(d, b) {
    _extendStatics335 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics335(d, b);
  };
  return function (d, b) {
    _extendStatics335(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3L = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartMenu = /** @class */function (_super) {
  __extends$56(ChartMenu, _super);
  function ChartMenu(eChartContainer, eMenuPanelContainer, chartController, chartOptionsService) {
    var _this = _super.call(this, ChartMenu.TEMPLATE) || this;
    _this.eChartContainer = eChartContainer;
    _this.eMenuPanelContainer = eMenuPanelContainer;
    _this.chartController = chartController;
    _this.chartOptionsService = chartOptionsService;
    _this.buttons = {
      chartSettings: ['menu', function () {
        return _this.showMenu("chartSettings");
      }],
      chartData: ['menu', function () {
        return _this.showMenu("chartData");
      }],
      chartFormat: ['menu', function () {
        return _this.showMenu("chartFormat");
      }],
      chartLink: ['linked', function (e) {
        return _this.toggleDetached(e);
      }],
      chartUnlink: ['unlinked', function (e) {
        return _this.toggleDetached(e);
      }],
      chartDownload: ['save', function () {
        return _this.saveChart();
      }]
    };
    _this.tabs = [];
    _this.menuVisible = false;
    return _this;
  }
  ChartMenu.prototype.postConstruct = function () {
    this.createButtons();
    this.refreshMenuClasses();
  };
  ChartMenu.prototype.isVisible = function () {
    return this.menuVisible;
  };
  ChartMenu.prototype.getToolbarOptions = function () {
    var _this = this;
    var tabOptions = ['chartSettings', 'chartData', 'chartFormat', this.chartController.isChartLinked() ? 'chartLink' : 'chartUnlink', 'chartDownload'];
    var toolbarItemsFunc = this.gridOptionsWrapper.getChartToolbarItemsFunc();
    if (toolbarItemsFunc) {
      var params = {
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        defaultItems: tabOptions
      };
      tabOptions = toolbarItemsFunc(params).filter(function (option) {
        if (!_this.buttons[option]) {
          console.warn("AG Grid: '" + option + " is not a valid Chart Toolbar Option");
          return false;
        }
        return true;
      });
    }
    // pivot charts use the column tool panel instead of the data panel
    if (this.chartController.isPivotChart()) {
      tabOptions = tabOptions.filter(function (option) {
        return option !== 'chartData';
      });
    }
    var ignoreOptions = ['chartUnlink', 'chartLink', 'chartDownload'];
    this.tabs = tabOptions.filter(function (option) {
      return ignoreOptions.indexOf(option) === -1;
    });
    return tabOptions.filter(function (value) {
      return ignoreOptions.indexOf(value) !== -1 || _this.tabs.length && value === _this.tabs[0];
    });
  };
  ChartMenu.prototype.toggleDetached = function (e) {
    var target = e.target;
    var active = _.containsClass(target, 'ag-icon-linked');
    _.addOrRemoveCssClass(target, 'ag-icon-linked', !active);
    _.addOrRemoveCssClass(target, 'ag-icon-unlinked', active);
    var tooltipKey = active ? 'chartUnlinkToolbarTooltip' : 'chartLinkToolbarTooltip';
    var tooltipTitle = this.chartTranslator.translate(tooltipKey);
    if (tooltipTitle) {
      target.title = tooltipTitle;
    }
    this.chartController.detachChartRange();
  };
  ChartMenu.prototype.createButtons = function () {
    var _this = this;
    var chartToolbarOptions = this.getToolbarOptions();
    var gui = this.getGui();
    chartToolbarOptions.forEach(function (button) {
      var buttonConfig = _this.buttons[button];
      var iconName = buttonConfig[0],
        callback = buttonConfig[1];
      var buttonEl = _.createIconNoSpan(iconName, _this.gridOptionsWrapper, undefined, true);
      _.addCssClass(buttonEl, 'ag-chart-menu-icon');
      var tooltipTitle = _this.chartTranslator.translate(button + 'ToolbarTooltip');
      if (tooltipTitle) {
        buttonEl.title = tooltipTitle;
      }
      _this.addManagedListener(buttonEl, 'click', callback);
      gui.appendChild(buttonEl);
    });
  };
  ChartMenu.prototype.saveChart = function () {
    var event = {
      type: ChartMenu.EVENT_DOWNLOAD_CHART
    };
    this.dispatchEvent(event);
  };
  ChartMenu.prototype.createMenuPanel = function (defaultTab) {
    var _this = this;
    var width = this.gridOptionsWrapper.chartMenuPanelWidth();
    var menuPanel = this.menuPanel = this.createBean(new AgPanel({
      minWidth: width,
      width: width,
      height: '100%',
      closable: true,
      hideTitleBar: true,
      cssIdentifier: 'chart-menu'
    }));
    menuPanel.setParentComponent(this);
    this.eMenuPanelContainer.appendChild(menuPanel.getGui());
    this.tabbedMenu = this.createBean(new TabbedChartMenu({
      controller: this.chartController,
      type: this.chartController.getChartType(),
      panels: this.tabs,
      chartOptionsService: this.chartOptionsService
    }));
    this.addManagedListener(menuPanel, Component.EVENT_DESTROYED, function () {
      return _this.destroyBean(_this.tabbedMenu);
    });
    return new AgPromise(function (res) {
      window.setTimeout(function () {
        menuPanel.setBodyComponent(_this.tabbedMenu);
        _this.tabbedMenu.showTab(defaultTab);
        _this.addManagedListener(_this.eChartContainer, 'click', function (event) {
          if (_this.getGui().contains(event.target)) {
            return;
          }
          if (_this.menuVisible) {
            _this.hideMenu();
          }
        });
        res(menuPanel);
      }, 100);
    });
  };
  ChartMenu.prototype.showContainer = function () {
    if (!this.menuPanel) {
      return;
    }
    this.menuVisible = true;
    this.showParent(this.menuPanel.getWidth());
    this.refreshMenuClasses();
  };
  ChartMenu.prototype.showMenu = function (tabName) {
    var tab = this.tabs.indexOf(tabName);
    if (!this.menuPanel) {
      this.createMenuPanel(tab).then(this.showContainer.bind(this));
    } else {
      this.showContainer();
    }
  };
  ChartMenu.prototype.hideMenu = function () {
    var _this = this;
    this.hideParent();
    window.setTimeout(function () {
      _this.menuVisible = false;
      _this.refreshMenuClasses();
    }, 500);
  };
  ChartMenu.prototype.refreshMenuClasses = function () {
    _.addOrRemoveCssClass(this.eChartContainer, 'ag-chart-menu-visible', this.menuVisible);
    _.addOrRemoveCssClass(this.eChartContainer, 'ag-chart-menu-hidden', !this.menuVisible);
  };
  ChartMenu.prototype.showParent = function (width) {
    this.eMenuPanelContainer.style.minWidth = width + "px";
  };
  ChartMenu.prototype.hideParent = function () {
    this.eMenuPanelContainer.style.minWidth = '0';
  };
  ChartMenu.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    if (this.menuPanel && this.menuPanel.isAlive()) {
      this.destroyBean(this.menuPanel);
    }
  };
  ChartMenu.EVENT_DOWNLOAD_CHART = "downloadChart";
  ChartMenu.TEMPLATE = "<div class=\"ag-chart-menu\"></div>";
  __decorate$3L([Autowired('chartTranslator')], ChartMenu.prototype, "chartTranslator", void 0);
  __decorate$3L([PostConstruct], ChartMenu.prototype, "postConstruct", null);
  return ChartMenu;
}(Component);
var __extends$57 = undefined && undefined.__extends || function () {
  var _extendStatics336 = function extendStatics(d, b) {
    _extendStatics336 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics336(d, b);
  };
  return function (d, b) {
    _extendStatics336(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$q = undefined && undefined.__assign || function () {
  __assign$q = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$q.apply(this, arguments);
};
var __decorate$3M = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TitleEdit = /** @class */function (_super) {
  __extends$57(TitleEdit, _super);
  function TitleEdit(chartMenu) {
    var _this = _super.call(this, TitleEdit.TEMPLATE) || this;
    _this.chartMenu = chartMenu;
    return _this;
  }
  TitleEdit.prototype.init = function () {
    var _this = this;
    this.addManagedListener(this.getGui(), 'keypress', function (e) {
      if (e.key === 'Enter') {
        _this.endEditing();
      }
    });
    this.addManagedListener(this.getGui(), 'blur', this.endEditing.bind(this));
  };
  /* should be called when the containing component changes to a new chart proxy */
  TitleEdit.prototype.refreshTitle = function (chartController, chartOptionsService) {
    var _this = this;
    this.chartController = chartController;
    this.chartOptionsService = chartOptionsService;
    var chartProxy = this.chartController.getChartProxy();
    if (chartProxy) {
      for (var i = 0; i++; i < this.destroyableChartListeners.length) {
        this.destroyableChartListeners[i]();
      }
      this.destroyableChartListeners = [];
    }
    var chart = chartProxy.getChart();
    var canvas = chart.scene.canvas.element;
    var destroyDbleClickListener = this.addManagedListener(canvas, 'dblclick', function (event) {
      var title = chart.title;
      if (title && title.node.containsPoint(event.offsetX, event.offsetY)) {
        var bbox = title.node.computeBBox();
        var xy = title.node.inverseTransformPoint(bbox.x, bbox.y);
        _this.startEditing(__assign$q(__assign$q({}, bbox), xy));
      }
    });
    var destroyMouseMoveListener = this.addManagedListener(canvas, 'mousemove', function (event) {
      var title = chart.title;
      var inTitle = title && title.enabled && title.node.containsPoint(event.offsetX, event.offsetY);
      canvas.style.cursor = inTitle ? 'pointer' : '';
    });
    this.destroyableChartListeners = [destroyDbleClickListener, destroyMouseMoveListener];
  };
  TitleEdit.prototype.startEditing = function (titleBBox) {
    if (this.chartMenu && this.chartMenu.isVisible()) {
      // currently we ignore requests to edit the chart title while the chart menu is showing
      // because the click to edit the chart will also close the chart menu, making the position
      // of the title change.
      return;
    }
    var minimumTargetInputWidth = 300;
    var maximumInputWidth = this.chartController.getChartProxy().getChart().width;
    var inputWidth = Math.max(Math.min(titleBBox.width + 20, maximumInputWidth), minimumTargetInputWidth);
    var inputElement = this.getGui();
    _.addCssClass(inputElement, 'currently-editing');
    var inputStyle = inputElement.style;
    // match style of input to title that we're editing
    inputStyle.fontFamily = this.chartOptionsService.getChartOption('title.fontFamily');
    inputStyle.fontWeight = this.chartOptionsService.getChartOption('title.fontWeight');
    inputStyle.fontStyle = this.chartOptionsService.getChartOption('title.fontStyle');
    inputStyle.fontSize = this.chartOptionsService.getChartOption('title.fontSize') + 'px';
    inputStyle.color = this.chartOptionsService.getChartOption('title.color');
    // populate the input with the title, unless the title is the placeholder:
    var oldTitle = this.chartOptionsService.getChartOption('title.text');
    var inputValue = oldTitle === this.chartTranslator.translate('titlePlaceholder') ? '' : oldTitle;
    inputElement.value = inputValue;
    var inputRect = inputElement.getBoundingClientRect();
    inputStyle.left = Math.round(titleBBox.x + titleBBox.width / 2 - inputWidth / 2) + 'px';
    inputStyle.top = Math.round(titleBBox.y + titleBBox.height / 2 - inputRect.height / 2) + 'px';
    inputStyle.width = Math.round(inputWidth) + 'px';
    inputElement.focus();
  };
  TitleEdit.prototype.endEditing = function () {
    var value = this.getGui().value;
    this.chartOptionsService.setChartOption('title.text', value);
    this.eventService.dispatchEvent({
      type: 'chartTitleEdit'
    });
    _.removeCssClass(this.getGui(), 'currently-editing');
  };
  TitleEdit.TEMPLATE = "<input\n            class=\"ag-chart-title-edit\"\n            style=\"padding:0; border:none; border-radius: 0; min-height: 0; text-align: center;\" />\n        ";
  __decorate$3M([Autowired('chartTranslator')], TitleEdit.prototype, "chartTranslator", void 0);
  __decorate$3M([PostConstruct], TitleEdit.prototype, "init", null);
  return TitleEdit;
}(Component);

// deepMerge
function emptyTarget$1(value) {
  return Array.isArray(value) ? [] : {};
}
function cloneUnlessOtherwiseSpecified$1(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepMerge$1(emptyTarget$1(value), value, options) : value;
}
function defaultArrayMerge$1(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified$1(element, options);
  });
}
function getMergeFunction$1(key, options) {
  if (!options.customMerge) {
    return deepMerge$1;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepMerge$1;
}
function getEnumerableOwnPropertySymbols$1(target) {
  // @ts-ignore
  return Object.getOwnPropertySymbols
  // @ts-ignore
  ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys$1(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols$1(target));
}
function propertyIsOnObject$1(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe$1(target, key) {
  return propertyIsOnObject$1(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject$1(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys$1(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified$1(target[key], options);
    });
  }
  getKeys$1(source).forEach(function (key) {
    if (propertyIsUnsafe$1(target, key)) {
      return;
    }
    if (propertyIsOnObject$1(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction$1(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified$1(source[key], options);
    }
  });
  return destination;
}
function defaultIsMergeableObject$1(value) {
  return isNonNullObject$2(value) && !isSpecial$1(value);
}
function isNonNullObject$2(value) {
  return !!value && typeof value === 'object';
}
function isSpecial$1(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]';
}
function deepMerge$1(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge$1;
  options.isMergeableObject = options.isMergeableObject || defaultIsMergeableObject$1;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified$1;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified$1(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject$1(target, source, options);
  }
}
function getChartThemeOverridesObjectName(chartType) {
  switch (chartType) {
    case ChartType.Bar:
    case ChartType.GroupedBar:
    case ChartType.StackedBar:
    case ChartType.NormalizedBar:
      return 'bar';
    case ChartType.Column:
    case ChartType.GroupedColumn:
    case ChartType.StackedColumn:
    case ChartType.NormalizedColumn:
      return 'column';
    case ChartType.Line:
      return 'line';
    case ChartType.Area:
    case ChartType.StackedArea:
    case ChartType.NormalizedArea:
      return 'area';
    case ChartType.Scatter:
    case ChartType.Bubble:
      return 'scatter';
    case ChartType.Histogram:
      return 'histogram';
    case ChartType.Pie:
    case ChartType.Doughnut:
      return 'pie';
    default:
      return 'cartesian';
  }
}
var __assign$r = undefined && undefined.__assign || function () {
  __assign$r = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$r.apply(this, arguments);
};
var ChartProxy = /** @class */function () {
  function ChartProxy(chartProxyParams) {
    this.chartProxyParams = chartProxyParams;
    this.chartType = chartProxyParams.chartType;
    this.crossFiltering = chartProxyParams.crossFiltering;
    this.crossFilterCallback = chartProxyParams.crossFilterCallback;
    this.standaloneChartType = getChartThemeOverridesObjectName(this.chartType);
    if (this.chartProxyParams.chartOptionsToRestore) {
      this.chartOptions = this.chartProxyParams.chartOptionsToRestore;
      var themeOverrides = {
        overrides: this.chartOptions
      };
      this.chartTheme = getChartTheme(__assign$r({
        baseTheme: this.getSelectedTheme()
      }, themeOverrides));
      return;
    }
    this.chartTheme = this.createChartTheme();
    this.chartOptions = this.convertConfigToOverrides(this.chartTheme.config);
  }
  ChartProxy.prototype.recreateChart = function () {
    var _this = this;
    if (this.chart) {
      this.destroyChart();
    }
    this.chart = this.createChart();
    if (this.crossFiltering) {
      // add event listener to chart canvas to detect when user wishes to reset filters
      var resetFilters_1 = true;
      this.chart.addEventListener('click', function (e) {
        return _this.crossFilterCallback(e, resetFilters_1);
      });
    }
  };
  ChartProxy.prototype.getChart = function () {
    return this.chart;
  };
  ChartProxy.prototype.createChartTheme = function () {
    var _this = this;
    var themeName = this.getSelectedTheme();
    var stockTheme = this.isStockTheme(themeName);
    var gridOptionsThemeOverrides = this.chartProxyParams.getGridOptionsChartThemeOverrides();
    var apiThemeOverrides = this.chartProxyParams.apiChartThemeOverrides;
    if (gridOptionsThemeOverrides || apiThemeOverrides) {
      var themeOverrides_1 = {
        overrides: ChartProxy.mergeThemeOverrides(gridOptionsThemeOverrides, apiThemeOverrides)
      };
      var getCustomTheme = function getCustomTheme() {
        return deepMerge$1(_this.lookupCustomChartTheme(themeName), themeOverrides_1);
      };
      return getChartTheme(stockTheme ? __assign$r({
        baseTheme: themeName
      }, themeOverrides_1) : getCustomTheme());
    }
    return getChartTheme(stockTheme ? themeName : this.lookupCustomChartTheme(themeName));
  };
  ChartProxy.prototype.isStockTheme = function (themeName) {
    return _.includes(Object.keys(themes), themeName);
  };
  ChartProxy.prototype.getSelectedTheme = function () {
    var chartThemeName = this.chartProxyParams.getChartThemeName();
    var availableThemes = this.chartProxyParams.getChartThemes();
    if (!_.includes(availableThemes, chartThemeName)) {
      chartThemeName = availableThemes[0];
    }
    return chartThemeName;
  };
  ChartProxy.prototype.lookupCustomChartTheme = function (name) {
    var customChartThemes = this.chartProxyParams.customChartThemes;
    var customChartTheme = customChartThemes && customChartThemes[name];
    if (!customChartTheme) {
      console.warn("AG Grid: no stock theme exists with the name '" + name + "' and no " + "custom chart theme with that name was supplied to 'customChartThemes'");
    }
    return customChartTheme;
  };
  ChartProxy.mergeThemeOverrides = function (gridOptionsThemeOverrides, apiThemeOverrides) {
    if (!gridOptionsThemeOverrides) {
      return apiThemeOverrides;
    }
    if (!apiThemeOverrides) {
      return gridOptionsThemeOverrides;
    }
    return deepMerge$1(gridOptionsThemeOverrides, apiThemeOverrides);
  };
  ChartProxy.prototype.downloadChart = function () {
    var chart = this.chart;
    var fileName = chart.title ? chart.title.text : 'chart';
    chart.scene.download(fileName);
  };
  ChartProxy.prototype.getChartImageDataURL = function (type) {
    return this.chart.scene.getDataURL(type);
  };
  ChartProxy.prototype.getChartOptions = function () {
    return this.chartOptions;
  };
  ChartProxy.prototype.transformData = function (data, categoryKey) {
    if (this.chart.axes.filter(function (a) {
      return a instanceof CategoryAxis;
    }).length < 1) {
      return data;
    }
    // replace the values for the selected category with a complex object to allow for duplicated categories
    return data.map(function (d, index) {
      var value = d[categoryKey];
      var valueString = value && value.toString ? value.toString() : '';
      var datum = __assign$r({}, d);
      datum[categoryKey] = {
        id: index,
        value: value,
        toString: function toString() {
          return valueString;
        }
      };
      return datum;
    });
  };
  ChartProxy.prototype.convertConfigToOverrides = function (config) {
    var _a;
    var chartOverrides = deepMerge$1({}, config[this.standaloneChartType]);
    chartOverrides.series = chartOverrides.series[this.standaloneChartType];
    // special handing to add the scatter paired mode to the chart options
    if (this.standaloneChartType === 'scatter') {
      chartOverrides.paired = true;
    }
    return _a = {}, _a[this.standaloneChartType] = chartOverrides, _a;
  };
  ChartProxy.prototype.destroy = function () {
    this.destroyChart();
  };
  ChartProxy.prototype.destroyChart = function () {
    if (this.chart) {
      this.chart.destroy();
      this.chart = undefined;
    }
  };
  return ChartProxy;
}();
var __extends$58 = undefined && undefined.__extends || function () {
  var _extendStatics337 = function extendStatics(d, b) {
    _extendStatics337 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics337(d, b);
  };
  return function (d, b) {
    _extendStatics337(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var CartesianChartProxy = /** @class */function (_super) {
  __extends$58(CartesianChartProxy, _super);
  function CartesianChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.axisTypeToClassMap = {
      number: NumberAxis,
      category: CategoryAxis,
      groupedCategory: GroupedCategoryAxis,
      time: TimeAxis
    };
    return _this;
  }
  CartesianChartProxy.prototype.updateAxes = function (params) {
    // when grouping recreate chart if the axis is not a 'groupedCategory', otherwise return
    if (params.grouping) {
      if (!(this.axisTypeToClassMap[this.xAxisType] instanceof GroupedCategoryAxis)) {
        this.xAxisType = 'groupedCategory';
        this.recreateChart();
      }
      return;
    }
    // only update axis has changed and recreate the chart, i.e. switching from 'category' to 'time' axis
    var newXAxisType = CartesianChartProxy.isTimeAxis(params) ? 'time' : 'category';
    if (newXAxisType !== this.xAxisType) {
      this.xAxisType = newXAxisType;
      this.recreateChart();
    }
  };
  CartesianChartProxy.prototype.updateLabelRotation = function (categoryId) {
    var chartXAxisLabel = this.chart.axes[0].label;
    if (categoryId === ChartDataModel.DEFAULT_CATEGORY) {
      chartXAxisLabel.rotation = 0;
    } else {
      var xAxisOptions = this.getAxesOptions()[this.xAxisType];
      chartXAxisLabel.rotation = xAxisOptions.label.rotation;
    }
    this.chart.layoutPending = true;
  };
  CartesianChartProxy.prototype.getAxesOptions = function () {
    return this.chartOptions[this.standaloneChartType].axes;
  };
  CartesianChartProxy.prototype.processDataForCrossFiltering = function (data, colId, params) {
    var yKey = colId;
    var atLeastOneSelectedPoint = false;
    if (this.crossFiltering) {
      data.forEach(function (d) {
        d[colId + '-total'] = d[colId] + d[colId + '-filtered-out'];
        if (d[colId + '-filtered-out'] > 0) {
          atLeastOneSelectedPoint = true;
        }
      });
      var lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
      if (lastSelectedChartId === params.chartId) {
        yKey = colId + '-total';
      }
    }
    return {
      yKey: yKey,
      atLeastOneSelectedPoint: atLeastOneSelectedPoint
    };
  };
  CartesianChartProxy.prototype.updateSeriesForCrossFiltering = function (series, colId, chart, params, atLeastOneSelectedPoint) {
    if (this.crossFiltering) {
      // special custom marker handling to show and hide points
      series.marker.enabled = true;
      series.marker.formatter = function (p) {
        return {
          fill: p.highlighted ? 'yellow' : p.fill,
          size: p.highlighted ? 12 : p.datum[colId] > 0 ? 8 : 0
        };
      };
      chart.tooltip.delay = 500;
      // make line opaque when some points are deselected
      var ctx = params.getCrossFilteringContext();
      var lastSelectionOnThisChart = ctx.lastSelectedChartId === params.chartId;
      var deselectedPoints = lastSelectionOnThisChart && atLeastOneSelectedPoint;
      if (series instanceof AreaSeries) {
        series.fillOpacity = deselectedPoints ? 0.3 : 1;
      }
      if (series instanceof LineSeries) {
        series.strokeOpacity = deselectedPoints ? 0.3 : 1;
      }
      // add node click cross filtering callback to series
      series.addEventListener('nodeClick', this.crossFilterCallback);
    }
  };
  CartesianChartProxy.isTimeAxis = function (params) {
    if (params.category && params.category.chartDataType) {
      return params.category.chartDataType === 'time';
    }
    var testDatum = params.data[0];
    return (testDatum && testDatum[params.category.id]) instanceof Date;
  };
  return CartesianChartProxy;
}(ChartProxy);
function hexToRGBA(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return alpha ? "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")" : "rgba(" + r + ", " + g + ", " + b + ")";
}
function changeOpacity(fills, alpha) {
  return fills.map(function (fill) {
    var c = Color.fromString(fill);
    return new Color(c.r, c.g, c.b, alpha).toHexString();
  });
}
var __extends$59 = undefined && undefined.__extends || function () {
  var _extendStatics338 = function extendStatics(d, b) {
    _extendStatics338 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics338(d, b);
  };
  return function (d, b) {
    _extendStatics338(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$s = undefined && undefined.__assign || function () {
  __assign$s = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$s.apply(this, arguments);
};
var BarChartProxy = /** @class */function (_super) {
  __extends$59(BarChartProxy, _super);
  function BarChartProxy(params) {
    var _this = _super.call(this, params) || this;
    // when the standalone chart type is 'bar' - xAxis is positioned to the 'left'
    _this.xAxisType = params.grouping ? 'groupedCategory' : 'category';
    _this.yAxisType = 'number';
    _this.recreateChart();
    return _this;
  }
  BarChartProxy.prototype.createChart = function () {
    var _a = [this.standaloneChartType === 'bar', this.isNormalised()],
      isBar = _a[0],
      isNormalised = _a[1];
    return AgChart.create({
      type: isBar ? 'bar' : 'column',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme,
      axes: this.getAxes(isBar, isNormalised),
      series: this.getSeries(isNormalised)
    });
  };
  BarChartProxy.prototype.update = function (params) {
    this.updateAxes(params);
    var barSeries = this.chart.series[0];
    if (this.crossFiltering) {
      this.updateCrossFilteringSeries(barSeries, params);
    } else {
      barSeries.fills = this.chartTheme.palette.fills;
      barSeries.strokes = this.chartTheme.palette.strokes;
    }
    barSeries.data = this.transformData(params.data, params.category.id);
    barSeries.xKey = params.category.id;
    barSeries.xName = params.category.name;
    barSeries.yKeys = params.fields.map(function (f) {
      return f.colId;
    });
    barSeries.yNames = params.fields.map(function (f) {
      return f.displayName;
    });
    this.updateLabelRotation(params.category.id);
  };
  BarChartProxy.prototype.updateCrossFilteringSeries = function (barSeries, params) {
    // add additional filtered out field
    var fields = params.fields;
    fields.forEach(function (field) {
      var crossFilteringField = __assign$s({}, field);
      crossFilteringField.colId = field.colId + '-filtered-out';
      fields.push(crossFilteringField);
    });
    var palette = this.chartTheme.palette;
    // introduce cross filtering transparent fills
    var fills = [];
    palette.fills.forEach(function (fill) {
      fills.push(fill);
      fills.push(hexToRGBA(fill, '0.3'));
    });
    barSeries.fills = fills;
    // introduce cross filtering transparent strokes
    var strokes = [];
    palette.strokes.forEach(function (stroke) {
      fills.push(stroke);
      fills.push(hexToRGBA(stroke, '0.3'));
    });
    barSeries.strokes = strokes;
    // disable series highlighting by default
    barSeries.highlightStyle.fill = undefined;
    // hide 'filtered out' legend items
    var colIds = params.fields.map(function (f) {
      return f.colId;
    });
    barSeries.hideInLegend = colIds.filter(function (colId) {
      return colId.indexOf('-filtered-out') !== -1;
    });
    // sync toggling of legend item with hidden 'filtered out' item
    this.chart.legend.addEventListener('click', function (event) {
      barSeries.toggleSeriesItem(event.itemId + '-filtered-out', event.enabled);
    });
    this.chart.tooltip.delay = 500;
    // add node click cross filtering callback to series
    barSeries.addEventListener('nodeClick', this.crossFilterCallback);
  };
  BarChartProxy.prototype.getAxes = function (isBar, normalised) {
    var axisOptions = this.getAxesOptions();
    var axes = [__assign$s(__assign$s({}, deepMerge$1(axisOptions[this.xAxisType], axisOptions[this.xAxisType].bottom)), {
      type: this.xAxisType,
      position: isBar ? ChartAxisPosition.Left : ChartAxisPosition.Bottom
    }), __assign$s(__assign$s({}, deepMerge$1(axisOptions[this.yAxisType], axisOptions[this.yAxisType].left)), {
      type: this.yAxisType,
      position: isBar ? ChartAxisPosition.Bottom : ChartAxisPosition.Left
    })];
    // special handling to add a default label formatter to show '%' for normalized charts if none is provided
    if (normalised) {
      var numberAxis = axes[1];
      // FIXME: only update labels when no formatter is supplied
      numberAxis.label = __assign$s(__assign$s({}, numberAxis.label), {
        formatter: function formatter(params) {
          return Math.round(params.value) + '%';
        }
      });
    }
    return axes;
  };
  BarChartProxy.prototype.getSeries = function (normalised) {
    var groupedCharts = [ChartType.GroupedColumn, ChartType.GroupedBar];
    var isGrouped = !this.crossFiltering && _.includes(groupedCharts, this.chartType);
    return [__assign$s(__assign$s({}, this.chartOptions[this.standaloneChartType].series), {
      type: this.standaloneChartType,
      grouped: isGrouped,
      normalizedTo: normalised ? 100 : undefined
    })];
  };
  BarChartProxy.prototype.isNormalised = function () {
    var normalisedCharts = [ChartType.NormalizedColumn, ChartType.NormalizedBar];
    return !this.crossFiltering && _.includes(normalisedCharts, this.chartType);
  };
  return BarChartProxy;
}(CartesianChartProxy);
var __extends$5a = undefined && undefined.__extends || function () {
  var _extendStatics339 = function extendStatics(d, b) {
    _extendStatics339 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics339(d, b);
  };
  return function (d, b) {
    _extendStatics339(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$t = undefined && undefined.__assign || function () {
  __assign$t = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$t.apply(this, arguments);
};
var AreaChartProxy = /** @class */function (_super) {
  __extends$5a(AreaChartProxy, _super);
  function AreaChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.xAxisType = params.grouping ? 'groupedCategory' : 'category';
    _this.yAxisType = 'number';
    _this.recreateChart();
    return _this;
  }
  AreaChartProxy.prototype.createChart = function () {
    return AgChart.create({
      type: 'area',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme,
      axes: this.getAxes()
    });
  };
  AreaChartProxy.prototype.update = function (params) {
    this.updateAxes(params);
    if (this.chartType === ChartType.Area) {
      // area charts have multiple series
      this.updateAreaChart(params);
    } else {
      // stacked and normalized has a single series
      var areaSeries = this.chart.series[0];
      if (!areaSeries) {
        var seriesDefaults = __assign$t(__assign$t({}, this.chartOptions[this.standaloneChartType].series), {
          type: 'area',
          normalizedTo: this.chartType === ChartType.NormalizedArea ? 100 : undefined
        });
        areaSeries = AgChart.createComponent(__assign$t({}, seriesDefaults), 'area.series');
        if (!areaSeries) {
          return;
        }
        this.chart.addSeries(areaSeries);
      }
      areaSeries.data = this.transformData(params.data, params.category.id);
      areaSeries.xKey = params.category.id;
      areaSeries.xName = params.category.name;
      areaSeries.yKeys = params.fields.map(function (f) {
        return f.colId;
      });
      areaSeries.yNames = params.fields.map(function (f) {
        return f.displayName;
      });
      areaSeries.fills = this.chartTheme.palette.fills;
      areaSeries.strokes = this.chartTheme.palette.strokes;
    }
    this.updateLabelRotation(params.category.id);
  };
  AreaChartProxy.prototype.updateAreaChart = function (params) {
    var _this = this;
    var chart = this.chart;
    if (params.fields.length === 0) {
      chart.removeAllSeries();
      return;
    }
    var fieldIds = params.fields.map(function (f) {
      return f.colId;
    });
    var existingSeriesById = chart.series.reduceRight(function (map, series, i) {
      var id = series.yKeys[0];
      if (fieldIds.indexOf(id) === i) {
        map.set(id, series);
      } else {
        chart.removeSeries(series);
      }
      return map;
    }, new Map());
    var data = this.transformData(params.data, params.category.id);
    var previousSeries;
    var _a = this.chartTheme.palette,
      fills = _a.fills,
      strokes = _a.strokes;
    params.fields.forEach(function (f, index) {
      var _a = _this.processDataForCrossFiltering(data, f.colId, params),
        yKey = _a.yKey,
        atLeastOneSelectedPoint = _a.atLeastOneSelectedPoint;
      var areaSeries = existingSeriesById.get(f.colId);
      var fill = fills[index % fills.length];
      var stroke = strokes[index % strokes.length];
      if (areaSeries) {
        areaSeries.data = data;
        areaSeries.xKey = params.category.id;
        areaSeries.xName = params.category.name;
        areaSeries.yKeys = [yKey];
        areaSeries.yNames = [f.displayName];
        areaSeries.fills = [fill];
        areaSeries.strokes = [stroke];
      } else {
        var seriesOverrides = _this.chartOptions[_this.standaloneChartType].series;
        var seriesDefaults = __assign$t(__assign$t({}, seriesOverrides), {
          type: 'area',
          normalizedTo: _this.chartType === ChartType.NormalizedArea ? 100 : undefined
        });
        var options = __assign$t(__assign$t({}, seriesDefaults), {
          data: data,
          xKey: params.category.id,
          xName: params.category.name,
          yKeys: [yKey],
          yNames: [f.displayName],
          fills: [fill],
          strokes: [stroke],
          marker: __assign$t(__assign$t({}, seriesDefaults.marker), {
            fill: fill,
            stroke: stroke
          })
        });
        areaSeries = AgChart.createComponent(options, 'area.series');
        chart.addSeriesAfter(areaSeries, previousSeries);
      }
      _this.updateSeriesForCrossFiltering(areaSeries, f.colId, chart, params, atLeastOneSelectedPoint);
      previousSeries = areaSeries;
    });
  };
  AreaChartProxy.prototype.getAxes = function () {
    var axisOptions = this.getAxesOptions();
    return [__assign$t(__assign$t({}, deepMerge$1(axisOptions[this.xAxisType], axisOptions[this.xAxisType].bottom)), {
      type: this.xAxisType,
      position: ChartAxisPosition.Bottom,
      paddingInner: 1,
      paddingOuter: 0
    }), __assign$t(__assign$t({}, deepMerge$1(axisOptions[this.yAxisType], axisOptions[this.yAxisType].left)), {
      type: this.yAxisType,
      position: ChartAxisPosition.Left
    })];
  };
  return AreaChartProxy;
}(CartesianChartProxy);
var __extends$5b = undefined && undefined.__extends || function () {
  var _extendStatics340 = function extendStatics(d, b) {
    _extendStatics340 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics340(d, b);
  };
  return function (d, b) {
    _extendStatics340(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$u = undefined && undefined.__assign || function () {
  __assign$u = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$u.apply(this, arguments);
};
var LineChartProxy = /** @class */function (_super) {
  __extends$5b(LineChartProxy, _super);
  function LineChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.xAxisType = params.grouping ? 'groupedCategory' : 'category';
    _this.yAxisType = 'number';
    _this.recreateChart();
    return _this;
  }
  LineChartProxy.prototype.createChart = function () {
    return AgChart.create({
      type: 'line',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme,
      axes: this.getAxes()
    });
  };
  LineChartProxy.prototype.update = function (params) {
    var _this = this;
    if (params.fields.length === 0) {
      this.chart.removeAllSeries();
      return;
    }
    this.updateAxes(params);
    var chart = this.chart;
    var fields = params.fields;
    var fieldIds = fields.map(function (f) {
      return f.colId;
    });
    var data = this.transformData(params.data, params.category.id);
    var existingSeriesById = chart.series.reduceRight(function (map, series, i) {
      var id = series.yKey;
      fieldIds.indexOf(id) === i ? map.set(id, series) : chart.removeSeries(series);
      return map;
    }, new Map());
    var previousSeries;
    var _a = this.chartTheme.palette,
      fills = _a.fills,
      strokes = _a.strokes;
    fields.forEach(function (f, index) {
      var _a = _this.processDataForCrossFiltering(data, f.colId, params),
        yKey = _a.yKey,
        atLeastOneSelectedPoint = _a.atLeastOneSelectedPoint;
      var lineSeries = existingSeriesById.get(f.colId);
      var fill = fills[index % fills.length];
      var stroke = strokes[index % strokes.length];
      if (lineSeries) {
        lineSeries.title = f.displayName;
        lineSeries.data = data;
        lineSeries.xKey = params.category.id;
        lineSeries.xName = params.category.name;
        lineSeries.yKey = yKey;
        lineSeries.yName = f.displayName;
        lineSeries.marker.fill = fill;
        lineSeries.marker.stroke = stroke;
        lineSeries.stroke = fill; // this is deliberate, so that the line colours match the fills of other series
      } else {
        var seriesOverrides = _this.chartOptions[_this.standaloneChartType].series;
        var seriesOptions = __assign$u(__assign$u({}, seriesOverrides), {
          type: 'line',
          title: f.displayName,
          data: data,
          xKey: params.category.id,
          xName: params.category.name,
          yKey: yKey,
          yName: f.displayName,
          fill: fill,
          stroke: fill,
          marker: __assign$u(__assign$u({}, seriesOverrides.marker), {
            fill: fill,
            stroke: stroke
          })
        });
        lineSeries = AgChart.createComponent(seriesOptions, 'line.series');
        chart.addSeriesAfter(lineSeries, previousSeries);
      }
      _this.updateSeriesForCrossFiltering(lineSeries, f.colId, chart, params, atLeastOneSelectedPoint);
      previousSeries = lineSeries;
    });
    this.updateLabelRotation(params.category.id);
  };
  LineChartProxy.prototype.getAxes = function () {
    var axisOptions = this.getAxesOptions();
    return [__assign$u(__assign$u({}, deepMerge$1(axisOptions[this.xAxisType], axisOptions[this.xAxisType].bottom)), {
      type: this.xAxisType,
      position: ChartAxisPosition.Bottom
    }), __assign$u(__assign$u({}, deepMerge$1(axisOptions[this.yAxisType], axisOptions[this.yAxisType].left)), {
      type: this.yAxisType,
      position: ChartAxisPosition.Left
    })];
  };
  return LineChartProxy;
}(CartesianChartProxy);
var __extends$5c = undefined && undefined.__extends || function () {
  var _extendStatics341 = function extendStatics(d, b) {
    _extendStatics341 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics341(d, b);
  };
  return function (d, b) {
    _extendStatics341(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var PolarChartProxy = /** @class */function (_super) {
  __extends$5c(PolarChartProxy, _super);
  function PolarChartProxy(params) {
    return _super.call(this, params) || this;
  }
  PolarChartProxy.prototype.addCrossFilteringTooltipRenderer = function (pieSeries) {
    pieSeries.tooltip.renderer = function (params) {
      var label = params.datum[params.labelKey];
      var ratio = params.datum[params.radiusKey];
      var totalValue = params.angleValue;
      var value = totalValue * ratio;
      return {
        content: label + ": " + value
      };
    };
  };
  return PolarChartProxy;
}(ChartProxy);
var __extends$5d = undefined && undefined.__extends || function () {
  var _extendStatics342 = function extendStatics(d, b) {
    _extendStatics342 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics342(d, b);
  };
  return function (d, b) {
    _extendStatics342(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$v = undefined && undefined.__assign || function () {
  __assign$v = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$v.apply(this, arguments);
};
var PieChartProxy = /** @class */function (_super) {
  __extends$5d(PieChartProxy, _super);
  function PieChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.recreateChart();
    return _this;
  }
  PieChartProxy.prototype.createChart = function () {
    return AgChart.create({
      type: 'pie',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme
    });
  };
  PieChartProxy.prototype.update = function (params) {
    var chart = this.chart;
    if (params.fields.length === 0) {
      chart.removeAllSeries();
      return;
    }
    var field = params.fields[0];
    var angleField = field;
    if (this.crossFiltering) {
      // add additional filtered out field
      var fields_1 = params.fields;
      fields_1.forEach(function (field) {
        var crossFilteringField = __assign$v({}, field);
        crossFilteringField.colId = field.colId + '-filtered-out';
        fields_1.push(crossFilteringField);
      });
      var filteredOutField_1 = fields_1[1];
      params.data.forEach(function (d) {
        d[field.colId + '-total'] = d[field.colId] + d[filteredOutField_1.colId];
        d[field.colId] = d[field.colId] / d[field.colId + '-total'];
        d[filteredOutField_1.colId] = 1;
      });
      var opaqueSeries = chart.series[1];
      var radiusField = filteredOutField_1;
      opaqueSeries = this.updateSeries(chart, opaqueSeries, angleField, radiusField, params, undefined);
      radiusField = angleField;
      var filteredSeries = chart.series[0];
      this.updateSeries(chart, filteredSeries, angleField, radiusField, params, opaqueSeries);
    } else {
      var series = chart.series[0];
      this.updateSeries(chart, series, angleField, angleField, params, undefined);
    }
  };
  PieChartProxy.prototype.updateSeries = function (chart, series, angleField, field, params, opaqueSeries) {
    var existingSeriesId = series && series.angleKey;
    var seriesOverrides = this.chartOptions[this.standaloneChartType].series;
    var pieSeries = series;
    if (existingSeriesId !== field.colId) {
      chart.removeSeries(series);
      var options = __assign$v(__assign$v({}, seriesOverrides), {
        type: 'pie',
        angleKey: this.crossFiltering ? angleField.colId + '-total' : angleField.colId,
        radiusKey: this.crossFiltering ? field.colId : undefined
      });
      pieSeries = AgChart.createComponent(options, 'pie.series');
      pieSeries.fills = this.chartTheme.palette.fills;
      pieSeries.strokes = this.chartTheme.palette.strokes;
      pieSeries.callout.colors = this.chartTheme.palette.strokes;
      if (this.crossFiltering && pieSeries && !pieSeries.tooltip.renderer) {
        // only add renderer if user hasn't provided one
        this.addCrossFilteringTooltipRenderer(pieSeries);
      }
    }
    pieSeries.angleName = field.displayName;
    pieSeries.labelKey = params.category.id;
    pieSeries.labelName = params.category.name;
    pieSeries.data = params.data;
    if (this.crossFiltering) {
      pieSeries.radiusMin = 0;
      pieSeries.radiusMax = 1;
      var isOpaqueSeries = !opaqueSeries;
      if (isOpaqueSeries) {
        pieSeries.fills = changeOpacity(pieSeries.fills, 0.3);
        pieSeries.strokes = changeOpacity(pieSeries.strokes, 0.3);
        pieSeries.callout.colors = changeOpacity(pieSeries.strokes, 0.3);
        pieSeries.showInLegend = false;
      } else {
        chart.legend.addEventListener('click', function (event) {
          if (opaqueSeries) {
            opaqueSeries.toggleSeriesItem(event.itemId, event.enabled);
          }
        });
      }
      chart.tooltip.delay = 500;
      // disable series highlighting by default
      pieSeries.highlightStyle.fill = undefined;
      pieSeries.addEventListener("nodeClick", this.crossFilterCallback);
    }
    chart.addSeries(pieSeries);
    return pieSeries;
  };
  return PieChartProxy;
}(PolarChartProxy);
var __extends$5e = undefined && undefined.__extends || function () {
  var _extendStatics343 = function extendStatics(d, b) {
    _extendStatics343 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics343(d, b);
  };
  return function (d, b) {
    _extendStatics343(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$w = undefined && undefined.__assign || function () {
  __assign$w = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$w.apply(this, arguments);
};
var DoughnutChartProxy = /** @class */function (_super) {
  __extends$5e(DoughnutChartProxy, _super);
  function DoughnutChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.recreateChart();
    return _this;
  }
  DoughnutChartProxy.prototype.createChart = function () {
    return AgChart.create({
      type: 'pie',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme
    });
  };
  DoughnutChartProxy.prototype.update = function (params) {
    var _this = this;
    if (params.fields.length === 0) {
      this.chart.removeAllSeries();
      return;
    }
    var doughnutChart = this.chart;
    var fieldIds = params.fields.map(function (f) {
      return f.colId;
    });
    var seriesMap = {};
    doughnutChart.series.forEach(function (series) {
      var pieSeries = series;
      var id = pieSeries.angleKey;
      if (_.includes(fieldIds, id)) {
        seriesMap[id] = pieSeries;
      }
    });
    var fills = this.chartTheme.palette.fills;
    var strokes = this.chartTheme.palette.strokes;
    var seriesOverrides = this.chartOptions[this.standaloneChartType].series;
    var numFields = params.fields.length;
    var offset = 0;
    if (this.crossFiltering) {
      params.fields.forEach(function (field, index) {
        var filteredOutField = __assign$w({}, field);
        filteredOutField.colId = field.colId + '-filtered-out';
        params.data.forEach(function (d) {
          d[field.colId + '-total'] = d[field.colId] + d[filteredOutField.colId];
          d[field.colId] = d[field.colId] / d[field.colId + '-total'];
          d[filteredOutField.colId] = 1;
        });
        var _a = _this.updateSeries({
            seriesMap: seriesMap,
            angleField: field,
            field: filteredOutField,
            seriesDefaults: seriesOverrides,
            index: index,
            params: params,
            fills: fills,
            strokes: strokes,
            doughnutChart: doughnutChart,
            offset: offset,
            numFields: numFields,
            opaqueSeries: undefined
          }),
          updatedOffset = _a.updatedOffset,
          pieSeries = _a.pieSeries;
        _this.updateSeries({
          seriesMap: seriesMap,
          angleField: field,
          field: field,
          seriesDefaults: seriesOverrides,
          index: index,
          params: params,
          fills: fills,
          strokes: strokes,
          doughnutChart: doughnutChart,
          offset: offset,
          numFields: numFields,
          opaqueSeries: pieSeries
        });
        offset = updatedOffset;
      });
    } else {
      params.fields.forEach(function (f, index) {
        var updatedOffset = _this.updateSeries({
          seriesMap: seriesMap,
          angleField: f,
          field: f,
          seriesDefaults: seriesOverrides,
          index: index,
          params: params,
          fills: fills,
          strokes: strokes,
          doughnutChart: doughnutChart,
          offset: offset,
          numFields: numFields,
          opaqueSeries: undefined
        }).updatedOffset;
        offset = updatedOffset;
      });
    }
    // Because repaints are automatic, it's important to remove/add/update series at once,
    // so that we don't get painted twice.
    doughnutChart.series = _.values(seriesMap);
  };
  DoughnutChartProxy.prototype.updateSeries = function (updateParams) {
    var existingSeries = updateParams.seriesMap[updateParams.field.colId];
    var seriesOptions = __assign$w(__assign$w({}, updateParams.seriesDefaults), {
      type: 'pie',
      angleKey: this.crossFiltering ? updateParams.angleField.colId + '-total' : updateParams.angleField.colId,
      radiusKey: this.crossFiltering ? updateParams.field.colId : undefined,
      title: __assign$w(__assign$w({}, updateParams.seriesDefaults.title), {
        text: updateParams.seriesDefaults.title.text || updateParams.field.displayName
      })
    });
    var pieSeries = existingSeries || AgChart.createComponent(seriesOptions, 'pie.series');
    if (pieSeries.title) {
      pieSeries.title.showInLegend = updateParams.numFields > 1;
    }
    if (!existingSeries) {
      if (this.crossFiltering && !pieSeries.tooltip.renderer) {
        // only add renderer if user hasn't provided one
        this.addCrossFilteringTooltipRenderer(pieSeries);
      }
    }
    pieSeries.angleName = updateParams.field.displayName;
    pieSeries.labelKey = updateParams.params.category.id;
    pieSeries.labelName = updateParams.params.category.name;
    pieSeries.data = updateParams.params.data;
    if (this.crossFiltering) {
      pieSeries.radiusMin = 0;
      pieSeries.radiusMax = 1;
      var isOpaqueSeries = !updateParams.opaqueSeries;
      if (isOpaqueSeries) {
        pieSeries.fills = updateParams.fills.map(function (fill) {
          return hexToRGBA(fill, '0.3');
        });
        pieSeries.strokes = updateParams.strokes.map(function (stroke) {
          return hexToRGBA(stroke, '0.3');
        });
        pieSeries.showInLegend = false;
      } else {
        updateParams.doughnutChart.legend.addEventListener('click', function (event) {
          if (updateParams.opaqueSeries) {
            updateParams.opaqueSeries.toggleSeriesItem(event.itemId, event.enabled);
          }
        });
        pieSeries.fills = updateParams.fills;
        pieSeries.strokes = updateParams.strokes;
        pieSeries.callout.colors = updateParams.strokes;
      }
      // disable series highlighting by default
      pieSeries.highlightStyle.fill = undefined;
      pieSeries.addEventListener('nodeClick', this.crossFilterCallback);
      updateParams.doughnutChart.tooltip.delay = 500;
    } else {
      pieSeries.fills = updateParams.fills;
      pieSeries.strokes = updateParams.strokes;
      pieSeries.callout.colors = updateParams.strokes;
    }
    var offsetAmount = updateParams.numFields > 1 ? 20 : 40;
    pieSeries.outerRadiusOffset = updateParams.offset;
    updateParams.offset -= offsetAmount;
    pieSeries.innerRadiusOffset = updateParams.offset;
    updateParams.offset -= offsetAmount;
    if (!existingSeries) {
      updateParams.seriesMap[updateParams.field.colId] = pieSeries;
    }
    return {
      updatedOffset: updateParams.offset,
      pieSeries: pieSeries
    };
  };
  return DoughnutChartProxy;
}(PolarChartProxy);
var __extends$5f = undefined && undefined.__extends || function () {
  var _extendStatics344 = function extendStatics(d, b) {
    _extendStatics344 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics344(d, b);
  };
  return function (d, b) {
    _extendStatics344(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$x = undefined && undefined.__assign || function () {
  __assign$x = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$x.apply(this, arguments);
};
var ScatterChartProxy = /** @class */function (_super) {
  __extends$5f(ScatterChartProxy, _super);
  function ScatterChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.xAxisType = 'number';
    _this.yAxisType = 'number';
    _this.recreateChart();
    return _this;
  }
  ScatterChartProxy.prototype.createChart = function () {
    return AgChart.create({
      type: 'scatter',
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme,
      axes: this.getAxes()
    });
  };
  ScatterChartProxy.prototype.update = function (params) {
    var _this = this;
    if (params.fields.length < 2) {
      this.chart.removeAllSeries();
      return;
    }
    var fields = params.fields;
    if (this.crossFiltering) {
      // add additional filtered out field
      fields.forEach(function (field) {
        var crossFilteringField = __assign$x({}, field);
        crossFilteringField.colId = field.colId + '-filtered-out';
        fields.push(crossFilteringField);
      });
    }
    var paired = this.chartOptions[this.standaloneChartType].paired;
    var seriesDefinitions = this.getSeriesDefinitions(fields, paired);
    var dataDomain;
    if (this.crossFiltering) {
      dataDomain = this.getCrossFilteringDataDomain(seriesDefinitions, params);
    }
    var chart = this.chart;
    var existingSeriesById = chart.series.reduceRight(function (map, series, i) {
      var matchingIndex = _.findIndex(seriesDefinitions, function (s) {
        return s.xField.colId === series.xKey && s.yField.colId === series.yKey && (!s.sizeField && !series.sizeKey || s.sizeField && s.sizeField.colId === series.sizeKey);
      });
      if (matchingIndex === i) {
        map.set(series.yKey, series);
      } else {
        chart.removeSeries(series);
      }
      return map;
    }, new Map());
    var _a = this.chartTheme.palette,
      fills = _a.fills,
      strokes = _a.strokes;
    if (this.crossFiltering) {
      // introduce cross filtering transparent fills
      var fillsMod_1 = [];
      fills.forEach(function (fill) {
        fillsMod_1.push(fill);
        fillsMod_1.push(hexToRGBA(fill, '0.3'));
      });
      fills = fillsMod_1;
      // introduce cross filtering transparent strokes
      var strokesMod_1 = [];
      strokes.forEach(function (stroke) {
        strokesMod_1.push(stroke);
        strokesMod_1.push(hexToRGBA(stroke, '0.3'));
      });
      strokes = strokesMod_1;
    }
    var labelFieldDefinition = params.category.id === ChartDataModel.DEFAULT_CATEGORY ? undefined : params.category;
    var previousSeries;
    var seriesOverrides = this.chartOptions[this.standaloneChartType].series;
    seriesDefinitions.forEach(function (seriesDefinition, index) {
      var existingSeries = existingSeriesById.get(seriesDefinition.yField.colId);
      var series = existingSeries || AgChart.createComponent(__assign$x(__assign$x({}, seriesOverrides), {
        type: 'scatter'
      }), 'scatter.series');
      if (!series) {
        return;
      }
      var _a = seriesDefinition,
        xFieldDefinition = _a.xField,
        yFieldDefinition = _a.yField,
        sizeFieldDefinition = _a.sizeField;
      series.title = yFieldDefinition.displayName + " vs " + xFieldDefinition.displayName;
      series.xKey = xFieldDefinition.colId;
      series.xName = xFieldDefinition.displayName;
      series.yKey = yFieldDefinition.colId;
      series.yName = yFieldDefinition.displayName;
      series.data = params.data;
      series.fill = fills[index % fills.length];
      series.stroke = strokes[index % strokes.length];
      if (sizeFieldDefinition) {
        series.sizeKey = sizeFieldDefinition.colId;
        series.sizeName = sizeFieldDefinition.displayName;
      } else {
        series.sizeKey = undefined;
      }
      if (labelFieldDefinition) {
        series.labelKey = labelFieldDefinition.id;
        series.labelName = labelFieldDefinition.name;
      } else {
        series.labelKey = series.yKey;
      }
      var isFilteredOutYKey = yFieldDefinition.colId.indexOf('-filtered-out') > -1;
      if (_this.crossFiltering) {
        if (!isFilteredOutYKey) {
          // sync toggling of legend item with hidden 'filtered out' item
          chart.legend.addEventListener('click', function (event) {
            series.toggleSeriesItem(event.itemId + '-filtered-out', event.enabled);
          });
        }
        if (dataDomain) {
          series.marker.domain = dataDomain;
        }
        chart.tooltip.delay = 500;
        // hide 'filtered out' legend items
        if (isFilteredOutYKey) {
          series.showInLegend = false;
        }
        // add node click cross filtering callback to series
        series.addEventListener('nodeClick', _this.crossFilterCallback);
      }
      if (!existingSeries) {
        chart.addSeriesAfter(series, previousSeries);
      }
      previousSeries = series;
    });
  };
  ScatterChartProxy.prototype.getSeriesDefinitions = function (fields, paired) {
    if (fields.length < 2) {
      return [];
    }
    var isBubbleChart = this.chartType === ChartType.Bubble;
    if (paired) {
      if (isBubbleChart) {
        return fields.map(function (currentXField, i) {
          return i % 3 === 0 ? {
            xField: currentXField,
            yField: fields[i + 1],
            sizeField: fields[i + 2]
          } : null;
        }).filter(function (x) {
          return x && x.yField && x.sizeField;
        });
      }
      return fields.map(function (currentXField, i) {
        return i % 2 === 0 ? {
          xField: currentXField,
          yField: fields[i + 1]
        } : null;
      }).filter(function (x) {
        return x && x.yField;
      });
    }
    var xField = fields[0];
    if (isBubbleChart) {
      return fields.map(function (yField, i) {
        return i % 2 === 1 ? {
          xField: xField,
          yField: yField,
          sizeField: fields[i + 1]
        } : null;
      }).filter(function (x) {
        return x && x.sizeField;
      });
    }
    return fields.filter(function (value, i) {
      return i > 0;
    }).map(function (yField) {
      return {
        xField: xField,
        yField: yField
      };
    });
  };
  ScatterChartProxy.prototype.getCrossFilteringDataDomain = function (seriesDefinitions, params) {
    var domain;
    if (seriesDefinitions[0] && seriesDefinitions[0].sizeField) {
      var sizeColId_1 = seriesDefinitions[0].sizeField.colId;
      var allSizePoints_1 = [];
      params.data.forEach(function (d) {
        if (typeof d[sizeColId_1] !== 'undefined') {
          allSizePoints_1.push(d[sizeColId_1]);
        }
        if (typeof d[sizeColId_1 + '-filtered-out'] !== 'undefined') {
          allSizePoints_1.push(d[sizeColId_1 + '-filtered-out']);
        }
      });
      if (allSizePoints_1.length > 0) {
        domain = [Math.min.apply(Math, allSizePoints_1), Math.max.apply(Math, allSizePoints_1)];
      }
    }
    return domain;
  };
  ScatterChartProxy.prototype.getAxes = function () {
    var axisOptions = this.getAxesOptions();
    return [__assign$x(__assign$x({}, deepMerge$1(axisOptions[this.xAxisType], axisOptions[this.xAxisType].bottom)), {
      type: this.xAxisType,
      position: ChartAxisPosition.Bottom
    }), __assign$x(__assign$x({}, deepMerge$1(axisOptions[this.yAxisType], axisOptions[this.yAxisType].left)), {
      type: this.yAxisType,
      position: ChartAxisPosition.Left
    })];
  };
  return ScatterChartProxy;
}(CartesianChartProxy);
var __extends$5g = undefined && undefined.__extends || function () {
  var _extendStatics345 = function extendStatics(d, b) {
    _extendStatics345 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics345(d, b);
  };
  return function (d, b) {
    _extendStatics345(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$y = undefined && undefined.__assign || function () {
  __assign$y = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$y.apply(this, arguments);
};
var HistogramChartProxy = /** @class */function (_super) {
  __extends$5g(HistogramChartProxy, _super);
  function HistogramChartProxy(params) {
    var _this = _super.call(this, params) || this;
    _this.xAxisType = 'number';
    _this.yAxisType = 'number';
    _this.recreateChart();
    return _this;
  }
  HistogramChartProxy.prototype.createChart = function () {
    return AgChart.create({
      container: this.chartProxyParams.parentElement,
      theme: this.chartTheme,
      axes: this.getAxes(),
      series: [__assign$y(__assign$y({}, this.chartOptions[this.standaloneChartType].series), {
        type: 'histogram'
      })]
    });
  };
  HistogramChartProxy.prototype.update = function (params) {
    var xField = params.fields[0];
    var chart = this.chart;
    var series = chart.series[0];
    series.data = params.data;
    series.xKey = xField.colId;
    series.xName = xField.displayName;
    // for now, only constant width is supported via integrated charts
    series.areaPlot = false;
    series.fill = this.chartTheme.palette.fills[0];
    series.stroke = this.chartTheme.palette.strokes[0];
  };
  HistogramChartProxy.prototype.getAxes = function () {
    var axisOptions = this.getAxesOptions();
    return [__assign$y(__assign$y({}, deepMerge$1(axisOptions[this.xAxisType], axisOptions[this.xAxisType].bottom)), {
      type: this.xAxisType,
      position: ChartAxisPosition.Bottom
    }), __assign$y(__assign$y({}, deepMerge$1(axisOptions[this.yAxisType], axisOptions[this.yAxisType].left)), {
      type: this.yAxisType,
      position: ChartAxisPosition.Left
    })];
  };
  return HistogramChartProxy;
}(CartesianChartProxy);
var __extends$5h = undefined && undefined.__extends || function () {
  var _extendStatics346 = function extendStatics(d, b) {
    _extendStatics346 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics346(d, b);
  };
  return function (d, b) {
    _extendStatics346(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3N = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartOptionsService = /** @class */function (_super) {
  __extends$5h(ChartOptionsService, _super);
  function ChartOptionsService(chartController) {
    var _this = _super.call(this) || this;
    _this.chartController = chartController;
    return _this;
  }
  ChartOptionsService.prototype.getChartType = function () {
    return this.chartController.getChartType();
  };
  ChartOptionsService.prototype.getChartOption = function (expression) {
    return _.get(this.getChart(), expression, undefined);
  };
  ChartOptionsService.prototype.setChartOption = function (expression, value) {
    // update chart options
    var optionsType = getChartThemeOverridesObjectName(this.getChartType());
    var options = _.get(this.getChartOptions(), "" + optionsType, undefined);
    _.set(options, expression, value);
    // update chart
    _.set(this.getChart(), expression, value);
    this.raiseChartOptionsChangedEvent();
  };
  ChartOptionsService.prototype.getAxisProperty = function (expression) {
    return _.get(this.getChart().axes[0], expression, undefined);
  };
  ChartOptionsService.prototype.setAxisProperty = function (expression, value) {
    var _this = this;
    var chart = this.getChart();
    chart.axes.forEach(function (axis) {
      // update axis options
      _this.updateAxisOptions(axis, expression, value);
      // update chart axis
      _.set(axis, expression, value);
    });
    // chart axis properties are not reactive, need to schedule a layout
    chart.layoutPending = true;
    this.raiseChartOptionsChangedEvent();
  };
  ChartOptionsService.prototype.getLabelRotation = function (axisType) {
    var axis = this.getAxis(axisType);
    return _.get(axis, 'label.rotation', undefined);
  };
  ChartOptionsService.prototype.setLabelRotation = function (axisType, value) {
    var expression = 'label.rotation';
    // update chart
    var chartAxis = this.getAxis(axisType);
    _.set(chartAxis, expression, value);
    // chart axis properties are not reactive, need to schedule a layout
    this.getChart().layoutPending = true;
    // do not update axis options when the default category is selected
    if (chartAxis && !this.chartController.isDefaultCategorySelected()) {
      this.updateAxisOptions(chartAxis, expression, value);
      this.raiseChartOptionsChangedEvent();
    }
  };
  ChartOptionsService.prototype.getSeriesOption = function (expression) {
    return _.get(this.getChart().series[0], expression, undefined);
  };
  ChartOptionsService.prototype.setSeriesOption = function (expression, value) {
    // update series options
    var optionsType = getChartThemeOverridesObjectName(this.getChartType());
    _.set(this.getChartOptions()[optionsType].series, expression, value);
    // update chart
    this.getChart().series.forEach(function (s) {
      return _.set(s, expression, value);
    });
    this.raiseChartOptionsChangedEvent();
  };
  ChartOptionsService.prototype.getPairedMode = function () {
    var optionsType = getChartThemeOverridesObjectName(this.getChartType());
    return _.get(this.getChartOptions(), optionsType + ".paired", undefined);
  };
  ChartOptionsService.prototype.setPairedMode = function (paired) {
    var optionsType = getChartThemeOverridesObjectName(this.getChartType());
    var options = _.get(this.getChartOptions(), "" + optionsType, undefined);
    _.set(options, 'paired', paired);
  };
  ChartOptionsService.prototype.getChart = function () {
    return this.chartController.getChartProxy().getChart();
  };
  ChartOptionsService.prototype.getChartOptions = function () {
    return this.chartController.getChartProxy().getChartOptions();
  };
  ChartOptionsService.prototype.getAxis = function (axisType) {
    var chart = this.getChart();
    if (!chart.axes || chart.axes.length < 1) {
      return undefined;
    }
    if (axisType === 'xAxis') {
      return chart.axes && chart.axes[0].direction === 'x' ? chart.axes[0] : chart.axes[1];
    }
    return chart.axes && chart.axes[1].direction === 'y' ? chart.axes[1] : chart.axes[0];
  };
  ChartOptionsService.prototype.updateAxisOptions = function (chartAxis, expression, value) {
    var optionsType = getChartThemeOverridesObjectName(this.getChartType());
    var axisOptions = this.getChartOptions()[optionsType].axes;
    if (chartAxis instanceof NumberAxis) {
      _.set(axisOptions.number, expression, value);
    } else if (chartAxis instanceof CategoryAxis) {
      _.set(axisOptions.category, expression, value);
    } else if (chartAxis instanceof TimeAxis) {
      _.set(axisOptions.time, expression, value);
    } else if (chartAxis instanceof GroupedCategoryAxis) {
      _.set(axisOptions.groupedCategory, expression, value);
    }
  };
  ChartOptionsService.prototype.raiseChartOptionsChangedEvent = function () {
    var chartModel = this.chartController.getChartModel();
    var event = Object.freeze({
      type: Events.EVENT_CHART_OPTIONS_CHANGED,
      chartId: chartModel.chartId,
      chartType: chartModel.chartType,
      chartThemeName: chartModel.chartThemeName,
      chartOptions: chartModel.chartOptions,
      api: this.gridApi,
      columnApi: this.columnApi
    });
    this.eventService.dispatchEvent(event);
  };
  ChartOptionsService.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  __decorate$3N([Autowired('gridApi')], ChartOptionsService.prototype, "gridApi", void 0);
  __decorate$3N([Autowired('columnApi')], ChartOptionsService.prototype, "columnApi", void 0);
  return ChartOptionsService;
}(BeanStub);
var __extends$5i = undefined && undefined.__extends || function () {
  var _extendStatics347 = function extendStatics(d, b) {
    _extendStatics347 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics347(d, b);
  };
  return function (d, b) {
    _extendStatics347(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3O = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GridChartComp = /** @class */function (_super) {
  __extends$5i(GridChartComp, _super);
  function GridChartComp(params) {
    var _this = _super.call(this, GridChartComp.TEMPLATE) || this;
    _this.params = params;
    return _this;
  }
  GridChartComp.prototype.init = function () {
    var availableChartThemes = this.gridOptionsWrapper.getChartThemes();
    if (availableChartThemes.length < 1) {
      throw new Error('Cannot create chart: no chart themes are available to be used.');
    }
    var chartThemeName = this.params.chartThemeName;
    if (!_.includes(availableChartThemes, chartThemeName)) {
      chartThemeName = availableChartThemes[0];
    }
    var modelParams = {
      pivotChart: this.params.pivotChart,
      chartType: this.params.chartType,
      chartThemeName: chartThemeName,
      aggFunc: this.params.aggFunc,
      cellRange: this.params.cellRange,
      suppressChartRanges: this.params.suppressChartRanges,
      unlinkChart: this.params.unlinkChart,
      crossFiltering: this.params.crossFiltering
    };
    var isRtl = this.gridOptionsWrapper.isEnableRtl();
    _.addCssClass(this.getGui(), isRtl ? 'ag-rtl' : 'ag-ltr');
    this.model = this.createBean(new ChartDataModel(modelParams));
    this.chartController = this.createManagedBean(new ChartController(this.model));
    this.validateCustomThemes();
    // create chart before dialog to ensure dialog is correct size
    this.createChart();
    if (this.params.insideDialog) {
      this.addDialog();
    }
    this.addMenu();
    this.addTitleEditComp();
    this.addManagedListener(this.getGui(), 'focusin', this.setActiveChartCellRange.bind(this));
    this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, this.refresh.bind(this));
    if (this.chartMenu) {
      // chart menu may not exist, i.e. cross filtering
      this.addManagedListener(this.chartMenu, ChartMenu.EVENT_DOWNLOAD_CHART, this.downloadChart.bind(this));
    }
    this.refresh();
    this.raiseChartCreatedEvent();
  };
  GridChartComp.prototype.validateCustomThemes = function () {
    var suppliedThemes = this.gridOptionsWrapper.getChartThemes();
    var customChartThemes = this.gridOptionsWrapper.getCustomChartThemes();
    if (customChartThemes) {
      _.getAllKeysInObjects([customChartThemes]).forEach(function (customThemeName) {
        if (!_.includes(suppliedThemes, customThemeName)) {
          console.warn("AG Grid: a custom chart theme with the name '" + customThemeName + "' has been " + "supplied but not added to the 'chartThemes' list");
        }
      });
    }
  };
  GridChartComp.prototype.createChart = function () {
    var _this = this;
    // if chart already exists, destroy it and remove it from DOM
    if (this.chartProxy) {
      this.chartProxy.destroy();
    }
    var customChartThemes = this.gridOptionsWrapper.getCustomChartThemes();
    var chartType = this.model.getChartType();
    var isGrouping = this.model.isGrouping();
    var crossFilterCallback = function crossFilterCallback(event, reset) {
      var ctx = _this.params.crossFilteringContext;
      ctx.lastSelectedChartId = reset ? '' : _this.getChartId();
      _this.crossFilter.filter(event, reset);
    };
    var chartProxyParams = {
      chartType: chartType,
      getChartThemeName: this.getChartThemeName.bind(this),
      getChartThemes: this.getChartThemes.bind(this),
      customChartThemes: customChartThemes,
      getGridOptionsChartThemeOverrides: this.getGridOptionsChartThemeOverrides.bind(this),
      apiChartThemeOverrides: this.params.chartThemeOverrides,
      crossFiltering: this.params.crossFiltering,
      crossFilterCallback: crossFilterCallback,
      parentElement: this.eChart,
      grouping: isGrouping,
      chartOptionsToRestore: this.params.chartOptionsToRestore
    };
    // ensure 'restoring' options are not reused when switching chart types
    this.params.chartOptionsToRestore = undefined;
    // set local state used to detect when chart changes
    this.chartType = chartType;
    this.chartThemeName = this.model.getChartThemeName();
    this.chartProxy = GridChartComp.createChartProxy(chartProxyParams);
    if (!this.chartProxy) {
      console.warn('AG Grid: invalid chart type supplied: ', chartProxyParams.chartType);
      return;
    }
    var canvas = this.eChart.querySelector('canvas');
    if (canvas) {
      _.addCssClass(canvas, 'ag-charts-canvas');
    }
    this.chartController.setChartProxy(this.chartProxy);
    this.chartOptionsService = this.createBean(new ChartOptionsService(this.chartController));
    this.titleEdit && this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
  };
  GridChartComp.prototype.getChartThemeName = function () {
    return this.chartController.getThemeName();
  };
  GridChartComp.prototype.getChartThemes = function () {
    return this.chartController.getThemes();
  };
  GridChartComp.prototype.getGridOptionsChartThemeOverrides = function () {
    return this.gridOptionsWrapper.getChartThemeOverrides();
  };
  GridChartComp.createChartProxy = function (chartProxyParams) {
    switch (chartProxyParams.chartType) {
      case ChartType.Column:
      case ChartType.Bar:
      case ChartType.GroupedColumn:
      case ChartType.StackedColumn:
      case ChartType.NormalizedColumn:
      case ChartType.GroupedBar:
      case ChartType.StackedBar:
      case ChartType.NormalizedBar:
        return new BarChartProxy(chartProxyParams);
      case ChartType.Pie:
        return new PieChartProxy(chartProxyParams);
      case ChartType.Doughnut:
        return new DoughnutChartProxy(chartProxyParams);
      case ChartType.Area:
      case ChartType.StackedArea:
      case ChartType.NormalizedArea:
        return new AreaChartProxy(chartProxyParams);
      case ChartType.Line:
        return new LineChartProxy(chartProxyParams);
      case ChartType.Scatter:
      case ChartType.Bubble:
        return new ScatterChartProxy(chartProxyParams);
      case ChartType.Histogram:
        return new HistogramChartProxy(chartProxyParams);
    }
  };
  GridChartComp.prototype.addDialog = function () {
    var _this = this;
    var title = this.chartTranslator.translate(this.params.pivotChart ? 'pivotChartTitle' : 'rangeChartTitle');
    var _a = this.getBestDialogSize(),
      width = _a.width,
      height = _a.height;
    this.chartDialog = new AgDialog({
      resizable: true,
      movable: true,
      maximizable: true,
      title: title,
      width: width,
      height: height,
      component: this,
      centered: true,
      closable: true
    });
    this.getContext().createBean(this.chartDialog);
    this.chartDialog.addEventListener(AgDialog.EVENT_DESTROYED, function () {
      return _this.destroy();
    });
  };
  GridChartComp.prototype.getBestDialogSize = function () {
    var popupParent = this.popupService.getPopupParent();
    var maxWidth = _.getAbsoluteWidth(popupParent) * 0.75;
    var maxHeight = _.getAbsoluteHeight(popupParent) * 0.75;
    var ratio = 0.553;
    var chart = this.chartProxy.getChart();
    var width = this.params.insideDialog ? 850 : chart.width;
    var height = this.params.insideDialog ? 470 : chart.height;
    if (width > maxWidth || height > maxHeight) {
      width = Math.min(width, maxWidth);
      height = Math.round(width * ratio);
      if (height > maxHeight) {
        height = maxHeight;
        width = Math.min(width, Math.round(height / ratio));
      }
    }
    return {
      width: width,
      height: height
    };
  };
  GridChartComp.prototype.addMenu = function () {
    if (!this.params.crossFiltering) {
      this.chartMenu = this.createBean(new ChartMenu(this.eChartContainer, this.eMenuContainer, this.chartController, this.chartOptionsService));
      this.eChartContainer.appendChild(this.chartMenu.getGui());
    }
  };
  GridChartComp.prototype.addTitleEditComp = function () {
    this.titleEdit = this.createBean(new TitleEdit(this.chartMenu));
    this.eTitleEditContainer.appendChild(this.titleEdit.getGui());
    if (this.chartProxy) {
      this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
    }
  };
  GridChartComp.prototype.refresh = function () {
    if (this.shouldRecreateChart()) {
      this.createChart();
    }
    this.updateChart();
  };
  GridChartComp.prototype.shouldRecreateChart = function () {
    return this.chartType !== this.model.getChartType() || this.chartThemeName !== this.model.getChartThemeName();
  };
  GridChartComp.prototype.getCurrentChartType = function () {
    return this.chartType;
  };
  GridChartComp.prototype.getChartModel = function () {
    return this.chartController.getChartModel();
  };
  GridChartComp.prototype.getChartId = function () {
    return this.model.getChartId();
  };
  GridChartComp.prototype.getChartImageDataURL = function (fileFormat) {
    return this.chartProxy.getChartImageDataURL(fileFormat);
  };
  GridChartComp.prototype.updateChart = function () {
    var _this = this;
    var _a = this,
      model = _a.model,
      chartProxy = _a.chartProxy;
    var selectedCols = model.getSelectedValueColState();
    var fields = selectedCols.map(function (c) {
      return {
        colId: c.colId,
        displayName: c.displayName
      };
    });
    var data = model.getData();
    var chartEmpty = this.handleEmptyChart(data, fields);
    if (chartEmpty) {
      return;
    }
    var selectedDimension = model.getSelectedDimension();
    var chartUpdateParams = {
      data: data,
      grouping: model.isGrouping(),
      category: {
        id: selectedDimension.colId,
        name: selectedDimension.displayName,
        chartDataType: this.getChartDataType(selectedDimension.colId)
      },
      fields: fields,
      chartId: this.getChartId(),
      getCrossFilteringContext: function getCrossFilteringContext() {
        return _this.params.crossFilteringContext;
      }
    };
    chartProxy.update(chartUpdateParams);
    this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
  };
  GridChartComp.prototype.getChartDataType = function (colId) {
    var column = this.columnModel.getPrimaryColumn(colId);
    return column ? column.getColDef().chartDataType : undefined;
  };
  GridChartComp.prototype.handleEmptyChart = function (data, fields) {
    var container = this.chartProxy.getChart().container;
    var pivotModeDisabled = this.model.isPivotChart() && !this.model.isPivotMode();
    var minFieldsRequired = 1;
    if (this.chartController.isActiveXYChart()) {
      minFieldsRequired = this.model.getChartType() === ChartType.Bubble ? 3 : 2;
    }
    var isEmptyChart = fields.length < minFieldsRequired || data.length === 0;
    if (container) {
      var isEmpty = pivotModeDisabled || isEmptyChart;
      _.setDisplayed(this.eChart, !isEmpty);
      _.setDisplayed(this.eEmpty, isEmpty);
    }
    if (pivotModeDisabled) {
      this.eEmpty.innerText = this.chartTranslator.translate('pivotChartRequiresPivotMode');
      return true;
    }
    if (isEmptyChart) {
      this.eEmpty.innerText = this.chartTranslator.translate('noDataToChart');
      return true;
    }
    return false;
  };
  GridChartComp.prototype.downloadChart = function () {
    this.chartProxy.downloadChart();
  };
  GridChartComp.prototype.getUnderlyingChart = function () {
    return this.chartProxy.getChart();
  };
  GridChartComp.prototype.refreshCanvasSize = function () {
    if (!this.params.insideDialog) {
      return;
    }
    var eChart = this.eChart;
    if (this.chartMenu.isVisible()) {
      // we don't want the menu showing to affect the chart options
      var chart = this.chartProxy.getChart();
      chart.height = _.getInnerHeight(eChart);
      chart.width = _.getInnerWidth(eChart);
    }
  };
  GridChartComp.prototype.setActiveChartCellRange = function (focusEvent) {
    if (this.getGui().contains(focusEvent.relatedTarget)) {
      return;
    }
    this.chartController.setChartRange(true);
    this.gridApi.focusService.clearFocusedCell();
  };
  GridChartComp.prototype.raiseChartCreatedEvent = function () {
    var event = Object.freeze({
      type: Events.EVENT_CHART_CREATED,
      chartId: this.getChartId(),
      api: this.gridApi,
      columnApi: this.columnApi
    });
    this.eventService.dispatchEvent(event);
  };
  GridChartComp.prototype.raiseChartDestroyedEvent = function () {
    var event = Object.freeze({
      type: Events.EVENT_CHART_DESTROYED,
      chartId: this.getChartId(),
      api: this.gridApi,
      columnApi: this.columnApi
    });
    this.eventService.dispatchEvent(event);
  };
  GridChartComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
    if (this.chartProxy) {
      this.chartProxy.destroy();
    }
    this.destroyBean(this.chartMenu);
    // don't want to invoke destroy() on the Dialog (prevents destroy loop)
    if (this.chartDialog && this.chartDialog.isAlive()) {
      this.destroyBean(this.chartDialog);
    }
    // if the user is providing containers for the charts, we need to clean up, otherwise the old chart
    // data will still be visible although the chart is no longer bound to the grid
    var eGui = this.getGui();
    _.clearElement(eGui);
    // remove from parent, so if user provided container, we detach from the provided dom element
    _.removeFromParent(eGui);
    this.raiseChartDestroyedEvent();
  };
  GridChartComp.TEMPLATE = "<div class=\"ag-chart\" tabindex=\"-1\">\n            <div ref=\"eChartContainer\" tabindex=\"-1\" class=\"ag-chart-components-wrapper\">\n                <div ref=\"eChart\" class=\"ag-chart-canvas-wrapper\"></div>\n                <div ref=\"eEmpty\" class=\"ag-chart-empty-text ag-unselectable\"></div>\n            </div>\n            <div ref=\"eTitleEditContainer\"></div>\n            <div ref=\"eMenuContainer\" class=\"ag-chart-docked-container\"></div>\n        </div>";
  __decorate$3O([RefSelector('eChart')], GridChartComp.prototype, "eChart", void 0);
  __decorate$3O([RefSelector('eChartContainer')], GridChartComp.prototype, "eChartContainer", void 0);
  __decorate$3O([RefSelector('eMenuContainer')], GridChartComp.prototype, "eMenuContainer", void 0);
  __decorate$3O([RefSelector('eEmpty')], GridChartComp.prototype, "eEmpty", void 0);
  __decorate$3O([RefSelector('eTitleEditContainer')], GridChartComp.prototype, "eTitleEditContainer", void 0);
  __decorate$3O([Autowired('environment')], GridChartComp.prototype, "environment", void 0);
  __decorate$3O([Autowired('chartTranslator')], GridChartComp.prototype, "chartTranslator", void 0);
  __decorate$3O([Autowired('columnModel')], GridChartComp.prototype, "columnModel", void 0);
  __decorate$3O([Autowired('chartCrossFilter')], GridChartComp.prototype, "crossFilter", void 0);
  __decorate$3O([Autowired('gridApi')], GridChartComp.prototype, "gridApi", void 0);
  __decorate$3O([Autowired('columnApi')], GridChartComp.prototype, "columnApi", void 0);
  __decorate$3O([Autowired('popupService')], GridChartComp.prototype, "popupService", void 0);
  __decorate$3O([PostConstruct], GridChartComp.prototype, "init", null);
  return GridChartComp;
}(Component);
var __extends$5j = undefined && undefined.__extends || function () {
  var _extendStatics348 = function extendStatics(d, b) {
    _extendStatics348 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics348(d, b);
  };
  return function (d, b) {
    _extendStatics348(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3P = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartService = /** @class */function (_super) {
  __extends$5j(ChartService, _super);
  function ChartService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // we destroy all charts bound to this grid when grid is destroyed. activeCharts contains all charts, including
    // those in developer provided containers.
    _this.activeCharts = new Set();
    _this.activeChartComps = new Set();
    // this shared (singleton) context is used by cross filtering in line and area charts
    _this.crossFilteringContext = {
      lastSelectedChartId: ''
    };
    return _this;
  }
  ChartService.prototype.getChartModels = function () {
    var models = [];
    this.activeChartComps.forEach(function (c) {
      return models.push(c.getChartModel());
    });
    return models;
  };
  ChartService.prototype.getChartRef = function (chartId) {
    var chartRef;
    this.activeCharts.forEach(function (cr) {
      if (cr.chartId === chartId) {
        chartRef = cr;
      }
    });
    return chartRef;
  };
  ChartService.prototype.getChartImageDataURL = function (params) {
    var url;
    this.activeChartComps.forEach(function (c) {
      if (c.getChartId() === params.chartId) {
        url = c.getChartImageDataURL(params.fileFormat);
      }
    });
    return url;
  };
  ChartService.prototype.createChartFromCurrentRange = function (chartType) {
    if (chartType === void 0) {
      chartType = ChartType.GroupedColumn;
    }
    var selectedRange = this.getSelectedRange();
    return this.createChart(selectedRange, chartType);
  };
  ChartService.prototype.restoreChart = function (model, chartContainer) {
    var _this = this;
    if (!model) {
      console.warn("AG Grid - unable to restore chart as no chart model is provided");
      return;
    }
    var params = {
      cellRange: model.cellRange,
      chartType: model.chartType,
      chartThemeName: model.chartThemeName,
      chartContainer: chartContainer,
      suppressChartRanges: model.suppressChartRanges,
      aggFunc: model.aggFunc,
      unlinkChart: model.unlinkChart
    };
    var getCellRange = function getCellRange(cellRangeParams) {
      return _this.rangeService ? _this.rangeService.createCellRangeFromCellRangeParams(cellRangeParams) : undefined;
    };
    if (model.modelType === 'pivot') {
      // if required enter pivot mode
      if (!this.columnModel.isPivotMode()) {
        this.columnModel.setPivotMode(true, "pivotChart");
      }
      // pivot chart range contains all visible column without a row range to include all rows
      var columns = this.columnModel.getAllDisplayedColumns().map(function (col) {
        return col.getColId();
      });
      var chartAllRangeParams = {
        rowStartIndex: null,
        rowEndIndex: null,
        columns: columns
      };
      var cellRange_1 = getCellRange(chartAllRangeParams);
      if (!cellRange_1) {
        console.warn("AG Grid - unable to create chart as there are no columns in the grid.");
        return;
      }
      return this.createChart(cellRange_1, params.chartType, params.chartThemeName, true, true, params.chartContainer, undefined, undefined, params.unlinkChart, false, model.chartOptions);
    }
    var cellRange = getCellRange(params.cellRange);
    if (!cellRange) {
      console.warn("AG Grid - unable to create chart as no range is selected");
      return;
    }
    return this.createChart(cellRange, params.chartType, params.chartThemeName, false, params.suppressChartRanges, params.chartContainer, params.aggFunc, undefined, params.unlinkChart, false, model.chartOptions);
  };
  ChartService.prototype.createRangeChart = function (params) {
    var cellRange = this.rangeService ? this.rangeService.createCellRangeFromCellRangeParams(params.cellRange) : undefined;
    if (!cellRange) {
      console.warn("AG Grid - unable to create chart as no range is selected");
      return;
    }
    return this.createChart(cellRange, params.chartType, params.chartThemeName, false, params.suppressChartRanges, params.chartContainer, params.aggFunc, params.chartThemeOverrides, params.unlinkChart);
  };
  ChartService.prototype.createPivotChart = function (params) {
    // if required enter pivot mode
    if (!this.columnModel.isPivotMode()) {
      this.columnModel.setPivotMode(true, "pivotChart");
    }
    // pivot chart range contains all visible column without a row range to include all rows
    var chartAllRangeParams = {
      rowStartIndex: null,
      rowEndIndex: null,
      columns: this.columnModel.getAllDisplayedColumns().map(function (col) {
        return col.getColId();
      })
    };
    var cellRange = this.rangeService ? this.rangeService.createCellRangeFromCellRangeParams(chartAllRangeParams) : undefined;
    if (!cellRange) {
      console.warn("AG Grid - unable to create chart as there are no columns in the grid.");
      return;
    }
    return this.createChart(cellRange, params.chartType, params.chartThemeName, true, true, params.chartContainer, undefined, params.chartThemeOverrides, params.unlinkChart);
  };
  ChartService.prototype.createCrossFilterChart = function (params) {
    var cellRange = this.rangeService ? this.rangeService.createCellRangeFromCellRangeParams(params.cellRange) : undefined;
    if (!cellRange) {
      console.warn("AG Grid - unable to create chart as no range is selected");
      return;
    }
    var crossFiltering = true;
    var suppressChartRangesSupplied = typeof params.suppressChartRanges !== 'undefined' && params.suppressChartRanges !== null;
    var suppressChartRanges = suppressChartRangesSupplied ? params.suppressChartRanges : true;
    return this.createChart(cellRange, params.chartType, params.chartThemeName, false, suppressChartRanges, params.chartContainer, params.aggFunc, params.chartThemeOverrides, params.unlinkChart, crossFiltering);
  };
  ChartService.prototype.createChart = function (cellRange, chartType, chartThemeName, pivotChart, suppressChartRanges, container, aggFunc, chartThemeOverrides, unlinkChart, crossFiltering, chartOptionsToRestore) {
    var _this = this;
    if (pivotChart === void 0) {
      pivotChart = false;
    }
    if (suppressChartRanges === void 0) {
      suppressChartRanges = false;
    }
    if (unlinkChart === void 0) {
      unlinkChart = false;
    }
    if (crossFiltering === void 0) {
      crossFiltering = false;
    }
    var createChartContainerFunc = this.gridOptionsWrapper.getCreateChartContainerFunc();
    var params = {
      pivotChart: pivotChart,
      cellRange: cellRange,
      chartType: chartType,
      chartThemeName: chartThemeName,
      insideDialog: !(container || createChartContainerFunc),
      suppressChartRanges: suppressChartRanges,
      aggFunc: aggFunc,
      chartThemeOverrides: chartThemeOverrides,
      unlinkChart: unlinkChart,
      crossFiltering: crossFiltering,
      crossFilteringContext: this.crossFilteringContext,
      chartOptionsToRestore: chartOptionsToRestore
    };
    var chartComp = new GridChartComp(params);
    this.context.createBean(chartComp);
    var chartRef = this.createChartRef(chartComp);
    if (container) {
      // if container exists, means developer initiated chart create via API, so place in provided container
      container.appendChild(chartComp.getGui());
      // if the chart container was placed outside of an element that
      // has the grid's theme, we manually add the current theme to
      // make sure all styles for the chartMenu are rendered correctly
      var theme = this.environment.getTheme();
      if (theme.el && !theme.el.contains(container)) {
        _.addCssClass(container, theme.theme);
      }
    } else if (createChartContainerFunc) {
      // otherwise user created chart via grid UI, check if developer provides containers (eg if the application
      // is using its own dialogs rather than the grid provided dialogs)
      createChartContainerFunc(chartRef);
    } else {
      // add listener to remove from active charts list when charts are destroyed, e.g. closing chart dialog
      chartComp.addEventListener(GridChartComp.EVENT_DESTROYED, function () {
        _this.activeChartComps.delete(chartComp);
        _this.activeCharts.delete(chartRef);
      });
    }
    return chartRef;
  };
  ChartService.prototype.createChartRef = function (chartComp) {
    var _this = this;
    var chartRef = {
      destroyChart: function destroyChart() {
        if (_this.activeCharts.has(chartRef)) {
          _this.context.destroyBean(chartComp);
          _this.activeChartComps.delete(chartComp);
          _this.activeCharts.delete(chartRef);
        }
      },
      chartElement: chartComp.getGui(),
      chart: chartComp.getUnderlyingChart(),
      chartId: chartComp.getChartModel().chartId
    };
    this.activeCharts.add(chartRef);
    this.activeChartComps.add(chartComp);
    return chartRef;
  };
  ChartService.prototype.getSelectedRange = function () {
    var ranges = this.rangeService.getCellRanges();
    return ranges.length > 0 ? ranges[0] : {};
  };
  ChartService.prototype.destroyAllActiveCharts = function () {
    this.activeCharts.forEach(function (chart) {
      return chart.destroyChart();
    });
  };
  __decorate$3P([Optional('rangeService')], ChartService.prototype, "rangeService", void 0);
  __decorate$3P([Autowired('columnModel')], ChartService.prototype, "columnModel", void 0);
  __decorate$3P([Autowired('environment')], ChartService.prototype, "environment", void 0);
  __decorate$3P([PreDestroy], ChartService.prototype, "destroyAllActiveCharts", null);
  ChartService = __decorate$3P([Bean('chartService')], ChartService);
  return ChartService;
}(BeanStub);
var __extends$5k = undefined && undefined.__extends || function () {
  var _extendStatics349 = function extendStatics(d, b) {
    _extendStatics349 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics349(d, b);
  };
  return function (d, b) {
    _extendStatics349(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3Q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartTranslator = /** @class */function (_super) {
  __extends$5k(ChartTranslator, _super);
  function ChartTranslator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ChartTranslator_1 = ChartTranslator;
  ChartTranslator.prototype.translate = function (toTranslate) {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var defaultTranslation = ChartTranslator_1.DEFAULT_TRANSLATIONS[toTranslate];
    return translate(toTranslate, defaultTranslation);
  };
  var ChartTranslator_1;
  ChartTranslator.DEFAULT_TRANSLATIONS = {
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    shape: 'Shape',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    lineDash: 'Line Dash',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart'
  };
  ChartTranslator = ChartTranslator_1 = __decorate$3Q([Bean("chartTranslator")], ChartTranslator);
  return ChartTranslator;
}(BeanStub);
var __extends$5l = undefined && undefined.__extends || function () {
  var _extendStatics350 = function extendStatics(d, b) {
    _extendStatics350 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics350(d, b);
  };
  return function (d, b) {
    _extendStatics350(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3R = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChartCrossFilter = /** @class */function (_super) {
  __extends$5l(ChartCrossFilter, _super);
  function ChartCrossFilter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ChartCrossFilter_1 = ChartCrossFilter;
  ChartCrossFilter.prototype.filter = function (event, reset) {
    if (reset === void 0) {
      reset = false;
    }
    var filterModel = this.gridApi.getFilterModel();
    // filters should be reset when user clicks on canvas background
    if (reset) {
      this.resetFilters(filterModel);
      return;
    }
    var colId = ChartCrossFilter_1.extractFilterColId(event);
    if (this.isValidColumnFilter(colId)) {
      // update filters based on current chart selections
      this.updateFilters(filterModel, event);
    } else {
      console.warn("AG Grid: cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' " + "to be defined on the column with id: '" + colId + "'");
    }
  };
  ChartCrossFilter.prototype.resetFilters = function (filterModel) {
    var filtersExist = Object.keys(filterModel).length > 0;
    if (filtersExist) {
      // only reset filters / charts when necessary to prevent undesirable flickering effect
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    }
  };
  ChartCrossFilter.prototype.updateFilters = function (filterModel, event) {
    var _a;
    var dataKey = ChartCrossFilter_1.extractFilterColId(event);
    var rawValue = event.datum[dataKey];
    if (rawValue === undefined) {
      return;
    }
    var selectedValue = rawValue.toString();
    var filterColId = dataKey.replace('-filtered-out', '');
    if (event.event.metaKey || event.event.ctrlKey) {
      var existingGridValues = this.getCurrentGridValuesForCategory(filterColId);
      var valueAlreadyExists = _.includes(existingGridValues, selectedValue);
      var updatedValues = void 0;
      if (valueAlreadyExists) {
        updatedValues = existingGridValues.filter(function (v) {
          return v !== selectedValue;
        });
      } else {
        updatedValues = existingGridValues;
        updatedValues.push(selectedValue);
      }
      filterModel[filterColId] = this.getUpdatedFilterModel(filterColId, updatedValues);
    } else {
      var updatedValues = [selectedValue];
      filterModel = (_a = {}, _a[filterColId] = this.getUpdatedFilterModel(filterColId, updatedValues), _a);
    }
    this.gridApi.setFilterModel(filterModel);
  };
  ChartCrossFilter.prototype.getUpdatedFilterModel = function (colId, updatedValues) {
    var columnFilterType = this.getColumnFilterType(colId);
    if (columnFilterType === 'agMultiColumnFilter') {
      return {
        filterType: 'multi',
        filterModels: [null, {
          filterType: 'set',
          values: updatedValues
        }]
      };
    }
    return {
      filterType: 'set',
      values: updatedValues
    };
  };
  ChartCrossFilter.prototype.getCurrentGridValuesForCategory = function (dataKey) {
    var filteredValues = [];
    var gridContainsValue = _.includes;
    this.gridApi.forEachNodeAfterFilter(function (rowNode) {
      if (!rowNode.group) {
        var value = rowNode.data[dataKey] + '';
        if (!gridContainsValue(filteredValues, value)) {
          filteredValues.push(value);
        }
      }
    });
    return filteredValues;
  };
  ChartCrossFilter.extractFilterColId = function (event) {
    return event.xKey ? event.xKey : event.labelKey;
  };
  ChartCrossFilter.prototype.isValidColumnFilter = function (colId) {
    if (colId.indexOf('-filtered-out')) {
      colId = colId.replace('-filtered-out', '');
    }
    var filterType = this.getColumnFilterType(colId);
    if (typeof filterType === 'boolean') {
      return filterType;
    }
    return _.includes(['agSetColumnFilter', 'agMultiColumnFilter'], filterType);
  };
  ChartCrossFilter.prototype.getColumnFilterType = function (colId) {
    var gridColumn = this.columnModel.getGridColumn(colId);
    return gridColumn ? gridColumn.getColDef().filter : undefined;
  };
  var ChartCrossFilter_1;
  __decorate$3R([Autowired('gridApi')], ChartCrossFilter.prototype, "gridApi", void 0);
  __decorate$3R([Autowired('columnModel')], ChartCrossFilter.prototype, "columnModel", void 0);
  ChartCrossFilter = ChartCrossFilter_1 = __decorate$3R([Bean("chartCrossFilter")], ChartCrossFilter);
  return ChartCrossFilter;
}(BeanStub);
var __extends$5m = undefined && undefined.__extends || function () {
  var _extendStatics351 = function extendStatics(d, b) {
    _extendStatics351 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics351(d, b);
  };
  return function (d, b) {
    _extendStatics351(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3S = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$m = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var RangeService = /** @class */function (_super) {
  __extends$5m(RangeService, _super);
  function RangeService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.cellRanges = [];
    _this.bodyScrollListener = _this.onBodyScroll.bind(_this);
    _this.dragging = false;
    return _this;
  }
  RangeService.prototype.init = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, function () {
      return _this.removeAllCellRanges();
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
      return _this.removeAllCellRanges();
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
      return _this.removeAllCellRanges();
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, function () {
      return _this.removeAllCellRanges();
    });
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.refreshLastRangeStart.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.refreshLastRangeStart.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.refreshLastRangeStart.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.onColumnVisibleChange.bind(this));
    this.ctrlsService.whenReady(function () {
      var gridBodyCon = _this.ctrlsService.getGridBodyCtrl();
      _this.autoScrollService = new AutoScrollService({
        scrollContainer: gridBodyCon.getBodyViewportElement(),
        scrollAxis: 'xy',
        getVerticalPosition: function getVerticalPosition() {
          return gridBodyCon.getScrollFeature().getVScrollPosition().top;
        },
        setVerticalPosition: function setVerticalPosition(position) {
          return gridBodyCon.getScrollFeature().setVerticalScrollPosition(position);
        },
        getHorizontalPosition: function getHorizontalPosition() {
          return gridBodyCon.getScrollFeature().getHScrollPosition().left;
        },
        setHorizontalPosition: function setHorizontalPosition(position) {
          return gridBodyCon.getScrollFeature().setHorizontalScrollPosition(position);
        },
        shouldSkipVerticalScroll: function shouldSkipVerticalScroll() {
          return _this.gridOptionsWrapper.getDomLayout() !== Constants.DOM_LAYOUT_NORMAL;
        },
        shouldSkipHorizontalScroll: function shouldSkipHorizontalScroll() {
          return gridBodyCon.getScrollFeature().isHorizontalScrollShowing();
        }
      });
    });
  };
  RangeService.prototype.onColumnVisibleChange = function () {
    var _this = this;
    // first move start column in last cell range (i.e. series chart range)
    this.refreshLastRangeStart();
    // then check if the column visibility has changed in any cell range
    this.cellRanges.forEach(function (cellRange) {
      var beforeCols = cellRange.columns;
      // remove hidden cols from cell range
      cellRange.columns = cellRange.columns.filter(function (col) {
        return col.isVisible();
      });
      var colsInRangeChanged = !_.areEqual(beforeCols, cellRange.columns);
      if (colsInRangeChanged) {
        // notify users and other parts of grid (i.e. status panel) that range has changed
        _this.dispatchChangedEvent(false, true, cellRange.id);
      }
    });
  };
  RangeService.prototype.refreshLastRangeStart = function () {
    var lastRange = _.last(this.cellRanges);
    if (!lastRange) {
      return;
    }
    this.refreshRangeStart(lastRange);
  };
  RangeService.prototype.isContiguousRange = function (cellRange) {
    var rangeColumns = cellRange.columns;
    if (!rangeColumns.length) {
      return false;
    }
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var allPositions = rangeColumns.map(function (c) {
      return allColumns.indexOf(c);
    }).sort(function (a, b) {
      return a - b;
    });
    return _.last(allPositions) - allPositions[0] + 1 === rangeColumns.length;
  };
  RangeService.prototype.getRangeStartRow = function (cellRange) {
    if (cellRange.startRow && cellRange.endRow) {
      return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow) ? cellRange.startRow : cellRange.endRow;
    }
    var rowPinned = this.pinnedRowModel.getPinnedTopRowCount() > 0 ? Constants.PINNED_TOP : null;
    return {
      rowIndex: 0,
      rowPinned: rowPinned
    };
  };
  RangeService.prototype.getRangeEndRow = function (cellRange) {
    if (cellRange.startRow && cellRange.endRow) {
      return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow) ? cellRange.endRow : cellRange.startRow;
    }
    var pinnedBottomRowCount = this.pinnedRowModel.getPinnedBottomRowCount();
    var pinnedBottom = pinnedBottomRowCount > 0;
    if (pinnedBottom) {
      return {
        rowIndex: pinnedBottomRowCount - 1,
        rowPinned: Constants.PINNED_BOTTOM
      };
    }
    return {
      rowIndex: this.rowModel.getRowCount() - 1,
      rowPinned: null
    };
  };
  RangeService.prototype.setRangeToCell = function (cell, appendRange) {
    if (appendRange === void 0) {
      appendRange = false;
    }
    if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
      return;
    }
    var columns = this.calculateColumnsBetween(cell.column, cell.column);
    if (!columns) {
      return;
    }
    var suppressMultiRangeSelections = this.gridOptionsWrapper.isSuppressMultiRangeSelection();
    // if not appending, then clear previous range selections
    if (suppressMultiRangeSelections || !appendRange || _.missing(this.cellRanges)) {
      this.removeAllCellRanges(true);
    }
    var rowForCell = {
      rowIndex: cell.rowIndex,
      rowPinned: cell.rowPinned
    };
    // if there is already a range for this cell, then we reuse the same range, otherwise the user
    // can ctrl & click a cell many times and hit ctrl+c, which would result in the cell getting copied
    // many times to the clipboard.
    var cellRange;
    for (var i = 0; i < this.cellRanges.length; i++) {
      var range = this.cellRanges[i];
      var matches =
      // check cols are same
      range.columns && range.columns.length === 1 && range.columns[0] === cell.column &&
      // check rows are same
      this.rowPositionUtils.sameRow(rowForCell, range.startRow) && this.rowPositionUtils.sameRow(rowForCell, range.endRow);
      if (matches) {
        cellRange = range;
        break;
      }
    }
    if (cellRange) {
      // we need it at the end of the list, as the dragStart picks the last created
      // range as the start point for the drag
      if (_.last(this.cellRanges) !== cellRange) {
        _.removeFromArray(this.cellRanges, cellRange);
        this.cellRanges.push(cellRange);
      }
    } else {
      cellRange = {
        startRow: rowForCell,
        endRow: rowForCell,
        columns: columns,
        startColumn: cell.column
      };
      this.cellRanges.push(cellRange);
    }
    this.newestRangeStartCell = cell;
    this.onDragStop();
    this.dispatchChangedEvent(true, true, cellRange.id);
  };
  RangeService.prototype.extendLatestRangeToCell = function (cellPosition) {
    if (this.isEmpty() || !this.newestRangeStartCell) {
      return;
    }
    var cellRange = _.last(this.cellRanges);
    this.updateRangeEnd(cellRange, cellPosition);
  };
  RangeService.prototype.updateRangeEnd = function (cellRange, cellPosition, silent) {
    if (silent === void 0) {
      silent = false;
    }
    var endColumn = cellPosition.column;
    var colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
    if (!colsToAdd || this.isLastCellOfRange(cellRange, cellPosition)) {
      return;
    }
    cellRange.columns = colsToAdd;
    cellRange.endRow = {
      rowIndex: cellPosition.rowIndex,
      rowPinned: cellPosition.rowPinned
    };
    if (!silent) {
      this.dispatchChangedEvent(true, true, cellRange.id);
    }
  };
  RangeService.prototype.refreshRangeStart = function (cellRange) {
    var startColumn = cellRange.startColumn,
      columns = cellRange.columns;
    var moveColInCellRange = function moveColInCellRange(colToMove, moveToFront) {
      var otherCols = cellRange.columns.filter(function (col) {
        return col !== colToMove;
      });
      if (colToMove) {
        cellRange.startColumn = colToMove;
        cellRange.columns = moveToFront ? __spreadArrays$m([colToMove], otherCols) : __spreadArrays$m(otherCols, [colToMove]);
      } else {
        cellRange.columns = otherCols;
      }
    };
    var _a = this.getRangeEdgeColumns(cellRange),
      left = _a.left,
      right = _a.right;
    var shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
    if (shouldMoveLeftCol) {
      moveColInCellRange(left, true);
      return;
    }
    var shouldMoveRightCol = startColumn === _.last(columns) && startColumn === right;
    if (shouldMoveRightCol) {
      moveColInCellRange(right, false);
      return;
    }
  };
  RangeService.prototype.getRangeEdgeColumns = function (cellRange) {
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var allIndices = cellRange.columns.map(function (c) {
      return allColumns.indexOf(c);
    }).filter(function (i) {
      return i > -1;
    }).sort(function (a, b) {
      return a - b;
    });
    return {
      left: allColumns[allIndices[0]],
      right: allColumns[_.last(allIndices)]
    };
  };
  // returns true if successful, false if not successful
  RangeService.prototype.extendLatestRangeInDirection = function (key) {
    if (this.isEmpty() || !this.newestRangeStartCell) {
      return;
    }
    var lastRange = _.last(this.cellRanges);
    var startCell = this.newestRangeStartCell;
    var firstCol = lastRange.columns[0];
    var lastCol = _.last(lastRange.columns);
    // find the cell that is at the furthest away corner from the starting cell
    var endCellIndex = lastRange.endRow.rowIndex;
    var endCellFloating = lastRange.endRow.rowPinned;
    var endCellColumn = startCell.column === firstCol ? lastCol : firstCol;
    var endCell = {
      column: endCellColumn,
      rowIndex: endCellIndex,
      rowPinned: endCellFloating
    };
    var newEndCell = this.cellNavigationService.getNextCellToFocus(key, endCell);
    // if user is at end of grid, so no cell to extend to, we return false
    if (!newEndCell) {
      return;
    }
    this.setCellRange({
      rowStartIndex: startCell.rowIndex,
      rowStartPinned: startCell.rowPinned,
      rowEndIndex: newEndCell.rowIndex,
      rowEndPinned: newEndCell.rowPinned,
      columnStart: startCell.column,
      columnEnd: newEndCell.column
    });
    return newEndCell;
  };
  RangeService.prototype.setCellRange = function (params) {
    if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
      return;
    }
    this.removeAllCellRanges(true);
    this.addCellRange(params);
  };
  RangeService.prototype.setCellRanges = function (cellRanges) {
    var _this = this;
    if (_.shallowCompare(this.cellRanges, cellRanges)) {
      return;
    }
    this.removeAllCellRanges(true);
    cellRanges.forEach(function (newRange) {
      if (newRange.columns && newRange.startRow) {
        _this.newestRangeStartCell = {
          rowIndex: newRange.startRow.rowIndex,
          rowPinned: newRange.startRow.rowPinned,
          column: newRange.columns[0]
        };
      }
      _this.cellRanges.push(newRange);
    });
    this.dispatchChangedEvent(false, true);
  };
  RangeService.prototype.createCellRangeFromCellRangeParams = function (params) {
    var _this = this;
    var columns;
    if (params.columns) {
      columns = params.columns.map(function (c) {
        return _this.columnModel.getColumnWithValidation(c);
      }).filter(function (c) {
        return c;
      });
    } else {
      var columnStart = this.columnModel.getColumnWithValidation(params.columnStart);
      var columnEnd = this.columnModel.getColumnWithValidation(params.columnEnd);
      if (!columnStart || !columnEnd) {
        return;
      }
      columns = this.calculateColumnsBetween(columnStart, columnEnd);
    }
    if (!columns) {
      return;
    }
    var startRow = params.rowStartIndex != null ? {
      rowIndex: params.rowStartIndex,
      rowPinned: params.rowStartPinned || null
    } : undefined;
    var endRow = params.rowEndIndex != null ? {
      rowIndex: params.rowEndIndex,
      rowPinned: params.rowEndPinned || null
    } : undefined;
    return {
      startRow: startRow,
      endRow: endRow,
      columns: columns,
      startColumn: columns[0]
    };
  };
  RangeService.prototype.addCellRange = function (params) {
    if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
      return;
    }
    var newRange = this.createCellRangeFromCellRangeParams(params);
    if (newRange) {
      this.cellRanges.push(newRange);
      this.dispatchChangedEvent(false, true, newRange.id);
    }
  };
  RangeService.prototype.getCellRanges = function () {
    return this.cellRanges;
  };
  RangeService.prototype.isEmpty = function () {
    return this.cellRanges.length === 0;
  };
  RangeService.prototype.isMoreThanOneCell = function () {
    if (this.cellRanges.length === 0) {
      // no ranges, so not more than one cell
      return false;
    } else if (this.cellRanges.length > 1) {
      // many ranges, so more than one cell
      return true;
    }
    // only one range, return true if range has more than one
    var range = this.cellRanges[0];
    var startRow = this.getRangeStartRow(range);
    var endRow = this.getRangeEndRow(range);
    return startRow.rowPinned !== endRow.rowPinned || startRow.rowIndex !== endRow.rowIndex || range.columns.length !== 1;
  };
  RangeService.prototype.removeAllCellRanges = function (silent) {
    if (this.isEmpty()) {
      return;
    }
    this.onDragStop();
    this.cellRanges.length = 0;
    if (!silent) {
      this.dispatchChangedEvent(false, true);
    }
  };
  // as the user is dragging outside of the panel, the div starts to scroll, which in turn
  // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
  // the selection my mimicking a new mouse event
  RangeService.prototype.onBodyScroll = function () {
    this.onDragging(this.lastMouseEvent);
  };
  RangeService.prototype.isCellInAnyRange = function (cell) {
    return this.getCellRangeCount(cell) > 0;
  };
  RangeService.prototype.isCellInSpecificRange = function (cell, range) {
    var columnInRange = range.columns !== null && _.includes(range.columns, cell.column);
    var rowInRange = this.isRowInRange(cell.rowIndex, cell.rowPinned, range);
    return columnInRange && rowInRange;
  };
  RangeService.prototype.isLastCellOfRange = function (cellRange, cell) {
    var startRow = cellRange.startRow,
      endRow = cellRange.endRow;
    var lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
    var isLastRow = cell.rowIndex === lastRow.rowIndex && cell.rowPinned === lastRow.rowPinned;
    var rangeFirstIndexColumn = cellRange.columns[0];
    var rangeLastIndexColumn = _.last(cellRange.columns);
    var lastRangeColumn = cellRange.startColumn === rangeFirstIndexColumn ? rangeLastIndexColumn : rangeFirstIndexColumn;
    var isLastColumn = cell.column === lastRangeColumn;
    return isLastColumn && isLastRow;
  };
  RangeService.prototype.isBottomRightCell = function (cellRange, cell) {
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var allPositions = cellRange.columns.map(function (c) {
      return allColumns.indexOf(c);
    }).sort(function (a, b) {
      return a - b;
    });
    var startRow = cellRange.startRow,
      endRow = cellRange.endRow;
    var lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
    var isRightColumn = allColumns.indexOf(cell.column) === _.last(allPositions);
    var isLastRow = cell.rowIndex === lastRow.rowIndex && _.makeNull(cell.rowPinned) === _.makeNull(lastRow.rowPinned);
    return isRightColumn && isLastRow;
  };
  // returns the number of ranges this cell is in
  RangeService.prototype.getCellRangeCount = function (cell) {
    var _this = this;
    if (this.isEmpty()) {
      return 0;
    }
    return this.cellRanges.filter(function (cellRange) {
      return _this.isCellInSpecificRange(cell, cellRange);
    }).length;
  };
  RangeService.prototype.isRowInRange = function (rowIndex, floating, cellRange) {
    var firstRow = this.getRangeStartRow(cellRange);
    var lastRow = this.getRangeEndRow(cellRange);
    var thisRow = {
      rowIndex: rowIndex,
      rowPinned: floating || null
    };
    // compare rowPinned with == instead of === because it can be `null` or `undefined`
    var equalsFirstRow = thisRow.rowIndex === firstRow.rowIndex && thisRow.rowPinned == firstRow.rowPinned;
    var equalsLastRow = thisRow.rowIndex === lastRow.rowIndex && thisRow.rowPinned == lastRow.rowPinned;
    if (equalsFirstRow || equalsLastRow) {
      return true;
    }
    var afterFirstRow = !this.rowPositionUtils.before(thisRow, firstRow);
    var beforeLastRow = this.rowPositionUtils.before(thisRow, lastRow);
    return afterFirstRow && beforeLastRow;
  };
  RangeService.prototype.getDraggingRange = function () {
    return this.draggingRange;
  };
  RangeService.prototype.onDragStart = function (mouseEvent) {
    if (!this.gridOptionsWrapper.isEnableRangeSelection()) {
      return;
    }
    var ctrlKey = mouseEvent.ctrlKey,
      metaKey = mouseEvent.metaKey,
      shiftKey = mouseEvent.shiftKey;
    // ctrlKey for windows, metaKey for Apple
    var multiKeyPressed = ctrlKey || metaKey;
    var allowMulti = !this.gridOptionsWrapper.isSuppressMultiRangeSelection();
    var multiSelectKeyPressed = allowMulti ? multiKeyPressed : false;
    var mouseCell = this.mouseEventService.getCellPositionForEvent(mouseEvent);
    var extendRange = shiftKey && _.existsAndNotEmpty(this.cellRanges);
    if (_.missing(mouseCell)) {
      // if drag wasn't on cell, then do nothing, including do not set dragging=true,
      // (which them means onDragging and onDragStop do nothing)
      return;
    }
    if (!multiSelectKeyPressed && (!extendRange || _.exists(_.last(this.cellRanges).type))) {
      this.removeAllCellRanges(true);
    }
    this.dragging = true;
    this.draggingCell = mouseCell;
    this.lastMouseEvent = mouseEvent;
    if (!extendRange) {
      this.newestRangeStartCell = mouseCell;
    }
    // if we didn't clear the ranges, then dragging means the user clicked, and when the
    // user clicks it means a range of one cell was created. we need to extend this range
    // rather than creating another range. otherwise we end up with two distinct ranges
    // from a drag operation (one from click, and one from drag).
    if (this.cellRanges.length > 0) {
      this.draggingRange = _.last(this.cellRanges);
    } else {
      var mouseRowPosition = {
        rowIndex: mouseCell.rowIndex,
        rowPinned: mouseCell.rowPinned
      };
      this.draggingRange = {
        startRow: mouseRowPosition,
        endRow: mouseRowPosition,
        columns: [mouseCell.column],
        startColumn: this.newestRangeStartCell.column
      };
      this.cellRanges.push(this.draggingRange);
    }
    this.ctrlsService.getGridBodyCtrl().addScrollEventListener(this.bodyScrollListener);
    this.dispatchChangedEvent(true, false, this.draggingRange.id);
  };
  RangeService.prototype.onDragging = function (mouseEvent) {
    var _this = this;
    if (!this.dragging || !mouseEvent) {
      return;
    }
    this.lastMouseEvent = mouseEvent;
    var cellPosition = this.mouseEventService.getCellPositionForEvent(mouseEvent);
    var isMouseAndStartInPinned = function isMouseAndStartInPinned(position) {
      return cellPosition && cellPosition.rowPinned === position && _this.newestRangeStartCell.rowPinned === position;
    };
    var skipVerticalScroll = isMouseAndStartInPinned('top') || isMouseAndStartInPinned('bottom');
    this.autoScrollService.check(mouseEvent, skipVerticalScroll);
    if (!cellPosition || !this.draggingCell || this.cellPositionUtils.equals(this.draggingCell, cellPosition)) {
      return;
    }
    var columns = this.calculateColumnsBetween(this.newestRangeStartCell.column, cellPosition.column);
    if (!columns) {
      return;
    }
    this.draggingCell = cellPosition;
    this.draggingRange.endRow = {
      rowIndex: cellPosition.rowIndex,
      rowPinned: cellPosition.rowPinned
    };
    this.draggingRange.columns = columns;
    this.dispatchChangedEvent(false, false, this.draggingRange.id);
  };
  RangeService.prototype.onDragStop = function () {
    if (!this.dragging) {
      return;
    }
    var id = this.draggingRange.id;
    this.autoScrollService.ensureCleared();
    this.ctrlsService.getGridBodyCtrl().removeScrollEventListener(this.bodyScrollListener);
    this.lastMouseEvent = null;
    this.dragging = false;
    this.draggingRange = undefined;
    this.draggingCell = undefined;
    this.dispatchChangedEvent(false, true, id);
  };
  RangeService.prototype.dispatchChangedEvent = function (started, finished, id) {
    var event = Object.freeze({
      type: Events.EVENT_RANGE_SELECTION_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi,
      started: started,
      finished: finished,
      id: id
    });
    this.eventService.dispatchEvent(event);
  };
  RangeService.prototype.calculateColumnsBetween = function (columnFrom, columnTo) {
    var allColumns = this.columnModel.getAllDisplayedColumns();
    var isSameColumn = columnFrom === columnTo;
    var fromIndex = allColumns.indexOf(columnFrom);
    if (fromIndex < 0) {
      console.warn("AG Grid: column " + columnFrom.getId() + " is not visible");
      return;
    }
    var toIndex = isSameColumn ? fromIndex : allColumns.indexOf(columnTo);
    if (toIndex < 0) {
      console.warn("AG Grid: column " + columnTo.getId() + " is not visible");
      return;
    }
    if (isSameColumn) {
      return [columnFrom];
    }
    var firstIndex = Math.min(fromIndex, toIndex);
    var lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
    var columns = [];
    for (var i = firstIndex; i <= lastIndex; i++) {
      columns.push(allColumns[i]);
    }
    return columns;
  };
  __decorate$3S([Autowired('rowModel')], RangeService.prototype, "rowModel", void 0);
  __decorate$3S([Autowired('columnModel')], RangeService.prototype, "columnModel", void 0);
  __decorate$3S([Autowired('mouseEventService')], RangeService.prototype, "mouseEventService", void 0);
  __decorate$3S([Autowired('columnApi')], RangeService.prototype, "columnApi", void 0);
  __decorate$3S([Autowired('gridApi')], RangeService.prototype, "gridApi", void 0);
  __decorate$3S([Autowired('cellNavigationService')], RangeService.prototype, "cellNavigationService", void 0);
  __decorate$3S([Autowired("pinnedRowModel")], RangeService.prototype, "pinnedRowModel", void 0);
  __decorate$3S([Autowired('rowPositionUtils')], RangeService.prototype, "rowPositionUtils", void 0);
  __decorate$3S([Autowired('cellPositionUtils')], RangeService.prototype, "cellPositionUtils", void 0);
  __decorate$3S([Autowired('ctrlsService')], RangeService.prototype, "ctrlsService", void 0);
  __decorate$3S([PostConstruct], RangeService.prototype, "init", null);
  RangeService = __decorate$3S([Bean('rangeService')], RangeService);
  return RangeService;
}(BeanStub);
var __extends$5n = undefined && undefined.__extends || function () {
  var _extendStatics352 = function extendStatics(d, b) {
    _extendStatics352 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics352(d, b);
  };
  return function (d, b) {
    _extendStatics352(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3T = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AbstractSelectionHandle = /** @class */function (_super) {
  __extends$5n(AbstractSelectionHandle, _super);
  function AbstractSelectionHandle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.changedCalculatedValues = false;
    _this.dragging = false;
    _this.shouldDestroyOnEndDragging = false;
    return _this;
  }
  AbstractSelectionHandle.prototype.init = function () {
    var _this = this;
    this.dragService.addDragSource({
      dragStartPixels: 0,
      eElement: this.getGui(),
      onDragStart: this.onDragStart.bind(this),
      onDragging: function onDragging(e) {
        _this.dragging = true;
        _this.rangeService.autoScrollService.check(e);
        if (_this.changedCalculatedValues) {
          _this.onDrag(e);
          _this.changedCalculatedValues = false;
        }
      },
      onDragStop: function onDragStop(e) {
        _this.dragging = false;
        _this.onDragEnd(e);
        _this.clearValues();
        _this.rangeService.autoScrollService.ensureCleared();
        // TODO: this causes a bug where if there are multiple grids in the same page, all of them will
        // be affected by a drag on any. Move it to the root element.
        _.removeCssClass(document.body, _this.getDraggingCssClass());
        if (_this.shouldDestroyOnEndDragging) {
          _this.destroy();
        }
      }
    });
    this.addManagedListener(this.getGui(), 'mousedown', this.preventRangeExtension.bind(this));
  };
  AbstractSelectionHandle.prototype.isDragging = function () {
    return this.dragging;
  };
  AbstractSelectionHandle.prototype.getCellCtrl = function () {
    return this.cellCtrl;
  };
  AbstractSelectionHandle.prototype.setCellCtrl = function (cellComp) {
    this.cellCtrl = cellComp;
  };
  AbstractSelectionHandle.prototype.getCellRange = function () {
    return this.cellRange;
  };
  AbstractSelectionHandle.prototype.setCellRange = function (range) {
    this.cellRange = range;
  };
  AbstractSelectionHandle.prototype.getRangeStartRow = function () {
    return this.rangeStartRow;
  };
  AbstractSelectionHandle.prototype.setRangeStartRow = function (row) {
    this.rangeStartRow = row;
  };
  AbstractSelectionHandle.prototype.getRangeEndRow = function () {
    return this.rangeEndRow;
  };
  AbstractSelectionHandle.prototype.setRangeEndRow = function (row) {
    this.rangeEndRow = row;
  };
  AbstractSelectionHandle.prototype.getLastCellHovered = function () {
    return this.lastCellHovered;
  };
  AbstractSelectionHandle.prototype.preventRangeExtension = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };
  AbstractSelectionHandle.prototype.onDragStart = function (e) {
    this.cellHoverListener = this.addManagedListener(this.ctrlsService.getGridCtrl().getGui(), 'mousemove', this.updateValuesOnMove.bind(this));
    _.addCssClass(document.body, this.getDraggingCssClass());
  };
  AbstractSelectionHandle.prototype.getDraggingCssClass = function () {
    return "ag-dragging-" + (this.type === SelectionHandleType.FILL ? 'fill' : 'range') + "-handle";
  };
  AbstractSelectionHandle.prototype.updateValuesOnMove = function (e) {
    var cell = this.mouseEventService.getCellPositionForEvent(e);
    if (cell === this.lastCellHovered) {
      return;
    }
    this.lastCellHovered = cell;
    this.changedCalculatedValues = true;
  };
  AbstractSelectionHandle.prototype.getType = function () {
    return this.type;
  };
  AbstractSelectionHandle.prototype.refresh = function (cellCtrl) {
    var _this = this;
    var oldCellComp = this.getCellCtrl();
    var eGui = this.getGui();
    var cellRange = _.last(this.rangeService.getCellRanges());
    var start = cellRange.startRow;
    var end = cellRange.endRow;
    if (start && end) {
      var isBefore = this.rowPositionUtils.before(end, start);
      if (isBefore) {
        this.setRangeStartRow(end);
        this.setRangeEndRow(start);
      } else {
        this.setRangeStartRow(start);
        this.setRangeEndRow(end);
      }
    }
    if (oldCellComp !== cellCtrl || !_.isVisible(eGui)) {
      this.setCellCtrl(cellCtrl);
      window.setTimeout(function () {
        if (_this.isAlive()) {
          cellCtrl.appendChild(eGui);
        }
      }, 1);
    }
    this.setCellRange(cellRange);
  };
  AbstractSelectionHandle.prototype.clearValues = function () {
    this.lastCellHovered = undefined;
    this.removeListeners();
  };
  AbstractSelectionHandle.prototype.removeListeners = function () {
    if (this.cellHoverListener) {
      this.cellHoverListener();
      this.cellHoverListener = undefined;
    }
  };
  AbstractSelectionHandle.prototype.destroy = function () {
    if (!this.shouldDestroyOnEndDragging && this.isDragging()) {
      _.setDisplayed(this.getGui(), false);
      this.shouldDestroyOnEndDragging = true;
      return;
    }
    this.shouldDestroyOnEndDragging = false;
    _super.prototype.destroy.call(this);
    this.removeListeners();
    var eGui = this.getGui();
    if (eGui.parentElement) {
      eGui.parentElement.removeChild(eGui);
    }
  };
  __decorate$3T([Autowired("rowRenderer")], AbstractSelectionHandle.prototype, "rowRenderer", void 0);
  __decorate$3T([Autowired("dragService")], AbstractSelectionHandle.prototype, "dragService", void 0);
  __decorate$3T([Autowired("rangeService")], AbstractSelectionHandle.prototype, "rangeService", void 0);
  __decorate$3T([Autowired("mouseEventService")], AbstractSelectionHandle.prototype, "mouseEventService", void 0);
  __decorate$3T([Autowired("columnModel")], AbstractSelectionHandle.prototype, "columnModel", void 0);
  __decorate$3T([Autowired("cellNavigationService")], AbstractSelectionHandle.prototype, "cellNavigationService", void 0);
  __decorate$3T([Autowired("navigationService")], AbstractSelectionHandle.prototype, "navigationService", void 0);
  __decorate$3T([Autowired('rowPositionUtils')], AbstractSelectionHandle.prototype, "rowPositionUtils", void 0);
  __decorate$3T([Autowired('ctrlsService')], AbstractSelectionHandle.prototype, "ctrlsService", void 0);
  __decorate$3T([PostConstruct], AbstractSelectionHandle.prototype, "init", null);
  return AbstractSelectionHandle;
}(Component);
var __extends$5o = undefined && undefined.__extends || function () {
  var _extendStatics353 = function extendStatics(d, b) {
    _extendStatics353 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics353(d, b);
  };
  return function (d, b) {
    _extendStatics353(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$z = undefined && undefined.__assign || function () {
  __assign$z = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$z.apply(this, arguments);
};
var __decorate$3U = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays$n = undefined && undefined.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var FillHandle = /** @class */function (_super) {
  __extends$5o(FillHandle, _super);
  function FillHandle() {
    var _this = _super.call(this, FillHandle.TEMPLATE) || this;
    _this.markedCells = [];
    _this.cellValues = [];
    _this.isUp = false;
    _this.isLeft = false;
    _this.isReduce = false;
    _this.type = SelectionHandleType.FILL;
    return _this;
  }
  FillHandle.prototype.updateValuesOnMove = function (e) {
    _super.prototype.updateValuesOnMove.call(this, e);
    if (!this.initialXY) {
      this.initialXY = this.mouseEventService.getNormalisedPosition(e);
    }
    var _a = this.initialXY,
      x = _a.x,
      y = _a.y;
    var _b = this.mouseEventService.getNormalisedPosition(e),
      newX = _b.x,
      newY = _b.y;
    var diffX = Math.abs(x - newX);
    var diffY = Math.abs(y - newY);
    var allowedDirection = this.gridOptionsWrapper.getFillHandleDirection();
    var direction;
    if (allowedDirection === 'xy') {
      direction = diffX > diffY ? 'x' : 'y';
    } else {
      direction = allowedDirection;
    }
    if (direction !== this.dragAxis) {
      this.dragAxis = direction;
      this.changedCalculatedValues = true;
    }
  };
  FillHandle.prototype.onDrag = function (e) {
    if (!this.initialPosition) {
      var cellCtrl = this.getCellCtrl();
      if (!cellCtrl) {
        return;
      }
      this.initialPosition = cellCtrl.getCellPosition();
    }
    var lastCellHovered = this.getLastCellHovered();
    if (lastCellHovered) {
      this.markPathFrom(this.initialPosition, lastCellHovered);
    }
  };
  FillHandle.prototype.onDragEnd = function (e) {
    this.initialXY = null;
    if (!this.markedCells.length) {
      return;
    }
    var isX = this.dragAxis === 'x';
    var initialRange = this.getCellRange();
    var colLen = initialRange.columns.length;
    var rangeStartRow = this.getRangeStartRow();
    var rangeEndRow = this.getRangeEndRow();
    var finalRange;
    if (!this.isUp && !this.isLeft) {
      finalRange = this.rangeService.createCellRangeFromCellRangeParams({
        rowStartIndex: rangeStartRow.rowIndex,
        rowStartPinned: rangeStartRow.rowPinned,
        columnStart: initialRange.columns[0],
        rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
        rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
        columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1]
      });
    } else {
      var startRow = isX ? rangeStartRow : this.lastCellMarked;
      finalRange = this.rangeService.createCellRangeFromCellRangeParams({
        rowStartIndex: startRow.rowIndex,
        rowStartPinned: startRow.rowPinned,
        columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
        rowEndIndex: rangeEndRow.rowIndex,
        rowEndPinned: rangeEndRow.rowPinned,
        columnEnd: initialRange.columns[colLen - 1]
      });
    }
    if (finalRange) {
      // raising fill events for undo / redo
      this.raiseFillStartEvent();
      this.handleValueChanged(initialRange, finalRange, e);
      this.rangeService.setCellRanges([finalRange]);
      this.raiseFillEndEvent(initialRange, finalRange);
    }
  };
  FillHandle.prototype.raiseFillStartEvent = function () {
    var fillStartEvent = {
      type: Events.EVENT_FILL_START,
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      api: this.gridOptionsWrapper.getApi()
    };
    this.eventService.dispatchEvent(fillStartEvent);
  };
  FillHandle.prototype.raiseFillEndEvent = function (initialRange, finalRange) {
    var fillEndEvent = {
      type: Events.EVENT_FILL_END,
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      api: this.gridOptionsWrapper.getApi(),
      initialRange: initialRange,
      finalRange: finalRange
    };
    this.eventService.dispatchEvent(fillEndEvent);
  };
  FillHandle.prototype.handleValueChanged = function (initialRange, finalRange, e) {
    var _this = this;
    var initialRangeEndRow = this.rangeService.getRangeEndRow(initialRange);
    var initialRangeStartRow = this.rangeService.getRangeStartRow(initialRange);
    var finalRangeEndRow = this.rangeService.getRangeEndRow(finalRange);
    var finalRangeStartRow = this.rangeService.getRangeStartRow(finalRange);
    var isVertical = this.dragAxis === 'y';
    // if the range is being reduced in size, all we need to do is
    // clear the cells that are no longer part of the range
    if (this.isReduce && !this.gridOptionsWrapper.isSuppressClearOnFillReduction()) {
      var columns = isVertical ? initialRange.columns : initialRange.columns.filter(function (col) {
        return finalRange.columns.indexOf(col) < 0;
      });
      var startRow = isVertical ? this.cellNavigationService.getRowBelow(finalRangeEndRow) : finalRangeStartRow;
      if (startRow) {
        this.clearCellsInRange(startRow, initialRangeEndRow, columns);
      }
      return;
    }
    var withinInitialRange = true;
    var values = [];
    var initialValues = [];
    var idx = 0;
    var resetValues = function resetValues() {
      values.length = 0;
      initialValues.length = 0;
      idx = 0;
    };
    var iterateAcrossCells = function iterateAcrossCells(column, columns) {
      var currentRow = _this.isUp ? initialRangeEndRow : initialRangeStartRow;
      var finished = false;
      if (isVertical) {
        withinInitialRange = true;
        resetValues();
      }
      var _loop_1 = function _loop_1() {
        var rowNode = _this.rowPositionUtils.getRowNode(currentRow);
        if (!rowNode) {
          return "break";
        }
        if (isVertical && column) {
          fillValues(values, column, rowNode, function () {
            return !_this.rowPositionUtils.sameRow(currentRow, _this.isUp ? initialRangeStartRow : initialRangeEndRow);
          });
        } else if (columns) {
          withinInitialRange = true;
          resetValues();
          columns.forEach(function (col) {
            return fillValues(values, col, rowNode, function () {
              return col !== (_this.isLeft ? initialRange.columns[0] : _.last(initialRange.columns));
            });
          });
        }
        finished = _this.rowPositionUtils.sameRow(currentRow, _this.isUp ? finalRangeStartRow : finalRangeEndRow);
        currentRow = _this.isUp ? _this.cellNavigationService.getRowAbove(currentRow) : _this.cellNavigationService.getRowBelow(currentRow);
      };
      while (!finished && currentRow) {
        var state_1 = _loop_1();
        if (state_1 === "break") break;
      }
    };
    var fillValues = function fillValues(currentValues, col, rowNode, updateInitialSet) {
      var currentValue;
      var skipValue = false;
      if (withinInitialRange) {
        currentValue = _this.valueService.getValue(col, rowNode);
        initialValues.push(currentValue);
        withinInitialRange = updateInitialSet();
      } else {
        var _a = _this.processValues(e, currentValues, initialValues, col, rowNode, idx++),
          value = _a.value,
          fromUserFunction = _a.fromUserFunction;
        currentValue = value;
        if (col.isCellEditable(rowNode)) {
          var cellValue = _this.valueService.getValue(col, rowNode);
          if (!fromUserFunction || cellValue !== currentValue) {
            rowNode.setDataValue(col, currentValue);
          } else {
            skipValue = true;
          }
        }
      }
      if (!skipValue) {
        currentValues.push(currentValue);
      }
    };
    if (isVertical) {
      initialRange.columns.forEach(function (col) {
        iterateAcrossCells(col);
      });
    } else {
      var columns = this.isLeft ? __spreadArrays$n(finalRange.columns).reverse() : finalRange.columns;
      iterateAcrossCells(undefined, columns);
    }
  };
  FillHandle.prototype.clearCellsInRange = function (startRow, endRow, columns) {
    var currentRow = startRow;
    var finished = false;
    var _loop_2 = function _loop_2() {
      var rowNode = this_1.rowPositionUtils.getRowNode(currentRow);
      // should never happen, defensive programming
      if (!rowNode) {
        return "break";
      }
      columns.forEach(function (col) {
        if (col.isCellEditable(rowNode)) {
          rowNode.setDataValue(col, null);
        }
      });
      finished = this_1.rowPositionUtils.sameRow(currentRow, endRow);
      currentRow = this_1.cellNavigationService.getRowBelow(currentRow);
    };
    var this_1 = this;
    while (!finished && currentRow) {
      var state_2 = _loop_2();
      if (state_2 === "break") break;
    }
  };
  FillHandle.prototype.processValues = function (event, values, initialValues, col, rowNode, idx) {
    var userFillOperation = this.gridOptionsWrapper.getFillOperation();
    var isVertical = this.dragAxis === 'y';
    var direction;
    if (isVertical) {
      direction = this.isUp ? 'up' : 'down';
    } else {
      direction = this.isLeft ? 'left' : 'right';
    }
    if (userFillOperation) {
      var userResult = userFillOperation({
        event: event,
        values: values,
        initialValues: initialValues,
        currentIndex: idx,
        currentCellValue: this.valueService.getValue(col, rowNode),
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext(),
        direction: direction,
        column: col,
        rowNode: rowNode
      });
      if (userResult !== false) {
        return {
          value: userResult,
          fromUserFunction: true
        };
      }
    }
    var allNumbers = !values.some(function (val) {
      var asFloat = parseFloat(val);
      return isNaN(asFloat) || asFloat.toString() !== val.toString();
    });
    // values should be copied in order if the alt key is pressed
    // or if the values contain strings and numbers
    // However, if we only have one initial value selected, and that
    // value is a number and we are also pressing alt, then we should
    // increment or decrement the value by 1 based on direction.
    if (event.altKey || !allNumbers) {
      if (allNumbers && initialValues.length === 1) {
        var multiplier = this.isUp || this.isLeft ? -1 : 1;
        return {
          value: parseFloat(_.last(values)) + 1 * multiplier,
          fromUserFunction: false
        };
      }
      return {
        value: values[idx % values.length],
        fromUserFunction: false
      };
    }
    return {
      value: _.last(_.findLineByLeastSquares(values.map(Number))),
      fromUserFunction: false
    };
  };
  FillHandle.prototype.clearValues = function () {
    this.clearMarkedPath();
    this.clearCellValues();
    this.lastCellMarked = undefined;
    _super.prototype.clearValues.call(this);
  };
  FillHandle.prototype.clearMarkedPath = function () {
    this.markedCells.forEach(function (cell) {
      var comp = cell.getComp();
      comp.addOrRemoveCssClass('ag-selection-fill-top', false);
      comp.addOrRemoveCssClass('ag-selection-fill-right', false);
      comp.addOrRemoveCssClass('ag-selection-fill-bottom', false);
      comp.addOrRemoveCssClass('ag-selection-fill-left', false);
    });
    this.markedCells.length = 0;
    this.isUp = false;
    this.isLeft = false;
    this.isReduce = false;
  };
  FillHandle.prototype.clearCellValues = function () {
    this.cellValues.length = 0;
  };
  FillHandle.prototype.markPathFrom = function (initialPosition, currentPosition) {
    this.clearMarkedPath();
    this.clearCellValues();
    if (this.dragAxis === 'y') {
      if (this.rowPositionUtils.sameRow(currentPosition, initialPosition)) {
        return;
      }
      var isBefore = this.rowPositionUtils.before(currentPosition, initialPosition);
      var rangeStartRow = this.getRangeStartRow();
      var rangeEndRow = this.getRangeEndRow();
      if (isBefore && (currentPosition.rowPinned == rangeStartRow.rowPinned && currentPosition.rowIndex >= rangeStartRow.rowIndex || rangeStartRow.rowPinned != rangeEndRow.rowPinned && currentPosition.rowPinned == rangeEndRow.rowPinned && currentPosition.rowIndex <= rangeEndRow.rowIndex)) {
        this.reduceVertical(initialPosition, currentPosition);
        this.isReduce = true;
      } else {
        this.extendVertical(initialPosition, currentPosition, isBefore);
        this.isReduce = false;
      }
    } else {
      var initialColumn = initialPosition.column;
      var currentColumn = currentPosition.column;
      if (initialColumn === currentColumn) {
        return;
      }
      var displayedColumns = this.columnModel.getAllDisplayedColumns();
      var initialIndex = displayedColumns.indexOf(initialColumn);
      var currentIndex = displayedColumns.indexOf(currentColumn);
      if (currentIndex <= initialIndex && currentIndex >= displayedColumns.indexOf(this.getCellRange().columns[0])) {
        this.reduceHorizontal(initialPosition, currentPosition);
        this.isReduce = true;
      } else {
        this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
        this.isReduce = false;
      }
    }
    this.lastCellMarked = currentPosition;
  };
  FillHandle.prototype.extendVertical = function (initialPosition, endPosition, isMovingUp) {
    var _a = this,
      navigationService = _a.navigationService,
      rangeService = _a.rangeService;
    var row = initialPosition;
    do {
      var cellRange = this.getCellRange();
      var colLen = cellRange.columns.length;
      for (var i = 0; i < colLen; i++) {
        var column = cellRange.columns[i];
        var rowPos = {
          rowIndex: row.rowIndex,
          rowPinned: row.rowPinned
        };
        var cellPos = __assign$z(__assign$z({}, rowPos), {
          column: column
        });
        var cellInRange = rangeService.isCellInSpecificRange(cellPos, cellRange);
        var isInitialRow = this.rowPositionUtils.sameRow(row, initialPosition);
        if (isMovingUp) {
          this.isUp = true;
        }
        if (!isInitialRow) {
          var cell = navigationService.getCellByPosition(cellPos);
          if (cell) {
            this.markedCells.push(cell);
            var cellCtrl = cell.getComp();
            if (!cellInRange) {
              cellCtrl.addOrRemoveCssClass('ag-selection-fill-left', i === 0);
              cellCtrl.addOrRemoveCssClass('ag-selection-fill-right', i === colLen - 1);
            }
            cellCtrl.addOrRemoveCssClass(isMovingUp ? 'ag-selection-fill-top' : 'ag-selection-fill-bottom', this.rowPositionUtils.sameRow(row, endPosition));
          }
        }
      }
      if (this.rowPositionUtils.sameRow(row, endPosition)) {
        break;
      }
    } while (
    // tslint:disable-next-line
    row = isMovingUp ? this.cellNavigationService.getRowAbove(row) : this.cellNavigationService.getRowBelow(row));
  };
  FillHandle.prototype.reduceVertical = function (initialPosition, endPosition) {
    var row = initialPosition;
    do {
      var cellRange = this.getCellRange();
      var colLen = cellRange.columns.length;
      var isLastRow = this.rowPositionUtils.sameRow(row, endPosition);
      for (var i = 0; i < colLen; i++) {
        var rowPos = {
          rowIndex: row.rowIndex,
          rowPinned: row.rowPinned
        };
        var celPos = __assign$z(__assign$z({}, rowPos), {
          column: cellRange.columns[i]
        });
        var cell = this.navigationService.getCellByPosition(celPos);
        if (cell) {
          this.markedCells.push(cell);
          var cellComp = cell.getComp();
          cellComp.addOrRemoveCssClass('ag-selection-fill-bottom', this.rowPositionUtils.sameRow(row, endPosition));
        }
      }
      if (isLastRow) {
        break;
      }
      // tslint:disable-next-line
    } while (row = this.cellNavigationService.getRowAbove(row));
  };
  FillHandle.prototype.extendHorizontal = function (initialPosition, endPosition, isMovingLeft) {
    var _this = this;
    var allCols = this.columnModel.getAllDisplayedColumns();
    var startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
    var endCol = allCols.indexOf(isMovingLeft ? this.getCellRange().columns[0] : endPosition.column);
    var offset = isMovingLeft ? 0 : 1;
    var colsToMark = allCols.slice(startCol + offset, endCol + offset);
    var rangeStartRow = this.getRangeStartRow();
    var rangeEndRow = this.getRangeEndRow();
    colsToMark.forEach(function (column) {
      var row = rangeStartRow;
      var isLastRow = false;
      do {
        isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
        var cell = _this.navigationService.getCellByPosition({
          rowIndex: row.rowIndex,
          rowPinned: row.rowPinned,
          column: column
        });
        if (cell) {
          _this.markedCells.push(cell);
          var cellComp = cell.getComp();
          cellComp.addOrRemoveCssClass('ag-selection-fill-top', _this.rowPositionUtils.sameRow(row, rangeStartRow));
          cellComp.addOrRemoveCssClass('ag-selection-fill-bottom', _this.rowPositionUtils.sameRow(row, rangeEndRow));
          if (isMovingLeft) {
            _this.isLeft = true;
            cellComp.addOrRemoveCssClass('ag-selection-fill-left', column === colsToMark[0]);
          } else {
            cellComp.addOrRemoveCssClass('ag-selection-fill-right', column === _.last(colsToMark));
          }
        }
        row = _this.cellNavigationService.getRowBelow(row);
      } while (!isLastRow);
    });
  };
  FillHandle.prototype.reduceHorizontal = function (initialPosition, endPosition) {
    var _this = this;
    var allCols = this.columnModel.getAllDisplayedColumns();
    var startCol = allCols.indexOf(endPosition.column);
    var endCol = allCols.indexOf(initialPosition.column);
    var colsToMark = allCols.slice(startCol, endCol);
    var rangeStartRow = this.getRangeStartRow();
    var rangeEndRow = this.getRangeEndRow();
    colsToMark.forEach(function (column) {
      var row = rangeStartRow;
      var isLastRow = false;
      do {
        isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
        var cell = _this.navigationService.getCellByPosition({
          rowIndex: row.rowIndex,
          rowPinned: row.rowPinned,
          column: column
        });
        if (cell) {
          _this.markedCells.push(cell);
          var cellComp = cell.getComp();
          cellComp.addOrRemoveCssClass('ag-selection-fill-right', column === colsToMark[0]);
        }
        row = _this.cellNavigationService.getRowBelow(row);
      } while (!isLastRow);
    });
  };
  FillHandle.prototype.refresh = function (cellCtrl) {
    var cellRange = this.rangeService.getCellRanges()[0];
    var isColumnRange = !cellRange.startRow || !cellRange.endRow;
    if (isColumnRange) {
      this.destroy();
      return;
    }
    _super.prototype.refresh.call(this, cellCtrl);
  };
  FillHandle.TEMPLATE = "<div class=\"ag-fill-handle\"></div>";
  __decorate$3U([Autowired('valueService')], FillHandle.prototype, "valueService", void 0);
  return FillHandle;
}(AbstractSelectionHandle);
var __extends$5p = undefined && undefined.__extends || function () {
  var _extendStatics354 = function extendStatics(d, b) {
    _extendStatics354 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics354(d, b);
  };
  return function (d, b) {
    _extendStatics354(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$A = undefined && undefined.__assign || function () {
  __assign$A = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$A.apply(this, arguments);
};
var RangeHandle$1 = /** @class */function (_super) {
  __extends$5p(RangeHandle, _super);
  function RangeHandle() {
    var _this = _super.call(this, RangeHandle.TEMPLATE) || this;
    _this.type = SelectionHandleType.RANGE;
    _this.rangeFixed = false;
    return _this;
  }
  RangeHandle.prototype.onDrag = function (e) {
    var lastCellHovered = this.getLastCellHovered();
    if (!lastCellHovered) {
      return;
    }
    var cellRanges = this.rangeService.getCellRanges();
    var lastRange = _.last(cellRanges);
    if (!this.rangeFixed) {
      this.fixRangeStartEnd(lastRange);
      this.rangeFixed = true;
    }
    this.endPosition = {
      rowIndex: lastCellHovered.rowIndex,
      rowPinned: lastCellHovered.rowPinned,
      column: lastCellHovered.column
    };
    // check if the cell ranges are for a chart
    if (cellRanges.length === 2 && cellRanges[0].type === CellRangeType.DIMENSION && lastRange.type === CellRangeType.VALUE) {
      var rowChanged = !this.rowPositionUtils.sameRow(this.endPosition, this.rangeService.getRangeEndRow(lastRange));
      if (rowChanged) {
        // ensure the dimension range is kept in sync with the value range (which has the handle)
        this.rangeService.updateRangeEnd(cellRanges[0], __assign$A(__assign$A({}, this.endPosition), {
          column: cellRanges[0].columns[0]
        }), true);
      }
    }
    this.rangeService.extendLatestRangeToCell(this.endPosition);
  };
  RangeHandle.prototype.onDragEnd = function (e) {
    var cellRange = _.last(this.rangeService.getCellRanges());
    this.fixRangeStartEnd(cellRange);
    this.rangeFixed = false;
  };
  RangeHandle.prototype.fixRangeStartEnd = function (cellRange) {
    var startRow = this.rangeService.getRangeStartRow(cellRange);
    var endRow = this.rangeService.getRangeEndRow(cellRange);
    var column = cellRange.columns[0];
    cellRange.startRow = startRow;
    cellRange.endRow = endRow;
    cellRange.startColumn = column;
  };
  RangeHandle.TEMPLATE = "<div class=\"ag-range-handle\"></div>";
  return RangeHandle;
}(AbstractSelectionHandle);
var __extends$5q = undefined && undefined.__extends || function () {
  var _extendStatics355 = function extendStatics(d, b) {
    _extendStatics355 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics355(d, b);
  };
  return function (d, b) {
    _extendStatics355(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3V = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SelectionHandleFactory = /** @class */function (_super) {
  __extends$5q(SelectionHandleFactory, _super);
  function SelectionHandleFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SelectionHandleFactory.prototype.createSelectionHandle = function (type) {
    return this.createBean(type === SelectionHandleType.RANGE ? new RangeHandle$1() : new FillHandle());
  };
  SelectionHandleFactory = __decorate$3V([Bean('selectionHandleFactory')], SelectionHandleFactory);
  return SelectionHandleFactory;
}(BeanStub);
var RangeSelectionModule = {
  moduleName: ModuleNames.RangeSelectionModule,
  beans: [RangeService, SelectionHandleFactory],
  agStackComponents: [{
    componentName: 'AgFillHandle',
    componentClass: FillHandle
  }, {
    componentName: 'AgRangeHandle',
    componentClass: RangeHandle$1
  }],
  dependantModules: [EnterpriseCoreModule]
};
var GridChartsModule = {
  moduleName: ModuleNames.GridChartsModule,
  beans: [ChartService, ChartTranslator, ChartCrossFilter],
  dependantModules: [RangeSelectionModule, EnterpriseCoreModule]
};
var __extends$5r = undefined && undefined.__extends || function () {
  var _extendStatics356 = function extendStatics(d, b) {
    _extendStatics356 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics356(d, b);
  };
  return function (d, b) {
    _extendStatics356(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$B = undefined && undefined.__assign || function () {
  __assign$B = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$B.apply(this, arguments);
};
var __decorate$3W = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DetailCellRendererCtrl = /** @class */function (_super) {
  __extends$5r(DetailCellRendererCtrl, _super);
  function DetailCellRendererCtrl() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.loadRowDataVersion = 0;
    _this.needRefresh = false;
    return _this;
  }
  DetailCellRendererCtrl.prototype.init = function (comp, params) {
    var _this = this;
    this.params = params;
    this.comp = comp;
    var doNothingBecauseInsidePinnedSection = params.pinned != null;
    if (doNothingBecauseInsidePinnedSection) {
      return;
    }
    this.setAutoHeightClasses();
    this.checkForDeprecations();
    this.ensureValidRefreshStrategy();
    this.addThemeToDetailGrid();
    this.createDetailGrid();
    this.loadRowData();
    this.addManagedListener(params.node.parent, RowNode.EVENT_DATA_CHANGED, function () {
      _this.needRefresh = true;
    });
  };
  DetailCellRendererCtrl.prototype.setAutoHeightClasses = function () {
    var autoHeight = this.gridOptionsWrapper.isDetailRowAutoHeight();
    var parentClass = autoHeight ? 'ag-details-row-auto-height' : 'ag-details-row-fixed-height';
    var detailClass = autoHeight ? 'ag-details-grid-auto-height' : 'ag-details-grid-fixed-height';
    this.comp.addOrRemoveCssClass(parentClass, true);
    this.comp.addOrRemoveDetailGridCssClass(detailClass, true);
  };
  DetailCellRendererCtrl.prototype.checkForDeprecations = function () {
    if (this.params.suppressRefresh) {
      console.warn("AG Grid: as of v23.2.0, cellRendererParams.suppressRefresh for Detail Cell Renderer is no " + "longer used. Please set cellRendererParams.refreshStrategy = 'nothing' instead.");
      this.params.refreshStrategy = 'nothing';
    }
  };
  DetailCellRendererCtrl.prototype.ensureValidRefreshStrategy = function () {
    switch (this.params.refreshStrategy) {
      case 'rows':
      case 'nothing':
      case 'everything':
        return;
    }
    // check for incorrectly supplied refresh strategy
    if (this.params.refreshStrategy) {
      console.warn("AG Grid: invalid cellRendererParams.refreshStrategy = '" + this.params.refreshStrategy + "' supplied, defaulting to refreshStrategy = 'rows'.");
    }
    // use default strategy
    this.params.refreshStrategy = 'rows';
  };
  DetailCellRendererCtrl.prototype.addThemeToDetailGrid = function () {
    // this is needed by environment service of the child grid, the class needs to be on
    // the grid div itself - the browser's CSS on the other hand just inherits from the parent grid theme.
    var theme = this.environment.getTheme().theme;
    if (theme) {
      this.comp.addOrRemoveDetailGridCssClass(theme, true);
    }
  };
  DetailCellRendererCtrl.prototype.createDetailGrid = function () {
    if (_.missing(this.params.detailGridOptions)) {
      console.warn('AG Grid: could not find detail grid options for master detail, ' + 'please set gridOptions.detailCellRendererParams.detailGridOptions');
      return;
    }
    var autoHeight = this.gridOptionsWrapper.isDetailRowAutoHeight();
    // we clone the detail grid options, as otherwise it would be shared
    // across many instances, and that would be a problem because we set
    // api and columnApi into gridOptions
    var gridOptions = __assign$B({}, this.params.detailGridOptions);
    if (autoHeight) {
      gridOptions.domLayout = 'autoHeight';
    }
    this.comp.setDetailGrid(gridOptions);
  };
  DetailCellRendererCtrl.prototype.registerDetailWithMaster = function (api, columnApi) {
    var rowId = this.params.node.id;
    var masterGridApi = this.params.api;
    var gridInfo = {
      id: rowId,
      api: api,
      columnApi: columnApi
    };
    var rowNode = this.params.node;
    // register with api
    masterGridApi.addDetailGridInfo(rowId, gridInfo);
    // register with node
    rowNode.detailGridInfo = gridInfo;
    this.addDestroyFunc(function () {
      masterGridApi.removeDetailGridInfo(rowId); // unregister from api
      rowNode.detailGridInfo = null; // unregister from node
    });
  };

  DetailCellRendererCtrl.prototype.loadRowData = function () {
    var _this = this;
    // in case a refresh happens before the last refresh completes (as we depend on async
    // application logic) we keep track on what the latest call was.
    this.loadRowDataVersion++;
    var versionThisCall = this.loadRowDataVersion;
    var userFunc = this.params.getDetailRowData;
    if (!userFunc) {
      console.warn('AG Grid: could not find getDetailRowData for master / detail, ' + 'please set gridOptions.detailCellRendererParams.getDetailRowData');
      return;
    }
    var successCallback = function successCallback(rowData) {
      var mostRecentCall = _this.loadRowDataVersion === versionThisCall;
      if (mostRecentCall) {
        _this.comp.setRowData(rowData);
      }
    };
    var funcParams = {
      node: this.params.node,
      // we take data from node, rather than params.data
      // as the data could have been updated with new instance
      data: this.params.node.data,
      successCallback: successCallback,
      context: this.gridOptionsWrapper.getContext()
    };
    userFunc(funcParams);
  };
  DetailCellRendererCtrl.prototype.refresh = function () {
    var GET_GRID_TO_REFRESH = false;
    var GET_GRID_TO_DO_NOTHING = true;
    // if we return true, it means we pretend to the grid
    // that we have refreshed, so refresh will never happen.
    var doNotRefresh = !this.needRefresh || this.params.refreshStrategy === 'nothing';
    if (doNotRefresh) {
      // we do nothing in this refresh method, and also tell the grid to do nothing
      return GET_GRID_TO_DO_NOTHING;
    }
    // reset flag, so don't refresh again until more data changes.
    this.needRefresh = false;
    if (this.params.refreshStrategy === 'everything') {
      // we want full refresh, so tell the grid to destroy and recreate this cell
      return GET_GRID_TO_REFRESH;
    } else {
      // do the refresh here, and tell the grid to do nothing
      this.loadRowData();
      return GET_GRID_TO_DO_NOTHING;
    }
  };
  __decorate$3W([Autowired('environment')], DetailCellRendererCtrl.prototype, "environment", void 0);
  return DetailCellRendererCtrl;
}(BeanStub);
var __extends$5s = undefined && undefined.__extends || function () {
  var _extendStatics357 = function extendStatics(d, b) {
    _extendStatics357 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics357(d, b);
  };
  return function (d, b) {
    _extendStatics357(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3X = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DetailCellRenderer = /** @class */function (_super) {
  __extends$5s(DetailCellRenderer, _super);
  function DetailCellRenderer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DetailCellRenderer.prototype.init = function (params) {
    var _this = this;
    this.params = params;
    this.selectAndSetTemplate();
    var compProxy = {
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      addOrRemoveDetailGridCssClass: function addOrRemoveDetailGridCssClass(cssClassName, on) {
        return _.addOrRemoveCssClass(_this.eDetailGrid, cssClassName, on);
      },
      setDetailGrid: function setDetailGrid(gridOptions) {
        return _this.setDetailGrid(gridOptions);
      },
      setRowData: function setRowData(rowData) {
        return _this.setRowData(rowData);
      }
    };
    this.ctrl = this.createManagedBean(new DetailCellRendererCtrl());
    this.ctrl.init(compProxy, params);
  };
  DetailCellRenderer.prototype.refresh = function () {
    return this.ctrl && this.ctrl.refresh();
  };
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  DetailCellRenderer.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  DetailCellRenderer.prototype.selectAndSetTemplate = function () {
    var _this = this;
    if (this.params.pinned) {
      this.setTemplate('<div class="ag-details-row"></div>');
      return;
    }
    var setDefaultTemplate = function setDefaultTemplate() {
      _this.setTemplate(DetailCellRenderer.TEMPLATE);
    };
    if (_.missing(this.params.template)) {
      // use default template
      setDefaultTemplate();
    } else {
      // use user provided template
      if (typeof this.params.template === 'string') {
        this.setTemplate(this.params.template);
      } else if (typeof this.params.template === 'function') {
        var templateFunc = this.params.template;
        var template = templateFunc(this.params);
        this.setTemplate(template);
      } else {
        console.warn('AG Grid: detailCellRendererParams.template should be function or string');
        setDefaultTemplate();
      }
    }
    if (this.eDetailGrid == null) {
      console.warn('AG Grid: reference to eDetailGrid was missing from the details template. ' + 'Please add ref="eDetailGrid" to the template.');
    }
  };
  DetailCellRenderer.prototype.setDetailGrid = function (gridOptions) {
    if (!this.eDetailGrid) {
      return;
    }
    // AG-1715
    // this is only needed when reactUi=false, once we remove the old way
    // of doing react, and Master / Details is all native React, then we
    // can remove this code.
    var agGridReact = this.context.getBean('agGridReact');
    var agGridReactCloned = agGridReact ? _.cloneObject(agGridReact) : undefined;
    // when we create detail grid, the detail grid needs frameworkComponentWrapper so that
    // it created child components correctly, ie  Angular detail grid can have Angular cell renderer.
    // this is only used by Angular and Vue, as React uses native React AG Grid detail grids
    var frameworkComponentWrapper = this.context.getBean('frameworkComponentWrapper');
    // tslint:disable-next-line
    new Grid(this.eDetailGrid, gridOptions, {
      $scope: this.params.$scope,
      $compile: this.params.$compile,
      providedBeanInstances: {
        agGridReact: agGridReactCloned,
        frameworkComponentWrapper: frameworkComponentWrapper
      }
    });
    this.detailApi = gridOptions.api;
    this.ctrl.registerDetailWithMaster(gridOptions.api, gridOptions.columnApi);
    this.addDestroyFunc(function () {
      if (gridOptions.api) {
        gridOptions.api.destroy();
      }
    });
  };
  DetailCellRenderer.prototype.setRowData = function (rowData) {
    // ensure detail grid api still exists (grid may be destroyed when async call tries to set data)
    this.detailApi && this.detailApi.setRowData(rowData);
  };
  DetailCellRenderer.TEMPLATE = "<div class=\"ag-details-row\">\n            <div ref=\"eDetailGrid\" class=\"ag-details-grid\"></div>\n        </div>";
  __decorate$3X([RefSelector('eDetailGrid')], DetailCellRenderer.prototype, "eDetailGrid", void 0);
  return DetailCellRenderer;
}(Component);
var MasterDetailModule = {
  moduleName: ModuleNames.MasterDetailModule,
  beans: [],
  userComponents: [{
    componentName: 'agDetailCellRenderer',
    componentClass: DetailCellRenderer
  }],
  controllers: [{
    controllerName: 'detailCellRenderer',
    controllerClass: DetailCellRendererCtrl
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5t = undefined && undefined.__extends || function () {
  var _extendStatics358 = function extendStatics(d, b) {
    _extendStatics358 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics358(d, b);
  };
  return function (d, b) {
    _extendStatics358(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3Y = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MenuPanel = /** @class */function (_super) {
  __extends$5t(MenuPanel, _super);
  function MenuPanel(wrappedComponent) {
    var _this = _super.call(this) || this;
    _this.wrappedComponent = wrappedComponent;
    _this.setTemplateFromElement(wrappedComponent.getGui());
    return _this;
  }
  MenuPanel.prototype.postConstruct = function () {
    var _this = this;
    this.initialiseTabGuard({
      onTabKeyDown: function onTabKeyDown(e) {
        return _this.onTabKeyDown(e);
      },
      handleKeyDown: function handleKeyDown(e) {
        return _this.handleKeyDown(e);
      }
    });
  };
  MenuPanel.prototype.handleKeyDown = function (e) {
    if (e.keyCode === KeyCode.ESCAPE) {
      this.closePanel();
    }
  };
  MenuPanel.prototype.onTabKeyDown = function (e) {
    if (e.defaultPrevented) {
      return;
    }
    this.closePanel();
    e.preventDefault();
  };
  MenuPanel.prototype.closePanel = function () {
    var menuItem = this.parentComponent;
    menuItem.closeSubMenu();
    setTimeout(function () {
      return menuItem.getGui().focus();
    }, 0);
  };
  __decorate$3Y([PostConstruct], MenuPanel.prototype, "postConstruct", null);
  return MenuPanel;
}(TabGuardComp);
var __extends$5u = undefined && undefined.__extends || function () {
  var _extendStatics359 = function extendStatics(d, b) {
    _extendStatics359 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics359(d, b);
  };
  return function (d, b) {
    _extendStatics359(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3Z = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MenuItemComponent = /** @class */function (_super) {
  __extends$5u(MenuItemComponent, _super);
  function MenuItemComponent(params) {
    var _this = _super.call(this) || this;
    _this.params = params;
    _this.isActive = false;
    _this.subMenuIsOpen = false;
    _this.setTemplate( /* html */"<div class=\"" + _this.getClassName() + "\" tabindex=\"-1\" role=\"treeitem\"></div>");
    return _this;
  }
  MenuItemComponent.prototype.init = function () {
    var _this = this;
    this.addIcon();
    this.addName();
    this.addShortcut();
    this.addSubMenu();
    this.addTooltip();
    var eGui = this.getGui();
    if (this.params.disabled) {
      this.addCssClass(this.getClassName('disabled'));
      _.setAriaDisabled(eGui, true);
    } else {
      this.addGuiEventListener('click', function (e) {
        return _this.onItemSelected(e);
      });
      this.addGuiEventListener('keydown', function (e) {
        if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
          e.preventDefault();
          _this.onItemSelected(e);
        }
      });
      this.addGuiEventListener('mousedown', function (e) {
        // Prevent event bubbling to other event handlers such as PopupService triggering
        // premature closing of any open sub-menu popup.
        e.stopPropagation();
        e.preventDefault();
      });
      this.addGuiEventListener('mouseenter', function () {
        return _this.onMouseEnter();
      });
      this.addGuiEventListener('mouseleave', function () {
        return _this.onMouseLeave();
      });
    }
    if (this.params.cssClasses) {
      this.params.cssClasses.forEach(function (it) {
        return _.addCssClass(eGui, it);
      });
    }
  };
  MenuItemComponent.prototype.isDisabled = function () {
    return !!this.params.disabled;
  };
  MenuItemComponent.prototype.openSubMenu = function (activateFirstItem) {
    var _this = this;
    if (activateFirstItem === void 0) {
      activateFirstItem = false;
    }
    this.closeSubMenu();
    if (!this.params.subMenu) {
      return;
    }
    var ePopup = _.loadTemplate( /* html */"<div class=\"ag-menu\" role=\"presentation\"></div>");
    var destroySubMenu;
    if (this.params.subMenu instanceof Array) {
      var currentLevel = _.getAriaLevel(this.getGui());
      var nextLevel = isNaN(currentLevel) ? 1 : currentLevel + 1;
      var childMenu_1 = this.createBean(new MenuList(nextLevel));
      childMenu_1.setParentComponent(this);
      childMenu_1.addMenuItems(this.params.subMenu);
      ePopup.appendChild(childMenu_1.getGui());
      // bubble menu item selected events
      this.addManagedListener(childMenu_1, MenuItemComponent.EVENT_MENU_ITEM_SELECTED, function (e) {
        return _this.dispatchEvent(e);
      });
      childMenu_1.addGuiEventListener('mouseenter', function () {
        return _this.cancelDeactivate();
      });
      destroySubMenu = function destroySubMenu() {
        return _this.destroyBean(childMenu_1);
      };
      if (activateFirstItem) {
        setTimeout(function () {
          return childMenu_1.activateFirstItem();
        }, 0);
      }
    } else {
      var subMenu_1 = this.params.subMenu;
      var menuPanel = this.createBean(new MenuPanel(subMenu_1));
      menuPanel.setParentComponent(this);
      var subMenuGui_1 = menuPanel.getGui();
      var mouseEvent_1 = 'mouseenter';
      var mouseEnterListener_1 = function mouseEnterListener_1() {
        return _this.cancelDeactivate();
      };
      subMenuGui_1.addEventListener(mouseEvent_1, mouseEnterListener_1);
      destroySubMenu = function destroySubMenu() {
        return subMenuGui_1.removeEventListener(mouseEvent_1, mouseEnterListener_1);
      };
      ePopup.appendChild(subMenuGui_1);
      if (subMenu_1.afterGuiAttached) {
        setTimeout(function () {
          return subMenu_1.afterGuiAttached();
        }, 0);
      }
    }
    var eGui = this.getGui();
    var positionCallback = this.popupService.positionPopupForMenu.bind(this.popupService, {
      eventSource: eGui,
      ePopup: ePopup
    });
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: ePopup,
      positionCallback: positionCallback,
      anchorToElement: eGui,
      ariaLabel: translate('ariaLabelSubMenu', 'SubMenu')
    });
    this.subMenuIsOpen = true;
    _.setAriaExpanded(eGui, true);
    this.hideSubMenu = function () {
      if (addPopupRes) {
        addPopupRes.hideFunc();
      }
      _this.subMenuIsOpen = false;
      _.setAriaExpanded(eGui, false);
      destroySubMenu();
    };
  };
  MenuItemComponent.prototype.closeSubMenu = function () {
    if (!this.hideSubMenu) {
      return;
    }
    this.hideSubMenu();
    this.hideSubMenu = null;
    _.setAriaExpanded(this.getGui(), false);
  };
  MenuItemComponent.prototype.isSubMenuOpen = function () {
    return this.subMenuIsOpen;
  };
  MenuItemComponent.prototype.activate = function (openSubMenu) {
    var _this = this;
    this.cancelActivate();
    if (this.params.disabled) {
      return;
    }
    this.isActive = true;
    this.addCssClass(this.getClassName('active'));
    this.getGui().focus();
    if (openSubMenu && this.params.subMenu) {
      window.setTimeout(function () {
        if (_this.isAlive() && _this.isActive) {
          _this.openSubMenu();
        }
      }, 300);
    }
    this.onItemActivated();
  };
  MenuItemComponent.prototype.deactivate = function () {
    this.cancelDeactivate();
    this.removeCssClass(this.getClassName('active'));
    this.isActive = false;
    if (this.subMenuIsOpen) {
      this.hideSubMenu();
    }
  };
  MenuItemComponent.prototype.addIcon = function () {
    if (!this.params.checked && !this.params.icon && this.params.isCompact) {
      return;
    }
    var icon = _.loadTemplate( /* html */"<span ref=\"eIcon\" class=\"" + this.getClassName('part') + " " + this.getClassName('icon') + "\" role=\"presentation\"></span>");
    if (this.params.checked) {
      icon.appendChild(_.createIconNoSpan('check', this.gridOptionsWrapper));
    } else if (this.params.icon) {
      if (_.isNodeOrElement(this.params.icon)) {
        icon.appendChild(this.params.icon);
      } else if (typeof this.params.icon === 'string') {
        icon.innerHTML = this.params.icon;
      } else {
        console.warn('AG Grid: menu item icon must be DOM node or string');
      }
    }
    this.getGui().appendChild(icon);
  };
  MenuItemComponent.prototype.addName = function () {
    if (!this.params.name && this.params.isCompact) {
      return;
    }
    var name = _.loadTemplate( /* html */"<span ref=\"eName\" class=\"" + this.getClassName('part') + " " + this.getClassName('text') + "\">" + (this.params.name || '') + "</span>");
    this.getGui().appendChild(name);
  };
  MenuItemComponent.prototype.addTooltip = function () {
    if (!this.params.tooltip) {
      return;
    }
    this.tooltip = this.params.tooltip;
    if (this.gridOptionsWrapper.isEnableBrowserTooltips()) {
      this.getGui().setAttribute('title', this.tooltip);
    } else {
      this.createManagedBean(new CustomTooltipFeature(this));
    }
  };
  MenuItemComponent.prototype.getTooltipParams = function () {
    return {
      location: 'menu',
      value: this.tooltip
    };
  };
  MenuItemComponent.prototype.addShortcut = function () {
    if (!this.params.shortcut && this.params.isCompact) {
      return;
    }
    var shortcut = _.loadTemplate( /* html */"<span ref=\"eShortcut\" class=\"" + this.getClassName('part') + " " + this.getClassName('shortcut') + "\">" + (this.params.shortcut || '') + "</span>");
    this.getGui().appendChild(shortcut);
  };
  MenuItemComponent.prototype.addSubMenu = function () {
    if (!this.params.subMenu && this.params.isCompact) {
      return;
    }
    var pointer = _.loadTemplate( /* html */"<span ref=\"ePopupPointer\" class=\"" + this.getClassName('part') + " " + this.getClassName('popup-pointer') + "\"></span>");
    var eGui = this.getGui();
    if (this.params.subMenu) {
      var iconName = this.gridOptionsWrapper.isEnableRtl() ? 'smallLeft' : 'smallRight';
      _.setAriaExpanded(eGui, false);
      pointer.appendChild(_.createIconNoSpan(iconName, this.gridOptionsWrapper));
    }
    eGui.appendChild(pointer);
  };
  MenuItemComponent.prototype.onItemSelected = function (event) {
    if (this.params.action) {
      this.params.action();
    } else {
      this.openSubMenu(event && event.type === 'keydown');
    }
    if (this.params.subMenu && !this.params.action) {
      return;
    }
    var e = {
      type: MenuItemComponent.EVENT_MENU_ITEM_SELECTED,
      action: this.params.action,
      checked: this.params.checked,
      cssClasses: this.params.cssClasses,
      disabled: this.params.disabled,
      icon: this.params.icon,
      name: this.params.name,
      shortcut: this.params.shortcut,
      subMenu: this.params.subMenu,
      tooltip: this.params.tooltip,
      event: event
    };
    this.dispatchEvent(e);
  };
  MenuItemComponent.prototype.onItemActivated = function () {
    var event = {
      type: MenuItemComponent.EVENT_MENU_ITEM_ACTIVATED,
      menuItem: this
    };
    this.dispatchEvent(event);
  };
  MenuItemComponent.prototype.cancelActivate = function () {
    if (this.activateTimeoutId) {
      window.clearTimeout(this.activateTimeoutId);
      this.activateTimeoutId = 0;
    }
  };
  MenuItemComponent.prototype.cancelDeactivate = function () {
    if (this.deactivateTimeoutId) {
      window.clearTimeout(this.deactivateTimeoutId);
      this.deactivateTimeoutId = 0;
    }
  };
  MenuItemComponent.prototype.onMouseEnter = function () {
    var _this = this;
    this.cancelDeactivate();
    if (this.params.isAnotherSubMenuOpen()) {
      // wait to see if the user enters the open sub-menu
      this.activateTimeoutId = window.setTimeout(function () {
        return _this.activate(true);
      }, MenuItemComponent.ACTIVATION_DELAY);
    } else {
      // activate immediately
      this.activate(true);
    }
  };
  MenuItemComponent.prototype.onMouseLeave = function () {
    var _this = this;
    this.cancelActivate();
    if (this.isSubMenuOpen()) {
      // wait to see if the user enters the sub-menu
      this.deactivateTimeoutId = window.setTimeout(function () {
        return _this.deactivate();
      }, MenuItemComponent.ACTIVATION_DELAY);
    } else {
      // de-activate immediately
      this.deactivate();
    }
  };
  MenuItemComponent.prototype.getClassName = function (suffix) {
    var prefix = this.params.isCompact ? 'ag-compact-menu-option' : 'ag-menu-option';
    return suffix ? prefix + "-" + suffix : prefix;
  };
  MenuItemComponent.EVENT_MENU_ITEM_SELECTED = 'menuItemSelected';
  MenuItemComponent.EVENT_MENU_ITEM_ACTIVATED = 'menuItemActivated';
  MenuItemComponent.ACTIVATION_DELAY = 80;
  __decorate$3Z([Autowired('popupService')], MenuItemComponent.prototype, "popupService", void 0);
  __decorate$3Z([PostConstruct], MenuItemComponent.prototype, "init", null);
  return MenuItemComponent;
}(Component);
var __extends$5v = undefined && undefined.__extends || function () {
  var _extendStatics360 = function extendStatics(d, b) {
    _extendStatics360 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics360(d, b);
  };
  return function (d, b) {
    _extendStatics360(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$C = undefined && undefined.__assign || function () {
  __assign$C = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$C.apply(this, arguments);
};
var __decorate$3_ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MenuList = /** @class */function (_super) {
  __extends$5v(MenuList, _super);
  function MenuList(level) {
    if (level === void 0) {
      level = 1;
    }
    var _this = _super.call(this, /* html */"<div class=\"ag-menu-list\" role=\"tree\"></div>") || this;
    _this.level = level;
    _this.menuItems = [];
    return _this;
  }
  MenuList.prototype.postConstruct = function () {
    var _this = this;
    this.initialiseTabGuard({
      onTabKeyDown: function onTabKeyDown(e) {
        return _this.onTabKeyDown(e);
      },
      handleKeyDown: function handleKeyDown(e) {
        return _this.handleKeyDown(e);
      }
    });
  };
  MenuList.prototype.onTabKeyDown = function (e) {
    var parent = this.getParentComponent();
    var parentGui = parent && parent.getGui();
    var isManaged = parentGui && _.containsClass(parentGui, 'ag-focus-managed');
    if (!isManaged) {
      e.preventDefault();
    }
    if (e.shiftKey) {
      this.closeIfIsChild(e);
    }
  };
  MenuList.prototype.handleKeyDown = function (e) {
    switch (e.keyCode) {
      case KeyCode.UP:
      case KeyCode.RIGHT:
      case KeyCode.DOWN:
      case KeyCode.LEFT:
        e.preventDefault();
        this.handleNavKey(e.keyCode);
        break;
      case KeyCode.ESCAPE:
        var topMenu = this.findTopMenu();
        if (topMenu) {
          this.focusService.focusInto(topMenu.getGui());
        }
        break;
    }
  };
  MenuList.prototype.clearActiveItem = function () {
    if (this.activeMenuItem) {
      this.activeMenuItem.deactivate();
      this.activeMenuItem = null;
    }
  };
  MenuList.prototype.addMenuItems = function (menuItems) {
    var _this = this;
    if (menuItems == null) {
      return;
    }
    menuItems.forEach(function (menuItemOrString) {
      if (menuItemOrString === 'separator') {
        _this.addSeparator();
      } else if (typeof menuItemOrString === 'string') {
        console.warn("AG Grid: unrecognised menu item " + menuItemOrString);
      } else {
        _this.addItem(menuItemOrString);
      }
    });
  };
  MenuList.prototype.addItem = function (menuItemDef) {
    var _this = this;
    var menuItem = this.createManagedBean(new MenuItemComponent(__assign$C(__assign$C({}, menuItemDef), {
      isAnotherSubMenuOpen: function isAnotherSubMenuOpen() {
        return _.some(_this.menuItems, function (m) {
          return m.isSubMenuOpen();
        });
      }
    })));
    menuItem.setParentComponent(this);
    _.setAriaLevel(menuItem.getGui(), this.level);
    this.menuItems.push(menuItem);
    this.appendChild(menuItem.getGui());
    this.addManagedListener(menuItem, MenuItemComponent.EVENT_MENU_ITEM_SELECTED, function (event) {
      _this.dispatchEvent(event);
    });
    this.addManagedListener(menuItem, MenuItemComponent.EVENT_MENU_ITEM_ACTIVATED, function (event) {
      if (_this.activeMenuItem && _this.activeMenuItem !== event.menuItem) {
        _this.activeMenuItem.deactivate();
      }
      _this.activeMenuItem = event.menuItem;
    });
  };
  MenuList.prototype.activateFirstItem = function () {
    var item = this.menuItems.filter(function (currentItem) {
      return !currentItem.isDisabled();
    })[0];
    if (!item) {
      return;
    }
    item.activate();
  };
  MenuList.prototype.addSeparator = function () {
    var separatorHtml = /* html */"\n            <div class=\"ag-menu-separator\" aria-hidden=\"true\">\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n                <div class=\"ag-menu-separator-part\"></div>\n            </div>";
    this.appendChild(_.loadTemplate(separatorHtml));
  };
  MenuList.prototype.findTopMenu = function () {
    var parent = this.getParentComponent();
    if (!parent && this instanceof MenuList) {
      return this;
    }
    while (true) {
      var nextParent = parent && parent.getParentComponent && parent.getParentComponent();
      if (!nextParent || !(nextParent instanceof MenuList || nextParent instanceof MenuItemComponent)) {
        break;
      }
      parent = nextParent;
    }
    return parent instanceof MenuList ? parent : undefined;
  };
  MenuList.prototype.handleNavKey = function (key) {
    switch (key) {
      case KeyCode.UP:
      case KeyCode.DOWN:
        var nextItem = this.findNextItem(key === KeyCode.UP);
        if (nextItem && nextItem !== this.activeMenuItem) {
          nextItem.activate();
        }
        return;
    }
    var left = this.gridOptionsWrapper.isEnableRtl() ? KeyCode.RIGHT : KeyCode.LEFT;
    if (key === left) {
      this.closeIfIsChild();
    } else {
      this.openChild();
    }
  };
  MenuList.prototype.closeIfIsChild = function (e) {
    var parentItem = this.getParentComponent();
    if (parentItem && parentItem instanceof MenuItemComponent) {
      if (e) {
        e.preventDefault();
      }
      parentItem.closeSubMenu();
      parentItem.getGui().focus();
    }
  };
  MenuList.prototype.openChild = function () {
    if (this.activeMenuItem) {
      this.activeMenuItem.openSubMenu(true);
    }
  };
  MenuList.prototype.findNextItem = function (up) {
    var items = this.menuItems.filter(function (item) {
      return !item.isDisabled();
    });
    if (!items.length) {
      return;
    }
    if (!this.activeMenuItem) {
      return up ? _.last(items) : items[0];
    }
    if (up) {
      items.reverse();
    }
    var nextItem;
    var foundCurrent = false;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!foundCurrent) {
        if (item === this.activeMenuItem) {
          foundCurrent = true;
        }
        continue;
      }
      nextItem = item;
      break;
    }
    return nextItem || this.activeMenuItem;
  };
  MenuList.prototype.destroy = function () {
    this.clearActiveItem();
    _super.prototype.destroy.call(this);
  };
  __decorate$3_([Autowired('focusService')], MenuList.prototype, "focusService", void 0);
  __decorate$3_([PostConstruct], MenuList.prototype, "postConstruct", null);
  return MenuList;
}(TabGuardComp);
var __extends$5w = undefined && undefined.__extends || function () {
  var _extendStatics361 = function extendStatics(d, b) {
    _extendStatics361 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics361(d, b);
  };
  return function (d, b) {
    _extendStatics361(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$3$ = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EnterpriseMenuFactory = /** @class */function (_super) {
  __extends$5w(EnterpriseMenuFactory, _super);
  function EnterpriseMenuFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  EnterpriseMenuFactory.prototype.hideActiveMenu = function () {
    this.destroyBean(this.activeMenu);
  };
  EnterpriseMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent, defaultTab) {
    var _this = this;
    this.showMenu(column, function (menu) {
      var ePopup = menu.getGui();
      _this.popupService.positionPopupUnderMouseEvent({
        type: 'columnMenu',
        column: column,
        mouseEvent: mouseEvent,
        ePopup: ePopup
      });
      if (defaultTab) {
        menu.showTab(defaultTab);
      }
    }, 'columnMenu', defaultTab, undefined, mouseEvent.target);
  };
  EnterpriseMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource, containerType, defaultTab, restrictToTabs) {
    var _this = this;
    var multiplier = -1;
    var alignSide = 'left';
    if (this.gridOptionsWrapper.isEnableRtl()) {
      multiplier = 1;
      alignSide = 'right';
    }
    this.showMenu(column, function (menu) {
      var ePopup = menu.getGui();
      _this.popupService.positionPopupUnderComponent({
        type: containerType,
        column: column,
        eventSource: eventSource,
        ePopup: ePopup,
        alignSide: alignSide,
        nudgeX: 9 * multiplier,
        nudgeY: -23,
        keepWithinBounds: true
      });
      if (defaultTab) {
        menu.showTab(defaultTab);
      }
    }, containerType, defaultTab, restrictToTabs, eventSource);
  };
  EnterpriseMenuFactory.prototype.showMenu = function (column, _positionCallback2, containerType, defaultTab, restrictToTabs, eventSource) {
    var _this = this;
    var menu = this.createBean(new EnterpriseMenu(column, this.lastSelectedTab, restrictToTabs));
    var eMenuGui = menu.getGui();
    var anchorToElement = eventSource || this.ctrlsService.getGridBodyCtrl().getGui();
    var closedFuncs = [];
    closedFuncs.push(function (e) {
      _this.destroyBean(menu);
      column.setMenuVisible(false, 'contextMenu');
      var isKeyboardEvent = e instanceof KeyboardEvent;
      if (isKeyboardEvent && eventSource && _.isVisible(eventSource)) {
        var focusableEl = _this.focusService.findTabbableParent(eventSource);
        if (focusableEl) {
          focusableEl.focus();
        }
      }
    });
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    // need to show filter before positioning, as only after filter
    // is visible can we find out what the width of it is
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: eMenuGui,
      closeOnEsc: true,
      closedCallback: function closedCallback(e) {
        closedFuncs.forEach(function (f) {
          return f(e);
        });
      },
      afterGuiAttached: function afterGuiAttached(params) {
        return menu.afterGuiAttached(_.assign({}, {
          container: containerType
        }, params));
      },
      positionCallback: function positionCallback() {
        return _positionCallback2(menu);
      },
      anchorToElement: anchorToElement,
      ariaLabel: translate('ariaLabelColumnMenu', 'Column Menu')
    });
    if (addPopupRes) {
      // if user starts showing / hiding columns, or otherwise move the underlying column
      // for this menu, we want to stop tracking the menu with the column position. otherwise
      // the menu would move as the user is using the columns tab inside the menu.
      var stopAnchoringPromise = addPopupRes.stopAnchoringPromise;
      if (stopAnchoringPromise) {
        stopAnchoringPromise.then(function (stopAnchoringFunc) {
          column.addEventListener(Column.EVENT_LEFT_CHANGED, stopAnchoringFunc);
          column.addEventListener(Column.EVENT_VISIBLE_CHANGED, stopAnchoringFunc);
          closedFuncs.push(function () {
            column.removeEventListener(Column.EVENT_LEFT_CHANGED, stopAnchoringFunc);
            column.removeEventListener(Column.EVENT_VISIBLE_CHANGED, stopAnchoringFunc);
          });
        });
      }
    }
    if (!defaultTab) {
      menu.showTabBasedOnPreviousSelection();
      // reposition the menu because the method above could load
      // an element that is bigger than enterpriseMenu header.
      _positionCallback2(menu);
    }
    menu.addEventListener(EnterpriseMenu.EVENT_TAB_SELECTED, function (event) {
      _this.lastSelectedTab = event.key;
    });
    column.setMenuVisible(true, 'contextMenu');
    this.activeMenu = menu;
    menu.addEventListener(BeanStub.EVENT_DESTROYED, function () {
      if (_this.activeMenu === menu) {
        _this.activeMenu = null;
      }
    });
  };
  EnterpriseMenuFactory.prototype.isMenuEnabled = function (column) {
    return column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT).length > 0;
  };
  __decorate$3$([Autowired('popupService')], EnterpriseMenuFactory.prototype, "popupService", void 0);
  __decorate$3$([Autowired('focusService')], EnterpriseMenuFactory.prototype, "focusService", void 0);
  __decorate$3$([Autowired('ctrlsService')], EnterpriseMenuFactory.prototype, "ctrlsService", void 0);
  EnterpriseMenuFactory = __decorate$3$([Bean('menuFactory')], EnterpriseMenuFactory);
  return EnterpriseMenuFactory;
}(BeanStub);
var EnterpriseMenu = /** @class */function (_super) {
  __extends$5w(EnterpriseMenu, _super);
  function EnterpriseMenu(column, initialSelection, restrictTo) {
    var _this = _super.call(this) || this;
    _this.tabFactories = {};
    _this.includeChecks = {};
    _this.column = column;
    _this.initialSelection = initialSelection;
    _this.tabFactories[EnterpriseMenu.TAB_GENERAL] = _this.createMainPanel.bind(_this);
    _this.tabFactories[EnterpriseMenu.TAB_FILTER] = _this.createFilterPanel.bind(_this);
    _this.tabFactories[EnterpriseMenu.TAB_COLUMNS] = _this.createColumnsPanel.bind(_this);
    _this.includeChecks[EnterpriseMenu.TAB_GENERAL] = function () {
      return true;
    };
    _this.includeChecks[EnterpriseMenu.TAB_FILTER] = function () {
      return column.isFilterAllowed();
    };
    _this.includeChecks[EnterpriseMenu.TAB_COLUMNS] = function () {
      return true;
    };
    _this.restrictTo = restrictTo;
    return _this;
  }
  EnterpriseMenu.prototype.init = function () {
    var _this = this;
    var tabs = this.getTabsToCreate().map(function (name) {
      return _this.createTab(name);
    });
    this.tabbedLayout = new TabbedLayout({
      items: tabs,
      cssClass: 'ag-menu',
      onActiveItemClicked: this.onHidePopup.bind(this),
      onItemClicked: this.onTabItemClicked.bind(this)
    });
    this.createBean(this.tabbedLayout);
    if (this.mainMenuList) {
      this.mainMenuList.setParentComponent(this.tabbedLayout);
    }
  };
  EnterpriseMenu.prototype.getTabsToCreate = function () {
    var _this = this;
    if (this.restrictTo) {
      return this.restrictTo;
    }
    return this.column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT).filter(function (tabName) {
      return _this.isValidMenuTabItem(tabName);
    }).filter(function (tabName) {
      return _this.isNotSuppressed(tabName);
    }).filter(function (tabName) {
      return _this.isModuleLoaded(tabName);
    });
  };
  EnterpriseMenu.prototype.isModuleLoaded = function (menuTabName) {
    if (menuTabName === EnterpriseMenu.TAB_COLUMNS) {
      return ModuleRegistry.isRegistered(ModuleNames.ColumnToolPanelModule);
    }
    return true;
  };
  EnterpriseMenu.prototype.isValidMenuTabItem = function (menuTabName) {
    var isValid = true;
    var itemsToConsider = EnterpriseMenu.TABS_DEFAULT;
    if (this.restrictTo != null) {
      isValid = this.restrictTo.indexOf(menuTabName) > -1;
      itemsToConsider = this.restrictTo;
    }
    isValid = isValid && EnterpriseMenu.TABS_DEFAULT.indexOf(menuTabName) > -1;
    if (!isValid) {
      console.warn("Trying to render an invalid menu item '" + menuTabName + "'. Check that your 'menuTabs' contains one of [" + itemsToConsider + "]");
    }
    return isValid;
  };
  EnterpriseMenu.prototype.isNotSuppressed = function (menuTabName) {
    return this.includeChecks[menuTabName]();
  };
  EnterpriseMenu.prototype.createTab = function (name) {
    return this.tabFactories[name]();
  };
  EnterpriseMenu.prototype.showTabBasedOnPreviousSelection = function () {
    // show the tab the user was on last time they had a menu open
    this.showTab(this.initialSelection);
  };
  EnterpriseMenu.prototype.showTab = function (toShow) {
    if (this.tabItemColumns && toShow === EnterpriseMenu.TAB_COLUMNS) {
      this.tabbedLayout.showItem(this.tabItemColumns);
    } else if (this.tabItemFilter && toShow === EnterpriseMenu.TAB_FILTER) {
      this.tabbedLayout.showItem(this.tabItemFilter);
    } else if (this.tabItemGeneral && toShow === EnterpriseMenu.TAB_GENERAL) {
      this.tabbedLayout.showItem(this.tabItemGeneral);
    } else {
      this.tabbedLayout.showFirstItem();
    }
  };
  EnterpriseMenu.prototype.onTabItemClicked = function (event) {
    var key = null;
    switch (event.item) {
      case this.tabItemColumns:
        key = EnterpriseMenu.TAB_COLUMNS;
        break;
      case this.tabItemFilter:
        key = EnterpriseMenu.TAB_FILTER;
        break;
      case this.tabItemGeneral:
        key = EnterpriseMenu.TAB_GENERAL;
        break;
    }
    if (key) {
      this.activateTab(key);
    }
  };
  EnterpriseMenu.prototype.activateTab = function (tab) {
    var ev = {
      type: EnterpriseMenu.EVENT_TAB_SELECTED,
      key: tab
    };
    this.dispatchEvent(ev);
  };
  EnterpriseMenu.prototype.getMenuItems = function () {
    var defaultMenuOptions = this.getDefaultMenuOptions();
    var result;
    var userFunc = this.gridOptionsWrapper.getMainMenuItemsFunc();
    if (userFunc) {
      result = userFunc({
        column: this.column,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext(),
        defaultItems: defaultMenuOptions
      });
    } else {
      result = defaultMenuOptions;
    }
    // GUI looks weird when two separators are side by side. this can happen accidentally
    // if we remove items from the menu then two separators can edit up adjacent.
    _.removeRepeatsFromArray(result, EnterpriseMenu.MENU_ITEM_SEPARATOR);
    return result;
  };
  EnterpriseMenu.prototype.getDefaultMenuOptions = function () {
    var result = [];
    var allowPinning = !this.column.getColDef().lockPinned;
    var rowGroupCount = this.columnModel.getRowGroupColumns().length;
    var doingGrouping = rowGroupCount > 0;
    var groupedByThisColumn = this.columnModel.getRowGroupColumns().indexOf(this.column) >= 0;
    var allowValue = this.column.isAllowValue();
    var allowRowGroup = this.column.isAllowRowGroup();
    var isPrimary = this.column.isPrimary();
    var pivotModeOn = this.columnModel.isPivotMode();
    var isInMemoryRowModel = this.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE;
    var usingTreeData = this.gridOptionsWrapper.isTreeData();
    var allowValueAgg =
    // if primary, then only allow aggValue if grouping and it's a value columns
    isPrimary && doingGrouping && allowValue
    // secondary columns can always have aggValue, as it means it's a pivot value column
    || !isPrimary;
    if (allowPinning) {
      result.push('pinSubMenu');
    }
    if (allowValueAgg) {
      result.push('valueAggSubMenu');
    }
    if (allowPinning || allowValueAgg) {
      result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
    }
    result.push('autoSizeThis');
    result.push('autoSizeAll');
    result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
    if (allowRowGroup && this.column.isPrimary()) {
      if (groupedByThisColumn) {
        result.push('rowUnGroup');
      } else {
        result.push('rowGroup');
      }
    }
    result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
    result.push('resetColumns');
    // only add grouping expand/collapse if grouping in the InMemoryRowModel
    // if pivoting, we only have expandable groups if grouping by 2 or more columns
    // as the lowest level group is not expandable while pivoting.
    // if not pivoting, then any active row group can be expanded.
    var allowExpandAndContract = isInMemoryRowModel && (usingTreeData || rowGroupCount > (pivotModeOn ? 1 : 0));
    if (allowExpandAndContract) {
      result.push('expandAll');
      result.push('contractAll');
    }
    return result;
  };
  EnterpriseMenu.prototype.createMainPanel = function () {
    this.mainMenuList = this.createManagedBean(new MenuList());
    var menuItems = this.getMenuItems();
    var menuItemsMapped = this.menuItemMapper.mapWithStockItems(menuItems, this.column);
    this.mainMenuList.addMenuItems(menuItemsMapped);
    this.mainMenuList.addEventListener(MenuItemComponent.EVENT_MENU_ITEM_SELECTED, this.onHidePopup.bind(this));
    this.tabItemGeneral = {
      title: _.createIconNoSpan('menu', this.gridOptionsWrapper, this.column),
      titleLabel: EnterpriseMenu.TAB_GENERAL.replace('MenuTab', ''),
      bodyPromise: AgPromise.resolve(this.mainMenuList.getGui()),
      name: EnterpriseMenu.TAB_GENERAL
    };
    return this.tabItemGeneral;
  };
  EnterpriseMenu.prototype.onHidePopup = function (event) {
    var keyboardEvent;
    if (event && event.event && event.event instanceof KeyboardEvent) {
      keyboardEvent = event.event;
    }
    this.hidePopupFunc(keyboardEvent && {
      keyboardEvent: keyboardEvent
    });
    // this method only gets called when the menu was closed by selection an option
    // in this case we highlight the cell that was previously highlighted
    var focusedCell = this.focusService.getFocusedCell();
    if (focusedCell) {
      var rowIndex = focusedCell.rowIndex,
        rowPinned = focusedCell.rowPinned,
        column = focusedCell.column;
      this.focusService.setFocusedCell(rowIndex, column, rowPinned, true);
    }
  };
  EnterpriseMenu.prototype.createFilterPanel = function () {
    var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.column, 'COLUMN_MENU');
    var afterFilterAttachedCallback = function afterFilterAttachedCallback(params) {
      if (!filterWrapper.filterPromise) {
        return;
      }
      // slightly odd block this - this promise will always have been resolved by the time it gets here, so won't be
      // async (_unless_ in react or similar, but if so why not encountered before now?).
      // I'd suggest a future improvement would be to remove/replace this promise as this block just wont work if it is
      // async and is confusing if you don't have this context
      filterWrapper.filterPromise.then(function (filter) {
        if (filter && filter.afterGuiAttached) {
          filter.afterGuiAttached(params);
        }
      });
    };
    this.tabItemFilter = {
      title: _.createIconNoSpan('filter', this.gridOptionsWrapper, this.column),
      titleLabel: EnterpriseMenu.TAB_FILTER.replace('MenuTab', ''),
      bodyPromise: filterWrapper.guiPromise,
      afterAttachedCallback: afterFilterAttachedCallback,
      name: EnterpriseMenu.TAB_FILTER
    };
    return this.tabItemFilter;
  };
  EnterpriseMenu.prototype.createColumnsPanel = function () {
    var eWrapperDiv = document.createElement('div');
    _.addCssClass(eWrapperDiv, 'ag-menu-column-select-wrapper');
    this.columnSelectPanel = this.createManagedBean(new PrimaryColsPanel());
    var columnsMenuParams = this.column.getColDef().columnsMenuParams;
    if (!columnsMenuParams) {
      columnsMenuParams = {};
    }
    this.columnSelectPanel.init(false, {
      suppressColumnMove: false,
      suppressValues: false,
      suppressPivots: false,
      suppressRowGroups: false,
      suppressPivotMode: false,
      contractColumnSelection: !!columnsMenuParams.contractColumnSelection,
      suppressColumnExpandAll: !!columnsMenuParams.suppressColumnExpandAll,
      suppressColumnFilter: !!columnsMenuParams.suppressColumnFilter,
      suppressColumnSelectAll: !!columnsMenuParams.suppressColumnSelectAll,
      suppressSyncLayoutWithGrid: !!columnsMenuParams.suppressSyncLayoutWithGrid,
      api: this.gridApi,
      columnApi: this.columnApi
    }, 'columnMenu');
    _.addCssClass(this.columnSelectPanel.getGui(), 'ag-menu-column-select');
    eWrapperDiv.appendChild(this.columnSelectPanel.getGui());
    this.tabItemColumns = {
      title: _.createIconNoSpan('columns', this.gridOptionsWrapper, this.column),
      titleLabel: EnterpriseMenu.TAB_COLUMNS.replace('MenuTab', ''),
      bodyPromise: AgPromise.resolve(eWrapperDiv),
      name: EnterpriseMenu.TAB_COLUMNS
    };
    return this.tabItemColumns;
  };
  EnterpriseMenu.prototype.afterGuiAttached = function (params) {
    var container = params.container,
      hidePopup = params.hidePopup;
    this.tabbedLayout.setAfterAttachedParams({
      container: container,
      hidePopup: hidePopup
    });
    if (hidePopup) {
      this.hidePopupFunc = hidePopup;
      this.addDestroyFunc(hidePopup);
    }
  };
  EnterpriseMenu.prototype.getGui = function () {
    return this.tabbedLayout.getGui();
  };
  EnterpriseMenu.EVENT_TAB_SELECTED = 'tabSelected';
  EnterpriseMenu.TAB_FILTER = 'filterMenuTab';
  EnterpriseMenu.TAB_GENERAL = 'generalMenuTab';
  EnterpriseMenu.TAB_COLUMNS = 'columnsMenuTab';
  EnterpriseMenu.TABS_DEFAULT = [EnterpriseMenu.TAB_GENERAL, EnterpriseMenu.TAB_FILTER, EnterpriseMenu.TAB_COLUMNS];
  EnterpriseMenu.MENU_ITEM_SEPARATOR = 'separator';
  __decorate$3$([Autowired('columnModel')], EnterpriseMenu.prototype, "columnModel", void 0);
  __decorate$3$([Autowired('filterManager')], EnterpriseMenu.prototype, "filterManager", void 0);
  __decorate$3$([Autowired('gridApi')], EnterpriseMenu.prototype, "gridApi", void 0);
  __decorate$3$([Autowired('columnApi')], EnterpriseMenu.prototype, "columnApi", void 0);
  __decorate$3$([Autowired('menuItemMapper')], EnterpriseMenu.prototype, "menuItemMapper", void 0);
  __decorate$3$([Autowired('rowModel')], EnterpriseMenu.prototype, "rowModel", void 0);
  __decorate$3$([Autowired('focusService')], EnterpriseMenu.prototype, "focusService", void 0);
  __decorate$3$([PostConstruct], EnterpriseMenu.prototype, "init", null);
  return EnterpriseMenu;
}(BeanStub);
var __extends$5x = undefined && undefined.__extends || function () {
  var _extendStatics362 = function extendStatics(d, b) {
    _extendStatics362 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics362(d, b);
  };
  return function (d, b) {
    _extendStatics362(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$40 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CSS_MENU = 'ag-menu';
var CSS_CONTEXT_MENU_OPEN = ' ag-context-menu-open';
var ContextMenuFactory = /** @class */function (_super) {
  __extends$5x(ContextMenuFactory, _super);
  function ContextMenuFactory() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ContextMenuFactory.prototype.hideActiveMenu = function () {
    this.destroyBean(this.activeMenu);
  };
  ContextMenuFactory.prototype.getMenuItems = function (node, column, value) {
    var defaultMenuOptions = [];
    if (_.exists(node) && ModuleRegistry.isRegistered(ModuleNames.ClipboardModule)) {
      if (column) {
        // only makes sense if column exists, could have originated from a row
        defaultMenuOptions.push('copy', 'copyWithHeaders', 'paste', 'separator');
      }
    }
    if (this.gridOptionsWrapper.isEnableCharts() && ModuleRegistry.isRegistered(ModuleNames.RangeSelectionModule) && ModuleRegistry.isRegistered(ModuleNames.GridChartsModule)) {
      if (this.columnModel.isPivotMode()) {
        defaultMenuOptions.push('pivotChart');
      }
      if (this.rangeService && !this.rangeService.isEmpty()) {
        defaultMenuOptions.push('chartRange');
      }
    }
    if (_.exists(node)) {
      // if user clicks a cell
      var csvModuleMissing = !ModuleRegistry.isRegistered(ModuleNames.CsvExportModule);
      var excelModuleMissing = !ModuleRegistry.isRegistered(ModuleNames.ExcelExportModule);
      var suppressExcel = this.gridOptionsWrapper.isSuppressExcelExport() || excelModuleMissing;
      var suppressCsv = this.gridOptionsWrapper.isSuppressCsvExport() || csvModuleMissing;
      var onIPad = _.isIOSUserAgent();
      var anyExport = !onIPad && (!suppressExcel || !suppressCsv);
      if (anyExport) {
        defaultMenuOptions.push('export');
      }
    }
    if (this.gridOptionsWrapper.getContextMenuItemsFunc()) {
      var userFunc = this.gridOptionsWrapper.getContextMenuItemsFunc();
      var params = {
        node: node,
        column: column,
        value: value,
        defaultItems: defaultMenuOptions.length ? defaultMenuOptions : undefined,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      return userFunc ? userFunc(params) : undefined;
    }
    return defaultMenuOptions;
  };
  ContextMenuFactory.prototype.onContextMenu = function (mouseEvent, touchEvent, rowNode, column, value, anchorToElement) {
    // to allow us to debug in chrome, we ignore the event if ctrl is pressed.
    // not everyone wants this, so first 'if' below allows to turn this hack off.
    if (!this.gridOptionsWrapper.isAllowContextMenuWithControlKey()) {
      // then do the check
      if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) {
        return;
      }
    }
    // need to do this regardless of context menu showing or not, so doing
    // before the isSuppressContextMenu() check
    if (mouseEvent) {
      this.blockMiddleClickScrollsIfNeeded(mouseEvent);
    }
    if (this.gridOptionsWrapper.isSuppressContextMenu()) {
      return;
    }
    var eventOrTouch = mouseEvent ? mouseEvent : touchEvent.touches[0];
    if (this.showMenu(rowNode, column, value, eventOrTouch, anchorToElement)) {
      var event_1 = mouseEvent ? mouseEvent : touchEvent;
      event_1.preventDefault();
    }
  };
  ContextMenuFactory.prototype.blockMiddleClickScrollsIfNeeded = function (mouseEvent) {
    // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
    // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
    // button in the browser). so this property allows the user to receive middle button clicks if
    // they want.
    var gridOptionsWrapper = this.gridOptionsWrapper;
    var which = mouseEvent.which;
    if (gridOptionsWrapper.isSuppressMiddleClickScrolls() && which === 2) {
      mouseEvent.preventDefault();
    }
  };
  ContextMenuFactory.prototype.showMenu = function (node, column, value, mouseEvent, anchorToElement) {
    var _this = this;
    var menuItems = this.getMenuItems(node, column, value);
    var eGridBodyGui = this.ctrlsService.getGridBodyCtrl().getGui();
    if (menuItems === undefined || _.missingOrEmpty(menuItems)) {
      return false;
    }
    var menu = new ContextMenu(menuItems);
    this.createBean(menu);
    var eMenuGui = menu.getGui();
    var positionParams = {
      column: column,
      rowNode: node,
      type: 'contextMenu',
      mouseEvent: mouseEvent,
      ePopup: eMenuGui,
      // move one pixel away so that accidentally double clicking
      // won't show the browser's contextmenu
      nudgeY: 1
    };
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var addPopupRes = this.popupService.addPopup({
      modal: true,
      eChild: eMenuGui,
      closeOnEsc: true,
      closedCallback: function closedCallback() {
        _.removeCssClass(eGridBodyGui, CSS_CONTEXT_MENU_OPEN);
        _this.destroyBean(menu);
      },
      click: mouseEvent,
      positionCallback: function positionCallback() {
        _this.popupService.positionPopupUnderMouseEvent(_.assign({}, {
          nudgeX: _this.gridOptionsWrapper.isEnableRtl() ? (eMenuGui.offsetWidth + 1) * -1 : 1
        }, positionParams));
      },
      // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
      anchorToElement: anchorToElement,
      ariaLabel: translate('ariaLabelContextMenu', 'Context Menu')
    });
    if (addPopupRes) {
      _.addCssClass(eGridBodyGui, CSS_CONTEXT_MENU_OPEN);
      menu.afterGuiAttached({
        container: 'contextMenu',
        hidePopup: addPopupRes.hideFunc
      });
    }
    // there should never be an active menu at this point, however it was found
    // that you could right click a second time just 1 or 2 pixels from the first
    // click, and another menu would pop up. so somehow the logic for closing the
    // first menu (clicking outside should close it) was glitchy somehow. an easy
    // way to avoid this is just remove the old context menu here if it exists.
    if (this.activeMenu) {
      this.hideActiveMenu();
    }
    this.activeMenu = menu;
    menu.addEventListener(BeanStub.EVENT_DESTROYED, function () {
      if (_this.activeMenu === menu) {
        _this.activeMenu = null;
      }
    });
    // hide the popup if something gets selected
    if (addPopupRes) {
      menu.addEventListener(MenuItemComponent.EVENT_MENU_ITEM_SELECTED, addPopupRes.hideFunc);
    }
    return true;
  };
  __decorate$40([Autowired('popupService')], ContextMenuFactory.prototype, "popupService", void 0);
  __decorate$40([Optional('rangeService')], ContextMenuFactory.prototype, "rangeService", void 0);
  __decorate$40([Autowired('ctrlsService')], ContextMenuFactory.prototype, "ctrlsService", void 0);
  __decorate$40([Autowired('columnModel')], ContextMenuFactory.prototype, "columnModel", void 0);
  ContextMenuFactory = __decorate$40([Bean('contextMenuFactory')], ContextMenuFactory);
  return ContextMenuFactory;
}(BeanStub);
var ContextMenu = /** @class */function (_super) {
  __extends$5x(ContextMenu, _super);
  function ContextMenu(menuItems) {
    var _this = _super.call(this, /* html */"<div class=\"" + CSS_MENU + "\" role=\"presentation\"></div>") || this;
    _this.menuList = null;
    _this.focusedCell = null;
    _this.menuItems = menuItems;
    return _this;
  }
  ContextMenu.prototype.addMenuItems = function () {
    var _this = this;
    var menuList = this.createBean(new MenuList());
    var menuItemsMapped = this.menuItemMapper.mapWithStockItems(this.menuItems, null);
    menuList.addMenuItems(menuItemsMapped);
    this.appendChild(menuList);
    this.menuList = menuList;
    menuList.addEventListener(MenuItemComponent.EVENT_MENU_ITEM_SELECTED, function (e) {
      return _this.dispatchEvent(e);
    });
  };
  ContextMenu.prototype.afterGuiAttached = function (params) {
    if (params.hidePopup) {
      this.addDestroyFunc(params.hidePopup);
    }
    this.focusedCell = this.focusService.getFocusedCell();
    if (this.menuList) {
      this.focusService.focusInto(this.menuList.getGui());
    }
  };
  ContextMenu.prototype.restoreFocusedCell = function () {
    var currentFocusedCell = this.focusService.getFocusedCell();
    if (currentFocusedCell && this.focusedCell && this.cellPositionUtils.equals(currentFocusedCell, this.focusedCell)) {
      var _a = this.focusedCell,
        rowIndex = _a.rowIndex,
        rowPinned = _a.rowPinned,
        column = _a.column;
      var doc = this.gridOptionsWrapper.getDocument();
      if (doc.activeElement === doc.body) {
        this.focusService.setFocusedCell(rowIndex, column, rowPinned, true);
      }
    }
  };
  ContextMenu.prototype.destroy = function () {
    this.restoreFocusedCell();
    _super.prototype.destroy.call(this);
  };
  __decorate$40([Autowired('menuItemMapper')], ContextMenu.prototype, "menuItemMapper", void 0);
  __decorate$40([Autowired('focusService')], ContextMenu.prototype, "focusService", void 0);
  __decorate$40([Autowired('cellPositionUtils')], ContextMenu.prototype, "cellPositionUtils", void 0);
  __decorate$40([PostConstruct], ContextMenu.prototype, "addMenuItems", null);
  return ContextMenu;
}(Component);
var __extends$5y = undefined && undefined.__extends || function () {
  var _extendStatics363 = function extendStatics(d, b) {
    _extendStatics363 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics363(d, b);
  };
  return function (d, b) {
    _extendStatics363(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$41 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MenuItemMapper = /** @class */function (_super) {
  __extends$5y(MenuItemMapper, _super);
  function MenuItemMapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MenuItemMapper.prototype.mapWithStockItems = function (originalList, column) {
    var _this = this;
    if (!originalList) {
      return [];
    }
    var resultList = [];
    originalList.forEach(function (menuItemOrString) {
      var result;
      if (typeof menuItemOrString === 'string') {
        result = _this.getStockMenuItem(menuItemOrString, column);
      } else {
        result = menuItemOrString;
      }
      // if no mapping, can happen when module is not loaded but user tries to use module anyway
      if (!result) {
        return;
      }
      var resultDef = result;
      var subMenu = resultDef.subMenu;
      if (subMenu && subMenu instanceof Array) {
        resultDef.subMenu = _this.mapWithStockItems(resultDef.subMenu, column);
      }
      if (result != null) {
        resultList.push(result);
      }
    });
    return resultList;
  };
  MenuItemMapper.prototype.getStockMenuItem = function (key, column) {
    var _this = this;
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var skipHeaderOnAutoSize = this.gridOptionsWrapper.isSkipHeaderOnAutoSize();
    switch (key) {
      case 'pinSubMenu':
        return {
          name: localeTextFunc('pinColumn', 'Pin Column'),
          icon: _.createIconNoSpan('menuPin', this.gridOptionsWrapper, null),
          subMenu: ['pinLeft', 'pinRight', 'clearPinned']
        };
      case 'pinLeft':
        return {
          name: localeTextFunc('pinLeft', 'Pin Left'),
          action: function action() {
            return _this.columnModel.setColumnPinned(column, Constants.PINNED_LEFT, "contextMenu");
          },
          checked: !!column && column.isPinnedLeft()
        };
      case 'pinRight':
        return {
          name: localeTextFunc('pinRight', 'Pin Right'),
          action: function action() {
            return _this.columnModel.setColumnPinned(column, Constants.PINNED_RIGHT, "contextMenu");
          },
          checked: !!column && column.isPinnedRight()
        };
      case 'clearPinned':
        return {
          name: localeTextFunc('noPin', 'No Pin'),
          action: function action() {
            return _this.columnModel.setColumnPinned(column, null, "contextMenu");
          },
          checked: !!column && !column.isPinned()
        };
      case 'valueAggSubMenu':
        if (ModuleRegistry.assertRegistered(ModuleNames.RowGroupingModule, 'Aggregation from Menu')) {
          return {
            name: localeTextFunc('valueAggregation', 'Value Aggregation'),
            icon: _.createIconNoSpan('menuValue', this.gridOptionsWrapper, null),
            subMenu: this.createAggregationSubMenu(column)
          };
        } else {
          return null;
        }
      case 'autoSizeThis':
        return {
          name: localeTextFunc('autosizeThiscolumn', 'Autosize This Column'),
          action: function action() {
            return _this.columnModel.autoSizeColumn(column, skipHeaderOnAutoSize, "contextMenu");
          }
        };
      case 'autoSizeAll':
        return {
          name: localeTextFunc('autosizeAllColumns', 'Autosize All Columns'),
          action: function action() {
            return _this.columnModel.autoSizeAllColumns(skipHeaderOnAutoSize, "contextMenu");
          }
        };
      case 'rowGroup':
        return {
          name: localeTextFunc('groupBy', 'Group by') + ' ' + _.escapeString(this.columnModel.getDisplayNameForColumn(column, 'header')),
          action: function action() {
            return _this.columnModel.addRowGroupColumn(column, "contextMenu");
          },
          icon: _.createIconNoSpan('menuAddRowGroup', this.gridOptionsWrapper, null)
        };
      case 'rowUnGroup':
        return {
          name: localeTextFunc('ungroupBy', 'Un-Group by') + ' ' + _.escapeString(this.columnModel.getDisplayNameForColumn(column, 'header')),
          action: function action() {
            return _this.columnModel.removeRowGroupColumn(column, "contextMenu");
          },
          icon: _.createIconNoSpan('menuRemoveRowGroup', this.gridOptionsWrapper, null)
        };
      case 'resetColumns':
        return {
          name: localeTextFunc('resetColumns', 'Reset Columns'),
          action: function action() {
            return _this.columnModel.resetColumnState("contextMenu");
          }
        };
      case 'expandAll':
        return {
          name: localeTextFunc('expandAll', 'Expand All'),
          action: function action() {
            return _this.gridApi.expandAll();
          }
        };
      case 'contractAll':
        return {
          name: localeTextFunc('collapseAll', 'Collapse All'),
          action: function action() {
            return _this.gridApi.collapseAll();
          }
        };
      case 'copy':
        if (ModuleRegistry.assertRegistered(ModuleNames.ClipboardModule, 'Copy from Menu')) {
          return {
            name: localeTextFunc('copy', 'Copy'),
            shortcut: localeTextFunc('ctrlC', 'Ctrl+C'),
            icon: _.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
            action: function action() {
              return _this.clipboardService.copyToClipboard(false);
            }
          };
        } else {
          return null;
        }
      case 'copyWithHeaders':
        if (ModuleRegistry.assertRegistered(ModuleNames.ClipboardModule, 'Copy with Headers from Menu')) {
          return {
            name: localeTextFunc('copyWithHeaders', 'Copy with Headers'),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: _.createIconNoSpan('clipboardCopy', this.gridOptionsWrapper, null),
            action: function action() {
              return _this.clipboardService.copyToClipboard(true);
            }
          };
        } else {
          return null;
        }
      case 'paste':
        if (ModuleRegistry.assertRegistered(ModuleNames.ClipboardModule, 'Paste from Clipboard')) {
          return {
            name: localeTextFunc('paste', 'Paste'),
            shortcut: localeTextFunc('ctrlV', 'Ctrl+V'),
            disabled: true,
            icon: _.createIconNoSpan('clipboardPaste', this.gridOptionsWrapper, null),
            action: function action() {
              return _this.clipboardService.pasteFromClipboard();
            }
          };
        } else {
          return null;
        }
      case 'export':
        var exportSubMenuItems = [];
        var csvModuleLoaded = ModuleRegistry.isRegistered(ModuleNames.CsvExportModule);
        var excelModuleLoaded = ModuleRegistry.isRegistered(ModuleNames.ExcelExportModule);
        if (!this.gridOptionsWrapper.isSuppressCsvExport() && csvModuleLoaded) {
          exportSubMenuItems.push('csvExport');
        }
        if (!this.gridOptionsWrapper.isSuppressExcelExport() && excelModuleLoaded) {
          exportSubMenuItems.push('excelExport');
        }
        return {
          name: localeTextFunc('export', 'Export'),
          subMenu: exportSubMenuItems,
          icon: _.createIconNoSpan('save', this.gridOptionsWrapper, null)
        };
      case 'csvExport':
        return {
          name: localeTextFunc('csvExport', 'CSV Export'),
          icon: _.createIconNoSpan('csvExport', this.gridOptionsWrapper, null),
          action: function action() {
            return _this.gridApi.exportDataAsCsv({});
          }
        };
      case 'excelExport':
        return {
          name: localeTextFunc('excelExport', 'Excel Export'),
          icon: _.createIconNoSpan('excelExport', this.gridOptionsWrapper, null),
          action: function action() {
            return _this.gridApi.exportDataAsExcel();
          }
        };
      case 'separator':
        return 'separator';
      default:
        var chartMenuItem = this.getChartItems(key);
        if (chartMenuItem) {
          return chartMenuItem;
        } else {
          console.warn("AG Grid: unknown menu item type " + key);
          return null;
        }
    }
  };
  MenuItemMapper.prototype.getChartItems = function (key) {
    var _this = this;
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var pivotChartMenuItem = function pivotChartMenuItem(localeKey, defaultText, chartType) {
      return {
        name: localeTextFunc(localeKey, defaultText),
        action: function action() {
          return _this.chartService.createPivotChart({
            chartType: chartType
          });
        }
      };
    };
    var rangeChartMenuItem = function rangeChartMenuItem(localeKey, defaultText, chartType) {
      return {
        name: localeTextFunc(localeKey, defaultText),
        action: function action() {
          return _this.chartService.createChartFromCurrentRange(chartType);
        }
      };
    };
    switch (key) {
      // case 'pivotChartAndPivotMode':
      //     return {
      //         name: localeTextFunc('pivotChartAndPivotMode', 'Pivot Chart & Pivot Mode&lrm;'),
      //         action: () => this.chartService.pivotChart(ChartType.GroupedColumn),
      //         icon: _.createIconNoSpan('chart', this.gridOptionsWrapper, null)
      //     };
      case 'pivotChart':
        return {
          name: localeTextFunc('pivotChart', 'Pivot Chart'),
          subMenu: ['pivotColumnChart', 'pivotBarChart', 'pivotPieChart', 'pivotLineChart', 'pivotXYChart', 'pivotAreaChart'],
          icon: _.createIconNoSpan('chart', this.gridOptionsWrapper, null)
        };
      case 'chartRange':
        return {
          name: localeTextFunc('chartRange', 'Chart Range'),
          subMenu: ['rangeColumnChart', 'rangeBarChart', 'rangePieChart', 'rangeLineChart', 'rangeXYChart', 'rangeAreaChart', 'rangeHistogramChart'],
          icon: _.createIconNoSpan('chart', this.gridOptionsWrapper, null)
        };
      case 'pivotColumnChart':
        return {
          name: localeTextFunc('columnChart', 'Column'),
          subMenu: ['pivotGroupedColumn', 'pivotStackedColumn', 'pivotNormalizedColumn']
        };
      case 'pivotGroupedColumn':
        return pivotChartMenuItem('groupedColumn', 'Grouped&lrm;', ChartType.GroupedColumn);
      case 'pivotStackedColumn':
        return pivotChartMenuItem('stackedColumn', 'Stacked&lrm;', ChartType.StackedColumn);
      case 'pivotNormalizedColumn':
        return pivotChartMenuItem('normalizedColumn', '100% Stacked&lrm;', ChartType.NormalizedColumn);
      case 'rangeColumnChart':
        return {
          name: localeTextFunc('columnChart', 'Column'),
          subMenu: ['rangeGroupedColumn', 'rangeStackedColumn', 'rangeNormalizedColumn']
        };
      case 'rangeGroupedColumn':
        return rangeChartMenuItem('groupedColumn', 'Grouped&lrm;', ChartType.GroupedColumn);
      case 'rangeStackedColumn':
        return rangeChartMenuItem('stackedColumn', 'Stacked&lrm;', ChartType.StackedColumn);
      case 'rangeNormalizedColumn':
        return rangeChartMenuItem('normalizedColumn', '100% Stacked&lrm;', ChartType.NormalizedColumn);
      case 'pivotBarChart':
        return {
          name: localeTextFunc('barChart', 'Bar'),
          subMenu: ['pivotGroupedBar', 'pivotStackedBar', 'pivotNormalizedBar']
        };
      case 'pivotGroupedBar':
        return pivotChartMenuItem('groupedBar', 'Grouped&lrm;', ChartType.GroupedBar);
      case 'pivotStackedBar':
        return pivotChartMenuItem('stackedBar', 'Stacked&lrm;', ChartType.StackedBar);
      case 'pivotNormalizedBar':
        return pivotChartMenuItem('normalizedBar', '100% Stacked&lrm;', ChartType.NormalizedBar);
      case 'rangeBarChart':
        return {
          name: localeTextFunc('barChart', 'Bar'),
          subMenu: ['rangeGroupedBar', 'rangeStackedBar', 'rangeNormalizedBar']
        };
      case 'rangeGroupedBar':
        return rangeChartMenuItem('groupedBar', 'Grouped&lrm;', ChartType.GroupedBar);
      case 'rangeStackedBar':
        return rangeChartMenuItem('stackedBar', 'Stacked&lrm;', ChartType.StackedBar);
      case 'rangeNormalizedBar':
        return rangeChartMenuItem('normalizedBar', '100% Stacked&lrm;', ChartType.NormalizedBar);
      case 'pivotPieChart':
        return {
          name: localeTextFunc('pieChart', 'Pie'),
          subMenu: ['pivotPie', 'pivotDoughnut']
        };
      case 'pivotPie':
        return pivotChartMenuItem('pie', 'Pie&lrm;', ChartType.Pie);
      case 'pivotDoughnut':
        return pivotChartMenuItem('doughnut', 'Doughnut&lrm;', ChartType.Doughnut);
      case 'rangePieChart':
        return {
          name: localeTextFunc('pieChart', 'Pie'),
          subMenu: ['rangePie', 'rangeDoughnut']
        };
      case 'rangePie':
        return rangeChartMenuItem('pie', 'Pie&lrm;', ChartType.Pie);
      case 'rangeDoughnut':
        return rangeChartMenuItem('doughnut', 'Doughnut&lrm;', ChartType.Doughnut);
      case 'pivotLineChart':
        return pivotChartMenuItem('line', 'Line&lrm;', ChartType.Line);
      case 'rangeLineChart':
        return rangeChartMenuItem('line', 'Line&lrm;', ChartType.Line);
      case 'pivotXYChart':
        return {
          name: localeTextFunc('xyChart', 'X Y (Scatter)'),
          subMenu: ['pivotScatter', 'pivotBubble']
        };
      case 'pivotScatter':
        return pivotChartMenuItem('scatter', 'Scatter&lrm;', ChartType.Scatter);
      case 'pivotBubble':
        return pivotChartMenuItem('bubble', 'Bubble&lrm;', ChartType.Bubble);
      case 'rangeXYChart':
        return {
          name: localeTextFunc('xyChart', 'X Y (Scatter)'),
          subMenu: ['rangeScatter', 'rangeBubble']
        };
      case 'rangeScatter':
        return rangeChartMenuItem('scatter', 'Scatter&lrm;', ChartType.Scatter);
      case 'rangeBubble':
        return rangeChartMenuItem('bubble', 'Bubble&lrm;', ChartType.Bubble);
      case 'pivotAreaChart':
        return {
          name: localeTextFunc('areaChart', 'Area'),
          subMenu: ['pivotArea', 'pivotStackedArea', 'pivotNormalizedArea']
        };
      case 'pivotArea':
        return pivotChartMenuItem('area', 'Area&lrm;', ChartType.Area);
      case 'pivotStackedArea':
        return pivotChartMenuItem('stackedArea', 'Stacked&lrm;', ChartType.StackedArea);
      case 'pivotNormalizedArea':
        return pivotChartMenuItem('normalizedArea', '100% Stacked&lrm;', ChartType.NormalizedArea);
      case 'rangeAreaChart':
        return {
          name: localeTextFunc('areaChart', 'Area'),
          subMenu: ['rangeArea', 'rangeStackedArea', 'rangeNormalizedArea']
        };
      case 'rangeArea':
        return rangeChartMenuItem('area', 'Area&lrm;', ChartType.Area);
      case 'rangeStackedArea':
        return rangeChartMenuItem('stackedArea', 'Stacked&lrm;', ChartType.StackedArea);
      case 'rangeNormalizedArea':
        return rangeChartMenuItem('normalizedArea', '100% Stacked&lrm;', ChartType.NormalizedArea);
      case 'rangeHistogramChart':
        return rangeChartMenuItem('histogramChart', 'Histogram&lrm;', ChartType.Histogram);
      default:
        return null;
    }
  };
  MenuItemMapper.prototype.createAggregationSubMenu = function (column) {
    var _this = this;
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    var columnIsAlreadyAggValue = column.isValueActive();
    var funcNames = this.aggFuncService.getFuncNames(column);
    var columnToUse;
    if (column.isPrimary()) {
      columnToUse = column;
    } else {
      var pivotValueColumn = column.getColDef().pivotValueColumn;
      columnToUse = _.exists(pivotValueColumn) ? pivotValueColumn : undefined;
    }
    var result = [];
    funcNames.forEach(function (funcName) {
      result.push({
        name: localeTextFunc(funcName, funcName),
        action: function action() {
          _this.columnModel.setColumnAggFunc(columnToUse, funcName, "contextMenu");
          _this.columnModel.addValueColumn(columnToUse, "contextMenu");
        },
        checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
      });
    });
    return result;
  };
  __decorate$41([Autowired('columnModel')], MenuItemMapper.prototype, "columnModel", void 0);
  __decorate$41([Autowired('gridApi')], MenuItemMapper.prototype, "gridApi", void 0);
  __decorate$41([Optional('clipboardService')], MenuItemMapper.prototype, "clipboardService", void 0);
  __decorate$41([Optional('aggFuncService')], MenuItemMapper.prototype, "aggFuncService", void 0);
  __decorate$41([Optional('chartService')], MenuItemMapper.prototype, "chartService", void 0);
  MenuItemMapper = __decorate$41([Bean('menuItemMapper')], MenuItemMapper);
  return MenuItemMapper;
}(BeanStub);
var MenuModule = {
  moduleName: ModuleNames.MenuModule,
  beans: [EnterpriseMenuFactory, ContextMenuFactory, MenuItemMapper],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5z = undefined && undefined.__extends || function () {
  var _extendStatics364 = function extendStatics(d, b) {
    _extendStatics364 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics364(d, b);
  };
  return function (d, b) {
    _extendStatics364(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$D = undefined && undefined.__assign || function () {
  __assign$D = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$D.apply(this, arguments);
};
var __decorate$42 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MultiFilter = /** @class */function (_super) {
  __extends$5z(MultiFilter, _super);
  function MultiFilter() {
    var _this = _super.call(this, /* html */"<div class=\"ag-multi-filter ag-menu-list-compact\"></div>") || this;
    _this.filterDefs = [];
    _this.filters = [];
    _this.guiDestroyFuncs = [];
    _this.activeFilterIndices = [];
    _this.lastActivatedMenuItem = null;
    _this.afterFiltersReadyFuncs = [];
    return _this;
  }
  MultiFilter.prototype.postConstruct = function () {
    var _this = this;
    this.initialiseTabGuard({
      onFocusIn: function onFocusIn(e) {
        return _this.onFocusIn(e);
      }
    });
  };
  MultiFilter.getFilterDefs = function (params) {
    var filters = params.filters;
    return filters && filters.length > 0 ? filters : [{
      filter: 'agTextColumnFilter'
    }, {
      filter: 'agSetColumnFilter'
    }];
  };
  MultiFilter.prototype.init = function (params) {
    var _this = this;
    this.params = params;
    this.filterDefs = MultiFilter.getFilterDefs(params);
    var column = params.column,
      filterChangedCallback = params.filterChangedCallback;
    this.column = column;
    this.filterChangedCallback = filterChangedCallback;
    var filterPromises = [];
    _.forEach(this.filterDefs, function (filterDef, index) {
      var filterPromise = _this.createFilter(filterDef, index);
      if (filterPromise != null) {
        filterPromises.push(filterPromise);
      }
    });
    // we have to refresh the GUI here to ensure that Angular components are not rendered in odd places
    return AgPromise.all(filterPromises).then(function (filters) {
      _this.filters = filters;
      _this.refreshGui('columnMenu');
      _this.afterFiltersReadyFuncs.forEach(function (f) {
        return f();
      });
      _this.afterFiltersReadyFuncs.length = 0;
    });
  };
  MultiFilter.prototype.refreshGui = function (container) {
    var _this = this;
    if (container === this.lastOpenedInContainer) {
      return;
    }
    this.removeAllChildrenExceptTabGuards();
    this.destroyChildren();
    _.forEach(this.filters, function (filter, index) {
      if (index > 0) {
        _this.appendChild(_.loadTemplate( /* html */"<div class=\"ag-filter-separator\"></div>"));
      }
      var filterDef = _this.filterDefs[index];
      var filterTitle = _this.getFilterTitle(filter, filterDef);
      var filterGui;
      if (filterDef.display === 'subMenu' && container !== 'toolPanel') {
        // prevent sub-menu being used in tool panel
        var menuItem = _this.insertFilterMenu(filter, filterTitle);
        filterGui = menuItem.getGui();
      } else if (filterDef.display === 'subMenu' || filterDef.display === 'accordion') {
        // sub-menus should appear as groups in the tool panel
        var group = _this.insertFilterGroup(filter, filterTitle);
        filterGui = group.getGui();
      } else {
        // display inline
        filterGui = filter.getGui();
      }
      _this.appendChild(filterGui);
    });
    this.lastOpenedInContainer = container;
  };
  MultiFilter.prototype.getFilterTitle = function (filter, filterDef) {
    if (filterDef.title != null) {
      return filterDef.title;
    }
    var filterWithoutType = filter;
    return typeof filterWithoutType.getFilterTitle === 'function' ? filterWithoutType.getFilterTitle() : 'Filter';
  };
  MultiFilter.prototype.destroyChildren = function () {
    _.forEach(this.guiDestroyFuncs, function (func) {
      return func();
    });
    this.guiDestroyFuncs.length = 0;
  };
  MultiFilter.prototype.insertFilterMenu = function (filter, name) {
    var _this = this;
    var menuItem = this.createBean(new MenuItemComponent({
      name: name,
      subMenu: filter,
      cssClasses: ['ag-multi-filter-menu-item'],
      isCompact: true,
      isAnotherSubMenuOpen: function isAnotherSubMenuOpen() {
        return false;
      }
    }));
    menuItem.setParentComponent(this);
    this.guiDestroyFuncs.push(function () {
      return _this.destroyBean(menuItem);
    });
    this.addManagedListener(menuItem, MenuItemComponent.EVENT_MENU_ITEM_ACTIVATED, function (event) {
      if (_this.lastActivatedMenuItem && _this.lastActivatedMenuItem !== event.menuItem) {
        _this.lastActivatedMenuItem.deactivate();
      }
      _this.lastActivatedMenuItem = event.menuItem;
    });
    menuItem.addGuiEventListener('focusin', function () {
      return menuItem.activate();
    });
    menuItem.addGuiEventListener('focusout', function () {
      if (!menuItem.isSubMenuOpen()) {
        menuItem.deactivate();
      }
    });
    return menuItem;
  };
  MultiFilter.prototype.insertFilterGroup = function (filter, title) {
    var _this = this;
    var group = this.createBean(new AgGroupComponent({
      title: title,
      cssIdentifier: 'multi-filter'
    }));
    this.guiDestroyFuncs.push(function () {
      return _this.destroyBean(group);
    });
    group.addItem(filter.getGui());
    group.toggleGroupExpand(false);
    if (filter.afterGuiAttached) {
      var params_1 = {
        container: this.lastOpenedInContainer,
        suppressFocus: true
      };
      group.addManagedListener(group, AgGroupComponent.EVENT_EXPANDED, function () {
        return filter.afterGuiAttached(params_1);
      });
    }
    return group;
  };
  MultiFilter.prototype.isFilterActive = function () {
    return _.some(this.filters, function (filter) {
      return filter.isFilterActive();
    });
  };
  MultiFilter.prototype.getLastActiveFilterIndex = function () {
    return this.activeFilterIndices.length > 0 ? this.activeFilterIndices[this.activeFilterIndices.length - 1] : null;
  };
  MultiFilter.prototype.doesFilterPass = function (params, filterToSkip) {
    var rowPasses = true;
    this.filters.forEach(function (filter) {
      if (!rowPasses || filter === filterToSkip || !filter.isFilterActive()) {
        return;
      }
      rowPasses = filter.doesFilterPass(params);
    });
    return rowPasses;
  };
  MultiFilter.prototype.getFilterType = function () {
    return 'multi';
  };
  MultiFilter.prototype.getModelFromUi = function () {
    var model = {
      filterType: this.getFilterType(),
      filterModels: _.map(this.filters, function (filter) {
        var providedFilter = filter;
        if (typeof providedFilter.getModelFromUi === 'function') {
          return providedFilter.getModelFromUi();
        }
        return null;
      })
    };
    return model;
  };
  MultiFilter.prototype.getModel = function () {
    if (!this.isFilterActive()) {
      return null;
    }
    var model = {
      filterType: this.getFilterType(),
      filterModels: _.map(this.filters, function (filter) {
        if (filter.isFilterActive()) {
          return filter.getModel();
        }
        return null;
      })
    };
    return model;
  };
  MultiFilter.prototype.setModel = function (model) {
    var _this = this;
    var setFilterModel = function setFilterModel(filter, filterModel) {
      return new AgPromise(function (resolve) {
        var promise = filter.setModel(filterModel);
        promise ? promise.then(function () {
          return resolve();
        }) : resolve();
      });
    };
    var promises = [];
    if (model == null) {
      promises = _.map(this.filters, function (filter, index) {
        var res = setFilterModel(filter, null);
        _this.updateActiveList(index);
        return res;
      });
    } else {
      _.forEach(this.filters, function (filter, index) {
        var filterModel = model.filterModels.length > index ? model.filterModels[index] : null;
        var res = setFilterModel(filter, filterModel);
        promises.push(res);
        _this.updateActiveList(index);
      });
    }
    return AgPromise.all(promises).then(function () {});
  };
  MultiFilter.prototype.getChildFilterInstance = function (index) {
    return this.filters[index];
  };
  MultiFilter.prototype.afterGuiAttached = function (params) {
    if (params) {
      this.refreshGui(params.container);
    }
    var filters = this.params.filters;
    var suppressFocus = filters && _.some(filters, function (filter) {
      return filter.display && filter.display !== 'inline';
    });
    this.executeFunctionIfExists('afterGuiAttached', __assign$D(__assign$D({}, params || {}), {
      suppressFocus: suppressFocus
    }));
    var activeEl = document.activeElement;
    // if suppress focus is true, we might run into two scenarios: 
    // 1 - we are loading the filter for the first time and the component isn't ready, 
    //     which means the document will have focus.
    // 2 - The focus will be somewhere inside the component due to auto focus
    // In both cases we need to force the focus somewhere valid but outside the filter.
    if (suppressFocus && (activeEl === document.body || this.getGui().contains(activeEl))) {
      // reset focus to the top of the container, and blur
      this.forceFocusOutOfContainer(true);
    }
  };
  MultiFilter.prototype.onAnyFilterChanged = function () {
    this.executeFunctionIfExists('onAnyFilterChanged');
  };
  MultiFilter.prototype.onNewRowsLoaded = function () {
    this.executeFunctionIfExists('onNewRowsLoaded');
  };
  MultiFilter.prototype.destroy = function () {
    var _this = this;
    _.forEach(this.filters, function (filter) {
      filter.setModel(null);
      _this.destroyBean(filter);
    });
    this.filters.length = 0;
    this.destroyChildren();
    _super.prototype.destroy.call(this);
  };
  MultiFilter.prototype.executeFunctionIfExists = function (name) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      params[_i - 1] = arguments[_i];
    }
    // The first filter is always the "dominant" one. By iterating in reverse order we ensure the first filter
    // always gets the last say
    _.forEachReverse(this.filters, function (filter) {
      var func = filter[name];
      if (typeof func === 'function') {
        func.apply(filter, params);
      }
    });
  };
  MultiFilter.prototype.createFilter = function (filterDef, index) {
    var _this = this;
    var _a = this.params,
      filterModifiedCallback = _a.filterModifiedCallback,
      _doesRowPassOtherFilter = _a.doesRowPassOtherFilter;
    var filterInstance;
    var filterParams = __assign$D(__assign$D({}, this.filterManager.createFilterParams(this.column, this.column.getColDef())), {
      filterModifiedCallback: filterModifiedCallback,
      filterChangedCallback: function filterChangedCallback(additionalEventAttributes) {
        _this.executeWhenAllFiltersReady(function () {
          return _this.filterChanged(index, additionalEventAttributes);
        });
      },
      doesRowPassOtherFilter: function doesRowPassOtherFilter(node) {
        return _doesRowPassOtherFilter(node) && _this.doesFilterPass({
          node: node,
          data: node.data
        }, filterInstance);
      }
    });
    var compDetails = this.userComponentFactory.getFilterDetails(filterDef, filterParams, 'agTextColumnFilter');
    if (!compDetails) {
      return null;
    }
    var filterPromise = compDetails.newAgStackInstance();
    if (filterPromise) {
      filterPromise.then(function (filter) {
        return filterInstance = filter;
      });
    }
    return filterPromise;
  };
  MultiFilter.prototype.executeWhenAllFiltersReady = function (action) {
    if (this.filters && this.filters.length > 0) {
      action();
    } else {
      this.afterFiltersReadyFuncs.push(action);
    }
  };
  MultiFilter.prototype.updateActiveList = function (index) {
    var changedFilter = this.filters[index];
    _.removeFromArray(this.activeFilterIndices, index);
    if (changedFilter.isFilterActive()) {
      this.activeFilterIndices.push(index);
    }
  };
  MultiFilter.prototype.filterChanged = function (index, additionalEventAttributes) {
    this.updateActiveList(index);
    this.filterChangedCallback(additionalEventAttributes);
    var changedFilter = this.filters[index];
    _.forEach(this.filters, function (filter) {
      if (filter === changedFilter) {
        return;
      }
      if (typeof filter.onAnyFilterChanged === 'function') {
        filter.onAnyFilterChanged();
      }
    });
  };
  MultiFilter.prototype.onFocusIn = function (e) {
    if (this.lastActivatedMenuItem != null && !this.lastActivatedMenuItem.getGui().contains(e.target)) {
      this.lastActivatedMenuItem.deactivate();
      this.lastActivatedMenuItem = null;
    }
    return true;
  };
  __decorate$42([Autowired('filterManager')], MultiFilter.prototype, "filterManager", void 0);
  __decorate$42([Autowired('userComponentFactory')], MultiFilter.prototype, "userComponentFactory", void 0);
  __decorate$42([PostConstruct], MultiFilter.prototype, "postConstruct", null);
  return MultiFilter;
}(TabGuardComp);
var __extends$5A = undefined && undefined.__extends || function () {
  var _extendStatics365 = function extendStatics(d, b) {
    _extendStatics365 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics365(d, b);
  };
  return function (d, b) {
    _extendStatics365(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$E = undefined && undefined.__assign || function () {
  __assign$E = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$E.apply(this, arguments);
};
var __decorate$43 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MultiFloatingFilterComp = /** @class */function (_super) {
  __extends$5A(MultiFloatingFilterComp, _super);
  function MultiFloatingFilterComp() {
    var _this = _super.call(this, /* html */"<div class=\"ag-multi-floating-filter ag-floating-filter-input\"></div>") || this;
    _this.floatingFilters = [];
    return _this;
  }
  MultiFloatingFilterComp.prototype.init = function (params) {
    var _this = this;
    this.params = params;
    var filterParams = params.filterParams;
    var floatingFilterPromises = [];
    _.forEach(MultiFilter.getFilterDefs(filterParams), function (filterDef, index) {
      var floatingFilterParams = __assign$E(__assign$E({}, params), {
        // set the parent filter instance for each floating filter to the relevant child filter instance
        parentFilterInstance: function parentFilterInstance(callback) {
          params.parentFilterInstance(function (parent) {
            var childFilterInstance = parent.getChildFilterInstance(index);
            callback(childFilterInstance);
          });
        }
      });
      var floatingFilterPromise = _this.createFloatingFilter(filterDef, floatingFilterParams);
      if (floatingFilterPromise != null) {
        floatingFilterPromises.push(floatingFilterPromise);
      }
    });
    return AgPromise.all(floatingFilterPromises).then(function (floatingFilters) {
      _.forEach(floatingFilters, function (floatingFilter, index) {
        _this.floatingFilters.push(floatingFilter);
        var gui = floatingFilter.getGui();
        _this.appendChild(gui);
        if (index > 0) {
          _.setDisplayed(gui, false);
        }
      });
    });
  };
  MultiFloatingFilterComp.prototype.onParentModelChanged = function (model, event) {
    var _this = this;
    // We don't want to update the floating filter if the floating filter caused the change,
    // because the UI is already in sync. if we didn't do this, the UI would behave strangely
    // as it would be updating as the user is typing
    if (event && event.afterFloatingFilter) {
      return;
    }
    this.params.parentFilterInstance(function (parent) {
      if (model == null) {
        _.forEach(_this.floatingFilters, function (filter, i) {
          filter.onParentModelChanged(null, event);
          _.setDisplayed(filter.getGui(), i === 0);
        });
      } else {
        var lastActiveFloatingFilterIndex_1 = parent.getLastActiveFilterIndex();
        _.forEach(_this.floatingFilters, function (filter, i) {
          var filterModel = model.filterModels.length > i ? model.filterModels[i] : null;
          filter.onParentModelChanged(filterModel, event);
          var shouldShow = lastActiveFloatingFilterIndex_1 == null ? i === 0 : i === lastActiveFloatingFilterIndex_1;
          _.setDisplayed(filter.getGui(), shouldShow);
        });
      }
    });
  };
  MultiFloatingFilterComp.prototype.destroy = function () {
    this.destroyBeans(this.floatingFilters);
    this.floatingFilters.length = 0;
    _super.prototype.destroy.call(this);
  };
  MultiFloatingFilterComp.prototype.createFloatingFilter = function (filterDef, params) {
    var defaultComponentName = HeaderFilterCellCtrl.getDefaultFloatingFilterType(filterDef) || 'agTextColumnFloatingFilter';
    var compDetails = this.userComponentFactory.getFloatingFilterCompDetails(filterDef, params, defaultComponentName);
    return compDetails ? compDetails.newAgStackInstance() : null;
  };
  __decorate$43([Autowired('userComponentFactory')], MultiFloatingFilterComp.prototype, "userComponentFactory", void 0);
  return MultiFloatingFilterComp;
}(Component);
var MultiFilterModule = {
  moduleName: ModuleNames.MultiFilterModule,
  beans: [],
  userComponents: [{
    componentName: 'agMultiColumnFilter',
    componentClass: MultiFilter
  }, {
    componentName: 'agMultiColumnFloatingFilter',
    componentClass: MultiFloatingFilterComp
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5B = undefined && undefined.__extends || function () {
  var _extendStatics366 = function extendStatics(d, b) {
    _extendStatics366 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics366(d, b);
  };
  return function (d, b) {
    _extendStatics366(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$44 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RichSelectRow = /** @class */function (_super) {
  __extends$5B(RichSelectRow, _super);
  function RichSelectRow(params) {
    var _this = _super.call(this, /* html */"<div class=\"ag-rich-select-row\"></div>") || this;
    _this.params = params;
    return _this;
  }
  RichSelectRow.prototype.setState = function (value, valueFormatted, selected) {
    var rendererSuccessful = this.populateWithRenderer(value, valueFormatted);
    if (!rendererSuccessful) {
      this.populateWithoutRenderer(value, valueFormatted);
    }
    _.addOrRemoveCssClass(this.getGui(), 'ag-rich-select-row-selected', selected);
  };
  RichSelectRow.prototype.populateWithoutRenderer = function (value, valueFormatted) {
    var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
    var valueToRender = valueFormattedExits ? valueFormatted : value;
    if (_.exists(valueToRender) && valueToRender !== '') {
      // not using innerHTML to prevent injection of HTML
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/innerHTML#Security_considerations
      this.getGui().textContent = valueToRender.toString();
    } else {
      // putting in blank, so if missing, at least the user can click on it
      this.getGui().innerHTML = '&nbsp;';
    }
  };
  RichSelectRow.prototype.populateWithRenderer = function (value, valueFormatted) {
    var _this = this;
    // bad coder here - we are not populating all values of the cellRendererParams
    var params = {
      value: value,
      valueFormatted: valueFormatted,
      api: this.gridOptionsWrapper.getApi()
    };
    var compDetails = this.userComponentFactory.getCellRendererDetails(this.params, params);
    var cellRendererPromise = compDetails ? compDetails.newAgStackInstance() : undefined;
    if (cellRendererPromise != null) {
      _.bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
    } else {
      this.getGui().innerText = params.valueFormatted != null ? params.valueFormatted : params.value;
    }
    if (cellRendererPromise) {
      cellRendererPromise.then(function (childComponent) {
        _this.addDestroyFunc(function () {
          _this.getContext().destroyBean(childComponent);
        });
      });
      return true;
    }
    return false;
  };
  __decorate$44([Autowired('userComponentFactory')], RichSelectRow.prototype, "userComponentFactory", void 0);
  return RichSelectRow;
}(Component);
var __extends$5C = undefined && undefined.__extends || function () {
  var _extendStatics367 = function extendStatics(d, b) {
    _extendStatics367 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics367(d, b);
  };
  return function (d, b) {
    _extendStatics367(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$45 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RichSelectCellEditor = /** @class */function (_super) {
  __extends$5C(RichSelectCellEditor, _super);
  function RichSelectCellEditor() {
    var _this = _super.call(this, RichSelectCellEditor.TEMPLATE) || this;
    _this.selectionConfirmed = false;
    _this.searchString = '';
    return _this;
  }
  RichSelectCellEditor.prototype.init = function (params) {
    this.params = params;
    this.selectedValue = params.value;
    this.originalSelectedValue = params.value;
    this.focusAfterAttached = params.cellStartedEdit;
    var icon = _.createIconNoSpan('smallDown', this.gridOptionsWrapper);
    _.addCssClass(icon, 'ag-rich-select-value-icon');
    this.eValue.appendChild(icon);
    this.virtualList = this.getContext().createBean(new VirtualList('rich-select'));
    this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
    this.eList.appendChild(this.virtualList.getGui());
    if (_.exists(this.params.cellHeight)) {
      this.virtualList.setRowHeight(this.params.cellHeight);
    }
    this.renderSelectedValue();
    if (_.missing(params.values)) {
      console.warn('AG Grid: richSelectCellEditor requires values for it to work');
      return;
    }
    var values = params.values;
    this.virtualList.setModel({
      getRowCount: function getRowCount() {
        return values.length;
      },
      getRow: function getRow(index) {
        return values[index];
      }
    });
    this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
    var virtualListGui = this.virtualList.getGui();
    this.addManagedListener(virtualListGui, 'click', this.onClick.bind(this));
    this.addManagedListener(virtualListGui, 'mousemove', this.onMouseMove.bind(this));
    var debounceDelay = _.exists(params.searchDebounceDelay) ? params.searchDebounceDelay : 300;
    this.clearSearchString = _.debounce(this.clearSearchString, debounceDelay);
    if (_.exists(params.charPress)) {
      this.searchText(params.charPress);
    }
  };
  RichSelectCellEditor.prototype.onKeyDown = function (event) {
    var key = event.keyCode;
    event.preventDefault();
    switch (key) {
      case KeyCode.ENTER:
        this.onEnterKeyDown();
        break;
      case KeyCode.TAB:
        this.confirmSelection();
        break;
      case KeyCode.DOWN:
      case KeyCode.UP:
        this.onNavigationKeyPressed(event, key);
        break;
      default:
        this.searchText(event);
    }
  };
  RichSelectCellEditor.prototype.confirmSelection = function () {
    this.selectionConfirmed = true;
  };
  RichSelectCellEditor.prototype.onEnterKeyDown = function () {
    this.confirmSelection();
    this.params.stopEditing();
  };
  RichSelectCellEditor.prototype.onNavigationKeyPressed = function (event, key) {
    // if we don't preventDefault the page body and/or grid scroll will move.
    event.preventDefault();
    var oldIndex = this.params.values.indexOf(this.selectedValue);
    var newIndex = key === KeyCode.UP ? oldIndex - 1 : oldIndex + 1;
    if (newIndex >= 0 && newIndex < this.params.values.length) {
      var valueToSelect = this.params.values[newIndex];
      this.setSelectedValue(valueToSelect);
    }
  };
  RichSelectCellEditor.prototype.searchText = function (key) {
    if (typeof key !== 'string') {
      var keyCode = key.keyCode;
      var keyString = key.key;
      if (keyCode === KeyCode.BACKSPACE) {
        this.searchString = this.searchString.slice(0, -1);
        keyString = '';
      } else if (!_.isEventFromPrintableCharacter(key)) {
        return;
      }
      this.searchText(keyString);
      return;
    }
    this.searchString += key;
    this.runSearch();
    this.clearSearchString();
  };
  RichSelectCellEditor.prototype.runSearch = function () {
    var _this = this;
    var values = this.params.values;
    var searchStrings;
    if (typeof values[0] === 'number' || typeof values[0] === 'string') {
      searchStrings = values.map(String);
    }
    if (typeof values[0] === 'object' && this.params.colDef.keyCreator) {
      searchStrings = values.map(function (value) {
        var keyParams = {
          value: value,
          colDef: _this.params.colDef,
          column: _this.params.column,
          node: _this.params.node,
          data: _this.params.data,
          api: _this.gridOptionsWrapper.getApi(),
          columnApi: _this.gridOptionsWrapper.getColumnApi(),
          context: _this.gridOptionsWrapper.getContext()
        };
        return _this.params.colDef.keyCreator(keyParams);
      });
    }
    if (!searchStrings) {
      return;
    }
    var topSuggestion = _.fuzzySuggestions(this.searchString, searchStrings, true, true)[0];
    if (!topSuggestion) {
      return;
    }
    var topSuggestionIndex = searchStrings.indexOf(topSuggestion);
    var topValue = values[topSuggestionIndex];
    this.setSelectedValue(topValue);
  };
  RichSelectCellEditor.prototype.clearSearchString = function () {
    this.searchString = '';
  };
  RichSelectCellEditor.prototype.renderSelectedValue = function () {
    var _this = this;
    var valueFormatted = this.params.formatValue(this.selectedValue);
    var eValue = this.eValue;
    var params = {
      value: this.selectedValue,
      valueFormatted: valueFormatted,
      api: this.gridOptionsWrapper.getApi()
    };
    var compDetails = this.userComponentFactory.getCellRendererDetails(this.params, params);
    var promise = compDetails ? compDetails.newAgStackInstance() : undefined;
    if (promise) {
      _.bindCellRendererToHtmlElement(promise, eValue);
      promise.then(function (renderer) {
        _this.addDestroyFunc(function () {
          return _this.getContext().destroyBean(renderer);
        });
      });
    } else {
      if (_.exists(this.selectedValue)) {
        eValue.innerHTML = valueFormatted;
      } else {
        _.clearElement(eValue);
      }
    }
  };
  RichSelectCellEditor.prototype.setSelectedValue = function (value) {
    if (this.selectedValue === value) {
      return;
    }
    var index = this.params.values.indexOf(value);
    if (index === -1) {
      return;
    }
    this.selectedValue = value;
    this.virtualList.ensureIndexVisible(index);
    this.virtualList.refresh();
  };
  RichSelectCellEditor.prototype.createRowComponent = function (value) {
    var valueFormatted = this.params.formatValue(value);
    var row = new RichSelectRow(this.params);
    this.getContext().createBean(row);
    row.setState(value, valueFormatted, value === this.selectedValue);
    return row;
  };
  RichSelectCellEditor.prototype.onMouseMove = function (mouseEvent) {
    var rect = this.virtualList.getGui().getBoundingClientRect();
    var scrollTop = this.virtualList.getScrollTop();
    var mouseY = mouseEvent.clientY - rect.top + scrollTop;
    var row = Math.floor(mouseY / this.virtualList.getRowHeight());
    var value = this.params.values[row];
    // not using utils.exist() as want empty string test to pass
    if (value !== undefined) {
      this.setSelectedValue(value);
    }
  };
  RichSelectCellEditor.prototype.onClick = function () {
    this.confirmSelection();
    this.params.stopEditing();
  };
  // we need to have the gui attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the gui state
  RichSelectCellEditor.prototype.afterGuiAttached = function () {
    var selectedIndex = this.params.values.indexOf(this.selectedValue);
    // we have to call this here to get the list to have the right height, ie
    // otherwise it would not have scrolls yet and ensureIndexVisible would do nothing
    this.virtualList.refresh();
    if (selectedIndex >= 0) {
      this.virtualList.ensureIndexVisible(selectedIndex);
    }
    // we call refresh again, as the list could of moved, and we need to render the new rows
    this.virtualList.refresh();
    if (this.focusAfterAttached) {
      this.getGui().focus();
    }
  };
  RichSelectCellEditor.prototype.getValue = function () {
    // NOTE: we don't use valueParser for Set Filter. The user should provide values that are to be
    // set into the data. valueParser only really makese sense when the user is typing in text (not picking
    // form a set).
    return this.selectionConfirmed ? this.selectedValue : this.originalSelectedValue;
  };
  // tab index is needed so we can focus, which is needed for keyboard events
  RichSelectCellEditor.TEMPLATE = "<div class=\"ag-rich-select\" tabindex=\"-1\">\n            <div ref=\"eValue\" class=\"ag-rich-select-value\"></div>\n            <div ref=\"eList\" class=\"ag-rich-select-list\"></div>\n        </div>";
  __decorate$45([Autowired('userComponentFactory')], RichSelectCellEditor.prototype, "userComponentFactory", void 0);
  __decorate$45([RefSelector('eValue')], RichSelectCellEditor.prototype, "eValue", void 0);
  __decorate$45([RefSelector('eList')], RichSelectCellEditor.prototype, "eList", void 0);
  return RichSelectCellEditor;
}(PopupComponent);
var RichSelectModule = {
  moduleName: ModuleNames.RichSelectModule,
  beans: [],
  userComponents: [{
    componentName: 'agRichSelect',
    componentClass: RichSelectCellEditor
  }, {
    componentName: 'agRichSelectCellEditor',
    componentClass: RichSelectCellEditor
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5D = undefined && undefined.__extends || function () {
  var _extendStatics368 = function extendStatics(d, b) {
    _extendStatics368 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics368(d, b);
  };
  return function (d, b) {
    _extendStatics368(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$46 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$b = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var ServerSideRowModel = /** @class */function (_super) {
  __extends$5D(ServerSideRowModel, _super);
  function ServerSideRowModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.pauseStoreUpdateListening = false;
    return _this;
  }
  // we don't implement as lazy row heights is not supported in this row model
  ServerSideRowModel.prototype.ensureRowHeightsValid = function () {
    return false;
  };
  ServerSideRowModel.prototype.start = function () {
    var datasource = this.gridOptionsWrapper.getServerSideDatasource();
    if (datasource) {
      this.setDatasource(datasource);
    }
  };
  ServerSideRowModel.prototype.destroyDatasource = function () {
    if (!this.datasource) {
      return;
    }
    if (this.datasource.destroy) {
      this.datasource.destroy();
    }
    this.rowRenderer.datasourceChanged();
    this.datasource = undefined;
  };
  ServerSideRowModel.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('ServerSideRowModel');
  };
  ServerSideRowModel.prototype.addEventListeners = function () {
    this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_STORE_UPDATED, this.onStoreUpdated.bind(this));
    var resetListener = this.resetRootStore.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, resetListener);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, resetListener);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, resetListener);
    this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, resetListener);
    this.verifyProps();
  };
  ServerSideRowModel.prototype.verifyProps = function () {
    if (this.gridOptionsWrapper.getDefaultGroupOrderComparator() != null) {
      var message_1 = "AG Grid: defaultGroupOrderComparator cannot be used with Server Side Row Model. If using Full Store, then provide the rows to the grid in the desired sort order. If using Partial Store, then sorting is done on the server side, nothing to do with the client.";
      _.doOnce(function () {
        return console.warn(message_1);
      }, 'SSRM.DefaultGroupOrderComparator');
    }
  };
  ServerSideRowModel.prototype.setDatasource = function (datasource) {
    this.destroyDatasource();
    this.datasource = datasource;
    this.resetRootStore();
  };
  ServerSideRowModel.prototype.isLastRowIndexKnown = function () {
    var cache = this.getRootStore();
    if (!cache) {
      return false;
    }
    return cache.isLastRowIndexKnown();
  };
  ServerSideRowModel.prototype.onColumnEverything = function () {
    // this is a hack for one customer only, so they can suppress the resetting of the columns.
    // The problem the customer had was they were api.setColumnDefs() after the data source came
    // back with data. So this stops the reload from the grid after the data comes back.
    // Once we have "AG-1591 Allow delta changes to columns" fixed, then this hack can be taken out.
    if (this.gridOptionsWrapper.isSuppressEnterpriseResetOnNewColumns()) {
      return;
    }
    // every other customer can continue as normal and have it working!!!
    // if first time, alwasy reset
    if (!this.storeParams) {
      this.resetRootStore();
      return;
    }
    // check if anything pertaining to fetching data has changed, and if it has, reset, but if
    // it has not, don't reset
    var rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
    var valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
    var pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
    var sortModelDifferent = !_.jsonEquals(this.storeParams.sortModel, this.sortController.getSortModel());
    var rowGroupDifferent = !_.jsonEquals(this.storeParams.rowGroupCols, rowGroupColumnVos);
    var pivotDifferent = !_.jsonEquals(this.storeParams.pivotCols, pivotColumnVos);
    var valuesDifferent = !_.jsonEquals(this.storeParams.valueCols, valueColumnVos);
    var resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
    if (resetRequired) {
      this.resetRootStore();
    }
  };
  ServerSideRowModel.prototype.destroyRootStore = function () {
    if (!this.rootNode || !this.rootNode.childStore) {
      return;
    }
    this.rootNode.childStore = this.destroyBean(this.rootNode.childStore);
    this.nodeManager.clear();
  };
  ServerSideRowModel.prototype.refreshAfterSort = function (newSortModel, params) {
    if (this.storeParams) {
      this.storeParams.sortModel = newSortModel;
    }
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.refreshAfterSort(params);
    this.onStoreUpdated();
  };
  ServerSideRowModel.prototype.resetRootStore = function () {
    this.destroyRootStore();
    this.rootNode = new RowNode(this.beans);
    this.rootNode.group = true;
    this.rootNode.level = -1;
    if (this.datasource) {
      this.storeParams = this.createStoreParams();
      this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode));
      this.updateRowIndexesAndBounds();
    }
    // this event: 1) clears selection 2) updates filters 3) shows/hides 'no rows' overlay
    var rowDataChangedEvent = {
      type: Events.EVENT_ROW_DATA_CHANGED,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    this.eventService.dispatchEvent(rowDataChangedEvent);
    // this gets the row to render rows (or remove the previously rendered rows, as it's blank to start).
    // important to NOT pass in an event with keepRenderedRows or animate, as we want the renderer
    // to treat the rows as new rows, as it's all new data
    this.dispatchModelUpdated(true);
  };
  ServerSideRowModel.prototype.columnsToValueObjects = function (columns) {
    var _this = this;
    return columns.map(function (col) {
      return {
        id: col.getId(),
        aggFunc: col.getAggFunc(),
        displayName: _this.columnModel.getDisplayNameForColumn(col, 'model'),
        field: col.getColDef().field
      };
    });
  };
  ServerSideRowModel.prototype.createStoreParams = function () {
    var rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
    var valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
    var pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
    var dynamicRowHeight = this.gridOptionsWrapper.isDynamicRowHeight();
    var params = {
      // the columns the user has grouped and aggregated by
      valueCols: valueColumnVos,
      rowGroupCols: rowGroupColumnVos,
      pivotCols: pivotColumnVos,
      pivotMode: this.columnModel.isPivotMode(),
      // sort and filter model
      filterModel: this.filterManager.getFilterModel(),
      sortModel: this.sortListener.extractSortModel(),
      datasource: this.datasource,
      lastAccessedSequence: new NumberSequence(),
      // blockSize: blockSize == null ? 100 : blockSize,
      dynamicRowHeight: dynamicRowHeight
    };
    return params;
  };
  ServerSideRowModel.prototype.getParams = function () {
    return this.storeParams;
  };
  ServerSideRowModel.prototype.dispatchModelUpdated = function (reset) {
    if (reset === void 0) {
      reset = false;
    }
    var modelUpdatedEvent = {
      type: Events.EVENT_MODEL_UPDATED,
      api: this.gridApi,
      columnApi: this.columnApi,
      animate: !reset,
      keepRenderedRows: !reset,
      newPage: false,
      newData: false
    };
    this.eventService.dispatchEvent(modelUpdatedEvent);
  };
  ServerSideRowModel.prototype.onStoreUpdated = function () {
    // sometimes if doing a batch update, we do the batch first,
    // then call onStoreUpdated manually. eg expandAll() method.
    if (this.pauseStoreUpdateListening) {
      return;
    }
    this.updateRowIndexesAndBounds();
    this.dispatchModelUpdated();
  };
  ServerSideRowModel.prototype.onRowHeightChanged = function () {
    this.updateRowIndexesAndBounds();
    this.dispatchModelUpdated();
  };
  ServerSideRowModel.prototype.updateRowIndexesAndBounds = function () {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.setDisplayIndexes(new NumberSequence(), {
      value: 0
    });
  };
  ServerSideRowModel.prototype.retryLoads = function () {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.retryLoads();
    this.onStoreUpdated();
  };
  ServerSideRowModel.prototype.getRow = function (index) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return undefined;
    }
    return rootStore.getRowUsingDisplayIndex(index);
  };
  ServerSideRowModel.prototype.expandAll = function (value) {
    // if we don't pause store updating, we are needlessly
    // recalculating row-indexes etc, and also getting rendering
    // engine to re-render (listens on ModelUpdated event)
    this.pauseStoreUpdateListening = true;
    this.forEachNode(function (node) {
      if (node.group) {
        node.setExpanded(value);
      }
    });
    this.pauseStoreUpdateListening = false;
    this.onStoreUpdated();
  };
  ServerSideRowModel.prototype.refreshAfterFilter = function (newFilterModel, params) {
    if (this.storeParams) {
      this.storeParams.filterModel = newFilterModel;
    }
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.refreshAfterFilter(params);
    this.onStoreUpdated();
  };
  ServerSideRowModel.prototype.getRootStore = function () {
    if (this.rootNode && this.rootNode.childStore) {
      return this.rootNode.childStore;
    }
  };
  ServerSideRowModel.prototype.getRowCount = function () {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return 1;
    }
    return rootStore.getDisplayIndexEnd();
  };
  ServerSideRowModel.prototype.getTopLevelRowCount = function () {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return 1;
    }
    return rootStore.getRowCount();
  };
  ServerSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return topLevelIndex;
    }
    return rootStore.getTopLevelRowDisplayedIndex(topLevelIndex);
  };
  ServerSideRowModel.prototype.getRowBounds = function (index) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      var rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
      return {
        rowTop: 0,
        rowHeight: rowHeight
      };
    }
    return rootStore.getRowBounds(index);
  };
  ServerSideRowModel.prototype.getRowIndexAtPixel = function (pixel) {
    var rootStore = this.getRootStore();
    if (pixel <= 0 || !rootStore) {
      return 0;
    }
    return rootStore.getRowIndexAtPixel(pixel);
  };
  ServerSideRowModel.prototype.isEmpty = function () {
    return false;
  };
  ServerSideRowModel.prototype.isRowsToRender = function () {
    return this.getRootStore() != null && this.getRowCount() > 0;
  };
  ServerSideRowModel.prototype.getType = function () {
    return Constants.ROW_MODEL_TYPE_SERVER_SIDE;
  };
  ServerSideRowModel.prototype.forEachNode = function (callback) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.forEachNodeDeep(callback);
  };
  ServerSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    rootStore.forEachNodeDeepAfterFilterAndSort(callback);
  };
  ServerSideRowModel.prototype.executeOnStore = function (route, callback) {
    var rootStore = this.getRootStore();
    if (!rootStore) {
      return;
    }
    var storeToExecuteOn = rootStore.getChildStore(route);
    if (storeToExecuteOn) {
      callback(storeToExecuteOn);
    }
  };
  ServerSideRowModel.prototype.refreshStore = function (params) {
    if (params === void 0) {
      params = {};
    }
    var route = params.route ? params.route : [];
    this.executeOnStore(route, function (store) {
      return store.refreshStore(params.purge == true);
    });
  };
  ServerSideRowModel.prototype.getStoreState = function () {
    var res = [];
    var rootStore = this.getRootStore();
    if (rootStore) {
      rootStore.addStoreStates(res);
    }
    return res;
  };
  ServerSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
    if (_.exists(lastInRange) && firstInRange.parent !== lastInRange.parent) {
      return [];
    }
    return firstInRange.parent.childStore.getRowNodesInRange(lastInRange, firstInRange);
  };
  ServerSideRowModel.prototype.getRowNode = function (id) {
    var result = undefined;
    this.forEachNode(function (rowNode) {
      if (rowNode.id === id) {
        result = rowNode;
      }
      if (rowNode.detailNode && rowNode.detailNode.id === id) {
        result = rowNode.detailNode;
      }
    });
    return result;
  };
  ServerSideRowModel.prototype.isRowPresent = function (rowNode) {
    var foundRowNode = this.getRowNode(rowNode.id);
    return !!foundRowNode;
  };
  __decorate$46([Autowired('columnModel')], ServerSideRowModel.prototype, "columnModel", void 0);
  __decorate$46([Autowired('filterManager')], ServerSideRowModel.prototype, "filterManager", void 0);
  __decorate$46([Autowired('sortController')], ServerSideRowModel.prototype, "sortController", void 0);
  __decorate$46([Autowired('gridApi')], ServerSideRowModel.prototype, "gridApi", void 0);
  __decorate$46([Autowired('columnApi')], ServerSideRowModel.prototype, "columnApi", void 0);
  __decorate$46([Autowired('rowRenderer')], ServerSideRowModel.prototype, "rowRenderer", void 0);
  __decorate$46([Autowired('ssrmSortService')], ServerSideRowModel.prototype, "sortListener", void 0);
  __decorate$46([Autowired('ssrmNodeManager')], ServerSideRowModel.prototype, "nodeManager", void 0);
  __decorate$46([Autowired('ssrmStoreFactory')], ServerSideRowModel.prototype, "storeFactory", void 0);
  __decorate$46([Autowired('beans')], ServerSideRowModel.prototype, "beans", void 0);
  __decorate$46([PreDestroy], ServerSideRowModel.prototype, "destroyDatasource", null);
  __decorate$46([__param$b(0, Qualifier('loggerFactory'))], ServerSideRowModel.prototype, "setBeans", null);
  __decorate$46([PostConstruct], ServerSideRowModel.prototype, "addEventListeners", null);
  __decorate$46([PreDestroy], ServerSideRowModel.prototype, "destroyRootStore", null);
  ServerSideRowModel = __decorate$46([Bean('rowModel')], ServerSideRowModel);
  return ServerSideRowModel;
}(BeanStub);
var __extends$5E = undefined && undefined.__extends || function () {
  var _extendStatics369 = function extendStatics(d, b) {
    _extendStatics369 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics369(d, b);
  };
  return function (d, b) {
    _extendStatics369(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$47 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StoreUtils = /** @class */function (_super) {
  __extends$5E(StoreUtils, _super);
  function StoreUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  StoreUtils.prototype.createGroupKeys = function (groupNode) {
    var keys = [];
    var pointer = groupNode;
    while (pointer && pointer.level >= 0) {
      keys.push(pointer.key);
      pointer = pointer.parent;
    }
    keys.reverse();
    return keys;
  };
  StoreUtils.prototype.loadFromDatasource = function (p) {
    var groupKeys = this.createGroupKeys(p.parentNode);
    var storeParams = p.storeParams;
    if (!storeParams.datasource) {
      return;
    }
    var request = {
      startRow: p.startRow,
      endRow: p.endRow,
      rowGroupCols: storeParams.rowGroupCols,
      valueCols: storeParams.valueCols,
      pivotCols: storeParams.pivotCols,
      pivotMode: storeParams.pivotMode,
      groupKeys: groupKeys,
      filterModel: storeParams.filterModel,
      sortModel: storeParams.sortModel
    };
    var getRowsParams = {
      successCallback: p.successCallback,
      success: p.success,
      failCallback: p.failCallback,
      fail: p.fail,
      request: request,
      parentNode: p.parentNode,
      api: this.gridApi,
      columnApi: this.columnApi
    };
    window.setTimeout(function () {
      if (storeParams.datasource) {
        storeParams.datasource.getRows(getRowsParams);
      }
    }, 0);
  };
  StoreUtils.prototype.getChildStore = function (keys, currentCache, findNodeFunc) {
    if (_.missingOrEmpty(keys)) {
      return currentCache;
    }
    var nextKey = keys[0];
    var nextNode = findNodeFunc(nextKey);
    if (nextNode) {
      var keyListForNextLevel = keys.slice(1, keys.length);
      var nextStore = nextNode.childStore;
      return nextStore ? nextStore.getChildStore(keyListForNextLevel) : null;
    }
    return null;
  };
  StoreUtils.prototype.isServerRefreshNeeded = function (parentRowNode, rowGroupCols, params) {
    if (params.alwaysReset || params.valueColChanged || params.secondaryColChanged) {
      return true;
    }
    var level = parentRowNode.level + 1;
    var grouping = level < rowGroupCols.length;
    var leafNodes = !grouping;
    if (leafNodes) {
      return true;
    }
    var colIdThisGroup = rowGroupCols[level].id;
    var actionOnThisGroup = params.changedColumns.indexOf(colIdThisGroup) > -1;
    if (actionOnThisGroup) {
      return true;
    }
    return false;
  };
  __decorate$47([Autowired('columnApi')], StoreUtils.prototype, "columnApi", void 0);
  __decorate$47([Autowired('gridApi')], StoreUtils.prototype, "gridApi", void 0);
  StoreUtils = __decorate$47([Bean('ssrmCacheUtils')], StoreUtils);
  return StoreUtils;
}(BeanStub);
var __extends$5F = undefined && undefined.__extends || function () {
  var _extendStatics370 = function extendStatics(d, b) {
    _extendStatics370 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics370(d, b);
  };
  return function (d, b) {
    _extendStatics370(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$48 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BlockUtils = /** @class */function (_super) {
  __extends$5F(BlockUtils, _super);
  function BlockUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BlockUtils.prototype.postConstruct = function () {
    this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
    this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    this.usingMasterDetail = this.gridOptionsWrapper.isMasterDetail();
  };
  BlockUtils.prototype.createRowNode = function (params) {
    var rowNode = new RowNode(this.beans);
    rowNode.setRowHeight(this.rowHeight);
    rowNode.group = params.group;
    rowNode.leafGroup = params.leafGroup;
    rowNode.level = params.level;
    rowNode.uiLevel = params.level;
    rowNode.parent = params.parent;
    // stub gets set to true here, and then false when this rowNode gets it's data
    rowNode.stub = true;
    if (rowNode.group) {
      rowNode.expanded = false;
      rowNode.field = params.field;
      rowNode.rowGroupColumn = params.rowGroupColumn;
    }
    return rowNode;
  };
  BlockUtils.prototype.destroyRowNodes = function (rowNodes) {
    if (rowNodes) {
      rowNodes.forEach(this.destroyRowNode.bind(this));
    }
  };
  BlockUtils.prototype.destroyRowNode = function (rowNode) {
    if (rowNode.childStore) {
      this.destroyBean(rowNode.childStore);
      rowNode.childStore = null;
    }
    // this is needed, so row render knows to fade out the row, otherwise it
    // sees row top is present, and thinks the row should be shown. maybe
    // rowNode should have a flag on whether it is visible???
    rowNode.clearRowTopAndRowIndex();
    if (rowNode.id != null) {
      this.nodeManager.removeNode(rowNode);
    }
  };
  BlockUtils.prototype.setDataIntoRowNode = function (rowNode, data, defaultId) {
    rowNode.stub = false;
    if (_.exists(data)) {
      rowNode.setDataAndId(data, defaultId);
      if (this.usingTreeData) {
        var isGroupFunc = this.gridOptionsWrapper.getIsServerSideGroupFunc();
        var getKeyFunc = this.gridOptionsWrapper.getServerSideGroupKeyFunc();
        if (isGroupFunc != null) {
          rowNode.group = isGroupFunc(rowNode.data);
          if (rowNode.group && getKeyFunc != null) {
            rowNode.key = getKeyFunc(rowNode.data);
          }
        }
      } else if (rowNode.group) {
        rowNode.key = this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
        if (rowNode.key === null || rowNode.key === undefined) {
          _.doOnce(function () {
            console.warn("null and undefined values are not allowed for server side row model keys");
            if (rowNode.rowGroupColumn) {
              console.warn("column = " + rowNode.rowGroupColumn.getId());
            }
            console.warn("data is ", rowNode.data);
          }, 'ServerSideBlock-CannotHaveNullOrUndefinedForKey');
        }
      } else if (this.usingMasterDetail) {
        var isMasterFunc = this.gridOptionsWrapper.getIsRowMasterFunc();
        if (isMasterFunc != null) {
          rowNode.master = isMasterFunc(rowNode.data);
        } else {
          rowNode.master = true;
        }
      }
    } else {
      rowNode.setDataAndId(undefined, undefined);
      rowNode.key = null;
    }
    if (this.usingTreeData || rowNode.group) {
      this.setGroupDataIntoRowNode(rowNode);
      this.setChildCountIntoRowNode(rowNode);
    }
    // this needs to be done AFTER setGroupDataIntoRowNode(), as the height can depend on the group data
    // getting set, if it's a group node and colDef.autoHeight=true
    if (_.exists(data)) {
      rowNode.setRowHeight(this.gridOptionsWrapper.getRowHeightForNode(rowNode).height);
    }
  };
  BlockUtils.prototype.setChildCountIntoRowNode = function (rowNode) {
    var getChildCount = this.gridOptionsWrapper.getChildCountFunc();
    if (getChildCount) {
      rowNode.allChildrenCount = getChildCount(rowNode.data);
    }
  };
  BlockUtils.prototype.setGroupDataIntoRowNode = function (rowNode) {
    var _this = this;
    var groupDisplayCols = this.columnModel.getGroupDisplayColumns();
    var usingTreeData = this.gridOptionsWrapper.isTreeData();
    groupDisplayCols.forEach(function (col) {
      if (rowNode.groupData == null) {
        rowNode.groupData = {};
      }
      if (usingTreeData) {
        rowNode.groupData[col.getColId()] = rowNode.key;
      } else if (col.isRowGroupDisplayed(rowNode.rowGroupColumn.getId())) {
        var groupValue = _this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
        rowNode.groupData[col.getColId()] = groupValue;
      }
    });
  };
  BlockUtils.prototype.clearDisplayIndex = function (rowNode) {
    rowNode.clearRowTopAndRowIndex();
    var hasChildStore = rowNode.group && _.exists(rowNode.childStore);
    if (hasChildStore) {
      var childStore = rowNode.childStore;
      childStore.clearDisplayIndexes();
    }
    var hasDetailNode = rowNode.master && rowNode.detailNode;
    if (hasDetailNode) {
      rowNode.detailNode.clearRowTopAndRowIndex();
    }
  };
  BlockUtils.prototype.setDisplayIndex = function (rowNode, displayIndexSeq, nextRowTop) {
    // set this row
    rowNode.setRowIndex(displayIndexSeq.next());
    rowNode.setRowTop(nextRowTop.value);
    nextRowTop.value += rowNode.rowHeight;
    // set child for master / detail
    var hasDetailRow = rowNode.master;
    if (hasDetailRow) {
      if (rowNode.expanded && rowNode.detailNode) {
        rowNode.detailNode.setRowIndex(displayIndexSeq.next());
        rowNode.detailNode.setRowTop(nextRowTop.value);
        nextRowTop.value += rowNode.detailNode.rowHeight;
      } else if (rowNode.detailNode) {
        rowNode.detailNode.clearRowTopAndRowIndex();
      }
    }
    // set children for SSRM child rows
    var hasChildStore = rowNode.group && _.exists(rowNode.childStore);
    if (hasChildStore) {
      var childStore = rowNode.childStore;
      if (rowNode.expanded) {
        childStore.setDisplayIndexes(displayIndexSeq, nextRowTop);
      } else {
        // we need to clear the row tops, as the row renderer depends on
        // this to know if the row should be faded out
        childStore.clearDisplayIndexes();
      }
    }
  };
  BlockUtils.prototype.binarySearchForDisplayIndex = function (displayRowIndex, rowNodes) {
    var bottomPointer = 0;
    var topPointer = rowNodes.length - 1;
    if (_.missing(topPointer) || _.missing(bottomPointer)) {
      console.warn("ag-grid: error: topPointer = " + topPointer + ", bottomPointer = " + bottomPointer);
      return undefined;
    }
    while (true) {
      var midPointer = Math.floor((bottomPointer + topPointer) / 2);
      var currentRowNode = rowNodes[midPointer];
      // first check current row for index
      if (currentRowNode.rowIndex === displayRowIndex) {
        return currentRowNode;
      }
      // then check if current row contains a detail row with the index
      var expandedMasterRow = currentRowNode.master && currentRowNode.expanded;
      if (expandedMasterRow && currentRowNode.detailNode.rowIndex === displayRowIndex) {
        return currentRowNode.detailNode;
      }
      // then check if child cache contains index
      var childStore = currentRowNode.childStore;
      if (currentRowNode.expanded && childStore && childStore.isDisplayIndexInStore(displayRowIndex)) {
        return childStore.getRowUsingDisplayIndex(displayRowIndex);
      }
      // otherwise adjust pointers to continue searching for index
      if (currentRowNode.rowIndex < displayRowIndex) {
        bottomPointer = midPointer + 1;
      } else if (currentRowNode.rowIndex > displayRowIndex) {
        topPointer = midPointer - 1;
      } else {
        console.warn("AG Grid: error: unable to locate rowIndex = " + displayRowIndex + " in cache");
        return undefined;
      }
    }
  };
  BlockUtils.prototype.extractRowBounds = function (rowNode, index) {
    var extractRowBounds = function extractRowBounds(currentRowNode) {
      return {
        rowHeight: currentRowNode.rowHeight,
        rowTop: currentRowNode.rowTop
      };
    };
    if (rowNode.rowIndex === index) {
      return extractRowBounds(rowNode);
    }
    if (rowNode.group && rowNode.expanded && _.exists(rowNode.childStore)) {
      var childStore = rowNode.childStore;
      if (childStore.isDisplayIndexInStore(index)) {
        return childStore.getRowBounds(index);
      }
    } else if (rowNode.master && rowNode.expanded && _.exists(rowNode.detailNode)) {
      if (rowNode.detailNode.rowIndex === index) {
        return extractRowBounds(rowNode.detailNode);
      }
    }
  };
  BlockUtils.prototype.getIndexAtPixel = function (rowNode, pixel) {
    // first check if pixel is in range of current row
    if (rowNode.isPixelInRange(pixel)) {
      return rowNode.rowIndex;
    }
    // then check if current row contains a detail row with pixel in range
    var expandedMasterRow = rowNode.master && rowNode.expanded;
    if (expandedMasterRow && rowNode.detailNode.isPixelInRange(pixel)) {
      return rowNode.detailNode.rowIndex;
    }
    // then check if it's a group row with a child cache with pixel in range
    if (rowNode.group && rowNode.expanded && _.exists(rowNode.childStore)) {
      var childStore = rowNode.childStore;
      if (childStore.isPixelInRange(pixel)) {
        return childStore.getRowIndexAtPixel(pixel);
      }
    }
    return null;
    // pixel is not within this row node or it's children / detail, so return undefined
  };

  BlockUtils.prototype.createNodeIdPrefix = function (parentRowNode) {
    var parts = [];
    var rowNode = parentRowNode;
    // pull keys from all parent nodes, but do not include the root node
    while (rowNode && rowNode.level >= 0) {
      parts.push(rowNode.key);
      rowNode = rowNode.parent;
    }
    if (parts.length > 0) {
      return parts.reverse().join('-');
    }
    // no prefix, so node id's are left as they are
    return undefined;
  };
  BlockUtils.prototype.checkOpenByDefault = function (rowNode) {
    if (!rowNode.isExpandable()) {
      return;
    }
    var userFunc = this.gridOptionsWrapper.getIsServerSideGroupOpenByDefaultFunc();
    if (!userFunc) {
      return;
    }
    var params = {
      data: rowNode.data,
      rowNode: rowNode
    };
    var userFuncRes = userFunc(params);
    if (userFuncRes) {
      // we do this in a timeout, so that we don't expand a row node while in the middle
      // of setting up rows, setting up rows is complex enough without another chunk of work
      // getting added to the call stack. this is also helpful as openByDefault may or may
      // not happen (so makes setting up rows more deterministic by expands never happening)
      // and also checkOpenByDefault is shard with both store types, so easier control how it
      // impacts things by keeping it in new VM turn.
      window.setTimeout(function () {
        return rowNode.setExpanded(true);
      }, 0);
    }
  };
  __decorate$48([Autowired('valueService')], BlockUtils.prototype, "valueService", void 0);
  __decorate$48([Autowired('columnModel')], BlockUtils.prototype, "columnModel", void 0);
  __decorate$48([Autowired('ssrmNodeManager')], BlockUtils.prototype, "nodeManager", void 0);
  __decorate$48([Autowired('beans')], BlockUtils.prototype, "beans", void 0);
  __decorate$48([PostConstruct], BlockUtils.prototype, "postConstruct", null);
  BlockUtils = __decorate$48([Bean('ssrmBlockUtils')], BlockUtils);
  return BlockUtils;
}(BeanStub);
var __decorate$49 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NodeManager = /** @class */function () {
  function NodeManager() {
    this.rowNodes = {};
  }
  NodeManager.prototype.addRowNode = function (rowNode) {
    var id = rowNode.id;
    if (this.rowNodes[id]) {
      console.warn('AG Grid: duplicate node id ' + rowNode.id);
      console.warn('first instance', this.rowNodes[id].data);
      console.warn('second instance', rowNode.data);
    }
    this.rowNodes[id] = rowNode;
  };
  NodeManager.prototype.removeNode = function (rowNode) {
    var id = rowNode.id;
    if (this.rowNodes[id]) {
      this.rowNodes[id] = undefined;
    }
  };
  NodeManager.prototype.clear = function () {
    this.rowNodes = {};
  };
  __decorate$49([PreDestroy], NodeManager.prototype, "clear", null);
  NodeManager = __decorate$49([Bean('ssrmNodeManager')], NodeManager);
  return NodeManager;
}();
var __extends$5G = undefined && undefined.__extends || function () {
  var _extendStatics371 = function extendStatics(d, b) {
    _extendStatics371 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics371(d, b);
  };
  return function (d, b) {
    _extendStatics371(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TransactionManager = /** @class */function (_super) {
  __extends$5G(TransactionManager, _super);
  function TransactionManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.asyncTransactions = [];
    return _this;
  }
  TransactionManager.prototype.postConstruct = function () {
    // only want to be active if SSRM active, otherwise would be interfering with other row models
    if (!this.gridOptionsWrapper.isRowModelServerSide()) {
      return;
    }
  };
  TransactionManager.prototype.applyTransactionAsync = function (transaction, callback) {
    if (this.asyncTransactionsTimeout == null) {
      this.scheduleExecuteAsync();
    }
    this.asyncTransactions.push({
      transaction: transaction,
      callback: callback
    });
  };
  TransactionManager.prototype.scheduleExecuteAsync = function () {
    var _this = this;
    var waitMillis = this.gridOptionsWrapper.getAsyncTransactionWaitMillis();
    this.asyncTransactionsTimeout = window.setTimeout(function () {
      _this.executeAsyncTransactions();
    }, waitMillis);
  };
  TransactionManager.prototype.executeAsyncTransactions = function () {
    var _this = this;
    if (!this.asyncTransactions) {
      return;
    }
    var resultFuncs = [];
    var resultsForEvent = [];
    var transactionsToRetry = [];
    var atLeastOneTransactionApplied = false;
    this.asyncTransactions.forEach(function (txWrapper) {
      var result;
      _this.serverSideRowModel.executeOnStore(txWrapper.transaction.route, function (cache) {
        result = cache.applyTransaction(txWrapper.transaction);
      });
      if (result == undefined) {
        result = {
          status: ServerSideTransactionResultStatus.StoreNotFound
        };
      }
      resultsForEvent.push(result);
      var retryTransaction = result.status == ServerSideTransactionResultStatus.StoreLoading;
      if (retryTransaction) {
        transactionsToRetry.push(txWrapper);
        return;
      }
      if (txWrapper.callback) {
        resultFuncs.push(function () {
          return txWrapper.callback(result);
        });
      }
      if (result.status === ServerSideTransactionResultStatus.Applied) {
        atLeastOneTransactionApplied = true;
      }
    });
    // do callbacks in next VM turn so it's async
    if (resultFuncs.length > 0) {
      window.setTimeout(function () {
        resultFuncs.forEach(function (func) {
          return func();
        });
      }, 0);
    }
    this.asyncTransactionsTimeout = undefined;
    // this will be empty list if nothing to retry
    this.asyncTransactions = transactionsToRetry;
    if (atLeastOneTransactionApplied) {
      this.valueCache.onDataChanged();
      this.eventService.dispatchEvent({
        type: Events.EVENT_STORE_UPDATED
      });
    }
    if (resultsForEvent.length > 0) {
      var event_1 = {
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        type: Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
        results: resultsForEvent
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  TransactionManager.prototype.flushAsyncTransactions = function () {
    // the timeout could be missing, if we are flushing due to row data loaded
    if (this.asyncTransactionsTimeout != null) {
      clearTimeout(this.asyncTransactionsTimeout);
    }
    this.executeAsyncTransactions();
  };
  TransactionManager.prototype.applyTransaction = function (transaction) {
    var res;
    this.serverSideRowModel.executeOnStore(transaction.route, function (store) {
      res = store.applyTransaction(transaction);
    });
    if (res) {
      this.valueCache.onDataChanged();
      this.eventService.dispatchEvent({
        type: Events.EVENT_STORE_UPDATED
      });
      return res;
    } else {
      return {
        status: ServerSideTransactionResultStatus.StoreNotFound
      };
    }
  };
  __decorate$4a([Autowired('rowNodeBlockLoader')], TransactionManager.prototype, "rowNodeBlockLoader", void 0);
  __decorate$4a([Autowired('valueCache')], TransactionManager.prototype, "valueCache", void 0);
  __decorate$4a([Autowired('rowModel')], TransactionManager.prototype, "serverSideRowModel", void 0);
  __decorate$4a([PostConstruct], TransactionManager.prototype, "postConstruct", null);
  TransactionManager = __decorate$4a([Bean('ssrmTransactionManager')], TransactionManager);
  return TransactionManager;
}(BeanStub);
var __extends$5H = undefined && undefined.__extends || function () {
  var _extendStatics372 = function extendStatics(d, b) {
    _extendStatics372 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics372(d, b);
  };
  return function (d, b) {
    _extendStatics372(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4b = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ExpandListener = /** @class */function (_super) {
  __extends$5H(ExpandListener, _super);
  function ExpandListener() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ExpandListener.prototype.postConstruct = function () {
    // only want to be active if SSRM active, otherwise would be interfering with other row models
    if (!this.gridOptionsWrapper.isRowModelServerSide()) {
      return;
    }
    this.addManagedListener(this.eventService, Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
  };
  ExpandListener.prototype.onRowGroupOpened = function (event) {
    var rowNode = event.node;
    if (rowNode.expanded) {
      if (rowNode.master) {
        this.createDetailNode(rowNode);
      } else if (_.missing(rowNode.childStore)) {
        var storeParams = this.serverSideRowModel.getParams();
        rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
      }
    } else if (this.gridOptionsWrapper.isPurgeClosedRowNodes() && _.exists(rowNode.childStore)) {
      rowNode.childStore = this.destroyBean(rowNode.childStore);
    }
    var storeUpdatedEvent = {
      type: Events.EVENT_STORE_UPDATED
    };
    this.eventService.dispatchEvent(storeUpdatedEvent);
  };
  ExpandListener.prototype.createDetailNode = function (masterNode) {
    if (_.exists(masterNode.detailNode)) {
      return masterNode.detailNode;
    }
    var detailNode = new RowNode(this.beans);
    detailNode.detail = true;
    detailNode.selectable = false;
    detailNode.parent = masterNode;
    if (_.exists(masterNode.id)) {
      detailNode.id = 'detail_' + masterNode.id;
    }
    detailNode.data = masterNode.data;
    detailNode.level = masterNode.level + 1;
    var defaultDetailRowHeight = 200;
    var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(detailNode).height;
    detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
    masterNode.detailNode = detailNode;
    return detailNode;
  };
  __decorate$4b([Autowired('rowModel')], ExpandListener.prototype, "serverSideRowModel", void 0);
  __decorate$4b([Autowired('ssrmStoreFactory')], ExpandListener.prototype, "storeFactory", void 0);
  __decorate$4b([Autowired('beans')], ExpandListener.prototype, "beans", void 0);
  __decorate$4b([PostConstruct], ExpandListener.prototype, "postConstruct", null);
  ExpandListener = __decorate$4b([Bean('ssrmExpandListener')], ExpandListener);
  return ExpandListener;
}(BeanStub);
var __extends$5I = undefined && undefined.__extends || function () {
  var _extendStatics373 = function extendStatics(d, b) {
    _extendStatics373 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics373(d, b);
  };
  return function (d, b) {
    _extendStatics373(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4c = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SortListener = /** @class */function (_super) {
  __extends$5I(SortListener, _super);
  function SortListener() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SortListener.prototype.postConstruct = function () {
    // only want to be active if SSRM active, otherwise would be interfering with other row models
    if (!this.gridOptionsWrapper.isRowModelServerSide()) {
      return;
    }
    this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
  };
  SortListener.prototype.extractSortModel = function () {
    var sortModel = this.sortController.getSortModel();
    // when using tree data we just return the sort model with the 'ag-Grid-AutoColumn' as is, i.e not broken out
    // into it's constitute group columns as they are not defined up front and can vary per node.
    if (this.gridOptionsWrapper.isTreeData()) {
      return sortModel;
    }
    // it autoCol is active, we don't want to send this to the server. instead we want to
    // send the
    this.replaceAutoGroupColumnWithActualRowGroupColumns(sortModel);
    this.removeMultiColumnPrefixOnColumnIds(sortModel);
    return sortModel;
  };
  SortListener.prototype.removeMultiColumnPrefixOnColumnIds = function (sortModel) {
    if (this.gridOptionsWrapper.isGroupMultiAutoColumn()) {
      var multiColumnPrefix = Constants.GROUP_AUTO_COLUMN_ID + "-";
      for (var i = 0; i < sortModel.length; ++i) {
        if (sortModel[i].colId.indexOf(multiColumnPrefix) > -1) {
          sortModel[i].colId = sortModel[i].colId.substr(multiColumnPrefix.length);
        }
      }
    }
  };
  SortListener.prototype.replaceAutoGroupColumnWithActualRowGroupColumns = function (sortModel) {
    // find index of auto group column in sort model
    var autoGroupSortModel = _.find(sortModel, function (sm) {
      return sm.colId == Constants.GROUP_AUTO_COLUMN_ID;
    });
    // replace auto column with individual group columns
    if (autoGroupSortModel) {
      // remove auto group column
      var autoGroupIndex = sortModel.indexOf(autoGroupSortModel);
      _.removeFromArray(sortModel, autoGroupSortModel);
      var isNotInSortModel = function isNotInSortModel(col) {
        return sortModel.filter(function (sm) {
          return sm.colId === col.getColId();
        }).length == 0;
      };
      var mapColumnToSortModel = function mapColumnToSortModel(col) {
        return {
          colId: col.getId(),
          sort: autoGroupSortModel.sort
        };
      };
      var newModels = this.columnModel.getRowGroupColumns().filter(isNotInSortModel).map(mapColumnToSortModel);
      _.insertArrayIntoArray(sortModel, newModels, autoGroupIndex);
    }
  };
  SortListener.prototype.onSortChanged = function () {
    var storeParams = this.serverSideRowModel.getParams();
    if (!storeParams) {
      return;
    } // params is undefined if no datasource set
    var newSortModel = this.extractSortModel();
    var oldSortModel = storeParams.sortModel;
    var changedColumns = this.findChangedColumnsInSort(newSortModel, oldSortModel);
    var valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
    var secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
    var alwaysReset = this.gridOptionsWrapper.isServerSideSortingAlwaysResets();
    var params = {
      valueColChanged: valueColChanged,
      secondaryColChanged: secondaryColChanged,
      alwaysReset: alwaysReset,
      changedColumns: changedColumns
    };
    this.serverSideRowModel.refreshAfterSort(newSortModel, params);
  };
  // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
  // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
  // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
  // was previously sorted by A and then the A sort now needs to be cleared.
  SortListener.prototype.findChangedColumnsInSort = function (newSortModel, oldSortModel) {
    var allColsInBothSorts = [];
    [newSortModel, oldSortModel].forEach(function (sortModel) {
      if (sortModel) {
        var ids = sortModel.map(function (sm) {
          return sm.colId;
        });
        allColsInBothSorts = allColsInBothSorts.concat(ids);
      }
    });
    var differentSorts = function differentSorts(oldSortItem, newSortItem) {
      var oldSort = oldSortItem ? oldSortItem.sort : null;
      var newSort = newSortItem ? newSortItem.sort : null;
      return oldSort !== newSort;
    };
    var differentIndexes = function differentIndexes(oldSortItem, newSortItem) {
      var oldIndex = oldSortModel.indexOf(oldSortItem);
      var newIndex = newSortModel.indexOf(newSortItem);
      return oldIndex !== newIndex;
    };
    return allColsInBothSorts.filter(function (colId) {
      var oldSortItem = _.find(oldSortModel, function (sm) {
        return sm.colId === colId;
      });
      var newSortItem = _.find(newSortModel, function (sm) {
        return sm.colId === colId;
      });
      return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
    });
  };
  __decorate$4c([Autowired('sortController')], SortListener.prototype, "sortController", void 0);
  __decorate$4c([Autowired('columnModel')], SortListener.prototype, "columnModel", void 0);
  __decorate$4c([Autowired('rowModel')], SortListener.prototype, "serverSideRowModel", void 0);
  __decorate$4c([Autowired('ssrmListenerUtils')], SortListener.prototype, "listenerUtils", void 0);
  __decorate$4c([PostConstruct], SortListener.prototype, "postConstruct", null);
  SortListener = __decorate$4c([Bean('ssrmSortService')], SortListener);
  return SortListener;
}(BeanStub);
var __extends$5J = undefined && undefined.__extends || function () {
  var _extendStatics374 = function extendStatics(d, b) {
    _extendStatics374 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics374(d, b);
  };
  return function (d, b) {
    _extendStatics374(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4d = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterListener = /** @class */function (_super) {
  __extends$5J(FilterListener, _super);
  function FilterListener() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FilterListener.prototype.postConstruct = function () {
    // only want to be active if SSRM active, otherwise would be interfering with other row models
    if (!this.gridOptionsWrapper.isRowModelServerSide()) {
      return;
    }
    this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
  };
  FilterListener.prototype.onFilterChanged = function () {
    var storeParams = this.serverSideRowModel.getParams();
    if (!storeParams) {
      return;
    } // params is undefined if no datasource set
    var newModel = this.filterManager.getFilterModel();
    var oldModel = storeParams ? storeParams.filterModel : {};
    var changedColumns = this.findChangedColumns(newModel, oldModel);
    var valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
    var secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
    var alwaysReset = this.gridOptionsWrapper.isServerSideFilteringAlwaysResets();
    var params = {
      valueColChanged: valueColChanged,
      secondaryColChanged: secondaryColChanged,
      alwaysReset: alwaysReset,
      changedColumns: changedColumns
    };
    this.serverSideRowModel.refreshAfterFilter(newModel, params);
  };
  FilterListener.prototype.findChangedColumns = function (oldModel, newModel) {
    var allColKeysMap = {};
    Object.keys(oldModel).forEach(function (key) {
      return allColKeysMap[key] = true;
    });
    Object.keys(newModel).forEach(function (key) {
      return allColKeysMap[key] = true;
    });
    var res = [];
    Object.keys(allColKeysMap).forEach(function (key) {
      var oldJson = JSON.stringify(oldModel[key]);
      var newJson = JSON.stringify(newModel[key]);
      var filterChanged = oldJson != newJson;
      if (filterChanged) {
        res.push(key);
      }
    });
    return res;
  };
  __decorate$4d([Autowired('rowModel')], FilterListener.prototype, "serverSideRowModel", void 0);
  __decorate$4d([Autowired('filterManager')], FilterListener.prototype, "filterManager", void 0);
  __decorate$4d([Autowired('ssrmListenerUtils')], FilterListener.prototype, "listenerUtils", void 0);
  __decorate$4d([PostConstruct], FilterListener.prototype, "postConstruct", null);
  FilterListener = __decorate$4d([Bean('ssrmFilterListener')], FilterListener);
  return FilterListener;
}(BeanStub);
var __extends$5K = undefined && undefined.__extends || function () {
  var _extendStatics375 = function extendStatics(d, b) {
    _extendStatics375 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics375(d, b);
  };
  return function (d, b) {
    _extendStatics375(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4e = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$c = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var PartialStoreBlock = /** @class */function (_super) {
  __extends$5K(PartialStoreBlock, _super);
  function PartialStoreBlock(blockNumber, parentRowNode, ssrmParams, storeParams, parentStore) {
    var _this = _super.call(this, blockNumber) || this;
    _this.ssrmParams = ssrmParams;
    _this.storeParams = storeParams;
    _this.parentRowNode = parentRowNode;
    // we don't need to calculate these now, as the inputs don't change,
    // however it makes the code easier to read if we work them out up front
    _this.startRow = blockNumber * storeParams.cacheBlockSize;
    _this.parentStore = parentStore;
    _this.level = parentRowNode.level + 1;
    _this.groupLevel = ssrmParams.rowGroupCols ? _this.level < ssrmParams.rowGroupCols.length : undefined;
    _this.leafGroup = ssrmParams.rowGroupCols ? _this.level === ssrmParams.rowGroupCols.length - 1 : false;
    return _this;
  }
  PartialStoreBlock.prototype.postConstruct = function () {
    this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    if (!this.usingTreeData && this.groupLevel) {
      var groupColVo = this.ssrmParams.rowGroupCols[this.level];
      this.groupField = groupColVo.field;
      this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
    }
    this.nodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.parentRowNode);
    this.setData([]);
  };
  PartialStoreBlock.prototype.isDisplayIndexInBlock = function (displayIndex) {
    return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
  };
  PartialStoreBlock.prototype.isBlockBefore = function (displayIndex) {
    return displayIndex >= this.displayIndexEnd;
  };
  PartialStoreBlock.prototype.getDisplayIndexStart = function () {
    return this.displayIndexStart;
  };
  PartialStoreBlock.prototype.getDisplayIndexEnd = function () {
    return this.displayIndexEnd;
  };
  PartialStoreBlock.prototype.getBlockHeightPx = function () {
    return this.blockHeightPx;
  };
  PartialStoreBlock.prototype.getBlockTopPx = function () {
    return this.blockTopPx;
  };
  PartialStoreBlock.prototype.isGroupLevel = function () {
    return this.groupLevel;
  };
  PartialStoreBlock.prototype.getGroupField = function () {
    return this.groupField;
  };
  PartialStoreBlock.prototype.prefixId = function (id) {
    if (this.nodeIdPrefix != null) {
      return this.nodeIdPrefix + '-' + id;
    } else {
      return id.toString();
    }
  };
  PartialStoreBlock.prototype.getBlockStateJson = function () {
    return {
      id: this.prefixId(this.getId()),
      state: {
        blockNumber: this.getId(),
        startRow: this.startRow,
        endRow: this.startRow + this.storeParams.cacheBlockSize,
        pageStatus: this.getState()
      }
    };
  };
  PartialStoreBlock.prototype.isAnyNodeOpen = function () {
    var openNodeCount = this.rowNodes.filter(function (node) {
      return node.expanded;
    }).length;
    return openNodeCount > 0;
  };
  // this method is repeated, see forEachRowNode, why?
  PartialStoreBlock.prototype.forEachNode = function (callback, sequence, includeChildren, filterAndSort) {
    if (sequence === void 0) {
      sequence = new NumberSequence();
    }
    this.rowNodes.forEach(function (rowNode) {
      callback(rowNode, sequence.next());
      // this will only every happen for server side row model, as infinite
      // row model doesn't have groups
      if (includeChildren && rowNode.childStore) {
        var childStore = rowNode.childStore;
        if (filterAndSort) {
          childStore.forEachNodeDeepAfterFilterAndSort(callback, sequence);
        } else {
          childStore.forEachNodeDeep(callback, sequence);
        }
      }
    });
  };
  PartialStoreBlock.prototype.forEachNodeDeep = function (callback, sequence) {
    this.forEachNode(callback, sequence, true, false);
  };
  PartialStoreBlock.prototype.forEachNodeAfterFilterAndSort = function (callback, sequence) {
    this.forEachNode(callback, sequence, true, true);
  };
  PartialStoreBlock.prototype.forEachNodeShallow = function (callback, sequence) {
    this.forEachNode(callback, sequence, false, false);
  };
  PartialStoreBlock.prototype.getLastAccessed = function () {
    return this.lastAccessed;
  };
  PartialStoreBlock.prototype.getRowUsingLocalIndex = function (rowIndex) {
    return this.rowNodes[rowIndex - this.startRow];
  };
  PartialStoreBlock.prototype.touchLastAccessed = function () {
    this.lastAccessed = this.ssrmParams.lastAccessedSequence.next();
  };
  PartialStoreBlock.prototype.processServerFail = function () {
    this.parentStore.onBlockLoadFailed(this);
  };
  PartialStoreBlock.prototype.retryLoads = function () {
    if (this.getState() === RowNodeBlock.STATE_FAILED) {
      this.setStateWaitingToLoad();
      this.rowNodeBlockLoader.checkBlockToLoad();
      this.setData();
    }
    this.forEachNodeShallow(function (node) {
      if (node.childStore) {
        node.childStore.retryLoads();
      }
    });
  };
  PartialStoreBlock.prototype.processServerResult = function (params) {
    this.parentStore.onBlockLoaded(this, params);
  };
  PartialStoreBlock.prototype.setData = function (rows, failedLoad) {
    if (rows === void 0) {
      rows = [];
    }
    if (failedLoad === void 0) {
      failedLoad = false;
    }
    this.destroyRowNodes();
    var storeRowCount = this.parentStore.getRowCount();
    var startRow = this.getId() * this.storeParams.cacheBlockSize;
    var endRow = Math.min(startRow + this.storeParams.cacheBlockSize, storeRowCount);
    var rowsToCreate = endRow - startRow;
    for (var i = 0; i < rowsToCreate; i++) {
      var rowNode = this.blockUtils.createRowNode({
        field: this.groupField,
        group: this.groupLevel,
        leafGroup: this.leafGroup,
        level: this.level,
        parent: this.parentRowNode,
        rowGroupColumn: this.rowGroupColumn
      });
      var dataLoadedForThisRow = i < rows.length;
      if (dataLoadedForThisRow) {
        var data = rows[i];
        var defaultId = this.prefixId(this.startRow + i);
        this.blockUtils.setDataIntoRowNode(rowNode, data, defaultId);
        var newId = rowNode.id;
        this.parentStore.removeDuplicateNode(newId);
        this.nodeManager.addRowNode(rowNode);
        this.allNodesMap[rowNode.id] = rowNode;
        this.blockUtils.checkOpenByDefault(rowNode);
      }
      this.rowNodes.push(rowNode);
      if (failedLoad) {
        rowNode.failedLoad = true;
      }
    }
  };
  // to safeguard the grid against duplicate nodes, when a row is loaded, we check
  // for another row in the same cache. if another row does exist, we delete it.
  // this covers for when user refreshes the store (which typically happens after a
  // data change) and the same row ends up coming back in a different block, and the
  // new block finishes refreshing before the old block has finished refreshing.
  PartialStoreBlock.prototype.removeDuplicateNode = function (id) {
    var rowNode = this.allNodesMap[id];
    if (!rowNode) {
      return;
    }
    this.blockUtils.destroyRowNode(rowNode);
    var index = this.rowNodes.indexOf(rowNode);
    var stubRowNode = this.blockUtils.createRowNode({
      field: this.groupField,
      group: this.groupLevel,
      leafGroup: this.leafGroup,
      level: this.level,
      parent: this.parentRowNode,
      rowGroupColumn: this.rowGroupColumn
    });
    this.rowNodes[index] = stubRowNode;
  };
  PartialStoreBlock.prototype.refresh = function () {
    if (this.getState() !== RowNodeBlock.STATE_WAITING_TO_LOAD) {
      this.setStateWaitingToLoad();
    }
  };
  PartialStoreBlock.prototype.destroyRowNodes = function () {
    this.blockUtils.destroyRowNodes(this.rowNodes);
    this.rowNodes = [];
    this.allNodesMap = {};
  };
  PartialStoreBlock.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('ServerSideBlock');
  };
  PartialStoreBlock.prototype.getRowUsingDisplayIndex = function (displayRowIndex) {
    this.touchLastAccessed();
    var res = this.blockUtils.binarySearchForDisplayIndex(displayRowIndex, this.rowNodes);
    return res;
  };
  PartialStoreBlock.prototype.loadFromDatasource = function () {
    this.cacheUtils.loadFromDatasource({
      startRow: this.startRow,
      endRow: this.startRow + this.storeParams.cacheBlockSize,
      parentNode: this.parentRowNode,
      storeParams: this.ssrmParams,
      successCallback: this.pageLoaded.bind(this, this.getVersion()),
      success: this.success.bind(this, this.getVersion()),
      failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
      fail: this.pageLoadFailed.bind(this, this.getVersion())
    });
  };
  PartialStoreBlock.prototype.isPixelInRange = function (pixel) {
    return pixel >= this.blockTopPx && pixel < this.blockTopPx + this.blockHeightPx;
  };
  PartialStoreBlock.prototype.getRowBounds = function (index) {
    var _this = this;
    this.touchLastAccessed();
    var res;
    _.find(this.rowNodes, function (rowNode) {
      res = _this.blockUtils.extractRowBounds(rowNode, index);
      return res != null;
    });
    return res;
  };
  PartialStoreBlock.prototype.getRowIndexAtPixel = function (pixel) {
    var _this = this;
    this.touchLastAccessed();
    var res = null;
    _.find(this.rowNodes, function (rowNode) {
      res = _this.blockUtils.getIndexAtPixel(rowNode, pixel);
      return res != null;
    });
    return res;
  };
  PartialStoreBlock.prototype.clearDisplayIndexes = function () {
    var _this = this;
    this.displayIndexEnd = undefined;
    this.displayIndexStart = undefined;
    this.rowNodes.forEach(function (rowNode) {
      return _this.blockUtils.clearDisplayIndex(rowNode);
    });
  };
  PartialStoreBlock.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
    var _this = this;
    this.displayIndexStart = displayIndexSeq.peek();
    this.blockTopPx = nextRowTop.value;
    this.rowNodes.forEach(function (rowNode) {
      return _this.blockUtils.setDisplayIndex(rowNode, displayIndexSeq, nextRowTop);
    });
    this.displayIndexEnd = displayIndexSeq.peek();
    this.blockHeightPx = nextRowTop.value - this.blockTopPx;
  };
  __decorate$4e([Autowired('columnModel')], PartialStoreBlock.prototype, "columnModel", void 0);
  __decorate$4e([Autowired('ssrmCacheUtils')], PartialStoreBlock.prototype, "cacheUtils", void 0);
  __decorate$4e([Autowired('ssrmBlockUtils')], PartialStoreBlock.prototype, "blockUtils", void 0);
  __decorate$4e([Autowired('ssrmNodeManager')], PartialStoreBlock.prototype, "nodeManager", void 0);
  __decorate$4e([Autowired('rowNodeBlockLoader')], PartialStoreBlock.prototype, "rowNodeBlockLoader", void 0);
  __decorate$4e([PostConstruct], PartialStoreBlock.prototype, "postConstruct", null);
  __decorate$4e([PreDestroy], PartialStoreBlock.prototype, "destroyRowNodes", null);
  __decorate$4e([__param$c(0, Qualifier('loggerFactory'))], PartialStoreBlock.prototype, "setBeans", null);
  return PartialStoreBlock;
}(RowNodeBlock);
var __extends$5L = undefined && undefined.__extends || function () {
  var _extendStatics376 = function extendStatics(d, b) {
    _extendStatics376 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics376(d, b);
  };
  return function (d, b) {
    _extendStatics376(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4f = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$d = undefined && undefined.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};
var FindResult;
(function (FindResult) {
  FindResult[FindResult["FOUND"] = 0] = "FOUND";
  FindResult[FindResult["CONTINUE_FIND"] = 1] = "CONTINUE_FIND";
  FindResult[FindResult["BREAK_FIND"] = 2] = "BREAK_FIND";
})(FindResult || (FindResult = {}));
var PartialStore = /** @class */function (_super) {
  __extends$5L(PartialStore, _super);
  function PartialStore(ssrmParams, storeParams, parentRowNode) {
    var _this = _super.call(this) || this;
    _this.blocks = {};
    _this.blockHeights = {};
    _this.lastRowIndexKnown = false;
    // this will always be zero for the top level cache only,
    // all the other ones change as the groups open and close
    _this.displayIndexStart = 0;
    _this.displayIndexEnd = 0; // not sure if setting this one to zero is necessary
    _this.cacheTopPixel = 0;
    _this.info = {};
    _this.ssrmParams = ssrmParams;
    _this.storeParams = storeParams;
    _this.parentRowNode = parentRowNode;
    _this.rowCount = PartialStore.INITIAL_ROW_COUNT;
    return _this;
  }
  PartialStore.prototype.postConstruct = function () {
    this.defaultRowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
  };
  PartialStore.prototype.destroyAllBlocks = function () {
    var _this = this;
    this.getBlocksInOrder().forEach(function (block) {
      return _this.destroyBlock(block);
    });
  };
  PartialStore.prototype.setBeans = function (loggerFactory) {
    this.logger = loggerFactory.create('ServerSideCache');
  };
  PartialStore.prototype.getRowCount = function () {
    return this.rowCount;
  };
  PartialStore.prototype.isLastRowIndexKnown = function () {
    return this.lastRowIndexKnown;
  };
  PartialStore.prototype.retryLoads = function () {
    this.getBlocksInOrder().forEach(function (block) {
      return block.retryLoads();
    });
  };
  PartialStore.prototype.onBlockLoadFailed = function (block) {
    block.setData([], true);
    this.fireCacheUpdatedEvent();
  };
  PartialStore.prototype.onBlockLoaded = function (block, params) {
    this.logger.log("onPageLoaded: page = " + block.getId() + ", lastRow = " + params.rowCount);
    if (params.storeInfo) {
      _.assign(this.info, params.storeInfo);
    }
    if (!params.rowData) {
      var message_1 = 'AG Grid: "params.rowData" is missing from Server-Side Row Model success() callback. Please use the "rowData" attribute. If no data is returned, set an empty list.';
      _.doOnce(function () {
        return console.warn(message_1, params);
      }, 'InfiniteStore.noData');
    }
    var finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : undefined;
    // if we are not active, then we ignore all events, otherwise we could end up getting the
    // grid to refresh even though we are no longer the active cache
    if (!this.isAlive()) {
      return;
    }
    this.checkRowCount(block, finalRowCount);
    block.setData(params.rowData);
    // if the virtualRowCount is shortened, then it's possible blocks exist that are no longer
    // in the valid range. so we must remove these. this can happen if the datasource returns a
    // result and sets lastRow to something less than virtualRowCount (can happen if user scrolls
    // down, server reduces dataset size).
    this.destroyAllBlocksPastVirtualRowCount();
    this.fireCacheUpdatedEvent();
  };
  PartialStore.prototype.purgeBlocksIfNeeded = function (blockToExclude) {
    var _this = this;
    // we exclude checking for the page just created, as this has yet to be accessed and hence
    // the lastAccessed stamp will not be updated for the first time yet
    var blocksForPurging = this.getBlocksInOrder().filter(function (b) {
      return b != blockToExclude;
    });
    var lastAccessedComparator = function lastAccessedComparator(a, b) {
      return b.getLastAccessed() - a.getLastAccessed();
    };
    blocksForPurging.sort(lastAccessedComparator);
    // we remove (maxBlocksInCache - 1) as we already excluded the 'just created' page.
    // in other words, after the splice operation below, we have taken out the blocks
    // we want to keep, which means we are left with blocks that we can potentially purge
    var maxBlocksProvided = this.storeParams.maxBlocksInCache > 0;
    var blocksToKeep = maxBlocksProvided ? this.storeParams.maxBlocksInCache - 1 : null;
    var emptyBlocksToKeep = PartialStore.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
    blocksForPurging.forEach(function (block, index) {
      var purgeBecauseBlockEmpty = block.getState() === PartialStoreBlock.STATE_WAITING_TO_LOAD && index >= emptyBlocksToKeep;
      var purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
      if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
        // we never purge blocks if they are open, as purging them would mess up with
        // our indexes, it would be very messy to restore the purged block to it's
        // previous state if it had open children.
        if (block.isAnyNodeOpen()) {
          return;
        }
        // if the block currently has rows been displayed, then don't remove it either.
        // this can happen if user has maxBlocks=2, and blockSize=5 (thus 10 max rows in cache)
        // but the screen is showing 20 rows, so at least 4 blocks are needed.
        if (_this.isBlockCurrentlyDisplayed(block)) {
          return;
        }
        // don't want to loose keyboard focus, so keyboard navigation can continue. so keep focused blocks.
        if (_this.isBlockFocused(block)) {
          return;
        }
        // at this point, block is not needed, and no open nodes, so burn baby burn
        _this.destroyBlock(block);
      }
    });
  };
  PartialStore.prototype.isBlockFocused = function (block) {
    var focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
    if (!focusedCell) {
      return false;
    }
    if (focusedCell.rowPinned != null) {
      return false;
    }
    var blockIndexStart = block.getDisplayIndexStart();
    var blockIndexEnd = block.getDisplayIndexEnd();
    if (blockIndexEnd == null || blockIndexStart == null) {
      return false;
    }
    var hasFocus = focusedCell.rowIndex >= blockIndexStart && focusedCell.rowIndex < blockIndexEnd;
    return hasFocus;
  };
  PartialStore.prototype.isBlockCurrentlyDisplayed = function (block) {
    var startIndex = block.getDisplayIndexStart();
    var endIndex = block.getDisplayIndexEnd() - 1;
    return this.rowRenderer.isRangeInRenderedViewport(startIndex, endIndex);
  };
  PartialStore.prototype.removeDuplicateNode = function (id) {
    this.getBlocksInOrder().forEach(function (block) {
      return block.removeDuplicateNode(id);
    });
  };
  PartialStore.prototype.checkRowCount = function (block, lastRow) {
    // if client provided a last row, we always use it, as it could change between server calls
    // if user deleted data and then called refresh on the grid.
    if (typeof lastRow === 'number' && lastRow >= 0) {
      this.rowCount = lastRow;
      this.lastRowIndexKnown = true;
    } else if (!this.lastRowIndexKnown) {
      // otherwise, see if we need to add some virtual rows
      var lastRowIndex = (block.getId() + 1) * this.storeParams.cacheBlockSize;
      var lastRowIndexPlusOverflow = lastRowIndex + PartialStore.OVERFLOW_SIZE;
      if (this.rowCount < lastRowIndexPlusOverflow) {
        this.rowCount = lastRowIndexPlusOverflow;
      }
    }
  };
  PartialStore.prototype.forEachNodeDeep = function (callback, sequence) {
    if (sequence === void 0) {
      sequence = new NumberSequence();
    }
    this.getBlocksInOrder().forEach(function (block) {
      return block.forEachNodeDeep(callback, sequence);
    });
  };
  PartialStore.prototype.forEachNodeDeepAfterFilterAndSort = function (callback, sequence) {
    if (sequence === void 0) {
      sequence = new NumberSequence();
    }
    this.getBlocksInOrder().forEach(function (block) {
      return block.forEachNodeAfterFilterAndSort(callback, sequence);
    });
  };
  PartialStore.prototype.getBlocksInOrder = function () {
    // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
    var blockComparator = function blockComparator(a, b) {
      return a.getId() - b.getId();
    };
    var blocks = _.getAllValuesInObject(this.blocks).sort(blockComparator);
    return blocks;
  };
  PartialStore.prototype.destroyBlock = function (block) {
    delete this.blocks[block.getId()];
    this.destroyBean(block);
    this.rowNodeBlockLoader.removeBlock(block);
  };
  // gets called 1) row count changed 2) cache purged 3) items inserted
  PartialStore.prototype.fireCacheUpdatedEvent = function () {
    // this results in row model firing ModelUpdated.
    // server side row model also updates the row indexes first
    var event = {
      type: Events.EVENT_STORE_UPDATED
    };
    this.eventService.dispatchEvent(event);
  };
  PartialStore.prototype.destroyAllBlocksPastVirtualRowCount = function () {
    var _this = this;
    var blocksToDestroy = [];
    this.getBlocksInOrder().forEach(function (block) {
      var startRow = block.getId() * _this.storeParams.cacheBlockSize;
      if (startRow >= _this.rowCount) {
        blocksToDestroy.push(block);
      }
    });
    if (blocksToDestroy.length > 0) {
      blocksToDestroy.forEach(function (block) {
        return _this.destroyBlock(block);
      });
    }
  };
  PartialStore.prototype.refreshStore = function (purge) {
    var noBlocksToRefresh = this.getRowCount() == 0;
    if (noBlocksToRefresh || purge) {
      this.resetStore();
    } else {
      this.refreshBlocks();
    }
    this.fireCacheUpdatedEvent();
  };
  PartialStore.prototype.refreshBlocks = function () {
    this.getBlocksInOrder().forEach(function (block) {
      block.refresh();
    });
    this.lastRowIndexKnown = false;
    this.rowNodeBlockLoader.checkBlockToLoad();
  };
  PartialStore.prototype.resetStore = function () {
    this.destroyAllBlocks();
    this.lastRowIndexKnown = false;
    // if zero rows in the cache, we need to get the SSRM to start asking for rows again.
    // otherwise if set to zero rows last time, and we don't update the row count, then after
    // the purge there will still be zero rows, meaning the SSRM won't request any rows.
    // to kick things off, at least one row needs to be asked for.
    if (this.columnModel.isAutoRowHeightActive || this.rowCount === 0) {
      this.rowCount = PartialStore.INITIAL_ROW_COUNT;
    }
  };
  PartialStore.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
    var result = [];
    var lastBlockId = -1;
    var inActiveRange = false;
    // if only one node passed, we start the selection at the top
    if (_.missing(firstInRange)) {
      inActiveRange = true;
    }
    var foundGapInSelection = false;
    this.getBlocksInOrder().forEach(function (block) {
      if (foundGapInSelection) {
        return;
      }
      if (inActiveRange && lastBlockId + 1 !== block.getId()) {
        foundGapInSelection = true;
        return;
      }
      lastBlockId = block.getId();
      block.forEachNodeShallow(function (rowNode) {
        var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
        if (inActiveRange || hitFirstOrLast) {
          result.push(rowNode);
        }
        if (hitFirstOrLast) {
          inActiveRange = !inActiveRange;
        }
      });
    });
    // inActiveRange will be still true if we never hit the second rowNode
    var invalidRange = foundGapInSelection || inActiveRange;
    return invalidRange ? [] : result;
  };
  PartialStore.prototype.findBlockAndExecute = function (matchBlockFunc, blockFoundFunc, blockNotFoundFunc) {
    var blockFound = false;
    var breakSearch = false;
    var lastBlock = null;
    var res;
    this.getBlocksInOrder().forEach(function (block) {
      if (blockFound || breakSearch) {
        return;
      }
      var comparatorResult = matchBlockFunc(block);
      if (comparatorResult == FindResult.FOUND) {
        res = blockFoundFunc(block);
        blockFound = true;
      } else if (comparatorResult == FindResult.CONTINUE_FIND) {
        lastBlock = block;
      } else if (comparatorResult == FindResult.BREAK_FIND) {
        breakSearch = true;
      }
    });
    if (!blockFound) {
      res = blockNotFoundFunc(lastBlock);
    }
    return res;
  };
  PartialStore.prototype.getRowBounds = function (index) {
    var _this = this;
    var matchBlockFunc = function matchBlockFunc(block) {
      if (block.isDisplayIndexInBlock(index)) {
        return FindResult.FOUND;
      } else {
        return block.isBlockBefore(index) ? FindResult.CONTINUE_FIND : FindResult.BREAK_FIND;
      }
    };
    var blockFoundFunc = function blockFoundFunc(foundBlock) {
      return foundBlock.getRowBounds(index);
    };
    var blockNotFoundFunc = function blockNotFoundFunc(previousBlock) {
      var nextRowTop;
      var nextRowIndex;
      if (previousBlock !== null) {
        nextRowTop = previousBlock.getBlockTopPx() + previousBlock.getBlockHeightPx();
        nextRowIndex = previousBlock.getDisplayIndexEnd();
      } else {
        nextRowTop = _this.cacheTopPixel;
        nextRowIndex = _this.displayIndexStart;
      }
      var rowsBetween = index - nextRowIndex;
      return {
        rowHeight: _this.defaultRowHeight,
        rowTop: nextRowTop + rowsBetween * _this.defaultRowHeight
      };
    };
    return this.findBlockAndExecute(matchBlockFunc, blockFoundFunc, blockNotFoundFunc);
  };
  PartialStore.prototype.getRowIndexAtPixel = function (pixel) {
    var _this = this;
    var matchBlockFunc = function matchBlockFunc(block) {
      if (block.isPixelInRange(pixel)) {
        return FindResult.FOUND;
      } else {
        return block.getBlockTopPx() < pixel ? FindResult.CONTINUE_FIND : FindResult.BREAK_FIND;
      }
    };
    var blockFoundFunc = function blockFoundFunc(foundBlock) {
      return foundBlock.getRowIndexAtPixel(pixel);
    };
    var blockNotFoundFunc = function blockNotFoundFunc(previousBlock) {
      var nextRowTop;
      var nextRowIndex;
      if (previousBlock) {
        nextRowTop = previousBlock.getBlockTopPx() + previousBlock.getBlockHeightPx();
        nextRowIndex = previousBlock.getDisplayIndexEnd();
      } else {
        nextRowTop = _this.cacheTopPixel;
        nextRowIndex = _this.displayIndexStart;
      }
      var pixelsBetween = pixel - nextRowTop;
      var rowsBetween = pixelsBetween / _this.defaultRowHeight | 0;
      return nextRowIndex + rowsBetween;
    };
    var result = this.findBlockAndExecute(matchBlockFunc, blockFoundFunc, blockNotFoundFunc);
    var lastAllowedIndex = this.getDisplayIndexEnd() - 1;
    result = Math.min(result, lastAllowedIndex);
    return result;
  };
  PartialStore.prototype.clearDisplayIndexes = function () {
    this.displayIndexStart = undefined;
    this.displayIndexEnd = undefined;
    this.getBlocksInOrder().forEach(function (block) {
      return block.clearDisplayIndexes();
    });
  };
  PartialStore.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
    var _this = this;
    this.displayIndexStart = displayIndexSeq.peek();
    this.cacheTopPixel = nextRowTop.value;
    var lastBlockId = -1;
    var blockSize = this.storeParams.cacheBlockSize;
    this.getBlocksInOrder().forEach(function (currentBlock) {
      // if we skipped blocks, then we need to skip the row indexes. we assume that all missing
      // blocks are made up of closed RowNodes only (if they were groups), as we never expire from
      // the cache if any row nodes are open.
      var blockId = currentBlock.getId();
      var blocksSkippedCount = blockId - lastBlockId - 1;
      var rowsSkippedCount = blocksSkippedCount * blockSize;
      if (rowsSkippedCount > 0) {
        displayIndexSeq.skip(rowsSkippedCount);
      }
      for (var i = 1; i <= blocksSkippedCount; i++) {
        var blockToAddId = blockId - i;
        if (_.exists(_this.blockHeights[blockToAddId])) {
          nextRowTop.value += _this.blockHeights[blockToAddId];
        } else {
          nextRowTop.value += blockSize * _this.defaultRowHeight;
        }
      }
      lastBlockId = blockId;
      currentBlock.setDisplayIndexes(displayIndexSeq, nextRowTop);
      _this.blockHeights[blockId] = currentBlock.getBlockHeightPx();
    });
    // if any blocks missing at the end, need to increase the row index for them also
    // eg if block size = 10, we have total rows of 25 (indexes 0 .. 24), but first 2 blocks loaded (because
    // last row was ejected from cache), then:
    // lastVisitedRow = 19, virtualRowCount = 25, rows not accounted for = 5 (24 - 19)
    var lastVisitedRow = (lastBlockId + 1) * blockSize - 1;
    var rowCount = this.getRowCount();
    var rowsNotAccountedFor = rowCount - lastVisitedRow - 1;
    if (rowsNotAccountedFor > 0) {
      displayIndexSeq.skip(rowsNotAccountedFor);
      nextRowTop.value += rowsNotAccountedFor * this.defaultRowHeight;
    }
    this.displayIndexEnd = displayIndexSeq.peek();
    this.cacheHeightPixels = nextRowTop.value - this.cacheTopPixel;
  };
  // gets called in a) init() above and b) by the grid
  PartialStore.prototype.getRowUsingDisplayIndex = function (displayRowIndex, dontCreateBlock) {
    var _this = this;
    if (dontCreateBlock === void 0) {
      dontCreateBlock = false;
    }
    // this can happen if asking for a row that doesn't exist in the model,
    // eg if a cell range is selected, and the user filters so rows no longer exists
    if (!this.isDisplayIndexInStore(displayRowIndex)) {
      return undefined;
    }
    var matchBlockFunc = function matchBlockFunc(block) {
      if (block.isDisplayIndexInBlock(displayRowIndex)) {
        return FindResult.FOUND;
      } else {
        return block.isBlockBefore(displayRowIndex) ? FindResult.CONTINUE_FIND : FindResult.BREAK_FIND;
      }
    };
    var blockFoundFunc = function blockFoundFunc(foundBlock) {
      return foundBlock.getRowUsingDisplayIndex(displayRowIndex);
    };
    var blockNotFoundFunc = function blockNotFoundFunc(previousBlock) {
      if (dontCreateBlock) {
        return;
      }
      var blockNumber;
      var displayIndexStart;
      var nextRowTop;
      var blockSize = _this.storeParams.cacheBlockSize;
      // because missing blocks are always fully closed, we can work out
      // the start index of the block we want by hopping from the closest block,
      // as we know the row count in closed blocks is equal to the page size
      if (previousBlock) {
        blockNumber = previousBlock.getId() + 1;
        displayIndexStart = previousBlock.getDisplayIndexEnd();
        nextRowTop = previousBlock.getBlockHeightPx() + previousBlock.getBlockTopPx();
        var isInRange = function isInRange() {
          return displayRowIndex >= displayIndexStart && displayRowIndex < displayIndexStart + blockSize;
        };
        while (!isInRange()) {
          displayIndexStart += blockSize;
          var cachedBlockHeight = _this.blockHeights[blockNumber];
          if (_.exists(cachedBlockHeight)) {
            nextRowTop += cachedBlockHeight;
          } else {
            nextRowTop += _this.defaultRowHeight * blockSize;
          }
          blockNumber++;
        }
      } else {
        var localIndex = displayRowIndex - _this.displayIndexStart;
        blockNumber = Math.floor(localIndex / blockSize);
        displayIndexStart = _this.displayIndexStart + blockNumber * blockSize;
        nextRowTop = _this.cacheTopPixel + blockNumber * blockSize * _this.defaultRowHeight;
      }
      _this.logger.log("block missing, rowIndex = " + displayRowIndex + ", creating #" + blockNumber + ", displayIndexStart = " + displayIndexStart);
      var newBlock = _this.createBlock(blockNumber, displayIndexStart, {
        value: nextRowTop
      });
      return newBlock.getRowUsingDisplayIndex(displayRowIndex);
    };
    return this.findBlockAndExecute(matchBlockFunc, blockFoundFunc, blockNotFoundFunc);
  };
  PartialStore.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    var blockSize = this.storeParams.cacheBlockSize;
    var blockId = Math.floor(topLevelIndex / blockSize);
    var matchBlockFunc = function matchBlockFunc(block) {
      if (block.getId() === blockId) {
        return FindResult.FOUND;
      }
      return block.getId() < blockId ? FindResult.CONTINUE_FIND : FindResult.BREAK_FIND;
    };
    var blockFoundFunc = function blockFoundFunc(foundBlock) {
      var rowNode = foundBlock.getRowUsingLocalIndex(topLevelIndex);
      return rowNode.rowIndex;
    };
    var blockNotFoundFunc = function blockNotFoundFunc(previousBlock) {
      if (!previousBlock) {
        return topLevelIndex;
      }
      // note: the local index is the same as the top level index, two terms for same thing
      //
      // get index of the last row before this row
      // eg if blocksize = 100, then:
      //   last row of first block is 99 (100 * 1) -1;
      //   last row of second block is 199 (100 * 2) -1;
      var lastRowTopLevelIndex = blockSize * (previousBlock.getId() + 1) - 1;
      // get the last top level node in the block before the wanted block. this will be the last
      // loaded displayed top level node.
      var lastRowNode = previousBlock.getRowUsingLocalIndex(lastRowTopLevelIndex);
      // we want the index of the last displayed node, not just the top level node, so if the last top level node
      // is open, we get the index of the last displayed child node.
      var lastDisplayedNodeIndexInBlockBefore;
      if (lastRowNode.expanded && lastRowNode.childStore) {
        var serverSideCache = lastRowNode.childStore;
        lastDisplayedNodeIndexInBlockBefore = serverSideCache.getDisplayIndexEnd() - 1;
      } else if (lastRowNode.expanded && lastRowNode.detailNode) {
        lastDisplayedNodeIndexInBlockBefore = lastRowNode.detailNode.rowIndex;
      } else {
        lastDisplayedNodeIndexInBlockBefore = lastRowNode.rowIndex;
      }
      // we are guaranteed no rows are open. so the difference between the topTopIndex will be the
      // same as the difference between the displayed index
      var indexDiff = topLevelIndex - lastRowTopLevelIndex;
      return lastDisplayedNodeIndexInBlockBefore + indexDiff;
    };
    return this.findBlockAndExecute(matchBlockFunc, blockFoundFunc, blockNotFoundFunc);
  };
  PartialStore.prototype.addStoreStates = function (result) {
    result.push({
      type: 'partial',
      route: this.storeUtils.createGroupKeys(this.parentRowNode),
      rowCount: this.rowCount,
      lastRowIndexKnown: this.lastRowIndexKnown,
      info: this.info,
      maxBlocksInCache: this.storeParams.maxBlocksInCache,
      cacheBlockSize: this.storeParams.cacheBlockSize
    });
    this.forEachChildStoreShallow(function (childStore) {
      return childStore.addStoreStates(result);
    });
  };
  PartialStore.prototype.createBlock = function (blockNumber, displayIndex, nextRowTop) {
    var block = this.createBean(new PartialStoreBlock(blockNumber, this.parentRowNode, this.ssrmParams, this.storeParams, this));
    block.setDisplayIndexes(new NumberSequence(displayIndex), nextRowTop);
    this.blocks[block.getId()] = block;
    this.purgeBlocksIfNeeded(block);
    this.rowNodeBlockLoader.addBlock(block);
    return block;
  };
  PartialStore.prototype.getDisplayIndexEnd = function () {
    return this.displayIndexEnd;
  };
  PartialStore.prototype.isDisplayIndexInStore = function (displayIndex) {
    if (this.getRowCount() === 0) {
      return false;
    }
    return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
  };
  PartialStore.prototype.applyTransaction = function (transaction) {
    return {
      status: ServerSideTransactionResultStatus.StoreWrongType
    };
  };
  PartialStore.prototype.getChildStore = function (keys) {
    var _this = this;
    var findNodeCallback = function findNodeCallback(key) {
      var nextNode = null;
      _this.getBlocksInOrder().forEach(function (block) {
        block.forEachNodeShallow(function (rowNode) {
          if (rowNode.key === key) {
            nextNode = rowNode;
          }
        }, new NumberSequence());
      });
      return nextNode;
    };
    return this.storeUtils.getChildStore(keys, this, findNodeCallback);
  };
  PartialStore.prototype.isPixelInRange = function (pixel) {
    if (this.getRowCount() === 0) {
      return false;
    }
    return pixel >= this.cacheTopPixel && pixel < this.cacheTopPixel + this.cacheHeightPixels;
  };
  PartialStore.prototype.refreshAfterFilter = function (params) {
    this.resetStore();
  };
  PartialStore.prototype.refreshAfterSort = function (params) {
    if (this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
      this.resetStore();
      return;
    }
    // call refreshAfterSort on children, as we did not purge.
    // if we did purge, no need to do this as all children were destroyed
    this.forEachChildStoreShallow(function (store) {
      return store.refreshAfterSort(params);
    });
  };
  PartialStore.prototype.forEachChildStoreShallow = function (callback) {
    this.getBlocksInOrder().forEach(function (block) {
      if (block.isGroupLevel()) {
        var innerCallback = function innerCallback(rowNode) {
          var nextCache = rowNode.childStore;
          if (nextCache) {
            callback(nextCache);
          }
        };
        block.forEachNodeShallow(innerCallback, new NumberSequence());
      }
    });
  };
  // this property says how many empty blocks should be in a cache, eg if scrolls down fast and creates 10
  // blocks all for loading, the grid will only load the last 2 - it will assume the blocks the user quickly
  // scrolled over are not needed to be loaded.
  PartialStore.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
  PartialStore.INITIAL_ROW_COUNT = 1;
  PartialStore.OVERFLOW_SIZE = 1;
  __decorate$4f([Autowired('rowRenderer')], PartialStore.prototype, "rowRenderer", void 0);
  __decorate$4f([Autowired('rowNodeBlockLoader')], PartialStore.prototype, "rowNodeBlockLoader", void 0);
  __decorate$4f([Autowired('ssrmCacheUtils')], PartialStore.prototype, "storeUtils", void 0);
  __decorate$4f([Autowired("focusService")], PartialStore.prototype, "focusService", void 0);
  __decorate$4f([Autowired("columnModel")], PartialStore.prototype, "columnModel", void 0);
  __decorate$4f([PostConstruct], PartialStore.prototype, "postConstruct", null);
  __decorate$4f([PreDestroy], PartialStore.prototype, "destroyAllBlocks", null);
  __decorate$4f([__param$d(0, Qualifier('loggerFactory'))], PartialStore.prototype, "setBeans", null);
  return PartialStore;
}(BeanStub);
var __extends$5M = undefined && undefined.__extends || function () {
  var _extendStatics377 = function extendStatics(d, b) {
    _extendStatics377 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics377(d, b);
  };
  return function (d, b) {
    _extendStatics377(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4g = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FullStore = /** @class */function (_super) {
  __extends$5M(FullStore, _super);
  function FullStore(ssrmParams, storeParams, parentRowNode) {
    var _this =
    // finite block represents a cache with just one block, thus 0 is the id, it's the first block
    _super.call(this, 0) || this;
    _this.nodeIdSequence = new NumberSequence();
    _this.info = {};
    _this.ssrmParams = ssrmParams;
    _this.parentRowNode = parentRowNode;
    _this.level = parentRowNode.level + 1;
    _this.groupLevel = ssrmParams.rowGroupCols ? _this.level < ssrmParams.rowGroupCols.length : undefined;
    _this.leafGroup = ssrmParams.rowGroupCols ? _this.level === ssrmParams.rowGroupCols.length - 1 : false;
    return _this;
  }
  FullStore.prototype.postConstruct = function () {
    var _this = this;
    this.usingTreeData = this.gridOptionsWrapper.isTreeData();
    this.nodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.parentRowNode);
    if (!this.usingTreeData && this.groupLevel) {
      var groupColVo = this.ssrmParams.rowGroupCols[this.level];
      this.groupField = groupColVo.field;
      this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
    }
    this.initialiseRowNodes();
    this.rowNodeBlockLoader.addBlock(this);
    this.addDestroyFunc(function () {
      return _this.rowNodeBlockLoader.removeBlock(_this);
    });
  };
  FullStore.prototype.destroyRowNodes = function () {
    this.blockUtils.destroyRowNodes(this.allRowNodes);
    this.allRowNodes = [];
    this.nodesAfterSort = [];
    this.nodesAfterFilter = [];
    this.allNodesMap = {};
  };
  FullStore.prototype.initialiseRowNodes = function (loadingRowsCount, failedLoad) {
    if (loadingRowsCount === void 0) {
      loadingRowsCount = 1;
    }
    if (failedLoad === void 0) {
      failedLoad = false;
    }
    this.destroyRowNodes();
    for (var i = 0; i < loadingRowsCount; i++) {
      var loadingRowNode = this.blockUtils.createRowNode({
        field: this.groupField,
        group: this.groupLevel,
        leafGroup: this.leafGroup,
        level: this.level,
        parent: this.parentRowNode,
        rowGroupColumn: this.rowGroupColumn
      });
      if (failedLoad) {
        loadingRowNode.failedLoad = true;
      }
      this.allRowNodes.push(loadingRowNode);
      this.nodesAfterFilter.push(loadingRowNode);
      this.nodesAfterSort.push(loadingRowNode);
    }
  };
  FullStore.prototype.getBlockStateJson = function () {
    return {
      id: this.nodeIdPrefix ? this.nodeIdPrefix : '',
      state: this.getState()
    };
  };
  FullStore.prototype.loadFromDatasource = function () {
    this.storeUtils.loadFromDatasource({
      startRow: undefined,
      endRow: undefined,
      parentNode: this.parentRowNode,
      storeParams: this.ssrmParams,
      successCallback: this.pageLoaded.bind(this, this.getVersion()),
      success: this.success.bind(this, this.getVersion()),
      failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
      fail: this.pageLoadFailed.bind(this, this.getVersion())
    });
  };
  FullStore.prototype.getStartRow = function () {
    return 0; // always zero as not in a cache
  };

  FullStore.prototype.getEndRow = function () {
    return this.nodesAfterSort.length;
  };
  FullStore.prototype.createDataNode = function (data, index) {
    var rowNode = this.blockUtils.createRowNode({
      field: this.groupField,
      group: this.groupLevel,
      leafGroup: this.leafGroup,
      level: this.level,
      parent: this.parentRowNode,
      rowGroupColumn: this.rowGroupColumn
    });
    if (index != null) {
      _.insertIntoArray(this.allRowNodes, rowNode, index);
    } else {
      this.allRowNodes.push(rowNode);
    }
    var defaultId = this.prefixId(this.nodeIdSequence.next());
    this.blockUtils.setDataIntoRowNode(rowNode, data, defaultId);
    this.nodeManager.addRowNode(rowNode);
    this.blockUtils.checkOpenByDefault(rowNode);
    this.allNodesMap[rowNode.id] = rowNode;
    return rowNode;
  };
  FullStore.prototype.prefixId = function (id) {
    if (this.nodeIdPrefix) {
      return this.nodeIdPrefix + '-' + id;
    } else {
      return id.toString();
    }
  };
  FullStore.prototype.processServerFail = function () {
    this.initialiseRowNodes(1, true);
    this.fireStoreUpdatedEvent();
    this.flushAsyncTransactions();
  };
  FullStore.prototype.processServerResult = function (params) {
    if (!this.isAlive()) {
      return;
    }
    if (params.storeInfo) {
      _.assign(this.info, params.storeInfo);
    }
    var nodesToRecycle = this.allRowNodes.length > 0 ? this.allNodesMap : undefined;
    this.allRowNodes = [];
    this.nodesAfterSort = [];
    this.nodesAfterFilter = [];
    this.allNodesMap = {};
    if (!params.rowData) {
      var message_1 = 'AG Grid: "params.data" is missing from Server-Side Row Model success() callback. Please use the "data" attribute. If no data is returned, set an empty list.';
      _.doOnce(function () {
        return console.warn(message_1, params);
      }, 'FullStore.noData');
    }
    this.createOrRecycleNodes(nodesToRecycle, params.rowData);
    if (nodesToRecycle) {
      this.blockUtils.destroyRowNodes(_.getAllValuesInObject(nodesToRecycle));
    }
    this.filterAndSortNodes();
    this.fireStoreUpdatedEvent();
    this.flushAsyncTransactions();
  };
  FullStore.prototype.createOrRecycleNodes = function (nodesToRecycle, rowData) {
    var _this = this;
    if (!rowData) {
      return;
    }
    var lookupNodeToRecycle = function lookupNodeToRecycle(dataItem) {
      if (!nodesToRecycle) {
        return undefined;
      }
      var userIdFunc = _this.gridOptionsWrapper.getRowNodeIdFunc();
      if (!userIdFunc) {
        return undefined;
      }
      var id = userIdFunc(dataItem);
      var foundNode = nodesToRecycle[id];
      if (!foundNode) {
        return undefined;
      }
      delete nodesToRecycle[id];
      return foundNode;
    };
    var recycleNode = function recycleNode(rowNode, dataItem) {
      _this.allNodesMap[rowNode.id] = rowNode;
      rowNode.updateData(dataItem);
      _this.allRowNodes.push(rowNode);
    };
    rowData.forEach(function (dataItem) {
      var nodeToRecycle = lookupNodeToRecycle(dataItem);
      if (nodeToRecycle) {
        recycleNode(nodeToRecycle, dataItem);
      } else {
        _this.createDataNode(dataItem);
      }
    });
  };
  FullStore.prototype.flushAsyncTransactions = function () {
    var _this = this;
    // we want to update the store with any outstanding transactions straight away,
    // as otherwise if waitTimeMillis is large (eg 5s), then the user could be looking
    // at old data for a few seconds before the transactions is applied, which isn't what
    // you would expect when we advertise 'transaction is applied when data is loaded'.
    // we do this in a timeout as flushAsyncTransactions expects the grid to be in a settled
    // state, not in the middle of loading rows! keeps the VM Turns more simple and deterministic.
    window.setTimeout(function () {
      return _this.transactionManager.flushAsyncTransactions();
    }, 0);
  };
  FullStore.prototype.filterAndSortNodes = function () {
    this.filterRowNodes();
    this.sortRowNodes();
  };
  FullStore.prototype.sortRowNodes = function () {
    var sortOptions = this.sortController.getSortOptions();
    var noSortApplied = !sortOptions || sortOptions.length == 0;
    // if we reset after sort, it means the sorting is done on the server
    var sortDoneOnServer = this.gridOptionsWrapper.isServerSideSortingAlwaysResets();
    if (noSortApplied || sortDoneOnServer) {
      this.nodesAfterSort = this.nodesAfterFilter;
      return;
    }
    this.nodesAfterSort = this.rowNodeSorter.doFullSort(this.nodesAfterFilter, sortOptions);
  };
  FullStore.prototype.filterRowNodes = function () {
    var _this = this;
    // if we reset after filter, it means the filtering is done on the server
    var filterDoneOnServer = this.gridOptionsWrapper.isServerSideFilteringAlwaysResets();
    // filtering for InFullStore only works at lowest level details.
    // reason is the logic for group filtering was to difficult to work out how it should work at time of writing.
    var groupLevel = this.groupLevel;
    var skipFilter = filterDoneOnServer || groupLevel;
    if (skipFilter) {
      this.nodesAfterFilter = this.allRowNodes;
      return;
    }
    this.nodesAfterFilter = this.allRowNodes.filter(function (rowNode) {
      return _this.filterManager.doesRowPassFilter({
        rowNode: rowNode
      });
    });
  };
  FullStore.prototype.clearDisplayIndexes = function () {
    var _this = this;
    this.displayIndexStart = undefined;
    this.displayIndexEnd = undefined;
    this.allRowNodes.forEach(function (rowNode) {
      return _this.blockUtils.clearDisplayIndex(rowNode);
    });
  };
  FullStore.prototype.getDisplayIndexEnd = function () {
    return this.displayIndexEnd;
  };
  FullStore.prototype.isDisplayIndexInStore = function (displayIndex) {
    if (this.getRowCount() === 0) {
      return false;
    }
    return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
  };
  FullStore.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
    var _this = this;
    this.displayIndexStart = displayIndexSeq.peek();
    this.topPx = nextRowTop.value;
    var visibleNodeIds = {};
    // set on all visible nodes
    this.nodesAfterSort.forEach(function (rowNode) {
      _this.blockUtils.setDisplayIndex(rowNode, displayIndexSeq, nextRowTop);
      visibleNodeIds[rowNode.id] = true;
    });
    // and clear on all non-visible nodes
    this.allRowNodes.forEach(function (rowNode) {
      if (!visibleNodeIds[rowNode.id]) {
        _this.blockUtils.clearDisplayIndex(rowNode);
      }
    });
    this.displayIndexEnd = displayIndexSeq.peek();
    this.heightPx = nextRowTop.value - this.topPx;
  };
  FullStore.prototype.forEachNodeDeep = function (callback, sequence) {
    if (sequence === void 0) {
      sequence = new NumberSequence();
    }
    this.allRowNodes.forEach(function (rowNode) {
      callback(rowNode, sequence.next());
      var childCache = rowNode.childStore;
      if (childCache) {
        childCache.forEachNodeDeep(callback, sequence);
      }
    });
  };
  FullStore.prototype.forEachNodeDeepAfterFilterAndSort = function (callback, sequence) {
    if (sequence === void 0) {
      sequence = new NumberSequence();
    }
    this.nodesAfterSort.forEach(function (rowNode) {
      callback(rowNode, sequence.next());
      var childCache = rowNode.childStore;
      if (childCache) {
        childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence);
      }
    });
  };
  FullStore.prototype.getRowUsingDisplayIndex = function (displayRowIndex) {
    // this can happen if asking for a row that doesn't exist in the model,
    // eg if a cell range is selected, and the user filters so rows no longer exists
    if (!this.isDisplayIndexInStore(displayRowIndex)) {
      return undefined;
    }
    var res = this.blockUtils.binarySearchForDisplayIndex(displayRowIndex, this.nodesAfterSort);
    return res;
  };
  FullStore.prototype.getRowBounds = function (index) {
    for (var i = 0; i < this.nodesAfterSort.length; i++) {
      var rowNode = this.nodesAfterSort[i];
      var res = this.blockUtils.extractRowBounds(rowNode, index);
      if (res) {
        return res;
      }
    }
    return null;
  };
  FullStore.prototype.isPixelInRange = function (pixel) {
    return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
  };
  FullStore.prototype.getRowIndexAtPixel = function (pixel) {
    var _this = this;
    // if pixel before block, return first row
    var pixelBeforeThisStore = pixel <= this.topPx;
    if (pixelBeforeThisStore) {
      var firstNode = this.nodesAfterSort[0];
      return firstNode.rowIndex;
    }
    // if pixel after store, return last row, however the last
    // row could be a child store
    var pixelAfterThisStore = pixel >= this.topPx + this.heightPx;
    if (pixelAfterThisStore) {
      var lastRowNode = this.nodesAfterSort[this.nodesAfterSort.length - 1];
      var lastRowNodeBottomPx = lastRowNode.rowTop + lastRowNode.rowHeight;
      if (pixel >= lastRowNodeBottomPx && lastRowNode.expanded) {
        if (lastRowNode.childStore && lastRowNode.childStore.getRowCount() > 0) {
          return lastRowNode.childStore.getRowIndexAtPixel(pixel);
        }
        if (lastRowNode.detailNode) {
          return lastRowNode.detailNode.rowIndex;
        }
      }
      return lastRowNode.rowIndex;
    }
    var res = null;
    this.nodesAfterSort.forEach(function (rowNode) {
      var res2 = _this.blockUtils.getIndexAtPixel(rowNode, pixel);
      if (res2 != null) {
        res = res2;
      }
    });
    var pixelIsPastLastRow = res == null;
    if (pixelIsPastLastRow) {
      return this.displayIndexEnd - 1;
    }
    return res;
  };
  FullStore.prototype.getChildStore = function (keys) {
    var _this = this;
    return this.storeUtils.getChildStore(keys, this, function (key) {
      var rowNode = _.find(_this.allRowNodes, function (currentRowNode) {
        return currentRowNode.key === key;
      });
      return rowNode;
    });
  };
  FullStore.prototype.forEachChildStoreShallow = function (callback) {
    this.allRowNodes.forEach(function (rowNode) {
      var childStore = rowNode.childStore;
      if (childStore) {
        callback(childStore);
      }
    });
  };
  FullStore.prototype.refreshAfterFilter = function (params) {
    if (params.alwaysReset || this.gridOptionsWrapper.isTreeData()) {
      this.refreshStore(true);
      return;
    }
    this.filterAndSortNodes();
    this.forEachChildStoreShallow(function (store) {
      return store.refreshAfterFilter(params);
    });
  };
  FullStore.prototype.refreshAfterSort = function (params) {
    if (params.alwaysReset) {
      this.refreshStore(true);
      return;
    }
    this.sortRowNodes();
    this.forEachChildStoreShallow(function (store) {
      return store.refreshAfterSort(params);
    });
  };
  FullStore.prototype.applyTransaction = function (transaction) {
    // we only apply transactions to loaded state
    switch (this.getState()) {
      case RowNodeBlock.STATE_FAILED:
        return {
          status: ServerSideTransactionResultStatus.StoreLoadingFailed
        };
      case RowNodeBlock.STATE_LOADING:
        return {
          status: ServerSideTransactionResultStatus.StoreLoading
        };
      case RowNodeBlock.STATE_WAITING_TO_LOAD:
        return {
          status: ServerSideTransactionResultStatus.StoreWaitingToLoad
        };
    }
    var applyCallback = this.gridOptionsWrapper.getIsApplyServerSideTransactionFunc();
    if (applyCallback) {
      var params = {
        transaction: transaction,
        parentNode: this.parentRowNode,
        storeInfo: this.info
      };
      var apply = applyCallback(params);
      if (!apply) {
        return {
          status: ServerSideTransactionResultStatus.Cancelled
        };
      }
    }
    var res = {
      status: ServerSideTransactionResultStatus.Applied,
      remove: [],
      update: [],
      add: []
    };
    var nodesToUnselect = [];
    this.executeAdd(transaction, res);
    this.executeRemove(transaction, res, nodesToUnselect);
    this.executeUpdate(transaction, res, nodesToUnselect);
    this.filterAndSortNodes();
    this.updateSelection(nodesToUnselect);
    return res;
  };
  FullStore.prototype.updateSelection = function (nodesToUnselect) {
    var selectionChanged = nodesToUnselect.length > 0;
    if (selectionChanged) {
      nodesToUnselect.forEach(function (rowNode) {
        rowNode.setSelected(false, false, true);
      });
      var event_1 = {
        type: Events.EVENT_SELECTION_CHANGED,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi()
      };
      this.eventService.dispatchEvent(event_1);
    }
  };
  FullStore.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
    var _this = this;
    var add = rowDataTran.add,
      addIndex = rowDataTran.addIndex;
    if (_.missingOrEmpty(add)) {
      return;
    }
    var useIndex = typeof addIndex === 'number' && addIndex >= 0;
    if (useIndex) {
      // items get inserted in reverse order for index insertion
      add.reverse().forEach(function (item) {
        var newRowNode = _this.createDataNode(item, addIndex);
        rowNodeTransaction.add.push(newRowNode);
      });
    } else {
      add.forEach(function (item) {
        var newRowNode = _this.createDataNode(item);
        rowNodeTransaction.add.push(newRowNode);
      });
    }
  };
  FullStore.prototype.executeRemove = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
    var _this = this;
    var remove = rowDataTran.remove;
    if (remove == null) {
      return;
    }
    var rowIdsRemoved = {};
    remove.forEach(function (item) {
      var rowNode = _this.lookupRowNode(item);
      if (!rowNode) {
        return;
      }
      // do delete - setting 'suppressFinishActions = true' to ensure EVENT_SELECTION_CHANGED is not raised for
      // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
      if (rowNode.isSelected()) {
        nodesToUnselect.push(rowNode);
      }
      // so row renderer knows to fade row out (and not reposition it)
      rowNode.clearRowTopAndRowIndex();
      // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
      // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
      rowIdsRemoved[rowNode.id] = true;
      // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
      delete _this.allNodesMap[rowNode.id];
      rowNodeTransaction.remove.push(rowNode);
      _this.nodeManager.removeNode(rowNode);
    });
    this.allRowNodes = this.allRowNodes.filter(function (rowNode) {
      return !rowIdsRemoved[rowNode.id];
    });
  };
  FullStore.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
    var _this = this;
    var update = rowDataTran.update;
    if (update == null) {
      return;
    }
    update.forEach(function (item) {
      var rowNode = _this.lookupRowNode(item);
      if (!rowNode) {
        return;
      }
      rowNode.updateData(item);
      if (!rowNode.selectable && rowNode.isSelected()) {
        nodesToUnselect.push(rowNode);
      }
      rowNodeTransaction.update.push(rowNode);
    });
  };
  FullStore.prototype.lookupRowNode = function (data) {
    var rowNodeIdFunc = this.gridOptionsWrapper.getRowNodeIdFunc();
    var rowNode;
    if (_.exists(rowNodeIdFunc)) {
      // find rowNode using id
      var id = rowNodeIdFunc(data);
      rowNode = this.allNodesMap[id];
      if (!rowNode) {
        console.error("AG Grid: could not find row id=" + id + ", data item was not found for this id");
        return null;
      }
    } else {
      // find rowNode using object references
      rowNode = _.find(this.allRowNodes, function (currentRowNode) {
        return currentRowNode.data === data;
      });
      if (!rowNode) {
        console.error("AG Grid: could not find data item as object was not found", data);
        return null;
      }
    }
    return rowNode;
  };
  FullStore.prototype.addStoreStates = function (result) {
    result.push({
      type: 'full',
      route: this.storeUtils.createGroupKeys(this.parentRowNode),
      rowCount: this.allRowNodes.length,
      info: this.info
    });
    this.forEachChildStoreShallow(function (childStore) {
      return childStore.addStoreStates(result);
    });
  };
  FullStore.prototype.refreshStore = function (purge) {
    if (purge) {
      var loadingRowsToShow = this.nodesAfterSort ? this.nodesAfterSort.length : 1;
      this.initialiseRowNodes(loadingRowsToShow);
    }
    this.scheduleLoad();
    this.fireStoreUpdatedEvent();
  };
  FullStore.prototype.retryLoads = function () {
    if (this.getState() === RowNodeBlock.STATE_FAILED) {
      this.initialiseRowNodes(1);
      this.scheduleLoad();
    }
    this.forEachChildStoreShallow(function (store) {
      return store.retryLoads();
    });
  };
  FullStore.prototype.scheduleLoad = function () {
    this.setStateWaitingToLoad();
    this.rowNodeBlockLoader.checkBlockToLoad();
  };
  // gets called 1) row count changed 2) cache purged 3) items inserted
  FullStore.prototype.fireStoreUpdatedEvent = function () {
    // this results in row model firing ModelUpdated.
    // server side row model also updates the row indexes first
    var event = {
      type: Events.EVENT_STORE_UPDATED
    };
    this.eventService.dispatchEvent(event);
  };
  FullStore.prototype.getRowCount = function () {
    return this.nodesAfterSort.length;
  };
  FullStore.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    var rowNode = this.nodesAfterSort[topLevelIndex];
    return rowNode.rowIndex;
  };
  FullStore.prototype.isLastRowIndexKnown = function () {
    return this.getState() == RowNodeBlock.STATE_LOADED;
  };
  FullStore.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
    var result = [];
    var inActiveRange = false;
    // if only one node passed, we start the selection at the top
    if (_.missing(firstInRange)) {
      inActiveRange = true;
    }
    this.nodesAfterSort.forEach(function (rowNode) {
      var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
      if (inActiveRange || hitFirstOrLast) {
        result.push(rowNode);
      }
      if (hitFirstOrLast) {
        inActiveRange = !inActiveRange;
      }
    });
    // inActiveRange will be still true if we never hit the second rowNode
    var invalidRange = inActiveRange;
    return invalidRange ? [] : result;
  };
  __decorate$4g([Autowired('ssrmCacheUtils')], FullStore.prototype, "storeUtils", void 0);
  __decorate$4g([Autowired('ssrmBlockUtils')], FullStore.prototype, "blockUtils", void 0);
  __decorate$4g([Autowired('columnModel')], FullStore.prototype, "columnModel", void 0);
  __decorate$4g([Autowired('rowNodeBlockLoader')], FullStore.prototype, "rowNodeBlockLoader", void 0);
  __decorate$4g([Autowired('rowNodeSorter')], FullStore.prototype, "rowNodeSorter", void 0);
  __decorate$4g([Autowired('sortController')], FullStore.prototype, "sortController", void 0);
  __decorate$4g([Autowired('ssrmNodeManager')], FullStore.prototype, "nodeManager", void 0);
  __decorate$4g([Autowired('filterManager')], FullStore.prototype, "filterManager", void 0);
  __decorate$4g([Autowired('ssrmTransactionManager')], FullStore.prototype, "transactionManager", void 0);
  __decorate$4g([PostConstruct], FullStore.prototype, "postConstruct", null);
  __decorate$4g([PreDestroy], FullStore.prototype, "destroyRowNodes", null);
  return FullStore;
}(RowNodeBlock);
var __decorate$4h = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StoreFactory = /** @class */function () {
  function StoreFactory() {}
  StoreFactory.prototype.createStore = function (ssrmParams, parentNode) {
    var storeParams = this.getStoreParams(ssrmParams, parentNode);
    var CacheClass = storeParams.storeType === 'partial' ? PartialStore : FullStore;
    return new CacheClass(ssrmParams, storeParams, parentNode);
  };
  StoreFactory.prototype.getStoreParams = function (ssrmParams, parentNode) {
    var userStoreParams = this.getLevelSpecificParams(parentNode);
    // if user provided overrideParams, we take storeType from there if it exists
    var storeType = this.getStoreType(userStoreParams);
    var cacheBlockSize = this.getBlockSize(storeType, userStoreParams);
    var maxBlocksInCache = this.getMaxBlocksInCache(storeType, ssrmParams, userStoreParams);
    var storeParams = {
      storeType: storeType,
      cacheBlockSize: cacheBlockSize,
      maxBlocksInCache: maxBlocksInCache
    };
    return storeParams;
  };
  StoreFactory.prototype.getMaxBlocksInCache = function (storeType, ssrmParams, userStoreParams) {
    if (storeType == 'full') {
      return undefined;
    }
    var maxBlocksInCache = userStoreParams && userStoreParams.maxBlocksInCache != null ? userStoreParams.maxBlocksInCache : this.gridOptionsWrapper.getMaxBlocksInCache();
    var maxBlocksActive = maxBlocksInCache != null && maxBlocksInCache >= 0;
    if (!maxBlocksActive) {
      return undefined;
    }
    if (ssrmParams.dynamicRowHeight) {
      var message_1 = 'AG Grid: Server Side Row Model does not support Dynamic Row Height and Cache Purging. ' + 'Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.';
      _.doOnce(function () {
        return console.warn(message_1);
      }, 'storeFactory.maxBlocksInCache.dynamicRowHeight');
      return undefined;
    }
    if (this.columnModel.isAutoRowHeightActive()) {
      var message_2 = 'AG Grid: Server Side Row Model does not support Auto Row Height and Cache Purging. ' + 'Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.';
      _.doOnce(function () {
        return console.warn(message_2);
      }, 'storeFactory.maxBlocksInCache.autoRowHeightActive');
      return undefined;
    }
    return maxBlocksInCache;
  };
  StoreFactory.prototype.getBlockSize = function (storeType, userStoreParams) {
    if (storeType == 'full') {
      return undefined;
    }
    var blockSize = userStoreParams && userStoreParams.cacheBlockSize != null ? userStoreParams.cacheBlockSize : this.gridOptionsWrapper.getCacheBlockSize();
    if (blockSize != null && blockSize > 0) {
      return blockSize;
    } else {
      return 100;
    }
  };
  StoreFactory.prototype.getLevelSpecificParams = function (parentNode) {
    var callback = this.gridOptionsWrapper.getServerSideStoreParamsFunc();
    if (!callback) {
      return undefined;
    }
    var params = {
      level: parentNode.level + 1,
      parentRowNode: parentNode.level >= 0 ? parentNode : undefined,
      rowGroupColumns: this.columnModel.getRowGroupColumns(),
      pivotColumns: this.columnModel.getPivotColumns(),
      pivotMode: this.columnModel.isPivotMode()
    };
    return callback(params);
  };
  StoreFactory.prototype.getStoreType = function (storeParams) {
    var storeType = storeParams && storeParams.storeType != null ? storeParams.storeType : this.gridOptionsWrapper.getServerSideStoreType();
    switch (storeType) {
      case 'partial':
      case 'full':
        return storeType;
      case null:
      case undefined:
        return 'full';
      default:
        var serverTypes = ['full', 'partial'];
        var types = serverTypes.join(', ');
        console.warn("AG Grid: invalid Server Side Store Type " + storeType + ", valid types are [" + types + "]");
        return 'partial';
    }
  };
  __decorate$4h([Autowired('gridOptionsWrapper')], StoreFactory.prototype, "gridOptionsWrapper", void 0);
  __decorate$4h([Autowired('columnModel')], StoreFactory.prototype, "columnModel", void 0);
  StoreFactory = __decorate$4h([Bean('ssrmStoreFactory')], StoreFactory);
  return StoreFactory;
}();
var __decorate$4i = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ListenerUtils = /** @class */function () {
  function ListenerUtils() {}
  ListenerUtils.prototype.isSortingWithValueColumn = function (changedColumnsInSort) {
    var valueColIds = this.columnModel.getValueColumns().map(function (col) {
      return col.getColId();
    });
    for (var i = 0; i < changedColumnsInSort.length; i++) {
      if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) {
        return true;
      }
    }
    return false;
  };
  ListenerUtils.prototype.isSortingWithSecondaryColumn = function (changedColumnsInSort) {
    if (!this.columnModel.getSecondaryColumns()) {
      return false;
    }
    var secondaryColIds = this.columnModel.getSecondaryColumns().map(function (col) {
      return col.getColId();
    });
    for (var i = 0; i < changedColumnsInSort.length; i++) {
      if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) {
        return true;
      }
    }
    return false;
  };
  __decorate$4i([Autowired('columnModel')], ListenerUtils.prototype, "columnModel", void 0);
  ListenerUtils = __decorate$4i([Bean('ssrmListenerUtils')], ListenerUtils);
  return ListenerUtils;
}();
var ServerSideRowModelModule = {
  moduleName: ModuleNames.ServerSideRowModelModule,
  rowModels: {
    serverSide: ServerSideRowModel
  },
  beans: [ExpandListener, SortListener, StoreUtils, BlockUtils, NodeManager, TransactionManager, FilterListener, StoreFactory, ListenerUtils],
  dependantModules: [EnterpriseCoreModule]
};
var NULL_SUBSTITUTE = '__<ag-grid-pseudo-null>__';
var ClientSideValuesExtractor = /** @class */function () {
  function ClientSideValuesExtractor(rowModel, filterParams, caseFormat) {
    this.rowModel = rowModel;
    this.filterParams = filterParams;
    this.caseFormat = caseFormat;
  }
  ClientSideValuesExtractor.prototype.extractUniqueValues = function (predicate) {
    var _this = this;
    var values = {};
    var keyCreator = this.filterParams.colDef.keyCreator;
    var addValue = function addValue(value) {
      // NOTE: We don't care about the keys later on (only values in the dictionary are
      // returned), so as long as we use a non-conflicting key for the `null` value this
      // will behave correctly.
      var valueKey = value != null ? _this.caseFormat(value) : NULL_SUBSTITUTE;
      if (valueKey && values[valueKey] == null) {
        values[valueKey] = value;
      }
    };
    this.rowModel.forEachLeafNode(function (node) {
      // only pull values from rows that have data. this means we skip filler group nodes.
      if (!node.data || !predicate(node)) {
        return;
      }
      var value = _this.filterParams.valueGetter(node);
      if (keyCreator) {
        var params = {
          value: value,
          colDef: _this.filterParams.colDef,
          column: _this.filterParams.column,
          node: node,
          data: node.data,
          api: _this.filterParams.api,
          columnApi: _this.filterParams.columnApi,
          context: _this.filterParams.context
        };
        value = keyCreator(params);
      }
      value = _.makeNull(value);
      if (value != null && Array.isArray(value)) {
        _.forEach(value, function (x) {
          var formatted = _.toStringOrNull(_.makeNull(x));
          addValue(formatted);
        });
      } else {
        addValue(_.toStringOrNull(value));
      }
    });
    return _.values(values);
  };
  return ClientSideValuesExtractor;
}();
var SetFilterModelValuesType;
(function (SetFilterModelValuesType) {
  SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_LIST"] = 0] = "PROVIDED_LIST";
  SetFilterModelValuesType[SetFilterModelValuesType["PROVIDED_CALLBACK"] = 1] = "PROVIDED_CALLBACK";
  SetFilterModelValuesType[SetFilterModelValuesType["TAKEN_FROM_GRID_VALUES"] = 2] = "TAKEN_FROM_GRID_VALUES";
})(SetFilterModelValuesType || (SetFilterModelValuesType = {}));
var NULL_SUBSTITUTE$1 = '__<ag-grid-pseudo-null>__';
var SetValueModel = /** @class */function () {
  function SetValueModel(filterParams, setIsLoading, valueFormatterService, translate, caseFormat) {
    var _this = this;
    this.filterParams = filterParams;
    this.setIsLoading = setIsLoading;
    this.valueFormatterService = valueFormatterService;
    this.translate = translate;
    this.caseFormat = caseFormat;
    this.localEventService = new EventService();
    this.miniFilterText = null;
    // The lookup for a set is much faster than the lookup for an array, especially when the length of the array is
    // thousands of records long, so where lookups are important we use a set.
    /** Values provided to the filter for use. */
    this.providedValues = null;
    /** All possible values for the filter, sorted if required. */
    this.allValues = [];
    /** Remaining values when filters from other columns have been applied. */
    this.availableValues = new Set();
    /** All values that are currently displayed, after the mini-filter has been applied. */
    this.displayedValues = [];
    /** Values that have been selected for this filter. */
    this.selectedValues = new Set();
    this.initialised = false;
    var column = filterParams.column,
      colDef = filterParams.colDef,
      textFormatter = filterParams.textFormatter,
      doesRowPassOtherFilter = filterParams.doesRowPassOtherFilter,
      suppressSorting = filterParams.suppressSorting,
      comparator = filterParams.comparator,
      rowModel = filterParams.rowModel,
      values = filterParams.values,
      caseSensitive = filterParams.caseSensitive;
    this.column = column;
    this.colDef = colDef;
    this.formatter = textFormatter || TextFilter.DEFAULT_FORMATTER;
    this.doesRowPassOtherFilters = doesRowPassOtherFilter;
    this.suppressSorting = suppressSorting || false;
    this.comparator = comparator || colDef.comparator || _.defaultComparator;
    this.caseSensitive = caseSensitive || false;
    if (rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE) {
      this.clientSideValuesExtractor = new ClientSideValuesExtractor(rowModel, this.filterParams, this.caseFormat);
    }
    if (values == null) {
      this.valuesType = SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES;
    } else {
      this.valuesType = Array.isArray(values) ? SetFilterModelValuesType.PROVIDED_LIST : SetFilterModelValuesType.PROVIDED_CALLBACK;
      this.providedValues = values;
    }
    this.updateAllValues().then(function (updatedValues) {
      return _this.resetSelectionState(updatedValues || []);
    });
  }
  SetValueModel.prototype.addEventListener = function (eventType, listener, async) {
    this.localEventService.addEventListener(eventType, listener, async);
  };
  SetValueModel.prototype.removeEventListener = function (eventType, listener, async) {
    this.localEventService.removeEventListener(eventType, listener, async);
  };
  /**
   * Re-fetches the values used in the filter from the value source.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */
  SetValueModel.prototype.refreshValues = function (keepSelection) {
    if (keepSelection === void 0) {
      keepSelection = true;
    }
    var currentModel = this.getModel();
    this.updateAllValues();
    // ensure model is updated for new values
    return this.setModel(keepSelection ? currentModel : null);
  };
  /**
   * Overrides the current values being used for the set filter.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */
  SetValueModel.prototype.overrideValues = function (valuesToUse, keepSelection) {
    var _this = this;
    if (keepSelection === void 0) {
      keepSelection = true;
    }
    return new AgPromise(function (resolve) {
      // wait for any existing values to be populated before overriding
      _this.allValuesPromise.then(function () {
        _this.valuesType = SetFilterModelValuesType.PROVIDED_LIST;
        _this.providedValues = valuesToUse;
        _this.refreshValues(keepSelection).then(function () {
          return resolve();
        });
      });
    });
  };
  SetValueModel.prototype.refreshAfterAnyFilterChanged = function () {
    var _this = this;
    return this.showAvailableOnly() ? this.allValuesPromise.then(function (values) {
      return _this.updateAvailableValues(values || []);
    }) : AgPromise.resolve();
  };
  SetValueModel.prototype.isInitialised = function () {
    return this.initialised;
  };
  SetValueModel.prototype.updateAllValues = function () {
    var _this = this;
    this.allValuesPromise = new AgPromise(function (resolve) {
      switch (_this.valuesType) {
        case SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES:
        case SetFilterModelValuesType.PROVIDED_LIST:
          {
            var values = _this.valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES ? _this.getValuesFromRows(false) : _.values(_this.uniqueValues(_.toStrings(_this.providedValues) || []));
            var sortedValues = _this.sortValues(values || []);
            _this.allValues = sortedValues;
            resolve(sortedValues);
            break;
          }
        case SetFilterModelValuesType.PROVIDED_CALLBACK:
          {
            _this.setIsLoading(true);
            var callback_1 = _this.providedValues;
            var _a = _this.filterParams,
              columnApi = _a.columnApi,
              api = _a.api,
              context = _a.context,
              column = _a.column,
              colDef = _a.colDef;
            var params_1 = {
              success: function success(values) {
                var processedValues = _.values(_this.uniqueValues(_.toStrings(values) || []));
                _this.setIsLoading(false);
                var sortedValues = _this.sortValues(processedValues || []);
                _this.allValues = sortedValues;
                resolve(sortedValues);
              },
              colDef: colDef,
              column: column,
              columnApi: columnApi,
              api: api,
              context: context
            };
            window.setTimeout(function () {
              return callback_1(params_1);
            }, 0);
            break;
          }
        default:
          throw new Error('Unrecognised valuesType');
      }
    });
    this.allValuesPromise.then(function (values) {
      return _this.updateAvailableValues(values || []);
    }).then(function () {
      return _this.initialised = true;
    });
    return this.allValuesPromise;
  };
  SetValueModel.prototype.setValuesType = function (value) {
    this.valuesType = value;
  };
  SetValueModel.prototype.getValuesType = function () {
    return this.valuesType;
  };
  SetValueModel.prototype.isValueAvailable = function (value) {
    return this.availableValues.has(value);
  };
  SetValueModel.prototype.showAvailableOnly = function () {
    return this.valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES && !this.filterParams.suppressRemoveEntries;
  };
  SetValueModel.prototype.updateAvailableValues = function (allValues) {
    var availableValues = this.showAvailableOnly() ? this.sortValues(this.getValuesFromRows(true)) : allValues;
    this.availableValues = _.convertToSet(availableValues);
    this.localEventService.dispatchEvent({
      type: SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED
    });
    this.updateDisplayedValues();
  };
  SetValueModel.prototype.sortValues = function (values) {
    if (this.suppressSorting) {
      return values;
    }
    if (!this.filterParams.excelMode || values.indexOf(null) < 0) {
      return values.sort(this.comparator);
    }
    // ensure the blank value always appears last
    return _.filter(values, function (v) {
      return v != null;
    }).sort(this.comparator).concat(null);
  };
  SetValueModel.prototype.getValuesFromRows = function (removeUnavailableValues) {
    var _this = this;
    if (removeUnavailableValues === void 0) {
      removeUnavailableValues = false;
    }
    if (!this.clientSideValuesExtractor) {
      console.error('AG Grid: Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values');
      return [];
    }
    var predicate = function predicate(node) {
      return !removeUnavailableValues || _this.doesRowPassOtherFilters(node);
    };
    return this.clientSideValuesExtractor.extractUniqueValues(predicate);
  };
  /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */
  SetValueModel.prototype.setMiniFilter = function (value) {
    value = _.makeNull(value);
    if (this.miniFilterText === value) {
      //do nothing if filter has not changed
      return false;
    }
    this.miniFilterText = value;
    this.updateDisplayedValues();
    return true;
  };
  SetValueModel.prototype.getMiniFilter = function () {
    return this.miniFilterText;
  };
  SetValueModel.prototype.updateDisplayedValues = function () {
    var _this = this;
    // if no filter, just display all available values
    if (this.miniFilterText == null) {
      this.displayedValues = _.values(this.availableValues);
      return;
    }
    // if filter present, we filter down the list
    this.displayedValues = [];
    // to allow for case insensitive searches, upper-case both filter text and value
    var formattedFilterText = this.caseFormat(this.formatter(this.miniFilterText) || '');
    var matchesFilter = function matchesFilter(valueToCheck) {
      return valueToCheck != null && _this.caseFormat(valueToCheck).indexOf(formattedFilterText) >= 0;
    };
    this.availableValues.forEach(function (value) {
      if (value == null) {
        if (_this.filterParams.excelMode && matchesFilter(_this.translate('blanks'))) {
          _this.displayedValues.push(value);
        }
      } else {
        var textFormatterValue = _this.formatter(value);
        // TODO: should this be applying the text formatter *after* the value formatter?
        var valueFormatterValue = _this.valueFormatterService.formatValue(_this.column, null, null, textFormatterValue, _this.filterParams.valueFormatter, false);
        if (matchesFilter(textFormatterValue) || matchesFilter(valueFormatterValue)) {
          _this.displayedValues.push(value);
        }
      }
    });
  };
  SetValueModel.prototype.getDisplayedValueCount = function () {
    return this.displayedValues.length;
  };
  SetValueModel.prototype.getDisplayedValue = function (index) {
    return this.displayedValues[index];
  };
  SetValueModel.prototype.hasSelections = function () {
    return this.filterParams.defaultToNothingSelected ? this.selectedValues.size > 0 : this.allValues.length !== this.selectedValues.size;
  };
  SetValueModel.prototype.getUniqueValueCount = function () {
    return this.allValues.length;
  };
  SetValueModel.prototype.getUniqueValue = function (index) {
    return this.allValues[index];
  };
  SetValueModel.prototype.getValues = function () {
    return this.allValues.slice();
  };
  SetValueModel.prototype.selectAllMatchingMiniFilter = function (clearExistingSelection) {
    var _this = this;
    if (clearExistingSelection === void 0) {
      clearExistingSelection = false;
    }
    if (this.miniFilterText == null) {
      // ensure everything is selected
      this.selectedValues = _.convertToSet(this.allValues);
    } else {
      // ensure everything that matches the mini filter is selected
      if (clearExistingSelection) {
        this.selectedValues.clear();
      }
      _.forEach(this.displayedValues, function (value) {
        return _this.selectedValues.add(value);
      });
    }
  };
  SetValueModel.prototype.deselectAllMatchingMiniFilter = function () {
    var _this = this;
    if (this.miniFilterText == null) {
      // ensure everything is deselected
      this.selectedValues.clear();
    } else {
      // ensure everything that matches the mini filter is deselected
      _.forEach(this.displayedValues, function (value) {
        return _this.selectedValues.delete(value);
      });
    }
  };
  SetValueModel.prototype.selectValue = function (value) {
    this.selectedValues.add(value);
  };
  SetValueModel.prototype.deselectValue = function (value) {
    if (this.filterParams.excelMode && this.isEverythingVisibleSelected()) {
      // ensure we're starting from the correct "everything selected" state
      this.resetSelectionState(this.displayedValues);
    }
    this.selectedValues.delete(value);
  };
  SetValueModel.prototype.isValueSelected = function (value) {
    return this.selectedValues.has(value);
  };
  SetValueModel.prototype.isEverythingVisibleSelected = function () {
    var _this = this;
    return _.filter(this.displayedValues, function (it) {
      return _this.isValueSelected(it);
    }).length === this.displayedValues.length;
  };
  SetValueModel.prototype.isNothingVisibleSelected = function () {
    var _this = this;
    return _.filter(this.displayedValues, function (it) {
      return _this.isValueSelected(it);
    }).length === 0;
  };
  SetValueModel.prototype.getModel = function () {
    return this.hasSelections() ? _.values(this.selectedValues) : null;
  };
  SetValueModel.prototype.setModel = function (model) {
    var _this = this;
    return this.allValuesPromise.then(function (values) {
      if (model == null) {
        _this.resetSelectionState(values || []);
      } else {
        // select all values from the model that exist in the filter
        _this.selectedValues.clear();
        var allValues_1 = _this.uniqueValues(values || []);
        _.forEach(model, function (value) {
          var allValue = allValues_1[_this.uniqueKey(value)];
          if (allValue !== undefined) {
            _this.selectedValues.add(allValue);
          }
        });
      }
    });
  };
  SetValueModel.prototype.uniqueValues = function (values) {
    var _this = this;
    // Honour case-sensitivity setting for matching purposes here, preserving original casing
    // in the selectedValues output.
    var uniqueValues = {};
    _.forEach(values || [], function (value) {
      var key = _this.uniqueKey(value);
      if (uniqueValues[key] === undefined) {
        uniqueValues[key] = value;
      }
    });
    return uniqueValues;
  };
  SetValueModel.prototype.uniqueKey = function (v) {
    return v == null ? NULL_SUBSTITUTE$1 : this.caseFormat(v);
  };
  SetValueModel.prototype.resetSelectionState = function (values) {
    if (this.filterParams.defaultToNothingSelected) {
      this.selectedValues.clear();
    } else {
      this.selectedValues = _.convertToSet(values || []);
    }
  };
  SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED = 'availableValuesChanged';
  return SetValueModel;
}();
var __extends$5N = undefined && undefined.__extends || function () {
  var _extendStatics378 = function extendStatics(d, b) {
    _extendStatics378 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics378(d, b);
  };
  return function (d, b) {
    _extendStatics378(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4j = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetFilterListItem = /** @class */function (_super) {
  __extends$5N(SetFilterListItem, _super);
  function SetFilterListItem(value, params, translate, isSelected) {
    var _this = _super.call(this, SetFilterListItem.TEMPLATE) || this;
    _this.value = value;
    _this.params = params;
    _this.translate = translate;
    _this.isSelected = isSelected;
    return _this;
  }
  SetFilterListItem.prototype.init = function () {
    var _this = this;
    this.render();
    this.eCheckbox.setValue(this.isSelected, true);
    this.eCheckbox.setDisabled(!!this.params.readOnly);
    if (!!this.params.readOnly) {
      // Don't add event listeners if we're read-only.
      return;
    }
    this.eCheckbox.onValueChange(function (value) {
      var parsedValue = value || false;
      _this.isSelected = parsedValue;
      var event = {
        type: SetFilterListItem.EVENT_SELECTION_CHANGED,
        isSelected: parsedValue
      };
      _this.dispatchEvent(event);
    });
  };
  SetFilterListItem.prototype.toggleSelected = function () {
    if (!!this.params.readOnly) {
      return;
    }
    this.isSelected = !this.isSelected;
    this.eCheckbox.setValue(this.isSelected);
  };
  SetFilterListItem.prototype.render = function () {
    var column = this.params.column;
    var value = this.value;
    var formattedValue = null;
    if (typeof value === 'function') {
      value = value();
    } else {
      formattedValue = this.getFormattedValue(this.params, column, value);
    }
    if (this.params.showTooltips) {
      var tooltipValue = formattedValue != null ? formattedValue : value;
      this.setTooltip(tooltipValue);
    }
    var params = {
      value: value,
      valueFormatted: formattedValue,
      api: this.gridOptionsWrapper.getApi(),
      columnApi: this.gridOptionsWrapper.getColumnApi(),
      context: this.gridOptionsWrapper.getContext(),
      colDef: this.params.colDef,
      column: this.params.column
    };
    this.renderCell(params);
  };
  SetFilterListItem.prototype.getTooltipParams = function () {
    var res = _super.prototype.getTooltipParams.call(this);
    res.location = 'setFilterValue';
    res.colDef = this.getComponentHolder();
    return res;
  };
  SetFilterListItem.prototype.getFormattedValue = function (filterParams, column, value) {
    var formatter = filterParams && filterParams.valueFormatter;
    return this.valueFormatterService.formatValue(column, null, null, value, formatter, false);
  };
  SetFilterListItem.prototype.renderCell = function (params) {
    var _this = this;
    var compDetails = this.userComponentFactory.getSetFilterCellRendererDetails(this.params, params);
    var cellRendererPromise = compDetails ? compDetails.newAgStackInstance() : undefined;
    if (cellRendererPromise == null) {
      var valueToRender = params.valueFormatted == null ? params.value : params.valueFormatted;
      this.eCheckbox.setLabel(valueToRender == null ? this.translate('blanks') : valueToRender);
      return;
    }
    cellRendererPromise.then(function (component) {
      if (component) {
        _this.eCheckbox.setLabel(component.getGui());
        _this.addDestroyFunc(function () {
          return _this.destroyBean(component);
        });
      }
    });
  };
  SetFilterListItem.prototype.getComponentHolder = function () {
    return this.params.column.getColDef();
  };
  SetFilterListItem.EVENT_SELECTION_CHANGED = 'selectionChanged';
  SetFilterListItem.TEMPLATE = "\n        <div class=\"ag-set-filter-item\">\n            <ag-checkbox ref=\"eCheckbox\" class=\"ag-set-filter-item-checkbox\"></ag-checkbox>\n        </div>";
  __decorate$4j([Autowired('valueFormatterService')], SetFilterListItem.prototype, "valueFormatterService", void 0);
  __decorate$4j([Autowired('userComponentFactory')], SetFilterListItem.prototype, "userComponentFactory", void 0);
  __decorate$4j([RefSelector('eCheckbox')], SetFilterListItem.prototype, "eCheckbox", void 0);
  __decorate$4j([PostConstruct], SetFilterListItem.prototype, "init", null);
  return SetFilterListItem;
}(Component);
var DEFAULT_LOCALE_TEXT = {
  loadingOoo: 'Loading...',
  blanks: '(Blanks)',
  searchOoo: 'Search...',
  selectAll: '(Select All)',
  selectAllSearchResults: '(Select All Search Results)',
  noMatches: 'No matches.'
};
var __extends$5O = undefined && undefined.__extends || function () {
  var _extendStatics379 = function extendStatics(d, b) {
    _extendStatics379 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics379(d, b);
  };
  return function (d, b) {
    _extendStatics379(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4k = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetFilter = /** @class */function (_super) {
  __extends$5O(SetFilter, _super);
  function SetFilter() {
    var _this = _super.call(this, 'setFilter') || this;
    _this.valueModel = null;
    _this.setFilterParams = null;
    _this.virtualList = null;
    _this.caseSensitive = false;
    // To make the filtering super fast, we store the values in an object, and check for the boolean value.
    // Although Set would be a more natural choice of data structure, its performance across browsers is
    // significantly worse than using an object: https://jsbench.me/hdk91jbw1h/
    _this.appliedModelValues = null;
    return _this;
  }
  SetFilter.prototype.postConstruct = function () {
    _super.prototype.postConstruct.call(this);
    this.positionableFeature = new PositionableFeature(this.eSetFilterList, {
      forcePopupParentAsOffsetParent: true
    });
    this.createBean(this.positionableFeature);
  };
  // unlike the simple filters, nothing in the set filter UI shows/hides.
  // maybe this method belongs in abstractSimpleFilter???
  SetFilter.prototype.updateUiVisibility = function () {};
  SetFilter.prototype.createBodyTemplate = function () {
    return (/* html */"\n            <div class=\"ag-set-filter\">\n                <div ref=\"eFilterLoading\" class=\"ag-filter-loading ag-hidden\">" + this.translateForSetFilter('loadingOoo') + "</div>\n                <ag-input-text-field class=\"ag-mini-filter\" ref=\"eMiniFilter\"></ag-input-text-field>\n                <div ref=\"eFilterNoMatches\" class=\"ag-filter-no-matches ag-hidden\">" + this.translateForSetFilter('noMatches') + "</div>\n                <div ref=\"eSetFilterList\" class=\"ag-set-filter-list\" role=\"presentation\"></div>\n            </div>"
    );
  };
  SetFilter.prototype.handleKeyDown = function (e) {
    _super.prototype.handleKeyDown.call(this, e);
    if (e.defaultPrevented) {
      return;
    }
    switch (e.which || e.keyCode) {
      case KeyCode.SPACE:
        this.handleKeySpace(e);
        break;
      case KeyCode.ENTER:
        this.handleKeyEnter(e);
        break;
    }
  };
  SetFilter.prototype.handleKeySpace = function (e) {
    if (!this.eSetFilterList.contains(document.activeElement) || !this.virtualList) {
      return;
    }
    var currentItem = this.virtualList.getLastFocusedRow();
    if (currentItem == null) {
      return;
    }
    var component = this.virtualList.getComponentAt(currentItem);
    if (component == null) {
      return;
    }
    e.preventDefault();
    var readOnly = (this.setFilterParams || {}).readOnly;
    if (!!readOnly) {
      return;
    }
    component.toggleSelected();
  };
  SetFilter.prototype.handleKeyEnter = function (e) {
    if (!this.setFilterParams) {
      return;
    }
    var _a = this.setFilterParams || {},
      excelMode = _a.excelMode,
      readOnly = _a.readOnly;
    if (!excelMode || !!readOnly) {
      return;
    }
    e.preventDefault();
    // in Excel Mode, hitting Enter is the same as pressing the Apply button
    this.onBtApply(false, false, e);
    if (this.setFilterParams.excelMode === 'mac') {
      // in Mac version, select all the input text
      this.eMiniFilter.getInputElement().select();
    }
  };
  SetFilter.prototype.getCssIdentifier = function () {
    return 'set-filter';
  };
  SetFilter.prototype.setModelAndRefresh = function (values) {
    var _this = this;
    return this.valueModel ? this.valueModel.setModel(values).then(function () {
      return _this.refresh();
    }) : AgPromise.resolve();
  };
  SetFilter.prototype.resetUiToDefaults = function () {
    this.setMiniFilter(null);
    return this.setModelAndRefresh(null);
  };
  SetFilter.prototype.setModelIntoUi = function (model) {
    this.setMiniFilter(null);
    if (model instanceof Array) {
      var message_1 = 'AG Grid: The Set Filter Model is no longer an array and models as arrays are ' + 'deprecated. Please check the docs on what the set filter model looks like. Future versions of ' + 'AG Grid will have the array version of the model removed.';
      _.doOnce(function () {
        return console.warn(message_1);
      }, 'setFilter.modelAsArray');
    }
    // also supporting old filter model for backwards compatibility
    var values = model == null ? null : model instanceof Array ? model : model.values;
    return this.setModelAndRefresh(values);
  };
  SetFilter.prototype.getModelFromUi = function () {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var values = this.valueModel.getModel();
    if (!values) {
      return null;
    }
    if (this.gridOptionsWrapper.isEnableOldSetFilterModel()) {
      // this is a hack, it breaks casting rules, to apply with old model
      return values;
    }
    return {
      values: values,
      filterType: this.getFilterType()
    };
  };
  SetFilter.prototype.getFilterType = function () {
    return 'set';
  };
  SetFilter.prototype.getValueModel = function () {
    return this.valueModel;
  };
  SetFilter.prototype.areModelsEqual = function (a, b) {
    // both are missing
    if (a == null && b == null) {
      return true;
    }
    return a != null && b != null && _.areEqual(a.values, b.values);
  };
  SetFilter.prototype.setParams = function (params) {
    var _this = this;
    this.applyExcelModeOptions(params);
    _super.prototype.setParams.call(this, params);
    this.checkSetFilterDeprecatedParams(params);
    this.setFilterParams = params;
    this.caseSensitive = params.caseSensitive || false;
    this.valueModel = new SetValueModel(params, function (loading) {
      return _this.showOrHideLoadingScreen(loading);
    }, this.valueFormatterService, function (key) {
      return _this.translateForSetFilter(key);
    }, function (v) {
      return _this.caseFormat(v);
    });
    this.initialiseFilterBodyUi();
    if (params.rowModel.getType() === Constants.ROW_MODEL_TYPE_CLIENT_SIDE && !params.values && !params.suppressSyncValuesAfterDataChange) {
      this.addEventListenersForDataChanges();
    }
  };
  SetFilter.prototype.applyExcelModeOptions = function (params) {
    // apply default options to match Excel behaviour, unless they have already been specified
    if (params.excelMode === 'windows') {
      if (!params.buttons) {
        params.buttons = ['apply', 'cancel'];
      }
      if (params.closeOnApply == null) {
        params.closeOnApply = true;
      }
    } else if (params.excelMode === 'mac') {
      if (!params.buttons) {
        params.buttons = ['reset'];
      }
      if (params.applyMiniFilterWhileTyping == null) {
        params.applyMiniFilterWhileTyping = true;
      }
      if (params.debounceMs == null) {
        params.debounceMs = 500;
      }
    }
  };
  SetFilter.prototype.checkSetFilterDeprecatedParams = function (params) {
    if (params.syncValuesLikeExcel) {
      var message_2 = 'AG Grid: since version 22.x, the Set Filter param syncValuesLikeExcel is no longer' + ' used as this is the default behaviour. To turn this default behaviour off, use the' + ' param suppressSyncValuesAfterDataChange';
      _.doOnce(function () {
        return console.warn(message_2);
      }, 'syncValuesLikeExcel deprecated');
    }
    if (params.selectAllOnMiniFilter) {
      var message_3 = 'AG Grid: since version 22.x, the Set Filter param selectAllOnMiniFilter is no longer' + ' used as this is the default behaviour.';
      _.doOnce(function () {
        return console.warn(message_3);
      }, 'selectAllOnMiniFilter deprecated');
    }
    if (params.suppressSyncValuesAfterDataChange) {
      var message_4 = 'AG Grid: since version 23.1, the Set Filter param suppressSyncValuesAfterDataChange has' + ' been deprecated and will be removed in a future major release.';
      _.doOnce(function () {
        return console.warn(message_4);
      }, 'suppressSyncValuesAfterDataChange deprecated');
    }
    if (params.suppressRemoveEntries) {
      var message_5 = 'AG Grid: since version 23.1, the Set Filter param suppressRemoveEntries has' + ' been deprecated and will be removed in a future major release.';
      _.doOnce(function () {
        return console.warn(message_5);
      }, 'suppressRemoveEntries deprecated');
    }
  };
  SetFilter.prototype.addEventListenersForDataChanges = function () {
    var _this = this;
    this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATED, function () {
      return _this.syncAfterDataChange();
    });
    this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, function (event) {
      // only interested in changes to do with this column
      if (_this.setFilterParams && event.column === _this.setFilterParams.column) {
        _this.syncAfterDataChange();
      }
    });
  };
  SetFilter.prototype.syncAfterDataChange = function (refreshValues, keepSelection) {
    var _this = this;
    if (refreshValues === void 0) {
      refreshValues = true;
    }
    if (keepSelection === void 0) {
      keepSelection = true;
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var promise = AgPromise.resolve();
    if (refreshValues) {
      promise = this.valueModel.refreshValues(keepSelection);
    } else if (!keepSelection) {
      promise = this.valueModel.setModel(null);
    }
    return promise.then(function () {
      _this.refresh();
      _this.onBtApply(false, true);
    });
  };
  /** @deprecated since version 23.2. The loading screen is displayed automatically when the set filter is retrieving values. */
  SetFilter.prototype.setLoading = function (loading) {
    var message = 'AG Grid: since version 23.2, setLoading has been deprecated. The loading screen is displayed automatically when the set filter is retrieving values.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.setLoading');
    this.showOrHideLoadingScreen(loading);
  };
  SetFilter.prototype.showOrHideLoadingScreen = function (isLoading) {
    _.setDisplayed(this.eFilterLoading, isLoading);
  };
  SetFilter.prototype.initialiseFilterBodyUi = function () {
    this.initVirtualList();
    this.initMiniFilter();
  };
  SetFilter.prototype.initVirtualList = function () {
    var _this = this;
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    var filterListName = translate('ariaFilterList', 'Filter List');
    var virtualList = this.virtualList = this.createBean(new VirtualList('filter', 'listbox', filterListName));
    var eSetFilterList = this.getRefElement('eSetFilterList');
    if (eSetFilterList) {
      eSetFilterList.appendChild(virtualList.getGui());
    }
    var cellHeight = this.setFilterParams.cellHeight;
    if (cellHeight != null) {
      virtualList.setRowHeight(cellHeight);
    }
    virtualList.setComponentCreator(function (value) {
      return _this.createSetListItem(value);
    });
    var model;
    if (this.setFilterParams.suppressSelectAll) {
      model = new ModelWrapper(this.valueModel);
    } else {
      model = new ModelWrapperWithSelectAll(this.valueModel, function () {
        return _this.isSelectAllSelected();
      });
    }
    virtualList.setModel(model);
  };
  SetFilter.prototype.getSelectAllLabel = function () {
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var key = this.valueModel.getMiniFilter() == null || !this.setFilterParams.excelMode ? 'selectAll' : 'selectAllSearchResults';
    return this.translateForSetFilter(key);
  };
  SetFilter.prototype.createSetListItem = function (value) {
    var _this = this;
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var listItem;
    if (value === SetFilter.SELECT_ALL_VALUE) {
      listItem = this.createBean(new SetFilterListItem(function () {
        return _this.getSelectAllLabel();
      }, this.setFilterParams, function (key) {
        return _this.translateForSetFilter(key);
      }, this.isSelectAllSelected()));
      listItem.addEventListener(SetFilterListItem.EVENT_SELECTION_CHANGED, function (e) {
        return _this.onSelectAll(e.isSelected);
      });
      return listItem;
    }
    listItem = this.createBean(new SetFilterListItem(value, this.setFilterParams, function (key) {
      return _this.translateForSetFilter(key);
    }, this.valueModel.isValueSelected(value)));
    listItem.addEventListener(SetFilterListItem.EVENT_SELECTION_CHANGED, function (e) {
      return _this.onItemSelected(value, e.isSelected);
    });
    return listItem;
  };
  SetFilter.prototype.initMiniFilter = function () {
    var _this = this;
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var _a = this,
      eMiniFilter = _a.eMiniFilter,
      gridOptionsWrapper = _a.gridOptionsWrapper;
    var translate = gridOptionsWrapper.getLocaleTextFunc();
    _.setDisplayed(eMiniFilter.getGui(), !this.setFilterParams.suppressMiniFilter);
    eMiniFilter.setValue(this.valueModel.getMiniFilter());
    eMiniFilter.onValueChange(function () {
      return _this.onMiniFilterInput();
    });
    eMiniFilter.setInputAriaLabel(translate('ariaSearchFilterValues', 'Search filter values'));
    this.addManagedListener(eMiniFilter.getInputElement(), 'keypress', function (e) {
      return _this.onMiniFilterKeyPress(e);
    });
  };
  // we need to have the GUI attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the GUI state
  SetFilter.prototype.afterGuiAttached = function (params) {
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    _super.prototype.afterGuiAttached.call(this, params);
    this.refreshVirtualList();
    if (this.setFilterParams.excelMode) {
      this.resetUiToActiveModel();
    }
    var eMiniFilter = this.eMiniFilter;
    eMiniFilter.setInputPlaceholder(this.translateForSetFilter('searchOoo'));
    if (!params || !params.suppressFocus) {
      eMiniFilter.getFocusableElement().focus();
    }
    var resizable = !!(params && params.container === 'floatingFilter');
    var resizableObject;
    if (this.gridOptionsWrapper.isEnableRtl()) {
      resizableObject = {
        bottom: true,
        bottomLeft: true,
        left: true
      };
    } else {
      resizableObject = {
        bottom: true,
        bottomRight: true,
        right: true
      };
    }
    if (resizable) {
      this.positionableFeature.restoreLastSize();
      this.positionableFeature.setResizable(resizableObject);
    } else {
      this.positionableFeature.removeSizeFromEl();
      this.positionableFeature.setResizable(false);
    }
  };
  SetFilter.prototype.applyModel = function () {
    var _this = this;
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    if (this.setFilterParams.excelMode && this.valueModel.isEverythingVisibleSelected()) {
      // In Excel, if the filter is applied with all visible values selected, then any active filter on the
      // column is removed. This ensures the filter is removed in this situation.
      this.valueModel.selectAllMatchingMiniFilter();
    }
    var result = _super.prototype.applyModel.call(this);
    // keep appliedModelValues in sync with the applied model
    var appliedModel = this.getModel();
    if (appliedModel) {
      this.appliedModelValues = _.reduce(appliedModel.values, function (values, value) {
        values[_this.caseFormat(String(value))] = true;
        return values;
      }, {});
    } else {
      this.appliedModelValues = null;
    }
    return result;
  };
  SetFilter.prototype.isModelValid = function (model) {
    return this.setFilterParams && this.setFilterParams.excelMode ? model == null || model.values.length > 0 : true;
  };
  SetFilter.prototype.doesFilterPass = function (params) {
    var _this = this;
    if (!this.setFilterParams || !this.valueModel || !this.appliedModelValues) {
      return true;
    }
    var _a = this.setFilterParams,
      valueGetter = _a.valueGetter,
      keyCreator = _a.colDef.keyCreator;
    var value = valueGetter(params.node);
    if (keyCreator) {
      var keyParams = {
        value: value,
        colDef: this.setFilterParams.colDef,
        column: this.setFilterParams.column,
        node: params.node,
        data: params.data,
        api: this.gridOptionsWrapper.getApi(),
        columnApi: this.gridOptionsWrapper.getColumnApi(),
        context: this.gridOptionsWrapper.getContext()
      };
      value = keyCreator(keyParams);
    }
    value = _.makeNull(value);
    if (Array.isArray(value)) {
      return _.some(value, function (v) {
        return _this.appliedModelValues[_this.caseFormat(_.makeNull(v))] === true;
      });
    }
    // Comparing against a value performs better than just checking for undefined
    // https://jsbench.me/hdk91jbw1h/
    return this.appliedModelValues[this.caseFormat(value)] === true;
  };
  SetFilter.prototype.onNewRowsLoaded = function () {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var valuesType = this.valueModel.getValuesType();
    var keepSelection = this.isNewRowsActionKeep();
    this.syncAfterDataChange(valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES, keepSelection);
  };
  //noinspection JSUnusedGlobalSymbols
  /**
   * Public method provided so the user can change the value of the filter once
   * the filter has been already started
   * @param options The options to use.
   */
  SetFilter.prototype.setFilterValues = function (options) {
    var _this = this;
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.overrideValues(options, this.isNewRowsActionKeep()).then(function () {
      _this.refresh();
      _this.onUiChanged();
    });
  };
  //noinspection JSUnusedGlobalSymbols
  /**
   * Public method provided so the user can reset the values of the filter once that it has started.
   */
  SetFilter.prototype.resetFilterValues = function () {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.setValuesType(SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES);
    this.syncAfterDataChange(true, this.isNewRowsActionKeep());
  };
  SetFilter.prototype.refreshFilterValues = function () {
    var _this = this;
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    // the model is still being initialised
    if (!this.valueModel.isInitialised()) {
      return;
    }
    this.valueModel.refreshValues().then(function () {
      _this.refresh();
      _this.onUiChanged();
    });
  };
  SetFilter.prototype.onAnyFilterChanged = function () {
    var _this = this;
    // don't block the current action when updating the values for this filter
    setTimeout(function () {
      if (!_this.isAlive()) {
        return;
      }
      if (!_this.valueModel) {
        throw new Error('Value model has not been created.');
      }
      _this.valueModel.refreshAfterAnyFilterChanged().then(function () {
        return _this.refresh();
      });
    }, 0);
  };
  SetFilter.prototype.onMiniFilterInput = function () {
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    if (!this.valueModel.setMiniFilter(this.eMiniFilter.getValue())) {
      return;
    }
    var _a = this.setFilterParams || {},
      applyMiniFilterWhileTyping = _a.applyMiniFilterWhileTyping,
      readOnly = _a.readOnly;
    if (!readOnly && applyMiniFilterWhileTyping) {
      this.filterOnAllVisibleValues(false);
    } else {
      this.updateUiAfterMiniFilterChange();
    }
  };
  SetFilter.prototype.updateUiAfterMiniFilterChange = function () {
    if (!this.setFilterParams) {
      throw new Error('Set filter params have not been provided.');
    }
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var _a = this.setFilterParams || {},
      excelMode = _a.excelMode,
      readOnly = _a.readOnly;
    if (excelMode == null || !!readOnly) {
      this.refresh();
    } else if (this.valueModel.getMiniFilter() == null) {
      this.resetUiToActiveModel();
    } else {
      this.valueModel.selectAllMatchingMiniFilter(true);
      this.refresh();
      this.onUiChanged();
    }
    this.showOrHideResults();
  };
  SetFilter.prototype.showOrHideResults = function () {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    var hideResults = this.valueModel.getMiniFilter() != null && this.valueModel.getDisplayedValueCount() < 1;
    _.setDisplayed(this.eNoMatches, hideResults);
    _.setDisplayed(this.eSetFilterList, !hideResults);
  };
  SetFilter.prototype.resetUiToActiveModel = function () {
    var _this = this;
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.eMiniFilter.setValue(null, true);
    this.valueModel.setMiniFilter(null);
    this.setModelIntoUi(this.getModel()).then(function () {
      return _this.onUiChanged(false, 'prevent');
    });
  };
  SetFilter.prototype.onMiniFilterKeyPress = function (e) {
    var _a = this.setFilterParams || {},
      excelMode = _a.excelMode,
      readOnly = _a.readOnly;
    if (_.isKeyPressed(e, KeyCode.ENTER) && !excelMode && !readOnly) {
      this.filterOnAllVisibleValues();
    }
  };
  SetFilter.prototype.filterOnAllVisibleValues = function (applyImmediately) {
    if (applyImmediately === void 0) {
      applyImmediately = true;
    }
    var readOnly = (this.setFilterParams || {}).readOnly;
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    if (!!readOnly) {
      throw new Error('Unable to filter in readOnly mode.');
    }
    this.valueModel.selectAllMatchingMiniFilter(true);
    this.refresh();
    this.onUiChanged(false, applyImmediately ? 'immediately' : 'debounce');
    this.showOrHideResults();
  };
  SetFilter.prototype.focusRowIfAlive = function (rowIndex) {
    var _this = this;
    if (rowIndex == null) {
      return;
    }
    window.setTimeout(function () {
      if (!_this.virtualList) {
        throw new Error('Virtual list has not been created.');
      }
      if (_this.isAlive()) {
        _this.virtualList.focusRow(rowIndex);
      }
    }, 0);
  };
  SetFilter.prototype.onSelectAll = function (isSelected) {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    if (!this.virtualList) {
      throw new Error('Virtual list has not been created.');
    }
    if (isSelected) {
      this.valueModel.selectAllMatchingMiniFilter();
    } else {
      this.valueModel.deselectAllMatchingMiniFilter();
    }
    var focusedRow = this.virtualList.getLastFocusedRow();
    this.refresh();
    this.onUiChanged();
    this.focusRowIfAlive(focusedRow);
  };
  SetFilter.prototype.onItemSelected = function (value, isSelected) {
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    if (!this.virtualList) {
      throw new Error('Virtual list has not been created.');
    }
    if (isSelected) {
      this.valueModel.selectValue(value);
    } else {
      this.valueModel.deselectValue(value);
    }
    var focusedRow = this.virtualList.getLastFocusedRow();
    this.refresh();
    this.onUiChanged();
    this.focusRowIfAlive(focusedRow);
  };
  SetFilter.prototype.setMiniFilter = function (newMiniFilter) {
    this.eMiniFilter.setValue(newMiniFilter);
    this.onMiniFilterInput();
  };
  SetFilter.prototype.getMiniFilter = function () {
    return this.valueModel ? this.valueModel.getMiniFilter() : null;
  };
  /** @deprecated since version 23.2. Please use setModel instead. */
  SetFilter.prototype.selectEverything = function () {
    var message = 'AG Grid: since version 23.2, selectEverything has been deprecated. Please use setModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.selectEverything');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.selectAllMatchingMiniFilter();
    this.refresh();
  };
  /** @deprecated since version 23.2. Please use setModel instead. */
  SetFilter.prototype.selectNothing = function () {
    var message = 'AG Grid: since version 23.2, selectNothing has been deprecated. Please use setModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.selectNothing');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.deselectAllMatchingMiniFilter();
    this.refresh();
  };
  /** @deprecated since version 23.2. Please use setModel instead. */
  SetFilter.prototype.unselectValue = function (value) {
    var message = 'AG Grid: since version 23.2, unselectValue has been deprecated. Please use setModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.unselectValue');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.deselectValue(value);
    this.refresh();
  };
  /** @deprecated since version 23.2. Please use setModel instead. */
  SetFilter.prototype.selectValue = function (value) {
    var message = 'AG Grid: since version 23.2, selectValue has been deprecated. Please use setModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.selectValue');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    this.valueModel.selectValue(value);
    this.refresh();
  };
  SetFilter.prototype.refresh = function () {
    if (!this.virtualList) {
      throw new Error('Virtual list has not been created.');
    }
    this.virtualList.refresh();
  };
  /** @deprecated since version 23.2. Please use getModel instead. */
  SetFilter.prototype.isValueSelected = function (value) {
    var message = 'AG Grid: since version 23.2, isValueSelected has been deprecated. Please use getModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.isValueSelected');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    return this.valueModel.isValueSelected(value);
  };
  /** @deprecated since version 23.2. Please use getModel instead. */
  SetFilter.prototype.isEverythingSelected = function () {
    var message = 'AG Grid: since version 23.2, isEverythingSelected has been deprecated. Please use getModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.isEverythingSelected');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    return this.valueModel.isEverythingVisibleSelected();
  };
  /** @deprecated since version 23.2. Please use getModel instead. */
  SetFilter.prototype.isNothingSelected = function () {
    var message = 'AG Grid: since version 23.2, isNothingSelected has been deprecated. Please use getModel instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.isNothingSelected');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    return this.valueModel.isNothingVisibleSelected();
  };
  /** @deprecated since version 23.2. Please use getValues instead. */
  SetFilter.prototype.getUniqueValueCount = function () {
    var message = 'AG Grid: since version 23.2, getUniqueValueCount has been deprecated. Please use getValues instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.getUniqueValueCount');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    return this.valueModel.getUniqueValueCount();
  };
  /** @deprecated since version 23.2. Please use getValues instead. */
  SetFilter.prototype.getUniqueValue = function (index) {
    var message = 'AG Grid: since version 23.2, getUniqueValue has been deprecated. Please use getValues instead.';
    _.doOnce(function () {
      return console.warn(message);
    }, 'setFilter.getUniqueValue');
    if (!this.valueModel) {
      throw new Error('Value model has not been created.');
    }
    return this.valueModel.getUniqueValue(index);
  };
  SetFilter.prototype.getValues = function () {
    return this.valueModel ? this.valueModel.getValues() : [];
  };
  SetFilter.prototype.refreshVirtualList = function () {
    if (this.setFilterParams && this.setFilterParams.refreshValuesOnOpen) {
      this.refreshFilterValues();
    } else {
      this.refresh();
    }
  };
  SetFilter.prototype.translateForSetFilter = function (key) {
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    return translate(key, DEFAULT_LOCALE_TEXT[key]);
  };
  SetFilter.prototype.isSelectAllSelected = function () {
    if (!this.setFilterParams || !this.valueModel) {
      return false;
    }
    if (!this.setFilterParams.defaultToNothingSelected) {
      // everything selected by default
      if (this.valueModel.hasSelections() && this.valueModel.isNothingVisibleSelected()) {
        return false;
      }
      if (this.valueModel.isEverythingVisibleSelected()) {
        return true;
      }
    } else {
      // nothing selected by default
      if (this.valueModel.hasSelections() && this.valueModel.isEverythingVisibleSelected()) {
        return true;
      }
      if (this.valueModel.isNothingVisibleSelected()) {
        return false;
      }
    }
    // returning `undefined` means the checkbox status is indeterminate.
    return undefined;
  };
  SetFilter.prototype.destroy = function () {
    if (this.virtualList != null) {
      this.virtualList.destroy();
      this.virtualList = null;
    }
    _super.prototype.destroy.call(this);
  };
  SetFilter.prototype.caseFormat = function (valueToFormat) {
    if (valueToFormat == null || typeof valueToFormat !== 'string') {
      return valueToFormat;
    }
    return this.caseSensitive ? valueToFormat : valueToFormat.toUpperCase();
  };
  SetFilter.SELECT_ALL_VALUE = '__AG_SELECT_ALL__';
  __decorate$4k([RefSelector('eMiniFilter')], SetFilter.prototype, "eMiniFilter", void 0);
  __decorate$4k([RefSelector('eFilterLoading')], SetFilter.prototype, "eFilterLoading", void 0);
  __decorate$4k([RefSelector('eSetFilterList')], SetFilter.prototype, "eSetFilterList", void 0);
  __decorate$4k([RefSelector('eFilterNoMatches')], SetFilter.prototype, "eNoMatches", void 0);
  __decorate$4k([Autowired('valueFormatterService')], SetFilter.prototype, "valueFormatterService", void 0);
  return SetFilter;
}(ProvidedFilter);
var ModelWrapper = /** @class */function () {
  function ModelWrapper(model) {
    this.model = model;
  }
  ModelWrapper.prototype.getRowCount = function () {
    return this.model.getDisplayedValueCount();
  };
  ModelWrapper.prototype.getRow = function (index) {
    return this.model.getDisplayedValue(index);
  };
  ModelWrapper.prototype.isRowSelected = function (index) {
    return this.model.isValueSelected(this.getRow(index));
  };
  return ModelWrapper;
}();
var ModelWrapperWithSelectAll = /** @class */function () {
  function ModelWrapperWithSelectAll(model, isSelectAllSelected) {
    this.model = model;
    this.isSelectAllSelected = isSelectAllSelected;
  }
  ModelWrapperWithSelectAll.prototype.getRowCount = function () {
    return this.model.getDisplayedValueCount() + 1;
  };
  ModelWrapperWithSelectAll.prototype.getRow = function (index) {
    return index === 0 ? SetFilter.SELECT_ALL_VALUE : this.model.getDisplayedValue(index - 1);
  };
  ModelWrapperWithSelectAll.prototype.isRowSelected = function (index) {
    return index === 0 ? this.isSelectAllSelected() : this.model.isValueSelected(this.getRow(index));
  };
  return ModelWrapperWithSelectAll;
}();
var __extends$5P = undefined && undefined.__extends || function () {
  var _extendStatics380 = function extendStatics(d, b) {
    _extendStatics380 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics380(d, b);
  };
  return function (d, b) {
    _extendStatics380(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4l = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SetFloatingFilterComp = /** @class */function (_super) {
  __extends$5P(SetFloatingFilterComp, _super);
  function SetFloatingFilterComp() {
    var _this = _super.call(this, /* html */"\n            <div class=\"ag-floating-filter-input\" role=\"presentation\">\n                <ag-input-text-field ref=\"eFloatingFilterText\"></ag-input-text-field>\n            </div>") || this;
    _this.availableValuesListenerAdded = false;
    return _this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  SetFloatingFilterComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  SetFloatingFilterComp.prototype.init = function (params) {
    var displayName = this.columnModel.getDisplayNameForColumn(params.column, 'header', true);
    var translate = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(displayName + " " + translate('ariaFilterInput', 'Filter Input')).addGuiEventListener('click', function () {
      return params.showParentFilter();
    });
    this.params = params;
  };
  SetFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
    this.updateFloatingFilterText(parentModel);
  };
  SetFloatingFilterComp.prototype.addAvailableValuesListener = function () {
    var _this = this;
    this.params.parentFilterInstance(function (setFilter) {
      var setValueModel = setFilter.getValueModel();
      if (!setValueModel) {
        return;
      }
      // unlike other filters, what we show in the floating filter can be different, even
      // if another filter changes. this is due to how set filter restricts its values based
      // on selections in other filters, e.g. if you filter Language to English, then the set filter
      // on Country will only show English speaking countries. Thus the list of items to show
      // in the floating filter can change.
      _this.addManagedListener(setValueModel, SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED, function () {
        return _this.updateFloatingFilterText();
      });
    });
    this.availableValuesListenerAdded = true;
  };
  SetFloatingFilterComp.prototype.updateFloatingFilterText = function (parentModel) {
    var _this = this;
    if (!this.availableValuesListenerAdded) {
      this.addAvailableValuesListener();
    }
    this.params.parentFilterInstance(function (setFilter) {
      var values = (parentModel || setFilter.getModel() || {}).values;
      var valueModel = setFilter.getValueModel();
      if (values == null || valueModel == null) {
        _this.eFloatingFilterText.setValue('');
        return;
      }
      var localeTextFunc = _this.gridOptionsWrapper.getLocaleTextFunc();
      var availableValues = _.filter(values, function (v) {
        return valueModel.isValueAvailable(v);
      });
      // format all the values, if a formatter is provided
      var formattedValues = _.map(availableValues, function (value) {
        var _a = _this.params,
          column = _a.column,
          filterParams = _a.filterParams;
        var formattedValue = _this.valueFormatterService.formatValue(column, null, null, value, filterParams.valueFormatter, false);
        var valueToRender = formattedValue != null ? formattedValue : value;
        return valueToRender == null ? localeTextFunc('blanks', DEFAULT_LOCALE_TEXT.blanks) : valueToRender;
      });
      var arrayToDisplay = formattedValues.length > 10 ? formattedValues.slice(0, 10).concat('...') : formattedValues;
      var valuesString = "(" + formattedValues.length + ") " + arrayToDisplay.join(',');
      _this.eFloatingFilterText.setValue(valuesString);
    });
  };
  __decorate$4l([RefSelector('eFloatingFilterText')], SetFloatingFilterComp.prototype, "eFloatingFilterText", void 0);
  __decorate$4l([Autowired('valueFormatterService')], SetFloatingFilterComp.prototype, "valueFormatterService", void 0);
  __decorate$4l([Autowired('columnModel')], SetFloatingFilterComp.prototype, "columnModel", void 0);
  return SetFloatingFilterComp;
}(Component);
var SetFilterModule = {
  moduleName: ModuleNames.SetFilterModule,
  beans: [],
  userComponents: [{
    componentName: 'agSetColumnFilter',
    componentClass: SetFilter
  }, {
    componentName: 'agSetColumnFloatingFilter',
    componentClass: SetFloatingFilterComp
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5Q = undefined && undefined.__extends || function () {
  var _extendStatics381 = function extendStatics(d, b) {
    _extendStatics381 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics381(d, b);
  };
  return function (d, b) {
    _extendStatics381(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4m = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StatusBarService = /** @class */function (_super) {
  __extends$5Q(StatusBarService, _super);
  // tslint:disable-next-line
  function StatusBarService() {
    var _this = _super.call(this) || this;
    _this.allComponents = {};
    return _this;
  }
  StatusBarService.prototype.registerStatusPanel = function (key, component) {
    this.allComponents[key] = component;
  };
  StatusBarService.prototype.getStatusPanel = function (key) {
    return this.allComponents[key];
  };
  StatusBarService = __decorate$4m([Bean('statusBarService')], StatusBarService);
  return StatusBarService;
}(BeanStub);
var __extends$5R = undefined && undefined.__extends || function () {
  var _extendStatics382 = function extendStatics(d, b) {
    _extendStatics382 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics382(d, b);
  };
  return function (d, b) {
    _extendStatics382(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4n = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StatusBar = /** @class */function (_super) {
  __extends$5R(StatusBar, _super);
  function StatusBar() {
    return _super.call(this, StatusBar.TEMPLATE) || this;
  }
  StatusBar.prototype.postConstruct = function () {
    if (this.gridOptions.statusBar && this.gridOptions.statusBar.statusPanels) {
      var leftStatusPanelComponents = this.gridOptions.statusBar.statusPanels.filter(function (componentConfig) {
        return componentConfig.align === 'left';
      });
      this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft);
      var centerStatusPanelComponents = this.gridOptions.statusBar.statusPanels.filter(function (componentConfig) {
        return componentConfig.align === 'center';
      });
      this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter);
      var rightStatusPanelComponents = this.gridOptions.statusBar.statusPanels.filter(function (componentConfig) {
        return !componentConfig.align || componentConfig.align === 'right';
      });
      this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight);
    } else {
      this.setDisplayed(false);
    }
  };
  StatusBar.prototype.createAndRenderComponents = function (statusBarComponents, ePanelComponent) {
    var _this = this;
    var componentDetails = [];
    statusBarComponents.forEach(function (componentConfig) {
      var params = {
        api: _this.gridOptionsWrapper.getApi(),
        columnApi: _this.gridOptionsWrapper.getColumnApi(),
        context: _this.gridOptionsWrapper.getContext()
      };
      var compDetails = _this.userComponentFactory.getStatusPanelCompDetails(componentConfig, params);
      var promise = compDetails.newAgStackInstance();
      if (!promise) {
        return;
      }
      componentDetails.push({
        // default to the component name if no key supplied
        key: componentConfig.key || componentConfig.statusPanel,
        promise: promise
      });
    });
    AgPromise.all(componentDetails.map(function (details) {
      return details.promise;
    })).then(function () {
      componentDetails.forEach(function (componentDetail) {
        componentDetail.promise.then(function (component) {
          var destroyFunc = function destroyFunc() {
            _this.getContext().destroyBean(component);
          };
          if (_this.isAlive()) {
            _this.statusBarService.registerStatusPanel(componentDetail.key, component);
            ePanelComponent.appendChild(component.getGui());
            _this.addDestroyFunc(destroyFunc);
          } else {
            destroyFunc();
          }
        });
      });
    });
  };
  StatusBar.TEMPLATE = "<div class=\"ag-status-bar\">\n            <div ref=\"eStatusBarLeft\" class=\"ag-status-bar-left\" role=\"status\"></div>\n            <div ref=\"eStatusBarCenter\" class=\"ag-status-bar-center\" role=\"status\"></div>\n            <div ref=\"eStatusBarRight\" class=\"ag-status-bar-right\" role=\"status\"></div>\n        </div>";
  __decorate$4n([Autowired('gridOptions')], StatusBar.prototype, "gridOptions", void 0);
  __decorate$4n([Autowired('userComponentFactory')], StatusBar.prototype, "userComponentFactory", void 0);
  __decorate$4n([Autowired('statusBarService')], StatusBar.prototype, "statusBarService", void 0);
  __decorate$4n([RefSelector('eStatusBarLeft')], StatusBar.prototype, "eStatusBarLeft", void 0);
  __decorate$4n([RefSelector('eStatusBarCenter')], StatusBar.prototype, "eStatusBarCenter", void 0);
  __decorate$4n([RefSelector('eStatusBarRight')], StatusBar.prototype, "eStatusBarRight", void 0);
  __decorate$4n([PostConstruct], StatusBar.prototype, "postConstruct", null);
  return StatusBar;
}(Component);
var __extends$5S = undefined && undefined.__extends || function () {
  var _extendStatics383 = function extendStatics(d, b) {
    _extendStatics383 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics383(d, b);
  };
  return function (d, b) {
    _extendStatics383(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4o = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NameValueComp = /** @class */function (_super) {
  __extends$5S(NameValueComp, _super);
  function NameValueComp() {
    return _super.call(this, NameValueComp.TEMPLATE) || this;
  }
  NameValueComp.prototype.setLabel = function (key, defaultValue) {
    // we want to hide until the first value comes in
    this.setDisplayed(false);
    var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
    this.eLabel.innerHTML = localeTextFunc(key, defaultValue);
  };
  NameValueComp.prototype.setValue = function (value) {
    this.eValue.innerHTML = value;
  };
  NameValueComp.TEMPLATE = "<div class=\"ag-status-name-value\">\n            <span ref=\"eLabel\"></span>:&nbsp;\n            <span ref=\"eValue\" class=\"ag-status-name-value-value\"></span>\n        </div>";
  __decorate$4o([RefSelector('eLabel')], NameValueComp.prototype, "eLabel", void 0);
  __decorate$4o([RefSelector('eValue')], NameValueComp.prototype, "eValue", void 0);
  return NameValueComp;
}(Component);
var __extends$5T = undefined && undefined.__extends || function () {
  var _extendStatics384 = function extendStatics(d, b) {
    _extendStatics384 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics384(d, b);
  };
  return function (d, b) {
    _extendStatics384(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4p = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TotalAndFilteredRowsComp = /** @class */function (_super) {
  __extends$5T(TotalAndFilteredRowsComp, _super);
  function TotalAndFilteredRowsComp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TotalAndFilteredRowsComp.prototype.postConstruct = function () {
    // this component is only really useful with client side row model
    if (this.gridApi.getModel().getType() !== 'clientSide') {
      console.warn("AG Grid: agTotalAndFilteredRowCountComponent should only be used with the client side row model.");
      return;
    }
    this.setLabel('totalAndFilteredRows', 'Rows');
    this.addCssClass('ag-status-panel');
    this.addCssClass('ag-status-panel-total-and-filtered-row-count');
    this.setDisplayed(true);
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
  };
  TotalAndFilteredRowsComp.prototype.onDataChanged = function () {
    var rowCount = _.formatNumberCommas(this.getFilteredRowCountValue());
    var totalRowCount = _.formatNumberCommas(this.getTotalRowCount());
    if (rowCount === totalRowCount) {
      this.setValue(rowCount);
    } else {
      var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
      this.setValue(rowCount + " " + localeTextFunc('of', 'of') + " " + totalRowCount);
    }
  };
  TotalAndFilteredRowsComp.prototype.getFilteredRowCountValue = function () {
    var filteredRowCount = 0;
    this.gridApi.forEachNodeAfterFilter(function (node) {
      if (!node.group) {
        filteredRowCount++;
      }
    });
    return filteredRowCount;
  };
  TotalAndFilteredRowsComp.prototype.getTotalRowCount = function () {
    var totalRowCount = 0;
    this.gridApi.forEachNode(function (node) {
      if (!node.group) {
        totalRowCount++;
      }
    });
    return totalRowCount;
  };
  TotalAndFilteredRowsComp.prototype.init = function () {};
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  TotalAndFilteredRowsComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  __decorate$4p([Autowired('gridApi')], TotalAndFilteredRowsComp.prototype, "gridApi", void 0);
  __decorate$4p([PostConstruct], TotalAndFilteredRowsComp.prototype, "postConstruct", null);
  return TotalAndFilteredRowsComp;
}(NameValueComp);
var __extends$5U = undefined && undefined.__extends || function () {
  var _extendStatics385 = function extendStatics(d, b) {
    _extendStatics385 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics385(d, b);
  };
  return function (d, b) {
    _extendStatics385(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4q = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilteredRowsComp = /** @class */function (_super) {
  __extends$5U(FilteredRowsComp, _super);
  function FilteredRowsComp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FilteredRowsComp.prototype.postConstruct = function () {
    this.setLabel('filteredRows', 'Filtered');
    // this component is only really useful with client side row model
    if (this.gridApi.getModel().getType() !== 'clientSide') {
      console.warn("AG Grid: agFilteredRowCountComponent should only be used with the client side row model.");
      return;
    }
    this.addCssClass('ag-status-panel');
    this.addCssClass('ag-status-panel-filtered-row-count');
    this.setDisplayed(true);
    var listener = this.onDataChanged.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, listener);
  };
  FilteredRowsComp.prototype.onDataChanged = function () {
    var totalRowCountValue = this.getTotalRowCountValue();
    var filteredRowCountValue = this.getFilteredRowCountValue();
    this.setValue(_.formatNumberCommas(filteredRowCountValue));
    this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
  };
  FilteredRowsComp.prototype.getTotalRowCountValue = function () {
    var totalRowCount = 0;
    this.gridApi.forEachNode(function (node) {
      return totalRowCount += 1;
    });
    return totalRowCount;
  };
  FilteredRowsComp.prototype.getFilteredRowCountValue = function () {
    var filteredRowCount = 0;
    this.gridApi.forEachNodeAfterFilter(function (node) {
      if (!node.group) {
        filteredRowCount += 1;
      }
    });
    return filteredRowCount;
  };
  FilteredRowsComp.prototype.init = function () {};
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  FilteredRowsComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  __decorate$4q([Autowired('gridApi')], FilteredRowsComp.prototype, "gridApi", void 0);
  __decorate$4q([PostConstruct], FilteredRowsComp.prototype, "postConstruct", null);
  return FilteredRowsComp;
}(NameValueComp);
var __extends$5V = undefined && undefined.__extends || function () {
  var _extendStatics386 = function extendStatics(d, b) {
    _extendStatics386 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics386(d, b);
  };
  return function (d, b) {
    _extendStatics386(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4r = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TotalRowsComp = /** @class */function (_super) {
  __extends$5V(TotalRowsComp, _super);
  function TotalRowsComp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TotalRowsComp.prototype.postConstruct = function () {
    this.setLabel('totalRows', 'Total Rows');
    // this component is only really useful with client side row model
    if (this.gridApi.getModel().getType() !== 'clientSide') {
      console.warn("AG Grid: agTotalRowCountComponent should only be used with the client side row model.");
      return;
    }
    this.addCssClass('ag-status-panel');
    this.addCssClass('ag-status-panel-total-row-count');
    this.setDisplayed(true);
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
  };
  TotalRowsComp.prototype.onDataChanged = function () {
    this.setValue(_.formatNumberCommas(this.getRowCountValue()));
  };
  TotalRowsComp.prototype.getRowCountValue = function () {
    var totalRowCount = 0;
    this.gridApi.forEachLeafNode(function (node) {
      return totalRowCount += 1;
    });
    return totalRowCount;
  };
  TotalRowsComp.prototype.init = function () {};
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  TotalRowsComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  __decorate$4r([Autowired('gridApi')], TotalRowsComp.prototype, "gridApi", void 0);
  __decorate$4r([PostConstruct], TotalRowsComp.prototype, "postConstruct", null);
  return TotalRowsComp;
}(NameValueComp);
var __extends$5W = undefined && undefined.__extends || function () {
  var _extendStatics387 = function extendStatics(d, b) {
    _extendStatics387 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics387(d, b);
  };
  return function (d, b) {
    _extendStatics387(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4s = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SelectedRowsComp = /** @class */function (_super) {
  __extends$5W(SelectedRowsComp, _super);
  function SelectedRowsComp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SelectedRowsComp.prototype.postConstruct = function () {
    if (!this.isValidRowModel()) {
      console.warn("AG Grid: agSelectedRowCountComponent should only be used with the client and server side row model.");
      return;
    }
    this.setLabel('selectedRows', 'Selected');
    this.addCssClass('ag-status-panel');
    this.addCssClass('ag-status-panel-selected-row-count');
    var selectedRowCount = this.gridApi.getSelectedRows().length;
    this.setValue(_.formatNumberCommas(selectedRowCount));
    this.setDisplayed(selectedRowCount > 0);
    var eventListener = this.onRowSelectionChanged.bind(this);
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, eventListener);
    this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, eventListener);
  };
  SelectedRowsComp.prototype.isValidRowModel = function () {
    // this component is only really useful with client or server side rowmodels
    var rowModelType = this.gridApi.getModel().getType();
    return rowModelType === 'clientSide' || rowModelType === 'serverSide';
  };
  SelectedRowsComp.prototype.onRowSelectionChanged = function () {
    var selectedRowCount = this.gridApi.getSelectedRows().length;
    this.setValue(_.formatNumberCommas(selectedRowCount));
    this.setDisplayed(selectedRowCount > 0);
  };
  SelectedRowsComp.prototype.init = function () {};
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  SelectedRowsComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  __decorate$4s([Autowired('gridApi')], SelectedRowsComp.prototype, "gridApi", void 0);
  __decorate$4s([PostConstruct], SelectedRowsComp.prototype, "postConstruct", null);
  return SelectedRowsComp;
}(NameValueComp);
var __extends$5X = undefined && undefined.__extends || function () {
  var _extendStatics388 = function extendStatics(d, b) {
    _extendStatics388 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics388(d, b);
  };
  return function (d, b) {
    _extendStatics388(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4t = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AggregationComp = /** @class */function (_super) {
  __extends$5X(AggregationComp, _super);
  function AggregationComp() {
    return _super.call(this, AggregationComp.TEMPLATE) || this;
  }
  // this is a user component, and IComponent has "public destroy()" as part of the interface.
  // so we need to override destroy() just to make the method public.
  AggregationComp.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };
  AggregationComp.prototype.postConstruct = function () {
    if (!this.isValidRowModel()) {
      console.warn("AG Grid: agAggregationComponent should only be used with the client and server side row model.");
      return;
    }
    this.avgAggregationComp.setLabel('avg', 'Average');
    this.countAggregationComp.setLabel('count', 'Count');
    this.minAggregationComp.setLabel('min', 'Min');
    this.maxAggregationComp.setLabel('max', 'Max');
    this.sumAggregationComp.setLabel('sum', 'Sum');
    this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, this.onRangeSelectionChanged.bind(this));
    this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onRangeSelectionChanged.bind(this));
  };
  AggregationComp.prototype.isValidRowModel = function () {
    // this component is only really useful with client or server side rowmodels
    var rowModelType = this.gridApi.getModel().getType();
    return rowModelType === 'clientSide' || rowModelType === 'serverSide';
  };
  AggregationComp.prototype.init = function () {};
  AggregationComp.prototype.setAggregationComponentValue = function (aggFuncName, value, visible) {
    var statusBarValueComponent = this.getAggregationValueComponent(aggFuncName);
    if (_.exists(statusBarValueComponent) && statusBarValueComponent) {
      statusBarValueComponent.setValue(_.formatNumberTwoDecimalPlacesAndCommas(value));
      statusBarValueComponent.setDisplayed(visible);
    }
  };
  AggregationComp.prototype.getAggregationValueComponent = function (aggFuncName) {
    // converts user supplied agg name to our reference - eg: sum => sumAggregationComp
    var refComponentName = aggFuncName + "AggregationComp";
    // if the user has specified the agAggregationPanelComp but no aggFuncs we show the all
    // if the user has specified the agAggregationPanelComp and aggFuncs, then we only show the aggFuncs listed
    var statusBarValueComponent = null;
    var aggregationPanelConfig = _.exists(this.gridOptions.statusBar) && this.gridOptions.statusBar ? _.find(this.gridOptions.statusBar.statusPanels, function (panel) {
      return panel.statusPanel === 'agAggregationComponent';
    }) : null;
    if (_.exists(aggregationPanelConfig) && aggregationPanelConfig) {
      // a little defensive here - if no statusPanelParams show it, if componentParams we also expect aggFuncs
      if (!_.exists(aggregationPanelConfig.statusPanelParams) || _.exists(aggregationPanelConfig.statusPanelParams) && _.exists(aggregationPanelConfig.statusPanelParams.aggFuncs) && _.exists(_.find(aggregationPanelConfig.statusPanelParams.aggFuncs, function (func) {
        return func === aggFuncName;
      }))) {
        statusBarValueComponent = this[refComponentName];
      }
    } else {
      // components not specified - assume we can show this component
      statusBarValueComponent = this[refComponentName];
    }
    // either we can't find it (which would indicate a typo or similar user side), or the user has deliberately
    // not listed the component in aggFuncs
    return statusBarValueComponent;
  };
  AggregationComp.prototype.onRangeSelectionChanged = function () {
    var _this = this;
    var cellRanges = this.rangeService ? this.rangeService.getCellRanges() : undefined;
    var sum = 0;
    var count = 0;
    var numberCount = 0;
    var min = null;
    var max = null;
    var cellsSoFar = {};
    if (cellRanges && !_.missingOrEmpty(cellRanges)) {
      cellRanges.forEach(function (cellRange) {
        var currentRow = _this.rangeService.getRangeStartRow(cellRange);
        var lastRow = _this.rangeService.getRangeEndRow(cellRange);
        while (true) {
          var finishedAllRows = _.missing(currentRow) || !currentRow || _this.rowPositionUtils.before(lastRow, currentRow);
          if (finishedAllRows || !currentRow || !cellRange.columns) {
            break;
          }
          cellRange.columns.forEach(function (col) {
            if (currentRow === null) {
              return;
            }
            // we only want to include each cell once, in case a cell is in multiple ranges
            var cellId = _this.cellPositionUtils.createId({
              rowPinned: currentRow.rowPinned,
              column: col,
              rowIndex: currentRow.rowIndex
            });
            if (cellsSoFar[cellId]) {
              return;
            }
            cellsSoFar[cellId] = true;
            var rowNode = _this.rowRenderer.getRowNode(currentRow);
            if (_.missing(rowNode)) {
              return;
            }
            var value = _this.valueService.getValue(col, rowNode);
            // if empty cell, skip it, doesn't impact count or anything
            if (_.missing(value) || value === '') {
              return;
            }
            // see if value is wrapped, can happen when doing count() or avg() functions
            if (value.value) {
              value = value.value;
            }
            if (typeof value === 'string') {
              value = Number(value);
            }
            if (typeof value === 'number' && !isNaN(value)) {
              sum += value;
              if (max === null || value > max) {
                max = value;
              }
              if (min === null || value < min) {
                min = value;
              }
              numberCount++;
            }
            count++;
          });
          currentRow = _this.cellNavigationService.getRowBelow(currentRow);
        }
      });
    }
    var gotResult = count > 1;
    var gotNumberResult = numberCount > 1;
    // we show count even if no numbers
    this.setAggregationComponentValue('count', count, gotResult);
    // show if numbers found
    this.setAggregationComponentValue('sum', sum, gotNumberResult);
    this.setAggregationComponentValue('min', min, gotNumberResult);
    this.setAggregationComponentValue('max', max, gotNumberResult);
    this.setAggregationComponentValue('avg', sum / numberCount, gotNumberResult);
  };
  AggregationComp.TEMPLATE = "<div class=\"ag-status-panel ag-status-panel-aggregations\">\n            <ag-name-value ref=\"avgAggregationComp\"></ag-name-value>\n            <ag-name-value ref=\"countAggregationComp\"></ag-name-value>\n            <ag-name-value ref=\"minAggregationComp\"></ag-name-value>\n            <ag-name-value ref=\"maxAggregationComp\"></ag-name-value>\n            <ag-name-value ref=\"sumAggregationComp\"></ag-name-value>\n        </div>";
  __decorate$4t([Optional('rangeService')], AggregationComp.prototype, "rangeService", void 0);
  __decorate$4t([Autowired('valueService')], AggregationComp.prototype, "valueService", void 0);
  __decorate$4t([Autowired('cellNavigationService')], AggregationComp.prototype, "cellNavigationService", void 0);
  __decorate$4t([Autowired('rowRenderer')], AggregationComp.prototype, "rowRenderer", void 0);
  __decorate$4t([Autowired('gridOptions')], AggregationComp.prototype, "gridOptions", void 0);
  __decorate$4t([Autowired('gridApi')], AggregationComp.prototype, "gridApi", void 0);
  __decorate$4t([Autowired('cellPositionUtils')], AggregationComp.prototype, "cellPositionUtils", void 0);
  __decorate$4t([Autowired('rowPositionUtils')], AggregationComp.prototype, "rowPositionUtils", void 0);
  __decorate$4t([RefSelector('sumAggregationComp')], AggregationComp.prototype, "sumAggregationComp", void 0);
  __decorate$4t([RefSelector('countAggregationComp')], AggregationComp.prototype, "countAggregationComp", void 0);
  __decorate$4t([RefSelector('minAggregationComp')], AggregationComp.prototype, "minAggregationComp", void 0);
  __decorate$4t([RefSelector('maxAggregationComp')], AggregationComp.prototype, "maxAggregationComp", void 0);
  __decorate$4t([RefSelector('avgAggregationComp')], AggregationComp.prototype, "avgAggregationComp", void 0);
  __decorate$4t([PostConstruct], AggregationComp.prototype, "postConstruct", null);
  return AggregationComp;
}(Component);
var StatusBarModule = {
  moduleName: ModuleNames.StatusBarModule,
  beans: [StatusBarService],
  agStackComponents: [{
    componentName: 'AgStatusBar',
    componentClass: StatusBar
  }, {
    componentName: 'AgNameValue',
    componentClass: NameValueComp
  }],
  userComponents: [{
    componentName: 'agAggregationComponent',
    componentClass: AggregationComp
  }, {
    componentName: 'agSelectedRowCountComponent',
    componentClass: SelectedRowsComp
  }, {
    componentName: 'agTotalRowCountComponent',
    componentClass: TotalRowsComp
  }, {
    componentName: 'agFilteredRowCountComponent',
    componentClass: FilteredRowsComp
  }, {
    componentName: 'agTotalAndFilteredRowCountComponent',
    componentClass: TotalAndFilteredRowsComp
  }],
  dependantModules: [EnterpriseCoreModule]
};
var __extends$5Y = undefined && undefined.__extends || function () {
  var _extendStatics389 = function extendStatics(d, b) {
    _extendStatics389 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics389(d, b);
  };
  return function (d, b) {
    _extendStatics389(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4u = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ViewportRowModel = /** @class */function (_super) {
  __extends$5Y(ViewportRowModel, _super);
  function ViewportRowModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // rowRenderer tells us these
    _this.firstRow = -1;
    _this.lastRow = -1;
    // datasource tells us this
    _this.rowCount = -1;
    _this.rowNodesByIndex = {};
    return _this;
  }
  // we don't implement as lazy row heights is not supported in this row model
  ViewportRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
    return false;
  };
  ViewportRowModel.prototype.init = function () {
    this.rowHeight = this.gridOptionsWrapper.getRowHeightAsNumber();
    this.addManagedListener(this.eventService, Events.EVENT_VIEWPORT_CHANGED, this.onViewportChanged.bind(this));
  };
  ViewportRowModel.prototype.start = function () {
    if (this.gridOptionsWrapper.getViewportDatasource()) {
      this.setViewportDatasource(this.gridOptionsWrapper.getViewportDatasource());
    }
  };
  ViewportRowModel.prototype.isLastRowIndexKnown = function () {
    return true;
  };
  ViewportRowModel.prototype.destroyDatasource = function () {
    if (!this.viewportDatasource) {
      return;
    }
    if (this.viewportDatasource.destroy) {
      this.viewportDatasource.destroy();
    }
    this.rowRenderer.datasourceChanged();
    this.firstRow = -1;
    this.lastRow = -1;
  };
  ViewportRowModel.prototype.calculateFirstRow = function (firstRenderedRow) {
    var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
    var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
    var afterBuffer = firstRenderedRow - bufferSize;
    if (afterBuffer < 0) {
      return 0;
    }
    return Math.floor(afterBuffer / pageSize) * pageSize;
  };
  ViewportRowModel.prototype.calculateLastRow = function (lastRenderedRow) {
    if (lastRenderedRow === -1) {
      return lastRenderedRow;
    }
    var bufferSize = this.gridOptionsWrapper.getViewportRowModelBufferSize();
    var pageSize = this.gridOptionsWrapper.getViewportRowModelPageSize();
    var afterBuffer = lastRenderedRow + bufferSize;
    var result = Math.ceil(afterBuffer / pageSize) * pageSize;
    var lastRowIndex = this.rowCount - 1;
    return Math.min(result, lastRowIndex);
  };
  ViewportRowModel.prototype.onViewportChanged = function (event) {
    var newFirst = this.calculateFirstRow(event.firstRow);
    var newLast = this.calculateLastRow(event.lastRow);
    if (this.firstRow !== newFirst || this.lastRow !== newLast) {
      this.firstRow = newFirst;
      this.lastRow = newLast;
      this.purgeRowsNotInViewport();
      if (this.viewportDatasource) {
        this.viewportDatasource.setViewportRange(this.firstRow, this.lastRow);
      }
    }
  };
  ViewportRowModel.prototype.purgeRowsNotInViewport = function () {
    var _this = this;
    Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
      var index = parseInt(indexStr, 10);
      if (index < _this.firstRow || index > _this.lastRow) {
        delete _this.rowNodesByIndex[index];
      }
    });
  };
  ViewportRowModel.prototype.setViewportDatasource = function (viewportDatasource) {
    this.destroyDatasource();
    this.viewportDatasource = viewportDatasource;
    this.rowCount = 0;
    if (!viewportDatasource.init) {
      console.warn('AG Grid: viewport is missing init method.');
    } else {
      viewportDatasource.init({
        setRowCount: this.setRowCount.bind(this),
        setRowData: this.setRowData.bind(this),
        getRow: this.getRow.bind(this)
      });
    }
  };
  ViewportRowModel.prototype.getType = function () {
    return Constants.ROW_MODEL_TYPE_VIEWPORT;
  };
  ViewportRowModel.prototype.getRow = function (rowIndex) {
    if (!this.rowNodesByIndex[rowIndex]) {
      this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
    }
    return this.rowNodesByIndex[rowIndex];
  };
  ViewportRowModel.prototype.getRowNode = function (id) {
    var result = undefined;
    this.forEachNode(function (rowNode) {
      if (rowNode.id === id) {
        result = rowNode;
      }
    });
    return result;
  };
  ViewportRowModel.prototype.getRowCount = function () {
    return this.rowCount;
  };
  ViewportRowModel.prototype.getRowIndexAtPixel = function (pixel) {
    if (this.rowHeight !== 0) {
      // avoid divide by zero error
      return Math.floor(pixel / this.rowHeight);
    }
    return 0;
  };
  ViewportRowModel.prototype.getRowBounds = function (index) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * index
    };
  };
  ViewportRowModel.prototype.getTopLevelRowCount = function () {
    return this.getRowCount();
  };
  ViewportRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
    return topLevelIndex;
  };
  ViewportRowModel.prototype.isEmpty = function () {
    return this.rowCount > 0;
  };
  ViewportRowModel.prototype.isRowsToRender = function () {
    return this.rowCount > 0;
  };
  ViewportRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
    var firstIndex = _.missing(firstInRange) ? 0 : firstInRange.rowIndex;
    var lastIndex = lastInRange.rowIndex;
    var firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
    var lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
    if (firstNodeOutOfRange || lastNodeOutOfRange) {
      return [];
    }
    var result = [];
    var startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
    var endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
    for (var i = startIndex; i <= endIndex; i++) {
      result.push(this.rowNodesByIndex[i]);
    }
    return result;
  };
  ViewportRowModel.prototype.forEachNode = function (callback) {
    var _this = this;
    var callbackCount = 0;
    Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
      var index = parseInt(indexStr, 10);
      var rowNode = _this.rowNodesByIndex[index];
      callback(rowNode, callbackCount);
      callbackCount++;
    });
  };
  ViewportRowModel.prototype.setRowData = function (rowData) {
    var _this = this;
    _.iterateObject(rowData, function (indexStr, dataItem) {
      var index = parseInt(indexStr, 10);
      // we should never keep rows that we didn't specifically ask for, this
      // guarantees the contract we have with the server.
      if (index >= _this.firstRow && index <= _this.lastRow) {
        var rowNode = _this.rowNodesByIndex[index];
        // the abnormal case is we requested a row even though the grid didn't need it
        // as a result of the paging and buffer (ie the row is off screen), in which
        // case we need to create a new node now
        if (_.missing(rowNode)) {
          rowNode = _this.createBlankRowNode(index);
          _this.rowNodesByIndex[index] = rowNode;
        }
        // now we deffo have a row node, so set in the details
        // if the grid already asked for this row (the normal case), then we would
        // of put a placeholder node in place.
        rowNode.setDataAndId(dataItem, index.toString());
      }
    });
  };
  ViewportRowModel.prototype.createBlankRowNode = function (rowIndex) {
    var rowNode = new RowNode(this.beans);
    rowNode.setRowHeight(this.rowHeight);
    rowNode.setRowTop(this.rowHeight * rowIndex);
    rowNode.setRowIndex(rowIndex);
    return rowNode;
  };
  ViewportRowModel.prototype.setRowCount = function (rowCount, keepRenderedRows) {
    if (keepRenderedRows === void 0) {
      keepRenderedRows = false;
    }
    if (rowCount === this.rowCount) {
      return;
    }
    this.rowCount = rowCount;
    var event = {
      type: Events.EVENT_MODEL_UPDATED,
      api: this.gridApi,
      columnApi: this.columnApi,
      newData: false,
      newPage: false,
      keepRenderedRows: keepRenderedRows,
      animate: false
    };
    this.eventService.dispatchEvent(event);
  };
  ViewportRowModel.prototype.isRowPresent = function (rowNode) {
    return false;
  };
  __decorate$4u([Autowired('gridApi')], ViewportRowModel.prototype, "gridApi", void 0);
  __decorate$4u([Autowired('columnApi')], ViewportRowModel.prototype, "columnApi", void 0);
  __decorate$4u([Autowired('rowRenderer')], ViewportRowModel.prototype, "rowRenderer", void 0);
  __decorate$4u([Autowired('beans')], ViewportRowModel.prototype, "beans", void 0);
  __decorate$4u([PostConstruct], ViewportRowModel.prototype, "init", null);
  __decorate$4u([PreDestroy], ViewportRowModel.prototype, "destroyDatasource", null);
  ViewportRowModel = __decorate$4u([Bean('rowModel')], ViewportRowModel);
  return ViewportRowModel;
}(BeanStub);
var ViewportRowModelModule = {
  moduleName: ModuleNames.ViewportRowModelModule,
  rowModels: {
    viewport: ViewportRowModel
  },
  dependantModules: [EnterpriseCoreModule]
};

// For small data structs like a bounding box, objects are superior to arrays
// in terms of performance (by 3-4% in Chrome 71, Safari 12 and by 20% in Firefox 64).
// They are also self descriptive and harder to abuse.
// For example, one has to do:
// `ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);`
// rather than become enticed by the much slower:
// `ctx.strokeRect(...bbox);`
// https://jsperf.com/array-vs-object-create-access
var BBox$1 = /** @class */function () {
  function BBox(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
  BBox.prototype.isValid = function () {
    return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
  };
  BBox.prototype.dilate = function (value) {
    this.x -= value;
    this.y -= value;
    this.width += value * 2;
    this.height += value * 2;
  };
  BBox.prototype.containsPoint = function (x, y) {
    return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
  };
  BBox.prototype.render = function (ctx, params) {
    if (params === void 0) {
      params = BBox.noParams;
    }
    ctx.save();
    if (params.resetTransform) {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    ctx.strokeStyle = params.strokeStyle || 'cyan';
    ctx.lineWidth = params.lineWidth || 1;
    ctx.strokeRect(this.x, this.y, this.width, this.height);
    if (params.label) {
      ctx.fillStyle = params.fillStyle || 'black';
      ctx.textBaseline = 'bottom';
      ctx.fillText(params.label, this.x, this.y);
    }
    ctx.restore();
  };
  BBox.noParams = {};
  return BBox;
}();

/**
 * As of Jan 8, 2019, Firefox still doesn't implement
 * `getTransform(): DOMMatrix;`
 * `setTransform(transform?: DOMMatrix2DInit)`
 * in the `CanvasRenderingContext2D`.
 * Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=928150
 * IE11 and Edge 44 also don't have the support.
 * Thus this class, to keep track of the current transform and
 * combine transformations.
 * Standards:
 * https://html.spec.whatwg.org/dev/canvas.html
 * https://www.w3.org/TR/geometry-1/
 */
var Matrix$1 = /** @class */function () {
  function Matrix(elements) {
    if (elements === void 0) {
      elements = [1, 0, 0, 1, 0, 0];
    }
    this.elements = elements;
  }
  Matrix.prototype.setElements = function (elements) {
    var e = this.elements;
    // `this.elements = elements.slice()` is 4-5 times slower
    // (in Chrome 71 and FF 64) than manually copying elements,
    // since slicing allocates new memory.
    // The performance of passing parameters individually
    // vs as an array is about the same in both browsers, so we
    // go with a single (array of elements) parameter, because
    // `setElements(elements)` and `setElements([a, b, c, d, e, f])`
    // calls give us roughly the same performance, versus
    // `setElements(...elements)` and `setElements(a, b, c, d, e, f)`,
    // where the spread operator causes a 20-30x performance drop
    // (30x when compiled to ES5's `.apply(this, elements)`
    //  20x when used natively).
    e[0] = elements[0];
    e[1] = elements[1];
    e[2] = elements[2];
    e[3] = elements[3];
    e[4] = elements[4];
    e[5] = elements[5];
    return this;
  };
  Matrix.prototype.setIdentityElements = function () {
    var e = this.elements;
    e[0] = 1;
    e[1] = 0;
    e[2] = 0;
    e[3] = 1;
    e[4] = 0;
    e[5] = 0;
    return this;
  };
  Object.defineProperty(Matrix.prototype, "identity", {
    get: function get() {
      var e = this.elements;
      return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "a", {
    get: function get() {
      return this.elements[0];
    },
    set: function set(value) {
      this.elements[0] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "b", {
    get: function get() {
      return this.elements[1];
    },
    set: function set(value) {
      this.elements[1] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "c", {
    get: function get() {
      return this.elements[2];
    },
    set: function set(value) {
      this.elements[2] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "d", {
    get: function get() {
      return this.elements[3];
    },
    set: function set(value) {
      this.elements[3] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "e", {
    get: function get() {
      return this.elements[4];
    },
    set: function set(value) {
      this.elements[4] = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Matrix.prototype, "f", {
    get: function get() {
      return this.elements[5];
    },
    set: function set(value) {
      this.elements[5] = value;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Performs the AxB matrix multiplication and saves the result
   * to `C`, if given, or to `A` otherwise.
   */
  Matrix.prototype.AxB = function (A, B, C) {
    var m11 = A[0],
      m12 = A[1],
      m21 = A[2],
      m22 = A[3],
      m31 = A[4],
      m32 = A[5];
    var o11 = B[0],
      o12 = B[1],
      o21 = B[2],
      o22 = B[3],
      o31 = B[4],
      o32 = B[5];
    C = C || A;
    C[0] = m11 * o11 + m21 * o12;
    C[1] = m12 * o11 + m22 * o12;
    C[2] = m11 * o21 + m21 * o22;
    C[3] = m12 * o21 + m22 * o22;
    C[4] = m11 * o31 + m21 * o32 + m31;
    C[5] = m12 * o31 + m22 * o32 + m32;
  };
  /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns the current matrix.
   * @param other
   */
  Matrix.prototype.multiplySelf = function (other) {
    this.AxB(this.elements, other.elements);
    return this;
  };
  /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns a new matrix.
   * @param other
   */
  Matrix.prototype.multiply = function (other) {
    var elements = new Array(6);
    this.AxB(this.elements, other.elements, elements);
    return new Matrix(elements);
  };
  Matrix.prototype.preMultiplySelf = function (other) {
    this.AxB(other.elements, this.elements, this.elements);
    return this;
  };
  /**
   * Returns the inverse of this matrix as a new matrix.
   */
  Matrix.prototype.inverse = function () {
    var _a = this.elements,
      a = _a[0],
      b = _a[1],
      c = _a[2],
      d = _a[3],
      e = _a[4],
      f = _a[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    return new Matrix([d, -b, -c, a, c * f - d * e, b * e - a * f]);
  };
  /**
   * Save the inverse of this matrix to the given matrix.
   */
  Matrix.prototype.inverseTo = function (other) {
    var _a = this.elements,
      a = _a[0],
      b = _a[1],
      c = _a[2],
      d = _a[3],
      e = _a[4],
      f = _a[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    other.setElements([d, -b, -c, a, c * f - d * e, b * e - a * f]);
    return this;
  };
  Matrix.prototype.invertSelf = function () {
    var elements = this.elements;
    var a = elements[0],
      b = elements[1],
      c = elements[2],
      d = elements[3],
      e = elements[4],
      f = elements[5];
    var rD = 1 / (a * d - b * c); // reciprocal of determinant
    a *= rD;
    b *= rD;
    c *= rD;
    d *= rD;
    elements[0] = d;
    elements[1] = -b;
    elements[2] = -c;
    elements[3] = a;
    elements[4] = c * f - d * e;
    elements[5] = b * e - a * f;
    return this;
  };
  Matrix.prototype.clone = function () {
    return new Matrix(this.elements.slice());
  };
  Matrix.prototype.transformPoint = function (x, y) {
    var e = this.elements;
    return {
      x: x * e[0] + y * e[2] + e[4],
      y: x * e[1] + y * e[3] + e[5]
    };
  };
  Matrix.prototype.transformBBox = function (bbox, radius, target) {
    if (radius === void 0) {
      radius = 0;
    }
    var elements = this.elements;
    var xx = elements[0];
    var xy = elements[1];
    var yx = elements[2];
    var yy = elements[3];
    var h_w = bbox.width * 0.5;
    var h_h = bbox.height * 0.5;
    var cx = bbox.x + h_w;
    var cy = bbox.y + h_h;
    var w, h;
    if (radius) {
      h_w -= radius;
      h_h -= radius;
      var sx = Math.sqrt(xx * xx + yx * yx);
      var sy = Math.sqrt(xy * xy + yy * yy);
      w = Math.abs(h_w * xx) + Math.abs(h_h * yx) + Math.abs(sx * radius);
      h = Math.abs(h_w * xy) + Math.abs(h_h * yy) + Math.abs(sy * radius);
    } else {
      w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
      h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
    }
    if (!target) {
      target = new BBox$1(0, 0, 0, 0);
    }
    target.x = cx * xx + cy * yx + elements[4] - w;
    target.y = cx * xy + cy * yy + elements[5] - h;
    target.width = w + w;
    target.height = h + h;
    return target;
  };
  Matrix.prototype.toContext = function (ctx) {
    // It's fair to say that matrix multiplications are not cheap.
    // However, updating path definitions on every frame isn't either, so
    // it may be cheaper to just translate paths. It's also fair to
    // say, that most paths will have to be re-rendered anyway, say
    // rectangle paths in a bar chart, where an animation would happen when
    // the data set changes and existing bars are morphed into new ones.
    // Or a pie chart, where old sectors are also morphed into new ones.
    // Same for the line chart. The only plausible case where translating
    // existing paths would be enough, is the scatter chart, where marker
    // icons, typically circles, stay the same size. But if circle radii
    // are bound to some data points, even circle paths would have to be
    // updated. And thus it makes sense to optimize for fewer matrix
    // transforms, where transform matrices of paths are mostly identity
    // matrices and `x`/`y`, `centerX`/`centerY` and similar properties
    // are used to define a path at specific coordinates. And only groups
    // are used to collectively apply a transform to a set of nodes.
    // If the matrix is mostly identity (95% of the time),
    // the `if (this.isIdentity)` check can make this call 3-4 times
    // faster on average: https://jsperf.com/matrix-check-first-vs-always-set
    if (this.identity) {
      return;
    }
    var e = this.elements;
    ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
  };
  Matrix.flyweight = function (elements) {
    if (elements) {
      if (elements instanceof Matrix) {
        Matrix.matrix.setElements(elements.elements);
      } else {
        Matrix.matrix.setElements(elements);
      }
    } else {
      Matrix.matrix.setIdentityElements();
    }
    return Matrix.matrix;
  };
  Matrix.matrix = new Matrix();
  return Matrix;
}();
function createId$1(instance) {
  var constructor = instance.constructor;
  var className = constructor.className;
  if (!className) {
    throw new Error("The " + constructor + " is missing the 'className' property.");
  }
  return className + '-' + (constructor.id = (constructor.id || 0) + 1);
}
var PointerEvents$1;
(function (PointerEvents) {
  PointerEvents[PointerEvents["All"] = 0] = "All";
  PointerEvents[PointerEvents["None"] = 1] = "None";
})(PointerEvents$1 || (PointerEvents$1 = {}));
/**
 * Abstract scene graph node.
 * Each node can have zero or one parent and belong to zero or one scene.
 */
var Node$2 = /** @class */function () {
  function Node() {
    /**
     * Unique node ID in the form `ClassName-NaturalNumber`.
     */
    this.id = createId$1(this);
    /**
     * Some number to identify this node, typically within a `Group` node.
     * Usually this will be some enum value used as a selector.
     */
    this.tag = NaN;
    /**
     * To simplify the type system (especially in Selections) we don't have the `Parent` node
     * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
     * But we still need to distinguish regular leaf nodes from container leafs somehow.
     */
    this.isContainerNode = false;
    this._children = [];
    // Used to check for duplicate nodes.
    this.childSet = {}; // new Set<Node>()
    // These matrices may need to have package level visibility
    // for performance optimization purposes.
    this.matrix = new Matrix$1();
    this.inverseMatrix = new Matrix$1();
    this._dirtyTransform = false;
    this._scalingX = 1;
    this._scalingY = 1;
    /**
     * The center of scaling.
     * The default value of `null` means the scaling center will be
     * determined automatically, as the center of the bounding box
     * of a node.
     */
    this._scalingCenterX = null;
    this._scalingCenterY = null;
    this._rotationCenterX = null;
    this._rotationCenterY = null;
    /**
     * Rotation angle in radians.
     * The value is set as is. No normalization to the [-180, 180) or [0, 360)
     * interval is performed.
     */
    this._rotation = 0;
    this._translationX = 0;
    this._translationY = 0;
    /**
     * Each time a property of the node that effects how it renders changes
     * the `dirty` property of the node should be set to `true`. The change
     * to the `dirty` property of the node will propagate up to its parents
     * and eventually to the scene, at which point an animation frame callback
     * will be scheduled to rerender the scene and its nodes and reset the `dirty`
     * flags of all nodes and the {@link Scene._dirty | Scene} back to `false`.
     * Since changes to node properties are not rendered immediately, it's possible
     * to change as many properties on as many nodes as needed and the rendering
     * will still only happen once in the next animation frame callback.
     * The animation frame callback is only scheduled if it hasn't been already.
     */
    this._dirty = true;
    this._visible = true;
    this.pointerEvents = PointerEvents$1.All;
  }
  /**
   * This is meaningfully faster than `instanceof` and should be the preferred way
   * of checking inside loops.
   * @param node
   */
  Node.isNode = function (node) {
    return node ? node.matrix !== undefined : false;
  };
  Node.prototype._setScene = function (value) {
    this._scene = value;
    var children = this.children;
    var n = children.length;
    for (var i = 0; i < n; i++) {
      children[i]._setScene(value);
    }
  };
  Object.defineProperty(Node.prototype, "scene", {
    get: function get() {
      return this._scene;
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype._setParent = function (value) {
    this._parent = value;
  };
  Object.defineProperty(Node.prototype, "parent", {
    get: function get() {
      return this._parent;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "children", {
    get: function get() {
      return this._children;
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.countChildren = function (depth) {
    if (depth === void 0) {
      depth = Node.MAX_SAFE_INTEGER;
    }
    if (depth <= 0) {
      return 0;
    }
    var children = this.children;
    var n = children.length;
    var size = n;
    for (var i = 0; i < n; i++) {
      size += children[i].countChildren(depth - 1);
    }
    return size;
  };
  /**
   * Appends one or more new node instances to this parent.
   * If one needs to:
   * - move a child to the end of the list of children
   * - move a child from one parent to another (including parents in other scenes)
   * one should use the {@link insertBefore} method instead.
   * @param nodes A node or nodes to append.
   */
  Node.prototype.append = function (nodes) {
    // Passing a single parameter to an open-ended version of `append`
    // would be 30-35% slower than this.
    if (Node.isNode(nodes)) {
      nodes = [nodes];
    }
    // The function takes an array rather than having open-ended
    // arguments like `...nodes: Node[]` because the latter is
    // transpiled to a function where the `arguments` object
    // is copied to a temporary array inside a loop.
    // So an array is created either way. And if we already have
    // an array of nodes we want to add, we have to use the prohibitively
    // expensive spread operator to pass it to the function,
    // and, on top of that, the copy of the `arguments` is still made.
    var n = nodes.length;
    for (var i = 0; i < n; i++) {
      var node = nodes[i];
      if (node.parent) {
        throw new Error(node + " already belongs to another parent: " + node.parent + ".");
      }
      if (node.scene) {
        throw new Error(node + " already belongs a scene: " + node.scene + ".");
      }
      if (this.childSet[node.id]) {
        // Cast to `any` to avoid `Property 'name' does not exist on type 'Function'`.
        throw new Error("Duplicate " + node.constructor.name + " node: " + node);
      }
      this._children.push(node);
      this.childSet[node.id] = true;
      node._setParent(this);
      node._setScene(this.scene);
    }
    this.dirty = true;
  };
  Node.prototype.appendChild = function (node) {
    if (node.parent) {
      throw new Error(node + " already belongs to another parent: " + node.parent + ".");
    }
    if (node.scene) {
      throw new Error(node + " already belongs to a scene: " + node.scene + ".");
    }
    if (this.childSet[node.id]) {
      // Cast to `any` to avoid `Property 'name' does not exist on type 'Function'`.
      throw new Error("Duplicate " + node.constructor.name + " node: " + node);
    }
    this._children.push(node);
    this.childSet[node.id] = true;
    node._setParent(this);
    node._setScene(this.scene);
    this.dirty = true;
    return node;
  };
  Node.prototype.removeChild = function (node) {
    if (node.parent === this) {
      var i = this.children.indexOf(node);
      if (i >= 0) {
        this._children.splice(i, 1);
        delete this.childSet[node.id];
        node._setParent();
        node._setScene();
        this.dirty = true;
        return node;
      }
    }
    throw new Error("The node to be removed is not a child of this node.");
  };
  /**
   * Inserts the node `node` before the existing child node `nextNode`.
   * If `nextNode` is null, insert `node` at the end of the list of children.
   * If the `node` belongs to another parent, it is first removed.
   * Returns the `node`.
   * @param node
   * @param nextNode
   */
  Node.prototype.insertBefore = function (node, nextNode) {
    var parent = node.parent;
    if (node.parent) {
      node.parent.removeChild(node);
    }
    if (nextNode && nextNode.parent === this) {
      var i = this.children.indexOf(nextNode);
      if (i >= 0) {
        this._children.splice(i, 0, node);
        this.childSet[node.id] = true;
        node._setParent(this);
        node._setScene(this.scene);
      } else {
        throw new Error(nextNode + " has " + parent + " as the parent, " + "but is not in its list of children.");
      }
      this.dirty = true;
    } else {
      this.append(node);
    }
    return node;
  };
  Object.defineProperty(Node.prototype, "nextSibling", {
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var children = parent.children;
        var index = children.indexOf(this);
        if (index >= 0 && index <= children.length - 1) {
          return children[index + 1];
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.transformPoint = function (x, y) {
    var matrix = Matrix$1.flyweight(this.matrix);
    var parent = this.parent;
    while (parent) {
      matrix.preMultiplySelf(parent.matrix);
      parent = parent.parent;
    }
    return matrix.invertSelf().transformPoint(x, y);
  };
  Node.prototype.inverseTransformPoint = function (x, y) {
    var matrix = Matrix$1.flyweight(this.matrix);
    var parent = this.parent;
    while (parent) {
      matrix.preMultiplySelf(parent.matrix);
      parent = parent.parent;
    }
    return matrix.transformPoint(x, y);
  };
  Object.defineProperty(Node.prototype, "dirtyTransform", {
    get: function get() {
      return this._dirtyTransform;
    },
    set: function set(value) {
      this._dirtyTransform = value;
      if (value) {
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingX", {
    get: function get() {
      return this._scalingX;
    },
    set: function set(value) {
      if (this._scalingX !== value) {
        this._scalingX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingY", {
    get: function get() {
      return this._scalingY;
    },
    set: function set(value) {
      if (this._scalingY !== value) {
        this._scalingY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingCenterX", {
    get: function get() {
      return this._scalingCenterX;
    },
    set: function set(value) {
      if (this._scalingCenterX !== value) {
        this._scalingCenterX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "scalingCenterY", {
    get: function get() {
      return this._scalingCenterY;
    },
    set: function set(value) {
      if (this._scalingCenterY !== value) {
        this._scalingCenterY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationCenterX", {
    get: function get() {
      return this._rotationCenterX;
    },
    set: function set(value) {
      if (this._rotationCenterX !== value) {
        this._rotationCenterX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationCenterY", {
    get: function get() {
      return this._rotationCenterY;
    },
    set: function set(value) {
      if (this._rotationCenterY !== value) {
        this._rotationCenterY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotation", {
    get: function get() {
      return this._rotation;
    },
    set: function set(value) {
      if (this._rotation !== value) {
        this._rotation = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "rotationDeg", {
    get: function get() {
      return this.rotation / Math.PI * 180;
    },
    /**
     * For performance reasons the rotation angle's internal representation
     * is in radians. Therefore, don't expect to get the same number you set.
     * Even with integer angles about a quarter of them from 0 to 359 cannot
     * be converted to radians and back without precision loss.
     * For example:
     *
     *     node.rotationDeg = 11;
     *     console.log(node.rotationDeg); // 10.999999999999998
     *
     * @param value Rotation angle in degrees.
     */
    set: function set(value) {
      this.rotation = value / 180 * Math.PI;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "translationX", {
    get: function get() {
      return this._translationX;
    },
    set: function set(value) {
      if (this._translationX !== value) {
        this._translationX = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "translationY", {
    get: function get() {
      return this._translationY;
    },
    set: function set(value) {
      if (this._translationY !== value) {
        this._translationY = value;
        this.dirtyTransform = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.prototype.containsPoint = function (x, y) {
    return false;
  };
  /**
   * Hit testing method.
   * Recursively checks if the given point is inside this node or any of its children.
   * Returns the first matching node or `undefined`.
   * Nodes that render later (show on top) are hit tested first.
   * @param x
   * @param y
   */
  Node.prototype.pickNode = function (x, y) {
    if (!this.visible || this.pointerEvents === PointerEvents$1.None || !this.containsPoint(x, y)) {
      return;
    }
    var children = this.children;
    if (children.length) {
      // Nodes added later should be hit-tested first,
      // as they are rendered on top of the previously added nodes.
      for (var i = children.length - 1; i >= 0; i--) {
        var hit = children[i].pickNode(x, y);
        if (hit) {
          return hit;
        }
      }
    } else if (!this.isContainerNode) {
      // a leaf node, but not a container leaf
      return this;
    }
  };
  Node.prototype.computeBBox = function () {
    return;
  };
  Node.prototype.computeBBoxCenter = function () {
    var bbox = this.computeBBox && this.computeBBox();
    if (bbox) {
      return [bbox.x + bbox.width * 0.5, bbox.y + bbox.height * 0.5];
    }
    return [0, 0];
  };
  Node.prototype.computeTransformMatrix = function () {
    // TODO: transforms without center of scaling and rotation correspond directly
    //       to `setAttribute('transform', 'translate(tx, ty) rotate(rDeg) scale(sx, sy)')`
    //       in SVG. Our use cases will mostly require positioning elements (rects, circles)
    //       within a group, rotating groups at right angles (e.g. for axis) and translating
    //       groups. We shouldn't even need `scale(1, -1)` (invert vertically), since this
    //       can be done using D3-like scales already by inverting the output range.
    //       So for now, just assume that centers of scaling and rotation are at the origin.
    // const [bbcx, bbcy] = this.computeBBoxCenter();
    var _a = [0, 0],
      bbcx = _a[0],
      bbcy = _a[1];
    var sx = this.scalingX;
    var sy = this.scalingY;
    var scx;
    var scy;
    if (sx === 1 && sy === 1) {
      scx = 0;
      scy = 0;
    } else {
      scx = this.scalingCenterX === null ? bbcx : this.scalingCenterX;
      scy = this.scalingCenterY === null ? bbcy : this.scalingCenterY;
    }
    var r = this.rotation;
    var cos = Math.cos(r);
    var sin = Math.sin(r);
    var rcx;
    var rcy;
    if (r === 0) {
      rcx = 0;
      rcy = 0;
    } else {
      rcx = this.rotationCenterX === null ? bbcx : this.rotationCenterX;
      rcy = this.rotationCenterY === null ? bbcy : this.rotationCenterY;
    }
    var tx = this.translationX;
    var ty = this.translationY;
    // The transform matrix `M` is a result of the following transformations:
    // 1) translate the center of scaling to the origin
    // 2) scale
    // 3) translate back
    // 4) translate the center of rotation to the origin
    // 5) rotate
    // 6) translate back
    // 7) translate
    //         (7)          (6)             (5)             (4)           (3)           (2)           (1)
    //     | 1 0 tx |   | 1 0 rcx |   | cos -sin 0 |   | 1 0 -rcx |   | 1 0 scx |   | sx 0 0 |   | 1 0 -scx |
    // M = | 0 1 ty | * | 0 1 rcy | * | sin  cos 0 | * | 0 1 -rcy | * | 0 1 scy | * | 0 sy 0 | * | 0 1 -scy |
    //     | 0 0  1 |   | 0 0  1  |   |  0    0  1 |   | 0 0  1   |   | 0 0  1  |   | 0  0 0 |   | 0 0  1   |
    // Translation after steps 1-4 above:
    var tx4 = scx * (1 - sx) - rcx;
    var ty4 = scy * (1 - sy) - rcy;
    this.dirtyTransform = false;
    this.matrix.setElements([cos * sx, sin * sx, -sin * sy, cos * sy, cos * tx4 - sin * ty4 + rcx + tx, sin * tx4 + cos * ty4 + rcy + ty]).inverseTo(this.inverseMatrix);
  };
  Object.defineProperty(Node.prototype, "dirty", {
    get: function get() {
      return this._dirty;
    },
    set: function set(value) {
      // TODO: check if we are already dirty (e.g. if (this._dirty !== value))
      //       if we are, then all parents and the scene have been
      //       notified already, and we are doing redundant work
      //       (but test if this is indeed the case)
      this._dirty = value;
      if (value) {
        if (this.parent) {
          this.parent.dirty = true;
        } else if (this.scene) {
          this.scene.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "visible", {
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      if (this._visible !== value) {
        this._visible = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Node.MAX_SAFE_INTEGER = Math.pow(2, 53) - 1; // Number.MAX_SAFE_INTEGER
  return Node;
}();
var __extends$5Z = undefined && undefined.__extends || function () {
  var _extendStatics390 = function extendStatics(d, b) {
    _extendStatics390 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics390(d, b);
  };
  return function (d, b) {
    _extendStatics390(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Group$1 = /** @class */function (_super) {
  __extends$5Z(Group, _super);
  function Group() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isContainerNode = true;
    _this._opacity = 1;
    return _this;
  }
  Object.defineProperty(Group.prototype, "opacity", {
    get: function get() {
      return this._opacity;
    },
    set: function set(value) {
      value = Math.min(1, Math.max(0, value));
      if (this._opacity !== value) {
        this._opacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  // We consider a group to be boundless, thus any point belongs to it.
  Group.prototype.containsPoint = function (x, y) {
    return true;
  };
  Group.prototype.computeBBox = function () {
    var left = Infinity;
    var right = -Infinity;
    var top = Infinity;
    var bottom = -Infinity;
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.children.forEach(function (child) {
      if (!child.visible) {
        return;
      }
      var bbox = child.computeBBox();
      if (!bbox) {
        return;
      }
      if (!(child instanceof Group)) {
        if (child.dirtyTransform) {
          child.computeTransformMatrix();
        }
        var matrix = Matrix$1.flyweight(child.matrix);
        var parent_1 = child.parent;
        while (parent_1) {
          matrix.preMultiplySelf(parent_1.matrix);
          parent_1 = parent_1.parent;
        }
        matrix.transformBBox(bbox, 0, bbox);
      }
      var x = bbox.x;
      var y = bbox.y;
      if (x < left) {
        left = x;
      }
      if (y < top) {
        top = y;
      }
      if (x + bbox.width > right) {
        right = x + bbox.width;
      }
      if (y + bbox.height > bottom) {
        bottom = y + bbox.height;
      }
    });
    return new BBox$1(left, top, right - left, bottom - top);
  };
  Group.prototype.render = function (ctx) {
    // A group can have `scaling`, `rotation`, `translation` properties
    // that are applied to the canvas context before children are rendered,
    // so all children can be transformed at once.
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var children = this.children;
    var n = children.length;
    ctx.globalAlpha *= this.opacity;
    for (var i = 0; i < n; i++) {
      var child = children[i];
      if (child.visible) {
        ctx.save();
        child.render(ctx);
        ctx.restore();
      }
    }
    // debug
    // this.computeBBox().render(ctx, {
    //     label: this.id,
    //     resetTransform: true,
    //     fillStyle: 'rgba(0, 0, 0, 0.5)'
    // });
  };

  Group.className = 'Group';
  return Group;
}(Node$2);

/**
 * Creates a new object with a `parent` as its prototype
 * and copies properties from the `child` into it.
 * @param parent
 * @param child
 */
function chainObjects$1(parent, child) {
  var obj = Object.create(parent);
  for (var prop in child) {
    if (child.hasOwnProperty(prop)) {
      obj[prop] = child[prop];
    }
  }
  return obj;
}
var __extends$5_ = undefined && undefined.__extends || function () {
  var _extendStatics391 = function extendStatics(d, b) {
    _extendStatics391 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics391(d, b);
  };
  return function (d, b) {
    _extendStatics391(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Shape$1 = /** @class */function (_super) {
  __extends$5_(Shape, _super);
  function Shape() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.lastInstanceId = 0;
    _this._fillOpacity = 1;
    _this._strokeOpacity = 1;
    _this._fill = Shape.defaultStyles.fill;
    /**
     * Note that `strokeStyle = null` means invisible stroke,
     * while `lineWidth = 0` means no stroke, and sometimes this can mean different things.
     * For example, a rect shape with an invisible stroke may not align to the pixel grid
     * properly because the stroke affects the rules of alignment, and arc shapes forming
     * a pie chart will have a gap between them if they have an invisible stroke, whereas
     * there would be not gap if there was no stroke at all.
     * The preferred way of making the stroke invisible is setting the `lineWidth` to zero,
     * unless specific looks that is achieved by having an invisible stroke is desired.
     */
    _this._stroke = Shape.defaultStyles.stroke;
    _this._strokeWidth = Shape.defaultStyles.strokeWidth;
    _this._lineDash = Shape.defaultStyles.lineDash;
    _this._lineDashOffset = Shape.defaultStyles.lineDashOffset;
    _this._lineCap = Shape.defaultStyles.lineCap;
    _this._lineJoin = Shape.defaultStyles.lineJoin;
    _this._opacity = Shape.defaultStyles.opacity;
    _this.onShadowChange = function () {
      _this.dirty = true;
    };
    _this._fillShadow = Shape.defaultStyles.fillShadow;
    _this._strokeShadow = Shape.defaultStyles.strokeShadow;
    return _this;
  }
  /**
   * Creates a light-weight instance of the given shape (that serves as a template).
   * The created instance only stores the properites set on the instance itself
   * and the rest of the properties come via the prototype chain from the template.
   * This can greatly reduce memory usage in cases where one has many simular shapes,
   * for example, circles of different size, position and color. The exact memory usage
   * reduction will depend on the size of the template and the number of own properties
   * set on its lightweight instances, but will typically be around an order of magnitude
   * or more.
   *
   * Note: template shapes are not supposed to be part of the scene graph (they should not
   * have a parent).
   *
   * @param template
   */
  Shape.createInstance = function (template) {
    var shape = Object.create(template);
    shape._setParent(undefined);
    shape.id = template.id + '-Instance-' + String(++template.lastInstanceId);
    return shape;
  };
  /**
   * Restores the default styles introduced by this subclass.
   */
  Shape.prototype.restoreOwnStyles = function () {
    var styles = this.constructor.defaultStyles;
    var keys = Object.getOwnPropertyNames(styles);
    // getOwnPropertyNames is about 2.5 times faster than
    // for..in with the hasOwnProperty check and in this
    // case, where most properties are inherited, can be
    // more then an order of magnitude faster.
    for (var i = 0, n = keys.length; i < n; i++) {
      var key = keys[i];
      this[key] = styles[key];
    }
  };
  Shape.prototype.restoreAllStyles = function () {
    var styles = this.constructor.defaultStyles;
    for (var property in styles) {
      this[property] = styles[property];
    }
  };
  /**
   * Restores the base class default styles that have been overridden by this subclass.
   */
  Shape.prototype.restoreOverriddenStyles = function () {
    var styles = this.constructor.defaultStyles;
    var protoStyles = Object.getPrototypeOf(styles);
    for (var property in styles) {
      if (styles.hasOwnProperty(property) && protoStyles.hasOwnProperty(property)) {
        this[property] = styles[property];
      }
    }
  };
  Object.defineProperty(Shape.prototype, "fillOpacity", {
    get: function get() {
      return this._fillOpacity;
    },
    set: function set(value) {
      if (this._fillOpacity !== value) {
        this._fillOpacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeOpacity", {
    get: function get() {
      return this._strokeOpacity;
    },
    set: function set(value) {
      if (this._strokeOpacity !== value) {
        this._strokeOpacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "fill", {
    get: function get() {
      return this._fill;
    },
    set: function set(value) {
      if (this._fill !== value) {
        this._fill = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "stroke", {
    get: function get() {
      return this._stroke;
    },
    set: function set(value) {
      if (this._stroke !== value) {
        this._stroke = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeWidth", {
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      if (this._strokeWidth !== value) {
        this._strokeWidth = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "alignment", {
    // An offset value to align to the pixel grid.
    get: function get() {
      return Math.floor(this.strokeWidth) % 2 / 2;
    },
    enumerable: true,
    configurable: true
  });
  // Returns the aligned `start` or `length` value.
  // For example: `start` could be `y` and `length` could be `height` of a rectangle.
  Shape.prototype.align = function (alignment, start, length) {
    if (length != undefined) {
      return Math.floor(length) + Math.floor(start % 1 + length % 1);
    }
    return Math.floor(start) + alignment;
  };
  Object.defineProperty(Shape.prototype, "lineDash", {
    get: function get() {
      return this._lineDash;
    },
    set: function set(value) {
      var oldValue = this._lineDash;
      if (oldValue !== value) {
        if (oldValue && value && oldValue.length === value.length) {
          var identical = true;
          var n = value.length;
          for (var i = 0; i < n; i++) {
            if (oldValue[i] !== value[i]) {
              identical = false;
              break;
            }
          }
          if (identical) {
            return;
          }
        }
        this._lineDash = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineDashOffset", {
    get: function get() {
      return this._lineDashOffset;
    },
    set: function set(value) {
      if (this._lineDashOffset !== value) {
        this._lineDashOffset = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineCap", {
    get: function get() {
      return this._lineCap;
    },
    set: function set(value) {
      if (this._lineCap !== value) {
        this._lineCap = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "lineJoin", {
    get: function get() {
      return this._lineJoin;
    },
    set: function set(value) {
      if (this._lineJoin !== value) {
        this._lineJoin = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "opacity", {
    get: function get() {
      return this._opacity;
    },
    set: function set(value) {
      value = Math.min(1, Math.max(0, value));
      if (this._opacity !== value) {
        this._opacity = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "fillShadow", {
    get: function get() {
      return this._fillShadow;
    },
    set: function set(value) {
      var oldValue = this._fillShadow;
      if (oldValue !== value) {
        if (oldValue) {
          oldValue.removeEventListener('change', this.onShadowChange);
        }
        if (value) {
          value.addEventListener('change', this.onShadowChange);
        }
        this._fillShadow = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Shape.prototype, "strokeShadow", {
    get: function get() {
      return this._strokeShadow;
    },
    set: function set(value) {
      var oldValue = this._strokeShadow;
      if (oldValue !== value) {
        if (oldValue) {
          oldValue.removeEventListener('change', this.onShadowChange);
        }
        if (value) {
          value.addEventListener('change', this.onShadowChange);
        }
        this._strokeShadow = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Shape.prototype.fillStroke = function (ctx) {
    if (!this.scene) {
      return;
    }
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    var globalAlpha = ctx.globalAlpha;
    if (this.fill) {
      ctx.fillStyle = this.fill;
      ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
      // The canvas context scaling (depends on the device's pixel ratio)
      // has no effect on shadows, so we have to account for the pixel ratio
      // manually here.
      var fillShadow = this.fillShadow;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fill();
    }
    ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    if (this.stroke && this.strokeWidth) {
      ctx.strokeStyle = this.stroke;
      ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
      ctx.lineWidth = this.strokeWidth;
      if (this.lineDash) {
        ctx.setLineDash(this.lineDash);
      }
      if (this.lineDashOffset) {
        ctx.lineDashOffset = this.lineDashOffset;
      }
      if (this.lineCap) {
        ctx.lineCap = this.lineCap;
      }
      if (this.lineJoin) {
        ctx.lineJoin = this.lineJoin;
      }
      var strokeShadow = this.strokeShadow;
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.stroke();
    }
  };
  Shape.prototype.containsPoint = function (x, y) {
    return this.isPointInPath(x, y);
  };
  /**
   * Defaults for style properties. Note that properties that affect the position
   * and shape of the node are not considered style properties, for example:
   * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
   * Can be used to reset to the original styling after some custom styling
   * has been applied (using the `restoreOwnStyles` and `restoreAllStyles` methods).
   * These static defaults are meant to be inherited by subclasses.
   */
  Shape.defaultStyles = chainObjects$1({}, {
    fill: 'black',
    stroke: undefined,
    strokeWidth: 0,
    lineDash: undefined,
    lineDashOffset: 0,
    lineCap: undefined,
    lineJoin: undefined,
    opacity: 1,
    fillShadow: undefined,
    strokeShadow: undefined
  });
  return Shape;
}(Node$2);

// @ts-ignore Suppress tsc error: Property 'sign' does not exist on type 'Math'
var sign$1 = Math.sign ? Math.sign : function (x) {
  x = +x;
  if (x === 0 || isNaN(x)) {
    return x;
  }
  return x > 0 ? 1 : -1;
};
/**
 * Finds the roots of a parametric linear equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function linearRoot$1(a, b) {
  var t = -b / a;
  return a !== 0 && t >= 0 && t <= 1 ? [t] : [];
}
/**
 * Finds the roots of a parametric quadratic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function quadraticRoots$1(a, b, c) {
  if (a === 0) {
    return linearRoot$1(b, c);
  }
  var D = b * b - 4 * a * c; // The polynomial's discriminant.
  var roots = [];
  if (D === 0) {
    // A single real root.
    var t = -b / (2 * a);
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
  } else if (D > 0) {
    // A pair of distinct real roots.
    var rD = Math.sqrt(D);
    var t1 = (-b - rD) / (2 * a);
    var t2 = (-b + rD) / (2 * a);
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (t2 >= 0 && t2 <= 1) {
      roots.push(t2);
    }
  }
  // else -> Complex roots.
  return roots;
}
/**
 * Finds the roots of a parametric cubic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 * Returns an array of parametric intersection locations along the cubic,
 * excluding out-of-bounds intersections (before or after the end point
 * or in the imaginary plane).
 * An adaptation of http://www.particleincell.com/blog/2013/cubic-line-intersection/
 */
function cubicRoots$1(a, b, c, d) {
  if (a === 0) {
    return quadraticRoots$1(b, c, d);
  }
  var A = b / a;
  var B = c / a;
  var C = d / a;
  var Q = (3 * B - A * A) / 9;
  var R = (9 * A * B - 27 * C - 2 * A * A * A) / 54;
  var D = Q * Q * Q + R * R; // The polynomial's discriminant.
  var third = 1 / 3;
  var roots = [];
  if (D >= 0) {
    // Complex or duplicate roots.
    var rD = Math.sqrt(D);
    var S = sign$1(R + rD) * Math.pow(Math.abs(R + rD), third);
    var T = sign$1(R - rD) * Math.pow(Math.abs(R - rD), third);
    var Im = Math.abs(Math.sqrt(3) * (S - T) / 2); // Complex part of the root pair.
    var t = -third * A + (S + T); // A real root.
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
    if (Im === 0) {
      var t_1 = -third * A - (S + T) / 2; // The real part of a complex root.
      if (t_1 >= 0 && t_1 <= 1) {
        roots.push(t_1);
      }
    }
  } else {
    // Distinct real roots.
    var theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
    var thirdA = third * A;
    var twoSqrtQ = 2 * Math.sqrt(-Q);
    var t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
    var t2 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
    var t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (t2 >= 0 && t2 <= 1) {
      roots.push(t2);
    }
    if (t3 >= 0 && t3 <= 1) {
      roots.push(t3);
    }
  }
  return roots;
}

/**
 * Returns the intersection point for the given pair of line segments, or null,
 * if the segments are parallel or don't intersect.
 * Based on http://paulbourke.net/geometry/pointlineplane/
 */
function segmentIntersection$1(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
  var d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
  if (d === 0) {
    // The lines are parallel.
    return null;
  }
  var ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
  var ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
  if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
    return {
      x: ax1 + ua * (ax2 - ax1),
      y: ay1 + ua * (ay2 - ay1)
    };
  }
  return null; // The intersection point is outside either or both segments.
}
/**
 * Returns intersection points of the given cubic curve and the line segment.
 * Takes in x/y components of cubic control points and line segment start/end points
 * as parameters.
 */
function cubicSegmentIntersections$1(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
  var intersections = [];
  // Find line equation coefficients.
  var A = y1 - y2;
  var B = x2 - x1;
  var C = x1 * (y2 - y1) - y1 * (x2 - x1);
  // Find cubic Bezier curve equation coefficients from control points.
  var bx = bezierCoefficients$1(px1, px2, px3, px4);
  var by = bezierCoefficients$1(py1, py2, py3, py4);
  var a = A * bx[0] + B * by[0]; // t^3
  var b = A * bx[1] + B * by[1]; // t^2
  var c = A * bx[2] + B * by[2]; // t
  var d = A * bx[3] + B * by[3] + C; // 1
  var roots = cubicRoots$1(a, b, c, d);
  // Verify that the roots are within bounds of the linear segment.
  for (var i = 0; i < roots.length; i++) {
    var t = roots[i];
    var tt = t * t;
    var ttt = t * tt;
    // Find the cartesian plane coordinates for the parametric root `t`.
    var x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
    var y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
    // The parametric cubic roots we found are intersection points
    // with an infinite line, and so the x/y coordinates above are as well.
    // Make sure the x/y is also within the bounds of the given segment.
    var s = void 0;
    if (x1 !== x2) {
      s = (x - x1) / (x2 - x1);
    } else {
      // the line is vertical
      s = (y - y1) / (y2 - y1);
    }
    if (s >= 0 && s <= 1) {
      intersections.push({
        x: x,
        y: y
      });
    }
  }
  return intersections;
}
/**
 * Returns the given coordinates vector multiplied by the coefficient matrix
 * of the parametric cubic Bézier equation.
 */
function bezierCoefficients$1(P1, P2, P3, P4) {
  return [-P1 + 3 * P2 - 3 * P3 + P4, 3 * P1 - 6 * P2 + 3 * P3, -3 * P1 + 3 * P2, P1 //                 | 1  0  0  0| |P4|
  ];
}

var Path2D$1 = /** @class */function () {
  function Path2D() {
    // The methods of this class will likely be called many times per animation frame,
    // and any allocation can trigger a GC cycle during animation, so we attempt
    // to minimize the number of allocations.
    this.commands = [];
    this.params = [];
    this._closedPath = false;
  }
  Path2D.prototype.moveTo = function (x, y) {
    if (this.xy) {
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.xy = [x, y];
    }
    this.commands.push('M');
    this.params.push(x, y);
  };
  Path2D.prototype.lineTo = function (x, y) {
    if (this.xy) {
      this.commands.push('L');
      this.params.push(x, y);
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.moveTo(x, y);
    }
  };
  Path2D.prototype.rect = function (x, y, width, height) {
    this.moveTo(x, y);
    this.lineTo(x + width, y);
    this.lineTo(x + width, y + height);
    this.lineTo(x, y + height);
    this.closePath();
  };
  /**
   * Adds an arc segment to the path definition.
   * https://www.w3.org/TR/SVG11/paths.html#PathDataEllipticalArcCommands
   * @param rx The major-axis radius.
   * @param ry The minor-axis radius.
   * @param rotation The x-axis rotation, expressed in radians.
   * @param fA The large arc flag. `1` to use angle > π.
   * @param fS The sweep flag. `1` for the arc that goes to `x`/`y` clockwise.
   * @param x2 The x coordinate to arc to.
   * @param y2 The y coordinate to arc to.
   */
  Path2D.prototype.arcTo = function (rx, ry, rotation, fA, fS, x2, y2) {
    // Convert from endpoint to center parametrization:
    // https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
    var xy = this.xy;
    if (!xy) {
      return;
    }
    if (rx < 0) {
      rx = -rx;
    }
    if (ry < 0) {
      ry = -ry;
    }
    var x1 = xy[0];
    var y1 = xy[1];
    var hdx = (x1 - x2) / 2;
    var hdy = (y1 - y2) / 2;
    var sinPhi = Math.sin(rotation);
    var cosPhi = Math.cos(rotation);
    var xp = cosPhi * hdx + sinPhi * hdy;
    var yp = -sinPhi * hdx + cosPhi * hdy;
    var ratX = xp / rx;
    var ratY = yp / ry;
    var lambda = ratX * ratX + ratY * ratY;
    var cx = (x1 + x2) / 2;
    var cy = (y1 + y2) / 2;
    var cpx = 0;
    var cpy = 0;
    if (lambda >= 1) {
      lambda = Math.sqrt(lambda);
      rx *= lambda;
      ry *= lambda;
      // me gives lambda == cpx == cpy == 0;
    } else {
      lambda = Math.sqrt(1 / lambda - 1);
      if (fA === fS) {
        lambda = -lambda;
      }
      cpx = lambda * rx * ratY;
      cpy = -lambda * ry * ratX;
      cx += cosPhi * cpx - sinPhi * cpy;
      cy += sinPhi * cpx + cosPhi * cpy;
    }
    var theta1 = Math.atan2((yp - cpy) / ry, (xp - cpx) / rx);
    var deltaTheta = Math.atan2((-yp - cpy) / ry, (-xp - cpx) / rx) - theta1;
    // if (fS) {
    //     if (deltaTheta <= 0) {
    //         deltaTheta += Math.PI * 2;
    //     }
    // }
    // else {
    //     if (deltaTheta >= 0) {
    //         deltaTheta -= Math.PI * 2;
    //     }
    // }
    this.cubicArc(cx, cy, rx, ry, rotation, theta1, theta1 + deltaTheta, 1 - fS);
  };
  /**
   * Approximates an elliptical arc with up to four cubic Bézier curves.
   * @param commands The string array to write SVG command letters to.
   * @param params The number array to write SVG command parameters (cubic control points) to.
   * @param cx The x-axis coordinate for the ellipse's center.
   * @param cy The y-axis coordinate for the ellipse's center.
   * @param rx The ellipse's major-axis radius.
   * @param ry The ellipse's minor-axis radius.
   * @param phi The rotation for this ellipse, expressed in radians.
   * @param theta1 The starting angle, measured clockwise from the positive x-axis and expressed in radians.
   * @param theta2 The ending angle, measured clockwise from the positive x-axis and expressed in radians.
   * @param anticlockwise The arc control points are always placed clockwise from `theta1` to `theta2`,
   * even when `theta1 > theta2`, unless this flag is set to `1`.
   */
  Path2D.cubicArc = function (commands, params, cx, cy, rx, ry, phi, theta1, theta2, anticlockwise) {
    if (anticlockwise) {
      var temp = theta1;
      theta1 = theta2;
      theta2 = temp;
    }
    var start = params.length;
    // See https://pomax.github.io/bezierinfo/#circles_cubic
    // Arc of unit circle (start angle = 0, end angle <= π/2) in cubic Bézier coordinates:
    // S = [1, 0]
    // C1 = [1, f]
    // C2 = [cos(θ) + f * sin(θ), sin(θ) - f * cos(θ)]
    // E = [cos(θ), sin(θ)]
    // f = 4/3 * tan(θ/4)
    var f90 = 0.5522847498307935; // f for θ = π/2 is 4/3 * (Math.sqrt(2) - 1)
    var sinTheta1 = Math.sin(theta1);
    var cosTheta1 = Math.cos(theta1);
    var sinPhi = Math.sin(phi);
    var cosPhi = Math.cos(phi);
    var rightAngle = Math.PI / 2;
    // Since we know how to draw an arc of a unit circle with a cubic Bézier,
    // to draw an elliptical arc with arbitrary rotation and radii we:
    // 1) rotate the Bézier coordinates that represent a circular arc by θ
    // 2) scale the circular arc separately along the x/y axes, making it elliptical
    // 3) rotate elliptical arc by φ
    // |cos(φ) -sin(φ)| |sx  0| |cos(θ) -sin(θ)| -> |xx xy|
    // |sin(φ)  cos(φ)| | 0 sy| |sin(θ)  cos(θ)| -> |yx yy|
    var xx = cosPhi * cosTheta1 * rx - sinPhi * sinTheta1 * ry;
    var yx = sinPhi * cosTheta1 * rx + cosPhi * sinTheta1 * ry;
    var xy = -cosPhi * sinTheta1 * rx - sinPhi * cosTheta1 * ry;
    var yy = -sinPhi * sinTheta1 * rx + cosPhi * cosTheta1 * ry;
    // TODO: what if delta between θ1 and θ2 is greater than 2π?
    // Always draw clockwise from θ1 to θ2.
    theta2 -= theta1;
    if (theta2 < 0) {
      theta2 += Math.PI * 2;
    }
    // Multiplying each point [x, y] by:
    // |xx xy cx| |x|
    // |yx yy cy| |y|
    // | 0  0  1| |1|
    // TODO: This move command may be redundant, if we are already at this point.
    // The coordinates of the point calculated here may differ ever so slightly
    // because of precision error.
    commands.push('M');
    params.push(xx + cx, yx + cy);
    while (theta2 >= rightAngle) {
      theta2 -= rightAngle;
      commands.push('C');
      // Temp workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=993330
      // Revert this commit when fixed ^^.
      var lastX = xy + cx;
      params.push(xx + xy * f90 + cx, yx + yy * f90 + cy, xx * f90 + xy + cx, yx * f90 + yy + cy, Math.abs(lastX) < 1e-8 ? 0 : lastX, yy + cy);
      // Prepend π/2 rotation matrix.
      // |xx xy| | 0 1| -> | xy -xx|
      // |yx yy| |-1 0| -> | yy -yx|
      // [xx, yx, xy, yy] = [xy, yy, -xx, -yx];
      // Compared to swapping with a temp variable, destructuring is:
      // - 10% faster in Chrome 70
      // - 99% slower in Firefox 63
      // Temp variable solution is 45% faster in FF than Chrome.
      // https://jsperf.com/multi-swap
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1165569
      var temp = xx;
      xx = xy;
      xy = -temp;
      temp = yx;
      yx = yy;
      yy = -temp;
    }
    if (theta2) {
      var f = 4 / 3 * Math.tan(theta2 / 4);
      var sinPhi2 = Math.sin(theta2);
      var cosPhi2 = Math.cos(theta2);
      var C2x = cosPhi2 + f * sinPhi2;
      var C2y = sinPhi2 - f * cosPhi2;
      commands.push('C');
      // Temp workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=993330
      // Revert this commit when fixed ^^.
      var lastX = xx * cosPhi2 + xy * sinPhi2 + cx;
      params.push(xx + xy * f + cx, yx + yy * f + cy, xx * C2x + xy * C2y + cx, yx * C2x + yy * C2y + cy, Math.abs(lastX) < 1e-8 ? 0 : lastX, yx * cosPhi2 + yy * sinPhi2 + cy);
    }
    if (anticlockwise) {
      for (var i = start, j = params.length - 2; i < j; i += 2, j -= 2) {
        var temp = params[i];
        params[i] = params[j];
        params[j] = temp;
        temp = params[i + 1];
        params[i + 1] = params[j + 1];
        params[j + 1] = temp;
      }
    }
  };
  Path2D.prototype.cubicArc = function (cx, cy, rx, ry, phi, theta1, theta2, anticlockwise) {
    var commands = this.commands;
    var params = this.params;
    var start = commands.length;
    Path2D.cubicArc(commands, params, cx, cy, rx, ry, phi, theta1, theta2, anticlockwise);
    var x = params[params.length - 2];
    var y = params[params.length - 1];
    if (this.xy) {
      commands[start] = 'L';
      this.xy[0] = x;
      this.xy[1] = y;
    } else {
      this.xy = [x, y];
    }
  };
  /**
   * Returns the `[x, y]` coordinates of the curve at `t`.
   * @param points `(n + 1) * 2` control point coordinates for a Bézier curve of n-th order.
   * @param t
   */
  Path2D.prototype.deCasteljau = function (points, t) {
    var n = points.length;
    if (n < 2 || n % 2 === 1) {
      throw new Error('Fewer than two points or not an even count.');
    } else if (n === 2 || t === 0) {
      return points.slice(0, 2);
    } else if (t === 1) {
      return points.slice(-2);
    } else {
      var newPoints = [];
      var last = n - 2;
      for (var i = 0; i < last; i += 2) {
        newPoints.push((1 - t) * points[i] + t * points[i + 2],
        // x
        (1 - t) * points[i + 1] + t * points[i + 3] // y
        );
      }

      return this.deCasteljau(newPoints, t);
    }
  };
  /**
   * Approximates the given curve using `n` line segments.
   * @param points `(n + 1) * 2` control point coordinates for a Bézier curve of n-th order.
   * @param n
   */
  Path2D.prototype.approximateCurve = function (points, n) {
    var xy = this.deCasteljau(points, 0);
    this.moveTo(xy[0], xy[1]);
    var step = 1 / n;
    for (var t = step; t <= 1; t += step) {
      var xy_1 = this.deCasteljau(points, t);
      this.lineTo(xy_1[0], xy_1[1]);
    }
  };
  /**
   * Adds a quadratic curve segment to the path definition.
   * Note: the given quadratic segment is converted and stored as a cubic one.
   * @param cx x-component of the curve's control point
   * @param cy y-component of the curve's control point
   * @param x x-component of the end point
   * @param y y-component of the end point
   */
  Path2D.prototype.quadraticCurveTo = function (cx, cy, x, y) {
    if (!this.xy) {
      this.moveTo(cx, cy);
    }
    // See https://pomax.github.io/bezierinfo/#reordering
    this.cubicCurveTo((this.xy[0] + 2 * cx) / 3, (this.xy[1] + 2 * cy) / 3,
    // 1/3 start + 2/3 control
    (2 * cx + x) / 3, (2 * cy + y) / 3,
    // 2/3 control + 1/3 end
    x, y);
  };
  Path2D.prototype.cubicCurveTo = function (cx1, cy1, cx2, cy2, x, y) {
    if (!this.xy) {
      this.moveTo(cx1, cy1);
    }
    this.commands.push('C');
    this.params.push(cx1, cy1, cx2, cy2, x, y);
    this.xy[0] = x;
    this.xy[1] = y;
  };
  Object.defineProperty(Path2D.prototype, "closedPath", {
    get: function get() {
      return this._closedPath;
    },
    enumerable: true,
    configurable: true
  });
  Path2D.prototype.closePath = function () {
    if (this.xy) {
      this.xy = undefined;
      this.commands.push('Z');
      this._closedPath = true;
    }
  };
  Path2D.prototype.clear = function () {
    this.commands.length = 0;
    this.params.length = 0;
    this.xy = undefined;
    this._closedPath = false;
  };
  Path2D.prototype.isPointInPath = function (x, y) {
    var commands = this.commands;
    var params = this.params;
    var cn = commands.length;
    // Hit testing using ray casting method, where the ray's origin is some point
    // outside the path. In this case, an offscreen point that is remote enough, so that
    // even if the path itself is large and is partially offscreen, the ray's origin
    // will likely be outside the path anyway. To test if the given point is inside the
    // path or not, we cast a ray from the origin to the given point and check the number
    // of intersections of this segment with the path. If the number of intersections is
    // even, then the ray both entered and exited the path an equal number of times,
    // therefore the point is outside the path, and inside the path, if the number of
    // intersections is odd. Since the path is compound, we check if the ray segment
    // intersects with each of the path's segments, which can be either a line segment
    // (one or no intersection points) or a Bézier curve segment (up to 3 intersection
    // points).
    var ox = -10000;
    var oy = -10000;
    // the starting point of the  current path
    var sx = NaN;
    var sy = NaN;
    // the previous point of the current path
    var px = 0;
    var py = 0;
    var intersectionCount = 0;
    for (var ci = 0, pi = 0; ci < cn; ci++) {
      switch (commands[ci]) {
        case 'M':
          if (!isNaN(sx)) {
            if (segmentIntersection$1(sx, sy, px, py, ox, oy, x, y)) {
              intersectionCount++;
            }
          }
          sx = px = params[pi++];
          sy = py = params[pi++];
          break;
        case 'L':
          if (segmentIntersection$1(px, py, px = params[pi++], py = params[pi++], ox, oy, x, y)) {
            intersectionCount++;
          }
          break;
        case 'C':
          intersectionCount += cubicSegmentIntersections$1(px, py, params[pi++], params[pi++], params[pi++], params[pi++], px = params[pi++], py = params[pi++], ox, oy, x, y).length;
          break;
        case 'Z':
          if (!isNaN(sx)) {
            if (segmentIntersection$1(sx, sy, px, py, ox, oy, x, y)) {
              intersectionCount++;
            }
          }
          break;
      }
    }
    return intersectionCount % 2 === 1;
  };
  Path2D.fromString = function (value) {
    var path = new Path2D();
    path.setFromString(value);
    return path;
  };
  /**
   * Split the SVG path at command letters,
   * then extract the command letter and parameters from each substring.
   * @param value
   */
  Path2D.parseSvgPath = function (value) {
    return value.trim().split(Path2D.splitCommandsRe).map(function (part) {
      var strParams = part.match(Path2D.matchParamsRe);
      return {
        command: part.substr(0, 1),
        params: strParams ? strParams.map(parseFloat) : []
      };
    });
  };
  Path2D.prettifySvgPath = function (value) {
    return Path2D.parseSvgPath(value).map(function (d) {
      return d.command + d.params.join(',');
    }).join('\n');
  };
  /**
   * See https://www.w3.org/TR/SVG11/paths.html
   * @param value
   */
  Path2D.prototype.setFromString = function (value) {
    var _this = this;
    this.clear();
    var parts = Path2D.parseSvgPath(value);
    // Current point.
    var x;
    var y;
    // Last control point. Used to calculate the reflection point
    // for `S`, `s`, `T`, `t` commands.
    var cpx;
    var cpy;
    var lastCommand;
    function checkQuadraticCP() {
      if (!lastCommand.match(Path2D.quadraticCommandRe)) {
        cpx = x;
        cpy = y;
      }
    }
    function checkCubicCP() {
      if (!lastCommand.match(Path2D.cubicCommandRe)) {
        cpx = x;
        cpy = y;
      }
    }
    // But that will make compiler complain about x/y, cpx/cpy
    // being used without being set first.
    parts.forEach(function (part) {
      var p = part.params;
      var n = p.length;
      var i = 0;
      switch (part.command) {
        case 'M':
          _this.moveTo(x = p[i++], y = p[i++]);
          while (i < n) {
            _this.lineTo(x = p[i++], y = p[i++]);
          }
          break;
        case 'm':
          _this.moveTo(x += p[i++], y += p[i++]);
          while (i < n) {
            _this.lineTo(x += p[i++], y += p[i++]);
          }
          break;
        case 'L':
          while (i < n) {
            _this.lineTo(x = p[i++], y = p[i++]);
          }
          break;
        case 'l':
          while (i < n) {
            _this.lineTo(x += p[i++], y += p[i++]);
          }
          break;
        case 'C':
          while (i < n) {
            _this.cubicCurveTo(p[i++], p[i++], cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'c':
          while (i < n) {
            _this.cubicCurveTo(x + p[i++], y + p[i++], cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'S':
          checkCubicCP();
          while (i < n) {
            _this.cubicCurveTo(x + x - cpx, y + y - cpy, cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 's':
          checkCubicCP();
          while (i < n) {
            _this.cubicCurveTo(x + x - cpx, y + y - cpy, cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'Q':
          while (i < n) {
            _this.quadraticCurveTo(cpx = p[i++], cpy = p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'q':
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + p[i++], cpy = y + p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'T':
          checkQuadraticCP();
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + x - cpx, cpy = y + y - cpy, x = p[i++], y = p[i++]);
          }
          break;
        case 't':
          checkQuadraticCP();
          while (i < n) {
            _this.quadraticCurveTo(cpx = x + x - cpx, cpy = y + y - cpy, x += p[i++], y += p[i++]);
          }
          break;
        case 'A':
          while (i < n) {
            _this.arcTo(p[i++], p[i++], p[i++] * Math.PI / 180, p[i++], p[i++], x = p[i++], y = p[i++]);
          }
          break;
        case 'a':
          while (i < n) {
            _this.arcTo(p[i++], p[i++], p[i++] * Math.PI / 180, p[i++], p[i++], x += p[i++], y += p[i++]);
          }
          break;
        case 'Z':
        case 'z':
          _this.closePath();
          break;
        case 'H':
          while (i < n) {
            _this.lineTo(x = p[i++], y);
          }
          break;
        case 'h':
          while (i < n) {
            _this.lineTo(x += p[i++], y);
          }
          break;
        case 'V':
          while (i < n) {
            _this.lineTo(x, y = p[i++]);
          }
          break;
        case 'v':
          while (i < n) {
            _this.lineTo(x, y += p[i++]);
          }
          break;
      }
      lastCommand = part.command;
    });
  };
  Path2D.prototype.toString = function () {
    var c = this.commands;
    var p = this.params;
    var cn = c.length;
    var out = [];
    for (var ci = 0, pi = 0; ci < cn; ci++) {
      switch (c[ci]) {
        case 'M':
          out.push('M' + p[pi++] + ',' + p[pi++]);
          break;
        case 'L':
          out.push('L' + p[pi++] + ',' + p[pi++]);
          break;
        case 'C':
          out.push('C' + p[pi++] + ',' + p[pi++] + ' ' + p[pi++] + ',' + p[pi++] + ' ' + p[pi++] + ',' + p[pi++]);
          break;
        case 'Z':
          out.push('Z');
          break;
      }
    }
    return out.join('');
  };
  Path2D.prototype.toPrettyString = function () {
    return Path2D.prettifySvgPath(this.toString());
  };
  Path2D.prototype.toSvg = function () {
    return Path2D.xmlDeclaration + "\n<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 50 50\" version=\"1.1\" xmlns=\"" + Path2D.xmlns + "\">\n    <path d=\"" + this.toString() + "\" style=\"fill:none;stroke:#000;stroke-width:0.5;\"/>\n</svg>";
  };
  Path2D.prototype.toDebugSvg = function () {
    var d = Path2D.prettifySvgPath(this.toString());
    return Path2D.xmlDeclaration + "\n<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 100 100\" version=\"1.1\" xmlns=\"" + Path2D.xmlns + "\">\n    <path d=\"" + d + "\" style=\"fill:none;stroke:#000;stroke-width:0.5;\"/>\n</svg>";
  };
  /**
   * Returns an array of sub-paths of this Path,
   * where each sub-path is represented exclusively by cubic segments.
   */
  Path2D.prototype.toCubicPaths = function () {
    // Each sub-path is an array of `(n * 3 + 1) * 2` numbers,
    // where `n` is the number of segments.
    var paths = [];
    var params = this.params;
    // current path
    var path;
    // the starting point of the  current path
    var sx;
    var sy;
    // the previous point of the current path
    var px;
    var py;
    var i = 0; // current parameter
    this.commands.forEach(function (command) {
      switch (command) {
        case 'M':
          path = [sx = px = params[i++], sy = py = params[i++]];
          paths.push(path);
          break;
        case 'L':
          var x = params[i++];
          var y = params[i++];
          // Place control points along the line `a + (b - a) * t`
          // at t = 1/3 and 2/3:
          path.push((px + px + x) / 3, (py + py + y) / 3, (px + x + x) / 3, (py + y + y) / 3, px = x, py = y);
          break;
        case 'C':
          path.push(params[i++], params[i++], params[i++], params[i++], px = params[i++], py = params[i++]);
          break;
        case 'Z':
          path.push((px + px + sx) / 3, (py + py + sy) / 3, (px + sx + sx) / 3, (py + sy + sy) / 3, px = sx, py = sy);
          break;
      }
    });
    return paths;
  };
  Path2D.cubicPathToString = function (path) {
    var n = path.length;
    if (!(n % 2 === 0 && (n / 2 - 1) / 2 >= 1)) {
      throw new Error('Invalid path.');
    }
    return 'M' + path.slice(0, 2).join(',') + 'C' + path.slice(2).join(',');
  };
  Path2D.splitCommandsRe = /(?=[AaCcHhLlMmQqSsTtVvZz])/g;
  Path2D.matchParamsRe = /-?[0-9]*\.?\d+/g;
  Path2D.quadraticCommandRe = /[QqTt]/;
  Path2D.cubicCommandRe = /[CcSs]/;
  Path2D.xmlDeclaration = '<?xml version="1.0" encoding="UTF-8"?>';
  Path2D.xmlns = 'http://www.w3.org/2000/svg';
  return Path2D;
}();
var __extends$5$ = undefined && undefined.__extends || function () {
  var _extendStatics392 = function extendStatics(d, b) {
    _extendStatics392 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics392(d, b);
  };
  return function (d, b) {
    _extendStatics392(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Path$1 = /** @class */function (_super) {
  __extends$5$(Path, _super);
  function Path() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Declare a path to retain for later rendering and hit testing
     * using custom Path2D class. Think of it as a TypeScript version
     * of the native Path2D (with some differences) that works in all browsers.
     */
    _this.path = new Path2D$1();
    /**
    * The path only has to be updated when certain attributes change.
    * For example, if transform attributes (such as `translationX`)
    * are changed, we don't have to update the path. The `dirtyPath` flag
    * is how we keep track if the path has to be updated or not.
    */
    _this._dirtyPath = true;
    /**
     * Path definition in SVG path syntax:
     * https://www.w3.org/TR/SVG11/paths.html#DAttribute
     */
    _this._svgPath = '';
    return _this;
  }
  Object.defineProperty(Path.prototype, "dirtyPath", {
    get: function get() {
      return this._dirtyPath;
    },
    set: function set(value) {
      if (this._dirtyPath !== value) {
        this._dirtyPath = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Path.prototype, "svgPath", {
    get: function get() {
      return this._svgPath;
    },
    set: function set(value) {
      if (this._svgPath !== value) {
        this._svgPath = value;
        this.path.setFromString(value);
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Path.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    return this.path.closedPath && this.path.isPointInPath(point.x, point.y);
  };
  Path.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Path.prototype.updatePath = function () {};
  Path.prototype.render = function (ctx) {
    var scene = this.scene;
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    // if (scene.debug.renderBoundingBoxes) {
    //     const bbox = this.computeBBox();
    //     if (bbox) {
    //         this.matrix.transformBBox(bbox).render(ctx);
    //     }
    // }
    this.matrix.toContext(ctx);
    if (this.dirtyPath) {
      this.updatePath();
      this.dirtyPath = false;
    }
    scene.appendPath(this.path);
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Path.className = 'Path';
  return Path;
}(Shape$1);
var __extends$60 = undefined && undefined.__extends || function () {
  var _extendStatics393 = function extendStatics(d, b) {
    _extendStatics393 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics393(d, b);
  };
  return function (d, b) {
    _extendStatics393(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Line$1 = /** @class */function (_super) {
  __extends$60(Line, _super);
  function Line() {
    var _this = _super.call(this) || this;
    _this._x1 = 0;
    _this._y1 = 0;
    _this._x2 = 0;
    _this._y2 = 0;
    _this.restoreOwnStyles();
    return _this;
  }
  Object.defineProperty(Line.prototype, "x1", {
    get: function get() {
      // TODO: Investigate getter performance further in the context
      //       of the scene graph.
      //       In isolated benchmarks using a getter has the same
      //       performance as a direct property access in Firefox 64.
      //       But in Chrome 71 the getter is 60% slower than direct access.
      //       Direct read is 4.5+ times slower in Chrome than it is in Firefox.
      //       Property access and direct read have the same performance
      //       in Safari 12, which is 2+ times faster than Firefox at this.
      // https://jsperf.com/es5-getters-setters-versus-getter-setter-methods/18
      // This is a know Chrome issue. They say it's not a regression, since
      // the behavior is observed since M60, but jsperf.com history shows the
      // 10x slowdown happened between Chrome 48 and Chrome 57.
      // https://bugs.chromium.org/p/chromium/issues/detail?id=908743
      return this._x1;
    },
    set: function set(value) {
      if (this._x1 !== value) {
        this._x1 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "y1", {
    get: function get() {
      return this._y1;
    },
    set: function set(value) {
      if (this._y1 !== value) {
        this._y1 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "x2", {
    get: function get() {
      return this._x2;
    },
    set: function set(value) {
      if (this._x2 !== value) {
        this._x2 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Line.prototype, "y2", {
    get: function get() {
      return this._y2;
    },
    set: function set(value) {
      if (this._y2 !== value) {
        this._y2 = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Line.prototype.computeBBox = function () {
    return new BBox$1(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
  };
  Line.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Line.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Line.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var x1 = this.x1;
    var y1 = this.y1;
    var x2 = this.x2;
    var y2 = this.y2;
    // Align to the pixel grid if the line is strictly vertical
    // or horizontal (but not both, i.e. a dot).
    if (x1 === x2) {
      var x = Math.round(x1) + Math.floor(this.strokeWidth) % 2 / 2;
      x1 = x;
      x2 = x;
    } else if (y1 === y2) {
      var y = Math.round(y1) + Math.floor(this.strokeWidth) % 2 / 2;
      y1 = y;
      y2 = y;
    }
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Line.className = 'Line';
  Line.defaultStyles = chainObjects$1(Shape$1.defaultStyles, {
    fill: undefined,
    strokeWidth: 1
  });
  return Line;
}(Shape$1);

/**
 * Maps a discrete domain to a continuous numeric range.
 * See https://github.com/d3/d3-scale#band-scales for more info.
 */
var BandScale$1 = /** @class */function () {
  function BandScale() {
    this.type = 'band';
    /**
     * Maps datum to its index in the {@link domain} array.
     * Used to check for duplicate datums (not allowed).
     */
    this.index = new Map();
    /**
     * The output range values for datum at each index.
     */
    this.ordinalRange = [];
    /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */
    this._domain = [];
    this._range = [0, 1];
    this._bandwidth = 1;
    /**
     * The ratio of the range that is reserved for space between bands.
     */
    this._paddingInner = 0;
    /**
     * The ratio of the range that is reserved for space before the first
     * and after the last band.
     */
    this._paddingOuter = 0;
    this._round = false;
    /**
     * How the leftover range is distributed.
     * `0.5` - equal distribution of space before the first and after the last band,
     * with bands effectively centered within the range.
     */
    this._align = 0.5;
  }
  Object.defineProperty(BandScale.prototype, "domain", {
    get: function get() {
      return this._domain;
    },
    set: function set(values) {
      var domain = this._domain;
      domain.length = 0;
      this.index = new Map();
      var index = this.index;
      // In case one wants to have duplicate domain values, for example, two 'Italy' categories,
      // one should use objects rather than strings for domain values like so:
      // { toString: () => 'Italy' }
      // { toString: () => 'Italy' }
      values.forEach(function (value) {
        if (index.get(value) === undefined) {
          index.set(value, domain.push(value) - 1);
        }
      });
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "range", {
    get: function get() {
      return this._range;
    },
    set: function set(values) {
      this._range[0] = values[0];
      this._range[1] = values[1];
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  BandScale.prototype.ticks = function () {
    return this._domain;
  };
  BandScale.prototype.convert = function (d) {
    var i = this.index.get(d);
    if (i === undefined) {
      return NaN;
    }
    var r = this.ordinalRange[i];
    if (r === undefined) {
      return NaN;
    }
    return r;
  };
  Object.defineProperty(BandScale.prototype, "bandwidth", {
    get: function get() {
      return this._bandwidth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "padding", {
    get: function get() {
      return this._paddingInner;
    },
    set: function set(value) {
      value = Math.max(0, Math.min(1, value));
      this._paddingInner = value;
      this._paddingOuter = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "paddingInner", {
    get: function get() {
      return this._paddingInner;
    },
    set: function set(value) {
      this._paddingInner = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "paddingOuter", {
    get: function get() {
      return this._paddingOuter;
    },
    set: function set(value) {
      this._paddingOuter = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "round", {
    get: function get() {
      return this._round;
    },
    set: function set(value) {
      this._round = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BandScale.prototype, "align", {
    get: function get() {
      return this._align;
    },
    set: function set(value) {
      this._align = Math.max(0, Math.min(1, value)); // [0, 1]
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  BandScale.prototype.rescale = function () {
    var _a;
    var n = this._domain.length;
    if (!n) {
      return;
    }
    var _b = this._range,
      a = _b[0],
      b = _b[1];
    var reversed = b < a;
    if (reversed) {
      _a = [b, a], a = _a[0], b = _a[1];
    }
    var step = (b - a) / Math.max(1, n - this._paddingInner + this._paddingOuter * 2);
    if (this._round) {
      step = Math.floor(step);
    }
    a += (b - a - step * (n - this._paddingInner)) * this._align;
    this._bandwidth = step * (1 - this._paddingInner);
    if (this._round) {
      a = Math.round(a);
      this._bandwidth = Math.round(this._bandwidth);
    }
    var values = [];
    for (var i = 0; i < n; i++) {
      values.push(a + step * i);
    }
    this.ordinalRange = reversed ? values.reverse() : values;
  };
  return BandScale;
}();
var __assign$F = undefined && undefined.__assign || function () {
  __assign$F = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$F.apply(this, arguments);
};
var Observable$1 = /** @class */function () {
  function Observable() {
    // Note that these maps can't be specified generically, so they are kept untyped.
    // Some methods in this class only need generics in their signatures, the generics inside the methods
    // are just for clarity. The generics in signatures allow for static type checking of user provided
    // listeners and for type inference, so that the users wouldn't have to specify the type of parameters
    // of their inline lambdas.
    this.allPropertyListeners = new Map(); // property name => property change listener => scopes
    this.allEventListeners = new Map(); // event type => event listener => scopes
  }

  Observable.prototype.addPropertyListener = function (name, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (!propertyListeners) {
      propertyListeners = new Map();
      allPropertyListeners.set(name, propertyListeners);
    }
    if (!propertyListeners.has(listener)) {
      var scopes_1 = new Set();
      propertyListeners.set(listener, scopes_1);
    }
    var scopes = propertyListeners.get(listener);
    if (scopes) {
      scopes.add(scope);
    }
  };
  Observable.prototype.removePropertyListener = function (name, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (propertyListeners) {
      if (listener) {
        var scopes = propertyListeners.get(listener);
        if (scopes) {
          scopes.delete(scope);
          if (!scopes.size) {
            propertyListeners.delete(listener);
          }
        }
      } else {
        propertyListeners.clear();
      }
    }
  };
  Observable.prototype.notifyPropertyListeners = function (name, oldValue, value) {
    var _this = this;
    var allPropertyListeners = this.allPropertyListeners;
    var propertyListeners = allPropertyListeners.get(name);
    if (propertyListeners) {
      propertyListeners.forEach(function (scopes, listener) {
        scopes.forEach(function (scope) {
          return listener.call(scope, {
            type: name,
            source: _this,
            value: value,
            oldValue: oldValue
          });
        });
      });
    }
  };
  Observable.prototype.addEventListener = function (type, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allEventListeners = this.allEventListeners;
    var eventListeners = allEventListeners.get(type);
    if (!eventListeners) {
      eventListeners = new Map();
      allEventListeners.set(type, eventListeners);
    }
    if (!eventListeners.has(listener)) {
      var scopes_2 = new Set();
      eventListeners.set(listener, scopes_2);
    }
    var scopes = eventListeners.get(listener);
    if (scopes) {
      scopes.add(scope);
    }
  };
  Observable.prototype.removeEventListener = function (type, listener, scope) {
    if (scope === void 0) {
      scope = this;
    }
    var allEventListeners = this.allEventListeners;
    var eventListeners = allEventListeners.get(type);
    if (eventListeners) {
      if (listener) {
        var scopes = eventListeners.get(listener);
        if (scopes) {
          scopes.delete(scope);
          if (!scopes.size) {
            eventListeners.delete(listener);
          }
        }
      } else {
        eventListeners.clear();
      }
    }
  };
  Observable.prototype.notifyEventListeners = function (types) {
    var _this = this;
    var allEventListeners = this.allEventListeners;
    types.forEach(function (type) {
      var listeners = allEventListeners.get(type);
      if (listeners) {
        listeners.forEach(function (scopes, listener) {
          scopes.forEach(function (scope) {
            return listener.call(scope, {
              type: type,
              source: _this
            });
          });
        });
      }
    });
  };
  // 'source' is added automatically and is always the object this method belongs to.
  Observable.prototype.fireEvent = function (event) {
    var _this = this;
    var listeners = this.allEventListeners.get(event.type);
    if (listeners) {
      listeners.forEach(function (scopes, listener) {
        scopes.forEach(function (scope) {
          return listener.call(scope, __assign$F(__assign$F({}, event), {
            source: _this
          }));
        });
      });
    }
  };
  Observable.privateKeyPrefix = '_';
  return Observable;
}();
function reactive$1() {
  var events = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    events[_i] = arguments[_i];
  }
  var debug = events.indexOf('debugger') >= 0;
  return function (target, key) {
    // `target` is either a constructor (static member) or prototype (instance member)
    var privateKey = Observable$1.privateKeyPrefix + key;
    var privateKeyEvents = privateKey + 'Events';
    if (!target[key]) {
      if (events) {
        target[privateKeyEvents] = events;
      }
      Object.defineProperty(target, key, {
        set: function set(value) {
          var oldValue = this[privateKey];
          // This is a way to stop inside the setter by adding the special
          // 'debugger' event to a reactive property, for example:
          //  @reactive('layoutChange', 'debugger') title?: Caption;
          if (debug) {
            // DO NOT REMOVE
            debugger;
          }
          if (value !== oldValue || typeof value === 'object' && value !== null) {
            this[privateKey] = value;
            this.notifyPropertyListeners(key, oldValue, value);
            var events_1 = this[privateKeyEvents];
            if (events_1) {
              this.notifyEventListeners(events_1);
            }
          }
        },
        get: function get() {
          return this[privateKey];
        },
        enumerable: true,
        configurable: true
      });
    }
  };
}
var EnterNode$1 = /** @class */function () {
  function EnterNode(parent, datum) {
    this.next = null;
    this.scene = parent.scene;
    this.parent = parent;
    this.datum = datum;
  }
  EnterNode.prototype.appendChild = function (node) {
    // This doesn't work without the `strict: true` in the `tsconfig.json`,
    // so we must have two `if` checks below, instead of this single one.
    // if (this.next && !Node.isNode(this.next)) {
    //     throw new Error(`${this.next} is not a Node.`);
    // }
    if (this.next === null) {
      return this.parent.insertBefore(node, null);
    }
    if (!Node$2.isNode(this.next)) {
      throw new Error(this.next + " is not a Node.");
    }
    return this.parent.insertBefore(node, this.next);
  };
  EnterNode.prototype.insertBefore = function (node, nextNode) {
    return this.parent.insertBefore(node, nextNode);
  };
  return EnterNode;
}();
/**
 * G - type of the selected node(s).
 * GDatum - type of the datum of the selected node(s).
 * P - type of the parent node(s).
 * PDatum - type of the datum of the parent node(s).
 */
var Selection$1 = /** @class */function () {
  function Selection(groups, parents) {
    this.groups = groups;
    this.parents = parents;
  }
  Selection.select = function (node) {
    return new Selection([[typeof node === 'function' ? node() : node]], [undefined]);
  };
  Selection.selectAll = function (nodes) {
    return new Selection([nodes == null ? [] : nodes], [undefined]);
  };
  /**
   * Creates new nodes, appends them to the nodes of this selection and returns them
   * as a new selection. The created nodes inherit the datums and the parents of the nodes
   * they replace.
   * @param Class The constructor function to use to create the new nodes.
   */
  Selection.prototype.append = function (Class) {
    return this.select(function (node) {
      return node.appendChild(new Class());
    });
  };
  /**
   * Same as the {@link append}, but accepts a custom creator function with the
   * {@link NodeSelector} signature rather than a constructor function.
   * @param creator
   */
  Selection.prototype.appendFn = function (creator) {
    return this.select(function (node, data, index, group) {
      return node.appendChild(creator(node, data, index, group));
    });
  };
  /**
   * Runs the given selector that returns a single node for every node in each group.
   * The original nodes are then replaced by the nodes returned by the selector
   * and returned as a new selection.
   * The selected nodes inherit the datums and the parents of the original nodes.
   */
  Selection.prototype.select = function (selector) {
    var groups = this.groups;
    var numGroups = groups.length;
    var subgroups = [];
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      var subgroup = subgroups[j] = new Array(groupSize);
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          var subnode = selector(node, node.datum, i, group);
          if (subnode) {
            subnode.datum = node.datum;
          }
          subgroup[i] = subnode;
        }
        // else this can be a group of the `enter` selection,
        // for example, with no nodes at the i-th position,
        // only nodes at the end of the group
      }
    }

    return new Selection(subgroups, this.parents);
  };
  /**
   * Same as {@link select}, but uses the given {@param Class} (constructor) as a selector.
   * @param Class The constructor function to use to find matching nodes.
   */
  Selection.prototype.selectByClass = function (Class) {
    return this.select(function (node) {
      if (Node$2.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child instanceof Class) {
            return child;
          }
        }
      }
    });
  };
  Selection.prototype.selectByTag = function (tag) {
    return this.select(function (node) {
      if (Node$2.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child.tag === tag) {
            return child;
          }
        }
      }
    });
  };
  Selection.prototype.selectAllByClass = function (Class) {
    return this.selectAll(function (node) {
      var nodes = [];
      if (Node$2.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child instanceof Class) {
            nodes.push(child);
          }
        }
      }
      return nodes;
    });
  };
  Selection.prototype.selectAllByTag = function (tag) {
    return this.selectAll(function (node) {
      var nodes = [];
      if (Node$2.isNode(node)) {
        var children = node.children;
        var n = children.length;
        for (var i = 0; i < n; i++) {
          var child = children[i];
          if (child.tag === tag) {
            nodes.push(child);
          }
        }
      }
      return nodes;
    });
  };
  Selection.prototype.selectNone = function () {
    return [];
  };
  /**
   * Runs the given selector that returns a group of nodes for every node in each group.
   * The original nodes are then replaced by the groups of nodes returned by the selector
   * and returned as a new selection. The original nodes become the parent nodes for each
   * group in the new selection. The selected nodes do not inherit the datums of the original nodes.
   * If called without any parameters, creates a new selection with an empty group for each
   * node in this selection.
   */
  Selection.prototype.selectAll = function (selectorAll) {
    if (!selectorAll) {
      selectorAll = this.selectNone;
    }
    // Each subgroup is populated with the selector (run on each group node) results.
    var subgroups = [];
    // In the new selection that we return, subgroups become groups,
    // and group nodes become parents.
    var parents = [];
    var groups = this.groups;
    var groupCount = groups.length;
    for (var j = 0; j < groupCount; j++) {
      var group = groups[j];
      var groupLength = group.length;
      for (var i = 0; i < groupLength; i++) {
        var node = group[i];
        if (node) {
          subgroups.push(selectorAll(node, node.datum, i, group));
          parents.push(node);
        }
      }
    }
    return new Selection(subgroups, parents);
  };
  /**
   * Runs the given callback for every node in this selection and returns this selection.
   * @param cb
   */
  Selection.prototype.each = function (cb) {
    var groups = this.groups;
    var numGroups = groups.length;
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          cb(node, node.datum, i, group);
        }
      }
    }
    return this;
  };
  Selection.prototype.remove = function () {
    return this.each(function (node) {
      if (Node$2.isNode(node)) {
        var parent_1 = node.parent;
        if (parent_1) {
          parent_1.removeChild(node);
        }
      }
    });
  };
  Selection.prototype.merge = function (other) {
    var groups0 = this.groups;
    var groups1 = other.groups;
    var m0 = groups0.length;
    var m1 = groups1.length;
    var m = Math.min(m0, m1);
    var merges = new Array(m0);
    var j = 0;
    for (; j < m; j++) {
      var group0 = groups0[j];
      var group1 = groups1[j];
      var n = group0.length;
      var merge = merges[j] = new Array(n);
      for (var i = 0; i < n; i++) {
        var node = group0[i] || group1[i];
        merge[i] = node || undefined;
      }
    }
    for (; j < m0; j++) {
      merges[j] = groups0[j];
    }
    return new Selection(merges, this.parents);
  };
  /**
   * Return the first non-null element in this selection.
   * If the selection is empty, returns null.
   */
  Selection.prototype.node = function () {
    var groups = this.groups;
    var numGroups = groups.length;
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var groupSize = group.length;
      for (var i = 0; i < groupSize; i++) {
        var node = group[i];
        if (node) {
          return node;
        }
      }
    }
    return null;
  };
  Selection.prototype.attr = function (name, value) {
    this.each(function (node) {
      node[name] = value;
    });
    return this;
  };
  Selection.prototype.attrFn = function (name, value) {
    this.each(function (node, datum, index, group) {
      node[name] = value(node, datum, index, group);
    });
    return this;
  };
  /**
   * Invokes the given function once, passing in this selection.
   * Returns this selection. Facilitates method chaining.
   * @param cb
   */
  Selection.prototype.call = function (cb) {
    cb(this);
    return this;
  };
  Object.defineProperty(Selection.prototype, "size", {
    /**
     * Returns the total number of nodes in this selection.
     */
    get: function get() {
      var size = 0;
      this.each(function () {
        return size++;
      });
      return size;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "data", {
    /**
     * Returns the array of data for the selected elements.
     */
    get: function get() {
      var data = [];
      this.each(function (_, datum) {
        return data.push(datum);
      });
      return data;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "enter", {
    get: function get() {
      return new Selection(this.enterGroups ? this.enterGroups : [[]], this.parents);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Selection.prototype, "exit", {
    get: function get() {
      return new Selection(this.exitGroups ? this.exitGroups : [[]], this.parents);
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Binds the given value to each selected node and returns this selection
   * with its {@link GDatum} type changed to the type of the given value.
   * This method doesn't compute a join and doesn't affect indexes or the enter and exit selections.
   * This method can also be used to clear bound data.
   * @param value
   */
  Selection.prototype.setDatum = function (value) {
    return this.each(function (node) {
      node.datum = value;
    });
  };
  Object.defineProperty(Selection.prototype, "datum", {
    /**
     * Returns the bound datum for the first non-null element in the selection.
     * This is generally useful only if you know the selection contains exactly one element.
     */
    get: function get() {
      var node = this.node();
      return node ? node.datum : null;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Binds the specified array of values with the selected nodes, returning a new selection
   * that represents the _update_ selection: the nodes successfully bound to the values.
   * Also defines the {@link enter} and {@link exit} selections on the returned selection,
   * which can be used to add or remove the nodes to correspond to the new data.
   * The `values` is an array of values of a particular type, or a function that returns
   * an array of values for each group.
   * When values are assigned to the nodes, they are stored in the {@link Node.datum} property.
   * @param values
   * @param key
   */
  Selection.prototype.setData = function (values, key) {
    if (typeof values !== 'function') {
      var data_1 = values;
      values = function values() {
        return data_1;
      };
    }
    var groups = this.groups;
    var parents = this.parents;
    var numGroups = groups.length;
    var updateGroups = new Array(numGroups);
    var enterGroups = new Array(numGroups);
    var exitGroups = new Array(numGroups);
    for (var j = 0; j < numGroups; j++) {
      var group = groups[j];
      var parent_2 = parents[j];
      if (!parent_2) {
        throw new Error("Group #" + j + " has no parent: " + group);
      }
      var groupSize = group.length;
      var data = values(parent_2, parent_2.datum, j, parents);
      var dataSize = data.length;
      var enterGroup = enterGroups[j] = new Array(dataSize);
      var updateGroup = updateGroups[j] = new Array(dataSize);
      var exitGroup = exitGroups[j] = new Array(groupSize);
      if (key) {
        this.bindKey(parent_2, group, enterGroup, updateGroup, exitGroup, data, key);
      } else {
        this.bindIndex(parent_2, group, enterGroup, updateGroup, exitGroup, data);
      }
      // Now connect the enter nodes to their following update node, such that
      // appendChild can insert the materialized enter node before this node,
      // rather than at the end of the parent node.
      for (var i0 = 0, i1 = 0; i0 < dataSize; i0++) {
        var previous = enterGroup[i0];
        if (previous) {
          if (i0 >= i1) {
            i1 = i0 + 1;
          }
          var next = void 0;
          while (!(next = updateGroup[i1]) && i1 < dataSize) {
            i1++;
          }
          previous.next = next || null;
        }
      }
    }
    var result = new Selection(updateGroups, parents);
    result.enterGroups = enterGroups;
    result.exitGroups = exitGroups;
    return result;
  };
  Selection.prototype.bindIndex = function (parent, group, enter, update, exit, data) {
    var groupSize = group.length;
    var dataSize = data.length;
    var i = 0;
    for (; i < dataSize; i++) {
      var node = group[i];
      if (node) {
        node.datum = data[i];
        update[i] = node;
      } else {
        // more datums than group nodes
        enter[i] = new EnterNode$1(parent, data[i]);
      }
    }
    // more group nodes than datums
    for (; i < groupSize; i++) {
      var node = group[i];
      if (node) {
        exit[i] = node;
      }
    }
  };
  Selection.prototype.bindKey = function (parent, group, enter, update, exit, data, key) {
    var groupSize = group.length;
    var dataSize = data.length;
    var keyValues = new Array(groupSize);
    var nodeByKeyValue = {};
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for (var i = 0; i < groupSize; i++) {
      var node = group[i];
      if (node) {
        var keyValue = keyValues[i] = Selection.keyPrefix + key(node, node.datum, i, group);
        if (keyValue in nodeByKeyValue) {
          exit[i] = node;
        } else {
          nodeByKeyValue[keyValue] = node;
        }
      }
    }
    // Compute the key for each datum.
    // If there is a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for (var i = 0; i < dataSize; i++) {
      var keyValue = Selection.keyPrefix + key(parent, data[i], i, data);
      var node = nodeByKeyValue[keyValue];
      if (node) {
        update[i] = node;
        node.datum = data[i];
        nodeByKeyValue[keyValue] = undefined;
      } else {
        enter[i] = new EnterNode$1(parent, data[i]);
      }
    }
    // Add any remaining nodes that were not bound to data to exit.
    for (var i = 0; i < groupSize; i++) {
      var node = group[i];
      if (node && nodeByKeyValue[keyValues[i]] === node) {
        exit[i] = node;
      }
    }
  };
  Selection.keyPrefix = '$'; // Protect against keys like '__proto__'.
  return Selection;
}();

/**
 * Wraps the native Canvas element and overrides its CanvasRenderingContext2D to
 * provide resolution independent rendering based on `window.devicePixelRatio`.
 */
var HdpiCanvas$1 = /** @class */function () {
  // The width/height attributes of the Canvas element default to
  // 300/150 according to w3.org.
  function HdpiCanvas(document, width, height) {
    if (document === void 0) {
      document = window.document;
    }
    if (width === void 0) {
      width = 600;
    }
    if (height === void 0) {
      height = 300;
    }
    this._container = undefined;
    // `NaN` is deliberate here, so that overrides are always applied
    // and the `resetTransform` inside the `resize` method works in IE11.
    this._pixelRatio = NaN;
    this._width = 100;
    this._height = 100;
    this.document = document;
    this.element = document.createElement('canvas');
    this.context = this.element.getContext('2d');
    this.element.style.userSelect = 'none';
    this.element.style.display = 'block';
    this.setPixelRatio();
    this.resize(width, height);
  }
  Object.defineProperty(HdpiCanvas.prototype, "container", {
    get: function get() {
      return this._container;
    },
    set: function set(value) {
      if (this._container !== value) {
        this.remove();
        if (value) {
          value.appendChild(this.element);
        }
        this._container = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.prototype.remove = function () {
    var parentNode = this.element.parentNode;
    if (parentNode != null) {
      parentNode.removeChild(this.element);
    }
  };
  HdpiCanvas.prototype.destroy = function () {
    this.element.remove();
    this._canvas = undefined;
    Object.freeze(this);
  };
  HdpiCanvas.prototype.toImage = function () {
    var img = this.document.createElement('img');
    img.src = this.getDataURL();
    return img;
  };
  HdpiCanvas.prototype.getDataURL = function (type) {
    return this.element.toDataURL(type);
  };
  /**
   * @param fileName The name of the file upon save. The `.png` extension is going to be added automatically.
   */
  HdpiCanvas.prototype.download = function (fileName) {
    fileName = ((fileName || '').trim() || 'image') + '.png';
    // Chart images saved as JPEG are a few times larger at 50% quality than PNG images,
    // so we don't support saving to JPEG.
    var type = 'image/png';
    var dataUrl = this.getDataURL(type);
    var document = this.document;
    if (navigator.msSaveOrOpenBlob) {
      // IE11
      var binary = atob(dataUrl.split(',')[1]); // strip the `data:image/png;base64,` part
      var array = [];
      for (var i = 0, n = binary.length; i < n; i++) {
        array.push(binary.charCodeAt(i));
      }
      var blob = new Blob([new Uint8Array(array)], {
        type: type
      });
      navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      var a = document.createElement('a');
      a.href = dataUrl;
      a.download = fileName;
      a.style.display = 'none';
      document.body.appendChild(a); // required for the `click` to work in Firefox
      a.click();
      document.body.removeChild(a);
    }
  };
  Object.defineProperty(HdpiCanvas.prototype, "pixelRatio", {
    get: function get() {
      return this._pixelRatio;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Changes the pixel ratio of the Canvas element to the given value,
   * or uses the window.devicePixelRatio (default), then resizes the Canvas
   * element accordingly (default).
   */
  HdpiCanvas.prototype.setPixelRatio = function (ratio) {
    var pixelRatio = ratio || window.devicePixelRatio;
    if (pixelRatio === this.pixelRatio) {
      return;
    }
    HdpiCanvas.overrideScale(this.context, pixelRatio);
    this._pixelRatio = pixelRatio;
    this.resize(this.width, this.height);
  };
  Object.defineProperty(HdpiCanvas.prototype, "pixelated", {
    get: function get() {
      return this.element.style.imageRendering === 'pixelated';
    },
    set: function set(value) {
      this.element.style.imageRendering = value ? 'pixelated' : 'auto';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas.prototype, "width", {
    get: function get() {
      return this._width;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas.prototype, "height", {
    get: function get() {
      return this._height;
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.prototype.resize = function (width, height) {
    if (!(width > 0 && height > 0)) {
      return;
    }
    var _a = this,
      element = _a.element,
      context = _a.context,
      pixelRatio = _a.pixelRatio;
    element.width = Math.round(width * pixelRatio);
    element.height = Math.round(height * pixelRatio);
    element.style.width = width + 'px';
    element.style.height = height + 'px';
    context.resetTransform();
    this._width = width;
    this._height = height;
  };
  Object.defineProperty(HdpiCanvas, "textMeasuringContext", {
    get: function get() {
      if (this._textMeasuringContext) {
        return this._textMeasuringContext;
      }
      var canvas = document.createElement('canvas');
      return this._textMeasuringContext = canvas.getContext('2d');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas, "svgText", {
    get: function get() {
      if (this._svgText) {
        return this._svgText;
      }
      var xmlns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(xmlns, 'svg');
      svg.setAttribute('width', '100');
      svg.setAttribute('height', '100');
      // Add a descriptive class name in case someone sees this SVG element
      // in devtools and wonders about its purpose:
      if (svg.classList) {
        svg.classList.add('text-measuring-svg');
      } else {
        svg.setAttribute('class', 'text-measuring-svg');
      }
      svg.style.position = 'absolute';
      svg.style.top = '-1000px';
      svg.style.visibility = 'hidden';
      var svgText = document.createElementNS(xmlns, 'text');
      svgText.setAttribute('x', '0');
      svgText.setAttribute('y', '30');
      svgText.setAttribute('text', 'black');
      svg.appendChild(svgText);
      document.body.appendChild(svg);
      this._svgText = svgText;
      return svgText;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HdpiCanvas, "has", {
    get: function get() {
      if (this._has) {
        return this._has;
      }
      var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
      var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
      var isSafari = !isChrome && navigator.userAgent.indexOf('Safari') > -1;
      return this._has = Object.freeze({
        textMetrics: this.textMeasuringContext.measureText('test').actualBoundingBoxDescent !== undefined
        // Firefox implemented advanced TextMetrics object in v74:
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1102584
        // but it's buggy, so we'll keed using the SVG for text measurement in Firefox for now.
        && !isFirefox && !isSafari,
        getTransform: this.textMeasuringContext.getTransform !== undefined
      });
    },
    enumerable: true,
    configurable: true
  });
  HdpiCanvas.measureText = function (text, font, textBaseline, textAlign) {
    var ctx = this.textMeasuringContext;
    ctx.font = font;
    ctx.textBaseline = textBaseline;
    ctx.textAlign = textAlign;
    return ctx.measureText(text);
  };
  /**
   * Returns the width and height of the measured text.
   * @param text The single-line text to measure.
   * @param font The font shorthand string.
   */
  HdpiCanvas.getTextSize = function (text, font) {
    if (this.has.textMetrics) {
      var ctx = this.textMeasuringContext;
      ctx.font = font;
      var metrics = ctx.measureText(text);
      return {
        width: metrics.width,
        height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
      };
    } else {
      return this.measureSvgText(text, font);
    }
  };
  HdpiCanvas.measureSvgText = function (text, font) {
    var cache = this.textSizeCache;
    var fontCache = cache[font];
    // Note: consider not caching the size of numeric strings.
    // For example: if (isNaN(+text)) { // skip
    if (fontCache) {
      var size_1 = fontCache[text];
      if (size_1) {
        return size_1;
      }
    } else {
      cache[font] = {};
    }
    var svgText = this.svgText;
    svgText.style.font = font;
    svgText.textContent = text;
    // `getBBox` returns an instance of `SVGRect` with the same `width` and `height`
    // measurements as `DOMRect` instance returned by the `getBoundingClientRect`.
    // But the `SVGRect` instance has half the properties of the `DOMRect`,
    // so we use the `getBBox` method.
    var bbox = svgText.getBBox();
    var size = {
      width: bbox.width,
      height: bbox.height
    };
    cache[font][text] = size;
    return size;
  };
  HdpiCanvas.overrideScale = function (ctx, scale) {
    var depth = 0;
    var overrides = {
      save: function save() {
        this.$save();
        depth++;
      },
      restore: function restore() {
        if (depth > 0) {
          this.$restore();
          depth--;
        }
      },
      setTransform: function setTransform(a, b, c, d, e, f) {
        this.$setTransform(a * scale, b * scale, c * scale, d * scale, e * scale, f * scale);
      },
      resetTransform: function resetTransform() {
        // As of Jan 8, 2019, `resetTransform` is still an "experimental technology",
        // and doesn't work in IE11 and Edge 44.
        this.$setTransform(scale, 0, 0, scale, 0, 0);
        this.save();
        depth = 0;
        // The scale above will be impossible to restore,
        // because we override the `ctx.restore` above and
        // check `depth` there.
      }
    };

    for (var name_1 in overrides) {
      if (overrides.hasOwnProperty(name_1)) {
        // Save native methods under prefixed names,
        // if this hasn't been done by the previous overrides already.
        if (!ctx['$' + name_1]) {
          ctx['$' + name_1] = ctx[name_1];
        }
        // Replace native methods with overrides,
        // or previous overrides with the new ones.
        ctx[name_1] = overrides[name_1];
      }
    }
  };
  HdpiCanvas.textSizeCache = {};
  return HdpiCanvas;
}();
var Scene$1 = /** @class */function () {
  // As a rule of thumb, constructors with no parameters are preferred.
  // A few exceptions are:
  // - we absolutely need to know something at construction time (document)
  // - knowing something at construction time meaningfully improves performance (width, height)
  function Scene(document, width, height) {
    var _this = this;
    if (document === void 0) {
      document = window.document;
    }
    this.id = createId$1(this);
    this._dirty = false;
    this.animationFrameId = 0;
    this._root = null;
    this.debug = {
      renderFrameIndex: false,
      renderBoundingBoxes: false
    };
    this._frameIndex = 0;
    this.render = function () {
      var _a;
      var _b = _this,
        ctx = _b.ctx,
        root = _b.root,
        pendingSize = _b.pendingSize;
      _this.animationFrameId = 0;
      if (pendingSize) {
        (_a = _this.canvas).resize.apply(_a, pendingSize);
        _this.pendingSize = undefined;
      }
      if (root && !root.visible) {
        _this.dirty = false;
        return;
      }
      // start with a blank canvas, clear previous drawing
      ctx.clearRect(0, 0, _this.width, _this.height);
      if (root) {
        ctx.save();
        if (root.visible) {
          root.render(ctx);
        }
        ctx.restore();
      }
      _this._frameIndex++;
      if (_this.debug.renderFrameIndex) {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, 40, 15);
        ctx.fillStyle = 'black';
        ctx.fillText(_this.frameIndex.toString(), 2, 10);
      }
      _this.dirty = false;
    };
    this.canvas = new HdpiCanvas$1(document, width, height);
    this.ctx = this.canvas.context;
  }
  Object.defineProperty(Scene.prototype, "container", {
    get: function get() {
      return this.canvas.container;
    },
    set: function set(value) {
      this.canvas.container = value;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.download = function (fileName) {
    this.canvas.download(fileName);
  };
  Scene.prototype.getDataURL = function (type) {
    return this.canvas.getDataURL(type);
  };
  Object.defineProperty(Scene.prototype, "width", {
    get: function get() {
      return this.pendingSize ? this.pendingSize[0] : this.canvas.width;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Scene.prototype, "height", {
    get: function get() {
      return this.pendingSize ? this.pendingSize[1] : this.canvas.height;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.resize = function (width, height) {
    width = Math.round(width);
    height = Math.round(height);
    if (width === this.width && height === this.height) {
      return;
    }
    this.pendingSize = [width, height];
    this.dirty = true;
  };
  Object.defineProperty(Scene.prototype, "dirty", {
    get: function get() {
      return this._dirty;
    },
    set: function set(dirty) {
      if (dirty && !this._dirty) {
        this.animationFrameId = requestAnimationFrame(this.render);
      }
      this._dirty = dirty;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.cancelRender = function () {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = 0;
      this._dirty = false;
    }
  };
  Object.defineProperty(Scene.prototype, "root", {
    get: function get() {
      return this._root;
    },
    set: function set(node) {
      if (node === this._root) {
        return;
      }
      if (this._root) {
        this._root._setScene();
      }
      this._root = node;
      if (node) {
        // If `node` is the root node of another scene ...
        if (node.parent === null && node.scene && node.scene !== this) {
          node.scene.root = null;
        }
        node._setScene(this);
      }
      this.dirty = true;
    },
    enumerable: true,
    configurable: true
  });
  Scene.prototype.appendPath = function (path) {
    var ctx = this.ctx;
    var commands = path.commands;
    var params = path.params;
    var n = commands.length;
    var j = 0;
    ctx.beginPath();
    for (var i = 0; i < n; i++) {
      switch (commands[i]) {
        case 'M':
          ctx.moveTo(params[j++], params[j++]);
          break;
        case 'L':
          ctx.lineTo(params[j++], params[j++]);
          break;
        case 'C':
          ctx.bezierCurveTo(params[j++], params[j++], params[j++], params[j++], params[j++], params[j++]);
          break;
        case 'Z':
          ctx.closePath();
          break;
      }
    }
  };
  Object.defineProperty(Scene.prototype, "frameIndex", {
    get: function get() {
      return this._frameIndex;
    },
    enumerable: true,
    configurable: true
  });
  Scene.className = 'Scene';
  return Scene;
}();
var Padding$1 = /** @class */function () {
  function Padding(top, right, bottom, left) {
    if (top === void 0) {
      top = 0;
    }
    if (right === void 0) {
      right = top;
    }
    if (bottom === void 0) {
      bottom = top;
    }
    if (left === void 0) {
      left = right;
    }
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
  }
  Padding.prototype.clear = function () {
    this.top = this.right = this.bottom = this.left = 0;
  };
  return Padding;
}();
var defaultTooltipCss$1 = "\n.ag-sparkline-tooltip {\n    display: table;\n    position: absolute;\n    user-select: none;\n    pointer-events: none;\n    white-space: nowrap;\n    z-index: 99999;\n    font: 12px Verdana, sans-serif;\n    color: black;\n    background: rgb(244, 244, 244);\n    border-radius: 5px;\n    box-shadow: 0 0 1px rgba(3, 3, 3, 0.7), 0.5vh 0.5vh 1vh rgba(3, 3, 3, 0.25);\n}\n\n.ag-sparkline-tooltip-hidden {\n    top: -10000px !important;\n}\n\n.ag-sparkline-tooltip-title {\n    font-weight: bold;\n    padding: 7px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    color: white;\n    background-color: #888888;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.ag-sparkline-tooltip-content {\n    padding: 7px;\n    line-height: 1.7em;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    overflow: hidden;\n}\n\n.ag-sparkline-tooltip-content:empty {\n    padding: 0;\n    height: 7px;\n}\n\n.ag-sparkline-tooltip-arrow::before {\n    content: \"\";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 6px solid #989898;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: #989898;\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-sparkline-tooltip-arrow::after {\n    content: \"\";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 5px solid black;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: rgb(244, 244, 244);\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-sparkline-wrapper {\n    box-sizing: border-box;\n    overflow: hidden;\n}\n";

// Simplified version of https://github.com/plotly/fast-isnumeric
// that doesn't treat number strings with leading/trailing whitespace as numbers.
function isNumber$1(value) {
  var type = typeof value;
  if (type === 'string') {
    return false;
  } else if (type !== 'number') {
    return false;
  }
  // value - value is going to be:
  // - zero, for any finite number
  // -  NaN, for NaN, Infinity, -Infinity
  return value - value < 1;
}
function isNumberObject$1(value) {
  return !!value && value.hasOwnProperty('valueOf') && isNumber$1(value.valueOf());
}
function isNumeric$2(value) {
  return isNumber$1(value) || isNumberObject$1(value);
}
function isDate$1(value) {
  return value instanceof Date && !isNaN(+value);
}
function isString$1(value) {
  return typeof value === 'string';
}
function isStringObject$1(value) {
  return !!value && value.hasOwnProperty('toString') && isString$1(value.toString());
}
function isContinuous$1(value) {
  return isNumeric$2(value) || isDate$1(value);
}
var constant$2 = function constant$2(x) {
  return function () {
    return x;
  };
};
function interpolateNumber$1(a, b) {
  a = +a;
  b = +b;
  return function (t) {
    return a * (1 - t) + b * t;
  };
}
function date$1(a, b) {
  var date = new Date();
  var msA = +a;
  var msB = +b;
  return function (t) {
    date.setTime(msA * (1 - t) + msB * t);
    return date;
  };
}
function array$1(a, b) {
  var nb = b ? b.length : 0;
  var na = a ? Math.min(nb, a.length) : 0;
  var x = new Array(na);
  var c = new Array(nb);
  var i;
  for (i = 0; i < na; ++i) {
    x[i] = interpolateValue$1(a[i], b[i]);
  }
  for (; i < nb; ++i) {
    c[i] = b[i];
  }
  return function (t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }
    return c;
  };
}
function object$1(a, b) {
  var i = {};
  var c = {};
  var k;
  if (a === null || typeof a !== 'object') {
    a = {};
  }
  if (b === null || typeof b !== 'object') {
    b = {};
  }
  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue$1(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }
    return c;
  };
}
var Color$2 = /** @class */function () {
  /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */
  function Color(r, g, b, a) {
    if (a === void 0) {
      a = 1;
    }
    // NaN is treated as 0.
    this.r = Math.min(1, Math.max(0, r || 0));
    this.g = Math.min(1, Math.max(0, g || 0));
    this.b = Math.min(1, Math.max(0, b || 0));
    this.a = Math.min(1, Math.max(0, a || 0));
  }
  /**
   * The given string can be in one of the following formats:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   * @param str
   */
  Color.fromString = function (str) {
    // hexadecimal notation
    if (str.indexOf('#') >= 0) {
      // there can be some leading whitespace
      return Color.fromHexString(str);
    }
    // color name
    var hex = Color.nameToHex[str];
    if (hex) {
      return Color.fromHexString(hex);
    }
    // rgb(a) notation
    if (str.indexOf('rgb') >= 0) {
      return Color.fromRgbaString(str);
    }
    throw new Error("Invalid color string: '" + str + "'");
  };
  // See https://drafts.csswg.org/css-color/#hex-notation
  Color.parseHex = function (input) {
    input = input.replace(/ /g, '').slice(1);
    var parts;
    switch (input.length) {
      case 6:
      case 8:
        parts = [];
        for (var i = 0; i < input.length; i += 2) {
          parts.push(parseInt("" + input[i] + input[i + 1], 16));
        }
        break;
      case 3:
      case 4:
        parts = input.split('').map(function (p) {
          return parseInt(p, 16);
        }).map(function (p) {
          return p + p * 16;
        });
        break;
    }
    if (parts.length >= 3) {
      if (parts.every(function (p) {
        return p >= 0;
      })) {
        if (parts.length === 3) {
          parts.push(255);
        }
        return parts;
      }
    }
  };
  Color.fromHexString = function (str) {
    var values = Color.parseHex(str);
    if (values) {
      var r = values[0],
        g = values[1],
        b = values[2],
        a = values[3];
      return new Color(r / 255, g / 255, b / 255, a / 255);
    }
    throw new Error("Malformed hexadecimal color string: '" + str + "'");
  };
  Color.stringToRgba = function (str) {
    // Find positions of opening and closing parentheses.
    var _a = [NaN, NaN],
      po = _a[0],
      pc = _a[1];
    for (var i = 0; i < str.length; i++) {
      var c = str[i];
      if (!po && c === '(') {
        po = i;
      } else if (c === ')') {
        pc = i;
        break;
      }
    }
    var contents = po && pc && str.substring(po + 1, pc);
    if (!contents) {
      return;
    }
    var parts = contents.split(',');
    var rgba = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var value = parseFloat(part);
      if (isNaN(value)) {
        return;
      }
      if (part.indexOf('%') >= 0) {
        // percentage r, g, or b value
        value = Math.max(0, Math.min(100, value));
        value /= 100;
      } else {
        if (i === 3) {
          // alpha component
          value = Math.max(0, Math.min(1, value));
        } else {
          // absolute r, g, or b value
          value = Math.max(0, Math.min(255, value));
          value /= 255;
        }
      }
      rgba.push(value);
    }
    return rgba;
  };
  Color.fromRgbaString = function (str) {
    var rgba = Color.stringToRgba(str);
    if (rgba) {
      if (rgba.length === 3) {
        return new Color(rgba[0], rgba[1], rgba[2]);
      } else if (rgba.length === 4) {
        return new Color(rgba[0], rgba[1], rgba[2], rgba[3]);
      }
    }
    throw new Error("Malformed rgb/rgba color string: '" + str + "'");
  };
  Color.fromArray = function (arr) {
    if (arr.length === 4) {
      return new Color(arr[0], arr[1], arr[2], arr[3]);
    }
    if (arr.length === 3) {
      return new Color(arr[0], arr[1], arr[2]);
    }
    throw new Error('The given array should contain 3 or 4 color components (numbers).');
  };
  Color.fromHSB = function (h, s, b, alpha) {
    if (alpha === void 0) {
      alpha = 1;
    }
    var rgb = Color.HSBtoRGB(h, s, b);
    return new Color(rgb[0], rgb[1], rgb[2], alpha);
  };
  Color.padHex = function (str) {
    // Can't use `padStart(2, '0')` here because of IE.
    return str.length === 1 ? '0' + str : str;
  };
  Color.prototype.toHexString = function () {
    var hex = '#' + Color.padHex(Math.round(this.r * 255).toString(16)) + Color.padHex(Math.round(this.g * 255).toString(16)) + Color.padHex(Math.round(this.b * 255).toString(16));
    if (this.a < 1) {
      hex += Color.padHex(Math.round(this.a * 255).toString(16));
    }
    return hex;
  };
  Color.prototype.toRgbaString = function (fractionDigits) {
    if (fractionDigits === void 0) {
      fractionDigits = 3;
    }
    var components = [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
    var k = Math.pow(10, fractionDigits);
    if (this.a !== 1) {
      components.push(Math.round(this.a * k) / k);
      return "rgba(" + components.join(', ') + ")";
    }
    return "rgb(" + components.join(', ') + ")";
  };
  Color.prototype.toString = function () {
    if (this.a === 1) {
      return this.toHexString();
    }
    return this.toRgbaString();
  };
  Color.prototype.toHSB = function () {
    return Color.RGBtoHSB(this.r, this.g, this.b);
  };
  /**
   * Converts the given RGB triple to an array of HSB (HSV) components.
   * The hue component will be `NaN` for achromatic colors.
   */
  Color.RGBtoHSB = function (r, g, b) {
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var S = max !== 0 ? (max - min) / max : 0;
    var H = NaN;
    // min == max, means all components are the same
    // and the color is a shade of gray with no hue (H is NaN)
    if (min !== max) {
      var delta = max - min;
      var rc = (max - r) / delta;
      var gc = (max - g) / delta;
      var bc = (max - b) / delta;
      if (r === max) {
        H = bc - gc;
      } else if (g === max) {
        H = 2.0 + rc - bc;
      } else {
        H = 4.0 + gc - rc;
      }
      H /= 6.0;
      if (H < 0) {
        H = H + 1.0;
      }
    }
    return [H * 360, S, max];
  };
  /**
   * Converts the given HSB (HSV) triple to an array of RGB components.
   */
  Color.HSBtoRGB = function (H, S, B) {
    if (isNaN(H)) {
      H = 0;
    }
    H = (H % 360 + 360) % 360 / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
    var r = 0;
    var g = 0;
    var b = 0;
    if (S === 0) {
      r = g = b = B;
    } else {
      var h = (H - Math.floor(H)) * 6;
      var f = h - Math.floor(h);
      var p = B * (1 - S);
      var q = B * (1 - S * f);
      var t = B * (1 - S * (1 - f));
      switch (h >> 0) {
        // discard the floating point part of the number
        case 0:
          r = B;
          g = t;
          b = p;
          break;
        case 1:
          r = q;
          g = B;
          b = p;
          break;
        case 2:
          r = p;
          g = B;
          b = t;
          break;
        case 3:
          r = p;
          g = q;
          b = B;
          break;
        case 4:
          r = t;
          g = p;
          b = B;
          break;
        case 5:
          r = B;
          g = p;
          b = q;
          break;
      }
    }
    return [r, g, b];
  };
  Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
    var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
    var b = hsb[2];
    if (b == 0 && brightnessFactor > 1.0) {
      b = 0.05;
    }
    var h = ((hsb[0] + hueShift) % 360 + 360) % 360;
    var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
    b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
    var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
    var rgba = Color.HSBtoRGB(h, s, b);
    rgba.push(a);
    return Color.fromArray(rgba);
  };
  Color.prototype.brighter = function () {
    return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
  };
  Color.prototype.darker = function () {
    return this.derive(0, 1.0, 0.7, 1.0);
  };
  /**
   * CSS Color Module Level 4:
   * https://drafts.csswg.org/css-color/#named-colors
   */
  Color.nameToHex = Object.freeze({
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#00FFFF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000000',
    blanchedalmond: '#FFEBCD',
    blue: '#0000FF',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#00FFFF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgreen: '#006400',
    darkgrey: '#A9A9A9',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#FF00FF',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    grey: '#808080',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgreen: '#90EE90',
    lightgrey: '#D3D3D3',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#00FF00',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#FF00FF',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#FF0000',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFFFFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FFFF00',
    yellowgreen: '#9ACD32'
  });
  return Color;
}();
function color$1(a, b) {
  if (typeof a === 'string') {
    try {
      a = Color$2.fromString(a);
    } catch (e) {
      a = Color$2.fromArray([0, 0, 0]);
    }
  }
  if (typeof b === 'string') {
    try {
      b = Color$2.fromString(b);
    } catch (e) {
      b = Color$2.fromArray([0, 0, 0]);
    }
  }
  var red = interpolateNumber$1(a.r, b.r);
  var green = interpolateNumber$1(a.g, b.g);
  var blue = interpolateNumber$1(a.b, b.b);
  var alpha = interpolateNumber$1(a.a, b.a);
  return function (t) {
    return Color$2.fromArray([red(t), green(t), blue(t), alpha(t)]).toRgbaString();
  };
}
function interpolateValue$1(a, b) {
  var t = typeof b;
  var c;
  if (b == null || t === 'boolean') {
    return constant$2(b);
  }
  if (t === 'number') {
    return interpolateNumber$1(a, b);
  }
  if (t === 'string') {
    try {
      c = Color$2.fromString(b);
      b = c;
      return color$1(a, b);
    } catch (e) {
      // return string(a, b);
    }
  }
  if (b instanceof Color$2) {
    return color$1(a, b);
  }
  if (b instanceof Date) {
    return date$1(a, b);
  }
  if (Array.isArray(b)) {
    return array$1(a, b);
  }
  if (typeof b.valueOf !== 'function' && typeof b.toString !== 'function' || isNaN(b)) {
    return object$1(a, b);
  }
  return interpolateNumber$1(a, b);
}
var constant$3 = function constant$3(x) {
  return function () {
    return x;
  };
};
var identity$4 = function identity$4(x) {
  return x;
};
function clamper$2(domain) {
  var _a;
  var a = domain[0];
  var b = domain[domain.length - 1];
  if (a > b) {
    _a = [b, a], a = _a[0], b = _a[1];
  }
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}
var ContinuousScale$1 = /** @class */function () {
  function ContinuousScale() {
    /**
     * The output value of the scale for `undefined` or `NaN` input values.
     */
    this.unknown = undefined;
    this._clamp = identity$4;
    this._domain = [0, 1];
    this._range = [0, 1];
    this.transform = identity$4; // transforms domain value
    this.untransform = identity$4; // untransforms domain value
    this._interpolate = interpolateValue$1;
    this.rescale();
  }
  Object.defineProperty(ContinuousScale.prototype, "clamp", {
    get: function get() {
      return this._clamp !== identity$4;
    },
    set: function set(value) {
      this._clamp = value ? clamper$2(this.domain) : identity$4;
    },
    enumerable: true,
    configurable: true
  });
  ContinuousScale.prototype.setDomain = function (values) {
    this._domain = Array.prototype.map.call(values, function (v) {
      return +v;
    });
    if (this._clamp !== identity$4) {
      this._clamp = clamper$2(this.domain);
    }
    this.rescale();
  };
  ContinuousScale.prototype.getDomain = function () {
    return this._domain.slice();
  };
  Object.defineProperty(ContinuousScale.prototype, "domain", {
    get: function get() {
      return this.getDomain();
    },
    set: function set(values) {
      this.setDomain(values);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContinuousScale.prototype, "range", {
    get: function get() {
      return this._range.slice();
    },
    set: function set(values) {
      this._range = Array.prototype.slice.call(values);
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContinuousScale.prototype, "interpolate", {
    get: function get() {
      return this._interpolate;
    },
    set: function set(value) {
      this._interpolate = value;
      this.rescale();
    },
    enumerable: true,
    configurable: true
  });
  ContinuousScale.prototype.rescale = function () {
    this.piecewise = this.bimap;
    this.output = undefined;
    this.input = undefined;
  };
  /**
   * Returns a function that converts `x` in `[a, b]` to `t` in `[0, 1]`. Non-clamping.
   * @param a
   * @param b
   */
  ContinuousScale.prototype.normalize = function (a, b) {
    return (b -= a = +a) ? function (x) {
      return (x - a) / b;
    } : constant$3(isNaN(b) ? NaN : 0.5);
  };
  ContinuousScale.prototype.bimap = function (domain, range, interpolate) {
    var x0 = domain[0];
    var x1 = domain[1];
    var y0 = range[0];
    var y1 = range[1];
    var xt;
    var ty;
    if (x1 < x0) {
      xt = this.normalize(x1, x0);
      ty = interpolate(y1, y0);
    } else {
      xt = this.normalize(x0, x1);
      ty = interpolate(y0, y1);
    }
    return function (x) {
      return ty(xt(x));
    }; // domain value x --> t in [0, 1] --> range value y
  };

  ContinuousScale.prototype.convert = function (x) {
    x = +x;
    if (isNaN(x)) {
      return this.unknown;
    } else {
      if (!this.output) {
        this.output = this.piecewise(this.domain.map(this.transform), this.range, this.interpolate);
      }
      return this.output(this.transform(this._clamp(x)));
    }
  };
  ContinuousScale.prototype.invert = function (y) {
    if (!this.input) {
      this.input = this.piecewise(this.range, this.domain.map(this.transform), interpolateNumber$1);
    }
    return this._clamp(this.untransform(this.input(y)));
  };
  return ContinuousScale;
}();
var __extends$61 = undefined && undefined.__extends || function () {
  var _extendStatics394 = function extendStatics(d, b) {
    _extendStatics394 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics394(d, b);
  };
  return function (d, b) {
    _extendStatics394(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
function ticks$1(a, b, count) {
  var step = tickStep$1(a, b, count);
  a = Math.ceil(a / step) * step;
  b = Math.floor(b / step) * step + step / 2;
  // Add half a step here so that the array returned by `range` includes the last tick.
  return range$1(a, b, step);
}
var e10$1 = Math.sqrt(50);
var e5$1 = Math.sqrt(10);
var e2$1 = Math.sqrt(2);
function tickStep$1(a, b, count) {
  var rawStep = Math.abs(b - a) / Math.max(0, count);
  var step = Math.pow(10, Math.floor(Math.log(rawStep) / Math.LN10)); // = Math.log10(rawStep)
  var error = rawStep / step;
  if (error >= e10$1) {
    step *= 10;
  } else if (error >= e5$1) {
    step *= 5;
  } else if (error >= e2$1) {
    step *= 2;
  }
  return b < a ? -step : step;
}
function tickIncrement$1(a, b, count) {
  var rawStep = (b - a) / Math.max(0, count);
  var power = Math.floor(Math.log(rawStep) / Math.LN10);
  var error = rawStep / Math.pow(10, power);
  return power >= 0 ? (error >= e10$1 ? 10 : error >= e5$1 ? 5 : error >= e2$1 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10$1 ? 10 : error >= e5$1 ? 5 : error >= e2$1 ? 2 : 1);
}
var NumericTicks$1 = /** @class */function (_super) {
  __extends$61(NumericTicks, _super);
  function NumericTicks(fractionDigits, elements) {
    var _this = _super.call(this) || this;
    if (elements) {
      for (var i = 0, n = elements.length; i < n; i++) {
        _this[i] = elements[i];
      }
    }
    _this.fractionDigits = fractionDigits;
    return _this;
  }
  return NumericTicks;
}(Array);
function range$1(a, b, step) {
  if (step === void 0) {
    step = 1;
  }
  var absStep = Math.abs(step);
  var fractionDigits = absStep > 0 && absStep < 1 ? Math.abs(Math.floor(Math.log(absStep) / Math.LN10)) : 0;
  var f = Math.pow(10, fractionDigits);
  var n = Math.max(0, Math.ceil((b - a) / step)) || 0;
  var values = new NumericTicks$1(fractionDigits);
  for (var i = 0; i < n; i++) {
    var value = a + step * i;
    values[i] = Math.round(value * f) / f;
  }
  return values;
}
function formatDefault$1(x, p) {
  var xs = x.toPrecision(p);
  out: for (var n = xs.length, i = 1, i0 = -1, i1 = 0; i < n; ++i) {
    switch (xs[i]) {
      case '.':
        i0 = i1 = i;
        break;
      case '0':
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      case 'e':
        break out;
      default:
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? xs.slice(0, i0) + xs.slice(i1 + 1) : xs;
}
var formatTypes$1 = {
  '': formatDefault$1,
  // Multiply by 100, and then decimal notation with a percent sign.
  '%': function _(x, p) {
    return (x * 100).toFixed(p);
  },
  // Binary notation, rounded to integer.
  'b': function b(x) {
    return Math.round(x).toString(2);
  },
  // Converts the integer to the corresponding unicode character before printing.
  'c': function c(x) {
    return String(x);
  },
  // Decimal notation, rounded to integer.
  'd': formatDecimal$1,
  // Exponent notation.
  'e': function e(x, p) {
    return x.toExponential(p);
  },
  // Fixed point notation.
  'f': function f(x, p) {
    return x.toFixed(p);
  },
  // Either decimal or exponent notation, rounded to significant digits.
  'g': function g(x, p) {
    return x.toPrecision(p);
  },
  // Octal notation, rounded to integer.
  'o': function o(x) {
    return Math.round(x).toString(8);
  },
  // Multiply by 100, round to significant digits, and then decimal notation with a percent sign.
  'p': function p(x, _p4) {
    return formatRounded$1(x * 100, _p4);
  },
  // Decimal notation, rounded to significant digits.
  'r': formatRounded$1,
  // Decimal notation with a SI prefix, rounded to significant digits.
  's': formatPrefixAuto$1,
  // Hexadecimal notation, using upper-case letters, rounded to integer.
  'X': function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  // Hexadecimal notation, using lower-case letters, rounded to integer.
  'x': function x(_x4) {
    return Math.round(_x4).toString(16);
  }
};
var prefixes$1 = ['y', 'z', 'a', 'f', 'p', 'n', '\xB5', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
/**
 * [[fill]align][sign][#][0][width][grouping_option][.precision][type]
 */
var FormatSpecifier$1 = /** @class */function () {
  function FormatSpecifier(specifier) {
    if (specifier instanceof FormatSpecifier) {
      this.fill = specifier.fill;
      this.align = specifier.align;
      this.sign = specifier.sign;
      this.symbol = specifier.symbol;
      this.zero = specifier.zero;
      this.width = specifier.width;
      this.comma = specifier.comma;
      this.precision = specifier.precision;
      this.trim = specifier.trim;
      this.type = specifier.type;
      this.string = specifier.string;
    } else {
      this.fill = specifier.fill === undefined ? ' ' : String(specifier.fill);
      this.align = specifier.align === undefined ? '>' : String(specifier.align);
      this.sign = specifier.sign === undefined ? '-' : String(specifier.sign);
      this.symbol = specifier.symbol === undefined ? '' : String(specifier.symbol);
      this.zero = !!specifier.zero;
      this.width = specifier.width === undefined ? undefined : +specifier.width;
      this.comma = !!specifier.comma;
      this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
      this.trim = !!specifier.trim;
      this.type = specifier.type === undefined ? '' : String(specifier.type);
      this.string = specifier.string;
    }
  }
  return FormatSpecifier;
}();
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var formatRegEx$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
var interpolateRegEx$1 = /(#\{(.*?)\})/g;
function makeFormatSpecifier$1(specifier) {
  if (specifier instanceof FormatSpecifier$1) {
    return new FormatSpecifier$1(specifier);
  }
  var found = false;
  var string = specifier.replace(interpolateRegEx$1, function () {
    if (!found) {
      specifier = arguments[2];
      found = true;
    }
    return '#{}';
  });
  var match = formatRegEx$1.exec(specifier);
  if (!match) {
    throw new Error("Invalid format: " + specifier);
  }
  return new FormatSpecifier$1({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10],
    string: found ? string : undefined
  });
}
function tickFormat$1(start, stop, count, specifier) {
  var step = tickStep$1(start, stop, count);
  var formatSpecifier = makeFormatSpecifier$1(specifier == undefined ? ',f' : specifier);
  var precision;
  switch (formatSpecifier.type) {
    case 's':
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (formatSpecifier.precision == null && !isNaN(precision = precisionPrefix$1(step, value))) {
          formatSpecifier.precision = precision;
        }
        return formatPrefix$1(formatSpecifier, value);
      }
    case '':
    case 'e':
    case 'g':
    case 'p':
    case 'r':
      {
        if (formatSpecifier.precision == null && !isNaN(precision = precisionRound$1(step, Math.max(Math.abs(start), Math.abs(stop))))) {
          formatSpecifier.precision = precision - +(formatSpecifier.type === 'e');
        }
        break;
      }
    case 'f':
    case '%':
      {
        if (formatSpecifier.precision == null && !isNaN(precision = precisionFixed$1(step))) {
          formatSpecifier.precision = precision - +(formatSpecifier.type === '%') * 2;
        }
        break;
      }
  }
  return format$1(formatSpecifier);
}
var prefixExponent$1;
function formatPrefixAuto$1(x, p) {
  if (p === void 0) {
    p = 0;
  }
  var d = formatDecimalParts$1(x, p);
  if (!d) {
    return String(x);
  }
  var coefficient = d[0];
  var exponent = d[1];
  prefixExponent$1 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3;
  var i = exponent - prefixExponent$1 + 1;
  var n = coefficient.length;
  if (i === n) {
    return coefficient;
  } else {
    if (i > n) {
      return coefficient + new Array(i - n + 1).join('0');
    }
    if (i > 0) {
      return coefficient.slice(0, i) + '.' + coefficient.slice(i);
    } else {
      var parts = formatDecimalParts$1(x, Math.max(0, p + i - 1));
      return '0.' + new Array(1 - i).join('0') + parts[0]; // less than 1y!
    }
  }
}

function formatDecimal$1(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString('en').replace(/,/g, '') : x.toString(10);
}
function formatGroup$1(grouping, thousands) {
  return function (value, width) {
    var t = [];
    var i = value.length;
    var j = 0;
    var g = grouping[0];
    var length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) {
        g = Math.max(1, width - length);
      }
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) {
        break;
      }
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals$1(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim$1(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1 = 0; i < n; ++i) {
    switch (s[i]) {
      case '.':
        i0 = i1 = i;
        break;
      case '0':
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
function formatRounded$1(x, p) {
  var d = formatDecimalParts$1(x, p);
  if (!d) {
    return String(x);
  }
  var coefficient = d[0];
  var exponent = d[1];
  if (exponent < 0) {
    return '0.' + new Array(-exponent).join('0') + coefficient;
  } else {
    if (coefficient.length > exponent + 1) {
      return coefficient.slice(0, exponent + 1) + '.' + coefficient.slice(exponent + 1);
    } else {
      return coefficient + new Array(exponent - coefficient.length + 2).join('0');
    }
  }
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ['123', 0].
function formatDecimalParts$1(x, p) {
  var sx = p ? x.toExponential(p - 1) : x.toExponential();
  var i = sx.indexOf('e');
  if (i < 0) {
    // NaN, ±Infinity
    return undefined;
  }
  var coefficient = sx.slice(0, i);
  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +sx.slice(i + 1)];
}
function identity$5(x) {
  return x;
}
var formatDefaultLocale$1;
var format$1;
var formatPrefix$1;
defaultLocale$1({
  thousands: ',',
  grouping: [3],
  currency: ['$', '']
});
function defaultLocale$1(definition) {
  formatDefaultLocale$1 = formatLocale$2(definition);
  format$1 = formatDefaultLocale$1.format;
  formatPrefix$1 = formatDefaultLocale$1.formatPrefix;
}
function exponent$1(x) {
  var parts = formatDecimalParts$1(Math.abs(x));
  if (parts) {
    return parts[1];
  }
  return NaN;
}
function precisionFixed$1(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
}
function precisionPrefix$1(step, value) {
  var x = Math.floor(exponent$1(value) / 3);
  x = Math.min(8, x);
  x = Math.max(-8, x);
  return Math.max(0, x * 3 - exponent$1(Math.abs(step)));
}
function precisionRound$1(step, max) {
  step = Math.abs(step);
  max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
}
function formatLocale$2(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$5 : formatGroup$1(Array.prototype.map.call(locale.grouping, Number), String(locale.thousands));
  var currencyPrefix = locale.currency === undefined ? '' : String(locale.currency[0]);
  var currencySuffix = locale.currency === undefined ? '' : String(locale.currency[1]);
  var decimal = locale.decimal === undefined ? '.' : String(locale.decimal);
  var numerals = locale.numerals === undefined ? identity$5 : formatNumerals$1(Array.prototype.map.call(locale.numerals, String));
  var percent = locale.percent === undefined ? '%' : String(locale.percent);
  var minus = locale.minus === undefined ? "\u2212" : String(locale.minus);
  var nan = locale.nan === undefined ? 'NaN' : String(locale.nan);
  function newFormat(specifier) {
    var formatSpecifier = makeFormatSpecifier$1(specifier);
    var fill = formatSpecifier.fill;
    var align = formatSpecifier.align;
    var sign = formatSpecifier.sign;
    var symbol = formatSpecifier.symbol;
    var zero = formatSpecifier.zero;
    var width = formatSpecifier.width;
    var comma = formatSpecifier.comma;
    var precision = formatSpecifier.precision;
    var trim = formatSpecifier.trim;
    var type = formatSpecifier.type;
    // The 'n' type is an alias for ',g'.
    if (type === 'n') {
      comma = true;
      type = 'g';
    } else if (!formatTypes$1[type]) {
      // The '' type, and any invalid type, is an alias for '.12~g'.
      if (precision === undefined) {
        precision = 12;
      }
      trim = true;
      type = 'g';
    }
    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === '0' && align === '=') {
      zero = true;
      fill = '0';
      align = '=';
    }
    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === '$' ? currencyPrefix : symbol === '#' && /[boxX]/.test(type) ? '0' + type.toLowerCase() : '';
    var suffix = symbol === '$' ? currencySuffix : /[%p]/.test(type) ? percent : '';
    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes$1[type];
    var maybeSuffix = /[defgprs%]/.test(type);
    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    if (precision === undefined) {
      precision = 6;
    } else if (/[gprs]/.test(type)) {
      precision = Math.max(1, Math.min(21, precision));
    } else {
      precision = Math.max(0, Math.min(20, precision));
    }
    function format(x) {
      var valuePrefix = prefix;
      var valueSuffix = suffix;
      var value;
      if (type === 'c') {
        valueSuffix = formatType(+x) + valueSuffix;
        value = '';
      } else {
        var nx = +x;
        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = x < 0 || 1 / nx < 0;
        // Perform the initial formatting.
        value = isNaN(nx) ? nan : formatType(Math.abs(nx), precision);
        // Trim insignificant zeros.
        if (trim) {
          value = formatTrim$1(value);
        }
        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== '+') {
          valueNegative = false;
        }
        // Compute the prefix and suffix.
        var signPrefix = valueNegative ? sign === '(' ? sign : minus : sign === '-' || sign === '(' ? '' : sign;
        var signSuffix = valueNegative && sign === '(' ? ')' : '';
        valuePrefix = signPrefix + valuePrefix;
        valueSuffix = (type === 's' ? prefixes$1[8 + prefixExponent$1 / 3] : '') + valueSuffix + signSuffix;
        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          for (var i = 0, n = value.length; i < n; i++) {
            var c = value.charCodeAt(i);
            if (48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      // If the fill character is not '0', grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);
      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length;
      var padding = length < width ? new Array(width - length + 1).join(fill) : '';
      // If the fill character is '0', grouping is applied after padding.
      if (comma && zero) {
        value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity);
        padding = '';
      }
      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case '<':
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case '=':
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case '^':
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      var string = formatSpecifier.string;
      if (string) {
        return string.replace(interpolateRegEx$1, function () {
          return numerals(value);
        });
      }
      return numerals(value);
    }
    return format;
  }
  function formatPrefix(specifier, value) {
    var formatSpecifier = makeFormatSpecifier$1(specifier);
    formatSpecifier.type = 'f';
    var f = newFormat(formatSpecifier);
    var e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3;
    var k = Math.pow(10, -e);
    var prefix = prefixes$1[8 + e / 3];
    return function (value) {
      return f(k * +value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}
var __extends$62 = undefined && undefined.__extends || function () {
  var _extendStatics395 = function extendStatics(d, b) {
    _extendStatics395 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics395(d, b);
  };
  return function (d, b) {
    _extendStatics395(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * Maps continuous domain to a continuous range.
 */
var LinearScale$1 = /** @class */function (_super) {
  __extends$62(LinearScale, _super);
  function LinearScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'linear';
    return _this;
  }
  LinearScale.prototype.ticks = function (count) {
    if (count === void 0) {
      count = 10;
    }
    var d = this._domain;
    return ticks$1(d[0], d[d.length - 1], count);
  };
  /**
   * Extends the domain so that it starts and ends on nice round values.
   * @param count Tick count.
   */
  LinearScale.prototype.nice = function (count) {
    if (count === void 0) {
      count = 10;
    }
    var d = this.domain;
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var step;
    if (stop < start) {
      step = start;
      start = stop;
      stop = step;
      step = i0;
      i0 = i1;
      i1 = step;
    }
    step = tickIncrement$1(start, stop, count);
    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement$1(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement$1(start, stop, count);
    }
    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      this.domain = d;
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      this.domain = d;
    }
  };
  LinearScale.prototype.tickFormat = function (count, specifier) {
    var d = this.domain;
    return tickFormat$1(d[0], d[d.length - 1], count == undefined ? 10 : count, specifier);
  };
  return LinearScale;
}(ContinuousScale$1);
var __extends$63 = undefined && undefined.__extends || function () {
  var _extendStatics396 = function extendStatics(d, b) {
    _extendStatics396 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics396(d, b);
  };
  return function (d, b) {
    _extendStatics396(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var t0$1 = new Date();
var t1$1 = new Date();
/**
 * The interval methods don't mutate Date parameters.
 */
var TimeInterval$1 = /** @class */function () {
  function TimeInterval(floor, offset) {
    this._floor = floor;
    this._offset = offset;
  }
  /**
   * Returns a new date representing the latest interval boundary date before or equal to date.
   * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
   * @param date
   */
  TimeInterval.prototype.floor = function (date) {
    date = new Date(+date);
    this._floor(date);
    return date;
  };
  /**
   * Returns a new date representing the earliest interval boundary date after or equal to date.
   * @param date
   */
  TimeInterval.prototype.ceil = function (date) {
    date = new Date(+date - 1);
    this._floor(date);
    this._offset(date, 1);
    this._floor(date);
    return date;
  };
  /**
   * Returns a new date representing the closest interval boundary date to date.
   * @param date
   */
  TimeInterval.prototype.round = function (date) {
    var d0 = this.floor(date);
    var d1 = this.ceil(date);
    var ms = +date;
    return ms - d0.getTime() < d1.getTime() - ms ? d0 : d1;
  };
  /**
   * Returns a new date equal to date plus step intervals.
   * @param date
   * @param step
   */
  TimeInterval.prototype.offset = function (date, step) {
    if (step === void 0) {
      step = 1;
    }
    date = new Date(+date);
    this._offset(date, Math.floor(step));
    return date;
  };
  /**
   * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
   * @param start
   * @param stop
   * @param step
   */
  TimeInterval.prototype.range = function (start, stop, step) {
    if (step === void 0) {
      step = 1;
    }
    var range = [];
    start = this.ceil(start);
    step = Math.floor(step);
    if (start > stop || step <= 0) {
      return range;
    }
    var previous;
    do {
      previous = new Date(+start);
      range.push(previous);
      this._offset(start, step);
      this._floor(start);
    } while (previous < start && start < stop);
    return range;
  };
  // Returns an interval that is a subset of this interval.
  // For example, to create an interval that return 1st, 11th, 21st and 31st of each month:
  // day.filter(date => (date.getDate() - 1) % 10 === 0)
  TimeInterval.prototype.filter = function (test) {
    var _this = this;
    var floor = function floor(date) {
      if (date >= date) {
        while (_this._floor(date), !test(date)) {
          date.setTime(date.getTime() - 1);
        }
      }
      return date;
    };
    var offset = function offset(date, step) {
      if (date >= date) {
        if (step < 0) {
          while (++step <= 0) {
            do {
              _this._offset(date, -1);
            } while (!test(date));
          }
        } else {
          while (--step >= 0) {
            do {
              _this._offset(date, 1);
            } while (!test(date));
          }
        }
      }
      return date;
    };
    return new TimeInterval(floor, offset);
  };
  return TimeInterval;
}();
var CountableTimeInterval$1 = /** @class */function (_super) {
  __extends$63(CountableTimeInterval, _super);
  function CountableTimeInterval(floor, offset, count, field) {
    var _this = _super.call(this, floor, offset) || this;
    _this._count = count;
    _this._field = field;
    return _this;
  }
  /**
   * Returns the number of interval boundaries after start (exclusive) and before or equal to end (inclusive).
   * @param start
   * @param end
   */
  CountableTimeInterval.prototype.count = function (start, end) {
    t0$1.setTime(+start);
    t1$1.setTime(+end);
    this._floor(t0$1);
    this._floor(t1$1);
    return Math.floor(this._count(t0$1, t1$1));
  };
  /**
   * Returns a filtered view of this interval representing every step'th date.
   * The meaning of step is dependent on this interval’s parent interval as defined by the `field` function.
   * @param step
   */
  CountableTimeInterval.prototype.every = function (step) {
    var _this = this;
    var result;
    step = Math.floor(step);
    if (isFinite(step) && step > 0) {
      if (step > 1) {
        var field_1 = this._field;
        if (field_1) {
          result = this.filter(function (d) {
            return field_1(d) % step === 0;
          });
        } else {
          result = this.filter(function (d) {
            return _this.count(0, d) % step === 0;
          });
        }
      } else {
        result = this;
      }
    }
    return result;
  };
  return CountableTimeInterval;
}(TimeInterval$1);
function floor$d(date) {
  return date;
}
function offset$c(date, milliseconds) {
  date.setTime(date.getTime() + milliseconds);
}
function count$c(start, end) {
  return end.getTime() - start.getTime();
}
var millisecond$1 = new CountableTimeInterval$1(floor$d, offset$c, count$c);

// Common time unit sizes in milliseconds.
var durationSecond$1 = 1000;
var durationMinute$1 = durationSecond$1 * 60;
var durationHour$1 = durationMinute$1 * 60;
var durationDay$1 = durationHour$1 * 24;
var durationWeek$1 = durationDay$1 * 7;
var durationMonth$1 = durationDay$1 * 30;
var durationYear$1 = durationDay$1 * 365;
function floor$e(date) {
  date.setTime(date.getTime() - date.getMilliseconds());
}
function offset$d(date, seconds) {
  date.setTime(date.getTime() + seconds * durationSecond$1);
}
function count$d(start, end) {
  return (end.getTime() - start.getTime()) / durationSecond$1;
}
var second$1 = new CountableTimeInterval$1(floor$e, offset$d, count$d);
function floor$f(date) {
  date.setTime(date.getTime() - date.getMilliseconds() - date.getSeconds() * durationSecond$1);
}
function offset$e(date, minutes) {
  date.setTime(date.getTime() + minutes * durationMinute$1);
}
function count$e(start, end) {
  return (end.getTime() - start.getTime()) / durationMinute$1;
}
function field$a(date) {
  return date.getMinutes();
}
var minute$1 = new CountableTimeInterval$1(floor$f, offset$e, count$e, field$a);
function floor$g(date) {
  date.setTime(date.getTime() - date.getMilliseconds() - date.getSeconds() * durationSecond$1 - date.getMinutes() * durationMinute$1);
}
function offset$f(date, hours) {
  date.setTime(date.getTime() + hours * durationHour$1);
}
function count$f(start, end) {
  return (end.getTime() - start.getTime()) / durationHour$1;
}
function field$b(date) {
  return date.getHours();
}
var hour$1 = new CountableTimeInterval$1(floor$g, offset$f, count$f, field$b);
function floor$h(date) {
  date.setHours(0, 0, 0, 0);
}
function offset$g(date, days) {
  date.setDate(date.getDate() + days);
}
function count$g(start, end) {
  var tzMinuteDelta = end.getTimezoneOffset() - start.getTimezoneOffset();
  return (end.getTime() - start.getTime() - tzMinuteDelta * durationMinute$1) / durationDay$1;
}
function field$c(date) {
  return date.getDate() - 1;
}
var day$1 = new CountableTimeInterval$1(floor$h, offset$g, count$g, field$c);

// Set date to n-th day of the week.
function weekday$2(n) {
  // Sets the `date` to the start of the `n`-th day of the current week.
  // n == 0 is Sunday.
  function floor(date) {
    //                  1..31            1..7
    date.setDate(date.getDate() - (date.getDay() + 7 - n) % 7);
    date.setHours(0, 0, 0, 0); // h, m, s, ms
  }
  // Offset the date by the given number of weeks.
  function offset(date, weeks) {
    date.setDate(date.getDate() + weeks * 7);
  }
  // Count the number of weeks between the start and end dates.
  function count(start, end) {
    var msDelta = end.getTime() - start.getTime();
    var tzMinuteDelta = end.getTimezoneOffset() - start.getTimezoneOffset();
    return (msDelta - tzMinuteDelta * durationMinute$1) / durationWeek$1;
  }
  return new CountableTimeInterval$1(floor, offset, count);
}
var sunday$1 = weekday$2(0);
var monday$1 = weekday$2(1);
var tuesday$1 = weekday$2(2);
var wednesday$1 = weekday$2(3);
var thursday$1 = weekday$2(4);
var friday$1 = weekday$2(5);
var saturday$1 = weekday$2(6);
function floor$i(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}
function offset$h(date, months) {
  date.setMonth(date.getMonth() + months);
}
function count$h(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}
function field$d(date) {
  return date.getMonth();
}
var month$1 = new CountableTimeInterval$1(floor$i, offset$h, count$h, field$d);
function floor$j(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}
function offset$i(date, years) {
  date.setFullYear(date.getFullYear() + years);
}
function count$i(start, end) {
  return end.getFullYear() - start.getFullYear();
}
function field$e(date) {
  return date.getFullYear();
}
var year$1 = new CountableTimeInterval$1(floor$j, offset$i, count$i, field$e);
function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function complexBisectRight$1(list, x, map, lo, hi) {
  if (lo === void 0) {
    lo = 0;
  }
  if (hi === void 0) {
    hi = list.length;
  }
  var comparator = ascendingComparator$1(map);
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (comparator(list[mid], x) < 0) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }
  return lo;
}
function ascendingComparator$1(map) {
  return function (item, x) {
    return ascending$1(map(item), x);
  };
}
function floor$k(date) {
  date.setUTCHours(0, 0, 0, 0);
}
function offset$j(date, days) {
  date.setUTCDate(date.getUTCDate() + days);
}
function count$j(start, end) {
  return (end.getTime() - start.getTime()) / durationDay$1;
}
function field$f(date) {
  return date.getUTCDate() - 1;
}
var utcDay$1 = new CountableTimeInterval$1(floor$k, offset$j, count$j, field$f);
function floor$l(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}
function offset$k(date, years) {
  date.setUTCFullYear(date.getUTCFullYear() + years);
}
function count$k(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}
function field$g(date) {
  return date.getUTCFullYear();
}
var utcYear$1 = new CountableTimeInterval$1(floor$l, offset$k, count$k, field$g);

// Set date to n-th day of the week.
function weekday$3(n) {
  // Sets the `date` to the start of the `n`-th day of the current week.
  // n == 0 is Sunday.
  function floor(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - n) % 7);
    date.setHours(0, 0, 0, 0); // h, m, s, ms
  }
  // Offset the date by the given number of weeks.
  function offset(date, weeks) {
    date.setUTCDate(date.getUTCDate() + weeks * 7);
  }
  // Count the number of weeks between the start and end dates.
  function count(start, end) {
    return (end.getTime() - start.getTime()) / durationWeek$1;
  }
  return new CountableTimeInterval$1(floor, offset, count);
}
var utcSunday$1 = weekday$3(0);
var utcMonday$1 = weekday$3(1);
var utcTuesday$1 = weekday$3(2);
var utcWednesday$1 = weekday$3(3);
var utcThursday$1 = weekday$3(4);
var utcFriday$1 = weekday$3(5);
var utcSaturday$1 = weekday$3(6);
function localDate$1(d) {
  // For JS Dates the [0, 100) interval is a time warp, a fast forward to the 20th century.
  // For example, -1 is -0001 BC, 0 is already 1900 AD.
  if (d.y >= 0 && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate$1(d) {
  if (d.y >= 0 && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
/**
 * Creates a lookup map for array of names to go from a name to index.
 * @param names
 */
function formatLookup$1(names) {
  var map = {};
  for (var i = 0, n = names.length; i < n; i++) {
    map[names[i].toLowerCase()] = i;
  }
  return map;
}
function newYear$1(y) {
  return {
    y: y,
    m: 0,
    d: 1,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
var percentCharCode$1 = 37;
var numberRe$1 = /^\s*\d+/; // ignores next directive
var percentRe$1 = /^%/;
var requoteRe$1 = /[\\^$*+?|[\]().{}]/g;
/**
 * Prepends any character in the `requoteRe` set with a backslash.
 * @param s
 */
var requote$1 = function requote$1(s) {
  return s.replace(requoteRe$1, '\\$&');
}; // $& - matched substring
/**
 * Returns a RegExp that matches any string that starts with any of the given names (case insensitive).
 * @param names
 */
var formatRe$1 = function formatRe$1(names) {
  return new RegExp('^(?:' + names.map(requote$1).join('|') + ')', 'i');
};
// A map of padding modifiers to padding strings. Default is `0`.
var pads$1 = {
  '-': '',
  '_': ' ',
  '0': '0'
};
function pad$1(value, fill, width) {
  var sign = value < 0 ? '-' : '';
  var string = String(sign ? -value : value);
  var length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
/**
 * Create a new time-locale-based object which exposes time-formatting
 * methods for the specified locale definition.
 *
 * @param timeLocale A time locale definition.
 */
function formatLocale$3(timeLocale) {
  var lDateTime = timeLocale.dateTime;
  var lDate = timeLocale.date;
  var lTime = timeLocale.time;
  var lPeriods = timeLocale.periods;
  var lWeekdays = timeLocale.days;
  var lShortWeekdays = timeLocale.shortDays;
  var lMonths = timeLocale.months;
  var lShortMonths = timeLocale.shortMonths;
  var periodRe = formatRe$1(lPeriods);
  var periodLookup = formatLookup$1(lPeriods);
  var weekdayRe = formatRe$1(lWeekdays);
  var weekdayLookup = formatLookup$1(lWeekdays);
  var shortWeekdayRe = formatRe$1(lShortWeekdays);
  var shortWeekdayLookup = formatLookup$1(lShortWeekdays);
  var monthRe = formatRe$1(lMonths);
  var monthLookup = formatLookup$1(lMonths);
  var shortMonthRe = formatRe$1(lShortMonths);
  var shortMonthLookup = formatLookup$1(lShortMonths);
  var formats = {
    'a': formatShortWeekday,
    'A': formatWeekday,
    'b': formatShortMonth,
    'B': formatMonth,
    'c': undefined,
    'd': formatDayOfMonth,
    'e': formatDayOfMonth,
    'f': formatMicroseconds,
    'H': formatHour24,
    'I': formatHour12,
    'j': formatDayOfYear,
    'L': formatMilliseconds,
    'm': formatMonthNumber,
    'M': formatMinutes,
    'p': formatPeriod,
    'Q': formatUnixTimestamp,
    's': formatUnixTimestampSeconds,
    'S': formatSeconds,
    'u': formatWeekdayNumberMonday,
    'U': formatWeekNumberSunday,
    'V': formatWeekNumberISO,
    'w': formatWeekdayNumberSunday,
    'W': formatWeekNumberMonday,
    'x': undefined,
    'X': undefined,
    'y': formatYear,
    'Y': formatFullYear,
    'Z': formatZone,
    '%': formatLiteralPercent
  };
  var utcFormats = {
    'a': formatUTCShortWeekday,
    'A': formatUTCWeekday,
    'b': formatUTCShortMonth,
    'B': formatUTCMonth,
    'c': undefined,
    'd': formatUTCDayOfMonth,
    'e': formatUTCDayOfMonth,
    'f': formatUTCMicroseconds,
    'H': formatUTCHour24,
    'I': formatUTCHour12,
    'j': formatUTCDayOfYear,
    'L': formatUTCMilliseconds,
    'm': formatUTCMonthNumber,
    'M': formatUTCMinutes,
    'p': formatUTCPeriod,
    'Q': formatUnixTimestamp,
    's': formatUnixTimestampSeconds,
    'S': formatUTCSeconds,
    'u': formatUTCWeekdayNumberMonday,
    'U': formatUTCWeekNumberSunday,
    'V': formatUTCWeekNumberISO,
    'w': formatUTCWeekdayNumberSunday,
    'W': formatUTCWeekNumberMonday,
    'x': undefined,
    'X': undefined,
    'y': formatUTCYear,
    'Y': formatUTCFullYear,
    'Z': formatUTCZone,
    '%': formatLiteralPercent
  };
  var parses = {
    'a': parseShortWeekday,
    'A': parseWeekday,
    'b': parseShortMonth,
    'B': parseMonth,
    'c': parseLocaleDateTime,
    'd': parseDayOfMonth,
    'e': parseDayOfMonth,
    'f': parseMicroseconds,
    'H': parseHour24,
    'I': parseHour24,
    'j': parseDayOfYear,
    'L': parseMilliseconds,
    'm': parseMonthNumber,
    'M': parseMinutes,
    'p': parsePeriod,
    'Q': parseUnixTimestamp,
    's': parseUnixTimestampSeconds,
    'S': parseSeconds,
    'u': parseWeekdayNumberMonday,
    'U': parseWeekNumberSunday,
    'V': parseWeekNumberISO,
    'w': parseWeekdayNumberSunday,
    'W': parseWeekNumberMonday,
    'x': parseLocaleDate,
    'X': parseLocaleTime,
    'y': parseYear,
    'Y': parseFullYear,
    'Z': parseZone,
    '%': parseLiteralPercent
  };
  // Recursive definitions.
  formats.x = newFormat(lDate, formats);
  formats.X = newFormat(lTime, formats);
  formats.c = newFormat(lDateTime, formats);
  utcFormats.x = newFormat(lDate, utcFormats);
  utcFormats.X = newFormat(lTime, utcFormats);
  utcFormats.c = newFormat(lDateTime, utcFormats);
  function newParse(specifier, newDate) {
    return function (str) {
      var d = newYear$1(1900);
      var i = parseSpecifier(d, specifier, str += '', 0);
      if (i != str.length) {
        return undefined;
      }
      // If a UNIX timestamp is specified, return it.
      if ('Q' in d) {
        return new Date(d.Q);
      }
      // The am-pm flag is 0 for AM, and 1 for PM.
      if ('p' in d) {
        d.H = d.H % 12 + d.p * 12;
      }
      // Convert day-of-week and week-of-year to day-of-year.
      if ('V' in d) {
        if (d.V < 1 || d.V > 53) {
          return undefined;
        }
        if (!('w' in d)) {
          d.w = 1;
        }
        if ('Z' in d) {
          var week = utcDate$1(newYear$1(d.y));
          var day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday$1.ceil(week) : utcMonday$1.floor(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          var week = newDate(newYear$1(d.y));
          var day = week.getDay();
          week = day > 4 || day === 0 ? monday$1.ceil(week) : monday$1.floor(week);
          week = day$1.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ('W' in d || 'U' in d) {
        if (!('w' in d)) {
          d.w = 'u' in d ? d.u % 7 : 'W' in d ? 1 : 0;
        }
        var day = 'Z' in d ? utcDate$1(newYear$1(d.y)).getUTCDay() : newDate(newYear$1(d.y)).getDay();
        d.m = 0;
        d.d = 'W' in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }
      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ('Z' in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate$1(d);
      }
      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }
  /**
   * Creates a new function that formats the given Date or timestamp according to specifier.
   * @param specifier
   * @param formats
   */
  function newFormat(specifier, formats) {
    return function (date) {
      var string = [];
      var n = specifier.length;
      var i = -1;
      var j = 0;
      if (!(date instanceof Date)) {
        date = new Date(+date);
      }
      while (++i < n) {
        if (specifier.charCodeAt(i) === percentCharCode$1) {
          string.push(specifier.slice(j, i)); // copy the chunks of specifier with no directives as is
          var c = specifier.charAt(++i);
          var pad_1 = pads$1[c];
          if (pad_1 != undefined) {
            // if format directive has a padding modifier in front of it
            c = specifier.charAt(++i); // fetch the directive itself
          } else {
            pad_1 = c === 'e' ? ' ' : '0'; // use the default padding modifier
          }

          var format = formats[c];
          if (format) {
            // if the directive has a corresponding formatting function
            c = format(date, pad_1); // replace the directive with the formatted date
          }

          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join('');
    };
  }
  // Simultaneously walks over the specifier and the parsed string, populating the `d` map with parsed values.
  // The returned number is expected to equal the length of the parsed `string`, if parsing succeeded.
  function parseSpecifier(d, specifier, string, j) {
    // i - `specifier` string index
    // j - parsed `string` index
    var i = 0;
    var n = specifier.length;
    var m = string.length;
    while (i < n) {
      if (j >= m) {
        return -1;
      }
      var code = specifier.charCodeAt(i++);
      if (code === percentCharCode$1) {
        var char = specifier.charAt(i++);
        var parse = parses[char in pads$1 ? specifier.charAt(i++) : char];
        if (!parse || (j = parse(d, string, j)) < 0) {
          return -1;
        }
      } else if (code != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  // ----------------------------- formats ----------------------------------
  function formatMicroseconds(date, fill) {
    return formatMilliseconds(date, fill) + '000';
  }
  function formatMilliseconds(date, fill) {
    return pad$1(date.getMilliseconds(), fill, 3);
  }
  function formatSeconds(date, fill) {
    return pad$1(date.getSeconds(), fill, 2);
  }
  function formatMinutes(date, fill) {
    return pad$1(date.getMinutes(), fill, 2);
  }
  function formatHour12(date, fill) {
    return pad$1(date.getHours() % 12 || 12, fill, 2);
  }
  function formatHour24(date, fill) {
    return pad$1(date.getHours(), fill, 2);
  }
  function formatPeriod(date) {
    return lPeriods[date.getHours() >= 12 ? 1 : 0];
  }
  function formatShortWeekday(date) {
    return lShortWeekdays[date.getDay()];
  }
  function formatWeekday(date) {
    return lWeekdays[date.getDay()];
  }
  function formatWeekdayNumberMonday(date) {
    var dayOfWeek = date.getDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
  }
  function formatWeekNumberSunday(date, fill) {
    return pad$1(sunday$1.count(year$1.floor(date), date), fill, 2);
  }
  function formatWeekNumberISO(date, fill) {
    var day = date.getDay();
    date = day >= 4 || day === 0 ? thursday$1.floor(date) : thursday$1.ceil(date);
    var yearStart = year$1.floor(date);
    return pad$1(thursday$1.count(yearStart, date) + (yearStart.getDay() === 4 ? 1 : 0), fill, 2);
  }
  function formatWeekdayNumberSunday(date) {
    return date.getDay();
  }
  function formatWeekNumberMonday(date, fill) {
    return pad$1(monday$1.count(year$1.floor(date), date), fill, 2);
  }
  function formatDayOfMonth(date, fill) {
    return pad$1(date.getDate(), fill, 2);
  }
  function formatDayOfYear(date, fill) {
    return pad$1(1 + day$1.count(year$1.floor(date), date), fill, 3);
  }
  function formatShortMonth(date) {
    return lShortMonths[date.getMonth()];
  }
  function formatMonth(date) {
    return lMonths[date.getMonth()];
  }
  function formatMonthNumber(date, fill) {
    return pad$1(date.getMonth() + 1, fill, 2);
  }
  function formatYear(date, fill) {
    return pad$1(date.getFullYear() % 100, fill, 2);
  }
  function formatFullYear(date, fill) {
    return pad$1(date.getFullYear() % 10000, fill, 4);
  }
  function formatZone(date) {
    var z = date.getTimezoneOffset();
    return (z > 0 ? '-' : (z *= -1, '+')) + pad$1(Math.floor(z / 60), '0', 2) + pad$1(z % 60, '0', 2);
  }
  // -------------------------- UTC formats -----------------------------------
  function formatUTCMicroseconds(date, fill) {
    return formatUTCMilliseconds(date, fill) + '000';
  }
  function formatUTCMilliseconds(date, fill) {
    return pad$1(date.getUTCMilliseconds(), fill, 3);
  }
  function formatUTCSeconds(date, fill) {
    return pad$1(date.getUTCSeconds(), fill, 2);
  }
  function formatUTCMinutes(date, fill) {
    return pad$1(date.getUTCMinutes(), fill, 2);
  }
  function formatUTCHour12(date, fill) {
    return pad$1(date.getUTCHours() % 12 || 12, fill, 2);
  }
  function formatUTCHour24(date, fill) {
    return pad$1(date.getUTCHours(), fill, 2);
  }
  function formatUTCPeriod(date) {
    return lPeriods[date.getUTCHours() >= 12 ? 1 : 0];
  }
  function formatUTCDayOfMonth(date, fill) {
    return pad$1(date.getUTCDate(), fill, 2);
  }
  function formatUTCDayOfYear(date, fill) {
    return pad$1(1 + utcDay$1.count(utcYear$1.floor(date), date), fill, 3);
  }
  function formatUTCMonthNumber(date, fill) {
    return pad$1(date.getUTCMonth() + 1, fill, 2);
  }
  function formatUTCShortMonth(date) {
    return lShortMonths[date.getUTCMonth()];
  }
  function formatUTCMonth(date) {
    return lMonths[date.getUTCMonth()];
  }
  function formatUTCShortWeekday(date) {
    return lShortWeekdays[date.getUTCDay()];
  }
  function formatUTCWeekday(date) {
    return lWeekdays[date.getUTCDay()];
  }
  function formatUTCWeekdayNumberMonday(date) {
    var dayOfWeek = date.getUTCDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
  }
  function formatUTCWeekNumberSunday(date, fill) {
    return pad$1(utcSunday$1.count(utcYear$1.floor(date), date), fill, 2);
  }
  function formatUTCWeekNumberISO(date, fill) {
    var day = date.getUTCDay();
    date = day >= 4 || day === 0 ? utcThursday$1.floor(date) : utcThursday$1.ceil(date);
    var yearStart = utcYear$1.floor(date);
    return pad$1(utcThursday$1.count(yearStart, date) + (yearStart.getUTCDay() === 4 ? 1 : 0), fill, 4);
  }
  function formatUTCWeekdayNumberSunday(date) {
    return date.getUTCDay();
  }
  function formatUTCWeekNumberMonday(date, fill) {
    return pad$1(utcMonday$1.count(utcYear$1.floor(date), date), fill, 2);
  }
  function formatUTCYear(date, fill) {
    return pad$1(date.getUTCFullYear() % 100, fill, 2);
  }
  function formatUTCFullYear(date, fill) {
    return pad$1(date.getUTCFullYear() % 10000, fill, 4);
  }
  function formatUTCZone() {
    return '+0000';
  }
  function formatLiteralPercent(date) {
    return '%';
  }
  function formatUnixTimestamp(date) {
    return date.getTime();
  }
  function formatUnixTimestampSeconds(date) {
    return Math.floor(date.getTime() / 1000);
  }
  // ------------------------------- parsers ------------------------------------
  function parseMicroseconds(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(parseFloat(n[0]) / 1000), i + n[0].length) : -1;
  }
  function parseMilliseconds(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
  }
  function parseSeconds(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
  }
  function parseMinutes(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
  }
  function parseHour24(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseDayOfMonth(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
  }
  function parseDayOfYear(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberSunday(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberISO(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
  }
  function parseWeekNumberMonday(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
  }
  function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }
  function parseMonthNumber(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.m = parseFloat(n[0]) - 1, i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, lDateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, lDate, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, lTime, string, i);
  }
  function parseUnixTimestamp(d, string, i) {
    var n = numberRe$1.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
  }
  function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe$1.exec(string.slice(i));
    return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
  }
  function parseYear(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
  }
  function parseFullYear(d, string, i) {
    var n = numberRe$1.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
  }
  function parseZone(d, string, i) {
    var n = /^(Z)|^([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || '00')), i + n[0].length) : -1;
  }
  function parseLiteralPercent(d, string, i) {
    var n = percentRe$1.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  return {
    format: function format(specifier) {
      var f = newFormat(specifier, formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function parse(specifier) {
      var p = newParse(specifier, localDate$1);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function utcFormat(specifier) {
      var f = newFormat(specifier, utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function utcParse(specifier) {
      var p = newParse(specifier, utcDate$1);
      p.toString = function () {
        return specifier;
      };
      return p;
    }
  };
}
var locale$1;
setDefaultLocale$1({
  dateTime: '%x, %X',
  date: '%-m/%-d/%Y',
  time: '%-I:%M:%S %p',
  periods: ['AM', 'PM'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
});
function setDefaultLocale$1(definition) {
  return locale$1 = formatLocale$3(definition);
}
var __extends$64 = undefined && undefined.__extends || function () {
  var _extendStatics397 = function extendStatics(d, b) {
    _extendStatics397 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics397(d, b);
  };
  return function (d, b) {
    _extendStatics397(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var TimeScale$1 = /** @class */function (_super) {
  __extends$64(TimeScale, _super);
  function TimeScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'time';
    _this.year = year$1;
    _this.month = month$1;
    _this.week = sunday$1;
    _this.day = day$1;
    _this.hour = hour$1;
    _this.minute = minute$1;
    _this.second = second$1;
    _this.millisecond = millisecond$1;
    _this.format = locale$1.format;
    /**
     * Array of default tick intervals in the following format:
     *
     *     [
     *         interval (unit of time),
     *         number of units (step),
     *         the length of that number of units in milliseconds
     *     ]
     */
    _this.tickIntervals = [[_this.second, 1, durationSecond$1], [_this.second, 5, 5 * durationSecond$1], [_this.second, 15, 15 * durationSecond$1], [_this.second, 30, 30 * durationSecond$1], [_this.minute, 1, durationMinute$1], [_this.minute, 5, 5 * durationMinute$1], [_this.minute, 15, 15 * durationMinute$1], [_this.minute, 30, 30 * durationMinute$1], [_this.hour, 1, durationHour$1], [_this.hour, 3, 3 * durationHour$1], [_this.hour, 6, 6 * durationHour$1], [_this.hour, 12, 12 * durationHour$1], [_this.day, 1, durationDay$1], [_this.day, 2, 2 * durationDay$1], [_this.week, 1, durationWeek$1], [_this.month, 1, durationMonth$1], [_this.month, 3, 3 * durationMonth$1], [_this.year, 1, durationYear$1]];
    _this.formatMillisecond = _this.format('.%L');
    _this.formatSecond = _this.format(':%S');
    _this.formatMinute = _this.format('%I:%M');
    _this.formatHour = _this.format('%I %p');
    _this.formatDay = _this.format('%a %d');
    _this.formatWeek = _this.format('%b %d');
    _this.formatMonth = _this.format('%B');
    _this.formatYear = _this.format('%Y');
    _this._domain = [new Date(2000, 0, 1), new Date(2000, 0, 2)];
    return _this;
  }
  TimeScale.prototype.defaultTickFormat = function (date) {
    return (this.second.floor(date) < date ? this.formatMillisecond : this.minute.floor(date) < date ? this.formatSecond : this.hour.floor(date) < date ? this.formatMinute : this.day.floor(date) < date ? this.formatHour : this.month.floor(date) < date ? this.week.floor(date) < date ? this.formatDay : this.formatWeek : this.year.floor(date) < date ? this.formatMonth : this.formatYear)(date);
  };
  /**
   *
   * @param interval If the `interval` is a number, it's interpreted as the desired tick count
   * and the method tries to pick an appropriate interval automatically, based on the extent of the domain.
   * If the `interval` is `undefined`, it defaults to `10`.
   * If the `interval` is a time interval, simply use it.
   * @param start The start time (timestamp).
   * @param stop The end time (timestamp).
   * @param step Number of intervals between ticks.
   */
  TimeScale.prototype.tickInterval = function (interval, start, stop, step) {
    var _a;
    if (typeof interval === 'number') {
      var tickCount = interval;
      var tickIntervals = this.tickIntervals;
      var target = Math.abs(stop - start) / tickCount;
      var i = complexBisectRight$1(tickIntervals, target, function (interval) {
        return interval[2];
      });
      if (i === tickIntervals.length) {
        step = tickStep$1(start / durationYear$1, stop / durationYear$1, tickCount);
        interval = this.year;
      } else if (i) {
        _a = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], interval = _a[0], step = _a[1];
      } else {
        step = Math.max(tickStep$1(start, stop, interval), 1);
        interval = this.millisecond;
      }
    }
    return step == undefined ? interval : interval.every(step);
  };
  Object.defineProperty(TimeScale.prototype, "domain", {
    get: function get() {
      return _super.prototype.getDomain.call(this).map(function (t) {
        return new Date(t);
      });
    },
    set: function set(values) {
      _super.prototype.setDomain.call(this, Array.prototype.map.call(values, function (t) {
        return t instanceof Date ? +t : +new Date(+t);
      }));
    },
    enumerable: true,
    configurable: true
  });
  TimeScale.prototype.invert = function (y) {
    return new Date(_super.prototype.invert.call(this, y));
  };
  /**
   * Returns uniformly-spaced dates that represent the scale's domain.
   * @param interval The desired tick count or a time interval object.
   */
  TimeScale.prototype.ticks = function (interval) {
    if (interval === void 0) {
      interval = 10;
    }
    var d = _super.prototype.getDomain.call(this);
    var t0 = d[0];
    var t1 = d[d.length - 1];
    var reverse = t1 < t0;
    if (reverse) {
      var _ = t0;
      t0 = t1;
      t1 = _;
    }
    var t = this.tickInterval(interval, t0, t1);
    var i = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return reverse ? i.reverse() : i;
  };
  /**
   * Returns a time format function suitable for displaying tick values.
   * @param count Ignored. Used only to satisfy the {@link Scale} interface.
   * @param specifier If the specifier string is provided, this method is equivalent to
   * the {@link TimeLocaleObject.format} method.
   * If no specifier is provided, this method returns the default time format function.
   */
  TimeScale.prototype.tickFormat = function (count, specifier) {
    return specifier == undefined ? this.defaultTickFormat.bind(this) : this.format(specifier);
  };
  /**
   * Extends the domain so that it starts and ends on nice round values.
   * This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value.
   * @param interval
   */
  TimeScale.prototype.nice = function (interval) {
    if (interval === void 0) {
      interval = 10;
    }
    var d = _super.prototype.getDomain.call(this);
    var i = this.tickInterval(interval, d[0], d[d.length - 1]);
    if (i) {
      this.domain = this._nice(d, i);
    }
  };
  TimeScale.prototype._nice = function (domain, interval) {
    var _a, _b;
    domain = domain.slice();
    var i0 = 0;
    var i1 = domain.length - 1;
    var x0 = domain[i0];
    var x1 = domain[i1];
    if (x1 < x0) {
      _a = [i1, i0], i0 = _a[0], i1 = _a[1];
      _b = [x1, x0], x0 = _b[0], x1 = _b[1];
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
  };
  return TimeScale;
}(ContinuousScale$1);

// Custom `Array.find` implementation for legacy browsers.
function identity$6(value) {
  return value;
}
function extent$1(values, predicate, map) {
  var transform = map || identity$6;
  var n = values.length;
  var i = -1;
  var value;
  var min;
  var max;
  while (++i < n) {
    // Find the first value.
    value = values[i];
    if (predicate(value)) {
      min = max = value;
      while (++i < n) {
        // Compare the remaining values.
        value = values[i];
        if (predicate(value)) {
          if (min > value) {
            min = value;
          }
          if (max < value) {
            max = value;
          }
        }
      }
    }
  }
  return min === undefined || max === undefined ? undefined : [transform(min), transform(max)];
}
var __extends$65 = undefined && undefined.__extends || function () {
  var _extendStatics398 = function extendStatics(d, b) {
    _extendStatics398 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics398(d, b);
  };
  return function (d, b) {
    _extendStatics398(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SparklineAxis = /** @class */function (_super) {
  __extends$65(SparklineAxis, _super);
  function SparklineAxis() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'category';
    _this.stroke = 'rgb(204, 214, 235)';
    _this.strokeWidth = 1;
    return _this;
  }
  return SparklineAxis;
}(Observable$1);
var Sparkline = /** @class */function (_super) {
  __extends$65(Sparkline, _super);
  function Sparkline() {
    var _this = _super.call(this) || this;
    _this.id = createId$1(_this);
    _this.seriesRect = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    _this._context = undefined;
    _this._container = undefined;
    _this._data = undefined;
    _this.padding = new Padding$1(3);
    _this.xKey = 'x';
    _this.yKey = 'y';
    _this.dataType = undefined;
    _this.xData = [];
    _this.yData = [];
    // Minimum y value in provided data.
    _this.min = undefined;
    // Maximum y value in provided data.
    _this.max = undefined;
    _this.yScale = new LinearScale$1();
    _this.axis = new SparklineAxis();
    _this.highlightStyle = {
      size: 6,
      fill: 'yellow',
      stroke: 'silver',
      strokeWidth: 1
    };
    _this._width = 100;
    _this._height = 100;
    _this.layoutId = 0;
    _this.defaultDateFormatter = locale$1.format('%m/%d/%y, %H:%M:%S');
    _this._onMouseMove = _this.onMouseMove.bind(_this);
    _this._onMouseOut = _this.onMouseOut.bind(_this);
    var root = new Group$1();
    _this.rootGroup = root;
    var element = document.createElement('div');
    element.setAttribute('class', 'ag-sparkline-wrapper');
    var scene = new Scene$1(document);
    _this.scene = scene;
    _this.canvasElement = scene.canvas.element;
    scene.root = root;
    scene.container = element;
    scene.resize(_this.width, _this.height);
    _this.seriesRect.width = _this.width;
    _this.seriesRect.height = _this.height;
    // one style element for tooltip styles per document
    if (Sparkline.tooltipDocuments.indexOf(document) === -1) {
      var styleElement = document.createElement('style');
      styleElement.innerHTML = defaultTooltipCss$1;
      document.head.insertBefore(styleElement, document.head.querySelector('style'));
      Sparkline.tooltipDocuments.push(document);
    }
    _this.setupDomEventListeners(_this.scene.canvas.element);
    return _this;
  }
  Object.defineProperty(Sparkline.prototype, "context", {
    get: function get() {
      return this._context;
    },
    set: function set(value) {
      if (this._context !== value) {
        this._context = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sparkline.prototype, "container", {
    get: function get() {
      return this._container;
    },
    set: function set(value) {
      if (this._container !== value) {
        var parentNode = this.canvasElement.parentNode;
        if (parentNode != null) {
          parentNode.removeChild(this.canvasElement);
        }
        if (value) {
          value.appendChild(this.canvasElement);
        }
        this._container = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sparkline.prototype, "data", {
    get: function get() {
      return this._data;
    },
    set: function set(value) {
      if (this._data !== value) {
        this._data = value;
        this.processData();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sparkline.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.scene.resize(value, this.height);
        this.scheduleLayout();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Sparkline.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.scene.resize(this.width, value);
        this.scheduleLayout();
      }
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Generate node data from processed data.
   * Produce data joins.
   * Update selection's nodes using node data.
   */
  Sparkline.prototype.update = function () {};
  // Update y scale based on processed data.
  Sparkline.prototype.updateYScale = function () {
    this.updateYScaleRange();
    this.updateYScaleDomain();
  };
  // Update y scale domain based on processed data.
  Sparkline.prototype.updateYScaleDomain = function () {};
  // Update y scale range based on height and padding (seriesRect).
  Sparkline.prototype.updateYScaleRange = function () {
    var _a = this,
      yScale = _a.yScale,
      seriesRect = _a.seriesRect;
    yScale.range = [seriesRect.height, 0];
  };
  // Update x scale based on processed data.
  Sparkline.prototype.updateXScale = function () {
    var type = this.axis.type;
    this.xScale = this.getXScale(type);
    this.updateXScaleRange();
    this.updateXScaleDomain();
  };
  // Update x scale range based on width and padding (seriesRect).
  Sparkline.prototype.updateXScaleRange = function () {
    var seriesRect = this.seriesRect;
    this.xScale.range = [0, seriesRect.width];
  };
  // Update x scale domain based on processed data and type of scale.
  Sparkline.prototype.updateXScaleDomain = function () {
    var _a = this,
      xData = _a.xData,
      xScale = _a.xScale;
    var xMinMax;
    if (xScale instanceof LinearScale$1) {
      xMinMax = extent$1(xData, isNumber$1);
    } else if (xScale instanceof TimeScale$1) {
      xMinMax = extent$1(xData, isContinuous$1);
    }
    this.xScale.domain = xMinMax ? xMinMax.slice() : xData;
  };
  /**
  * Return xScale instance based on the provided type or return a `BandScale` by default.
  * The default type is `category`.
  * @param type
  */
  Sparkline.prototype.getXScale = function (type) {
    if (type === void 0) {
      type = 'category';
    }
    switch (type) {
      case 'number':
        return new LinearScale$1();
      case 'time':
        return new TimeScale$1();
      case 'category':
      default:
        return new BandScale$1();
    }
  };
  // Update axis line.
  Sparkline.prototype.updateAxisLine = function () {};
  Sparkline.prototype.updateAxes = function () {
    this.updateYScale();
    this.updateXScale();
    this.updateAxisLine();
  };
  // Using processed data, generate data that backs visible nodes.
  Sparkline.prototype.generateNodeData = function () {
    return [];
  };
  // Returns persisted node data associated with the sparkline's data.
  Sparkline.prototype.getNodeData = function () {
    return [];
  };
  // Update the selection's nodes.
  Sparkline.prototype.updateNodes = function () {};
  Sparkline.prototype.highlightDatum = function (closestDatum) {
    this.updateNodes();
  };
  Sparkline.prototype.dehighlightDatum = function () {
    this.highlightedDatum = undefined;
    this.updateNodes();
  };
  /**
   * Highlight closest datum and display tooltip if enabled.
   * Only update if necessary, i.e. only update if the highlighted datum is different from previously highlighted datum,
   * or if there is no previously highlighted datum.
   * @param event
   */
  Sparkline.prototype.onMouseMove = function (event) {
    var closestDatum = this.pickClosestSeriesNodeDatum(event.offsetX, event.offsetY);
    if (!closestDatum) {
      return;
    }
    var oldHighlightedDatum = this.highlightedDatum;
    this.highlightedDatum = closestDatum;
    if (this.highlightedDatum && !oldHighlightedDatum || this.highlightedDatum && oldHighlightedDatum && this.highlightedDatum !== oldHighlightedDatum) {
      this.highlightDatum(closestDatum);
      if (this.tooltip.enabled) {
        this.handleTooltip(closestDatum);
      }
    }
  };
  /**
   * Dehighlight all nodes and remove tooltip.
   * @param event
   */
  Sparkline.prototype.onMouseOut = function (event) {
    this.dehighlightDatum();
    this.tooltip.toggle(false);
  };
  // Fetch required values from the data object and process them.
  Sparkline.prototype.processData = function () {
    var _a = this,
      data = _a.data,
      yData = _a.yData,
      xData = _a.xData;
    if (!data) {
      return;
    }
    yData.length = 0;
    xData.length = 0;
    var n = data.length;
    var dataType = this.getDataType(data);
    this.dataType = dataType;
    var xValueType = this.axis.type;
    var xType = xValueType !== 'number' && xValueType !== 'time' ? 'category' : xValueType;
    if (dataType === 'number') {
      for (var i = 0; i < n; i++) {
        var xDatum = i;
        var yDatum = data[i];
        var x = this.getDatum(xDatum, xType);
        var y = this.getDatum(yDatum, 'number');
        xData.push(x);
        yData.push(y);
      }
    } else if (dataType === 'array') {
      for (var i = 0; i < n; i++) {
        var datum = data[i];
        if (Array.isArray(datum)) {
          var xDatum = datum[0];
          var yDatum = datum[1];
          var x = this.getDatum(xDatum, xType);
          var y = this.getDatum(yDatum, 'number');
          if (x == undefined) {
            continue;
          }
          xData.push(x);
          yData.push(y);
        }
      }
    } else if (dataType === 'object') {
      var _b = this,
        yKey = _b.yKey,
        xKey = _b.xKey;
      for (var i = 0; i < n; i++) {
        var datum = data[i];
        if (typeof datum === 'object' && !Array.isArray(datum)) {
          var xDatum = datum[xKey];
          var yDatum = datum[yKey];
          var x = this.getDatum(xDatum, xType);
          var y = this.getDatum(yDatum, 'number');
          if (x == undefined) {
            continue;
          }
          xData.push(x);
          yData.push(y);
        }
      }
    }
    // update axes
    this.updateAxes();
    // produce data joins and update selection's nodes
    this.update();
  };
  /**
  * Return the type of data provided to the sparkline based on the first truthy value in the data array.
  * If the value is not a number, array or object, return `undefined`.
  * @param data
  */
  Sparkline.prototype.getDataType = function (data) {
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
      var datum = data_1[_i];
      if (datum) {
        if (isNumber$1(datum)) {
          return 'number';
        } else if (Array.isArray(datum)) {
          return 'array';
        } else if (typeof datum === 'object') {
          return 'object';
        }
      }
    }
  };
  /**
  * Return the given value depending on the type of axis.
  * Return `undefined` if the value is invalid for the given axis type.
  * @param value
  */
  Sparkline.prototype.getDatum = function (value, type) {
    if (type === 'number' && isNumber$1(value) || type === 'time' && (isNumber$1(value) || isDate$1(value))) {
      return value;
    } else if (type === 'category') {
      if (isString$1(value) || isDate$1(value) || isNumber$1(value)) {
        return {
          toString: function toString() {
            return String(value);
          }
        };
      } else if (isStringObject$1(value)) {
        return value;
      }
    }
  };
  Object.defineProperty(Sparkline.prototype, "layoutScheduled", {
    /**
     * Only `true` while we are waiting for the layout to start.
     * This will be `false` if the layout has already started and is ongoing.
     */
    get: function get() {
      return !!this.layoutId;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Execute update method on the next available screen repaint to make changes to the canvas.
   * If we are waiting for a layout to start and a new layout is requested,
   * cancel the previous layout using the non 0 integer (this.layoutId) returned from requestAnimationFrame.
   */
  Sparkline.prototype.scheduleLayout = function () {
    var _this = this;
    if (this.layoutId) {
      cancelAnimationFrame(this.layoutId);
    }
    this.layoutId = requestAnimationFrame(function () {
      var _a = _this,
        width = _a.width,
        height = _a.height,
        padding = _a.padding,
        seriesRect = _a.seriesRect,
        rootGroup = _a.rootGroup;
      var shrunkWidth = width - padding.left - padding.right;
      var shrunkHeight = height - padding.top - padding.bottom;
      seriesRect.width = shrunkWidth;
      seriesRect.height = shrunkHeight;
      seriesRect.x = padding.left;
      seriesRect.y = padding.top;
      rootGroup.translationX = seriesRect.x;
      rootGroup.translationY = seriesRect.y;
      // update axes ranges
      _this.updateXScaleRange();
      _this.updateYScaleRange();
      // update axis line
      _this.updateAxisLine();
      // produce data joins and update selection's nodes
      _this.update();
      _this.layoutId = 0;
    });
  };
  /**
   * Return the closest data point to x/y canvas coordinates.
   * @param x
   * @param y
   */
  Sparkline.prototype.pickClosestSeriesNodeDatum = function (x, y) {
    function getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    }
    var minDistance = Infinity;
    var closestDatum;
    var hitPoint = this.rootGroup.transformPoint(x, y);
    this.getNodeData().forEach(function (datum) {
      if (!datum.point) {
        return;
      }
      var distance = getDistance(hitPoint, datum.point);
      if (distance < minDistance) {
        minDistance = distance;
        closestDatum = datum;
      }
    });
    return closestDatum;
  };
  /**
   * calculate x/y coordinates for tooltip based on coordinates of highlighted datum, position of canvas and page offset.
   * @param datum
   */
  Sparkline.prototype.handleTooltip = function (datum) {
    var seriesDatum = datum.seriesDatum;
    var canvasElement = this.canvasElement;
    var canvasRect = canvasElement.getBoundingClientRect();
    var pageXOffset = window.pageXOffset,
      pageYOffset = window.pageYOffset;
    // pickClosestSeriesNodeDatum only returns datum with point
    var point = this.rootGroup.inverseTransformPoint(datum.point.x, datum.point.y);
    var meta = {
      pageX: point.x + canvasRect.left + pageXOffset,
      pageY: point.y + canvasRect.top + pageYOffset
    };
    var yValue = seriesDatum.y;
    var xValue = seriesDatum.x;
    // check if tooltip is enabled for this specific data point
    var enabled = this.tooltip.enabled;
    if (this.tooltip.renderer) {
      var tooltipRendererResult = this.tooltip.renderer({
        context: this.context,
        datum: seriesDatum,
        yValue: yValue,
        xValue: xValue
      });
      enabled = typeof tooltipRendererResult !== 'string' && tooltipRendererResult.enabled !== undefined ? tooltipRendererResult.enabled : enabled;
    }
    var html = enabled && seriesDatum.y !== undefined && this.getTooltipHtml(datum);
    if (html) {
      this.tooltip.show(meta, html);
    }
  };
  Sparkline.prototype.formatNumericDatum = function (datum) {
    return String(Math.round(datum * 10) / 10);
  };
  Sparkline.prototype.formatDatum = function (datum) {
    var type = this.axis.type || 'category';
    if (type === 'number' && typeof datum === 'number') {
      return this.formatNumericDatum(datum);
    } else if (type === 'time' && (datum instanceof Date || isNumber$1(datum))) {
      return this.defaultDateFormatter(datum);
    } else return String(datum);
  };
  Sparkline.prototype.setupDomEventListeners = function (chartElement) {
    chartElement.addEventListener('mousemove', this._onMouseMove);
    chartElement.addEventListener('mouseout', this._onMouseOut);
  };
  Sparkline.prototype.cleanupDomEventListerners = function (chartElement) {
    chartElement.removeEventListener('mousemove', this._onMouseMove);
    chartElement.removeEventListener('mouseout', this._onMouseOut);
  };
  /**
   * Cleanup and remove canvas element from the DOM.
   */
  Sparkline.prototype.destroy = function () {
    this.scene.container = undefined;
    // remove canvas element from the DOM
    this.container = undefined;
    this.cleanupDomEventListerners(this.scene.canvas.element);
  };
  /**
   * @returns this.scene.canvas.element
   */
  Sparkline.prototype.getCanvasElement = function () {
    return this.canvasElement;
  };
  Sparkline.tooltipDocuments = [];
  return Sparkline;
}(Observable$1);
var __extends$66 = undefined && undefined.__extends || function () {
  var _extendStatics399 = function extendStatics(d, b) {
    _extendStatics399 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics399(d, b);
  };
  return function (d, b) {
    _extendStatics399(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
function toTooltipHtml$1(input, defaults) {
  if (typeof input === 'string') {
    return input;
  }
  defaults = defaults || {};
  var _a = input.content,
    content = _a === void 0 ? defaults.content || '' : _a,
    _b = input.title,
    title = _b === void 0 ? defaults.title || undefined : _b,
    _c = input.color,
    color = _c === void 0 ? defaults.color || 'black' : _c,
    _d = input.backgroundColor,
    backgroundColor = _d === void 0 ? defaults.backgroundColor || 'rgb(136, 136, 136)' : _d,
    _e = input.opacity,
    opacity = _e === void 0 ? defaults.opacity || 0.2 : _e;
  var titleBgColor = Color$2.fromString(backgroundColor.toLowerCase());
  var r = titleBgColor.r,
    g = titleBgColor.g,
    b = titleBgColor.b,
    a = titleBgColor.a;
  // TODO: combine a and opacity for alpha?
  var alpha = opacity;
  var titleBgColorWithAlpha = Color$2.fromArray([r, g, b, alpha]);
  var titleBgColorRgbaString = titleBgColorWithAlpha.toRgbaString();
  var contentBgColor = "rgba(244, 244, 244, " + opacity + ")";
  var titleHtml = title ? "<div class=\"" + SparklineTooltip.class + "-title\";\n    style=\"color: " + color + "; background-color: " + titleBgColorRgbaString + "\">" + title + "</div>" : '';
  return titleHtml + "<div class=\"" + SparklineTooltip.class + "-content\" style=\"background-color: " + contentBgColor + "\">" + content + "</div>";
}
var SparklineTooltip = /** @class */function (_super) {
  __extends$66(SparklineTooltip, _super);
  function SparklineTooltip() {
    var _this = _super.call(this) || this;
    _this.element = document.createElement('div');
    _this.enabled = true;
    _this.container = undefined;
    _this.renderer = undefined;
    _this.constrained = false;
    var tooltipRoot = document.body;
    tooltipRoot.appendChild(_this.element);
    return _this;
  }
  SparklineTooltip.prototype.isVisible = function () {
    var element = this.element;
    if (element.classList) {
      return !element.classList.contains(SparklineTooltip.class + "-hidden");
    }
    // IE11
    var classes = element.getAttribute('class');
    if (classes) {
      return classes.split(' ').indexOf(SparklineTooltip.class + "-hidden") < 0;
    }
    return false;
  };
  SparklineTooltip.prototype.updateClass = function (visible, constrained) {
    var classList = [SparklineTooltip.class];
    if (visible !== true) {
      classList.push(SparklineTooltip.class + "-hidden");
    }
    if (constrained !== true) {
      classList.push(SparklineTooltip.class + "-arrow");
    }
    this.element.setAttribute('class', classList.join(' '));
  };
  SparklineTooltip.prototype.show = function (meta, html) {
    this.toggle(false);
    var element = this.element;
    if (html !== undefined) {
      element.innerHTML = html;
    } else if (!element.innerHTML) {
      return;
    }
    var left = meta.pageX - element.clientWidth / 2;
    var top = meta.pageY - element.clientHeight - 6;
    this.constrained = false;
    var tooltipRect = element.getBoundingClientRect();
    var minLeft = 0;
    var maxLeft = window.innerWidth - tooltipRect.width;
    var minTop = window.pageYOffset;
    if (this.container) {
      var containerRect = this.container.getBoundingClientRect();
      minLeft = containerRect.left;
      maxLeft = containerRect.width - tooltipRect.width;
      minTop = containerRect.top < 0 ? window.pageYOffset : containerRect.top;
    }
    if (left < minLeft) {
      left = minLeft;
      this.updateClass(true, this.constrained = true);
    } else if (left > maxLeft) {
      left = maxLeft;
      this.updateClass(true, this.constrained = true);
    }
    if (top < minTop) {
      top = minTop;
      this.updateClass(true, this.constrained = true);
    }
    element.style.left = Math.round(left) + "px";
    element.style.top = Math.round(top) + "px";
    this.toggle(true);
  };
  SparklineTooltip.prototype.toggle = function (visible) {
    this.updateClass(visible, this.constrained);
  };
  SparklineTooltip.prototype.destroy = function () {
    var parentNode = this.element.parentNode;
    if (parentNode) {
      parentNode.removeChild(this.element);
    }
  };
  SparklineTooltip.class = 'ag-sparkline-tooltip';
  return SparklineTooltip;
}(Observable$1);
var __extends$67 = undefined && undefined.__extends || function () {
  var _extendStatics400 = function extendStatics(d, b) {
    _extendStatics400 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics400(d, b);
  };
  return function (d, b) {
    _extendStatics400(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Marker$1 = /** @class */function (_super) {
  __extends$67(Marker, _super);
  function Marker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this._size = 3;
    return _this;
  }
  Object.defineProperty(Marker.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "size", {
    get: function get() {
      return this._size;
    },
    set: function set(value) {
      if (this._size !== value) {
        this._size = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  return Marker;
}(Shape$1);
var __extends$68 = undefined && undefined.__extends || function () {
  var _extendStatics401 = function extendStatics(d, b) {
    _extendStatics401 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics401(d, b);
  };
  return function (d, b) {
    _extendStatics401(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Circle$1 = /** @class */function (_super) {
  __extends$68(Circle, _super);
  function Circle() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Circle.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Circle.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Circle.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var _a = this,
      x = _a.x,
      y = _a.y,
      size = _a.size;
    var radius = size / 2;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Circle.className = 'Circle';
  return Circle;
}(Marker$1);
var __extends$69 = undefined && undefined.__extends || function () {
  var _extendStatics402 = function extendStatics(d, b) {
    _extendStatics402 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics402(d, b);
  };
  return function (d, b) {
    _extendStatics402(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Diamond$1 = /** @class */function (_super) {
  __extends$69(Diamond, _super);
  function Diamond() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Diamond.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Diamond.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Diamond.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var _a = this,
      x = _a.x,
      y = _a.y,
      size = _a.size;
    var hs = size / 2;
    ctx.beginPath();
    ctx.moveTo(x, y -= hs);
    ctx.lineTo(x += hs, y += hs);
    ctx.lineTo(x -= hs, y += hs);
    ctx.lineTo(x -= hs, y -= hs);
    ctx.lineTo(x += hs, y -= hs);
    ctx.closePath();
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Diamond.className = 'Diamond';
  return Diamond;
}(Marker$1);
var __extends$6a = undefined && undefined.__extends || function () {
  var _extendStatics403 = function extendStatics(d, b) {
    _extendStatics403 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics403(d, b);
  };
  return function (d, b) {
    _extendStatics403(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Square$1 = /** @class */function (_super) {
  __extends$6a(Square, _super);
  function Square() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Square.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Square.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Square.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var _a = this,
      x = _a.x,
      y = _a.y,
      size = _a.size;
    var hs = size / 2;
    ctx.beginPath();
    ctx.moveTo(x -= hs, y -= hs);
    ctx.lineTo(x += size, y);
    ctx.lineTo(x, y += size);
    ctx.lineTo(x -= size, y);
    ctx.lineTo(x, y -= size);
    ctx.closePath();
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Square.className = "Square";
  return Square;
}(Marker$1);
function getMarker$1(shape) {
  switch (shape) {
    case 'circle':
      return Circle$1;
    case 'square':
      return Square$1;
    case 'diamond':
      return Diamond$1;
    default:
      return Circle$1;
  }
}
var __extends$6b = undefined && undefined.__extends || function () {
  var _extendStatics404 = function extendStatics(d, b) {
    _extendStatics404 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics404(d, b);
  };
  return function (d, b) {
    _extendStatics404(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SparklineMarker = /** @class */function (_super) {
  __extends$6b(SparklineMarker, _super);
  function SparklineMarker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.enabled = true;
    _this.shape = 'circle';
    _this.size = 0;
    _this.fill = 'rgb(124, 181, 236)';
    _this.stroke = 'rgb(124, 181, 236)';
    _this.strokeWidth = 1;
    _this.formatter = undefined;
    return _this;
  }
  return SparklineMarker;
}(Observable$1);
var SparklineLine = /** @class */function (_super) {
  __extends$6b(SparklineLine, _super);
  function SparklineLine() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.stroke = 'rgb(124, 181, 236)';
    _this.strokeWidth = 1;
    return _this;
  }
  return SparklineLine;
}(Observable$1);
var AreaSparkline = /** @class */function (_super) {
  __extends$6b(AreaSparkline, _super);
  function AreaSparkline() {
    var _this = _super.call(this) || this;
    _this.fill = 'rgba(124, 181, 236, 0.25)';
    _this.areaSparklineGroup = new Group$1();
    _this.strokePath = new Path$1();
    _this.fillPath = new Path$1();
    _this.fillPathData = [];
    _this.strokePathData = [];
    _this.xAxisLine = new Line$1();
    _this.markers = new Group$1();
    _this.markerSelection = Selection$1.select(_this.markers).selectAll();
    _this.markerSelectionData = [];
    _this.marker = new SparklineMarker();
    _this.line = new SparklineLine();
    _this.rootGroup.append(_this.areaSparklineGroup);
    _this.areaSparklineGroup.append([_this.fillPath, _this.xAxisLine, _this.strokePath, _this.markers]);
    return _this;
  }
  AreaSparkline.prototype.getNodeData = function () {
    return this.markerSelectionData;
  };
  /**
  * If marker shape is changed, this method should be called to remove the previous marker nodes selection.
  */
  AreaSparkline.prototype.onMarkerShapeChange = function () {
    this.markerSelection = this.markerSelection.setData([]);
    this.markerSelection.exit.remove();
    this.scheduleLayout();
  };
  AreaSparkline.prototype.update = function () {
    var data = this.generateNodeData();
    if (!data) {
      return;
    }
    var nodeData = data.nodeData,
      fillData = data.fillData,
      strokeData = data.strokeData;
    this.markerSelectionData = nodeData;
    this.fillPathData = fillData;
    this.strokePathData = strokeData;
    this.updateSelection(nodeData);
    this.updateNodes();
    this.updateStroke(strokeData);
    this.updateFill(fillData);
  };
  AreaSparkline.prototype.updateYScaleDomain = function () {
    var _a = this,
      yData = _a.yData,
      yScale = _a.yScale;
    var yMinMax = extent$1(yData, isNumber$1);
    var yMin = 0;
    var yMax = 1;
    if (yMinMax !== undefined) {
      yMin = this.min = yMinMax[0];
      yMax = this.max = yMinMax[1];
    }
    if (yData.length > 1) {
      // if yMin is positive, set yMin to 0
      yMin = yMin < 0 ? yMin : 0;
      // if yMax is negative, set yMax to 0
      yMax = yMax < 0 ? 0 : yMax;
    }
    yScale.domain = [yMin, yMax];
  };
  AreaSparkline.prototype.generateNodeData = function () {
    var _a = this,
      data = _a.data,
      yData = _a.yData,
      xData = _a.xData,
      xScale = _a.xScale,
      yScale = _a.yScale;
    if (!data) {
      return;
    }
    var offsetX = xScale instanceof BandScale$1 ? xScale.bandwidth / 2 : 0;
    var n = yData.length;
    var nodeData = [];
    var fillData = [];
    var strokeData = [];
    var firstValidX;
    var lastValidX;
    var previousX;
    var nextX;
    var yZero = yScale.convert(0);
    for (var i = 0; i < n; i++) {
      var yDatum = yData[i];
      var xDatum = xData[i];
      var x = xScale.convert(xDatum) + offsetX;
      var y = yScale.convert(yDatum);
      // if this iteration is not the last, set nextX using the next value in the data array
      if (i + 1 < n) {
        nextX = xScale.convert(xData[i + 1]) + offsetX;
      }
      // set stroke data regardless of missing/ undefined values. Undefined values will be handled in the updateStroke() method
      strokeData.push({
        seriesDatum: {
          x: xDatum,
          y: yDatum
        },
        point: {
          x: x,
          y: y
        }
      });
      if (yDatum === undefined && previousX !== undefined) {
        // if yDatum is undefined and there is a valid previous data point, add a phantom point at yZero
        // if a next data point exists, add a phantom point at yZero at the next X
        fillData.push({
          seriesDatum: undefined,
          point: {
            x: previousX,
            y: yZero
          }
        });
        if (nextX !== undefined) {
          fillData.push({
            seriesDatum: undefined,
            point: {
              x: nextX,
              y: yZero
            }
          });
        }
      } else if (yDatum !== undefined) {
        fillData.push({
          seriesDatum: {
            x: xDatum,
            y: yDatum
          },
          point: {
            x: x,
            y: y
          }
        });
        // set node data only if yDatum is not not undefined. These values are used in the updateSelection() method to update markers
        nodeData.push({
          seriesDatum: {
            x: xDatum,
            y: yDatum
          },
          point: {
            x: x,
            y: y
          }
        });
        firstValidX = firstValidX !== undefined ? firstValidX : x;
        lastValidX = x;
      }
      previousX = x;
    }
    // phantom points for creating closed area
    fillData.push({
      seriesDatum: undefined,
      point: {
        x: lastValidX,
        y: yZero
      }
    }, {
      seriesDatum: undefined,
      point: {
        x: firstValidX,
        y: yZero
      }
    });
    return {
      nodeData: nodeData,
      fillData: fillData,
      strokeData: strokeData
    };
  };
  AreaSparkline.prototype.updateAxisLine = function () {
    var _a = this,
      xScale = _a.xScale,
      yScale = _a.yScale,
      axis = _a.axis,
      xAxisLine = _a.xAxisLine;
    xAxisLine.x1 = xScale.range[0];
    xAxisLine.x2 = xScale.range[1];
    xAxisLine.y1 = xAxisLine.y2 = 0;
    xAxisLine.stroke = axis.stroke;
    xAxisLine.strokeWidth = axis.strokeWidth;
    var yZero = yScale.convert(0);
    xAxisLine.translationY = yZero;
  };
  AreaSparkline.prototype.updateSelection = function (selectionData) {
    var marker = this.marker;
    var shape = getMarker$1(marker.shape);
    var updateMarkerSelection = this.markerSelection.setData(selectionData);
    var enterMarkerSelection = updateMarkerSelection.enter.append(shape);
    updateMarkerSelection.exit.remove();
    this.markerSelection = updateMarkerSelection.merge(enterMarkerSelection);
  };
  AreaSparkline.prototype.updateNodes = function () {
    var _this = this;
    var _a = this,
      highlightedDatum = _a.highlightedDatum,
      highlightStyle = _a.highlightStyle,
      marker = _a.marker;
    var highlightSize = highlightStyle.size,
      highlightFill = highlightStyle.fill,
      highlightStroke = highlightStyle.stroke,
      highlightStrokeWidth = highlightStyle.strokeWidth;
    var markerFormatter = marker.formatter;
    this.markerSelection.each(function (node, datum, index) {
      var point = datum.point,
        seriesDatum = datum.seriesDatum;
      if (!point) {
        return;
      }
      var highlighted = datum === highlightedDatum;
      var markerFill = highlighted && highlightFill !== undefined ? highlightFill : marker.fill;
      var markerStroke = highlighted && highlightStroke !== undefined ? highlightStroke : marker.stroke;
      var markerStrokeWidth = highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : marker.strokeWidth;
      var markerSize = highlighted && highlightSize !== undefined ? highlightSize : marker.size;
      var markerFormat = undefined;
      if (markerFormatter) {
        var first = index === 0;
        var last = index === _this.markerSelectionData.length - 1;
        var min = seriesDatum.y === _this.min;
        var max = seriesDatum.y === _this.max;
        markerFormat = markerFormatter({
          datum: datum,
          xValue: seriesDatum.x,
          yValue: seriesDatum.y,
          min: min,
          max: max,
          first: first,
          last: last,
          fill: markerFill,
          stroke: markerStroke,
          strokeWidth: markerStrokeWidth,
          size: markerSize,
          highlighted: highlighted
        });
      }
      node.size = markerFormat && markerFormat.size != undefined ? markerFormat.size : markerSize;
      node.fill = markerFormat && markerFormat.fill != undefined ? markerFormat.fill : markerFill;
      node.stroke = markerFormat && markerFormat.stroke != undefined ? markerFormat.stroke : markerStroke;
      node.strokeWidth = markerFormat && markerFormat.strokeWidth != undefined ? markerFormat.strokeWidth : markerStrokeWidth;
      node.translationX = point.x;
      node.translationY = point.y;
      node.visible = markerFormat && markerFormat.enabled != undefined ? markerFormat.enabled : marker.enabled && node.size > 0;
    });
  };
  AreaSparkline.prototype.updateStroke = function (strokeData) {
    var _a = this,
      strokePath = _a.strokePath,
      yData = _a.yData,
      line = _a.line;
    if (yData.length < 2) {
      return;
    }
    var path = strokePath.path;
    var n = strokeData.length;
    var moveTo = true;
    path.clear();
    for (var i = 0; i < n; i++) {
      var _b = strokeData[i],
        point = _b.point,
        seriesDatum = _b.seriesDatum;
      var x = point.x;
      var y = point.y;
      if (seriesDatum.y == undefined) {
        moveTo = true;
      } else {
        if (moveTo) {
          path.moveTo(x, y);
          moveTo = false;
        } else {
          path.lineTo(x, y);
        }
      }
    }
    strokePath.lineJoin = strokePath.lineCap = 'round';
    strokePath.fill = undefined;
    strokePath.stroke = line.stroke;
    strokePath.strokeWidth = line.strokeWidth;
  };
  AreaSparkline.prototype.updateFill = function (areaData) {
    var _a = this,
      fillPath = _a.fillPath,
      yData = _a.yData,
      fill = _a.fill;
    var path = fillPath.path;
    var n = areaData.length;
    path.clear();
    if (yData.length < 2) {
      return;
    }
    for (var i = 0; i < n; i++) {
      var point = areaData[i].point;
      var x = point.x;
      var y = point.y;
      if (i > 0) {
        path.lineTo(x, y);
      } else {
        path.moveTo(x, y);
      }
    }
    path.closePath();
    fillPath.lineJoin = 'round';
    fillPath.stroke = undefined;
    fillPath.fill = fill;
  };
  AreaSparkline.prototype.getTooltipHtml = function (datum) {
    var _a = this,
      marker = _a.marker,
      dataType = _a.dataType;
    var seriesDatum = datum.seriesDatum;
    var yValue = seriesDatum.y;
    var xValue = seriesDatum.x;
    var backgroundColor = marker.fill;
    var content = this.formatNumericDatum(yValue);
    var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
    var defaults = {
      backgroundColor: backgroundColor,
      content: content,
      title: title
    };
    if (this.tooltip.renderer) {
      return toTooltipHtml$1(this.tooltip.renderer({
        context: this.context,
        datum: seriesDatum,
        yValue: yValue,
        xValue: xValue
      }), defaults);
    }
    return toTooltipHtml$1(defaults);
  };
  AreaSparkline.className = 'AreaSparkline';
  return AreaSparkline;
}(Sparkline);
var __extends$6c = undefined && undefined.__extends || function () {
  var _extendStatics405 = function extendStatics(d, b) {
    _extendStatics405 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics405(d, b);
  };
  return function (d, b) {
    _extendStatics405(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SparklineMarker$1 = /** @class */function (_super) {
  __extends$6c(SparklineMarker, _super);
  function SparklineMarker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.enabled = true;
    _this.shape = 'circle';
    _this.size = 0;
    _this.fill = 'rgb(124, 181, 236)';
    _this.stroke = 'rgb(124, 181, 236)';
    _this.strokeWidth = 1;
    _this.formatter = undefined;
    return _this;
  }
  return SparklineMarker;
}(Observable$1);
var SparklineLine$1 = /** @class */function (_super) {
  __extends$6c(SparklineLine, _super);
  function SparklineLine() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.stroke = 'rgb(124, 181, 236)';
    _this.strokeWidth = 1;
    return _this;
  }
  return SparklineLine;
}(Observable$1);
var LineSparkline = /** @class */function (_super) {
  __extends$6c(LineSparkline, _super);
  function LineSparkline() {
    var _this = _super.call(this) || this;
    _this.lineSparklineGroup = new Group$1();
    _this.linePath = new Path$1();
    _this.markers = new Group$1();
    _this.markerSelection = Selection$1.select(_this.markers).selectAll();
    _this.markerSelectionData = [];
    _this.marker = new SparklineMarker$1();
    _this.line = new SparklineLine$1();
    _this.rootGroup.append(_this.lineSparklineGroup);
    _this.lineSparklineGroup.append([_this.linePath, _this.markers]);
    return _this;
  }
  LineSparkline.prototype.getNodeData = function () {
    return this.markerSelectionData;
  };
  /**
   * If marker shape is changed, this method should be called to remove the previous marker nodes selection.
   */
  LineSparkline.prototype.onMarkerShapeChange = function () {
    this.markerSelection = this.markerSelection.setData([]);
    this.markerSelection.exit.remove();
    this.scheduleLayout();
  };
  LineSparkline.prototype.update = function () {
    var nodeData = this.generateNodeData();
    if (!nodeData) {
      return;
    }
    this.markerSelectionData = nodeData;
    this.updateSelection(nodeData);
    this.updateNodes();
    this.updateLine();
  };
  LineSparkline.prototype.updateYScaleDomain = function () {
    var _a = this,
      yData = _a.yData,
      yScale = _a.yScale;
    var yMinMax = extent$1(yData, isNumber$1);
    var yMin = 0;
    var yMax = 1;
    if (yMinMax !== undefined) {
      yMin = this.min = yMinMax[0];
      yMax = this.max = yMinMax[1];
    }
    if (yMin === yMax) {
      // if all values in the data are the same, yMin and yMax will be equal, need to adjust the domain with some padding
      var padding = Math.abs(yMin * 0.01);
      yMin -= padding;
      yMax += padding;
    }
    yScale.domain = [yMin, yMax];
  };
  LineSparkline.prototype.generateNodeData = function () {
    var _a = this,
      data = _a.data,
      yData = _a.yData,
      xData = _a.xData,
      xScale = _a.xScale,
      yScale = _a.yScale;
    if (!data) {
      return;
    }
    var offsetX = xScale instanceof BandScale$1 ? xScale.bandwidth / 2 : 0;
    var nodeData = [];
    for (var i = 0; i < yData.length; i++) {
      var yDatum = yData[i];
      var xDatum = xData[i];
      if (yDatum == undefined) {
        continue;
      }
      var x = xScale.convert(xDatum) + offsetX;
      var y = yScale.convert(yDatum);
      nodeData.push({
        seriesDatum: {
          x: xDatum,
          y: yDatum
        },
        point: {
          x: x,
          y: y
        }
      });
    }
    return nodeData;
  };
  LineSparkline.prototype.updateSelection = function (selectionData) {
    var marker = this.marker;
    var shape = getMarker$1(marker.shape);
    var updateMarkerSelection = this.markerSelection.setData(selectionData);
    var enterMarkerSelection = updateMarkerSelection.enter.append(shape);
    updateMarkerSelection.exit.remove();
    this.markerSelection = updateMarkerSelection.merge(enterMarkerSelection);
  };
  LineSparkline.prototype.updateNodes = function () {
    var _this = this;
    var _a = this,
      highlightedDatum = _a.highlightedDatum,
      highlightStyle = _a.highlightStyle,
      marker = _a.marker,
      min = _a.min,
      max = _a.max;
    var highlightSize = highlightStyle.size,
      highlightFill = highlightStyle.fill,
      highlightStroke = highlightStyle.stroke,
      highlightStrokeWidth = highlightStyle.strokeWidth;
    var markerFormatter = marker.formatter;
    this.markerSelection.each(function (node, datum, index) {
      var highlighted = datum === highlightedDatum;
      var markerFill = highlighted && highlightFill !== undefined ? highlightFill : marker.fill;
      var markerStroke = highlighted && highlightStroke !== undefined ? highlightStroke : marker.stroke;
      var markerStrokeWidth = highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : marker.strokeWidth;
      var markerSize = highlighted && highlightSize !== undefined ? highlightSize : marker.size;
      var markerFormat = undefined;
      var seriesDatum = datum.seriesDatum,
        point = datum.point;
      if (markerFormatter) {
        var first = index === 0;
        var last = index === _this.markerSelectionData.length - 1;
        var min_1 = seriesDatum.y === _this.min;
        var max_1 = seriesDatum.y === _this.max;
        markerFormat = markerFormatter({
          datum: datum,
          xValue: seriesDatum.x,
          yValue: seriesDatum.y,
          min: min_1,
          max: max_1,
          first: first,
          last: last,
          fill: markerFill,
          stroke: markerStroke,
          strokeWidth: markerStrokeWidth,
          size: markerSize,
          highlighted: highlighted
        });
      }
      node.size = markerFormat && markerFormat.size != undefined ? markerFormat.size : markerSize;
      node.fill = markerFormat && markerFormat.fill != undefined ? markerFormat.fill : markerFill;
      node.stroke = markerFormat && markerFormat.stroke != undefined ? markerFormat.stroke : markerStroke;
      node.strokeWidth = markerFormat && markerFormat.strokeWidth != undefined ? markerFormat.strokeWidth : markerStrokeWidth;
      node.translationX = point.x;
      node.translationY = point.y;
      node.visible = markerFormat && markerFormat.enabled != undefined ? markerFormat.enabled : marker.enabled && node.size > 0;
    });
  };
  LineSparkline.prototype.updateLine = function () {
    var _a = this,
      linePath = _a.linePath,
      yData = _a.yData,
      xData = _a.xData,
      xScale = _a.xScale,
      yScale = _a.yScale,
      line = _a.line;
    if (yData.length < 2) {
      return;
    }
    var path = linePath.path;
    var n = yData.length;
    var offsetX = xScale instanceof BandScale$1 ? xScale.bandwidth / 2 : 0;
    var moveTo = true;
    path.clear();
    for (var i = 0; i < n; i++) {
      var xDatum = xData[i];
      var yDatum = yData[i];
      var x = xScale.convert(xDatum) + offsetX;
      var y = yScale.convert(yDatum);
      if (yDatum == undefined) {
        moveTo = true;
      } else {
        if (moveTo) {
          path.moveTo(x, y);
          moveTo = false;
        } else {
          path.lineTo(x, y);
        }
      }
    }
    linePath.fill = undefined;
    linePath.stroke = line.stroke;
    linePath.strokeWidth = line.strokeWidth;
  };
  LineSparkline.prototype.getTooltipHtml = function (datum) {
    var _a = this,
      marker = _a.marker,
      dataType = _a.dataType;
    var seriesDatum = datum.seriesDatum;
    var yValue = seriesDatum.y;
    var xValue = seriesDatum.x;
    var backgroundColor = marker.fill;
    var content = this.formatNumericDatum(yValue);
    var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
    var defaults = {
      backgroundColor: backgroundColor,
      content: content,
      title: title
    };
    if (this.tooltip.renderer) {
      return toTooltipHtml$1(this.tooltip.renderer({
        context: this.context,
        datum: seriesDatum,
        yValue: yValue,
        xValue: xValue
      }), defaults);
    }
    return toTooltipHtml$1(defaults);
  };
  LineSparkline.className = 'LineSparkline';
  return LineSparkline;
}(Sparkline);
var __extends$6d = undefined && undefined.__extends || function () {
  var _extendStatics406 = function extendStatics(d, b) {
    _extendStatics406 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics406(d, b);
  };
  return function (d, b) {
    _extendStatics406(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Rectangle = /** @class */function (_super) {
  __extends$6d(Rectangle, _super);
  function Rectangle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this._width = 0;
    _this._height = 0;
    /**
     * If `true`, the rect is aligned to the pixel grid for crisp looking lines.
     */
    _this._crisp = false;
    return _this;
  }
  Object.defineProperty(Rectangle.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rectangle.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rectangle.prototype, "width", {
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rectangle.prototype, "height", {
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Rectangle.prototype, "crisp", {
    get: function get() {
      return this._crisp;
    },
    set: function set(value) {
      if (this._crisp !== value) {
        this._crisp = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Rectangle.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Rectangle.prototype.isPointInPath = function (x, y) {
    return false;
  };
  Rectangle.prototype.render = function (ctx) {
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    this.matrix.toContext(ctx);
    var _a = this,
      x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height,
      crisp = _a.crisp;
    ctx.beginPath();
    if (crisp) {
      // ensure stroke aligns to the pixel grid
      var _b = this,
        a = _b.alignment,
        al = _b.align;
      ctx.rect(al(a, x), al(a, y), al(a, x, width), al(a, y, height));
    } else {
      ctx.rect(x, y, width, height);
    }
    this.fillStroke(ctx);
    this.dirty = false;
  };
  Rectangle.className = 'Column';
  return Rectangle;
}(Shape$1);
var __extends$6e = undefined && undefined.__extends || function () {
  var _extendStatics407 = function extendStatics(d, b) {
    _extendStatics407 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics407(d, b);
  };
  return function (d, b) {
    _extendStatics407(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Text$1 = /** @class */function (_super) {
  __extends$6e(Text, _super);
  function Text() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this.lineBreakRegex = /\r?\n/g;
    _this.lines = [];
    _this._text = '';
    _this._dirtyFont = true;
    _this._fontSize = 10;
    _this._fontFamily = 'sans-serif';
    _this._textAlign = Text.defaultStyles.textAlign;
    _this._textBaseline = Text.defaultStyles.textBaseline;
    _this._lineHeight = 14;
    return _this;
  }
  Object.defineProperty(Text.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.splitText = function () {
    this.lines = this._text.split(this.lineBreakRegex);
  };
  Object.defineProperty(Text.prototype, "text", {
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      var str = String(value); // `value` can be an object here
      if (this._text !== str) {
        this._text = str;
        this.splitText();
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "font", {
    get: function get() {
      if (this.dirtyFont) {
        this.dirtyFont = false;
        this._font = getFont$2(this.fontSize, this.fontFamily, this.fontStyle, this.fontWeight);
      }
      return this._font;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "dirtyFont", {
    get: function get() {
      return this._dirtyFont;
    },
    set: function set(value) {
      if (this._dirtyFont !== value) {
        this._dirtyFont = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontStyle", {
    get: function get() {
      return this._fontStyle;
    },
    set: function set(value) {
      if (this._fontStyle !== value) {
        this._fontStyle = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontWeight", {
    get: function get() {
      return this._fontWeight;
    },
    set: function set(value) {
      if (this._fontWeight !== value) {
        this._fontWeight = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontSize", {
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      if (!isFinite(value)) {
        value = 10;
      }
      if (this._fontSize !== value) {
        this._fontSize = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontFamily", {
    get: function get() {
      return this._fontFamily;
    },
    set: function set(value) {
      if (this._fontFamily !== value) {
        this._fontFamily = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textAlign", {
    get: function get() {
      return this._textAlign;
    },
    set: function set(value) {
      if (this._textAlign !== value) {
        this._textAlign = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textBaseline", {
    get: function get() {
      return this._textBaseline;
    },
    set: function set(value) {
      if (this._textBaseline !== value) {
        this._textBaseline = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "lineHeight", {
    get: function get() {
      return this._lineHeight;
    },
    set: function set(value) {
      // Multi-line text is complicated because:
      // - Canvas does not support it natively, so we have to implement it manually
      // - need to know the height of each line -> need to parse the font shorthand ->
      //   generally impossible to do because font size may not be in pixels
      // - so, need to measure the text instead, each line individually -> expensive
      // - or make the user provide the line height manually for multi-line text
      // - computeBBox should use the lineHeight for multi-line text but ignore it otherwise
      // - textBaseline kind of loses its meaning for multi-line text
      if (this._lineHeight !== value) {
        this._lineHeight = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.computeBBox = function () {
    return HdpiCanvas$1.has.textMetrics ? this.getPreciseBBox() : this.getApproximateBBox();
  };
  Text.prototype.getPreciseBBox = function () {
    var metrics = HdpiCanvas$1.measureText(this.text, this.font, this.textBaseline, this.textAlign);
    return new BBox$1(this.x - metrics.actualBoundingBoxLeft, this.y - metrics.actualBoundingBoxAscent, metrics.width, metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
  };
  Text.prototype.getApproximateBBox = function () {
    var size = HdpiCanvas$1.getTextSize(this.text, this.font);
    var _a = this,
      x = _a.x,
      y = _a.y;
    switch (this.textAlign) {
      case 'end':
      case 'right':
        x -= size.width;
        break;
      case 'center':
        x -= size.width / 2;
    }
    switch (this.textBaseline) {
      case 'alphabetic':
        y -= size.height * 0.7;
        break;
      case 'middle':
        y -= size.height * 0.45;
        break;
      case 'ideographic':
        y -= size.height;
        break;
      case 'hanging':
        y -= size.height * 0.2;
        break;
      case 'bottom':
        y -= size.height;
        break;
    }
    return new BBox$1(x, y, size.width, size.height);
  };
  Text.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return bbox ? bbox.containsPoint(point.x, point.y) : false;
  };
  Text.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Text.prototype.render = function (ctx) {
    if (!this.lines.length || !this.scene) {
      return;
    }
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    // this.matrix.transformBBox(this.computeBBox!()).render(ctx); // debug
    this.matrix.toContext(ctx);
    var _a = this,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth;
    ctx.font = this.font;
    ctx.textAlign = this.textAlign;
    ctx.textBaseline = this.textBaseline;
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    var globalAlpha = ctx.globalAlpha;
    if (fill) {
      ctx.fillStyle = fill;
      ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
      var _b = this,
        fillShadow = _b.fillShadow,
        text = _b.text,
        x = _b.x,
        y = _b.y;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fillText(text, x, y);
    }
    if (stroke && strokeWidth) {
      ctx.strokeStyle = stroke;
      ctx.lineWidth = strokeWidth;
      ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
      var _c = this,
        lineDash = _c.lineDash,
        lineDashOffset = _c.lineDashOffset,
        lineCap = _c.lineCap,
        lineJoin = _c.lineJoin,
        strokeShadow = _c.strokeShadow,
        text = _c.text,
        x = _c.x,
        y = _c.y;
      if (lineDash) {
        ctx.setLineDash(lineDash);
      }
      if (lineDashOffset) {
        ctx.lineDashOffset = lineDashOffset;
      }
      if (lineCap) {
        ctx.lineCap = lineCap;
      }
      if (lineJoin) {
        ctx.lineJoin = lineJoin;
      }
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.strokeText(text, x, y);
    }
    this.dirty = false;
  };
  Text.className = 'Text';
  Text.defaultStyles = chainObjects$1(Shape$1.defaultStyles, {
    textAlign: 'start',
    fontStyle: undefined,
    fontWeight: undefined,
    fontSize: 10,
    fontFamily: 'sans-serif',
    textBaseline: 'alphabetic'
  });
  return Text;
}(Shape$1);
function getFont$2(fontSize, fontFamily, fontStyle, fontWeight) {
  return [fontStyle || '', fontWeight || '', fontSize + 'px', fontFamily].join(' ').trim();
}
var __extends$6f = undefined && undefined.__extends || function () {
  var _extendStatics408 = function extendStatics(d, b) {
    _extendStatics408 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics408(d, b);
  };
  return function (d, b) {
    _extendStatics408(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4v = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Label$1 = /** @class */function (_super) {
  __extends$6f(Label, _super);
  function Label() {
    var _this = _super.call(this) || this;
    _this.enabled = true;
    _this.fontSize = 8;
    _this.fontFamily = 'Verdana, sans-serif';
    _this.color = 'rgba(70, 70, 70, 1)';
    return _this;
  }
  Label.prototype.getFont = function () {
    return getFont$2(this.fontSize, this.fontFamily, this.fontStyle, this.fontWeight);
  };
  __decorate$4v([reactive$1('change', 'dataChange')], Label.prototype, "enabled", void 0);
  __decorate$4v([reactive$1('change')], Label.prototype, "fontSize", void 0);
  __decorate$4v([reactive$1('change')], Label.prototype, "fontFamily", void 0);
  __decorate$4v([reactive$1('change')], Label.prototype, "fontStyle", void 0);
  __decorate$4v([reactive$1('change')], Label.prototype, "fontWeight", void 0);
  __decorate$4v([reactive$1('change')], Label.prototype, "color", void 0);
  return Label;
}(Observable$1);
var __extends$6g = undefined && undefined.__extends || function () {
  var _extendStatics409 = function extendStatics(d, b) {
    _extendStatics409 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics409(d, b);
  };
  return function (d, b) {
    _extendStatics409(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Text$2 = /** @class */function (_super) {
  __extends$6g(Text, _super);
  function Text() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._x = 0;
    _this._y = 0;
    _this.lineBreakRegex = /\r?\n/g;
    _this.lines = [];
    _this._text = '';
    _this._dirtyFont = true;
    _this._fontSize = 10;
    _this._fontFamily = 'sans-serif';
    _this._textAlign = Text.defaultStyles.textAlign;
    _this._textBaseline = Text.defaultStyles.textBaseline;
    _this._lineHeight = 14;
    return _this;
  }
  Object.defineProperty(Text.prototype, "x", {
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if (this._x !== value) {
        this._x = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "y", {
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if (this._y !== value) {
        this._y = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.splitText = function () {
    this.lines = this._text.split(this.lineBreakRegex);
  };
  Object.defineProperty(Text.prototype, "text", {
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      var str = String(value); // `value` can be an object here
      if (this._text !== str) {
        this._text = str;
        this.splitText();
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "font", {
    get: function get() {
      if (this.dirtyFont) {
        this.dirtyFont = false;
        this._font = getFont$3(this.fontSize, this.fontFamily, this.fontStyle, this.fontWeight);
      }
      return this._font;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "dirtyFont", {
    get: function get() {
      return this._dirtyFont;
    },
    set: function set(value) {
      if (this._dirtyFont !== value) {
        this._dirtyFont = value;
        if (value) {
          this.dirty = true;
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontStyle", {
    get: function get() {
      return this._fontStyle;
    },
    set: function set(value) {
      if (this._fontStyle !== value) {
        this._fontStyle = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontWeight", {
    get: function get() {
      return this._fontWeight;
    },
    set: function set(value) {
      if (this._fontWeight !== value) {
        this._fontWeight = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontSize", {
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      if (!isFinite(value)) {
        value = 10;
      }
      if (this._fontSize !== value) {
        this._fontSize = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "fontFamily", {
    get: function get() {
      return this._fontFamily;
    },
    set: function set(value) {
      if (this._fontFamily !== value) {
        this._fontFamily = value;
        this.dirtyFont = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textAlign", {
    get: function get() {
      return this._textAlign;
    },
    set: function set(value) {
      if (this._textAlign !== value) {
        this._textAlign = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "textBaseline", {
    get: function get() {
      return this._textBaseline;
    },
    set: function set(value) {
      if (this._textBaseline !== value) {
        this._textBaseline = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Text.prototype, "lineHeight", {
    get: function get() {
      return this._lineHeight;
    },
    set: function set(value) {
      // Multi-line text is complicated because:
      // - Canvas does not support it natively, so we have to implement it manually
      // - need to know the height of each line -> need to parse the font shorthand ->
      //   generally impossible to do because font size may not be in pixels
      // - so, need to measure the text instead, each line individually -> expensive
      // - or make the user provide the line height manually for multi-line text
      // - computeBBox should use the lineHeight for multi-line text but ignore it otherwise
      // - textBaseline kind of loses its meaning for multi-line text
      if (this._lineHeight !== value) {
        this._lineHeight = value;
        this.dirty = true;
      }
    },
    enumerable: true,
    configurable: true
  });
  Text.prototype.computeBBox = function () {
    return HdpiCanvas$1.has.textMetrics ? this.getPreciseBBox() : this.getApproximateBBox();
  };
  Text.prototype.getPreciseBBox = function () {
    var metrics = HdpiCanvas$1.measureText(this.text, this.font, this.textBaseline, this.textAlign);
    return new BBox$1(this.x - metrics.actualBoundingBoxLeft, this.y - metrics.actualBoundingBoxAscent, metrics.width, metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
  };
  Text.prototype.getApproximateBBox = function () {
    var size = HdpiCanvas$1.getTextSize(this.text, this.font);
    var _a = this,
      x = _a.x,
      y = _a.y;
    switch (this.textAlign) {
      case 'end':
      case 'right':
        x -= size.width;
        break;
      case 'center':
        x -= size.width / 2;
    }
    switch (this.textBaseline) {
      case 'alphabetic':
        y -= size.height * 0.7;
        break;
      case 'middle':
        y -= size.height * 0.45;
        break;
      case 'ideographic':
        y -= size.height;
        break;
      case 'hanging':
        y -= size.height * 0.2;
        break;
      case 'bottom':
        y -= size.height;
        break;
    }
    return new BBox$1(x, y, size.width, size.height);
  };
  Text.prototype.isPointInPath = function (x, y) {
    var point = this.transformPoint(x, y);
    var bbox = this.computeBBox();
    return bbox ? bbox.containsPoint(point.x, point.y) : false;
  };
  Text.prototype.isPointInStroke = function (x, y) {
    return false;
  };
  Text.prototype.render = function (ctx) {
    if (!this.lines.length || !this.scene) {
      return;
    }
    if (this.dirtyTransform) {
      this.computeTransformMatrix();
    }
    // this.matrix.transformBBox(this.computeBBox!()).render(ctx); // debug
    this.matrix.toContext(ctx);
    var _a = this,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth;
    ctx.font = this.font;
    ctx.textAlign = this.textAlign;
    ctx.textBaseline = this.textBaseline;
    var pixelRatio = this.scene.canvas.pixelRatio || 1;
    var globalAlpha = ctx.globalAlpha;
    if (fill) {
      ctx.fillStyle = fill;
      ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
      var _b = this,
        fillShadow = _b.fillShadow,
        text = _b.text,
        x = _b.x,
        y = _b.y;
      if (fillShadow && fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
      ctx.fillText(text, x, y);
    }
    if (stroke && strokeWidth) {
      ctx.strokeStyle = stroke;
      ctx.lineWidth = strokeWidth;
      ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
      var _c = this,
        lineDash = _c.lineDash,
        lineDashOffset = _c.lineDashOffset,
        lineCap = _c.lineCap,
        lineJoin = _c.lineJoin,
        strokeShadow = _c.strokeShadow,
        text = _c.text,
        x = _c.x,
        y = _c.y;
      if (lineDash) {
        ctx.setLineDash(lineDash);
      }
      if (lineDashOffset) {
        ctx.lineDashOffset = lineDashOffset;
      }
      if (lineCap) {
        ctx.lineCap = lineCap;
      }
      if (lineJoin) {
        ctx.lineJoin = lineJoin;
      }
      if (strokeShadow && strokeShadow.enabled) {
        ctx.shadowColor = strokeShadow.color;
        ctx.shadowOffsetX = strokeShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = strokeShadow.yOffset * pixelRatio;
        ctx.shadowBlur = strokeShadow.blur * pixelRatio;
      }
      ctx.strokeText(text, x, y);
    }
    this.dirty = false;
  };
  Text.className = 'Text';
  Text.defaultStyles = chainObjects$1(Shape$1.defaultStyles, {
    textAlign: 'start',
    fontStyle: undefined,
    fontWeight: undefined,
    fontSize: 10,
    fontFamily: 'sans-serif',
    textBaseline: 'alphabetic'
  });
  return Text;
}(Shape$1);
function getFont$3(fontSize, fontFamily, fontStyle, fontWeight) {
  return [fontStyle || '', fontWeight || '', fontSize + 'px', fontFamily].join(' ').trim();
}
var __extends$6h = undefined && undefined.__extends || function () {
  var _extendStatics410 = function extendStatics(d, b) {
    _extendStatics410 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics410(d, b);
  };
  return function (d, b) {
    _extendStatics410(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var BarColumnNodeTag;
(function (BarColumnNodeTag) {
  BarColumnNodeTag[BarColumnNodeTag["Rect"] = 0] = "Rect";
  BarColumnNodeTag[BarColumnNodeTag["Label"] = 1] = "Label";
})(BarColumnNodeTag || (BarColumnNodeTag = {}));
var BarColumnLabelPlacement;
(function (BarColumnLabelPlacement) {
  BarColumnLabelPlacement["InsideBase"] = "insideBase";
  BarColumnLabelPlacement["InsideEnd"] = "insideEnd";
  BarColumnLabelPlacement["Center"] = "center";
  BarColumnLabelPlacement["OutsideEnd"] = "outsideEnd";
})(BarColumnLabelPlacement || (BarColumnLabelPlacement = {}));
var BarColumnLabel = /** @class */function (_super) {
  __extends$6h(BarColumnLabel, _super);
  function BarColumnLabel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.formatter = undefined;
    _this.placement = BarColumnLabelPlacement.InsideEnd;
    return _this;
  }
  return BarColumnLabel;
}(Label$1);
var BarColumnSparkline = /** @class */function (_super) {
  __extends$6h(BarColumnSparkline, _super);
  function BarColumnSparkline() {
    var _this = _super.call(this) || this;
    _this.fill = 'rgb(124, 181, 236)';
    _this.stroke = 'silver';
    _this.strokeWidth = 0;
    _this.paddingInner = 0.1;
    _this.paddingOuter = 0.2;
    _this.valueAxisDomain = undefined;
    _this.formatter = undefined;
    _this.axisLine = new Line$1();
    _this.sparklineGroup = new Group$1();
    _this.rectGroup = new Group$1();
    _this.labelGroup = new Group$1();
    _this.rectSelection = Selection$1.select(_this.rectGroup).selectAll();
    _this.labelSelection = Selection$1.select(_this.labelGroup).selectAll();
    _this.nodeSelectionData = [];
    _this.label = new BarColumnLabel();
    _this.rootGroup.append(_this.sparklineGroup);
    _this.sparklineGroup.append([_this.rectGroup, _this.axisLine, _this.labelGroup]);
    _this.axisLine.lineCap = 'round';
    _this.label.enabled = false;
    return _this;
  }
  BarColumnSparkline.prototype.getNodeData = function () {
    return this.nodeSelectionData;
  };
  BarColumnSparkline.prototype.update = function () {
    this.updateSelections();
    this.updateNodes();
  };
  BarColumnSparkline.prototype.updateSelections = function () {
    var nodeData = this.generateNodeData();
    if (!nodeData) {
      return;
    }
    this.nodeSelectionData = nodeData;
    this.updateRectSelection(nodeData);
    this.updateLabelSelection(nodeData);
  };
  BarColumnSparkline.prototype.updateNodes = function () {
    this.updateRectNodes();
    this.updateLabelNodes();
  };
  BarColumnSparkline.prototype.updateYScaleDomain = function () {
    var _a = this,
      yScale = _a.yScale,
      yData = _a.yData,
      valueAxisDomain = _a.valueAxisDomain;
    var yMinMax = extent$1(yData, isNumber$1);
    var yMin = 0;
    var yMax = 1;
    if (yMinMax !== undefined) {
      yMin = this.min = yMinMax[0];
      yMax = this.max = yMinMax[1];
    }
    // if yMin is positive, set yMin to 0
    yMin = yMin < 0 ? yMin : 0;
    // if yMax is negative, set yMax to 0
    yMax = yMax < 0 ? 0 : yMax;
    if (valueAxisDomain) {
      if (valueAxisDomain[1] < yMax) {
        valueAxisDomain[1] = yMax;
      }
      if (valueAxisDomain[0] > yMin) {
        valueAxisDomain[0] = yMin;
      }
    }
    yScale.domain = valueAxisDomain ? valueAxisDomain : [yMin, yMax];
  };
  BarColumnSparkline.prototype.updateRectSelection = function (selectionData) {
    var updateRectSelection = this.rectSelection.setData(selectionData);
    var enterRectSelection = updateRectSelection.enter.append(Rectangle);
    updateRectSelection.exit.remove();
    this.rectSelection = updateRectSelection.merge(enterRectSelection);
  };
  BarColumnSparkline.prototype.updateRectNodes = function () {
    var _this = this;
    var _a = this,
      highlightedDatum = _a.highlightedDatum,
      nodeFormatter = _a.formatter,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth;
    var _b = this.highlightStyle,
      highlightFill = _b.fill,
      highlightStroke = _b.stroke,
      highlightStrokeWidth = _b.strokeWidth;
    this.rectSelection.each(function (node, datum, index) {
      var highlighted = datum === highlightedDatum;
      var nodeFill = highlighted && highlightFill !== undefined ? highlightFill : fill;
      var nodeStroke = highlighted && highlightStroke !== undefined ? highlightStroke : stroke;
      var nodeStrokeWidth = highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : strokeWidth;
      var nodeFormat = undefined;
      var x = datum.x,
        y = datum.y,
        width = datum.width,
        height = datum.height,
        seriesDatum = datum.seriesDatum;
      if (nodeFormatter) {
        var first = index === 0;
        var last = index === _this.nodeSelectionData.length - 1;
        var min = seriesDatum.y === _this.min;
        var max = seriesDatum.y === _this.max;
        nodeFormat = nodeFormatter({
          datum: datum,
          xValue: seriesDatum.x,
          yValue: seriesDatum.y,
          width: width,
          height: height,
          min: min,
          max: max,
          first: first,
          last: last,
          fill: nodeFill,
          stroke: nodeStroke,
          strokeWidth: nodeStrokeWidth,
          highlighted: highlighted
        });
      }
      node.fill = nodeFormat && nodeFormat.fill || nodeFill;
      node.stroke = nodeFormat && nodeFormat.stroke || nodeStroke;
      node.strokeWidth = nodeFormat && nodeFormat.strokeWidth || nodeStrokeWidth;
      node.x = node.y = 0;
      node.width = width;
      node.height = height;
      node.visible = node.height > 0;
      node.translationX = x;
      node.translationY = y;
      // shifts bars upwards?
      // node.crisp = true;
    });
  };

  BarColumnSparkline.prototype.updateLabelSelection = function (selectionData) {
    var updateLabels = this.labelSelection.setData(selectionData);
    var enterLabels = updateLabels.enter.append(Text$2).each(function (text) {
      text.tag = BarColumnNodeTag.Label, text.pointerEvents = PointerEvents$1.None;
    });
    updateLabels.exit.remove();
    this.labelSelection = updateLabels.merge(enterLabels);
  };
  BarColumnSparkline.prototype.updateLabelNodes = function () {
    var _a = this.label,
      labelEnabled = _a.enabled,
      fontStyle = _a.fontStyle,
      fontWeight = _a.fontWeight,
      fontSize = _a.fontSize,
      fontFamily = _a.fontFamily,
      color = _a.color;
    this.labelSelection.each(function (text, datum) {
      var label = datum.label;
      if (label && labelEnabled) {
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.textAlign = label.textAlign;
        text.textBaseline = label.textBaseline;
        text.text = label.text;
        text.x = label.x;
        text.y = label.y;
        text.fill = color;
        text.visible = true;
      } else {
        text.visible = false;
      }
    });
  };
  BarColumnSparkline.prototype.getTooltipHtml = function (datum) {
    var _a = this,
      fill = _a.fill,
      dataType = _a.dataType;
    var seriesDatum = datum.seriesDatum;
    var yValue = seriesDatum.y;
    var xValue = seriesDatum.x;
    var backgroundColor = fill;
    var content = this.formatNumericDatum(yValue);
    var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
    var defaults = {
      backgroundColor: backgroundColor,
      content: content,
      title: title
    };
    if (this.tooltip.renderer) {
      return toTooltipHtml$1(this.tooltip.renderer({
        context: this.context,
        datum: seriesDatum,
        yValue: yValue,
        xValue: xValue
      }), defaults);
    }
    return toTooltipHtml$1(defaults);
  };
  BarColumnSparkline.prototype.formatLabelValue = function (value) {
    return value % 1 !== 0 ? value.toFixed(1) : value.toFixed(0);
  };
  return BarColumnSparkline;
}(Sparkline);
var __extends$6i = undefined && undefined.__extends || function () {
  var _extendStatics411 = function extendStatics(d, b) {
    _extendStatics411 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics411(d, b);
  };
  return function (d, b) {
    _extendStatics411(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var BarSparkline = /** @class */function (_super) {
  __extends$6i(BarSparkline, _super);
  function BarSparkline() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BarSparkline.prototype.updateYScaleRange = function () {
    var _a = this,
      seriesRect = _a.seriesRect,
      yScale = _a.yScale;
    yScale.range = [0, seriesRect.width];
  };
  BarSparkline.prototype.updateXScaleRange = function () {
    var _a = this,
      xScale = _a.xScale,
      seriesRect = _a.seriesRect,
      paddingOuter = _a.paddingOuter,
      paddingInner = _a.paddingInner,
      data = _a.data;
    if (xScale instanceof BandScale$1) {
      xScale.range = [0, seriesRect.height];
      xScale.paddingInner = paddingInner;
      xScale.paddingOuter = paddingOuter;
    } else {
      // last node will be clipped if the scale is not a band scale
      // subtract maximum possible node width from the range so that the last node is not clipped
      xScale.range = [0, seriesRect.height - seriesRect.height / data.length];
    }
  };
  BarSparkline.prototype.updateAxisLine = function () {
    var _a = this,
      yScale = _a.yScale,
      axis = _a.axis,
      axisLine = _a.axisLine,
      seriesRect = _a.seriesRect;
    var strokeWidth = axis.strokeWidth;
    axisLine.x1 = 0;
    axisLine.x2 = 0;
    axisLine.y1 = 0;
    axisLine.y2 = seriesRect.height;
    axisLine.stroke = axis.stroke;
    axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
    var yZero = yScale.convert(0);
    axisLine.translationX = yZero;
  };
  BarSparkline.prototype.generateNodeData = function () {
    var _a = this,
      data = _a.data,
      yData = _a.yData,
      xData = _a.xData,
      xScale = _a.xScale,
      yScale = _a.yScale,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth,
      label = _a.label;
    if (!data) {
      return;
    }
    var labelFontStyle = label.fontStyle,
      labelFontWeight = label.fontWeight,
      labelFontSize = label.fontSize,
      labelFontFamily = label.fontFamily,
      labelColor = label.color,
      labelFormatter = label.formatter,
      labelPlacement = label.placement;
    var nodeData = [];
    var yZero = yScale.convert(0);
    for (var i = 0, n = yData.length; i < n; i++) {
      var yDatum = yData[i];
      var xDatum = xData[i];
      var invalidDatum = yDatum === undefined;
      if (invalidDatum) {
        yDatum = 0;
      }
      var y = xScale.convert(xDatum);
      var x = Math.min(yScale.convert(yDatum), yZero);
      var bottom = Math.max(yScale.convert(yDatum), yZero);
      // if the scale is a band scale, the width of the rects will be the bandwidth, otherwise the width of the rects will be the range / number of items in the data
      var height = xScale instanceof BandScale$1 ? xScale.bandwidth : Math.abs(yScale.range[1] - yScale.range[0]) / data.length;
      var width = bottom - x;
      var midPoint = {
        x: yZero,
        y: y
      };
      var labelText = void 0;
      if (labelFormatter) {
        labelText = labelFormatter({
          value: yDatum
        });
      } else {
        labelText = yDatum !== undefined && isNumber$1(yDatum) ? this.formatLabelValue(yDatum) : '';
      }
      var labelY = y + height / 2;
      var labelX = void 0;
      var labelTextBaseline = 'middle';
      var labelTextAlign = void 0;
      var isPositiveY = yDatum !== undefined && yDatum >= 0;
      var labelPadding = 4;
      if (labelPlacement === BarColumnLabelPlacement.Center) {
        labelX = x + width / 2;
        labelTextAlign = 'center';
      } else if (labelPlacement === BarColumnLabelPlacement.OutsideEnd) {
        labelX = x + (isPositiveY ? width + labelPadding : -labelPadding);
        labelTextAlign = isPositiveY ? 'start' : 'end';
      } else if (labelPlacement === BarColumnLabelPlacement.InsideEnd) {
        labelX = x + (isPositiveY ? width - labelPadding : labelPadding);
        labelTextAlign = isPositiveY ? 'end' : 'start';
        var textSize = HdpiCanvas$1.getTextSize(labelText, labelFontFamily);
        var textWidth = textSize.width || 20;
        var positiveBoundary = yZero + textWidth;
        var negativeBoundary = yZero - textWidth;
        var exceedsBoundaries = isPositiveY && labelX < positiveBoundary || !isPositiveY && labelX > negativeBoundary;
        if (exceedsBoundaries) {
          // if labelX exceeds the boundary, labels should be positioned at `insideBase`.
          labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
          labelTextAlign = isPositiveY ? 'start' : 'end';
        }
      } else {
        // if labelPlacement === BarColumnLabelPlacement.InsideBase
        labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
        labelTextAlign = isPositiveY ? 'start' : 'end';
      }
      nodeData.push({
        x: x,
        y: y,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        seriesDatum: {
          x: xDatum,
          y: invalidDatum ? undefined : yDatum
        },
        point: midPoint,
        label: {
          x: labelX,
          y: labelY,
          text: labelText,
          fontStyle: labelFontStyle,
          fontWeight: labelFontWeight,
          fontSize: labelFontSize,
          fontFamily: labelFontFamily,
          textAlign: labelTextAlign,
          textBaseline: labelTextBaseline,
          fill: labelColor
        }
      });
    }
    return nodeData;
  };
  BarSparkline.className = 'BarSparkline';
  return BarSparkline;
}(BarColumnSparkline);
var __extends$6j = undefined && undefined.__extends || function () {
  var _extendStatics412 = function extendStatics(d, b) {
    _extendStatics412 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics412(d, b);
  };
  return function (d, b) {
    _extendStatics412(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ColumnSparkline = /** @class */function (_super) {
  __extends$6j(ColumnSparkline, _super);
  function ColumnSparkline() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ColumnSparkline.prototype.updateYScaleRange = function () {
    var _a = this,
      seriesRect = _a.seriesRect,
      yScale = _a.yScale;
    yScale.range = [seriesRect.height, 0];
  };
  ColumnSparkline.prototype.updateXScaleRange = function () {
    var _a = this,
      xScale = _a.xScale,
      seriesRect = _a.seriesRect,
      paddingOuter = _a.paddingOuter,
      paddingInner = _a.paddingInner,
      data = _a.data;
    if (xScale instanceof BandScale$1) {
      xScale.range = [0, seriesRect.width];
      xScale.paddingInner = paddingInner;
      xScale.paddingOuter = paddingOuter;
    } else {
      // last node will be clipped if the scale is not a band scale
      // subtract maximum possible node width from the range so that the last node is not clipped
      xScale.range = [0, seriesRect.width - seriesRect.width / data.length];
    }
  };
  ColumnSparkline.prototype.updateAxisLine = function () {
    var _a = this,
      yScale = _a.yScale,
      axis = _a.axis,
      axisLine = _a.axisLine,
      seriesRect = _a.seriesRect;
    var strokeWidth = axis.strokeWidth;
    axisLine.x1 = 0;
    axisLine.x2 = seriesRect.width;
    axisLine.y1 = 0;
    axisLine.y2 = 0;
    axisLine.stroke = axis.stroke;
    axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
    var yZero = yScale.convert(0);
    axisLine.translationY = yZero;
  };
  ColumnSparkline.prototype.generateNodeData = function () {
    var _a = this,
      data = _a.data,
      yData = _a.yData,
      xData = _a.xData,
      xScale = _a.xScale,
      yScale = _a.yScale,
      fill = _a.fill,
      stroke = _a.stroke,
      strokeWidth = _a.strokeWidth,
      label = _a.label;
    if (!data) {
      return;
    }
    var labelFontStyle = label.fontStyle,
      labelFontWeight = label.fontWeight,
      labelFontSize = label.fontSize,
      labelFontFamily = label.fontFamily,
      labelColor = label.color,
      labelFormatter = label.formatter,
      labelPlacement = label.placement;
    var nodeData = [];
    var yZero = yScale.convert(0);
    for (var i = 0, n = yData.length; i < n; i++) {
      var yDatum = yData[i];
      var xDatum = xData[i];
      var invalidDatum = yDatum === undefined;
      if (invalidDatum) {
        yDatum = 0;
      }
      var y = Math.min(yScale.convert(yDatum), yZero);
      var x = xScale.convert(xDatum);
      var bottom = Math.max(yScale.convert(yDatum), yZero);
      // if the scale is a band scale, the width of the rects will be the bandwidth, otherwise the width of the rects will be the range / number of items in the data
      var width = xScale instanceof BandScale$1 ? xScale.bandwidth : Math.abs(yScale.range[1] - yScale.range[0]) / data.length;
      var height = bottom - y;
      var midPoint = {
        x: x + width / 2,
        y: yZero
      };
      var labelText = void 0;
      if (labelFormatter) {
        labelText = labelFormatter({
          value: yDatum
        });
      } else {
        labelText = yDatum !== undefined && isNumber$1(yDatum) ? this.formatLabelValue(yDatum) : '';
      }
      var labelX = x + width / 2;
      var labelY = void 0;
      var labelTextAlign = 'center';
      var labelTextBaseline = void 0;
      var isPositiveY = yDatum !== undefined && yDatum >= 0;
      var labelPadding = 2;
      if (labelPlacement === BarColumnLabelPlacement.Center) {
        labelY = y + height / 2;
        labelTextBaseline = 'middle';
      } else if (labelPlacement === BarColumnLabelPlacement.OutsideEnd) {
        labelY = y + (isPositiveY ? -labelPadding : height + labelPadding);
        labelTextBaseline = isPositiveY ? 'bottom' : 'top';
      } else if (labelPlacement === BarColumnLabelPlacement.InsideEnd) {
        labelY = y + (isPositiveY ? labelPadding : height - labelPadding);
        labelTextBaseline = isPositiveY ? 'top' : 'bottom';
        var textSize = HdpiCanvas$1.getTextSize(labelText, labelFontFamily);
        var textHeight = textSize.height || 10;
        var positiveBoundary = yZero - textHeight;
        var negativeBoundary = yZero + textHeight;
        var exceedsBoundaries = isPositiveY && labelY > positiveBoundary || !isPositiveY && labelY < negativeBoundary;
        if (exceedsBoundaries) {
          // if labelY exceeds the y boundary, labels should be positioned at the insideBase
          labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
          labelTextBaseline = isPositiveY ? 'bottom' : 'top';
        }
      } else {
        // if labelPlacement === BarColumnLabelPlacement.InsideBase
        labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
        labelTextBaseline = isPositiveY ? 'bottom' : 'top';
      }
      nodeData.push({
        x: x,
        y: y,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        seriesDatum: {
          x: xDatum,
          y: invalidDatum ? undefined : yDatum
        },
        point: midPoint,
        label: {
          x: labelX,
          y: labelY,
          text: labelText,
          fontStyle: labelFontStyle,
          fontWeight: labelFontWeight,
          fontSize: labelFontSize,
          fontFamily: labelFontFamily,
          textAlign: labelTextAlign,
          textBaseline: labelTextBaseline,
          fill: labelColor
        }
      });
    }
    return nodeData;
  };
  ColumnSparkline.className = 'ColumnSparkline';
  return ColumnSparkline;
}(BarColumnSparkline);
var AgSparkline = /** @class */function () {
  function AgSparkline() {}
  AgSparkline.create = function (options, tooltip) {
    // avoid mutating user provided options
    options = Object.create(options);
    var sparkline = getSparklineInstance(options.type);
    if (tooltip) {
      sparkline.tooltip = tooltip;
    }
    initSparkline(sparkline, options);
    initSparklineByType(sparkline, options);
    if (options.data) {
      sparkline.data = options.data;
    }
    return sparkline;
  };
  return AgSparkline;
}();
function getSparklineInstance(type) {
  if (type === void 0) {
    type = 'line';
  }
  switch (type) {
    case 'column':
      return new ColumnSparkline();
    case 'bar':
      return new BarSparkline();
    case 'area':
      return new AreaSparkline();
    case 'line':
    default:
      return new LineSparkline();
  }
}
function initSparklineByType(sparkline, options) {
  switch (options.type) {
    case 'bar':
      initBarColumnSparkline(sparkline, options);
      break;
    case 'column':
      initBarColumnSparkline(sparkline, options);
      break;
    case 'area':
      initAreaSparkline(sparkline, options);
      break;
    case 'line':
    default:
      initLineSparkline(sparkline, options);
      break;
  }
}
function initSparkline(sparkline, options) {
  setValueIfPropertyExists(sparkline, 'context', options.context, options);
  setValueIfPropertyExists(sparkline, 'width', options.width, options);
  setValueIfPropertyExists(sparkline, 'height', options.height, options);
  setValueIfPropertyExists(sparkline, 'container', options.container, options);
  setValueIfPropertyExists(sparkline, 'xKey', options.xKey, options);
  setValueIfPropertyExists(sparkline, 'yKey', options.yKey, options);
  if (options.padding) {
    initPaddingOptions(sparkline.padding, options.padding);
  }
  if (options.axis) {
    initAxisOptions(sparkline.axis, options.axis);
  }
  if (options.highlightStyle) {
    initHighlightStyleOptions(sparkline.highlightStyle, options.highlightStyle);
  }
  if (options.tooltip && sparkline.tooltip) {
    initTooltipOptions(sparkline.tooltip, options.tooltip);
  }
}
function initLineSparkline(sparkline, options) {
  if (options.marker) {
    initMarkerOptions(sparkline.marker, options.marker);
  }
  if (options.line) {
    initLineOptions(sparkline.line, options.line);
  }
}
function initAreaSparkline(sparkline, options) {
  setValueIfPropertyExists(sparkline, 'fill', options.fill, options);
  if (options.marker) {
    initMarkerOptions(sparkline.marker, options.marker);
  }
  if (options.line) {
    initLineOptions(sparkline.line, options.line);
  }
}
function initBarColumnSparkline(sparkline, options) {
  setValueIfPropertyExists(sparkline, 'valueAxisDomain', options.valueAxisDomain, options);
  setValueIfPropertyExists(sparkline, 'fill', options.fill, options);
  setValueIfPropertyExists(sparkline, 'stroke', options.stroke, options);
  setValueIfPropertyExists(sparkline, 'strokeWidth', options.strokeWidth, options);
  setValueIfPropertyExists(sparkline, 'paddingInner', options.paddingInner, options);
  setValueIfPropertyExists(sparkline, 'paddingOuter', options.paddingOuter, options);
  setValueIfPropertyExists(sparkline, 'formatter', options.formatter, options);
  if (options.label) {
    initLabelOptions(sparkline.label, options.label);
  }
}
function setValueIfPropertyExists(target, property, value, options) {
  if (property in options) {
    if (property in target) {
      if (target[property] !== value) {
        // only set property if the value is different to new value
        target[property] = value;
      }
    } else {
      console.warn("Property " + property + " does not exist on the target object.");
    }
  }
}
function initPaddingOptions(target, options) {
  setValueIfPropertyExists(target, 'top', options.top, options);
  setValueIfPropertyExists(target, 'right', options.right, options);
  setValueIfPropertyExists(target, 'bottom', options.bottom, options);
  setValueIfPropertyExists(target, 'left', options.left, options);
}
function initMarkerOptions(target, options) {
  setValueIfPropertyExists(target, 'enabled', options.enabled, options);
  setValueIfPropertyExists(target, 'size', options.size, options);
  setValueIfPropertyExists(target, 'shape', options.shape, options);
  setValueIfPropertyExists(target, 'fill', options.fill, options);
  setValueIfPropertyExists(target, 'stroke', options.stroke, options);
  setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
  setValueIfPropertyExists(target, 'formatter', options.formatter, options);
}
function initLabelOptions(target, options) {
  setValueIfPropertyExists(target, 'enabled', options.enabled, options);
  setValueIfPropertyExists(target, 'fontStyle', options.fontStyle, options);
  setValueIfPropertyExists(target, 'fontWeight', options.fontWeight, options);
  setValueIfPropertyExists(target, 'fontSize', options.fontSize, options);
  setValueIfPropertyExists(target, 'fontFamily', options.fontFamily, options);
  setValueIfPropertyExists(target, 'textAlign', options.textAlign, options);
  setValueIfPropertyExists(target, 'textBaseline', options.textBaseline, options);
  setValueIfPropertyExists(target, 'color', options.color, options);
  setValueIfPropertyExists(target, 'formatter', options.formatter, options);
  setValueIfPropertyExists(target, 'placement', options.placement, options);
}
function initLineOptions(target, options) {
  setValueIfPropertyExists(target, 'stroke', options.stroke, options);
  setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initAxisOptions(target, options) {
  setValueIfPropertyExists(target, 'type', options.type, options);
  setValueIfPropertyExists(target, 'stroke', options.stroke, options);
  setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initHighlightStyleOptions(target, options) {
  setValueIfPropertyExists(target, 'fill', options.fill, options);
  setValueIfPropertyExists(target, 'size', options.size, options);
  setValueIfPropertyExists(target, 'stroke', options.stroke, options);
  setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initTooltipOptions(target, options) {
  setValueIfPropertyExists(target, 'enabled', options.enabled, options);
  setValueIfPropertyExists(target, 'container', options.container, options);
  setValueIfPropertyExists(target, 'renderer', options.renderer, options);
}
var __extends$6k = undefined && undefined.__extends || function () {
  var _extendStatics413 = function extendStatics(d, b) {
    _extendStatics413 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics413(d, b);
  };
  return function (d, b) {
    _extendStatics413(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$G = undefined && undefined.__assign || function () {
  __assign$G = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$G.apply(this, arguments);
};
var __decorate$4w = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SparklineCellRenderer = /** @class */function (_super) {
  __extends$6k(SparklineCellRenderer, _super);
  function SparklineCellRenderer() {
    return _super.call(this, SparklineCellRenderer.TEMPLATE) || this;
  }
  SparklineCellRenderer.prototype.init = function (params) {
    var _this = this;
    var firstTimeIn = true;
    var updateSparkline = function updateSparkline() {
      var _a = _this.getGui(),
        clientWidth = _a.clientWidth,
        clientHeight = _a.clientHeight;
      if (clientWidth === 0 || clientHeight === 0) {
        return;
      }
      if (firstTimeIn) {
        var options = __assign$G({
          data: params.value,
          width: clientWidth,
          height: clientHeight,
          context: {
            data: params.data
          }
        }, params.sparklineOptions);
        // create new instance of sparkline
        _this.sparkline = AgSparkline.create(options, _this.sparklineTooltipSingleton.getSparklineTooltip());
        // append sparkline canvas to cell renderer element
        _this.eSparkline.appendChild(_this.sparkline.canvasElement);
        firstTimeIn = false;
      } else {
        _this.sparkline.width = clientWidth;
        _this.sparkline.height = clientHeight;
      }
    };
    var unsubscribeFromResize = this.resizeObserverService.observeResize(this.getGui(), updateSparkline);
    this.addDestroyFunc(function () {
      return unsubscribeFromResize();
    });
  };
  SparklineCellRenderer.prototype.refresh = function (params) {
    if (this.sparkline) {
      this.sparkline.data = params.value;
      return true;
    }
    return false;
  };
  SparklineCellRenderer.prototype.destroy = function () {
    if (this.sparkline) {
      this.sparkline.destroy();
    }
    _super.prototype.destroy.call(this);
  };
  SparklineCellRenderer.TEMPLATE = "<div class=\"ag-sparkline-wrapper\">\n            <span ref=\"eSparkline\"></span>\n        </div>";
  __decorate$4w([RefSelector('eSparkline')], SparklineCellRenderer.prototype, "eSparkline", void 0);
  __decorate$4w([Autowired('resizeObserverService')], SparklineCellRenderer.prototype, "resizeObserverService", void 0);
  __decorate$4w([Autowired('sparklineTooltipSingleton')], SparklineCellRenderer.prototype, "sparklineTooltipSingleton", void 0);
  return SparklineCellRenderer;
}(Component);
var __extends$6l = undefined && undefined.__extends || function () {
  var _extendStatics414 = function extendStatics(d, b) {
    _extendStatics414 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics414(d, b);
  };
  return function (d, b) {
    _extendStatics414(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate$4x = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * This 'bean' creates a single sparkline tooltip that is bound to the grid lifecycle.
 */
var SparklineTooltipSingleton = /** @class */function (_super) {
  __extends$6l(SparklineTooltipSingleton, _super);
  function SparklineTooltipSingleton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SparklineTooltipSingleton.prototype.postConstruct = function () {
    this.tooltip = new SparklineTooltip();
  };
  SparklineTooltipSingleton.prototype.getSparklineTooltip = function () {
    return this.tooltip;
  };
  SparklineTooltipSingleton.prototype.destroyTooltip = function () {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
  };
  __decorate$4x([PostConstruct], SparklineTooltipSingleton.prototype, "postConstruct", null);
  __decorate$4x([PreDestroy], SparklineTooltipSingleton.prototype, "destroyTooltip", null);
  SparklineTooltipSingleton = __decorate$4x([Bean('sparklineTooltipSingleton')], SparklineTooltipSingleton);
  return SparklineTooltipSingleton;
}(BeanStub);
var SparklinesModule = {
  moduleName: ModuleNames.SparklinesModule,
  beans: [SparklineTooltipSingleton],
  userComponents: [{
    componentName: 'agSparklineCellRenderer',
    componentClass: SparklineCellRenderer
  }],
  dependantModules: [EnterpriseCoreModule]
};
var AllEnterpriseModules = [ClipboardModule, ColumnsToolPanelModule, ExcelExportModule, FiltersToolPanelModule, GridChartsModule, MasterDetailModule, MenuModule, MultiFilterModule, RangeSelectionModule, RichSelectModule, RowGroupingModule, ServerSideRowModelModule, SetFilterModule, SideBarModule, StatusBarModule, ViewportRowModelModule, SparklinesModule];
var AllModules = AllCommunityModules.concat(AllEnterpriseModules);
var DefaultDataGridContextValue = {
  exportCsv: function exportCsv(_) {},
  exportExcel: function exportExcel(_) {},
  quickSearch: function quickSearch(_) {},
  initializeGrid: function initializeGrid(_) {}
};
var DataGridSelectionType;
(function (DataGridSelectionType) {
  DataGridSelectionType[DataGridSelectionType["None"] = 0] = "None";
  DataGridSelectionType[DataGridSelectionType["Single"] = 1] = "Single";
  DataGridSelectionType[DataGridSelectionType["SingleOrNone"] = 2] = "SingleOrNone";
  DataGridSelectionType[DataGridSelectionType["Multiple"] = 3] = "Multiple";
  DataGridSelectionType[DataGridSelectionType["MultipleOrNone"] = 4] = "MultipleOrNone";
})(DataGridSelectionType || (DataGridSelectionType = {}));
var DataGridContext = React__default.createContext(DefaultDataGridContextValue);
var DataGridContextProvider = /** @class */function (_super) {
  __extends(DataGridContextProvider, _super);
  function DataGridContextProvider(props) {
    var _this = _super.call(this, props) || this;
    _this.initializeGrid = function (gridApi, columnApi) {
      _this.setState(function (state) {
        return _assign2(_assign2({}, state), {
          gridApi: gridApi,
          columnApi: columnApi,
          exportCsv: function exportCsv(fileName) {
            var _a = _this.state,
              gridApi = _a.gridApi,
              columnApi = _a.columnApi;
            if (gridApi && columnApi) {
              var onlySelected = false;
              if (gridApi.getSelectedNodes().length) {
                onlySelected = true;
              }
              var columns = columnApi.getAllColumns();
              if (columns) {
                gridApi.exportDataAsCsv({
                  columnKeys: columns.filter(function (e) {
                    return e.getColDef().headerName;
                  }).map(function (e) {
                    return e.getColDef().field;
                  }),
                  fileName: fileName,
                  onlySelected: onlySelected
                });
              }
            }
          },
          exportExcel: function exportExcel(fileName) {
            var _a = _this.state,
              gridApi = _a.gridApi,
              columnApi = _a.columnApi;
            if (gridApi && columnApi) {
              var onlySelected = false;
              if (gridApi.getSelectedNodes().length) {
                onlySelected = true;
              }
              var columns = columnApi.getAllColumns();
              if (columns) {
                gridApi.exportDataAsExcel({
                  columnKeys: columns.filter(function (e) {
                    return e.getColDef().headerName;
                  }).map(function (e) {
                    return e.getColDef().field;
                  }),
                  fileName: fileName,
                  onlySelected: onlySelected
                });
              }
            }
          },
          quickSearch: function quickSearch(query) {
            if (_this.state.gridApi) {
              _this.state.gridApi.setQuickFilter(query);
            }
          }
        });
      });
    };
    _this.state = _assign2(_assign2({}, DefaultDataGridContextValue), {
      initializeGrid: _this.initializeGrid
    });
    return _this;
  }
  DataGridContextProvider.prototype.render = function () {
    return React__default.createElement(DataGridContext.Provider, {
      value: this.state
    }, this.props.children);
  };
  return DataGridContextProvider;
}(React__default.Component);
var useGridExportEvents = function useGridExportEvents() {
  var context = useContext(DataGridContext);
  var exportCsv = context.exportCsv,
    exportExcel = context.exportExcel;
  if (context && !!exportCsv && !!exportExcel) {
    return {
      exportCsv: exportCsv,
      exportExcel: exportExcel
    };
  }
  return null;
};
var useGridApi = function useGridApi() {
  var context = useContext(DataGridContext);
  // TODO: Check if destroyCalled is working well in future ag grid releases
  return context.gridApi && context.gridApi["destroyCalled"] ? undefined : context.gridApi;
};
var useGridQuickSearchEvent = function useGridQuickSearchEvent() {
  var context = useContext(DataGridContext);
  var quickSearch = context.quickSearch;
  if (context && quickSearch) {
    return quickSearch;
  }
  return null;
};
var useGridEvents = function useGridEvents(gridApi, columnApi) {
  var gridContext = useContext(DataGridContext);
  useEffect(function () {
    if (gridApi && columnApi) {
      gridContext.initializeGrid(gridApi, columnApi);
    }
  }, [gridApi, columnApi]);
};
var styles$5 = function styles$5(theme) {
  return createStyles$1({
    unselectableRow: {
      pointerEvents: 'none',
      '& .ag-icon-checkbox-checked': {
        color: theme.palette.grey[500] + " !important"
      }
    },
    gridContainer: {
      '& .ag-invisible': {
        marginLeft: '0 !important'
      },
      '& .ag-group-checkbox': {
        marginLeft: '0 !important'
      },
      '& .ag-cell-wrapper.ag-row-group': {
        alignItems: 'center'
      },
      '& .ag-row-group-indent-1': {
        paddingLeft: theme.spacing(2) + "px !important"
      },
      '& .ag-row-group-indent-2': {
        paddingLeft: theme.spacing(4) + "px !important"
      },
      '& .ag-row-group-indent-3': {
        paddingLeft: theme.spacing(6) + "px !important"
      },
      '& .ag-row-group-leaf-indent': {
        marginLeft: theme.spacing(3) + "px !important"
      },
      '& .ag-input-field-input': {
        height: '26px !important',
        fontSize: '12px !important',
        paddingBottom: 0,
        textIndent: theme.spacing(0.5)
      },
      '& .ag-group-expanded': {
        marginRight: theme.spacing(1) + "px !important"
      },
      '& .ag-group-contracted': {
        marginRight: theme.spacing(1) + "px !important"
      },
      '& .ag-text-field-input': {
        marginTop: theme.spacing(0.5) + "px !important",
        marginLeft: theme.spacing(1) + "px !important",
        marginRight: theme.spacing(1) + "px !important",
        borderBottomLeftRadius: '0 !important',
        borderBottomRightRadius: '0 !important'
      },
      '& .ag-checked::after': {
        color: theme.palette.secondary.main + " !important"
      },
      '& .ag-picker-field-wrapper:focus': {
        boxShadow: 'none !important'
      },
      '& *::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
        cursor: 'pointer',
        background: '#D4CCC7'
      },
      '& *::webkit-scrollbar-track': {
        background: '#9A9791',
        cursor: 'pointer'
      },
      '& *::-webkit-scrollbar-thumb': {
        background: '#9A9791',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': {
          background: '#9A9791'
        }
      },
      '& .ag-tab-selected': {
        borderBottomColor: theme.palette.secondary.main
      },
      '& .ag-input-field-input:focus': {
        borderBottomColor: theme.palette.secondary.main + " !important"
      },
      '& .ag-header-cell, & .ag-cell': {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(0)
      },
      '& .ag-header-cell .ag-react-container': {
        width: '100%'
      },
      '& .ag-cell .ag-react-container': {
        marginTop: 'auto',
        marginBottom: 'auto',
        lineHeight: 'normal !important',
        height: '100%',
        display: 'flex'
      },
      '& button:focus': {
        boxShadow: 'none !important'
      },
      '& .ag-cell-value': _assign2({
        width: '100%',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(0.5),
        marginTop: 'auto',
        marginBottom: 'auto'
      }, theme.typography.body2),
      '& .ag-filter-filter': {
        borderBottomColor: theme.palette.secondary.main + " !important",
        borderBottomLeftRadius: '0 !important',
        borderBottomRightRadius: '0 !important'
      },
      '& .ag-theme-material .ag-tab-header .ag-tab.ag-tab-selected': {
        borderBottomColor: theme.palette.secondary.main + " !important"
      },
      '& .ag-primary-cols-header-panel': {
        display: 'none',
        borderRadius: '0 !important'
      },
      '& .ag-checkbox-input-wrapper.ag-checked::after': {
        cursor: 'pointer !important',
        color: theme.palette.secondary.main + " !important"
      },
      '& .ag-icon-checkbox-unchecked': {
        cursor: 'pointer !important'
      },
      '& .ag-floating-filter-button': {
        marginRight: theme.spacing(0.5)
      },
      '& .ag-floating-filter-input': {
        fontSize: '1rem !important',
        height: '32px !important',
        paddingBottom: '0 !important',
        borderRadius: '0px !important',
        fontWeight: 'normal !important'
      },
      '& .ag-header-row:first-child .ag-header-cell:not(:last-child)': {
        borderRight: "1px solid " + theme.palette.divider
      },
      '& .ag-floating-filter-input:focus': {
        borderColor: theme.palette.secondary.main + " !important",
        fontWeight: 'normal !important'
      },
      '& .ag-filter-select': {
        font: 'inherit',
        border: '0 !important',
        margin: 0,
        display: 'block',
        padding: '6px 0 7px !important',
        minWidth: 0,
        background: 'none',
        boxSizing: 'content-box',
        cursor: 'pointer'
      },
      '& .selection-cell': {
        textAlign: 'center',
        borderRight: "1px solid " + theme.palette.divider,
        '& .ag-header-select-all, & .ag-selection-checkbox': {
          marginLeft: '15px !important'
        }
      }
    },
    rowPointer: {
      cursor: 'pointer'
    }
  });
};
var useStyles$5 = makeStyles(styles$5);
var useOnGridReady = function useOnGridReady(columnDefs) {
  var _a = useState(undefined),
    gridApi = _a[0],
    setGridApi = _a[1];
  var _b = useState(undefined),
    columnApi = _b[0],
    setColumnApi = _b[1];
  var onGridReady = useCallback(function (e) {
    setGridApi(e.api);
    setColumnApi(e.columnApi);
    Array.from(document.getElementsByClassName('ag-floating-filter-input')).forEach(function (obj) {
      if (obj.attributes.getNamedItem('disabled')) {
        // skip columns with disabled filter
        return;
      }
      obj.setAttribute('placeholder', 'Filter...');
    });
    var colWithSort = columnDefs.find(function (e) {
      return !!e.sort;
    });
    if (colWithSort) {
      e.api.setSortModel([{
        colId: colWithSort.field,
        sort: colWithSort.sort
      }]);
    }
  }, [columnDefs]);
  return {
    gridApi: gridApi,
    columnApi: columnApi,
    onGridReady: onGridReady
  };
};
var useGrid = function useGrid() {
  var gridContext = useContext(DataGridContext);
  var onGridReady = useCallback(function (e) {
    gridContext.initializeGrid(e.api, e.columnApi);
  }, [gridContext]);
  return [onGridReady];
};
var styles$6 = function styles$6(theme) {
  return createStyles$1({
    booleanFilterSelect: {
      width: '100%'
    }
  });
};
var useStyles$6 = makeStyles(styles$6);
var BooleanFloatingFilter = forwardRef(function (props, ref) {
  var _a = useState(-1),
    value = _a[0],
    setValue = _a[1];
  var t = useTranslation()[0];
  var classes = useStyles$6();
  var parentFilterInstance = props.parentFilterInstance;
  useImperativeHandle(ref, function () {
    return {
      onParentModelChanged: function onParentModelChanged(parentModel, event) {
        setValue(parentModel);
      }
    };
  });
  var handleValueChanged = useCallback(function (event) {
    var newVal = event.target.value;
    setValue(newVal);
    parentFilterInstance(function (instance) {
      instance.onFloatingFilterChanged('equals', newVal);
    });
  }, [parentFilterInstance]);
  return React__default.createElement(FormControl, {
    className: classes.booleanFilterSelect
  }, React__default.createElement(InputLabel, null, props.filterTitle), React__default.createElement(Select, {
    value: value,
    onChange: handleValueChanged
  }, React__default.createElement(MenuItem, {
    value: -1
  }, t('all')), React__default.createElement(MenuItem, {
    value: 0
  }, t('no')), React__default.createElement(MenuItem, {
    value: 1
  }, t('yes'))));
});
var BooleanFilter = forwardRef(function (props, ref) {
  var classes = useStyles$6();
  var inputRef = useRef(null);
  var hiddenInputRef = useRef(null);
  var t = useTranslation()[0];
  var _a = useState(-1),
    value = _a[0],
    setValue = _a[1];
  var updateValue = useCallback(function (newValue) {
    setValue(newValue);
    hiddenInputRef.current.value = newValue;
    props.filterChangedCallback();
  }, [props]);
  useImperativeHandle(ref, function () {
    return {
      isFilterActive: function isFilterActive() {
        return true;
      },
      doesFilterPass: function doesFilterPass(params) {
        var newValue = parseInt(hiddenInputRef.current.value, 10);
        if (newValue === -1) {
          return true;
        }
        var boolValue = !!newValue;
        return params.data[props.colDef.field ? props.colDef.field : 'id'] === boolValue;
      },
      onFloatingFilterChanged: function onFloatingFilterChanged(type, newValue) {
        updateValue(newValue);
      },
      getModel: function getModel() {
        return parseInt(hiddenInputRef.current.value, 10);
      }
    };
  });
  var handleValueChanged = useCallback(function (event) {
    var newValue = event.target.value;
    updateValue(newValue);
  }, [updateValue]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(FormControl, {
    className: classes.booleanFilterSelect,
    ref: inputRef
  }, React__default.createElement(InputLabel, null, props.filterTitle), React__default.createElement(Select, {
    value: value,
    onChange: handleValueChanged
  }, React__default.createElement(MenuItem, {
    value: -1
  }, t('all')), React__default.createElement(MenuItem, {
    value: 0
  }, t('no')), React__default.createElement(MenuItem, {
    value: 1
  }, t('yes')))), React__default.createElement("input", {
    type: "number",
    hidden: true,
    ref: hiddenInputRef,
    onChange: function onChange() {
      return props.filterChangedCallback();
    }
  }));
});
function useDebouncedCallback(callback, delay, options) {
  if (options === void 0) {
    options = {};
  }
  var maxWait = options.maxWait;
  var maxWaitHandler = useRef(null);
  var maxWaitArgs = useRef([]);
  var leading = options.leading;
  var trailing = options.trailing === undefined ? true : options.trailing;
  var leadingCall = useRef(false);
  var functionTimeoutHandler = useRef(null);
  var isComponentUnmounted = useRef(false);
  var debouncedFunction = useRef(callback);
  debouncedFunction.current = callback;
  var cancelDebouncedCallback = useCallback(function () {
    clearTimeout(functionTimeoutHandler.current);
    clearTimeout(maxWaitHandler.current);
    maxWaitHandler.current = null;
    maxWaitArgs.current = [];
    functionTimeoutHandler.current = null;
    leadingCall.current = false;
  }, []);
  useEffect(function () {
    return function () {
      // we use flag, as we allow to call callPending outside the hook
      isComponentUnmounted.current = true;
    };
  }, []);
  var debouncedCallback = useCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    maxWaitArgs.current = args;
    clearTimeout(functionTimeoutHandler.current);
    if (leadingCall.current) {
      leadingCall.current = false;
    }
    if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
      debouncedFunction.current.apply(debouncedFunction, args);
      leadingCall.current = true;
    }
    functionTimeoutHandler.current = setTimeout(function () {
      var shouldCallFunction = true;
      if (leading && leadingCall.current) {
        shouldCallFunction = false;
      }
      cancelDebouncedCallback();
      if (!isComponentUnmounted.current && trailing && shouldCallFunction) {
        debouncedFunction.current.apply(debouncedFunction, args);
      }
    }, delay);
    if (maxWait && !maxWaitHandler.current && trailing) {
      maxWaitHandler.current = setTimeout(function () {
        var args = maxWaitArgs.current;
        cancelDebouncedCallback();
        if (!isComponentUnmounted.current) {
          debouncedFunction.current.apply(null, args);
        }
      }, maxWait);
    }
  }, [maxWait, delay, cancelDebouncedCallback, leading, trailing]);
  var callPending = useCallback(function () {
    // Call pending callback only if we have anything in our queue
    if (!functionTimeoutHandler.current) {
      return;
    }
    debouncedFunction.current.apply(null, maxWaitArgs.current);
    cancelDebouncedCallback();
  }, [cancelDebouncedCallback]);
  // At the moment, we use 3 args array so that we save backward compatibility
  return [debouncedCallback, cancelDebouncedCallback, callPending];
}
var INPUT_DELAY = 250;
var InputBaseInnerWrapper = function InputBaseInnerWrapper(props) {
  var _a = useState(""),
    innerValue = _a[0],
    setInnerValue = _a[1];
  useEffect(function () {
    if (props.value) {
      setInnerValue(props.value);
    } else {
      setInnerValue("");
    }
  }, [props.value]);
  var debouncedHandleOnChange = useDebouncedCallback(function (event) {
    if (props.onChange) {
      props.onChange(event);
    }
  }, INPUT_DELAY)[0];
  var handleOnChange = useCallback(function (event) {
    event.persist();
    var newValue = event.currentTarget.value;
    setInnerValue(newValue);
    debouncedHandleOnChange(event);
  }, [debouncedHandleOnChange]);
  return React__default.createElement(InputBase, _assign2({
    autoComplete: "off"
  }, props, {
    value: innerValue,
    onChange: handleOnChange
  }));
};
var TextFieldInnerWrapper = function TextFieldInnerWrapper(props) {
  var _a = useState(""),
    innerValue = _a[0],
    setInnerValue = _a[1];
  useEffect(function () {
    if (props.value) {
      setInnerValue(props.value);
    } else {
      setInnerValue("");
    }
  }, [props.value]);
  var debouncedHandleOnChange = useDebouncedCallback(function (event) {
    if (props.onChange) {
      props.onChange(event);
    }
  }, INPUT_DELAY)[0];
  var handleOnChange = useCallback(function (event) {
    event.persist();
    var newValue = event.currentTarget.value;
    setInnerValue(newValue);
    debouncedHandleOnChange(event);
  }, [debouncedHandleOnChange]);
  return React__default.createElement(TextField, _assign2({
    autoComplete: "new-password"
  }, props, {
    value: innerValue,
    onChange: handleOnChange
  }));
};
var styles$7 = function styles$7(theme) {
  return createStyles$2({
    form: {
      padding: theme.spacing(1)
    }
  });
};
var useStyles$7 = makeStyles$1(styles$7);
var DefaultFilter = forwardRef(function (props, ref) {
  var _a = useState(""),
    value = _a[0],
    setValue = _a[1];
  var classes = useStyles$7();
  useEffect(function () {
    props.filterChangedCallback();
  }, [value]);
  useImperativeHandle(ref, function () {
    return {
      isFilterActive: function isFilterActive() {
        return value !== "";
      },
      doesFilterPass: function doesFilterPass(params) {
        return value.toLowerCase().split(" ").every(function (filterWord) {
          return props.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
        });
      }
    };
  });
  return React__default.createElement("div", {
    className: classes.form
  }, React__default.createElement(TextFieldInnerWrapper, {
    inputProps: {
      maxLength: 25
    },
    placeholder: "Search",
    autoComplete: "off",
    name: "search",
    color: "secondary",
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    }
  }));
});
var styles$8 = function styles$8(theme) {
  return createStyles$2({
    container: {
      width: "100%",
      display: "flex",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(0.5)
    },
    icon: {
      padding: theme.spacing(0.25),
      "& svg": {
        fontSize: "1rem"
      }
    },
    headerText: {
      marginTop: "auto",
      marginBottom: "auto",
      fontWeight: "bold",
      flexGrow: 1,
      textOverflow: "ellipsis"
    }
  });
};
var useStyles$8 = makeStyles$1(styles$8);
var DefaultHeader = function DefaultHeader(props) {
  var _a = useState(props.column.isSortAscending() ? "asc" : props.column.isSortDescending() ? "desc" : ""),
    sortDirection = _a[0],
    setSortDirection = _a[1];
  var _b = useState(false),
    isDragging = _b[0],
    setIsDragging = _b[1];
  var menuRef = useRef();
  var classes = useStyles$8();
  useEffect(function () {
    props.column.addEventListener("sortChanged", function () {
      if (props.column.isSortAscending()) {
        setSortDirection("asc");
      } else if (props.column.isSortDescending()) {
        setSortDirection("desc");
      } else {
        setSortDirection("");
      }
    });
    props.api.addEventListener("dragStarted", function (event) {
      return setIsDragging(true);
    });
    props.api.addEventListener("dragStopped", function (event) {
      return setIsDragging(false);
    });
  }, []);
  var progressSort = useCallback(function () {
    return !isDragging ? props.progressSort() : null;
  }, [props.progressSort, isDragging]);
  var sort = useMemo(function () {
    var icon = null;
    switch (sortDirection) {
      case "asc":
        icon = React__default.createElement(KeyboardArrowUp, null);
        break;
      case "desc":
        icon = React__default.createElement(KeyboardArrowDown, null);
    }
    return icon ? React__default.createElement(IconButton, {
      disabled: true,
      className: classes.icon,
      size: "small"
    }, icon) : React__default.createElement("span", null);
  }, [sortDirection]);
  var openColumnMenu = useCallback(function (event) {
    event.stopPropagation();
    props.showColumnMenu(event.target);
  }, []);
  return React__default.createElement("div", {
    className: classes.container,
    onClick: progressSort
  }, React__default.createElement(Typography$1, {
    noWrap: true,
    variant: "caption",
    className: classes.headerText
  }, props.displayName), React__default.createElement("div", null, props.enableSorting && sort, props.enableMenu && React__default.createElement(IconButton, {
    onClick: openColumnMenu,
    className: classes.icon,
    ref: menuRef
  }, React__default.createElement(FilterList, null))));
};
var generateNoRowsFoundComponent = function generateNoRowsFoundComponent(message) {
  var Component = function Component() {
    var t = useTranslation()[0];
    var translated = t(message ? message : "No Data found");
    return React__default.createElement("div", {
      className: "ag-overlay-loading-center"
    }, translated);
  };
  return Component;
};
var useSelectionType = function useSelectionType(selectionType) {
  var rowSelection = selectionType === DataGridSelectionType.Multiple || selectionType === DataGridSelectionType.MultipleOrNone ? "multiple" : "single";
  return rowSelection;
};
var useBuildColumns = function useBuildColumns(columnSettings, identifier, selectionType, noDataMessage, headerComponent, hideHeaderCheckbox) {
  var showSelectionColumn = selectionType !== DataGridSelectionType.None;
  var rowSelection = useSelectionType(selectionType);
  var NoRowsFound = generateNoRowsFoundComponent(noDataMessage);
  var t = useTranslation()[0];
  var _a = useState(0),
    widthSum = _a[0],
    setWidthSum = _a[1];
  var _b = useState(null),
    frameworkComponents = _b[0],
    setFrameworkComponents = _b[1];
  var _c = useState([]),
    columnDefs = _c[0],
    setColumnDefs = _c[1];
  var isFirstColumn = useCallback(function (_a) {
    var columnApi = _a.columnApi,
      column = _a.column;
    var displayedColumns = columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === column;
    return thisIsFirstColumn;
  }, []);
  var defaultColDef = {
    headerCheckboxSelection: rowSelection === 'multiple' ? isFirstColumn : undefined,
    checkboxSelection: rowSelection === 'multiple' ? isFirstColumn : undefined,
    floatingFilter: true
  };
  var buildColumns = useCallback(function () {
    var columns = [];
    var width = 0;
    var components = {
      agColumnHeader: headerComponent ? headerComponent : DefaultHeader,
      defaultFilter: DefaultFilter
    };
    if (showSelectionColumn) {
      columns.push({
        field: '#selection',
        resizable: false,
        sortable: false,
        checkboxSelection: true,
        headerCheckboxSelection: (rowSelection === 'single' ? false : true) && !hideHeaderCheckbox,
        headerName: '',
        suppressMenu: true,
        suppressSizeToFit: true,
        cellClass: 'selection-cell',
        headerClass: 'selection-cell',
        suppressMovable: true,
        pinned: 'left',
        width: 48,
        suppressColumnsToolPanel: true,
        lockPosition: true,
        lockVisible: true,
        headerCheckboxSelectionFilteredOnly: true
      });
    }
    columnSettings.forEach(function (columnConfig, index) {
      if (columnConfig.customFloatingFilter && columnConfig.customFloatingFilter === 'boolean') {
        components['booleanFloatingFilter'] = BooleanFloatingFilter;
        components['booleanFilter'] = BooleanFilter;
      }
      if (columnConfig.customFloatingFilter) {
        components[columnConfig.name] = columnConfig.customFloatingFilter;
      }
      if (columnConfig.formatter) {
        components[columnConfig.formatter.name] = columnConfig.formatter;
      }
      width += columnConfig.width;
      columns.push({
        pinned: columnConfig.pinned,
        sort: columnConfig.sort ? columnConfig.sort.direction : undefined,
        field: columnConfig.name,
        width: showSelectionColumn ? columnConfig.width + 25 : columnConfig.width,
        minWidth: columnConfig.width,
        sortable: true,
        headerName: t(identifier + "." + columnConfig.name),
        lockVisible: columnConfig.lockVisibility,
        resizable: true,
        hide: columnConfig.hide,
        valueFormatter: columnConfig.valueFormatter,
        cellRenderer: columnConfig.formatter ? columnConfig.formatter.name : undefined,
        floatingFilterComponentParams: _assign2({
          suppressFilterButton: columnConfig.filter === 'agSetColumnFilter' ? false : true
        }, columnConfig.customFloatingFilterParams),
        floatingFilterComponent: columnConfig.customFloatingFilter ? columnConfig.name : undefined,
        filter: columnConfig.filter ? columnConfig.filter : 'defaultFilter',
        filterParams: columnConfig.customFloatingFilterParams,
        menuTabs: ['filterMenuTab', 'columnsMenuTab', 'generalMenuTab'],
        keyCreator: columnConfig.keyCreator,
        tooltipField: columnConfig.name,
        lockPinned: true,
        comparator: columnConfig.comparator
      });
    });
    setWidthSum(width);
    setFrameworkComponents(_assign2(_assign2({}, components), {
      noRowsFound: NoRowsFound
    }));
    return columns;
  }, [columnSettings, showSelectionColumn, rowSelection]);
  useEffect(function () {
    setColumnDefs(buildColumns());
  }, [columnSettings, buildColumns]);
  return {
    columnDefs: columnDefs,
    widthSum: widthSum,
    frameworkComponents: frameworkComponents,
    defaultColDef: defaultColDef
  };
};
var savePreviousItems = function savePreviousItems(gridApi, items) {
  if (gridApi) {
    gridApi.__previousItems__ = items;
  }
};
var getPreviousItems = function getPreviousItems(gridApi) {
  if (gridApi.__previousItems__) {
    return gridApi.__previousItems__;
  }
  return {};
};
var useDefaultSelectionChange = function useDefaultSelectionChange(defaultSelection, items, idColumn, highlightNewlyAdded, gridApi) {
  useEffect(function () {
    // select default rows
    if (gridApi) {
      var previousItems = getPreviousItems(gridApi);
      var itemsKeys = Object.keys(items);
      var previousItemsKeys_1 = new Set(Object.keys(previousItems));
      var newlyAddedId_1 = itemsKeys.find(function (itemKey) {
        return !previousItemsKeys_1.has(itemKey);
      });
      var rowNodesToRedraw_1 = [];
      var rowNodesToSelect_1 = [];
      var rowNodesToUnselect_1 = [];
      var visibleIndex_1 = null;
      var allRowNodes_1 = [];
      gridApi.forEachNode(function (rowNode) {
        allRowNodes_1.push(rowNode);
        if (defaultSelection && rowNode.data) {
          var row = defaultSelection.find(function (e) {
            return e[idColumn] === rowNode.data[idColumn];
          });
          if (row) {
            rowNode.data.HIGHLIGHT_ROW = true;
            rowNodesToRedraw_1.push(rowNode);
            rowNodesToSelect_1.push(rowNode);
            visibleIndex_1 = rowNode.rowIndex;
          } else {
            if (rowNode.isSelected()) {
              rowNodesToUnselect_1.push(rowNode);
              rowNode.data.HIGHLIGHT_ROW = false;
              rowNodesToRedraw_1.push(rowNode);
            }
          }
        }
        if (highlightNewlyAdded && newlyAddedId_1) {
          if (rowNode.data[idColumn] === newlyAddedId_1 && newlyAddedId_1 !== '0') {
            rowNodesToSelect_1.push(rowNode);
            rowNodesToRedraw_1.push(rowNode);
            visibleIndex_1 = rowNode.rowIndex;
          }
        }
      });
      batch(function () {
        rowNodesToUnselect_1.map(function (e) {
          return e.setSelected(false, false, true);
        });
        rowNodesToSelect_1.map(function (e) {
          return e.setSelected(true, false, true);
        });
        if (rowNodesToRedraw_1.length) {
          var selectableCount = allRowNodes_1.filter(function (e) {
            return !e.group;
          }).length;
          if (selectableCount === rowNodesToSelect_1.length) {
            gridApi.selectAll();
          }
          gridApi.refreshHeader();
          gridApi.refreshCells({
            rowNodes: rowNodesToRedraw_1
          });
        }
        if (visibleIndex_1 !== null) {
          gridApi.ensureIndexVisible(visibleIndex_1, "middle");
        }
      });
    }
    savePreviousItems(gridApi, items);
  }, [defaultSelection, gridApi, items]);
};
var useGridRowEvents = function useGridRowEvents(onRowClicked, onSelect, supressUnselectDefault, defaultSelection, unselectableClass, rowClass) {
  // row clicked
  var handleRowClicked = useCallback(function (event) {
    if (onRowClicked) {
      onRowClicked(event.data);
    }
  }, [onRowClicked]);
  var handleSelectionChanged = useCallback(function (event) {
    if (onSelect) {
      onSelect(event.api.getSelectedRows());
    }
  }, [onSelect]);
  var getRowClass = function getRowClass(event) {
    var node = event.node;
    if (supressUnselectDefault && defaultSelection) {
      if (node.data.HIGHLIGHT_ROW === true) {
        return [unselectableClass, rowClass ? rowClass : ''];
      }
    }
    return [rowClass ? rowClass : ''];
  };
  return {
    handleRowClicked: handleRowClicked,
    handleSelectionChanged: handleSelectionChanged,
    getRowClass: getRowClass
  };
};
var useGridResize = function useGridResize(widthSum, columnSettings) {
  var handleGridSizeChanged = useCallback(function (_a) {
    var api = _a.api,
      columnApi = _a.columnApi,
      clientWidth = _a.clientWidth;
    if (clientWidth > widthSum) {
      api.sizeColumnsToFit();
    } else {
      columnApi.getAllDisplayedColumns().forEach(function (col) {
        var settings = columnSettings.find(function (e) {
          return e.name === col.getColDef().field;
        });
        if (settings) {
          columnApi.setColumnWidth(col, settings.width);
        } else {
          var colDef = col.getColDef();
          columnApi.setColumnWidth(col, colDef && colDef.width ? colDef.width : 100);
        }
      });
    }
  }, [widthSum, columnSettings]);
  return handleGridSizeChanged;
};
var DEFAULT_ROW_HEIGHT$1 = 36;
var DataGrid = React__default.memo(function (_a) {
  var onRowClicked = _a.onRowClicked,
    onSelect = _a.onSelect,
    props = __rest(_a, ["onRowClicked", "onSelect"]);
  var classes = useStyles$5();
  var idColumn = useMemo(function () {
    return props.idColumn ? props.idColumn : 'id';
  }, [props.idColumn]);
  var rowSelection = useSelectionType(props.selectionType);
  var normalizedItems = useMemo(function () {
    return normalize$2(props.items, idColumn);
  }, [props.items]);
  var _b = useBuildColumns(props.columnSettings, props.identifier, props.selectionType, props.noDataMessage, props.headerComponent, props.hideHeaderCheckbox),
    columnDefs = _b.columnDefs,
    frameworkComponents = _b.frameworkComponents,
    widthSum = _b.widthSum,
    defaultColDef = _b.defaultColDef;
  var _c = useOnGridReady(columnDefs),
    gridApi = _c.gridApi,
    columnApi = _c.columnApi,
    onGridReady = _c.onGridReady;
  useGridEvents(gridApi, columnApi);
  var handleGridSizeChanged = useGridResize(widthSum, props.columnSettings);
  // run when default selected rows change
  useDefaultSelectionChange(props.defaultSelection, normalizedItems, idColumn, props.highlightNewlyAdded, gridApi);
  var _d = useGridRowEvents(onRowClicked, onSelect, props.supressUnselectDefault, props.defaultSelection, classes.unselectableRow, props.rowClass),
    getRowClass = _d.getRowClass,
    handleRowClicked = _d.handleRowClicked,
    handleSelectionChanged = _d.handleSelectionChanged;
  var handleFilterChanged = useCallback(function (event) {
    var rows = event.api.getDisplayedRowCount();
    if (rows === 0) {
      event.api.showNoRowsOverlay();
    } else {
      event.api.hideOverlay();
    }
  }, []);
  var rowHeight = props.rowHeight ? props.rowHeight : DEFAULT_ROW_HEIGHT$1;
  if (frameworkComponents) {
    return React__default.createElement("div", {
      style: {
        height: '100%',
        width: '100%'
      },
      className: classes.gridContainer
    }, React__default.createElement("div", {
      id: "grid",
      className: "ag-theme-material",
      style: {
        height: '100%',
        width: '100%'
      }
    }, React__default.createElement(AgGridReact, _assign2({
      reactUi: true,
      onGridReady: onGridReady,
      columnDefs: columnDefs,
      rowData: props.items,
      modules: AllModules,
      onRowClicked: handleRowClicked,
      onSelectionChanged: handleSelectionChanged,
      defaultColDef: defaultColDef,
      frameworkComponents: frameworkComponents,
      noRowsOverlayComponent: 'noRowsFound',
      rowSelection: rowSelection,
      onFilterChanged: handleFilterChanged,
      onGridSizeChanged: handleGridSizeChanged,
      rowClass: onRowClicked ? classes.rowPointer : '',
      getRowClass: getRowClass,
      suppressContextMenu: true,
      suppressCellSelection: true,
      suppressRowClickSelection: true,
      suppressDragLeaveHidesColumns: true,
      rowHeight: rowHeight,
      headerHeight: rowHeight,
      floatingFilter: true,
      floatingFiltersHeight: rowHeight,
      isExternalFilterPresent: props.isExternalFilterEnabled,
      doesExternalFilterPass: props.externalFilterFn
    }, props.gridProps))));
  }
  return React__default.createElement("div", null);
});
var useTreeBuildColumns = function useTreeBuildColumns(columnSettings, identifier, selectionType, noDataMessage, rowSelectable, headerComponent, hideHeaderCheckbox) {
  var showSelectionColumn = selectionType !== DataGridSelectionType.None;
  var rowSelection = useSelectionType(selectionType);
  var NoRowsFound = generateNoRowsFoundComponent(noDataMessage);
  var t = useTranslation()[0];
  var _a = useState(0),
    widthSum = _a[0],
    setWidthSum = _a[1];
  var _b = useState(null),
    frameworkComponents = _b[0],
    setFrameworkComponents = _b[1];
  var _c = useState([]),
    columnDefs = _c[0],
    setColumnDefs = _c[1];
  var isFirstColumn = useCallback(function (_a) {
    var columnApi = _a.columnApi,
      column = _a.column;
    var displayedColumns = columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === column;
    return thisIsFirstColumn;
  }, []);
  var defaultColDef = {
    headerCheckboxSelection: rowSelection === 'multiple' ? isFirstColumn : undefined,
    checkboxSelection: rowSelection === 'multiple' ? isFirstColumn : undefined,
    floatingFilter: true
  };
  var buildColumns = useCallback(function () {
    var columns = [];
    var width = 0;
    var components = {
      agColumnHeader: headerComponent ? headerComponent : DefaultHeader,
      defaultFilter: DefaultFilter
    };
    if (showSelectionColumn) {
      columns.push({
        field: '#selection',
        resizable: false,
        sortable: false,
        checkboxSelection: rowSelectable,
        headerCheckboxSelection: (rowSelection === 'single' ? false : true) && !hideHeaderCheckbox,
        headerName: '',
        suppressMenu: true,
        suppressSizeToFit: true,
        cellClass: 'selection-cell',
        headerClass: 'selection-cell',
        suppressMovable: true,
        pinned: 'left',
        width: 48,
        suppressColumnsToolPanel: true,
        lockPosition: true,
        headerCheckboxSelectionFilteredOnly: true
      });
    }
    columnSettings.forEach(function (columnConfig, index) {
      if (columnConfig.customFloatingFilter && columnConfig.customFloatingFilter === 'boolean') {
        components['booleanFloatingFilter'] = BooleanFloatingFilter;
        components['booleanFilter'] = BooleanFilter;
      }
      if (columnConfig.customFloatingFilter) {
        components[columnConfig.name] = columnConfig.customFloatingFilter;
      }
      if (columnConfig.formatter) {
        components[columnConfig.name + "_formatter"] = columnConfig.formatter;
      }
      width += columnConfig.width;
      columns.push({
        pinned: columnConfig.pinned,
        sort: columnConfig.sort ? columnConfig.sort.direction : undefined,
        field: columnConfig.name,
        width: showSelectionColumn ? columnConfig.width + 25 : columnConfig.width,
        minWidth: columnConfig.width,
        sortable: true,
        headerName: t(identifier + "." + columnConfig.name),
        lockVisible: columnConfig.lockVisibility,
        resizable: true,
        valueFormatter: columnConfig.valueFormatter,
        cellRenderer: columnConfig.formatter ? columnConfig.name + "_formatter" : undefined,
        floatingFilterComponentParams: _assign2({
          suppressFilterButton: columnConfig.filter === 'agSetColumnFilter' ? false : true
        }, columnConfig.customFloatingFilterParams),
        floatingFilterComponent: columnConfig.customFloatingFilter ? columnConfig.name : undefined,
        filter: columnConfig.filter ? columnConfig.filter : columnConfig.filter !== false ? 'defaultFilter' : false,
        suppressFiltersToolPanel: columnConfig.suppressHeaderFilter,
        filterParams: columnConfig.customFloatingFilterParams,
        menuTabs: ['filterMenuTab', 'columnsMenuTab', 'generalMenuTab'],
        keyCreator: columnConfig.keyCreator,
        tooltipField: columnConfig.name,
        lockPinned: true,
        comparator: columnConfig.comparator
      });
    });
    setWidthSum(width);
    setFrameworkComponents(_assign2(_assign2({}, components), {
      noRowsFound: NoRowsFound
    }));
    return columns;
  }, [columnSettings, showSelectionColumn, rowSelection]);
  useEffect(function () {
    setColumnDefs(buildColumns());
  }, [columnSettings, buildColumns]);
  return {
    columnDefs: columnDefs,
    widthSum: widthSum,
    frameworkComponents: frameworkComponents,
    defaultColDef: defaultColDef
  };
};
var rowSelectable = function rowSelectable(params) {
  return params.node.group === false;
};
var TreeGrid = function TreeGrid(_a) {
  var columnSettings = _a.columnSettings,
    identifier = _a.identifier,
    selectionType = _a.selectionType,
    noDataMessage = _a.noDataMessage,
    rowHeight = _a.rowHeight,
    onRowClicked = _a.onRowClicked,
    onSelect = _a.onSelect,
    supressUnselectDefault = _a.supressUnselectDefault,
    defaultSelection = _a.defaultSelection,
    items = _a.items,
    getRowDataPath = _a.getRowDataPath,
    highlightNewlyAdded = _a.highlightNewlyAdded,
    hideHeaderCheckbox = _a.hideHeaderCheckbox,
    props = __rest(_a, ["columnSettings", "identifier", "selectionType", "noDataMessage", "rowHeight", "onRowClicked", "onSelect", "supressUnselectDefault", "defaultSelection", "items", "getRowDataPath", "highlightNewlyAdded", "hideHeaderCheckbox"]);
  var classes = useStyles$5();
  var _b = useState({}),
    normalizedItems = _b[0],
    setNormalizedItems = _b[1];
  var _c = useTreeBuildColumns(columnSettings, identifier, selectionType, noDataMessage, rowSelectable, undefined, hideHeaderCheckbox),
    columnDefs = _c.columnDefs,
    defaultColDef = _c.defaultColDef,
    frameworkComponents = _c.frameworkComponents,
    widthSum = _c.widthSum;
  var _d = useOnGridReady(columnDefs),
    gridApi = _d.gridApi,
    columnApi = _d.columnApi,
    onGridReady = _d.onGridReady;
  var handleGridSizeChanged = useGridResize(widthSum, columnSettings);
  var idColumn = useMemo(function () {
    return props.idColumn ? props.idColumn : 'id';
  }, [props.idColumn]);
  useEffect(function () {
    if (items) {
      setNormalizedItems(normalize$2(items, idColumn));
    }
  }, [items]);
  useDefaultSelectionChange(defaultSelection, normalizedItems, idColumn, highlightNewlyAdded, gridApi);
  useGridEvents(gridApi, columnApi);
  var _e = useGridRowEvents(onRowClicked, onSelect, supressUnselectDefault, defaultSelection, classes.unselectableRow, props.rowClass),
    getRowClass = _e.getRowClass,
    handleRowClicked = _e.handleRowClicked,
    handleSelectionChanged = _e.handleSelectionChanged;
  var rowSelection = useSelectionType(selectionType);
  var handleFilterChanged = useCallback(function (event) {
    var rows = event.api.getDisplayedRowCount();
    if (rows === 0) {
      event.api.showNoRowsOverlay();
    } else {
      event.api.hideOverlay();
    }
  }, []);
  if (frameworkComponents) {
    return React__default.createElement("div", {
      style: {
        height: '100%',
        width: '100%'
      },
      className: classes.gridContainer
    }, React__default.createElement("div", {
      id: "grid",
      className: "ag-theme-material",
      style: {
        height: '100%',
        width: '100%'
      }
    }, React__default.createElement(AgGridReact, {
      reactUi: true,
      treeData: true,
      getDataPath: getRowDataPath,
      onGridReady: onGridReady,
      columnDefs: columnDefs,
      rowData: items,
      modules: AllModules,
      onRowClicked: handleRowClicked,
      onSelectionChanged: handleSelectionChanged,
      defaultColDef: defaultColDef,
      frameworkComponents: _assign2(_assign2({}, frameworkComponents), props.components),
      noRowsOverlayComponent: 'noRowsFound',
      rowSelection: rowSelection,
      onFilterChanged: handleFilterChanged,
      onGridSizeChanged: handleGridSizeChanged,
      rowClass: onRowClicked ? classes.rowPointer : '',
      getRowClass: getRowClass,
      suppressContextMenu: true,
      suppressCellSelection: true,
      suppressRowClickSelection: true,
      suppressDragLeaveHidesColumns: true,
      rowHeight: rowHeight,
      headerHeight: rowHeight,
      floatingFilter: true,
      floatingFiltersHeight: rowHeight,
      groupDefaultExpanded: -1,
      isExternalFilterPresent: props.isExternalFilterEnabled,
      doesExternalFilterPass: props.externalFilterFn,
      autoGroupColumnDef: {
        headerName: props.groupColumnTitle,
        cellRendererParams: {
          suppressCount: true,
          innerRenderer: props.groupColumnRendererComponent
        },
        width: 120,
        resizable: true,
        filter: 'agTextColumnFilter',
        suppressColumnsToolPanel: true,
        lockPosition: true,
        lockPinned: true,
        sort: 'asc',
        sortable: true
      }
    })));
  }
  return React__default.createElement("div", null);
};
var styles$9 = function styles$9(theme) {
  return createStyles$1({
    cardRoot: function cardRoot(props) {
      return {
        overflow: props.overflow
      };
    },
    card: function card(props) {
      return {
        padding: theme.spacing(props.padding),
        display: 'flex',
        flexDirection: 'column'
      };
    },
    bottomMargin: {
      marginBottom: theme.spacing(2)
    },
    topMargin: {
      marginTop: theme.spacing(2)
    },
    gridCard: {
      margin: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column'
    }
  });
};
var useStyles$9 = makeStyles$1(styles$9);
var FormCard = function FormCard(props) {
  var _a;
  var padding = props.padding,
    marginBottom = props.marginBottom,
    marginTop = props.marginTop,
    overflow = props.overflow,
    cardProps = __rest(props, ["padding", "marginBottom", "marginTop", "overflow"]);
  var classes = useStyles$9({
    padding: props.padding ? props.padding : 2,
    overflow: overflow ? overflow : 'initial'
  });
  return React__default.createElement(Card, _assign2({
    className: classNames(classes.card, props.className, (_a = {}, _a[classes.bottomMargin] = props.marginBottom, _a[classes.topMargin] = props.marginTop, _a)),
    classes: {
      root: classes.cardRoot
    }
  }, cardProps), props.children);
};
var FormActionsCard = function FormActionsCard(props) {
  return React__default.createElement(FormCard, _assign2({}, props, {
    padding: -2
  }), props.children);
};
var GridCard = function GridCard(props) {
  var classes = useStyles$9({
    padding: -2,
    overflow: 'hidden'
  });
  return React__default.createElement(FormCard, _assign2({}, props, {
    marginBottom: true,
    padding: -2,
    className: classes.gridCard,
    overflow: 'hidden'
  }), props.children);
};
var styles$a = function styles$a(theme) {
  var _a;
  return createStyles$1({
    search: (_a = {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.text.primary, 0.05),
      '&:hover': {
        backgroundColor: fade(theme.palette.text.primary, 0.1)
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%'
    }, _a[theme.breakpoints.up('sm')] = {
      marginLeft: theme.spacing(0.5),
      width: 'auto'
    }, _a),
    searchIcon: {
      padding: theme.spacing(0, 1),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit',
      width: '100%'
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: "calc(1em + " + theme.spacing(3) + "px)",
      transition: theme.transitions.create('width'),
      width: '100%'
    }
  });
};
var useStyles$a = makeStyles$1(styles$a);
var SearchBox = function SearchBox(props) {
  var classes = useStyles$a();
  return React__default.createElement("div", {
    className: classes.search
  }, React__default.createElement("div", {
    className: classes.searchIcon
  }, React__default.createElement(SearchIcon, null)), React__default.createElement(InputBaseInnerWrapper, _assign2({
    inputProps: {
      maxLength: 255
    },
    classes: {
      root: classes.inputRoot,
      input: classes.inputInput
    },
    autoComplete: "off"
  }, props)));
};
var GridSearchBox = function GridSearchBox(props) {
  var t = useTranslation()[0];
  var quickSearch = useGridQuickSearchEvent();
  var quickSearchCallback = useCallback(function (e) {
    if (quickSearch) {
      quickSearch(e.target.value);
    }
  }, [quickSearch]);
  return React__default.createElement(SearchBox, {
    placeholder: t('workgroupLocations.quickSearch'),
    onChange: quickSearchCallback
  });
};
var useStyles$b = makeStyles$2(function (theme) {
  return createStyles$1({
    mathContainer: {
      display: "flex",
      flexDirection: "column"
    },
    alignedRow: {
      '& [role="gridcell"]': {
        lineHeight: "36px",
        height: "36px"
      }
    },
    iconSuccessColor: {
      "& svg": {
        color: "green !important"
      }
    },
    warningContainer: {
      padding: theme.spacing(1),
      borderTop: "1px solid " + theme.palette.warning.main,
      borderBottom: "1px solid " + theme.palette.warning.main,
      backgroundColor: theme.palette.warning.light,
      marginBottom: theme.spacing(2)
    },
    warningContent: {
      fontWeight: "bold"
    },
    inputContainer: {
      display: "flex"
    },
    math: {
      marginTop: "auto",
      marginBottom: "auto",
      marginRight: theme.spacing(1)
    },
    input: {
      width: 120,
      "& input": {
        fontSize: theme.typography.h5.fontSize,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          margin: 0
        }
      }
    },
    spacer: {
      flexGrow: 1
    },
    critDialogCheckRoot: {
      marginLeft: 0
    },
    divider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  });
});
var getRandom = function getRandom() {
  return Math.floor(Math.random() * 10);
};
var CountCheck = function CountCheck(props) {
  var t = useTranslation()[0];
  var classes = useStyles$b();
  return React__default.createElement(FormControl, {
    fullWidth: true
  }, React__default.createElement(FormLabel, null, t(props.label)), React__default.createElement(FilledInput, {
    color: 'secondary',
    type: 'number',
    autoFocus: true,
    className: classes.input,
    style: {
      width: "100%"
    },
    endAdornment: React__default.createElement(InputAdornment, {
      position: 'end'
    }, React__default.createElement(Icon, {
      className: classes.iconSuccessColor
    }, props.isCorrect && React__default.createElement(Check, null))),
    onChange: props.onChange
  }), React__default.createElement(FormHelperText, null, props.helperText));
};
var MathProblemConfirmDialog = function MathProblemConfirmDialog(_a) {
  var open = _a.open,
    onCancel = _a.onCancel,
    onSave = _a.onSave,
    title = _a.title,
    message = _a.message,
    warning = _a.warning,
    nextLabel = _a.nextLabel,
    extraMessage = _a.extraMessage,
    checkboxText = _a.checkboxText,
    countCheck = _a.countCheck,
    countCheckLabelKey = _a.countCheckLabelKey,
    countCheckHelperText = _a.countCheckHelperText;
  var t = useTranslation()[0];
  var classes = useStyles$b();
  var _b = useState(0),
    answer = _b[0],
    setAnswer = _b[1];
  var _c = useState(false),
    checked = _c[0],
    setChecked = _c[1];
  var _d = useState(0),
    term1 = _d[0],
    setTerm1 = _d[1];
  var _e = useState(0),
    term2 = _e[0],
    setTerm2 = _e[1];
  var _f = useState(countCheck != undefined ? false : true),
    countCheckCorrect = _f[0],
    setCountCheckCorrect = _f[1];
  useEffect(function () {
    if (countCheck === undefined) {
      setCountCheckCorrect(true);
    } else {
      setCountCheckCorrect(false);
    }
  }, [countCheck]);
  useEffect(function () {
    setChecked(false);
    if (open) {
      setTerm1(getRandom());
      setTerm2(getRandom());
    }
  }, [open]);
  var correctAnswer = useMemo(function () {
    return term1 + term2;
  }, [term1, term2]);
  var handleFieldChange = useCallback(function (event) {
    return setAnswer(parseFloat(event.target.value));
  }, []);
  var handleCheckboxChange = useCallback(function (_, checked) {
    return setChecked(checked);
  }, []);
  var countCheckCallback = useCallback(function (e) {
    if (countCheck !== undefined) {
      setCountCheckCorrect(countCheck === Number(e.target.value));
    } else {
      setCountCheckCorrect(true);
    }
  }, [countCheck]);
  return React__default.createElement(Dialog, {
    onClose: onCancel,
    open: open,
    maxWidth: 'sm',
    fullWidth: true
  }, React__default.createElement(DialogTitle, null, title), React__default.createElement(DialogContent$1, null, React__default.createElement(Typography$1, {
    variant: 'body1',
    align: 'left',
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), React__default.createElement("div", {
    className: classes.warningContainer
  }, React__default.createElement(Typography$1, {
    color: "error",
    className: classes.warningContent,
    variant: 'body1',
    align: 'left'
  }, warning)), extraMessage && React__default.createElement(Typography$1, {
    variant: 'body1',
    align: 'left',
    dangerouslySetInnerHTML: {
      __html: extraMessage
    }
  }), React__default.createElement(Divider, {
    className: classes.divider
  }), React__default.createElement("div", {
    className: classes.mathContainer
  }, React__default.createElement(Typography$1, {
    variant: 'body1',
    align: 'left'
  }, t("mathConfirmationDialog.math")), React__default.createElement("div", {
    className: classes.inputContainer
  }, React__default.createElement(Typography$1, {
    className: classes.math,
    variant: 'h5'
  }, term1, " + ", term2, " =", " "), React__default.createElement(FormControl, null, React__default.createElement(FilledInput, {
    autoFocus: true,
    className: classes.input,
    type: 'number',
    inputProps: {
      min: "0",
      step: "1"
    },
    onChange: handleFieldChange,
    endAdornment: React__default.createElement(InputAdornment, {
      position: 'end'
    }, React__default.createElement(Icon, {
      className: classes.iconSuccessColor
    }, answer === correctAnswer && React__default.createElement(Check, {
      color: "primary"
    })))
  })))), React__default.createElement(Divider, {
    className: classes.divider
  }), countCheck !== undefined && countCheckLabelKey && React__default.createElement(CountCheck, {
    label: countCheckLabelKey,
    helperText: countCheckHelperText,
    onChange: countCheckCallback,
    isCorrect: countCheckCorrect
  })), React__default.createElement(DialogActions$1, null, React__default.createElement(FormControlLabel, {
    classes: {
      root: classes.critDialogCheckRoot
    },
    control: React__default.createElement(Checkbox, {
      checked: checked,
      onChange: handleCheckboxChange
    }),
    label: React__default.createElement(Typography$1, {
      variant: 'subtitle2'
    }, React__default.createElement("b", null, checkboxText))
  }), React__default.createElement("div", {
    className: classes.spacer
  }), React__default.createElement(Button, {
    onClick: onCancel
  }, t("cancel")), React__default.createElement(Button, {
    variant: 'contained',
    color: 'secondary',
    disabled: !checked || answer !== correctAnswer || !countCheckCorrect,
    onClick: onSave
  }, nextLabel ? nextLabel : t("proceed"))));
};
var styles$b = function styles$b(theme) {
  return createStyles$1({
    gridHeaderContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: 'white',
      borderBottom: 'solid 1px #e2e2e2'
    }
  });
};
var useStyles$c = makeStyles(styles$b);
var DataGridHeader = React__default.memo(function (props) {
  var gridApi = useGridApi();
  var classes = useStyles$c();
  var _a = useState(0),
    selectionCount = _a[0],
    setSelectionCount = _a[1];
  useEffect(function () {
    if (gridApi) {
      gridApi.addEventListener('selectionChanged', function (e) {
        return setSelectionCount(gridApi.getSelectedRows().length);
      });
      gridApi.addEventListener('componentStateChanged', function (e) {
        return setSelectionCount(gridApi.getSelectedRows().length);
      });
    }
  }, [gridApi]);
  return React__default.createElement("div", {
    className: classes.gridHeaderContainer
  }, React__default.createElement(Typography$1, {
    variant: 'body2'
  }, "Total selected: " + selectionCount + " (some may be hidden)"), React__default.createElement(GridSearchBox, null));
});
LicenseManager.setLicenseKey('CompanyName=Mood Media North America Holdings Corp.,LicensedApplication=Harmony,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=12,AssetReference=AG-032839,SupportServicesEnd=9_November_2023_[v2]_MTY5OTQ4ODAwMDAwMA==69f640a9aca3ce55010dcf57ab4ab64c');
var styles$c = function styles$c(theme) {
  return createStyles$1({
    headerButton: {
      marginRight: theme.spacing(1)
    },
    headerButtonIconSmall: {
      fontSize: 20,
      marginRight: theme.spacing(1)
    }
  });
};
var useStyles$d = makeStyles(styles$c);
var styles$d = function styles$d(theme) {
  return createStyles$1({
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      minHeight: "42px",
      boxSizing: 'content-box',
      zIndex: 1
    },
    containerExtendMargins: {
      marginLeft: -theme.spacing(2),
      marginRight: -theme.spacing(2)
    },
    stickyHelper: {
      height: "1px",
      bottom: 0
    }
  });
};
var useStyles$e = makeStyles(styles$d);
var Footer = React__default.memo(function (props) {
  var _a;
  var classes = useStyles$e();
  return React__default.createElement(Paper, {
    className: classNames(classes.container, (_a = {}, _a[classes.containerExtendMargins] = props.compensateForMargins, _a)),
    square: true
  }, props.children);
});
var styles$e = function styles$e(theme) {
  return createStyles$1({
    header: {
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(2),
      // zIndex: 2,
      minHeight: '36px',
      boxSizing: 'content-box'
    }
  });
};
var useStyles$f = makeStyles(styles$e);
var Header = function Header(props) {
  var classes = useStyles$f();
  var theme = useTheme();
  return React__default.createElement(MuiThemeProvider, {
    theme: theme
  }, React__default.createElement("div", {
    className: classes.header
  }, props.children));
};
var styles$f = function styles$f(theme) {
  return createStyles$1({
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: "1 1",
      minHeight: "1px"
    },
    contentWithOverflow: {
      overflowY: "auto",
      height: 0,
      flex: '1 1 auto'
    },
    contentWithPadding: {
      padding: theme.spacing(2)
    },
    '@keyframes fade': {
      from: {
        opacity: 1
      },
      to: {
        opacity: 0.4
      }
    },
    loadingProgress: {
      top: '50%',
      position: 'absolute',
      alignSelf: 'center'
    },
    disabled: {
      animationName: '$fade',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
      pointerEvents: "none"
    }
  });
};
var useStyles$g = makeStyles(styles$f);
var HeaderAndContent = React__default.memo(function (props) {
  var _a, _b;
  var classes = useStyles$g();
  var showHeader = props.showHeader !== undefined ? props.showHeader : true;
  return React__default.createElement("div", {
    className: classNames(classes.container, props.containerClassName, (_a = {}, _a[classes.disabled] = props.disabled || props.isBusy, _a))
  }, showHeader && React__default.createElement(Header, null, props.header && props.header()), React__default.createElement("div", {
    className: classNames(classes.content, (_b = {}, _b[classes.contentWithPadding] = !props.removePadding, _b[classes.contentWithOverflow] = !props.removeVerticalScroll, _b))
  }, props.isBusy && React__default.createElement(CircularProgress, {
    className: classes.loadingProgress,
    size: 60
  }), props.children), props.footer && React__default.createElement(Footer, null, props.footer()));
});
var ButtonsHeaderAndContent = React__default.memo(function (props) {
  var classes = useStyles$d({});
  var header = useCallback(function () {
    return React__default.createElement(React__default.Fragment, null, props.buttons.map(function (button, i) {
      return React__default.createElement(Button$1, {
        className: classes.headerButton,
        onClick: button.onClick,
        disabled: button.disabled
      }, button.icon && button.icon());
    }));
  }, [props.buttons, classes.headerButtonIconSmall, classes.headerButton]);
  return React__default.createElement(HeaderAndContent, _assign2({
    header: header
  }, props), props.children);
});
var styles$g = function styles$g(theme) {
  return createStyles$1({
    leftsideContent: {
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center'
    },
    button: {
      marginLeft: theme.spacing(2)
    },
    buttonProgress: {
      color: theme.palette.secondary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  });
};
var useStyles$h = makeStyles(styles$g);
var FooterSubmit = function FooterSubmit(props) {
  var classes = useStyles$h();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: classes.leftsideContent
  }, props.children), props.hasCancelButton && React__default.createElement(Button$1, {
    className: classes.button,
    onClick: props.cancel
  }, props.cancelButtonLabel), React__default.createElement(Button$1, {
    variant: "contained",
    color: "secondary",
    className: classes.button,
    disabled: props.submitInProgress,
    type: "submit",
    onClick: props.submit,
    onMouseDown: props.onSubmitPress
  }, props.submitButtonLabel, props.submitInProgress && React__default.createElement(CircularProgress$1, {
    size: 24,
    className: classes.buttonProgress
  })));
};
var styles$h = function styles$h() {
  return createStyles$1({
    tabs: {
      color: "white",
      marginTop: "-12px"
    }
  });
};
var useStyles$i = makeStyles(styles$h);
var TabsHeaderAndContent = function TabsHeaderAndContent(props) {
  var _a = useState(0),
    selectedTabIndex = _a[0],
    setSelectedTabIndex = _a[1];
  var classes = useStyles$i();
  var header = function header() {
    return React__default.createElement(Tabs, {
      className: classes.tabs,
      value: selectedTabIndex,
      onChange: function onChange(_, value) {
        return setSelectedTabIndex(value);
      }
    }, props.tabs.map(function (t, i) {
      return React__default.createElement(Tab, {
        key: "Tab" + i,
        label: t.label
      });
    }));
  };
  return React__default.createElement(HeaderAndContent, {
    header: header,
    disabled: props.disabled,
    footer: props.footer,
    removePadding: props.removePadding,
    isBusy: props.isBusy
  }, props.content(selectedTabIndex));
};
var styles$i = function styles$i(theme) {
  return createStyles$1({
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%"
    },
    loadingProgress: {
      top: '50%',
      position: 'absolute',
      alignSelf: 'center'
    },
    alignedRow: {
      '& > div[role="gridcell"]': {
        display: 'flex',
        alignItems: 'center'
      }
    }
  });
};
var useStyles$j = makeStyles(styles$i);
var SelectionBlade = function SelectionBlade(props) {
  var classes = useStyles$j();
  var t = useTranslation()[0];
  var _a = useState(props.selectedItems ? props.selectedItems : []),
    selectedItems = _a[0],
    setSelectedItems = _a[1];
  var _b = useState(false),
    isSubmiting = _b[0],
    setIsSubmiting = _b[1];
  var onBladeClose = useCallback(function () {
    if (props.onClose) {
      if (isSubmiting) {
        props.onClose(selectedItems);
      } else {
        props.onClose(null);
      }
    }
  }, [selectedItems, isSubmiting]);
  useBladeClosing(props.bladeId, function () {
    return true;
  }, onBladeClose);
  var onSelect = useCallback(function (items) {
    setSelectedItems(items);
    if (props.onSelect) {
      props.onSelect(items);
    }
  }, []);
  var onSubmit = useCallback(function () {
    setIsSubmiting(true);
    props.closeBlade();
  }, [props.closeBlade]);
  var showFooter = props.selectionType !== DataGridSelectionType.None;
  var footer = useCallback(function () {
    return showFooter ? React__default.createElement(Footer, null, React__default.createElement(FooterSubmit, {
      hasCancelButton: true,
      cancel: props.closeBlade,
      cancelButtonLabel: t('cancel'),
      submitButtonLabel: props.submitButtonLabel ? t(props.submitButtonLabel) : t('save'),
      submit: onSubmit,
      submitInProgress: false
    }, props.footerSecondary)) : React__default.createElement(React__default.Fragment, null);
  }, [showFooter, onSubmit, t]);
  return React__default.createElement("div", {
    className: classes.container
  }, props.isFetching && React__default.createElement(CircularProgress, {
    className: classes.loadingProgress,
    size: 60
  }), React__default.createElement(GridCard, null, React__default.createElement(DataGridHeader, {
    loading: props.isFetching
  }), React__default.createElement(DataGrid, {
    onSelect: onSelect,
    identifier: props.identifier,
    selectionType: props.selectionType ? props.selectionType : DataGridSelectionType.None,
    rowClass: props.selectionType === DataGridSelectionType.Single || props.selectionType === DataGridSelectionType.SingleOrNone ? classes.alignedRow : "",
    defaultSelection: props.selectedItems,
    items: props.items,
    columnSettings: props.columns,
    externalFilterFn: props.externalFilterFn,
    isExternalFilterEnabled: props.defaultIsExternalFilterEnabled
  })), footer());
};
var SelectionBladeCloseReason;
(function (SelectionBladeCloseReason) {
  SelectionBladeCloseReason["Cancel"] = "Cancel";
  SelectionBladeCloseReason["Save"] = "Save";
})(SelectionBladeCloseReason || (SelectionBladeCloseReason = {}));
var SelectionListBladeType = 'GENERIC_SELECTION_LIST';
var bladeConfig = {
  size: {
    defaultWidth: 800,
    minWidth: 600
  },
  bladeType: SelectionListBladeType,
  title: function title(props) {
    return props.title;
  },
  allowMultipleInstances: false
};
var ContainerComponent = function ContainerComponent(props) {
  var items = useSelector(props.itemsSelector ? props.itemsSelector : function () {
    return props.items ? props.items : [];
  });
  var isFetching = useSelector(props.isFetchingSelector ? props.isFetchingSelector : function () {
    return false;
  });
  var dispatch = useDispatch();
  var closeBlade = useCallback(function () {
    return dispatch(BladeActions.closeBlade(props.bladeId));
  }, [props.bladeId]);
  return React__default.createElement(DataGridContextProvider, null, React__default.createElement(SelectionBlade, {
    items: items,
    columns: props.columns,
    identifier: props.identifier,
    isFetching: isFetching,
    onSelect: props.onSelect,
    onClose: props.onClose,
    closeBlade: closeBlade,
    selectionType: props.selectionType,
    selectedItems: props.selectedItems ? props.selectedItems : [],
    bladeId: props.bladeId,
    idColumn: props.idColumn,
    footerSecondary: props.footerSecondary,
    defaultIsExternalFilterEnabled: props.defaultIsExternalFilterEnabled,
    externalFilterFn: props.externalFilterFn,
    submitButtonLabel: props.submitButtonLabel
  }));
};
var SelectionBladeContainer = withRegisterBlade(bladeConfig)(ContainerComponent);
var notificationsAreaName = "REACT_TOOLS_NOTIFICATIONS_STATE";
var NotificationType;
(function (NotificationType) {
  NotificationType[NotificationType["success"] = 0] = "success";
  NotificationType[NotificationType["error"] = 1] = "error";
  NotificationType[NotificationType["warning"] = 2] = "warning";
  NotificationType[NotificationType["info"] = 3] = "info";
})(NotificationType || (NotificationType = {}));
var ActionTypes$1;
(function (ActionTypes) {
  ActionTypes["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  ActionTypes["REMOVE_NOTIFICATION"] = "REMOVE_NOTIFICATION";
})(ActionTypes$1 || (ActionTypes$1 = {}));
var pushNotification = function pushNotification(message, type, notificationAction) {
  if (type === void 0) {
    type = 'info';
  }
  var notification = {
    key: new Date().getTime() + Math.random(),
    message: message,
    type: type,
    action: notificationAction
  };
  return action(ActionTypes$1.PUSH_NOTIFICATION, notification);
};
var _removeNotification = function removeNotification(notificationKey) {
  return action(ActionTypes$1.REMOVE_NOTIFICATION, notificationKey);
};
var initialState$1 = {
  items: []
};
var notificationsReducer = function notificationsReducer(state, action) {
  if (state === void 0) {
    state = initialState$1;
  }
  switch (action.type) {
    case ActionTypes$1.PUSH_NOTIFICATION:
      {
        return _assign2(_assign2({}, state), {
          items: __spreadArrays(state.items, [action.payload])
        });
      }
    case ActionTypes$1.REMOVE_NOTIFICATION:
      {
        return _assign2(_assign2({}, state), {
          notifications: state.items.filter(function (notification) {
            return notification.key !== action.payload;
          })
        });
      }
    default:
      return state;
  }
};
var Notifier = /** @class */function (_super) {
  __extends(Notifier, _super);
  function Notifier() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.displayed = [];
    _this.storeDisplayed = function (id) {
      _this.displayed = __spreadArrays(_this.displayed, [id]);
    };
    return _this;
  }
  Notifier.prototype.shouldComponentUpdate = function (nextProps) {
    var currentSnacks = this.props.notifications;
    var newSnacks = nextProps.notifications;
    var notExists = false;
    var _loop_1 = function _loop_1(i) {
      if (notExists) {
        return "continue";
      }
      notExists = notExists || !currentSnacks.filter(function (_a) {
        var key = _a.key;
        return newSnacks[i].key === key;
      }).length;
    };
    for (var i = 0; i < newSnacks.length; i += 1) {
      _loop_1(i);
    }
    return notExists;
  };
  Notifier.prototype.componentDidUpdate = function () {
    var _this = this;
    var _a = this.props.notifications,
      notifications = _a === void 0 ? [] : _a;
    notifications.forEach(function (notification) {
      // Do nothing if snackbar is already displayed
      if (_this.displayed.includes(notification.key)) {
        return;
      }
      // Display snackbar using notistack
      var options = {
        variant: notification.type,
        action: notification.action && React__default.createElement(Button, {
          color: "inherit",
          size: "small"
        }, notification.action.label)
      };
      _this.props.enqueueSnackbar(notification.message, options);
      // Keep track of snackbars that we've displayed
      _this.storeDisplayed(notification.key);
      // Dispatch action to remove snackbar from redux store
      _this.props.removeNotification(notification.key);
    });
  };
  Notifier.prototype.render = function () {
    return null;
  };
  return Notifier;
}(React__default.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: state[notificationsAreaName].items
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    removeNotification: function removeNotification(notificationKey) {
      return dispatch(_removeNotification(notificationKey));
    }
  };
};
var NotifierContainer = connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Notifier));
var treeAreaName = "REACT_TOOLS_TREE_STATE";
var CheckboxState;
(function (CheckboxState) {
  CheckboxState["Selected"] = "Selected";
  CheckboxState["SelectedWithChildren"] = "SelectedWithChildren";
})(CheckboxState || (CheckboxState = {}));
var SelectionMode;
(function (SelectionMode) {
  SelectionMode[SelectionMode["None"] = 0] = "None";
  SelectionMode[SelectionMode["SingleSelection"] = 1] = "SingleSelection";
  SelectionMode[SelectionMode["MultipleSelection"] = 2] = "MultipleSelection";
  SelectionMode[SelectionMode["MultipleWithInheritanceSelection"] = 3] = "MultipleWithInheritanceSelection";
})(SelectionMode || (SelectionMode = {}));
var ActionTypes$2;
(function (ActionTypes) {
  ActionTypes["TREE_EXPAND_ITEM"] = "TREE_EXPAND_ITEM";
  ActionTypes["TREE_EXPAND_MODEL"] = "TREE_EXPAND_MODEL";
  ActionTypes["TREE_COLLAPSE_ITEM"] = "TREE_COLLAPSE_ITEM";
  ActionTypes["TREE_COLLAPSE_MODEL"] = "TREE_COLLAPSE_MODEL";
  ActionTypes["TREE_EXPAND_ALL"] = "TREE_EXPAND_ALL";
  ActionTypes["TREE_COLLAPSE_ALL"] = "TREE_COLLAPSE_ALL";
  ActionTypes["TREE_SELECT_ITEM"] = "TREE_SELECT_ITEM";
  ActionTypes["TREE_SELECT_MODEL"] = "TREE_SELECT_MODEL";
  ActionTypes["TREE_UNSELECT_ITEM"] = "TREE_UNSELECT_ITEM";
  ActionTypes["TREE_UNSELECT_MODEL"] = "TREE_UNSELECT_MODEL";
  ActionTypes["TREE_SELECT_ALL"] = "TREE_SELECT_ALL";
  ActionTypes["TREE_UNSELECT_ALL"] = "TREE_UNSELECT_ALL";
  ActionTypes["TREE_FILTER"] = "TREE_FILTER";
  ActionTypes["TREE_INIT"] = "TREE_INIT";
  ActionTypes["SET_ACTION_LOADING"] = "SET_ACTION_LOADING";
  ActionTypes["CLEAR_ACTION_LOADING"] = "CLEAR_ACTION_LOADING";
  ActionTypes["SET_ACTION_ERROR"] = "SET_ACTION_ERROR";
})(ActionTypes$2 || (ActionTypes$2 = {}));
var initTree = function initTree(treeName, items, selectionModel, level) {
  return action(ActionTypes$2.TREE_INIT, {
    treeName: treeName,
    items: items,
    selectionModel: selectionModel,
    level: level
  });
};
var expandItem = function expandItem(treeName, treeItemId) {
  return action(ActionTypes$2.TREE_EXPAND_ITEM, {
    treeName: treeName,
    treeItemId: treeItemId
  });
};
var expandModel = function expandModel(treeName, modelId) {
  return action(ActionTypes$2.TREE_EXPAND_MODEL, {
    treeName: treeName,
    modelId: modelId
  });
};
var collapseItem = function collapseItem(treeName, treeItemId) {
  return action(ActionTypes$2.TREE_COLLAPSE_ITEM, {
    treeName: treeName,
    treeItemId: treeItemId
  });
};
var collapseModel = function collapseModel(treeName, modelId) {
  return action(ActionTypes$2.TREE_COLLAPSE_MODEL, {
    treeName: treeName,
    modelId: modelId
  });
};
var expandAll = function expandAll(treeName) {
  return action(ActionTypes$2.TREE_EXPAND_ALL, {
    treeName: treeName
  });
};
var collapseAll = function collapseAll(treeName) {
  return action(ActionTypes$2.TREE_COLLAPSE_ALL, {
    treeName: treeName
  });
};
var selectItem = function selectItem(treeName, treeItemId) {
  return action(ActionTypes$2.TREE_SELECT_ITEM, {
    treeName: treeName,
    treeItemId: treeItemId
  });
};
var selectModel = function selectModel(treeName, modelId) {
  return action(ActionTypes$2.TREE_SELECT_MODEL, {
    treeName: treeName,
    modelId: modelId
  });
};
var unselectItem = function unselectItem(treeName, treeItemId) {
  return action(ActionTypes$2.TREE_UNSELECT_ITEM, {
    treeName: treeName,
    treeItemId: treeItemId
  });
};
var unselectModel = function unselectModel(treeName, modelId) {
  return action(ActionTypes$2.TREE_UNSELECT_MODEL, {
    treeName: treeName,
    modelId: modelId
  });
};
var selectAll = function selectAll(treeName) {
  return action(ActionTypes$2.TREE_SELECT_ALL, {
    treeName: treeName
  });
};
var unselectAll = function unselectAll(treeName) {
  return action(ActionTypes$2.TREE_UNSELECT_ALL, {
    treeName: treeName
  });
};
var filter$1 = function filter$1(treeName, filterValue, arrayFilter) {
  return action(ActionTypes$2.TREE_FILTER, {
    treeName: treeName,
    filterValue: filterValue,
    arrayFilter: arrayFilter
  });
};
var setActionLoading = function setActionLoading(treeName, modelId, actionName) {
  return action(ActionTypes$2.SET_ACTION_LOADING, {
    treeName: treeName,
    modelId: modelId,
    actionName: actionName
  });
};
var clearActionLoading = function clearActionLoading(treeName, modelId, actionName) {
  return action(ActionTypes$2.CLEAR_ACTION_LOADING, {
    treeName: treeName,
    modelId: modelId,
    actionName: actionName
  });
};
var setActionError = function setActionError(treeName, modelId, actionName, error) {
  return action(ActionTypes$2.SET_ACTION_ERROR, {
    treeName: treeName,
    modelId: modelId,
    actionName: actionName,
    error: error
  });
};
var TreeActions = {
  initTree: initTree,
  expandItem: expandItem,
  expandModel: expandModel,
  collapseItem: collapseItem,
  collapseModel: collapseModel,
  expandAll: expandAll,
  collapseAll: collapseAll,
  selectItem: selectItem,
  selectModel: selectModel,
  unselectItem: unselectItem,
  unselectModel: unselectModel,
  selectAll: selectAll,
  unselectAll: unselectAll,
  filter: filter$1,
  setActionLoading: setActionLoading,
  clearActionLoading: clearActionLoading,
  setActionError: setActionError
};
var getTreeState = function getTreeState(state, treeName) {
  return state[treeAreaName][treeName] || {};
};
var selectTreeItems = function selectTreeItems(state, treeName) {
  var treeState = getTreeState(state, treeName);
  return treeState.items;
};
var selectVisibleTree = function selectVisibleTree(state, treeName) {
  var treeState = getTreeState(state, treeName);
  if (treeState.filterValue === "" && !treeState.arrayFilter.length) {
    return treeState.unfilteredTree;
  } else {
    return treeState.filteredTree;
  }
};
var selectSelectionMode = function selectSelectionMode(state, treeName) {
  var treeState = getTreeState(state, treeName);
  return treeState.selectionMode;
};
var selectSelectedItems = function selectSelectedItems(state, treeName) {
  var treeState = getTreeState(state, treeName);
  return treeState.selectedItems;
};
var selectSelectedTreeItems = function selectSelectedTreeItems(state, treeName) {
  var treeState = getTreeState(state, treeName);
  return Object.keys(treeState.selectedItems).map(function (treeItemId) {
    return treeState.items[treeItemId];
  });
};
var selectActionState = function selectActionState(state, treeName) {
  var treeState = getTreeState(state, treeName);
  return treeState.itemActions;
};
var TreeSelectors = {
  selectTreeItems: selectTreeItems,
  selectVisibleTree: selectVisibleTree,
  selectSelectionMode: selectSelectionMode,
  selectSelectedItems: selectSelectedItems,
  selectActionState: selectActionState,
  selectSelectedTreeItems: selectSelectedTreeItems
};
var expandItem$1 = function expandItem$1(state, id) {
  var unfilteredTree = batchExpand(state.items, state.unfilteredTree, [id]);
  var filteredTree = getFilteredTree(state.items, unfilteredTree);
  return _assign2(_assign2({}, state), {
    unfilteredTree: unfilteredTree,
    filteredTree: filteredTree
  });
};
var expandModel$1 = function expandModel$1(state, modelId) {
  var treeItem = denormalize(state.items).find(function (e) {
    return e.modelId === modelId;
  });
  if (treeItem && treeItem.treeId !== "/1") {
    return expandItem$1(state, treeItem.treeId);
  }
  return state;
};
var collapseItem$1 = function collapseItem$1(state, id) {
  var unfilteredTree = batchCollapse(state.items, state.unfilteredTree, [id]);
  var filteredTree = getFilteredTree(state.items, unfilteredTree);
  return _assign2(_assign2({}, state), {
    unfilteredTree: unfilteredTree,
    filteredTree: filteredTree
  });
};
var collapseModel$1 = function collapseModel$1(state, modelId) {
  var treeItem = denormalize(state.items).find(function (e) {
    return e.modelId === modelId;
  });
  if (treeItem) {
    return collapseItem$1(state, treeItem.treeId);
  }
  return state;
};
var expandAll$1 = function expandAll$1(state) {
  var nextExpanded = Object.keys(state.items).filter(function (k) {
    return state.items[k].hasChildren;
  });
  return batchUpdate(state, nextExpanded);
};
var collapseAll$1 = function collapseAll$1(state) {
  var nextExpanded = state.expandedDefault;
  return batchUpdate(state, nextExpanded);
};
var batchUpdate = function batchUpdate(state, expandedIds) {
  var previousExpanded = getExpandedOfTree(state);
  var toCollapse = previousExpanded._difference(expandedIds);
  var toExpand = expandedIds._difference(previousExpanded);
  var unfilteredTree = batchCollapse(state.items, state.unfilteredTree, toCollapse);
  unfilteredTree = batchExpand(state.items, unfilteredTree, toExpand);
  var filteredTree = getFilteredTree(state.items, unfilteredTree);
  return _assign2(_assign2({}, state), {
    unfilteredTree: unfilteredTree,
    filteredTree: filteredTree
  });
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var batchExpand = function batchExpand(items, tree, ids) {
  var itemsIds = Object.keys(items);
  var result = __spreadArrays(tree);
  ids.reverse().forEach(function (id) {
    if (result.indexOf(id) === -1) {
      items[id].isExpanded = true;
    } else {
      result = main$1.expandRow(items, itemsIds, result, id);
    }
  });
  return result;
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var batchCollapse = function batchCollapse(items, tree, ids) {
  var result = __spreadArrays(tree);
  ids.forEach(function (id) {
    if (result.indexOf(id) === -1) {
      items[id].isExpanded = false;
    } else {
      result = main$1.collapseRow(items, result, id);
    }
  });
  return result;
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var expandRow = function expandRow(normalizedTreeItems, itemsIds, tree, id) {
  var parent = normalizedTreeItems[id];
  if (!parent) {
    return tree;
  }
  var childNodes = [];
  var i = parent.flatListIndex + 1;
  var parentStack = [parent];
  var parentStackExpandedCount = 1;
  parent.isExpanded = true;
  while (i < itemsIds.length) {
    var currentNode = normalizedTreeItems[itemsIds[i]];
    if (currentNode.level <= parent.level) {
      break;
    }
    // current parent is the last in the stack
    var currentParent = parentStack[parentStack.length - 1];
    // if the current parent is not a direct child of the current parent then we have to remove the current parent from the stack
    while (currentNode.level <= currentParent.level) {
      parentStack.pop();
      if (currentParent.isExpanded) {
        parentStackExpandedCount--;
      }
      currentParent = parentStack[parentStack.length - 1];
    }
    // every parent in the stack is expanded only if the expanded count is equal to the stack count
    var allParentsExpanded = parentStackExpandedCount === parentStack.length;
    // add the current node only if
    if (currentNode.treeParentId === currentParent.treeId && allParentsExpanded) {
      childNodes.push(currentNode);
    }
    // if the current node is a parent itself, then add it to the stack of parents
    if (currentNode.hasChildren) {
      parentStack.push(currentNode);
      // if it's also expanded then increase the count of expanded parents
      if (currentNode.isExpanded) {
        parentStackExpandedCount++;
      }
    }
    i++;
  }
  var result = __spreadArrays(tree);
  result.splice.apply(result, __spreadArrays([result.indexOf(id) + 1, 0], childNodes.map(function (i) {
    return i.treeId;
  })));
  return result;
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var collapseRow = function collapseRow(normalizedTreeItems, tree, id) {
  var rowIndex = tree.indexOf(id);
  if (rowIndex === -1) {
    return tree;
  }
  var item = normalizedTreeItems[tree[rowIndex]];
  var startIndex = rowIndex + 1;
  var stopIndex = -1;
  var i = startIndex;
  var endNotFound = true;
  if (normalizedTreeItems[tree[startIndex]].level <= item.level) {
    return tree;
  }
  while (endNotFound) {
    i++;
    if (i === tree.length) {
      stopIndex = i;
      endNotFound = false;
      continue;
    }
    if (normalizedTreeItems[tree[i]].level <= item.level) {
      stopIndex = i;
      endNotFound = false;
    }
  }
  item.isExpanded = false;
  var result = __spreadArrays(tree);
  result.splice(startIndex, stopIndex - startIndex);
  return result;
};
var getExpandedOfTree = function getExpandedOfTree(state) {
  return denormalize(state.items).filter(function (i) {
    return i.isExpanded;
  }).map(function (i) {
    return i.treeId;
  });
};
var getFilteredTree = function getFilteredTree(items, unfilteredTree) {
  return unfilteredTree.filter(function (i) {
    var item = items[i];
    return item.match !== null || item.hasChildrenMatched;
  });
};
var main$1 = {
  expandRow: expandRow,
  collapseRow: collapseRow
};
var selectItem$1 = function selectItem$1(state, treeItemId) {
  var selectedItems = selectRow(state, treeItemId);
  return _assign2(_assign2({}, state), {
    selectedItems: selectedItems
  });
};
var selectModel$1 = function selectModel$1(state, modelId) {
  var treeItem = denormalize(state.items).find(function (e) {
    return e.modelId === modelId;
  });
  if (treeItem) {
    return _assign2(_assign2({}, state), {
      selectedItems: selectRow(state, treeItem.treeId)
    });
  }
  return state;
};
var unselectItem$1 = function unselectItem$1(state, treeItemId) {
  var selectedItems = unselectRow(state, treeItemId);
  return _assign2(_assign2({}, state), {
    selectedItems: selectedItems
  });
};
var unselectModel$1 = function unselectModel$1(state, modelId) {
  var treeItem = denormalize(state.items).find(function (e) {
    return e.modelId === modelId;
  });
  if (treeItem) {
    return _assign2(_assign2({}, state), {
      selectedItems: unselectRow(state, treeItem.treeId)
    });
  }
  return state;
};
var selectAll$1 = function selectAll$1(state) {
  var selectedItems = selectAllRows(state);
  return _assign2(_assign2({}, state), {
    selectedItems: selectedItems
  });
};
var unselectAll$1 = function unselectAll$1(state) {
  var selectedItems = {};
  return _assign2(_assign2({}, state), {
    selectedItems: selectedItems
  });
};
var selectAllRows = function selectAllRows(treeState) {
  var ids = Object.keys(treeState.items);
  var root = ids[0];
  var selection = {};
  switch (treeState.selectionMode) {
    case SelectionMode.MultipleWithInheritanceSelection:
      selection = selectRow(treeState, root);
      break;
    case SelectionMode.MultipleSelection:
      ids.forEach(function (i) {
        return selection[i] = {
          state: CheckboxState.Selected,
          selected: true,
          isIndeterminate: false,
          selectedChildrenCount: 0
        };
      });
      break;
  }
  return selection;
};
var selectRow = function selectRow(treeState, selectedTreeItemId) {
  var _a;
  var treeItemIds = Object.keys(treeState.items);
  var selectedTreeItem = treeState.items[selectedTreeItemId];
  var treeSelection = _assign2({}, treeState.selectedItems);
  var currentSelection = treeSelection[selectedTreeItemId] ? treeSelection[selectedTreeItemId] : {
    state: CheckboxState.Selected,
    selected: true,
    isIndeterminate: false,
    selectedChildrenCount: 0
  };
  switch (treeState.selectionMode) {
    case SelectionMode.SingleSelection:
      {
        treeSelection = {};
        treeSelection[selectedTreeItemId] = currentSelection;
        break;
      }
    case SelectionMode.MultipleSelection:
      {
        treeSelection[selectedTreeItemId] = currentSelection;
        break;
      }
    case SelectionMode.MultipleWithInheritanceSelection:
      {
        var addedCount = 0;
        if (selectedTreeItem.hasChildren) {
          _a = inheritSelectionToChildren(selectedTreeItemId, treeState, treeItemIds, treeSelection), treeSelection = _a.treeSelection, addedCount = _a.addedCount;
          if (!treeSelection[selectedTreeItemId]) {
            addedCount++;
          }
          treeSelection[selectedTreeItemId] = {
            isIndeterminate: false,
            selected: true,
            selectedChildrenCount: selectedTreeItem.totalChildCount,
            state: CheckboxState.SelectedWithChildren
          };
        } else {
          treeSelection[selectedTreeItemId] = {
            isIndeterminate: false,
            selected: true,
            selectedChildrenCount: 0,
            state: CheckboxState.Selected
          };
          addedCount = 1;
        }
        treeSelection = parentsSelectionAddCount(selectedTreeItem.treeParentId, treeState, treeSelection, addedCount);
        break;
      }
  }
  return treeSelection;
};
var unselectRow = function unselectRow(treeState, selectedTreeItemId) {
  var _a;
  var treeSelection = _assign2({}, treeState.selectedItems);
  switch (treeState.selectionMode) {
    case SelectionMode.MultipleSelection:
      {
        delete treeSelection[selectedTreeItemId];
        break;
      }
    case SelectionMode.MultipleWithInheritanceSelection:
      switch (treeSelection[selectedTreeItemId].state) {
        case CheckboxState.SelectedWithChildren:
          {
            treeSelection[selectedTreeItemId].state = CheckboxState.Selected;
            var removedCount = 0;
            var treeItemIds = Object.keys(treeState.items);
            _a = removeInheritedSelectionFromChildren(selectedTreeItemId, treeState, treeItemIds, treeSelection), treeSelection = _a.treeSelection, removedCount = _a.removedCount;
            parentsSelectionAddCount(selectedTreeItemId, treeState, treeSelection, -removedCount);
            break;
          }
        case CheckboxState.Selected:
          delete treeSelection[selectedTreeItemId];
          parentsSelectionAddCount(treeState.items[selectedTreeItemId].treeParentId, treeState, treeSelection, -1);
          break;
      }
      break;
    case SelectionMode.SingleSelection:
  }
  return treeSelection;
};
var inheritSelectionToChildren = function inheritSelectionToChildren(selectedTreeItemId, treeState, treeItemIds, treeSelection) {
  var i = treeState.items[selectedTreeItemId].flatListIndex + 1;
  var parentTreeItem = treeState.items[selectedTreeItemId];
  var newlySelectedItemsCount = 0;
  while (i < treeItemIds.length) {
    var currentTreeItem = treeState.items[treeItemIds[i]];
    if (currentTreeItem.level <= parentTreeItem.level) {
      break;
    }
    if (!treeSelection[currentTreeItem.treeId]) {
      newlySelectedItemsCount++;
    }
    treeSelection[currentTreeItem.treeId] = {
      isIndeterminate: false,
      selected: true,
      selectedChildrenCount: currentTreeItem.totalChildCount,
      state: currentTreeItem.hasChildren ? CheckboxState.SelectedWithChildren : CheckboxState.Selected
    };
    i++;
  }
  return {
    treeSelection: treeSelection,
    addedCount: newlySelectedItemsCount
  };
};
var removeInheritedSelectionFromChildren = function removeInheritedSelectionFromChildren(parentTreeItemId, treeState, treeItemIds, treeSelection) {
  var i = treeState.items[parentTreeItemId].flatListIndex + 1;
  var parentTreeItem = treeState.items[parentTreeItemId];
  var removedCount = 0;
  while (i < treeItemIds.length) {
    var currentTreeItem = treeState.items[treeItemIds[i]];
    if (currentTreeItem.level <= parentTreeItem.level) {
      break;
    }
    if (!treeSelection[currentTreeItem.treeId]) {
      i++;
      continue;
    }
    delete treeSelection[currentTreeItem.treeId];
    removedCount++;
    i++;
  }
  return {
    treeSelection: treeSelection,
    removedCount: removedCount
  };
};
var parentsSelectionAddCount = function parentsSelectionAddCount(treeItemId, treeState, treeSelection, itemsToAdd) {
  var currentItem = treeState.items[treeItemId];
  while (currentItem) {
    var itemSelection = treeSelection[currentItem.treeId];
    if (!itemSelection) {
      itemSelection = {
        isIndeterminate: currentItem.totalChildCount !== itemsToAdd,
        selectedChildrenCount: itemsToAdd,
        state: CheckboxState.SelectedWithChildren,
        selected: false
      };
      treeSelection[currentItem.treeId] = itemSelection;
      itemsToAdd++;
    } else {
      itemSelection.selectedChildrenCount += itemsToAdd;
    }
    switch (itemSelection.selectedChildrenCount) {
      case 0:
        {
          itemSelection.isIndeterminate = false;
          break;
        }
      case currentItem.totalChildCount:
        {
          itemSelection.state = CheckboxState.SelectedWithChildren;
          itemSelection.isIndeterminate = false;
          break;
        }
      default:
        {
          itemSelection.isIndeterminate = true;
          itemSelection.state = CheckboxState.SelectedWithChildren;
        }
    }
    if (!itemSelection.isIndeterminate && itemSelection.selectedChildrenCount === 0) {
      if (!itemSelection.selected) {
        delete treeSelection[currentItem.treeId];
        itemsToAdd--;
      } else {
        treeSelection[currentItem.treeId].state = CheckboxState.Selected;
      }
    }
    currentItem = treeState.items[currentItem.treeParentId];
  }
  return treeSelection;
};
var filter$2 = function filter$2(state, filterValue, arrayFilter) {
  return filterValue || arrayFilter ? applyFilter(state, filterValue, arrayFilter) : clearFilter(state);
};
var clearFilter = function clearFilter(state) {
  if (state.filterValue === "" && state.arrayFilter.length === 0) {
    return state;
  }
  clearMatchProperties(denormalize(state.items));
  var nextState = batchUpdate(state, state.expandedBeforeFilter);
  return _assign2(_assign2({}, nextState), {
    filterValue: "",
    arrayFilter: [],
    expandedBeforeFilter: []
  });
};
var applyFilter = function applyFilter(state, filterValue, arrayFilter) {
  var normalizedItems = state.items;
  var items = denormalize(normalizedItems);
  clearMatchProperties(items);
  var previousExpanded = getExpandedOfTree(state);
  var matches = items;
  if (arrayFilter && arrayFilter.length) {
    matches = matchInclusionInArray(matches, arrayFilter);
  }
  matches = stringSearchMatch(matches, filterValue);
  var nextExpanded = findParentsOfMatches(normalizedItems, matches);
  var nextState = batchUpdate(state, nextExpanded);
  nextState.filterValue = filterValue;
  nextState.arrayFilter = arrayFilter ? arrayFilter : [];
  if (state.filterValue === "" && !state.arrayFilter.length) {
    nextState.expandedBeforeFilter = __spreadArrays(previousExpanded);
  }
  return nextState;
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var stringSearchMatch = function stringSearchMatch(items, filterValue) {
  var value = filterValue.toLowerCase();
  return items.reduce(function (o, item) {
    var matchIndex = item.label.toLowerCase().indexOf(value);
    if (matchIndex !== -1) {
      item.match = [matchIndex, matchIndex + value.length - 1];
      o.push(item);
    }
    return o;
  }, []);
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var matchInclusionInArray = function matchInclusionInArray(items, toMatchArray) {
  return items.filter(function (item) {
    return !!toMatchArray.find(function (e) {
      return e === item.modelId;
    });
  }).map(function (e) {
    e.match = [0, 0];
    return e;
  });
};
/**
 * Do not use outside of module.
 * Only exported for testing purposes.
 */
var findParentsOfMatches = function findParentsOfMatches(normalizedItems, matches) {
  var result = [];
  for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
    var item = matches_1[_i];
    if (!item.treeParentId) {
      continue;
    }
    var parent_1 = normalizedItems[item.treeParentId];
    parent_1.hasChildrenMatched = true;
    if (result.indexOf(parent_1.treeId) === -1) {
      result.push(parent_1.treeId);
    }
    matches.push(parent_1);
  }
  return result.sort();
};
var clearMatchProperties = function clearMatchProperties(items) {
  items.forEach(function (item) {
    item.match = null;
    item.hasChildrenMatched = false;
  });
};
var build$1 = function build$1(dataItems) {
  var firstLevel = buildTree(dataItems);
  var treeItems = [];
  firstLevel.forEach(function (node) {
    return treeItems = __spreadArrays(treeItems, [node.item], depthFirst(node));
  });
  var items = treeItems.reduce(function (obj, treeItem, index) {
    treeItem.flatListIndex = index;
    obj[treeItem.treeId] = treeItem;
    return obj;
  }, {});
  return items;
};
var buildTree = function buildTree(list) {
  var lookup = {};
  var firstLevel = [];
  list.forEach(function (item) {
    if (lookup[item.id]) {
      return;
    }
    var parent = lookup[item.parentId];
    if (parent) {
      var child = {
        modelId: item.id,
        modelParentId: item.parentId,
        hasChildren: false,
        isExpanded: false,
        label: item.name,
        level: parent.item.level + 1,
        treeId: parent.item.treeId + "/" + (parent.children.length + 1),
        treeParentId: parent.item.treeId,
        flatListIndex: 0,
        totalChildCount: 0,
        match: null,
        hasChildrenMatched: false
      };
      var node = {
        item: child,
        children: []
      };
      parent.children.push(node);
      parent.item.hasChildren = true;
      lookup[item.id] = node;
      updateParentsChildCount(lookup, parent);
    } else {
      lookup[item.id] = {
        item: {
          modelId: item.id,
          modelParentId: item.parentId,
          hasChildren: false,
          isExpanded: false,
          label: item.name,
          level: 1,
          treeId: "/" + (firstLevel.length + 1),
          treeParentId: "",
          flatListIndex: 0,
          totalChildCount: 0,
          match: null,
          hasChildrenMatched: false
        },
        children: []
      };
      firstLevel.push(lookup[item.id]);
    }
  });
  return firstLevel;
};
var updateParentsChildCount = function updateParentsChildCount(lookup, node) {
  while (node) {
    node.item.totalChildCount++;
    node = lookup[node.item.modelParentId];
  }
};
var depthFirst = function depthFirst(node) {
  var subtree = [];
  for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
    var child = _a[_i];
    subtree.push(child.item);
    subtree = subtree.concat(depthFirst(child));
  }
  return subtree;
};
var initTree$1 = function initTree$1(treeName, dataItems, selectionMode, level) {
  if (selectionMode === void 0) {
    selectionMode = SelectionMode.SingleSelection;
  }
  if (level === void 0) {
    level = 1;
  }
  var items = build$1(dataItems);
  var _a = expandToLevel(items, level),
    tree = _a.tree,
    expanded = _a.expanded;
  return {
    treeName: treeName,
    items: items,
    expandedDefault: __spreadArrays(expanded),
    expandedBeforeFilter: [],
    unfilteredTree: tree,
    filteredTree: [],
    selectionMode: selectionMode,
    selectedItems: {},
    itemActions: {},
    filterValue: "",
    arrayFilter: [],
    pickSelectionOn: false,
    previousSelection: {},
    selectedItemId: ""
  };
};
var expandToLevel = function expandToLevel(items, level) {
  var itemIds = Object.keys(items);
  var tree = itemIds.filter(function (id) {
    return items[id].level <= level;
  });
  var expanded = tree.map(function (id) {
    return items[id];
  }).filter(function (item) {
    return item.level <= level - 1;
  }).map(function (item) {
    item.isExpanded = true;
    return item.treeId;
  });
  return {
    tree: tree,
    expanded: expanded
  };
};
var TreeReducer = function TreeReducer(state, action) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  if (state === void 0) {
    state = {};
  }
  switch (action.type) {
    case ActionTypes$2.TREE_INIT:
      {
        var _z = action.payload,
          treeName = _z.treeName,
          items = _z.items,
          selectionModel = _z.selectionModel,
          level = _z.level;
        return _assign2(_assign2({}, state), (_a = {}, _a[treeName] = initTree$1(treeName, items, selectionModel, level), _a));
      }
    case ActionTypes$2.TREE_EXPAND_ITEM:
      {
        var _0 = action.payload,
          treeItemId = _0.treeItemId,
          treeName = _0.treeName;
        return _assign2(_assign2({}, state), (_b = {}, _b[treeName] = expandItem$1(state[treeName], treeItemId), _b));
      }
    case ActionTypes$2.TREE_EXPAND_MODEL:
      {
        var _1 = action.payload,
          modelId = _1.modelId,
          treeName = _1.treeName;
        var treeState = state[treeName];
        return _assign2(_assign2({}, state), (_c = {}, _c[treeName] = expandModel$1(treeState, modelId), _c));
      }
    case ActionTypes$2.TREE_COLLAPSE_ITEM:
      {
        var _2 = action.payload,
          treeItemId = _2.treeItemId,
          treeName = _2.treeName;
        return _assign2(_assign2({}, state), (_d = {}, _d[treeName] = collapseItem$1(state[treeName], treeItemId), _d));
      }
    case ActionTypes$2.TREE_COLLAPSE_MODEL:
      {
        var _3 = action.payload,
          modelId = _3.modelId,
          treeName = _3.treeName;
        var treeState = state[treeName];
        return _assign2(_assign2({}, state), (_e = {}, _e[treeName] = collapseModel$1(treeState, modelId), _e));
      }
    case ActionTypes$2.TREE_COLLAPSE_ALL:
      {
        var treeName = action.payload.treeName;
        return _assign2(_assign2({}, state), (_f = {}, _f[treeName] = collapseAll$1(state[treeName]), _f));
      }
    case ActionTypes$2.TREE_EXPAND_ALL:
      {
        var treeName = action.payload.treeName;
        return _assign2(_assign2({}, state), (_g = {}, _g[treeName] = expandAll$1(state[treeName]), _g));
      }
    case ActionTypes$2.TREE_SELECT_ITEM:
      {
        var _4 = action.payload,
          treeName = _4.treeName,
          treeItemId = _4.treeItemId;
        var treeState = state[treeName];
        if (treeState.pickSelectionOn) {
          return state;
        }
        return _assign2(_assign2({}, state), (_h = {}, _h[treeName] = selectItem$1(treeState, treeItemId), _h));
      }
    case ActionTypes$2.TREE_SELECT_MODEL:
      {
        var _5 = action.payload,
          treeName = _5.treeName,
          modelId = _5.modelId;
        var treeState = state[treeName];
        if (treeState.pickSelectionOn) {
          return state;
        }
        return _assign2(_assign2({}, state), (_j = {}, _j[treeName] = selectModel$1(treeState, modelId), _j));
      }
    case ActionTypes$2.TREE_UNSELECT_ITEM:
      {
        var _6 = action.payload,
          treeName = _6.treeName,
          treeItemId = _6.treeItemId;
        return _assign2(_assign2({}, state), (_k = {}, _k[treeName] = unselectItem$1(state[treeName], treeItemId), _k));
      }
    case ActionTypes$2.TREE_UNSELECT_MODEL:
      {
        var _7 = action.payload,
          treeName = _7.treeName,
          modelId = _7.modelId;
        return _assign2(_assign2({}, state), (_l = {}, _l[treeName] = unselectModel$1(state[treeName], modelId), _l));
      }
    case ActionTypes$2.TREE_SELECT_ALL:
      {
        var treeName = action.payload.treeName;
        return _assign2(_assign2({}, state), (_m = {}, _m[treeName] = selectAll$1(state[treeName]), _m));
      }
    case ActionTypes$2.TREE_UNSELECT_ALL:
      {
        var treeName = action.payload.treeName;
        return _assign2(_assign2({}, state), (_o = {}, _o[treeName] = unselectAll$1(state[treeName]), _o));
      }
    case ActionTypes$2.TREE_FILTER:
      {
        var _8 = action.payload,
          treeName = _8.treeName,
          arrayFilter = _8.arrayFilter,
          filterValue = _8.filterValue;
        return _assign2(_assign2({}, state), (_p = {}, _p[treeName] = filter$2(state[treeName], filterValue, arrayFilter), _p));
      }
    case ActionTypes$2.SET_ACTION_LOADING:
      {
        var _9 = action.payload,
          actionName = _9.actionName,
          modelId_1 = _9.modelId,
          treeName = _9.treeName;
        var treeState_1 = state[treeName];
        var treeItemId = Object.keys(treeState_1.items).find(function (k) {
          return treeState_1.items[k].modelId === modelId_1;
        });
        if (treeItemId) {
          return _assign2(_assign2({}, state), (_q = {}, _q[treeName] = _assign2(_assign2({}, treeState_1), {
            itemActions: _assign2(_assign2({}, treeState_1.itemActions), (_r = {}, _r[treeItemId] = _assign2(_assign2({}, treeState_1.itemActions[treeItemId]), (_s = {}, _s[actionName] = {
              inProgress: true,
              error: null
            }, _s)), _r))
          }), _q));
        }
        return _assign2({}, state);
      }
    case ActionTypes$2.CLEAR_ACTION_LOADING:
      {
        var _10 = action.payload,
          actionName = _10.actionName,
          modelId_2 = _10.modelId,
          treeName = _10.treeName;
        var treeState_2 = state[treeName];
        var treeItemId = Object.keys(treeState_2.items).find(function (k) {
          return treeState_2.items[k].modelId === modelId_2;
        });
        if (treeItemId) {
          return _assign2(_assign2({}, state), (_t = {}, _t[treeName] = _assign2(_assign2({}, treeState_2), {
            itemActions: _assign2(_assign2({}, treeState_2.itemActions), (_u = {}, _u[treeItemId] = _assign2(_assign2({}, treeState_2.itemActions[treeItemId]), (_v = {}, _v[actionName] = {
              inProgress: false,
              error: null
            }, _v)), _u))
          }), _t));
        }
        return _assign2({}, state);
      }
    case ActionTypes$2.SET_ACTION_ERROR:
      {
        var _11 = action.payload,
          actionName = _11.actionName,
          modelId_3 = _11.modelId,
          treeName = _11.treeName,
          error = _11.error;
        var treeState_3 = state[treeName];
        var treeItemId = Object.keys(treeState_3.items).find(function (k) {
          return treeState_3.items[k].modelId === modelId_3;
        });
        if (treeItemId) {
          return _assign2(_assign2({}, state), (_w = {}, _w[treeName] = _assign2(_assign2({}, treeState_3), {
            itemActions: _assign2(_assign2({}, treeState_3.itemActions), (_x = {}, _x[treeItemId] = _assign2(_assign2({}, treeState_3.itemActions[treeItemId]), (_y = {}, _y[actionName] = {
              inProgress: false,
              error: error
            }, _y)), _x))
          }), _w));
        }
        return _assign2({}, state);
      }
    default:
      return state;
  }
};
var styles$j = function styles$j(theme) {
  return createStyles$1({
    treeMeasure: {
      flexGrow: 1,
      display: 'flex'
    },
    treeFixedList: {
      "overflow-x": 'scroll !important',
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
        cursor: "pointer",
        background: "#2B3338"
      },
      "&::webkit-scrollbar-track": {
        background: "#65686E",
        cursor: "pointer"
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#65686E",
        borderRadius: "5px",
        cursor: "pointer",
        "&:hover": {
          background: "#65686E"
        }
      }
    },
    noDataMessage: {
      margin: "auto"
    }
  });
};
var useStyles$k = makeStyles(styles$j);
var styles$k = function styles$k(theme) {
  return createStyles$1({
    matchedText: {
      textDecoration: "underline",
      fontStyle: 'italic'
    },
    label: {
      textOverflow: 'clip'
    },
    hiddenLabel: {
      display: 'flex',
      opacity: 0,
      position: 'absolute'
    },
    visibleLabel: {
      display: 'flex',
      marginTop: theme.spacing(0.5),
      zIndex: 99
    }
  });
};
var useStyles$l = makeStyles(styles$k);
var SelectionCheckbox = function SelectionCheckbox(_a) {
  var item = _a.item,
    id = _a.id;
  var color = item && item.selected ? 'secondary' : 'primary';
  return React__default.createElement(CheckboxComponent, {
    disableRipple: true,
    color: color,
    checkedIcon: getIcon(item),
    checked: item !== undefined,
    style: {
      paddingLeft: '8px'
    }
  });
};
var getIcon = function getIcon(item) {
  if (!item) {
    return React__default.createElement(CheckBox, null);
  }
  switch (item.state) {
    case CheckboxState.SelectedWithChildren:
      return item.isIndeterminate ? React__default.createElement(IndeterminateCheckBox, null) : React__default.createElement(CheckBox, null);
    case CheckboxState.Selected:
      return item.isIndeterminate ? React__default.createElement(IndeterminateCheckBoxOutlined, null) : React__default.createElement(CheckBoxOutlined, null);
  }
};
var ExpandButton = function ExpandButton(_a) {
  var item = _a.item,
    onClick = _a.onClick;
  return React__default.createElement(IconButton, {
    "data-key": item.treeId,
    "data-expanded": item.isExpanded,
    centerRipple: true,
    onClick: onClick,
    style: {
      padding: "2px"
    }
  }, item.isExpanded ? React__default.createElement(KeyboardArrowDown, null) : React__default.createElement(KeyboardArrowRight, null));
};
var TreeItemLabel = function TreeItemLabel(_a) {
  var treeItem = _a.treeItem,
    expandChanged = _a.expandChanged,
    multipleSelection = _a.multipleSelection,
    selectedItem = _a.selectedItem,
    visibleLabelWidth = _a.visibleLabelWidth,
    buttonsWidth = _a.buttonsWidth;
  var classes = useStyles$l();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
    className: classes.hiddenLabel,
    style: {
      paddingRight: buttonsWidth + 10
    }
  }, treeItem.hasChildren && React__default.createElement(ExpandButton, {
    item: treeItem,
    onClick: function onClick(e) {
      return expandChanged(e, treeItem);
    }
  }), multipleSelection && React__default.createElement(SelectionCheckbox, {
    item: selectedItem,
    id: treeItem.treeId
  }), React__default.createElement(Label$2, {
    clip: true,
    item: treeItem
  })), React__default.createElement("span", {
    className: classes.visibleLabel,
    style: {
      maxWidth: visibleLabelWidth
    }
  }, treeItem.hasChildren && React__default.createElement(ExpandButton, {
    item: treeItem,
    onClick: function onClick(e) {
      return expandChanged(e, treeItem);
    }
  }), multipleSelection && React__default.createElement(SelectionCheckbox, {
    item: selectedItem,
    id: treeItem.treeId
  }), React__default.createElement(Label$2, {
    clip: false,
    item: treeItem
  })));
};
var Label$2 = function Label$2(_a) {
  var item = _a.item,
    clip = _a.clip;
  var classes = useStyles$l();
  var formatLabel = function formatLabel(value, _a) {
    var start = _a[0],
      end = _a[1];
    return React__default.createElement("span", null, start > 0 && value.slice(0, start), React__default.createElement("span", {
      className: classes.matchedText
    }, value.slice(start, end === 0 ? end : end + 1)), end < value.length && value.slice(end === 0 ? end : end + 1));
  };
  return clip ? React__default.createElement(Typography$1, {
    variant: "body1",
    noWrap: true,
    className: classes.label
  }, item.match ? formatLabel(item.label, item.match) : item.label) : React__default.createElement(Typography$1, {
    variant: "body1",
    noWrap: true
  }, item.match ? formatLabel(item.label, item.match) : item.label);
};
var styles$l = function styles$l(theme) {
  return createStyles({
    treeItem: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      borderLeft: theme.spacing(0.2) + "px solid transparent",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main + " !important",
        "& $hiddenButton": {
          visibility: "visible"
        },
        "& $selectedIndicator": {
          backgroundColor: theme.palette.secondary.main
        }
      },
      "&:focus-within": {}
    },
    treeItemContainer: {
      display: "flex",
      alignItems: "center",
      paddingLeft: function paddingLeft(props) {
        return props.indentation;
      },
      flexGrow: 1,
      height: "100%",
      "&>div": {
        backgroundColor: "transparent"
      }
    },
    selected: {
      backgroundColor: theme.palette.secondary.main + " !important",
      "& $selectedIndicator": {
        backgroundColor: theme.palette.secondary.main
      },
      "& $hiddenButton": {
        visibility: "visible"
      }
    },
    hiddenButton: {
      visibility: "collapse"
    },
    selectedIndicator: {
      width: 5,
      height: "100%",
      backgroundColor: "transparent",
      position: "absolute"
    },
    actions: {
      height: "100%",
      position: "absolute",
      display: "flex",
      width: function width(props) {
        return props.buttonsWidth + theme.spacing(1);
      },
      zIndex: 99,
      "& div": {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        marginRight: theme.spacing(1),
        marginTop: "auto",
        marginBottom: "auto"
      }
    }
  });
};
var useStyles$m = makeStyles(styles$l);
var useTreeContainerOffset = function useTreeContainerOffset(debounceScrollOffsetReadTimeout) {
  if (debounceScrollOffsetReadTimeout === void 0) {
    debounceScrollOffsetReadTimeout = 100;
  }
  var _a = useState(0),
    leftOffset = _a[0],
    setLeftOffset = _a[1];
  var offset = useRef(0);
  var onRefSet = useCallback(function (event) {
    return function () {
      var newOffset = event.target.scrollLeft;
      if (newOffset !== offset.current) {
        offset.current = newOffset;
        setLeftOffset(newOffset);
      }
    };
  }, [leftOffset]);
  var setRef = useCallback(function (node) {
    if (node) {
      var timer_1;
      node.addEventListener('scroll', function (event) {
        if (timer_1 !== null) {
          clearTimeout(timer_1);
        }
        timer_1 = setTimeout(onRefSet(event), debounceScrollOffsetReadTimeout);
      });
    }
  }, []);
  return [setRef, leftOffset];
};
var useTreeItemWidth = function useTreeItemWidth(level, hasChildren, numberOfActions, width, scrollWidth, leftOffset) {
  var indentation = useMemo(function () {
    return 8 * level - 8 + (hasChildren ? 0 : 24);
  }, [level, hasChildren]);
  var buttonsWidth = useMemo(function () {
    return 30 * (numberOfActions ? numberOfActions : 0) + 5;
  }, [numberOfActions]);
  var itemWidth = useMemo(function () {
    return scrollWidth >= width ? scrollWidth + buttonsWidth : scrollWidth;
  }, [scrollWidth, buttonsWidth]);
  var visibleLabelWidth = useMemo(function () {
    return width - indentation - buttonsWidth + leftOffset - 8;
  }, [width, indentation, buttonsWidth, leftOffset]);
  var buttonsRightPosition = useMemo(function () {
    return width + leftOffset - buttonsWidth - 18;
  }, [itemWidth, width, leftOffset]);
  var selectedIndicatorPosition = useMemo(function () {
    return buttonsRightPosition + buttonsWidth + 3;
  }, [buttonsRightPosition, buttonsWidth]);
  return {
    indentation: indentation,
    buttonsWidth: buttonsWidth,
    buttonsRightPosition: buttonsRightPosition,
    visibleLabelWidth: visibleLabelWidth,
    selectedIndicatorPosition: selectedIndicatorPosition
  };
};
var TreeListItem = function TreeListItem(props) {
  var _a;
  var treeItem = props.itemProps.data[props.itemProps.index];
  var selectedItem = props.selectedItems[treeItem.treeId];
  var selected = selectedItem && selectedItem.selected;
  var _b = useTreeItemWidth(treeItem.level, treeItem.hasChildren, props.actions ? props.actions.length : 0, props.width, props.scrollWidth, props.leftOffset),
    indentation = _b.indentation,
    buttonsWidth = _b.buttonsWidth,
    visibleLabelWidth = _b.visibleLabelWidth,
    buttonsRightPosition = _b.buttonsRightPosition;
  var disabledItemStyle = useMemo(function () {
    return props.disableSelection ? {
      pointerEvents: 'none'
    } : {};
  }, [props.disableSelection]);
  var treeItemStyles = _assign2(_assign2(_assign2({}, props.itemProps.style), {
    width: 'auto',
    whiteSpace: 'normal',
    minWidth: '100%'
  }), disabledItemStyle);
  var classes = useStyles$m({
    buttonsWidth: buttonsWidth,
    indentation: indentation
  });
  return React__default.createElement("div", {
    style: treeItemStyles,
    className: classNames(classes.treeItem, (_a = {}, _a[classes.selected] = selected, _a)),
    onClick: function onClick(e) {
      return props.selectionChanged(e, selectedItem, treeItem);
    }
  }, React__default.createElement("div", {
    className: classes.treeItemContainer
  }, React__default.createElement(TreeItemLabel, {
    expandChanged: props.expandChanged,
    selectedItem: selectedItem,
    treeItem: treeItem,
    buttonsWidth: buttonsWidth,
    visibleLabelWidth: visibleLabelWidth
  }), props.actions && React__default.createElement("div", {
    className: classes.actions,
    style: {
      left: buttonsRightPosition
    }
  }, React__default.createElement("div", null, props.actions.map(function (e) {
    var content = e.content(treeItem, selected);
    return content.component(!content.visible ? classes.hiddenButton : "");
  })))), React__default.createElement("div", {
    className: classes.selectedIndicator,
    style: {
      left: props.width - 10,
      width: props.leftOffset
    }
  }));
};
var Tree = function Tree(props) {
  var classes = useStyles$k();
  var _a = useState({
      width: 0,
      height: 0
    }),
    size = _a[0],
    setSize = _a[1];
  var _b = useState(0),
    scrollWidth = _b[0],
    setScrollWidth = _b[1];
  var multipleSelection = useMemo(function () {
    return props.selectionMode === SelectionMode.MultipleSelection || props.selectionMode === SelectionMode.MultipleWithInheritanceSelection;
  }, [props.selectionMode]);
  var items = useMemo(function () {
    return props.visibleTree.map(function (i) {
      return props.items[i];
    });
  }, [props.visibleTree, props.items]);
  var expandChanged = useCallback(function (e, item) {
    e.stopPropagation();
    if (item.isExpanded) {
      props.collapse(item.treeId);
    } else {
      props.expand(item.treeId);
    }
  }, [props.collapse, props.expand]);
  var sizeChanged = useCallback(function (contentRect) {
    if (contentRect && contentRect.bounds) {
      setSize({
        width: contentRect.bounds.width,
        height: contentRect.bounds.height
      });
    }
  }, []);
  var selectionChanged = useCallback(function (event, item, treeItem) {
    if (event) {
      event.stopPropagation();
    }
    var previouslySelected = item && item.selected;
    if (previouslySelected) {
      props.unselect(treeItem.treeId);
    } else {
      props.select(treeItem.treeId);
      if (props.onSelect) {
        props.onSelect(treeItem.modelId, treeItem.treeId);
      }
    }
  }, [props.select, props.unselect]);
  var itemKey = function itemKey(index, data) {
    return data[index].treeId;
  };
  var _c = useTreeContainerOffset(),
    outerRef = _c[0],
    leftScrollOffset = _c[1];
  useEffect(function () {
    var treeContainer = document.getElementById(props.treeName);
    if (treeContainer && treeContainer.children[0]) {
      var treeContainerDiv = treeContainer.children[0];
      setScrollWidth(treeContainerDiv.scrollWidth);
    }
  }, [items]);
  return React__default.createElement(Measure, {
    bounds: true,
    onResize: sizeChanged
  }, function (_a) {
    var measureRef = _a.measureRef;
    return React__default.createElement("div", {
      ref: measureRef,
      className: classes.treeMeasure,
      id: props.treeName
    }, items.length ? React__default.createElement(FixedSizeList, {
      outerRef: outerRef,
      className: classes.treeFixedList,
      height: size.height,
      width: size.width,
      itemCount: items.length,
      itemData: items,
      itemKey: itemKey,
      itemSize: 40,
      style: {
        overflowX: 'hidden',
        display: 'inline-block',
        width: undefined,
        minWidth: '100%'
      },
      overscanCount: 20
    }, function (itemProps) {
      return React__default.createElement(TreeListItem, {
        scrollWidth: scrollWidth,
        leftOffset: leftScrollOffset,
        width: size.width,
        expandChanged: expandChanged,
        itemProps: itemProps,
        selectedItems: props.selectedItems,
        selectionChanged: selectionChanged,
        multipleSelection: multipleSelection,
        key: itemProps.index,
        actions: props.actions,
        disableSelection: props.disableSelection
      });
    }) : React__default.createElement(Typography$1, {
      variant: "body1",
      className: classes.noDataMessage
    }, props.noDataMessage));
  });
};
var TreeContainer = function TreeContainer(props) {
  var dispatch = useDispatch();
  var items = useSelector(function (state) {
    return selectTreeItems(state, props.treeName);
  });
  var visibleTree = useSelector(function (state) {
    return selectVisibleTree(state, props.treeName);
  });
  var selectionMode = useSelector(function (state) {
    return selectSelectionMode(state, props.treeName);
  });
  var selectedItems = useSelector(function (state) {
    return selectSelectedItems(state, props.treeName);
  });
  var actionState = useSelector(function (state) {
    return selectActionState(state, props.treeName);
  });
  var collapse = useCallback(function (treeItemId) {
    return dispatch(collapseItem(props.treeName, treeItemId));
  }, [props.treeName, dispatch]);
  var expand = useCallback(function (treeItemId) {
    return dispatch(expandItem(props.treeName, treeItemId));
  }, [props.treeName, dispatch]);
  var select = useCallback(function (treeItemId) {
    return dispatch(selectItem(props.treeName, treeItemId));
  }, [props.treeName, dispatch]);
  var unselect = useCallback(function (treeItemId) {
    return dispatch(unselectItem(props.treeName, treeItemId));
  }, [props.treeName, dispatch]);
  return items ? React__default.createElement(Tree, {
    noDataMessage: props.noDataMessage,
    disableSelection: props.disableSelection,
    actions: props.actions,
    itemRenderer: props.itemRenderer,
    onSelect: props.onSelect,
    treeName: props.treeName,
    items: items,
    visibleTree: visibleTree,
    selectionMode: selectionMode,
    selectedItems: selectedItems,
    actionState: actionState,
    collapse: collapse,
    expand: expand,
    select: select,
    unselect: unselect
  }) : React__default.createElement("div", null, "Loading");
};
var EntityType;
(function (EntityType) {
  EntityType[EntityType["Brand"] = 1] = "Brand";
  EntityType[EntityType["Workgroup"] = 2] = "Workgroup";
  EntityType[EntityType["Group"] = 3] = "Group";
  EntityType[EntityType["Site"] = 4] = "Site";
  EntityType[EntityType["Hardware"] = 5] = "Hardware";
  EntityType[EntityType["Stream"] = 6] = "Stream";
  EntityType[EntityType["FlashParameter"] = 7] = "FlashParameter";
})(EntityType || (EntityType = {}));
var DeviceSettingType;
(function (DeviceSettingType) {
  DeviceSettingType[DeviceSettingType["text"] = 0] = "text";
  DeviceSettingType[DeviceSettingType["numeric"] = 1] = "numeric";
  DeviceSettingType[DeviceSettingType["timestamp"] = 2] = "timestamp";
  DeviceSettingType[DeviceSettingType["array"] = 3] = "array";
  DeviceSettingType[DeviceSettingType["jsonb"] = 4] = "jsonb";
  DeviceSettingType[DeviceSettingType["boolean"] = 5] = "boolean";
})(DeviceSettingType || (DeviceSettingType = {}));
var useStyles$n = makeStyles$2(function (theme) {
  return createStyles$1({
    fadeIn: {
      height: '100%',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }
    },
    wizardContaier: {
      minHeight: '1px',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%'
    },
    wizardContent: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    centerText: {
      textAlign: 'center'
    },
    dangerZoneMathContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    alignedRow: {
      '& [role="gridcell"]': {
        lineHeight: '36px',
        height: '36px'
      }
    },
    dangerZoneWarningContainer: {
      padding: theme.spacing(1),
      borderTop: "1px solid " + theme.palette.warning.main,
      borderBottom: "1px solid " + theme.palette.warning.main,
      backgroundColor: theme.palette.warning.light,
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-3),
      marginBottom: theme.spacing(3)
    },
    dangerZoneWarningContent: {
      color: theme.palette.warning.contrastText
    },
    dangerZoneInputContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex'
    },
    dangerZoneMath: {
      marginTop: 'auto',
      marginBottom: 'auto',
      marginRight: theme.spacing(1)
    },
    dangerZoneInput: {
      width: 80,
      '& input': {
        fontSize: theme.typography.h5.fontSize,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
      }
    },
    countInputContainer: {
      marginTop: theme.spacing(2)
    },
    countInput: {
      marginTop: theme.spacing(1)
    },
    timerContainer: {
      display: 'flex',
      marginTop: theme.spacing(1),
      position: 'relative'
    },
    progress: {
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    progressText: {
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      top: "calc(50% - " + theme.spacing(3.5) + "px)"
    },
    completedIcon: {
      color: theme.palette.success.main,
      position: 'absolute',
      width: '100%',
      textAlign: 'center',
      fontSize: theme.typography.h2.fontSize,
      top: "calc(50% - " + theme.spacing(4) + "px)"
    },
    spacer: {
      flexGrow: 1
    },
    critDialogCheckRoot: {
      marginLeft: 0
    },
    confirmDialogSummaryAlertIcon: {
      marginBottom: theme.spacing(-0.5)
    },
    centerContainer: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& > div': {
        alignSelf: 'center'
      }
    },
    loadingContainer: {
      flexGrow: 1,
      display: 'flex'
    },
    loading: {
      margin: 'auto'
    }
  });
});
var getRandom$1 = function getRandom$1() {
  return Math.floor(Math.random() * 10);
};
var CriticalSettingUnlockDialog = function CriticalSettingUnlockDialog(_a) {
  var open = _a.open,
    onClose = _a.onClose,
    save = _a.save;
  var t = useTranslation()[0];
  var classes = useStyles$n();
  var _b = useState(0),
    answer = _b[0],
    setAnswer = _b[1];
  var _c = useState(false),
    checked = _c[0],
    setChecked = _c[1];
  var _d = useState(0),
    term1 = _d[0],
    setTerm1 = _d[1];
  var _e = useState(0),
    term2 = _e[0],
    setTerm2 = _e[1];
  useEffect(function () {
    setChecked(false);
    if (open) {
      setTerm1(getRandom$1());
      setTerm2(getRandom$1());
    }
  }, [open]);
  var correctAnswer = term1 + term2;
  var handleFieldChange = useCallback(function (event) {
    return setAnswer(parseFloat(event.target.value));
  }, []);
  var handleCheckboxChange = useCallback(function (_, checked) {
    return setChecked(checked);
  }, []);
  return React__default.createElement(Dialog, {
    onClose: onClose,
    open: open,
    maxWidth: 'sm',
    fullWidth: true
  }, React__default.createElement(DialogTitle, {
    className: classes.centerText
  }, t("warning!")), React__default.createElement(DialogContent$1, null, React__default.createElement("div", {
    className: classes.dangerZoneWarningContainer
  }, React__default.createElement(Typography$1, {
    className: classes.dangerZoneWarningContent,
    variant: 'body1',
    align: 'center'
  }, t("deviceSettings.dangerZoneWarning"))), React__default.createElement(Typography$1, {
    variant: 'body1',
    align: 'center'
  }, t("deviceSettings.dangerZoneReadMe")), React__default.createElement("br", null), React__default.createElement("div", {
    className: classes.dangerZoneMathContainer
  }, React__default.createElement(Typography$1, {
    variant: 'body1',
    align: 'center'
  }, t("deviceSettings.dangerZoneMath")), React__default.createElement("div", {
    className: classes.dangerZoneInputContainer
  }, React__default.createElement(Typography$1, {
    className: classes.dangerZoneMath,
    variant: 'h5'
  }, term1, " + ", term2, " =", " "), React__default.createElement(TextField, {
    autoFocus: true,
    className: classes.dangerZoneInput,
    size: 'small',
    type: 'number',
    variant: 'filled',
    inputProps: {
      min: "0",
      step: "1"
    },
    onChange: handleFieldChange
  })))), React__default.createElement(DialogActions$1, null, React__default.createElement(FormControlLabel, {
    classes: {
      root: classes.critDialogCheckRoot
    },
    control: React__default.createElement(Checkbox, {
      checked: checked,
      onChange: handleCheckboxChange
    }),
    label: t("deviceSettings.dangerZoneCheckbox")
  }), React__default.createElement("div", {
    className: classes.spacer
  }), React__default.createElement(Button, {
    onClick: onClose
  }, t("cancel")), React__default.createElement(Button, {
    variant: 'contained',
    color: 'secondary',
    disabled: !checked || answer !== correctAnswer,
    onClick: save
  }, t("proceed"))));
};
var createObject = function createObject(schema) {
  switch (schema.type) {
    case 'string':
      if (schema.enum && schema.enum.length > 0) {
        return schema.enum[0];
      }
      return '';
    case 'number':
    case 'integer':
      if (schema.enum && schema.enum.length > 0) {
        return schema.enum[0];
      }
      if (schema.minimum) {
        return schema.minimum;
      }
      if (schema.exclusiveMinimum) {
        return schema.exclusiveMinimum + 1;
      }
      return 0;
    case 'array':
      return [];
    case 'boolean':
      return false;
    case 'object':
      {
        if (schema.properties) {
          var sprops_1 = schema.properties;
          return Object.keys(sprops_1).reduce(function (o, k) {
            o[k] = createObject(sprops_1[k]);
            return o;
          }, {});
        }
        if (schema.patternProperties) return {};
      }
    case 'null':
      return null;
    case undefined:
      {
        console.warn("Schema has no schemas defined in anyOf");
        if (schema.anyOf.length === 0) {
          return undefined;
        }
        var nullSchema = schema.anyOf.find(function (s) {
          return s.type === 'null';
        });
        if (nullSchema) {
          return null;
        } else {
          return createObject(schema.anyOf[0]);
        }
      }
  }
};
var safeSettingKey = function safeSettingKey(settingKey) {
  return settingKey.replace(/\./g, '--');
};
var formValuesToNodeIds = function formValuesToNodeIds(formValues) {
  var isObject = function isObject(val) {
    return typeof val === 'object' && !Array.isArray(val);
  };
  var objDelimiter = function objDelimiter(a, b) {
    return a ? a + "." + b : b;
  };
  var arrayDelimiter = function arrayDelimiter(a, b) {
    return a ? a + "[" + b + "]" : b;
  };
  var paths = function paths(obj, head, delimiterFunc) {
    if (obj === void 0) {
      obj = {};
    }
    if (head === void 0) {
      head = '';
    }
    if (delimiterFunc === void 0) {
      delimiterFunc = null;
    }
    if (obj === null || obj === undefined) {
      return [head];
    }
    return Object.entries(obj).reduce(function (product, _a) {
      var key = _a[0],
        value = _a[1];
      var currentDelimiterFunc = delimiterFunc ? delimiterFunc : objDelimiter;
      var fullPath = currentDelimiterFunc(head, key);
      if (isObject(value)) {
        product.push(fullPath);
        return product.concat(paths(value, fullPath));
      } else if (Array.isArray(value)) {
        product.push(fullPath);
        return product.concat(paths(value, fullPath, arrayDelimiter));
      } else {
        return product.concat(fullPath);
      }
    }, []);
  };
  return paths(formValues);
};
var overrideKeyPrefix = '$revert-overrides';
var overrideKey = function overrideKey(settingKey) {
  return overrideKeyPrefix + "." + settingKey;
};
var flattenSettingPath = function flattenSettingPath(setting) {
  return setting.path.reduce(function (p, item, index) {
    if (index === setting.path.length - 1) return p;
    return p + item + (index !== setting.path.length - 2 ? ' / ' : '');
  }, '');
};
var groupSettings = function groupSettings(settings) {
  return settings.reduce(function (groups, setting) {
    var flattenedPath = flattenSettingPath(setting);
    if (!groups.has(flattenedPath)) {
      groups.set(flattenedPath, []);
    }
    var group = groups.get(flattenedPath);
    if (group) {
      group.push(setting);
    }
    return groups;
  }, new Map());
};
var styles$m = function styles$m(theme) {
  return createStyles$1({
    muiTreeItemRoot: {
      '&:focus $muiTreeItemLabel': {
        background: 'transparent !important',
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.04) !important'
        }
      }
    },
    onHoverOnly: {
      visibility: 'hidden'
    },
    muiTreeItemLabel: {
      '&:hover > $onHoverOnly': {
        visibility: 'visible'
      },
      minHeight: '38px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    treeItemDefaultEndIcon: {
      width: '24px'
    },
    labelDivider: {
      height: '24px',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    fixedItemLabel: {
      width: '350px'
    },
    treeItemLabel: {
      marginRight: theme.spacing(2),
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    treeItemLabelTooltipIcon: {
      color: theme.palette.grey[400]
    },
    textField: {
      //minWidth: '300px',
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(2),
      flexGrow: 1,
      '& input': {
        fontSize: theme.typography.body2.fontSize,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
      }
    },
    selectRoot: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    green: {
      color: 'green'
    },
    red: {
      color: 'red'
    },
    arrayItemHeaderContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      height: '24px',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },
    arrayItemHeaderCountLabel: {
      color: theme.palette.grey[500]
    },
    schemaSelect: {
      marginRight: theme.spacing(2)
    },
    fieldContainer: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    form: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      minHeight: '0px',
      height: '0px',
      overflowY: 'auto',
      flex: '1 1 auto',
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
        cursor: 'pointer',
        background: '#D4CCC7'
      },
      '&::webkit-scrollbar-track': {
        background: '#9A9791',
        cursor: 'pointer'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#9A9791',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': {
          background: '#9A9791'
        }
      }
    },
    formContent: {
      flexGrow: 1,
      padding: theme.spacing(2)
    },
    settingGroupCard: {
      marginBottom: theme.spacing(2)
    },
    settingGroupCardRoot: {
      overflow: 'visible'
    },
    spacer: {
      flexGrow: 1
    }
  });
};
var useStyles$o = makeStyles(styles$m);
var calculateSelectedSchema = function calculateSelectedSchema(schema, propKey, value) {
  if (schema.anyOf.length === 0) {
    console.warn("Schema for prop key " + propKey + " has no schemas defined in anyOf");
    return {
      type: 'null'
    };
  }
  var nullSchema = schema.anyOf.find(function (s) {
    return s.type === 'null';
  });
  if (value === undefined) {
    if (nullSchema) return nullSchema;
    return schema.anyOf[0];
  }
  if (value === null) {
    if (!nullSchema) {
      console.warn("Value for prop key " + propKey + " is null but no schema defined for 'null' in anyOf");
    }
    return nullSchema;
  }
  if (Array.isArray(value)) {
    var arraySchema = schema.anyOf.find(function (s) {
      return s.type === 'array';
    });
    if (arraySchema) {
      return arraySchema;
    }
  }
  return schema.anyOf.find(function (s) {
    return typeof value === s.type;
  });
};
var AnyEditor = React__default.memo(function (_a) {
  var schema = _a.schema,
    propKey = _a.propKey,
    value = _a.value,
    readOnly = _a.readOnly,
    labelChildren = _a.labelChildren,
    label = _a.label;
  var classes = useStyles$o();
  var _b = useField(propKey),
    field = _b[0],
    meta = _b[1],
    helpers = _b[2];
  var _c = useState(function () {
      return calculateSelectedSchema(schema, propKey, value);
    }),
    selectedSchema = _c[0],
    setSelectedSchema = _c[1];
  useEffect(function () {
    var newSchema = calculateSelectedSchema(schema, propKey, value);
    setSelectedSchema(newSchema);
  }, [value]);
  var onSchemaChanged = useCallback(function (e, child) {
    var newType = e.target.value;
    var newSchema = schema.anyOf.find(function (s) {
      return s.type === newType;
    });
    if (newSchema) {
      helpers.setValue(createObject(newSchema));
    }
    setSelectedSchema(newSchema);
  }, [setSelectedSchema]);
  var schemaSelect = useMemo(function () {
    return React__default.createElement(Select, {
      value: selectedSchema ? selectedSchema.type : null,
      onChange: onSchemaChanged,
      disableUnderline: true,
      readOnly: readOnly,
      className: classes.schemaSelect
    }, schema.anyOf.map(function (s) {
      return React__default.createElement(MenuItem, {
        key: s.type,
        value: s.type
      }, s.type);
    }));
  }, [onSchemaChanged, selectedSchema, readOnly]);
  if (!selectedSchema) {
    return schemaSelect;
  }
  return React__default.createElement(SettingItem, {
    readOnly: readOnly,
    label: label ? label : propKey,
    propKey: propKey,
    schema: selectedSchema,
    value: value,
    labelChildren: React__default.createElement(React__default.Fragment, null, schemaSelect, React__default.createElement("div", {
      className: classes.spacer
    }), labelChildren)
  });
});
var EditorTreeItem = function EditorTreeItem(props) {
  var classes = useStyles$o();
  return React__default.createElement(TreeItem, _assign2({
    onLabelClick: function onLabelClick(e) {
      var target = e.target;
      if (target.nodeName === 'INPUT') {
        e.stopPropagation();
      }
    }
  }, props, {
    classes: {
      root: classes.muiTreeItemRoot,
      label: classes.muiTreeItemLabel
    }
  }));
};
var TreeItemLabel$1 = function TreeItemLabel$1(props) {
  var classes = useStyles$o();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography$1, {
    className: classNames(classes.treeItemLabel, props.classes ? props.classes.label : null)
  }, props.label + ":"), props.children, React__default.createElement(Tooltip, {
    title: props.tooltip ? props.tooltip : props.label
  }, React__default.createElement(HelpRounded, {
    name: "helpIcon",
    className: classNames([classes.treeItemLabelTooltipIcon, classes.onHoverOnly])
  })));
};
var ArrayFieldEditor = React__default.memo(function (props) {
  var classes = useStyles$o();
  var t = useTranslation()[0];
  return React__default.createElement(FieldArray, {
    name: props.propKey,
    render: function render(arrayHelpers) {
      var properties = arrayHelpers.form.getFieldProps(props.propKey).value;
      return React__default.createElement(EditorTreeItem, {
        nodeId: props.propKey,
        label: React__default.createElement(TreeItemLabel$1, {
          label: props.label ? props.label : props.propKey
        }, React__default.createElement("div", {
          className: classes.spacer
        }), React__default.createElement("div", {
          className: classes.arrayItemHeaderContainer
        }, React__default.createElement(Typography$1, {
          variant: "caption",
          className: classes.arrayItemHeaderCountLabel
        }, (properties ? properties.length : 0) + " items"), React__default.createElement(Tooltip, {
          title: t('settingsEditor.button.addItem').toString()
        }, React__default.createElement(IconButton, {
          disabled: props.readOnly,
          color: "secondary",
          size: "small",
          onClick: function onClick(e) {
            arrayHelpers.push(createObject(props.schema.items));
            e.stopPropagation();
          }
        }, React__default.createElement(AddCircle, null)))), props.labelChildren)
      }, properties && properties.map(function (item, index) {
        return React__default.createElement(SettingItem, {
          readOnly: props.readOnly,
          key: index,
          schema: props.schema.items,
          propKey: props.propKey + "[" + index + "]",
          value: item,
          label: (index + 1).toString(),
          labelChildren: React__default.createElement(React__default.Fragment, null, React__default.createElement(Tooltip, {
            title: t('settingsEditor.button.removeItem').toString()
          }, React__default.createElement(IconButton, {
            disabled: props.readOnly,
            size: "small",
            className: classNames(classes.onHoverOnly),
            onClick: function onClick(e) {
              e.stopPropagation();
              arrayHelpers.remove(index);
            }
          }, React__default.createElement(Delete, null))), React__default.createElement(Tooltip, {
            title: t('settingsEditor.button.cloneItem').toString()
          }, React__default.createElement(IconButton, {
            size: "small",
            disabled: props.readOnly,
            className: classNames(classes.onHoverOnly),
            onClick: function onClick(e) {
              e.stopPropagation();
              var currentValue = arrayHelpers.form.getFieldProps(props.propKey).value[index];
              var clone = JSON.parse(JSON.stringify(currentValue));
              arrayHelpers.push(clone);
            }
          }, React__default.createElement(Copy, null))))
        });
      }));
    }
  });
});
var MemoBooleanEditor = React__default.memo(function (props) {
  var classes = useStyles$o();
  return React__default.createElement(EditorTreeItem, {
    nodeId: props.propKey,
    label: React__default.createElement(TreeItemLabel$1, {
      label: props.label ? props.label : props.propKey,
      classes: {
        label: classes.fixedItemLabel
      },
      tooltip: props.schema.description
    }, React__default.createElement(Switch, {
      disabled: props.readOnly,
      color: 'secondary',
      checked: props.field.value,
      onChange: props.field.onChange,
      name: props.field.name
    }), React__default.createElement("div", {
      className: classes.spacer
    }), props.labelChildren)
  });
}, function (p, n) {
  return p.field.value === n.field.value && p.readOnly === n.readOnly;
});
var BooleanEditor = function BooleanEditor(props) {
  var _a = useField(props.propKey),
    field = _a[0],
    meta = _a[1];
  return React__default.createElement(MemoBooleanEditor, _assign2({}, props, {
    field: field
  }));
};
var KeyEditorDialog = React__default.memo(function (props) {
  var propKey = props.propKey;
  var t = useTranslation()[0];
  var inputRef = useRef(null);
  var onSave = useCallback(function () {
    var patternProps = props.schema.patternProperties;
    var newPropKey = inputRef.current ? inputRef.current.value : null;
    if (newPropKey && patternProps) {
      var matchedPatternProp = Object.keys(patternProps).find(function (k) {
        var regex = new RegExp(k);
        return regex.test(newPropKey);
      });
      if (matchedPatternProp) {
        props.onSubmit(propKey, newPropKey, matchedPatternProp);
      }
    }
  }, [inputRef.current, propKey]);
  return React__default.createElement(Dialog, {
    open: props.isOpen
  }, React__default.createElement(DialogTitle, null, propKey ? t('settingsEditor.dialog.editKey') : t('settingsEditor.dialog.addKey')), React__default.createElement(DialogContent$1, null, React__default.createElement(DialogContentText, null), React__default.createElement(TextField, {
    autoFocus: true,
    defaultValue: propKey,
    margin: "dense",
    id: "key",
    inputRef: inputRef,
    label: t('settingsEditor.propertyKey'),
    fullWidth: true,
    inputProps: {
      maxLength: 255
    }
  })), React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
    onClick: props.onCancel,
    color: "primary"
  }, t('cancel')), React__default.createElement(Button, {
    onClick: onSave,
    color: "secondary",
    variant: "contained"
  }, t('save'))));
});
var ObjectNoPropsError = function ObjectNoPropsError(props) {
  return React__default.createElement("p", null, "Schema for " + props.propKey + " contains no properties and no patternProperties");
};
var ObjectDynamicEditor = React__default.memo(function (props) {
  var label = props.label,
    labelChildren = props.labelChildren,
    propKey = props.propKey,
    schema = props.schema,
    value = props.value,
    readOnly = props.readOnly;
  var patternProps = schema.patternProperties;
  var classes = useStyles$o();
  var t = useTranslation()[0];
  var _a = useState({
      key: undefined,
      open: false
    }),
    dialogState = _a[0],
    setDialogState = _a[1];
  if (!patternProps) {
    return React__default.createElement(ObjectNoPropsError, {
      propKey: propKey
    });
  }
  var field = useField(propKey)[0];
  var _b = useFormikContext(),
    setFieldValue = _b.setFieldValue,
    getFieldProps = _b.getFieldProps;
  var onPropDelete = useCallback(function (e) {
    var prop = e.currentTarget.name;
    setFieldValue(prop, undefined);
    e.stopPropagation();
  }, [setFieldValue]);
  var onKeyEdit = useCallback(function (e) {
    e.stopPropagation();
    setDialogState({
      key: e.currentTarget.name,
      open: true
    });
  }, [setDialogState]);
  var onKeyEditDialogCancel = useCallback(function () {
    return setDialogState({
      key: undefined,
      open: false
    });
  }, [setDialogState]);
  var onKeyEditDialogSubmit = useCallback(function (oldKey, newKey, matchedPatternProp) {
    var newProp = propKey + "." + newKey;
    if (oldKey) {
      var oldProp = propKey + "." + oldKey;
      var fieldProps = getFieldProps(oldProp);
      setFieldValue(newProp, fieldProps.value);
      if (newProp !== oldProp) {
        setFieldValue(oldProp, undefined);
      }
    } else {
      setFieldValue(newProp, createObject(patternProps[matchedPatternProp]));
    }
    setDialogState({
      key: undefined,
      open: false
    });
  }, [setDialogState, setFieldValue, getFieldProps, patternProps, propKey]);
  // value might change from object to null/primitive/array by reverting back to an inherited value
  if (field.value !== Object(field.value) || Array.isArray(field.value)) {
    return React__default.createElement(EditorTreeItem, {
      nodeId: propKey,
      label: React__default.createElement(TreeItemLabel$1, {
        label: label ? label : propKey
      }, labelChildren)
    });
  }
  var items = Object.keys(field.value).map(function (valueKey) {
    var patternProp = Object.keys(patternProps).find(function (patternPropKey) {
      var r = new RegExp(patternPropKey);
      return r.test(valueKey);
    });
    if (!patternProp) {
      return React__default.createElement("p", null, "Object property " + valueKey + " does not match any pattern property");
    }
    var propSchema = patternProps[patternProp];
    var prop = propKey + "." + valueKey;
    return React__default.createElement(SettingItem, {
      key: valueKey,
      readOnly: props.readOnly,
      propKey: prop,
      label: valueKey,
      schema: propSchema,
      value: value ? value[valueKey] : value,
      labelChildren: React__default.createElement(React__default.Fragment, null, React__default.createElement(Tooltip, {
        title: t('settingsEditor.button.editKey').toString()
      }, React__default.createElement(IconButton, {
        disabled: readOnly,
        size: 'small',
        className: classNames(classes.onHoverOnly),
        name: valueKey,
        onClick: onKeyEdit
      }, React__default.createElement(Edit, null))), React__default.createElement(Tooltip, {
        title: t('settingsEditor.button.removeItem').toString()
      }, React__default.createElement(IconButton, {
        size: 'small',
        disabled: readOnly,
        className: classNames(classes.onHoverOnly),
        name: prop,
        onClick: onPropDelete
      }, React__default.createElement(Delete, null))))
    });
  });
  var propertiesCount = Object.keys(field.value).length;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(EditorTreeItem, {
    nodeId: propKey,
    label: React__default.createElement(TreeItemLabel$1, {
      label: label ? label : propKey
    }, React__default.createElement("div", {
      className: classes.arrayItemHeaderContainer
    }, React__default.createElement(Typography$1, {
      variant: 'caption',
      className: classes.arrayItemHeaderCountLabel
    }, propertiesCount === 1 ? t('settingsEditor.propertiesCountSingle') : t('settingsEditor.propertiesCountMultiple', {
      count: propertiesCount
    })), React__default.createElement(Tooltip, {
      title: t('settingsEditor.button.addItem').toString()
    }, React__default.createElement(IconButton, {
      disabled: readOnly,
      color: 'secondary',
      size: 'small',
      onClick: onKeyEdit
    }, React__default.createElement(AddCircle, null)))), labelChildren)
  }, items), React__default.createElement(KeyEditorDialog, {
    schema: schema,
    propKey: dialogState.key,
    isOpen: dialogState.open,
    onCancel: onKeyEditDialogCancel,
    onSubmit: onKeyEditDialogSubmit
  }));
});
var ObjectStaticEditor = React__default.memo(function (props) {
  var label = props.label,
    labelChildren = props.labelChildren,
    propKey = props.propKey,
    schema = props.schema,
    value = props.value;
  var schemaProps = schema.properties;
  var classes = useStyles$o();
  return React__default.createElement(EditorTreeItem, {
    nodeId: propKey,
    label: React__default.createElement(TreeItemLabel$1, {
      label: label ? label : propKey
    }, React__default.createElement("div", {
      className: classes.spacer
    }), labelChildren)
  }, schemaProps && Object.keys(schemaProps).map(function (prop) {
    return React__default.createElement(SettingItem, {
      key: prop,
      propKey: propKey + "." + prop,
      label: prop,
      required: schema.required ? schema.required.includes(prop) : false,
      schema: schemaProps[prop],
      value: value ? value[prop] : value,
      readOnly: props.readOnly
    });
  }));
});
var ObjectEditor = React__default.memo(function (props) {
  var propKey = props.propKey,
    schema = props.schema;
  var schemaProps = schema.properties;
  var schemaPatternProps = schema.patternProperties;
  if (schemaProps) {
    return React__default.createElement(ObjectStaticEditor, _assign2({}, props));
  } else if (schemaPatternProps) {
    return React__default.createElement(ObjectDynamicEditor, _assign2({}, props));
  }
  return React__default.createElement(ObjectNoPropsError, {
    propKey: propKey
  });
});
var ErrorTooltip = withStyles$1(function (theme) {
  return {
    tooltip: {
      backgroundColor: 'red',
      color: 'white',
      boxShadow: theme.shadows[1],
      fontSize: 11
    },
    arrow: {
      color: 'red'
    }
  };
})(Tooltip);
var defaultMaxNumber = 2147483647;
var defaultMaxLength = 2000;
var generateOptions = function generateOptions(schema) {
  var options = schema.type === 'integer' || schema.type === 'number' ? schema.options : undefined;
  if (options) return options.map(function (o) {
    return React__default.createElement(MenuItem, {
      key: o.id,
      value: o.id
    }, o.name);
  });
  if (schema.enum) {
    return schema.enum.map(function (e) {
      return React__default.createElement(MenuItem, {
        key: e,
        value: e
      }, e);
    });
  }
  return [];
};
var MemoTextFieldEditor = React__default.memo(function (props) {
  var _a;
  var label = props.label,
    schema = props.schema,
    propKey = props.propKey,
    value = props.value,
    onChange = props.onChange,
    onBlur = props.onBlur,
    name = props.name,
    labelChildren = props.labelChildren,
    error = props.error;
  var classes = useStyles$o();
  return React__default.createElement(EditorTreeItem, {
    nodeId: propKey,
    label: React__default.createElement(TreeItemLabel$1, {
      label: label ? label : propKey,
      tooltip: schema.description,
      classes: {
        label: classes.fixedItemLabel
      }
    }, schema.enum ? React__default.createElement(Select, {
      variant: 'filled',
      className: classes.textField,
      classes: {
        root: classes.selectRoot
      },
      disableUnderline: true,
      name: name,
      value: value,
      onChange: onChange,
      readOnly: props.readOnly
    }, generateOptions(schema)) : React__default.createElement(ErrorTooltip, {
      arrow: true,
      title: error ? error : ''
    }, React__default.createElement(TextField, {
      size: 'small',
      variant: 'filled',
      className: classNames(classes.textField, (_a = {}, _a[classes.green] = schema.type === 'string', _a[classes.red] = schema.type === 'number' || schema.type === 'integer', _a)),
      autoComplete: 'new-password',
      type: schema.type === 'string' ? 'text' : 'number',
      value: value !== undefined ? value : '',
      name: name,
      error: error !== undefined,
      onBlur: onBlur,
      onChange: onChange,
      InputProps: {
        disableUnderline: !error,
        readOnly: props.readOnly
      },
      inputProps: {
        max: defaultMaxNumber,
        maxLength: defaultMaxLength
      }
    })), labelChildren)
  });
}, function (p, n) {
  return p.value === n.value && p.error === n.error && p.readOnly === n.readOnly && p.labelChildren === n.labelChildren && p.schema === n.schema;
});
var TextFieldEditor = function TextFieldEditor(props) {
  var schema = props.schema,
    propKey = props.propKey,
    required = props.required;
  var t = useTranslation()[0];
  var validate = function validate(value) {
    if (schema.enum) {
      return undefined;
    }
    if (value === undefined && !required) {
      return undefined;
    }
    if (value === undefined && required) {
      return t('settingsEditor.validation.required');
    }
    switch (schema.type) {
      case 'integer':
      case 'number':
        {
          var nv = value;
          if (schema.exclusiveMinimum !== undefined && nv <= schema.exclusiveMinimum) return t('settingsEditor.validation.greaterThan', {
            value: schema.exclusiveMinimum
          });
          if (schema.exclusiveMaximum !== undefined && nv >= schema.exclusiveMaximum) return t('settingsEditor.validation.lessThan', {
            value: schema.exclusiveMaximum
          });
          if (schema.minimum !== undefined && nv < schema.minimum) return t('settingsEditor.validation.greaterOrEqualThan', {
            value: schema.minimum
          });
          if (schema.maximum !== undefined && nv > schema.maximum) return t('settingsEditor.validation.lessOrEqualThan', {
            value: schema.maximum
          });
          if (nv > defaultMaxNumber) {
            return t('settingsEditor.validation.lessOrEqualThan', {
              value: defaultMaxNumber
            });
          }
          break;
        }
      case 'string':
        {
          var sv = value;
          if (schema.pattern) {
            var regex = new RegExp(schema.pattern);
            var regexMatched = regex.test(sv);
            if (!regexMatched) return t('settingsEditor.validation.pattern');
          }
          if (schema.minLength && sv.length < schema.minLength) return t('settingsEditor.validation.longerThan', {
            value: schema.minLength
          });
          if (schema.maxLength && sv.length > schema.maxLength) return t('settingsEditor.validation.shorterThan', {
            value: schema.maxLength
          });
          if (sv.length > defaultMaxLength) {
            return t('settingsEditor.validation.shorterThan', {
              value: defaultMaxLength
            });
          }
          break;
        }
    }
    return undefined;
  };
  var _a = useField({
      name: propKey,
      validate: validate
    }),
    field = _a[0],
    meta = _a[1];
  return React__default.createElement(MemoTextFieldEditor, _assign2({}, props, field, {
    error: meta.error
  }));
};

// TODO: determine if we need this null check
// const schemaAllowsNull = (schema: JSONSchema): boolean => {
//   if (schema.type === 'null') return true;
//   if (schema.type !== undefined) return false;
//   return schema.anyOf.findIndex((s) => s.type === 'null') !== -1;
// };
var SettingItem = React__default.memo(function (props) {
  var schema = props.schema,
    value = props.value,
    label = props.label,
    propKey = props.propKey,
    labelChildren = props.labelChildren,
    readOnly = props.readOnly,
    required = props.required;
  switch (schema.type) {
    case 'object':
      return React__default.createElement(ObjectEditor, {
        required: required,
        value: value,
        propKey: propKey,
        schema: schema,
        label: label,
        labelChildren: labelChildren,
        readOnly: readOnly
      });
    case 'number':
    case 'integer':
      return React__default.createElement(TextFieldEditor, {
        required: required,
        propKey: propKey,
        schema: schema,
        label: label,
        labelChildren: labelChildren,
        readOnly: readOnly
      });
    case 'string':
      return React__default.createElement(TextFieldEditor, {
        required: required,
        propKey: propKey,
        schema: schema,
        label: label,
        labelChildren: labelChildren,
        readOnly: readOnly
      });
    case 'boolean':
      return React__default.createElement(BooleanEditor, {
        required: required,
        propKey: propKey,
        label: label,
        schema: schema,
        readOnly: readOnly,
        labelChildren: labelChildren
      });
    case 'array':
      return React__default.createElement(ArrayFieldEditor, {
        required: required,
        propKey: propKey,
        label: label,
        schema: schema,
        readOnly: readOnly,
        labelChildren: labelChildren
      });
    case 'null':
      return React__default.createElement(EditorTreeItem, {
        nodeId: propKey,
        label: React__default.createElement(TreeItemLabel$1, {
          label: label ? label : propKey
        }, labelChildren)
      });
    case undefined:
      {
        return React__default.createElement(AnyEditor, {
          required: required,
          propKey: propKey,
          schema: schema,
          value: value,
          label: label,
          readOnly: readOnly,
          labelChildren: labelChildren
        });
      }
    default:
      return React__default.createElement(EditorTreeItem, {
        nodeId: propKey,
        label: "Unrecognized schema type '" + schema.type + "'"
      });
  }
});
var SettingValueEditor = React__default.memo(function (props) {
  var settingId = props.settingId,
    schema = props.schema,
    override = props.override,
    readOnly = props.readOnly,
    riskLevel = props.riskLevel;
  var t = useTranslation()[0];
  var _a = useFormikContext(),
    setFieldValue = _a.setFieldValue,
    getFieldProps = _a.getFieldProps,
    values = _a.values;
  var classes = useStyles$o();
  var itemSchema = schema;
  var _b = useState(override),
    isOverride = _b[0],
    setOverride = _b[1];
  var onOverrideClick = function onOverrideClick(e) {
    e.stopPropagation();
    var newOverride = !isOverride;
    // use value from either parent(inherited) or from own overriden value
    setFieldValue(props.propKey, newOverride ? props.value : props.parentValue);
    setFieldValue(overrideKey(props.propKey), !newOverride);
    setOverride(newOverride);
  };
  var lockNeeded = !readOnly && riskLevel === 0;
  var _c = useState(function () {
      return lockNeeded;
    }),
    locked = _c[0],
    setLocked = _c[1];
  var onUnlockClick = useCallback(function (e) {
    e.stopPropagation();
    props.openUnlockDialog(props.propKey, onUnlock);
  }, [locked, setLocked]);
  var onUnlock = useCallback(function () {
    return setLocked(false);
  }, [setLocked]);
  var onRemoveClick = useCallback(function () {
    return props.removeSelf(settingId);
  }, [settingId, props.removeSelf]);
  var showLock = lockNeeded && locked;
  var showOverride = props.override && !locked;
  return React__default.createElement(TreeView, {
    disableSelection: true,
    defaultExpanded: props.nodeIds,
    defaultCollapseIcon: React__default.createElement(ArrowDropDownIcon, null),
    defaultExpandIcon: React__default.createElement(ArrowRightIcon, null),
    defaultEndIcon: React__default.createElement("div", {
      className: classes.treeItemDefaultEndIcon
    })
  }, React__default.createElement(SettingItem, {
    propKey: props.propKey,
    label: props.settingLabel,
    schema: itemSchema,
    value: values[props.propKey],
    level: 0,
    readOnly: props.readOnly || locked || props.override && !isOverride,
    labelChildren: React__default.createElement(React__default.Fragment, null, showLock && React__default.createElement(Tooltip, {
      title: t('settingsEditor.unlock').toString()
    }, React__default.createElement(IconButton, {
      size: 'small',
      onClick: onUnlockClick,
      color: 'secondary'
    }, React__default.createElement(Lock, null))), showOverride && React__default.createElement(Tooltip, {
      title: isOverride ? t('deviceSettings.deleteOverride') : t('deviceSettings.returnToOverride')
    }, React__default.createElement(IconButton, {
      size: 'small',
      color: 'secondary',
      onClick: onOverrideClick
    }, isOverride ? React__default.createElement(Backspace, null) : React__default.createElement(Redo, null))))
  }));
});
var createFormValues = function createFormValues(settings) {
  return settings.reduce(function (o, s) {
    o[safeSettingKey(s.key)] = s.value;
    return o;
  }, {});
};
var SettingsEditor = React__default.forwardRef(function (props, ref) {
  var classes = useStyles$o();
  var readOnly = props.readOnly,
    onSubmit = props.onSubmit;
  var _a = useState(props.settings),
    settings = _a[0],
    setSettings = _a[1];
  var _b = useState({
      open: false,
      setting: '',
      callback: function callback() {}
    }),
    critDialogState = _b[0],
    setCritDialogState = _b[1];
  var openUnlockDialog = useCallback(function (setting, saveCallback) {
    return setCritDialogState({
      open: true,
      setting: setting,
      callback: saveCallback
    });
  }, [setCritDialogState]);
  var formValues = createFormValues(settings);
  var onSettingRemove = useCallback(function (settingId) {
    var settingIndex = settings.findIndex(function (s) {
      return s.id === settingId;
    });
    var newSettings = __spreadArrays(settings);
    newSettings.splice(settingIndex, 1);
    setSettings(newSettings);
  }, [settings, setSettings]);
  var editors = useMemo(function () {
    var groups = groupSettings(settings);
    var nodeIds = formValuesToNodeIds(formValues);
    var settingToEditor = function settingToEditor(s) {
      var setting = props.parentSettings ? props.parentSettings.find(function (ps) {
        return ps.id === s.id;
      }) : null;
      return React__default.createElement(SettingValueEditor, {
        key: safeSettingKey(s.key),
        settingLabel: s.path[s.path.length - 1],
        readOnly: readOnly,
        riskLevel: s.riskLevel,
        nodeIds: nodeIds,
        propKey: safeSettingKey(s.key),
        parentValue: setting ? setting.value : undefined,
        schema: s.schema,
        value: s.value,
        settingId: s.id,
        override: props.parentSettings !== null && s.entityId === props.entity.entityId && s.entityType == props.entity.entityType,
        openUnlockDialog: openUnlockDialog,
        removeSelf: onSettingRemove
      });
    };
    var sortedGroups = Array.from(groups.keys()).sort();
    if (props.groupSettings) {
      return sortedGroups.map(function (groupName) {
        return React__default.createElement(Card, {
          className: classes.settingGroupCard,
          classes: {
            root: classes.settingGroupCardRoot
          },
          key: groupName
        }, React__default.createElement(CardHeader, {
          title: groupName
        }), React__default.createElement(CardContent, null, groups.get(groupName).sort(function (a, b) {
          if (a.key < b.key) {
            return -1;
          }
          if (a.key > b.key) {
            return 1;
          }
          return 0;
        }).map(settingToEditor)));
      });
    } else {
      return sortedGroups.map(function (groupName) {
        var group = groups.get(groupName);
        if (group) {
          return group.map(settingToEditor);
        }
      });
    }
  }, [settings]);
  var onFormChanged = useCallback(function (initialValues, values) {
    return function () {
      if (props.setDirty === undefined) {
        return;
      }
      var rawDiffs = diff(initialValues, values);
      if (rawDiffs === undefined) {
        props.setDirty(false);
      } else {
        var uniqueArr = function uniqueArr(arr) {
          return Array.from(new Set(arr));
        };
        var diffs = rawDiffs.map(function (d) {
          return d.path[0];
        });
        var revertObj_1 = values[overrideKeyPrefix];
        var reverts = revertObj_1 ? Object.keys(revertObj_1).filter(function (k) {
          return revertObj_1[k] === true;
        }) : [];
        var dirtySettings = uniqueArr(diffs.concat(reverts).filter(function (d) {
          return d !== overrideKeyPrefix;
        }));
        if (dirtySettings.length === 0) {
          props.setDirty(false);
        } else {
          props.setDirty(true);
          if (props.setDirtySettings) {
            props.setDirtySettings(dirtySettings);
          }
        }
      }
    };
  }, [props.setDirty]);
  return React__default.createElement(Formik, {
    initialValues: formValues,
    validateOnBlur: true,
    onSubmit: onSubmit,
    innerRef: ref
  }, function (_a) {
    var initialValues = _a.initialValues,
      values = _a.values;
    return React__default.createElement(Form, {
      onBlur: onFormChanged(initialValues, values),
      className: classNames(classes.form, props.classes ? props.classes.form : null)
    }, editors, React__default.createElement(CriticalSettingUnlockDialog, {
      open: critDialogState.open,
      onClose: function onClose() {
        return setCritDialogState({
          open: false,
          setting: '',
          callback: function callback() {}
        });
      },
      save: function save() {
        critDialogState.callback();
        setCritDialogState({
          open: false,
          setting: '',
          callback: function callback() {}
        });
      }
    }));
  });
});
var cellPStyle = {
  marginBottom: 'auto',
  marginTop: 'auto',
  paddingLeft: '8px',
  paddingRight: '4px'
};
var groupStyle = {
  fontWeight: 600
};
var criticalStyle = {
  color: 'red',
  fontWeight: 'bold',
  paddingLeft: '8px',
  paddingRight: '4px',
  marginBottom: 'auto',
  marginTop: 'auto'
};
var SettingColumnRenderer = /** @class */function (_super) {
  __extends(SettingColumnRenderer, _super);
  function SettingColumnRenderer(props) {
    return _super.call(this, props) || this;
  }
  SettingColumnRenderer.prototype.render = function () {
    return this.props.node.group ? React__default.createElement("span", {
      style: groupStyle
    }, this.props.value) : this.props.node.data.riskLevel === 0 ? React__default.createElement(Tooltip, {
      title: i18next.t('deviceSettings.criticalSetting').toString()
    }, React__default.createElement("p", {
      style: criticalStyle
    }, this.props.value)) : React__default.createElement("p", {
      style: cellPStyle
    }, this.props.value);
  };
  return SettingColumnRenderer;
}(React__default.Component);
var StyledButton = withStyles$1({
  root: {
    marginBottom: 'auto',
    marginTop: 'auto',
    paddingLeft: '8px',
    paddingRight: '4px'
  }
})(Button);
var StyledSettingsEditor = withStyles$1({
  form: {
    height: 'initial'
  }
})(SettingsEditor);
var ValueColumnFormatter = function ValueColumnFormatter(item) {
  var t = useTranslation()[0];
  var _a = useState(false),
    open = _a[0],
    setOpen = _a[1];
  var row = item.data;
  var _b = useState(false),
    showChild = _b[0],
    setShowChild = _b[1];
  var closeDialog = useCallback(function () {
    return setOpen(false);
  }, []);
  var openDialog = useCallback(function () {
    return setOpen(true);
  }, []);
  var dialogTitle = useMemo(function () {
    return row ? t('deviceSettings.valueDialogTitle', {
      key: t(row.key)
    }).toString() : '';
  }, [row]);
  // Wait until after client-side hydration to show
  useEffect(function () {
    setShowChild(true);
  }, []);
  if (!showChild) {
    // You can show some kind of placeholder UI here
    return React__default.createElement("span", null);
  }
  if (row && row.type === DeviceSettingType.jsonb && row.value) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(Tooltip, {
      title: dialogTitle
    }, React__default.createElement(StyledButton, {
      style: cellPStyle,
      onClick: openDialog
    }, "...")), React__default.createElement(Dialog, {
      open: open,
      onClose: closeDialog
    }, React__default.createElement(DialogTitle, null, dialogTitle), React__default.createElement(DialogContent$1, null, React__default.createElement(StyledSettingsEditor, {
      parentSettings: null,
      onSubmit: function onSubmit() {},
      readOnly: true,
      settings: [row],
      entity: {
        entityId: 1,
        entityType: EntityType.Workgroup
      },
      parentEntity: null
    })), React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
      onClick: closeDialog,
      color: 'primary'
    }, t('close')))));
  }
  return React__default.createElement("div", {
    style: cellPStyle
  }, item.value !== undefined ? item.value + '' : '');
};
var styles$n = function styles$n(theme) {
  return createStyles$1({
    container: {
      display: 'flex',
      marginTop: theme.spacing(1),
      position: 'relative',
      overflow: 'hidden'
    },
    progress: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  });
};
var useStyles$p = makeStyles(styles$n);
var DeviceCountConfirmLoader = function DeviceCountConfirmLoader() {
  var classes = useStyles$p();
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: classes.container
  }, React__default.createElement(CircularProgress, {
    className: classes.progress,
    variant: "indeterminate",
    color: "secondary",
    size: 120
  })));
};
var STEP_SUMMARY = 0;
var STEP_COUNT_CHECK = 1;
var STEP_TIMER = 2;
var STEP_DONE = 3;
var ConfirmDialog = React__default.memo(function (_a) {
  var entity = _a.entity,
    open = _a.open,
    onClose = _a.onClose,
    confirmApplySettings = _a.confirmApplySettings,
    settingsForSaving = _a.settingsForSaving,
    settingsNotForSaving = _a.settingsNotForSaving;
  var t = useTranslation()[0];
  var _b = useState(0),
    step = _b[0],
    setStep = _b[1];
  var _c = useState(false),
    canSave = _c[0],
    setCanSave = _c[1];
  var _d = useState({
      forSaving: settingsForSaving,
      notForSaving: settingsNotForSaving
    }),
    settings = _d[0],
    setSettings = _d[1];
  useEffect(function () {
    if (open) {
      setStep(STEP_SUMMARY);
      setCanSave(false);
      setSettings({
        forSaving: settingsForSaving,
        notForSaving: settingsNotForSaving
      });
    }
  }, [open]);
  var handleDeviceFormStatusChange = useCallback(function (newStatus) {
    setCanSave(function (previousCanSave) {
      return previousCanSave !== newStatus ? newStatus : previousCanSave;
    });
  }, []);
  var onNext = useCallback(function () {
    if (step === STEP_SUMMARY) {
      setStep(STEP_COUNT_CHECK);
    }
    if (canSave && step === STEP_COUNT_CHECK) {
      setStep(STEP_TIMER);
    }
    if (step >= STEP_TIMER) {
      onClose();
    }
  }, [canSave, step]);
  var confirmSave = useCallback(function () {
    var finalSettings = settings.forSaving;
    setTimeout(function () {
      setStep(STEP_DONE);
      confirmApplySettings(finalSettings);
    }, 0);
  }, [settings]);
  var moveSetting = useCallback(function (settingKey, from, to) {
    var newSettings = _assign2({}, settings);
    var fromList = from === SettingList.forSaving ? newSettings.forSaving : newSettings.notForSaving;
    var toList = to === SettingList.forSaving ? newSettings.forSaving : newSettings.notForSaving;
    var fromIndex = fromList.findIndex(function (s) {
      return s.key === settingKey;
    });
    var settingToMove = fromList.splice(fromIndex, 1);
    if (settingToMove.length > 0) {
      toList.push(settingToMove[0]);
      setSettings(newSettings);
    }
  }, [settings, setSettings]);
  var MemoTimer = useMemo(function () {
    return React__default.createElement(ApplySettingsCancelTimer, {
      onComplete: confirmSave
    });
  }, [confirmSave]);
  return React__default.createElement(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: 'sm',
    fullWidth: true
  }, React__default.createElement(DialogTitle, null, t('deviceSettings.applyingSettings')), React__default.createElement(DialogContent$1, null, step === STEP_SUMMARY && React__default.createElement(Summary, {
    settingsForSaving: settings.forSaving,
    settingsNotForSaving: settings.notForSaving,
    moveSetting: moveSetting
  }), step === STEP_COUNT_CHECK && React__default.createElement(DeviceCountConfirm, {
    entity: entity,
    settingIds: settingsForSaving.map(function (x) {
      return x.id;
    }),
    onStatusChange: handleDeviceFormStatusChange
  }), step === STEP_TIMER && MemoTimer), React__default.createElement(DialogActions$1, null, (step === STEP_SUMMARY || step === STEP_COUNT_CHECK) && React__default.createElement(Button, {
    onClick: onClose
  }, t('cancel')), React__default.createElement(Button, {
    variant: 'contained',
    color: 'secondary',
    onClick: onNext,
    disabled: step === STEP_SUMMARY && settings.forSaving.length === 0 || step === STEP_COUNT_CHECK && !canSave
  }, step === STEP_SUMMARY || step === STEP_COUNT_CHECK ? t('next') : step === STEP_TIMER ? t('deviceSettings.cancelChanges') : t('close'))));
});
var MS = 5000;
var STEPS = 50;
var ApplySettingsCancelTimer = function ApplySettingsCancelTimer(_a) {
  var onComplete = _a.onComplete;
  var t = useTranslation()[0];
  var classes = useStyles$n();
  var _b = React__default.useState(0),
    elapsed = _b[0],
    setElapsed = _b[1];
  var startTimeRef = React__default.useRef(0);
  useEffect(function () {
    var progress = function progress() {
      setElapsed(function (previous) {
        if (previous >= MS) {
          clearInterval(timer);
          onComplete();
          return MS;
        }
        return +new Date() - startTimeRef.current;
      });
    };
    startTimeRef.current = +new Date();
    var timer = setInterval(progress, MS / STEPS);
    return function () {
      return clearInterval(timer);
    };
  }, [onComplete]);
  var secondsRemaining = useMemo(function () {
    return Math.ceil((MS - elapsed) / 1000);
  }, [elapsed]);
  var completed = useMemo(function () {
    return 100 * (elapsed / MS);
  }, [elapsed]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography$1, {
    variant: 'h6',
    align: 'center'
  }, completed < 100 ? t('deviceSettings.youCanStillCancel') : t('deviceSettings.saved')), React__default.createElement("div", {
    className: classes.timerContainer
  }, completed < 100 && React__default.createElement(Typography$1, {
    variant: 'h3',
    className: classes.progressText
  }, secondsRemaining), completed >= 100 && React__default.createElement(Done, {
    className: classes.completedIcon
  }), React__default.createElement(CircularProgress, {
    className: classes.progress,
    variant: 'static',
    value: completed,
    color: 'secondary',
    size: 120
  })));
};
var fetchAffectedDevices = function fetchAffectedDevices(entity, settingIds) {
  return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, HttpService$1.post("v6/deviceSettings/affected", {
            entity: entity,
            settingIds: settingIds
          })];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
      }
    });
  });
};
var DeviceCountConfirm = function DeviceCountConfirm(_a) {
  var entity = _a.entity,
    settingIds = _a.settingIds,
    onStatusChange = _a.onStatusChange;
  var t = useTranslation()[0];
  var classes = useStyles$n();
  var _b = useState(0),
    count = _b[0],
    setCount = _b[1];
  var _c = useState(true),
    fetching = _c[0],
    setFetching = _c[1];
  useEffect(function () {
    var fetchData = function fetchData() {
      return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, fetchAffectedDevices(entity, settingIds)];
            case 1:
              response = _a.sent();
              setCount(response);
              setFetching(false);
              return [2 /*return*/];
          }
        });
      });
    };

    fetchData();
  }, []);
  var handleCountChange = useCallback(function (event) {
    var value = parseInt(event.target.value);
    onStatusChange(value === count);
  }, [count]);
  return React__default.createElement(React__default.Fragment, null, fetching && React__default.createElement(DeviceCountConfirmLoader, null), !fetching && React__default.createElement(React__default.Fragment, null, React__default.createElement(Alert, {
    severity: 'warning'
  }, t('deviceSettings.playerCountReadme', {
    count: count
  }), React__default.createElement("br", null)), React__default.createElement(DialogContentText, {
    className: classes.countInputContainer
  }, t('deviceSettings.playerCountDialogInfo')), React__default.createElement(TextField, {
    className: classes.countInput,
    size: 'small',
    color: 'secondary',
    type: 'number',
    autoFocus: true,
    label: t('deviceSettings.playerCountLabel'),
    fullWidth: true,
    onChange: handleCountChange
  })));
};
var SettingList;
(function (SettingList) {
  SettingList[SettingList["forSaving"] = 0] = "forSaving";
  SettingList[SettingList["notForSaving"] = 1] = "notForSaving";
})(SettingList || (SettingList = {}));
var Summary = function Summary(props) {
  var settingsForSaving = props.settingsForSaving,
    settingsNotForSaving = props.settingsNotForSaving,
    moveSetting = props.moveSetting;
  var t = useTranslation()[0];
  var classes = useStyles$n();
  var removeSetting = useCallback(function (e) {
    var settingKey = e.currentTarget.name;
    moveSetting(settingKey, SettingList.forSaving, SettingList.notForSaving);
  }, [settingsForSaving, moveSetting]);
  var addSetting = useCallback(function (e) {
    var settingKey = e.currentTarget.name;
    moveSetting(settingKey, SettingList.notForSaving, SettingList.forSaving);
  }, [settingsForSaving, moveSetting]);
  return React__default.createElement("div", null, React__default.createElement(Alert, {
    severity: 'info'
  }, t('deviceSettings.summarySettingsForSavingPart1'), React__default.createElement(RemoveIcon, {
    className: classes.confirmDialogSummaryAlertIcon,
    fontSize: 'small'
  }), t('deviceSettings.summarySettingsForSavingPart2')), React__default.createElement(List, null, settingsForSaving.map(function (s) {
    return React__default.createElement(ListItem, {
      key: s.key
    }, React__default.createElement(ListItemText, {
      primary: t(s.key)
    }), React__default.createElement(ListItemSecondaryAction, null, React__default.createElement(Tooltip, {
      title: t('deviceSettings.summaryRemoveSetting')
    }, React__default.createElement(IconButton, {
      edge: 'end',
      "aria-label": 'remove',
      onClick: removeSetting,
      name: s.key
    }, React__default.createElement(RemoveIcon, null)))));
  })), React__default.createElement(Alert, {
    severity: 'warning'
  }, t('deviceSettings.summarySettingsNotForSavingPart1'), React__default.createElement(AddIcon, {
    className: classes.confirmDialogSummaryAlertIcon,
    fontSize: 'small'
  }), t('deviceSettings.summarySettingsNotForSavingPart2')), React__default.createElement(List, null, settingsNotForSaving.map(function (s) {
    return React__default.createElement(ListItem, {
      key: s.key
    }, React__default.createElement(ListItemText, {
      primary: t(s.key)
    }), React__default.createElement(ListItemSecondaryAction, null, React__default.createElement(Tooltip, {
      title: t('deviceSettings.summaryAddSetting')
    }, React__default.createElement(IconButton, {
      edge: 'end',
      "aria-label": 'add',
      onClick: addSetting,
      name: s.key
    }, React__default.createElement(AddIcon, null)))));
  })));
};
var mapDeviceSettingRiskLevel = function mapDeviceSettingRiskLevel(setting) {
  return _assign2(_assign2({}, setting), {
    riskLevelLabel: i18next.t("settingsEditor.riskLevel" + setting.riskLevel).toString()
  });
};
var useMapDeviceSettings = function useMapDeviceSettings(deviceSettings) {
  return useMemo(function () {
    return deviceSettings.map(mapDeviceSettingRiskLevel);
  }, [deviceSettings]);
};
var useFilterCriticalDeviceSettings = function useFilterCriticalDeviceSettings(deviceSettings, criticalVisible) {
  return useMemo(function () {
    return deviceSettings.filter(function (e) {
      return criticalVisible ? true : e.riskLevel !== 0;
    });
  }, [deviceSettings, criticalVisible]);
};
var useCriticalSettingsVisible = function useCriticalSettingsVisible(onSetCriticalToggle) {
  var _a = useState(false),
    criticalVisible = _a[0],
    setCriticalVisible = _a[1];
  var _b = useState(),
    filterModel = _b[0],
    setFilterModel = _b[1];
  var gridApi = useGridApi();
  var toggleCriticalVisible = useCallback(function () {
    return setCriticalVisible(function (currentCriticalVisibility) {
      if (onSetCriticalToggle && gridApi) {
        onSetCriticalToggle();
      }
      if (gridApi) {
        setFilterModel(gridApi.getFilterModel());
      }
      return !currentCriticalVisibility;
    });
  }, [onSetCriticalToggle, gridApi]);
  useEffect(function () {
    if (gridApi && filterModel) {
      gridApi.setFilterModel(filterModel);
    }
  }, [filterModel]);
  useEffect(function () {
    if (gridApi && gridApi.onFilterChanged) {
      gridApi.onFilterChanged();
      gridApi.redrawRows();
      if (criticalVisible) {
        var scrolled_1 = false;
        gridApi.forEachNode(function (row) {
          var rowData = row.data;
          var shouldScroll = rowData && rowData.riskLevel === 0 && !scrolled_1;
          if (shouldScroll) {
            gridApi.ensureIndexVisible(row.rowIndex, "middle");
            scrolled_1 = true;
          }
        });
      }
    }
  }, [criticalVisible, gridApi]);
  return [criticalVisible, toggleCriticalVisible];
};
var entity = function entity(entityId, entityType) {
  return {
    entityId: entityId,
    entityType: entityType
  };
};
var useFetchDeviceSettings = function useFetchDeviceSettings(_a) {
  var device = _a.device,
    location = _a.location,
    workgroup = _a.workgroup,
    parentEntity = _a.parentEntity,
    fetchDevicesSettings = _a.fetchDevicesSettings;
  useEffect(function () {
    if (location && location.id) {
      fetchDevicesSettings(entity(location.id, EntityType.Site), parentEntity);
    }
    if (workgroup && workgroup.id) {
      fetchDevicesSettings(entity(workgroup.id, EntityType.Workgroup), parentEntity);
    }
    if (device && device.id) {
      fetchDevicesSettings(entity(device.id, EntityType.Hardware), parentEntity);
    }
  }, [location, workgroup, device]);
};
var useDefaultDeviceSettingFns = function useDefaultDeviceSettingFns(bladeId, parentEntity) {
  var dispatch = useDispatch();
  var fetchDevicesSettings = useCallback(function (entity, parentEntity) {
    dispatch(fetchDeviceSettingsAsync(entity, parentEntity));
  }, []);
  var saveDeviceSettings = useCallback(function (entity, parentEntity, settings) {
    return dispatch(saveDeviceSettingsAsync(entity, parentEntity, settings));
  }, []);
  var openDeviceSettings = useCallback(function () {
    return dispatch(openBlade(bladeId, WizardBladeName, {
      parentEntity: parentEntity
    }));
  }, [bladeId, saveDeviceSettings]);
  return {
    fetchDevicesSettings: fetchDevicesSettings,
    openDeviceSettings: openDeviceSettings
  };
};
var useDeviceSettingsBladeButtons = function useDeviceSettingsBladeButtons(criticalVisible, hideShowCriticalSettingsButton, showCritical) {
  var _a = useTranslation();
  var buttons = useMemo(function () {
    return hideShowCriticalSettingsButton ? [] : [{
      tooltip: 'deviceSettings.showCritical',
      icon: function icon() {
        return React__default.createElement(Report, {
          color: criticalVisible ? 'error' : 'inherit'
        });
      },
      onClick: showCritical,
      disabled: false
    }];
  }, [showCritical, criticalVisible, hideShowCriticalSettingsButton]);
  return buttons;
};
var valueFilterSettings = {
  filter: 'agTextColumnFilter',
  customFloatingFilterParams: {
    filterOptions: [{
      displayKey: 'settingValueSearch',
      displayName: i18next.t('settingValueSearch'),
      test: function test(filterValue, cellValue) {
        var a = filterValue.toLowerCase();
        var b = cellValue.toLowerCase();
        return b.indexOf(a) > -1;
      }
    }],
    valueGetter: function valueGetter(rowNode) {
      if (rowNode.data === undefined) {
        return '';
      }
      var cellValue = rowNode.data.value;
      if (cellValue === undefined) {
        return '';
      }
      if (cellValue === null) {
        return 'null';
      }
      if (typeof cellValue === 'object') {
        return JSON.stringify(cellValue);
      }
      return cellValue;
    },
    suppressAndOrCondition: true
  }
};
var WizardSettingsColumnSettings = [{
  name: 'value',
  width: 100,
  formatter: ValueColumnFormatter,
  lockVisibility: true,
  filter: valueFilterSettings.filter,
  customFloatingFilterParams: valueFilterSettings.customFloatingFilterParams
}];
var useStyles$q = makeStyles$2(function (theme) {
  return createStyles$1({
    listContainer: {
      overflowY: "auto",
      marginBottom: theme.spacing() / 2,
      marginTop: theme.spacing(),
      paddingLeft: theme.spacing() * 2,
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
        cursor: "pointer",
        background: "#D4CCC7"
      },
      "&::webkit-scrollbar-track": {
        background: "#9A9791",
        cursor: "pointer"
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#9A9791",
        borderRadius: "5px",
        cursor: "pointer",
        "&:hover": {
          background: "#9A9791"
        }
      }
    },
    moreButton: {
      "&:hover": {
        textDecoration: "underline",
        cursor: "pointer"
      }
    }
  });
});
var DefaultProps = {
  settings: [],
  visibleThreshold: 5
};
var DirtySettingsList = function DirtySettingsList(props) {
  var classes = useStyles$q();
  var t = useTranslation()[0];
  var settings = useState(props.settings.map(function (s) {
    return t(s.replace(/--/g, '.'));
  }).sort())[0];
  var _a = useState(true),
    hide = _a[0],
    setHide = _a[1];
  var visibleThreshold = props.visibleThreshold ? props.visibleThreshold : DefaultProps.visibleThreshold;
  var oneSetting = React__default.createElement(Typography$1, {
    color: 'textSecondary',
    variant: 'body2'
  }, t('wizard.dirtyDialog.listHeader') + " " + settings[0] + ".");
  var multipleSettings = React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography$1, {
    color: 'textSecondary',
    variant: 'body2'
  }, t('wizard.dirtyDialog.listHeader'), ":"), React__default.createElement("ul", {
    className: classes.listContainer,
    style: {
      maxHeight: (visibleThreshold + 1) * 20
    }
  }, settings.filter(function (s, i) {
    return hide ? i < visibleThreshold ? true : false : true;
  }).map(function (s, i) {
    return React__default.createElement("li", {
      key: i
    }, React__default.createElement(Typography$1, {
      color: 'textSecondary',
      variant: 'body2'
    }, s));
  })), hide && settings.length > visibleThreshold && React__default.createElement("span", {
    className: classes.moreButton,
    onClick: function onClick(e) {
      e.preventDefault();
      setHide(false);
    }
  }, React__default.createElement(Typography$1, {
    color: 'textSecondary',
    variant: 'body2'
  }, t('wizard.dirtyDialog.andmore', {
    count: settings.length - visibleThreshold
  }))));
  return settings.length === 1 ? oneSetting : multipleSettings;
};
var EditorDirtyDialog = React__default.memo(function (_a) {
  var opened = _a.opened,
    onCancel = _a.onCancel,
    onConfirm = _a.onConfirm,
    settings = _a.settings;
  var t = useTranslation()[0];
  return React__default.createElement(Dialog, {
    open: opened,
    maxWidth: 'xs'
  }, React__default.createElement(DialogTitle, null, t('wizard.dirtyDialog.title')), React__default.createElement(DialogContent$1, null, React__default.createElement(DialogContentText, null, t('wizard.dirtyDialog.unsavedChangesMessage1'), React__default.createElement("br", null), t('wizard.dirtyDialog.unsavedChangesMessage2'), React__default.createElement("br", null)), React__default.createElement(DirtySettingsList, {
    settings: settings
  })), React__default.createElement(DialogActions$1, null, React__default.createElement(Button, {
    onClick: onCancel,
    color: 'primary',
    autoFocus: true
  }, t('cancel')), React__default.createElement(Button, {
    onClick: onConfirm,
    color: 'primary'
  }, t('confirm'))));
});
var useStyles$r = makeStyles$2(function (theme) {
  return createStyles$1({
    root: {
      width: "100%",
      paddingBottom: theme.spacing(2)
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "row-reverse"
    },
    button: {
      marginRight: theme.spacing(1)
    },
    stepIconActive: {
      color: theme.palette.secondary.main + " !important"
    },
    stepIconComplete: {
      color: theme.palette.text.disabled + " !important"
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  });
});
var _a$1;
var SettingsStep;
(function (SettingsStep) {
  SettingsStep[SettingsStep["SelectSettings"] = 0] = "SelectSettings";
  SettingsStep[SettingsStep["SetValues"] = 1] = "SetValues";
  SettingsStep[SettingsStep["SetTarget"] = 2] = "SetTarget";
})(SettingsStep || (SettingsStep = {}));
var SettingsStepI18n = (_a$1 = {}, _a$1[SettingsStep.SelectSettings] = i18next.t('wizard.settingsStepper.settingsSelector'), _a$1[SettingsStep.SetValues] = i18next.t('wizard.settingsStepper.setValues'), _a$1[SettingsStep.SetTarget] = i18next.t('wizard.settingsStepper.setTarget'), _a$1);
var SettingsStepper = React__default.memo(function (props) {
  var classes = useStyles$r();
  var t = useTranslation()[0];
  var isOnFirstStep = props.activeStepIndex === 0;
  var hasFinished = props.activeStepIndex === props.steps.length;
  var hasReachedLastStep = props.activeStepIndex >= props.steps.length - 1;
  return React__default.createElement("div", {
    className: classes.root
  }, React__default.createElement(Stepper, {
    activeStep: props.activeStepIndex
  }, props.steps.map(function (step) {
    return React__default.createElement(Step, {
      key: step
    }, React__default.createElement(StepLabel, {
      StepIconProps: {
        classes: {
          active: classes.stepIconActive,
          completed: classes.stepIconComplete
        }
      }
    }, SettingsStepI18n[step]));
  })), React__default.createElement("div", {
    className: classes.buttonsContainer
  }, React__default.createElement(Button$1, {
    variant: 'contained',
    color: 'secondary',
    className: classes.button,
    onClick: props.loading ? function () {} : props.onNext,
    disabled: props.nextDisabled || hasFinished
  }, props.loading ? React__default.createElement(CircularProgress, {
    size: 24,
    className: classes.buttonProgress
  }) : hasReachedLastStep ? t('wizard.settingsStepper.save') : t('wizard.settingsStepper.next')), React__default.createElement(Button$1, {
    onClick: props.onBack,
    className: classes.button,
    disabled: props.backDisabled
  }, isOnFirstStep ? t('wizard.settingsStepper.cancel') : t('wizard.settingsStepper.back'))));
});
var getItemPath = function getItemPath(item) {
  return item.path;
};
var rowSelectable$1 = function rowSelectable$1(params) {
  return params.node.group === false;
};
var steps = [SettingsStep.SelectSettings, SettingsStep.SetValues];
var mapSettingsForSave = function mapSettingsForSave(initialSettings, settings) {
  var overrides = settings[overrideKeyPrefix];
  if (settings) {
    return Object.keys(settings).reduce(function (accumulator, settingKey) {
      if (settingKey === overrideKeyPrefix) return accumulator; // the overrides key is only used to keep track of overrides and not part of the final result
      var key = settingKey.replace(/--/g, '.');
      var revertValue = overrides ? overrides[settingKey] ? true : false : false;
      var value = settings[settingKey];
      var id = initialSettings.find(function (x) {
        return x.key === key;
      }).id;
      // ignore setting value if it's not different from the initial value
      var initialSetting = initialSettings.find(function (s) {
        return s.key === key;
      });
      if (!revertValue && initialSetting && deepEqual(value, initialSetting.value, {
        strict: true
      })) {
        accumulator.notSaved.push({
          id: id,
          key: key,
          value: value,
          revertValue: revertValue
        });
        return accumulator;
      }
      accumulator.toBeSaved.push({
        id: id,
        key: key,
        value: value,
        revertValue: revertValue
      });
      return accumulator;
    }, {
      toBeSaved: [],
      notSaved: []
    });
  }
  return {
    toBeSaved: [],
    notSaved: []
  };
};
var shouldSetDefaultSettings = function shouldSetDefaultSettings(stored, incomming) {
  if (stored.length !== incomming.length) {
    return true;
  }
  return incomming.filter(function (e) {
    return stored.filter(function (f) {
      return f.id === e.id;
    }).length === 0;
  }).length > 0;
};
var checkAndSetDefaultSettingfs = function checkAndSetDefaultSettingfs(stored, incomming, setDefaultSettings) {
  if (shouldSetDefaultSettings(stored, incomming)) {
    setDefaultSettings(incomming);
  }
};
var wizardSteps = [SettingsStep.SelectSettings, SettingsStep.SetValues];
var Wizard = function Wizard(props) {
  var t = useTranslation()[0];
  var classes = useStyles$n();
  var _a = useState(0),
    activeStepIndex = _a[0],
    setActiveStepIndex = _a[1];
  var _b = useState(false),
    dirtyDialogOpen = _b[0],
    setDirtyDialogOpen = _b[1];
  var _c = useState([]),
    dirtySettings = _c[0],
    setDirtySettings = _c[1];
  var onConfirmBack = useCallback(function () {
    setDirtyDialogOpen(false);
    props.setDirty(false);
    setActiveStepIndex(0);
  }, []);
  var onCancelBack = useCallback(function () {
    setDirtyDialogOpen(false);
  }, []);
  var _d = useState([]),
    selectedSettings = _d[0],
    setSelectedSettings = _d[1];
  var _e = useState([]),
    defaultSettings = _e[0],
    setDefaultSettings = _e[1];
  var _f = useState({
      open: false,
      toBeSaved: [],
      notSaved: []
    }),
    showConfirmDialog = _f[0],
    setShowConfirmDialog = _f[1];
  useEffect(function () {
    if (props.saved) {
      setActiveStepIndex(0);
      setShowConfirmDialog({
        open: false,
        toBeSaved: [],
        notSaved: []
      });
      props.clearSavedFlag();
    }
  }, [props.saved]);
  var handleNext = useCallback(function () {
    if (activeStepIndex === steps.length - 1) {
      if (formRef.current) {
        formRef.current.submitForm();
      }
    } else {
      setActiveStepIndex(function (prevActiveStepIndex) {
        if (prevActiveStepIndex === steps.length) {
          return prevActiveStepIndex;
        } else {
          return prevActiveStepIndex + 1;
        }
      });
    }
    checkAndSetDefaultSettingfs(defaultSettings, selectedSettings, setDefaultSettings);
  }, [activeStepIndex, selectedSettings, defaultSettings]);
  var handleBack = useCallback(function () {
    if (activeStepIndex === 0) {
      props.closeBlade();
    }
    if (activeStepIndex !== 0) {
      if (props.isDirty) {
        setDirtyDialogOpen(true);
      } else {
        setActiveStepIndex(0);
      }
    }
    checkAndSetDefaultSettingfs(defaultSettings, selectedSettings, setDefaultSettings);
  }, [activeStepIndex, selectedSettings, props.isDirty, defaultSettings]);
  var formRef = useRef();
  var onValuesFormSubmit = function onValuesFormSubmit(values, formikHelpers) {
    var settings = mapSettingsForSave(props.entitySettings, formRef.current ? formRef.current.values : null);
    setShowConfirmDialog({
      open: true,
      toBeSaved: settings.toBeSaved,
      notSaved: settings.notSaved
    });
  };
  var closeConfirmDialog = useCallback(function () {
    return setShowConfirmDialog(_assign2(_assign2({}, showConfirmDialog), {
      open: false
    }));
  }, []);
  var confirmApplySettings = useCallback(function (settings) {
    props.setDirty(false);
    props.saveDeviceSettings(props.entity, props.parentEntity, settings);
  }, [props.saveDeviceSettings, props.entity, props.parentEntity]);
  var onShowCriticalToggle = useCallback(function () {
    return checkAndSetDefaultSettingfs(defaultSettings, selectedSettings, setDefaultSettings);
  }, [selectedSettings, defaultSettings]);
  var _g = useCriticalSettingsVisible(onShowCriticalToggle),
    criticalVisible = _g[0],
    showCritical = _g[1];
  var buttons = useDeviceSettingsBladeButtons(criticalVisible, steps[activeStepIndex] === SettingsStep.SetValues, showCritical);
  useBladeButtons(buttons, [buttons]);
  useBladeClosing(props.bladeId, function () {
    return !props.isDirty;
  }, function () {});
  var deviceSettings = useFilterCriticalDeviceSettings(props.entitySettings, criticalVisible);
  var MemoizedTreeGrid = useMemo(function () {
    return props.isFetching ? React__default.createElement("div", {
      className: classes.centerContainer
    }, React__default.createElement(CircularProgress, {
      size: 60,
      className: classes.loading
    })) : React__default.createElement(TreeGrid, {
      columnSettings: WizardSettingsColumnSettings,
      getRowDataPath: getItemPath,
      items: deviceSettings,
      selectionType: DataGridSelectionType.Multiple,
      rowClass: classes.alignedRow,
      identifier: 'settingsSelector',
      groupColumnTitle: t('settingsSelector.setting'),
      rowHeight: 36,
      defaultSelection: defaultSettings,
      rowSelectable: rowSelectable$1,
      onSelect: setSelectedSettings,
      groupColumnRendererComponent: 'settingsRenderer',
      components: {
        settingsRenderer: SettingColumnRenderer
      },
      hideHeaderCheckbox: true
    });
  }, [deviceSettings.length, defaultSettings, props.isFetching]);
  var content = useMemo(function () {
    switch (steps[activeStepIndex]) {
      case SettingsStep.SelectSettings:
        return MemoizedTreeGrid;
      case SettingsStep.SetValues:
        return React__default.createElement(SettingsEditor, {
          entity: props.entity,
          parentEntity: props.parentEntity,
          settings: selectedSettings,
          parentSettings: props.parentEntitySettings,
          ref: formRef,
          onSubmit: onValuesFormSubmit,
          readOnly: false,
          groupSettings: true,
          setDirty: props.setDirty,
          setDirtySettings: setDirtySettings
        });
    }
  }, [activeStepIndex, MemoizedTreeGrid]);
  return React__default.createElement("div", {
    className: classes.wizardContaier
  }, React__default.createElement("div", {
    className: classes.wizardContent
  }, content), React__default.createElement(Footer, null, React__default.createElement(SettingsStepper, {
    steps: wizardSteps,
    loading: props.isSavingSettings,
    activeStepIndex: activeStepIndex,
    onBack: handleBack,
    onNext: handleNext,
    nextDisabled: selectedSettings.length === 0
  })), React__default.createElement(ConfirmDialog, {
    entity: props.entity,
    onClose: closeConfirmDialog,
    open: showConfirmDialog.open,
    confirmApplySettings: confirmApplySettings,
    settingsForSaving: showConfirmDialog.toBeSaved,
    settingsNotForSaving: showConfirmDialog.notSaved
  }), React__default.createElement(EditorDirtyDialog, {
    onCancel: onCancelBack,
    onConfirm: onConfirmBack,
    opened: dirtyDialogOpen,
    settings: dirtySettings
  }));
};
var areaName = 'deviceSettings';
var ActionTypes$3;
(function (ActionTypes) {
  ActionTypes["FETCH_DEVICE_SETTINGS"] = "FETCH_DEVICE_SETTINGS";
  ActionTypes["FETCH_DEVICE_SETTINGS_FAIL"] = "FETCH_DEVICE_SETTINGS_FAIL";
  ActionTypes["FETCH_DEVICE_SETTINGS_SUCCESS"] = "FETCH_DEVICE_SETTINGS_SUCCESS";
  ActionTypes["CLEAR_DEVICE_SETTINGS"] = "CLEAR_DEVICE_SETTINGS";
  ActionTypes["SAVE_DEVICE_SETTINGS"] = "SAVE_DEVICE_SETTINGS";
  ActionTypes["SAVE_DEVICE_SETTINGS_SUCCESS"] = "SAVE_DEVICE_SETTINGS_SUCCESS";
  ActionTypes["SAVE_DEVICE_SETTINGS_FAIL"] = "SAVE_DEVICE_SETTINGS_FAIL";
  ActionTypes["CLEAR_SAVED_FLAG"] = "CLEAR_SAVED_FLAG";
  ActionTypes["SET_ACCEPTED_SETTINGS"] = "SET_ACCEPTED_SETTINGS";
})(ActionTypes$3 || (ActionTypes$3 = {}));
var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  areaName: areaName,
  get ActionTypes() {
    return ActionTypes$3;
  }
});
var fetchDeviceSettings = function fetchDeviceSettings(entity, parentEntity) {
  return action(ActionTypes$3.FETCH_DEVICE_SETTINGS, {
    entity: entity,
    parentEntity: parentEntity
  });
};
var fetchDeviceSettingsFail = function fetchDeviceSettingsFail(error) {
  return action(ActionTypes$3.FETCH_DEVICE_SETTINGS_FAIL, {
    error: error
  });
};
var fetchDeviceSettingsSuccess = function fetchDeviceSettingsSuccess(entitySettings, parentSettings, entity, parentEntity) {
  return action(ActionTypes$3.FETCH_DEVICE_SETTINGS_SUCCESS, {
    entitySettings: entitySettings,
    parentSettings: parentSettings,
    entity: entity,
    parentEntity: parentEntity
  });
};
var saveDeviceSettings = function saveDeviceSettings(entity, settings) {
  return action(ActionTypes$3.SAVE_DEVICE_SETTINGS, {
    entity: entity,
    settings: settings
  });
};
var saveDeviceSettingsSuccess = function saveDeviceSettingsSuccess(settings) {
  return action(ActionTypes$3.SAVE_DEVICE_SETTINGS_SUCCESS, {
    settings: settings
  });
};
var saveDeviceSettingsFail = function saveDeviceSettingsFail(error) {
  return action(ActionTypes$3.SAVE_DEVICE_SETTINGS_FAIL);
};
var clearDeviceSettings = function clearDeviceSettings() {
  return action(ActionTypes$3.CLEAR_DEVICE_SETTINGS);
};
var clearSavedFlag = function clearSavedFlag() {
  return action(ActionTypes$3.CLEAR_SAVED_FLAG);
};
var setAcceptedSettings = function setAcceptedSettings(acceptedSettings) {
  return action(ActionTypes$3.SET_ACCEPTED_SETTINGS, {
    acceptedSettings: acceptedSettings
  });
};
var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchDeviceSettings: fetchDeviceSettings,
  fetchDeviceSettingsFail: fetchDeviceSettingsFail,
  fetchDeviceSettingsSuccess: fetchDeviceSettingsSuccess,
  saveDeviceSettings: saveDeviceSettings,
  saveDeviceSettingsSuccess: saveDeviceSettingsSuccess,
  saveDeviceSettingsFail: saveDeviceSettingsFail,
  clearDeviceSettings: clearDeviceSettings,
  clearSavedFlag: clearSavedFlag,
  setAcceptedSettings: setAcceptedSettings
});
var selectDeviceSettingsState = function selectDeviceSettingsState(state) {
  return state[areaName];
};
var selectEntitySettings = createSelector([selectDeviceSettingsState], function (state) {
  return state.acceptedSettings && state.acceptedSettings.length ? state.entitySettings.filter(function (entitysetting) {
    return state.acceptedSettings && state.acceptedSettings.findIndex(function (acceptedSetting) {
      return acceptedSetting === entitysetting.key;
    }) > -1;
  }) : state.entitySettings;
});
var selectParentEntitySettings = createSelector([selectDeviceSettingsState], function (state) {
  return state.parentEntitySettings;
});
var selectEntity = createSelector([selectDeviceSettingsState], function (state) {
  return state.entity;
});
var selectParentEntity = createSelector([selectDeviceSettingsState], function (state) {
  return state.parentEntitySettings;
});
var selectIsFetchingDeviceSettings = createSelector([selectDeviceSettingsState], function (state) {
  return state.isFetching;
});
var selectIsSavingSettings = createSelector([selectDeviceSettingsState], function (state) {
  return state.isSavingSettings;
});
var selectIsSaved = createSelector([selectDeviceSettingsState], function (state) {
  return state.saved;
});
var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectEntitySettings: selectEntitySettings,
  selectParentEntitySettings: selectParentEntitySettings,
  selectEntity: selectEntity,
  selectParentEntity: selectParentEntity,
  selectIsFetchingDeviceSettings: selectIsFetchingDeviceSettings,
  selectIsSavingSettings: selectIsSavingSettings,
  selectIsSaved: selectIsSaved
});
var DeviceSettingsService = /** @class */function () {
  function DeviceSettingsService() {
    this.HIERARCHY_FORMAT_ID = 2;
  }
  DeviceSettingsService.prototype.fetchDeviceSettings = function (entity, parentEntity) {
    return __awaiter(this, void 0, void 0, function () {
      var url, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "v6/deviceSettings?entityType=" + entity.entityType + "&entityId=" + entity.entityId + "&format=" + this.HIERARCHY_FORMAT_ID;
            if (parentEntity) {
              url = url + "&parentEntityId=" + parentEntity.entityId + "&parentEntityType=" + parentEntity.entityType;
            }
            return [4 /*yield*/, HttpService$1.get(url)];
          case 1:
            response = _a.sent();
            return [4 /*yield*/, this.fetchUsersForDeviceSettingsResponse(response)];
          case 2:
            _a.sent();
            return [2 /*return*/, this.mapSettingJsonString(response, entity)];
        }
      });
    });
  };
  DeviceSettingsService.prototype.fetchUsersForDeviceSettingsResponse = function (response) {
    return __awaiter(this, void 0, void 0, function () {
      var allUserIds, users, normalizedUsers_1, addUsername, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            allUserIds = [];
            if (response.settings.entity) {
              allUserIds = allUserIds.concat(response.settings.entity.map(function (e) {
                return e.userId;
              }));
            }
            if (response.settings.parent) {
              allUserIds = allUserIds.concat(response.settings.parent.map(function (e) {
                return e.userId;
              }));
            }
            allUserIds = Array.from(new Set(allUserIds));
            return [4 /*yield*/, HttpService$1.post('v6/admin/users/byIds', allUserIds)];
          case 1:
            users = _a.sent();
            normalizedUsers_1 = {};
            users.map(function (u) {
              normalizedUsers_1[u.id] = u;
            });
            addUsername = function addUsername(deviceSetting) {
              deviceSetting.forEach(function (s) {
                if (normalizedUsers_1[s.userId] && s.userId !== 0) {
                  s.username = normalizedUsers_1[s.userId].login;
                } else {
                  s.username = '';
                }
              });
            };
            addUsername(response.settings.entity);
            if (response.settings.parent) {
              addUsername(response.settings.parent);
            }
            return [3 /*break*/, 3];
          case 2:
            err_1 = _a.sent();
            console.error('Failed to populate users for settings');
            console.error(err_1);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  DeviceSettingsService.prototype.fetchAffectedDevices = function (entity, settingIds) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, HttpService$1.post("v6/deviceSettings/affected", {
              entity: entity,
              settingIds: settingIds
            })];
          case 1:
            response = _a.sent();
            return [2 /*return*/, response];
        }
      });
    });
  };
  DeviceSettingsService.prototype.saveDeviceSettings = function (entity, settings) {
    return __awaiter(this, void 0, void 0, function () {
      var settingsToSave, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            settingsToSave = settings.map(function (s) {
              var value = s.revertValue ? null : s.value;
              return _assign2(_assign2({}, s), {
                value: value
              });
            });
            return [4 /*yield*/, HttpService$1.put('v6/deviceSettings', {
              changes: {
                entityId: entity.entityId,
                entityType: entity.entityType,
                settings: settingsToSave,
                changeId: new Date()
              }
            })];
          case 1:
            response = _a.sent();
            return [4 /*yield*/, this.fetchUsersForDeviceSettingsResponse(response)];
          case 2:
            _a.sent();
            return [2 /*return*/, this.mapSettingJsonResponseString(entity, response)];
        }
      });
    });
  };
  DeviceSettingsService.prototype.mapSettingJsonString = function (settingsResponse, entityInfo) {
    var settings = settingsResponse.settings,
      tree = settingsResponse.tree;
    var entity = settings.entity.map(function (setting) {
      var groupTree = tree.find(function (group) {
        return group.settingKey === setting.key;
      });
      var path = [];
      var isInherited = setting.entityId !== entityInfo.entityId || setting.entityType !== entityInfo.entityType;
      if (groupTree) {
        path = groupTree.path.map(function (e) {
          return i18next.t(e.name).toString();
        });
      }
      path.push(i18next.t(setting.key).toString());
      return _assign2(_assign2({}, setting), {
        path: path,
        isInherited: isInherited
      });
    });
    return {
      entity: entity,
      parent: settings.parent
    };
  };
  DeviceSettingsService.prototype.mapSettingJsonResponseString = function (originalEntity, settingsResponse) {
    var settings = settingsResponse.settings;
    var newSettings = settings.entity.map(function (setting) {
      var isInherited = originalEntity.entityId !== setting.entityId || originalEntity.entityType !== setting.entityType;
      return _assign2(_assign2({}, setting), {
        isInherited: isInherited
      });
    });
    return newSettings;
  };
  return DeviceSettingsService;
}();
var service = new DeviceSettingsService();
var fetchDeviceSettingsAsync = function fetchDeviceSettingsAsync(entity, parentEntity) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0, function () {
      var settings, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            dispatch(fetchDeviceSettings(entity, parentEntity));
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, service.fetchDeviceSettings(entity, parentEntity)];
          case 2:
            settings = _a.sent();
            dispatch(fetchDeviceSettingsSuccess(settings.entity, settings.parent, entity, parentEntity));
            return [3 /*break*/, 4];
          case 3:
            err_1 = _a.sent();
            dispatch(fetchDeviceSettingsFail(err_1));
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
};

var saveDeviceSettingsAsync = function saveDeviceSettingsAsync(entity, parentEntity, settings) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0, function () {
      var response, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            dispatch(saveDeviceSettings(entity, settings));
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, service.saveDeviceSettings(entity, settings)];
          case 2:
            response = _a.sent();
            dispatch(pushNotification(i18next.t('deviceSettings.saveSuccessToast'), 'success'));
            dispatch(saveDeviceSettingsSuccess(response));
            return [3 /*break*/, 4];
          case 3:
            e_1 = _a.sent();
            dispatch(pushNotification(e_1.message, 'error'));
            dispatch(saveDeviceSettingsFail(e_1.message));
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
};

var thunks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchDeviceSettingsAsync: fetchDeviceSettingsAsync,
  saveDeviceSettingsAsync: saveDeviceSettingsAsync
});
var initialState$2 = {
  entity: {
    entityId: 0,
    entityType: EntityType.Workgroup
  },
  parentEntity: null,
  entitySettings: [],
  parentEntitySettings: [],
  isFetching: false,
  isSavingSettings: false,
  saved: false,
  acceptedSettings: []
};
var deviceSettingsReducer = function deviceSettingsReducer(state, action) {
  if (state === void 0) {
    state = initialState$2;
  }
  switch (action.type) {
    case ActionTypes$3.FETCH_DEVICE_SETTINGS:
      return _assign2(_assign2({}, state), {
        isFetching: true,
        saved: false
      });
    case ActionTypes$3.FETCH_DEVICE_SETTINGS_FAIL:
      return _assign2(_assign2({}, state), {
        isFetching: false
      });
    case ActionTypes$3.FETCH_DEVICE_SETTINGS_SUCCESS:
      return _assign2(_assign2({}, state), {
        entity: action.payload.entity,
        parentEntity: action.payload.parentEntity,
        entitySettings: action.payload.entitySettings,
        parentEntitySettings: action.payload.parentSettings,
        isFetching: false
      });
    case ActionTypes$3.CLEAR_DEVICE_SETTINGS:
      return _assign2(_assign2({}, state), {
        entitySettings: [],
        parentEntitySettings: [],
        entity: {
          entityId: 0,
          entityType: EntityType.Workgroup
        },
        parentEntity: null
      });
    case ActionTypes$3.SAVE_DEVICE_SETTINGS:
      {
        return _assign2(_assign2({}, state), {
          isSavingSettings: true
        });
      }
    case ActionTypes$3.SAVE_DEVICE_SETTINGS_FAIL:
      {
        return _assign2(_assign2({}, state), {
          isSavingSettings: false
        });
      }
    case ActionTypes$3.SAVE_DEVICE_SETTINGS_SUCCESS:
      {
        var newSettings = __spreadArrays(state.entitySettings);
        if (newSettings.length) {
          newSettings = action.payload.settings.reduce(function (acc, setting) {
            var index = acc.findIndex(function (x) {
              return x.key === setting.key;
            });
            acc[index].value = setting.value;
            acc[index].userId = setting.userId;
            acc[index].username = setting.username;
            acc[index].timestamp = setting.timestamp;
            acc[index].description = setting.description;
            acc[index].origin = setting.origin;
            acc[index].entityId = setting.entityId;
            acc[index].entityType = setting.entityType;
            acc[index].isInherited = setting.isInherited;
            return acc;
          }, __spreadArrays(newSettings));
        }
        return _assign2(_assign2({}, state), {
          entitySettings: newSettings,
          isSavingSettings: false,
          saved: true
        });
      }
    case ActionTypes$3.CLEAR_SAVED_FLAG:
      {
        return _assign2(_assign2({}, state), {
          saved: false
        });
      }
    case ActionTypes$3.SET_ACCEPTED_SETTINGS:
      return _assign2(_assign2({}, state), {
        acceptedSettings: action.payload.acceptedSettings
      });
    default:
      return state;
  }
};
var WizardBladeName = 'WIZARD';
var bladeConfig$1 = {
  bladeType: WizardBladeName,
  size: {
    defaultWidth: 800,
    minWidth: 400
  },
  title: function title() {
    return i18next.t('wizard.title');
  },
  allowMultipleInstances: false
};
var WizardContainerComponent = function WizardContainerComponent(props) {
  var dispatch = useDispatch();
  var entitySettings = useSelector(selectEntitySettings);
  var parentEntitySettings = useSelector(selectParentEntitySettings);
  var entity = useSelector(selectEntity);
  var isSavingSettings = useSelector(selectIsSavingSettings);
  var saved = useSelector(selectIsSaved);
  var closeBlade = useCallback(function () {
    return dispatch(BladeActions.closeBlade(props.bladeId));
  }, [props.bladeId]);
  var saveDeviceSettings = useCallback(function (entityToSave, parentEntity, settings) {
    return dispatch(saveDeviceSettingsAsync(entityToSave, parentEntity, settings));
  }, []);
  var isFetching = useSelector(selectIsFetchingDeviceSettings);
  var clearSavedFlag$1 = useCallback(function () {
    return dispatch(clearSavedFlag());
  }, []);
  return React__default.createElement(DataGridContextProvider, null, React__default.createElement(Wizard, _assign2({}, props, {
    isSavingSettings: isSavingSettings,
    saveDeviceSettings: saveDeviceSettings,
    entity: entity,
    parentEntity: props.parentEntity,
    entitySettings: entitySettings,
    parentEntitySettings: parentEntitySettings,
    closeBlade: closeBlade,
    saved: saved,
    isFetching: isFetching,
    clearSavedFlag: clearSavedFlag$1
  })));
};
var DeviceSettingsContainer = withRegisterBlade(bladeConfig$1)(WizardContainerComponent);
var mergeWithReactToolsTranslations = function mergeWithReactToolsTranslations(resource, prioritizeReactTools) {
  return prioritizeReactTools ? {
    en: {
      translation: _assign2(_assign2({}, resource.en.translation), translations.en.translation)
    },
    de: {
      translation: _assign2(_assign2({}, resource.de.translation), translations.de.translation)
    },
    fr: {
      translation: _assign2(_assign2({}, resource.fr.translation), translations.fr.translation)
    }
  } : {
    en: {
      translation: _assign2(_assign2({}, translations.en.translation), resource.en.translation)
    },
    de: {
      translation: _assign2(_assign2({}, translations.de.translation), resource.de.translation)
    },
    fr: {
      translation: _assign2(_assign2({}, translations.fr.translation), resource.fr.translation)
    }
  };
};
var translations = {
  en: {
    translation: {
      "deviceSettings.showCritical": "Show critical settings",
      "deviceSettings.criticalSetting": "This setting is CRITICAL",
      "deviceSettings.value": "Value",
      "deviceSettings.isInherited": "Inherited",
      "deviceSettings.riskLevel": "Risk Level",
      "deviceSettings.riskLevelLabel": "Risk Level",
      "deviceSettings.timestamp": "Timestamp",
      "deviceSettings.origin": "Origin",
      "deviceSettings.username": "User",
      "deviceSettings.setting": "Setting",
      "deviceSettings.title": "Device Settings",
      "deviceSettings.valueDialogTitle": "Value for {{key}}",
      "deviceSettings.dangerZone": "DANGER ZONE",
      "deviceSettings.dangerZoneWarning": "You are about to modify a critical setting!",
      "deviceSettings.dangerZoneReadMe": "A wrong value may have irreversible impact on the devices!",
      "deviceSettings.dangerZoneMath": "Please answer the following math question to proceed:",
      "deviceSettings.dangerZoneCheckbox": "Yes, I understand the risk",
      "deviceSettings.applyingSettings": "Applying Settings",
      "deviceSettings.youCanStillCancel": "You can still cancel these changes",
      "deviceSettings.cancelChanges": "Cancel Changes",
      "deviceSettings.playerCountReadme": "By continuing, you are going to affect {{count}} devices.",
      "deviceSettings.playerCountDialogInfo": "Please type in the number of devices to confirm you want to proceed:",
      "deviceSettings.playerCountLabel": "Number of devices",
      "deviceSettings.saved": "Done",
      "deviceSettings.saveSuccessToast": "Changes pushed successfully",
      "deviceSettings.deleteOverride": "Delete overridden value and inherit from parent",
      "deviceSettings.returnToOverride": "Use overridden value",
      "deviceSettings.removeSetting": "Remove this setting from editting",
      "deviceSettings.summarySettingsForSavingPart1": "The following settings have changes and will be saved. Remove any setting by clicking the ",
      "deviceSettings.summarySettingsForSavingPart2": " button.",
      "deviceSettings.summarySettingsNotForSavingPart1": "These settings have not been changed and will not be saved. Add any setting as override by clicking the ",
      "deviceSettings.summarySettingsNotForSavingPart2": " button.",
      "deviceSettings.summaryRemoveSetting": "Remove setting",
      "deviceSettings.summaryAddSetting": "Add setting",
      // Device Settings Keys
      securitySettings: "Security Settings",
      "securitySettings.vodAppPassword": "VOD App password",
      "securitySettings.playerConfigAppPassword": "Player Config App Password",
      "securitySettings.diagnosticsAppPassword": "Diagnostics App Password",
      "securitySettings.encryptMediaFiles": "Encrypt Media Files",
      siteSettings: "Site Settings",
      "siteSettings.siteId": "Site Id",
      "siteSettings.bandwidthSettings": "Bandwidth Settings",
      "siteSettings.sleepMode": "Sleep Mode",
      "siteSettings.openingHours": "Opening Hour",
      "siteSettings.customParamsMap1": "Custom Params Map 01",
      "siteSettings.customParamsMap2": "Custom Params Map 02",
      "siteSettings.customParamsMap3": "Custom Params Map 03",
      "siteSettings.customParamsMap4": "Custom Params Map 04",
      "siteSettings.customParamsMap5": "Custom Params Map 05",
      "siteSettings.customParamsMap6": "Custom Params Map 06",
      "siteSettings.customParamsMap7": "Custom Params Map 07",
      "siteSettings.customParamsMap8": "Custom Params Map 08",
      "siteSettings.customParamsMap9": "Custom Params Map 09",
      "siteSettings.customParamsMap10": "Custom Params Map 10",
      "siteSettings.customParamsMap11": "Custom Params Map 11",
      "siteSettings.customParamsMap12": "Custom Params Map 12",
      "siteSettings.customParamsMap13": "Custom Params Map 13",
      "siteSettings.customParamsMap14": "Custom Params Map 14",
      "siteSettings.customParamsMap15": "Custom Params Map 15",
      "siteSettings.contentDownloadWindows": "Content Download Window",
      "siteSettings.zipCode": "Zip Code",
      "siteSettings.longitude": "Longitude",
      "siteSettings.latitude": "Latitude",
      cloudApiSettings: "Cloud API Settings",
      "cloudApiSettings.baseServerUpgradeUrl": "Base Server Upgrade URL",
      "cloudApiSettings.baseServerApiUrl": "Base Server API URL",
      contentSettings: "Content Settings",
      "contentSettings.storedTracksCountLimit": "Stored Tracks Count Limit",
      "contentSettings.networkNotAvailableMessage": "Network Not Available Message",
      platformSettings: "Platform Settings",
      "platformSettings.zidooSoundOutputRaw": "Zidoo Sound Output Raw",
      "platformSettings.usePowerKeyForScreenOff": "Use Power Key For Screen Off",
      "platformSettings.adbEnabled": "ADB Enabled",
      serialDisplayCommands: "Serial Display Commands",
      "serialDisplayCommands.commandsMap": "Commands Map",
      soundSettings: "Sound Settings",
      "soundSettings.volumeLevels": "Volume Levels",
      hardwareSettings: "Hardware Settings",
      "hardwareSettings.serial": "Serial",
      "hardwareSettings.deviceModel": "Device Model",
      "hardwareSettings.networkHostname": "Network Hostname",
      "hardwareSettings.knownSerialProductIds": "Known Serial Product Ids",
      softwareSettings: "Software Settings",
      "softwareSettings.headlessSetupEnabled": "Headless Setup Enabled",
      "softwareSettings.liveCommandsEnabled": "Live Commands Enabled",
      "softwareSettings.earlyAdopter": "Early Adopter",
      "softwareSettings.httpServiceMaxWorkers": "HTTP Service Max Workers",
      resetSettings: "Reset Settings",
      "softwareSettings.resetSettings.resetMode": "Reset Mode",
      "softwareSettings.resetSettings.resetTime": "Reset Time",
      "softwareSettings.resetSettings.exceptions": "Reset Exceptions",
      debugSettings: "Debug Settings",
      "softwareSettings.debugSettings.streamMusicTracks": "Stream Music Tracks",
      "softwareSettings.debugSettings.networkSetupDisabled": "Disable Network Setup",
      "softwareSettings.debugSettings.playerFilesUpdateDisabled": "Disable Player Files Update",
      "softwareSettings.debugSettings.deleteMediaOnLaunch": "Delete Media on Launch",
      "softwareSettings.debugSettings.deletePlaylistOnLaunch": "Delete Playlist On Launch",
      "softwareSettings.debugSettings.playbackLogsUploadDisabled": "Disable Playback Logs Upload",
      "softwareSettings.debugSettings.monitoringDisabled": "Disable Monitoring",
      "softwareSettings.debugSettings.useHeadlessSetupWebAppDevBuild": "Use Headless Setup WebApp Dev Build",
      "softwareSettings.debugSettings.crashLoggerEnabled": "Enable Crash Logger",
      "softwareSettings.debugSettings.debugViewVisible": "Debug View Visible",
      watchdogSettings: "Watchdog Settings",
      "watchdogSettings.playbackRestartTimeoutMillis": "Playback Restart Timeout (ms)",
      "watchdogSettings.watchdogEnabled": "Watchdog Enabled",
      displaySettings: "Display Settings",
      "displaySettings.displayScale": "Scale",
      "displaySettings.displayResolution": "Resolution",
      "displaySettings.displayOrientation": "Orientation",
      "displaySettings.displayBrightness": "Brightness",
      "displaySettings.displayDensity": "Density",
      purgeSettings: "Purge Settings",
      "contentSettings.purgeSettings.mediaFilesPurgeUntouchedDays": "Purge media files untouched # days",
      "contentSettings.purgeSettings.logsPurgeUntouchedDays": "Purge logs untouched # days",
      "contentSettings.purgeSettings.statisticsPurgeUntouchedDays": "Purge statistics untouched # days",
      "contentSettings.purgeSettings.customDirectories": "Custom Directories",
      loggingSettings: "Logging Settings",
      "loggingSettings.activityLogsAutoUploadEnabled": "Enable Activity Logs Auto Upload",
      "loggingSettings.activityLogsAutoUploadIntervalMillis": "Auto Upload Activity Logs Interval (ms)",
      "loggingSettings.playbackLogsFileEnabled": "Enable Playback Logs File",
      "loggingSettings.activityLogsFileEnabled": "Enable Activity Logs File",
      "loggingSettings.activityLogsBufferMaxSizeBytes": "Activity Logs Buffer Max Size (bytes)",
      cronSettings: "Cron Settings",
      "cronSettings.monitorDataUploadIntervalSeconds": "Monitor Data Upload Interval (s)",
      "cronSettings.playlistFeedsUpdateIntervalSeconds": "Playlist Feeds Update Interval (s)",
      "cronSettings.playlistUpdateIntervalSeconds": "Playlist Update Interval (s)",
      "cronSettings.playerFilesDownloadIntervalSeconds": "Player Files Download Interval (s)",
      clientSettings: "Client Settings",
      "clientSettings.projectId": "Project Id",
      timeSettings: "Time Settings",
      "timeSettings.timeZone": "Timezone",
      timeSyncSettings: "Time Sync Settings",
      "timeSettings.timeSyncSettings.syncMode": "Sync Mode",
      "timeSettings.timeSyncSettings.customNtpServerUrl": "Custom NTP Server URL",
      playbackSettings: "Playback Settings",
      "playbackSettings.multiZoneNoMediaFillColor": "Multizone No Media Fill Color",
      "playbackSettings.vodSettings.mediaListZoneFrameLandscape": "Media List Zone Frame Landscape",
      "playbackSettings.syncPlaybackTimeoutMillis": "Playback Sync Timeout (ms)",
      "playbackSettings.playlistUpdateInstantReload": "Instant Reload on Playlist Update",
      "playbackSettings.forceReportNowPlayingData": "Force Report Now Playing Data",
      flashMediaSettings: "Flash Media Settings",
      "playbackSettings.flashMediaSettings.useAirRuntime": "Use AIR Runtime",
      vodSettings: "VOD Settings",
      "playbackSettings.vodSettings.mediaFrameFocusBackgroundColor": "Media Frame Focus BG Color",
      "playbackSettings.vodSettings.mediaTitleTextColor": "Media Title Text Color",
      "playbackSettings.vodSettings.mediaTitleTextColorFocused": "Media Title Focused Text Color",
      "playbackSettings.vodSettings.isHintEnable": "Enable Hint",
      "playbackSettings.vodSettings.mediaFrameBackgroundColor": "Media Frame BG Color",
      "playbackSettings.vodSettings.timeoutIntervalSeconds": "Timeout Interval (s)",
      "playbackSettings.vodSettings.mediaListZoneFramePortrait": "Media List Zone Frame Portrait",
      videoSettings: "Video Settings",
      "playbackSettings.videoSettings.videoPlayerType": "Player Type",
      "playbackSettings.videoSettings.videoRenderingMode": "Rendering Mode",
      webPageSettings: "Web Page Settings",
      "playbackSettings.webPageSettings.purgeWebCacheOnStart": "Purge Cache on Start",
      "playbackSettings.webPageSettings.crosswalkUseTextureView": "Use Crosswalk Texture View",
      "playbackSettings.webPageSettings.allowedUrls": "Allowed URLs",
      audioSettings: "Audio Settings",
      "playbackSettings.audioSettings.duckingDuration": "Ducking Duration",
      "playbackSettings.audioSettings.duckingPercent": "Ducking (%)",
      "playbackSettings.audioSettings.musicCrossfadeMode": "Music Crossfade Mode",
      "playbackSettings.audioSettings.audioPlayerType": "Player Type",
      "playbackSettings.audioSettings.musicTracksVolume": "Music Tracks Volume",
      "playbackSettings.audioSettings.musicSmoothStopDurationMillis": "Music Smooth Stop Duration (ms)",
      "playbackSettings.audioSettings.musicStaticCrossfadeDurationMillis": "Music Static Crossfade Duration (ms)",
      "playbackSettings.audioSettings.musicSmoothStopPercent": "Music Smooth Stop (%)",
      "playbackSettings.audioSettings.volumePercentFactorZoneLeft": "Volume Percent Factor Zone Left",
      "playbackSettings.audioSettings.volumePercentFactorZoneRight": "Volume Percent Factor Zone Right",
      "playbackSettings.audioSettings.musicTracksVolumeZoneLeft": "Music Tracks Volume Left Zone",
      "playbackSettings.audioSettings.musicTracksVolumeZoneRight": "Music Tracks Volume Right Zone",
      playbackInteractionSettings: "Playback Interaction Settings",
      "playbackSettings.playbackInteractionSettings.onTouchAction": "On Touch Action",
      appCommunicationSettings: "App Communication Settings",
      multicastSettings: "Multicast Settings",
      "appCommunicationSettings.multicastSettings.defaultMulticastPort": "Default Port",
      "appCommunicationSettings.multicastSettings.defaultMulticastAddress": "Default Address",
      ipcSettings: "IPC Settings",
      "appCommunicationSettings.ipcSettings.tcpPort": "TCP Port",
      "appCommunicationSettings.ipcSettings.datagramReceivePort": "Datagram Receive Port",
      "appCommunicationSettings.ipcSettings.datagramSendPort": "Datagram Send Port",
      p2pSettings: "P2P Settings",
      "appCommunicationSettings.p2pSettings.port": "Port",
      "appCommunicationSettings.p2pSettings.clientEnabled": "Enable Client",
      "appCommunicationSettings.p2pSettings.serverEnabled": "Enable Server",
      networkSettings: "Network Settings",
      wifiSettings: "Wifi Settings",
      "networkSettings.wifiSettings.allowConfigurationChange": "Allow Configuration Change",
      networkLinkSettings: "Network Link Settings",
      wifiAccessPointSettings: "Wifi Access Point Settings",
      "networkSettings.wifiSettings.wifiAccessPointSettings.ssid": "SSID",
      "networkSettings.wifiSettings.wifiAccessPointSettings.password": "Password",
      "networkSettings.wifiSettings.wifiAccessPointSettings.authenticationType": "Authentication Type",
      "networkSettings.wifiSettings.dhcpEnabled": "Enable DHCP",
      "networkSettings.wifiSettings.networkLinkSettings.dns1": "DNS1",
      "networkSettings.wifiSettings.networkLinkSettings.dns2": "DNS2",
      "networkSettings.wifiSettings.networkLinkSettings.gateway": "Gateway",
      "networkSettings.wifiSettings.networkLinkSettings.ipAddress": "IP Address",
      "networkSettings.wifiSettings.networkLinkSettings.netmask": "Netmask",
      "networkSettings.wifiSettings.interfaceEnabled": "Interface Enabled",
      "networkSettings.wifiSettings.vlanConfigurations": "VLAN Configurations",
      httpProxySettings: "HTTP Proxy Settings",
      "networkSettings.httpProxySettings.port": "Port",
      "networkSettings.httpProxySettings.host": "Host",
      "networkSettings.httpProxySettings.proxyEnabled": "Enable Proxy",
      "networkSettings.httpProxySettings.excludedHostsList": "Excluded Hosts",
      "networkSettings.httpProxySettings.password": "Password",
      "networkSettings.httpProxySettings.username": "Username",
      ethernetSettings: "Ethernet Settings",
      "networkSettings.ethernetSettings.dhcpEnabled": "Enable DHCP",
      "networkSettings.ethernetSettings.vlanConfigurations": "VLAN Configurations",
      "networkSettings.ethernetSettings.allowConfigurationChange": "Allow Configuration Change",
      "networkSettings.ethernetSettings.interfaceEnabled": "Interface Enabled",
      "networkSettings.ethernetSettings.networkLinkSettings.dns1": "DNS1",
      "networkSettings.ethernetSettings.networkLinkSettings.dns2": "DNS2",
      "networkSettings.ethernetSettings.networkLinkSettings.gateway": "Gateway",
      "networkSettings.ethernetSettings.networkLinkSettings.ipAddress": "IP Address",
      "networkSettings.ethernetSettings.networkLinkSettings.netmask": "Netmask",
      "settingsEditor.propertiesCountMultiple": "{{count}} properties",
      "settingsEditor.propertiesCountSingle": "1 property",
      "settingsEditor.itemsCountMultiple": "{{count}} items",
      "settingsEditor.itemsCountSingle": "1 item",
      "settingsEditor.propertiesCount": "{{count}} properties",
      "settingsEditor.propertyKey": "Property key",
      "settingsEditor.dialog.editKey": "Edit key",
      "settingsEditor.dialog.addKey": "Add key",
      "settingsEditor.button.editKey": "Edit key",
      "settingsEditor.button.addItem": "Add item",
      "settingsEditor.button.cloneItem": "Clone item",
      "settingsEditor.button.removeItem": "Remove item",
      "settingsEditor.unlock": "Unlock device setting",
      "settingsEditor.validation.required": "Value cannot be empty",
      "settingsEditor.validation.greaterThan": "Value must be greater than {{value}}",
      "settingsEditor.validation.lessThan": "Value must be less than {{value}}",
      "settingsEditor.validation.greaterOrEqualThan": "Value must be greater than or equal to {{value}}",
      "settingsEditor.validation.lessOrEqualThan": "Value must be less than or equal to {{value}}",
      "settingsEditor.validation.pattern": "Incorrect value format",
      "settingsEditor.validation.longerThan": "Value must be longer than {{value}} characters",
      "settingsEditor.validation.shorterThan": "Value must be shorter than {{value}} characters",
      "settingsEditor.riskLevel0": "Critical",
      "settingsEditor.riskLevel1": "High",
      "settingsEditor.riskLevel2": "Medium",
      "settingsEditor.riskLevel3": "Low",
      "settingsEditor.riskLevel4": "No risk",
      settingValueSearch: "Contains",
      "wizard.title": "Edit Settings",
      "wizard.settingsStepper.back": "Back",
      "wizard.settingsStepper.next": "Next",
      "wizard.settingsStepper.save": "Save",
      "wizard.settingsStepper.settingsSelector": "Select Settings",
      "wizard.settingsStepper.setValues": "Set Values",
      "wizard.settingsStepper.setTarget": "Set Target",
      "settingsSelector.setting": "Setting",
      "settingsSelector.value": "Value",
      "wizard.settingsStepper.cancel": "Cancel",
      "wizard.dirtyDialog.unsavedChangesMessage1": "Are you sure you want to go back?",
      "wizard.dirtyDialog.unsavedChangesMessage2": "The changes you have made will be lost.",
      "wizard.dirtyDialog.title": "Back to settings list",
      "wizard.dirtyDialog.andmore": "...and {{count}} more",
      "wizard.dirtyDialog.listHeader": "You have changed",
      "mathConfirmationDialog.math": "Please solve the following math equation to continue:"
    }
  },
  fr: {
    translation: {}
  },
  de: {
    translation: {}
  }
};
export { BadRequestError, BladeActions, BladeRowContainer, BladeSelectors, ButtonsHeaderAndContent, CURRENT_WORKGROUP_HEADER_NAME, ConcurrencyError, DataGrid, DataGridContextProvider, DataGridHeader, DataGridSelectionType, DeviceSettingType, DeviceSettingsContainer, EntityType, Footer, FooterSubmit, FormActionsCard, FormCard, GridCard, GridSearchBox, Header, HeaderAndContent, HelpDialog, HttpService$1 as HttpService, InputBaseInnerWrapper, InternalServerError, MathProblemConfirmDialog, NotifierContainer, SearchBox, SelectionBladeCloseReason, SelectionBladeContainer, SelectionListBladeType, SelectionMode, SettingsEditor, TabsHeaderAndContent, TextFieldInnerWrapper, ActionTypes$2 as TreeActionTypes, TreeActions, TreeContainer, TreeGrid, TreeReducer, TreeSelectors, WizardBladeName, bladeAreaName, bladeConnect, bladeReducer, createBtn, createEditDelete, currentWorkgroupKey, customBtn, deleteBtn, denormalize, actions as deviceSettingsActions, deviceSettingsReducer, selectors as deviceSettingsSelectors, thunks as deviceSettingsThunks, types as deviceSettingsTypes, editBtn, getCookieValue, getMaterialUISelectButton, importBtn, mergeWithReactToolsTranslations, normalize$2 as normalize, notificationsAreaName, notificationsReducer, openBlade, openMaterialUISelect, pushNotification, renderWithStore, selectMaterialUIOption, translations, treeAreaName, updateBladeProps, useBladeButtons, useBladeClosing, useCriticalSettingsVisible, useDefaultDeviceSettingFns, useFetchDeviceSettings, useFilterCriticalDeviceSettings, useGrid, useGridApi, useGridEvents, useGridExportEvents, useGridQuickSearchEvent, useMapDeviceSettings, withRegisterBlade };